function _M0DTPB4Json4Null() {}
_M0DTPB4Json4Null.prototype.$tag = 0;
const _M0DTPB4Json4Null__ = new _M0DTPB4Json4Null();
function _M0DTPB4Json4True() {}
_M0DTPB4Json4True.prototype.$tag = 1;
const _M0DTPB4Json4True__ = new _M0DTPB4Json4True();
function _M0DTPB4Json5False() {}
_M0DTPB4Json5False.prototype.$tag = 2;
const _M0DTPB4Json5False__ = new _M0DTPB4Json5False();
function _M0DTPB4Json6Number(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPB4Json6Number.prototype.$tag = 3;
function _M0DTPB4Json6String(param0) {
  this._0 = param0;
}
_M0DTPB4Json6String.prototype.$tag = 4;
function _M0DTPB4Json5Array(param0) {
  this._0 = param0;
}
_M0DTPB4Json5Array.prototype.$tag = 5;
function _M0DTPB4Json6Object(param0) {
  this._0 = param0;
}
_M0DTPB4Json6Object.prototype.$tag = 6;
const $reinterpret_view = new DataView(new ArrayBuffer(8));
function $i64_reinterpret_f64(a) {
  $reinterpret_view.setBigUint64(0, BigInt.asUintN(64, a), false);
  return $reinterpret_view.getFloat64(0, false);
}
function _M0TPC28internal7strconv9FloatInfo(param0, param1, param2) {
  this.mantissa_bits = param0;
  this.exponent_bits = param1;
  this.bias = param2;
}
function _M0TPC17strconv9FloatInfo(param0, param1, param2) {
  this.mantissa_bits = param0;
  this.exponent_bits = param1;
  this.bias = param2;
}
function _M0TP410Haoxincode8moonbash3lib3ast15ExecutionLimits(param0, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10) {
  this.max_call_depth = param0;
  this.max_command_count = param1;
  this.max_loop_iterations = param2;
  this.max_string_length = param3;
  this.max_array_elements = param4;
  this.max_heredoc_size = param5;
  this.max_substitution_depth = param6;
  this.max_glob_operations = param7;
  this.max_awk_iterations = param8;
  this.max_sed_iterations = param9;
  this.max_jq_iterations = param10;
}
function _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError.prototype.$tag = 65;
function _M0DTPC15error5Error58peter_2djerry_2dye_2fparse__args_2eParseError_2eParseError(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error58peter_2djerry_2dye_2fparse__args_2eParseError_2eParseError.prototype.$tag = 64;
function _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError.prototype.$tag = 63;
function _M0DTPC15error5Error60moonbitlang_2fcore_2fencoding_2futf8_2eMalformed_2eMalformed(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error60moonbitlang_2fcore_2fencoding_2futf8_2eMalformed_2eMalformed.prototype.$tag = 62;
function _M0DTPC15error5Error48moonbitlang_2fregexp_2eRegexpError_2eRegexpError(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC15error5Error48moonbitlang_2fregexp_2eRegexpError_2eRegexpError.prototype.$tag = 61;
function _M0DTPC15error5Error58moonbitlang_2fcore_2fstrconv_2eStrConvError_2eStrConvError(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error58moonbitlang_2fcore_2fstrconv_2eStrConvError_2eStrConvError.prototype.$tag = 60;
function _M0DTPC15error5Error57bobzhang_2fmoonjq_2fparser_2eParseError_2eUnexpectedToken(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC15error5Error57bobzhang_2fmoonjq_2fparser_2eParseError_2eUnexpectedToken.prototype.$tag = 59;
function _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eUnexpectedEnd(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eUnexpectedEnd.prototype.$tag = 58;
function _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax.prototype.$tag = 57;
function _M0DTPC15error5Error59bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidExpression(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error59bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidExpression.prototype.$tag = 56;
function _M0DTPC15error5Error55tonyfettes_2funicode_2fidna_2eIdnaError_2ePunycodeError(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error55tonyfettes_2funicode_2fidna_2eIdnaError_2ePunycodeError.prototype.$tag = 55;
function _M0DTPC15error5Error61tonyfettes_2funicode_2fidna_2eIdnaError_2eDisallowedCodePoint(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error61tonyfettes_2funicode_2fidna_2eIdnaError_2eDisallowedCodePoint.prototype.$tag = 54;
function _M0DTPC15error5Error54tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidLabel(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error54tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidLabel.prototype.$tag = 53;
function _M0DTPC15error5Error55tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidHyphen() {}
_M0DTPC15error5Error55tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidHyphen.prototype.$tag = 52;
const _M0DTPC15error5Error55tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidHyphen__ = new _M0DTPC15error5Error55tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidHyphen();
function _M0DTPC15error5Error54tonyfettes_2funicode_2fidna_2eIdnaError_2eLabelTooLong() {}
_M0DTPC15error5Error54tonyfettes_2funicode_2fidna_2eIdnaError_2eLabelTooLong.prototype.$tag = 51;
const _M0DTPC15error5Error54tonyfettes_2funicode_2fidna_2eIdnaError_2eLabelTooLong__ = new _M0DTPC15error5Error54tonyfettes_2funicode_2fidna_2eIdnaError_2eLabelTooLong();
function _M0DTPC15error5Error55tonyfettes_2funicode_2fidna_2eIdnaError_2eDomainTooLong() {}
_M0DTPC15error5Error55tonyfettes_2funicode_2fidna_2eIdnaError_2eDomainTooLong.prototype.$tag = 50;
const _M0DTPC15error5Error55tonyfettes_2funicode_2fidna_2eIdnaError_2eDomainTooLong__ = new _M0DTPC15error5Error55tonyfettes_2funicode_2fidna_2eIdnaError_2eDomainTooLong();
function _M0DTPC15error5Error52tonyfettes_2funicode_2fidna_2eIdnaError_2eEmptyLabel() {}
_M0DTPC15error5Error52tonyfettes_2funicode_2fidna_2eIdnaError_2eEmptyLabel.prototype.$tag = 49;
const _M0DTPC15error5Error52tonyfettes_2funicode_2fidna_2eIdnaError_2eEmptyLabel__ = new _M0DTPC15error5Error52tonyfettes_2funicode_2fidna_2eIdnaError_2eEmptyLabel();
function _M0DTPC15error5Error53tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidBidi() {}
_M0DTPC15error5Error53tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidBidi.prototype.$tag = 48;
const _M0DTPC15error5Error53tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidBidi__ = new _M0DTPC15error5Error53tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidBidi();
function _M0DTPC15error5Error55tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidJoiner() {}
_M0DTPC15error5Error55tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidJoiner.prototype.$tag = 47;
const _M0DTPC15error5Error55tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidJoiner__ = new _M0DTPC15error5Error55tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidJoiner();
function _M0DTPC15error5Error58tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidAcePrefix() {}
_M0DTPC15error5Error58tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidAcePrefix.prototype.$tag = 46;
const _M0DTPC15error5Error58tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidAcePrefix__ = new _M0DTPC15error5Error58tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidAcePrefix();
function _M0DTPC15error5Error62tonyfettes_2funicode_2fidna_2eIdnaError_2eLeadingCombiningMark() {}
_M0DTPC15error5Error62tonyfettes_2funicode_2fidna_2eIdnaError_2eLeadingCombiningMark.prototype.$tag = 45;
const _M0DTPC15error5Error62tonyfettes_2funicode_2fidna_2eIdnaError_2eLeadingCombiningMark__ = new _M0DTPC15error5Error62tonyfettes_2funicode_2fidna_2eIdnaError_2eLeadingCombiningMark();
function _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch.prototype.$tag = 44;
function _M0DTPC15error5Error56bobzhang_2fmoonjq_2fast_2eInterpreterError_2eKeyNotFound(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error56bobzhang_2fmoonjq_2fast_2eInterpreterError_2eKeyNotFound.prototype.$tag = 43;
function _M0DTPC15error5Error61bobzhang_2fmoonjq_2fast_2eInterpreterError_2eIndexOutOfBounds(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error61bobzhang_2fmoonjq_2fast_2eInterpreterError_2eIndexOutOfBounds.prototype.$tag = 42;
function _M0DTPC15error5Error61bobzhang_2fmoonjq_2fast_2eInterpreterError_2eInvalidOperation(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error61bobzhang_2fmoonjq_2fast_2eInterpreterError_2eInvalidOperation.prototype.$tag = 41;
function _M0DTPC15error5Error59bobzhang_2fmoonjq_2fast_2eInterpreterError_2eDivisionByZero() {}
_M0DTPC15error5Error59bobzhang_2fmoonjq_2fast_2eInterpreterError_2eDivisionByZero.prototype.$tag = 40;
const _M0DTPC15error5Error59bobzhang_2fmoonjq_2fast_2eInterpreterError_2eDivisionByZero__ = new _M0DTPC15error5Error59bobzhang_2fmoonjq_2fast_2eInterpreterError_2eDivisionByZero();
function _M0DTPC15error5Error54bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeError(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error54bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeError.prototype.$tag = 39;
function _M0DTPC15error5Error54bobzhang_2fmoonjq_2fast_2eInterpreterError_2eEvalError(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error54bobzhang_2fmoonjq_2fast_2eInterpreterError_2eEvalError.prototype.$tag = 38;
function _M0DTPC15error5Error54bobzhang_2fmoonjq_2fparser_2eLexError_2eUnexpectedChar(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC15error5Error54bobzhang_2fmoonjq_2fparser_2eLexError_2eUnexpectedChar.prototype.$tag = 37;
function _M0DTPC15error5Error58bobzhang_2fmoonjq_2fparser_2eLexError_2eUnterminatedString(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error58bobzhang_2fmoonjq_2fparser_2eLexError_2eUnterminatedString.prototype.$tag = 36;
function _M0DTPC15error5Error53bobzhang_2fmoonjq_2fparser_2eLexError_2eInvalidNumber(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC15error5Error53bobzhang_2fmoonjq_2fparser_2eLexError_2eInvalidNumber.prototype.$tag = 35;
function _M0DTPC15error5Error53bobzhang_2fmoonjq_2fparser_2eLexError_2eInvalidEscape(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC15error5Error53bobzhang_2fmoonjq_2fparser_2eLexError_2eInvalidEscape.prototype.$tag = 34;
function _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError.prototype.$tag = 33;
function _M0DTPC15error5Error56gmlewis_2fbase64_2eCorruptInputError_2eCorruptInputError(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error56gmlewis_2fbase64_2eCorruptInputError_2eCorruptInputError.prototype.$tag = 32;
function _M0DTPC15error5Error50tonyfettes_2furl_2eValidationError_2eDomainToAscii() {}
_M0DTPC15error5Error50tonyfettes_2furl_2eValidationError_2eDomainToAscii.prototype.$tag = 31;
const _M0DTPC15error5Error50tonyfettes_2furl_2eValidationError_2eDomainToAscii__ = new _M0DTPC15error5Error50tonyfettes_2furl_2eValidationError_2eDomainToAscii();
function _M0DTPC15error5Error57tonyfettes_2furl_2eValidationError_2eHostInvalidCodePoint() {}
_M0DTPC15error5Error57tonyfettes_2furl_2eValidationError_2eHostInvalidCodePoint.prototype.$tag = 30;
const _M0DTPC15error5Error57tonyfettes_2furl_2eValidationError_2eHostInvalidCodePoint__ = new _M0DTPC15error5Error57tonyfettes_2furl_2eValidationError_2eHostInvalidCodePoint();
function _M0DTPC15error5Error50tonyfettes_2furl_2eValidationError_2eIPv4EmptyPart() {}
_M0DTPC15error5Error50tonyfettes_2furl_2eValidationError_2eIPv4EmptyPart.prototype.$tag = 29;
const _M0DTPC15error5Error50tonyfettes_2furl_2eValidationError_2eIPv4EmptyPart__ = new _M0DTPC15error5Error50tonyfettes_2furl_2eValidationError_2eIPv4EmptyPart();
function _M0DTPC15error5Error53tonyfettes_2furl_2eValidationError_2eIPv4TooManyParts() {}
_M0DTPC15error5Error53tonyfettes_2furl_2eValidationError_2eIPv4TooManyParts.prototype.$tag = 28;
const _M0DTPC15error5Error53tonyfettes_2furl_2eValidationError_2eIPv4TooManyParts__ = new _M0DTPC15error5Error53tonyfettes_2furl_2eValidationError_2eIPv4TooManyParts();
function _M0DTPC15error5Error55tonyfettes_2furl_2eValidationError_2eIPv4NonNumericPart() {}
_M0DTPC15error5Error55tonyfettes_2furl_2eValidationError_2eIPv4NonNumericPart.prototype.$tag = 27;
const _M0DTPC15error5Error55tonyfettes_2furl_2eValidationError_2eIPv4NonNumericPart__ = new _M0DTPC15error5Error55tonyfettes_2furl_2eValidationError_2eIPv4NonNumericPart();
function _M0DTPC15error5Error55tonyfettes_2furl_2eValidationError_2eIPv4OutOfRangePart() {}
_M0DTPC15error5Error55tonyfettes_2furl_2eValidationError_2eIPv4OutOfRangePart.prototype.$tag = 26;
const _M0DTPC15error5Error55tonyfettes_2furl_2eValidationError_2eIPv4OutOfRangePart__ = new _M0DTPC15error5Error55tonyfettes_2furl_2eValidationError_2eIPv4OutOfRangePart();
function _M0DTPC15error5Error59tonyfettes_2furl_2eValidationError_2eIPv6InvalidCompression() {}
_M0DTPC15error5Error59tonyfettes_2furl_2eValidationError_2eIPv6InvalidCompression.prototype.$tag = 25;
const _M0DTPC15error5Error59tonyfettes_2furl_2eValidationError_2eIPv6InvalidCompression__ = new _M0DTPC15error5Error59tonyfettes_2furl_2eValidationError_2eIPv6InvalidCompression();
function _M0DTPC15error5Error60tonyfettes_2furl_2eValidationError_2eIPv6MultipleCompression() {}
_M0DTPC15error5Error60tonyfettes_2furl_2eValidationError_2eIPv6MultipleCompression.prototype.$tag = 24;
const _M0DTPC15error5Error60tonyfettes_2furl_2eValidationError_2eIPv6MultipleCompression__ = new _M0DTPC15error5Error60tonyfettes_2furl_2eValidationError_2eIPv6MultipleCompression();
function _M0DTPC15error5Error54tonyfettes_2furl_2eValidationError_2eIPv6TooManyPieces() {}
_M0DTPC15error5Error54tonyfettes_2furl_2eValidationError_2eIPv6TooManyPieces.prototype.$tag = 23;
const _M0DTPC15error5Error54tonyfettes_2furl_2eValidationError_2eIPv6TooManyPieces__ = new _M0DTPC15error5Error54tonyfettes_2furl_2eValidationError_2eIPv6TooManyPieces();
function _M0DTPC15error5Error57tonyfettes_2furl_2eValidationError_2eIPv6InvalidCodePoint() {}
_M0DTPC15error5Error57tonyfettes_2furl_2eValidationError_2eIPv6InvalidCodePoint.prototype.$tag = 22;
const _M0DTPC15error5Error57tonyfettes_2furl_2eValidationError_2eIPv6InvalidCodePoint__ = new _M0DTPC15error5Error57tonyfettes_2furl_2eValidationError_2eIPv6InvalidCodePoint();
function _M0DTPC15error5Error53tonyfettes_2furl_2eValidationError_2eIPv6TooFewPieces() {}
_M0DTPC15error5Error53tonyfettes_2furl_2eValidationError_2eIPv6TooFewPieces.prototype.$tag = 21;
const _M0DTPC15error5Error53tonyfettes_2furl_2eValidationError_2eIPv6TooFewPieces__ = new _M0DTPC15error5Error53tonyfettes_2furl_2eValidationError_2eIPv6TooFewPieces();
function _M0DTPC15error5Error49tonyfettes_2furl_2eValidationError_2eIPv6Unclosed() {}
_M0DTPC15error5Error49tonyfettes_2furl_2eValidationError_2eIPv6Unclosed.prototype.$tag = 20;
const _M0DTPC15error5Error49tonyfettes_2furl_2eValidationError_2eIPv6Unclosed__ = new _M0DTPC15error5Error49tonyfettes_2furl_2eValidationError_2eIPv6Unclosed();
function _M0DTPC15error5Error63tonyfettes_2furl_2eValidationError_2eIPv4InIPv6InvalidCodePoint() {}
_M0DTPC15error5Error63tonyfettes_2furl_2eValidationError_2eIPv4InIPv6InvalidCodePoint.prototype.$tag = 19;
const _M0DTPC15error5Error63tonyfettes_2furl_2eValidationError_2eIPv4InIPv6InvalidCodePoint__ = new _M0DTPC15error5Error63tonyfettes_2furl_2eValidationError_2eIPv4InIPv6InvalidCodePoint();
function _M0DTPC15error5Error60tonyfettes_2furl_2eValidationError_2eIPv4InIPv6TooManyPieces() {}
_M0DTPC15error5Error60tonyfettes_2furl_2eValidationError_2eIPv4InIPv6TooManyPieces.prototype.$tag = 18;
const _M0DTPC15error5Error60tonyfettes_2furl_2eValidationError_2eIPv4InIPv6TooManyPieces__ = new _M0DTPC15error5Error60tonyfettes_2furl_2eValidationError_2eIPv4InIPv6TooManyPieces();
function _M0DTPC15error5Error61tonyfettes_2furl_2eValidationError_2eIPv4InIPv6OutOfRangePart() {}
_M0DTPC15error5Error61tonyfettes_2furl_2eValidationError_2eIPv4InIPv6OutOfRangePart.prototype.$tag = 17;
const _M0DTPC15error5Error61tonyfettes_2furl_2eValidationError_2eIPv4InIPv6OutOfRangePart__ = new _M0DTPC15error5Error61tonyfettes_2furl_2eValidationError_2eIPv4InIPv6OutOfRangePart();
function _M0DTPC15error5Error58tonyfettes_2furl_2eValidationError_2eIPv4InIPv6TooFewParts() {}
_M0DTPC15error5Error58tonyfettes_2furl_2eValidationError_2eIPv4InIPv6TooFewParts.prototype.$tag = 16;
const _M0DTPC15error5Error58tonyfettes_2furl_2eValidationError_2eIPv4InIPv6TooFewParts__ = new _M0DTPC15error5Error58tonyfettes_2furl_2eValidationError_2eIPv4InIPv6TooFewParts();
function _M0DTPC15error5Error64tonyfettes_2furl_2eValidationError_2eMissingSchemeNonRelativeUrl() {}
_M0DTPC15error5Error64tonyfettes_2furl_2eValidationError_2eMissingSchemeNonRelativeUrl.prototype.$tag = 15;
const _M0DTPC15error5Error64tonyfettes_2furl_2eValidationError_2eMissingSchemeNonRelativeUrl__ = new _M0DTPC15error5Error64tonyfettes_2furl_2eValidationError_2eMissingSchemeNonRelativeUrl();
function _M0DTPC15error5Error73tonyfettes_2furl_2eValidationError_2eSpecialSchemeMissingFollowingSolidus() {}
_M0DTPC15error5Error73tonyfettes_2furl_2eValidationError_2eSpecialSchemeMissingFollowingSolidus.prototype.$tag = 14;
const _M0DTPC15error5Error73tonyfettes_2furl_2eValidationError_2eSpecialSchemeMissingFollowingSolidus__ = new _M0DTPC15error5Error73tonyfettes_2furl_2eValidationError_2eSpecialSchemeMissingFollowingSolidus();
function _M0DTPC15error5Error58tonyfettes_2furl_2eValidationError_2eInvalidReverseSolidus() {}
_M0DTPC15error5Error58tonyfettes_2furl_2eValidationError_2eInvalidReverseSolidus.prototype.$tag = 13;
const _M0DTPC15error5Error58tonyfettes_2furl_2eValidationError_2eInvalidReverseSolidus__ = new _M0DTPC15error5Error58tonyfettes_2furl_2eValidationError_2eInvalidReverseSolidus();
function _M0DTPC15error5Error55tonyfettes_2furl_2eValidationError_2eInvalidCredentials() {}
_M0DTPC15error5Error55tonyfettes_2furl_2eValidationError_2eInvalidCredentials.prototype.$tag = 12;
const _M0DTPC15error5Error55tonyfettes_2furl_2eValidationError_2eInvalidCredentials__ = new _M0DTPC15error5Error55tonyfettes_2furl_2eValidationError_2eInvalidCredentials();
function _M0DTPC15error5Error48tonyfettes_2furl_2eValidationError_2eHostMissing() {}
_M0DTPC15error5Error48tonyfettes_2furl_2eValidationError_2eHostMissing.prototype.$tag = 11;
const _M0DTPC15error5Error48tonyfettes_2furl_2eValidationError_2eHostMissing__ = new _M0DTPC15error5Error48tonyfettes_2furl_2eValidationError_2eHostMissing();
function _M0DTPC15error5Error52moonbitlang_2fcore_2fjson_2eParseError_2eInvalidChar(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC15error5Error52moonbitlang_2fcore_2fjson_2eParseError_2eInvalidChar.prototype.$tag = 10;
function _M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof() {}
_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof.prototype.$tag = 9;
const _M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__ = new _M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof();
function _M0DTPC15error5Error54moonbitlang_2fcore_2fjson_2eParseError_2eInvalidNumber(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC15error5Error54moonbitlang_2fcore_2fjson_2eParseError_2eInvalidNumber.prototype.$tag = 8;
function _M0DTPC15error5Error59moonbitlang_2fcore_2fjson_2eParseError_2eInvalidIdentEscape(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error59moonbitlang_2fcore_2fjson_2eParseError_2eInvalidIdentEscape.prototype.$tag = 7;
function _M0DTPC15error5Error59moonbitlang_2fcore_2fjson_2eParseError_2eDepthLimitExceeded() {}
_M0DTPC15error5Error59moonbitlang_2fcore_2fjson_2eParseError_2eDepthLimitExceeded.prototype.$tag = 6;
const _M0DTPC15error5Error59moonbitlang_2fcore_2fjson_2eParseError_2eDepthLimitExceeded__ = new _M0DTPC15error5Error59moonbitlang_2fcore_2fjson_2eParseError_2eDepthLimitExceeded();
function _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError.prototype.$tag = 5;
function _M0DTPC15error5Error48moonbitlang_2fcore_2fbuiltin_2eFailure_2eFailure(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error48moonbitlang_2fcore_2fbuiltin_2eFailure_2eFailure.prototype.$tag = 4;
function _M0DTPC15error5Error58tonyfettes_2funicode_2fpunycode_2ePunycodeError_2eOverflow() {}
_M0DTPC15error5Error58tonyfettes_2funicode_2fpunycode_2ePunycodeError_2eOverflow.prototype.$tag = 3;
const _M0DTPC15error5Error58tonyfettes_2funicode_2fpunycode_2ePunycodeError_2eOverflow__ = new _M0DTPC15error5Error58tonyfettes_2funicode_2fpunycode_2ePunycodeError_2eOverflow();
function _M0DTPC15error5Error62tonyfettes_2funicode_2fpunycode_2ePunycodeError_2eInvalidInput() {}
_M0DTPC15error5Error62tonyfettes_2funicode_2fpunycode_2ePunycodeError_2eInvalidInput.prototype.$tag = 2;
function _M0DTPC15error5Error58tonyfettes_2funicode_2fpunycode_2ePunycodeError_2eBadInput() {}
_M0DTPC15error5Error58tonyfettes_2funicode_2fpunycode_2ePunycodeError_2eBadInput.prototype.$tag = 1;
const _M0DTPC15error5Error58tonyfettes_2funicode_2fpunycode_2ePunycodeError_2eBadInput__ = new _M0DTPC15error5Error58tonyfettes_2funicode_2fpunycode_2ePunycodeError_2eBadInput();
function _M0DTPC15error5Error32gmlewis_2fio_2eIOError_2eIOError(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error32gmlewis_2fio_2eIOError_2eIOError.prototype.$tag = 0;
function _M0TP27gmlewis5flate14HuffmanEncoder(param0, param1, param2) {
  this.codes = param0;
  this.freqcache = param1;
  this.bit_count = param2;
}
function _M0TP27gmlewis5flate5HCode(param0, param1) {
  this.code = param0;
  this.len = param1;
}
function _M0TP27gmlewis5flate14HuffmanDecoder(param0, param1, param2, param3) {
  this.min = param0;
  this.chunks = param1;
  this.links = param2;
  this.link_mask = param3;
}
function _M0TP27gmlewis5flate11LiteralNode(param0, param1) {
  this.literal = param0;
  this.freq = param1;
}
function _M0TP311moonbitlang1x4time10ZoneOffset(param0, param1, param2, param3) {
  this.id = param0;
  this.abbrev = param1;
  this.seconds = param2;
  this.dst = param3;
}
function _M0TP410Haoxincode8moonbash3lib8commands16AwkExprEvalState(param0) {
  this.out = param0;
}
function _M0TP410Haoxincode8moonbash3lib11interpreter13SedRangeState(param0, param1, param2) {
  this.in_range = param0;
  this.relative_end_line = param1;
  this.pending_single_line = param2;
}
function _M0TP410Haoxincode8moonbash3lib11interpreter14TestEvalResult(param0, param1) {
  this.value = param0;
  this.status = param1;
}
function _M0DTP410Haoxincode8moonbash3lib3ast5Token4Word(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast5Token4Word.prototype.$tag = 0;
function _M0DTP410Haoxincode8moonbash3lib3ast5Token6Number(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast5Token6Number.prototype.$tag = 1;
function _M0DTP410Haoxincode8moonbash3lib3ast5Token14AssignmentWord(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP410Haoxincode8moonbash3lib3ast5Token14AssignmentWord.prototype.$tag = 2;
function _M0DTP410Haoxincode8moonbash3lib3ast5Token4Pipe() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token4Pipe.prototype.$tag = 3;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token4Pipe__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token4Pipe();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token7PipeAnd() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token7PipeAnd.prototype.$tag = 4;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token7PipeAnd__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token7PipeAnd();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token3And() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token3And.prototype.$tag = 5;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token3And__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token3And();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token2Or() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token2Or.prototype.$tag = 6;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token2Or__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token2Or();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token4Semi() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token4Semi.prototype.$tag = 7;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token4Semi__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token4Semi();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token9Ampersand() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token9Ampersand.prototype.$tag = 8;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token9Ampersand__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token9Ampersand();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token7Newline() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token7Newline.prototype.$tag = 9;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token7Newline__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token7Newline();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token10RedirectIn() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token10RedirectIn.prototype.$tag = 10;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token10RedirectIn__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token10RedirectIn();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token11RedirectOut() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token11RedirectOut.prototype.$tag = 11;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token11RedirectOut__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token11RedirectOut();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token14RedirectAppend() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token14RedirectAppend.prototype.$tag = 12;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token14RedirectAppend__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token14RedirectAppend();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token15RedirectClobber() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token15RedirectClobber.prototype.$tag = 13;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token15RedirectClobber__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token15RedirectClobber();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token7HereDoc() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token7HereDoc.prototype.$tag = 14;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token7HereDoc__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token7HereDoc();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token12HereDocStrip() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token12HereDocStrip.prototype.$tag = 15;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token12HereDocStrip__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token12HereDocStrip();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token10HereString() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token10HereString.prototype.$tag = 16;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token10HereString__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token10HereString();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token5DupIn() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token5DupIn.prototype.$tag = 17;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token5DupIn__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token5DupIn();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token6DupOut() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token6DupOut.prototype.$tag = 18;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token6DupOut__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token6DupOut();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token13RedirectInOut() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token13RedirectInOut.prototype.$tag = 19;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token13RedirectInOut__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token13RedirectInOut();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token14RedirectAndOut() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token14RedirectAndOut.prototype.$tag = 20;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token14RedirectAndOut__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token14RedirectAndOut();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token17RedirectAndAppend() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token17RedirectAndAppend.prototype.$tag = 21;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token17RedirectAndAppend__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token17RedirectAndAppend();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token9LeftParen() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token9LeftParen.prototype.$tag = 22;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token9LeftParen__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token9LeftParen();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token10RightParen() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token10RightParen.prototype.$tag = 23;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token10RightParen__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token10RightParen();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token9LeftBrace() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token9LeftBrace.prototype.$tag = 24;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token9LeftBrace__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token9LeftBrace();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token10RightBrace() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token10RightBrace.prototype.$tag = 25;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token10RightBrace__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token10RightBrace();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token17DoubleBracketOpen() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token17DoubleBracketOpen.prototype.$tag = 26;
function _M0DTP410Haoxincode8moonbash3lib3ast5Token18DoubleBracketClose() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token18DoubleBracketClose.prototype.$tag = 27;
function _M0DTP410Haoxincode8moonbash3lib3ast5Token2If() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token2If.prototype.$tag = 28;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token2If__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token2If();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token4Then() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token4Then.prototype.$tag = 29;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token4Then__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token4Then();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token4Elif() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token4Elif.prototype.$tag = 30;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token4Elif__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token4Elif();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token4Else() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token4Else.prototype.$tag = 31;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token4Else__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token4Else();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token2Fi() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token2Fi.prototype.$tag = 32;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token2Fi__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token2Fi();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token3For() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token3For.prototype.$tag = 33;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token3For__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token3For();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token5While() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token5While.prototype.$tag = 34;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token5While__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token5While();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token5Until() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token5Until.prototype.$tag = 35;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token5Until__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token5Until();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token2Do() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token2Do.prototype.$tag = 36;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token2Do__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token2Do();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token4Done() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token4Done.prototype.$tag = 37;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token4Done__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token4Done();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token4Case() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token4Case.prototype.$tag = 38;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token4Case__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token4Case();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token4Esac() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token4Esac.prototype.$tag = 39;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token4Esac__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token4Esac();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token2In() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token2In.prototype.$tag = 40;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token2In__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token2In();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token8Function() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token8Function.prototype.$tag = 41;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token8Function__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token8Function();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token6Select() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token6Select.prototype.$tag = 42;
function _M0DTP410Haoxincode8moonbash3lib3ast5Token4Bang() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token4Bang.prototype.$tag = 43;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token4Bang__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token4Bang();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token4Time() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token4Time.prototype.$tag = 44;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token4Time__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token4Time();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token3EOF() {}
_M0DTP410Haoxincode8moonbash3lib3ast5Token3EOF.prototype.$tag = 45;
const _M0DTP410Haoxincode8moonbash3lib3ast5Token3EOF__ = new _M0DTP410Haoxincode8moonbash3lib3ast5Token3EOF();
function _M0DTP410Haoxincode8moonbash3lib3ast5Token8FdNumber(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast5Token8FdNumber.prototype.$tag = 46;
function _M0DTP410Haoxincode8moonbash3lib3ast8WordPart7Literal(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast8WordPart7Literal.prototype.$tag = 0;
function _M0DTP410Haoxincode8moonbash3lib3ast8WordPart12SingleQuoted(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast8WordPart12SingleQuoted.prototype.$tag = 1;
function _M0DTP410Haoxincode8moonbash3lib3ast8WordPart12DoubleQuoted(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast8WordPart12DoubleQuoted.prototype.$tag = 2;
function _M0DTP410Haoxincode8moonbash3lib3ast8WordPart8Variable(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast8WordPart8Variable.prototype.$tag = 3;
function _M0DTP410Haoxincode8moonbash3lib3ast8WordPart18ParameterExpansion(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast8WordPart18ParameterExpansion.prototype.$tag = 4;
function _M0DTP410Haoxincode8moonbash3lib3ast8WordPart19CommandSubstitution(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast8WordPart19CommandSubstitution.prototype.$tag = 5;
function _M0DTP410Haoxincode8moonbash3lib3ast8WordPart19ArithmeticExpansion(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast8WordPart19ArithmeticExpansion.prototype.$tag = 6;
function _M0DTP410Haoxincode8moonbash3lib3ast8WordPart14BraceExpansion(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast8WordPart14BraceExpansion.prototype.$tag = 7;
function _M0DTP410Haoxincode8moonbash3lib3ast8WordPart11TildePrefix(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast8WordPart11TildePrefix.prototype.$tag = 8;
function _M0DTP410Haoxincode8moonbash3lib3ast8WordPart4Glob(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast8WordPart4Glob.prototype.$tag = 9;
function _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp5Input() {}
_M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp5Input.prototype.$tag = 0;
const _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp5Input__ = new _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp5Input();
function _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp6Output() {}
_M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp6Output.prototype.$tag = 1;
const _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp6Output__ = new _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp6Output();
function _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp6Append() {}
_M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp6Append.prototype.$tag = 2;
const _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp6Append__ = new _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp6Append();
function _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp7Clobber() {}
_M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp7Clobber.prototype.$tag = 3;
const _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp7Clobber__ = new _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp7Clobber();
function _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp11InputOutput() {}
_M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp11InputOutput.prototype.$tag = 4;
const _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp11InputOutput__ = new _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp11InputOutput();
function _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp7HereDoc(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp7HereDoc.prototype.$tag = 5;
function _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp10HereString() {}
_M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp10HereString.prototype.$tag = 6;
const _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp10HereString__ = new _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp10HereString();
function _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp8DupInput() {}
_M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp8DupInput.prototype.$tag = 7;
const _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp8DupInput__ = new _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp8DupInput();
function _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp9DupOutput() {}
_M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp9DupOutput.prototype.$tag = 8;
const _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp9DupOutput__ = new _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp9DupOutput();
function _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp9AndOutput() {}
_M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp9AndOutput.prototype.$tag = 9;
const _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp9AndOutput__ = new _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp9AndOutput();
function _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp9AndAppend() {}
_M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp9AndAppend.prototype.$tag = 10;
const _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp9AndAppend__ = new _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp9AndAppend();
function _M0DTP219moonbit_2dcommunity4yaml9TokenType11StreamStart() {}
_M0DTP219moonbit_2dcommunity4yaml9TokenType11StreamStart.prototype.$tag = 0;
const _M0DTP219moonbit_2dcommunity4yaml9TokenType11StreamStart__ = new _M0DTP219moonbit_2dcommunity4yaml9TokenType11StreamStart();
function _M0DTP219moonbit_2dcommunity4yaml9TokenType9StreamEnd() {}
_M0DTP219moonbit_2dcommunity4yaml9TokenType9StreamEnd.prototype.$tag = 1;
const _M0DTP219moonbit_2dcommunity4yaml9TokenType9StreamEnd__ = new _M0DTP219moonbit_2dcommunity4yaml9TokenType9StreamEnd();
function _M0DTP219moonbit_2dcommunity4yaml9TokenType16VersionDirective(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP219moonbit_2dcommunity4yaml9TokenType16VersionDirective.prototype.$tag = 2;
function _M0DTP219moonbit_2dcommunity4yaml9TokenType12TagDirective(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP219moonbit_2dcommunity4yaml9TokenType12TagDirective.prototype.$tag = 3;
function _M0DTP219moonbit_2dcommunity4yaml9TokenType13DocumentStart() {}
_M0DTP219moonbit_2dcommunity4yaml9TokenType13DocumentStart.prototype.$tag = 4;
const _M0DTP219moonbit_2dcommunity4yaml9TokenType13DocumentStart__ = new _M0DTP219moonbit_2dcommunity4yaml9TokenType13DocumentStart();
function _M0DTP219moonbit_2dcommunity4yaml9TokenType11DocumentEnd() {}
_M0DTP219moonbit_2dcommunity4yaml9TokenType11DocumentEnd.prototype.$tag = 5;
const _M0DTP219moonbit_2dcommunity4yaml9TokenType11DocumentEnd__ = new _M0DTP219moonbit_2dcommunity4yaml9TokenType11DocumentEnd();
function _M0DTP219moonbit_2dcommunity4yaml9TokenType18BlockSequenceStart() {}
_M0DTP219moonbit_2dcommunity4yaml9TokenType18BlockSequenceStart.prototype.$tag = 6;
const _M0DTP219moonbit_2dcommunity4yaml9TokenType18BlockSequenceStart__ = new _M0DTP219moonbit_2dcommunity4yaml9TokenType18BlockSequenceStart();
function _M0DTP219moonbit_2dcommunity4yaml9TokenType17BlockMappingStart() {}
_M0DTP219moonbit_2dcommunity4yaml9TokenType17BlockMappingStart.prototype.$tag = 7;
const _M0DTP219moonbit_2dcommunity4yaml9TokenType17BlockMappingStart__ = new _M0DTP219moonbit_2dcommunity4yaml9TokenType17BlockMappingStart();
function _M0DTP219moonbit_2dcommunity4yaml9TokenType8BlockEnd() {}
_M0DTP219moonbit_2dcommunity4yaml9TokenType8BlockEnd.prototype.$tag = 8;
const _M0DTP219moonbit_2dcommunity4yaml9TokenType8BlockEnd__ = new _M0DTP219moonbit_2dcommunity4yaml9TokenType8BlockEnd();
function _M0DTP219moonbit_2dcommunity4yaml9TokenType17FlowSequenceStart() {}
_M0DTP219moonbit_2dcommunity4yaml9TokenType17FlowSequenceStart.prototype.$tag = 9;
const _M0DTP219moonbit_2dcommunity4yaml9TokenType17FlowSequenceStart__ = new _M0DTP219moonbit_2dcommunity4yaml9TokenType17FlowSequenceStart();
function _M0DTP219moonbit_2dcommunity4yaml9TokenType15FlowSequenceEnd() {}
_M0DTP219moonbit_2dcommunity4yaml9TokenType15FlowSequenceEnd.prototype.$tag = 10;
const _M0DTP219moonbit_2dcommunity4yaml9TokenType15FlowSequenceEnd__ = new _M0DTP219moonbit_2dcommunity4yaml9TokenType15FlowSequenceEnd();
function _M0DTP219moonbit_2dcommunity4yaml9TokenType16FlowMappingStart() {}
_M0DTP219moonbit_2dcommunity4yaml9TokenType16FlowMappingStart.prototype.$tag = 11;
const _M0DTP219moonbit_2dcommunity4yaml9TokenType16FlowMappingStart__ = new _M0DTP219moonbit_2dcommunity4yaml9TokenType16FlowMappingStart();
function _M0DTP219moonbit_2dcommunity4yaml9TokenType14FlowMappingEnd() {}
_M0DTP219moonbit_2dcommunity4yaml9TokenType14FlowMappingEnd.prototype.$tag = 12;
const _M0DTP219moonbit_2dcommunity4yaml9TokenType14FlowMappingEnd__ = new _M0DTP219moonbit_2dcommunity4yaml9TokenType14FlowMappingEnd();
function _M0DTP219moonbit_2dcommunity4yaml9TokenType10BlockEntry() {}
_M0DTP219moonbit_2dcommunity4yaml9TokenType10BlockEntry.prototype.$tag = 13;
const _M0DTP219moonbit_2dcommunity4yaml9TokenType10BlockEntry__ = new _M0DTP219moonbit_2dcommunity4yaml9TokenType10BlockEntry();
function _M0DTP219moonbit_2dcommunity4yaml9TokenType9FlowEntry() {}
_M0DTP219moonbit_2dcommunity4yaml9TokenType9FlowEntry.prototype.$tag = 14;
const _M0DTP219moonbit_2dcommunity4yaml9TokenType9FlowEntry__ = new _M0DTP219moonbit_2dcommunity4yaml9TokenType9FlowEntry();
function _M0DTP219moonbit_2dcommunity4yaml9TokenType3Key() {}
_M0DTP219moonbit_2dcommunity4yaml9TokenType3Key.prototype.$tag = 15;
const _M0DTP219moonbit_2dcommunity4yaml9TokenType3Key__ = new _M0DTP219moonbit_2dcommunity4yaml9TokenType3Key();
function _M0DTP219moonbit_2dcommunity4yaml9TokenType5Value() {}
_M0DTP219moonbit_2dcommunity4yaml9TokenType5Value.prototype.$tag = 16;
const _M0DTP219moonbit_2dcommunity4yaml9TokenType5Value__ = new _M0DTP219moonbit_2dcommunity4yaml9TokenType5Value();
function _M0DTP219moonbit_2dcommunity4yaml9TokenType5Alias(param0) {
  this._0 = param0;
}
_M0DTP219moonbit_2dcommunity4yaml9TokenType5Alias.prototype.$tag = 17;
function _M0DTP219moonbit_2dcommunity4yaml9TokenType6Anchor(param0) {
  this._0 = param0;
}
_M0DTP219moonbit_2dcommunity4yaml9TokenType6Anchor.prototype.$tag = 18;
function _M0DTP219moonbit_2dcommunity4yaml9TokenType3Tag(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP219moonbit_2dcommunity4yaml9TokenType3Tag.prototype.$tag = 19;
function _M0DTP219moonbit_2dcommunity4yaml9TokenType6Scalar(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP219moonbit_2dcommunity4yaml9TokenType6Scalar.prototype.$tag = 20;
function _M0TP219moonbit_2dcommunity4yaml6Marker(param0, param1, param2) {
  this.index = param0;
  this.line = param1;
  this.col = param2;
}
function _M0DTP219moonbit_2dcommunity4yaml4Yaml4Real(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP219moonbit_2dcommunity4yaml4Yaml4Real.prototype.$tag = 0;
function _M0DTP219moonbit_2dcommunity4yaml4Yaml7Integer(param0) {
  this._0 = param0;
}
_M0DTP219moonbit_2dcommunity4yaml4Yaml7Integer.prototype.$tag = 1;
function _M0DTP219moonbit_2dcommunity4yaml4Yaml6String(param0) {
  this._0 = param0;
}
_M0DTP219moonbit_2dcommunity4yaml4Yaml6String.prototype.$tag = 2;
function _M0DTP219moonbit_2dcommunity4yaml4Yaml7Boolean(param0) {
  this._0 = param0;
}
_M0DTP219moonbit_2dcommunity4yaml4Yaml7Boolean.prototype.$tag = 3;
function _M0DTP219moonbit_2dcommunity4yaml4Yaml5Array(param0) {
  this._0 = param0;
}
_M0DTP219moonbit_2dcommunity4yaml4Yaml5Array.prototype.$tag = 4;
function _M0DTP219moonbit_2dcommunity4yaml4Yaml3Map(param0) {
  this._0 = param0;
}
_M0DTP219moonbit_2dcommunity4yaml4Yaml3Map.prototype.$tag = 5;
function _M0DTP219moonbit_2dcommunity4yaml4Yaml4Null() {}
_M0DTP219moonbit_2dcommunity4yaml4Yaml4Null.prototype.$tag = 6;
const _M0DTP219moonbit_2dcommunity4yaml4Yaml4Null__ = new _M0DTP219moonbit_2dcommunity4yaml4Yaml4Null();
function _M0DTP219moonbit_2dcommunity4yaml4Yaml8BadValue() {}
_M0DTP219moonbit_2dcommunity4yaml4Yaml8BadValue.prototype.$tag = 7;
const _M0DTP219moonbit_2dcommunity4yaml4Yaml8BadValue__ = new _M0DTP219moonbit_2dcommunity4yaml4Yaml8BadValue();
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands14VmExecResponsesE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands14VmExecResponsesE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands14VmExecResponsesE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands14VmExecResponsesE2Ok.prototype.$tag = 1;
function _M0DTP38bobzhang6moonjq3ast7Literal4Null() {}
_M0DTP38bobzhang6moonjq3ast7Literal4Null.prototype.$tag = 0;
const _M0DTP38bobzhang6moonjq3ast7Literal4Null__ = new _M0DTP38bobzhang6moonjq3ast7Literal4Null();
function _M0DTP38bobzhang6moonjq3ast7Literal4Bool(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast7Literal4Bool.prototype.$tag = 1;
function _M0DTP38bobzhang6moonjq3ast7Literal6Number(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast7Literal6Number.prototype.$tag = 2;
function _M0DTP38bobzhang6moonjq3ast7Literal6String(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast7Literal6String.prototype.$tag = 3;
function _M0DTP38bobzhang6moonjq3ast4Expr8Identity() {}
_M0DTP38bobzhang6moonjq3ast4Expr8Identity.prototype.$tag = 0;
const _M0DTP38bobzhang6moonjq3ast4Expr8Identity__ = new _M0DTP38bobzhang6moonjq3ast4Expr8Identity();
function _M0DTP38bobzhang6moonjq3ast4Expr7Literal(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr7Literal.prototype.$tag = 1;
function _M0DTP38bobzhang6moonjq3ast4Expr4Pipe(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr4Pipe.prototype.$tag = 2;
function _M0DTP38bobzhang6moonjq3ast4Expr5Comma(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr5Comma.prototype.$tag = 3;
function _M0DTP38bobzhang6moonjq3ast4Expr3Key(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr3Key.prototype.$tag = 4;
function _M0DTP38bobzhang6moonjq3ast4Expr5Index(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr5Index.prototype.$tag = 5;
function _M0DTP38bobzhang6moonjq3ast4Expr5Slice(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr5Slice.prototype.$tag = 6;
function _M0DTP38bobzhang6moonjq3ast4Expr8Optional(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr8Optional.prototype.$tag = 7;
function _M0DTP38bobzhang6moonjq3ast4Expr14ArrayConstruct(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr14ArrayConstruct.prototype.$tag = 8;
function _M0DTP38bobzhang6moonjq3ast4Expr15ObjectConstruct(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr15ObjectConstruct.prototype.$tag = 9;
function _M0DTP38bobzhang6moonjq3ast4Expr9Operation(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP38bobzhang6moonjq3ast4Expr9Operation.prototype.$tag = 10;
function _M0DTP38bobzhang6moonjq3ast4Expr6Length() {}
_M0DTP38bobzhang6moonjq3ast4Expr6Length.prototype.$tag = 11;
const _M0DTP38bobzhang6moonjq3ast4Expr6Length__ = new _M0DTP38bobzhang6moonjq3ast4Expr6Length();
function _M0DTP38bobzhang6moonjq3ast4Expr4Keys() {}
_M0DTP38bobzhang6moonjq3ast4Expr4Keys.prototype.$tag = 12;
const _M0DTP38bobzhang6moonjq3ast4Expr4Keys__ = new _M0DTP38bobzhang6moonjq3ast4Expr4Keys();
function _M0DTP38bobzhang6moonjq3ast4Expr6Values() {}
_M0DTP38bobzhang6moonjq3ast4Expr6Values.prototype.$tag = 13;
const _M0DTP38bobzhang6moonjq3ast4Expr6Values__ = new _M0DTP38bobzhang6moonjq3ast4Expr6Values();
function _M0DTP38bobzhang6moonjq3ast4Expr4Type() {}
_M0DTP38bobzhang6moonjq3ast4Expr4Type.prototype.$tag = 14;
const _M0DTP38bobzhang6moonjq3ast4Expr4Type__ = new _M0DTP38bobzhang6moonjq3ast4Expr4Type();
function _M0DTP38bobzhang6moonjq3ast4Expr5Empty() {}
_M0DTP38bobzhang6moonjq3ast4Expr5Empty.prototype.$tag = 15;
const _M0DTP38bobzhang6moonjq3ast4Expr5Empty__ = new _M0DTP38bobzhang6moonjq3ast4Expr5Empty();
function _M0DTP38bobzhang6moonjq3ast4Expr3Not() {}
_M0DTP38bobzhang6moonjq3ast4Expr3Not.prototype.$tag = 16;
const _M0DTP38bobzhang6moonjq3ast4Expr3Not__ = new _M0DTP38bobzhang6moonjq3ast4Expr3Not();
function _M0DTP38bobzhang6moonjq3ast4Expr3Map(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr3Map.prototype.$tag = 17;
function _M0DTP38bobzhang6moonjq3ast4Expr6Select(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr6Select.prototype.$tag = 18;
function _M0DTP38bobzhang6moonjq3ast4Expr4Sort() {}
_M0DTP38bobzhang6moonjq3ast4Expr4Sort.prototype.$tag = 19;
const _M0DTP38bobzhang6moonjq3ast4Expr4Sort__ = new _M0DTP38bobzhang6moonjq3ast4Expr4Sort();
function _M0DTP38bobzhang6moonjq3ast4Expr6SortBy(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr6SortBy.prototype.$tag = 20;
function _M0DTP38bobzhang6moonjq3ast4Expr7Reverse() {}
_M0DTP38bobzhang6moonjq3ast4Expr7Reverse.prototype.$tag = 21;
const _M0DTP38bobzhang6moonjq3ast4Expr7Reverse__ = new _M0DTP38bobzhang6moonjq3ast4Expr7Reverse();
function _M0DTP38bobzhang6moonjq3ast4Expr7Flatten(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr7Flatten.prototype.$tag = 22;
function _M0DTP38bobzhang6moonjq3ast4Expr6Unique() {}
_M0DTP38bobzhang6moonjq3ast4Expr6Unique.prototype.$tag = 23;
const _M0DTP38bobzhang6moonjq3ast4Expr6Unique__ = new _M0DTP38bobzhang6moonjq3ast4Expr6Unique();
function _M0DTP38bobzhang6moonjq3ast4Expr8UniqueBy(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr8UniqueBy.prototype.$tag = 24;
function _M0DTP38bobzhang6moonjq3ast4Expr7GroupBy(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr7GroupBy.prototype.$tag = 25;
function _M0DTP38bobzhang6moonjq3ast4Expr12Combinations() {}
_M0DTP38bobzhang6moonjq3ast4Expr12Combinations.prototype.$tag = 26;
const _M0DTP38bobzhang6moonjq3ast4Expr12Combinations__ = new _M0DTP38bobzhang6moonjq3ast4Expr12Combinations();
function _M0DTP38bobzhang6moonjq3ast4Expr9Transpose() {}
_M0DTP38bobzhang6moonjq3ast4Expr9Transpose.prototype.$tag = 27;
const _M0DTP38bobzhang6moonjq3ast4Expr9Transpose__ = new _M0DTP38bobzhang6moonjq3ast4Expr9Transpose();
function _M0DTP38bobzhang6moonjq3ast4Expr3Add() {}
_M0DTP38bobzhang6moonjq3ast4Expr3Add.prototype.$tag = 28;
const _M0DTP38bobzhang6moonjq3ast4Expr3Add__ = new _M0DTP38bobzhang6moonjq3ast4Expr3Add();
function _M0DTP38bobzhang6moonjq3ast4Expr5Floor() {}
_M0DTP38bobzhang6moonjq3ast4Expr5Floor.prototype.$tag = 29;
const _M0DTP38bobzhang6moonjq3ast4Expr5Floor__ = new _M0DTP38bobzhang6moonjq3ast4Expr5Floor();
function _M0DTP38bobzhang6moonjq3ast4Expr4Sqrt() {}
_M0DTP38bobzhang6moonjq3ast4Expr4Sqrt.prototype.$tag = 30;
const _M0DTP38bobzhang6moonjq3ast4Expr4Sqrt__ = new _M0DTP38bobzhang6moonjq3ast4Expr4Sqrt();
function _M0DTP38bobzhang6moonjq3ast4Expr3Min() {}
_M0DTP38bobzhang6moonjq3ast4Expr3Min.prototype.$tag = 31;
const _M0DTP38bobzhang6moonjq3ast4Expr3Min__ = new _M0DTP38bobzhang6moonjq3ast4Expr3Min();
function _M0DTP38bobzhang6moonjq3ast4Expr5MinBy(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr5MinBy.prototype.$tag = 32;
function _M0DTP38bobzhang6moonjq3ast4Expr3Max() {}
_M0DTP38bobzhang6moonjq3ast4Expr3Max.prototype.$tag = 33;
const _M0DTP38bobzhang6moonjq3ast4Expr3Max__ = new _M0DTP38bobzhang6moonjq3ast4Expr3Max();
function _M0DTP38bobzhang6moonjq3ast4Expr5MaxBy(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr5MaxBy.prototype.$tag = 34;
function _M0DTP38bobzhang6moonjq3ast4Expr5Round() {}
_M0DTP38bobzhang6moonjq3ast4Expr5Round.prototype.$tag = 35;
const _M0DTP38bobzhang6moonjq3ast4Expr5Round__ = new _M0DTP38bobzhang6moonjq3ast4Expr5Round();
function _M0DTP38bobzhang6moonjq3ast4Expr4Ceil() {}
_M0DTP38bobzhang6moonjq3ast4Expr4Ceil.prototype.$tag = 36;
const _M0DTP38bobzhang6moonjq3ast4Expr4Ceil__ = new _M0DTP38bobzhang6moonjq3ast4Expr4Ceil();
function _M0DTP38bobzhang6moonjq3ast4Expr3Abs() {}
_M0DTP38bobzhang6moonjq3ast4Expr3Abs.prototype.$tag = 37;
const _M0DTP38bobzhang6moonjq3ast4Expr3Abs__ = new _M0DTP38bobzhang6moonjq3ast4Expr3Abs();
function _M0DTP38bobzhang6moonjq3ast4Expr5Split(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr5Split.prototype.$tag = 38;
function _M0DTP38bobzhang6moonjq3ast4Expr4Join(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr4Join.prototype.$tag = 39;
function _M0DTP38bobzhang6moonjq3ast4Expr10StartsWith(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr10StartsWith.prototype.$tag = 40;
function _M0DTP38bobzhang6moonjq3ast4Expr8EndsWith(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr8EndsWith.prototype.$tag = 41;
function _M0DTP38bobzhang6moonjq3ast4Expr8Contains(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr8Contains.prototype.$tag = 42;
function _M0DTP38bobzhang6moonjq3ast4Expr6Inside(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr6Inside.prototype.$tag = 43;
function _M0DTP38bobzhang6moonjq3ast4Expr3Has(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr3Has.prototype.$tag = 44;
function _M0DTP38bobzhang6moonjq3ast4Expr2In(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr2In.prototype.$tag = 45;
function _M0DTP38bobzhang6moonjq3ast4Expr9ToEntries() {}
_M0DTP38bobzhang6moonjq3ast4Expr9ToEntries.prototype.$tag = 46;
const _M0DTP38bobzhang6moonjq3ast4Expr9ToEntries__ = new _M0DTP38bobzhang6moonjq3ast4Expr9ToEntries();
function _M0DTP38bobzhang6moonjq3ast4Expr11FromEntries() {}
_M0DTP38bobzhang6moonjq3ast4Expr11FromEntries.prototype.$tag = 47;
const _M0DTP38bobzhang6moonjq3ast4Expr11FromEntries__ = new _M0DTP38bobzhang6moonjq3ast4Expr11FromEntries();
function _M0DTP38bobzhang6moonjq3ast4Expr11WithEntries(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr11WithEntries.prototype.$tag = 48;
function _M0DTP38bobzhang6moonjq3ast4Expr9MapValues(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr9MapValues.prototype.$tag = 49;
function _M0DTP38bobzhang6moonjq3ast4Expr5Range(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr5Range.prototype.$tag = 50;
function _M0DTP38bobzhang6moonjq3ast4Expr11RangeFromTo(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr11RangeFromTo.prototype.$tag = 51;
function _M0DTP38bobzhang6moonjq3ast4Expr13RangeWithStep(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP38bobzhang6moonjq3ast4Expr13RangeWithStep.prototype.$tag = 52;
function _M0DTP38bobzhang6moonjq3ast4Expr5First() {}
_M0DTP38bobzhang6moonjq3ast4Expr5First.prototype.$tag = 53;
const _M0DTP38bobzhang6moonjq3ast4Expr5First__ = new _M0DTP38bobzhang6moonjq3ast4Expr5First();
function _M0DTP38bobzhang6moonjq3ast4Expr8FirstGen(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr8FirstGen.prototype.$tag = 54;
function _M0DTP38bobzhang6moonjq3ast4Expr4Last() {}
_M0DTP38bobzhang6moonjq3ast4Expr4Last.prototype.$tag = 55;
const _M0DTP38bobzhang6moonjq3ast4Expr4Last__ = new _M0DTP38bobzhang6moonjq3ast4Expr4Last();
function _M0DTP38bobzhang6moonjq3ast4Expr7LastGen(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr7LastGen.prototype.$tag = 56;
function _M0DTP38bobzhang6moonjq3ast4Expr6Repeat(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr6Repeat.prototype.$tag = 57;
function _M0DTP38bobzhang6moonjq3ast4Expr9IndicesOf(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr9IndicesOf.prototype.$tag = 58;
function _M0DTP38bobzhang6moonjq3ast4Expr7IndexOf(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr7IndexOf.prototype.$tag = 59;
function _M0DTP38bobzhang6moonjq3ast4Expr3Any() {}
_M0DTP38bobzhang6moonjq3ast4Expr3Any.prototype.$tag = 60;
const _M0DTP38bobzhang6moonjq3ast4Expr3Any__ = new _M0DTP38bobzhang6moonjq3ast4Expr3Any();
function _M0DTP38bobzhang6moonjq3ast4Expr6AnyGen(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr6AnyGen.prototype.$tag = 61;
function _M0DTP38bobzhang6moonjq3ast4Expr3All() {}
_M0DTP38bobzhang6moonjq3ast4Expr3All.prototype.$tag = 62;
const _M0DTP38bobzhang6moonjq3ast4Expr3All__ = new _M0DTP38bobzhang6moonjq3ast4Expr3All();
function _M0DTP38bobzhang6moonjq3ast4Expr6AllGen(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr6AllGen.prototype.$tag = 63;
function _M0DTP38bobzhang6moonjq3ast4Expr10IfThenElse(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP38bobzhang6moonjq3ast4Expr10IfThenElse.prototype.$tag = 64;
function _M0DTP38bobzhang6moonjq3ast4Expr8TryCatch(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr8TryCatch.prototype.$tag = 65;
function _M0DTP38bobzhang6moonjq3ast4Expr8Variable(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr8Variable.prototype.$tag = 66;
function _M0DTP38bobzhang6moonjq3ast4Expr2As(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP38bobzhang6moonjq3ast4Expr2As.prototype.$tag = 67;
function _M0DTP38bobzhang6moonjq3ast4Expr6Reduce(param0, param1, param2, param3) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
  this._3 = param3;
}
_M0DTP38bobzhang6moonjq3ast4Expr6Reduce.prototype.$tag = 68;
function _M0DTP38bobzhang6moonjq3ast4Expr7Foreach(param0, param1, param2, param3, param4) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
  this._3 = param3;
  this._4 = param4;
}
_M0DTP38bobzhang6moonjq3ast4Expr7Foreach.prototype.$tag = 69;
function _M0DTP38bobzhang6moonjq3ast4Expr7Recurse() {}
_M0DTP38bobzhang6moonjq3ast4Expr7Recurse.prototype.$tag = 70;
const _M0DTP38bobzhang6moonjq3ast4Expr7Recurse__ = new _M0DTP38bobzhang6moonjq3ast4Expr7Recurse();
function _M0DTP38bobzhang6moonjq3ast4Expr11RecurseWith(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr11RecurseWith.prototype.$tag = 71;
function _M0DTP38bobzhang6moonjq3ast4Expr4Walk(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr4Walk.prototype.$tag = 72;
function _M0DTP38bobzhang6moonjq3ast4Expr4Path(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr4Path.prototype.$tag = 73;
function _M0DTP38bobzhang6moonjq3ast4Expr6Update(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr6Update.prototype.$tag = 74;
function _M0DTP38bobzhang6moonjq3ast4Expr6Assign(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr6Assign.prototype.$tag = 75;
function _M0DTP38bobzhang6moonjq3ast4Expr11Alternative(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr11Alternative.prototype.$tag = 76;
function _M0DTP38bobzhang6moonjq3ast4Expr9AddAssign(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr9AddAssign.prototype.$tag = 77;
function _M0DTP38bobzhang6moonjq3ast4Expr9SubAssign(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr9SubAssign.prototype.$tag = 78;
function _M0DTP38bobzhang6moonjq3ast4Expr9MulAssign(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr9MulAssign.prototype.$tag = 79;
function _M0DTP38bobzhang6moonjq3ast4Expr9DivAssign(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr9DivAssign.prototype.$tag = 80;
function _M0DTP38bobzhang6moonjq3ast4Expr9ModAssign(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr9ModAssign.prototype.$tag = 81;
function _M0DTP38bobzhang6moonjq3ast4Expr9AltAssign(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr9AltAssign.prototype.$tag = 82;
function _M0DTP38bobzhang6moonjq3ast4Expr6Format(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr6Format.prototype.$tag = 83;
function _M0DTP38bobzhang6moonjq3ast4Expr19StringInterpolation(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr19StringInterpolation.prototype.$tag = 84;
function _M0DTP38bobzhang6moonjq3ast4Expr11FunctionDef(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP38bobzhang6moonjq3ast4Expr11FunctionDef.prototype.$tag = 85;
function _M0DTP38bobzhang6moonjq3ast4Expr12FunctionCall(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr12FunctionCall.prototype.$tag = 86;
function _M0DTP38bobzhang6moonjq3ast4Expr8LTrimStr(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr8LTrimStr.prototype.$tag = 87;
function _M0DTP38bobzhang6moonjq3ast4Expr8RTrimStr(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr8RTrimStr.prototype.$tag = 88;
function _M0DTP38bobzhang6moonjq3ast4Expr11AsciiUpcase() {}
_M0DTP38bobzhang6moonjq3ast4Expr11AsciiUpcase.prototype.$tag = 89;
const _M0DTP38bobzhang6moonjq3ast4Expr11AsciiUpcase__ = new _M0DTP38bobzhang6moonjq3ast4Expr11AsciiUpcase();
function _M0DTP38bobzhang6moonjq3ast4Expr13AsciiDowncase() {}
_M0DTP38bobzhang6moonjq3ast4Expr13AsciiDowncase.prototype.$tag = 90;
const _M0DTP38bobzhang6moonjq3ast4Expr13AsciiDowncase__ = new _M0DTP38bobzhang6moonjq3ast4Expr13AsciiDowncase();
function _M0DTP38bobzhang6moonjq3ast4Expr7Explode() {}
_M0DTP38bobzhang6moonjq3ast4Expr7Explode.prototype.$tag = 91;
const _M0DTP38bobzhang6moonjq3ast4Expr7Explode__ = new _M0DTP38bobzhang6moonjq3ast4Expr7Explode();
function _M0DTP38bobzhang6moonjq3ast4Expr7Implode() {}
_M0DTP38bobzhang6moonjq3ast4Expr7Implode.prototype.$tag = 92;
const _M0DTP38bobzhang6moonjq3ast4Expr7Implode__ = new _M0DTP38bobzhang6moonjq3ast4Expr7Implode();
function _M0DTP38bobzhang6moonjq3ast4Expr12ToJsonString() {}
_M0DTP38bobzhang6moonjq3ast4Expr12ToJsonString.prototype.$tag = 93;
const _M0DTP38bobzhang6moonjq3ast4Expr12ToJsonString__ = new _M0DTP38bobzhang6moonjq3ast4Expr12ToJsonString();
function _M0DTP38bobzhang6moonjq3ast4Expr14FromJsonString() {}
_M0DTP38bobzhang6moonjq3ast4Expr14FromJsonString.prototype.$tag = 94;
const _M0DTP38bobzhang6moonjq3ast4Expr14FromJsonString__ = new _M0DTP38bobzhang6moonjq3ast4Expr14FromJsonString();
function _M0DTP38bobzhang6moonjq3ast4Expr3Nth(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr3Nth.prototype.$tag = 95;
function _M0DTP38bobzhang6moonjq3ast4Expr6RIndex(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr6RIndex.prototype.$tag = 96;
function _M0DTP38bobzhang6moonjq3ast4Expr5Paths() {}
_M0DTP38bobzhang6moonjq3ast4Expr5Paths.prototype.$tag = 97;
const _M0DTP38bobzhang6moonjq3ast4Expr5Paths__ = new _M0DTP38bobzhang6moonjq3ast4Expr5Paths();
function _M0DTP38bobzhang6moonjq3ast4Expr15PathsWithFilter(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr15PathsWithFilter.prototype.$tag = 98;
function _M0DTP38bobzhang6moonjq3ast4Expr9LeafPaths() {}
_M0DTP38bobzhang6moonjq3ast4Expr9LeafPaths.prototype.$tag = 99;
const _M0DTP38bobzhang6moonjq3ast4Expr9LeafPaths__ = new _M0DTP38bobzhang6moonjq3ast4Expr9LeafPaths();
function _M0DTP38bobzhang6moonjq3ast4Expr7GetPath(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr7GetPath.prototype.$tag = 100;
function _M0DTP38bobzhang6moonjq3ast4Expr7SetPath(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr7SetPath.prototype.$tag = 101;
function _M0DTP38bobzhang6moonjq3ast4Expr8DelPaths(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr8DelPaths.prototype.$tag = 102;
function _M0DTP38bobzhang6moonjq3ast4Expr5Limit(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr5Limit.prototype.$tag = 103;
function _M0DTP38bobzhang6moonjq3ast4Expr5Until(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr5Until.prototype.$tag = 104;
function _M0DTP38bobzhang6moonjq3ast4Expr5While(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr5While.prototype.$tag = 105;
function _M0DTP38bobzhang6moonjq3ast4Expr3Pow(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr3Pow.prototype.$tag = 106;
function _M0DTP38bobzhang6moonjq3ast4Expr3Log() {}
_M0DTP38bobzhang6moonjq3ast4Expr3Log.prototype.$tag = 107;
const _M0DTP38bobzhang6moonjq3ast4Expr3Log__ = new _M0DTP38bobzhang6moonjq3ast4Expr3Log();
function _M0DTP38bobzhang6moonjq3ast4Expr3Exp() {}
_M0DTP38bobzhang6moonjq3ast4Expr3Exp.prototype.$tag = 108;
const _M0DTP38bobzhang6moonjq3ast4Expr3Exp__ = new _M0DTP38bobzhang6moonjq3ast4Expr3Exp();
function _M0DTP38bobzhang6moonjq3ast4Expr3Sin() {}
_M0DTP38bobzhang6moonjq3ast4Expr3Sin.prototype.$tag = 109;
const _M0DTP38bobzhang6moonjq3ast4Expr3Sin__ = new _M0DTP38bobzhang6moonjq3ast4Expr3Sin();
function _M0DTP38bobzhang6moonjq3ast4Expr3Cos() {}
_M0DTP38bobzhang6moonjq3ast4Expr3Cos.prototype.$tag = 110;
const _M0DTP38bobzhang6moonjq3ast4Expr3Cos__ = new _M0DTP38bobzhang6moonjq3ast4Expr3Cos();
function _M0DTP38bobzhang6moonjq3ast4Expr3Tan() {}
_M0DTP38bobzhang6moonjq3ast4Expr3Tan.prototype.$tag = 111;
const _M0DTP38bobzhang6moonjq3ast4Expr3Tan__ = new _M0DTP38bobzhang6moonjq3ast4Expr3Tan();
function _M0DTP38bobzhang6moonjq3ast4Expr4Asin() {}
_M0DTP38bobzhang6moonjq3ast4Expr4Asin.prototype.$tag = 112;
const _M0DTP38bobzhang6moonjq3ast4Expr4Asin__ = new _M0DTP38bobzhang6moonjq3ast4Expr4Asin();
function _M0DTP38bobzhang6moonjq3ast4Expr4Acos() {}
_M0DTP38bobzhang6moonjq3ast4Expr4Acos.prototype.$tag = 113;
const _M0DTP38bobzhang6moonjq3ast4Expr4Acos__ = new _M0DTP38bobzhang6moonjq3ast4Expr4Acos();
function _M0DTP38bobzhang6moonjq3ast4Expr4Atan() {}
_M0DTP38bobzhang6moonjq3ast4Expr4Atan.prototype.$tag = 114;
const _M0DTP38bobzhang6moonjq3ast4Expr4Atan__ = new _M0DTP38bobzhang6moonjq3ast4Expr4Atan();
function _M0DTP38bobzhang6moonjq3ast4Expr4Test(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr4Test.prototype.$tag = 115;
function _M0DTP38bobzhang6moonjq3ast4Expr5Match(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr5Match.prototype.$tag = 116;
function _M0DTP38bobzhang6moonjq3ast4Expr7Capture(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr7Capture.prototype.$tag = 117;
function _M0DTP38bobzhang6moonjq3ast4Expr4Scan(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr4Scan.prototype.$tag = 118;
function _M0DTP38bobzhang6moonjq3ast4Expr6Splits(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq3ast4Expr6Splits.prototype.$tag = 119;
function _M0DTP38bobzhang6moonjq3ast4Expr3Sub(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr3Sub.prototype.$tag = 120;
function _M0DTP38bobzhang6moonjq3ast4Expr4GSub(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP38bobzhang6moonjq3ast4Expr4GSub.prototype.$tag = 121;
function _M0TP311moonbitlang1x4time4Zone(param0, param1, param2) {
  this.id = param0;
  this.offsets = param1;
  this.transitions = param2;
}
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands18CustomExecResponsesE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands18CustomExecResponsesE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands18CustomExecResponsesE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands18CustomExecResponsesE2Ok.prototype.$tag = 1;
function _M0TP410Haoxincode8moonbash3lib3ast10ExecResult(param0, param1, param2) {
  this.stdout = param0;
  this.stderr = param1;
  this.exit_code = param2;
}
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands16NetFetchResponsesE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands16NetFetchResponsesE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands16NetFetchResponsesE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands16NetFetchResponsesE2Ok.prototype.$tag = 1;
function _M0DTP210tonyfettes3url4Host6Domain(param0) {
  this._0 = param0;
}
_M0DTP210tonyfettes3url4Host6Domain.prototype.$tag = 0;
function _M0DTP210tonyfettes3url4Host4IPv4(param0) {
  this._0 = param0;
}
_M0DTP210tonyfettes3url4Host4IPv4.prototype.$tag = 1;
function _M0DTP210tonyfettes3url4Host4IPv6(param0) {
  this._0 = param0;
}
_M0DTP210tonyfettes3url4Host4IPv6.prototype.$tag = 2;
function _M0DTP210tonyfettes3url4Host6Opaque(param0) {
  this._0 = param0;
}
_M0DTP210tonyfettes3url4Host6Opaque.prototype.$tag = 3;
function _M0DTP210tonyfettes3url4Path6Opaque(param0) {
  this._0 = param0;
}
_M0DTP210tonyfettes3url4Path6Opaque.prototype.$tag = 0;
function _M0DTP210tonyfettes3url4Path8Segments(param0) {
  this._0 = param0;
}
_M0DTP210tonyfettes3url4Path8Segments.prototype.$tag = 1;
function _M0DTPC16result6ResultGssE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGssE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGssE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGssE2Ok.prototype.$tag = 1;
function _M0TPB9ArrayViewGyE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0TP410Haoxincode8moonbash3lib6nyacsv10CSVOptions(param0, param1, param2, param3, param4) {
  this.delimiter = param0;
  this.allow_newlines_in_quotes = param1;
  this.quote_char = param2;
  this.skip_empty_lines = param3;
  this.trim_spaces = param4;
}
function _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst3Raw(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst3Raw.prototype.$tag = 0;
function _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst4Call(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst4Call.prototype.$tag = 1;
function _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Mutate(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Mutate.prototype.$tag = 2;
function _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst8UnaryNot(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst8UnaryNot.prototype.$tag = 3;
function _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Concat(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Concat.prototype.$tag = 4;
function _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst7Ternary(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst7Ternary.prototype.$tag = 5;
function _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Assign(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Assign.prototype.$tag = 6;
function _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst2In(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst2In.prototype.$tag = 7;
function _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Binary(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Binary.prototype.$tag = 8;
function _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt2If(param0, param1, param2, param3) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
  this._3 = param3;
}
_M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt2If.prototype.$tag = 0;
function _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt3For(param0, param1, param2, param3, param4) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
  this._3 = param3;
  this._4 = param4;
}
_M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt3For.prototype.$tag = 1;
function _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt5ForIn(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt5ForIn.prototype.$tag = 2;
function _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt5While(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt5While.prototype.$tag = 3;
function _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt4Next() {}
_M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt4Next.prototype.$tag = 4;
const _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt4Next__ = new _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt4Next();
function _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt4Exit(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt4Exit.prototype.$tag = 5;
function _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt6Return(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt6Return.prototype.$tag = 6;
function _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt6Printf(param0, param1, param2, param3) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
  this._3 = param3;
}
_M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt6Printf.prototype.$tag = 7;
function _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt5Print(param0, param1, param2, param3) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
  this._3 = param3;
}
_M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt5Print.prototype.$tag = 8;
function _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt6Delete(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt6Delete.prototype.$tag = 9;
function _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt11PipeGetline(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt11PipeGetline.prototype.$tag = 10;
function _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt7Getline(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt7Getline.prototype.$tag = 11;
function _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt10SystemStmt() {}
_M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt10SystemStmt.prototype.$tag = 12;
const _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt10SystemStmt__ = new _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt10SystemStmt();
function _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt14SubstituteStmt(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt14SubstituteStmt.prototype.$tag = 13;
function _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt15FieldAssignStmt(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt15FieldAssignStmt.prototype.$tag = 14;
function _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt10AssignStmt(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt10AssignStmt.prototype.$tag = 15;
function _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt18CompoundAssignStmt(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt18CompoundAssignStmt.prototype.$tag = 16;
function _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt8ExprStmt(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt8ExprStmt.prototype.$tag = 17;
function _M0DTP411moonbitlang6regexp8internal2vm11Instruction7Matched() {}
_M0DTP411moonbitlang6regexp8internal2vm11Instruction7Matched.prototype.$tag = 0;
const _M0DTP411moonbitlang6regexp8internal2vm11Instruction7Matched__ = new _M0DTP411moonbitlang6regexp8internal2vm11Instruction7Matched();
function _M0DTP411moonbitlang6regexp8internal2vm11Instruction4Save(param0) {
  this._0 = param0;
}
_M0DTP411moonbitlang6regexp8internal2vm11Instruction4Save.prototype.$tag = 1;
function _M0DTP411moonbitlang6regexp8internal2vm11Instruction4Char(param0) {
  this._0 = param0;
}
_M0DTP411moonbitlang6regexp8internal2vm11Instruction4Char.prototype.$tag = 2;
function _M0DTP411moonbitlang6regexp8internal2vm11Instruction4Jump(param0) {
  this._0 = param0;
}
_M0DTP411moonbitlang6regexp8internal2vm11Instruction4Jump.prototype.$tag = 3;
function _M0DTP411moonbitlang6regexp8internal2vm11Instruction5Split(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP411moonbitlang6regexp8internal2vm11Instruction5Split.prototype.$tag = 4;
function _M0DTP411moonbitlang6regexp8internal2vm11Instruction9Assertion(param0) {
  this._0 = param0;
}
_M0DTP411moonbitlang6regexp8internal2vm11Instruction9Assertion.prototype.$tag = 5;
function _M0DTP411moonbitlang6regexp8internal2vm11Instruction13Backreference(param0) {
  this._0 = param0;
}
_M0DTP411moonbitlang6regexp8internal2vm11Instruction13Backreference.prototype.$tag = 6;
function _M0TPB9ArrayViewGcE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0TPB9ArrayViewGUsRPB9ArrayViewGcEEE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0TPB9ArrayViewGUssEE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0TPB9ArrayViewGUccEE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0DTP411moonbitlang6regexp8internal3ast3Ast5Empty() {}
_M0DTP411moonbitlang6regexp8internal3ast3Ast5Empty.prototype.$tag = 0;
const _M0DTP411moonbitlang6regexp8internal3ast3Ast5Empty__ = new _M0DTP411moonbitlang6regexp8internal3ast3Ast5Empty();
function _M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass.prototype.$tag = 1;
function _M0DTP411moonbitlang6regexp8internal3ast3Ast9Assertion(param0) {
  this._0 = param0;
}
_M0DTP411moonbitlang6regexp8internal3ast3Ast9Assertion.prototype.$tag = 2;
function _M0DTP411moonbitlang6regexp8internal3ast3Ast7Capture(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP411moonbitlang6regexp8internal3ast3Ast7Capture.prototype.$tag = 3;
function _M0DTP411moonbitlang6regexp8internal3ast3Ast10ZeroOrMore(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP411moonbitlang6regexp8internal3ast3Ast10ZeroOrMore.prototype.$tag = 4;
function _M0DTP411moonbitlang6regexp8internal3ast3Ast9OneOrMore(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP411moonbitlang6regexp8internal3ast3Ast9OneOrMore.prototype.$tag = 5;
function _M0DTP411moonbitlang6regexp8internal3ast3Ast9ZeroOrOne(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP411moonbitlang6regexp8internal3ast3Ast9ZeroOrOne.prototype.$tag = 6;
function _M0DTP411moonbitlang6regexp8internal3ast3Ast6Repeat(param0, param1, param2, param3) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
  this._3 = param3;
}
_M0DTP411moonbitlang6regexp8internal3ast3Ast6Repeat.prototype.$tag = 7;
function _M0DTP411moonbitlang6regexp8internal3ast3Ast6Concat(param0) {
  this._0 = param0;
}
_M0DTP411moonbitlang6regexp8internal3ast3Ast6Concat.prototype.$tag = 8;
function _M0DTP411moonbitlang6regexp8internal3ast3Ast9Alternate(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP411moonbitlang6regexp8internal3ast3Ast9Alternate.prototype.$tag = 9;
function _M0DTP411moonbitlang6regexp8internal3ast3Ast13Backreference(param0) {
  this._0 = param0;
}
_M0DTP411moonbitlang6regexp8internal3ast3Ast13Backreference.prototype.$tag = 10;
class $PanicError extends Error {}
function $panic() {
  throw new $PanicError();
}
function _M0TPB9ArrayViewGRP219moonbit_2dcommunity4yaml5TokenE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function $bound_check(arr, index) {
  if (index < 0 || index >= arr.length) throw new Error("Index out of bounds");
}
function _M0TPB13StringBuilder(param0) {
  this.val = param0;
}
function _M0TPC16string10StringView(param0, param1, param2) {
  this.str = param0;
  this.start = param1;
  this.end = param2;
}
function $compare_int(a, b) {
  return (a >= b) - (a <= b);
}
const _M0FPB12random__seed = () => {
  if (globalThis.crypto?.getRandomValues) {
    const array = new Uint32Array(1);
    globalThis.crypto.getRandomValues(array);
    return array[0] | 0; // Convert to signed 32
  } else {
    return Math.floor(Math.random() * 0x100000000) | 0; // Fallback to Math.random
  }
};
function _M0TPB6Hasher(param0) {
  this.acc = param0;
}
const _M0FPB19int__to__string__js = (x, radix) => {
  return x.toString(radix);
};
const _M0FPB20uint__to__string__js = (x, radix) => {
  return (x >>> 0).toString(radix);
};
const _M0FPB21int64__to__string__js = (num, radix) => BigInt.asIntN(64, num).toString(radix);
function _M0DTPC16result6ResultGRP311moonbitlang1x4time9PlainDateRPB7FailureE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP311moonbitlang1x4time9PlainDateRPB7FailureE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP311moonbitlang1x4time9PlainDateRPB7FailureE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP311moonbitlang1x4time9PlainDateRPB7FailureE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGuRPB7FailureE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRPB7FailureE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGuRPB7FailureE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRPB7FailureE2Ok.prototype.$tag = 1;
function _M0TPB4IterGUssEE(param0, param1) {
  this.f = param0;
  this.size_hint = param1;
}
function _M0TPB4IterGcE(param0, param1) {
  this.f = param0;
  this.size_hint = param1;
}
function _M0TPB4IterGyE(param0, param1) {
  this.f = param0;
  this.size_hint = param1;
}
function _M0TPB4IterGRPB5ArrayGRPB4JsonEE(param0, param1) {
  this.f = param0;
  this.size_hint = param1;
}
function _M0TPB4IterGiE(param0, param1) {
  this.f = param0;
  this.size_hint = param1;
}
function $unsafe_bytes_sub_string(bytes, byte_offset, byte_length) {
  const end_offset = byte_offset + byte_length;
  let buf = '';
  while (byte_offset < end_offset) {
    buf += String.fromCharCode(bytes[byte_offset] | (bytes[byte_offset + 1] << 8));
    byte_offset += 2;
  }
  return buf;
}
function $makebytes(a, b) {
  const arr = new Uint8Array(a);
  if (b !== 0) {
    arr.fill(b);
  }
  return arr;
}
function _M0TPB8MutLocalGiE(param0) {
  this.val = param0;
}
function _M0TPB4IterGUiiEE(param0, param1) {
  this.f = param0;
  this.size_hint = param1;
}
function _M0TPB4IterGUiRP27gmlewis5flate11LiteralNodeEE(param0, param1) {
  this.f = param0;
  this.size_hint = param1;
}
function _M0TPB4IterGUicEE(param0, param1) {
  this.f = param0;
  this.size_hint = param1;
}
function $make_array_len_and_init(a, b) {
  const arr = new Array(a);
  arr.fill(b);
  return arr;
}
const _M0MPB7JSArray4push = (arr, val) => { arr.push(val); };
function _M0TPB4IterGRPB4JsonE(param0, param1) {
  this.f = param0;
  this.size_hint = param1;
}
function _M0TPB4IterGRPC16string10StringViewE(param0, param1) {
  this.f = param0;
  this.size_hint = param1;
}
function _M0TPB8MutLocalGORPC16string10StringViewE(param0) {
  this.val = param0;
}
function _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None() {}
_M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None.prototype.$tag = 0;
const _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__ = new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None();
function _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some(param0) {
  this._0 = param0;
}
_M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some.prototype.$tag = 1;
function _M0TPB9ArrayViewGsE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0TPB9ArrayViewGiE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0TPB9ArrayViewGRPB5ArrayGRPB4JsonEE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0TPB8MutLocalGbE(param0) {
  this.val = param0;
}
function _M0TPB12MutArrayViewGUssEE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0TPB3MapGssE(param0, param1, param2, param3, param4, param5, param6) {
  this.entries = param0;
  this.size = param1;
  this.capacity = param2;
  this.capacity_mask = param3;
  this.grow_at = param4;
  this.head = param5;
  this.tail = param6;
}
function _M0TPB3MapGsbE(param0, param1, param2, param3, param4, param5, param6) {
  this.entries = param0;
  this.size = param1;
  this.capacity = param2;
  this.capacity_mask = param3;
  this.grow_at = param4;
  this.head = param5;
  this.tail = param6;
}
function _M0TPB3MapGsRPB5ArrayGsEE(param0, param1, param2, param3, param4, param5, param6) {
  this.entries = param0;
  this.size = param1;
  this.capacity = param2;
  this.capacity_mask = param3;
  this.grow_at = param4;
  this.head = param5;
  this.tail = param6;
}
function _M0TPB3MapGsiE(param0, param1, param2, param3, param4, param5, param6) {
  this.entries = param0;
  this.size = param1;
  this.capacity = param2;
  this.capacity_mask = param3;
  this.grow_at = param4;
  this.head = param5;
  this.tail = param6;
}
function _M0TPB3MapGccE(param0, param1, param2, param3, param4, param5, param6) {
  this.entries = param0;
  this.size = param1;
  this.capacity = param2;
  this.capacity_mask = param3;
  this.grow_at = param4;
  this.head = param5;
  this.tail = param6;
}
function _M0TPB5EntryGssE(param0, param1, param2, param3, param4, param5) {
  this.prev = param0;
  this.next = param1;
  this.psl = param2;
  this.hash = param3;
  this.key = param4;
  this.value = param5;
}
function _M0TPB5EntryGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(param0, param1, param2, param3, param4, param5) {
  this.prev = param0;
  this.next = param1;
  this.psl = param2;
  this.hash = param3;
  this.key = param4;
  this.value = param5;
}
function _M0TPB5EntryGsbE(param0, param1, param2, param3, param4, param5) {
  this.prev = param0;
  this.next = param1;
  this.psl = param2;
  this.hash = param3;
  this.key = param4;
  this.value = param5;
}
function _M0TPB5EntryGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(param0, param1, param2, param3, param4, param5) {
  this.prev = param0;
  this.next = param1;
  this.psl = param2;
  this.hash = param3;
  this.key = param4;
  this.value = param5;
}
function _M0TPB5EntryGsRP410Haoxincode8moonbash3lib8commands11AwkFunctionE(param0, param1, param2, param3, param4, param5) {
  this.prev = param0;
  this.next = param1;
  this.psl = param2;
  this.hash = param3;
  this.key = param4;
  this.value = param5;
}
function _M0TPB5EntryGsRPB4JsonE(param0, param1, param2, param3, param4, param5) {
  this.prev = param0;
  this.next = param1;
  this.psl = param2;
  this.hash = param3;
  this.key = param4;
  this.value = param5;
}
function _M0TPB5EntryGsRPB5ArrayGsEE(param0, param1, param2, param3, param4, param5) {
  this.prev = param0;
  this.next = param1;
  this.psl = param2;
  this.hash = param3;
  this.key = param4;
  this.value = param5;
}
function _M0TPB5EntryGsiE(param0, param1, param2, param3, param4, param5) {
  this.prev = param0;
  this.next = param1;
  this.psl = param2;
  this.hash = param3;
  this.key = param4;
  this.value = param5;
}
function _M0TPB5EntryGsRPB5ArrayGRPB4JsonEE(param0, param1, param2, param3, param4, param5) {
  this.prev = param0;
  this.next = param1;
  this.psl = param2;
  this.hash = param3;
  this.key = param4;
  this.value = param5;
}
function _M0TPB5EntryGsURP38bobzhang6moonjq3ast4ExprRPB5ArrayGsEEE(param0, param1, param2, param3, param4, param5) {
  this.prev = param0;
  this.next = param1;
  this.psl = param2;
  this.hash = param3;
  this.key = param4;
  this.value = param5;
}
function _M0TPB5EntryGsRP219moonbit_2dcommunity4yaml4YamlE(param0, param1, param2, param3, param4, param5) {
  this.prev = param0;
  this.next = param1;
  this.psl = param2;
  this.hash = param3;
  this.key = param4;
  this.value = param5;
}
function _M0TPB5EntryGccE(param0, param1, param2, param3, param4, param5) {
  this.prev = param0;
  this.next = param1;
  this.psl = param2;
  this.hash = param3;
  this.key = param4;
  this.value = param5;
}
function _M0TPB5EntryGsRPB9ArrayViewGcEE(param0, param1, param2, param3, param4, param5) {
  this.prev = param0;
  this.next = param1;
  this.psl = param2;
  this.hash = param3;
  this.key = param4;
  this.value = param5;
}
function _M0DTPC16option6OptionGRPB5ArrayGsEE4None() {}
_M0DTPC16option6OptionGRPB5ArrayGsEE4None.prototype.$tag = 0;
const _M0DTPC16option6OptionGRPB5ArrayGsEE4None__ = new _M0DTPC16option6OptionGRPB5ArrayGsEE4None();
function _M0DTPC16option6OptionGRPB5ArrayGsEE4Some(param0) {
  this._0 = param0;
}
_M0DTPC16option6OptionGRPB5ArrayGsEE4Some.prototype.$tag = 1;
function _M0TPB8MutLocalGORPB5EntryGssEE(param0) {
  this.val = param0;
}
function _M0TPB8MutLocalGORPB5EntryGsbEE(param0) {
  this.val = param0;
}
function _M0TPB8MutLocalGORPB5EntryGsRPB5ArrayGRPB4JsonEEE(param0) {
  this.val = param0;
}
function _M0TPB3MapGsRPB4JsonE(param0, param1, param2, param3, param4, param5, param6) {
  this.entries = param0;
  this.size = param1;
  this.capacity = param2;
  this.capacity_mask = param3;
  this.grow_at = param4;
  this.head = param5;
  this.tail = param6;
}
function _M0TPB8MutLocalGORPB4IterGRPB4JsonEE(param0) {
  this.val = param0;
}
const _M0MPB7JSArray4copy = (arr) => arr.slice(0);
const _M0MPC16double6Double8mod__ffi = (a, b) => (a % b);
const $bytes_literal$0 = new Uint8Array();
function _M0TPC15bytes9BytesView(param0, param1, param2) {
  this.bytes = param0;
  this.start = param1;
  this.end = param2;
}
function _M0TPB9ArrayViewGRPB5ArrayGsEE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
const _M0MPB7JSArray11set__length = (arr, len) => { arr.length = len; };
const _M0MPB7JSArray3pop = (arr) => arr.pop();
const _M0MPB7JSArray7splice1 = (arr, idx, cnt, val) => arr.splice(idx, cnt, val);
function _M0TPB9ArrayViewGRPC16string10StringViewE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0DTPC15debug4Repr7UnitLit() {}
_M0DTPC15debug4Repr7UnitLit.prototype.$tag = 0;
function _M0DTPC15debug4Repr7Integer(param0) {
  this._0 = param0;
}
_M0DTPC15debug4Repr7Integer.prototype.$tag = 1;
function _M0DTPC15debug4Repr9DoubleLit(param0) {
  this._0 = param0;
}
_M0DTPC15debug4Repr9DoubleLit.prototype.$tag = 2;
function _M0DTPC15debug4Repr8FloatLit(param0) {
  this._0 = param0;
}
_M0DTPC15debug4Repr8FloatLit.prototype.$tag = 3;
function _M0DTPC15debug4Repr7BoolLit(param0) {
  this._0 = param0;
}
_M0DTPC15debug4Repr7BoolLit.prototype.$tag = 4;
function _M0DTPC15debug4Repr7CharLit(param0) {
  this._0 = param0;
}
_M0DTPC15debug4Repr7CharLit.prototype.$tag = 5;
function _M0DTPC15debug4Repr9StringLit(param0) {
  this._0 = param0;
}
_M0DTPC15debug4Repr9StringLit.prototype.$tag = 6;
function _M0DTPC15debug4Repr5Tuple(param0) {
  this._0 = param0;
}
_M0DTPC15debug4Repr5Tuple.prototype.$tag = 7;
function _M0DTPC15debug4Repr5Array(param0) {
  this._0 = param0;
}
_M0DTPC15debug4Repr5Array.prototype.$tag = 8;
function _M0DTPC15debug4Repr6Record(param0) {
  this._0 = param0;
}
_M0DTPC15debug4Repr6Record.prototype.$tag = 9;
function _M0DTPC15debug4Repr4Enum(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC15debug4Repr4Enum.prototype.$tag = 10;
function _M0DTPC15debug4Repr3Map(param0) {
  this._0 = param0;
}
_M0DTPC15debug4Repr3Map.prototype.$tag = 11;
function _M0DTPC15debug4Repr11RecordField(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC15debug4Repr11RecordField.prototype.$tag = 12;
function _M0DTPC15debug4Repr14EnumLabeledArg(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC15debug4Repr14EnumLabeledArg.prototype.$tag = 13;
function _M0DTPC15debug4Repr6Opaque(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC15debug4Repr6Opaque.prototype.$tag = 14;
function _M0DTPC15debug4Repr7Literal(param0) {
  this._0 = param0;
}
_M0DTPC15debug4Repr7Literal.prototype.$tag = 15;
function _M0DTPC15debug4Repr8MapEntry(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC15debug4Repr8MapEntry.prototype.$tag = 16;
function _M0DTPC15debug4Repr7Omitted() {}
_M0DTPC15debug4Repr7Omitted.prototype.$tag = 17;
const _M0DTPC15debug4Repr7Omitted__ = new _M0DTPC15debug4Repr7Omitted();
function _M0TPC15debug13ContentParens(param0, param1) {
  this.size = param0;
  this.lines = param1;
}
function _M0TPC15debug7Content(param0, param1, param2) {
  this.size = param0;
  this.lines = param1;
  this.needs_parens = param2;
}
function _M0TPC13set3SetGRPC16string10StringViewE(param0, param1, param2, param3, param4, param5, param6) {
  this.entries = param0;
  this.size = param1;
  this.capacity = param2;
  this.capacity_mask = param3;
  this.grow_at = param4;
  this.head = param5;
  this.tail = param6;
}
function _M0TPC13set3SetGiE(param0, param1, param2, param3, param4, param5, param6) {
  this.entries = param0;
  this.size = param1;
  this.capacity = param2;
  this.capacity_mask = param3;
  this.grow_at = param4;
  this.head = param5;
  this.tail = param6;
}
function _M0TPC13set5EntryGRPC16string10StringViewE(param0, param1, param2, param3, param4) {
  this.prev = param0;
  this.next = param1;
  this.psl = param2;
  this.hash = param3;
  this.key = param4;
}
function _M0TPC13set5EntryGiE(param0, param1, param2, param3, param4) {
  this.prev = param0;
  this.next = param1;
  this.psl = param2;
  this.hash = param3;
  this.key = param4;
}
function _M0DTPC16result6ResultGUiRPC16string10StringViewbERPB7FailureE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGUiRPC16string10StringViewbERPB7FailureE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGUiRPC16string10StringViewbERPB7FailureE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGUiRPC16string10StringViewbERPB7FailureE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGiRPB7FailureE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGiRPB7FailureE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGiRPB7FailureE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGiRPB7FailureE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGlRPB7FailureE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGlRPB7FailureE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGlRPB7FailureE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGlRPB7FailureE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGdRPB7FailureE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGdRPB7FailureE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGdRPB7FailureE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGdRPB7FailureE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGORPC28internal7strconv6NumberRPB7FailureE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGORPC28internal7strconv6NumberRPB7FailureE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGORPC28internal7strconv6NumberRPB7FailureE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGORPC28internal7strconv6NumberRPB7FailureE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGORPC28internal7strconv6NumberRPC15error5ErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGORPC28internal7strconv6NumberRPC15error5ErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGORPC28internal7strconv6NumberRPC15error5ErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGORPC28internal7strconv6NumberRPC15error5ErrorE2Ok.prototype.$tag = 1;
function _M0TPC28internal7strconv6Number(param0, param1, param2, param3) {
  this.exponent = param0;
  this.mantissa = param1;
  this.negative = param2;
  this.many_digits = param3;
}
function _M0DTPC16result6ResultGdRPC15error5ErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGdRPC15error5ErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGdRPC15error5ErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGdRPC15error5ErrorE2Ok.prototype.$tag = 1;
function $i64_clz(a) {
  a = BigInt.asUintN(64, a);
  if (a === 0n) return 64;
  const hi = Number(a >> 32n);
  if (hi !== 0) {
    return Math.clz32(hi);
  }
  return 32 + Math.clz32(Number(a & 0xffffffffn));
}
function _M0DTPC16result6ResultGlRPC15error5ErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGlRPC15error5ErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGlRPC15error5ErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGlRPC15error5ErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGiRPC15error5ErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGiRPC15error5ErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGiRPC15error5ErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGiRPC15error5ErrorE2Ok.prototype.$tag = 1;
function _M0TPC28internal7strconv7Decimal(param0, param1, param2, param3, param4) {
  this.digits = param0;
  this.digits_num = param1;
  this.decimal_point = param2;
  this.negative = param3;
  this.truncated = param4;
}
function _M0DTPC16result6ResultGRPC28internal7strconv7DecimalRPC15error5ErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPC28internal7strconv7DecimalRPC15error5ErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRPC28internal7strconv7DecimalRPC15error5ErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPC28internal7strconv7DecimalRPC15error5ErrorE2Ok.prototype.$tag = 1;
function $f64_convert_i64_u(a) {
  return Number(a);
}
function _M0DTPC16option6OptionGdE4None() {}
_M0DTPC16option6OptionGdE4None.prototype.$tag = 0;
const _M0DTPC16option6OptionGdE4None__ = new _M0DTPC16option6OptionGdE4None();
function _M0DTPC16option6OptionGdE4Some(param0) {
  this._0 = param0;
}
_M0DTPC16option6OptionGdE4Some.prototype.$tag = 1;
function _M0TPC17hashmap7HashMapGsiE(param0, param1, param2, param3) {
  this.entries = param0;
  this.capacity = param1;
  this.capacity_mask = param2;
  this.size = param3;
}
function _M0TPC17hashmap7HashMapGssE(param0, param1, param2, param3) {
  this.entries = param0;
  this.capacity = param1;
  this.capacity_mask = param2;
  this.size = param3;
}
function _M0TPC17hashmap5EntryGsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEE(param0, param1, param2, param3) {
  this.psl = param0;
  this.hash = param1;
  this.key = param2;
  this.value = param3;
}
function _M0TPC17hashmap5EntryGsiE(param0, param1, param2, param3) {
  this.psl = param0;
  this.hash = param1;
  this.key = param2;
  this.value = param3;
}
function _M0TPC17hashmap5EntryGssE(param0, param1, param2, param3) {
  this.psl = param0;
  this.hash = param1;
  this.key = param2;
  this.value = param3;
}
function _M0TPC16buffer6Buffer(param0, param1) {
  this.data = param0;
  this.len = param1;
}
function _M0TPC14json8Position(param0, param1) {
  this.line = param0;
  this.column = param1;
}
function _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGuRPC14json10ParseErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRPC14json10ParseErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGuRPC14json10ParseErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRPC14json10ParseErrorE2Ok.prototype.$tag = 1;
function _M0TPC14json12ParseContext(param0, param1, param2, param3) {
  this.offset = param0;
  this.input = param1;
  this.end_offset = param2;
  this.remaining_available_depth = param3;
}
function $f64_convert_i64(a) {
  return Number(BigInt.asIntN(64, a));
}
function _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGiRPC14json10ParseErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGiRPC14json10ParseErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGiRPC14json10ParseErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGiRPC14json10ParseErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGsRPC14json10ParseErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRPC14json10ParseErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGsRPC14json10ParseErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRPC14json10ParseErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok.prototype.$tag = 1;
function _M0DTPC14json5Token4Null() {}
_M0DTPC14json5Token4Null.prototype.$tag = 0;
const _M0DTPC14json5Token4Null__ = new _M0DTPC14json5Token4Null();
function _M0DTPC14json5Token4True() {}
_M0DTPC14json5Token4True.prototype.$tag = 1;
const _M0DTPC14json5Token4True__ = new _M0DTPC14json5Token4True();
function _M0DTPC14json5Token5False() {}
_M0DTPC14json5Token5False.prototype.$tag = 2;
const _M0DTPC14json5Token5False__ = new _M0DTPC14json5Token5False();
function _M0DTPC14json5Token6Number(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC14json5Token6Number.prototype.$tag = 3;
function _M0DTPC14json5Token6String(param0) {
  this._0 = param0;
}
_M0DTPC14json5Token6String.prototype.$tag = 4;
function _M0DTPC14json5Token6LBrace() {}
_M0DTPC14json5Token6LBrace.prototype.$tag = 5;
const _M0DTPC14json5Token6LBrace__ = new _M0DTPC14json5Token6LBrace();
function _M0DTPC14json5Token6RBrace() {}
_M0DTPC14json5Token6RBrace.prototype.$tag = 6;
const _M0DTPC14json5Token6RBrace__ = new _M0DTPC14json5Token6RBrace();
function _M0DTPC14json5Token8LBracket() {}
_M0DTPC14json5Token8LBracket.prototype.$tag = 7;
const _M0DTPC14json5Token8LBracket__ = new _M0DTPC14json5Token8LBracket();
function _M0DTPC14json5Token8RBracket() {}
_M0DTPC14json5Token8RBracket.prototype.$tag = 8;
const _M0DTPC14json5Token8RBracket__ = new _M0DTPC14json5Token8RBracket();
function _M0DTPC14json5Token5Comma() {}
_M0DTPC14json5Token5Comma.prototype.$tag = 9;
const _M0DTPC14json5Token5Comma__ = new _M0DTPC14json5Token5Comma();
function _M0TPB9ArrayViewGUsRPB4JsonEE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0DTPC14json10WriteFrame5Array(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC14json10WriteFrame5Array.prototype.$tag = 0;
function _M0DTPC14json10WriteFrame6Object(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC14json10WriteFrame6Object.prototype.$tag = 1;
function _M0TPC13ref3RefGRPB5ArrayGRPB4JsonEE(param0) {
  this.val = param0;
}
function _M0TPC13ref3RefGiE(param0) {
  this.val = param0;
}
function _M0TPC13ref3RefGbE(param0) {
  this.val = param0;
}
function _M0TPC15deque5DequeGcE(param0, param1, param2) {
  this.buf = param0;
  this.len = param1;
  this.head = param2;
}
function _M0TPC15deque5DequeGRP219moonbit_2dcommunity4yaml5TokenE(param0, param1, param2) {
  this.buf = param0;
  this.len = param1;
  this.head = param2;
}
function _M0DTPC16result6ResultGsRPC28encoding4utf89MalformedE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRPC28encoding4utf89MalformedE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGsRPC28encoding4utf89MalformedE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRPC28encoding4utf89MalformedE2Ok.prototype.$tag = 1;
function _M0TPC111sorted__map4NodeGiRP219moonbit_2dcommunity4yaml4YamlE(param0, param1, param2, param3, param4) {
  this.key = param0;
  this.value = param1;
  this.left = param2;
  this.right = param3;
  this.height = param4;
}
function _M0TPC111sorted__map9SortedMapGiRP219moonbit_2dcommunity4yaml4YamlE(param0, param1) {
  this.root = param0;
  this.size = param1;
}
function _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC17strconv12StrConvErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGUiRPC16string10StringViewbERPC17strconv12StrConvErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC17strconv12StrConvErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGUiRPC16string10StringViewbERPC17strconv12StrConvErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGuRPC17strconv12StrConvErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRPC17strconv12StrConvErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGuRPC17strconv12StrConvErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRPC17strconv12StrConvErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGdRPC17strconv12StrConvErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGdRPC17strconv12StrConvErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGdRPC17strconv12StrConvErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGdRPC17strconv12StrConvErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGiRPC17strconv12StrConvErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGiRPC17strconv12StrConvErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGiRPC17strconv12StrConvErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGiRPC17strconv12StrConvErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGlRPC17strconv12StrConvErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGlRPC17strconv12StrConvErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGlRPC17strconv12StrConvErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGlRPC17strconv12StrConvErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGORPC17strconv6NumberRPC17strconv12StrConvErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGORPC17strconv6NumberRPC17strconv12StrConvErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGORPC17strconv6NumberRPC17strconv12StrConvErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGORPC17strconv6NumberRPC17strconv12StrConvErrorE2Ok.prototype.$tag = 1;
function _M0TPC17strconv7Decimal(param0, param1, param2, param3, param4) {
  this.digits = param0;
  this.digits_num = param1;
  this.decimal_point = param2;
  this.negative = param3;
  this.truncated = param4;
}
function _M0DTPC16result6ResultGRPC17strconv7DecimalRPC17strconv12StrConvErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPC17strconv7DecimalRPC17strconv12StrConvErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRPC17strconv7DecimalRPC17strconv12StrConvErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPC17strconv7DecimalRPC17strconv12StrConvErrorE2Ok.prototype.$tag = 1;
function _M0TPC17strconv6Number(param0, param1, param2, param3) {
  this.exponent = param0;
  this.mantissa = param1;
  this.negative = param2;
  this.many_digits = param3;
}
function _M0TP410Haoxincode8moonbash3lib3ast12ShellOptions(param0, param1, param2, param3, param4, param5, param6) {
  this.errexit = param0;
  this.nounset = param1;
  this.pipefail = param2;
  this.noclobber = param3;
  this.xtrace = param4;
  this.noglob = param5;
  this.allexport = param6;
}
function _M0DTPC16result6ResultGbRPC15error5ErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGbRPC15error5ErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGbRPC15error5ErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGbRPC15error5ErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok.prototype.$tag = 1;
function _M0TPB9ArrayViewGUsRP410Haoxincode8moonbash3lib2fs7FsEntryEE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0DTP410Haoxincode8moonbash3lib2fs7FsEntry4File(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib2fs7FsEntry4File.prototype.$tag = 0;
function _M0DTP410Haoxincode8moonbash3lib2fs7FsEntry9Directory(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib2fs7FsEntry9Directory.prototype.$tag = 1;
function _M0DTP410Haoxincode8moonbash3lib2fs7FsEntry7Symlink(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib2fs7FsEntry7Symlink.prototype.$tag = 2;
function _M0TP410Haoxincode8moonbash3lib2fs7DirData(param0, param1) {
  this.mode = param0;
  this.mtime = param1;
}
function _M0TP410Haoxincode8moonbash3lib2fs10InMemoryFs(param0) {
  this.entries = param0;
}
function _M0TP410Haoxincode8moonbash3lib2fs8FileData(param0, param1, param2) {
  this.content = param0;
  this.mode = param1;
  this.mtime = param2;
}
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib2fs6FsStatRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib2fs6FsStatRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib2fs6FsStatRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib2fs6FsStatRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok.prototype.$tag = 1;
function _M0TP410Haoxincode8moonbash3lib2fs6FsStat(param0, param1, param2, param3, param4, param5) {
  this.is_file = param0;
  this.is_directory = param1;
  this.is_symlink = param2;
  this.size = param3;
  this.mode = param4;
  this.mtime = param5;
}
function _M0DTPC16result6ResultGRPB5ArrayGRP410Haoxincode8moonbash3lib2fs11DirentEntryERP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB5ArrayGRP410Haoxincode8moonbash3lib2fs11DirentEntryERP410Haoxincode8moonbash3lib2fs7FsErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRPB5ArrayGRP410Haoxincode8moonbash3lib2fs11DirentEntryERP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB5ArrayGRP410Haoxincode8moonbash3lib2fs11DirentEntryERP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok.prototype.$tag = 1;
function _M0TP410Haoxincode8moonbash3lib2fs11DirentEntry(param0, param1) {
  this.name = param0;
  this.entry_type = param1;
}
function _M0TP410Haoxincode8moonbash3lib2fs11SymlinkData(param0, param1, param2) {
  this.target = param0;
  this.mode = param1;
  this.mtime = param2;
}
const _M0FP410Haoxincode8moonbash3lib3ffi21host__fetch__sync__js = function(requestJson) {
   try {
     const bridge = globalThis.__moon_bash_fetch;
     if (typeof bridge !== "function") {
       return JSON.stringify({
         ok: false,
         status: 0,
         statusText: "",
         headers: {},
         body: "",
         error: "network fetch bridge is not configured",
       });
     }
     const result = bridge(requestJson);
     if (result && typeof result.then === "function") {
       return JSON.stringify({
         ok: false,
         status: 0,
         statusText: "",
         headers: {},
         body: "",
         error: "async fetch bridge is not supported by sync runtime",
       });
     }
     if (typeof result === "string") {
       return result;
     }
     if (typeof result === "undefined") {
       return JSON.stringify({
         ok: false,
         status: 0,
         statusText: "",
         headers: {},
         body: "",
         error: "fetch bridge returned undefined",
       });
     }
     return JSON.stringify(result);
   } catch (error) {
     const message = error && error.message ? error.message : String(error);
     return JSON.stringify({
       ok: false,
       status: 0,
       statusText: "",
       headers: {},
       body: "",
       error: message,
     });
   }
 };
const _M0FP410Haoxincode8moonbash3lib3ffi21host__sleep__sync__js = function(durationMs) {
   try {
     const bridge = globalThis.__moon_bash_sleep;
     if (typeof bridge !== "function") {
       return "timer sleep bridge is not configured";
     }
     const result = bridge(durationMs);
     if (result && typeof result.then === "function") {
       return "async sleep bridge is not supported by sync runtime";
     }
     if (typeof result === "string") {
       return result;
     }
     if (typeof result === "undefined") {
       return "";
     }
     return "";
   } catch (error) {
     return error && error.message ? error.message : String(error);
   }
 };
const _M0FP410Haoxincode8moonbash3lib3ffi23host__now__ms__sync__js = function() {
   try {
     const bridge = globalThis.__moon_bash_now;
     let value;
     if (typeof bridge === "function") {
       value = bridge();
     } else if (typeof performance !== "undefined" && performance && typeof performance.now === "function") {
       value = performance.now();
     } else if (typeof Date !== "undefined" && typeof Date.now === "function") {
       value = Date.now();
     } else {
       value = 0;
     }
     if (!Number.isFinite(value)) {
       return 0;
     }
     if (value < 0) {
       value = 0;
     }
     return Math.floor(value) % 2147483647;
   } catch (_error) {
     return 0;
   }
 };
const _M0FP410Haoxincode8moonbash3lib3ffi29host__wall__now__ms__sync__js = function() {
   try {
     const bridge = globalThis.__moon_bash_wall_now;
     let value;
     if (typeof bridge === "function") {
       value = bridge();
     } else if (typeof Date !== "undefined" && typeof Date.now === "function") {
       value = Date.now();
     } else {
       value = 0;
     }
     if (!Number.isFinite(value)) {
       return "0";
     }
     return Math.floor(value).toString();
   } catch (_error) {
     return "0";
   }
 };
const _M0FP410Haoxincode8moonbash3lib3ffi18host__vm__sync__js = function(requestJson) {
   try {
     const bridge = globalThis.__moon_bash_vm;
     if (typeof bridge !== "function") {
       return JSON.stringify({
         stdout: "",
         stderr: "",
         exitCode: 127,
         error: "vm bridge is not configured",
       });
     }
     const result = bridge(requestJson);
     if (result && typeof result.then === "function") {
       return JSON.stringify({
         stdout: "",
         stderr: "",
         exitCode: 1,
         error: "async vm bridge is not supported by sync runtime",
       });
     }
     if (typeof result === "string") {
       return result;
     }
     if (typeof result === "undefined") {
       return JSON.stringify({
         stdout: "",
         stderr: "",
         exitCode: 1,
         error: "vm bridge returned undefined",
       });
     }
     return JSON.stringify(result);
   } catch (error) {
     const message = error && error.message ? error.message : String(error);
     return JSON.stringify({
       stdout: "",
       stderr: "",
       exitCode: 1,
       error: message,
     });
   }
 };
const _M0FP410Haoxincode8moonbash3lib3ffi31host__custom__command__sync__js = function(requestJson) {
   try {
     const bridge = globalThis.__moon_bash_custom;
     if (typeof bridge !== "function") {
       return JSON.stringify({
         handled: false,
         stdout: "",
         stderr: "",
         exitCode: 127,
       });
     }
     const result = bridge(requestJson);
     if (result && typeof result.then === "function") {
       return JSON.stringify({
         handled: false,
         stdout: "",
         stderr: "",
         exitCode: 1,
         error: "async custom command bridge is not supported by sync runtime",
       });
     }
     if (typeof result === "string") {
       return result;
     }
     if (typeof result === "undefined") {
       return JSON.stringify({
         handled: false,
         stdout: "",
         stderr: "",
         exitCode: 1,
         error: "custom command bridge returned undefined",
       });
     }
     return JSON.stringify(result);
   } catch (error) {
     const message = error && error.message ? error.message : String(error);
     return JSON.stringify({
       handled: false,
       stdout: "",
       stderr: "",
       exitCode: 1,
       error: message,
     });
   }
 };
function _M0TP410Haoxincode8moonbash3lib6nyacsv3CSV(param0, param1) {
  this.headers = param0;
  this.rows = param1;
}
function _M0TP410Haoxincode8moonbash3lib6nyacsv12StringReader(param0, param1) {
  this.source = param0;
  this.pos = param1;
}
function _M0TP38bobzhang6moonjq3ast3Env(param0, param1) {
  this.bindings = param0;
  this.functions = param1;
}
function _M0TPB9ArrayViewGUsURP38bobzhang6moonjq3ast4ExprRPB5ArrayGsEEEE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0DTPC16result6ResultGzRP38bobzhang6moonjq3ast16InterpreterErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGzRP38bobzhang6moonjq3ast16InterpreterErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGzRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGzRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok.prototype.$tag = 1;
function $compare_float(a, b) {
  return (a >= b) - (a <= b);
}
function _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok.prototype.$tag = 1;
function _M0TPB9ArrayViewGUsRPB5ArrayGRPB4JsonEEE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0DTPC16result6ResultGRPB5ArrayGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB5ArrayGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRPB5ArrayGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB5ArrayGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok.prototype.$tag = 1;
function _M0TPB9ArrayViewGUsbEE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0DTPC16result6ResultGuRP38bobzhang6moonjq3ast16InterpreterErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRP38bobzhang6moonjq3ast16InterpreterErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGuRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok.prototype.$tag = 1;
function _M0TP38bobzhang6moonjq6parser6Parser(param0, param1) {
  this.tokens = param0;
  this.pos = param1;
}
function _M0DTPC16result6ResultGuRP38bobzhang6moonjq6parser10ParseErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRP38bobzhang6moonjq6parser10ParseErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGuRP38bobzhang6moonjq6parser10ParseErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRP38bobzhang6moonjq6parser10ParseErrorE2Ok.prototype.$tag = 1;
function _M0DTP38bobzhang6moonjq6parser5Token7TNumber(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq6parser5Token7TNumber.prototype.$tag = 0;
function _M0DTP38bobzhang6moonjq6parser5Token7TString(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq6parser5Token7TString.prototype.$tag = 1;
function _M0DTP38bobzhang6moonjq6parser5Token20TStringInterpolation(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq6parser5Token20TStringInterpolation.prototype.$tag = 2;
function _M0DTP38bobzhang6moonjq6parser5Token5TTrue() {}
_M0DTP38bobzhang6moonjq6parser5Token5TTrue.prototype.$tag = 3;
const _M0DTP38bobzhang6moonjq6parser5Token5TTrue__ = new _M0DTP38bobzhang6moonjq6parser5Token5TTrue();
function _M0DTP38bobzhang6moonjq6parser5Token6TFalse() {}
_M0DTP38bobzhang6moonjq6parser5Token6TFalse.prototype.$tag = 4;
const _M0DTP38bobzhang6moonjq6parser5Token6TFalse__ = new _M0DTP38bobzhang6moonjq6parser5Token6TFalse();
function _M0DTP38bobzhang6moonjq6parser5Token5TNull() {}
_M0DTP38bobzhang6moonjq6parser5Token5TNull.prototype.$tag = 5;
const _M0DTP38bobzhang6moonjq6parser5Token5TNull__ = new _M0DTP38bobzhang6moonjq6parser5Token5TNull();
function _M0DTP38bobzhang6moonjq6parser5Token11TIdentifier(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq6parser5Token11TIdentifier.prototype.$tag = 6;
function _M0DTP38bobzhang6moonjq6parser5Token9TVariable(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq6parser5Token9TVariable.prototype.$tag = 7;
function _M0DTP38bobzhang6moonjq6parser5Token7TFormat(param0) {
  this._0 = param0;
}
_M0DTP38bobzhang6moonjq6parser5Token7TFormat.prototype.$tag = 8;
function _M0DTP38bobzhang6moonjq6parser5Token4TDot() {}
_M0DTP38bobzhang6moonjq6parser5Token4TDot.prototype.$tag = 9;
const _M0DTP38bobzhang6moonjq6parser5Token4TDot__ = new _M0DTP38bobzhang6moonjq6parser5Token4TDot();
function _M0DTP38bobzhang6moonjq6parser5Token7TDotDot() {}
_M0DTP38bobzhang6moonjq6parser5Token7TDotDot.prototype.$tag = 10;
const _M0DTP38bobzhang6moonjq6parser5Token7TDotDot__ = new _M0DTP38bobzhang6moonjq6parser5Token7TDotDot();
function _M0DTP38bobzhang6moonjq6parser5Token5TPipe() {}
_M0DTP38bobzhang6moonjq6parser5Token5TPipe.prototype.$tag = 11;
const _M0DTP38bobzhang6moonjq6parser5Token5TPipe__ = new _M0DTP38bobzhang6moonjq6parser5Token5TPipe();
function _M0DTP38bobzhang6moonjq6parser5Token6TComma() {}
_M0DTP38bobzhang6moonjq6parser5Token6TComma.prototype.$tag = 12;
const _M0DTP38bobzhang6moonjq6parser5Token6TComma__ = new _M0DTP38bobzhang6moonjq6parser5Token6TComma();
function _M0DTP38bobzhang6moonjq6parser5Token6TColon() {}
_M0DTP38bobzhang6moonjq6parser5Token6TColon.prototype.$tag = 13;
const _M0DTP38bobzhang6moonjq6parser5Token6TColon__ = new _M0DTP38bobzhang6moonjq6parser5Token6TColon();
function _M0DTP38bobzhang6moonjq6parser5Token10TSemicolon() {}
_M0DTP38bobzhang6moonjq6parser5Token10TSemicolon.prototype.$tag = 14;
const _M0DTP38bobzhang6moonjq6parser5Token10TSemicolon__ = new _M0DTP38bobzhang6moonjq6parser5Token10TSemicolon();
function _M0DTP38bobzhang6moonjq6parser5Token9TQuestion() {}
_M0DTP38bobzhang6moonjq6parser5Token9TQuestion.prototype.$tag = 15;
const _M0DTP38bobzhang6moonjq6parser5Token9TQuestion__ = new _M0DTP38bobzhang6moonjq6parser5Token9TQuestion();
function _M0DTP38bobzhang6moonjq6parser5Token7TLParen() {}
_M0DTP38bobzhang6moonjq6parser5Token7TLParen.prototype.$tag = 16;
const _M0DTP38bobzhang6moonjq6parser5Token7TLParen__ = new _M0DTP38bobzhang6moonjq6parser5Token7TLParen();
function _M0DTP38bobzhang6moonjq6parser5Token7TRParen() {}
_M0DTP38bobzhang6moonjq6parser5Token7TRParen.prototype.$tag = 17;
const _M0DTP38bobzhang6moonjq6parser5Token7TRParen__ = new _M0DTP38bobzhang6moonjq6parser5Token7TRParen();
function _M0DTP38bobzhang6moonjq6parser5Token9TLBracket() {}
_M0DTP38bobzhang6moonjq6parser5Token9TLBracket.prototype.$tag = 18;
const _M0DTP38bobzhang6moonjq6parser5Token9TLBracket__ = new _M0DTP38bobzhang6moonjq6parser5Token9TLBracket();
function _M0DTP38bobzhang6moonjq6parser5Token9TRBracket() {}
_M0DTP38bobzhang6moonjq6parser5Token9TRBracket.prototype.$tag = 19;
const _M0DTP38bobzhang6moonjq6parser5Token9TRBracket__ = new _M0DTP38bobzhang6moonjq6parser5Token9TRBracket();
function _M0DTP38bobzhang6moonjq6parser5Token7TLBrace() {}
_M0DTP38bobzhang6moonjq6parser5Token7TLBrace.prototype.$tag = 20;
const _M0DTP38bobzhang6moonjq6parser5Token7TLBrace__ = new _M0DTP38bobzhang6moonjq6parser5Token7TLBrace();
function _M0DTP38bobzhang6moonjq6parser5Token7TRBrace() {}
_M0DTP38bobzhang6moonjq6parser5Token7TRBrace.prototype.$tag = 21;
const _M0DTP38bobzhang6moonjq6parser5Token7TRBrace__ = new _M0DTP38bobzhang6moonjq6parser5Token7TRBrace();
function _M0DTP38bobzhang6moonjq6parser5Token5TPlus() {}
_M0DTP38bobzhang6moonjq6parser5Token5TPlus.prototype.$tag = 22;
const _M0DTP38bobzhang6moonjq6parser5Token5TPlus__ = new _M0DTP38bobzhang6moonjq6parser5Token5TPlus();
function _M0DTP38bobzhang6moonjq6parser5Token6TMinus() {}
_M0DTP38bobzhang6moonjq6parser5Token6TMinus.prototype.$tag = 23;
const _M0DTP38bobzhang6moonjq6parser5Token6TMinus__ = new _M0DTP38bobzhang6moonjq6parser5Token6TMinus();
function _M0DTP38bobzhang6moonjq6parser5Token5TStar() {}
_M0DTP38bobzhang6moonjq6parser5Token5TStar.prototype.$tag = 24;
const _M0DTP38bobzhang6moonjq6parser5Token5TStar__ = new _M0DTP38bobzhang6moonjq6parser5Token5TStar();
function _M0DTP38bobzhang6moonjq6parser5Token6TSlash() {}
_M0DTP38bobzhang6moonjq6parser5Token6TSlash.prototype.$tag = 25;
const _M0DTP38bobzhang6moonjq6parser5Token6TSlash__ = new _M0DTP38bobzhang6moonjq6parser5Token6TSlash();
function _M0DTP38bobzhang6moonjq6parser5Token8TPercent() {}
_M0DTP38bobzhang6moonjq6parser5Token8TPercent.prototype.$tag = 26;
const _M0DTP38bobzhang6moonjq6parser5Token8TPercent__ = new _M0DTP38bobzhang6moonjq6parser5Token8TPercent();
function _M0DTP38bobzhang6moonjq6parser5Token3TEq() {}
_M0DTP38bobzhang6moonjq6parser5Token3TEq.prototype.$tag = 27;
const _M0DTP38bobzhang6moonjq6parser5Token3TEq__ = new _M0DTP38bobzhang6moonjq6parser5Token3TEq();
function _M0DTP38bobzhang6moonjq6parser5Token4TNeq() {}
_M0DTP38bobzhang6moonjq6parser5Token4TNeq.prototype.$tag = 28;
const _M0DTP38bobzhang6moonjq6parser5Token4TNeq__ = new _M0DTP38bobzhang6moonjq6parser5Token4TNeq();
function _M0DTP38bobzhang6moonjq6parser5Token3TLt() {}
_M0DTP38bobzhang6moonjq6parser5Token3TLt.prototype.$tag = 29;
const _M0DTP38bobzhang6moonjq6parser5Token3TLt__ = new _M0DTP38bobzhang6moonjq6parser5Token3TLt();
function _M0DTP38bobzhang6moonjq6parser5Token3TLe() {}
_M0DTP38bobzhang6moonjq6parser5Token3TLe.prototype.$tag = 30;
const _M0DTP38bobzhang6moonjq6parser5Token3TLe__ = new _M0DTP38bobzhang6moonjq6parser5Token3TLe();
function _M0DTP38bobzhang6moonjq6parser5Token3TGt() {}
_M0DTP38bobzhang6moonjq6parser5Token3TGt.prototype.$tag = 31;
const _M0DTP38bobzhang6moonjq6parser5Token3TGt__ = new _M0DTP38bobzhang6moonjq6parser5Token3TGt();
function _M0DTP38bobzhang6moonjq6parser5Token3TGe() {}
_M0DTP38bobzhang6moonjq6parser5Token3TGe.prototype.$tag = 32;
const _M0DTP38bobzhang6moonjq6parser5Token3TGe__ = new _M0DTP38bobzhang6moonjq6parser5Token3TGe();
function _M0DTP38bobzhang6moonjq6parser5Token7TAssign() {}
_M0DTP38bobzhang6moonjq6parser5Token7TAssign.prototype.$tag = 33;
const _M0DTP38bobzhang6moonjq6parser5Token7TAssign__ = new _M0DTP38bobzhang6moonjq6parser5Token7TAssign();
function _M0DTP38bobzhang6moonjq6parser5Token7TUpdate() {}
_M0DTP38bobzhang6moonjq6parser5Token7TUpdate.prototype.$tag = 34;
const _M0DTP38bobzhang6moonjq6parser5Token7TUpdate__ = new _M0DTP38bobzhang6moonjq6parser5Token7TUpdate();
function _M0DTP38bobzhang6moonjq6parser5Token12TAlternative() {}
_M0DTP38bobzhang6moonjq6parser5Token12TAlternative.prototype.$tag = 35;
const _M0DTP38bobzhang6moonjq6parser5Token12TAlternative__ = new _M0DTP38bobzhang6moonjq6parser5Token12TAlternative();
function _M0DTP38bobzhang6moonjq6parser5Token10TAddAssign() {}
_M0DTP38bobzhang6moonjq6parser5Token10TAddAssign.prototype.$tag = 36;
const _M0DTP38bobzhang6moonjq6parser5Token10TAddAssign__ = new _M0DTP38bobzhang6moonjq6parser5Token10TAddAssign();
function _M0DTP38bobzhang6moonjq6parser5Token10TSubAssign() {}
_M0DTP38bobzhang6moonjq6parser5Token10TSubAssign.prototype.$tag = 37;
const _M0DTP38bobzhang6moonjq6parser5Token10TSubAssign__ = new _M0DTP38bobzhang6moonjq6parser5Token10TSubAssign();
function _M0DTP38bobzhang6moonjq6parser5Token10TMulAssign() {}
_M0DTP38bobzhang6moonjq6parser5Token10TMulAssign.prototype.$tag = 38;
const _M0DTP38bobzhang6moonjq6parser5Token10TMulAssign__ = new _M0DTP38bobzhang6moonjq6parser5Token10TMulAssign();
function _M0DTP38bobzhang6moonjq6parser5Token10TDivAssign() {}
_M0DTP38bobzhang6moonjq6parser5Token10TDivAssign.prototype.$tag = 39;
const _M0DTP38bobzhang6moonjq6parser5Token10TDivAssign__ = new _M0DTP38bobzhang6moonjq6parser5Token10TDivAssign();
function _M0DTP38bobzhang6moonjq6parser5Token10TModAssign() {}
_M0DTP38bobzhang6moonjq6parser5Token10TModAssign.prototype.$tag = 40;
const _M0DTP38bobzhang6moonjq6parser5Token10TModAssign__ = new _M0DTP38bobzhang6moonjq6parser5Token10TModAssign();
function _M0DTP38bobzhang6moonjq6parser5Token10TAltAssign() {}
_M0DTP38bobzhang6moonjq6parser5Token10TAltAssign.prototype.$tag = 41;
const _M0DTP38bobzhang6moonjq6parser5Token10TAltAssign__ = new _M0DTP38bobzhang6moonjq6parser5Token10TAltAssign();
function _M0DTP38bobzhang6moonjq6parser5Token4TAnd() {}
_M0DTP38bobzhang6moonjq6parser5Token4TAnd.prototype.$tag = 42;
const _M0DTP38bobzhang6moonjq6parser5Token4TAnd__ = new _M0DTP38bobzhang6moonjq6parser5Token4TAnd();
function _M0DTP38bobzhang6moonjq6parser5Token3TOr() {}
_M0DTP38bobzhang6moonjq6parser5Token3TOr.prototype.$tag = 43;
const _M0DTP38bobzhang6moonjq6parser5Token3TOr__ = new _M0DTP38bobzhang6moonjq6parser5Token3TOr();
function _M0DTP38bobzhang6moonjq6parser5Token4TNot() {}
_M0DTP38bobzhang6moonjq6parser5Token4TNot.prototype.$tag = 44;
const _M0DTP38bobzhang6moonjq6parser5Token4TNot__ = new _M0DTP38bobzhang6moonjq6parser5Token4TNot();
function _M0DTP38bobzhang6moonjq6parser5Token3TIf() {}
_M0DTP38bobzhang6moonjq6parser5Token3TIf.prototype.$tag = 45;
const _M0DTP38bobzhang6moonjq6parser5Token3TIf__ = new _M0DTP38bobzhang6moonjq6parser5Token3TIf();
function _M0DTP38bobzhang6moonjq6parser5Token5TThen() {}
_M0DTP38bobzhang6moonjq6parser5Token5TThen.prototype.$tag = 46;
const _M0DTP38bobzhang6moonjq6parser5Token5TThen__ = new _M0DTP38bobzhang6moonjq6parser5Token5TThen();
function _M0DTP38bobzhang6moonjq6parser5Token5TElse() {}
_M0DTP38bobzhang6moonjq6parser5Token5TElse.prototype.$tag = 47;
const _M0DTP38bobzhang6moonjq6parser5Token5TElse__ = new _M0DTP38bobzhang6moonjq6parser5Token5TElse();
function _M0DTP38bobzhang6moonjq6parser5Token5TElif() {}
_M0DTP38bobzhang6moonjq6parser5Token5TElif.prototype.$tag = 48;
const _M0DTP38bobzhang6moonjq6parser5Token5TElif__ = new _M0DTP38bobzhang6moonjq6parser5Token5TElif();
function _M0DTP38bobzhang6moonjq6parser5Token4TEnd() {}
_M0DTP38bobzhang6moonjq6parser5Token4TEnd.prototype.$tag = 49;
const _M0DTP38bobzhang6moonjq6parser5Token4TEnd__ = new _M0DTP38bobzhang6moonjq6parser5Token4TEnd();
function _M0DTP38bobzhang6moonjq6parser5Token3TAs() {}
_M0DTP38bobzhang6moonjq6parser5Token3TAs.prototype.$tag = 50;
const _M0DTP38bobzhang6moonjq6parser5Token3TAs__ = new _M0DTP38bobzhang6moonjq6parser5Token3TAs();
function _M0DTP38bobzhang6moonjq6parser5Token7TReduce() {}
_M0DTP38bobzhang6moonjq6parser5Token7TReduce.prototype.$tag = 51;
const _M0DTP38bobzhang6moonjq6parser5Token7TReduce__ = new _M0DTP38bobzhang6moonjq6parser5Token7TReduce();
function _M0DTP38bobzhang6moonjq6parser5Token8TForeach() {}
_M0DTP38bobzhang6moonjq6parser5Token8TForeach.prototype.$tag = 52;
const _M0DTP38bobzhang6moonjq6parser5Token8TForeach__ = new _M0DTP38bobzhang6moonjq6parser5Token8TForeach();
function _M0DTP38bobzhang6moonjq6parser5Token4TTry() {}
_M0DTP38bobzhang6moonjq6parser5Token4TTry.prototype.$tag = 53;
const _M0DTP38bobzhang6moonjq6parser5Token4TTry__ = new _M0DTP38bobzhang6moonjq6parser5Token4TTry();
function _M0DTP38bobzhang6moonjq6parser5Token6TCatch() {}
_M0DTP38bobzhang6moonjq6parser5Token6TCatch.prototype.$tag = 54;
const _M0DTP38bobzhang6moonjq6parser5Token6TCatch__ = new _M0DTP38bobzhang6moonjq6parser5Token6TCatch();
function _M0DTP38bobzhang6moonjq6parser5Token4TDef() {}
_M0DTP38bobzhang6moonjq6parser5Token4TDef.prototype.$tag = 55;
const _M0DTP38bobzhang6moonjq6parser5Token4TDef__ = new _M0DTP38bobzhang6moonjq6parser5Token4TDef();
function _M0DTP38bobzhang6moonjq6parser5Token4TEof() {}
_M0DTP38bobzhang6moonjq6parser5Token4TEof.prototype.$tag = 56;
const _M0DTP38bobzhang6moonjq6parser5Token4TEof__ = new _M0DTP38bobzhang6moonjq6parser5Token4TEof();
function _M0DTPC16result6ResultGuRP38bobzhang6moonjq6parser8LexErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRP38bobzhang6moonjq6parser8LexErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGuRP38bobzhang6moonjq6parser8LexErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRP38bobzhang6moonjq6parser8LexErrorE2Ok.prototype.$tag = 1;
function _M0TP38bobzhang6moonjq6parser5Lexer(param0, param1, param2) {
  this.input = param0;
  this.pos = param1;
  this.tokens = param2;
}
function _M0DTPC16result6ResultGRPB5ArrayGRP38bobzhang6moonjq6parser5TokenERP38bobzhang6moonjq6parser8LexErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB5ArrayGRP38bobzhang6moonjq6parser5TokenERP38bobzhang6moonjq6parser8LexErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRPB5ArrayGRP38bobzhang6moonjq6parser5TokenERP38bobzhang6moonjq6parser8LexErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB5ArrayGRP38bobzhang6moonjq6parser5TokenERP38bobzhang6moonjq6parser8LexErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGOiRP38bobzhang6moonjq6parser10ParseErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGOiRP38bobzhang6moonjq6parser10ParseErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGOiRP38bobzhang6moonjq6parser10ParseErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGOiRP38bobzhang6moonjq6parser10ParseErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGRP28bobzhang6moonjq5QueryRPC15error5ErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP28bobzhang6moonjq5QueryRPC15error5ErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP28bobzhang6moonjq5QueryRPC15error5ErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP28bobzhang6moonjq5QueryRPC15error5ErrorE2Ok.prototype.$tag = 1;
function _M0TP28bobzhang6moonjq5Query(param0) {
  this.expr = param0;
}
function _M0DTPC16result6ResultGRPB5ArrayGRPB4JsonERPC15error5ErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB5ArrayGRPB4JsonERPC15error5ErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRPB5ArrayGRPB4JsonERPC15error5ErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB5ArrayGRPB4JsonERPC15error5ErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGUiiERP27gmlewis6base6417CorruptInputErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGUiiERP27gmlewis6base6417CorruptInputErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGUiiERP27gmlewis6base6417CorruptInputErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGUiiERP27gmlewis6base6417CorruptInputErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGiRP27gmlewis6base6417CorruptInputErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGiRP27gmlewis6base6417CorruptInputErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGiRP27gmlewis6base6417CorruptInputErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGiRP27gmlewis6base6417CorruptInputErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGzRP27gmlewis6base6417CorruptInputErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGzRP27gmlewis6base6417CorruptInputErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGzRP27gmlewis6base6417CorruptInputErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGzRP27gmlewis6base6417CorruptInputErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGsRP27gmlewis6base6417CorruptInputErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRP27gmlewis6base6417CorruptInputErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGsRP27gmlewis6base6417CorruptInputErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRP27gmlewis6base6417CorruptInputErrorE2Ok.prototype.$tag = 1;
function _M0TP27gmlewis2io5SliceGyE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.len = param2;
}
function _M0TP27gmlewis2io5SliceGjE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.len = param2;
}
function _M0TP27gmlewis2io5SliceGiE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.len = param2;
}
function _M0TP27gmlewis2io5SliceGRP27gmlewis5flate11LiteralNodeE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.len = param2;
}
function _M0TP27gmlewis2io6Buffer(param0, param1) {
  this.b = param0;
  this.off = param1;
}
function _M0TP27gmlewis5flate11DeflateFast(param0, param1, param2) {
  this.table = param0;
  this.prev = param1;
  this.cur = param2;
}
function _M0TP27gmlewis5flate10TableEntry(param0, param1) {
  this.val = param0;
  this.offset = param1;
}
function _M0TP27gmlewis5flate16HuffmanBitWriter(param0, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10, param11, param12) {
  this.writer = param0;
  this.bits = param1;
  this.nbits = param2;
  this.bytes = param3;
  this.codegen_freq = param4;
  this.nbytes = param5;
  this.literal_freq = param6;
  this.offset_freq = param7;
  this.codegen = param8;
  this.literal_encoding = param9;
  this.offset_encoding = param10;
  this.codegen_encoding = param11;
  this.err = param12;
}
function _M0TP27gmlewis5flate10Compressor(param0, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10) {
  this.w = param0;
  this.best_speed = param1;
  this.hash_head = param2;
  this.hash_prev = param3;
  this.hash_offset = param4;
  this.window = param5;
  this.window_end = param6;
  this.sync = param7;
  this.tokens = param8;
  this.err = param9;
  this.hash_match = param10;
}
function _M0TP27gmlewis5flate6Writer(param0) {
  this.d = param0;
}
function _M0TPB8MutLocalGRPB5ArrayGRP27gmlewis5flate5TokenEE(param0) {
  this.val = param0;
}
function _M0TP27gmlewis5flate9LevelInfo(param0, param1, param2, param3, param4) {
  this.level = param0;
  this.last_freq = param1;
  this.next_char_freq = param2;
  this.next_pair_freq = param3;
  this.needed = param4;
}
function _M0TP27gmlewis5flate11DictDecoder(param0, param1, param2, param3) {
  this.hist = param0;
  this.wr_pos = param1;
  this.rd_pos = param2;
  this.full = param3;
}
function _M0TP27gmlewis5flate12Decompressor(param0, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10, param11, param12, param13, param14, param15, param16, param17, param18) {
  this.r = param0;
  this.roffset = param1;
  this.b = param2;
  this.nb = param3;
  this.h1 = param4;
  this.h2 = param5;
  this.bits = param6;
  this.codebits = param7;
  this.dict = param8;
  this.buf = param9;
  this.step = param10;
  this.step_state = param11;
  this.final_flag = param12;
  this.err = param13;
  this.to_read = param14;
  this.hl = param15;
  this.hd = param16;
  this.copy_len = param17;
  this.copy_dist = param18;
}
function _M0TP27gmlewis5crc326Digest(param0, param1) {
  this.crc = param0;
  this.name = param1;
}
function _M0TP311moonbitlang1x4time13ZonedDateTime(param0, param1, param2) {
  this.datetime = param0;
  this.zone = param1;
  this.offset = param2;
}
function _M0DTPC16result6ResultGRP311moonbitlang1x4time9PlainDateRPC15error5ErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP311moonbitlang1x4time9PlainDateRPC15error5ErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP311moonbitlang1x4time9PlainDateRPC15error5ErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP311moonbitlang1x4time9PlainDateRPC15error5ErrorE2Ok.prototype.$tag = 1;
function _M0TP311moonbitlang1x4time9PlainDate(param0, param1, param2) {
  this.year = param0;
  this.month = param1;
  this.day = param2;
}
function _M0DTPC16result6ResultGRP311moonbitlang1x4time9PlainTimeRPC15error5ErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP311moonbitlang1x4time9PlainTimeRPC15error5ErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP311moonbitlang1x4time9PlainTimeRPC15error5ErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP311moonbitlang1x4time9PlainTimeRPC15error5ErrorE2Ok.prototype.$tag = 1;
function _M0TP311moonbitlang1x4time9PlainTime(param0, param1, param2, param3) {
  this.hour = param0;
  this.minute = param1;
  this.second = param2;
  this.nanosecond = param3;
}
function _M0DTPC16result6ResultGRP311moonbitlang1x4time13PlainDateTimeRPC15error5ErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP311moonbitlang1x4time13PlainDateTimeRPC15error5ErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP311moonbitlang1x4time13PlainDateTimeRPC15error5ErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP311moonbitlang1x4time13PlainDateTimeRPC15error5ErrorE2Ok.prototype.$tag = 1;
function _M0TP311moonbitlang1x4time13PlainDateTime(param0, param1) {
  this.date = param0;
  this.time = param1;
}
function $i64_trunc_f64(a) {
  if (Number.isNaN(a)) return 0n;
  if (a >= 9223372036854775807) return 9223372036854775807n;
  if (a <= -9223372036854775808) return 9223372036854775808n;
  return BigInt.asUintN(64, BigInt(Math.trunc(a)));
}
function _M0DTPC16result6ResultGRP311moonbitlang1x4time13ZonedDateTimeRPC15error5ErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP311moonbitlang1x4time13ZonedDateTimeRPC15error5ErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP311moonbitlang1x4time13ZonedDateTimeRPC15error5ErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP311moonbitlang1x4time13ZonedDateTimeRPC15error5ErrorE2Ok.prototype.$tag = 1;
function _M0TP27gmlewis4gzip6Header(param0, param1, param2, param3, param4) {
  this.comment = param0;
  this.extra = param1;
  this.mod_time = param2;
  this.name = param3;
  this.os = param4;
}
function _M0TP27gmlewis4gzip6Writer(param0, param1, param2, param3, param4, param5, param6, param7, param8, param9) {
  this.header = param0;
  this.w = param1;
  this.level = param2;
  this.wrote_header = param3;
  this.closed = param4;
  this.buf = param5;
  this.compressor = param6;
  this.digest = param7;
  this.size = param8;
  this.err = param9;
}
function _M0TP27gmlewis4gzip6Reader(param0, param1, param2, param3, param4, param5, param6, param7) {
  this.header = param0;
  this.r = param1;
  this.decompressor = param2;
  this.digest = param3;
  this.size = param4;
  this.buf = param5;
  this.err = param6;
  this.multistream = param7;
}
function _M0TP27gmlewis3md56Digest(param0, param1, param2, param3, param4) {
  this.s = param0;
  this.x = param1;
  this.nx = param2;
  this.len = param3;
  this.name = param4;
}
function _M0TPB9ArrayViewGjE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0TP27gmlewis4sha16Digest(param0, param1, param2, param3) {
  this.h = param0;
  this.x = param1;
  this.nx = param2;
  this.len = param3;
}
function _M0TP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsE(param0, param1, param2, param3) {
  this.old_idx = param0;
  this.old_count = param1;
  this.new_idx = param2;
  this.new_count = param3;
}
function _M0TP219moonbit_2dcommunity7piediff5StackGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE(param0, param1) {
  this.top = param0;
  this.stack = param1;
}
function _M0DTPC14list4ListGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE5Empty() {}
_M0DTPC14list4ListGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE5Empty.prototype.$tag = 0;
const _M0DTPC14list4ListGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE5Empty__ = new _M0DTPC14list4ListGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE5Empty();
function _M0DTPC14list4ListGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE4More(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC14list4ListGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE4More.prototype.$tag = 1;
function _M0TP219moonbit_2dcommunity7piediff11BackPointerGUiiEE(param0, param1) {
  this.value = param0;
  this.prev = param1;
}
function _M0TPB9ArrayViewGUiiEE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0DTP219moonbit_2dcommunity7piediff4Edit6Delete(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP219moonbit_2dcommunity7piediff4Edit6Delete.prototype.$tag = 0;
function _M0DTP219moonbit_2dcommunity7piediff4Edit6Insert(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP219moonbit_2dcommunity7piediff4Edit6Insert.prototype.$tag = 1;
function _M0DTP219moonbit_2dcommunity7piediff4Edit5Equal(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP219moonbit_2dcommunity7piediff4Edit5Equal.prototype.$tag = 2;
function _M0TP219moonbit_2dcommunity7piediff4HunkGsE(param0, param1, param2) {
  this.edits = param0;
  this.old = param1;
  this.new = param2;
}
function _M0TPB9ArrayViewGRP219moonbit_2dcommunity7piediff4EditE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0TP219moonbit_2dcommunity7piediff9Partition(param0, param1, param2, param3) {
  this.lhs_midpoint = param0;
  this.rhs_midpoint = param1;
  this.lo_minimal = param2;
  this.hi_minimal = param3;
}
function _M0TP219moonbit_2dcommunity7piediff4DiffGsE(param0, param1, param2) {
  this.old = param0;
  this.new = param1;
  this.edits = param2;
}
function _M0TP219moonbit_2dcommunity4yaml9SimpleKey(param0, param1, param2, param3) {
  this.possible = param0;
  this.required = param1;
  this.token_number = param2;
  this.mark = param3;
}
function _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok.prototype.$tag = 1;
function _M0TP219moonbit_2dcommunity4yaml5Token(param0, param1) {
  this.marker = param0;
  this.token_type = param1;
}
function _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok.prototype.$tag = 1;
function _M0TP219moonbit_2dcommunity4yaml6Indent(param0, param1) {
  this.indent = param0;
  this.needs_block_end = param1;
}
function _M0DTP219moonbit_2dcommunity4yaml8SkipTabs3Yes() {}
_M0DTP219moonbit_2dcommunity4yaml8SkipTabs3Yes.prototype.$tag = 0;
const _M0DTP219moonbit_2dcommunity4yaml8SkipTabs3Yes__ = new _M0DTP219moonbit_2dcommunity4yaml8SkipTabs3Yes();
function _M0DTP219moonbit_2dcommunity4yaml8SkipTabs2No() {}
_M0DTP219moonbit_2dcommunity4yaml8SkipTabs2No.prototype.$tag = 1;
const _M0DTP219moonbit_2dcommunity4yaml8SkipTabs2No__ = new _M0DTP219moonbit_2dcommunity4yaml8SkipTabs2No();
function _M0DTP219moonbit_2dcommunity4yaml8SkipTabs6Result(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP219moonbit_2dcommunity4yaml8SkipTabs6Result.prototype.$tag = 2;
function _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml8SkipTabsRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml8SkipTabsRP219moonbit_2dcommunity4yaml9YamlErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml8SkipTabsRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml8SkipTabsRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGsRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRP219moonbit_2dcommunity4yaml9YamlErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGsRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGcRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGcRP219moonbit_2dcommunity4yaml9YamlErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGcRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGcRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGiRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGiRP219moonbit_2dcommunity4yaml9YamlErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGiRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGiRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGORP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGORP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGORP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGORP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml3TagRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml3TagRP219moonbit_2dcommunity4yaml9YamlErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml3TagRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml3TagRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok.prototype.$tag = 1;
function _M0TP219moonbit_2dcommunity4yaml3Tag(param0, param1) {
  this.handle = param0;
  this.suffix = param1;
}
function _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok.prototype.$tag = 1;
function _M0DTP219moonbit_2dcommunity4yaml5Event11StreamStart() {}
_M0DTP219moonbit_2dcommunity4yaml5Event11StreamStart.prototype.$tag = 0;
const _M0DTP219moonbit_2dcommunity4yaml5Event11StreamStart__ = new _M0DTP219moonbit_2dcommunity4yaml5Event11StreamStart();
function _M0DTP219moonbit_2dcommunity4yaml5Event9StreamEnd() {}
_M0DTP219moonbit_2dcommunity4yaml5Event9StreamEnd.prototype.$tag = 1;
const _M0DTP219moonbit_2dcommunity4yaml5Event9StreamEnd__ = new _M0DTP219moonbit_2dcommunity4yaml5Event9StreamEnd();
function _M0DTP219moonbit_2dcommunity4yaml5Event13DocumentStart() {}
_M0DTP219moonbit_2dcommunity4yaml5Event13DocumentStart.prototype.$tag = 2;
const _M0DTP219moonbit_2dcommunity4yaml5Event13DocumentStart__ = new _M0DTP219moonbit_2dcommunity4yaml5Event13DocumentStart();
function _M0DTP219moonbit_2dcommunity4yaml5Event11DocumentEnd() {}
_M0DTP219moonbit_2dcommunity4yaml5Event11DocumentEnd.prototype.$tag = 3;
const _M0DTP219moonbit_2dcommunity4yaml5Event11DocumentEnd__ = new _M0DTP219moonbit_2dcommunity4yaml5Event11DocumentEnd();
function _M0DTP219moonbit_2dcommunity4yaml5Event5Alias(param0) {
  this._0 = param0;
}
_M0DTP219moonbit_2dcommunity4yaml5Event5Alias.prototype.$tag = 4;
function _M0DTP219moonbit_2dcommunity4yaml5Event6Scalar(param0, param1, param2, param3) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
  this._3 = param3;
}
_M0DTP219moonbit_2dcommunity4yaml5Event6Scalar.prototype.$tag = 5;
function _M0DTP219moonbit_2dcommunity4yaml5Event13SequenceStart(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP219moonbit_2dcommunity4yaml5Event13SequenceStart.prototype.$tag = 6;
function _M0DTP219moonbit_2dcommunity4yaml5Event11SequenceEnd() {}
_M0DTP219moonbit_2dcommunity4yaml5Event11SequenceEnd.prototype.$tag = 7;
const _M0DTP219moonbit_2dcommunity4yaml5Event11SequenceEnd__ = new _M0DTP219moonbit_2dcommunity4yaml5Event11SequenceEnd();
function _M0DTP219moonbit_2dcommunity4yaml5Event12MappingStart(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP219moonbit_2dcommunity4yaml5Event12MappingStart.prototype.$tag = 8;
function _M0DTP219moonbit_2dcommunity4yaml5Event10MappingEnd() {}
_M0DTP219moonbit_2dcommunity4yaml5Event10MappingEnd.prototype.$tag = 9;
const _M0DTP219moonbit_2dcommunity4yaml5Event10MappingEnd__ = new _M0DTP219moonbit_2dcommunity4yaml5Event10MappingEnd();
function _M0TP219moonbit_2dcommunity4yaml10YamlLoader(param0, param1, param2, param3, param4) {
  this.docs = param0;
  this.doc_stack = param1;
  this.key_stack = param2;
  this.anchor_map = param3;
  this.error = param4;
}
function _M0DTPC16result6ResultGRPB5ArrayGRP219moonbit_2dcommunity4yaml4YamlERP219moonbit_2dcommunity4yaml9YamlErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB5ArrayGRP219moonbit_2dcommunity4yaml4YamlERP219moonbit_2dcommunity4yaml9YamlErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRPB5ArrayGRP219moonbit_2dcommunity4yaml4YamlERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB5ArrayGRP219moonbit_2dcommunity4yaml4YamlERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok.prototype.$tag = 1;
function _M0TP219moonbit_2dcommunity4yaml5Lexer(param0, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10, param11, param12, param13, param14, param15, param16, param17, param18, param19) {
  this.input = param0;
  this.index = param1;
  this.line = param2;
  this.col = param3;
  this.tokens = param4;
  this.buffer = param5;
  this.error = param6;
  this.stream_start_produced = param7;
  this.stream_end_produced = param8;
  this.adjacent_value_allowed_at = param9;
  this.simple_key_allowed = param10;
  this.simple_keys = param11;
  this.indent = param12;
  this.indents = param13;
  this.flow_level = param14;
  this.tokens_parsed = param15;
  this.token_available = param16;
  this.leading_whitespace = param17;
  this.flow_mapping_started = param18;
  this.implicit_flow_mapping = param19;
}
function _M0TP219moonbit_2dcommunity4yaml6Parser(param0, param1, param2, param3, param4, param5, param6, param7, param8) {
  this.lexer = param0;
  this.states = param1;
  this.state = param2;
  this.token = param3;
  this.current = param4;
  this.anchors = param5;
  this.anchor_id = param6;
  this.tags = param7;
  this.keep_tags = param8;
}
function _M0TPB9ArrayViewGUsRP219moonbit_2dcommunity4yaml4YamlEE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0TPB9ArrayViewGUsRPB5ArrayGsEEE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0DTPC16result6ResultGRP218peter_2djerry_2dye11parse__args4ArgsRP218peter_2djerry_2dye11parse__args10ParseErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP218peter_2djerry_2dye11parse__args4ArgsRP218peter_2djerry_2dye11parse__args10ParseErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP218peter_2djerry_2dye11parse__args4ArgsRP218peter_2djerry_2dye11parse__args10ParseErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP218peter_2djerry_2dye11parse__args4ArgsRP218peter_2djerry_2dye11parse__args10ParseErrorE2Ok.prototype.$tag = 1;
function _M0TP218peter_2djerry_2dye11parse__args4Args(param0, param1, param2, param3) {
  this.positional = param0;
  this.flags = param1;
  this.options = param2;
  this.collections = param3;
}
function _M0DTPC16option6OptionGRPB5ArrayGcEE4None() {}
_M0DTPC16option6OptionGRPB5ArrayGcEE4None.prototype.$tag = 0;
const _M0DTPC16option6OptionGRPB5ArrayGcEE4None__ = new _M0DTPC16option6OptionGRPB5ArrayGcEE4None();
function _M0DTPC16option6OptionGRPB5ArrayGcEE4Some(param0) {
  this._0 = param0;
}
_M0DTPC16option6OptionGRPB5ArrayGcEE4Some.prototype.$tag = 1;
function _M0DTPC16result6ResultGsRP310tonyfettes7unicode8punycode13PunycodeErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRP310tonyfettes7unicode8punycode13PunycodeErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGsRP310tonyfettes7unicode8punycode13PunycodeErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRP310tonyfettes7unicode8punycode13PunycodeErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGsRP310tonyfettes7unicode4idna9IdnaErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRP310tonyfettes7unicode4idna9IdnaErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGsRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRP310tonyfettes7unicode4idna9IdnaErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGUssERP310tonyfettes7unicode4idna9IdnaErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGUssERP310tonyfettes7unicode4idna9IdnaErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGUssERP310tonyfettes7unicode4idna9IdnaErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGUssERP310tonyfettes7unicode4idna9IdnaErrorE2Ok.prototype.$tag = 1;
function _M0TP210tonyfettes3url3Url(param0, param1, param2, param3, param4, param5, param6, param7) {
  this.scheme = param0;
  this.username = param1;
  this.password = param2;
  this.host = param3;
  this.port = param4;
  this.path = param5;
  this.query = param6;
  this.fragment = param7;
}
function _M0DTPC16result6ResultGsRP210tonyfettes3url15ValidationErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRP210tonyfettes3url15ValidationErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGsRP210tonyfettes3url15ValidationErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRP210tonyfettes3url15ValidationErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGmRP210tonyfettes3url15ValidationErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGmRP210tonyfettes3url15ValidationErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGmRP210tonyfettes3url15ValidationErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGmRP210tonyfettes3url15ValidationErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGRP210tonyfettes3url4IPv4RP210tonyfettes3url15ValidationErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP210tonyfettes3url4IPv4RP210tonyfettes3url15ValidationErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP210tonyfettes3url4IPv4RP210tonyfettes3url15ValidationErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP210tonyfettes3url4IPv4RP210tonyfettes3url15ValidationErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGRP210tonyfettes3url4IPv6RP210tonyfettes3url15ValidationErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP210tonyfettes3url4IPv6RP210tonyfettes3url15ValidationErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP210tonyfettes3url4IPv6RP210tonyfettes3url15ValidationErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP210tonyfettes3url4IPv6RP210tonyfettes3url15ValidationErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGRP210tonyfettes3url4HostRP210tonyfettes3url15ValidationErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP210tonyfettes3url4HostRP210tonyfettes3url15ValidationErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP210tonyfettes3url4HostRP210tonyfettes3url15ValidationErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP210tonyfettes3url4HostRP210tonyfettes3url15ValidationErrorE2Ok.prototype.$tag = 1;
function _M0TP210tonyfettes3url13StringPointer(param0, param1) {
  this.input = param0;
  this.pointer = param1;
}
function _M0TP410Haoxincode8moonbash3lib8commands14VmExecResponse(param0, param1, param2, param3, param4, param5) {
  this.stdout = param0;
  this.stderr = param1;
  this.exit_code = param2;
  this.error = param3;
  this.has_files = param4;
  this.files = param5;
}
function _M0TP410Haoxincode8moonbash3lib8commands10ExprParser(param0, param1, param2) {
  this.tokens = param0;
  this.pos = param1;
  this.error = param2;
}
function _M0TP410Haoxincode8moonbash3lib8commands8TarEntry(param0, param1, param2) {
  this.path = param0;
  this.is_dir = param1;
  this.content = param2;
}
function _M0DTP410Haoxincode8moonbash3lib8commands16AwkGetlineTarget6Record() {}
_M0DTP410Haoxincode8moonbash3lib8commands16AwkGetlineTarget6Record.prototype.$tag = 0;
const _M0DTP410Haoxincode8moonbash3lib8commands16AwkGetlineTarget6Record__ = new _M0DTP410Haoxincode8moonbash3lib8commands16AwkGetlineTarget6Record();
function _M0DTP410Haoxincode8moonbash3lib8commands16AwkGetlineTarget3Var(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib8commands16AwkGetlineTarget3Var.prototype.$tag = 1;
function _M0DTP410Haoxincode8moonbash3lib8commands16AwkGetlineTarget5Field(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib8commands16AwkGetlineTarget5Field.prototype.$tag = 2;
function _M0DTP410Haoxincode8moonbash3lib8commands16AwkGetlineTarget9ArrayElem(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP410Haoxincode8moonbash3lib8commands16AwkGetlineTarget9ArrayElem.prototype.$tag = 3;
function _M0DTP410Haoxincode8moonbash3lib8commands16AwkGetlineTarget7Invalid(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib8commands16AwkGetlineTarget7Invalid.prototype.$tag = 4;
function _M0DTP410Haoxincode8moonbash3lib8commands15AwkAssignTarget3Var(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib8commands15AwkAssignTarget3Var.prototype.$tag = 0;
function _M0DTP410Haoxincode8moonbash3lib8commands15AwkAssignTarget9ArrayElem(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP410Haoxincode8moonbash3lib8commands15AwkAssignTarget9ArrayElem.prototype.$tag = 1;
function _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib8commands7AwkStmtEE4None() {}
_M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib8commands7AwkStmtEE4None.prototype.$tag = 0;
const _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib8commands7AwkStmtEE4None__ = new _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib8commands7AwkStmtEE4None();
function _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib8commands7AwkStmtEE4Some(param0) {
  this._0 = param0;
}
_M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib8commands7AwkStmtEE4Some.prototype.$tag = 1;
function _M0TP410Haoxincode8moonbash3lib8commands11AwkFunction(param0, param1) {
  this.params = param0;
  this.body = param1;
}
function _M0TPB9ArrayViewGUsRP410Haoxincode8moonbash3lib8commands11AwkFunctionEE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0TP410Haoxincode8moonbash3lib8commands10AwkProgram(param0, param1, param2, param3, param4, param5, param6) {
  this.begin_actions = param0;
  this.pattern_ast = param1;
  this.action = param2;
  this.end_actions = param3;
  this.has_main = param4;
  this.range_start_ast = param5;
  this.range_end_ast = param6;
}
function _M0TP410Haoxincode8moonbash3lib8commands13CsvlookConfig(param0) {
  this.file_path = param0;
}
function _M0TP410Haoxincode8moonbash3lib8commands16NetFetchResponse(param0, param1, param2, param3, param4, param5) {
  this.ok = param0;
  this.status = param1;
  this.status_text = param2;
  this.body = param3;
  this.error = param4;
  this.headers = param5;
}
function _M0DTPC16option6OptionGRPB5ArrayGRP210tonyfettes3url15ValidationErrorEE4None() {}
_M0DTPC16option6OptionGRPB5ArrayGRP210tonyfettes3url15ValidationErrorEE4None.prototype.$tag = 0;
const _M0DTPC16option6OptionGRPB5ArrayGRP210tonyfettes3url15ValidationErrorEE4None__ = new _M0DTPC16option6OptionGRPB5ArrayGRP210tonyfettes3url15ValidationErrorEE4None();
function _M0DTPC16option6OptionGRPB5ArrayGRP210tonyfettes3url15ValidationErrorEE4Some(param0) {
  this._0 = param0;
}
_M0DTPC16option6OptionGRPB5ArrayGRP210tonyfettes3url15ValidationErrorEE4Some.prototype.$tag = 1;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands13NetCurlConfigRP410Haoxincode8moonbash3lib3ast10ExecResultE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands13NetCurlConfigRP410Haoxincode8moonbash3lib3ast10ExecResultE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands13NetCurlConfigRP410Haoxincode8moonbash3lib3ast10ExecResultE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands13NetCurlConfigRP410Haoxincode8moonbash3lib3ast10ExecResultE2Ok.prototype.$tag = 1;
function _M0TP410Haoxincode8moonbash3lib8commands13NetCurlConfig(param0, param1, param2, param3, param4, param5, param6) {
  this.http_method = param0;
  this.include_headers = param1;
  this.silent = param2;
  this.output_path = param3;
  this.body = param4;
  this.url = param5;
  this.headers = param6;
}
function _M0TP410Haoxincode8moonbash3lib8commands18CustomExecResponse(param0, param1, param2, param3, param4, param5, param6) {
  this.handled = param0;
  this.stdout = param1;
  this.stderr = param2;
  this.exit_code = param3;
  this.error = param4;
  this.has_files = param5;
  this.files = param6;
}
function _M0TPB8MutLocalGOiE(param0) {
  this.val = param0;
}
function _M0TP410Haoxincode8moonbash3lib8commands14CommandContext(param0, param1, param2, param3, param4) {
  this.args = param0;
  this.stdin_content = param1;
  this.cwd = param2;
  this.env = param3;
  this.fs = param4;
}
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands23NetHtmlToMarkdownConfigRP410Haoxincode8moonbash3lib3ast10ExecResultE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands23NetHtmlToMarkdownConfigRP410Haoxincode8moonbash3lib3ast10ExecResultE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands23NetHtmlToMarkdownConfigRP410Haoxincode8moonbash3lib3ast10ExecResultE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands23NetHtmlToMarkdownConfigRP410Haoxincode8moonbash3lib3ast10ExecResultE2Ok.prototype.$tag = 1;
function _M0TP410Haoxincode8moonbash3lib8commands23NetHtmlToMarkdownConfig(param0, param1) {
  this.output_path = param0;
  this.source_url = param1;
}
function _M0TP410Haoxincode8moonbash3lib8commands14XanSliceConfig(param0, param1, param2) {
  this.start = param0;
  this.length = param1;
  this.file_path = param2;
}
function _M0TP410Haoxincode8moonbash3lib8commands8YqConfig(param0, param1, param2) {
  this.raw = param0;
  this.filter = param1;
  this.file_path = param2;
}
function _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGbRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGbRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGbRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGbRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast5TokenERP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast5TokenERP410Haoxincode8moonbash3lib3ast9BashErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast5TokenERP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast5TokenERP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok.prototype.$tag = 1;
function _M0TP410Haoxincode8moonbash3lib5lexer5Lexer(param0, param1, param2) {
  this.source = param0;
  this.pos = param1;
  this.tokens = param2;
}
function _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Num(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Num.prototype.$tag = 0;
function _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Var(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Var.prototype.$tag = 1;
function _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr5BinOp(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr5BinOp.prototype.$tag = 2;
function _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr7UnaryOp(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr7UnaryOp.prototype.$tag = 3;
function _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr6Assign(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr6Assign.prototype.$tag = 4;
function _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr7Ternary(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr7Ternary.prototype.$tag = 5;
function _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Raw(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Raw.prototype.$tag = 6;
function _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion6Simple(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion6Simple.prototype.$tag = 0;
function _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion7Default(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion7Default.prototype.$tag = 1;
function _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion6Assign(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion6Assign.prototype.$tag = 2;
function _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion5Error(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion5Error.prototype.$tag = 3;
function _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion11Alternative(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion11Alternative.prototype.$tag = 4;
function _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion6Length(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion6Length.prototype.$tag = 5;
function _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion9Substring(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion9Substring.prototype.$tag = 6;
function _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion12PrefixRemove(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion12PrefixRemove.prototype.$tag = 7;
function _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion12SuffixRemove(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion12SuffixRemove.prototype.$tag = 8;
function _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion7Replace(param0, param1, param2, param3) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
  this._3 = param3;
}
_M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion7Replace.prototype.$tag = 9;
function _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion9Uppercase(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion9Uppercase.prototype.$tag = 10;
function _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion9Lowercase(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion9Lowercase.prototype.$tag = 11;
function _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion11Indirection(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion11Indirection.prototype.$tag = 12;
function _M0TP410Haoxincode8moonbash3lib3ast4Word(param0) {
  this.parts = param0;
}
function _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast11RedirectionRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast11RedirectionRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast11RedirectionRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast11RedirectionRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok.prototype.$tag = 1;
function _M0TP410Haoxincode8moonbash3lib3ast11Redirection(param0, param1, param2, param3) {
  this.fd = param0;
  this.fd_var = param1;
  this.op = param2;
  this.target = param3;
}
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast13SimpleCommandRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast13SimpleCommandRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast13SimpleCommandRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast13SimpleCommandRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok.prototype.$tag = 1;
function _M0TP410Haoxincode8moonbash3lib3ast13SimpleCommand(param0, param1, param2) {
  this.assignments = param0;
  this.words = param1;
  this.redirections = param2;
}
function _M0DTPC16result6ResultGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast11RedirectionERP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast11RedirectionERP410Haoxincode8moonbash3lib3ast9BashErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast11RedirectionERP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast11RedirectionERP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok.prototype.$tag = 1;
function _M0TP410Haoxincode8moonbash3lib3ast10Assignment(param0, param1, param2) {
  this.name = param0;
  this.value = param1;
  this.append = param2;
}
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast6ScriptRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast6ScriptRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast6ScriptRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast6ScriptRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok.prototype.$tag = 1;
function _M0TP410Haoxincode8moonbash3lib3ast6Script(param0) {
  this.statements = param0;
}
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast9StatementRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast9StatementRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast9StatementRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast9StatementRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok.prototype.$tag = 1;
function _M0DTP410Haoxincode8moonbash3lib3ast9Statement8Pipeline(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast9Statement8Pipeline.prototype.$tag = 0;
function _M0DTP410Haoxincode8moonbash3lib3ast9Statement7AndList(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP410Haoxincode8moonbash3lib3ast9Statement7AndList.prototype.$tag = 1;
function _M0DTP410Haoxincode8moonbash3lib3ast9Statement6OrList(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP410Haoxincode8moonbash3lib3ast9Statement6OrList.prototype.$tag = 2;
function _M0DTP410Haoxincode8moonbash3lib3ast9Statement10Background(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast9Statement10Background.prototype.$tag = 3;
function _M0DTP410Haoxincode8moonbash3lib3ast9Statement8Sequence(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP410Haoxincode8moonbash3lib3ast9Statement8Sequence.prototype.$tag = 4;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast8PipelineRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast8PipelineRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast8PipelineRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast8PipelineRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok.prototype.$tag = 1;
function _M0TP410Haoxincode8moonbash3lib3ast8Pipeline(param0, param1, param2) {
  this.negated = param0;
  this.commands = param1;
  this.pipe_stderr = param2;
}
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast7CommandRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast7CommandRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast7CommandRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast7CommandRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok.prototype.$tag = 1;
function _M0DTP410Haoxincode8moonbash3lib3ast7Command6Simple(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast7Command6Simple.prototype.$tag = 0;
function _M0DTP410Haoxincode8moonbash3lib3ast7Command8Compound(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP410Haoxincode8moonbash3lib3ast7Command8Compound.prototype.$tag = 1;
function _M0DTP410Haoxincode8moonbash3lib3ast7Command11FunctionDef(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast7Command11FunctionDef.prototype.$tag = 2;
function _M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand2If(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand2If.prototype.$tag = 0;
function _M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand3For(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand3For.prototype.$tag = 1;
function _M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand9CStyleFor(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand9CStyleFor.prototype.$tag = 2;
function _M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand5While(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand5While.prototype.$tag = 3;
function _M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand5Until(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand5Until.prototype.$tag = 4;
function _M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand4Case(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand4Case.prototype.$tag = 5;
function _M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand8Subshell(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand8Subshell.prototype.$tag = 6;
function _M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand5Group(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand5Group.prototype.$tag = 7;
function _M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand17ArithmeticCommand(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand17ArithmeticCommand.prototype.$tag = 8;
function _M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand18ConditionalCommand(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand18ConditionalCommand.prototype.$tag = 9;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast10CaseClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast10CaseClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast10CaseClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast10CaseClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok.prototype.$tag = 1;
function _M0TP410Haoxincode8moonbash3lib3ast8CaseItem(param0, param1, param2) {
  this.patterns = param0;
  this.body = param1;
  this.terminator = param2;
}
function _M0TP410Haoxincode8moonbash3lib3ast10CaseClause(param0, param1) {
  this.word = param0;
  this.items = param1;
}
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast15CompoundCommandRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast15CompoundCommandRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast15CompoundCommandRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast15CompoundCommandRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok.prototype.$tag = 1;
function _M0TP410Haoxincode8moonbash3lib3ast15CStyleForClause(param0, param1, param2, param3) {
  this.init = param0;
  this.condition = param1;
  this.update = param2;
  this.body = param3;
}
function _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast4WordEE4None() {}
_M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast4WordEE4None.prototype.$tag = 0;
const _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast4WordEE4None__ = new _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast4WordEE4None();
function _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast4WordEE4Some(param0) {
  this._0 = param0;
}
_M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast4WordEE4Some.prototype.$tag = 1;
function _M0TP410Haoxincode8moonbash3lib3ast9ForClause(param0, param1, param2) {
  this.var_name = param0;
  this.words = param1;
  this.body = param2;
}
function _M0TP410Haoxincode8moonbash3lib3ast11FunctionDef(param0, param1, param2) {
  this.name = param0;
  this.body = param1;
  this.redirections = param2;
}
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast8IfClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast8IfClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast8IfClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast8IfClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok.prototype.$tag = 1;
function _M0TP410Haoxincode8moonbash3lib3ast8IfClause(param0, param1, param2, param3) {
  this.condition = param0;
  this.then_branch = param1;
  this.elif_branches = param2;
  this.else_branch = param3;
}
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast11UntilClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast11UntilClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast11UntilClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast11UntilClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok.prototype.$tag = 1;
function _M0TP410Haoxincode8moonbash3lib3ast11UntilClause(param0, param1) {
  this.condition = param0;
  this.body = param1;
}
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast11WhileClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast11WhileClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast11WhileClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast11WhileClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok.prototype.$tag = 1;
function _M0TP410Haoxincode8moonbash3lib3ast11WhileClause(param0, param1) {
  this.condition = param0;
  this.body = param1;
}
function _M0TP410Haoxincode8moonbash3lib6parser6Parser(param0, param1, param2) {
  this.tokens = param0;
  this.pos = param1;
  this.depth = param2;
}
function _M0TP411moonbitlang6regexp8internal2vm6Thread(param0, param1, param2) {
  this.pc = param0;
  this.sp = param1;
  this.captures = param2;
}
function _M0TPB9ArrayViewGUsiEE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0TP411moonbitlang6regexp8internal5parse6Parser(param0, param1, param2, param3, param4, param5) {
  this.input = param0;
  this.flags = param1;
  this.captures = param2;
  this.current_capture_scope = param3;
  this.capture_map = param4;
  this.has_backreference = param5;
}
function _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGcRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGcRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGcRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGcRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGsRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGsRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok.prototype.$tag = 1;
function _M0TP411moonbitlang6regexp8internal5parse5Flags(param0, param1, param2) {
  this.multiline = param0;
  this.singleline = param1;
  this.ignore_case = param2;
}
function _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal5parse5FlagsRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP411moonbitlang6regexp8internal5parse5FlagsRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal5parse5FlagsRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP411moonbitlang6regexp8internal5parse5FlagsRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGjRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGjRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGjRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGjRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGUjOjERP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGUjOjERP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGUjOjERP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGUjOjERP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal5parse11ParseResultRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP411moonbitlang6regexp8internal5parse11ParseResultRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal5parse11ParseResultRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP411moonbitlang6regexp8internal5parse11ParseResultRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok.prototype.$tag = 1;
function _M0TP411moonbitlang6regexp8internal5parse11ParseResult(param0, param1, param2, param3) {
  this.ast = param0;
  this.captures = param1;
  this.capture_map = param2;
  this.has_backreference = param3;
}
function _M0TP211moonbitlang6regexp6Regexp(param0, param1, param2, param3) {
  this.instructions = param0;
  this.map = param1;
  this.capture = param2;
  this.allow_exponentiaion = param3;
}
function _M0DTPC16result6ResultGRP211moonbitlang6regexp6RegexpRP211moonbitlang6regexp11RegexpErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP211moonbitlang6regexp6RegexpRP211moonbitlang6regexp11RegexpErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP211moonbitlang6regexp6RegexpRP211moonbitlang6regexp11RegexpErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP211moonbitlang6regexp6RegexpRP211moonbitlang6regexp11RegexpErrorE2Ok.prototype.$tag = 1;
function _M0TP211moonbitlang6regexp11MatchResult(param0, param1, param2, param3, param4) {
  this.input = param0;
  this.captures = param1;
  this.names = param2;
  this.before = param3;
  this.after = param4;
}
function _M0DTPC16result6ResultGuRP211moonbitlang6regexp11RegexpErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRP211moonbitlang6regexp11RegexpErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGuRP211moonbitlang6regexp11RegexpErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRP211moonbitlang6regexp11RegexpErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib5regex11GrepMatcherRP211moonbitlang6regexp11RegexpErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib5regex11GrepMatcherRP211moonbitlang6regexp11RegexpErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib5regex11GrepMatcherRP211moonbitlang6regexp11RegexpErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib5regex11GrepMatcherRP211moonbitlang6regexp11RegexpErrorE2Ok.prototype.$tag = 1;
function _M0DTP410Haoxincode8moonbash3lib5regex11GrepMatcher5Fixed(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP410Haoxincode8moonbash3lib5regex11GrepMatcher5Fixed.prototype.$tag = 0;
function _M0DTP410Haoxincode8moonbash3lib5regex11GrepMatcher5Regex(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP410Haoxincode8moonbash3lib5regex11GrepMatcher5Regex.prototype.$tag = 1;
function _M0DTP410Haoxincode8moonbash3lib11interpreter10SedAddress4Line(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib11interpreter10SedAddress4Line.prototype.$tag = 0;
function _M0DTP410Haoxincode8moonbash3lib11interpreter10SedAddress8LastLine() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter10SedAddress8LastLine.prototype.$tag = 1;
const _M0DTP410Haoxincode8moonbash3lib11interpreter10SedAddress8LastLine__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter10SedAddress8LastLine();
function _M0DTP410Haoxincode8moonbash3lib11interpreter10SedAddress5Regex(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib11interpreter10SedAddress5Regex.prototype.$tag = 2;
function _M0DTP410Haoxincode8moonbash3lib11interpreter10SedAddress9LastRegex() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter10SedAddress9LastRegex.prototype.$tag = 3;
const _M0DTP410Haoxincode8moonbash3lib11interpreter10SedAddress9LastRegex__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter10SedAddress9LastRegex();
function _M0DTP410Haoxincode8moonbash3lib11interpreter10SedAddress8Relative(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib11interpreter10SedAddress8Relative.prototype.$tag = 4;
function _M0TP410Haoxincode8moonbash3lib11interpreter15SedAddressRange(param0, param1) {
  this.start = param0;
  this.end = param1;
}
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind10GroupStart() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind10GroupStart.prototype.$tag = 0;
const _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind10GroupStart__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind10GroupStart();
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind8GroupEnd() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind8GroupEnd.prototype.$tag = 1;
const _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind8GroupEnd__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind8GroupEnd();
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind6Delete() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind6Delete.prototype.$tag = 2;
const _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind6Delete__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind6Delete();
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind15DeleteFirstLine() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind15DeleteFirstLine.prototype.$tag = 3;
const _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind15DeleteFirstLine__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind15DeleteFirstLine();
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind10Substitute(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind10Substitute.prototype.$tag = 4;
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind14AppendNextLine() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind14AppendNextLine.prototype.$tag = 5;
const _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind14AppendNextLine__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind14AppendNextLine();
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind8NextLine() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind8NextLine.prototype.$tag = 6;
const _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind8NextLine__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind8NextLine();
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind13Transliterate(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind13Transliterate.prototype.$tag = 7;
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind12PrintPattern() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind12PrintPattern.prototype.$tag = 8;
const _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind12PrintPattern__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind12PrintPattern();
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind14PrintFirstLine() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind14PrintFirstLine.prototype.$tag = 9;
const _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind14PrintFirstLine__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind14PrintFirstLine();
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind15PrintLineNumber() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind15PrintLineNumber.prototype.$tag = 10;
const _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind15PrintLineNumber__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind15PrintLineNumber();
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind7HoldSet() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind7HoldSet.prototype.$tag = 11;
const _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind7HoldSet__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind7HoldSet();
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind10HoldAppend() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind10HoldAppend.prototype.$tag = 12;
const _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind10HoldAppend__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind10HoldAppend();
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind7HoldGet() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind7HoldGet.prototype.$tag = 13;
const _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind7HoldGet__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind7HoldGet();
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind13HoldAppendGet() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind13HoldAppendGet.prototype.$tag = 14;
const _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind13HoldAppendGet__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind13HoldAppendGet();
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind12ExchangeHold() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind12ExchangeHold.prototype.$tag = 15;
const _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind12ExchangeHold__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind12ExchangeHold();
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind10AppendText(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind10AppendText.prototype.$tag = 16;
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind10InsertText(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind10InsertText.prototype.$tag = 17;
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind10ChangeText(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind10ChangeText.prototype.$tag = 18;
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind9WriteFile(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind9WriteFile.prototype.$tag = 19;
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind5Label(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind5Label.prototype.$tag = 20;
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind6Branch(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind6Branch.prototype.$tag = 21;
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind13BranchIfSubst(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind13BranchIfSubst.prototype.$tag = 22;
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind16BranchIfNotSubst(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind16BranchIfNotSubst.prototype.$tag = 23;
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind12VersionCheck(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind12VersionCheck.prototype.$tag = 24;
function _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind4Quit() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind4Quit.prototype.$tag = 25;
const _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind4Quit__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind4Quit();
function _M0TP410Haoxincode8moonbash3lib11interpreter10SedCommand(param0, param1, param2) {
  this.address = param0;
  this.kind = param1;
  this.negated = param2;
}
function _M0TP410Haoxincode8moonbash3lib11interpreter18SedSubstituteFlags(param0, param1, param2, param3, param4) {
  this.global = param0;
  this.ignore_case = param1;
  this.occurrence = param2;
  this.print_on_subst = param3;
  this.write_file = param4;
}
function _M0TP410Haoxincode8moonbash3lib11interpreter12SedSubstSpec(param0, param1, param2, param3, param4, param5, param6) {
  this.matcher = param0;
  this.replacement = param1;
  this.global = param2;
  this.occurrence = param3;
  this.literal_ampersand = param4;
  this.print_on_subst = param5;
  this.write_file = param6;
}
function _M0TP410Haoxincode8moonbash3lib11interpreter15SedTranslitSpec(param0, param1) {
  this.source = param0;
  this.target = param1;
}
function _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib11interpreter10SedCommandEE4None() {}
_M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib11interpreter10SedCommandEE4None.prototype.$tag = 0;
const _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib11interpreter10SedCommandEE4None__ = new _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib11interpreter10SedCommandEE4None();
function _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib11interpreter10SedCommandEE4Some(param0) {
  this._0 = param0;
}
_M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib11interpreter10SedCommandEE4Some.prototype.$tag = 1;
function _M0TP410Haoxincode8moonbash3lib11interpreter10SedRuntime(param0, param1, param2, param3, param4, param5, param6) {
  this.commands = param0;
  this.lines = param1;
  this.total_lines = param2;
  this.range_states = param3;
  this.label_names = param4;
  this.label_indices = param5;
  this.out = param6;
}
function _M0TP410Haoxincode8moonbash3lib11interpreter8SedCycle(param0, param1, param2, param3, param4, param5, param6, param7) {
  this.line_no = param0;
  this.line = param1;
  this.line_terminated = param2;
  this.deleted = param3;
  this.consumed_extra = param4;
  this.substituted = param5;
  this.stop_after_cycle = param6;
  this.append_queue = param7;
}
function _M0TP410Haoxincode8moonbash3lib11interpreter8SedState(param0, param1, param2, param3, param4) {
  this.hold_space = param0;
  this.last_regex = param1;
  this.pending_no_newline = param2;
  this.quit = param3;
  this.executed_steps = param4;
}
function _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next.prototype.$tag = 0;
const _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next();
function _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction12RestartCycle() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction12RestartCycle.prototype.$tag = 1;
const _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction12RestartCycle__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction12RestartCycle();
function _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction10BreakCycle() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction10BreakCycle.prototype.$tag = 2;
const _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction10BreakCycle__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction10BreakCycle();
function _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction6JumpTo(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction6JumpTo.prototype.$tag = 3;
function _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Quit() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Quit.prototype.$tag = 4;
const _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Quit__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Quit();
function _M0TPB9ArrayViewGUsRP410Haoxincode8moonbash3lib3ast11FunctionDefEE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib11interpreter10DateConfigsE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib11interpreter10DateConfigsE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib11interpreter10DateConfigsE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib11interpreter10DateConfigsE2Ok.prototype.$tag = 1;
function _M0TP410Haoxincode8moonbash3lib11interpreter10DateConfig(param0, param1) {
  this.use_utc = param0;
  this.format = param1;
}
function _M0TP410Haoxincode8moonbash3lib11interpreter10GrepTarget(param0, param1) {
  this.display_path = param0;
  this.content = param1;
}
function _M0DTPC16result6ResultGisE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGisE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGisE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGisE2Ok.prototype.$tag = 1;
function _M0TPB8MutLocalGOsE(param0) {
  this.val = param0;
}
function _M0TP410Haoxincode8moonbash3lib11interpreter10ArithValue(param0, param1) {
  this.value = param0;
  this.target = param1;
}
function _M0DTP410Haoxincode8moonbash3lib11interpreter11ArithTarget8NoTarget() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter11ArithTarget8NoTarget.prototype.$tag = 0;
const _M0DTP410Haoxincode8moonbash3lib11interpreter11ArithTarget8NoTarget__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter11ArithTarget8NoTarget();
function _M0DTP410Haoxincode8moonbash3lib11interpreter11ArithTarget3Var(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib11interpreter11ArithTarget3Var.prototype.$tag = 1;
function _M0DTP410Haoxincode8moonbash3lib11interpreter11ArithTarget9ArrayElem(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP410Haoxincode8moonbash3lib11interpreter11ArithTarget9ArrayElem.prototype.$tag = 2;
function _M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult12BraceNoRange() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult12BraceNoRange.prototype.$tag = 0;
const _M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult12BraceNoRange__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult12BraceNoRange();
function _M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult17BraceRangeOptions(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult17BraceRangeOptions.prototype.$tag = 1;
function _M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult21BraceRangeSyntaxError() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult21BraceRangeSyntaxError.prototype.$tag = 2;
const _M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult21BraceRangeSyntaxError__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult21BraceRangeSyntaxError();
function _M0DTP410Haoxincode8moonbash3lib11interpreter22BraceOptionParseResult13BraceNoOption() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter22BraceOptionParseResult13BraceNoOption.prototype.$tag = 0;
const _M0DTP410Haoxincode8moonbash3lib11interpreter22BraceOptionParseResult13BraceNoOption__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter22BraceOptionParseResult13BraceNoOption();
function _M0DTP410Haoxincode8moonbash3lib11interpreter22BraceOptionParseResult12BraceOptions(param0) {
  this._0 = param0;
}
_M0DTP410Haoxincode8moonbash3lib11interpreter22BraceOptionParseResult12BraceOptions.prototype.$tag = 1;
function _M0DTP410Haoxincode8moonbash3lib11interpreter22BraceOptionParseResult22BraceOptionSyntaxError() {}
_M0DTP410Haoxincode8moonbash3lib11interpreter22BraceOptionParseResult22BraceOptionSyntaxError.prototype.$tag = 2;
const _M0DTP410Haoxincode8moonbash3lib11interpreter22BraceOptionParseResult22BraceOptionSyntaxError__ = new _M0DTP410Haoxincode8moonbash3lib11interpreter22BraceOptionParseResult22BraceOptionSyntaxError();
function _M0TP410Haoxincode8moonbash3lib11interpreter11ArithParser(param0, param1) {
  this.tokens = param0;
  this.pos = param1;
}
function _M0TP410Haoxincode8moonbash3lib11interpreter14TestExprParser(param0, param1) {
  this.tokens = param0;
  this.pos = param1;
}
function _M0TP410Haoxincode8moonbash3lib11interpreter11ExecContext(param0, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10, param11, param12, param13, param14, param15, param16, param17, param18, param19, param20) {
  this.env = param0;
  this.exported = param1;
  this.cwd = param2;
  this.functions = param3;
  this.options = param4;
  this.stdin_buf = param5;
  this.stdout_buf = param6;
  this.stderr_buf = param7;
  this.exit_code = param8;
  this.should_exit = param9;
  this.loop_depth = param10;
  this.break_count = param11;
  this.continue_count = param12;
  this.return_requested = param13;
  this.limits = param14;
  this.command_count = param15;
  this.call_depth = param16;
  this.substitution_depth = param17;
  this.glob_operations = param18;
  this.fs = param19;
  this.current_script = param20;
}
const _M0FP066gmlewis_2fflate_2fDecompressor_24as_24_40gmlewis_2fio_2eReadCloser = { method_0: _M0IP27gmlewis5flate12DecompressorP27gmlewis2io6Reader4read, method_1: _M0IP27gmlewis5flate12DecompressorP27gmlewis2io6Closer5close };
const _M0FP061gmlewis_2fflate_2fWriter_24as_24_40gmlewis_2fio_2eWriteCloser = { method_0: _M0IP27gmlewis5flate6WriterP27gmlewis2io6Writer5write, method_1: _M0IP27gmlewis5flate6WriterP27gmlewis2io6Closer5close };
const _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger = { method_0: _M0IPB13StringBuilderPB6Logger13write__string, method_1: _M0IP016_24default__implPB6Logger16write__substringGRPB13StringBuilderE, method_2: _M0IPB13StringBuilderPB6Logger11write__view, method_3: _M0IPB13StringBuilderPB6Logger11write__char, method_4: _M0IP016_24default__implPB6Logger5writeGRPB13StringBuilderE };
const _M0FP055gmlewis_2fgzip_2fReader_24as_24_40gmlewis_2fio_2eReader = { method_0: _M0IP27gmlewis4gzip6ReaderP27gmlewis2io6Reader4read };
const _M0FP056gmlewis_2fio_2fBuffer_24as_24_40gmlewis_2fflate_2eReader = { method_0: _M0IP27gmlewis2io6BufferP27gmlewis5flate6Reader4read, method_1: _M0IP27gmlewis2io6BufferP27gmlewis5flate6Reader10read__byte };
const _M0FP053gmlewis_2fio_2fBuffer_24as_24_40gmlewis_2fio_2eWriter = { method_0: _M0IP27gmlewis2io6BufferP27gmlewis2io6Writer5write };
const _M0FP056gmlewis_2fflate_2fReader_24as_24_40gmlewis_2fio_2eReader = { method_0: _M0IP27gmlewis5flate6ReaderP27gmlewis2io6Reader4read };
function _M0FP15Error10to__string(_e) {
  switch (_e.$tag) {
    case 36: {
      return _M0IP016_24default__implPB4Show10to__stringGRP38bobzhang6moonjq6parser8LexErrorE(_e);
    }
    case 32: {
      return _M0IP016_24default__implPB4Show10to__stringGRP27gmlewis6base6417CorruptInputErrorE(_e);
    }
    case 12: {
      return _M0IP016_24default__implPB4Show10to__stringGRP210tonyfettes3url15ValidationErrorE(_e);
    }
    case 63: {
      return "Haoxincode/moonbash/lib/fs.FsError.FsError";
    }
    case 31: {
      return _M0IP016_24default__implPB4Show10to__stringGRP210tonyfettes3url15ValidationErrorE(_e);
    }
    case 37: {
      return _M0IP016_24default__implPB4Show10to__stringGRP38bobzhang6moonjq6parser8LexErrorE(_e);
    }
    case 27: {
      return _M0IP016_24default__implPB4Show10to__stringGRP210tonyfettes3url15ValidationErrorE(_e);
    }
    case 48: {
      return _M0IP016_24default__implPB4Show10to__stringGRP310tonyfettes7unicode4idna9IdnaErrorE(_e);
    }
    case 33: {
      return _M0IP016_24default__implPB4Show10to__stringGRP411moonbitlang6regexp8internal5parse11RegexpErrorE(_e);
    }
    case 5: {
      return _M0IP016_24default__implPB4Show10to__stringGRP219moonbit_2dcommunity4yaml9YamlErrorE(_e);
    }
    case 29: {
      return _M0IP016_24default__implPB4Show10to__stringGRP210tonyfettes3url15ValidationErrorE(_e);
    }
    case 0: {
      return _M0IP016_24default__implPB4Show10to__stringGRP27gmlewis2io7IOErrorE(_e);
    }
    case 51: {
      return _M0IP016_24default__implPB4Show10to__stringGRP310tonyfettes7unicode4idna9IdnaErrorE(_e);
    }
    case 49: {
      return _M0IP016_24default__implPB4Show10to__stringGRP310tonyfettes7unicode4idna9IdnaErrorE(_e);
    }
    case 24: {
      return _M0IP016_24default__implPB4Show10to__stringGRP210tonyfettes3url15ValidationErrorE(_e);
    }
    case 21: {
      return _M0IP016_24default__implPB4Show10to__stringGRP210tonyfettes3url15ValidationErrorE(_e);
    }
    case 30: {
      return _M0IP016_24default__implPB4Show10to__stringGRP210tonyfettes3url15ValidationErrorE(_e);
    }
    case 25: {
      return _M0IP016_24default__implPB4Show10to__stringGRP210tonyfettes3url15ValidationErrorE(_e);
    }
    case 59: {
      return _M0IP016_24default__implPB4Show10to__stringGRP38bobzhang6moonjq6parser10ParseErrorE(_e);
    }
    case 50: {
      return _M0IP016_24default__implPB4Show10to__stringGRP310tonyfettes7unicode4idna9IdnaErrorE(_e);
    }
    case 18: {
      return _M0IP016_24default__implPB4Show10to__stringGRP210tonyfettes3url15ValidationErrorE(_e);
    }
    case 13: {
      return _M0IP016_24default__implPB4Show10to__stringGRP210tonyfettes3url15ValidationErrorE(_e);
    }
    case 60: {
      return _M0IP016_24default__implPB4Show10to__stringGRPC17strconv12StrConvErrorE(_e);
    }
    case 52: {
      return _M0IP016_24default__implPB4Show10to__stringGRP310tonyfettes7unicode4idna9IdnaErrorE(_e);
    }
    case 40: {
      return _M0IP016_24default__implPB4Show10to__stringGRP38bobzhang6moonjq3ast16InterpreterErrorE(_e);
    }
    case 7: {
      return _M0IP016_24default__implPB4Show10to__stringGRPC14json10ParseErrorE(_e);
    }
    case 6: {
      return _M0IP016_24default__implPB4Show10to__stringGRPC14json10ParseErrorE(_e);
    }
    case 15: {
      return _M0IP016_24default__implPB4Show10to__stringGRP210tonyfettes3url15ValidationErrorE(_e);
    }
    case 28: {
      return _M0IP016_24default__implPB4Show10to__stringGRP210tonyfettes3url15ValidationErrorE(_e);
    }
    case 54: {
      return _M0IP016_24default__implPB4Show10to__stringGRP310tonyfettes7unicode4idna9IdnaErrorE(_e);
    }
    case 16: {
      return _M0IP016_24default__implPB4Show10to__stringGRP210tonyfettes3url15ValidationErrorE(_e);
    }
    case 55: {
      return _M0IP016_24default__implPB4Show10to__stringGRP310tonyfettes7unicode4idna9IdnaErrorE(_e);
    }
    case 53: {
      return _M0IP016_24default__implPB4Show10to__stringGRP310tonyfettes7unicode4idna9IdnaErrorE(_e);
    }
    case 35: {
      return _M0IP016_24default__implPB4Show10to__stringGRP38bobzhang6moonjq6parser8LexErrorE(_e);
    }
    case 14: {
      return _M0IP016_24default__implPB4Show10to__stringGRP210tonyfettes3url15ValidationErrorE(_e);
    }
    case 2: {
      return _M0IP016_24default__implPB4Show10to__stringGRP310tonyfettes7unicode8punycode13PunycodeErrorE(_e);
    }
    case 61: {
      return _M0IP016_24default__implPB4Show10to__stringGRP211moonbitlang6regexp11RegexpErrorE(_e);
    }
    case 58: {
      return _M0IP016_24default__implPB4Show10to__stringGRP38bobzhang6moonjq6parser10ParseErrorE(_e);
    }
    case 22: {
      return _M0IP016_24default__implPB4Show10to__stringGRP210tonyfettes3url15ValidationErrorE(_e);
    }
    case 45: {
      return _M0IP016_24default__implPB4Show10to__stringGRP310tonyfettes7unicode4idna9IdnaErrorE(_e);
    }
    case 39: {
      return _M0IP016_24default__implPB4Show10to__stringGRP38bobzhang6moonjq3ast16InterpreterErrorE(_e);
    }
    case 62: {
      return "moonbitlang/core/encoding/utf8.Malformed.Malformed";
    }
    case 3: {
      return _M0IP016_24default__implPB4Show10to__stringGRP310tonyfettes7unicode8punycode13PunycodeErrorE(_e);
    }
    case 64: {
      return "peter-jerry-ye/parse_args.ParseError.ParseError";
    }
    case 8: {
      return _M0IP016_24default__implPB4Show10to__stringGRPC14json10ParseErrorE(_e);
    }
    case 4: {
      return _M0IP016_24default__implPB4Show10to__stringGRPB7FailureE(_e);
    }
    case 26: {
      return _M0IP016_24default__implPB4Show10to__stringGRP210tonyfettes3url15ValidationErrorE(_e);
    }
    case 46: {
      return _M0IP016_24default__implPB4Show10to__stringGRP310tonyfettes7unicode4idna9IdnaErrorE(_e);
    }
    case 9: {
      return _M0IP016_24default__implPB4Show10to__stringGRPC14json10ParseErrorE(_e);
    }
    case 38: {
      return _M0IP016_24default__implPB4Show10to__stringGRP38bobzhang6moonjq3ast16InterpreterErrorE(_e);
    }
    case 34: {
      return _M0IP016_24default__implPB4Show10to__stringGRP38bobzhang6moonjq6parser8LexErrorE(_e);
    }
    case 10: {
      return _M0IP016_24default__implPB4Show10to__stringGRPC14json10ParseErrorE(_e);
    }
    case 44: {
      return _M0IP016_24default__implPB4Show10to__stringGRP38bobzhang6moonjq3ast16InterpreterErrorE(_e);
    }
    case 42: {
      return _M0IP016_24default__implPB4Show10to__stringGRP38bobzhang6moonjq3ast16InterpreterErrorE(_e);
    }
    case 57: {
      return _M0IP016_24default__implPB4Show10to__stringGRP38bobzhang6moonjq6parser10ParseErrorE(_e);
    }
    case 41: {
      return _M0IP016_24default__implPB4Show10to__stringGRP38bobzhang6moonjq3ast16InterpreterErrorE(_e);
    }
    case 23: {
      return _M0IP016_24default__implPB4Show10to__stringGRP210tonyfettes3url15ValidationErrorE(_e);
    }
    case 1: {
      return _M0IP016_24default__implPB4Show10to__stringGRP310tonyfettes7unicode8punycode13PunycodeErrorE(_e);
    }
    case 47: {
      return _M0IP016_24default__implPB4Show10to__stringGRP310tonyfettes7unicode4idna9IdnaErrorE(_e);
    }
    case 65: {
      return "Haoxincode/moonbash/lib/ast.BashError.BashError";
    }
    case 17: {
      return _M0IP016_24default__implPB4Show10to__stringGRP210tonyfettes3url15ValidationErrorE(_e);
    }
    case 19: {
      return _M0IP016_24default__implPB4Show10to__stringGRP210tonyfettes3url15ValidationErrorE(_e);
    }
    case 43: {
      return _M0IP016_24default__implPB4Show10to__stringGRP38bobzhang6moonjq3ast16InterpreterErrorE(_e);
    }
    case 56: {
      return _M0IP016_24default__implPB4Show10to__stringGRP38bobzhang6moonjq6parser10ParseErrorE(_e);
    }
    case 11: {
      return _M0IP016_24default__implPB4Show10to__stringGRP210tonyfettes3url15ValidationErrorE(_e);
    }
    default: {
      return _M0IP016_24default__implPB4Show10to__stringGRP210tonyfettes3url15ValidationErrorE(_e);
    }
  }
}
const _M0MPC16string6String4trimN7_2abindS5977 = "\t\n\r ";
const _M0FPB4null = _M0DTPB4Json4Null__;
const _M0FPB18double__max__value = $i64_reinterpret_f64(9218868437227405311n);
const _M0FPB18double__min__value = $i64_reinterpret_f64(18442240474082181119n);
const _M0MPB4Iter4nextN6constrS8638GUssEE = 0;
const _M0MPB4Iter4nextN6constrS8639GUssEE = 0;
const _M0MPB4Iter4nextN6constrS8638GcE = 0;
const _M0MPB4Iter4nextN6constrS8639GcE = 0;
const _M0MPB4Iter4nextN6constrS8638GyE = 0;
const _M0MPB4Iter4nextN6constrS8639GyE = 0;
const _M0MPB4Iter4nextN6constrS8638GRPB5ArrayGRPB4JsonEE = 0;
const _M0MPB4Iter4nextN6constrS8639GRPB5ArrayGRPB4JsonEE = 0;
const _M0MPB4Iter4nextN6constrS8638GiE = 0;
const _M0MPB4Iter4nextN6constrS8639GiE = 0;
const _M0MPB4Iter3newN6constrS8646GUssEE = 0;
const _M0MPB4Iter3newN6constrS8646GcE = 0;
const _M0MPB4Iter3newN6constrS8646GyE = 0;
const _M0MPB4Iter3newN6constrS8646GRPB5ArrayGRPB4JsonEE = 0;
const _M0MPB4Iter3newN6constrS8646GiE = 0;
const _M0MPB5Iter23newN6constrS8647GiiE = 0;
const _M0MPB5Iter23newN6constrS8647GiRP27gmlewis5flate11LiteralNodeE = 0;
const _M0MPB5Iter23newN6constrS8647GicE = 0;
const _M0FPC16double14not__a__number = $i64_reinterpret_f64(9221120237041090561n);
const _M0FPC16double8infinity = $i64_reinterpret_f64(9218868437227405312n);
const _M0FPC16double13neg__infinity = $i64_reinterpret_f64(18442240474082181120n);
const _M0FPC15debug14compact__linesN7_2abindS1156 = "";
const _M0FPC15debug14compact__linesN7_2abindS1177 = " ";
const _M0FPC15debug14compact__linesN7_2abindS1171 = ",";
const _M0FPC15debug14compact__linesN7_2abindS1165 = " ";
const _M0FPC15debug14compact__linesN7_2abindS1159 = " ";
const _M0FPC15debug14compact__linesN7_2abindS1158 = "";
const _M0FPC15debug14compact__linesN7_2abindS1178 = "(";
const _M0FPC15debug14compact__linesN7_2abindS1182 = "";
const _M0FPC15debug14compact__linesN7_2abindS1190 = " ";
const _M0FPC15debug14compact__linesN7_2abindS1184 = ",";
const _M0FPC15debug14compact__linesN7_2abindS1195 = " ";
const _M0FPC15debug19bracket__seq__linesN7_2abindS1204 = "";
const _M0FPC15debug14print__contentN7_2abindS1272 = "\n";
const _M0FPC28internal7strconv14base__err__str = "invalid base";
const _M0FPC28internal7strconv15range__err__str = "value out of range";
const _M0FPC28internal7strconv16syntax__err__str = "invalid syntax";
const _M0FPC28internal7strconv17min__19digit__int = 1000000000000000000n;
const _M0FPC28internal7strconv17parse__scientificN8exp__numS241 = 0n;
const _M0FPC28internal7strconv13parse__numberN11exp__numberS222 = 0n;
const _M0FPC28internal7strconv20parse__int64_2einnerN7_2abindS658 = "";
const _M0FPC28internal7strconv12double__info = new _M0TPC28internal7strconv9FloatInfo(52, 11, -1023);
const _M0FPC28internal7strconv25min__exponent__fast__path = 18446744073709551594n;
const _M0FPC28internal7strconv25max__exponent__fast__path = 22n;
const _M0FPC28internal7strconv36max__exponent__disguised__fast__path = 37n;
const _M0FPC28internal7strconv25max__mantissa__fast__path = 9007199254740992n;
const _M0FPC28internal7strconv6powtab = [1, 3, 6, 9, 13, 16, 19, 23, 26, 29, 33, 36, 39, 43, 46, 49, 53, 56, 59];
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1049 = { _0: 0, _1: "" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1050 = { _0: 1, _1: "5" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1051 = { _0: 1, _1: "25" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1052 = { _0: 1, _1: "125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1053 = { _0: 2, _1: "625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1054 = { _0: 2, _1: "3125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1055 = { _0: 2, _1: "15625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1056 = { _0: 3, _1: "78125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1057 = { _0: 3, _1: "390625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1058 = { _0: 3, _1: "1953125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1059 = { _0: 4, _1: "9765625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1060 = { _0: 4, _1: "48828125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1061 = { _0: 4, _1: "244140625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1062 = { _0: 4, _1: "1220703125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1063 = { _0: 5, _1: "6103515625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1064 = { _0: 5, _1: "30517578125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1065 = { _0: 5, _1: "152587890625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1066 = { _0: 6, _1: "762939453125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1067 = { _0: 6, _1: "3814697265625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1068 = { _0: 6, _1: "19073486328125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1069 = { _0: 7, _1: "95367431640625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1070 = { _0: 7, _1: "476837158203125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1071 = { _0: 7, _1: "2384185791015625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1072 = { _0: 7, _1: "11920928955078125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1073 = { _0: 8, _1: "59604644775390625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1074 = { _0: 8, _1: "298023223876953125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1075 = { _0: 8, _1: "1490116119384765625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1076 = { _0: 9, _1: "7450580596923828125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1077 = { _0: 9, _1: "37252902984619140625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1078 = { _0: 9, _1: "186264514923095703125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1079 = { _0: 10, _1: "931322574615478515625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1080 = { _0: 10, _1: "4656612873077392578125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1081 = { _0: 10, _1: "23283064365386962890625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1082 = { _0: 10, _1: "116415321826934814453125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1083 = { _0: 11, _1: "582076609134674072265625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1084 = { _0: 11, _1: "2910383045673370361328125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1085 = { _0: 11, _1: "14551915228366851806640625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1086 = { _0: 12, _1: "72759576141834259033203125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1087 = { _0: 12, _1: "363797880709171295166015625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1088 = { _0: 12, _1: "1818989403545856475830078125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1089 = { _0: 13, _1: "9094947017729282379150390625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1090 = { _0: 13, _1: "45474735088646411895751953125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1091 = { _0: 13, _1: "227373675443232059478759765625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1092 = { _0: 13, _1: "1136868377216160297393798828125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1093 = { _0: 14, _1: "5684341886080801486968994140625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1094 = { _0: 14, _1: "28421709430404007434844970703125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1095 = { _0: 14, _1: "142108547152020037174224853515625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1096 = { _0: 15, _1: "710542735760100185871124267578125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1097 = { _0: 15, _1: "3552713678800500929355621337890625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1098 = { _0: 15, _1: "17763568394002504646778106689453125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1099 = { _0: 16, _1: "88817841970012523233890533447265625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1100 = { _0: 16, _1: "444089209850062616169452667236328125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1101 = { _0: 16, _1: "2220446049250313080847263336181640625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1102 = { _0: 16, _1: "11102230246251565404236316680908203125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1103 = { _0: 17, _1: "55511151231257827021181583404541015625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1104 = { _0: 17, _1: "277555756156289135105907917022705078125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1105 = { _0: 17, _1: "1387778780781445675529539585113525390625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1106 = { _0: 18, _1: "6938893903907228377647697925567626953125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1107 = { _0: 18, _1: "34694469519536141888238489627838134765625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1108 = { _0: 18, _1: "173472347597680709441192448139190673828125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1109 = { _0: 19, _1: "867361737988403547205962240695953369140625" };
const _M0FPC28internal7strconv19left__shift__cheats = [_M0FPC28internal7strconv19left__shift__cheatsN5tupleS1049, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1050, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1051, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1052, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1053, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1054, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1055, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1056, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1057, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1058, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1059, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1060, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1061, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1062, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1063, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1064, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1065, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1066, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1067, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1068, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1069, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1070, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1071, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1072, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1073, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1074, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1075, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1076, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1077, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1078, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1079, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1080, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1081, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1082, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1083, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1084, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1085, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1086, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1087, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1088, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1089, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1090, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1091, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1092, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1093, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1094, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1095, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1096, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1097, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1098, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1099, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1100, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1101, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1102, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1103, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1104, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1105, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1106, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1107, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1108, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1109];
const _M0FPC28internal7strconv10int__pow10 = [1n, 10n, 100n, 1000n, 10000n, 100000n, 1000000n, 10000000n, 100000000n, 1000000000n, 10000000000n, 100000000000n, 1000000000000n, 10000000000000n, 100000000000000n, 1000000000000000n];
const _M0FPC28internal7strconv5table = [1, 10, 100, 1000, 10000, 100000, 1000000, 10000000, 100000000, 1000000000, 10000000000, 100000000000, 1e+12, 1e+13, 1e+14, 1e+15, 1e+16, 1e+17, 1e+18, 1e+19, 1e+20, 1e+21, 1e+22, 0, 0, 0, 0, 0, 0, 0, 0, 0];
const _M0FPC28internal7strconv12checked__mulN6constrS1190 = 0n;
const _M0MPC14json12ParseContext16lex__number__endN7_2abindS1120 = ".";
const _M0MPC14json12ParseContext16lex__number__endN7_2abindS1121 = "e";
const _M0MPC14json12ParseContext16lex__number__endN7_2abindS1122 = "E";
const _M0FPC17strconv14base__err__str = "invalid base";
const _M0FPC17strconv15range__err__str = "value out of range";
const _M0FPC17strconv16syntax__err__str = "invalid syntax";
const _M0FPC17strconv20parse__int64_2einnerN7_2abindS538 = "";
const _M0FPC17strconv17min__19digit__int = 1000000000000000000n;
const _M0FPC17strconv17parse__scientificN8exp__numS249 = 0n;
const _M0FPC17strconv13parse__numberN11exp__numberS230 = 0n;
const _M0FPC17strconv12double__info = new _M0TPC17strconv9FloatInfo(52, 11, -1023);
const _M0FPC17strconv6powtab = [1, 3, 6, 9, 13, 16, 19, 23, 26, 29, 33, 36, 39, 43, 46, 49, 53, 56, 59];
const _M0FPC17strconv19left__shift__cheatsN5tupleS996 = { _0: 0, _1: "" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS997 = { _0: 1, _1: "5" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS998 = { _0: 1, _1: "25" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS999 = { _0: 1, _1: "125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1000 = { _0: 2, _1: "625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1001 = { _0: 2, _1: "3125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1002 = { _0: 2, _1: "15625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1003 = { _0: 3, _1: "78125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1004 = { _0: 3, _1: "390625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1005 = { _0: 3, _1: "1953125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1006 = { _0: 4, _1: "9765625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1007 = { _0: 4, _1: "48828125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1008 = { _0: 4, _1: "244140625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1009 = { _0: 4, _1: "1220703125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1010 = { _0: 5, _1: "6103515625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1011 = { _0: 5, _1: "30517578125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1012 = { _0: 5, _1: "152587890625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1013 = { _0: 6, _1: "762939453125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1014 = { _0: 6, _1: "3814697265625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1015 = { _0: 6, _1: "19073486328125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1016 = { _0: 7, _1: "95367431640625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1017 = { _0: 7, _1: "476837158203125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1018 = { _0: 7, _1: "2384185791015625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1019 = { _0: 7, _1: "11920928955078125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1020 = { _0: 8, _1: "59604644775390625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1021 = { _0: 8, _1: "298023223876953125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1022 = { _0: 8, _1: "1490116119384765625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1023 = { _0: 9, _1: "7450580596923828125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1024 = { _0: 9, _1: "37252902984619140625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1025 = { _0: 9, _1: "186264514923095703125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1026 = { _0: 10, _1: "931322574615478515625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1027 = { _0: 10, _1: "4656612873077392578125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1028 = { _0: 10, _1: "23283064365386962890625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1029 = { _0: 10, _1: "116415321826934814453125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1030 = { _0: 11, _1: "582076609134674072265625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1031 = { _0: 11, _1: "2910383045673370361328125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1032 = { _0: 11, _1: "14551915228366851806640625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1033 = { _0: 12, _1: "72759576141834259033203125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1034 = { _0: 12, _1: "363797880709171295166015625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1035 = { _0: 12, _1: "1818989403545856475830078125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1036 = { _0: 13, _1: "9094947017729282379150390625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1037 = { _0: 13, _1: "45474735088646411895751953125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1038 = { _0: 13, _1: "227373675443232059478759765625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1039 = { _0: 13, _1: "1136868377216160297393798828125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1040 = { _0: 14, _1: "5684341886080801486968994140625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1041 = { _0: 14, _1: "28421709430404007434844970703125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1042 = { _0: 14, _1: "142108547152020037174224853515625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1043 = { _0: 15, _1: "710542735760100185871124267578125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1044 = { _0: 15, _1: "3552713678800500929355621337890625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1045 = { _0: 15, _1: "17763568394002504646778106689453125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1046 = { _0: 16, _1: "88817841970012523233890533447265625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1047 = { _0: 16, _1: "444089209850062616169452667236328125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1048 = { _0: 16, _1: "2220446049250313080847263336181640625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1049 = { _0: 16, _1: "11102230246251565404236316680908203125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1050 = { _0: 17, _1: "55511151231257827021181583404541015625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1051 = { _0: 17, _1: "277555756156289135105907917022705078125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1052 = { _0: 17, _1: "1387778780781445675529539585113525390625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1053 = { _0: 18, _1: "6938893903907228377647697925567626953125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1054 = { _0: 18, _1: "34694469519536141888238489627838134765625" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1055 = { _0: 18, _1: "173472347597680709441192448139190673828125" };
const _M0FPC17strconv19left__shift__cheatsN5tupleS1056 = { _0: 19, _1: "867361737988403547205962240695953369140625" };
const _M0FPC17strconv19left__shift__cheats = [_M0FPC17strconv19left__shift__cheatsN5tupleS996, _M0FPC17strconv19left__shift__cheatsN5tupleS997, _M0FPC17strconv19left__shift__cheatsN5tupleS998, _M0FPC17strconv19left__shift__cheatsN5tupleS999, _M0FPC17strconv19left__shift__cheatsN5tupleS1000, _M0FPC17strconv19left__shift__cheatsN5tupleS1001, _M0FPC17strconv19left__shift__cheatsN5tupleS1002, _M0FPC17strconv19left__shift__cheatsN5tupleS1003, _M0FPC17strconv19left__shift__cheatsN5tupleS1004, _M0FPC17strconv19left__shift__cheatsN5tupleS1005, _M0FPC17strconv19left__shift__cheatsN5tupleS1006, _M0FPC17strconv19left__shift__cheatsN5tupleS1007, _M0FPC17strconv19left__shift__cheatsN5tupleS1008, _M0FPC17strconv19left__shift__cheatsN5tupleS1009, _M0FPC17strconv19left__shift__cheatsN5tupleS1010, _M0FPC17strconv19left__shift__cheatsN5tupleS1011, _M0FPC17strconv19left__shift__cheatsN5tupleS1012, _M0FPC17strconv19left__shift__cheatsN5tupleS1013, _M0FPC17strconv19left__shift__cheatsN5tupleS1014, _M0FPC17strconv19left__shift__cheatsN5tupleS1015, _M0FPC17strconv19left__shift__cheatsN5tupleS1016, _M0FPC17strconv19left__shift__cheatsN5tupleS1017, _M0FPC17strconv19left__shift__cheatsN5tupleS1018, _M0FPC17strconv19left__shift__cheatsN5tupleS1019, _M0FPC17strconv19left__shift__cheatsN5tupleS1020, _M0FPC17strconv19left__shift__cheatsN5tupleS1021, _M0FPC17strconv19left__shift__cheatsN5tupleS1022, _M0FPC17strconv19left__shift__cheatsN5tupleS1023, _M0FPC17strconv19left__shift__cheatsN5tupleS1024, _M0FPC17strconv19left__shift__cheatsN5tupleS1025, _M0FPC17strconv19left__shift__cheatsN5tupleS1026, _M0FPC17strconv19left__shift__cheatsN5tupleS1027, _M0FPC17strconv19left__shift__cheatsN5tupleS1028, _M0FPC17strconv19left__shift__cheatsN5tupleS1029, _M0FPC17strconv19left__shift__cheatsN5tupleS1030, _M0FPC17strconv19left__shift__cheatsN5tupleS1031, _M0FPC17strconv19left__shift__cheatsN5tupleS1032, _M0FPC17strconv19left__shift__cheatsN5tupleS1033, _M0FPC17strconv19left__shift__cheatsN5tupleS1034, _M0FPC17strconv19left__shift__cheatsN5tupleS1035, _M0FPC17strconv19left__shift__cheatsN5tupleS1036, _M0FPC17strconv19left__shift__cheatsN5tupleS1037, _M0FPC17strconv19left__shift__cheatsN5tupleS1038, _M0FPC17strconv19left__shift__cheatsN5tupleS1039, _M0FPC17strconv19left__shift__cheatsN5tupleS1040, _M0FPC17strconv19left__shift__cheatsN5tupleS1041, _M0FPC17strconv19left__shift__cheatsN5tupleS1042, _M0FPC17strconv19left__shift__cheatsN5tupleS1043, _M0FPC17strconv19left__shift__cheatsN5tupleS1044, _M0FPC17strconv19left__shift__cheatsN5tupleS1045, _M0FPC17strconv19left__shift__cheatsN5tupleS1046, _M0FPC17strconv19left__shift__cheatsN5tupleS1047, _M0FPC17strconv19left__shift__cheatsN5tupleS1048, _M0FPC17strconv19left__shift__cheatsN5tupleS1049, _M0FPC17strconv19left__shift__cheatsN5tupleS1050, _M0FPC17strconv19left__shift__cheatsN5tupleS1051, _M0FPC17strconv19left__shift__cheatsN5tupleS1052, _M0FPC17strconv19left__shift__cheatsN5tupleS1053, _M0FPC17strconv19left__shift__cheatsN5tupleS1054, _M0FPC17strconv19left__shift__cheatsN5tupleS1055, _M0FPC17strconv19left__shift__cheatsN5tupleS1056];
const _M0FPC17strconv10int__pow10 = [1n, 10n, 100n, 1000n, 10000n, 100000n, 1000000n, 10000000n, 100000000n, 1000000000n, 10000000000n, 100000000000n, 1000000000000n, 10000000000000n, 100000000000000n, 1000000000000000n];
const _M0FPC17strconv25max__exponent__fast__path = 22n;
const _M0FPC17strconv25max__mantissa__fast__path = 9007199254740992n;
const _M0FPC17strconv5table = [1, 10, 100, 1000, 10000, 100000, 1000000, 10000000, 100000000, 1000000000, 10000000000, 100000000000, 1e+12, 1e+13, 1e+14, 1e+15, 1e+16, 1e+17, 1e+18, 1e+19, 1e+20, 1e+21, 1e+22, 0, 0, 0, 0, 0, 0, 0, 0, 0];
const _M0FPC17strconv36max__exponent__disguised__fast__path = 37n;
const _M0FPC17strconv25min__exponent__fast__path = 18446744073709551594n;
const _M0FPC17strconv12checked__mulN6constrS1141 = 0n;
const _M0MP410Haoxincode8moonbash3lib3ast15ExecutionLimits7defaultN6recordS779 = new _M0TP410Haoxincode8moonbash3lib3ast15ExecutionLimits(100, 10000, 10000, 10485760, 100000, 10485760, 50, 100000, 10000, 10000, 10000);
const _M0FP29justjavac4glob11match__hereN7_2abindS38 = "**";
const _M0FP29justjavac4glob11match__hereN7_2abindS41 = "*";
const _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs3newN3nowS189 = 0n;
const _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs20ensure__parent__dirsN3nowS179 = 0n;
const _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs11write__fileN3nowS168 = 0n;
const _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs12append__fileN3nowS162 = 0n;
const _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs12append__fileN3nowS161 = 0n;
const _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs16mkdir__recursiveN3nowS128 = 0n;
const _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs13mkdir_2einnerN3nowS134 = 0n;
const _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10cp_2einnerN3nowS92 = 0n;
const _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10cp_2einnerN3nowS98 = 0n;
const _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs7symlinkN3nowS66 = 0n;
const _M0FP38bobzhang6moonjq3ast14base64__encodeN5charsS27 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
const _M0FP38bobzhang6moonjq3ast11uri__encodeN6digitsS47 = "0123456789ABCDEF";
const _M0FP38bobzhang6moonjq3ast15eval__with__envN7_2abindS3823 = "\"";
const _M0FP38bobzhang6moonjq3ast15eval__with__envN7_2abindS3824 = "\"";
const _M0FP38bobzhang6moonjq3ast15eval__with__envN7_2abindS3825 = "\"\"";
const _M0FP27gmlewis6base6416std__decode__map = new Uint8Array([255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 62, 255, 255, 255, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 255, 255, 255, 255, 255, 255, 255, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 255, 255, 255, 255, 255, 255, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]);
const _M0FP27gmlewis2io18err__short__buffer = new _M0DTPC15error5Error32gmlewis_2fio_2eIOError_2eIOError("short buffer");
const _M0FP27gmlewis2io3eof = new _M0DTPC15error5Error32gmlewis_2fio_2eIOError_2eIOError("eof");
const _M0FP27gmlewis2io20err__unexpected__eof = new _M0DTPC15error5Error32gmlewis_2fio_2eIOError_2eIOError("unexpected eof");
const _M0FP27gmlewis5flate14codegen__order = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
const _M0FP27gmlewis5flate13length__codes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 28];
const _M0FP27gmlewis5flate13offset__codes = [0, 1, 2, 3, 4, 4, 5, 5, 6, 6, 6, 6, 7, 7, 7, 7, 8, 8, 8, 8, 8, 8, 8, 8, 9, 9, 9, 9, 9, 9, 9, 9, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15];
const _M0FP27gmlewis5flate7rev8tab = [0, 128, 64, 192, 32, 160, 96, 224, 16, 144, 80, 208, 48, 176, 112, 240, 8, 136, 72, 200, 40, 168, 104, 232, 24, 152, 88, 216, 56, 184, 120, 248, 4, 132, 68, 196, 36, 164, 100, 228, 20, 148, 84, 212, 52, 180, 116, 244, 12, 140, 76, 204, 44, 172, 108, 236, 28, 156, 92, 220, 60, 188, 124, 252, 2, 130, 66, 194, 34, 162, 98, 226, 18, 146, 82, 210, 50, 178, 114, 242, 10, 138, 74, 202, 42, 170, 106, 234, 26, 154, 90, 218, 58, 186, 122, 250, 6, 134, 70, 198, 38, 166, 102, 230, 22, 150, 86, 214, 54, 182, 118, 246, 14, 142, 78, 206, 46, 174, 110, 238, 30, 158, 94, 222, 62, 190, 126, 254, 1, 129, 65, 193, 33, 161, 97, 225, 17, 145, 81, 209, 49, 177, 113, 241, 9, 137, 73, 201, 41, 169, 105, 233, 25, 153, 89, 217, 57, 185, 121, 249, 5, 133, 69, 197, 37, 165, 101, 229, 21, 149, 85, 213, 53, 181, 117, 245, 13, 141, 77, 205, 45, 173, 109, 237, 29, 157, 93, 221, 61, 189, 125, 253, 3, 131, 67, 195, 35, 163, 99, 227, 19, 147, 83, 211, 51, 179, 115, 243, 11, 139, 75, 203, 43, 171, 107, 235, 27, 155, 91, 219, 59, 187, 123, 251, 7, 135, 71, 199, 39, 167, 103, 231, 23, 151, 87, 215, 55, 183, 119, 247, 15, 143, 79, 207, 47, 175, 111, 239, 31, 159, 95, 223, 63, 191, 127, 255];
const _M0FP27gmlewis5flate12length__base = [0, 1, 2, 3, 4, 5, 6, 7, 8, 10, 12, 14, 16, 20, 24, 28, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 255];
const _M0FP27gmlewis5flate19length__extra__bits = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0];
const _M0FP27gmlewis5flate12offset__base = [0, 1, 2, 3, 4, 6, 8, 12, 16, 24, 32, 48, 64, 96, 128, 192, 256, 384, 512, 768, 1024, 1536, 2048, 3072, 4096, 6144, 8192, 12288, 16384, 24576];
const _M0FP27gmlewis5flate19offset__extra__bits = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13];
const _M0FP27gmlewis5flate12huff__offset = new _M0TP27gmlewis5flate14HuffmanEncoder([new _M0TP27gmlewis5flate5HCode(0, 1), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0), new _M0TP27gmlewis5flate5HCode(0, 0)], [], []);
const _M0FP27gmlewis5flate21writer__closed__error = new _M0DTPC15error5Error32gmlewis_2fio_2eIOError_2eIOError("writer closed");
const _M0FP27gmlewis5flate23fixed__huffman__decoder = new _M0TP27gmlewis5flate14HuffmanDecoder(7, [4103, 1288, 264, 4488, 4359, 1800, 776, 3081, 4231, 1544, 520, 2569, 8, 2056, 1032, 3593, 4167, 1416, 392, 2313, 4423, 1928, 904, 3337, 4295, 1672, 648, 2825, 136, 2184, 1160, 3849, 4135, 1352, 328, 4552, 4391, 1864, 840, 3209, 4263, 1608, 584, 2697, 72, 2120, 1096, 3721, 4199, 1480, 456, 2441, 4455, 1992, 968, 3465, 4327, 1736, 712, 2953, 200, 2248, 1224, 3977, 4119, 1320, 296, 4520, 4375, 1832, 808, 3145, 4247, 1576, 552, 2633, 40, 2088, 1064, 3657, 4183, 1448, 424, 2377, 4439, 1960, 936, 3401, 4311, 1704, 680, 2889, 168, 2216, 1192, 3913, 4151, 1384, 360, 4584, 4407, 1896, 872, 3273, 4279, 1640, 616, 2761, 104, 2152, 1128, 3785, 4215, 1512, 488, 2505, 4471, 2024, 1000, 3529, 4343, 1768, 744, 3017, 232, 2280, 1256, 4041, 4103, 1304, 280, 4504, 4359, 1816, 792, 3113, 4231, 1560, 536, 2601, 24, 2072, 1048, 3625, 4167, 1432, 408, 2345, 4423, 1944, 920, 3369, 4295, 1688, 664, 2857, 152, 2200, 1176, 3881, 4135, 1368, 344, 4568, 4391, 1880, 856, 3241, 4263, 1624, 600, 2729, 88, 2136, 1112, 3753, 4199, 1496, 472, 2473, 4455, 2008, 984, 3497, 4327, 1752, 728, 2985, 216, 2264, 1240, 4009, 4119, 1336, 312, 4536, 4375, 1848, 824, 3177, 4247, 1592, 568, 2665, 56, 2104, 1080, 3689, 4183, 1464, 440, 2409, 4439, 1976, 952, 3433, 4311, 1720, 696, 2921, 184, 2232, 1208, 3945, 4151, 1400, 376, 4600, 4407, 1912, 888, 3305, 4279, 1656, 632, 2793, 120, 2168, 1144, 3817, 4215, 1528, 504, 2537, 4471, 2040, 1016, 3561, 4343, 1784, 760, 3049, 248, 2296, 1272, 4073, 4103, 1288, 264, 4488, 4359, 1800, 776, 3097, 4231, 1544, 520, 2585, 8, 2056, 1032, 3609, 4167, 1416, 392, 2329, 4423, 1928, 904, 3353, 4295, 1672, 648, 2841, 136, 2184, 1160, 3865, 4135, 1352, 328, 4552, 4391, 1864, 840, 3225, 4263, 1608, 584, 2713, 72, 2120, 1096, 3737, 4199, 1480, 456, 2457, 4455, 1992, 968, 3481, 4327, 1736, 712, 2969, 200, 2248, 1224, 3993, 4119, 1320, 296, 4520, 4375, 1832, 808, 3161, 4247, 1576, 552, 2649, 40, 2088, 1064, 3673, 4183, 1448, 424, 2393, 4439, 1960, 936, 3417, 4311, 1704, 680, 2905, 168, 2216, 1192, 3929, 4151, 1384, 360, 4584, 4407, 1896, 872, 3289, 4279, 1640, 616, 2777, 104, 2152, 1128, 3801, 4215, 1512, 488, 2521, 4471, 2024, 1000, 3545, 4343, 1768, 744, 3033, 232, 2280, 1256, 4057, 4103, 1304, 280, 4504, 4359, 1816, 792, 3129, 4231, 1560, 536, 2617, 24, 2072, 1048, 3641, 4167, 1432, 408, 2361, 4423, 1944, 920, 3385, 4295, 1688, 664, 2873, 152, 2200, 1176, 3897, 4135, 1368, 344, 4568, 4391, 1880, 856, 3257, 4263, 1624, 600, 2745, 88, 2136, 1112, 3769, 4199, 1496, 472, 2489, 4455, 2008, 984, 3513, 4327, 1752, 728, 3001, 216, 2264, 1240, 4025, 4119, 1336, 312, 4536, 4375, 1848, 824, 3193, 4247, 1592, 568, 2681, 56, 2104, 1080, 3705, 4183, 1464, 440, 2425, 4439, 1976, 952, 3449, 4311, 1720, 696, 2937, 184, 2232, 1208, 3961, 4151, 1400, 376, 4600, 4407, 1912, 888, 3321, 4279, 1656, 632, 2809, 120, 2168, 1144, 3833, 4215, 1528, 504, 2553, 4471, 2040, 1016, 3577, 4343, 1784, 760, 3065, 248, 2296, 1272, 4089], [], 0);
const _M0FP27gmlewis5flate11code__order = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
const _M0FP27gmlewis5flate12stored__sizeN5tupleS1076 = { _0: 0, _1: false };
const _M0FP27gmlewis5flate12stored__sizeN5tupleS1077 = { _0: 0, _1: false };
const _M0FP27gmlewis5flate9max__nodeN6recordS1078 = new _M0TP27gmlewis5flate11LiteralNode(-1, 2147483647);
const _M0FP27gmlewis5crc325table = [0, 1996959894, -301047508, -1727442502, 124634137, 1886057615, -379345611, -1637575261, 249268274, 2044508324, -522852066, -1747789432, 162941995, 2125561021, -407360249, -1866523247, 498536548, 1789927666, -205950648, -2067906082, 450548861, 1843258603, -187386543, -2083289657, 325883990, 1684777152, -43845254, -1973040660, 335633487, 1661365465, -99664541, -1928851979, 997073096, 1281953886, -715111964, -1570279054, 1006888145, 1258607687, -770865667, -1526024853, 901097722, 1119000684, -608450090, -1396901568, 853044451, 1172266101, -589951537, -1412350631, 651767980, 1373503546, -925412992, -1076862698, 565507253, 1454621731, -809855591, -1195530993, 671266974, 1594198024, -972236366, -1324619484, 795835527, 1483230225, -1050600021, -1234817731, 1994146192, 31158534, -1731059524, -271249366, 1907459465, 112637215, -1614814043, -390540237, 2013776290, 251722036, -1777751922, -519137256, 2137656763, 141376813, -1855689577, -429695999, 1802195444, 476864866, -2056965928, -228458418, 1812370925, 453092731, -2113342271, -183516073, 1706088902, 314042704, -1950435094, -54949764, 1658658271, 366619977, -1932296973, -69972891, 1303535960, 984961486, -1547960204, -725929758, 1256170817, 1037604311, -1529756563, -740887301, 1131014506, 879679996, -1385723834, -631195440, 1141124467, 855842277, -1442165665, -586318647, 1342533948, 654459306, -1106571248, -921952122, 1466479909, 544179635, -1184443383, -832445281, 1591671054, 702138776, -1328506846, -942167884, 1504918807, 783551873, -1212326853, -1061524307, -306674912, -1698712650, 62317068, 1957810842, -355121351, -1647151185, 81470997, 1943803523, -480048366, -1805370492, 225274430, 2053790376, -468791541, -1828061283, 167816743, 2097651377, -267414716, -2029476910, 503444072, 1762050814, -144550051, -2140837941, 426522225, 1852507879, -19653770, -1982649376, 282753626, 1742555852, -105259153, -1900089351, 397917763, 1622183637, -690576408, -1580100738, 953729732, 1340076626, -776247311, -1497606297, 1068828381, 1219638859, -670225446, -1358292148, 906185462, 1090812512, -547295293, -1469587627, 829329135, 1181335161, -882789492, -1134132454, 628085408, 1382605366, -871598187, -1156888829, 570562233, 1426400815, -977650754, -1296233688, 733239954, 1555261956, -1026031705, -1244606671, 752459403, 1541320221, -1687895376, -328994266, 1969922972, 40735498, -1677130071, -351390145, 1913087877, 83908371, -1782625662, -491226604, 2075208622, 213261112, -1831694693, -438977011, 2094854071, 198958881, -2032938284, -237706686, 1759359992, 534414190, -2118248755, -155638181, 1873836001, 414664567, -2012718362, -15766928, 1711684554, 285281116, -1889165569, -127750551, 1634467795, 376229701, -1609899400, -686959890, 1308918612, 956543938, -1486412191, -799009033, 1231636301, 1047427035, -1362007478, -640263460, 1088359270, 936918000, -1447252397, -558129467, 1202900863, 817233897, -1111625188, -893730166, 1404277552, 615818150, -1160759803, -841546093, 1423857449, 601450431, -1285129682, -1000256840, 1567103746, 711928724, -1274298825, -1022587231, 1510334235, 755167117];
const _M0FP311moonbitlang1x4time11utc__offset = new _M0TP311moonbitlang1x4time10ZoneOffset("Z", "UTC", 0, false);
const _M0FP311moonbitlang1x4time20seconds__per__minute = 60n;
const _M0FP311moonbitlang1x4time21days__per__400__years = 146097n;
const _M0FP311moonbitlang1x4time18invalid__date__err = "Invalid date";
const _M0FP311moonbitlang1x4time18invalid__time__err = "Invalid time";
const _M0FP311moonbitlang1x4time17floor__div__int64N7_2abindS809 = "division by zero";
const _M0FP311moonbitlang1x4time24invalid__date__time__err = "Invalid date time";
const _M0FP311moonbitlang1x4time24nanoseconds__per__second = 1000000000n;
const _M0FP311moonbitlang1x4time12year__deltas = [0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 6, 6, 6, 6, 7, 7, 7, 7, 8, 8, 8, 8, 9, 9, 9, 9, 10, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 22, 22, 22, 22, 23, 23, 23, 23, 24, 24, 24, 24, 25, 25, 25, 25, 25, 25, 25, 25, 26, 26, 26, 26, 27, 27, 27, 27, 28, 28, 28, 28, 29, 29, 29, 29, 30, 30, 30, 30, 31, 31, 31, 31, 32, 32, 32, 32, 33, 33, 33, 33, 34, 34, 34, 34, 35, 35, 35, 35, 36, 36, 36, 36, 37, 37, 37, 37, 38, 38, 38, 38, 39, 39, 39, 39, 40, 40, 40, 40, 41, 41, 41, 41, 42, 42, 42, 42, 43, 43, 43, 43, 44, 44, 44, 44, 45, 45, 45, 45, 46, 46, 46, 46, 47, 47, 47, 47, 48, 48, 48, 48, 49, 49, 49, 49, 49, 49, 49, 49, 50, 50, 50, 50, 51, 51, 51, 51, 52, 52, 52, 52, 53, 53, 53, 53, 54, 54, 54, 54, 55, 55, 55, 55, 56, 56, 56, 56, 57, 57, 57, 57, 58, 58, 58, 58, 59, 59, 59, 59, 60, 60, 60, 60, 61, 61, 61, 61, 62, 62, 62, 62, 63, 63, 63, 63, 64, 64, 64, 64, 65, 65, 65, 65, 66, 66, 66, 66, 67, 67, 67, 67, 68, 68, 68, 68, 69, 69, 69, 69, 70, 70, 70, 70, 71, 71, 71, 71, 72, 72, 72, 72, 73, 73, 73, 73, 73, 73, 73, 73, 74, 74, 74, 74, 75, 75, 75, 75, 76, 76, 76, 76, 77, 77, 77, 77, 78, 78, 78, 78, 79, 79, 79, 79, 80, 80, 80, 80, 81, 81, 81, 81, 82, 82, 82, 82, 83, 83, 83, 83, 84, 84, 84, 84, 85, 85, 85, 85, 86, 86, 86, 86, 87, 87, 87, 87, 88, 88, 88, 88, 89, 89, 89, 89, 90, 90, 90, 90, 91, 91, 91, 91, 92, 92, 92, 92, 93, 93, 93, 93, 94, 94, 94, 94, 95, 95, 95, 95, 96, 96, 96, 96, 97, 97, 97, 97];
const _M0FP311moonbitlang1x4time18minutes__per__hour = 60n;
const _M0MP311moonbitlang1x4time7Weekday3newN6constrS1242 = 0;
const _M0MP311moonbitlang1x4time7Weekday3newN6constrS1243 = 1;
const _M0MP311moonbitlang1x4time7Weekday3newN6constrS1244 = 2;
const _M0MP311moonbitlang1x4time7Weekday3newN6constrS1245 = 3;
const _M0MP311moonbitlang1x4time7Weekday3newN6constrS1246 = 4;
const _M0MP311moonbitlang1x4time7Weekday3newN6constrS1247 = 5;
const _M0MP311moonbitlang1x4time7Weekday3newN6constrS1248 = 6;
const _M0FP27gmlewis4gzip13err__checksum = new _M0DTPC15error5Error32gmlewis_2fio_2eIOError_2eIOError("gzip: invalid checksum");
const _M0FP27gmlewis4gzip11err__header = new _M0DTPC15error5Error32gmlewis_2fio_2eIOError_2eIOError("gzip: invalid header");
const _M0MP219moonbit_2dcommunity4yaml5Lexer9scan__tagN7_2abindS1383 = "!";
const _M0MP219moonbit_2dcommunity4yaml5Lexer9scan__tagN7_2abindS1384 = "!";
const _M0MP219moonbit_2dcommunity4yaml6Parser12resolve__tagN7_2abindS1457 = "!";
const _M0MP219moonbit_2dcommunity4yaml6Parser12resolve__tagN7_2abindS1458 = "!";
const _M0FP218peter_2djerry_2dye11parse__args13parse_2einnerN7_2abindS95 = "-";
const _M0FP218peter_2djerry_2dye11parse__args13parse_2einnerN7_2abindS138 = "=";
const _M0FP214shu_2dkitamura6sha2561k = [1116352408, 1899447441, -1245643825, -373957723, 961987163, 1508970993, -1841331548, -1424204075, -670586216, 310598401, 607225278, 1426881987, 1925078388, -2132889090, -1680079193, -1046744716, -459576895, -272742522, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, -1740746414, -1473132947, -1341970488, -1084653625, -958395405, -710438585, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, -2117940946, -1838011259, -1564481375, -1474664885, -1035236496, -949202525, -778901479, -694614492, -200395387, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, -2067236844, -1933114872, -1866530822, -1538233109, -1090935817, -965641998];
const _M0FP410tonyfettes7unicode8internal4idna19idna__range__starts = [0, 45, 47, 48, 58, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 97, 123, 128, 160, 161, 168, 169, 170, 171, 173, 174, 175, 176, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 247, 248, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 308, 309, 310, 311, 313, 314, 315, 316, 317, 318, 319, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 384, 385, 386, 387, 388, 389, 390, 391, 392, 393, 394, 395, 396, 398, 399, 400, 401, 402, 403, 404, 405, 406, 407, 408, 409, 412, 413, 414, 415, 416, 417, 418, 419, 420, 421, 422, 423, 424, 425, 426, 428, 429, 430, 431, 432, 433, 434, 435, 436, 437, 438, 439, 440, 441, 444, 445, 452, 455, 458, 461, 462, 463, 464, 465, 466, 467, 468, 469, 470, 471, 472, 473, 474, 475, 476, 478, 479, 480, 481, 482, 483, 484, 485, 486, 487, 488, 489, 490, 491, 492, 493, 494, 495, 497, 500, 501, 502, 503, 504, 505, 506, 507, 508, 509, 510, 511, 512, 513, 514, 515, 516, 517, 518, 519, 520, 521, 522, 523, 524, 525, 526, 527, 528, 529, 530, 531, 532, 533, 534, 535, 536, 537, 538, 539, 540, 541, 542, 543, 544, 545, 546, 547, 548, 549, 550, 551, 552, 553, 554, 555, 556, 557, 558, 559, 560, 561, 562, 563, 564, 567, 570, 571, 572, 573, 574, 575, 577, 578, 579, 580, 581, 582, 583, 584, 585, 586, 587, 588, 589, 590, 591, 592, 681, 686, 688, 689, 690, 691, 692, 693, 694, 695, 696, 697, 706, 710, 722, 728, 729, 730, 731, 732, 733, 734, 735, 736, 737, 738, 739, 740, 741, 746, 748, 749, 750, 751, 768, 832, 833, 834, 835, 836, 837, 838, 847, 848, 856, 861, 864, 866, 867, 880, 881, 882, 883, 884, 885, 886, 887, 888, 890, 891, 894, 895, 896, 900, 901, 902, 903, 904, 905, 906, 907, 908, 909, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 930, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 962, 963, 975, 976, 977, 978, 979, 980, 981, 982, 983, 984, 985, 986, 987, 988, 989, 990, 991, 992, 993, 994, 995, 996, 997, 998, 999, 1000, 1001, 1002, 1003, 1004, 1005, 1006, 1007, 1008, 1009, 1010, 1011, 1012, 1013, 1014, 1015, 1016, 1017, 1018, 1019, 1020, 1021, 1022, 1023, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1104, 1105, 1117, 1118, 1120, 1121, 1122, 1123, 1124, 1125, 1126, 1127, 1128, 1129, 1130, 1131, 1132, 1133, 1134, 1135, 1136, 1137, 1138, 1139, 1140, 1141, 1142, 1143, 1144, 1145, 1146, 1147, 1148, 1149, 1150, 1151, 1152, 1153, 1154, 1155, 1159, 1160, 1162, 1163, 1164, 1165, 1166, 1167, 1168, 1169, 1170, 1171, 1172, 1173, 1174, 1175, 1176, 1177, 1178, 1179, 1180, 1181, 1182, 1183, 1184, 1185, 1186, 1187, 1188, 1189, 1190, 1191, 1192, 1193, 1194, 1195, 1196, 1197, 1198, 1199, 1200, 1201, 1202, 1203, 1204, 1205, 1206, 1207, 1208, 1209, 1210, 1211, 1212, 1213, 1214, 1215, 1216, 1217, 1218, 1219, 1220, 1221, 1222, 1223, 1224, 1225, 1226, 1227, 1228, 1229, 1230, 1231, 1232, 1233, 1234, 1235, 1236, 1237, 1238, 1239, 1240, 1241, 1242, 1243, 1244, 1245, 1246, 1247, 1248, 1249, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1257, 1258, 1259, 1260, 1261, 1262, 1263, 1264, 1265, 1266, 1267, 1268, 1269, 1270, 1271, 1272, 1273, 1274, 1275, 1276, 1277, 1278, 1279, 1280, 1281, 1282, 1283, 1284, 1285, 1286, 1287, 1288, 1289, 1290, 1291, 1292, 1293, 1294, 1295, 1296, 1297, 1298, 1299, 1300, 1301, 1302, 1303, 1304, 1305, 1306, 1307, 1308, 1309, 1310, 1311, 1312, 1313, 1314, 1315, 1316, 1317, 1318, 1319, 1320, 1321, 1322, 1323, 1324, 1325, 1326, 1327, 1328, 1329, 1330, 1331, 1332, 1333, 1334, 1335, 1336, 1337, 1338, 1339, 1340, 1341, 1342, 1343, 1344, 1345, 1346, 1347, 1348, 1349, 1350, 1351, 1352, 1353, 1354, 1355, 1356, 1357, 1358, 1359, 1360, 1361, 1362, 1363, 1364, 1365, 1366, 1367, 1369, 1370, 1376, 1377, 1415, 1416, 1417, 1418, 1419, 1421, 1423, 1424, 1425, 1442, 1443, 1456, 1466, 1467, 1470, 1471, 1472, 1473, 1475, 1476, 1477, 1478, 1479, 1480, 1488, 1515, 1519, 1520, 1525, 1536, 1540, 1541, 1542, 1547, 1548, 1549, 1552, 1558, 1563, 1564, 1565, 1566, 1567, 1568, 1569, 1595, 1600, 1601, 1619, 1622, 1625, 1631, 1632, 1642, 1646, 1648, 1653, 1654, 1655, 1656, 1657, 1720, 1722, 1727, 1728, 1743, 1744, 1748, 1749, 1757, 1758, 1759, 1769, 1770, 1774, 1776, 1786, 1791, 1792, 1806, 1807, 1808, 1837, 1840, 1867, 1869, 1872, 1902, 1920, 1969, 1970, 1984, 2038, 2043, 2045, 2046, 2048, 2094, 2096, 2111, 2112, 2140, 2142, 2143, 2144, 2155, 2160, 2184, 2185, 2191, 2192, 2194, 2199, 2200, 2208, 2209, 2210, 2221, 2227, 2229, 2230, 2238, 2248, 2259, 2260, 2274, 2275, 2276, 2303, 2304, 2305, 2308, 2309, 2362, 2364, 2382, 2383, 2384, 2389, 2390, 2392, 2393, 2394, 2395, 2396, 2397, 2398, 2399, 2400, 2404, 2406, 2416, 2417, 2419, 2424, 2425, 2427, 2429, 2430, 2432, 2433, 2436, 2437, 2445, 2447, 2449, 2451, 2473, 2474, 2481, 2482, 2483, 2486, 2490, 2492, 2493, 2494, 2501, 2503, 2505, 2507, 2510, 2511, 2519, 2520, 2524, 2525, 2526, 2527, 2528, 2532, 2534, 2546, 2555, 2556, 2557, 2558, 2559, 2561, 2562, 2563, 2564, 2565, 2571, 2575, 2577, 2579, 2601, 2602, 2609, 2610, 2611, 2612, 2613, 2614, 2615, 2616, 2618, 2620, 2621, 2622, 2627, 2631, 2633, 2635, 2638, 2641, 2642, 2649, 2650, 2651, 2652, 2653, 2654, 2655, 2662, 2677, 2678, 2679, 2689, 2692, 2693, 2700, 2701, 2702, 2703, 2706, 2707, 2729, 2730, 2737, 2738, 2740, 2741, 2746, 2748, 2758, 2759, 2762, 2763, 2766, 2768, 2769, 2784, 2785, 2788, 2790, 2800, 2801, 2802, 2809, 2810, 2816, 2817, 2820, 2821, 2829, 2831, 2833, 2835, 2857, 2858, 2865, 2866, 2868, 2869, 2870, 2874, 2876, 2884, 2885, 2887, 2889, 2891, 2894, 2901, 2902, 2904, 2908, 2909, 2910, 2911, 2914, 2916, 2918, 2928, 2929, 2930, 2936, 2946, 2948, 2949, 2955, 2958, 2961, 2962, 2966, 2969, 2971, 2972, 2973, 2974, 2976, 2979, 2981, 2984, 2987, 2990, 2998, 2999, 3002, 3006, 3011, 3014, 3017, 3018, 3022, 3024, 3025, 3031, 3032, 3046, 3047, 3056, 3059, 3067, 3072, 3073, 3076, 3077, 3085, 3086, 3089, 3090, 3113, 3114, 3124, 3125, 3130, 3132, 3133, 3134, 3141, 3142, 3145, 3146, 3150, 3157, 3159, 3160, 3162, 3163, 3165, 3166, 3168, 3170, 3172, 3174, 3184, 3191, 3192, 3200, 3201, 3202, 3204, 3205, 3213, 3214, 3217, 3218, 3241, 3242, 3252, 3253, 3258, 3260, 3262, 3269, 3270, 3273, 3274, 3278, 3285, 3287, 3293, 3294, 3295, 3296, 3298, 3300, 3302, 3312, 3313, 3315, 3316, 3328, 3329, 3330, 3332, 3333, 3341, 3342, 3345, 3346, 3369, 3370, 3386, 3387, 3389, 3390, 3396, 3397, 3398, 3401, 3402, 3406, 3407, 3408, 3412, 3415, 3416, 3423, 3424, 3426, 3428, 3430, 3440, 3446, 3449, 3450, 3456, 3457, 3458, 3460, 3461, 3479, 3482, 3506, 3507, 3516, 3517, 3518, 3520, 3527, 3530, 3531, 3535, 3541, 3542, 3543, 3544, 3552, 3558, 3568, 3570, 3572, 3573, 3585, 3635, 3636, 3643, 3647, 3648, 3663, 3664, 3674, 3676, 3713, 3715, 3716, 3717, 3718, 3719, 3721, 3722, 3723, 3724, 3725, 3726, 3732, 3736, 3737, 3744, 3745, 3748, 3749, 3750, 3751, 3752, 3754, 3756, 3757, 3763, 3764, 3770, 3771, 3774, 3776, 3781, 3782, 3783, 3784, 3790, 3791, 3792, 3802, 3804, 3805, 3806, 3808, 3840, 3841, 3851, 3852, 3853, 3864, 3866, 3872, 3882, 3893, 3894, 3895, 3896, 3897, 3898, 3902, 3907, 3908, 3912, 3913, 3917, 3918, 3922, 3923, 3927, 3928, 3932, 3933, 3945, 3946, 3947, 3949, 3953, 3955, 3956, 3957, 3958, 3959, 3960, 3961, 3962, 3969, 3970, 3973, 3974, 3980, 3984, 3987, 3988, 3990, 3991, 3992, 3993, 3997, 3998, 4002, 4003, 4007, 4008, 4012, 4013, 4014, 4017, 4024, 4025, 4026, 4029, 4030, 4038, 4039, 4045, 4046, 4047, 4048, 4050, 4053, 4057, 4059, 4096, 4130, 4131, 4136, 4137, 4139, 4140, 4147, 4150, 4154, 4160, 4170, 4176, 4186, 4250, 4254, 4256, 4257, 4258, 4259, 4260, 4261, 4262, 4263, 4264, 4265, 4266, 4267, 4268, 4269, 4270, 4271, 4272, 4273, 4274, 4275, 4276, 4277, 4278, 4279, 4280, 4281, 4282, 4283, 4284, 4285, 4286, 4287, 4288, 4289, 4290, 4291, 4292, 4293, 4294, 4295, 4296, 4301, 4302, 4304, 4343, 4345, 4347, 4348, 4349, 4352, 4442, 4447, 4449, 4515, 4520, 4602, 4608, 4615, 4616, 4679, 4680, 4681, 4682, 4686, 4688, 4695, 4696, 4697, 4698, 4702, 4704, 4743, 4744, 4745, 4746, 4750, 4752, 4783, 4784, 4785, 4786, 4790, 4792, 4799, 4800, 4801, 4802, 4806, 4808, 4815, 4816, 4823, 4824, 4847, 4848, 4879, 4880, 4881, 4882, 4886, 4888, 4895, 4896, 4935, 4936, 4955, 4957, 4959, 4960, 4961, 4989, 4992, 5008, 5018, 5024, 5109, 5110, 5112, 5113, 5114, 5115, 5116, 5117, 5118, 5120, 5121, 5741, 5743, 5751, 5760, 5761, 5787, 5789, 5792, 5867, 5873, 5881, 5888, 5901, 5902, 5909, 5910, 5919, 5920, 5941, 5943, 5952, 5972, 5984, 5997, 5998, 6001, 6002, 6004, 6016, 6068, 6070, 6100, 6103, 6104, 6108, 6109, 6110, 6112, 6122, 6128, 6138, 6144, 6155, 6159, 6160, 6170, 6176, 6264, 6265, 6272, 6314, 6315, 6320, 6390, 6400, 6429, 6431, 6432, 6444, 6448, 6460, 6464, 6465, 6468, 6470, 6510, 6512, 6517, 6528, 6570, 6572, 6576, 6602, 6608, 6618, 6619, 6622, 6624, 6656, 6684, 6686, 6688, 6751, 6752, 6781, 6783, 6794, 6800, 6810, 6816, 6823, 6824, 6830, 6832, 6846, 6847, 6849, 6863, 6912, 6988, 6989, 6990, 6992, 7002, 7019, 7028, 7037, 7039, 7040, 7083, 7086, 7098, 7104, 7156, 7164, 7168, 7224, 7227, 7232, 7242, 7245, 7294, 7296, 7297, 7298, 7299, 7300, 7302, 7303, 7304, 7305, 7306, 7307, 7312, 7313, 7314, 7315, 7316, 7317, 7318, 7319, 7320, 7321, 7322, 7323, 7324, 7325, 7326, 7327, 7328, 7329, 7330, 7331, 7332, 7333, 7334, 7335, 7336, 7337, 7338, 7339, 7340, 7341, 7342, 7343, 7344, 7345, 7346, 7347, 7348, 7349, 7350, 7351, 7352, 7353, 7354, 7355, 7357, 7358, 7359, 7360, 7368, 7376, 7379, 7380, 7411, 7415, 7416, 7418, 7419, 7424, 7468, 7469, 7470, 7471, 7472, 7473, 7474, 7475, 7476, 7477, 7478, 7479, 7480, 7481, 7482, 7483, 7484, 7485, 7486, 7487, 7488, 7489, 7490, 7491, 7492, 7493, 7494, 7495, 7496, 7497, 7498, 7499, 7500, 7501, 7502, 7503, 7504, 7505, 7506, 7507, 7508, 7509, 7510, 7511, 7512, 7513, 7514, 7515, 7516, 7517, 7518, 7519, 7520, 7521, 7522, 7523, 7524, 7525, 7526, 7527, 7528, 7529, 7530, 7531, 7532, 7544, 7545, 7579, 7580, 7581, 7582, 7583, 7584, 7585, 7586, 7587, 7588, 7589, 7590, 7591, 7592, 7593, 7594, 7595, 7596, 7597, 7598, 7599, 7600, 7601, 7602, 7603, 7604, 7605, 7606, 7607, 7608, 7609, 7610, 7611, 7612, 7613, 7614, 7615, 7616, 7620, 7627, 7655, 7670, 7674, 7675, 7676, 7677, 7678, 7680, 7681, 7682, 7683, 7684, 7685, 7686, 7687, 7688, 7689, 7690, 7691, 7692, 7693, 7694, 7695, 7696, 7697, 7698, 7699, 7700, 7701, 7702, 7703, 7704, 7705, 7706, 7707, 7708, 7709, 7710, 7711, 7712, 7713, 7714, 7715, 7716, 7717, 7718, 7719, 7720, 7721, 7722, 7723, 7724, 7725, 7726, 7727, 7728, 7729, 7730, 7731, 7732, 7733, 7734, 7735, 7736, 7737, 7738, 7739, 7740, 7741, 7742, 7743, 7744, 7745, 7746, 7747, 7748, 7749, 7750, 7751, 7752, 7753, 7754, 7755, 7756, 7757, 7758, 7759, 7760, 7761, 7762, 7763, 7764, 7765, 7766, 7767, 7768, 7769, 7770, 7771, 7772, 7773, 7774, 7775, 7776, 7777, 7778, 7779, 7780, 7781, 7782, 7783, 7784, 7785, 7786, 7787, 7788, 7789, 7790, 7791, 7792, 7793, 7794, 7795, 7796, 7797, 7798, 7799, 7800, 7801, 7802, 7803, 7804, 7805, 7806, 7807, 7808, 7809, 7810, 7811, 7812, 7813, 7814, 7815, 7816, 7817, 7818, 7819, 7820, 7821, 7822, 7823, 7824, 7825, 7826, 7827, 7828, 7829, 7834, 7835, 7836, 7838, 7839, 7840, 7841, 7842, 7843, 7844, 7845, 7846, 7847, 7848, 7849, 7850, 7851, 7852, 7853, 7854, 7855, 7856, 7857, 7858, 7859, 7860, 7861, 7862, 7863, 7864, 7865, 7866, 7867, 7868, 7869, 7870, 7871, 7872, 7873, 7874, 7875, 7876, 7877, 7878, 7879, 7880, 7881, 7882, 7883, 7884, 7885, 7886, 7887, 7888, 7889, 7890, 7891, 7892, 7893, 7894, 7895, 7896, 7897, 7898, 7899, 7900, 7901, 7902, 7903, 7904, 7905, 7906, 7907, 7908, 7909, 7910, 7911, 7912, 7913, 7914, 7915, 7916, 7917, 7918, 7919, 7920, 7921, 7922, 7923, 7924, 7925, 7926, 7927, 7928, 7929, 7930, 7931, 7932, 7933, 7934, 7935, 7936, 7944, 7945, 7946, 7947, 7948, 7949, 7950, 7951, 7952, 7958, 7960, 7961, 7962, 7963, 7964, 7965, 7966, 7968, 7976, 7977, 7978, 7979, 7980, 7981, 7982, 7983, 7984, 7992, 7993, 7994, 7995, 7996, 7997, 7998, 7999, 8000, 8006, 8008, 8009, 8010, 8011, 8012, 8013, 8014, 8016, 8024, 8025, 8026, 8027, 8028, 8029, 8030, 8031, 8032, 8040, 8041, 8042, 8043, 8044, 8045, 8046, 8047, 8048, 8049, 8050, 8051, 8052, 8053, 8054, 8055, 8056, 8057, 8058, 8059, 8060, 8061, 8062, 8064, 8065, 8066, 8067, 8068, 8069, 8070, 8071, 8072, 8073, 8074, 8075, 8076, 8077, 8078, 8079, 8080, 8081, 8082, 8083, 8084, 8085, 8086, 8087, 8088, 8089, 8090, 8091, 8092, 8093, 8094, 8095, 8096, 8097, 8098, 8099, 8100, 8101, 8102, 8103, 8104, 8105, 8106, 8107, 8108, 8109, 8110, 8111, 8112, 8114, 8115, 8116, 8117, 8118, 8119, 8120, 8121, 8122, 8123, 8124, 8125, 8126, 8127, 8128, 8129, 8130, 8131, 8132, 8133, 8134, 8135, 8136, 8137, 8138, 8139, 8140, 8141, 8142, 8143, 8144, 8147, 8148, 8150, 8152, 8153, 8154, 8155, 8156, 8157, 8158, 8159, 8160, 8163, 8164, 8168, 8169, 8170, 8171, 8172, 8173, 8174, 8175, 8176, 8178, 8179, 8180, 8181, 8182, 8183, 8184, 8185, 8186, 8187, 8188, 8189, 8190, 8191, 8192, 8203, 8204, 8206, 8208, 8209, 8210, 8215, 8216, 8228, 8231, 8232, 8239, 8240, 8243, 8244, 8245, 8246, 8247, 8248, 8252, 8253, 8254, 8255, 8263, 8264, 8265, 8266, 8270, 8275, 8277, 8279, 8280, 8287, 8288, 8292, 8293, 8294, 8298, 8304, 8305, 8306, 8308, 8309, 8310, 8311, 8312, 8313, 8314, 8315, 8316, 8317, 8318, 8319, 8320, 8321, 8322, 8323, 8324, 8325, 8326, 8327, 8328, 8329, 8330, 8331, 8332, 8333, 8334, 8335, 8336, 8337, 8338, 8339, 8340, 8341, 8342, 8343, 8344, 8345, 8346, 8347, 8348, 8349, 8352, 8360, 8361, 8363, 8364, 8365, 8368, 8370, 8374, 8377, 8378, 8379, 8382, 8383, 8384, 8385, 8400, 8418, 8420, 8427, 8428, 8432, 8433, 8448, 8449, 8450, 8451, 8452, 8453, 8454, 8455, 8456, 8457, 8458, 8459, 8463, 8464, 8466, 8468, 8469, 8470, 8471, 8473, 8474, 8475, 8478, 8480, 8481, 8482, 8483, 8484, 8485, 8486, 8487, 8488, 8489, 8490, 8491, 8492, 8493, 8494, 8495, 8497, 8498, 8499, 8500, 8501, 8502, 8503, 8504, 8505, 8506, 8507, 8508, 8509, 8511, 8512, 8513, 8517, 8519, 8520, 8521, 8522, 8524, 8525, 8526, 8527, 8528, 8529, 8530, 8531, 8532, 8533, 8534, 8535, 8536, 8537, 8538, 8539, 8540, 8541, 8542, 8543, 8544, 8545, 8546, 8547, 8548, 8549, 8550, 8551, 8552, 8553, 8554, 8555, 8556, 8557, 8558, 8559, 8560, 8561, 8562, 8563, 8564, 8565, 8566, 8567, 8568, 8569, 8570, 8571, 8572, 8573, 8574, 8575, 8576, 8579, 8580, 8581, 8585, 8586, 8588, 8592, 8683, 8692, 8704, 8748, 8749, 8750, 8751, 8752, 8753, 8946, 8960, 8961, 8962, 9001, 9002, 9003, 9083, 9084, 9085, 9115, 9167, 9169, 9180, 9192, 9193, 9204, 9211, 9215, 9216, 9253, 9255, 9258, 9280, 9291, 9312, 9313, 9314, 9315, 9316, 9317, 9318, 9319, 9320, 9321, 9322, 9323, 9324, 9325, 9326, 9327, 9328, 9329, 9330, 9331, 9332, 9333, 9334, 9335, 9336, 9337, 9338, 9339, 9340, 9341, 9342, 9343, 9344, 9345, 9346, 9347, 9348, 9349, 9350, 9351, 9352, 9372, 9373, 9374, 9375, 9376, 9377, 9378, 9379, 9380, 9381, 9382, 9383, 9384, 9385, 9386, 9387, 9388, 9389, 9390, 9391, 9392, 9393, 9394, 9395, 9396, 9397, 9398, 9399, 9400, 9401, 9402, 9403, 9404, 9405, 9406, 9407, 9408, 9409, 9410, 9411, 9412, 9413, 9414, 9415, 9416, 9417, 9418, 9419, 9420, 9421, 9422, 9423, 9424, 9425, 9426, 9427, 9428, 9429, 9430, 9431, 9432, 9433, 9434, 9435, 9436, 9437, 9438, 9439, 9440, 9441, 9442, 9443, 9444, 9445, 9446, 9447, 9448, 9449, 9450, 9451, 9471, 9472, 9622, 9632, 9712, 9720, 9728, 9748, 9750, 9752, 9753, 9754, 9840, 9842, 9854, 9856, 9866, 9874, 9885, 9886, 9888, 9890, 9906, 9907, 9917, 9920, 9924, 9934, 9935, 9954, 9955, 9956, 9960, 9984, 9985, 9989, 9990, 9994, 9996, 10024, 10025, 10060, 10061, 10062, 10063, 10067, 10070, 10071, 10072, 10079, 10081, 10088, 10102, 10133, 10136, 10160, 10161, 10175, 10176, 10183, 10187, 10188, 10189, 10190, 10192, 10220, 10224, 10240, 10496, 10764, 10765, 10868, 10869, 10870, 10871, 10972, 10973, 11008, 11022, 11028, 11035, 11040, 11044, 11085, 11088, 11093, 11098, 11124, 11126, 11158, 11159, 11160, 11194, 11197, 11209, 11210, 11218, 11219, 11244, 11248, 11263, 11264, 11265, 11266, 11267, 11268, 11269, 11270, 11271, 11272, 11273, 11274, 11275, 11276, 11277, 11278, 11279, 11280, 11281, 11282, 11283, 11284, 11285, 11286, 11287, 11288, 11289, 11290, 11291, 11292, 11293, 11294, 11295, 11296, 11297, 11298, 11299, 11300, 11301, 11302, 11303, 11304, 11305, 11306, 11307, 11308, 11309, 11310, 11311, 11312, 11359, 11360, 11361, 11362, 11363, 11364, 11365, 11367, 11368, 11369, 11370, 11371, 11372, 11373, 11374, 11375, 11376, 11377, 11378, 11379, 11380, 11381, 11382, 11384, 11388, 11389, 11390, 11391, 11392, 11393, 11394, 11395, 11396, 11397, 11398, 11399, 11400, 11401, 11402, 11403, 11404, 11405, 11406, 11407, 11408, 11409, 11410, 11411, 11412, 11413, 11414, 11415, 11416, 11417, 11418, 11419, 11420, 11421, 11422, 11423, 11424, 11425, 11426, 11427, 11428, 11429, 11430, 11431, 11432, 11433, 11434, 11435, 11436, 11437, 11438, 11439, 11440, 11441, 11442, 11443, 11444, 11445, 11446, 11447, 11448, 11449, 11450, 11451, 11452, 11453, 11454, 11455, 11456, 11457, 11458, 11459, 11460, 11461, 11462, 11463, 11464, 11465, 11466, 11467, 11468, 11469, 11470, 11471, 11472, 11473, 11474, 11475, 11476, 11477, 11478, 11479, 11480, 11481, 11482, 11483, 11484, 11485, 11486, 11487, 11488, 11489, 11490, 11491, 11493, 11499, 11500, 11501, 11502, 11506, 11507, 11508, 11513, 11520, 11558, 11559, 11560, 11565, 11566, 11568, 11622, 11624, 11631, 11632, 11633, 11647, 11648, 11671, 11680, 11687, 11688, 11695, 11696, 11703, 11704, 11711, 11712, 11719, 11720, 11727, 11728, 11735, 11736, 11743, 11744, 11776, 11800, 11804, 11806, 11823, 11824, 11825, 11826, 11836, 11843, 11845, 11850, 11855, 11856, 11859, 11870, 11904, 11930, 11931, 11935, 11936, 12019, 12020, 12032, 12033, 12034, 12035, 12036, 12037, 12038, 12039, 12040, 12041, 12042, 12043, 12044, 12045, 12046, 12047, 12048, 12049, 12050, 12051, 12052, 12053, 12054, 12055, 12056, 12057, 12058, 12059, 12060, 12061, 12062, 12063, 12064, 12065, 12066, 12067, 12068, 12069, 12070, 12071, 12072, 12073, 12074, 12075, 12076, 12077, 12078, 12079, 12080, 12081, 12082, 12083, 12084, 12085, 12086, 12087, 12088, 12089, 12090, 12091, 12092, 12093, 12094, 12095, 12096, 12097, 12098, 12099, 12100, 12101, 12102, 12103, 12104, 12105, 12106, 12107, 12108, 12109, 12110, 12111, 12112, 12113, 12114, 12115, 12116, 12117, 12118, 12119, 12120, 12121, 12122, 12123, 12124, 12125, 12126, 12127, 12128, 12129, 12130, 12131, 12132, 12133, 12134, 12135, 12136, 12137, 12138, 12139, 12140, 12141, 12142, 12143, 12144, 12145, 12146, 12147, 12148, 12149, 12150, 12151, 12152, 12153, 12154, 12155, 12156, 12157, 12158, 12159, 12160, 12161, 12162, 12163, 12164, 12165, 12166, 12167, 12168, 12169, 12170, 12171, 12172, 12173, 12174, 12175, 12176, 12177, 12178, 12179, 12180, 12181, 12182, 12183, 12184, 12185, 12186, 12187, 12188, 12189, 12190, 12191, 12192, 12193, 12194, 12195, 12196, 12197, 12198, 12199, 12200, 12201, 12202, 12203, 12204, 12205, 12206, 12207, 12208, 12209, 12210, 12211, 12212, 12213, 12214, 12215, 12216, 12217, 12218, 12219, 12220, 12221, 12222, 12223, 12224, 12225, 12226, 12227, 12228, 12229, 12230, 12231, 12232, 12233, 12234, 12235, 12236, 12237, 12238, 12239, 12240, 12241, 12242, 12243, 12244, 12245, 12246, 12272, 12284, 12288, 12289, 12290, 12291, 12293, 12296, 12330, 12334, 12342, 12343, 12344, 12345, 12346, 12347, 12348, 12349, 12350, 12351, 12352, 12353, 12437, 12439, 12441, 12443, 12444, 12445, 12447, 12448, 12449, 12543, 12544, 12549, 12589, 12590, 12591, 12592, 12593, 12594, 12595, 12596, 12597, 12598, 12599, 12600, 12601, 12602, 12603, 12604, 12605, 12606, 12607, 12608, 12609, 12610, 12611, 12612, 12613, 12614, 12615, 12616, 12617, 12618, 12619, 12620, 12621, 12622, 12623, 12624, 12625, 12626, 12627, 12628, 12629, 12630, 12631, 12632, 12633, 12634, 12635, 12636, 12637, 12638, 12639, 12640, 12641, 12642, 12643, 12644, 12645, 12646, 12647, 12648, 12649, 12650, 12651, 12652, 12653, 12654, 12655, 12656, 12657, 12658, 12659, 12660, 12661, 12662, 12663, 12664, 12665, 12666, 12667, 12668, 12669, 12670, 12671, 12672, 12673, 12674, 12675, 12676, 12677, 12678, 12679, 12680, 12681, 12682, 12683, 12684, 12685, 12686, 12687, 12688, 12690, 12691, 12692, 12693, 12694, 12695, 12696, 12697, 12698, 12699, 12700, 12701, 12702, 12703, 12704, 12728, 12731, 12736, 12752, 12772, 12774, 12783, 12784, 12800, 12801, 12802, 12803, 12804, 12805, 12806, 12807, 12808, 12809, 12810, 12811, 12812, 12813, 12814, 12815, 12816, 12817, 12818, 12819, 12820, 12821, 12822, 12823, 12824, 12825, 12826, 12827, 12828, 12829, 12830, 12831, 12832, 12833, 12834, 12835, 12836, 12837, 12838, 12839, 12840, 12841, 12842, 12843, 12844, 12845, 12846, 12847, 12848, 12849, 12850, 12851, 12852, 12853, 12854, 12855, 12856, 12857, 12858, 12859, 12860, 12861, 12862, 12863, 12864, 12865, 12866, 12867, 12868, 12869, 12870, 12871, 12872, 12880, 12881, 12882, 12883, 12884, 12885, 12886, 12887, 12888, 12889, 12890, 12891, 12892, 12893, 12894, 12895, 12896, 12897, 12898, 12899, 12900, 12901, 12902, 12903, 12904, 12905, 12906, 12907, 12908, 12909, 12910, 12911, 12912, 12913, 12914, 12915, 12916, 12917, 12918, 12919, 12920, 12921, 12922, 12923, 12924, 12925, 12926, 12927, 12928, 12929, 12930, 12931, 12932, 12933, 12934, 12935, 12936, 12937, 12938, 12939, 12940, 12941, 12942, 12943, 12944, 12945, 12946, 12947, 12948, 12949, 12950, 12951, 12952, 12953, 12954, 12955, 12956, 12957, 12958, 12959, 12960, 12961, 12962, 12963, 12964, 12965, 12966, 12967, 12968, 12969, 12970, 12971, 12972, 12973, 12974, 12975, 12976, 12977, 12978, 12979, 12980, 12981, 12982, 12983, 12984, 12985, 12986, 12987, 12988, 12989, 12990, 12991, 12992, 12993, 12994, 12995, 12996, 12997, 12998, 12999, 13000, 13001, 13002, 13003, 13004, 13005, 13006, 13007, 13008, 13009, 13010, 13011, 13012, 13013, 13014, 13015, 13016, 13017, 13018, 13019, 13020, 13021, 13022, 13023, 13024, 13025, 13026, 13027, 13028, 13029, 13030, 13031, 13032, 13033, 13034, 13035, 13036, 13037, 13038, 13039, 13040, 13041, 13042, 13043, 13044, 13045, 13046, 13047, 13048, 13049, 13050, 13051, 13052, 13053, 13054, 13055, 13056, 13057, 13058, 13059, 13060, 13061, 13062, 13063, 13064, 13065, 13066, 13067, 13068, 13069, 13070, 13071, 13072, 13073, 13074, 13075, 13076, 13077, 13078, 13079, 13080, 13081, 13082, 13083, 13084, 13085, 13086, 13087, 13088, 13089, 13090, 13091, 13092, 13093, 13094, 13095, 13096, 13097, 13098, 13099, 13100, 13101, 13102, 13103, 13104, 13105, 13106, 13107, 13108, 13109, 13110, 13111, 13112, 13113, 13114, 13115, 13116, 13117, 13118, 13119, 13120, 13121, 13122, 13123, 13124, 13125, 13126, 13127, 13128, 13129, 13130, 13131, 13132, 13133, 13134, 13135, 13136, 13137, 13138, 13139, 13140, 13141, 13142, 13143, 13144, 13145, 13146, 13147, 13148, 13149, 13150, 13151, 13152, 13153, 13154, 13155, 13156, 13157, 13158, 13159, 13160, 13161, 13162, 13163, 13164, 13165, 13166, 13167, 13168, 13169, 13170, 13171, 13172, 13173, 13174, 13175, 13176, 13177, 13178, 13179, 13180, 13181, 13182, 13183, 13184, 13185, 13186, 13187, 13188, 13189, 13190, 13191, 13192, 13193, 13194, 13195, 13196, 13197, 13198, 13199, 13200, 13201, 13202, 13203, 13204, 13205, 13206, 13207, 13208, 13209, 13210, 13211, 13212, 13213, 13214, 13215, 13216, 13217, 13218, 13219, 13220, 13221, 13222, 13223, 13224, 13225, 13226, 13227, 13228, 13229, 13230, 13231, 13232, 13233, 13234, 13235, 13236, 13237, 13238, 13239, 13240, 13241, 13242, 13243, 13244, 13245, 13246, 13247, 13248, 13249, 13250, 13251, 13252, 13253, 13254, 13255, 13256, 13257, 13258, 13259, 13260, 13261, 13262, 13263, 13264, 13265, 13266, 13267, 13268, 13269, 13270, 13271, 13272, 13273, 13274, 13275, 13276, 13277, 13278, 13279, 13280, 13281, 13282, 13283, 13284, 13285, 13286, 13287, 13288, 13289, 13290, 13291, 13292, 13293, 13294, 13295, 13296, 13297, 13298, 13299, 13300, 13301, 13302, 13303, 13304, 13305, 13306, 13307, 13308, 13309, 13310, 13311, 13312, 19894, 19904, 19968, 40870, 40892, 40900, 40908, 40909, 40918, 40939, 40944, 40957, 40960, 42125, 42128, 42146, 42148, 42164, 42165, 42177, 42178, 42181, 42182, 42183, 42192, 42238, 42240, 42509, 42512, 42540, 42560, 42561, 42562, 42563, 42564, 42565, 42566, 42567, 42568, 42569, 42570, 42571, 42572, 42573, 42574, 42575, 42576, 42577, 42578, 42579, 42580, 42581, 42582, 42583, 42584, 42585, 42586, 42587, 42588, 42589, 42590, 42591, 42592, 42593, 42594, 42595, 42596, 42597, 42598, 42599, 42600, 42601, 42602, 42603, 42604, 42605, 42608, 42612, 42620, 42622, 42623, 42624, 42625, 42626, 42627, 42628, 42629, 42630, 42631, 42632, 42633, 42634, 42635, 42636, 42637, 42638, 42639, 42640, 42641, 42642, 42643, 42644, 42645, 42646, 42647, 42648, 42649, 42650, 42651, 42652, 42653, 42654, 42655, 42656, 42726, 42736, 42738, 42744, 42752, 42775, 42779, 42784, 42786, 42787, 42788, 42789, 42790, 42791, 42792, 42793, 42794, 42795, 42796, 42797, 42798, 42799, 42802, 42803, 42804, 42805, 42806, 42807, 42808, 42809, 42810, 42811, 42812, 42813, 42814, 42815, 42816, 42817, 42818, 42819, 42820, 42821, 42822, 42823, 42824, 42825, 42826, 42827, 42828, 42829, 42830, 42831, 42832, 42833, 42834, 42835, 42836, 42837, 42838, 42839, 42840, 42841, 42842, 42843, 42844, 42845, 42846, 42847, 42848, 42849, 42850, 42851, 42852, 42853, 42854, 42855, 42856, 42857, 42858, 42859, 42860, 42861, 42862, 42863, 42864, 42865, 42873, 42874, 42875, 42876, 42877, 42878, 42879, 42880, 42881, 42882, 42883, 42884, 42885, 42886, 42887, 42889, 42891, 42892, 42893, 42894, 42895, 42896, 42897, 42898, 42899, 42900, 42902, 42903, 42904, 42905, 42906, 42907, 42908, 42909, 42910, 42911, 42912, 42913, 42914, 42915, 42916, 42917, 42918, 42919, 42920, 42921, 42922, 42923, 42924, 42925, 42926, 42927, 42928, 42929, 42930, 42931, 42932, 42933, 42934, 42935, 42936, 42937, 42938, 42939, 42940, 42941, 42942, 42943, 42944, 42945, 42946, 42947, 42948, 42949, 42950, 42951, 42952, 42953, 42954, 42955, 42956, 42957, 42958, 42960, 42961, 42962, 42963, 42964, 42965, 42966, 42967, 42968, 42969, 42970, 42971, 42972, 42973, 42994, 42995, 42996, 42997, 42998, 42999, 43000, 43001, 43002, 43003, 43008, 43048, 43052, 43053, 43056, 43066, 43072, 43124, 43128, 43136, 43205, 43206, 43214, 43216, 43226, 43232, 43256, 43259, 43260, 43261, 43262, 43264, 43310, 43312, 43348, 43359, 43360, 43389, 43392, 43457, 43470, 43471, 43482, 43486, 43488, 43519, 43520, 43575, 43584, 43598, 43600, 43610, 43612, 43616, 43639, 43642, 43644, 43648, 43715, 43739, 43742, 43744, 43760, 43762, 43767, 43777, 43783, 43785, 43791, 43793, 43799, 43808, 43815, 43816, 43823, 43824, 43867, 43868, 43869, 43870, 43871, 43872, 43876, 43878, 43880, 43881, 43882, 43884, 43888, 43889, 43890, 43891, 43892, 43893, 43894, 43895, 43896, 43897, 43898, 43899, 43900, 43901, 43902, 43903, 43904, 43905, 43906, 43907, 43908, 43909, 43910, 43911, 43912, 43913, 43914, 43915, 43916, 43917, 43918, 43919, 43920, 43921, 43922, 43923, 43924, 43925, 43926, 43927, 43928, 43929, 43930, 43931, 43932, 43933, 43934, 43935, 43936, 43937, 43938, 43939, 43940, 43941, 43942, 43943, 43944, 43945, 43946, 43947, 43948, 43949, 43950, 43951, 43952, 43953, 43954, 43955, 43956, 43957, 43958, 43959, 43960, 43961, 43962, 43963, 43964, 43965, 43966, 43967, 43968, 44011, 44012, 44014, 44016, 44026, 44032, 55204, 55216, 55239, 55243, 55292, 55296, 57344, 63744, 63745, 63746, 63747, 63748, 63749, 63750, 63751, 63753, 63754, 63755, 63756, 63757, 63758, 63759, 63760, 63761, 63762, 63763, 63764, 63765, 63766, 63767, 63768, 63769, 63770, 63771, 63772, 63773, 63774, 63775, 63776, 63777, 63778, 63779, 63780, 63781, 63782, 63783, 63784, 63785, 63786, 63787, 63788, 63789, 63790, 63791, 63792, 63793, 63794, 63795, 63796, 63797, 63798, 63799, 63800, 63801, 63802, 63803, 63804, 63805, 63806, 63807, 63808, 63809, 63810, 63811, 63812, 63813, 63814, 63815, 63816, 63817, 63818, 63819, 63820, 63821, 63822, 63823, 63824, 63825, 63826, 63827, 63828, 63829, 63830, 63831, 63832, 63833, 63834, 63835, 63836, 63837, 63838, 63839, 63840, 63841, 63842, 63843, 63844, 63845, 63846, 63847, 63848, 63849, 63850, 63851, 63852, 63853, 63854, 63855, 63856, 63857, 63858, 63859, 63860, 63861, 63862, 63863, 63864, 63865, 63866, 63867, 63868, 63869, 63870, 63871, 63872, 63873, 63874, 63875, 63876, 63877, 63878, 63879, 63880, 63881, 63882, 63883, 63884, 63885, 63886, 63887, 63888, 63889, 63890, 63891, 63892, 63893, 63894, 63895, 63896, 63897, 63898, 63899, 63900, 63901, 63902, 63903, 63904, 63905, 63906, 63907, 63908, 63909, 63910, 63911, 63912, 63913, 63914, 63915, 63916, 63917, 63918, 63919, 63920, 63921, 63922, 63923, 63924, 63925, 63926, 63927, 63928, 63929, 63930, 63931, 63932, 63933, 63934, 63935, 63936, 63937, 63938, 63939, 63940, 63941, 63942, 63943, 63944, 63945, 63946, 63947, 63948, 63949, 63950, 63951, 63952, 63953, 63954, 63955, 63956, 63957, 63958, 63959, 63960, 63961, 63962, 63963, 63964, 63965, 63966, 63967, 63968, 63969, 63970, 63971, 63972, 63973, 63974, 63975, 63976, 63977, 63978, 63979, 63980, 63981, 63982, 63983, 63984, 63985, 63986, 63987, 63988, 63989, 63990, 63991, 63992, 63993, 63994, 63995, 63996, 63997, 63998, 63999, 64000, 64001, 64002, 64003, 64004, 64005, 64006, 64007, 64008, 64009, 64010, 64011, 64012, 64013, 64014, 64016, 64017, 64018, 64019, 64021, 64022, 64023, 64024, 64025, 64026, 64027, 64028, 64029, 64030, 64031, 64032, 64033, 64034, 64035, 64037, 64038, 64039, 64042, 64043, 64044, 64045, 64046, 64047, 64048, 64049, 64050, 64051, 64052, 64053, 64054, 64055, 64056, 64057, 64058, 64059, 64060, 64061, 64062, 64063, 64064, 64065, 64066, 64067, 64068, 64069, 64070, 64071, 64072, 64073, 64074, 64075, 64076, 64077, 64078, 64079, 64080, 64081, 64082, 64083, 64084, 64085, 64086, 64087, 64088, 64089, 64090, 64091, 64092, 64093, 64095, 64096, 64097, 64098, 64099, 64100, 64101, 64102, 64103, 64104, 64105, 64106, 64107, 64108, 64109, 64110, 64112, 64113, 64114, 64115, 64116, 64117, 64118, 64119, 64120, 64121, 64122, 64123, 64124, 64125, 64126, 64127, 64128, 64129, 64130, 64131, 64132, 64133, 64134, 64135, 64136, 64137, 64138, 64139, 64140, 64141, 64142, 64143, 64144, 64145, 64146, 64147, 64148, 64149, 64150, 64151, 64152, 64153, 64154, 64155, 64156, 64157, 64158, 64159, 64160, 64161, 64162, 64163, 64164, 64165, 64166, 64167, 64168, 64169, 64170, 64171, 64172, 64173, 64174, 64175, 64176, 64177, 64178, 64179, 64180, 64181, 64182, 64183, 64184, 64185, 64186, 64187, 64188, 64189, 64190, 64191, 64192, 64193, 64194, 64195, 64196, 64197, 64198, 64199, 64200, 64201, 64202, 64203, 64204, 64205, 64206, 64207, 64208, 64209, 64210, 64211, 64212, 64213, 64214, 64215, 64216, 64217, 64218, 64256, 64257, 64258, 64259, 64260, 64261, 64263, 64275, 64276, 64277, 64278, 64279, 64280, 64285, 64286, 64287, 64288, 64289, 64290, 64291, 64292, 64293, 64294, 64295, 64296, 64297, 64298, 64299, 64300, 64301, 64302, 64303, 64304, 64305, 64306, 64307, 64308, 64309, 64310, 64311, 64312, 64313, 64314, 64315, 64316, 64317, 64318, 64319, 64320, 64321, 64322, 64323, 64324, 64325, 64326, 64327, 64328, 64329, 64330, 64331, 64332, 64333, 64334, 64335, 64336, 64338, 64342, 64346, 64350, 64354, 64358, 64362, 64366, 64370, 64374, 64378, 64382, 64386, 64388, 64390, 64392, 64394, 64396, 64398, 64402, 64406, 64410, 64414, 64416, 64420, 64422, 64426, 64430, 64432, 64434, 64450, 64451, 64467, 64471, 64473, 64475, 64477, 64478, 64480, 64482, 64484, 64488, 64490, 64492, 64494, 64496, 64498, 64500, 64502, 64505, 64508, 64512, 64513, 64514, 64515, 64516, 64517, 64518, 64519, 64520, 64521, 64522, 64523, 64524, 64525, 64526, 64527, 64528, 64529, 64530, 64531, 64532, 64533, 64534, 64535, 64536, 64537, 64538, 64539, 64540, 64541, 64542, 64543, 64544, 64545, 64546, 64547, 64548, 64549, 64550, 64551, 64552, 64553, 64554, 64555, 64556, 64557, 64558, 64559, 64560, 64561, 64562, 64563, 64564, 64565, 64566, 64567, 64568, 64569, 64570, 64571, 64572, 64573, 64574, 64575, 64576, 64577, 64578, 64579, 64580, 64581, 64582, 64583, 64584, 64585, 64586, 64587, 64588, 64589, 64590, 64591, 64592, 64593, 64594, 64595, 64596, 64597, 64598, 64599, 64600, 64601, 64602, 64603, 64604, 64605, 64606, 64607, 64608, 64609, 64610, 64611, 64612, 64613, 64614, 64615, 64616, 64617, 64618, 64619, 64620, 64621, 64622, 64623, 64624, 64625, 64626, 64627, 64628, 64629, 64630, 64631, 64632, 64633, 64634, 64635, 64636, 64637, 64638, 64639, 64640, 64641, 64642, 64643, 64644, 64645, 64646, 64647, 64648, 64649, 64650, 64651, 64652, 64653, 64654, 64655, 64656, 64657, 64658, 64659, 64660, 64661, 64662, 64663, 64664, 64665, 64666, 64667, 64668, 64669, 64670, 64671, 64672, 64673, 64674, 64675, 64676, 64677, 64678, 64679, 64680, 64681, 64682, 64683, 64684, 64685, 64686, 64687, 64688, 64689, 64690, 64691, 64692, 64693, 64694, 64695, 64696, 64697, 64698, 64699, 64700, 64701, 64702, 64703, 64704, 64705, 64706, 64707, 64708, 64709, 64710, 64711, 64712, 64713, 64714, 64715, 64716, 64717, 64718, 64719, 64720, 64721, 64722, 64723, 64724, 64725, 64726, 64727, 64728, 64729, 64730, 64731, 64732, 64733, 64734, 64735, 64736, 64737, 64738, 64739, 64740, 64741, 64742, 64743, 64744, 64745, 64746, 64747, 64748, 64749, 64750, 64751, 64752, 64753, 64754, 64755, 64756, 64757, 64758, 64759, 64760, 64761, 64762, 64763, 64764, 64765, 64766, 64767, 64768, 64769, 64770, 64771, 64772, 64773, 64774, 64775, 64776, 64777, 64778, 64779, 64780, 64781, 64782, 64783, 64784, 64785, 64786, 64787, 64788, 64789, 64790, 64791, 64792, 64793, 64794, 64795, 64796, 64797, 64798, 64799, 64800, 64801, 64802, 64803, 64804, 64805, 64806, 64807, 64808, 64809, 64810, 64811, 64812, 64813, 64814, 64815, 64816, 64817, 64818, 64819, 64820, 64821, 64822, 64823, 64824, 64825, 64826, 64827, 64828, 64830, 64832, 64848, 64849, 64851, 64852, 64853, 64854, 64855, 64856, 64858, 64859, 64860, 64861, 64862, 64863, 64865, 64866, 64868, 64870, 64871, 64873, 64874, 64876, 64878, 64879, 64881, 64883, 64884, 64885, 64886, 64888, 64889, 64890, 64891, 64892, 64894, 64895, 64896, 64897, 64898, 64899, 64901, 64903, 64905, 64906, 64907, 64908, 64909, 64910, 64911, 64912, 64914, 64915, 64916, 64917, 64918, 64919, 64921, 64922, 64923, 64924, 64926, 64927, 64928, 64929, 64930, 64931, 64932, 64933, 64934, 64935, 64936, 64937, 64938, 64939, 64940, 64941, 64942, 64943, 64944, 64945, 64946, 64947, 64948, 64949, 64950, 64951, 64952, 64953, 64954, 64955, 64956, 64957, 64958, 64959, 64960, 64961, 64962, 64963, 64964, 64965, 64966, 64967, 64968, 64975, 64976, 65008, 65009, 65010, 65011, 65012, 65013, 65014, 65015, 65016, 65017, 65018, 65019, 65020, 65021, 65022, 65024, 65040, 65041, 65042, 65043, 65044, 65045, 65046, 65047, 65048, 65049, 65050, 65056, 65060, 65063, 65070, 65072, 65073, 65074, 65075, 65077, 65078, 65079, 65080, 65081, 65082, 65083, 65084, 65085, 65086, 65087, 65088, 65089, 65090, 65091, 65092, 65093, 65095, 65096, 65097, 65101, 65104, 65105, 65106, 65107, 65108, 65109, 65110, 65111, 65112, 65113, 65114, 65115, 65116, 65117, 65118, 65119, 65120, 65121, 65122, 65123, 65124, 65125, 65126, 65127, 65128, 65129, 65130, 65131, 65132, 65136, 65137, 65138, 65139, 65140, 65141, 65142, 65143, 65144, 65145, 65146, 65147, 65148, 65149, 65150, 65151, 65152, 65153, 65155, 65157, 65159, 65161, 65165, 65167, 65171, 65173, 65177, 65181, 65185, 65189, 65193, 65195, 65197, 65199, 65201, 65205, 65209, 65213, 65217, 65221, 65225, 65229, 65233, 65237, 65241, 65245, 65249, 65253, 65257, 65261, 65263, 65265, 65269, 65271, 65273, 65275, 65277, 65279, 65280, 65281, 65282, 65283, 65284, 65285, 65286, 65287, 65288, 65289, 65290, 65291, 65292, 65293, 65294, 65295, 65296, 65297, 65298, 65299, 65300, 65301, 65302, 65303, 65304, 65305, 65306, 65307, 65308, 65309, 65310, 65311, 65312, 65313, 65314, 65315, 65316, 65317, 65318, 65319, 65320, 65321, 65322, 65323, 65324, 65325, 65326, 65327, 65328, 65329, 65330, 65331, 65332, 65333, 65334, 65335, 65336, 65337, 65338, 65339, 65340, 65341, 65342, 65343, 65344, 65345, 65346, 65347, 65348, 65349, 65350, 65351, 65352, 65353, 65354, 65355, 65356, 65357, 65358, 65359, 65360, 65361, 65362, 65363, 65364, 65365, 65366, 65367, 65368, 65369, 65370, 65371, 65372, 65373, 65374, 65375, 65376, 65377, 65378, 65379, 65380, 65381, 65382, 65383, 65384, 65385, 65386, 65387, 65388, 65389, 65390, 65391, 65392, 65393, 65394, 65395, 65396, 65397, 65398, 65399, 65400, 65401, 65402, 65403, 65404, 65405, 65406, 65407, 65408, 65409, 65410, 65411, 65412, 65413, 65414, 65415, 65416, 65417, 65418, 65419, 65420, 65421, 65422, 65423, 65424, 65425, 65426, 65427, 65428, 65429, 65430, 65431, 65432, 65433, 65434, 65435, 65436, 65437, 65438, 65439, 65440, 65441, 65442, 65443, 65444, 65445, 65446, 65447, 65448, 65449, 65450, 65451, 65452, 65453, 65454, 65455, 65456, 65457, 65458, 65459, 65460, 65461, 65462, 65463, 65464, 65465, 65466, 65467, 65468, 65469, 65470, 65471, 65474, 65475, 65476, 65477, 65478, 65479, 65480, 65482, 65483, 65484, 65485, 65486, 65487, 65488, 65490, 65491, 65492, 65493, 65494, 65495, 65496, 65498, 65499, 65500, 65501, 65504, 65505, 65506, 65507, 65508, 65509, 65510, 65511, 65512, 65513, 65514, 65515, 65516, 65517, 65518, 65519, 65529, 65532, 65533, 65534, 65536, 65548, 65549, 65575, 65576, 65595, 65596, 65598, 65599, 65614, 65616, 65630, 65664, 65787, 65792, 65795, 65799, 65844, 65847, 65856, 65931, 65933, 65935, 65936, 65948, 65949, 65952, 65953, 66000, 66045, 66046, 66176, 66205, 66208, 66257, 66272, 66273, 66300, 66304, 66335, 66336, 66340, 66349, 66352, 66369, 66370, 66378, 66379, 66384, 66427, 66432, 66462, 66463, 66464, 66500, 66504, 66512, 66518, 66560, 66561, 66562, 66563, 66564, 66565, 66566, 66567, 66568, 66569, 66570, 66571, 66572, 66573, 66574, 66575, 66576, 66577, 66578, 66579, 66580, 66581, 66582, 66583, 66584, 66585, 66586, 66587, 66588, 66589, 66590, 66591, 66592, 66593, 66594, 66595, 66596, 66597, 66598, 66599, 66600, 66638, 66718, 66720, 66730, 66736, 66737, 66738, 66739, 66740, 66741, 66742, 66743, 66744, 66745, 66746, 66747, 66748, 66749, 66750, 66751, 66752, 66753, 66754, 66755, 66756, 66757, 66758, 66759, 66760, 66761, 66762, 66763, 66764, 66765, 66766, 66767, 66768, 66769, 66770, 66771, 66772, 66776, 66812, 66816, 66856, 66864, 66916, 66927, 66928, 66929, 66930, 66931, 66932, 66933, 66934, 66935, 66936, 66937, 66938, 66939, 66940, 66941, 66942, 66943, 66944, 66945, 66946, 66947, 66948, 66949, 66950, 66951, 66952, 66953, 66954, 66955, 66956, 66957, 66958, 66959, 66960, 66961, 66962, 66963, 66964, 66965, 66966, 66967, 66978, 66979, 66994, 66995, 67002, 67003, 67005, 67008, 67060, 67072, 67383, 67392, 67414, 67424, 67432, 67456, 67457, 67458, 67459, 67460, 67461, 67462, 67463, 67464, 67465, 67466, 67467, 67468, 67469, 67470, 67471, 67472, 67473, 67474, 67475, 67476, 67477, 67478, 67479, 67480, 67481, 67482, 67483, 67484, 67485, 67486, 67487, 67488, 67489, 67490, 67491, 67492, 67493, 67494, 67495, 67496, 67497, 67498, 67499, 67500, 67501, 67502, 67503, 67504, 67505, 67506, 67507, 67508, 67509, 67510, 67511, 67512, 67513, 67514, 67515, 67584, 67590, 67592, 67593, 67594, 67638, 67639, 67641, 67644, 67645, 67647, 67648, 67670, 67671, 67680, 67703, 67712, 67743, 67751, 67760, 67808, 67827, 67828, 67830, 67835, 67840, 67862, 67866, 67868, 67871, 67872, 67898, 67903, 67904, 67968, 68024, 68028, 68030, 68032, 68048, 68050, 68096, 68100, 68101, 68103, 68108, 68116, 68117, 68120, 68121, 68148, 68150, 68152, 68155, 68159, 68160, 68168, 68169, 68176, 68185, 68192, 68221, 68224, 68253, 68256, 68288, 68296, 68297, 68327, 68331, 68343, 68352, 68406, 68409, 68416, 68438, 68440, 68448, 68467, 68472, 68480, 68498, 68505, 68509, 68521, 68528, 68608, 68681, 68736, 68737, 68738, 68739, 68740, 68741, 68742, 68743, 68744, 68745, 68746, 68747, 68748, 68749, 68750, 68751, 68752, 68753, 68754, 68755, 68756, 68757, 68758, 68759, 68760, 68761, 68762, 68763, 68764, 68765, 68766, 68767, 68768, 68769, 68770, 68771, 68772, 68773, 68774, 68775, 68776, 68777, 68778, 68779, 68780, 68781, 68782, 68783, 68784, 68785, 68786, 68787, 68800, 68851, 68858, 68864, 68904, 68912, 68922, 68928, 68944, 68945, 68946, 68947, 68948, 68949, 68950, 68951, 68952, 68953, 68954, 68955, 68956, 68957, 68958, 68959, 68960, 68961, 68962, 68963, 68964, 68965, 68966, 68969, 68974, 68975, 68998, 69006, 69008, 69216, 69247, 69248, 69290, 69291, 69293, 69294, 69296, 69298, 69314, 69317, 69372, 69373, 69376, 69405, 69415, 69416, 69424, 69457, 69466, 69488, 69510, 69514, 69552, 69573, 69580, 69600, 69623, 69632, 69703, 69710, 69714, 69734, 69744, 69750, 69759, 69760, 69819, 69821, 69822, 69826, 69827, 69837, 69838, 69840, 69865, 69872, 69882, 69888, 69941, 69942, 69952, 69956, 69959, 69960, 69968, 70004, 70006, 70007, 70016, 70085, 70089, 70093, 70094, 70096, 70106, 70107, 70108, 70109, 70112, 70113, 70133, 70144, 70162, 70163, 70200, 70206, 70207, 70210, 70272, 70279, 70280, 70281, 70282, 70286, 70287, 70302, 70303, 70313, 70314, 70320, 70379, 70384, 70394, 70400, 70401, 70404, 70405, 70413, 70415, 70417, 70419, 70441, 70442, 70449, 70450, 70452, 70453, 70458, 70459, 70460, 70469, 70471, 70473, 70475, 70478, 70480, 70481, 70487, 70488, 70493, 70500, 70502, 70509, 70512, 70517, 70528, 70538, 70539, 70540, 70542, 70543, 70544, 70582, 70583, 70593, 70594, 70595, 70597, 70598, 70599, 70603, 70604, 70612, 70614, 70615, 70617, 70625, 70627, 70656, 70731, 70736, 70746, 70747, 70748, 70749, 70750, 70751, 70752, 70754, 70784, 70854, 70855, 70856, 70864, 70874, 71040, 71094, 71096, 71105, 71114, 71128, 71134, 71168, 71233, 71236, 71237, 71248, 71258, 71264, 71277, 71296, 71352, 71353, 71354, 71360, 71370, 71376, 71396, 71424, 71450, 71451, 71453, 71468, 71472, 71482, 71488, 71495, 71680, 71739, 71740, 71840, 71841, 71842, 71843, 71844, 71845, 71846, 71847, 71848, 71849, 71850, 71851, 71852, 71853, 71854, 71855, 71856, 71857, 71858, 71859, 71860, 71861, 71862, 71863, 71864, 71865, 71866, 71867, 71868, 71869, 71870, 71871, 71872, 71914, 71923, 71935, 71936, 71943, 71945, 71946, 71948, 71956, 71957, 71959, 71960, 71990, 71991, 71993, 71995, 72004, 72007, 72016, 72026, 72096, 72104, 72106, 72152, 72154, 72162, 72163, 72165, 72192, 72255, 72263, 72264, 72272, 72324, 72326, 72346, 72349, 72350, 72355, 72368, 72384, 72441, 72448, 72458, 72640, 72673, 72674, 72688, 72698, 72704, 72713, 72714, 72759, 72760, 72769, 72774, 72784, 72794, 72813, 72816, 72818, 72848, 72850, 72872, 72873, 72887, 72960, 72967, 72968, 72970, 72971, 73015, 73018, 73019, 73020, 73022, 73023, 73032, 73040, 73050, 73056, 73062, 73063, 73065, 73066, 73103, 73104, 73106, 73107, 73113, 73120, 73130, 73440, 73463, 73465, 73472, 73489, 73490, 73531, 73534, 73539, 73552, 73562, 73563, 73648, 73649, 73664, 73714, 73727, 73728, 74607, 74649, 74650, 74752, 74851, 74863, 74864, 74868, 74869, 74880, 75076, 77712, 77809, 77811, 77824, 78895, 78896, 78905, 78912, 78934, 78944, 82939, 82944, 83527, 90368, 90426, 92160, 92729, 92736, 92767, 92768, 92778, 92782, 92784, 92863, 92864, 92874, 92880, 92910, 92912, 92917, 92918, 92928, 92983, 92992, 92996, 92998, 93008, 93018, 93019, 93026, 93027, 93048, 93053, 93072, 93504, 93549, 93552, 93562, 93760, 93761, 93762, 93763, 93764, 93765, 93766, 93767, 93768, 93769, 93770, 93771, 93772, 93773, 93774, 93775, 93776, 93777, 93778, 93779, 93780, 93781, 93782, 93783, 93784, 93785, 93786, 93787, 93788, 93789, 93790, 93791, 93792, 93824, 93851, 93952, 94021, 94027, 94031, 94032, 94079, 94088, 94095, 94112, 94176, 94177, 94178, 94179, 94180, 94181, 94192, 94194, 94208, 100333, 100338, 100344, 100352, 101107, 101590, 101631, 101632, 101641, 110576, 110580, 110581, 110588, 110589, 110591, 110592, 110594, 110879, 110883, 110898, 110899, 110928, 110931, 110933, 110934, 110948, 110952, 110960, 111356, 113664, 113771, 113776, 113789, 113792, 113801, 113808, 113818, 113820, 113821, 113823, 113824, 113828, 117760, 117974, 117975, 117976, 117977, 117978, 117979, 117980, 117981, 117982, 117983, 117984, 117985, 117986, 117987, 117988, 117989, 117990, 117991, 117992, 117993, 117994, 117995, 117996, 117997, 117998, 117999, 118000, 118001, 118002, 118003, 118004, 118005, 118006, 118007, 118008, 118009, 118010, 118016, 118452, 118528, 118574, 118576, 118599, 118608, 118724, 118784, 119030, 119040, 119079, 119081, 119082, 119134, 119135, 119136, 119137, 119138, 119139, 119140, 119141, 119155, 119163, 119227, 119228, 119229, 119230, 119231, 119232, 119233, 119262, 119273, 119275, 119296, 119366, 119488, 119508, 119520, 119540, 119552, 119639, 119648, 119666, 119673, 119808, 119809, 119810, 119811, 119812, 119813, 119814, 119815, 119816, 119817, 119818, 119819, 119820, 119821, 119822, 119823, 119824, 119825, 119826, 119827, 119828, 119829, 119830, 119831, 119832, 119833, 119834, 119835, 119836, 119837, 119838, 119839, 119840, 119841, 119842, 119843, 119844, 119845, 119846, 119847, 119848, 119849, 119850, 119851, 119852, 119853, 119854, 119855, 119856, 119857, 119858, 119859, 119860, 119861, 119862, 119863, 119864, 119865, 119866, 119867, 119868, 119869, 119870, 119871, 119872, 119873, 119874, 119875, 119876, 119877, 119878, 119879, 119880, 119881, 119882, 119883, 119884, 119885, 119886, 119887, 119888, 119889, 119890, 119891, 119892, 119893, 119894, 119895, 119896, 119897, 119898, 119899, 119900, 119901, 119902, 119903, 119904, 119905, 119906, 119907, 119908, 119909, 119910, 119911, 119912, 119913, 119914, 119915, 119916, 119917, 119918, 119919, 119920, 119921, 119922, 119923, 119924, 119925, 119926, 119927, 119928, 119929, 119930, 119931, 119932, 119933, 119934, 119935, 119936, 119937, 119938, 119939, 119940, 119941, 119942, 119943, 119944, 119945, 119946, 119947, 119948, 119949, 119950, 119951, 119952, 119953, 119954, 119955, 119956, 119957, 119958, 119959, 119960, 119961, 119962, 119963, 119964, 119965, 119966, 119967, 119968, 119970, 119971, 119973, 119974, 119975, 119977, 119978, 119979, 119980, 119981, 119982, 119983, 119984, 119985, 119986, 119987, 119988, 119989, 119990, 119991, 119992, 119993, 119994, 119995, 119996, 119997, 119998, 119999, 120000, 120001, 120002, 120003, 120004, 120005, 120006, 120007, 120008, 120009, 120010, 120011, 120012, 120013, 120014, 120015, 120016, 120017, 120018, 120019, 120020, 120021, 120022, 120023, 120024, 120025, 120026, 120027, 120028, 120029, 120030, 120031, 120032, 120033, 120034, 120035, 120036, 120037, 120038, 120039, 120040, 120041, 120042, 120043, 120044, 120045, 120046, 120047, 120048, 120049, 120050, 120051, 120052, 120053, 120054, 120055, 120056, 120057, 120058, 120059, 120060, 120061, 120062, 120063, 120064, 120065, 120066, 120067, 120068, 120069, 120070, 120071, 120072, 120073, 120074, 120075, 120077, 120078, 120079, 120080, 120081, 120082, 120083, 120084, 120085, 120086, 120087, 120088, 120089, 120090, 120091, 120092, 120093, 120094, 120095, 120096, 120097, 120098, 120099, 120100, 120101, 120102, 120103, 120104, 120105, 120106, 120107, 120108, 120109, 120110, 120111, 120112, 120113, 120114, 120115, 120116, 120117, 120118, 120119, 120120, 120121, 120122, 120123, 120124, 120125, 120126, 120127, 120128, 120129, 120130, 120131, 120132, 120133, 120134, 120135, 120138, 120139, 120140, 120141, 120142, 120143, 120144, 120145, 120146, 120147, 120148, 120149, 120150, 120151, 120152, 120153, 120154, 120155, 120156, 120157, 120158, 120159, 120160, 120161, 120162, 120163, 120164, 120165, 120166, 120167, 120168, 120169, 120170, 120171, 120172, 120173, 120174, 120175, 120176, 120177, 120178, 120179, 120180, 120181, 120182, 120183, 120184, 120185, 120186, 120187, 120188, 120189, 120190, 120191, 120192, 120193, 120194, 120195, 120196, 120197, 120198, 120199, 120200, 120201, 120202, 120203, 120204, 120205, 120206, 120207, 120208, 120209, 120210, 120211, 120212, 120213, 120214, 120215, 120216, 120217, 120218, 120219, 120220, 120221, 120222, 120223, 120224, 120225, 120226, 120227, 120228, 120229, 120230, 120231, 120232, 120233, 120234, 120235, 120236, 120237, 120238, 120239, 120240, 120241, 120242, 120243, 120244, 120245, 120246, 120247, 120248, 120249, 120250, 120251, 120252, 120253, 120254, 120255, 120256, 120257, 120258, 120259, 120260, 120261, 120262, 120263, 120264, 120265, 120266, 120267, 120268, 120269, 120270, 120271, 120272, 120273, 120274, 120275, 120276, 120277, 120278, 120279, 120280, 120281, 120282, 120283, 120284, 120285, 120286, 120287, 120288, 120289, 120290, 120291, 120292, 120293, 120294, 120295, 120296, 120297, 120298, 120299, 120300, 120301, 120302, 120303, 120304, 120305, 120306, 120307, 120308, 120309, 120310, 120311, 120312, 120313, 120314, 120315, 120316, 120317, 120318, 120319, 120320, 120321, 120322, 120323, 120324, 120325, 120326, 120327, 120328, 120329, 120330, 120331, 120332, 120333, 120334, 120335, 120336, 120337, 120338, 120339, 120340, 120341, 120342, 120343, 120344, 120345, 120346, 120347, 120348, 120349, 120350, 120351, 120352, 120353, 120354, 120355, 120356, 120357, 120358, 120359, 120360, 120361, 120362, 120363, 120364, 120365, 120366, 120367, 120368, 120369, 120370, 120371, 120372, 120373, 120374, 120375, 120376, 120377, 120378, 120379, 120380, 120381, 120382, 120383, 120384, 120385, 120386, 120387, 120388, 120389, 120390, 120391, 120392, 120393, 120394, 120395, 120396, 120397, 120398, 120399, 120400, 120401, 120402, 120403, 120404, 120405, 120406, 120407, 120408, 120409, 120410, 120411, 120412, 120413, 120414, 120415, 120416, 120417, 120418, 120419, 120420, 120421, 120422, 120423, 120424, 120425, 120426, 120427, 120428, 120429, 120430, 120431, 120432, 120433, 120434, 120435, 120436, 120437, 120438, 120439, 120440, 120441, 120442, 120443, 120444, 120445, 120446, 120447, 120448, 120449, 120450, 120451, 120452, 120453, 120454, 120455, 120456, 120457, 120458, 120459, 120460, 120461, 120462, 120463, 120464, 120465, 120466, 120467, 120468, 120469, 120470, 120471, 120472, 120473, 120474, 120475, 120476, 120477, 120478, 120479, 120480, 120481, 120482, 120483, 120484, 120485, 120486, 120488, 120489, 120490, 120491, 120492, 120493, 120494, 120495, 120496, 120497, 120498, 120499, 120500, 120501, 120502, 120503, 120504, 120505, 120506, 120507, 120508, 120509, 120510, 120511, 120512, 120513, 120514, 120515, 120516, 120517, 120518, 120519, 120520, 120521, 120522, 120523, 120524, 120525, 120526, 120527, 120528, 120529, 120530, 120531, 120533, 120534, 120535, 120536, 120537, 120538, 120539, 120540, 120541, 120542, 120543, 120544, 120545, 120546, 120547, 120548, 120549, 120550, 120551, 120552, 120553, 120554, 120555, 120556, 120557, 120558, 120559, 120560, 120561, 120562, 120563, 120564, 120565, 120566, 120567, 120568, 120569, 120570, 120571, 120572, 120573, 120574, 120575, 120576, 120577, 120578, 120579, 120580, 120581, 120582, 120583, 120584, 120585, 120586, 120587, 120588, 120589, 120591, 120592, 120593, 120594, 120595, 120596, 120597, 120598, 120599, 120600, 120601, 120602, 120603, 120604, 120605, 120606, 120607, 120608, 120609, 120610, 120611, 120612, 120613, 120614, 120615, 120616, 120617, 120618, 120619, 120620, 120621, 120622, 120623, 120624, 120625, 120626, 120627, 120628, 120629, 120630, 120631, 120632, 120633, 120634, 120635, 120636, 120637, 120638, 120639, 120640, 120641, 120642, 120643, 120644, 120645, 120646, 120647, 120649, 120650, 120651, 120652, 120653, 120654, 120655, 120656, 120657, 120658, 120659, 120660, 120661, 120662, 120663, 120664, 120665, 120666, 120667, 120668, 120669, 120670, 120671, 120672, 120673, 120674, 120675, 120676, 120677, 120678, 120679, 120680, 120681, 120682, 120683, 120684, 120685, 120686, 120687, 120688, 120689, 120690, 120691, 120692, 120693, 120694, 120695, 120696, 120697, 120698, 120699, 120700, 120701, 120702, 120703, 120704, 120705, 120707, 120708, 120709, 120710, 120711, 120712, 120713, 120714, 120715, 120716, 120717, 120718, 120719, 120720, 120721, 120722, 120723, 120724, 120725, 120726, 120727, 120728, 120729, 120730, 120731, 120732, 120733, 120734, 120735, 120736, 120737, 120738, 120739, 120740, 120741, 120742, 120743, 120744, 120745, 120746, 120747, 120748, 120749, 120750, 120751, 120752, 120753, 120754, 120755, 120756, 120757, 120758, 120759, 120760, 120761, 120762, 120763, 120765, 120766, 120767, 120768, 120769, 120770, 120771, 120772, 120773, 120774, 120775, 120776, 120777, 120778, 120780, 120782, 120783, 120784, 120785, 120786, 120787, 120788, 120789, 120790, 120791, 120792, 120793, 120794, 120795, 120796, 120797, 120798, 120799, 120800, 120801, 120802, 120803, 120804, 120805, 120806, 120807, 120808, 120809, 120810, 120811, 120812, 120813, 120814, 120815, 120816, 120817, 120818, 120819, 120820, 120821, 120822, 120823, 120824, 120825, 120826, 120827, 120828, 120829, 120830, 120831, 120832, 121344, 121399, 121403, 121453, 121461, 121462, 121476, 121477, 121484, 121499, 121504, 121505, 121520, 122624, 122655, 122661, 122667, 122880, 122887, 122888, 122905, 122907, 122914, 122915, 122917, 122918, 122923, 122928, 122929, 122930, 122931, 122932, 122933, 122934, 122935, 122936, 122937, 122938, 122939, 122940, 122941, 122942, 122943, 122944, 122945, 122946, 122947, 122948, 122949, 122950, 122951, 122952, 122953, 122954, 122955, 122956, 122957, 122958, 122959, 122960, 122961, 122962, 122963, 122964, 122965, 122966, 122967, 122968, 122969, 122970, 122971, 122972, 122973, 122974, 122975, 122976, 122977, 122978, 122979, 122980, 122981, 122982, 122983, 122984, 122985, 122986, 122987, 122988, 122989, 122990, 123023, 123024, 123136, 123181, 123184, 123198, 123200, 123210, 123214, 123215, 123216, 123536, 123567, 123584, 123642, 123647, 123648, 124112, 124154, 124368, 124411, 124415, 124416, 124896, 124903, 124904, 124908, 124909, 124911, 124912, 124927, 124928, 125125, 125127, 125136, 125143, 125184, 125185, 125186, 125187, 125188, 125189, 125190, 125191, 125192, 125193, 125194, 125195, 125196, 125197, 125198, 125199, 125200, 125201, 125202, 125203, 125204, 125205, 125206, 125207, 125208, 125209, 125210, 125211, 125212, 125213, 125214, 125215, 125216, 125217, 125218, 125259, 125260, 125264, 125274, 125278, 125280, 126065, 126133, 126209, 126270, 126464, 126465, 126466, 126467, 126468, 126469, 126470, 126471, 126472, 126473, 126474, 126475, 126476, 126477, 126478, 126479, 126480, 126481, 126482, 126483, 126484, 126485, 126486, 126487, 126488, 126489, 126490, 126491, 126492, 126493, 126494, 126495, 126496, 126497, 126498, 126499, 126500, 126501, 126503, 126504, 126505, 126506, 126507, 126508, 126509, 126510, 126511, 126512, 126513, 126514, 126515, 126516, 126517, 126518, 126519, 126520, 126521, 126522, 126523, 126524, 126530, 126531, 126535, 126536, 126537, 126538, 126539, 126540, 126541, 126542, 126543, 126544, 126545, 126546, 126547, 126548, 126549, 126551, 126552, 126553, 126554, 126555, 126556, 126557, 126558, 126559, 126560, 126561, 126562, 126563, 126564, 126565, 126567, 126568, 126569, 126570, 126571, 126572, 126573, 126574, 126575, 126576, 126577, 126578, 126579, 126580, 126581, 126582, 126583, 126584, 126585, 126586, 126587, 126588, 126589, 126590, 126591, 126592, 126593, 126594, 126595, 126596, 126597, 126598, 126599, 126600, 126601, 126602, 126603, 126604, 126605, 126606, 126607, 126608, 126609, 126610, 126611, 126612, 126613, 126614, 126615, 126616, 126617, 126618, 126619, 126620, 126625, 126626, 126627, 126628, 126629, 126630, 126631, 126632, 126633, 126634, 126635, 126636, 126637, 126638, 126639, 126640, 126641, 126642, 126643, 126644, 126645, 126646, 126647, 126648, 126649, 126650, 126651, 126652, 126704, 126706, 126976, 127020, 127024, 127124, 127136, 127151, 127153, 127167, 127168, 127169, 127184, 127185, 127200, 127222, 127232, 127233, 127234, 127235, 127236, 127237, 127238, 127239, 127240, 127241, 127242, 127243, 127245, 127248, 127249, 127250, 127251, 127252, 127253, 127254, 127255, 127256, 127257, 127258, 127259, 127260, 127261, 127262, 127263, 127264, 127265, 127266, 127267, 127268, 127269, 127270, 127271, 127272, 127273, 127274, 127275, 127276, 127277, 127278, 127279, 127280, 127281, 127282, 127283, 127284, 127285, 127286, 127287, 127288, 127289, 127290, 127291, 127292, 127293, 127294, 127295, 127296, 127297, 127298, 127299, 127300, 127301, 127302, 127303, 127304, 127305, 127306, 127307, 127308, 127309, 127310, 127311, 127312, 127319, 127320, 127327, 127328, 127338, 127339, 127340, 127341, 127344, 127353, 127354, 127355, 127357, 127359, 127360, 127370, 127374, 127376, 127377, 127387, 127405, 127406, 127462, 127488, 127489, 127490, 127491, 127504, 127505, 127506, 127507, 127508, 127509, 127510, 127511, 127512, 127513, 127514, 127515, 127516, 127517, 127518, 127519, 127520, 127521, 127522, 127523, 127524, 127525, 127526, 127527, 127528, 127529, 127530, 127531, 127532, 127533, 127534, 127535, 127536, 127537, 127538, 127539, 127540, 127541, 127542, 127543, 127544, 127545, 127546, 127547, 127548, 127552, 127553, 127554, 127555, 127556, 127557, 127558, 127559, 127560, 127561, 127568, 127569, 127570, 127584, 127590, 127744, 127777, 127789, 127792, 127798, 127799, 127869, 127870, 127872, 127892, 127904, 127941, 127942, 127947, 127951, 127956, 127968, 127985, 127992, 128000, 128063, 128064, 128065, 128066, 128248, 128249, 128253, 128255, 128256, 128318, 128320, 128324, 128331, 128336, 128360, 128378, 128379, 128420, 128421, 128507, 128512, 128513, 128529, 128530, 128533, 128534, 128535, 128536, 128537, 128538, 128539, 128540, 128543, 128544, 128550, 128552, 128556, 128557, 128558, 128560, 128564, 128565, 128577, 128579, 128581, 128592, 128640, 128710, 128720, 128721, 128723, 128725, 128726, 128728, 128732, 128733, 128736, 128749, 128752, 128756, 128759, 128761, 128762, 128763, 128765, 128768, 128884, 128887, 128891, 128896, 128981, 128985, 128986, 128992, 129004, 129008, 129009, 129024, 129036, 129040, 129096, 129104, 129114, 129120, 129160, 129168, 129198, 129200, 129202, 129212, 129216, 129218, 129280, 129292, 129293, 129296, 129305, 129311, 129312, 129320, 129328, 129329, 129331, 129343, 129344, 129356, 129357, 129360, 129375, 129388, 129393, 129394, 129395, 129399, 129401, 129402, 129403, 129404, 129408, 129413, 129426, 129432, 129443, 129445, 129451, 129454, 129456, 129466, 129472, 129473, 129475, 129483, 129484, 129485, 129488, 129511, 129536, 129620, 129632, 129646, 129648, 129652, 129653, 129656, 129659, 129661, 129664, 129667, 129671, 129673, 129674, 129679, 129680, 129686, 129705, 129709, 129712, 129719, 129723, 129726, 129727, 129728, 129731, 129734, 129735, 129742, 129744, 129751, 129754, 129756, 129757, 129759, 129760, 129768, 129769, 129770, 129776, 129783, 129785, 129792, 129939, 129940, 129995, 130032, 130033, 130034, 130035, 130036, 130037, 130038, 130039, 130040, 130041, 130042, 131070, 131072, 173783, 173790, 173792, 173824, 177973, 177977, 177978, 177984, 178206, 178208, 183970, 183984, 191457, 191472, 192094, 194560, 194561, 194562, 194563, 194564, 194565, 194566, 194567, 194568, 194569, 194570, 194571, 194572, 194573, 194574, 194575, 194576, 194577, 194578, 194579, 194580, 194581, 194582, 194583, 194584, 194585, 194586, 194587, 194588, 194589, 194590, 194591, 194592, 194593, 194594, 194595, 194596, 194597, 194598, 194599, 194600, 194601, 194602, 194603, 194604, 194605, 194606, 194607, 194608, 194609, 194612, 194613, 194614, 194615, 194616, 194617, 194618, 194619, 194620, 194621, 194622, 194623, 194624, 194625, 194626, 194627, 194628, 194629, 194631, 194632, 194633, 194634, 194635, 194636, 194637, 194638, 194639, 194640, 194641, 194642, 194643, 194644, 194645, 194646, 194647, 194648, 194649, 194650, 194651, 194652, 194653, 194654, 194655, 194656, 194657, 194658, 194659, 194660, 194661, 194662, 194663, 194664, 194665, 194666, 194668, 194669, 194670, 194671, 194672, 194673, 194674, 194675, 194676, 194677, 194678, 194679, 194680, 194681, 194682, 194683, 194684, 194685, 194686, 194687, 194688, 194689, 194690, 194691, 194692, 194693, 194694, 194695, 194696, 194697, 194698, 194699, 194700, 194701, 194702, 194703, 194704, 194705, 194707, 194708, 194710, 194711, 194712, 194713, 194714, 194715, 194716, 194717, 194718, 194719, 194720, 194721, 194722, 194723, 194724, 194725, 194726, 194727, 194728, 194729, 194730, 194731, 194732, 194733, 194734, 194735, 194736, 194737, 194738, 194739, 194740, 194741, 194742, 194743, 194744, 194745, 194746, 194747, 194748, 194749, 194750, 194751, 194752, 194753, 194754, 194755, 194756, 194757, 194758, 194759, 194760, 194761, 194762, 194763, 194764, 194765, 194766, 194767, 194768, 194769, 194770, 194771, 194772, 194773, 194774, 194775, 194776, 194777, 194778, 194779, 194780, 194781, 194782, 194783, 194784, 194785, 194786, 194787, 194788, 194789, 194790, 194791, 194792, 194793, 194794, 194795, 194796, 194797, 194798, 194799, 194800, 194801, 194802, 194803, 194804, 194805, 194806, 194807, 194808, 194809, 194810, 194811, 194812, 194813, 194814, 194815, 194816, 194817, 194818, 194819, 194820, 194821, 194822, 194823, 194824, 194825, 194826, 194827, 194828, 194829, 194830, 194831, 194832, 194833, 194834, 194835, 194836, 194837, 194838, 194839, 194840, 194841, 194842, 194843, 194844, 194845, 194846, 194847, 194848, 194849, 194850, 194851, 194852, 194853, 194854, 194855, 194856, 194857, 194858, 194859, 194860, 194862, 194863, 194864, 194865, 194866, 194867, 194868, 194869, 194870, 194871, 194872, 194873, 194874, 194875, 194876, 194877, 194878, 194879, 194880, 194881, 194882, 194883, 194884, 194885, 194886, 194888, 194889, 194890, 194891, 194892, 194893, 194894, 194895, 194896, 194897, 194898, 194899, 194900, 194901, 194902, 194903, 194904, 194905, 194906, 194907, 194908, 194909, 194911, 194912, 194913, 194914, 194915, 194916, 194917, 194918, 194919, 194920, 194921, 194922, 194923, 194924, 194925, 194926, 194927, 194928, 194929, 194930, 194931, 194932, 194933, 194934, 194935, 194936, 194937, 194938, 194939, 194940, 194941, 194942, 194943, 194944, 194945, 194946, 194947, 194948, 194949, 194950, 194951, 194952, 194953, 194954, 194955, 194956, 194957, 194958, 194959, 194960, 194961, 194962, 194963, 194964, 194965, 194966, 194967, 194968, 194969, 194970, 194971, 194972, 194973, 194974, 194975, 194976, 194977, 194978, 194979, 194980, 194981, 194982, 194983, 194984, 194985, 194986, 194987, 194988, 194989, 194990, 194991, 194992, 194993, 194994, 194995, 194996, 194997, 194998, 194999, 195000, 195001, 195002, 195003, 195004, 195005, 195006, 195007, 195008, 195009, 195010, 195011, 195012, 195013, 195014, 195015, 195016, 195017, 195018, 195019, 195020, 195021, 195022, 195023, 195024, 195025, 195026, 195027, 195028, 195029, 195030, 195031, 195032, 195033, 195034, 195035, 195036, 195037, 195038, 195039, 195040, 195041, 195042, 195043, 195044, 195045, 195046, 195047, 195048, 195049, 195050, 195051, 195052, 195053, 195054, 195055, 195056, 195057, 195058, 195059, 195060, 195061, 195062, 195063, 195064, 195065, 195066, 195067, 195068, 195069, 195070, 195072, 195073, 195074, 195075, 195076, 195077, 195078, 195079, 195080, 195081, 195082, 195083, 195084, 195085, 195086, 195087, 195088, 195089, 195090, 195091, 195092, 195093, 195094, 195095, 195096, 195097, 195098, 195099, 195100, 195101, 195102, 196606, 196608, 201547, 201552, 205744, 262142, 262144, 327678, 327680, 393214, 393216, 458750, 458752, 524286, 524288, 589822, 589824, 655358, 655360, 720894, 720896, 786430, 786432, 851966, 851968, 917502, 917504, 917505, 917506, 917536, 917632, 917760, 918000, 983038, 983040, 1048574, 1048576, 1114110];
const _M0FP410tonyfettes7unicode8internal4idna17idna__range__ends = [44, 46, 47, 57, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 96, 122, 127, 159, 160, 167, 168, 169, 170, 172, 173, 174, 175, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 246, 247, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 307, 308, 309, 310, 312, 313, 314, 315, 316, 317, 318, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 384, 385, 386, 387, 388, 389, 390, 391, 392, 393, 394, 395, 397, 398, 399, 400, 401, 402, 403, 404, 405, 406, 407, 408, 411, 412, 413, 414, 415, 416, 417, 418, 419, 420, 421, 422, 423, 424, 425, 427, 428, 429, 430, 431, 432, 433, 434, 435, 436, 437, 438, 439, 440, 443, 444, 451, 454, 457, 460, 461, 462, 463, 464, 465, 466, 467, 468, 469, 470, 471, 472, 473, 474, 475, 477, 478, 479, 480, 481, 482, 483, 484, 485, 486, 487, 488, 489, 490, 491, 492, 493, 494, 496, 499, 500, 501, 502, 503, 504, 505, 506, 507, 508, 509, 510, 511, 512, 513, 514, 515, 516, 517, 518, 519, 520, 521, 522, 523, 524, 525, 526, 527, 528, 529, 530, 531, 532, 533, 534, 535, 536, 537, 538, 539, 540, 541, 542, 543, 544, 545, 546, 547, 548, 549, 550, 551, 552, 553, 554, 555, 556, 557, 558, 559, 560, 561, 562, 563, 566, 569, 570, 571, 572, 573, 574, 576, 577, 578, 579, 580, 581, 582, 583, 584, 585, 586, 587, 588, 589, 590, 591, 680, 685, 687, 688, 689, 690, 691, 692, 693, 694, 695, 696, 705, 709, 721, 727, 728, 729, 730, 731, 732, 733, 734, 735, 736, 737, 738, 739, 740, 745, 747, 748, 749, 750, 767, 831, 832, 833, 834, 835, 836, 837, 846, 847, 855, 860, 863, 865, 866, 879, 880, 881, 882, 883, 884, 885, 886, 887, 889, 890, 893, 894, 895, 899, 900, 901, 902, 903, 904, 905, 906, 907, 908, 909, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 930, 931, 932, 933, 934, 935, 936, 937, 938, 939, 961, 962, 974, 975, 976, 977, 978, 979, 980, 981, 982, 983, 984, 985, 986, 987, 988, 989, 990, 991, 992, 993, 994, 995, 996, 997, 998, 999, 1000, 1001, 1002, 1003, 1004, 1005, 1006, 1007, 1008, 1009, 1010, 1011, 1012, 1013, 1014, 1015, 1016, 1017, 1018, 1019, 1020, 1021, 1022, 1023, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1103, 1104, 1116, 1117, 1119, 1120, 1121, 1122, 1123, 1124, 1125, 1126, 1127, 1128, 1129, 1130, 1131, 1132, 1133, 1134, 1135, 1136, 1137, 1138, 1139, 1140, 1141, 1142, 1143, 1144, 1145, 1146, 1147, 1148, 1149, 1150, 1151, 1152, 1153, 1154, 1158, 1159, 1161, 1162, 1163, 1164, 1165, 1166, 1167, 1168, 1169, 1170, 1171, 1172, 1173, 1174, 1175, 1176, 1177, 1178, 1179, 1180, 1181, 1182, 1183, 1184, 1185, 1186, 1187, 1188, 1189, 1190, 1191, 1192, 1193, 1194, 1195, 1196, 1197, 1198, 1199, 1200, 1201, 1202, 1203, 1204, 1205, 1206, 1207, 1208, 1209, 1210, 1211, 1212, 1213, 1214, 1215, 1216, 1217, 1218, 1219, 1220, 1221, 1222, 1223, 1224, 1225, 1226, 1227, 1228, 1229, 1230, 1231, 1232, 1233, 1234, 1235, 1236, 1237, 1238, 1239, 1240, 1241, 1242, 1243, 1244, 1245, 1246, 1247, 1248, 1249, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1257, 1258, 1259, 1260, 1261, 1262, 1263, 1264, 1265, 1266, 1267, 1268, 1269, 1270, 1271, 1272, 1273, 1274, 1275, 1276, 1277, 1278, 1279, 1280, 1281, 1282, 1283, 1284, 1285, 1286, 1287, 1288, 1289, 1290, 1291, 1292, 1293, 1294, 1295, 1296, 1297, 1298, 1299, 1300, 1301, 1302, 1303, 1304, 1305, 1306, 1307, 1308, 1309, 1310, 1311, 1312, 1313, 1314, 1315, 1316, 1317, 1318, 1319, 1320, 1321, 1322, 1323, 1324, 1325, 1326, 1327, 1328, 1329, 1330, 1331, 1332, 1333, 1334, 1335, 1336, 1337, 1338, 1339, 1340, 1341, 1342, 1343, 1344, 1345, 1346, 1347, 1348, 1349, 1350, 1351, 1352, 1353, 1354, 1355, 1356, 1357, 1358, 1359, 1360, 1361, 1362, 1363, 1364, 1365, 1366, 1368, 1369, 1375, 1376, 1414, 1415, 1416, 1417, 1418, 1420, 1422, 1423, 1424, 1441, 1442, 1455, 1465, 1466, 1469, 1470, 1471, 1472, 1474, 1475, 1476, 1477, 1478, 1479, 1487, 1514, 1518, 1519, 1524, 1535, 1539, 1540, 1541, 1546, 1547, 1548, 1551, 1557, 1562, 1563, 1564, 1565, 1566, 1567, 1568, 1594, 1599, 1600, 1618, 1621, 1624, 1630, 1631, 1641, 1645, 1647, 1652, 1653, 1654, 1655, 1656, 1719, 1721, 1726, 1727, 1742, 1743, 1747, 1748, 1756, 1757, 1758, 1768, 1769, 1773, 1775, 1785, 1790, 1791, 1805, 1806, 1807, 1836, 1839, 1866, 1868, 1871, 1901, 1919, 1968, 1969, 1983, 2037, 2042, 2044, 2045, 2047, 2093, 2095, 2110, 2111, 2139, 2141, 2142, 2143, 2154, 2159, 2183, 2184, 2190, 2191, 2193, 2198, 2199, 2207, 2208, 2209, 2220, 2226, 2228, 2229, 2237, 2247, 2258, 2259, 2273, 2274, 2275, 2302, 2303, 2304, 2307, 2308, 2361, 2363, 2381, 2382, 2383, 2388, 2389, 2391, 2392, 2393, 2394, 2395, 2396, 2397, 2398, 2399, 2403, 2405, 2415, 2416, 2418, 2423, 2424, 2426, 2428, 2429, 2431, 2432, 2435, 2436, 2444, 2446, 2448, 2450, 2472, 2473, 2480, 2481, 2482, 2485, 2489, 2491, 2492, 2493, 2500, 2502, 2504, 2506, 2509, 2510, 2518, 2519, 2523, 2524, 2525, 2526, 2527, 2531, 2533, 2545, 2554, 2555, 2556, 2557, 2558, 2560, 2561, 2562, 2563, 2564, 2570, 2574, 2576, 2578, 2600, 2601, 2608, 2609, 2610, 2611, 2612, 2613, 2614, 2615, 2617, 2619, 2620, 2621, 2626, 2630, 2632, 2634, 2637, 2640, 2641, 2648, 2649, 2650, 2651, 2652, 2653, 2654, 2661, 2676, 2677, 2678, 2688, 2691, 2692, 2699, 2700, 2701, 2702, 2705, 2706, 2728, 2729, 2736, 2737, 2739, 2740, 2745, 2747, 2757, 2758, 2761, 2762, 2765, 2767, 2768, 2783, 2784, 2787, 2789, 2799, 2800, 2801, 2808, 2809, 2815, 2816, 2819, 2820, 2828, 2830, 2832, 2834, 2856, 2857, 2864, 2865, 2867, 2868, 2869, 2873, 2875, 2883, 2884, 2886, 2888, 2890, 2893, 2900, 2901, 2903, 2907, 2908, 2909, 2910, 2913, 2915, 2917, 2927, 2928, 2929, 2935, 2945, 2947, 2948, 2954, 2957, 2960, 2961, 2965, 2968, 2970, 2971, 2972, 2973, 2975, 2978, 2980, 2983, 2986, 2989, 2997, 2998, 3001, 3005, 3010, 3013, 3016, 3017, 3021, 3023, 3024, 3030, 3031, 3045, 3046, 3055, 3058, 3066, 3071, 3072, 3075, 3076, 3084, 3085, 3088, 3089, 3112, 3113, 3123, 3124, 3129, 3131, 3132, 3133, 3140, 3141, 3144, 3145, 3149, 3156, 3158, 3159, 3161, 3162, 3164, 3165, 3167, 3169, 3171, 3173, 3183, 3190, 3191, 3199, 3200, 3201, 3203, 3204, 3212, 3213, 3216, 3217, 3240, 3241, 3251, 3252, 3257, 3259, 3261, 3268, 3269, 3272, 3273, 3277, 3284, 3286, 3292, 3293, 3294, 3295, 3297, 3299, 3301, 3311, 3312, 3314, 3315, 3327, 3328, 3329, 3331, 3332, 3340, 3341, 3344, 3345, 3368, 3369, 3385, 3386, 3388, 3389, 3395, 3396, 3397, 3400, 3401, 3405, 3406, 3407, 3411, 3414, 3415, 3422, 3423, 3425, 3427, 3429, 3439, 3445, 3448, 3449, 3455, 3456, 3457, 3459, 3460, 3478, 3481, 3505, 3506, 3515, 3516, 3517, 3519, 3526, 3529, 3530, 3534, 3540, 3541, 3542, 3543, 3551, 3557, 3567, 3569, 3571, 3572, 3584, 3634, 3635, 3642, 3646, 3647, 3662, 3663, 3673, 3675, 3712, 3714, 3715, 3716, 3717, 3718, 3720, 3721, 3722, 3723, 3724, 3725, 3731, 3735, 3736, 3743, 3744, 3747, 3748, 3749, 3750, 3751, 3753, 3755, 3756, 3762, 3763, 3769, 3770, 3773, 3775, 3780, 3781, 3782, 3783, 3789, 3790, 3791, 3801, 3803, 3804, 3805, 3807, 3839, 3840, 3850, 3851, 3852, 3863, 3865, 3871, 3881, 3892, 3893, 3894, 3895, 3896, 3897, 3901, 3906, 3907, 3911, 3912, 3916, 3917, 3921, 3922, 3926, 3927, 3931, 3932, 3944, 3945, 3946, 3948, 3952, 3954, 3955, 3956, 3957, 3958, 3959, 3960, 3961, 3968, 3969, 3972, 3973, 3979, 3983, 3986, 3987, 3989, 3990, 3991, 3992, 3996, 3997, 4001, 4002, 4006, 4007, 4011, 4012, 4013, 4016, 4023, 4024, 4025, 4028, 4029, 4037, 4038, 4044, 4045, 4046, 4047, 4049, 4052, 4056, 4058, 4095, 4129, 4130, 4135, 4136, 4138, 4139, 4146, 4149, 4153, 4159, 4169, 4175, 4185, 4249, 4253, 4255, 4256, 4257, 4258, 4259, 4260, 4261, 4262, 4263, 4264, 4265, 4266, 4267, 4268, 4269, 4270, 4271, 4272, 4273, 4274, 4275, 4276, 4277, 4278, 4279, 4280, 4281, 4282, 4283, 4284, 4285, 4286, 4287, 4288, 4289, 4290, 4291, 4292, 4293, 4294, 4295, 4300, 4301, 4303, 4342, 4344, 4346, 4347, 4348, 4351, 4441, 4446, 4448, 4514, 4519, 4601, 4607, 4614, 4615, 4678, 4679, 4680, 4681, 4685, 4687, 4694, 4695, 4696, 4697, 4701, 4703, 4742, 4743, 4744, 4745, 4749, 4751, 4782, 4783, 4784, 4785, 4789, 4791, 4798, 4799, 4800, 4801, 4805, 4807, 4814, 4815, 4822, 4823, 4846, 4847, 4878, 4879, 4880, 4881, 4885, 4887, 4894, 4895, 4934, 4935, 4954, 4956, 4958, 4959, 4960, 4988, 4991, 5007, 5017, 5023, 5108, 5109, 5111, 5112, 5113, 5114, 5115, 5116, 5117, 5119, 5120, 5740, 5742, 5750, 5759, 5760, 5786, 5788, 5791, 5866, 5872, 5880, 5887, 5900, 5901, 5908, 5909, 5918, 5919, 5940, 5942, 5951, 5971, 5983, 5996, 5997, 6000, 6001, 6003, 6015, 6067, 6069, 6099, 6102, 6103, 6107, 6108, 6109, 6111, 6121, 6127, 6137, 6143, 6154, 6158, 6159, 6169, 6175, 6263, 6264, 6271, 6313, 6314, 6319, 6389, 6399, 6428, 6430, 6431, 6443, 6447, 6459, 6463, 6464, 6467, 6469, 6509, 6511, 6516, 6527, 6569, 6571, 6575, 6601, 6607, 6617, 6618, 6621, 6623, 6655, 6683, 6685, 6687, 6750, 6751, 6780, 6782, 6793, 6799, 6809, 6815, 6822, 6823, 6829, 6831, 6845, 6846, 6848, 6862, 6911, 6987, 6988, 6989, 6991, 7001, 7018, 7027, 7036, 7038, 7039, 7082, 7085, 7097, 7103, 7155, 7163, 7167, 7223, 7226, 7231, 7241, 7244, 7293, 7295, 7296, 7297, 7298, 7299, 7301, 7302, 7303, 7304, 7305, 7306, 7311, 7312, 7313, 7314, 7315, 7316, 7317, 7318, 7319, 7320, 7321, 7322, 7323, 7324, 7325, 7326, 7327, 7328, 7329, 7330, 7331, 7332, 7333, 7334, 7335, 7336, 7337, 7338, 7339, 7340, 7341, 7342, 7343, 7344, 7345, 7346, 7347, 7348, 7349, 7350, 7351, 7352, 7353, 7354, 7356, 7357, 7358, 7359, 7367, 7375, 7378, 7379, 7410, 7414, 7415, 7417, 7418, 7423, 7467, 7468, 7469, 7470, 7471, 7472, 7473, 7474, 7475, 7476, 7477, 7478, 7479, 7480, 7481, 7482, 7483, 7484, 7485, 7486, 7487, 7488, 7489, 7490, 7491, 7492, 7493, 7494, 7495, 7496, 7497, 7498, 7499, 7500, 7501, 7502, 7503, 7504, 7505, 7506, 7507, 7508, 7509, 7510, 7511, 7512, 7513, 7514, 7515, 7516, 7517, 7518, 7519, 7520, 7521, 7522, 7523, 7524, 7525, 7526, 7527, 7528, 7529, 7530, 7531, 7543, 7544, 7578, 7579, 7580, 7581, 7582, 7583, 7584, 7585, 7586, 7587, 7588, 7589, 7590, 7591, 7592, 7593, 7594, 7595, 7596, 7597, 7598, 7599, 7600, 7601, 7602, 7603, 7604, 7605, 7606, 7607, 7608, 7609, 7610, 7611, 7612, 7613, 7614, 7615, 7619, 7626, 7654, 7669, 7673, 7674, 7675, 7676, 7677, 7679, 7680, 7681, 7682, 7683, 7684, 7685, 7686, 7687, 7688, 7689, 7690, 7691, 7692, 7693, 7694, 7695, 7696, 7697, 7698, 7699, 7700, 7701, 7702, 7703, 7704, 7705, 7706, 7707, 7708, 7709, 7710, 7711, 7712, 7713, 7714, 7715, 7716, 7717, 7718, 7719, 7720, 7721, 7722, 7723, 7724, 7725, 7726, 7727, 7728, 7729, 7730, 7731, 7732, 7733, 7734, 7735, 7736, 7737, 7738, 7739, 7740, 7741, 7742, 7743, 7744, 7745, 7746, 7747, 7748, 7749, 7750, 7751, 7752, 7753, 7754, 7755, 7756, 7757, 7758, 7759, 7760, 7761, 7762, 7763, 7764, 7765, 7766, 7767, 7768, 7769, 7770, 7771, 7772, 7773, 7774, 7775, 7776, 7777, 7778, 7779, 7780, 7781, 7782, 7783, 7784, 7785, 7786, 7787, 7788, 7789, 7790, 7791, 7792, 7793, 7794, 7795, 7796, 7797, 7798, 7799, 7800, 7801, 7802, 7803, 7804, 7805, 7806, 7807, 7808, 7809, 7810, 7811, 7812, 7813, 7814, 7815, 7816, 7817, 7818, 7819, 7820, 7821, 7822, 7823, 7824, 7825, 7826, 7827, 7828, 7833, 7834, 7835, 7837, 7838, 7839, 7840, 7841, 7842, 7843, 7844, 7845, 7846, 7847, 7848, 7849, 7850, 7851, 7852, 7853, 7854, 7855, 7856, 7857, 7858, 7859, 7860, 7861, 7862, 7863, 7864, 7865, 7866, 7867, 7868, 7869, 7870, 7871, 7872, 7873, 7874, 7875, 7876, 7877, 7878, 7879, 7880, 7881, 7882, 7883, 7884, 7885, 7886, 7887, 7888, 7889, 7890, 7891, 7892, 7893, 7894, 7895, 7896, 7897, 7898, 7899, 7900, 7901, 7902, 7903, 7904, 7905, 7906, 7907, 7908, 7909, 7910, 7911, 7912, 7913, 7914, 7915, 7916, 7917, 7918, 7919, 7920, 7921, 7922, 7923, 7924, 7925, 7926, 7927, 7928, 7929, 7930, 7931, 7932, 7933, 7934, 7935, 7943, 7944, 7945, 7946, 7947, 7948, 7949, 7950, 7951, 7957, 7959, 7960, 7961, 7962, 7963, 7964, 7965, 7967, 7975, 7976, 7977, 7978, 7979, 7980, 7981, 7982, 7983, 7991, 7992, 7993, 7994, 7995, 7996, 7997, 7998, 7999, 8005, 8007, 8008, 8009, 8010, 8011, 8012, 8013, 8015, 8023, 8024, 8025, 8026, 8027, 8028, 8029, 8030, 8031, 8039, 8040, 8041, 8042, 8043, 8044, 8045, 8046, 8047, 8048, 8049, 8050, 8051, 8052, 8053, 8054, 8055, 8056, 8057, 8058, 8059, 8060, 8061, 8063, 8064, 8065, 8066, 8067, 8068, 8069, 8070, 8071, 8072, 8073, 8074, 8075, 8076, 8077, 8078, 8079, 8080, 8081, 8082, 8083, 8084, 8085, 8086, 8087, 8088, 8089, 8090, 8091, 8092, 8093, 8094, 8095, 8096, 8097, 8098, 8099, 8100, 8101, 8102, 8103, 8104, 8105, 8106, 8107, 8108, 8109, 8110, 8111, 8113, 8114, 8115, 8116, 8117, 8118, 8119, 8120, 8121, 8122, 8123, 8124, 8125, 8126, 8127, 8128, 8129, 8130, 8131, 8132, 8133, 8134, 8135, 8136, 8137, 8138, 8139, 8140, 8141, 8142, 8143, 8146, 8147, 8149, 8151, 8152, 8153, 8154, 8155, 8156, 8157, 8158, 8159, 8162, 8163, 8167, 8168, 8169, 8170, 8171, 8172, 8173, 8174, 8175, 8177, 8178, 8179, 8180, 8181, 8182, 8183, 8184, 8185, 8186, 8187, 8188, 8189, 8190, 8191, 8202, 8203, 8205, 8207, 8208, 8209, 8214, 8215, 8227, 8230, 8231, 8238, 8239, 8242, 8243, 8244, 8245, 8246, 8247, 8251, 8252, 8253, 8254, 8262, 8263, 8264, 8265, 8269, 8274, 8276, 8278, 8279, 8286, 8287, 8291, 8292, 8293, 8297, 8303, 8304, 8305, 8307, 8308, 8309, 8310, 8311, 8312, 8313, 8314, 8315, 8316, 8317, 8318, 8319, 8320, 8321, 8322, 8323, 8324, 8325, 8326, 8327, 8328, 8329, 8330, 8331, 8332, 8333, 8334, 8335, 8336, 8337, 8338, 8339, 8340, 8341, 8342, 8343, 8344, 8345, 8346, 8347, 8348, 8351, 8359, 8360, 8362, 8363, 8364, 8367, 8369, 8373, 8376, 8377, 8378, 8381, 8382, 8383, 8384, 8399, 8417, 8419, 8426, 8427, 8431, 8432, 8447, 8448, 8449, 8450, 8451, 8452, 8453, 8454, 8455, 8456, 8457, 8458, 8462, 8463, 8465, 8467, 8468, 8469, 8470, 8472, 8473, 8474, 8477, 8479, 8480, 8481, 8482, 8483, 8484, 8485, 8486, 8487, 8488, 8489, 8490, 8491, 8492, 8493, 8494, 8496, 8497, 8498, 8499, 8500, 8501, 8502, 8503, 8504, 8505, 8506, 8507, 8508, 8510, 8511, 8512, 8516, 8518, 8519, 8520, 8521, 8523, 8524, 8525, 8526, 8527, 8528, 8529, 8530, 8531, 8532, 8533, 8534, 8535, 8536, 8537, 8538, 8539, 8540, 8541, 8542, 8543, 8544, 8545, 8546, 8547, 8548, 8549, 8550, 8551, 8552, 8553, 8554, 8555, 8556, 8557, 8558, 8559, 8560, 8561, 8562, 8563, 8564, 8565, 8566, 8567, 8568, 8569, 8570, 8571, 8572, 8573, 8574, 8575, 8578, 8579, 8580, 8584, 8585, 8587, 8591, 8682, 8691, 8703, 8747, 8748, 8749, 8750, 8751, 8752, 8945, 8959, 8960, 8961, 9000, 9001, 9002, 9082, 9083, 9084, 9114, 9166, 9168, 9179, 9191, 9192, 9203, 9210, 9214, 9215, 9252, 9254, 9257, 9279, 9290, 9311, 9312, 9313, 9314, 9315, 9316, 9317, 9318, 9319, 9320, 9321, 9322, 9323, 9324, 9325, 9326, 9327, 9328, 9329, 9330, 9331, 9332, 9333, 9334, 9335, 9336, 9337, 9338, 9339, 9340, 9341, 9342, 9343, 9344, 9345, 9346, 9347, 9348, 9349, 9350, 9351, 9371, 9372, 9373, 9374, 9375, 9376, 9377, 9378, 9379, 9380, 9381, 9382, 9383, 9384, 9385, 9386, 9387, 9388, 9389, 9390, 9391, 9392, 9393, 9394, 9395, 9396, 9397, 9398, 9399, 9400, 9401, 9402, 9403, 9404, 9405, 9406, 9407, 9408, 9409, 9410, 9411, 9412, 9413, 9414, 9415, 9416, 9417, 9418, 9419, 9420, 9421, 9422, 9423, 9424, 9425, 9426, 9427, 9428, 9429, 9430, 9431, 9432, 9433, 9434, 9435, 9436, 9437, 9438, 9439, 9440, 9441, 9442, 9443, 9444, 9445, 9446, 9447, 9448, 9449, 9450, 9470, 9471, 9621, 9631, 9711, 9719, 9727, 9747, 9749, 9751, 9752, 9753, 9839, 9841, 9853, 9855, 9865, 9873, 9884, 9885, 9887, 9889, 9905, 9906, 9916, 9919, 9923, 9933, 9934, 9953, 9954, 9955, 9959, 9983, 9984, 9988, 9989, 9993, 9995, 10023, 10024, 10059, 10060, 10061, 10062, 10066, 10069, 10070, 10071, 10078, 10080, 10087, 10101, 10132, 10135, 10159, 10160, 10174, 10175, 10182, 10186, 10187, 10188, 10189, 10191, 10219, 10223, 10239, 10495, 10763, 10764, 10867, 10868, 10869, 10870, 10971, 10972, 11007, 11021, 11027, 11034, 11039, 11043, 11084, 11087, 11092, 11097, 11123, 11125, 11157, 11158, 11159, 11193, 11196, 11208, 11209, 11217, 11218, 11243, 11247, 11262, 11263, 11264, 11265, 11266, 11267, 11268, 11269, 11270, 11271, 11272, 11273, 11274, 11275, 11276, 11277, 11278, 11279, 11280, 11281, 11282, 11283, 11284, 11285, 11286, 11287, 11288, 11289, 11290, 11291, 11292, 11293, 11294, 11295, 11296, 11297, 11298, 11299, 11300, 11301, 11302, 11303, 11304, 11305, 11306, 11307, 11308, 11309, 11310, 11311, 11358, 11359, 11360, 11361, 11362, 11363, 11364, 11366, 11367, 11368, 11369, 11370, 11371, 11372, 11373, 11374, 11375, 11376, 11377, 11378, 11379, 11380, 11381, 11383, 11387, 11388, 11389, 11390, 11391, 11392, 11393, 11394, 11395, 11396, 11397, 11398, 11399, 11400, 11401, 11402, 11403, 11404, 11405, 11406, 11407, 11408, 11409, 11410, 11411, 11412, 11413, 11414, 11415, 11416, 11417, 11418, 11419, 11420, 11421, 11422, 11423, 11424, 11425, 11426, 11427, 11428, 11429, 11430, 11431, 11432, 11433, 11434, 11435, 11436, 11437, 11438, 11439, 11440, 11441, 11442, 11443, 11444, 11445, 11446, 11447, 11448, 11449, 11450, 11451, 11452, 11453, 11454, 11455, 11456, 11457, 11458, 11459, 11460, 11461, 11462, 11463, 11464, 11465, 11466, 11467, 11468, 11469, 11470, 11471, 11472, 11473, 11474, 11475, 11476, 11477, 11478, 11479, 11480, 11481, 11482, 11483, 11484, 11485, 11486, 11487, 11488, 11489, 11490, 11492, 11498, 11499, 11500, 11501, 11505, 11506, 11507, 11512, 11519, 11557, 11558, 11559, 11564, 11565, 11567, 11621, 11623, 11630, 11631, 11632, 11646, 11647, 11670, 11679, 11686, 11687, 11694, 11695, 11702, 11703, 11710, 11711, 11718, 11719, 11726, 11727, 11734, 11735, 11742, 11743, 11775, 11799, 11803, 11805, 11822, 11823, 11824, 11825, 11835, 11842, 11844, 11849, 11854, 11855, 11858, 11869, 11903, 11929, 11930, 11934, 11935, 12018, 12019, 12031, 12032, 12033, 12034, 12035, 12036, 12037, 12038, 12039, 12040, 12041, 12042, 12043, 12044, 12045, 12046, 12047, 12048, 12049, 12050, 12051, 12052, 12053, 12054, 12055, 12056, 12057, 12058, 12059, 12060, 12061, 12062, 12063, 12064, 12065, 12066, 12067, 12068, 12069, 12070, 12071, 12072, 12073, 12074, 12075, 12076, 12077, 12078, 12079, 12080, 12081, 12082, 12083, 12084, 12085, 12086, 12087, 12088, 12089, 12090, 12091, 12092, 12093, 12094, 12095, 12096, 12097, 12098, 12099, 12100, 12101, 12102, 12103, 12104, 12105, 12106, 12107, 12108, 12109, 12110, 12111, 12112, 12113, 12114, 12115, 12116, 12117, 12118, 12119, 12120, 12121, 12122, 12123, 12124, 12125, 12126, 12127, 12128, 12129, 12130, 12131, 12132, 12133, 12134, 12135, 12136, 12137, 12138, 12139, 12140, 12141, 12142, 12143, 12144, 12145, 12146, 12147, 12148, 12149, 12150, 12151, 12152, 12153, 12154, 12155, 12156, 12157, 12158, 12159, 12160, 12161, 12162, 12163, 12164, 12165, 12166, 12167, 12168, 12169, 12170, 12171, 12172, 12173, 12174, 12175, 12176, 12177, 12178, 12179, 12180, 12181, 12182, 12183, 12184, 12185, 12186, 12187, 12188, 12189, 12190, 12191, 12192, 12193, 12194, 12195, 12196, 12197, 12198, 12199, 12200, 12201, 12202, 12203, 12204, 12205, 12206, 12207, 12208, 12209, 12210, 12211, 12212, 12213, 12214, 12215, 12216, 12217, 12218, 12219, 12220, 12221, 12222, 12223, 12224, 12225, 12226, 12227, 12228, 12229, 12230, 12231, 12232, 12233, 12234, 12235, 12236, 12237, 12238, 12239, 12240, 12241, 12242, 12243, 12244, 12245, 12271, 12283, 12287, 12288, 12289, 12290, 12292, 12295, 12329, 12333, 12341, 12342, 12343, 12344, 12345, 12346, 12347, 12348, 12349, 12350, 12351, 12352, 12436, 12438, 12440, 12442, 12443, 12444, 12446, 12447, 12448, 12542, 12543, 12548, 12588, 12589, 12590, 12591, 12592, 12593, 12594, 12595, 12596, 12597, 12598, 12599, 12600, 12601, 12602, 12603, 12604, 12605, 12606, 12607, 12608, 12609, 12610, 12611, 12612, 12613, 12614, 12615, 12616, 12617, 12618, 12619, 12620, 12621, 12622, 12623, 12624, 12625, 12626, 12627, 12628, 12629, 12630, 12631, 12632, 12633, 12634, 12635, 12636, 12637, 12638, 12639, 12640, 12641, 12642, 12643, 12644, 12645, 12646, 12647, 12648, 12649, 12650, 12651, 12652, 12653, 12654, 12655, 12656, 12657, 12658, 12659, 12660, 12661, 12662, 12663, 12664, 12665, 12666, 12667, 12668, 12669, 12670, 12671, 12672, 12673, 12674, 12675, 12676, 12677, 12678, 12679, 12680, 12681, 12682, 12683, 12684, 12685, 12686, 12687, 12689, 12690, 12691, 12692, 12693, 12694, 12695, 12696, 12697, 12698, 12699, 12700, 12701, 12702, 12703, 12727, 12730, 12735, 12751, 12771, 12773, 12782, 12783, 12799, 12800, 12801, 12802, 12803, 12804, 12805, 12806, 12807, 12808, 12809, 12810, 12811, 12812, 12813, 12814, 12815, 12816, 12817, 12818, 12819, 12820, 12821, 12822, 12823, 12824, 12825, 12826, 12827, 12828, 12829, 12830, 12831, 12832, 12833, 12834, 12835, 12836, 12837, 12838, 12839, 12840, 12841, 12842, 12843, 12844, 12845, 12846, 12847, 12848, 12849, 12850, 12851, 12852, 12853, 12854, 12855, 12856, 12857, 12858, 12859, 12860, 12861, 12862, 12863, 12864, 12865, 12866, 12867, 12868, 12869, 12870, 12871, 12879, 12880, 12881, 12882, 12883, 12884, 12885, 12886, 12887, 12888, 12889, 12890, 12891, 12892, 12893, 12894, 12895, 12896, 12897, 12898, 12899, 12900, 12901, 12902, 12903, 12904, 12905, 12906, 12907, 12908, 12909, 12910, 12911, 12912, 12913, 12914, 12915, 12916, 12917, 12918, 12919, 12920, 12921, 12922, 12923, 12924, 12925, 12926, 12927, 12928, 12929, 12930, 12931, 12932, 12933, 12934, 12935, 12936, 12937, 12938, 12939, 12940, 12941, 12942, 12943, 12944, 12945, 12946, 12947, 12948, 12949, 12950, 12951, 12952, 12953, 12954, 12955, 12956, 12957, 12958, 12959, 12960, 12961, 12962, 12963, 12964, 12965, 12966, 12967, 12968, 12969, 12970, 12971, 12972, 12973, 12974, 12975, 12976, 12977, 12978, 12979, 12980, 12981, 12982, 12983, 12984, 12985, 12986, 12987, 12988, 12989, 12990, 12991, 12992, 12993, 12994, 12995, 12996, 12997, 12998, 12999, 13000, 13001, 13002, 13003, 13004, 13005, 13006, 13007, 13008, 13009, 13010, 13011, 13012, 13013, 13014, 13015, 13016, 13017, 13018, 13019, 13020, 13021, 13022, 13023, 13024, 13025, 13026, 13027, 13028, 13029, 13030, 13031, 13032, 13033, 13034, 13035, 13036, 13037, 13038, 13039, 13040, 13041, 13042, 13043, 13044, 13045, 13046, 13047, 13048, 13049, 13050, 13051, 13052, 13053, 13054, 13055, 13056, 13057, 13058, 13059, 13060, 13061, 13062, 13063, 13064, 13065, 13066, 13067, 13068, 13069, 13070, 13071, 13072, 13073, 13074, 13075, 13076, 13077, 13078, 13079, 13080, 13081, 13082, 13083, 13084, 13085, 13086, 13087, 13088, 13089, 13090, 13091, 13092, 13093, 13094, 13095, 13096, 13097, 13098, 13099, 13100, 13101, 13102, 13103, 13104, 13105, 13106, 13107, 13108, 13109, 13110, 13111, 13112, 13113, 13114, 13115, 13116, 13117, 13118, 13119, 13120, 13121, 13122, 13123, 13124, 13125, 13126, 13127, 13128, 13129, 13130, 13131, 13132, 13133, 13134, 13135, 13136, 13137, 13138, 13139, 13140, 13141, 13142, 13143, 13144, 13145, 13146, 13147, 13148, 13149, 13150, 13151, 13152, 13153, 13154, 13155, 13156, 13157, 13158, 13159, 13160, 13161, 13162, 13163, 13164, 13165, 13166, 13167, 13168, 13169, 13170, 13171, 13172, 13173, 13174, 13175, 13176, 13177, 13178, 13179, 13180, 13181, 13182, 13183, 13184, 13185, 13186, 13187, 13188, 13189, 13190, 13191, 13192, 13193, 13194, 13195, 13196, 13197, 13198, 13199, 13200, 13201, 13202, 13203, 13204, 13205, 13206, 13207, 13208, 13209, 13210, 13211, 13212, 13213, 13214, 13215, 13216, 13217, 13218, 13219, 13220, 13221, 13222, 13223, 13224, 13225, 13226, 13227, 13228, 13229, 13230, 13231, 13232, 13233, 13234, 13235, 13236, 13237, 13238, 13239, 13240, 13241, 13242, 13243, 13244, 13245, 13246, 13247, 13248, 13249, 13250, 13251, 13252, 13253, 13254, 13255, 13256, 13257, 13258, 13259, 13260, 13261, 13262, 13263, 13264, 13265, 13266, 13267, 13268, 13269, 13270, 13271, 13272, 13273, 13274, 13275, 13276, 13277, 13278, 13279, 13280, 13281, 13282, 13283, 13284, 13285, 13286, 13287, 13288, 13289, 13290, 13291, 13292, 13293, 13294, 13295, 13296, 13297, 13298, 13299, 13300, 13301, 13302, 13303, 13304, 13305, 13306, 13307, 13308, 13309, 13310, 13311, 19893, 19903, 19967, 40869, 40891, 40899, 40907, 40908, 40917, 40938, 40943, 40956, 40959, 42124, 42127, 42145, 42147, 42163, 42164, 42176, 42177, 42180, 42181, 42182, 42191, 42237, 42239, 42508, 42511, 42539, 42559, 42560, 42561, 42562, 42563, 42564, 42565, 42566, 42567, 42568, 42569, 42570, 42571, 42572, 42573, 42574, 42575, 42576, 42577, 42578, 42579, 42580, 42581, 42582, 42583, 42584, 42585, 42586, 42587, 42588, 42589, 42590, 42591, 42592, 42593, 42594, 42595, 42596, 42597, 42598, 42599, 42600, 42601, 42602, 42603, 42604, 42607, 42611, 42619, 42621, 42622, 42623, 42624, 42625, 42626, 42627, 42628, 42629, 42630, 42631, 42632, 42633, 42634, 42635, 42636, 42637, 42638, 42639, 42640, 42641, 42642, 42643, 42644, 42645, 42646, 42647, 42648, 42649, 42650, 42651, 42652, 42653, 42654, 42655, 42725, 42735, 42737, 42743, 42751, 42774, 42778, 42783, 42785, 42786, 42787, 42788, 42789, 42790, 42791, 42792, 42793, 42794, 42795, 42796, 42797, 42798, 42801, 42802, 42803, 42804, 42805, 42806, 42807, 42808, 42809, 42810, 42811, 42812, 42813, 42814, 42815, 42816, 42817, 42818, 42819, 42820, 42821, 42822, 42823, 42824, 42825, 42826, 42827, 42828, 42829, 42830, 42831, 42832, 42833, 42834, 42835, 42836, 42837, 42838, 42839, 42840, 42841, 42842, 42843, 42844, 42845, 42846, 42847, 42848, 42849, 42850, 42851, 42852, 42853, 42854, 42855, 42856, 42857, 42858, 42859, 42860, 42861, 42862, 42863, 42864, 42872, 42873, 42874, 42875, 42876, 42877, 42878, 42879, 42880, 42881, 42882, 42883, 42884, 42885, 42886, 42888, 42890, 42891, 42892, 42893, 42894, 42895, 42896, 42897, 42898, 42899, 42901, 42902, 42903, 42904, 42905, 42906, 42907, 42908, 42909, 42910, 42911, 42912, 42913, 42914, 42915, 42916, 42917, 42918, 42919, 42920, 42921, 42922, 42923, 42924, 42925, 42926, 42927, 42928, 42929, 42930, 42931, 42932, 42933, 42934, 42935, 42936, 42937, 42938, 42939, 42940, 42941, 42942, 42943, 42944, 42945, 42946, 42947, 42948, 42949, 42950, 42951, 42952, 42953, 42954, 42955, 42956, 42957, 42959, 42960, 42961, 42962, 42963, 42964, 42965, 42966, 42967, 42968, 42969, 42970, 42971, 42972, 42993, 42994, 42995, 42996, 42997, 42998, 42999, 43000, 43001, 43002, 43007, 43047, 43051, 43052, 43055, 43065, 43071, 43123, 43127, 43135, 43204, 43205, 43213, 43215, 43225, 43231, 43255, 43258, 43259, 43260, 43261, 43263, 43309, 43311, 43347, 43358, 43359, 43388, 43391, 43456, 43469, 43470, 43481, 43485, 43487, 43518, 43519, 43574, 43583, 43597, 43599, 43609, 43611, 43615, 43638, 43641, 43643, 43647, 43714, 43738, 43741, 43743, 43759, 43761, 43766, 43776, 43782, 43784, 43790, 43792, 43798, 43807, 43814, 43815, 43822, 43823, 43866, 43867, 43868, 43869, 43870, 43871, 43875, 43877, 43879, 43880, 43881, 43883, 43887, 43888, 43889, 43890, 43891, 43892, 43893, 43894, 43895, 43896, 43897, 43898, 43899, 43900, 43901, 43902, 43903, 43904, 43905, 43906, 43907, 43908, 43909, 43910, 43911, 43912, 43913, 43914, 43915, 43916, 43917, 43918, 43919, 43920, 43921, 43922, 43923, 43924, 43925, 43926, 43927, 43928, 43929, 43930, 43931, 43932, 43933, 43934, 43935, 43936, 43937, 43938, 43939, 43940, 43941, 43942, 43943, 43944, 43945, 43946, 43947, 43948, 43949, 43950, 43951, 43952, 43953, 43954, 43955, 43956, 43957, 43958, 43959, 43960, 43961, 43962, 43963, 43964, 43965, 43966, 43967, 44010, 44011, 44013, 44015, 44025, 44031, 55203, 55215, 55238, 55242, 55291, 55295, 57343, 63743, 63744, 63745, 63746, 63747, 63748, 63749, 63750, 63752, 63753, 63754, 63755, 63756, 63757, 63758, 63759, 63760, 63761, 63762, 63763, 63764, 63765, 63766, 63767, 63768, 63769, 63770, 63771, 63772, 63773, 63774, 63775, 63776, 63777, 63778, 63779, 63780, 63781, 63782, 63783, 63784, 63785, 63786, 63787, 63788, 63789, 63790, 63791, 63792, 63793, 63794, 63795, 63796, 63797, 63798, 63799, 63800, 63801, 63802, 63803, 63804, 63805, 63806, 63807, 63808, 63809, 63810, 63811, 63812, 63813, 63814, 63815, 63816, 63817, 63818, 63819, 63820, 63821, 63822, 63823, 63824, 63825, 63826, 63827, 63828, 63829, 63830, 63831, 63832, 63833, 63834, 63835, 63836, 63837, 63838, 63839, 63840, 63841, 63842, 63843, 63844, 63845, 63846, 63847, 63848, 63849, 63850, 63851, 63852, 63853, 63854, 63855, 63856, 63857, 63858, 63859, 63860, 63861, 63862, 63863, 63864, 63865, 63866, 63867, 63868, 63869, 63870, 63871, 63872, 63873, 63874, 63875, 63876, 63877, 63878, 63879, 63880, 63881, 63882, 63883, 63884, 63885, 63886, 63887, 63888, 63889, 63890, 63891, 63892, 63893, 63894, 63895, 63896, 63897, 63898, 63899, 63900, 63901, 63902, 63903, 63904, 63905, 63906, 63907, 63908, 63909, 63910, 63911, 63912, 63913, 63914, 63915, 63916, 63917, 63918, 63919, 63920, 63921, 63922, 63923, 63924, 63925, 63926, 63927, 63928, 63929, 63930, 63931, 63932, 63933, 63934, 63935, 63936, 63937, 63938, 63939, 63940, 63941, 63942, 63943, 63944, 63945, 63946, 63947, 63948, 63949, 63950, 63951, 63952, 63953, 63954, 63955, 63956, 63957, 63958, 63959, 63960, 63961, 63962, 63963, 63964, 63965, 63966, 63967, 63968, 63969, 63970, 63971, 63972, 63973, 63974, 63975, 63976, 63977, 63978, 63979, 63980, 63981, 63982, 63983, 63984, 63985, 63986, 63987, 63988, 63989, 63990, 63991, 63992, 63993, 63994, 63995, 63996, 63997, 63998, 63999, 64000, 64001, 64002, 64003, 64004, 64005, 64006, 64007, 64008, 64009, 64010, 64011, 64012, 64013, 64015, 64016, 64017, 64018, 64020, 64021, 64022, 64023, 64024, 64025, 64026, 64027, 64028, 64029, 64030, 64031, 64032, 64033, 64034, 64036, 64037, 64038, 64041, 64042, 64043, 64044, 64045, 64046, 64047, 64048, 64049, 64050, 64051, 64052, 64053, 64054, 64055, 64056, 64057, 64058, 64059, 64060, 64061, 64062, 64063, 64064, 64065, 64066, 64067, 64068, 64069, 64070, 64071, 64072, 64073, 64074, 64075, 64076, 64077, 64078, 64079, 64080, 64081, 64082, 64083, 64084, 64085, 64086, 64087, 64088, 64089, 64090, 64091, 64092, 64094, 64095, 64096, 64097, 64098, 64099, 64100, 64101, 64102, 64103, 64104, 64105, 64106, 64107, 64108, 64109, 64111, 64112, 64113, 64114, 64115, 64116, 64117, 64118, 64119, 64120, 64121, 64122, 64123, 64124, 64125, 64126, 64127, 64128, 64129, 64130, 64131, 64132, 64133, 64134, 64135, 64136, 64137, 64138, 64139, 64140, 64141, 64142, 64143, 64144, 64145, 64146, 64147, 64148, 64149, 64150, 64151, 64152, 64153, 64154, 64155, 64156, 64157, 64158, 64159, 64160, 64161, 64162, 64163, 64164, 64165, 64166, 64167, 64168, 64169, 64170, 64171, 64172, 64173, 64174, 64175, 64176, 64177, 64178, 64179, 64180, 64181, 64182, 64183, 64184, 64185, 64186, 64187, 64188, 64189, 64190, 64191, 64192, 64193, 64194, 64195, 64196, 64197, 64198, 64199, 64200, 64201, 64202, 64203, 64204, 64205, 64206, 64207, 64208, 64209, 64210, 64211, 64212, 64213, 64214, 64215, 64216, 64217, 64255, 64256, 64257, 64258, 64259, 64260, 64262, 64274, 64275, 64276, 64277, 64278, 64279, 64284, 64285, 64286, 64287, 64288, 64289, 64290, 64291, 64292, 64293, 64294, 64295, 64296, 64297, 64298, 64299, 64300, 64301, 64302, 64303, 64304, 64305, 64306, 64307, 64308, 64309, 64310, 64311, 64312, 64313, 64314, 64315, 64316, 64317, 64318, 64319, 64320, 64321, 64322, 64323, 64324, 64325, 64326, 64327, 64328, 64329, 64330, 64331, 64332, 64333, 64334, 64335, 64337, 64341, 64345, 64349, 64353, 64357, 64361, 64365, 64369, 64373, 64377, 64381, 64385, 64387, 64389, 64391, 64393, 64395, 64397, 64401, 64405, 64409, 64413, 64415, 64419, 64421, 64425, 64429, 64431, 64433, 64449, 64450, 64466, 64470, 64472, 64474, 64476, 64477, 64479, 64481, 64483, 64487, 64489, 64491, 64493, 64495, 64497, 64499, 64501, 64504, 64507, 64511, 64512, 64513, 64514, 64515, 64516, 64517, 64518, 64519, 64520, 64521, 64522, 64523, 64524, 64525, 64526, 64527, 64528, 64529, 64530, 64531, 64532, 64533, 64534, 64535, 64536, 64537, 64538, 64539, 64540, 64541, 64542, 64543, 64544, 64545, 64546, 64547, 64548, 64549, 64550, 64551, 64552, 64553, 64554, 64555, 64556, 64557, 64558, 64559, 64560, 64561, 64562, 64563, 64564, 64565, 64566, 64567, 64568, 64569, 64570, 64571, 64572, 64573, 64574, 64575, 64576, 64577, 64578, 64579, 64580, 64581, 64582, 64583, 64584, 64585, 64586, 64587, 64588, 64589, 64590, 64591, 64592, 64593, 64594, 64595, 64596, 64597, 64598, 64599, 64600, 64601, 64602, 64603, 64604, 64605, 64606, 64607, 64608, 64609, 64610, 64611, 64612, 64613, 64614, 64615, 64616, 64617, 64618, 64619, 64620, 64621, 64622, 64623, 64624, 64625, 64626, 64627, 64628, 64629, 64630, 64631, 64632, 64633, 64634, 64635, 64636, 64637, 64638, 64639, 64640, 64641, 64642, 64643, 64644, 64645, 64646, 64647, 64648, 64649, 64650, 64651, 64652, 64653, 64654, 64655, 64656, 64657, 64658, 64659, 64660, 64661, 64662, 64663, 64664, 64665, 64666, 64667, 64668, 64669, 64670, 64671, 64672, 64673, 64674, 64675, 64676, 64677, 64678, 64679, 64680, 64681, 64682, 64683, 64684, 64685, 64686, 64687, 64688, 64689, 64690, 64691, 64692, 64693, 64694, 64695, 64696, 64697, 64698, 64699, 64700, 64701, 64702, 64703, 64704, 64705, 64706, 64707, 64708, 64709, 64710, 64711, 64712, 64713, 64714, 64715, 64716, 64717, 64718, 64719, 64720, 64721, 64722, 64723, 64724, 64725, 64726, 64727, 64728, 64729, 64730, 64731, 64732, 64733, 64734, 64735, 64736, 64737, 64738, 64739, 64740, 64741, 64742, 64743, 64744, 64745, 64746, 64747, 64748, 64749, 64750, 64751, 64752, 64753, 64754, 64755, 64756, 64757, 64758, 64759, 64760, 64761, 64762, 64763, 64764, 64765, 64766, 64767, 64768, 64769, 64770, 64771, 64772, 64773, 64774, 64775, 64776, 64777, 64778, 64779, 64780, 64781, 64782, 64783, 64784, 64785, 64786, 64787, 64788, 64789, 64790, 64791, 64792, 64793, 64794, 64795, 64796, 64797, 64798, 64799, 64800, 64801, 64802, 64803, 64804, 64805, 64806, 64807, 64808, 64809, 64810, 64811, 64812, 64813, 64814, 64815, 64816, 64817, 64818, 64819, 64820, 64821, 64822, 64823, 64824, 64825, 64826, 64827, 64829, 64831, 64847, 64848, 64850, 64851, 64852, 64853, 64854, 64855, 64857, 64858, 64859, 64860, 64861, 64862, 64864, 64865, 64867, 64869, 64870, 64872, 64873, 64875, 64877, 64878, 64880, 64882, 64883, 64884, 64885, 64887, 64888, 64889, 64890, 64891, 64893, 64894, 64895, 64896, 64897, 64898, 64900, 64902, 64904, 64905, 64906, 64907, 64908, 64909, 64910, 64911, 64913, 64914, 64915, 64916, 64917, 64918, 64920, 64921, 64922, 64923, 64925, 64926, 64927, 64928, 64929, 64930, 64931, 64932, 64933, 64934, 64935, 64936, 64937, 64938, 64939, 64940, 64941, 64942, 64943, 64944, 64945, 64946, 64947, 64948, 64949, 64950, 64951, 64952, 64953, 64954, 64955, 64956, 64957, 64958, 64959, 64960, 64961, 64962, 64963, 64964, 64965, 64966, 64967, 64974, 64975, 65007, 65008, 65009, 65010, 65011, 65012, 65013, 65014, 65015, 65016, 65017, 65018, 65019, 65020, 65021, 65023, 65039, 65040, 65041, 65042, 65043, 65044, 65045, 65046, 65047, 65048, 65049, 65055, 65059, 65062, 65069, 65071, 65072, 65073, 65074, 65076, 65077, 65078, 65079, 65080, 65081, 65082, 65083, 65084, 65085, 65086, 65087, 65088, 65089, 65090, 65091, 65092, 65094, 65095, 65096, 65100, 65103, 65104, 65105, 65106, 65107, 65108, 65109, 65110, 65111, 65112, 65113, 65114, 65115, 65116, 65117, 65118, 65119, 65120, 65121, 65122, 65123, 65124, 65125, 65126, 65127, 65128, 65129, 65130, 65131, 65135, 65136, 65137, 65138, 65139, 65140, 65141, 65142, 65143, 65144, 65145, 65146, 65147, 65148, 65149, 65150, 65151, 65152, 65154, 65156, 65158, 65160, 65164, 65166, 65170, 65172, 65176, 65180, 65184, 65188, 65192, 65194, 65196, 65198, 65200, 65204, 65208, 65212, 65216, 65220, 65224, 65228, 65232, 65236, 65240, 65244, 65248, 65252, 65256, 65260, 65262, 65264, 65268, 65270, 65272, 65274, 65276, 65278, 65279, 65280, 65281, 65282, 65283, 65284, 65285, 65286, 65287, 65288, 65289, 65290, 65291, 65292, 65293, 65294, 65295, 65296, 65297, 65298, 65299, 65300, 65301, 65302, 65303, 65304, 65305, 65306, 65307, 65308, 65309, 65310, 65311, 65312, 65313, 65314, 65315, 65316, 65317, 65318, 65319, 65320, 65321, 65322, 65323, 65324, 65325, 65326, 65327, 65328, 65329, 65330, 65331, 65332, 65333, 65334, 65335, 65336, 65337, 65338, 65339, 65340, 65341, 65342, 65343, 65344, 65345, 65346, 65347, 65348, 65349, 65350, 65351, 65352, 65353, 65354, 65355, 65356, 65357, 65358, 65359, 65360, 65361, 65362, 65363, 65364, 65365, 65366, 65367, 65368, 65369, 65370, 65371, 65372, 65373, 65374, 65375, 65376, 65377, 65378, 65379, 65380, 65381, 65382, 65383, 65384, 65385, 65386, 65387, 65388, 65389, 65390, 65391, 65392, 65393, 65394, 65395, 65396, 65397, 65398, 65399, 65400, 65401, 65402, 65403, 65404, 65405, 65406, 65407, 65408, 65409, 65410, 65411, 65412, 65413, 65414, 65415, 65416, 65417, 65418, 65419, 65420, 65421, 65422, 65423, 65424, 65425, 65426, 65427, 65428, 65429, 65430, 65431, 65432, 65433, 65434, 65435, 65436, 65437, 65438, 65439, 65440, 65441, 65442, 65443, 65444, 65445, 65446, 65447, 65448, 65449, 65450, 65451, 65452, 65453, 65454, 65455, 65456, 65457, 65458, 65459, 65460, 65461, 65462, 65463, 65464, 65465, 65466, 65467, 65468, 65469, 65470, 65473, 65474, 65475, 65476, 65477, 65478, 65479, 65481, 65482, 65483, 65484, 65485, 65486, 65487, 65489, 65490, 65491, 65492, 65493, 65494, 65495, 65497, 65498, 65499, 65500, 65503, 65504, 65505, 65506, 65507, 65508, 65509, 65510, 65511, 65512, 65513, 65514, 65515, 65516, 65517, 65518, 65528, 65531, 65532, 65533, 65535, 65547, 65548, 65574, 65575, 65594, 65595, 65597, 65598, 65613, 65615, 65629, 65663, 65786, 65791, 65794, 65798, 65843, 65846, 65855, 65930, 65932, 65934, 65935, 65947, 65948, 65951, 65952, 65999, 66044, 66045, 66175, 66204, 66207, 66256, 66271, 66272, 66299, 66303, 66334, 66335, 66339, 66348, 66351, 66368, 66369, 66377, 66378, 66383, 66426, 66431, 66461, 66462, 66463, 66499, 66503, 66511, 66517, 66559, 66560, 66561, 66562, 66563, 66564, 66565, 66566, 66567, 66568, 66569, 66570, 66571, 66572, 66573, 66574, 66575, 66576, 66577, 66578, 66579, 66580, 66581, 66582, 66583, 66584, 66585, 66586, 66587, 66588, 66589, 66590, 66591, 66592, 66593, 66594, 66595, 66596, 66597, 66598, 66599, 66637, 66717, 66719, 66729, 66735, 66736, 66737, 66738, 66739, 66740, 66741, 66742, 66743, 66744, 66745, 66746, 66747, 66748, 66749, 66750, 66751, 66752, 66753, 66754, 66755, 66756, 66757, 66758, 66759, 66760, 66761, 66762, 66763, 66764, 66765, 66766, 66767, 66768, 66769, 66770, 66771, 66775, 66811, 66815, 66855, 66863, 66915, 66926, 66927, 66928, 66929, 66930, 66931, 66932, 66933, 66934, 66935, 66936, 66937, 66938, 66939, 66940, 66941, 66942, 66943, 66944, 66945, 66946, 66947, 66948, 66949, 66950, 66951, 66952, 66953, 66954, 66955, 66956, 66957, 66958, 66959, 66960, 66961, 66962, 66963, 66964, 66965, 66966, 66977, 66978, 66993, 66994, 67001, 67002, 67004, 67007, 67059, 67071, 67382, 67391, 67413, 67423, 67431, 67455, 67456, 67457, 67458, 67459, 67460, 67461, 67462, 67463, 67464, 67465, 67466, 67467, 67468, 67469, 67470, 67471, 67472, 67473, 67474, 67475, 67476, 67477, 67478, 67479, 67480, 67481, 67482, 67483, 67484, 67485, 67486, 67487, 67488, 67489, 67490, 67491, 67492, 67493, 67494, 67495, 67496, 67497, 67498, 67499, 67500, 67501, 67502, 67503, 67504, 67505, 67506, 67507, 67508, 67509, 67510, 67511, 67512, 67513, 67514, 67583, 67589, 67591, 67592, 67593, 67637, 67638, 67640, 67643, 67644, 67646, 67647, 67669, 67670, 67679, 67702, 67711, 67742, 67750, 67759, 67807, 67826, 67827, 67829, 67834, 67839, 67861, 67865, 67867, 67870, 67871, 67897, 67902, 67903, 67967, 68023, 68027, 68029, 68031, 68047, 68049, 68095, 68099, 68100, 68102, 68107, 68115, 68116, 68119, 68120, 68147, 68149, 68151, 68154, 68158, 68159, 68167, 68168, 68175, 68184, 68191, 68220, 68223, 68252, 68255, 68287, 68295, 68296, 68326, 68330, 68342, 68351, 68405, 68408, 68415, 68437, 68439, 68447, 68466, 68471, 68479, 68497, 68504, 68508, 68520, 68527, 68607, 68680, 68735, 68736, 68737, 68738, 68739, 68740, 68741, 68742, 68743, 68744, 68745, 68746, 68747, 68748, 68749, 68750, 68751, 68752, 68753, 68754, 68755, 68756, 68757, 68758, 68759, 68760, 68761, 68762, 68763, 68764, 68765, 68766, 68767, 68768, 68769, 68770, 68771, 68772, 68773, 68774, 68775, 68776, 68777, 68778, 68779, 68780, 68781, 68782, 68783, 68784, 68785, 68786, 68799, 68850, 68857, 68863, 68903, 68911, 68921, 68927, 68943, 68944, 68945, 68946, 68947, 68948, 68949, 68950, 68951, 68952, 68953, 68954, 68955, 68956, 68957, 68958, 68959, 68960, 68961, 68962, 68963, 68964, 68965, 68968, 68973, 68974, 68997, 69005, 69007, 69215, 69246, 69247, 69289, 69290, 69292, 69293, 69295, 69297, 69313, 69316, 69371, 69372, 69375, 69404, 69414, 69415, 69423, 69456, 69465, 69487, 69509, 69513, 69551, 69572, 69579, 69599, 69622, 69631, 69702, 69709, 69713, 69733, 69743, 69749, 69758, 69759, 69818, 69820, 69821, 69825, 69826, 69836, 69837, 69839, 69864, 69871, 69881, 69887, 69940, 69941, 69951, 69955, 69958, 69959, 69967, 70003, 70005, 70006, 70015, 70084, 70088, 70092, 70093, 70095, 70105, 70106, 70107, 70108, 70111, 70112, 70132, 70143, 70161, 70162, 70199, 70205, 70206, 70209, 70271, 70278, 70279, 70280, 70281, 70285, 70286, 70301, 70302, 70312, 70313, 70319, 70378, 70383, 70393, 70399, 70400, 70403, 70404, 70412, 70414, 70416, 70418, 70440, 70441, 70448, 70449, 70451, 70452, 70457, 70458, 70459, 70468, 70470, 70472, 70474, 70477, 70479, 70480, 70486, 70487, 70492, 70499, 70501, 70508, 70511, 70516, 70527, 70537, 70538, 70539, 70541, 70542, 70543, 70581, 70582, 70592, 70593, 70594, 70596, 70597, 70598, 70602, 70603, 70611, 70613, 70614, 70616, 70624, 70626, 70655, 70730, 70735, 70745, 70746, 70747, 70748, 70749, 70750, 70751, 70753, 70783, 70853, 70854, 70855, 70863, 70873, 71039, 71093, 71095, 71104, 71113, 71127, 71133, 71167, 71232, 71235, 71236, 71247, 71257, 71263, 71276, 71295, 71351, 71352, 71353, 71359, 71369, 71375, 71395, 71423, 71449, 71450, 71452, 71467, 71471, 71481, 71487, 71494, 71679, 71738, 71739, 71839, 71840, 71841, 71842, 71843, 71844, 71845, 71846, 71847, 71848, 71849, 71850, 71851, 71852, 71853, 71854, 71855, 71856, 71857, 71858, 71859, 71860, 71861, 71862, 71863, 71864, 71865, 71866, 71867, 71868, 71869, 71870, 71871, 71913, 71922, 71934, 71935, 71942, 71944, 71945, 71947, 71955, 71956, 71958, 71959, 71989, 71990, 71992, 71994, 72003, 72006, 72015, 72025, 72095, 72103, 72105, 72151, 72153, 72161, 72162, 72164, 72191, 72254, 72262, 72263, 72271, 72323, 72325, 72345, 72348, 72349, 72354, 72367, 72383, 72440, 72447, 72457, 72639, 72672, 72673, 72687, 72697, 72703, 72712, 72713, 72758, 72759, 72768, 72773, 72783, 72793, 72812, 72815, 72817, 72847, 72849, 72871, 72872, 72886, 72959, 72966, 72967, 72969, 72970, 73014, 73017, 73018, 73019, 73021, 73022, 73031, 73039, 73049, 73055, 73061, 73062, 73064, 73065, 73102, 73103, 73105, 73106, 73112, 73119, 73129, 73439, 73462, 73464, 73471, 73488, 73489, 73530, 73533, 73538, 73551, 73561, 73562, 73647, 73648, 73663, 73713, 73726, 73727, 74606, 74648, 74649, 74751, 74850, 74862, 74863, 74867, 74868, 74879, 75075, 77711, 77808, 77810, 77823, 78894, 78895, 78904, 78911, 78933, 78943, 82938, 82943, 83526, 90367, 90425, 92159, 92728, 92735, 92766, 92767, 92777, 92781, 92783, 92862, 92863, 92873, 92879, 92909, 92911, 92916, 92917, 92927, 92982, 92991, 92995, 92997, 93007, 93017, 93018, 93025, 93026, 93047, 93052, 93071, 93503, 93548, 93551, 93561, 93759, 93760, 93761, 93762, 93763, 93764, 93765, 93766, 93767, 93768, 93769, 93770, 93771, 93772, 93773, 93774, 93775, 93776, 93777, 93778, 93779, 93780, 93781, 93782, 93783, 93784, 93785, 93786, 93787, 93788, 93789, 93790, 93791, 93823, 93850, 93951, 94020, 94026, 94030, 94031, 94078, 94087, 94094, 94111, 94175, 94176, 94177, 94178, 94179, 94180, 94191, 94193, 94207, 100332, 100337, 100343, 100351, 101106, 101589, 101630, 101631, 101640, 110575, 110579, 110580, 110587, 110588, 110590, 110591, 110593, 110878, 110882, 110897, 110898, 110927, 110930, 110932, 110933, 110947, 110951, 110959, 111355, 113663, 113770, 113775, 113788, 113791, 113800, 113807, 113817, 113819, 113820, 113822, 113823, 113827, 117759, 117973, 117974, 117975, 117976, 117977, 117978, 117979, 117980, 117981, 117982, 117983, 117984, 117985, 117986, 117987, 117988, 117989, 117990, 117991, 117992, 117993, 117994, 117995, 117996, 117997, 117998, 117999, 118000, 118001, 118002, 118003, 118004, 118005, 118006, 118007, 118008, 118009, 118015, 118451, 118527, 118573, 118575, 118598, 118607, 118723, 118783, 119029, 119039, 119078, 119080, 119081, 119133, 119134, 119135, 119136, 119137, 119138, 119139, 119140, 119154, 119162, 119226, 119227, 119228, 119229, 119230, 119231, 119232, 119261, 119272, 119274, 119295, 119365, 119487, 119507, 119519, 119539, 119551, 119638, 119647, 119665, 119672, 119807, 119808, 119809, 119810, 119811, 119812, 119813, 119814, 119815, 119816, 119817, 119818, 119819, 119820, 119821, 119822, 119823, 119824, 119825, 119826, 119827, 119828, 119829, 119830, 119831, 119832, 119833, 119834, 119835, 119836, 119837, 119838, 119839, 119840, 119841, 119842, 119843, 119844, 119845, 119846, 119847, 119848, 119849, 119850, 119851, 119852, 119853, 119854, 119855, 119856, 119857, 119858, 119859, 119860, 119861, 119862, 119863, 119864, 119865, 119866, 119867, 119868, 119869, 119870, 119871, 119872, 119873, 119874, 119875, 119876, 119877, 119878, 119879, 119880, 119881, 119882, 119883, 119884, 119885, 119886, 119887, 119888, 119889, 119890, 119891, 119892, 119893, 119894, 119895, 119896, 119897, 119898, 119899, 119900, 119901, 119902, 119903, 119904, 119905, 119906, 119907, 119908, 119909, 119910, 119911, 119912, 119913, 119914, 119915, 119916, 119917, 119918, 119919, 119920, 119921, 119922, 119923, 119924, 119925, 119926, 119927, 119928, 119929, 119930, 119931, 119932, 119933, 119934, 119935, 119936, 119937, 119938, 119939, 119940, 119941, 119942, 119943, 119944, 119945, 119946, 119947, 119948, 119949, 119950, 119951, 119952, 119953, 119954, 119955, 119956, 119957, 119958, 119959, 119960, 119961, 119962, 119963, 119964, 119965, 119966, 119967, 119969, 119970, 119972, 119973, 119974, 119976, 119977, 119978, 119979, 119980, 119981, 119982, 119983, 119984, 119985, 119986, 119987, 119988, 119989, 119990, 119991, 119992, 119993, 119994, 119995, 119996, 119997, 119998, 119999, 120000, 120001, 120002, 120003, 120004, 120005, 120006, 120007, 120008, 120009, 120010, 120011, 120012, 120013, 120014, 120015, 120016, 120017, 120018, 120019, 120020, 120021, 120022, 120023, 120024, 120025, 120026, 120027, 120028, 120029, 120030, 120031, 120032, 120033, 120034, 120035, 120036, 120037, 120038, 120039, 120040, 120041, 120042, 120043, 120044, 120045, 120046, 120047, 120048, 120049, 120050, 120051, 120052, 120053, 120054, 120055, 120056, 120057, 120058, 120059, 120060, 120061, 120062, 120063, 120064, 120065, 120066, 120067, 120068, 120069, 120070, 120071, 120072, 120073, 120074, 120076, 120077, 120078, 120079, 120080, 120081, 120082, 120083, 120084, 120085, 120086, 120087, 120088, 120089, 120090, 120091, 120092, 120093, 120094, 120095, 120096, 120097, 120098, 120099, 120100, 120101, 120102, 120103, 120104, 120105, 120106, 120107, 120108, 120109, 120110, 120111, 120112, 120113, 120114, 120115, 120116, 120117, 120118, 120119, 120120, 120121, 120122, 120123, 120124, 120125, 120126, 120127, 120128, 120129, 120130, 120131, 120132, 120133, 120134, 120137, 120138, 120139, 120140, 120141, 120142, 120143, 120144, 120145, 120146, 120147, 120148, 120149, 120150, 120151, 120152, 120153, 120154, 120155, 120156, 120157, 120158, 120159, 120160, 120161, 120162, 120163, 120164, 120165, 120166, 120167, 120168, 120169, 120170, 120171, 120172, 120173, 120174, 120175, 120176, 120177, 120178, 120179, 120180, 120181, 120182, 120183, 120184, 120185, 120186, 120187, 120188, 120189, 120190, 120191, 120192, 120193, 120194, 120195, 120196, 120197, 120198, 120199, 120200, 120201, 120202, 120203, 120204, 120205, 120206, 120207, 120208, 120209, 120210, 120211, 120212, 120213, 120214, 120215, 120216, 120217, 120218, 120219, 120220, 120221, 120222, 120223, 120224, 120225, 120226, 120227, 120228, 120229, 120230, 120231, 120232, 120233, 120234, 120235, 120236, 120237, 120238, 120239, 120240, 120241, 120242, 120243, 120244, 120245, 120246, 120247, 120248, 120249, 120250, 120251, 120252, 120253, 120254, 120255, 120256, 120257, 120258, 120259, 120260, 120261, 120262, 120263, 120264, 120265, 120266, 120267, 120268, 120269, 120270, 120271, 120272, 120273, 120274, 120275, 120276, 120277, 120278, 120279, 120280, 120281, 120282, 120283, 120284, 120285, 120286, 120287, 120288, 120289, 120290, 120291, 120292, 120293, 120294, 120295, 120296, 120297, 120298, 120299, 120300, 120301, 120302, 120303, 120304, 120305, 120306, 120307, 120308, 120309, 120310, 120311, 120312, 120313, 120314, 120315, 120316, 120317, 120318, 120319, 120320, 120321, 120322, 120323, 120324, 120325, 120326, 120327, 120328, 120329, 120330, 120331, 120332, 120333, 120334, 120335, 120336, 120337, 120338, 120339, 120340, 120341, 120342, 120343, 120344, 120345, 120346, 120347, 120348, 120349, 120350, 120351, 120352, 120353, 120354, 120355, 120356, 120357, 120358, 120359, 120360, 120361, 120362, 120363, 120364, 120365, 120366, 120367, 120368, 120369, 120370, 120371, 120372, 120373, 120374, 120375, 120376, 120377, 120378, 120379, 120380, 120381, 120382, 120383, 120384, 120385, 120386, 120387, 120388, 120389, 120390, 120391, 120392, 120393, 120394, 120395, 120396, 120397, 120398, 120399, 120400, 120401, 120402, 120403, 120404, 120405, 120406, 120407, 120408, 120409, 120410, 120411, 120412, 120413, 120414, 120415, 120416, 120417, 120418, 120419, 120420, 120421, 120422, 120423, 120424, 120425, 120426, 120427, 120428, 120429, 120430, 120431, 120432, 120433, 120434, 120435, 120436, 120437, 120438, 120439, 120440, 120441, 120442, 120443, 120444, 120445, 120446, 120447, 120448, 120449, 120450, 120451, 120452, 120453, 120454, 120455, 120456, 120457, 120458, 120459, 120460, 120461, 120462, 120463, 120464, 120465, 120466, 120467, 120468, 120469, 120470, 120471, 120472, 120473, 120474, 120475, 120476, 120477, 120478, 120479, 120480, 120481, 120482, 120483, 120484, 120485, 120487, 120488, 120489, 120490, 120491, 120492, 120493, 120494, 120495, 120496, 120497, 120498, 120499, 120500, 120501, 120502, 120503, 120504, 120505, 120506, 120507, 120508, 120509, 120510, 120511, 120512, 120513, 120514, 120515, 120516, 120517, 120518, 120519, 120520, 120521, 120522, 120523, 120524, 120525, 120526, 120527, 120528, 120529, 120530, 120532, 120533, 120534, 120535, 120536, 120537, 120538, 120539, 120540, 120541, 120542, 120543, 120544, 120545, 120546, 120547, 120548, 120549, 120550, 120551, 120552, 120553, 120554, 120555, 120556, 120557, 120558, 120559, 120560, 120561, 120562, 120563, 120564, 120565, 120566, 120567, 120568, 120569, 120570, 120571, 120572, 120573, 120574, 120575, 120576, 120577, 120578, 120579, 120580, 120581, 120582, 120583, 120584, 120585, 120586, 120587, 120588, 120590, 120591, 120592, 120593, 120594, 120595, 120596, 120597, 120598, 120599, 120600, 120601, 120602, 120603, 120604, 120605, 120606, 120607, 120608, 120609, 120610, 120611, 120612, 120613, 120614, 120615, 120616, 120617, 120618, 120619, 120620, 120621, 120622, 120623, 120624, 120625, 120626, 120627, 120628, 120629, 120630, 120631, 120632, 120633, 120634, 120635, 120636, 120637, 120638, 120639, 120640, 120641, 120642, 120643, 120644, 120645, 120646, 120648, 120649, 120650, 120651, 120652, 120653, 120654, 120655, 120656, 120657, 120658, 120659, 120660, 120661, 120662, 120663, 120664, 120665, 120666, 120667, 120668, 120669, 120670, 120671, 120672, 120673, 120674, 120675, 120676, 120677, 120678, 120679, 120680, 120681, 120682, 120683, 120684, 120685, 120686, 120687, 120688, 120689, 120690, 120691, 120692, 120693, 120694, 120695, 120696, 120697, 120698, 120699, 120700, 120701, 120702, 120703, 120704, 120706, 120707, 120708, 120709, 120710, 120711, 120712, 120713, 120714, 120715, 120716, 120717, 120718, 120719, 120720, 120721, 120722, 120723, 120724, 120725, 120726, 120727, 120728, 120729, 120730, 120731, 120732, 120733, 120734, 120735, 120736, 120737, 120738, 120739, 120740, 120741, 120742, 120743, 120744, 120745, 120746, 120747, 120748, 120749, 120750, 120751, 120752, 120753, 120754, 120755, 120756, 120757, 120758, 120759, 120760, 120761, 120762, 120764, 120765, 120766, 120767, 120768, 120769, 120770, 120771, 120772, 120773, 120774, 120775, 120776, 120777, 120779, 120781, 120782, 120783, 120784, 120785, 120786, 120787, 120788, 120789, 120790, 120791, 120792, 120793, 120794, 120795, 120796, 120797, 120798, 120799, 120800, 120801, 120802, 120803, 120804, 120805, 120806, 120807, 120808, 120809, 120810, 120811, 120812, 120813, 120814, 120815, 120816, 120817, 120818, 120819, 120820, 120821, 120822, 120823, 120824, 120825, 120826, 120827, 120828, 120829, 120830, 120831, 121343, 121398, 121402, 121452, 121460, 121461, 121475, 121476, 121483, 121498, 121503, 121504, 121519, 122623, 122654, 122660, 122666, 122879, 122886, 122887, 122904, 122906, 122913, 122914, 122916, 122917, 122922, 122927, 122928, 122929, 122930, 122931, 122932, 122933, 122934, 122935, 122936, 122937, 122938, 122939, 122940, 122941, 122942, 122943, 122944, 122945, 122946, 122947, 122948, 122949, 122950, 122951, 122952, 122953, 122954, 122955, 122956, 122957, 122958, 122959, 122960, 122961, 122962, 122963, 122964, 122965, 122966, 122967, 122968, 122969, 122970, 122971, 122972, 122973, 122974, 122975, 122976, 122977, 122978, 122979, 122980, 122981, 122982, 122983, 122984, 122985, 122986, 122987, 122988, 122989, 123022, 123023, 123135, 123180, 123183, 123197, 123199, 123209, 123213, 123214, 123215, 123535, 123566, 123583, 123641, 123646, 123647, 124111, 124153, 124367, 124410, 124414, 124415, 124895, 124902, 124903, 124907, 124908, 124910, 124911, 124926, 124927, 125124, 125126, 125135, 125142, 125183, 125184, 125185, 125186, 125187, 125188, 125189, 125190, 125191, 125192, 125193, 125194, 125195, 125196, 125197, 125198, 125199, 125200, 125201, 125202, 125203, 125204, 125205, 125206, 125207, 125208, 125209, 125210, 125211, 125212, 125213, 125214, 125215, 125216, 125217, 125258, 125259, 125263, 125273, 125277, 125279, 126064, 126132, 126208, 126269, 126463, 126464, 126465, 126466, 126467, 126468, 126469, 126470, 126471, 126472, 126473, 126474, 126475, 126476, 126477, 126478, 126479, 126480, 126481, 126482, 126483, 126484, 126485, 126486, 126487, 126488, 126489, 126490, 126491, 126492, 126493, 126494, 126495, 126496, 126497, 126498, 126499, 126500, 126502, 126503, 126504, 126505, 126506, 126507, 126508, 126509, 126510, 126511, 126512, 126513, 126514, 126515, 126516, 126517, 126518, 126519, 126520, 126521, 126522, 126523, 126529, 126530, 126534, 126535, 126536, 126537, 126538, 126539, 126540, 126541, 126542, 126543, 126544, 126545, 126546, 126547, 126548, 126550, 126551, 126552, 126553, 126554, 126555, 126556, 126557, 126558, 126559, 126560, 126561, 126562, 126563, 126564, 126566, 126567, 126568, 126569, 126570, 126571, 126572, 126573, 126574, 126575, 126576, 126577, 126578, 126579, 126580, 126581, 126582, 126583, 126584, 126585, 126586, 126587, 126588, 126589, 126590, 126591, 126592, 126593, 126594, 126595, 126596, 126597, 126598, 126599, 126600, 126601, 126602, 126603, 126604, 126605, 126606, 126607, 126608, 126609, 126610, 126611, 126612, 126613, 126614, 126615, 126616, 126617, 126618, 126619, 126624, 126625, 126626, 126627, 126628, 126629, 126630, 126631, 126632, 126633, 126634, 126635, 126636, 126637, 126638, 126639, 126640, 126641, 126642, 126643, 126644, 126645, 126646, 126647, 126648, 126649, 126650, 126651, 126703, 126705, 126975, 127019, 127023, 127123, 127135, 127150, 127152, 127166, 127167, 127168, 127183, 127184, 127199, 127221, 127231, 127232, 127233, 127234, 127235, 127236, 127237, 127238, 127239, 127240, 127241, 127242, 127244, 127247, 127248, 127249, 127250, 127251, 127252, 127253, 127254, 127255, 127256, 127257, 127258, 127259, 127260, 127261, 127262, 127263, 127264, 127265, 127266, 127267, 127268, 127269, 127270, 127271, 127272, 127273, 127274, 127275, 127276, 127277, 127278, 127279, 127280, 127281, 127282, 127283, 127284, 127285, 127286, 127287, 127288, 127289, 127290, 127291, 127292, 127293, 127294, 127295, 127296, 127297, 127298, 127299, 127300, 127301, 127302, 127303, 127304, 127305, 127306, 127307, 127308, 127309, 127310, 127311, 127318, 127319, 127326, 127327, 127337, 127338, 127339, 127340, 127343, 127352, 127353, 127354, 127356, 127358, 127359, 127369, 127373, 127375, 127376, 127386, 127404, 127405, 127461, 127487, 127488, 127489, 127490, 127503, 127504, 127505, 127506, 127507, 127508, 127509, 127510, 127511, 127512, 127513, 127514, 127515, 127516, 127517, 127518, 127519, 127520, 127521, 127522, 127523, 127524, 127525, 127526, 127527, 127528, 127529, 127530, 127531, 127532, 127533, 127534, 127535, 127536, 127537, 127538, 127539, 127540, 127541, 127542, 127543, 127544, 127545, 127546, 127547, 127551, 127552, 127553, 127554, 127555, 127556, 127557, 127558, 127559, 127560, 127567, 127568, 127569, 127583, 127589, 127743, 127776, 127788, 127791, 127797, 127798, 127868, 127869, 127871, 127891, 127903, 127940, 127941, 127946, 127950, 127955, 127967, 127984, 127991, 127999, 128062, 128063, 128064, 128065, 128247, 128248, 128252, 128254, 128255, 128317, 128319, 128323, 128330, 128335, 128359, 128377, 128378, 128419, 128420, 128506, 128511, 128512, 128528, 128529, 128532, 128533, 128534, 128535, 128536, 128537, 128538, 128539, 128542, 128543, 128549, 128551, 128555, 128556, 128557, 128559, 128563, 128564, 128576, 128578, 128580, 128591, 128639, 128709, 128719, 128720, 128722, 128724, 128725, 128727, 128731, 128732, 128735, 128748, 128751, 128755, 128758, 128760, 128761, 128762, 128764, 128767, 128883, 128886, 128890, 128895, 128980, 128984, 128985, 128991, 129003, 129007, 129008, 129023, 129035, 129039, 129095, 129103, 129113, 129119, 129159, 129167, 129197, 129199, 129201, 129211, 129215, 129217, 129279, 129291, 129292, 129295, 129304, 129310, 129311, 129319, 129327, 129328, 129330, 129342, 129343, 129355, 129356, 129359, 129374, 129387, 129392, 129393, 129394, 129398, 129400, 129401, 129402, 129403, 129407, 129412, 129425, 129431, 129442, 129444, 129450, 129453, 129455, 129465, 129471, 129472, 129474, 129482, 129483, 129484, 129487, 129510, 129535, 129619, 129631, 129645, 129647, 129651, 129652, 129655, 129658, 129660, 129663, 129666, 129670, 129672, 129673, 129678, 129679, 129685, 129704, 129708, 129711, 129718, 129722, 129725, 129726, 129727, 129730, 129733, 129734, 129741, 129743, 129750, 129753, 129755, 129756, 129758, 129759, 129767, 129768, 129769, 129775, 129782, 129784, 129791, 129938, 129939, 129994, 130031, 130032, 130033, 130034, 130035, 130036, 130037, 130038, 130039, 130040, 130041, 131069, 131071, 173782, 173789, 173791, 173823, 177972, 177976, 177977, 177983, 178205, 178207, 183969, 183983, 191456, 191471, 192093, 194559, 194560, 194561, 194562, 194563, 194564, 194565, 194566, 194567, 194568, 194569, 194570, 194571, 194572, 194573, 194574, 194575, 194576, 194577, 194578, 194579, 194580, 194581, 194582, 194583, 194584, 194585, 194586, 194587, 194588, 194589, 194590, 194591, 194592, 194593, 194594, 194595, 194596, 194597, 194598, 194599, 194600, 194601, 194602, 194603, 194604, 194605, 194606, 194607, 194608, 194611, 194612, 194613, 194614, 194615, 194616, 194617, 194618, 194619, 194620, 194621, 194622, 194623, 194624, 194625, 194626, 194627, 194628, 194630, 194631, 194632, 194633, 194634, 194635, 194636, 194637, 194638, 194639, 194640, 194641, 194642, 194643, 194644, 194645, 194646, 194647, 194648, 194649, 194650, 194651, 194652, 194653, 194654, 194655, 194656, 194657, 194658, 194659, 194660, 194661, 194662, 194663, 194664, 194665, 194667, 194668, 194669, 194670, 194671, 194672, 194673, 194674, 194675, 194676, 194677, 194678, 194679, 194680, 194681, 194682, 194683, 194684, 194685, 194686, 194687, 194688, 194689, 194690, 194691, 194692, 194693, 194694, 194695, 194696, 194697, 194698, 194699, 194700, 194701, 194702, 194703, 194704, 194706, 194707, 194709, 194710, 194711, 194712, 194713, 194714, 194715, 194716, 194717, 194718, 194719, 194720, 194721, 194722, 194723, 194724, 194725, 194726, 194727, 194728, 194729, 194730, 194731, 194732, 194733, 194734, 194735, 194736, 194737, 194738, 194739, 194740, 194741, 194742, 194743, 194744, 194745, 194746, 194747, 194748, 194749, 194750, 194751, 194752, 194753, 194754, 194755, 194756, 194757, 194758, 194759, 194760, 194761, 194762, 194763, 194764, 194765, 194766, 194767, 194768, 194769, 194770, 194771, 194772, 194773, 194774, 194775, 194776, 194777, 194778, 194779, 194780, 194781, 194782, 194783, 194784, 194785, 194786, 194787, 194788, 194789, 194790, 194791, 194792, 194793, 194794, 194795, 194796, 194797, 194798, 194799, 194800, 194801, 194802, 194803, 194804, 194805, 194806, 194807, 194808, 194809, 194810, 194811, 194812, 194813, 194814, 194815, 194816, 194817, 194818, 194819, 194820, 194821, 194822, 194823, 194824, 194825, 194826, 194827, 194828, 194829, 194830, 194831, 194832, 194833, 194834, 194835, 194836, 194837, 194838, 194839, 194840, 194841, 194842, 194843, 194844, 194845, 194846, 194847, 194848, 194849, 194850, 194851, 194852, 194853, 194854, 194855, 194856, 194857, 194858, 194859, 194861, 194862, 194863, 194864, 194865, 194866, 194867, 194868, 194869, 194870, 194871, 194872, 194873, 194874, 194875, 194876, 194877, 194878, 194879, 194880, 194881, 194882, 194883, 194884, 194885, 194887, 194888, 194889, 194890, 194891, 194892, 194893, 194894, 194895, 194896, 194897, 194898, 194899, 194900, 194901, 194902, 194903, 194904, 194905, 194906, 194907, 194908, 194910, 194911, 194912, 194913, 194914, 194915, 194916, 194917, 194918, 194919, 194920, 194921, 194922, 194923, 194924, 194925, 194926, 194927, 194928, 194929, 194930, 194931, 194932, 194933, 194934, 194935, 194936, 194937, 194938, 194939, 194940, 194941, 194942, 194943, 194944, 194945, 194946, 194947, 194948, 194949, 194950, 194951, 194952, 194953, 194954, 194955, 194956, 194957, 194958, 194959, 194960, 194961, 194962, 194963, 194964, 194965, 194966, 194967, 194968, 194969, 194970, 194971, 194972, 194973, 194974, 194975, 194976, 194977, 194978, 194979, 194980, 194981, 194982, 194983, 194984, 194985, 194986, 194987, 194988, 194989, 194990, 194991, 194992, 194993, 194994, 194995, 194996, 194997, 194998, 194999, 195000, 195001, 195002, 195003, 195004, 195005, 195006, 195007, 195008, 195009, 195010, 195011, 195012, 195013, 195014, 195015, 195016, 195017, 195018, 195019, 195020, 195021, 195022, 195023, 195024, 195025, 195026, 195027, 195028, 195029, 195030, 195031, 195032, 195033, 195034, 195035, 195036, 195037, 195038, 195039, 195040, 195041, 195042, 195043, 195044, 195045, 195046, 195047, 195048, 195049, 195050, 195051, 195052, 195053, 195054, 195055, 195056, 195057, 195058, 195059, 195060, 195061, 195062, 195063, 195064, 195065, 195066, 195067, 195068, 195069, 195071, 195072, 195073, 195074, 195075, 195076, 195077, 195078, 195079, 195080, 195081, 195082, 195083, 195084, 195085, 195086, 195087, 195088, 195089, 195090, 195091, 195092, 195093, 195094, 195095, 195096, 195097, 195098, 195099, 195100, 195101, 196605, 196607, 201546, 201551, 205743, 262141, 262143, 327677, 327679, 393213, 393215, 458749, 458751, 524285, 524287, 589821, 589823, 655357, 655359, 720893, 720895, 786429, 786431, 851965, 851967, 917501, 917503, 917504, 917505, 917535, 917631, 917759, 917999, 983037, 983039, 1048573, 1048575, 1114109, 1114111];
const _M0FP410tonyfettes7unicode8internal4idna21idna__range__statuses = [0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 4, 2, 0, 2, 0, 2, 0, 1, 0, 2, 0, 2, 2, 2, 2, 0, 0, 2, 2, 2, 0, 2, 2, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 2, 2, 2, 2, 2, 2, 3, 0, 0, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 2, 0, 2, 0, 2, 0, 2, 0, 2, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 2, 0, 2, 0, 2, 0, 2, 0, 2, 2, 0, 2, 0, 2, 2, 0, 2, 2, 2, 0, 2, 2, 2, 2, 0, 2, 2, 0, 2, 2, 2, 0, 2, 2, 0, 2, 2, 0, 2, 0, 2, 0, 2, 2, 0, 2, 0, 2, 0, 2, 2, 0, 2, 2, 2, 0, 2, 0, 2, 2, 0, 2, 0, 2, 2, 2, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 2, 0, 2, 2, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 0, 0, 2, 2, 0, 2, 2, 0, 2, 0, 2, 2, 2, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 0, 0, 2, 2, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 2, 2, 0, 2, 2, 2, 0, 1, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 2, 0, 2, 0, 4, 2, 0, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 4, 2, 4, 2, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 3, 0, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 2, 2, 0, 2, 2, 0, 2, 0, 2, 2, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 0, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 0, 0, 0, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 0, 0, 0, 0, 2, 0, 0, 0, 4, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 4, 0, 0, 4, 4, 4, 4, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 4, 0, 0, 0, 4, 0, 0, 0, 0, 0, 4, 0, 0, 4, 0, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 0, 4, 4, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 0, 4, 0, 4, 0, 0, 4, 0, 4, 2, 2, 4, 2, 0, 4, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 2, 4, 0, 2, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 2, 2, 2, 0, 4, 2, 4, 0, 0, 0, 4, 0, 4, 0, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 0, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 0, 4, 2, 2, 4, 0, 0, 4, 0, 0, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 0, 0, 4, 0, 0, 0, 0, 4, 0, 4, 0, 4, 0, 0, 0, 4, 0, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 4, 0, 0, 4, 0, 4, 0, 0, 0, 0, 0, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 0, 4, 0, 4, 0, 0, 4, 0, 0, 0, 0, 0, 4, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 4, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 2, 0, 4, 0, 0, 0, 0, 0, 4, 0, 4, 0, 4, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 4, 0, 0, 0, 0, 0, 2, 0, 0, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 4, 2, 2, 0, 4, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 4, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 0, 4, 0, 2, 0, 2, 2, 2, 2, 2, 0, 2, 0, 0, 0, 0, 0, 2, 0, 0, 0, 4, 0, 2, 0, 2, 0, 2, 0, 2, 0, 0, 0, 0, 2, 0, 4, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 4, 2, 4, 0, 0, 0, 0, 2, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 0, 4, 0, 4, 0, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 0, 4, 0, 0, 0, 0, 0, 4, 0, 4, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 4, 0, 0, 4, 0, 0, 4, 2, 2, 2, 2, 2, 2, 4, 0, 0, 0, 0, 0, 4, 0, 0, 4, 0, 0, 0, 4, 0, 0, 0, 0, 4, 0, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 1, 0, 0, 0, 0, 0, 0, 4, 0, 4, 0, 4, 0, 1, 1, 0, 4, 0, 0, 4, 0, 0, 4, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 4, 0, 0, 4, 0, 4, 0, 0, 4, 0, 0, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 0, 4, 0, 0, 0, 0, 4, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 4, 0, 0, 4, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 0, 4, 0, 0, 0, 0, 0, 0, 0, 4, 0, 2, 2, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 0, 4, 2, 2, 2, 2, 2, 2, 4, 0, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 0, 4, 2, 2, 2, 2, 2, 2, 4, 0, 4, 2, 4, 2, 4, 2, 4, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 2, 2, 4, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 4, 0, 2, 2, 2, 2, 4, 2, 2, 2, 0, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 4, 0, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 1, 3, 4, 0, 2, 0, 2, 0, 4, 0, 4, 2, 0, 2, 2, 0, 2, 2, 0, 2, 0, 2, 0, 2, 2, 2, 0, 0, 0, 0, 2, 0, 2, 1, 1, 4, 4, 1, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 4, 2, 2, 2, 2, 0, 2, 2, 2, 0, 2, 2, 2, 2, 2, 2, 0, 2, 2, 0, 2, 2, 2, 0, 2, 2, 2, 0, 2, 0, 2, 0, 2, 0, 2, 2, 2, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 2, 2, 2, 2, 0, 2, 2, 2, 2, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 0, 0, 2, 0, 4, 0, 0, 0, 0, 2, 2, 0, 2, 2, 0, 0, 0, 0, 0, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 2, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 2, 0, 2, 2, 2, 0, 2, 0, 2, 0, 2, 0, 2, 2, 2, 2, 0, 2, 0, 0, 2, 0, 0, 2, 2, 2, 2, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 0, 2, 0, 2, 0, 2, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 0, 4, 2, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 4, 0, 2, 0, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 4, 4, 2, 0, 2, 0, 0, 0, 0, 0, 2, 0, 2, 2, 2, 0, 0, 0, 0, 0, 4, 0, 0, 4, 0, 2, 2, 0, 2, 0, 0, 2, 4, 0, 0, 0, 0, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 0, 0, 0, 4, 4, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 4, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 2, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 0, 2, 0, 2, 0, 0, 2, 0, 2, 0, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 2, 2, 2, 2, 0, 2, 2, 2, 2, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 2, 2, 2, 0, 2, 0, 2, 2, 0, 4, 2, 0, 4, 0, 4, 0, 2, 0, 2, 0, 2, 0, 2, 4, 2, 2, 2, 2, 0, 0, 2, 2, 0, 0, 0, 0, 0, 4, 0, 4, 0, 0, 4, 0, 0, 4, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 4, 0, 0, 4, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 2, 2, 2, 2, 0, 0, 0, 0, 2, 0, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 4, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 0, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 0, 2, 0, 2, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 4, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 4, 2, 4, 2, 2, 4, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 0, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 1, 2, 2, 4, 2, 2, 2, 2, 2, 2, 4, 4, 0, 0, 0, 0, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 2, 2, 2, 2, 2, 4, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 4, 2, 2, 2, 0, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 1, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 4, 4, 4, 4, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 0, 0, 4, 0, 0, 4, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 0, 0, 4, 0, 0, 0, 0, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 0, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 4, 0, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 0, 4, 0, 4, 0, 4, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 0, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 0, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 0, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 4, 0, 0, 0, 4, 0, 4, 0, 0, 0, 0, 4, 0, 0, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 0, 4, 0, 0, 4, 0, 4, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 0, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 0, 0, 0, 0, 4, 0, 0, 4, 0, 0, 4, 0, 0, 4, 0, 4, 0, 0, 4, 0, 0, 0, 4, 0, 0, 0, 4, 0, 0, 4, 4, 4, 0, 4, 0, 4, 0, 4, 0, 0, 0, 0, 4, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 4, 0, 4, 0, 0, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 4, 0, 0, 0, 4, 0, 4, 0, 4, 0, 0, 0, 0, 4, 0, 0, 0, 4, 0, 4, 0, 4, 0, 0, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 4, 0, 0, 0, 4, 0, 0, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 0, 4, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 4, 0, 0, 4, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 0, 0, 0, 4, 0, 4, 0, 4, 0, 0, 0, 0, 4, 0, 0, 4, 0, 0, 4, 0, 4, 0, 0, 4, 0, 0, 4, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 0, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 0, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 4, 0, 0, 4, 0, 0, 0, 4, 0, 4, 0, 0, 0, 0, 0, 4, 0, 4, 0, 0, 0, 4, 0, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 0, 1, 4, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 2, 2, 2, 2, 2, 2, 2, 0, 1, 0, 2, 2, 2, 2, 2, 2, 0, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 4, 2, 4, 2, 2, 4, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 4, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 4, 2, 4, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 4, 2, 4, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 4, 2, 4, 2, 4, 2, 4, 2, 4, 2, 4, 2, 4, 2, 2, 2, 4, 2, 2, 4, 2, 4, 2, 4, 2, 4, 2, 4, 2, 4, 2, 4, 2, 2, 4, 2, 4, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 4, 2, 2, 2, 2, 4, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 4, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 4, 0, 0, 4, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 0, 0, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 4, 0, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 4, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 4, 0, 0, 4, 0, 0, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 0, 4, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 4, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 4, 0, 0, 4, 0, 4, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 4, 0, 0, 0, 4, 0, 0, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 4, 0, 4, 0, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 1, 4, 4, 4, 4, 4, 4];
const _M0FP410tonyfettes7unicode8internal4idna21idna__mapping__starts = [0, 0, 0, 0, 0, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 26, 26, 26, 26, 27, 27, 29, 29, 30, 30, 30, 30, 32, 32, 33, 34, 36, 37, 37, 37, 39, 40, 41, 41, 44, 47, 50, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 73, 74, 75, 76, 77, 78, 79, 80, 82, 82, 82, 82, 83, 83, 84, 84, 85, 85, 86, 86, 87, 87, 88, 88, 89, 89, 90, 90, 91, 91, 92, 92, 93, 93, 94, 94, 95, 95, 96, 96, 97, 97, 98, 98, 99, 99, 100, 100, 101, 101, 102, 102, 103, 103, 104, 104, 105, 105, 106, 106, 108, 108, 110, 111, 111, 112, 112, 113, 113, 114, 114, 115, 115, 117, 118, 118, 119, 119, 120, 120, 121, 121, 123, 124, 124, 125, 125, 126, 126, 127, 127, 128, 128, 129, 129, 130, 130, 131, 131, 132, 132, 133, 133, 134, 134, 135, 135, 136, 136, 137, 137, 138, 138, 139, 139, 140, 140, 141, 141, 142, 142, 143, 143, 144, 144, 145, 145, 146, 146, 147, 148, 148, 149, 149, 150, 150, 151, 151, 152, 153, 153, 154, 154, 155, 156, 156, 157, 158, 159, 159, 160, 161, 162, 163, 163, 164, 165, 165, 166, 167, 168, 168, 169, 170, 170, 171, 172, 172, 173, 173, 174, 174, 175, 176, 176, 177, 177, 178, 178, 179, 180, 180, 181, 182, 183, 183, 184, 184, 185, 186, 186, 187, 187, 189, 191, 193, 194, 194, 195, 195, 196, 196, 197, 197, 198, 198, 199, 199, 200, 200, 201, 201, 202, 202, 203, 203, 204, 204, 205, 205, 206, 206, 207, 207, 208, 208, 209, 209, 210, 210, 212, 213, 213, 214, 215, 216, 216, 217, 217, 218, 218, 219, 219, 220, 220, 221, 221, 222, 222, 223, 223, 224, 224, 225, 225, 226, 226, 227, 227, 228, 228, 229, 229, 230, 230, 231, 231, 232, 232, 233, 233, 234, 234, 235, 235, 236, 236, 237, 237, 238, 238, 239, 239, 240, 240, 241, 241, 242, 242, 243, 243, 244, 244, 245, 245, 245, 245, 246, 247, 247, 248, 249, 249, 250, 250, 251, 252, 253, 254, 254, 255, 255, 256, 256, 257, 257, 258, 258, 258, 258, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 267, 267, 267, 267, 269, 271, 273, 275, 277, 279, 279, 279, 280, 281, 282, 283, 284, 284, 284, 284, 284, 284, 284, 284, 285, 286, 286, 287, 289, 290, 290, 290, 290, 290, 290, 290, 290, 290, 291, 291, 292, 292, 293, 293, 294, 294, 294, 296, 296, 297, 298, 298, 300, 303, 304, 305, 306, 307, 308, 308, 309, 309, 310, 311, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 337, 338, 338, 339, 340, 341, 342, 343, 344, 345, 346, 346, 347, 347, 348, 348, 349, 349, 350, 350, 351, 351, 352, 352, 353, 353, 354, 354, 355, 355, 356, 356, 357, 357, 358, 358, 359, 360, 361, 361, 362, 363, 363, 364, 364, 365, 366, 366, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 384, 385, 386, 387, 388, 389, 390, 391, 392, 393, 394, 395, 396, 397, 398, 399, 400, 401, 402, 403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413, 414, 415, 416, 417, 417, 417, 417, 417, 417, 418, 418, 419, 419, 420, 420, 421, 421, 422, 422, 423, 423, 424, 424, 425, 425, 426, 426, 427, 427, 428, 428, 429, 429, 430, 430, 431, 431, 432, 432, 433, 433, 434, 434, 434, 434, 434, 434, 435, 435, 436, 436, 437, 437, 438, 438, 439, 439, 440, 440, 441, 441, 442, 442, 443, 443, 444, 444, 445, 445, 446, 446, 447, 447, 448, 448, 449, 449, 450, 450, 451, 451, 452, 452, 453, 453, 454, 454, 455, 455, 456, 456, 457, 457, 458, 458, 459, 459, 460, 460, 461, 461, 462, 463, 463, 464, 464, 465, 465, 466, 466, 467, 467, 468, 468, 469, 469, 469, 470, 470, 471, 471, 472, 472, 473, 473, 474, 474, 475, 475, 476, 476, 477, 477, 478, 478, 479, 479, 480, 480, 481, 481, 482, 482, 483, 483, 484, 484, 485, 485, 486, 486, 487, 487, 488, 488, 489, 489, 490, 490, 491, 491, 492, 492, 493, 493, 494, 494, 495, 495, 496, 496, 497, 497, 498, 498, 499, 499, 500, 500, 501, 501, 502, 502, 503, 503, 504, 504, 505, 505, 506, 506, 507, 507, 508, 508, 509, 509, 510, 510, 511, 511, 512, 512, 513, 513, 514, 514, 515, 515, 516, 516, 517, 517, 517, 518, 519, 520, 521, 522, 523, 524, 525, 526, 527, 528, 529, 530, 531, 532, 533, 534, 535, 536, 537, 538, 539, 540, 541, 542, 543, 544, 545, 546, 547, 548, 549, 550, 551, 552, 553, 554, 555, 555, 555, 555, 555, 555, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 557, 559, 561, 563, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 565, 567, 569, 571, 573, 575, 577, 579, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 581, 583, 585, 585, 587, 587, 587, 587, 587, 587, 587, 587, 587, 587, 587, 587, 587, 587, 587, 587, 587, 587, 587, 587, 587, 587, 587, 589, 589, 589, 591, 591, 591, 591, 591, 591, 591, 591, 591, 591, 591, 591, 591, 591, 593, 595, 597, 597, 597, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 599, 601, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 603, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 605, 607, 607, 607, 607, 607, 607, 607, 607, 607, 607, 607, 607, 607, 607, 609, 611, 611, 611, 611, 611, 611, 612, 612, 612, 612, 612, 612, 612, 612, 612, 612, 612, 612, 612, 614, 614, 614, 614, 616, 616, 618, 618, 620, 620, 622, 622, 624, 624, 624, 624, 624, 626, 626, 628, 630, 633, 635, 638, 638, 640, 640, 640, 640, 640, 640, 642, 642, 642, 642, 642, 642, 644, 644, 646, 646, 648, 648, 650, 650, 650, 650, 650, 652, 652, 652, 652, 652, 652, 652, 652, 652, 652, 652, 652, 652, 652, 652, 652, 652, 652, 652, 652, 652, 652, 652, 652, 652, 652, 652, 652, 652, 652, 653, 654, 655, 656, 657, 658, 659, 660, 661, 662, 663, 664, 665, 666, 667, 668, 669, 670, 671, 672, 673, 674, 675, 676, 677, 678, 679, 680, 681, 682, 683, 684, 685, 686, 687, 688, 689, 690, 690, 691, 691, 692, 692, 692, 692, 692, 692, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 693, 694, 695, 696, 697, 698, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 699, 700, 701, 702, 703, 704, 705, 706, 707, 708, 708, 708, 709, 710, 711, 712, 713, 714, 715, 716, 717, 718, 719, 720, 721, 722, 723, 724, 725, 726, 727, 728, 729, 730, 731, 732, 733, 734, 735, 736, 737, 738, 739, 740, 741, 742, 743, 744, 745, 746, 747, 748, 749, 750, 751, 751, 752, 753, 754, 754, 754, 754, 754, 754, 754, 754, 754, 754, 754, 754, 755, 756, 757, 757, 758, 759, 760, 761, 762, 763, 764, 765, 766, 767, 768, 768, 769, 770, 771, 772, 773, 774, 775, 776, 777, 778, 779, 780, 781, 782, 783, 784, 785, 786, 786, 787, 788, 789, 790, 791, 792, 793, 794, 795, 796, 797, 798, 799, 800, 801, 802, 803, 804, 805, 806, 807, 808, 809, 810, 811, 812, 813, 814, 814, 814, 815, 815, 816, 817, 818, 819, 820, 821, 822, 823, 824, 825, 826, 827, 828, 829, 830, 831, 832, 833, 834, 835, 836, 837, 838, 839, 840, 841, 842, 843, 844, 845, 846, 847, 848, 849, 850, 851, 852, 852, 852, 852, 852, 852, 852, 852, 852, 852, 852, 853, 853, 854, 854, 855, 855, 856, 856, 857, 857, 858, 858, 859, 859, 860, 860, 861, 861, 862, 862, 863, 863, 864, 864, 865, 865, 866, 866, 867, 867, 868, 868, 869, 869, 870, 870, 871, 871, 872, 872, 873, 873, 874, 874, 875, 875, 876, 876, 877, 877, 878, 878, 879, 879, 880, 880, 881, 881, 882, 882, 883, 883, 884, 884, 885, 885, 886, 886, 887, 887, 888, 888, 889, 889, 890, 890, 891, 891, 892, 892, 893, 893, 894, 894, 895, 895, 896, 896, 897, 897, 898, 898, 899, 899, 900, 900, 901, 901, 902, 902, 903, 903, 904, 904, 905, 905, 906, 906, 907, 907, 908, 908, 909, 909, 910, 910, 911, 911, 912, 912, 913, 913, 914, 914, 915, 915, 916, 916, 917, 917, 918, 918, 919, 919, 920, 920, 921, 921, 922, 922, 923, 923, 924, 924, 925, 925, 926, 926, 927, 927, 929, 930, 930, 931, 931, 932, 932, 933, 933, 934, 934, 935, 935, 936, 936, 937, 937, 938, 938, 939, 939, 940, 940, 941, 941, 942, 942, 943, 943, 944, 944, 945, 945, 946, 946, 947, 947, 948, 948, 949, 949, 950, 950, 951, 951, 952, 952, 953, 953, 954, 954, 955, 955, 956, 956, 957, 957, 958, 958, 959, 959, 960, 960, 961, 961, 962, 962, 963, 963, 964, 964, 965, 965, 966, 966, 967, 967, 968, 968, 969, 969, 970, 970, 971, 971, 972, 972, 973, 973, 974, 974, 975, 975, 976, 976, 977, 977, 978, 978, 979, 979, 979, 980, 981, 982, 983, 984, 985, 986, 987, 987, 987, 988, 989, 990, 991, 992, 993, 993, 993, 994, 995, 996, 997, 998, 999, 1000, 1001, 1001, 1002, 1003, 1004, 1005, 1006, 1007, 1008, 1009, 1009, 1009, 1010, 1011, 1012, 1013, 1014, 1015, 1015, 1015, 1015, 1016, 1016, 1017, 1017, 1018, 1018, 1019, 1019, 1020, 1021, 1022, 1023, 1024, 1025, 1026, 1027, 1027, 1028, 1028, 1029, 1029, 1030, 1030, 1031, 1031, 1032, 1032, 1033, 1033, 1034, 1034, 1036, 1038, 1040, 1042, 1044, 1046, 1048, 1050, 1052, 1054, 1056, 1058, 1060, 1062, 1064, 1066, 1068, 1070, 1072, 1074, 1076, 1078, 1080, 1082, 1084, 1086, 1088, 1090, 1092, 1094, 1096, 1098, 1100, 1102, 1104, 1106, 1108, 1110, 1112, 1114, 1116, 1118, 1120, 1122, 1124, 1126, 1128, 1130, 1130, 1132, 1134, 1136, 1136, 1136, 1138, 1139, 1140, 1141, 1142, 1144, 1146, 1147, 1149, 1151, 1154, 1156, 1158, 1160, 1160, 1160, 1162, 1163, 1164, 1165, 1166, 1168, 1171, 1174, 1177, 1177, 1178, 1178, 1178, 1179, 1180, 1181, 1182, 1182, 1185, 1188, 1191, 1191, 1192, 1192, 1193, 1194, 1195, 1196, 1197, 1200, 1203, 1204, 1204, 1206, 1208, 1210, 1210, 1210, 1212, 1213, 1214, 1215, 1216, 1218, 1220, 1222, 1222, 1223, 1223, 1223, 1223, 1223, 1224, 1224, 1226, 1226, 1226, 1226, 1226, 1227, 1227, 1229, 1232, 1232, 1234, 1237, 1237, 1239, 1239, 1241, 1241, 1243, 1245, 1247, 1247, 1247, 1247, 1247, 1251, 1251, 1252, 1252, 1252, 1252, 1252, 1252, 1253, 1254, 1254, 1255, 1256, 1257, 1258, 1259, 1260, 1261, 1262, 1263, 1264, 1265, 1266, 1267, 1268, 1269, 1270, 1271, 1272, 1273, 1274, 1275, 1276, 1277, 1278, 1279, 1280, 1281, 1281, 1282, 1283, 1284, 1285, 1286, 1287, 1288, 1289, 1290, 1291, 1292, 1293, 1294, 1294, 1294, 1296, 1296, 1296, 1296, 1296, 1296, 1296, 1296, 1296, 1296, 1296, 1296, 1296, 1296, 1296, 1296, 1296, 1296, 1296, 1296, 1296, 1296, 1299, 1302, 1303, 1305, 1305, 1308, 1311, 1312, 1312, 1314, 1315, 1316, 1317, 1318, 1319, 1319, 1320, 1322, 1322, 1323, 1324, 1325, 1325, 1327, 1330, 1332, 1332, 1333, 1333, 1334, 1334, 1335, 1335, 1336, 1337, 1338, 1339, 1339, 1340, 1341, 1342, 1343, 1344, 1345, 1346, 1347, 1348, 1349, 1349, 1352, 1353, 1354, 1355, 1356, 1356, 1357, 1358, 1359, 1360, 1360, 1360, 1360, 1360, 1360, 1363, 1366, 1370, 1373, 1376, 1379, 1382, 1385, 1388, 1391, 1394, 1397, 1400, 1403, 1406, 1408, 1409, 1411, 1414, 1416, 1417, 1419, 1422, 1426, 1428, 1429, 1431, 1434, 1435, 1436, 1437, 1438, 1439, 1441, 1444, 1446, 1447, 1449, 1452, 1456, 1458, 1459, 1461, 1464, 1465, 1466, 1467, 1468, 1468, 1469, 1469, 1469, 1472, 1472, 1472, 1472, 1472, 1472, 1472, 1474, 1477, 1477, 1479, 1482, 1482, 1482, 1482, 1482, 1482, 1483, 1484, 1484, 1484, 1484, 1484, 1484, 1484, 1484, 1484, 1484, 1484, 1484, 1484, 1484, 1484, 1484, 1484, 1484, 1484, 1484, 1485, 1486, 1487, 1488, 1489, 1490, 1491, 1492, 1493, 1495, 1497, 1499, 1501, 1503, 1505, 1507, 1509, 1511, 1513, 1515, 1518, 1521, 1524, 1527, 1530, 1533, 1536, 1539, 1542, 1546, 1550, 1554, 1558, 1562, 1566, 1570, 1574, 1578, 1582, 1586, 1586, 1589, 1592, 1595, 1598, 1601, 1604, 1607, 1610, 1613, 1616, 1619, 1622, 1625, 1628, 1631, 1634, 1637, 1640, 1643, 1646, 1649, 1652, 1655, 1658, 1661, 1664, 1665, 1666, 1667, 1668, 1669, 1670, 1671, 1672, 1673, 1674, 1675, 1676, 1677, 1678, 1679, 1680, 1681, 1682, 1683, 1684, 1685, 1686, 1687, 1688, 1689, 1690, 1691, 1692, 1693, 1694, 1695, 1696, 1697, 1698, 1699, 1700, 1701, 1702, 1703, 1704, 1705, 1706, 1707, 1708, 1709, 1710, 1711, 1712, 1713, 1714, 1715, 1716, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1717, 1721, 1721, 1724, 1726, 1729, 1729, 1731, 1731, 1731, 1731, 1731, 1731, 1731, 1731, 1731, 1731, 1731, 1731, 1731, 1731, 1731, 1731, 1731, 1731, 1731, 1731, 1731, 1731, 1731, 1731, 1731, 1731, 1732, 1733, 1734, 1735, 1736, 1737, 1738, 1739, 1740, 1741, 1742, 1743, 1744, 1745, 1746, 1747, 1748, 1749, 1750, 1751, 1752, 1753, 1754, 1755, 1756, 1757, 1758, 1759, 1760, 1761, 1762, 1763, 1764, 1765, 1766, 1767, 1768, 1769, 1770, 1771, 1772, 1773, 1774, 1775, 1776, 1777, 1778, 1779, 1779, 1779, 1780, 1780, 1781, 1782, 1783, 1783, 1784, 1784, 1785, 1785, 1786, 1786, 1787, 1788, 1789, 1790, 1790, 1791, 1791, 1791, 1792, 1792, 1792, 1793, 1794, 1795, 1796, 1797, 1797, 1798, 1798, 1799, 1799, 1800, 1800, 1801, 1801, 1802, 1802, 1803, 1803, 1804, 1804, 1805, 1805, 1806, 1806, 1807, 1807, 1808, 1808, 1809, 1809, 1810, 1810, 1811, 1811, 1812, 1812, 1813, 1813, 1814, 1814, 1815, 1815, 1816, 1816, 1817, 1817, 1818, 1818, 1819, 1819, 1820, 1820, 1821, 1821, 1822, 1822, 1823, 1823, 1824, 1824, 1825, 1825, 1826, 1826, 1827, 1827, 1828, 1828, 1829, 1829, 1830, 1830, 1831, 1831, 1832, 1832, 1833, 1833, 1834, 1834, 1835, 1835, 1836, 1836, 1837, 1837, 1838, 1838, 1839, 1839, 1840, 1840, 1841, 1841, 1842, 1842, 1843, 1843, 1844, 1844, 1845, 1845, 1846, 1846, 1846, 1847, 1847, 1848, 1848, 1849, 1849, 1849, 1849, 1849, 1849, 1849, 1849, 1849, 1849, 1849, 1849, 1849, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1850, 1851, 1851, 1852, 1852, 1853, 1854, 1855, 1856, 1857, 1858, 1859, 1860, 1861, 1862, 1863, 1864, 1865, 1866, 1867, 1868, 1869, 1870, 1871, 1872, 1873, 1874, 1875, 1876, 1877, 1878, 1879, 1880, 1881, 1882, 1883, 1884, 1885, 1886, 1887, 1888, 1889, 1890, 1891, 1892, 1893, 1894, 1895, 1896, 1897, 1898, 1899, 1900, 1901, 1902, 1903, 1904, 1905, 1906, 1907, 1908, 1909, 1910, 1911, 1912, 1913, 1914, 1915, 1916, 1917, 1918, 1919, 1920, 1921, 1922, 1923, 1924, 1925, 1926, 1927, 1928, 1929, 1930, 1931, 1932, 1933, 1934, 1935, 1936, 1937, 1938, 1939, 1940, 1941, 1942, 1943, 1944, 1945, 1946, 1947, 1948, 1949, 1950, 1951, 1952, 1953, 1954, 1955, 1956, 1957, 1958, 1959, 1960, 1961, 1962, 1963, 1964, 1965, 1966, 1967, 1968, 1969, 1970, 1971, 1972, 1973, 1974, 1975, 1976, 1977, 1978, 1979, 1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989, 1990, 1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035, 2036, 2037, 2038, 2039, 2040, 2041, 2042, 2043, 2044, 2045, 2046, 2047, 2048, 2049, 2050, 2051, 2052, 2053, 2054, 2055, 2056, 2057, 2058, 2059, 2060, 2061, 2062, 2063, 2064, 2065, 2066, 2066, 2066, 2066, 2067, 2067, 2068, 2068, 2068, 2068, 2068, 2068, 2069, 2069, 2070, 2071, 2072, 2072, 2072, 2072, 2072, 2072, 2072, 2072, 2072, 2072, 2072, 2074, 2076, 2076, 2078, 2078, 2078, 2080, 2080, 2080, 2080, 2080, 2080, 2080, 2081, 2082, 2083, 2084, 2085, 2086, 2087, 2088, 2089, 2090, 2091, 2092, 2093, 2094, 2095, 2096, 2097, 2098, 2099, 2100, 2101, 2102, 2103, 2104, 2105, 2106, 2107, 2108, 2109, 2110, 2111, 2112, 2113, 2114, 2115, 2116, 2117, 2118, 2119, 2120, 2121, 2122, 2123, 2124, 2125, 2126, 2127, 2128, 2129, 2130, 2131, 2131, 2132, 2133, 2134, 2135, 2136, 2137, 2138, 2139, 2140, 2141, 2142, 2143, 2144, 2145, 2146, 2147, 2148, 2149, 2150, 2151, 2152, 2153, 2154, 2155, 2156, 2157, 2158, 2159, 2160, 2161, 2162, 2163, 2164, 2165, 2166, 2167, 2168, 2169, 2170, 2171, 2172, 2173, 2173, 2173, 2174, 2175, 2176, 2177, 2178, 2179, 2180, 2181, 2182, 2183, 2184, 2185, 2186, 2187, 2187, 2187, 2187, 2187, 2187, 2187, 2187, 2187, 2187, 2190, 2193, 2196, 2199, 2202, 2205, 2208, 2211, 2214, 2217, 2220, 2223, 2226, 2229, 2232, 2235, 2238, 2241, 2244, 2247, 2250, 2253, 2256, 2259, 2262, 2265, 2268, 2271, 2274, 2278, 2282, 2282, 2285, 2288, 2291, 2294, 2297, 2300, 2303, 2306, 2309, 2312, 2315, 2318, 2321, 2324, 2327, 2330, 2333, 2336, 2339, 2342, 2345, 2348, 2351, 2354, 2357, 2360, 2363, 2366, 2369, 2372, 2375, 2378, 2381, 2384, 2387, 2390, 2391, 2392, 2393, 2394, 2394, 2397, 2399, 2401, 2403, 2405, 2407, 2409, 2411, 2413, 2415, 2417, 2419, 2421, 2423, 2425, 2427, 2428, 2429, 2430, 2431, 2432, 2433, 2434, 2435, 2436, 2437, 2438, 2439, 2440, 2441, 2442, 2443, 2444, 2445, 2446, 2447, 2448, 2449, 2450, 2451, 2452, 2453, 2454, 2455, 2457, 2459, 2460, 2460, 2461, 2462, 2463, 2464, 2465, 2466, 2467, 2468, 2469, 2470, 2471, 2472, 2473, 2474, 2475, 2476, 2477, 2478, 2479, 2480, 2481, 2482, 2483, 2484, 2485, 2486, 2487, 2488, 2489, 2490, 2491, 2492, 2493, 2494, 2495, 2496, 2497, 2498, 2499, 2500, 2501, 2502, 2503, 2504, 2505, 2506, 2507, 2508, 2509, 2511, 2513, 2515, 2517, 2519, 2521, 2523, 2525, 2527, 2529, 2531, 2533, 2535, 2537, 2539, 2541, 2543, 2545, 2547, 2549, 2551, 2553, 2555, 2557, 2560, 2563, 2566, 2568, 2571, 2573, 2576, 2577, 2578, 2579, 2580, 2581, 2582, 2583, 2584, 2585, 2586, 2587, 2588, 2589, 2590, 2591, 2592, 2593, 2594, 2595, 2596, 2597, 2598, 2599, 2600, 2601, 2602, 2603, 2604, 2605, 2606, 2607, 2608, 2609, 2610, 2611, 2612, 2613, 2614, 2615, 2616, 2617, 2618, 2619, 2620, 2621, 2622, 2623, 2625, 2629, 2633, 2637, 2640, 2644, 2647, 2650, 2655, 2659, 2662, 2665, 2668, 2672, 2676, 2679, 2682, 2684, 2687, 2691, 2695, 2697, 2702, 2708, 2713, 2716, 2721, 2726, 2730, 2733, 2736, 2739, 2743, 2748, 2752, 2755, 2758, 2761, 2763, 2765, 2767, 2769, 2772, 2775, 2780, 2783, 2787, 2792, 2795, 2797, 2799, 2804, 2808, 2813, 2816, 2821, 2823, 2826, 2829, 2832, 2835, 2838, 2842, 2845, 2847, 2850, 2853, 2856, 2860, 2863, 2866, 2869, 2874, 2878, 2880, 2885, 2887, 2891, 2895, 2898, 2901, 2904, 2908, 2910, 2913, 2917, 2919, 2924, 2927, 2929, 2931, 2933, 2935, 2937, 2939, 2941, 2943, 2945, 2947, 2950, 2953, 2956, 2959, 2962, 2965, 2968, 2971, 2974, 2977, 2980, 2983, 2986, 2989, 2992, 2995, 2997, 2999, 3002, 3004, 3006, 3008, 3011, 3014, 3016, 3018, 3020, 3022, 3024, 3028, 3030, 3032, 3034, 3036, 3038, 3040, 3042, 3044, 3047, 3051, 3053, 3055, 3057, 3059, 3061, 3063, 3065, 3068, 3071, 3074, 3077, 3079, 3081, 3083, 3085, 3087, 3089, 3091, 3093, 3095, 3097, 3100, 3103, 3105, 3108, 3111, 3114, 3116, 3119, 3122, 3126, 3128, 3131, 3134, 3137, 3140, 3145, 3151, 3153, 3155, 3157, 3159, 3161, 3163, 3165, 3167, 3169, 3171, 3173, 3175, 3177, 3179, 3181, 3183, 3185, 3187, 3187, 3189, 3191, 3193, 3197, 3197, 3199, 3201, 3203, 3205, 3207, 3209, 3211, 3213, 3215, 3217, 3220, 3222, 3224, 3227, 3230, 3232, 3232, 3235, 3237, 3239, 3241, 3243, 3246, 3249, 3251, 3253, 3255, 3257, 3259, 3261, 3263, 3265, 3267, 3270, 3273, 3276, 3279, 3282, 3285, 3288, 3291, 3294, 3297, 3300, 3303, 3306, 3309, 3312, 3315, 3318, 3321, 3324, 3327, 3330, 3333, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3336, 3337, 3337, 3338, 3338, 3339, 3339, 3340, 3340, 3341, 3341, 3342, 3342, 3343, 3343, 3344, 3344, 3345, 3345, 3346, 3346, 3347, 3347, 3348, 3348, 3349, 3349, 3350, 3350, 3351, 3351, 3352, 3352, 3353, 3353, 3354, 3354, 3355, 3355, 3356, 3356, 3357, 3357, 3358, 3358, 3359, 3359, 3359, 3359, 3359, 3359, 3359, 3360, 3360, 3361, 3361, 3362, 3362, 3363, 3363, 3364, 3364, 3365, 3365, 3366, 3366, 3367, 3367, 3368, 3368, 3369, 3369, 3370, 3370, 3371, 3371, 3372, 3372, 3373, 3373, 3374, 3375, 3375, 3375, 3375, 3375, 3375, 3375, 3375, 3375, 3375, 3375, 3375, 3376, 3376, 3377, 3377, 3378, 3378, 3379, 3379, 3380, 3380, 3381, 3381, 3382, 3382, 3383, 3383, 3384, 3384, 3385, 3385, 3386, 3386, 3387, 3387, 3388, 3388, 3389, 3389, 3390, 3390, 3391, 3391, 3392, 3392, 3393, 3393, 3394, 3394, 3395, 3395, 3396, 3396, 3397, 3397, 3398, 3398, 3399, 3399, 3400, 3400, 3401, 3401, 3402, 3402, 3403, 3403, 3404, 3404, 3405, 3405, 3406, 3406, 3407, 3407, 3408, 3408, 3409, 3409, 3410, 3410, 3411, 3411, 3412, 3412, 3413, 3413, 3414, 3414, 3415, 3415, 3416, 3416, 3417, 3418, 3418, 3419, 3419, 3420, 3420, 3421, 3421, 3422, 3422, 3422, 3423, 3423, 3424, 3424, 3424, 3425, 3425, 3426, 3426, 3426, 3427, 3427, 3428, 3428, 3429, 3429, 3430, 3430, 3431, 3431, 3432, 3432, 3433, 3433, 3434, 3434, 3435, 3435, 3436, 3436, 3437, 3438, 3439, 3440, 3441, 3441, 3442, 3443, 3444, 3445, 3446, 3446, 3447, 3447, 3448, 3448, 3449, 3449, 3450, 3450, 3451, 3451, 3452, 3452, 3453, 3453, 3454, 3455, 3456, 3457, 3457, 3458, 3458, 3459, 3460, 3460, 3460, 3461, 3461, 3461, 3461, 3461, 3461, 3462, 3462, 3463, 3463, 3464, 3464, 3465, 3465, 3466, 3467, 3468, 3469, 3469, 3469, 3470, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3471, 3472, 3473, 3474, 3475, 3475, 3475, 3475, 3475, 3476, 3476, 3476, 3477, 3478, 3479, 3480, 3481, 3482, 3483, 3484, 3485, 3486, 3487, 3488, 3489, 3490, 3491, 3492, 3493, 3494, 3495, 3496, 3497, 3498, 3499, 3500, 3501, 3502, 3503, 3504, 3505, 3506, 3507, 3508, 3509, 3510, 3511, 3512, 3513, 3514, 3515, 3516, 3517, 3518, 3519, 3520, 3521, 3522, 3523, 3524, 3525, 3526, 3527, 3528, 3529, 3530, 3531, 3532, 3533, 3534, 3535, 3536, 3537, 3538, 3539, 3540, 3541, 3542, 3543, 3544, 3545, 3546, 3547, 3548, 3549, 3550, 3551, 3552, 3553, 3554, 3555, 3556, 3556, 3556, 3556, 3556, 3556, 3556, 3556, 3556, 3556, 3556, 3556, 3556, 3556, 3556, 3557, 3558, 3559, 3560, 3561, 3562, 3563, 3564, 3565, 3566, 3567, 3568, 3569, 3570, 3571, 3572, 3573, 3574, 3575, 3576, 3577, 3578, 3579, 3580, 3581, 3582, 3583, 3584, 3585, 3586, 3587, 3588, 3589, 3590, 3591, 3592, 3593, 3594, 3595, 3596, 3597, 3598, 3599, 3600, 3601, 3602, 3603, 3604, 3605, 3606, 3607, 3608, 3609, 3610, 3611, 3612, 3613, 3614, 3615, 3616, 3617, 3618, 3619, 3620, 3621, 3622, 3623, 3624, 3625, 3626, 3627, 3628, 3629, 3630, 3631, 3632, 3633, 3634, 3635, 3636, 3637, 3638, 3639, 3640, 3641, 3642, 3643, 3644, 3645, 3646, 3647, 3648, 3649, 3650, 3651, 3652, 3653, 3654, 3655, 3656, 3657, 3658, 3659, 3660, 3661, 3662, 3663, 3664, 3665, 3666, 3667, 3668, 3669, 3670, 3671, 3672, 3673, 3674, 3675, 3676, 3677, 3678, 3679, 3680, 3681, 3682, 3683, 3684, 3685, 3686, 3687, 3688, 3689, 3690, 3691, 3692, 3693, 3694, 3695, 3696, 3697, 3698, 3699, 3700, 3701, 3702, 3703, 3704, 3705, 3706, 3707, 3708, 3709, 3710, 3711, 3712, 3713, 3714, 3715, 3716, 3717, 3718, 3719, 3720, 3721, 3722, 3723, 3724, 3725, 3726, 3727, 3728, 3729, 3730, 3731, 3732, 3733, 3734, 3735, 3736, 3737, 3738, 3739, 3740, 3741, 3742, 3743, 3744, 3745, 3746, 3747, 3748, 3749, 3750, 3751, 3752, 3753, 3754, 3755, 3756, 3757, 3758, 3759, 3760, 3761, 3762, 3763, 3764, 3765, 3766, 3767, 3768, 3769, 3770, 3771, 3772, 3773, 3774, 3775, 3776, 3777, 3778, 3779, 3780, 3781, 3782, 3783, 3784, 3785, 3786, 3787, 3788, 3789, 3790, 3791, 3792, 3793, 3794, 3795, 3796, 3797, 3798, 3799, 3800, 3801, 3802, 3803, 3804, 3805, 3806, 3807, 3808, 3809, 3810, 3811, 3812, 3813, 3814, 3815, 3816, 3817, 3818, 3819, 3820, 3821, 3822, 3823, 3824, 3825, 3825, 3826, 3826, 3827, 3827, 3828, 3829, 3830, 3831, 3832, 3833, 3834, 3835, 3836, 3837, 3837, 3838, 3838, 3839, 3839, 3840, 3841, 3841, 3842, 3843, 3844, 3845, 3846, 3847, 3848, 3849, 3850, 3851, 3852, 3853, 3854, 3855, 3856, 3857, 3858, 3859, 3860, 3861, 3862, 3863, 3864, 3865, 3866, 3867, 3868, 3869, 3870, 3871, 3872, 3873, 3874, 3875, 3876, 3877, 3878, 3879, 3880, 3881, 3882, 3883, 3884, 3885, 3886, 3887, 3888, 3889, 3890, 3891, 3892, 3893, 3894, 3895, 3896, 3897, 3898, 3899, 3900, 3901, 3902, 3903, 3904, 3905, 3906, 3907, 3908, 3908, 3909, 3910, 3911, 3912, 3913, 3914, 3915, 3916, 3917, 3918, 3919, 3920, 3921, 3922, 3923, 3924, 3925, 3926, 3927, 3928, 3929, 3930, 3931, 3932, 3933, 3934, 3935, 3936, 3937, 3938, 3939, 3940, 3941, 3942, 3943, 3944, 3945, 3946, 3947, 3948, 3949, 3950, 3951, 3952, 3953, 3954, 3955, 3956, 3957, 3958, 3959, 3960, 3961, 3962, 3963, 3964, 3965, 3966, 3967, 3968, 3969, 3970, 3971, 3972, 3973, 3974, 3975, 3976, 3977, 3978, 3979, 3980, 3981, 3982, 3983, 3984, 3985, 3986, 3987, 3988, 3989, 3990, 3991, 3992, 3993, 3994, 3995, 3996, 3997, 3998, 3999, 4000, 4001, 4002, 4003, 4004, 4005, 4006, 4007, 4008, 4009, 4010, 4011, 4012, 4013, 4014, 4014, 4016, 4018, 4020, 4023, 4026, 4028, 4028, 4030, 4032, 4034, 4036, 4038, 4038, 4040, 4040, 4042, 4043, 4044, 4045, 4046, 4047, 4048, 4049, 4050, 4051, 4052, 4054, 4056, 4059, 4062, 4064, 4066, 4068, 4070, 4072, 4074, 4076, 4078, 4080, 4080, 4082, 4084, 4086, 4088, 4090, 4090, 4092, 4092, 4094, 4096, 4096, 4098, 4100, 4100, 4102, 4104, 4106, 4108, 4110, 4112, 4114, 4116, 4118, 4120, 4121, 4122, 4123, 4124, 4125, 4126, 4127, 4128, 4129, 4130, 4131, 4132, 4133, 4134, 4135, 4136, 4137, 4138, 4139, 4140, 4141, 4142, 4143, 4144, 4145, 4146, 4147, 4148, 4149, 4150, 4150, 4150, 4150, 4151, 4152, 4153, 4154, 4156, 4157, 4158, 4159, 4160, 4161, 4163, 4165, 4167, 4169, 4171, 4173, 4175, 4177, 4178, 4180, 4182, 4184, 4186, 4188, 4190, 4192, 4194, 4196, 4198, 4200, 4202, 4204, 4206, 4208, 4210, 4212, 4214, 4216, 4218, 4220, 4222, 4224, 4226, 4228, 4230, 4232, 4234, 4236, 4238, 4240, 4242, 4244, 4246, 4248, 4250, 4252, 4254, 4256, 4258, 4260, 4262, 4264, 4266, 4268, 4270, 4272, 4274, 4276, 4278, 4280, 4282, 4284, 4286, 4288, 4290, 4292, 4294, 4296, 4298, 4300, 4302, 4304, 4306, 4308, 4310, 4312, 4314, 4316, 4318, 4320, 4322, 4324, 4326, 4328, 4330, 4332, 4334, 4336, 4338, 4340, 4342, 4344, 4346, 4348, 4350, 4352, 4354, 4356, 4358, 4360, 4362, 4364, 4366, 4369, 4372, 4375, 4378, 4381, 4384, 4386, 4388, 4390, 4392, 4394, 4396, 4398, 4400, 4402, 4404, 4406, 4408, 4410, 4412, 4414, 4416, 4418, 4420, 4422, 4424, 4426, 4428, 4430, 4432, 4434, 4436, 4438, 4440, 4442, 4444, 4446, 4448, 4450, 4452, 4454, 4456, 4458, 4460, 4462, 4464, 4466, 4468, 4470, 4472, 4474, 4476, 4478, 4480, 4482, 4484, 4486, 4488, 4490, 4492, 4494, 4496, 4498, 4500, 4502, 4504, 4506, 4508, 4510, 4512, 4514, 4516, 4518, 4520, 4522, 4524, 4526, 4528, 4530, 4532, 4534, 4536, 4538, 4540, 4542, 4544, 4546, 4548, 4550, 4552, 4554, 4556, 4558, 4560, 4562, 4564, 4566, 4568, 4570, 4572, 4574, 4576, 4578, 4580, 4582, 4584, 4586, 4588, 4590, 4592, 4594, 4596, 4598, 4600, 4602, 4604, 4606, 4608, 4610, 4612, 4614, 4616, 4618, 4620, 4622, 4624, 4626, 4628, 4630, 4632, 4634, 4636, 4638, 4640, 4642, 4644, 4646, 4648, 4650, 4652, 4654, 4656, 4658, 4660, 4662, 4664, 4666, 4668, 4671, 4674, 4677, 4679, 4681, 4683, 4685, 4687, 4689, 4691, 4693, 4695, 4697, 4699, 4701, 4703, 4705, 4707, 4709, 4711, 4713, 4715, 4717, 4719, 4721, 4723, 4725, 4727, 4729, 4731, 4733, 4735, 4737, 4739, 4741, 4743, 4745, 4747, 4749, 4751, 4753, 4755, 4757, 4759, 4761, 4763, 4765, 4767, 4769, 4771, 4773, 4775, 4777, 4779, 4781, 4783, 4785, 4787, 4789, 4791, 4793, 4795, 4797, 4799, 4801, 4803, 4805, 4807, 4809, 4811, 4813, 4815, 4817, 4819, 4821, 4821, 4821, 4824, 4827, 4830, 4833, 4836, 4839, 4842, 4845, 4848, 4851, 4854, 4857, 4860, 4863, 4866, 4869, 4872, 4875, 4878, 4881, 4884, 4887, 4890, 4893, 4896, 4899, 4902, 4905, 4908, 4911, 4914, 4917, 4920, 4923, 4926, 4929, 4932, 4935, 4938, 4941, 4944, 4947, 4950, 4953, 4956, 4959, 4962, 4965, 4968, 4968, 4971, 4974, 4977, 4980, 4983, 4986, 4989, 4992, 4995, 4998, 5001, 5004, 5007, 5010, 5013, 5016, 5019, 5022, 5025, 5028, 5031, 5034, 5037, 5040, 5043, 5046, 5049, 5052, 5055, 5058, 5061, 5064, 5067, 5070, 5073, 5076, 5079, 5082, 5085, 5088, 5091, 5094, 5097, 5100, 5103, 5106, 5109, 5112, 5115, 5118, 5121, 5124, 5124, 5124, 5124, 5127, 5130, 5134, 5138, 5142, 5146, 5150, 5154, 5158, 5161, 5179, 5187, 5191, 5191, 5191, 5191, 5192, 5193, 5193, 5194, 5195, 5196, 5197, 5198, 5199, 5199, 5199, 5199, 5199, 5199, 5199, 5199, 5200, 5201, 5202, 5203, 5204, 5205, 5206, 5207, 5208, 5209, 5210, 5211, 5212, 5213, 5214, 5215, 5216, 5217, 5218, 5218, 5219, 5220, 5222, 5223, 5224, 5225, 5225, 5225, 5226, 5227, 5228, 5229, 5230, 5231, 5232, 5233, 5234, 5235, 5236, 5237, 5238, 5239, 5240, 5241, 5242, 5243, 5244, 5244, 5245, 5246, 5247, 5248, 5248, 5250, 5252, 5254, 5254, 5256, 5256, 5258, 5260, 5262, 5264, 5266, 5268, 5270, 5272, 5274, 5276, 5277, 5278, 5279, 5280, 5281, 5282, 5283, 5284, 5285, 5286, 5287, 5288, 5289, 5290, 5291, 5292, 5293, 5294, 5295, 5296, 5297, 5298, 5299, 5300, 5301, 5302, 5303, 5304, 5305, 5306, 5307, 5308, 5309, 5310, 5311, 5312, 5314, 5316, 5318, 5320, 5320, 5320, 5320, 5321, 5322, 5323, 5324, 5325, 5326, 5327, 5328, 5329, 5330, 5331, 5332, 5333, 5334, 5335, 5336, 5337, 5338, 5339, 5340, 5341, 5342, 5343, 5344, 5345, 5346, 5347, 5348, 5349, 5350, 5351, 5352, 5353, 5354, 5355, 5356, 5357, 5358, 5359, 5360, 5361, 5362, 5363, 5364, 5365, 5366, 5367, 5368, 5369, 5370, 5371, 5372, 5373, 5374, 5375, 5376, 5377, 5378, 5379, 5380, 5381, 5382, 5383, 5384, 5385, 5386, 5387, 5388, 5389, 5390, 5391, 5392, 5393, 5394, 5395, 5396, 5397, 5398, 5399, 5400, 5401, 5402, 5403, 5404, 5405, 5406, 5407, 5408, 5409, 5410, 5411, 5412, 5413, 5414, 5415, 5416, 5417, 5418, 5419, 5420, 5421, 5422, 5423, 5424, 5425, 5426, 5427, 5428, 5429, 5430, 5431, 5432, 5433, 5434, 5435, 5436, 5437, 5438, 5439, 5440, 5441, 5442, 5443, 5444, 5445, 5446, 5447, 5448, 5449, 5450, 5451, 5452, 5453, 5454, 5455, 5456, 5457, 5458, 5459, 5460, 5461, 5462, 5463, 5464, 5465, 5466, 5467, 5468, 5469, 5470, 5471, 5472, 5473, 5474, 5475, 5476, 5477, 5478, 5479, 5479, 5480, 5481, 5482, 5483, 5484, 5485, 5486, 5487, 5488, 5489, 5490, 5491, 5492, 5493, 5494, 5495, 5496, 5497, 5498, 5499, 5500, 5501, 5502, 5503, 5504, 5505, 5506, 5507, 5508, 5509, 5509, 5510, 5511, 5512, 5513, 5514, 5515, 5515, 5516, 5517, 5518, 5519, 5520, 5521, 5521, 5522, 5523, 5524, 5525, 5526, 5527, 5527, 5528, 5529, 5530, 5530, 5531, 5532, 5533, 5535, 5536, 5537, 5538, 5538, 5539, 5540, 5541, 5542, 5543, 5544, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5545, 5546, 5547, 5548, 5549, 5550, 5551, 5552, 5553, 5554, 5555, 5556, 5557, 5558, 5559, 5560, 5561, 5562, 5563, 5564, 5565, 5566, 5567, 5568, 5569, 5570, 5571, 5572, 5573, 5574, 5575, 5576, 5577, 5578, 5579, 5580, 5581, 5582, 5583, 5584, 5585, 5585, 5585, 5585, 5585, 5585, 5586, 5587, 5588, 5589, 5590, 5591, 5592, 5593, 5594, 5595, 5596, 5597, 5598, 5599, 5600, 5601, 5602, 5603, 5604, 5605, 5606, 5607, 5608, 5609, 5610, 5611, 5612, 5613, 5614, 5615, 5616, 5617, 5618, 5619, 5620, 5621, 5621, 5621, 5621, 5621, 5621, 5621, 5621, 5621, 5622, 5623, 5624, 5625, 5626, 5627, 5628, 5629, 5630, 5631, 5632, 5632, 5633, 5634, 5635, 5636, 5637, 5638, 5639, 5640, 5641, 5642, 5643, 5644, 5645, 5646, 5647, 5647, 5648, 5649, 5650, 5651, 5652, 5653, 5654, 5654, 5655, 5656, 5656, 5656, 5656, 5656, 5656, 5656, 5656, 5656, 5656, 5656, 5656, 5656, 5656, 5656, 5656, 5656, 5656, 5656, 5657, 5658, 5659, 5660, 5661, 5661, 5662, 5663, 5664, 5665, 5666, 5667, 5668, 5669, 5670, 5671, 5672, 5673, 5674, 5675, 5676, 5677, 5678, 5679, 5680, 5681, 5682, 5683, 5684, 5685, 5686, 5687, 5688, 5689, 5690, 5691, 5692, 5693, 5694, 5695, 5696, 5697, 5698, 5699, 5700, 5701, 5702, 5703, 5703, 5704, 5705, 5706, 5707, 5708, 5709, 5710, 5711, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5712, 5713, 5714, 5715, 5716, 5717, 5718, 5719, 5720, 5721, 5722, 5723, 5724, 5725, 5726, 5727, 5728, 5729, 5730, 5731, 5732, 5733, 5734, 5735, 5736, 5737, 5738, 5739, 5740, 5741, 5742, 5743, 5744, 5745, 5746, 5747, 5748, 5749, 5750, 5751, 5752, 5753, 5754, 5755, 5756, 5757, 5758, 5759, 5760, 5761, 5762, 5763, 5763, 5763, 5763, 5763, 5763, 5763, 5763, 5763, 5763, 5764, 5765, 5766, 5767, 5768, 5769, 5770, 5771, 5772, 5773, 5774, 5775, 5776, 5777, 5778, 5779, 5780, 5781, 5782, 5783, 5784, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5785, 5786, 5787, 5788, 5789, 5790, 5791, 5792, 5793, 5794, 5795, 5796, 5797, 5798, 5799, 5800, 5801, 5802, 5803, 5804, 5805, 5806, 5807, 5808, 5809, 5810, 5811, 5812, 5813, 5814, 5815, 5816, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5817, 5818, 5819, 5820, 5821, 5822, 5823, 5824, 5825, 5826, 5827, 5828, 5829, 5830, 5831, 5832, 5833, 5834, 5835, 5836, 5837, 5838, 5839, 5840, 5841, 5842, 5843, 5844, 5845, 5846, 5847, 5848, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5849, 5850, 5851, 5852, 5853, 5854, 5855, 5856, 5857, 5858, 5859, 5860, 5861, 5862, 5863, 5864, 5865, 5866, 5867, 5868, 5869, 5870, 5871, 5872, 5873, 5874, 5875, 5876, 5877, 5878, 5879, 5880, 5881, 5882, 5883, 5884, 5885, 5885, 5885, 5885, 5885, 5885, 5885, 5885, 5885, 5885, 5885, 5885, 5885, 5885, 5885, 5885, 5887, 5889, 5892, 5895, 5898, 5901, 5904, 5904, 5904, 5904, 5906, 5908, 5911, 5914, 5917, 5920, 5920, 5920, 5920, 5920, 5920, 5920, 5920, 5920, 5920, 5920, 5920, 5920, 5920, 5920, 5920, 5921, 5922, 5923, 5924, 5925, 5926, 5927, 5928, 5929, 5930, 5931, 5932, 5933, 5934, 5935, 5936, 5937, 5938, 5939, 5940, 5941, 5942, 5943, 5944, 5945, 5946, 5947, 5948, 5949, 5950, 5951, 5952, 5953, 5954, 5955, 5956, 5957, 5958, 5959, 5960, 5961, 5962, 5963, 5964, 5965, 5966, 5967, 5968, 5969, 5970, 5971, 5972, 5973, 5974, 5975, 5976, 5977, 5978, 5979, 5980, 5981, 5982, 5983, 5984, 5985, 5986, 5987, 5988, 5989, 5990, 5991, 5992, 5993, 5994, 5995, 5996, 5997, 5998, 5999, 6000, 6001, 6002, 6003, 6004, 6005, 6005, 6006, 6007, 6008, 6009, 6010, 6011, 6012, 6013, 6014, 6015, 6016, 6017, 6018, 6019, 6020, 6021, 6022, 6023, 6024, 6025, 6026, 6027, 6028, 6029, 6030, 6031, 6032, 6033, 6034, 6035, 6036, 6037, 6038, 6039, 6040, 6041, 6042, 6043, 6044, 6045, 6046, 6047, 6048, 6049, 6050, 6051, 6052, 6053, 6054, 6055, 6056, 6057, 6058, 6059, 6060, 6061, 6062, 6063, 6064, 6065, 6066, 6067, 6068, 6069, 6070, 6071, 6072, 6073, 6074, 6075, 6076, 6076, 6077, 6078, 6078, 6079, 6079, 6080, 6081, 6081, 6082, 6083, 6084, 6085, 6085, 6086, 6087, 6088, 6089, 6090, 6091, 6092, 6093, 6094, 6095, 6096, 6097, 6097, 6098, 6098, 6099, 6100, 6101, 6102, 6103, 6104, 6105, 6105, 6106, 6107, 6108, 6109, 6110, 6111, 6112, 6113, 6114, 6115, 6116, 6117, 6118, 6119, 6120, 6121, 6122, 6123, 6124, 6125, 6126, 6127, 6128, 6129, 6130, 6131, 6132, 6133, 6134, 6135, 6136, 6137, 6138, 6139, 6140, 6141, 6142, 6143, 6144, 6145, 6146, 6147, 6148, 6149, 6150, 6151, 6152, 6153, 6154, 6155, 6156, 6157, 6158, 6159, 6160, 6161, 6162, 6163, 6164, 6165, 6166, 6167, 6168, 6169, 6170, 6170, 6171, 6172, 6173, 6174, 6174, 6175, 6176, 6177, 6178, 6179, 6180, 6181, 6182, 6182, 6183, 6184, 6185, 6186, 6187, 6188, 6189, 6189, 6190, 6191, 6192, 6193, 6194, 6195, 6196, 6197, 6198, 6199, 6200, 6201, 6202, 6203, 6204, 6205, 6206, 6207, 6208, 6209, 6210, 6211, 6212, 6213, 6214, 6215, 6216, 6217, 6217, 6218, 6219, 6220, 6221, 6221, 6222, 6223, 6224, 6225, 6226, 6226, 6227, 6227, 6228, 6229, 6230, 6231, 6232, 6233, 6234, 6234, 6235, 6236, 6237, 6238, 6239, 6240, 6241, 6242, 6243, 6244, 6245, 6246, 6247, 6248, 6249, 6250, 6251, 6252, 6253, 6254, 6255, 6256, 6257, 6258, 6259, 6260, 6261, 6262, 6263, 6264, 6265, 6266, 6267, 6268, 6269, 6270, 6271, 6272, 6273, 6274, 6275, 6276, 6277, 6278, 6279, 6280, 6281, 6282, 6283, 6284, 6285, 6286, 6287, 6288, 6289, 6290, 6291, 6292, 6293, 6294, 6295, 6296, 6297, 6298, 6299, 6300, 6301, 6302, 6303, 6304, 6305, 6306, 6307, 6308, 6309, 6310, 6311, 6312, 6313, 6314, 6315, 6316, 6317, 6318, 6319, 6320, 6321, 6322, 6323, 6324, 6325, 6326, 6327, 6328, 6329, 6330, 6331, 6332, 6333, 6334, 6335, 6336, 6337, 6338, 6339, 6340, 6341, 6342, 6343, 6344, 6345, 6346, 6347, 6348, 6349, 6350, 6351, 6352, 6353, 6354, 6355, 6356, 6357, 6358, 6359, 6360, 6361, 6362, 6363, 6364, 6365, 6366, 6367, 6368, 6369, 6370, 6371, 6372, 6373, 6374, 6375, 6376, 6377, 6378, 6379, 6380, 6381, 6382, 6383, 6384, 6385, 6386, 6387, 6388, 6389, 6390, 6391, 6392, 6393, 6394, 6395, 6396, 6397, 6398, 6399, 6400, 6401, 6402, 6403, 6404, 6405, 6406, 6407, 6408, 6409, 6410, 6411, 6412, 6413, 6414, 6415, 6416, 6417, 6418, 6419, 6420, 6421, 6422, 6423, 6424, 6425, 6426, 6427, 6428, 6429, 6430, 6431, 6432, 6433, 6434, 6435, 6436, 6437, 6438, 6439, 6440, 6441, 6442, 6443, 6444, 6445, 6446, 6447, 6448, 6449, 6450, 6451, 6452, 6453, 6454, 6455, 6456, 6457, 6458, 6459, 6460, 6461, 6462, 6463, 6464, 6465, 6466, 6467, 6468, 6469, 6470, 6471, 6472, 6473, 6474, 6475, 6476, 6477, 6478, 6479, 6480, 6481, 6482, 6483, 6484, 6485, 6486, 6487, 6488, 6489, 6490, 6491, 6492, 6493, 6494, 6495, 6496, 6497, 6498, 6499, 6500, 6501, 6502, 6503, 6504, 6505, 6506, 6507, 6508, 6509, 6510, 6511, 6512, 6513, 6514, 6515, 6516, 6517, 6518, 6519, 6520, 6521, 6522, 6523, 6524, 6525, 6526, 6527, 6528, 6529, 6530, 6531, 6532, 6533, 6534, 6535, 6536, 6537, 6538, 6539, 6540, 6541, 6542, 6543, 6544, 6545, 6546, 6547, 6548, 6549, 6550, 6551, 6552, 6553, 6554, 6555, 6556, 6557, 6558, 6559, 6560, 6561, 6562, 6563, 6564, 6565, 6566, 6567, 6568, 6569, 6570, 6571, 6572, 6573, 6574, 6574, 6575, 6576, 6577, 6578, 6579, 6580, 6581, 6582, 6583, 6584, 6585, 6586, 6587, 6588, 6589, 6590, 6591, 6592, 6593, 6594, 6595, 6596, 6597, 6598, 6599, 6600, 6601, 6602, 6603, 6604, 6605, 6606, 6607, 6608, 6609, 6610, 6611, 6612, 6613, 6614, 6615, 6616, 6617, 6618, 6619, 6620, 6621, 6622, 6623, 6624, 6625, 6626, 6627, 6628, 6629, 6630, 6631, 6632, 6633, 6634, 6635, 6636, 6637, 6638, 6639, 6640, 6641, 6642, 6643, 6644, 6645, 6646, 6647, 6648, 6649, 6650, 6651, 6652, 6653, 6654, 6655, 6656, 6657, 6658, 6659, 6660, 6661, 6662, 6663, 6664, 6665, 6666, 6667, 6668, 6669, 6670, 6671, 6672, 6673, 6674, 6675, 6676, 6677, 6678, 6679, 6680, 6681, 6682, 6683, 6684, 6685, 6686, 6687, 6688, 6689, 6690, 6691, 6692, 6693, 6694, 6695, 6696, 6697, 6698, 6699, 6700, 6701, 6702, 6703, 6704, 6705, 6706, 6707, 6708, 6709, 6710, 6711, 6712, 6713, 6714, 6715, 6716, 6717, 6718, 6719, 6720, 6721, 6722, 6723, 6724, 6725, 6726, 6727, 6728, 6729, 6730, 6731, 6732, 6733, 6734, 6735, 6736, 6737, 6738, 6739, 6740, 6741, 6742, 6743, 6744, 6745, 6746, 6747, 6748, 6749, 6750, 6751, 6752, 6753, 6754, 6755, 6756, 6757, 6758, 6759, 6760, 6761, 6762, 6763, 6764, 6765, 6766, 6767, 6768, 6769, 6770, 6771, 6772, 6773, 6774, 6775, 6776, 6777, 6778, 6779, 6780, 6781, 6782, 6783, 6784, 6785, 6786, 6787, 6788, 6789, 6790, 6791, 6792, 6793, 6794, 6795, 6796, 6797, 6798, 6799, 6800, 6801, 6802, 6803, 6804, 6805, 6806, 6807, 6808, 6809, 6810, 6811, 6812, 6813, 6814, 6815, 6816, 6817, 6818, 6819, 6820, 6821, 6822, 6823, 6824, 6825, 6826, 6827, 6828, 6829, 6830, 6831, 6832, 6833, 6834, 6835, 6836, 6837, 6838, 6839, 6840, 6841, 6842, 6843, 6844, 6845, 6846, 6847, 6848, 6849, 6850, 6851, 6852, 6853, 6854, 6855, 6856, 6857, 6858, 6859, 6860, 6860, 6861, 6862, 6863, 6864, 6865, 6866, 6867, 6868, 6869, 6870, 6871, 6872, 6873, 6874, 6875, 6876, 6877, 6878, 6879, 6880, 6881, 6882, 6883, 6884, 6885, 6886, 6887, 6888, 6889, 6890, 6891, 6892, 6893, 6894, 6895, 6896, 6897, 6898, 6899, 6900, 6901, 6902, 6903, 6904, 6905, 6906, 6907, 6908, 6909, 6910, 6910, 6910, 6910, 6910, 6910, 6910, 6910, 6910, 6910, 6910, 6910, 6910, 6910, 6910, 6910, 6910, 6910, 6910, 6910, 6910, 6910, 6910, 6910, 6910, 6910, 6910, 6910, 6910, 6911, 6912, 6913, 6914, 6915, 6916, 6917, 6918, 6919, 6920, 6921, 6922, 6923, 6924, 6925, 6926, 6927, 6928, 6929, 6930, 6931, 6932, 6933, 6934, 6935, 6936, 6937, 6938, 6939, 6940, 6941, 6942, 6943, 6944, 6945, 6946, 6947, 6948, 6949, 6950, 6951, 6952, 6953, 6954, 6955, 6956, 6957, 6958, 6959, 6960, 6961, 6962, 6963, 6964, 6965, 6966, 6967, 6968, 6969, 6970, 6971, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6972, 6973, 6974, 6975, 6976, 6977, 6978, 6979, 6980, 6981, 6982, 6983, 6984, 6985, 6986, 6987, 6988, 6989, 6990, 6991, 6992, 6993, 6994, 6995, 6996, 6997, 6998, 6999, 7000, 7001, 7002, 7003, 7004, 7005, 7006, 7006, 7006, 7006, 7006, 7006, 7006, 7006, 7006, 7006, 7006, 7006, 7007, 7008, 7009, 7010, 7010, 7011, 7012, 7013, 7014, 7015, 7016, 7017, 7018, 7019, 7020, 7021, 7022, 7023, 7024, 7025, 7026, 7027, 7028, 7029, 7030, 7031, 7032, 7033, 7034, 7035, 7036, 7037, 7037, 7038, 7039, 7039, 7040, 7040, 7041, 7041, 7042, 7043, 7044, 7045, 7046, 7047, 7048, 7049, 7050, 7051, 7051, 7052, 7053, 7054, 7055, 7055, 7056, 7056, 7057, 7057, 7058, 7058, 7059, 7059, 7060, 7060, 7061, 7061, 7062, 7063, 7064, 7064, 7065, 7066, 7066, 7067, 7067, 7068, 7068, 7069, 7069, 7070, 7070, 7071, 7071, 7072, 7072, 7073, 7074, 7074, 7075, 7075, 7076, 7077, 7078, 7079, 7079, 7080, 7081, 7082, 7083, 7084, 7085, 7086, 7086, 7087, 7088, 7089, 7090, 7090, 7091, 7092, 7093, 7094, 7094, 7095, 7095, 7096, 7097, 7098, 7099, 7100, 7101, 7102, 7103, 7104, 7105, 7105, 7106, 7107, 7108, 7109, 7110, 7111, 7112, 7113, 7114, 7115, 7116, 7117, 7118, 7119, 7120, 7121, 7122, 7122, 7123, 7124, 7125, 7125, 7126, 7127, 7128, 7129, 7130, 7130, 7131, 7132, 7133, 7134, 7135, 7136, 7137, 7138, 7139, 7140, 7141, 7142, 7143, 7144, 7145, 7146, 7147, 7147, 7147, 7147, 7147, 7147, 7147, 7147, 7147, 7147, 7147, 7147, 7147, 7147, 7147, 7147, 7147, 7147, 7147, 7149, 7151, 7153, 7155, 7157, 7159, 7161, 7163, 7165, 7167, 7167, 7167, 7170, 7173, 7176, 7179, 7182, 7185, 7188, 7191, 7194, 7197, 7200, 7203, 7206, 7209, 7212, 7215, 7218, 7221, 7224, 7227, 7230, 7233, 7236, 7239, 7242, 7245, 7248, 7249, 7250, 7252, 7254, 7254, 7255, 7256, 7257, 7258, 7259, 7260, 7261, 7262, 7263, 7264, 7265, 7266, 7267, 7268, 7269, 7270, 7271, 7272, 7273, 7274, 7275, 7276, 7277, 7278, 7279, 7280, 7282, 7284, 7286, 7288, 7291, 7293, 7293, 7293, 7293, 7293, 7293, 7295, 7297, 7299, 7299, 7299, 7299, 7299, 7299, 7299, 7299, 7299, 7299, 7299, 7301, 7301, 7301, 7301, 7301, 7301, 7303, 7305, 7306, 7306, 7307, 7308, 7309, 7310, 7311, 7312, 7313, 7314, 7315, 7316, 7317, 7318, 7319, 7320, 7321, 7322, 7323, 7324, 7325, 7326, 7327, 7328, 7329, 7330, 7331, 7332, 7333, 7334, 7335, 7336, 7337, 7338, 7339, 7340, 7341, 7342, 7343, 7344, 7345, 7346, 7347, 7348, 7349, 7350, 7350, 7353, 7356, 7359, 7362, 7365, 7368, 7371, 7374, 7377, 7377, 7378, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7379, 7380, 7381, 7382, 7383, 7384, 7385, 7386, 7387, 7388, 7389, 7389, 7389, 7389, 7389, 7389, 7389, 7389, 7389, 7389, 7389, 7389, 7389, 7389, 7389, 7389, 7389, 7389, 7389, 7390, 7391, 7392, 7393, 7394, 7395, 7396, 7397, 7398, 7399, 7400, 7401, 7402, 7403, 7404, 7405, 7406, 7407, 7408, 7409, 7410, 7411, 7412, 7413, 7414, 7415, 7416, 7417, 7418, 7419, 7420, 7421, 7422, 7423, 7424, 7425, 7426, 7427, 7428, 7429, 7430, 7431, 7432, 7433, 7434, 7435, 7436, 7437, 7438, 7439, 7440, 7441, 7442, 7443, 7444, 7445, 7446, 7447, 7448, 7449, 7450, 7451, 7452, 7453, 7454, 7455, 7456, 7457, 7458, 7459, 7460, 7461, 7462, 7463, 7464, 7465, 7466, 7467, 7468, 7469, 7470, 7471, 7472, 7473, 7474, 7475, 7476, 7477, 7478, 7479, 7480, 7481, 7482, 7483, 7484, 7485, 7486, 7487, 7488, 7489, 7490, 7491, 7492, 7493, 7494, 7495, 7496, 7497, 7498, 7499, 7500, 7501, 7502, 7503, 7504, 7505, 7506, 7507, 7508, 7509, 7510, 7511, 7512, 7513, 7514, 7515, 7516, 7517, 7518, 7519, 7520, 7521, 7522, 7523, 7524, 7525, 7526, 7527, 7528, 7529, 7530, 7531, 7532, 7533, 7534, 7535, 7536, 7537, 7538, 7539, 7540, 7541, 7542, 7543, 7544, 7545, 7546, 7547, 7548, 7549, 7550, 7551, 7552, 7553, 7554, 7555, 7556, 7557, 7558, 7559, 7560, 7561, 7562, 7563, 7564, 7565, 7566, 7567, 7568, 7569, 7570, 7571, 7572, 7573, 7574, 7575, 7576, 7577, 7578, 7579, 7580, 7581, 7582, 7583, 7584, 7585, 7586, 7587, 7588, 7589, 7590, 7591, 7592, 7593, 7594, 7595, 7596, 7597, 7598, 7599, 7600, 7601, 7602, 7603, 7604, 7605, 7606, 7607, 7608, 7609, 7610, 7611, 7612, 7613, 7614, 7615, 7616, 7617, 7618, 7619, 7620, 7621, 7622, 7623, 7624, 7625, 7626, 7627, 7628, 7629, 7630, 7631, 7632, 7633, 7634, 7635, 7636, 7637, 7638, 7639, 7640, 7641, 7642, 7643, 7644, 7645, 7646, 7647, 7648, 7649, 7650, 7651, 7652, 7653, 7654, 7655, 7656, 7657, 7658, 7659, 7660, 7661, 7662, 7663, 7664, 7665, 7666, 7667, 7668, 7669, 7670, 7671, 7672, 7673, 7674, 7675, 7676, 7677, 7678, 7679, 7680, 7681, 7682, 7683, 7684, 7685, 7686, 7687, 7688, 7689, 7690, 7691, 7692, 7693, 7694, 7695, 7696, 7697, 7698, 7699, 7700, 7701, 7702, 7703, 7704, 7705, 7706, 7707, 7708, 7709, 7710, 7711, 7712, 7713, 7714, 7715, 7716, 7717, 7718, 7719, 7720, 7721, 7722, 7723, 7724, 7725, 7726, 7727, 7728, 7729, 7730, 7731, 7732, 7733, 7734, 7735, 7736, 7737, 7738, 7739, 7740, 7741, 7742, 7743, 7744, 7745, 7746, 7747, 7748, 7749, 7750, 7751, 7752, 7753, 7754, 7755, 7756, 7757, 7758, 7759, 7760, 7761, 7762, 7763, 7764, 7765, 7766, 7767, 7768, 7769, 7770, 7771, 7772, 7773, 7774, 7775, 7776, 7777, 7778, 7779, 7780, 7781, 7782, 7783, 7784, 7785, 7786, 7787, 7788, 7789, 7790, 7791, 7792, 7793, 7794, 7795, 7796, 7797, 7798, 7799, 7800, 7801, 7802, 7803, 7804, 7805, 7806, 7807, 7808, 7809, 7810, 7811, 7812, 7813, 7814, 7815, 7816, 7817, 7818, 7819, 7820, 7821, 7822, 7823, 7824, 7825, 7826, 7827, 7828, 7829, 7830, 7831, 7832, 7833, 7834, 7835, 7836, 7837, 7838, 7839, 7840, 7841, 7842, 7843, 7844, 7845, 7846, 7847, 7848, 7849, 7850, 7851, 7852, 7853, 7854, 7855, 7856, 7857, 7858, 7859, 7860, 7861, 7862, 7863, 7864, 7865, 7866, 7867, 7868, 7869, 7870, 7871, 7872, 7873, 7874, 7875, 7876, 7877, 7878, 7879, 7880, 7881, 7882, 7883, 7884, 7885, 7886, 7887, 7888, 7889, 7890, 7891, 7892, 7893, 7894, 7895, 7896, 7897, 7898, 7899, 7900, 7901, 7902, 7903, 7904, 7905, 7906, 7907, 7908, 7909, 7910, 7911, 7912, 7913, 7914, 7915, 7916, 7917, 7918, 7919, 7920, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921, 7921];
const _M0FP410tonyfettes7unicode8internal4idna19idna__mapping__lens = [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 1, 0, 2, 0, 1, 0, 0, 0, 2, 0, 1, 1, 2, 1, 0, 0, 2, 1, 1, 0, 3, 3, 3, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 2, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 2, 0, 2, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 2, 1, 0, 1, 0, 1, 0, 1, 0, 2, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 1, 0, 1, 1, 0, 1, 1, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 1, 1, 0, 1, 0, 1, 1, 0, 1, 0, 2, 2, 2, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 2, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 1, 0, 1, 1, 0, 1, 0, 1, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 2, 0, 1, 1, 0, 2, 3, 1, 1, 1, 1, 1, 0, 1, 0, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 0, 1, 1, 0, 1, 0, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 0, 0, 0, 2, 0, 2, 2, 3, 2, 3, 0, 2, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 2, 0, 2, 0, 2, 0, 2, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 2, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 2, 2, 0, 0, 2, 1, 1, 1, 1, 2, 2, 1, 2, 2, 3, 2, 2, 2, 0, 0, 2, 1, 1, 1, 1, 2, 3, 3, 3, 0, 1, 0, 0, 1, 1, 1, 1, 0, 3, 3, 3, 0, 1, 0, 1, 1, 1, 1, 1, 3, 3, 1, 0, 2, 2, 2, 0, 0, 2, 1, 1, 1, 1, 2, 2, 2, 0, 1, 0, 0, 0, 0, 1, 0, 2, 0, 0, 0, 0, 1, 0, 2, 3, 0, 2, 3, 0, 2, 0, 2, 0, 2, 2, 2, 0, 0, 0, 0, 4, 0, 1, 0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 3, 1, 2, 0, 3, 3, 1, 0, 2, 1, 1, 1, 1, 1, 0, 1, 2, 0, 1, 1, 1, 0, 2, 3, 2, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 3, 1, 1, 1, 1, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 3, 3, 4, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 1, 2, 3, 2, 1, 2, 3, 4, 2, 1, 2, 3, 1, 1, 1, 1, 1, 2, 3, 2, 1, 2, 3, 4, 2, 1, 2, 3, 1, 1, 1, 1, 0, 1, 0, 0, 3, 0, 0, 0, 0, 0, 0, 2, 3, 0, 2, 3, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 0, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 3, 2, 3, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 0, 1, 0, 0, 1, 0, 0, 1, 1, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 1, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 0, 2, 0, 0, 2, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 0, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 1, 1, 1, 0, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 2, 3, 2, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 4, 4, 4, 3, 4, 3, 3, 5, 4, 3, 3, 3, 4, 4, 3, 3, 2, 3, 4, 4, 2, 5, 6, 5, 3, 5, 5, 4, 3, 3, 3, 4, 5, 4, 3, 3, 3, 2, 2, 2, 2, 3, 3, 5, 3, 4, 5, 3, 2, 2, 5, 4, 5, 3, 5, 2, 3, 3, 3, 3, 3, 4, 3, 2, 3, 3, 3, 4, 3, 3, 3, 5, 4, 2, 5, 2, 4, 4, 3, 3, 3, 4, 2, 3, 4, 2, 5, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 2, 3, 2, 2, 2, 3, 3, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 3, 4, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 2, 3, 3, 3, 2, 3, 3, 4, 2, 3, 3, 3, 3, 5, 6, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 2, 2, 4, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 2, 2, 3, 3, 2, 0, 3, 2, 2, 2, 2, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 0, 1, 0, 1, 1, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 2, 2, 2, 3, 3, 2, 0, 2, 2, 2, 2, 2, 0, 2, 0, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 2, 2, 2, 2, 0, 2, 0, 2, 2, 0, 2, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 0, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 0, 0, 0, 3, 3, 4, 4, 4, 4, 4, 4, 4, 3, 18, 8, 4, 0, 0, 0, 1, 1, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 2, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 0, 2, 2, 2, 0, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 2, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 3, 3, 3, 3, 3, 0, 0, 0, 2, 2, 3, 3, 3, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 0, 1, 0, 1, 1, 0, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 0, 1, 1, 1, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 1, 2, 2, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 3, 2, 0, 0, 0, 0, 0, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 2, 2, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 3, 3, 3, 3, 3, 3, 3, 3, 3, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
const _M0FP410tonyfettes7unicode8internal4idna19idna__mapping__data = [97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 32, 32, 776, 97, 32, 772, 50, 51, 32, 769, 956, 32, 807, 49, 111, 49, 8260, 52, 49, 8260, 50, 51, 8260, 52, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 248, 249, 250, 251, 252, 253, 254, 115, 115, 257, 259, 261, 263, 265, 267, 269, 271, 273, 275, 277, 279, 281, 283, 285, 287, 289, 291, 293, 295, 297, 299, 301, 303, 105, 775, 105, 106, 309, 311, 314, 316, 318, 108, 183, 322, 324, 326, 328, 700, 110, 331, 333, 335, 337, 339, 341, 343, 345, 347, 349, 351, 353, 355, 357, 359, 361, 363, 365, 367, 369, 371, 373, 375, 255, 378, 380, 382, 115, 595, 387, 389, 596, 392, 598, 599, 396, 477, 601, 603, 402, 608, 611, 617, 616, 409, 623, 626, 629, 417, 419, 421, 640, 424, 643, 429, 648, 432, 650, 651, 436, 438, 658, 441, 445, 100, 382, 108, 106, 110, 106, 462, 464, 466, 468, 470, 472, 474, 476, 479, 481, 483, 485, 487, 489, 491, 493, 495, 100, 122, 501, 405, 447, 505, 507, 509, 511, 513, 515, 517, 519, 521, 523, 525, 527, 529, 531, 533, 535, 537, 539, 541, 543, 414, 547, 549, 551, 553, 555, 557, 559, 561, 563, 11365, 572, 410, 11366, 578, 384, 649, 652, 583, 585, 587, 589, 591, 104, 614, 106, 114, 633, 635, 641, 119, 121, 32, 774, 32, 775, 32, 778, 32, 808, 32, 771, 32, 779, 611, 108, 115, 120, 661, 768, 769, 787, 776, 769, 953, 881, 883, 697, 887, 32, 953, 59, 1011, 32, 769, 32, 776, 769, 940, 183, 941, 942, 943, 972, 973, 974, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 963, 964, 965, 966, 967, 968, 969, 970, 971, 963, 983, 946, 952, 965, 973, 971, 966, 960, 985, 987, 989, 991, 993, 995, 997, 999, 1001, 1003, 1005, 1007, 954, 961, 963, 952, 949, 1016, 963, 1019, 891, 892, 893, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1121, 1123, 1125, 1127, 1129, 1131, 1133, 1135, 1137, 1139, 1141, 1143, 1145, 1147, 1149, 1151, 1153, 1163, 1165, 1167, 1169, 1171, 1173, 1175, 1177, 1179, 1181, 1183, 1185, 1187, 1189, 1191, 1193, 1195, 1197, 1199, 1201, 1203, 1205, 1207, 1209, 1211, 1213, 1215, 1231, 1218, 1220, 1222, 1224, 1226, 1228, 1230, 1233, 1235, 1237, 1239, 1241, 1243, 1245, 1247, 1249, 1251, 1253, 1255, 1257, 1259, 1261, 1263, 1265, 1267, 1269, 1271, 1273, 1275, 1277, 1279, 1281, 1283, 1285, 1287, 1289, 1291, 1293, 1295, 1297, 1299, 1301, 1303, 1305, 1307, 1309, 1311, 1313, 1315, 1317, 1319, 1321, 1323, 1325, 1327, 1377, 1378, 1379, 1380, 1381, 1382, 1383, 1384, 1385, 1386, 1387, 1388, 1389, 1390, 1391, 1392, 1393, 1394, 1395, 1396, 1397, 1398, 1399, 1400, 1401, 1402, 1403, 1404, 1405, 1406, 1407, 1408, 1409, 1410, 1411, 1412, 1413, 1414, 1381, 1410, 1575, 1652, 1608, 1652, 1735, 1652, 1610, 1652, 2325, 2364, 2326, 2364, 2327, 2364, 2332, 2364, 2337, 2364, 2338, 2364, 2347, 2364, 2351, 2364, 2465, 2492, 2466, 2492, 2479, 2492, 2610, 2620, 2616, 2620, 2582, 2620, 2583, 2620, 2588, 2620, 2603, 2620, 2849, 2876, 2850, 2876, 3661, 3634, 3789, 3762, 3755, 3737, 3755, 3745, 3851, 3906, 4023, 3916, 4023, 3921, 4023, 3926, 4023, 3931, 4023, 3904, 4021, 3953, 3954, 3953, 3956, 4018, 3968, 4018, 3953, 3968, 4019, 3968, 4019, 3953, 3968, 3953, 3968, 3986, 4023, 3996, 4023, 4001, 4023, 4006, 4023, 4011, 4023, 3984, 4021, 11520, 11521, 11522, 11523, 11524, 11525, 11526, 11527, 11528, 11529, 11530, 11531, 11532, 11533, 11534, 11535, 11536, 11537, 11538, 11539, 11540, 11541, 11542, 11543, 11544, 11545, 11546, 11547, 11548, 11549, 11550, 11551, 11552, 11553, 11554, 11555, 11556, 11557, 11559, 11565, 4316, 5104, 5105, 5106, 5107, 5108, 5109, 1074, 1076, 1086, 1089, 1090, 1098, 1123, 42571, 7306, 4304, 4305, 4306, 4307, 4308, 4309, 4310, 4311, 4312, 4313, 4314, 4315, 4316, 4317, 4318, 4319, 4320, 4321, 4322, 4323, 4324, 4325, 4326, 4327, 4328, 4329, 4330, 4331, 4332, 4333, 4334, 4335, 4336, 4337, 4338, 4339, 4340, 4341, 4342, 4343, 4344, 4345, 4346, 4349, 4350, 4351, 97, 230, 98, 100, 101, 477, 103, 104, 105, 106, 107, 108, 109, 110, 111, 547, 112, 114, 116, 117, 119, 97, 592, 593, 7426, 98, 100, 101, 601, 603, 604, 103, 107, 109, 331, 111, 596, 7446, 7447, 112, 116, 117, 7453, 623, 118, 7461, 946, 947, 948, 966, 967, 105, 114, 117, 118, 946, 947, 961, 966, 967, 1085, 594, 99, 597, 240, 604, 102, 607, 609, 613, 616, 617, 618, 7547, 669, 621, 7557, 671, 625, 624, 626, 627, 628, 629, 632, 642, 643, 427, 649, 650, 7452, 651, 652, 122, 656, 657, 658, 952, 7681, 7683, 7685, 7687, 7689, 7691, 7693, 7695, 7697, 7699, 7701, 7703, 7705, 7707, 7709, 7711, 7713, 7715, 7717, 7719, 7721, 7723, 7725, 7727, 7729, 7731, 7733, 7735, 7737, 7739, 7741, 7743, 7745, 7747, 7749, 7751, 7753, 7755, 7757, 7759, 7761, 7763, 7765, 7767, 7769, 7771, 7773, 7775, 7777, 7779, 7781, 7783, 7785, 7787, 7789, 7791, 7793, 7795, 7797, 7799, 7801, 7803, 7805, 7807, 7809, 7811, 7813, 7815, 7817, 7819, 7821, 7823, 7825, 7827, 7829, 97, 702, 7777, 223, 7841, 7843, 7845, 7847, 7849, 7851, 7853, 7855, 7857, 7859, 7861, 7863, 7865, 7867, 7869, 7871, 7873, 7875, 7877, 7879, 7881, 7883, 7885, 7887, 7889, 7891, 7893, 7895, 7897, 7899, 7901, 7903, 7905, 7907, 7909, 7911, 7913, 7915, 7917, 7919, 7921, 7923, 7925, 7927, 7929, 7931, 7933, 7935, 7936, 7937, 7938, 7939, 7940, 7941, 7942, 7943, 7952, 7953, 7954, 7955, 7956, 7957, 7968, 7969, 7970, 7971, 7972, 7973, 7974, 7975, 7984, 7985, 7986, 7987, 7988, 7989, 7990, 7991, 8000, 8001, 8002, 8003, 8004, 8005, 8017, 8019, 8021, 8023, 8032, 8033, 8034, 8035, 8036, 8037, 8038, 8039, 940, 941, 942, 943, 972, 973, 974, 7936, 953, 7937, 953, 7938, 953, 7939, 953, 7940, 953, 7941, 953, 7942, 953, 7943, 953, 7936, 953, 7937, 953, 7938, 953, 7939, 953, 7940, 953, 7941, 953, 7942, 953, 7943, 953, 7968, 953, 7969, 953, 7970, 953, 7971, 953, 7972, 953, 7973, 953, 7974, 953, 7975, 953, 7968, 953, 7969, 953, 7970, 953, 7971, 953, 7972, 953, 7973, 953, 7974, 953, 7975, 953, 8032, 953, 8033, 953, 8034, 953, 8035, 953, 8036, 953, 8037, 953, 8038, 953, 8039, 953, 8032, 953, 8033, 953, 8034, 953, 8035, 953, 8036, 953, 8037, 953, 8038, 953, 8039, 953, 8048, 953, 945, 953, 940, 953, 8118, 953, 8112, 8113, 8048, 940, 945, 953, 32, 787, 953, 32, 787, 32, 834, 32, 776, 834, 8052, 953, 951, 953, 942, 953, 8134, 953, 8050, 941, 8052, 942, 951, 953, 32, 787, 768, 32, 787, 769, 32, 787, 834, 912, 8144, 8145, 8054, 943, 32, 788, 768, 32, 788, 769, 32, 788, 834, 944, 8160, 8161, 8058, 973, 8165, 32, 776, 768, 32, 776, 769, 96, 8060, 953, 969, 953, 974, 953, 8182, 953, 8056, 972, 8060, 974, 969, 953, 32, 769, 32, 788, 32, 8208, 32, 819, 32, 8242, 8242, 8242, 8242, 8242, 8245, 8245, 8245, 8245, 8245, 33, 33, 32, 773, 63, 63, 63, 33, 33, 63, 8242, 8242, 8242, 8242, 32, 48, 105, 52, 53, 54, 55, 56, 57, 43, 8722, 61, 40, 41, 110, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 43, 8722, 61, 40, 41, 97, 101, 111, 120, 601, 104, 107, 108, 109, 110, 112, 115, 116, 114, 115, 97, 47, 99, 97, 47, 115, 99, 176, 99, 99, 47, 111, 99, 47, 117, 603, 176, 102, 103, 104, 295, 105, 108, 110, 110, 111, 112, 113, 114, 115, 109, 116, 101, 108, 116, 109, 122, 969, 122, 107, 229, 98, 99, 101, 102, 8526, 109, 111, 1488, 1489, 1490, 1491, 105, 102, 97, 120, 960, 947, 960, 8721, 100, 101, 105, 106, 49, 8260, 55, 49, 8260, 57, 49, 8260, 49, 48, 49, 8260, 51, 50, 8260, 51, 49, 8260, 53, 50, 8260, 53, 51, 8260, 53, 52, 8260, 53, 49, 8260, 54, 53, 8260, 54, 49, 8260, 56, 51, 8260, 56, 53, 8260, 56, 55, 8260, 56, 49, 8260, 105, 105, 105, 105, 105, 105, 105, 118, 118, 118, 105, 118, 105, 105, 118, 105, 105, 105, 105, 120, 120, 120, 105, 120, 105, 105, 108, 99, 100, 109, 105, 105, 105, 105, 105, 105, 105, 118, 118, 118, 105, 118, 105, 105, 118, 105, 105, 105, 105, 120, 120, 120, 105, 120, 105, 105, 108, 99, 100, 109, 8580, 48, 8260, 51, 8747, 8747, 8747, 8747, 8747, 8750, 8750, 8750, 8750, 8750, 12296, 12297, 49, 50, 51, 52, 53, 54, 55, 56, 57, 49, 48, 49, 49, 49, 50, 49, 51, 49, 52, 49, 53, 49, 54, 49, 55, 49, 56, 49, 57, 50, 48, 40, 49, 41, 40, 50, 41, 40, 51, 41, 40, 52, 41, 40, 53, 41, 40, 54, 41, 40, 55, 41, 40, 56, 41, 40, 57, 41, 40, 49, 48, 41, 40, 49, 49, 41, 40, 49, 50, 41, 40, 49, 51, 41, 40, 49, 52, 41, 40, 49, 53, 41, 40, 49, 54, 41, 40, 49, 55, 41, 40, 49, 56, 41, 40, 49, 57, 41, 40, 50, 48, 41, 40, 97, 41, 40, 98, 41, 40, 99, 41, 40, 100, 41, 40, 101, 41, 40, 102, 41, 40, 103, 41, 40, 104, 41, 40, 105, 41, 40, 106, 41, 40, 107, 41, 40, 108, 41, 40, 109, 41, 40, 110, 41, 40, 111, 41, 40, 112, 41, 40, 113, 41, 40, 114, 41, 40, 115, 41, 40, 116, 41, 40, 117, 41, 40, 118, 41, 40, 119, 41, 40, 120, 41, 40, 121, 41, 40, 122, 41, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 48, 8747, 8747, 8747, 8747, 58, 58, 61, 61, 61, 61, 61, 61, 10973, 824, 11312, 11313, 11314, 11315, 11316, 11317, 11318, 11319, 11320, 11321, 11322, 11323, 11324, 11325, 11326, 11327, 11328, 11329, 11330, 11331, 11332, 11333, 11334, 11335, 11336, 11337, 11338, 11339, 11340, 11341, 11342, 11343, 11344, 11345, 11346, 11347, 11348, 11349, 11350, 11351, 11352, 11353, 11354, 11355, 11356, 11357, 11358, 11359, 11361, 619, 7549, 637, 11368, 11370, 11372, 593, 625, 592, 594, 11379, 11382, 106, 118, 575, 576, 11393, 11395, 11397, 11399, 11401, 11403, 11405, 11407, 11409, 11411, 11413, 11415, 11417, 11419, 11421, 11423, 11425, 11427, 11429, 11431, 11433, 11435, 11437, 11439, 11441, 11443, 11445, 11447, 11449, 11451, 11453, 11455, 11457, 11459, 11461, 11463, 11465, 11467, 11469, 11471, 11473, 11475, 11477, 11479, 11481, 11483, 11485, 11487, 11489, 11491, 11500, 11502, 11507, 11617, 27597, 40863, 19968, 20008, 20022, 20031, 20057, 20101, 20108, 20128, 20154, 20799, 20837, 20843, 20866, 20886, 20907, 20960, 20981, 20992, 21147, 21241, 21269, 21274, 21304, 21313, 21340, 21353, 21378, 21430, 21448, 21475, 22231, 22303, 22763, 22786, 22794, 22805, 22823, 22899, 23376, 23424, 23544, 23567, 23586, 23608, 23662, 23665, 24027, 24037, 24049, 24062, 24178, 24186, 24191, 24308, 24318, 24331, 24339, 24400, 24417, 24435, 24515, 25096, 25142, 25163, 25903, 25908, 25991, 26007, 26020, 26041, 26080, 26085, 26352, 26376, 26408, 27424, 27490, 27513, 27571, 27595, 27604, 27611, 27663, 27668, 27700, 28779, 29226, 29238, 29243, 29247, 29255, 29273, 29275, 29356, 29572, 29577, 29916, 29926, 29976, 29983, 29992, 30000, 30091, 30098, 30326, 30333, 30382, 30399, 30446, 30683, 30690, 30707, 31034, 31160, 31166, 31348, 31435, 31481, 31859, 31992, 32566, 32593, 32650, 32701, 32769, 32780, 32786, 32819, 32895, 32905, 33251, 33258, 33267, 33276, 33292, 33307, 33311, 33390, 33394, 33400, 34381, 34411, 34880, 34892, 34915, 35198, 35211, 35282, 35328, 35895, 35910, 35925, 35960, 35997, 36196, 36208, 36275, 36523, 36554, 36763, 36784, 36789, 37009, 37193, 37318, 37324, 37329, 38263, 38272, 38428, 38582, 38585, 38632, 38737, 38750, 38754, 38761, 38859, 38893, 38899, 38913, 39080, 39131, 39135, 39318, 39321, 39340, 39592, 39640, 39647, 39717, 39727, 39730, 39740, 39770, 40165, 40565, 40575, 40613, 40635, 40643, 40653, 40657, 40697, 40701, 40718, 40723, 40736, 40763, 40778, 40786, 40845, 40860, 40864, 32, 46, 12306, 21313, 21316, 21317, 32, 12441, 32, 12442, 12424, 12426, 12467, 12488, 4352, 4353, 4522, 4354, 4524, 4525, 4355, 4356, 4357, 4528, 4529, 4530, 4531, 4532, 4533, 4378, 4358, 4359, 4360, 4385, 4361, 4362, 4363, 4364, 4365, 4366, 4367, 4368, 4369, 4370, 4449, 4450, 4451, 4452, 4453, 4454, 4455, 4456, 4457, 4458, 4459, 4460, 4461, 4462, 4463, 4464, 4465, 4466, 4467, 4468, 4469, 4372, 4373, 4551, 4552, 4556, 4558, 4563, 4567, 4569, 4380, 4573, 4575, 4381, 4382, 4384, 4386, 4387, 4391, 4393, 4395, 4396, 4397, 4398, 4399, 4402, 4406, 4416, 4423, 4428, 4593, 4594, 4439, 4440, 4441, 4484, 4485, 4488, 4497, 4498, 4500, 4510, 4513, 19968, 20108, 19977, 22235, 19978, 20013, 19979, 30002, 20057, 19993, 19969, 22825, 22320, 20154, 40, 4352, 41, 40, 4354, 41, 40, 4355, 41, 40, 4357, 41, 40, 4358, 41, 40, 4359, 41, 40, 4361, 41, 40, 4363, 41, 40, 4364, 41, 40, 4366, 41, 40, 4367, 41, 40, 4368, 41, 40, 4369, 41, 40, 4370, 41, 40, 44032, 41, 40, 45208, 41, 40, 45796, 41, 40, 46972, 41, 40, 47560, 41, 40, 48148, 41, 40, 49324, 41, 40, 50500, 41, 40, 51088, 41, 40, 52264, 41, 40, 52852, 41, 40, 53440, 41, 40, 54028, 41, 40, 54616, 41, 40, 51452, 41, 40, 50724, 51204, 41, 40, 50724, 54980, 41, 40, 19968, 41, 40, 20108, 41, 40, 19977, 41, 40, 22235, 41, 40, 20116, 41, 40, 20845, 41, 40, 19971, 41, 40, 20843, 41, 40, 20061, 41, 40, 21313, 41, 40, 26376, 41, 40, 28779, 41, 40, 27700, 41, 40, 26408, 41, 40, 37329, 41, 40, 22303, 41, 40, 26085, 41, 40, 26666, 41, 40, 26377, 41, 40, 31038, 41, 40, 21517, 41, 40, 29305, 41, 40, 36001, 41, 40, 31069, 41, 40, 21172, 41, 40, 20195, 41, 40, 21628, 41, 40, 23398, 41, 40, 30435, 41, 40, 20225, 41, 40, 36039, 41, 40, 21332, 41, 40, 31085, 41, 40, 20241, 41, 40, 33258, 41, 40, 33267, 41, 21839, 24188, 25991, 31631, 112, 116, 101, 50, 49, 50, 50, 50, 51, 50, 52, 50, 53, 50, 54, 50, 55, 50, 56, 50, 57, 51, 48, 51, 49, 51, 50, 51, 51, 51, 52, 51, 53, 4352, 4354, 4355, 4357, 4358, 4359, 4361, 4363, 4364, 4366, 4367, 4368, 4369, 4370, 44032, 45208, 45796, 46972, 47560, 48148, 49324, 50500, 51088, 52264, 52852, 53440, 54028, 54616, 52280, 44256, 51452, 51032, 50864, 19968, 20108, 19977, 22235, 20116, 20845, 19971, 20843, 20061, 21313, 26376, 28779, 27700, 26408, 37329, 22303, 26085, 26666, 26377, 31038, 21517, 29305, 36001, 31069, 21172, 31192, 30007, 22899, 36969, 20778, 21360, 27880, 38917, 20241, 20889, 27491, 19978, 20013, 19979, 24038, 21491, 21307, 23447, 23398, 30435, 20225, 36039, 21332, 22812, 51, 54, 51, 55, 51, 56, 51, 57, 52, 48, 52, 49, 52, 50, 52, 51, 52, 52, 52, 53, 52, 54, 52, 55, 52, 56, 52, 57, 53, 48, 49, 26376, 50, 26376, 51, 26376, 52, 26376, 53, 26376, 54, 26376, 55, 26376, 56, 26376, 57, 26376, 49, 48, 26376, 49, 49, 26376, 49, 50, 26376, 104, 103, 101, 114, 103, 101, 118, 108, 116, 100, 12450, 12452, 12454, 12456, 12458, 12459, 12461, 12463, 12465, 12467, 12469, 12471, 12473, 12475, 12477, 12479, 12481, 12484, 12486, 12488, 12490, 12491, 12492, 12493, 12494, 12495, 12498, 12501, 12504, 12507, 12510, 12511, 12512, 12513, 12514, 12516, 12518, 12520, 12521, 12522, 12523, 12524, 12525, 12527, 12528, 12529, 12530, 20196, 21644, 12450, 12497, 12540, 12488, 12450, 12523, 12501, 12449, 12450, 12531, 12506, 12450, 12450, 12540, 12523, 12452, 12491, 12531, 12464, 12452, 12531, 12481, 12454, 12457, 12531, 12456, 12473, 12463, 12540, 12489, 12456, 12540, 12459, 12540, 12458, 12531, 12473, 12458, 12540, 12512, 12459, 12452, 12522, 12459, 12521, 12483, 12488, 12459, 12525, 12522, 12540, 12460, 12525, 12531, 12460, 12531, 12510, 12462, 12460, 12462, 12491, 12540, 12461, 12517, 12522, 12540, 12462, 12523, 12480, 12540, 12461, 12525, 12461, 12525, 12464, 12521, 12512, 12461, 12525, 12513, 12540, 12488, 12523, 12461, 12525, 12527, 12483, 12488, 12464, 12521, 12512, 12464, 12521, 12512, 12488, 12531, 12463, 12523, 12476, 12452, 12525, 12463, 12525, 12540, 12493, 12465, 12540, 12473, 12467, 12523, 12490, 12467, 12540, 12509, 12469, 12452, 12463, 12523, 12469, 12531, 12481, 12540, 12512, 12471, 12522, 12531, 12464, 12475, 12531, 12481, 12475, 12531, 12488, 12480, 12540, 12473, 12487, 12471, 12489, 12523, 12488, 12531, 12490, 12494, 12494, 12483, 12488, 12495, 12452, 12484, 12497, 12540, 12475, 12531, 12488, 12497, 12540, 12484, 12496, 12540, 12524, 12523, 12500, 12450, 12473, 12488, 12523, 12500, 12463, 12523, 12500, 12467, 12499, 12523, 12501, 12449, 12521, 12483, 12489, 12501, 12451, 12540, 12488, 12502, 12483, 12471, 12455, 12523, 12501, 12521, 12531, 12504, 12463, 12479, 12540, 12523, 12506, 12477, 12506, 12491, 12498, 12504, 12523, 12484, 12506, 12531, 12473, 12506, 12540, 12472, 12505, 12540, 12479, 12509, 12452, 12531, 12488, 12508, 12523, 12488, 12507, 12531, 12509, 12531, 12489, 12507, 12540, 12523, 12507, 12540, 12531, 12510, 12452, 12463, 12525, 12510, 12452, 12523, 12510, 12483, 12495, 12510, 12523, 12463, 12510, 12531, 12471, 12519, 12531, 12511, 12463, 12525, 12531, 12511, 12522, 12511, 12522, 12496, 12540, 12523, 12513, 12460, 12513, 12460, 12488, 12531, 12513, 12540, 12488, 12523, 12516, 12540, 12489, 12516, 12540, 12523, 12518, 12450, 12531, 12522, 12483, 12488, 12523, 12522, 12521, 12523, 12500, 12540, 12523, 12540, 12502, 12523, 12524, 12512, 12524, 12531, 12488, 12466, 12531, 12527, 12483, 12488, 48, 28857, 49, 28857, 50, 28857, 51, 28857, 52, 28857, 53, 28857, 54, 28857, 55, 28857, 56, 28857, 57, 28857, 49, 48, 28857, 49, 49, 28857, 49, 50, 28857, 49, 51, 28857, 49, 52, 28857, 49, 53, 28857, 49, 54, 28857, 49, 55, 28857, 49, 56, 28857, 49, 57, 28857, 50, 48, 28857, 50, 49, 28857, 50, 50, 28857, 50, 51, 28857, 50, 52, 28857, 104, 112, 97, 100, 97, 97, 117, 98, 97, 114, 111, 118, 112, 99, 100, 109, 100, 109, 50, 100, 109, 51, 105, 117, 24179, 25104, 26157, 21644, 22823, 27491, 26126, 27835, 26666, 24335, 20250, 31038, 112, 97, 110, 97, 956, 97, 109, 97, 107, 97, 107, 98, 109, 98, 103, 98, 99, 97, 108, 107, 99, 97, 108, 112, 102, 110, 102, 956, 102, 956, 103, 109, 103, 107, 103, 104, 122, 107, 104, 122, 109, 104, 122, 103, 104, 122, 116, 104, 122, 956, 108, 109, 108, 100, 108, 107, 108, 102, 109, 110, 109, 956, 109, 109, 109, 99, 109, 107, 109, 109, 109, 50, 99, 109, 50, 109, 50, 107, 109, 50, 109, 109, 51, 99, 109, 51, 109, 51, 107, 109, 51, 109, 8725, 115, 109, 8725, 115, 50, 112, 97, 107, 112, 97, 109, 112, 97, 103, 112, 97, 114, 97, 100, 114, 97, 100, 8725, 115, 114, 97, 100, 8725, 115, 50, 112, 115, 110, 115, 956, 115, 109, 115, 112, 118, 110, 118, 956, 118, 109, 118, 107, 118, 109, 118, 112, 119, 110, 119, 956, 119, 109, 119, 107, 119, 109, 119, 107, 969, 109, 969, 98, 113, 99, 99, 99, 100, 99, 8725, 107, 103, 100, 98, 103, 121, 104, 97, 104, 112, 105, 110, 107, 107, 107, 109, 107, 116, 108, 109, 108, 110, 108, 111, 103, 108, 120, 109, 98, 109, 105, 108, 109, 111, 108, 112, 104, 112, 112, 109, 112, 114, 115, 114, 115, 118, 119, 98, 118, 8725, 109, 97, 8725, 109, 49, 26085, 50, 26085, 51, 26085, 52, 26085, 53, 26085, 54, 26085, 55, 26085, 56, 26085, 57, 26085, 49, 48, 26085, 49, 49, 26085, 49, 50, 26085, 49, 51, 26085, 49, 52, 26085, 49, 53, 26085, 49, 54, 26085, 49, 55, 26085, 49, 56, 26085, 49, 57, 26085, 50, 48, 26085, 50, 49, 26085, 50, 50, 26085, 50, 51, 26085, 50, 52, 26085, 50, 53, 26085, 50, 54, 26085, 50, 55, 26085, 50, 56, 26085, 50, 57, 26085, 51, 48, 26085, 51, 49, 26085, 103, 97, 108, 42561, 42563, 42565, 42567, 42569, 42571, 42573, 42575, 42577, 42579, 42581, 42583, 42585, 42587, 42589, 42591, 42593, 42595, 42597, 42599, 42601, 42603, 42605, 42625, 42627, 42629, 42631, 42633, 42635, 42637, 42639, 42641, 42643, 42645, 42647, 42649, 42651, 1098, 1100, 42787, 42789, 42791, 42793, 42795, 42797, 42799, 42803, 42805, 42807, 42809, 42811, 42813, 42815, 42817, 42819, 42821, 42823, 42825, 42827, 42829, 42831, 42833, 42835, 42837, 42839, 42841, 42843, 42845, 42847, 42849, 42851, 42853, 42855, 42857, 42859, 42861, 42863, 42863, 42874, 42876, 7545, 42879, 42881, 42883, 42885, 42887, 42892, 613, 42897, 42899, 42903, 42905, 42907, 42909, 42911, 42913, 42915, 42917, 42919, 42921, 614, 604, 609, 620, 618, 670, 647, 669, 43859, 42933, 42935, 42937, 42939, 42941, 42943, 42945, 42947, 42900, 642, 7566, 42952, 42954, 612, 42957, 42961, 42967, 42969, 42971, 411, 99, 102, 113, 42998, 295, 339, 42791, 43831, 619, 43858, 653, 5024, 5025, 5026, 5027, 5028, 5029, 5030, 5031, 5032, 5033, 5034, 5035, 5036, 5037, 5038, 5039, 5040, 5041, 5042, 5043, 5044, 5045, 5046, 5047, 5048, 5049, 5050, 5051, 5052, 5053, 5054, 5055, 5056, 5057, 5058, 5059, 5060, 5061, 5062, 5063, 5064, 5065, 5066, 5067, 5068, 5069, 5070, 5071, 5072, 5073, 5074, 5075, 5076, 5077, 5078, 5079, 5080, 5081, 5082, 5083, 5084, 5085, 5086, 5087, 5088, 5089, 5090, 5091, 5092, 5093, 5094, 5095, 5096, 5097, 5098, 5099, 5100, 5101, 5102, 5103, 35912, 26356, 36554, 36040, 28369, 20018, 21477, 40860, 22865, 37329, 21895, 22856, 25078, 30313, 32645, 34367, 34746, 35064, 37007, 27138, 27931, 28889, 29662, 33853, 37226, 39409, 20098, 21365, 27396, 29211, 34349, 40478, 23888, 28651, 34253, 35172, 25289, 33240, 34847, 24266, 26391, 28010, 29436, 37070, 20358, 20919, 21214, 25796, 27347, 29200, 30439, 32769, 34310, 34396, 36335, 38706, 39791, 40442, 30860, 31103, 32160, 33737, 37636, 40575, 35542, 22751, 24324, 31840, 32894, 29282, 30922, 36034, 38647, 22744, 23650, 27155, 28122, 28431, 32047, 32311, 38475, 21202, 32907, 20956, 20940, 31260, 32190, 33777, 38517, 35712, 25295, 27138, 35582, 20025, 23527, 24594, 29575, 30064, 21271, 30971, 20415, 24489, 19981, 27852, 25976, 32034, 21443, 22622, 30465, 33865, 35498, 27578, 36784, 27784, 25342, 33509, 25504, 30053, 20142, 20841, 20937, 26753, 31975, 33391, 35538, 37327, 21237, 21570, 22899, 24300, 26053, 28670, 31018, 38317, 39530, 40599, 40654, 21147, 26310, 27511, 36706, 24180, 24976, 25088, 25754, 28451, 29001, 29833, 31178, 32244, 32879, 36646, 34030, 36899, 37706, 21015, 21155, 21693, 28872, 35010, 35498, 24265, 24565, 25467, 27566, 31806, 29557, 20196, 22265, 23527, 23994, 24604, 29618, 29801, 32666, 32838, 37428, 38646, 38728, 38936, 20363, 31150, 37300, 38584, 24801, 20102, 20698, 23534, 23615, 26009, 27138, 29134, 30274, 34044, 36988, 40845, 26248, 38446, 21129, 26491, 26611, 27969, 28316, 29705, 30041, 30827, 32016, 39006, 20845, 25134, 38520, 20523, 23833, 28138, 36650, 24459, 24900, 26647, 29575, 38534, 21033, 21519, 23653, 26131, 26446, 26792, 27877, 29702, 30178, 32633, 35023, 35041, 37324, 38626, 21311, 28346, 21533, 29136, 29848, 34298, 38563, 40023, 40607, 26519, 28107, 33256, 31435, 31520, 31890, 29376, 28825, 35672, 20160, 33590, 21050, 20999, 24230, 25299, 31958, 23429, 27934, 26292, 36667, 34892, 38477, 35211, 24275, 20800, 21952, 22618, 26228, 20958, 29482, 30410, 31036, 31070, 31077, 31119, 38742, 31934, 32701, 34322, 35576, 36920, 37117, 39151, 39164, 39208, 40372, 37086, 38583, 20398, 20711, 20813, 21193, 21220, 21329, 21917, 22022, 22120, 22592, 22696, 23652, 23662, 24724, 24936, 24974, 25074, 25935, 26082, 26257, 26757, 28023, 28186, 28450, 29038, 29227, 29730, 30865, 31038, 31049, 31048, 31056, 31062, 31069, 31117, 31118, 31296, 31361, 31680, 32244, 32265, 32321, 32626, 32773, 33261, 33401, 33879, 35088, 35222, 35585, 35641, 36051, 36104, 36790, 36920, 38627, 38911, 38971, 24693, 148206, 33304, 20006, 20917, 20840, 20352, 20805, 20864, 21191, 21242, 21917, 21845, 21913, 21986, 22618, 22707, 22852, 22868, 23138, 23336, 24274, 24281, 24425, 24493, 24792, 24910, 24840, 24974, 24928, 25074, 25140, 25540, 25628, 25682, 25942, 26228, 26391, 26395, 26454, 27513, 27578, 27969, 28379, 28363, 28450, 28702, 29038, 30631, 29237, 29359, 29482, 29809, 29958, 30011, 30237, 30239, 30410, 30427, 30452, 30538, 30528, 30924, 31409, 31680, 31867, 32091, 32244, 32574, 32773, 33618, 33775, 34681, 35137, 35206, 35222, 35519, 35576, 35531, 35585, 35582, 35565, 35641, 35722, 36104, 36664, 36978, 37273, 37494, 38524, 38627, 38742, 38875, 38911, 38923, 38971, 39698, 40860, 141386, 141380, 144341, 15261, 16408, 16441, 152137, 154832, 163539, 40771, 40846, 102, 102, 102, 105, 102, 108, 102, 102, 105, 102, 102, 108, 115, 116, 1396, 1398, 1396, 1381, 1396, 1387, 1406, 1398, 1396, 1389, 1497, 1460, 1522, 1463, 1506, 1488, 1491, 1492, 1499, 1500, 1501, 1512, 1514, 43, 1513, 1473, 1513, 1474, 1513, 1468, 1473, 1513, 1468, 1474, 1488, 1463, 1488, 1464, 1488, 1468, 1489, 1468, 1490, 1468, 1491, 1468, 1492, 1468, 1493, 1468, 1494, 1468, 1496, 1468, 1497, 1468, 1498, 1468, 1499, 1468, 1500, 1468, 1502, 1468, 1504, 1468, 1505, 1468, 1507, 1468, 1508, 1468, 1510, 1468, 1511, 1468, 1512, 1468, 1513, 1468, 1514, 1468, 1493, 1465, 1489, 1471, 1499, 1471, 1508, 1471, 1488, 1500, 1649, 1659, 1662, 1664, 1658, 1663, 1657, 1700, 1702, 1668, 1667, 1670, 1671, 1677, 1676, 1678, 1672, 1688, 1681, 1705, 1711, 1715, 1713, 1722, 1723, 1728, 1729, 1726, 1746, 1747, 1709, 1735, 1734, 1736, 1735, 1652, 1739, 1733, 1737, 1744, 1609, 1574, 1575, 1574, 1749, 1574, 1608, 1574, 1735, 1574, 1734, 1574, 1736, 1574, 1744, 1574, 1609, 1740, 1574, 1580, 1574, 1581, 1574, 1605, 1574, 1609, 1574, 1610, 1576, 1580, 1576, 1581, 1576, 1582, 1576, 1605, 1576, 1609, 1576, 1610, 1578, 1580, 1578, 1581, 1578, 1582, 1578, 1605, 1578, 1609, 1578, 1610, 1579, 1580, 1579, 1605, 1579, 1609, 1579, 1610, 1580, 1581, 1580, 1605, 1581, 1580, 1581, 1605, 1582, 1580, 1582, 1581, 1582, 1605, 1587, 1580, 1587, 1581, 1587, 1582, 1587, 1605, 1589, 1581, 1589, 1605, 1590, 1580, 1590, 1581, 1590, 1582, 1590, 1605, 1591, 1581, 1591, 1605, 1592, 1605, 1593, 1580, 1593, 1605, 1594, 1580, 1594, 1605, 1601, 1580, 1601, 1581, 1601, 1582, 1601, 1605, 1601, 1609, 1601, 1610, 1602, 1581, 1602, 1605, 1602, 1609, 1602, 1610, 1603, 1575, 1603, 1580, 1603, 1581, 1603, 1582, 1603, 1604, 1603, 1605, 1603, 1609, 1603, 1610, 1604, 1580, 1604, 1581, 1604, 1582, 1604, 1605, 1604, 1609, 1604, 1610, 1605, 1580, 1605, 1581, 1605, 1582, 1605, 1605, 1605, 1609, 1605, 1610, 1606, 1580, 1606, 1581, 1606, 1582, 1606, 1605, 1606, 1609, 1606, 1610, 1607, 1580, 1607, 1605, 1607, 1609, 1607, 1610, 1610, 1580, 1610, 1581, 1610, 1582, 1610, 1605, 1610, 1609, 1610, 1610, 1584, 1648, 1585, 1648, 1609, 1648, 32, 1612, 1617, 32, 1613, 1617, 32, 1614, 1617, 32, 1615, 1617, 32, 1616, 1617, 32, 1617, 1648, 1574, 1585, 1574, 1586, 1574, 1605, 1574, 1606, 1574, 1609, 1574, 1610, 1576, 1585, 1576, 1586, 1576, 1605, 1576, 1606, 1576, 1609, 1576, 1610, 1578, 1585, 1578, 1586, 1578, 1605, 1578, 1606, 1578, 1609, 1578, 1610, 1579, 1585, 1579, 1586, 1579, 1605, 1579, 1606, 1579, 1609, 1579, 1610, 1601, 1609, 1601, 1610, 1602, 1609, 1602, 1610, 1603, 1575, 1603, 1604, 1603, 1605, 1603, 1609, 1603, 1610, 1604, 1605, 1604, 1609, 1604, 1610, 1605, 1575, 1605, 1605, 1606, 1585, 1606, 1586, 1606, 1605, 1606, 1606, 1606, 1609, 1606, 1610, 1609, 1648, 1610, 1585, 1610, 1586, 1610, 1605, 1610, 1606, 1610, 1609, 1610, 1610, 1574, 1580, 1574, 1581, 1574, 1582, 1574, 1605, 1574, 1607, 1576, 1580, 1576, 1581, 1576, 1582, 1576, 1605, 1576, 1607, 1578, 1580, 1578, 1581, 1578, 1582, 1578, 1605, 1578, 1607, 1579, 1605, 1580, 1581, 1580, 1605, 1581, 1580, 1581, 1605, 1582, 1580, 1582, 1605, 1587, 1580, 1587, 1581, 1587, 1582, 1587, 1605, 1589, 1581, 1589, 1582, 1589, 1605, 1590, 1580, 1590, 1581, 1590, 1582, 1590, 1605, 1591, 1581, 1592, 1605, 1593, 1580, 1593, 1605, 1594, 1580, 1594, 1605, 1601, 1580, 1601, 1581, 1601, 1582, 1601, 1605, 1602, 1581, 1602, 1605, 1603, 1580, 1603, 1581, 1603, 1582, 1603, 1604, 1603, 1605, 1604, 1580, 1604, 1581, 1604, 1582, 1604, 1605, 1604, 1607, 1605, 1580, 1605, 1581, 1605, 1582, 1605, 1605, 1606, 1580, 1606, 1581, 1606, 1582, 1606, 1605, 1606, 1607, 1607, 1580, 1607, 1605, 1607, 1648, 1610, 1580, 1610, 1581, 1610, 1582, 1610, 1605, 1610, 1607, 1574, 1605, 1574, 1607, 1576, 1605, 1576, 1607, 1578, 1605, 1578, 1607, 1579, 1605, 1579, 1607, 1587, 1605, 1587, 1607, 1588, 1605, 1588, 1607, 1603, 1604, 1603, 1605, 1604, 1605, 1606, 1605, 1606, 1607, 1610, 1605, 1610, 1607, 1600, 1614, 1617, 1600, 1615, 1617, 1600, 1616, 1617, 1591, 1609, 1591, 1610, 1593, 1609, 1593, 1610, 1594, 1609, 1594, 1610, 1587, 1609, 1587, 1610, 1588, 1609, 1588, 1610, 1581, 1609, 1581, 1610, 1580, 1609, 1580, 1610, 1582, 1609, 1582, 1610, 1589, 1609, 1589, 1610, 1590, 1609, 1590, 1610, 1588, 1580, 1588, 1581, 1588, 1582, 1588, 1605, 1588, 1585, 1587, 1585, 1589, 1585, 1590, 1585, 1591, 1609, 1591, 1610, 1593, 1609, 1593, 1610, 1594, 1609, 1594, 1610, 1587, 1609, 1587, 1610, 1588, 1609, 1588, 1610, 1581, 1609, 1581, 1610, 1580, 1609, 1580, 1610, 1582, 1609, 1582, 1610, 1589, 1609, 1589, 1610, 1590, 1609, 1590, 1610, 1588, 1580, 1588, 1581, 1588, 1582, 1588, 1605, 1588, 1585, 1587, 1585, 1589, 1585, 1590, 1585, 1588, 1580, 1588, 1581, 1588, 1582, 1588, 1605, 1587, 1607, 1588, 1607, 1591, 1605, 1587, 1580, 1587, 1581, 1587, 1582, 1588, 1580, 1588, 1581, 1588, 1582, 1591, 1605, 1592, 1605, 1575, 1611, 1578, 1580, 1605, 1578, 1581, 1580, 1578, 1581, 1605, 1578, 1582, 1605, 1578, 1605, 1580, 1578, 1605, 1581, 1578, 1605, 1582, 1580, 1605, 1581, 1581, 1605, 1610, 1581, 1605, 1609, 1587, 1581, 1580, 1587, 1580, 1581, 1587, 1580, 1609, 1587, 1605, 1581, 1587, 1605, 1580, 1587, 1605, 1605, 1589, 1581, 1581, 1589, 1605, 1605, 1588, 1581, 1605, 1588, 1580, 1610, 1588, 1605, 1582, 1588, 1605, 1605, 1590, 1581, 1609, 1590, 1582, 1605, 1591, 1605, 1581, 1591, 1605, 1605, 1591, 1605, 1610, 1593, 1580, 1605, 1593, 1605, 1605, 1593, 1605, 1609, 1594, 1605, 1605, 1594, 1605, 1610, 1594, 1605, 1609, 1601, 1582, 1605, 1602, 1605, 1581, 1602, 1605, 1605, 1604, 1581, 1605, 1604, 1581, 1610, 1604, 1581, 1609, 1604, 1580, 1580, 1604, 1582, 1605, 1604, 1605, 1581, 1605, 1581, 1580, 1605, 1581, 1605, 1605, 1581, 1610, 1605, 1580, 1581, 1605, 1580, 1605, 1605, 1582, 1580, 1605, 1582, 1605, 1605, 1580, 1582, 1607, 1605, 1580, 1607, 1605, 1605, 1606, 1581, 1605, 1606, 1581, 1609, 1606, 1580, 1605, 1606, 1580, 1609, 1606, 1605, 1610, 1606, 1605, 1609, 1610, 1605, 1605, 1576, 1582, 1610, 1578, 1580, 1610, 1578, 1580, 1609, 1578, 1582, 1610, 1578, 1582, 1609, 1578, 1605, 1610, 1578, 1605, 1609, 1580, 1605, 1610, 1580, 1581, 1609, 1580, 1605, 1609, 1587, 1582, 1609, 1589, 1581, 1610, 1588, 1581, 1610, 1590, 1581, 1610, 1604, 1580, 1610, 1604, 1605, 1610, 1610, 1581, 1610, 1610, 1580, 1610, 1610, 1605, 1610, 1605, 1605, 1610, 1602, 1605, 1610, 1606, 1581, 1610, 1602, 1605, 1581, 1604, 1581, 1605, 1593, 1605, 1610, 1603, 1605, 1610, 1606, 1580, 1581, 1605, 1582, 1610, 1604, 1580, 1605, 1603, 1605, 1605, 1604, 1580, 1605, 1606, 1580, 1581, 1580, 1581, 1610, 1581, 1580, 1610, 1605, 1580, 1610, 1601, 1605, 1610, 1576, 1581, 1610, 1603, 1605, 1605, 1593, 1580, 1605, 1589, 1605, 1605, 1587, 1582, 1610, 1606, 1580, 1610, 1589, 1604, 1746, 1602, 1604, 1746, 1575, 1604, 1604, 1607, 1575, 1603, 1576, 1585, 1605, 1581, 1605, 1583, 1589, 1604, 1593, 1605, 1585, 1587, 1608, 1604, 1593, 1604, 1610, 1607, 1608, 1587, 1604, 1605, 1589, 1604, 1609, 1589, 1604, 1609, 32, 1575, 1604, 1604, 1607, 32, 1593, 1604, 1610, 1607, 32, 1608, 1587, 1604, 1605, 1580, 1604, 32, 1580, 1604, 1575, 1604, 1607, 1585, 1740, 1575, 1604, 44, 12289, 58, 59, 33, 63, 12310, 12311, 8212, 8211, 95, 40, 41, 123, 125, 12308, 12309, 12304, 12305, 12298, 12299, 12296, 12297, 12300, 12301, 12302, 12303, 91, 93, 32, 773, 95, 44, 12289, 59, 58, 63, 33, 8212, 40, 41, 123, 125, 12308, 12309, 35, 38, 42, 43, 45, 60, 62, 61, 92, 36, 37, 64, 32, 1611, 1600, 1611, 32, 1612, 32, 1613, 32, 1614, 1600, 1614, 32, 1615, 1600, 1615, 32, 1616, 1600, 1616, 32, 1617, 1600, 1617, 32, 1618, 1600, 1618, 1569, 1570, 1571, 1572, 1573, 1574, 1575, 1576, 1577, 1578, 1579, 1580, 1581, 1582, 1583, 1584, 1585, 1586, 1587, 1588, 1589, 1590, 1591, 1592, 1593, 1594, 1601, 1602, 1603, 1604, 1605, 1606, 1607, 1608, 1609, 1610, 1604, 1570, 1604, 1571, 1604, 1573, 1604, 1575, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 10629, 10630, 46, 12300, 12301, 12289, 12539, 12530, 12449, 12451, 12453, 12455, 12457, 12515, 12517, 12519, 12483, 12540, 12450, 12452, 12454, 12456, 12458, 12459, 12461, 12463, 12465, 12467, 12469, 12471, 12473, 12475, 12477, 12479, 12481, 12484, 12486, 12488, 12490, 12491, 12492, 12493, 12494, 12495, 12498, 12501, 12504, 12507, 12510, 12511, 12512, 12513, 12514, 12516, 12518, 12520, 12521, 12522, 12523, 12524, 12525, 12527, 12531, 12441, 12442, 4352, 4353, 4522, 4354, 4524, 4525, 4355, 4356, 4357, 4528, 4529, 4530, 4531, 4532, 4533, 4378, 4358, 4359, 4360, 4385, 4361, 4362, 4363, 4364, 4365, 4366, 4367, 4368, 4369, 4370, 4449, 4450, 4451, 4452, 4453, 4454, 4455, 4456, 4457, 4458, 4459, 4460, 4461, 4462, 4463, 4464, 4465, 4466, 4467, 4468, 4469, 162, 163, 172, 32, 772, 166, 165, 8361, 9474, 8592, 8593, 8594, 8595, 9632, 9675, 66600, 66601, 66602, 66603, 66604, 66605, 66606, 66607, 66608, 66609, 66610, 66611, 66612, 66613, 66614, 66615, 66616, 66617, 66618, 66619, 66620, 66621, 66622, 66623, 66624, 66625, 66626, 66627, 66628, 66629, 66630, 66631, 66632, 66633, 66634, 66635, 66636, 66637, 66638, 66639, 66776, 66777, 66778, 66779, 66780, 66781, 66782, 66783, 66784, 66785, 66786, 66787, 66788, 66789, 66790, 66791, 66792, 66793, 66794, 66795, 66796, 66797, 66798, 66799, 66800, 66801, 66802, 66803, 66804, 66805, 66806, 66807, 66808, 66809, 66810, 66811, 66967, 66968, 66969, 66970, 66971, 66972, 66973, 66974, 66975, 66976, 66977, 66979, 66980, 66981, 66982, 66983, 66984, 66985, 66986, 66987, 66988, 66989, 66990, 66991, 66992, 66993, 66995, 66996, 66997, 66998, 66999, 67000, 67001, 67003, 67004, 720, 721, 230, 665, 595, 675, 43878, 677, 676, 598, 599, 7569, 600, 606, 681, 612, 610, 608, 667, 295, 668, 615, 644, 682, 683, 620, 122628, 42894, 622, 122629, 654, 122630, 248, 630, 631, 113, 634, 122632, 637, 638, 640, 680, 678, 43879, 679, 648, 11377, 655, 673, 674, 664, 448, 449, 450, 122634, 122654, 68800, 68801, 68802, 68803, 68804, 68805, 68806, 68807, 68808, 68809, 68810, 68811, 68812, 68813, 68814, 68815, 68816, 68817, 68818, 68819, 68820, 68821, 68822, 68823, 68824, 68825, 68826, 68827, 68828, 68829, 68830, 68831, 68832, 68833, 68834, 68835, 68836, 68837, 68838, 68839, 68840, 68841, 68842, 68843, 68844, 68845, 68846, 68847, 68848, 68849, 68850, 68976, 68977, 68978, 68979, 68980, 68981, 68982, 68983, 68984, 68985, 68986, 68987, 68988, 68989, 68990, 68991, 68992, 68993, 68994, 68995, 68996, 68997, 71872, 71873, 71874, 71875, 71876, 71877, 71878, 71879, 71880, 71881, 71882, 71883, 71884, 71885, 71886, 71887, 71888, 71889, 71890, 71891, 71892, 71893, 71894, 71895, 71896, 71897, 71898, 71899, 71900, 71901, 71902, 71903, 93792, 93793, 93794, 93795, 93796, 93797, 93798, 93799, 93800, 93801, 93802, 93803, 93804, 93805, 93806, 93807, 93808, 93809, 93810, 93811, 93812, 93813, 93814, 93815, 93816, 93817, 93818, 93819, 93820, 93821, 93822, 93823, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 119127, 119141, 119128, 119141, 119128, 119141, 119150, 119128, 119141, 119151, 119128, 119141, 119152, 119128, 119141, 119153, 119128, 119141, 119154, 119225, 119141, 119226, 119141, 119225, 119141, 119150, 119226, 119141, 119150, 119225, 119141, 119151, 119226, 119141, 119151, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 97, 98, 99, 100, 101, 102, 103, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 97, 99, 100, 103, 106, 107, 110, 111, 112, 113, 115, 116, 117, 118, 119, 120, 121, 122, 97, 98, 99, 100, 102, 104, 105, 106, 107, 108, 109, 110, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 97, 98, 100, 101, 102, 103, 106, 107, 108, 109, 110, 111, 112, 113, 115, 116, 117, 118, 119, 120, 121, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 97, 98, 100, 101, 102, 103, 105, 106, 107, 108, 109, 111, 115, 116, 117, 118, 119, 120, 121, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 305, 567, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 952, 963, 964, 965, 966, 967, 968, 969, 8711, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 963, 964, 965, 966, 967, 968, 969, 8706, 949, 952, 954, 966, 961, 960, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 952, 963, 964, 965, 966, 967, 968, 969, 8711, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 963, 964, 965, 966, 967, 968, 969, 8706, 949, 952, 954, 966, 961, 960, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 952, 963, 964, 965, 966, 967, 968, 969, 8711, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 963, 964, 965, 966, 967, 968, 969, 8706, 949, 952, 954, 966, 961, 960, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 952, 963, 964, 965, 966, 967, 968, 969, 8711, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 963, 964, 965, 966, 967, 968, 969, 8706, 949, 952, 954, 966, 961, 960, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 952, 963, 964, 965, 966, 967, 968, 969, 8711, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 963, 964, 965, 966, 967, 968, 969, 8706, 949, 952, 954, 966, 961, 960, 989, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1082, 1083, 1084, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1099, 1101, 1102, 42633, 1241, 1110, 1112, 1257, 1199, 1231, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1082, 1083, 1086, 1087, 1089, 1091, 1092, 1093, 1094, 1095, 1096, 1098, 1099, 1169, 1110, 1109, 1119, 1195, 42577, 1201, 125218, 125219, 125220, 125221, 125222, 125223, 125224, 125225, 125226, 125227, 125228, 125229, 125230, 125231, 125232, 125233, 125234, 125235, 125236, 125237, 125238, 125239, 125240, 125241, 125242, 125243, 125244, 125245, 125246, 125247, 125248, 125249, 125250, 125251, 1575, 1576, 1580, 1583, 1608, 1586, 1581, 1591, 1610, 1603, 1604, 1605, 1606, 1587, 1593, 1601, 1589, 1602, 1585, 1588, 1578, 1579, 1582, 1584, 1590, 1592, 1594, 1646, 1722, 1697, 1647, 1576, 1580, 1607, 1581, 1610, 1603, 1604, 1605, 1606, 1587, 1593, 1601, 1589, 1602, 1588, 1578, 1579, 1582, 1590, 1594, 1580, 1581, 1610, 1604, 1606, 1587, 1593, 1589, 1602, 1588, 1582, 1590, 1594, 1722, 1647, 1576, 1580, 1607, 1581, 1591, 1610, 1603, 1605, 1606, 1587, 1593, 1601, 1589, 1602, 1588, 1578, 1579, 1582, 1590, 1592, 1594, 1646, 1697, 1575, 1576, 1580, 1583, 1607, 1608, 1586, 1581, 1591, 1610, 1604, 1605, 1606, 1587, 1593, 1601, 1589, 1602, 1585, 1588, 1578, 1579, 1582, 1584, 1590, 1592, 1594, 1576, 1580, 1583, 1608, 1586, 1581, 1591, 1610, 1604, 1605, 1606, 1587, 1593, 1601, 1589, 1602, 1585, 1588, 1578, 1579, 1582, 1584, 1590, 1592, 1594, 48, 44, 49, 44, 50, 44, 51, 44, 52, 44, 53, 44, 54, 44, 55, 44, 56, 44, 57, 44, 40, 97, 41, 40, 98, 41, 40, 99, 41, 40, 100, 41, 40, 101, 41, 40, 102, 41, 40, 103, 41, 40, 104, 41, 40, 105, 41, 40, 106, 41, 40, 107, 41, 40, 108, 41, 40, 109, 41, 40, 110, 41, 40, 111, 41, 40, 112, 41, 40, 113, 41, 40, 114, 41, 40, 115, 41, 40, 116, 41, 40, 117, 41, 40, 118, 41, 40, 119, 41, 40, 120, 41, 40, 121, 41, 40, 122, 41, 12308, 115, 12309, 99, 114, 99, 100, 119, 122, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 104, 118, 109, 118, 115, 100, 115, 115, 112, 112, 118, 119, 99, 109, 99, 109, 100, 109, 114, 100, 106, 12411, 12363, 12467, 12467, 12469, 25163, 23383, 21452, 12487, 20108, 22810, 35299, 22825, 20132, 26144, 28961, 26009, 21069, 24460, 20877, 26032, 21021, 32066, 29983, 36009, 22768, 21561, 28436, 25237, 25429, 19968, 19977, 36938, 24038, 20013, 21491, 25351, 36208, 25171, 31105, 31354, 21512, 28288, 26377, 26376, 30003, 21106, 21942, 37197, 12308, 26412, 12309, 12308, 19977, 12309, 12308, 20108, 12309, 12308, 23433, 12309, 12308, 28857, 12309, 12308, 25171, 12309, 12308, 30423, 12309, 12308, 21213, 12309, 12308, 25943, 12309, 24471, 21487, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 20029, 20024, 20033, 131362, 20320, 20398, 20411, 20482, 20602, 20633, 20711, 20687, 13470, 132666, 20813, 20820, 20836, 20855, 132380, 13497, 20839, 20877, 132427, 20887, 20900, 20172, 20908, 20917, 168415, 20981, 20995, 13535, 21051, 21062, 21106, 21111, 13589, 21191, 21193, 21220, 21242, 21253, 21254, 21271, 21321, 21329, 21338, 21363, 21373, 21375, 133676, 28784, 21450, 21471, 133987, 21483, 21489, 21510, 21662, 21560, 21576, 21608, 21666, 21750, 21776, 21843, 21859, 21892, 21913, 21931, 21939, 21954, 22294, 22022, 22295, 22097, 22132, 20999, 22766, 22478, 22516, 22541, 22411, 22578, 22577, 22700, 136420, 22770, 22775, 22790, 22810, 22818, 22882, 136872, 136938, 23020, 23067, 23079, 23000, 23142, 14062, 14076, 23304, 23358, 137672, 23491, 23512, 23527, 23539, 138008, 23551, 23558, 24403, 23586, 14209, 23648, 23662, 23744, 23693, 138724, 23875, 138726, 23918, 23915, 23932, 24033, 24034, 14383, 24061, 24104, 24125, 24169, 14434, 139651, 14460, 24240, 24243, 24246, 24266, 172946, 24318, 140081, 33281, 24354, 14535, 144056, 156122, 24418, 24427, 14563, 24474, 24525, 24535, 24569, 24705, 14650, 14620, 24724, 141012, 24775, 24904, 24908, 24910, 24908, 24954, 24974, 25010, 24996, 25007, 25054, 25074, 25078, 25104, 25115, 25181, 25265, 25300, 25424, 142092, 25405, 25340, 25448, 25475, 25572, 142321, 25634, 25541, 25513, 14894, 25705, 25726, 25757, 25719, 14956, 25935, 25964, 143370, 26083, 26360, 26185, 15129, 26257, 15112, 15076, 20882, 20885, 26368, 26268, 32941, 17369, 26391, 26395, 26401, 26462, 26451, 144323, 15177, 26618, 26501, 26706, 26757, 144493, 26766, 26655, 26900, 15261, 26946, 27043, 27114, 27304, 145059, 27355, 15384, 27425, 145575, 27476, 15438, 27506, 27551, 27578, 27579, 146061, 138507, 146170, 27726, 146620, 27839, 27853, 27751, 27926, 27966, 28023, 27969, 28009, 28024, 28037, 146718, 27956, 28207, 28270, 15667, 28363, 28359, 147153, 28153, 28526, 147294, 147342, 28614, 28729, 28702, 28699, 15766, 28746, 28797, 28791, 28845, 132389, 28997, 148067, 29084, 148395, 29224, 29237, 29264, 149000, 29312, 29333, 149301, 149524, 29562, 29579, 16044, 29605, 16056, 29767, 29788, 29809, 29829, 29898, 16155, 29988, 150582, 30014, 150674, 30064, 139679, 30224, 151457, 151480, 151620, 16380, 16392, 30452, 151795, 151794, 151833, 151859, 30494, 30495, 30538, 16441, 30603, 16454, 16534, 152605, 30798, 30860, 30924, 16611, 153126, 31062, 153242, 153285, 31119, 31211, 16687, 31296, 31306, 31311, 153980, 154279, 31470, 16898, 154539, 31686, 31689, 16935, 154752, 31954, 17056, 31976, 31971, 32000, 155526, 32099, 17153, 32199, 32258, 32325, 17204, 156200, 156231, 17241, 156377, 32634, 156478, 32661, 32762, 32773, 156890, 156963, 32864, 157096, 32880, 144223, 17365, 32946, 33027, 17419, 33086, 23221, 157607, 157621, 144275, 144284, 33281, 33284, 36766, 17515, 33425, 33419, 33437, 21171, 33457, 33459, 33469, 33510, 158524, 33509, 33565, 33635, 33709, 33571, 33725, 33767, 33879, 33619, 33738, 33740, 33756, 158774, 159083, 158933, 17707, 34033, 34035, 34070, 160714, 34148, 159532, 17757, 17761, 159665, 159954, 17771, 34384, 34396, 34407, 34409, 34473, 34440, 34574, 34530, 34681, 34600, 34667, 34694, 17879, 34785, 34817, 17913, 34912, 34915, 161383, 35031, 35038, 17973, 35066, 13499, 161966, 162150, 18110, 18119, 35488, 35565, 35722, 35925, 162984, 36011, 36033, 36123, 36215, 163631, 133124, 36299, 36284, 36336, 133342, 36564, 36664, 165330, 165357, 37012, 37105, 37137, 165678, 37147, 37432, 37591, 37592, 37500, 37881, 37909, 166906, 38283, 18837, 38327, 167287, 18918, 38595, 23986, 38691, 168261, 168474, 19054, 19062, 38880, 168970, 19122, 169110, 38923, 38953, 169398, 39138, 19251, 39209, 39335, 39362, 39422, 19406, 170800, 39698, 40000, 40189, 19662, 19693, 40295, 172238, 19704, 172293, 172558, 172689, 40635, 19798, 40697, 40702, 40709, 40719, 40726, 40763, 173568];
const _M0FP410tonyfettes7unicode8internal4idna22joining__range__starts = [173, 768, 1155, 1160, 1425, 1471, 1473, 1476, 1479, 1552, 1564, 1568, 1570, 1574, 1575, 1576, 1577, 1578, 1583, 1587, 1600, 1601, 1608, 1609, 1611, 1646, 1648, 1649, 1653, 1656, 1672, 1690, 1728, 1729, 1731, 1740, 1741, 1742, 1743, 1744, 1746, 1749, 1750, 1759, 1767, 1770, 1774, 1786, 1791, 1807, 1808, 1809, 1810, 1813, 1818, 1822, 1823, 1832, 1833, 1834, 1835, 1836, 1837, 1839, 1840, 1869, 1870, 1881, 1884, 1899, 1901, 1905, 1906, 1907, 1909, 1912, 1914, 1958, 1994, 2027, 2042, 2045, 2070, 2075, 2085, 2089, 2112, 2113, 2118, 2120, 2121, 2122, 2132, 2133, 2134, 2137, 2144, 2146, 2151, 2152, 2153, 2160, 2179, 2182, 2185, 2190, 2199, 2208, 2218, 2222, 2223, 2225, 2227, 2233, 2234, 2250, 2275, 2362, 2364, 2369, 2381, 2385, 2402, 2433, 2492, 2497, 2509, 2530, 2558, 2561, 2620, 2625, 2631, 2635, 2641, 2672, 2677, 2689, 2748, 2753, 2759, 2765, 2786, 2810, 2817, 2876, 2879, 2881, 2893, 2901, 2914, 2946, 3008, 3021, 3072, 3076, 3132, 3134, 3142, 3146, 3157, 3170, 3201, 3260, 3263, 3270, 3276, 3298, 3328, 3387, 3393, 3405, 3426, 3457, 3530, 3538, 3542, 3633, 3636, 3655, 3761, 3764, 3784, 3864, 3893, 3895, 3897, 3953, 3968, 3974, 3981, 3993, 4038, 4141, 4146, 4153, 4157, 4184, 4190, 4209, 4226, 4229, 4237, 4253, 4957, 5906, 5938, 5970, 6002, 6068, 6071, 6086, 6089, 6109, 6151, 6154, 6155, 6159, 6176, 6211, 6212, 6277, 6279, 6313, 6314, 6432, 6439, 6450, 6457, 6679, 6683, 6742, 6744, 6752, 6754, 6757, 6771, 6783, 6832, 6846, 6847, 6912, 6964, 6966, 6972, 6978, 7019, 7040, 7074, 7080, 7083, 7142, 7144, 7149, 7151, 7212, 7222, 7376, 7380, 7394, 7405, 7412, 7416, 7616, 8203, 8205, 8206, 8234, 8288, 8298, 8400, 8413, 8417, 8418, 8421, 11503, 11647, 11744, 12330, 12441, 42607, 42608, 42612, 42654, 42736, 43010, 43014, 43019, 43045, 43052, 43072, 43122, 43204, 43232, 43263, 43302, 43335, 43392, 43443, 43446, 43452, 43493, 43561, 43569, 43573, 43587, 43596, 43644, 43696, 43698, 43703, 43710, 43713, 43756, 43766, 44005, 44008, 44013, 64286, 65024, 65056, 65279, 65529, 66045, 66272, 66422, 68097, 68101, 68108, 68152, 68159, 68288, 68293, 68295, 68297, 68301, 68302, 68307, 68311, 68312, 68317, 68318, 68321, 68324, 68325, 68331, 68335, 68480, 68481, 68482, 68483, 68486, 68489, 68490, 68492, 68493, 68494, 68496, 68497, 68521, 68525, 68864, 68865, 68898, 68899, 68900, 68969, 69291, 69314, 69315, 69372, 69424, 69427, 69428, 69446, 69457, 69460, 69488, 69492, 69494, 69506, 69552, 69554, 69556, 69560, 69561, 69563, 69565, 69566, 69569, 69570, 69572, 69577, 69578, 69579, 69633, 69688, 69744, 69747, 69759, 69811, 69817, 69826, 69888, 69927, 69933, 70003, 70016, 70070, 70089, 70095, 70191, 70196, 70198, 70206, 70209, 70367, 70371, 70400, 70459, 70464, 70502, 70512, 70587, 70606, 70608, 70610, 70625, 70712, 70722, 70726, 70750, 70835, 70842, 70847, 70850, 71090, 71100, 71103, 71132, 71219, 71229, 71231, 71339, 71341, 71344, 71351, 71453, 71455, 71458, 71463, 71727, 71737, 71995, 71998, 72003, 72148, 72154, 72160, 72193, 72243, 72251, 72263, 72273, 72281, 72330, 72344, 72752, 72760, 72767, 72850, 72874, 72882, 72885, 73009, 73018, 73020, 73023, 73031, 73104, 73109, 73111, 73459, 73472, 73526, 73536, 73538, 73562, 78896, 78912, 78919, 90398, 90413, 92912, 92976, 94031, 94095, 94180, 113821, 113824, 118528, 118576, 119143, 119155, 119163, 119173, 119210, 119362, 121344, 121403, 121461, 121476, 121499, 121505, 122880, 122888, 122907, 122915, 122918, 123023, 123184, 123566, 123628, 124140, 124398, 125136, 125184, 125252, 125259, 917505, 917536, 917760];
const _M0FP410tonyfettes7unicode8internal4idna20joining__range__ends = [173, 879, 1159, 1161, 1469, 1471, 1474, 1477, 1479, 1562, 1564, 1568, 1573, 1574, 1575, 1576, 1577, 1582, 1586, 1599, 1600, 1607, 1608, 1610, 1631, 1647, 1648, 1651, 1655, 1671, 1689, 1727, 1728, 1730, 1739, 1740, 1741, 1742, 1743, 1745, 1747, 1749, 1756, 1764, 1768, 1773, 1775, 1788, 1791, 1807, 1808, 1809, 1812, 1817, 1821, 1822, 1831, 1832, 1833, 1834, 1835, 1836, 1838, 1839, 1866, 1869, 1880, 1883, 1898, 1900, 1904, 1905, 1906, 1908, 1911, 1913, 1919, 1968, 2026, 2035, 2042, 2045, 2073, 2083, 2087, 2093, 2112, 2117, 2119, 2120, 2121, 2131, 2132, 2133, 2136, 2139, 2144, 2149, 2151, 2152, 2154, 2178, 2181, 2182, 2189, 2190, 2207, 2217, 2220, 2222, 2224, 2226, 2232, 2233, 2248, 2273, 2306, 2362, 2364, 2376, 2381, 2391, 2403, 2433, 2492, 2500, 2509, 2531, 2558, 2562, 2620, 2626, 2632, 2637, 2641, 2673, 2677, 2690, 2748, 2757, 2760, 2765, 2787, 2815, 2817, 2876, 2879, 2884, 2893, 2902, 2915, 2946, 3008, 3021, 3072, 3076, 3132, 3136, 3144, 3149, 3158, 3171, 3201, 3260, 3263, 3270, 3277, 3299, 3329, 3388, 3396, 3405, 3427, 3457, 3530, 3540, 3542, 3633, 3642, 3662, 3761, 3772, 3790, 3865, 3893, 3895, 3897, 3966, 3972, 3975, 3991, 4028, 4038, 4144, 4151, 4154, 4158, 4185, 4192, 4212, 4226, 4230, 4237, 4253, 4959, 5908, 5939, 5971, 6003, 6069, 6077, 6086, 6099, 6109, 6151, 6154, 6157, 6159, 6210, 6211, 6264, 6278, 6312, 6313, 6314, 6434, 6440, 6450, 6459, 6680, 6683, 6742, 6750, 6752, 6754, 6764, 6780, 6783, 6845, 6846, 6862, 6915, 6964, 6970, 6972, 6978, 7027, 7041, 7077, 7081, 7085, 7142, 7145, 7149, 7153, 7219, 7223, 7378, 7392, 7400, 7405, 7412, 7417, 7679, 8203, 8205, 8207, 8238, 8292, 8303, 8412, 8416, 8417, 8420, 8432, 11505, 11647, 11775, 12333, 12442, 42607, 42610, 42621, 42655, 42737, 43010, 43014, 43019, 43046, 43052, 43121, 43122, 43205, 43249, 43263, 43309, 43345, 43394, 43443, 43449, 43453, 43493, 43566, 43570, 43574, 43587, 43596, 43644, 43696, 43700, 43704, 43711, 43713, 43757, 43766, 44005, 44008, 44013, 64286, 65039, 65071, 65279, 65531, 66045, 66272, 66426, 68099, 68102, 68111, 68154, 68159, 68292, 68293, 68295, 68298, 68301, 68306, 68310, 68311, 68316, 68317, 68320, 68321, 68324, 68326, 68334, 68335, 68480, 68481, 68482, 68485, 68488, 68489, 68491, 68492, 68493, 68495, 68496, 68497, 68524, 68526, 68864, 68897, 68898, 68899, 68903, 68973, 69292, 69314, 69316, 69375, 69426, 69427, 69444, 69456, 69459, 69460, 69491, 69493, 69505, 69509, 69552, 69555, 69558, 69560, 69562, 69564, 69565, 69567, 69569, 69571, 69572, 69577, 69578, 69579, 69633, 69702, 69744, 69748, 69761, 69814, 69818, 69826, 69890, 69931, 69940, 70003, 70017, 70078, 70092, 70095, 70193, 70196, 70199, 70206, 70209, 70367, 70378, 70401, 70460, 70464, 70508, 70516, 70592, 70606, 70608, 70610, 70626, 70719, 70724, 70726, 70750, 70840, 70842, 70848, 70851, 71093, 71101, 71104, 71133, 71226, 71229, 71232, 71339, 71341, 71349, 71351, 71453, 71455, 71461, 71467, 71735, 71738, 71996, 71998, 72003, 72151, 72155, 72160, 72202, 72248, 72254, 72263, 72278, 72283, 72342, 72345, 72758, 72765, 72767, 72871, 72880, 72883, 72886, 73014, 73018, 73021, 73029, 73031, 73105, 73109, 73111, 73460, 73473, 73530, 73536, 73538, 73562, 78911, 78912, 78933, 90409, 90415, 92916, 92982, 94031, 94098, 94180, 113822, 113827, 118573, 118598, 119145, 119162, 119170, 119179, 119213, 119364, 121398, 121452, 121461, 121476, 121503, 121519, 122886, 122904, 122913, 122916, 122922, 123023, 123190, 123566, 123631, 124143, 124399, 125142, 125251, 125258, 125259, 917505, 917631, 917999];
const _M0FP410tonyfettes7unicode8internal4idna21joining__range__types = [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 2, 1, 2, 1, 2, 1, 2, 1, 2, 3, 2, 1, 2, 4, 2, 4, 1, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 1, 4, 4, 4, 4, 1, 2, 2, 4, 1, 4, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 4, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 4, 2, 4, 3, 4, 4, 4, 4, 4, 1, 2, 1, 2, 1, 2, 1, 2, 1, 4, 2, 2, 1, 2, 1, 1, 3, 2, 2, 1, 4, 2, 1, 1, 2, 1, 2, 1, 2, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 2, 3, 4, 4, 2, 2, 2, 4, 2, 4, 2, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 2, 0, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 2, 1, 1, 1, 0, 1, 2, 0, 2, 1, 2, 1, 1, 4, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 1, 2, 0, 2, 1, 2, 4, 4, 4, 1, 2, 4, 2, 1, 2, 4, 2, 1, 2, 1, 2, 4, 2, 2, 1, 2, 1, 2, 1, 2, 2, 1, 2, 1, 2, 0, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 2, 4, 4, 4, 4, 4];
const _M0FP410tonyfettes7unicode8internal4idna19bidi__range__starts = [0, 14, 33, 35, 36, 37, 38, 40, 41, 42, 43, 44, 45, 46, 48, 58, 59, 60, 63, 65, 91, 92, 93, 94, 95, 96, 97, 123, 124, 125, 126, 127, 134, 160, 161, 162, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 180, 181, 182, 184, 185, 186, 187, 188, 191, 192, 215, 216, 247, 248, 443, 444, 448, 452, 660, 661, 688, 697, 699, 706, 710, 720, 722, 736, 741, 748, 749, 750, 751, 768, 880, 884, 885, 886, 890, 891, 894, 895, 900, 902, 903, 904, 908, 910, 931, 1014, 1015, 1154, 1155, 1160, 1162, 1329, 1369, 1370, 1376, 1417, 1418, 1421, 1423, 1425, 1470, 1471, 1472, 1473, 1475, 1476, 1478, 1479, 1488, 1519, 1523, 1536, 1542, 1544, 1545, 1547, 1548, 1549, 1550, 1552, 1563, 1564, 1565, 1568, 1600, 1601, 1611, 1632, 1642, 1643, 1645, 1646, 1648, 1649, 1748, 1749, 1750, 1757, 1758, 1759, 1765, 1767, 1769, 1770, 1774, 1776, 1786, 1789, 1791, 1792, 1807, 1808, 1809, 1810, 1840, 1869, 1958, 1969, 1984, 1994, 2027, 2036, 2038, 2039, 2042, 2045, 2046, 2048, 2070, 2074, 2075, 2084, 2085, 2088, 2089, 2096, 2112, 2137, 2142, 2144, 2160, 2184, 2185, 2192, 2199, 2208, 2249, 2250, 2274, 2275, 2307, 2308, 2362, 2363, 2364, 2365, 2366, 2369, 2377, 2381, 2382, 2384, 2385, 2392, 2402, 2404, 2406, 2416, 2417, 2418, 2433, 2434, 2437, 2447, 2451, 2474, 2482, 2486, 2492, 2493, 2494, 2497, 2503, 2507, 2509, 2510, 2519, 2524, 2527, 2530, 2534, 2544, 2546, 2548, 2554, 2555, 2556, 2557, 2558, 2561, 2563, 2565, 2575, 2579, 2602, 2610, 2613, 2616, 2620, 2622, 2625, 2631, 2635, 2641, 2649, 2654, 2662, 2672, 2674, 2677, 2678, 2689, 2691, 2693, 2703, 2707, 2730, 2738, 2741, 2748, 2749, 2750, 2753, 2759, 2761, 2763, 2765, 2768, 2784, 2786, 2790, 2800, 2801, 2809, 2810, 2817, 2818, 2821, 2831, 2835, 2858, 2866, 2869, 2876, 2877, 2878, 2879, 2880, 2881, 2887, 2891, 2893, 2901, 2903, 2908, 2911, 2914, 2918, 2928, 2929, 2930, 2946, 2947, 2949, 2958, 2962, 2969, 2972, 2974, 2979, 2984, 2990, 3006, 3008, 3009, 3014, 3018, 3021, 3024, 3031, 3046, 3056, 3059, 3065, 3066, 3072, 3073, 3076, 3077, 3086, 3090, 3114, 3132, 3133, 3134, 3137, 3142, 3146, 3157, 3160, 3165, 3168, 3170, 3174, 3191, 3192, 3199, 3200, 3201, 3202, 3204, 3205, 3214, 3218, 3242, 3253, 3260, 3261, 3262, 3263, 3264, 3270, 3271, 3274, 3276, 3285, 3293, 3296, 3298, 3302, 3313, 3315, 3328, 3330, 3332, 3342, 3346, 3387, 3389, 3390, 3393, 3398, 3402, 3405, 3406, 3407, 3412, 3415, 3416, 3423, 3426, 3430, 3440, 3449, 3450, 3457, 3458, 3461, 3482, 3507, 3517, 3520, 3530, 3535, 3538, 3542, 3544, 3558, 3570, 3572, 3585, 3633, 3634, 3636, 3647, 3648, 3654, 3655, 3663, 3664, 3674, 3713, 3716, 3718, 3724, 3749, 3751, 3761, 3762, 3764, 3773, 3776, 3782, 3784, 3792, 3804, 3840, 3841, 3844, 3859, 3860, 3861, 3864, 3866, 3872, 3882, 3892, 3893, 3894, 3895, 3896, 3897, 3898, 3899, 3900, 3901, 3902, 3904, 3913, 3953, 3967, 3968, 3973, 3974, 3976, 3981, 3993, 4030, 4038, 4039, 4046, 4048, 4053, 4057, 4096, 4139, 4141, 4145, 4146, 4152, 4153, 4155, 4157, 4159, 4160, 4170, 4176, 4182, 4184, 4186, 4190, 4193, 4194, 4197, 4199, 4206, 4209, 4213, 4226, 4227, 4229, 4231, 4237, 4238, 4239, 4240, 4250, 4253, 4254, 4256, 4295, 4301, 4304, 4347, 4348, 4349, 4352, 4682, 4688, 4696, 4698, 4704, 4746, 4752, 4786, 4792, 4800, 4802, 4808, 4824, 4882, 4888, 4957, 4960, 4969, 4992, 5008, 5024, 5112, 5120, 5121, 5741, 5742, 5743, 5761, 5787, 5788, 5792, 5867, 5870, 5873, 5888, 5906, 5909, 5919, 5938, 5940, 5941, 5952, 5970, 5984, 5998, 6002, 6016, 6068, 6070, 6071, 6078, 6086, 6087, 6089, 6100, 6103, 6104, 6107, 6108, 6109, 6112, 6128, 6144, 6150, 6151, 6155, 6158, 6159, 6160, 6176, 6211, 6212, 6272, 6277, 6279, 6313, 6314, 6320, 6400, 6432, 6435, 6439, 6441, 6448, 6450, 6451, 6457, 6464, 6468, 6470, 6480, 6512, 6528, 6576, 6608, 6618, 6622, 6656, 6679, 6681, 6683, 6686, 6688, 6741, 6742, 6743, 6744, 6752, 6753, 6754, 6755, 6757, 6765, 6771, 6783, 6784, 6800, 6816, 6823, 6824, 6832, 6846, 6847, 6912, 6916, 6917, 6964, 6965, 6966, 6971, 6972, 6973, 6978, 6979, 6981, 6990, 6992, 7002, 7009, 7019, 7028, 7037, 7040, 7042, 7043, 7073, 7074, 7078, 7080, 7082, 7083, 7086, 7088, 7098, 7142, 7143, 7144, 7146, 7149, 7150, 7151, 7154, 7164, 7168, 7204, 7212, 7220, 7222, 7227, 7232, 7245, 7248, 7258, 7288, 7294, 7296, 7312, 7357, 7360, 7376, 7379, 7380, 7393, 7394, 7401, 7405, 7406, 7412, 7413, 7415, 7416, 7418, 7424, 7468, 7531, 7544, 7545, 7579, 7616, 7680, 7960, 7968, 8008, 8016, 8025, 8027, 8029, 8031, 8064, 8118, 8125, 8126, 8127, 8130, 8134, 8141, 8144, 8150, 8157, 8160, 8173, 8178, 8182, 8189, 8203, 8206, 8207, 8208, 8214, 8216, 8217, 8218, 8219, 8221, 8222, 8223, 8224, 8239, 8240, 8245, 8249, 8250, 8251, 8255, 8257, 8260, 8261, 8262, 8263, 8274, 8275, 8276, 8277, 8288, 8293, 8298, 8304, 8305, 8308, 8314, 8316, 8317, 8318, 8319, 8320, 8330, 8332, 8333, 8334, 8336, 8352, 8400, 8413, 8417, 8418, 8421, 8448, 8450, 8451, 8455, 8456, 8458, 8468, 8469, 8470, 8472, 8473, 8478, 8484, 8485, 8486, 8487, 8488, 8489, 8490, 8494, 8495, 8501, 8505, 8506, 8508, 8512, 8517, 8522, 8523, 8524, 8526, 8527, 8528, 8544, 8579, 8581, 8585, 8586, 8592, 8597, 8602, 8604, 8608, 8609, 8611, 8612, 8614, 8615, 8622, 8623, 8654, 8656, 8658, 8659, 8660, 8661, 8692, 8722, 8723, 8724, 8960, 8968, 8969, 8970, 8971, 8972, 8992, 8994, 9001, 9002, 9003, 9014, 9083, 9084, 9085, 9109, 9110, 9115, 9140, 9180, 9186, 9280, 9312, 9352, 9372, 9450, 9472, 9655, 9656, 9665, 9666, 9720, 9728, 9839, 9840, 9900, 9901, 10088, 10089, 10090, 10091, 10092, 10093, 10094, 10095, 10096, 10097, 10098, 10099, 10100, 10101, 10102, 10132, 10176, 10181, 10182, 10183, 10214, 10215, 10216, 10217, 10218, 10219, 10220, 10221, 10222, 10223, 10224, 10240, 10496, 10627, 10628, 10629, 10630, 10631, 10632, 10633, 10634, 10635, 10636, 10637, 10638, 10639, 10640, 10641, 10642, 10643, 10644, 10645, 10646, 10647, 10648, 10649, 10712, 10713, 10714, 10715, 10716, 10748, 10749, 10750, 11008, 11056, 11077, 11079, 11085, 11126, 11159, 11264, 11388, 11390, 11493, 11499, 11503, 11506, 11513, 11517, 11518, 11520, 11559, 11565, 11568, 11631, 11632, 11647, 11648, 11680, 11688, 11696, 11704, 11712, 11720, 11728, 11736, 11744, 11776, 11778, 11779, 11780, 11781, 11782, 11785, 11786, 11787, 11788, 11789, 11790, 11799, 11800, 11802, 11803, 11804, 11805, 11806, 11808, 11809, 11810, 11811, 11812, 11813, 11814, 11815, 11816, 11817, 11818, 11823, 11824, 11834, 11836, 11840, 11841, 11842, 11843, 11856, 11858, 11861, 11862, 11863, 11864, 11865, 11866, 11867, 11868, 11869, 11904, 11931, 12032, 12272, 12289, 12292, 12293, 12294, 12295, 12296, 12297, 12298, 12299, 12300, 12301, 12302, 12303, 12304, 12305, 12306, 12308, 12309, 12310, 12311, 12312, 12313, 12314, 12315, 12316, 12317, 12318, 12320, 12321, 12330, 12334, 12336, 12337, 12342, 12344, 12347, 12348, 12349, 12350, 12353, 12441, 12443, 12445, 12447, 12448, 12449, 12539, 12540, 12543, 12549, 12593, 12688, 12690, 12694, 12704, 12736, 12783, 12784, 12800, 12829, 12832, 12842, 12872, 12880, 12881, 12896, 12924, 12927, 12928, 12938, 12977, 12992, 13004, 13008, 13175, 13179, 13278, 13280, 13311, 13312, 19904, 19968, 40981, 40982, 42128, 42192, 42232, 42238, 42240, 42508, 42509, 42512, 42528, 42538, 42560, 42606, 42607, 42608, 42611, 42612, 42622, 42623, 42624, 42652, 42654, 42656, 42726, 42736, 42738, 42752, 42775, 42784, 42786, 42864, 42865, 42888, 42889, 42891, 42895, 42896, 42960, 42963, 42965, 42994, 42997, 42999, 43000, 43002, 43003, 43010, 43011, 43014, 43015, 43019, 43020, 43043, 43045, 43047, 43048, 43052, 43056, 43062, 43064, 43065, 43072, 43124, 43136, 43138, 43188, 43204, 43214, 43216, 43232, 43250, 43256, 43259, 43260, 43261, 43263, 43264, 43274, 43302, 43310, 43312, 43335, 43346, 43359, 43360, 43392, 43395, 43396, 43443, 43444, 43446, 43450, 43452, 43454, 43457, 43471, 43472, 43486, 43488, 43493, 43494, 43495, 43504, 43514, 43520, 43561, 43567, 43569, 43571, 43573, 43584, 43587, 43588, 43596, 43597, 43600, 43612, 43616, 43632, 43633, 43639, 43642, 43643, 43644, 43645, 43646, 43696, 43697, 43698, 43701, 43703, 43705, 43710, 43712, 43713, 43714, 43739, 43741, 43742, 43744, 43755, 43756, 43758, 43760, 43762, 43763, 43765, 43766, 43777, 43785, 43793, 43808, 43816, 43824, 43867, 43868, 43872, 43881, 43882, 43888, 43968, 44003, 44005, 44006, 44008, 44009, 44011, 44012, 44013, 44016, 44032, 55216, 55243, 57344, 63744, 64112, 64256, 64275, 64285, 64286, 64287, 64297, 64298, 64312, 64318, 64320, 64323, 64326, 64336, 64434, 64467, 64830, 64831, 64832, 64848, 64914, 64975, 64976, 65008, 65020, 65021, 65024, 65040, 65047, 65048, 65049, 65056, 65072, 65073, 65075, 65077, 65078, 65079, 65080, 65081, 65082, 65083, 65084, 65085, 65086, 65087, 65088, 65089, 65090, 65091, 65092, 65093, 65095, 65096, 65097, 65101, 65104, 65105, 65106, 65108, 65109, 65110, 65112, 65113, 65114, 65115, 65116, 65117, 65118, 65119, 65120, 65122, 65123, 65124, 65128, 65129, 65130, 65131, 65136, 65142, 65279, 65281, 65283, 65284, 65285, 65286, 65288, 65289, 65290, 65291, 65292, 65293, 65294, 65296, 65306, 65307, 65308, 65311, 65313, 65339, 65340, 65341, 65342, 65343, 65344, 65345, 65371, 65372, 65373, 65374, 65375, 65376, 65377, 65378, 65379, 65380, 65382, 65392, 65393, 65438, 65440, 65474, 65482, 65490, 65498, 65504, 65506, 65507, 65508, 65509, 65512, 65513, 65517, 65520, 65529, 65532, 65534, 65536, 65549, 65576, 65596, 65599, 65616, 65664, 65792, 65793, 65794, 65799, 65847, 65856, 65909, 65913, 65930, 65932, 65933, 65936, 65952, 66000, 66045, 66176, 66208, 66272, 66273, 66304, 66336, 66349, 66369, 66370, 66378, 66384, 66422, 66432, 66463, 66464, 66504, 66512, 66513, 66560, 66640, 66720, 66736, 66776, 66816, 66864, 66927, 66928, 66940, 66956, 66964, 66967, 66979, 66995, 67003, 67008, 67072, 67392, 67424, 67456, 67463, 67506, 67584, 67592, 67594, 67639, 67644, 67647, 67671, 67672, 67680, 67703, 67705, 67712, 67751, 67808, 67828, 67835, 67840, 67862, 67871, 67872, 67903, 67968, 68028, 68030, 68032, 68050, 68096, 68097, 68101, 68108, 68112, 68117, 68121, 68152, 68159, 68160, 68176, 68192, 68221, 68223, 68224, 68253, 68288, 68296, 68297, 68325, 68331, 68336, 68352, 68409, 68416, 68440, 68448, 68472, 68480, 68505, 68521, 68608, 68736, 68800, 68858, 68864, 68900, 68912, 68928, 68938, 68942, 68943, 68944, 68969, 68974, 68975, 68976, 69006, 69216, 69248, 69291, 69293, 69296, 69314, 69372, 69376, 69405, 69415, 69424, 69446, 69457, 69461, 69488, 69506, 69510, 69552, 69573, 69600, 69632, 69633, 69634, 69635, 69688, 69703, 69714, 69734, 69744, 69745, 69747, 69749, 69759, 69762, 69763, 69808, 69811, 69815, 69817, 69819, 69821, 69822, 69826, 69837, 69840, 69872, 69888, 69891, 69927, 69932, 69933, 69942, 69952, 69956, 69957, 69959, 69968, 70003, 70004, 70006, 70016, 70018, 70019, 70067, 70070, 70079, 70081, 70085, 70089, 70093, 70094, 70095, 70096, 70106, 70107, 70108, 70109, 70113, 70144, 70163, 70188, 70191, 70194, 70196, 70197, 70198, 70200, 70206, 70207, 70209, 70272, 70280, 70282, 70287, 70303, 70313, 70320, 70367, 70368, 70371, 70384, 70400, 70402, 70405, 70415, 70419, 70442, 70450, 70453, 70459, 70461, 70462, 70464, 70465, 70471, 70475, 70480, 70487, 70493, 70498, 70502, 70512, 70528, 70539, 70542, 70544, 70583, 70584, 70587, 70594, 70597, 70599, 70604, 70606, 70607, 70608, 70609, 70610, 70611, 70612, 70615, 70625, 70656, 70709, 70712, 70720, 70722, 70725, 70726, 70727, 70731, 70736, 70746, 70749, 70750, 70751, 70784, 70832, 70835, 70841, 70842, 70843, 70847, 70849, 70850, 70852, 70854, 70855, 70864, 71040, 71087, 71090, 71096, 71100, 71102, 71103, 71105, 71128, 71132, 71168, 71216, 71219, 71227, 71229, 71230, 71231, 71233, 71236, 71248, 71264, 71296, 71339, 71340, 71341, 71342, 71344, 71350, 71351, 71352, 71353, 71360, 71376, 71424, 71453, 71454, 71455, 71456, 71458, 71462, 71463, 71472, 71482, 71484, 71487, 71488, 71680, 71724, 71727, 71736, 71737, 71739, 71840, 71904, 71914, 71935, 71945, 71948, 71957, 71960, 71984, 71991, 71995, 71997, 71998, 71999, 72000, 72001, 72002, 72003, 72004, 72016, 72096, 72106, 72145, 72148, 72154, 72156, 72160, 72161, 72162, 72163, 72164, 72192, 72193, 72199, 72201, 72203, 72243, 72249, 72250, 72251, 72255, 72263, 72272, 72273, 72279, 72281, 72284, 72330, 72343, 72344, 72346, 72349, 72350, 72368, 72448, 72640, 72673, 72688, 72704, 72714, 72751, 72752, 72760, 72766, 72767, 72768, 72769, 72784, 72794, 72816, 72818, 72850, 72873, 72874, 72881, 72882, 72884, 72885, 72960, 72968, 72971, 73009, 73018, 73020, 73023, 73030, 73031, 73040, 73056, 73063, 73066, 73098, 73104, 73107, 73109, 73110, 73111, 73112, 73120, 73440, 73459, 73461, 73463, 73472, 73474, 73475, 73476, 73490, 73524, 73526, 73534, 73536, 73537, 73538, 73539, 73552, 73562, 73648, 73664, 73685, 73693, 73697, 73727, 73728, 74752, 74864, 74880, 77712, 77809, 77824, 78896, 78912, 78913, 78919, 78944, 82944, 90368, 90398, 90410, 90413, 90416, 92160, 92736, 92768, 92782, 92784, 92864, 92880, 92912, 92917, 92928, 92976, 92983, 92988, 92992, 92996, 92997, 93008, 93019, 93027, 93053, 93504, 93507, 93547, 93549, 93552, 93760, 93824, 93847, 93952, 94031, 94032, 94033, 94095, 94099, 94176, 94178, 94179, 94180, 94192, 94208, 100352, 101631, 110576, 110581, 110589, 110592, 110898, 110928, 110933, 110948, 110960, 113664, 113776, 113792, 113808, 113820, 113821, 113823, 113824, 117760, 117974, 118000, 118016, 118528, 118576, 118608, 118784, 119040, 119081, 119141, 119143, 119146, 119149, 119155, 119163, 119171, 119173, 119180, 119210, 119214, 119273, 119296, 119362, 119365, 119488, 119520, 119552, 119648, 119808, 119894, 119966, 119970, 119973, 119977, 119982, 119995, 119997, 120005, 120071, 120077, 120086, 120094, 120123, 120128, 120134, 120138, 120146, 120488, 120513, 120514, 120539, 120540, 120571, 120572, 120597, 120598, 120629, 120630, 120655, 120656, 120687, 120688, 120713, 120714, 120745, 120746, 120771, 120772, 120782, 120832, 121344, 121399, 121403, 121453, 121461, 121462, 121476, 121477, 121479, 121499, 121505, 122624, 122634, 122635, 122661, 122880, 122888, 122907, 122915, 122918, 122928, 123023, 123136, 123184, 123191, 123200, 123214, 123215, 123536, 123566, 123584, 123628, 123632, 123647, 124112, 124139, 124140, 124144, 124368, 124398, 124400, 124401, 124415, 124896, 124904, 124909, 124912, 124928, 125127, 125136, 125184, 125252, 125259, 125264, 125278, 126065, 126124, 126125, 126128, 126129, 126209, 126254, 126255, 126464, 126469, 126497, 126500, 126503, 126505, 126516, 126521, 126523, 126530, 126535, 126537, 126539, 126541, 126545, 126548, 126551, 126553, 126555, 126557, 126559, 126561, 126564, 126567, 126572, 126580, 126585, 126590, 126592, 126603, 126625, 126629, 126635, 126704, 126976, 127024, 127136, 127153, 127169, 127185, 127232, 127243, 127245, 127248, 127279, 127280, 127338, 127344, 127405, 127462, 127504, 127552, 127568, 127584, 127744, 127995, 128000, 128732, 128752, 128768, 128891, 128992, 129008, 129024, 129040, 129104, 129120, 129168, 129200, 129216, 129280, 129632, 129648, 129664, 129679, 129742, 129759, 129776, 129792, 129940, 130032, 131070, 131072, 173824, 177984, 178208, 183984, 191472, 194560, 196606, 196608, 201552, 262142, 327678, 393214, 458750, 524286, 589822, 655358, 720894, 786430, 851966, 917502, 917505, 917506, 917536, 917632, 917760, 918000, 983038, 983040, 1048574, 1048576, 1114110];
const _M0FP410tonyfettes7unicode8internal4idna17bidi__range__ends = [8, 27, 34, 35, 36, 37, 39, 40, 41, 42, 43, 44, 45, 47, 57, 58, 59, 62, 64, 90, 91, 92, 93, 94, 95, 96, 122, 123, 124, 125, 126, 132, 159, 160, 161, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 179, 180, 181, 183, 184, 185, 186, 187, 190, 191, 214, 215, 246, 247, 442, 443, 447, 451, 659, 660, 687, 696, 698, 705, 709, 719, 721, 735, 740, 747, 748, 749, 750, 767, 879, 883, 884, 885, 887, 890, 893, 894, 895, 901, 902, 903, 906, 908, 929, 1013, 1014, 1153, 1154, 1159, 1161, 1327, 1366, 1369, 1375, 1416, 1417, 1418, 1422, 1423, 1469, 1470, 1471, 1472, 1474, 1475, 1477, 1478, 1479, 1514, 1522, 1524, 1541, 1543, 1544, 1546, 1547, 1548, 1549, 1551, 1562, 1563, 1564, 1567, 1599, 1600, 1610, 1631, 1641, 1642, 1644, 1645, 1647, 1648, 1747, 1748, 1749, 1756, 1757, 1758, 1764, 1766, 1768, 1769, 1773, 1775, 1785, 1788, 1790, 1791, 1805, 1807, 1808, 1809, 1839, 1866, 1957, 1968, 1969, 1993, 2026, 2035, 2037, 2038, 2041, 2042, 2045, 2047, 2069, 2073, 2074, 2083, 2084, 2087, 2088, 2093, 2110, 2136, 2139, 2142, 2154, 2183, 2184, 2190, 2193, 2207, 2248, 2249, 2273, 2274, 2306, 2307, 2361, 2362, 2363, 2364, 2365, 2368, 2376, 2380, 2381, 2383, 2384, 2391, 2401, 2403, 2405, 2415, 2416, 2417, 2432, 2433, 2435, 2444, 2448, 2472, 2480, 2482, 2489, 2492, 2493, 2496, 2500, 2504, 2508, 2509, 2510, 2519, 2525, 2529, 2531, 2543, 2545, 2547, 2553, 2554, 2555, 2556, 2557, 2558, 2562, 2563, 2570, 2576, 2600, 2608, 2611, 2614, 2617, 2620, 2624, 2626, 2632, 2637, 2641, 2652, 2654, 2671, 2673, 2676, 2677, 2678, 2690, 2691, 2701, 2705, 2728, 2736, 2739, 2745, 2748, 2749, 2752, 2757, 2760, 2761, 2764, 2765, 2768, 2785, 2787, 2799, 2800, 2801, 2809, 2815, 2817, 2819, 2828, 2832, 2856, 2864, 2867, 2873, 2876, 2877, 2878, 2879, 2880, 2884, 2888, 2892, 2893, 2902, 2903, 2909, 2913, 2915, 2927, 2928, 2929, 2935, 2946, 2947, 2954, 2960, 2965, 2970, 2972, 2975, 2980, 2986, 3001, 3007, 3008, 3010, 3016, 3020, 3021, 3024, 3031, 3055, 3058, 3064, 3065, 3066, 3072, 3075, 3076, 3084, 3088, 3112, 3129, 3132, 3133, 3136, 3140, 3144, 3149, 3158, 3162, 3165, 3169, 3171, 3183, 3191, 3198, 3199, 3200, 3201, 3203, 3204, 3212, 3216, 3240, 3251, 3257, 3260, 3261, 3262, 3263, 3268, 3270, 3272, 3275, 3277, 3286, 3294, 3297, 3299, 3311, 3314, 3315, 3329, 3331, 3340, 3344, 3386, 3388, 3389, 3392, 3396, 3400, 3404, 3405, 3406, 3407, 3414, 3415, 3422, 3425, 3427, 3439, 3448, 3449, 3455, 3457, 3459, 3478, 3505, 3515, 3517, 3526, 3530, 3537, 3540, 3542, 3551, 3567, 3571, 3572, 3632, 3633, 3635, 3642, 3647, 3653, 3654, 3662, 3663, 3673, 3675, 3714, 3716, 3722, 3747, 3749, 3760, 3761, 3763, 3772, 3773, 3780, 3782, 3790, 3801, 3807, 3840, 3843, 3858, 3859, 3860, 3863, 3865, 3871, 3881, 3891, 3892, 3893, 3894, 3895, 3896, 3897, 3898, 3899, 3900, 3901, 3903, 3911, 3948, 3966, 3967, 3972, 3973, 3975, 3980, 3991, 4028, 4037, 4038, 4044, 4047, 4052, 4056, 4058, 4138, 4140, 4144, 4145, 4151, 4152, 4154, 4156, 4158, 4159, 4169, 4175, 4181, 4183, 4185, 4189, 4192, 4193, 4196, 4198, 4205, 4208, 4212, 4225, 4226, 4228, 4230, 4236, 4237, 4238, 4239, 4249, 4252, 4253, 4255, 4293, 4295, 4301, 4346, 4347, 4348, 4351, 4680, 4685, 4694, 4696, 4701, 4744, 4749, 4784, 4789, 4798, 4800, 4805, 4822, 4880, 4885, 4954, 4959, 4968, 4988, 5007, 5017, 5109, 5117, 5120, 5740, 5741, 5742, 5759, 5786, 5787, 5788, 5866, 5869, 5872, 5880, 5905, 5908, 5909, 5937, 5939, 5940, 5942, 5969, 5971, 5996, 6000, 6003, 6067, 6069, 6070, 6077, 6085, 6086, 6088, 6099, 6102, 6103, 6106, 6107, 6108, 6109, 6121, 6137, 6149, 6150, 6154, 6157, 6158, 6159, 6169, 6210, 6211, 6264, 6276, 6278, 6312, 6313, 6314, 6389, 6430, 6434, 6438, 6440, 6443, 6449, 6450, 6456, 6459, 6464, 6469, 6479, 6509, 6516, 6571, 6601, 6617, 6618, 6655, 6678, 6680, 6682, 6683, 6687, 6740, 6741, 6742, 6743, 6750, 6752, 6753, 6754, 6756, 6764, 6770, 6780, 6783, 6793, 6809, 6822, 6823, 6829, 6845, 6846, 6862, 6915, 6916, 6963, 6964, 6965, 6970, 6971, 6972, 6977, 6978, 6980, 6988, 6991, 7001, 7008, 7018, 7027, 7036, 7039, 7041, 7042, 7072, 7073, 7077, 7079, 7081, 7082, 7085, 7087, 7097, 7141, 7142, 7143, 7145, 7148, 7149, 7150, 7153, 7155, 7167, 7203, 7211, 7219, 7221, 7223, 7231, 7241, 7247, 7257, 7287, 7293, 7295, 7306, 7354, 7359, 7367, 7378, 7379, 7392, 7393, 7400, 7404, 7405, 7411, 7412, 7414, 7415, 7417, 7418, 7467, 7530, 7543, 7544, 7578, 7615, 7679, 7957, 7965, 8005, 8013, 8023, 8025, 8027, 8029, 8061, 8116, 8124, 8125, 8126, 8129, 8132, 8140, 8143, 8147, 8155, 8159, 8172, 8175, 8180, 8188, 8190, 8205, 8206, 8207, 8213, 8215, 8216, 8217, 8218, 8220, 8221, 8222, 8223, 8231, 8239, 8244, 8248, 8249, 8250, 8254, 8256, 8259, 8260, 8261, 8262, 8273, 8274, 8275, 8276, 8286, 8292, 8293, 8303, 8304, 8305, 8313, 8315, 8316, 8317, 8318, 8319, 8329, 8331, 8332, 8333, 8334, 8348, 8384, 8412, 8416, 8417, 8420, 8432, 8449, 8450, 8454, 8455, 8457, 8467, 8468, 8469, 8471, 8472, 8477, 8483, 8484, 8485, 8486, 8487, 8488, 8489, 8493, 8494, 8500, 8504, 8505, 8507, 8511, 8516, 8521, 8522, 8523, 8525, 8526, 8527, 8543, 8578, 8580, 8584, 8585, 8587, 8596, 8601, 8603, 8607, 8608, 8610, 8611, 8613, 8614, 8621, 8622, 8653, 8655, 8657, 8658, 8659, 8660, 8691, 8721, 8722, 8723, 8959, 8967, 8968, 8969, 8970, 8971, 8991, 8993, 9000, 9001, 9002, 9013, 9082, 9083, 9084, 9108, 9109, 9114, 9139, 9179, 9185, 9257, 9290, 9351, 9371, 9449, 9471, 9654, 9655, 9664, 9665, 9719, 9727, 9838, 9839, 9899, 9900, 10087, 10088, 10089, 10090, 10091, 10092, 10093, 10094, 10095, 10096, 10097, 10098, 10099, 10100, 10101, 10131, 10175, 10180, 10181, 10182, 10213, 10214, 10215, 10216, 10217, 10218, 10219, 10220, 10221, 10222, 10223, 10239, 10495, 10626, 10627, 10628, 10629, 10630, 10631, 10632, 10633, 10634, 10635, 10636, 10637, 10638, 10639, 10640, 10641, 10642, 10643, 10644, 10645, 10646, 10647, 10648, 10711, 10712, 10713, 10714, 10715, 10747, 10748, 10749, 11007, 11055, 11076, 11078, 11084, 11123, 11157, 11263, 11387, 11389, 11492, 11498, 11502, 11505, 11507, 11516, 11517, 11519, 11557, 11559, 11565, 11623, 11631, 11632, 11647, 11670, 11686, 11694, 11702, 11710, 11718, 11726, 11734, 11742, 11775, 11777, 11778, 11779, 11780, 11781, 11784, 11785, 11786, 11787, 11788, 11789, 11798, 11799, 11801, 11802, 11803, 11804, 11805, 11807, 11808, 11809, 11810, 11811, 11812, 11813, 11814, 11815, 11816, 11817, 11822, 11823, 11833, 11835, 11839, 11840, 11841, 11842, 11855, 11857, 11860, 11861, 11862, 11863, 11864, 11865, 11866, 11867, 11868, 11869, 11929, 12019, 12245, 12287, 12291, 12292, 12293, 12294, 12295, 12296, 12297, 12298, 12299, 12300, 12301, 12302, 12303, 12304, 12305, 12307, 12308, 12309, 12310, 12311, 12312, 12313, 12314, 12315, 12316, 12317, 12319, 12320, 12329, 12333, 12335, 12336, 12341, 12343, 12346, 12347, 12348, 12349, 12351, 12438, 12442, 12444, 12446, 12447, 12448, 12538, 12539, 12542, 12543, 12591, 12686, 12689, 12693, 12703, 12735, 12773, 12783, 12799, 12828, 12830, 12841, 12871, 12879, 12880, 12895, 12923, 12926, 12927, 12937, 12976, 12991, 13003, 13007, 13174, 13178, 13277, 13279, 13310, 13311, 19903, 19967, 40980, 40981, 42124, 42182, 42231, 42237, 42239, 42507, 42508, 42511, 42527, 42537, 42539, 42605, 42606, 42607, 42610, 42611, 42621, 42622, 42623, 42651, 42653, 42655, 42725, 42735, 42737, 42743, 42774, 42783, 42785, 42863, 42864, 42887, 42888, 42890, 42894, 42895, 42957, 42961, 42963, 42972, 42996, 42998, 42999, 43001, 43002, 43009, 43010, 43013, 43014, 43018, 43019, 43042, 43044, 43046, 43047, 43051, 43052, 43061, 43063, 43064, 43065, 43123, 43127, 43137, 43187, 43203, 43205, 43215, 43225, 43249, 43255, 43258, 43259, 43260, 43262, 43263, 43273, 43301, 43309, 43311, 43334, 43345, 43347, 43359, 43388, 43394, 43395, 43442, 43443, 43445, 43449, 43451, 43453, 43456, 43469, 43471, 43481, 43487, 43492, 43493, 43494, 43503, 43513, 43518, 43560, 43566, 43568, 43570, 43572, 43574, 43586, 43587, 43595, 43596, 43597, 43609, 43615, 43631, 43632, 43638, 43641, 43642, 43643, 43644, 43645, 43695, 43696, 43697, 43700, 43702, 43704, 43709, 43711, 43712, 43713, 43714, 43740, 43741, 43743, 43754, 43755, 43757, 43759, 43761, 43762, 43764, 43765, 43766, 43782, 43790, 43798, 43814, 43822, 43866, 43867, 43871, 43880, 43881, 43883, 43967, 44002, 44004, 44005, 44007, 44008, 44010, 44011, 44012, 44013, 44025, 55203, 55238, 55291, 63743, 64109, 64217, 64262, 64279, 64285, 64286, 64296, 64297, 64310, 64316, 64318, 64321, 64324, 64335, 64433, 64450, 64829, 64830, 64831, 64847, 64911, 64967, 64975, 65007, 65019, 65020, 65023, 65039, 65046, 65047, 65048, 65049, 65071, 65072, 65074, 65076, 65077, 65078, 65079, 65080, 65081, 65082, 65083, 65084, 65085, 65086, 65087, 65088, 65089, 65090, 65091, 65092, 65094, 65095, 65096, 65100, 65103, 65104, 65105, 65106, 65108, 65109, 65111, 65112, 65113, 65114, 65115, 65116, 65117, 65118, 65119, 65121, 65122, 65123, 65126, 65128, 65129, 65130, 65131, 65140, 65276, 65279, 65282, 65283, 65284, 65285, 65287, 65288, 65289, 65290, 65291, 65292, 65293, 65295, 65305, 65306, 65307, 65310, 65312, 65338, 65339, 65340, 65341, 65342, 65343, 65344, 65370, 65371, 65372, 65373, 65374, 65375, 65376, 65377, 65378, 65379, 65381, 65391, 65392, 65437, 65439, 65470, 65479, 65487, 65495, 65500, 65505, 65506, 65507, 65508, 65510, 65512, 65516, 65518, 65528, 65531, 65533, 65535, 65547, 65574, 65594, 65597, 65613, 65629, 65786, 65792, 65793, 65794, 65843, 65855, 65908, 65912, 65929, 65931, 65932, 65934, 65948, 65952, 66044, 66045, 66204, 66256, 66272, 66299, 66335, 66339, 66368, 66369, 66377, 66378, 66421, 66426, 66461, 66463, 66499, 66511, 66512, 66517, 66639, 66717, 66729, 66771, 66811, 66855, 66915, 66927, 66938, 66954, 66962, 66965, 66977, 66993, 67001, 67004, 67059, 67382, 67413, 67431, 67461, 67504, 67514, 67589, 67592, 67637, 67640, 67644, 67669, 67671, 67679, 67702, 67704, 67711, 67742, 67759, 67826, 67829, 67839, 67861, 67867, 67871, 67897, 67903, 68023, 68029, 68031, 68047, 68095, 68096, 68099, 68102, 68111, 68115, 68119, 68149, 68154, 68159, 68168, 68184, 68220, 68222, 68223, 68252, 68255, 68295, 68296, 68324, 68326, 68335, 68342, 68405, 68415, 68437, 68447, 68466, 68479, 68497, 68508, 68527, 68680, 68786, 68850, 68863, 68899, 68903, 68921, 68937, 68941, 68942, 68943, 68965, 68973, 68974, 68975, 68997, 69007, 69246, 69289, 69292, 69293, 69297, 69316, 69375, 69404, 69414, 69415, 69445, 69456, 69460, 69465, 69505, 69509, 69513, 69572, 69579, 69622, 69632, 69633, 69634, 69687, 69702, 69709, 69733, 69743, 69744, 69746, 69748, 69749, 69761, 69762, 69807, 69810, 69814, 69816, 69818, 69820, 69821, 69825, 69826, 69837, 69864, 69881, 69890, 69926, 69931, 69932, 69940, 69951, 69955, 69956, 69958, 69959, 70002, 70003, 70005, 70006, 70017, 70018, 70066, 70069, 70078, 70080, 70084, 70088, 70092, 70093, 70094, 70095, 70105, 70106, 70107, 70108, 70111, 70132, 70161, 70187, 70190, 70193, 70195, 70196, 70197, 70199, 70205, 70206, 70208, 70209, 70278, 70280, 70285, 70301, 70312, 70313, 70366, 70367, 70370, 70378, 70393, 70401, 70403, 70412, 70416, 70440, 70448, 70451, 70457, 70460, 70461, 70463, 70464, 70468, 70472, 70477, 70480, 70487, 70497, 70499, 70508, 70516, 70537, 70539, 70542, 70581, 70583, 70586, 70592, 70594, 70597, 70602, 70605, 70606, 70607, 70608, 70609, 70610, 70611, 70613, 70616, 70626, 70708, 70711, 70719, 70721, 70724, 70725, 70726, 70730, 70735, 70745, 70747, 70749, 70750, 70753, 70831, 70834, 70840, 70841, 70842, 70846, 70848, 70849, 70851, 70853, 70854, 70855, 70873, 71086, 71089, 71093, 71099, 71101, 71102, 71104, 71127, 71131, 71133, 71215, 71218, 71226, 71228, 71229, 71230, 71232, 71235, 71236, 71257, 71276, 71338, 71339, 71340, 71341, 71343, 71349, 71350, 71351, 71352, 71353, 71369, 71395, 71450, 71453, 71454, 71455, 71457, 71461, 71462, 71467, 71481, 71483, 71486, 71487, 71494, 71723, 71726, 71735, 71736, 71738, 71739, 71903, 71913, 71922, 71942, 71945, 71955, 71958, 71983, 71989, 71992, 71996, 71997, 71998, 71999, 72000, 72001, 72002, 72003, 72006, 72025, 72103, 72144, 72147, 72151, 72155, 72159, 72160, 72161, 72162, 72163, 72164, 72192, 72198, 72200, 72202, 72242, 72248, 72249, 72250, 72254, 72262, 72263, 72272, 72278, 72280, 72283, 72329, 72342, 72343, 72345, 72348, 72349, 72354, 72440, 72457, 72672, 72673, 72697, 72712, 72750, 72751, 72758, 72765, 72766, 72767, 72768, 72773, 72793, 72812, 72817, 72847, 72871, 72873, 72880, 72881, 72883, 72884, 72886, 72966, 72969, 73008, 73014, 73018, 73021, 73029, 73030, 73031, 73049, 73061, 73064, 73097, 73102, 73105, 73108, 73109, 73110, 73111, 73112, 73129, 73458, 73460, 73462, 73464, 73473, 73474, 73475, 73488, 73523, 73525, 73530, 73535, 73536, 73537, 73538, 73551, 73561, 73562, 73648, 73684, 73692, 73696, 73713, 73727, 74649, 74862, 74868, 75075, 77808, 77810, 78895, 78911, 78912, 78918, 78933, 82938, 83526, 90397, 90409, 90412, 90415, 90425, 92728, 92766, 92777, 92783, 92862, 92873, 92909, 92916, 92917, 92975, 92982, 92987, 92991, 92995, 92996, 92997, 93017, 93025, 93047, 93071, 93506, 93546, 93548, 93551, 93561, 93823, 93846, 93850, 94026, 94031, 94032, 94087, 94098, 94111, 94177, 94178, 94179, 94180, 94193, 100343, 101589, 101640, 110579, 110587, 110590, 110882, 110898, 110930, 110933, 110951, 111355, 113770, 113788, 113800, 113817, 113820, 113822, 113823, 113827, 117973, 117999, 118009, 118451, 118573, 118598, 118723, 119029, 119078, 119140, 119142, 119145, 119148, 119154, 119162, 119170, 119172, 119179, 119209, 119213, 119272, 119274, 119361, 119364, 119365, 119507, 119539, 119638, 119672, 119892, 119964, 119967, 119970, 119974, 119980, 119993, 119995, 120003, 120069, 120074, 120084, 120092, 120121, 120126, 120132, 120134, 120144, 120485, 120512, 120513, 120538, 120539, 120570, 120571, 120596, 120597, 120628, 120629, 120654, 120655, 120686, 120687, 120712, 120713, 120744, 120745, 120770, 120771, 120779, 120831, 121343, 121398, 121402, 121452, 121460, 121461, 121475, 121476, 121478, 121483, 121503, 121519, 122633, 122634, 122654, 122666, 122886, 122904, 122913, 122916, 122922, 122989, 123023, 123180, 123190, 123197, 123209, 123214, 123215, 123565, 123566, 123627, 123631, 123641, 123647, 124138, 124139, 124143, 124153, 124397, 124399, 124400, 124410, 124415, 124902, 124907, 124910, 124926, 125124, 125135, 125142, 125251, 125258, 125259, 125273, 125279, 126123, 126124, 126127, 126128, 126132, 126253, 126254, 126269, 126467, 126495, 126498, 126500, 126503, 126514, 126519, 126521, 126523, 126530, 126535, 126537, 126539, 126543, 126546, 126548, 126551, 126553, 126555, 126557, 126559, 126562, 126564, 126570, 126578, 126583, 126588, 126590, 126601, 126619, 126627, 126633, 126651, 126705, 127019, 127123, 127150, 127167, 127183, 127221, 127242, 127244, 127247, 127278, 127279, 127337, 127343, 127404, 127405, 127490, 127547, 127560, 127569, 127589, 127994, 127999, 128727, 128748, 128764, 128886, 128985, 129003, 129008, 129035, 129095, 129113, 129159, 129197, 129211, 129217, 129619, 129645, 129660, 129673, 129734, 129756, 129769, 129784, 129938, 130031, 130041, 131071, 173791, 177977, 178205, 183969, 191456, 192093, 195101, 196607, 201546, 205743, 262143, 327679, 393215, 458751, 524287, 589823, 655359, 720895, 786431, 851967, 917504, 917505, 917535, 917631, 917759, 917999, 921599, 983039, 1048573, 1048575, 1114109, 1114111];
const _M0FP410tonyfettes7unicode8internal4idna20bidi__range__classes = [9, 9, 8, 7, 7, 7, 8, 8, 8, 8, 5, 6, 5, 6, 4, 6, 8, 8, 8, 0, 8, 8, 8, 8, 8, 8, 0, 8, 8, 8, 8, 9, 9, 6, 8, 7, 8, 8, 8, 8, 0, 8, 8, 9, 8, 8, 7, 7, 4, 8, 0, 8, 8, 4, 0, 8, 8, 8, 0, 8, 0, 8, 0, 0, 0, 0, 0, 0, 0, 0, 8, 0, 8, 8, 0, 8, 0, 8, 8, 8, 0, 8, 10, 0, 8, 8, 0, 0, 0, 8, 0, 8, 0, 8, 0, 0, 0, 0, 8, 0, 0, 10, 10, 0, 0, 0, 0, 0, 0, 8, 8, 7, 10, 1, 10, 1, 10, 1, 10, 1, 10, 1, 1, 1, 3, 8, 2, 7, 2, 6, 2, 8, 10, 2, 2, 2, 2, 2, 2, 10, 3, 7, 3, 2, 2, 10, 2, 2, 2, 10, 3, 8, 10, 2, 10, 8, 10, 2, 4, 2, 2, 2, 2, 2, 2, 10, 2, 10, 2, 10, 2, 1, 1, 10, 1, 8, 8, 1, 10, 1, 1, 10, 1, 10, 1, 10, 1, 10, 1, 1, 10, 1, 2, 2, 2, 2, 3, 10, 2, 2, 10, 3, 10, 0, 0, 10, 0, 10, 0, 0, 10, 0, 10, 0, 0, 10, 0, 10, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 10, 0, 0, 10, 0, 0, 0, 0, 10, 0, 0, 7, 0, 0, 7, 0, 0, 10, 10, 0, 0, 0, 0, 0, 0, 0, 0, 10, 0, 10, 10, 10, 10, 0, 0, 0, 10, 0, 10, 0, 10, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 10, 10, 0, 0, 10, 0, 0, 10, 0, 0, 7, 0, 10, 10, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 10, 0, 10, 0, 0, 10, 10, 0, 0, 0, 10, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 10, 0, 0, 0, 0, 8, 7, 8, 10, 0, 10, 0, 0, 0, 0, 10, 0, 10, 0, 10, 10, 10, 0, 0, 0, 10, 0, 0, 8, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 10, 0, 0, 0, 10, 0, 0, 0, 0, 10, 0, 0, 10, 0, 0, 10, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 10, 0, 10, 10, 0, 0, 0, 0, 0, 10, 0, 10, 7, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 0, 10, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 10, 0, 10, 0, 10, 8, 8, 8, 8, 0, 0, 0, 10, 0, 10, 0, 10, 0, 10, 10, 0, 10, 0, 0, 0, 0, 0, 0, 0, 10, 0, 10, 0, 10, 0, 10, 0, 0, 0, 0, 0, 10, 0, 10, 0, 0, 0, 0, 0, 10, 0, 10, 0, 10, 0, 10, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 8, 0, 0, 8, 0, 0, 0, 0, 0, 8, 8, 0, 0, 0, 0, 0, 10, 0, 0, 10, 0, 0, 0, 10, 0, 0, 10, 0, 10, 0, 10, 0, 10, 0, 10, 0, 0, 0, 7, 0, 10, 0, 8, 8, 8, 8, 10, 9, 10, 0, 0, 0, 0, 0, 10, 0, 10, 0, 0, 0, 10, 0, 10, 0, 0, 10, 0, 10, 8, 8, 0, 0, 0, 0, 0, 0, 0, 8, 0, 10, 0, 10, 0, 0, 0, 10, 0, 10, 10, 0, 10, 0, 10, 0, 10, 10, 0, 0, 0, 0, 0, 10, 10, 10, 10, 0, 0, 10, 0, 10, 0, 10, 0, 10, 0, 0, 0, 0, 0, 0, 10, 0, 0, 10, 0, 0, 0, 10, 0, 10, 0, 10, 0, 0, 0, 10, 0, 10, 0, 10, 0, 10, 0, 0, 0, 0, 10, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 0, 10, 0, 10, 0, 10, 0, 10, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8, 0, 8, 0, 0, 8, 0, 0, 8, 0, 8, 0, 0, 8, 9, 0, 1, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 6, 7, 8, 8, 8, 8, 8, 8, 6, 8, 8, 8, 8, 8, 8, 8, 9, 9, 9, 4, 0, 4, 5, 8, 8, 8, 0, 4, 5, 8, 8, 8, 0, 7, 10, 10, 10, 10, 10, 8, 0, 8, 0, 8, 0, 8, 0, 8, 8, 0, 8, 0, 8, 0, 8, 0, 8, 0, 7, 0, 0, 0, 8, 0, 8, 0, 8, 8, 8, 0, 0, 8, 0, 0, 0, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 5, 7, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8, 8, 8, 8, 8, 4, 0, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 0, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 0, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 0, 0, 0, 8, 0, 10, 0, 8, 8, 8, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 0, 0, 0, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 0, 10, 0, 8, 0, 8, 0, 0, 0, 8, 8, 0, 10, 8, 0, 0, 8, 0, 8, 0, 0, 0, 0, 0, 0, 0, 0, 8, 8, 0, 0, 8, 0, 0, 0, 8, 8, 0, 8, 0, 0, 0, 8, 0, 8, 0, 8, 0, 8, 0, 8, 0, 8, 0, 0, 0, 8, 0, 0, 0, 0, 0, 8, 0, 0, 0, 0, 0, 10, 10, 8, 10, 8, 8, 0, 0, 10, 0, 0, 10, 0, 8, 8, 8, 0, 0, 0, 8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 0, 10, 0, 10, 0, 0, 10, 0, 8, 10, 0, 0, 7, 7, 0, 8, 0, 0, 0, 10, 0, 0, 10, 0, 0, 0, 0, 0, 10, 0, 0, 10, 0, 0, 10, 0, 0, 0, 10, 0, 0, 10, 0, 10, 0, 10, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 10, 0, 10, 0, 10, 0, 10, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 10, 0, 10, 0, 10, 0, 10, 0, 10, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8, 0, 0, 0, 10, 0, 10, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 10, 1, 5, 1, 1, 1, 1, 1, 1, 2, 2, 2, 8, 8, 8, 2, 2, 8, 9, 2, 2, 8, 10, 8, 8, 8, 8, 10, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 6, 8, 6, 8, 6, 8, 8, 8, 8, 8, 8, 8, 8, 7, 8, 5, 5, 8, 8, 7, 7, 8, 2, 2, 9, 8, 7, 7, 7, 8, 8, 8, 8, 5, 6, 5, 6, 4, 6, 8, 8, 8, 0, 8, 8, 8, 8, 8, 8, 0, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 7, 8, 8, 8, 7, 8, 8, 8, 9, 8, 8, 9, 0, 0, 0, 0, 0, 0, 0, 0, 8, 0, 0, 0, 8, 8, 8, 8, 8, 0, 8, 8, 0, 10, 0, 0, 10, 4, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 8, 1, 1, 1, 1, 1, 1, 1, 1, 10, 10, 10, 1, 1, 1, 10, 10, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 10, 1, 1, 1, 8, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 10, 3, 3, 1, 1, 1, 1, 10, 8, 1, 1, 1, 3, 1, 10, 1, 1, 2, 10, 1, 1, 1, 2, 10, 2, 2, 1, 10, 1, 1, 1, 1, 0, 10, 0, 0, 10, 0, 8, 0, 10, 0, 10, 0, 10, 0, 0, 0, 10, 0, 10, 0, 0, 0, 10, 0, 0, 0, 10, 0, 10, 0, 10, 0, 0, 0, 0, 0, 0, 10, 0, 0, 10, 0, 0, 0, 10, 0, 0, 0, 10, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 0, 10, 0, 10, 0, 10, 0, 10, 0, 0, 0, 0, 0, 0, 0, 10, 0, 10, 0, 10, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 10, 10, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 10, 0, 10, 0, 10, 0, 0, 0, 10, 0, 0, 10, 0, 10, 0, 10, 0, 0, 0, 0, 0, 10, 0, 0, 0, 10, 0, 10, 0, 10, 0, 10, 0, 0, 0, 0, 0, 0, 10, 0, 10, 0, 10, 0, 0, 10, 0, 0, 10, 0, 10, 0, 10, 0, 0, 0, 8, 0, 10, 0, 10, 0, 10, 0, 10, 0, 0, 0, 0, 0, 10, 0, 10, 0, 10, 0, 10, 0, 0, 0, 0, 0, 0, 0, 10, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 0, 10, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 10, 10, 0, 10, 0, 0, 0, 0, 0, 10, 0, 10, 0, 10, 0, 0, 10, 0, 10, 0, 10, 0, 10, 0, 10, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 10, 0, 0, 0, 0, 0, 0, 0, 0, 10, 0, 10, 0, 10, 0, 10, 0, 0, 0, 10, 10, 10, 10, 0, 10, 0, 0, 0, 0, 0, 10, 0, 10, 0, 10, 0, 0, 0, 10, 0, 0, 10, 0, 0, 0, 0, 0, 10, 0, 10, 0, 10, 0, 0, 10, 0, 0, 8, 7, 8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 0, 10, 0, 0, 0, 10, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 10, 0, 0, 8, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 0, 9, 8, 0, 4, 8, 10, 10, 0, 0, 0, 0, 0, 10, 0, 0, 9, 10, 0, 10, 0, 10, 0, 8, 8, 10, 8, 0, 0, 8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8, 0, 8, 0, 8, 0, 8, 0, 8, 0, 8, 0, 8, 0, 8, 0, 8, 0, 8, 0, 4, 0, 10, 0, 10, 0, 10, 0, 10, 0, 0, 10, 10, 0, 0, 0, 0, 10, 10, 10, 10, 10, 0, 10, 0, 10, 0, 0, 0, 0, 0, 10, 0, 10, 0, 7, 0, 0, 10, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 1, 1, 10, 1, 10, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 8, 8, 8, 8, 8, 8, 8, 4, 8, 8, 0, 8, 0, 8, 0, 8, 0, 0, 0, 0, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 4, 9, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 10, 9, 9, 0, 9, 0, 9];
const _M0FP410tonyfettes7unicode8internal3ucd11decomp__cps = [160, 168, 170, 175, 178, 179, 180, 181, 184, 185, 186, 188, 189, 190, 192, 193, 194, 195, 196, 197, 199, 200, 201, 202, 203, 204, 205, 206, 207, 209, 210, 211, 212, 213, 214, 217, 218, 219, 220, 221, 224, 225, 226, 227, 228, 229, 231, 232, 233, 234, 235, 236, 237, 238, 239, 241, 242, 243, 244, 245, 246, 249, 250, 251, 252, 253, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 296, 297, 298, 299, 300, 301, 302, 303, 304, 306, 307, 308, 309, 310, 311, 313, 314, 315, 316, 317, 318, 319, 320, 323, 324, 325, 326, 327, 328, 329, 332, 333, 334, 335, 336, 337, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 416, 417, 431, 432, 452, 453, 454, 455, 456, 457, 458, 459, 460, 461, 462, 463, 464, 465, 466, 467, 468, 469, 470, 471, 472, 473, 474, 475, 476, 478, 479, 480, 481, 482, 483, 486, 487, 488, 489, 490, 491, 492, 493, 494, 495, 496, 497, 498, 499, 500, 501, 504, 505, 506, 507, 508, 509, 510, 511, 512, 513, 514, 515, 516, 517, 518, 519, 520, 521, 522, 523, 524, 525, 526, 527, 528, 529, 530, 531, 532, 533, 534, 535, 536, 537, 538, 539, 542, 543, 550, 551, 552, 553, 554, 555, 556, 557, 558, 559, 560, 561, 562, 563, 688, 689, 690, 691, 692, 693, 694, 695, 696, 728, 729, 730, 731, 732, 733, 736, 737, 738, 739, 740, 832, 833, 835, 836, 884, 890, 894, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 938, 939, 940, 941, 942, 943, 944, 970, 971, 972, 973, 974, 976, 977, 978, 979, 980, 981, 982, 1008, 1009, 1010, 1012, 1013, 1017, 1024, 1025, 1027, 1031, 1036, 1037, 1038, 1049, 1081, 1104, 1105, 1107, 1111, 1116, 1117, 1118, 1142, 1143, 1217, 1218, 1232, 1233, 1234, 1235, 1238, 1239, 1242, 1243, 1244, 1245, 1246, 1247, 1250, 1251, 1252, 1253, 1254, 1255, 1258, 1259, 1260, 1261, 1262, 1263, 1264, 1265, 1266, 1267, 1268, 1269, 1272, 1273, 1415, 1570, 1571, 1572, 1573, 1574, 1653, 1654, 1655, 1656, 1728, 1730, 1747, 2345, 2353, 2356, 2392, 2393, 2394, 2395, 2396, 2397, 2398, 2399, 2507, 2508, 2524, 2525, 2527, 2611, 2614, 2649, 2650, 2651, 2654, 2888, 2891, 2892, 2908, 2909, 2964, 3018, 3019, 3020, 3144, 3264, 3271, 3272, 3274, 3275, 3402, 3403, 3404, 3546, 3548, 3549, 3550, 3635, 3763, 3804, 3805, 3852, 3907, 3917, 3922, 3927, 3932, 3945, 3955, 3957, 3958, 3959, 3960, 3961, 3969, 3987, 3997, 4002, 4007, 4012, 4025, 4134, 4348, 6918, 6920, 6922, 6924, 6926, 6930, 6971, 6973, 6976, 6977, 6979, 7468, 7469, 7470, 7472, 7473, 7474, 7475, 7476, 7477, 7478, 7479, 7480, 7481, 7482, 7484, 7485, 7486, 7487, 7488, 7489, 7490, 7491, 7492, 7493, 7494, 7495, 7496, 7497, 7498, 7499, 7500, 7501, 7503, 7504, 7505, 7506, 7507, 7508, 7509, 7510, 7511, 7512, 7513, 7514, 7515, 7516, 7517, 7518, 7519, 7520, 7521, 7522, 7523, 7524, 7525, 7526, 7527, 7528, 7529, 7530, 7544, 7579, 7580, 7581, 7582, 7583, 7584, 7585, 7586, 7587, 7588, 7589, 7590, 7591, 7592, 7593, 7594, 7595, 7596, 7597, 7598, 7599, 7600, 7601, 7602, 7603, 7604, 7605, 7606, 7607, 7608, 7609, 7610, 7611, 7612, 7613, 7614, 7615, 7680, 7681, 7682, 7683, 7684, 7685, 7686, 7687, 7688, 7689, 7690, 7691, 7692, 7693, 7694, 7695, 7696, 7697, 7698, 7699, 7700, 7701, 7702, 7703, 7704, 7705, 7706, 7707, 7708, 7709, 7710, 7711, 7712, 7713, 7714, 7715, 7716, 7717, 7718, 7719, 7720, 7721, 7722, 7723, 7724, 7725, 7726, 7727, 7728, 7729, 7730, 7731, 7732, 7733, 7734, 7735, 7736, 7737, 7738, 7739, 7740, 7741, 7742, 7743, 7744, 7745, 7746, 7747, 7748, 7749, 7750, 7751, 7752, 7753, 7754, 7755, 7756, 7757, 7758, 7759, 7760, 7761, 7762, 7763, 7764, 7765, 7766, 7767, 7768, 7769, 7770, 7771, 7772, 7773, 7774, 7775, 7776, 7777, 7778, 7779, 7780, 7781, 7782, 7783, 7784, 7785, 7786, 7787, 7788, 7789, 7790, 7791, 7792, 7793, 7794, 7795, 7796, 7797, 7798, 7799, 7800, 7801, 7802, 7803, 7804, 7805, 7806, 7807, 7808, 7809, 7810, 7811, 7812, 7813, 7814, 7815, 7816, 7817, 7818, 7819, 7820, 7821, 7822, 7823, 7824, 7825, 7826, 7827, 7828, 7829, 7830, 7831, 7832, 7833, 7834, 7835, 7840, 7841, 7842, 7843, 7844, 7845, 7846, 7847, 7848, 7849, 7850, 7851, 7852, 7853, 7854, 7855, 7856, 7857, 7858, 7859, 7860, 7861, 7862, 7863, 7864, 7865, 7866, 7867, 7868, 7869, 7870, 7871, 7872, 7873, 7874, 7875, 7876, 7877, 7878, 7879, 7880, 7881, 7882, 7883, 7884, 7885, 7886, 7887, 7888, 7889, 7890, 7891, 7892, 7893, 7894, 7895, 7896, 7897, 7898, 7899, 7900, 7901, 7902, 7903, 7904, 7905, 7906, 7907, 7908, 7909, 7910, 7911, 7912, 7913, 7914, 7915, 7916, 7917, 7918, 7919, 7920, 7921, 7922, 7923, 7924, 7925, 7926, 7927, 7928, 7929, 7936, 7937, 7938, 7939, 7940, 7941, 7942, 7943, 7944, 7945, 7946, 7947, 7948, 7949, 7950, 7951, 7952, 7953, 7954, 7955, 7956, 7957, 7960, 7961, 7962, 7963, 7964, 7965, 7968, 7969, 7970, 7971, 7972, 7973, 7974, 7975, 7976, 7977, 7978, 7979, 7980, 7981, 7982, 7983, 7984, 7985, 7986, 7987, 7988, 7989, 7990, 7991, 7992, 7993, 7994, 7995, 7996, 7997, 7998, 7999, 8000, 8001, 8002, 8003, 8004, 8005, 8008, 8009, 8010, 8011, 8012, 8013, 8016, 8017, 8018, 8019, 8020, 8021, 8022, 8023, 8025, 8027, 8029, 8031, 8032, 8033, 8034, 8035, 8036, 8037, 8038, 8039, 8040, 8041, 8042, 8043, 8044, 8045, 8046, 8047, 8048, 8049, 8050, 8051, 8052, 8053, 8054, 8055, 8056, 8057, 8058, 8059, 8060, 8061, 8064, 8065, 8066, 8067, 8068, 8069, 8070, 8071, 8072, 8073, 8074, 8075, 8076, 8077, 8078, 8079, 8080, 8081, 8082, 8083, 8084, 8085, 8086, 8087, 8088, 8089, 8090, 8091, 8092, 8093, 8094, 8095, 8096, 8097, 8098, 8099, 8100, 8101, 8102, 8103, 8104, 8105, 8106, 8107, 8108, 8109, 8110, 8111, 8112, 8113, 8114, 8115, 8116, 8118, 8119, 8120, 8121, 8122, 8123, 8124, 8125, 8126, 8127, 8128, 8129, 8130, 8131, 8132, 8134, 8135, 8136, 8137, 8138, 8139, 8140, 8141, 8142, 8143, 8144, 8145, 8146, 8147, 8150, 8151, 8152, 8153, 8154, 8155, 8157, 8158, 8159, 8160, 8161, 8162, 8163, 8164, 8165, 8166, 8167, 8168, 8169, 8170, 8171, 8172, 8173, 8174, 8175, 8178, 8179, 8180, 8182, 8183, 8184, 8185, 8186, 8187, 8188, 8189, 8190, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200, 8201, 8202, 8209, 8215, 8228, 8229, 8230, 8239, 8243, 8244, 8246, 8247, 8252, 8254, 8263, 8264, 8265, 8279, 8287, 8304, 8305, 8308, 8309, 8310, 8311, 8312, 8313, 8314, 8315, 8316, 8317, 8318, 8319, 8320, 8321, 8322, 8323, 8324, 8325, 8326, 8327, 8328, 8329, 8330, 8331, 8332, 8333, 8334, 8336, 8337, 8338, 8339, 8340, 8341, 8342, 8343, 8344, 8345, 8346, 8347, 8348, 8360, 8448, 8449, 8450, 8451, 8453, 8454, 8455, 8457, 8458, 8459, 8460, 8461, 8462, 8463, 8464, 8465, 8466, 8467, 8469, 8470, 8473, 8474, 8475, 8476, 8477, 8480, 8481, 8482, 8484, 8486, 8488, 8490, 8491, 8492, 8493, 8495, 8496, 8497, 8499, 8500, 8501, 8502, 8503, 8504, 8505, 8507, 8508, 8509, 8510, 8511, 8512, 8517, 8518, 8519, 8520, 8521, 8528, 8529, 8530, 8531, 8532, 8533, 8534, 8535, 8536, 8537, 8538, 8539, 8540, 8541, 8542, 8543, 8544, 8545, 8546, 8547, 8548, 8549, 8550, 8551, 8552, 8553, 8554, 8555, 8556, 8557, 8558, 8559, 8560, 8561, 8562, 8563, 8564, 8565, 8566, 8567, 8568, 8569, 8570, 8571, 8572, 8573, 8574, 8575, 8585, 8602, 8603, 8622, 8653, 8654, 8655, 8708, 8713, 8716, 8740, 8742, 8748, 8749, 8751, 8752, 8769, 8772, 8775, 8777, 8800, 8802, 8813, 8814, 8815, 8816, 8817, 8820, 8821, 8824, 8825, 8832, 8833, 8836, 8837, 8840, 8841, 8876, 8877, 8878, 8879, 8928, 8929, 8930, 8931, 8938, 8939, 8940, 8941, 9001, 9002, 9312, 9313, 9314, 9315, 9316, 9317, 9318, 9319, 9320, 9321, 9322, 9323, 9324, 9325, 9326, 9327, 9328, 9329, 9330, 9331, 9332, 9333, 9334, 9335, 9336, 9337, 9338, 9339, 9340, 9341, 9342, 9343, 9344, 9345, 9346, 9347, 9348, 9349, 9350, 9351, 9352, 9353, 9354, 9355, 9356, 9357, 9358, 9359, 9360, 9361, 9362, 9363, 9364, 9365, 9366, 9367, 9368, 9369, 9370, 9371, 9372, 9373, 9374, 9375, 9376, 9377, 9378, 9379, 9380, 9381, 9382, 9383, 9384, 9385, 9386, 9387, 9388, 9389, 9390, 9391, 9392, 9393, 9394, 9395, 9396, 9397, 9398, 9399, 9400, 9401, 9402, 9403, 9404, 9405, 9406, 9407, 9408, 9409, 9410, 9411, 9412, 9413, 9414, 9415, 9416, 9417, 9418, 9419, 9420, 9421, 9422, 9423, 9424, 9425, 9426, 9427, 9428, 9429, 9430, 9431, 9432, 9433, 9434, 9435, 9436, 9437, 9438, 9439, 9440, 9441, 9442, 9443, 9444, 9445, 9446, 9447, 9448, 9449, 9450, 10764, 10868, 10869, 10870, 10972, 11388, 11389, 11631, 11935, 12019, 12032, 12033, 12034, 12035, 12036, 12037, 12038, 12039, 12040, 12041, 12042, 12043, 12044, 12045, 12046, 12047, 12048, 12049, 12050, 12051, 12052, 12053, 12054, 12055, 12056, 12057, 12058, 12059, 12060, 12061, 12062, 12063, 12064, 12065, 12066, 12067, 12068, 12069, 12070, 12071, 12072, 12073, 12074, 12075, 12076, 12077, 12078, 12079, 12080, 12081, 12082, 12083, 12084, 12085, 12086, 12087, 12088, 12089, 12090, 12091, 12092, 12093, 12094, 12095, 12096, 12097, 12098, 12099, 12100, 12101, 12102, 12103, 12104, 12105, 12106, 12107, 12108, 12109, 12110, 12111, 12112, 12113, 12114, 12115, 12116, 12117, 12118, 12119, 12120, 12121, 12122, 12123, 12124, 12125, 12126, 12127, 12128, 12129, 12130, 12131, 12132, 12133, 12134, 12135, 12136, 12137, 12138, 12139, 12140, 12141, 12142, 12143, 12144, 12145, 12146, 12147, 12148, 12149, 12150, 12151, 12152, 12153, 12154, 12155, 12156, 12157, 12158, 12159, 12160, 12161, 12162, 12163, 12164, 12165, 12166, 12167, 12168, 12169, 12170, 12171, 12172, 12173, 12174, 12175, 12176, 12177, 12178, 12179, 12180, 12181, 12182, 12183, 12184, 12185, 12186, 12187, 12188, 12189, 12190, 12191, 12192, 12193, 12194, 12195, 12196, 12197, 12198, 12199, 12200, 12201, 12202, 12203, 12204, 12205, 12206, 12207, 12208, 12209, 12210, 12211, 12212, 12213, 12214, 12215, 12216, 12217, 12218, 12219, 12220, 12221, 12222, 12223, 12224, 12225, 12226, 12227, 12228, 12229, 12230, 12231, 12232, 12233, 12234, 12235, 12236, 12237, 12238, 12239, 12240, 12241, 12242, 12243, 12244, 12245, 12288, 12342, 12344, 12345, 12346, 12364, 12366, 12368, 12370, 12372, 12374, 12376, 12378, 12380, 12382, 12384, 12386, 12389, 12391, 12393, 12400, 12401, 12403, 12404, 12406, 12407, 12409, 12410, 12412, 12413, 12436, 12443, 12444, 12446, 12447, 12460, 12462, 12464, 12466, 12468, 12470, 12472, 12474, 12476, 12478, 12480, 12482, 12485, 12487, 12489, 12496, 12497, 12499, 12500, 12502, 12503, 12505, 12506, 12508, 12509, 12532, 12535, 12536, 12537, 12538, 12542, 12543, 12593, 12594, 12595, 12596, 12597, 12598, 12599, 12600, 12601, 12602, 12603, 12604, 12605, 12606, 12607, 12608, 12609, 12610, 12611, 12612, 12613, 12614, 12615, 12616, 12617, 12618, 12619, 12620, 12621, 12622, 12623, 12624, 12625, 12626, 12627, 12628, 12629, 12630, 12631, 12632, 12633, 12634, 12635, 12636, 12637, 12638, 12639, 12640, 12641, 12642, 12643, 12644, 12645, 12646, 12647, 12648, 12649, 12650, 12651, 12652, 12653, 12654, 12655, 12656, 12657, 12658, 12659, 12660, 12661, 12662, 12663, 12664, 12665, 12666, 12667, 12668, 12669, 12670, 12671, 12672, 12673, 12674, 12675, 12676, 12677, 12678, 12679, 12680, 12681, 12682, 12683, 12684, 12685, 12686, 12690, 12691, 12692, 12693, 12694, 12695, 12696, 12697, 12698, 12699, 12700, 12701, 12702, 12703, 12800, 12801, 12802, 12803, 12804, 12805, 12806, 12807, 12808, 12809, 12810, 12811, 12812, 12813, 12814, 12815, 12816, 12817, 12818, 12819, 12820, 12821, 12822, 12823, 12824, 12825, 12826, 12827, 12828, 12829, 12830, 12832, 12833, 12834, 12835, 12836, 12837, 12838, 12839, 12840, 12841, 12842, 12843, 12844, 12845, 12846, 12847, 12848, 12849, 12850, 12851, 12852, 12853, 12854, 12855, 12856, 12857, 12858, 12859, 12860, 12861, 12862, 12863, 12864, 12865, 12866, 12867, 12868, 12869, 12870, 12871, 12880, 12881, 12882, 12883, 12884, 12885, 12886, 12887, 12888, 12889, 12890, 12891, 12892, 12893, 12894, 12895, 12896, 12897, 12898, 12899, 12900, 12901, 12902, 12903, 12904, 12905, 12906, 12907, 12908, 12909, 12910, 12911, 12912, 12913, 12914, 12915, 12916, 12917, 12918, 12919, 12920, 12921, 12922, 12923, 12924, 12925, 12926, 12928, 12929, 12930, 12931, 12932, 12933, 12934, 12935, 12936, 12937, 12938, 12939, 12940, 12941, 12942, 12943, 12944, 12945, 12946, 12947, 12948, 12949, 12950, 12951, 12952, 12953, 12954, 12955, 12956, 12957, 12958, 12959, 12960, 12961, 12962, 12963, 12964, 12965, 12966, 12967, 12968, 12969, 12970, 12971, 12972, 12973, 12974, 12975, 12976, 12977, 12978, 12979, 12980, 12981, 12982, 12983, 12984, 12985, 12986, 12987, 12988, 12989, 12990, 12991, 12992, 12993, 12994, 12995, 12996, 12997, 12998, 12999, 13000, 13001, 13002, 13003, 13004, 13005, 13006, 13007, 13008, 13009, 13010, 13011, 13012, 13013, 13014, 13015, 13016, 13017, 13018, 13019, 13020, 13021, 13022, 13023, 13024, 13025, 13026, 13027, 13028, 13029, 13030, 13031, 13032, 13033, 13034, 13035, 13036, 13037, 13038, 13039, 13040, 13041, 13042, 13043, 13044, 13045, 13046, 13047, 13048, 13049, 13050, 13051, 13052, 13053, 13054, 13055, 13056, 13057, 13058, 13059, 13060, 13061, 13062, 13063, 13064, 13065, 13066, 13067, 13068, 13069, 13070, 13071, 13072, 13073, 13074, 13075, 13076, 13077, 13078, 13079, 13080, 13081, 13082, 13083, 13084, 13085, 13086, 13087, 13088, 13089, 13090, 13091, 13092, 13093, 13094, 13095, 13096, 13097, 13098, 13099, 13100, 13101, 13102, 13103, 13104, 13105, 13106, 13107, 13108, 13109, 13110, 13111, 13112, 13113, 13114, 13115, 13116, 13117, 13118, 13119, 13120, 13121, 13122, 13123, 13124, 13125, 13126, 13127, 13128, 13129, 13130, 13131, 13132, 13133, 13134, 13135, 13136, 13137, 13138, 13139, 13140, 13141, 13142, 13143, 13144, 13145, 13146, 13147, 13148, 13149, 13150, 13151, 13152, 13153, 13154, 13155, 13156, 13157, 13158, 13159, 13160, 13161, 13162, 13163, 13164, 13165, 13166, 13167, 13168, 13169, 13170, 13171, 13172, 13173, 13174, 13175, 13176, 13177, 13178, 13179, 13180, 13181, 13182, 13183, 13184, 13185, 13186, 13187, 13188, 13189, 13190, 13191, 13192, 13193, 13194, 13195, 13196, 13197, 13198, 13199, 13200, 13201, 13202, 13203, 13204, 13205, 13206, 13207, 13208, 13209, 13210, 13211, 13212, 13213, 13214, 13215, 13216, 13217, 13218, 13219, 13220, 13221, 13222, 13223, 13224, 13225, 13226, 13227, 13228, 13229, 13230, 13231, 13232, 13233, 13234, 13235, 13236, 13237, 13238, 13239, 13240, 13241, 13242, 13243, 13244, 13245, 13246, 13247, 13248, 13249, 13250, 13251, 13252, 13253, 13254, 13255, 13256, 13257, 13258, 13259, 13260, 13261, 13262, 13263, 13264, 13265, 13266, 13267, 13268, 13269, 13270, 13271, 13272, 13273, 13274, 13275, 13276, 13277, 13278, 13279, 13280, 13281, 13282, 13283, 13284, 13285, 13286, 13287, 13288, 13289, 13290, 13291, 13292, 13293, 13294, 13295, 13296, 13297, 13298, 13299, 13300, 13301, 13302, 13303, 13304, 13305, 13306, 13307, 13308, 13309, 13310, 13311, 42652, 42653, 42864, 42994, 42995, 42996, 43000, 43001, 43868, 43869, 43870, 43871, 43881, 63744, 63745, 63746, 63747, 63748, 63749, 63750, 63751, 63752, 63753, 63754, 63755, 63756, 63757, 63758, 63759, 63760, 63761, 63762, 63763, 63764, 63765, 63766, 63767, 63768, 63769, 63770, 63771, 63772, 63773, 63774, 63775, 63776, 63777, 63778, 63779, 63780, 63781, 63782, 63783, 63784, 63785, 63786, 63787, 63788, 63789, 63790, 63791, 63792, 63793, 63794, 63795, 63796, 63797, 63798, 63799, 63800, 63801, 63802, 63803, 63804, 63805, 63806, 63807, 63808, 63809, 63810, 63811, 63812, 63813, 63814, 63815, 63816, 63817, 63818, 63819, 63820, 63821, 63822, 63823, 63824, 63825, 63826, 63827, 63828, 63829, 63830, 63831, 63832, 63833, 63834, 63835, 63836, 63837, 63838, 63839, 63840, 63841, 63842, 63843, 63844, 63845, 63846, 63847, 63848, 63849, 63850, 63851, 63852, 63853, 63854, 63855, 63856, 63857, 63858, 63859, 63860, 63861, 63862, 63863, 63864, 63865, 63866, 63867, 63868, 63869, 63870, 63871, 63872, 63873, 63874, 63875, 63876, 63877, 63878, 63879, 63880, 63881, 63882, 63883, 63884, 63885, 63886, 63887, 63888, 63889, 63890, 63891, 63892, 63893, 63894, 63895, 63896, 63897, 63898, 63899, 63900, 63901, 63902, 63903, 63904, 63905, 63906, 63907, 63908, 63909, 63910, 63911, 63912, 63913, 63914, 63915, 63916, 63917, 63918, 63919, 63920, 63921, 63922, 63923, 63924, 63925, 63926, 63927, 63928, 63929, 63930, 63931, 63932, 63933, 63934, 63935, 63936, 63937, 63938, 63939, 63940, 63941, 63942, 63943, 63944, 63945, 63946, 63947, 63948, 63949, 63950, 63951, 63952, 63953, 63954, 63955, 63956, 63957, 63958, 63959, 63960, 63961, 63962, 63963, 63964, 63965, 63966, 63967, 63968, 63969, 63970, 63971, 63972, 63973, 63974, 63975, 63976, 63977, 63978, 63979, 63980, 63981, 63982, 63983, 63984, 63985, 63986, 63987, 63988, 63989, 63990, 63991, 63992, 63993, 63994, 63995, 63996, 63997, 63998, 63999, 64000, 64001, 64002, 64003, 64004, 64005, 64006, 64007, 64008, 64009, 64010, 64011, 64012, 64013, 64016, 64018, 64021, 64022, 64023, 64024, 64025, 64026, 64027, 64028, 64029, 64030, 64032, 64034, 64037, 64038, 64042, 64043, 64044, 64045, 64046, 64047, 64048, 64049, 64050, 64051, 64052, 64053, 64054, 64055, 64056, 64057, 64058, 64059, 64060, 64061, 64062, 64063, 64064, 64065, 64066, 64067, 64068, 64069, 64070, 64071, 64072, 64073, 64074, 64075, 64076, 64077, 64078, 64079, 64080, 64081, 64082, 64083, 64084, 64085, 64086, 64087, 64088, 64089, 64090, 64091, 64092, 64093, 64094, 64095, 64096, 64097, 64098, 64099, 64100, 64101, 64102, 64103, 64104, 64105, 64106, 64107, 64108, 64109, 64112, 64113, 64114, 64115, 64116, 64117, 64118, 64119, 64120, 64121, 64122, 64123, 64124, 64125, 64126, 64127, 64128, 64129, 64130, 64131, 64132, 64133, 64134, 64135, 64136, 64137, 64138, 64139, 64140, 64141, 64142, 64143, 64144, 64145, 64146, 64147, 64148, 64149, 64150, 64151, 64152, 64153, 64154, 64155, 64156, 64157, 64158, 64159, 64160, 64161, 64162, 64163, 64164, 64165, 64166, 64167, 64168, 64169, 64170, 64171, 64172, 64173, 64174, 64175, 64176, 64177, 64178, 64179, 64180, 64181, 64182, 64183, 64184, 64185, 64186, 64187, 64188, 64189, 64190, 64191, 64192, 64193, 64194, 64195, 64196, 64197, 64198, 64199, 64200, 64201, 64202, 64203, 64204, 64205, 64206, 64207, 64208, 64209, 64210, 64211, 64212, 64213, 64214, 64215, 64216, 64217, 64256, 64257, 64258, 64259, 64260, 64261, 64262, 64275, 64276, 64277, 64278, 64279, 64285, 64287, 64288, 64289, 64290, 64291, 64292, 64293, 64294, 64295, 64296, 64297, 64298, 64299, 64300, 64301, 64302, 64303, 64304, 64305, 64306, 64307, 64308, 64309, 64310, 64312, 64313, 64314, 64315, 64316, 64318, 64320, 64321, 64323, 64324, 64326, 64327, 64328, 64329, 64330, 64331, 64332, 64333, 64334, 64335, 64336, 64337, 64338, 64339, 64340, 64341, 64342, 64343, 64344, 64345, 64346, 64347, 64348, 64349, 64350, 64351, 64352, 64353, 64354, 64355, 64356, 64357, 64358, 64359, 64360, 64361, 64362, 64363, 64364, 64365, 64366, 64367, 64368, 64369, 64370, 64371, 64372, 64373, 64374, 64375, 64376, 64377, 64378, 64379, 64380, 64381, 64382, 64383, 64384, 64385, 64386, 64387, 64388, 64389, 64390, 64391, 64392, 64393, 64394, 64395, 64396, 64397, 64398, 64399, 64400, 64401, 64402, 64403, 64404, 64405, 64406, 64407, 64408, 64409, 64410, 64411, 64412, 64413, 64414, 64415, 64416, 64417, 64418, 64419, 64420, 64421, 64422, 64423, 64424, 64425, 64426, 64427, 64428, 64429, 64430, 64431, 64432, 64433, 64467, 64468, 64469, 64470, 64471, 64472, 64473, 64474, 64475, 64476, 64477, 64478, 64479, 64480, 64481, 64482, 64483, 64484, 64485, 64486, 64487, 64488, 64489, 64490, 64491, 64492, 64493, 64494, 64495, 64496, 64497, 64498, 64499, 64500, 64501, 64502, 64503, 64504, 64505, 64506, 64507, 64508, 64509, 64510, 64511, 64512, 64513, 64514, 64515, 64516, 64517, 64518, 64519, 64520, 64521, 64522, 64523, 64524, 64525, 64526, 64527, 64528, 64529, 64530, 64531, 64532, 64533, 64534, 64535, 64536, 64537, 64538, 64539, 64540, 64541, 64542, 64543, 64544, 64545, 64546, 64547, 64548, 64549, 64550, 64551, 64552, 64553, 64554, 64555, 64556, 64557, 64558, 64559, 64560, 64561, 64562, 64563, 64564, 64565, 64566, 64567, 64568, 64569, 64570, 64571, 64572, 64573, 64574, 64575, 64576, 64577, 64578, 64579, 64580, 64581, 64582, 64583, 64584, 64585, 64586, 64587, 64588, 64589, 64590, 64591, 64592, 64593, 64594, 64595, 64596, 64597, 64598, 64599, 64600, 64601, 64602, 64603, 64604, 64605, 64606, 64607, 64608, 64609, 64610, 64611, 64612, 64613, 64614, 64615, 64616, 64617, 64618, 64619, 64620, 64621, 64622, 64623, 64624, 64625, 64626, 64627, 64628, 64629, 64630, 64631, 64632, 64633, 64634, 64635, 64636, 64637, 64638, 64639, 64640, 64641, 64642, 64643, 64644, 64645, 64646, 64647, 64648, 64649, 64650, 64651, 64652, 64653, 64654, 64655, 64656, 64657, 64658, 64659, 64660, 64661, 64662, 64663, 64664, 64665, 64666, 64667, 64668, 64669, 64670, 64671, 64672, 64673, 64674, 64675, 64676, 64677, 64678, 64679, 64680, 64681, 64682, 64683, 64684, 64685, 64686, 64687, 64688, 64689, 64690, 64691, 64692, 64693, 64694, 64695, 64696, 64697, 64698, 64699, 64700, 64701, 64702, 64703, 64704, 64705, 64706, 64707, 64708, 64709, 64710, 64711, 64712, 64713, 64714, 64715, 64716, 64717, 64718, 64719, 64720, 64721, 64722, 64723, 64724, 64725, 64726, 64727, 64728, 64729, 64730, 64731, 64732, 64733, 64734, 64735, 64736, 64737, 64738, 64739, 64740, 64741, 64742, 64743, 64744, 64745, 64746, 64747, 64748, 64749, 64750, 64751, 64752, 64753, 64754, 64755, 64756, 64757, 64758, 64759, 64760, 64761, 64762, 64763, 64764, 64765, 64766, 64767, 64768, 64769, 64770, 64771, 64772, 64773, 64774, 64775, 64776, 64777, 64778, 64779, 64780, 64781, 64782, 64783, 64784, 64785, 64786, 64787, 64788, 64789, 64790, 64791, 64792, 64793, 64794, 64795, 64796, 64797, 64798, 64799, 64800, 64801, 64802, 64803, 64804, 64805, 64806, 64807, 64808, 64809, 64810, 64811, 64812, 64813, 64814, 64815, 64816, 64817, 64818, 64819, 64820, 64821, 64822, 64823, 64824, 64825, 64826, 64827, 64828, 64829, 64848, 64849, 64850, 64851, 64852, 64853, 64854, 64855, 64856, 64857, 64858, 64859, 64860, 64861, 64862, 64863, 64864, 64865, 64866, 64867, 64868, 64869, 64870, 64871, 64872, 64873, 64874, 64875, 64876, 64877, 64878, 64879, 64880, 64881, 64882, 64883, 64884, 64885, 64886, 64887, 64888, 64889, 64890, 64891, 64892, 64893, 64894, 64895, 64896, 64897, 64898, 64899, 64900, 64901, 64902, 64903, 64904, 64905, 64906, 64907, 64908, 64909, 64910, 64911, 64914, 64915, 64916, 64917, 64918, 64919, 64920, 64921, 64922, 64923, 64924, 64925, 64926, 64927, 64928, 64929, 64930, 64931, 64932, 64933, 64934, 64935, 64936, 64937, 64938, 64939, 64940, 64941, 64942, 64943, 64944, 64945, 64946, 64947, 64948, 64949, 64950, 64951, 64952, 64953, 64954, 64955, 64956, 64957, 64958, 64959, 64960, 64961, 64962, 64963, 64964, 64965, 64966, 64967, 65008, 65009, 65010, 65011, 65012, 65013, 65014, 65015, 65016, 65017, 65018, 65019, 65020, 65040, 65041, 65042, 65043, 65044, 65045, 65046, 65047, 65048, 65049, 65072, 65073, 65074, 65075, 65076, 65077, 65078, 65079, 65080, 65081, 65082, 65083, 65084, 65085, 65086, 65087, 65088, 65089, 65090, 65091, 65092, 65095, 65096, 65097, 65098, 65099, 65100, 65101, 65102, 65103, 65104, 65105, 65106, 65108, 65109, 65110, 65111, 65112, 65113, 65114, 65115, 65116, 65117, 65118, 65119, 65120, 65121, 65122, 65123, 65124, 65125, 65126, 65128, 65129, 65130, 65131, 65136, 65137, 65138, 65140, 65142, 65143, 65144, 65145, 65146, 65147, 65148, 65149, 65150, 65151, 65152, 65153, 65154, 65155, 65156, 65157, 65158, 65159, 65160, 65161, 65162, 65163, 65164, 65165, 65166, 65167, 65168, 65169, 65170, 65171, 65172, 65173, 65174, 65175, 65176, 65177, 65178, 65179, 65180, 65181, 65182, 65183, 65184, 65185, 65186, 65187, 65188, 65189, 65190, 65191, 65192, 65193, 65194, 65195, 65196, 65197, 65198, 65199, 65200, 65201, 65202, 65203, 65204, 65205, 65206, 65207, 65208, 65209, 65210, 65211, 65212, 65213, 65214, 65215, 65216, 65217, 65218, 65219, 65220, 65221, 65222, 65223, 65224, 65225, 65226, 65227, 65228, 65229, 65230, 65231, 65232, 65233, 65234, 65235, 65236, 65237, 65238, 65239, 65240, 65241, 65242, 65243, 65244, 65245, 65246, 65247, 65248, 65249, 65250, 65251, 65252, 65253, 65254, 65255, 65256, 65257, 65258, 65259, 65260, 65261, 65262, 65263, 65264, 65265, 65266, 65267, 65268, 65269, 65270, 65271, 65272, 65273, 65274, 65275, 65276, 65281, 65282, 65283, 65284, 65285, 65286, 65287, 65288, 65289, 65290, 65291, 65292, 65293, 65294, 65295, 65296, 65297, 65298, 65299, 65300, 65301, 65302, 65303, 65304, 65305, 65306, 65307, 65308, 65309, 65310, 65311, 65312, 65313, 65314, 65315, 65316, 65317, 65318, 65319, 65320, 65321, 65322, 65323, 65324, 65325, 65326, 65327, 65328, 65329, 65330, 65331, 65332, 65333, 65334, 65335, 65336, 65337, 65338, 65339, 65340, 65341, 65342, 65343, 65344, 65345, 65346, 65347, 65348, 65349, 65350, 65351, 65352, 65353, 65354, 65355, 65356, 65357, 65358, 65359, 65360, 65361, 65362, 65363, 65364, 65365, 65366, 65367, 65368, 65369, 65370, 65371, 65372, 65373, 65374, 65375, 65376, 65377, 65378, 65379, 65380, 65381, 65382, 65383, 65384, 65385, 65386, 65387, 65388, 65389, 65390, 65391, 65392, 65393, 65394, 65395, 65396, 65397, 65398, 65399, 65400, 65401, 65402, 65403, 65404, 65405, 65406, 65407, 65408, 65409, 65410, 65411, 65412, 65413, 65414, 65415, 65416, 65417, 65418, 65419, 65420, 65421, 65422, 65423, 65424, 65425, 65426, 65427, 65428, 65429, 65430, 65431, 65432, 65433, 65434, 65435, 65436, 65437, 65438, 65439, 65440, 65441, 65442, 65443, 65444, 65445, 65446, 65447, 65448, 65449, 65450, 65451, 65452, 65453, 65454, 65455, 65456, 65457, 65458, 65459, 65460, 65461, 65462, 65463, 65464, 65465, 65466, 65467, 65468, 65469, 65470, 65474, 65475, 65476, 65477, 65478, 65479, 65482, 65483, 65484, 65485, 65486, 65487, 65490, 65491, 65492, 65493, 65494, 65495, 65498, 65499, 65500, 65504, 65505, 65506, 65507, 65508, 65509, 65510, 65512, 65513, 65514, 65515, 65516, 65517, 65518, 67017, 67044, 67457, 67458, 67459, 67460, 67461, 67463, 67464, 67465, 67466, 67467, 67468, 67469, 67470, 67471, 67472, 67473, 67474, 67475, 67476, 67477, 67478, 67479, 67480, 67481, 67482, 67483, 67484, 67485, 67486, 67487, 67488, 67489, 67490, 67491, 67492, 67493, 67494, 67495, 67496, 67497, 67498, 67499, 67500, 67501, 67502, 67503, 67504, 67506, 67507, 67508, 67509, 67510, 67511, 67512, 67513, 67514, 69786, 69788, 69803, 69934, 69935, 70475, 70476, 70531, 70533, 70542, 70545, 70597, 70599, 70600, 70843, 70844, 70846, 71098, 71099, 71992, 90401, 90402, 90403, 90404, 90405, 90406, 90407, 90408, 93544, 93545, 93546, 117974, 117975, 117976, 117977, 117978, 117979, 117980, 117981, 117982, 117983, 117984, 117985, 117986, 117987, 117988, 117989, 117990, 117991, 117992, 117993, 117994, 117995, 117996, 117997, 117998, 117999, 118000, 118001, 118002, 118003, 118004, 118005, 118006, 118007, 118008, 118009, 119134, 119135, 119136, 119137, 119138, 119139, 119140, 119227, 119228, 119229, 119230, 119231, 119232, 119808, 119809, 119810, 119811, 119812, 119813, 119814, 119815, 119816, 119817, 119818, 119819, 119820, 119821, 119822, 119823, 119824, 119825, 119826, 119827, 119828, 119829, 119830, 119831, 119832, 119833, 119834, 119835, 119836, 119837, 119838, 119839, 119840, 119841, 119842, 119843, 119844, 119845, 119846, 119847, 119848, 119849, 119850, 119851, 119852, 119853, 119854, 119855, 119856, 119857, 119858, 119859, 119860, 119861, 119862, 119863, 119864, 119865, 119866, 119867, 119868, 119869, 119870, 119871, 119872, 119873, 119874, 119875, 119876, 119877, 119878, 119879, 119880, 119881, 119882, 119883, 119884, 119885, 119886, 119887, 119888, 119889, 119890, 119891, 119892, 119894, 119895, 119896, 119897, 119898, 119899, 119900, 119901, 119902, 119903, 119904, 119905, 119906, 119907, 119908, 119909, 119910, 119911, 119912, 119913, 119914, 119915, 119916, 119917, 119918, 119919, 119920, 119921, 119922, 119923, 119924, 119925, 119926, 119927, 119928, 119929, 119930, 119931, 119932, 119933, 119934, 119935, 119936, 119937, 119938, 119939, 119940, 119941, 119942, 119943, 119944, 119945, 119946, 119947, 119948, 119949, 119950, 119951, 119952, 119953, 119954, 119955, 119956, 119957, 119958, 119959, 119960, 119961, 119962, 119963, 119964, 119966, 119967, 119970, 119973, 119974, 119977, 119978, 119979, 119980, 119982, 119983, 119984, 119985, 119986, 119987, 119988, 119989, 119990, 119991, 119992, 119993, 119995, 119997, 119998, 119999, 120000, 120001, 120002, 120003, 120005, 120006, 120007, 120008, 120009, 120010, 120011, 120012, 120013, 120014, 120015, 120016, 120017, 120018, 120019, 120020, 120021, 120022, 120023, 120024, 120025, 120026, 120027, 120028, 120029, 120030, 120031, 120032, 120033, 120034, 120035, 120036, 120037, 120038, 120039, 120040, 120041, 120042, 120043, 120044, 120045, 120046, 120047, 120048, 120049, 120050, 120051, 120052, 120053, 120054, 120055, 120056, 120057, 120058, 120059, 120060, 120061, 120062, 120063, 120064, 120065, 120066, 120067, 120068, 120069, 120071, 120072, 120073, 120074, 120077, 120078, 120079, 120080, 120081, 120082, 120083, 120084, 120086, 120087, 120088, 120089, 120090, 120091, 120092, 120094, 120095, 120096, 120097, 120098, 120099, 120100, 120101, 120102, 120103, 120104, 120105, 120106, 120107, 120108, 120109, 120110, 120111, 120112, 120113, 120114, 120115, 120116, 120117, 120118, 120119, 120120, 120121, 120123, 120124, 120125, 120126, 120128, 120129, 120130, 120131, 120132, 120134, 120138, 120139, 120140, 120141, 120142, 120143, 120144, 120146, 120147, 120148, 120149, 120150, 120151, 120152, 120153, 120154, 120155, 120156, 120157, 120158, 120159, 120160, 120161, 120162, 120163, 120164, 120165, 120166, 120167, 120168, 120169, 120170, 120171, 120172, 120173, 120174, 120175, 120176, 120177, 120178, 120179, 120180, 120181, 120182, 120183, 120184, 120185, 120186, 120187, 120188, 120189, 120190, 120191, 120192, 120193, 120194, 120195, 120196, 120197, 120198, 120199, 120200, 120201, 120202, 120203, 120204, 120205, 120206, 120207, 120208, 120209, 120210, 120211, 120212, 120213, 120214, 120215, 120216, 120217, 120218, 120219, 120220, 120221, 120222, 120223, 120224, 120225, 120226, 120227, 120228, 120229, 120230, 120231, 120232, 120233, 120234, 120235, 120236, 120237, 120238, 120239, 120240, 120241, 120242, 120243, 120244, 120245, 120246, 120247, 120248, 120249, 120250, 120251, 120252, 120253, 120254, 120255, 120256, 120257, 120258, 120259, 120260, 120261, 120262, 120263, 120264, 120265, 120266, 120267, 120268, 120269, 120270, 120271, 120272, 120273, 120274, 120275, 120276, 120277, 120278, 120279, 120280, 120281, 120282, 120283, 120284, 120285, 120286, 120287, 120288, 120289, 120290, 120291, 120292, 120293, 120294, 120295, 120296, 120297, 120298, 120299, 120300, 120301, 120302, 120303, 120304, 120305, 120306, 120307, 120308, 120309, 120310, 120311, 120312, 120313, 120314, 120315, 120316, 120317, 120318, 120319, 120320, 120321, 120322, 120323, 120324, 120325, 120326, 120327, 120328, 120329, 120330, 120331, 120332, 120333, 120334, 120335, 120336, 120337, 120338, 120339, 120340, 120341, 120342, 120343, 120344, 120345, 120346, 120347, 120348, 120349, 120350, 120351, 120352, 120353, 120354, 120355, 120356, 120357, 120358, 120359, 120360, 120361, 120362, 120363, 120364, 120365, 120366, 120367, 120368, 120369, 120370, 120371, 120372, 120373, 120374, 120375, 120376, 120377, 120378, 120379, 120380, 120381, 120382, 120383, 120384, 120385, 120386, 120387, 120388, 120389, 120390, 120391, 120392, 120393, 120394, 120395, 120396, 120397, 120398, 120399, 120400, 120401, 120402, 120403, 120404, 120405, 120406, 120407, 120408, 120409, 120410, 120411, 120412, 120413, 120414, 120415, 120416, 120417, 120418, 120419, 120420, 120421, 120422, 120423, 120424, 120425, 120426, 120427, 120428, 120429, 120430, 120431, 120432, 120433, 120434, 120435, 120436, 120437, 120438, 120439, 120440, 120441, 120442, 120443, 120444, 120445, 120446, 120447, 120448, 120449, 120450, 120451, 120452, 120453, 120454, 120455, 120456, 120457, 120458, 120459, 120460, 120461, 120462, 120463, 120464, 120465, 120466, 120467, 120468, 120469, 120470, 120471, 120472, 120473, 120474, 120475, 120476, 120477, 120478, 120479, 120480, 120481, 120482, 120483, 120484, 120485, 120488, 120489, 120490, 120491, 120492, 120493, 120494, 120495, 120496, 120497, 120498, 120499, 120500, 120501, 120502, 120503, 120504, 120505, 120506, 120507, 120508, 120509, 120510, 120511, 120512, 120513, 120514, 120515, 120516, 120517, 120518, 120519, 120520, 120521, 120522, 120523, 120524, 120525, 120526, 120527, 120528, 120529, 120530, 120531, 120532, 120533, 120534, 120535, 120536, 120537, 120538, 120539, 120540, 120541, 120542, 120543, 120544, 120545, 120546, 120547, 120548, 120549, 120550, 120551, 120552, 120553, 120554, 120555, 120556, 120557, 120558, 120559, 120560, 120561, 120562, 120563, 120564, 120565, 120566, 120567, 120568, 120569, 120570, 120571, 120572, 120573, 120574, 120575, 120576, 120577, 120578, 120579, 120580, 120581, 120582, 120583, 120584, 120585, 120586, 120587, 120588, 120589, 120590, 120591, 120592, 120593, 120594, 120595, 120596, 120597, 120598, 120599, 120600, 120601, 120602, 120603, 120604, 120605, 120606, 120607, 120608, 120609, 120610, 120611, 120612, 120613, 120614, 120615, 120616, 120617, 120618, 120619, 120620, 120621, 120622, 120623, 120624, 120625, 120626, 120627, 120628, 120629, 120630, 120631, 120632, 120633, 120634, 120635, 120636, 120637, 120638, 120639, 120640, 120641, 120642, 120643, 120644, 120645, 120646, 120647, 120648, 120649, 120650, 120651, 120652, 120653, 120654, 120655, 120656, 120657, 120658, 120659, 120660, 120661, 120662, 120663, 120664, 120665, 120666, 120667, 120668, 120669, 120670, 120671, 120672, 120673, 120674, 120675, 120676, 120677, 120678, 120679, 120680, 120681, 120682, 120683, 120684, 120685, 120686, 120687, 120688, 120689, 120690, 120691, 120692, 120693, 120694, 120695, 120696, 120697, 120698, 120699, 120700, 120701, 120702, 120703, 120704, 120705, 120706, 120707, 120708, 120709, 120710, 120711, 120712, 120713, 120714, 120715, 120716, 120717, 120718, 120719, 120720, 120721, 120722, 120723, 120724, 120725, 120726, 120727, 120728, 120729, 120730, 120731, 120732, 120733, 120734, 120735, 120736, 120737, 120738, 120739, 120740, 120741, 120742, 120743, 120744, 120745, 120746, 120747, 120748, 120749, 120750, 120751, 120752, 120753, 120754, 120755, 120756, 120757, 120758, 120759, 120760, 120761, 120762, 120763, 120764, 120765, 120766, 120767, 120768, 120769, 120770, 120771, 120772, 120773, 120774, 120775, 120776, 120777, 120778, 120779, 120782, 120783, 120784, 120785, 120786, 120787, 120788, 120789, 120790, 120791, 120792, 120793, 120794, 120795, 120796, 120797, 120798, 120799, 120800, 120801, 120802, 120803, 120804, 120805, 120806, 120807, 120808, 120809, 120810, 120811, 120812, 120813, 120814, 120815, 120816, 120817, 120818, 120819, 120820, 120821, 120822, 120823, 120824, 120825, 120826, 120827, 120828, 120829, 120830, 120831, 122928, 122929, 122930, 122931, 122932, 122933, 122934, 122935, 122936, 122937, 122938, 122939, 122940, 122941, 122942, 122943, 122944, 122945, 122946, 122947, 122948, 122949, 122950, 122951, 122952, 122953, 122954, 122955, 122956, 122957, 122958, 122959, 122960, 122961, 122962, 122963, 122964, 122965, 122966, 122967, 122968, 122969, 122970, 122971, 122972, 122973, 122974, 122975, 122976, 122977, 122978, 122979, 122980, 122981, 122982, 122983, 122984, 122985, 122986, 122987, 122988, 122989, 126464, 126465, 126466, 126467, 126469, 126470, 126471, 126472, 126473, 126474, 126475, 126476, 126477, 126478, 126479, 126480, 126481, 126482, 126483, 126484, 126485, 126486, 126487, 126488, 126489, 126490, 126491, 126492, 126493, 126494, 126495, 126497, 126498, 126500, 126503, 126505, 126506, 126507, 126508, 126509, 126510, 126511, 126512, 126513, 126514, 126516, 126517, 126518, 126519, 126521, 126523, 126530, 126535, 126537, 126539, 126541, 126542, 126543, 126545, 126546, 126548, 126551, 126553, 126555, 126557, 126559, 126561, 126562, 126564, 126567, 126568, 126569, 126570, 126572, 126573, 126574, 126575, 126576, 126577, 126578, 126580, 126581, 126582, 126583, 126585, 126586, 126587, 126588, 126590, 126592, 126593, 126594, 126595, 126596, 126597, 126598, 126599, 126600, 126601, 126603, 126604, 126605, 126606, 126607, 126608, 126609, 126610, 126611, 126612, 126613, 126614, 126615, 126616, 126617, 126618, 126619, 126625, 126626, 126627, 126629, 126630, 126631, 126632, 126633, 126635, 126636, 126637, 126638, 126639, 126640, 126641, 126642, 126643, 126644, 126645, 126646, 126647, 126648, 126649, 126650, 126651, 127232, 127233, 127234, 127235, 127236, 127237, 127238, 127239, 127240, 127241, 127242, 127248, 127249, 127250, 127251, 127252, 127253, 127254, 127255, 127256, 127257, 127258, 127259, 127260, 127261, 127262, 127263, 127264, 127265, 127266, 127267, 127268, 127269, 127270, 127271, 127272, 127273, 127274, 127275, 127276, 127277, 127278, 127280, 127281, 127282, 127283, 127284, 127285, 127286, 127287, 127288, 127289, 127290, 127291, 127292, 127293, 127294, 127295, 127296, 127297, 127298, 127299, 127300, 127301, 127302, 127303, 127304, 127305, 127306, 127307, 127308, 127309, 127310, 127311, 127338, 127339, 127340, 127376, 127488, 127489, 127490, 127504, 127505, 127506, 127507, 127508, 127509, 127510, 127511, 127512, 127513, 127514, 127515, 127516, 127517, 127518, 127519, 127520, 127521, 127522, 127523, 127524, 127525, 127526, 127527, 127528, 127529, 127530, 127531, 127532, 127533, 127534, 127535, 127536, 127537, 127538, 127539, 127540, 127541, 127542, 127543, 127544, 127545, 127546, 127547, 127552, 127553, 127554, 127555, 127556, 127557, 127558, 127559, 127560, 127568, 127569, 130032, 130033, 130034, 130035, 130036, 130037, 130038, 130039, 130040, 130041, 194560, 194561, 194562, 194563, 194564, 194565, 194566, 194567, 194568, 194569, 194570, 194571, 194572, 194573, 194574, 194575, 194576, 194577, 194578, 194579, 194580, 194581, 194582, 194583, 194584, 194585, 194586, 194587, 194588, 194589, 194590, 194591, 194592, 194593, 194594, 194595, 194596, 194597, 194598, 194599, 194600, 194601, 194602, 194603, 194604, 194605, 194606, 194607, 194608, 194609, 194610, 194611, 194612, 194613, 194614, 194615, 194616, 194617, 194618, 194619, 194620, 194621, 194622, 194623, 194624, 194625, 194626, 194627, 194628, 194629, 194630, 194631, 194632, 194633, 194634, 194635, 194636, 194637, 194638, 194639, 194640, 194641, 194642, 194643, 194644, 194645, 194646, 194647, 194648, 194649, 194650, 194651, 194652, 194653, 194654, 194655, 194656, 194657, 194658, 194659, 194660, 194661, 194662, 194663, 194664, 194665, 194666, 194667, 194668, 194669, 194670, 194671, 194672, 194673, 194674, 194675, 194676, 194677, 194678, 194679, 194680, 194681, 194682, 194683, 194684, 194685, 194686, 194687, 194688, 194689, 194690, 194691, 194692, 194693, 194694, 194695, 194696, 194697, 194698, 194699, 194700, 194701, 194702, 194703, 194704, 194705, 194706, 194707, 194708, 194709, 194710, 194711, 194712, 194713, 194714, 194715, 194716, 194717, 194718, 194719, 194720, 194721, 194722, 194723, 194724, 194725, 194726, 194727, 194728, 194729, 194730, 194731, 194732, 194733, 194734, 194735, 194736, 194737, 194738, 194739, 194740, 194741, 194742, 194743, 194744, 194745, 194746, 194747, 194748, 194749, 194750, 194751, 194752, 194753, 194754, 194755, 194756, 194757, 194758, 194759, 194760, 194761, 194762, 194763, 194764, 194765, 194766, 194767, 194768, 194769, 194770, 194771, 194772, 194773, 194774, 194775, 194776, 194777, 194778, 194779, 194780, 194781, 194782, 194783, 194784, 194785, 194786, 194787, 194788, 194789, 194790, 194791, 194792, 194793, 194794, 194795, 194796, 194797, 194798, 194799, 194800, 194801, 194802, 194803, 194804, 194805, 194806, 194807, 194808, 194809, 194810, 194811, 194812, 194813, 194814, 194815, 194816, 194817, 194818, 194819, 194820, 194821, 194822, 194823, 194824, 194825, 194826, 194827, 194828, 194829, 194830, 194831, 194832, 194833, 194834, 194835, 194836, 194837, 194838, 194839, 194840, 194841, 194842, 194843, 194844, 194845, 194846, 194847, 194848, 194849, 194850, 194851, 194852, 194853, 194854, 194855, 194856, 194857, 194858, 194859, 194860, 194861, 194862, 194863, 194864, 194865, 194866, 194867, 194868, 194869, 194870, 194871, 194872, 194873, 194874, 194875, 194876, 194877, 194878, 194879, 194880, 194881, 194882, 194883, 194884, 194885, 194886, 194887, 194888, 194889, 194890, 194891, 194892, 194893, 194894, 194895, 194896, 194897, 194898, 194899, 194900, 194901, 194902, 194903, 194904, 194905, 194906, 194907, 194908, 194909, 194910, 194911, 194912, 194913, 194914, 194915, 194916, 194917, 194918, 194919, 194920, 194921, 194922, 194923, 194924, 194925, 194926, 194927, 194928, 194929, 194930, 194931, 194932, 194933, 194934, 194935, 194936, 194937, 194938, 194939, 194940, 194941, 194942, 194943, 194944, 194945, 194946, 194947, 194948, 194949, 194950, 194951, 194952, 194953, 194954, 194955, 194956, 194957, 194958, 194959, 194960, 194961, 194962, 194963, 194964, 194965, 194966, 194967, 194968, 194969, 194970, 194971, 194972, 194973, 194974, 194975, 194976, 194977, 194978, 194979, 194980, 194981, 194982, 194983, 194984, 194985, 194986, 194987, 194988, 194989, 194990, 194991, 194992, 194993, 194994, 194995, 194996, 194997, 194998, 194999, 195000, 195001, 195002, 195003, 195004, 195005, 195006, 195007, 195008, 195009, 195010, 195011, 195012, 195013, 195014, 195015, 195016, 195017, 195018, 195019, 195020, 195021, 195022, 195023, 195024, 195025, 195026, 195027, 195028, 195029, 195030, 195031, 195032, 195033, 195034, 195035, 195036, 195037, 195038, 195039, 195040, 195041, 195042, 195043, 195044, 195045, 195046, 195047, 195048, 195049, 195050, 195051, 195052, 195053, 195054, 195055, 195056, 195057, 195058, 195059, 195060, 195061, 195062, 195063, 195064, 195065, 195066, 195067, 195068, 195069, 195070, 195071, 195072, 195073, 195074, 195075, 195076, 195077, 195078, 195079, 195080, 195081, 195082, 195083, 195084, 195085, 195086, 195087, 195088, 195089, 195090, 195091, 195092, 195093, 195094, 195095, 195096, 195097, 195098, 195099, 195100, 195101];
const _M0FP410tonyfettes7unicode8internal3ucd20decomp__data__starts = [0, 1, 3, 4, 6, 7, 8, 10, 11, 13, 14, 15, 18, 21, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 62, 64, 66, 68, 70, 72, 74, 76, 78, 80, 82, 84, 86, 88, 90, 92, 94, 96, 98, 100, 102, 104, 106, 108, 110, 112, 114, 116, 118, 120, 122, 124, 126, 128, 130, 132, 134, 136, 138, 140, 142, 144, 146, 148, 150, 152, 154, 156, 158, 160, 162, 164, 166, 168, 170, 172, 174, 176, 178, 180, 182, 184, 186, 188, 190, 192, 194, 196, 198, 200, 202, 204, 206, 208, 210, 212, 214, 216, 218, 220, 222, 224, 226, 228, 230, 232, 234, 236, 238, 240, 242, 244, 246, 248, 250, 252, 254, 256, 258, 260, 262, 264, 266, 268, 270, 272, 274, 276, 278, 280, 282, 284, 286, 288, 290, 292, 294, 296, 298, 300, 302, 304, 306, 308, 310, 312, 314, 316, 318, 320, 322, 324, 326, 328, 330, 332, 334, 336, 338, 340, 342, 344, 346, 348, 350, 352, 354, 356, 357, 359, 361, 363, 365, 367, 369, 371, 373, 375, 377, 379, 381, 383, 385, 387, 389, 391, 393, 395, 397, 399, 401, 403, 405, 407, 409, 411, 413, 415, 417, 419, 421, 423, 425, 427, 429, 431, 433, 435, 437, 439, 441, 443, 445, 447, 449, 451, 453, 455, 457, 459, 461, 463, 465, 467, 469, 471, 473, 475, 477, 479, 481, 483, 485, 487, 489, 491, 493, 495, 497, 499, 501, 503, 505, 507, 509, 511, 513, 515, 517, 519, 521, 523, 525, 527, 529, 531, 533, 535, 537, 539, 541, 543, 545, 547, 549, 551, 553, 555, 557, 559, 561, 563, 564, 565, 566, 567, 568, 569, 570, 571, 572, 574, 576, 578, 580, 582, 584, 585, 586, 587, 588, 589, 590, 591, 592, 594, 595, 597, 598, 600, 602, 604, 605, 607, 609, 611, 613, 615, 617, 619, 621, 623, 625, 627, 629, 631, 633, 635, 637, 639, 641, 643, 644, 645, 646, 648, 650, 651, 652, 653, 654, 655, 656, 657, 658, 660, 662, 664, 666, 668, 670, 672, 674, 676, 678, 680, 682, 684, 686, 688, 690, 692, 694, 696, 698, 700, 702, 704, 706, 708, 710, 712, 714, 716, 718, 720, 722, 724, 726, 728, 730, 732, 734, 736, 738, 740, 742, 744, 746, 748, 750, 752, 754, 756, 758, 760, 762, 764, 766, 768, 770, 772, 774, 776, 778, 780, 782, 784, 786, 788, 790, 792, 794, 796, 798, 800, 802, 804, 806, 808, 810, 812, 814, 816, 818, 820, 822, 824, 826, 828, 830, 832, 834, 836, 838, 840, 842, 844, 846, 848, 850, 852, 854, 856, 858, 860, 862, 864, 866, 868, 870, 872, 874, 876, 878, 880, 882, 884, 885, 887, 889, 891, 893, 895, 897, 899, 901, 903, 905, 907, 909, 911, 913, 915, 917, 919, 921, 923, 925, 926, 928, 930, 932, 934, 936, 938, 940, 942, 944, 946, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 975, 976, 977, 978, 979, 980, 981, 982, 983, 984, 985, 986, 987, 988, 989, 990, 991, 992, 993, 994, 995, 996, 997, 998, 999, 1000, 1001, 1002, 1003, 1004, 1005, 1006, 1007, 1008, 1009, 1010, 1011, 1012, 1013, 1014, 1015, 1016, 1017, 1018, 1019, 1020, 1021, 1022, 1023, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1048, 1050, 1052, 1054, 1056, 1058, 1060, 1062, 1064, 1066, 1068, 1070, 1072, 1074, 1076, 1078, 1080, 1082, 1084, 1086, 1088, 1090, 1092, 1094, 1096, 1098, 1100, 1102, 1104, 1106, 1108, 1110, 1112, 1114, 1116, 1118, 1120, 1122, 1124, 1126, 1128, 1130, 1132, 1134, 1136, 1138, 1140, 1142, 1144, 1146, 1148, 1150, 1152, 1154, 1156, 1158, 1160, 1162, 1164, 1166, 1168, 1170, 1172, 1174, 1176, 1178, 1180, 1182, 1184, 1186, 1188, 1190, 1192, 1194, 1196, 1198, 1200, 1202, 1204, 1206, 1208, 1210, 1212, 1214, 1216, 1218, 1220, 1222, 1224, 1226, 1228, 1230, 1232, 1234, 1236, 1238, 1240, 1242, 1244, 1246, 1248, 1250, 1252, 1254, 1256, 1258, 1260, 1262, 1264, 1266, 1268, 1270, 1272, 1274, 1276, 1278, 1280, 1282, 1284, 1286, 1288, 1290, 1292, 1294, 1296, 1298, 1300, 1302, 1304, 1306, 1308, 1310, 1312, 1314, 1316, 1318, 1320, 1322, 1324, 1326, 1328, 1330, 1332, 1334, 1336, 1338, 1340, 1342, 1344, 1346, 1348, 1350, 1352, 1354, 1356, 1358, 1360, 1362, 1364, 1366, 1368, 1370, 1372, 1374, 1376, 1378, 1380, 1382, 1384, 1386, 1388, 1390, 1392, 1394, 1396, 1398, 1400, 1402, 1404, 1406, 1408, 1410, 1412, 1414, 1416, 1418, 1420, 1422, 1424, 1426, 1428, 1430, 1432, 1434, 1436, 1438, 1440, 1442, 1444, 1446, 1448, 1450, 1452, 1454, 1456, 1458, 1460, 1462, 1464, 1466, 1468, 1470, 1472, 1474, 1476, 1478, 1480, 1482, 1484, 1486, 1488, 1490, 1492, 1494, 1496, 1498, 1500, 1502, 1504, 1506, 1508, 1510, 1512, 1514, 1516, 1518, 1520, 1522, 1524, 1526, 1528, 1530, 1532, 1534, 1536, 1538, 1540, 1542, 1544, 1546, 1548, 1550, 1552, 1554, 1556, 1558, 1560, 1562, 1564, 1566, 1568, 1570, 1572, 1574, 1576, 1578, 1580, 1582, 1584, 1586, 1588, 1590, 1592, 1594, 1596, 1598, 1600, 1602, 1604, 1606, 1608, 1610, 1612, 1614, 1616, 1618, 1620, 1622, 1624, 1626, 1628, 1630, 1632, 1634, 1636, 1638, 1640, 1642, 1644, 1646, 1648, 1650, 1652, 1654, 1656, 1658, 1660, 1662, 1664, 1666, 1668, 1670, 1672, 1674, 1676, 1678, 1680, 1682, 1684, 1686, 1688, 1690, 1692, 1694, 1696, 1698, 1700, 1702, 1704, 1706, 1708, 1710, 1712, 1714, 1716, 1718, 1720, 1722, 1724, 1726, 1728, 1730, 1732, 1734, 1736, 1738, 1740, 1741, 1743, 1744, 1746, 1747, 1749, 1750, 1752, 1753, 1755, 1756, 1758, 1759, 1761, 1763, 1765, 1767, 1769, 1771, 1773, 1775, 1777, 1779, 1781, 1783, 1785, 1787, 1789, 1791, 1793, 1795, 1797, 1799, 1801, 1803, 1805, 1807, 1809, 1811, 1813, 1815, 1817, 1819, 1821, 1823, 1825, 1827, 1829, 1831, 1833, 1835, 1837, 1839, 1841, 1843, 1845, 1847, 1849, 1851, 1853, 1855, 1857, 1859, 1861, 1863, 1865, 1867, 1869, 1871, 1873, 1875, 1876, 1878, 1880, 1881, 1883, 1885, 1887, 1889, 1891, 1893, 1895, 1897, 1899, 1900, 1902, 1903, 1905, 1907, 1909, 1911, 1913, 1915, 1917, 1918, 1920, 1922, 1924, 1926, 1928, 1929, 1931, 1933, 1935, 1937, 1939, 1941, 1942, 1944, 1946, 1948, 1950, 1952, 1954, 1956, 1957, 1959, 1961, 1962, 1963, 1965, 1967, 1969, 1971, 1973, 1975, 1976, 1978, 1979, 1981, 1982, 1984, 1985, 1986, 1987, 1988, 1989, 1990, 1991, 1992, 1993, 1994, 1995, 1996, 1998, 1999, 2001, 2004, 2005, 2007, 2010, 2012, 2015, 2017, 2019, 2021, 2023, 2025, 2029, 2030, 2031, 2032, 2033, 2034, 2035, 2036, 2037, 2038, 2039, 2040, 2041, 2042, 2043, 2044, 2045, 2046, 2047, 2048, 2049, 2050, 2051, 2052, 2053, 2054, 2055, 2056, 2057, 2058, 2059, 2060, 2061, 2062, 2063, 2064, 2065, 2066, 2067, 2068, 2069, 2070, 2071, 2072, 2074, 2077, 2080, 2081, 2083, 2086, 2089, 2090, 2092, 2093, 2094, 2095, 2096, 2097, 2098, 2099, 2100, 2101, 2102, 2103, 2105, 2106, 2107, 2108, 2109, 2110, 2112, 2115, 2117, 2118, 2119, 2120, 2121, 2122, 2123, 2124, 2125, 2126, 2127, 2128, 2129, 2130, 2131, 2132, 2133, 2134, 2137, 2138, 2139, 2140, 2141, 2142, 2143, 2144, 2145, 2146, 2147, 2150, 2153, 2157, 2160, 2163, 2166, 2169, 2172, 2175, 2178, 2181, 2184, 2187, 2190, 2193, 2195, 2196, 2198, 2201, 2203, 2204, 2206, 2209, 2213, 2215, 2216, 2218, 2221, 2222, 2223, 2224, 2225, 2226, 2228, 2231, 2233, 2234, 2236, 2239, 2243, 2245, 2246, 2248, 2251, 2252, 2253, 2254, 2255, 2258, 2260, 2262, 2264, 2266, 2268, 2270, 2272, 2274, 2276, 2278, 2280, 2282, 2285, 2287, 2290, 2292, 2294, 2296, 2298, 2300, 2302, 2304, 2306, 2308, 2310, 2312, 2314, 2316, 2318, 2320, 2322, 2324, 2326, 2328, 2330, 2332, 2334, 2336, 2338, 2340, 2342, 2344, 2346, 2348, 2350, 2352, 2354, 2356, 2357, 2358, 2359, 2360, 2361, 2362, 2363, 2364, 2365, 2366, 2367, 2369, 2371, 2373, 2375, 2377, 2379, 2381, 2383, 2385, 2387, 2389, 2392, 2395, 2398, 2401, 2404, 2407, 2410, 2413, 2416, 2420, 2424, 2428, 2432, 2436, 2440, 2444, 2448, 2452, 2456, 2460, 2462, 2464, 2466, 2468, 2470, 2472, 2474, 2476, 2478, 2481, 2484, 2487, 2490, 2493, 2496, 2499, 2502, 2505, 2508, 2511, 2514, 2517, 2520, 2523, 2526, 2529, 2532, 2535, 2538, 2541, 2544, 2547, 2550, 2553, 2556, 2559, 2562, 2565, 2568, 2571, 2574, 2577, 2580, 2583, 2586, 2589, 2590, 2591, 2592, 2593, 2594, 2595, 2596, 2597, 2598, 2599, 2600, 2601, 2602, 2603, 2604, 2605, 2606, 2607, 2608, 2609, 2610, 2611, 2612, 2613, 2614, 2615, 2616, 2617, 2618, 2619, 2620, 2621, 2622, 2623, 2624, 2625, 2626, 2627, 2628, 2629, 2630, 2631, 2632, 2633, 2634, 2635, 2636, 2637, 2638, 2639, 2640, 2641, 2642, 2646, 2649, 2651, 2654, 2656, 2657, 2658, 2659, 2660, 2661, 2662, 2663, 2664, 2665, 2666, 2667, 2668, 2669, 2670, 2671, 2672, 2673, 2674, 2675, 2676, 2677, 2678, 2679, 2680, 2681, 2682, 2683, 2684, 2685, 2686, 2687, 2688, 2689, 2690, 2691, 2692, 2693, 2694, 2695, 2696, 2697, 2698, 2699, 2700, 2701, 2702, 2703, 2704, 2705, 2706, 2707, 2708, 2709, 2710, 2711, 2712, 2713, 2714, 2715, 2716, 2717, 2718, 2719, 2720, 2721, 2722, 2723, 2724, 2725, 2726, 2727, 2728, 2729, 2730, 2731, 2732, 2733, 2734, 2735, 2736, 2737, 2738, 2739, 2740, 2741, 2742, 2743, 2744, 2745, 2746, 2747, 2748, 2749, 2750, 2751, 2752, 2753, 2754, 2755, 2756, 2757, 2758, 2759, 2760, 2761, 2762, 2763, 2764, 2765, 2766, 2767, 2768, 2769, 2770, 2771, 2772, 2773, 2774, 2775, 2776, 2777, 2778, 2779, 2780, 2781, 2782, 2783, 2784, 2785, 2786, 2787, 2788, 2789, 2790, 2791, 2792, 2793, 2794, 2795, 2796, 2797, 2798, 2799, 2800, 2801, 2802, 2803, 2804, 2805, 2806, 2807, 2808, 2809, 2810, 2811, 2812, 2813, 2814, 2815, 2816, 2817, 2818, 2819, 2820, 2821, 2822, 2823, 2824, 2825, 2826, 2827, 2828, 2829, 2830, 2831, 2832, 2833, 2834, 2835, 2836, 2837, 2838, 2839, 2840, 2841, 2842, 2843, 2844, 2845, 2846, 2847, 2848, 2849, 2850, 2851, 2852, 2853, 2854, 2855, 2856, 2857, 2858, 2859, 2860, 2861, 2862, 2863, 2864, 2865, 2866, 2867, 2868, 2869, 2870, 2871, 2872, 2873, 2874, 2875, 2876, 2877, 2878, 2879, 2880, 2882, 2884, 2886, 2888, 2890, 2892, 2894, 2896, 2898, 2900, 2902, 2904, 2906, 2908, 2910, 2912, 2914, 2916, 2918, 2920, 2922, 2924, 2926, 2928, 2930, 2932, 2934, 2936, 2938, 2940, 2942, 2944, 2946, 2948, 2950, 2952, 2954, 2956, 2958, 2960, 2962, 2964, 2966, 2968, 2970, 2972, 2974, 2976, 2978, 2980, 2982, 2984, 2986, 2988, 2990, 2992, 2994, 2996, 2998, 3000, 3002, 3004, 3005, 3006, 3007, 3008, 3009, 3010, 3011, 3012, 3013, 3014, 3015, 3016, 3017, 3018, 3019, 3020, 3021, 3022, 3023, 3024, 3025, 3026, 3027, 3028, 3029, 3030, 3031, 3032, 3033, 3034, 3035, 3036, 3037, 3038, 3039, 3040, 3041, 3042, 3043, 3044, 3045, 3046, 3047, 3048, 3049, 3050, 3051, 3052, 3053, 3054, 3055, 3056, 3057, 3058, 3059, 3060, 3061, 3062, 3063, 3064, 3065, 3066, 3067, 3068, 3069, 3070, 3071, 3072, 3073, 3074, 3075, 3076, 3077, 3078, 3079, 3080, 3081, 3082, 3083, 3084, 3085, 3086, 3087, 3088, 3089, 3090, 3091, 3092, 3093, 3094, 3095, 3096, 3097, 3098, 3099, 3100, 3101, 3102, 3103, 3104, 3105, 3106, 3107, 3108, 3109, 3110, 3111, 3112, 3115, 3118, 3121, 3124, 3127, 3130, 3133, 3136, 3139, 3142, 3145, 3148, 3151, 3154, 3158, 3162, 3166, 3170, 3174, 3178, 3182, 3186, 3190, 3194, 3198, 3202, 3206, 3210, 3214, 3221, 3227, 3230, 3233, 3236, 3239, 3242, 3245, 3248, 3251, 3254, 3257, 3260, 3263, 3266, 3269, 3272, 3275, 3278, 3281, 3284, 3287, 3290, 3293, 3296, 3299, 3302, 3305, 3308, 3311, 3314, 3317, 3320, 3323, 3326, 3329, 3332, 3335, 3336, 3337, 3338, 3339, 3342, 3344, 3346, 3348, 3350, 3352, 3354, 3356, 3358, 3360, 3362, 3364, 3366, 3368, 3370, 3372, 3373, 3374, 3375, 3376, 3377, 3378, 3379, 3380, 3381, 3382, 3383, 3384, 3385, 3386, 3388, 3390, 3392, 3394, 3396, 3398, 3400, 3402, 3404, 3406, 3408, 3410, 3412, 3414, 3419, 3423, 3425, 3426, 3427, 3428, 3429, 3430, 3431, 3432, 3433, 3434, 3435, 3436, 3437, 3438, 3439, 3440, 3441, 3442, 3443, 3444, 3445, 3446, 3447, 3448, 3449, 3450, 3451, 3452, 3453, 3454, 3455, 3456, 3457, 3458, 3459, 3460, 3461, 3462, 3463, 3464, 3465, 3466, 3467, 3468, 3469, 3470, 3471, 3472, 3473, 3474, 3476, 3478, 3480, 3482, 3484, 3486, 3488, 3490, 3492, 3494, 3496, 3498, 3500, 3502, 3504, 3506, 3508, 3510, 3512, 3514, 3516, 3518, 3520, 3522, 3525, 3528, 3531, 3533, 3536, 3538, 3541, 3542, 3543, 3544, 3545, 3546, 3547, 3548, 3549, 3550, 3551, 3552, 3553, 3554, 3555, 3556, 3557, 3558, 3559, 3560, 3561, 3562, 3563, 3564, 3565, 3566, 3567, 3568, 3569, 3570, 3571, 3572, 3573, 3574, 3575, 3576, 3577, 3578, 3579, 3580, 3581, 3582, 3583, 3584, 3585, 3586, 3587, 3588, 3590, 3594, 3598, 3602, 3605, 3609, 3612, 3615, 3620, 3624, 3627, 3630, 3633, 3637, 3641, 3644, 3647, 3649, 3652, 3656, 3660, 3662, 3667, 3673, 3678, 3681, 3686, 3691, 3695, 3698, 3701, 3704, 3708, 3713, 3717, 3720, 3723, 3726, 3728, 3730, 3732, 3734, 3737, 3740, 3745, 3748, 3752, 3757, 3760, 3762, 3764, 3769, 3773, 3778, 3781, 3786, 3788, 3791, 3794, 3797, 3800, 3803, 3807, 3810, 3812, 3815, 3818, 3821, 3825, 3828, 3831, 3834, 3839, 3843, 3845, 3850, 3852, 3856, 3860, 3863, 3866, 3869, 3873, 3875, 3878, 3882, 3884, 3889, 3892, 3894, 3896, 3898, 3900, 3902, 3904, 3906, 3908, 3910, 3912, 3915, 3918, 3921, 3924, 3927, 3930, 3933, 3936, 3939, 3942, 3945, 3948, 3951, 3954, 3957, 3960, 3962, 3964, 3967, 3969, 3971, 3973, 3976, 3979, 3981, 3983, 3985, 3987, 3989, 3993, 3995, 3997, 3999, 4001, 4003, 4005, 4007, 4009, 4012, 4016, 4018, 4020, 4022, 4024, 4026, 4028, 4030, 4033, 4036, 4039, 4042, 4044, 4046, 4048, 4050, 4052, 4054, 4056, 4058, 4060, 4062, 4065, 4068, 4070, 4073, 4076, 4079, 4081, 4084, 4087, 4091, 4093, 4096, 4099, 4102, 4105, 4110, 4116, 4118, 4120, 4122, 4124, 4126, 4128, 4130, 4132, 4134, 4136, 4138, 4140, 4142, 4144, 4146, 4148, 4150, 4152, 4156, 4158, 4160, 4162, 4166, 4169, 4171, 4173, 4175, 4177, 4179, 4181, 4183, 4185, 4187, 4189, 4192, 4194, 4196, 4199, 4202, 4204, 4208, 4211, 4213, 4215, 4217, 4219, 4222, 4225, 4227, 4229, 4231, 4233, 4235, 4237, 4239, 4241, 4243, 4246, 4249, 4252, 4255, 4258, 4261, 4264, 4267, 4270, 4273, 4276, 4279, 4282, 4285, 4288, 4291, 4294, 4297, 4300, 4303, 4306, 4309, 4312, 4313, 4314, 4315, 4316, 4317, 4318, 4319, 4320, 4321, 4322, 4323, 4324, 4325, 4326, 4327, 4328, 4329, 4330, 4331, 4332, 4333, 4334, 4335, 4336, 4337, 4338, 4339, 4340, 4341, 4342, 4343, 4344, 4345, 4346, 4347, 4348, 4349, 4350, 4351, 4352, 4353, 4354, 4355, 4356, 4357, 4358, 4359, 4360, 4361, 4362, 4363, 4364, 4365, 4366, 4367, 4368, 4369, 4370, 4371, 4372, 4373, 4374, 4375, 4376, 4377, 4378, 4379, 4380, 4381, 4382, 4383, 4384, 4385, 4386, 4387, 4388, 4389, 4390, 4391, 4392, 4393, 4394, 4395, 4396, 4397, 4398, 4399, 4400, 4401, 4402, 4403, 4404, 4405, 4406, 4407, 4408, 4409, 4410, 4411, 4412, 4413, 4414, 4415, 4416, 4417, 4418, 4419, 4420, 4421, 4422, 4423, 4424, 4425, 4426, 4427, 4428, 4429, 4430, 4431, 4432, 4433, 4434, 4435, 4436, 4437, 4438, 4439, 4440, 4441, 4442, 4443, 4444, 4445, 4446, 4447, 4448, 4449, 4450, 4451, 4452, 4453, 4454, 4455, 4456, 4457, 4458, 4459, 4460, 4461, 4462, 4463, 4464, 4465, 4466, 4467, 4468, 4469, 4470, 4471, 4472, 4473, 4474, 4475, 4476, 4477, 4478, 4479, 4480, 4481, 4482, 4483, 4484, 4485, 4486, 4487, 4488, 4489, 4490, 4491, 4492, 4493, 4494, 4495, 4496, 4497, 4498, 4499, 4500, 4501, 4502, 4503, 4504, 4505, 4506, 4507, 4508, 4509, 4510, 4511, 4512, 4513, 4514, 4515, 4516, 4517, 4518, 4519, 4520, 4521, 4522, 4523, 4524, 4525, 4526, 4527, 4528, 4529, 4530, 4531, 4532, 4533, 4534, 4535, 4536, 4537, 4538, 4539, 4540, 4541, 4542, 4543, 4544, 4545, 4546, 4547, 4548, 4549, 4550, 4551, 4552, 4553, 4554, 4555, 4556, 4557, 4558, 4559, 4560, 4561, 4562, 4563, 4564, 4565, 4566, 4567, 4568, 4569, 4570, 4571, 4572, 4573, 4574, 4575, 4576, 4577, 4578, 4579, 4580, 4581, 4582, 4583, 4584, 4585, 4586, 4587, 4588, 4589, 4590, 4591, 4592, 4593, 4594, 4595, 4596, 4597, 4598, 4599, 4600, 4601, 4602, 4603, 4604, 4605, 4606, 4607, 4608, 4609, 4610, 4611, 4612, 4613, 4614, 4615, 4616, 4617, 4618, 4619, 4620, 4621, 4622, 4623, 4624, 4625, 4626, 4627, 4628, 4629, 4630, 4631, 4632, 4633, 4634, 4635, 4636, 4637, 4638, 4639, 4640, 4641, 4642, 4643, 4644, 4645, 4646, 4647, 4648, 4649, 4650, 4651, 4652, 4653, 4654, 4655, 4656, 4657, 4658, 4659, 4660, 4661, 4662, 4663, 4664, 4665, 4666, 4667, 4668, 4669, 4670, 4671, 4672, 4673, 4674, 4675, 4676, 4677, 4678, 4679, 4680, 4681, 4682, 4683, 4684, 4685, 4686, 4687, 4688, 4689, 4690, 4691, 4692, 4693, 4694, 4695, 4696, 4697, 4698, 4699, 4700, 4701, 4702, 4703, 4704, 4705, 4706, 4707, 4708, 4709, 4710, 4711, 4712, 4713, 4714, 4715, 4716, 4717, 4718, 4719, 4720, 4721, 4722, 4723, 4724, 4725, 4726, 4727, 4728, 4729, 4730, 4731, 4732, 4733, 4734, 4735, 4736, 4737, 4738, 4739, 4740, 4741, 4742, 4743, 4744, 4745, 4746, 4747, 4748, 4749, 4750, 4751, 4752, 4753, 4754, 4755, 4756, 4757, 4758, 4759, 4760, 4761, 4762, 4763, 4764, 4765, 4766, 4767, 4768, 4769, 4770, 4771, 4772, 4773, 4774, 4775, 4776, 4777, 4778, 4779, 4780, 4781, 4782, 4783, 4784, 4785, 4787, 4789, 4791, 4794, 4797, 4799, 4801, 4803, 4805, 4807, 4809, 4811, 4813, 4815, 4816, 4817, 4818, 4819, 4820, 4821, 4822, 4823, 4824, 4825, 4827, 4829, 4831, 4833, 4835, 4837, 4839, 4841, 4843, 4845, 4847, 4849, 4851, 4853, 4855, 4857, 4859, 4861, 4863, 4865, 4867, 4869, 4871, 4873, 4875, 4877, 4879, 4881, 4883, 4885, 4887, 4889, 4891, 4892, 4893, 4894, 4895, 4896, 4897, 4898, 4899, 4900, 4901, 4902, 4903, 4904, 4905, 4906, 4907, 4908, 4909, 4910, 4911, 4912, 4913, 4914, 4915, 4916, 4917, 4918, 4919, 4920, 4921, 4922, 4923, 4924, 4925, 4926, 4927, 4928, 4929, 4930, 4931, 4932, 4933, 4934, 4935, 4936, 4937, 4938, 4939, 4940, 4941, 4942, 4943, 4944, 4945, 4946, 4947, 4948, 4949, 4950, 4951, 4952, 4953, 4954, 4955, 4956, 4957, 4958, 4959, 4960, 4961, 4962, 4963, 4964, 4965, 4966, 4967, 4968, 4969, 4970, 4971, 4972, 4973, 4974, 4975, 4976, 4977, 4978, 4979, 4980, 4981, 4982, 4983, 4984, 4985, 4986, 4987, 4988, 4989, 4990, 4991, 4992, 4993, 4994, 4995, 4996, 4997, 4998, 4999, 5000, 5001, 5002, 5003, 5004, 5005, 5006, 5007, 5008, 5009, 5010, 5011, 5012, 5014, 5016, 5018, 5020, 5022, 5024, 5026, 5028, 5030, 5032, 5034, 5036, 5038, 5040, 5042, 5044, 5046, 5048, 5049, 5050, 5051, 5052, 5054, 5056, 5058, 5060, 5062, 5064, 5066, 5068, 5070, 5072, 5074, 5076, 5078, 5080, 5082, 5084, 5086, 5088, 5090, 5092, 5094, 5096, 5098, 5100, 5102, 5104, 5106, 5108, 5110, 5112, 5114, 5116, 5118, 5120, 5122, 5124, 5126, 5128, 5130, 5132, 5134, 5136, 5138, 5140, 5142, 5144, 5146, 5148, 5150, 5152, 5154, 5156, 5158, 5160, 5162, 5164, 5166, 5168, 5170, 5172, 5174, 5176, 5178, 5180, 5182, 5184, 5186, 5188, 5190, 5192, 5194, 5196, 5198, 5200, 5202, 5204, 5206, 5208, 5210, 5212, 5214, 5216, 5218, 5220, 5222, 5224, 5226, 5228, 5230, 5232, 5234, 5236, 5238, 5240, 5243, 5246, 5249, 5252, 5255, 5258, 5260, 5262, 5264, 5266, 5268, 5270, 5272, 5274, 5276, 5278, 5280, 5282, 5284, 5286, 5288, 5290, 5292, 5294, 5296, 5298, 5300, 5302, 5304, 5306, 5308, 5310, 5312, 5314, 5316, 5318, 5320, 5322, 5324, 5326, 5328, 5330, 5332, 5334, 5336, 5338, 5340, 5342, 5344, 5346, 5348, 5350, 5352, 5354, 5356, 5358, 5360, 5362, 5364, 5366, 5368, 5370, 5372, 5374, 5376, 5378, 5380, 5382, 5384, 5386, 5388, 5390, 5392, 5394, 5396, 5398, 5400, 5402, 5404, 5406, 5408, 5410, 5412, 5414, 5416, 5418, 5420, 5422, 5424, 5426, 5428, 5430, 5432, 5434, 5436, 5438, 5440, 5442, 5444, 5446, 5448, 5450, 5452, 5454, 5456, 5458, 5460, 5462, 5464, 5466, 5468, 5470, 5472, 5474, 5476, 5478, 5480, 5482, 5484, 5486, 5488, 5490, 5492, 5494, 5496, 5498, 5500, 5502, 5504, 5506, 5508, 5510, 5512, 5514, 5516, 5518, 5520, 5522, 5524, 5526, 5528, 5530, 5532, 5534, 5536, 5538, 5540, 5542, 5545, 5548, 5551, 5553, 5555, 5557, 5559, 5561, 5563, 5565, 5567, 5569, 5571, 5573, 5575, 5577, 5579, 5581, 5583, 5585, 5587, 5589, 5591, 5593, 5595, 5597, 5599, 5601, 5603, 5605, 5607, 5609, 5611, 5613, 5615, 5617, 5619, 5621, 5623, 5625, 5627, 5629, 5631, 5633, 5635, 5637, 5639, 5641, 5643, 5645, 5647, 5649, 5651, 5653, 5655, 5657, 5659, 5661, 5663, 5665, 5667, 5669, 5671, 5673, 5675, 5677, 5679, 5681, 5683, 5685, 5687, 5689, 5691, 5693, 5695, 5697, 5700, 5703, 5706, 5709, 5712, 5715, 5718, 5721, 5724, 5727, 5730, 5733, 5736, 5739, 5742, 5745, 5748, 5751, 5754, 5757, 5760, 5763, 5766, 5769, 5772, 5775, 5778, 5781, 5784, 5787, 5790, 5793, 5796, 5799, 5802, 5805, 5808, 5811, 5814, 5817, 5820, 5823, 5826, 5829, 5832, 5835, 5838, 5841, 5844, 5847, 5850, 5853, 5856, 5859, 5862, 5865, 5868, 5871, 5874, 5877, 5880, 5883, 5886, 5889, 5892, 5895, 5898, 5901, 5904, 5907, 5910, 5913, 5916, 5919, 5922, 5925, 5928, 5931, 5934, 5937, 5940, 5943, 5946, 5949, 5952, 5955, 5958, 5961, 5964, 5967, 5970, 5973, 5976, 5979, 5982, 5985, 5988, 5991, 5994, 5997, 6000, 6003, 6006, 6009, 6012, 6015, 6018, 6021, 6024, 6027, 6030, 6033, 6036, 6039, 6042, 6045, 6048, 6051, 6054, 6057, 6061, 6065, 6069, 6073, 6077, 6081, 6085, 6088, 6106, 6114, 6118, 6119, 6120, 6121, 6122, 6123, 6124, 6125, 6126, 6127, 6128, 6129, 6130, 6131, 6132, 6133, 6134, 6135, 6136, 6137, 6138, 6139, 6140, 6141, 6142, 6143, 6144, 6145, 6146, 6147, 6148, 6149, 6150, 6151, 6152, 6153, 6154, 6155, 6156, 6157, 6158, 6159, 6160, 6161, 6162, 6163, 6164, 6165, 6166, 6167, 6168, 6169, 6170, 6171, 6172, 6173, 6174, 6175, 6176, 6177, 6178, 6179, 6180, 6181, 6182, 6183, 6184, 6186, 6188, 6190, 6192, 6194, 6196, 6198, 6200, 6202, 6204, 6206, 6208, 6210, 6212, 6213, 6214, 6215, 6216, 6217, 6218, 6219, 6220, 6221, 6222, 6223, 6224, 6225, 6226, 6227, 6228, 6229, 6230, 6231, 6232, 6233, 6234, 6235, 6236, 6237, 6238, 6239, 6240, 6241, 6242, 6243, 6244, 6245, 6246, 6247, 6248, 6249, 6250, 6251, 6252, 6253, 6254, 6255, 6256, 6257, 6258, 6259, 6260, 6261, 6262, 6263, 6264, 6265, 6266, 6267, 6268, 6269, 6270, 6271, 6272, 6273, 6274, 6275, 6276, 6277, 6278, 6279, 6280, 6281, 6282, 6283, 6284, 6285, 6286, 6287, 6288, 6289, 6290, 6291, 6292, 6293, 6294, 6295, 6296, 6297, 6298, 6299, 6300, 6301, 6302, 6303, 6304, 6305, 6306, 6307, 6308, 6309, 6310, 6311, 6312, 6313, 6314, 6315, 6316, 6317, 6318, 6319, 6320, 6321, 6322, 6323, 6324, 6325, 6326, 6327, 6328, 6329, 6331, 6333, 6335, 6337, 6339, 6341, 6343, 6345, 6346, 6347, 6348, 6349, 6350, 6351, 6352, 6353, 6354, 6355, 6356, 6357, 6358, 6359, 6360, 6361, 6362, 6363, 6364, 6365, 6366, 6367, 6368, 6369, 6370, 6371, 6372, 6373, 6374, 6375, 6376, 6377, 6378, 6379, 6380, 6381, 6382, 6383, 6384, 6385, 6386, 6387, 6388, 6389, 6390, 6391, 6392, 6393, 6394, 6395, 6396, 6397, 6398, 6399, 6400, 6401, 6402, 6403, 6404, 6405, 6406, 6407, 6408, 6409, 6410, 6411, 6412, 6413, 6414, 6415, 6416, 6417, 6418, 6419, 6420, 6421, 6422, 6423, 6424, 6425, 6426, 6427, 6428, 6429, 6430, 6431, 6432, 6433, 6434, 6435, 6436, 6437, 6438, 6439, 6440, 6441, 6442, 6443, 6444, 6445, 6446, 6447, 6448, 6449, 6450, 6451, 6452, 6453, 6454, 6455, 6456, 6457, 6458, 6459, 6460, 6461, 6462, 6463, 6464, 6465, 6466, 6467, 6468, 6469, 6470, 6471, 6472, 6473, 6474, 6475, 6476, 6477, 6478, 6479, 6480, 6481, 6482, 6483, 6484, 6485, 6486, 6487, 6488, 6489, 6490, 6491, 6492, 6493, 6494, 6495, 6496, 6497, 6498, 6499, 6500, 6501, 6502, 6503, 6504, 6505, 6506, 6507, 6508, 6509, 6510, 6511, 6512, 6513, 6514, 6515, 6516, 6517, 6518, 6519, 6520, 6521, 6522, 6523, 6524, 6525, 6526, 6527, 6528, 6529, 6530, 6531, 6532, 6533, 6534, 6535, 6536, 6537, 6538, 6539, 6540, 6541, 6542, 6543, 6544, 6545, 6546, 6547, 6548, 6549, 6550, 6551, 6552, 6553, 6554, 6555, 6556, 6557, 6558, 6559, 6560, 6561, 6562, 6563, 6564, 6565, 6566, 6567, 6568, 6569, 6570, 6572, 6574, 6575, 6576, 6577, 6578, 6579, 6580, 6581, 6582, 6583, 6584, 6585, 6586, 6587, 6588, 6589, 6590, 6591, 6592, 6593, 6594, 6595, 6596, 6597, 6598, 6599, 6600, 6601, 6602, 6603, 6604, 6605, 6606, 6607, 6608, 6609, 6610, 6611, 6612, 6613, 6614, 6615, 6616, 6617, 6618, 6619, 6620, 6621, 6622, 6623, 6624, 6625, 6626, 6627, 6628, 6629, 6630, 6632, 6634, 6636, 6638, 6640, 6642, 6644, 6646, 6648, 6650, 6652, 6654, 6656, 6658, 6660, 6662, 6664, 6666, 6668, 6670, 6672, 6674, 6676, 6678, 6680, 6682, 6684, 6686, 6688, 6690, 6692, 6693, 6694, 6695, 6696, 6697, 6698, 6699, 6700, 6701, 6702, 6703, 6704, 6705, 6706, 6707, 6708, 6709, 6710, 6711, 6712, 6713, 6714, 6715, 6716, 6717, 6718, 6719, 6720, 6721, 6722, 6723, 6724, 6725, 6726, 6727, 6728, 6730, 6732, 6734, 6736, 6738, 6740, 6742, 6744, 6746, 6748, 6750, 6752, 6754, 6755, 6756, 6757, 6758, 6759, 6760, 6761, 6762, 6763, 6764, 6765, 6766, 6767, 6768, 6769, 6770, 6771, 6772, 6773, 6774, 6775, 6776, 6777, 6778, 6779, 6780, 6781, 6782, 6783, 6784, 6785, 6786, 6787, 6788, 6789, 6790, 6791, 6792, 6793, 6794, 6795, 6796, 6797, 6798, 6799, 6800, 6801, 6802, 6803, 6804, 6805, 6806, 6807, 6808, 6809, 6810, 6811, 6812, 6813, 6814, 6815, 6816, 6817, 6818, 6819, 6820, 6821, 6822, 6823, 6824, 6825, 6826, 6827, 6828, 6829, 6830, 6831, 6832, 6833, 6834, 6835, 6836, 6837, 6838, 6839, 6840, 6841, 6842, 6843, 6844, 6845, 6846, 6847, 6848, 6849, 6850, 6851, 6852, 6853, 6854, 6855, 6856, 6857, 6858, 6859, 6860, 6861, 6862, 6863, 6864, 6865, 6866, 6867, 6868, 6869, 6870, 6871, 6872, 6873, 6874, 6875, 6876, 6877, 6878, 6879, 6880, 6881, 6882, 6883, 6884, 6885, 6886, 6887, 6888, 6889, 6890, 6891, 6892, 6893, 6894, 6895, 6896, 6897, 6898, 6899, 6900, 6901, 6902, 6903, 6904, 6905, 6906, 6907, 6908, 6909, 6910, 6911, 6912, 6913, 6914, 6915, 6916, 6917, 6918, 6919, 6920, 6921, 6922, 6923, 6924, 6925, 6926, 6927, 6928, 6929, 6930, 6931, 6932, 6933, 6934, 6935, 6936, 6937, 6938, 6939, 6940, 6941, 6942, 6943, 6944, 6945, 6946, 6947, 6948, 6949, 6950, 6951, 6952, 6953, 6954, 6955, 6956, 6957, 6958, 6959, 6960, 6961, 6962, 6963, 6964, 6965, 6966, 6967, 6968, 6969, 6970, 6971, 6972, 6973, 6974, 6975, 6976, 6977, 6978, 6979, 6980, 6981, 6982, 6983, 6984, 6985, 6986, 6987, 6988, 6989, 6990, 6991, 6992, 6993, 6994, 6995, 6996, 6997, 6998, 6999, 7000, 7001, 7002, 7003, 7004, 7005, 7006, 7007, 7008, 7009, 7010, 7011, 7012, 7013, 7014, 7015, 7016, 7017, 7018, 7019, 7020, 7021, 7022, 7023, 7024, 7025, 7026, 7027, 7028, 7029, 7030, 7031, 7032, 7033, 7034, 7035, 7036, 7037, 7038, 7039, 7040, 7041, 7042, 7043, 7044, 7045, 7046, 7047, 7048, 7049, 7050, 7051, 7052, 7053, 7054, 7055, 7056, 7057, 7058, 7059, 7060, 7061, 7062, 7063, 7064, 7065, 7066, 7067, 7068, 7069, 7070, 7071, 7072, 7073, 7074, 7075, 7076, 7077, 7078, 7079, 7080, 7081, 7082, 7083, 7084, 7085, 7086, 7087, 7088, 7089, 7090, 7091, 7092, 7093, 7094, 7095, 7096, 7097, 7098, 7099, 7100, 7101, 7102, 7103, 7104, 7105, 7106, 7107, 7108, 7109, 7110, 7111, 7112, 7113, 7114, 7115, 7116, 7117, 7118, 7119, 7120, 7121, 7122, 7123, 7124, 7125, 7126, 7127, 7128, 7129, 7130, 7131, 7132, 7133, 7134, 7135, 7136, 7137, 7138, 7139, 7140, 7141, 7142, 7143, 7144, 7145, 7146, 7147, 7148, 7149, 7150, 7151, 7152, 7153, 7154, 7155, 7156, 7157, 7158, 7159, 7160, 7161, 7162, 7163, 7164, 7165, 7166, 7167, 7168, 7169, 7170, 7171, 7172, 7173, 7174, 7175, 7176, 7177, 7178, 7179, 7180, 7181, 7182, 7183, 7184, 7185, 7186, 7187, 7188, 7189, 7190, 7191, 7192, 7193, 7194, 7195, 7196, 7197, 7198, 7199, 7200, 7201, 7202, 7203, 7204, 7205, 7206, 7207, 7208, 7209, 7210, 7211, 7212, 7213, 7214, 7215, 7216, 7217, 7218, 7219, 7220, 7221, 7222, 7223, 7224, 7225, 7226, 7227, 7228, 7229, 7230, 7231, 7232, 7233, 7234, 7235, 7236, 7237, 7238, 7239, 7240, 7241, 7242, 7243, 7244, 7245, 7246, 7247, 7248, 7249, 7250, 7251, 7252, 7253, 7254, 7255, 7256, 7257, 7258, 7259, 7260, 7261, 7262, 7263, 7264, 7265, 7266, 7267, 7268, 7269, 7270, 7271, 7272, 7273, 7274, 7275, 7276, 7277, 7278, 7279, 7280, 7281, 7282, 7283, 7284, 7285, 7286, 7287, 7288, 7289, 7290, 7291, 7292, 7293, 7294, 7295, 7296, 7297, 7298, 7299, 7300, 7301, 7302, 7303, 7304, 7305, 7306, 7307, 7308, 7309, 7310, 7311, 7312, 7313, 7314, 7315, 7316, 7317, 7318, 7319, 7320, 7321, 7322, 7323, 7324, 7325, 7326, 7327, 7328, 7329, 7330, 7331, 7332, 7333, 7334, 7335, 7336, 7337, 7338, 7339, 7340, 7341, 7342, 7343, 7344, 7345, 7346, 7347, 7348, 7349, 7350, 7351, 7352, 7353, 7354, 7355, 7356, 7357, 7358, 7359, 7360, 7361, 7362, 7363, 7364, 7365, 7366, 7367, 7368, 7369, 7370, 7371, 7372, 7373, 7374, 7375, 7376, 7377, 7378, 7379, 7380, 7381, 7382, 7383, 7384, 7385, 7386, 7387, 7388, 7389, 7390, 7391, 7392, 7393, 7394, 7395, 7396, 7397, 7398, 7399, 7400, 7401, 7402, 7403, 7404, 7405, 7406, 7407, 7408, 7409, 7410, 7411, 7412, 7413, 7414, 7415, 7416, 7417, 7418, 7419, 7420, 7421, 7422, 7423, 7424, 7425, 7426, 7427, 7428, 7429, 7430, 7431, 7432, 7433, 7434, 7435, 7436, 7437, 7438, 7439, 7440, 7441, 7442, 7443, 7444, 7445, 7446, 7447, 7448, 7449, 7450, 7451, 7452, 7453, 7454, 7455, 7456, 7457, 7458, 7459, 7460, 7461, 7462, 7463, 7464, 7465, 7466, 7467, 7468, 7469, 7470, 7471, 7472, 7473, 7474, 7475, 7476, 7477, 7478, 7479, 7480, 7481, 7482, 7483, 7484, 7485, 7486, 7487, 7488, 7489, 7490, 7491, 7492, 7493, 7494, 7495, 7496, 7497, 7498, 7499, 7500, 7501, 7502, 7503, 7504, 7505, 7506, 7507, 7508, 7509, 7510, 7511, 7512, 7513, 7514, 7515, 7516, 7517, 7518, 7519, 7520, 7521, 7522, 7523, 7524, 7525, 7526, 7527, 7528, 7529, 7530, 7531, 7532, 7533, 7534, 7535, 7536, 7537, 7538, 7539, 7540, 7541, 7542, 7543, 7544, 7545, 7546, 7547, 7548, 7549, 7550, 7551, 7552, 7553, 7554, 7555, 7556, 7557, 7558, 7559, 7560, 7561, 7562, 7563, 7564, 7565, 7566, 7567, 7568, 7569, 7570, 7571, 7572, 7573, 7574, 7575, 7576, 7577, 7578, 7579, 7580, 7581, 7582, 7583, 7584, 7585, 7586, 7587, 7588, 7589, 7590, 7591, 7592, 7593, 7594, 7595, 7596, 7597, 7598, 7599, 7600, 7601, 7602, 7603, 7604, 7605, 7606, 7607, 7608, 7609, 7610, 7611, 7612, 7613, 7614, 7615, 7616, 7617, 7618, 7619, 7620, 7621, 7622, 7623, 7624, 7625, 7626, 7627, 7628, 7629, 7630, 7631, 7632, 7633, 7634, 7635, 7636, 7637, 7638, 7639, 7640, 7641, 7642, 7643, 7644, 7645, 7646, 7647, 7648, 7649, 7650, 7651, 7652, 7653, 7654, 7655, 7656, 7657, 7658, 7659, 7660, 7661, 7662, 7663, 7664, 7665, 7666, 7667, 7668, 7669, 7670, 7671, 7672, 7673, 7674, 7675, 7676, 7677, 7678, 7679, 7680, 7681, 7682, 7683, 7684, 7685, 7686, 7687, 7688, 7689, 7690, 7691, 7692, 7693, 7694, 7695, 7696, 7697, 7698, 7699, 7700, 7701, 7702, 7703, 7704, 7705, 7706, 7707, 7708, 7709, 7710, 7711, 7712, 7713, 7714, 7715, 7716, 7717, 7718, 7719, 7720, 7721, 7722, 7723, 7724, 7725, 7726, 7727, 7728, 7729, 7730, 7731, 7732, 7733, 7734, 7735, 7736, 7737, 7738, 7739, 7740, 7741, 7742, 7743, 7744, 7745, 7746, 7747, 7748, 7749, 7750, 7751, 7752, 7753, 7754, 7755, 7756, 7757, 7758, 7759, 7760, 7761, 7762, 7763, 7764, 7765, 7766, 7767, 7768, 7769, 7770, 7771, 7772, 7773, 7774, 7775, 7776, 7777, 7778, 7779, 7780, 7781, 7782, 7783, 7784, 7785, 7786, 7787, 7788, 7789, 7790, 7791, 7792, 7793, 7794, 7795, 7796, 7797, 7798, 7799, 7800, 7801, 7802, 7803, 7804, 7805, 7806, 7807, 7808, 7809, 7810, 7811, 7812, 7813, 7814, 7815, 7816, 7817, 7818, 7819, 7820, 7821, 7822, 7823, 7824, 7825, 7826, 7827, 7828, 7829, 7830, 7831, 7832, 7833, 7834, 7835, 7836, 7837, 7838, 7839, 7840, 7841, 7842, 7843, 7844, 7845, 7846, 7847, 7848, 7849, 7850, 7851, 7852, 7853, 7854, 7855, 7856, 7857, 7858, 7859, 7860, 7861, 7862, 7863, 7864, 7865, 7866, 7867, 7868, 7869, 7870, 7871, 7872, 7873, 7874, 7875, 7876, 7877, 7878, 7879, 7880, 7881, 7882, 7883, 7884, 7885, 7886, 7887, 7888, 7889, 7890, 7891, 7892, 7893, 7894, 7895, 7896, 7897, 7898, 7899, 7900, 7901, 7902, 7903, 7904, 7905, 7906, 7907, 7908, 7909, 7910, 7911, 7912, 7913, 7914, 7915, 7916, 7917, 7918, 7919, 7920, 7921, 7922, 7923, 7924, 7925, 7926, 7927, 7928, 7929, 7930, 7931, 7932, 7933, 7934, 7935, 7936, 7937, 7938, 7939, 7940, 7941, 7942, 7943, 7944, 7945, 7946, 7947, 7948, 7949, 7950, 7951, 7952, 7953, 7955, 7957, 7959, 7961, 7963, 7965, 7967, 7969, 7971, 7973, 7975, 7978, 7981, 7984, 7987, 7990, 7993, 7996, 7999, 8002, 8005, 8008, 8011, 8014, 8017, 8020, 8023, 8026, 8029, 8032, 8035, 8038, 8041, 8044, 8047, 8050, 8053, 8056, 8057, 8058, 8060, 8062, 8063, 8064, 8065, 8066, 8067, 8068, 8069, 8070, 8071, 8072, 8073, 8074, 8075, 8076, 8077, 8078, 8079, 8080, 8081, 8082, 8083, 8084, 8085, 8086, 8087, 8088, 8090, 8092, 8094, 8096, 8099, 8101, 8103, 8105, 8107, 8109, 8111, 8113, 8114, 8115, 8116, 8117, 8118, 8119, 8120, 8121, 8122, 8123, 8124, 8125, 8126, 8127, 8128, 8129, 8130, 8131, 8132, 8133, 8134, 8135, 8136, 8137, 8138, 8139, 8140, 8141, 8142, 8143, 8144, 8145, 8146, 8147, 8148, 8149, 8150, 8151, 8152, 8153, 8154, 8155, 8156, 8157, 8158, 8161, 8164, 8167, 8170, 8173, 8176, 8179, 8182, 8185, 8186, 8187, 8188, 8189, 8190, 8191, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200, 8201, 8202, 8203, 8204, 8205, 8206, 8207, 8208, 8209, 8210, 8211, 8212, 8213, 8214, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8223, 8224, 8225, 8226, 8227, 8228, 8229, 8230, 8231, 8232, 8233, 8234, 8235, 8236, 8237, 8238, 8239, 8240, 8241, 8242, 8243, 8244, 8245, 8246, 8247, 8248, 8249, 8250, 8251, 8252, 8253, 8254, 8255, 8256, 8257, 8258, 8259, 8260, 8261, 8262, 8263, 8264, 8265, 8266, 8267, 8268, 8269, 8270, 8271, 8272, 8273, 8274, 8275, 8276, 8277, 8278, 8279, 8280, 8281, 8282, 8283, 8284, 8285, 8286, 8287, 8288, 8289, 8290, 8291, 8292, 8293, 8294, 8295, 8296, 8297, 8298, 8299, 8300, 8301, 8302, 8303, 8304, 8305, 8306, 8307, 8308, 8309, 8310, 8311, 8312, 8313, 8314, 8315, 8316, 8317, 8318, 8319, 8320, 8321, 8322, 8323, 8324, 8325, 8326, 8327, 8328, 8329, 8330, 8331, 8332, 8333, 8334, 8335, 8336, 8337, 8338, 8339, 8340, 8341, 8342, 8343, 8344, 8345, 8346, 8347, 8348, 8349, 8350, 8351, 8352, 8353, 8354, 8355, 8356, 8357, 8358, 8359, 8360, 8361, 8362, 8363, 8364, 8365, 8366, 8367, 8368, 8369, 8370, 8371, 8372, 8373, 8374, 8375, 8376, 8377, 8378, 8379, 8380, 8381, 8382, 8383, 8384, 8385, 8386, 8387, 8388, 8389, 8390, 8391, 8392, 8393, 8394, 8395, 8396, 8397, 8398, 8399, 8400, 8401, 8402, 8403, 8404, 8405, 8406, 8407, 8408, 8409, 8410, 8411, 8412, 8413, 8414, 8415, 8416, 8417, 8418, 8419, 8420, 8421, 8422, 8423, 8424, 8425, 8426, 8427, 8428, 8429, 8430, 8431, 8432, 8433, 8434, 8435, 8436, 8437, 8438, 8439, 8440, 8441, 8442, 8443, 8444, 8445, 8446, 8447, 8448, 8449, 8450, 8451, 8452, 8453, 8454, 8455, 8456, 8457, 8458, 8459, 8460, 8461, 8462, 8463, 8464, 8465, 8466, 8467, 8468, 8469, 8470, 8471, 8472, 8473, 8474, 8475, 8476, 8477, 8478, 8479, 8480, 8481, 8482, 8483, 8484, 8485, 8486, 8487, 8488, 8489, 8490, 8491, 8492, 8493, 8494, 8495, 8496, 8497, 8498, 8499, 8500, 8501, 8502, 8503, 8504, 8505, 8506, 8507, 8508, 8509, 8510, 8511, 8512, 8513, 8514, 8515, 8516, 8517, 8518, 8519, 8520, 8521, 8522, 8523, 8524, 8525, 8526, 8527, 8528, 8529, 8530, 8531, 8532, 8533, 8534, 8535, 8536, 8537, 8538, 8539, 8540, 8541, 8542, 8543, 8544, 8545, 8546, 8547, 8548, 8549, 8550, 8551, 8552, 8553, 8554, 8555, 8556, 8557, 8558, 8559, 8560, 8561, 8562, 8563, 8564, 8565, 8566, 8567, 8568, 8569, 8570, 8571, 8572, 8573, 8574, 8575, 8576, 8577, 8578, 8579, 8580, 8581, 8582, 8583, 8584, 8585, 8586, 8587, 8588, 8589, 8590, 8591, 8592, 8593, 8594, 8595, 8596, 8597, 8598, 8599, 8600, 8601, 8602, 8603, 8604, 8605, 8606, 8607, 8608, 8609, 8610, 8611, 8612, 8613, 8614, 8615, 8616, 8617, 8618, 8619, 8620, 8621, 8622, 8623, 8624, 8625, 8626, 8627, 8628, 8629, 8630, 8631, 8632, 8633, 8634, 8635, 8636, 8637, 8638, 8639, 8640, 8641, 8642, 8643, 8644, 8645, 8646, 8647, 8648, 8649, 8650, 8651, 8652, 8653, 8654, 8655, 8656, 8657, 8658, 8659, 8660, 8661, 8662, 8663, 8664, 8665, 8666, 8667, 8668, 8669, 8670, 8671, 8672, 8673, 8674, 8675, 8676, 8677, 8678, 8679, 8680, 8681, 8682, 8683, 8684, 8685, 8686, 8687, 8688, 8689, 8690, 8691, 8692, 8693, 8694, 8695, 8696, 8697, 8698, 8699, 8700, 8701, 8702, 8703, 8704, 8705, 8706, 8707, 8708, 8709, 8710, 8711, 8712, 8713, 8714, 8715, 8716, 8717, 8718, 8719, 8720, 8721, 8722, 8723, 8724, 8725, 8726, 8727, 8728, 8729, 8730, 8731, 8732, 8733, 8734, 8735, 8736, 8737, 8738];
const _M0FP410tonyfettes7unicode8internal3ucd23decomp__canonical__lens = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 2, 2, 2, 2, 2, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 2, 1, 0, 1, 0, 2, 2, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 2, 2, 2, 2, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 2, 0, 1, 0, 0, 2, 2, 2, 2, 2, 2, 2, 1, 2, 1, 2, 2, 2, 2, 2, 2, 2, 1, 2, 2, 2, 2, 2, 1, 2, 2, 2, 2, 2, 2, 1, 2, 2, 2, 2, 2, 2, 2, 1, 2, 2, 1, 1, 2, 2, 2, 2, 2, 2, 1, 2, 1, 2, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
const _M0FP410tonyfettes7unicode8internal3ucd20decomp__compat__lens = [1, 2, 1, 2, 1, 1, 2, 1, 2, 1, 1, 3, 3, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 2, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 2, 3, 1, 2, 3, 2, 3, 2, 2, 2, 2, 2, 4, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 3, 3, 1, 2, 3, 3, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 2, 3, 2, 1, 0, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 3, 4, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 1, 2, 3, 2, 1, 2, 3, 4, 2, 1, 2, 3, 1, 1, 1, 1, 1, 2, 3, 2, 1, 2, 3, 4, 2, 1, 2, 3, 1, 1, 1, 1, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 2, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 4, 3, 2, 3, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 7, 6, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 1, 1, 1, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 5, 4, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 2, 3, 2, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 4, 4, 4, 3, 4, 3, 3, 5, 4, 3, 3, 3, 4, 4, 3, 3, 2, 3, 4, 4, 2, 5, 6, 5, 3, 5, 5, 4, 3, 3, 3, 4, 5, 4, 3, 3, 3, 2, 2, 2, 2, 3, 3, 5, 3, 4, 5, 3, 2, 2, 5, 4, 5, 3, 5, 2, 3, 3, 3, 3, 3, 4, 3, 2, 3, 3, 3, 4, 3, 3, 3, 5, 4, 2, 5, 2, 4, 4, 3, 3, 3, 4, 2, 3, 4, 2, 5, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 2, 3, 2, 2, 2, 3, 3, 2, 2, 2, 2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 3, 4, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 2, 3, 3, 3, 2, 3, 3, 4, 2, 3, 3, 3, 3, 5, 6, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 4, 2, 2, 2, 4, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 2, 2, 3, 3, 2, 4, 3, 2, 2, 2, 2, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 3, 3, 2, 2, 2, 2, 2, 2, 2, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 3, 18, 8, 4, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 1, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 3, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
const _M0FP410tonyfettes7unicode8internal3ucd12decomp__data = [32, 32, 776, 97, 32, 772, 50, 51, 32, 769, 956, 32, 807, 49, 111, 49, 8260, 52, 49, 8260, 50, 51, 8260, 52, 65, 768, 65, 769, 65, 770, 65, 771, 65, 776, 65, 778, 67, 807, 69, 768, 69, 769, 69, 770, 69, 776, 73, 768, 73, 769, 73, 770, 73, 776, 78, 771, 79, 768, 79, 769, 79, 770, 79, 771, 79, 776, 85, 768, 85, 769, 85, 770, 85, 776, 89, 769, 97, 768, 97, 769, 97, 770, 97, 771, 97, 776, 97, 778, 99, 807, 101, 768, 101, 769, 101, 770, 101, 776, 105, 768, 105, 769, 105, 770, 105, 776, 110, 771, 111, 768, 111, 769, 111, 770, 111, 771, 111, 776, 117, 768, 117, 769, 117, 770, 117, 776, 121, 769, 121, 776, 65, 772, 97, 772, 65, 774, 97, 774, 65, 808, 97, 808, 67, 769, 99, 769, 67, 770, 99, 770, 67, 775, 99, 775, 67, 780, 99, 780, 68, 780, 100, 780, 69, 772, 101, 772, 69, 774, 101, 774, 69, 775, 101, 775, 69, 808, 101, 808, 69, 780, 101, 780, 71, 770, 103, 770, 71, 774, 103, 774, 71, 775, 103, 775, 71, 807, 103, 807, 72, 770, 104, 770, 73, 771, 105, 771, 73, 772, 105, 772, 73, 774, 105, 774, 73, 808, 105, 808, 73, 775, 73, 74, 105, 106, 74, 770, 106, 770, 75, 807, 107, 807, 76, 769, 108, 769, 76, 807, 108, 807, 76, 780, 108, 780, 76, 183, 108, 183, 78, 769, 110, 769, 78, 807, 110, 807, 78, 780, 110, 780, 700, 110, 79, 772, 111, 772, 79, 774, 111, 774, 79, 779, 111, 779, 82, 769, 114, 769, 82, 807, 114, 807, 82, 780, 114, 780, 83, 769, 115, 769, 83, 770, 115, 770, 83, 807, 115, 807, 83, 780, 115, 780, 84, 807, 116, 807, 84, 780, 116, 780, 85, 771, 117, 771, 85, 772, 117, 772, 85, 774, 117, 774, 85, 778, 117, 778, 85, 779, 117, 779, 85, 808, 117, 808, 87, 770, 119, 770, 89, 770, 121, 770, 89, 776, 90, 769, 122, 769, 90, 775, 122, 775, 90, 780, 122, 780, 115, 79, 795, 111, 795, 85, 795, 117, 795, 68, 381, 68, 382, 100, 382, 76, 74, 76, 106, 108, 106, 78, 74, 78, 106, 110, 106, 65, 780, 97, 780, 73, 780, 105, 780, 79, 780, 111, 780, 85, 780, 117, 780, 220, 772, 252, 772, 220, 769, 252, 769, 220, 780, 252, 780, 220, 768, 252, 768, 196, 772, 228, 772, 550, 772, 551, 772, 198, 772, 230, 772, 71, 780, 103, 780, 75, 780, 107, 780, 79, 808, 111, 808, 490, 772, 491, 772, 439, 780, 658, 780, 106, 780, 68, 90, 68, 122, 100, 122, 71, 769, 103, 769, 78, 768, 110, 768, 197, 769, 229, 769, 198, 769, 230, 769, 216, 769, 248, 769, 65, 783, 97, 783, 65, 785, 97, 785, 69, 783, 101, 783, 69, 785, 101, 785, 73, 783, 105, 783, 73, 785, 105, 785, 79, 783, 111, 783, 79, 785, 111, 785, 82, 783, 114, 783, 82, 785, 114, 785, 85, 783, 117, 783, 85, 785, 117, 785, 83, 806, 115, 806, 84, 806, 116, 806, 72, 780, 104, 780, 65, 775, 97, 775, 69, 807, 101, 807, 214, 772, 246, 772, 213, 772, 245, 772, 79, 775, 111, 775, 558, 772, 559, 772, 89, 772, 121, 772, 104, 614, 106, 114, 633, 635, 641, 119, 121, 32, 774, 32, 775, 32, 778, 32, 808, 32, 771, 32, 779, 611, 108, 115, 120, 661, 768, 769, 787, 776, 769, 697, 32, 837, 59, 32, 769, 168, 769, 913, 769, 183, 917, 769, 919, 769, 921, 769, 927, 769, 933, 769, 937, 769, 970, 769, 921, 776, 933, 776, 945, 769, 949, 769, 951, 769, 953, 769, 971, 769, 953, 776, 965, 776, 959, 769, 965, 769, 969, 769, 946, 952, 933, 978, 769, 978, 776, 966, 960, 954, 961, 962, 920, 949, 931, 1045, 768, 1045, 776, 1043, 769, 1030, 776, 1050, 769, 1048, 768, 1059, 774, 1048, 774, 1080, 774, 1077, 768, 1077, 776, 1075, 769, 1110, 776, 1082, 769, 1080, 768, 1091, 774, 1140, 783, 1141, 783, 1046, 774, 1078, 774, 1040, 774, 1072, 774, 1040, 776, 1072, 776, 1045, 774, 1077, 774, 1240, 776, 1241, 776, 1046, 776, 1078, 776, 1047, 776, 1079, 776, 1048, 772, 1080, 772, 1048, 776, 1080, 776, 1054, 776, 1086, 776, 1256, 776, 1257, 776, 1069, 776, 1101, 776, 1059, 772, 1091, 772, 1059, 776, 1091, 776, 1059, 779, 1091, 779, 1063, 776, 1095, 776, 1067, 776, 1099, 776, 1381, 1410, 1575, 1619, 1575, 1620, 1608, 1620, 1575, 1621, 1610, 1620, 1575, 1652, 1608, 1652, 1735, 1652, 1610, 1652, 1749, 1620, 1729, 1620, 1746, 1620, 2344, 2364, 2352, 2364, 2355, 2364, 2325, 2364, 2326, 2364, 2327, 2364, 2332, 2364, 2337, 2364, 2338, 2364, 2347, 2364, 2351, 2364, 2503, 2494, 2503, 2519, 2465, 2492, 2466, 2492, 2479, 2492, 2610, 2620, 2616, 2620, 2582, 2620, 2583, 2620, 2588, 2620, 2603, 2620, 2887, 2902, 2887, 2878, 2887, 2903, 2849, 2876, 2850, 2876, 2962, 3031, 3014, 3006, 3015, 3006, 3014, 3031, 3142, 3158, 3263, 3285, 3270, 3285, 3270, 3286, 3270, 3266, 3274, 3285, 3398, 3390, 3399, 3390, 3398, 3415, 3545, 3530, 3545, 3535, 3548, 3530, 3545, 3551, 3661, 3634, 3789, 3762, 3755, 3737, 3755, 3745, 3851, 3906, 4023, 3916, 4023, 3921, 4023, 3926, 4023, 3931, 4023, 3904, 4021, 3953, 3954, 3953, 3956, 4018, 3968, 4018, 3969, 4019, 3968, 4019, 3969, 3953, 3968, 3986, 4023, 3996, 4023, 4001, 4023, 4006, 4023, 4011, 4023, 3984, 4021, 4133, 4142, 4316, 6917, 6965, 6919, 6965, 6921, 6965, 6923, 6965, 6925, 6965, 6929, 6965, 6970, 6965, 6972, 6965, 6974, 6965, 6975, 6965, 6978, 6965, 65, 198, 66, 68, 69, 398, 71, 72, 73, 74, 75, 76, 77, 78, 79, 546, 80, 82, 84, 85, 87, 97, 592, 593, 7426, 98, 100, 101, 601, 603, 604, 103, 107, 109, 331, 111, 596, 7446, 7447, 112, 116, 117, 7453, 623, 118, 7461, 946, 947, 948, 966, 967, 105, 114, 117, 118, 946, 947, 961, 966, 967, 1085, 594, 99, 597, 240, 604, 102, 607, 609, 613, 616, 617, 618, 7547, 669, 621, 7557, 671, 625, 624, 626, 627, 628, 629, 632, 642, 643, 427, 649, 650, 7452, 651, 652, 122, 656, 657, 658, 952, 65, 805, 97, 805, 66, 775, 98, 775, 66, 803, 98, 803, 66, 817, 98, 817, 199, 769, 231, 769, 68, 775, 100, 775, 68, 803, 100, 803, 68, 817, 100, 817, 68, 807, 100, 807, 68, 813, 100, 813, 274, 768, 275, 768, 274, 769, 275, 769, 69, 813, 101, 813, 69, 816, 101, 816, 552, 774, 553, 774, 70, 775, 102, 775, 71, 772, 103, 772, 72, 775, 104, 775, 72, 803, 104, 803, 72, 776, 104, 776, 72, 807, 104, 807, 72, 814, 104, 814, 73, 816, 105, 816, 207, 769, 239, 769, 75, 769, 107, 769, 75, 803, 107, 803, 75, 817, 107, 817, 76, 803, 108, 803, 7734, 772, 7735, 772, 76, 817, 108, 817, 76, 813, 108, 813, 77, 769, 109, 769, 77, 775, 109, 775, 77, 803, 109, 803, 78, 775, 110, 775, 78, 803, 110, 803, 78, 817, 110, 817, 78, 813, 110, 813, 213, 769, 245, 769, 213, 776, 245, 776, 332, 768, 333, 768, 332, 769, 333, 769, 80, 769, 112, 769, 80, 775, 112, 775, 82, 775, 114, 775, 82, 803, 114, 803, 7770, 772, 7771, 772, 82, 817, 114, 817, 83, 775, 115, 775, 83, 803, 115, 803, 346, 775, 347, 775, 352, 775, 353, 775, 7778, 775, 7779, 775, 84, 775, 116, 775, 84, 803, 116, 803, 84, 817, 116, 817, 84, 813, 116, 813, 85, 804, 117, 804, 85, 816, 117, 816, 85, 813, 117, 813, 360, 769, 361, 769, 362, 776, 363, 776, 86, 771, 118, 771, 86, 803, 118, 803, 87, 768, 119, 768, 87, 769, 119, 769, 87, 776, 119, 776, 87, 775, 119, 775, 87, 803, 119, 803, 88, 775, 120, 775, 88, 776, 120, 776, 89, 775, 121, 775, 90, 770, 122, 770, 90, 803, 122, 803, 90, 817, 122, 817, 104, 817, 116, 776, 119, 778, 121, 778, 97, 702, 383, 775, 65, 803, 97, 803, 65, 777, 97, 777, 194, 769, 226, 769, 194, 768, 226, 768, 194, 777, 226, 777, 194, 771, 226, 771, 7840, 770, 7841, 770, 258, 769, 259, 769, 258, 768, 259, 768, 258, 777, 259, 777, 258, 771, 259, 771, 7840, 774, 7841, 774, 69, 803, 101, 803, 69, 777, 101, 777, 69, 771, 101, 771, 202, 769, 234, 769, 202, 768, 234, 768, 202, 777, 234, 777, 202, 771, 234, 771, 7864, 770, 7865, 770, 73, 777, 105, 777, 73, 803, 105, 803, 79, 803, 111, 803, 79, 777, 111, 777, 212, 769, 244, 769, 212, 768, 244, 768, 212, 777, 244, 777, 212, 771, 244, 771, 7884, 770, 7885, 770, 416, 769, 417, 769, 416, 768, 417, 768, 416, 777, 417, 777, 416, 771, 417, 771, 416, 803, 417, 803, 85, 803, 117, 803, 85, 777, 117, 777, 431, 769, 432, 769, 431, 768, 432, 768, 431, 777, 432, 777, 431, 771, 432, 771, 431, 803, 432, 803, 89, 768, 121, 768, 89, 803, 121, 803, 89, 777, 121, 777, 89, 771, 121, 771, 945, 787, 945, 788, 7936, 768, 7937, 768, 7936, 769, 7937, 769, 7936, 834, 7937, 834, 913, 787, 913, 788, 7944, 768, 7945, 768, 7944, 769, 7945, 769, 7944, 834, 7945, 834, 949, 787, 949, 788, 7952, 768, 7953, 768, 7952, 769, 7953, 769, 917, 787, 917, 788, 7960, 768, 7961, 768, 7960, 769, 7961, 769, 951, 787, 951, 788, 7968, 768, 7969, 768, 7968, 769, 7969, 769, 7968, 834, 7969, 834, 919, 787, 919, 788, 7976, 768, 7977, 768, 7976, 769, 7977, 769, 7976, 834, 7977, 834, 953, 787, 953, 788, 7984, 768, 7985, 768, 7984, 769, 7985, 769, 7984, 834, 7985, 834, 921, 787, 921, 788, 7992, 768, 7993, 768, 7992, 769, 7993, 769, 7992, 834, 7993, 834, 959, 787, 959, 788, 8000, 768, 8001, 768, 8000, 769, 8001, 769, 927, 787, 927, 788, 8008, 768, 8009, 768, 8008, 769, 8009, 769, 965, 787, 965, 788, 8016, 768, 8017, 768, 8016, 769, 8017, 769, 8016, 834, 8017, 834, 933, 788, 8025, 768, 8025, 769, 8025, 834, 969, 787, 969, 788, 8032, 768, 8033, 768, 8032, 769, 8033, 769, 8032, 834, 8033, 834, 937, 787, 937, 788, 8040, 768, 8041, 768, 8040, 769, 8041, 769, 8040, 834, 8041, 834, 945, 768, 940, 949, 768, 941, 951, 768, 942, 953, 768, 943, 959, 768, 972, 965, 768, 973, 969, 768, 974, 7936, 837, 7937, 837, 7938, 837, 7939, 837, 7940, 837, 7941, 837, 7942, 837, 7943, 837, 7944, 837, 7945, 837, 7946, 837, 7947, 837, 7948, 837, 7949, 837, 7950, 837, 7951, 837, 7968, 837, 7969, 837, 7970, 837, 7971, 837, 7972, 837, 7973, 837, 7974, 837, 7975, 837, 7976, 837, 7977, 837, 7978, 837, 7979, 837, 7980, 837, 7981, 837, 7982, 837, 7983, 837, 8032, 837, 8033, 837, 8034, 837, 8035, 837, 8036, 837, 8037, 837, 8038, 837, 8039, 837, 8040, 837, 8041, 837, 8042, 837, 8043, 837, 8044, 837, 8045, 837, 8046, 837, 8047, 837, 945, 774, 945, 772, 8048, 837, 945, 837, 940, 837, 945, 834, 8118, 837, 913, 774, 913, 772, 913, 768, 902, 913, 837, 32, 787, 953, 32, 787, 32, 834, 168, 834, 8052, 837, 951, 837, 942, 837, 951, 834, 8134, 837, 917, 768, 904, 919, 768, 905, 919, 837, 8127, 768, 8127, 769, 8127, 834, 953, 774, 953, 772, 970, 768, 912, 953, 834, 970, 834, 921, 774, 921, 772, 921, 768, 906, 8190, 768, 8190, 769, 8190, 834, 965, 774, 965, 772, 971, 768, 944, 961, 787, 961, 788, 965, 834, 971, 834, 933, 774, 933, 772, 933, 768, 910, 929, 788, 168, 768, 901, 96, 8060, 837, 969, 837, 974, 837, 969, 834, 8182, 837, 927, 768, 908, 937, 768, 911, 937, 837, 180, 32, 788, 8194, 8195, 32, 32, 32, 32, 32, 32, 32, 32, 32, 8208, 32, 819, 46, 46, 46, 46, 46, 46, 32, 8242, 8242, 8242, 8242, 8242, 8245, 8245, 8245, 8245, 8245, 33, 33, 32, 773, 63, 63, 63, 33, 33, 63, 8242, 8242, 8242, 8242, 32, 48, 105, 52, 53, 54, 55, 56, 57, 43, 8722, 61, 40, 41, 110, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 43, 8722, 61, 40, 41, 97, 101, 111, 120, 601, 104, 107, 108, 109, 110, 112, 115, 116, 82, 115, 97, 47, 99, 97, 47, 115, 67, 176, 67, 99, 47, 111, 99, 47, 117, 400, 176, 70, 103, 72, 72, 72, 104, 295, 73, 73, 76, 108, 78, 78, 111, 80, 81, 82, 82, 82, 83, 77, 84, 69, 76, 84, 77, 90, 937, 90, 75, 197, 66, 67, 101, 69, 70, 77, 111, 1488, 1489, 1490, 1491, 105, 70, 65, 88, 960, 947, 915, 928, 8721, 68, 100, 101, 105, 106, 49, 8260, 55, 49, 8260, 57, 49, 8260, 49, 48, 49, 8260, 51, 50, 8260, 51, 49, 8260, 53, 50, 8260, 53, 51, 8260, 53, 52, 8260, 53, 49, 8260, 54, 53, 8260, 54, 49, 8260, 56, 51, 8260, 56, 53, 8260, 56, 55, 8260, 56, 49, 8260, 73, 73, 73, 73, 73, 73, 73, 86, 86, 86, 73, 86, 73, 73, 86, 73, 73, 73, 73, 88, 88, 88, 73, 88, 73, 73, 76, 67, 68, 77, 105, 105, 105, 105, 105, 105, 105, 118, 118, 118, 105, 118, 105, 105, 118, 105, 105, 105, 105, 120, 120, 120, 105, 120, 105, 105, 108, 99, 100, 109, 48, 8260, 51, 8592, 824, 8594, 824, 8596, 824, 8656, 824, 8660, 824, 8658, 824, 8707, 824, 8712, 824, 8715, 824, 8739, 824, 8741, 824, 8747, 8747, 8747, 8747, 8747, 8750, 8750, 8750, 8750, 8750, 8764, 824, 8771, 824, 8773, 824, 8776, 824, 61, 824, 8801, 824, 8781, 824, 60, 824, 62, 824, 8804, 824, 8805, 824, 8818, 824, 8819, 824, 8822, 824, 8823, 824, 8826, 824, 8827, 824, 8834, 824, 8835, 824, 8838, 824, 8839, 824, 8866, 824, 8872, 824, 8873, 824, 8875, 824, 8828, 824, 8829, 824, 8849, 824, 8850, 824, 8882, 824, 8883, 824, 8884, 824, 8885, 824, 12296, 12297, 49, 50, 51, 52, 53, 54, 55, 56, 57, 49, 48, 49, 49, 49, 50, 49, 51, 49, 52, 49, 53, 49, 54, 49, 55, 49, 56, 49, 57, 50, 48, 40, 49, 41, 40, 50, 41, 40, 51, 41, 40, 52, 41, 40, 53, 41, 40, 54, 41, 40, 55, 41, 40, 56, 41, 40, 57, 41, 40, 49, 48, 41, 40, 49, 49, 41, 40, 49, 50, 41, 40, 49, 51, 41, 40, 49, 52, 41, 40, 49, 53, 41, 40, 49, 54, 41, 40, 49, 55, 41, 40, 49, 56, 41, 40, 49, 57, 41, 40, 50, 48, 41, 49, 46, 50, 46, 51, 46, 52, 46, 53, 46, 54, 46, 55, 46, 56, 46, 57, 46, 49, 48, 46, 49, 49, 46, 49, 50, 46, 49, 51, 46, 49, 52, 46, 49, 53, 46, 49, 54, 46, 49, 55, 46, 49, 56, 46, 49, 57, 46, 50, 48, 46, 40, 97, 41, 40, 98, 41, 40, 99, 41, 40, 100, 41, 40, 101, 41, 40, 102, 41, 40, 103, 41, 40, 104, 41, 40, 105, 41, 40, 106, 41, 40, 107, 41, 40, 108, 41, 40, 109, 41, 40, 110, 41, 40, 111, 41, 40, 112, 41, 40, 113, 41, 40, 114, 41, 40, 115, 41, 40, 116, 41, 40, 117, 41, 40, 118, 41, 40, 119, 41, 40, 120, 41, 40, 121, 41, 40, 122, 41, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 48, 8747, 8747, 8747, 8747, 58, 58, 61, 61, 61, 61, 61, 61, 10973, 824, 106, 86, 11617, 27597, 40863, 19968, 20008, 20022, 20031, 20057, 20101, 20108, 20128, 20154, 20799, 20837, 20843, 20866, 20886, 20907, 20960, 20981, 20992, 21147, 21241, 21269, 21274, 21304, 21313, 21340, 21353, 21378, 21430, 21448, 21475, 22231, 22303, 22763, 22786, 22794, 22805, 22823, 22899, 23376, 23424, 23544, 23567, 23586, 23608, 23662, 23665, 24027, 24037, 24049, 24062, 24178, 24186, 24191, 24308, 24318, 24331, 24339, 24400, 24417, 24435, 24515, 25096, 25142, 25163, 25903, 25908, 25991, 26007, 26020, 26041, 26080, 26085, 26352, 26376, 26408, 27424, 27490, 27513, 27571, 27595, 27604, 27611, 27663, 27668, 27700, 28779, 29226, 29238, 29243, 29247, 29255, 29273, 29275, 29356, 29572, 29577, 29916, 29926, 29976, 29983, 29992, 30000, 30091, 30098, 30326, 30333, 30382, 30399, 30446, 30683, 30690, 30707, 31034, 31160, 31166, 31348, 31435, 31481, 31859, 31992, 32566, 32593, 32650, 32701, 32769, 32780, 32786, 32819, 32895, 32905, 33251, 33258, 33267, 33276, 33292, 33307, 33311, 33390, 33394, 33400, 34381, 34411, 34880, 34892, 34915, 35198, 35211, 35282, 35328, 35895, 35910, 35925, 35960, 35997, 36196, 36208, 36275, 36523, 36554, 36763, 36784, 36789, 37009, 37193, 37318, 37324, 37329, 38263, 38272, 38428, 38582, 38585, 38632, 38737, 38750, 38754, 38761, 38859, 38893, 38899, 38913, 39080, 39131, 39135, 39318, 39321, 39340, 39592, 39640, 39647, 39717, 39727, 39730, 39740, 39770, 40165, 40565, 40575, 40613, 40635, 40643, 40653, 40657, 40697, 40701, 40718, 40723, 40736, 40763, 40778, 40786, 40845, 40860, 40864, 32, 12306, 21313, 21316, 21317, 12363, 12441, 12365, 12441, 12367, 12441, 12369, 12441, 12371, 12441, 12373, 12441, 12375, 12441, 12377, 12441, 12379, 12441, 12381, 12441, 12383, 12441, 12385, 12441, 12388, 12441, 12390, 12441, 12392, 12441, 12399, 12441, 12399, 12442, 12402, 12441, 12402, 12442, 12405, 12441, 12405, 12442, 12408, 12441, 12408, 12442, 12411, 12441, 12411, 12442, 12358, 12441, 32, 12441, 32, 12442, 12445, 12441, 12424, 12426, 12459, 12441, 12461, 12441, 12463, 12441, 12465, 12441, 12467, 12441, 12469, 12441, 12471, 12441, 12473, 12441, 12475, 12441, 12477, 12441, 12479, 12441, 12481, 12441, 12484, 12441, 12486, 12441, 12488, 12441, 12495, 12441, 12495, 12442, 12498, 12441, 12498, 12442, 12501, 12441, 12501, 12442, 12504, 12441, 12504, 12442, 12507, 12441, 12507, 12442, 12454, 12441, 12527, 12441, 12528, 12441, 12529, 12441, 12530, 12441, 12541, 12441, 12467, 12488, 4352, 4353, 4522, 4354, 4524, 4525, 4355, 4356, 4357, 4528, 4529, 4530, 4531, 4532, 4533, 4378, 4358, 4359, 4360, 4385, 4361, 4362, 4363, 4364, 4365, 4366, 4367, 4368, 4369, 4370, 4449, 4450, 4451, 4452, 4453, 4454, 4455, 4456, 4457, 4458, 4459, 4460, 4461, 4462, 4463, 4464, 4465, 4466, 4467, 4468, 4469, 4448, 4372, 4373, 4551, 4552, 4556, 4558, 4563, 4567, 4569, 4380, 4573, 4575, 4381, 4382, 4384, 4386, 4387, 4391, 4393, 4395, 4396, 4397, 4398, 4399, 4402, 4406, 4416, 4423, 4428, 4593, 4594, 4439, 4440, 4441, 4484, 4485, 4488, 4497, 4498, 4500, 4510, 4513, 19968, 20108, 19977, 22235, 19978, 20013, 19979, 30002, 20057, 19993, 19969, 22825, 22320, 20154, 40, 4352, 41, 40, 4354, 41, 40, 4355, 41, 40, 4357, 41, 40, 4358, 41, 40, 4359, 41, 40, 4361, 41, 40, 4363, 41, 40, 4364, 41, 40, 4366, 41, 40, 4367, 41, 40, 4368, 41, 40, 4369, 41, 40, 4370, 41, 40, 4352, 4449, 41, 40, 4354, 4449, 41, 40, 4355, 4449, 41, 40, 4357, 4449, 41, 40, 4358, 4449, 41, 40, 4359, 4449, 41, 40, 4361, 4449, 41, 40, 4363, 4449, 41, 40, 4364, 4449, 41, 40, 4366, 4449, 41, 40, 4367, 4449, 41, 40, 4368, 4449, 41, 40, 4369, 4449, 41, 40, 4370, 4449, 41, 40, 4364, 4462, 41, 40, 4363, 4457, 4364, 4453, 4523, 41, 40, 4363, 4457, 4370, 4462, 41, 40, 19968, 41, 40, 20108, 41, 40, 19977, 41, 40, 22235, 41, 40, 20116, 41, 40, 20845, 41, 40, 19971, 41, 40, 20843, 41, 40, 20061, 41, 40, 21313, 41, 40, 26376, 41, 40, 28779, 41, 40, 27700, 41, 40, 26408, 41, 40, 37329, 41, 40, 22303, 41, 40, 26085, 41, 40, 26666, 41, 40, 26377, 41, 40, 31038, 41, 40, 21517, 41, 40, 29305, 41, 40, 36001, 41, 40, 31069, 41, 40, 21172, 41, 40, 20195, 41, 40, 21628, 41, 40, 23398, 41, 40, 30435, 41, 40, 20225, 41, 40, 36039, 41, 40, 21332, 41, 40, 31085, 41, 40, 20241, 41, 40, 33258, 41, 40, 33267, 41, 21839, 24188, 25991, 31631, 80, 84, 69, 50, 49, 50, 50, 50, 51, 50, 52, 50, 53, 50, 54, 50, 55, 50, 56, 50, 57, 51, 48, 51, 49, 51, 50, 51, 51, 51, 52, 51, 53, 4352, 4354, 4355, 4357, 4358, 4359, 4361, 4363, 4364, 4366, 4367, 4368, 4369, 4370, 4352, 4449, 4354, 4449, 4355, 4449, 4357, 4449, 4358, 4449, 4359, 4449, 4361, 4449, 4363, 4449, 4364, 4449, 4366, 4449, 4367, 4449, 4368, 4449, 4369, 4449, 4370, 4449, 4366, 4449, 4535, 4352, 4457, 4364, 4462, 4363, 4468, 4363, 4462, 19968, 20108, 19977, 22235, 20116, 20845, 19971, 20843, 20061, 21313, 26376, 28779, 27700, 26408, 37329, 22303, 26085, 26666, 26377, 31038, 21517, 29305, 36001, 31069, 21172, 31192, 30007, 22899, 36969, 20778, 21360, 27880, 38917, 20241, 20889, 27491, 19978, 20013, 19979, 24038, 21491, 21307, 23447, 23398, 30435, 20225, 36039, 21332, 22812, 51, 54, 51, 55, 51, 56, 51, 57, 52, 48, 52, 49, 52, 50, 52, 51, 52, 52, 52, 53, 52, 54, 52, 55, 52, 56, 52, 57, 53, 48, 49, 26376, 50, 26376, 51, 26376, 52, 26376, 53, 26376, 54, 26376, 55, 26376, 56, 26376, 57, 26376, 49, 48, 26376, 49, 49, 26376, 49, 50, 26376, 72, 103, 101, 114, 103, 101, 86, 76, 84, 68, 12450, 12452, 12454, 12456, 12458, 12459, 12461, 12463, 12465, 12467, 12469, 12471, 12473, 12475, 12477, 12479, 12481, 12484, 12486, 12488, 12490, 12491, 12492, 12493, 12494, 12495, 12498, 12501, 12504, 12507, 12510, 12511, 12512, 12513, 12514, 12516, 12518, 12520, 12521, 12522, 12523, 12524, 12525, 12527, 12528, 12529, 12530, 20196, 21644, 12450, 12497, 12540, 12488, 12450, 12523, 12501, 12449, 12450, 12531, 12506, 12450, 12450, 12540, 12523, 12452, 12491, 12531, 12464, 12452, 12531, 12481, 12454, 12457, 12531, 12456, 12473, 12463, 12540, 12489, 12456, 12540, 12459, 12540, 12458, 12531, 12473, 12458, 12540, 12512, 12459, 12452, 12522, 12459, 12521, 12483, 12488, 12459, 12525, 12522, 12540, 12460, 12525, 12531, 12460, 12531, 12510, 12462, 12460, 12462, 12491, 12540, 12461, 12517, 12522, 12540, 12462, 12523, 12480, 12540, 12461, 12525, 12461, 12525, 12464, 12521, 12512, 12461, 12525, 12513, 12540, 12488, 12523, 12461, 12525, 12527, 12483, 12488, 12464, 12521, 12512, 12464, 12521, 12512, 12488, 12531, 12463, 12523, 12476, 12452, 12525, 12463, 12525, 12540, 12493, 12465, 12540, 12473, 12467, 12523, 12490, 12467, 12540, 12509, 12469, 12452, 12463, 12523, 12469, 12531, 12481, 12540, 12512, 12471, 12522, 12531, 12464, 12475, 12531, 12481, 12475, 12531, 12488, 12480, 12540, 12473, 12487, 12471, 12489, 12523, 12488, 12531, 12490, 12494, 12494, 12483, 12488, 12495, 12452, 12484, 12497, 12540, 12475, 12531, 12488, 12497, 12540, 12484, 12496, 12540, 12524, 12523, 12500, 12450, 12473, 12488, 12523, 12500, 12463, 12523, 12500, 12467, 12499, 12523, 12501, 12449, 12521, 12483, 12489, 12501, 12451, 12540, 12488, 12502, 12483, 12471, 12455, 12523, 12501, 12521, 12531, 12504, 12463, 12479, 12540, 12523, 12506, 12477, 12506, 12491, 12498, 12504, 12523, 12484, 12506, 12531, 12473, 12506, 12540, 12472, 12505, 12540, 12479, 12509, 12452, 12531, 12488, 12508, 12523, 12488, 12507, 12531, 12509, 12531, 12489, 12507, 12540, 12523, 12507, 12540, 12531, 12510, 12452, 12463, 12525, 12510, 12452, 12523, 12510, 12483, 12495, 12510, 12523, 12463, 12510, 12531, 12471, 12519, 12531, 12511, 12463, 12525, 12531, 12511, 12522, 12511, 12522, 12496, 12540, 12523, 12513, 12460, 12513, 12460, 12488, 12531, 12513, 12540, 12488, 12523, 12516, 12540, 12489, 12516, 12540, 12523, 12518, 12450, 12531, 12522, 12483, 12488, 12523, 12522, 12521, 12523, 12500, 12540, 12523, 12540, 12502, 12523, 12524, 12512, 12524, 12531, 12488, 12466, 12531, 12527, 12483, 12488, 48, 28857, 49, 28857, 50, 28857, 51, 28857, 52, 28857, 53, 28857, 54, 28857, 55, 28857, 56, 28857, 57, 28857, 49, 48, 28857, 49, 49, 28857, 49, 50, 28857, 49, 51, 28857, 49, 52, 28857, 49, 53, 28857, 49, 54, 28857, 49, 55, 28857, 49, 56, 28857, 49, 57, 28857, 50, 48, 28857, 50, 49, 28857, 50, 50, 28857, 50, 51, 28857, 50, 52, 28857, 104, 80, 97, 100, 97, 65, 85, 98, 97, 114, 111, 86, 112, 99, 100, 109, 100, 109, 178, 100, 109, 179, 73, 85, 24179, 25104, 26157, 21644, 22823, 27491, 26126, 27835, 26666, 24335, 20250, 31038, 112, 65, 110, 65, 956, 65, 109, 65, 107, 65, 75, 66, 77, 66, 71, 66, 99, 97, 108, 107, 99, 97, 108, 112, 70, 110, 70, 956, 70, 956, 103, 109, 103, 107, 103, 72, 122, 107, 72, 122, 77, 72, 122, 71, 72, 122, 84, 72, 122, 956, 8467, 109, 8467, 100, 8467, 107, 8467, 102, 109, 110, 109, 956, 109, 109, 109, 99, 109, 107, 109, 109, 109, 178, 99, 109, 178, 109, 178, 107, 109, 178, 109, 109, 179, 99, 109, 179, 109, 179, 107, 109, 179, 109, 8725, 115, 109, 8725, 115, 178, 80, 97, 107, 80, 97, 77, 80, 97, 71, 80, 97, 114, 97, 100, 114, 97, 100, 8725, 115, 114, 97, 100, 8725, 115, 178, 112, 115, 110, 115, 956, 115, 109, 115, 112, 86, 110, 86, 956, 86, 109, 86, 107, 86, 77, 86, 112, 87, 110, 87, 956, 87, 109, 87, 107, 87, 77, 87, 107, 937, 77, 937, 97, 46, 109, 46, 66, 113, 99, 99, 99, 100, 67, 8725, 107, 103, 67, 111, 46, 100, 66, 71, 121, 104, 97, 72, 80, 105, 110, 75, 75, 75, 77, 107, 116, 108, 109, 108, 110, 108, 111, 103, 108, 120, 109, 98, 109, 105, 108, 109, 111, 108, 80, 72, 112, 46, 109, 46, 80, 80, 77, 80, 82, 115, 114, 83, 118, 87, 98, 86, 8725, 109, 65, 8725, 109, 49, 26085, 50, 26085, 51, 26085, 52, 26085, 53, 26085, 54, 26085, 55, 26085, 56, 26085, 57, 26085, 49, 48, 26085, 49, 49, 26085, 49, 50, 26085, 49, 51, 26085, 49, 52, 26085, 49, 53, 26085, 49, 54, 26085, 49, 55, 26085, 49, 56, 26085, 49, 57, 26085, 50, 48, 26085, 50, 49, 26085, 50, 50, 26085, 50, 51, 26085, 50, 52, 26085, 50, 53, 26085, 50, 54, 26085, 50, 55, 26085, 50, 56, 26085, 50, 57, 26085, 51, 48, 26085, 51, 49, 26085, 103, 97, 108, 1098, 1100, 42863, 67, 70, 81, 294, 339, 42791, 43831, 619, 43858, 653, 35912, 26356, 36554, 36040, 28369, 20018, 21477, 40860, 40860, 22865, 37329, 21895, 22856, 25078, 30313, 32645, 34367, 34746, 35064, 37007, 27138, 27931, 28889, 29662, 33853, 37226, 39409, 20098, 21365, 27396, 29211, 34349, 40478, 23888, 28651, 34253, 35172, 25289, 33240, 34847, 24266, 26391, 28010, 29436, 37070, 20358, 20919, 21214, 25796, 27347, 29200, 30439, 32769, 34310, 34396, 36335, 38706, 39791, 40442, 30860, 31103, 32160, 33737, 37636, 40575, 35542, 22751, 24324, 31840, 32894, 29282, 30922, 36034, 38647, 22744, 23650, 27155, 28122, 28431, 32047, 32311, 38475, 21202, 32907, 20956, 20940, 31260, 32190, 33777, 38517, 35712, 25295, 27138, 35582, 20025, 23527, 24594, 29575, 30064, 21271, 30971, 20415, 24489, 19981, 27852, 25976, 32034, 21443, 22622, 30465, 33865, 35498, 27578, 36784, 27784, 25342, 33509, 25504, 30053, 20142, 20841, 20937, 26753, 31975, 33391, 35538, 37327, 21237, 21570, 22899, 24300, 26053, 28670, 31018, 38317, 39530, 40599, 40654, 21147, 26310, 27511, 36706, 24180, 24976, 25088, 25754, 28451, 29001, 29833, 31178, 32244, 32879, 36646, 34030, 36899, 37706, 21015, 21155, 21693, 28872, 35010, 35498, 24265, 24565, 25467, 27566, 31806, 29557, 20196, 22265, 23527, 23994, 24604, 29618, 29801, 32666, 32838, 37428, 38646, 38728, 38936, 20363, 31150, 37300, 38584, 24801, 20102, 20698, 23534, 23615, 26009, 27138, 29134, 30274, 34044, 36988, 40845, 26248, 38446, 21129, 26491, 26611, 27969, 28316, 29705, 30041, 30827, 32016, 39006, 20845, 25134, 38520, 20523, 23833, 28138, 36650, 24459, 24900, 26647, 29575, 38534, 21033, 21519, 23653, 26131, 26446, 26792, 27877, 29702, 30178, 32633, 35023, 35041, 37324, 38626, 21311, 28346, 21533, 29136, 29848, 34298, 38563, 40023, 40607, 26519, 28107, 33256, 31435, 31520, 31890, 29376, 28825, 35672, 20160, 33590, 21050, 20999, 24230, 25299, 31958, 23429, 27934, 26292, 36667, 34892, 38477, 35211, 24275, 20800, 21952, 22618, 26228, 20958, 29482, 30410, 31036, 31070, 31077, 31119, 38742, 31934, 32701, 34322, 35576, 36920, 37117, 39151, 39164, 39208, 40372, 37086, 38583, 20398, 20711, 20813, 21193, 21220, 21329, 21917, 22022, 22120, 22592, 22696, 23652, 23662, 24724, 24936, 24974, 25074, 25935, 26082, 26257, 26757, 28023, 28186, 28450, 29038, 29227, 29730, 30865, 31038, 31049, 31048, 31056, 31062, 31069, 31117, 31118, 31296, 31361, 31680, 32244, 32265, 32321, 32626, 32773, 33261, 33401, 33401, 33879, 35088, 35222, 35585, 35641, 36051, 36104, 36790, 36920, 38627, 38911, 38971, 24693, 148206, 33304, 20006, 20917, 20840, 20352, 20805, 20864, 21191, 21242, 21917, 21845, 21913, 21986, 22618, 22707, 22852, 22868, 23138, 23336, 24274, 24281, 24425, 24493, 24792, 24910, 24840, 24974, 24928, 25074, 25140, 25540, 25628, 25682, 25942, 26228, 26391, 26395, 26454, 27513, 27578, 27969, 28379, 28363, 28450, 28702, 29038, 30631, 29237, 29359, 29482, 29809, 29958, 30011, 30237, 30239, 30410, 30427, 30452, 30538, 30528, 30924, 31409, 31680, 31867, 32091, 32244, 32574, 32773, 33618, 33775, 34681, 35137, 35206, 35222, 35519, 35576, 35531, 35585, 35582, 35565, 35641, 35722, 36104, 36664, 36978, 37273, 37494, 38524, 38627, 38742, 38875, 38911, 38923, 38971, 39698, 40860, 141386, 141380, 144341, 15261, 16408, 16441, 152137, 154832, 163539, 40771, 40846, 102, 102, 102, 105, 102, 108, 102, 102, 105, 102, 102, 108, 383, 116, 115, 116, 1396, 1398, 1396, 1381, 1396, 1387, 1406, 1398, 1396, 1389, 1497, 1460, 1522, 1463, 1506, 1488, 1491, 1492, 1499, 1500, 1501, 1512, 1514, 43, 1513, 1473, 1513, 1474, 64329, 1473, 64329, 1474, 1488, 1463, 1488, 1464, 1488, 1468, 1489, 1468, 1490, 1468, 1491, 1468, 1492, 1468, 1493, 1468, 1494, 1468, 1496, 1468, 1497, 1468, 1498, 1468, 1499, 1468, 1500, 1468, 1502, 1468, 1504, 1468, 1505, 1468, 1507, 1468, 1508, 1468, 1510, 1468, 1511, 1468, 1512, 1468, 1513, 1468, 1514, 1468, 1493, 1465, 1489, 1471, 1499, 1471, 1508, 1471, 1488, 1500, 1649, 1649, 1659, 1659, 1659, 1659, 1662, 1662, 1662, 1662, 1664, 1664, 1664, 1664, 1658, 1658, 1658, 1658, 1663, 1663, 1663, 1663, 1657, 1657, 1657, 1657, 1700, 1700, 1700, 1700, 1702, 1702, 1702, 1702, 1668, 1668, 1668, 1668, 1667, 1667, 1667, 1667, 1670, 1670, 1670, 1670, 1671, 1671, 1671, 1671, 1677, 1677, 1676, 1676, 1678, 1678, 1672, 1672, 1688, 1688, 1681, 1681, 1705, 1705, 1705, 1705, 1711, 1711, 1711, 1711, 1715, 1715, 1715, 1715, 1713, 1713, 1713, 1713, 1722, 1722, 1723, 1723, 1723, 1723, 1728, 1728, 1729, 1729, 1729, 1729, 1726, 1726, 1726, 1726, 1746, 1746, 1747, 1747, 1709, 1709, 1709, 1709, 1735, 1735, 1734, 1734, 1736, 1736, 1655, 1739, 1739, 1733, 1733, 1737, 1737, 1744, 1744, 1744, 1744, 1609, 1609, 1574, 1575, 1574, 1575, 1574, 1749, 1574, 1749, 1574, 1608, 1574, 1608, 1574, 1735, 1574, 1735, 1574, 1734, 1574, 1734, 1574, 1736, 1574, 1736, 1574, 1744, 1574, 1744, 1574, 1744, 1574, 1609, 1574, 1609, 1574, 1609, 1740, 1740, 1740, 1740, 1574, 1580, 1574, 1581, 1574, 1605, 1574, 1609, 1574, 1610, 1576, 1580, 1576, 1581, 1576, 1582, 1576, 1605, 1576, 1609, 1576, 1610, 1578, 1580, 1578, 1581, 1578, 1582, 1578, 1605, 1578, 1609, 1578, 1610, 1579, 1580, 1579, 1605, 1579, 1609, 1579, 1610, 1580, 1581, 1580, 1605, 1581, 1580, 1581, 1605, 1582, 1580, 1582, 1581, 1582, 1605, 1587, 1580, 1587, 1581, 1587, 1582, 1587, 1605, 1589, 1581, 1589, 1605, 1590, 1580, 1590, 1581, 1590, 1582, 1590, 1605, 1591, 1581, 1591, 1605, 1592, 1605, 1593, 1580, 1593, 1605, 1594, 1580, 1594, 1605, 1601, 1580, 1601, 1581, 1601, 1582, 1601, 1605, 1601, 1609, 1601, 1610, 1602, 1581, 1602, 1605, 1602, 1609, 1602, 1610, 1603, 1575, 1603, 1580, 1603, 1581, 1603, 1582, 1603, 1604, 1603, 1605, 1603, 1609, 1603, 1610, 1604, 1580, 1604, 1581, 1604, 1582, 1604, 1605, 1604, 1609, 1604, 1610, 1605, 1580, 1605, 1581, 1605, 1582, 1605, 1605, 1605, 1609, 1605, 1610, 1606, 1580, 1606, 1581, 1606, 1582, 1606, 1605, 1606, 1609, 1606, 1610, 1607, 1580, 1607, 1605, 1607, 1609, 1607, 1610, 1610, 1580, 1610, 1581, 1610, 1582, 1610, 1605, 1610, 1609, 1610, 1610, 1584, 1648, 1585, 1648, 1609, 1648, 32, 1612, 1617, 32, 1613, 1617, 32, 1614, 1617, 32, 1615, 1617, 32, 1616, 1617, 32, 1617, 1648, 1574, 1585, 1574, 1586, 1574, 1605, 1574, 1606, 1574, 1609, 1574, 1610, 1576, 1585, 1576, 1586, 1576, 1605, 1576, 1606, 1576, 1609, 1576, 1610, 1578, 1585, 1578, 1586, 1578, 1605, 1578, 1606, 1578, 1609, 1578, 1610, 1579, 1585, 1579, 1586, 1579, 1605, 1579, 1606, 1579, 1609, 1579, 1610, 1601, 1609, 1601, 1610, 1602, 1609, 1602, 1610, 1603, 1575, 1603, 1604, 1603, 1605, 1603, 1609, 1603, 1610, 1604, 1605, 1604, 1609, 1604, 1610, 1605, 1575, 1605, 1605, 1606, 1585, 1606, 1586, 1606, 1605, 1606, 1606, 1606, 1609, 1606, 1610, 1609, 1648, 1610, 1585, 1610, 1586, 1610, 1605, 1610, 1606, 1610, 1609, 1610, 1610, 1574, 1580, 1574, 1581, 1574, 1582, 1574, 1605, 1574, 1607, 1576, 1580, 1576, 1581, 1576, 1582, 1576, 1605, 1576, 1607, 1578, 1580, 1578, 1581, 1578, 1582, 1578, 1605, 1578, 1607, 1579, 1605, 1580, 1581, 1580, 1605, 1581, 1580, 1581, 1605, 1582, 1580, 1582, 1605, 1587, 1580, 1587, 1581, 1587, 1582, 1587, 1605, 1589, 1581, 1589, 1582, 1589, 1605, 1590, 1580, 1590, 1581, 1590, 1582, 1590, 1605, 1591, 1581, 1592, 1605, 1593, 1580, 1593, 1605, 1594, 1580, 1594, 1605, 1601, 1580, 1601, 1581, 1601, 1582, 1601, 1605, 1602, 1581, 1602, 1605, 1603, 1580, 1603, 1581, 1603, 1582, 1603, 1604, 1603, 1605, 1604, 1580, 1604, 1581, 1604, 1582, 1604, 1605, 1604, 1607, 1605, 1580, 1605, 1581, 1605, 1582, 1605, 1605, 1606, 1580, 1606, 1581, 1606, 1582, 1606, 1605, 1606, 1607, 1607, 1580, 1607, 1605, 1607, 1648, 1610, 1580, 1610, 1581, 1610, 1582, 1610, 1605, 1610, 1607, 1574, 1605, 1574, 1607, 1576, 1605, 1576, 1607, 1578, 1605, 1578, 1607, 1579, 1605, 1579, 1607, 1587, 1605, 1587, 1607, 1588, 1605, 1588, 1607, 1603, 1604, 1603, 1605, 1604, 1605, 1606, 1605, 1606, 1607, 1610, 1605, 1610, 1607, 1600, 1614, 1617, 1600, 1615, 1617, 1600, 1616, 1617, 1591, 1609, 1591, 1610, 1593, 1609, 1593, 1610, 1594, 1609, 1594, 1610, 1587, 1609, 1587, 1610, 1588, 1609, 1588, 1610, 1581, 1609, 1581, 1610, 1580, 1609, 1580, 1610, 1582, 1609, 1582, 1610, 1589, 1609, 1589, 1610, 1590, 1609, 1590, 1610, 1588, 1580, 1588, 1581, 1588, 1582, 1588, 1605, 1588, 1585, 1587, 1585, 1589, 1585, 1590, 1585, 1591, 1609, 1591, 1610, 1593, 1609, 1593, 1610, 1594, 1609, 1594, 1610, 1587, 1609, 1587, 1610, 1588, 1609, 1588, 1610, 1581, 1609, 1581, 1610, 1580, 1609, 1580, 1610, 1582, 1609, 1582, 1610, 1589, 1609, 1589, 1610, 1590, 1609, 1590, 1610, 1588, 1580, 1588, 1581, 1588, 1582, 1588, 1605, 1588, 1585, 1587, 1585, 1589, 1585, 1590, 1585, 1588, 1580, 1588, 1581, 1588, 1582, 1588, 1605, 1587, 1607, 1588, 1607, 1591, 1605, 1587, 1580, 1587, 1581, 1587, 1582, 1588, 1580, 1588, 1581, 1588, 1582, 1591, 1605, 1592, 1605, 1575, 1611, 1575, 1611, 1578, 1580, 1605, 1578, 1581, 1580, 1578, 1581, 1580, 1578, 1581, 1605, 1578, 1582, 1605, 1578, 1605, 1580, 1578, 1605, 1581, 1578, 1605, 1582, 1580, 1605, 1581, 1580, 1605, 1581, 1581, 1605, 1610, 1581, 1605, 1609, 1587, 1581, 1580, 1587, 1580, 1581, 1587, 1580, 1609, 1587, 1605, 1581, 1587, 1605, 1581, 1587, 1605, 1580, 1587, 1605, 1605, 1587, 1605, 1605, 1589, 1581, 1581, 1589, 1581, 1581, 1589, 1605, 1605, 1588, 1581, 1605, 1588, 1581, 1605, 1588, 1580, 1610, 1588, 1605, 1582, 1588, 1605, 1582, 1588, 1605, 1605, 1588, 1605, 1605, 1590, 1581, 1609, 1590, 1582, 1605, 1590, 1582, 1605, 1591, 1605, 1581, 1591, 1605, 1581, 1591, 1605, 1605, 1591, 1605, 1610, 1593, 1580, 1605, 1593, 1605, 1605, 1593, 1605, 1605, 1593, 1605, 1609, 1594, 1605, 1605, 1594, 1605, 1610, 1594, 1605, 1609, 1601, 1582, 1605, 1601, 1582, 1605, 1602, 1605, 1581, 1602, 1605, 1605, 1604, 1581, 1605, 1604, 1581, 1610, 1604, 1581, 1609, 1604, 1580, 1580, 1604, 1580, 1580, 1604, 1582, 1605, 1604, 1582, 1605, 1604, 1605, 1581, 1604, 1605, 1581, 1605, 1581, 1580, 1605, 1581, 1605, 1605, 1581, 1610, 1605, 1580, 1581, 1605, 1580, 1605, 1605, 1582, 1580, 1605, 1582, 1605, 1605, 1580, 1582, 1607, 1605, 1580, 1607, 1605, 1605, 1606, 1581, 1605, 1606, 1581, 1609, 1606, 1580, 1605, 1606, 1580, 1605, 1606, 1580, 1609, 1606, 1605, 1610, 1606, 1605, 1609, 1610, 1605, 1605, 1610, 1605, 1605, 1576, 1582, 1610, 1578, 1580, 1610, 1578, 1580, 1609, 1578, 1582, 1610, 1578, 1582, 1609, 1578, 1605, 1610, 1578, 1605, 1609, 1580, 1605, 1610, 1580, 1581, 1609, 1580, 1605, 1609, 1587, 1582, 1609, 1589, 1581, 1610, 1588, 1581, 1610, 1590, 1581, 1610, 1604, 1580, 1610, 1604, 1605, 1610, 1610, 1581, 1610, 1610, 1580, 1610, 1610, 1605, 1610, 1605, 1605, 1610, 1602, 1605, 1610, 1606, 1581, 1610, 1602, 1605, 1581, 1604, 1581, 1605, 1593, 1605, 1610, 1603, 1605, 1610, 1606, 1580, 1581, 1605, 1582, 1610, 1604, 1580, 1605, 1603, 1605, 1605, 1604, 1580, 1605, 1606, 1580, 1581, 1580, 1581, 1610, 1581, 1580, 1610, 1605, 1580, 1610, 1601, 1605, 1610, 1576, 1581, 1610, 1603, 1605, 1605, 1593, 1580, 1605, 1589, 1605, 1605, 1587, 1582, 1610, 1606, 1580, 1610, 1589, 1604, 1746, 1602, 1604, 1746, 1575, 1604, 1604, 1607, 1575, 1603, 1576, 1585, 1605, 1581, 1605, 1583, 1589, 1604, 1593, 1605, 1585, 1587, 1608, 1604, 1593, 1604, 1610, 1607, 1608, 1587, 1604, 1605, 1589, 1604, 1609, 1589, 1604, 1609, 32, 1575, 1604, 1604, 1607, 32, 1593, 1604, 1610, 1607, 32, 1608, 1587, 1604, 1605, 1580, 1604, 32, 1580, 1604, 1575, 1604, 1607, 1585, 1740, 1575, 1604, 44, 12289, 12290, 58, 59, 33, 63, 12310, 12311, 8230, 8229, 8212, 8211, 95, 95, 40, 41, 123, 125, 12308, 12309, 12304, 12305, 12298, 12299, 12296, 12297, 12300, 12301, 12302, 12303, 91, 93, 8254, 8254, 8254, 8254, 95, 95, 95, 44, 12289, 46, 59, 58, 63, 33, 8212, 40, 41, 123, 125, 12308, 12309, 35, 38, 42, 43, 45, 60, 62, 61, 92, 36, 37, 64, 32, 1611, 1600, 1611, 32, 1612, 32, 1613, 32, 1614, 1600, 1614, 32, 1615, 1600, 1615, 32, 1616, 1600, 1616, 32, 1617, 1600, 1617, 32, 1618, 1600, 1618, 1569, 1570, 1570, 1571, 1571, 1572, 1572, 1573, 1573, 1574, 1574, 1574, 1574, 1575, 1575, 1576, 1576, 1576, 1576, 1577, 1577, 1578, 1578, 1578, 1578, 1579, 1579, 1579, 1579, 1580, 1580, 1580, 1580, 1581, 1581, 1581, 1581, 1582, 1582, 1582, 1582, 1583, 1583, 1584, 1584, 1585, 1585, 1586, 1586, 1587, 1587, 1587, 1587, 1588, 1588, 1588, 1588, 1589, 1589, 1589, 1589, 1590, 1590, 1590, 1590, 1591, 1591, 1591, 1591, 1592, 1592, 1592, 1592, 1593, 1593, 1593, 1593, 1594, 1594, 1594, 1594, 1601, 1601, 1601, 1601, 1602, 1602, 1602, 1602, 1603, 1603, 1603, 1603, 1604, 1604, 1604, 1604, 1605, 1605, 1605, 1605, 1606, 1606, 1606, 1606, 1607, 1607, 1607, 1607, 1608, 1608, 1609, 1609, 1610, 1610, 1610, 1610, 1604, 1570, 1604, 1570, 1604, 1571, 1604, 1571, 1604, 1573, 1604, 1573, 1604, 1575, 1604, 1575, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 10629, 10630, 12290, 12300, 12301, 12289, 12539, 12530, 12449, 12451, 12453, 12455, 12457, 12515, 12517, 12519, 12483, 12540, 12450, 12452, 12454, 12456, 12458, 12459, 12461, 12463, 12465, 12467, 12469, 12471, 12473, 12475, 12477, 12479, 12481, 12484, 12486, 12488, 12490, 12491, 12492, 12493, 12494, 12495, 12498, 12501, 12504, 12507, 12510, 12511, 12512, 12513, 12514, 12516, 12518, 12520, 12521, 12522, 12523, 12524, 12525, 12527, 12531, 12441, 12442, 12644, 12593, 12594, 12595, 12596, 12597, 12598, 12599, 12600, 12601, 12602, 12603, 12604, 12605, 12606, 12607, 12608, 12609, 12610, 12611, 12612, 12613, 12614, 12615, 12616, 12617, 12618, 12619, 12620, 12621, 12622, 12623, 12624, 12625, 12626, 12627, 12628, 12629, 12630, 12631, 12632, 12633, 12634, 12635, 12636, 12637, 12638, 12639, 12640, 12641, 12642, 12643, 162, 163, 172, 175, 166, 165, 8361, 9474, 8592, 8593, 8594, 8595, 9632, 9675, 67026, 775, 67034, 775, 720, 721, 230, 665, 595, 675, 43878, 677, 676, 598, 599, 7569, 600, 606, 681, 612, 610, 608, 667, 295, 668, 615, 644, 682, 683, 620, 122628, 42894, 622, 122629, 654, 122630, 248, 630, 631, 113, 634, 122632, 637, 638, 640, 680, 678, 43879, 679, 648, 11377, 655, 673, 674, 664, 448, 449, 450, 122634, 122654, 69785, 69818, 69787, 69818, 69797, 69818, 69937, 69927, 69938, 69927, 70471, 70462, 70471, 70487, 70530, 70601, 70532, 70587, 70539, 70594, 70544, 70601, 70594, 70594, 70594, 70584, 70594, 70601, 70841, 70842, 70841, 70832, 70841, 70845, 71096, 71087, 71097, 71087, 71989, 71984, 90398, 90398, 90398, 90409, 90398, 90399, 90409, 90399, 90398, 90400, 90401, 90399, 90402, 90399, 90401, 90400, 93543, 93543, 93539, 93543, 93545, 93543, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 119127, 119141, 119128, 119141, 119135, 119150, 119135, 119151, 119135, 119152, 119135, 119153, 119135, 119154, 119225, 119141, 119226, 119141, 119227, 119150, 119228, 119150, 119227, 119151, 119228, 119151, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 65, 67, 68, 71, 74, 75, 78, 79, 80, 81, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 102, 104, 105, 106, 107, 108, 109, 110, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 65, 66, 68, 69, 70, 71, 74, 75, 76, 77, 78, 79, 80, 81, 83, 84, 85, 86, 87, 88, 89, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 65, 66, 68, 69, 70, 71, 73, 74, 75, 76, 77, 79, 83, 84, 85, 86, 87, 88, 89, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 305, 567, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 1012, 931, 932, 933, 934, 935, 936, 937, 8711, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 8706, 1013, 977, 1008, 981, 1009, 982, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 1012, 931, 932, 933, 934, 935, 936, 937, 8711, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 8706, 1013, 977, 1008, 981, 1009, 982, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 1012, 931, 932, 933, 934, 935, 936, 937, 8711, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 8706, 1013, 977, 1008, 981, 1009, 982, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 1012, 931, 932, 933, 934, 935, 936, 937, 8711, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 8706, 1013, 977, 1008, 981, 1009, 982, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 1012, 931, 932, 933, 934, 935, 936, 937, 8711, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 8706, 1013, 977, 1008, 981, 1009, 982, 988, 989, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1082, 1083, 1084, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1099, 1101, 1102, 42633, 1241, 1110, 1112, 1257, 1199, 1231, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1082, 1083, 1086, 1087, 1089, 1091, 1092, 1093, 1094, 1095, 1096, 1098, 1099, 1169, 1110, 1109, 1119, 1195, 42577, 1201, 1575, 1576, 1580, 1583, 1608, 1586, 1581, 1591, 1610, 1603, 1604, 1605, 1606, 1587, 1593, 1601, 1589, 1602, 1585, 1588, 1578, 1579, 1582, 1584, 1590, 1592, 1594, 1646, 1722, 1697, 1647, 1576, 1580, 1607, 1581, 1610, 1603, 1604, 1605, 1606, 1587, 1593, 1601, 1589, 1602, 1588, 1578, 1579, 1582, 1590, 1594, 1580, 1581, 1610, 1604, 1606, 1587, 1593, 1589, 1602, 1588, 1582, 1590, 1594, 1722, 1647, 1576, 1580, 1607, 1581, 1591, 1610, 1603, 1605, 1606, 1587, 1593, 1601, 1589, 1602, 1588, 1578, 1579, 1582, 1590, 1592, 1594, 1646, 1697, 1575, 1576, 1580, 1583, 1607, 1608, 1586, 1581, 1591, 1610, 1604, 1605, 1606, 1587, 1593, 1601, 1589, 1602, 1585, 1588, 1578, 1579, 1582, 1584, 1590, 1592, 1594, 1576, 1580, 1583, 1608, 1586, 1581, 1591, 1610, 1604, 1605, 1606, 1587, 1593, 1601, 1589, 1602, 1585, 1588, 1578, 1579, 1582, 1584, 1590, 1592, 1594, 48, 46, 48, 44, 49, 44, 50, 44, 51, 44, 52, 44, 53, 44, 54, 44, 55, 44, 56, 44, 57, 44, 40, 65, 41, 40, 66, 41, 40, 67, 41, 40, 68, 41, 40, 69, 41, 40, 70, 41, 40, 71, 41, 40, 72, 41, 40, 73, 41, 40, 74, 41, 40, 75, 41, 40, 76, 41, 40, 77, 41, 40, 78, 41, 40, 79, 41, 40, 80, 41, 40, 81, 41, 40, 82, 41, 40, 83, 41, 40, 84, 41, 40, 85, 41, 40, 86, 41, 40, 87, 41, 40, 88, 41, 40, 89, 41, 40, 90, 41, 12308, 83, 12309, 67, 82, 67, 68, 87, 90, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 72, 86, 77, 86, 83, 68, 83, 83, 80, 80, 86, 87, 67, 77, 67, 77, 68, 77, 82, 68, 74, 12411, 12363, 12467, 12467, 12469, 25163, 23383, 21452, 12487, 20108, 22810, 35299, 22825, 20132, 26144, 28961, 26009, 21069, 24460, 20877, 26032, 21021, 32066, 29983, 36009, 22768, 21561, 28436, 25237, 25429, 19968, 19977, 36938, 24038, 20013, 21491, 25351, 36208, 25171, 31105, 31354, 21512, 28288, 26377, 26376, 30003, 21106, 21942, 37197, 12308, 26412, 12309, 12308, 19977, 12309, 12308, 20108, 12309, 12308, 23433, 12309, 12308, 28857, 12309, 12308, 25171, 12309, 12308, 30423, 12309, 12308, 21213, 12309, 12308, 25943, 12309, 24471, 21487, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 20029, 20024, 20033, 131362, 20320, 20398, 20411, 20482, 20602, 20633, 20711, 20687, 13470, 132666, 20813, 20820, 20836, 20855, 132380, 13497, 20839, 20877, 132427, 20887, 20900, 20172, 20908, 20917, 168415, 20981, 20995, 13535, 21051, 21062, 21106, 21111, 13589, 21191, 21193, 21220, 21242, 21253, 21254, 21271, 21321, 21329, 21338, 21363, 21373, 21375, 21375, 21375, 133676, 28784, 21450, 21471, 133987, 21483, 21489, 21510, 21662, 21560, 21576, 21608, 21666, 21750, 21776, 21843, 21859, 21892, 21892, 21913, 21931, 21939, 21954, 22294, 22022, 22295, 22097, 22132, 20999, 22766, 22478, 22516, 22541, 22411, 22578, 22577, 22700, 136420, 22770, 22775, 22790, 22810, 22818, 22882, 136872, 136938, 23020, 23067, 23079, 23000, 23142, 14062, 14076, 23304, 23358, 23358, 137672, 23491, 23512, 23527, 23539, 138008, 23551, 23558, 24403, 23586, 14209, 23648, 23662, 23744, 23693, 138724, 23875, 138726, 23918, 23915, 23932, 24033, 24034, 14383, 24061, 24104, 24125, 24169, 14434, 139651, 14460, 24240, 24243, 24246, 24266, 172946, 24318, 140081, 140081, 33281, 24354, 24354, 14535, 144056, 156122, 24418, 24427, 14563, 24474, 24525, 24535, 24569, 24705, 14650, 14620, 24724, 141012, 24775, 24904, 24908, 24910, 24908, 24954, 24974, 25010, 24996, 25007, 25054, 25074, 25078, 25104, 25115, 25181, 25265, 25300, 25424, 142092, 25405, 25340, 25448, 25475, 25572, 142321, 25634, 25541, 25513, 14894, 25705, 25726, 25757, 25719, 14956, 25935, 25964, 143370, 26083, 26360, 26185, 15129, 26257, 15112, 15076, 20882, 20885, 26368, 26268, 32941, 17369, 26391, 26395, 26401, 26462, 26451, 144323, 15177, 26618, 26501, 26706, 26757, 144493, 26766, 26655, 26900, 15261, 26946, 27043, 27114, 27304, 145059, 27355, 15384, 27425, 145575, 27476, 15438, 27506, 27551, 27578, 27579, 146061, 138507, 146170, 27726, 146620, 27839, 27853, 27751, 27926, 27966, 28023, 27969, 28009, 28024, 28037, 146718, 27956, 28207, 28270, 15667, 28363, 28359, 147153, 28153, 28526, 147294, 147342, 28614, 28729, 28702, 28699, 15766, 28746, 28797, 28791, 28845, 132389, 28997, 148067, 29084, 148395, 29224, 29237, 29264, 149000, 29312, 29333, 149301, 149524, 29562, 29579, 16044, 29605, 16056, 16056, 29767, 29788, 29809, 29829, 29898, 16155, 29988, 150582, 30014, 150674, 30064, 139679, 30224, 151457, 151480, 151620, 16380, 16392, 30452, 151795, 151794, 151833, 151859, 30494, 30495, 30495, 30538, 16441, 30603, 16454, 16534, 152605, 30798, 30860, 30924, 16611, 153126, 31062, 153242, 153285, 31119, 31211, 16687, 31296, 31306, 31311, 153980, 154279, 154279, 31470, 16898, 154539, 31686, 31689, 16935, 154752, 31954, 17056, 31976, 31971, 32000, 155526, 32099, 17153, 32199, 32258, 32325, 17204, 156200, 156231, 17241, 156377, 32634, 156478, 32661, 32762, 32773, 156890, 156963, 32864, 157096, 32880, 144223, 17365, 32946, 33027, 17419, 33086, 23221, 157607, 157621, 144275, 144284, 33281, 33284, 36766, 17515, 33425, 33419, 33437, 21171, 33457, 33459, 33469, 33510, 158524, 33509, 33565, 33635, 33709, 33571, 33725, 33767, 33879, 33619, 33738, 33740, 33756, 158774, 159083, 158933, 17707, 34033, 34035, 34070, 160714, 34148, 159532, 17757, 17761, 159665, 159954, 17771, 34384, 34396, 34407, 34409, 34473, 34440, 34574, 34530, 34681, 34600, 34667, 34694, 17879, 34785, 34817, 17913, 34912, 34915, 161383, 35031, 35038, 17973, 35066, 13499, 161966, 162150, 18110, 18119, 35488, 35565, 35722, 35925, 162984, 36011, 36033, 36123, 36215, 163631, 133124, 36299, 36284, 36336, 133342, 36564, 36664, 165330, 165357, 37012, 37105, 37137, 165678, 37147, 37432, 37591, 37592, 37500, 37881, 37909, 166906, 38283, 18837, 38327, 167287, 18918, 38595, 23986, 38691, 168261, 168474, 19054, 19062, 38880, 168970, 19122, 169110, 38923, 38923, 38953, 169398, 39138, 19251, 39209, 39335, 39362, 39422, 19406, 170800, 39698, 40000, 40189, 19662, 19693, 40295, 172238, 19704, 172293, 172558, 172689, 40635, 19798, 40697, 40702, 40709, 40719, 40726, 40763, 173568];
const _M0FP410tonyfettes7unicode8internal3ucd12comp__firsts = [60, 61, 62, 65, 65, 65, 65, 65, 65, 65, 65, 65, 65, 65, 65, 65, 65, 65, 65, 66, 66, 66, 67, 67, 67, 67, 67, 68, 68, 68, 68, 68, 68, 69, 69, 69, 69, 69, 69, 69, 69, 69, 69, 69, 69, 69, 69, 69, 69, 69, 70, 71, 71, 71, 71, 71, 71, 71, 72, 72, 72, 72, 72, 72, 72, 73, 73, 73, 73, 73, 73, 73, 73, 73, 73, 73, 73, 73, 73, 73, 74, 75, 75, 75, 75, 75, 76, 76, 76, 76, 76, 76, 77, 77, 77, 78, 78, 78, 78, 78, 78, 78, 78, 78, 79, 79, 79, 79, 79, 79, 79, 79, 79, 79, 79, 79, 79, 79, 79, 79, 80, 80, 82, 82, 82, 82, 82, 82, 82, 82, 83, 83, 83, 83, 83, 83, 83, 84, 84, 84, 84, 84, 84, 84, 85, 85, 85, 85, 85, 85, 85, 85, 85, 85, 85, 85, 85, 85, 85, 85, 85, 85, 85, 86, 86, 87, 87, 87, 87, 87, 87, 88, 88, 89, 89, 89, 89, 89, 89, 89, 89, 89, 90, 90, 90, 90, 90, 90, 97, 97, 97, 97, 97, 97, 97, 97, 97, 97, 97, 97, 97, 97, 97, 97, 98, 98, 98, 99, 99, 99, 99, 99, 100, 100, 100, 100, 100, 100, 101, 101, 101, 101, 101, 101, 101, 101, 101, 101, 101, 101, 101, 101, 101, 101, 101, 102, 103, 103, 103, 103, 103, 103, 103, 104, 104, 104, 104, 104, 104, 104, 104, 105, 105, 105, 105, 105, 105, 105, 105, 105, 105, 105, 105, 105, 105, 106, 106, 107, 107, 107, 107, 107, 108, 108, 108, 108, 108, 108, 109, 109, 109, 110, 110, 110, 110, 110, 110, 110, 110, 110, 111, 111, 111, 111, 111, 111, 111, 111, 111, 111, 111, 111, 111, 111, 111, 111, 112, 112, 114, 114, 114, 114, 114, 114, 114, 114, 115, 115, 115, 115, 115, 115, 115, 116, 116, 116, 116, 116, 116, 116, 116, 117, 117, 117, 117, 117, 117, 117, 117, 117, 117, 117, 117, 117, 117, 117, 117, 117, 117, 117, 118, 118, 119, 119, 119, 119, 119, 119, 119, 120, 120, 121, 121, 121, 121, 121, 121, 121, 121, 121, 121, 122, 122, 122, 122, 122, 122, 168, 168, 168, 194, 194, 194, 194, 196, 197, 198, 198, 199, 202, 202, 202, 202, 207, 212, 212, 212, 212, 213, 213, 213, 214, 216, 220, 220, 220, 220, 226, 226, 226, 226, 228, 229, 230, 230, 231, 234, 234, 234, 234, 239, 244, 244, 244, 244, 245, 245, 245, 246, 248, 252, 252, 252, 252, 258, 258, 258, 258, 259, 259, 259, 259, 274, 274, 275, 275, 332, 332, 333, 333, 346, 347, 352, 353, 360, 361, 362, 363, 383, 416, 416, 416, 416, 416, 417, 417, 417, 417, 417, 431, 431, 431, 431, 431, 432, 432, 432, 432, 432, 439, 490, 491, 550, 551, 552, 553, 558, 559, 658, 776, 913, 913, 913, 913, 913, 913, 913, 917, 917, 917, 917, 919, 919, 919, 919, 919, 921, 921, 921, 921, 921, 921, 921, 927, 927, 927, 927, 929, 933, 933, 933, 933, 933, 933, 937, 937, 937, 937, 937, 940, 942, 945, 945, 945, 945, 945, 945, 945, 945, 949, 949, 949, 949, 951, 951, 951, 951, 951, 951, 953, 953, 953, 953, 953, 953, 953, 953, 959, 959, 959, 959, 961, 961, 965, 965, 965, 965, 965, 965, 965, 965, 969, 969, 969, 969, 969, 969, 970, 970, 970, 971, 971, 971, 974, 978, 978, 1030, 1040, 1040, 1043, 1045, 1045, 1045, 1046, 1046, 1047, 1048, 1048, 1048, 1048, 1050, 1054, 1059, 1059, 1059, 1059, 1063, 1067, 1069, 1072, 1072, 1075, 1077, 1077, 1077, 1078, 1078, 1079, 1080, 1080, 1080, 1080, 1082, 1086, 1091, 1091, 1091, 1091, 1095, 1099, 1101, 1110, 1140, 1141, 1240, 1241, 1256, 1257, 1575, 1575, 1575, 1608, 1610, 1729, 1746, 1749, 2344, 2352, 2355, 2503, 2503, 2887, 2887, 2887, 2962, 3014, 3014, 3015, 3142, 3263, 3270, 3270, 3270, 3274, 3398, 3398, 3399, 3545, 3545, 3545, 3548, 3953, 3953, 3953, 4133, 6917, 6919, 6921, 6923, 6925, 6929, 6970, 6972, 6974, 6975, 6978, 7734, 7735, 7770, 7771, 7778, 7779, 7840, 7840, 7841, 7841, 7864, 7865, 7884, 7885, 7936, 7936, 7936, 7936, 7937, 7937, 7937, 7937, 7938, 7939, 7940, 7941, 7942, 7943, 7944, 7944, 7944, 7944, 7945, 7945, 7945, 7945, 7946, 7947, 7948, 7949, 7950, 7951, 7952, 7952, 7953, 7953, 7960, 7960, 7961, 7961, 7968, 7968, 7968, 7968, 7969, 7969, 7969, 7969, 7970, 7971, 7972, 7973, 7974, 7975, 7976, 7976, 7976, 7976, 7977, 7977, 7977, 7977, 7978, 7979, 7980, 7981, 7982, 7983, 7984, 7984, 7984, 7985, 7985, 7985, 7992, 7992, 7992, 7993, 7993, 7993, 8000, 8000, 8001, 8001, 8008, 8008, 8009, 8009, 8016, 8016, 8016, 8017, 8017, 8017, 8025, 8025, 8025, 8032, 8032, 8032, 8032, 8033, 8033, 8033, 8033, 8034, 8035, 8036, 8037, 8038, 8039, 8040, 8040, 8040, 8040, 8041, 8041, 8041, 8041, 8042, 8043, 8044, 8045, 8046, 8047, 8048, 8052, 8060, 8118, 8127, 8127, 8127, 8134, 8182, 8190, 8190, 8190, 8592, 8594, 8596, 8656, 8658, 8660, 8707, 8712, 8715, 8739, 8741, 8764, 8771, 8773, 8776, 8781, 8801, 8804, 8805, 8818, 8819, 8822, 8823, 8826, 8827, 8828, 8829, 8834, 8835, 8838, 8839, 8849, 8850, 8866, 8872, 8873, 8875, 8882, 8883, 8884, 8885, 12358, 12363, 12365, 12367, 12369, 12371, 12373, 12375, 12377, 12379, 12381, 12383, 12385, 12388, 12390, 12392, 12399, 12399, 12402, 12402, 12405, 12405, 12408, 12408, 12411, 12411, 12445, 12454, 12459, 12461, 12463, 12465, 12467, 12469, 12471, 12473, 12475, 12477, 12479, 12481, 12484, 12486, 12488, 12495, 12495, 12498, 12498, 12501, 12501, 12504, 12504, 12507, 12507, 12527, 12528, 12529, 12530, 12541, 67026, 67034, 69785, 69787, 69797, 69937, 69938, 70471, 70471, 70530, 70532, 70539, 70544, 70594, 70594, 70594, 70841, 70841, 70841, 71096, 71097, 71989, 90398, 90398, 90398, 90398, 90401, 90401, 90402, 90409, 93539, 93543, 93545];
const _M0FP410tonyfettes7unicode8internal3ucd13comp__seconds = [824, 824, 824, 768, 769, 770, 771, 772, 774, 775, 776, 777, 778, 780, 783, 785, 803, 805, 808, 775, 803, 817, 769, 770, 775, 780, 807, 775, 780, 803, 807, 813, 817, 768, 769, 770, 771, 772, 774, 775, 776, 777, 780, 783, 785, 803, 807, 808, 813, 816, 775, 769, 770, 772, 774, 775, 780, 807, 770, 775, 776, 780, 803, 807, 814, 768, 769, 770, 771, 772, 774, 775, 776, 777, 780, 783, 785, 803, 808, 816, 770, 769, 780, 803, 807, 817, 769, 780, 803, 807, 813, 817, 769, 775, 803, 768, 769, 771, 775, 780, 803, 807, 813, 817, 768, 769, 770, 771, 772, 774, 775, 776, 777, 779, 780, 783, 785, 795, 803, 808, 769, 775, 769, 775, 780, 783, 785, 803, 807, 817, 769, 770, 775, 780, 803, 806, 807, 775, 780, 803, 806, 807, 813, 817, 768, 769, 770, 771, 772, 774, 776, 777, 778, 779, 780, 783, 785, 795, 803, 804, 808, 813, 816, 771, 803, 768, 769, 770, 775, 776, 803, 775, 776, 768, 769, 770, 771, 772, 775, 776, 777, 803, 769, 770, 775, 780, 803, 817, 768, 769, 770, 771, 772, 774, 775, 776, 777, 778, 780, 783, 785, 803, 805, 808, 775, 803, 817, 769, 770, 775, 780, 807, 775, 780, 803, 807, 813, 817, 768, 769, 770, 771, 772, 774, 775, 776, 777, 780, 783, 785, 803, 807, 808, 813, 816, 775, 769, 770, 772, 774, 775, 780, 807, 770, 775, 776, 780, 803, 807, 814, 817, 768, 769, 770, 771, 772, 774, 776, 777, 780, 783, 785, 803, 808, 816, 770, 780, 769, 780, 803, 807, 817, 769, 780, 803, 807, 813, 817, 769, 775, 803, 768, 769, 771, 775, 780, 803, 807, 813, 817, 768, 769, 770, 771, 772, 774, 775, 776, 777, 779, 780, 783, 785, 795, 803, 808, 769, 775, 769, 775, 780, 783, 785, 803, 807, 817, 769, 770, 775, 780, 803, 806, 807, 775, 776, 780, 803, 806, 807, 813, 817, 768, 769, 770, 771, 772, 774, 776, 777, 778, 779, 780, 783, 785, 795, 803, 804, 808, 813, 816, 771, 803, 768, 769, 770, 775, 776, 778, 803, 775, 776, 768, 769, 770, 771, 772, 775, 776, 777, 778, 803, 769, 770, 775, 780, 803, 817, 768, 769, 834, 768, 769, 771, 777, 772, 769, 769, 772, 769, 768, 769, 771, 777, 769, 768, 769, 771, 777, 769, 772, 776, 772, 769, 768, 769, 772, 780, 768, 769, 771, 777, 772, 769, 769, 772, 769, 768, 769, 771, 777, 769, 768, 769, 771, 777, 769, 772, 776, 772, 769, 768, 769, 772, 780, 768, 769, 771, 777, 768, 769, 771, 777, 768, 769, 768, 769, 768, 769, 768, 769, 775, 775, 775, 775, 769, 769, 776, 776, 775, 768, 769, 771, 777, 803, 768, 769, 771, 777, 803, 768, 769, 771, 777, 803, 768, 769, 771, 777, 803, 780, 772, 772, 772, 772, 774, 774, 772, 772, 780, 769, 768, 769, 772, 774, 787, 788, 837, 768, 769, 787, 788, 768, 769, 787, 788, 837, 768, 769, 772, 774, 776, 787, 788, 768, 769, 787, 788, 788, 768, 769, 772, 774, 776, 788, 768, 769, 787, 788, 837, 837, 837, 768, 769, 772, 774, 787, 788, 834, 837, 768, 769, 787, 788, 768, 769, 787, 788, 834, 837, 768, 769, 772, 774, 776, 787, 788, 834, 768, 769, 787, 788, 787, 788, 768, 769, 772, 774, 776, 787, 788, 834, 768, 769, 787, 788, 834, 837, 768, 769, 834, 768, 769, 834, 837, 769, 776, 776, 774, 776, 769, 768, 774, 776, 774, 776, 776, 768, 772, 774, 776, 769, 776, 772, 774, 776, 779, 776, 776, 776, 774, 776, 769, 768, 774, 776, 774, 776, 776, 768, 772, 774, 776, 769, 776, 772, 774, 776, 779, 776, 776, 776, 776, 783, 783, 776, 776, 776, 776, 1619, 1620, 1621, 1620, 1620, 1620, 1620, 1620, 2364, 2364, 2364, 2494, 2519, 2878, 2902, 2903, 3031, 3006, 3031, 3006, 3158, 3285, 3266, 3285, 3286, 3285, 3390, 3415, 3390, 3530, 3535, 3551, 3530, 3954, 3956, 3968, 4142, 6965, 6965, 6965, 6965, 6965, 6965, 6965, 6965, 6965, 6965, 6965, 772, 772, 772, 772, 775, 775, 770, 774, 770, 774, 770, 770, 770, 770, 768, 769, 834, 837, 768, 769, 834, 837, 837, 837, 837, 837, 837, 837, 768, 769, 834, 837, 768, 769, 834, 837, 837, 837, 837, 837, 837, 837, 768, 769, 768, 769, 768, 769, 768, 769, 768, 769, 834, 837, 768, 769, 834, 837, 837, 837, 837, 837, 837, 837, 768, 769, 834, 837, 768, 769, 834, 837, 837, 837, 837, 837, 837, 837, 768, 769, 834, 768, 769, 834, 768, 769, 834, 768, 769, 834, 768, 769, 768, 769, 768, 769, 768, 769, 768, 769, 834, 768, 769, 834, 768, 769, 834, 768, 769, 834, 837, 768, 769, 834, 837, 837, 837, 837, 837, 837, 837, 768, 769, 834, 837, 768, 769, 834, 837, 837, 837, 837, 837, 837, 837, 837, 837, 837, 837, 768, 769, 834, 837, 837, 768, 769, 834, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 824, 12441, 12441, 12441, 12441, 12441, 12441, 12441, 12441, 12441, 12441, 12441, 12441, 12441, 12441, 12441, 12441, 12441, 12442, 12441, 12442, 12441, 12442, 12441, 12442, 12441, 12442, 12441, 12441, 12441, 12441, 12441, 12441, 12441, 12441, 12441, 12441, 12441, 12441, 12441, 12441, 12441, 12441, 12441, 12441, 12442, 12441, 12442, 12441, 12442, 12441, 12442, 12441, 12442, 12441, 12441, 12441, 12441, 12441, 775, 775, 69818, 69818, 69818, 69927, 69927, 70462, 70487, 70601, 70587, 70594, 70601, 70584, 70594, 70601, 70832, 70842, 70845, 71087, 71087, 71984, 90398, 90399, 90400, 90409, 90399, 90400, 90399, 90399, 93543, 93543, 93543];
const _M0FP410tonyfettes7unicode8internal3ucd13comp__results = [8814, 8800, 8815, 192, 193, 194, 195, 256, 258, 550, 196, 7842, 197, 461, 512, 514, 7840, 7680, 260, 7682, 7684, 7686, 262, 264, 266, 268, 199, 7690, 270, 7692, 7696, 7698, 7694, 200, 201, 202, 7868, 274, 276, 278, 203, 7866, 282, 516, 518, 7864, 552, 280, 7704, 7706, 7710, 500, 284, 7712, 286, 288, 486, 290, 292, 7714, 7718, 542, 7716, 7720, 7722, 204, 205, 206, 296, 298, 300, 304, 207, 7880, 463, 520, 522, 7882, 302, 7724, 308, 7728, 488, 7730, 310, 7732, 313, 317, 7734, 315, 7740, 7738, 7742, 7744, 7746, 504, 323, 209, 7748, 327, 7750, 325, 7754, 7752, 210, 211, 212, 213, 332, 334, 558, 214, 7886, 336, 465, 524, 526, 416, 7884, 490, 7764, 7766, 340, 7768, 344, 528, 530, 7770, 342, 7774, 346, 348, 7776, 352, 7778, 536, 350, 7786, 356, 7788, 538, 354, 7792, 7790, 217, 218, 219, 360, 362, 364, 220, 7910, 366, 368, 467, 532, 534, 431, 7908, 7794, 370, 7798, 7796, 7804, 7806, 7808, 7810, 372, 7814, 7812, 7816, 7818, 7820, 7922, 221, 374, 7928, 562, 7822, 376, 7926, 7924, 377, 7824, 379, 381, 7826, 7828, 224, 225, 226, 227, 257, 259, 551, 228, 7843, 229, 462, 513, 515, 7841, 7681, 261, 7683, 7685, 7687, 263, 265, 267, 269, 231, 7691, 271, 7693, 7697, 7699, 7695, 232, 233, 234, 7869, 275, 277, 279, 235, 7867, 283, 517, 519, 7865, 553, 281, 7705, 7707, 7711, 501, 285, 7713, 287, 289, 487, 291, 293, 7715, 7719, 543, 7717, 7721, 7723, 7830, 236, 237, 238, 297, 299, 301, 239, 7881, 464, 521, 523, 7883, 303, 7725, 309, 496, 7729, 489, 7731, 311, 7733, 314, 318, 7735, 316, 7741, 7739, 7743, 7745, 7747, 505, 324, 241, 7749, 328, 7751, 326, 7755, 7753, 242, 243, 244, 245, 333, 335, 559, 246, 7887, 337, 466, 525, 527, 417, 7885, 491, 7765, 7767, 341, 7769, 345, 529, 531, 7771, 343, 7775, 347, 349, 7777, 353, 7779, 537, 351, 7787, 7831, 357, 7789, 539, 355, 7793, 7791, 249, 250, 251, 361, 363, 365, 252, 7911, 367, 369, 468, 533, 535, 432, 7909, 7795, 371, 7799, 7797, 7805, 7807, 7809, 7811, 373, 7815, 7813, 7832, 7817, 7819, 7821, 7923, 253, 375, 7929, 563, 7823, 255, 7927, 7833, 7925, 378, 7825, 380, 382, 7827, 7829, 8173, 901, 8129, 7846, 7844, 7850, 7848, 478, 506, 508, 482, 7688, 7872, 7870, 7876, 7874, 7726, 7890, 7888, 7894, 7892, 7756, 556, 7758, 554, 510, 475, 471, 469, 473, 7847, 7845, 7851, 7849, 479, 507, 509, 483, 7689, 7873, 7871, 7877, 7875, 7727, 7891, 7889, 7895, 7893, 7757, 557, 7759, 555, 511, 476, 472, 470, 474, 7856, 7854, 7860, 7858, 7857, 7855, 7861, 7859, 7700, 7702, 7701, 7703, 7760, 7762, 7761, 7763, 7780, 7781, 7782, 7783, 7800, 7801, 7802, 7803, 7835, 7900, 7898, 7904, 7902, 7906, 7901, 7899, 7905, 7903, 7907, 7914, 7912, 7918, 7916, 7920, 7915, 7913, 7919, 7917, 7921, 494, 492, 493, 480, 481, 7708, 7709, 560, 561, 495, 836, 8122, 902, 8121, 8120, 7944, 7945, 8124, 8136, 904, 7960, 7961, 8138, 905, 7976, 7977, 8140, 8154, 906, 8153, 8152, 938, 7992, 7993, 8184, 908, 8008, 8009, 8172, 8170, 910, 8169, 8168, 939, 8025, 8186, 911, 8040, 8041, 8188, 8116, 8132, 8048, 940, 8113, 8112, 7936, 7937, 8118, 8115, 8050, 941, 7952, 7953, 8052, 942, 7968, 7969, 8134, 8131, 8054, 943, 8145, 8144, 970, 7984, 7985, 8150, 8056, 972, 8000, 8001, 8164, 8165, 8058, 973, 8161, 8160, 971, 8016, 8017, 8166, 8060, 974, 8032, 8033, 8182, 8179, 8146, 912, 8151, 8162, 944, 8167, 8180, 979, 980, 1031, 1232, 1234, 1027, 1024, 1238, 1025, 1217, 1244, 1246, 1037, 1250, 1049, 1252, 1036, 1254, 1262, 1038, 1264, 1266, 1268, 1272, 1260, 1233, 1235, 1107, 1104, 1239, 1105, 1218, 1245, 1247, 1117, 1251, 1081, 1253, 1116, 1255, 1263, 1118, 1265, 1267, 1269, 1273, 1261, 1111, 1142, 1143, 1242, 1243, 1258, 1259, 1570, 1571, 1573, 1572, 1574, 1730, 1747, 1728, 2345, 2353, 2356, 2507, 2508, 2891, 2888, 2892, 2964, 3018, 3020, 3019, 3144, 3264, 3274, 3271, 3272, 3275, 3402, 3404, 3403, 3546, 3548, 3550, 3549, 3955, 3957, 3969, 4134, 6918, 6920, 6922, 6924, 6926, 6930, 6971, 6973, 6976, 6977, 6979, 7736, 7737, 7772, 7773, 7784, 7785, 7852, 7862, 7853, 7863, 7878, 7879, 7896, 7897, 7938, 7940, 7942, 8064, 7939, 7941, 7943, 8065, 8066, 8067, 8068, 8069, 8070, 8071, 7946, 7948, 7950, 8072, 7947, 7949, 7951, 8073, 8074, 8075, 8076, 8077, 8078, 8079, 7954, 7956, 7955, 7957, 7962, 7964, 7963, 7965, 7970, 7972, 7974, 8080, 7971, 7973, 7975, 8081, 8082, 8083, 8084, 8085, 8086, 8087, 7978, 7980, 7982, 8088, 7979, 7981, 7983, 8089, 8090, 8091, 8092, 8093, 8094, 8095, 7986, 7988, 7990, 7987, 7989, 7991, 7994, 7996, 7998, 7995, 7997, 7999, 8002, 8004, 8003, 8005, 8010, 8012, 8011, 8013, 8018, 8020, 8022, 8019, 8021, 8023, 8027, 8029, 8031, 8034, 8036, 8038, 8096, 8035, 8037, 8039, 8097, 8098, 8099, 8100, 8101, 8102, 8103, 8042, 8044, 8046, 8104, 8043, 8045, 8047, 8105, 8106, 8107, 8108, 8109, 8110, 8111, 8114, 8130, 8178, 8119, 8141, 8142, 8143, 8135, 8183, 8157, 8158, 8159, 8602, 8603, 8622, 8653, 8655, 8654, 8708, 8713, 8716, 8740, 8742, 8769, 8772, 8775, 8777, 8813, 8802, 8816, 8817, 8820, 8821, 8824, 8825, 8832, 8833, 8928, 8929, 8836, 8837, 8840, 8841, 8930, 8931, 8876, 8877, 8878, 8879, 8938, 8939, 8940, 8941, 12436, 12364, 12366, 12368, 12370, 12372, 12374, 12376, 12378, 12380, 12382, 12384, 12386, 12389, 12391, 12393, 12400, 12401, 12403, 12404, 12406, 12407, 12409, 12410, 12412, 12413, 12446, 12532, 12460, 12462, 12464, 12466, 12468, 12470, 12472, 12474, 12476, 12478, 12480, 12482, 12485, 12487, 12489, 12496, 12497, 12499, 12500, 12502, 12503, 12505, 12506, 12508, 12509, 12535, 12536, 12537, 12538, 12542, 67017, 67044, 69786, 69788, 69803, 69934, 69935, 70475, 70476, 70531, 70533, 70542, 70545, 70599, 70597, 70600, 70844, 70843, 70846, 71098, 71099, 71992, 90401, 90403, 90405, 90402, 90406, 90408, 90407, 90404, 93545, 93544, 93546];
const _M0FP410tonyfettes7unicode8internal3ucd11ccc__starts = [768, 789, 790, 794, 795, 796, 801, 803, 807, 809, 820, 825, 829, 837, 838, 839, 842, 845, 848, 851, 855, 856, 857, 859, 860, 861, 863, 864, 866, 867, 1155, 1425, 1426, 1430, 1431, 1434, 1435, 1436, 1442, 1448, 1450, 1451, 1453, 1454, 1455, 1456, 1457, 1458, 1459, 1460, 1461, 1462, 1463, 1464, 1465, 1467, 1468, 1469, 1471, 1473, 1474, 1476, 1477, 1479, 1552, 1560, 1561, 1562, 1611, 1612, 1613, 1614, 1615, 1616, 1617, 1618, 1619, 1621, 1623, 1628, 1629, 1631, 1648, 1750, 1759, 1763, 1764, 1767, 1770, 1771, 1773, 1809, 1840, 1841, 1842, 1844, 1845, 1847, 1850, 1851, 1853, 1854, 1855, 1858, 1859, 1860, 1861, 1862, 1863, 1864, 1865, 2027, 2034, 2035, 2045, 2070, 2075, 2085, 2089, 2137, 2199, 2201, 2204, 2250, 2255, 2260, 2275, 2276, 2278, 2279, 2281, 2282, 2285, 2288, 2289, 2290, 2291, 2294, 2295, 2297, 2299, 2364, 2381, 2385, 2386, 2387, 2492, 2509, 2558, 2620, 2637, 2748, 2765, 2876, 2893, 3021, 3132, 3149, 3157, 3158, 3260, 3277, 3387, 3405, 3530, 3640, 3642, 3656, 3768, 3770, 3784, 3864, 3893, 3895, 3897, 3953, 3954, 3956, 3962, 3968, 3970, 3972, 3974, 4038, 4151, 4153, 4237, 4957, 5908, 5940, 6098, 6109, 6313, 6457, 6458, 6459, 6679, 6680, 6752, 6773, 6783, 6832, 6837, 6843, 6845, 6847, 6849, 6851, 6853, 6858, 6859, 6964, 6980, 7019, 7020, 7021, 7082, 7142, 7154, 7223, 7376, 7380, 7381, 7386, 7388, 7392, 7394, 7405, 7412, 7416, 7616, 7618, 7619, 7626, 7627, 7629, 7630, 7631, 7632, 7633, 7670, 7671, 7673, 7674, 7675, 7676, 7677, 7678, 7679, 8400, 8402, 8404, 8408, 8411, 8417, 8421, 8423, 8424, 8425, 8426, 8428, 8432, 11503, 11647, 11744, 12330, 12331, 12332, 12333, 12334, 12441, 42607, 42612, 42654, 42736, 43014, 43052, 43204, 43232, 43307, 43347, 43443, 43456, 43696, 43698, 43700, 43703, 43710, 43713, 43766, 44013, 64286, 65056, 65063, 65070, 66045, 66272, 66422, 68109, 68111, 68152, 68153, 68154, 68159, 68325, 68326, 68900, 68969, 69291, 69373, 69446, 69448, 69451, 69452, 69453, 69506, 69507, 69508, 69509, 69702, 69744, 69759, 69817, 69818, 69888, 69939, 70003, 70080, 70090, 70197, 70198, 70377, 70378, 70459, 70477, 70502, 70512, 70606, 70722, 70726, 70750, 70850, 70851, 71103, 71104, 71231, 71350, 71351, 71467, 71737, 71738, 71997, 72003, 72160, 72244, 72263, 72345, 72767, 73026, 73028, 73111, 73537, 90415, 92912, 92976, 94192, 113822, 119141, 119143, 119149, 119150, 119163, 119173, 119178, 119210, 119362, 122880, 122888, 122907, 122915, 122918, 123023, 123184, 123566, 123628, 124140, 124142, 124143, 124398, 124399, 125136, 125252, 125258];
const _M0FP410tonyfettes7unicode8internal3ucd9ccc__ends = [788, 789, 793, 794, 795, 800, 802, 806, 808, 819, 824, 828, 836, 837, 838, 841, 844, 846, 850, 854, 855, 856, 858, 859, 860, 862, 863, 865, 866, 879, 1159, 1425, 1429, 1430, 1433, 1434, 1435, 1441, 1447, 1449, 1450, 1452, 1453, 1454, 1455, 1456, 1457, 1458, 1459, 1460, 1461, 1462, 1463, 1464, 1466, 1467, 1468, 1469, 1471, 1473, 1474, 1476, 1477, 1479, 1559, 1560, 1561, 1562, 1611, 1612, 1613, 1614, 1615, 1616, 1617, 1618, 1620, 1622, 1627, 1628, 1630, 1631, 1648, 1756, 1762, 1763, 1764, 1768, 1770, 1772, 1773, 1809, 1840, 1841, 1843, 1844, 1846, 1849, 1850, 1852, 1853, 1854, 1857, 1858, 1859, 1860, 1861, 1862, 1863, 1864, 1866, 2033, 2034, 2035, 2045, 2073, 2083, 2087, 2093, 2139, 2200, 2203, 2207, 2254, 2259, 2273, 2275, 2277, 2278, 2280, 2281, 2284, 2287, 2288, 2289, 2290, 2293, 2294, 2296, 2298, 2303, 2364, 2381, 2385, 2386, 2388, 2492, 2509, 2558, 2620, 2637, 2748, 2765, 2876, 2893, 3021, 3132, 3149, 3157, 3158, 3260, 3277, 3388, 3405, 3530, 3641, 3642, 3659, 3769, 3770, 3787, 3865, 3893, 3895, 3897, 3953, 3954, 3956, 3965, 3968, 3971, 3972, 3975, 4038, 4151, 4154, 4237, 4959, 5909, 5940, 6098, 6109, 6313, 6457, 6458, 6459, 6679, 6680, 6752, 6780, 6783, 6836, 6842, 6844, 6845, 6848, 6850, 6852, 6857, 6858, 6862, 6964, 6980, 7019, 7020, 7027, 7083, 7142, 7155, 7223, 7378, 7380, 7385, 7387, 7391, 7392, 7400, 7405, 7412, 7417, 7617, 7618, 7625, 7626, 7628, 7629, 7630, 7631, 7632, 7669, 7670, 7672, 7673, 7674, 7675, 7676, 7677, 7678, 7679, 8401, 8403, 8407, 8410, 8412, 8417, 8422, 8423, 8424, 8425, 8427, 8431, 8432, 11505, 11647, 11775, 12330, 12331, 12332, 12333, 12335, 12442, 42607, 42621, 42655, 42737, 43014, 43052, 43204, 43249, 43309, 43347, 43443, 43456, 43696, 43699, 43700, 43704, 43711, 43713, 43766, 44013, 64286, 65062, 65069, 65071, 66045, 66272, 66426, 68109, 68111, 68152, 68153, 68154, 68159, 68325, 68326, 68903, 68973, 69292, 69375, 69447, 69450, 69451, 69452, 69456, 69506, 69507, 69508, 69509, 69702, 69744, 69759, 69817, 69818, 69890, 69940, 70003, 70080, 70090, 70197, 70198, 70377, 70378, 70460, 70477, 70508, 70516, 70608, 70722, 70726, 70750, 70850, 70851, 71103, 71104, 71231, 71350, 71351, 71467, 71737, 71738, 71998, 72003, 72160, 72244, 72263, 72345, 72767, 73026, 73029, 73111, 73538, 90415, 92916, 92982, 94193, 113822, 119142, 119145, 119149, 119154, 119170, 119177, 119179, 119213, 119364, 122886, 122904, 122913, 122916, 122922, 123023, 123190, 123566, 123631, 124141, 124142, 124143, 124398, 124399, 125142, 125257, 125258];
const _M0FP410tonyfettes7unicode8internal3ucd11ccc__values = [230, 232, 220, 232, 216, 220, 202, 220, 202, 220, 1, 220, 230, 240, 230, 220, 230, 220, 230, 220, 230, 232, 220, 230, 233, 234, 233, 234, 233, 230, 230, 220, 230, 220, 230, 222, 220, 230, 220, 230, 220, 230, 222, 228, 230, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 230, 220, 18, 230, 30, 31, 32, 27, 28, 29, 30, 31, 32, 33, 34, 230, 220, 230, 220, 230, 220, 35, 230, 230, 220, 230, 230, 220, 230, 220, 36, 230, 220, 230, 220, 230, 220, 230, 220, 230, 220, 230, 220, 230, 220, 230, 220, 230, 220, 230, 230, 220, 230, 220, 230, 230, 230, 230, 220, 230, 220, 230, 230, 220, 230, 220, 230, 220, 230, 220, 230, 220, 27, 28, 29, 230, 220, 230, 220, 230, 7, 9, 230, 220, 230, 7, 9, 230, 7, 9, 7, 9, 7, 9, 9, 7, 9, 84, 91, 7, 9, 9, 9, 9, 103, 9, 107, 118, 9, 122, 220, 220, 220, 216, 129, 130, 132, 130, 130, 230, 9, 230, 220, 7, 9, 220, 230, 9, 9, 9, 230, 228, 222, 230, 220, 230, 220, 9, 230, 220, 230, 220, 230, 220, 220, 230, 220, 230, 220, 230, 7, 9, 230, 220, 230, 9, 7, 9, 7, 230, 1, 220, 230, 220, 230, 1, 220, 230, 230, 230, 220, 230, 220, 230, 234, 214, 220, 202, 230, 232, 228, 220, 218, 230, 233, 220, 230, 220, 230, 1, 230, 1, 230, 230, 1, 230, 220, 230, 1, 220, 230, 230, 9, 230, 218, 228, 232, 222, 224, 8, 230, 230, 230, 230, 9, 9, 9, 230, 220, 9, 7, 9, 230, 230, 220, 230, 230, 230, 9, 9, 26, 230, 220, 230, 220, 220, 230, 220, 230, 230, 1, 220, 9, 230, 220, 230, 230, 230, 220, 220, 230, 220, 230, 220, 230, 220, 230, 220, 9, 9, 9, 9, 7, 230, 9, 7, 9, 7, 9, 7, 7, 9, 7, 9, 230, 230, 9, 9, 7, 230, 9, 7, 9, 7, 9, 9, 7, 9, 9, 7, 9, 7, 9, 9, 9, 9, 9, 7, 9, 9, 9, 9, 1, 230, 6, 1, 216, 1, 226, 216, 220, 230, 220, 230, 230, 230, 230, 230, 230, 230, 230, 230, 230, 230, 232, 220, 230, 230, 220, 220, 230, 7];
const _M0FP410tonyfettes7unicode8internal3ucd12mark__starts = [768, 1155, 1425, 1471, 1473, 1476, 1479, 1552, 1611, 1648, 1750, 1759, 1767, 1770, 1809, 1840, 1958, 2027, 2045, 2070, 2075, 2085, 2089, 2137, 2199, 2250, 2275, 2362, 2366, 2385, 2402, 2433, 2492, 2494, 2503, 2507, 2519, 2530, 2558, 2561, 2620, 2622, 2631, 2635, 2641, 2672, 2677, 2689, 2748, 2750, 2759, 2763, 2786, 2810, 2817, 2876, 2878, 2887, 2891, 2901, 2914, 2946, 3006, 3014, 3018, 3031, 3072, 3132, 3134, 3142, 3146, 3157, 3170, 3201, 3260, 3262, 3270, 3274, 3285, 3298, 3315, 3328, 3387, 3390, 3398, 3402, 3415, 3426, 3457, 3530, 3535, 3542, 3544, 3570, 3633, 3636, 3655, 3761, 3764, 3784, 3864, 3893, 3895, 3897, 3902, 3953, 3974, 3981, 3993, 4038, 4139, 4182, 4190, 4194, 4199, 4209, 4226, 4239, 4250, 4957, 5906, 5938, 5970, 6002, 6068, 6109, 6155, 6159, 6277, 6313, 6432, 6448, 6679, 6741, 6752, 6783, 6832, 6912, 6964, 7019, 7040, 7073, 7142, 7204, 7376, 7380, 7405, 7412, 7415, 7616, 8400, 11503, 11647, 11744, 12330, 12441, 42607, 42612, 42654, 42736, 43010, 43014, 43019, 43043, 43052, 43136, 43188, 43232, 43263, 43302, 43335, 43392, 43443, 43493, 43561, 43587, 43596, 43643, 43696, 43698, 43703, 43710, 43713, 43755, 43765, 44003, 44012, 64286, 65024, 65056, 66045, 66272, 66422, 68097, 68101, 68108, 68152, 68159, 68325, 68900, 68969, 69291, 69372, 69446, 69506, 69632, 69688, 69744, 69747, 69759, 69808, 69826, 69888, 69927, 69957, 70003, 70016, 70067, 70089, 70094, 70188, 70206, 70209, 70367, 70400, 70459, 70462, 70471, 70475, 70487, 70498, 70502, 70512, 70584, 70594, 70597, 70599, 70604, 70610, 70625, 70709, 70750, 70832, 71087, 71096, 71132, 71216, 71339, 71453, 71724, 71984, 71991, 71995, 72000, 72002, 72145, 72154, 72164, 72193, 72243, 72251, 72263, 72273, 72330, 72751, 72760, 72850, 72873, 73009, 73018, 73020, 73023, 73031, 73098, 73104, 73107, 73459, 73472, 73475, 73524, 73534, 73562, 78912, 78919, 90398, 92912, 92976, 94031, 94033, 94095, 94180, 94192, 113821, 118528, 118576, 119141, 119149, 119163, 119173, 119210, 119362, 121344, 121403, 121461, 121476, 121499, 121505, 122880, 122888, 122907, 122915, 122918, 123023, 123184, 123566, 123628, 124140, 124398, 125136, 125252, 917760];
const _M0FP410tonyfettes7unicode8internal3ucd10mark__ends = [879, 1161, 1469, 1471, 1474, 1477, 1479, 1562, 1631, 1648, 1756, 1764, 1768, 1773, 1809, 1866, 1968, 2035, 2045, 2073, 2083, 2087, 2093, 2139, 2207, 2273, 2307, 2364, 2383, 2391, 2403, 2435, 2492, 2500, 2504, 2509, 2519, 2531, 2558, 2563, 2620, 2626, 2632, 2637, 2641, 2673, 2677, 2691, 2748, 2757, 2761, 2765, 2787, 2815, 2819, 2876, 2884, 2888, 2893, 2903, 2915, 2946, 3010, 3016, 3021, 3031, 3076, 3132, 3140, 3144, 3149, 3158, 3171, 3203, 3260, 3268, 3272, 3277, 3286, 3299, 3315, 3331, 3388, 3396, 3400, 3405, 3415, 3427, 3459, 3530, 3540, 3542, 3551, 3571, 3633, 3642, 3662, 3761, 3772, 3790, 3865, 3893, 3895, 3897, 3903, 3972, 3975, 3991, 4028, 4038, 4158, 4185, 4192, 4196, 4205, 4212, 4237, 4239, 4253, 4959, 5909, 5940, 5971, 6003, 6099, 6109, 6157, 6159, 6278, 6313, 6443, 6459, 6683, 6750, 6780, 6783, 6862, 6916, 6980, 7027, 7042, 7085, 7155, 7223, 7378, 7400, 7405, 7412, 7417, 7679, 8432, 11505, 11647, 11775, 12335, 12442, 42610, 42621, 42655, 42737, 43010, 43014, 43019, 43047, 43052, 43137, 43205, 43249, 43263, 43309, 43347, 43395, 43456, 43493, 43574, 43587, 43597, 43645, 43696, 43700, 43704, 43711, 43713, 43759, 43766, 44010, 44013, 64286, 65039, 65071, 66045, 66272, 66426, 68099, 68102, 68111, 68154, 68159, 68326, 68903, 68973, 69292, 69375, 69456, 69509, 69634, 69702, 69744, 69748, 69762, 69818, 69826, 69890, 69940, 69958, 70003, 70018, 70080, 70092, 70095, 70199, 70206, 70209, 70378, 70403, 70460, 70468, 70472, 70477, 70487, 70499, 70508, 70516, 70592, 70594, 70597, 70602, 70608, 70610, 70626, 70726, 70750, 70851, 71093, 71104, 71133, 71232, 71351, 71467, 71738, 71989, 71992, 71998, 72000, 72003, 72151, 72160, 72164, 72202, 72249, 72254, 72263, 72283, 72345, 72758, 72767, 72871, 72886, 73014, 73018, 73021, 73029, 73031, 73102, 73105, 73111, 73462, 73473, 73475, 73530, 73538, 73562, 78912, 78933, 90415, 92916, 92982, 94031, 94087, 94098, 94180, 94193, 113822, 118573, 118598, 119145, 119154, 119170, 119179, 119213, 119364, 121398, 121452, 121461, 121476, 121503, 121519, 122886, 122904, 122913, 122916, 122922, 123023, 123190, 123566, 123631, 124143, 124399, 125142, 125258, 917999];
const _M0FP310tonyfettes7unicode4idna11ace__prefix = "xn--";
const _M0FP310tonyfettes7unicode4idna16has__ace__prefixN7_2abindS357 = "xn--";
const _M0FP310tonyfettes7unicode4idna17to__ascii_2einnerN7_2abindS394 = ".";
const _M0FP210tonyfettes3url11hex__digits = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 65, 66, 67, 68, 69, 70];
const _M0FP210tonyfettes3url19ends__in__a__numberN7_2abindS941 = ".";
const _M0MP210tonyfettes3url4IPv45parseN7_2abindS1036 = ".";
const _M0MP210tonyfettes3url4Host13parse_2einnerN7_2abindS1118 = "xn--";
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN7_2abindS1226 = "//";
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN7_2abindS1260 = "/";
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN7_2abindS1290 = "/";
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN7_2abindS1610 = "[";
const _M0FP210tonyfettes3url10hex__chars = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 97, 98, 99, 100, 101, 102];
const _M0FP410Haoxincode8moonbash3lib8commands11cmd__base64N7_2abindS4221 = "-w";
const _M0FP410Haoxincode8moonbash3lib8commands9cmd__headN7_2abindS4351 = "-n";
const _M0FP410Haoxincode8moonbash3lib8commands9cmd__headN7_2abindS4352 = "-c";
const _M0FP410Haoxincode8moonbash3lib8commands9cmd__headN7_2abindS4353 = "-";
const _M0FP410Haoxincode8moonbash3lib8commands9cmd__tailN7_2abindS4381 = "+";
const _M0FP410Haoxincode8moonbash3lib8commands9cmd__tailN7_2abindS4382 = "-n";
const _M0FP410Haoxincode8moonbash3lib8commands9cmd__tailN7_2abindS4383 = "+";
const _M0FP410Haoxincode8moonbash3lib8commands9cmd__tailN7_2abindS4384 = "-c";
const _M0FP410Haoxincode8moonbash3lib8commands9cmd__tailN7_2abindS4385 = "-";
const _M0FP410Haoxincode8moonbash3lib8commands12cmd__stringsN7_2abindS4493 = "-n";
const _M0FP410Haoxincode8moonbash3lib8commands18cmd__split__suffixN8alphabetS3263 = "abcdefghijklmnopqrstuvwxyz";
const _M0FP410Haoxincode8moonbash3lib8commands10cmd__splitN7_2abindS4518 = "-l";
const _M0FP410Haoxincode8moonbash3lib8commands10cmd__splitN7_2abindS4519 = "-b";
const _M0FP410Haoxincode8moonbash3lib8commands8cmd__tarN7_2abindS4566 = "--strip-components=";
const _M0FP410Haoxincode8moonbash3lib8commands21awk__ctrl__error__key = "__moon_bash_awk_ctrl_error";
const _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key = "__moon_bash_awk_ctrl_exit";
const _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__next__key = "__moon_bash_awk_ctrl_next";
const _M0FP410Haoxincode8moonbash3lib8commands25awk__regex__delim__prefix = "__moon_bash_awk_regex_delim__:";
const _M0FP410Haoxincode8moonbash3lib8commands22awk__ctrl__return__key = "__moon_bash_awk_ctrl_return";
const _M0FP410Haoxincode8moonbash3lib8commands29awk__ctrl__return__value__key = "__moon_bash_awk_ctrl_return_value";
const _M0FP410Haoxincode8moonbash3lib8commands20awk__to__hex__stringN3hexS1066 = "0123456789abcdef";
const _M0FP410Haoxincode8moonbash3lib8commands21awk__fn__body__prefix = "__moon_bash_awk_fn_body#";
const _M0FP410Haoxincode8moonbash3lib8commands23awk__fn__params__prefix = "__moon_bash_awk_fn_params#";
const _M0FP410Haoxincode8moonbash3lib8commands22awk__expr__eval__state = new _M0TP410Haoxincode8moonbash3lib8commands16AwkExprEvalState(undefined);
const _M0FP410Haoxincode8moonbash3lib8commands31awk__take__function__definitionN7keywordS967 = "function";
const _M0FP410Haoxincode8moonbash3lib8commands23awk__install__functionsN7_2abindS5875 = ",";
const _M0FP410Haoxincode8moonbash3lib8commands9xan__viewN7_2abindS6200 = "\n";
const _M0FP410Haoxincode8moonbash3lib8commands9xan__viewN7_2abindS6201 = "\\n";
const _M0FP410Haoxincode8moonbash3lib8commands9xan__viewN7_2abindS6210 = "\n";
const _M0FP410Haoxincode8moonbash3lib8commands9xan__viewN7_2abindS6211 = "\\n";
const _M0FP410Haoxincode8moonbash3lib8commands27net__curl__preprocess__argsN7_2abindS6352 = "-X";
const _M0FP410Haoxincode8moonbash3lib8commands27net__curl__preprocess__argsN7_2abindS6353 = "-H";
const _M0FP410Haoxincode8moonbash3lib8commands27net__curl__preprocess__argsN7_2abindS6354 = "-o";
const _M0FP410Haoxincode8moonbash3lib8commands7cmd__duN7_2abindS6602 = "--max-depth=";
const _M0FP410Haoxincode8moonbash3lib8commands9cmd__findN7_2abindS6700 = "-";
const _M0FP410Haoxincode8moonbash3lib8commands23net__html__to__markdownN7_2abindS6830 = "\r\n";
const _M0FP410Haoxincode8moonbash3lib8commands23net__html__to__markdownN7_2abindS6831 = "\n";
const _M0FP410Haoxincode8moonbash3lib8commands23net__html__to__markdownN7_2abindS6832 = "\r";
const _M0FP410Haoxincode8moonbash3lib8commands23net__html__to__markdownN7_2abindS6833 = "\n";
const _M0FP410Haoxincode8moonbash3lib8commands41jq__time__plain__datetime__from__iso__utcN7_2abindS6936 = "Z";
const _M0FP410Haoxincode8moonbash3lib8commands27jq__compat__strings__arraysN7_2abindS7398 = ",";
const _M0FP410Haoxincode8moonbash3lib8commands27jq__compat__strings__arraysN7_2abindS7420 = ",";
const _M0FP410Haoxincode8moonbash3lib8commands17jq__compat__typesN7_2abindS7689 = ",";
const _M0FP410Haoxincode8moonbash3lib8commands17jq__compat__typesN7_2abindS7690 = "/";
const _M0FP410Haoxincode8moonbash3lib8commands30jq__parse__query__with__compatN15compat__preludeS2675 = "def arrays: select(type == \"array\");def objects: select(type == \"object\");def iterables: select(type == \"array\" or type == \"object\");def scalars: select(type != \"array\" and type != \"object\");def booleans: select(type == \"boolean\");def nulls: select(. == null);def debug: .;def fabs: abs;def tostring: if type == \"string\" then . else tojson end;def tonumber: if type == \"number\" then . else if type == \"string\" then fromjson else . end end;def toboolean: if type == \"boolean\" then . else if . == \"true\" then true else if . == \"false\" then false else . end end end;def nan: (0 / 0);def utf8bytelength: (explode | map(if . <= 127 then 1 else if . <= 2047 then 2 else if . <= 65535 then 3 else 4 end end end) | add);def builtins: [\"empty/0\",\"path/1\",\"paths/0\",\"select/1\",\"map/1\",\"length/0\",\"type/0\",\"keys/0\",\"tostring/0\",\"tonumber/0\",\"abs/0\",\"add/0\",\"sort/0\",\"unique/0\"];";
const _M0FP410Haoxincode8moonbash3lib8commands30cmd__touch__parse__date__valueN7_2abindS8466 = "/";
const _M0FP410Haoxincode8moonbash3lib8commands30cmd__touch__parse__date__valueN7_2abindS8467 = "-";
const _M0FP410Haoxincode8moonbash3lib8commands27xan__slice__normalize__argsN7_2abindS8576 = "-";
const _M0FP410Haoxincode8moonbash3lib8commands10xan__sliceN7_2abindS8587 = ",";
const _M0FP410Haoxincode8moonbash3lib8commands10xan__sliceN7_2abindS8590 = ",";
const _M0FP410Haoxincode8moonbash3lib8commands17yq__apply__filterN7_2abindS8638 = "[";
const _M0FP410Haoxincode8moonbash3lib8commands17yq__apply__filterN7_2abindS8639 = "]";
const _M0FP410Haoxincode8moonbash3lib8commands15yq__parse__argsN7_2abindS8666 = "-";
const _M0FP410Haoxincode8moonbash3lib8commands15yq__parse__argsN7_2abindS8671 = ".";
const _M0FP411moonbitlang6regexp8internal7unicode17ranges__is__digit = [48, 57];
const _M0FP411moonbitlang6regexp8internal7unicode22ranges__is__not__digit = [0, 47, 58, 1114111];
const _M0FP411moonbitlang6regexp8internal7unicode16ranges__is__word = [48, 57, 65, 90, 95, 95, 97, 122];
const _M0FP411moonbitlang6regexp8internal7unicode21ranges__is__not__word = [0, 47, 58, 64, 91, 94, 96, 96, 123, 1114111];
const _M0FP411moonbitlang6regexp8internal7unicode11ranges__any = [0, 1114111];
const _M0FP411moonbitlang6regexp8internal7unicode27ranges__any__not__new__line = [0, 9, 17, 1114111];
const _M0FP411moonbitlang6regexp8internal7unicode46ranges__is__white__space__or__line__terminator = [9, 13, 32, 32, 160, 160, 5760, 5760, 8192, 8202, 8232, 8233, 8239, 8239, 8287, 8287, 12288, 12288, 65279, 65279];
const _M0FP411moonbitlang6regexp8internal7unicode51ranges__is__not__white__space__or__line__terminator = [0, 8, 14, 31, 33, 159, 161, 5759, 5761, 8191, 8203, 8231, 8234, 8238, 8240, 8286, 8288, 12287, 12289, 65278, 65280, 1114111];
const _M0FP211moonbitlang6regexp15compile_2einnerN7_2abindS94 = "m";
const _M0FP211moonbitlang6regexp15compile_2einnerN7_2abindS95 = "s";
const _M0FP211moonbitlang6regexp15compile_2einnerN7_2abindS96 = "i";
const _M0FP211moonbitlang6regexp7compileN7_2abindS89 = "";
const _M0FP410Haoxincode8moonbash3lib5regex21raise__invalid__regexN7_2abindS196 = "[";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__sedN7_2abindS5344 = "-i";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__sedN7_2abindS5364 = "-e";
const _M0FP410Haoxincode8moonbash3lib11interpreter29command__stub__marker__prefix = "# moon_bash command stub:";
const _M0FP410Haoxincode8moonbash3lib11interpreter21hash__storage__prefix = "__MOON_BASH_HASH__";
const _M0FP410Haoxincode8moonbash3lib11interpreter35command__default__path__lookup__key = "__MOON_BASH_COMMAND_USE_DEFAULT_PATH";
const _M0FP410Haoxincode8moonbash3lib11interpreter22default__command__path = "/usr/bin:/bin";
const _M0FP410Haoxincode8moonbash3lib11interpreter36command__skip__function__lookup__key = "__MOON_BASH_SKIP_FUNCTION_LOOKUP";
const _M0FP410Haoxincode8moonbash3lib11interpreter13alias__prefix = "__ALIAS_";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17builtin__basenameN7_2abindS6347 = "-s";
const _M0FP410Haoxincode8moonbash3lib11interpreter24dir__stack__storage__key = "__MOON_BASH_DIR_STACK__";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15builtin__columnN7_2abindS6490 = "-s";
const _M0FP410Haoxincode8moonbash3lib11interpreter22command__alias__prefix = "__ALIAS_";
const _M0FP410Haoxincode8moonbash3lib11interpreter25completion__alias__prefix = "__ALIAS_";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32collect__variable__names__sortedN7_2abindS6657 = "__";
const _M0FP410Haoxincode8moonbash3lib11interpreter26compgen__in__function__key = "__MOON_BASH_COMPGEN_IN_FUNC__";
const _M0FP410Haoxincode8moonbash3lib11interpreter25complete__storage__prefix = "__MOON_BASH_COMPLETE__";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__cutN7_2abindS6830 = "-d";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__cutN7_2abindS6831 = "-f";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__cutN7_2abindS6832 = "-c";
const _M0FP410Haoxincode8moonbash3lib11interpreter36is__internal__declare__storage__nameN7_2abindS6974 = "__MOON_BASH_";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__dirnameN7_2abindS7049 = "/";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15builtin__expandN7_2abindS7088 = "-t";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__foldN7_2abindS7147 = "-w";
const _M0FP410Haoxincode8moonbash3lib11interpreter30grep__recursive__display__pathN7_2abindS7175 = "/";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__grepN7_2abindS7181 = "--include=";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__grepN7_2abindS7182 = "-A";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__grepN7_2abindS7183 = "-B";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__grepN7_2abindS7184 = "-C";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__grepN7_2abindS7208 = "/";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__helpN4textS833 = "MoonBash - POSIX Shell Sandbox\n\nFile commands:    cat, ls, cp, mv, rm, mkdir, touch, chmod, ln, stat, file, tree, du\nNavigation:       cd, pwd, pushd, popd\nText processing:  grep, sed, awk, sort, uniq, cut, head, tail, wc, tr, rev, nl, fold\nText tools:       diff, comm, paste, join, column, expand, unexpand, tee, xargs\nSearch:           find, grep, egrep, fgrep\nData tools:       jq, base64, md5sum, sha256sum, od, tac\nShell builtins:   echo, printf, read, test, eval, source, export, set, unset, declare\nControl flow:     if, for, while, until, case, function\nEnvironment:      env, printenv, which, type, basename, dirname, seq, date\nOther:            whoami, hostname, true, false, exit, history, help, clear\n";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__joinN7_2abindS7341 = "-1";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__joinN7_2abindS7342 = "-2";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__joinN7_2abindS7343 = "-t";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__joinN7_2abindS7344 = "-a";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__joinN7_2abindS7345 = "-v";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__nlN7_2abindS7404 = "-b";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__nlN7_2abindS7405 = "-n";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__nlN7_2abindS7406 = "-w";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__nlN7_2abindS7407 = "-s";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__nlN7_2abindS7408 = "-v";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__nlN7_2abindS7409 = "-i";
const _M0FP410Haoxincode8moonbash3lib11interpreter16od__format__hex2N3hexS755 = "0123456789abcdef";
const _M0FP410Haoxincode8moonbash3lib11interpreter16od__format__hex4N10hex__charsS760 = "0123456789abcdef";
const _M0FP410Haoxincode8moonbash3lib11interpreter21od__format__hex__addrN10hex__charsS772 = "0123456789abcdef";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__odN7_2abindS7455 = "-A";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__odN7_2abindS7456 = "-t";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__pasteN7_2abindS7484 = "-d";
const _M0FP410Haoxincode8moonbash3lib11interpreter22shopt__storage__prefix = "__MOON_BASH_SHOPT__";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__sortN7_2abindS7786 = "-k";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__sortN7_2abindS7787 = "-t";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17builtin__unexpandN7_2abindS8077 = "-t";
const _M0FP410Haoxincode8moonbash3lib11interpreter28alias__runtime__disable__key = "__MOON_BASH_ALIAS_EXPANSION_DISABLED";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32stash__pending__cmd__sub__stderrN18pending__path__keyS2239 = "__MOON_BASH_PENDING_CMD_SUB_STDERR_CAPTURE_PATH__";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32stash__pending__cmd__sub__stderrN18pending__data__keyS2240 = "__MOON_BASH_PENDING_CMD_SUB_STDERR_CAPTURE_DATA__";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16eval__arith__rawN7_2abindS8703 = "__MOON_BASH_ARITH_INVALID__";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__stringN11marker__keyS2523 = "__MOON_BASH_DISABLE_SPLIT_PROTECTION__";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18expand__word__partN11marker__keyS2511 = "__MOON_BASH_IN_DQUOTE_EXPANSION__";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN36cmd__sub__stderr__capture__path__keyS3491 = "__MOON_BASH_PENDING_CMD_SUB_STDERR_CAPTURE_PATH__";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN36cmd__sub__stderr__capture__data__keyS3492 = "__MOON_BASH_PENDING_CMD_SUB_STDERR_CAPTURE_DATA__";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN30pending__cmd__sub__stderr__keyS3493 = "__MOON_BASH_PENDING_CMD_SUB_STDERR__";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN7_2abindS9208 = "-e";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN7_2abindS9209 = "--regexp=";
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29expand__double__quoted__partsN11marker__keyS2453 = "__MOON_BASH_IN_DQUOTE_EXPANSION__";
const _M0FP410Haoxincode8moonbash3lib11interpreter24sed__empty__range__stateN6recordS11259 = new _M0TP410Haoxincode8moonbash3lib11interpreter13SedRangeState(false, -1, false);
const _M0FP410Haoxincode8moonbash3lib11interpreter19arith__digit__valueN6constrS11266 = 62;
const _M0FP410Haoxincode8moonbash3lib11interpreter19arith__digit__valueN6constrS11267 = 63;
const _M0FP410Haoxincode8moonbash3lib11interpreter25test__eval__syntax__errorN6recordS11268 = new _M0TP410Haoxincode8moonbash3lib11interpreter14TestEvalResult(false, 2);
const _M0FPB4seed = _M0FPB12random__seed();
const _M0MP410Haoxincode8moonbash3lib5lexer5Lexer10scan__wordN6constrS288 = new _M0DTP410Haoxincode8moonbash3lib3ast5Token4Word("");
const _M0FP410Haoxincode8moonbash3lib6parser41parse__word__parts__with__context_2einnerN6constrS1046 = new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart7Literal("");
const _M0FP410Haoxincode8moonbash3lib6parser40parse__param__expansion__content_2einnerN6constrS1047 = new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart7Literal("");
const _M0FPC15debug6renderN6constrS1711 = 16;
const _M0MP410Haoxincode8moonbash3lib6parser6Parser18parse__redirectionN6constrS1048 = new _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp7HereDoc(false);
const _M0MP410Haoxincode8moonbash3lib6parser6Parser18parse__redirectionN6constrS1049 = new _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp7HereDoc(true);
const _M0FP410Haoxincode8moonbash3lib11interpreter23join__values__with__ifsN6constrS11265 = 1;
const _M0FPB18brute__force__findN6constrS8649 = 0;
const _M0FPB28boyer__moore__horspool__findN6constrS8648 = 0;
const _M0FP410Haoxincode8moonbash3lib8commands15yq__parse__argsN5tupleS9253 = { _0: "r", _1: "raw" };
const _M0FP410Haoxincode8moonbash3lib8commands15yq__parse__argsN5tupleS9254 = { _0: "j", _1: "json" };
const _M0FP410Haoxincode8moonbash3lib8commands15yq__parse__argsN7_2abindS8678 = [_M0FP410Haoxincode8moonbash3lib8commands15yq__parse__argsN5tupleS9253, _M0FP410Haoxincode8moonbash3lib8commands15yq__parse__argsN5tupleS9254];
const _M0FP410Haoxincode8moonbash3lib8commands15yq__parse__argsN7_2abindS8676 = ["raw", "json"];
const _M0FP410Haoxincode8moonbash3lib8commands15yq__parse__argsN6constrS9255 = false;
const _M0MP219moonbit_2dcommunity4yaml5Lexer15scan__directiveN6constrS2085 = new _M0DTP219moonbit_2dcommunity4yaml9TokenType12TagDirective("", "");
const _M0MP219moonbit_2dcommunity4yaml5Lexer21increase__flow__levelN6recordS2086 = new _M0TP219moonbit_2dcommunity4yaml6Marker(0, 0, 0);
const _M0MP219moonbit_2dcommunity4yaml5Lexer20fetch__stream__startN6recordS2087 = new _M0TP219moonbit_2dcommunity4yaml6Marker(0, 0, 0);
const _M0MP219moonbit_2dcommunity4yaml4Yaml9from__strN6constrS2063 = new _M0DTP219moonbit_2dcommunity4yaml4Yaml7Boolean(false);
const _M0MP219moonbit_2dcommunity4yaml4Yaml9from__strN6constrS2064 = new _M0DTP219moonbit_2dcommunity4yaml4Yaml7Boolean(true);
const _M0MP219moonbit_2dcommunity4yaml10YamlLoader15on__event__implN6constrS2088 = new _M0DTP219moonbit_2dcommunity4yaml4Yaml7Boolean(false);
const _M0MP219moonbit_2dcommunity4yaml10YamlLoader15on__event__implN6constrS2089 = new _M0DTP219moonbit_2dcommunity4yaml4Yaml7Boolean(true);
const _M0FP410Haoxincode8moonbash3lib8commands19vm__parse__responseN6constrS9206 = new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands14VmExecResponsesE3Err("vm bridge returned invalid JSON");
const _M0FP410Haoxincode8moonbash3lib8commands19vm__parse__responseN6constrS9207 = new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands14VmExecResponsesE3Err("vm bridge returned a non-object payload");
const _M0MP38bobzhang6moonjq6parser5Lexer11lex__numberN6constrS1227 = 45;
const _M0FP38bobzhang6moonjq6parser3lexN6constrS1228 = 46;
const _M0FP38bobzhang6moonjq6parser3lexN6constrS1229 = 61;
const _M0FP38bobzhang6moonjq6parser3lexN6constrS1230 = 47;
const _M0FP38bobzhang6moonjq6parser3lexN6constrS1231 = 61;
const _M0FP38bobzhang6moonjq6parser3lexN6constrS1232 = 61;
const _M0FP38bobzhang6moonjq6parser3lexN6constrS1233 = 61;
const _M0FP38bobzhang6moonjq6parser3lexN6constrS1234 = 61;
const _M0FP38bobzhang6moonjq6parser3lexN6constrS1235 = 61;
const _M0FP38bobzhang6moonjq6parser3lexN6constrS1236 = 61;
const _M0FP38bobzhang6moonjq6parser3lexN6constrS1237 = 61;
const _M0FP38bobzhang6moonjq6parser3lexN6constrS1238 = 61;
const _M0FP38bobzhang6moonjq6parser3lexN6constrS1239 = 61;
const _M0FP38bobzhang6moonjq6parser3lexN6constrS1240 = 61;
const _M0MP38bobzhang6moonjq6parser6Parser14parse__primaryN6constrS1241 = new _M0DTP38bobzhang6moonjq3ast7Literal4Bool(true);
const _M0MP38bobzhang6moonjq6parser6Parser14parse__primaryN6constrS1242 = new _M0DTP38bobzhang6moonjq3ast4Expr7Literal(_M0MP38bobzhang6moonjq6parser6Parser14parse__primaryN6constrS1241);
const _M0MP38bobzhang6moonjq6parser6Parser14parse__primaryN6constrS1243 = new _M0DTP38bobzhang6moonjq3ast7Literal4Bool(false);
const _M0MP38bobzhang6moonjq6parser6Parser14parse__primaryN6constrS1244 = new _M0DTP38bobzhang6moonjq3ast4Expr7Literal(_M0MP38bobzhang6moonjq6parser6Parser14parse__primaryN6constrS1243);
const _M0FP410Haoxincode8moonbash3lib8commands32jq__rewrite__binary__plus__minusN6constrS9246 = 32;
const _M0FP410Haoxincode8moonbash3lib8commands32jq__rewrite__binary__plus__minusN6constrS9247 = 32;
const _M0FP38bobzhang6moonjq3ast14base64__decodeN6constrS5185 = 62;
const _M0FP38bobzhang6moonjq3ast14base64__decodeN6constrS5186 = 63;
const _M0MPB4Iter5emptyN6constrS9081GRPB4JsonE = 0;
const _M0MPB4Iter4takeN6constrS9083GRPB4JsonE = 0;
const _M0MPB4Iter4takeN6constrS9084GRPB4JsonE = 0;
const _M0MPB4Iter9singletonN6constrS9082GRPB4JsonE = 1;
const _M0MPB4Iter4takeN6constrS9083GyE = 0;
const _M0MPB4Iter4takeN6constrS9084GyE = 0;
const _M0FP27gmlewis6base6410assemble32N5tupleS214 = { _0: 0, _1: false };
const _M0FP410Haoxincode8moonbash3lib8commands27jq__decode__base64__for__jqN6constrS9244 = "";
const _M0FP410Haoxincode8moonbash3lib8commands27jq__decode__base64__for__jqN6constrS9245 = "";
const _M0FP311moonbitlang1x4time9utc__zone = new _M0TP311moonbitlang1x4time4Zone("UTC", [_M0FP311moonbitlang1x4time11utc__offset], []);
const _M0FP311moonbitlang1x4time18seconds__per__hour = BigInt.asUintN(64, _M0FP311moonbitlang1x4time20seconds__per__minute * 60n);
const _M0FP311moonbitlang1x4time17seconds__per__day = BigInt.asUintN(64, _M0FP311moonbitlang1x4time18seconds__per__hour * 24n);
const _M0FP311moonbitlang1x4time33days__zero__year__to__unix__epoch = BigInt.asUintN(64, BigInt.asUintN(64, 5n * _M0FP311moonbitlang1x4time21days__per__400__years) - 10957n);
const _M0FP311moonbitlang1x4time24nanoseconds__per__minute = BigInt.asUintN(64, _M0FP311moonbitlang1x4time24nanoseconds__per__second * _M0FP311moonbitlang1x4time20seconds__per__minute);
const _M0FP311moonbitlang1x4time22nanoseconds__per__hour = BigInt.asUintN(64, _M0FP311moonbitlang1x4time24nanoseconds__per__minute * _M0FP311moonbitlang1x4time18minutes__per__hour);
const _M0FP311moonbitlang1x4time21nanoseconds__per__day = BigInt.asUintN(64, _M0FP311moonbitlang1x4time24nanoseconds__per__second * _M0FP311moonbitlang1x4time17seconds__per__day);
const _M0MP27gmlewis5flate12Decompressor11data__blockN6constrS1084 = 4;
const _M0MP27gmlewis4gzip6Reader12read__headerN6constrS349 = 10;
const _M0MP27gmlewis4gzip6Reader12read__headerN6constrS350 = 8;
const _M0MP27gmlewis4gzip6Reader12read__headerN6constrS351 = 2;
const _M0MP27gmlewis4gzip6Reader12read__headerN6constrS352 = 2;
const _M0MP27gmlewis4gzip6Reader12read__headerN6constrS353 = 2;
const _M0MP27gmlewis4gzip6Reader12read__headerN6constrS354 = 2;
const _M0FP27gmlewis2io9read__allN6constrS902 = 0;
const _M0MP27gmlewis2io6Buffer11new_2einnerN6constrS903 = 0;
const _M0IP27gmlewis4gzip6ReaderP27gmlewis2io6Reader4readN6constrS355 = 8;
const _M0IP27gmlewis4gzip6ReaderP27gmlewis2io6Reader4readN6constrS356 = 4;
const _M0IP27gmlewis4gzip6ReaderP27gmlewis2io6Reader4readN6constrS357 = 8;
const _M0FP410Haoxincode8moonbash3lib8commands15expr__parse__orN6constrS9209 = "|";
const _M0FP410Haoxincode8moonbash3lib8commands16expr__parse__andN6constrS9210 = "&";
const _M0FP410Haoxincode8moonbash3lib8commands23custom__parse__responseN6constrS9238 = new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands18CustomExecResponsesE3Err("custom command bridge returned invalid JSON");
const _M0FP410Haoxincode8moonbash3lib8commands23custom__parse__responseN6constrS9239 = new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands18CustomExecResponsesE3Err("custom command bridge returned a non-object payload");
const _M0FP410Haoxincode8moonbash3lib8commands19cmd__custom__bridgeN6recordS9240 = new _M0TP410Haoxincode8moonbash3lib3ast10ExecResult("", "__moon_bash_custom__: command name argument required\n", 2);
const _M0FP410Haoxincode8moonbash3lib8commands27net__parse__fetch__responseN6constrS9226 = new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands16NetFetchResponsesE3Err("fetch bridge returned invalid JSON");
const _M0FP410Haoxincode8moonbash3lib8commands27net__parse__fetch__responseN6constrS9227 = new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands16NetFetchResponsesE3Err("fetch bridge returned a non-object payload");
const _M0FP410Haoxincode8moonbash3lib8commands15net__fetch__urlN6constrS9228 = new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands16NetFetchResponsesE3Err("network request failed");
const _M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__argsN5tupleS9231 = { _0: "s", _1: "silent" };
const _M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__argsN5tupleS9232 = { _0: "i", _1: "include" };
const _M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__argsN5tupleS9233 = { _0: "L", _1: "location" };
const _M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__argsN5tupleS9234 = { _0: "X", _1: "method" };
const _M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__argsN5tupleS9235 = { _0: "H", _1: "header" };
const _M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__argsN5tupleS9236 = { _0: "d", _1: "data" };
const _M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__argsN5tupleS9237 = { _0: "o", _1: "output" };
const _M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__argsN7_2abindS6394 = [_M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__argsN5tupleS9231, _M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__argsN5tupleS9232, _M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__argsN5tupleS9233, _M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__argsN5tupleS9234, _M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__argsN5tupleS9235, _M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__argsN5tupleS9236, _M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__argsN5tupleS9237];
const _M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__argsN7_2abindS6388 = ["silent", "include", "location"];
const _M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__argsN7_2abindS6389 = ["method", "data", "output"];
const _M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__argsN7_2abindS6390 = ["header"];
const _M0FP310tonyfettes7unicode4idna26process__label__for__asciiN5tupleS427 = { _0: "", _1: "" };
const _M0FP210tonyfettes3url13default__portN6constrS2083 = 443;
const _M0FP210tonyfettes3url13default__portN6constrS2084 = 80;
const _M0FP210tonyfettes3url13default__portN6constrS2085 = 21;
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2086 = new _M0DTP210tonyfettes3url4Host6Opaque("");
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2087 = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2086;
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2088 = new _M0DTP210tonyfettes3url4Path6Opaque("");
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2089 = "";
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2090 = "";
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2091 = "";
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2092 = "";
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2093 = "";
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2094 = "";
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2095 = "";
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2096 = "";
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2097 = "";
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2098 = "";
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2099 = "";
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2100 = "";
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2101 = new _M0DTP210tonyfettes3url4Host6Opaque("");
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2102 = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2101;
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2103 = "";
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2104 = "";
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2105 = new _M0DTP210tonyfettes3url4Host6Opaque("");
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2106 = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2105;
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2107 = new _M0DTP210tonyfettes3url4Host6Opaque("");
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2108 = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2107;
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2109 = new _M0DTP210tonyfettes3url4Host6Opaque("");
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2110 = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2109;
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2111 = new _M0DTP210tonyfettes3url4Host6Opaque("");
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2112 = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2111;
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2113 = new _M0DTP210tonyfettes3url4Host6Opaque("");
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2114 = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2113;
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2115 = new _M0DTP210tonyfettes3url4Host6Opaque("");
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2116 = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2115;
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2117 = new _M0DTP210tonyfettes3url4Host6Opaque("");
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2118 = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2117;
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2119 = new _M0DTP210tonyfettes3url4Host6Opaque("");
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2120 = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2119;
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2121 = new _M0DTP210tonyfettes3url4Host6Opaque("");
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2122 = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2121;
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2123 = new _M0DTP210tonyfettes3url4Host6Opaque("");
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2124 = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2123;
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2125 = new _M0DTP210tonyfettes3url4Host6Opaque("");
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2126 = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2125;
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2127 = new _M0DTP210tonyfettes3url4Host6Opaque("");
const _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2128 = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2127;
const _M0FP410Haoxincode8moonbash3lib8commands28net__normalize__request__urlN6constrS9229 = new _M0DTPC16result6ResultGssE3Err("unsupported URL scheme");
const _M0FP410Haoxincode8moonbash3lib8commands28net__normalize__request__urlN6constrS9230 = new _M0DTPC16result6ResultGssE3Err("invalid URL");
const _M0FP410Haoxincode8moonbash3lib8commands14base64__decodeN5tupleS9208 = { _0: "", _1: "base64: invalid input\n" };
const _p = _M0MPC16string6String9to__array("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/");
const _p$2 = new Array(_p.length);
const _p$3 = _p.length;
let _tmp = 0;
while (true) {
  const _p$4 = _tmp;
  if (_p$4 < _p$3) {
    const _p$5 = _p[_p$4];
    _p$2[_p$4] = _p$5 & 255;
    _tmp = _p$4 + 1 | 0;
    continue;
  } else {
    break;
  }
}
const _bind = _p$2;
const _M0FP27gmlewis6base6413std__encoding = _M0MPC15array10FixedArray11from__arrayGyE(new _M0TPB9ArrayViewGyE(_bind, 0, _bind.length));
const _M0FP410Haoxincode8moonbash3lib6nyacsv13parse_2einnerN6constrS100GRP410Haoxincode8moonbash3lib6nyacsv12StringReaderE = 10;
const _M0MP410Haoxincode8moonbash3lib6nyacsv3CSV13parse__stringN6recordS102 = new _M0TP410Haoxincode8moonbash3lib6nyacsv10CSVOptions(44, true, 34, true, false);
const _M0FP410Haoxincode8moonbash3lib8commands23xan__slice__parse__argsN5tupleS9250 = { _0: "i", _1: "index" };
const _M0FP410Haoxincode8moonbash3lib8commands23xan__slice__parse__argsN5tupleS9251 = { _0: "l", _1: "length" };
const _M0FP410Haoxincode8moonbash3lib8commands23xan__slice__parse__argsN7_2abindS8586 = [_M0FP410Haoxincode8moonbash3lib8commands23xan__slice__parse__argsN5tupleS9250, _M0FP410Haoxincode8moonbash3lib8commands23xan__slice__parse__argsN5tupleS9251];
const _M0FP410Haoxincode8moonbash3lib8commands23xan__slice__parse__argsN7_2abindS8584 = ["index", "length"];
const _M0FP410Haoxincode8moonbash3lib8commands23xan__slice__parse__argsN6constrS9252 = false;
const _M0FP410Haoxincode8moonbash3lib8commands7cmd__wcN6constrS9211 = "total";
const _M0MP27gmlewis5flate14HuffmanEncoder8generateN6recordS1079 = new _M0TP27gmlewis5flate11LiteralNode(0, 0);
const _M0MP27gmlewis5flate14HuffmanEncoder8generateN6recordS1080 = new _M0TP27gmlewis5flate11LiteralNode(0, 0);
const _M0MP27gmlewis5flate16HuffmanBitWriter18write__block__huffN6constrS1081 = 257;
const _M0IP27gmlewis4gzip6WriterP27gmlewis2io6Closer5closeN6constrS348 = 8;
const _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__astN6constrS9212 = new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst3Raw("");
const _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__astN6constrS9213 = 61;
const _M0FP410Haoxincode8moonbash3lib8commands31awk__parse__field__assign__stmtN6constrS9215 = 61;
const _M0FP410Haoxincode8moonbash3lib8commands24awk__parse__assign__stmtN6constrS9214 = 61;
const _M0FP410Haoxincode8moonbash3lib8commands26awk__parse__statement__astN6constrS9216 = new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst3Raw("");
const _M0FP410Haoxincode8moonbash3lib8commands26awk__parse__statement__astN6constrS9217 = new _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt8ExprStmt(_M0FP410Haoxincode8moonbash3lib8commands26awk__parse__statement__astN6constrS9216);
const _M0FP410Haoxincode8moonbash3lib8commands30awk__find__regex__match__rangeN5tupleS9218 = { _0: 1, _1: 0 };
const _M0FP410Haoxincode8moonbash3lib8commands30awk__find__regex__match__rangeN5tupleS9219 = { _0: 0, _1: -1 };
const _M0FP410Haoxincode8moonbash3lib8commands30awk__find__regex__match__rangeN5tupleS9220 = { _0: 0, _1: -1 };
const _M0FP410Haoxincode8moonbash3lib8commands30awk__find__regex__match__rangeN5tupleS9221 = { _0: 0, _1: -1 };
const _M0FP410Haoxincode8moonbash3lib8commands30awk__find__regex__match__rangeN5tupleS9222 = { _0: 0, _1: -1 };
const _M0FP410Haoxincode8moonbash3lib8commands28awk__pattern__match__programN5tupleS9223 = { _0: true, _1: false };
const _M0FP410Haoxincode8moonbash3lib8commands28awk__pattern__match__programN5tupleS9224 = { _0: false, _1: false };
const _M0MP27gmlewis3md56Digest3newN7_2abindS68 = [1732584193, -271733879, -1732584194, 271733878];
const _M0MP27gmlewis4sha16Digest3newN7_2abindS81 = [1732584193, -271733879, -1732584194, 271733878, -1009589776];
const _M0FP410Haoxincode8moonbash3lib8commands36net__parse__html__to__markdown__argsN5tupleS9241 = { _0: "o", _1: "output" };
const _M0FP410Haoxincode8moonbash3lib8commands36net__parse__html__to__markdown__argsN5tupleS9242 = { _0: "u", _1: "url" };
const _M0FP410Haoxincode8moonbash3lib8commands36net__parse__html__to__markdown__argsN7_2abindS6850 = [_M0FP410Haoxincode8moonbash3lib8commands36net__parse__html__to__markdown__argsN5tupleS9241, _M0FP410Haoxincode8moonbash3lib8commands36net__parse__html__to__markdown__argsN5tupleS9242];
const _M0FP410Haoxincode8moonbash3lib8commands36net__parse__html__to__markdown__argsN7_2abindS6846 = ["output", "url"];
const _M0FP410Haoxincode8moonbash3lib8commands23cmd__html__to__markdownN5tupleS9243 = { _0: "accept", _1: "text/html" };
const _M0FP410Haoxincode8moonbash3lib8commands20csvlook__parse__argsN6constrS9225 = false;
const _M0FP410Haoxincode8moonbash3lib8commands22cmd__ls__read__entriesN5tupleS9248 = { _0: ".", _1: 4096 };
const _M0FP410Haoxincode8moonbash3lib8commands22cmd__ls__read__entriesN5tupleS9249 = { _0: "..", _1: 4096 };
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9256 = _M0FP410Haoxincode8moonbash3lib8commands26cmd__js__exec__placeholder;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9257 = _M0FP410Haoxincode8moonbash3lib8commands12cmd__python3;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9258 = _M0FP410Haoxincode8moonbash3lib8commands9cmd__echo;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9259 = _M0FP410Haoxincode8moonbash3lib8commands8cmd__cat;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9260 = _M0FP410Haoxincode8moonbash3lib8commands7cmd__cd;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9261 = _M0FP410Haoxincode8moonbash3lib8commands8cmd__pwd;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9262 = _M0FP410Haoxincode8moonbash3lib8commands7cmd__ls;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9263 = _M0FP410Haoxincode8moonbash3lib8commands10cmd__mkdir;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9264 = _M0FP410Haoxincode8moonbash3lib8commands7cmd__rm;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9265 = _M0FP410Haoxincode8moonbash3lib8commands7cmd__cp;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9266 = _M0FP410Haoxincode8moonbash3lib8commands7cmd__mv;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9267 = _M0FP410Haoxincode8moonbash3lib8commands10cmd__touch;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9268 = _M0FP410Haoxincode8moonbash3lib8commands9cmd__find;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9269 = _M0FP410Haoxincode8moonbash3lib8commands9cmd__head;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9270 = _M0FP410Haoxincode8moonbash3lib8commands9cmd__tail;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9271 = _M0FP410Haoxincode8moonbash3lib8commands7cmd__wc;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9272 = _M0FP410Haoxincode8moonbash3lib8commands12cmd__strings;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9273 = _M0FP410Haoxincode8moonbash3lib8commands10cmd__split;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9274 = _M0FP410Haoxincode8moonbash3lib8commands8cmd__tar;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9275 = _M0FP410Haoxincode8moonbash3lib8commands8cmd__awk;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9276 = _M0FP410Haoxincode8moonbash3lib8commands7cmd__jq;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9277 = _M0FP410Haoxincode8moonbash3lib8commands9cmd__true;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9278 = _M0FP410Haoxincode8moonbash3lib8commands10cmd__false;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9279 = _M0FP410Haoxincode8moonbash3lib8commands10cmd__rmdir;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9280 = _M0FP410Haoxincode8moonbash3lib8commands9cmd__stat;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9281 = _M0FP410Haoxincode8moonbash3lib8commands9cmd__file;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9282 = _M0FP410Haoxincode8moonbash3lib8commands9cmd__tree;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9283 = _M0FP410Haoxincode8moonbash3lib8commands7cmd__du;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9284 = _M0FP410Haoxincode8moonbash3lib8commands10cmd__chmod;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9285 = _M0FP410Haoxincode8moonbash3lib8commands7cmd__ln;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9286 = _M0FP410Haoxincode8moonbash3lib8commands13cmd__readlink;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9287 = _M0FP410Haoxincode8moonbash3lib8commands9cmd__diff;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9288 = _M0FP410Haoxincode8moonbash3lib8commands8cmd__cmp;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9289 = _M0FP410Haoxincode8moonbash3lib8commands9cmd__comm;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9290 = _M0FP410Haoxincode8moonbash3lib8commands11cmd__base64;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9291 = _M0FP410Haoxincode8moonbash3lib8commands9cmd__expr;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9292 = _M0FP410Haoxincode8moonbash3lib8commands7cmd__yq;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9293 = _M0FP410Haoxincode8moonbash3lib8commands8cmd__xan;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9294 = _M0FP410Haoxincode8moonbash3lib8commands12cmd__csvlook;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9295 = _M0FP410Haoxincode8moonbash3lib8commands11cmd__md5sum;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9296 = _M0FP410Haoxincode8moonbash3lib8commands12cmd__sha1sum;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9297 = _M0FP410Haoxincode8moonbash3lib8commands14cmd__sha256sum;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9298 = _M0FP410Haoxincode8moonbash3lib8commands9cmd__gzip;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9299 = _M0FP410Haoxincode8moonbash3lib8commands11cmd__gunzip;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9300 = _M0FP410Haoxincode8moonbash3lib8commands9cmd__zcat;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9301 = _M0FP410Haoxincode8moonbash3lib8commands9cmd__curl;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9302 = _M0FP410Haoxincode8moonbash3lib8commands23cmd__html__to__markdown;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9303 = _M0FP410Haoxincode8moonbash3lib8commands12cmd__sqlite3;
const _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9304 = _M0FP410Haoxincode8moonbash3lib8commands19cmd__custom__bridge;
const _M0FP411moonbitlang6regexp8internal7unicode32compute__char__class__complementN7_2abindS112 = [0, 1114111];
const _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__auxN6constrS260 = new _M0DTP411moonbitlang6regexp8internal2vm11Instruction5Split(-1, -1);
const _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__auxN6constrS261 = new _M0DTP411moonbitlang6regexp8internal2vm11Instruction5Split(-1, -1);
const _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__auxN6constrS262 = new _M0DTP411moonbitlang6regexp8internal2vm11Instruction5Split(-1, -1);
const _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__auxN6constrS263 = new _M0DTP411moonbitlang6regexp8internal2vm11Instruction5Split(-1, -1);
const _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__auxN6constrS264 = new _M0DTP411moonbitlang6regexp8internal2vm11Instruction5Split(-1, -1);
const _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__auxN6constrS265 = new _M0DTP411moonbitlang6regexp8internal2vm11Instruction4Jump(-1);
const _M0MP411moonbitlang6regexp8internal3ast3Ast7compileN6constrS266 = new _M0DTP411moonbitlang6regexp8internal2vm11Instruction5Split(3, 1);
const _M0MP411moonbitlang6regexp8internal3ast3Ast7compileN7_2abindS214 = [0, 1114111];
const _M0MP411moonbitlang6regexp8internal3ast3Ast7compileN6constrS267 = new _M0DTP411moonbitlang6regexp8internal2vm11Instruction4Jump(0);
const _M0MP411moonbitlang6regexp8internal3ast3Ast7compileN6constrS268 = new _M0DTP411moonbitlang6regexp8internal2vm11Instruction4Save(0);
const _M0MP411moonbitlang6regexp8internal3ast3Ast7compileN6constrS269 = new _M0DTP411moonbitlang6regexp8internal2vm11Instruction4Save(1);
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS48 = [65, 90, 97, 122, 181, 181, 192, 214, 216, 246, 248, 442, 444, 447, 452, 659, 661, 687, 880, 883, 886, 887, 891, 893, 895, 895, 902, 902, 904, 906, 908, 908, 910, 929, 931, 1013, 1015, 1153, 1162, 1327, 1329, 1366, 1376, 1416, 4256, 4293, 4295, 4295, 4301, 4301, 4304, 4346, 4349, 4351, 5024, 5109, 5112, 5117, 7296, 7306, 7312, 7354, 7357, 7359, 7424, 7467, 7531, 7543, 7545, 7578, 7680, 7957, 7960, 7965, 7968, 8005, 8008, 8013, 8016, 8023, 8025, 8025, 8027, 8027, 8029, 8029, 8031, 8061, 8064, 8116, 8118, 8124, 8126, 8126, 8130, 8132, 8134, 8140, 8144, 8147, 8150, 8155, 8160, 8172, 8178, 8180, 8182, 8188, 8450, 8450, 8455, 8455, 8458, 8467, 8469, 8469, 8473, 8477, 8484, 8484, 8486, 8486, 8488, 8488, 8490, 8493, 8495, 8500, 8505, 8505, 8508, 8511, 8517, 8521, 8526, 8526, 8579, 8580, 11264, 11387, 11390, 11492, 11499, 11502, 11506, 11507, 11520, 11557, 11559, 11559, 11565, 11565, 42560, 42605, 42624, 42651, 42786, 42863, 42865, 42887, 42891, 42894, 42896, 42957, 42960, 42961, 42963, 42963, 42965, 42972, 42997, 42998, 43002, 43002, 43824, 43866, 43872, 43880, 43888, 43967, 64256, 64262, 64275, 64279, 65313, 65338, 65345, 65370, 66560, 66639, 66736, 66771, 66776, 66811, 66928, 66938, 66940, 66954, 66956, 66962, 66964, 66965, 66967, 66977, 66979, 66993, 66995, 67001, 67003, 67004, 68736, 68786, 68800, 68850, 68944, 68965, 68976, 68997, 71840, 71903, 93760, 93823, 119808, 119892, 119894, 119964, 119966, 119967, 119970, 119970, 119973, 119974, 119977, 119980, 119982, 119993, 119995, 119995, 119997, 120003, 120005, 120069, 120071, 120074, 120077, 120084, 120086, 120092, 120094, 120121, 120123, 120126, 120128, 120132, 120134, 120134, 120138, 120144, 120146, 120485, 120488, 120512, 120514, 120538, 120540, 120570, 120572, 120596, 120598, 120628, 120630, 120654, 120656, 120686, 120688, 120712, 120714, 120744, 120746, 120770, 120772, 120779, 122624, 122633, 122635, 122654, 122661, 122666, 125184, 125251];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS49 = [65, 90, 97, 122, 170, 170, 181, 181, 186, 186, 192, 214, 216, 246, 248, 705, 710, 721, 736, 740, 748, 748, 750, 750, 880, 884, 886, 887, 890, 893, 895, 895, 902, 902, 904, 906, 908, 908, 910, 929, 931, 1013, 1015, 1153, 1162, 1327, 1329, 1366, 1369, 1369, 1376, 1416, 1488, 1514, 1519, 1522, 1568, 1610, 1646, 1647, 1649, 1747, 1749, 1749, 1765, 1766, 1774, 1775, 1786, 1788, 1791, 1791, 1808, 1808, 1810, 1839, 1869, 1957, 1969, 1969, 1994, 2026, 2036, 2037, 2042, 2042, 2048, 2069, 2074, 2074, 2084, 2084, 2088, 2088, 2112, 2136, 2144, 2154, 2160, 2183, 2185, 2190, 2208, 2249, 2308, 2361, 2365, 2365, 2384, 2384, 2392, 2401, 2417, 2432, 2437, 2444, 2447, 2448, 2451, 2472, 2474, 2480, 2482, 2482, 2486, 2489, 2493, 2493, 2510, 2510, 2524, 2525, 2527, 2529, 2544, 2545, 2556, 2556, 2565, 2570, 2575, 2576, 2579, 2600, 2602, 2608, 2610, 2611, 2613, 2614, 2616, 2617, 2649, 2652, 2654, 2654, 2674, 2676, 2693, 2701, 2703, 2705, 2707, 2728, 2730, 2736, 2738, 2739, 2741, 2745, 2749, 2749, 2768, 2768, 2784, 2785, 2809, 2809, 2821, 2828, 2831, 2832, 2835, 2856, 2858, 2864, 2866, 2867, 2869, 2873, 2877, 2877, 2908, 2909, 2911, 2913, 2929, 2929, 2947, 2947, 2949, 2954, 2958, 2960, 2962, 2965, 2969, 2970, 2972, 2972, 2974, 2975, 2979, 2980, 2984, 2986, 2990, 3001, 3024, 3024, 3077, 3084, 3086, 3088, 3090, 3112, 3114, 3129, 3133, 3133, 3160, 3162, 3165, 3165, 3168, 3169, 3200, 3200, 3205, 3212, 3214, 3216, 3218, 3240, 3242, 3251, 3253, 3257, 3261, 3261, 3293, 3294, 3296, 3297, 3313, 3314, 3332, 3340, 3342, 3344, 3346, 3386, 3389, 3389, 3406, 3406, 3412, 3414, 3423, 3425, 3450, 3455, 3461, 3478, 3482, 3505, 3507, 3515, 3517, 3517, 3520, 3526, 3585, 3632, 3634, 3635, 3648, 3654, 3713, 3714, 3716, 3716, 3718, 3722, 3724, 3747, 3749, 3749, 3751, 3760, 3762, 3763, 3773, 3773, 3776, 3780, 3782, 3782, 3804, 3807, 3840, 3840, 3904, 3911, 3913, 3948, 3976, 3980, 4096, 4138, 4159, 4159, 4176, 4181, 4186, 4189, 4193, 4193, 4197, 4198, 4206, 4208, 4213, 4225, 4238, 4238, 4256, 4293, 4295, 4295, 4301, 4301, 4304, 4346, 4348, 4680, 4682, 4685, 4688, 4694, 4696, 4696, 4698, 4701, 4704, 4744, 4746, 4749, 4752, 4784, 4786, 4789, 4792, 4798, 4800, 4800, 4802, 4805, 4808, 4822, 4824, 4880, 4882, 4885, 4888, 4954, 4992, 5007, 5024, 5109, 5112, 5117, 5121, 5740, 5743, 5759, 5761, 5786, 5792, 5866, 5873, 5880, 5888, 5905, 5919, 5937, 5952, 5969, 5984, 5996, 5998, 6000, 6016, 6067, 6103, 6103, 6108, 6108, 6176, 6264, 6272, 6276, 6279, 6312, 6314, 6314, 6320, 6389, 6400, 6430, 6480, 6509, 6512, 6516, 6528, 6571, 6576, 6601, 6656, 6678, 6688, 6740, 6823, 6823, 6917, 6963, 6981, 6988, 7043, 7072, 7086, 7087, 7098, 7141, 7168, 7203, 7245, 7247, 7258, 7293, 7296, 7306, 7312, 7354, 7357, 7359, 7401, 7404, 7406, 7411, 7413, 7414, 7418, 7418, 7424, 7615, 7680, 7957, 7960, 7965, 7968, 8005, 8008, 8013, 8016, 8023, 8025, 8025, 8027, 8027, 8029, 8029, 8031, 8061, 8064, 8116, 8118, 8124, 8126, 8126, 8130, 8132, 8134, 8140, 8144, 8147, 8150, 8155, 8160, 8172, 8178, 8180, 8182, 8188, 8305, 8305, 8319, 8319, 8336, 8348, 8450, 8450, 8455, 8455, 8458, 8467, 8469, 8469, 8473, 8477, 8484, 8484, 8486, 8486, 8488, 8488, 8490, 8493, 8495, 8505, 8508, 8511, 8517, 8521, 8526, 8526, 8579, 8580, 11264, 11492, 11499, 11502, 11506, 11507, 11520, 11557, 11559, 11559, 11565, 11565, 11568, 11623, 11631, 11631, 11648, 11670, 11680, 11686, 11688, 11694, 11696, 11702, 11704, 11710, 11712, 11718, 11720, 11726, 11728, 11734, 11736, 11742, 11823, 11823, 12293, 12294, 12337, 12341, 12347, 12348, 12353, 12438, 12445, 12447, 12449, 12538, 12540, 12543, 12549, 12591, 12593, 12686, 12704, 12735, 12784, 12799, 13312, 19903, 19968, 42124, 42192, 42237, 42240, 42508, 42512, 42527, 42538, 42539, 42560, 42606, 42623, 42653, 42656, 42725, 42775, 42783, 42786, 42888, 42891, 42957, 42960, 42961, 42963, 42963, 42965, 42972, 42994, 43009, 43011, 43013, 43015, 43018, 43020, 43042, 43072, 43123, 43138, 43187, 43250, 43255, 43259, 43259, 43261, 43262, 43274, 43301, 43312, 43334, 43360, 43388, 43396, 43442, 43471, 43471, 43488, 43492, 43494, 43503, 43514, 43518, 43520, 43560, 43584, 43586, 43588, 43595, 43616, 43638, 43642, 43642, 43646, 43695, 43697, 43697, 43701, 43702, 43705, 43709, 43712, 43712, 43714, 43714, 43739, 43741, 43744, 43754, 43762, 43764, 43777, 43782, 43785, 43790, 43793, 43798, 43808, 43814, 43816, 43822, 43824, 43866, 43868, 43881, 43888, 44002, 44032, 55203, 55216, 55238, 55243, 55291, 63744, 64109, 64112, 64217, 64256, 64262, 64275, 64279, 64285, 64285, 64287, 64296, 64298, 64310, 64312, 64316, 64318, 64318, 64320, 64321, 64323, 64324, 64326, 64433, 64467, 64829, 64848, 64911, 64914, 64967, 65008, 65019, 65136, 65140, 65142, 65276, 65313, 65338, 65345, 65370, 65382, 65470, 65474, 65479, 65482, 65487, 65490, 65495, 65498, 65500, 65536, 65547, 65549, 65574, 65576, 65594, 65596, 65597, 65599, 65613, 65616, 65629, 65664, 65786, 66176, 66204, 66208, 66256, 66304, 66335, 66349, 66368, 66370, 66377, 66384, 66421, 66432, 66461, 66464, 66499, 66504, 66511, 66560, 66717, 66736, 66771, 66776, 66811, 66816, 66855, 66864, 66915, 66928, 66938, 66940, 66954, 66956, 66962, 66964, 66965, 66967, 66977, 66979, 66993, 66995, 67001, 67003, 67004, 67008, 67059, 67072, 67382, 67392, 67413, 67424, 67431, 67456, 67461, 67463, 67504, 67506, 67514, 67584, 67589, 67592, 67592, 67594, 67637, 67639, 67640, 67644, 67644, 67647, 67669, 67680, 67702, 67712, 67742, 67808, 67826, 67828, 67829, 67840, 67861, 67872, 67897, 67968, 68023, 68030, 68031, 68096, 68096, 68112, 68115, 68117, 68119, 68121, 68149, 68192, 68220, 68224, 68252, 68288, 68295, 68297, 68324, 68352, 68405, 68416, 68437, 68448, 68466, 68480, 68497, 68608, 68680, 68736, 68786, 68800, 68850, 68864, 68899, 68938, 68965, 68975, 68997, 69248, 69289, 69296, 69297, 69314, 69316, 69376, 69404, 69415, 69415, 69424, 69445, 69488, 69505, 69552, 69572, 69600, 69622, 69635, 69687, 69745, 69746, 69749, 69749, 69763, 69807, 69840, 69864, 69891, 69926, 69956, 69956, 69959, 69959, 69968, 70002, 70006, 70006, 70019, 70066, 70081, 70084, 70106, 70106, 70108, 70108, 70144, 70161, 70163, 70187, 70207, 70208, 70272, 70278, 70280, 70280, 70282, 70285, 70287, 70301, 70303, 70312, 70320, 70366, 70405, 70412, 70415, 70416, 70419, 70440, 70442, 70448, 70450, 70451, 70453, 70457, 70461, 70461, 70480, 70480, 70493, 70497, 70528, 70537, 70539, 70539, 70542, 70542, 70544, 70581, 70583, 70583, 70609, 70609, 70611, 70611, 70656, 70708, 70727, 70730, 70751, 70753, 70784, 70831, 70852, 70853, 70855, 70855, 71040, 71086, 71128, 71131, 71168, 71215, 71236, 71236, 71296, 71338, 71352, 71352, 71424, 71450, 71488, 71494, 71680, 71723, 71840, 71903, 71935, 71942, 71945, 71945, 71948, 71955, 71957, 71958, 71960, 71983, 71999, 71999, 72001, 72001, 72096, 72103, 72106, 72144, 72161, 72161, 72163, 72163, 72192, 72192, 72203, 72242, 72250, 72250, 72272, 72272, 72284, 72329, 72349, 72349, 72368, 72440, 72640, 72672, 72704, 72712, 72714, 72750, 72768, 72768, 72818, 72847, 72960, 72966, 72968, 72969, 72971, 73008, 73030, 73030, 73056, 73061, 73063, 73064, 73066, 73097, 73112, 73112, 73440, 73458, 73474, 73474, 73476, 73488, 73490, 73523, 73648, 73648, 73728, 74649, 74880, 75075, 77712, 77808, 77824, 78895, 78913, 78918, 78944, 82938, 82944, 83526, 90368, 90397, 92160, 92728, 92736, 92766, 92784, 92862, 92880, 92909, 92928, 92975, 92992, 92995, 93027, 93047, 93053, 93071, 93504, 93548, 93760, 93823, 93952, 94026, 94032, 94032, 94099, 94111, 94176, 94177, 94179, 94179, 94208, 100343, 100352, 101589, 101631, 101640, 110576, 110579, 110581, 110587, 110589, 110590, 110592, 110882, 110898, 110898, 110928, 110930, 110933, 110933, 110948, 110951, 110960, 111355, 113664, 113770, 113776, 113788, 113792, 113800, 113808, 113817, 119808, 119892, 119894, 119964, 119966, 119967, 119970, 119970, 119973, 119974, 119977, 119980, 119982, 119993, 119995, 119995, 119997, 120003, 120005, 120069, 120071, 120074, 120077, 120084, 120086, 120092, 120094, 120121, 120123, 120126, 120128, 120132, 120134, 120134, 120138, 120144, 120146, 120485, 120488, 120512, 120514, 120538, 120540, 120570, 120572, 120596, 120598, 120628, 120630, 120654, 120656, 120686, 120688, 120712, 120714, 120744, 120746, 120770, 120772, 120779, 122624, 122654, 122661, 122666, 122928, 122989, 123136, 123180, 123191, 123197, 123214, 123214, 123536, 123565, 123584, 123627, 124112, 124139, 124368, 124397, 124400, 124400, 124896, 124902, 124904, 124907, 124909, 124910, 124912, 124926, 124928, 125124, 125184, 125251, 125259, 125259, 126464, 126467, 126469, 126495, 126497, 126498, 126500, 126500, 126503, 126503, 126505, 126514, 126516, 126519, 126521, 126521, 126523, 126523, 126530, 126530, 126535, 126535, 126537, 126537, 126539, 126539, 126541, 126543, 126545, 126546, 126548, 126548, 126551, 126551, 126553, 126553, 126555, 126555, 126557, 126557, 126559, 126559, 126561, 126562, 126564, 126564, 126567, 126570, 126572, 126578, 126580, 126583, 126585, 126588, 126590, 126590, 126592, 126601, 126603, 126619, 126625, 126627, 126629, 126633, 126635, 126651, 131072, 173791, 173824, 177977, 177984, 178205, 178208, 183969, 183984, 191456, 191472, 192093, 194560, 195101, 196608, 201546, 201552, 205743];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS50 = [768, 879, 1155, 1161, 1425, 1469, 1471, 1471, 1473, 1474, 1476, 1477, 1479, 1479, 1552, 1562, 1611, 1631, 1648, 1648, 1750, 1756, 1759, 1764, 1767, 1768, 1770, 1773, 1809, 1809, 1840, 1866, 1958, 1968, 2027, 2035, 2045, 2045, 2070, 2073, 2075, 2083, 2085, 2087, 2089, 2093, 2137, 2139, 2199, 2207, 2250, 2273, 2275, 2307, 2362, 2364, 2366, 2383, 2385, 2391, 2402, 2403, 2433, 2435, 2492, 2492, 2494, 2500, 2503, 2504, 2507, 2509, 2519, 2519, 2530, 2531, 2558, 2558, 2561, 2563, 2620, 2620, 2622, 2626, 2631, 2632, 2635, 2637, 2641, 2641, 2672, 2673, 2677, 2677, 2689, 2691, 2748, 2748, 2750, 2757, 2759, 2761, 2763, 2765, 2786, 2787, 2810, 2815, 2817, 2819, 2876, 2876, 2878, 2884, 2887, 2888, 2891, 2893, 2901, 2903, 2914, 2915, 2946, 2946, 3006, 3010, 3014, 3016, 3018, 3021, 3031, 3031, 3072, 3076, 3132, 3132, 3134, 3140, 3142, 3144, 3146, 3149, 3157, 3158, 3170, 3171, 3201, 3203, 3260, 3260, 3262, 3268, 3270, 3272, 3274, 3277, 3285, 3286, 3298, 3299, 3315, 3315, 3328, 3331, 3387, 3388, 3390, 3396, 3398, 3400, 3402, 3405, 3415, 3415, 3426, 3427, 3457, 3459, 3530, 3530, 3535, 3540, 3542, 3542, 3544, 3551, 3570, 3571, 3633, 3633, 3636, 3642, 3655, 3662, 3761, 3761, 3764, 3772, 3784, 3790, 3864, 3865, 3893, 3893, 3895, 3895, 3897, 3897, 3902, 3903, 3953, 3972, 3974, 3975, 3981, 3991, 3993, 4028, 4038, 4038, 4139, 4158, 4182, 4185, 4190, 4192, 4194, 4196, 4199, 4205, 4209, 4212, 4226, 4237, 4239, 4239, 4250, 4253, 4957, 4959, 5906, 5909, 5938, 5940, 5970, 5971, 6002, 6003, 6068, 6099, 6109, 6109, 6155, 6157, 6159, 6159, 6277, 6278, 6313, 6313, 6432, 6443, 6448, 6459, 6679, 6683, 6741, 6750, 6752, 6780, 6783, 6783, 6832, 6862, 6912, 6916, 6964, 6980, 7019, 7027, 7040, 7042, 7073, 7085, 7142, 7155, 7204, 7223, 7376, 7378, 7380, 7400, 7405, 7405, 7412, 7412, 7415, 7417, 7616, 7679, 8400, 8432, 11503, 11505, 11647, 11647, 11744, 11775, 12330, 12335, 12441, 12442, 42607, 42610, 42612, 42621, 42654, 42655, 42736, 42737, 43010, 43010, 43014, 43014, 43019, 43019, 43043, 43047, 43052, 43052, 43136, 43137, 43188, 43205, 43232, 43249, 43263, 43263, 43302, 43309, 43335, 43347, 43392, 43395, 43443, 43456, 43493, 43493, 43561, 43574, 43587, 43587, 43596, 43597, 43643, 43645, 43696, 43696, 43698, 43700, 43703, 43704, 43710, 43711, 43713, 43713, 43755, 43759, 43765, 43766, 44003, 44010, 44012, 44013, 64286, 64286, 65024, 65039, 65056, 65071, 66045, 66045, 66272, 66272, 66422, 66426, 68097, 68099, 68101, 68102, 68108, 68111, 68152, 68154, 68159, 68159, 68325, 68326, 68900, 68903, 68969, 68973, 69291, 69292, 69372, 69375, 69446, 69456, 69506, 69509, 69632, 69634, 69688, 69702, 69744, 69744, 69747, 69748, 69759, 69762, 69808, 69818, 69826, 69826, 69888, 69890, 69927, 69940, 69957, 69958, 70003, 70003, 70016, 70018, 70067, 70080, 70089, 70092, 70094, 70095, 70188, 70199, 70206, 70206, 70209, 70209, 70367, 70378, 70400, 70403, 70459, 70460, 70462, 70468, 70471, 70472, 70475, 70477, 70487, 70487, 70498, 70499, 70502, 70508, 70512, 70516, 70584, 70592, 70594, 70594, 70597, 70597, 70599, 70602, 70604, 70608, 70610, 70610, 70625, 70626, 70709, 70726, 70750, 70750, 70832, 70851, 71087, 71093, 71096, 71104, 71132, 71133, 71216, 71232, 71339, 71351, 71453, 71467, 71724, 71738, 71984, 71989, 71991, 71992, 71995, 71998, 72000, 72000, 72002, 72003, 72145, 72151, 72154, 72160, 72164, 72164, 72193, 72202, 72243, 72249, 72251, 72254, 72263, 72263, 72273, 72283, 72330, 72345, 72751, 72758, 72760, 72767, 72850, 72871, 72873, 72886, 73009, 73014, 73018, 73018, 73020, 73021, 73023, 73029, 73031, 73031, 73098, 73102, 73104, 73105, 73107, 73111, 73459, 73462, 73472, 73473, 73475, 73475, 73524, 73530, 73534, 73538, 73562, 73562, 78912, 78912, 78919, 78933, 90398, 90415, 92912, 92916, 92976, 92982, 94031, 94031, 94033, 94087, 94095, 94098, 94180, 94180, 94192, 94193, 113821, 113822, 118528, 118573, 118576, 118598, 119141, 119145, 119149, 119154, 119163, 119170, 119173, 119179, 119210, 119213, 119362, 119364, 121344, 121398, 121403, 121452, 121461, 121461, 121476, 121476, 121499, 121503, 121505, 121519, 122880, 122886, 122888, 122904, 122907, 122913, 122915, 122916, 122918, 122922, 123023, 123023, 123184, 123190, 123566, 123566, 123628, 123631, 124140, 124143, 124398, 124399, 125136, 125142, 125252, 125258, 917760, 917999];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS51 = [48, 57, 178, 179, 185, 185, 188, 190, 1632, 1641, 1776, 1785, 1984, 1993, 2406, 2415, 2534, 2543, 2548, 2553, 2662, 2671, 2790, 2799, 2918, 2927, 2930, 2935, 3046, 3058, 3174, 3183, 3192, 3198, 3302, 3311, 3416, 3422, 3430, 3448, 3558, 3567, 3664, 3673, 3792, 3801, 3872, 3891, 4160, 4169, 4240, 4249, 4969, 4988, 5870, 5872, 6112, 6121, 6128, 6137, 6160, 6169, 6470, 6479, 6608, 6618, 6784, 6793, 6800, 6809, 6992, 7001, 7088, 7097, 7232, 7241, 7248, 7257, 8304, 8304, 8308, 8313, 8320, 8329, 8528, 8578, 8581, 8585, 9312, 9371, 9450, 9471, 10102, 10131, 11517, 11517, 12295, 12295, 12321, 12329, 12344, 12346, 12690, 12693, 12832, 12841, 12872, 12879, 12881, 12895, 12928, 12937, 12977, 12991, 42528, 42537, 42726, 42735, 43056, 43061, 43216, 43225, 43264, 43273, 43472, 43481, 43504, 43513, 43600, 43609, 44016, 44025, 65296, 65305, 65799, 65843, 65856, 65912, 65930, 65931, 66273, 66299, 66336, 66339, 66369, 66369, 66378, 66378, 66513, 66517, 66720, 66729, 67672, 67679, 67705, 67711, 67751, 67759, 67835, 67839, 67862, 67867, 68028, 68029, 68032, 68047, 68050, 68095, 68160, 68168, 68221, 68222, 68253, 68255, 68331, 68335, 68440, 68447, 68472, 68479, 68521, 68527, 68858, 68863, 68912, 68921, 68928, 68937, 69216, 69246, 69405, 69414, 69457, 69460, 69573, 69579, 69714, 69743, 69872, 69881, 69942, 69951, 70096, 70105, 70113, 70132, 70384, 70393, 70736, 70745, 70864, 70873, 71248, 71257, 71360, 71369, 71376, 71395, 71472, 71483, 71904, 71922, 72016, 72025, 72688, 72697, 72784, 72812, 73040, 73049, 73120, 73129, 73552, 73561, 73664, 73684, 74752, 74862, 90416, 90425, 92768, 92777, 92864, 92873, 93008, 93017, 93019, 93025, 93552, 93561, 93824, 93846, 118000, 118009, 119488, 119507, 119520, 119539, 119648, 119672, 120782, 120831, 123200, 123209, 123632, 123641, 124144, 124153, 124401, 124410, 125127, 125135, 125264, 125273, 126065, 126123, 126125, 126127, 126129, 126132, 126209, 126253, 126255, 126269, 127232, 127244, 130032, 130041];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS52 = [33, 35, 37, 42, 44, 47, 58, 59, 63, 64, 91, 93, 95, 95, 123, 123, 125, 125, 161, 161, 167, 167, 171, 171, 182, 183, 187, 187, 191, 191, 894, 894, 903, 903, 1370, 1375, 1417, 1418, 1470, 1470, 1472, 1472, 1475, 1475, 1478, 1478, 1523, 1524, 1545, 1546, 1548, 1549, 1563, 1563, 1565, 1567, 1642, 1645, 1748, 1748, 1792, 1805, 2039, 2041, 2096, 2110, 2142, 2142, 2404, 2405, 2416, 2416, 2557, 2557, 2678, 2678, 2800, 2800, 3191, 3191, 3204, 3204, 3572, 3572, 3663, 3663, 3674, 3675, 3844, 3858, 3860, 3860, 3898, 3901, 3973, 3973, 4048, 4052, 4057, 4058, 4170, 4175, 4347, 4347, 4960, 4968, 5120, 5120, 5742, 5742, 5787, 5788, 5867, 5869, 5941, 5942, 6100, 6102, 6104, 6106, 6144, 6154, 6468, 6469, 6686, 6687, 6816, 6822, 6824, 6829, 6990, 6991, 7002, 7008, 7037, 7039, 7164, 7167, 7227, 7231, 7294, 7295, 7360, 7367, 7379, 7379, 8208, 8231, 8240, 8259, 8261, 8273, 8275, 8286, 8317, 8318, 8333, 8334, 8968, 8971, 9001, 9002, 10088, 10101, 10181, 10182, 10214, 10223, 10627, 10648, 10712, 10715, 10748, 10749, 11513, 11516, 11518, 11519, 11632, 11632, 11776, 11822, 11824, 11855, 11858, 11869, 12289, 12291, 12296, 12305, 12308, 12319, 12336, 12336, 12349, 12349, 12448, 12448, 12539, 12539, 42238, 42239, 42509, 42511, 42611, 42611, 42622, 42622, 42738, 42743, 43124, 43127, 43214, 43215, 43256, 43258, 43260, 43260, 43310, 43311, 43359, 43359, 43457, 43469, 43486, 43487, 43612, 43615, 43742, 43743, 43760, 43761, 44011, 44011, 64830, 64831, 65040, 65049, 65072, 65106, 65108, 65121, 65123, 65123, 65128, 65128, 65130, 65131, 65281, 65283, 65285, 65290, 65292, 65295, 65306, 65307, 65311, 65312, 65339, 65341, 65343, 65343, 65371, 65371, 65373, 65373, 65375, 65381, 65792, 65794, 66463, 66463, 66512, 66512, 66927, 66927, 67671, 67671, 67871, 67871, 67903, 67903, 68176, 68184, 68223, 68223, 68336, 68342, 68409, 68415, 68505, 68508, 68974, 68974, 69293, 69293, 69461, 69465, 69510, 69513, 69703, 69709, 69819, 69820, 69822, 69825, 69952, 69955, 70004, 70005, 70085, 70088, 70093, 70093, 70107, 70107, 70109, 70111, 70200, 70205, 70313, 70313, 70612, 70613, 70615, 70616, 70731, 70735, 70746, 70747, 70749, 70749, 70854, 70854, 71105, 71127, 71233, 71235, 71264, 71276, 71353, 71353, 71484, 71486, 71739, 71739, 72004, 72006, 72162, 72162, 72255, 72262, 72346, 72348, 72350, 72354, 72448, 72457, 72673, 72673, 72769, 72773, 72816, 72817, 73463, 73464, 73539, 73551, 73727, 73727, 74864, 74868, 77809, 77810, 92782, 92783, 92917, 92917, 92983, 92987, 92996, 92996, 93549, 93551, 93847, 93850, 94178, 94178, 113823, 113823, 121479, 121483, 124415, 124415, 125278, 125279];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS53 = [36, 36, 43, 43, 60, 62, 94, 94, 96, 96, 124, 124, 126, 126, 162, 166, 168, 169, 172, 172, 174, 177, 180, 180, 184, 184, 215, 215, 247, 247, 706, 709, 722, 735, 741, 747, 749, 749, 751, 767, 885, 885, 900, 901, 1014, 1014, 1154, 1154, 1421, 1423, 1542, 1544, 1547, 1547, 1550, 1551, 1758, 1758, 1769, 1769, 1789, 1790, 2038, 2038, 2046, 2047, 2184, 2184, 2546, 2547, 2554, 2555, 2801, 2801, 2928, 2928, 3059, 3066, 3199, 3199, 3407, 3407, 3449, 3449, 3647, 3647, 3841, 3843, 3859, 3859, 3861, 3863, 3866, 3871, 3892, 3892, 3894, 3894, 3896, 3896, 4030, 4037, 4039, 4044, 4046, 4047, 4053, 4056, 4254, 4255, 5008, 5017, 5741, 5741, 6107, 6107, 6464, 6464, 6622, 6655, 7009, 7018, 7028, 7036, 8125, 8125, 8127, 8129, 8141, 8143, 8157, 8159, 8173, 8175, 8189, 8190, 8260, 8260, 8274, 8274, 8314, 8316, 8330, 8332, 8352, 8384, 8448, 8449, 8451, 8454, 8456, 8457, 8468, 8468, 8470, 8472, 8478, 8483, 8485, 8485, 8487, 8487, 8489, 8489, 8494, 8494, 8506, 8507, 8512, 8516, 8522, 8525, 8527, 8527, 8586, 8587, 8592, 8967, 8972, 9000, 9003, 9257, 9280, 9290, 9372, 9449, 9472, 10087, 10132, 10180, 10183, 10213, 10224, 10626, 10649, 10711, 10716, 10747, 10750, 11123, 11126, 11157, 11159, 11263, 11493, 11498, 11856, 11857, 11904, 11929, 11931, 12019, 12032, 12245, 12272, 12287, 12292, 12292, 12306, 12307, 12320, 12320, 12342, 12343, 12350, 12351, 12443, 12444, 12688, 12689, 12694, 12703, 12736, 12773, 12783, 12783, 12800, 12830, 12842, 12871, 12880, 12880, 12896, 12927, 12938, 12976, 12992, 13311, 19904, 19967, 42128, 42182, 42752, 42774, 42784, 42785, 42889, 42890, 43048, 43051, 43062, 43065, 43639, 43641, 43867, 43867, 43882, 43883, 64297, 64297, 64434, 64450, 64832, 64847, 64975, 64975, 65020, 65023, 65122, 65122, 65124, 65126, 65129, 65129, 65284, 65284, 65291, 65291, 65308, 65310, 65342, 65342, 65344, 65344, 65372, 65372, 65374, 65374, 65504, 65510, 65512, 65518, 65532, 65533, 65847, 65855, 65913, 65929, 65932, 65934, 65936, 65948, 65952, 65952, 66000, 66044, 67703, 67704, 68296, 68296, 69006, 69007, 71487, 71487, 73685, 73713, 92988, 92991, 92997, 92997, 113820, 113820, 117760, 117999, 118016, 118451, 118608, 118723, 118784, 119029, 119040, 119078, 119081, 119140, 119146, 119148, 119171, 119172, 119180, 119209, 119214, 119274, 119296, 119361, 119365, 119365, 119552, 119638, 120513, 120513, 120539, 120539, 120571, 120571, 120597, 120597, 120629, 120629, 120655, 120655, 120687, 120687, 120713, 120713, 120745, 120745, 120771, 120771, 120832, 121343, 121399, 121402, 121453, 121460, 121462, 121475, 121477, 121478, 123215, 123215, 123647, 123647, 126124, 126124, 126128, 126128, 126254, 126254, 126704, 126705, 126976, 127019, 127024, 127123, 127136, 127150, 127153, 127167, 127169, 127183, 127185, 127221, 127245, 127405, 127462, 127490, 127504, 127547, 127552, 127560, 127568, 127569, 127584, 127589, 127744, 128727, 128732, 128748, 128752, 128764, 128768, 128886, 128891, 128985, 128992, 129003, 129008, 129008, 129024, 129035, 129040, 129095, 129104, 129113, 129120, 129159, 129168, 129197, 129200, 129211, 129216, 129217, 129280, 129619, 129632, 129645, 129648, 129660, 129664, 129673, 129679, 129734, 129742, 129756, 129759, 129769, 129776, 129784, 129792, 129938, 129940, 130031];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS54 = [32, 32, 160, 160, 5760, 5760, 8192, 8202, 8232, 8233, 8239, 8239, 8287, 8287, 12288, 12288];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS55 = [0, 31, 127, 159, 173, 1541, 1564, 1564, 1757, 2198, 2274, 2274, 6158, 6158, 8203, 8207, 8234, 8238, 8288, 65531, 69821, 69839, 78896, 78911, 113824, 117759, 119155, 1114109];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS56 = [888, 889, 896, 899, 907, 907, 909, 909, 930, 930, 1328, 1328, 1367, 1368, 1419, 1420, 1424, 1424, 1480, 1487, 1515, 1518, 1525, 1535, 1806, 1806, 1867, 1868, 1970, 1983, 2043, 2044, 2094, 2095, 2111, 2111, 2140, 2141, 2143, 2143, 2155, 2159, 2191, 2191, 2194, 2198, 2436, 2436, 2445, 2446, 2449, 2450, 2473, 2473, 2481, 2481, 2483, 2485, 2490, 2491, 2501, 2502, 2505, 2506, 2511, 2518, 2520, 2523, 2526, 2526, 2532, 2533, 2559, 2560, 2564, 2564, 2571, 2574, 2577, 2578, 2601, 2601, 2609, 2609, 2612, 2612, 2615, 2615, 2618, 2619, 2621, 2621, 2627, 2630, 2633, 2634, 2638, 2640, 2642, 2648, 2653, 2653, 2655, 2661, 2679, 2688, 2692, 2692, 2702, 2702, 2706, 2706, 2729, 2729, 2737, 2737, 2740, 2740, 2746, 2747, 2758, 2758, 2762, 2762, 2766, 2767, 2769, 2783, 2788, 2789, 2802, 2808, 2816, 2816, 2820, 2820, 2829, 2830, 2833, 2834, 2857, 2857, 2865, 2865, 2868, 2868, 2874, 2875, 2885, 2886, 2889, 2890, 2894, 2900, 2904, 2907, 2910, 2910, 2916, 2917, 2936, 2945, 2948, 2948, 2955, 2957, 2961, 2961, 2966, 2968, 2971, 2971, 2973, 2973, 2976, 2978, 2981, 2983, 2987, 2989, 3002, 3005, 3011, 3013, 3017, 3017, 3022, 3023, 3025, 3030, 3032, 3045, 3067, 3071, 3085, 3085, 3089, 3089, 3113, 3113, 3130, 3131, 3141, 3141, 3145, 3145, 3150, 3156, 3159, 3159, 3163, 3164, 3166, 3167, 3172, 3173, 3184, 3190, 3213, 3213, 3217, 3217, 3241, 3241, 3252, 3252, 3258, 3259, 3269, 3269, 3273, 3273, 3278, 3284, 3287, 3292, 3295, 3295, 3300, 3301, 3312, 3312, 3316, 3327, 3341, 3341, 3345, 3345, 3397, 3397, 3401, 3401, 3408, 3411, 3428, 3429, 3456, 3456, 3460, 3460, 3479, 3481, 3506, 3506, 3516, 3516, 3518, 3519, 3527, 3529, 3531, 3534, 3541, 3541, 3543, 3543, 3552, 3557, 3568, 3569, 3573, 3584, 3643, 3646, 3676, 3712, 3715, 3715, 3717, 3717, 3723, 3723, 3748, 3748, 3750, 3750, 3774, 3775, 3781, 3781, 3783, 3783, 3791, 3791, 3802, 3803, 3808, 3839, 3912, 3912, 3949, 3952, 3992, 3992, 4029, 4029, 4045, 4045, 4059, 4095, 4294, 4294, 4296, 4300, 4302, 4303, 4681, 4681, 4686, 4687, 4695, 4695, 4697, 4697, 4702, 4703, 4745, 4745, 4750, 4751, 4785, 4785, 4790, 4791, 4799, 4799, 4801, 4801, 4806, 4807, 4823, 4823, 4881, 4881, 4886, 4887, 4955, 4956, 4989, 4991, 5018, 5023, 5110, 5111, 5118, 5119, 5789, 5791, 5881, 5887, 5910, 5918, 5943, 5951, 5972, 5983, 5997, 5997, 6001, 6001, 6004, 6015, 6110, 6111, 6122, 6127, 6138, 6143, 6170, 6175, 6265, 6271, 6315, 6319, 6390, 6399, 6431, 6431, 6444, 6447, 6460, 6463, 6465, 6467, 6510, 6511, 6517, 6527, 6572, 6575, 6602, 6607, 6619, 6621, 6684, 6685, 6751, 6751, 6781, 6782, 6794, 6799, 6810, 6815, 6830, 6831, 6863, 6911, 6989, 6989, 7156, 7163, 7224, 7226, 7242, 7244, 7307, 7311, 7355, 7356, 7368, 7375, 7419, 7423, 7958, 7959, 7966, 7967, 8006, 8007, 8014, 8015, 8024, 8024, 8026, 8026, 8028, 8028, 8030, 8030, 8062, 8063, 8117, 8117, 8133, 8133, 8148, 8149, 8156, 8156, 8176, 8177, 8181, 8181, 8191, 8191, 8293, 8293, 8306, 8307, 8335, 8335, 8349, 8351, 8385, 8399, 8433, 8447, 8588, 8591, 9258, 9279, 9291, 9311, 11124, 11125, 11158, 11158, 11508, 11512, 11558, 11558, 11560, 11564, 11566, 11567, 11624, 11630, 11633, 11646, 11671, 11679, 11687, 11687, 11695, 11695, 11703, 11703, 11711, 11711, 11719, 11719, 11727, 11727, 11735, 11735, 11743, 11743, 11870, 11903, 11930, 11930, 12020, 12031, 12246, 12271, 12352, 12352, 12439, 12440, 12544, 12548, 12592, 12592, 12687, 12687, 12774, 12782, 12831, 12831, 42125, 42127, 42183, 42191, 42540, 42559, 42744, 42751, 42958, 42959, 42962, 42962, 42964, 42964, 42973, 42993, 43053, 43055, 43066, 43071, 43128, 43135, 43206, 43213, 43226, 43231, 43348, 43358, 43389, 43391, 43470, 43470, 43482, 43485, 43519, 43519, 43575, 43583, 43598, 43599, 43610, 43611, 43715, 43738, 43767, 43776, 43783, 43784, 43791, 43792, 43799, 43807, 43815, 43815, 43823, 43823, 43884, 43887, 44014, 44015, 44026, 44031, 55204, 55215, 55239, 55242, 55292, 55295, 64110, 64111, 64218, 64255, 64263, 64274, 64280, 64284, 64311, 64311, 64317, 64317, 64319, 64319, 64322, 64322, 64325, 64325, 64451, 64466, 64912, 64913, 64968, 64974, 64976, 65007, 65050, 65055, 65107, 65107, 65127, 65127, 65132, 65135, 65141, 65141, 65277, 65278, 65280, 65280, 65471, 65473, 65480, 65481, 65488, 65489, 65496, 65497, 65501, 65503, 65511, 65511, 65519, 65528, 65534, 65535, 65548, 65548, 65575, 65575, 65595, 65595, 65598, 65598, 65614, 65615, 65630, 65663, 65787, 65791, 65795, 65798, 65844, 65846, 65935, 65935, 65949, 65951, 65953, 65999, 66046, 66175, 66205, 66207, 66257, 66271, 66300, 66303, 66340, 66348, 66379, 66383, 66427, 66431, 66462, 66462, 66500, 66503, 66518, 66559, 66718, 66719, 66730, 66735, 66772, 66775, 66812, 66815, 66856, 66863, 66916, 66926, 66939, 66939, 66955, 66955, 66963, 66963, 66966, 66966, 66978, 66978, 66994, 66994, 67002, 67002, 67005, 67007, 67060, 67071, 67383, 67391, 67414, 67423, 67432, 67455, 67462, 67462, 67505, 67505, 67515, 67583, 67590, 67591, 67593, 67593, 67638, 67638, 67641, 67643, 67645, 67646, 67670, 67670, 67743, 67750, 67760, 67807, 67827, 67827, 67830, 67834, 67868, 67870, 67898, 67902, 67904, 67967, 68024, 68027, 68048, 68049, 68100, 68100, 68103, 68107, 68116, 68116, 68120, 68120, 68150, 68151, 68155, 68158, 68169, 68175, 68185, 68191, 68256, 68287, 68327, 68330, 68343, 68351, 68406, 68408, 68438, 68439, 68467, 68471, 68498, 68504, 68509, 68520, 68528, 68607, 68681, 68735, 68787, 68799, 68851, 68857, 68904, 68911, 68922, 68927, 68966, 68968, 68998, 69005, 69008, 69215, 69247, 69247, 69290, 69290, 69294, 69295, 69298, 69313, 69317, 69371, 69416, 69423, 69466, 69487, 69514, 69551, 69580, 69599, 69623, 69631, 69710, 69713, 69750, 69758, 69827, 69836, 69838, 69839, 69865, 69871, 69882, 69887, 69941, 69941, 69960, 69967, 70007, 70015, 70112, 70112, 70133, 70143, 70162, 70162, 70210, 70271, 70279, 70279, 70281, 70281, 70286, 70286, 70302, 70302, 70314, 70319, 70379, 70383, 70394, 70399, 70404, 70404, 70413, 70414, 70417, 70418, 70441, 70441, 70449, 70449, 70452, 70452, 70458, 70458, 70469, 70470, 70473, 70474, 70478, 70479, 70481, 70486, 70488, 70492, 70500, 70501, 70509, 70511, 70517, 70527, 70538, 70538, 70540, 70541, 70543, 70543, 70582, 70582, 70593, 70593, 70595, 70596, 70598, 70598, 70603, 70603, 70614, 70614, 70617, 70624, 70627, 70655, 70748, 70748, 70754, 70783, 70856, 70863, 70874, 71039, 71094, 71095, 71134, 71167, 71237, 71247, 71258, 71263, 71277, 71295, 71354, 71359, 71370, 71375, 71396, 71423, 71451, 71452, 71468, 71471, 71495, 71679, 71740, 71839, 71923, 71934, 71943, 71944, 71946, 71947, 71956, 71956, 71959, 71959, 71990, 71990, 71993, 71994, 72007, 72015, 72026, 72095, 72104, 72105, 72152, 72153, 72165, 72191, 72264, 72271, 72355, 72367, 72441, 72447, 72458, 72639, 72674, 72687, 72698, 72703, 72713, 72713, 72759, 72759, 72774, 72783, 72813, 72815, 72848, 72849, 72872, 72872, 72887, 72959, 72967, 72967, 72970, 72970, 73015, 73017, 73019, 73019, 73022, 73022, 73032, 73039, 73050, 73055, 73062, 73062, 73065, 73065, 73103, 73103, 73106, 73106, 73113, 73119, 73130, 73439, 73465, 73471, 73489, 73489, 73531, 73533, 73563, 73647, 73649, 73663, 73714, 73726, 74650, 74751, 74863, 74863, 74869, 74879, 75076, 77711, 77811, 77823, 78934, 78943, 82939, 82943, 83527, 90367, 90426, 92159, 92729, 92735, 92767, 92767, 92778, 92781, 92863, 92863, 92874, 92879, 92910, 92911, 92918, 92927, 92998, 93007, 93018, 93018, 93026, 93026, 93048, 93052, 93072, 93503, 93562, 93759, 93851, 93951, 94027, 94030, 94088, 94094, 94112, 94175, 94181, 94191, 94194, 94207, 100344, 100351, 101590, 101630, 101641, 110575, 110580, 110580, 110588, 110588, 110591, 110591, 110883, 110897, 110899, 110927, 110931, 110932, 110934, 110947, 110952, 110959, 111356, 113663, 113771, 113775, 113789, 113791, 113801, 113807, 113818, 113819, 113828, 117759, 118010, 118015, 118452, 118527, 118574, 118575, 118599, 118607, 118724, 118783, 119030, 119039, 119079, 119080, 119275, 119295, 119366, 119487, 119508, 119519, 119540, 119551, 119639, 119647, 119673, 119807, 119893, 119893, 119965, 119965, 119968, 119969, 119971, 119972, 119975, 119976, 119981, 119981, 119994, 119994, 119996, 119996, 120004, 120004, 120070, 120070, 120075, 120076, 120085, 120085, 120093, 120093, 120122, 120122, 120127, 120127, 120133, 120133, 120135, 120137, 120145, 120145, 120486, 120487, 120780, 120781, 121484, 121498, 121504, 121504, 121520, 122623, 122655, 122660, 122667, 122879, 122887, 122887, 122905, 122906, 122914, 122914, 122917, 122917, 122923, 122927, 122990, 123022, 123024, 123135, 123181, 123183, 123198, 123199, 123210, 123213, 123216, 123535, 123567, 123583, 123642, 123646, 123648, 124111, 124154, 124367, 124411, 124414, 124416, 124895, 124903, 124903, 124908, 124908, 124911, 124911, 124927, 124927, 125125, 125126, 125143, 125183, 125260, 125263, 125274, 125277, 125280, 126064, 126133, 126208, 126270, 126463, 126468, 126468, 126496, 126496, 126499, 126499, 126501, 126502, 126504, 126504, 126515, 126515, 126520, 126520, 126522, 126522, 126524, 126529, 126531, 126534, 126536, 126536, 126538, 126538, 126540, 126540, 126544, 126544, 126547, 126547, 126549, 126550, 126552, 126552, 126554, 126554, 126556, 126556, 126558, 126558, 126560, 126560, 126563, 126563, 126565, 126566, 126571, 126571, 126579, 126579, 126584, 126584, 126589, 126589, 126591, 126591, 126602, 126602, 126620, 126624, 126628, 126628, 126634, 126634, 126652, 126703, 126706, 126975, 127020, 127023, 127124, 127135, 127151, 127152, 127168, 127168, 127184, 127184, 127222, 127231, 127406, 127461, 127491, 127503, 127548, 127551, 127561, 127567, 127570, 127583, 127590, 127743, 128728, 128731, 128749, 128751, 128765, 128767, 128887, 128890, 128986, 128991, 129004, 129007, 129009, 129023, 129036, 129039, 129096, 129103, 129114, 129119, 129160, 129167, 129198, 129199, 129212, 129215, 129218, 129279, 129620, 129631, 129646, 129647, 129661, 129663, 129674, 129678, 129735, 129741, 129757, 129758, 129770, 129775, 129785, 129791, 129939, 129939, 130042, 131071, 173792, 173823, 177978, 177983, 178206, 178207, 183970, 183983, 191457, 191471, 192094, 194559, 195102, 196607, 201547, 201551, 205744, 917504, 917506, 917535, 917632, 917759, 918000, 983039, 1048574, 1048575];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS57 = [0, 31, 127, 159];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS58 = [32, 32, 160, 160, 5760, 5760, 8192, 8202, 8239, 8239, 8287, 8287, 12288, 12288];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS59 = [33, 35, 37, 39, 42, 42, 44, 44, 46, 47, 58, 59, 63, 64, 92, 92, 161, 161, 167, 167, 182, 183, 191, 191, 894, 894, 903, 903, 1370, 1375, 1417, 1417, 1472, 1472, 1475, 1475, 1478, 1478, 1523, 1524, 1545, 1546, 1548, 1549, 1563, 1563, 1565, 1567, 1642, 1645, 1748, 1748, 1792, 1805, 2039, 2041, 2096, 2110, 2142, 2142, 2404, 2405, 2416, 2416, 2557, 2557, 2678, 2678, 2800, 2800, 3191, 3191, 3204, 3204, 3572, 3572, 3663, 3663, 3674, 3675, 3844, 3858, 3860, 3860, 3973, 3973, 4048, 4052, 4057, 4058, 4170, 4175, 4347, 4347, 4960, 4968, 5742, 5742, 5867, 5869, 5941, 5942, 6100, 6102, 6104, 6106, 6144, 6149, 6151, 6154, 6468, 6469, 6686, 6687, 6816, 6822, 6824, 6829, 6990, 6991, 7002, 7008, 7037, 7039, 7164, 7167, 7227, 7231, 7294, 7295, 7360, 7367, 7379, 7379, 8214, 8215, 8224, 8231, 8240, 8248, 8251, 8254, 8257, 8259, 8263, 8273, 8275, 8275, 8277, 8286, 11513, 11516, 11518, 11519, 11632, 11632, 11776, 11777, 11782, 11784, 11787, 11787, 11790, 11798, 11800, 11801, 11803, 11803, 11806, 11807, 11818, 11822, 11824, 11833, 11836, 11839, 11841, 11841, 11843, 11855, 11858, 11860, 12289, 12291, 12349, 12349, 12539, 12539, 42238, 42239, 42509, 42511, 42611, 42611, 42622, 42622, 42738, 42743, 43124, 43127, 43214, 43215, 43256, 43258, 43260, 43260, 43310, 43311, 43359, 43359, 43457, 43469, 43486, 43487, 43612, 43615, 43742, 43743, 43760, 43761, 44011, 44011, 65040, 65046, 65049, 65049, 65072, 65072, 65093, 65094, 65097, 65100, 65104, 65106, 65108, 65111, 65119, 65121, 65128, 65128, 65130, 65131, 65281, 65283, 65285, 65287, 65290, 65290, 65292, 65292, 65294, 65295, 65306, 65307, 65311, 65312, 65340, 65340, 65377, 65377, 65380, 65381, 65792, 65794, 66463, 66463, 66512, 66512, 66927, 66927, 67671, 67671, 67871, 67871, 67903, 67903, 68176, 68184, 68223, 68223, 68336, 68342, 68409, 68415, 68505, 68508, 69461, 69465, 69510, 69513, 69703, 69709, 69819, 69820, 69822, 69825, 69952, 69955, 70004, 70005, 70085, 70088, 70093, 70093, 70107, 70107, 70109, 70111, 70200, 70205, 70313, 70313, 70612, 70613, 70615, 70616, 70731, 70735, 70746, 70747, 70749, 70749, 70854, 70854, 71105, 71127, 71233, 71235, 71264, 71276, 71353, 71353, 71484, 71486, 71739, 71739, 72004, 72006, 72162, 72162, 72255, 72262, 72346, 72348, 72350, 72354, 72448, 72457, 72673, 72673, 72769, 72773, 72816, 72817, 73463, 73464, 73539, 73551, 73727, 73727, 74864, 74868, 77809, 77810, 92782, 92783, 92917, 92917, 92983, 92987, 92996, 92996, 93549, 93551, 93847, 93850, 94178, 94178, 113823, 113823, 121479, 121483, 124415, 124415, 125278, 125279];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS60 = [36, 36, 162, 165, 1423, 1423, 1547, 1547, 2046, 2047, 2546, 2547, 2555, 2555, 2801, 2801, 3065, 3065, 3647, 3647, 6107, 6107, 8352, 8384, 43064, 43064, 65020, 65020, 65129, 65129, 65284, 65284, 65504, 65505, 65509, 65510, 73693, 73696, 123647, 123647, 126128, 126128];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS61 = [40, 40, 91, 91, 123, 123, 3898, 3898, 3900, 3900, 5787, 5787, 8218, 8218, 8222, 8222, 8261, 8261, 8317, 8317, 8333, 8333, 8968, 8968, 8970, 8970, 9001, 9001, 10088, 10088, 10090, 10090, 10092, 10092, 10094, 10094, 10096, 10096, 10098, 10098, 10100, 10100, 10181, 10181, 10214, 10214, 10216, 10216, 10218, 10218, 10220, 10220, 10222, 10222, 10627, 10627, 10629, 10629, 10631, 10631, 10633, 10633, 10635, 10635, 10637, 10637, 10639, 10639, 10641, 10641, 10643, 10643, 10645, 10645, 10647, 10647, 10712, 10712, 10714, 10714, 10748, 10748, 11810, 11810, 11812, 11812, 11814, 11814, 11816, 11816, 11842, 11842, 11861, 11861, 11863, 11863, 11865, 11865, 11867, 11867, 12296, 12296, 12298, 12298, 12300, 12300, 12302, 12302, 12304, 12304, 12308, 12308, 12310, 12310, 12312, 12312, 12314, 12314, 12317, 12317, 64831, 64831, 65047, 65047, 65077, 65077, 65079, 65079, 65081, 65081, 65083, 65083, 65085, 65085, 65087, 65087, 65089, 65089, 65091, 65091, 65095, 65095, 65113, 65113, 65115, 65115, 65117, 65117, 65288, 65288, 65339, 65339, 65371, 65371, 65375, 65375, 65378, 65378];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS62 = [41, 41, 93, 93, 125, 125, 3899, 3899, 3901, 3901, 5788, 5788, 8262, 8262, 8318, 8318, 8334, 8334, 8969, 8969, 8971, 8971, 9002, 9002, 10089, 10089, 10091, 10091, 10093, 10093, 10095, 10095, 10097, 10097, 10099, 10099, 10101, 10101, 10182, 10182, 10215, 10215, 10217, 10217, 10219, 10219, 10221, 10221, 10223, 10223, 10628, 10628, 10630, 10630, 10632, 10632, 10634, 10634, 10636, 10636, 10638, 10638, 10640, 10640, 10642, 10642, 10644, 10644, 10646, 10646, 10648, 10648, 10713, 10713, 10715, 10715, 10749, 10749, 11811, 11811, 11813, 11813, 11815, 11815, 11817, 11817, 11862, 11862, 11864, 11864, 11866, 11866, 11868, 11868, 12297, 12297, 12299, 12299, 12301, 12301, 12303, 12303, 12305, 12305, 12309, 12309, 12311, 12311, 12313, 12313, 12315, 12315, 12318, 12319, 64830, 64830, 65048, 65048, 65078, 65078, 65080, 65080, 65082, 65082, 65084, 65084, 65086, 65086, 65088, 65088, 65090, 65090, 65092, 65092, 65096, 65096, 65114, 65114, 65116, 65116, 65118, 65118, 65289, 65289, 65341, 65341, 65373, 65373, 65376, 65376, 65379, 65379];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS63 = [43, 43, 60, 62, 124, 124, 126, 126, 172, 172, 177, 177, 215, 215, 247, 247, 1014, 1014, 1542, 1544, 8260, 8260, 8274, 8274, 8314, 8316, 8330, 8332, 8472, 8472, 8512, 8516, 8523, 8523, 8592, 8596, 8602, 8603, 8608, 8608, 8611, 8611, 8614, 8614, 8622, 8622, 8654, 8655, 8658, 8658, 8660, 8660, 8692, 8959, 8992, 8993, 9084, 9084, 9115, 9139, 9180, 9185, 9655, 9655, 9665, 9665, 9720, 9727, 9839, 9839, 10176, 10180, 10183, 10213, 10224, 10239, 10496, 10626, 10649, 10711, 10716, 10747, 10750, 11007, 11056, 11076, 11079, 11084, 64297, 64297, 65122, 65122, 65124, 65126, 65291, 65291, 65308, 65310, 65372, 65372, 65374, 65374, 65506, 65506, 65513, 65516, 69006, 69007, 120513, 120513, 120539, 120539, 120571, 120571, 120597, 120597, 120629, 120629, 120655, 120655, 120687, 120687, 120713, 120713, 120745, 120745, 120771, 120771, 126704, 126705];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS64 = [45, 45, 1418, 1418, 1470, 1470, 5120, 5120, 6150, 6150, 8208, 8213, 11799, 11799, 11802, 11802, 11834, 11835, 11840, 11840, 11869, 11869, 12316, 12316, 12336, 12336, 12448, 12448, 65073, 65074, 65112, 65112, 65123, 65123, 65293, 65293, 68974, 68974, 69293, 69293];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS65 = [48, 57, 1632, 1641, 1776, 1785, 1984, 1993, 2406, 2415, 2534, 2543, 2662, 2671, 2790, 2799, 2918, 2927, 3046, 3055, 3174, 3183, 3302, 3311, 3430, 3439, 3558, 3567, 3664, 3673, 3792, 3801, 3872, 3881, 4160, 4169, 4240, 4249, 6112, 6121, 6160, 6169, 6470, 6479, 6608, 6617, 6784, 6793, 6800, 6809, 6992, 7001, 7088, 7097, 7232, 7241, 7248, 7257, 42528, 42537, 43216, 43225, 43264, 43273, 43472, 43481, 43504, 43513, 43600, 43609, 44016, 44025, 65296, 65305, 66720, 66729, 68912, 68921, 68928, 68937, 69734, 69743, 69872, 69881, 69942, 69951, 70096, 70105, 70384, 70393, 70736, 70745, 70864, 70873, 71248, 71257, 71360, 71369, 71376, 71395, 71472, 71481, 71904, 71913, 72016, 72025, 72688, 72697, 72784, 72793, 73040, 73049, 73120, 73129, 73552, 73561, 90416, 90425, 92768, 92777, 92864, 92873, 93008, 93017, 93552, 93561, 118000, 118009, 120782, 120831, 123200, 123209, 123632, 123641, 124144, 124153, 124401, 124410, 125264, 125273, 130032, 130041];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS66 = [65, 90, 192, 214, 216, 222, 256, 256, 258, 258, 260, 260, 262, 262, 264, 264, 266, 266, 268, 268, 270, 270, 272, 272, 274, 274, 276, 276, 278, 278, 280, 280, 282, 282, 284, 284, 286, 286, 288, 288, 290, 290, 292, 292, 294, 294, 296, 296, 298, 298, 300, 300, 302, 302, 304, 304, 306, 306, 308, 308, 310, 310, 313, 313, 315, 315, 317, 317, 319, 319, 321, 321, 323, 323, 325, 325, 327, 327, 330, 330, 332, 332, 334, 334, 336, 336, 338, 338, 340, 340, 342, 342, 344, 344, 346, 346, 348, 348, 350, 350, 352, 352, 354, 354, 356, 356, 358, 358, 360, 360, 362, 362, 364, 364, 366, 366, 368, 368, 370, 370, 372, 372, 374, 374, 376, 377, 379, 379, 381, 381, 385, 386, 388, 388, 390, 391, 393, 395, 398, 401, 403, 404, 406, 408, 412, 413, 415, 416, 418, 418, 420, 420, 422, 423, 425, 425, 428, 428, 430, 431, 433, 435, 437, 437, 439, 440, 444, 444, 452, 452, 455, 455, 458, 458, 461, 461, 463, 463, 465, 465, 467, 467, 469, 469, 471, 471, 473, 473, 475, 475, 478, 478, 480, 480, 482, 482, 484, 484, 486, 486, 488, 488, 490, 490, 492, 492, 494, 494, 497, 497, 500, 500, 502, 504, 506, 506, 508, 508, 510, 510, 512, 512, 514, 514, 516, 516, 518, 518, 520, 520, 522, 522, 524, 524, 526, 526, 528, 528, 530, 530, 532, 532, 534, 534, 536, 536, 538, 538, 540, 540, 542, 542, 544, 544, 546, 546, 548, 548, 550, 550, 552, 552, 554, 554, 556, 556, 558, 558, 560, 560, 562, 562, 570, 571, 573, 574, 577, 577, 579, 582, 584, 584, 586, 586, 588, 588, 590, 590, 880, 880, 882, 882, 886, 886, 895, 895, 902, 902, 904, 906, 908, 908, 910, 911, 913, 929, 931, 939, 975, 975, 978, 980, 984, 984, 986, 986, 988, 988, 990, 990, 992, 992, 994, 994, 996, 996, 998, 998, 1000, 1000, 1002, 1002, 1004, 1004, 1006, 1006, 1012, 1012, 1015, 1015, 1017, 1018, 1021, 1071, 1120, 1120, 1122, 1122, 1124, 1124, 1126, 1126, 1128, 1128, 1130, 1130, 1132, 1132, 1134, 1134, 1136, 1136, 1138, 1138, 1140, 1140, 1142, 1142, 1144, 1144, 1146, 1146, 1148, 1148, 1150, 1150, 1152, 1152, 1162, 1162, 1164, 1164, 1166, 1166, 1168, 1168, 1170, 1170, 1172, 1172, 1174, 1174, 1176, 1176, 1178, 1178, 1180, 1180, 1182, 1182, 1184, 1184, 1186, 1186, 1188, 1188, 1190, 1190, 1192, 1192, 1194, 1194, 1196, 1196, 1198, 1198, 1200, 1200, 1202, 1202, 1204, 1204, 1206, 1206, 1208, 1208, 1210, 1210, 1212, 1212, 1214, 1214, 1216, 1217, 1219, 1219, 1221, 1221, 1223, 1223, 1225, 1225, 1227, 1227, 1229, 1229, 1232, 1232, 1234, 1234, 1236, 1236, 1238, 1238, 1240, 1240, 1242, 1242, 1244, 1244, 1246, 1246, 1248, 1248, 1250, 1250, 1252, 1252, 1254, 1254, 1256, 1256, 1258, 1258, 1260, 1260, 1262, 1262, 1264, 1264, 1266, 1266, 1268, 1268, 1270, 1270, 1272, 1272, 1274, 1274, 1276, 1276, 1278, 1278, 1280, 1280, 1282, 1282, 1284, 1284, 1286, 1286, 1288, 1288, 1290, 1290, 1292, 1292, 1294, 1294, 1296, 1296, 1298, 1298, 1300, 1300, 1302, 1302, 1304, 1304, 1306, 1306, 1308, 1308, 1310, 1310, 1312, 1312, 1314, 1314, 1316, 1316, 1318, 1318, 1320, 1320, 1322, 1322, 1324, 1324, 1326, 1326, 1329, 1366, 4256, 4293, 4295, 4295, 4301, 4301, 5024, 5109, 7305, 7305, 7312, 7354, 7357, 7359, 7680, 7680, 7682, 7682, 7684, 7684, 7686, 7686, 7688, 7688, 7690, 7690, 7692, 7692, 7694, 7694, 7696, 7696, 7698, 7698, 7700, 7700, 7702, 7702, 7704, 7704, 7706, 7706, 7708, 7708, 7710, 7710, 7712, 7712, 7714, 7714, 7716, 7716, 7718, 7718, 7720, 7720, 7722, 7722, 7724, 7724, 7726, 7726, 7728, 7728, 7730, 7730, 7732, 7732, 7734, 7734, 7736, 7736, 7738, 7738, 7740, 7740, 7742, 7742, 7744, 7744, 7746, 7746, 7748, 7748, 7750, 7750, 7752, 7752, 7754, 7754, 7756, 7756, 7758, 7758, 7760, 7760, 7762, 7762, 7764, 7764, 7766, 7766, 7768, 7768, 7770, 7770, 7772, 7772, 7774, 7774, 7776, 7776, 7778, 7778, 7780, 7780, 7782, 7782, 7784, 7784, 7786, 7786, 7788, 7788, 7790, 7790, 7792, 7792, 7794, 7794, 7796, 7796, 7798, 7798, 7800, 7800, 7802, 7802, 7804, 7804, 7806, 7806, 7808, 7808, 7810, 7810, 7812, 7812, 7814, 7814, 7816, 7816, 7818, 7818, 7820, 7820, 7822, 7822, 7824, 7824, 7826, 7826, 7828, 7828, 7838, 7838, 7840, 7840, 7842, 7842, 7844, 7844, 7846, 7846, 7848, 7848, 7850, 7850, 7852, 7852, 7854, 7854, 7856, 7856, 7858, 7858, 7860, 7860, 7862, 7862, 7864, 7864, 7866, 7866, 7868, 7868, 7870, 7870, 7872, 7872, 7874, 7874, 7876, 7876, 7878, 7878, 7880, 7880, 7882, 7882, 7884, 7884, 7886, 7886, 7888, 7888, 7890, 7890, 7892, 7892, 7894, 7894, 7896, 7896, 7898, 7898, 7900, 7900, 7902, 7902, 7904, 7904, 7906, 7906, 7908, 7908, 7910, 7910, 7912, 7912, 7914, 7914, 7916, 7916, 7918, 7918, 7920, 7920, 7922, 7922, 7924, 7924, 7926, 7926, 7928, 7928, 7930, 7930, 7932, 7932, 7934, 7934, 7944, 7951, 7960, 7965, 7976, 7983, 7992, 7999, 8008, 8013, 8025, 8025, 8027, 8027, 8029, 8029, 8031, 8031, 8040, 8047, 8120, 8123, 8136, 8139, 8152, 8155, 8168, 8172, 8184, 8187, 8450, 8450, 8455, 8455, 8459, 8461, 8464, 8466, 8469, 8469, 8473, 8477, 8484, 8484, 8486, 8486, 8488, 8488, 8490, 8493, 8496, 8499, 8510, 8511, 8517, 8517, 8579, 8579, 11264, 11311, 11360, 11360, 11362, 11364, 11367, 11367, 11369, 11369, 11371, 11371, 11373, 11376, 11378, 11378, 11381, 11381, 11390, 11392, 11394, 11394, 11396, 11396, 11398, 11398, 11400, 11400, 11402, 11402, 11404, 11404, 11406, 11406, 11408, 11408, 11410, 11410, 11412, 11412, 11414, 11414, 11416, 11416, 11418, 11418, 11420, 11420, 11422, 11422, 11424, 11424, 11426, 11426, 11428, 11428, 11430, 11430, 11432, 11432, 11434, 11434, 11436, 11436, 11438, 11438, 11440, 11440, 11442, 11442, 11444, 11444, 11446, 11446, 11448, 11448, 11450, 11450, 11452, 11452, 11454, 11454, 11456, 11456, 11458, 11458, 11460, 11460, 11462, 11462, 11464, 11464, 11466, 11466, 11468, 11468, 11470, 11470, 11472, 11472, 11474, 11474, 11476, 11476, 11478, 11478, 11480, 11480, 11482, 11482, 11484, 11484, 11486, 11486, 11488, 11488, 11490, 11490, 11499, 11499, 11501, 11501, 11506, 11506, 42560, 42560, 42562, 42562, 42564, 42564, 42566, 42566, 42568, 42568, 42570, 42570, 42572, 42572, 42574, 42574, 42576, 42576, 42578, 42578, 42580, 42580, 42582, 42582, 42584, 42584, 42586, 42586, 42588, 42588, 42590, 42590, 42592, 42592, 42594, 42594, 42596, 42596, 42598, 42598, 42600, 42600, 42602, 42602, 42604, 42604, 42624, 42624, 42626, 42626, 42628, 42628, 42630, 42630, 42632, 42632, 42634, 42634, 42636, 42636, 42638, 42638, 42640, 42640, 42642, 42642, 42644, 42644, 42646, 42646, 42648, 42648, 42650, 42650, 42786, 42786, 42788, 42788, 42790, 42790, 42792, 42792, 42794, 42794, 42796, 42796, 42798, 42798, 42802, 42802, 42804, 42804, 42806, 42806, 42808, 42808, 42810, 42810, 42812, 42812, 42814, 42814, 42816, 42816, 42818, 42818, 42820, 42820, 42822, 42822, 42824, 42824, 42826, 42826, 42828, 42828, 42830, 42830, 42832, 42832, 42834, 42834, 42836, 42836, 42838, 42838, 42840, 42840, 42842, 42842, 42844, 42844, 42846, 42846, 42848, 42848, 42850, 42850, 42852, 42852, 42854, 42854, 42856, 42856, 42858, 42858, 42860, 42860, 42862, 42862, 42873, 42873, 42875, 42875, 42877, 42878, 42880, 42880, 42882, 42882, 42884, 42884, 42886, 42886, 42891, 42891, 42893, 42893, 42896, 42896, 42898, 42898, 42902, 42902, 42904, 42904, 42906, 42906, 42908, 42908, 42910, 42910, 42912, 42912, 42914, 42914, 42916, 42916, 42918, 42918, 42920, 42920, 42922, 42926, 42928, 42932, 42934, 42934, 42936, 42936, 42938, 42938, 42940, 42940, 42942, 42942, 42944, 42944, 42946, 42946, 42948, 42951, 42953, 42953, 42955, 42956, 42960, 42960, 42966, 42966, 42968, 42968, 42970, 42970, 42972, 42972, 42997, 42997, 65313, 65338, 66560, 66599, 66736, 66771, 66928, 66938, 66940, 66954, 66956, 66962, 66964, 66965, 68736, 68786, 68944, 68965, 71840, 71871, 93760, 93791, 119808, 119833, 119860, 119885, 119912, 119937, 119964, 119964, 119966, 119967, 119970, 119970, 119973, 119974, 119977, 119980, 119982, 119989, 120016, 120041, 120068, 120069, 120071, 120074, 120077, 120084, 120086, 120092, 120120, 120121, 120123, 120126, 120128, 120132, 120134, 120134, 120138, 120144, 120172, 120197, 120224, 120249, 120276, 120301, 120328, 120353, 120380, 120405, 120432, 120457, 120488, 120512, 120546, 120570, 120604, 120628, 120662, 120686, 120720, 120744, 120778, 120778, 125184, 125217];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS67 = [94, 94, 96, 96, 168, 168, 175, 175, 180, 180, 184, 184, 706, 709, 722, 735, 741, 747, 749, 749, 751, 767, 885, 885, 900, 901, 2184, 2184, 8125, 8125, 8127, 8129, 8141, 8143, 8157, 8159, 8173, 8175, 8189, 8190, 12443, 12444, 42752, 42774, 42784, 42785, 42889, 42890, 43867, 43867, 43882, 43883, 64434, 64450, 65342, 65342, 65344, 65344, 65507, 65507, 127995, 127999];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS68 = [95, 95, 8255, 8256, 8276, 8276, 65075, 65076, 65101, 65103, 65343, 65343];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS69 = [97, 122, 181, 181, 223, 246, 248, 255, 257, 257, 259, 259, 261, 261, 263, 263, 265, 265, 267, 267, 269, 269, 271, 271, 273, 273, 275, 275, 277, 277, 279, 279, 281, 281, 283, 283, 285, 285, 287, 287, 289, 289, 291, 291, 293, 293, 295, 295, 297, 297, 299, 299, 301, 301, 303, 303, 305, 305, 307, 307, 309, 309, 311, 312, 314, 314, 316, 316, 318, 318, 320, 320, 322, 322, 324, 324, 326, 326, 328, 329, 331, 331, 333, 333, 335, 335, 337, 337, 339, 339, 341, 341, 343, 343, 345, 345, 347, 347, 349, 349, 351, 351, 353, 353, 355, 355, 357, 357, 359, 359, 361, 361, 363, 363, 365, 365, 367, 367, 369, 369, 371, 371, 373, 373, 375, 375, 378, 378, 380, 380, 382, 384, 387, 387, 389, 389, 392, 392, 396, 397, 402, 402, 405, 405, 409, 411, 414, 414, 417, 417, 419, 419, 421, 421, 424, 424, 426, 427, 429, 429, 432, 432, 436, 436, 438, 438, 441, 442, 445, 447, 454, 454, 457, 457, 460, 460, 462, 462, 464, 464, 466, 466, 468, 468, 470, 470, 472, 472, 474, 474, 476, 477, 479, 479, 481, 481, 483, 483, 485, 485, 487, 487, 489, 489, 491, 491, 493, 493, 495, 496, 499, 499, 501, 501, 505, 505, 507, 507, 509, 509, 511, 511, 513, 513, 515, 515, 517, 517, 519, 519, 521, 521, 523, 523, 525, 525, 527, 527, 529, 529, 531, 531, 533, 533, 535, 535, 537, 537, 539, 539, 541, 541, 543, 543, 545, 545, 547, 547, 549, 549, 551, 551, 553, 553, 555, 555, 557, 557, 559, 559, 561, 561, 563, 569, 572, 572, 575, 576, 578, 578, 583, 583, 585, 585, 587, 587, 589, 589, 591, 659, 661, 687, 881, 881, 883, 883, 887, 887, 891, 893, 912, 912, 940, 974, 976, 977, 981, 983, 985, 985, 987, 987, 989, 989, 991, 991, 993, 993, 995, 995, 997, 997, 999, 999, 1001, 1001, 1003, 1003, 1005, 1005, 1007, 1011, 1013, 1013, 1016, 1016, 1019, 1020, 1072, 1119, 1121, 1121, 1123, 1123, 1125, 1125, 1127, 1127, 1129, 1129, 1131, 1131, 1133, 1133, 1135, 1135, 1137, 1137, 1139, 1139, 1141, 1141, 1143, 1143, 1145, 1145, 1147, 1147, 1149, 1149, 1151, 1151, 1153, 1153, 1163, 1163, 1165, 1165, 1167, 1167, 1169, 1169, 1171, 1171, 1173, 1173, 1175, 1175, 1177, 1177, 1179, 1179, 1181, 1181, 1183, 1183, 1185, 1185, 1187, 1187, 1189, 1189, 1191, 1191, 1193, 1193, 1195, 1195, 1197, 1197, 1199, 1199, 1201, 1201, 1203, 1203, 1205, 1205, 1207, 1207, 1209, 1209, 1211, 1211, 1213, 1213, 1215, 1215, 1218, 1218, 1220, 1220, 1222, 1222, 1224, 1224, 1226, 1226, 1228, 1228, 1230, 1231, 1233, 1233, 1235, 1235, 1237, 1237, 1239, 1239, 1241, 1241, 1243, 1243, 1245, 1245, 1247, 1247, 1249, 1249, 1251, 1251, 1253, 1253, 1255, 1255, 1257, 1257, 1259, 1259, 1261, 1261, 1263, 1263, 1265, 1265, 1267, 1267, 1269, 1269, 1271, 1271, 1273, 1273, 1275, 1275, 1277, 1277, 1279, 1279, 1281, 1281, 1283, 1283, 1285, 1285, 1287, 1287, 1289, 1289, 1291, 1291, 1293, 1293, 1295, 1295, 1297, 1297, 1299, 1299, 1301, 1301, 1303, 1303, 1305, 1305, 1307, 1307, 1309, 1309, 1311, 1311, 1313, 1313, 1315, 1315, 1317, 1317, 1319, 1319, 1321, 1321, 1323, 1323, 1325, 1325, 1327, 1327, 1376, 1416, 4304, 4346, 4349, 4351, 5112, 5117, 7296, 7304, 7306, 7306, 7424, 7467, 7531, 7543, 7545, 7578, 7681, 7681, 7683, 7683, 7685, 7685, 7687, 7687, 7689, 7689, 7691, 7691, 7693, 7693, 7695, 7695, 7697, 7697, 7699, 7699, 7701, 7701, 7703, 7703, 7705, 7705, 7707, 7707, 7709, 7709, 7711, 7711, 7713, 7713, 7715, 7715, 7717, 7717, 7719, 7719, 7721, 7721, 7723, 7723, 7725, 7725, 7727, 7727, 7729, 7729, 7731, 7731, 7733, 7733, 7735, 7735, 7737, 7737, 7739, 7739, 7741, 7741, 7743, 7743, 7745, 7745, 7747, 7747, 7749, 7749, 7751, 7751, 7753, 7753, 7755, 7755, 7757, 7757, 7759, 7759, 7761, 7761, 7763, 7763, 7765, 7765, 7767, 7767, 7769, 7769, 7771, 7771, 7773, 7773, 7775, 7775, 7777, 7777, 7779, 7779, 7781, 7781, 7783, 7783, 7785, 7785, 7787, 7787, 7789, 7789, 7791, 7791, 7793, 7793, 7795, 7795, 7797, 7797, 7799, 7799, 7801, 7801, 7803, 7803, 7805, 7805, 7807, 7807, 7809, 7809, 7811, 7811, 7813, 7813, 7815, 7815, 7817, 7817, 7819, 7819, 7821, 7821, 7823, 7823, 7825, 7825, 7827, 7827, 7829, 7837, 7839, 7839, 7841, 7841, 7843, 7843, 7845, 7845, 7847, 7847, 7849, 7849, 7851, 7851, 7853, 7853, 7855, 7855, 7857, 7857, 7859, 7859, 7861, 7861, 7863, 7863, 7865, 7865, 7867, 7867, 7869, 7869, 7871, 7871, 7873, 7873, 7875, 7875, 7877, 7877, 7879, 7879, 7881, 7881, 7883, 7883, 7885, 7885, 7887, 7887, 7889, 7889, 7891, 7891, 7893, 7893, 7895, 7895, 7897, 7897, 7899, 7899, 7901, 7901, 7903, 7903, 7905, 7905, 7907, 7907, 7909, 7909, 7911, 7911, 7913, 7913, 7915, 7915, 7917, 7917, 7919, 7919, 7921, 7921, 7923, 7923, 7925, 7925, 7927, 7927, 7929, 7929, 7931, 7931, 7933, 7933, 7935, 7943, 7952, 7957, 7968, 7975, 7984, 7991, 8000, 8005, 8016, 8023, 8032, 8039, 8048, 8061, 8064, 8071, 8080, 8087, 8096, 8103, 8112, 8116, 8118, 8119, 8126, 8126, 8130, 8132, 8134, 8135, 8144, 8147, 8150, 8151, 8160, 8167, 8178, 8180, 8182, 8183, 8458, 8458, 8462, 8463, 8467, 8467, 8495, 8495, 8500, 8500, 8505, 8505, 8508, 8509, 8518, 8521, 8526, 8526, 8580, 8580, 11312, 11359, 11361, 11361, 11365, 11366, 11368, 11368, 11370, 11370, 11372, 11372, 11377, 11377, 11379, 11380, 11382, 11387, 11393, 11393, 11395, 11395, 11397, 11397, 11399, 11399, 11401, 11401, 11403, 11403, 11405, 11405, 11407, 11407, 11409, 11409, 11411, 11411, 11413, 11413, 11415, 11415, 11417, 11417, 11419, 11419, 11421, 11421, 11423, 11423, 11425, 11425, 11427, 11427, 11429, 11429, 11431, 11431, 11433, 11433, 11435, 11435, 11437, 11437, 11439, 11439, 11441, 11441, 11443, 11443, 11445, 11445, 11447, 11447, 11449, 11449, 11451, 11451, 11453, 11453, 11455, 11455, 11457, 11457, 11459, 11459, 11461, 11461, 11463, 11463, 11465, 11465, 11467, 11467, 11469, 11469, 11471, 11471, 11473, 11473, 11475, 11475, 11477, 11477, 11479, 11479, 11481, 11481, 11483, 11483, 11485, 11485, 11487, 11487, 11489, 11489, 11491, 11492, 11500, 11500, 11502, 11502, 11507, 11507, 11520, 11557, 11559, 11559, 11565, 11565, 42561, 42561, 42563, 42563, 42565, 42565, 42567, 42567, 42569, 42569, 42571, 42571, 42573, 42573, 42575, 42575, 42577, 42577, 42579, 42579, 42581, 42581, 42583, 42583, 42585, 42585, 42587, 42587, 42589, 42589, 42591, 42591, 42593, 42593, 42595, 42595, 42597, 42597, 42599, 42599, 42601, 42601, 42603, 42603, 42605, 42605, 42625, 42625, 42627, 42627, 42629, 42629, 42631, 42631, 42633, 42633, 42635, 42635, 42637, 42637, 42639, 42639, 42641, 42641, 42643, 42643, 42645, 42645, 42647, 42647, 42649, 42649, 42651, 42651, 42787, 42787, 42789, 42789, 42791, 42791, 42793, 42793, 42795, 42795, 42797, 42797, 42799, 42801, 42803, 42803, 42805, 42805, 42807, 42807, 42809, 42809, 42811, 42811, 42813, 42813, 42815, 42815, 42817, 42817, 42819, 42819, 42821, 42821, 42823, 42823, 42825, 42825, 42827, 42827, 42829, 42829, 42831, 42831, 42833, 42833, 42835, 42835, 42837, 42837, 42839, 42839, 42841, 42841, 42843, 42843, 42845, 42845, 42847, 42847, 42849, 42849, 42851, 42851, 42853, 42853, 42855, 42855, 42857, 42857, 42859, 42859, 42861, 42861, 42863, 42863, 42865, 42872, 42874, 42874, 42876, 42876, 42879, 42879, 42881, 42881, 42883, 42883, 42885, 42885, 42887, 42887, 42892, 42892, 42894, 42894, 42897, 42897, 42899, 42901, 42903, 42903, 42905, 42905, 42907, 42907, 42909, 42909, 42911, 42911, 42913, 42913, 42915, 42915, 42917, 42917, 42919, 42919, 42921, 42921, 42927, 42927, 42933, 42933, 42935, 42935, 42937, 42937, 42939, 42939, 42941, 42941, 42943, 42943, 42945, 42945, 42947, 42947, 42952, 42952, 42954, 42954, 42957, 42957, 42961, 42961, 42963, 42963, 42965, 42965, 42967, 42967, 42969, 42969, 42971, 42971, 42998, 42998, 43002, 43002, 43824, 43866, 43872, 43880, 43888, 43967, 64256, 64262, 64275, 64279, 65345, 65370, 66600, 66639, 66776, 66811, 66967, 66977, 66979, 66993, 66995, 67001, 67003, 67004, 68800, 68850, 68976, 68997, 71872, 71903, 93792, 93823, 119834, 119859, 119886, 119892, 119894, 119911, 119938, 119963, 119990, 119993, 119995, 119995, 119997, 120003, 120005, 120015, 120042, 120067, 120094, 120119, 120146, 120171, 120198, 120223, 120250, 120275, 120302, 120327, 120354, 120379, 120406, 120431, 120458, 120485, 120514, 120538, 120540, 120545, 120572, 120596, 120598, 120603, 120630, 120654, 120656, 120661, 120688, 120712, 120714, 120719, 120746, 120770, 120772, 120777, 120779, 120779, 122624, 122633, 122635, 122654, 122661, 122666, 125218, 125251];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS70 = [166, 166, 169, 169, 174, 174, 176, 176, 1154, 1154, 1421, 1422, 1550, 1551, 1758, 1758, 1769, 1769, 1789, 1790, 2038, 2038, 2554, 2554, 2928, 2928, 3059, 3064, 3066, 3066, 3199, 3199, 3407, 3407, 3449, 3449, 3841, 3843, 3859, 3859, 3861, 3863, 3866, 3871, 3892, 3892, 3894, 3894, 3896, 3896, 4030, 4037, 4039, 4044, 4046, 4047, 4053, 4056, 4254, 4255, 5008, 5017, 5741, 5741, 6464, 6464, 6622, 6655, 7009, 7018, 7028, 7036, 8448, 8449, 8451, 8454, 8456, 8457, 8468, 8468, 8470, 8471, 8478, 8483, 8485, 8485, 8487, 8487, 8489, 8489, 8494, 8494, 8506, 8507, 8522, 8522, 8524, 8525, 8527, 8527, 8586, 8587, 8597, 8601, 8604, 8607, 8609, 8610, 8612, 8613, 8615, 8621, 8623, 8653, 8656, 8657, 8659, 8659, 8661, 8691, 8960, 8967, 8972, 8991, 8994, 9000, 9003, 9083, 9085, 9114, 9140, 9179, 9186, 9257, 9280, 9290, 9372, 9449, 9472, 9654, 9656, 9664, 9666, 9719, 9728, 9838, 9840, 10087, 10132, 10175, 10240, 10495, 11008, 11055, 11077, 11078, 11085, 11123, 11126, 11157, 11159, 11263, 11493, 11498, 11856, 11857, 11904, 11929, 11931, 12019, 12032, 12245, 12272, 12287, 12292, 12292, 12306, 12307, 12320, 12320, 12342, 12343, 12350, 12351, 12688, 12689, 12694, 12703, 12736, 12773, 12783, 12783, 12800, 12830, 12842, 12871, 12880, 12880, 12896, 12927, 12938, 12976, 12992, 13311, 19904, 19967, 42128, 42182, 43048, 43051, 43062, 43063, 43065, 43065, 43639, 43641, 64832, 64847, 64975, 64975, 65021, 65023, 65508, 65508, 65512, 65512, 65517, 65518, 65532, 65533, 65847, 65855, 65913, 65929, 65932, 65934, 65936, 65948, 65952, 65952, 66000, 66044, 67703, 67704, 68296, 68296, 71487, 71487, 73685, 73692, 73697, 73713, 92988, 92991, 92997, 92997, 113820, 113820, 117760, 117999, 118016, 118451, 118608, 118723, 118784, 119029, 119040, 119078, 119081, 119140, 119146, 119148, 119171, 119172, 119180, 119209, 119214, 119274, 119296, 119361, 119365, 119365, 119552, 119638, 120832, 121343, 121399, 121402, 121453, 121460, 121462, 121475, 121477, 121478, 123215, 123215, 126124, 126124, 126254, 126254, 126976, 127019, 127024, 127123, 127136, 127150, 127153, 127167, 127169, 127183, 127185, 127221, 127245, 127405, 127462, 127490, 127504, 127547, 127552, 127560, 127568, 127569, 127584, 127589, 127744, 127994, 128000, 128727, 128732, 128748, 128752, 128764, 128768, 128886, 128891, 128985, 128992, 129003, 129008, 129008, 129024, 129035, 129040, 129095, 129104, 129113, 129120, 129159, 129168, 129197, 129200, 129211, 129216, 129217, 129280, 129619, 129632, 129645, 129648, 129660, 129664, 129673, 129679, 129734, 129742, 129756, 129759, 129769, 129776, 129784, 129792, 129938, 129940, 130031];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS71 = [170, 170, 186, 186, 443, 443, 448, 451, 660, 660, 1488, 1514, 1519, 1522, 1568, 1599, 1601, 1610, 1646, 1647, 1649, 1747, 1749, 1749, 1774, 1775, 1786, 1788, 1791, 1791, 1808, 1808, 1810, 1839, 1869, 1957, 1969, 1969, 1994, 2026, 2048, 2069, 2112, 2136, 2144, 2154, 2160, 2183, 2185, 2190, 2208, 2248, 2308, 2361, 2365, 2365, 2384, 2384, 2392, 2401, 2418, 2432, 2437, 2444, 2447, 2448, 2451, 2472, 2474, 2480, 2482, 2482, 2486, 2489, 2493, 2493, 2510, 2510, 2524, 2525, 2527, 2529, 2544, 2545, 2556, 2556, 2565, 2570, 2575, 2576, 2579, 2600, 2602, 2608, 2610, 2611, 2613, 2614, 2616, 2617, 2649, 2652, 2654, 2654, 2674, 2676, 2693, 2701, 2703, 2705, 2707, 2728, 2730, 2736, 2738, 2739, 2741, 2745, 2749, 2749, 2768, 2768, 2784, 2785, 2809, 2809, 2821, 2828, 2831, 2832, 2835, 2856, 2858, 2864, 2866, 2867, 2869, 2873, 2877, 2877, 2908, 2909, 2911, 2913, 2929, 2929, 2947, 2947, 2949, 2954, 2958, 2960, 2962, 2965, 2969, 2970, 2972, 2972, 2974, 2975, 2979, 2980, 2984, 2986, 2990, 3001, 3024, 3024, 3077, 3084, 3086, 3088, 3090, 3112, 3114, 3129, 3133, 3133, 3160, 3162, 3165, 3165, 3168, 3169, 3200, 3200, 3205, 3212, 3214, 3216, 3218, 3240, 3242, 3251, 3253, 3257, 3261, 3261, 3293, 3294, 3296, 3297, 3313, 3314, 3332, 3340, 3342, 3344, 3346, 3386, 3389, 3389, 3406, 3406, 3412, 3414, 3423, 3425, 3450, 3455, 3461, 3478, 3482, 3505, 3507, 3515, 3517, 3517, 3520, 3526, 3585, 3632, 3634, 3635, 3648, 3653, 3713, 3714, 3716, 3716, 3718, 3722, 3724, 3747, 3749, 3749, 3751, 3760, 3762, 3763, 3773, 3773, 3776, 3780, 3804, 3807, 3840, 3840, 3904, 3911, 3913, 3948, 3976, 3980, 4096, 4138, 4159, 4159, 4176, 4181, 4186, 4189, 4193, 4193, 4197, 4198, 4206, 4208, 4213, 4225, 4238, 4238, 4352, 4680, 4682, 4685, 4688, 4694, 4696, 4696, 4698, 4701, 4704, 4744, 4746, 4749, 4752, 4784, 4786, 4789, 4792, 4798, 4800, 4800, 4802, 4805, 4808, 4822, 4824, 4880, 4882, 4885, 4888, 4954, 4992, 5007, 5121, 5740, 5743, 5759, 5761, 5786, 5792, 5866, 5873, 5880, 5888, 5905, 5919, 5937, 5952, 5969, 5984, 5996, 5998, 6000, 6016, 6067, 6108, 6108, 6176, 6210, 6212, 6264, 6272, 6276, 6279, 6312, 6314, 6314, 6320, 6389, 6400, 6430, 6480, 6509, 6512, 6516, 6528, 6571, 6576, 6601, 6656, 6678, 6688, 6740, 6917, 6963, 6981, 6988, 7043, 7072, 7086, 7087, 7098, 7141, 7168, 7203, 7245, 7247, 7258, 7287, 7401, 7404, 7406, 7411, 7413, 7414, 7418, 7418, 8501, 8504, 11568, 11623, 11648, 11670, 11680, 11686, 11688, 11694, 11696, 11702, 11704, 11710, 11712, 11718, 11720, 11726, 11728, 11734, 11736, 11742, 12294, 12294, 12348, 12348, 12353, 12438, 12447, 12447, 12449, 12538, 12543, 12543, 12549, 12591, 12593, 12686, 12704, 12735, 12784, 12799, 13312, 19903, 19968, 40980, 40982, 42124, 42192, 42231, 42240, 42507, 42512, 42527, 42538, 42539, 42606, 42606, 42656, 42725, 42895, 42895, 42999, 42999, 43003, 43009, 43011, 43013, 43015, 43018, 43020, 43042, 43072, 43123, 43138, 43187, 43250, 43255, 43259, 43259, 43261, 43262, 43274, 43301, 43312, 43334, 43360, 43388, 43396, 43442, 43488, 43492, 43495, 43503, 43514, 43518, 43520, 43560, 43584, 43586, 43588, 43595, 43616, 43631, 43633, 43638, 43642, 43642, 43646, 43695, 43697, 43697, 43701, 43702, 43705, 43709, 43712, 43712, 43714, 43714, 43739, 43740, 43744, 43754, 43762, 43762, 43777, 43782, 43785, 43790, 43793, 43798, 43808, 43814, 43816, 43822, 43968, 44002, 44032, 55203, 55216, 55238, 55243, 55291, 63744, 64109, 64112, 64217, 64285, 64285, 64287, 64296, 64298, 64310, 64312, 64316, 64318, 64318, 64320, 64321, 64323, 64324, 64326, 64433, 64467, 64829, 64848, 64911, 64914, 64967, 65008, 65019, 65136, 65140, 65142, 65276, 65382, 65391, 65393, 65437, 65440, 65470, 65474, 65479, 65482, 65487, 65490, 65495, 65498, 65500, 65536, 65547, 65549, 65574, 65576, 65594, 65596, 65597, 65599, 65613, 65616, 65629, 65664, 65786, 66176, 66204, 66208, 66256, 66304, 66335, 66349, 66368, 66370, 66377, 66384, 66421, 66432, 66461, 66464, 66499, 66504, 66511, 66640, 66717, 66816, 66855, 66864, 66915, 67008, 67059, 67072, 67382, 67392, 67413, 67424, 67431, 67584, 67589, 67592, 67592, 67594, 67637, 67639, 67640, 67644, 67644, 67647, 67669, 67680, 67702, 67712, 67742, 67808, 67826, 67828, 67829, 67840, 67861, 67872, 67897, 67968, 68023, 68030, 68031, 68096, 68096, 68112, 68115, 68117, 68119, 68121, 68149, 68192, 68220, 68224, 68252, 68288, 68295, 68297, 68324, 68352, 68405, 68416, 68437, 68448, 68466, 68480, 68497, 68608, 68680, 68864, 68899, 68938, 68941, 68943, 68943, 69248, 69289, 69296, 69297, 69314, 69316, 69376, 69404, 69415, 69415, 69424, 69445, 69488, 69505, 69552, 69572, 69600, 69622, 69635, 69687, 69745, 69746, 69749, 69749, 69763, 69807, 69840, 69864, 69891, 69926, 69956, 69956, 69959, 69959, 69968, 70002, 70006, 70006, 70019, 70066, 70081, 70084, 70106, 70106, 70108, 70108, 70144, 70161, 70163, 70187, 70207, 70208, 70272, 70278, 70280, 70280, 70282, 70285, 70287, 70301, 70303, 70312, 70320, 70366, 70405, 70412, 70415, 70416, 70419, 70440, 70442, 70448, 70450, 70451, 70453, 70457, 70461, 70461, 70480, 70480, 70493, 70497, 70528, 70537, 70539, 70539, 70542, 70542, 70544, 70581, 70583, 70583, 70609, 70609, 70611, 70611, 70656, 70708, 70727, 70730, 70751, 70753, 70784, 70831, 70852, 70853, 70855, 70855, 71040, 71086, 71128, 71131, 71168, 71215, 71236, 71236, 71296, 71338, 71352, 71352, 71424, 71450, 71488, 71494, 71680, 71723, 71935, 71942, 71945, 71945, 71948, 71955, 71957, 71958, 71960, 71983, 71999, 71999, 72001, 72001, 72096, 72103, 72106, 72144, 72161, 72161, 72163, 72163, 72192, 72192, 72203, 72242, 72250, 72250, 72272, 72272, 72284, 72329, 72349, 72349, 72368, 72440, 72640, 72672, 72704, 72712, 72714, 72750, 72768, 72768, 72818, 72847, 72960, 72966, 72968, 72969, 72971, 73008, 73030, 73030, 73056, 73061, 73063, 73064, 73066, 73097, 73112, 73112, 73440, 73458, 73474, 73474, 73476, 73488, 73490, 73523, 73648, 73648, 73728, 74649, 74880, 75075, 77712, 77808, 77824, 78895, 78913, 78918, 78944, 82938, 82944, 83526, 90368, 90397, 92160, 92728, 92736, 92766, 92784, 92862, 92880, 92909, 92928, 92975, 93027, 93047, 93053, 93071, 93507, 93546, 93952, 94026, 94032, 94032, 94208, 100343, 100352, 101589, 101631, 101640, 110592, 110882, 110898, 110898, 110928, 110930, 110933, 110933, 110948, 110951, 110960, 111355, 113664, 113770, 113776, 113788, 113792, 113800, 113808, 113817, 122634, 122634, 123136, 123180, 123214, 123214, 123536, 123565, 123584, 123627, 124112, 124138, 124368, 124397, 124400, 124400, 124896, 124902, 124904, 124907, 124909, 124910, 124912, 124926, 124928, 125124, 126464, 126467, 126469, 126495, 126497, 126498, 126500, 126500, 126503, 126503, 126505, 126514, 126516, 126519, 126521, 126521, 126523, 126523, 126530, 126530, 126535, 126535, 126537, 126537, 126539, 126539, 126541, 126543, 126545, 126546, 126548, 126548, 126551, 126551, 126553, 126553, 126555, 126555, 126557, 126557, 126559, 126559, 126561, 126562, 126564, 126564, 126567, 126570, 126572, 126578, 126580, 126583, 126585, 126588, 126590, 126590, 126592, 126601, 126603, 126619, 126625, 126627, 126629, 126633, 126635, 126651, 131072, 173791, 173824, 177977, 177984, 178205, 178208, 183969, 183984, 191456, 191472, 192093, 194560, 195101, 196608, 201546, 201552, 205743];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS72 = [171, 171, 8216, 8216, 8219, 8220, 8223, 8223, 8249, 8249, 11778, 11778, 11780, 11780, 11785, 11785, 11788, 11788, 11804, 11804, 11808, 11808];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS73 = [173, 173, 1536, 1541, 1564, 1564, 1757, 1757, 1807, 1807, 2192, 2193, 2274, 2274, 6158, 6158, 8203, 8207, 8234, 8238, 8288, 8292, 8294, 8303, 65279, 65279, 65529, 65531, 69821, 69821, 69837, 69837, 78896, 78911, 113824, 113827, 119155, 119162, 917505, 917505, 917536, 917631];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS74 = [178, 179, 185, 185, 188, 190, 2548, 2553, 2930, 2935, 3056, 3058, 3192, 3198, 3416, 3422, 3440, 3448, 3882, 3891, 4969, 4988, 6128, 6137, 6618, 6618, 8304, 8304, 8308, 8313, 8320, 8329, 8528, 8543, 8585, 8585, 9312, 9371, 9450, 9471, 10102, 10131, 11517, 11517, 12690, 12693, 12832, 12841, 12872, 12879, 12881, 12895, 12928, 12937, 12977, 12991, 43056, 43061, 65799, 65843, 65909, 65912, 65930, 65931, 66273, 66299, 66336, 66339, 67672, 67679, 67705, 67711, 67751, 67759, 67835, 67839, 67862, 67867, 68028, 68029, 68032, 68047, 68050, 68095, 68160, 68168, 68221, 68222, 68253, 68255, 68331, 68335, 68440, 68447, 68472, 68479, 68521, 68527, 68858, 68863, 69216, 69246, 69405, 69414, 69457, 69460, 69573, 69579, 69714, 69733, 70113, 70132, 71482, 71483, 71914, 71922, 72794, 72812, 73664, 73684, 93019, 93025, 93824, 93846, 119488, 119507, 119520, 119539, 119648, 119672, 125127, 125135, 126065, 126123, 126125, 126127, 126129, 126132, 126209, 126253, 126255, 126269, 127232, 127244];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS75 = [187, 187, 8217, 8217, 8221, 8221, 8250, 8250, 11779, 11779, 11781, 11781, 11786, 11786, 11789, 11789, 11805, 11805, 11809, 11809];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS76 = [453, 453, 456, 456, 459, 459, 498, 498, 8072, 8079, 8088, 8095, 8104, 8111, 8124, 8124, 8140, 8140, 8188, 8188];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS77 = [688, 705, 710, 721, 736, 740, 748, 748, 750, 750, 884, 884, 890, 890, 1369, 1369, 1600, 1600, 1765, 1766, 2036, 2037, 2042, 2042, 2074, 2074, 2084, 2084, 2088, 2088, 2249, 2249, 2417, 2417, 3654, 3654, 3782, 3782, 4348, 4348, 6103, 6103, 6211, 6211, 6823, 6823, 7288, 7293, 7468, 7530, 7544, 7544, 7579, 7615, 8305, 8305, 8319, 8319, 8336, 8348, 11388, 11389, 11631, 11631, 11823, 11823, 12293, 12293, 12337, 12341, 12347, 12347, 12445, 12446, 12540, 12542, 40981, 40981, 42232, 42237, 42508, 42508, 42623, 42623, 42652, 42653, 42775, 42783, 42864, 42864, 42888, 42888, 42994, 42996, 43000, 43001, 43471, 43471, 43494, 43494, 43632, 43632, 43741, 43741, 43763, 43764, 43868, 43871, 43881, 43881, 65392, 65392, 65438, 65439, 67456, 67461, 67463, 67504, 67506, 67514, 68942, 68942, 68975, 68975, 92992, 92995, 93504, 93506, 93547, 93548, 94099, 94111, 94176, 94177, 94179, 94179, 110576, 110579, 110581, 110587, 110589, 110590, 122928, 122989, 123191, 123197, 124139, 124139, 125259, 125259];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS78 = [768, 879, 1155, 1159, 1425, 1469, 1471, 1471, 1473, 1474, 1476, 1477, 1479, 1479, 1552, 1562, 1611, 1631, 1648, 1648, 1750, 1756, 1759, 1764, 1767, 1768, 1770, 1773, 1809, 1809, 1840, 1866, 1958, 1968, 2027, 2035, 2045, 2045, 2070, 2073, 2075, 2083, 2085, 2087, 2089, 2093, 2137, 2139, 2199, 2207, 2250, 2273, 2275, 2306, 2362, 2362, 2364, 2364, 2369, 2376, 2381, 2381, 2385, 2391, 2402, 2403, 2433, 2433, 2492, 2492, 2497, 2500, 2509, 2509, 2530, 2531, 2558, 2558, 2561, 2562, 2620, 2620, 2625, 2626, 2631, 2632, 2635, 2637, 2641, 2641, 2672, 2673, 2677, 2677, 2689, 2690, 2748, 2748, 2753, 2757, 2759, 2760, 2765, 2765, 2786, 2787, 2810, 2815, 2817, 2817, 2876, 2876, 2879, 2879, 2881, 2884, 2893, 2893, 2901, 2902, 2914, 2915, 2946, 2946, 3008, 3008, 3021, 3021, 3072, 3072, 3076, 3076, 3132, 3132, 3134, 3136, 3142, 3144, 3146, 3149, 3157, 3158, 3170, 3171, 3201, 3201, 3260, 3260, 3263, 3263, 3270, 3270, 3276, 3277, 3298, 3299, 3328, 3329, 3387, 3388, 3393, 3396, 3405, 3405, 3426, 3427, 3457, 3457, 3530, 3530, 3538, 3540, 3542, 3542, 3633, 3633, 3636, 3642, 3655, 3662, 3761, 3761, 3764, 3772, 3784, 3790, 3864, 3865, 3893, 3893, 3895, 3895, 3897, 3897, 3953, 3966, 3968, 3972, 3974, 3975, 3981, 3991, 3993, 4028, 4038, 4038, 4141, 4144, 4146, 4151, 4153, 4154, 4157, 4158, 4184, 4185, 4190, 4192, 4209, 4212, 4226, 4226, 4229, 4230, 4237, 4237, 4253, 4253, 4957, 4959, 5906, 5908, 5938, 5939, 5970, 5971, 6002, 6003, 6068, 6069, 6071, 6077, 6086, 6086, 6089, 6099, 6109, 6109, 6155, 6157, 6159, 6159, 6277, 6278, 6313, 6313, 6432, 6434, 6439, 6440, 6450, 6450, 6457, 6459, 6679, 6680, 6683, 6683, 6742, 6742, 6744, 6750, 6752, 6752, 6754, 6754, 6757, 6764, 6771, 6780, 6783, 6783, 6832, 6845, 6847, 6862, 6912, 6915, 6964, 6964, 6966, 6970, 6972, 6972, 6978, 6978, 7019, 7027, 7040, 7041, 7074, 7077, 7080, 7081, 7083, 7085, 7142, 7142, 7144, 7145, 7149, 7149, 7151, 7153, 7212, 7219, 7222, 7223, 7376, 7378, 7380, 7392, 7394, 7400, 7405, 7405, 7412, 7412, 7416, 7417, 7616, 7679, 8400, 8412, 8417, 8417, 8421, 8432, 11503, 11505, 11647, 11647, 11744, 11775, 12330, 12333, 12441, 12442, 42607, 42607, 42612, 42621, 42654, 42655, 42736, 42737, 43010, 43010, 43014, 43014, 43019, 43019, 43045, 43046, 43052, 43052, 43204, 43205, 43232, 43249, 43263, 43263, 43302, 43309, 43335, 43345, 43392, 43394, 43443, 43443, 43446, 43449, 43452, 43453, 43493, 43493, 43561, 43566, 43569, 43570, 43573, 43574, 43587, 43587, 43596, 43596, 43644, 43644, 43696, 43696, 43698, 43700, 43703, 43704, 43710, 43711, 43713, 43713, 43756, 43757, 43766, 43766, 44005, 44005, 44008, 44008, 44013, 44013, 64286, 64286, 65024, 65039, 65056, 65071, 66045, 66045, 66272, 66272, 66422, 66426, 68097, 68099, 68101, 68102, 68108, 68111, 68152, 68154, 68159, 68159, 68325, 68326, 68900, 68903, 68969, 68973, 69291, 69292, 69372, 69375, 69446, 69456, 69506, 69509, 69633, 69633, 69688, 69702, 69744, 69744, 69747, 69748, 69759, 69761, 69811, 69814, 69817, 69818, 69826, 69826, 69888, 69890, 69927, 69931, 69933, 69940, 70003, 70003, 70016, 70017, 70070, 70078, 70089, 70092, 70095, 70095, 70191, 70193, 70196, 70196, 70198, 70199, 70206, 70206, 70209, 70209, 70367, 70367, 70371, 70378, 70400, 70401, 70459, 70460, 70464, 70464, 70502, 70508, 70512, 70516, 70587, 70592, 70606, 70606, 70608, 70608, 70610, 70610, 70625, 70626, 70712, 70719, 70722, 70724, 70726, 70726, 70750, 70750, 70835, 70840, 70842, 70842, 70847, 70848, 70850, 70851, 71090, 71093, 71100, 71101, 71103, 71104, 71132, 71133, 71219, 71226, 71229, 71229, 71231, 71232, 71339, 71339, 71341, 71341, 71344, 71349, 71351, 71351, 71453, 71453, 71455, 71455, 71458, 71461, 71463, 71467, 71727, 71735, 71737, 71738, 71995, 71996, 71998, 71998, 72003, 72003, 72148, 72151, 72154, 72155, 72160, 72160, 72193, 72202, 72243, 72248, 72251, 72254, 72263, 72263, 72273, 72278, 72281, 72283, 72330, 72342, 72344, 72345, 72752, 72758, 72760, 72765, 72767, 72767, 72850, 72871, 72874, 72880, 72882, 72883, 72885, 72886, 73009, 73014, 73018, 73018, 73020, 73021, 73023, 73029, 73031, 73031, 73104, 73105, 73109, 73109, 73111, 73111, 73459, 73460, 73472, 73473, 73526, 73530, 73536, 73536, 73538, 73538, 73562, 73562, 78912, 78912, 78919, 78933, 90398, 90409, 90413, 90415, 92912, 92916, 92976, 92982, 94031, 94031, 94095, 94098, 94180, 94180, 113821, 113822, 118528, 118573, 118576, 118598, 119143, 119145, 119163, 119170, 119173, 119179, 119210, 119213, 119362, 119364, 121344, 121398, 121403, 121452, 121461, 121461, 121476, 121476, 121499, 121503, 121505, 121519, 122880, 122886, 122888, 122904, 122907, 122913, 122915, 122916, 122918, 122922, 123023, 123023, 123184, 123190, 123566, 123566, 123628, 123631, 124140, 124143, 124398, 124399, 125136, 125142, 125252, 125258, 917760, 917999];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS79 = [1160, 1161, 6846, 6846, 8413, 8416, 8418, 8420, 42608, 42610];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS80 = [2307, 2307, 2363, 2363, 2366, 2368, 2377, 2380, 2382, 2383, 2434, 2435, 2494, 2496, 2503, 2504, 2507, 2508, 2519, 2519, 2563, 2563, 2622, 2624, 2691, 2691, 2750, 2752, 2761, 2761, 2763, 2764, 2818, 2819, 2878, 2878, 2880, 2880, 2887, 2888, 2891, 2892, 2903, 2903, 3006, 3007, 3009, 3010, 3014, 3016, 3018, 3020, 3031, 3031, 3073, 3075, 3137, 3140, 3202, 3203, 3262, 3262, 3264, 3268, 3271, 3272, 3274, 3275, 3285, 3286, 3315, 3315, 3330, 3331, 3390, 3392, 3398, 3400, 3402, 3404, 3415, 3415, 3458, 3459, 3535, 3537, 3544, 3551, 3570, 3571, 3902, 3903, 3967, 3967, 4139, 4140, 4145, 4145, 4152, 4152, 4155, 4156, 4182, 4183, 4194, 4196, 4199, 4205, 4227, 4228, 4231, 4236, 4239, 4239, 4250, 4252, 5909, 5909, 5940, 5940, 6070, 6070, 6078, 6085, 6087, 6088, 6435, 6438, 6441, 6443, 6448, 6449, 6451, 6456, 6681, 6682, 6741, 6741, 6743, 6743, 6753, 6753, 6755, 6756, 6765, 6770, 6916, 6916, 6965, 6965, 6971, 6971, 6973, 6977, 6979, 6980, 7042, 7042, 7073, 7073, 7078, 7079, 7082, 7082, 7143, 7143, 7146, 7148, 7150, 7150, 7154, 7155, 7204, 7211, 7220, 7221, 7393, 7393, 7415, 7415, 12334, 12335, 43043, 43044, 43047, 43047, 43136, 43137, 43188, 43203, 43346, 43347, 43395, 43395, 43444, 43445, 43450, 43451, 43454, 43456, 43567, 43568, 43571, 43572, 43597, 43597, 43643, 43643, 43645, 43645, 43755, 43755, 43758, 43759, 43765, 43765, 44003, 44004, 44006, 44007, 44009, 44010, 44012, 44012, 69632, 69632, 69634, 69634, 69762, 69762, 69808, 69810, 69815, 69816, 69932, 69932, 69957, 69958, 70018, 70018, 70067, 70069, 70079, 70080, 70094, 70094, 70188, 70190, 70194, 70195, 70197, 70197, 70368, 70370, 70402, 70403, 70462, 70463, 70465, 70468, 70471, 70472, 70475, 70477, 70487, 70487, 70498, 70499, 70584, 70586, 70594, 70594, 70597, 70597, 70599, 70602, 70604, 70605, 70607, 70607, 70709, 70711, 70720, 70721, 70725, 70725, 70832, 70834, 70841, 70841, 70843, 70846, 70849, 70849, 71087, 71089, 71096, 71099, 71102, 71102, 71216, 71218, 71227, 71228, 71230, 71230, 71340, 71340, 71342, 71343, 71350, 71350, 71454, 71454, 71456, 71457, 71462, 71462, 71724, 71726, 71736, 71736, 71984, 71989, 71991, 71992, 71997, 71997, 72000, 72000, 72002, 72002, 72145, 72147, 72156, 72159, 72164, 72164, 72249, 72249, 72279, 72280, 72343, 72343, 72751, 72751, 72766, 72766, 72873, 72873, 72881, 72881, 72884, 72884, 73098, 73102, 73107, 73108, 73110, 73110, 73461, 73462, 73475, 73475, 73524, 73525, 73534, 73535, 73537, 73537, 90410, 90412, 94033, 94087, 94192, 94193, 119141, 119142, 119149, 119154];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS81 = [5870, 5872, 8544, 8578, 8581, 8584, 12295, 12295, 12321, 12329, 12344, 12346, 42726, 42735, 65856, 65908, 66369, 66369, 66378, 66378, 66513, 66517, 74752, 74862];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS82 = [8232, 8232];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS83 = [8233, 8233];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS85 = [57344, 63743, 983040, 1048573, 1048576, 1114109];
const _tmp$2 = { _0: "LC", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS48, 0, 290) };
const _tmp$3 = { _0: "L", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS49, 0, 1354) };
const _tmp$4 = { _0: "M", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS50, 0, 642) };
const _tmp$5 = { _0: "N", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS51, 0, 288) };
const _tmp$6 = { _0: "P", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS52, 0, 396) };
const _tmp$7 = { _0: "S", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS53, 0, 472) };
const _tmp$8 = { _0: "Z", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS54, 0, 16) };
const _tmp$9 = { _0: "C", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS55, 0, 28) };
const _tmp$10 = { _0: "Cn", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS56, 0, 1460) };
const _tmp$11 = { _0: "Cc", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS57, 0, 4) };
const _tmp$12 = { _0: "Zs", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS58, 0, 14) };
const _tmp$13 = { _0: "Po", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS59, 0, 386) };
const _tmp$14 = { _0: "Sc", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS60, 0, 42) };
const _tmp$15 = { _0: "Ps", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS61, 0, 158) };
const _tmp$16 = { _0: "Pe", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS62, 0, 152) };
const _tmp$17 = { _0: "Sm", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS63, 0, 130) };
const _tmp$18 = { _0: "Pd", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS64, 0, 40) };
const _tmp$19 = { _0: "Nd", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS65, 0, 142) };
const _tmp$20 = { _0: "Lu", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS66, 0, 1302) };
const _tmp$21 = { _0: "Sk", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS67, 0, 62) };
const _tmp$22 = { _0: "Pc", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS68, 0, 12) };
const _tmp$23 = { _0: "Ll", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS69, 0, 1324) };
const _tmp$24 = { _0: "So", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS70, 0, 374) };
const _tmp$25 = { _0: "Lo", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS71, 0, 1056) };
const _tmp$26 = { _0: "Pi", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS72, 0, 22) };
const _tmp$27 = { _0: "Cf", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS73, 0, 42) };
const _tmp$28 = { _0: "No", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS74, 0, 144) };
const _tmp$29 = { _0: "Pf", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS75, 0, 20) };
const _tmp$30 = { _0: "Lt", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS76, 0, 20) };
const _tmp$31 = { _0: "Lm", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS77, 0, 150) };
const _tmp$32 = { _0: "Mn", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS78, 0, 714) };
const _tmp$33 = { _0: "Me", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS79, 0, 10) };
const _tmp$34 = { _0: "Mc", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS80, 0, 380) };
const _tmp$35 = { _0: "Nl", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS81, 0, 24) };
const _tmp$36 = { _0: "Zl", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS82, 0, 2) };
const _tmp$37 = { _0: "Zp", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS83, 0, 2) };
const _bind$2 = [];
const _bind$3 = [_tmp$2, _tmp$3, _tmp$4, _tmp$5, _tmp$6, _tmp$7, _tmp$8, _tmp$9, _tmp$10, _tmp$11, _tmp$12, _tmp$13, _tmp$14, _tmp$15, _tmp$16, _tmp$17, _tmp$18, _tmp$19, _tmp$20, _tmp$21, _tmp$22, _tmp$23, _tmp$24, _tmp$25, _tmp$26, _tmp$27, _tmp$28, _tmp$29, _tmp$30, _tmp$31, _tmp$32, _tmp$33, _tmp$34, _tmp$35, _tmp$36, _tmp$37, { _0: "Cs", _1: new _M0TPB9ArrayViewGcE(_bind$2, 0, 0) }, { _0: "Co", _1: new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__rangesN7_2abindS85, 0, 6) }];
const _M0FP411moonbitlang6regexp8internal7unicode25general__category__ranges = _M0MPB3Map3MapGsRPB9ArrayViewGcEE(new _M0TPB9ArrayViewGUsRPB9ArrayViewGcEEE(_bind$3, 0, 38), undefined);
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS145 = { _0: "C", _1: "C" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS146 = { _0: "Other", _1: "C" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS147 = { _0: "Cc", _1: "Cc" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS148 = { _0: "Control", _1: "Cc" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS149 = { _0: "cntrl", _1: "Cc" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS150 = { _0: "Cf", _1: "Cf" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS151 = { _0: "Format", _1: "Cf" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS152 = { _0: "Cn", _1: "Cn" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS153 = { _0: "Unassigned", _1: "Cn" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS154 = { _0: "Co", _1: "Co" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS155 = { _0: "Private_Use", _1: "Co" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS156 = { _0: "Cs", _1: "Cs" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS157 = { _0: "Surrogate", _1: "Cs" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS158 = { _0: "L", _1: "L" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS159 = { _0: "Letter", _1: "L" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS160 = { _0: "LC", _1: "LC" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS161 = { _0: "Cased_Letter", _1: "LC" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS162 = { _0: "Ll", _1: "Ll" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS163 = { _0: "Lowercase_Letter", _1: "Ll" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS164 = { _0: "Lm", _1: "Lm" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS165 = { _0: "Modifier_Letter", _1: "Lm" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS166 = { _0: "Lo", _1: "Lo" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS167 = { _0: "Other_Letter", _1: "Lo" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS168 = { _0: "Lt", _1: "Lt" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS169 = { _0: "Titlecase_Letter", _1: "Lt" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS170 = { _0: "Lu", _1: "Lu" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS171 = { _0: "Uppercase_Letter", _1: "Lu" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS172 = { _0: "M", _1: "M" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS173 = { _0: "Mark", _1: "M" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS174 = { _0: "Combining_Mark", _1: "M" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS175 = { _0: "Mc", _1: "Mc" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS176 = { _0: "Spacing_Mark", _1: "Mc" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS177 = { _0: "Me", _1: "Me" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS178 = { _0: "Enclosing_Mark", _1: "Me" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS179 = { _0: "Mn", _1: "Mn" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS180 = { _0: "Nonspacing_Mark", _1: "Mn" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS181 = { _0: "N", _1: "N" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS182 = { _0: "Number", _1: "N" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS183 = { _0: "Nd", _1: "Nd" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS184 = { _0: "Decimal_Number", _1: "Nd" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS185 = { _0: "digit", _1: "Nd" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS186 = { _0: "Nl", _1: "Nl" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS187 = { _0: "Letter_Number", _1: "Nl" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS188 = { _0: "No", _1: "No" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS189 = { _0: "Other_Number", _1: "No" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS190 = { _0: "P", _1: "P" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS191 = { _0: "Punctuation", _1: "P" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS192 = { _0: "punct", _1: "P" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS193 = { _0: "Pc", _1: "Pc" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS194 = { _0: "Connector_Punctuation", _1: "Pc" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS195 = { _0: "Pd", _1: "Pd" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS196 = { _0: "Dash_Punctuation", _1: "Pd" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS197 = { _0: "Pe", _1: "Pe" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS198 = { _0: "Close_Punctuation", _1: "Pe" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS199 = { _0: "Pf", _1: "Pf" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS200 = { _0: "Final_Punctuation", _1: "Pf" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS201 = { _0: "Pi", _1: "Pi" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS202 = { _0: "Initial_Punctuation", _1: "Pi" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS203 = { _0: "Po", _1: "Po" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS204 = { _0: "Other_Punctuation", _1: "Po" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS205 = { _0: "Ps", _1: "Ps" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS206 = { _0: "Open_Punctuation", _1: "Ps" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS207 = { _0: "S", _1: "S" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS208 = { _0: "Symbol", _1: "S" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS209 = { _0: "Sc", _1: "Sc" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS210 = { _0: "Currency_Symbol", _1: "Sc" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS211 = { _0: "Sk", _1: "Sk" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS212 = { _0: "Modifier_Symbol", _1: "Sk" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS213 = { _0: "Sm", _1: "Sm" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS214 = { _0: "Math_Symbol", _1: "Sm" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS215 = { _0: "So", _1: "So" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS216 = { _0: "Other_Symbol", _1: "So" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS217 = { _0: "Z", _1: "Z" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS218 = { _0: "Separator", _1: "Z" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS219 = { _0: "Zl", _1: "Zl" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS220 = { _0: "Line_Separator", _1: "Zl" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS221 = { _0: "Zp", _1: "Zp" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS222 = { _0: "Paragraph_Separator", _1: "Zp" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS223 = { _0: "Zs", _1: "Zs" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS224 = { _0: "Space_Separator", _1: "Zs" };
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN7_2abindS47 = [_M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS145, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS146, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS147, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS148, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS149, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS150, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS151, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS152, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS153, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS154, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS155, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS156, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS157, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS158, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS159, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS160, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS161, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS162, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS163, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS164, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS165, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS166, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS167, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS168, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS169, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS170, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS171, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS172, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS173, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS174, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS175, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS176, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS177, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS178, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS179, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS180, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS181, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS182, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS183, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS184, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS185, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS186, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS187, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS188, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS189, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS190, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS191, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS192, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS193, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS194, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS195, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS196, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS197, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS198, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS199, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS200, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS201, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS202, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS203, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS204, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS205, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS206, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS207, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS208, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS209, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS210, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS211, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS212, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS213, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS214, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS215, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS216, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS217, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS218, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS219, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS220, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS221, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS222, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS223, _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN5tupleS224];
const _M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alises = _M0MPB3Map3MapGssE(new _M0TPB9ArrayViewGUssEE(_M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alisesN7_2abindS47, 0, 80), undefined);
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS225 = { _0: 97, _1: 65 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS226 = { _0: 65, _1: 97 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS227 = { _0: 98, _1: 66 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS228 = { _0: 66, _1: 98 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS229 = { _0: 99, _1: 67 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS230 = { _0: 67, _1: 99 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS231 = { _0: 100, _1: 68 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS232 = { _0: 68, _1: 100 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS233 = { _0: 101, _1: 69 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS234 = { _0: 69, _1: 101 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS235 = { _0: 102, _1: 70 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS236 = { _0: 70, _1: 102 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS237 = { _0: 103, _1: 71 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS238 = { _0: 71, _1: 103 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS239 = { _0: 104, _1: 72 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS240 = { _0: 72, _1: 104 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS241 = { _0: 105, _1: 73 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS242 = { _0: 73, _1: 105 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS243 = { _0: 106, _1: 74 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS244 = { _0: 74, _1: 106 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS245 = { _0: 107, _1: 75 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS246 = { _0: 75, _1: 8490 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS247 = { _0: 8490, _1: 107 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS248 = { _0: 108, _1: 76 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS249 = { _0: 76, _1: 108 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS250 = { _0: 109, _1: 77 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS251 = { _0: 77, _1: 109 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS252 = { _0: 110, _1: 78 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS253 = { _0: 78, _1: 110 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS254 = { _0: 111, _1: 79 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS255 = { _0: 79, _1: 111 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS256 = { _0: 112, _1: 80 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS257 = { _0: 80, _1: 112 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS258 = { _0: 113, _1: 81 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS259 = { _0: 81, _1: 113 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS260 = { _0: 114, _1: 82 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS261 = { _0: 82, _1: 114 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS262 = { _0: 115, _1: 83 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS263 = { _0: 83, _1: 383 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS264 = { _0: 383, _1: 115 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS265 = { _0: 116, _1: 84 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS266 = { _0: 84, _1: 116 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS267 = { _0: 117, _1: 85 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS268 = { _0: 85, _1: 117 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS269 = { _0: 118, _1: 86 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS270 = { _0: 86, _1: 118 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS271 = { _0: 119, _1: 87 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS272 = { _0: 87, _1: 119 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS273 = { _0: 120, _1: 88 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS274 = { _0: 88, _1: 120 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS275 = { _0: 121, _1: 89 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS276 = { _0: 89, _1: 121 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS277 = { _0: 122, _1: 90 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS278 = { _0: 90, _1: 122 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS279 = { _0: 956, _1: 181 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS280 = { _0: 181, _1: 924 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS281 = { _0: 924, _1: 956 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS282 = { _0: 224, _1: 192 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS283 = { _0: 192, _1: 224 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS284 = { _0: 225, _1: 193 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS285 = { _0: 193, _1: 225 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS286 = { _0: 226, _1: 194 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS287 = { _0: 194, _1: 226 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS288 = { _0: 227, _1: 195 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS289 = { _0: 195, _1: 227 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS290 = { _0: 228, _1: 196 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS291 = { _0: 196, _1: 228 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS292 = { _0: 229, _1: 197 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS293 = { _0: 197, _1: 8491 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS294 = { _0: 8491, _1: 229 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS295 = { _0: 230, _1: 198 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS296 = { _0: 198, _1: 230 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS297 = { _0: 231, _1: 199 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS298 = { _0: 199, _1: 231 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS299 = { _0: 232, _1: 200 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS300 = { _0: 200, _1: 232 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS301 = { _0: 233, _1: 201 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS302 = { _0: 201, _1: 233 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS303 = { _0: 234, _1: 202 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS304 = { _0: 202, _1: 234 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS305 = { _0: 235, _1: 203 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS306 = { _0: 203, _1: 235 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS307 = { _0: 236, _1: 204 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS308 = { _0: 204, _1: 236 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS309 = { _0: 237, _1: 205 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS310 = { _0: 205, _1: 237 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS311 = { _0: 238, _1: 206 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS312 = { _0: 206, _1: 238 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS313 = { _0: 239, _1: 207 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS314 = { _0: 207, _1: 239 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS315 = { _0: 240, _1: 208 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS316 = { _0: 208, _1: 240 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS317 = { _0: 241, _1: 209 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS318 = { _0: 209, _1: 241 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS319 = { _0: 242, _1: 210 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS320 = { _0: 210, _1: 242 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS321 = { _0: 243, _1: 211 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS322 = { _0: 211, _1: 243 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS323 = { _0: 244, _1: 212 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS324 = { _0: 212, _1: 244 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS325 = { _0: 245, _1: 213 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS326 = { _0: 213, _1: 245 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS327 = { _0: 246, _1: 214 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS328 = { _0: 214, _1: 246 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS329 = { _0: 248, _1: 216 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS330 = { _0: 216, _1: 248 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS331 = { _0: 249, _1: 217 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS332 = { _0: 217, _1: 249 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS333 = { _0: 250, _1: 218 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS334 = { _0: 218, _1: 250 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS335 = { _0: 251, _1: 219 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS336 = { _0: 219, _1: 251 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS337 = { _0: 252, _1: 220 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS338 = { _0: 220, _1: 252 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS339 = { _0: 253, _1: 221 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS340 = { _0: 221, _1: 253 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS341 = { _0: 254, _1: 222 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS342 = { _0: 222, _1: 254 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS343 = { _0: 257, _1: 256 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS344 = { _0: 256, _1: 257 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS345 = { _0: 259, _1: 258 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS346 = { _0: 258, _1: 259 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS347 = { _0: 261, _1: 260 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS348 = { _0: 260, _1: 261 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS349 = { _0: 263, _1: 262 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS350 = { _0: 262, _1: 263 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS351 = { _0: 265, _1: 264 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS352 = { _0: 264, _1: 265 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS353 = { _0: 267, _1: 266 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS354 = { _0: 266, _1: 267 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS355 = { _0: 269, _1: 268 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS356 = { _0: 268, _1: 269 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS357 = { _0: 271, _1: 270 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS358 = { _0: 270, _1: 271 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS359 = { _0: 273, _1: 272 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS360 = { _0: 272, _1: 273 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS361 = { _0: 275, _1: 274 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS362 = { _0: 274, _1: 275 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS363 = { _0: 277, _1: 276 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS364 = { _0: 276, _1: 277 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS365 = { _0: 279, _1: 278 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS366 = { _0: 278, _1: 279 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS367 = { _0: 281, _1: 280 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS368 = { _0: 280, _1: 281 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS369 = { _0: 283, _1: 282 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS370 = { _0: 282, _1: 283 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS371 = { _0: 285, _1: 284 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS372 = { _0: 284, _1: 285 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS373 = { _0: 287, _1: 286 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS374 = { _0: 286, _1: 287 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS375 = { _0: 289, _1: 288 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS376 = { _0: 288, _1: 289 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS377 = { _0: 291, _1: 290 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS378 = { _0: 290, _1: 291 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS379 = { _0: 293, _1: 292 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS380 = { _0: 292, _1: 293 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS381 = { _0: 295, _1: 294 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS382 = { _0: 294, _1: 295 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS383 = { _0: 297, _1: 296 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS384 = { _0: 296, _1: 297 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS385 = { _0: 299, _1: 298 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS386 = { _0: 298, _1: 299 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS387 = { _0: 301, _1: 300 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS388 = { _0: 300, _1: 301 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS389 = { _0: 303, _1: 302 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS390 = { _0: 302, _1: 303 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS391 = { _0: 307, _1: 306 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS392 = { _0: 306, _1: 307 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS393 = { _0: 309, _1: 308 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS394 = { _0: 308, _1: 309 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS395 = { _0: 311, _1: 310 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS396 = { _0: 310, _1: 311 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS397 = { _0: 314, _1: 313 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS398 = { _0: 313, _1: 314 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS399 = { _0: 316, _1: 315 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS400 = { _0: 315, _1: 316 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS401 = { _0: 318, _1: 317 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS402 = { _0: 317, _1: 318 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS403 = { _0: 320, _1: 319 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS404 = { _0: 319, _1: 320 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS405 = { _0: 322, _1: 321 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS406 = { _0: 321, _1: 322 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS407 = { _0: 324, _1: 323 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS408 = { _0: 323, _1: 324 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS409 = { _0: 326, _1: 325 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS410 = { _0: 325, _1: 326 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS411 = { _0: 328, _1: 327 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS412 = { _0: 327, _1: 328 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS413 = { _0: 331, _1: 330 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS414 = { _0: 330, _1: 331 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS415 = { _0: 333, _1: 332 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS416 = { _0: 332, _1: 333 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS417 = { _0: 335, _1: 334 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS418 = { _0: 334, _1: 335 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS419 = { _0: 337, _1: 336 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS420 = { _0: 336, _1: 337 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS421 = { _0: 339, _1: 338 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS422 = { _0: 338, _1: 339 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS423 = { _0: 341, _1: 340 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS424 = { _0: 340, _1: 341 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS425 = { _0: 343, _1: 342 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS426 = { _0: 342, _1: 343 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS427 = { _0: 345, _1: 344 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS428 = { _0: 344, _1: 345 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS429 = { _0: 347, _1: 346 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS430 = { _0: 346, _1: 347 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS431 = { _0: 349, _1: 348 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS432 = { _0: 348, _1: 349 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS433 = { _0: 351, _1: 350 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS434 = { _0: 350, _1: 351 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS435 = { _0: 353, _1: 352 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS436 = { _0: 352, _1: 353 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS437 = { _0: 355, _1: 354 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS438 = { _0: 354, _1: 355 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS439 = { _0: 357, _1: 356 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS440 = { _0: 356, _1: 357 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS441 = { _0: 359, _1: 358 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS442 = { _0: 358, _1: 359 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS443 = { _0: 361, _1: 360 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS444 = { _0: 360, _1: 361 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS445 = { _0: 363, _1: 362 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS446 = { _0: 362, _1: 363 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS447 = { _0: 365, _1: 364 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS448 = { _0: 364, _1: 365 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS449 = { _0: 367, _1: 366 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS450 = { _0: 366, _1: 367 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS451 = { _0: 369, _1: 368 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS452 = { _0: 368, _1: 369 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS453 = { _0: 371, _1: 370 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS454 = { _0: 370, _1: 371 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS455 = { _0: 373, _1: 372 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS456 = { _0: 372, _1: 373 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS457 = { _0: 375, _1: 374 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS458 = { _0: 374, _1: 375 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS459 = { _0: 255, _1: 376 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS460 = { _0: 376, _1: 255 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS461 = { _0: 378, _1: 377 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS462 = { _0: 377, _1: 378 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS463 = { _0: 380, _1: 379 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS464 = { _0: 379, _1: 380 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS465 = { _0: 382, _1: 381 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS466 = { _0: 381, _1: 382 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS467 = { _0: 595, _1: 385 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS468 = { _0: 385, _1: 595 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS469 = { _0: 387, _1: 386 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS470 = { _0: 386, _1: 387 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS471 = { _0: 389, _1: 388 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS472 = { _0: 388, _1: 389 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS473 = { _0: 596, _1: 390 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS474 = { _0: 390, _1: 596 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS475 = { _0: 392, _1: 391 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS476 = { _0: 391, _1: 392 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS477 = { _0: 598, _1: 393 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS478 = { _0: 393, _1: 598 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS479 = { _0: 599, _1: 394 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS480 = { _0: 394, _1: 599 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS481 = { _0: 396, _1: 395 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS482 = { _0: 395, _1: 396 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS483 = { _0: 477, _1: 398 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS484 = { _0: 398, _1: 477 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS485 = { _0: 601, _1: 399 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS486 = { _0: 399, _1: 601 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS487 = { _0: 603, _1: 400 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS488 = { _0: 400, _1: 603 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS489 = { _0: 402, _1: 401 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS490 = { _0: 401, _1: 402 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS491 = { _0: 608, _1: 403 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS492 = { _0: 403, _1: 608 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS493 = { _0: 611, _1: 404 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS494 = { _0: 404, _1: 611 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS495 = { _0: 617, _1: 406 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS496 = { _0: 406, _1: 617 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS497 = { _0: 616, _1: 407 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS498 = { _0: 407, _1: 616 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS499 = { _0: 409, _1: 408 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS500 = { _0: 408, _1: 409 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS501 = { _0: 623, _1: 412 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS502 = { _0: 412, _1: 623 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS503 = { _0: 626, _1: 413 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS504 = { _0: 413, _1: 626 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS505 = { _0: 629, _1: 415 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS506 = { _0: 415, _1: 629 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS507 = { _0: 417, _1: 416 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS508 = { _0: 416, _1: 417 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS509 = { _0: 419, _1: 418 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS510 = { _0: 418, _1: 419 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS511 = { _0: 421, _1: 420 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS512 = { _0: 420, _1: 421 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS513 = { _0: 640, _1: 422 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS514 = { _0: 422, _1: 640 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS515 = { _0: 424, _1: 423 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS516 = { _0: 423, _1: 424 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS517 = { _0: 643, _1: 425 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS518 = { _0: 425, _1: 643 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS519 = { _0: 429, _1: 428 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS520 = { _0: 428, _1: 429 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS521 = { _0: 648, _1: 430 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS522 = { _0: 430, _1: 648 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS523 = { _0: 432, _1: 431 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS524 = { _0: 431, _1: 432 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS525 = { _0: 650, _1: 433 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS526 = { _0: 433, _1: 650 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS527 = { _0: 651, _1: 434 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS528 = { _0: 434, _1: 651 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS529 = { _0: 436, _1: 435 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS530 = { _0: 435, _1: 436 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS531 = { _0: 438, _1: 437 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS532 = { _0: 437, _1: 438 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS533 = { _0: 658, _1: 439 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS534 = { _0: 439, _1: 658 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS535 = { _0: 441, _1: 440 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS536 = { _0: 440, _1: 441 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS537 = { _0: 445, _1: 444 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS538 = { _0: 444, _1: 445 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS539 = { _0: 454, _1: 452 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS540 = { _0: 452, _1: 453 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS541 = { _0: 453, _1: 454 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS542 = { _0: 457, _1: 455 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS543 = { _0: 455, _1: 456 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS544 = { _0: 456, _1: 457 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS545 = { _0: 460, _1: 458 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS546 = { _0: 458, _1: 459 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS547 = { _0: 459, _1: 460 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS548 = { _0: 462, _1: 461 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS549 = { _0: 461, _1: 462 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS550 = { _0: 464, _1: 463 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS551 = { _0: 463, _1: 464 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS552 = { _0: 466, _1: 465 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS553 = { _0: 465, _1: 466 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS554 = { _0: 468, _1: 467 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS555 = { _0: 467, _1: 468 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS556 = { _0: 470, _1: 469 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS557 = { _0: 469, _1: 470 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS558 = { _0: 472, _1: 471 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS559 = { _0: 471, _1: 472 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS560 = { _0: 474, _1: 473 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS561 = { _0: 473, _1: 474 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS562 = { _0: 476, _1: 475 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS563 = { _0: 475, _1: 476 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS564 = { _0: 479, _1: 478 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS565 = { _0: 478, _1: 479 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS566 = { _0: 481, _1: 480 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS567 = { _0: 480, _1: 481 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS568 = { _0: 483, _1: 482 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS569 = { _0: 482, _1: 483 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS570 = { _0: 485, _1: 484 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS571 = { _0: 484, _1: 485 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS572 = { _0: 487, _1: 486 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS573 = { _0: 486, _1: 487 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS574 = { _0: 489, _1: 488 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS575 = { _0: 488, _1: 489 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS576 = { _0: 491, _1: 490 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS577 = { _0: 490, _1: 491 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS578 = { _0: 493, _1: 492 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS579 = { _0: 492, _1: 493 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS580 = { _0: 495, _1: 494 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS581 = { _0: 494, _1: 495 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS582 = { _0: 499, _1: 497 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS583 = { _0: 497, _1: 498 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS584 = { _0: 498, _1: 499 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS585 = { _0: 501, _1: 500 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS586 = { _0: 500, _1: 501 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS587 = { _0: 405, _1: 502 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS588 = { _0: 502, _1: 405 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS589 = { _0: 447, _1: 503 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS590 = { _0: 503, _1: 447 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS591 = { _0: 505, _1: 504 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS592 = { _0: 504, _1: 505 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS593 = { _0: 507, _1: 506 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS594 = { _0: 506, _1: 507 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS595 = { _0: 509, _1: 508 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS596 = { _0: 508, _1: 509 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS597 = { _0: 511, _1: 510 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS598 = { _0: 510, _1: 511 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS599 = { _0: 513, _1: 512 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS600 = { _0: 512, _1: 513 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS601 = { _0: 515, _1: 514 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS602 = { _0: 514, _1: 515 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS603 = { _0: 517, _1: 516 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS604 = { _0: 516, _1: 517 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS605 = { _0: 519, _1: 518 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS606 = { _0: 518, _1: 519 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS607 = { _0: 521, _1: 520 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS608 = { _0: 520, _1: 521 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS609 = { _0: 523, _1: 522 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS610 = { _0: 522, _1: 523 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS611 = { _0: 525, _1: 524 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS612 = { _0: 524, _1: 525 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS613 = { _0: 527, _1: 526 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS614 = { _0: 526, _1: 527 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS615 = { _0: 529, _1: 528 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS616 = { _0: 528, _1: 529 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS617 = { _0: 531, _1: 530 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS618 = { _0: 530, _1: 531 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS619 = { _0: 533, _1: 532 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS620 = { _0: 532, _1: 533 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS621 = { _0: 535, _1: 534 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS622 = { _0: 534, _1: 535 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS623 = { _0: 537, _1: 536 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS624 = { _0: 536, _1: 537 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS625 = { _0: 539, _1: 538 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS626 = { _0: 538, _1: 539 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS627 = { _0: 541, _1: 540 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS628 = { _0: 540, _1: 541 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS629 = { _0: 543, _1: 542 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS630 = { _0: 542, _1: 543 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS631 = { _0: 414, _1: 544 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS632 = { _0: 544, _1: 414 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS633 = { _0: 547, _1: 546 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS634 = { _0: 546, _1: 547 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS635 = { _0: 549, _1: 548 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS636 = { _0: 548, _1: 549 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS637 = { _0: 551, _1: 550 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS638 = { _0: 550, _1: 551 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS639 = { _0: 553, _1: 552 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS640 = { _0: 552, _1: 553 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS641 = { _0: 555, _1: 554 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS642 = { _0: 554, _1: 555 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS643 = { _0: 557, _1: 556 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS644 = { _0: 556, _1: 557 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS645 = { _0: 559, _1: 558 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS646 = { _0: 558, _1: 559 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS647 = { _0: 561, _1: 560 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS648 = { _0: 560, _1: 561 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS649 = { _0: 563, _1: 562 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS650 = { _0: 562, _1: 563 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS651 = { _0: 11365, _1: 570 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS652 = { _0: 570, _1: 11365 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS653 = { _0: 572, _1: 571 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS654 = { _0: 571, _1: 572 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS655 = { _0: 410, _1: 573 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS656 = { _0: 573, _1: 410 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS657 = { _0: 11366, _1: 574 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS658 = { _0: 574, _1: 11366 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS659 = { _0: 578, _1: 577 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS660 = { _0: 577, _1: 578 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS661 = { _0: 384, _1: 579 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS662 = { _0: 579, _1: 384 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS663 = { _0: 649, _1: 580 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS664 = { _0: 580, _1: 649 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS665 = { _0: 652, _1: 581 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS666 = { _0: 581, _1: 652 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS667 = { _0: 583, _1: 582 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS668 = { _0: 582, _1: 583 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS669 = { _0: 585, _1: 584 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS670 = { _0: 584, _1: 585 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS671 = { _0: 587, _1: 586 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS672 = { _0: 586, _1: 587 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS673 = { _0: 589, _1: 588 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS674 = { _0: 588, _1: 589 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS675 = { _0: 591, _1: 590 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS676 = { _0: 590, _1: 591 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS677 = { _0: 953, _1: 837 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS678 = { _0: 837, _1: 921 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS679 = { _0: 921, _1: 8126 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS680 = { _0: 8126, _1: 953 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS681 = { _0: 881, _1: 880 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS682 = { _0: 880, _1: 881 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS683 = { _0: 883, _1: 882 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS684 = { _0: 882, _1: 883 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS685 = { _0: 887, _1: 886 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS686 = { _0: 886, _1: 887 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS687 = { _0: 1011, _1: 895 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS688 = { _0: 895, _1: 1011 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS689 = { _0: 940, _1: 902 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS690 = { _0: 902, _1: 940 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS691 = { _0: 941, _1: 904 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS692 = { _0: 904, _1: 941 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS693 = { _0: 942, _1: 905 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS694 = { _0: 905, _1: 942 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS695 = { _0: 943, _1: 906 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS696 = { _0: 906, _1: 943 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS697 = { _0: 972, _1: 908 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS698 = { _0: 908, _1: 972 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS699 = { _0: 973, _1: 910 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS700 = { _0: 910, _1: 973 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS701 = { _0: 974, _1: 911 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS702 = { _0: 911, _1: 974 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS703 = { _0: 945, _1: 913 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS704 = { _0: 913, _1: 945 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS705 = { _0: 946, _1: 914 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS706 = { _0: 914, _1: 976 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS707 = { _0: 976, _1: 946 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS708 = { _0: 947, _1: 915 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS709 = { _0: 915, _1: 947 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS710 = { _0: 948, _1: 916 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS711 = { _0: 916, _1: 948 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS712 = { _0: 949, _1: 917 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS713 = { _0: 917, _1: 1013 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS714 = { _0: 1013, _1: 949 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS715 = { _0: 950, _1: 918 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS716 = { _0: 918, _1: 950 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS717 = { _0: 951, _1: 919 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS718 = { _0: 919, _1: 951 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS719 = { _0: 952, _1: 920 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS720 = { _0: 920, _1: 977 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS721 = { _0: 977, _1: 1012 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS722 = { _0: 1012, _1: 952 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS723 = { _0: 954, _1: 922 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS724 = { _0: 922, _1: 1008 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS725 = { _0: 1008, _1: 954 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS726 = { _0: 955, _1: 923 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS727 = { _0: 923, _1: 955 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS728 = { _0: 957, _1: 925 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS729 = { _0: 925, _1: 957 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS730 = { _0: 958, _1: 926 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS731 = { _0: 926, _1: 958 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS732 = { _0: 959, _1: 927 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS733 = { _0: 927, _1: 959 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS734 = { _0: 960, _1: 928 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS735 = { _0: 928, _1: 982 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS736 = { _0: 982, _1: 960 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS737 = { _0: 961, _1: 929 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS738 = { _0: 929, _1: 1009 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS739 = { _0: 1009, _1: 961 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS740 = { _0: 963, _1: 931 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS741 = { _0: 931, _1: 962 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS742 = { _0: 962, _1: 963 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS743 = { _0: 964, _1: 932 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS744 = { _0: 932, _1: 964 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS745 = { _0: 965, _1: 933 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS746 = { _0: 933, _1: 965 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS747 = { _0: 966, _1: 934 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS748 = { _0: 934, _1: 981 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS749 = { _0: 981, _1: 966 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS750 = { _0: 967, _1: 935 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS751 = { _0: 935, _1: 967 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS752 = { _0: 968, _1: 936 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS753 = { _0: 936, _1: 968 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS754 = { _0: 969, _1: 937 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS755 = { _0: 937, _1: 8486 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS756 = { _0: 8486, _1: 969 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS757 = { _0: 970, _1: 938 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS758 = { _0: 938, _1: 970 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS759 = { _0: 971, _1: 939 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS760 = { _0: 939, _1: 971 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS761 = { _0: 983, _1: 975 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS762 = { _0: 975, _1: 983 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS763 = { _0: 985, _1: 984 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS764 = { _0: 984, _1: 985 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS765 = { _0: 987, _1: 986 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS766 = { _0: 986, _1: 987 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS767 = { _0: 989, _1: 988 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS768 = { _0: 988, _1: 989 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS769 = { _0: 991, _1: 990 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS770 = { _0: 990, _1: 991 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS771 = { _0: 993, _1: 992 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS772 = { _0: 992, _1: 993 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS773 = { _0: 995, _1: 994 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS774 = { _0: 994, _1: 995 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS775 = { _0: 997, _1: 996 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS776 = { _0: 996, _1: 997 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS777 = { _0: 999, _1: 998 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS778 = { _0: 998, _1: 999 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS779 = { _0: 1001, _1: 1000 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS780 = { _0: 1000, _1: 1001 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS781 = { _0: 1003, _1: 1002 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS782 = { _0: 1002, _1: 1003 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS783 = { _0: 1005, _1: 1004 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS784 = { _0: 1004, _1: 1005 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS785 = { _0: 1007, _1: 1006 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS786 = { _0: 1006, _1: 1007 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS787 = { _0: 1016, _1: 1015 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS788 = { _0: 1015, _1: 1016 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS789 = { _0: 1010, _1: 1017 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS790 = { _0: 1017, _1: 1010 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS791 = { _0: 1019, _1: 1018 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS792 = { _0: 1018, _1: 1019 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS793 = { _0: 891, _1: 1021 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS794 = { _0: 1021, _1: 891 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS795 = { _0: 892, _1: 1022 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS796 = { _0: 1022, _1: 892 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS797 = { _0: 893, _1: 1023 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS798 = { _0: 1023, _1: 893 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS799 = { _0: 1104, _1: 1024 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS800 = { _0: 1024, _1: 1104 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS801 = { _0: 1105, _1: 1025 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS802 = { _0: 1025, _1: 1105 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS803 = { _0: 1106, _1: 1026 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS804 = { _0: 1026, _1: 1106 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS805 = { _0: 1107, _1: 1027 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS806 = { _0: 1027, _1: 1107 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS807 = { _0: 1108, _1: 1028 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS808 = { _0: 1028, _1: 1108 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS809 = { _0: 1109, _1: 1029 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS810 = { _0: 1029, _1: 1109 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS811 = { _0: 1110, _1: 1030 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS812 = { _0: 1030, _1: 1110 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS813 = { _0: 1111, _1: 1031 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS814 = { _0: 1031, _1: 1111 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS815 = { _0: 1112, _1: 1032 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS816 = { _0: 1032, _1: 1112 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS817 = { _0: 1113, _1: 1033 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS818 = { _0: 1033, _1: 1113 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS819 = { _0: 1114, _1: 1034 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS820 = { _0: 1034, _1: 1114 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS821 = { _0: 1115, _1: 1035 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS822 = { _0: 1035, _1: 1115 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS823 = { _0: 1116, _1: 1036 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS824 = { _0: 1036, _1: 1116 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS825 = { _0: 1117, _1: 1037 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS826 = { _0: 1037, _1: 1117 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS827 = { _0: 1118, _1: 1038 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS828 = { _0: 1038, _1: 1118 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS829 = { _0: 1119, _1: 1039 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS830 = { _0: 1039, _1: 1119 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS831 = { _0: 1072, _1: 1040 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS832 = { _0: 1040, _1: 1072 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS833 = { _0: 1073, _1: 1041 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS834 = { _0: 1041, _1: 1073 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS835 = { _0: 1074, _1: 1042 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS836 = { _0: 1042, _1: 7296 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS837 = { _0: 7296, _1: 1074 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS838 = { _0: 1075, _1: 1043 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS839 = { _0: 1043, _1: 1075 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS840 = { _0: 1076, _1: 1044 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS841 = { _0: 1044, _1: 7297 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS842 = { _0: 7297, _1: 1076 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS843 = { _0: 1077, _1: 1045 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS844 = { _0: 1045, _1: 1077 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS845 = { _0: 1078, _1: 1046 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS846 = { _0: 1046, _1: 1078 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS847 = { _0: 1079, _1: 1047 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS848 = { _0: 1047, _1: 1079 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS849 = { _0: 1080, _1: 1048 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS850 = { _0: 1048, _1: 1080 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS851 = { _0: 1081, _1: 1049 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS852 = { _0: 1049, _1: 1081 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS853 = { _0: 1082, _1: 1050 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS854 = { _0: 1050, _1: 1082 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS855 = { _0: 1083, _1: 1051 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS856 = { _0: 1051, _1: 1083 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS857 = { _0: 1084, _1: 1052 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS858 = { _0: 1052, _1: 1084 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS859 = { _0: 1085, _1: 1053 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS860 = { _0: 1053, _1: 1085 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS861 = { _0: 1086, _1: 1054 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS862 = { _0: 1054, _1: 7298 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS863 = { _0: 7298, _1: 1086 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS864 = { _0: 1087, _1: 1055 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS865 = { _0: 1055, _1: 1087 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS866 = { _0: 1088, _1: 1056 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS867 = { _0: 1056, _1: 1088 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS868 = { _0: 1089, _1: 1057 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS869 = { _0: 1057, _1: 7299 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS870 = { _0: 7299, _1: 1089 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS871 = { _0: 1090, _1: 1058 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS872 = { _0: 1058, _1: 7300 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS873 = { _0: 7300, _1: 7301 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS874 = { _0: 7301, _1: 1090 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS875 = { _0: 1091, _1: 1059 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS876 = { _0: 1059, _1: 1091 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS877 = { _0: 1092, _1: 1060 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS878 = { _0: 1060, _1: 1092 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS879 = { _0: 1093, _1: 1061 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS880 = { _0: 1061, _1: 1093 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS881 = { _0: 1094, _1: 1062 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS882 = { _0: 1062, _1: 1094 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS883 = { _0: 1095, _1: 1063 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS884 = { _0: 1063, _1: 1095 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS885 = { _0: 1096, _1: 1064 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS886 = { _0: 1064, _1: 1096 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS887 = { _0: 1097, _1: 1065 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS888 = { _0: 1065, _1: 1097 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS889 = { _0: 1098, _1: 1066 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS890 = { _0: 1066, _1: 7302 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS891 = { _0: 7302, _1: 1098 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS892 = { _0: 1099, _1: 1067 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS893 = { _0: 1067, _1: 1099 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS894 = { _0: 1100, _1: 1068 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS895 = { _0: 1068, _1: 1100 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS896 = { _0: 1101, _1: 1069 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS897 = { _0: 1069, _1: 1101 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS898 = { _0: 1102, _1: 1070 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS899 = { _0: 1070, _1: 1102 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS900 = { _0: 1103, _1: 1071 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS901 = { _0: 1071, _1: 1103 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS902 = { _0: 1121, _1: 1120 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS903 = { _0: 1120, _1: 1121 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS904 = { _0: 1123, _1: 1122 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS905 = { _0: 1122, _1: 7303 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS906 = { _0: 7303, _1: 1123 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS907 = { _0: 1125, _1: 1124 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS908 = { _0: 1124, _1: 1125 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS909 = { _0: 1127, _1: 1126 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS910 = { _0: 1126, _1: 1127 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS911 = { _0: 1129, _1: 1128 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS912 = { _0: 1128, _1: 1129 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS913 = { _0: 1131, _1: 1130 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS914 = { _0: 1130, _1: 1131 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS915 = { _0: 1133, _1: 1132 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS916 = { _0: 1132, _1: 1133 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS917 = { _0: 1135, _1: 1134 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS918 = { _0: 1134, _1: 1135 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS919 = { _0: 1137, _1: 1136 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS920 = { _0: 1136, _1: 1137 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS921 = { _0: 1139, _1: 1138 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS922 = { _0: 1138, _1: 1139 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS923 = { _0: 1141, _1: 1140 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS924 = { _0: 1140, _1: 1141 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS925 = { _0: 1143, _1: 1142 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS926 = { _0: 1142, _1: 1143 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS927 = { _0: 1145, _1: 1144 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS928 = { _0: 1144, _1: 1145 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS929 = { _0: 1147, _1: 1146 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS930 = { _0: 1146, _1: 1147 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS931 = { _0: 1149, _1: 1148 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS932 = { _0: 1148, _1: 1149 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS933 = { _0: 1151, _1: 1150 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS934 = { _0: 1150, _1: 1151 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS935 = { _0: 1153, _1: 1152 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS936 = { _0: 1152, _1: 1153 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS937 = { _0: 1163, _1: 1162 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS938 = { _0: 1162, _1: 1163 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS939 = { _0: 1165, _1: 1164 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS940 = { _0: 1164, _1: 1165 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS941 = { _0: 1167, _1: 1166 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS942 = { _0: 1166, _1: 1167 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS943 = { _0: 1169, _1: 1168 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS944 = { _0: 1168, _1: 1169 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS945 = { _0: 1171, _1: 1170 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS946 = { _0: 1170, _1: 1171 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS947 = { _0: 1173, _1: 1172 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS948 = { _0: 1172, _1: 1173 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS949 = { _0: 1175, _1: 1174 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS950 = { _0: 1174, _1: 1175 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS951 = { _0: 1177, _1: 1176 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS952 = { _0: 1176, _1: 1177 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS953 = { _0: 1179, _1: 1178 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS954 = { _0: 1178, _1: 1179 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS955 = { _0: 1181, _1: 1180 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS956 = { _0: 1180, _1: 1181 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS957 = { _0: 1183, _1: 1182 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS958 = { _0: 1182, _1: 1183 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS959 = { _0: 1185, _1: 1184 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS960 = { _0: 1184, _1: 1185 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS961 = { _0: 1187, _1: 1186 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS962 = { _0: 1186, _1: 1187 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS963 = { _0: 1189, _1: 1188 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS964 = { _0: 1188, _1: 1189 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS965 = { _0: 1191, _1: 1190 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS966 = { _0: 1190, _1: 1191 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS967 = { _0: 1193, _1: 1192 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS968 = { _0: 1192, _1: 1193 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS969 = { _0: 1195, _1: 1194 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS970 = { _0: 1194, _1: 1195 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS971 = { _0: 1197, _1: 1196 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS972 = { _0: 1196, _1: 1197 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS973 = { _0: 1199, _1: 1198 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS974 = { _0: 1198, _1: 1199 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS975 = { _0: 1201, _1: 1200 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS976 = { _0: 1200, _1: 1201 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS977 = { _0: 1203, _1: 1202 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS978 = { _0: 1202, _1: 1203 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS979 = { _0: 1205, _1: 1204 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS980 = { _0: 1204, _1: 1205 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS981 = { _0: 1207, _1: 1206 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS982 = { _0: 1206, _1: 1207 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS983 = { _0: 1209, _1: 1208 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS984 = { _0: 1208, _1: 1209 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS985 = { _0: 1211, _1: 1210 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS986 = { _0: 1210, _1: 1211 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS987 = { _0: 1213, _1: 1212 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS988 = { _0: 1212, _1: 1213 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS989 = { _0: 1215, _1: 1214 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS990 = { _0: 1214, _1: 1215 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS991 = { _0: 1231, _1: 1216 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS992 = { _0: 1216, _1: 1231 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS993 = { _0: 1218, _1: 1217 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS994 = { _0: 1217, _1: 1218 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS995 = { _0: 1220, _1: 1219 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS996 = { _0: 1219, _1: 1220 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS997 = { _0: 1222, _1: 1221 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS998 = { _0: 1221, _1: 1222 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS999 = { _0: 1224, _1: 1223 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1000 = { _0: 1223, _1: 1224 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1001 = { _0: 1226, _1: 1225 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1002 = { _0: 1225, _1: 1226 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1003 = { _0: 1228, _1: 1227 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1004 = { _0: 1227, _1: 1228 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1005 = { _0: 1230, _1: 1229 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1006 = { _0: 1229, _1: 1230 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1007 = { _0: 1233, _1: 1232 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1008 = { _0: 1232, _1: 1233 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1009 = { _0: 1235, _1: 1234 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1010 = { _0: 1234, _1: 1235 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1011 = { _0: 1237, _1: 1236 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1012 = { _0: 1236, _1: 1237 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1013 = { _0: 1239, _1: 1238 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1014 = { _0: 1238, _1: 1239 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1015 = { _0: 1241, _1: 1240 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1016 = { _0: 1240, _1: 1241 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1017 = { _0: 1243, _1: 1242 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1018 = { _0: 1242, _1: 1243 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1019 = { _0: 1245, _1: 1244 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1020 = { _0: 1244, _1: 1245 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1021 = { _0: 1247, _1: 1246 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1022 = { _0: 1246, _1: 1247 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1023 = { _0: 1249, _1: 1248 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1024 = { _0: 1248, _1: 1249 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1025 = { _0: 1251, _1: 1250 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1026 = { _0: 1250, _1: 1251 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1027 = { _0: 1253, _1: 1252 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1028 = { _0: 1252, _1: 1253 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1029 = { _0: 1255, _1: 1254 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1030 = { _0: 1254, _1: 1255 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1031 = { _0: 1257, _1: 1256 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1032 = { _0: 1256, _1: 1257 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1033 = { _0: 1259, _1: 1258 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1034 = { _0: 1258, _1: 1259 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1035 = { _0: 1261, _1: 1260 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1036 = { _0: 1260, _1: 1261 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1037 = { _0: 1263, _1: 1262 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1038 = { _0: 1262, _1: 1263 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1039 = { _0: 1265, _1: 1264 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1040 = { _0: 1264, _1: 1265 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1041 = { _0: 1267, _1: 1266 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1042 = { _0: 1266, _1: 1267 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1043 = { _0: 1269, _1: 1268 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1044 = { _0: 1268, _1: 1269 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1045 = { _0: 1271, _1: 1270 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1046 = { _0: 1270, _1: 1271 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1047 = { _0: 1273, _1: 1272 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1048 = { _0: 1272, _1: 1273 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1049 = { _0: 1275, _1: 1274 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1050 = { _0: 1274, _1: 1275 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1051 = { _0: 1277, _1: 1276 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1052 = { _0: 1276, _1: 1277 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1053 = { _0: 1279, _1: 1278 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1054 = { _0: 1278, _1: 1279 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1055 = { _0: 1281, _1: 1280 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1056 = { _0: 1280, _1: 1281 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1057 = { _0: 1283, _1: 1282 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1058 = { _0: 1282, _1: 1283 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1059 = { _0: 1285, _1: 1284 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1060 = { _0: 1284, _1: 1285 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1061 = { _0: 1287, _1: 1286 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1062 = { _0: 1286, _1: 1287 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1063 = { _0: 1289, _1: 1288 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1064 = { _0: 1288, _1: 1289 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1065 = { _0: 1291, _1: 1290 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1066 = { _0: 1290, _1: 1291 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1067 = { _0: 1293, _1: 1292 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1068 = { _0: 1292, _1: 1293 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1069 = { _0: 1295, _1: 1294 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1070 = { _0: 1294, _1: 1295 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1071 = { _0: 1297, _1: 1296 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1072 = { _0: 1296, _1: 1297 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1073 = { _0: 1299, _1: 1298 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1074 = { _0: 1298, _1: 1299 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1075 = { _0: 1301, _1: 1300 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1076 = { _0: 1300, _1: 1301 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1077 = { _0: 1303, _1: 1302 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1078 = { _0: 1302, _1: 1303 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1079 = { _0: 1305, _1: 1304 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1080 = { _0: 1304, _1: 1305 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1081 = { _0: 1307, _1: 1306 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1082 = { _0: 1306, _1: 1307 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1083 = { _0: 1309, _1: 1308 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1084 = { _0: 1308, _1: 1309 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1085 = { _0: 1311, _1: 1310 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1086 = { _0: 1310, _1: 1311 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1087 = { _0: 1313, _1: 1312 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1088 = { _0: 1312, _1: 1313 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1089 = { _0: 1315, _1: 1314 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1090 = { _0: 1314, _1: 1315 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1091 = { _0: 1317, _1: 1316 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1092 = { _0: 1316, _1: 1317 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1093 = { _0: 1319, _1: 1318 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1094 = { _0: 1318, _1: 1319 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1095 = { _0: 1321, _1: 1320 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1096 = { _0: 1320, _1: 1321 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1097 = { _0: 1323, _1: 1322 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1098 = { _0: 1322, _1: 1323 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1099 = { _0: 1325, _1: 1324 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1100 = { _0: 1324, _1: 1325 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1101 = { _0: 1327, _1: 1326 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1102 = { _0: 1326, _1: 1327 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1103 = { _0: 1377, _1: 1329 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1104 = { _0: 1329, _1: 1377 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1105 = { _0: 1378, _1: 1330 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1106 = { _0: 1330, _1: 1378 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1107 = { _0: 1379, _1: 1331 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1108 = { _0: 1331, _1: 1379 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1109 = { _0: 1380, _1: 1332 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1110 = { _0: 1332, _1: 1380 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1111 = { _0: 1381, _1: 1333 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1112 = { _0: 1333, _1: 1381 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1113 = { _0: 1382, _1: 1334 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1114 = { _0: 1334, _1: 1382 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1115 = { _0: 1383, _1: 1335 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1116 = { _0: 1335, _1: 1383 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1117 = { _0: 1384, _1: 1336 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1118 = { _0: 1336, _1: 1384 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1119 = { _0: 1385, _1: 1337 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1120 = { _0: 1337, _1: 1385 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1121 = { _0: 1386, _1: 1338 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1122 = { _0: 1338, _1: 1386 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1123 = { _0: 1387, _1: 1339 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1124 = { _0: 1339, _1: 1387 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1125 = { _0: 1388, _1: 1340 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1126 = { _0: 1340, _1: 1388 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1127 = { _0: 1389, _1: 1341 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1128 = { _0: 1341, _1: 1389 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1129 = { _0: 1390, _1: 1342 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1130 = { _0: 1342, _1: 1390 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1131 = { _0: 1391, _1: 1343 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1132 = { _0: 1343, _1: 1391 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1133 = { _0: 1392, _1: 1344 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1134 = { _0: 1344, _1: 1392 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1135 = { _0: 1393, _1: 1345 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1136 = { _0: 1345, _1: 1393 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1137 = { _0: 1394, _1: 1346 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1138 = { _0: 1346, _1: 1394 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1139 = { _0: 1395, _1: 1347 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1140 = { _0: 1347, _1: 1395 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1141 = { _0: 1396, _1: 1348 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1142 = { _0: 1348, _1: 1396 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1143 = { _0: 1397, _1: 1349 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1144 = { _0: 1349, _1: 1397 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1145 = { _0: 1398, _1: 1350 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1146 = { _0: 1350, _1: 1398 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1147 = { _0: 1399, _1: 1351 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1148 = { _0: 1351, _1: 1399 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1149 = { _0: 1400, _1: 1352 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1150 = { _0: 1352, _1: 1400 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1151 = { _0: 1401, _1: 1353 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1152 = { _0: 1353, _1: 1401 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1153 = { _0: 1402, _1: 1354 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1154 = { _0: 1354, _1: 1402 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1155 = { _0: 1403, _1: 1355 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1156 = { _0: 1355, _1: 1403 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1157 = { _0: 1404, _1: 1356 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1158 = { _0: 1356, _1: 1404 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1159 = { _0: 1405, _1: 1357 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1160 = { _0: 1357, _1: 1405 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1161 = { _0: 1406, _1: 1358 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1162 = { _0: 1358, _1: 1406 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1163 = { _0: 1407, _1: 1359 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1164 = { _0: 1359, _1: 1407 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1165 = { _0: 1408, _1: 1360 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1166 = { _0: 1360, _1: 1408 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1167 = { _0: 1409, _1: 1361 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1168 = { _0: 1361, _1: 1409 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1169 = { _0: 1410, _1: 1362 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1170 = { _0: 1362, _1: 1410 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1171 = { _0: 1411, _1: 1363 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1172 = { _0: 1363, _1: 1411 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1173 = { _0: 1412, _1: 1364 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1174 = { _0: 1364, _1: 1412 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1175 = { _0: 1413, _1: 1365 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1176 = { _0: 1365, _1: 1413 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1177 = { _0: 1414, _1: 1366 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1178 = { _0: 1366, _1: 1414 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1179 = { _0: 11520, _1: 4256 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1180 = { _0: 4256, _1: 11520 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1181 = { _0: 11521, _1: 4257 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1182 = { _0: 4257, _1: 11521 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1183 = { _0: 11522, _1: 4258 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1184 = { _0: 4258, _1: 11522 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1185 = { _0: 11523, _1: 4259 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1186 = { _0: 4259, _1: 11523 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1187 = { _0: 11524, _1: 4260 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1188 = { _0: 4260, _1: 11524 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1189 = { _0: 11525, _1: 4261 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1190 = { _0: 4261, _1: 11525 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1191 = { _0: 11526, _1: 4262 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1192 = { _0: 4262, _1: 11526 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1193 = { _0: 11527, _1: 4263 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1194 = { _0: 4263, _1: 11527 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1195 = { _0: 11528, _1: 4264 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1196 = { _0: 4264, _1: 11528 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1197 = { _0: 11529, _1: 4265 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1198 = { _0: 4265, _1: 11529 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1199 = { _0: 11530, _1: 4266 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1200 = { _0: 4266, _1: 11530 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1201 = { _0: 11531, _1: 4267 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1202 = { _0: 4267, _1: 11531 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1203 = { _0: 11532, _1: 4268 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1204 = { _0: 4268, _1: 11532 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1205 = { _0: 11533, _1: 4269 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1206 = { _0: 4269, _1: 11533 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1207 = { _0: 11534, _1: 4270 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1208 = { _0: 4270, _1: 11534 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1209 = { _0: 11535, _1: 4271 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1210 = { _0: 4271, _1: 11535 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1211 = { _0: 11536, _1: 4272 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1212 = { _0: 4272, _1: 11536 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1213 = { _0: 11537, _1: 4273 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1214 = { _0: 4273, _1: 11537 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1215 = { _0: 11538, _1: 4274 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1216 = { _0: 4274, _1: 11538 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1217 = { _0: 11539, _1: 4275 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1218 = { _0: 4275, _1: 11539 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1219 = { _0: 11540, _1: 4276 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1220 = { _0: 4276, _1: 11540 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1221 = { _0: 11541, _1: 4277 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1222 = { _0: 4277, _1: 11541 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1223 = { _0: 11542, _1: 4278 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1224 = { _0: 4278, _1: 11542 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1225 = { _0: 11543, _1: 4279 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1226 = { _0: 4279, _1: 11543 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1227 = { _0: 11544, _1: 4280 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1228 = { _0: 4280, _1: 11544 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1229 = { _0: 11545, _1: 4281 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1230 = { _0: 4281, _1: 11545 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1231 = { _0: 11546, _1: 4282 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1232 = { _0: 4282, _1: 11546 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1233 = { _0: 11547, _1: 4283 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1234 = { _0: 4283, _1: 11547 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1235 = { _0: 11548, _1: 4284 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1236 = { _0: 4284, _1: 11548 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1237 = { _0: 11549, _1: 4285 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1238 = { _0: 4285, _1: 11549 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1239 = { _0: 11550, _1: 4286 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1240 = { _0: 4286, _1: 11550 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1241 = { _0: 11551, _1: 4287 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1242 = { _0: 4287, _1: 11551 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1243 = { _0: 11552, _1: 4288 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1244 = { _0: 4288, _1: 11552 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1245 = { _0: 11553, _1: 4289 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1246 = { _0: 4289, _1: 11553 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1247 = { _0: 11554, _1: 4290 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1248 = { _0: 4290, _1: 11554 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1249 = { _0: 11555, _1: 4291 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1250 = { _0: 4291, _1: 11555 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1251 = { _0: 11556, _1: 4292 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1252 = { _0: 4292, _1: 11556 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1253 = { _0: 11557, _1: 4293 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1254 = { _0: 4293, _1: 11557 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1255 = { _0: 11559, _1: 4295 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1256 = { _0: 4295, _1: 11559 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1257 = { _0: 11565, _1: 4301 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1258 = { _0: 4301, _1: 11565 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1259 = { _0: 5104, _1: 5112 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1260 = { _0: 5112, _1: 5104 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1261 = { _0: 5105, _1: 5113 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1262 = { _0: 5113, _1: 5105 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1263 = { _0: 5106, _1: 5114 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1264 = { _0: 5114, _1: 5106 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1265 = { _0: 5107, _1: 5115 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1266 = { _0: 5115, _1: 5107 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1267 = { _0: 5108, _1: 5116 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1268 = { _0: 5116, _1: 5108 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1269 = { _0: 5109, _1: 5117 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1270 = { _0: 5117, _1: 5109 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1271 = { _0: 42571, _1: 7304 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1272 = { _0: 7304, _1: 42570 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1273 = { _0: 42570, _1: 42571 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1274 = { _0: 7306, _1: 7305 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1275 = { _0: 7305, _1: 7306 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1276 = { _0: 4304, _1: 7312 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1277 = { _0: 7312, _1: 4304 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1278 = { _0: 4305, _1: 7313 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1279 = { _0: 7313, _1: 4305 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1280 = { _0: 4306, _1: 7314 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1281 = { _0: 7314, _1: 4306 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1282 = { _0: 4307, _1: 7315 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1283 = { _0: 7315, _1: 4307 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1284 = { _0: 4308, _1: 7316 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1285 = { _0: 7316, _1: 4308 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1286 = { _0: 4309, _1: 7317 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1287 = { _0: 7317, _1: 4309 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1288 = { _0: 4310, _1: 7318 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1289 = { _0: 7318, _1: 4310 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1290 = { _0: 4311, _1: 7319 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1291 = { _0: 7319, _1: 4311 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1292 = { _0: 4312, _1: 7320 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1293 = { _0: 7320, _1: 4312 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1294 = { _0: 4313, _1: 7321 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1295 = { _0: 7321, _1: 4313 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1296 = { _0: 4314, _1: 7322 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1297 = { _0: 7322, _1: 4314 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1298 = { _0: 4315, _1: 7323 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1299 = { _0: 7323, _1: 4315 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1300 = { _0: 4316, _1: 7324 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1301 = { _0: 7324, _1: 4316 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1302 = { _0: 4317, _1: 7325 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1303 = { _0: 7325, _1: 4317 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1304 = { _0: 4318, _1: 7326 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1305 = { _0: 7326, _1: 4318 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1306 = { _0: 4319, _1: 7327 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1307 = { _0: 7327, _1: 4319 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1308 = { _0: 4320, _1: 7328 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1309 = { _0: 7328, _1: 4320 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1310 = { _0: 4321, _1: 7329 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1311 = { _0: 7329, _1: 4321 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1312 = { _0: 4322, _1: 7330 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1313 = { _0: 7330, _1: 4322 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1314 = { _0: 4323, _1: 7331 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1315 = { _0: 7331, _1: 4323 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1316 = { _0: 4324, _1: 7332 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1317 = { _0: 7332, _1: 4324 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1318 = { _0: 4325, _1: 7333 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1319 = { _0: 7333, _1: 4325 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1320 = { _0: 4326, _1: 7334 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1321 = { _0: 7334, _1: 4326 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1322 = { _0: 4327, _1: 7335 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1323 = { _0: 7335, _1: 4327 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1324 = { _0: 4328, _1: 7336 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1325 = { _0: 7336, _1: 4328 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1326 = { _0: 4329, _1: 7337 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1327 = { _0: 7337, _1: 4329 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1328 = { _0: 4330, _1: 7338 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1329 = { _0: 7338, _1: 4330 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1330 = { _0: 4331, _1: 7339 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1331 = { _0: 7339, _1: 4331 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1332 = { _0: 4332, _1: 7340 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1333 = { _0: 7340, _1: 4332 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1334 = { _0: 4333, _1: 7341 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1335 = { _0: 7341, _1: 4333 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1336 = { _0: 4334, _1: 7342 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1337 = { _0: 7342, _1: 4334 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1338 = { _0: 4335, _1: 7343 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1339 = { _0: 7343, _1: 4335 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1340 = { _0: 4336, _1: 7344 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1341 = { _0: 7344, _1: 4336 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1342 = { _0: 4337, _1: 7345 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1343 = { _0: 7345, _1: 4337 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1344 = { _0: 4338, _1: 7346 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1345 = { _0: 7346, _1: 4338 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1346 = { _0: 4339, _1: 7347 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1347 = { _0: 7347, _1: 4339 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1348 = { _0: 4340, _1: 7348 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1349 = { _0: 7348, _1: 4340 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1350 = { _0: 4341, _1: 7349 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1351 = { _0: 7349, _1: 4341 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1352 = { _0: 4342, _1: 7350 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1353 = { _0: 7350, _1: 4342 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1354 = { _0: 4343, _1: 7351 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1355 = { _0: 7351, _1: 4343 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1356 = { _0: 4344, _1: 7352 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1357 = { _0: 7352, _1: 4344 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1358 = { _0: 4345, _1: 7353 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1359 = { _0: 7353, _1: 4345 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1360 = { _0: 4346, _1: 7354 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1361 = { _0: 7354, _1: 4346 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1362 = { _0: 4349, _1: 7357 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1363 = { _0: 7357, _1: 4349 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1364 = { _0: 4350, _1: 7358 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1365 = { _0: 7358, _1: 4350 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1366 = { _0: 4351, _1: 7359 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1367 = { _0: 7359, _1: 4351 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1368 = { _0: 7681, _1: 7680 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1369 = { _0: 7680, _1: 7681 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1370 = { _0: 7683, _1: 7682 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1371 = { _0: 7682, _1: 7683 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1372 = { _0: 7685, _1: 7684 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1373 = { _0: 7684, _1: 7685 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1374 = { _0: 7687, _1: 7686 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1375 = { _0: 7686, _1: 7687 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1376 = { _0: 7689, _1: 7688 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1377 = { _0: 7688, _1: 7689 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1378 = { _0: 7691, _1: 7690 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1379 = { _0: 7690, _1: 7691 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1380 = { _0: 7693, _1: 7692 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1381 = { _0: 7692, _1: 7693 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1382 = { _0: 7695, _1: 7694 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1383 = { _0: 7694, _1: 7695 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1384 = { _0: 7697, _1: 7696 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1385 = { _0: 7696, _1: 7697 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1386 = { _0: 7699, _1: 7698 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1387 = { _0: 7698, _1: 7699 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1388 = { _0: 7701, _1: 7700 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1389 = { _0: 7700, _1: 7701 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1390 = { _0: 7703, _1: 7702 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1391 = { _0: 7702, _1: 7703 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1392 = { _0: 7705, _1: 7704 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1393 = { _0: 7704, _1: 7705 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1394 = { _0: 7707, _1: 7706 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1395 = { _0: 7706, _1: 7707 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1396 = { _0: 7709, _1: 7708 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1397 = { _0: 7708, _1: 7709 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1398 = { _0: 7711, _1: 7710 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1399 = { _0: 7710, _1: 7711 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1400 = { _0: 7713, _1: 7712 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1401 = { _0: 7712, _1: 7713 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1402 = { _0: 7715, _1: 7714 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1403 = { _0: 7714, _1: 7715 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1404 = { _0: 7717, _1: 7716 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1405 = { _0: 7716, _1: 7717 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1406 = { _0: 7719, _1: 7718 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1407 = { _0: 7718, _1: 7719 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1408 = { _0: 7721, _1: 7720 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1409 = { _0: 7720, _1: 7721 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1410 = { _0: 7723, _1: 7722 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1411 = { _0: 7722, _1: 7723 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1412 = { _0: 7725, _1: 7724 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1413 = { _0: 7724, _1: 7725 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1414 = { _0: 7727, _1: 7726 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1415 = { _0: 7726, _1: 7727 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1416 = { _0: 7729, _1: 7728 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1417 = { _0: 7728, _1: 7729 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1418 = { _0: 7731, _1: 7730 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1419 = { _0: 7730, _1: 7731 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1420 = { _0: 7733, _1: 7732 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1421 = { _0: 7732, _1: 7733 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1422 = { _0: 7735, _1: 7734 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1423 = { _0: 7734, _1: 7735 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1424 = { _0: 7737, _1: 7736 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1425 = { _0: 7736, _1: 7737 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1426 = { _0: 7739, _1: 7738 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1427 = { _0: 7738, _1: 7739 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1428 = { _0: 7741, _1: 7740 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1429 = { _0: 7740, _1: 7741 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1430 = { _0: 7743, _1: 7742 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1431 = { _0: 7742, _1: 7743 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1432 = { _0: 7745, _1: 7744 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1433 = { _0: 7744, _1: 7745 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1434 = { _0: 7747, _1: 7746 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1435 = { _0: 7746, _1: 7747 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1436 = { _0: 7749, _1: 7748 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1437 = { _0: 7748, _1: 7749 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1438 = { _0: 7751, _1: 7750 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1439 = { _0: 7750, _1: 7751 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1440 = { _0: 7753, _1: 7752 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1441 = { _0: 7752, _1: 7753 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1442 = { _0: 7755, _1: 7754 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1443 = { _0: 7754, _1: 7755 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1444 = { _0: 7757, _1: 7756 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1445 = { _0: 7756, _1: 7757 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1446 = { _0: 7759, _1: 7758 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1447 = { _0: 7758, _1: 7759 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1448 = { _0: 7761, _1: 7760 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1449 = { _0: 7760, _1: 7761 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1450 = { _0: 7763, _1: 7762 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1451 = { _0: 7762, _1: 7763 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1452 = { _0: 7765, _1: 7764 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1453 = { _0: 7764, _1: 7765 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1454 = { _0: 7767, _1: 7766 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1455 = { _0: 7766, _1: 7767 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1456 = { _0: 7769, _1: 7768 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1457 = { _0: 7768, _1: 7769 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1458 = { _0: 7771, _1: 7770 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1459 = { _0: 7770, _1: 7771 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1460 = { _0: 7773, _1: 7772 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1461 = { _0: 7772, _1: 7773 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1462 = { _0: 7775, _1: 7774 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1463 = { _0: 7774, _1: 7775 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1464 = { _0: 7777, _1: 7776 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1465 = { _0: 7776, _1: 7835 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1466 = { _0: 7835, _1: 7777 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1467 = { _0: 7779, _1: 7778 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1468 = { _0: 7778, _1: 7779 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1469 = { _0: 7781, _1: 7780 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1470 = { _0: 7780, _1: 7781 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1471 = { _0: 7783, _1: 7782 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1472 = { _0: 7782, _1: 7783 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1473 = { _0: 7785, _1: 7784 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1474 = { _0: 7784, _1: 7785 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1475 = { _0: 7787, _1: 7786 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1476 = { _0: 7786, _1: 7787 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1477 = { _0: 7789, _1: 7788 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1478 = { _0: 7788, _1: 7789 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1479 = { _0: 7791, _1: 7790 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1480 = { _0: 7790, _1: 7791 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1481 = { _0: 7793, _1: 7792 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1482 = { _0: 7792, _1: 7793 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1483 = { _0: 7795, _1: 7794 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1484 = { _0: 7794, _1: 7795 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1485 = { _0: 7797, _1: 7796 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1486 = { _0: 7796, _1: 7797 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1487 = { _0: 7799, _1: 7798 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1488 = { _0: 7798, _1: 7799 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1489 = { _0: 7801, _1: 7800 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1490 = { _0: 7800, _1: 7801 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1491 = { _0: 7803, _1: 7802 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1492 = { _0: 7802, _1: 7803 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1493 = { _0: 7805, _1: 7804 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1494 = { _0: 7804, _1: 7805 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1495 = { _0: 7807, _1: 7806 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1496 = { _0: 7806, _1: 7807 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1497 = { _0: 7809, _1: 7808 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1498 = { _0: 7808, _1: 7809 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1499 = { _0: 7811, _1: 7810 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1500 = { _0: 7810, _1: 7811 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1501 = { _0: 7813, _1: 7812 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1502 = { _0: 7812, _1: 7813 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1503 = { _0: 7815, _1: 7814 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1504 = { _0: 7814, _1: 7815 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1505 = { _0: 7817, _1: 7816 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1506 = { _0: 7816, _1: 7817 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1507 = { _0: 7819, _1: 7818 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1508 = { _0: 7818, _1: 7819 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1509 = { _0: 7821, _1: 7820 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1510 = { _0: 7820, _1: 7821 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1511 = { _0: 7823, _1: 7822 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1512 = { _0: 7822, _1: 7823 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1513 = { _0: 7825, _1: 7824 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1514 = { _0: 7824, _1: 7825 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1515 = { _0: 7827, _1: 7826 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1516 = { _0: 7826, _1: 7827 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1517 = { _0: 7829, _1: 7828 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1518 = { _0: 7828, _1: 7829 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1519 = { _0: 223, _1: 7838 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1520 = { _0: 7838, _1: 223 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1521 = { _0: 7841, _1: 7840 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1522 = { _0: 7840, _1: 7841 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1523 = { _0: 7843, _1: 7842 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1524 = { _0: 7842, _1: 7843 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1525 = { _0: 7845, _1: 7844 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1526 = { _0: 7844, _1: 7845 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1527 = { _0: 7847, _1: 7846 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1528 = { _0: 7846, _1: 7847 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1529 = { _0: 7849, _1: 7848 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1530 = { _0: 7848, _1: 7849 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1531 = { _0: 7851, _1: 7850 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1532 = { _0: 7850, _1: 7851 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1533 = { _0: 7853, _1: 7852 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1534 = { _0: 7852, _1: 7853 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1535 = { _0: 7855, _1: 7854 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1536 = { _0: 7854, _1: 7855 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1537 = { _0: 7857, _1: 7856 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1538 = { _0: 7856, _1: 7857 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1539 = { _0: 7859, _1: 7858 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1540 = { _0: 7858, _1: 7859 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1541 = { _0: 7861, _1: 7860 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1542 = { _0: 7860, _1: 7861 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1543 = { _0: 7863, _1: 7862 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1544 = { _0: 7862, _1: 7863 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1545 = { _0: 7865, _1: 7864 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1546 = { _0: 7864, _1: 7865 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1547 = { _0: 7867, _1: 7866 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1548 = { _0: 7866, _1: 7867 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1549 = { _0: 7869, _1: 7868 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1550 = { _0: 7868, _1: 7869 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1551 = { _0: 7871, _1: 7870 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1552 = { _0: 7870, _1: 7871 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1553 = { _0: 7873, _1: 7872 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1554 = { _0: 7872, _1: 7873 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1555 = { _0: 7875, _1: 7874 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1556 = { _0: 7874, _1: 7875 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1557 = { _0: 7877, _1: 7876 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1558 = { _0: 7876, _1: 7877 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1559 = { _0: 7879, _1: 7878 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1560 = { _0: 7878, _1: 7879 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1561 = { _0: 7881, _1: 7880 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1562 = { _0: 7880, _1: 7881 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1563 = { _0: 7883, _1: 7882 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1564 = { _0: 7882, _1: 7883 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1565 = { _0: 7885, _1: 7884 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1566 = { _0: 7884, _1: 7885 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1567 = { _0: 7887, _1: 7886 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1568 = { _0: 7886, _1: 7887 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1569 = { _0: 7889, _1: 7888 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1570 = { _0: 7888, _1: 7889 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1571 = { _0: 7891, _1: 7890 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1572 = { _0: 7890, _1: 7891 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1573 = { _0: 7893, _1: 7892 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1574 = { _0: 7892, _1: 7893 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1575 = { _0: 7895, _1: 7894 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1576 = { _0: 7894, _1: 7895 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1577 = { _0: 7897, _1: 7896 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1578 = { _0: 7896, _1: 7897 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1579 = { _0: 7899, _1: 7898 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1580 = { _0: 7898, _1: 7899 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1581 = { _0: 7901, _1: 7900 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1582 = { _0: 7900, _1: 7901 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1583 = { _0: 7903, _1: 7902 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1584 = { _0: 7902, _1: 7903 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1585 = { _0: 7905, _1: 7904 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1586 = { _0: 7904, _1: 7905 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1587 = { _0: 7907, _1: 7906 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1588 = { _0: 7906, _1: 7907 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1589 = { _0: 7909, _1: 7908 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1590 = { _0: 7908, _1: 7909 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1591 = { _0: 7911, _1: 7910 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1592 = { _0: 7910, _1: 7911 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1593 = { _0: 7913, _1: 7912 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1594 = { _0: 7912, _1: 7913 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1595 = { _0: 7915, _1: 7914 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1596 = { _0: 7914, _1: 7915 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1597 = { _0: 7917, _1: 7916 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1598 = { _0: 7916, _1: 7917 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1599 = { _0: 7919, _1: 7918 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1600 = { _0: 7918, _1: 7919 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1601 = { _0: 7921, _1: 7920 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1602 = { _0: 7920, _1: 7921 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1603 = { _0: 7923, _1: 7922 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1604 = { _0: 7922, _1: 7923 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1605 = { _0: 7925, _1: 7924 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1606 = { _0: 7924, _1: 7925 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1607 = { _0: 7927, _1: 7926 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1608 = { _0: 7926, _1: 7927 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1609 = { _0: 7929, _1: 7928 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1610 = { _0: 7928, _1: 7929 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1611 = { _0: 7931, _1: 7930 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1612 = { _0: 7930, _1: 7931 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1613 = { _0: 7933, _1: 7932 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1614 = { _0: 7932, _1: 7933 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1615 = { _0: 7935, _1: 7934 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1616 = { _0: 7934, _1: 7935 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1617 = { _0: 7936, _1: 7944 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1618 = { _0: 7944, _1: 7936 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1619 = { _0: 7937, _1: 7945 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1620 = { _0: 7945, _1: 7937 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1621 = { _0: 7938, _1: 7946 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1622 = { _0: 7946, _1: 7938 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1623 = { _0: 7939, _1: 7947 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1624 = { _0: 7947, _1: 7939 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1625 = { _0: 7940, _1: 7948 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1626 = { _0: 7948, _1: 7940 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1627 = { _0: 7941, _1: 7949 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1628 = { _0: 7949, _1: 7941 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1629 = { _0: 7942, _1: 7950 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1630 = { _0: 7950, _1: 7942 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1631 = { _0: 7943, _1: 7951 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1632 = { _0: 7951, _1: 7943 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1633 = { _0: 7952, _1: 7960 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1634 = { _0: 7960, _1: 7952 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1635 = { _0: 7953, _1: 7961 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1636 = { _0: 7961, _1: 7953 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1637 = { _0: 7954, _1: 7962 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1638 = { _0: 7962, _1: 7954 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1639 = { _0: 7955, _1: 7963 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1640 = { _0: 7963, _1: 7955 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1641 = { _0: 7956, _1: 7964 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1642 = { _0: 7964, _1: 7956 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1643 = { _0: 7957, _1: 7965 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1644 = { _0: 7965, _1: 7957 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1645 = { _0: 7968, _1: 7976 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1646 = { _0: 7976, _1: 7968 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1647 = { _0: 7969, _1: 7977 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1648 = { _0: 7977, _1: 7969 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1649 = { _0: 7970, _1: 7978 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1650 = { _0: 7978, _1: 7970 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1651 = { _0: 7971, _1: 7979 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1652 = { _0: 7979, _1: 7971 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1653 = { _0: 7972, _1: 7980 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1654 = { _0: 7980, _1: 7972 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1655 = { _0: 7973, _1: 7981 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1656 = { _0: 7981, _1: 7973 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1657 = { _0: 7974, _1: 7982 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1658 = { _0: 7982, _1: 7974 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1659 = { _0: 7975, _1: 7983 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1660 = { _0: 7983, _1: 7975 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1661 = { _0: 7984, _1: 7992 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1662 = { _0: 7992, _1: 7984 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1663 = { _0: 7985, _1: 7993 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1664 = { _0: 7993, _1: 7985 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1665 = { _0: 7986, _1: 7994 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1666 = { _0: 7994, _1: 7986 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1667 = { _0: 7987, _1: 7995 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1668 = { _0: 7995, _1: 7987 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1669 = { _0: 7988, _1: 7996 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1670 = { _0: 7996, _1: 7988 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1671 = { _0: 7989, _1: 7997 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1672 = { _0: 7997, _1: 7989 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1673 = { _0: 7990, _1: 7998 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1674 = { _0: 7998, _1: 7990 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1675 = { _0: 7991, _1: 7999 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1676 = { _0: 7999, _1: 7991 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1677 = { _0: 8000, _1: 8008 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1678 = { _0: 8008, _1: 8000 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1679 = { _0: 8001, _1: 8009 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1680 = { _0: 8009, _1: 8001 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1681 = { _0: 8002, _1: 8010 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1682 = { _0: 8010, _1: 8002 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1683 = { _0: 8003, _1: 8011 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1684 = { _0: 8011, _1: 8003 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1685 = { _0: 8004, _1: 8012 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1686 = { _0: 8012, _1: 8004 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1687 = { _0: 8005, _1: 8013 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1688 = { _0: 8013, _1: 8005 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1689 = { _0: 8017, _1: 8025 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1690 = { _0: 8025, _1: 8017 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1691 = { _0: 8019, _1: 8027 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1692 = { _0: 8027, _1: 8019 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1693 = { _0: 8021, _1: 8029 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1694 = { _0: 8029, _1: 8021 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1695 = { _0: 8023, _1: 8031 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1696 = { _0: 8031, _1: 8023 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1697 = { _0: 8032, _1: 8040 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1698 = { _0: 8040, _1: 8032 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1699 = { _0: 8033, _1: 8041 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1700 = { _0: 8041, _1: 8033 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1701 = { _0: 8034, _1: 8042 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1702 = { _0: 8042, _1: 8034 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1703 = { _0: 8035, _1: 8043 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1704 = { _0: 8043, _1: 8035 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1705 = { _0: 8036, _1: 8044 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1706 = { _0: 8044, _1: 8036 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1707 = { _0: 8037, _1: 8045 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1708 = { _0: 8045, _1: 8037 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1709 = { _0: 8038, _1: 8046 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1710 = { _0: 8046, _1: 8038 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1711 = { _0: 8039, _1: 8047 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1712 = { _0: 8047, _1: 8039 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1713 = { _0: 8064, _1: 8072 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1714 = { _0: 8072, _1: 8064 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1715 = { _0: 8065, _1: 8073 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1716 = { _0: 8073, _1: 8065 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1717 = { _0: 8066, _1: 8074 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1718 = { _0: 8074, _1: 8066 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1719 = { _0: 8067, _1: 8075 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1720 = { _0: 8075, _1: 8067 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1721 = { _0: 8068, _1: 8076 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1722 = { _0: 8076, _1: 8068 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1723 = { _0: 8069, _1: 8077 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1724 = { _0: 8077, _1: 8069 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1725 = { _0: 8070, _1: 8078 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1726 = { _0: 8078, _1: 8070 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1727 = { _0: 8071, _1: 8079 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1728 = { _0: 8079, _1: 8071 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1729 = { _0: 8080, _1: 8088 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1730 = { _0: 8088, _1: 8080 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1731 = { _0: 8081, _1: 8089 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1732 = { _0: 8089, _1: 8081 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1733 = { _0: 8082, _1: 8090 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1734 = { _0: 8090, _1: 8082 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1735 = { _0: 8083, _1: 8091 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1736 = { _0: 8091, _1: 8083 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1737 = { _0: 8084, _1: 8092 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1738 = { _0: 8092, _1: 8084 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1739 = { _0: 8085, _1: 8093 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1740 = { _0: 8093, _1: 8085 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1741 = { _0: 8086, _1: 8094 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1742 = { _0: 8094, _1: 8086 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1743 = { _0: 8087, _1: 8095 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1744 = { _0: 8095, _1: 8087 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1745 = { _0: 8096, _1: 8104 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1746 = { _0: 8104, _1: 8096 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1747 = { _0: 8097, _1: 8105 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1748 = { _0: 8105, _1: 8097 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1749 = { _0: 8098, _1: 8106 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1750 = { _0: 8106, _1: 8098 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1751 = { _0: 8099, _1: 8107 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1752 = { _0: 8107, _1: 8099 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1753 = { _0: 8100, _1: 8108 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1754 = { _0: 8108, _1: 8100 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1755 = { _0: 8101, _1: 8109 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1756 = { _0: 8109, _1: 8101 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1757 = { _0: 8102, _1: 8110 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1758 = { _0: 8110, _1: 8102 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1759 = { _0: 8103, _1: 8111 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1760 = { _0: 8111, _1: 8103 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1761 = { _0: 8112, _1: 8120 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1762 = { _0: 8120, _1: 8112 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1763 = { _0: 8113, _1: 8121 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1764 = { _0: 8121, _1: 8113 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1765 = { _0: 8048, _1: 8122 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1766 = { _0: 8122, _1: 8048 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1767 = { _0: 8049, _1: 8123 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1768 = { _0: 8123, _1: 8049 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1769 = { _0: 8115, _1: 8124 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1770 = { _0: 8124, _1: 8115 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1771 = { _0: 8050, _1: 8136 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1772 = { _0: 8136, _1: 8050 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1773 = { _0: 8051, _1: 8137 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1774 = { _0: 8137, _1: 8051 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1775 = { _0: 8052, _1: 8138 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1776 = { _0: 8138, _1: 8052 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1777 = { _0: 8053, _1: 8139 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1778 = { _0: 8139, _1: 8053 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1779 = { _0: 8131, _1: 8140 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1780 = { _0: 8140, _1: 8131 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1781 = { _0: 912, _1: 8147 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1782 = { _0: 8147, _1: 912 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1783 = { _0: 8144, _1: 8152 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1784 = { _0: 8152, _1: 8144 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1785 = { _0: 8145, _1: 8153 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1786 = { _0: 8153, _1: 8145 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1787 = { _0: 8054, _1: 8154 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1788 = { _0: 8154, _1: 8054 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1789 = { _0: 8055, _1: 8155 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1790 = { _0: 8155, _1: 8055 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1791 = { _0: 944, _1: 8163 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1792 = { _0: 8163, _1: 944 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1793 = { _0: 8160, _1: 8168 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1794 = { _0: 8168, _1: 8160 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1795 = { _0: 8161, _1: 8169 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1796 = { _0: 8169, _1: 8161 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1797 = { _0: 8058, _1: 8170 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1798 = { _0: 8170, _1: 8058 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1799 = { _0: 8059, _1: 8171 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1800 = { _0: 8171, _1: 8059 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1801 = { _0: 8165, _1: 8172 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1802 = { _0: 8172, _1: 8165 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1803 = { _0: 8056, _1: 8184 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1804 = { _0: 8184, _1: 8056 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1805 = { _0: 8057, _1: 8185 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1806 = { _0: 8185, _1: 8057 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1807 = { _0: 8060, _1: 8186 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1808 = { _0: 8186, _1: 8060 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1809 = { _0: 8061, _1: 8187 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1810 = { _0: 8187, _1: 8061 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1811 = { _0: 8179, _1: 8188 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1812 = { _0: 8188, _1: 8179 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1813 = { _0: 8526, _1: 8498 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1814 = { _0: 8498, _1: 8526 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1815 = { _0: 8560, _1: 8544 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1816 = { _0: 8544, _1: 8560 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1817 = { _0: 8561, _1: 8545 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1818 = { _0: 8545, _1: 8561 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1819 = { _0: 8562, _1: 8546 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1820 = { _0: 8546, _1: 8562 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1821 = { _0: 8563, _1: 8547 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1822 = { _0: 8547, _1: 8563 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1823 = { _0: 8564, _1: 8548 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1824 = { _0: 8548, _1: 8564 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1825 = { _0: 8565, _1: 8549 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1826 = { _0: 8549, _1: 8565 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1827 = { _0: 8566, _1: 8550 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1828 = { _0: 8550, _1: 8566 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1829 = { _0: 8567, _1: 8551 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1830 = { _0: 8551, _1: 8567 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1831 = { _0: 8568, _1: 8552 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1832 = { _0: 8552, _1: 8568 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1833 = { _0: 8569, _1: 8553 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1834 = { _0: 8553, _1: 8569 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1835 = { _0: 8570, _1: 8554 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1836 = { _0: 8554, _1: 8570 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1837 = { _0: 8571, _1: 8555 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1838 = { _0: 8555, _1: 8571 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1839 = { _0: 8572, _1: 8556 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1840 = { _0: 8556, _1: 8572 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1841 = { _0: 8573, _1: 8557 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1842 = { _0: 8557, _1: 8573 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1843 = { _0: 8574, _1: 8558 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1844 = { _0: 8558, _1: 8574 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1845 = { _0: 8575, _1: 8559 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1846 = { _0: 8559, _1: 8575 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1847 = { _0: 8580, _1: 8579 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1848 = { _0: 8579, _1: 8580 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1849 = { _0: 9424, _1: 9398 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1850 = { _0: 9398, _1: 9424 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1851 = { _0: 9425, _1: 9399 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1852 = { _0: 9399, _1: 9425 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1853 = { _0: 9426, _1: 9400 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1854 = { _0: 9400, _1: 9426 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1855 = { _0: 9427, _1: 9401 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1856 = { _0: 9401, _1: 9427 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1857 = { _0: 9428, _1: 9402 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1858 = { _0: 9402, _1: 9428 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1859 = { _0: 9429, _1: 9403 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1860 = { _0: 9403, _1: 9429 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1861 = { _0: 9430, _1: 9404 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1862 = { _0: 9404, _1: 9430 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1863 = { _0: 9431, _1: 9405 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1864 = { _0: 9405, _1: 9431 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1865 = { _0: 9432, _1: 9406 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1866 = { _0: 9406, _1: 9432 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1867 = { _0: 9433, _1: 9407 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1868 = { _0: 9407, _1: 9433 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1869 = { _0: 9434, _1: 9408 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1870 = { _0: 9408, _1: 9434 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1871 = { _0: 9435, _1: 9409 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1872 = { _0: 9409, _1: 9435 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1873 = { _0: 9436, _1: 9410 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1874 = { _0: 9410, _1: 9436 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1875 = { _0: 9437, _1: 9411 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1876 = { _0: 9411, _1: 9437 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1877 = { _0: 9438, _1: 9412 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1878 = { _0: 9412, _1: 9438 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1879 = { _0: 9439, _1: 9413 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1880 = { _0: 9413, _1: 9439 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1881 = { _0: 9440, _1: 9414 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1882 = { _0: 9414, _1: 9440 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1883 = { _0: 9441, _1: 9415 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1884 = { _0: 9415, _1: 9441 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1885 = { _0: 9442, _1: 9416 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1886 = { _0: 9416, _1: 9442 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1887 = { _0: 9443, _1: 9417 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1888 = { _0: 9417, _1: 9443 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1889 = { _0: 9444, _1: 9418 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1890 = { _0: 9418, _1: 9444 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1891 = { _0: 9445, _1: 9419 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1892 = { _0: 9419, _1: 9445 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1893 = { _0: 9446, _1: 9420 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1894 = { _0: 9420, _1: 9446 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1895 = { _0: 9447, _1: 9421 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1896 = { _0: 9421, _1: 9447 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1897 = { _0: 9448, _1: 9422 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1898 = { _0: 9422, _1: 9448 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1899 = { _0: 9449, _1: 9423 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1900 = { _0: 9423, _1: 9449 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1901 = { _0: 11312, _1: 11264 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1902 = { _0: 11264, _1: 11312 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1903 = { _0: 11313, _1: 11265 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1904 = { _0: 11265, _1: 11313 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1905 = { _0: 11314, _1: 11266 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1906 = { _0: 11266, _1: 11314 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1907 = { _0: 11315, _1: 11267 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1908 = { _0: 11267, _1: 11315 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1909 = { _0: 11316, _1: 11268 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1910 = { _0: 11268, _1: 11316 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1911 = { _0: 11317, _1: 11269 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1912 = { _0: 11269, _1: 11317 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1913 = { _0: 11318, _1: 11270 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1914 = { _0: 11270, _1: 11318 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1915 = { _0: 11319, _1: 11271 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1916 = { _0: 11271, _1: 11319 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1917 = { _0: 11320, _1: 11272 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1918 = { _0: 11272, _1: 11320 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1919 = { _0: 11321, _1: 11273 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1920 = { _0: 11273, _1: 11321 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1921 = { _0: 11322, _1: 11274 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1922 = { _0: 11274, _1: 11322 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1923 = { _0: 11323, _1: 11275 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1924 = { _0: 11275, _1: 11323 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1925 = { _0: 11324, _1: 11276 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1926 = { _0: 11276, _1: 11324 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1927 = { _0: 11325, _1: 11277 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1928 = { _0: 11277, _1: 11325 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1929 = { _0: 11326, _1: 11278 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1930 = { _0: 11278, _1: 11326 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1931 = { _0: 11327, _1: 11279 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1932 = { _0: 11279, _1: 11327 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1933 = { _0: 11328, _1: 11280 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1934 = { _0: 11280, _1: 11328 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1935 = { _0: 11329, _1: 11281 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1936 = { _0: 11281, _1: 11329 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1937 = { _0: 11330, _1: 11282 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1938 = { _0: 11282, _1: 11330 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1939 = { _0: 11331, _1: 11283 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1940 = { _0: 11283, _1: 11331 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1941 = { _0: 11332, _1: 11284 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1942 = { _0: 11284, _1: 11332 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1943 = { _0: 11333, _1: 11285 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1944 = { _0: 11285, _1: 11333 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1945 = { _0: 11334, _1: 11286 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1946 = { _0: 11286, _1: 11334 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1947 = { _0: 11335, _1: 11287 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1948 = { _0: 11287, _1: 11335 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1949 = { _0: 11336, _1: 11288 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1950 = { _0: 11288, _1: 11336 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1951 = { _0: 11337, _1: 11289 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1952 = { _0: 11289, _1: 11337 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1953 = { _0: 11338, _1: 11290 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1954 = { _0: 11290, _1: 11338 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1955 = { _0: 11339, _1: 11291 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1956 = { _0: 11291, _1: 11339 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1957 = { _0: 11340, _1: 11292 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1958 = { _0: 11292, _1: 11340 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1959 = { _0: 11341, _1: 11293 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1960 = { _0: 11293, _1: 11341 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1961 = { _0: 11342, _1: 11294 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1962 = { _0: 11294, _1: 11342 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1963 = { _0: 11343, _1: 11295 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1964 = { _0: 11295, _1: 11343 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1965 = { _0: 11344, _1: 11296 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1966 = { _0: 11296, _1: 11344 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1967 = { _0: 11345, _1: 11297 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1968 = { _0: 11297, _1: 11345 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1969 = { _0: 11346, _1: 11298 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1970 = { _0: 11298, _1: 11346 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1971 = { _0: 11347, _1: 11299 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1972 = { _0: 11299, _1: 11347 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1973 = { _0: 11348, _1: 11300 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1974 = { _0: 11300, _1: 11348 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1975 = { _0: 11349, _1: 11301 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1976 = { _0: 11301, _1: 11349 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1977 = { _0: 11350, _1: 11302 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1978 = { _0: 11302, _1: 11350 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1979 = { _0: 11351, _1: 11303 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1980 = { _0: 11303, _1: 11351 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1981 = { _0: 11352, _1: 11304 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1982 = { _0: 11304, _1: 11352 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1983 = { _0: 11353, _1: 11305 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1984 = { _0: 11305, _1: 11353 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1985 = { _0: 11354, _1: 11306 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1986 = { _0: 11306, _1: 11354 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1987 = { _0: 11355, _1: 11307 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1988 = { _0: 11307, _1: 11355 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1989 = { _0: 11356, _1: 11308 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1990 = { _0: 11308, _1: 11356 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1991 = { _0: 11357, _1: 11309 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1992 = { _0: 11309, _1: 11357 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1993 = { _0: 11358, _1: 11310 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1994 = { _0: 11310, _1: 11358 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1995 = { _0: 11359, _1: 11311 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1996 = { _0: 11311, _1: 11359 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1997 = { _0: 11361, _1: 11360 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1998 = { _0: 11360, _1: 11361 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1999 = { _0: 619, _1: 11362 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2000 = { _0: 11362, _1: 619 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2001 = { _0: 7549, _1: 11363 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2002 = { _0: 11363, _1: 7549 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2003 = { _0: 637, _1: 11364 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2004 = { _0: 11364, _1: 637 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2005 = { _0: 11368, _1: 11367 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2006 = { _0: 11367, _1: 11368 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2007 = { _0: 11370, _1: 11369 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2008 = { _0: 11369, _1: 11370 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2009 = { _0: 11372, _1: 11371 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2010 = { _0: 11371, _1: 11372 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2011 = { _0: 593, _1: 11373 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2012 = { _0: 11373, _1: 593 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2013 = { _0: 625, _1: 11374 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2014 = { _0: 11374, _1: 625 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2015 = { _0: 592, _1: 11375 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2016 = { _0: 11375, _1: 592 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2017 = { _0: 594, _1: 11376 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2018 = { _0: 11376, _1: 594 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2019 = { _0: 11379, _1: 11378 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2020 = { _0: 11378, _1: 11379 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2021 = { _0: 11382, _1: 11381 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2022 = { _0: 11381, _1: 11382 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2023 = { _0: 575, _1: 11390 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2024 = { _0: 11390, _1: 575 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2025 = { _0: 576, _1: 11391 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2026 = { _0: 11391, _1: 576 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2027 = { _0: 11393, _1: 11392 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2028 = { _0: 11392, _1: 11393 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2029 = { _0: 11395, _1: 11394 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2030 = { _0: 11394, _1: 11395 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2031 = { _0: 11397, _1: 11396 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2032 = { _0: 11396, _1: 11397 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2033 = { _0: 11399, _1: 11398 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2034 = { _0: 11398, _1: 11399 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2035 = { _0: 11401, _1: 11400 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2036 = { _0: 11400, _1: 11401 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2037 = { _0: 11403, _1: 11402 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2038 = { _0: 11402, _1: 11403 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2039 = { _0: 11405, _1: 11404 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2040 = { _0: 11404, _1: 11405 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2041 = { _0: 11407, _1: 11406 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2042 = { _0: 11406, _1: 11407 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2043 = { _0: 11409, _1: 11408 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2044 = { _0: 11408, _1: 11409 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2045 = { _0: 11411, _1: 11410 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2046 = { _0: 11410, _1: 11411 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2047 = { _0: 11413, _1: 11412 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2048 = { _0: 11412, _1: 11413 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2049 = { _0: 11415, _1: 11414 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2050 = { _0: 11414, _1: 11415 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2051 = { _0: 11417, _1: 11416 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2052 = { _0: 11416, _1: 11417 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2053 = { _0: 11419, _1: 11418 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2054 = { _0: 11418, _1: 11419 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2055 = { _0: 11421, _1: 11420 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2056 = { _0: 11420, _1: 11421 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2057 = { _0: 11423, _1: 11422 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2058 = { _0: 11422, _1: 11423 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2059 = { _0: 11425, _1: 11424 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2060 = { _0: 11424, _1: 11425 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2061 = { _0: 11427, _1: 11426 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2062 = { _0: 11426, _1: 11427 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2063 = { _0: 11429, _1: 11428 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2064 = { _0: 11428, _1: 11429 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2065 = { _0: 11431, _1: 11430 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2066 = { _0: 11430, _1: 11431 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2067 = { _0: 11433, _1: 11432 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2068 = { _0: 11432, _1: 11433 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2069 = { _0: 11435, _1: 11434 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2070 = { _0: 11434, _1: 11435 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2071 = { _0: 11437, _1: 11436 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2072 = { _0: 11436, _1: 11437 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2073 = { _0: 11439, _1: 11438 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2074 = { _0: 11438, _1: 11439 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2075 = { _0: 11441, _1: 11440 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2076 = { _0: 11440, _1: 11441 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2077 = { _0: 11443, _1: 11442 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2078 = { _0: 11442, _1: 11443 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2079 = { _0: 11445, _1: 11444 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2080 = { _0: 11444, _1: 11445 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2081 = { _0: 11447, _1: 11446 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2082 = { _0: 11446, _1: 11447 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2083 = { _0: 11449, _1: 11448 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2084 = { _0: 11448, _1: 11449 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2085 = { _0: 11451, _1: 11450 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2086 = { _0: 11450, _1: 11451 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2087 = { _0: 11453, _1: 11452 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2088 = { _0: 11452, _1: 11453 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2089 = { _0: 11455, _1: 11454 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2090 = { _0: 11454, _1: 11455 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2091 = { _0: 11457, _1: 11456 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2092 = { _0: 11456, _1: 11457 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2093 = { _0: 11459, _1: 11458 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2094 = { _0: 11458, _1: 11459 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2095 = { _0: 11461, _1: 11460 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2096 = { _0: 11460, _1: 11461 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2097 = { _0: 11463, _1: 11462 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2098 = { _0: 11462, _1: 11463 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2099 = { _0: 11465, _1: 11464 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2100 = { _0: 11464, _1: 11465 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2101 = { _0: 11467, _1: 11466 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2102 = { _0: 11466, _1: 11467 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2103 = { _0: 11469, _1: 11468 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2104 = { _0: 11468, _1: 11469 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2105 = { _0: 11471, _1: 11470 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2106 = { _0: 11470, _1: 11471 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2107 = { _0: 11473, _1: 11472 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2108 = { _0: 11472, _1: 11473 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2109 = { _0: 11475, _1: 11474 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2110 = { _0: 11474, _1: 11475 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2111 = { _0: 11477, _1: 11476 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2112 = { _0: 11476, _1: 11477 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2113 = { _0: 11479, _1: 11478 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2114 = { _0: 11478, _1: 11479 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2115 = { _0: 11481, _1: 11480 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2116 = { _0: 11480, _1: 11481 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2117 = { _0: 11483, _1: 11482 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2118 = { _0: 11482, _1: 11483 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2119 = { _0: 11485, _1: 11484 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2120 = { _0: 11484, _1: 11485 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2121 = { _0: 11487, _1: 11486 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2122 = { _0: 11486, _1: 11487 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2123 = { _0: 11489, _1: 11488 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2124 = { _0: 11488, _1: 11489 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2125 = { _0: 11491, _1: 11490 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2126 = { _0: 11490, _1: 11491 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2127 = { _0: 11500, _1: 11499 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2128 = { _0: 11499, _1: 11500 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2129 = { _0: 11502, _1: 11501 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2130 = { _0: 11501, _1: 11502 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2131 = { _0: 11507, _1: 11506 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2132 = { _0: 11506, _1: 11507 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2133 = { _0: 42561, _1: 42560 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2134 = { _0: 42560, _1: 42561 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2135 = { _0: 42563, _1: 42562 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2136 = { _0: 42562, _1: 42563 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2137 = { _0: 42565, _1: 42564 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2138 = { _0: 42564, _1: 42565 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2139 = { _0: 42567, _1: 42566 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2140 = { _0: 42566, _1: 42567 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2141 = { _0: 42569, _1: 42568 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2142 = { _0: 42568, _1: 42569 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2143 = { _0: 42573, _1: 42572 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2144 = { _0: 42572, _1: 42573 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2145 = { _0: 42575, _1: 42574 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2146 = { _0: 42574, _1: 42575 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2147 = { _0: 42577, _1: 42576 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2148 = { _0: 42576, _1: 42577 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2149 = { _0: 42579, _1: 42578 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2150 = { _0: 42578, _1: 42579 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2151 = { _0: 42581, _1: 42580 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2152 = { _0: 42580, _1: 42581 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2153 = { _0: 42583, _1: 42582 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2154 = { _0: 42582, _1: 42583 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2155 = { _0: 42585, _1: 42584 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2156 = { _0: 42584, _1: 42585 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2157 = { _0: 42587, _1: 42586 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2158 = { _0: 42586, _1: 42587 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2159 = { _0: 42589, _1: 42588 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2160 = { _0: 42588, _1: 42589 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2161 = { _0: 42591, _1: 42590 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2162 = { _0: 42590, _1: 42591 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2163 = { _0: 42593, _1: 42592 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2164 = { _0: 42592, _1: 42593 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2165 = { _0: 42595, _1: 42594 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2166 = { _0: 42594, _1: 42595 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2167 = { _0: 42597, _1: 42596 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2168 = { _0: 42596, _1: 42597 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2169 = { _0: 42599, _1: 42598 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2170 = { _0: 42598, _1: 42599 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2171 = { _0: 42601, _1: 42600 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2172 = { _0: 42600, _1: 42601 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2173 = { _0: 42603, _1: 42602 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2174 = { _0: 42602, _1: 42603 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2175 = { _0: 42605, _1: 42604 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2176 = { _0: 42604, _1: 42605 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2177 = { _0: 42625, _1: 42624 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2178 = { _0: 42624, _1: 42625 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2179 = { _0: 42627, _1: 42626 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2180 = { _0: 42626, _1: 42627 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2181 = { _0: 42629, _1: 42628 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2182 = { _0: 42628, _1: 42629 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2183 = { _0: 42631, _1: 42630 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2184 = { _0: 42630, _1: 42631 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2185 = { _0: 42633, _1: 42632 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2186 = { _0: 42632, _1: 42633 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2187 = { _0: 42635, _1: 42634 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2188 = { _0: 42634, _1: 42635 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2189 = { _0: 42637, _1: 42636 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2190 = { _0: 42636, _1: 42637 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2191 = { _0: 42639, _1: 42638 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2192 = { _0: 42638, _1: 42639 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2193 = { _0: 42641, _1: 42640 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2194 = { _0: 42640, _1: 42641 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2195 = { _0: 42643, _1: 42642 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2196 = { _0: 42642, _1: 42643 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2197 = { _0: 42645, _1: 42644 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2198 = { _0: 42644, _1: 42645 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2199 = { _0: 42647, _1: 42646 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2200 = { _0: 42646, _1: 42647 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2201 = { _0: 42649, _1: 42648 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2202 = { _0: 42648, _1: 42649 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2203 = { _0: 42651, _1: 42650 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2204 = { _0: 42650, _1: 42651 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2205 = { _0: 42787, _1: 42786 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2206 = { _0: 42786, _1: 42787 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2207 = { _0: 42789, _1: 42788 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2208 = { _0: 42788, _1: 42789 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2209 = { _0: 42791, _1: 42790 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2210 = { _0: 42790, _1: 42791 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2211 = { _0: 42793, _1: 42792 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2212 = { _0: 42792, _1: 42793 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2213 = { _0: 42795, _1: 42794 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2214 = { _0: 42794, _1: 42795 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2215 = { _0: 42797, _1: 42796 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2216 = { _0: 42796, _1: 42797 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2217 = { _0: 42799, _1: 42798 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2218 = { _0: 42798, _1: 42799 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2219 = { _0: 42803, _1: 42802 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2220 = { _0: 42802, _1: 42803 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2221 = { _0: 42805, _1: 42804 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2222 = { _0: 42804, _1: 42805 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2223 = { _0: 42807, _1: 42806 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2224 = { _0: 42806, _1: 42807 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2225 = { _0: 42809, _1: 42808 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2226 = { _0: 42808, _1: 42809 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2227 = { _0: 42811, _1: 42810 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2228 = { _0: 42810, _1: 42811 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2229 = { _0: 42813, _1: 42812 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2230 = { _0: 42812, _1: 42813 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2231 = { _0: 42815, _1: 42814 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2232 = { _0: 42814, _1: 42815 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2233 = { _0: 42817, _1: 42816 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2234 = { _0: 42816, _1: 42817 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2235 = { _0: 42819, _1: 42818 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2236 = { _0: 42818, _1: 42819 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2237 = { _0: 42821, _1: 42820 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2238 = { _0: 42820, _1: 42821 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2239 = { _0: 42823, _1: 42822 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2240 = { _0: 42822, _1: 42823 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2241 = { _0: 42825, _1: 42824 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2242 = { _0: 42824, _1: 42825 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2243 = { _0: 42827, _1: 42826 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2244 = { _0: 42826, _1: 42827 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2245 = { _0: 42829, _1: 42828 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2246 = { _0: 42828, _1: 42829 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2247 = { _0: 42831, _1: 42830 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2248 = { _0: 42830, _1: 42831 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2249 = { _0: 42833, _1: 42832 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2250 = { _0: 42832, _1: 42833 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2251 = { _0: 42835, _1: 42834 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2252 = { _0: 42834, _1: 42835 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2253 = { _0: 42837, _1: 42836 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2254 = { _0: 42836, _1: 42837 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2255 = { _0: 42839, _1: 42838 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2256 = { _0: 42838, _1: 42839 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2257 = { _0: 42841, _1: 42840 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2258 = { _0: 42840, _1: 42841 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2259 = { _0: 42843, _1: 42842 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2260 = { _0: 42842, _1: 42843 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2261 = { _0: 42845, _1: 42844 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2262 = { _0: 42844, _1: 42845 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2263 = { _0: 42847, _1: 42846 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2264 = { _0: 42846, _1: 42847 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2265 = { _0: 42849, _1: 42848 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2266 = { _0: 42848, _1: 42849 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2267 = { _0: 42851, _1: 42850 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2268 = { _0: 42850, _1: 42851 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2269 = { _0: 42853, _1: 42852 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2270 = { _0: 42852, _1: 42853 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2271 = { _0: 42855, _1: 42854 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2272 = { _0: 42854, _1: 42855 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2273 = { _0: 42857, _1: 42856 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2274 = { _0: 42856, _1: 42857 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2275 = { _0: 42859, _1: 42858 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2276 = { _0: 42858, _1: 42859 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2277 = { _0: 42861, _1: 42860 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2278 = { _0: 42860, _1: 42861 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2279 = { _0: 42863, _1: 42862 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2280 = { _0: 42862, _1: 42863 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2281 = { _0: 42874, _1: 42873 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2282 = { _0: 42873, _1: 42874 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2283 = { _0: 42876, _1: 42875 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2284 = { _0: 42875, _1: 42876 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2285 = { _0: 7545, _1: 42877 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2286 = { _0: 42877, _1: 7545 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2287 = { _0: 42879, _1: 42878 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2288 = { _0: 42878, _1: 42879 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2289 = { _0: 42881, _1: 42880 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2290 = { _0: 42880, _1: 42881 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2291 = { _0: 42883, _1: 42882 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2292 = { _0: 42882, _1: 42883 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2293 = { _0: 42885, _1: 42884 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2294 = { _0: 42884, _1: 42885 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2295 = { _0: 42887, _1: 42886 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2296 = { _0: 42886, _1: 42887 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2297 = { _0: 42892, _1: 42891 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2298 = { _0: 42891, _1: 42892 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2299 = { _0: 613, _1: 42893 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2300 = { _0: 42893, _1: 613 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2301 = { _0: 42897, _1: 42896 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2302 = { _0: 42896, _1: 42897 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2303 = { _0: 42899, _1: 42898 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2304 = { _0: 42898, _1: 42899 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2305 = { _0: 42903, _1: 42902 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2306 = { _0: 42902, _1: 42903 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2307 = { _0: 42905, _1: 42904 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2308 = { _0: 42904, _1: 42905 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2309 = { _0: 42907, _1: 42906 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2310 = { _0: 42906, _1: 42907 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2311 = { _0: 42909, _1: 42908 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2312 = { _0: 42908, _1: 42909 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2313 = { _0: 42911, _1: 42910 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2314 = { _0: 42910, _1: 42911 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2315 = { _0: 42913, _1: 42912 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2316 = { _0: 42912, _1: 42913 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2317 = { _0: 42915, _1: 42914 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2318 = { _0: 42914, _1: 42915 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2319 = { _0: 42917, _1: 42916 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2320 = { _0: 42916, _1: 42917 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2321 = { _0: 42919, _1: 42918 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2322 = { _0: 42918, _1: 42919 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2323 = { _0: 42921, _1: 42920 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2324 = { _0: 42920, _1: 42921 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2325 = { _0: 614, _1: 42922 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2326 = { _0: 42922, _1: 614 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2327 = { _0: 604, _1: 42923 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2328 = { _0: 42923, _1: 604 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2329 = { _0: 609, _1: 42924 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2330 = { _0: 42924, _1: 609 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2331 = { _0: 620, _1: 42925 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2332 = { _0: 42925, _1: 620 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2333 = { _0: 618, _1: 42926 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2334 = { _0: 42926, _1: 618 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2335 = { _0: 670, _1: 42928 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2336 = { _0: 42928, _1: 670 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2337 = { _0: 647, _1: 42929 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2338 = { _0: 42929, _1: 647 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2339 = { _0: 669, _1: 42930 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2340 = { _0: 42930, _1: 669 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2341 = { _0: 43859, _1: 42931 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2342 = { _0: 42931, _1: 43859 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2343 = { _0: 42933, _1: 42932 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2344 = { _0: 42932, _1: 42933 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2345 = { _0: 42935, _1: 42934 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2346 = { _0: 42934, _1: 42935 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2347 = { _0: 42937, _1: 42936 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2348 = { _0: 42936, _1: 42937 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2349 = { _0: 42939, _1: 42938 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2350 = { _0: 42938, _1: 42939 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2351 = { _0: 42941, _1: 42940 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2352 = { _0: 42940, _1: 42941 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2353 = { _0: 42943, _1: 42942 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2354 = { _0: 42942, _1: 42943 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2355 = { _0: 42945, _1: 42944 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2356 = { _0: 42944, _1: 42945 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2357 = { _0: 42947, _1: 42946 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2358 = { _0: 42946, _1: 42947 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2359 = { _0: 42900, _1: 42948 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2360 = { _0: 42948, _1: 42900 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2361 = { _0: 642, _1: 42949 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2362 = { _0: 42949, _1: 642 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2363 = { _0: 7566, _1: 42950 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2364 = { _0: 42950, _1: 7566 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2365 = { _0: 42952, _1: 42951 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2366 = { _0: 42951, _1: 42952 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2367 = { _0: 42954, _1: 42953 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2368 = { _0: 42953, _1: 42954 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2369 = { _0: 612, _1: 42955 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2370 = { _0: 42955, _1: 612 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2371 = { _0: 42957, _1: 42956 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2372 = { _0: 42956, _1: 42957 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2373 = { _0: 42961, _1: 42960 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2374 = { _0: 42960, _1: 42961 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2375 = { _0: 42967, _1: 42966 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2376 = { _0: 42966, _1: 42967 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2377 = { _0: 42969, _1: 42968 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2378 = { _0: 42968, _1: 42969 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2379 = { _0: 42971, _1: 42970 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2380 = { _0: 42970, _1: 42971 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2381 = { _0: 411, _1: 42972 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2382 = { _0: 42972, _1: 411 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2383 = { _0: 42998, _1: 42997 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2384 = { _0: 42997, _1: 42998 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2385 = { _0: 5024, _1: 43888 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2386 = { _0: 43888, _1: 5024 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2387 = { _0: 5025, _1: 43889 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2388 = { _0: 43889, _1: 5025 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2389 = { _0: 5026, _1: 43890 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2390 = { _0: 43890, _1: 5026 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2391 = { _0: 5027, _1: 43891 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2392 = { _0: 43891, _1: 5027 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2393 = { _0: 5028, _1: 43892 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2394 = { _0: 43892, _1: 5028 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2395 = { _0: 5029, _1: 43893 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2396 = { _0: 43893, _1: 5029 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2397 = { _0: 5030, _1: 43894 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2398 = { _0: 43894, _1: 5030 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2399 = { _0: 5031, _1: 43895 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2400 = { _0: 43895, _1: 5031 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2401 = { _0: 5032, _1: 43896 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2402 = { _0: 43896, _1: 5032 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2403 = { _0: 5033, _1: 43897 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2404 = { _0: 43897, _1: 5033 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2405 = { _0: 5034, _1: 43898 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2406 = { _0: 43898, _1: 5034 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2407 = { _0: 5035, _1: 43899 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2408 = { _0: 43899, _1: 5035 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2409 = { _0: 5036, _1: 43900 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2410 = { _0: 43900, _1: 5036 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2411 = { _0: 5037, _1: 43901 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2412 = { _0: 43901, _1: 5037 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2413 = { _0: 5038, _1: 43902 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2414 = { _0: 43902, _1: 5038 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2415 = { _0: 5039, _1: 43903 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2416 = { _0: 43903, _1: 5039 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2417 = { _0: 5040, _1: 43904 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2418 = { _0: 43904, _1: 5040 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2419 = { _0: 5041, _1: 43905 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2420 = { _0: 43905, _1: 5041 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2421 = { _0: 5042, _1: 43906 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2422 = { _0: 43906, _1: 5042 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2423 = { _0: 5043, _1: 43907 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2424 = { _0: 43907, _1: 5043 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2425 = { _0: 5044, _1: 43908 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2426 = { _0: 43908, _1: 5044 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2427 = { _0: 5045, _1: 43909 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2428 = { _0: 43909, _1: 5045 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2429 = { _0: 5046, _1: 43910 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2430 = { _0: 43910, _1: 5046 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2431 = { _0: 5047, _1: 43911 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2432 = { _0: 43911, _1: 5047 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2433 = { _0: 5048, _1: 43912 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2434 = { _0: 43912, _1: 5048 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2435 = { _0: 5049, _1: 43913 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2436 = { _0: 43913, _1: 5049 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2437 = { _0: 5050, _1: 43914 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2438 = { _0: 43914, _1: 5050 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2439 = { _0: 5051, _1: 43915 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2440 = { _0: 43915, _1: 5051 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2441 = { _0: 5052, _1: 43916 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2442 = { _0: 43916, _1: 5052 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2443 = { _0: 5053, _1: 43917 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2444 = { _0: 43917, _1: 5053 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2445 = { _0: 5054, _1: 43918 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2446 = { _0: 43918, _1: 5054 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2447 = { _0: 5055, _1: 43919 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2448 = { _0: 43919, _1: 5055 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2449 = { _0: 5056, _1: 43920 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2450 = { _0: 43920, _1: 5056 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2451 = { _0: 5057, _1: 43921 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2452 = { _0: 43921, _1: 5057 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2453 = { _0: 5058, _1: 43922 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2454 = { _0: 43922, _1: 5058 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2455 = { _0: 5059, _1: 43923 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2456 = { _0: 43923, _1: 5059 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2457 = { _0: 5060, _1: 43924 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2458 = { _0: 43924, _1: 5060 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2459 = { _0: 5061, _1: 43925 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2460 = { _0: 43925, _1: 5061 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2461 = { _0: 5062, _1: 43926 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2462 = { _0: 43926, _1: 5062 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2463 = { _0: 5063, _1: 43927 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2464 = { _0: 43927, _1: 5063 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2465 = { _0: 5064, _1: 43928 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2466 = { _0: 43928, _1: 5064 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2467 = { _0: 5065, _1: 43929 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2468 = { _0: 43929, _1: 5065 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2469 = { _0: 5066, _1: 43930 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2470 = { _0: 43930, _1: 5066 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2471 = { _0: 5067, _1: 43931 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2472 = { _0: 43931, _1: 5067 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2473 = { _0: 5068, _1: 43932 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2474 = { _0: 43932, _1: 5068 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2475 = { _0: 5069, _1: 43933 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2476 = { _0: 43933, _1: 5069 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2477 = { _0: 5070, _1: 43934 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2478 = { _0: 43934, _1: 5070 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2479 = { _0: 5071, _1: 43935 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2480 = { _0: 43935, _1: 5071 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2481 = { _0: 5072, _1: 43936 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2482 = { _0: 43936, _1: 5072 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2483 = { _0: 5073, _1: 43937 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2484 = { _0: 43937, _1: 5073 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2485 = { _0: 5074, _1: 43938 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2486 = { _0: 43938, _1: 5074 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2487 = { _0: 5075, _1: 43939 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2488 = { _0: 43939, _1: 5075 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2489 = { _0: 5076, _1: 43940 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2490 = { _0: 43940, _1: 5076 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2491 = { _0: 5077, _1: 43941 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2492 = { _0: 43941, _1: 5077 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2493 = { _0: 5078, _1: 43942 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2494 = { _0: 43942, _1: 5078 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2495 = { _0: 5079, _1: 43943 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2496 = { _0: 43943, _1: 5079 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2497 = { _0: 5080, _1: 43944 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2498 = { _0: 43944, _1: 5080 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2499 = { _0: 5081, _1: 43945 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2500 = { _0: 43945, _1: 5081 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2501 = { _0: 5082, _1: 43946 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2502 = { _0: 43946, _1: 5082 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2503 = { _0: 5083, _1: 43947 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2504 = { _0: 43947, _1: 5083 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2505 = { _0: 5084, _1: 43948 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2506 = { _0: 43948, _1: 5084 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2507 = { _0: 5085, _1: 43949 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2508 = { _0: 43949, _1: 5085 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2509 = { _0: 5086, _1: 43950 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2510 = { _0: 43950, _1: 5086 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2511 = { _0: 5087, _1: 43951 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2512 = { _0: 43951, _1: 5087 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2513 = { _0: 5088, _1: 43952 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2514 = { _0: 43952, _1: 5088 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2515 = { _0: 5089, _1: 43953 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2516 = { _0: 43953, _1: 5089 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2517 = { _0: 5090, _1: 43954 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2518 = { _0: 43954, _1: 5090 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2519 = { _0: 5091, _1: 43955 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2520 = { _0: 43955, _1: 5091 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2521 = { _0: 5092, _1: 43956 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2522 = { _0: 43956, _1: 5092 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2523 = { _0: 5093, _1: 43957 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2524 = { _0: 43957, _1: 5093 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2525 = { _0: 5094, _1: 43958 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2526 = { _0: 43958, _1: 5094 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2527 = { _0: 5095, _1: 43959 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2528 = { _0: 43959, _1: 5095 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2529 = { _0: 5096, _1: 43960 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2530 = { _0: 43960, _1: 5096 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2531 = { _0: 5097, _1: 43961 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2532 = { _0: 43961, _1: 5097 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2533 = { _0: 5098, _1: 43962 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2534 = { _0: 43962, _1: 5098 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2535 = { _0: 5099, _1: 43963 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2536 = { _0: 43963, _1: 5099 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2537 = { _0: 5100, _1: 43964 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2538 = { _0: 43964, _1: 5100 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2539 = { _0: 5101, _1: 43965 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2540 = { _0: 43965, _1: 5101 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2541 = { _0: 5102, _1: 43966 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2542 = { _0: 43966, _1: 5102 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2543 = { _0: 5103, _1: 43967 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2544 = { _0: 43967, _1: 5103 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2545 = { _0: 64262, _1: 64261 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2546 = { _0: 64261, _1: 64262 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2547 = { _0: 65345, _1: 65313 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2548 = { _0: 65313, _1: 65345 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2549 = { _0: 65346, _1: 65314 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2550 = { _0: 65314, _1: 65346 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2551 = { _0: 65347, _1: 65315 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2552 = { _0: 65315, _1: 65347 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2553 = { _0: 65348, _1: 65316 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2554 = { _0: 65316, _1: 65348 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2555 = { _0: 65349, _1: 65317 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2556 = { _0: 65317, _1: 65349 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2557 = { _0: 65350, _1: 65318 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2558 = { _0: 65318, _1: 65350 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2559 = { _0: 65351, _1: 65319 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2560 = { _0: 65319, _1: 65351 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2561 = { _0: 65352, _1: 65320 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2562 = { _0: 65320, _1: 65352 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2563 = { _0: 65353, _1: 65321 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2564 = { _0: 65321, _1: 65353 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2565 = { _0: 65354, _1: 65322 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2566 = { _0: 65322, _1: 65354 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2567 = { _0: 65355, _1: 65323 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2568 = { _0: 65323, _1: 65355 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2569 = { _0: 65356, _1: 65324 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2570 = { _0: 65324, _1: 65356 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2571 = { _0: 65357, _1: 65325 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2572 = { _0: 65325, _1: 65357 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2573 = { _0: 65358, _1: 65326 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2574 = { _0: 65326, _1: 65358 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2575 = { _0: 65359, _1: 65327 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2576 = { _0: 65327, _1: 65359 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2577 = { _0: 65360, _1: 65328 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2578 = { _0: 65328, _1: 65360 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2579 = { _0: 65361, _1: 65329 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2580 = { _0: 65329, _1: 65361 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2581 = { _0: 65362, _1: 65330 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2582 = { _0: 65330, _1: 65362 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2583 = { _0: 65363, _1: 65331 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2584 = { _0: 65331, _1: 65363 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2585 = { _0: 65364, _1: 65332 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2586 = { _0: 65332, _1: 65364 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2587 = { _0: 65365, _1: 65333 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2588 = { _0: 65333, _1: 65365 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2589 = { _0: 65366, _1: 65334 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2590 = { _0: 65334, _1: 65366 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2591 = { _0: 65367, _1: 65335 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2592 = { _0: 65335, _1: 65367 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2593 = { _0: 65368, _1: 65336 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2594 = { _0: 65336, _1: 65368 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2595 = { _0: 65369, _1: 65337 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2596 = { _0: 65337, _1: 65369 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2597 = { _0: 65370, _1: 65338 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2598 = { _0: 65338, _1: 65370 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2599 = { _0: 66600, _1: 66560 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2600 = { _0: 66560, _1: 66600 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2601 = { _0: 66601, _1: 66561 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2602 = { _0: 66561, _1: 66601 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2603 = { _0: 66602, _1: 66562 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2604 = { _0: 66562, _1: 66602 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2605 = { _0: 66603, _1: 66563 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2606 = { _0: 66563, _1: 66603 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2607 = { _0: 66604, _1: 66564 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2608 = { _0: 66564, _1: 66604 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2609 = { _0: 66605, _1: 66565 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2610 = { _0: 66565, _1: 66605 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2611 = { _0: 66606, _1: 66566 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2612 = { _0: 66566, _1: 66606 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2613 = { _0: 66607, _1: 66567 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2614 = { _0: 66567, _1: 66607 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2615 = { _0: 66608, _1: 66568 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2616 = { _0: 66568, _1: 66608 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2617 = { _0: 66609, _1: 66569 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2618 = { _0: 66569, _1: 66609 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2619 = { _0: 66610, _1: 66570 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2620 = { _0: 66570, _1: 66610 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2621 = { _0: 66611, _1: 66571 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2622 = { _0: 66571, _1: 66611 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2623 = { _0: 66612, _1: 66572 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2624 = { _0: 66572, _1: 66612 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2625 = { _0: 66613, _1: 66573 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2626 = { _0: 66573, _1: 66613 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2627 = { _0: 66614, _1: 66574 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2628 = { _0: 66574, _1: 66614 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2629 = { _0: 66615, _1: 66575 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2630 = { _0: 66575, _1: 66615 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2631 = { _0: 66616, _1: 66576 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2632 = { _0: 66576, _1: 66616 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2633 = { _0: 66617, _1: 66577 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2634 = { _0: 66577, _1: 66617 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2635 = { _0: 66618, _1: 66578 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2636 = { _0: 66578, _1: 66618 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2637 = { _0: 66619, _1: 66579 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2638 = { _0: 66579, _1: 66619 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2639 = { _0: 66620, _1: 66580 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2640 = { _0: 66580, _1: 66620 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2641 = { _0: 66621, _1: 66581 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2642 = { _0: 66581, _1: 66621 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2643 = { _0: 66622, _1: 66582 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2644 = { _0: 66582, _1: 66622 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2645 = { _0: 66623, _1: 66583 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2646 = { _0: 66583, _1: 66623 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2647 = { _0: 66624, _1: 66584 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2648 = { _0: 66584, _1: 66624 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2649 = { _0: 66625, _1: 66585 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2650 = { _0: 66585, _1: 66625 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2651 = { _0: 66626, _1: 66586 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2652 = { _0: 66586, _1: 66626 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2653 = { _0: 66627, _1: 66587 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2654 = { _0: 66587, _1: 66627 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2655 = { _0: 66628, _1: 66588 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2656 = { _0: 66588, _1: 66628 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2657 = { _0: 66629, _1: 66589 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2658 = { _0: 66589, _1: 66629 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2659 = { _0: 66630, _1: 66590 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2660 = { _0: 66590, _1: 66630 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2661 = { _0: 66631, _1: 66591 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2662 = { _0: 66591, _1: 66631 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2663 = { _0: 66632, _1: 66592 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2664 = { _0: 66592, _1: 66632 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2665 = { _0: 66633, _1: 66593 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2666 = { _0: 66593, _1: 66633 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2667 = { _0: 66634, _1: 66594 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2668 = { _0: 66594, _1: 66634 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2669 = { _0: 66635, _1: 66595 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2670 = { _0: 66595, _1: 66635 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2671 = { _0: 66636, _1: 66596 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2672 = { _0: 66596, _1: 66636 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2673 = { _0: 66637, _1: 66597 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2674 = { _0: 66597, _1: 66637 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2675 = { _0: 66638, _1: 66598 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2676 = { _0: 66598, _1: 66638 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2677 = { _0: 66639, _1: 66599 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2678 = { _0: 66599, _1: 66639 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2679 = { _0: 66776, _1: 66736 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2680 = { _0: 66736, _1: 66776 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2681 = { _0: 66777, _1: 66737 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2682 = { _0: 66737, _1: 66777 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2683 = { _0: 66778, _1: 66738 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2684 = { _0: 66738, _1: 66778 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2685 = { _0: 66779, _1: 66739 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2686 = { _0: 66739, _1: 66779 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2687 = { _0: 66780, _1: 66740 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2688 = { _0: 66740, _1: 66780 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2689 = { _0: 66781, _1: 66741 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2690 = { _0: 66741, _1: 66781 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2691 = { _0: 66782, _1: 66742 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2692 = { _0: 66742, _1: 66782 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2693 = { _0: 66783, _1: 66743 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2694 = { _0: 66743, _1: 66783 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2695 = { _0: 66784, _1: 66744 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2696 = { _0: 66744, _1: 66784 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2697 = { _0: 66785, _1: 66745 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2698 = { _0: 66745, _1: 66785 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2699 = { _0: 66786, _1: 66746 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2700 = { _0: 66746, _1: 66786 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2701 = { _0: 66787, _1: 66747 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2702 = { _0: 66747, _1: 66787 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2703 = { _0: 66788, _1: 66748 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2704 = { _0: 66748, _1: 66788 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2705 = { _0: 66789, _1: 66749 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2706 = { _0: 66749, _1: 66789 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2707 = { _0: 66790, _1: 66750 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2708 = { _0: 66750, _1: 66790 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2709 = { _0: 66791, _1: 66751 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2710 = { _0: 66751, _1: 66791 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2711 = { _0: 66792, _1: 66752 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2712 = { _0: 66752, _1: 66792 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2713 = { _0: 66793, _1: 66753 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2714 = { _0: 66753, _1: 66793 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2715 = { _0: 66794, _1: 66754 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2716 = { _0: 66754, _1: 66794 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2717 = { _0: 66795, _1: 66755 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2718 = { _0: 66755, _1: 66795 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2719 = { _0: 66796, _1: 66756 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2720 = { _0: 66756, _1: 66796 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2721 = { _0: 66797, _1: 66757 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2722 = { _0: 66757, _1: 66797 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2723 = { _0: 66798, _1: 66758 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2724 = { _0: 66758, _1: 66798 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2725 = { _0: 66799, _1: 66759 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2726 = { _0: 66759, _1: 66799 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2727 = { _0: 66800, _1: 66760 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2728 = { _0: 66760, _1: 66800 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2729 = { _0: 66801, _1: 66761 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2730 = { _0: 66761, _1: 66801 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2731 = { _0: 66802, _1: 66762 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2732 = { _0: 66762, _1: 66802 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2733 = { _0: 66803, _1: 66763 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2734 = { _0: 66763, _1: 66803 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2735 = { _0: 66804, _1: 66764 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2736 = { _0: 66764, _1: 66804 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2737 = { _0: 66805, _1: 66765 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2738 = { _0: 66765, _1: 66805 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2739 = { _0: 66806, _1: 66766 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2740 = { _0: 66766, _1: 66806 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2741 = { _0: 66807, _1: 66767 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2742 = { _0: 66767, _1: 66807 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2743 = { _0: 66808, _1: 66768 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2744 = { _0: 66768, _1: 66808 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2745 = { _0: 66809, _1: 66769 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2746 = { _0: 66769, _1: 66809 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2747 = { _0: 66810, _1: 66770 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2748 = { _0: 66770, _1: 66810 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2749 = { _0: 66811, _1: 66771 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2750 = { _0: 66771, _1: 66811 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2751 = { _0: 66967, _1: 66928 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2752 = { _0: 66928, _1: 66967 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2753 = { _0: 66968, _1: 66929 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2754 = { _0: 66929, _1: 66968 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2755 = { _0: 66969, _1: 66930 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2756 = { _0: 66930, _1: 66969 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2757 = { _0: 66970, _1: 66931 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2758 = { _0: 66931, _1: 66970 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2759 = { _0: 66971, _1: 66932 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2760 = { _0: 66932, _1: 66971 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2761 = { _0: 66972, _1: 66933 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2762 = { _0: 66933, _1: 66972 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2763 = { _0: 66973, _1: 66934 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2764 = { _0: 66934, _1: 66973 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2765 = { _0: 66974, _1: 66935 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2766 = { _0: 66935, _1: 66974 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2767 = { _0: 66975, _1: 66936 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2768 = { _0: 66936, _1: 66975 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2769 = { _0: 66976, _1: 66937 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2770 = { _0: 66937, _1: 66976 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2771 = { _0: 66977, _1: 66938 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2772 = { _0: 66938, _1: 66977 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2773 = { _0: 66979, _1: 66940 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2774 = { _0: 66940, _1: 66979 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2775 = { _0: 66980, _1: 66941 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2776 = { _0: 66941, _1: 66980 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2777 = { _0: 66981, _1: 66942 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2778 = { _0: 66942, _1: 66981 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2779 = { _0: 66982, _1: 66943 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2780 = { _0: 66943, _1: 66982 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2781 = { _0: 66983, _1: 66944 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2782 = { _0: 66944, _1: 66983 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2783 = { _0: 66984, _1: 66945 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2784 = { _0: 66945, _1: 66984 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2785 = { _0: 66985, _1: 66946 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2786 = { _0: 66946, _1: 66985 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2787 = { _0: 66986, _1: 66947 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2788 = { _0: 66947, _1: 66986 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2789 = { _0: 66987, _1: 66948 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2790 = { _0: 66948, _1: 66987 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2791 = { _0: 66988, _1: 66949 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2792 = { _0: 66949, _1: 66988 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2793 = { _0: 66989, _1: 66950 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2794 = { _0: 66950, _1: 66989 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2795 = { _0: 66990, _1: 66951 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2796 = { _0: 66951, _1: 66990 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2797 = { _0: 66991, _1: 66952 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2798 = { _0: 66952, _1: 66991 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2799 = { _0: 66992, _1: 66953 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2800 = { _0: 66953, _1: 66992 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2801 = { _0: 66993, _1: 66954 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2802 = { _0: 66954, _1: 66993 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2803 = { _0: 66995, _1: 66956 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2804 = { _0: 66956, _1: 66995 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2805 = { _0: 66996, _1: 66957 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2806 = { _0: 66957, _1: 66996 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2807 = { _0: 66997, _1: 66958 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2808 = { _0: 66958, _1: 66997 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2809 = { _0: 66998, _1: 66959 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2810 = { _0: 66959, _1: 66998 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2811 = { _0: 66999, _1: 66960 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2812 = { _0: 66960, _1: 66999 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2813 = { _0: 67000, _1: 66961 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2814 = { _0: 66961, _1: 67000 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2815 = { _0: 67001, _1: 66962 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2816 = { _0: 66962, _1: 67001 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2817 = { _0: 67003, _1: 66964 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2818 = { _0: 66964, _1: 67003 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2819 = { _0: 67004, _1: 66965 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2820 = { _0: 66965, _1: 67004 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2821 = { _0: 68800, _1: 68736 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2822 = { _0: 68736, _1: 68800 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2823 = { _0: 68801, _1: 68737 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2824 = { _0: 68737, _1: 68801 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2825 = { _0: 68802, _1: 68738 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2826 = { _0: 68738, _1: 68802 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2827 = { _0: 68803, _1: 68739 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2828 = { _0: 68739, _1: 68803 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2829 = { _0: 68804, _1: 68740 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2830 = { _0: 68740, _1: 68804 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2831 = { _0: 68805, _1: 68741 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2832 = { _0: 68741, _1: 68805 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2833 = { _0: 68806, _1: 68742 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2834 = { _0: 68742, _1: 68806 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2835 = { _0: 68807, _1: 68743 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2836 = { _0: 68743, _1: 68807 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2837 = { _0: 68808, _1: 68744 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2838 = { _0: 68744, _1: 68808 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2839 = { _0: 68809, _1: 68745 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2840 = { _0: 68745, _1: 68809 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2841 = { _0: 68810, _1: 68746 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2842 = { _0: 68746, _1: 68810 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2843 = { _0: 68811, _1: 68747 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2844 = { _0: 68747, _1: 68811 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2845 = { _0: 68812, _1: 68748 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2846 = { _0: 68748, _1: 68812 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2847 = { _0: 68813, _1: 68749 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2848 = { _0: 68749, _1: 68813 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2849 = { _0: 68814, _1: 68750 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2850 = { _0: 68750, _1: 68814 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2851 = { _0: 68815, _1: 68751 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2852 = { _0: 68751, _1: 68815 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2853 = { _0: 68816, _1: 68752 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2854 = { _0: 68752, _1: 68816 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2855 = { _0: 68817, _1: 68753 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2856 = { _0: 68753, _1: 68817 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2857 = { _0: 68818, _1: 68754 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2858 = { _0: 68754, _1: 68818 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2859 = { _0: 68819, _1: 68755 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2860 = { _0: 68755, _1: 68819 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2861 = { _0: 68820, _1: 68756 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2862 = { _0: 68756, _1: 68820 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2863 = { _0: 68821, _1: 68757 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2864 = { _0: 68757, _1: 68821 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2865 = { _0: 68822, _1: 68758 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2866 = { _0: 68758, _1: 68822 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2867 = { _0: 68823, _1: 68759 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2868 = { _0: 68759, _1: 68823 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2869 = { _0: 68824, _1: 68760 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2870 = { _0: 68760, _1: 68824 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2871 = { _0: 68825, _1: 68761 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2872 = { _0: 68761, _1: 68825 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2873 = { _0: 68826, _1: 68762 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2874 = { _0: 68762, _1: 68826 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2875 = { _0: 68827, _1: 68763 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2876 = { _0: 68763, _1: 68827 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2877 = { _0: 68828, _1: 68764 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2878 = { _0: 68764, _1: 68828 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2879 = { _0: 68829, _1: 68765 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2880 = { _0: 68765, _1: 68829 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2881 = { _0: 68830, _1: 68766 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2882 = { _0: 68766, _1: 68830 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2883 = { _0: 68831, _1: 68767 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2884 = { _0: 68767, _1: 68831 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2885 = { _0: 68832, _1: 68768 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2886 = { _0: 68768, _1: 68832 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2887 = { _0: 68833, _1: 68769 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2888 = { _0: 68769, _1: 68833 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2889 = { _0: 68834, _1: 68770 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2890 = { _0: 68770, _1: 68834 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2891 = { _0: 68835, _1: 68771 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2892 = { _0: 68771, _1: 68835 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2893 = { _0: 68836, _1: 68772 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2894 = { _0: 68772, _1: 68836 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2895 = { _0: 68837, _1: 68773 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2896 = { _0: 68773, _1: 68837 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2897 = { _0: 68838, _1: 68774 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2898 = { _0: 68774, _1: 68838 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2899 = { _0: 68839, _1: 68775 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2900 = { _0: 68775, _1: 68839 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2901 = { _0: 68840, _1: 68776 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2902 = { _0: 68776, _1: 68840 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2903 = { _0: 68841, _1: 68777 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2904 = { _0: 68777, _1: 68841 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2905 = { _0: 68842, _1: 68778 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2906 = { _0: 68778, _1: 68842 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2907 = { _0: 68843, _1: 68779 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2908 = { _0: 68779, _1: 68843 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2909 = { _0: 68844, _1: 68780 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2910 = { _0: 68780, _1: 68844 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2911 = { _0: 68845, _1: 68781 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2912 = { _0: 68781, _1: 68845 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2913 = { _0: 68846, _1: 68782 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2914 = { _0: 68782, _1: 68846 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2915 = { _0: 68847, _1: 68783 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2916 = { _0: 68783, _1: 68847 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2917 = { _0: 68848, _1: 68784 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2918 = { _0: 68784, _1: 68848 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2919 = { _0: 68849, _1: 68785 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2920 = { _0: 68785, _1: 68849 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2921 = { _0: 68850, _1: 68786 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2922 = { _0: 68786, _1: 68850 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2923 = { _0: 68976, _1: 68944 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2924 = { _0: 68944, _1: 68976 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2925 = { _0: 68977, _1: 68945 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2926 = { _0: 68945, _1: 68977 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2927 = { _0: 68978, _1: 68946 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2928 = { _0: 68946, _1: 68978 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2929 = { _0: 68979, _1: 68947 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2930 = { _0: 68947, _1: 68979 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2931 = { _0: 68980, _1: 68948 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2932 = { _0: 68948, _1: 68980 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2933 = { _0: 68981, _1: 68949 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2934 = { _0: 68949, _1: 68981 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2935 = { _0: 68982, _1: 68950 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2936 = { _0: 68950, _1: 68982 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2937 = { _0: 68983, _1: 68951 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2938 = { _0: 68951, _1: 68983 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2939 = { _0: 68984, _1: 68952 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2940 = { _0: 68952, _1: 68984 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2941 = { _0: 68985, _1: 68953 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2942 = { _0: 68953, _1: 68985 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2943 = { _0: 68986, _1: 68954 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2944 = { _0: 68954, _1: 68986 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2945 = { _0: 68987, _1: 68955 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2946 = { _0: 68955, _1: 68987 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2947 = { _0: 68988, _1: 68956 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2948 = { _0: 68956, _1: 68988 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2949 = { _0: 68989, _1: 68957 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2950 = { _0: 68957, _1: 68989 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2951 = { _0: 68990, _1: 68958 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2952 = { _0: 68958, _1: 68990 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2953 = { _0: 68991, _1: 68959 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2954 = { _0: 68959, _1: 68991 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2955 = { _0: 68992, _1: 68960 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2956 = { _0: 68960, _1: 68992 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2957 = { _0: 68993, _1: 68961 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2958 = { _0: 68961, _1: 68993 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2959 = { _0: 68994, _1: 68962 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2960 = { _0: 68962, _1: 68994 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2961 = { _0: 68995, _1: 68963 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2962 = { _0: 68963, _1: 68995 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2963 = { _0: 68996, _1: 68964 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2964 = { _0: 68964, _1: 68996 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2965 = { _0: 68997, _1: 68965 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2966 = { _0: 68965, _1: 68997 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2967 = { _0: 71872, _1: 71840 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2968 = { _0: 71840, _1: 71872 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2969 = { _0: 71873, _1: 71841 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2970 = { _0: 71841, _1: 71873 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2971 = { _0: 71874, _1: 71842 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2972 = { _0: 71842, _1: 71874 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2973 = { _0: 71875, _1: 71843 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2974 = { _0: 71843, _1: 71875 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2975 = { _0: 71876, _1: 71844 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2976 = { _0: 71844, _1: 71876 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2977 = { _0: 71877, _1: 71845 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2978 = { _0: 71845, _1: 71877 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2979 = { _0: 71878, _1: 71846 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2980 = { _0: 71846, _1: 71878 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2981 = { _0: 71879, _1: 71847 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2982 = { _0: 71847, _1: 71879 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2983 = { _0: 71880, _1: 71848 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2984 = { _0: 71848, _1: 71880 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2985 = { _0: 71881, _1: 71849 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2986 = { _0: 71849, _1: 71881 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2987 = { _0: 71882, _1: 71850 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2988 = { _0: 71850, _1: 71882 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2989 = { _0: 71883, _1: 71851 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2990 = { _0: 71851, _1: 71883 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2991 = { _0: 71884, _1: 71852 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2992 = { _0: 71852, _1: 71884 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2993 = { _0: 71885, _1: 71853 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2994 = { _0: 71853, _1: 71885 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2995 = { _0: 71886, _1: 71854 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2996 = { _0: 71854, _1: 71886 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2997 = { _0: 71887, _1: 71855 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2998 = { _0: 71855, _1: 71887 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2999 = { _0: 71888, _1: 71856 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3000 = { _0: 71856, _1: 71888 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3001 = { _0: 71889, _1: 71857 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3002 = { _0: 71857, _1: 71889 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3003 = { _0: 71890, _1: 71858 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3004 = { _0: 71858, _1: 71890 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3005 = { _0: 71891, _1: 71859 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3006 = { _0: 71859, _1: 71891 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3007 = { _0: 71892, _1: 71860 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3008 = { _0: 71860, _1: 71892 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3009 = { _0: 71893, _1: 71861 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3010 = { _0: 71861, _1: 71893 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3011 = { _0: 71894, _1: 71862 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3012 = { _0: 71862, _1: 71894 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3013 = { _0: 71895, _1: 71863 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3014 = { _0: 71863, _1: 71895 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3015 = { _0: 71896, _1: 71864 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3016 = { _0: 71864, _1: 71896 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3017 = { _0: 71897, _1: 71865 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3018 = { _0: 71865, _1: 71897 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3019 = { _0: 71898, _1: 71866 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3020 = { _0: 71866, _1: 71898 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3021 = { _0: 71899, _1: 71867 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3022 = { _0: 71867, _1: 71899 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3023 = { _0: 71900, _1: 71868 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3024 = { _0: 71868, _1: 71900 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3025 = { _0: 71901, _1: 71869 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3026 = { _0: 71869, _1: 71901 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3027 = { _0: 71902, _1: 71870 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3028 = { _0: 71870, _1: 71902 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3029 = { _0: 71903, _1: 71871 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3030 = { _0: 71871, _1: 71903 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3031 = { _0: 93792, _1: 93760 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3032 = { _0: 93760, _1: 93792 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3033 = { _0: 93793, _1: 93761 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3034 = { _0: 93761, _1: 93793 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3035 = { _0: 93794, _1: 93762 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3036 = { _0: 93762, _1: 93794 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3037 = { _0: 93795, _1: 93763 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3038 = { _0: 93763, _1: 93795 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3039 = { _0: 93796, _1: 93764 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3040 = { _0: 93764, _1: 93796 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3041 = { _0: 93797, _1: 93765 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3042 = { _0: 93765, _1: 93797 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3043 = { _0: 93798, _1: 93766 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3044 = { _0: 93766, _1: 93798 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3045 = { _0: 93799, _1: 93767 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3046 = { _0: 93767, _1: 93799 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3047 = { _0: 93800, _1: 93768 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3048 = { _0: 93768, _1: 93800 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3049 = { _0: 93801, _1: 93769 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3050 = { _0: 93769, _1: 93801 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3051 = { _0: 93802, _1: 93770 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3052 = { _0: 93770, _1: 93802 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3053 = { _0: 93803, _1: 93771 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3054 = { _0: 93771, _1: 93803 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3055 = { _0: 93804, _1: 93772 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3056 = { _0: 93772, _1: 93804 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3057 = { _0: 93805, _1: 93773 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3058 = { _0: 93773, _1: 93805 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3059 = { _0: 93806, _1: 93774 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3060 = { _0: 93774, _1: 93806 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3061 = { _0: 93807, _1: 93775 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3062 = { _0: 93775, _1: 93807 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3063 = { _0: 93808, _1: 93776 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3064 = { _0: 93776, _1: 93808 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3065 = { _0: 93809, _1: 93777 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3066 = { _0: 93777, _1: 93809 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3067 = { _0: 93810, _1: 93778 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3068 = { _0: 93778, _1: 93810 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3069 = { _0: 93811, _1: 93779 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3070 = { _0: 93779, _1: 93811 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3071 = { _0: 93812, _1: 93780 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3072 = { _0: 93780, _1: 93812 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3073 = { _0: 93813, _1: 93781 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3074 = { _0: 93781, _1: 93813 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3075 = { _0: 93814, _1: 93782 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3076 = { _0: 93782, _1: 93814 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3077 = { _0: 93815, _1: 93783 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3078 = { _0: 93783, _1: 93815 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3079 = { _0: 93816, _1: 93784 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3080 = { _0: 93784, _1: 93816 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3081 = { _0: 93817, _1: 93785 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3082 = { _0: 93785, _1: 93817 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3083 = { _0: 93818, _1: 93786 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3084 = { _0: 93786, _1: 93818 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3085 = { _0: 93819, _1: 93787 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3086 = { _0: 93787, _1: 93819 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3087 = { _0: 93820, _1: 93788 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3088 = { _0: 93788, _1: 93820 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3089 = { _0: 93821, _1: 93789 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3090 = { _0: 93789, _1: 93821 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3091 = { _0: 93822, _1: 93790 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3092 = { _0: 93790, _1: 93822 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3093 = { _0: 93823, _1: 93791 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3094 = { _0: 93791, _1: 93823 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3095 = { _0: 125218, _1: 125184 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3096 = { _0: 125184, _1: 125218 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3097 = { _0: 125219, _1: 125185 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3098 = { _0: 125185, _1: 125219 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3099 = { _0: 125220, _1: 125186 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3100 = { _0: 125186, _1: 125220 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3101 = { _0: 125221, _1: 125187 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3102 = { _0: 125187, _1: 125221 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3103 = { _0: 125222, _1: 125188 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3104 = { _0: 125188, _1: 125222 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3105 = { _0: 125223, _1: 125189 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3106 = { _0: 125189, _1: 125223 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3107 = { _0: 125224, _1: 125190 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3108 = { _0: 125190, _1: 125224 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3109 = { _0: 125225, _1: 125191 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3110 = { _0: 125191, _1: 125225 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3111 = { _0: 125226, _1: 125192 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3112 = { _0: 125192, _1: 125226 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3113 = { _0: 125227, _1: 125193 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3114 = { _0: 125193, _1: 125227 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3115 = { _0: 125228, _1: 125194 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3116 = { _0: 125194, _1: 125228 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3117 = { _0: 125229, _1: 125195 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3118 = { _0: 125195, _1: 125229 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3119 = { _0: 125230, _1: 125196 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3120 = { _0: 125196, _1: 125230 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3121 = { _0: 125231, _1: 125197 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3122 = { _0: 125197, _1: 125231 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3123 = { _0: 125232, _1: 125198 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3124 = { _0: 125198, _1: 125232 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3125 = { _0: 125233, _1: 125199 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3126 = { _0: 125199, _1: 125233 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3127 = { _0: 125234, _1: 125200 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3128 = { _0: 125200, _1: 125234 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3129 = { _0: 125235, _1: 125201 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3130 = { _0: 125201, _1: 125235 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3131 = { _0: 125236, _1: 125202 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3132 = { _0: 125202, _1: 125236 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3133 = { _0: 125237, _1: 125203 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3134 = { _0: 125203, _1: 125237 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3135 = { _0: 125238, _1: 125204 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3136 = { _0: 125204, _1: 125238 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3137 = { _0: 125239, _1: 125205 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3138 = { _0: 125205, _1: 125239 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3139 = { _0: 125240, _1: 125206 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3140 = { _0: 125206, _1: 125240 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3141 = { _0: 125241, _1: 125207 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3142 = { _0: 125207, _1: 125241 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3143 = { _0: 125242, _1: 125208 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3144 = { _0: 125208, _1: 125242 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3145 = { _0: 125243, _1: 125209 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3146 = { _0: 125209, _1: 125243 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3147 = { _0: 125244, _1: 125210 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3148 = { _0: 125210, _1: 125244 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3149 = { _0: 125245, _1: 125211 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3150 = { _0: 125211, _1: 125245 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3151 = { _0: 125246, _1: 125212 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3152 = { _0: 125212, _1: 125246 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3153 = { _0: 125247, _1: 125213 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3154 = { _0: 125213, _1: 125247 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3155 = { _0: 125248, _1: 125214 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3156 = { _0: 125214, _1: 125248 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3157 = { _0: 125249, _1: 125215 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3158 = { _0: 125215, _1: 125249 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3159 = { _0: 125250, _1: 125216 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3160 = { _0: 125216, _1: 125250 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3161 = { _0: 125251, _1: 125217 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3162 = { _0: 125217, _1: 125251 };
const _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN7_2abindS116 = [_M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS225, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS226, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS227, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS228, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS229, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS230, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS231, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS232, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS233, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS234, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS235, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS236, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS237, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS238, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS239, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS240, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS241, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS242, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS243, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS244, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS245, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS246, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS247, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS248, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS249, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS250, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS251, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS252, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS253, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS254, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS255, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS256, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS257, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS258, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS259, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS260, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS261, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS262, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS263, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS264, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS265, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS266, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS267, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS268, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS269, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS270, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS271, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS272, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS273, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS274, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS275, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS276, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS277, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS278, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS279, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS280, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS281, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS282, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS283, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS284, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS285, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS286, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS287, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS288, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS289, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS290, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS291, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS292, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS293, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS294, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS295, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS296, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS297, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS298, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS299, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS300, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS301, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS302, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS303, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS304, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS305, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS306, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS307, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS308, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS309, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS310, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS311, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS312, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS313, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS314, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS315, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS316, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS317, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS318, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS319, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS320, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS321, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS322, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS323, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS324, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS325, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS326, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS327, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS328, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS329, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS330, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS331, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS332, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS333, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS334, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS335, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS336, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS337, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS338, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS339, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS340, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS341, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS342, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS343, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS344, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS345, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS346, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS347, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS348, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS349, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS350, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS351, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS352, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS353, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS354, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS355, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS356, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS357, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS358, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS359, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS360, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS361, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS362, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS363, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS364, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS365, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS366, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS367, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS368, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS369, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS370, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS371, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS372, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS373, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS374, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS375, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS376, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS377, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS378, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS379, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS380, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS381, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS382, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS383, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS384, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS385, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS386, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS387, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS388, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS389, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS390, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS391, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS392, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS393, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS394, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS395, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS396, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS397, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS398, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS399, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS400, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS401, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS402, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS403, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS404, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS405, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS406, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS407, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS408, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS409, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS410, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS411, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS412, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS413, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS414, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS415, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS416, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS417, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS418, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS419, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS420, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS421, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS422, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS423, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS424, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS425, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS426, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS427, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS428, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS429, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS430, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS431, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS432, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS433, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS434, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS435, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS436, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS437, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS438, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS439, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS440, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS441, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS442, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS443, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS444, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS445, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS446, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS447, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS448, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS449, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS450, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS451, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS452, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS453, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS454, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS455, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS456, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS457, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS458, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS459, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS460, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS461, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS462, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS463, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS464, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS465, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS466, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS467, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS468, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS469, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS470, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS471, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS472, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS473, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS474, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS475, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS476, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS477, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS478, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS479, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS480, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS481, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS482, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS483, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS484, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS485, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS486, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS487, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS488, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS489, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS490, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS491, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS492, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS493, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS494, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS495, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS496, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS497, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS498, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS499, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS500, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS501, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS502, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS503, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS504, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS505, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS506, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS507, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS508, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS509, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS510, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS511, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS512, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS513, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS514, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS515, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS516, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS517, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS518, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS519, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS520, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS521, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS522, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS523, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS524, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS525, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS526, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS527, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS528, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS529, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS530, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS531, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS532, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS533, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS534, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS535, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS536, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS537, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS538, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS539, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS540, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS541, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS542, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS543, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS544, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS545, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS546, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS547, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS548, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS549, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS550, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS551, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS552, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS553, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS554, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS555, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS556, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS557, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS558, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS559, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS560, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS561, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS562, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS563, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS564, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS565, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS566, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS567, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS568, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS569, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS570, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS571, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS572, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS573, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS574, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS575, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS576, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS577, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS578, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS579, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS580, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS581, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS582, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS583, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS584, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS585, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS586, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS587, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS588, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS589, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS590, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS591, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS592, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS593, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS594, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS595, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS596, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS597, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS598, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS599, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS600, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS601, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS602, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS603, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS604, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS605, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS606, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS607, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS608, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS609, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS610, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS611, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS612, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS613, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS614, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS615, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS616, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS617, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS618, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS619, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS620, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS621, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS622, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS623, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS624, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS625, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS626, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS627, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS628, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS629, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS630, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS631, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS632, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS633, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS634, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS635, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS636, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS637, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS638, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS639, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS640, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS641, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS642, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS643, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS644, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS645, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS646, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS647, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS648, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS649, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS650, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS651, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS652, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS653, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS654, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS655, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS656, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS657, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS658, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS659, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS660, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS661, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS662, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS663, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS664, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS665, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS666, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS667, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS668, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS669, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS670, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS671, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS672, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS673, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS674, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS675, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS676, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS677, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS678, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS679, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS680, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS681, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS682, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS683, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS684, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS685, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS686, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS687, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS688, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS689, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS690, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS691, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS692, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS693, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS694, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS695, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS696, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS697, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS698, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS699, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS700, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS701, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS702, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS703, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS704, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS705, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS706, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS707, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS708, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS709, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS710, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS711, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS712, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS713, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS714, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS715, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS716, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS717, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS718, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS719, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS720, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS721, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS722, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS723, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS724, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS725, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS726, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS727, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS728, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS729, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS730, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS731, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS732, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS733, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS734, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS735, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS736, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS737, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS738, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS739, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS740, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS741, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS742, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS743, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS744, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS745, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS746, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS747, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS748, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS749, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS750, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS751, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS752, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS753, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS754, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS755, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS756, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS757, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS758, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS759, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS760, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS761, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS762, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS763, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS764, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS765, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS766, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS767, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS768, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS769, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS770, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS771, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS772, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS773, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS774, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS775, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS776, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS777, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS778, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS779, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS780, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS781, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS782, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS783, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS784, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS785, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS786, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS787, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS788, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS789, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS790, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS791, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS792, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS793, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS794, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS795, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS796, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS797, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS798, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS799, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS800, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS801, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS802, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS803, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS804, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS805, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS806, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS807, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS808, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS809, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS810, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS811, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS812, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS813, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS814, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS815, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS816, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS817, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS818, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS819, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS820, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS821, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS822, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS823, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS824, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS825, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS826, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS827, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS828, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS829, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS830, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS831, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS832, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS833, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS834, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS835, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS836, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS837, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS838, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS839, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS840, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS841, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS842, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS843, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS844, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS845, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS846, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS847, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS848, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS849, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS850, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS851, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS852, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS853, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS854, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS855, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS856, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS857, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS858, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS859, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS860, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS861, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS862, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS863, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS864, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS865, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS866, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS867, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS868, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS869, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS870, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS871, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS872, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS873, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS874, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS875, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS876, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS877, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS878, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS879, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS880, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS881, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS882, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS883, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS884, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS885, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS886, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS887, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS888, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS889, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS890, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS891, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS892, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS893, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS894, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS895, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS896, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS897, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS898, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS899, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS900, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS901, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS902, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS903, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS904, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS905, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS906, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS907, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS908, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS909, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS910, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS911, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS912, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS913, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS914, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS915, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS916, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS917, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS918, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS919, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS920, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS921, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS922, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS923, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS924, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS925, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS926, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS927, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS928, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS929, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS930, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS931, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS932, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS933, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS934, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS935, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS936, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS937, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS938, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS939, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS940, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS941, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS942, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS943, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS944, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS945, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS946, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS947, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS948, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS949, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS950, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS951, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS952, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS953, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS954, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS955, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS956, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS957, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS958, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS959, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS960, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS961, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS962, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS963, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS964, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS965, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS966, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS967, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS968, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS969, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS970, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS971, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS972, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS973, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS974, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS975, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS976, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS977, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS978, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS979, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS980, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS981, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS982, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS983, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS984, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS985, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS986, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS987, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS988, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS989, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS990, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS991, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS992, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS993, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS994, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS995, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS996, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS997, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS998, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS999, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1000, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1001, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1002, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1003, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1004, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1005, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1006, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1007, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1008, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1009, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1010, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1011, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1012, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1013, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1014, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1015, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1016, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1017, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1018, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1019, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1020, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1021, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1022, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1023, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1024, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1025, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1026, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1027, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1028, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1029, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1030, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1031, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1032, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1033, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1034, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1035, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1036, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1037, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1038, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1039, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1040, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1041, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1042, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1043, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1044, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1045, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1046, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1047, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1048, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1049, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1050, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1051, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1052, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1053, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1054, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1055, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1056, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1057, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1058, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1059, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1060, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1061, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1062, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1063, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1064, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1065, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1066, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1067, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1068, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1069, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1070, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1071, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1072, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1073, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1074, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1075, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1076, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1077, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1078, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1079, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1080, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1081, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1082, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1083, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1084, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1085, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1086, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1087, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1088, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1089, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1090, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1091, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1092, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1093, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1094, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1095, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1096, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1097, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1098, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1099, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1100, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1101, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1102, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1103, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1104, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1105, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1106, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1107, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1108, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1109, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1110, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1111, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1112, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1113, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1114, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1115, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1116, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1117, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1118, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1119, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1120, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1121, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1122, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1123, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1124, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1125, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1126, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1127, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1128, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1129, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1130, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1131, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1132, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1133, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1134, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1135, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1136, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1137, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1138, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1139, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1140, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1141, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1142, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1143, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1144, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1145, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1146, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1147, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1148, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1149, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1150, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1151, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1152, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1153, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1154, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1155, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1156, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1157, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1158, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1159, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1160, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1161, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1162, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1163, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1164, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1165, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1166, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1167, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1168, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1169, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1170, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1171, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1172, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1173, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1174, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1175, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1176, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1177, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1178, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1179, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1180, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1181, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1182, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1183, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1184, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1185, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1186, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1187, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1188, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1189, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1190, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1191, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1192, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1193, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1194, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1195, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1196, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1197, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1198, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1199, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1200, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1201, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1202, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1203, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1204, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1205, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1206, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1207, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1208, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1209, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1210, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1211, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1212, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1213, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1214, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1215, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1216, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1217, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1218, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1219, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1220, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1221, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1222, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1223, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1224, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1225, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1226, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1227, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1228, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1229, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1230, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1231, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1232, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1233, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1234, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1235, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1236, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1237, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1238, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1239, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1240, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1241, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1242, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1243, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1244, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1245, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1246, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1247, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1248, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1249, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1250, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1251, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1252, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1253, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1254, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1255, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1256, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1257, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1258, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1259, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1260, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1261, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1262, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1263, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1264, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1265, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1266, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1267, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1268, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1269, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1270, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1271, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1272, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1273, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1274, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1275, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1276, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1277, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1278, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1279, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1280, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1281, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1282, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1283, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1284, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1285, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1286, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1287, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1288, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1289, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1290, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1291, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1292, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1293, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1294, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1295, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1296, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1297, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1298, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1299, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1300, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1301, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1302, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1303, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1304, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1305, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1306, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1307, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1308, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1309, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1310, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1311, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1312, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1313, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1314, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1315, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1316, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1317, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1318, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1319, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1320, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1321, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1322, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1323, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1324, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1325, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1326, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1327, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1328, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1329, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1330, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1331, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1332, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1333, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1334, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1335, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1336, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1337, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1338, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1339, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1340, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1341, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1342, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1343, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1344, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1345, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1346, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1347, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1348, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1349, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1350, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1351, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1352, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1353, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1354, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1355, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1356, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1357, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1358, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1359, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1360, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1361, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1362, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1363, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1364, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1365, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1366, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1367, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1368, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1369, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1370, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1371, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1372, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1373, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1374, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1375, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1376, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1377, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1378, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1379, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1380, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1381, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1382, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1383, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1384, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1385, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1386, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1387, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1388, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1389, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1390, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1391, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1392, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1393, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1394, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1395, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1396, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1397, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1398, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1399, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1400, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1401, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1402, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1403, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1404, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1405, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1406, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1407, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1408, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1409, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1410, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1411, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1412, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1413, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1414, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1415, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1416, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1417, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1418, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1419, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1420, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1421, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1422, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1423, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1424, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1425, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1426, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1427, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1428, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1429, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1430, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1431, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1432, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1433, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1434, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1435, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1436, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1437, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1438, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1439, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1440, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1441, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1442, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1443, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1444, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1445, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1446, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1447, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1448, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1449, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1450, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1451, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1452, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1453, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1454, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1455, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1456, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1457, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1458, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1459, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1460, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1461, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1462, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1463, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1464, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1465, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1466, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1467, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1468, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1469, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1470, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1471, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1472, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1473, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1474, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1475, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1476, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1477, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1478, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1479, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1480, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1481, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1482, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1483, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1484, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1485, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1486, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1487, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1488, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1489, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1490, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1491, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1492, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1493, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1494, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1495, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1496, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1497, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1498, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1499, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1500, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1501, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1502, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1503, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1504, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1505, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1506, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1507, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1508, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1509, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1510, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1511, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1512, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1513, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1514, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1515, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1516, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1517, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1518, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1519, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1520, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1521, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1522, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1523, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1524, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1525, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1526, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1527, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1528, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1529, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1530, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1531, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1532, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1533, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1534, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1535, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1536, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1537, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1538, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1539, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1540, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1541, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1542, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1543, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1544, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1545, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1546, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1547, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1548, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1549, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1550, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1551, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1552, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1553, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1554, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1555, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1556, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1557, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1558, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1559, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1560, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1561, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1562, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1563, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1564, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1565, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1566, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1567, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1568, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1569, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1570, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1571, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1572, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1573, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1574, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1575, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1576, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1577, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1578, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1579, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1580, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1581, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1582, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1583, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1584, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1585, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1586, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1587, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1588, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1589, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1590, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1591, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1592, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1593, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1594, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1595, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1596, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1597, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1598, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1599, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1600, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1601, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1602, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1603, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1604, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1605, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1606, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1607, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1608, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1609, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1610, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1611, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1612, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1613, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1614, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1615, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1616, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1617, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1618, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1619, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1620, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1621, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1622, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1623, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1624, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1625, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1626, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1627, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1628, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1629, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1630, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1631, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1632, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1633, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1634, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1635, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1636, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1637, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1638, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1639, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1640, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1641, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1642, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1643, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1644, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1645, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1646, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1647, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1648, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1649, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1650, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1651, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1652, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1653, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1654, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1655, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1656, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1657, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1658, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1659, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1660, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1661, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1662, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1663, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1664, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1665, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1666, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1667, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1668, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1669, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1670, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1671, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1672, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1673, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1674, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1675, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1676, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1677, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1678, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1679, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1680, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1681, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1682, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1683, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1684, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1685, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1686, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1687, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1688, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1689, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1690, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1691, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1692, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1693, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1694, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1695, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1696, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1697, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1698, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1699, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1700, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1701, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1702, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1703, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1704, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1705, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1706, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1707, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1708, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1709, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1710, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1711, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1712, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1713, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1714, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1715, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1716, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1717, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1718, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1719, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1720, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1721, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1722, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1723, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1724, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1725, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1726, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1727, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1728, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1729, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1730, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1731, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1732, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1733, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1734, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1735, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1736, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1737, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1738, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1739, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1740, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1741, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1742, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1743, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1744, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1745, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1746, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1747, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1748, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1749, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1750, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1751, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1752, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1753, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1754, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1755, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1756, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1757, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1758, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1759, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1760, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1761, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1762, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1763, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1764, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1765, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1766, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1767, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1768, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1769, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1770, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1771, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1772, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1773, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1774, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1775, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1776, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1777, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1778, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1779, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1780, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1781, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1782, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1783, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1784, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1785, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1786, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1787, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1788, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1789, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1790, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1791, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1792, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1793, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1794, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1795, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1796, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1797, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1798, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1799, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1800, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1801, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1802, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1803, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1804, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1805, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1806, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1807, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1808, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1809, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1810, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1811, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1812, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1813, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1814, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1815, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1816, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1817, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1818, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1819, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1820, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1821, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1822, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1823, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1824, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1825, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1826, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1827, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1828, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1829, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1830, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1831, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1832, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1833, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1834, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1835, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1836, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1837, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1838, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1839, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1840, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1841, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1842, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1843, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1844, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1845, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1846, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1847, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1848, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1849, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1850, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1851, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1852, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1853, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1854, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1855, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1856, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1857, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1858, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1859, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1860, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1861, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1862, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1863, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1864, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1865, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1866, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1867, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1868, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1869, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1870, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1871, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1872, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1873, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1874, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1875, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1876, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1877, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1878, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1879, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1880, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1881, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1882, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1883, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1884, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1885, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1886, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1887, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1888, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1889, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1890, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1891, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1892, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1893, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1894, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1895, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1896, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1897, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1898, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1899, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1900, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1901, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1902, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1903, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1904, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1905, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1906, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1907, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1908, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1909, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1910, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1911, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1912, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1913, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1914, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1915, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1916, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1917, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1918, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1919, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1920, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1921, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1922, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1923, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1924, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1925, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1926, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1927, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1928, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1929, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1930, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1931, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1932, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1933, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1934, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1935, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1936, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1937, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1938, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1939, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1940, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1941, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1942, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1943, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1944, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1945, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1946, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1947, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1948, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1949, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1950, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1951, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1952, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1953, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1954, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1955, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1956, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1957, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1958, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1959, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1960, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1961, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1962, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1963, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1964, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1965, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1966, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1967, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1968, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1969, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1970, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1971, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1972, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1973, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1974, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1975, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1976, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1977, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1978, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1979, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1980, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1981, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1982, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1983, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1984, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1985, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1986, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1987, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1988, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1989, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1990, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1991, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1992, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1993, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1994, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1995, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1996, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1997, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1998, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS1999, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2000, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2001, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2002, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2003, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2004, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2005, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2006, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2007, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2008, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2009, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2010, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2011, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2012, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2013, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2014, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2015, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2016, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2017, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2018, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2019, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2020, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2021, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2022, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2023, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2024, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2025, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2026, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2027, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2028, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2029, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2030, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2031, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2032, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2033, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2034, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2035, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2036, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2037, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2038, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2039, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2040, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2041, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2042, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2043, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2044, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2045, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2046, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2047, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2048, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2049, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2050, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2051, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2052, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2053, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2054, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2055, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2056, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2057, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2058, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2059, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2060, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2061, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2062, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2063, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2064, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2065, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2066, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2067, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2068, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2069, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2070, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2071, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2072, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2073, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2074, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2075, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2076, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2077, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2078, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2079, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2080, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2081, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2082, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2083, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2084, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2085, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2086, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2087, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2088, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2089, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2090, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2091, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2092, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2093, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2094, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2095, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2096, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2097, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2098, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2099, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2100, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2101, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2102, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2103, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2104, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2105, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2106, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2107, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2108, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2109, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2110, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2111, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2112, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2113, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2114, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2115, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2116, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2117, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2118, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2119, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2120, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2121, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2122, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2123, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2124, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2125, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2126, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2127, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2128, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2129, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2130, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2131, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2132, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2133, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2134, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2135, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2136, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2137, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2138, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2139, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2140, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2141, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2142, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2143, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2144, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2145, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2146, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2147, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2148, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2149, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2150, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2151, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2152, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2153, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2154, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2155, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2156, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2157, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2158, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2159, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2160, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2161, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2162, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2163, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2164, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2165, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2166, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2167, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2168, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2169, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2170, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2171, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2172, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2173, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2174, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2175, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2176, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2177, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2178, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2179, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2180, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2181, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2182, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2183, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2184, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2185, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2186, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2187, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2188, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2189, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2190, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2191, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2192, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2193, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2194, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2195, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2196, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2197, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2198, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2199, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2200, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2201, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2202, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2203, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2204, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2205, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2206, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2207, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2208, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2209, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2210, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2211, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2212, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2213, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2214, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2215, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2216, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2217, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2218, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2219, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2220, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2221, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2222, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2223, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2224, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2225, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2226, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2227, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2228, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2229, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2230, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2231, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2232, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2233, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2234, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2235, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2236, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2237, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2238, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2239, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2240, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2241, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2242, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2243, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2244, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2245, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2246, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2247, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2248, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2249, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2250, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2251, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2252, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2253, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2254, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2255, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2256, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2257, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2258, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2259, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2260, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2261, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2262, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2263, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2264, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2265, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2266, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2267, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2268, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2269, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2270, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2271, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2272, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2273, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2274, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2275, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2276, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2277, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2278, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2279, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2280, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2281, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2282, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2283, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2284, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2285, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2286, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2287, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2288, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2289, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2290, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2291, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2292, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2293, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2294, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2295, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2296, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2297, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2298, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2299, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2300, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2301, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2302, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2303, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2304, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2305, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2306, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2307, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2308, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2309, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2310, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2311, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2312, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2313, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2314, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2315, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2316, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2317, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2318, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2319, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2320, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2321, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2322, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2323, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2324, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2325, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2326, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2327, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2328, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2329, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2330, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2331, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2332, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2333, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2334, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2335, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2336, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2337, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2338, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2339, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2340, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2341, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2342, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2343, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2344, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2345, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2346, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2347, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2348, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2349, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2350, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2351, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2352, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2353, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2354, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2355, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2356, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2357, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2358, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2359, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2360, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2361, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2362, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2363, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2364, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2365, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2366, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2367, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2368, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2369, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2370, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2371, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2372, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2373, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2374, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2375, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2376, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2377, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2378, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2379, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2380, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2381, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2382, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2383, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2384, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2385, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2386, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2387, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2388, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2389, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2390, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2391, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2392, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2393, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2394, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2395, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2396, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2397, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2398, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2399, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2400, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2401, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2402, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2403, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2404, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2405, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2406, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2407, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2408, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2409, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2410, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2411, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2412, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2413, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2414, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2415, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2416, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2417, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2418, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2419, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2420, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2421, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2422, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2423, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2424, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2425, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2426, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2427, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2428, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2429, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2430, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2431, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2432, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2433, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2434, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2435, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2436, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2437, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2438, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2439, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2440, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2441, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2442, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2443, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2444, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2445, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2446, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2447, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2448, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2449, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2450, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2451, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2452, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2453, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2454, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2455, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2456, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2457, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2458, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2459, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2460, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2461, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2462, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2463, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2464, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2465, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2466, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2467, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2468, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2469, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2470, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2471, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2472, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2473, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2474, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2475, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2476, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2477, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2478, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2479, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2480, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2481, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2482, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2483, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2484, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2485, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2486, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2487, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2488, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2489, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2490, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2491, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2492, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2493, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2494, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2495, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2496, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2497, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2498, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2499, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2500, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2501, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2502, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2503, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2504, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2505, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2506, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2507, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2508, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2509, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2510, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2511, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2512, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2513, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2514, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2515, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2516, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2517, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2518, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2519, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2520, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2521, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2522, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2523, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2524, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2525, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2526, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2527, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2528, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2529, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2530, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2531, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2532, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2533, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2534, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2535, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2536, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2537, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2538, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2539, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2540, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2541, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2542, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2543, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2544, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2545, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2546, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2547, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2548, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2549, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2550, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2551, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2552, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2553, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2554, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2555, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2556, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2557, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2558, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2559, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2560, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2561, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2562, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2563, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2564, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2565, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2566, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2567, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2568, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2569, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2570, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2571, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2572, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2573, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2574, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2575, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2576, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2577, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2578, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2579, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2580, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2581, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2582, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2583, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2584, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2585, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2586, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2587, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2588, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2589, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2590, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2591, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2592, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2593, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2594, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2595, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2596, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2597, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2598, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2599, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2600, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2601, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2602, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2603, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2604, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2605, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2606, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2607, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2608, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2609, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2610, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2611, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2612, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2613, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2614, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2615, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2616, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2617, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2618, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2619, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2620, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2621, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2622, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2623, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2624, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2625, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2626, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2627, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2628, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2629, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2630, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2631, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2632, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2633, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2634, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2635, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2636, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2637, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2638, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2639, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2640, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2641, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2642, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2643, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2644, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2645, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2646, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2647, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2648, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2649, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2650, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2651, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2652, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2653, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2654, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2655, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2656, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2657, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2658, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2659, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2660, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2661, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2662, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2663, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2664, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2665, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2666, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2667, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2668, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2669, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2670, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2671, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2672, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2673, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2674, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2675, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2676, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2677, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2678, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2679, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2680, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2681, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2682, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2683, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2684, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2685, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2686, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2687, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2688, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2689, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2690, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2691, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2692, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2693, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2694, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2695, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2696, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2697, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2698, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2699, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2700, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2701, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2702, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2703, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2704, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2705, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2706, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2707, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2708, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2709, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2710, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2711, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2712, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2713, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2714, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2715, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2716, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2717, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2718, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2719, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2720, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2721, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2722, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2723, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2724, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2725, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2726, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2727, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2728, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2729, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2730, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2731, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2732, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2733, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2734, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2735, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2736, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2737, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2738, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2739, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2740, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2741, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2742, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2743, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2744, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2745, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2746, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2747, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2748, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2749, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2750, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2751, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2752, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2753, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2754, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2755, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2756, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2757, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2758, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2759, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2760, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2761, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2762, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2763, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2764, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2765, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2766, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2767, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2768, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2769, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2770, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2771, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2772, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2773, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2774, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2775, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2776, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2777, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2778, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2779, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2780, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2781, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2782, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2783, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2784, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2785, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2786, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2787, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2788, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2789, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2790, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2791, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2792, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2793, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2794, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2795, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2796, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2797, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2798, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2799, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2800, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2801, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2802, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2803, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2804, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2805, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2806, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2807, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2808, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2809, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2810, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2811, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2812, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2813, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2814, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2815, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2816, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2817, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2818, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2819, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2820, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2821, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2822, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2823, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2824, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2825, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2826, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2827, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2828, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2829, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2830, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2831, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2832, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2833, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2834, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2835, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2836, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2837, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2838, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2839, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2840, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2841, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2842, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2843, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2844, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2845, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2846, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2847, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2848, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2849, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2850, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2851, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2852, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2853, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2854, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2855, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2856, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2857, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2858, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2859, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2860, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2861, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2862, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2863, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2864, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2865, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2866, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2867, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2868, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2869, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2870, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2871, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2872, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2873, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2874, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2875, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2876, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2877, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2878, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2879, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2880, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2881, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2882, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2883, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2884, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2885, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2886, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2887, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2888, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2889, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2890, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2891, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2892, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2893, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2894, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2895, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2896, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2897, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2898, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2899, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2900, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2901, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2902, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2903, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2904, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2905, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2906, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2907, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2908, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2909, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2910, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2911, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2912, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2913, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2914, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2915, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2916, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2917, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2918, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2919, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2920, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2921, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2922, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2923, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2924, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2925, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2926, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2927, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2928, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2929, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2930, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2931, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2932, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2933, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2934, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2935, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2936, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2937, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2938, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2939, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2940, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2941, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2942, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2943, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2944, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2945, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2946, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2947, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2948, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2949, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2950, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2951, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2952, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2953, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2954, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2955, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2956, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2957, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2958, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2959, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2960, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2961, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2962, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2963, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2964, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2965, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2966, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2967, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2968, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2969, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2970, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2971, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2972, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2973, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2974, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2975, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2976, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2977, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2978, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2979, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2980, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2981, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2982, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2983, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2984, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2985, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2986, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2987, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2988, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2989, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2990, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2991, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2992, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2993, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2994, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2995, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2996, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2997, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2998, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS2999, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3000, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3001, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3002, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3003, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3004, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3005, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3006, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3007, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3008, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3009, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3010, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3011, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3012, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3013, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3014, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3015, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3016, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3017, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3018, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3019, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3020, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3021, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3022, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3023, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3024, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3025, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3026, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3027, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3028, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3029, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3030, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3031, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3032, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3033, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3034, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3035, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3036, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3037, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3038, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3039, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3040, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3041, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3042, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3043, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3044, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3045, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3046, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3047, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3048, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3049, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3050, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3051, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3052, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3053, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3054, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3055, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3056, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3057, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3058, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3059, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3060, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3061, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3062, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3063, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3064, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3065, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3066, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3067, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3068, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3069, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3070, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3071, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3072, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3073, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3074, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3075, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3076, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3077, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3078, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3079, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3080, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3081, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3082, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3083, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3084, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3085, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3086, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3087, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3088, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3089, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3090, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3091, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3092, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3093, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3094, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3095, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3096, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3097, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3098, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3099, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3100, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3101, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3102, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3103, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3104, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3105, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3106, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3107, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3108, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3109, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3110, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3111, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3112, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3113, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3114, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3115, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3116, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3117, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3118, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3119, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3120, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3121, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3122, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3123, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3124, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3125, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3126, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3127, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3128, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3129, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3130, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3131, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3132, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3133, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3134, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3135, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3136, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3137, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3138, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3139, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3140, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3141, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3142, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3143, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3144, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3145, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3146, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3147, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3148, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3149, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3150, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3151, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3152, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3153, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3154, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3155, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3156, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3157, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3158, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3159, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3160, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3161, _M0FP411moonbitlang6regexp8internal7unicode13case__foldingN5tupleS3162];
const _M0FP411moonbitlang6regexp8internal7unicode13case__folding = _M0MPB3Map3MapGccE(new _M0TPB9ArrayViewGUccEE(_M0FP411moonbitlang6regexp8internal7unicode13case__foldingN7_2abindS116, 0, 2938), undefined);
const _M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN6constrS659 = new _M0DTP411moonbitlang6regexp8internal3ast3Ast9Assertion(4);
const _M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN6constrS660 = new _M0DTP411moonbitlang6regexp8internal3ast3Ast9Assertion(5);
const _M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN7_2abindS507 = [9, 9];
const _M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN7_2abindS508 = [10, 10];
const _M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN7_2abindS509 = [11, 11];
const _M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN7_2abindS510 = [12, 12];
const _M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN7_2abindS511 = [13, 13];
const _M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN7_2abindS513 = [0, 0];
const _M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN6constrS661 = new _M0DTP411moonbitlang6regexp8internal3ast3Ast9Assertion(3);
const _M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN6constrS662 = new _M0DTP411moonbitlang6regexp8internal3ast3Ast9Assertion(1);
const _M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN6constrS663 = new _M0DTP411moonbitlang6regexp8internal3ast3Ast9Assertion(2);
const _M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN6constrS664 = new _M0DTP411moonbitlang6regexp8internal3ast3Ast9Assertion(0);
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32parse__loop__control__count__argN6constrS11269 = 1;
const _M0FP410Haoxincode8moonbash3lib11interpreter27printf__increment__fractionN5tupleS11270 = { _0: "", _1: true };
const _M0FP410Haoxincode8moonbash3lib11interpreter14format__printfN6constrS11271 = 0;
const _M0FP410Haoxincode8moonbash3lib11interpreter27sed__address__tick__skippedN6recordS11261 = new _M0TP410Haoxincode8moonbash3lib11interpreter13SedRangeState(false, -1, true);
const _M0FP410Haoxincode8moonbash3lib11interpreter27sed__address__tick__skippedN6recordS11262 = new _M0TP410Haoxincode8moonbash3lib11interpreter13SedRangeState(false, -1, true);
const _M0FP410Haoxincode8moonbash3lib11interpreter27sed__address__tick__skippedN6recordS11263 = new _M0TP410Haoxincode8moonbash3lib11interpreter13SedRangeState(true, -1, false);
const _M0FP410Haoxincode8moonbash3lib11interpreter27sed__address__tick__skippedN6recordS11264 = new _M0TP410Haoxincode8moonbash3lib11interpreter13SedRangeState(true, -1, false);
const _M0FP410Haoxincode8moonbash3lib11interpreter21sed__address__appliesN6recordS11260 = new _M0TP410Haoxincode8moonbash3lib11interpreter13SedRangeState(true, -1, false);
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__setN6constrS11272 = 2;
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__setN6constrS11273 = 2;
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext46test__parse__double__bracket__numeric__operandN6constrS11274 = 0n;
const _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext46test__parse__double__bracket__numeric__operandN6constrS11275 = 0n;
function _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE(msg) {
  return $panic();
}
function _M0FPC15abort5abortGuE(msg) {
  $panic();
}
function _M0FPC15abort5abortGRPB5ArrayGRP219moonbit_2dcommunity7piediff4HunkGsEEE(msg) {
  return $panic();
}
function _M0FPC15abort5abortGyE(msg) {
  return $panic();
}
function _M0FPC15abort5abortGiE(msg) {
  return $panic();
}
function _M0FPC15abort5abortGOiE(msg) {
  return $panic();
}
function _M0FPC15abort5abortGkE(msg) {
  return $panic();
}
function _M0FPC15abort5abortGcE(msg) {
  return $panic();
}
function _M0FPC15abort5abortGRP210tonyfettes3url4IPv4E(msg) {
  return $panic();
}
function _M0MPC14json4Json5array(array) {
  return new _M0DTPB4Json5Array(array);
}
function _M0MPB6Logger13write__objectGRP219moonbit_2dcommunity4yaml6MarkerE(self, obj) {
  _M0IP219moonbit_2dcommunity4yaml6MarkerPB4Show6output(obj, self);
}
function _M0MPB6Logger13write__objectGsE(self, obj) {
  _M0IP016_24default__implPB4Show6outputGsE(obj, self);
}
function _M0MPB6Logger13write__objectGiE(self, obj) {
  _M0IP016_24default__implPB4Show6outputGiE(obj, self);
}
function _M0MPB6Logger13write__objectGRP219moonbit_2dcommunity4yaml12TScalarStyleE(self, obj) {
  _M0IP219moonbit_2dcommunity4yaml12TScalarStylePB4Show6output(obj, self);
}
function _M0MPB6Logger13write__objectGORP219moonbit_2dcommunity4yaml3TagE(self, obj) {
  _M0IPC16option6OptionPB4Show6outputGRP219moonbit_2dcommunity4yaml3TagE(obj, self);
}
function _M0MPB6Logger13write__objectGdE(self, obj) {
  _M0IP016_24default__implPB4Show6outputGdE(obj, self);
}
function _M0MPB6Logger13write__objectGRPB5ArrayGUsOsEEE(self, obj) {
  _M0IPC15array5ArrayPB4Show6outputGUsOsEE(obj, self);
}
function _M0MPB6Logger13write__objectGRPB4JsonE(self, obj) {
  _M0IPC14json4JsonPB4Show6output(obj, self);
}
function _M0MPB6Logger13write__objectGRP219moonbit_2dcommunity4yaml3TagE(self, obj) {
  _M0IP219moonbit_2dcommunity4yaml3TagPB4Show6output(obj, self);
}
function _M0MPB6Logger13write__objectGUsOsEE(self, obj) {
  _M0IPC15tuple6Tuple2PB4Show6outputGsOsE(obj, self);
}
function _M0MPB6Logger13write__objectGOsE(self, obj) {
  _M0IPC16option6OptionPB4Show6outputGsE(obj, self);
}
function _M0MPB6Logger13write__objectGRP411moonbitlang6regexp8internal5parse3ErrE(self, obj) {
  _M0IP411moonbitlang6regexp8internal5parse3ErrPB4Show6output(obj, self);
}
function _M0MPB6Logger13write__objectGRPC16string10StringViewE(self, obj) {
  _M0IPC16string10StringViewPB4Show6output(obj, self);
}
function _M0MPB6Logger13write__objectGcE(self, obj) {
  _M0IP016_24default__implPB4Show6outputGcE(obj, self);
}
function _M0MPB6Logger13write__objectGRP310tonyfettes7unicode8punycode13PunycodeErrorE(self, obj) {
  _M0IP310tonyfettes7unicode8punycode13PunycodeErrorPB4Show6output(obj, self);
}
function _M0MPB6Logger13write__objectGRP211moonbitlang6regexp3ErrE(self, obj) {
  _M0IP211moonbitlang6regexp3ErrPB4Show6output(obj, self);
}
function _M0IPB7FailurePB4Show6output(_x_4786, _x_4787) {
  const _Failure = _x_4786;
  const _$42$arg_4788 = _Failure._0;
  _x_4787.method_table.method_0(_x_4787.self, "Failure(");
  _M0MPB6Logger13write__objectGsE(_x_4787, _$42$arg_4788);
  _x_4787.method_table.method_0(_x_4787.self, ")");
}
function _M0MPB6Hasher8consume4(self, input) {
  const _p$4 = (self.acc >>> 0) + ((Math.imul(input, -1028477379) | 0) >>> 0) | 0;
  const _p$5 = 17;
  self.acc = Math.imul(_p$4 << _p$5 | (_p$4 >>> (32 - _p$5 | 0) | 0), 668265263) | 0;
}
function _M0MPB6Hasher13combine__uint(self, value) {
  self.acc = (self.acc >>> 0) + (4 >>> 0) | 0;
  _M0MPB6Hasher8consume4(self, value);
}
function _M0MPB18UninitializedArray11sub_2einnerGcE(self, start, end) {
  const len = self.length;
  let end$2;
  if (end === undefined) {
    end$2 = len;
  } else {
    const _Some = end;
    end$2 = _Some;
  }
  if (start >= 0 && (start <= end$2 && end$2 <= len)) {
    const _bind$4 = end$2 - start | 0;
    return new _M0TPB9ArrayViewGcE(self, start, start + _bind$4 | 0);
  } else {
    return _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("View start index out of bounds");
  }
}
function _M0MPB18UninitializedArray11sub_2einnerGRP219moonbit_2dcommunity4yaml5TokenE(self, start, end) {
  const len = self.length;
  let end$2;
  if (end === undefined) {
    end$2 = len;
  } else {
    const _Some = end;
    end$2 = _Some;
  }
  if (start >= 0 && (start <= end$2 && end$2 <= len)) {
    const _bind$4 = end$2 - start | 0;
    return new _M0TPB9ArrayViewGRP219moonbit_2dcommunity4yaml5TokenE(self, start, start + _bind$4 | 0);
  } else {
    return _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("View start index out of bounds");
  }
}
function _M0MPC15array10FixedArray12unsafe__blitGyE(dst, dst_offset, src, src_offset, len) {
  if (dst === src && dst_offset < src_offset) {
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < len) {
        const _tmp$39 = dst_offset + i | 0;
        const _tmp$40 = src_offset + i | 0;
        $bound_check(src, _tmp$40);
        $bound_check(dst, _tmp$39);
        dst[_tmp$39] = src[_tmp$40];
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        return;
      }
    }
  } else {
    let _tmp$38 = len - 1 | 0;
    while (true) {
      const i = _tmp$38;
      if (i >= 0) {
        const _tmp$39 = dst_offset + i | 0;
        const _tmp$40 = src_offset + i | 0;
        $bound_check(src, _tmp$40);
        $bound_check(dst, _tmp$39);
        dst[_tmp$39] = src[_tmp$40];
        _tmp$38 = i - 1 | 0;
        continue;
      } else {
        return;
      }
    }
  }
}
function _M0MPC15array10FixedArray12unsafe__blitGRPB17UnsafeMaybeUninitGyEE(dst, dst_offset, src, src_offset, len) {
  if (dst === src && dst_offset < src_offset) {
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < len) {
        const _tmp$39 = dst_offset + i | 0;
        const _tmp$40 = src_offset + i | 0;
        $bound_check(src, _tmp$40);
        $bound_check(dst, _tmp$39);
        dst[_tmp$39] = src[_tmp$40];
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        return;
      }
    }
  } else {
    let _tmp$38 = len - 1 | 0;
    while (true) {
      const i = _tmp$38;
      if (i >= 0) {
        const _tmp$39 = dst_offset + i | 0;
        const _tmp$40 = src_offset + i | 0;
        $bound_check(src, _tmp$40);
        $bound_check(dst, _tmp$39);
        dst[_tmp$39] = src[_tmp$40];
        _tmp$38 = i - 1 | 0;
        continue;
      } else {
        return;
      }
    }
  }
}
function _M0MPC15array10FixedArray12unsafe__blitGRPB17UnsafeMaybeUninitGsEE(dst, dst_offset, src, src_offset, len) {
  if (dst === src && dst_offset < src_offset) {
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < len) {
        const _tmp$39 = dst_offset + i | 0;
        const _tmp$40 = src_offset + i | 0;
        $bound_check(src, _tmp$40);
        $bound_check(dst, _tmp$39);
        dst[_tmp$39] = src[_tmp$40];
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        return;
      }
    }
  } else {
    let _tmp$38 = len - 1 | 0;
    while (true) {
      const i = _tmp$38;
      if (i >= 0) {
        const _tmp$39 = dst_offset + i | 0;
        const _tmp$40 = src_offset + i | 0;
        $bound_check(src, _tmp$40);
        $bound_check(dst, _tmp$39);
        dst[_tmp$39] = src[_tmp$40];
        _tmp$38 = i - 1 | 0;
        continue;
      } else {
        return;
      }
    }
  }
}
function _M0MPC15array10FixedArray12unsafe__blitGRPB17UnsafeMaybeUninitGcEE(dst, dst_offset, src, src_offset, len) {
  if (dst === src && dst_offset < src_offset) {
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < len) {
        const _tmp$39 = dst_offset + i | 0;
        const _tmp$40 = src_offset + i | 0;
        $bound_check(src, _tmp$40);
        $bound_check(dst, _tmp$39);
        dst[_tmp$39] = src[_tmp$40];
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        return;
      }
    }
  } else {
    let _tmp$38 = len - 1 | 0;
    while (true) {
      const i = _tmp$38;
      if (i >= 0) {
        const _tmp$39 = dst_offset + i | 0;
        const _tmp$40 = src_offset + i | 0;
        $bound_check(src, _tmp$40);
        $bound_check(dst, _tmp$39);
        dst[_tmp$39] = src[_tmp$40];
        _tmp$38 = i - 1 | 0;
        continue;
      } else {
        return;
      }
    }
  }
}
function _M0MPC15array10FixedArray12unsafe__blitGRPB17UnsafeMaybeUninitGiEE(dst, dst_offset, src, src_offset, len) {
  if (dst === src && dst_offset < src_offset) {
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < len) {
        const _tmp$39 = dst_offset + i | 0;
        const _tmp$40 = src_offset + i | 0;
        $bound_check(src, _tmp$40);
        $bound_check(dst, _tmp$39);
        dst[_tmp$39] = src[_tmp$40];
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        return;
      }
    }
  } else {
    let _tmp$38 = len - 1 | 0;
    while (true) {
      const i = _tmp$38;
      if (i >= 0) {
        const _tmp$39 = dst_offset + i | 0;
        const _tmp$40 = src_offset + i | 0;
        $bound_check(src, _tmp$40);
        $bound_check(dst, _tmp$39);
        dst[_tmp$39] = src[_tmp$40];
        _tmp$38 = i - 1 | 0;
        continue;
      } else {
        return;
      }
    }
  }
}
function _M0MPB18UninitializedArray12unsafe__blitGsE(dst, dst_offset, src, src_offset, len) {
  _M0MPC15array10FixedArray12unsafe__blitGRPB17UnsafeMaybeUninitGsEE(dst, dst_offset, src, src_offset, len);
}
function _M0MPB18UninitializedArray12unsafe__blitGcE(dst, dst_offset, src, src_offset, len) {
  _M0MPC15array10FixedArray12unsafe__blitGRPB17UnsafeMaybeUninitGcEE(dst, dst_offset, src, src_offset, len);
}
function _M0MPB18UninitializedArray12unsafe__blitGiE(dst, dst_offset, src, src_offset, len) {
  _M0MPC15array10FixedArray12unsafe__blitGRPB17UnsafeMaybeUninitGiEE(dst, dst_offset, src, src_offset, len);
}
function _M0MPB13StringBuilder21StringBuilder_2einner(size_hint) {
  return new _M0TPB13StringBuilder("");
}
function _M0IPB13StringBuilderPB6Logger11write__char(self, ch) {
  self.val = `${self.val}${String.fromCodePoint(ch)}`;
}
function _M0MPC16uint166UInt1622is__leading__surrogate(self) {
  return _M0IP016_24default__implPB7Compare6op__geGkE(self, 55296) && _M0IP016_24default__implPB7Compare6op__leGkE(self, 56319);
}
function _M0MPC16uint166UInt1623is__trailing__surrogate(self) {
  return _M0IP016_24default__implPB7Compare6op__geGkE(self, 56320) && _M0IP016_24default__implPB7Compare6op__leGkE(self, 57343);
}
function _M0FPB32code__point__of__surrogate__pair(leading, trailing) {
  return (((Math.imul(leading - 55296 | 0, 1024) | 0) + trailing | 0) - 56320 | 0) + 65536 | 0;
}
function _M0MPC16string6String16unsafe__char__at(self, index) {
  const c1 = self.charCodeAt(index);
  if (_M0MPC16uint166UInt1622is__leading__surrogate(c1)) {
    const c2 = self.charCodeAt(index + 1 | 0);
    return _M0FPB32code__point__of__surrogate__pair(c1, c2);
  } else {
    return c1;
  }
}
function _M0MPC14byte4Byte7to__hexN14to__hex__digitS3488(i) {
  if (i < 10) {
    const _p$4 = 48;
    const _p$5 = (i + _p$4 | 0) & 255;
    return _p$5;
  } else {
    const _p$4 = 97;
    const _p$5 = (i + _p$4 | 0) & 255;
    const _p$6 = 10;
    const _p$7 = (_p$5 - _p$6 | 0) & 255;
    return _p$7;
  }
}
function _M0MPC14byte4Byte7to__hex(b) {
  const _self = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _p$4 = 16;
  _M0IPB13StringBuilderPB6Logger11write__char(_self, _M0MPC14byte4Byte7to__hexN14to__hex__digitS3488((b / _p$4 | 0) & 255));
  const _p$5 = 16;
  _M0IPB13StringBuilderPB6Logger11write__char(_self, _M0MPC14byte4Byte7to__hexN14to__hex__digitS3488((b % _p$5 | 0) & 255));
  const _p$6 = _self;
  return _p$6.val;
}
function _M0MPC16string10StringView11sub_2einner(self, start, end) {
  const str_len = self.str.length;
  let abs_end;
  if (end === undefined) {
    abs_end = self.end;
  } else {
    const _Some = end;
    const _end = _Some;
    abs_end = _end < 0 ? self.end + _end | 0 : self.start + _end | 0;
  }
  const abs_start = start < 0 ? self.end + start | 0 : self.start + start | 0;
  if (abs_start >= self.start && (abs_start <= abs_end && abs_end <= self.end)) {
    if (abs_start < str_len) {
      if (!_M0MPC16uint166UInt1623is__trailing__surrogate(self.str.charCodeAt(abs_start))) {
      } else {
        $panic();
      }
    }
    if (abs_end < str_len) {
      if (!_M0MPC16uint166UInt1623is__trailing__surrogate(self.str.charCodeAt(abs_end))) {
      } else {
        $panic();
      }
    }
    return new _M0TPC16string10StringView(self.str, abs_start, abs_end);
  } else {
    return $panic();
  }
}
function _M0MPC16string10StringView18escape__to_2einnerN14flush__segmentS3473(_env, seg, i) {
  const self = _env._1;
  const logger = _env._0;
  if (i > seg) {
    logger.method_table.method_2(logger.self, _M0MPC16string10StringView11sub_2einner(self, seg, i));
    return;
  } else {
    return;
  }
}
function _M0MPC16string10StringView18escape__to_2einner(self, logger, quote) {
  if (quote) {
    logger.method_table.method_3(logger.self, 34);
  }
  const len = self.end - self.start | 0;
  const _env = { _0: logger, _1: self };
  let _tmp$38 = 0;
  let _tmp$39 = 0;
  _L: while (true) {
    const i = _tmp$38;
    const seg = _tmp$39;
    if (i >= len) {
      _M0MPC16string10StringView18escape__to_2einnerN14flush__segmentS3473(_env, seg, i);
      break;
    }
    const code = self.str.charCodeAt(self.start + i | 0);
    let c;
    _L$2: {
      switch (code) {
        case 34: {
          c = code;
          break _L$2;
        }
        case 92: {
          c = code;
          break _L$2;
        }
        case 10: {
          _M0MPC16string10StringView18escape__to_2einnerN14flush__segmentS3473(_env, seg, i);
          logger.method_table.method_0(logger.self, "\\n");
          _tmp$38 = i + 1 | 0;
          _tmp$39 = i + 1 | 0;
          continue _L;
        }
        case 13: {
          _M0MPC16string10StringView18escape__to_2einnerN14flush__segmentS3473(_env, seg, i);
          logger.method_table.method_0(logger.self, "\\r");
          _tmp$38 = i + 1 | 0;
          _tmp$39 = i + 1 | 0;
          continue _L;
        }
        case 8: {
          _M0MPC16string10StringView18escape__to_2einnerN14flush__segmentS3473(_env, seg, i);
          logger.method_table.method_0(logger.self, "\\b");
          _tmp$38 = i + 1 | 0;
          _tmp$39 = i + 1 | 0;
          continue _L;
        }
        case 9: {
          _M0MPC16string10StringView18escape__to_2einnerN14flush__segmentS3473(_env, seg, i);
          logger.method_table.method_0(logger.self, "\\t");
          _tmp$38 = i + 1 | 0;
          _tmp$39 = i + 1 | 0;
          continue _L;
        }
        default: {
          if (_M0IP016_24default__implPB7Compare6op__ltGkE(code, 32)) {
            _M0MPC16string10StringView18escape__to_2einnerN14flush__segmentS3473(_env, seg, i);
            logger.method_table.method_0(logger.self, "\\u{");
            logger.method_table.method_0(logger.self, _M0MPC14byte4Byte7to__hex(code & 255));
            logger.method_table.method_3(logger.self, 125);
            _tmp$38 = i + 1 | 0;
            _tmp$39 = i + 1 | 0;
            continue _L;
          } else {
            _tmp$38 = i + 1 | 0;
            continue _L;
          }
        }
      }
    }
    _M0MPC16string10StringView18escape__to_2einnerN14flush__segmentS3473(_env, seg, i);
    logger.method_table.method_3(logger.self, 92);
    logger.method_table.method_3(logger.self, c);
    _tmp$38 = i + 1 | 0;
    _tmp$39 = i + 1 | 0;
    continue;
  }
  if (quote) {
    logger.method_table.method_3(logger.self, 34);
    return;
  } else {
    return;
  }
}
function _M0MPC16string6String14escape_2einner(self, quote) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0MPC16string10StringView18escape__to_2einner(new _M0TPC16string10StringView(self, 0, self.length), { self: buf, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger }, quote);
  return buf.val;
}
function _M0MPB13StringBuilder13write__objectGdE(self, obj) {
  _M0IP016_24default__implPB4Show6outputGdE(obj, { self: self, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
}
function _M0IPB13StringBuilderPB6Logger13write__string(self, str) {
  self.val = `${self.val}${str}`;
}
function _M0MPC16uint166UInt1613is__surrogate(self) {
  return _M0IP016_24default__implPB7Compare6op__geGkE(self, 55296) && _M0IP016_24default__implPB7Compare6op__leGkE(self, 57343);
}
function _M0MPB6Hasher12combine__int(self, value) {
  _M0MPB6Hasher13combine__uint(self, value);
}
function _M0IPC15tuple6Tuple2PB4Show6outputGsOsE(self, logger) {
  const _a = self._0;
  const _b = self._1;
  logger.method_table.method_0(logger.self, "(");
  _M0MPB6Logger13write__objectGsE(logger, _a);
  logger.method_table.method_0(logger.self, ", ");
  _M0MPB6Logger13write__objectGOsE(logger, _b);
  logger.method_table.method_0(logger.self, ")");
}
function _M0MPB6Hasher7combineGsE(self, value) {
  _M0IPC16string6StringPB4Hash13hash__combine(value, self);
}
function _M0MPB6Hasher7combineGRPC16string10StringViewE(self, value) {
  _M0IPC16string10StringViewPB4Hash13hash__combine(value, self);
}
function _M0MPB6Hasher7combineGiE(self, value) {
  _M0IPC13int3IntPB4Hash13hash__combine(value, self);
}
function _M0MPB6Hasher7combineGcE(self, value) {
  _M0IPC14char4CharPB4Hash13hash__combine(value, self);
}
function _M0IPC15tuple6Tuple2PB2Eq5equalGsOsE(self, other) {
  return self._0 === other._0 && _M0IPC16option6OptionPB2Eq5equalGsE(self._1, other._1);
}
function _M0IP016_24default__implPB2Eq10not__equalGRP410Haoxincode8moonbash3lib3ast5TokenE(x, y) {
  return !_M0IP410Haoxincode8moonbash3lib3ast5TokenPB2Eq5equal(x, y);
}
function _M0IP016_24default__implPB2Eq10not__equalGOcE(x, y) {
  return !_M0IPC16option6OptionPB2Eq5equalGcE(x, y);
}
function _M0IP016_24default__implPB2Eq10not__equalGRP219moonbit_2dcommunity4yaml5EventE(x, y) {
  return !_M0IP219moonbit_2dcommunity4yaml5EventPB2Eq5equal(x, y);
}
function _M0IP016_24default__implPB2Eq10not__equalGORP27gmlewis2io7IOErrorE(x, y) {
  return !_M0IPC16option6OptionPB2Eq5equalGRP27gmlewis2io7IOErrorE(x, y);
}
function _M0IP016_24default__implPB2Eq10not__equalGRPC16string10StringViewE(x, y) {
  return !_M0IPC16string10StringViewPB2Eq5equal(x, y);
}
function _M0IP016_24default__implPB2Eq10not__equalGRPB4JsonE(x, y) {
  return !_M0IPC14json4JsonPB2Eq5equal(x, y);
}
function _M0IP016_24default__implPB2Eq10not__equalGRP219moonbit_2dcommunity4yaml12TScalarStyleE(x, y) {
  return !_M0IP219moonbit_2dcommunity4yaml12TScalarStylePB2Eq5equal(x, y);
}
function _M0IP016_24default__implPB2Eq10not__equalGORPC111sorted__map4NodeGiRP219moonbit_2dcommunity4yaml4YamlEE(x, y) {
  return !_M0IPC16option6OptionPB2Eq5equalGRPC111sorted__map4NodeGiRP219moonbit_2dcommunity4yaml4YamlEE(x, y);
}
function _M0IP016_24default__implPB2Eq10not__equalGRP219moonbit_2dcommunity4yaml8SkipTabsE(x, y) {
  return !_M0IP219moonbit_2dcommunity4yaml8SkipTabsPB2Eq5equal(x, y);
}
function _M0IP016_24default__implPB2Eq10not__equalGRP219moonbit_2dcommunity4yaml8ChompingE(x, y) {
  return !_M0IP219moonbit_2dcommunity4yaml8ChompingPB2Eq5equal(x, y);
}
function _M0IP016_24default__implPB7Compare6op__ltGsE(x, y) {
  return _M0IPC16string6StringPB7Compare7compare(x, y) < 0;
}
function _M0IP016_24default__implPB7Compare6op__ltGkE(x, y) {
  return $compare_int(x, y) < 0;
}
function _M0IP016_24default__implPB7Compare6op__gtGsE(x, y) {
  return _M0IPC16string6StringPB7Compare7compare(x, y) > 0;
}
function _M0IP016_24default__implPB7Compare6op__gtGkE(x, y) {
  return $compare_int(x, y) > 0;
}
function _M0IP016_24default__implPB7Compare6op__leGkE(x, y) {
  return $compare_int(x, y) <= 0;
}
function _M0IP016_24default__implPB7Compare6op__geGkE(x, y) {
  return $compare_int(x, y) >= 0;
}
function _M0MPB6Hasher9avalanche(self) {
  let acc = self.acc;
  acc = acc ^ (acc >>> 15 | 0);
  acc = Math.imul(acc, -2048144777) | 0;
  acc = acc ^ (acc >>> 13 | 0);
  acc = Math.imul(acc, -1028477379) | 0;
  acc = acc ^ (acc >>> 16 | 0);
  return acc;
}
function _M0MPB6Hasher8finalize(self) {
  return _M0MPB6Hasher9avalanche(self);
}
function _M0MPB6Hasher11new_2einner(seed) {
  return new _M0TPB6Hasher((seed >>> 0) + (374761393 >>> 0) | 0);
}
function _M0MPB6Hasher3new(seed$46$opt) {
  let seed;
  if (seed$46$opt === undefined) {
    seed = _M0FPB4seed;
  } else {
    const _Some = seed$46$opt;
    seed = _Some;
  }
  return _M0MPB6Hasher11new_2einner(seed);
}
function _M0IP016_24default__implPB4Hash4hashGsE(self) {
  const h = _M0MPB6Hasher3new(undefined);
  _M0MPB6Hasher7combineGsE(h, self);
  return _M0MPB6Hasher8finalize(h);
}
function _M0IP016_24default__implPB4Hash4hashGRPC16string10StringViewE(self) {
  const h = _M0MPB6Hasher3new(undefined);
  _M0MPB6Hasher7combineGRPC16string10StringViewE(h, self);
  return _M0MPB6Hasher8finalize(h);
}
function _M0IP016_24default__implPB4Hash4hashGiE(self) {
  const h = _M0MPB6Hasher3new(undefined);
  _M0MPB6Hasher7combineGiE(h, self);
  return _M0MPB6Hasher8finalize(h);
}
function _M0IP016_24default__implPB4Hash4hashGcE(self) {
  const h = _M0MPB6Hasher3new(undefined);
  _M0MPB6Hasher7combineGcE(h, self);
  return _M0MPB6Hasher8finalize(h);
}
function _M0IP016_24default__implPB6Logger5writeGRPB13StringBuilderE(self, show) {
  show.method_table.method_0(show.self, { self: self, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
}
function _M0MPC16string6String11sub_2einner(self, start, end) {
  const len = self.length;
  let end$2;
  if (end === undefined) {
    end$2 = len;
  } else {
    const _Some = end;
    const _end = _Some;
    end$2 = _end < 0 ? len + _end | 0 : _end;
  }
  const start$2 = start < 0 ? len + start | 0 : start;
  if (start$2 >= 0 && (start$2 <= end$2 && end$2 <= len)) {
    if (start$2 < len) {
      if (!_M0MPC16uint166UInt1623is__trailing__surrogate(self.charCodeAt(start$2))) {
      } else {
        $panic();
      }
    }
    if (end$2 < len) {
      if (!_M0MPC16uint166UInt1623is__trailing__surrogate(self.charCodeAt(end$2))) {
      } else {
        $panic();
      }
    }
    return new _M0TPC16string10StringView(self, start$2, end$2);
  } else {
    return $panic();
  }
}
function _M0IP016_24default__implPB6Logger16write__substringGRPB13StringBuilderE(self, value, start, len) {
  _M0IPB13StringBuilderPB6Logger11write__view(self, _M0MPC16string6String11sub_2einner(value, start, start + len | 0));
}
function _M0IP016_24default__implPB4Show6outputGdE(self, logger) {
  logger.method_table.method_0(logger.self, _M0IPC16double6DoublePB4Show10to__string(self));
}
function _M0IP016_24default__implPB4Show6outputGsE(self, logger) {
  logger.method_table.method_0(logger.self, self);
}
function _M0IP016_24default__implPB4Show6outputGiE(self, logger) {
  logger.method_table.method_0(logger.self, _M0IPC13int3IntPB4Show10to__string(self));
}
function _M0IP016_24default__implPB4Show6outputGcE(self, logger) {
  logger.method_table.method_0(logger.self, _M0IPC14char4CharPB4Show10to__string(self));
}
function _M0IP016_24default__implPB4Show10to__stringGRP410Haoxincode8moonbash3lib3ast5TokenE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IP410Haoxincode8moonbash3lib3ast5TokenPB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRP219moonbit_2dcommunity4yaml9YamlErrorE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IP219moonbit_2dcommunity4yaml9YamlErrorPB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRP219moonbit_2dcommunity7piediff4HunkGsEE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IP219moonbit_2dcommunity7piediff4HunkPB4Show6outputGsE(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRP219moonbit_2dcommunity7piediff10HunkHeaderE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IP219moonbit_2dcommunity7piediff10HunkHeaderPB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRPC16buffer6BufferE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPC16buffer6BufferPB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRPB4JsonE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPC14json4JsonPB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRPC14json10ParseErrorE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPC14json10ParseErrorPB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRP219moonbit_2dcommunity7piediff5RangeE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IP219moonbit_2dcommunity7piediff5RangePB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRP219moonbit_2dcommunity4yaml5EventE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IP219moonbit_2dcommunity4yaml5EventPB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRP38bobzhang6moonjq6parser5TokenE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IP38bobzhang6moonjq6parser5TokenPB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRP210tonyfettes3url15ValidationErrorE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IP210tonyfettes3url15ValidationErrorPB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRPB7FailureE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB7FailurePB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRP27gmlewis6base6417CorruptInputErrorE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IP27gmlewis6base6417CorruptInputErrorPB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRP411moonbitlang6regexp8internal5parse11RegexpErrorE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IP411moonbitlang6regexp8internal5parse11RegexpErrorPB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRP38bobzhang6moonjq6parser8LexErrorE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IP38bobzhang6moonjq6parser8LexErrorPB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRP310tonyfettes7unicode8punycode13PunycodeErrorE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IP310tonyfettes7unicode8punycode13PunycodeErrorPB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRP38bobzhang6moonjq3ast16InterpreterErrorE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IP38bobzhang6moonjq3ast16InterpreterErrorPB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRP27gmlewis2io7IOErrorE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IP27gmlewis2io7IOErrorPB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRP310tonyfettes7unicode4idna9IdnaErrorE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IP310tonyfettes7unicode4idna9IdnaErrorPB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRP38bobzhang6moonjq6parser10ParseErrorE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IP38bobzhang6moonjq6parser10ParseErrorPB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRPC17strconv12StrConvErrorE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPC17strconv12StrConvErrorPB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRP211moonbitlang6regexp11RegexpErrorE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IP211moonbitlang6regexp11RegexpErrorPB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0MPB4Iter4nextGUssEE(self) {
  const _func = self.f;
  const result = _func();
  const _bind$4 = self.size_hint;
  if (result === undefined) {
    self.size_hint = _M0MPB4Iter4nextN6constrS8639GUssEE;
  } else {
    if (_bind$4 === undefined) {
    } else {
      const _Some = _bind$4;
      const _n = _Some;
      self.size_hint = _n > 0 ? _n - 1 | 0 : _M0MPB4Iter4nextN6constrS8638GUssEE;
    }
  }
  return result;
}
function _M0MPB4Iter4nextGcE(self) {
  const _func = self.f;
  const result = _func();
  const _bind$4 = self.size_hint;
  if (result === -1) {
    self.size_hint = _M0MPB4Iter4nextN6constrS8639GcE;
  } else {
    if (_bind$4 === undefined) {
    } else {
      const _Some = _bind$4;
      const _n = _Some;
      self.size_hint = _n > 0 ? _n - 1 | 0 : _M0MPB4Iter4nextN6constrS8638GcE;
    }
  }
  return result;
}
function _M0MPB4Iter4nextGyE(self) {
  const _func = self.f;
  const result = _func();
  const _bind$4 = self.size_hint;
  if (result === -1) {
    self.size_hint = _M0MPB4Iter4nextN6constrS8639GyE;
  } else {
    if (_bind$4 === undefined) {
    } else {
      const _Some = _bind$4;
      const _n = _Some;
      self.size_hint = _n > 0 ? _n - 1 | 0 : _M0MPB4Iter4nextN6constrS8638GyE;
    }
  }
  return result;
}
function _M0MPB4Iter4nextGRPB5ArrayGRPB4JsonEE(self) {
  const _func = self.f;
  const result = _func();
  const _bind$4 = self.size_hint;
  if (result.$tag === 1) {
    if (_bind$4 === undefined) {
    } else {
      const _Some = _bind$4;
      const _n = _Some;
      self.size_hint = _n > 0 ? _n - 1 | 0 : _M0MPB4Iter4nextN6constrS8638GRPB5ArrayGRPB4JsonEE;
    }
  } else {
    self.size_hint = _M0MPB4Iter4nextN6constrS8639GRPB5ArrayGRPB4JsonEE;
  }
  return result;
}
function _M0MPB4Iter4nextGiE(self) {
  const _func = self.f;
  const result = _func();
  const _bind$4 = self.size_hint;
  if (result === undefined) {
    self.size_hint = _M0MPB4Iter4nextN6constrS8639GiE;
  } else {
    if (_bind$4 === undefined) {
    } else {
      const _Some = _bind$4;
      const _n = _Some;
      self.size_hint = _n > 0 ? _n - 1 | 0 : _M0MPB4Iter4nextN6constrS8638GiE;
    }
  }
  return result;
}
function _M0MPB6Logger19write__iter_2einnerGRPB4JsonE(self, iter, prefix, suffix, sep, trailing) {
  self.method_table.method_0(self.self, prefix);
  if (trailing) {
    while (true) {
      const _bind$4 = _M0MPB4Iter4nextGUssEE(iter);
      if (_bind$4 === undefined) {
        break;
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        _M0MPB6Logger13write__objectGRPB4JsonE(self, _x);
        self.method_table.method_0(self.self, sep);
        continue;
      }
    }
  } else {
    const _bind$4 = _M0MPB4Iter4nextGUssEE(iter);
    if (_bind$4 === undefined) {
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      _M0MPB6Logger13write__objectGRPB4JsonE(self, _x);
      while (true) {
        const _bind$5 = _M0MPB4Iter4nextGUssEE(iter);
        if (_bind$5 === undefined) {
          break;
        } else {
          const _Some$2 = _bind$5;
          const _x$2 = _Some$2;
          self.method_table.method_0(self.self, sep);
          _M0MPB6Logger13write__objectGRPB4JsonE(self, _x$2);
          continue;
        }
      }
    }
  }
  self.method_table.method_0(self.self, suffix);
}
function _M0MPB6Logger19write__iter_2einnerGUsOsEE(self, iter, prefix, suffix, sep, trailing) {
  self.method_table.method_0(self.self, prefix);
  if (trailing) {
    while (true) {
      const _bind$4 = _M0MPB4Iter4nextGUssEE(iter);
      if (_bind$4 === undefined) {
        break;
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        _M0MPB6Logger13write__objectGUsOsEE(self, _x);
        self.method_table.method_0(self.self, sep);
        continue;
      }
    }
  } else {
    const _bind$4 = _M0MPB4Iter4nextGUssEE(iter);
    if (_bind$4 === undefined) {
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      _M0MPB6Logger13write__objectGUsOsEE(self, _x);
      while (true) {
        const _bind$5 = _M0MPB4Iter4nextGUssEE(iter);
        if (_bind$5 === undefined) {
          break;
        } else {
          const _Some$2 = _bind$5;
          const _x$2 = _Some$2;
          self.method_table.method_0(self.self, sep);
          _M0MPB6Logger13write__objectGUsOsEE(self, _x$2);
          continue;
        }
      }
    }
  }
  self.method_table.method_0(self.self, suffix);
}
function _M0MPC13int3Int18to__string_2einner(self, radix) {
  return _M0FPB19int__to__string__js(self, radix);
}
function _M0MPC14uint4UInt18to__string_2einner(self, radix) {
  return _M0FPB20uint__to__string__js(self, radix);
}
function _M0MPC15int645Int6418to__string_2einner(self, radix) {
  return _M0FPB21int64__to__string__js(self, radix);
}
function _M0MPC16uint166UInt1618to__string_2einner(self, radix) {
  return _M0MPC13int3Int18to__string_2einner(self, radix);
}
function _M0FPB4failGRP311moonbitlang1x4time9PlainDateE(msg, loc) {
  return new _M0DTPC16result6ResultGRP311moonbitlang1x4time9PlainDateRPB7FailureE3Err(new _M0DTPC15error5Error48moonbitlang_2fcore_2fbuiltin_2eFailure_2eFailure(`${loc} FAILED: ${_M0IPC16string10StringViewPB4Show10to__string(msg)}`));
}
function _M0FPB4failGuE(msg, loc) {
  return new _M0DTPC16result6ResultGuRPB7FailureE3Err(new _M0DTPC15error5Error48moonbitlang_2fcore_2fbuiltin_2eFailure_2eFailure(`${loc} FAILED: ${_M0IPC16string10StringViewPB4Show10to__string(msg)}`));
}
function _M0MPC16string10StringView2at(self, index) {
  return index >= 0 && index < (self.end - self.start | 0) ? self.str.charCodeAt(self.start + index | 0) : _M0FPC15abort5abortGkE("Index out of bounds");
}
function _M0MPB4Iter3newGUssEE(f, size_hint) {
  let size_hint$2;
  if (size_hint === undefined) {
    size_hint$2 = undefined;
  } else {
    const _Some = size_hint;
    const _n = _Some;
    size_hint$2 = _n > 0 ? _n : _M0MPB4Iter3newN6constrS8646GUssEE;
  }
  return new _M0TPB4IterGUssEE(f, size_hint$2);
}
function _M0MPB4Iter3newGcE(f, size_hint) {
  let size_hint$2;
  if (size_hint === undefined) {
    size_hint$2 = undefined;
  } else {
    const _Some = size_hint;
    const _n = _Some;
    size_hint$2 = _n > 0 ? _n : _M0MPB4Iter3newN6constrS8646GcE;
  }
  return new _M0TPB4IterGcE(f, size_hint$2);
}
function _M0MPB4Iter3newGyE(f, size_hint) {
  let size_hint$2;
  if (size_hint === undefined) {
    size_hint$2 = undefined;
  } else {
    const _Some = size_hint;
    const _n = _Some;
    size_hint$2 = _n > 0 ? _n : _M0MPB4Iter3newN6constrS8646GyE;
  }
  return new _M0TPB4IterGyE(f, size_hint$2);
}
function _M0MPB4Iter3newGRPB5ArrayGRPB4JsonEE(f, size_hint) {
  let size_hint$2;
  if (size_hint === undefined) {
    size_hint$2 = undefined;
  } else {
    const _Some = size_hint;
    const _n = _Some;
    size_hint$2 = _n > 0 ? _n : _M0MPB4Iter3newN6constrS8646GRPB5ArrayGRPB4JsonEE;
  }
  return new _M0TPB4IterGRPB5ArrayGRPB4JsonEE(f, size_hint$2);
}
function _M0MPB4Iter3newGiE(f, size_hint) {
  let size_hint$2;
  if (size_hint === undefined) {
    size_hint$2 = undefined;
  } else {
    const _Some = size_hint;
    const _n = _Some;
    size_hint$2 = _n > 0 ? _n : _M0MPB4Iter3newN6constrS8646GiE;
  }
  return new _M0TPB4IterGiE(f, size_hint$2);
}
function _M0MPC16string10StringView12view_2einner(self, start_offset, end_offset) {
  let end_offset$2;
  if (end_offset === undefined) {
    end_offset$2 = self.end - self.start | 0;
  } else {
    const _Some = end_offset;
    end_offset$2 = _Some;
  }
  return start_offset >= 0 && (start_offset <= end_offset$2 && end_offset$2 <= (self.end - self.start | 0)) ? new _M0TPC16string10StringView(self.str, self.start + start_offset | 0, self.start + end_offset$2 | 0) : _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("Invalid index for View");
}
function _M0IPC16string10StringViewPB4Show6output(self, logger) {
  _M0MPC16string10StringView18escape__to_2einner(self, logger, true);
}
function _M0MPC15array10FixedArray18blit__from__string(self, bytes_offset, str, str_offset, length) {
  const e1 = (bytes_offset + (Math.imul(length, 2) | 0) | 0) - 1 | 0;
  const e2 = (str_offset + length | 0) - 1 | 0;
  const len1 = self.length;
  const len2 = str.length;
  if (length >= 0 && (bytes_offset >= 0 && (e1 < len1 && (str_offset >= 0 && e2 < len2)))) {
    const end_str_offset = str_offset + length | 0;
    let _tmp$38 = str_offset;
    let _tmp$39 = bytes_offset;
    while (true) {
      const i = _tmp$38;
      const j = _tmp$39;
      if (i < end_str_offset) {
        const c = str.charCodeAt(i);
        const _p$4 = c & 255;
        $bound_check(self, j);
        self[j] = _p$4 & 255;
        const _tmp$40 = j + 1 | 0;
        const _p$5 = c >>> 8 | 0;
        $bound_check(self, _tmp$40);
        self[_tmp$40] = _p$5 & 255;
        _tmp$38 = i + 1 | 0;
        _tmp$39 = j + 2 | 0;
        continue;
      } else {
        return;
      }
    }
  } else {
    $panic();
    return;
  }
}
function _M0FPB19unsafe__sub__string(_tmp$38, _tmp$39, _tmp$40) {
  return $unsafe_bytes_sub_string(_tmp$38, _tmp$39, _tmp$40);
}
function _M0MPC15bytes5Bytes29to__unchecked__string_2einner(self, offset, length) {
  const len = self.length;
  let length$2;
  if (length === undefined) {
    length$2 = len - offset | 0;
  } else {
    const _Some = length;
    length$2 = _Some;
  }
  return offset >= 0 && (length$2 >= 0 && (offset + length$2 | 0) <= len) ? _M0FPB19unsafe__sub__string(self, offset, length$2) : $panic();
}
function _M0MPC16string10StringView9to__owned(self) {
  return self.str.substring(self.start, self.end);
}
function _M0IPC16string10StringViewPB4Show10to__string(self) {
  return _M0MPC16string10StringView9to__owned(self);
}
function _M0MPC16string10StringView4iter(self) {
  const start = self.start;
  const end = self.end;
  const index = new _M0TPB8MutLocalGiE(start);
  return _M0MPB4Iter3newGcE(() => {
    if (index.val < end) {
      const c1 = self.str.charCodeAt(index.val);
      if (_M0MPC16uint166UInt1622is__leading__surrogate(c1) && (index.val + 1 | 0) < self.end) {
        const c2 = self.str.charCodeAt(index.val + 1 | 0);
        if (_M0MPC16uint166UInt1623is__trailing__surrogate(c2)) {
          index.val = index.val + 2 | 0;
          return _M0FPB32code__point__of__surrogate__pair(c1, c2);
        }
      }
      index.val = index.val + 1 | 0;
      return c1;
    } else {
      return -1;
    }
  }, undefined);
}
function _M0MPB5Iter23newGiiE(f, size_hint) {
  let size_hint$2;
  if (size_hint === undefined) {
    size_hint$2 = undefined;
  } else {
    const _Some = size_hint;
    const _n = _Some;
    size_hint$2 = _n > 0 ? _n : _M0MPB5Iter23newN6constrS8647GiiE;
  }
  return new _M0TPB4IterGUiiEE(f, size_hint$2);
}
function _M0MPB5Iter23newGiRP27gmlewis5flate11LiteralNodeE(f, size_hint) {
  let size_hint$2;
  if (size_hint === undefined) {
    size_hint$2 = undefined;
  } else {
    const _Some = size_hint;
    const _n = _Some;
    size_hint$2 = _n > 0 ? _n : _M0MPB5Iter23newN6constrS8647GiRP27gmlewis5flate11LiteralNodeE;
  }
  return new _M0TPB4IterGUiRP27gmlewis5flate11LiteralNodeEE(f, size_hint$2);
}
function _M0MPB5Iter23newGicE(f, size_hint) {
  let size_hint$2;
  if (size_hint === undefined) {
    size_hint$2 = undefined;
  } else {
    const _Some = size_hint;
    const _n = _Some;
    size_hint$2 = _n > 0 ? _n : _M0MPB5Iter23newN6constrS8647GicE;
  }
  return new _M0TPB4IterGUicEE(f, size_hint$2);
}
function _M0MPC16string10StringView5iter2(self) {
  const start = self.start;
  const end = self.end;
  const index = new _M0TPB8MutLocalGiE(start);
  const char_index = new _M0TPB8MutLocalGiE(0);
  return _M0MPB5Iter23newGicE(() => {
    if (index.val < end) {
      const c1 = self.str.charCodeAt(index.val);
      if (_M0MPC16uint166UInt1622is__leading__surrogate(c1) && (index.val + 1 | 0) < self.end) {
        const c2 = self.str.charCodeAt(index.val + 1 | 0);
        if (_M0MPC16uint166UInt1623is__trailing__surrogate(c2)) {
          const result = { _0: char_index.val, _1: _M0FPB32code__point__of__surrogate__pair(c1, c2) };
          index.val = index.val + 2 | 0;
          char_index.val = char_index.val + 1 | 0;
          return result;
        }
      }
      const result = { _0: char_index.val, _1: c1 };
      index.val = index.val + 1 | 0;
      char_index.val = char_index.val + 1 | 0;
      return result;
    } else {
      return undefined;
    }
  }, undefined);
}
function _M0IPC16string10StringViewPB2Eq5equal(self, other) {
  const len = self.end - self.start | 0;
  if (len === (other.end - other.start | 0)) {
    if (self.str === other.str && self.start === other.start) {
      return true;
    }
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < len) {
        const _p$4 = self.str.charCodeAt(self.start + i | 0);
        const _p$5 = other.str.charCodeAt(other.start + i | 0);
        if (_p$4 === _p$5) {
        } else {
          return false;
        }
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return true;
  } else {
    return false;
  }
}
function _M0MPC16string6String12view_2einner(self, start_offset, end_offset) {
  let end_offset$2;
  if (end_offset === undefined) {
    end_offset$2 = self.length;
  } else {
    const _Some = end_offset;
    end_offset$2 = _Some;
  }
  return start_offset >= 0 && (start_offset <= end_offset$2 && end_offset$2 <= self.length) ? new _M0TPC16string10StringView(self, start_offset, end_offset$2) : _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("Invalid index for View");
}
function _M0MPC16string6String4view(self, start_offset$46$opt, end_offset) {
  let start_offset;
  if (start_offset$46$opt === undefined) {
    start_offset = 0;
  } else {
    const _Some = start_offset$46$opt;
    start_offset = _Some;
  }
  return _M0MPC16string6String12view_2einner(self, start_offset, end_offset);
}
function _M0MPC16string6String11from__array(chars) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(Math.imul(chars.end - chars.start | 0, 4) | 0);
  const _bind$4 = chars.end - chars.start | 0;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const c = chars.buf[chars.start + _ | 0];
      _M0IPB13StringBuilderPB6Logger11write__char(buf, c);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function _M0MPC16string6String10from__iter(iter) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  while (true) {
    const _bind$4 = _M0MPB4Iter4nextGcE(iter);
    if (_bind$4 === -1) {
      break;
    } else {
      const _Some = _bind$4;
      const _c = _Some;
      _M0IPB13StringBuilderPB6Logger11write__char(buf, _c);
      continue;
    }
  }
  return buf.val;
}
function _M0MPC16string6String24char__length__eq_2einner(self, len, start_offset, end_offset) {
  let end_offset$2;
  if (end_offset === undefined) {
    end_offset$2 = self.length;
  } else {
    const _Some = end_offset;
    end_offset$2 = _Some;
  }
  let _tmp$38 = start_offset;
  let _tmp$39 = 0;
  while (true) {
    const index = _tmp$38;
    const count = _tmp$39;
    if (index < end_offset$2 && count < len) {
      const c1 = self.charCodeAt(index);
      if (_M0MPC16uint166UInt1622is__leading__surrogate(c1) && (index + 1 | 0) < end_offset$2) {
        const c2 = self.charCodeAt(index + 1 | 0);
        if (_M0MPC16uint166UInt1623is__trailing__surrogate(c2)) {
          _tmp$38 = index + 2 | 0;
          _tmp$39 = count + 1 | 0;
          continue;
        } else {
          _M0FPC15abort5abortGuE("invalid surrogate pair");
        }
      }
      _tmp$38 = index + 1 | 0;
      _tmp$39 = count + 1 | 0;
      continue;
    } else {
      return count === len && index === end_offset$2;
    }
  }
}
function _M0MPC16string6String24char__length__ge_2einner(self, len, start_offset, end_offset) {
  let end_offset$2;
  if (end_offset === undefined) {
    end_offset$2 = self.length;
  } else {
    const _Some = end_offset;
    end_offset$2 = _Some;
  }
  let _tmp$38 = start_offset;
  let _tmp$39 = 0;
  while (true) {
    const index = _tmp$38;
    const count = _tmp$39;
    if (index < end_offset$2 && count < len) {
      const c1 = self.charCodeAt(index);
      if (_M0MPC16uint166UInt1622is__leading__surrogate(c1) && (index + 1 | 0) < end_offset$2) {
        const c2 = self.charCodeAt(index + 1 | 0);
        if (_M0MPC16uint166UInt1623is__trailing__surrogate(c2)) {
          _tmp$38 = index + 2 | 0;
          _tmp$39 = count + 1 | 0;
          continue;
        } else {
          _M0FPC15abort5abortGuE("invalid surrogate pair");
        }
      }
      _tmp$38 = index + 1 | 0;
      _tmp$39 = count + 1 | 0;
      continue;
    } else {
      return count >= len;
    }
  }
}
function _M0MPC16string6String31offset__of__nth__char__backward(self, n, start_offset, end_offset) {
  let _tmp$38 = end_offset;
  let _tmp$39 = 0;
  while (true) {
    const utf16_offset = _tmp$38;
    const char_count = _tmp$39;
    if ((utf16_offset - 1 | 0) >= start_offset && char_count < n) {
      const c = self.charCodeAt(utf16_offset - 1 | 0);
      if (_M0MPC16uint166UInt1623is__trailing__surrogate(c)) {
        _tmp$38 = utf16_offset - 2 | 0;
        _tmp$39 = char_count + 1 | 0;
        continue;
      } else {
        _tmp$38 = utf16_offset - 1 | 0;
        _tmp$39 = char_count + 1 | 0;
        continue;
      }
    } else {
      return char_count < n || utf16_offset < start_offset ? undefined : utf16_offset;
    }
  }
}
function _M0MPC16string6String30offset__of__nth__char__forward(self, n, start_offset, end_offset) {
  if (start_offset >= 0 && start_offset <= end_offset) {
    let _tmp$38 = start_offset;
    let _tmp$39 = 0;
    while (true) {
      const utf16_offset = _tmp$38;
      const char_count = _tmp$39;
      if (utf16_offset < end_offset && char_count < n) {
        const c = self.charCodeAt(utf16_offset);
        if (_M0MPC16uint166UInt1622is__leading__surrogate(c)) {
          _tmp$38 = utf16_offset + 2 | 0;
          _tmp$39 = char_count + 1 | 0;
          continue;
        } else {
          _tmp$38 = utf16_offset + 1 | 0;
          _tmp$39 = char_count + 1 | 0;
          continue;
        }
      } else {
        return char_count < n || utf16_offset >= end_offset ? undefined : utf16_offset;
      }
    }
  } else {
    return _M0FPC15abort5abortGOiE("Invalid start index");
  }
}
function _M0MPC16string6String29offset__of__nth__char_2einner(self, i, start_offset, end_offset) {
  let end_offset$2;
  if (end_offset === undefined) {
    end_offset$2 = self.length;
  } else {
    const _Some = end_offset;
    end_offset$2 = _Some;
  }
  return i >= 0 ? _M0MPC16string6String30offset__of__nth__char__forward(self, i, start_offset, end_offset$2) : _M0MPC16string6String31offset__of__nth__char__backward(self, -i | 0, start_offset, end_offset$2);
}
function _M0MPB13StringBuilder11write__iter(self, iter) {
  while (true) {
    const _bind$4 = _M0MPB4Iter4nextGcE(iter);
    if (_bind$4 === -1) {
      return;
    } else {
      const _Some = _bind$4;
      const _ch = _Some;
      _M0IPB13StringBuilderPB6Logger11write__char(self, _ch);
      continue;
    }
  }
}
function _M0IPB13StringBuilderPB6Logger11write__view(self, str) {
  self.val = `${self.val}${_M0MPC16string10StringView9to__owned(str)}`;
}
function _M0MPB13StringBuilder5reset(self) {
  self.val = "";
}
function _M0MPB13StringBuilder17write__stringview(self, view) {
  const start = view.start;
  const end = view.end;
  _M0IP016_24default__implPB6Logger16write__substringGRPB13StringBuilderE(self, view.str, start, end - start | 0);
}
function _M0FPB28boyer__moore__horspool__find(haystack, needle) {
  const haystack_len = haystack.end - haystack.start | 0;
  const needle_len = needle.end - needle.start | 0;
  if (needle_len > 0) {
    if (haystack_len >= needle_len) {
      const skip_table = $make_array_len_and_init(256, needle_len);
      const _bind$4 = needle_len - 1 | 0;
      let _tmp$38 = 0;
      while (true) {
        const i = _tmp$38;
        if (i < _bind$4) {
          const _tmp$39 = needle.str.charCodeAt(needle.start + i | 0) & 255;
          $bound_check(skip_table, _tmp$39);
          skip_table[_tmp$39] = (needle_len - 1 | 0) - i | 0;
          _tmp$38 = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      let _tmp$39 = 0;
      while (true) {
        const i = _tmp$39;
        if (i <= (haystack_len - needle_len | 0)) {
          const _bind$5 = needle_len - 1 | 0;
          let _tmp$40 = 0;
          while (true) {
            const j = _tmp$40;
            if (j <= _bind$5) {
              const _p$4 = i + j | 0;
              const _p$5 = haystack.str.charCodeAt(haystack.start + _p$4 | 0);
              const _p$6 = needle.str.charCodeAt(needle.start + j | 0);
              if (_p$5 !== _p$6) {
                break;
              }
              _tmp$40 = j + 1 | 0;
              continue;
            } else {
              return i;
            }
          }
          const _p$4 = (i + needle_len | 0) - 1 | 0;
          const _tmp$41 = haystack.str.charCodeAt(haystack.start + _p$4 | 0) & 255;
          $bound_check(skip_table, _tmp$41);
          _tmp$39 = i + skip_table[_tmp$41] | 0;
          continue;
        } else {
          break;
        }
      }
      return undefined;
    } else {
      return undefined;
    }
  } else {
    return _M0FPB28boyer__moore__horspool__findN6constrS8648;
  }
}
function _M0FPB18brute__force__find(haystack, needle) {
  const haystack_len = haystack.end - haystack.start | 0;
  const needle_len = needle.end - needle.start | 0;
  if (needle_len > 0) {
    if (haystack_len >= needle_len) {
      const _p$4 = 0;
      const needle_first = needle.str.charCodeAt(needle.start + _p$4 | 0);
      const forward_len = haystack_len - needle_len | 0;
      let _tmp$38 = 0;
      while (true) {
        const i = _tmp$38;
        if (i <= forward_len) {
          const _p$5 = haystack.str.charCodeAt(haystack.start + i | 0);
          if (_p$5 !== needle_first) {
            _tmp$38 = i + 1 | 0;
            continue;
          }
          let _tmp$39 = 1;
          while (true) {
            const j = _tmp$39;
            if (j < needle_len) {
              const _p$6 = i + j | 0;
              const _p$7 = haystack.str.charCodeAt(haystack.start + _p$6 | 0);
              const _p$8 = needle.str.charCodeAt(needle.start + j | 0);
              if (_p$7 !== _p$8) {
                break;
              }
              _tmp$39 = j + 1 | 0;
              continue;
            } else {
              return i;
            }
          }
          _tmp$38 = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return undefined;
    } else {
      return undefined;
    }
  } else {
    return _M0FPB18brute__force__findN6constrS8649;
  }
}
function _M0MPC16string10StringView4find(self, str) {
  return (str.end - str.start | 0) <= 4 ? _M0FPB18brute__force__find(self, str) : _M0FPB28boyer__moore__horspool__find(self, str);
}
function _M0FPB33boyer__moore__horspool__rev__find(haystack, needle) {
  const haystack_len = haystack.end - haystack.start | 0;
  const needle_len = needle.end - needle.start | 0;
  if (needle_len > 0) {
    if (haystack_len >= needle_len) {
      const skip_table = $make_array_len_and_init(256, needle_len);
      let _tmp$38 = needle_len - 1 | 0;
      while (true) {
        const i = _tmp$38;
        if (i >= 1) {
          const _tmp$39 = needle.str.charCodeAt(needle.start + i | 0) & 255;
          $bound_check(skip_table, _tmp$39);
          skip_table[_tmp$39] = i;
          _tmp$38 = i - 1 | 0;
          continue;
        } else {
          break;
        }
      }
      let _tmp$39 = haystack_len - needle_len | 0;
      while (true) {
        const i = _tmp$39;
        if (i >= 0) {
          let _tmp$40 = 0;
          while (true) {
            const j = _tmp$40;
            if (j < needle_len) {
              const _p$4 = i + j | 0;
              const _p$5 = haystack.str.charCodeAt(haystack.start + _p$4 | 0);
              const _p$6 = needle.str.charCodeAt(needle.start + j | 0);
              if (_p$5 !== _p$6) {
                break;
              }
              _tmp$40 = j + 1 | 0;
              continue;
            } else {
              return i;
            }
          }
          const _tmp$41 = haystack.str.charCodeAt(haystack.start + i | 0) & 255;
          $bound_check(skip_table, _tmp$41);
          _tmp$39 = i - skip_table[_tmp$41] | 0;
          continue;
        } else {
          break;
        }
      }
      return undefined;
    } else {
      return undefined;
    }
  } else {
    return haystack_len;
  }
}
function _M0MPC16string6String4find(self, str) {
  return _M0MPC16string10StringView4find(new _M0TPC16string10StringView(self, 0, self.length), str);
}
function _M0MPC16string6String6repeat(self, n) {
  if (n < 0) {
    return _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("negative repeat count");
  } else {
    if (n === 0) {
      return "";
    } else {
      if (n === 1) {
        return self;
      } else {
        const len = self.length;
        const total = Math.imul(len, n) | 0;
        if (len === 0 || (total / n | 0) === len) {
          const buf = _M0MPB13StringBuilder21StringBuilder_2einner(total);
          const str = self;
          let _tmp$38 = 0;
          while (true) {
            const _ = _tmp$38;
            if (_ < n) {
              _M0IPB13StringBuilderPB6Logger13write__string(buf, str);
              _tmp$38 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          return buf.val;
        } else {
          return _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("repeat result too large");
        }
      }
    }
  }
}
function _M0MPC16string6String8find__by(self, pred) {
  const _p$4 = new _M0TPC16string10StringView(self, 0, self.length);
  const _p$5 = _M0MPC16string10StringView5iter2(_p$4);
  while (true) {
    const _p$6 = _M0MPB5Iter24nextGicE(_p$5);
    if (_p$6 === undefined) {
      break;
    } else {
      const _p$7 = _p$6;
      const _p$8 = _p$7;
      const _p$9 = _p$8._0;
      const _p$10 = _p$8._1;
      if (pred(_p$10)) {
        return _p$9;
      }
      continue;
    }
  }
  return undefined;
}
function _M0FPB23brute__force__rev__find(haystack, needle) {
  const haystack_len = haystack.end - haystack.start | 0;
  const needle_len = needle.end - needle.start | 0;
  if (needle_len > 0) {
    if (haystack_len >= needle_len) {
      const _p$4 = 0;
      const needle_first = needle.str.charCodeAt(needle.start + _p$4 | 0);
      let _tmp$38 = haystack_len - needle_len | 0;
      while (true) {
        const i = _tmp$38;
        if (i >= 0) {
          const _p$5 = haystack.str.charCodeAt(haystack.start + i | 0);
          if (_p$5 !== needle_first) {
            _tmp$38 = i - 1 | 0;
            continue;
          }
          let _tmp$39 = 1;
          while (true) {
            const j = _tmp$39;
            if (j < needle_len) {
              const _p$6 = i + j | 0;
              const _p$7 = haystack.str.charCodeAt(haystack.start + _p$6 | 0);
              const _p$8 = needle.str.charCodeAt(needle.start + j | 0);
              if (_p$7 !== _p$8) {
                break;
              }
              _tmp$39 = j + 1 | 0;
              continue;
            } else {
              return i;
            }
          }
          _tmp$38 = i - 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return undefined;
    } else {
      return undefined;
    }
  } else {
    return haystack_len;
  }
}
function _M0MPC16string10StringView9rev__find(self, str) {
  return (str.end - str.start | 0) <= 4 ? _M0FPB23brute__force__rev__find(self, str) : _M0FPB33boyer__moore__horspool__rev__find(self, str);
}
function _M0MPC16string6String9rev__find(self, str) {
  return _M0MPC16string10StringView9rev__find(new _M0TPC16string10StringView(self, 0, self.length), str);
}
function _M0MPC16string10StringView11has__suffix(self, str) {
  const _bind$4 = _M0MPC16string10StringView9rev__find(self, str);
  if (_bind$4 === undefined) {
    return false;
  } else {
    const _Some = _bind$4;
    const _i = _Some;
    return _i === ((self.end - self.start | 0) - (str.end - str.start | 0) | 0);
  }
}
function _M0MPC16string6String11has__suffix(self, str) {
  return _M0MPC16string10StringView11has__suffix(new _M0TPC16string10StringView(self, 0, self.length), str);
}
function _M0MPC16string10StringView11has__prefix(self, str) {
  const _bind$4 = _M0MPC16string10StringView4find(self, str);
  if (_bind$4 === undefined) {
    return false;
  } else {
    const _Some = _bind$4;
    const _i = _Some;
    return _i === 0;
  }
}
function _M0MPC16string6String11has__prefix(self, str) {
  return _M0MPC16string10StringView11has__prefix(new _M0TPC16string10StringView(self, 0, self.length), str);
}
function _M0MPC16string10StringView13strip__suffix(self, suffix) {
  const self_len = self.end - self.start | 0;
  const suffix_len = suffix.end - suffix.start | 0;
  return self_len >= suffix_len && _M0IPC16string10StringViewPB2Eq5equal(_M0MPC16string10StringView12view_2einner(self, self_len - suffix_len | 0, undefined), suffix) ? _M0MPC16string10StringView12view_2einner(self, 0, self_len - suffix_len | 0) : undefined;
}
function _M0MPC16string6String13strip__suffix(self, suffix) {
  return _M0MPC16string10StringView13strip__suffix(new _M0TPC16string10StringView(self, 0, self.length), suffix);
}
function _M0MPC16string10StringView13strip__prefix(self, prefix) {
  const prefix_len = prefix.end - prefix.start | 0;
  return (self.end - self.start | 0) >= prefix_len && _M0IPC16string10StringViewPB2Eq5equal(_M0MPC16string10StringView12view_2einner(self, 0, prefix_len), prefix) ? _M0MPC16string10StringView12view_2einner(self, prefix_len, undefined) : undefined;
}
function _M0MPC16string6String13strip__prefix(self, prefix) {
  return _M0MPC16string10StringView13strip__prefix(new _M0TPC16string10StringView(self, 0, self.length), prefix);
}
function _M0MPC15array5Array11new_2einnerGRP219moonbit_2dcommunity4yaml5StateE(capacity) {
  return [];
}
function _M0MPC15array5Array11new_2einnerGyE(capacity) {
  return [];
}
function _M0MPC15array5Array11new_2einnerGRP411moonbitlang6regexp8internal2vm6ThreadE(capacity) {
  return [];
}
function _M0MPC15array5Array11new_2einnerGRPB5ArrayGsEE(capacity) {
  return [];
}
function _M0MPC15array5Array11new_2einnerGcE(capacity) {
  return [];
}
function _M0MPC15array5Array11new_2einnerGRP27gmlewis5flate5TokenE(capacity) {
  return [];
}
function _M0MPC15array5Array4pushGUssEE(self, value) {
  _M0MPB7JSArray4push(self, value);
}
function _M0MPC15array5Array4pushGiE(self, value) {
  _M0MPB7JSArray4push(self, value);
}
function _M0MPC15array5Array4pushGbE(self, value) {
  _M0MPB7JSArray4push(self, value);
}
function _M0MPC15array5Array4pushGRPB5ArrayGsEE(self, value) {
  _M0MPB7JSArray4push(self, value);
}
function _M0MPC15array5Array4pushGcE(self, value) {
  _M0MPB7JSArray4push(self, value);
}
function _M0MPC15array5Array4pushGyE(self, value) {
  _M0MPB7JSArray4push(self, value);
}
function _M0MPC15array5Array4pushGRP27gmlewis5flate5TokenE(self, value) {
  _M0MPB7JSArray4push(self, value);
}
function _M0MPC15array5Array4pushGRP219moonbit_2dcommunity4yaml5StateE(self, value) {
  _M0MPB7JSArray4push(self, value);
}
function _M0MPC16string10StringView8contains(self, str) {
  const _bind$4 = _M0MPC16string10StringView4find(self, str);
  return !(_bind$4 === undefined);
}
function _M0MPC16string6String8contains(self, str) {
  return _M0MPC16string10StringView8contains(new _M0TPC16string10StringView(self, 0, self.length), str);
}
function _M0MPC16string10StringView14contains__char(self, c) {
  const len = self.end - self.start | 0;
  if (len > 0) {
    const c$2 = c;
    if (c$2 <= 65535) {
      let _tmp$38 = 0;
      while (true) {
        const i = _tmp$38;
        if (i < len) {
          if (self.str.charCodeAt(self.start + i | 0) === c$2) {
            return true;
          }
          _tmp$38 = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
    } else {
      if (len >= 2) {
        const adj = c$2 - 65536 | 0;
        const high = 55296 + (adj >> 10) | 0;
        const low = 56320 + (adj & 1023) | 0;
        let _tmp$38 = 0;
        while (true) {
          const i = _tmp$38;
          if (i < (len - 1 | 0)) {
            if (self.str.charCodeAt(self.start + i | 0) === high) {
              const _p$4 = i + 1 | 0;
              if (self.str.charCodeAt(self.start + _p$4 | 0) === low) {
                return true;
              }
              _tmp$38 = i + 2 | 0;
              continue;
            }
            _tmp$38 = i + 1 | 0;
            continue;
          } else {
            break;
          }
        }
      } else {
        return false;
      }
    }
    return false;
  } else {
    return false;
  }
}
function _M0MPC16string6String14contains__char(self, c) {
  return _M0MPC16string10StringView14contains__char(new _M0TPC16string10StringView(self, 0, self.length), c);
}
function _M0MPC16string10StringView19trim__start_2einner(self, chars) {
  let _tmp$38 = self;
  while (true) {
    const x = _tmp$38;
    if (_M0MPC16string6String24char__length__eq_2einner(x.str, 0, x.start, x.end)) {
      return x;
    } else {
      const _c = _M0MPC16string6String16unsafe__char__at(x.str, _M0MPC16string6String29offset__of__nth__char_2einner(x.str, 0, x.start, x.end));
      const _tmp$39 = x.str;
      const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(x.str, 1, x.start, x.end);
      let _tmp$40;
      if (_bind$4 === undefined) {
        _tmp$40 = x.end;
      } else {
        const _Some = _bind$4;
        _tmp$40 = _Some;
      }
      const _x = new _M0TPC16string10StringView(_tmp$39, _tmp$40, x.end);
      if (_M0MPC16string10StringView14contains__char(chars, _c)) {
        _tmp$38 = _x;
        continue;
      } else {
        return x;
      }
    }
  }
}
function _M0MPC16string10StringView17trim__end_2einner(self, chars) {
  let _tmp$38 = self;
  while (true) {
    const x = _tmp$38;
    if (_M0MPC16string6String24char__length__eq_2einner(x.str, 0, x.start, x.end)) {
      return x;
    } else {
      const _c = _M0MPC16string6String16unsafe__char__at(x.str, _M0MPC16string6String29offset__of__nth__char_2einner(x.str, -1, x.start, x.end));
      const _x = new _M0TPC16string10StringView(x.str, x.start, _M0MPC16string6String29offset__of__nth__char_2einner(x.str, -1, x.start, x.end));
      if (_M0MPC16string10StringView14contains__char(chars, _c)) {
        _tmp$38 = _x;
        continue;
      } else {
        return x;
      }
    }
  }
}
function _M0MPC16string10StringView12trim_2einner(self, chars) {
  return _M0MPC16string10StringView17trim__end_2einner(_M0MPC16string10StringView19trim__start_2einner(self, chars), chars);
}
function _M0MPC16string6String12trim_2einner(self, chars) {
  return _M0MPC16string10StringView12trim_2einner(new _M0TPC16string10StringView(self, 0, self.length), chars);
}
function _M0MPC16string6String4trim(self, chars$46$opt) {
  let chars;
  if (chars$46$opt === undefined) {
    chars = new _M0TPC16string10StringView(_M0MPC16string6String4trimN7_2abindS5977, 0, _M0MPC16string6String4trimN7_2abindS5977.length);
  } else {
    const _Some = chars$46$opt;
    chars = _Some;
  }
  return _M0MPC16string6String12trim_2einner(self, chars);
}
function _M0MPC16string10StringView9is__empty(self) {
  return (self.end - self.start | 0) === 0;
}
function _M0MPC16string6String4iter(self) {
  const len = self.length;
  const index = new _M0TPB8MutLocalGiE(0);
  return _M0MPB4Iter3newGcE(() => {
    if (index.val < len) {
      const c1 = self.charCodeAt(index.val);
      if (_M0MPC16uint166UInt1622is__leading__surrogate(c1) && (index.val + 1 | 0) < len) {
        const c2 = self.charCodeAt(index.val + 1 | 0);
        if (_M0MPC16uint166UInt1623is__trailing__surrogate(c2)) {
          const c = _M0FPB32code__point__of__surrogate__pair(c1, c2);
          index.val = index.val + 2 | 0;
          return c;
        }
      }
      index.val = index.val + 1 | 0;
      return c1;
    } else {
      return -1;
    }
  }, undefined);
}
function _M0MPB4Iter3mapGiRPB4JsonE(self, f) {
  return new _M0TPB4IterGRPB4JsonE(() => {
    const _bind$4 = _M0MPB4Iter4nextGiE(self);
    if (_bind$4 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      return f(_x);
    }
  }, self.size_hint);
}
function _M0MPB4Iter3mapGRPC16string10StringViewRPB4JsonE(self, f) {
  return new _M0TPB4IterGRPB4JsonE(() => {
    const _bind$4 = _M0MPB4Iter4nextGUssEE(self);
    if (_bind$4 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      return f(_x);
    }
  }, self.size_hint);
}
function _M0MPB4Iter3mapGRPB5ArrayGRPB4JsonERPB4JsonE(self, f) {
  return new _M0TPB4IterGRPB4JsonE(() => {
    const _bind$4 = _M0MPB4Iter4nextGRPB5ArrayGRPB4JsonEE(self);
    if (_bind$4.$tag === 1) {
      const _Some = _bind$4;
      const _x = _Some._0;
      return f(_x);
    } else {
      return undefined;
    }
  }, self.size_hint);
}
function _M0MPB4Iter3mapGcRPC16string10StringViewE(self, f) {
  return new _M0TPB4IterGRPC16string10StringViewE(() => {
    const _bind$4 = _M0MPB4Iter4nextGcE(self);
    if (_bind$4 === -1) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      return f(_x);
    }
  }, self.size_hint);
}
function _M0IPC14char4CharPB4Show10to__string(self) {
  return String.fromCodePoint(self);
}
function _M0MPC16string10StringView5split(self, sep) {
  const sep_len = sep.end - sep.start | 0;
  if (sep_len === 0) {
    return _M0MPB4Iter3mapGcRPC16string10StringViewE(_M0MPC16string10StringView4iter(self), (c) => _M0MPC16string6String12view_2einner(_M0IPC14char4CharPB4Show10to__string(c), 0, undefined));
  }
  const remaining = new _M0TPB8MutLocalGORPC16string10StringViewE(self);
  return _M0MPB4Iter3newGUssEE(() => {
    const _bind$4 = remaining.val;
    if (_bind$4 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _view = _Some;
      const _bind$5 = _M0MPC16string10StringView4find(_view, sep);
      if (_bind$5 === undefined) {
        remaining.val = undefined;
        return _view;
      } else {
        const _Some$2 = _bind$5;
        const _end = _Some$2;
        remaining.val = _M0MPC16string10StringView12view_2einner(_view, _end + sep_len | 0, undefined);
        return _M0MPC16string10StringView12view_2einner(_view, 0, _end);
      }
    }
  }, undefined);
}
function _M0MPC16string6String5split(self, sep) {
  return _M0MPC16string10StringView5split(new _M0TPC16string10StringView(self, 0, self.length), sep);
}
function _M0MPB4Iter9to__arrayGRPB4JsonE(self) {
  const _bind$4 = self.size_hint;
  let result;
  if (_bind$4 === undefined) {
    result = [];
  } else {
    const _Some = _bind$4;
    const _n = _Some;
    result = _M0MPC15array5Array11new_2einnerGRP411moonbitlang6regexp8internal2vm6ThreadE(_n);
  }
  while (true) {
    const _bind$5 = _M0MPB4Iter4nextGUssEE(self);
    if (_bind$5 === undefined) {
      break;
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      _M0MPC15array5Array4pushGUssEE(result, _x);
      continue;
    }
  }
  return result;
}
function _M0MPB4Iter9to__arrayGyE(self) {
  const _bind$4 = self.size_hint;
  let result;
  if (_bind$4 === undefined) {
    result = [];
  } else {
    const _Some = _bind$4;
    const _n = _Some;
    result = _M0MPC15array5Array11new_2einnerGyE(_n);
  }
  while (true) {
    const _bind$5 = _M0MPB4Iter4nextGyE(self);
    if (_bind$5 === -1) {
      break;
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      _M0MPC15array5Array4pushGyE(result, _x);
      continue;
    }
  }
  return result;
}
function _M0MPC16string6String7replace(self, old, new_) {
  const _bind$4 = _M0MPC16string6String4find(self, old);
  if (_bind$4 === undefined) {
    return self;
  } else {
    const _Some = _bind$4;
    const _end = _Some;
    const _self = _M0MPB13StringBuilder21StringBuilder_2einner(0);
    _M0MPB13StringBuilder11write__iter(_self, _M0MPC16string10StringView4iter(_M0MPC16string6String12view_2einner(self, 0, _end)));
    _M0MPB13StringBuilder11write__iter(_self, _M0MPC16string10StringView4iter(new_));
    _M0MPB13StringBuilder11write__iter(_self, _M0MPC16string10StringView4iter(_M0MPC16string6String12view_2einner(self, _end + (old.end - old.start | 0) | 0, undefined)));
    const _p$4 = _self;
    return _p$4.val;
  }
}
function _M0MPC16string6String12replace__all(self, old, new_) {
  const len = self.length;
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(len);
  const old_len = old.end - old.start | 0;
  const new$2 = _M0MPC16string10StringView9to__owned(new_);
  if (old_len === 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(buf, new$2);
    const _it = _M0MPC16string6String4iter(self);
    while (true) {
      const _bind$4 = _M0MPB4Iter4nextGcE(_it);
      if (_bind$4 === -1) {
        break;
      } else {
        const _Some = _bind$4;
        const _c = _Some;
        _M0IPB13StringBuilderPB6Logger11write__char(buf, _c);
        _M0IPB13StringBuilderPB6Logger13write__string(buf, new$2);
        continue;
      }
    }
    return buf.val;
  } else {
    const first_end = _M0MPC16string6String4find(self, old);
    if (first_end === undefined) {
      return self;
    } else {
      const _Some = first_end;
      const _end = _Some;
      let _tmp$38 = new _M0TPC16string10StringView(self, 0, self.length);
      let _tmp$39 = _end;
      while (true) {
        const view = _tmp$38;
        const end = _tmp$39;
        const seg = _M0MPC16string10StringView12view_2einner(view, 0, end);
        _M0IP016_24default__implPB6Logger16write__substringGRPB13StringBuilderE(buf, seg.str, seg.start, seg.end - seg.start | 0);
        _M0IPB13StringBuilderPB6Logger13write__string(buf, new$2);
        if ((end + old_len | 0) <= len) {
          const next_view = _M0MPC16string10StringView12view_2einner(view, end + old_len | 0, undefined);
          const _bind$4 = _M0MPC16string10StringView4find(next_view, old);
          if (_bind$4 === undefined) {
            _M0IP016_24default__implPB6Logger16write__substringGRPB13StringBuilderE(buf, next_view.str, next_view.start, next_view.end - next_view.start | 0);
            break;
          } else {
            const _Some$2 = _bind$4;
            const _next_end = _Some$2;
            _tmp$38 = next_view;
            _tmp$39 = _next_end;
            continue;
          }
        } else {
          break;
        }
      }
      return buf.val;
    }
  }
}
function _M0MPC14char4Char20is__ascii__uppercase(self) {
  return self >= 65 && self <= 90;
}
function _M0MPC16string6String9to__lower(self) {
  const _bind$4 = _M0MPC16string6String8find__by(self, (x) => _M0MPC14char4Char20is__ascii__uppercase(x));
  if (_bind$4 === undefined) {
    return self;
  } else {
    const _Some = _bind$4;
    const _idx = _Some;
    const buf = _M0MPB13StringBuilder21StringBuilder_2einner(self.length);
    const head = _M0MPC16string6String12view_2einner(self, 0, _idx);
    _M0IP016_24default__implPB6Logger16write__substringGRPB13StringBuilderE(buf, head.str, head.start, head.end - head.start | 0);
    const _it = _M0MPC16string10StringView4iter(_M0MPC16string6String12view_2einner(self, _idx, undefined));
    while (true) {
      const _bind$5 = _M0MPB4Iter4nextGcE(_it);
      if (_bind$5 === -1) {
        break;
      } else {
        const _Some$2 = _bind$5;
        const _c = _Some$2;
        if (_M0MPC14char4Char20is__ascii__uppercase(_c)) {
          _M0IPB13StringBuilderPB6Logger11write__char(buf, _c + 32 | 0);
        } else {
          _M0IPB13StringBuilderPB6Logger11write__char(buf, _c);
        }
        continue;
      }
    }
    return buf.val;
  }
}
function _M0MPC14char4Char20is__ascii__lowercase(self) {
  return self >= 97 && self <= 122;
}
function _M0MPC16string6String9get__char(self, idx) {
  if (idx >= 0 && idx < self.length) {
    const c = self.charCodeAt(idx);
    if (_M0MPC16uint166UInt1622is__leading__surrogate(c)) {
      if ((idx + 1 | 0) < self.length) {
        const next = self.charCodeAt(idx + 1 | 0);
        return _M0MPC16uint166UInt1623is__trailing__surrogate(next) ? _M0FPB32code__point__of__surrogate__pair(c, next) : -1;
      } else {
        return -1;
      }
    } else {
      return _M0MPC16uint166UInt1623is__trailing__surrogate(c) ? -1 : c;
    }
  } else {
    return -1;
  }
}
function _M0MPC16string10StringView9get__char(self, idx) {
  if (idx >= 0 && idx < (self.end - self.start | 0)) {
    const c = self.str.charCodeAt(self.start + idx | 0);
    if (_M0MPC16uint166UInt1622is__leading__surrogate(c)) {
      if ((idx + 1 | 0) < (self.end - self.start | 0)) {
        const _p$4 = idx + 1 | 0;
        const next = self.str.charCodeAt(self.start + _p$4 | 0);
        return _M0MPC16uint166UInt1623is__trailing__surrogate(next) ? _M0FPB32code__point__of__surrogate__pair(c, next) : -1;
      } else {
        return -1;
      }
    } else {
      return _M0MPC16uint166UInt1623is__trailing__surrogate(c) ? -1 : c;
    }
  } else {
    return -1;
  }
}
function _M0IPC16string6StringPB12ToStringView16to__string__view(self) {
  return new _M0TPC16string10StringView(self, 0, self.length);
}
function _M0IPC16string6StringPB7Compare7compare(self, other) {
  const len = self.length;
  const _bind$4 = $compare_int(len, other.length);
  if (_bind$4 === 0) {
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < len) {
        const _p$4 = self.charCodeAt(i);
        const _p$5 = other.charCodeAt(i);
        const order = $compare_int(_p$4, _p$5);
        if (order !== 0) {
          return order;
        }
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return 0;
  } else {
    return _bind$4;
  }
}
function _M0MPC16string6String9to__array(self) {
  const _p$4 = _M0MPC16string6String4iter(self);
  const _p$5 = _M0MPC15array5Array11new_2einnerGcE(self.length);
  let _p$6 = _p$5;
  while (true) {
    const _p$7 = _M0MPB4Iter4nextGcE(_p$4);
    if (_p$7 === -1) {
      break;
    } else {
      const _p$8 = _p$7;
      const _p$9 = _p$8;
      const _p$10 = _p$6;
      _M0MPC15array5Array4pushGcE(_p$10, _p$9);
      _p$6 = _p$10;
      continue;
    }
  }
  return _p$6;
}
function _M0MPB4Iter5iter2GcE(self) {
  const i = new _M0TPB8MutLocalGiE(0);
  return new _M0TPB4IterGUicEE(() => {
    const _bind$4 = _M0MPB4Iter4nextGcE(self);
    if (_bind$4 === -1) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _elem = _Some;
      const result = { _0: i.val, _1: _elem };
      i.val = i.val + 1 | 0;
      return result;
    }
  }, self.size_hint);
}
function _M0MPC16string6String5iter2(self) {
  return _M0MPB4Iter5iter2GcE(_M0MPC16string6String4iter(self));
}
function _M0IPC13int3IntPB4Show10to__string(self) {
  return _M0MPC13int3Int18to__string_2einner(self, 10);
}
function _M0IPC15int645Int64PB4Show10to__string(self) {
  return _M0MPC15int645Int6418to__string_2einner(self, 10);
}
function _M0IPC14uint4UIntPB4Show10to__string(self) {
  return _M0MPC14uint4UInt18to__string_2einner(self, 10);
}
function _M0IPC16option6OptionPB4Show6outputGRP219moonbit_2dcommunity4yaml3TagE(self, logger) {
  if (self === undefined) {
    logger.method_table.method_0(logger.self, "None");
    return;
  } else {
    const _Some = self;
    const _arg = _Some;
    logger.method_table.method_0(logger.self, "Some(");
    _M0MPB6Logger13write__objectGRP219moonbit_2dcommunity4yaml3TagE(logger, _arg);
    logger.method_table.method_0(logger.self, ")");
    return;
  }
}
function _M0IPC16option6OptionPB4Show6outputGsE(self, logger) {
  if (self === undefined) {
    logger.method_table.method_0(logger.self, "None");
    return;
  } else {
    const _Some = self;
    const _arg = _Some;
    logger.method_table.method_0(logger.self, "Some(");
    _M0MPB6Logger13write__objectGsE(logger, _arg);
    logger.method_table.method_0(logger.self, ")");
    return;
  }
}
function _M0MPC15array9ArrayView4iterGsE(self) {
  const i = new _M0TPB8MutLocalGiE(0);
  const len = self.end - self.start | 0;
  return _M0MPB4Iter3newGUssEE(() => {
    if (i.val < len) {
      const elem = self.buf[self.start + i.val | 0];
      i.val = i.val + 1 | 0;
      return elem;
    } else {
      return undefined;
    }
  }, len);
}
function _M0MPC15array9ArrayView4iterGyE(self) {
  const i = new _M0TPB8MutLocalGiE(0);
  const len = self.end - self.start | 0;
  return _M0MPB4Iter3newGyE(() => {
    if (i.val < len) {
      const elem = self.buf[self.start + i.val | 0];
      i.val = i.val + 1 | 0;
      return elem;
    } else {
      return -1;
    }
  }, len);
}
function _M0MPC15array9ArrayView4iterGiE(self) {
  const i = new _M0TPB8MutLocalGiE(0);
  const len = self.end - self.start | 0;
  return _M0MPB4Iter3newGiE(() => {
    if (i.val < len) {
      const elem = self.buf[self.start + i.val | 0];
      i.val = i.val + 1 | 0;
      return elem;
    } else {
      return undefined;
    }
  }, len);
}
function _M0MPC15array9ArrayView4iterGRPB5ArrayGRPB4JsonEE(self) {
  const i = new _M0TPB8MutLocalGiE(0);
  const len = self.end - self.start | 0;
  return _M0MPB4Iter3newGRPB5ArrayGRPB4JsonEE(() => {
    if (i.val < len) {
      const elem = self.buf[self.start + i.val | 0];
      i.val = i.val + 1 | 0;
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some(elem);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }, len);
}
function _M0MPC15array9ArrayView4iterGcE(self) {
  const i = new _M0TPB8MutLocalGiE(0);
  const len = self.end - self.start | 0;
  return _M0MPB4Iter3newGcE(() => {
    if (i.val < len) {
      const elem = self.buf[self.start + i.val | 0];
      i.val = i.val + 1 | 0;
      return elem;
    } else {
      return -1;
    }
  }, len);
}
function _M0MPC15array10FixedArray4iterGyE(self) {
  return _M0MPC15array9ArrayView4iterGyE(new _M0TPB9ArrayViewGyE(self, 0, self.length));
}
function _M0MPC15array5Array4iterGsE(self) {
  return _M0MPC15array9ArrayView4iterGsE(new _M0TPB9ArrayViewGsE(self, 0, self.length));
}
function _M0MPC15array5Array4iterGiE(self) {
  return _M0MPC15array9ArrayView4iterGiE(new _M0TPB9ArrayViewGiE(self, 0, self.length));
}
function _M0MPC15array5Array4iterGRPB5ArrayGRPB4JsonEE(self) {
  return _M0MPC15array9ArrayView4iterGRPB5ArrayGRPB4JsonEE(new _M0TPB9ArrayViewGRPB5ArrayGRPB4JsonEE(self, 0, self.length));
}
function _M0MPC15array5Array4iterGcE(self) {
  return _M0MPC15array9ArrayView4iterGcE(new _M0TPB9ArrayViewGcE(self, 0, self.length));
}
function _M0IPC15array5ArrayPB4Show6outputGRPB4JsonE(self, logger) {
  _M0MPB6Logger19write__iter_2einnerGRPB4JsonE(logger, _M0MPC15array5Array4iterGsE(self), "[", "]", ", ", false);
}
function _M0IPC15array5ArrayPB4Show6outputGUsOsEE(self, logger) {
  _M0MPB6Logger19write__iter_2einnerGUsOsEE(logger, _M0MPC15array5Array4iterGsE(self), "[", "]", ", ", false);
}
function _M0MPC15array10FixedArray11from__arrayGjE(array) {
  const _p$4 = array.end - array.start | 0;
  if (_p$4 <= 0) {
    return [];
  } else {
    const _p$5 = 0;
    const _p$6 = $make_array_len_and_init(_p$4, array.buf[array.start + _p$5 | 0]);
    let _tmp$38 = 1;
    while (true) {
      const _p$7 = _tmp$38;
      if (_p$7 < _p$4) {
        $bound_check(_p$6, _p$7);
        _p$6[_p$7] = array.buf[array.start + _p$7 | 0];
        _tmp$38 = _p$7 + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return _p$6;
  }
}
function _M0MPC15array10FixedArray11from__arrayGyE(array) {
  const _p$4 = array.end - array.start | 0;
  if (_p$4 <= 0) {
    return new Uint8Array([]);
  } else {
    const _p$5 = 0;
    const _p$6 = $makebytes(_p$4, array.buf[array.start + _p$5 | 0]);
    let _tmp$38 = 1;
    while (true) {
      const _p$7 = _tmp$38;
      if (_p$7 < _p$4) {
        $bound_check(_p$6, _p$7);
        _p$6[_p$7] = array.buf[array.start + _p$7 | 0];
        _tmp$38 = _p$7 + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return _p$6;
  }
}
function _M0MPC15array10FixedArray10from__iterGyE(iter) {
  const _bind$4 = _M0MPB4Iter9to__arrayGyE(iter);
  return _M0MPC15array10FixedArray11from__arrayGyE(new _M0TPB9ArrayViewGyE(_bind$4, 0, _bind$4.length));
}
function _M0MPC15array9ArrayView5iter2GiE(self) {
  const i = new _M0TPB8MutLocalGiE(0);
  const len = self.end - self.start | 0;
  return _M0MPB5Iter23newGiiE(() => {
    if (i.val < len) {
      const result = { _0: i.val, _1: self.buf[self.start + i.val | 0] };
      i.val = i.val + 1 | 0;
      return result;
    } else {
      return undefined;
    }
  }, len);
}
function _M0MPC15array9ArrayView5iter2GRP27gmlewis5flate11LiteralNodeE(self) {
  const i = new _M0TPB8MutLocalGiE(0);
  const len = self.end - self.start | 0;
  return _M0MPB5Iter23newGiRP27gmlewis5flate11LiteralNodeE(() => {
    if (i.val < len) {
      const result = { _0: i.val, _1: self.buf[self.start + i.val | 0] };
      i.val = i.val + 1 | 0;
      return result;
    } else {
      return undefined;
    }
  }, len);
}
function _M0MPC15array9ArrayView2atGyE(self, index) {
  if (index >= 0 && index < (self.end - self.start | 0)) {
    const _tmp$38 = self.buf;
    const _tmp$39 = self.start + index | 0;
    $bound_check(_tmp$38, _tmp$39);
    return _tmp$38[_tmp$39];
  } else {
    return _M0FPC15abort5abortGyE(`index out of bounds: the len is from 0 to ${_M0IPC13int3IntPB4Show10to__string(self.end - self.start | 0)} but the index is ${_M0IPC13int3IntPB4Show10to__string(index)}`);
  }
}
function _M0MPC15array9ArrayView2atGcE(self, index) {
  if (index >= 0 && index < (self.end - self.start | 0)) {
    const _tmp$38 = self.buf;
    const _tmp$39 = self.start + index | 0;
    $bound_check(_tmp$38, _tmp$39);
    return _tmp$38[_tmp$39];
  } else {
    return _M0FPC15abort5abortGcE(`index out of bounds: the len is from 0 to ${_M0IPC13int3IntPB4Show10to__string(self.end - self.start | 0)} but the index is ${_M0IPC13int3IntPB4Show10to__string(index)}`);
  }
}
function _M0MPC15array9ArrayView2atGRP219moonbit_2dcommunity7piediff4EditE(self, index) {
  if (index >= 0 && index < (self.end - self.start | 0)) {
    const _tmp$38 = self.buf;
    const _tmp$39 = self.start + index | 0;
    $bound_check(_tmp$38, _tmp$39);
    return _tmp$38[_tmp$39];
  } else {
    return _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE(`index out of bounds: the len is from 0 to ${_M0IPC13int3IntPB4Show10to__string(self.end - self.start | 0)} but the index is ${_M0IPC13int3IntPB4Show10to__string(index)}`);
  }
}
function _M0MPC15array10FixedArray12view_2einnerGyE(self, start, end) {
  const len = self.length;
  let end$2;
  if (end === undefined) {
    end$2 = len;
  } else {
    const _Some = end;
    const _end = _Some;
    end$2 = _end < 0 ? len + _end | 0 : _end;
  }
  const start$2 = start < 0 ? len + start | 0 : start;
  if (start$2 >= 0 && (start$2 <= end$2 && end$2 <= len)) {
    const _bind$4 = self;
    const _bind$5 = end$2 - start$2 | 0;
    return new _M0TPB9ArrayViewGyE(_bind$4, start$2, start$2 + _bind$5 | 0);
  } else {
    return _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("View index out of bounds");
  }
}
function _M0MPB4Iter5emptyGRPB4JsonE() {
  return _M0MPB4Iter3newGUssEE(() => undefined, _M0MPB4Iter5emptyN6constrS9081GRPB4JsonE);
}
function _M0IPC16option6OptionPB2Eq5equalGsE(self, other) {
  if (self === undefined) {
    return other === undefined;
  } else {
    const _Some = self;
    const _x = _Some;
    if (other === undefined) {
      return false;
    } else {
      const _Some$2 = other;
      const _y = _Some$2;
      return _x === _y;
    }
  }
}
function _M0IPC16option6OptionPB2Eq5equalGcE(self, other) {
  if (self === -1) {
    return other === -1;
  } else {
    const _Some = self;
    const _x = _Some;
    if (other === -1) {
      return false;
    } else {
      const _Some$2 = other;
      const _y = _Some$2;
      return _x === _y;
    }
  }
}
function _M0IPC16option6OptionPB2Eq5equalGRP27gmlewis2io7IOErrorE(self, other) {
  if (self === undefined) {
    return other === undefined;
  } else {
    const _Some = self;
    const _x = _Some;
    if (other === undefined) {
      return false;
    } else {
      const _Some$2 = other;
      const _y = _Some$2;
      return _M0IP27gmlewis2io7IOErrorPB2Eq5equal(_x, _y);
    }
  }
}
function _M0IPC16option6OptionPB2Eq5equalGRP38bobzhang6moonjq6parser5TokenE(self, other) {
  if (self === undefined) {
    return other === undefined;
  } else {
    const _Some = self;
    const _x = _Some;
    if (other === undefined) {
      return false;
    } else {
      const _Some$2 = other;
      const _y = _Some$2;
      return _M0IP38bobzhang6moonjq6parser5TokenPB2Eq5equal(_x, _y);
    }
  }
}
function _M0IPC16option6OptionPB2Eq5equalGRP219moonbit_2dcommunity4yaml3TagE(self, other) {
  if (self === undefined) {
    return other === undefined;
  } else {
    const _Some = self;
    const _x = _Some;
    if (other === undefined) {
      return false;
    } else {
      const _Some$2 = other;
      const _y = _Some$2;
      return _x.handle === _y.handle && _x.suffix === _y.suffix;
    }
  }
}
function _M0IPC16option6OptionPB2Eq5equalGRPC111sorted__map4NodeGiRP219moonbit_2dcommunity4yaml4YamlEE(self, other) {
  if (self === undefined) {
    return other === undefined;
  } else {
    const _Some = self;
    const _x = _Some;
    if (other === undefined) {
      return false;
    } else {
      const _Some$2 = other;
      const _y = _Some$2;
      return _x.key === _y.key;
    }
  }
}
function _M0MPC16option6Option10unwrap__orGRPB5ArrayGsEE(self, default_) {
  if (self.$tag === 0) {
    return default_;
  } else {
    const _Some = self;
    return _Some._0;
  }
}
function _M0MPC16option6Option16unwrap__or__elseGRP219moonbit_2dcommunity4yaml5TokenE(self, default_) {
  if (self === undefined) {
    return default_();
  } else {
    const _Some = self;
    const _t = _Some;
    return _t;
  }
}
function _M0MPB4Iter9singletonGRPB4JsonE(elem) {
  const consumed = new _M0TPB8MutLocalGbE(false);
  return _M0MPB4Iter3newGUssEE(() => {
    if (consumed.val) {
      return undefined;
    } else {
      consumed.val = true;
      return elem;
    }
  }, _M0MPB4Iter9singletonN6constrS9082GRPB4JsonE);
}
function _M0MPC16option6Option3mapGRPC16string10StringViewsE(self, f) {
  if (self === undefined) {
    return undefined;
  } else {
    const _Some = self;
    const _t = _Some;
    return f(_t);
  }
}
function _M0MPC16option6Option3mapGcbE(self, f) {
  if (self === -1) {
    return -1;
  } else {
    const _Some = self;
    const _t = _Some;
    return f(_t);
  }
}
function _M0MPC16option6Option7map__orGRP219moonbit_2dcommunity4yaml6IndentbE(self, default_, f) {
  if (self === undefined) {
    return default_;
  } else {
    const _Some = self;
    const _x = _Some;
    return f(_x);
  }
}
function _M0MPC15array12MutArrayView2atGUssEE(self, index) {
  if (index >= 0 && index < (self.end - self.start | 0)) {
    const _tmp$38 = self.buf;
    const _tmp$39 = self.start + index | 0;
    $bound_check(_tmp$38, _tmp$39);
    return _tmp$38[_tmp$39];
  } else {
    return _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE(`index out of bounds: the len is from 0 to ${_M0IPC13int3IntPB4Show10to__string(self.end - self.start | 0)} but the index is ${_M0IPC13int3IntPB4Show10to__string(index)}`);
  }
}
function _M0MPC15array12MutArrayView3setGUssEE(self, index, value) {
  if (index >= 0 && index < (self.end - self.start | 0)) {
    const _tmp$38 = self.buf;
    const _tmp$39 = self.start + index | 0;
    $bound_check(_tmp$38, _tmp$39);
    _tmp$38[_tmp$39] = value;
    return;
  } else {
    _M0FPC15abort5abortGuE(`index out of bounds: the len is from 0 to ${_M0IPC13int3IntPB4Show10to__string(self.end - self.start | 0)} but the index is ${_M0IPC13int3IntPB4Show10to__string(index)}`);
    return;
  }
}
function _M0MPC15array5Array17mut__view_2einnerGUssEE(self, start, end) {
  const len = self.length;
  let end$2;
  if (end === undefined) {
    end$2 = len;
  } else {
    const _Some = end;
    const _end = _Some;
    end$2 = _end < 0 ? len + _end | 0 : _end;
  }
  const start$2 = start < 0 ? len + start | 0 : start;
  if (start$2 >= 0 && (start$2 <= end$2 && end$2 <= len)) {
    const _bind$4 = self;
    const _bind$5 = end$2 - start$2 | 0;
    return new _M0TPB12MutArrayViewGUssEE(_bind$4, start$2, start$2 + _bind$5 | 0);
  } else {
    return _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("View index out of bounds");
  }
}
function _M0MPC15array12MutArrayView17mut__view_2einnerGUssEE(self, start, end) {
  const len = self.end - self.start | 0;
  let end$2;
  if (end === undefined) {
    end$2 = len;
  } else {
    const _Some = end;
    const _end = _Some;
    end$2 = _end < 0 ? len + _end | 0 : _end;
  }
  const start$2 = start < 0 ? len + start | 0 : start;
  if (start$2 >= 0 && (start$2 <= end$2 && end$2 <= len)) {
    const _bind$4 = self.buf;
    const _bind$5 = self.start + start$2 | 0;
    const _bind$6 = end$2 - start$2 | 0;
    return new _M0TPB12MutArrayViewGUssEE(_bind$4, _bind$5, _bind$5 + _bind$6 | 0);
  } else {
    return _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("View index out of bounds");
  }
}
function _M0MPC15array5Array4makeGiE(len, elem) {
  const arr = new Array(len);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < len) {
      arr[i] = elem;
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return arr;
}
function _M0MPC15array5Array4makeGyE(len, elem) {
  const arr = new Array(len);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < len) {
      arr[i] = elem;
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return arr;
}
function _M0MPC15array5Array4makeGjE(len, elem) {
  const arr = new Array(len);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < len) {
      arr[i] = elem;
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return arr;
}
function _M0MPC15array5Array4makeGRP27gmlewis5flate5TokenE(len, elem) {
  const arr = new Array(len);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < len) {
      arr[i] = elem;
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return arr;
}
function _M0MPC15array5Array4makeGRP27gmlewis5flate5HCodeE(len, elem) {
  const arr = new Array(len);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < len) {
      arr[i] = elem;
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return arr;
}
function _M0MPC15array5Array4makeGRPB5ArrayGjEE(len, elem) {
  const arr = new Array(len);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < len) {
      arr[i] = elem;
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return arr;
}
function _M0MPC15array5Array3setGsE(self, index, value) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    self[index] = value;
    return;
  } else {
    $panic();
    return;
  }
}
function _M0MPC15array5Array3setGbE(self, index, value) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    self[index] = value;
    return;
  } else {
    $panic();
    return;
  }
}
function _M0MPC15array5Array3setGiE(self, index, value) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    self[index] = value;
    return;
  } else {
    $panic();
    return;
  }
}
function _M0MPC15array5Array3setGyE(self, index, value) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    self[index] = value;
    return;
  } else {
    $panic();
    return;
  }
}
function _M0MPC15array5Array3setGcE(self, index, value) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    self[index] = value;
    return;
  } else {
    $panic();
    return;
  }
}
function _M0MPC15array5Array3setGjE(self, index, value) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    self[index] = value;
    return;
  } else {
    $panic();
    return;
  }
}
function _M0MPC15array5Array3setGRPB5ArrayGjEE(self, index, value) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    self[index] = value;
    return;
  } else {
    $panic();
    return;
  }
}
function _M0MPC15array9ArrayView9to__ownedGRPB4JsonE(self) {
  const len = self.end - self.start | 0;
  if (len === 0) {
    return [];
  } else {
    const arr = _M0MPC15array5Array4makeGRP27gmlewis5flate5HCodeE(len, _M0MPC15array9ArrayView2atGRP219moonbit_2dcommunity7piediff4EditE(self, 0));
    const _bind$4 = self.end - self.start | 0;
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < _bind$4) {
        const v = self.buf[self.start + i | 0];
        _M0MPC15array5Array3setGsE(arr, i, v);
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return arr;
  }
}
function _M0MPC13int3Int20next__power__of__two(self) {
  if (self >= 0) {
    if (self <= 1) {
      return 1;
    }
    if (self > 1073741824) {
      return 1073741824;
    }
    return (2147483647 >> (Math.clz32(self - 1 | 0) - 1 | 0)) + 1 | 0;
  } else {
    return $panic();
  }
}
function _M0FPB8new__mapGssE(capacity) {
  const capacity$2 = _M0MPC13int3Int20next__power__of__two(capacity);
  const _bind$4 = capacity$2 - 1 | 0;
  const _bind$5 = (Math.imul(capacity$2, 13) | 0) / 16 | 0;
  const _bind$6 = $make_array_len_and_init(capacity$2, undefined);
  const _bind$7 = undefined;
  return new _M0TPB3MapGssE(_bind$6, 0, capacity$2, _bind$4, _bind$5, _bind$7, -1);
}
function _M0FPB8new__mapGsbE(capacity) {
  const capacity$2 = _M0MPC13int3Int20next__power__of__two(capacity);
  const _bind$4 = capacity$2 - 1 | 0;
  const _bind$5 = (Math.imul(capacity$2, 13) | 0) / 16 | 0;
  const _bind$6 = $make_array_len_and_init(capacity$2, undefined);
  const _bind$7 = undefined;
  return new _M0TPB3MapGsbE(_bind$6, 0, capacity$2, _bind$4, _bind$5, _bind$7, -1);
}
function _M0FPB8new__mapGsRPB5ArrayGsEE(capacity) {
  const capacity$2 = _M0MPC13int3Int20next__power__of__two(capacity);
  const _bind$4 = capacity$2 - 1 | 0;
  const _bind$5 = (Math.imul(capacity$2, 13) | 0) / 16 | 0;
  const _bind$6 = $make_array_len_and_init(capacity$2, undefined);
  const _bind$7 = undefined;
  return new _M0TPB3MapGsRPB5ArrayGsEE(_bind$6, 0, capacity$2, _bind$4, _bind$5, _bind$7, -1);
}
function _M0FPB8new__mapGsiE(capacity) {
  const capacity$2 = _M0MPC13int3Int20next__power__of__two(capacity);
  const _bind$4 = capacity$2 - 1 | 0;
  const _bind$5 = (Math.imul(capacity$2, 13) | 0) / 16 | 0;
  const _bind$6 = $make_array_len_and_init(capacity$2, undefined);
  const _bind$7 = undefined;
  return new _M0TPB3MapGsiE(_bind$6, 0, capacity$2, _bind$4, _bind$5, _bind$7, -1);
}
function _M0FPB8new__mapGccE(capacity) {
  const capacity$2 = _M0MPC13int3Int20next__power__of__two(capacity);
  const _bind$4 = capacity$2 - 1 | 0;
  const _bind$5 = (Math.imul(capacity$2, 13) | 0) / 16 | 0;
  const _bind$6 = $make_array_len_and_init(capacity$2, undefined);
  const _bind$7 = undefined;
  return new _M0TPB3MapGccE(_bind$6, 0, capacity$2, _bind$4, _bind$5, _bind$7, -1);
}
function _M0FPB21capacity__for__length(length) {
  let capacity = _M0MPC13int3Int20next__power__of__two(length);
  const _p$4 = capacity;
  if (length > ((Math.imul(_p$4, 13) | 0) / 16 | 0)) {
    capacity = Math.imul(capacity, 2) | 0;
  }
  return capacity;
}
function _M0MPB3Map20add__entry__to__tailGssE(self, idx, entry) {
  const _bind$4 = self.tail;
  if (_bind$4 === -1) {
    self.head = entry;
  } else {
    const _tmp$38 = self.entries;
    $bound_check(_tmp$38, _bind$4);
    const _p$4 = _tmp$38[_bind$4];
    let _tmp$39;
    if (_p$4 === undefined) {
      _tmp$39 = $panic();
    } else {
      const _p$5 = _p$4;
      _tmp$39 = _p$5;
    }
    _tmp$39.next = entry;
  }
  self.tail = idx;
  const _tmp$38 = self.entries;
  $bound_check(_tmp$38, idx);
  _tmp$38[idx] = entry;
  self.size = self.size + 1 | 0;
}
function _M0MPB3Map20add__entry__to__tailGsbE(self, idx, entry) {
  const _bind$4 = self.tail;
  if (_bind$4 === -1) {
    self.head = entry;
  } else {
    const _tmp$38 = self.entries;
    $bound_check(_tmp$38, _bind$4);
    const _p$4 = _tmp$38[_bind$4];
    let _tmp$39;
    if (_p$4 === undefined) {
      _tmp$39 = $panic();
    } else {
      const _p$5 = _p$4;
      _tmp$39 = _p$5;
    }
    _tmp$39.next = entry;
  }
  self.tail = idx;
  const _tmp$38 = self.entries;
  $bound_check(_tmp$38, idx);
  _tmp$38[idx] = entry;
  self.size = self.size + 1 | 0;
}
function _M0MPB3Map20add__entry__to__tailGsRPB5ArrayGsEE(self, idx, entry) {
  const _bind$4 = self.tail;
  if (_bind$4 === -1) {
    self.head = entry;
  } else {
    const _tmp$38 = self.entries;
    $bound_check(_tmp$38, _bind$4);
    const _p$4 = _tmp$38[_bind$4];
    let _tmp$39;
    if (_p$4 === undefined) {
      _tmp$39 = $panic();
    } else {
      const _p$5 = _p$4;
      _tmp$39 = _p$5;
    }
    _tmp$39.next = entry;
  }
  self.tail = idx;
  const _tmp$38 = self.entries;
  $bound_check(_tmp$38, idx);
  _tmp$38[idx] = entry;
  self.size = self.size + 1 | 0;
}
function _M0MPB3Map20add__entry__to__tailGsiE(self, idx, entry) {
  const _bind$4 = self.tail;
  if (_bind$4 === -1) {
    self.head = entry;
  } else {
    const _tmp$38 = self.entries;
    $bound_check(_tmp$38, _bind$4);
    const _p$4 = _tmp$38[_bind$4];
    let _tmp$39;
    if (_p$4 === undefined) {
      _tmp$39 = $panic();
    } else {
      const _p$5 = _p$4;
      _tmp$39 = _p$5;
    }
    _tmp$39.next = entry;
  }
  self.tail = idx;
  const _tmp$38 = self.entries;
  $bound_check(_tmp$38, idx);
  _tmp$38[idx] = entry;
  self.size = self.size + 1 | 0;
}
function _M0MPB3Map20add__entry__to__tailGccE(self, idx, entry) {
  const _bind$4 = self.tail;
  if (_bind$4 === -1) {
    self.head = entry;
  } else {
    const _tmp$38 = self.entries;
    $bound_check(_tmp$38, _bind$4);
    const _p$4 = _tmp$38[_bind$4];
    let _tmp$39;
    if (_p$4 === undefined) {
      _tmp$39 = $panic();
    } else {
      const _p$5 = _p$4;
      _tmp$39 = _p$5;
    }
    _tmp$39.next = entry;
  }
  self.tail = idx;
  const _tmp$38 = self.entries;
  $bound_check(_tmp$38, idx);
  _tmp$38[idx] = entry;
  self.size = self.size + 1 | 0;
}
function _M0MPB3Map10set__entryGssE(self, entry, new_idx) {
  const _tmp$38 = self.entries;
  $bound_check(_tmp$38, new_idx);
  _tmp$38[new_idx] = entry;
  const _bind$4 = entry.next;
  if (_bind$4 === undefined) {
    self.tail = new_idx;
    return;
  } else {
    const _Some = _bind$4;
    const _next = _Some;
    _next.prev = new_idx;
    return;
  }
}
function _M0MPB3Map10set__entryGsbE(self, entry, new_idx) {
  const _tmp$38 = self.entries;
  $bound_check(_tmp$38, new_idx);
  _tmp$38[new_idx] = entry;
  const _bind$4 = entry.next;
  if (_bind$4 === undefined) {
    self.tail = new_idx;
    return;
  } else {
    const _Some = _bind$4;
    const _next = _Some;
    _next.prev = new_idx;
    return;
  }
}
function _M0MPB3Map10set__entryGsRPB5ArrayGsEE(self, entry, new_idx) {
  const _tmp$38 = self.entries;
  $bound_check(_tmp$38, new_idx);
  _tmp$38[new_idx] = entry;
  const _bind$4 = entry.next;
  if (_bind$4 === undefined) {
    self.tail = new_idx;
    return;
  } else {
    const _Some = _bind$4;
    const _next = _Some;
    _next.prev = new_idx;
    return;
  }
}
function _M0MPB3Map10set__entryGsiE(self, entry, new_idx) {
  const _tmp$38 = self.entries;
  $bound_check(_tmp$38, new_idx);
  _tmp$38[new_idx] = entry;
  const _bind$4 = entry.next;
  if (_bind$4 === undefined) {
    self.tail = new_idx;
    return;
  } else {
    const _Some = _bind$4;
    const _next = _Some;
    _next.prev = new_idx;
    return;
  }
}
function _M0MPB3Map10set__entryGccE(self, entry, new_idx) {
  const _tmp$38 = self.entries;
  $bound_check(_tmp$38, new_idx);
  _tmp$38[new_idx] = entry;
  const _bind$4 = entry.next;
  if (_bind$4 === undefined) {
    self.tail = new_idx;
    return;
  } else {
    const _Some = _bind$4;
    const _next = _Some;
    _next.prev = new_idx;
    return;
  }
}
function _M0MPB3Map10push__awayGssE(self, idx, entry) {
  let _tmp$38 = entry.psl + 1 | 0;
  let _tmp$39 = idx + 1 & self.capacity_mask;
  let _tmp$40 = entry;
  while (true) {
    const psl = _tmp$38;
    const idx$2 = _tmp$39;
    const entry$2 = _tmp$40;
    const _tmp$41 = self.entries;
    $bound_check(_tmp$41, idx$2);
    const _bind$4 = _tmp$41[idx$2];
    if (_bind$4 === undefined) {
      entry$2.psl = psl;
      _M0MPB3Map10set__entryGssE(self, entry$2, idx$2);
      return;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (psl > _curr_entry.psl) {
        entry$2.psl = psl;
        _M0MPB3Map10set__entryGssE(self, entry$2, idx$2);
        _tmp$38 = _curr_entry.psl + 1 | 0;
        _tmp$39 = idx$2 + 1 & self.capacity_mask;
        _tmp$40 = _curr_entry;
        continue;
      } else {
        _tmp$38 = psl + 1 | 0;
        _tmp$39 = idx$2 + 1 & self.capacity_mask;
        continue;
      }
    }
  }
}
function _M0MPB3Map10push__awayGsbE(self, idx, entry) {
  let _tmp$38 = entry.psl + 1 | 0;
  let _tmp$39 = idx + 1 & self.capacity_mask;
  let _tmp$40 = entry;
  while (true) {
    const psl = _tmp$38;
    const idx$2 = _tmp$39;
    const entry$2 = _tmp$40;
    const _tmp$41 = self.entries;
    $bound_check(_tmp$41, idx$2);
    const _bind$4 = _tmp$41[idx$2];
    if (_bind$4 === undefined) {
      entry$2.psl = psl;
      _M0MPB3Map10set__entryGsbE(self, entry$2, idx$2);
      return;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (psl > _curr_entry.psl) {
        entry$2.psl = psl;
        _M0MPB3Map10set__entryGsbE(self, entry$2, idx$2);
        _tmp$38 = _curr_entry.psl + 1 | 0;
        _tmp$39 = idx$2 + 1 & self.capacity_mask;
        _tmp$40 = _curr_entry;
        continue;
      } else {
        _tmp$38 = psl + 1 | 0;
        _tmp$39 = idx$2 + 1 & self.capacity_mask;
        continue;
      }
    }
  }
}
function _M0MPB3Map10push__awayGsRPB5ArrayGsEE(self, idx, entry) {
  let _tmp$38 = entry.psl + 1 | 0;
  let _tmp$39 = idx + 1 & self.capacity_mask;
  let _tmp$40 = entry;
  while (true) {
    const psl = _tmp$38;
    const idx$2 = _tmp$39;
    const entry$2 = _tmp$40;
    const _tmp$41 = self.entries;
    $bound_check(_tmp$41, idx$2);
    const _bind$4 = _tmp$41[idx$2];
    if (_bind$4 === undefined) {
      entry$2.psl = psl;
      _M0MPB3Map10set__entryGsRPB5ArrayGsEE(self, entry$2, idx$2);
      return;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (psl > _curr_entry.psl) {
        entry$2.psl = psl;
        _M0MPB3Map10set__entryGsRPB5ArrayGsEE(self, entry$2, idx$2);
        _tmp$38 = _curr_entry.psl + 1 | 0;
        _tmp$39 = idx$2 + 1 & self.capacity_mask;
        _tmp$40 = _curr_entry;
        continue;
      } else {
        _tmp$38 = psl + 1 | 0;
        _tmp$39 = idx$2 + 1 & self.capacity_mask;
        continue;
      }
    }
  }
}
function _M0MPB3Map10push__awayGsiE(self, idx, entry) {
  let _tmp$38 = entry.psl + 1 | 0;
  let _tmp$39 = idx + 1 & self.capacity_mask;
  let _tmp$40 = entry;
  while (true) {
    const psl = _tmp$38;
    const idx$2 = _tmp$39;
    const entry$2 = _tmp$40;
    const _tmp$41 = self.entries;
    $bound_check(_tmp$41, idx$2);
    const _bind$4 = _tmp$41[idx$2];
    if (_bind$4 === undefined) {
      entry$2.psl = psl;
      _M0MPB3Map10set__entryGsiE(self, entry$2, idx$2);
      return;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (psl > _curr_entry.psl) {
        entry$2.psl = psl;
        _M0MPB3Map10set__entryGsiE(self, entry$2, idx$2);
        _tmp$38 = _curr_entry.psl + 1 | 0;
        _tmp$39 = idx$2 + 1 & self.capacity_mask;
        _tmp$40 = _curr_entry;
        continue;
      } else {
        _tmp$38 = psl + 1 | 0;
        _tmp$39 = idx$2 + 1 & self.capacity_mask;
        continue;
      }
    }
  }
}
function _M0MPB3Map10push__awayGccE(self, idx, entry) {
  let _tmp$38 = entry.psl + 1 | 0;
  let _tmp$39 = idx + 1 & self.capacity_mask;
  let _tmp$40 = entry;
  while (true) {
    const psl = _tmp$38;
    const idx$2 = _tmp$39;
    const entry$2 = _tmp$40;
    const _tmp$41 = self.entries;
    $bound_check(_tmp$41, idx$2);
    const _bind$4 = _tmp$41[idx$2];
    if (_bind$4 === undefined) {
      entry$2.psl = psl;
      _M0MPB3Map10set__entryGccE(self, entry$2, idx$2);
      return;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (psl > _curr_entry.psl) {
        entry$2.psl = psl;
        _M0MPB3Map10set__entryGccE(self, entry$2, idx$2);
        _tmp$38 = _curr_entry.psl + 1 | 0;
        _tmp$39 = idx$2 + 1 & self.capacity_mask;
        _tmp$40 = _curr_entry;
        continue;
      } else {
        _tmp$38 = psl + 1 | 0;
        _tmp$39 = idx$2 + 1 & self.capacity_mask;
        continue;
      }
    }
  }
}
function _M0MPB3Map15set__with__hashGssE(self, key, value, hash) {
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const psl = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      if (self.size >= self.grow_at) {
        _M0MPB3Map4growGssE(self);
        _tmp$38 = 0;
        _tmp$39 = hash & self.capacity_mask;
        continue;
      }
      const _bind$5 = self.tail;
      const _bind$6 = undefined;
      const entry = new _M0TPB5EntryGssE(_bind$5, _bind$6, psl, hash, key, value);
      _M0MPB3Map20add__entry__to__tailGssE(self, idx, entry);
      return undefined;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (_curr_entry.hash === hash && _curr_entry.key === key) {
        _curr_entry.value = value;
        return undefined;
      }
      if (psl > _curr_entry.psl) {
        if (self.size >= self.grow_at) {
          _M0MPB3Map4growGssE(self);
          _tmp$38 = 0;
          _tmp$39 = hash & self.capacity_mask;
          continue;
        }
        _M0MPB3Map10push__awayGssE(self, idx, _curr_entry);
        const _bind$5 = self.tail;
        const _bind$6 = undefined;
        const entry = new _M0TPB5EntryGssE(_bind$5, _bind$6, psl, hash, key, value);
        _M0MPB3Map20add__entry__to__tailGssE(self, idx, entry);
        return undefined;
      }
      _tmp$38 = psl + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map15set__with__hashGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self, key, value, hash) {
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const psl = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      if (self.size >= self.grow_at) {
        _M0MPB3Map4growGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self);
        _tmp$38 = 0;
        _tmp$39 = hash & self.capacity_mask;
        continue;
      }
      const _bind$5 = self.tail;
      const _bind$6 = undefined;
      const entry = new _M0TPB5EntryGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(_bind$5, _bind$6, psl, hash, key, value);
      _M0MPB3Map20add__entry__to__tailGssE(self, idx, entry);
      return undefined;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (_curr_entry.hash === hash && _curr_entry.key === key) {
        _curr_entry.value = value;
        return undefined;
      }
      if (psl > _curr_entry.psl) {
        if (self.size >= self.grow_at) {
          _M0MPB3Map4growGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self);
          _tmp$38 = 0;
          _tmp$39 = hash & self.capacity_mask;
          continue;
        }
        _M0MPB3Map10push__awayGssE(self, idx, _curr_entry);
        const _bind$5 = self.tail;
        const _bind$6 = undefined;
        const entry = new _M0TPB5EntryGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(_bind$5, _bind$6, psl, hash, key, value);
        _M0MPB3Map20add__entry__to__tailGssE(self, idx, entry);
        return undefined;
      }
      _tmp$38 = psl + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map15set__with__hashGsbE(self, key, value, hash) {
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const psl = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      if (self.size >= self.grow_at) {
        _M0MPB3Map4growGsbE(self);
        _tmp$38 = 0;
        _tmp$39 = hash & self.capacity_mask;
        continue;
      }
      const _bind$5 = self.tail;
      const _bind$6 = undefined;
      const entry = new _M0TPB5EntryGsbE(_bind$5, _bind$6, psl, hash, key, value);
      _M0MPB3Map20add__entry__to__tailGsbE(self, idx, entry);
      return undefined;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (_curr_entry.hash === hash && _curr_entry.key === key) {
        _curr_entry.value = value;
        return undefined;
      }
      if (psl > _curr_entry.psl) {
        if (self.size >= self.grow_at) {
          _M0MPB3Map4growGsbE(self);
          _tmp$38 = 0;
          _tmp$39 = hash & self.capacity_mask;
          continue;
        }
        _M0MPB3Map10push__awayGsbE(self, idx, _curr_entry);
        const _bind$5 = self.tail;
        const _bind$6 = undefined;
        const entry = new _M0TPB5EntryGsbE(_bind$5, _bind$6, psl, hash, key, value);
        _M0MPB3Map20add__entry__to__tailGsbE(self, idx, entry);
        return undefined;
      }
      _tmp$38 = psl + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map15set__with__hashGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self, key, value, hash) {
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const psl = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      if (self.size >= self.grow_at) {
        _M0MPB3Map4growGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self);
        _tmp$38 = 0;
        _tmp$39 = hash & self.capacity_mask;
        continue;
      }
      const _bind$5 = self.tail;
      const _bind$6 = undefined;
      const entry = new _M0TPB5EntryGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(_bind$5, _bind$6, psl, hash, key, value);
      _M0MPB3Map20add__entry__to__tailGssE(self, idx, entry);
      return undefined;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (_curr_entry.hash === hash && _curr_entry.key === key) {
        _curr_entry.value = value;
        return undefined;
      }
      if (psl > _curr_entry.psl) {
        if (self.size >= self.grow_at) {
          _M0MPB3Map4growGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self);
          _tmp$38 = 0;
          _tmp$39 = hash & self.capacity_mask;
          continue;
        }
        _M0MPB3Map10push__awayGssE(self, idx, _curr_entry);
        const _bind$5 = self.tail;
        const _bind$6 = undefined;
        const entry = new _M0TPB5EntryGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(_bind$5, _bind$6, psl, hash, key, value);
        _M0MPB3Map20add__entry__to__tailGssE(self, idx, entry);
        return undefined;
      }
      _tmp$38 = psl + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map15set__with__hashGsRP410Haoxincode8moonbash3lib8commands11AwkFunctionE(self, key, value, hash) {
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const psl = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      if (self.size >= self.grow_at) {
        _M0MPB3Map4growGsRP410Haoxincode8moonbash3lib8commands11AwkFunctionE(self);
        _tmp$38 = 0;
        _tmp$39 = hash & self.capacity_mask;
        continue;
      }
      const _bind$5 = self.tail;
      const _bind$6 = undefined;
      const entry = new _M0TPB5EntryGsRP410Haoxincode8moonbash3lib8commands11AwkFunctionE(_bind$5, _bind$6, psl, hash, key, value);
      _M0MPB3Map20add__entry__to__tailGssE(self, idx, entry);
      return undefined;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (_curr_entry.hash === hash && _curr_entry.key === key) {
        _curr_entry.value = value;
        return undefined;
      }
      if (psl > _curr_entry.psl) {
        if (self.size >= self.grow_at) {
          _M0MPB3Map4growGsRP410Haoxincode8moonbash3lib8commands11AwkFunctionE(self);
          _tmp$38 = 0;
          _tmp$39 = hash & self.capacity_mask;
          continue;
        }
        _M0MPB3Map10push__awayGssE(self, idx, _curr_entry);
        const _bind$5 = self.tail;
        const _bind$6 = undefined;
        const entry = new _M0TPB5EntryGsRP410Haoxincode8moonbash3lib8commands11AwkFunctionE(_bind$5, _bind$6, psl, hash, key, value);
        _M0MPB3Map20add__entry__to__tailGssE(self, idx, entry);
        return undefined;
      }
      _tmp$38 = psl + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map15set__with__hashGsRPB4JsonE(self, key, value, hash) {
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const psl = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      if (self.size >= self.grow_at) {
        _M0MPB3Map4growGsRPB4JsonE(self);
        _tmp$38 = 0;
        _tmp$39 = hash & self.capacity_mask;
        continue;
      }
      const _bind$5 = self.tail;
      const _bind$6 = undefined;
      const entry = new _M0TPB5EntryGsRPB4JsonE(_bind$5, _bind$6, psl, hash, key, value);
      _M0MPB3Map20add__entry__to__tailGssE(self, idx, entry);
      return undefined;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (_curr_entry.hash === hash && _curr_entry.key === key) {
        _curr_entry.value = value;
        return undefined;
      }
      if (psl > _curr_entry.psl) {
        if (self.size >= self.grow_at) {
          _M0MPB3Map4growGsRPB4JsonE(self);
          _tmp$38 = 0;
          _tmp$39 = hash & self.capacity_mask;
          continue;
        }
        _M0MPB3Map10push__awayGssE(self, idx, _curr_entry);
        const _bind$5 = self.tail;
        const _bind$6 = undefined;
        const entry = new _M0TPB5EntryGsRPB4JsonE(_bind$5, _bind$6, psl, hash, key, value);
        _M0MPB3Map20add__entry__to__tailGssE(self, idx, entry);
        return undefined;
      }
      _tmp$38 = psl + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map15set__with__hashGsRPB5ArrayGsEE(self, key, value, hash) {
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const psl = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      if (self.size >= self.grow_at) {
        _M0MPB3Map4growGsRPB5ArrayGsEE(self);
        _tmp$38 = 0;
        _tmp$39 = hash & self.capacity_mask;
        continue;
      }
      const _bind$5 = self.tail;
      const _bind$6 = undefined;
      const entry = new _M0TPB5EntryGsRPB5ArrayGsEE(_bind$5, _bind$6, psl, hash, key, value);
      _M0MPB3Map20add__entry__to__tailGsRPB5ArrayGsEE(self, idx, entry);
      return undefined;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (_curr_entry.hash === hash && _curr_entry.key === key) {
        _curr_entry.value = value;
        return undefined;
      }
      if (psl > _curr_entry.psl) {
        if (self.size >= self.grow_at) {
          _M0MPB3Map4growGsRPB5ArrayGsEE(self);
          _tmp$38 = 0;
          _tmp$39 = hash & self.capacity_mask;
          continue;
        }
        _M0MPB3Map10push__awayGsRPB5ArrayGsEE(self, idx, _curr_entry);
        const _bind$5 = self.tail;
        const _bind$6 = undefined;
        const entry = new _M0TPB5EntryGsRPB5ArrayGsEE(_bind$5, _bind$6, psl, hash, key, value);
        _M0MPB3Map20add__entry__to__tailGsRPB5ArrayGsEE(self, idx, entry);
        return undefined;
      }
      _tmp$38 = psl + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map15set__with__hashGsiE(self, key, value, hash) {
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const psl = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      if (self.size >= self.grow_at) {
        _M0MPB3Map4growGsiE(self);
        _tmp$38 = 0;
        _tmp$39 = hash & self.capacity_mask;
        continue;
      }
      const _bind$5 = self.tail;
      const _bind$6 = undefined;
      const entry = new _M0TPB5EntryGsiE(_bind$5, _bind$6, psl, hash, key, value);
      _M0MPB3Map20add__entry__to__tailGsiE(self, idx, entry);
      return undefined;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (_curr_entry.hash === hash && _curr_entry.key === key) {
        _curr_entry.value = value;
        return undefined;
      }
      if (psl > _curr_entry.psl) {
        if (self.size >= self.grow_at) {
          _M0MPB3Map4growGsiE(self);
          _tmp$38 = 0;
          _tmp$39 = hash & self.capacity_mask;
          continue;
        }
        _M0MPB3Map10push__awayGsiE(self, idx, _curr_entry);
        const _bind$5 = self.tail;
        const _bind$6 = undefined;
        const entry = new _M0TPB5EntryGsiE(_bind$5, _bind$6, psl, hash, key, value);
        _M0MPB3Map20add__entry__to__tailGsiE(self, idx, entry);
        return undefined;
      }
      _tmp$38 = psl + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map15set__with__hashGsRPB5ArrayGRPB4JsonEE(self, key, value, hash) {
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const psl = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      if (self.size >= self.grow_at) {
        _M0MPB3Map4growGsRPB5ArrayGRPB4JsonEE(self);
        _tmp$38 = 0;
        _tmp$39 = hash & self.capacity_mask;
        continue;
      }
      const _bind$5 = self.tail;
      const _bind$6 = undefined;
      const entry = new _M0TPB5EntryGsRPB5ArrayGRPB4JsonEE(_bind$5, _bind$6, psl, hash, key, value);
      _M0MPB3Map20add__entry__to__tailGsRPB5ArrayGsEE(self, idx, entry);
      return undefined;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (_curr_entry.hash === hash && _curr_entry.key === key) {
        _curr_entry.value = value;
        return undefined;
      }
      if (psl > _curr_entry.psl) {
        if (self.size >= self.grow_at) {
          _M0MPB3Map4growGsRPB5ArrayGRPB4JsonEE(self);
          _tmp$38 = 0;
          _tmp$39 = hash & self.capacity_mask;
          continue;
        }
        _M0MPB3Map10push__awayGsRPB5ArrayGsEE(self, idx, _curr_entry);
        const _bind$5 = self.tail;
        const _bind$6 = undefined;
        const entry = new _M0TPB5EntryGsRPB5ArrayGRPB4JsonEE(_bind$5, _bind$6, psl, hash, key, value);
        _M0MPB3Map20add__entry__to__tailGsRPB5ArrayGsEE(self, idx, entry);
        return undefined;
      }
      _tmp$38 = psl + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map15set__with__hashGsURP38bobzhang6moonjq3ast4ExprRPB5ArrayGsEEE(self, key, value, hash) {
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const psl = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      if (self.size >= self.grow_at) {
        _M0MPB3Map4growGsURP38bobzhang6moonjq3ast4ExprRPB5ArrayGsEEE(self);
        _tmp$38 = 0;
        _tmp$39 = hash & self.capacity_mask;
        continue;
      }
      const _bind$5 = self.tail;
      const _bind$6 = undefined;
      const entry = new _M0TPB5EntryGsURP38bobzhang6moonjq3ast4ExprRPB5ArrayGsEEE(_bind$5, _bind$6, psl, hash, key, value);
      _M0MPB3Map20add__entry__to__tailGssE(self, idx, entry);
      return undefined;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (_curr_entry.hash === hash && _curr_entry.key === key) {
        _curr_entry.value = value;
        return undefined;
      }
      if (psl > _curr_entry.psl) {
        if (self.size >= self.grow_at) {
          _M0MPB3Map4growGsURP38bobzhang6moonjq3ast4ExprRPB5ArrayGsEEE(self);
          _tmp$38 = 0;
          _tmp$39 = hash & self.capacity_mask;
          continue;
        }
        _M0MPB3Map10push__awayGssE(self, idx, _curr_entry);
        const _bind$5 = self.tail;
        const _bind$6 = undefined;
        const entry = new _M0TPB5EntryGsURP38bobzhang6moonjq3ast4ExprRPB5ArrayGsEEE(_bind$5, _bind$6, psl, hash, key, value);
        _M0MPB3Map20add__entry__to__tailGssE(self, idx, entry);
        return undefined;
      }
      _tmp$38 = psl + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map15set__with__hashGsRP219moonbit_2dcommunity4yaml4YamlE(self, key, value, hash) {
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const psl = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      if (self.size >= self.grow_at) {
        _M0MPB3Map4growGsRP219moonbit_2dcommunity4yaml4YamlE(self);
        _tmp$38 = 0;
        _tmp$39 = hash & self.capacity_mask;
        continue;
      }
      const _bind$5 = self.tail;
      const _bind$6 = undefined;
      const entry = new _M0TPB5EntryGsRP219moonbit_2dcommunity4yaml4YamlE(_bind$5, _bind$6, psl, hash, key, value);
      _M0MPB3Map20add__entry__to__tailGssE(self, idx, entry);
      return undefined;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (_curr_entry.hash === hash && _curr_entry.key === key) {
        _curr_entry.value = value;
        return undefined;
      }
      if (psl > _curr_entry.psl) {
        if (self.size >= self.grow_at) {
          _M0MPB3Map4growGsRP219moonbit_2dcommunity4yaml4YamlE(self);
          _tmp$38 = 0;
          _tmp$39 = hash & self.capacity_mask;
          continue;
        }
        _M0MPB3Map10push__awayGssE(self, idx, _curr_entry);
        const _bind$5 = self.tail;
        const _bind$6 = undefined;
        const entry = new _M0TPB5EntryGsRP219moonbit_2dcommunity4yaml4YamlE(_bind$5, _bind$6, psl, hash, key, value);
        _M0MPB3Map20add__entry__to__tailGssE(self, idx, entry);
        return undefined;
      }
      _tmp$38 = psl + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map15set__with__hashGccE(self, key, value, hash) {
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const psl = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      if (self.size >= self.grow_at) {
        _M0MPB3Map4growGccE(self);
        _tmp$38 = 0;
        _tmp$39 = hash & self.capacity_mask;
        continue;
      }
      const _bind$5 = self.tail;
      const _bind$6 = undefined;
      const entry = new _M0TPB5EntryGccE(_bind$5, _bind$6, psl, hash, key, value);
      _M0MPB3Map20add__entry__to__tailGccE(self, idx, entry);
      return undefined;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (_curr_entry.hash === hash && _curr_entry.key === key) {
        _curr_entry.value = value;
        return undefined;
      }
      if (psl > _curr_entry.psl) {
        if (self.size >= self.grow_at) {
          _M0MPB3Map4growGccE(self);
          _tmp$38 = 0;
          _tmp$39 = hash & self.capacity_mask;
          continue;
        }
        _M0MPB3Map10push__awayGccE(self, idx, _curr_entry);
        const _bind$5 = self.tail;
        const _bind$6 = undefined;
        const entry = new _M0TPB5EntryGccE(_bind$5, _bind$6, psl, hash, key, value);
        _M0MPB3Map20add__entry__to__tailGccE(self, idx, entry);
        return undefined;
      }
      _tmp$38 = psl + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map15set__with__hashGsRPB9ArrayViewGcEE(self, key, value, hash) {
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const psl = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      if (self.size >= self.grow_at) {
        _M0MPB3Map4growGsRPB9ArrayViewGcEE(self);
        _tmp$38 = 0;
        _tmp$39 = hash & self.capacity_mask;
        continue;
      }
      const _bind$5 = self.tail;
      const _bind$6 = undefined;
      const entry = new _M0TPB5EntryGsRPB9ArrayViewGcEE(_bind$5, _bind$6, psl, hash, key, value);
      _M0MPB3Map20add__entry__to__tailGssE(self, idx, entry);
      return undefined;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (_curr_entry.hash === hash && _curr_entry.key === key) {
        _curr_entry.value = value;
        return undefined;
      }
      if (psl > _curr_entry.psl) {
        if (self.size >= self.grow_at) {
          _M0MPB3Map4growGsRPB9ArrayViewGcEE(self);
          _tmp$38 = 0;
          _tmp$39 = hash & self.capacity_mask;
          continue;
        }
        _M0MPB3Map10push__awayGssE(self, idx, _curr_entry);
        const _bind$5 = self.tail;
        const _bind$6 = undefined;
        const entry = new _M0TPB5EntryGsRPB9ArrayViewGcEE(_bind$5, _bind$6, psl, hash, key, value);
        _M0MPB3Map20add__entry__to__tailGssE(self, idx, entry);
        return undefined;
      }
      _tmp$38 = psl + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map4growGssE(self) {
  const old_head = self.head;
  const new_capacity = self.capacity << 1;
  self.entries = $make_array_len_and_init(new_capacity, undefined);
  self.capacity = new_capacity;
  self.capacity_mask = new_capacity - 1 | 0;
  const _p$4 = self.capacity;
  self.grow_at = (Math.imul(_p$4, 13) | 0) / 16 | 0;
  self.size = 0;
  self.head = undefined;
  self.tail = -1;
  let _tmp$38 = old_head;
  while (true) {
    const x = _tmp$38;
    if (x === undefined) {
      return;
    } else {
      const _Some = x;
      const _x = _Some;
      const _next = _x.next;
      const _key = _x.key;
      const _value = _x.value;
      const _hash = _x.hash;
      _M0MPB3Map15set__with__hashGssE(self, _key, _value, _hash);
      _tmp$38 = _next;
      continue;
    }
  }
}
function _M0MPB3Map4growGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self) {
  const old_head = self.head;
  const new_capacity = self.capacity << 1;
  self.entries = $make_array_len_and_init(new_capacity, undefined);
  self.capacity = new_capacity;
  self.capacity_mask = new_capacity - 1 | 0;
  const _p$4 = self.capacity;
  self.grow_at = (Math.imul(_p$4, 13) | 0) / 16 | 0;
  self.size = 0;
  self.head = undefined;
  self.tail = -1;
  let _tmp$38 = old_head;
  while (true) {
    const x = _tmp$38;
    if (x === undefined) {
      return;
    } else {
      const _Some = x;
      const _x = _Some;
      const _next = _x.next;
      const _key = _x.key;
      const _value = _x.value;
      const _hash = _x.hash;
      _M0MPB3Map15set__with__hashGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self, _key, _value, _hash);
      _tmp$38 = _next;
      continue;
    }
  }
}
function _M0MPB3Map4growGsbE(self) {
  const old_head = self.head;
  const new_capacity = self.capacity << 1;
  self.entries = $make_array_len_and_init(new_capacity, undefined);
  self.capacity = new_capacity;
  self.capacity_mask = new_capacity - 1 | 0;
  const _p$4 = self.capacity;
  self.grow_at = (Math.imul(_p$4, 13) | 0) / 16 | 0;
  self.size = 0;
  self.head = undefined;
  self.tail = -1;
  let _tmp$38 = old_head;
  while (true) {
    const x = _tmp$38;
    if (x === undefined) {
      return;
    } else {
      const _Some = x;
      const _x = _Some;
      const _next = _x.next;
      const _key = _x.key;
      const _value = _x.value;
      const _hash = _x.hash;
      _M0MPB3Map15set__with__hashGsbE(self, _key, _value, _hash);
      _tmp$38 = _next;
      continue;
    }
  }
}
function _M0MPB3Map4growGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self) {
  const old_head = self.head;
  const new_capacity = self.capacity << 1;
  self.entries = $make_array_len_and_init(new_capacity, undefined);
  self.capacity = new_capacity;
  self.capacity_mask = new_capacity - 1 | 0;
  const _p$4 = self.capacity;
  self.grow_at = (Math.imul(_p$4, 13) | 0) / 16 | 0;
  self.size = 0;
  self.head = undefined;
  self.tail = -1;
  let _tmp$38 = old_head;
  while (true) {
    const x = _tmp$38;
    if (x === undefined) {
      return;
    } else {
      const _Some = x;
      const _x = _Some;
      const _next = _x.next;
      const _key = _x.key;
      const _value = _x.value;
      const _hash = _x.hash;
      _M0MPB3Map15set__with__hashGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self, _key, _value, _hash);
      _tmp$38 = _next;
      continue;
    }
  }
}
function _M0MPB3Map4growGsRP410Haoxincode8moonbash3lib8commands11AwkFunctionE(self) {
  const old_head = self.head;
  const new_capacity = self.capacity << 1;
  self.entries = $make_array_len_and_init(new_capacity, undefined);
  self.capacity = new_capacity;
  self.capacity_mask = new_capacity - 1 | 0;
  const _p$4 = self.capacity;
  self.grow_at = (Math.imul(_p$4, 13) | 0) / 16 | 0;
  self.size = 0;
  self.head = undefined;
  self.tail = -1;
  let _tmp$38 = old_head;
  while (true) {
    const x = _tmp$38;
    if (x === undefined) {
      return;
    } else {
      const _Some = x;
      const _x = _Some;
      const _next = _x.next;
      const _key = _x.key;
      const _value = _x.value;
      const _hash = _x.hash;
      _M0MPB3Map15set__with__hashGsRP410Haoxincode8moonbash3lib8commands11AwkFunctionE(self, _key, _value, _hash);
      _tmp$38 = _next;
      continue;
    }
  }
}
function _M0MPB3Map4growGsRPB4JsonE(self) {
  const old_head = self.head;
  const new_capacity = self.capacity << 1;
  self.entries = $make_array_len_and_init(new_capacity, undefined);
  self.capacity = new_capacity;
  self.capacity_mask = new_capacity - 1 | 0;
  const _p$4 = self.capacity;
  self.grow_at = (Math.imul(_p$4, 13) | 0) / 16 | 0;
  self.size = 0;
  self.head = undefined;
  self.tail = -1;
  let _tmp$38 = old_head;
  while (true) {
    const x = _tmp$38;
    if (x === undefined) {
      return;
    } else {
      const _Some = x;
      const _x = _Some;
      const _next = _x.next;
      const _key = _x.key;
      const _value = _x.value;
      const _hash = _x.hash;
      _M0MPB3Map15set__with__hashGsRPB4JsonE(self, _key, _value, _hash);
      _tmp$38 = _next;
      continue;
    }
  }
}
function _M0MPB3Map4growGsRPB5ArrayGsEE(self) {
  const old_head = self.head;
  const new_capacity = self.capacity << 1;
  self.entries = $make_array_len_and_init(new_capacity, undefined);
  self.capacity = new_capacity;
  self.capacity_mask = new_capacity - 1 | 0;
  const _p$4 = self.capacity;
  self.grow_at = (Math.imul(_p$4, 13) | 0) / 16 | 0;
  self.size = 0;
  self.head = undefined;
  self.tail = -1;
  let _tmp$38 = old_head;
  while (true) {
    const x = _tmp$38;
    if (x === undefined) {
      return;
    } else {
      const _Some = x;
      const _x = _Some;
      const _next = _x.next;
      const _key = _x.key;
      const _value = _x.value;
      const _hash = _x.hash;
      _M0MPB3Map15set__with__hashGsRPB5ArrayGsEE(self, _key, _value, _hash);
      _tmp$38 = _next;
      continue;
    }
  }
}
function _M0MPB3Map4growGsiE(self) {
  const old_head = self.head;
  const new_capacity = self.capacity << 1;
  self.entries = $make_array_len_and_init(new_capacity, undefined);
  self.capacity = new_capacity;
  self.capacity_mask = new_capacity - 1 | 0;
  const _p$4 = self.capacity;
  self.grow_at = (Math.imul(_p$4, 13) | 0) / 16 | 0;
  self.size = 0;
  self.head = undefined;
  self.tail = -1;
  let _tmp$38 = old_head;
  while (true) {
    const x = _tmp$38;
    if (x === undefined) {
      return;
    } else {
      const _Some = x;
      const _x = _Some;
      const _next = _x.next;
      const _key = _x.key;
      const _value = _x.value;
      const _hash = _x.hash;
      _M0MPB3Map15set__with__hashGsiE(self, _key, _value, _hash);
      _tmp$38 = _next;
      continue;
    }
  }
}
function _M0MPB3Map4growGsRPB5ArrayGRPB4JsonEE(self) {
  const old_head = self.head;
  const new_capacity = self.capacity << 1;
  self.entries = $make_array_len_and_init(new_capacity, undefined);
  self.capacity = new_capacity;
  self.capacity_mask = new_capacity - 1 | 0;
  const _p$4 = self.capacity;
  self.grow_at = (Math.imul(_p$4, 13) | 0) / 16 | 0;
  self.size = 0;
  self.head = undefined;
  self.tail = -1;
  let _tmp$38 = old_head;
  while (true) {
    const x = _tmp$38;
    if (x === undefined) {
      return;
    } else {
      const _Some = x;
      const _x = _Some;
      const _next = _x.next;
      const _key = _x.key;
      const _value = _x.value;
      const _hash = _x.hash;
      _M0MPB3Map15set__with__hashGsRPB5ArrayGRPB4JsonEE(self, _key, _value, _hash);
      _tmp$38 = _next;
      continue;
    }
  }
}
function _M0MPB3Map4growGsURP38bobzhang6moonjq3ast4ExprRPB5ArrayGsEEE(self) {
  const old_head = self.head;
  const new_capacity = self.capacity << 1;
  self.entries = $make_array_len_and_init(new_capacity, undefined);
  self.capacity = new_capacity;
  self.capacity_mask = new_capacity - 1 | 0;
  const _p$4 = self.capacity;
  self.grow_at = (Math.imul(_p$4, 13) | 0) / 16 | 0;
  self.size = 0;
  self.head = undefined;
  self.tail = -1;
  let _tmp$38 = old_head;
  while (true) {
    const x = _tmp$38;
    if (x === undefined) {
      return;
    } else {
      const _Some = x;
      const _x = _Some;
      const _next = _x.next;
      const _key = _x.key;
      const _value = _x.value;
      const _hash = _x.hash;
      _M0MPB3Map15set__with__hashGsURP38bobzhang6moonjq3ast4ExprRPB5ArrayGsEEE(self, _key, _value, _hash);
      _tmp$38 = _next;
      continue;
    }
  }
}
function _M0MPB3Map4growGsRP219moonbit_2dcommunity4yaml4YamlE(self) {
  const old_head = self.head;
  const new_capacity = self.capacity << 1;
  self.entries = $make_array_len_and_init(new_capacity, undefined);
  self.capacity = new_capacity;
  self.capacity_mask = new_capacity - 1 | 0;
  const _p$4 = self.capacity;
  self.grow_at = (Math.imul(_p$4, 13) | 0) / 16 | 0;
  self.size = 0;
  self.head = undefined;
  self.tail = -1;
  let _tmp$38 = old_head;
  while (true) {
    const x = _tmp$38;
    if (x === undefined) {
      return;
    } else {
      const _Some = x;
      const _x = _Some;
      const _next = _x.next;
      const _key = _x.key;
      const _value = _x.value;
      const _hash = _x.hash;
      _M0MPB3Map15set__with__hashGsRP219moonbit_2dcommunity4yaml4YamlE(self, _key, _value, _hash);
      _tmp$38 = _next;
      continue;
    }
  }
}
function _M0MPB3Map4growGccE(self) {
  const old_head = self.head;
  const new_capacity = self.capacity << 1;
  self.entries = $make_array_len_and_init(new_capacity, undefined);
  self.capacity = new_capacity;
  self.capacity_mask = new_capacity - 1 | 0;
  const _p$4 = self.capacity;
  self.grow_at = (Math.imul(_p$4, 13) | 0) / 16 | 0;
  self.size = 0;
  self.head = undefined;
  self.tail = -1;
  let _tmp$38 = old_head;
  while (true) {
    const x = _tmp$38;
    if (x === undefined) {
      return;
    } else {
      const _Some = x;
      const _x = _Some;
      const _next = _x.next;
      const _key = _x.key;
      const _value = _x.value;
      const _hash = _x.hash;
      _M0MPB3Map15set__with__hashGccE(self, _key, _value, _hash);
      _tmp$38 = _next;
      continue;
    }
  }
}
function _M0MPB3Map4growGsRPB9ArrayViewGcEE(self) {
  const old_head = self.head;
  const new_capacity = self.capacity << 1;
  self.entries = $make_array_len_and_init(new_capacity, undefined);
  self.capacity = new_capacity;
  self.capacity_mask = new_capacity - 1 | 0;
  const _p$4 = self.capacity;
  self.grow_at = (Math.imul(_p$4, 13) | 0) / 16 | 0;
  self.size = 0;
  self.head = undefined;
  self.tail = -1;
  let _tmp$38 = old_head;
  while (true) {
    const x = _tmp$38;
    if (x === undefined) {
      return;
    } else {
      const _Some = x;
      const _x = _Some;
      const _next = _x.next;
      const _key = _x.key;
      const _value = _x.value;
      const _hash = _x.hash;
      _M0MPB3Map15set__with__hashGsRPB9ArrayViewGcEE(self, _key, _value, _hash);
      _tmp$38 = _next;
      continue;
    }
  }
}
function _M0MPB3Map3setGssE(self, key, value) {
  _M0MPB3Map15set__with__hashGssE(self, key, value, _M0IP016_24default__implPB4Hash4hashGsE(key));
}
function _M0MPB3Map3setGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self, key, value) {
  _M0MPB3Map15set__with__hashGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self, key, value, _M0IP016_24default__implPB4Hash4hashGsE(key));
}
function _M0MPB3Map3setGsbE(self, key, value) {
  _M0MPB3Map15set__with__hashGsbE(self, key, value, _M0IP016_24default__implPB4Hash4hashGsE(key));
}
function _M0MPB3Map3setGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self, key, value) {
  _M0MPB3Map15set__with__hashGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self, key, value, _M0IP016_24default__implPB4Hash4hashGsE(key));
}
function _M0MPB3Map3setGsRP410Haoxincode8moonbash3lib8commands11AwkFunctionE(self, key, value) {
  _M0MPB3Map15set__with__hashGsRP410Haoxincode8moonbash3lib8commands11AwkFunctionE(self, key, value, _M0IP016_24default__implPB4Hash4hashGsE(key));
}
function _M0MPB3Map3setGsRPB4JsonE(self, key, value) {
  _M0MPB3Map15set__with__hashGsRPB4JsonE(self, key, value, _M0IP016_24default__implPB4Hash4hashGsE(key));
}
function _M0MPB3Map3setGsRPB5ArrayGsEE(self, key, value) {
  _M0MPB3Map15set__with__hashGsRPB5ArrayGsEE(self, key, value, _M0IP016_24default__implPB4Hash4hashGsE(key));
}
function _M0MPB3Map3setGsiE(self, key, value) {
  _M0MPB3Map15set__with__hashGsiE(self, key, value, _M0IP016_24default__implPB4Hash4hashGsE(key));
}
function _M0MPB3Map3setGsRPB5ArrayGRPB4JsonEE(self, key, value) {
  _M0MPB3Map15set__with__hashGsRPB5ArrayGRPB4JsonEE(self, key, value, _M0IP016_24default__implPB4Hash4hashGsE(key));
}
function _M0MPB3Map3setGsURP38bobzhang6moonjq3ast4ExprRPB5ArrayGsEEE(self, key, value) {
  _M0MPB3Map15set__with__hashGsURP38bobzhang6moonjq3ast4ExprRPB5ArrayGsEEE(self, key, value, _M0IP016_24default__implPB4Hash4hashGsE(key));
}
function _M0MPB3Map3setGsRP219moonbit_2dcommunity4yaml4YamlE(self, key, value) {
  _M0MPB3Map15set__with__hashGsRP219moonbit_2dcommunity4yaml4YamlE(self, key, value, _M0IP016_24default__implPB4Hash4hashGsE(key));
}
function _M0MPB3Map3setGccE(self, key, value) {
  _M0MPB3Map15set__with__hashGccE(self, key, value, _M0IP016_24default__implPB4Hash4hashGcE(key));
}
function _M0MPB3Map3setGsRPB9ArrayViewGcEE(self, key, value) {
  _M0MPB3Map15set__with__hashGsRPB9ArrayViewGcEE(self, key, value, _M0IP016_24default__implPB4Hash4hashGsE(key));
}
function _M0MPB3Map3MapGssE(arr, capacity) {
  const length = arr.end - arr.start | 0;
  let capacity$2;
  if (capacity === undefined) {
    capacity$2 = length === 0 ? 8 : _M0FPB21capacity__for__length(length);
  } else {
    const _Some = capacity;
    const _capacity = _Some;
    const _p$4 = _M0FPB21capacity__for__length(length);
    capacity$2 = _capacity > _p$4 ? _capacity : _p$4;
  }
  const m = _M0FPB8new__mapGssE(capacity$2);
  const _bind$4 = arr.end - arr.start | 0;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const e = arr.buf[arr.start + _ | 0];
      _M0MPB3Map3setGssE(m, e._0, e._1);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return m;
}
function _M0MPB3Map3MapGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(arr, capacity) {
  const length = arr.end - arr.start | 0;
  let capacity$2;
  if (capacity === undefined) {
    capacity$2 = length === 0 ? 8 : _M0FPB21capacity__for__length(length);
  } else {
    const _Some = capacity;
    const _capacity = _Some;
    const _p$4 = _M0FPB21capacity__for__length(length);
    capacity$2 = _capacity > _p$4 ? _capacity : _p$4;
  }
  const m = _M0FPB8new__mapGssE(capacity$2);
  const _bind$4 = arr.end - arr.start | 0;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const e = arr.buf[arr.start + _ | 0];
      _M0MPB3Map3setGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(m, e._0, e._1);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return m;
}
function _M0MPB3Map3MapGsbE(arr, capacity) {
  const length = arr.end - arr.start | 0;
  let capacity$2;
  if (capacity === undefined) {
    capacity$2 = length === 0 ? 8 : _M0FPB21capacity__for__length(length);
  } else {
    const _Some = capacity;
    const _capacity = _Some;
    const _p$4 = _M0FPB21capacity__for__length(length);
    capacity$2 = _capacity > _p$4 ? _capacity : _p$4;
  }
  const m = _M0FPB8new__mapGsbE(capacity$2);
  const _bind$4 = arr.end - arr.start | 0;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const e = arr.buf[arr.start + _ | 0];
      _M0MPB3Map3setGsbE(m, e._0, e._1);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return m;
}
function _M0MPB3Map3MapGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(arr, capacity) {
  const length = arr.end - arr.start | 0;
  let capacity$2;
  if (capacity === undefined) {
    capacity$2 = length === 0 ? 8 : _M0FPB21capacity__for__length(length);
  } else {
    const _Some = capacity;
    const _capacity = _Some;
    const _p$4 = _M0FPB21capacity__for__length(length);
    capacity$2 = _capacity > _p$4 ? _capacity : _p$4;
  }
  const m = _M0FPB8new__mapGssE(capacity$2);
  const _bind$4 = arr.end - arr.start | 0;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const e = arr.buf[arr.start + _ | 0];
      _M0MPB3Map3setGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(m, e._0, e._1);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return m;
}
function _M0MPB3Map3MapGsRP410Haoxincode8moonbash3lib8commands11AwkFunctionE(arr, capacity) {
  const length = arr.end - arr.start | 0;
  let capacity$2;
  if (capacity === undefined) {
    capacity$2 = length === 0 ? 8 : _M0FPB21capacity__for__length(length);
  } else {
    const _Some = capacity;
    const _capacity = _Some;
    const _p$4 = _M0FPB21capacity__for__length(length);
    capacity$2 = _capacity > _p$4 ? _capacity : _p$4;
  }
  const m = _M0FPB8new__mapGssE(capacity$2);
  const _bind$4 = arr.end - arr.start | 0;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const e = arr.buf[arr.start + _ | 0];
      _M0MPB3Map3setGsRP410Haoxincode8moonbash3lib8commands11AwkFunctionE(m, e._0, e._1);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return m;
}
function _M0MPB3Map3MapGsRPB4JsonE(arr, capacity) {
  const length = arr.end - arr.start | 0;
  let capacity$2;
  if (capacity === undefined) {
    capacity$2 = length === 0 ? 8 : _M0FPB21capacity__for__length(length);
  } else {
    const _Some = capacity;
    const _capacity = _Some;
    const _p$4 = _M0FPB21capacity__for__length(length);
    capacity$2 = _capacity > _p$4 ? _capacity : _p$4;
  }
  const m = _M0FPB8new__mapGssE(capacity$2);
  const _bind$4 = arr.end - arr.start | 0;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const e = arr.buf[arr.start + _ | 0];
      _M0MPB3Map3setGsRPB4JsonE(m, e._0, e._1);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return m;
}
function _M0MPB3Map3MapGsRPB5ArrayGsEE(arr, capacity) {
  const length = arr.end - arr.start | 0;
  let capacity$2;
  if (capacity === undefined) {
    capacity$2 = length === 0 ? 8 : _M0FPB21capacity__for__length(length);
  } else {
    const _Some = capacity;
    const _capacity = _Some;
    const _p$4 = _M0FPB21capacity__for__length(length);
    capacity$2 = _capacity > _p$4 ? _capacity : _p$4;
  }
  const m = _M0FPB8new__mapGsRPB5ArrayGsEE(capacity$2);
  const _bind$4 = arr.end - arr.start | 0;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const e = arr.buf[arr.start + _ | 0];
      _M0MPB3Map3setGsRPB5ArrayGsEE(m, e._0, e._1);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return m;
}
function _M0MPB3Map3MapGsiE(arr, capacity) {
  const length = arr.end - arr.start | 0;
  let capacity$2;
  if (capacity === undefined) {
    capacity$2 = length === 0 ? 8 : _M0FPB21capacity__for__length(length);
  } else {
    const _Some = capacity;
    const _capacity = _Some;
    const _p$4 = _M0FPB21capacity__for__length(length);
    capacity$2 = _capacity > _p$4 ? _capacity : _p$4;
  }
  const m = _M0FPB8new__mapGsiE(capacity$2);
  const _bind$4 = arr.end - arr.start | 0;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const e = arr.buf[arr.start + _ | 0];
      _M0MPB3Map3setGsiE(m, e._0, e._1);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return m;
}
function _M0MPB3Map3MapGsRPB5ArrayGRPB4JsonEE(arr, capacity) {
  const length = arr.end - arr.start | 0;
  let capacity$2;
  if (capacity === undefined) {
    capacity$2 = length === 0 ? 8 : _M0FPB21capacity__for__length(length);
  } else {
    const _Some = capacity;
    const _capacity = _Some;
    const _p$4 = _M0FPB21capacity__for__length(length);
    capacity$2 = _capacity > _p$4 ? _capacity : _p$4;
  }
  const m = _M0FPB8new__mapGsRPB5ArrayGsEE(capacity$2);
  const _bind$4 = arr.end - arr.start | 0;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const e = arr.buf[arr.start + _ | 0];
      _M0MPB3Map3setGsRPB5ArrayGRPB4JsonEE(m, e._0, e._1);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return m;
}
function _M0MPB3Map3MapGsURP38bobzhang6moonjq3ast4ExprRPB5ArrayGsEEE(arr, capacity) {
  const length = arr.end - arr.start | 0;
  let capacity$2;
  if (capacity === undefined) {
    capacity$2 = length === 0 ? 8 : _M0FPB21capacity__for__length(length);
  } else {
    const _Some = capacity;
    const _capacity = _Some;
    const _p$4 = _M0FPB21capacity__for__length(length);
    capacity$2 = _capacity > _p$4 ? _capacity : _p$4;
  }
  const m = _M0FPB8new__mapGssE(capacity$2);
  const _bind$4 = arr.end - arr.start | 0;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const e = arr.buf[arr.start + _ | 0];
      _M0MPB3Map3setGsURP38bobzhang6moonjq3ast4ExprRPB5ArrayGsEEE(m, e._0, e._1);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return m;
}
function _M0MPB3Map3MapGsRP219moonbit_2dcommunity4yaml4YamlE(arr, capacity) {
  const length = arr.end - arr.start | 0;
  let capacity$2;
  if (capacity === undefined) {
    capacity$2 = length === 0 ? 8 : _M0FPB21capacity__for__length(length);
  } else {
    const _Some = capacity;
    const _capacity = _Some;
    const _p$4 = _M0FPB21capacity__for__length(length);
    capacity$2 = _capacity > _p$4 ? _capacity : _p$4;
  }
  const m = _M0FPB8new__mapGssE(capacity$2);
  const _bind$4 = arr.end - arr.start | 0;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const e = arr.buf[arr.start + _ | 0];
      _M0MPB3Map3setGsRP219moonbit_2dcommunity4yaml4YamlE(m, e._0, e._1);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return m;
}
function _M0MPB3Map3MapGccE(arr, capacity) {
  const length = arr.end - arr.start | 0;
  let capacity$2;
  if (capacity === undefined) {
    capacity$2 = length === 0 ? 8 : _M0FPB21capacity__for__length(length);
  } else {
    const _Some = capacity;
    const _capacity = _Some;
    const _p$4 = _M0FPB21capacity__for__length(length);
    capacity$2 = _capacity > _p$4 ? _capacity : _p$4;
  }
  const m = _M0FPB8new__mapGccE(capacity$2);
  const _bind$4 = arr.end - arr.start | 0;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const e = arr.buf[arr.start + _ | 0];
      _M0MPB3Map3setGccE(m, e._0, e._1);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return m;
}
function _M0MPB3Map3MapGsRPB9ArrayViewGcEE(arr, capacity) {
  const length = arr.end - arr.start | 0;
  let capacity$2;
  if (capacity === undefined) {
    capacity$2 = length === 0 ? 8 : _M0FPB21capacity__for__length(length);
  } else {
    const _Some = capacity;
    const _capacity = _Some;
    const _p$4 = _M0FPB21capacity__for__length(length);
    capacity$2 = _capacity > _p$4 ? _capacity : _p$4;
  }
  const m = _M0FPB8new__mapGssE(capacity$2);
  const _bind$4 = arr.end - arr.start | 0;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const e = arr.buf[arr.start + _ | 0];
      _M0MPB3Map3setGsRPB9ArrayViewGcEE(m, e._0, e._1);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return m;
}
function _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return _entry.value;
      }
      if (i > _entry.psl) {
        return undefined;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map3getGssE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return _entry.value;
      }
      if (i > _entry.psl) {
        return undefined;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return _entry.value;
      }
      if (i > _entry.psl) {
        return undefined;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map3getGsbE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return -1;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return _entry.value;
      }
      if (i > _entry.psl) {
        return -1;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map3getGsRP219moonbit_2dcommunity4yaml4YamlE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return _entry.value;
      }
      if (i > _entry.psl) {
        return undefined;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map3getGsRPB5ArrayGsEE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return _M0DTPC16option6OptionGRPB5ArrayGsEE4None__;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some(_entry.value);
      }
      if (i > _entry.psl) {
        return _M0DTPC16option6OptionGRPB5ArrayGsEE4None__;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map3getGsRPB4JsonE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return _entry.value;
      }
      if (i > _entry.psl) {
        return undefined;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map3getGsRPB5ArrayGRPB4JsonEE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some(_entry.value);
      }
      if (i > _entry.psl) {
        return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map3getGsURP38bobzhang6moonjq3ast4ExprRPB5ArrayGsEEE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return _entry.value;
      }
      if (i > _entry.psl) {
        return undefined;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map3getGsiE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return _entry.value;
      }
      if (i > _entry.psl) {
        return undefined;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map3getGccE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGcE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return -1;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return _entry.value;
      }
      if (i > _entry.psl) {
        return -1;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map3getGsRPB9ArrayViewGcEE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return _entry.value;
      }
      if (i > _entry.psl) {
        return undefined;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map2atGssE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      $panic();
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return _entry.value;
      }
      if (i <= _entry.psl) {
        _tmp$38 = i + 1 | 0;
        _tmp$39 = idx + 1 & self.capacity_mask;
        continue;
      } else {
        $panic();
      }
    }
    continue;
  }
}
function _M0MPB3Map8containsGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return false;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return true;
      }
      if (i > _entry.psl) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map8containsGssE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return false;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return true;
      }
      if (i > _entry.psl) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map8containsGsbE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return false;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return true;
      }
      if (i > _entry.psl) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map8containsGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return false;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return true;
      }
      if (i > _entry.psl) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map8containsGsRPB4JsonE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return false;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return true;
      }
      if (i > _entry.psl) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map8containsGsRP219moonbit_2dcommunity4yaml4YamlE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return false;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return true;
      }
      if (i > _entry.psl) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map8containsGsiE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return false;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return true;
      }
      if (i > _entry.psl) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map12contains__kvGsRPB4JsonE(self, key, value) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return false;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && (_entry.key === key && _M0IPC14json4JsonPB2Eq5equal(_entry.value, value))) {
        return true;
      }
      if (i > _entry.psl) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map13remove__entryGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self, entry) {
  const _bind$4 = entry.prev;
  if (_bind$4 === -1) {
    self.head = entry.next;
  } else {
    const _tmp$38 = self.entries;
    $bound_check(_tmp$38, _bind$4);
    const _p$4 = _tmp$38[_bind$4];
    let _tmp$39;
    if (_p$4 === undefined) {
      _tmp$39 = $panic();
    } else {
      const _p$5 = _p$4;
      _tmp$39 = _p$5;
    }
    _tmp$39.next = entry.next;
  }
  const _bind$5 = entry.next;
  if (_bind$5 === undefined) {
    self.tail = entry.prev;
    return;
  } else {
    const _Some = _bind$5;
    const _next = _Some;
    _next.prev = entry.prev;
    return;
  }
}
function _M0MPB3Map13remove__entryGsbE(self, entry) {
  const _bind$4 = entry.prev;
  if (_bind$4 === -1) {
    self.head = entry.next;
  } else {
    const _tmp$38 = self.entries;
    $bound_check(_tmp$38, _bind$4);
    const _p$4 = _tmp$38[_bind$4];
    let _tmp$39;
    if (_p$4 === undefined) {
      _tmp$39 = $panic();
    } else {
      const _p$5 = _p$4;
      _tmp$39 = _p$5;
    }
    _tmp$39.next = entry.next;
  }
  const _bind$5 = entry.next;
  if (_bind$5 === undefined) {
    self.tail = entry.prev;
    return;
  } else {
    const _Some = _bind$5;
    const _next = _Some;
    _next.prev = entry.prev;
    return;
  }
}
function _M0MPB3Map11shift__backGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self, idx) {
  let _tmp$38 = idx;
  while (true) {
    const cur = _tmp$38;
    const next = cur + 1 & self.capacity_mask;
    _L: {
      const _tmp$39 = self.entries;
      $bound_check(_tmp$39, next);
      const _bind$4 = _tmp$39[next];
      if (_bind$4 === undefined) {
        break _L;
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        const _x$2 = _x.psl;
        if (_x$2 === 0) {
          break _L;
        } else {
          _x.psl = _x.psl - 1 | 0;
          _M0MPB3Map10set__entryGssE(self, _x, cur);
          _tmp$38 = next;
          continue;
        }
      }
    }
    const _tmp$39 = self.entries;
    $bound_check(_tmp$39, cur);
    _tmp$39[cur] = undefined;
    return;
  }
}
function _M0MPB3Map11shift__backGsbE(self, idx) {
  let _tmp$38 = idx;
  while (true) {
    const cur = _tmp$38;
    const next = cur + 1 & self.capacity_mask;
    _L: {
      const _tmp$39 = self.entries;
      $bound_check(_tmp$39, next);
      const _bind$4 = _tmp$39[next];
      if (_bind$4 === undefined) {
        break _L;
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        const _x$2 = _x.psl;
        if (_x$2 === 0) {
          break _L;
        } else {
          _x.psl = _x.psl - 1 | 0;
          _M0MPB3Map10set__entryGsbE(self, _x, cur);
          _tmp$38 = next;
          continue;
        }
      }
    }
    const _tmp$39 = self.entries;
    $bound_check(_tmp$39, cur);
    _tmp$39[cur] = undefined;
    return;
  }
}
function _M0MPB3Map18remove__with__hashGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self, key, hash) {
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        _M0MPB3Map13remove__entryGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self, _entry);
        _M0MPB3Map11shift__backGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self, idx);
        self.size = self.size - 1 | 0;
        return;
      }
      if (i > _entry.psl) {
        return;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map18remove__with__hashGssE(self, key, hash) {
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        _M0MPB3Map13remove__entryGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self, _entry);
        _M0MPB3Map11shift__backGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self, idx);
        self.size = self.size - 1 | 0;
        return;
      }
      if (i > _entry.psl) {
        return;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map18remove__with__hashGsbE(self, key, hash) {
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        _M0MPB3Map13remove__entryGsbE(self, _entry);
        _M0MPB3Map11shift__backGsbE(self, idx);
        self.size = self.size - 1 | 0;
        return;
      }
      if (i > _entry.psl) {
        return;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map18remove__with__hashGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self, key, hash) {
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        _M0MPB3Map13remove__entryGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self, _entry);
        _M0MPB3Map11shift__backGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self, idx);
        self.size = self.size - 1 | 0;
        return;
      }
      if (i > _entry.psl) {
        return;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map18remove__with__hashGsRPB4JsonE(self, key, hash) {
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        _M0MPB3Map13remove__entryGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self, _entry);
        _M0MPB3Map11shift__backGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self, idx);
        self.size = self.size - 1 | 0;
        return;
      }
      if (i > _entry.psl) {
        return;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map6removeGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self, key) {
  _M0MPB3Map18remove__with__hashGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self, key, _M0IP016_24default__implPB4Hash4hashGsE(key));
}
function _M0MPB3Map6removeGssE(self, key) {
  _M0MPB3Map18remove__with__hashGssE(self, key, _M0IP016_24default__implPB4Hash4hashGsE(key));
}
function _M0MPB3Map6removeGsbE(self, key) {
  _M0MPB3Map18remove__with__hashGsbE(self, key, _M0IP016_24default__implPB4Hash4hashGsE(key));
}
function _M0MPB3Map6removeGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self, key) {
  _M0MPB3Map18remove__with__hashGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self, key, _M0IP016_24default__implPB4Hash4hashGsE(key));
}
function _M0MPB3Map6removeGsRPB4JsonE(self, key) {
  _M0MPB3Map18remove__with__hashGsRPB4JsonE(self, key, _M0IP016_24default__implPB4Hash4hashGsE(key));
}
function _M0IPB3MapPB4Show6outputGsRPB4JsonE(self, logger) {
  logger.method_table.method_0(logger.self, "{");
  let _tmp$38 = 0;
  let _tmp$39 = self.head;
  while (true) {
    const x = _tmp$38;
    const y = _tmp$39;
    if (y === undefined) {
      logger.method_table.method_0(logger.self, "}");
      return;
    } else {
      const _Some = y;
      const _x = _Some;
      const _key = _x.key;
      const _value = _x.value;
      const _next = _x.next;
      if (x > 0) {
        logger.method_table.method_0(logger.self, ", ");
      }
      _M0MPB6Logger13write__objectGsE(logger, _key);
      logger.method_table.method_0(logger.self, ": ");
      _M0MPB6Logger13write__objectGRPB4JsonE(logger, _value);
      _tmp$38 = x + 1 | 0;
      _tmp$39 = _next;
      continue;
    }
  }
}
function _M0MPC15array10FixedArray12fill_2einnerGORPC17hashmap5EntryGsiEE(self, value, start, end) {
  const array_length = self.length;
  if (array_length > 0) {
    if (start >= 0 && start < array_length) {
      let length;
      if (end === undefined) {
        length = array_length - start | 0;
      } else {
        const _Some = end;
        const _e = _Some;
        length = _e >= start && _e <= array_length ? _e - start | 0 : $panic();
      }
      self.fill(value, start, start + length);
      return;
    } else {
      $panic();
      return;
    }
  } else {
    return;
  }
}
function _M0MPB3Map4iterGssE(self) {
  const curr_entry = new _M0TPB8MutLocalGORPB5EntryGssEE(self.head);
  const len = self.size;
  const remaining = new _M0TPB8MutLocalGiE(len);
  return _M0MPB4Iter3newGUssEE(() => {
    _L: {
      if (remaining.val > 0) {
        const _bind$4 = curr_entry.val;
        if (_bind$4 === undefined) {
          break _L;
        } else {
          const _Some = _bind$4;
          const _x = _Some;
          const _key = _x.key;
          const _value = _x.value;
          const _next = _x.next;
          curr_entry.val = _next;
          remaining.val = remaining.val - 1 | 0;
          return { _0: _key, _1: _value };
        }
      } else {
        break _L;
      }
    }
    return undefined;
  }, len);
}
function _M0MPB3Map4iterGsbE(self) {
  const curr_entry = new _M0TPB8MutLocalGORPB5EntryGsbEE(self.head);
  const len = self.size;
  const remaining = new _M0TPB8MutLocalGiE(len);
  return _M0MPB4Iter3newGUssEE(() => {
    _L: {
      if (remaining.val > 0) {
        const _bind$4 = curr_entry.val;
        if (_bind$4 === undefined) {
          break _L;
        } else {
          const _Some = _bind$4;
          const _x = _Some;
          const _key = _x.key;
          const _value = _x.value;
          const _next = _x.next;
          curr_entry.val = _next;
          remaining.val = remaining.val - 1 | 0;
          return { _0: _key, _1: _value };
        }
      } else {
        break _L;
      }
    }
    return undefined;
  }, len);
}
function _M0MPB3Map5iter2GssE(self) {
  return _M0MPB3Map4iterGssE(self);
}
function _M0MPB3Map5iter2GsbE(self) {
  return _M0MPB3Map4iterGsbE(self);
}
function _M0MPB3Map6valuesGsRPB5ArrayGRPB4JsonEE(self) {
  const curr_entry = new _M0TPB8MutLocalGORPB5EntryGsRPB5ArrayGRPB4JsonEEE(self.head);
  const len = self.size;
  const remaining = new _M0TPB8MutLocalGiE(len);
  return _M0MPB4Iter3newGRPB5ArrayGRPB4JsonEE(() => {
    _L: {
      if (remaining.val > 0) {
        const _bind$4 = curr_entry.val;
        if (_bind$4 === undefined) {
          break _L;
        } else {
          const _Some = _bind$4;
          const _x = _Some;
          const _value = _x.value;
          const _next = _x.next;
          curr_entry.val = _next;
          remaining.val = remaining.val - 1 | 0;
          return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some(_value);
        }
      } else {
        break _L;
      }
    }
    return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
  }, len);
}
function _M0IPB3MapPB2Eq5equalGsRPB4JsonE(self, that) {
  if (self.size === that.size) {
    const _it = _M0MPB3Map5iter2GssE(self);
    while (true) {
      const _bind$4 = _M0MPB5Iter24nextGssE(_it);
      if (_bind$4 === undefined) {
        return true;
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        const _k = _x._0;
        const _v = _x._1;
        if (_M0MPB3Map12contains__kvGsRPB4JsonE(that, _k, _v)) {
        } else {
          return false;
        }
        continue;
      }
    }
  } else {
    return false;
  }
}
function _M0MPB3Map3mapGsRP219moonbit_2dcommunity4yaml4YamlRPB4JsonE(self, f) {
  const _bind$4 = self.capacity;
  const _bind$5 = $make_array_len_and_init(self.capacity, undefined);
  const _bind$6 = self.size;
  const _bind$7 = self.capacity_mask;
  const _bind$8 = self.grow_at;
  const _bind$9 = undefined;
  const _bind$10 = self.tail;
  const other = new _M0TPB3MapGsRPB4JsonE(_bind$5, _bind$6, _bind$4, _bind$7, _bind$8, _bind$9, _bind$10);
  if (self.size === 0) {
    return other;
  }
  const _tmp$38 = self.entries;
  const _tmp$39 = self.tail;
  $bound_check(_tmp$38, _tmp$39);
  const _bind$11 = _tmp$38[_tmp$39];
  if (_bind$11 === undefined) {
    return $panic();
  } else {
    const _Some = _bind$11;
    const _last = _Some;
    let _tmp$40 = _last;
    let _tmp$41 = self.tail;
    let _tmp$42 = undefined;
    while (true) {
      const entry = _tmp$40;
      const idx = _tmp$41;
      const next = _tmp$42;
      const _prev = entry.prev;
      const _psl = entry.psl;
      const _hash = entry.hash;
      const _key = entry.key;
      const _value = entry.value;
      const new_value = f(_key, _value);
      const new_entry = new _M0TPB5EntryGsRPB4JsonE(_prev, next, _psl, _hash, _key, new_value);
      const _tmp$43 = other.entries;
      $bound_check(_tmp$43, idx);
      _tmp$43[idx] = new_entry;
      if (_prev !== -1) {
        const _tmp$44 = self.entries;
        $bound_check(_tmp$44, _prev);
        const _p$4 = _tmp$44[_prev];
        if (_p$4 === undefined) {
          _tmp$40 = $panic();
        } else {
          const _p$5 = _p$4;
          _tmp$40 = _p$5;
        }
        _tmp$41 = _prev;
        _tmp$42 = new_entry;
        continue;
      } else {
        other.head = new_entry;
        break;
      }
    }
    return other;
  }
}
function _M0MPC16string10StringView17equal__to__string(self, other) {
  const str = self.str;
  const start = self.start;
  const end = self.end;
  const len = end - start | 0;
  if (len === other.length) {
    if (str === other && self.start === 0) {
      return true;
    }
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < len) {
        const _p$4 = str.charCodeAt(self.start + i | 0);
        const _p$5 = other.charCodeAt(i);
        if (_p$4 === _p$5) {
        } else {
          return false;
        }
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return true;
  } else {
    return false;
  }
}
function _M0MPB3Map17get__from__stringGRPB5ArrayGsEE(map, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGRPC16string10StringViewE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & map.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = map.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return _M0DTPC16option6OptionGRPB5ArrayGsEE4None__;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _M0MPC16string10StringView17equal__to__string(key, _entry.key)) {
        return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some(_entry.value);
      }
      if (i > _entry.psl) {
        return _M0DTPC16option6OptionGRPB5ArrayGsEE4None__;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & map.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map17get__from__stringGsE(map, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGRPC16string10StringViewE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & map.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = map.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _M0MPC16string10StringView17equal__to__string(key, _entry.key)) {
        return _entry.value;
      }
      if (i > _entry.psl) {
        return undefined;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & map.capacity_mask;
      continue;
    }
  }
}
function _M0IPC14json4JsonPB2Eq5equal(a, b) {
  switch (a.$tag) {
    case 0: {
      if (b.$tag === 0) {
        return true;
      } else {
        return false;
      }
    }
    case 1: {
      if (b.$tag === 1) {
        return true;
      } else {
        return false;
      }
    }
    case 2: {
      if (b.$tag === 2) {
        return true;
      } else {
        return false;
      }
    }
    case 3: {
      const _Number = a;
      const _a_num = _Number._0;
      if (b.$tag === 3) {
        const _Number$2 = b;
        const _b_num = _Number$2._0;
        return _a_num === _b_num;
      } else {
        return false;
      }
    }
    case 4: {
      const _String = a;
      const _a_str = _String._0;
      if (b.$tag === 4) {
        const _String$2 = b;
        const _b_str = _String$2._0;
        return _a_str === _b_str;
      } else {
        return false;
      }
    }
    case 5: {
      const _Array = a;
      const _a_arr = _Array._0;
      if (b.$tag === 5) {
        const _Array$2 = b;
        const _b_arr = _Array$2._0;
        return _M0IPC15array5ArrayPB2Eq5equalGRPB4JsonE(_a_arr, _b_arr);
      } else {
        return false;
      }
    }
    default: {
      const _Object = a;
      const _a_obj = _Object._0;
      if (b.$tag === 6) {
        const _Object$2 = b;
        const _b_obj = _Object$2._0;
        return _M0IPB3MapPB2Eq5equalGsRPB4JsonE(_a_obj, _b_obj);
      } else {
        return false;
      }
    }
  }
}
function _M0MPB4Iter6filterGUsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEEE(self, f) {
  return _M0MPB4Iter3newGUssEE(() => {
    while (true) {
      const _bind$4 = _M0MPB4Iter4nextGUssEE(self);
      if (_bind$4 === undefined) {
        return undefined;
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        if (f(_x)) {
          return _x;
        }
        continue;
      }
    }
  }, undefined);
}
function _M0MPB4Iter9flat__mapGRPB4IterGRPB4JsonERPB4JsonE(self, f) {
  const current_iter = new _M0TPB8MutLocalGORPB4IterGRPB4JsonEE(_M0MPB4Iter5emptyGRPB4JsonE());
  return _M0MPB4Iter3newGUssEE(() => {
    const _bind$4 = current_iter.val;
    if (_bind$4 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _iter = _Some;
      let _tmp$38 = _M0MPB4Iter4nextGUssEE(_iter);
      while (true) {
        const x = _tmp$38;
        if (x === undefined) {
          const _bind$5 = _M0MPB4Iter4nextGUssEE(self);
          if (_bind$5 === undefined) {
            return undefined;
          } else {
            const _Some$2 = _bind$5;
            const _x = _Some$2;
            const iter = f(_x);
            current_iter.val = iter;
            _tmp$38 = _M0MPB4Iter4nextGUssEE(iter);
            continue;
          }
        } else {
          const _Some$2 = x;
          return _Some$2;
        }
      }
    }
  }, undefined);
}
function _M0MPB4Iter7flattenGRPB4JsonE(self) {
  return _M0MPB4Iter9flat__mapGRPB4IterGRPB4JsonERPB4JsonE(self, (it) => it);
}
function _M0MPB4Iter4takeGyE(self, n) {
  const remaining = new _M0TPB8MutLocalGiE(n);
  const _bind$4 = self.size_hint;
  let size_hint;
  if (_bind$4 === undefined) {
    size_hint = n <= 0 ? _M0MPB4Iter4takeN6constrS9084GyE : undefined;
  } else {
    const _Some = _bind$4;
    if (n <= 0) {
      size_hint = _M0MPB4Iter4takeN6constrS9083GyE;
    } else {
      const _len = _Some;
      size_hint = n < _len ? n : _len;
    }
  }
  return new _M0TPB4IterGyE(() => {
    if (remaining.val > 0) {
      const result = _M0MPB4Iter4nextGyE(self);
      if (result === -1) {
      } else {
        remaining.val = remaining.val - 1 | 0;
      }
      return result;
    } else {
      return -1;
    }
  }, size_hint);
}
function _M0MPB4Iter4takeGRPB4JsonE(self, n) {
  const remaining = new _M0TPB8MutLocalGiE(n);
  const _bind$4 = self.size_hint;
  let size_hint;
  if (_bind$4 === undefined) {
    size_hint = n <= 0 ? _M0MPB4Iter4takeN6constrS9084GRPB4JsonE : undefined;
  } else {
    const _Some = _bind$4;
    if (n <= 0) {
      size_hint = _M0MPB4Iter4takeN6constrS9083GRPB4JsonE;
    } else {
      const _len = _Some;
      size_hint = n < _len ? n : _len;
    }
  }
  return new _M0TPB4IterGRPB4JsonE(() => {
    if (remaining.val > 0) {
      const result = _M0MPB4Iter4nextGUssEE(self);
      if (result === undefined) {
      } else {
        remaining.val = remaining.val - 1 | 0;
      }
      return result;
    } else {
      return undefined;
    }
  }, size_hint);
}
function _M0MPB4Iter6concatGRPB4JsonE(self, other) {
  const in_first = new _M0TPB8MutLocalGbE(true);
  let size_hint;
  _L: {
    _L$2: {
      const _bind$4 = self.size_hint;
      const _bind$5 = other.size_hint;
      if (_bind$4 === undefined) {
        break _L$2;
      } else {
        const _Some = _bind$4;
        const _n = _Some;
        if (_bind$5 === undefined) {
          break _L$2;
        } else {
          const _Some$2 = _bind$5;
          const _m = _Some$2;
          size_hint = _n + _m | 0;
        }
      }
      break _L;
    }
    size_hint = undefined;
  }
  return new _M0TPB4IterGRPB4JsonE(() => {
    if (in_first.val) {
      const result = _M0MPB4Iter4nextGUssEE(self);
      if (result === undefined) {
        in_first.val = false;
        return _M0MPB4Iter4nextGUssEE(other);
      } else {
        return result;
      }
    } else {
      return _M0MPB4Iter4nextGUssEE(other);
    }
  }, size_hint);
}
function _M0MPB5Iter24nextGssE(self) {
  return _M0MPB4Iter4nextGUssEE(self);
}
function _M0MPB5Iter24nextGsbE(self) {
  return _M0MPB4Iter4nextGUssEE(self);
}
function _M0MPB5Iter24nextGicE(self) {
  return _M0MPB4Iter4nextGUssEE(self);
}
function _M0MPB5Iter24nextGiiE(self) {
  return _M0MPB4Iter4nextGUssEE(self);
}
function _M0MPB5Iter24nextGiRP27gmlewis5flate11LiteralNodeE(self) {
  return _M0MPB4Iter4nextGUssEE(self);
}
function _M0MPC13int3Int8to__char(self) {
  _L: {
    if (self >= 0 && self <= 55295) {
      break _L;
    } else {
      if (self >= 57344 && self <= 1114111) {
        break _L;
      } else {
        return -1;
      }
    }
  }
  return self;
}
function _M0MPB6Hasher15combine__string(self, value) {
  const _bind$4 = value.length;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < _bind$4) {
      _M0MPB6Hasher13combine__uint(self, value.charCodeAt(i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0MPB6Hasher13combine__char(self, value) {
  _M0MPB6Hasher13combine__uint(self, value);
}
function _M0IPC16string6StringPB4Hash13hash__combine(self, hasher) {
  _M0MPB6Hasher15combine__string(hasher, self);
}
function _M0IPC16string10StringViewPB4Hash13hash__combine(self, hasher) {
  const str = self.str;
  const _bind$4 = self.start;
  const _bind$5 = self.end;
  let _tmp$38 = _bind$4;
  while (true) {
    const i = _tmp$38;
    if (i < _bind$5) {
      _M0MPB6Hasher13combine__uint(hasher, str.charCodeAt(i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0IPC13int3IntPB4Hash13hash__combine(self, hasher) {
  _M0MPB6Hasher12combine__int(hasher, self);
}
function _M0MPB18UninitializedArray19unsafe__blit__fixedGyE(dst, dst_offset, src, src_offset, len) {
  let _tmp$38 = len - 1 | 0;
  while (true) {
    const i = _tmp$38;
    if (i >= 0) {
      const _tmp$39 = dst_offset + i | 0;
      const _tmp$40 = src_offset + i | 0;
      $bound_check(src, _tmp$40);
      $bound_check(dst, _tmp$39);
      dst[_tmp$39] = src[_tmp$40];
      _tmp$38 = i - 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0MPC15array10FixedArray4swapGkE(self, i, j) {
  $bound_check(self, i);
  const temp = self[i];
  $bound_check(self, j);
  $bound_check(self, i);
  self[i] = self[j];
  $bound_check(self, j);
  self[j] = temp;
}
function _M0MPC16double6Double7to__int(self) {
  return self !== self ? 0 : self >= 2147483647 ? 2147483647 : self <= -2147483648 ? -2147483648 : self | 0;
}
function _M0MPC16double6Double4ceil(_tmp$38) {
  return Math.ceil(_tmp$38);
}
function _M0MPC16double6Double5floor(_tmp$38) {
  return Math.floor(_tmp$38);
}
function _M0MPC16double6Double5round(_tmp$38) {
  return Math.round(_tmp$38);
}
function _M0MPC16double6Double3pow(_tmp$38, _tmp$39) {
  return Math.pow(_tmp$38, _tmp$39);
}
function _M0IPC16double6DoublePB3Mod3mod(self, other) {
  return _M0MPC16double6Double8mod__ffi(self, other);
}
function _M0IPC16double6DoublePB4Show10to__string(self) {
  return String(self);
}
function _M0MPC15bytes5Bytes5makei(length, value) {
  if (length <= 0) {
    return $bytes_literal$0;
  }
  const arr = $makebytes(length, value(0));
  let _tmp$38 = 1;
  while (true) {
    const i = _tmp$38;
    if (i < length) {
      $bound_check(arr, i);
      arr[i] = value(i);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return arr;
}
function _M0MPB3Map11new_2einnerGsbE(capacity) {
  return _M0FPB8new__mapGsbE(capacity);
}
function _M0FPB7printlnGsE(input) {
  console.log(input);
}
function _M0MPC14char4Char7to__hex(char) {
  const code = char;
  return code >= 0 && code <= 255 ? _M0MPC14byte4Byte7to__hex(code & 255) : code <= 65535 ? `${_M0MPC14byte4Byte7to__hex(code >> 8 & 255)}${_M0MPC14byte4Byte7to__hex(code & 255)}` : `${_M0MPC14byte4Byte7to__hex(code >> 16 & 255)}${_M0MPC14byte4Byte7to__hex(code >> 8 & 255)}${_M0MPC14byte4Byte7to__hex(code & 255)}`;
}
function _M0IPC14char4CharPB4Hash13hash__combine(self, hasher) {
  _M0MPB6Hasher13combine__char(hasher, self);
}
function _M0MPC14char4Char21is__ascii__alphabetic(self) {
  return self >= 65 && self <= 90 ? true : self >= 97 && self <= 122;
}
function _M0MPC14char4Char16is__ascii__digit(self) {
  return self >= 48 && self <= 57;
}
function _M0MPC14char4Char11is__control(self) {
  return self >= 0 && self <= 31 ? true : self >= 127 && self <= 159;
}
function _M0MPC14char4Char13is__printable(self) {
  if (_M0MPC14char4Char11is__control(self)) {
    return false;
  }
  const self$2 = self;
  _L: {
    _L$2: {
      if (self$2 >= 57344 && self$2 <= 63743) {
        break _L$2;
      } else {
        if (self$2 >= 983040 && self$2 <= 1048573) {
          break _L$2;
        } else {
          if (self$2 >= 1048576 && self$2 <= 1114109) {
            break _L$2;
          }
        }
      }
      break _L;
    }
    return false;
  }
  _L$2: {
    _L$3: {
      if (self$2 === 173) {
        break _L$3;
      } else {
        if (self$2 >= 1536 && self$2 <= 1541) {
          break _L$3;
        } else {
          if (self$2 === 1564) {
            break _L$3;
          } else {
            if (self$2 === 1757) {
              break _L$3;
            } else {
              if (self$2 === 1807) {
                break _L$3;
              } else {
                if (self$2 >= 2192 && self$2 <= 2193) {
                  break _L$3;
                } else {
                  if (self$2 === 2274) {
                    break _L$3;
                  } else {
                    if (self$2 === 6158) {
                      break _L$3;
                    } else {
                      if (self$2 >= 8203 && self$2 <= 8207) {
                        break _L$3;
                      } else {
                        if (self$2 >= 8234 && self$2 <= 8238) {
                          break _L$3;
                        } else {
                          if (self$2 >= 8288 && self$2 <= 8292) {
                            break _L$3;
                          } else {
                            if (self$2 >= 8294 && self$2 <= 8303) {
                              break _L$3;
                            } else {
                              if (self$2 === 65279) {
                                break _L$3;
                              } else {
                                if (self$2 >= 65529 && self$2 <= 65531) {
                                  break _L$3;
                                } else {
                                  if (self$2 === 69821) {
                                    break _L$3;
                                  } else {
                                    if (self$2 === 69837) {
                                      break _L$3;
                                    } else {
                                      if (self$2 >= 78896 && self$2 <= 78911) {
                                        break _L$3;
                                      } else {
                                        if (self$2 >= 113824 && self$2 <= 113827) {
                                          break _L$3;
                                        } else {
                                          if (self$2 >= 119155 && self$2 <= 119162) {
                                            break _L$3;
                                          } else {
                                            if (self$2 === 917505) {
                                              break _L$3;
                                            } else {
                                              if (self$2 >= 917536 && self$2 <= 917631) {
                                                break _L$3;
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      break _L$2;
    }
    return false;
  }
  if (55296 <= self$2 && self$2 <= 57343) {
    return false;
  }
  if (self$2 === 8232 || self$2 === 8233) {
    return false;
  }
  _L$3: {
    _L$4: {
      if (self$2 >= 64976 && self$2 <= 65007) {
        break _L$4;
      } else {
        if (self$2 >= 65534 && self$2 <= 65535) {
          break _L$4;
        } else {
          if (self$2 >= 131070 && self$2 <= 131071) {
            break _L$4;
          } else {
            if (self$2 >= 196606 && self$2 <= 196607) {
              break _L$4;
            } else {
              if (self$2 >= 262142 && self$2 <= 262143) {
                break _L$4;
              } else {
                if (self$2 >= 327678 && self$2 <= 327679) {
                  break _L$4;
                } else {
                  if (self$2 >= 393214 && self$2 <= 393215) {
                    break _L$4;
                  } else {
                    if (self$2 >= 458750 && self$2 <= 458751) {
                      break _L$4;
                    } else {
                      if (self$2 >= 524286 && self$2 <= 524287) {
                        break _L$4;
                      } else {
                        if (self$2 >= 589822 && self$2 <= 589823) {
                          break _L$4;
                        } else {
                          if (self$2 >= 655358 && self$2 <= 655359) {
                            break _L$4;
                          } else {
                            if (self$2 >= 720894 && self$2 <= 720895) {
                              break _L$4;
                            } else {
                              if (self$2 >= 786430 && self$2 <= 786431) {
                                break _L$4;
                              } else {
                                if (self$2 >= 851966 && self$2 <= 851967) {
                                  break _L$4;
                                } else {
                                  if (self$2 >= 917502 && self$2 <= 917503) {
                                    break _L$4;
                                  } else {
                                    if (self$2 >= 983038 && self$2 <= 983039) {
                                      break _L$4;
                                    } else {
                                      if (self$2 >= 1048574 && self$2 <= 1048575) {
                                        break _L$4;
                                      } else {
                                        if (self$2 >= 1114110 && self$2 <= 1114111) {
                                          break _L$4;
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      break _L$3;
    }
    return false;
  }
  return true;
}
function _M0MPC14char4Char20to__ascii__lowercase(self) {
  if (_M0MPC14char4Char20is__ascii__uppercase(self)) {
    return self + 32 | 0;
  }
  return self;
}
function _M0MPC14char4Char18escape__to_2einner(self, logger, quote) {
  if (quote) {
    logger.method_table.method_3(logger.self, 39);
  }
  _L: {
    _L$2: {
      if (self === 39) {
        break _L$2;
      } else {
        if (self === 92) {
          break _L$2;
        } else {
          if (self === 10) {
            logger.method_table.method_0(logger.self, "\\n");
          } else {
            if (self === 13) {
              logger.method_table.method_0(logger.self, "\\r");
            } else {
              if (self === 8) {
                logger.method_table.method_0(logger.self, "\\b");
              } else {
                if (self === 9) {
                  logger.method_table.method_0(logger.self, "\\t");
                } else {
                  if (self >= 32 && self <= 126) {
                    logger.method_table.method_3(logger.self, self);
                  } else {
                    if (!_M0MPC14char4Char13is__printable(self)) {
                      logger.method_table.method_0(logger.self, "\\u{");
                      logger.method_table.method_0(logger.self, _M0MPC14char4Char7to__hex(self));
                      logger.method_table.method_3(logger.self, 125);
                    } else {
                      logger.method_table.method_3(logger.self, self);
                    }
                  }
                }
              }
            }
          }
        }
      }
      break _L;
    }
    logger.method_table.method_3(logger.self, 92);
    logger.method_table.method_3(logger.self, self);
  }
  if (quote) {
    logger.method_table.method_3(logger.self, 39);
    return;
  } else {
    return;
  }
}
function _M0MPC14char4Char14escape_2einner(self, quote) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0MPC14char4Char18escape__to_2einner(self, { self: buf, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger }, quote);
  return buf.val;
}
function _M0MPC15bytes5Bytes12view_2einner(self, start, end) {
  const len = self.length;
  let end$2;
  if (end === undefined) {
    end$2 = len;
  } else {
    const _Some = end;
    const _end = _Some;
    end$2 = _end < 0 ? len + _end | 0 : _end;
  }
  const start$2 = start < 0 ? len + start | 0 : start;
  if (start$2 >= 0 && (start$2 <= end$2 && end$2 <= len)) {
    const _bind$4 = end$2 - start$2 | 0;
    return new _M0TPC15bytes9BytesView(self, start$2, start$2 + _bind$4 | 0);
  } else {
    return _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("Invalid index for View");
  }
}
function _M0MPC15bytes9BytesView12view_2einner(self, start, end) {
  const len = self.end - self.start | 0;
  let end$2;
  if (end === undefined) {
    end$2 = len;
  } else {
    const _Some = end;
    const _end = _Some;
    end$2 = _end < 0 ? len + _end | 0 : _end;
  }
  const start$2 = start < 0 ? len + start | 0 : start;
  if (start$2 >= 0 && (start$2 <= end$2 && end$2 <= len)) {
    const _bind$4 = self.bytes;
    const _bind$5 = self.start + start$2 | 0;
    const _bind$6 = end$2 - start$2 | 0;
    return new _M0TPC15bytes9BytesView(_bind$4, _bind$5, _bind$5 + _bind$6 | 0);
  } else {
    return _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("Invalid index for View");
  }
}
function _M0MPC15array10FixedArray18set__utf16le__char(self, offset, value) {
  const code = value;
  if (code >>> 0 < 65536 >>> 0) {
    const _p$4 = code & 255;
    $bound_check(self, offset);
    self[offset] = _p$4 & 255;
    const _tmp$38 = offset + 1 | 0;
    const _p$5 = code >>> 8 | 0;
    $bound_check(self, _tmp$38);
    self[_tmp$38] = _p$5 & 255;
    return 2;
  } else {
    if (code >>> 0 < 1114112 >>> 0) {
      const hi = (code >>> 0) - (65536 >>> 0) | 0;
      const lo = hi >>> 10 | 55296;
      const hi$2 = hi & 1023 | 56320;
      const _p$4 = lo & 255;
      $bound_check(self, offset);
      self[offset] = _p$4 & 255;
      const _tmp$38 = offset + 1 | 0;
      const _p$5 = lo >>> 8 | 0;
      $bound_check(self, _tmp$38);
      self[_tmp$38] = _p$5 & 255;
      const _tmp$39 = offset + 2 | 0;
      const _p$6 = hi$2 & 255;
      $bound_check(self, _tmp$39);
      self[_tmp$39] = _p$6 & 255;
      const _tmp$40 = offset + 3 | 0;
      const _p$7 = hi$2 >>> 8 | 0;
      $bound_check(self, _tmp$40);
      self[_tmp$40] = _p$7 & 255;
      return 4;
    } else {
      return _M0FPC15abort5abortGiE("Char out of range");
    }
  }
}
function _M0MPC15bytes5Bytes11from__array(arr) {
  return _M0MPC15bytes5Bytes5makei(arr.end - arr.start | 0, (i) => _M0MPC15array9ArrayView2atGyE(arr, i));
}
function _M0MPC15bytes5Bytes10from__iter(iter) {
  const _bind$4 = _M0MPB4Iter9to__arrayGyE(iter);
  return _M0MPC15bytes5Bytes11from__array(new _M0TPB9ArrayViewGyE(_bind$4, 0, _bind$4.length));
}
function _M0MPC15bytes5Bytes9to__array(self) {
  const len = self.length;
  const rv = new Array(len);
  _M0MPB18UninitializedArray19unsafe__blit__fixedGyE(rv, 0, self, 0, len);
  return rv;
}
function _M0MPC15bytes5Bytes4iter(self) {
  const i = new _M0TPB8MutLocalGiE(0);
  const len = self.length;
  return _M0MPB4Iter3newGyE(() => {
    if (i.val < len) {
      const c = self[i.val];
      i.val = i.val + 1 | 0;
      return c;
    } else {
      return -1;
    }
  }, len);
}
function _M0MPC15array9ArrayView12view_2einnerGsE(self, start, end) {
  const len = self.end - self.start | 0;
  let end$2;
  if (end === undefined) {
    end$2 = len;
  } else {
    const _Some = end;
    const _end = _Some;
    end$2 = _end < 0 ? len + _end | 0 : _end;
  }
  const start$2 = start < 0 ? len + start | 0 : start;
  if (start$2 >= 0 && (start$2 <= end$2 && end$2 <= len)) {
    const _bind$4 = self.buf;
    const _bind$5 = self.start + start$2 | 0;
    const _bind$6 = end$2 - start$2 | 0;
    return new _M0TPB9ArrayViewGsE(_bind$4, _bind$5, _bind$5 + _bind$6 | 0);
  } else {
    return _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("View index out of bounds");
  }
}
function _M0MPC15array5Array12view_2einnerGyE(self, start, end) {
  const len = self.length;
  let end$2;
  if (end === undefined) {
    end$2 = len;
  } else {
    const _Some = end;
    const _end = _Some;
    end$2 = _end < 0 ? len + _end | 0 : _end;
  }
  const start$2 = start < 0 ? len + start | 0 : start;
  if (start$2 >= 0 && (start$2 <= end$2 && end$2 <= len)) {
    const _bind$4 = self;
    const _bind$5 = end$2 - start$2 | 0;
    return new _M0TPB9ArrayViewGyE(_bind$4, start$2, start$2 + _bind$5 | 0);
  } else {
    return _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("View index out of bounds");
  }
}
function _M0MPC15array5Array12view_2einnerGsE(self, start, end) {
  const len = self.length;
  let end$2;
  if (end === undefined) {
    end$2 = len;
  } else {
    const _Some = end;
    const _end = _Some;
    end$2 = _end < 0 ? len + _end | 0 : _end;
  }
  const start$2 = start < 0 ? len + start | 0 : start;
  if (start$2 >= 0 && (start$2 <= end$2 && end$2 <= len)) {
    const _bind$4 = self;
    const _bind$5 = end$2 - start$2 | 0;
    return new _M0TPB9ArrayViewGsE(_bind$4, start$2, start$2 + _bind$5 | 0);
  } else {
    return _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("View index out of bounds");
  }
}
function _M0MPC15array5Array12view_2einnerGRPB5ArrayGsEE(self, start, end) {
  const len = self.length;
  let end$2;
  if (end === undefined) {
    end$2 = len;
  } else {
    const _Some = end;
    const _end = _Some;
    end$2 = _end < 0 ? len + _end | 0 : _end;
  }
  const start$2 = start < 0 ? len + start | 0 : start;
  if (start$2 >= 0 && (start$2 <= end$2 && end$2 <= len)) {
    const _bind$4 = self;
    const _bind$5 = end$2 - start$2 | 0;
    return new _M0TPB9ArrayViewGRPB5ArrayGsEE(_bind$4, start$2, start$2 + _bind$5 | 0);
  } else {
    return _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("View index out of bounds");
  }
}
function _M0MPC15array5Array12view_2einnerGiE(self, start, end) {
  const len = self.length;
  let end$2;
  if (end === undefined) {
    end$2 = len;
  } else {
    const _Some = end;
    const _end = _Some;
    end$2 = _end < 0 ? len + _end | 0 : _end;
  }
  const start$2 = start < 0 ? len + start | 0 : start;
  if (start$2 >= 0 && (start$2 <= end$2 && end$2 <= len)) {
    const _bind$4 = self;
    const _bind$5 = end$2 - start$2 | 0;
    return new _M0TPB9ArrayViewGiE(_bind$4, start$2, start$2 + _bind$5 | 0);
  } else {
    return _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("View index out of bounds");
  }
}
function _M0MPC15array9ArrayView4joinGsE(self, separator) {
  if ((self.end - self.start | 0) === 0) {
    return "";
  } else {
    const _hd = self.buf[self.start];
    const _x_buf = self.buf;
    const _x_start = 1 + self.start | 0;
    const _x_end = self.end;
    const hd = _M0IPC16string6StringPB12ToStringView16to__string__view(_hd);
    const _bind$4 = _x_end - _x_start | 0;
    let size_hint;
    let _tmp$38 = 0;
    let _tmp$39 = hd.end - hd.start | 0;
    while (true) {
      const _ = _tmp$38;
      const size_hint$2 = _tmp$39;
      if (_ < _bind$4) {
        const s = _x_buf[_x_start + _ | 0];
        _tmp$38 = _ + 1 | 0;
        const _p$4 = _M0IPC16string6StringPB12ToStringView16to__string__view(s);
        _tmp$39 = (size_hint$2 + (_p$4.end - _p$4.start | 0) | 0) + (separator.end - separator.start | 0) | 0;
        continue;
      } else {
        size_hint = size_hint$2;
        break;
      }
    }
    const size_hint$2 = size_hint << 1;
    const buf = _M0MPB13StringBuilder21StringBuilder_2einner(size_hint$2);
    _M0IPB13StringBuilderPB6Logger11write__view(buf, hd);
    if (_M0MPC16string6String24char__length__eq_2einner(separator.str, 0, separator.start, separator.end)) {
      const _bind$5 = _x_end - _x_start | 0;
      let _tmp$40 = 0;
      while (true) {
        const _ = _tmp$40;
        if (_ < _bind$5) {
          const s = _x_buf[_x_start + _ | 0];
          const s$2 = _M0IPC16string6StringPB12ToStringView16to__string__view(s);
          _M0IPB13StringBuilderPB6Logger11write__view(buf, s$2);
          _tmp$40 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
    } else {
      const _bind$5 = _x_end - _x_start | 0;
      let _tmp$40 = 0;
      while (true) {
        const _ = _tmp$40;
        if (_ < _bind$5) {
          const s = _x_buf[_x_start + _ | 0];
          const s$2 = _M0IPC16string6StringPB12ToStringView16to__string__view(s);
          _M0IPB13StringBuilderPB6Logger11write__view(buf, separator);
          _M0IPB13StringBuilderPB6Logger11write__view(buf, s$2);
          _tmp$40 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
    }
    return buf.val;
  }
}
function _M0MPC15array9ArrayView4joinGRPC16string10StringViewE(self, separator) {
  if ((self.end - self.start | 0) === 0) {
    return "";
  } else {
    const _hd = self.buf[self.start];
    const _x_buf = self.buf;
    const _x_start = 1 + self.start | 0;
    const _x_end = self.end;
    const hd = _hd;
    const _bind$4 = _x_end - _x_start | 0;
    let size_hint;
    let _tmp$38 = 0;
    let _tmp$39 = hd.end - hd.start | 0;
    while (true) {
      const _ = _tmp$38;
      const size_hint$2 = _tmp$39;
      if (_ < _bind$4) {
        const s = _x_buf[_x_start + _ | 0];
        _tmp$38 = _ + 1 | 0;
        _tmp$39 = (size_hint$2 + (s.end - s.start | 0) | 0) + (separator.end - separator.start | 0) | 0;
        continue;
      } else {
        size_hint = size_hint$2;
        break;
      }
    }
    const size_hint$2 = size_hint << 1;
    const buf = _M0MPB13StringBuilder21StringBuilder_2einner(size_hint$2);
    _M0IPB13StringBuilderPB6Logger11write__view(buf, hd);
    if (_M0MPC16string6String24char__length__eq_2einner(separator.str, 0, separator.start, separator.end)) {
      const _bind$5 = _x_end - _x_start | 0;
      let _tmp$40 = 0;
      while (true) {
        const _ = _tmp$40;
        if (_ < _bind$5) {
          const s = _x_buf[_x_start + _ | 0];
          const s$2 = s;
          _M0IPB13StringBuilderPB6Logger11write__view(buf, s$2);
          _tmp$40 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
    } else {
      const _bind$5 = _x_end - _x_start | 0;
      let _tmp$40 = 0;
      while (true) {
        const _ = _tmp$40;
        if (_ < _bind$5) {
          const s = _x_buf[_x_start + _ | 0];
          const s$2 = s;
          _M0IPB13StringBuilderPB6Logger11write__view(buf, separator);
          _M0IPB13StringBuilderPB6Logger11write__view(buf, s$2);
          _tmp$40 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
    }
    return buf.val;
  }
}
function _M0MPC15array5Array28unsafe__truncate__to__lengthGRP411moonbitlang6regexp8internal2vm6ThreadE(self, new_len) {
  _M0MPB7JSArray11set__length(self, new_len);
}
function _M0MPC15array5Array17reserve__capacityGsE(self, capacity) {}
function _M0MPC15array5Array11unsafe__popGsE(self) {
  return _M0MPB7JSArray3pop(self);
}
function _M0MPC15array5Array11unsafe__popGRP219moonbit_2dcommunity4yaml5StateE(self) {
  return _M0MPB7JSArray3pop(self);
}
function _M0MPC15array5Array3popGsE(self) {
  if (self.length === 0) {
    return undefined;
  } else {
    const v = _M0MPC15array5Array11unsafe__popGsE(self);
    return v;
  }
}
function _M0MPC15array5Array3popGRP219moonbit_2dcommunity4yaml5StateE(self) {
  if (self.length === 0) {
    return undefined;
  } else {
    const v = _M0MPC15array5Array11unsafe__popGRP219moonbit_2dcommunity4yaml5StateE(self);
    return v;
  }
}
function _M0MPC15array5Array6insertGcE(self, index, value) {
  if (index >= 0 && index <= self.length) {
    _M0MPB7JSArray7splice1(self, index, 0, value);
    return;
  } else {
    _M0FPC15abort5abortGuE(`index out of bounds: the len is from 0 to ${_M0IPC13int3IntPB4Show10to__string(self.length)} but the index is ${_M0IPC13int3IntPB4Show10to__string(index)}`);
    return;
  }
}
function _M0MPC15array5Array24unsafe__grow__to__lengthGsE(self, new_len) {
  if (new_len >= self.length) {
    _M0MPB7JSArray11set__length(self, new_len);
    return;
  } else {
    $panic();
    return;
  }
}
function _M0MPC15array5Array24unsafe__grow__to__lengthGcE(self, new_len) {
  if (new_len >= self.length) {
    _M0MPB7JSArray11set__length(self, new_len);
    return;
  } else {
    $panic();
    return;
  }
}
function _M0MPC15array5Array4copyGiE(self) {
  return _M0MPB7JSArray4copy(self);
}
function _M0MPC15array5Array4copyGRPB4JsonE(self) {
  return _M0MPB7JSArray4copy(self);
}
function _M0MPC15array5Array2atGUssEE(self, index) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    return self[index];
  } else {
    return $panic();
  }
}
function _M0MPC15array5Array2atGiE(self, index) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    return self[index];
  } else {
    return $panic();
  }
}
function _M0MPC15array5Array2atGbE(self, index) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    return self[index];
  } else {
    return $panic();
  }
}
function _M0MPC15array5Array2atGRPB5ArrayGsEE(self, index) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    return self[index];
  } else {
    return $panic();
  }
}
function _M0MPC15array5Array2atGcE(self, index) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    return self[index];
  } else {
    return $panic();
  }
}
function _M0MPC15array5Array2atGyE(self, index) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    return self[index];
  } else {
    return $panic();
  }
}
function _M0MPC15array5Array2atGjE(self, index) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    return self[index];
  } else {
    return $panic();
  }
}
function _M0MPC15array12MutArrayView4swapGUssEE(arr, i, j) {
  const temp = _M0MPC15array12MutArrayView2atGUssEE(arr, i);
  _M0MPC15array12MutArrayView3setGUssEE(arr, i, _M0MPC15array12MutArrayView2atGUssEE(arr, j));
  _M0MPC15array12MutArrayView3setGUssEE(arr, j, temp);
}
function _M0MPC15array12MutArrayView5sliceGUssEE(arr, start, end) {
  return _M0MPC15array12MutArrayView17mut__view_2einnerGUssEE(arr, start, end);
}
function _M0MPC15array12MutArrayView14rev__in__placeGUssEE(arr) {
  const len = arr.end - arr.start | 0;
  const mid_len = len / 2 | 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < mid_len) {
      const j = (len - i | 0) - 1 | 0;
      const temp = _M0MPC15array12MutArrayView2atGUssEE(arr, i);
      _M0MPC15array12MutArrayView3setGUssEE(arr, i, _M0MPC15array12MutArrayView2atGUssEE(arr, j));
      _M0MPC15array12MutArrayView3setGUssEE(arr, j, temp);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0FPB17fixed__get__limit(len) {
  let _tmp$38 = len;
  let _tmp$39 = 0;
  while (true) {
    const len$2 = _tmp$38;
    const limit = _tmp$39;
    if (len$2 > 0) {
      _tmp$38 = len$2 / 2 | 0;
      _tmp$39 = limit + 1 | 0;
      continue;
    } else {
      return limit;
    }
  }
}
function _M0FPB23fixed__bubble__sort__byGUssEE(arr, cmp) {
  const _bind$4 = arr.end - arr.start | 0;
  let _tmp$38 = 1;
  while (true) {
    const i = _tmp$38;
    if (i < _bind$4) {
      let _tmp$39 = i;
      while (true) {
        const j = _tmp$39;
        if (j > 0 && cmp(_M0MPC15array12MutArrayView2atGUssEE(arr, j - 1 | 0), _M0MPC15array12MutArrayView2atGUssEE(arr, j)) > 0) {
          _M0MPC15array12MutArrayView4swapGUssEE(arr, j, j - 1 | 0);
          _tmp$39 = j - 1 | 0;
          continue;
        } else {
          break;
        }
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0FPB24fixed__choose__pivot__byN7sort__2S418GUssEE(_env, a, b) {
  const arr = _env._2;
  const cmp = _env._1;
  const swaps = _env._0;
  if (cmp(_M0MPC15array12MutArrayView2atGUssEE(arr, a), _M0MPC15array12MutArrayView2atGUssEE(arr, b)) > 0) {
    _M0MPC15array12MutArrayView4swapGUssEE(arr, a, b);
    swaps.val = swaps.val + 1 | 0;
    return;
  } else {
    return;
  }
}
function _M0FPB24fixed__choose__pivot__byN7sort__3S422GUssEE(_env, a, b, c) {
  _M0FPB24fixed__choose__pivot__byN7sort__2S418GUssEE(_env, a, b);
  _M0FPB24fixed__choose__pivot__byN7sort__2S418GUssEE(_env, b, c);
  _M0FPB24fixed__choose__pivot__byN7sort__2S418GUssEE(_env, a, b);
}
function _M0FPB24fixed__choose__pivot__byGUssEE(arr, cmp) {
  const len = arr.end - arr.start | 0;
  const swaps = new _M0TPB8MutLocalGiE(0);
  const b = Math.imul(len / 4 | 0, 2) | 0;
  if (len >= 8) {
    const a = Math.imul(len / 4 | 0, 1) | 0;
    const c = Math.imul(len / 4 | 0, 3) | 0;
    const _env = { _0: swaps, _1: cmp, _2: arr };
    if (len > 50) {
      _M0FPB24fixed__choose__pivot__byN7sort__3S422GUssEE(_env, a - 1 | 0, a, a + 1 | 0);
      _M0FPB24fixed__choose__pivot__byN7sort__3S422GUssEE(_env, b - 1 | 0, b, b + 1 | 0);
      _M0FPB24fixed__choose__pivot__byN7sort__3S422GUssEE(_env, c - 1 | 0, c, c + 1 | 0);
    }
    _M0FPB24fixed__choose__pivot__byN7sort__3S422GUssEE(_env, a, b, c);
  }
  if (swaps.val === 12) {
    _M0MPC15array12MutArrayView14rev__in__placeGUssEE(arr);
    return { _0: (len - b | 0) - 1 | 0, _1: true };
  } else {
    return { _0: b, _1: swaps.val === 0 };
  }
}
function _M0FPB21fixed__sift__down__byGUssEE(arr, index, cmp) {
  const len = arr.end - arr.start | 0;
  let _tmp$38 = index;
  let _tmp$39 = (Math.imul(index, 2) | 0) + 1 | 0;
  while (true) {
    const index$2 = _tmp$38;
    const child = _tmp$39;
    if (child < len) {
      const child$2 = (child + 1 | 0) < len && cmp(_M0MPC15array12MutArrayView2atGUssEE(arr, child), _M0MPC15array12MutArrayView2atGUssEE(arr, child + 1 | 0)) < 0 ? child + 1 | 0 : child;
      if (cmp(_M0MPC15array12MutArrayView2atGUssEE(arr, index$2), _M0MPC15array12MutArrayView2atGUssEE(arr, child$2)) >= 0) {
        return undefined;
      }
      _M0MPC15array12MutArrayView4swapGUssEE(arr, index$2, child$2);
      _tmp$38 = child$2;
      _tmp$39 = (Math.imul(child$2, 2) | 0) + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0FPB21fixed__heap__sort__byGUssEE(arr, cmp) {
  const len = arr.end - arr.start | 0;
  const _bind$4 = len / 2 | 0;
  let _tmp$38 = _bind$4 - 1 | 0;
  while (true) {
    const i = _tmp$38;
    if (i >= 0) {
      _M0FPB21fixed__sift__down__byGUssEE(arr, i, cmp);
      _tmp$38 = i - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let _tmp$39 = len - 1 | 0;
  while (true) {
    const i = _tmp$39;
    if (i >= 1) {
      _M0MPC15array12MutArrayView4swapGUssEE(arr, 0, i);
      _M0FPB21fixed__sift__down__byGUssEE(_M0MPC15array12MutArrayView5sliceGUssEE(arr, 0, i), 0, cmp);
      _tmp$39 = i - 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0FPB20fixed__partition__byGUssEE(arr, cmp, pivot_index) {
  _M0MPC15array12MutArrayView4swapGUssEE(arr, pivot_index, (arr.end - arr.start | 0) - 1 | 0);
  const pivot = _M0MPC15array12MutArrayView2atGUssEE(arr, (arr.end - arr.start | 0) - 1 | 0);
  const _bind$4 = (arr.end - arr.start | 0) - 1 | 0;
  let _tmp$38 = 0;
  let _tmp$39 = 0;
  let _tmp$40 = true;
  while (true) {
    const j = _tmp$38;
    const i = _tmp$39;
    const partitioned = _tmp$40;
    if (j < _bind$4) {
      if (cmp(_M0MPC15array12MutArrayView2atGUssEE(arr, j), pivot) < 0) {
        if (i !== j) {
          _M0MPC15array12MutArrayView4swapGUssEE(arr, i, j);
          _tmp$38 = j + 1 | 0;
          _tmp$39 = i + 1 | 0;
          _tmp$40 = false;
          continue;
        } else {
          _tmp$38 = j + 1 | 0;
          _tmp$39 = i + 1 | 0;
          continue;
        }
      } else {
        _tmp$38 = j + 1 | 0;
        continue;
      }
    } else {
      _M0MPC15array12MutArrayView4swapGUssEE(arr, i, (arr.end - arr.start | 0) - 1 | 0);
      return { _0: i, _1: partitioned };
    }
  }
}
function _M0FPB28fixed__try__bubble__sort__byGUssEE(arr, cmp) {
  const _bind$4 = arr.end - arr.start | 0;
  let _tmp$38 = 1;
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$38;
    const tries = _tmp$39;
    if (i < _bind$4) {
      let sorted;
      let _tmp$40 = i;
      let _tmp$41 = true;
      while (true) {
        const j = _tmp$40;
        const sorted$2 = _tmp$41;
        if (j > 0 && cmp(_M0MPC15array12MutArrayView2atGUssEE(arr, j - 1 | 0), _M0MPC15array12MutArrayView2atGUssEE(arr, j)) > 0) {
          _M0MPC15array12MutArrayView4swapGUssEE(arr, j, j - 1 | 0);
          _tmp$40 = j - 1 | 0;
          _tmp$41 = false;
          continue;
        } else {
          sorted = sorted$2;
          break;
        }
      }
      if (!sorted) {
        const tries$2 = tries + 1 | 0;
        if (tries$2 > 8) {
          return false;
        }
        _tmp$38 = i + 1 | 0;
        _tmp$39 = tries$2;
        continue;
      } else {
        _tmp$38 = i + 1 | 0;
        continue;
      }
    } else {
      return true;
    }
  }
}
function _M0FPB22fixed__quick__sort__byGUssEE(arr, cmp, pred, limit) {
  let _tmp$38 = limit;
  let _tmp$39 = arr;
  let _tmp$40 = pred;
  let _tmp$41 = true;
  let _tmp$42 = true;
  while (true) {
    const limit$2 = _tmp$38;
    const arr$2 = _tmp$39;
    const pred$2 = _tmp$40;
    const was_partitioned = _tmp$41;
    const balanced = _tmp$42;
    const len = arr$2.end - arr$2.start | 0;
    if (len <= 16) {
      if (len >= 2) {
        _M0FPB23fixed__bubble__sort__byGUssEE(arr$2, cmp);
      }
      return undefined;
    }
    if (limit$2 === 0) {
      _M0FPB21fixed__heap__sort__byGUssEE(arr$2, cmp);
      return undefined;
    }
    const _bind$4 = _M0FPB24fixed__choose__pivot__byGUssEE(arr$2, cmp);
    const _pivot_index = _bind$4._0;
    const _likely_sorted = _bind$4._1;
    if (was_partitioned && (balanced && _likely_sorted)) {
      if (_M0FPB28fixed__try__bubble__sort__byGUssEE(arr$2, cmp)) {
        return undefined;
      }
    }
    const _bind$5 = _M0FPB20fixed__partition__byGUssEE(arr$2, cmp, _pivot_index);
    const _pivot = _bind$5._0;
    const _partitioned = _bind$5._1;
    const _p$4 = len - _pivot | 0;
    const balanced$2 = (_pivot > _p$4 ? _p$4 : _pivot) >= (len / 8 | 0);
    const limit$3 = !balanced$2 ? limit$2 - 1 | 0 : limit$2;
    if (pred$2 === undefined) {
    } else {
      const _Some = pred$2;
      const _p$5 = _Some;
      if (cmp(_p$5, _M0MPC15array12MutArrayView2atGUssEE(arr$2, _pivot)) === 0) {
        let i;
        let _tmp$43 = _pivot;
        while (true) {
          const i$2 = _tmp$43;
          if (i$2 < len && cmp(_p$5, _M0MPC15array12MutArrayView2atGUssEE(arr$2, i$2)) === 0) {
            _tmp$43 = i$2 + 1 | 0;
            continue;
          } else {
            i = i$2;
            break;
          }
        }
        _tmp$38 = limit$3;
        _tmp$39 = _M0MPC15array12MutArrayView5sliceGUssEE(arr$2, i, len);
        _tmp$41 = _partitioned;
        _tmp$42 = balanced$2;
        continue;
      }
    }
    const left = _M0MPC15array12MutArrayView5sliceGUssEE(arr$2, 0, _pivot);
    const right = _M0MPC15array12MutArrayView5sliceGUssEE(arr$2, _pivot + 1 | 0, len);
    if ((left.end - left.start | 0) < (right.end - right.start | 0)) {
      _M0FPB22fixed__quick__sort__byGUssEE(left, cmp, pred$2, limit$3);
      _tmp$38 = limit$3;
      _tmp$39 = right;
      _tmp$40 = _M0MPC15array12MutArrayView2atGUssEE(arr$2, _pivot);
      _tmp$41 = _partitioned;
      _tmp$42 = balanced$2;
      continue;
    } else {
      _M0FPB22fixed__quick__sort__byGUssEE(right, cmp, _M0MPC15array12MutArrayView2atGUssEE(arr$2, _pivot), limit$3);
      _tmp$38 = limit$3;
      _tmp$39 = left;
      _tmp$41 = _partitioned;
      _tmp$42 = balanced$2;
      continue;
    }
  }
}
function _M0MPC15array12MutArrayView13sort__by__keyGUccEcE(self, map) {
  _M0FPB22fixed__quick__sort__byGUssEE(self, (a, b) => $compare_int(map(a), map(b)), undefined, _M0FPB17fixed__get__limit(self.end - self.start | 0));
}
function _M0MPC15array12MutArrayView13sort__by__keyGUiiEiE(self, map) {
  _M0FPB22fixed__quick__sort__byGUssEE(self, (a, b) => $compare_int(map(a), map(b)), undefined, _M0FPB17fixed__get__limit(self.end - self.start | 0));
}
function _M0MPC15array12MutArrayView8sort__byGUssEE(self, cmp) {
  _M0FPB22fixed__quick__sort__byGUssEE(self, cmp, undefined, _M0FPB17fixed__get__limit(self.end - self.start | 0));
}
function _M0MPC15array5Array13sort__by__keyGUccEcE(self, map) {
  _M0MPC15array12MutArrayView13sort__by__keyGUccEcE(_M0MPC15array5Array17mut__view_2einnerGUssEE(self, 0, undefined), map);
}
function _M0MPC15array5Array13sort__by__keyGUiiEiE(self, map) {
  _M0MPC15array12MutArrayView13sort__by__keyGUiiEiE(_M0MPC15array5Array17mut__view_2einnerGUssEE(self, 0, undefined), map);
}
function _M0MPC15array5Array8sort__byGUssEE(self, cmp) {
  _M0MPC15array12MutArrayView8sort__byGUssEE(_M0MPC15array5Array17mut__view_2einnerGUssEE(self, 0, undefined), cmp);
}
function _M0MPC15array5Array12unsafe__blitGyE(dst, dst_offset, src, src_offset, len) {
  _M0MPC15array10FixedArray12unsafe__blitGRPB17UnsafeMaybeUninitGyEE(dst, dst_offset, src, src_offset, len);
}
function _M0MPC15array9ArrayView16blit__to_2einnerGsE(self, dst, dst_offset) {
  const len = self.end - self.start | 0;
  if (dst_offset >= 0 && dst_offset <= dst.length) {
    if ((dst_offset + len | 0) > dst.length) {
      _M0MPC15array5Array24unsafe__grow__to__lengthGsE(dst, dst_offset + len | 0);
    }
    _M0MPB18UninitializedArray12unsafe__blitGsE(dst, dst_offset, self.buf, self.start, len);
    return;
  } else {
    $panic();
    return;
  }
}
function _M0MPC15array9ArrayView16blit__to_2einnerGcE(self, dst, dst_offset) {
  const len = self.end - self.start | 0;
  if (dst_offset >= 0 && dst_offset <= dst.length) {
    if ((dst_offset + len | 0) > dst.length) {
      _M0MPC15array5Array24unsafe__grow__to__lengthGcE(dst, dst_offset + len | 0);
    }
    _M0MPB18UninitializedArray12unsafe__blitGcE(dst, dst_offset, self.buf, self.start, len);
    return;
  } else {
    $panic();
    return;
  }
}
function _M0MPC15array5Array3getGsE(self, index) {
  const len = self.length;
  return index >= 0 && index < len ? self[index] : undefined;
}
function _M0IPC15array5ArrayPB2Eq5equalGUsOsEE(self, other) {
  const self_len = self.length;
  const other_len = other.length;
  if (self_len === other_len) {
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < self_len) {
        if (_M0IPC15tuple6Tuple2PB2Eq5equalGsOsE(self[i], other[i])) {
        } else {
          return false;
        }
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        return true;
      }
    }
  } else {
    return false;
  }
}
function _M0IPC15array5ArrayPB2Eq5equalGRPB4JsonE(self, other) {
  const self_len = self.length;
  const other_len = other.length;
  if (self_len === other_len) {
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < self_len) {
        if (_M0IPC14json4JsonPB2Eq5equal(self[i], other[i])) {
        } else {
          return false;
        }
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        return true;
      }
    }
  } else {
    return false;
  }
}
function _M0IPC15array5ArrayPB3Add3addGsE(self, other) {
  const result = new Array(self.length + other.length | 0);
  _M0MPB18UninitializedArray12unsafe__blitGsE(result, 0, self, 0, self.length);
  _M0MPB18UninitializedArray12unsafe__blitGsE(result, self.length, other, 0, other.length);
  return result;
}
function _M0IPC15array5ArrayPB3Add3addGiE(self, other) {
  const result = new Array(self.length + other.length | 0);
  _M0MPB18UninitializedArray12unsafe__blitGiE(result, 0, self, 0, self.length);
  _M0MPB18UninitializedArray12unsafe__blitGiE(result, self.length, other, 0, other.length);
  return result;
}
function _M0MPC15array5Array6appendGsE(self, other) {
  _M0MPC15array9ArrayView16blit__to_2einnerGsE(other, self, self.length);
}
function _M0MPC15array5Array6appendGcE(self, other) {
  _M0MPC15array9ArrayView16blit__to_2einnerGcE(other, self, self.length);
}
function _M0MPC15array5Array3allGsE(self, f) {
  const _p$4 = new _M0TPB9ArrayViewGsE(self, 0, self.length);
  const _p$5 = _p$4.end - _p$4.start | 0;
  let _tmp$38 = 0;
  while (true) {
    const _p$6 = _tmp$38;
    if (_p$6 < _p$5) {
      const _p$7 = _p$4.buf[_p$4.start + _p$6 | 0];
      if (!f(_p$7)) {
        return false;
      }
      _tmp$38 = _p$6 + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0MPC15array5Array5clearGRP411moonbitlang6regexp8internal2vm6ThreadE(self) {
  _M0MPC15array5Array28unsafe__truncate__to__lengthGRP411moonbitlang6regexp8internal2vm6ThreadE(self, 0);
}
function _M0MPC15array5Array3revGRP38bobzhang6moonjq3ast4ExprE(self) {
  const len = self.length;
  const arr = new Array(len);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < len) {
      arr[i] = self[(len - i | 0) - 1 | 0];
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return arr;
}
function _M0MPC15array5Array10push__iterGsE(self, iter) {
  const _bind$4 = iter.size_hint;
  if (_bind$4 === undefined) {
  } else {
    const _Some = _bind$4;
    const _n = _Some;
    _M0MPC15array5Array17reserve__capacityGsE(self, self.length + _n | 0);
  }
  while (true) {
    const _bind$5 = _M0MPB4Iter4nextGUssEE(iter);
    if (_bind$5 === undefined) {
      return;
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      _M0MPC15array5Array4pushGUssEE(self, _x);
      continue;
    }
  }
}
function _M0MPC15array5Array4lastGURP219moonbit_2dcommunity4yaml4YamliEE(self) {
  if (self.length === 0) {
    return undefined;
  } else {
    const _last = self[self.length - 1 | 0];
    return _last;
  }
}
function _M0MPC15array5Array4joinGsE(self, separator) {
  return _M0MPC15array9ArrayView4joinGsE(new _M0TPB9ArrayViewGsE(self, 0, self.length), separator);
}
function _M0MPC15array5Array4joinGRPC16string10StringViewE(self, separator) {
  return _M0MPC15array9ArrayView4joinGRPC16string10StringViewE(new _M0TPB9ArrayViewGRPC16string10StringViewE(self, 0, self.length), separator);
}
function _M0MPC14uint4UInt9to__int64(self) {
  return BigInt.asUintN(64, BigInt(self >>> 0));
}
function _M0IPC15float5FloatPB4Show10to__string(self) {
  return String(self);
}
function _M0MPC15debug4Repr8children(self) {
  let value;
  _L: {
    _L$2: {
      switch (self.$tag) {
        case 0: {
          break _L$2;
        }
        case 1: {
          break _L$2;
        }
        case 2: {
          break _L$2;
        }
        case 3: {
          break _L$2;
        }
        case 4: {
          break _L$2;
        }
        case 5: {
          break _L$2;
        }
        case 6: {
          break _L$2;
        }
        case 15: {
          break _L$2;
        }
        case 17: {
          break _L$2;
        }
        case 7: {
          const _Tuple = self;
          const _xs = _Tuple._0;
          return _xs;
        }
        case 8: {
          const _Array = self;
          const _xs$2 = _Array._0;
          return _xs$2;
        }
        case 9: {
          const _Record = self;
          const _xs$3 = _Record._0;
          return _xs$3;
        }
        case 10: {
          const _Enum = self;
          const _xs$4 = _Enum._1;
          return _xs$4;
        }
        case 11: {
          const _Map = self;
          const _xs$5 = _Map._0;
          return _xs$5;
        }
        case 14: {
          const _Opaque = self;
          const _value = _Opaque._1;
          value = _value;
          break _L;
        }
        case 12: {
          const _RecordField = self;
          const _value$2 = _RecordField._1;
          value = _value$2;
          break _L;
        }
        case 13: {
          const _EnumLabeledArg = self;
          const _value$3 = _EnumLabeledArg._1;
          value = _value$3;
          break _L;
        }
        default: {
          const _MapEntry = self;
          const _key = _MapEntry._0;
          const _value$4 = _MapEntry._1;
          return [_key, _value$4];
        }
      }
    }
    return [];
  }
  return [value];
}
function _M0MPC15debug4Repr14with__children(self, children) {
  _L: {
    switch (self.$tag) {
      case 0: {
        break _L;
      }
      case 1: {
        break _L;
      }
      case 2: {
        break _L;
      }
      case 3: {
        break _L;
      }
      case 4: {
        break _L;
      }
      case 5: {
        break _L;
      }
      case 6: {
        break _L;
      }
      case 15: {
        break _L;
      }
      case 17: {
        break _L;
      }
      case 7: {
        return new _M0DTPC15debug4Repr5Tuple(children);
      }
      case 8: {
        return new _M0DTPC15debug4Repr5Array(children);
      }
      case 9: {
        return new _M0DTPC15debug4Repr6Record(children);
      }
      case 10: {
        const _Enum = self;
        const _name = _Enum._0;
        return new _M0DTPC15debug4Repr4Enum(_name, children);
      }
      case 11: {
        return new _M0DTPC15debug4Repr3Map(children);
      }
      case 12: {
        const _RecordField = self;
        const _name$2 = _RecordField._0;
        if (children.length === 1) {
          const _value = children[0];
          return new _M0DTPC15debug4Repr11RecordField(_name$2, _value);
        } else {
          return new _M0DTPC15debug4Repr11RecordField(_name$2, _M0DTPC15debug4Repr7Omitted__);
        }
      }
      case 13: {
        const _EnumLabeledArg = self;
        const _label = _EnumLabeledArg._0;
        if (children.length === 1) {
          const _value = children[0];
          return new _M0DTPC15debug4Repr14EnumLabeledArg(_label, _value);
        } else {
          return new _M0DTPC15debug4Repr14EnumLabeledArg(_label, _M0DTPC15debug4Repr7Omitted__);
        }
      }
      case 16: {
        if (children.length === 2) {
          const _key = children[0];
          const _value = children[1];
          return new _M0DTPC15debug4Repr8MapEntry(_key, _value);
        } else {
          return new _M0DTPC15debug4Repr8MapEntry(_M0DTPC15debug4Repr7Omitted__, _M0DTPC15debug4Repr7Omitted__);
        }
      }
      default: {
        const _Opaque = self;
        const _name$3 = _Opaque._0;
        if (children.length === 1) {
          const _value = children[0];
          return new _M0DTPC15debug4Repr6Opaque(_name$3, _value);
        } else {
          return new _M0DTPC15debug4Repr6Opaque(_name$3, _M0DTPC15debug4Repr7Omitted__);
        }
      }
    }
  }
  return self;
}
function _M0MPC15debug4Repr4ctor(name, args) {
  const _p$4 = new Array(args.length);
  const _p$5 = args.length;
  let _tmp$38 = 0;
  while (true) {
    const _p$6 = _tmp$38;
    if (_p$6 < _p$5) {
      const _p$7 = args[_p$6];
      const _p$8 = _p$7._0;
      const _p$9 = _p$7._1;
      let _tmp$39;
      if (_p$8 === undefined) {
        _tmp$39 = _p$9;
      } else {
        const _p$10 = _p$8;
        const _p$11 = _p$10;
        _tmp$39 = new _M0DTPC15debug4Repr14EnumLabeledArg(_p$11, _p$9);
      }
      _p$4[_p$6] = _tmp$39;
      _tmp$38 = _p$6 + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC15debug4Repr4Enum(name, _p$4);
}
function _M0MPC15debug4Repr7shallow(self) {
  _L: {
    switch (self.$tag) {
      case 0: {
        break _L;
      }
      case 1: {
        break _L;
      }
      case 2: {
        break _L;
      }
      case 3: {
        break _L;
      }
      case 4: {
        break _L;
      }
      case 5: {
        break _L;
      }
      case 6: {
        break _L;
      }
      case 15: {
        break _L;
      }
      case 17: {
        break _L;
      }
      case 7: {
        return new _M0DTPC15debug4Repr5Tuple([]);
      }
      case 8: {
        return new _M0DTPC15debug4Repr5Array([]);
      }
      case 9: {
        return new _M0DTPC15debug4Repr6Record([]);
      }
      case 10: {
        const _Enum = self;
        const _name = _Enum._0;
        return new _M0DTPC15debug4Repr4Enum(_name, []);
      }
      case 14: {
        const _Opaque = self;
        const _name$2 = _Opaque._0;
        return new _M0DTPC15debug4Repr6Opaque(_name$2, _M0DTPC15debug4Repr7Omitted__);
      }
      case 11: {
        return new _M0DTPC15debug4Repr3Map([]);
      }
      case 12: {
        const _RecordField = self;
        const _name$3 = _RecordField._0;
        return new _M0DTPC15debug4Repr11RecordField(_name$3, _M0DTPC15debug4Repr7Omitted__);
      }
      case 13: {
        const _EnumLabeledArg = self;
        const _label = _EnumLabeledArg._0;
        return new _M0DTPC15debug4Repr14EnumLabeledArg(_label, _M0DTPC15debug4Repr7Omitted__);
      }
      default: {
        return new _M0DTPC15debug4Repr8MapEntry(_M0DTPC15debug4Repr7Omitted__, _M0DTPC15debug4Repr7Omitted__);
      }
    }
  }
  return self;
}
function _M0IPC15debug13ContentParensPB3Add3add(self, other) {
  return new _M0TPC15debug13ContentParens(self.size + other.size | 0, _M0IPC15array5ArrayPB3Add3addGsE(self.lines, other.lines));
}
function _M0FPC15debug14empty__content() {
  return new _M0TPC15debug7Content(0, [], false);
}
function _M0FPC15debug8verbatim(x) {
  return new _M0TPC15debug13ContentParens(1, [x]);
}
function _M0FPC15debug15content__parens(size, lines) {
  return new _M0TPC15debug13ContentParens(size, lines);
}
function _M0FPC15debug12leaf_2einner(x, needs_parens) {
  return new _M0TPC15debug7Content(1, [x], needs_parens);
}
function _M0FPC15debug11with__lines(r, f) {
  return new _M0TPC15debug13ContentParens(r.size, f(r.lines));
}
function _M0MPC15debug7Content20with__lines__content(r, f) {
  return new _M0TPC15debug7Content(r.size, f(r.lines), r.needs_parens);
}
function _M0FPC15debug15surround__lines(start, finish, lines) {
  if (lines.length === 0) {
    return [`${start}${finish}`];
  } else {
    if (lines.length === 1) {
      const _item = lines[0];
      return [`${start}${_item}${finish}`];
    } else {
      const _first = lines[0];
      const _last = lines[lines.length - 1 | 0];
      const _x = _M0MPC15array5Array12view_2einnerGsE(lines, 1, lines.length - 1 | 0);
      const _self = [];
      _M0MPC15array5Array4pushGUssEE(_self, `${start}${_first}`);
      _M0MPC15array5Array10push__iterGsE(_self, _M0MPC15array9ArrayView4iterGsE(_x));
      _M0MPC15array5Array4pushGUssEE(_self, `${_last}${finish}`);
      return _self;
    }
  }
}
function _M0FPC15debug8surround(start, finish, r) {
  return _M0FPC15debug11with__lines(r, (lines) => _M0FPC15debug15surround__lines(start, finish, lines));
}
function _M0MPC15debug7Content8no__wrap(c) {
  return new _M0TPC15debug13ContentParens(c.size, c.lines);
}
function _M0FPC15debug6parens(r) {
  return new _M0TPC15debug7Content(r.size, r.lines, true);
}
function _M0FPC15debug10no__parens(r) {
  return new _M0TPC15debug7Content(r.size, r.lines, false);
}
function _M0FPC15debug14compact__lines(lines) {
  if (lines.length === 0) {
    return [];
  } else {
    if (lines.length === 1) {
      const _x = lines[0];
      return [_x];
    } else {
      const _first = lines[0];
      const _last = lines[lines.length - 1 | 0];
      const _x = _M0MPC15array5Array12view_2einnerGsE(lines, 1, lines.length - 1 | 0);
      if (_first === "[" && _last === "]" || _first === "{" && _last === "}") {
        const parts = [];
        const _bind$4 = _x.end - _x.start | 0;
        let _tmp$38 = 0;
        while (true) {
          const _ = _tmp$38;
          if (_ < _bind$4) {
            const m = _x.buf[_x.start + _ | 0];
            const t = _M0MPC16string6String4trim(m, undefined);
            if (_M0IP016_24default__implPB2Eq10not__equalGRPC16string10StringViewE(t, new _M0TPC16string10StringView(_M0FPC15debug14compact__linesN7_2abindS1156, 0, _M0FPC15debug14compact__linesN7_2abindS1156.length))) {
              _M0MPC15array5Array4pushGUssEE(parts, t);
            }
            _tmp$38 = _ + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        const joined0 = _M0MPC15array5Array4joinGRPC16string10StringViewE(parts, new _M0TPC16string10StringView(_M0FPC15debug14compact__linesN7_2abindS1177, 0, _M0FPC15debug14compact__linesN7_2abindS1177.length));
        const _bind$5 = _M0MPC16string6String13strip__suffix(joined0, new _M0TPC16string10StringView(_M0FPC15debug14compact__linesN7_2abindS1171, 0, _M0FPC15debug14compact__linesN7_2abindS1171.length));
        let joined;
        if (_bind$5 === undefined) {
          joined = new _M0TPC16string10StringView(joined0, 0, joined0.length);
        } else {
          const _Some = _bind$5;
          joined = _Some;
        }
        if (_first === "{") {
          const _bind$6 = _M0MPC16string10StringView13strip__prefix(joined, new _M0TPC16string10StringView(_M0FPC15debug14compact__linesN7_2abindS1165, 0, _M0FPC15debug14compact__linesN7_2abindS1165.length));
          let s1;
          if (_bind$6 === undefined) {
            s1 = joined;
          } else {
            const _Some = _bind$6;
            s1 = _Some;
          }
          const _bind$7 = _M0MPC16string10StringView13strip__suffix(s1, new _M0TPC16string10StringView(_M0FPC15debug14compact__linesN7_2abindS1159, 0, _M0FPC15debug14compact__linesN7_2abindS1159.length));
          let inner;
          if (_bind$7 === undefined) {
            inner = s1;
          } else {
            const _Some = _bind$7;
            inner = _Some;
          }
          return _M0IPC16string10StringViewPB2Eq5equal(inner, new _M0TPC16string10StringView(_M0FPC15debug14compact__linesN7_2abindS1158, 0, _M0FPC15debug14compact__linesN7_2abindS1158.length)) ? ["{}"] : [`{ ${_M0IPC16string10StringViewPB4Show10to__string(inner)} }`];
        } else {
          return [`[${_M0IPC16string10StringViewPB4Show10to__string(joined)}]`];
        }
      } else {
        if (_M0MPC16string6String11has__suffix(_first, new _M0TPC16string10StringView(_M0FPC15debug14compact__linesN7_2abindS1178, 0, _M0FPC15debug14compact__linesN7_2abindS1178.length)) && _last === ")") {
          const parts = [];
          const _bind$4 = _x.end - _x.start | 0;
          let _tmp$38 = 0;
          while (true) {
            const _ = _tmp$38;
            if (_ < _bind$4) {
              const m = _x.buf[_x.start + _ | 0];
              const t = _M0MPC16string6String4trim(m, undefined);
              if (_M0IP016_24default__implPB2Eq10not__equalGRPC16string10StringViewE(t, new _M0TPC16string10StringView(_M0FPC15debug14compact__linesN7_2abindS1182, 0, _M0FPC15debug14compact__linesN7_2abindS1182.length))) {
                _M0MPC15array5Array4pushGUssEE(parts, t);
              }
              _tmp$38 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          const joined0 = _M0MPC15array5Array4joinGRPC16string10StringViewE(parts, new _M0TPC16string10StringView(_M0FPC15debug14compact__linesN7_2abindS1190, 0, _M0FPC15debug14compact__linesN7_2abindS1190.length));
          const _bind$5 = _M0MPC16string6String13strip__suffix(joined0, new _M0TPC16string10StringView(_M0FPC15debug14compact__linesN7_2abindS1184, 0, _M0FPC15debug14compact__linesN7_2abindS1184.length));
          let joined;
          if (_bind$5 === undefined) {
            joined = new _M0TPC16string10StringView(joined0, 0, joined0.length);
          } else {
            const _Some = _bind$5;
            joined = _Some;
          }
          return [`${_first}${_M0IPC16string10StringViewPB4Show10to__string(joined)}${_last}`];
        } else {
          const parts = [new _M0TPC16string10StringView(_first, 0, _first.length)];
          const _bind$4 = _x.end - _x.start | 0;
          let _tmp$38 = 0;
          while (true) {
            const _ = _tmp$38;
            if (_ < _bind$4) {
              const m = _x.buf[_x.start + _ | 0];
              _M0MPC15array5Array4pushGUssEE(parts, _M0MPC16string6String4trim(m, undefined));
              _tmp$38 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          _M0MPC15array5Array4pushGUssEE(parts, _M0MPC16string6String4trim(_last, undefined));
          return [_M0MPC15array5Array4joinGRPC16string10StringViewE(parts, new _M0TPC16string10StringView(_M0FPC15debug14compact__linesN7_2abindS1195, 0, _M0FPC15debug14compact__linesN7_2abindS1195.length))];
        }
      }
    }
  }
}
function _M0MPC15debug7Content7compact(r) {
  return _M0MPC15debug7Content20with__lines__content(r, _M0FPC15debug14compact__lines);
}
function _M0FPC15debug6indent(prefix, r) {
  return _M0FPC15debug11with__lines(r, (lines) => {
    const _p$4 = new Array(lines.length);
    const _p$5 = lines.length;
    let _tmp$38 = 0;
    while (true) {
      const _p$6 = _tmp$38;
      if (_p$6 < _p$5) {
        const _p$7 = lines[_p$6];
        _p$4[_p$6] = `${prefix}${_p$7}`;
        _tmp$38 = _p$6 + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return _p$4;
  });
}
function _M0FPC15debug14indent__spaces(n, r) {
  return _M0FPC15debug6indent(_M0MPC16string6String6repeat(" ", n), r);
}
function _M0FPC15debug19bracket__seq__lines(open, close, indent_by, contents) {
  if (contents.length === 0) {
    return [`${open}${close}`];
  } else {
    if (contents.length === 1) {
      const _item = contents[0];
      if (_item.length > 1) {
        const lines = _M0FPC15debug14indent__spaces(indent_by, new _M0TPC15debug13ContentParens(0, _item)).lines;
        if (lines.length > 0) {
          const last_i = lines.length - 1 | 0;
          _M0MPC15array5Array3setGsE(lines, last_i, `${_M0MPC15array5Array2atGUssEE(lines, last_i)},`);
        }
        const _self = [];
        _M0MPC15array5Array4pushGUssEE(_self, open);
        _M0MPC15array5Array10push__iterGsE(_self, _M0MPC15array5Array4iterGsE(lines));
        _M0MPC15array5Array4pushGUssEE(_self, close);
        return _self;
      } else {
        const inner = _M0FPC15debug14compact__lines(_item);
        if (inner.length === 0) {
          return [`${open}${close}`];
        } else {
          if (inner.length === 1) {
            const _x = inner[0];
            if (open === "{" && close === "}") {
              const inner$2 = _M0MPC16string6String4trim(_x, undefined);
              return _M0IPC16string10StringViewPB2Eq5equal(inner$2, new _M0TPC16string10StringView(_M0FPC15debug19bracket__seq__linesN7_2abindS1204, 0, _M0FPC15debug19bracket__seq__linesN7_2abindS1204.length)) ? ["{}"] : [`{ ${_M0IPC16string10StringViewPB4Show10to__string(inner$2)} }`];
            } else {
              return [`${open}${_x}${close}`];
            }
          } else {
            const _self = [];
            _M0MPC15array5Array4pushGUssEE(_self, open);
            _M0MPC15array5Array10push__iterGsE(_self, _M0MPC15array5Array4iterGsE(_M0FPC15debug14indent__spaces(indent_by, new _M0TPC15debug13ContentParens(0, _item)).lines));
            _M0MPC15array5Array4pushGUssEE(_self, close);
            return _self;
          }
        }
      }
    } else {
      const out = [open];
      const _bind$4 = contents.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const item = contents[_];
          const _p$4 = [];
          const _p$5 = item.length;
          let _tmp$39 = 0;
          while (true) {
            const _p$6 = _tmp$39;
            if (_p$6 < _p$5) {
              const _p$7 = item[_p$6];
              const _p$8 = "";
              if (!(_p$7 === _p$8)) {
                _M0MPC15array5Array4pushGUssEE(_p$4, _p$7);
              }
              _tmp$39 = _p$6 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          const item_lines = _p$4;
          if (item_lines.length === 0) {
          } else {
            if (item_lines.length === 1) {
              const _x = item_lines[0];
              _M0MPC15array5Array4pushGUssEE(out, `${_M0MPC16string6String6repeat(" ", indent_by)}${_x},`);
            } else {
              const _first = item_lines[0];
              const _last = item_lines[item_lines.length - 1 | 0];
              const _x = _M0MPC15array5Array12view_2einnerGsE(item_lines, 1, item_lines.length - 1 | 0);
              _M0MPC15array5Array4pushGUssEE(out, `${_M0MPC16string6String6repeat(" ", indent_by)}${_first}`);
              const _bind$5 = _x.end - _x.start | 0;
              let _tmp$40 = 0;
              while (true) {
                const _$2 = _tmp$40;
                if (_$2 < _bind$5) {
                  const mid = _x.buf[_x.start + _$2 | 0];
                  _M0MPC15array5Array4pushGUssEE(out, `${_M0MPC16string6String6repeat(" ", indent_by)}${mid}`);
                  _tmp$40 = _$2 + 1 | 0;
                  continue;
                } else {
                  break;
                }
              }
              _M0MPC15array5Array4pushGUssEE(out, `${_M0MPC16string6String6repeat(" ", indent_by)}${_last},`);
            }
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      _M0MPC15array5Array4pushGUssEE(out, close);
      return out;
    }
  }
}
function _M0FPC15debug17comma__seq__lines(begin, end, contents) {
  if (begin === "[" && end === "]") {
    return _M0FPC15debug19bracket__seq__lines("[", "]", 2, contents);
  } else {
    if (begin === "{" && end === "}") {
      return _M0FPC15debug19bracket__seq__lines("{", "}", 2, contents);
    } else {
      if (begin === "" && end === "") {
        let lines;
        if (contents.length === 0) {
          lines = [`${begin}${end}`];
        } else {
          if (contents.length === 1) {
            const _item = contents[0];
            lines = _M0FPC15debug15surround__lines(begin, end, _item);
          } else {
            const _first = contents[0];
            const _last = contents[contents.length - 1 | 0];
            const _x = _M0MPC15array5Array12view_2einnerGRPB5ArrayGsEE(contents, 1, contents.length - 1 | 0);
            const space = _M0MPC16string6String6repeat(" ", begin.length);
            const middle_lines = [];
            const _bind$4 = _x.end - _x.start | 0;
            let _tmp$38 = 0;
            while (true) {
              const _ = _tmp$38;
              if (_ < _bind$4) {
                const item = _x.buf[_x.start + _ | 0];
                const _bind$5 = _M0FPC15debug15surround__lines(space, ",", item);
                _M0MPC15array5Array6appendGsE(middle_lines, new _M0TPB9ArrayViewGsE(_bind$5, 0, _bind$5.length));
                _tmp$38 = _ + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            const _self = [];
            _M0MPC15array5Array10push__iterGsE(_self, _M0MPC15array5Array4iterGsE(_M0FPC15debug15surround__lines(begin, ",", _first)));
            _M0MPC15array5Array10push__iterGsE(_self, _M0MPC15array5Array4iterGsE(middle_lines));
            _M0MPC15array5Array10push__iterGsE(_self, _M0MPC15array5Array4iterGsE(_M0FPC15debug15surround__lines(space, end, _last)));
            lines = _self;
          }
        }
        const _p$4 = [];
        const _p$5 = lines.length;
        let _tmp$38 = 0;
        while (true) {
          const _p$6 = _tmp$38;
          if (_p$6 < _p$5) {
            const _p$7 = lines[_p$6];
            const _p$8 = "";
            if (!(_p$7 === _p$8)) {
              _M0MPC15array5Array4pushGUssEE(_p$4, _p$7);
            }
            _tmp$38 = _p$6 + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        return _p$4;
      } else {
        if (contents.length === 0) {
          return [`${begin}${end}`];
        } else {
          if (contents.length === 1) {
            const _item = contents[0];
            const _p$4 = [];
            const _p$5 = _item.length;
            let _tmp$38 = 0;
            while (true) {
              const _p$6 = _tmp$38;
              if (_p$6 < _p$5) {
                const _p$7 = _item[_p$6];
                const _p$8 = "";
                if (!(_p$7 === _p$8)) {
                  _M0MPC15array5Array4pushGUssEE(_p$4, _p$7);
                }
                _tmp$38 = _p$6 + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            const item_lines = _p$4;
            if (item_lines.length === 0) {
              return [`${begin}${end}`];
            } else {
              if (item_lines.length === 1) {
                const _x = item_lines[0];
                return [`${begin}${_x}${end}`];
              } else {
                const _last_line = item_lines[item_lines.length - 1 | 0];
                const _x = _M0MPC15array5Array12view_2einnerGsE(item_lines, 0, item_lines.length - 1 | 0);
                const _self = [];
                _M0MPC15array5Array4pushGUssEE(_self, begin);
                _M0MPC15array5Array10push__iterGsE(_self, _M0MPB4Iter3mapGRPC16string10StringViewRPB4JsonE(_M0MPC15array9ArrayView4iterGsE(_x), (line) => `${_M0MPC16string6String6repeat(" ", 2)}${line}`));
                _M0MPC15array5Array4pushGUssEE(_self, `${_M0MPC16string6String6repeat(" ", 2)}${_last_line},`);
                _M0MPC15array5Array4pushGUssEE(_self, end);
                return _self;
              }
            }
          } else {
            const out = [begin];
            const _bind$4 = contents.length;
            let _tmp$38 = 0;
            while (true) {
              const _ = _tmp$38;
              if (_ < _bind$4) {
                const item = contents[_];
                const _p$4 = [];
                const _p$5 = item.length;
                let _tmp$39 = 0;
                while (true) {
                  const _p$6 = _tmp$39;
                  if (_p$6 < _p$5) {
                    const _p$7 = item[_p$6];
                    const _p$8 = "";
                    if (!(_p$7 === _p$8)) {
                      _M0MPC15array5Array4pushGUssEE(_p$4, _p$7);
                    }
                    _tmp$39 = _p$6 + 1 | 0;
                    continue;
                  } else {
                    break;
                  }
                }
                const item_lines = _p$4;
                if (item_lines.length === 0) {
                } else {
                  if (item_lines.length === 1) {
                    const _x = item_lines[0];
                    _M0MPC15array5Array4pushGUssEE(out, `${_M0MPC16string6String6repeat(" ", 2)}${_x},`);
                  } else {
                    const _first = item_lines[0];
                    const _last = item_lines[item_lines.length - 1 | 0];
                    const _x = _M0MPC15array5Array12view_2einnerGsE(item_lines, 1, item_lines.length - 1 | 0);
                    _M0MPC15array5Array4pushGUssEE(out, `${_M0MPC16string6String6repeat(" ", 2)}${_first}`);
                    const _bind$5 = _x.end - _x.start | 0;
                    let _tmp$40 = 0;
                    while (true) {
                      const _$2 = _tmp$40;
                      if (_$2 < _bind$5) {
                        const mid = _x.buf[_x.start + _$2 | 0];
                        _M0MPC15array5Array4pushGUssEE(out, `${_M0MPC16string6String6repeat(" ", 2)}${mid}`);
                        _tmp$40 = _$2 + 1 | 0;
                        continue;
                      } else {
                        break;
                      }
                    }
                    _M0MPC15array5Array4pushGUssEE(out, `${_M0MPC16string6String6repeat(" ", 2)}${_last},`);
                  }
                }
                _tmp$38 = _ + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            _M0MPC15array5Array4pushGUssEE(out, end);
            return out;
          }
        }
      }
    }
  }
}
function _M0FPC15debug10comma__seq(begin, end, contents) {
  const _bind$4 = contents.length;
  let _tmp$38 = 0;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$38;
    const size = _tmp$39;
    if (_ < _bind$4) {
      const c = contents[_];
      _tmp$38 = _ + 1 | 0;
      _tmp$39 = size + c.size | 0;
      continue;
    } else {
      const _p$4 = new Array(contents.length);
      const _p$5 = contents.length;
      let _tmp$40 = 0;
      while (true) {
        const _p$6 = _tmp$40;
        if (_p$6 < _p$5) {
          const _p$7 = contents[_p$6];
          _p$4[_p$6] = _p$7.lines;
          _tmp$40 = _p$6 + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return new _M0TPC15debug7Content(size, _M0FPC15debug17comma__seq__lines(begin, end, _p$4), false);
    }
  }
}
function _M0FPC15debug14print__content(r) {
  return _M0MPC15array5Array4joinGsE(r.lines, new _M0TPC16string10StringView(_M0FPC15debug14print__contentN7_2abindS1272, 0, _M0FPC15debug14print__contentN7_2abindS1272.length));
}
function _M0FPC15debug14with__resizing(_root_size, threshold, rendered_children) {
  if (threshold <= 0) {
    return rendered_children;
  } else {
    const compacted = _M0MPC15debug7Content7compact(rendered_children);
    return _M0MPC15array5Array3allGsE(compacted.lines, (line) => line.length <= threshold) ? compacted : rendered_children;
  }
}
function _M0MPC15debug4Repr17info__adds__depth(info) {
  let _tmp$38;
  switch (info.$tag) {
    case 12: {
      _tmp$38 = true;
      break;
    }
    case 13: {
      _tmp$38 = true;
      break;
    }
    case 16: {
      _tmp$38 = true;
      break;
    }
    default: {
      _tmp$38 = false;
    }
  }
  return !_tmp$38;
}
function _M0MPC15debug4Repr19prune__info_2einnerN2goS260(replacement, d, node) {
  const children = _M0MPC15debug4Repr8children(node);
  if (d <= 0) {
    if (children.length === 0) {
      return node;
    } else {
      if (!_M0MPC15debug4Repr17info__adds__depth(node)) {
        const _p$4 = new Array(children.length);
        const _p$5 = children.length;
        let _tmp$38 = 0;
        while (true) {
          const _p$6 = _tmp$38;
          if (_p$6 < _p$5) {
            const _p$7 = children[_p$6];
            _p$4[_p$6] = _M0MPC15debug4Repr19prune__info_2einnerN2goS260(replacement, d, _p$7);
            _tmp$38 = _p$6 + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        return _M0MPC15debug4Repr14with__children(node, _p$4);
      } else {
        return replacement;
      }
    }
  } else {
    if (children.length === 0) {
      return node;
    } else {
      const next_depth = _M0MPC15debug4Repr17info__adds__depth(node) ? d - 1 | 0 : d;
      const _p$4 = new Array(children.length);
      const _p$5 = children.length;
      let _tmp$38 = 0;
      while (true) {
        const _p$6 = _tmp$38;
        if (_p$6 < _p$5) {
          const _p$7 = children[_p$6];
          _p$4[_p$6] = _M0MPC15debug4Repr19prune__info_2einnerN2goS260(replacement, next_depth, _p$7);
          _tmp$38 = _p$6 + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return _M0MPC15debug4Repr14with__children(node, _p$4);
    }
  }
}
function _M0MPC15debug4Repr19prune__info_2einner(self, replacement, max_depth) {
  if (max_depth === undefined) {
    return self;
  } else {
    const _Some = max_depth;
    const _depth = _Some;
    const _p$4 = 1;
    return _M0MPC15debug4Repr19prune__info_2einnerN2goS260(replacement, _p$4 > _depth ? _p$4 : _depth, self);
  }
}
function _M0MPC15debug4Repr11prune__info(self, replacement$46$opt, max_depth) {
  let replacement;
  if (replacement$46$opt === undefined) {
    replacement = _M0DTPC15debug4Repr7Omitted__;
  } else {
    const _Some = replacement$46$opt;
    replacement = _Some;
  }
  return _M0MPC15debug4Repr19prune__info_2einner(self, replacement, max_depth);
}
function _M0FPC15debug10info__size(info) {
  switch (info.$tag) {
    case 0: {
      return 1;
    }
    case 1: {
      return 1;
    }
    case 2: {
      return 1;
    }
    case 3: {
      return 1;
    }
    case 4: {
      return 1;
    }
    case 5: {
      return 1;
    }
    case 6: {
      const _StringLit = info;
      const _s = _StringLit._0;
      return _s.length <= 15 ? 1 : 2;
    }
    case 7: {
      return 1;
    }
    case 8: {
      return 1;
    }
    case 9: {
      return 2;
    }
    case 12: {
      const _RecordField = info;
      const _name = _RecordField._0;
      return _name.length <= 15 ? 0 : 1;
    }
    case 13: {
      const _EnumLabeledArg = info;
      const _name$2 = _EnumLabeledArg._0;
      return _name$2.length <= 15 ? 0 : 1;
    }
    case 10: {
      const _Enum = info;
      const _name$3 = _Enum._0;
      return _name$3.length <= 15 ? 1 : 2;
    }
    case 14: {
      const _Opaque = info;
      const _name$4 = _Opaque._0;
      return _name$4.length <= 15 ? 1 : 2;
    }
    case 15: {
      const _Literal = info;
      const _s$2 = _Literal._0;
      return _s$2.length <= 15 ? 1 : 2;
    }
    case 11: {
      return 2;
    }
    case 16: {
      return 0;
    }
    default: {
      return 0;
    }
  }
}
function _M0FPC15debug17is__unquoted__key(key) {
  let rest;
  _L: {
    if (_M0MPC16string6String24char__length__ge_2einner(key, 1, 0, key.length)) {
      const _x = _M0MPC16string6String16unsafe__char__at(key, _M0MPC16string6String29offset__of__nth__char_2einner(key, 0, 0, key.length));
      if (_x >= 97 && _x <= 122) {
        const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(key, 1, 0, key.length);
        let _tmp$38;
        if (_bind$4 === undefined) {
          _tmp$38 = key.length;
        } else {
          const _Some = _bind$4;
          _tmp$38 = _Some;
        }
        const _x$2 = new _M0TPC16string10StringView(key, _tmp$38, key.length);
        rest = _x$2;
        break _L;
      } else {
        if (_x === 95) {
          const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(key, 1, 0, key.length);
          let _tmp$38;
          if (_bind$4 === undefined) {
            _tmp$38 = key.length;
          } else {
            const _Some = _bind$4;
            _tmp$38 = _Some;
          }
          const _x$2 = new _M0TPC16string10StringView(key, _tmp$38, key.length);
          rest = _x$2;
          break _L;
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  }
  let _tmp$38 = rest;
  while (true) {
    const rest$2 = _tmp$38;
    let rest$3;
    _L$2: {
      if (_M0MPC16string6String24char__length__ge_2einner(rest$2.str, 1, rest$2.start, rest$2.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(rest$2.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 0, rest$2.start, rest$2.end));
        if (_x >= 97 && _x <= 122) {
          const _tmp$39 = rest$2.str;
          const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 1, rest$2.start, rest$2.end);
          let _tmp$40;
          if (_bind$4 === undefined) {
            _tmp$40 = rest$2.end;
          } else {
            const _Some = _bind$4;
            _tmp$40 = _Some;
          }
          const _x$2 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, rest$2.end);
          rest$3 = _x$2;
          break _L$2;
        } else {
          if (_x >= 65 && _x <= 90) {
            const _tmp$39 = rest$2.str;
            const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 1, rest$2.start, rest$2.end);
            let _tmp$40;
            if (_bind$4 === undefined) {
              _tmp$40 = rest$2.end;
            } else {
              const _Some = _bind$4;
              _tmp$40 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, rest$2.end);
            rest$3 = _x$2;
            break _L$2;
          } else {
            if (_x >= 48 && _x <= 57) {
              const _tmp$39 = rest$2.str;
              const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 1, rest$2.start, rest$2.end);
              let _tmp$40;
              if (_bind$4 === undefined) {
                _tmp$40 = rest$2.end;
              } else {
                const _Some = _bind$4;
                _tmp$40 = _Some;
              }
              const _x$2 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, rest$2.end);
              rest$3 = _x$2;
              break _L$2;
            } else {
              if (_x === 95) {
                const _tmp$39 = rest$2.str;
                const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 1, rest$2.start, rest$2.end);
                let _tmp$40;
                if (_bind$4 === undefined) {
                  _tmp$40 = rest$2.end;
                } else {
                  const _Some = _bind$4;
                  _tmp$40 = _Some;
                }
                const _x$2 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, rest$2.end);
                rest$3 = _x$2;
                break _L$2;
              } else {
                return false;
              }
            }
          }
        }
      } else {
        return true;
      }
    }
    _tmp$38 = rest$3;
    continue;
  }
}
function _M0FPC15debug20pretty__print__label(name) {
  return _M0FPC15debug17is__unquoted__key(name) ? name : _M0MPC16string6String14escape_2einner(name, true);
}
function _M0MPC15debug4Repr13pretty__print(self, children) {
  switch (self.$tag) {
    case 0: {
      return _M0FPC15debug10comma__seq("(", ")", []);
    }
    case 1: {
      const _Integer = self;
      const _s = _Integer._0;
      let _tmp$38;
      if (_M0MPC16string6String24char__length__ge_2einner(_s, 1, 0, _s.length)) {
        const _x = _s.charCodeAt(0);
        if (_x === 45) {
          _tmp$38 = 1;
        } else {
          _tmp$38 = 0;
        }
      } else {
        _tmp$38 = 0;
      }
      return _M0FPC15debug10no__parens(_M0FPC15debug15content__parens(_tmp$38, [_s]));
    }
    case 2: {
      const _DoubleLit = self;
      const _x = _DoubleLit._0;
      const needs_parens = 1 / _x < 0;
      return _M0FPC15debug12leaf_2einner(String(_x), needs_parens);
    }
    case 3: {
      const _FloatLit = self;
      const _x$2 = _FloatLit._0;
      const needs_parens$2 = Math.fround(Math.fround(1) / _x$2) < Math.fround(0);
      return _M0FPC15debug12leaf_2einner(_M0IPC15float5FloatPB4Show10to__string(_x$2), needs_parens$2);
    }
    case 4: {
      const _BoolLit = self;
      const _x$3 = _BoolLit._0;
      return _M0FPC15debug12leaf_2einner(_x$3 ? "true" : "false", false);
    }
    case 5: {
      const _CharLit = self;
      const _x$4 = _CharLit._0;
      return _M0FPC15debug12leaf_2einner(_M0MPC14char4Char14escape_2einner(_x$4, true), false);
    }
    case 6: {
      const _StringLit = self;
      const _x$5 = _StringLit._0;
      return _M0FPC15debug10no__parens(_M0FPC15debug8verbatim(_M0MPC16string6String14escape_2einner(_x$5, true)));
    }
    case 7: {
      const _p$4 = new Array(children.length);
      const _p$5 = children.length;
      let _tmp$39 = 0;
      while (true) {
        const _p$6 = _tmp$39;
        if (_p$6 < _p$5) {
          const _p$7 = children[_p$6];
          _p$4[_p$6] = _M0MPC15debug7Content8no__wrap(_p$7);
          _tmp$39 = _p$6 + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return _M0FPC15debug10comma__seq("(", ")", _p$4);
    }
    case 10: {
      const _Enum = self;
      const _name = _Enum._0;
      if (children.length === 0) {
        return _M0FPC15debug10no__parens(_M0FPC15debug8verbatim(_name));
      } else {
        if (_name === "Tuple") {
          const _p$6 = new Array(children.length);
          const _p$7 = children.length;
          let _tmp$40 = 0;
          while (true) {
            const _p$8 = _tmp$40;
            if (_p$8 < _p$7) {
              const _p$9 = children[_p$8];
              _p$6[_p$8] = _M0MPC15debug7Content8no__wrap(_p$9);
              _tmp$40 = _p$8 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          return _M0FPC15debug10comma__seq("(", ")", _p$6);
        } else {
          const _tmp$40 = `${_name}(`;
          const _p$6 = new Array(children.length);
          const _p$7 = children.length;
          let _tmp$41 = 0;
          while (true) {
            const _p$8 = _tmp$41;
            if (_p$8 < _p$7) {
              const _p$9 = children[_p$8];
              _p$6[_p$8] = _M0MPC15debug7Content8no__wrap(_p$9);
              _tmp$41 = _p$8 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          return _M0FPC15debug10comma__seq(_tmp$40, ")", _p$6);
        }
      }
    }
    case 8: {
      const _p$6 = new Array(children.length);
      const _p$7 = children.length;
      let _tmp$40 = 0;
      while (true) {
        const _p$8 = _tmp$40;
        if (_p$8 < _p$7) {
          const _p$9 = children[_p$8];
          _p$6[_p$8] = _M0MPC15debug7Content8no__wrap(_p$9);
          _tmp$40 = _p$8 + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return _M0FPC15debug10comma__seq("[", "]", _p$6);
    }
    case 9: {
      const _p$8 = new Array(children.length);
      const _p$9 = children.length;
      let _tmp$41 = 0;
      while (true) {
        const _p$10 = _tmp$41;
        if (_p$10 < _p$9) {
          const _p$11 = children[_p$10];
          _p$8[_p$10] = _M0MPC15debug7Content8no__wrap(_p$11);
          _tmp$41 = _p$10 + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return _M0FPC15debug10comma__seq("{", "}", _p$8);
    }
    case 14: {
      const _Opaque = self;
      const _name$2 = _Opaque._0;
      if (children.length === 0) {
        return _M0FPC15debug10no__parens(_M0FPC15debug8surround("<", ">", _M0FPC15debug8verbatim(_name$2)));
      } else {
        const _tmp$42 = _M0FPC15debug8verbatim(`${_name$2}:`);
        const _p$10 = new Array(children.length);
        const _p$11 = children.length;
        let _tmp$43 = 0;
        while (true) {
          const _p$12 = _tmp$43;
          if (_p$12 < _p$11) {
            const _p$13 = children[_p$12];
            _p$10[_p$12] = _M0MPC15debug7Content8no__wrap(_p$13);
            _tmp$43 = _p$12 + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        const body = _M0IPC15debug13ContentParensPB3Add3add(_tmp$42, _M0FPC15debug6indent("  ", _M0MPC15debug7Content8no__wrap(_M0FPC15debug10comma__seq("", "", _p$10))));
        return _M0FPC15debug10no__parens(_M0FPC15debug8surround("<", ">", body));
      }
    }
    case 15: {
      const _Literal = self;
      const _str = _Literal._0;
      return _M0FPC15debug10no__parens(_M0FPC15debug8verbatim(_str));
    }
    case 11: {
      const _p$10 = new Array(children.length);
      const _p$11 = children.length;
      let _tmp$42 = 0;
      while (true) {
        const _p$12 = _tmp$42;
        if (_p$12 < _p$11) {
          const _p$13 = children[_p$12];
          _p$10[_p$12] = _M0MPC15debug7Content8no__wrap(_p$13);
          _tmp$42 = _p$12 + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return _M0FPC15debug10comma__seq("{", "}", _p$10);
    }
    case 16: {
      if (children.length === 2) {
        const _key = children[0];
        const _val = children[1];
        const k = _M0MPC15debug7Content8no__wrap(_key);
        const v = _M0MPC15debug7Content8no__wrap(_val);
        const _bind$4 = v.lines;
        if (_bind$4.length === 0) {
          return _M0FPC15debug14empty__content();
        } else {
          if (_bind$4.length === 1) {
            const _one = _bind$4[0];
            return _M0FPC15debug10no__parens(_M0FPC15debug15content__parens((1 + k.size | 0) + v.size | 0, [`${_M0FPC15debug14print__content(_M0FPC15debug8surround("", ": ", k))}${_one}`]));
          } else {
            const _first = _bind$4[0];
            const _x$6 = _M0MPC15array5Array12view_2einnerGsE(_bind$4, 1, _bind$4.length);
            const head = `${_M0FPC15debug14print__content(_M0FPC15debug8surround("", ": ", k))}${_first}`;
            const _tmp$43 = (1 + k.size | 0) + v.size | 0;
            const _self = [];
            _M0MPC15array5Array4pushGUssEE(_self, head);
            _M0MPC15array5Array10push__iterGsE(_self, _M0MPC15array9ArrayView4iterGsE(_x$6));
            return _M0FPC15debug10no__parens(_M0FPC15debug15content__parens(_tmp$43, _self));
          }
        }
      } else {
        return _M0FPC15debug14empty__content();
      }
    }
    case 13: {
      const _EnumLabeledArg = self;
      const _name$3 = _EnumLabeledArg._0;
      if (children.length === 1) {
        const _val = children[0];
        const _bind$4 = _val.lines;
        if (_bind$4.length === 0) {
          return _M0FPC15debug14empty__content();
        } else {
          if (_bind$4.length === 1) {
            const _first = _bind$4[0];
            return _M0FPC15debug10no__parens(_M0FPC15debug15content__parens(1 + _val.size | 0, [`${_name$3}=${_first}`]));
          } else {
            const _first = _bind$4[0];
            const _x$6 = _M0MPC15array5Array12view_2einnerGsE(_bind$4, 1, _bind$4.length);
            const _tmp$43 = 1 + _val.size | 0;
            const _self = [];
            _M0MPC15array5Array4pushGUssEE(_self, `${_name$3}=${_first}`);
            _M0MPC15array5Array10push__iterGsE(_self, _M0MPC15array9ArrayView4iterGsE(_x$6));
            return _M0FPC15debug10no__parens(_M0FPC15debug15content__parens(_tmp$43, _self));
          }
        }
      } else {
        return _M0FPC15debug14empty__content();
      }
    }
    case 12: {
      const _RecordField = self;
      const _name$4 = _RecordField._0;
      if (children.length === 1) {
        const _val = children[0];
        const label = _M0FPC15debug20pretty__print__label(_name$4);
        const v = _M0MPC15debug7Content8no__wrap(_val);
        const _bind$4 = v.lines;
        if (_bind$4.length === 0) {
          return _M0FPC15debug14empty__content();
        } else {
          if (_bind$4.length === 1) {
            const _one = _bind$4[0];
            return _M0FPC15debug10no__parens(_M0FPC15debug15content__parens(1 + v.size | 0, [`${label}: ${_one}`]));
          } else {
            const _first = _bind$4[0];
            const _x$6 = _M0MPC15array5Array12view_2einnerGsE(_bind$4, 1, _bind$4.length);
            const _tmp$43 = 1 + v.size | 0;
            const _self = [];
            _M0MPC15array5Array4pushGUssEE(_self, `${label}: ${_first}`);
            _M0MPC15array5Array10push__iterGsE(_self, _M0MPC15array9ArrayView4iterGsE(_x$6));
            return _M0FPC15debug10no__parens(_M0FPC15debug15content__parens(_tmp$43, _self));
          }
        }
      } else {
        return _M0FPC15debug14empty__content();
      }
    }
    default: {
      return _M0FPC15debug6parens(_M0FPC15debug8verbatim("..."));
    }
  }
}
function _M0MPC15debug4Repr12render__repr(self, threshold) {
  const label = _M0MPC15debug4Repr7shallow(self);
  const _p$4 = _M0MPC15debug4Repr8children(self);
  const _p$5 = new Array(_p$4.length);
  const _p$6 = _p$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _p$7 = _tmp$38;
    if (_p$7 < _p$6) {
      const _p$8 = _p$4[_p$7];
      _p$5[_p$7] = _M0MPC15debug4Repr12render__repr(_p$8, threshold);
      _tmp$38 = _p$7 + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const children = _p$5;
  return _M0FPC15debug14with__resizing(_M0FPC15debug10info__size(label), threshold, _M0MPC15debug4Repr13pretty__print(label, children));
}
function _M0FPC15debug6render(r, max_depth) {
  const max_depth$2 = max_depth === undefined ? _M0FPC15debug6renderN6constrS1711 : max_depth;
  const info = _M0MPC15debug4Repr11prune__info(r, undefined, max_depth$2);
  return _M0FPC15debug14print__content(_M0MPC15debug7Content8no__wrap(_M0MPC15debug4Repr12render__repr(info, 70)));
}
function _M0FPC15debug10to__stringGRP410Haoxincode8moonbash3lib3ast5TokenE(x) {
  return _M0FPC15debug6render(_M0IP410Haoxincode8moonbash3lib3ast5TokenPC15debug5Debug8to__repr(x), undefined);
}
function _M0IPC13int3IntPC15debug5Debug8to__repr(self) {
  const _p$4 = _M0MPC13int3Int18to__string_2einner(self, 10);
  return new _M0DTPC15debug4Repr7Integer(_p$4);
}
function _M0IPC15int645Int64PC15debug5Debug8to__repr(self) {
  const _p$4 = _M0MPC15int645Int6418to__string_2einner(self, 10);
  return new _M0DTPC15debug4Repr7Integer(_p$4);
}
function _M0IPC14bool4BoolPC15debug5Debug8to__repr(self) {
  return new _M0DTPC15debug4Repr7BoolLit(self);
}
function _M0IPC16string6StringPC15debug5Debug8to__repr(self) {
  return new _M0DTPC15debug4Repr9StringLit(self);
}
function _M0IPC15error5ErrorPB4Show10to__string(self) {
  return _M0FP15Error10to__string(self);
}
function _M0FPC13set8new__setGRPC16string10StringViewE(capacity) {
  const capacity$2 = _M0MPC13int3Int20next__power__of__two(capacity);
  const _bind$4 = capacity$2 - 1 | 0;
  const _bind$5 = (Math.imul(capacity$2, 13) | 0) / 16 | 0;
  const _bind$6 = $make_array_len_and_init(capacity$2, undefined);
  const _bind$7 = undefined;
  return new _M0TPC13set3SetGRPC16string10StringViewE(_bind$6, 0, capacity$2, _bind$4, _bind$5, _bind$7, -1);
}
function _M0FPC13set8new__setGiE(capacity) {
  const capacity$2 = _M0MPC13int3Int20next__power__of__two(capacity);
  const _bind$4 = capacity$2 - 1 | 0;
  const _bind$5 = (Math.imul(capacity$2, 13) | 0) / 16 | 0;
  const _bind$6 = $make_array_len_and_init(capacity$2, undefined);
  const _bind$7 = undefined;
  return new _M0TPC13set3SetGiE(_bind$6, 0, capacity$2, _bind$4, _bind$5, _bind$7, -1);
}
function _M0FPC13set21capacity__for__length(length) {
  let capacity = _M0MPC13int3Int20next__power__of__two(length);
  const _p$4 = capacity;
  if (length > ((Math.imul(_p$4, 13) | 0) / 16 | 0)) {
    capacity = Math.imul(capacity, 2) | 0;
  }
  return capacity;
}
function _M0MPC13set3Set20add__entry__to__tailGRPC16string10StringViewE(self, idx, entry) {
  const _bind$4 = self.tail;
  if (_bind$4 === -1) {
    self.head = entry;
  } else {
    const _tmp$38 = self.entries;
    $bound_check(_tmp$38, _bind$4);
    const _p$4 = _tmp$38[_bind$4];
    let _tmp$39;
    if (_p$4 === undefined) {
      _tmp$39 = $panic();
    } else {
      const _p$5 = _p$4;
      _tmp$39 = _p$5;
    }
    _tmp$39.next = entry;
  }
  self.tail = idx;
  const _tmp$38 = self.entries;
  $bound_check(_tmp$38, idx);
  _tmp$38[idx] = entry;
  self.size = self.size + 1 | 0;
}
function _M0MPC13set3Set20add__entry__to__tailGiE(self, idx, entry) {
  const _bind$4 = self.tail;
  if (_bind$4 === -1) {
    self.head = entry;
  } else {
    const _tmp$38 = self.entries;
    $bound_check(_tmp$38, _bind$4);
    const _p$4 = _tmp$38[_bind$4];
    let _tmp$39;
    if (_p$4 === undefined) {
      _tmp$39 = $panic();
    } else {
      const _p$5 = _p$4;
      _tmp$39 = _p$5;
    }
    _tmp$39.next = entry;
  }
  self.tail = idx;
  const _tmp$38 = self.entries;
  $bound_check(_tmp$38, idx);
  _tmp$38[idx] = entry;
  self.size = self.size + 1 | 0;
}
function _M0MPC13set3Set10set__entryGRPC16string10StringViewE(self, entry, new_idx) {
  const _tmp$38 = self.entries;
  $bound_check(_tmp$38, new_idx);
  _tmp$38[new_idx] = entry;
  const _bind$4 = entry.next;
  if (_bind$4 === undefined) {
    self.tail = new_idx;
    return;
  } else {
    const _Some = _bind$4;
    const _next = _Some;
    _next.prev = new_idx;
    return;
  }
}
function _M0MPC13set3Set10set__entryGiE(self, entry, new_idx) {
  const _tmp$38 = self.entries;
  $bound_check(_tmp$38, new_idx);
  _tmp$38[new_idx] = entry;
  const _bind$4 = entry.next;
  if (_bind$4 === undefined) {
    self.tail = new_idx;
    return;
  } else {
    const _Some = _bind$4;
    const _next = _Some;
    _next.prev = new_idx;
    return;
  }
}
function _M0MPC13set3Set10push__awayGRPC16string10StringViewE(self, idx, entry) {
  let _tmp$38 = entry.psl + 1 | 0;
  let _tmp$39 = idx + 1 & self.capacity_mask;
  let _tmp$40 = entry;
  while (true) {
    const psl = _tmp$38;
    const idx$2 = _tmp$39;
    const entry$2 = _tmp$40;
    const _tmp$41 = self.entries;
    $bound_check(_tmp$41, idx$2);
    const _bind$4 = _tmp$41[idx$2];
    if (_bind$4 === undefined) {
      entry$2.psl = psl;
      _M0MPC13set3Set10set__entryGRPC16string10StringViewE(self, entry$2, idx$2);
      return;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (psl > _curr_entry.psl) {
        entry$2.psl = psl;
        _M0MPC13set3Set10set__entryGRPC16string10StringViewE(self, entry$2, idx$2);
        _tmp$38 = _curr_entry.psl + 1 | 0;
        _tmp$39 = idx$2 + 1 & self.capacity_mask;
        _tmp$40 = _curr_entry;
        continue;
      } else {
        _tmp$38 = psl + 1 | 0;
        _tmp$39 = idx$2 + 1 & self.capacity_mask;
        continue;
      }
    }
  }
}
function _M0MPC13set3Set10push__awayGiE(self, idx, entry) {
  let _tmp$38 = entry.psl + 1 | 0;
  let _tmp$39 = idx + 1 & self.capacity_mask;
  let _tmp$40 = entry;
  while (true) {
    const psl = _tmp$38;
    const idx$2 = _tmp$39;
    const entry$2 = _tmp$40;
    const _tmp$41 = self.entries;
    $bound_check(_tmp$41, idx$2);
    const _bind$4 = _tmp$41[idx$2];
    if (_bind$4 === undefined) {
      entry$2.psl = psl;
      _M0MPC13set3Set10set__entryGiE(self, entry$2, idx$2);
      return;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (psl > _curr_entry.psl) {
        entry$2.psl = psl;
        _M0MPC13set3Set10set__entryGiE(self, entry$2, idx$2);
        _tmp$38 = _curr_entry.psl + 1 | 0;
        _tmp$39 = idx$2 + 1 & self.capacity_mask;
        _tmp$40 = _curr_entry;
        continue;
      } else {
        _tmp$38 = psl + 1 | 0;
        _tmp$39 = idx$2 + 1 & self.capacity_mask;
        continue;
      }
    }
  }
}
function _M0MPC13set3Set15add__with__hashGRPC16string10StringViewE(self, key, hash) {
  if (self.size >= self.grow_at) {
    _M0MPC13set3Set4growGRPC16string10StringViewE(self);
  }
  let idx;
  let psl;
  _L: {
    let _tmp$38 = 0;
    let _tmp$39 = hash & self.capacity_mask;
    while (true) {
      const psl$2 = _tmp$38;
      const idx$2 = _tmp$39;
      const _tmp$40 = self.entries;
      $bound_check(_tmp$40, idx$2);
      const _bind$4 = _tmp$40[idx$2];
      if (_bind$4 === undefined) {
        idx = idx$2;
        psl = psl$2;
        break _L;
      } else {
        const _Some = _bind$4;
        const _curr_entry = _Some;
        if (_curr_entry.hash === hash && _M0IPC16string10StringViewPB2Eq5equal(_curr_entry.key, key)) {
          return undefined;
        }
        if (psl$2 > _curr_entry.psl) {
          _M0MPC13set3Set10push__awayGRPC16string10StringViewE(self, idx$2, _curr_entry);
          idx = idx$2;
          psl = psl$2;
          break _L;
        }
        _tmp$38 = psl$2 + 1 | 0;
        _tmp$39 = idx$2 + 1 & self.capacity_mask;
        continue;
      }
    }
  }
  const _bind$4 = self.tail;
  const _bind$5 = undefined;
  const entry = new _M0TPC13set5EntryGRPC16string10StringViewE(_bind$4, _bind$5, psl, hash, key);
  _M0MPC13set3Set20add__entry__to__tailGRPC16string10StringViewE(self, idx, entry);
}
function _M0MPC13set3Set15add__with__hashGiE(self, key, hash) {
  if (self.size >= self.grow_at) {
    _M0MPC13set3Set4growGiE(self);
  }
  let idx;
  let psl;
  _L: {
    let _tmp$38 = 0;
    let _tmp$39 = hash & self.capacity_mask;
    while (true) {
      const psl$2 = _tmp$38;
      const idx$2 = _tmp$39;
      const _tmp$40 = self.entries;
      $bound_check(_tmp$40, idx$2);
      const _bind$4 = _tmp$40[idx$2];
      if (_bind$4 === undefined) {
        idx = idx$2;
        psl = psl$2;
        break _L;
      } else {
        const _Some = _bind$4;
        const _curr_entry = _Some;
        if (_curr_entry.hash === hash && _curr_entry.key === key) {
          return undefined;
        }
        if (psl$2 > _curr_entry.psl) {
          _M0MPC13set3Set10push__awayGiE(self, idx$2, _curr_entry);
          idx = idx$2;
          psl = psl$2;
          break _L;
        }
        _tmp$38 = psl$2 + 1 | 0;
        _tmp$39 = idx$2 + 1 & self.capacity_mask;
        continue;
      }
    }
  }
  const _bind$4 = self.tail;
  const _bind$5 = undefined;
  const entry = new _M0TPC13set5EntryGiE(_bind$4, _bind$5, psl, hash, key);
  _M0MPC13set3Set20add__entry__to__tailGiE(self, idx, entry);
}
function _M0MPC13set3Set4growGRPC16string10StringViewE(self) {
  const old_head = self.head;
  const new_capacity = self.capacity << 1;
  self.entries = $make_array_len_and_init(new_capacity, undefined);
  self.capacity = new_capacity;
  self.capacity_mask = new_capacity - 1 | 0;
  const _p$4 = self.capacity;
  self.grow_at = (Math.imul(_p$4, 13) | 0) / 16 | 0;
  self.size = 0;
  self.head = undefined;
  self.tail = -1;
  let _tmp$38 = old_head;
  while (true) {
    const x = _tmp$38;
    if (x === undefined) {
      return;
    } else {
      const _Some = x;
      const _x = _Some;
      const _next = _x.next;
      const _key = _x.key;
      const _hash = _x.hash;
      _M0MPC13set3Set15add__with__hashGRPC16string10StringViewE(self, _key, _hash);
      _tmp$38 = _next;
      continue;
    }
  }
}
function _M0MPC13set3Set4growGiE(self) {
  const old_head = self.head;
  const new_capacity = self.capacity << 1;
  self.entries = $make_array_len_and_init(new_capacity, undefined);
  self.capacity = new_capacity;
  self.capacity_mask = new_capacity - 1 | 0;
  const _p$4 = self.capacity;
  self.grow_at = (Math.imul(_p$4, 13) | 0) / 16 | 0;
  self.size = 0;
  self.head = undefined;
  self.tail = -1;
  let _tmp$38 = old_head;
  while (true) {
    const x = _tmp$38;
    if (x === undefined) {
      return;
    } else {
      const _Some = x;
      const _x = _Some;
      const _next = _x.next;
      const _key = _x.key;
      const _hash = _x.hash;
      _M0MPC13set3Set15add__with__hashGiE(self, _key, _hash);
      _tmp$38 = _next;
      continue;
    }
  }
}
function _M0MPC13set3Set3addGRPC16string10StringViewE(self, key) {
  _M0MPC13set3Set15add__with__hashGRPC16string10StringViewE(self, key, _M0IP016_24default__implPB4Hash4hashGRPC16string10StringViewE(key));
}
function _M0MPC13set3Set3addGiE(self, key) {
  _M0MPC13set3Set15add__with__hashGiE(self, key, _M0IP016_24default__implPB4Hash4hashGiE(key));
}
function _M0MPC13set3Set3SetGRPC16string10StringViewE(arr, capacity) {
  const length = arr.end - arr.start | 0;
  let capacity$2;
  if (capacity === undefined) {
    capacity$2 = length === 0 ? 8 : _M0FPC13set21capacity__for__length(length);
  } else {
    const _Some = capacity;
    const _capacity = _Some;
    const _p$4 = _M0FPC13set21capacity__for__length(length);
    capacity$2 = _capacity > _p$4 ? _capacity : _p$4;
  }
  const m = _M0FPC13set8new__setGRPC16string10StringViewE(capacity$2);
  const _bind$4 = arr.end - arr.start | 0;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const e = arr.buf[arr.start + _ | 0];
      _M0MPC13set3Set3addGRPC16string10StringViewE(m, e);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return m;
}
function _M0MPC13set3Set8containsGRPC16string10StringViewE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGRPC16string10StringViewE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return false;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _M0IPC16string10StringViewPB2Eq5equal(_entry.key, key)) {
        return true;
      }
      if (i > _entry.psl) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPC13set3Set8containsGiE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGiE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return false;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return true;
      }
      if (i > _entry.psl) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPC13set3Set13remove__entryGiE(self, entry) {
  const _bind$4 = entry.prev;
  if (_bind$4 === -1) {
    self.head = entry.next;
  } else {
    const _tmp$38 = self.entries;
    $bound_check(_tmp$38, _bind$4);
    const _p$4 = _tmp$38[_bind$4];
    let _tmp$39;
    if (_p$4 === undefined) {
      _tmp$39 = $panic();
    } else {
      const _p$5 = _p$4;
      _tmp$39 = _p$5;
    }
    _tmp$39.next = entry.next;
  }
  const _bind$5 = entry.next;
  if (_bind$5 === undefined) {
    self.tail = entry.prev;
    return;
  } else {
    const _Some = _bind$5;
    const _next = _Some;
    _next.prev = entry.prev;
    return;
  }
}
function _M0MPC13set3Set11shift__backGiE(self, idx) {
  let _tmp$38 = idx;
  while (true) {
    const cur = _tmp$38;
    const next = cur + 1 & self.capacity_mask;
    _L: {
      const _tmp$39 = self.entries;
      $bound_check(_tmp$39, next);
      const _bind$4 = _tmp$39[next];
      if (_bind$4 === undefined) {
        break _L;
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        const _x$2 = _x.psl;
        if (_x$2 === 0) {
          break _L;
        } else {
          _x.psl = _x.psl - 1 | 0;
          _M0MPC13set3Set10set__entryGiE(self, _x, cur);
          _tmp$38 = next;
          continue;
        }
      }
    }
    const _tmp$39 = self.entries;
    $bound_check(_tmp$39, cur);
    _tmp$39[cur] = undefined;
    return;
  }
}
function _M0MPC13set3Set6removeGiE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGiE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        _M0MPC13set3Set13remove__entryGiE(self, _entry);
        _M0MPC13set3Set11shift__backGiE(self, idx);
        self.size = self.size - 1 | 0;
        return;
      }
      if (i > _entry.psl) {
        return;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPC13set3Set11new_2einnerGiE(capacity) {
  return _M0FPC13set8new__setGiE(capacity);
}
function _M0MPC13set3Set3newGiE(capacity$46$opt) {
  let capacity;
  if (capacity$46$opt === undefined) {
    capacity = 8;
  } else {
    const _Some = capacity$46$opt;
    capacity = _Some;
  }
  return _M0MPC13set3Set11new_2einnerGiE(capacity);
}
function _M0FPC28internal7strconv9base__errGUiRPC16string10StringViewbEE() {
  return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPB7FailureE3Err(new _M0DTPC15error5Error48moonbitlang_2fcore_2fbuiltin_2eFailure_2eFailure(_M0FPC28internal7strconv14base__err__str));
}
function _M0FPC28internal7strconv25check__and__consume__base(view, base) {
  if (base === 0) {
    _L: {
      let rest;
      _L$2: {
        let rest$2;
        _L$3: {
          let rest$3;
          _L$4: {
            if (_M0MPC16string6String24char__length__ge_2einner(view.str, 2, view.start, view.end)) {
              const _x = _M0MPC16string6String16unsafe__char__at(view.str, _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 0, view.start, view.end));
              if (_x === 48) {
                const _x$2 = _M0MPC16string6String16unsafe__char__at(view.str, _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 1, view.start, view.end));
                switch (_x$2) {
                  case 120: {
                    const _tmp$38 = view.str;
                    const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$39;
                    if (_bind$4 === undefined) {
                      _tmp$39 = view.end;
                    } else {
                      const _Some = _bind$4;
                      _tmp$39 = _Some;
                    }
                    const _x$3 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, view.end);
                    rest$3 = _x$3;
                    break _L$4;
                  }
                  case 88: {
                    const _tmp$40 = view.str;
                    const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$41;
                    if (_bind$5 === undefined) {
                      _tmp$41 = view.end;
                    } else {
                      const _Some = _bind$5;
                      _tmp$41 = _Some;
                    }
                    const _x$4 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, view.end);
                    rest$3 = _x$4;
                    break _L$4;
                  }
                  case 111: {
                    const _tmp$42 = view.str;
                    const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$43;
                    if (_bind$6 === undefined) {
                      _tmp$43 = view.end;
                    } else {
                      const _Some = _bind$6;
                      _tmp$43 = _Some;
                    }
                    const _x$5 = new _M0TPC16string10StringView(_tmp$42, _tmp$43, view.end);
                    rest$2 = _x$5;
                    break _L$3;
                  }
                  case 79: {
                    const _tmp$44 = view.str;
                    const _bind$7 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$45;
                    if (_bind$7 === undefined) {
                      _tmp$45 = view.end;
                    } else {
                      const _Some = _bind$7;
                      _tmp$45 = _Some;
                    }
                    const _x$6 = new _M0TPC16string10StringView(_tmp$44, _tmp$45, view.end);
                    rest$2 = _x$6;
                    break _L$3;
                  }
                  case 98: {
                    const _tmp$46 = view.str;
                    const _bind$8 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$47;
                    if (_bind$8 === undefined) {
                      _tmp$47 = view.end;
                    } else {
                      const _Some = _bind$8;
                      _tmp$47 = _Some;
                    }
                    const _x$7 = new _M0TPC16string10StringView(_tmp$46, _tmp$47, view.end);
                    rest = _x$7;
                    break _L$2;
                  }
                  case 66: {
                    const _tmp$48 = view.str;
                    const _bind$9 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$49;
                    if (_bind$9 === undefined) {
                      _tmp$49 = view.end;
                    } else {
                      const _Some = _bind$9;
                      _tmp$49 = _Some;
                    }
                    const _x$8 = new _M0TPC16string10StringView(_tmp$48, _tmp$49, view.end);
                    rest = _x$8;
                    break _L$2;
                  }
                  default: {
                    break _L;
                  }
                }
              } else {
                break _L;
              }
            } else {
              break _L;
            }
          }
          return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE2Ok({ _0: 16, _1: rest$3, _2: true });
        }
        return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE2Ok({ _0: 8, _1: rest$2, _2: true });
      }
      return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE2Ok({ _0: 2, _1: rest, _2: true });
    }
    return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE2Ok({ _0: 10, _1: view, _2: false });
  } else {
    _L: {
      let rest;
      _L$2: {
        let rest$2;
        _L$3: {
          let rest$3;
          _L$4: {
            if (_M0MPC16string6String24char__length__ge_2einner(view.str, 2, view.start, view.end)) {
              const _x = _M0MPC16string6String16unsafe__char__at(view.str, _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 0, view.start, view.end));
              if (_x === 48) {
                const _x$2 = _M0MPC16string6String16unsafe__char__at(view.str, _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 1, view.start, view.end));
                switch (_x$2) {
                  case 120: {
                    const _tmp$38 = view.str;
                    const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$39;
                    if (_bind$4 === undefined) {
                      _tmp$39 = view.end;
                    } else {
                      const _Some = _bind$4;
                      _tmp$39 = _Some;
                    }
                    const _x$3 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, view.end);
                    if (base === 16) {
                      rest$3 = _x$3;
                      break _L$4;
                    } else {
                      break _L;
                    }
                  }
                  case 88: {
                    const _tmp$40 = view.str;
                    const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$41;
                    if (_bind$5 === undefined) {
                      _tmp$41 = view.end;
                    } else {
                      const _Some = _bind$5;
                      _tmp$41 = _Some;
                    }
                    const _x$4 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, view.end);
                    if (base === 16) {
                      rest$3 = _x$4;
                      break _L$4;
                    } else {
                      break _L;
                    }
                  }
                  case 111: {
                    const _tmp$42 = view.str;
                    const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$43;
                    if (_bind$6 === undefined) {
                      _tmp$43 = view.end;
                    } else {
                      const _Some = _bind$6;
                      _tmp$43 = _Some;
                    }
                    const _x$5 = new _M0TPC16string10StringView(_tmp$42, _tmp$43, view.end);
                    if (base === 8) {
                      rest$2 = _x$5;
                      break _L$3;
                    } else {
                      break _L;
                    }
                  }
                  case 79: {
                    const _tmp$44 = view.str;
                    const _bind$7 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$45;
                    if (_bind$7 === undefined) {
                      _tmp$45 = view.end;
                    } else {
                      const _Some = _bind$7;
                      _tmp$45 = _Some;
                    }
                    const _x$6 = new _M0TPC16string10StringView(_tmp$44, _tmp$45, view.end);
                    if (base === 8) {
                      rest$2 = _x$6;
                      break _L$3;
                    } else {
                      break _L;
                    }
                  }
                  case 98: {
                    const _tmp$46 = view.str;
                    const _bind$8 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$47;
                    if (_bind$8 === undefined) {
                      _tmp$47 = view.end;
                    } else {
                      const _Some = _bind$8;
                      _tmp$47 = _Some;
                    }
                    const _x$7 = new _M0TPC16string10StringView(_tmp$46, _tmp$47, view.end);
                    if (base === 2) {
                      rest = _x$7;
                      break _L$2;
                    } else {
                      break _L;
                    }
                  }
                  case 66: {
                    const _tmp$48 = view.str;
                    const _bind$9 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$49;
                    if (_bind$9 === undefined) {
                      _tmp$49 = view.end;
                    } else {
                      const _Some = _bind$9;
                      _tmp$49 = _Some;
                    }
                    const _x$8 = new _M0TPC16string10StringView(_tmp$48, _tmp$49, view.end);
                    if (base === 2) {
                      rest = _x$8;
                      break _L$2;
                    } else {
                      break _L;
                    }
                  }
                  default: {
                    break _L;
                  }
                }
              } else {
                break _L;
              }
            } else {
              break _L;
            }
          }
          return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE2Ok({ _0: 16, _1: rest$3, _2: true });
        }
        return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE2Ok({ _0: 8, _1: rest$2, _2: true });
      }
      return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE2Ok({ _0: 2, _1: rest, _2: true });
    }
    return base >= 2 && base <= 36 ? new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE2Ok({ _0: base, _1: view, _2: false }) : _M0FPC28internal7strconv9base__errGUiRPC16string10StringViewbEE();
  }
}
function _M0FPC28internal7strconv10range__errGuE() {
  return new _M0DTPC16result6ResultGuRPB7FailureE3Err(new _M0DTPC15error5Error48moonbitlang_2fcore_2fbuiltin_2eFailure_2eFailure(_M0FPC28internal7strconv15range__err__str));
}
function _M0FPC28internal7strconv11syntax__errGiE() {
  return new _M0DTPC16result6ResultGiRPB7FailureE3Err(new _M0DTPC15error5Error48moonbitlang_2fcore_2fbuiltin_2eFailure_2eFailure(_M0FPC28internal7strconv16syntax__err__str));
}
function _M0FPC28internal7strconv11syntax__errGuE() {
  return new _M0DTPC16result6ResultGuRPB7FailureE3Err(new _M0DTPC15error5Error48moonbitlang_2fcore_2fbuiltin_2eFailure_2eFailure(_M0FPC28internal7strconv16syntax__err__str));
}
function _M0FPC28internal7strconv11syntax__errGlE() {
  return new _M0DTPC16result6ResultGlRPB7FailureE3Err(new _M0DTPC15error5Error48moonbitlang_2fcore_2fbuiltin_2eFailure_2eFailure(_M0FPC28internal7strconv16syntax__err__str));
}
function _M0FPC28internal7strconv11syntax__errGdE() {
  return new _M0DTPC16result6ResultGdRPB7FailureE3Err(new _M0DTPC15error5Error48moonbitlang_2fcore_2fbuiltin_2eFailure_2eFailure(_M0FPC28internal7strconv16syntax__err__str));
}
function _M0FPC28internal7strconv11syntax__errGORPC28internal7strconv6NumberE() {
  return new _M0DTPC16result6ResultGORPC28internal7strconv6NumberRPB7FailureE3Err(new _M0DTPC15error5Error48moonbitlang_2fcore_2fbuiltin_2eFailure_2eFailure(_M0FPC28internal7strconv16syntax__err__str));
}
function _M0EPC16string10StringViewPC28internal7strconv12fold__digitsGmE(self, init, f) {
  let ret = init;
  let len = 0;
  let str = self;
  while (true) {
    const _bind$4 = str;
    if (_M0MPC16string6String24char__length__ge_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end)) {
      const _ch = _M0MPC16string6String16unsafe__char__at(_bind$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 0, _bind$4.start, _bind$4.end));
      const _tmp$38 = _bind$4.str;
      const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
      let _tmp$39;
      if (_bind$5 === undefined) {
        _tmp$39 = _bind$4.end;
      } else {
        const _Some = _bind$5;
        _tmp$39 = _Some;
      }
      const _x = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$4.end);
      if (_ch >= 48 && _ch <= 57) {
        len = len + 1 | 0;
        ret = f(_ch - 48 | 0, ret);
      } else {
        if (_ch !== 95) {
          break;
        }
      }
      str = _x;
      continue;
    } else {
      break;
    }
  }
  return { _0: str, _1: ret, _2: len };
}
function _M0FPC28internal7strconv13parse__digits(s, x) {
  return _M0EPC16string10StringViewPC28internal7strconv12fold__digitsGmE(s, x, (digit, acc) => BigInt.asUintN(64, BigInt.asUintN(64, acc * 10n) + BigInt.asUintN(64, BigInt(digit >>> 0))));
}
function _M0FPC28internal7strconv20try__parse__19digits(s, x) {
  let x$2 = x;
  let len = 0;
  let _tmp$38 = s;
  while (true) {
    const s$2 = _tmp$38;
    let s$3;
    _L: {
      if (_M0MPC16string6String24char__length__ge_2einner(s$2.str, 1, s$2.start, s$2.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(s$2.str, _M0MPC16string6String29offset__of__nth__char_2einner(s$2.str, 0, s$2.start, s$2.end));
        if (_x >= 48 && _x <= 57) {
          const _tmp$39 = s$2.str;
          const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(s$2.str, 1, s$2.start, s$2.end);
          let _tmp$40;
          if (_bind$4 === undefined) {
            _tmp$40 = s$2.end;
          } else {
            const _Some = _bind$4;
            _tmp$40 = _Some;
          }
          const _x$2 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, s$2.end);
          if (BigInt.asUintN(64, x$2) < BigInt.asUintN(64, _M0FPC28internal7strconv17min__19digit__int)) {
            len = len + 1 | 0;
            x$2 = BigInt.asUintN(64, BigInt.asUintN(64, x$2 * 10n) + BigInt.asUintN(64, BigInt((_x - 48 | 0) >>> 0)));
            _tmp$38 = _x$2;
            continue;
          } else {
            s$3 = s$2;
            break _L;
          }
        } else {
          if (_x === 95) {
            const _tmp$39 = s$2.str;
            const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(s$2.str, 1, s$2.start, s$2.end);
            let _tmp$40;
            if (_bind$4 === undefined) {
              _tmp$40 = s$2.end;
            } else {
              const _Some = _bind$4;
              _tmp$40 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, s$2.end);
            _tmp$38 = _x$2;
            continue;
          } else {
            s$3 = s$2;
            break _L;
          }
        }
      } else {
        s$3 = s$2;
        break _L;
      }
    }
    return { _0: s$3, _1: x$2, _2: len };
  }
}
function _M0FPC28internal7strconv17parse__scientific(s) {
  let s$2 = s;
  let neg_exp = false;
  let rest;
  let ch;
  _L: {
    _L$2: {
      const _bind$4 = s$2;
      if (_M0MPC16string6String24char__length__ge_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(_bind$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 0, _bind$4.start, _bind$4.end));
        switch (_x) {
          case 43: {
            const _tmp$38 = _bind$4.str;
            const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
            let _tmp$39;
            if (_bind$5 === undefined) {
              _tmp$39 = _bind$4.end;
            } else {
              const _Some = _bind$5;
              _tmp$39 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$4.end);
            rest = _x$2;
            ch = _x;
            break _L$2;
          }
          case 45: {
            const _tmp$40 = _bind$4.str;
            const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
            let _tmp$41;
            if (_bind$6 === undefined) {
              _tmp$41 = _bind$4.end;
            } else {
              const _Some = _bind$6;
              _tmp$41 = _Some;
            }
            const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, _bind$4.end);
            rest = _x$3;
            ch = _x;
            break _L$2;
          }
        }
      }
      break _L;
    }
    neg_exp = ch === 45;
    s$2 = rest;
  }
  _L$2: {
    const _bind$4 = s$2;
    if (_M0MPC16string6String24char__length__ge_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end)) {
      const _x = _M0MPC16string6String16unsafe__char__at(_bind$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 0, _bind$4.start, _bind$4.end));
      if (_x >= 48 && _x <= 57) {
        const _bind$5 = _M0EPC16string10StringViewPC28internal7strconv12fold__digitsGmE(s$2, _M0FPC28internal7strconv17parse__scientificN8exp__numS241, (digit, exp_num) => BigInt.asIntN(64, exp_num) < BigInt.asIntN(64, 65536n) ? BigInt.asUintN(64, BigInt.asUintN(64, 10n * exp_num) + BigInt.asUintN(64, BigInt(digit))) : exp_num);
        const _s = _bind$5._0;
        const _exp_num = _bind$5._1;
        return neg_exp ? { _0: _s, _1: BigInt.asUintN(64, -_exp_num) } : { _0: _s, _1: _exp_num };
      } else {
        break _L$2;
      }
    } else {
      break _L$2;
    }
  }
  return undefined;
}
function _M0FPC28internal7strconv13parse__number(s) {
  let s$2;
  let negative;
  _L: {
    let rest;
    _L$2: {
      if (_M0MPC16string6String24char__length__ge_2einner(s.str, 1, s.start, s.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(s.str, _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 0, s.start, s.end));
        switch (_x) {
          case 45: {
            const _tmp$38 = s.str;
            const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 1, s.start, s.end);
            let _tmp$39;
            if (_bind$4 === undefined) {
              _tmp$39 = s.end;
            } else {
              const _Some = _bind$4;
              _tmp$39 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, s.end);
            s$2 = _x$2;
            negative = true;
            break _L;
          }
          case 43: {
            const _tmp$40 = s.str;
            const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 1, s.start, s.end);
            let _tmp$41;
            if (_bind$5 === undefined) {
              _tmp$41 = s.end;
            } else {
              const _Some = _bind$5;
              _tmp$41 = _Some;
            }
            const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, s.end);
            rest = _x$3;
            break _L$2;
          }
          default: {
            rest = s;
            break _L$2;
          }
        }
      } else {
        rest = s;
        break _L$2;
      }
    }
    s$2 = rest;
    negative = false;
    break _L;
  }
  if (_M0MPC16string10StringView9is__empty(s$2)) {
    return new _M0DTPC16result6ResultGORPC28internal7strconv6NumberRPC15error5ErrorE2Ok(undefined);
  }
  const _bind$4 = _M0FPC28internal7strconv13parse__digits(s$2, 0n);
  const _s = _bind$4._0;
  const _mantissa = _bind$4._1;
  const _consumed = _bind$4._2;
  let mantissa = _mantissa;
  let s$3 = _s;
  let n_digits = _consumed;
  let n_after_dot = 0;
  let exponent = 0n;
  const _bind$5 = s$3;
  if (_M0MPC16string6String24char__length__ge_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end)) {
    const _x = _M0MPC16string6String16unsafe__char__at(_bind$5.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 0, _bind$5.start, _bind$5.end));
    if (_x === 46) {
      const _tmp$38 = _bind$5.str;
      const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end);
      let _tmp$39;
      if (_bind$6 === undefined) {
        _tmp$39 = _bind$5.end;
      } else {
        const _Some = _bind$6;
        _tmp$39 = _Some;
      }
      const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$5.end);
      s$3 = _x$2;
      const _bind$7 = _M0FPC28internal7strconv13parse__digits(s$3, mantissa);
      const _new_s = _bind$7._0;
      const _new_mantissa = _bind$7._1;
      const _consumed_digit = _bind$7._2;
      s$3 = _new_s;
      mantissa = _new_mantissa;
      n_after_dot = _consumed_digit;
      exponent = BigInt.asUintN(64, -BigInt.asUintN(64, BigInt(n_after_dot)));
    }
  }
  n_digits = n_digits + n_after_dot | 0;
  if (n_digits === 0) {
    return new _M0DTPC16result6ResultGORPC28internal7strconv6NumberRPC15error5ErrorE2Ok(undefined);
  }
  let rest;
  _L$2: {
    _L$3: {
      const _bind$6 = s$3;
      if (_M0MPC16string6String24char__length__ge_2einner(_bind$6.str, 1, _bind$6.start, _bind$6.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(_bind$6.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6.str, 0, _bind$6.start, _bind$6.end));
        switch (_x) {
          case 101: {
            const _tmp$38 = _bind$6.str;
            const _bind$7 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6.str, 1, _bind$6.start, _bind$6.end);
            let _tmp$39;
            if (_bind$7 === undefined) {
              _tmp$39 = _bind$6.end;
            } else {
              const _Some = _bind$7;
              _tmp$39 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$6.end);
            rest = _x$2;
            break _L$3;
          }
          case 69: {
            const _tmp$40 = _bind$6.str;
            const _bind$8 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6.str, 1, _bind$6.start, _bind$6.end);
            let _tmp$41;
            if (_bind$8 === undefined) {
              _tmp$41 = _bind$6.end;
            } else {
              const _Some = _bind$8;
              _tmp$41 = _Some;
            }
            const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, _bind$6.end);
            rest = _x$3;
            break _L$3;
          }
        }
      }
      break _L$2;
    }
    const _bind$6 = _M0FPC28internal7strconv17parse__scientific(rest);
    let _bind$7;
    if (_bind$6 === undefined) {
      return new _M0DTPC16result6ResultGORPC28internal7strconv6NumberRPC15error5ErrorE2Ok(undefined);
    } else {
      const _Some = _bind$6;
      _bind$7 = _Some;
    }
    const _new_s = _bind$7._0;
    const _exp_number = _bind$7._1;
    s$3 = _new_s;
    exponent = BigInt.asUintN(64, exponent + _exp_number);
  }
  const _bind$6 = s$3;
  if (_M0MPC16string6String24char__length__eq_2einner(_bind$6.str, 0, _bind$6.start, _bind$6.end)) {
    if (n_digits <= 19) {
      return new _M0DTPC16result6ResultGORPC28internal7strconv6NumberRPC15error5ErrorE2Ok(new _M0TPC28internal7strconv6Number(exponent, mantissa, negative, false));
    }
    n_digits = n_digits - 19 | 0;
    let many_digits = false;
    let _tmp$38 = s;
    while (true) {
      const s$4 = _tmp$38;
      _L$3: {
        let rest$2;
        let ch;
        _L$4: {
          if (_M0MPC16string6String24char__length__ge_2einner(s$4.str, 1, s$4.start, s$4.end)) {
            const _x = _M0MPC16string6String16unsafe__char__at(s$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(s$4.str, 0, s$4.start, s$4.end));
            switch (_x) {
              case 48: {
                const _tmp$39 = s$4.str;
                const _bind$7 = _M0MPC16string6String29offset__of__nth__char_2einner(s$4.str, 1, s$4.start, s$4.end);
                let _tmp$40;
                if (_bind$7 === undefined) {
                  _tmp$40 = s$4.end;
                } else {
                  const _Some = _bind$7;
                  _tmp$40 = _Some;
                }
                const _x$2 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, s$4.end);
                rest$2 = _x$2;
                ch = _x;
                break _L$4;
              }
              case 46: {
                const _tmp$41 = s$4.str;
                const _bind$8 = _M0MPC16string6String29offset__of__nth__char_2einner(s$4.str, 1, s$4.start, s$4.end);
                let _tmp$42;
                if (_bind$8 === undefined) {
                  _tmp$42 = s$4.end;
                } else {
                  const _Some = _bind$8;
                  _tmp$42 = _Some;
                }
                const _x$3 = new _M0TPC16string10StringView(_tmp$41, _tmp$42, s$4.end);
                rest$2 = _x$3;
                ch = _x;
                break _L$4;
              }
              default: {
                break _L$3;
              }
            }
          } else {
            break _L$3;
          }
        }
        n_digits = n_digits - ((ch - 46 | 0) / 2 | 0) | 0;
        _tmp$38 = rest$2;
        continue;
      }
      break;
    }
    let mantissa$2 = mantissa;
    if (n_digits > 0) {
      many_digits = true;
      mantissa$2 = 0n;
      const _bind$7 = _M0FPC28internal7strconv20try__parse__19digits(s, mantissa$2);
      const _s$2 = _bind$7._0;
      const _new_mantissa = _bind$7._1;
      const _consumed_digit = _bind$7._2;
      mantissa$2 = _new_mantissa;
      let _tmp$39;
      if (BigInt.asUintN(64, mantissa$2) >= BigInt.asUintN(64, _M0FPC28internal7strconv17min__19digit__int)) {
        _tmp$39 = _consumed_digit;
      } else {
        if (_M0MPC16string6String24char__length__ge_2einner(_s$2.str, 1, _s$2.start, _s$2.end)) {
          const _tmp$40 = _s$2.str;
          const _bind$8 = _M0MPC16string6String29offset__of__nth__char_2einner(_s$2.str, 1, _s$2.start, _s$2.end);
          let _tmp$41;
          if (_bind$8 === undefined) {
            _tmp$41 = _s$2.end;
          } else {
            const _Some = _bind$8;
            _tmp$41 = _Some;
          }
          const _x = new _M0TPC16string10StringView(_tmp$40, _tmp$41, _s$2.end);
          const _bind$9 = _M0FPC28internal7strconv20try__parse__19digits(_x, mantissa$2);
          const _new_mantissa$2 = _bind$9._1;
          const _consumed_digit$2 = _bind$9._2;
          mantissa$2 = _new_mantissa$2;
          _tmp$39 = _consumed_digit$2;
        } else {
          return new _M0DTPC16result6ResultGORPC28internal7strconv6NumberRPC15error5ErrorE2Ok(undefined);
        }
      }
      exponent = BigInt.asUintN(64, BigInt(_tmp$39));
      exponent = BigInt.asUintN(64, exponent + _M0FPC28internal7strconv13parse__numberN11exp__numberS222);
    }
    return new _M0DTPC16result6ResultGORPC28internal7strconv6NumberRPC15error5ErrorE2Ok(new _M0TPC28internal7strconv6Number(exponent, mantissa$2, negative, many_digits));
  } else {
    return _M0FPC28internal7strconv11syntax__errGORPC28internal7strconv6NumberE();
  }
}
function _M0FPC28internal7strconv15parse__inf__nan(rest) {
  let pos;
  let rest$2;
  _L: {
    let rest$3;
    _L$2: {
      if (_M0MPC16string6String24char__length__ge_2einner(rest.str, 1, rest.start, rest.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(rest.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest.str, 0, rest.start, rest.end));
        switch (_x) {
          case 45: {
            const _tmp$38 = rest.str;
            const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(rest.str, 1, rest.start, rest.end);
            let _tmp$39;
            if (_bind$4 === undefined) {
              _tmp$39 = rest.end;
            } else {
              const _Some = _bind$4;
              _tmp$39 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, rest.end);
            pos = false;
            rest$2 = _x$2;
            break _L;
          }
          case 43: {
            const _tmp$40 = rest.str;
            const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(rest.str, 1, rest.start, rest.end);
            let _tmp$41;
            if (_bind$5 === undefined) {
              _tmp$41 = rest.end;
            } else {
              const _Some = _bind$5;
              _tmp$41 = _Some;
            }
            const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, rest.end);
            rest$3 = _x$3;
            break _L$2;
          }
          default: {
            rest$3 = rest;
            break _L$2;
          }
        }
      } else {
        rest$3 = rest;
        break _L$2;
      }
    }
    pos = true;
    rest$2 = rest$3;
    break _L;
  }
  const _data = rest$2.str;
  const _start = rest$2.start;
  const _end = _start + (rest$2.end - rest$2.start | 0) | 0;
  let _cursor = _start;
  let accept_state = -1;
  let match_end = -1;
  _L$2: {
    _L$3: {
      if ((_cursor + 2 | 0) < _end) {
        _L$4: {
          _L$5: {
            const _p$4 = _cursor;
            const next_char = _data.charCodeAt(_p$4);
            _cursor = _cursor + 1 | 0;
            if (next_char < 79) {
              if (next_char < 74) {
                if (next_char < 73) {
                  break _L$2;
                } else {
                  break _L$4;
                }
              } else {
                if (next_char > 77) {
                  break _L$5;
                } else {
                  break _L$2;
                }
              }
            } else {
              if (next_char > 104) {
                if (next_char < 110) {
                  if (next_char < 106) {
                    break _L$4;
                  } else {
                    break _L$2;
                  }
                } else {
                  if (next_char > 110) {
                    break _L$2;
                  } else {
                    break _L$5;
                  }
                }
              } else {
                break _L$2;
              }
            }
          }
          _L$6: {
            const _p$4 = _cursor;
            const next_char = _data.charCodeAt(_p$4);
            _cursor = _cursor + 1 | 0;
            if (next_char < 66) {
              if (next_char < 65) {
                break _L$2;
              } else {
                break _L$6;
              }
            } else {
              if (next_char > 96) {
                if (next_char < 98) {
                  break _L$6;
                } else {
                  break _L$2;
                }
              } else {
                break _L$2;
              }
            }
          }
          _L$7: {
            const _p$4 = _cursor;
            const next_char = _data.charCodeAt(_p$4);
            _cursor = _cursor + 1 | 0;
            if (next_char < 79) {
              if (next_char < 78) {
                break _L$2;
              } else {
                break _L$7;
              }
            } else {
              if (next_char > 109) {
                if (next_char < 111) {
                  break _L$7;
                } else {
                  break _L$2;
                }
              } else {
                break _L$2;
              }
            }
          }
          if (_cursor < _end) {
            break _L$2;
          } else {
            accept_state = 0;
            match_end = _cursor;
            break _L$2;
          }
        }
        _L$5: {
          const _p$4 = _cursor;
          const next_char = _data.charCodeAt(_p$4);
          _cursor = _cursor + 1 | 0;
          if (next_char < 79) {
            if (next_char < 78) {
              break _L$2;
            } else {
              break _L$5;
            }
          } else {
            if (next_char > 109) {
              if (next_char < 111) {
                break _L$5;
              } else {
                break _L$2;
              }
            } else {
              break _L$2;
            }
          }
        }
        _L$6: {
          const _p$4 = _cursor;
          const next_char = _data.charCodeAt(_p$4);
          _cursor = _cursor + 1 | 0;
          if (next_char < 71) {
            if (next_char < 70) {
              break _L$2;
            } else {
              break _L$6;
            }
          } else {
            if (next_char > 101) {
              if (next_char < 103) {
                break _L$6;
              } else {
                break _L$2;
              }
            } else {
              break _L$2;
            }
          }
        }
        if (_cursor < _end) {
          _L$7: {
            const _p$4 = _cursor;
            const next_char = _data.charCodeAt(_p$4);
            _cursor = _cursor + 1 | 0;
            if (next_char < 74) {
              if (next_char < 73) {
                break _L$2;
              } else {
                break _L$7;
              }
            } else {
              if (next_char > 104) {
                if (next_char < 106) {
                  break _L$7;
                } else {
                  break _L$2;
                }
              } else {
                break _L$2;
              }
            }
          }
          if ((_cursor + 3 | 0) < _end) {
            _L$8: {
              const _p$4 = _cursor;
              const next_char = _data.charCodeAt(_p$4);
              _cursor = _cursor + 1 | 0;
              if (next_char < 79) {
                if (next_char < 78) {
                  break _L$2;
                } else {
                  break _L$8;
                }
              } else {
                if (next_char > 109) {
                  if (next_char < 111) {
                    break _L$8;
                  } else {
                    break _L$2;
                  }
                } else {
                  break _L$2;
                }
              }
            }
            _L$9: {
              const _p$4 = _cursor;
              const next_char = _data.charCodeAt(_p$4);
              _cursor = _cursor + 1 | 0;
              if (next_char < 74) {
                if (next_char < 73) {
                  break _L$2;
                } else {
                  break _L$9;
                }
              } else {
                if (next_char > 104) {
                  if (next_char < 106) {
                    break _L$9;
                  } else {
                    break _L$2;
                  }
                } else {
                  break _L$2;
                }
              }
            }
            _L$10: {
              const _p$4 = _cursor;
              const next_char = _data.charCodeAt(_p$4);
              _cursor = _cursor + 1 | 0;
              if (next_char < 85) {
                if (next_char < 84) {
                  break _L$2;
                } else {
                  break _L$10;
                }
              } else {
                if (next_char > 115) {
                  if (next_char < 117) {
                    break _L$10;
                  } else {
                    break _L$2;
                  }
                } else {
                  break _L$2;
                }
              }
            }
            _L$11: {
              const _p$4 = _cursor;
              const next_char = _data.charCodeAt(_p$4);
              _cursor = _cursor + 1 | 0;
              if (next_char < 90) {
                if (next_char < 89) {
                  break _L$2;
                } else {
                  break _L$11;
                }
              } else {
                if (next_char > 120) {
                  if (next_char < 122) {
                    break _L$11;
                  } else {
                    break _L$2;
                  }
                } else {
                  break _L$2;
                }
              }
            }
            if (_cursor < _end) {
              break _L$2;
            } else {
              break _L$3;
            }
          } else {
            break _L$2;
          }
        } else {
          break _L$3;
        }
      } else {
        break _L$2;
      }
    }
    accept_state = 1;
    match_end = _cursor;
    break _L$2;
  }
  switch (accept_state) {
    case 0: {
      return new _M0DTPC16result6ResultGdRPC15error5ErrorE2Ok(_M0FPC16double14not__a__number);
    }
    case 1: {
      return pos ? new _M0DTPC16result6ResultGdRPC15error5ErrorE2Ok(_M0FPC16double8infinity) : new _M0DTPC16result6ResultGdRPC15error5ErrorE2Ok(_M0FPC16double13neg__infinity);
    }
    default: {
      return _M0FPC28internal7strconv11syntax__errGdE();
    }
  }
}
function _M0FPC28internal7strconv12checked__mul(a, b) {
  if (BigInt.asUintN(64, a) === BigInt.asUintN(64, 0n) || BigInt.asUintN(64, b) === BigInt.asUintN(64, 0n)) {
    return _M0FPC28internal7strconv12checked__mulN6constrS1190;
  }
  if (BigInt.asUintN(64, a) === BigInt.asUintN(64, 1n)) {
    return b;
  }
  if (BigInt.asUintN(64, b) === BigInt.asUintN(64, 1n)) {
    return a;
  }
  if ($i64_clz(b) === 0 || $i64_clz(a) === 0) {
    return undefined;
  }
  if (b === 0n) {
    $panic();
  }
  const quotient = BigInt.asUintN(64, BigInt.asUintN(64, 18446744073709551615n) / BigInt.asUintN(64, b));
  if (BigInt.asUintN(64, a) > BigInt.asUintN(64, quotient)) {
    return undefined;
  }
  return BigInt.asUintN(64, a * b);
}
function _M0FPC28internal7strconv19overflow__threshold(base, neg) {
  if (!neg) {
    if (base === 10) {
      return 922337203685477581n;
    } else {
      if (base === 16) {
        return 576460752303423488n;
      } else {
        const _tmp$38 = BigInt.asUintN(64, BigInt(base));
        if (_tmp$38 === 0n) {
          $panic();
        }
        return BigInt.asUintN(64, BigInt.asUintN(64, BigInt.asIntN(64, 9223372036854775807n) / BigInt.asIntN(64, _tmp$38)) + 1n);
      }
    }
  } else {
    if (base === 10) {
      return 17524406870024074036n;
    } else {
      if (base === 16) {
        return 17870283321406128128n;
      } else {
        const _tmp$38 = BigInt.asUintN(64, BigInt(base));
        if (_tmp$38 === 0n) {
          $panic();
        }
        return BigInt.asUintN(64, BigInt.asIntN(64, 9223372036854775808n) / BigInt.asIntN(64, _tmp$38));
      }
    }
  }
}
function _M0FPC28internal7strconv20parse__int64_2einner(str, base) {
  if (_M0IP016_24default__implPB2Eq10not__equalGRPC16string10StringViewE(str, new _M0TPC16string10StringView(_M0FPC28internal7strconv20parse__int64_2einnerN7_2abindS658, 0, _M0FPC28internal7strconv20parse__int64_2einnerN7_2abindS658.length))) {
    let neg;
    let rest;
    _L: {
      let rest$2;
      _L$2: {
        const _bind$4 = _M0MPC16string10StringView12view_2einner(str, 0, undefined);
        if (_M0MPC16string6String24char__length__ge_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end)) {
          const _x = _M0MPC16string6String16unsafe__char__at(_bind$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 0, _bind$4.start, _bind$4.end));
          switch (_x) {
            case 43: {
              const _tmp$38 = _bind$4.str;
              const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
              let _tmp$39;
              if (_bind$5 === undefined) {
                _tmp$39 = _bind$4.end;
              } else {
                const _Some = _bind$5;
                _tmp$39 = _Some;
              }
              const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$4.end);
              neg = false;
              rest = _x$2;
              break _L;
            }
            case 45: {
              const _tmp$40 = _bind$4.str;
              const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
              let _tmp$41;
              if (_bind$6 === undefined) {
                _tmp$41 = _bind$4.end;
              } else {
                const _Some = _bind$6;
                _tmp$41 = _Some;
              }
              const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, _bind$4.end);
              neg = true;
              rest = _x$3;
              break _L;
            }
            default: {
              rest$2 = _bind$4;
              break _L$2;
            }
          }
        } else {
          rest$2 = _bind$4;
          break _L$2;
        }
      }
      neg = false;
      rest = rest$2;
      break _L;
    }
    const _bind$4 = _M0FPC28internal7strconv25check__and__consume__base(rest, base);
    let _bind$5;
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _bind$5 = _ok._0;
    } else {
      return _bind$4;
    }
    const _num_base = _bind$5._0;
    const _rest = _bind$5._1;
    const _allow_underscore = _bind$5._2;
    const overflow_threshold = _M0FPC28internal7strconv19overflow__threshold(_num_base, neg);
    let has_digit;
    if (_M0MPC16string6String24char__length__ge_2einner(_rest.str, 1, _rest.start, _rest.end)) {
      const _x = _M0MPC16string6String16unsafe__char__at(_rest.str, _M0MPC16string6String29offset__of__nth__char_2einner(_rest.str, 0, _rest.start, _rest.end));
      if (_x >= 48 && _x <= 57) {
        has_digit = true;
      } else {
        if (_x >= 97 && _x <= 122) {
          has_digit = true;
        } else {
          if (_x >= 65 && _x <= 90) {
            has_digit = true;
          } else {
            if (_M0MPC16string6String24char__length__ge_2einner(_rest.str, 2, _rest.start, _rest.end)) {
              if (_x === 95) {
                const _x$2 = _M0MPC16string6String16unsafe__char__at(_rest.str, _M0MPC16string6String29offset__of__nth__char_2einner(_rest.str, 1, _rest.start, _rest.end));
                has_digit = _x$2 >= 48 && _x$2 <= 57 ? true : _x$2 >= 97 && _x$2 <= 122 ? true : _x$2 >= 65 && _x$2 <= 90;
              } else {
                has_digit = false;
              }
            } else {
              has_digit = false;
            }
          }
        }
      }
    } else {
      has_digit = false;
    }
    if (has_digit) {
      let _tmp$38;
      let _tmp$39 = _rest;
      let _tmp$40 = 0n;
      let _tmp$41 = _allow_underscore;
      while (true) {
        const rest$2 = _tmp$39;
        const acc = _tmp$40;
        const allow_underscore = _tmp$41;
        let acc$2;
        let rest$3;
        let c;
        _L$2: {
          _L$3: {
            if (_M0MPC16string6String24char__length__eq_2einner(rest$2.str, 1, rest$2.start, rest$2.end)) {
              const _x = _M0MPC16string6String16unsafe__char__at(rest$2.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 0, rest$2.start, rest$2.end));
              if (_x === 95) {
                const _bind$6 = _M0FPC28internal7strconv11syntax__errGuE();
                if (_bind$6.$tag === 1) {
                  const _ok = _bind$6;
                  _ok._0;
                } else {
                  return _bind$6;
                }
              } else {
                const _tmp$42 = rest$2.str;
                const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 1, rest$2.start, rest$2.end);
                let _tmp$43;
                if (_bind$6 === undefined) {
                  _tmp$43 = rest$2.end;
                } else {
                  const _Some = _bind$6;
                  _tmp$43 = _Some;
                }
                const _x$2 = new _M0TPC16string10StringView(_tmp$42, _tmp$43, rest$2.end);
                acc$2 = acc;
                rest$3 = _x$2;
                c = _x;
                break _L$3;
              }
            } else {
              if (_M0MPC16string6String24char__length__ge_2einner(rest$2.str, 1, rest$2.start, rest$2.end)) {
                const _x = _M0MPC16string6String16unsafe__char__at(rest$2.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 0, rest$2.start, rest$2.end));
                if (_x === 95) {
                  if (allow_underscore === false) {
                    const _bind$6 = _M0FPC28internal7strconv11syntax__errGuE();
                    if (_bind$6.$tag === 1) {
                      const _ok = _bind$6;
                      _ok._0;
                    } else {
                      return _bind$6;
                    }
                  } else {
                    const _tmp$42 = rest$2.str;
                    const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 1, rest$2.start, rest$2.end);
                    let _tmp$43;
                    if (_bind$6 === undefined) {
                      _tmp$43 = rest$2.end;
                    } else {
                      const _Some = _bind$6;
                      _tmp$43 = _Some;
                    }
                    const _x$2 = new _M0TPC16string10StringView(_tmp$42, _tmp$43, rest$2.end);
                    _tmp$39 = _x$2;
                    _tmp$41 = false;
                    continue;
                  }
                } else {
                  const _tmp$42 = rest$2.str;
                  const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 1, rest$2.start, rest$2.end);
                  let _tmp$43;
                  if (_bind$6 === undefined) {
                    _tmp$43 = rest$2.end;
                  } else {
                    const _Some = _bind$6;
                    _tmp$43 = _Some;
                  }
                  const _x$2 = new _M0TPC16string10StringView(_tmp$42, _tmp$43, rest$2.end);
                  acc$2 = acc;
                  rest$3 = _x$2;
                  c = _x;
                  break _L$3;
                }
              } else {
                _tmp$38 = acc;
                break;
              }
            }
            break _L$2;
          }
          const c$2 = c;
          let d;
          if (c$2 >= 48 && c$2 <= 57) {
            d = c$2 - 48 | 0;
          } else {
            if (c$2 >= 97 && c$2 <= 122) {
              d = c$2 + -87 | 0;
            } else {
              if (c$2 >= 65 && c$2 <= 90) {
                d = c$2 + -55 | 0;
              } else {
                const _bind$6 = _M0FPC28internal7strconv11syntax__errGiE();
                if (_bind$6.$tag === 1) {
                  const _ok = _bind$6;
                  d = _ok._0;
                } else {
                  return _bind$6;
                }
              }
            }
          }
          if (d < _num_base) {
            if (neg) {
              if (BigInt.asIntN(64, acc$2) >= BigInt.asIntN(64, overflow_threshold)) {
                const next_acc = BigInt.asUintN(64, BigInt.asUintN(64, acc$2 * BigInt.asUintN(64, BigInt(_num_base))) - BigInt.asUintN(64, BigInt(d)));
                if (BigInt.asIntN(64, next_acc) <= BigInt.asIntN(64, acc$2)) {
                  _tmp$39 = rest$3;
                  _tmp$40 = next_acc;
                  _tmp$41 = true;
                  continue;
                } else {
                  const _bind$6 = _M0FPC28internal7strconv10range__errGuE();
                  if (_bind$6.$tag === 1) {
                    const _ok = _bind$6;
                    _ok._0;
                  } else {
                    return _bind$6;
                  }
                }
              } else {
                const _bind$6 = _M0FPC28internal7strconv10range__errGuE();
                if (_bind$6.$tag === 1) {
                  const _ok = _bind$6;
                  _ok._0;
                } else {
                  return _bind$6;
                }
              }
            } else {
              if (BigInt.asIntN(64, acc$2) < BigInt.asIntN(64, overflow_threshold)) {
                const next_acc = BigInt.asUintN(64, BigInt.asUintN(64, acc$2 * BigInt.asUintN(64, BigInt(_num_base))) + BigInt.asUintN(64, BigInt(d)));
                if (BigInt.asIntN(64, next_acc) >= BigInt.asIntN(64, acc$2)) {
                  _tmp$39 = rest$3;
                  _tmp$40 = next_acc;
                  _tmp$41 = true;
                  continue;
                } else {
                  const _bind$6 = _M0FPC28internal7strconv10range__errGuE();
                  if (_bind$6.$tag === 1) {
                    const _ok = _bind$6;
                    _ok._0;
                  } else {
                    return _bind$6;
                  }
                }
              } else {
                const _bind$6 = _M0FPC28internal7strconv10range__errGuE();
                if (_bind$6.$tag === 1) {
                  const _ok = _bind$6;
                  _ok._0;
                } else {
                  return _bind$6;
                }
              }
            }
          } else {
            const _bind$6 = _M0FPC28internal7strconv11syntax__errGuE();
            if (_bind$6.$tag === 1) {
              const _ok = _bind$6;
              _ok._0;
            } else {
              return _bind$6;
            }
          }
        }
        continue;
      }
      return new _M0DTPC16result6ResultGlRPC15error5ErrorE2Ok(_tmp$38);
    } else {
      return _M0FPC28internal7strconv11syntax__errGlE();
    }
  } else {
    return _M0FPC28internal7strconv11syntax__errGlE();
  }
}
function _M0FPC28internal7strconv18parse__int_2einner(str, base) {
  const _bind$4 = _M0FPC28internal7strconv20parse__int64_2einner(str, base);
  let n;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    n = _ok._0;
  } else {
    return _bind$4;
  }
  if (BigInt.asIntN(64, n) < BigInt.asIntN(64, 18446744071562067968n) || BigInt.asIntN(64, n) > BigInt.asIntN(64, 2147483647n)) {
    const _bind$5 = _M0FPC28internal7strconv10range__errGuE();
    if (_bind$5.$tag === 1) {
      const _ok = _bind$5;
      _ok._0;
    } else {
      return _bind$5;
    }
  }
  return new _M0DTPC16result6ResultGiRPC15error5ErrorE2Ok(Number(BigInt.asIntN(32, n)) | 0);
}
function _M0FPC28internal7strconv17check__underscore(str) {
  let rest;
  if (_M0MPC16string6String24char__length__ge_2einner(str.str, 1, str.start, str.end)) {
    const _x = _M0MPC16string6String16unsafe__char__at(str.str, _M0MPC16string6String29offset__of__nth__char_2einner(str.str, 0, str.start, str.end));
    switch (_x) {
      case 43: {
        const _tmp$38 = str.str;
        const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(str.str, 1, str.start, str.end);
        let _tmp$39;
        if (_bind$4 === undefined) {
          _tmp$39 = str.end;
        } else {
          const _Some = _bind$4;
          _tmp$39 = _Some;
        }
        const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, str.end);
        rest = _x$2;
        break;
      }
      case 45: {
        const _tmp$40 = str.str;
        const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(str.str, 1, str.start, str.end);
        let _tmp$41;
        if (_bind$5 === undefined) {
          _tmp$41 = str.end;
        } else {
          const _Some = _bind$5;
          _tmp$41 = _Some;
        }
        const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, str.end);
        rest = _x$3;
        break;
      }
      default: {
        rest = str;
      }
    }
  } else {
    rest = str;
  }
  let rest$2;
  let allow_underscore;
  let hex;
  _L: {
    const _data = rest.str;
    const _start = rest.start;
    const _end = _start + (rest.end - rest.start | 0) | 0;
    let _cursor = _start;
    let accept_state = -1;
    let match_end = -1;
    _L$2: {
      if ((_cursor + 1 | 0) < _end) {
        const _p$4 = _cursor;
        if (_data.charCodeAt(_p$4) === 48) {
          _cursor = _cursor + 1 | 0;
          _L$3: {
            _L$4: {
              _L$5: {
                const _p$5 = _cursor;
                const next_char = _data.charCodeAt(_p$5);
                _cursor = _cursor + 1 | 0;
                if (next_char < 89) {
                  if (next_char < 79) {
                    if (next_char === 66) {
                      break _L$3;
                    } else {
                      break _L$2;
                    }
                  } else {
                    if (next_char > 79) {
                      if (next_char < 88) {
                        break _L$2;
                      } else {
                        break _L$5;
                      }
                    } else {
                      break _L$4;
                    }
                  }
                } else {
                  if (next_char > 97) {
                    if (next_char < 112) {
                      if (next_char < 99) {
                        break _L$3;
                      } else {
                        if (next_char > 110) {
                          break _L$4;
                        } else {
                          break _L$2;
                        }
                      }
                    } else {
                      if (next_char > 119) {
                        if (next_char < 121) {
                          break _L$5;
                        } else {
                          break _L$2;
                        }
                      } else {
                        break _L$2;
                      }
                    }
                  } else {
                    break _L$2;
                  }
                }
              }
              accept_state = 2;
              match_end = _cursor;
              break _L$2;
            }
            accept_state = 1;
            match_end = _cursor;
            break _L$2;
          }
          accept_state = 0;
          match_end = _cursor;
          break _L$2;
        } else {
          break _L$2;
        }
      } else {
        break _L$2;
      }
    }
    switch (accept_state) {
      case 2: {
        const rest$3 = _M0MPC16string6String4view(_data, match_end, _end);
        rest$2 = rest$3;
        allow_underscore = true;
        hex = true;
        break _L;
      }
      case 1: {
        const rest$4 = _M0MPC16string6String4view(_data, match_end, _end);
        rest$2 = rest$4;
        allow_underscore = true;
        hex = false;
        break _L;
      }
      case 0: {
        const rest$5 = _M0MPC16string6String4view(_data, match_end, _end);
        rest$2 = rest$5;
        allow_underscore = true;
        hex = false;
        break _L;
      }
      default: {
        rest$2 = rest;
        allow_underscore = false;
        hex = false;
        break _L;
      }
    }
  }
  let _tmp$38 = rest$2;
  let _tmp$39 = allow_underscore;
  let _tmp$40 = false;
  while (true) {
    const rest$3 = _tmp$38;
    const allow_underscore$2 = _tmp$39;
    const follow_underscore = _tmp$40;
    let rest$4;
    let c;
    let follow_underscore$2;
    _L$2: {
      if (_M0MPC16string6String24char__length__eq_2einner(rest$3.str, 0, rest$3.start, rest$3.end)) {
        return true;
      } else {
        if (_M0MPC16string6String24char__length__eq_2einner(rest$3.str, 1, rest$3.start, rest$3.end)) {
          const _x = _M0MPC16string6String16unsafe__char__at(rest$3.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest$3.str, 0, rest$3.start, rest$3.end));
          if (_x === 95) {
            return false;
          } else {
            const _tmp$41 = rest$3.str;
            const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$3.str, 1, rest$3.start, rest$3.end);
            let _tmp$42;
            if (_bind$4 === undefined) {
              _tmp$42 = rest$3.end;
            } else {
              const _Some = _bind$4;
              _tmp$42 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$41, _tmp$42, rest$3.end);
            rest$4 = _x$2;
            c = _x;
            follow_underscore$2 = follow_underscore;
            break _L$2;
          }
        } else {
          const _x = _M0MPC16string6String16unsafe__char__at(rest$3.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest$3.str, 0, rest$3.start, rest$3.end));
          if (_x === 95) {
            if (allow_underscore$2 === false) {
              return false;
            } else {
              const _tmp$41 = rest$3.str;
              const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$3.str, 1, rest$3.start, rest$3.end);
              let _tmp$42;
              if (_bind$4 === undefined) {
                _tmp$42 = rest$3.end;
              } else {
                const _Some = _bind$4;
                _tmp$42 = _Some;
              }
              const _x$2 = new _M0TPC16string10StringView(_tmp$41, _tmp$42, rest$3.end);
              _tmp$38 = _x$2;
              _tmp$39 = false;
              _tmp$40 = true;
              continue;
            }
          } else {
            const _tmp$41 = rest$3.str;
            const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$3.str, 1, rest$3.start, rest$3.end);
            let _tmp$42;
            if (_bind$4 === undefined) {
              _tmp$42 = rest$3.end;
            } else {
              const _Some = _bind$4;
              _tmp$42 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$41, _tmp$42, rest$3.end);
            rest$4 = _x$2;
            c = _x;
            follow_underscore$2 = follow_underscore;
            break _L$2;
          }
        }
      }
    }
    if (c >= 48 && c <= 57 ? true : hex && (c >= 97 && c <= 102 ? true : c >= 65 && c <= 70)) {
      _tmp$38 = rest$4;
      _tmp$39 = true;
      _tmp$40 = false;
      continue;
    } else {
      if (follow_underscore$2) {
        return false;
      } else {
        _tmp$38 = rest$4;
        _tmp$39 = false;
        _tmp$40 = false;
        continue;
      }
    }
  }
}
function _M0MPC28internal7strconv7Decimal9new__priv() {
  return new _M0TPC28internal7strconv7Decimal($makebytes(800, 0), 0, 0, false, false);
}
function _M0MPC28internal7strconv7Decimal4trim(self) {
  while (true) {
    let _tmp$38;
    if (self.digits_num > 0) {
      const _tmp$39 = self.digits;
      const _tmp$40 = self.digits_num - 1 | 0;
      $bound_check(_tmp$39, _tmp$40);
      const _p$4 = _tmp$39[_tmp$40];
      const _p$5 = 0;
      _tmp$38 = _p$4 === _p$5;
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      self.digits_num = self.digits_num - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (self.digits_num === 0) {
    self.decimal_point = 0;
    return;
  } else {
    return;
  }
}
function _M0FPC28internal7strconv26parse__decimal__from__view(str) {
  const d = _M0MPC28internal7strconv7Decimal9new__priv();
  let has_dp = false;
  let has_digits = false;
  let rest;
  _L: {
    _L$2: {
      if (_M0MPC16string6String24char__length__ge_2einner(str.str, 1, str.start, str.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(str.str, _M0MPC16string6String29offset__of__nth__char_2einner(str.str, 0, str.start, str.end));
        switch (_x) {
          case 45: {
            const _tmp$38 = str.str;
            const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(str.str, 1, str.start, str.end);
            let _tmp$39;
            if (_bind$4 === undefined) {
              _tmp$39 = str.end;
            } else {
              const _Some = _bind$4;
              _tmp$39 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, str.end);
            d.negative = true;
            rest = _x$2;
            break;
          }
          case 43: {
            const _tmp$40 = str.str;
            const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(str.str, 1, str.start, str.end);
            let _tmp$41;
            if (_bind$5 === undefined) {
              _tmp$41 = str.end;
            } else {
              const _Some = _bind$5;
              _tmp$41 = _Some;
            }
            rest = new _M0TPC16string10StringView(_tmp$40, _tmp$41, str.end);
            break;
          }
          default: {
            break _L$2;
          }
        }
      } else {
        break _L$2;
      }
      break _L;
    }
    rest = str;
  }
  let rest$2;
  let _tmp$38 = rest;
  while (true) {
    const rest$3 = _tmp$38;
    let rest$4;
    _L$2: {
      _L$3: {
        if (_M0MPC16string6String24char__length__ge_2einner(rest$3.str, 1, rest$3.start, rest$3.end)) {
          const _x = _M0MPC16string6String16unsafe__char__at(rest$3.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest$3.str, 0, rest$3.start, rest$3.end));
          if (_x === 95) {
            const _tmp$39 = rest$3.str;
            const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$3.str, 1, rest$3.start, rest$3.end);
            let _tmp$40;
            if (_bind$4 === undefined) {
              _tmp$40 = rest$3.end;
            } else {
              const _Some = _bind$4;
              _tmp$40 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, rest$3.end);
            _tmp$38 = _x$2;
            continue;
          } else {
            if (_x === 46) {
              const _tmp$39 = rest$3.str;
              const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$3.str, 1, rest$3.start, rest$3.end);
              let _tmp$40;
              if (_bind$4 === undefined) {
                _tmp$40 = rest$3.end;
              } else {
                const _Some = _bind$4;
                _tmp$40 = _Some;
              }
              const _x$2 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, rest$3.end);
              if (!has_dp) {
                has_dp = true;
                d.decimal_point = d.digits_num;
                _tmp$38 = _x$2;
                continue;
              } else {
                const _bind$5 = _M0FPC28internal7strconv11syntax__errGuE();
                if (_bind$5.$tag === 1) {
                  const _ok = _bind$5;
                  _ok._0;
                } else {
                  return _bind$5;
                }
              }
            } else {
              if (_x >= 48 && _x <= 57) {
                const _tmp$39 = rest$3.str;
                const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$3.str, 1, rest$3.start, rest$3.end);
                let _tmp$40;
                if (_bind$4 === undefined) {
                  _tmp$40 = rest$3.end;
                } else {
                  const _Some = _bind$4;
                  _tmp$40 = _Some;
                }
                const _x$2 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, rest$3.end);
                has_digits = true;
                if (_x === 48 && d.digits_num === 0) {
                  d.decimal_point = d.decimal_point - 1 | 0;
                  _tmp$38 = _x$2;
                  continue;
                }
                if (d.digits_num < d.digits.length) {
                  const _tmp$41 = d.digits;
                  const _tmp$42 = d.digits_num;
                  $bound_check(_tmp$41, _tmp$42);
                  _tmp$41[_tmp$42] = (_x - 48 | 0) & 255;
                  d.digits_num = d.digits_num + 1 | 0;
                } else {
                  if (_x !== 48) {
                    d.truncated = true;
                  }
                }
                _tmp$38 = _x$2;
                continue;
              } else {
                rest$4 = rest$3;
                break _L$3;
              }
            }
          }
        } else {
          rest$4 = rest$3;
          break _L$3;
        }
        break _L$2;
      }
      rest$2 = rest$4;
      break;
    }
    continue;
  }
  if (has_digits) {
    if (!has_dp) {
      d.decimal_point = d.digits_num;
    }
    let rest$3;
    let rest$4;
    _L$2: {
      _L$3: {
        if (_M0MPC16string6String24char__length__ge_2einner(rest$2.str, 1, rest$2.start, rest$2.end)) {
          const _x = _M0MPC16string6String16unsafe__char__at(rest$2.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 0, rest$2.start, rest$2.end));
          switch (_x) {
            case 101: {
              const _tmp$39 = rest$2.str;
              const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 1, rest$2.start, rest$2.end);
              let _tmp$40;
              if (_bind$4 === undefined) {
                _tmp$40 = rest$2.end;
              } else {
                const _Some = _bind$4;
                _tmp$40 = _Some;
              }
              const _x$2 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, rest$2.end);
              rest$4 = _x$2;
              break _L$3;
            }
            case 69: {
              const _tmp$41 = rest$2.str;
              const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 1, rest$2.start, rest$2.end);
              let _tmp$42;
              if (_bind$5 === undefined) {
                _tmp$42 = rest$2.end;
              } else {
                const _Some = _bind$5;
                _tmp$42 = _Some;
              }
              const _x$3 = new _M0TPC16string10StringView(_tmp$41, _tmp$42, rest$2.end);
              rest$4 = _x$3;
              break _L$3;
            }
            default: {
              rest$3 = rest$2;
            }
          }
        } else {
          rest$3 = rest$2;
        }
        break _L$2;
      }
      let exp_sign = 1;
      let rest$5;
      if (_M0MPC16string6String24char__length__ge_2einner(rest$4.str, 1, rest$4.start, rest$4.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(rest$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest$4.str, 0, rest$4.start, rest$4.end));
        switch (_x) {
          case 43: {
            const _tmp$39 = rest$4.str;
            const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$4.str, 1, rest$4.start, rest$4.end);
            let _tmp$40;
            if (_bind$4 === undefined) {
              _tmp$40 = rest$4.end;
            } else {
              const _Some = _bind$4;
              _tmp$40 = _Some;
            }
            rest$5 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, rest$4.end);
            break;
          }
          case 45: {
            const _tmp$41 = rest$4.str;
            const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$4.str, 1, rest$4.start, rest$4.end);
            let _tmp$42;
            if (_bind$5 === undefined) {
              _tmp$42 = rest$4.end;
            } else {
              const _Some = _bind$5;
              _tmp$42 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$41, _tmp$42, rest$4.end);
            exp_sign = -1;
            rest$5 = _x$2;
            break;
          }
          default: {
            rest$5 = rest$4;
          }
        }
      } else {
        rest$5 = rest$4;
      }
      _L$4: {
        _L$5: {
          if (_M0MPC16string6String24char__length__ge_2einner(rest$5.str, 1, rest$5.start, rest$5.end)) {
            const _x = _M0MPC16string6String16unsafe__char__at(rest$5.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest$5.str, 0, rest$5.start, rest$5.end));
            if (_x >= 48 && _x <= 57) {
              const exp_limit = exp_sign > 0 ? (d.decimal_point < 311 ? 311 - d.decimal_point | 0 : 0) : d.decimal_point > -331 ? d.decimal_point + 331 | 0 : 0;
              let exp = 0;
              let rest$6;
              let _tmp$39 = rest$5;
              while (true) {
                const rest$7 = _tmp$39;
                let rest$8;
                _L$6: {
                  if (_M0MPC16string6String24char__length__ge_2einner(rest$7.str, 1, rest$7.start, rest$7.end)) {
                    const _x$2 = _M0MPC16string6String16unsafe__char__at(rest$7.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest$7.str, 0, rest$7.start, rest$7.end));
                    if (_x$2 === 95) {
                      const _tmp$40 = rest$7.str;
                      const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$7.str, 1, rest$7.start, rest$7.end);
                      let _tmp$41;
                      if (_bind$4 === undefined) {
                        _tmp$41 = rest$7.end;
                      } else {
                        const _Some = _bind$4;
                        _tmp$41 = _Some;
                      }
                      const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, rest$7.end);
                      _tmp$39 = _x$3;
                      continue;
                    } else {
                      if (_x$2 >= 48 && _x$2 <= 57) {
                        const _tmp$40 = rest$7.str;
                        const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$7.str, 1, rest$7.start, rest$7.end);
                        let _tmp$41;
                        if (_bind$4 === undefined) {
                          _tmp$41 = rest$7.end;
                        } else {
                          const _Some = _bind$4;
                          _tmp$41 = _Some;
                        }
                        const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, rest$7.end);
                        if (exp < exp_limit) {
                          exp = (Math.imul(exp, 10) | 0) + (_x$2 - 48 | 0) | 0;
                          if (exp > exp_limit) {
                            exp = exp_limit;
                          }
                        }
                        _tmp$39 = _x$3;
                        continue;
                      } else {
                        rest$8 = rest$7;
                        break _L$6;
                      }
                    }
                  } else {
                    rest$8 = rest$7;
                    break _L$6;
                  }
                }
                rest$6 = rest$8;
                break;
              }
              d.decimal_point = d.decimal_point + (Math.imul(exp_sign, exp) | 0) | 0;
              rest$3 = rest$6;
            } else {
              break _L$5;
            }
          } else {
            break _L$5;
          }
          break _L$4;
        }
        const _bind$4 = _M0FPC28internal7strconv11syntax__errGlE();
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          rest$3 = _ok._0;
        } else {
          return _bind$4;
        }
      }
    }
    if (_M0MPC16string6String24char__length__eq_2einner(rest$3.str, 0, rest$3.start, rest$3.end)) {
      _M0MPC28internal7strconv7Decimal4trim(d);
      return new _M0DTPC16result6ResultGRPC28internal7strconv7DecimalRPC15error5ErrorE2Ok(d);
    } else {
      return _M0FPC28internal7strconv11syntax__errGlE();
    }
  } else {
    return _M0FPC28internal7strconv11syntax__errGlE();
  }
}
function _M0FPC28internal7strconv20parse__decimal__priv(str) {
  return _M0FPC28internal7strconv26parse__decimal__from__view(str);
}
function _M0FPC28internal7strconv14assemble__bits(mantissa, exponent, negative) {
  const biased_exp = exponent - _M0FPC28internal7strconv12double__info.bias | 0;
  let bits = BigInt.asUintN(64, mantissa & BigInt.asUintN(64, BigInt.asUintN(64, 1n << BigInt(_M0FPC28internal7strconv12double__info.mantissa_bits & 63)) - 1n));
  const exp_bits = BigInt.asUintN(64, BigInt(biased_exp & ((1 << _M0FPC28internal7strconv12double__info.exponent_bits) - 1 | 0)));
  bits = BigInt.asUintN(64, bits | BigInt.asUintN(64, exp_bits << BigInt(_M0FPC28internal7strconv12double__info.mantissa_bits & 63)));
  if (negative) {
    bits = BigInt.asUintN(64, bits | BigInt.asUintN(64, BigInt.asUintN(64, 1n << BigInt(_M0FPC28internal7strconv12double__info.mantissa_bits & 63)) << BigInt(_M0FPC28internal7strconv12double__info.exponent_bits & 63)));
  }
  return bits;
}
function _M0MPC28internal7strconv7Decimal17should__round__up(self, d) {
  if (d < 0 || d >= self.digits_num) {
    return false;
  }
  let _tmp$38;
  const _tmp$39 = self.digits;
  $bound_check(_tmp$39, d);
  if (_tmp$39[d] === 5) {
    _tmp$38 = (d + 1 | 0) === self.digits_num;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    if (self.truncated) {
      return true;
    }
    let _tmp$40;
    if (d > 0) {
      const _tmp$41 = self.digits;
      const _tmp$42 = d - 1 | 0;
      $bound_check(_tmp$41, _tmp$42);
      _tmp$40 = (_tmp$41[_tmp$42] % 2 | 0) !== 0;
    } else {
      _tmp$40 = false;
    }
    return _tmp$40;
  }
  const _tmp$40 = self.digits;
  $bound_check(_tmp$40, d);
  return _tmp$40[d] >= 5;
}
function _M0MPC28internal7strconv7Decimal16rounded__integer(self) {
  if (self.decimal_point > 20) {
    return 18446744073709551615n;
  }
  let _tmp$38 = 0n;
  let _tmp$39 = 0;
  while (true) {
    const n = _tmp$38;
    const i = _tmp$39;
    if (i < self.decimal_point && i < self.digits_num) {
      const _tmp$40 = BigInt.asUintN(64, n * 10n);
      const _tmp$41 = self.digits;
      $bound_check(_tmp$41, i);
      const _p$4 = _tmp$41[i];
      _tmp$38 = BigInt.asUintN(64, _tmp$40 + BigInt.asUintN(64, BigInt(_p$4)));
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      let n$2;
      let _tmp$40 = n;
      let _tmp$41 = i;
      while (true) {
        const n$3 = _tmp$40;
        const i$2 = _tmp$41;
        if (i$2 < self.decimal_point) {
          _tmp$40 = BigInt.asUintN(64, n$3 * 10n);
          _tmp$41 = i$2 + 1 | 0;
          continue;
        } else {
          n$2 = n$3;
          break;
        }
      }
      return _M0MPC28internal7strconv7Decimal17should__round__up(self, self.decimal_point) ? BigInt.asUintN(64, n$2 + 1n) : n$2;
    }
  }
}
function _M0MPC28internal7strconv7Decimal11new__digits(self, s) {
  $bound_check(_M0FPC28internal7strconv19left__shift__cheats, s);
  const new_digits = _M0FPC28internal7strconv19left__shift__cheats[s]._0;
  $bound_check(_M0FPC28internal7strconv19left__shift__cheats, s);
  const cheat_num = _M0FPC28internal7strconv19left__shift__cheats[s]._1;
  const _bind$4 = cheat_num.length;
  let less;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < _bind$4) {
      if (i >= self.digits_num) {
        less = true;
        break;
      }
      const d = cheat_num.charCodeAt(i) - 48 | 0;
      const _tmp$39 = self.digits;
      $bound_check(_tmp$39, i);
      if (_tmp$39[i] !== d) {
        const _tmp$40 = self.digits;
        $bound_check(_tmp$40, i);
        less = _tmp$40[i] < d;
        break;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      less = false;
      break;
    }
  }
  return less ? new_digits - 1 | 0 : new_digits;
}
function _M0MPC28internal7strconv7Decimal11left__shift(self, s) {
  const new_digits = _M0MPC28internal7strconv7Decimal11new__digits(self, s);
  let read_index = self.digits_num;
  let write_index = self.digits_num + new_digits | 0;
  let acc = 0n;
  read_index = read_index - 1 | 0;
  while (true) {
    if (read_index >= 0) {
      const _tmp$38 = self.digits;
      const _tmp$39 = read_index;
      $bound_check(_tmp$38, _tmp$39);
      const _p$4 = _tmp$38[_tmp$39];
      const d = BigInt.asUintN(64, BigInt(_p$4));
      acc = BigInt.asUintN(64, acc + BigInt.asUintN(64, d << BigInt(s & 63)));
      if (10n === 0n) {
        $panic();
      }
      const quo = BigInt.asUintN(64, BigInt.asIntN(64, acc) / BigInt.asIntN(64, 10n));
      const rem = Number(BigInt.asIntN(32, BigInt.asUintN(64, acc - BigInt.asUintN(64, quo * 10n)))) | 0;
      write_index = write_index - 1 | 0;
      if (write_index < self.digits.length) {
        const _tmp$40 = self.digits;
        const _tmp$41 = write_index;
        $bound_check(_tmp$40, _tmp$41);
        _tmp$40[_tmp$41] = rem & 255;
      } else {
        if (rem !== 0) {
          self.truncated = true;
        }
      }
      acc = quo;
      read_index = read_index - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (BigInt.asIntN(64, acc) > BigInt.asIntN(64, 0n)) {
      if (10n === 0n) {
        $panic();
      }
      const quo = BigInt.asUintN(64, BigInt.asIntN(64, acc) / BigInt.asIntN(64, 10n));
      const rem = Number(BigInt.asIntN(32, BigInt.asUintN(64, acc - BigInt.asUintN(64, 10n * quo)))) | 0;
      write_index = write_index - 1 | 0;
      if (write_index < self.digits.length) {
        const _tmp$38 = self.digits;
        const _tmp$39 = write_index;
        $bound_check(_tmp$38, _tmp$39);
        _tmp$38[_tmp$39] = rem & 255;
      } else {
        if (rem !== 0) {
          self.truncated = true;
        }
      }
      acc = quo;
      continue;
    } else {
      break;
    }
  }
  self.digits_num = self.digits_num + new_digits | 0;
  if (self.digits_num > self.digits.length) {
    self.digits_num = self.digits.length;
  }
  self.decimal_point = self.decimal_point + new_digits | 0;
  _M0MPC28internal7strconv7Decimal4trim(self);
}
function _M0MPC28internal7strconv7Decimal12right__shift(self, s) {
  let read_index = 0;
  let write_index = 0;
  let acc = 0n;
  while (true) {
    if (BigInt.asUintN(64, BigInt.asUintN(64, BigInt.asUintN(64, acc) >> BigInt(s & 63))) === BigInt.asUintN(64, 0n)) {
      if (read_index >= self.digits_num) {
        while (true) {
          if (BigInt.asUintN(64, BigInt.asUintN(64, BigInt.asUintN(64, acc) >> BigInt(s & 63))) === BigInt.asUintN(64, 0n)) {
            acc = BigInt.asUintN(64, acc * 10n);
            read_index = read_index + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        break;
      }
      const _tmp$38 = self.digits;
      const _tmp$39 = read_index;
      $bound_check(_tmp$38, _tmp$39);
      const d = _tmp$38[_tmp$39];
      acc = BigInt.asUintN(64, BigInt.asUintN(64, acc * 10n) + BigInt.asUintN(64, BigInt(d)));
      read_index = read_index + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.decimal_point = self.decimal_point - (read_index - 1 | 0) | 0;
  const mask = BigInt.asUintN(64, BigInt.asUintN(64, 1n << BigInt(s & 63)) - 1n);
  while (true) {
    if (read_index < self.digits_num) {
      const out = BigInt.asUintN(64, BigInt.asUintN(64, acc) >> BigInt(s & 63));
      const _tmp$38 = self.digits;
      const _tmp$39 = write_index;
      $bound_check(_tmp$38, _tmp$39);
      _tmp$38[_tmp$39] = (Number(BigInt.asIntN(32, out)) | 0) & 255;
      write_index = write_index + 1 | 0;
      acc = BigInt.asUintN(64, acc & mask);
      const _tmp$40 = self.digits;
      const _tmp$41 = read_index;
      $bound_check(_tmp$40, _tmp$41);
      const d = _tmp$40[_tmp$41];
      acc = BigInt.asUintN(64, BigInt.asUintN(64, acc * 10n) + BigInt.asUintN(64, BigInt(d)));
      read_index = read_index + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (BigInt.asUintN(64, acc) > BigInt.asUintN(64, 0n)) {
      const out = BigInt.asUintN(64, BigInt.asUintN(64, acc) >> BigInt(s & 63));
      if (write_index < self.digits.length) {
        const _tmp$38 = self.digits;
        const _tmp$39 = write_index;
        $bound_check(_tmp$38, _tmp$39);
        _tmp$38[_tmp$39] = (Number(BigInt.asIntN(32, out)) | 0) & 255;
        write_index = write_index + 1 | 0;
      } else {
        if (BigInt.asUintN(64, out) > BigInt.asUintN(64, 0n)) {
          self.truncated = true;
        }
      }
      acc = BigInt.asUintN(64, acc & mask);
      acc = BigInt.asUintN(64, acc * 10n);
      continue;
    } else {
      break;
    }
  }
  self.digits_num = write_index;
  _M0MPC28internal7strconv7Decimal4trim(self);
}
function _M0MPC28internal7strconv7Decimal11shift__priv(self, s) {
  if (self.digits_num === 0) {
    return undefined;
  }
  let s$2 = s;
  if (s$2 > 0) {
    while (true) {
      if (s$2 > 59) {
        _M0MPC28internal7strconv7Decimal11left__shift(self, 59);
        s$2 = s$2 - 59 | 0;
        continue;
      } else {
        break;
      }
    }
    _M0MPC28internal7strconv7Decimal11left__shift(self, s$2);
  }
  if (s$2 < 0) {
    while (true) {
      if (s$2 < -59) {
        _M0MPC28internal7strconv7Decimal12right__shift(self, 59);
        s$2 = s$2 + 59 | 0;
        continue;
      } else {
        break;
      }
    }
    _M0MPC28internal7strconv7Decimal12right__shift(self, -s$2 | 0);
    return;
  } else {
    return;
  }
}
function _M0MPC28internal7strconv7Decimal16to__double__priv(self) {
  let exponent = 0;
  let mantissa = 0n;
  if (self.digits_num === 0 || self.decimal_point < -330) {
    mantissa = 0n;
    exponent = _M0FPC28internal7strconv12double__info.bias;
    const bits = _M0FPC28internal7strconv14assemble__bits(mantissa, exponent, self.negative);
    return new _M0DTPC16result6ResultGdRPC15error5ErrorE2Ok($i64_reinterpret_f64(bits));
  }
  if (self.decimal_point > 310) {
    const _bind$4 = _M0FPC28internal7strconv10range__errGuE();
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _ok._0;
    } else {
      return _bind$4;
    }
  }
  while (true) {
    if (self.decimal_point > 0) {
      let n = 0;
      if (self.decimal_point >= _M0FPC28internal7strconv6powtab.length) {
        n = 60;
      } else {
        const _p$4 = self.decimal_point;
        $bound_check(_M0FPC28internal7strconv6powtab, _p$4);
        n = _M0FPC28internal7strconv6powtab[_p$4];
      }
      _M0MPC28internal7strconv7Decimal11shift__priv(self, -n | 0);
      exponent = exponent + n | 0;
      continue;
    } else {
      break;
    }
  }
  while (true) {
    let _tmp$38;
    if (self.decimal_point < 0) {
      _tmp$38 = true;
    } else {
      let _tmp$39;
      if (self.decimal_point === 0) {
        const _tmp$40 = self.digits;
        $bound_check(_tmp$40, 0);
        _tmp$39 = _tmp$40[0] < 5;
      } else {
        _tmp$39 = false;
      }
      _tmp$38 = _tmp$39;
    }
    if (_tmp$38) {
      let n = 0;
      if ((-self.decimal_point | 0) >= _M0FPC28internal7strconv6powtab.length) {
        n = 60;
      } else {
        const _p$4 = -self.decimal_point | 0;
        $bound_check(_M0FPC28internal7strconv6powtab, _p$4);
        n = _M0FPC28internal7strconv6powtab[_p$4];
      }
      _M0MPC28internal7strconv7Decimal11shift__priv(self, n);
      exponent = exponent - n | 0;
      continue;
    } else {
      break;
    }
  }
  exponent = exponent - 1 | 0;
  if (exponent < (_M0FPC28internal7strconv12double__info.bias + 1 | 0)) {
    const n = (_M0FPC28internal7strconv12double__info.bias + 1 | 0) - exponent | 0;
    _M0MPC28internal7strconv7Decimal11shift__priv(self, -n | 0);
    exponent = exponent + n | 0;
  }
  if ((exponent - _M0FPC28internal7strconv12double__info.bias | 0) >= ((1 << _M0FPC28internal7strconv12double__info.exponent_bits) - 1 | 0)) {
    const _bind$4 = _M0FPC28internal7strconv10range__errGuE();
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _ok._0;
    } else {
      return _bind$4;
    }
  }
  _M0MPC28internal7strconv7Decimal11shift__priv(self, _M0FPC28internal7strconv12double__info.mantissa_bits + 1 | 0);
  mantissa = _M0MPC28internal7strconv7Decimal16rounded__integer(self);
  if (BigInt.asUintN(64, mantissa) === BigInt.asUintN(64, BigInt.asUintN(64, 2n << BigInt(_M0FPC28internal7strconv12double__info.mantissa_bits & 63)))) {
    mantissa = BigInt.asUintN(64, BigInt.asIntN(64, mantissa) >> BigInt(1 & 63));
    exponent = exponent + 1 | 0;
    if ((exponent - _M0FPC28internal7strconv12double__info.bias | 0) >= ((1 << _M0FPC28internal7strconv12double__info.exponent_bits) - 1 | 0)) {
      const _bind$4 = _M0FPC28internal7strconv10range__errGuE();
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        _ok._0;
      } else {
        return _bind$4;
      }
    }
  }
  if (BigInt.asUintN(64, BigInt.asUintN(64, mantissa & BigInt.asUintN(64, 1n << BigInt(_M0FPC28internal7strconv12double__info.mantissa_bits & 63)))) === BigInt.asUintN(64, 0n)) {
    exponent = _M0FPC28internal7strconv12double__info.bias;
  }
  const bits = _M0FPC28internal7strconv14assemble__bits(mantissa, exponent, self.negative);
  return new _M0DTPC16result6ResultGdRPC15error5ErrorE2Ok($i64_reinterpret_f64(bits));
}
function _M0FPC28internal7strconv17pow10__fast__path(exponent) {
  const _p$4 = exponent & 31;
  $bound_check(_M0FPC28internal7strconv5table, _p$4);
  return _M0FPC28internal7strconv5table[_p$4];
}
function _M0MPC28internal7strconv6Number14is__fast__path(self) {
  return BigInt.asIntN(64, _M0FPC28internal7strconv25min__exponent__fast__path) <= BigInt.asIntN(64, self.exponent) && (BigInt.asIntN(64, self.exponent) <= BigInt.asIntN(64, _M0FPC28internal7strconv36max__exponent__disguised__fast__path) && (BigInt.asUintN(64, self.mantissa) <= BigInt.asUintN(64, _M0FPC28internal7strconv25max__mantissa__fast__path) && !self.many_digits));
}
function _M0MPC28internal7strconv6Number15try__fast__path(self) {
  if (_M0MPC28internal7strconv6Number14is__fast__path(self)) {
    let value;
    if (BigInt.asIntN(64, self.exponent) <= BigInt.asIntN(64, _M0FPC28internal7strconv25max__exponent__fast__path)) {
      const value$2 = $f64_convert_i64_u(BigInt.asUintN(64, self.mantissa));
      value = BigInt.asIntN(64, self.exponent) < BigInt.asIntN(64, 0n) ? value$2 / _M0FPC28internal7strconv17pow10__fast__path(-(Number(BigInt.asIntN(32, self.exponent)) | 0) | 0) : value$2 * _M0FPC28internal7strconv17pow10__fast__path(Number(BigInt.asIntN(32, self.exponent)) | 0);
    } else {
      const shift = BigInt.asUintN(64, self.exponent - _M0FPC28internal7strconv25max__exponent__fast__path);
      const _tmp$38 = self.mantissa;
      const _p$4 = Number(BigInt.asIntN(32, shift)) | 0;
      $bound_check(_M0FPC28internal7strconv10int__pow10, _p$4);
      const _bind$4 = _M0FPC28internal7strconv12checked__mul(_tmp$38, _M0FPC28internal7strconv10int__pow10[_p$4]);
      let mantissa;
      if (_bind$4 === undefined) {
        return _M0DTPC16option6OptionGdE4None__;
      } else {
        const _Some = _bind$4;
        mantissa = _Some;
      }
      if (BigInt.asUintN(64, mantissa) > BigInt.asUintN(64, _M0FPC28internal7strconv25max__mantissa__fast__path)) {
        return _M0DTPC16option6OptionGdE4None__;
      }
      value = $f64_convert_i64_u(BigInt.asUintN(64, mantissa)) * _M0FPC28internal7strconv17pow10__fast__path(Number(BigInt.asIntN(32, _M0FPC28internal7strconv25max__exponent__fast__path)) | 0);
    }
    if (self.negative) {
      value = -value;
    }
    return new _M0DTPC16option6OptionGdE4Some(value);
  } else {
    return _M0DTPC16option6OptionGdE4None__;
  }
}
function _M0FPC28internal7strconv13parse__double(str) {
  if ((str.end - str.start | 0) > 0) {
    if (_M0FPC28internal7strconv17check__underscore(str)) {
      const _bind$4 = _M0FPC28internal7strconv13parse__number(str);
      let _bind$5;
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        _bind$5 = _ok._0;
      } else {
        return _bind$4;
      }
      if (_bind$5 === undefined) {
        return _M0FPC28internal7strconv15parse__inf__nan(str);
      } else {
        const _Some = _bind$5;
        const _num = _Some;
        const _bind$6 = _M0MPC28internal7strconv6Number15try__fast__path(_num);
        if (_bind$6.$tag === 1) {
          const _Some$2 = _bind$6;
          const _value = _Some$2._0;
          return new _M0DTPC16result6ResultGdRPC15error5ErrorE2Ok(_value);
        } else {
          const _bind$7 = _M0FPC28internal7strconv20parse__decimal__priv(str);
          let _tmp$38;
          if (_bind$7.$tag === 1) {
            const _ok = _bind$7;
            _tmp$38 = _ok._0;
          } else {
            return _bind$7;
          }
          return _M0MPC28internal7strconv7Decimal16to__double__priv(_tmp$38);
        }
      }
    } else {
      return _M0FPC28internal7strconv11syntax__errGdE();
    }
  } else {
    return _M0FPC28internal7strconv11syntax__errGdE();
  }
}
function _M0MPC17hashmap7HashMap5clearGsiE(self) {
  _M0MPC15array10FixedArray12fill_2einnerGORPC17hashmap5EntryGsiEE(self.entries, undefined, 0, undefined);
  self.size = 0;
}
function _M0MPC17hashmap7HashMap5clearGssE(self) {
  _M0MPC15array10FixedArray12fill_2einnerGORPC17hashmap5EntryGsiEE(self.entries, undefined, 0, undefined);
  self.size = 0;
}
function _M0MPC17hashmap7HashMap4iterGsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEE(self) {
  const i = new _M0TPB8MutLocalGiE(0);
  const len = self.entries.length;
  return _M0MPB4Iter3newGUssEE(() => {
    while (true) {
      if (i.val < len) {
        const entry = self.entries[i.val];
        i.val = i.val + 1 | 0;
        if (entry === undefined) {
        } else {
          const _Some = entry;
          const _x = _Some;
          const _key = _x.key;
          const _value = _x.value;
          return { _0: _key, _1: _value };
        }
        continue;
      } else {
        return undefined;
      }
    }
  }, self.size);
}
function _M0FPC17hashmap12new__hashmapGsiE(capacity) {
  const capacity$2 = _M0MPC13int3Int20next__power__of__two(capacity);
  const _bind$4 = $make_array_len_and_init(capacity$2, undefined);
  const _bind$5 = capacity$2 - 1 | 0;
  return new _M0TPC17hashmap7HashMapGsiE(_bind$4, capacity$2, _bind$5, 0);
}
function _M0FPC17hashmap12new__hashmapGssE(capacity) {
  const capacity$2 = _M0MPC13int3Int20next__power__of__two(capacity);
  const _bind$4 = $make_array_len_and_init(capacity$2, undefined);
  const _bind$5 = capacity$2 - 1 | 0;
  return new _M0TPC17hashmap7HashMapGssE(_bind$4, capacity$2, _bind$5, 0);
}
function _M0MPC17hashmap7HashMap10push__awayGsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEE(self, idx, entry) {
  let _tmp$38 = entry.psl + 1 | 0;
  let _tmp$39 = idx + 1 & self.capacity_mask;
  let _tmp$40 = entry;
  while (true) {
    const psl = _tmp$38;
    const idx$2 = _tmp$39;
    const entry$2 = _tmp$40;
    const _tmp$41 = self.entries;
    $bound_check(_tmp$41, idx$2);
    const _bind$4 = _tmp$41[idx$2];
    if (_bind$4 === undefined) {
      entry$2.psl = psl;
      const _tmp$42 = self.entries;
      $bound_check(_tmp$42, idx$2);
      _tmp$42[idx$2] = entry$2;
      return;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (psl > _curr_entry.psl) {
        entry$2.psl = psl;
        const _tmp$42 = self.entries;
        $bound_check(_tmp$42, idx$2);
        _tmp$42[idx$2] = entry$2;
        _tmp$38 = _curr_entry.psl + 1 | 0;
        _tmp$39 = idx$2 + 1 & self.capacity_mask;
        _tmp$40 = _curr_entry;
        continue;
      } else {
        _tmp$38 = psl + 1 | 0;
        _tmp$39 = idx$2 + 1 & self.capacity_mask;
        continue;
      }
    }
  }
}
function _M0MPC17hashmap7HashMap10push__awayGsiE(self, idx, entry) {
  let _tmp$38 = entry.psl + 1 | 0;
  let _tmp$39 = idx + 1 & self.capacity_mask;
  let _tmp$40 = entry;
  while (true) {
    const psl = _tmp$38;
    const idx$2 = _tmp$39;
    const entry$2 = _tmp$40;
    const _tmp$41 = self.entries;
    $bound_check(_tmp$41, idx$2);
    const _bind$4 = _tmp$41[idx$2];
    if (_bind$4 === undefined) {
      entry$2.psl = psl;
      const _tmp$42 = self.entries;
      $bound_check(_tmp$42, idx$2);
      _tmp$42[idx$2] = entry$2;
      return;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (psl > _curr_entry.psl) {
        entry$2.psl = psl;
        const _tmp$42 = self.entries;
        $bound_check(_tmp$42, idx$2);
        _tmp$42[idx$2] = entry$2;
        _tmp$38 = _curr_entry.psl + 1 | 0;
        _tmp$39 = idx$2 + 1 & self.capacity_mask;
        _tmp$40 = _curr_entry;
        continue;
      } else {
        _tmp$38 = psl + 1 | 0;
        _tmp$39 = idx$2 + 1 & self.capacity_mask;
        continue;
      }
    }
  }
}
function _M0MPC17hashmap7HashMap15set__with__hashGsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEE(self, key, value, hash) {
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const psl = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      if (self.size >= (self.capacity / 2 | 0)) {
        _M0MPC17hashmap7HashMap4growGsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEE(self);
        _tmp$38 = 0;
        _tmp$39 = hash & self.capacity_mask;
        continue;
      }
      const entry = new _M0TPC17hashmap5EntryGsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEE(psl, hash, key, value);
      const _tmp$41 = self.entries;
      $bound_check(_tmp$41, idx);
      _tmp$41[idx] = entry;
      self.size = self.size + 1 | 0;
      return undefined;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (_curr_entry.hash === hash && _curr_entry.key === key) {
        _curr_entry.value = value;
        return undefined;
      }
      if (psl > _curr_entry.psl) {
        if (self.size >= (self.capacity / 2 | 0)) {
          _M0MPC17hashmap7HashMap4growGsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEE(self);
          _tmp$38 = 0;
          _tmp$39 = hash & self.capacity_mask;
          continue;
        }
        _M0MPC17hashmap7HashMap10push__awayGsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEE(self, idx, _curr_entry);
        const entry = new _M0TPC17hashmap5EntryGsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEE(psl, hash, key, value);
        const _tmp$41 = self.entries;
        $bound_check(_tmp$41, idx);
        _tmp$41[idx] = entry;
        self.size = self.size + 1 | 0;
        return undefined;
      }
      _tmp$38 = psl + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPC17hashmap7HashMap15set__with__hashGsiE(self, key, value, hash) {
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const psl = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      if (self.size >= (self.capacity / 2 | 0)) {
        _M0MPC17hashmap7HashMap4growGsiE(self);
        _tmp$38 = 0;
        _tmp$39 = hash & self.capacity_mask;
        continue;
      }
      const entry = new _M0TPC17hashmap5EntryGsiE(psl, hash, key, value);
      const _tmp$41 = self.entries;
      $bound_check(_tmp$41, idx);
      _tmp$41[idx] = entry;
      self.size = self.size + 1 | 0;
      return undefined;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (_curr_entry.hash === hash && _curr_entry.key === key) {
        _curr_entry.value = value;
        return undefined;
      }
      if (psl > _curr_entry.psl) {
        if (self.size >= (self.capacity / 2 | 0)) {
          _M0MPC17hashmap7HashMap4growGsiE(self);
          _tmp$38 = 0;
          _tmp$39 = hash & self.capacity_mask;
          continue;
        }
        _M0MPC17hashmap7HashMap10push__awayGsiE(self, idx, _curr_entry);
        const entry = new _M0TPC17hashmap5EntryGsiE(psl, hash, key, value);
        const _tmp$41 = self.entries;
        $bound_check(_tmp$41, idx);
        _tmp$41[idx] = entry;
        self.size = self.size + 1 | 0;
        return undefined;
      }
      _tmp$38 = psl + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPC17hashmap7HashMap15set__with__hashGssE(self, key, value, hash) {
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const psl = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      if (self.size >= (self.capacity / 2 | 0)) {
        _M0MPC17hashmap7HashMap4growGssE(self);
        _tmp$38 = 0;
        _tmp$39 = hash & self.capacity_mask;
        continue;
      }
      const entry = new _M0TPC17hashmap5EntryGssE(psl, hash, key, value);
      const _tmp$41 = self.entries;
      $bound_check(_tmp$41, idx);
      _tmp$41[idx] = entry;
      self.size = self.size + 1 | 0;
      return undefined;
    } else {
      const _Some = _bind$4;
      const _curr_entry = _Some;
      if (_curr_entry.hash === hash && _curr_entry.key === key) {
        _curr_entry.value = value;
        return undefined;
      }
      if (psl > _curr_entry.psl) {
        if (self.size >= (self.capacity / 2 | 0)) {
          _M0MPC17hashmap7HashMap4growGssE(self);
          _tmp$38 = 0;
          _tmp$39 = hash & self.capacity_mask;
          continue;
        }
        _M0MPC17hashmap7HashMap10push__awayGsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEE(self, idx, _curr_entry);
        const entry = new _M0TPC17hashmap5EntryGssE(psl, hash, key, value);
        const _tmp$41 = self.entries;
        $bound_check(_tmp$41, idx);
        _tmp$41[idx] = entry;
        self.size = self.size + 1 | 0;
        return undefined;
      }
      _tmp$38 = psl + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPC17hashmap7HashMap4growGsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEE(self) {
  const old_entries = self.entries;
  const new_capacity = self.capacity << 1;
  self.entries = $make_array_len_and_init(new_capacity, undefined);
  self.capacity = new_capacity;
  self.capacity_mask = new_capacity - 1 | 0;
  self.size = 0;
  const _bind$4 = old_entries.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const entry = old_entries[_];
      if (entry === undefined) {
      } else {
        const _Some = entry;
        const _x = _Some;
        const _key = _x.key;
        const _value = _x.value;
        const _hash = _x.hash;
        _M0MPC17hashmap7HashMap15set__with__hashGsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEE(self, _key, _value, _hash);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0MPC17hashmap7HashMap4growGsiE(self) {
  const old_entries = self.entries;
  const new_capacity = self.capacity << 1;
  self.entries = $make_array_len_and_init(new_capacity, undefined);
  self.capacity = new_capacity;
  self.capacity_mask = new_capacity - 1 | 0;
  self.size = 0;
  const _bind$4 = old_entries.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const entry = old_entries[_];
      if (entry === undefined) {
      } else {
        const _Some = entry;
        const _x = _Some;
        const _key = _x.key;
        const _value = _x.value;
        const _hash = _x.hash;
        _M0MPC17hashmap7HashMap15set__with__hashGsiE(self, _key, _value, _hash);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0MPC17hashmap7HashMap4growGssE(self) {
  const old_entries = self.entries;
  const new_capacity = self.capacity << 1;
  self.entries = $make_array_len_and_init(new_capacity, undefined);
  self.capacity = new_capacity;
  self.capacity_mask = new_capacity - 1 | 0;
  self.size = 0;
  const _bind$4 = old_entries.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const entry = old_entries[_];
      if (entry === undefined) {
      } else {
        const _Some = entry;
        const _x = _Some;
        const _key = _x.key;
        const _value = _x.value;
        const _hash = _x.hash;
        _M0MPC17hashmap7HashMap15set__with__hashGssE(self, _key, _value, _hash);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0MPC17hashmap7HashMap3setGsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEE(self, key, value) {
  _M0MPC17hashmap7HashMap15set__with__hashGsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEE(self, key, value, _M0IP016_24default__implPB4Hash4hashGsE(key));
}
function _M0MPC17hashmap7HashMap3setGsiE(self, key, value) {
  _M0MPC17hashmap7HashMap15set__with__hashGsiE(self, key, value, _M0IP016_24default__implPB4Hash4hashGsE(key));
}
function _M0MPC17hashmap7HashMap3setGssE(self, key, value) {
  _M0MPC17hashmap7HashMap15set__with__hashGssE(self, key, value, _M0IP016_24default__implPB4Hash4hashGsE(key));
}
function _M0MPC17hashmap7HashMap3getGsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return _entry.value;
      }
      if (i > _entry.psl) {
        return undefined;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPC17hashmap7HashMap3getGsiE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return _entry.value;
      }
      if (i > _entry.psl) {
        return undefined;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPC17hashmap7HashMap3getGssE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return _entry.value;
      }
      if (i > _entry.psl) {
        return undefined;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPC17hashmap7HashMap8containsGsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return false;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return true;
      }
      if (i > _entry.psl) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPC17hashmap7HashMap8containsGssE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp$38 = 0;
  let _tmp$39 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp$38;
    const idx = _tmp$39;
    const _tmp$40 = self.entries;
    $bound_check(_tmp$40, idx);
    const _bind$4 = _tmp$40[idx];
    if (_bind$4 === undefined) {
      return false;
    } else {
      const _Some = _bind$4;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return true;
      }
      if (i > _entry.psl) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      _tmp$39 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPC17hashmap7HashMap11new_2einnerGsiE(capacity) {
  return _M0FPC17hashmap12new__hashmapGsiE(capacity);
}
function _M0MPC17hashmap7HashMap11new_2einnerGssE(capacity) {
  return _M0FPC17hashmap12new__hashmapGssE(capacity);
}
function _M0MPC17hashmap7HashMap3newGsiE(capacity$46$opt) {
  let capacity;
  if (capacity$46$opt === undefined) {
    capacity = 8;
  } else {
    const _Some = capacity$46$opt;
    capacity = _Some;
  }
  return _M0MPC17hashmap7HashMap11new_2einnerGsiE(capacity);
}
function _M0MPC17hashmap7HashMap3newGssE(capacity$46$opt) {
  let capacity;
  if (capacity$46$opt === undefined) {
    capacity = 8;
  } else {
    const _Some = capacity$46$opt;
    capacity = _Some;
  }
  return _M0MPC17hashmap7HashMap11new_2einnerGssE(capacity);
}
function _M0MPC16buffer6Buffer19grow__if__necessary(self, required) {
  const start = self.data.length <= 0 ? 1 : self.data.length;
  let enough_space;
  let _tmp$38 = start;
  while (true) {
    const space = _tmp$38;
    if (space >= required) {
      enough_space = space;
      break;
    }
    _tmp$38 = Math.imul(space, 2) | 0;
    continue;
  }
  if (enough_space !== self.data.length) {
    const new_data = $makebytes(enough_space, 0);
    _M0MPC15array10FixedArray12unsafe__blitGyE(new_data, 0, self.data, 0, self.len);
    self.data = new_data;
    return;
  } else {
    return;
  }
}
function _M0MPC16buffer6Buffer11write__byte(self, value) {
  _M0MPC16buffer6Buffer19grow__if__necessary(self, self.len + 1 | 0);
  const _tmp$38 = self.data;
  const _tmp$39 = self.len;
  $bound_check(_tmp$38, _tmp$39);
  _tmp$38[_tmp$39] = value;
  self.len = self.len + 1 | 0;
}
function _M0MPC16buffer6Buffer9to__bytes(self) {
  return _M0MPC15bytes5Bytes11from__array(_M0MPC15array10FixedArray12view_2einnerGyE(self.data, 0, self.len));
}
function _M0FPC16buffer11new_2einner(size_hint) {
  const initial = size_hint < 1 ? 1 : size_hint;
  const data = $makebytes(initial, 0);
  return new _M0TPC16buffer6Buffer(data, 0);
}
function _M0IPC16buffer6BufferPB6Logger13write__string(self, value) {
  _M0MPC16buffer6Buffer19grow__if__necessary(self, self.len + (Math.imul(value.length, 2) | 0) | 0);
  _M0MPC15array10FixedArray18blit__from__string(self.data, self.len, value, 0, value.length);
  self.len = self.len + (Math.imul(value.length, 2) | 0) | 0;
}
function _M0IPC16buffer6BufferPB6Logger11write__char(self, value) {
  _M0MPC16buffer6Buffer19grow__if__necessary(self, self.len + 4 | 0);
  const inc = _M0MPC15array10FixedArray18set__utf16le__char(self.data, self.len, value);
  self.len = self.len + inc | 0;
}
function _M0MPC16buffer6Buffer5reset(self) {
  self.len = 0;
}
function _M0IPC16buffer6BufferPB4Show6output(self, logger) {
  logger.method_table.method_0(logger.self, _M0MPC15bytes5Bytes29to__unchecked__string_2einner(_M0MPC16buffer6Buffer9to__bytes(self), 0, undefined));
}
function _M0FPC14json20offset__to__position(input, offset) {
  let _tmp$38 = 0;
  let _tmp$39 = 1;
  let _tmp$40 = 0;
  while (true) {
    const i = _tmp$38;
    const line = _tmp$39;
    const column = _tmp$40;
    if (i < offset) {
      const _p$4 = input.str.charCodeAt(input.start + i | 0);
      const _p$5 = 10;
      if (_p$4 === _p$5) {
        _tmp$38 = i + 1 | 0;
        _tmp$39 = line + 1 | 0;
        _tmp$40 = 0;
        continue;
      } else {
        _tmp$38 = i + 1 | 0;
        _tmp$40 = column + 1 | 0;
        continue;
      }
    } else {
      return new _M0TPC14json8Position(line, column);
    }
  }
}
function _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, shift) {
  const offset = ctx.offset + shift | 0;
  const _p$4 = _M0MPC16string10StringView9get__char(ctx.input, offset);
  const _p$5 = 65533;
  return new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE3Err(new _M0DTPC15error5Error52moonbitlang_2fcore_2fjson_2eParseError_2eInvalidChar(_M0FPC14json20offset__to__position(ctx.input, offset), _p$4 === -1 ? _p$5 : _p$4));
}
function _M0MPC14json12ParseContext21invalid__char_2einnerGuE(ctx, shift) {
  const offset = ctx.offset + shift | 0;
  const _p$4 = _M0MPC16string10StringView9get__char(ctx.input, offset);
  const _p$5 = 65533;
  return new _M0DTPC16result6ResultGuRPC14json10ParseErrorE3Err(new _M0DTPC15error5Error52moonbitlang_2fcore_2fjson_2eParseError_2eInvalidChar(_M0FPC14json20offset__to__position(ctx.input, offset), _p$4 === -1 ? _p$5 : _p$4));
}
function _M0IPC14json10ParseErrorPB4Show6output(self, logger) {
  switch (self.$tag) {
    case 10: {
      const _InvalidChar = self;
      const _x = _InvalidChar._0;
      const _line = _x.line;
      const _column = _x.column;
      const _c = _InvalidChar._1;
      logger.method_table.method_0(logger.self, "Invalid character ");
      logger.method_table.method_0(logger.self, _M0MPC14char4Char14escape_2einner(_c, true));
      logger.method_table.method_0(logger.self, " at line ");
      _M0MPB6Logger13write__objectGiE(logger, _line);
      logger.method_table.method_0(logger.self, ", column ");
      _M0MPB6Logger13write__objectGiE(logger, _column);
      return;
    }
    case 9: {
      logger.method_table.method_0(logger.self, "Unexpected end of file");
      return;
    }
    case 8: {
      const _InvalidNumber = self;
      const _x$2 = _InvalidNumber._0;
      const _line$2 = _x$2.line;
      const _column$2 = _x$2.column;
      const _s = _InvalidNumber._1;
      logger.method_table.method_0(logger.self, "Invalid number ");
      logger.method_table.method_0(logger.self, _s);
      logger.method_table.method_0(logger.self, " at line ");
      _M0MPB6Logger13write__objectGiE(logger, _line$2);
      logger.method_table.method_0(logger.self, ", column ");
      _M0MPB6Logger13write__objectGiE(logger, _column$2);
      return;
    }
    case 7: {
      const _InvalidIdentEscape = self;
      const _x$3 = _InvalidIdentEscape._0;
      const _line$3 = _x$3.line;
      const _column$3 = _x$3.column;
      logger.method_table.method_0(logger.self, "Invalid escape sequence in identifier at line ");
      _M0MPB6Logger13write__objectGiE(logger, _line$3);
      logger.method_table.method_0(logger.self, ", column ");
      _M0MPB6Logger13write__objectGiE(logger, _column$3);
      return;
    }
    default: {
      logger.method_table.method_0(logger.self, "Depth limit exceeded, please increase the max_nesting_depth parameter");
      return;
    }
  }
}
function _M0IPC14json4JsonPB4Show6output(self, logger) {
  switch (self.$tag) {
    case 0: {
      logger.method_table.method_0(logger.self, "Null");
      return;
    }
    case 1: {
      logger.method_table.method_0(logger.self, "True");
      return;
    }
    case 2: {
      logger.method_table.method_0(logger.self, "False");
      return;
    }
    case 3: {
      const _Number = self;
      const _n = _Number._0;
      const _repr = _Number._1;
      logger.method_table.method_0(logger.self, "Number(");
      _M0IP016_24default__implPB4Show6outputGdE(_n, logger);
      if (_repr === undefined) {
      } else {
        const _Some = _repr;
        const _repr$2 = _Some;
        logger.method_table.method_0(logger.self, ", repr=");
        logger.method_table.method_0(logger.self, "Some(");
        _M0IP016_24default__implPB4Show6outputGsE(_repr$2, logger);
        logger.method_table.method_0(logger.self, ")");
      }
      logger.method_table.method_0(logger.self, ")");
      return;
    }
    case 4: {
      const _String = self;
      const _s = _String._0;
      logger.method_table.method_0(logger.self, "String(");
      _M0IP016_24default__implPB4Show6outputGsE(_s, logger);
      logger.method_table.method_0(logger.self, ")");
      return;
    }
    case 5: {
      const _Array = self;
      const _a = _Array._0;
      logger.method_table.method_0(logger.self, "Array(");
      _M0IPC15array5ArrayPB4Show6outputGRPB4JsonE(_a, logger);
      logger.method_table.method_0(logger.self, ")");
      return;
    }
    default: {
      const _Object = self;
      const _o = _Object._0;
      logger.method_table.method_0(logger.self, "Object(");
      _M0IPB3MapPB4Show6outputGsRPB4JsonE(_o, logger);
      logger.method_table.method_0(logger.self, ")");
      return;
    }
  }
}
function _M0MPC14json12ParseContext21lex__skip__whitespace(ctx) {
  const rest = _M0MPC16string10StringView12view_2einner(ctx.input, ctx.offset, ctx.end_offset);
  const _data = rest.str;
  const _start = rest.start;
  const _end = _start + (rest.end - rest.start | 0) | 0;
  let _cursor = _start;
  let accept_state = -1;
  let match_end = -1;
  _L: {
    if (_cursor < _end) {
      _L$2: {
        const _p$4 = _cursor;
        const next_char = _data.charCodeAt(_p$4);
        _cursor = _cursor + 1 | 0;
        if (next_char < 13) {
          if (next_char >= 9 && next_char <= 10) {
            break _L$2;
          } else {
            break _L;
          }
        } else {
          if (next_char > 13) {
            if (next_char === 32) {
              break _L$2;
            } else {
              break _L;
            }
          } else {
            break _L$2;
          }
        }
      }
      while (true) {
        accept_state = 0;
        match_end = _cursor;
        if (_cursor < _end) {
          _L$3: {
            const _p$4 = _cursor;
            const next_char = _data.charCodeAt(_p$4);
            _cursor = _cursor + 1 | 0;
            if (next_char < 13) {
              if (next_char >= 9 && next_char <= 10) {
                break _L$3;
              } else {
                break _L;
              }
            } else {
              if (next_char > 13) {
                if (next_char === 32) {
                  break _L$3;
                } else {
                  break _L;
                }
              } else {
                break _L$3;
              }
            }
          }
          continue;
        } else {
          break _L;
        }
      }
    } else {
      break _L;
    }
  }
  if (accept_state === 0) {
    const next = _M0MPC16string6String4view(_data, match_end, _end);
    ctx.offset = ctx.end_offset - (next.end - next.start | 0) | 0;
    return;
  } else {
    return;
  }
}
function _M0MPC14json12ParseContext4make(input, max_nesting_depth) {
  return new _M0TPC14json12ParseContext(0, input, input.end - input.start | 0, max_nesting_depth);
}
function _M0MPC14json12ParseContext19expect__ascii__char(ctx, c) {
  if (ctx.offset < ctx.end_offset) {
    const _p$4 = ctx.input;
    const _p$5 = ctx.offset;
    const c1 = _p$4.str.charCodeAt(_p$4.start + _p$5 | 0);
    ctx.offset = ctx.offset + 1 | 0;
    return c !== c1 ? _M0MPC14json12ParseContext21invalid__char_2einnerGuE(ctx, -1) : new _M0DTPC16result6ResultGuRPC14json10ParseErrorE2Ok(undefined);
  } else {
    return new _M0DTPC16result6ResultGuRPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
  }
}
function _M0MPC14json12ParseContext16lex__number__end(ctx, start, end) {
  const s = _M0MPC16string10StringView12view_2einner(ctx.input, start, end);
  if (!_M0MPC16string10StringView8contains(s, new _M0TPC16string10StringView(_M0MPC14json12ParseContext16lex__number__endN7_2abindS1120, 0, _M0MPC14json12ParseContext16lex__number__endN7_2abindS1120.length)) && (!_M0MPC16string10StringView8contains(s, new _M0TPC16string10StringView(_M0MPC14json12ParseContext16lex__number__endN7_2abindS1121, 0, _M0MPC14json12ParseContext16lex__number__endN7_2abindS1121.length)) && !_M0MPC16string10StringView8contains(s, new _M0TPC16string10StringView(_M0MPC14json12ParseContext16lex__number__endN7_2abindS1122, 0, _M0MPC14json12ParseContext16lex__number__endN7_2abindS1122.length)))) {
    let parsed_int;
    let _try_err;
    _L: {
      _L$2: {
        const _bind$4 = _M0FPC28internal7strconv20parse__int64_2einner(s, 0);
        let _tmp$38;
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          _tmp$38 = _ok._0;
        } else {
          const _err = _bind$4;
          _try_err = _err._0;
          break _L$2;
        }
        parsed_int = new _M0DTPC16result6ResultGlRPC15error5ErrorE2Ok(_tmp$38);
        break _L;
      }
      parsed_int = new _M0DTPC16result6ResultGlRPC15error5ErrorE3Err(_try_err);
    }
    _L$2: {
      if (parsed_int.$tag === 1) {
        const _Ok = parsed_int;
        const _i = _Ok._0;
        if (BigInt.asIntN(64, _i) <= BigInt.asIntN(64, 9007199254740991n) && BigInt.asIntN(64, _i) >= BigInt.asIntN(64, 18437736874454810625n)) {
          return { _0: $f64_convert_i64(BigInt.asIntN(64, _i)), _1: undefined };
        } else {
          break _L$2;
        }
      } else {
        break _L$2;
      }
    }
    _L$3: {
      if (_M0MPC16string6String24char__length__ge_2einner(s.str, 1, s.start, s.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(s.str, _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 0, s.start, s.end));
        if (_x === 45) {
          return { _0: _M0FPC16double13neg__infinity, _1: s };
        } else {
          break _L$3;
        }
      } else {
        break _L$3;
      }
    }
    return { _0: _M0FPC16double8infinity, _1: s };
  } else {
    let parsed_double;
    let _try_err;
    _L: {
      _L$2: {
        const _bind$4 = _M0FPC28internal7strconv13parse__double(s);
        let _tmp$38;
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          _tmp$38 = _ok._0;
        } else {
          const _err = _bind$4;
          _try_err = _err._0;
          break _L$2;
        }
        parsed_double = new _M0DTPC16result6ResultGdRPC15error5ErrorE2Ok(_tmp$38);
        break _L;
      }
      parsed_double = new _M0DTPC16result6ResultGdRPC15error5ErrorE3Err(_try_err);
    }
    if (parsed_double.$tag === 1) {
      const _Ok = parsed_double;
      const _d = _Ok._0;
      return { _0: _d, _1: undefined };
    } else {
      _L$2: {
        if (_M0MPC16string6String24char__length__ge_2einner(s.str, 1, s.start, s.end)) {
          const _x = _M0MPC16string6String16unsafe__char__at(s.str, _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 0, s.start, s.end));
          if (_x === 45) {
            return { _0: _M0FPC16double13neg__infinity, _1: s };
          } else {
            break _L$2;
          }
        } else {
          break _L$2;
        }
      }
      return { _0: _M0FPC16double8infinity, _1: s };
    }
  }
}
function _M0MPC14json12ParseContext10read__char(ctx) {
  if (ctx.offset < ctx.end_offset) {
    const _p$4 = ctx.input;
    const _p$5 = ctx.offset;
    const c1 = _p$4.str.charCodeAt(_p$4.start + _p$5 | 0);
    ctx.offset = ctx.offset + 1 | 0;
    if (c1 >= 55296 && c1 <= 56319) {
      if (ctx.offset < ctx.end_offset) {
        const _p$6 = ctx.input;
        const _p$7 = ctx.offset;
        const c2 = _p$6.str.charCodeAt(_p$6.start + _p$7 | 0);
        if (c2 >= 56320 && c2 <= 57343) {
          ctx.offset = ctx.offset + 1 | 0;
          const c3 = ((c1 << 10) + c2 | 0) - 56613888 | 0;
          return c3;
        }
      }
    }
    return c1;
  } else {
    return -1;
  }
}
function _M0MPC14json12ParseContext31lex__decimal__exponent__integer(ctx, start) {
  while (true) {
    const _bind$4 = _M0MPC14json12ParseContext10read__char(ctx);
    if (_bind$4 === -1) {
      return _M0MPC14json12ParseContext16lex__number__end(ctx, start, ctx.offset);
    } else {
      const _Some = _bind$4;
      const _c = _Some;
      if (_c >= 48 && _c <= 57) {
        continue;
      }
      ctx.offset = ctx.offset - 1 | 0;
      return _M0MPC14json12ParseContext16lex__number__end(ctx, start, ctx.offset);
    }
  }
}
function _M0MPC14json12ParseContext28lex__decimal__exponent__sign(ctx, start) {
  const _bind$4 = _M0MPC14json12ParseContext10read__char(ctx);
  if (_bind$4 === -1) {
    return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
  } else {
    const _Some = _bind$4;
    const _c = _Some;
    if (_c >= 48 && _c <= 57) {
      return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_M0MPC14json12ParseContext31lex__decimal__exponent__integer(ctx, start));
    }
    ctx.offset = ctx.offset - 1 | 0;
    return _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, 0);
  }
}
function _M0MPC14json12ParseContext22lex__decimal__exponent(ctx, start) {
  _L: {
    const _bind$4 = _M0MPC14json12ParseContext10read__char(ctx);
    if (_bind$4 === -1) {
      return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      switch (_x) {
        case 43: {
          break _L;
        }
        case 45: {
          break _L;
        }
        default: {
          if (_x >= 48 && _x <= 57) {
            return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_M0MPC14json12ParseContext31lex__decimal__exponent__integer(ctx, start));
          }
          ctx.offset = ctx.offset - 1 | 0;
          return _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, 0);
        }
      }
    }
  }
  const _bind$4 = _M0MPC14json12ParseContext28lex__decimal__exponent__sign(ctx, start);
  let _tmp$38;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _tmp$38 = _ok._0;
  } else {
    return _bind$4;
  }
  return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_tmp$38);
}
function _M0MPC14json12ParseContext22lex__decimal__fraction(ctx, start) {
  let _tmp$38;
  _L: while (true) {
    _L$2: {
      const _bind$4 = _M0MPC14json12ParseContext10read__char(ctx);
      if (_bind$4 === -1) {
        return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_M0MPC14json12ParseContext16lex__number__end(ctx, start, ctx.offset));
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        switch (_x) {
          case 101: {
            break _L$2;
          }
          case 69: {
            break _L$2;
          }
          default: {
            if (_x >= 48 && _x <= 57) {
              continue _L;
            }
            ctx.offset = ctx.offset - 1 | 0;
            return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_M0MPC14json12ParseContext16lex__number__end(ctx, start, ctx.offset));
          }
        }
      }
    }
    const _bind$4 = _M0MPC14json12ParseContext22lex__decimal__exponent(ctx, start);
    let _tmp$39;
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _tmp$39 = _ok._0;
    } else {
      return _bind$4;
    }
    return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_tmp$39);
  }
  return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_tmp$38);
}
function _M0MPC14json12ParseContext19lex__decimal__point(ctx, start) {
  const _bind$4 = _M0MPC14json12ParseContext10read__char(ctx);
  if (_bind$4 === -1) {
    return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
  } else {
    const _Some = _bind$4;
    const _c = _Some;
    return _c >= 48 && _c <= 57 ? _M0MPC14json12ParseContext22lex__decimal__fraction(ctx, start) : _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, -1);
  }
}
function _M0MPC14json12ParseContext21lex__decimal__integer(ctx, start) {
  let _tmp$38;
  _L: while (true) {
    _L$2: {
      const _bind$4 = _M0MPC14json12ParseContext10read__char(ctx);
      if (_bind$4 === -1) {
        return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_M0MPC14json12ParseContext16lex__number__end(ctx, start, ctx.offset));
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        switch (_x) {
          case 46: {
            const _bind$5 = _M0MPC14json12ParseContext19lex__decimal__point(ctx, start);
            let _tmp$39;
            if (_bind$5.$tag === 1) {
              const _ok = _bind$5;
              _tmp$39 = _ok._0;
            } else {
              return _bind$5;
            }
            return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_tmp$39);
          }
          case 101: {
            break _L$2;
          }
          case 69: {
            break _L$2;
          }
          default: {
            if (_x >= 48 && _x <= 57) {
              continue _L;
            }
            ctx.offset = ctx.offset - 1 | 0;
            return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_M0MPC14json12ParseContext16lex__number__end(ctx, start, ctx.offset));
          }
        }
      }
    }
    const _bind$4 = _M0MPC14json12ParseContext22lex__decimal__exponent(ctx, start);
    let _tmp$39;
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _tmp$39 = _ok._0;
    } else {
      return _bind$4;
    }
    return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_tmp$39);
  }
  return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_tmp$38);
}
function _M0MPC14json12ParseContext16lex__hex__digits(ctx, n) {
  let _tmp$38;
  let _tmp$39 = 0;
  let _tmp$40 = 0;
  while (true) {
    const _ = _tmp$39;
    const r = _tmp$40;
    if (_ < n) {
      const _bind$4 = _M0MPC14json12ParseContext10read__char(ctx);
      if (_bind$4 === -1) {
        return new _M0DTPC16result6ResultGiRPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
      } else {
        const _Some = _bind$4;
        const _c = _Some;
        if (_c >= 65) {
          const d = ((_c & ~32) - 65 | 0) + 10 | 0;
          if (d > 15) {
            const _bind$5 = _M0MPC14json12ParseContext21invalid__char_2einnerGuE(ctx, -1);
            if (_bind$5.$tag === 1) {
              const _ok = _bind$5;
              _ok._0;
            } else {
              return _bind$5;
            }
          }
          _tmp$39 = _ + 1 | 0;
          _tmp$40 = r << 4 | d;
          continue;
        } else {
          if (_c >= 48) {
            const d = _c - 48 | 0;
            if (d > 9) {
              const _bind$5 = _M0MPC14json12ParseContext21invalid__char_2einnerGuE(ctx, -1);
              if (_bind$5.$tag === 1) {
                const _ok = _bind$5;
                _ok._0;
              } else {
                return _bind$5;
              }
            }
            _tmp$39 = _ + 1 | 0;
            _tmp$40 = r << 4 | d;
            continue;
          } else {
            const _bind$5 = _M0MPC14json12ParseContext21invalid__char_2einnerGuE(ctx, -1);
            if (_bind$5.$tag === 1) {
              const _ok = _bind$5;
              _ok._0;
            } else {
              return _bind$5;
            }
          }
        }
      }
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      _tmp$38 = r;
      break;
    }
  }
  return new _M0DTPC16result6ResultGiRPC14json10ParseErrorE2Ok(_tmp$38);
}
function _M0MPC14json12ParseContext11lex__stringN5flushS276(_env, end) {
  const ctx = _env._2;
  const start = _env._1;
  const buf = _env._0;
  if (start.val > 0 && end > start.val) {
    _M0IPB13StringBuilderPB6Logger11write__view(buf, _M0MPC16string10StringView11sub_2einner(ctx.input, start.val, end));
    return;
  } else {
    return;
  }
}
function _M0MPC14json12ParseContext11lex__string(ctx) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const start = new _M0TPB8MutLocalGiE(ctx.offset);
  const _env = { _0: buf, _1: start, _2: ctx };
  _L: while (true) {
    _L$2: {
      _L$3: {
        const _bind$4 = _M0MPC14json12ParseContext10read__char(ctx);
        if (_bind$4 === -1) {
          return new _M0DTPC16result6ResultGsRPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
        } else {
          const _Some = _bind$4;
          const _x = _Some;
          switch (_x) {
            case 34: {
              _M0MPC14json12ParseContext11lex__stringN5flushS276(_env, ctx.offset - 1 | 0);
              break _L;
            }
            case 10: {
              break _L$3;
            }
            case 13: {
              break _L$3;
            }
            case 92: {
              _M0MPC14json12ParseContext11lex__stringN5flushS276(_env, ctx.offset - 1 | 0);
              const _bind$5 = _M0MPC14json12ParseContext10read__char(ctx);
              if (_bind$5 === -1) {
                return new _M0DTPC16result6ResultGsRPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
              } else {
                const _Some$2 = _bind$5;
                const _x$2 = _Some$2;
                switch (_x$2) {
                  case 98: {
                    _M0IPB13StringBuilderPB6Logger11write__char(buf, 8);
                    break;
                  }
                  case 102: {
                    _M0IPB13StringBuilderPB6Logger11write__char(buf, 12);
                    break;
                  }
                  case 110: {
                    _M0IPB13StringBuilderPB6Logger11write__char(buf, 10);
                    break;
                  }
                  case 114: {
                    _M0IPB13StringBuilderPB6Logger11write__char(buf, 13);
                    break;
                  }
                  case 116: {
                    _M0IPB13StringBuilderPB6Logger11write__char(buf, 9);
                    break;
                  }
                  case 34: {
                    _M0IPB13StringBuilderPB6Logger11write__char(buf, 34);
                    break;
                  }
                  case 92: {
                    _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
                    break;
                  }
                  case 47: {
                    _M0IPB13StringBuilderPB6Logger11write__char(buf, 47);
                    break;
                  }
                  case 117: {
                    const _bind$6 = _M0MPC14json12ParseContext16lex__hex__digits(ctx, 4);
                    let c;
                    if (_bind$6.$tag === 1) {
                      const _ok = _bind$6;
                      c = _ok._0;
                    } else {
                      return _bind$6;
                    }
                    _M0IPB13StringBuilderPB6Logger11write__char(buf, c);
                    break;
                  }
                  default: {
                    const _bind$7 = _M0MPC14json12ParseContext21invalid__char_2einnerGuE(ctx, -1);
                    if (_bind$7.$tag === 1) {
                      const _ok = _bind$7;
                      _ok._0;
                    } else {
                      return _bind$7;
                    }
                  }
                }
              }
              start.val = ctx.offset;
              break;
            }
            default: {
              if (_x < 32) {
                const _bind$6 = _M0MPC14json12ParseContext21invalid__char_2einnerGuE(ctx, -1);
                if (_bind$6.$tag === 1) {
                  const _ok = _bind$6;
                  _ok._0;
                } else {
                  return _bind$6;
                }
              } else {
                continue _L;
              }
            }
          }
        }
        break _L$2;
      }
      const _bind$4 = _M0MPC14json12ParseContext21invalid__char_2einnerGuE(ctx, -1);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        _ok._0;
      } else {
        return _bind$4;
      }
    }
    continue;
  }
  return new _M0DTPC16result6ResultGsRPC14json10ParseErrorE2Ok(buf.val);
}
function _M0MPC14json12ParseContext9lex__zero(ctx, start) {
  _L: {
    const _bind$4 = _M0MPC14json12ParseContext10read__char(ctx);
    if (_bind$4 === -1) {
      return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_M0MPC14json12ParseContext16lex__number__end(ctx, start, ctx.offset));
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      switch (_x) {
        case 46: {
          return _M0MPC14json12ParseContext19lex__decimal__point(ctx, start);
        }
        case 101: {
          break _L;
        }
        case 69: {
          break _L;
        }
        default: {
          if (_x >= 48 && _x <= 57) {
            ctx.offset = ctx.offset - 1 | 0;
            const _bind$5 = _M0MPC14json12ParseContext21invalid__char_2einnerGuE(ctx, 0);
            if (_bind$5.$tag === 1) {
              const _ok = _bind$5;
              _ok._0;
            } else {
              return _bind$5;
            }
          }
          ctx.offset = ctx.offset - 1 | 0;
          return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_M0MPC14json12ParseContext16lex__number__end(ctx, start, ctx.offset));
        }
      }
    }
  }
  return _M0MPC14json12ParseContext22lex__decimal__exponent(ctx, start);
}
function _M0MPC14json12ParseContext10lex__value(ctx, allow_rbracket) {
  _M0MPC14json12ParseContext21lex__skip__whitespace(ctx);
  const _bind$4 = _M0MPC14json12ParseContext10read__char(ctx);
  if (_bind$4 === -1) {
    return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    if (_x === 123) {
      return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(_M0DTPC14json5Token6LBrace__);
    } else {
      if (_x === 91) {
        return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(_M0DTPC14json5Token8LBracket__);
      } else {
        if (_x === 93) {
          if (allow_rbracket) {
            return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(_M0DTPC14json5Token8RBracket__);
          } else {
            return _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, -1);
          }
        } else {
          if (_x === 110) {
            const _bind$5 = _M0MPC14json12ParseContext19expect__ascii__char(ctx, 117);
            if (_bind$5.$tag === 1) {
              const _ok = _bind$5;
              _ok._0;
            } else {
              return _bind$5;
            }
            const _bind$6 = _M0MPC14json12ParseContext19expect__ascii__char(ctx, 108);
            if (_bind$6.$tag === 1) {
              const _ok = _bind$6;
              _ok._0;
            } else {
              return _bind$6;
            }
            const _bind$7 = _M0MPC14json12ParseContext19expect__ascii__char(ctx, 108);
            if (_bind$7.$tag === 1) {
              const _ok = _bind$7;
              _ok._0;
            } else {
              return _bind$7;
            }
            return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(_M0DTPC14json5Token4Null__);
          } else {
            if (_x === 116) {
              const _bind$5 = _M0MPC14json12ParseContext19expect__ascii__char(ctx, 114);
              if (_bind$5.$tag === 1) {
                const _ok = _bind$5;
                _ok._0;
              } else {
                return _bind$5;
              }
              const _bind$6 = _M0MPC14json12ParseContext19expect__ascii__char(ctx, 117);
              if (_bind$6.$tag === 1) {
                const _ok = _bind$6;
                _ok._0;
              } else {
                return _bind$6;
              }
              const _bind$7 = _M0MPC14json12ParseContext19expect__ascii__char(ctx, 101);
              if (_bind$7.$tag === 1) {
                const _ok = _bind$7;
                _ok._0;
              } else {
                return _bind$7;
              }
              return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(_M0DTPC14json5Token4True__);
            } else {
              if (_x === 102) {
                const _bind$5 = _M0MPC14json12ParseContext19expect__ascii__char(ctx, 97);
                if (_bind$5.$tag === 1) {
                  const _ok = _bind$5;
                  _ok._0;
                } else {
                  return _bind$5;
                }
                const _bind$6 = _M0MPC14json12ParseContext19expect__ascii__char(ctx, 108);
                if (_bind$6.$tag === 1) {
                  const _ok = _bind$6;
                  _ok._0;
                } else {
                  return _bind$6;
                }
                const _bind$7 = _M0MPC14json12ParseContext19expect__ascii__char(ctx, 115);
                if (_bind$7.$tag === 1) {
                  const _ok = _bind$7;
                  _ok._0;
                } else {
                  return _bind$7;
                }
                const _bind$8 = _M0MPC14json12ParseContext19expect__ascii__char(ctx, 101);
                if (_bind$8.$tag === 1) {
                  const _ok = _bind$8;
                  _ok._0;
                } else {
                  return _bind$8;
                }
                return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(_M0DTPC14json5Token5False__);
              } else {
                if (_x === 45) {
                  const _bind$5 = _M0MPC14json12ParseContext10read__char(ctx);
                  if (_bind$5 === -1) {
                    return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
                  } else {
                    const _Some$2 = _bind$5;
                    const _x$2 = _Some$2;
                    if (_x$2 === 48) {
                      const _bind$6 = _M0MPC14json12ParseContext9lex__zero(ctx, ctx.offset - 2 | 0);
                      let _bind$7;
                      if (_bind$6.$tag === 1) {
                        const _ok = _bind$6;
                        _bind$7 = _ok._0;
                      } else {
                        return _bind$6;
                      }
                      const _n = _bind$7._0;
                      const _repr = _bind$7._1;
                      return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(new _M0DTPC14json5Token6Number(_n, _M0MPC16option6Option3mapGRPC16string10StringViewsE(_repr, (repr) => _M0MPC16string10StringView9to__owned(repr))));
                    } else {
                      if (_x$2 >= 49 && _x$2 <= 57) {
                        const _bind$6 = _M0MPC14json12ParseContext21lex__decimal__integer(ctx, ctx.offset - 2 | 0);
                        let _bind$7;
                        if (_bind$6.$tag === 1) {
                          const _ok = _bind$6;
                          _bind$7 = _ok._0;
                        } else {
                          return _bind$6;
                        }
                        const _n = _bind$7._0;
                        const _repr = _bind$7._1;
                        return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(new _M0DTPC14json5Token6Number(_n, _M0MPC16option6Option3mapGRPC16string10StringViewsE(_repr, (repr) => _M0MPC16string10StringView9to__owned(repr))));
                      }
                      return _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, -1);
                    }
                  }
                } else {
                  if (_x === 48) {
                    const _bind$5 = _M0MPC14json12ParseContext9lex__zero(ctx, ctx.offset - 1 | 0);
                    let _bind$6;
                    if (_bind$5.$tag === 1) {
                      const _ok = _bind$5;
                      _bind$6 = _ok._0;
                    } else {
                      return _bind$5;
                    }
                    const _n = _bind$6._0;
                    const _repr = _bind$6._1;
                    return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(new _M0DTPC14json5Token6Number(_n, _M0MPC16option6Option3mapGRPC16string10StringViewsE(_repr, (repr) => _M0MPC16string10StringView9to__owned(repr))));
                  } else {
                    if (_x >= 49 && _x <= 57) {
                      const _bind$5 = _M0MPC14json12ParseContext21lex__decimal__integer(ctx, ctx.offset - 1 | 0);
                      let _bind$6;
                      if (_bind$5.$tag === 1) {
                        const _ok = _bind$5;
                        _bind$6 = _ok._0;
                      } else {
                        return _bind$5;
                      }
                      const _n = _bind$6._0;
                      const _repr = _bind$6._1;
                      return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(new _M0DTPC14json5Token6Number(_n, _M0MPC16option6Option3mapGRPC16string10StringViewsE(_repr, (repr) => _M0MPC16string10StringView9to__owned(repr))));
                    } else {
                      if (_x === 34) {
                        const _bind$5 = _M0MPC14json12ParseContext11lex__string(ctx);
                        let s;
                        if (_bind$5.$tag === 1) {
                          const _ok = _bind$5;
                          s = _ok._0;
                        } else {
                          return _bind$5;
                        }
                        return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(new _M0DTPC14json5Token6String(s));
                      } else {
                        const _p$4 = _x;
                        const shift = -(_p$4 <= 65535 ? 1 : 2) | 0;
                        return _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, shift);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
function _M0MPC14json12ParseContext24lex__after__array__value(ctx) {
  _M0MPC14json12ParseContext21lex__skip__whitespace(ctx);
  const _bind$4 = _M0MPC14json12ParseContext10read__char(ctx);
  if (_bind$4 === -1) {
    return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    switch (_x) {
      case 93: {
        return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(_M0DTPC14json5Token8RBracket__);
      }
      case 44: {
        return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(_M0DTPC14json5Token5Comma__);
      }
      default: {
        return _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, -1);
      }
    }
  }
}
function _M0MPC14json12ParseContext25lex__after__object__value(ctx) {
  _M0MPC14json12ParseContext21lex__skip__whitespace(ctx);
  const _bind$4 = _M0MPC14json12ParseContext10read__char(ctx);
  if (_bind$4 === -1) {
    return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    switch (_x) {
      case 125: {
        return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(_M0DTPC14json5Token6RBrace__);
      }
      case 44: {
        return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(_M0DTPC14json5Token5Comma__);
      }
      default: {
        return _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, -1);
      }
    }
  }
}
function _M0MPC14json12ParseContext26lex__after__property__name(ctx) {
  _M0MPC14json12ParseContext21lex__skip__whitespace(ctx);
  const _bind$4 = _M0MPC14json12ParseContext10read__char(ctx);
  if (_bind$4 === -1) {
    return new _M0DTPC16result6ResultGuRPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    if (_x === 58) {
      return new _M0DTPC16result6ResultGuRPC14json10ParseErrorE2Ok(undefined);
    } else {
      return _M0MPC14json12ParseContext21invalid__char_2einnerGuE(ctx, -1);
    }
  }
}
function _M0MPC14json12ParseContext19lex__property__name(ctx) {
  _M0MPC14json12ParseContext21lex__skip__whitespace(ctx);
  const _bind$4 = _M0MPC14json12ParseContext10read__char(ctx);
  if (_bind$4 === -1) {
    return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    switch (_x) {
      case 125: {
        return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(_M0DTPC14json5Token6RBrace__);
      }
      case 34: {
        const _bind$5 = _M0MPC14json12ParseContext11lex__string(ctx);
        let s;
        if (_bind$5.$tag === 1) {
          const _ok = _bind$5;
          s = _ok._0;
        } else {
          return _bind$5;
        }
        return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(new _M0DTPC14json5Token6String(s));
      }
      default: {
        return _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, -1);
      }
    }
  }
}
function _M0MPC14json12ParseContext20lex__property__name2(ctx) {
  _M0MPC14json12ParseContext21lex__skip__whitespace(ctx);
  const _bind$4 = _M0MPC14json12ParseContext10read__char(ctx);
  if (_bind$4 === -1) {
    return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    if (_x === 34) {
      const _bind$5 = _M0MPC14json12ParseContext11lex__string(ctx);
      let s;
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        s = _ok._0;
      } else {
        return _bind$5;
      }
      return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(new _M0DTPC14json5Token6String(s));
    } else {
      return _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, -1);
    }
  }
}
function _M0MPC14json12ParseContext12parse__value(ctx) {
  const _bind$4 = _M0MPC14json12ParseContext10lex__value(ctx, false);
  let tok;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    tok = _ok._0;
  } else {
    return _bind$4;
  }
  return _M0MPC14json12ParseContext13parse__value2(ctx, tok);
}
function _M0MPC14json12ParseContext13parse__value2(ctx, tok) {
  _L: {
    switch (tok.$tag) {
      case 0: {
        return new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE2Ok(_M0FPB4null);
      }
      case 1: {
        const _p$4 = true;
        return new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE2Ok(_p$4 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__);
      }
      case 2: {
        const _p$5 = false;
        return new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE2Ok(_p$5 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__);
      }
      case 3: {
        const _Number = tok;
        const _n = _Number._0;
        const _repr = _Number._1;
        return new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE2Ok(new _M0DTPB4Json6Number(_n, _repr));
      }
      case 4: {
        const _String = tok;
        const _s = _String._0;
        return new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE2Ok(new _M0DTPB4Json6String(_s));
      }
      case 5: {
        return _M0MPC14json12ParseContext13parse__object(ctx);
      }
      case 7: {
        return _M0MPC14json12ParseContext12parse__array(ctx);
      }
      case 8: {
        break _L;
      }
      case 6: {
        break _L;
      }
      default: {
        break _L;
      }
    }
  }
  return new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE2Ok(_M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("unreachable"));
}
function _M0MPC14json12ParseContext12parse__array(ctx) {
  if (ctx.remaining_available_depth <= 0) {
    return new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE3Err(_M0DTPC15error5Error59moonbitlang_2fcore_2fjson_2eParseError_2eDepthLimitExceeded__);
  }
  ctx.remaining_available_depth = ctx.remaining_available_depth - 1 | 0;
  const vec = [];
  let _tmp$38;
  const _bind$4 = _M0MPC14json12ParseContext10lex__value(ctx, true);
  let _tmp$39;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _tmp$39 = _ok._0;
  } else {
    return _bind$4;
  }
  let _tmp$40 = _tmp$39;
  _L: while (true) {
    const x = _tmp$40;
    if (x.$tag === 8) {
      ctx.remaining_available_depth = ctx.remaining_available_depth + 1 | 0;
      _tmp$38 = new _M0DTPB4Json5Array(vec);
      break;
    } else {
      const _bind$5 = _M0MPC14json12ParseContext13parse__value2(ctx, x);
      let _tmp$41;
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        _tmp$41 = _ok._0;
      } else {
        return _bind$5;
      }
      _M0MPC15array5Array4pushGUssEE(vec, _tmp$41);
      const _bind$6 = _M0MPC14json12ParseContext24lex__after__array__value(ctx);
      let tok2;
      if (_bind$6.$tag === 1) {
        const _ok = _bind$6;
        tok2 = _ok._0;
      } else {
        return _bind$6;
      }
      switch (tok2.$tag) {
        case 9: {
          const _bind$7 = _M0MPC14json12ParseContext10lex__value(ctx, false);
          if (_bind$7.$tag === 1) {
            const _ok = _bind$7;
            _tmp$40 = _ok._0;
          } else {
            return _bind$7;
          }
          continue _L;
        }
        case 8: {
          ctx.remaining_available_depth = ctx.remaining_available_depth + 1 | 0;
          _tmp$38 = new _M0DTPB4Json5Array(vec);
          break _L;
        }
        default: {
          _M0FPC15abort5abortGuE("unreachable");
        }
      }
    }
    continue;
  }
  return new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE2Ok(_tmp$38);
}
function _M0MPC14json12ParseContext13parse__object(ctx) {
  if (ctx.remaining_available_depth <= 0) {
    return new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE3Err(_M0DTPC15error5Error59moonbitlang_2fcore_2fjson_2eParseError_2eDepthLimitExceeded__);
  }
  ctx.remaining_available_depth = ctx.remaining_available_depth - 1 | 0;
  const _bind$4 = [];
  const map = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$4, 0, 0), undefined);
  let _tmp$38;
  const _bind$5 = _M0MPC14json12ParseContext19lex__property__name(ctx);
  let _tmp$39;
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    _tmp$39 = _ok._0;
  } else {
    return _bind$5;
  }
  let _tmp$40 = _tmp$39;
  _L: while (true) {
    const x = _tmp$40;
    switch (x.$tag) {
      case 6: {
        ctx.remaining_available_depth = ctx.remaining_available_depth + 1 | 0;
        _tmp$38 = new _M0DTPB4Json6Object(map);
        break _L;
      }
      case 4: {
        const _String = x;
        const _name = _String._0;
        const _bind$6 = _M0MPC14json12ParseContext26lex__after__property__name(ctx);
        if (_bind$6.$tag === 1) {
          const _ok = _bind$6;
          _ok._0;
        } else {
          return _bind$6;
        }
        const _bind$7 = _M0MPC14json12ParseContext12parse__value(ctx);
        let _tmp$41;
        if (_bind$7.$tag === 1) {
          const _ok = _bind$7;
          _tmp$41 = _ok._0;
        } else {
          return _bind$7;
        }
        _M0MPB3Map3setGsRPB4JsonE(map, _name, _tmp$41);
        const _bind$8 = _M0MPC14json12ParseContext25lex__after__object__value(ctx);
        let _bind$9;
        if (_bind$8.$tag === 1) {
          const _ok = _bind$8;
          _bind$9 = _ok._0;
        } else {
          return _bind$8;
        }
        switch (_bind$9.$tag) {
          case 9: {
            const _bind$10 = _M0MPC14json12ParseContext20lex__property__name2(ctx);
            if (_bind$10.$tag === 1) {
              const _ok = _bind$10;
              _tmp$40 = _ok._0;
            } else {
              return _bind$10;
            }
            continue _L;
          }
          case 6: {
            ctx.remaining_available_depth = ctx.remaining_available_depth + 1 | 0;
            _tmp$38 = new _M0DTPB4Json6Object(map);
            break _L;
          }
          default: {
            _M0FPC15abort5abortGuE("unreachable");
          }
        }
        break;
      }
      default: {
        _M0FPC15abort5abortGuE("unreachable");
      }
    }
    continue;
  }
  return new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE2Ok(_tmp$38);
}
function _M0FPC14json13parse_2einner(input, max_nesting_depth) {
  const ctx = _M0MPC14json12ParseContext4make(input, max_nesting_depth);
  const _bind$4 = _M0MPC14json12ParseContext12parse__value(ctx);
  let val;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    val = _ok._0;
  } else {
    return _bind$4;
  }
  _M0MPC14json12ParseContext21lex__skip__whitespace(ctx);
  return ctx.offset >= ctx.end_offset ? new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE2Ok(val) : _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, 0);
}
function _M0FPC14json6escape(str, escape_slash) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(str.length);
  const _it = _M0MPC16string6String4iter(str);
  while (true) {
    const _bind$4 = _M0MPB4Iter4nextGcE(_it);
    if (_bind$4 === -1) {
      break;
    } else {
      const _Some = _bind$4;
      const _c = _Some;
      switch (_c) {
        case 34: {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\\"");
          break;
        }
        case 92: {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\\\");
          break;
        }
        case 47: {
          if (escape_slash) {
            _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\/");
          } else {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, _c);
          }
          break;
        }
        case 10: {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\n");
          break;
        }
        case 13: {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\r");
          break;
        }
        case 8: {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\b");
          break;
        }
        case 9: {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\t");
          break;
        }
        default: {
          const code = _c;
          if (code === 12) {
            _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\f");
          } else {
            if (code < 32) {
              _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\u00");
              _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0MPC14byte4Byte7to__hex(code & 255));
            } else {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, _c);
            }
          }
        }
      }
      continue;
    }
  }
  return buf.val;
}
function _M0FPC14json11indent__str(level, indent) {
  if (indent === 0) {
    return "";
  } else {
    const spaces = Math.imul(indent, level) | 0;
    switch (spaces) {
      case 0: {
        return "\n";
      }
      case 1: {
        return "\n ";
      }
      case 2: {
        return "\n  ";
      }
      case 3: {
        return "\n   ";
      }
      case 4: {
        return "\n    ";
      }
      case 5: {
        return "\n     ";
      }
      case 6: {
        return "\n      ";
      }
      case 7: {
        return "\n       ";
      }
      case 8: {
        return "\n        ";
      }
      default: {
        return `\n${_M0MPC16string6String6repeat(" ", spaces)}`;
      }
    }
  }
}
function _M0MPC14json4Json17stringify_2einner(self, escape_slash, indent, replacer) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const stack = [];
  let depth = 0;
  let _tmp$38 = self;
  while (true) {
    const x = _tmp$38;
    if (x === undefined) {
      if (stack.length === 0) {
        break;
      } else {
        const _x = stack[stack.length - 1 | 0];
        if (_x.$tag === 0) {
          const _Array = _x;
          const _arr = _Array._0;
          const _i = _Array._1;
          if (_i < _arr.length) {
            const element = _M0MPC15array5Array2atGUssEE(_arr, _i);
            _Array._1 = _i + 1 | 0;
            if (_i > 0) {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, 44);
              _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FPC14json11indent__str(depth, indent));
            }
            _tmp$38 = element;
            continue;
          } else {
            depth = depth - 1 | 0;
            _M0MPC15array5Array3popGsE(stack);
            _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FPC14json11indent__str(depth, indent));
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 93);
            _tmp$38 = undefined;
            continue;
          }
        } else {
          const _Object = _x;
          const _iterator = _Object._0;
          const _first = _Object._1;
          const _bind$4 = _M0MPB4Iter4nextGUssEE(_iterator);
          if (_bind$4 === undefined) {
            depth = depth - 1 | 0;
            _M0MPC15array5Array3popGsE(stack);
            _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FPC14json11indent__str(depth, indent));
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 125);
            _tmp$38 = undefined;
            continue;
          } else {
            const _Some = _bind$4;
            const _x$2 = _Some;
            const _k = _x$2._0;
            const _v = _x$2._1;
            let v2 = _v;
            if (replacer === undefined) {
            } else {
              const _Some$2 = replacer;
              const _replacer = _Some$2;
              const _func = _replacer.f;
              const _bind$5 = _func(_k, _v);
              if (_bind$5 === undefined) {
                _tmp$38 = undefined;
                continue;
              } else {
                const _Some$3 = _bind$5;
                const _v$2 = _Some$3;
                v2 = _v$2;
              }
            }
            if (!_first) {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, 44);
              _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FPC14json11indent__str(depth, indent));
            }
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 34);
            _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FPC14json6escape(_k, escape_slash));
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 34);
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 58);
            if (indent > 0) {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, 32);
            }
            _Object._1 = false;
            _tmp$38 = v2;
            continue;
          }
        }
      }
    } else {
      const _Some = x;
      const _value = _Some;
      switch (_value.$tag) {
        case 6: {
          const _Object = _value;
          const _members = _Object._0;
          if (_members.size === 0) {
            _M0IPB13StringBuilderPB6Logger13write__string(buf, "{}");
          } else {
            depth = depth + 1 | 0;
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 123);
            _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FPC14json11indent__str(depth, indent));
            _M0MPC15array5Array4pushGUssEE(stack, new _M0DTPC14json10WriteFrame6Object(_M0MPB3Map4iterGssE(_members), true));
          }
          break;
        }
        case 5: {
          const _Array = _value;
          const _arr = _Array._0;
          if (_arr.length === 0) {
            _M0IPB13StringBuilderPB6Logger13write__string(buf, "[]");
          } else {
            depth = depth + 1 | 0;
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 91);
            _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FPC14json11indent__str(depth, indent));
            _M0MPC15array5Array4pushGUssEE(stack, new _M0DTPC14json10WriteFrame5Array(_arr, 0));
          }
          break;
        }
        case 4: {
          const _String = _value;
          const _s = _String._0;
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 34);
          _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FPC14json6escape(_s, escape_slash));
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 34);
          break;
        }
        case 3: {
          const _Number = _value;
          const _n = _Number._0;
          const _repr = _Number._1;
          if (_repr === undefined) {
            _M0MPB13StringBuilder13write__objectGdE(buf, _n);
          } else {
            const _Some$2 = _repr;
            const _r = _Some$2;
            _M0IPB13StringBuilderPB6Logger13write__string(buf, _r);
          }
          break;
        }
        case 1: {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, "true");
          break;
        }
        case 2: {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, "false");
          break;
        }
        default: {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, "null");
        }
      }
      _tmp$38 = undefined;
      continue;
    }
  }
  return buf.val;
}
function _M0MPC13ref3Ref3RefGRPB5ArrayGRPB4JsonEE(x) {
  return new _M0TPC13ref3RefGRPB5ArrayGRPB4JsonEE(x);
}
function _M0MPC13ref3Ref3RefGiE(x) {
  return new _M0TPC13ref3RefGiE(x);
}
function _M0MPC13ref3Ref3RefGbE(x) {
  return new _M0TPC13ref3RefGbE(x);
}
function _M0FPC15deque10new__dequeGcE(capacity) {
  return new _M0TPC15deque5DequeGcE(new Array(capacity), 0, 0);
}
function _M0FPC15deque10new__dequeGRP219moonbit_2dcommunity4yaml5TokenE(capacity) {
  return new _M0TPC15deque5DequeGRP219moonbit_2dcommunity4yaml5TokenE(new Array(capacity), 0, 0);
}
function _M0MPC15deque5Deque11tail__indexGRP219moonbit_2dcommunity4yaml5TokenE(self) {
  const _tmp$38 = (self.head + self.len | 0) - 1 | 0;
  const _p$4 = self.buf;
  return _tmp$38 % _p$4.length | 0;
}
function _M0MPC15deque5Deque9as__viewsGcE(self) {
  if (self.len !== 0) {
    const _buf = self.buf;
    const _head = self.head;
    const _len = self.len;
    const cap = _buf.length;
    const head_len = cap - _head | 0;
    if (head_len >= _len) {
      const _tmp$38 = _M0MPB18UninitializedArray11sub_2einnerGcE(_buf, _head, _head + _len | 0);
      const _bind$4 = [];
      return { _0: _tmp$38, _1: new _M0TPB9ArrayViewGcE(_bind$4, 0, 0) };
    } else {
      return { _0: _M0MPB18UninitializedArray11sub_2einnerGcE(_buf, _head, cap), _1: _M0MPB18UninitializedArray11sub_2einnerGcE(_buf, 0, _len - head_len | 0) };
    }
  } else {
    const _bind$4 = [];
    const _tmp$38 = new _M0TPB9ArrayViewGcE(_bind$4, 0, 0);
    const _bind$5 = [];
    return { _0: _tmp$38, _1: new _M0TPB9ArrayViewGcE(_bind$5, 0, 0) };
  }
}
function _M0MPC15deque5Deque9as__viewsGRP219moonbit_2dcommunity4yaml5TokenE(self) {
  if (self.len !== 0) {
    const _buf = self.buf;
    const _head = self.head;
    const _len = self.len;
    const cap = _buf.length;
    const head_len = cap - _head | 0;
    if (head_len >= _len) {
      const _tmp$38 = _M0MPB18UninitializedArray11sub_2einnerGRP219moonbit_2dcommunity4yaml5TokenE(_buf, _head, _head + _len | 0);
      const _bind$4 = [];
      return { _0: _tmp$38, _1: new _M0TPB9ArrayViewGRP219moonbit_2dcommunity4yaml5TokenE(_bind$4, 0, 0) };
    } else {
      return { _0: _M0MPB18UninitializedArray11sub_2einnerGRP219moonbit_2dcommunity4yaml5TokenE(_buf, _head, cap), _1: _M0MPB18UninitializedArray11sub_2einnerGRP219moonbit_2dcommunity4yaml5TokenE(_buf, 0, _len - head_len | 0) };
    }
  } else {
    const _bind$4 = [];
    const _tmp$38 = new _M0TPB9ArrayViewGRP219moonbit_2dcommunity4yaml5TokenE(_bind$4, 0, 0);
    const _bind$5 = [];
    return { _0: _tmp$38, _1: new _M0TPB9ArrayViewGRP219moonbit_2dcommunity4yaml5TokenE(_bind$5, 0, 0) };
  }
}
function _M0MPC15deque5Deque16unsafe__blit__toGcE(self, dst, dst_offset) {
  if (self.len !== 0) {
    const _bind$4 = _M0MPC15deque5Deque9as__viewsGcE(self);
    const _front = _bind$4._0;
    const _back = _bind$4._1;
    _M0MPB18UninitializedArray12unsafe__blitGcE(dst, dst_offset, self.buf, _front.start, _front.end - _front.start | 0);
    _M0MPB18UninitializedArray12unsafe__blitGcE(dst, dst_offset + (_front.end - _front.start | 0) | 0, self.buf, _back.start, _back.end - _back.start | 0);
    return;
  } else {
    return;
  }
}
function _M0MPC15deque5Deque16unsafe__blit__toGRP219moonbit_2dcommunity4yaml5TokenE(self, dst, dst_offset) {
  if (self.len !== 0) {
    const _bind$4 = _M0MPC15deque5Deque9as__viewsGRP219moonbit_2dcommunity4yaml5TokenE(self);
    const _front = _bind$4._0;
    const _back = _bind$4._1;
    _M0MPB18UninitializedArray12unsafe__blitGsE(dst, dst_offset, self.buf, _front.start, _front.end - _front.start | 0);
    _M0MPB18UninitializedArray12unsafe__blitGsE(dst, dst_offset + (_front.end - _front.start | 0) | 0, self.buf, _back.start, _back.end - _back.start | 0);
    return;
  } else {
    return;
  }
}
function _M0MPC15deque5Deque7reallocGcE(self) {
  const _p$4 = self.buf;
  const old_cap = _p$4.length;
  const new_cap = old_cap === 0 ? 8 : Math.imul(old_cap, 2) | 0;
  const new_buf = new Array(new_cap);
  _M0MPC15deque5Deque16unsafe__blit__toGcE(self, new_buf, 0);
  self.head = 0;
  self.buf = new_buf;
}
function _M0MPC15deque5Deque7reallocGRP219moonbit_2dcommunity4yaml5TokenE(self) {
  const _p$4 = self.buf;
  const old_cap = _p$4.length;
  const new_cap = old_cap === 0 ? 8 : Math.imul(old_cap, 2) | 0;
  const new_buf = new Array(new_cap);
  _M0MPC15deque5Deque16unsafe__blit__toGRP219moonbit_2dcommunity4yaml5TokenE(self, new_buf, 0);
  self.head = 0;
  self.buf = new_buf;
}
function _M0MPC15deque5Deque6insertGRP219moonbit_2dcommunity4yaml5TokenE(self, index, value) {
  if (index >= 0 && index <= self.len) {
    const _p$4 = self.buf;
    if ((_p$4.length - self.len | 0) === 0) {
      _M0MPC15deque5Deque7reallocGRP219moonbit_2dcommunity4yaml5TokenE(self);
    }
    const _p$5 = self.buf;
    const cap = _p$5.length;
    if (index < (self.len / 2 | 0)) {
      const new_head = ((self.head - 1 | 0) + cap | 0) % cap | 0;
      let _tmp$38 = 0;
      while (true) {
        const i = _tmp$38;
        if (i < index) {
          const to = (new_head + i | 0) % cap | 0;
          const from = (self.head + i | 0) % cap | 0;
          const _tmp$39 = self.buf;
          const _tmp$40 = self.buf;
          $bound_check(_tmp$40, from);
          $bound_check(_tmp$39, to);
          _tmp$39[to] = _tmp$40[from];
          _tmp$38 = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      self.head = new_head;
    } else {
      let _tmp$38 = self.len;
      while (true) {
        const i = _tmp$38;
        if (i > index) {
          const from = ((self.head + i | 0) - 1 | 0) % cap | 0;
          const to = (self.head + i | 0) % cap | 0;
          const _tmp$39 = self.buf;
          const _tmp$40 = self.buf;
          $bound_check(_tmp$40, from);
          $bound_check(_tmp$39, to);
          _tmp$39[to] = _tmp$40[from];
          _tmp$38 = i - 1 | 0;
          continue;
        } else {
          break;
        }
      }
    }
    const _tmp$38 = self.buf;
    const _tmp$39 = (self.head + index | 0) % cap | 0;
    $bound_check(_tmp$38, _tmp$39);
    _tmp$38[_tmp$39] = value;
    self.len = self.len + 1 | 0;
    return;
  } else {
    _M0FPC15abort5abortGuE(`index out of bounds: the len is from 0 to ${_M0IPC13int3IntPB4Show10to__string(self.len)} but the index is ${_M0IPC13int3IntPB4Show10to__string(index)}`);
    return;
  }
}
function _M0MPC15deque5Deque2atGcE(self, index) {
  if (index < 0 || index >= self.len) {
    const len = self.len;
    _M0FPC15abort5abortGuE(`index out of bounds: the len is from 0 to ${_M0IPC13int3IntPB4Show10to__string(len)} but the index is ${_M0IPC13int3IntPB4Show10to__string(index)}`);
  }
  const _tmp$38 = self.head + index | 0;
  const _p$4 = self.buf;
  if (_tmp$38 < _p$4.length) {
    const _tmp$39 = self.buf;
    const _tmp$40 = self.head + index | 0;
    $bound_check(_tmp$39, _tmp$40);
    return _tmp$39[_tmp$40];
  } else {
    const _tmp$39 = self.buf;
    const _tmp$40 = self.head + index | 0;
    const _p$5 = self.buf;
    const _tmp$41 = _tmp$40 - _p$5.length | 0;
    $bound_check(_tmp$39, _tmp$41);
    return _tmp$39[_tmp$41];
  }
}
function _M0MPC15deque5Deque4backGRP219moonbit_2dcommunity4yaml5TokenE(self) {
  if (self.len === 0) {
    return undefined;
  } else {
    const _tmp$38 = self.buf;
    const _tmp$39 = _M0MPC15deque5Deque11tail__indexGRP219moonbit_2dcommunity4yaml5TokenE(self);
    $bound_check(_tmp$38, _tmp$39);
    return _tmp$38[_tmp$39];
  }
}
function _M0MPC15deque5Deque10push__backGcE(self, value) {
  const _tmp$38 = self.len;
  const _p$4 = self.buf;
  if (_tmp$38 === _p$4.length) {
    _M0MPC15deque5Deque7reallocGcE(self);
  }
  const _p$5 = self.buf;
  const cap = _p$5.length;
  const write_idx = (self.head + self.len | 0) % cap | 0;
  const _tmp$39 = self.buf;
  $bound_check(_tmp$39, write_idx);
  _tmp$39[write_idx] = value;
  self.len = self.len + 1 | 0;
}
function _M0MPC15deque5Deque10push__backGRP219moonbit_2dcommunity4yaml5TokenE(self, value) {
  const _tmp$38 = self.len;
  const _p$4 = self.buf;
  if (_tmp$38 === _p$4.length) {
    _M0MPC15deque5Deque7reallocGRP219moonbit_2dcommunity4yaml5TokenE(self);
  }
  const _p$5 = self.buf;
  const cap = _p$5.length;
  const write_idx = (self.head + self.len | 0) % cap | 0;
  const _tmp$39 = self.buf;
  $bound_check(_tmp$39, write_idx);
  _tmp$39[write_idx] = value;
  self.len = self.len + 1 | 0;
}
function _M0MPC15deque5Deque10pop__frontGRP219moonbit_2dcommunity4yaml5TokenE(self) {
  if (self.len > 0) {
    const _tmp$38 = self.buf;
    const _tmp$39 = self.head;
    $bound_check(_tmp$38, _tmp$39);
    const value = _tmp$38[_tmp$39];
    const _tmp$40 = self.buf;
    const _tmp$41 = self.head;
    $bound_check(_tmp$40, _tmp$41);
    _tmp$40[_tmp$41] = null;
    const _p$4 = self.buf;
    const cap = _p$4.length;
    self.head = (self.head + 1 | 0) % cap | 0;
    self.len = self.len - 1 | 0;
    return value;
  } else {
    return undefined;
  }
}
function _M0MPC15deque5Deque10pop__frontGcE(self) {
  if (self.len > 0) {
    const _tmp$38 = self.buf;
    const _tmp$39 = self.head;
    $bound_check(_tmp$38, _tmp$39);
    const value = _tmp$38[_tmp$39];
    const _p$4 = self.buf;
    const cap = _p$4.length;
    self.head = (self.head + 1 | 0) % cap | 0;
    self.len = self.len - 1 | 0;
    return value;
  } else {
    return -1;
  }
}
function _M0MPC15deque5Deque11new_2einnerGcE(capacity) {
  return _M0FPC15deque10new__dequeGcE(capacity);
}
function _M0MPC15deque5Deque11new_2einnerGRP219moonbit_2dcommunity4yaml5TokenE(capacity) {
  return _M0FPC15deque10new__dequeGRP219moonbit_2dcommunity4yaml5TokenE(capacity);
}
function _M0FPC28encoding4utf814encode_2einner(str, bom) {
  const length = str.end - str.start | 0;
  let utf8_length;
  let _tmp$38 = 0;
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$38;
    const utf8_length$2 = _tmp$39;
    if (i < length) {
      const code = str.str.charCodeAt(str.start + i | 0);
      if (_M0IP016_24default__implPB7Compare6op__ltGkE(code, 128)) {
        _tmp$38 = i + 1 | 0;
        _tmp$39 = utf8_length$2 + 1 | 0;
        continue;
      } else {
        if (_M0IP016_24default__implPB7Compare6op__ltGkE(code, 2048)) {
          _tmp$38 = i + 1 | 0;
          _tmp$39 = utf8_length$2 + 2 | 0;
          continue;
        } else {
          let _tmp$40;
          if (_M0MPC16uint166UInt1622is__leading__surrogate(code)) {
            let _tmp$41;
            if ((i + 1 | 0) < length) {
              const _p$4 = i + 1 | 0;
              _tmp$41 = _M0MPC16uint166UInt1623is__trailing__surrogate(str.str.charCodeAt(str.start + _p$4 | 0));
            } else {
              _tmp$41 = false;
            }
            _tmp$40 = _tmp$41;
          } else {
            _tmp$40 = false;
          }
          if (_tmp$40) {
            _tmp$38 = i + 2 | 0;
            _tmp$39 = utf8_length$2 + 4 | 0;
            continue;
          } else {
            if (_M0MPC16uint166UInt1613is__surrogate(code)) {
              _M0FPC15abort5abortGuE("invalid surrogate pair");
            } else {
              _tmp$38 = i + 1 | 0;
              _tmp$39 = utf8_length$2 + 3 | 0;
              continue;
            }
          }
        }
      }
      continue;
    } else {
      utf8_length = bom ? 3 + utf8_length$2 | 0 : utf8_length$2;
      break;
    }
  }
  const arr = $makebytes(utf8_length, 0);
  let _tmp$40 = 0;
  let _tmp$41;
  if (bom) {
    $bound_check(arr, 0);
    arr[0] = 239;
    $bound_check(arr, 1);
    arr[1] = 187;
    $bound_check(arr, 2);
    arr[2] = 191;
    _tmp$41 = 3;
  } else {
    _tmp$41 = 0;
  }
  let _tmp$42 = _tmp$41;
  while (true) {
    const i = _tmp$40;
    const offset = _tmp$42;
    if (i < length) {
      const code_unit = str.str.charCodeAt(str.start + i | 0);
      const code = code_unit;
      if (code < 128) {
        $bound_check(arr, offset);
        arr[offset] = code & 255;
        _tmp$40 = i + 1 | 0;
        _tmp$42 = offset + 1 | 0;
        continue;
      } else {
        if (code < 2048) {
          $bound_check(arr, offset);
          arr[offset] = (192 + (code >> 6) | 0) & 255;
          const _tmp$43 = offset + 1 | 0;
          $bound_check(arr, _tmp$43);
          arr[_tmp$43] = (128 + (code & 63) | 0) & 255;
          _tmp$40 = i + 1 | 0;
          _tmp$42 = offset + 2 | 0;
          continue;
        } else {
          if (_M0MPC16uint166UInt1622is__leading__surrogate(code_unit) && (i + 1 | 0) < length) {
            const _p$4 = i + 1 | 0;
            const trailing = str.str.charCodeAt(str.start + _p$4 | 0);
            if (_M0MPC16uint166UInt1623is__trailing__surrogate(trailing)) {
              const code$2 = ((code - 55296 << 10) + (trailing - 56320 | 0) | 0) + 65536 | 0;
              $bound_check(arr, offset);
              arr[offset] = (240 + (code$2 >> 18) | 0) & 255;
              const _tmp$43 = offset + 1 | 0;
              $bound_check(arr, _tmp$43);
              arr[_tmp$43] = (128 + (code$2 >> 12 & 63) | 0) & 255;
              const _tmp$44 = offset + 2 | 0;
              $bound_check(arr, _tmp$44);
              arr[_tmp$44] = (128 + (code$2 >> 6 & 63) | 0) & 255;
              const _tmp$45 = offset + 3 | 0;
              $bound_check(arr, _tmp$45);
              arr[_tmp$45] = (128 + (code$2 & 63) | 0) & 255;
              _tmp$40 = i + 2 | 0;
              _tmp$42 = offset + 4 | 0;
              continue;
            } else {
              _M0FPC15abort5abortGuE("invalid surrogate pair");
            }
          } else {
            if (_M0MPC16uint166UInt1613is__surrogate(code_unit)) {
              _M0FPC15abort5abortGuE("invalid surrogate pair");
            } else {
              $bound_check(arr, offset);
              arr[offset] = (224 + (code >> 12) | 0) & 255;
              const _tmp$43 = offset + 1 | 0;
              $bound_check(arr, _tmp$43);
              arr[_tmp$43] = (128 + (code >> 6 & 63) | 0) & 255;
              const _tmp$44 = offset + 2 | 0;
              $bound_check(arr, _tmp$44);
              arr[_tmp$44] = (128 + (code & 63) | 0) & 255;
              _tmp$40 = i + 1 | 0;
              _tmp$42 = offset + 3 | 0;
              continue;
            }
          }
        }
      }
      continue;
    } else {
      break;
    }
  }
  return arr;
}
function _M0FPC28encoding4utf814decode_2einner(bytes, ignore_bom) {
  let bytes$2;
  _L: {
    _L$2: {
      if (ignore_bom) {
        _L$3: {
          _L$4: {
            if ((bytes.end - bytes.start | 0) >= 3) {
              const _x = bytes.bytes[bytes.start];
              if (_x === 239) {
                const _x$2 = bytes.bytes[bytes.start + 1 | 0];
                if (_x$2 === 187) {
                  const _x$3 = bytes.bytes[bytes.start + 2 | 0];
                  if (_x$3 === 191) {
                    bytes$2 = new _M0TPC15bytes9BytesView(bytes.bytes, bytes.start + 3 | 0, bytes.end);
                  } else {
                    break _L$4;
                  }
                } else {
                  break _L$4;
                }
              } else {
                break _L$4;
              }
            } else {
              break _L$4;
            }
            break _L$3;
          }
          break _L$2;
        }
      } else {
        break _L$2;
      }
      break _L;
    }
    bytes$2 = bytes;
  }
  const t = $makebytes(Math.imul(bytes$2.end - bytes$2.start | 0, 2) | 0, 0);
  let tlen;
  let _tmp$38 = 0;
  let _tmp$39 = bytes$2;
  while (true) {
    const tlen$2 = _tmp$38;
    const bs = _tmp$39;
    let bytes$3;
    _L$2: {
      let tlen$3;
      let b0;
      let b1;
      let b2;
      let b3;
      let rest;
      _L$3: {
        let tlen$4;
        let b0$2;
        let b1$2;
        let b2$2;
        let rest$2;
        _L$4: {
          let tlen$5;
          let rest$3;
          let b0$3;
          let b1$3;
          _L$5: {
            let tlen$6;
            let rest$4;
            let b;
            _L$6: {
              if ((bs.end - bs.start | 0) === 0) {
                tlen = tlen$2;
                break;
              } else {
                if ((bs.end - bs.start | 0) >= 8) {
                  const _x = bs.bytes[bs.start];
                  if (_x <= 127) {
                    const _x$2 = bs.bytes[bs.start + 1 | 0];
                    if (_x$2 <= 127) {
                      const _x$3 = bs.bytes[bs.start + 2 | 0];
                      if (_x$3 <= 127) {
                        const _x$4 = bs.bytes[bs.start + 3 | 0];
                        if (_x$4 <= 127) {
                          const _x$5 = bs.bytes[bs.start + 4 | 0];
                          if (_x$5 <= 127) {
                            const _x$6 = bs.bytes[bs.start + 5 | 0];
                            if (_x$6 <= 127) {
                              const _x$7 = bs.bytes[bs.start + 6 | 0];
                              if (_x$7 <= 127) {
                                const _x$8 = bs.bytes[bs.start + 7 | 0];
                                if (_x$8 <= 127) {
                                  const _x$9 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 8 | 0, bs.end);
                                  t[tlen$2] = _x;
                                  t[tlen$2 + 2 | 0] = _x$2;
                                  t[tlen$2 + 4 | 0] = _x$3;
                                  t[tlen$2 + 6 | 0] = _x$4;
                                  t[tlen$2 + 8 | 0] = _x$5;
                                  t[tlen$2 + 10 | 0] = _x$6;
                                  t[tlen$2 + 12 | 0] = _x$7;
                                  t[tlen$2 + 14 | 0] = _x$8;
                                  _tmp$38 = tlen$2 + 16 | 0;
                                  _tmp$39 = _x$9;
                                  continue;
                                } else {
                                  const _x$9 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                  tlen$6 = tlen$2;
                                  rest$4 = _x$9;
                                  b = _x;
                                  break _L$6;
                                }
                              } else {
                                const _x$8 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                tlen$6 = tlen$2;
                                rest$4 = _x$8;
                                b = _x;
                                break _L$6;
                              }
                            } else {
                              const _x$7 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                              tlen$6 = tlen$2;
                              rest$4 = _x$7;
                              b = _x;
                              break _L$6;
                            }
                          } else {
                            const _x$6 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                            tlen$6 = tlen$2;
                            rest$4 = _x$6;
                            b = _x;
                            break _L$6;
                          }
                        } else {
                          const _x$5 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                          tlen$6 = tlen$2;
                          rest$4 = _x$5;
                          b = _x;
                          break _L$6;
                        }
                      } else {
                        const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                        tlen$6 = tlen$2;
                        rest$4 = _x$4;
                        b = _x;
                        break _L$6;
                      }
                    } else {
                      const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                      tlen$6 = tlen$2;
                      rest$4 = _x$3;
                      b = _x;
                      break _L$6;
                    }
                  } else {
                    if (_x >= 194 && _x <= 223) {
                      const _x$2 = bs.bytes[bs.start + 1 | 0];
                      if (_x$2 >= 128 && _x$2 <= 191) {
                        const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                        tlen$5 = tlen$2;
                        rest$3 = _x$3;
                        b0$3 = _x;
                        b1$3 = _x$2;
                        break _L$5;
                      } else {
                        bytes$3 = bs;
                        break _L$2;
                      }
                    } else {
                      if (_x === 224) {
                        const _x$2 = bs.bytes[bs.start + 1 | 0];
                        if (_x$2 >= 160 && _x$2 <= 191) {
                          const _x$3 = bs.bytes[bs.start + 2 | 0];
                          if (_x$3 >= 128 && _x$3 <= 191) {
                            const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                            tlen$4 = tlen$2;
                            b0$2 = _x;
                            b1$2 = _x$2;
                            b2$2 = _x$3;
                            rest$2 = _x$4;
                            break _L$4;
                          } else {
                            bytes$3 = bs;
                            break _L$2;
                          }
                        } else {
                          bytes$3 = bs;
                          break _L$2;
                        }
                      } else {
                        if (_x >= 225 && _x <= 236) {
                          const _x$2 = bs.bytes[bs.start + 1 | 0];
                          if (_x$2 >= 128 && _x$2 <= 191) {
                            const _x$3 = bs.bytes[bs.start + 2 | 0];
                            if (_x$3 >= 128 && _x$3 <= 191) {
                              const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                              tlen$4 = tlen$2;
                              b0$2 = _x;
                              b1$2 = _x$2;
                              b2$2 = _x$3;
                              rest$2 = _x$4;
                              break _L$4;
                            } else {
                              bytes$3 = bs;
                              break _L$2;
                            }
                          } else {
                            bytes$3 = bs;
                            break _L$2;
                          }
                        } else {
                          if (_x === 237) {
                            const _x$2 = bs.bytes[bs.start + 1 | 0];
                            if (_x$2 >= 128 && _x$2 <= 159) {
                              const _x$3 = bs.bytes[bs.start + 2 | 0];
                              if (_x$3 >= 128 && _x$3 <= 191) {
                                const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                                tlen$4 = tlen$2;
                                b0$2 = _x;
                                b1$2 = _x$2;
                                b2$2 = _x$3;
                                rest$2 = _x$4;
                                break _L$4;
                              } else {
                                bytes$3 = bs;
                                break _L$2;
                              }
                            } else {
                              bytes$3 = bs;
                              break _L$2;
                            }
                          } else {
                            if (_x >= 238 && _x <= 239) {
                              const _x$2 = bs.bytes[bs.start + 1 | 0];
                              if (_x$2 >= 128 && _x$2 <= 191) {
                                const _x$3 = bs.bytes[bs.start + 2 | 0];
                                if (_x$3 >= 128 && _x$3 <= 191) {
                                  const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                                  tlen$4 = tlen$2;
                                  b0$2 = _x;
                                  b1$2 = _x$2;
                                  b2$2 = _x$3;
                                  rest$2 = _x$4;
                                  break _L$4;
                                } else {
                                  bytes$3 = bs;
                                  break _L$2;
                                }
                              } else {
                                bytes$3 = bs;
                                break _L$2;
                              }
                            } else {
                              if (_x === 240) {
                                const _x$2 = bs.bytes[bs.start + 1 | 0];
                                if (_x$2 >= 144 && _x$2 <= 191) {
                                  const _x$3 = bs.bytes[bs.start + 2 | 0];
                                  if (_x$3 >= 128 && _x$3 <= 191) {
                                    const _x$4 = bs.bytes[bs.start + 3 | 0];
                                    if (_x$4 >= 128 && _x$4 <= 191) {
                                      const _x$5 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 4 | 0, bs.end);
                                      tlen$3 = tlen$2;
                                      b0 = _x;
                                      b1 = _x$2;
                                      b2 = _x$3;
                                      b3 = _x$4;
                                      rest = _x$5;
                                      break _L$3;
                                    } else {
                                      bytes$3 = bs;
                                      break _L$2;
                                    }
                                  } else {
                                    bytes$3 = bs;
                                    break _L$2;
                                  }
                                } else {
                                  bytes$3 = bs;
                                  break _L$2;
                                }
                              } else {
                                if (_x >= 241 && _x <= 243) {
                                  const _x$2 = bs.bytes[bs.start + 1 | 0];
                                  if (_x$2 >= 128 && _x$2 <= 191) {
                                    const _x$3 = bs.bytes[bs.start + 2 | 0];
                                    if (_x$3 >= 128 && _x$3 <= 191) {
                                      const _x$4 = bs.bytes[bs.start + 3 | 0];
                                      if (_x$4 >= 128 && _x$4 <= 191) {
                                        const _x$5 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 4 | 0, bs.end);
                                        tlen$3 = tlen$2;
                                        b0 = _x;
                                        b1 = _x$2;
                                        b2 = _x$3;
                                        b3 = _x$4;
                                        rest = _x$5;
                                        break _L$3;
                                      } else {
                                        bytes$3 = bs;
                                        break _L$2;
                                      }
                                    } else {
                                      bytes$3 = bs;
                                      break _L$2;
                                    }
                                  } else {
                                    bytes$3 = bs;
                                    break _L$2;
                                  }
                                } else {
                                  if (_x === 244) {
                                    const _x$2 = bs.bytes[bs.start + 1 | 0];
                                    if (_x$2 >= 128 && _x$2 <= 143) {
                                      const _x$3 = bs.bytes[bs.start + 2 | 0];
                                      if (_x$3 >= 128 && _x$3 <= 191) {
                                        const _x$4 = bs.bytes[bs.start + 3 | 0];
                                        if (_x$4 >= 128 && _x$4 <= 191) {
                                          const _x$5 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 4 | 0, bs.end);
                                          tlen$3 = tlen$2;
                                          b0 = _x;
                                          b1 = _x$2;
                                          b2 = _x$3;
                                          b3 = _x$4;
                                          rest = _x$5;
                                          break _L$3;
                                        } else {
                                          bytes$3 = bs;
                                          break _L$2;
                                        }
                                      } else {
                                        bytes$3 = bs;
                                        break _L$2;
                                      }
                                    } else {
                                      bytes$3 = bs;
                                      break _L$2;
                                    }
                                  } else {
                                    bytes$3 = bs;
                                    break _L$2;
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                } else {
                  const _x = bs.bytes[bs.start];
                  if (_x >= 0 && _x <= 127) {
                    const _x$2 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                    tlen$6 = tlen$2;
                    rest$4 = _x$2;
                    b = _x;
                    break _L$6;
                  } else {
                    if ((bs.end - bs.start | 0) >= 2) {
                      if (_x >= 194 && _x <= 223) {
                        const _x$2 = bs.bytes[bs.start + 1 | 0];
                        if (_x$2 >= 128 && _x$2 <= 191) {
                          const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                          tlen$5 = tlen$2;
                          rest$3 = _x$3;
                          b0$3 = _x;
                          b1$3 = _x$2;
                          break _L$5;
                        } else {
                          if ((bs.end - bs.start | 0) >= 3) {
                            (bs.end - bs.start | 0) >= 4;
                            bytes$3 = bs;
                            break _L$2;
                          } else {
                            bytes$3 = bs;
                            break _L$2;
                          }
                        }
                      } else {
                        if ((bs.end - bs.start | 0) >= 3) {
                          if (_x === 224) {
                            const _x$2 = bs.bytes[bs.start + 1 | 0];
                            if (_x$2 >= 160 && _x$2 <= 191) {
                              const _x$3 = bs.bytes[bs.start + 2 | 0];
                              if (_x$3 >= 128 && _x$3 <= 191) {
                                const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                                tlen$4 = tlen$2;
                                b0$2 = _x;
                                b1$2 = _x$2;
                                b2$2 = _x$3;
                                rest$2 = _x$4;
                                break _L$4;
                              } else {
                                (bs.end - bs.start | 0) >= 4;
                                bytes$3 = bs;
                                break _L$2;
                              }
                            } else {
                              (bs.end - bs.start | 0) >= 4;
                              bytes$3 = bs;
                              break _L$2;
                            }
                          } else {
                            if (_x >= 225 && _x <= 236) {
                              const _x$2 = bs.bytes[bs.start + 1 | 0];
                              if (_x$2 >= 128 && _x$2 <= 191) {
                                const _x$3 = bs.bytes[bs.start + 2 | 0];
                                if (_x$3 >= 128 && _x$3 <= 191) {
                                  const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                                  tlen$4 = tlen$2;
                                  b0$2 = _x;
                                  b1$2 = _x$2;
                                  b2$2 = _x$3;
                                  rest$2 = _x$4;
                                  break _L$4;
                                } else {
                                  (bs.end - bs.start | 0) >= 4;
                                  bytes$3 = bs;
                                  break _L$2;
                                }
                              } else {
                                (bs.end - bs.start | 0) >= 4;
                                bytes$3 = bs;
                                break _L$2;
                              }
                            } else {
                              if (_x === 237) {
                                const _x$2 = bs.bytes[bs.start + 1 | 0];
                                if (_x$2 >= 128 && _x$2 <= 159) {
                                  const _x$3 = bs.bytes[bs.start + 2 | 0];
                                  if (_x$3 >= 128 && _x$3 <= 191) {
                                    const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                                    tlen$4 = tlen$2;
                                    b0$2 = _x;
                                    b1$2 = _x$2;
                                    b2$2 = _x$3;
                                    rest$2 = _x$4;
                                    break _L$4;
                                  } else {
                                    (bs.end - bs.start | 0) >= 4;
                                    bytes$3 = bs;
                                    break _L$2;
                                  }
                                } else {
                                  (bs.end - bs.start | 0) >= 4;
                                  bytes$3 = bs;
                                  break _L$2;
                                }
                              } else {
                                if (_x >= 238 && _x <= 239) {
                                  const _x$2 = bs.bytes[bs.start + 1 | 0];
                                  if (_x$2 >= 128 && _x$2 <= 191) {
                                    const _x$3 = bs.bytes[bs.start + 2 | 0];
                                    if (_x$3 >= 128 && _x$3 <= 191) {
                                      const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                                      tlen$4 = tlen$2;
                                      b0$2 = _x;
                                      b1$2 = _x$2;
                                      b2$2 = _x$3;
                                      rest$2 = _x$4;
                                      break _L$4;
                                    } else {
                                      (bs.end - bs.start | 0) >= 4;
                                      bytes$3 = bs;
                                      break _L$2;
                                    }
                                  } else {
                                    (bs.end - bs.start | 0) >= 4;
                                    bytes$3 = bs;
                                    break _L$2;
                                  }
                                } else {
                                  if ((bs.end - bs.start | 0) >= 4) {
                                    if (_x === 240) {
                                      const _x$2 = bs.bytes[bs.start + 1 | 0];
                                      if (_x$2 >= 144 && _x$2 <= 191) {
                                        const _x$3 = bs.bytes[bs.start + 2 | 0];
                                        if (_x$3 >= 128 && _x$3 <= 191) {
                                          const _x$4 = bs.bytes[bs.start + 3 | 0];
                                          if (_x$4 >= 128 && _x$4 <= 191) {
                                            const _x$5 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 4 | 0, bs.end);
                                            tlen$3 = tlen$2;
                                            b0 = _x;
                                            b1 = _x$2;
                                            b2 = _x$3;
                                            b3 = _x$4;
                                            rest = _x$5;
                                            break _L$3;
                                          } else {
                                            bytes$3 = bs;
                                            break _L$2;
                                          }
                                        } else {
                                          bytes$3 = bs;
                                          break _L$2;
                                        }
                                      } else {
                                        bytes$3 = bs;
                                        break _L$2;
                                      }
                                    } else {
                                      if (_x >= 241 && _x <= 243) {
                                        const _x$2 = bs.bytes[bs.start + 1 | 0];
                                        if (_x$2 >= 128 && _x$2 <= 191) {
                                          const _x$3 = bs.bytes[bs.start + 2 | 0];
                                          if (_x$3 >= 128 && _x$3 <= 191) {
                                            const _x$4 = bs.bytes[bs.start + 3 | 0];
                                            if (_x$4 >= 128 && _x$4 <= 191) {
                                              const _x$5 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 4 | 0, bs.end);
                                              tlen$3 = tlen$2;
                                              b0 = _x;
                                              b1 = _x$2;
                                              b2 = _x$3;
                                              b3 = _x$4;
                                              rest = _x$5;
                                              break _L$3;
                                            } else {
                                              bytes$3 = bs;
                                              break _L$2;
                                            }
                                          } else {
                                            bytes$3 = bs;
                                            break _L$2;
                                          }
                                        } else {
                                          bytes$3 = bs;
                                          break _L$2;
                                        }
                                      } else {
                                        if (_x === 244) {
                                          const _x$2 = bs.bytes[bs.start + 1 | 0];
                                          if (_x$2 >= 128 && _x$2 <= 143) {
                                            const _x$3 = bs.bytes[bs.start + 2 | 0];
                                            if (_x$3 >= 128 && _x$3 <= 191) {
                                              const _x$4 = bs.bytes[bs.start + 3 | 0];
                                              if (_x$4 >= 128 && _x$4 <= 191) {
                                                const _x$5 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 4 | 0, bs.end);
                                                tlen$3 = tlen$2;
                                                b0 = _x;
                                                b1 = _x$2;
                                                b2 = _x$3;
                                                b3 = _x$4;
                                                rest = _x$5;
                                                break _L$3;
                                              } else {
                                                bytes$3 = bs;
                                                break _L$2;
                                              }
                                            } else {
                                              bytes$3 = bs;
                                              break _L$2;
                                            }
                                          } else {
                                            bytes$3 = bs;
                                            break _L$2;
                                          }
                                        } else {
                                          bytes$3 = bs;
                                          break _L$2;
                                        }
                                      }
                                    }
                                  } else {
                                    bytes$3 = bs;
                                    break _L$2;
                                  }
                                }
                              }
                            }
                          }
                        } else {
                          bytes$3 = bs;
                          break _L$2;
                        }
                      }
                    } else {
                      bytes$3 = bs;
                      break _L$2;
                    }
                  }
                }
              }
            }
            t[tlen$6] = b;
            _tmp$38 = tlen$6 + 2 | 0;
            _tmp$39 = rest$4;
            continue;
          }
          const ch = (b0$3 & 31) << 6 | b1$3 & 63;
          t[tlen$5] = ch & 255;
          t[tlen$5 + 1 | 0] = ch >> 8 & 255;
          _tmp$38 = tlen$5 + 2 | 0;
          _tmp$39 = rest$3;
          continue;
        }
        const ch = (b0$2 & 15) << 12 | (b1$2 & 63) << 6 | b2$2 & 63;
        t[tlen$4] = ch & 255;
        t[tlen$4 + 1 | 0] = ch >> 8 & 255;
        _tmp$38 = tlen$4 + 2 | 0;
        _tmp$39 = rest$2;
        continue;
      }
      const ch = (b0 & 7) << 18 | (b1 & 63) << 12 | (b2 & 63) << 6 | b3 & 63;
      const chm = ch - 65536 | 0;
      const ch1 = (chm >> 10) + 55296 | 0;
      const ch2 = (chm & 1023) + 56320 | 0;
      t[tlen$3] = ch1 & 255;
      t[tlen$3 + 1 | 0] = ch1 >> 8 & 255;
      t[tlen$3 + 2 | 0] = ch2 & 255;
      t[tlen$3 + 3 | 0] = ch2 >> 8 & 255;
      _tmp$38 = tlen$3 + 4 | 0;
      _tmp$39 = rest;
      continue;
    }
    return new _M0DTPC16result6ResultGsRPC28encoding4utf89MalformedE3Err(new _M0DTPC15error5Error60moonbitlang_2fcore_2fencoding_2futf8_2eMalformed_2eMalformed(bytes$3));
  }
  return new _M0DTPC16result6ResultGsRPC28encoding4utf89MalformedE2Ok(_M0MPC15bytes5Bytes29to__unchecked__string_2einner(t, 0, tlen));
}
function _M0FPC28encoding4utf821decode__lossy_2einner(bytes, ignore_bom) {
  let bytes$2;
  _L: {
    _L$2: {
      if (ignore_bom) {
        _L$3: {
          _L$4: {
            if ((bytes.end - bytes.start | 0) >= 3) {
              const _x = bytes.bytes[bytes.start];
              if (_x === 239) {
                const _x$2 = bytes.bytes[bytes.start + 1 | 0];
                if (_x$2 === 187) {
                  const _x$3 = bytes.bytes[bytes.start + 2 | 0];
                  if (_x$3 === 191) {
                    bytes$2 = new _M0TPC15bytes9BytesView(bytes.bytes, bytes.start + 3 | 0, bytes.end);
                  } else {
                    break _L$4;
                  }
                } else {
                  break _L$4;
                }
              } else {
                break _L$4;
              }
            } else {
              break _L$4;
            }
            break _L$3;
          }
          break _L$2;
        }
      } else {
        break _L$2;
      }
      break _L;
    }
    bytes$2 = bytes;
  }
  const t = $makebytes(Math.imul(bytes$2.end - bytes$2.start | 0, 2) | 0, 0);
  let tlen;
  let _tmp$38 = 0;
  let _tmp$39 = bytes$2;
  while (true) {
    const tlen$2 = _tmp$38;
    const bs = _tmp$39;
    let tlen$3;
    let rest;
    _L$2: {
      let rest$2;
      let tlen$4;
      _L$3: {
        let rest$3;
        let tlen$5;
        _L$4: {
          let rest$4;
          let tlen$6;
          _L$5: {
            let tlen$7;
            let b0;
            let b1;
            let b2;
            let b3;
            let rest$5;
            _L$6: {
              let tlen$8;
              let b0$2;
              let b1$2;
              let b2$2;
              let rest$6;
              _L$7: {
                let tlen$9;
                let rest$7;
                let b0$3;
                let b1$3;
                _L$8: {
                  let tlen$10;
                  let rest$8;
                  let b;
                  _L$9: {
                    if ((bs.end - bs.start | 0) === 0) {
                      tlen = tlen$2;
                      break;
                    } else {
                      if ((bs.end - bs.start | 0) >= 8) {
                        const _x = bs.bytes[bs.start];
                        if (_x <= 127) {
                          const _x$2 = bs.bytes[bs.start + 1 | 0];
                          if (_x$2 <= 127) {
                            const _x$3 = bs.bytes[bs.start + 2 | 0];
                            if (_x$3 <= 127) {
                              const _x$4 = bs.bytes[bs.start + 3 | 0];
                              if (_x$4 <= 127) {
                                const _x$5 = bs.bytes[bs.start + 4 | 0];
                                if (_x$5 <= 127) {
                                  const _x$6 = bs.bytes[bs.start + 5 | 0];
                                  if (_x$6 <= 127) {
                                    const _x$7 = bs.bytes[bs.start + 6 | 0];
                                    if (_x$7 <= 127) {
                                      const _x$8 = bs.bytes[bs.start + 7 | 0];
                                      if (_x$8 <= 127) {
                                        const _x$9 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 8 | 0, bs.end);
                                        t[tlen$2] = _x;
                                        t[tlen$2 + 2 | 0] = _x$2;
                                        t[tlen$2 + 4 | 0] = _x$3;
                                        t[tlen$2 + 6 | 0] = _x$4;
                                        t[tlen$2 + 8 | 0] = _x$5;
                                        t[tlen$2 + 10 | 0] = _x$6;
                                        t[tlen$2 + 12 | 0] = _x$7;
                                        t[tlen$2 + 14 | 0] = _x$8;
                                        _tmp$38 = tlen$2 + 16 | 0;
                                        _tmp$39 = _x$9;
                                        continue;
                                      } else {
                                        const _x$9 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                        tlen$10 = tlen$2;
                                        rest$8 = _x$9;
                                        b = _x;
                                        break _L$9;
                                      }
                                    } else {
                                      const _x$8 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                      tlen$10 = tlen$2;
                                      rest$8 = _x$8;
                                      b = _x;
                                      break _L$9;
                                    }
                                  } else {
                                    const _x$7 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                    tlen$10 = tlen$2;
                                    rest$8 = _x$7;
                                    b = _x;
                                    break _L$9;
                                  }
                                } else {
                                  const _x$6 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                  tlen$10 = tlen$2;
                                  rest$8 = _x$6;
                                  b = _x;
                                  break _L$9;
                                }
                              } else {
                                const _x$5 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                tlen$10 = tlen$2;
                                rest$8 = _x$5;
                                b = _x;
                                break _L$9;
                              }
                            } else {
                              const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                              tlen$10 = tlen$2;
                              rest$8 = _x$4;
                              b = _x;
                              break _L$9;
                            }
                          } else {
                            const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                            tlen$10 = tlen$2;
                            rest$8 = _x$3;
                            b = _x;
                            break _L$9;
                          }
                        } else {
                          if (_x >= 194 && _x <= 223) {
                            const _x$2 = bs.bytes[bs.start + 1 | 0];
                            if (_x$2 >= 128 && _x$2 <= 191) {
                              const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                              tlen$9 = tlen$2;
                              rest$7 = _x$3;
                              b0$3 = _x;
                              b1$3 = _x$2;
                              break _L$8;
                            } else {
                              const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                              tlen$3 = tlen$2;
                              rest = _x$3;
                              break _L$2;
                            }
                          } else {
                            if (_x === 224) {
                              const _x$2 = bs.bytes[bs.start + 1 | 0];
                              if (_x$2 >= 160 && _x$2 <= 191) {
                                const _x$3 = bs.bytes[bs.start + 2 | 0];
                                if (_x$3 >= 128 && _x$3 <= 191) {
                                  const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                                  tlen$8 = tlen$2;
                                  b0$2 = _x;
                                  b1$2 = _x$2;
                                  b2$2 = _x$3;
                                  rest$6 = _x$4;
                                  break _L$7;
                                } else {
                                  const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                  rest$4 = _x$4;
                                  tlen$6 = tlen$2;
                                  break _L$5;
                                }
                              } else {
                                const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                tlen$3 = tlen$2;
                                rest = _x$3;
                                break _L$2;
                              }
                            } else {
                              if (_x >= 225 && _x <= 236) {
                                const _x$2 = bs.bytes[bs.start + 1 | 0];
                                if (_x$2 >= 128 && _x$2 <= 191) {
                                  const _x$3 = bs.bytes[bs.start + 2 | 0];
                                  if (_x$3 >= 128 && _x$3 <= 191) {
                                    const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                                    tlen$8 = tlen$2;
                                    b0$2 = _x;
                                    b1$2 = _x$2;
                                    b2$2 = _x$3;
                                    rest$6 = _x$4;
                                    break _L$7;
                                  } else {
                                    const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                    rest$4 = _x$4;
                                    tlen$6 = tlen$2;
                                    break _L$5;
                                  }
                                } else {
                                  const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                  tlen$3 = tlen$2;
                                  rest = _x$3;
                                  break _L$2;
                                }
                              } else {
                                if (_x === 237) {
                                  const _x$2 = bs.bytes[bs.start + 1 | 0];
                                  if (_x$2 >= 128 && _x$2 <= 159) {
                                    const _x$3 = bs.bytes[bs.start + 2 | 0];
                                    if (_x$3 >= 128 && _x$3 <= 191) {
                                      const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                                      tlen$8 = tlen$2;
                                      b0$2 = _x;
                                      b1$2 = _x$2;
                                      b2$2 = _x$3;
                                      rest$6 = _x$4;
                                      break _L$7;
                                    } else {
                                      const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                      rest$4 = _x$4;
                                      tlen$6 = tlen$2;
                                      break _L$5;
                                    }
                                  } else {
                                    const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                    tlen$3 = tlen$2;
                                    rest = _x$3;
                                    break _L$2;
                                  }
                                } else {
                                  if (_x >= 238 && _x <= 239) {
                                    const _x$2 = bs.bytes[bs.start + 1 | 0];
                                    if (_x$2 >= 128 && _x$2 <= 191) {
                                      const _x$3 = bs.bytes[bs.start + 2 | 0];
                                      if (_x$3 >= 128 && _x$3 <= 191) {
                                        const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                                        tlen$8 = tlen$2;
                                        b0$2 = _x;
                                        b1$2 = _x$2;
                                        b2$2 = _x$3;
                                        rest$6 = _x$4;
                                        break _L$7;
                                      } else {
                                        const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                        rest$4 = _x$4;
                                        tlen$6 = tlen$2;
                                        break _L$5;
                                      }
                                    } else {
                                      const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                      tlen$3 = tlen$2;
                                      rest = _x$3;
                                      break _L$2;
                                    }
                                  } else {
                                    if (_x === 240) {
                                      const _x$2 = bs.bytes[bs.start + 1 | 0];
                                      if (_x$2 >= 144 && _x$2 <= 191) {
                                        const _x$3 = bs.bytes[bs.start + 2 | 0];
                                        if (_x$3 >= 128 && _x$3 <= 191) {
                                          const _x$4 = bs.bytes[bs.start + 3 | 0];
                                          if (_x$4 >= 128 && _x$4 <= 191) {
                                            const _x$5 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 4 | 0, bs.end);
                                            tlen$7 = tlen$2;
                                            b0 = _x;
                                            b1 = _x$2;
                                            b2 = _x$3;
                                            b3 = _x$4;
                                            rest$5 = _x$5;
                                            break _L$6;
                                          } else {
                                            const _x$5 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                                            rest$3 = _x$5;
                                            tlen$5 = tlen$2;
                                            break _L$4;
                                          }
                                        } else {
                                          const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                          rest$2 = _x$4;
                                          tlen$4 = tlen$2;
                                          break _L$3;
                                        }
                                      } else {
                                        const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                        tlen$3 = tlen$2;
                                        rest = _x$3;
                                        break _L$2;
                                      }
                                    } else {
                                      if (_x >= 241 && _x <= 243) {
                                        const _x$2 = bs.bytes[bs.start + 1 | 0];
                                        if (_x$2 >= 128 && _x$2 <= 191) {
                                          const _x$3 = bs.bytes[bs.start + 2 | 0];
                                          if (_x$3 >= 128 && _x$3 <= 191) {
                                            const _x$4 = bs.bytes[bs.start + 3 | 0];
                                            if (_x$4 >= 128 && _x$4 <= 191) {
                                              const _x$5 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 4 | 0, bs.end);
                                              tlen$7 = tlen$2;
                                              b0 = _x;
                                              b1 = _x$2;
                                              b2 = _x$3;
                                              b3 = _x$4;
                                              rest$5 = _x$5;
                                              break _L$6;
                                            } else {
                                              const _x$5 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                                              rest$3 = _x$5;
                                              tlen$5 = tlen$2;
                                              break _L$4;
                                            }
                                          } else {
                                            const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                            rest$2 = _x$4;
                                            tlen$4 = tlen$2;
                                            break _L$3;
                                          }
                                        } else {
                                          const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                          tlen$3 = tlen$2;
                                          rest = _x$3;
                                          break _L$2;
                                        }
                                      } else {
                                        if (_x === 244) {
                                          const _x$2 = bs.bytes[bs.start + 1 | 0];
                                          if (_x$2 >= 128 && _x$2 <= 143) {
                                            const _x$3 = bs.bytes[bs.start + 2 | 0];
                                            if (_x$3 >= 128 && _x$3 <= 191) {
                                              const _x$4 = bs.bytes[bs.start + 3 | 0];
                                              if (_x$4 >= 128 && _x$4 <= 191) {
                                                const _x$5 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 4 | 0, bs.end);
                                                tlen$7 = tlen$2;
                                                b0 = _x;
                                                b1 = _x$2;
                                                b2 = _x$3;
                                                b3 = _x$4;
                                                rest$5 = _x$5;
                                                break _L$6;
                                              } else {
                                                const _x$5 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                                                rest$3 = _x$5;
                                                tlen$5 = tlen$2;
                                                break _L$4;
                                              }
                                            } else {
                                              const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                              rest$2 = _x$4;
                                              tlen$4 = tlen$2;
                                              break _L$3;
                                            }
                                          } else {
                                            const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                            tlen$3 = tlen$2;
                                            rest = _x$3;
                                            break _L$2;
                                          }
                                        } else {
                                          const _x$2 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                          tlen$3 = tlen$2;
                                          rest = _x$2;
                                          break _L$2;
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      } else {
                        const _x = bs.bytes[bs.start];
                        if (_x >= 0 && _x <= 127) {
                          const _x$2 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                          tlen$10 = tlen$2;
                          rest$8 = _x$2;
                          b = _x;
                          break _L$9;
                        } else {
                          if ((bs.end - bs.start | 0) >= 2) {
                            if (_x >= 194 && _x <= 223) {
                              const _x$2 = bs.bytes[bs.start + 1 | 0];
                              if (_x$2 >= 128 && _x$2 <= 191) {
                                const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                tlen$9 = tlen$2;
                                rest$7 = _x$3;
                                b0$3 = _x;
                                b1$3 = _x$2;
                                break _L$8;
                              } else {
                                if ((bs.end - bs.start | 0) >= 3) {
                                  if ((bs.end - bs.start | 0) >= 4) {
                                    const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                    tlen$3 = tlen$2;
                                    rest = _x$3;
                                    break _L$2;
                                  } else {
                                    const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                    tlen$3 = tlen$2;
                                    rest = _x$3;
                                    break _L$2;
                                  }
                                } else {
                                  const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                  tlen$3 = tlen$2;
                                  rest = _x$3;
                                  break _L$2;
                                }
                              }
                            } else {
                              if ((bs.end - bs.start | 0) >= 3) {
                                if (_x === 224) {
                                  const _x$2 = bs.bytes[bs.start + 1 | 0];
                                  if (_x$2 >= 160 && _x$2 <= 191) {
                                    const _x$3 = bs.bytes[bs.start + 2 | 0];
                                    if (_x$3 >= 128 && _x$3 <= 191) {
                                      const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                                      tlen$8 = tlen$2;
                                      b0$2 = _x;
                                      b1$2 = _x$2;
                                      b2$2 = _x$3;
                                      rest$6 = _x$4;
                                      break _L$7;
                                    } else {
                                      if ((bs.end - bs.start | 0) >= 4) {
                                        const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                        rest$4 = _x$4;
                                        tlen$6 = tlen$2;
                                        break _L$5;
                                      } else {
                                        const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                        rest$4 = _x$4;
                                        tlen$6 = tlen$2;
                                        break _L$5;
                                      }
                                    }
                                  } else {
                                    if ((bs.end - bs.start | 0) >= 4) {
                                      const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                      tlen$3 = tlen$2;
                                      rest = _x$3;
                                      break _L$2;
                                    } else {
                                      const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                      tlen$3 = tlen$2;
                                      rest = _x$3;
                                      break _L$2;
                                    }
                                  }
                                } else {
                                  if (_x >= 225 && _x <= 236) {
                                    const _x$2 = bs.bytes[bs.start + 1 | 0];
                                    if (_x$2 >= 128 && _x$2 <= 191) {
                                      const _x$3 = bs.bytes[bs.start + 2 | 0];
                                      if (_x$3 >= 128 && _x$3 <= 191) {
                                        const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                                        tlen$8 = tlen$2;
                                        b0$2 = _x;
                                        b1$2 = _x$2;
                                        b2$2 = _x$3;
                                        rest$6 = _x$4;
                                        break _L$7;
                                      } else {
                                        if ((bs.end - bs.start | 0) >= 4) {
                                          const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                          rest$4 = _x$4;
                                          tlen$6 = tlen$2;
                                          break _L$5;
                                        } else {
                                          const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                          rest$4 = _x$4;
                                          tlen$6 = tlen$2;
                                          break _L$5;
                                        }
                                      }
                                    } else {
                                      if ((bs.end - bs.start | 0) >= 4) {
                                        const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                        tlen$3 = tlen$2;
                                        rest = _x$3;
                                        break _L$2;
                                      } else {
                                        const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                        tlen$3 = tlen$2;
                                        rest = _x$3;
                                        break _L$2;
                                      }
                                    }
                                  } else {
                                    if (_x === 237) {
                                      const _x$2 = bs.bytes[bs.start + 1 | 0];
                                      if (_x$2 >= 128 && _x$2 <= 159) {
                                        const _x$3 = bs.bytes[bs.start + 2 | 0];
                                        if (_x$3 >= 128 && _x$3 <= 191) {
                                          const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                                          tlen$8 = tlen$2;
                                          b0$2 = _x;
                                          b1$2 = _x$2;
                                          b2$2 = _x$3;
                                          rest$6 = _x$4;
                                          break _L$7;
                                        } else {
                                          if ((bs.end - bs.start | 0) >= 4) {
                                            const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                            rest$4 = _x$4;
                                            tlen$6 = tlen$2;
                                            break _L$5;
                                          } else {
                                            const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                            rest$4 = _x$4;
                                            tlen$6 = tlen$2;
                                            break _L$5;
                                          }
                                        }
                                      } else {
                                        if ((bs.end - bs.start | 0) >= 4) {
                                          const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                          tlen$3 = tlen$2;
                                          rest = _x$3;
                                          break _L$2;
                                        } else {
                                          const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                          tlen$3 = tlen$2;
                                          rest = _x$3;
                                          break _L$2;
                                        }
                                      }
                                    } else {
                                      if (_x >= 238 && _x <= 239) {
                                        const _x$2 = bs.bytes[bs.start + 1 | 0];
                                        if (_x$2 >= 128 && _x$2 <= 191) {
                                          const _x$3 = bs.bytes[bs.start + 2 | 0];
                                          if (_x$3 >= 128 && _x$3 <= 191) {
                                            const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                                            tlen$8 = tlen$2;
                                            b0$2 = _x;
                                            b1$2 = _x$2;
                                            b2$2 = _x$3;
                                            rest$6 = _x$4;
                                            break _L$7;
                                          } else {
                                            if ((bs.end - bs.start | 0) >= 4) {
                                              const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                              rest$4 = _x$4;
                                              tlen$6 = tlen$2;
                                              break _L$5;
                                            } else {
                                              const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                              rest$4 = _x$4;
                                              tlen$6 = tlen$2;
                                              break _L$5;
                                            }
                                          }
                                        } else {
                                          if ((bs.end - bs.start | 0) >= 4) {
                                            const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                            tlen$3 = tlen$2;
                                            rest = _x$3;
                                            break _L$2;
                                          } else {
                                            const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                            tlen$3 = tlen$2;
                                            rest = _x$3;
                                            break _L$2;
                                          }
                                        }
                                      } else {
                                        if ((bs.end - bs.start | 0) >= 4) {
                                          if (_x === 240) {
                                            const _x$2 = bs.bytes[bs.start + 1 | 0];
                                            if (_x$2 >= 144 && _x$2 <= 191) {
                                              const _x$3 = bs.bytes[bs.start + 2 | 0];
                                              if (_x$3 >= 128 && _x$3 <= 191) {
                                                const _x$4 = bs.bytes[bs.start + 3 | 0];
                                                if (_x$4 >= 128 && _x$4 <= 191) {
                                                  const _x$5 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 4 | 0, bs.end);
                                                  tlen$7 = tlen$2;
                                                  b0 = _x;
                                                  b1 = _x$2;
                                                  b2 = _x$3;
                                                  b3 = _x$4;
                                                  rest$5 = _x$5;
                                                  break _L$6;
                                                } else {
                                                  const _x$5 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                                                  rest$3 = _x$5;
                                                  tlen$5 = tlen$2;
                                                  break _L$4;
                                                }
                                              } else {
                                                const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                                rest$2 = _x$4;
                                                tlen$4 = tlen$2;
                                                break _L$3;
                                              }
                                            } else {
                                              const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                              tlen$3 = tlen$2;
                                              rest = _x$3;
                                              break _L$2;
                                            }
                                          } else {
                                            if (_x >= 241 && _x <= 243) {
                                              const _x$2 = bs.bytes[bs.start + 1 | 0];
                                              if (_x$2 >= 128 && _x$2 <= 191) {
                                                const _x$3 = bs.bytes[bs.start + 2 | 0];
                                                if (_x$3 >= 128 && _x$3 <= 191) {
                                                  const _x$4 = bs.bytes[bs.start + 3 | 0];
                                                  if (_x$4 >= 128 && _x$4 <= 191) {
                                                    const _x$5 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 4 | 0, bs.end);
                                                    tlen$7 = tlen$2;
                                                    b0 = _x;
                                                    b1 = _x$2;
                                                    b2 = _x$3;
                                                    b3 = _x$4;
                                                    rest$5 = _x$5;
                                                    break _L$6;
                                                  } else {
                                                    const _x$5 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                                                    rest$3 = _x$5;
                                                    tlen$5 = tlen$2;
                                                    break _L$4;
                                                  }
                                                } else {
                                                  const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                                  rest$2 = _x$4;
                                                  tlen$4 = tlen$2;
                                                  break _L$3;
                                                }
                                              } else {
                                                const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                                tlen$3 = tlen$2;
                                                rest = _x$3;
                                                break _L$2;
                                              }
                                            } else {
                                              if (_x === 244) {
                                                const _x$2 = bs.bytes[bs.start + 1 | 0];
                                                if (_x$2 >= 128 && _x$2 <= 143) {
                                                  const _x$3 = bs.bytes[bs.start + 2 | 0];
                                                  if (_x$3 >= 128 && _x$3 <= 191) {
                                                    const _x$4 = bs.bytes[bs.start + 3 | 0];
                                                    if (_x$4 >= 128 && _x$4 <= 191) {
                                                      const _x$5 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 4 | 0, bs.end);
                                                      tlen$7 = tlen$2;
                                                      b0 = _x;
                                                      b1 = _x$2;
                                                      b2 = _x$3;
                                                      b3 = _x$4;
                                                      rest$5 = _x$5;
                                                      break _L$6;
                                                    } else {
                                                      const _x$5 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                                                      rest$3 = _x$5;
                                                      tlen$5 = tlen$2;
                                                      break _L$4;
                                                    }
                                                  } else {
                                                    const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                                    rest$2 = _x$4;
                                                    tlen$4 = tlen$2;
                                                    break _L$3;
                                                  }
                                                } else {
                                                  const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                                  tlen$3 = tlen$2;
                                                  rest = _x$3;
                                                  break _L$2;
                                                }
                                              } else {
                                                const _x$2 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                                tlen$3 = tlen$2;
                                                rest = _x$2;
                                                break _L$2;
                                              }
                                            }
                                          }
                                        } else {
                                          if (_x === 240) {
                                            const _x$2 = bs.bytes[bs.start + 1 | 0];
                                            if (_x$2 >= 144 && _x$2 <= 191) {
                                              const _x$3 = bs.bytes[bs.start + 2 | 0];
                                              if (_x$3 >= 128 && _x$3 <= 191) {
                                                const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                                                rest$3 = _x$4;
                                                tlen$5 = tlen$2;
                                                break _L$4;
                                              } else {
                                                const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                                rest$2 = _x$4;
                                                tlen$4 = tlen$2;
                                                break _L$3;
                                              }
                                            } else {
                                              const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                              tlen$3 = tlen$2;
                                              rest = _x$3;
                                              break _L$2;
                                            }
                                          } else {
                                            if (_x >= 241 && _x <= 243) {
                                              const _x$2 = bs.bytes[bs.start + 1 | 0];
                                              if (_x$2 >= 128 && _x$2 <= 191) {
                                                const _x$3 = bs.bytes[bs.start + 2 | 0];
                                                if (_x$3 >= 128 && _x$3 <= 191) {
                                                  const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                                                  rest$3 = _x$4;
                                                  tlen$5 = tlen$2;
                                                  break _L$4;
                                                } else {
                                                  const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                                  rest$2 = _x$4;
                                                  tlen$4 = tlen$2;
                                                  break _L$3;
                                                }
                                              } else {
                                                const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                                tlen$3 = tlen$2;
                                                rest = _x$3;
                                                break _L$2;
                                              }
                                            } else {
                                              if (_x === 244) {
                                                const _x$2 = bs.bytes[bs.start + 1 | 0];
                                                if (_x$2 >= 128 && _x$2 <= 143) {
                                                  const _x$3 = bs.bytes[bs.start + 2 | 0];
                                                  if (_x$3 >= 128 && _x$3 <= 191) {
                                                    const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 3 | 0, bs.end);
                                                    rest$3 = _x$4;
                                                    tlen$5 = tlen$2;
                                                    break _L$4;
                                                  } else {
                                                    const _x$4 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                                    rest$2 = _x$4;
                                                    tlen$4 = tlen$2;
                                                    break _L$3;
                                                  }
                                                } else {
                                                  const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                                  tlen$3 = tlen$2;
                                                  rest = _x$3;
                                                  break _L$2;
                                                }
                                              } else {
                                                const _x$2 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                                tlen$3 = tlen$2;
                                                rest = _x$2;
                                                break _L$2;
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              } else {
                                if (_x === 224) {
                                  const _x$2 = bs.bytes[bs.start + 1 | 0];
                                  if (_x$2 >= 160 && _x$2 <= 191) {
                                    const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                    rest$4 = _x$3;
                                    tlen$6 = tlen$2;
                                    break _L$5;
                                  } else {
                                    const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                    tlen$3 = tlen$2;
                                    rest = _x$3;
                                    break _L$2;
                                  }
                                } else {
                                  if (_x >= 225 && _x <= 236) {
                                    const _x$2 = bs.bytes[bs.start + 1 | 0];
                                    if (_x$2 >= 128 && _x$2 <= 191) {
                                      const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                      rest$4 = _x$3;
                                      tlen$6 = tlen$2;
                                      break _L$5;
                                    } else {
                                      const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                      tlen$3 = tlen$2;
                                      rest = _x$3;
                                      break _L$2;
                                    }
                                  } else {
                                    if (_x === 237) {
                                      const _x$2 = bs.bytes[bs.start + 1 | 0];
                                      if (_x$2 >= 128 && _x$2 <= 159) {
                                        const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                        rest$4 = _x$3;
                                        tlen$6 = tlen$2;
                                        break _L$5;
                                      } else {
                                        const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                        tlen$3 = tlen$2;
                                        rest = _x$3;
                                        break _L$2;
                                      }
                                    } else {
                                      if (_x >= 238 && _x <= 239) {
                                        const _x$2 = bs.bytes[bs.start + 1 | 0];
                                        if (_x$2 >= 128 && _x$2 <= 191) {
                                          const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                          rest$4 = _x$3;
                                          tlen$6 = tlen$2;
                                          break _L$5;
                                        } else {
                                          const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                          tlen$3 = tlen$2;
                                          rest = _x$3;
                                          break _L$2;
                                        }
                                      } else {
                                        if (_x === 240) {
                                          const _x$2 = bs.bytes[bs.start + 1 | 0];
                                          if (_x$2 >= 144 && _x$2 <= 191) {
                                            const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                            rest$2 = _x$3;
                                            tlen$4 = tlen$2;
                                            break _L$3;
                                          } else {
                                            const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                            tlen$3 = tlen$2;
                                            rest = _x$3;
                                            break _L$2;
                                          }
                                        } else {
                                          if (_x >= 241 && _x <= 243) {
                                            const _x$2 = bs.bytes[bs.start + 1 | 0];
                                            if (_x$2 >= 128 && _x$2 <= 191) {
                                              const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                              rest$2 = _x$3;
                                              tlen$4 = tlen$2;
                                              break _L$3;
                                            } else {
                                              const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                              tlen$3 = tlen$2;
                                              rest = _x$3;
                                              break _L$2;
                                            }
                                          } else {
                                            if (_x === 244) {
                                              const _x$2 = bs.bytes[bs.start + 1 | 0];
                                              if (_x$2 >= 128 && _x$2 <= 143) {
                                                const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 2 | 0, bs.end);
                                                rest$2 = _x$3;
                                                tlen$4 = tlen$2;
                                                break _L$3;
                                              } else {
                                                const _x$3 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                                tlen$3 = tlen$2;
                                                rest = _x$3;
                                                break _L$2;
                                              }
                                            } else {
                                              const _x$2 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                                              tlen$3 = tlen$2;
                                              rest = _x$2;
                                              break _L$2;
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          } else {
                            const _x$2 = new _M0TPC15bytes9BytesView(bs.bytes, bs.start + 1 | 0, bs.end);
                            tlen$3 = tlen$2;
                            rest = _x$2;
                            break _L$2;
                          }
                        }
                      }
                    }
                  }
                  t[tlen$10] = b;
                  _tmp$38 = tlen$10 + 2 | 0;
                  _tmp$39 = rest$8;
                  continue;
                }
                const ch = (b0$3 & 31) << 6 | b1$3 & 63;
                t[tlen$9] = ch & 255;
                t[tlen$9 + 1 | 0] = ch >> 8 & 255;
                _tmp$38 = tlen$9 + 2 | 0;
                _tmp$39 = rest$7;
                continue;
              }
              const ch = (b0$2 & 15) << 12 | (b1$2 & 63) << 6 | b2$2 & 63;
              t[tlen$8] = ch & 255;
              t[tlen$8 + 1 | 0] = ch >> 8 & 255;
              _tmp$38 = tlen$8 + 2 | 0;
              _tmp$39 = rest$6;
              continue;
            }
            const ch = (b0 & 7) << 18 | (b1 & 63) << 12 | (b2 & 63) << 6 | b3 & 63;
            const chm = ch - 65536 | 0;
            const ch1 = (chm >> 10) + 55296 | 0;
            const ch2 = (chm & 1023) + 56320 | 0;
            t[tlen$7] = ch1 & 255;
            t[tlen$7 + 1 | 0] = ch1 >> 8 & 255;
            t[tlen$7 + 2 | 0] = ch2 & 255;
            t[tlen$7 + 3 | 0] = ch2 >> 8 & 255;
            _tmp$38 = tlen$7 + 4 | 0;
            _tmp$39 = rest$5;
            continue;
          }
          t[tlen$6] = 253;
          t[tlen$6 + 1 | 0] = 255;
          _tmp$38 = tlen$6 + 2 | 0;
          _tmp$39 = rest$4;
          continue;
        }
        t[tlen$5] = 253;
        t[tlen$5 + 1 | 0] = 255;
        _tmp$38 = tlen$5 + 2 | 0;
        _tmp$39 = rest$3;
        continue;
      }
      t[tlen$4] = 253;
      t[tlen$4 + 1 | 0] = 255;
      _tmp$38 = tlen$4 + 2 | 0;
      _tmp$39 = rest$2;
      continue;
    }
    t[tlen$3] = 253;
    t[tlen$3 + 1 | 0] = 255;
    _tmp$38 = tlen$3 + 2 | 0;
    _tmp$39 = rest;
    continue;
  }
  return _M0MPC15bytes5Bytes29to__unchecked__string_2einner(t, 0, tlen);
}
function _M0FPC14math3sin(_tmp$38) {
  return Math.sin(_tmp$38);
}
function _M0FPC14math3cos(_tmp$38) {
  return Math.cos(_tmp$38);
}
function _M0FPC14math3tan(_tmp$38) {
  return Math.tan(_tmp$38);
}
function _M0FPC14math4asin(_tmp$38) {
  return Math.asin(_tmp$38);
}
function _M0FPC14math4acos(_tmp$38) {
  return Math.acos(_tmp$38);
}
function _M0FPC14math4atan(_tmp$38) {
  return Math.atan(_tmp$38);
}
function _M0FPC14math3pow(_tmp$38, _tmp$39) {
  return Math.pow(_tmp$38, _tmp$39);
}
function _M0FPC14math2ln(_tmp$38) {
  return Math.log(_tmp$38);
}
function _M0FPC14math3exp(_tmp$38) {
  return Math.exp(_tmp$38);
}
function _M0FPC111sorted__map9new__nodeGiRP219moonbit_2dcommunity4yaml4YamlE(key, value) {
  return new _M0TPC111sorted__map4NodeGiRP219moonbit_2dcommunity4yaml4YamlE(key, value, undefined, undefined, 1);
}
function _M0FPC111sorted__map16new__sorted__mapGiRP219moonbit_2dcommunity4yaml4YamlE() {
  return new _M0TPC111sorted__map9SortedMapGiRP219moonbit_2dcommunity4yaml4YamlE(undefined, 0);
}
function _M0FPC111sorted__map10height__geGiRP219moonbit_2dcommunity4yaml4YamlE(x1, x2) {
  if (x2 === undefined) {
    return true;
  } else {
    const _Some = x2;
    const _n2 = _Some;
    if (x1 === undefined) {
      return false;
    } else {
      const _Some$2 = x1;
      const _n1 = _Some$2;
      return _n1.height >= _n2.height;
    }
  }
}
function _M0MPC111sorted__map4Node14update__heightGiRP219moonbit_2dcommunity4yaml4YamlE(self) {
  const _p$4 = self.left;
  let _p$5;
  if (_p$4 === undefined) {
    _p$5 = 0;
  } else {
    const _p$6 = _p$4;
    const _p$7 = _p$6;
    _p$5 = _p$7.height;
  }
  const _p$6 = self.right;
  let _p$7;
  if (_p$6 === undefined) {
    _p$7 = 0;
  } else {
    const _p$8 = _p$6;
    const _p$9 = _p$8;
    _p$7 = _p$9.height;
  }
  self.height = 1 + (_p$5 > _p$7 ? _p$5 : _p$7) | 0;
}
function _M0FPC111sorted__map9rotate__lGiRP219moonbit_2dcommunity4yaml4YamlE(n) {
  const _p$4 = n.right;
  let r;
  if (_p$4 === undefined) {
    r = $panic();
  } else {
    const _p$5 = _p$4;
    r = _p$5;
  }
  n.right = r.left;
  r.left = n;
  _M0MPC111sorted__map4Node14update__heightGiRP219moonbit_2dcommunity4yaml4YamlE(n);
  _M0MPC111sorted__map4Node14update__heightGiRP219moonbit_2dcommunity4yaml4YamlE(r);
  return r;
}
function _M0FPC111sorted__map9rotate__rGiRP219moonbit_2dcommunity4yaml4YamlE(n) {
  const _p$4 = n.left;
  let l;
  if (_p$4 === undefined) {
    l = $panic();
  } else {
    const _p$5 = _p$4;
    l = _p$5;
  }
  n.left = l.right;
  l.right = n;
  _M0MPC111sorted__map4Node14update__heightGiRP219moonbit_2dcommunity4yaml4YamlE(n);
  _M0MPC111sorted__map4Node14update__heightGiRP219moonbit_2dcommunity4yaml4YamlE(l);
  return l;
}
function _M0FPC111sorted__map10rotate__lrGiRP219moonbit_2dcommunity4yaml4YamlE(n) {
  const _p$4 = n.left;
  let l;
  if (_p$4 === undefined) {
    l = $panic();
  } else {
    const _p$5 = _p$4;
    l = _p$5;
  }
  const v = _M0FPC111sorted__map9rotate__lGiRP219moonbit_2dcommunity4yaml4YamlE(l);
  n.left = v;
  return _M0FPC111sorted__map9rotate__rGiRP219moonbit_2dcommunity4yaml4YamlE(n);
}
function _M0FPC111sorted__map10rotate__rlGiRP219moonbit_2dcommunity4yaml4YamlE(n) {
  const _p$4 = n.right;
  let r;
  if (_p$4 === undefined) {
    r = $panic();
  } else {
    const _p$5 = _p$4;
    r = _p$5;
  }
  const v = _M0FPC111sorted__map9rotate__rGiRP219moonbit_2dcommunity4yaml4YamlE(r);
  n.right = v;
  return _M0FPC111sorted__map9rotate__lGiRP219moonbit_2dcommunity4yaml4YamlE(n);
}
function _M0FPC111sorted__map7balanceGiRP219moonbit_2dcommunity4yaml4YamlE(root) {
  const l = root.left;
  const r = root.right;
  let hl;
  if (l === undefined) {
    hl = 0;
  } else {
    const _p$4 = l;
    const _p$5 = _p$4;
    hl = _p$5.height;
  }
  let hr;
  if (r === undefined) {
    hr = 0;
  } else {
    const _p$4 = r;
    const _p$5 = _p$4;
    hr = _p$5.height;
  }
  let new_root;
  if (hl > (hr + 1 | 0)) {
    let _bind$4;
    if (l === undefined) {
      _bind$4 = $panic();
    } else {
      const _p$4 = l;
      _bind$4 = _p$4;
    }
    const _ll = _bind$4.left;
    const _lr = _bind$4.right;
    new_root = _M0FPC111sorted__map10height__geGiRP219moonbit_2dcommunity4yaml4YamlE(_ll, _lr) ? _M0FPC111sorted__map9rotate__rGiRP219moonbit_2dcommunity4yaml4YamlE(root) : _M0FPC111sorted__map10rotate__lrGiRP219moonbit_2dcommunity4yaml4YamlE(root);
  } else {
    if (hr > (hl + 1 | 0)) {
      let _bind$4;
      if (r === undefined) {
        _bind$4 = $panic();
      } else {
        const _p$4 = r;
        _bind$4 = _p$4;
      }
      const _rl = _bind$4.left;
      const _rr = _bind$4.right;
      new_root = _M0FPC111sorted__map10height__geGiRP219moonbit_2dcommunity4yaml4YamlE(_rr, _rl) ? _M0FPC111sorted__map9rotate__lGiRP219moonbit_2dcommunity4yaml4YamlE(root) : _M0FPC111sorted__map10rotate__rlGiRP219moonbit_2dcommunity4yaml4YamlE(root);
    } else {
      new_root = root;
    }
  }
  _M0MPC111sorted__map4Node14update__heightGiRP219moonbit_2dcommunity4yaml4YamlE(new_root);
  return new_root;
}
function _M0FPC111sorted__map9add__nodeGiRP219moonbit_2dcommunity4yaml4YamlE(root, key, value) {
  if (root === undefined) {
    return { _0: _M0FPC111sorted__map9new__nodeGiRP219moonbit_2dcommunity4yaml4YamlE(key, value), _1: true };
  } else {
    const _Some = root;
    const _n = _Some;
    if (key === _n.key) {
      _n.value = value;
      return { _0: _n, _1: false };
    } else {
      const l = _n.left;
      const r = _n.right;
      if (key < _n.key) {
        const _bind$4 = _M0FPC111sorted__map9add__nodeGiRP219moonbit_2dcommunity4yaml4YamlE(l, key, value);
        const _nl = _bind$4._0;
        const _inserted = _bind$4._1;
        _n.left = _nl;
        return { _0: _M0FPC111sorted__map7balanceGiRP219moonbit_2dcommunity4yaml4YamlE(_n), _1: _inserted };
      } else {
        const _bind$4 = _M0FPC111sorted__map9add__nodeGiRP219moonbit_2dcommunity4yaml4YamlE(r, key, value);
        const _nr = _bind$4._0;
        const _inserted = _bind$4._1;
        _n.right = _nr;
        return { _0: _M0FPC111sorted__map7balanceGiRP219moonbit_2dcommunity4yaml4YamlE(_n), _1: _inserted };
      }
    }
  }
}
function _M0MPC111sorted__map9SortedMap3setGiRP219moonbit_2dcommunity4yaml4YamlE(self, key, value) {
  const _bind$4 = _M0FPC111sorted__map9add__nodeGiRP219moonbit_2dcommunity4yaml4YamlE(self.root, key, value);
  const _new_root = _bind$4._0;
  const _inserted = _bind$4._1;
  if (_M0IP016_24default__implPB2Eq10not__equalGORPC111sorted__map4NodeGiRP219moonbit_2dcommunity4yaml4YamlEE(self.root, _new_root)) {
    self.root = _new_root;
  }
  if (_inserted) {
    self.size = self.size + 1 | 0;
    return;
  } else {
    return;
  }
}
function _M0MPC111sorted__map9SortedMap3getGiRP219moonbit_2dcommunity4yaml4YamlE(self, key) {
  let _tmp$38 = self.root;
  while (true) {
    const x = _tmp$38;
    if (x === undefined) {
      return undefined;
    } else {
      const _Some = x;
      const _node = _Some;
      const cmp = $compare_int(key, _node.key);
      if (cmp === 0) {
        return _node.value;
      } else {
        if (cmp > 0) {
          _tmp$38 = _node.right;
          continue;
        } else {
          _tmp$38 = _node.left;
          continue;
        }
      }
    }
  }
}
function _M0MPC111sorted__map9SortedMap3newGiRP219moonbit_2dcommunity4yaml4YamlE() {
  return _M0FPC111sorted__map16new__sorted__mapGiRP219moonbit_2dcommunity4yaml4YamlE();
}
function _M0FPC17strconv9base__errGUiRPC16string10StringViewbEE() {
  return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC17strconv12StrConvErrorE3Err(new _M0DTPC15error5Error58moonbitlang_2fcore_2fstrconv_2eStrConvError_2eStrConvError(_M0FPC17strconv14base__err__str));
}
function _M0FPC17strconv25check__and__consume__base(view, base) {
  if (base === 0) {
    _L: {
      let rest;
      _L$2: {
        let rest$2;
        _L$3: {
          let rest$3;
          _L$4: {
            if (_M0MPC16string6String24char__length__ge_2einner(view.str, 2, view.start, view.end)) {
              const _x = _M0MPC16string6String16unsafe__char__at(view.str, _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 0, view.start, view.end));
              if (_x === 48) {
                const _x$2 = _M0MPC16string6String16unsafe__char__at(view.str, _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 1, view.start, view.end));
                switch (_x$2) {
                  case 120: {
                    const _tmp$38 = view.str;
                    const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$39;
                    if (_bind$4 === undefined) {
                      _tmp$39 = view.end;
                    } else {
                      const _Some = _bind$4;
                      _tmp$39 = _Some;
                    }
                    const _x$3 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, view.end);
                    rest$3 = _x$3;
                    break _L$4;
                  }
                  case 88: {
                    const _tmp$40 = view.str;
                    const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$41;
                    if (_bind$5 === undefined) {
                      _tmp$41 = view.end;
                    } else {
                      const _Some = _bind$5;
                      _tmp$41 = _Some;
                    }
                    const _x$4 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, view.end);
                    rest$3 = _x$4;
                    break _L$4;
                  }
                  case 111: {
                    const _tmp$42 = view.str;
                    const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$43;
                    if (_bind$6 === undefined) {
                      _tmp$43 = view.end;
                    } else {
                      const _Some = _bind$6;
                      _tmp$43 = _Some;
                    }
                    const _x$5 = new _M0TPC16string10StringView(_tmp$42, _tmp$43, view.end);
                    rest$2 = _x$5;
                    break _L$3;
                  }
                  case 79: {
                    const _tmp$44 = view.str;
                    const _bind$7 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$45;
                    if (_bind$7 === undefined) {
                      _tmp$45 = view.end;
                    } else {
                      const _Some = _bind$7;
                      _tmp$45 = _Some;
                    }
                    const _x$6 = new _M0TPC16string10StringView(_tmp$44, _tmp$45, view.end);
                    rest$2 = _x$6;
                    break _L$3;
                  }
                  case 98: {
                    const _tmp$46 = view.str;
                    const _bind$8 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$47;
                    if (_bind$8 === undefined) {
                      _tmp$47 = view.end;
                    } else {
                      const _Some = _bind$8;
                      _tmp$47 = _Some;
                    }
                    const _x$7 = new _M0TPC16string10StringView(_tmp$46, _tmp$47, view.end);
                    rest = _x$7;
                    break _L$2;
                  }
                  case 66: {
                    const _tmp$48 = view.str;
                    const _bind$9 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$49;
                    if (_bind$9 === undefined) {
                      _tmp$49 = view.end;
                    } else {
                      const _Some = _bind$9;
                      _tmp$49 = _Some;
                    }
                    const _x$8 = new _M0TPC16string10StringView(_tmp$48, _tmp$49, view.end);
                    rest = _x$8;
                    break _L$2;
                  }
                  default: {
                    break _L;
                  }
                }
              } else {
                break _L;
              }
            } else {
              break _L;
            }
          }
          return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC17strconv12StrConvErrorE2Ok({ _0: 16, _1: rest$3, _2: true });
        }
        return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC17strconv12StrConvErrorE2Ok({ _0: 8, _1: rest$2, _2: true });
      }
      return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC17strconv12StrConvErrorE2Ok({ _0: 2, _1: rest, _2: true });
    }
    return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC17strconv12StrConvErrorE2Ok({ _0: 10, _1: view, _2: false });
  } else {
    _L: {
      let rest;
      _L$2: {
        let rest$2;
        _L$3: {
          let rest$3;
          _L$4: {
            if (_M0MPC16string6String24char__length__ge_2einner(view.str, 2, view.start, view.end)) {
              const _x = _M0MPC16string6String16unsafe__char__at(view.str, _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 0, view.start, view.end));
              if (_x === 48) {
                const _x$2 = _M0MPC16string6String16unsafe__char__at(view.str, _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 1, view.start, view.end));
                switch (_x$2) {
                  case 120: {
                    const _tmp$38 = view.str;
                    const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$39;
                    if (_bind$4 === undefined) {
                      _tmp$39 = view.end;
                    } else {
                      const _Some = _bind$4;
                      _tmp$39 = _Some;
                    }
                    const _x$3 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, view.end);
                    if (base === 16) {
                      rest$3 = _x$3;
                      break _L$4;
                    } else {
                      break _L;
                    }
                  }
                  case 88: {
                    const _tmp$40 = view.str;
                    const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$41;
                    if (_bind$5 === undefined) {
                      _tmp$41 = view.end;
                    } else {
                      const _Some = _bind$5;
                      _tmp$41 = _Some;
                    }
                    const _x$4 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, view.end);
                    if (base === 16) {
                      rest$3 = _x$4;
                      break _L$4;
                    } else {
                      break _L;
                    }
                  }
                  case 111: {
                    const _tmp$42 = view.str;
                    const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$43;
                    if (_bind$6 === undefined) {
                      _tmp$43 = view.end;
                    } else {
                      const _Some = _bind$6;
                      _tmp$43 = _Some;
                    }
                    const _x$5 = new _M0TPC16string10StringView(_tmp$42, _tmp$43, view.end);
                    if (base === 8) {
                      rest$2 = _x$5;
                      break _L$3;
                    } else {
                      break _L;
                    }
                  }
                  case 79: {
                    const _tmp$44 = view.str;
                    const _bind$7 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$45;
                    if (_bind$7 === undefined) {
                      _tmp$45 = view.end;
                    } else {
                      const _Some = _bind$7;
                      _tmp$45 = _Some;
                    }
                    const _x$6 = new _M0TPC16string10StringView(_tmp$44, _tmp$45, view.end);
                    if (base === 8) {
                      rest$2 = _x$6;
                      break _L$3;
                    } else {
                      break _L;
                    }
                  }
                  case 98: {
                    const _tmp$46 = view.str;
                    const _bind$8 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$47;
                    if (_bind$8 === undefined) {
                      _tmp$47 = view.end;
                    } else {
                      const _Some = _bind$8;
                      _tmp$47 = _Some;
                    }
                    const _x$7 = new _M0TPC16string10StringView(_tmp$46, _tmp$47, view.end);
                    if (base === 2) {
                      rest = _x$7;
                      break _L$2;
                    } else {
                      break _L;
                    }
                  }
                  case 66: {
                    const _tmp$48 = view.str;
                    const _bind$9 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$49;
                    if (_bind$9 === undefined) {
                      _tmp$49 = view.end;
                    } else {
                      const _Some = _bind$9;
                      _tmp$49 = _Some;
                    }
                    const _x$8 = new _M0TPC16string10StringView(_tmp$48, _tmp$49, view.end);
                    if (base === 2) {
                      rest = _x$8;
                      break _L$2;
                    } else {
                      break _L;
                    }
                  }
                  default: {
                    break _L;
                  }
                }
              } else {
                break _L;
              }
            } else {
              break _L;
            }
          }
          return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC17strconv12StrConvErrorE2Ok({ _0: 16, _1: rest$3, _2: true });
        }
        return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC17strconv12StrConvErrorE2Ok({ _0: 8, _1: rest$2, _2: true });
      }
      return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC17strconv12StrConvErrorE2Ok({ _0: 2, _1: rest, _2: true });
    }
    return base >= 2 && base <= 36 ? new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC17strconv12StrConvErrorE2Ok({ _0: base, _1: view, _2: false }) : _M0FPC17strconv9base__errGUiRPC16string10StringViewbEE();
  }
}
function _M0FPC17strconv10range__errGuE() {
  return new _M0DTPC16result6ResultGuRPC17strconv12StrConvErrorE3Err(new _M0DTPC15error5Error58moonbitlang_2fcore_2fstrconv_2eStrConvError_2eStrConvError(_M0FPC17strconv15range__err__str));
}
function _M0FPC17strconv11syntax__errGdE() {
  return new _M0DTPC16result6ResultGdRPC17strconv12StrConvErrorE3Err(new _M0DTPC15error5Error58moonbitlang_2fcore_2fstrconv_2eStrConvError_2eStrConvError(_M0FPC17strconv16syntax__err__str));
}
function _M0FPC17strconv11syntax__errGiE() {
  return new _M0DTPC16result6ResultGiRPC17strconv12StrConvErrorE3Err(new _M0DTPC15error5Error58moonbitlang_2fcore_2fstrconv_2eStrConvError_2eStrConvError(_M0FPC17strconv16syntax__err__str));
}
function _M0FPC17strconv11syntax__errGuE() {
  return new _M0DTPC16result6ResultGuRPC17strconv12StrConvErrorE3Err(new _M0DTPC15error5Error58moonbitlang_2fcore_2fstrconv_2eStrConvError_2eStrConvError(_M0FPC17strconv16syntax__err__str));
}
function _M0FPC17strconv11syntax__errGlE() {
  return new _M0DTPC16result6ResultGlRPC17strconv12StrConvErrorE3Err(new _M0DTPC15error5Error58moonbitlang_2fcore_2fstrconv_2eStrConvError_2eStrConvError(_M0FPC17strconv16syntax__err__str));
}
function _M0FPC17strconv11syntax__errGORPC17strconv6NumberE() {
  return new _M0DTPC16result6ResultGORPC17strconv6NumberRPC17strconv12StrConvErrorE3Err(new _M0DTPC15error5Error58moonbitlang_2fcore_2fstrconv_2eStrConvError_2eStrConvError(_M0FPC17strconv16syntax__err__str));
}
function _M0FPC17strconv19overflow__threshold(base, neg) {
  if (!neg) {
    if (base === 10) {
      return 922337203685477581n;
    } else {
      if (base === 16) {
        return 576460752303423488n;
      } else {
        const _tmp$38 = BigInt.asUintN(64, BigInt(base));
        if (_tmp$38 === 0n) {
          $panic();
        }
        return BigInt.asUintN(64, BigInt.asUintN(64, BigInt.asIntN(64, 9223372036854775807n) / BigInt.asIntN(64, _tmp$38)) + 1n);
      }
    }
  } else {
    if (base === 10) {
      return 17524406870024074036n;
    } else {
      if (base === 16) {
        return 17870283321406128128n;
      } else {
        const _tmp$38 = BigInt.asUintN(64, BigInt(base));
        if (_tmp$38 === 0n) {
          $panic();
        }
        return BigInt.asUintN(64, BigInt.asIntN(64, 9223372036854775808n) / BigInt.asIntN(64, _tmp$38));
      }
    }
  }
}
function _M0FPC17strconv20parse__int64_2einner(str, base) {
  if (_M0IP016_24default__implPB2Eq10not__equalGRPC16string10StringViewE(str, new _M0TPC16string10StringView(_M0FPC17strconv20parse__int64_2einnerN7_2abindS538, 0, _M0FPC17strconv20parse__int64_2einnerN7_2abindS538.length))) {
    let neg;
    let rest;
    _L: {
      let rest$2;
      _L$2: {
        const _bind$4 = _M0MPC16string10StringView12view_2einner(str, 0, undefined);
        if (_M0MPC16string6String24char__length__ge_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end)) {
          const _x = _M0MPC16string6String16unsafe__char__at(_bind$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 0, _bind$4.start, _bind$4.end));
          switch (_x) {
            case 43: {
              const _tmp$38 = _bind$4.str;
              const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
              let _tmp$39;
              if (_bind$5 === undefined) {
                _tmp$39 = _bind$4.end;
              } else {
                const _Some = _bind$5;
                _tmp$39 = _Some;
              }
              const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$4.end);
              neg = false;
              rest = _x$2;
              break _L;
            }
            case 45: {
              const _tmp$40 = _bind$4.str;
              const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
              let _tmp$41;
              if (_bind$6 === undefined) {
                _tmp$41 = _bind$4.end;
              } else {
                const _Some = _bind$6;
                _tmp$41 = _Some;
              }
              const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, _bind$4.end);
              neg = true;
              rest = _x$3;
              break _L;
            }
            default: {
              rest$2 = _bind$4;
              break _L$2;
            }
          }
        } else {
          rest$2 = _bind$4;
          break _L$2;
        }
      }
      neg = false;
      rest = rest$2;
      break _L;
    }
    const _bind$4 = _M0FPC17strconv25check__and__consume__base(rest, base);
    let _bind$5;
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _bind$5 = _ok._0;
    } else {
      return _bind$4;
    }
    const _num_base = _bind$5._0;
    const _rest = _bind$5._1;
    const _allow_underscore = _bind$5._2;
    const overflow_threshold = _M0FPC17strconv19overflow__threshold(_num_base, neg);
    let has_digit;
    if (_M0MPC16string6String24char__length__ge_2einner(_rest.str, 1, _rest.start, _rest.end)) {
      const _x = _M0MPC16string6String16unsafe__char__at(_rest.str, _M0MPC16string6String29offset__of__nth__char_2einner(_rest.str, 0, _rest.start, _rest.end));
      if (_x >= 48 && _x <= 57) {
        has_digit = true;
      } else {
        if (_x >= 97 && _x <= 122) {
          has_digit = true;
        } else {
          if (_x >= 65 && _x <= 90) {
            has_digit = true;
          } else {
            if (_M0MPC16string6String24char__length__ge_2einner(_rest.str, 2, _rest.start, _rest.end)) {
              if (_x === 95) {
                const _x$2 = _M0MPC16string6String16unsafe__char__at(_rest.str, _M0MPC16string6String29offset__of__nth__char_2einner(_rest.str, 1, _rest.start, _rest.end));
                has_digit = _x$2 >= 48 && _x$2 <= 57 ? true : _x$2 >= 97 && _x$2 <= 122 ? true : _x$2 >= 65 && _x$2 <= 90;
              } else {
                has_digit = false;
              }
            } else {
              has_digit = false;
            }
          }
        }
      }
    } else {
      has_digit = false;
    }
    if (has_digit) {
      let _tmp$38;
      let _tmp$39 = _rest;
      let _tmp$40 = 0n;
      let _tmp$41 = _allow_underscore;
      while (true) {
        const s = _tmp$39;
        const acc = _tmp$40;
        const au = _tmp$41;
        let acc$2;
        let rest$2;
        let c;
        _L$2: {
          _L$3: {
            if (_M0MPC16string6String24char__length__eq_2einner(s.str, 1, s.start, s.end)) {
              const _x = _M0MPC16string6String16unsafe__char__at(s.str, _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 0, s.start, s.end));
              if (_x === 95) {
                const _bind$6 = _M0FPC17strconv11syntax__errGuE();
                if (_bind$6.$tag === 1) {
                  const _ok = _bind$6;
                  _ok._0;
                } else {
                  return _bind$6;
                }
              } else {
                const _tmp$42 = s.str;
                const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 1, s.start, s.end);
                let _tmp$43;
                if (_bind$6 === undefined) {
                  _tmp$43 = s.end;
                } else {
                  const _Some = _bind$6;
                  _tmp$43 = _Some;
                }
                const _x$2 = new _M0TPC16string10StringView(_tmp$42, _tmp$43, s.end);
                acc$2 = acc;
                rest$2 = _x$2;
                c = _x;
                break _L$3;
              }
            } else {
              if (_M0MPC16string6String24char__length__ge_2einner(s.str, 1, s.start, s.end)) {
                const _x = _M0MPC16string6String16unsafe__char__at(s.str, _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 0, s.start, s.end));
                if (_x === 95) {
                  if (au === false) {
                    const _bind$6 = _M0FPC17strconv11syntax__errGuE();
                    if (_bind$6.$tag === 1) {
                      const _ok = _bind$6;
                      _ok._0;
                    } else {
                      return _bind$6;
                    }
                  } else {
                    const _tmp$42 = s.str;
                    const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 1, s.start, s.end);
                    let _tmp$43;
                    if (_bind$6 === undefined) {
                      _tmp$43 = s.end;
                    } else {
                      const _Some = _bind$6;
                      _tmp$43 = _Some;
                    }
                    const _x$2 = new _M0TPC16string10StringView(_tmp$42, _tmp$43, s.end);
                    _tmp$39 = _x$2;
                    _tmp$41 = false;
                    continue;
                  }
                } else {
                  const _tmp$42 = s.str;
                  const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 1, s.start, s.end);
                  let _tmp$43;
                  if (_bind$6 === undefined) {
                    _tmp$43 = s.end;
                  } else {
                    const _Some = _bind$6;
                    _tmp$43 = _Some;
                  }
                  const _x$2 = new _M0TPC16string10StringView(_tmp$42, _tmp$43, s.end);
                  acc$2 = acc;
                  rest$2 = _x$2;
                  c = _x;
                  break _L$3;
                }
              } else {
                _tmp$38 = acc;
                break;
              }
            }
            break _L$2;
          }
          const c$2 = c;
          let d;
          if (c$2 >= 48 && c$2 <= 57) {
            d = c$2 - 48 | 0;
          } else {
            if (c$2 >= 97 && c$2 <= 122) {
              d = c$2 + -87 | 0;
            } else {
              if (c$2 >= 65 && c$2 <= 90) {
                d = c$2 + -55 | 0;
              } else {
                const _bind$6 = _M0FPC17strconv11syntax__errGiE();
                if (_bind$6.$tag === 1) {
                  const _ok = _bind$6;
                  d = _ok._0;
                } else {
                  return _bind$6;
                }
              }
            }
          }
          if (d < _num_base) {
            if (neg) {
              if (BigInt.asIntN(64, acc$2) >= BigInt.asIntN(64, overflow_threshold)) {
                const next_acc = BigInt.asUintN(64, BigInt.asUintN(64, acc$2 * BigInt.asUintN(64, BigInt(_num_base))) - BigInt.asUintN(64, BigInt(d)));
                if (BigInt.asIntN(64, next_acc) <= BigInt.asIntN(64, acc$2)) {
                  _tmp$39 = rest$2;
                  _tmp$40 = next_acc;
                  _tmp$41 = true;
                  continue;
                } else {
                  const _bind$6 = _M0FPC17strconv10range__errGuE();
                  if (_bind$6.$tag === 1) {
                    const _ok = _bind$6;
                    _ok._0;
                  } else {
                    return _bind$6;
                  }
                }
              } else {
                const _bind$6 = _M0FPC17strconv10range__errGuE();
                if (_bind$6.$tag === 1) {
                  const _ok = _bind$6;
                  _ok._0;
                } else {
                  return _bind$6;
                }
              }
            } else {
              if (BigInt.asIntN(64, acc$2) < BigInt.asIntN(64, overflow_threshold)) {
                const next_acc = BigInt.asUintN(64, BigInt.asUintN(64, acc$2 * BigInt.asUintN(64, BigInt(_num_base))) + BigInt.asUintN(64, BigInt(d)));
                if (BigInt.asIntN(64, next_acc) >= BigInt.asIntN(64, acc$2)) {
                  _tmp$39 = rest$2;
                  _tmp$40 = next_acc;
                  _tmp$41 = true;
                  continue;
                } else {
                  const _bind$6 = _M0FPC17strconv10range__errGuE();
                  if (_bind$6.$tag === 1) {
                    const _ok = _bind$6;
                    _ok._0;
                  } else {
                    return _bind$6;
                  }
                }
              } else {
                const _bind$6 = _M0FPC17strconv10range__errGuE();
                if (_bind$6.$tag === 1) {
                  const _ok = _bind$6;
                  _ok._0;
                } else {
                  return _bind$6;
                }
              }
            }
          } else {
            const _bind$6 = _M0FPC17strconv11syntax__errGuE();
            if (_bind$6.$tag === 1) {
              const _ok = _bind$6;
              _ok._0;
            } else {
              return _bind$6;
            }
          }
        }
        continue;
      }
      return new _M0DTPC16result6ResultGlRPC17strconv12StrConvErrorE2Ok(_tmp$38);
    } else {
      return _M0FPC17strconv11syntax__errGlE();
    }
  } else {
    return _M0FPC17strconv11syntax__errGlE();
  }
}
function _M0FPC17strconv18parse__int_2einner(str, base) {
  const _bind$4 = _M0FPC17strconv20parse__int64_2einner(str, base);
  let n;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    n = _ok._0;
  } else {
    return _bind$4;
  }
  if (BigInt.asIntN(64, n) < BigInt.asIntN(64, 18446744071562067968n) || BigInt.asIntN(64, n) > BigInt.asIntN(64, 2147483647n)) {
    const _bind$5 = _M0FPC17strconv10range__errGuE();
    if (_bind$5.$tag === 1) {
      const _ok = _bind$5;
      _ok._0;
    } else {
      return _bind$5;
    }
  }
  return new _M0DTPC16result6ResultGiRPC17strconv12StrConvErrorE2Ok(Number(BigInt.asIntN(32, n)) | 0);
}
function _M0FPC17strconv17check__underscore(str) {
  let rest;
  if (_M0MPC16string6String24char__length__ge_2einner(str.str, 1, str.start, str.end)) {
    const _x = _M0MPC16string6String16unsafe__char__at(str.str, _M0MPC16string6String29offset__of__nth__char_2einner(str.str, 0, str.start, str.end));
    switch (_x) {
      case 43: {
        const _tmp$38 = str.str;
        const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(str.str, 1, str.start, str.end);
        let _tmp$39;
        if (_bind$4 === undefined) {
          _tmp$39 = str.end;
        } else {
          const _Some = _bind$4;
          _tmp$39 = _Some;
        }
        const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, str.end);
        rest = _x$2;
        break;
      }
      case 45: {
        const _tmp$40 = str.str;
        const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(str.str, 1, str.start, str.end);
        let _tmp$41;
        if (_bind$5 === undefined) {
          _tmp$41 = str.end;
        } else {
          const _Some = _bind$5;
          _tmp$41 = _Some;
        }
        const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, str.end);
        rest = _x$3;
        break;
      }
      default: {
        rest = str;
      }
    }
  } else {
    rest = str;
  }
  let rest$2;
  let allow_underscore;
  let hex;
  _L: {
    const _data = rest.str;
    const _start = rest.start;
    const _end = _start + (rest.end - rest.start | 0) | 0;
    let _cursor = _start;
    let accept_state = -1;
    let match_end = -1;
    _L$2: {
      if ((_cursor + 1 | 0) < _end) {
        const _p$4 = _cursor;
        if (_data.charCodeAt(_p$4) === 48) {
          _cursor = _cursor + 1 | 0;
          _L$3: {
            _L$4: {
              _L$5: {
                const _p$5 = _cursor;
                const next_char = _data.charCodeAt(_p$5);
                _cursor = _cursor + 1 | 0;
                if (next_char < 89) {
                  if (next_char < 79) {
                    if (next_char === 66) {
                      break _L$3;
                    } else {
                      break _L$2;
                    }
                  } else {
                    if (next_char > 79) {
                      if (next_char < 88) {
                        break _L$2;
                      } else {
                        break _L$5;
                      }
                    } else {
                      break _L$4;
                    }
                  }
                } else {
                  if (next_char > 97) {
                    if (next_char < 112) {
                      if (next_char < 99) {
                        break _L$3;
                      } else {
                        if (next_char > 110) {
                          break _L$4;
                        } else {
                          break _L$2;
                        }
                      }
                    } else {
                      if (next_char > 119) {
                        if (next_char < 121) {
                          break _L$5;
                        } else {
                          break _L$2;
                        }
                      } else {
                        break _L$2;
                      }
                    }
                  } else {
                    break _L$2;
                  }
                }
              }
              accept_state = 2;
              match_end = _cursor;
              break _L$2;
            }
            accept_state = 1;
            match_end = _cursor;
            break _L$2;
          }
          accept_state = 0;
          match_end = _cursor;
          break _L$2;
        } else {
          break _L$2;
        }
      } else {
        break _L$2;
      }
    }
    switch (accept_state) {
      case 2: {
        const rest$3 = _M0MPC16string6String4view(_data, match_end, _end);
        rest$2 = rest$3;
        allow_underscore = true;
        hex = true;
        break _L;
      }
      case 1: {
        const rest$4 = _M0MPC16string6String4view(_data, match_end, _end);
        rest$2 = rest$4;
        allow_underscore = true;
        hex = false;
        break _L;
      }
      case 0: {
        const rest$5 = _M0MPC16string6String4view(_data, match_end, _end);
        rest$2 = rest$5;
        allow_underscore = true;
        hex = false;
        break _L;
      }
      default: {
        rest$2 = rest;
        allow_underscore = false;
        hex = false;
        break _L;
      }
    }
  }
  let _tmp$38 = rest$2;
  let _tmp$39 = allow_underscore;
  let _tmp$40 = false;
  while (true) {
    const s = _tmp$38;
    const au = _tmp$39;
    const fu = _tmp$40;
    let rest$3;
    let c;
    let fu$2;
    _L$2: {
      if (_M0MPC16string6String24char__length__eq_2einner(s.str, 0, s.start, s.end)) {
        return true;
      } else {
        if (_M0MPC16string6String24char__length__eq_2einner(s.str, 1, s.start, s.end)) {
          const _x = _M0MPC16string6String16unsafe__char__at(s.str, _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 0, s.start, s.end));
          if (_x === 95) {
            return false;
          } else {
            const _tmp$41 = s.str;
            const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 1, s.start, s.end);
            let _tmp$42;
            if (_bind$4 === undefined) {
              _tmp$42 = s.end;
            } else {
              const _Some = _bind$4;
              _tmp$42 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$41, _tmp$42, s.end);
            rest$3 = _x$2;
            c = _x;
            fu$2 = fu;
            break _L$2;
          }
        } else {
          const _x = _M0MPC16string6String16unsafe__char__at(s.str, _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 0, s.start, s.end));
          if (_x === 95) {
            if (au === false) {
              return false;
            } else {
              const _tmp$41 = s.str;
              const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 1, s.start, s.end);
              let _tmp$42;
              if (_bind$4 === undefined) {
                _tmp$42 = s.end;
              } else {
                const _Some = _bind$4;
                _tmp$42 = _Some;
              }
              const _x$2 = new _M0TPC16string10StringView(_tmp$41, _tmp$42, s.end);
              _tmp$38 = _x$2;
              _tmp$39 = false;
              _tmp$40 = true;
              continue;
            }
          } else {
            const _tmp$41 = s.str;
            const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 1, s.start, s.end);
            let _tmp$42;
            if (_bind$4 === undefined) {
              _tmp$42 = s.end;
            } else {
              const _Some = _bind$4;
              _tmp$42 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$41, _tmp$42, s.end);
            rest$3 = _x$2;
            c = _x;
            fu$2 = fu;
            break _L$2;
          }
        }
      }
    }
    if (c >= 48 && c <= 57 ? true : hex && (c >= 97 && c <= 102 ? true : c >= 65 && c <= 70)) {
      _tmp$38 = rest$3;
      _tmp$39 = true;
      _tmp$40 = false;
      continue;
    } else {
      if (fu$2) {
        return false;
      } else {
        _tmp$38 = rest$3;
        _tmp$39 = false;
        _tmp$40 = false;
        continue;
      }
    }
  }
}
function _M0MPC17strconv7Decimal9new__priv() {
  return new _M0TPC17strconv7Decimal($makebytes(800, 0), 0, 0, false, false);
}
function _M0MPC17strconv7Decimal4trim(self) {
  while (true) {
    let _tmp$38;
    if (self.digits_num > 0) {
      const _tmp$39 = self.digits;
      const _tmp$40 = self.digits_num - 1 | 0;
      $bound_check(_tmp$39, _tmp$40);
      const _p$4 = _tmp$39[_tmp$40];
      const _p$5 = 0;
      _tmp$38 = _p$4 === _p$5;
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      self.digits_num = self.digits_num - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (self.digits_num === 0) {
    self.decimal_point = 0;
    return;
  } else {
    return;
  }
}
function _M0FPC17strconv26parse__decimal__from__view(str) {
  const d = _M0MPC17strconv7Decimal9new__priv();
  let has_dp = false;
  let has_digits = false;
  let rest;
  _L: {
    _L$2: {
      if (_M0MPC16string6String24char__length__ge_2einner(str.str, 1, str.start, str.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(str.str, _M0MPC16string6String29offset__of__nth__char_2einner(str.str, 0, str.start, str.end));
        switch (_x) {
          case 45: {
            const _tmp$38 = str.str;
            const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(str.str, 1, str.start, str.end);
            let _tmp$39;
            if (_bind$4 === undefined) {
              _tmp$39 = str.end;
            } else {
              const _Some = _bind$4;
              _tmp$39 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, str.end);
            d.negative = true;
            rest = _x$2;
            break;
          }
          case 43: {
            const _tmp$40 = str.str;
            const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(str.str, 1, str.start, str.end);
            let _tmp$41;
            if (_bind$5 === undefined) {
              _tmp$41 = str.end;
            } else {
              const _Some = _bind$5;
              _tmp$41 = _Some;
            }
            rest = new _M0TPC16string10StringView(_tmp$40, _tmp$41, str.end);
            break;
          }
          default: {
            break _L$2;
          }
        }
      } else {
        break _L$2;
      }
      break _L;
    }
    rest = str;
  }
  let rest$2;
  let _tmp$38 = rest;
  while (true) {
    const s = _tmp$38;
    let rest$3;
    _L$2: {
      _L$3: {
        if (_M0MPC16string6String24char__length__ge_2einner(s.str, 1, s.start, s.end)) {
          const _x = _M0MPC16string6String16unsafe__char__at(s.str, _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 0, s.start, s.end));
          if (_x === 95) {
            const _tmp$39 = s.str;
            const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 1, s.start, s.end);
            let _tmp$40;
            if (_bind$4 === undefined) {
              _tmp$40 = s.end;
            } else {
              const _Some = _bind$4;
              _tmp$40 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, s.end);
            _tmp$38 = _x$2;
            continue;
          } else {
            if (_x === 46) {
              const _tmp$39 = s.str;
              const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 1, s.start, s.end);
              let _tmp$40;
              if (_bind$4 === undefined) {
                _tmp$40 = s.end;
              } else {
                const _Some = _bind$4;
                _tmp$40 = _Some;
              }
              const _x$2 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, s.end);
              if (!has_dp) {
                has_dp = true;
                d.decimal_point = d.digits_num;
                _tmp$38 = _x$2;
                continue;
              } else {
                const _bind$5 = _M0FPC17strconv11syntax__errGuE();
                if (_bind$5.$tag === 1) {
                  const _ok = _bind$5;
                  _ok._0;
                } else {
                  return _bind$5;
                }
              }
            } else {
              if (_x >= 48 && _x <= 57) {
                const _tmp$39 = s.str;
                const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 1, s.start, s.end);
                let _tmp$40;
                if (_bind$4 === undefined) {
                  _tmp$40 = s.end;
                } else {
                  const _Some = _bind$4;
                  _tmp$40 = _Some;
                }
                const _x$2 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, s.end);
                has_digits = true;
                if (_x === 48 && d.digits_num === 0) {
                  d.decimal_point = d.decimal_point - 1 | 0;
                  _tmp$38 = _x$2;
                  continue;
                }
                if (d.digits_num < d.digits.length) {
                  const _tmp$41 = d.digits;
                  const _tmp$42 = d.digits_num;
                  $bound_check(_tmp$41, _tmp$42);
                  _tmp$41[_tmp$42] = (_x - 48 | 0) & 255;
                  d.digits_num = d.digits_num + 1 | 0;
                } else {
                  if (_x !== 48) {
                    d.truncated = true;
                  }
                }
                _tmp$38 = _x$2;
                continue;
              } else {
                rest$3 = s;
                break _L$3;
              }
            }
          }
        } else {
          rest$3 = s;
          break _L$3;
        }
        break _L$2;
      }
      rest$2 = rest$3;
      break;
    }
    continue;
  }
  if (has_digits) {
    if (!has_dp) {
      d.decimal_point = d.digits_num;
    }
    let rest$3;
    let rest$4;
    _L$2: {
      _L$3: {
        if (_M0MPC16string6String24char__length__ge_2einner(rest$2.str, 1, rest$2.start, rest$2.end)) {
          const _x = _M0MPC16string6String16unsafe__char__at(rest$2.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 0, rest$2.start, rest$2.end));
          switch (_x) {
            case 101: {
              const _tmp$39 = rest$2.str;
              const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 1, rest$2.start, rest$2.end);
              let _tmp$40;
              if (_bind$4 === undefined) {
                _tmp$40 = rest$2.end;
              } else {
                const _Some = _bind$4;
                _tmp$40 = _Some;
              }
              const _x$2 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, rest$2.end);
              rest$4 = _x$2;
              break _L$3;
            }
            case 69: {
              const _tmp$41 = rest$2.str;
              const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 1, rest$2.start, rest$2.end);
              let _tmp$42;
              if (_bind$5 === undefined) {
                _tmp$42 = rest$2.end;
              } else {
                const _Some = _bind$5;
                _tmp$42 = _Some;
              }
              const _x$3 = new _M0TPC16string10StringView(_tmp$41, _tmp$42, rest$2.end);
              rest$4 = _x$3;
              break _L$3;
            }
            default: {
              rest$3 = rest$2;
            }
          }
        } else {
          rest$3 = rest$2;
        }
        break _L$2;
      }
      let exp_sign = 1;
      let rest$5;
      if (_M0MPC16string6String24char__length__ge_2einner(rest$4.str, 1, rest$4.start, rest$4.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(rest$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest$4.str, 0, rest$4.start, rest$4.end));
        switch (_x) {
          case 43: {
            const _tmp$39 = rest$4.str;
            const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$4.str, 1, rest$4.start, rest$4.end);
            let _tmp$40;
            if (_bind$4 === undefined) {
              _tmp$40 = rest$4.end;
            } else {
              const _Some = _bind$4;
              _tmp$40 = _Some;
            }
            rest$5 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, rest$4.end);
            break;
          }
          case 45: {
            const _tmp$41 = rest$4.str;
            const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$4.str, 1, rest$4.start, rest$4.end);
            let _tmp$42;
            if (_bind$5 === undefined) {
              _tmp$42 = rest$4.end;
            } else {
              const _Some = _bind$5;
              _tmp$42 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$41, _tmp$42, rest$4.end);
            exp_sign = -1;
            rest$5 = _x$2;
            break;
          }
          default: {
            rest$5 = rest$4;
          }
        }
      } else {
        rest$5 = rest$4;
      }
      _L$4: {
        _L$5: {
          if (_M0MPC16string6String24char__length__ge_2einner(rest$5.str, 1, rest$5.start, rest$5.end)) {
            const _x = _M0MPC16string6String16unsafe__char__at(rest$5.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest$5.str, 0, rest$5.start, rest$5.end));
            if (_x >= 48 && _x <= 57) {
              const exp_limit = exp_sign > 0 ? (d.decimal_point < 311 ? 311 - d.decimal_point | 0 : 0) : d.decimal_point > -331 ? d.decimal_point + 331 | 0 : 0;
              let exp = 0;
              let rest$6;
              let _tmp$39 = rest$5;
              while (true) {
                const s = _tmp$39;
                let rest$7;
                _L$6: {
                  if (_M0MPC16string6String24char__length__ge_2einner(s.str, 1, s.start, s.end)) {
                    const _x$2 = _M0MPC16string6String16unsafe__char__at(s.str, _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 0, s.start, s.end));
                    if (_x$2 === 95) {
                      const _tmp$40 = s.str;
                      const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 1, s.start, s.end);
                      let _tmp$41;
                      if (_bind$4 === undefined) {
                        _tmp$41 = s.end;
                      } else {
                        const _Some = _bind$4;
                        _tmp$41 = _Some;
                      }
                      const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, s.end);
                      _tmp$39 = _x$3;
                      continue;
                    } else {
                      if (_x$2 >= 48 && _x$2 <= 57) {
                        const _tmp$40 = s.str;
                        const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 1, s.start, s.end);
                        let _tmp$41;
                        if (_bind$4 === undefined) {
                          _tmp$41 = s.end;
                        } else {
                          const _Some = _bind$4;
                          _tmp$41 = _Some;
                        }
                        const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, s.end);
                        if (exp < exp_limit) {
                          exp = (Math.imul(exp, 10) | 0) + (_x$2 - 48 | 0) | 0;
                          if (exp > exp_limit) {
                            exp = exp_limit;
                          }
                        }
                        _tmp$39 = _x$3;
                        continue;
                      } else {
                        rest$7 = s;
                        break _L$6;
                      }
                    }
                  } else {
                    rest$7 = s;
                    break _L$6;
                  }
                }
                rest$6 = rest$7;
                break;
              }
              d.decimal_point = d.decimal_point + (Math.imul(exp_sign, exp) | 0) | 0;
              rest$3 = rest$6;
            } else {
              break _L$5;
            }
          } else {
            break _L$5;
          }
          break _L$4;
        }
        const _bind$4 = _M0FPC17strconv11syntax__errGlE();
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          rest$3 = _ok._0;
        } else {
          return _bind$4;
        }
      }
    }
    if (_M0MPC16string6String24char__length__eq_2einner(rest$3.str, 0, rest$3.start, rest$3.end)) {
      _M0MPC17strconv7Decimal4trim(d);
      return new _M0DTPC16result6ResultGRPC17strconv7DecimalRPC17strconv12StrConvErrorE2Ok(d);
    } else {
      return _M0FPC17strconv11syntax__errGlE();
    }
  } else {
    return _M0FPC17strconv11syntax__errGlE();
  }
}
function _M0FPC17strconv20parse__decimal__priv(str) {
  return _M0FPC17strconv26parse__decimal__from__view(str);
}
function _M0FPC17strconv15parse__inf__nan(rest) {
  let pos;
  let rest$2;
  _L: {
    let rest$3;
    _L$2: {
      if (_M0MPC16string6String24char__length__ge_2einner(rest.str, 1, rest.start, rest.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(rest.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest.str, 0, rest.start, rest.end));
        switch (_x) {
          case 45: {
            const _tmp$38 = rest.str;
            const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(rest.str, 1, rest.start, rest.end);
            let _tmp$39;
            if (_bind$4 === undefined) {
              _tmp$39 = rest.end;
            } else {
              const _Some = _bind$4;
              _tmp$39 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, rest.end);
            pos = false;
            rest$2 = _x$2;
            break _L;
          }
          case 43: {
            const _tmp$40 = rest.str;
            const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(rest.str, 1, rest.start, rest.end);
            let _tmp$41;
            if (_bind$5 === undefined) {
              _tmp$41 = rest.end;
            } else {
              const _Some = _bind$5;
              _tmp$41 = _Some;
            }
            const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, rest.end);
            rest$3 = _x$3;
            break _L$2;
          }
          default: {
            rest$3 = rest;
            break _L$2;
          }
        }
      } else {
        rest$3 = rest;
        break _L$2;
      }
    }
    pos = true;
    rest$2 = rest$3;
    break _L;
  }
  const _data = rest$2.str;
  const _start = rest$2.start;
  const _end = _start + (rest$2.end - rest$2.start | 0) | 0;
  let _cursor = _start;
  let accept_state = -1;
  let match_end = -1;
  _L$2: {
    _L$3: {
      if ((_cursor + 2 | 0) < _end) {
        _L$4: {
          _L$5: {
            const _p$4 = _cursor;
            const next_char = _data.charCodeAt(_p$4);
            _cursor = _cursor + 1 | 0;
            if (next_char < 79) {
              if (next_char < 74) {
                if (next_char < 73) {
                  break _L$2;
                } else {
                  break _L$4;
                }
              } else {
                if (next_char > 77) {
                  break _L$5;
                } else {
                  break _L$2;
                }
              }
            } else {
              if (next_char > 104) {
                if (next_char < 110) {
                  if (next_char < 106) {
                    break _L$4;
                  } else {
                    break _L$2;
                  }
                } else {
                  if (next_char > 110) {
                    break _L$2;
                  } else {
                    break _L$5;
                  }
                }
              } else {
                break _L$2;
              }
            }
          }
          _L$6: {
            const _p$4 = _cursor;
            const next_char = _data.charCodeAt(_p$4);
            _cursor = _cursor + 1 | 0;
            if (next_char < 66) {
              if (next_char < 65) {
                break _L$2;
              } else {
                break _L$6;
              }
            } else {
              if (next_char > 96) {
                if (next_char < 98) {
                  break _L$6;
                } else {
                  break _L$2;
                }
              } else {
                break _L$2;
              }
            }
          }
          _L$7: {
            const _p$4 = _cursor;
            const next_char = _data.charCodeAt(_p$4);
            _cursor = _cursor + 1 | 0;
            if (next_char < 79) {
              if (next_char < 78) {
                break _L$2;
              } else {
                break _L$7;
              }
            } else {
              if (next_char > 109) {
                if (next_char < 111) {
                  break _L$7;
                } else {
                  break _L$2;
                }
              } else {
                break _L$2;
              }
            }
          }
          if (_cursor < _end) {
            break _L$2;
          } else {
            accept_state = 0;
            match_end = _cursor;
            break _L$2;
          }
        }
        _L$5: {
          const _p$4 = _cursor;
          const next_char = _data.charCodeAt(_p$4);
          _cursor = _cursor + 1 | 0;
          if (next_char < 79) {
            if (next_char < 78) {
              break _L$2;
            } else {
              break _L$5;
            }
          } else {
            if (next_char > 109) {
              if (next_char < 111) {
                break _L$5;
              } else {
                break _L$2;
              }
            } else {
              break _L$2;
            }
          }
        }
        _L$6: {
          const _p$4 = _cursor;
          const next_char = _data.charCodeAt(_p$4);
          _cursor = _cursor + 1 | 0;
          if (next_char < 71) {
            if (next_char < 70) {
              break _L$2;
            } else {
              break _L$6;
            }
          } else {
            if (next_char > 101) {
              if (next_char < 103) {
                break _L$6;
              } else {
                break _L$2;
              }
            } else {
              break _L$2;
            }
          }
        }
        if (_cursor < _end) {
          _L$7: {
            const _p$4 = _cursor;
            const next_char = _data.charCodeAt(_p$4);
            _cursor = _cursor + 1 | 0;
            if (next_char < 74) {
              if (next_char < 73) {
                break _L$2;
              } else {
                break _L$7;
              }
            } else {
              if (next_char > 104) {
                if (next_char < 106) {
                  break _L$7;
                } else {
                  break _L$2;
                }
              } else {
                break _L$2;
              }
            }
          }
          if ((_cursor + 3 | 0) < _end) {
            _L$8: {
              const _p$4 = _cursor;
              const next_char = _data.charCodeAt(_p$4);
              _cursor = _cursor + 1 | 0;
              if (next_char < 79) {
                if (next_char < 78) {
                  break _L$2;
                } else {
                  break _L$8;
                }
              } else {
                if (next_char > 109) {
                  if (next_char < 111) {
                    break _L$8;
                  } else {
                    break _L$2;
                  }
                } else {
                  break _L$2;
                }
              }
            }
            _L$9: {
              const _p$4 = _cursor;
              const next_char = _data.charCodeAt(_p$4);
              _cursor = _cursor + 1 | 0;
              if (next_char < 74) {
                if (next_char < 73) {
                  break _L$2;
                } else {
                  break _L$9;
                }
              } else {
                if (next_char > 104) {
                  if (next_char < 106) {
                    break _L$9;
                  } else {
                    break _L$2;
                  }
                } else {
                  break _L$2;
                }
              }
            }
            _L$10: {
              const _p$4 = _cursor;
              const next_char = _data.charCodeAt(_p$4);
              _cursor = _cursor + 1 | 0;
              if (next_char < 85) {
                if (next_char < 84) {
                  break _L$2;
                } else {
                  break _L$10;
                }
              } else {
                if (next_char > 115) {
                  if (next_char < 117) {
                    break _L$10;
                  } else {
                    break _L$2;
                  }
                } else {
                  break _L$2;
                }
              }
            }
            _L$11: {
              const _p$4 = _cursor;
              const next_char = _data.charCodeAt(_p$4);
              _cursor = _cursor + 1 | 0;
              if (next_char < 90) {
                if (next_char < 89) {
                  break _L$2;
                } else {
                  break _L$11;
                }
              } else {
                if (next_char > 120) {
                  if (next_char < 122) {
                    break _L$11;
                  } else {
                    break _L$2;
                  }
                } else {
                  break _L$2;
                }
              }
            }
            if (_cursor < _end) {
              break _L$2;
            } else {
              break _L$3;
            }
          } else {
            break _L$2;
          }
        } else {
          break _L$3;
        }
      } else {
        break _L$2;
      }
    }
    accept_state = 1;
    match_end = _cursor;
    break _L$2;
  }
  switch (accept_state) {
    case 0: {
      return new _M0DTPC16result6ResultGdRPC17strconv12StrConvErrorE2Ok(_M0FPC16double14not__a__number);
    }
    case 1: {
      return pos ? new _M0DTPC16result6ResultGdRPC17strconv12StrConvErrorE2Ok(_M0FPC16double8infinity) : new _M0DTPC16result6ResultGdRPC17strconv12StrConvErrorE2Ok(_M0FPC16double13neg__infinity);
    }
    default: {
      return _M0FPC17strconv11syntax__errGdE();
    }
  }
}
function _M0EPC16string10StringViewPC17strconv12fold__digitsGmE(self, init, f) {
  let ret = init;
  let len = 0;
  let str = self;
  while (true) {
    const _bind$4 = str;
    if (_M0MPC16string6String24char__length__ge_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end)) {
      const _ch = _M0MPC16string6String16unsafe__char__at(_bind$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 0, _bind$4.start, _bind$4.end));
      const _tmp$38 = _bind$4.str;
      const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
      let _tmp$39;
      if (_bind$5 === undefined) {
        _tmp$39 = _bind$4.end;
      } else {
        const _Some = _bind$5;
        _tmp$39 = _Some;
      }
      const _x = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$4.end);
      if (_ch >= 48 && _ch <= 57) {
        len = len + 1 | 0;
        ret = f(_ch - 48 | 0, ret);
      } else {
        if (_ch !== 95) {
          break;
        }
      }
      str = _x;
      continue;
    } else {
      break;
    }
  }
  return { _0: str, _1: ret, _2: len };
}
function _M0FPC17strconv13parse__digits(s, x) {
  return _M0EPC16string10StringViewPC17strconv12fold__digitsGmE(s, x, (digit, acc) => BigInt.asUintN(64, BigInt.asUintN(64, acc * 10n) + BigInt.asUintN(64, BigInt(digit >>> 0))));
}
function _M0FPC17strconv17parse__scientific(s) {
  let s$2 = s;
  let neg_exp = false;
  let rest;
  let ch;
  _L: {
    _L$2: {
      const _bind$4 = s$2;
      if (_M0MPC16string6String24char__length__ge_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(_bind$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 0, _bind$4.start, _bind$4.end));
        switch (_x) {
          case 43: {
            const _tmp$38 = _bind$4.str;
            const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
            let _tmp$39;
            if (_bind$5 === undefined) {
              _tmp$39 = _bind$4.end;
            } else {
              const _Some = _bind$5;
              _tmp$39 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$4.end);
            rest = _x$2;
            ch = _x;
            break _L$2;
          }
          case 45: {
            const _tmp$40 = _bind$4.str;
            const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
            let _tmp$41;
            if (_bind$6 === undefined) {
              _tmp$41 = _bind$4.end;
            } else {
              const _Some = _bind$6;
              _tmp$41 = _Some;
            }
            const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, _bind$4.end);
            rest = _x$3;
            ch = _x;
            break _L$2;
          }
        }
      }
      break _L;
    }
    neg_exp = ch === 45;
    s$2 = rest;
  }
  _L$2: {
    const _bind$4 = s$2;
    if (_M0MPC16string6String24char__length__ge_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end)) {
      const _x = _M0MPC16string6String16unsafe__char__at(_bind$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 0, _bind$4.start, _bind$4.end));
      if (_x >= 48 && _x <= 57) {
        const _bind$5 = _M0EPC16string10StringViewPC17strconv12fold__digitsGmE(s$2, _M0FPC17strconv17parse__scientificN8exp__numS249, (digit, exp_num) => BigInt.asIntN(64, exp_num) < BigInt.asIntN(64, 65536n) ? BigInt.asUintN(64, BigInt.asUintN(64, 10n * exp_num) + BigInt.asUintN(64, BigInt(digit))) : exp_num);
        const _s = _bind$5._0;
        const _exp_num = _bind$5._1;
        return neg_exp ? { _0: _s, _1: BigInt.asUintN(64, -_exp_num) } : { _0: _s, _1: _exp_num };
      } else {
        break _L$2;
      }
    } else {
      break _L$2;
    }
  }
  return undefined;
}
function _M0FPC17strconv20try__parse__19digits(s, x) {
  let x$2 = x;
  let len = 0;
  let _tmp$38 = s;
  while (true) {
    const s$2 = _tmp$38;
    let s$3;
    _L: {
      if (_M0MPC16string6String24char__length__ge_2einner(s$2.str, 1, s$2.start, s$2.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(s$2.str, _M0MPC16string6String29offset__of__nth__char_2einner(s$2.str, 0, s$2.start, s$2.end));
        if (_x >= 48 && _x <= 57) {
          const _tmp$39 = s$2.str;
          const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(s$2.str, 1, s$2.start, s$2.end);
          let _tmp$40;
          if (_bind$4 === undefined) {
            _tmp$40 = s$2.end;
          } else {
            const _Some = _bind$4;
            _tmp$40 = _Some;
          }
          const _x$2 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, s$2.end);
          if (BigInt.asUintN(64, x$2) < BigInt.asUintN(64, _M0FPC17strconv17min__19digit__int)) {
            len = len + 1 | 0;
            x$2 = BigInt.asUintN(64, BigInt.asUintN(64, x$2 * 10n) + BigInt.asUintN(64, BigInt((_x - 48 | 0) >>> 0)));
            _tmp$38 = _x$2;
            continue;
          } else {
            s$3 = s$2;
            break _L;
          }
        } else {
          if (_x === 95) {
            const _tmp$39 = s$2.str;
            const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(s$2.str, 1, s$2.start, s$2.end);
            let _tmp$40;
            if (_bind$4 === undefined) {
              _tmp$40 = s$2.end;
            } else {
              const _Some = _bind$4;
              _tmp$40 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, s$2.end);
            _tmp$38 = _x$2;
            continue;
          } else {
            s$3 = s$2;
            break _L;
          }
        }
      } else {
        s$3 = s$2;
        break _L;
      }
    }
    return { _0: s$3, _1: x$2, _2: len };
  }
}
function _M0FPC17strconv13parse__number(s) {
  let s$2;
  let negative;
  _L: {
    let rest;
    _L$2: {
      if (_M0MPC16string6String24char__length__ge_2einner(s.str, 1, s.start, s.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(s.str, _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 0, s.start, s.end));
        switch (_x) {
          case 45: {
            const _tmp$38 = s.str;
            const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 1, s.start, s.end);
            let _tmp$39;
            if (_bind$4 === undefined) {
              _tmp$39 = s.end;
            } else {
              const _Some = _bind$4;
              _tmp$39 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, s.end);
            s$2 = _x$2;
            negative = true;
            break _L;
          }
          case 43: {
            const _tmp$40 = s.str;
            const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 1, s.start, s.end);
            let _tmp$41;
            if (_bind$5 === undefined) {
              _tmp$41 = s.end;
            } else {
              const _Some = _bind$5;
              _tmp$41 = _Some;
            }
            const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, s.end);
            rest = _x$3;
            break _L$2;
          }
          default: {
            rest = s;
            break _L$2;
          }
        }
      } else {
        rest = s;
        break _L$2;
      }
    }
    s$2 = rest;
    negative = false;
    break _L;
  }
  if (_M0MPC16string10StringView9is__empty(s$2)) {
    return new _M0DTPC16result6ResultGORPC17strconv6NumberRPC17strconv12StrConvErrorE2Ok(undefined);
  }
  const _bind$4 = _M0FPC17strconv13parse__digits(s$2, 0n);
  const _s = _bind$4._0;
  const _mantissa = _bind$4._1;
  const _consumed = _bind$4._2;
  let mantissa = _mantissa;
  let s$3 = _s;
  let n_digits = _consumed;
  let n_after_dot = 0;
  let exponent = 0n;
  const _bind$5 = s$3;
  if (_M0MPC16string6String24char__length__ge_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end)) {
    const _x = _M0MPC16string6String16unsafe__char__at(_bind$5.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 0, _bind$5.start, _bind$5.end));
    if (_x === 46) {
      const _tmp$38 = _bind$5.str;
      const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end);
      let _tmp$39;
      if (_bind$6 === undefined) {
        _tmp$39 = _bind$5.end;
      } else {
        const _Some = _bind$6;
        _tmp$39 = _Some;
      }
      const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$5.end);
      s$3 = _x$2;
      const _bind$7 = _M0FPC17strconv13parse__digits(s$3, mantissa);
      const _new_s = _bind$7._0;
      const _new_mantissa = _bind$7._1;
      const _consumed_digit = _bind$7._2;
      s$3 = _new_s;
      mantissa = _new_mantissa;
      n_after_dot = _consumed_digit;
      exponent = BigInt.asUintN(64, -BigInt.asUintN(64, BigInt(n_after_dot)));
    }
  }
  n_digits = n_digits + n_after_dot | 0;
  if (n_digits === 0) {
    return new _M0DTPC16result6ResultGORPC17strconv6NumberRPC17strconv12StrConvErrorE2Ok(undefined);
  }
  let rest;
  _L$2: {
    _L$3: {
      const _bind$6 = s$3;
      if (_M0MPC16string6String24char__length__ge_2einner(_bind$6.str, 1, _bind$6.start, _bind$6.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(_bind$6.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6.str, 0, _bind$6.start, _bind$6.end));
        switch (_x) {
          case 101: {
            const _tmp$38 = _bind$6.str;
            const _bind$7 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6.str, 1, _bind$6.start, _bind$6.end);
            let _tmp$39;
            if (_bind$7 === undefined) {
              _tmp$39 = _bind$6.end;
            } else {
              const _Some = _bind$7;
              _tmp$39 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$6.end);
            rest = _x$2;
            break _L$3;
          }
          case 69: {
            const _tmp$40 = _bind$6.str;
            const _bind$8 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6.str, 1, _bind$6.start, _bind$6.end);
            let _tmp$41;
            if (_bind$8 === undefined) {
              _tmp$41 = _bind$6.end;
            } else {
              const _Some = _bind$8;
              _tmp$41 = _Some;
            }
            const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, _bind$6.end);
            rest = _x$3;
            break _L$3;
          }
        }
      }
      break _L$2;
    }
    const _bind$6 = _M0FPC17strconv17parse__scientific(rest);
    let _bind$7;
    if (_bind$6 === undefined) {
      return new _M0DTPC16result6ResultGORPC17strconv6NumberRPC17strconv12StrConvErrorE2Ok(undefined);
    } else {
      const _Some = _bind$6;
      _bind$7 = _Some;
    }
    const _new_s = _bind$7._0;
    const _exp_number = _bind$7._1;
    s$3 = _new_s;
    exponent = BigInt.asUintN(64, exponent + _exp_number);
  }
  const _bind$6 = s$3;
  if (_M0MPC16string6String24char__length__eq_2einner(_bind$6.str, 0, _bind$6.start, _bind$6.end)) {
    if (n_digits <= 19) {
      return new _M0DTPC16result6ResultGORPC17strconv6NumberRPC17strconv12StrConvErrorE2Ok(new _M0TPC17strconv6Number(exponent, mantissa, negative, false));
    }
    n_digits = n_digits - 19 | 0;
    let many_digits = false;
    let _tmp$38 = s;
    while (true) {
      const s$4 = _tmp$38;
      _L$3: {
        let rest$2;
        let ch;
        _L$4: {
          if (_M0MPC16string6String24char__length__ge_2einner(s$4.str, 1, s$4.start, s$4.end)) {
            const _x = _M0MPC16string6String16unsafe__char__at(s$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(s$4.str, 0, s$4.start, s$4.end));
            switch (_x) {
              case 48: {
                const _tmp$39 = s$4.str;
                const _bind$7 = _M0MPC16string6String29offset__of__nth__char_2einner(s$4.str, 1, s$4.start, s$4.end);
                let _tmp$40;
                if (_bind$7 === undefined) {
                  _tmp$40 = s$4.end;
                } else {
                  const _Some = _bind$7;
                  _tmp$40 = _Some;
                }
                const _x$2 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, s$4.end);
                rest$2 = _x$2;
                ch = _x;
                break _L$4;
              }
              case 46: {
                const _tmp$41 = s$4.str;
                const _bind$8 = _M0MPC16string6String29offset__of__nth__char_2einner(s$4.str, 1, s$4.start, s$4.end);
                let _tmp$42;
                if (_bind$8 === undefined) {
                  _tmp$42 = s$4.end;
                } else {
                  const _Some = _bind$8;
                  _tmp$42 = _Some;
                }
                const _x$3 = new _M0TPC16string10StringView(_tmp$41, _tmp$42, s$4.end);
                rest$2 = _x$3;
                ch = _x;
                break _L$4;
              }
              default: {
                break _L$3;
              }
            }
          } else {
            break _L$3;
          }
        }
        n_digits = n_digits - ((ch - 46 | 0) / 2 | 0) | 0;
        _tmp$38 = rest$2;
        continue;
      }
      break;
    }
    let mantissa$2 = mantissa;
    if (n_digits > 0) {
      many_digits = true;
      mantissa$2 = 0n;
      const _bind$7 = _M0FPC17strconv20try__parse__19digits(s, mantissa$2);
      const _s$2 = _bind$7._0;
      const _new_mantissa = _bind$7._1;
      const _consumed_digit = _bind$7._2;
      mantissa$2 = _new_mantissa;
      let _tmp$39;
      if (BigInt.asUintN(64, mantissa$2) >= BigInt.asUintN(64, _M0FPC17strconv17min__19digit__int)) {
        _tmp$39 = _consumed_digit;
      } else {
        if (_M0MPC16string6String24char__length__ge_2einner(_s$2.str, 1, _s$2.start, _s$2.end)) {
          const _tmp$40 = _s$2.str;
          const _bind$8 = _M0MPC16string6String29offset__of__nth__char_2einner(_s$2.str, 1, _s$2.start, _s$2.end);
          let _tmp$41;
          if (_bind$8 === undefined) {
            _tmp$41 = _s$2.end;
          } else {
            const _Some = _bind$8;
            _tmp$41 = _Some;
          }
          const _x = new _M0TPC16string10StringView(_tmp$40, _tmp$41, _s$2.end);
          const _bind$9 = _M0FPC17strconv20try__parse__19digits(_x, mantissa$2);
          const _new_mantissa$2 = _bind$9._1;
          const _consumed_digit$2 = _bind$9._2;
          mantissa$2 = _new_mantissa$2;
          _tmp$39 = _consumed_digit$2;
        } else {
          return new _M0DTPC16result6ResultGORPC17strconv6NumberRPC17strconv12StrConvErrorE2Ok(undefined);
        }
      }
      exponent = BigInt.asUintN(64, BigInt(_tmp$39));
      exponent = BigInt.asUintN(64, exponent + _M0FPC17strconv13parse__numberN11exp__numberS230);
    }
    return new _M0DTPC16result6ResultGORPC17strconv6NumberRPC17strconv12StrConvErrorE2Ok(new _M0TPC17strconv6Number(exponent, mantissa$2, negative, many_digits));
  } else {
    return _M0FPC17strconv11syntax__errGORPC17strconv6NumberE();
  }
}
function _M0FPC17strconv14assemble__bits(mantissa, exponent, negative) {
  const biased_exp = exponent - _M0FPC17strconv12double__info.bias | 0;
  let bits = BigInt.asUintN(64, mantissa & BigInt.asUintN(64, BigInt.asUintN(64, 1n << BigInt(_M0FPC17strconv12double__info.mantissa_bits & 63)) - 1n));
  const exp_bits = BigInt.asUintN(64, BigInt(biased_exp & ((1 << _M0FPC17strconv12double__info.exponent_bits) - 1 | 0)));
  bits = BigInt.asUintN(64, bits | BigInt.asUintN(64, exp_bits << BigInt(_M0FPC17strconv12double__info.mantissa_bits & 63)));
  if (negative) {
    bits = BigInt.asUintN(64, bits | BigInt.asUintN(64, BigInt.asUintN(64, 1n << BigInt(_M0FPC17strconv12double__info.mantissa_bits & 63)) << BigInt(_M0FPC17strconv12double__info.exponent_bits & 63)));
  }
  return bits;
}
function _M0MPC17strconv7Decimal17should__round__up(self, d) {
  if (d < 0 || d >= self.digits_num) {
    return false;
  }
  let _tmp$38;
  const _tmp$39 = self.digits;
  $bound_check(_tmp$39, d);
  if (_tmp$39[d] === 5) {
    _tmp$38 = (d + 1 | 0) === self.digits_num;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    if (self.truncated) {
      return true;
    }
    let _tmp$40;
    if (d > 0) {
      const _tmp$41 = self.digits;
      const _tmp$42 = d - 1 | 0;
      $bound_check(_tmp$41, _tmp$42);
      _tmp$40 = (_tmp$41[_tmp$42] % 2 | 0) !== 0;
    } else {
      _tmp$40 = false;
    }
    return _tmp$40;
  }
  const _tmp$40 = self.digits;
  $bound_check(_tmp$40, d);
  return _tmp$40[d] >= 5;
}
function _M0MPC17strconv7Decimal16rounded__integer(self) {
  if (self.decimal_point > 20) {
    return 18446744073709551615n;
  }
  let _tmp$38 = 0n;
  let _tmp$39 = 0;
  while (true) {
    const n = _tmp$38;
    const i = _tmp$39;
    if (i < self.decimal_point && i < self.digits_num) {
      const _tmp$40 = BigInt.asUintN(64, n * 10n);
      const _tmp$41 = self.digits;
      $bound_check(_tmp$41, i);
      const _p$4 = _tmp$41[i];
      _tmp$38 = BigInt.asUintN(64, _tmp$40 + BigInt.asUintN(64, BigInt(_p$4)));
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      let n$2;
      let _tmp$40 = n;
      let _tmp$41 = i;
      while (true) {
        const n$3 = _tmp$40;
        const i$2 = _tmp$41;
        if (i$2 < self.decimal_point) {
          _tmp$40 = BigInt.asUintN(64, n$3 * 10n);
          _tmp$41 = i$2 + 1 | 0;
          continue;
        } else {
          n$2 = n$3;
          break;
        }
      }
      return _M0MPC17strconv7Decimal17should__round__up(self, self.decimal_point) ? BigInt.asUintN(64, n$2 + 1n) : n$2;
    }
  }
}
function _M0MPC17strconv7Decimal11new__digits(self, s) {
  $bound_check(_M0FPC17strconv19left__shift__cheats, s);
  const new_digits = _M0FPC17strconv19left__shift__cheats[s]._0;
  $bound_check(_M0FPC17strconv19left__shift__cheats, s);
  const cheat_num = _M0FPC17strconv19left__shift__cheats[s]._1;
  const _bind$4 = cheat_num.length;
  let less;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < _bind$4) {
      if (i >= self.digits_num) {
        less = true;
        break;
      }
      const d = cheat_num.charCodeAt(i) - 48 | 0;
      const _tmp$39 = self.digits;
      $bound_check(_tmp$39, i);
      if (_tmp$39[i] !== d) {
        const _tmp$40 = self.digits;
        $bound_check(_tmp$40, i);
        less = _tmp$40[i] < d;
        break;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      less = false;
      break;
    }
  }
  return less ? new_digits - 1 | 0 : new_digits;
}
function _M0MPC17strconv7Decimal11left__shift(self, s) {
  const new_digits = _M0MPC17strconv7Decimal11new__digits(self, s);
  let read_index = self.digits_num;
  let write_index = self.digits_num + new_digits | 0;
  let acc = 0n;
  read_index = read_index - 1 | 0;
  while (true) {
    if (read_index >= 0) {
      const _tmp$38 = self.digits;
      const _tmp$39 = read_index;
      $bound_check(_tmp$38, _tmp$39);
      const _p$4 = _tmp$38[_tmp$39];
      const d = BigInt.asUintN(64, BigInt(_p$4));
      acc = BigInt.asUintN(64, acc + BigInt.asUintN(64, d << BigInt(s & 63)));
      if (10n === 0n) {
        $panic();
      }
      const quo = BigInt.asUintN(64, BigInt.asIntN(64, acc) / BigInt.asIntN(64, 10n));
      const rem = Number(BigInt.asIntN(32, BigInt.asUintN(64, acc - BigInt.asUintN(64, quo * 10n)))) | 0;
      write_index = write_index - 1 | 0;
      if (write_index < self.digits.length) {
        const _tmp$40 = self.digits;
        const _tmp$41 = write_index;
        $bound_check(_tmp$40, _tmp$41);
        _tmp$40[_tmp$41] = rem & 255;
      } else {
        if (rem !== 0) {
          self.truncated = true;
        }
      }
      acc = quo;
      read_index = read_index - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (BigInt.asIntN(64, acc) > BigInt.asIntN(64, 0n)) {
      if (10n === 0n) {
        $panic();
      }
      const quo = BigInt.asUintN(64, BigInt.asIntN(64, acc) / BigInt.asIntN(64, 10n));
      const rem = Number(BigInt.asIntN(32, BigInt.asUintN(64, acc - BigInt.asUintN(64, 10n * quo)))) | 0;
      write_index = write_index - 1 | 0;
      if (write_index < self.digits.length) {
        const _tmp$38 = self.digits;
        const _tmp$39 = write_index;
        $bound_check(_tmp$38, _tmp$39);
        _tmp$38[_tmp$39] = rem & 255;
      } else {
        if (rem !== 0) {
          self.truncated = true;
        }
      }
      acc = quo;
      continue;
    } else {
      break;
    }
  }
  self.digits_num = self.digits_num + new_digits | 0;
  if (self.digits_num > self.digits.length) {
    self.digits_num = self.digits.length;
  }
  self.decimal_point = self.decimal_point + new_digits | 0;
  _M0MPC17strconv7Decimal4trim(self);
}
function _M0MPC17strconv7Decimal12right__shift(self, s) {
  let read_index = 0;
  let write_index = 0;
  let acc = 0n;
  while (true) {
    if (BigInt.asUintN(64, BigInt.asUintN(64, BigInt.asUintN(64, acc) >> BigInt(s & 63))) === BigInt.asUintN(64, 0n)) {
      if (read_index >= self.digits_num) {
        while (true) {
          if (BigInt.asUintN(64, BigInt.asUintN(64, BigInt.asUintN(64, acc) >> BigInt(s & 63))) === BigInt.asUintN(64, 0n)) {
            acc = BigInt.asUintN(64, acc * 10n);
            read_index = read_index + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        break;
      }
      const _tmp$38 = self.digits;
      const _tmp$39 = read_index;
      $bound_check(_tmp$38, _tmp$39);
      const d = _tmp$38[_tmp$39];
      acc = BigInt.asUintN(64, BigInt.asUintN(64, acc * 10n) + BigInt.asUintN(64, BigInt(d)));
      read_index = read_index + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.decimal_point = self.decimal_point - (read_index - 1 | 0) | 0;
  const mask = BigInt.asUintN(64, BigInt.asUintN(64, 1n << BigInt(s & 63)) - 1n);
  while (true) {
    if (read_index < self.digits_num) {
      const out = BigInt.asUintN(64, BigInt.asUintN(64, acc) >> BigInt(s & 63));
      const _tmp$38 = self.digits;
      const _tmp$39 = write_index;
      $bound_check(_tmp$38, _tmp$39);
      _tmp$38[_tmp$39] = (Number(BigInt.asIntN(32, out)) | 0) & 255;
      write_index = write_index + 1 | 0;
      acc = BigInt.asUintN(64, acc & mask);
      const _tmp$40 = self.digits;
      const _tmp$41 = read_index;
      $bound_check(_tmp$40, _tmp$41);
      const d = _tmp$40[_tmp$41];
      acc = BigInt.asUintN(64, BigInt.asUintN(64, acc * 10n) + BigInt.asUintN(64, BigInt(d)));
      read_index = read_index + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (BigInt.asUintN(64, acc) > BigInt.asUintN(64, 0n)) {
      const out = BigInt.asUintN(64, BigInt.asUintN(64, acc) >> BigInt(s & 63));
      if (write_index < self.digits.length) {
        const _tmp$38 = self.digits;
        const _tmp$39 = write_index;
        $bound_check(_tmp$38, _tmp$39);
        _tmp$38[_tmp$39] = (Number(BigInt.asIntN(32, out)) | 0) & 255;
        write_index = write_index + 1 | 0;
      } else {
        if (BigInt.asUintN(64, out) > BigInt.asUintN(64, 0n)) {
          self.truncated = true;
        }
      }
      acc = BigInt.asUintN(64, acc & mask);
      acc = BigInt.asUintN(64, acc * 10n);
      continue;
    } else {
      break;
    }
  }
  self.digits_num = write_index;
  _M0MPC17strconv7Decimal4trim(self);
}
function _M0MPC17strconv7Decimal11shift__priv(self, s) {
  if (self.digits_num === 0) {
    return undefined;
  }
  let s$2 = s;
  if (s$2 > 0) {
    while (true) {
      if (s$2 > 59) {
        _M0MPC17strconv7Decimal11left__shift(self, 59);
        s$2 = s$2 - 59 | 0;
        continue;
      } else {
        break;
      }
    }
    _M0MPC17strconv7Decimal11left__shift(self, s$2);
  }
  if (s$2 < 0) {
    while (true) {
      if (s$2 < -59) {
        _M0MPC17strconv7Decimal12right__shift(self, 59);
        s$2 = s$2 + 59 | 0;
        continue;
      } else {
        break;
      }
    }
    _M0MPC17strconv7Decimal12right__shift(self, -s$2 | 0);
    return;
  } else {
    return;
  }
}
function _M0MPC17strconv7Decimal16to__double__priv(self) {
  let exponent = 0;
  let mantissa = 0n;
  if (self.digits_num === 0 || self.decimal_point < -330) {
    mantissa = 0n;
    exponent = _M0FPC17strconv12double__info.bias;
    const bits = _M0FPC17strconv14assemble__bits(mantissa, exponent, self.negative);
    return new _M0DTPC16result6ResultGdRPC17strconv12StrConvErrorE2Ok($i64_reinterpret_f64(bits));
  }
  if (self.decimal_point > 310) {
    const _bind$4 = _M0FPC17strconv10range__errGuE();
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _ok._0;
    } else {
      return _bind$4;
    }
  }
  while (true) {
    if (self.decimal_point > 0) {
      let n = 0;
      if (self.decimal_point >= _M0FPC17strconv6powtab.length) {
        n = 60;
      } else {
        const _p$4 = self.decimal_point;
        $bound_check(_M0FPC17strconv6powtab, _p$4);
        n = _M0FPC17strconv6powtab[_p$4];
      }
      _M0MPC17strconv7Decimal11shift__priv(self, -n | 0);
      exponent = exponent + n | 0;
      continue;
    } else {
      break;
    }
  }
  while (true) {
    let _tmp$38;
    if (self.decimal_point < 0) {
      _tmp$38 = true;
    } else {
      let _tmp$39;
      if (self.decimal_point === 0) {
        const _tmp$40 = self.digits;
        $bound_check(_tmp$40, 0);
        _tmp$39 = _tmp$40[0] < 5;
      } else {
        _tmp$39 = false;
      }
      _tmp$38 = _tmp$39;
    }
    if (_tmp$38) {
      let n = 0;
      if ((-self.decimal_point | 0) >= _M0FPC17strconv6powtab.length) {
        n = 60;
      } else {
        const _p$4 = -self.decimal_point | 0;
        $bound_check(_M0FPC17strconv6powtab, _p$4);
        n = _M0FPC17strconv6powtab[_p$4];
      }
      _M0MPC17strconv7Decimal11shift__priv(self, n);
      exponent = exponent - n | 0;
      continue;
    } else {
      break;
    }
  }
  exponent = exponent - 1 | 0;
  if (exponent < (_M0FPC17strconv12double__info.bias + 1 | 0)) {
    const n = (_M0FPC17strconv12double__info.bias + 1 | 0) - exponent | 0;
    _M0MPC17strconv7Decimal11shift__priv(self, -n | 0);
    exponent = exponent + n | 0;
  }
  if ((exponent - _M0FPC17strconv12double__info.bias | 0) >= ((1 << _M0FPC17strconv12double__info.exponent_bits) - 1 | 0)) {
    const _bind$4 = _M0FPC17strconv10range__errGuE();
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _ok._0;
    } else {
      return _bind$4;
    }
  }
  _M0MPC17strconv7Decimal11shift__priv(self, _M0FPC17strconv12double__info.mantissa_bits + 1 | 0);
  mantissa = _M0MPC17strconv7Decimal16rounded__integer(self);
  if (BigInt.asUintN(64, mantissa) === BigInt.asUintN(64, BigInt.asUintN(64, 2n << BigInt(_M0FPC17strconv12double__info.mantissa_bits & 63)))) {
    mantissa = BigInt.asUintN(64, BigInt.asIntN(64, mantissa) >> BigInt(1 & 63));
    exponent = exponent + 1 | 0;
    if ((exponent - _M0FPC17strconv12double__info.bias | 0) >= ((1 << _M0FPC17strconv12double__info.exponent_bits) - 1 | 0)) {
      const _bind$4 = _M0FPC17strconv10range__errGuE();
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        _ok._0;
      } else {
        return _bind$4;
      }
    }
  }
  if (BigInt.asUintN(64, BigInt.asUintN(64, mantissa & BigInt.asUintN(64, 1n << BigInt(_M0FPC17strconv12double__info.mantissa_bits & 63)))) === BigInt.asUintN(64, 0n)) {
    exponent = _M0FPC17strconv12double__info.bias;
  }
  const bits = _M0FPC17strconv14assemble__bits(mantissa, exponent, self.negative);
  return new _M0DTPC16result6ResultGdRPC17strconv12StrConvErrorE2Ok($i64_reinterpret_f64(bits));
}
function _M0FPC17strconv12checked__mul(a, b) {
  if (BigInt.asUintN(64, a) === BigInt.asUintN(64, 0n) || BigInt.asUintN(64, b) === BigInt.asUintN(64, 0n)) {
    return _M0FPC17strconv12checked__mulN6constrS1141;
  }
  if (BigInt.asUintN(64, a) === BigInt.asUintN(64, 1n)) {
    return b;
  }
  if (BigInt.asUintN(64, b) === BigInt.asUintN(64, 1n)) {
    return a;
  }
  if ($i64_clz(b) === 0 || $i64_clz(a) === 0) {
    return undefined;
  }
  if (b === 0n) {
    $panic();
  }
  const quotient = BigInt.asUintN(64, BigInt.asUintN(64, 18446744073709551615n) / BigInt.asUintN(64, b));
  if (BigInt.asUintN(64, a) > BigInt.asUintN(64, quotient)) {
    return undefined;
  }
  return BigInt.asUintN(64, a * b);
}
function _M0FPC17strconv17pow10__fast__path(exponent) {
  const _p$4 = exponent & 31;
  $bound_check(_M0FPC17strconv5table, _p$4);
  return _M0FPC17strconv5table[_p$4];
}
function _M0MPC17strconv6Number14is__fast__path(self) {
  return BigInt.asIntN(64, _M0FPC17strconv25min__exponent__fast__path) <= BigInt.asIntN(64, self.exponent) && (BigInt.asIntN(64, self.exponent) <= BigInt.asIntN(64, _M0FPC17strconv36max__exponent__disguised__fast__path) && (BigInt.asUintN(64, self.mantissa) <= BigInt.asUintN(64, _M0FPC17strconv25max__mantissa__fast__path) && !self.many_digits));
}
function _M0MPC17strconv6Number15try__fast__path(self) {
  if (_M0MPC17strconv6Number14is__fast__path(self)) {
    let value;
    if (BigInt.asIntN(64, self.exponent) <= BigInt.asIntN(64, _M0FPC17strconv25max__exponent__fast__path)) {
      const value$2 = $f64_convert_i64_u(BigInt.asUintN(64, self.mantissa));
      value = BigInt.asIntN(64, self.exponent) < BigInt.asIntN(64, 0n) ? value$2 / _M0FPC17strconv17pow10__fast__path(-(Number(BigInt.asIntN(32, self.exponent)) | 0) | 0) : value$2 * _M0FPC17strconv17pow10__fast__path(Number(BigInt.asIntN(32, self.exponent)) | 0);
    } else {
      const shift = BigInt.asUintN(64, self.exponent - _M0FPC17strconv25max__exponent__fast__path);
      const _tmp$38 = self.mantissa;
      const _p$4 = Number(BigInt.asIntN(32, shift)) | 0;
      $bound_check(_M0FPC17strconv10int__pow10, _p$4);
      const _bind$4 = _M0FPC17strconv12checked__mul(_tmp$38, _M0FPC17strconv10int__pow10[_p$4]);
      let mantissa;
      if (_bind$4 === undefined) {
        return _M0DTPC16option6OptionGdE4None__;
      } else {
        const _Some = _bind$4;
        mantissa = _Some;
      }
      if (BigInt.asUintN(64, mantissa) > BigInt.asUintN(64, _M0FPC17strconv25max__mantissa__fast__path)) {
        return _M0DTPC16option6OptionGdE4None__;
      }
      value = $f64_convert_i64_u(BigInt.asUintN(64, mantissa)) * _M0FPC17strconv17pow10__fast__path(Number(BigInt.asIntN(32, _M0FPC17strconv25max__exponent__fast__path)) | 0);
    }
    if (self.negative) {
      value = -value;
    }
    return new _M0DTPC16option6OptionGdE4Some(value);
  } else {
    return _M0DTPC16option6OptionGdE4None__;
  }
}
function _M0FPC17strconv13parse__double(str) {
  if ((str.end - str.start | 0) > 0) {
    if (_M0FPC17strconv17check__underscore(str)) {
      const _bind$4 = _M0FPC17strconv13parse__number(str);
      let _bind$5;
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        _bind$5 = _ok._0;
      } else {
        return _bind$4;
      }
      if (_bind$5 === undefined) {
        return _M0FPC17strconv15parse__inf__nan(str);
      } else {
        const _Some = _bind$5;
        const _num = _Some;
        const _bind$6 = _M0MPC17strconv6Number15try__fast__path(_num);
        if (_bind$6.$tag === 1) {
          const _Some$2 = _bind$6;
          const _value = _Some$2._0;
          return new _M0DTPC16result6ResultGdRPC17strconv12StrConvErrorE2Ok(_value);
        } else {
          const _bind$7 = _M0FPC17strconv20parse__decimal__priv(str);
          let _tmp$38;
          if (_bind$7.$tag === 1) {
            const _ok = _bind$7;
            _tmp$38 = _ok._0;
          } else {
            return _bind$7;
          }
          return _M0MPC17strconv7Decimal16to__double__priv(_tmp$38);
        }
      }
    } else {
      return _M0FPC17strconv11syntax__errGdE();
    }
  } else {
    return _M0FPC17strconv11syntax__errGdE();
  }
}
function _M0IPC17strconv12StrConvErrorPB4Show6output(self, logger) {
  const _StrConvError = self;
  const _err = _StrConvError._0;
  logger.method_table.method_0(logger.self, _err);
}
function _M0IP410Haoxincode8moonbash3lib3ast5TokenPC15debug5Debug8to__repr(_x_226) {
  switch (_x_226.$tag) {
    case 0: {
      const _Word = _x_226;
      const _$42$arg_227 = _Word._0;
      return _M0MPC15debug4Repr4ctor("Word", [{ _0: undefined, _1: _M0IPC16string6StringPC15debug5Debug8to__repr(_$42$arg_227) }]);
    }
    case 1: {
      const _Number = _x_226;
      const _$42$arg_228 = _Number._0;
      return _M0MPC15debug4Repr4ctor("Number", [{ _0: undefined, _1: _M0IPC15int645Int64PC15debug5Debug8to__repr(_$42$arg_228) }]);
    }
    case 2: {
      const _AssignmentWord = _x_226;
      const _$42$arg_229 = _AssignmentWord._0;
      const _$42$arg_230 = _AssignmentWord._1;
      const _$42$arg_231 = _AssignmentWord._2;
      return _M0MPC15debug4Repr4ctor("AssignmentWord", [{ _0: undefined, _1: _M0IPC16string6StringPC15debug5Debug8to__repr(_$42$arg_229) }, { _0: undefined, _1: _M0IPC16string6StringPC15debug5Debug8to__repr(_$42$arg_230) }, { _0: undefined, _1: _M0IPC14bool4BoolPC15debug5Debug8to__repr(_$42$arg_231) }]);
    }
    case 3: {
      return _M0MPC15debug4Repr4ctor("Pipe", []);
    }
    case 4: {
      return _M0MPC15debug4Repr4ctor("PipeAnd", []);
    }
    case 5: {
      return _M0MPC15debug4Repr4ctor("And", []);
    }
    case 6: {
      return _M0MPC15debug4Repr4ctor("Or", []);
    }
    case 7: {
      return _M0MPC15debug4Repr4ctor("Semi", []);
    }
    case 8: {
      return _M0MPC15debug4Repr4ctor("Ampersand", []);
    }
    case 9: {
      return _M0MPC15debug4Repr4ctor("Newline", []);
    }
    case 10: {
      return _M0MPC15debug4Repr4ctor("RedirectIn", []);
    }
    case 11: {
      return _M0MPC15debug4Repr4ctor("RedirectOut", []);
    }
    case 12: {
      return _M0MPC15debug4Repr4ctor("RedirectAppend", []);
    }
    case 13: {
      return _M0MPC15debug4Repr4ctor("RedirectClobber", []);
    }
    case 14: {
      return _M0MPC15debug4Repr4ctor("HereDoc", []);
    }
    case 15: {
      return _M0MPC15debug4Repr4ctor("HereDocStrip", []);
    }
    case 16: {
      return _M0MPC15debug4Repr4ctor("HereString", []);
    }
    case 17: {
      return _M0MPC15debug4Repr4ctor("DupIn", []);
    }
    case 18: {
      return _M0MPC15debug4Repr4ctor("DupOut", []);
    }
    case 19: {
      return _M0MPC15debug4Repr4ctor("RedirectInOut", []);
    }
    case 20: {
      return _M0MPC15debug4Repr4ctor("RedirectAndOut", []);
    }
    case 21: {
      return _M0MPC15debug4Repr4ctor("RedirectAndAppend", []);
    }
    case 22: {
      return _M0MPC15debug4Repr4ctor("LeftParen", []);
    }
    case 23: {
      return _M0MPC15debug4Repr4ctor("RightParen", []);
    }
    case 24: {
      return _M0MPC15debug4Repr4ctor("LeftBrace", []);
    }
    case 25: {
      return _M0MPC15debug4Repr4ctor("RightBrace", []);
    }
    case 26: {
      return _M0MPC15debug4Repr4ctor("DoubleBracketOpen", []);
    }
    case 27: {
      return _M0MPC15debug4Repr4ctor("DoubleBracketClose", []);
    }
    case 28: {
      return _M0MPC15debug4Repr4ctor("If", []);
    }
    case 29: {
      return _M0MPC15debug4Repr4ctor("Then", []);
    }
    case 30: {
      return _M0MPC15debug4Repr4ctor("Elif", []);
    }
    case 31: {
      return _M0MPC15debug4Repr4ctor("Else", []);
    }
    case 32: {
      return _M0MPC15debug4Repr4ctor("Fi", []);
    }
    case 33: {
      return _M0MPC15debug4Repr4ctor("For", []);
    }
    case 34: {
      return _M0MPC15debug4Repr4ctor("While", []);
    }
    case 35: {
      return _M0MPC15debug4Repr4ctor("Until", []);
    }
    case 36: {
      return _M0MPC15debug4Repr4ctor("Do", []);
    }
    case 37: {
      return _M0MPC15debug4Repr4ctor("Done", []);
    }
    case 38: {
      return _M0MPC15debug4Repr4ctor("Case", []);
    }
    case 39: {
      return _M0MPC15debug4Repr4ctor("Esac", []);
    }
    case 40: {
      return _M0MPC15debug4Repr4ctor("In", []);
    }
    case 41: {
      return _M0MPC15debug4Repr4ctor("Function", []);
    }
    case 42: {
      return _M0MPC15debug4Repr4ctor("Select", []);
    }
    case 43: {
      return _M0MPC15debug4Repr4ctor("Bang", []);
    }
    case 44: {
      return _M0MPC15debug4Repr4ctor("Time", []);
    }
    case 45: {
      return _M0MPC15debug4Repr4ctor("EOF", []);
    }
    default: {
      const _FdNumber = _x_226;
      const _$42$arg_232 = _FdNumber._0;
      return _M0MPC15debug4Repr4ctor("FdNumber", [{ _0: undefined, _1: _M0IPC13int3IntPC15debug5Debug8to__repr(_$42$arg_232) }]);
    }
  }
}
function _M0IP410Haoxincode8moonbash3lib3ast5TokenPB2Eq5equal(_x_198, _x_199) {
  switch (_x_198.$tag) {
    case 0: {
      const _Word = _x_198;
      const _$42$x0_200 = _Word._0;
      if (_x_199.$tag === 0) {
        const _Word$2 = _x_199;
        const _$42$y0_201 = _Word$2._0;
        return _$42$x0_200 === _$42$y0_201;
      } else {
        return false;
      }
    }
    case 1: {
      const _Number = _x_198;
      const _$42$x0_202 = _Number._0;
      if (_x_199.$tag === 1) {
        const _Number$2 = _x_199;
        const _$42$y0_203 = _Number$2._0;
        return BigInt.asUintN(64, _$42$x0_202) === BigInt.asUintN(64, _$42$y0_203);
      } else {
        return false;
      }
    }
    case 2: {
      const _AssignmentWord = _x_198;
      const _$42$x0_204 = _AssignmentWord._0;
      const _$42$x1_205 = _AssignmentWord._1;
      const _$42$x2_206 = _AssignmentWord._2;
      if (_x_199.$tag === 2) {
        const _AssignmentWord$2 = _x_199;
        const _$42$y0_207 = _AssignmentWord$2._0;
        const _$42$y1_208 = _AssignmentWord$2._1;
        const _$42$y2_209 = _AssignmentWord$2._2;
        return _$42$x0_204 === _$42$y0_207 && (_$42$x1_205 === _$42$y1_208 && _$42$x2_206 === _$42$y2_209);
      } else {
        return false;
      }
    }
    case 3: {
      if (_x_199.$tag === 3) {
        return true;
      } else {
        return false;
      }
    }
    case 4: {
      if (_x_199.$tag === 4) {
        return true;
      } else {
        return false;
      }
    }
    case 5: {
      if (_x_199.$tag === 5) {
        return true;
      } else {
        return false;
      }
    }
    case 6: {
      if (_x_199.$tag === 6) {
        return true;
      } else {
        return false;
      }
    }
    case 7: {
      if (_x_199.$tag === 7) {
        return true;
      } else {
        return false;
      }
    }
    case 8: {
      if (_x_199.$tag === 8) {
        return true;
      } else {
        return false;
      }
    }
    case 9: {
      if (_x_199.$tag === 9) {
        return true;
      } else {
        return false;
      }
    }
    case 10: {
      if (_x_199.$tag === 10) {
        return true;
      } else {
        return false;
      }
    }
    case 11: {
      if (_x_199.$tag === 11) {
        return true;
      } else {
        return false;
      }
    }
    case 12: {
      if (_x_199.$tag === 12) {
        return true;
      } else {
        return false;
      }
    }
    case 13: {
      if (_x_199.$tag === 13) {
        return true;
      } else {
        return false;
      }
    }
    case 14: {
      if (_x_199.$tag === 14) {
        return true;
      } else {
        return false;
      }
    }
    case 15: {
      if (_x_199.$tag === 15) {
        return true;
      } else {
        return false;
      }
    }
    case 16: {
      if (_x_199.$tag === 16) {
        return true;
      } else {
        return false;
      }
    }
    case 17: {
      if (_x_199.$tag === 17) {
        return true;
      } else {
        return false;
      }
    }
    case 18: {
      if (_x_199.$tag === 18) {
        return true;
      } else {
        return false;
      }
    }
    case 19: {
      if (_x_199.$tag === 19) {
        return true;
      } else {
        return false;
      }
    }
    case 20: {
      if (_x_199.$tag === 20) {
        return true;
      } else {
        return false;
      }
    }
    case 21: {
      if (_x_199.$tag === 21) {
        return true;
      } else {
        return false;
      }
    }
    case 22: {
      if (_x_199.$tag === 22) {
        return true;
      } else {
        return false;
      }
    }
    case 23: {
      if (_x_199.$tag === 23) {
        return true;
      } else {
        return false;
      }
    }
    case 24: {
      if (_x_199.$tag === 24) {
        return true;
      } else {
        return false;
      }
    }
    case 25: {
      if (_x_199.$tag === 25) {
        return true;
      } else {
        return false;
      }
    }
    case 26: {
      if (_x_199.$tag === 26) {
        return true;
      } else {
        return false;
      }
    }
    case 27: {
      if (_x_199.$tag === 27) {
        return true;
      } else {
        return false;
      }
    }
    case 28: {
      if (_x_199.$tag === 28) {
        return true;
      } else {
        return false;
      }
    }
    case 29: {
      if (_x_199.$tag === 29) {
        return true;
      } else {
        return false;
      }
    }
    case 30: {
      if (_x_199.$tag === 30) {
        return true;
      } else {
        return false;
      }
    }
    case 31: {
      if (_x_199.$tag === 31) {
        return true;
      } else {
        return false;
      }
    }
    case 32: {
      if (_x_199.$tag === 32) {
        return true;
      } else {
        return false;
      }
    }
    case 33: {
      if (_x_199.$tag === 33) {
        return true;
      } else {
        return false;
      }
    }
    case 34: {
      if (_x_199.$tag === 34) {
        return true;
      } else {
        return false;
      }
    }
    case 35: {
      if (_x_199.$tag === 35) {
        return true;
      } else {
        return false;
      }
    }
    case 36: {
      if (_x_199.$tag === 36) {
        return true;
      } else {
        return false;
      }
    }
    case 37: {
      if (_x_199.$tag === 37) {
        return true;
      } else {
        return false;
      }
    }
    case 38: {
      if (_x_199.$tag === 38) {
        return true;
      } else {
        return false;
      }
    }
    case 39: {
      if (_x_199.$tag === 39) {
        return true;
      } else {
        return false;
      }
    }
    case 40: {
      if (_x_199.$tag === 40) {
        return true;
      } else {
        return false;
      }
    }
    case 41: {
      if (_x_199.$tag === 41) {
        return true;
      } else {
        return false;
      }
    }
    case 42: {
      if (_x_199.$tag === 42) {
        return true;
      } else {
        return false;
      }
    }
    case 43: {
      if (_x_199.$tag === 43) {
        return true;
      } else {
        return false;
      }
    }
    case 44: {
      if (_x_199.$tag === 44) {
        return true;
      } else {
        return false;
      }
    }
    case 45: {
      if (_x_199.$tag === 45) {
        return true;
      } else {
        return false;
      }
    }
    default: {
      const _FdNumber = _x_198;
      const _$42$x0_210 = _FdNumber._0;
      if (_x_199.$tag === 46) {
        const _FdNumber$2 = _x_199;
        const _$42$y0_211 = _FdNumber$2._0;
        return _$42$x0_210 === _$42$y0_211;
      } else {
        return false;
      }
    }
  }
}
function _M0IP410Haoxincode8moonbash3lib3ast5TokenPB4Show6output(self, logger) {
  logger.method_table.method_0(logger.self, _M0FPC15debug10to__stringGRP410Haoxincode8moonbash3lib3ast5TokenE(self));
}
function _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(stdout) {
  return new _M0TP410Haoxincode8moonbash3lib3ast10ExecResult(stdout, "", 0);
}
function _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(stderr) {
  return new _M0TP410Haoxincode8moonbash3lib3ast10ExecResult("", stderr, 1);
}
function _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(stdout, stderr, exit_code) {
  return new _M0TP410Haoxincode8moonbash3lib3ast10ExecResult(stdout, stderr, exit_code);
}
function _M0MP410Haoxincode8moonbash3lib3ast12ShellOptions7default() {
  return new _M0TP410Haoxincode8moonbash3lib3ast12ShellOptions(false, false, false, false, false, false, false);
}
function _M0FP29justjavac4glob9get__char(s, index) {
  if (index >= 0 && index < s.length) {
    $bound_check(s, index);
    const code = s.charCodeAt(index);
    return code;
  } else {
    return -1;
  }
}
function _M0FP29justjavac4glob11match__here(pattern, text) {
  let _tmp$38 = pattern;
  let _tmp$39 = text;
  while (true) {
    const pattern$2 = _tmp$38;
    const text$2 = _tmp$39;
    const pattern_len = pattern$2.length;
    const text_len = text$2.length;
    if (pattern_len === 0) {
      return new _M0DTPC16result6ResultGbRPC15error5ErrorE2Ok(text_len === 0);
    }
    if (_M0MPC16string6String11has__prefix(pattern$2, new _M0TPC16string10StringView(_M0FP29justjavac4glob11match__hereN7_2abindS38, 0, _M0FP29justjavac4glob11match__hereN7_2abindS38.length))) {
      let _tmp$40 = 0;
      while (true) {
        const i = _tmp$40;
        if (i <= text$2.length) {
          const _bind$4 = _M0FP29justjavac4glob11match__here(_M0MPC16string10StringView9to__owned(_M0MPC16string6String11sub_2einner(pattern$2, 2, undefined)), _M0MPC16string10StringView9to__owned(_M0MPC16string6String11sub_2einner(text$2, i, undefined)));
          let _tmp$41;
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            _tmp$41 = _ok._0;
          } else {
            return _bind$4;
          }
          if (_tmp$41) {
            return new _M0DTPC16result6ResultGbRPC15error5ErrorE2Ok(true);
          }
          _tmp$40 = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return new _M0DTPC16result6ResultGbRPC15error5ErrorE2Ok(false);
    }
    if (_M0MPC16string6String11has__prefix(pattern$2, new _M0TPC16string10StringView(_M0FP29justjavac4glob11match__hereN7_2abindS41, 0, _M0FP29justjavac4glob11match__hereN7_2abindS41.length))) {
      const remaining_pattern = _M0MPC16string10StringView9to__owned(_M0MPC16string6String11sub_2einner(pattern$2, 1, undefined));
      if (remaining_pattern.length === 0) {
        let _tmp$40 = 0;
        while (true) {
          const i = _tmp$40;
          if (i < text$2.length) {
            const _bind$4 = _M0FP29justjavac4glob9get__char(text$2, i);
            if (_bind$4 === -1) {
            } else {
              const _Some = _bind$4;
              const _c = _Some;
              if (_c === 47 || _c === 92) {
                return new _M0DTPC16result6ResultGbRPC15error5ErrorE2Ok(false);
              }
            }
            _tmp$40 = i + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        return new _M0DTPC16result6ResultGbRPC15error5ErrorE2Ok(true);
      }
      let _tmp$40 = 0;
      while (true) {
        const i = _tmp$40;
        if (i <= text$2.length) {
          if (i < text$2.length) {
            const _bind$4 = _M0FP29justjavac4glob9get__char(text$2, i);
            if (_bind$4 === -1) {
            } else {
              const _Some = _bind$4;
              const _c = _Some;
              if (_c === 47 || _c === 92) {
                break;
              }
            }
          }
          const _bind$4 = _M0FP29justjavac4glob11match__here(remaining_pattern, _M0MPC16string10StringView9to__owned(_M0MPC16string6String11sub_2einner(text$2, i, undefined)));
          let _tmp$41;
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            _tmp$41 = _ok._0;
          } else {
            return _bind$4;
          }
          if (_tmp$41) {
            return new _M0DTPC16result6ResultGbRPC15error5ErrorE2Ok(true);
          }
          _tmp$40 = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return new _M0DTPC16result6ResultGbRPC15error5ErrorE2Ok(false);
    }
    if (text_len > 0 && pattern_len > 0) {
      $bound_check(pattern$2, 0);
      const _p$4 = pattern$2.charCodeAt(0);
      const pattern_char = _p$4;
      $bound_check(text$2, 0);
      const _p$5 = text$2.charCodeAt(0);
      const text_char = _p$5;
      if (pattern_char === 63 || pattern_char === text_char) {
        _tmp$38 = _M0MPC16string10StringView9to__owned(_M0MPC16string6String11sub_2einner(pattern$2, 1, undefined));
        _tmp$39 = _M0MPC16string10StringView9to__owned(_M0MPC16string6String11sub_2einner(text$2, 1, undefined));
        continue;
      }
    }
    return new _M0DTPC16result6ResultGbRPC15error5ErrorE2Ok(false);
  }
}
function _M0FP29justjavac4glob4glob(pattern, text) {
  return _M0FP29justjavac4glob11match__here(pattern, text);
}
function _M0FP410Haoxincode8moonbash3lib2fs14validate__path(path) {
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < path.length) {
      $bound_check(path, i);
      const _p$4 = path.charCodeAt(i);
      const _p$5 = 0;
      if (_p$4 === _p$5) {
        return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError("Invalid path: contains null byte"));
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(undefined);
}
function _M0FP410Haoxincode8moonbash3lib2fs6substr(s, start, end) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = start;
  while (true) {
    const i = _tmp$38;
    if (i < end) {
      $bound_check(s, i);
      _M0IPB13StringBuilderPB6Logger11write__char(buf, s.charCodeAt(i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function _M0FP410Haoxincode8moonbash3lib2fs15normalize__path(path) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs14validate__path(path);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  if (path.length === 0) {
    return new _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError("Invalid path: empty path"));
  }
  $bound_check(path, 0);
  const _p$4 = path.charCodeAt(0);
  const _p$5 = 47;
  if (_p$4 !== _p$5) {
    return new _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`Invalid path: not absolute: ${path}`));
  }
  const stack = [];
  let start = 0;
  const len = path.length;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i <= len) {
      let _tmp$39;
      if (i === len) {
        _tmp$39 = true;
      } else {
        $bound_check(path, i);
        const _p$6 = path.charCodeAt(i);
        const _p$7 = 47;
        _tmp$39 = _p$6 === _p$7;
      }
      if (_tmp$39) {
        if (i > start) {
          const part = _M0FP410Haoxincode8moonbash3lib2fs6substr(path, start, i);
          if (part === ".") {
          } else {
            if (part === "..") {
              if (stack.length > 0) {
                _M0MPC15array5Array3popGsE(stack);
              }
            } else {
              _M0MPC15array5Array4pushGUssEE(stack, part);
            }
          }
        }
        start = i + 1 | 0;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (stack.length === 0) {
    return new _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok("/");
  }
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _bind$5 = stack.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$5) {
      const part = stack[_];
      _M0IPB13StringBuilderPB6Logger13write__string(buf, "/");
      _M0IPB13StringBuilderPB6Logger13write__string(buf, part);
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(buf.val);
}
function _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(cwd, path) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs14validate__path(path);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  if (path.length === 0) {
    return new _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError("Invalid path: empty path"));
  }
  $bound_check(path, 0);
  const _p$4 = path.charCodeAt(0);
  const _p$5 = 47;
  if (_p$4 === _p$5) {
    return _M0FP410Haoxincode8moonbash3lib2fs15normalize__path(path);
  } else {
    return _M0FP410Haoxincode8moonbash3lib2fs15normalize__path(`${cwd}/${path}`);
  }
}
function _M0FP410Haoxincode8moonbash3lib2fs12parent__path(path) {
  if (path === "/") {
    return "/";
  }
  let last_slash = -1;
  let _tmp$38 = path.length - 1 | 0;
  while (true) {
    const i = _tmp$38;
    if (i >= 0) {
      $bound_check(path, i);
      const _p$4 = path.charCodeAt(i);
      const _p$5 = 47;
      if (_p$4 === _p$5) {
        last_slash = i;
        break;
      }
      _tmp$38 = i - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return last_slash <= 0 ? "/" : _M0FP410Haoxincode8moonbash3lib2fs6substr(path, 0, last_slash);
}
function _M0FP410Haoxincode8moonbash3lib2fs8basename(path) {
  if (path === "/") {
    return "/";
  }
  let last_slash = -1;
  let _tmp$38 = path.length - 1 | 0;
  while (true) {
    const i = _tmp$38;
    if (i >= 0) {
      $bound_check(path, i);
      const _p$4 = path.charCodeAt(i);
      const _p$5 = 47;
      if (_p$4 === _p$5) {
        last_slash = i;
        break;
      }
      _tmp$38 = i - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return last_slash < 0 ? path : _M0FP410Haoxincode8moonbash3lib2fs6substr(path, last_slash + 1 | 0, path.length);
}
function _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs3new() {
  const _bind$4 = [];
  const entries = _M0MPB3Map3MapGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(new _M0TPB9ArrayViewGUsRP410Haoxincode8moonbash3lib2fs7FsEntryEE(_bind$4, 0, 0), undefined);
  _M0MPB3Map3setGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(entries, "/", new _M0DTP410Haoxincode8moonbash3lib2fs7FsEntry9Directory(new _M0TP410Haoxincode8moonbash3lib2fs7DirData(493, _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs3newN3nowS189)));
  _M0MPB3Map3setGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(entries, "/home", new _M0DTP410Haoxincode8moonbash3lib2fs7FsEntry9Directory(new _M0TP410Haoxincode8moonbash3lib2fs7DirData(493, _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs3newN3nowS189)));
  _M0MPB3Map3setGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(entries, "/home/user", new _M0DTP410Haoxincode8moonbash3lib2fs7FsEntry9Directory(new _M0TP410Haoxincode8moonbash3lib2fs7DirData(493, _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs3newN3nowS189)));
  _M0MPB3Map3setGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(entries, "/bin", new _M0DTP410Haoxincode8moonbash3lib2fs7FsEntry9Directory(new _M0TP410Haoxincode8moonbash3lib2fs7DirData(493, _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs3newN3nowS189)));
  _M0MPB3Map3setGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(entries, "/usr", new _M0DTP410Haoxincode8moonbash3lib2fs7FsEntry9Directory(new _M0TP410Haoxincode8moonbash3lib2fs7DirData(493, _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs3newN3nowS189)));
  _M0MPB3Map3setGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(entries, "/usr/bin", new _M0DTP410Haoxincode8moonbash3lib2fs7FsEntry9Directory(new _M0TP410Haoxincode8moonbash3lib2fs7DirData(493, _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs3newN3nowS189)));
  _M0MPB3Map3setGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(entries, "/tmp", new _M0DTP410Haoxincode8moonbash3lib2fs7FsEntry9Directory(new _M0TP410Haoxincode8moonbash3lib2fs7DirData(1023, _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs3newN3nowS189)));
  return new _M0TP410Haoxincode8moonbash3lib2fs10InMemoryFs(entries);
}
function _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs25resolve__symlinks_2einner(self, path, max_depth) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs15normalize__path(path);
  let norm;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    norm = _ok._0;
  } else {
    return _bind$4;
  }
  let current = norm;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < max_depth) {
      _L: {
        _L$2: {
          const _bind$5 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, current);
          if (_bind$5 === undefined) {
            break _L$2;
          } else {
            const _Some = _bind$5;
            const _x = _Some;
            if (_x.$tag === 2) {
              const _Symlink = _x;
              const _data = _Symlink._0;
              const target = _data.target;
              let _tmp$39;
              let _tmp$40;
              if (target.length > 0) {
                $bound_check(target, 0);
                const _p$4 = target.charCodeAt(0);
                const _p$5 = 47;
                _tmp$40 = _p$4 === _p$5;
              } else {
                _tmp$40 = false;
              }
              if (_tmp$40) {
                const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs15normalize__path(target);
                if (_bind$6.$tag === 1) {
                  const _ok = _bind$6;
                  _tmp$39 = _ok._0;
                } else {
                  return _bind$6;
                }
              } else {
                const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs15normalize__path(`${_M0FP410Haoxincode8moonbash3lib2fs12parent__path(current)}/${target}`);
                if (_bind$6.$tag === 1) {
                  const _ok = _bind$6;
                  _tmp$39 = _ok._0;
                } else {
                  return _bind$6;
                }
              }
              current = _tmp$39;
            } else {
              break _L$2;
            }
          }
          break _L;
        }
        return new _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(current);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`Too many levels of symbolic links: ${path}`));
}
function _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs20ensure__parent__dirs(self, path) {
  const parent = _M0FP410Haoxincode8moonbash3lib2fs12parent__path(path);
  if (parent === path) {
    return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(undefined);
  }
  const _bind$4 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, parent);
  if (_bind$4 === undefined) {
    const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs20ensure__parent__dirs(self, parent);
    if (_bind$5.$tag === 1) {
      const _ok = _bind$5;
      _ok._0;
    } else {
      return _bind$5;
    }
    return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(_M0MPB3Map3setGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, parent, new _M0DTP410Haoxincode8moonbash3lib2fs7FsEntry9Directory(new _M0TP410Haoxincode8moonbash3lib2fs7DirData(493, _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs20ensure__parent__dirsN3nowS179))));
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    switch (_x.$tag) {
      case 1: {
        return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(undefined);
      }
      case 0: {
        return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`Not a directory: ${parent}`));
      }
      default: {
        const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs25resolve__symlinks_2einner(self, parent, 40);
        let resolved;
        if (_bind$5.$tag === 1) {
          const _ok = _bind$5;
          resolved = _ok._0;
        } else {
          return _bind$5;
        }
        _L: {
          const _bind$6 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, resolved);
          if (_bind$6 === undefined) {
            break _L;
          } else {
            const _Some$2 = _bind$6;
            const _x$2 = _Some$2;
            if (_x$2.$tag === 1) {
              return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(undefined);
            } else {
              break _L;
            }
          }
        }
        return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`Not a directory: ${parent}`));
      }
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(self, path) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs15normalize__path(path);
  let norm;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    norm = _ok._0;
  } else {
    return _bind$4;
  }
  const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs25resolve__symlinks_2einner(self, norm, 40);
  let resolved;
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    resolved = _ok._0;
  } else {
    return _bind$5;
  }
  const _bind$6 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, resolved);
  if (_bind$6 === undefined) {
    return new _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`No such file or directory: ${path}`));
  } else {
    const _Some = _bind$6;
    const _x = _Some;
    switch (_x.$tag) {
      case 0: {
        const _File = _x;
        const _data = _File._0;
        return new _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(_data.content);
      }
      case 1: {
        return new _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`Is a directory: ${path}`));
      }
      default: {
        return new _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`Dangling symlink: ${path}`));
      }
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs11write__file(self, path, content) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs15normalize__path(path);
  let norm;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    norm = _ok._0;
  } else {
    return _bind$4;
  }
  let target;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs25resolve__symlinks_2einner(self, norm, 40);
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        target = _ok._0;
      } else {
        const _err = _bind$5;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    target = norm;
  }
  const _bind$5 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, target);
  if (_bind$5 === undefined) {
  } else {
    const _Some = _bind$5;
    const _x = _Some;
    if (_x.$tag === 1) {
      return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`Is a directory: ${path}`));
    }
  }
  const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs20ensure__parent__dirs(self, target);
  if (_bind$6.$tag === 1) {
    const _ok = _bind$6;
    _ok._0;
  } else {
    return _bind$6;
  }
  _L$2: {
    const _bind$7 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, target);
    if (_bind$7 === undefined) {
      break _L$2;
    } else {
      const _Some = _bind$7;
      const _x = _Some;
      if (_x.$tag === 0) {
        const _File = _x;
        const _data = _File._0;
        _data.content = content;
        _data.mtime = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs11write__fileN3nowS168;
        return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(undefined);
      } else {
        break _L$2;
      }
    }
  }
  return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(_M0MPB3Map3setGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, target, new _M0DTP410Haoxincode8moonbash3lib2fs7FsEntry4File(new _M0TP410Haoxincode8moonbash3lib2fs8FileData(content, 420, _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs11write__fileN3nowS168))));
}
function _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs12append__file(self, path, content) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs15normalize__path(path);
  let norm;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    norm = _ok._0;
  } else {
    return _bind$4;
  }
  let target;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs25resolve__symlinks_2einner(self, norm, 40);
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        target = _ok._0;
      } else {
        const _err = _bind$5;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    target = norm;
  }
  _L$2: {
    const _bind$5 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, target);
    if (_bind$5 === undefined) {
      break _L$2;
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      switch (_x.$tag) {
        case 0: {
          const _File = _x;
          const _data = _File._0;
          _data.content = `${_data.content}${content}`;
          _data.mtime = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs12append__fileN3nowS161;
          return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(undefined);
        }
        case 1: {
          return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`Is a directory: ${path}`));
        }
        default: {
          break _L$2;
        }
      }
    }
  }
  const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs20ensure__parent__dirs(self, target);
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    _ok._0;
  } else {
    return _bind$5;
  }
  return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(_M0MPB3Map3setGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, target, new _M0DTP410Haoxincode8moonbash3lib2fs7FsEntry4File(new _M0TP410Haoxincode8moonbash3lib2fs8FileData(content, 420, _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs12append__fileN3nowS162))));
}
function _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs6exists(self, path) {
  let norm;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs15normalize__path(path);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        norm = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    return false;
  }
  return _M0MPB3Map8containsGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, norm);
}
function _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs4stat(self, path) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs15normalize__path(path);
  let norm;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    norm = _ok._0;
  } else {
    return _bind$4;
  }
  const _bind$5 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, norm);
  if (_bind$5 === undefined) {
    return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib2fs6FsStatRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`No such file or directory: ${path}`));
  } else {
    const _Some = _bind$5;
    const _x = _Some;
    switch (_x.$tag) {
      case 0: {
        const _File = _x;
        const _data = _File._0;
        return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib2fs6FsStatRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(new _M0TP410Haoxincode8moonbash3lib2fs6FsStat(true, false, false, _data.content.length, _data.mode, _data.mtime));
      }
      case 1: {
        const _Directory = _x;
        const _data$2 = _Directory._0;
        return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib2fs6FsStatRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(new _M0TP410Haoxincode8moonbash3lib2fs6FsStat(false, true, false, 0, _data$2.mode, _data$2.mtime));
      }
      default: {
        const _Symlink = _x;
        const _data$3 = _Symlink._0;
        return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib2fs6FsStatRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(new _M0TP410Haoxincode8moonbash3lib2fs6FsStat(false, false, true, _data$3.target.length, _data$3.mode, _data$3.mtime));
      }
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib2fs14contains__char(s, c) {
  const code = c & 65535;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const _p$4 = s.charCodeAt(i);
      if (_p$4 === code) {
        return true;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib2fs12starts__with(s, prefix) {
  if (prefix.length > s.length) {
    return false;
  }
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < prefix.length) {
      $bound_check(s, i);
      const _p$4 = s.charCodeAt(i);
      $bound_check(prefix, i);
      const _p$5 = prefix.charCodeAt(i);
      if (_p$4 !== _p$5) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs7readdir(self, path) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs15normalize__path(path);
  let norm;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    norm = _ok._0;
  } else {
    return _bind$4;
  }
  const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs25resolve__symlinks_2einner(self, norm, 40);
  let resolved;
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    resolved = _ok._0;
  } else {
    return _bind$5;
  }
  const _bind$6 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, resolved);
  if (_bind$6 === undefined) {
    return new _M0DTPC16result6ResultGRPB5ArrayGRP410Haoxincode8moonbash3lib2fs11DirentEntryERP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`No such file or directory: ${path}`));
  } else {
    const _Some = _bind$6;
    const _x = _Some;
    if (_x.$tag === 1) {
    } else {
      return new _M0DTPC16result6ResultGRPB5ArrayGRP410Haoxincode8moonbash3lib2fs11DirentEntryERP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`Not a directory: ${path}`));
    }
  }
  const result = [];
  const prefix = resolved === "/" ? "/" : `${resolved}/`;
  const prefix_len = prefix.length;
  const _p$4 = self.entries;
  let _tmp$38 = _p$4.head;
  while (true) {
    const _p$5 = _tmp$38;
    if (_p$5 === undefined) {
      break;
    } else {
      const _p$6 = _p$5;
      const _p$7 = _p$6;
      const _p$8 = _p$7.key;
      const _p$9 = _p$7.value;
      const _p$10 = _p$7.next;
      if (_p$8.length > prefix_len && _M0FP410Haoxincode8moonbash3lib2fs12starts__with(_p$8, prefix)) {
        const _p$11 = _M0FP410Haoxincode8moonbash3lib2fs6substr(_p$8, prefix_len, _p$8.length);
        if (!_M0FP410Haoxincode8moonbash3lib2fs14contains__char(_p$11, 47)) {
          let _p$12;
          switch (_p$9.$tag) {
            case 0: {
              _p$12 = 0;
              break;
            }
            case 1: {
              _p$12 = 1;
              break;
            }
            default: {
              _p$12 = 2;
            }
          }
          _M0MPC15array5Array4pushGUssEE(result, new _M0TP410Haoxincode8moonbash3lib2fs11DirentEntry(_p$11, _p$12));
        }
      }
      _tmp$38 = _p$10;
      continue;
    }
  }
  return new _M0DTPC16result6ResultGRPB5ArrayGRP410Haoxincode8moonbash3lib2fs11DirentEntryERP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(result);
}
function _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs16mkdir__recursive(self, path) {
  const _bind$4 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, path);
  if (_bind$4 === undefined) {
    const parent = _M0FP410Haoxincode8moonbash3lib2fs12parent__path(path);
    if (!(parent === path)) {
      const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs16mkdir__recursive(self, parent);
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        _ok._0;
      } else {
        return _bind$5;
      }
    }
    return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(_M0MPB3Map3setGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, path, new _M0DTP410Haoxincode8moonbash3lib2fs7FsEntry9Directory(new _M0TP410Haoxincode8moonbash3lib2fs7DirData(493, _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs16mkdir__recursiveN3nowS128))));
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    if (_x.$tag === 1) {
      return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(undefined);
    } else {
      return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`Not a directory: ${path}`));
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs13mkdir_2einner(self, path, recursive) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs15normalize__path(path);
  let norm;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    norm = _ok._0;
  } else {
    return _bind$4;
  }
  if (norm === "/") {
    if (recursive) {
      return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(undefined);
    }
    return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError("Already exists: /"));
  }
  if (recursive) {
    return _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs16mkdir__recursive(self, norm);
  } else {
    const parent = _M0FP410Haoxincode8moonbash3lib2fs12parent__path(norm);
    const _bind$5 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, parent);
    if (_bind$5 === undefined) {
      return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`No such file or directory: ${parent}`));
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      if (_x.$tag === 1) {
      } else {
        return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`Not a directory: ${parent}`));
      }
    }
    const _bind$6 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, norm);
    if (_bind$6 === undefined) {
      return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(_M0MPB3Map3setGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, norm, new _M0DTP410Haoxincode8moonbash3lib2fs7FsEntry9Directory(new _M0TP410Haoxincode8moonbash3lib2fs7DirData(493, _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs13mkdir_2einnerN3nowS134))));
    } else {
      return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`Already exists: ${path}`));
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10rm_2einner(self, path, recursive, force) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs15normalize__path(path);
  let norm;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    norm = _ok._0;
  } else {
    return _bind$4;
  }
  if (norm === "/") {
    if (recursive) {
      const keys_to_remove = [];
      const _p$4 = self.entries;
      let _tmp$38 = _p$4.head;
      while (true) {
        const _p$5 = _tmp$38;
        if (_p$5 === undefined) {
          break;
        } else {
          const _p$6 = _p$5;
          const _p$7 = _p$6;
          const _p$8 = _p$7.key;
          const _p$9 = _p$7.next;
          const _p$10 = "/";
          if (!(_p$8 === _p$10)) {
            _M0MPC15array5Array4pushGUssEE(keys_to_remove, _p$8);
          }
          _tmp$38 = _p$9;
          continue;
        }
      }
      const _bind$5 = keys_to_remove.length;
      let _tmp$39 = 0;
      while (true) {
        const _ = _tmp$39;
        if (_ < _bind$5) {
          const key = keys_to_remove[_];
          _M0MPB3Map6removeGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, key);
          _tmp$39 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(undefined);
    }
    return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError("Cannot remove root directory"));
  }
  const _bind$5 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, norm);
  if (_bind$5 === undefined) {
    if (force) {
      return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(undefined);
    }
    return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`No such file or directory: ${path}`));
  } else {
    const _Some = _bind$5;
    const _x = _Some;
    if (_x.$tag === 1) {
      if (!recursive) {
        const prefix = `${norm}/`;
        const has_children = new _M0TPB8MutLocalGbE(false);
        const _p$4 = self.entries;
        let _tmp$38 = _p$4.head;
        while (true) {
          const _p$5 = _tmp$38;
          if (_p$5 === undefined) {
            break;
          } else {
            const _p$6 = _p$5;
            const _p$7 = _p$6;
            const _p$8 = _p$7.key;
            const _p$9 = _p$7.next;
            if (_M0FP410Haoxincode8moonbash3lib2fs12starts__with(_p$8, prefix)) {
              has_children.val = true;
            }
            _tmp$38 = _p$9;
            continue;
          }
        }
        if (has_children.val) {
          return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`Directory not empty: ${path}`));
        }
        return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(_M0MPB3Map6removeGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, norm));
      } else {
        const prefix = `${norm}/`;
        const keys_to_remove = [];
        const _p$4 = self.entries;
        let _tmp$38 = _p$4.head;
        while (true) {
          const _p$5 = _tmp$38;
          if (_p$5 === undefined) {
            break;
          } else {
            const _p$6 = _p$5;
            const _p$7 = _p$6;
            const _p$8 = _p$7.key;
            const _p$9 = _p$7.next;
            if (_p$8 === norm || _M0FP410Haoxincode8moonbash3lib2fs12starts__with(_p$8, prefix)) {
              _M0MPC15array5Array4pushGUssEE(keys_to_remove, _p$8);
            }
            _tmp$38 = _p$9;
            continue;
          }
        }
        const _bind$6 = keys_to_remove.length;
        let _tmp$39 = 0;
        while (true) {
          const _ = _tmp$39;
          if (_ < _bind$6) {
            const key = keys_to_remove[_];
            _M0MPB3Map6removeGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, key);
            _tmp$39 = _ + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(undefined);
      }
    } else {
      return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(_M0MPB3Map6removeGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, norm));
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10cp_2einner(self, src, dst, recursive) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs15normalize__path(src);
  let src_norm;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    src_norm = _ok._0;
  } else {
    return _bind$4;
  }
  const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs15normalize__path(dst);
  let dst_norm;
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    dst_norm = _ok._0;
  } else {
    return _bind$5;
  }
  const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs25resolve__symlinks_2einner(self, src_norm, 40);
  let src_resolved;
  if (_bind$6.$tag === 1) {
    const _ok = _bind$6;
    src_resolved = _ok._0;
  } else {
    return _bind$6;
  }
  const _bind$7 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, src_resolved);
  if (_bind$7 === undefined) {
    return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`No such file or directory: ${src}`));
  } else {
    const _Some = _bind$7;
    const _x = _Some;
    switch (_x.$tag) {
      case 0: {
        const _File = _x;
        const _data = _File._0;
        let final_dst;
        _L: {
          _L$2: {
            const _bind$8 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, dst_norm);
            if (_bind$8 === undefined) {
              break _L$2;
            } else {
              const _Some$2 = _bind$8;
              const _x$2 = _Some$2;
              if (_x$2.$tag === 1) {
                final_dst = `${dst_norm}/${_M0FP410Haoxincode8moonbash3lib2fs8basename(src_norm)}`;
              } else {
                break _L$2;
              }
            }
            break _L;
          }
          final_dst = dst_norm;
        }
        const _bind$8 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs20ensure__parent__dirs(self, final_dst);
        if (_bind$8.$tag === 1) {
          const _ok = _bind$8;
          _ok._0;
        } else {
          return _bind$8;
        }
        return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(_M0MPB3Map3setGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, final_dst, new _M0DTP410Haoxincode8moonbash3lib2fs7FsEntry4File(new _M0TP410Haoxincode8moonbash3lib2fs8FileData(_data.content, _data.mode, _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10cp_2einnerN3nowS92))));
      }
      case 1: {
        if (!recursive) {
          return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`Is a directory (use recursive): ${src}`));
        }
        let final_dst$2;
        _L$2: {
          _L$3: {
            const _bind$9 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, dst_norm);
            if (_bind$9 === undefined) {
              break _L$3;
            } else {
              const _Some$2 = _bind$9;
              const _x$2 = _Some$2;
              if (_x$2.$tag === 1) {
                final_dst$2 = `${dst_norm}/${_M0FP410Haoxincode8moonbash3lib2fs8basename(src_norm)}`;
              } else {
                break _L$3;
              }
            }
            break _L$2;
          }
          final_dst$2 = dst_norm;
        }
        const prefix = `${src_resolved}/`;
        const entries_to_copy = [];
        _M0MPC15array5Array4pushGUssEE(entries_to_copy, { _0: src_resolved, _1: new _M0DTP410Haoxincode8moonbash3lib2fs7FsEntry9Directory(new _M0TP410Haoxincode8moonbash3lib2fs7DirData(493, 0n)) });
        const _p$4 = self.entries;
        let _tmp$38 = _p$4.head;
        while (true) {
          const _p$5 = _tmp$38;
          if (_p$5 === undefined) {
            break;
          } else {
            const _p$6 = _p$5;
            const _p$7 = _p$6;
            const _p$8 = _p$7.key;
            const _p$9 = _p$7.value;
            const _p$10 = _p$7.next;
            if (_M0FP410Haoxincode8moonbash3lib2fs12starts__with(_p$8, prefix)) {
              _M0MPC15array5Array4pushGUssEE(entries_to_copy, { _0: _p$8, _1: _p$9 });
            }
            _tmp$38 = _p$10;
            continue;
          }
        }
        const _bind$9 = entries_to_copy.length;
        let _tmp$39 = 0;
        while (true) {
          const _ = _tmp$39;
          if (_ < _bind$9) {
            const entry = entries_to_copy[_];
            const _old_path = entry._0;
            const _old_entry = entry._1;
            const relative = _M0FP410Haoxincode8moonbash3lib2fs6substr(_old_path, src_resolved.length, _old_path.length);
            const new_path = `${final_dst$2}${relative}`;
            const _bind$10 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs20ensure__parent__dirs(self, new_path);
            if (_bind$10.$tag === 1) {
              const _ok = _bind$10;
              _ok._0;
            } else {
              return _bind$10;
            }
            switch (_old_entry.$tag) {
              case 0: {
                const _File$2 = _old_entry;
                const _fdata = _File$2._0;
                _M0MPB3Map3setGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, new_path, new _M0DTP410Haoxincode8moonbash3lib2fs7FsEntry4File(new _M0TP410Haoxincode8moonbash3lib2fs8FileData(_fdata.content, _fdata.mode, _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10cp_2einnerN3nowS98)));
                break;
              }
              case 1: {
                const _Directory = _old_entry;
                const _ddata = _Directory._0;
                _M0MPB3Map3setGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, new_path, new _M0DTP410Haoxincode8moonbash3lib2fs7FsEntry9Directory(new _M0TP410Haoxincode8moonbash3lib2fs7DirData(_ddata.mode, _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10cp_2einnerN3nowS98)));
                break;
              }
              default: {
                const _Symlink = _old_entry;
                const _sdata = _Symlink._0;
                _M0MPB3Map3setGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, new_path, new _M0DTP410Haoxincode8moonbash3lib2fs7FsEntry7Symlink(new _M0TP410Haoxincode8moonbash3lib2fs11SymlinkData(_sdata.target, _sdata.mode, _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10cp_2einnerN3nowS98)));
              }
            }
            _tmp$39 = _ + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(undefined);
      }
      default: {
        return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`Dangling symlink: ${src}`));
      }
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs2mv(self, src, dst) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs15normalize__path(src);
  let src_norm;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    src_norm = _ok._0;
  } else {
    return _bind$4;
  }
  const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs15normalize__path(dst);
  let dst_norm;
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    dst_norm = _ok._0;
  } else {
    return _bind$5;
  }
  if (_M0MPB3Map8containsGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, src_norm)) {
    let final_dst;
    _L: {
      _L$2: {
        const _bind$6 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, dst_norm);
        if (_bind$6 === undefined) {
          break _L$2;
        } else {
          const _Some = _bind$6;
          const _x = _Some;
          if (_x.$tag === 1) {
            final_dst = `${dst_norm}/${_M0FP410Haoxincode8moonbash3lib2fs8basename(src_norm)}`;
          } else {
            break _L$2;
          }
        }
        break _L;
      }
      final_dst = dst_norm;
    }
    const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs20ensure__parent__dirs(self, final_dst);
    if (_bind$6.$tag === 1) {
      const _ok = _bind$6;
      _ok._0;
    } else {
      return _bind$6;
    }
    const _bind$7 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, src_norm);
    if (_bind$7 === undefined) {
      return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`No such file or directory: ${src}`));
    } else {
      const _Some = _bind$7;
      const _x = _Some;
      if (_x.$tag === 1) {
        const prefix = `${src_norm}/`;
        const to_move = [];
        const _p$4 = self.entries;
        let _tmp$38 = _p$4.head;
        while (true) {
          const _p$5 = _tmp$38;
          if (_p$5 === undefined) {
            break;
          } else {
            const _p$6 = _p$5;
            const _p$7 = _p$6;
            const _p$8 = _p$7.key;
            const _p$9 = _p$7.value;
            const _p$10 = _p$7.next;
            if (_p$8 === src_norm || _M0FP410Haoxincode8moonbash3lib2fs12starts__with(_p$8, prefix)) {
              _M0MPC15array5Array4pushGUssEE(to_move, { _0: _p$8, _1: _p$9 });
            }
            _tmp$38 = _p$10;
            continue;
          }
        }
        const _bind$8 = to_move.length;
        let _tmp$39 = 0;
        while (true) {
          const _ = _tmp$39;
          if (_ < _bind$8) {
            const entry = to_move[_];
            const _old_path = entry._0;
            const _old_entry = entry._1;
            const relative = _M0FP410Haoxincode8moonbash3lib2fs6substr(_old_path, src_norm.length, _old_path.length);
            const new_path = `${final_dst}${relative}`;
            _M0MPB3Map3setGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, new_path, _old_entry);
            _M0MPB3Map6removeGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, _old_path);
            _tmp$39 = _ + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(undefined);
      } else {
        _M0MPB3Map3setGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, final_dst, _x);
        return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(_M0MPB3Map6removeGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, src_norm));
      }
    }
  } else {
    return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`No such file or directory: ${src}`));
  }
}
function _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs7symlink(self, target, link_path) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs15normalize__path(link_path);
  let norm;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    norm = _ok._0;
  } else {
    return _bind$4;
  }
  const _bind$5 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, norm);
  if (_bind$5 === undefined) {
    const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs20ensure__parent__dirs(self, norm);
    if (_bind$6.$tag === 1) {
      const _ok = _bind$6;
      _ok._0;
    } else {
      return _bind$6;
    }
    return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(_M0MPB3Map3setGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, norm, new _M0DTP410Haoxincode8moonbash3lib2fs7FsEntry7Symlink(new _M0TP410Haoxincode8moonbash3lib2fs11SymlinkData(target, 511, _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs7symlinkN3nowS66))));
  } else {
    return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`Already exists: ${link_path}`));
  }
}
function _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs8readlink(self, path) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs15normalize__path(path);
  let norm;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    norm = _ok._0;
  } else {
    return _bind$4;
  }
  const _bind$5 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, norm);
  if (_bind$5 === undefined) {
    return new _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`No such file or directory: ${path}`));
  } else {
    const _Some = _bind$5;
    const _x = _Some;
    if (_x.$tag === 2) {
      const _Symlink = _x;
      const _data = _Symlink._0;
      return new _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(_data.target);
    } else {
      return new _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`Not a symbolic link: ${path}`));
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs5chmod(self, path, mode) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs15normalize__path(path);
  let norm;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    norm = _ok._0;
  } else {
    return _bind$4;
  }
  const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs25resolve__symlinks_2einner(self, norm, 40);
  let resolved;
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    resolved = _ok._0;
  } else {
    return _bind$5;
  }
  const _bind$6 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.entries, resolved);
  if (_bind$6 === undefined) {
    return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE3Err(new _M0DTPC15error5Error52Haoxincode_2fmoonbash_2flib_2ffs_2eFsError_2eFsError(`No such file or directory: ${path}`));
  } else {
    const _Some = _bind$6;
    const _x = _Some;
    switch (_x.$tag) {
      case 0: {
        const _File = _x;
        const _data = _File._0;
        _data.mode = mode;
        return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(undefined);
      }
      case 1: {
        const _Directory = _x;
        const _data$2 = _Directory._0;
        _data$2.mode = mode;
        return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(undefined);
      }
      default: {
        const _Symlink = _x;
        const _data$3 = _Symlink._0;
        _data$3.mode = mode;
        return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(undefined);
      }
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs17snapshot__entries(self) {
  const entries = [];
  const _p$4 = self.entries;
  let _tmp$38 = _p$4.head;
  while (true) {
    const _p$5 = _tmp$38;
    if (_p$5 === undefined) {
      break;
    } else {
      const _p$6 = _p$5;
      const _p$7 = _p$6;
      const _p$8 = _p$7.key;
      const _p$9 = _p$7.value;
      const _p$10 = _p$7.next;
      switch (_p$9.$tag) {
        case 0: {
          const _p$11 = _p$9;
          const _p$12 = _p$11._0;
          _M0MPC15array5Array4pushGUssEE(entries, { _0: _p$8, _1: "f", _2: _p$12.content, _3: _M0MPC13int3Int18to__string_2einner(_p$12.mode, 10) });
          break;
        }
        case 1: {
          const _p$13 = _p$9;
          const _p$14 = _p$13._0;
          _M0MPC15array5Array4pushGUssEE(entries, { _0: _p$8, _1: "d", _2: "", _3: _M0MPC13int3Int18to__string_2einner(_p$14.mode, 10) });
          break;
        }
        default: {
          const _p$15 = _p$9;
          const _p$16 = _p$15._0;
          _M0MPC15array5Array4pushGUssEE(entries, { _0: _p$8, _1: "l", _2: _p$16.target, _3: _M0MPC13int3Int18to__string_2einner(_p$16.mode, 10) });
        }
      }
      _tmp$38 = _p$10;
      continue;
    }
  }
  _M0MPC15array5Array8sort__byGUssEE(entries, (a, b) => _M0IP016_24default__implPB7Compare6op__ltGsE(a._0, b._0) ? -1 : _M0IP016_24default__implPB7Compare6op__gtGsE(a._0, b._0) ? 1 : 0);
  return entries;
}
function _M0FP410Haoxincode8moonbash3lib2fs31glob__pattern__has__char__class(pattern) {
  let i = 0;
  while (true) {
    if (i < pattern.length) {
      const _p$4 = i;
      $bound_check(pattern, _p$4);
      const ch = pattern.charCodeAt(_p$4);
      if (ch === 92) {
        i = i + 2 | 0;
        continue;
      }
      if (ch === 91) {
        let j = i + 1 | 0;
        while (true) {
          if (j < pattern.length) {
            const _p$5 = j;
            $bound_check(pattern, _p$5);
            const ch2 = pattern.charCodeAt(_p$5);
            if (ch2 === 93) {
              return true;
            }
            j = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        return false;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib2fs21glob__class__contains(pattern, class_start, target) {
  let i = class_start + 1 | 0;
  if (i >= pattern.length) {
    return { _0: false, _1: class_start + 1 | 0, _2: false };
  }
  let negated = false;
  const _p$4 = i;
  $bound_check(pattern, _p$4);
  const first = pattern.charCodeAt(_p$4);
  if (first === 33 || first === 94) {
    negated = true;
    i = i + 1 | 0;
  }
  let matched = false;
  let has_items = false;
  while (true) {
    if (i < pattern.length) {
      const _p$5 = i;
      $bound_check(pattern, _p$5);
      const ch = pattern.charCodeAt(_p$5);
      if (ch === 93 && has_items) {
        const result = negated ? !matched : matched;
        return { _0: result, _1: i + 1 | 0, _2: true };
      }
      let _tmp$38;
      if ((i + 2 | 0) < pattern.length) {
        let _tmp$39;
        const _p$6 = i + 1 | 0;
        $bound_check(pattern, _p$6);
        if (pattern.charCodeAt(_p$6) === 45) {
          const _p$7 = i + 2 | 0;
          $bound_check(pattern, _p$7);
          _tmp$39 = pattern.charCodeAt(_p$7) !== 93;
        } else {
          _tmp$39 = false;
        }
        _tmp$38 = _tmp$39;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        const _p$6 = i + 2 | 0;
        $bound_check(pattern, _p$6);
        const right = pattern.charCodeAt(_p$6);
        has_items = true;
        if (ch <= target && target <= right || right <= target && target <= ch) {
          matched = true;
        }
        i = i + 3 | 0;
        continue;
      }
      has_items = true;
      if (ch === target) {
        matched = true;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return { _0: false, _1: class_start + 1 | 0, _2: false };
}
function _M0FP410Haoxincode8moonbash3lib2fs30glob__match__with__char__class(pattern, text, pi, ti) {
  let _tmp$38 = pi;
  let _tmp$39 = ti;
  while (true) {
    const pi$2 = _tmp$38;
    const ti$2 = _tmp$39;
    if (pi$2 >= pattern.length) {
      return ti$2 >= text.length;
    }
    $bound_check(pattern, pi$2);
    const pch = pattern.charCodeAt(pi$2);
    if (pch === 42) {
      let i = ti$2;
      while (true) {
        if (i <= text.length) {
          if (_M0FP410Haoxincode8moonbash3lib2fs30glob__match__with__char__class(pattern, text, pi$2 + 1 | 0, i)) {
            return true;
          }
          i = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return false;
    }
    if (pch === 63) {
      if (ti$2 >= text.length) {
        return false;
      }
      _tmp$38 = pi$2 + 1 | 0;
      _tmp$39 = ti$2 + 1 | 0;
      continue;
    }
    if (pch === 91) {
      if (ti$2 >= text.length) {
        return false;
      }
      $bound_check(text, ti$2);
      const target = text.charCodeAt(ti$2);
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs21glob__class__contains(pattern, pi$2, target);
      const _ok = _bind$4._0;
      const _next_pi = _bind$4._1;
      const _parsed = _bind$4._2;
      if (_parsed) {
        if (!_ok) {
          return false;
        }
        _tmp$38 = _next_pi;
        _tmp$39 = ti$2 + 1 | 0;
        continue;
      }
      if (target !== 91) {
        return false;
      }
      _tmp$38 = pi$2 + 1 | 0;
      _tmp$39 = ti$2 + 1 | 0;
      continue;
    }
    if (pch === 92) {
      let literal;
      if ((pi$2 + 1 | 0) < pattern.length) {
        const _p$4 = pi$2 + 1 | 0;
        $bound_check(pattern, _p$4);
        literal = pattern.charCodeAt(_p$4);
      } else {
        literal = 92;
      }
      let _tmp$40;
      if (ti$2 >= text.length) {
        _tmp$40 = true;
      } else {
        $bound_check(text, ti$2);
        _tmp$40 = text.charCodeAt(ti$2) !== literal;
      }
      if (_tmp$40) {
        return false;
      }
      const next_pi = (pi$2 + 1 | 0) < pattern.length ? pi$2 + 2 | 0 : pi$2 + 1 | 0;
      _tmp$38 = next_pi;
      _tmp$39 = ti$2 + 1 | 0;
      continue;
    }
    let _tmp$40;
    if (ti$2 >= text.length) {
      _tmp$40 = true;
    } else {
      $bound_check(text, ti$2);
      _tmp$40 = text.charCodeAt(ti$2) !== pch;
    }
    if (_tmp$40) {
      return false;
    }
    _tmp$38 = pi$2 + 1 | 0;
    _tmp$39 = ti$2 + 1 | 0;
    continue;
  }
}
function _M0FP410Haoxincode8moonbash3lib2fs11glob__match(pattern, text) {
  if (_M0FP410Haoxincode8moonbash3lib2fs31glob__pattern__has__char__class(pattern)) {
    return _M0FP410Haoxincode8moonbash3lib2fs30glob__match__with__char__class(pattern, text, 0, 0);
  }
  let _try_err;
  _L: {
    const _bind$4 = _M0FP29justjavac4glob4glob(pattern, text);
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      return _ok._0;
    } else {
      const _err = _bind$4;
      _try_err = _err._0;
      break _L;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib3ffi11fetch__sync(request_json) {
  return _M0FP410Haoxincode8moonbash3lib3ffi21host__fetch__sync__js(request_json);
}
function _M0FP410Haoxincode8moonbash3lib3ffi11sleep__sync(duration_ms) {
  return _M0FP410Haoxincode8moonbash3lib3ffi21host__sleep__sync__js(duration_ms);
}
function _M0FP410Haoxincode8moonbash3lib3ffi13now__ms__sync() {
  return _M0FP410Haoxincode8moonbash3lib3ffi23host__now__ms__sync__js();
}
function _M0FP410Haoxincode8moonbash3lib3ffi27parse__host__int64__decimal(text) {
  if (text.length === 0) {
    return 0n;
  }
  let i = 0;
  let sign = 1n;
  $bound_check(text, 0);
  if (text.charCodeAt(0) === 43) {
    i = 1;
  } else {
    $bound_check(text, 0);
    if (text.charCodeAt(0) === 45) {
      sign = 18446744073709551615n;
      i = 1;
    }
  }
  let value = 0n;
  while (true) {
    if (i < text.length) {
      const _tmp$38 = i;
      $bound_check(text, _tmp$38);
      const ch = text.charCodeAt(_tmp$38);
      if (ch < 48 || ch > 57) {
        break;
      }
      value = BigInt.asUintN(64, BigInt.asUintN(64, value * 10n) + BigInt.asUintN(64, BigInt(ch - 48 | 0)));
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return BigInt.asUintN(64, value * sign);
}
function _M0FP410Haoxincode8moonbash3lib3ffi19wall__now__ms__sync() {
  return _M0FP410Haoxincode8moonbash3lib3ffi27parse__host__int64__decimal(_M0FP410Haoxincode8moonbash3lib3ffi29host__wall__now__ms__sync__js());
}
function _M0FP410Haoxincode8moonbash3lib3ffi8vm__sync(request_json) {
  return _M0FP410Haoxincode8moonbash3lib3ffi18host__vm__sync__js(request_json);
}
function _M0FP410Haoxincode8moonbash3lib3ffi21custom__command__sync(request_json) {
  return _M0FP410Haoxincode8moonbash3lib3ffi31host__custom__command__sync__js(request_json);
}
function _M0IP410Haoxincode8moonbash3lib6nyacsv12StringReaderP410Haoxincode8moonbash3lib6nyacsv9CSVReader10read__char(self) {
  if (self.pos < self.source.length) {
    const _tmp$38 = self.source;
    const _tmp$39 = self.pos;
    $bound_check(_tmp$38, _tmp$39);
    const ch = _tmp$38.charCodeAt(_tmp$39);
    self.pos = self.pos + 1 | 0;
    return ch;
  } else {
    return -1;
  }
}
function _M0IP410Haoxincode8moonbash3lib6nyacsv12StringReaderP410Haoxincode8moonbash3lib6nyacsv9CSVReader10peek__char(self) {
  if (self.pos < self.source.length) {
    const _tmp$38 = self.source;
    const _tmp$39 = self.pos;
    $bound_check(_tmp$38, _tmp$39);
    return _tmp$38.charCodeAt(_tmp$39);
  } else {
    return -1;
  }
}
function _M0FP410Haoxincode8moonbash3lib6nyacsv22nyacsv__is__trim__char(ch) {
  return ch === 32 || (ch === 9 || (ch === 10 || ch === 13));
}
function _M0FP410Haoxincode8moonbash3lib6nyacsv19nyacsv__trim__field(s) {
  if (s.length === 0) {
    return "";
  }
  let start = 0;
  while (true) {
    if (start < s.length) {
      const _tmp$38 = start;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (!_M0FP410Haoxincode8moonbash3lib6nyacsv22nyacsv__is__trim__char(ch)) {
        break;
      }
      start = start + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (start >= s.length) {
    return "";
  }
  let end_exclusive = s.length;
  while (true) {
    if (end_exclusive > start) {
      const _tmp$38 = end_exclusive - 1 | 0;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (!_M0FP410Haoxincode8moonbash3lib6nyacsv22nyacsv__is__trim__char(ch)) {
        break;
      }
      end_exclusive = end_exclusive - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = start;
  while (true) {
    const i = _tmp$38;
    if (i < end_exclusive) {
      $bound_check(s, i);
      _M0IPB13StringBuilderPB6Logger11write__char(out, s.charCodeAt(i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib6nyacsv23nyacsv__finalize__field(field, trim_spaces) {
  const raw = field.val;
  return trim_spaces ? _M0FP410Haoxincode8moonbash3lib6nyacsv19nyacsv__trim__field(raw) : raw;
}
function _M0FP410Haoxincode8moonbash3lib6nyacsv13parse_2einnerGRP410Haoxincode8moonbash3lib6nyacsv12StringReaderE(reader, options) {
  const rows = _M0MPC15array5Array11new_2einnerGRPB5ArrayGsEE(0);
  let row = _M0MPC15array5Array11new_2einnerGRP411moonbitlang6regexp8internal2vm6ThreadE(0);
  let field = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let in_quotes = false;
  while (true) {
    if (!(reader.pos >= reader.source.length)) {
      const _p$4 = _M0IP410Haoxincode8moonbash3lib6nyacsv12StringReaderP410Haoxincode8moonbash3lib6nyacsv9CSVReader10read__char(reader);
      let ch = _p$4 === -1 ? $panic() : _p$4;
      if (ch === 13) {
        if (_M0IPC16option6OptionPB2Eq5equalGcE(_M0IP410Haoxincode8moonbash3lib6nyacsv12StringReaderP410Haoxincode8moonbash3lib6nyacsv9CSVReader10peek__char(reader), _M0FP410Haoxincode8moonbash3lib6nyacsv13parse_2einnerN6constrS100GRP410Haoxincode8moonbash3lib6nyacsv12StringReaderE)) {
          if (in_quotes && options.allow_newlines_in_quotes) {
            _M0IPB13StringBuilderPB6Logger11write__char(field, ch);
            _M0IP410Haoxincode8moonbash3lib6nyacsv12StringReaderP410Haoxincode8moonbash3lib6nyacsv9CSVReader10read__char(reader);
            _M0IPB13StringBuilderPB6Logger11write__char(field, 10);
            continue;
          } else {
            continue;
          }
        } else {
          if (options.allow_newlines_in_quotes && in_quotes) {
            _M0IPB13StringBuilderPB6Logger11write__char(field, ch);
            continue;
          } else {
            ch = 10;
          }
        }
      }
      if (in_quotes) {
        if (ch === options.quote_char) {
          if (!(reader.pos >= reader.source.length) && _M0IPC16option6OptionPB2Eq5equalGcE(_M0IP410Haoxincode8moonbash3lib6nyacsv12StringReaderP410Haoxincode8moonbash3lib6nyacsv9CSVReader10peek__char(reader), options.quote_char)) {
            _M0IPB13StringBuilderPB6Logger11write__char(field, options.quote_char);
            _M0IP410Haoxincode8moonbash3lib6nyacsv12StringReaderP410Haoxincode8moonbash3lib6nyacsv9CSVReader10read__char(reader);
          } else {
            in_quotes = false;
          }
        } else {
          if (ch === 10 && !options.allow_newlines_in_quotes) {
            in_quotes = false;
            _M0MPC15array5Array4pushGUssEE(row, _M0FP410Haoxincode8moonbash3lib6nyacsv23nyacsv__finalize__field(field, options.trim_spaces));
            let _tmp$38;
            const _p$5 = row;
            if (!(_p$5.length === 0)) {
              _tmp$38 = true;
            } else {
              _tmp$38 = !options.skip_empty_lines;
            }
            if (_tmp$38) {
              _M0MPC15array5Array4pushGRPB5ArrayGsEE(rows, row);
            }
            row = _M0MPC15array5Array11new_2einnerGRP411moonbitlang6regexp8internal2vm6ThreadE(0);
            field = _M0MPB13StringBuilder21StringBuilder_2einner(0);
          } else {
            _M0IPB13StringBuilderPB6Logger11write__char(field, ch);
          }
        }
      } else {
        if (ch === options.quote_char) {
          const _p$5 = field;
          if (_p$5.val === "") {
            in_quotes = true;
          } else {
            _M0IPB13StringBuilderPB6Logger11write__char(field, ch);
          }
        } else {
          if (ch === options.delimiter) {
            _M0MPC15array5Array4pushGUssEE(row, _M0FP410Haoxincode8moonbash3lib6nyacsv23nyacsv__finalize__field(field, options.trim_spaces));
            field = _M0MPB13StringBuilder21StringBuilder_2einner(0);
          } else {
            if (ch === 10) {
              _M0MPC15array5Array4pushGUssEE(row, _M0FP410Haoxincode8moonbash3lib6nyacsv23nyacsv__finalize__field(field, options.trim_spaces));
              let _tmp$38;
              const _p$5 = row;
              if (!(_p$5.length === 0)) {
                _tmp$38 = true;
              } else {
                _tmp$38 = !options.skip_empty_lines;
              }
              if (_tmp$38) {
                _M0MPC15array5Array4pushGRPB5ArrayGsEE(rows, row);
              }
              row = _M0MPC15array5Array11new_2einnerGRP411moonbitlang6regexp8internal2vm6ThreadE(0);
              field = _M0MPB13StringBuilder21StringBuilder_2einner(0);
            } else {
              _M0IPB13StringBuilderPB6Logger11write__char(field, ch);
            }
          }
        }
      }
      continue;
    } else {
      break;
    }
  }
  let _tmp$38;
  const _p$4 = field;
  if (!(_p$4.val === "")) {
    _tmp$38 = true;
  } else {
    _tmp$38 = row.length > 0;
  }
  if (_tmp$38) {
    _M0MPC15array5Array4pushGUssEE(row, _M0FP410Haoxincode8moonbash3lib6nyacsv23nyacsv__finalize__field(field, options.trim_spaces));
    let _tmp$39;
    const _p$5 = row;
    if (!(_p$5.length === 0)) {
      _tmp$39 = true;
    } else {
      _tmp$39 = !options.skip_empty_lines;
    }
    if (_tmp$39) {
      _M0MPC15array5Array4pushGRPB5ArrayGsEE(rows, row);
    }
  }
  return rows;
}
function _M0MP410Haoxincode8moonbash3lib6nyacsv3CSV5shape(self) {
  const row_count = self.rows.length;
  const column_count = row_count > 0 ? _M0MPC15array5Array2atGRPB5ArrayGsEE(self.rows, 0).length : 0;
  return { _0: row_count, _1: column_count };
}
function _M0MP410Haoxincode8moonbash3lib6nyacsv3CSV3new() {
  const headers = _M0MPC15array5Array11new_2einnerGRP411moonbitlang6regexp8internal2vm6ThreadE(0);
  const rows = _M0MPC15array5Array11new_2einnerGRPB5ArrayGsEE(0);
  return new _M0TP410Haoxincode8moonbash3lib6nyacsv3CSV(headers, rows);
}
function _M0MP410Haoxincode8moonbash3lib6nyacsv3CSV19from__array_2einner(data, has_header, generate_headers) {
  if (data.length === 0) {
    return _M0MP410Haoxincode8moonbash3lib6nyacsv3CSV3new();
  }
  if (has_header) {
    const headers = _M0MPC15array5Array2atGRPB5ArrayGsEE(data, 0);
    const rows = _M0MPC15array5Array11new_2einnerGRPB5ArrayGsEE(0);
    let _tmp$38 = 1;
    while (true) {
      const i = _tmp$38;
      if (i < data.length) {
        _M0MPC15array5Array4pushGRPB5ArrayGsEE(rows, _M0MPC15array5Array2atGRPB5ArrayGsEE(data, i));
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return new _M0TP410Haoxincode8moonbash3lib6nyacsv3CSV(headers, rows);
  }
  if (generate_headers) {
    const column_count = _M0MPC15array5Array2atGRPB5ArrayGsEE(data, 0).length;
    const headers = _M0MPC15array5Array11new_2einnerGRP411moonbitlang6regexp8internal2vm6ThreadE(0);
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < column_count) {
        _M0MPC15array5Array4pushGUssEE(headers, `column${_M0IPC13int3IntPB4Show10to__string(i + 1 | 0)}`);
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return new _M0TP410Haoxincode8moonbash3lib6nyacsv3CSV(headers, data);
  }
  const column_count = _M0MPC15array5Array2atGRPB5ArrayGsEE(data, 0).length;
  const headers = _M0MPC15array5Array11new_2einnerGRP411moonbitlang6regexp8internal2vm6ThreadE(0);
  let _tmp$38 = 0;
  while (true) {
    const _i = _tmp$38;
    if (_i < column_count) {
      _M0MPC15array5Array4pushGUssEE(headers, "");
      _tmp$38 = _i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return new _M0TP410Haoxincode8moonbash3lib6nyacsv3CSV(headers, data);
}
function _M0MP410Haoxincode8moonbash3lib6nyacsv3CSV21parse__string_2einner(data, options) {
  const reader = new _M0TP410Haoxincode8moonbash3lib6nyacsv12StringReader(data, 0);
  return _M0MP410Haoxincode8moonbash3lib6nyacsv3CSV19from__array_2einner(_M0FP410Haoxincode8moonbash3lib6nyacsv13parse_2einnerGRP410Haoxincode8moonbash3lib6nyacsv12StringReaderE(reader, options), true, true);
}
function _M0MP410Haoxincode8moonbash3lib6nyacsv3CSV13parse__string(data, options$46$opt) {
  let options;
  if (options$46$opt === undefined) {
    options = _M0MP410Haoxincode8moonbash3lib6nyacsv3CSV13parse__stringN6recordS102;
  } else {
    const _Some = options$46$opt;
    options = _Some;
  }
  return _M0MP410Haoxincode8moonbash3lib6nyacsv3CSV21parse__string_2einner(data, options);
}
function _M0IP38bobzhang6moonjq3ast16InterpreterErrorPB4Show6output(_x_829, _x_830) {
  switch (_x_829.$tag) {
    case 44: {
      const _TypeMismatch = _x_829;
      const _$42$arg_831 = _TypeMismatch._0;
      const _$42$arg_832 = _TypeMismatch._1;
      _x_830.method_table.method_0(_x_830.self, "TypeMismatch(");
      _M0MPB6Logger13write__objectGsE(_x_830, _$42$arg_831);
      _x_830.method_table.method_0(_x_830.self, ", ");
      _M0MPB6Logger13write__objectGsE(_x_830, _$42$arg_832);
      _x_830.method_table.method_0(_x_830.self, ")");
      return;
    }
    case 43: {
      const _KeyNotFound = _x_829;
      const _$42$arg_833 = _KeyNotFound._0;
      _x_830.method_table.method_0(_x_830.self, "KeyNotFound(");
      _M0MPB6Logger13write__objectGsE(_x_830, _$42$arg_833);
      _x_830.method_table.method_0(_x_830.self, ")");
      return;
    }
    case 42: {
      const _IndexOutOfBounds = _x_829;
      const _$42$arg_834 = _IndexOutOfBounds._0;
      _x_830.method_table.method_0(_x_830.self, "IndexOutOfBounds(");
      _M0MPB6Logger13write__objectGiE(_x_830, _$42$arg_834);
      _x_830.method_table.method_0(_x_830.self, ")");
      return;
    }
    case 41: {
      const _InvalidOperation = _x_829;
      const _$42$arg_835 = _InvalidOperation._0;
      _x_830.method_table.method_0(_x_830.self, "InvalidOperation(");
      _M0MPB6Logger13write__objectGsE(_x_830, _$42$arg_835);
      _x_830.method_table.method_0(_x_830.self, ")");
      return;
    }
    case 40: {
      _x_830.method_table.method_0(_x_830.self, "DivisionByZero");
      return;
    }
    case 39: {
      const _TypeError = _x_829;
      const _$42$arg_836 = _TypeError._0;
      _x_830.method_table.method_0(_x_830.self, "TypeError(");
      _M0MPB6Logger13write__objectGsE(_x_830, _$42$arg_836);
      _x_830.method_table.method_0(_x_830.self, ")");
      return;
    }
    default: {
      const _EvalError = _x_829;
      const _$42$arg_837 = _EvalError._0;
      _x_830.method_table.method_0(_x_830.self, "EvalError(");
      _M0MPB6Logger13write__objectGsE(_x_830, _$42$arg_837);
      _x_830.method_table.method_0(_x_830.self, ")");
      return;
    }
  }
}
function _M0FP38bobzhang6moonjq3ast16json__type__name(json) {
  switch (json.$tag) {
    case 0: {
      return "null";
    }
    case 1: {
      return "boolean";
    }
    case 2: {
      return "boolean";
    }
    case 3: {
      return "number";
    }
    case 4: {
      return "string";
    }
    case 5: {
      return "array";
    }
    default: {
      return "object";
    }
  }
}
function _M0MP38bobzhang6moonjq3ast3Env3new() {
  const _bind$4 = [];
  const _tmp$38 = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$4, 0, 0), undefined);
  const _bind$5 = [];
  return new _M0TP38bobzhang6moonjq3ast3Env(_tmp$38, _M0MPB3Map3MapGsURP38bobzhang6moonjq3ast4ExprRPB5ArrayGsEEE(new _M0TPB9ArrayViewGUsURP38bobzhang6moonjq3ast4ExprRPB5ArrayGsEEEE(_bind$5, 0, 0), undefined));
}
function _M0MP38bobzhang6moonjq3ast3Env3get(self, name) {
  return _M0MPB3Map3getGsRPB4JsonE(self.bindings, name);
}
function _M0MP38bobzhang6moonjq3ast3Env3set(self, name, value) {
  const _bind$4 = [];
  const new_bindings = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$4, 0, 0), undefined);
  const _it = _M0MPB3Map5iter2GssE(self.bindings);
  while (true) {
    const _bind$5 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$5 === undefined) {
      break;
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      const _k = _x._0;
      const _v = _x._1;
      _M0MPB3Map3setGsRPB4JsonE(new_bindings, _k, _v);
      continue;
    }
  }
  _M0MPB3Map3setGsRPB4JsonE(new_bindings, name, value);
  return new _M0TP38bobzhang6moonjq3ast3Env(new_bindings, self.functions);
}
function _M0MP38bobzhang6moonjq3ast3Env13set__function(self, name, body, params) {
  const _bind$4 = [];
  const new_bindings = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$4, 0, 0), undefined);
  const _it = _M0MPB3Map5iter2GssE(self.bindings);
  while (true) {
    const _bind$5 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$5 === undefined) {
      break;
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      const _k = _x._0;
      const _v = _x._1;
      _M0MPB3Map3setGsRPB4JsonE(new_bindings, _k, _v);
      continue;
    }
  }
  const _bind$5 = [];
  const new_funcs = _M0MPB3Map3MapGsURP38bobzhang6moonjq3ast4ExprRPB5ArrayGsEEE(new _M0TPB9ArrayViewGUsURP38bobzhang6moonjq3ast4ExprRPB5ArrayGsEEEE(_bind$5, 0, 0), undefined);
  const _it$2 = _M0MPB3Map5iter2GssE(self.functions);
  while (true) {
    const _bind$6 = _M0MPB5Iter24nextGssE(_it$2);
    if (_bind$6 === undefined) {
      break;
    } else {
      const _Some = _bind$6;
      const _x = _Some;
      const _k = _x._0;
      const _v = _x._1;
      _M0MPB3Map3setGsURP38bobzhang6moonjq3ast4ExprRPB5ArrayGsEEE(new_funcs, _k, _v);
      continue;
    }
  }
  _M0MPB3Map3setGsURP38bobzhang6moonjq3ast4ExprRPB5ArrayGsEEE(new_funcs, name, { _0: body, _1: params });
  return new _M0TP38bobzhang6moonjq3ast3Env(new_bindings, new_funcs);
}
function _M0MP38bobzhang6moonjq3ast3Env13get__function(self, name) {
  return _M0MPB3Map3getGsURP38bobzhang6moonjq3ast4ExprRPB5ArrayGsEEE(self.functions, name);
}
function _M0FP38bobzhang6moonjq3ast14base64__decodeN13base64__valueS3(_env, ch) {
  const constr = _env._1;
  const constr$2 = _env._0;
  return ch >= 65 && ch <= 90 ? ch - 65 | 0 : ch >= 97 && ch <= 122 ? (26 + ch | 0) - 97 | 0 : ch >= 48 && ch <= 57 ? (52 + ch | 0) - 48 | 0 : ch === 43 ? constr : ch === 47 ? constr$2 : undefined;
}
function _M0FP38bobzhang6moonjq3ast14base64__decode(s) {
  const len = s.length;
  if ((len % 4 | 0) !== 0) {
    return new _M0DTPC16result6ResultGzRP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error54bobzhang_2fmoonjq_2fast_2eInterpreterError_2eEvalError("Invalid base64"));
  }
  const _env = { _0: _M0FP38bobzhang6moonjq3ast14base64__decodeN6constrS5186, _1: _M0FP38bobzhang6moonjq3ast14base64__decodeN6constrS5185 };
  const buf = [];
  let i = 0;
  while (true) {
    if (i < len) {
      const _p$4 = _M0MPC16string6String9get__char(s, i);
      const c1 = _p$4 === -1 ? $panic() : _p$4;
      const _p$5 = _M0MPC16string6String9get__char(s, i + 1 | 0);
      const c2 = _p$5 === -1 ? $panic() : _p$5;
      const _p$6 = _M0MPC16string6String9get__char(s, i + 2 | 0);
      const c3 = _p$6 === -1 ? $panic() : _p$6;
      const _p$7 = _M0MPC16string6String9get__char(s, i + 3 | 0);
      const c4 = _p$7 === -1 ? $panic() : _p$7;
      const _bind$4 = _M0FP38bobzhang6moonjq3ast14base64__decodeN13base64__valueS3(_env, c1);
      let v1;
      if (_bind$4 === undefined) {
        return new _M0DTPC16result6ResultGzRP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error54bobzhang_2fmoonjq_2fast_2eInterpreterError_2eEvalError("Invalid base64"));
      } else {
        const _Some = _bind$4;
        v1 = _Some;
      }
      const _bind$5 = _M0FP38bobzhang6moonjq3ast14base64__decodeN13base64__valueS3(_env, c2);
      let v2;
      if (_bind$5 === undefined) {
        return new _M0DTPC16result6ResultGzRP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error54bobzhang_2fmoonjq_2fast_2eInterpreterError_2eEvalError("Invalid base64"));
      } else {
        const _Some = _bind$5;
        v2 = _Some;
      }
      if ((c3 === 61 || c4 === 61) && (i + 4 | 0) !== len) {
        return new _M0DTPC16result6ResultGzRP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error54bobzhang_2fmoonjq_2fast_2eInterpreterError_2eEvalError("Invalid base64"));
      }
      const v1u = v1;
      const v2u = v2;
      const b1 = v1u << 2 | (v2u >>> 4 | 0);
      _M0MPC15array5Array4pushGyE(buf, b1 & 255);
      if (c3 !== 61) {
        const _bind$6 = _M0FP38bobzhang6moonjq3ast14base64__decodeN13base64__valueS3(_env, c3);
        let v3;
        if (_bind$6 === undefined) {
          return new _M0DTPC16result6ResultGzRP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error54bobzhang_2fmoonjq_2fast_2eInterpreterError_2eEvalError("Invalid base64"));
        } else {
          const _Some = _bind$6;
          v3 = _Some;
        }
        const v3u = v3;
        const b2 = (v2u & 15) << 4 | (v3u >>> 2 | 0);
        _M0MPC15array5Array4pushGyE(buf, b2 & 255);
        if (c4 !== 61) {
          const _bind$7 = _M0FP38bobzhang6moonjq3ast14base64__decodeN13base64__valueS3(_env, c4);
          let v4;
          if (_bind$7 === undefined) {
            return new _M0DTPC16result6ResultGzRP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error54bobzhang_2fmoonjq_2fast_2eInterpreterError_2eEvalError("Invalid base64"));
          } else {
            const _Some = _bind$7;
            v4 = _Some;
          }
          const v4u = v4;
          const b3 = (v3u & 3) << 6 | v4u;
          _M0MPC15array5Array4pushGyE(buf, b3 & 255);
        }
      } else {
        if (c4 !== 61) {
          return new _M0DTPC16result6ResultGzRP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error54bobzhang_2fmoonjq_2fast_2eInterpreterError_2eEvalError("Invalid base64"));
        }
      }
      i = i + 4 | 0;
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGzRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPC15bytes5Bytes11from__array(new _M0TPB9ArrayViewGyE(buf, 0, buf.length)));
}
function _M0FP38bobzhang6moonjq3ast14base64__encode(bytes) {
  const buf = _M0FPC16buffer11new_2einner(0);
  const len = bytes.length;
  let i = 0;
  while (true) {
    if (i < len) {
      const _tmp$38 = i;
      $bound_check(bytes, _tmp$38);
      const _p$4 = bytes[_tmp$38];
      const b1 = _p$4;
      let b2;
      if ((i + 1 | 0) < len) {
        const _tmp$39 = i + 1 | 0;
        $bound_check(bytes, _tmp$39);
        const _p$5 = bytes[_tmp$39];
        b2 = _p$5;
      } else {
        b2 = 0;
      }
      let b3;
      if ((i + 2 | 0) < len) {
        const _tmp$39 = i + 2 | 0;
        $bound_check(bytes, _tmp$39);
        const _p$5 = bytes[_tmp$39];
        b3 = _p$5;
      } else {
        b3 = 0;
      }
      const c1 = b1 >>> 2 | 0;
      const c2 = (b1 & 3) << 4 | (b2 >>> 4 | 0);
      const c3 = (b2 & 15) << 2 | (b3 >>> 6 | 0);
      const c4 = b3 & 63;
      const _p$5 = _M0MPC16string6String9get__char(_M0FP38bobzhang6moonjq3ast14base64__encodeN5charsS27, c1);
      _M0IPC16buffer6BufferPB6Logger11write__char(buf, _p$5 === -1 ? $panic() : _p$5);
      const _p$6 = _M0MPC16string6String9get__char(_M0FP38bobzhang6moonjq3ast14base64__encodeN5charsS27, c2);
      _M0IPC16buffer6BufferPB6Logger11write__char(buf, _p$6 === -1 ? $panic() : _p$6);
      if ((i + 1 | 0) < len) {
        const _p$7 = _M0MPC16string6String9get__char(_M0FP38bobzhang6moonjq3ast14base64__encodeN5charsS27, c3);
        _M0IPC16buffer6BufferPB6Logger11write__char(buf, _p$7 === -1 ? $panic() : _p$7);
      } else {
        _M0IPC16buffer6BufferPB6Logger11write__char(buf, 61);
      }
      if ((i + 2 | 0) < len) {
        const _p$7 = _M0MPC16string6String9get__char(_M0FP38bobzhang6moonjq3ast14base64__encodeN5charsS27, c4);
        _M0IPC16buffer6BufferPB6Logger11write__char(buf, _p$7 === -1 ? $panic() : _p$7);
      } else {
        _M0IPC16buffer6BufferPB6Logger11write__char(buf, 61);
      }
      i = i + 3 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0IP016_24default__implPB4Show10to__stringGRPC16buffer6BufferE(buf);
}
function _M0FP38bobzhang6moonjq3ast13compare__json(a, b) {
  if (a.$tag === 0) {
    if (b.$tag === 0) {
      return 0;
    } else {
      return -1;
    }
  } else {
    if (b.$tag === 0) {
      return 1;
    } else {
      switch (a.$tag) {
        case 2: {
          switch (b.$tag) {
            case 2: {
              return 0;
            }
            case 1: {
              return -1;
            }
            case 3: {
              return -1;
            }
            default: {
              return 0;
            }
          }
        }
        case 1: {
          switch (b.$tag) {
            case 2: {
              return 1;
            }
            case 1: {
              return 0;
            }
            case 3: {
              return -1;
            }
            default: {
              return 0;
            }
          }
        }
        case 3: {
          const _Number = a;
          const _x = _Number._0;
          switch (b.$tag) {
            case 3: {
              const _Number$2 = b;
              const _y = _Number$2._0;
              return $compare_float(_x, _y);
            }
            case 2: {
              return 1;
            }
            case 1: {
              return 1;
            }
            case 4: {
              return -1;
            }
            default: {
              return 0;
            }
          }
        }
        case 4: {
          const _String = a;
          const _x$2 = _String._0;
          switch (b.$tag) {
            case 4: {
              const _String$2 = b;
              const _y$2 = _String$2._0;
              return _M0IPC16string6StringPB7Compare7compare(_x$2, _y$2);
            }
            case 3: {
              return 1;
            }
            case 5: {
              return -1;
            }
            default: {
              return 0;
            }
          }
        }
        case 5: {
          const _Array = a;
          const _x$3 = _Array._0;
          switch (b.$tag) {
            case 5: {
              const _Array$2 = b;
              const _y$3 = _Array$2._0;
              const min_len = _x$3.length < _y$3.length ? _x$3.length : _y$3.length;
              let _tmp$38 = 0;
              while (true) {
                const i = _tmp$38;
                if (i < min_len) {
                  const cmp = _M0FP38bobzhang6moonjq3ast13compare__json(_M0MPC15array5Array2atGUssEE(_x$3, i), _M0MPC15array5Array2atGUssEE(_y$3, i));
                  if (cmp !== 0) {
                    return cmp;
                  }
                  _tmp$38 = i + 1 | 0;
                  continue;
                } else {
                  break;
                }
              }
              return $compare_int(_x$3.length, _y$3.length);
            }
            case 4: {
              return 1;
            }
            case 6: {
              return -1;
            }
            default: {
              return 0;
            }
          }
        }
        default: {
          switch (b.$tag) {
            case 5: {
              return 1;
            }
            case 6: {
              return 0;
            }
            default: {
              return 0;
            }
          }
        }
      }
    }
  }
}
function _M0FP38bobzhang6moonjq3ast16delete__at__path(root, path) {
  if (path.length === 0) {
    return _M0DTPB4Json4Null__;
  }
  if (path.length === 1) {
    const segment = _M0MPC15array5Array2atGUssEE(path, 0);
    _L: {
      switch (root.$tag) {
        case 6: {
          const _Object = root;
          const _obj = _Object._0;
          if (segment.$tag === 4) {
            const _String = segment;
            const _key = _String._0;
            const _bind$4 = _M0MPB4Iter9to__arrayGRPB4JsonE(_M0MPB3Map4iterGssE(_obj));
            const new_obj = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$4, 0, _bind$4.length), undefined);
            _M0MPB3Map6removeGsRPB4JsonE(new_obj, _key);
            return new _M0DTPB4Json6Object(new_obj);
          } else {
            break _L;
          }
        }
        case 5: {
          const _Array = root;
          const _arr = _Array._0;
          if (segment.$tag === 3) {
            const _Number = segment;
            const _idx = _Number._0;
            const i = _M0MPC16double6Double7to__int(_idx);
            if (i >= 0 && i < _arr.length) {
              const new_arr = [];
              let _tmp$38 = 0;
              while (true) {
                const j = _tmp$38;
                if (j < _arr.length) {
                  if (j !== i) {
                    _M0MPC15array5Array4pushGUssEE(new_arr, _M0MPC15array5Array2atGUssEE(_arr, j));
                  }
                  _tmp$38 = j + 1 | 0;
                  continue;
                } else {
                  break;
                }
              }
              return new _M0DTPB4Json5Array(new_arr);
            } else {
              return root;
            }
          } else {
            break _L;
          }
        }
        default: {
          break _L;
        }
      }
    }
    return root;
  } else {
    const segment = _M0MPC15array5Array2atGUssEE(path, 0);
    const remaining = _M0MPC15array5Array12view_2einnerGsE(path, 1, undefined);
    _L: {
      switch (root.$tag) {
        case 6: {
          const _Object = root;
          const _obj = _Object._0;
          if (segment.$tag === 4) {
            const _String = segment;
            const _key = _String._0;
            const _bind$4 = _M0MPB4Iter9to__arrayGRPB4JsonE(_M0MPB3Map4iterGssE(_obj));
            const new_obj = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$4, 0, _bind$4.length), undefined);
            const _bind$5 = _M0MPB3Map3getGsRPB4JsonE(_obj, _key);
            if (_bind$5 === undefined) {
            } else {
              const _Some = _bind$5;
              const _current = _Some;
              _M0MPB3Map3setGsRPB4JsonE(new_obj, _key, _M0FP38bobzhang6moonjq3ast16delete__at__path(_current, _M0MPC15array9ArrayView9to__ownedGRPB4JsonE(remaining)));
            }
            return new _M0DTPB4Json6Object(new_obj);
          } else {
            break _L;
          }
        }
        case 5: {
          const _Array = root;
          const _arr = _Array._0;
          if (segment.$tag === 3) {
            const _Number = segment;
            const _idx = _Number._0;
            const i = _M0MPC16double6Double7to__int(_idx);
            if (i >= 0 && i < _arr.length) {
              const new_arr = _M0MPC15array5Array4copyGRPB4JsonE(_arr);
              _M0MPC15array5Array3setGsE(new_arr, i, _M0FP38bobzhang6moonjq3ast16delete__at__path(_M0MPC15array5Array2atGUssEE(_arr, i), _M0MPC15array9ArrayView9to__ownedGRPB4JsonE(remaining)));
              return new _M0DTPB4Json5Array(new_arr);
            } else {
              return root;
            }
          } else {
            break _L;
          }
        }
        default: {
          break _L;
        }
      }
    }
    return root;
  }
}
function _M0FP38bobzhang6moonjq3ast9json__add(left, right) {
  _L: {
    switch (left.$tag) {
      case 3: {
        const _Number = left;
        const _a = _Number._0;
        if (right.$tag === 3) {
          const _Number$2 = right;
          const _b = _Number$2._0;
          const _p$4 = _a + _b;
          const _p$5 = undefined;
          return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(new _M0DTPB4Json6Number(_p$4, _p$5));
        } else {
          break _L;
        }
      }
      case 4: {
        const _String = left;
        const _a$2 = _String._0;
        if (right.$tag === 4) {
          const _String$2 = right;
          const _b = _String$2._0;
          const _p$4 = `${_a$2}${_b}`;
          return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(new _M0DTPB4Json6String(_p$4));
        } else {
          break _L;
        }
      }
      case 5: {
        const _Array = left;
        const _a$3 = _Array._0;
        if (right.$tag === 5) {
          const _Array$2 = right;
          const _b = _Array$2._0;
          const _p$4 = _M0IPC15array5ArrayPB3Add3addGsE(_a$3, _b);
          return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(new _M0DTPB4Json5Array(_p$4));
        } else {
          break _L;
        }
      }
      case 6: {
        const _Object = left;
        const _a$4 = _Object._0;
        if (right.$tag === 6) {
          const _Object$2 = right;
          const _b = _Object$2._0;
          const _it = _M0MPB3Map5iter2GssE(_b);
          while (true) {
            const _bind$4 = _M0MPB5Iter24nextGssE(_it);
            if (_bind$4 === undefined) {
              break;
            } else {
              const _Some = _bind$4;
              const _x = _Some;
              const _k = _x._0;
              const _v = _x._1;
              _M0MPB3Map3setGsRPB4JsonE(_a$4, _k, _v);
              continue;
            }
          }
          return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(new _M0DTPB4Json6Object(_a$4));
        } else {
          break _L;
        }
      }
      default: {
        break _L;
      }
    }
  }
  return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error61bobzhang_2fmoonjq_2fast_2eInterpreterError_2eInvalidOperation(`Cannot add ${_M0FP38bobzhang6moonjq3ast16json__type__name(left)} and ${_M0FP38bobzhang6moonjq3ast16json__type__name(right)}`));
}
function _M0FP38bobzhang6moonjq3ast12json__divide(left, right) {
  _L: {
    if (left.$tag === 3) {
      const _Number = left;
      const _a = _Number._0;
      if (right.$tag === 3) {
        const _Number$2 = right;
        const _b = _Number$2._0;
        if (_b === 0) {
          return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE3Err(_M0DTPC15error5Error59bobzhang_2fmoonjq_2fast_2eInterpreterError_2eDivisionByZero__);
        }
        const _p$4 = _a / _b;
        const _p$5 = undefined;
        return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(new _M0DTPB4Json6Number(_p$4, _p$5));
      } else {
        break _L;
      }
    } else {
      break _L;
    }
  }
  return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error61bobzhang_2fmoonjq_2fast_2eInterpreterError_2eInvalidOperation(`Cannot divide ${_M0FP38bobzhang6moonjq3ast16json__type__name(left)} by ${_M0FP38bobzhang6moonjq3ast16json__type__name(right)}`));
}
function _M0FP38bobzhang6moonjq3ast12json__modulo(left, right) {
  _L: {
    if (left.$tag === 3) {
      const _Number = left;
      const _a = _Number._0;
      if (right.$tag === 3) {
        const _Number$2 = right;
        const _b = _Number$2._0;
        if (_b === 0) {
          return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE3Err(_M0DTPC15error5Error59bobzhang_2fmoonjq_2fast_2eInterpreterError_2eDivisionByZero__);
        }
        const _p$4 = _M0IPC16double6DoublePB3Mod3mod(_a, _b);
        const _p$5 = undefined;
        return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(new _M0DTPB4Json6Number(_p$4, _p$5));
      } else {
        break _L;
      }
    } else {
      break _L;
    }
  }
  return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error61bobzhang_2fmoonjq_2fast_2eInterpreterError_2eInvalidOperation(`Cannot modulo ${_M0FP38bobzhang6moonjq3ast16json__type__name(left)} by ${_M0FP38bobzhang6moonjq3ast16json__type__name(right)}`));
}
function _M0FP38bobzhang6moonjq3ast14json__multiply(left, right) {
  _L: {
    let n;
    let s;
    _L$2: {
      switch (left.$tag) {
        case 3: {
          const _Number = left;
          const _a = _Number._0;
          switch (right.$tag) {
            case 3: {
              const _Number$2 = right;
              const _b = _Number$2._0;
              const _p$4 = _a * _b;
              const _p$5 = undefined;
              return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(new _M0DTPB4Json6Number(_p$4, _p$5));
            }
            case 4: {
              const _String = right;
              const _s = _String._0;
              n = _a;
              s = _s;
              break _L$2;
            }
            default: {
              break _L;
            }
          }
        }
        case 4: {
          const _String$2 = left;
          const _s$2 = _String$2._0;
          if (right.$tag === 3) {
            const _Number$3 = right;
            const _n = _Number$3._0;
            n = _n;
            s = _s$2;
            break _L$2;
          } else {
            break _L;
          }
        }
        default: {
          break _L;
        }
      }
    }
    const count = _M0MPC16double6Double7to__int(n);
    let result = "";
    let _tmp$38 = 0;
    while (true) {
      const _i = _tmp$38;
      if (_i < count) {
        result = `${result}${s}`;
        _tmp$38 = _i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    const _p$4 = result;
    return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(new _M0DTPB4Json6String(_p$4));
  }
  return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error61bobzhang_2fmoonjq_2fast_2eInterpreterError_2eInvalidOperation(`Cannot multiply ${_M0FP38bobzhang6moonjq3ast16json__type__name(left)} and ${_M0FP38bobzhang6moonjq3ast16json__type__name(right)}`));
}
function _M0FP38bobzhang6moonjq3ast14json__subtract(left, right) {
  _L: {
    switch (left.$tag) {
      case 3: {
        const _Number = left;
        const _a = _Number._0;
        if (right.$tag === 3) {
          const _Number$2 = right;
          const _b = _Number$2._0;
          const _p$4 = _a - _b;
          const _p$5 = undefined;
          return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(new _M0DTPB4Json6Number(_p$4, _p$5));
        } else {
          break _L;
        }
      }
      case 5: {
        const _Array = left;
        const _a$2 = _Array._0;
        if (right.$tag === 5) {
          const _Array$2 = right;
          const _b = _Array$2._0;
          let result = [];
          const _bind$4 = _a$2.length;
          let _tmp$38 = 0;
          while (true) {
            const _ = _tmp$38;
            if (_ < _bind$4) {
              const elem = _a$2[_];
              let found = false;
              const _bind$5 = _b.length;
              let _tmp$39 = 0;
              while (true) {
                const _$2 = _tmp$39;
                if (_$2 < _bind$5) {
                  const r = _b[_$2];
                  if (_M0FP38bobzhang6moonjq3ast13compare__json(elem, r) === 0) {
                    found = true;
                    break;
                  }
                  _tmp$39 = _$2 + 1 | 0;
                  continue;
                } else {
                  break;
                }
              }
              if (!found) {
                result = _M0IPC15array5ArrayPB3Add3addGsE(result, [elem]);
              }
              _tmp$38 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          const _p$4 = result;
          return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(new _M0DTPB4Json5Array(_p$4));
        } else {
          break _L;
        }
      }
      default: {
        break _L;
      }
    }
  }
  return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error61bobzhang_2fmoonjq_2fast_2eInterpreterError_2eInvalidOperation(`Cannot subtract ${_M0FP38bobzhang6moonjq3ast16json__type__name(right)} from ${_M0FP38bobzhang6moonjq3ast16json__type__name(left)}`));
}
function _M0FP38bobzhang6moonjq3ast16eval__binary__op(op, left, right) {
  switch (op) {
    case 0: {
      return _M0FP38bobzhang6moonjq3ast9json__add(left, right);
    }
    case 1: {
      return _M0FP38bobzhang6moonjq3ast14json__subtract(left, right);
    }
    case 2: {
      return _M0FP38bobzhang6moonjq3ast14json__multiply(left, right);
    }
    case 3: {
      return _M0FP38bobzhang6moonjq3ast12json__divide(left, right);
    }
    case 4: {
      return _M0FP38bobzhang6moonjq3ast12json__modulo(left, right);
    }
    case 5: {
      const _p$4 = _M0FP38bobzhang6moonjq3ast13compare__json(left, right) === 0;
      return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_p$4 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__);
    }
    case 6: {
      const _p$5 = _M0FP38bobzhang6moonjq3ast13compare__json(left, right) !== 0;
      return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_p$5 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__);
    }
    case 7: {
      const _p$6 = _M0FP38bobzhang6moonjq3ast13compare__json(left, right) < 0;
      return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_p$6 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__);
    }
    case 8: {
      const _p$7 = _M0FP38bobzhang6moonjq3ast13compare__json(left, right) <= 0;
      return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_p$7 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__);
    }
    case 9: {
      const _p$8 = _M0FP38bobzhang6moonjq3ast13compare__json(left, right) > 0;
      return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_p$8 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__);
    }
    case 10: {
      const _p$9 = _M0FP38bobzhang6moonjq3ast13compare__json(left, right) >= 0;
      return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_p$9 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__);
    }
    case 11: {
      let left_truthy;
      switch (left.$tag) {
        case 2: {
          left_truthy = false;
          break;
        }
        case 0: {
          left_truthy = false;
          break;
        }
        default: {
          left_truthy = true;
        }
      }
      if (left_truthy) {
        return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(right);
      } else {
        const _p$10 = false;
        return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_p$10 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__);
      }
    }
    default: {
      let left_truthy$2;
      switch (left.$tag) {
        case 2: {
          left_truthy$2 = false;
          break;
        }
        case 0: {
          left_truthy$2 = false;
          break;
        }
        default: {
          left_truthy$2 = true;
        }
      }
      return left_truthy$2 ? new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(left) : new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(right);
    }
  }
}
function _M0FP38bobzhang6moonjq3ast13eval__literal(lit) {
  switch (lit.$tag) {
    case 0: {
      return _M0DTPB4Json4Null__;
    }
    case 1: {
      const _Bool = lit;
      const _b = _Bool._0;
      return _b ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__;
    }
    case 2: {
      const _Number = lit;
      const _n = _Number._0;
      const _p$4 = undefined;
      return new _M0DTPB4Json6Number(_n, _p$4);
    }
    default: {
      const _String = lit;
      const _s = _String._0;
      return new _M0DTPB4Json6String(_s);
    }
  }
}
function _M0FP38bobzhang6moonjq3ast14flatten__array(arr, depth) {
  if (depth <= 0) {
    return arr;
  }
  let result = [];
  const _bind$4 = arr.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const elem = arr[_];
      if (elem.$tag === 5) {
        const _Array = elem;
        const _inner = _Array._0;
        result = _M0IPC15array5ArrayPB3Add3addGsE(result, _M0FP38bobzhang6moonjq3ast14flatten__array(_inner, depth - 1 | 0));
      } else {
        result = _M0IPC15array5ArrayPB3Add3addGsE(result, [elem]);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return result;
}
function _M0FP38bobzhang6moonjq3ast12html__escape(s) {
  const buf = _M0FPC16buffer11new_2einner(0);
  const _it = _M0MPC16string6String4iter(s);
  while (true) {
    const _bind$4 = _M0MPB4Iter4nextGcE(_it);
    if (_bind$4 === -1) {
      break;
    } else {
      const _Some = _bind$4;
      const _char = _Some;
      switch (_char) {
        case 60: {
          _M0IPC16buffer6BufferPB6Logger13write__string(buf, "&lt;");
          break;
        }
        case 62: {
          _M0IPC16buffer6BufferPB6Logger13write__string(buf, "&gt;");
          break;
        }
        case 38: {
          _M0IPC16buffer6BufferPB6Logger13write__string(buf, "&amp;");
          break;
        }
        case 34: {
          _M0IPC16buffer6BufferPB6Logger13write__string(buf, "&quot;");
          break;
        }
        case 39: {
          _M0IPC16buffer6BufferPB6Logger13write__string(buf, "&#39;");
          break;
        }
        default: {
          _M0IPC16buffer6BufferPB6Logger11write__char(buf, _char);
        }
      }
      continue;
    }
  }
  return _M0IP016_24default__implPB4Show10to__stringGRPC16buffer6BufferE(buf);
}
function _M0FP38bobzhang6moonjq3ast12recurse__all(input) {
  switch (input.$tag) {
    case 5: {
      const _Array = input;
      const _arr = _Array._0;
      return _M0MPB4Iter6concatGRPB4JsonE(_M0MPB4Iter9singletonGRPB4JsonE(input), _M0MPB4Iter9flat__mapGRPB4IterGRPB4JsonERPB4JsonE(_M0MPC15array5Array4iterGsE(_arr), _M0FP38bobzhang6moonjq3ast12recurse__all));
    }
    case 6: {
      const _Object = input;
      const _obj = _Object._0;
      let values = [];
      const _it = _M0MPB3Map5iter2GssE(_obj);
      while (true) {
        const _bind$4 = _M0MPB5Iter24nextGssE(_it);
        if (_bind$4 === undefined) {
          break;
        } else {
          const _Some = _bind$4;
          const _x = _Some;
          const _v = _x._1;
          values = _M0IPC15array5ArrayPB3Add3addGsE(values, [_v]);
          continue;
        }
      }
      return _M0MPB4Iter6concatGRPB4JsonE(_M0MPB4Iter9singletonGRPB4JsonE(input), _M0MPB4Iter9flat__mapGRPB4IterGRPB4JsonERPB4JsonE(_M0MPC15array5Array4iterGsE(values), _M0FP38bobzhang6moonjq3ast12recurse__all));
    }
    default: {
      return _M0MPB4Iter9singletonGRPB4JsonE(input);
    }
  }
}
function _M0FP38bobzhang6moonjq3ast13set__at__path(root, path, value) {
  if (path.length === 0) {
    return value;
  }
  const segment = _M0MPC15array5Array2atGUssEE(path, 0);
  const remaining = _M0MPC15array5Array12view_2einnerGsE(path, 1, undefined);
  _L: {
    switch (root.$tag) {
      case 6: {
        const _Object = root;
        const _obj = _Object._0;
        if (segment.$tag === 4) {
          const _String = segment;
          const _key = _String._0;
          const _bind$4 = _M0MPB4Iter9to__arrayGRPB4JsonE(_M0MPB3Map4iterGssE(_obj));
          const new_obj = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$4, 0, _bind$4.length), undefined);
          if ((remaining.end - remaining.start | 0) === 0) {
            _M0MPB3Map3setGsRPB4JsonE(new_obj, _key, value);
          } else {
            const _p$4 = _M0MPB3Map3getGsRPB4JsonE(_obj, _key);
            const _p$5 = _M0DTPB4Json4Null__;
            let current;
            if (_p$4 === undefined) {
              current = _p$5;
            } else {
              const _p$6 = _p$4;
              current = _p$6;
            }
            _M0MPB3Map3setGsRPB4JsonE(new_obj, _key, _M0FP38bobzhang6moonjq3ast13set__at__path(current, _M0MPC15array9ArrayView9to__ownedGRPB4JsonE(remaining), value));
          }
          return new _M0DTPB4Json6Object(new_obj);
        } else {
          break _L;
        }
      }
      case 5: {
        const _Array = root;
        const _arr = _Array._0;
        if (segment.$tag === 3) {
          const _Number = segment;
          const _idx = _Number._0;
          const i = _M0MPC16double6Double7to__int(_idx);
          if (i >= 0 && i < _arr.length) {
            const new_arr = _M0MPC15array5Array4copyGRPB4JsonE(_arr);
            if ((remaining.end - remaining.start | 0) === 0) {
              _M0MPC15array5Array3setGsE(new_arr, i, value);
            } else {
              _M0MPC15array5Array3setGsE(new_arr, i, _M0FP38bobzhang6moonjq3ast13set__at__path(_M0MPC15array5Array2atGUssEE(_arr, i), _M0MPC15array9ArrayView9to__ownedGRPB4JsonE(remaining), value));
            }
            return new _M0DTPB4Json5Array(new_arr);
          } else {
            return root;
          }
        } else {
          break _L;
        }
      }
      default: {
        break _L;
      }
    }
  }
  return root;
}
function _M0FP38bobzhang6moonjq3ast11uri__encodeN17hex__upper__digitS45(n) {
  const _p$4 = _M0MPC16string6String9get__char(_M0FP38bobzhang6moonjq3ast11uri__encodeN6digitsS47, n);
  return _p$4 === -1 ? $panic() : _p$4;
}
function _M0FP38bobzhang6moonjq3ast11uri__encode(s) {
  const bytes = _M0FPC28encoding4utf814encode_2einner(new _M0TPC16string10StringView(s, 0, s.length), false);
  const buf = _M0FPC16buffer11new_2einner(0);
  const _bind$4 = bytes.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const b = bytes[_];
      const code = b;
      if (code >= 65 && code <= 90 ? true : code >= 97 && code <= 122 ? true : code >= 48 && code <= 57 ? true : code === 45 ? true : code === 95 ? true : code === 46 ? true : code === 126) {
        _M0IPC16buffer6BufferPB6Logger11write__char(buf, b);
      } else {
        const code$2 = b;
        _M0IPC16buffer6BufferPB6Logger11write__char(buf, 37);
        _M0IPC16buffer6BufferPB6Logger11write__char(buf, _M0FP38bobzhang6moonjq3ast11uri__encodeN17hex__upper__digitS45(code$2 >> 4 & 15));
        _M0IPC16buffer6BufferPB6Logger11write__char(buf, _M0FP38bobzhang6moonjq3ast11uri__encodeN17hex__upper__digitS45(code$2 & 15));
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0IP016_24default__implPB4Show10to__stringGRPC16buffer6BufferE(buf);
}
function _M0FP38bobzhang6moonjq3ast15eval__with__envN13apply__updateS390(env, obj, p, upd) {
  let _tmp$38 = obj;
  let _tmp$39 = p;
  _L: while (true) {
    const obj$2 = _tmp$38;
    const p$2 = _tmp$39;
    switch (p$2.$tag) {
      case 0: {
        const _bind$4 = _M0FP38bobzhang6moonjq3ast15eval__with__env(upd, obj$2, env);
        let _tmp$40;
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          _tmp$40 = _ok._0;
        } else {
          return _bind$4;
        }
        const results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$40);
        return results.length === 0 ? new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(obj$2) : new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPC15array5Array2atGUssEE(results, 0));
      }
      case 4: {
        const _Key = p$2;
        const _key = _Key._0;
        if (obj$2.$tag === 6) {
          const _Object = obj$2;
          const _map = _Object._0;
          const _bind$5 = _M0MPB3Map3getGsRPB4JsonE(_map, _key);
          let current;
          if (_bind$5 === undefined) {
            current = _M0DTPB4Json4Null__;
          } else {
            const _Some = _bind$5;
            current = _Some;
          }
          const _bind$6 = _M0FP38bobzhang6moonjq3ast15eval__with__env(upd, current, env);
          let _tmp$41;
          if (_bind$6.$tag === 1) {
            const _ok = _bind$6;
            _tmp$41 = _ok._0;
          } else {
            return _bind$6;
          }
          const upd_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$41);
          if (upd_results.length === 0) {
            return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(obj$2);
          } else {
            const _bind$7 = [];
            const new_map = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$7, 0, 0), undefined);
            const _it = _M0MPB3Map5iter2GssE(_map);
            while (true) {
              const _bind$8 = _M0MPB5Iter24nextGssE(_it);
              if (_bind$8 === undefined) {
                break;
              } else {
                const _Some = _bind$8;
                const _x = _Some;
                const _k = _x._0;
                const _v = _x._1;
                _M0MPB3Map3setGsRPB4JsonE(new_map, _k, _v);
                continue;
              }
            }
            _M0MPB3Map3setGsRPB4JsonE(new_map, _key, _M0MPC15array5Array2atGUssEE(upd_results, 0));
            return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(new _M0DTPB4Json6Object(new_map));
          }
        } else {
          return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(obj$2);
        }
      }
      case 5: {
        const _Index = p$2;
        const _indices = _Index._0;
        if (obj$2.$tag === 5) {
          const _Array = obj$2;
          const _arr = _Array._0;
          if (_indices.length === 0 || _indices.length !== 1) {
            return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(obj$2);
          }
          const idx = _M0MPC15array5Array2atGiE(_indices, 0);
          if (idx < 0 || idx >= _arr.length) {
            return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(obj$2);
          }
          const current = _M0MPC15array5Array2atGUssEE(_arr, idx);
          const _bind$5 = _M0FP38bobzhang6moonjq3ast15eval__with__env(upd, current, env);
          let _tmp$41;
          if (_bind$5.$tag === 1) {
            const _ok = _bind$5;
            _tmp$41 = _ok._0;
          } else {
            return _bind$5;
          }
          const upd_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$41);
          if (upd_results.length === 0) {
            return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(obj$2);
          } else {
            const new_arr = _M0MPC15array5Array4copyGRPB4JsonE(_arr);
            _M0MPC15array5Array3setGsE(new_arr, idx, _M0MPC15array5Array2atGUssEE(upd_results, 0));
            return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(new _M0DTPB4Json5Array(new_arr));
          }
        } else {
          return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(obj$2);
        }
      }
      case 2: {
        const _Pipe = p$2;
        const _left = _Pipe._0;
        const _right = _Pipe._1;
        switch (_left.$tag) {
          case 0: {
            _tmp$39 = _right;
            continue _L;
          }
          case 4: {
            const _Key$2 = _left;
            const _key$2 = _Key$2._0;
            if (obj$2.$tag === 6) {
              const _Object = obj$2;
              const _map = _Object._0;
              const _bind$5 = _M0MPB3Map3getGsRPB4JsonE(_map, _key$2);
              let current;
              if (_bind$5 === undefined) {
                current = _M0DTPB4Json4Null__;
              } else {
                const _Some = _bind$5;
                current = _Some;
              }
              const _bind$6 = _M0FP38bobzhang6moonjq3ast15eval__with__envN13apply__updateS390(env, current, _right, upd);
              let updated;
              if (_bind$6.$tag === 1) {
                const _ok = _bind$6;
                updated = _ok._0;
              } else {
                return _bind$6;
              }
              const _bind$7 = [];
              const new_map = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$7, 0, 0), undefined);
              const _it = _M0MPB3Map5iter2GssE(_map);
              while (true) {
                const _bind$8 = _M0MPB5Iter24nextGssE(_it);
                if (_bind$8 === undefined) {
                  break;
                } else {
                  const _Some = _bind$8;
                  const _x = _Some;
                  const _k = _x._0;
                  const _v = _x._1;
                  _M0MPB3Map3setGsRPB4JsonE(new_map, _k, _v);
                  continue;
                }
              }
              _M0MPB3Map3setGsRPB4JsonE(new_map, _key$2, updated);
              return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(new _M0DTPB4Json6Object(new_map));
            } else {
              return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(obj$2);
            }
          }
          case 5: {
            const _Index$2 = _left;
            const _indices$2 = _Index$2._0;
            if (obj$2.$tag === 5) {
              const _Array = obj$2;
              const _arr = _Array._0;
              if (_indices$2.length === 0 || _indices$2.length !== 1) {
                return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(obj$2);
              }
              const idx = _M0MPC15array5Array2atGiE(_indices$2, 0);
              if (idx < 0 || idx >= _arr.length) {
                return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(obj$2);
              }
              const current = _M0MPC15array5Array2atGUssEE(_arr, idx);
              const _bind$5 = _M0FP38bobzhang6moonjq3ast15eval__with__envN13apply__updateS390(env, current, _right, upd);
              let updated;
              if (_bind$5.$tag === 1) {
                const _ok = _bind$5;
                updated = _ok._0;
              } else {
                return _bind$5;
              }
              const new_arr = _M0MPC15array5Array4copyGRPB4JsonE(_arr);
              _M0MPC15array5Array3setGsE(new_arr, idx, updated);
              return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(new _M0DTPB4Json5Array(new_arr));
            } else {
              return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(obj$2);
            }
          }
          default: {
            const _bind$5 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_left, obj$2, env);
            let _tmp$41;
            if (_bind$5.$tag === 1) {
              const _ok = _bind$5;
              _tmp$41 = _ok._0;
            } else {
              return _bind$5;
            }
            const navigated = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$41);
            if (navigated.length === 0) {
              return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(obj$2);
            }
            _tmp$38 = _M0MPC15array5Array2atGUssEE(navigated, 0);
            _tmp$39 = _right;
            continue _L;
          }
        }
      }
      default: {
        const _bind$6 = _M0FP38bobzhang6moonjq3ast15eval__with__env(p$2, obj$2, env);
        let _tmp$42;
        if (_bind$6.$tag === 1) {
          const _ok = _bind$6;
          _tmp$42 = _ok._0;
        } else {
          return _bind$6;
        }
        const current_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$42);
        if (current_results.length === 0) {
          return new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(obj$2);
        }
        const current = _M0MPC15array5Array2atGUssEE(current_results, 0);
        const _bind$7 = _M0FP38bobzhang6moonjq3ast15eval__with__env(upd, current, env);
        let _tmp$43;
        if (_bind$7.$tag === 1) {
          const _ok = _bind$7;
          _tmp$43 = _ok._0;
        } else {
          return _bind$7;
        }
        const updated_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$43);
        return updated_results.length === 0 ? new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(obj$2) : new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPC15array5Array2atGUssEE(updated_results, 0));
      }
    }
  }
}
function _M0FP38bobzhang6moonjq3ast15eval__with__envN14collect__pathsS588(paths_list, value, path) {
  switch (value.$tag) {
    case 6: {
      const _Object = value;
      const _obj = _Object._0;
      const _it = _M0MPB3Map5iter2GssE(_obj);
      while (true) {
        const _bind$4 = _M0MPB5Iter24nextGssE(_it);
        if (_bind$4 === undefined) {
          return;
        } else {
          const _Some = _bind$4;
          const _x = _Some;
          const _key = _x._0;
          const _val = _x._1;
          const new_path = _M0IPC15array5ArrayPB3Add3addGsE(path, [new _M0DTPB4Json6String(_key)]);
          _M0MPC15array5Array4pushGUssEE(paths_list, new _M0DTPB4Json5Array(new_path));
          _M0FP38bobzhang6moonjq3ast15eval__with__envN14collect__pathsS588(paths_list, _val, new_path);
          continue;
        }
      }
    }
    case 5: {
      const _Array = value;
      const _arr = _Array._0;
      let _tmp$38 = 0;
      while (true) {
        const i = _tmp$38;
        if (i < _arr.length) {
          const _p$4 = i + 0;
          const _p$5 = undefined;
          const new_path = _M0IPC15array5ArrayPB3Add3addGsE(path, [new _M0DTPB4Json6Number(_p$4, _p$5)]);
          _M0MPC15array5Array4pushGUssEE(paths_list, new _M0DTPB4Json5Array(new_path));
          _M0FP38bobzhang6moonjq3ast15eval__with__envN14collect__pathsS588(paths_list, _M0MPC15array5Array2atGUssEE(_arr, i), new_path);
          _tmp$38 = i + 1 | 0;
          continue;
        } else {
          return;
        }
      }
    }
    default: {
      return;
    }
  }
}
function _M0FP38bobzhang6moonjq3ast15eval__with__envN20collect__leaf__pathsS599(paths_list, value, path) {
  switch (value.$tag) {
    case 6: {
      const _Object = value;
      const _obj = _Object._0;
      if (_obj.size === 0) {
        _M0MPC15array5Array4pushGUssEE(paths_list, new _M0DTPB4Json5Array(path));
        return;
      } else {
        const _it = _M0MPB3Map5iter2GssE(_obj);
        while (true) {
          const _bind$4 = _M0MPB5Iter24nextGssE(_it);
          if (_bind$4 === undefined) {
            return;
          } else {
            const _Some = _bind$4;
            const _x = _Some;
            const _key = _x._0;
            const _val = _x._1;
            _M0FP38bobzhang6moonjq3ast15eval__with__envN20collect__leaf__pathsS599(paths_list, _val, _M0IPC15array5ArrayPB3Add3addGsE(path, [new _M0DTPB4Json6String(_key)]));
            continue;
          }
        }
      }
    }
    case 5: {
      const _Array = value;
      const _arr = _Array._0;
      if (_arr.length === 0) {
        _M0MPC15array5Array4pushGUssEE(paths_list, new _M0DTPB4Json5Array(path));
        return;
      } else {
        let _tmp$38 = 0;
        while (true) {
          const i = _tmp$38;
          if (i < _arr.length) {
            const _tmp$39 = _M0MPC15array5Array2atGUssEE(_arr, i);
            const _p$4 = i + 0;
            const _p$5 = undefined;
            _M0FP38bobzhang6moonjq3ast15eval__with__envN20collect__leaf__pathsS599(paths_list, _tmp$39, _M0IPC15array5ArrayPB3Add3addGsE(path, [new _M0DTPB4Json6Number(_p$4, _p$5)]));
            _tmp$38 = i + 1 | 0;
            continue;
          } else {
            return;
          }
        }
      }
    }
    default: {
      _M0MPC15array5Array4pushGUssEE(paths_list, new _M0DTPB4Json5Array(path));
      return;
    }
  }
}
function _M0FP38bobzhang6moonjq3ast15eval__with__env(expr, input, env) {
  let _tmp$38 = expr;
  let _tmp$39 = input;
  let _tmp$40 = env;
  _L: while (true) {
    const expr$2 = _tmp$38;
    const input$2 = _tmp$39;
    const env$2 = _tmp$40;
    switch (expr$2.$tag) {
      case 0: {
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(input$2));
      }
      case 1: {
        const _Literal = expr$2;
        const _lit = _Literal._0;
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0FP38bobzhang6moonjq3ast13eval__literal(_lit)));
      }
      case 2: {
        const _Pipe = expr$2;
        const _left = _Pipe._0;
        const _right = _Pipe._1;
        if (_left.$tag === 85) {
          const _FunctionDef = _left;
          const _name = _FunctionDef._0;
          const _params = _FunctionDef._1;
          const _body = _FunctionDef._2;
          const new_env = _M0MP38bobzhang6moonjq3ast3Env13set__function(env$2, _name, _body, _params);
          _tmp$38 = _right;
          _tmp$40 = new_env;
          continue _L;
        }
        const _bind$4 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_left, input$2, env$2);
        let _tmp$41;
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          _tmp$41 = _ok._0;
        } else {
          return _bind$4;
        }
        const left_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$41);
        const right_iters = [];
        const _bind$5 = left_results.length;
        let _tmp$42 = 0;
        while (true) {
          const _ = _tmp$42;
          if (_ < _bind$5) {
            const v = left_results[_];
            const _bind$6 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_right, v, env$2);
            let _tmp$43;
            if (_bind$6.$tag === 1) {
              const _ok = _bind$6;
              _tmp$43 = _ok._0;
            } else {
              return _bind$6;
            }
            _M0MPC15array5Array4pushGUssEE(right_iters, _tmp$43);
            _tmp$42 = _ + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter7flattenGRPB4JsonE(_M0MPC15array5Array4iterGsE(right_iters)));
      }
      case 3: {
        const _Comma = expr$2;
        const _left$2 = _Comma._0;
        const _right$2 = _Comma._1;
        const _bind$6 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_left$2, input$2, env$2);
        let _tmp$43;
        if (_bind$6.$tag === 1) {
          const _ok = _bind$6;
          _tmp$43 = _ok._0;
        } else {
          return _bind$6;
        }
        const _tmp$44 = _tmp$43;
        const _bind$7 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_right$2, input$2, env$2);
        let _tmp$45;
        if (_bind$7.$tag === 1) {
          const _ok = _bind$7;
          _tmp$45 = _ok._0;
        } else {
          return _bind$7;
        }
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter6concatGRPB4JsonE(_tmp$44, _tmp$45));
      }
      case 4: {
        const _Key = expr$2;
        const _key = _Key._0;
        if (input$2.$tag === 6) {
          const _Object = input$2;
          const _obj = _Object._0;
          const _bind$8 = _M0MPB3Map3getGsRPB4JsonE(_obj, _key);
          if (_bind$8 === undefined) {
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
          } else {
            const _Some = _bind$8;
            const _v = _Some;
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_v));
          }
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
        }
      }
      case 5: {
        const _Index = expr$2;
        const _indices = _Index._0;
        if (_indices.length === 0) {
          switch (input$2.$tag) {
            case 5: {
              const _Array = input$2;
              const _arr = _Array._0;
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPC15array5Array4iterGsE(_arr));
            }
            case 6: {
              const _Object = input$2;
              const _obj = _Object._0;
              let values = [];
              const _it = _M0MPB3Map5iter2GssE(_obj);
              while (true) {
                const _bind$8 = _M0MPB5Iter24nextGssE(_it);
                if (_bind$8 === undefined) {
                  break;
                } else {
                  const _Some = _bind$8;
                  const _x = _Some;
                  const _v = _x._1;
                  values = _M0IPC15array5ArrayPB3Add3addGsE(values, [_v]);
                  continue;
                }
              }
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPC15array5Array4iterGsE(values));
            }
            default: {
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter5emptyGRPB4JsonE());
            }
          }
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter3mapGiRPB4JsonE(_M0MPC15array5Array4iterGiE(_indices), (idx) => {
            if (input$2.$tag === 5) {
              const _Array = input$2;
              const _arr = _Array._0;
              const i = idx < 0 ? _arr.length + idx | 0 : idx;
              return i >= 0 && i < _arr.length ? _M0MPC15array5Array2atGUssEE(_arr, i) : _M0DTPB4Json4Null__;
            } else {
              return _M0DTPB4Json4Null__;
            }
          }));
        }
      }
      case 6: {
        const _Slice = expr$2;
        const _start = _Slice._0;
        const _end = _Slice._1;
        if (input$2.$tag === 5) {
          const _Array = input$2;
          const _arr = _Array._0;
          const len = _arr.length;
          let s;
          if (_start === undefined) {
            s = 0;
          } else {
            const _Some = _start;
            const _n = _Some;
            s = _n < 0 ? len + _n | 0 : _n;
          }
          let e;
          if (_end === undefined) {
            e = len;
          } else {
            const _Some = _end;
            const _n = _Some;
            e = _n < 0 ? len + _n | 0 : _n;
          }
          let result = [];
          let _tmp$46 = s;
          while (true) {
            const i = _tmp$46;
            if (i < e && i < len) {
              if (i >= 0) {
                result = _M0IPC15array5ArrayPB3Add3addGsE(result, [_M0MPC15array5Array2atGUssEE(_arr, i)]);
              }
              _tmp$46 = i + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          const _p$4 = result;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(_p$4)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
        }
      }
      case 7: {
        const _Optional = expr$2;
        const _inner = _Optional._0;
        let _try_err;
        _L$2: {
          const _bind$8 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_inner, input$2, env$2);
          let _tmp$46;
          if (_bind$8.$tag === 1) {
            const _ok = _bind$8;
            _tmp$46 = _ok._0;
          } else {
            const _err = _bind$8;
            _try_err = _err._0;
            break _L$2;
          }
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_tmp$46);
        }
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter5emptyGRPB4JsonE());
      }
      case 8: {
        const _ArrayConstruct = expr$2;
        const _expr_opt = _ArrayConstruct._0;
        if (_expr_opt === undefined) {
          const _p$4 = [];
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(_p$4)));
        } else {
          const _Some = _expr_opt;
          const _e = _Some;
          const _bind$8 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_e, input$2, env$2);
          let _tmp$46;
          if (_bind$8.$tag === 1) {
            const _ok = _bind$8;
            _tmp$46 = _ok._0;
          } else {
            return _bind$8;
          }
          const results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$46);
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(results)));
        }
      }
      case 9: {
        const _ObjectConstruct = expr$2;
        const _pairs = _ObjectConstruct._0;
        const _bind$8 = [];
        const obj = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$8, 0, 0), undefined);
        const _bind$9 = _pairs.length;
        let _tmp$46 = 0;
        while (true) {
          const _ = _tmp$46;
          if (_ < _bind$9) {
            const pair = _pairs[_];
            _L$3: {
              const _key_expr = pair._0;
              const _value_expr_opt = pair._1;
              const _bind$10 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_key_expr, input$2, env$2);
              let _tmp$47;
              if (_bind$10.$tag === 1) {
                const _ok = _bind$10;
                _tmp$47 = _ok._0;
              } else {
                return _bind$10;
              }
              const key_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$47);
              if (key_results.length === 0) {
                break _L$3;
              }
              const _bind$11 = _M0MPC15array5Array2atGUssEE(key_results, 0);
              let key_str;
              if (_bind$11.$tag === 4) {
                const _String = _bind$11;
                key_str = _String._0;
              } else {
                return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("string", _M0FP38bobzhang6moonjq3ast16json__type__name(_M0MPC15array5Array2atGUssEE(key_results, 0))));
              }
              let value;
              if (_value_expr_opt === undefined) {
                if (input$2.$tag === 6) {
                  const _Object = input$2;
                  const _input_obj = _Object._0;
                  const _bind$12 = _M0MPB3Map3getGsRPB4JsonE(_input_obj, key_str);
                  if (_bind$12 === undefined) {
                    value = _M0DTPB4Json4Null__;
                  } else {
                    const _Some = _bind$12;
                    value = _Some;
                  }
                } else {
                  value = _M0DTPB4Json4Null__;
                }
              } else {
                const _Some = _value_expr_opt;
                const _value_expr = _Some;
                const _bind$12 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_value_expr, input$2, env$2);
                let _tmp$48;
                if (_bind$12.$tag === 1) {
                  const _ok = _bind$12;
                  _tmp$48 = _ok._0;
                } else {
                  return _bind$12;
                }
                const value_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$48);
                value = value_results.length === 0 ? _M0DTPB4Json4Null__ : _M0MPC15array5Array2atGUssEE(value_results, 0);
              }
              _M0MPB3Map3setGsRPB4JsonE(obj, key_str, value);
              break _L$3;
            }
            _tmp$46 = _ + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Object(obj)));
      }
      case 10: {
        const _Operation = expr$2;
        const _left$3 = _Operation._0;
        const _op = _Operation._1;
        const _right$3 = _Operation._2;
        const _bind$10 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_left$3, input$2, env$2);
        let _tmp$47;
        if (_bind$10.$tag === 1) {
          const _ok = _bind$10;
          _tmp$47 = _ok._0;
        } else {
          return _bind$10;
        }
        const left_results$2 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$47);
        const _bind$11 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_right$3, input$2, env$2);
        let _tmp$48;
        if (_bind$11.$tag === 1) {
          const _ok = _bind$11;
          _tmp$48 = _ok._0;
        } else {
          return _bind$11;
        }
        const right_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$48);
        let all_results = [];
        const _bind$12 = left_results$2.length;
        let _tmp$49 = 0;
        while (true) {
          const _ = _tmp$49;
          if (_ < _bind$12) {
            const left_val = left_results$2[_];
            const _bind$13 = right_results.length;
            let _tmp$50 = 0;
            while (true) {
              const _$2 = _tmp$50;
              if (_$2 < _bind$13) {
                const right_val = right_results[_$2];
                const _tmp$51 = all_results;
                const _bind$14 = _M0FP38bobzhang6moonjq3ast16eval__binary__op(_op, left_val, right_val);
                let _tmp$52;
                if (_bind$14.$tag === 1) {
                  const _ok = _bind$14;
                  _tmp$52 = _ok._0;
                } else {
                  return _bind$14;
                }
                all_results = _M0IPC15array5ArrayPB3Add3addGsE(_tmp$51, [_tmp$52]);
                _tmp$50 = _$2 + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            _tmp$49 = _ + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPC15array5Array4iterGsE(all_results));
      }
      case 11: {
        let len;
        switch (input$2.$tag) {
          case 5: {
            const _Array = input$2;
            const _arr = _Array._0;
            len = _arr.length;
            break;
          }
          case 6: {
            const _Object = input$2;
            const _obj = _Object._0;
            len = _obj.size;
            break;
          }
          case 4: {
            const _String = input$2;
            const _s = _String._0;
            len = _s.length;
            break;
          }
          case 0: {
            len = 0;
            break;
          }
          default: {
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array/object/string", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
          }
        }
        const _p$4 = len + 0;
        const _p$5 = undefined;
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Number(_p$4, _p$5)));
      }
      case 12: {
        switch (input$2.$tag) {
          case 6: {
            const _Object$2 = input$2;
            const _obj$2 = _Object$2._0;
            let keys = [];
            const _it = _M0MPB3Map5iter2GssE(_obj$2);
            while (true) {
              const _bind$13 = _M0MPB5Iter24nextGssE(_it);
              if (_bind$13 === undefined) {
                break;
              } else {
                const _Some = _bind$13;
                const _x = _Some;
                const _k = _x._0;
                keys = _M0IPC15array5ArrayPB3Add3addGsE(keys, [new _M0DTPB4Json6String(_k)]);
                continue;
              }
            }
            const _p$6 = keys;
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(_p$6)));
          }
          case 5: {
            const _Array$2 = input$2;
            const _arr$2 = _Array$2._0;
            let indices = [];
            let _tmp$50 = 0;
            while (true) {
              const i = _tmp$50;
              if (i < _arr$2.length) {
                const _tmp$51 = indices;
                const _p$7 = i + 0;
                const _p$8 = undefined;
                indices = _M0IPC15array5ArrayPB3Add3addGsE(_tmp$51, [new _M0DTPB4Json6Number(_p$7, _p$8)]);
                _tmp$50 = i + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            const _p$7 = indices;
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(_p$7)));
          }
          default: {
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("object/array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
          }
        }
      }
      case 13: {
        switch (input$2.$tag) {
          case 6: {
            const _Object$3 = input$2;
            const _obj$3 = _Object$3._0;
            let values = [];
            const _it$2 = _M0MPB3Map5iter2GssE(_obj$3);
            while (true) {
              const _bind$13 = _M0MPB5Iter24nextGssE(_it$2);
              if (_bind$13 === undefined) {
                break;
              } else {
                const _Some = _bind$13;
                const _x = _Some;
                const _v = _x._1;
                values = _M0IPC15array5ArrayPB3Add3addGsE(values, [_v]);
                continue;
              }
            }
            const _p$8 = values;
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(_p$8)));
          }
          case 5: {
            const _Array$3 = input$2;
            const _arr$3 = _Array$3._0;
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(_arr$3)));
          }
          default: {
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("object/array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
          }
        }
      }
      case 14: {
        const _p$9 = _M0FP38bobzhang6moonjq3ast16json__type__name(input$2);
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6String(_p$9)));
      }
      case 15: {
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter5emptyGRPB4JsonE());
      }
      case 16: {
        let is_false;
        switch (input$2.$tag) {
          case 2: {
            is_false = true;
            break;
          }
          case 0: {
            is_false = true;
            break;
          }
          default: {
            is_false = false;
          }
        }
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(is_false ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
      }
      case 17: {
        const _Map = expr$2;
        const _inner$2 = _Map._0;
        if (input$2.$tag === 5) {
          const _Array$4 = input$2;
          const _arr$4 = _Array$4._0;
          let results = [];
          const _bind$13 = _arr$4.length;
          let _tmp$51 = 0;
          while (true) {
            const _ = _tmp$51;
            if (_ < _bind$13) {
              const elem = _arr$4[_];
              const _bind$14 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_inner$2, elem, env$2);
              let _tmp$52;
              if (_bind$14.$tag === 1) {
                const _ok = _bind$14;
                _tmp$52 = _ok._0;
              } else {
                return _bind$14;
              }
              const mapped = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$52);
              results = _M0IPC15array5ArrayPB3Add3addGsE(results, mapped);
              _tmp$51 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          const _p$10 = results;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(_p$10)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 18: {
        const _Select = expr$2;
        const _condition = _Select._0;
        const _bind$13 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_condition, input$2, env$2);
        let _tmp$51;
        if (_bind$13.$tag === 1) {
          const _ok = _bind$13;
          _tmp$51 = _ok._0;
        } else {
          return _bind$13;
        }
        const cond_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$51);
        if (cond_results.length === 0) {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter5emptyGRPB4JsonE());
        } else {
          const _bind$14 = _M0MPC15array5Array2atGUssEE(cond_results, 0);
          let is_truthy;
          switch (_bind$14.$tag) {
            case 2: {
              is_truthy = false;
              break;
            }
            case 0: {
              is_truthy = false;
              break;
            }
            default: {
              is_truthy = true;
            }
          }
          return is_truthy ? new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(input$2)) : new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter5emptyGRPB4JsonE());
        }
      }
      case 19: {
        if (input$2.$tag === 5) {
          const _Array$4 = input$2;
          const _arr$4 = _Array$4._0;
          const sorted = _M0MPC15array5Array4copyGRPB4JsonE(_arr$4);
          _M0MPC15array5Array8sort__byGUssEE(sorted, _M0FP38bobzhang6moonjq3ast13compare__json);
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(sorted)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 21: {
        if (input$2.$tag === 5) {
          const _Array$4 = input$2;
          const _arr$4 = _Array$4._0;
          let reversed = [];
          let _tmp$52 = _arr$4.length - 1 | 0;
          while (true) {
            const i = _tmp$52;
            if (i >= 0) {
              reversed = _M0IPC15array5ArrayPB3Add3addGsE(reversed, [_M0MPC15array5Array2atGUssEE(_arr$4, i)]);
              _tmp$52 = i - 1 | 0;
              continue;
            } else {
              break;
            }
          }
          const _p$10 = reversed;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(_p$10)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 22: {
        const _Flatten = expr$2;
        const _depth_opt = _Flatten._0;
        if (input$2.$tag === 5) {
          const _Array$4 = input$2;
          const _arr$4 = _Array$4._0;
          let depth;
          if (_depth_opt === undefined) {
            depth = 999999;
          } else {
            const _Some = _depth_opt;
            depth = _Some;
          }
          const _p$10 = _M0FP38bobzhang6moonjq3ast14flatten__array(_arr$4, depth);
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(_p$10)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 23: {
        if (input$2.$tag === 5) {
          const _Array$4 = input$2;
          const _arr$4 = _Array$4._0;
          const sorted = _M0MPC15array5Array4copyGRPB4JsonE(_arr$4);
          _M0MPC15array5Array8sort__byGUssEE(sorted, _M0FP38bobzhang6moonjq3ast13compare__json);
          let unique = [];
          let prev = undefined;
          const _bind$14 = sorted.length;
          let _tmp$52 = 0;
          while (true) {
            const _ = _tmp$52;
            if (_ < _bind$14) {
              const elem = sorted[_];
              const _bind$15 = prev;
              if (_bind$15 === undefined) {
                unique = _M0IPC15array5ArrayPB3Add3addGsE(unique, [elem]);
                prev = elem;
              } else {
                const _Some = _bind$15;
                const _p$10 = _Some;
                if (_M0FP38bobzhang6moonjq3ast13compare__json(_p$10, elem) !== 0) {
                  unique = _M0IPC15array5ArrayPB3Add3addGsE(unique, [elem]);
                  prev = elem;
                }
              }
              _tmp$52 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          const _p$10 = unique;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(_p$10)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 28: {
        if (input$2.$tag === 5) {
          const _Array$4 = input$2;
          const _arr$4 = _Array$4._0;
          let sum = 0;
          const _bind$14 = _arr$4.length;
          let _tmp$52 = 0;
          while (true) {
            const _ = _tmp$52;
            if (_ < _bind$14) {
              const elem = _arr$4[_];
              if (elem.$tag === 3) {
                const _Number = elem;
                const _n = _Number._0;
                sum = sum + _n;
              }
              _tmp$52 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          const _p$10 = sum;
          const _p$11 = undefined;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Number(_p$10, _p$11)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 29: {
        if (input$2.$tag === 3) {
          const _Number = input$2;
          const _n = _Number._0;
          const _p$10 = _M0MPC16double6Double5floor(_n);
          const _p$11 = undefined;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Number(_p$10, _p$11)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("number", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 30: {
        if (input$2.$tag === 3) {
          const _Number = input$2;
          const _n = _Number._0;
          const _p$10 = Math.sqrt(_n);
          const _p$11 = undefined;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Number(_p$10, _p$11)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("number", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 31: {
        if (input$2.$tag === 5) {
          const _Array$4 = input$2;
          const _arr$4 = _Array$4._0;
          if (_arr$4.length === 0) {
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
          } else {
            let min_val = _M0MPC15array5Array2atGUssEE(_arr$4, 0);
            const _bind$14 = _arr$4.length;
            let _tmp$52 = 0;
            while (true) {
              const _ = _tmp$52;
              if (_ < _bind$14) {
                const elem = _arr$4[_];
                if (_M0FP38bobzhang6moonjq3ast13compare__json(elem, min_val) < 0) {
                  min_val = elem;
                }
                _tmp$52 = _ + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(min_val));
          }
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 33: {
        if (input$2.$tag === 5) {
          const _Array$4 = input$2;
          const _arr$4 = _Array$4._0;
          if (_arr$4.length === 0) {
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
          } else {
            let max_val = _M0MPC15array5Array2atGUssEE(_arr$4, 0);
            const _bind$14 = _arr$4.length;
            let _tmp$52 = 0;
            while (true) {
              const _ = _tmp$52;
              if (_ < _bind$14) {
                const elem = _arr$4[_];
                if (_M0FP38bobzhang6moonjq3ast13compare__json(elem, max_val) > 0) {
                  max_val = elem;
                }
                _tmp$52 = _ + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(max_val));
          }
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 64: {
        const _IfThenElse = expr$2;
        const _cond = _IfThenElse._0;
        const _then_expr = _IfThenElse._1;
        const _else_expr = _IfThenElse._2;
        const _bind$14 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_cond, input$2, env$2);
        let _tmp$52;
        if (_bind$14.$tag === 1) {
          const _ok = _bind$14;
          _tmp$52 = _ok._0;
        } else {
          return _bind$14;
        }
        const cond_results$2 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$52);
        if (cond_results$2.length === 0) {
          _tmp$38 = _else_expr;
          continue _L;
        } else {
          const _bind$15 = _M0MPC15array5Array2atGUssEE(cond_results$2, 0);
          let is_truthy;
          switch (_bind$15.$tag) {
            case 2: {
              is_truthy = false;
              break;
            }
            case 0: {
              is_truthy = false;
              break;
            }
            default: {
              is_truthy = true;
            }
          }
          if (is_truthy) {
            _tmp$38 = _then_expr;
            continue _L;
          } else {
            _tmp$38 = _else_expr;
            continue _L;
          }
        }
      }
      case 65: {
        const _TryCatch = expr$2;
        const _try_expr = _TryCatch._0;
        const _catch_opt = _TryCatch._1;
        let _try_err$2;
        _L$3: {
          const _bind$15 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_try_expr, input$2, env$2);
          let _tmp$53;
          if (_bind$15.$tag === 1) {
            const _ok = _bind$15;
            _tmp$53 = _ok._0;
          } else {
            const _err = _bind$15;
            _try_err$2 = _err._0;
            break _L$3;
          }
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_tmp$53);
        }
        if (_catch_opt === undefined) {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter5emptyGRPB4JsonE());
        } else {
          const _Some = _catch_opt;
          const _catch_expr = _Some;
          _tmp$38 = _catch_expr;
          continue _L;
        }
      }
      case 66: {
        const _Variable = expr$2;
        const _name = _Variable._0;
        const _bind$15 = _M0MP38bobzhang6moonjq3ast3Env3get(env$2, _name);
        if (_bind$15 === undefined) {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error61bobzhang_2fmoonjq_2fast_2eInterpreterError_2eInvalidOperation(`Undefined variable: $${_name}`));
        } else {
          const _Some = _bind$15;
          const _v = _Some;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_v));
        }
      }
      case 70: {
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0FP38bobzhang6moonjq3ast12recurse__all(input$2));
      }
      case 76: {
        const _Alternative = expr$2;
        const _left$4 = _Alternative._0;
        const _right$4 = _Alternative._1;
        const _bind$16 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_left$4, input$2, env$2);
        let _tmp$53;
        if (_bind$16.$tag === 1) {
          const _ok = _bind$16;
          _tmp$53 = _ok._0;
        } else {
          return _bind$16;
        }
        const left_results$3 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$53);
        if (left_results$3.length === 0) {
          _tmp$38 = _right$4;
          continue _L;
        } else {
          _L$4: {
            const _bind$17 = _M0MPC15array5Array2atGUssEE(left_results$3, 0);
            switch (_bind$17.$tag) {
              case 0: {
                break _L$4;
              }
              case 2: {
                break _L$4;
              }
              default: {
                return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPC15array5Array4iterGsE(left_results$3));
              }
            }
          }
          _tmp$38 = _right$4;
          continue _L;
        }
      }
      case 77: {
        const _AddAssign = expr$2;
        const _path = _AddAssign._0;
        const _value_expr = _AddAssign._1;
        _tmp$38 = new _M0DTP38bobzhang6moonjq3ast4Expr6Update(_path, new _M0DTP38bobzhang6moonjq3ast4Expr9Operation(_M0DTP38bobzhang6moonjq3ast4Expr8Identity__, 0, _value_expr));
        continue _L;
      }
      case 78: {
        const _SubAssign = expr$2;
        const _path$2 = _SubAssign._0;
        const _value_expr$2 = _SubAssign._1;
        _tmp$38 = new _M0DTP38bobzhang6moonjq3ast4Expr6Update(_path$2, new _M0DTP38bobzhang6moonjq3ast4Expr9Operation(_M0DTP38bobzhang6moonjq3ast4Expr8Identity__, 1, _value_expr$2));
        continue _L;
      }
      case 79: {
        const _MulAssign = expr$2;
        const _path$3 = _MulAssign._0;
        const _value_expr$3 = _MulAssign._1;
        _tmp$38 = new _M0DTP38bobzhang6moonjq3ast4Expr6Update(_path$3, new _M0DTP38bobzhang6moonjq3ast4Expr9Operation(_M0DTP38bobzhang6moonjq3ast4Expr8Identity__, 2, _value_expr$3));
        continue _L;
      }
      case 80: {
        const _DivAssign = expr$2;
        const _path$4 = _DivAssign._0;
        const _value_expr$4 = _DivAssign._1;
        _tmp$38 = new _M0DTP38bobzhang6moonjq3ast4Expr6Update(_path$4, new _M0DTP38bobzhang6moonjq3ast4Expr9Operation(_M0DTP38bobzhang6moonjq3ast4Expr8Identity__, 3, _value_expr$4));
        continue _L;
      }
      case 81: {
        const _ModAssign = expr$2;
        const _path$5 = _ModAssign._0;
        const _value_expr$5 = _ModAssign._1;
        _tmp$38 = new _M0DTP38bobzhang6moonjq3ast4Expr6Update(_path$5, new _M0DTP38bobzhang6moonjq3ast4Expr9Operation(_M0DTP38bobzhang6moonjq3ast4Expr8Identity__, 4, _value_expr$5));
        continue _L;
      }
      case 82: {
        const _AltAssign = expr$2;
        const _path$6 = _AltAssign._0;
        const _value_expr$6 = _AltAssign._1;
        _tmp$38 = new _M0DTP38bobzhang6moonjq3ast4Expr6Update(_path$6, new _M0DTP38bobzhang6moonjq3ast4Expr11Alternative(_M0DTP38bobzhang6moonjq3ast4Expr8Identity__, _value_expr$6));
        continue _L;
      }
      case 83: {
        const _Format = expr$2;
        const _format_name = _Format._0;
        _L$4: {
          switch (_format_name) {
            case "base64": {
              if (input$2.$tag === 4) {
                const _String$2 = input$2;
                const _s$2 = _String$2._0;
                const bytes = _M0FPC28encoding4utf814encode_2einner(new _M0TPC16string10StringView(_s$2, 0, _s$2.length), false);
                const encoded = _M0FP38bobzhang6moonjq3ast14base64__encode(bytes);
                return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6String(encoded)));
              } else {
                return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error54bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeError("@base64 requires string"));
              }
            }
            case "base64d": {
              if (input$2.$tag === 4) {
                const _String$2 = input$2;
                const _s$2 = _String$2._0;
                let decoded_bytes;
                let _try_err$3;
                _L$5: {
                  _L$6: {
                    const _bind$17 = _M0FP38bobzhang6moonjq3ast14base64__decode(_s$2);
                    if (_bind$17.$tag === 1) {
                      const _ok = _bind$17;
                      decoded_bytes = _ok._0;
                    } else {
                      const _err = _bind$17;
                      _try_err$3 = _err._0;
                      break _L$6;
                    }
                    break _L$5;
                  }
                  return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error54bobzhang_2fmoonjq_2fast_2eInterpreterError_2eEvalError("Invalid base64"));
                }
                let decoded_str;
                let _try_err$4;
                _L$6: {
                  _L$7: {
                    const _bind$17 = _M0FPC28encoding4utf814decode_2einner(_M0MPC15bytes5Bytes12view_2einner(decoded_bytes, 0, decoded_bytes.length), false);
                    if (_bind$17.$tag === 1) {
                      const _ok = _bind$17;
                      decoded_str = _ok._0;
                    } else {
                      const _err = _bind$17;
                      _try_err$4 = _err._0;
                      break _L$7;
                    }
                    break _L$6;
                  }
                  return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error54bobzhang_2fmoonjq_2fast_2eInterpreterError_2eEvalError("Invalid UTF-8"));
                }
                return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6String(decoded_str)));
              } else {
                return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error54bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeError("@base64d requires string"));
              }
            }
            case "uri": {
              if (input$2.$tag === 4) {
                const _String$2 = input$2;
                const _s$2 = _String$2._0;
                const encoded = _M0FP38bobzhang6moonjq3ast11uri__encode(_s$2);
                return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6String(encoded)));
              } else {
                return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error54bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeError("@uri requires string"));
              }
            }
            case "csv": {
              break _L$4;
            }
            case "tsv": {
              break _L$4;
            }
            case "json": {
              const _p$10 = _M0IP016_24default__implPB4Show10to__stringGRPB4JsonE(input$2);
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6String(_p$10)));
            }
            case "text": {
              const _p$11 = _M0IP016_24default__implPB4Show10to__stringGRPB4JsonE(input$2);
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6String(_p$11)));
            }
            case "html": {
              if (input$2.$tag === 4) {
                const _String$2 = input$2;
                const _s$2 = _String$2._0;
                const escaped = _M0FP38bobzhang6moonjq3ast12html__escape(_s$2);
                return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6String(escaped)));
              } else {
                return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error54bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeError("@html requires string"));
              }
            }
            default: {
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error54bobzhang_2fmoonjq_2fast_2eInterpreterError_2eEvalError(`Unknown format: @${_format_name}`));
            }
          }
        }
        if (input$2.$tag === 5) {
          const _Array$4 = input$2;
          const _arr$4 = _Array$4._0;
          const sep = _format_name === "csv" ? "," : "\t";
          const parts = [];
          const _bind$17 = _arr$4.length;
          let _tmp$54 = 0;
          while (true) {
            const _ = _tmp$54;
            if (_ < _bind$17) {
              const item = _arr$4[_];
              switch (item.$tag) {
                case 4: {
                  const _String$2 = item;
                  const _s$2 = _String$2._0;
                  if (_M0MPC16string6String8contains(_s$2, new _M0TPC16string10StringView(sep, 0, sep.length)) || _M0MPC16string6String8contains(_s$2, new _M0TPC16string10StringView(_M0FP38bobzhang6moonjq3ast15eval__with__envN7_2abindS3823, 0, _M0FP38bobzhang6moonjq3ast15eval__with__envN7_2abindS3823.length))) {
                    const escaped = _M0MPC16string6String7replace(_s$2, new _M0TPC16string10StringView(_M0FP38bobzhang6moonjq3ast15eval__with__envN7_2abindS3824, 0, _M0FP38bobzhang6moonjq3ast15eval__with__envN7_2abindS3824.length), new _M0TPC16string10StringView(_M0FP38bobzhang6moonjq3ast15eval__with__envN7_2abindS3825, 0, _M0FP38bobzhang6moonjq3ast15eval__with__envN7_2abindS3825.length));
                    _M0MPC15array5Array4pushGUssEE(parts, `\"${escaped}\"`);
                  } else {
                    _M0MPC15array5Array4pushGUssEE(parts, _s$2);
                  }
                  break;
                }
                case 3: {
                  const _Number = item;
                  const _n = _Number._0;
                  _M0MPC15array5Array4pushGUssEE(parts, String(_n));
                  break;
                }
                case 1: {
                  _M0MPC15array5Array4pushGUssEE(parts, "true");
                  break;
                }
                case 2: {
                  _M0MPC15array5Array4pushGUssEE(parts, "false");
                  break;
                }
                case 0: {
                  _M0MPC15array5Array4pushGUssEE(parts, "");
                  break;
                }
                default: {
                  _M0MPC15array5Array4pushGUssEE(parts, _M0IP016_24default__implPB4Show10to__stringGRPB4JsonE(item));
                }
              }
              _tmp$54 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          const _p$10 = _M0MPC15array5Array4joinGsE(parts, new _M0TPC16string10StringView(sep, 0, sep.length));
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6String(_p$10)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error54bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeError("@csv/@tsv requires array"));
        }
      }
      case 84: {
        const _StringInterpolation = expr$2;
        const _parts = _StringInterpolation._0;
        const buf = _M0FPC16buffer11new_2einner(0);
        const _bind$17 = _parts.length;
        let _tmp$54 = 0;
        while (true) {
          const _ = _tmp$54;
          if (_ < _bind$17) {
            const pair = _parts[_];
            const _text = pair._0;
            const _expr_opt$2 = pair._1;
            _M0IPC16buffer6BufferPB6Logger13write__string(buf, _text);
            if (_expr_opt$2 === undefined) {
            } else {
              const _Some = _expr_opt$2;
              const _expr = _Some;
              const _bind$18 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_expr, input$2, env$2);
              let _tmp$55;
              if (_bind$18.$tag === 1) {
                const _ok = _bind$18;
                _tmp$55 = _ok._0;
              } else {
                return _bind$18;
              }
              const results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$55);
              if (!(results.length === 0)) {
                const _bind$19 = _M0MPC15array5Array2atGUssEE(results, 0);
                if (_bind$19.$tag === 4) {
                  const _String$2 = _bind$19;
                  const _s$2 = _String$2._0;
                  _M0IPC16buffer6BufferPB6Logger13write__string(buf, _s$2);
                } else {
                  _M0IPC16buffer6BufferPB6Logger13write__string(buf, _M0IP016_24default__implPB4Show10to__stringGRPB4JsonE(_M0MPC15array5Array2atGUssEE(results, 0)));
                }
              }
            }
            _tmp$54 = _ + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        const _p$10 = _M0IP016_24default__implPB4Show10to__stringGRPC16buffer6BufferE(buf);
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6String(_p$10)));
      }
      case 85: {
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(input$2));
      }
      case 86: {
        const _FunctionCall = expr$2;
        const _name$2 = _FunctionCall._0;
        const _args = _FunctionCall._1;
        const _bind$18 = _M0MP38bobzhang6moonjq3ast3Env13get__function(env$2, _name$2);
        if (_bind$18 === undefined) {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error54bobzhang_2fmoonjq_2fast_2eInterpreterError_2eEvalError(`Undefined function: ${_name$2}`));
        } else {
          const _Some = _bind$18;
          const _x = _Some;
          const _body = _x._0;
          const _params = _x._1;
          if (_params.length === 0) {
            _tmp$38 = _body;
            continue _L;
          } else {
            if (_args.length !== _params.length) {
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error54bobzhang_2fmoonjq_2fast_2eInterpreterError_2eEvalError(`Function ${_name$2} expects ${_M0IPC13int3IntPB4Show10to__string(_params.length)} arguments, got ${_M0IPC13int3IntPB4Show10to__string(_args.length)}`));
            } else {
              const arg_values = [];
              const _bind$19 = _args.length;
              let _tmp$55 = 0;
              while (true) {
                const _ = _tmp$55;
                if (_ < _bind$19) {
                  const arg = _args[_];
                  const _bind$20 = _M0FP38bobzhang6moonjq3ast15eval__with__env(arg, input$2, env$2);
                  let _tmp$56;
                  if (_bind$20.$tag === 1) {
                    const _ok = _bind$20;
                    _tmp$56 = _ok._0;
                  } else {
                    return _bind$20;
                  }
                  const results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$56);
                  _M0MPC15array5Array4pushGUssEE(arg_values, results.length === 0 ? _M0DTPB4Json4Null__ : _M0MPC15array5Array2atGUssEE(results, 0));
                  _tmp$55 = _ + 1 | 0;
                  continue;
                } else {
                  break;
                }
              }
              let new_env = env$2;
              let _tmp$56 = 0;
              while (true) {
                const i = _tmp$56;
                if (i < _params.length) {
                  new_env = _M0MP38bobzhang6moonjq3ast3Env3set(new_env, _M0MPC15array5Array2atGUssEE(_params, i), _M0MPC15array5Array2atGUssEE(arg_values, i));
                  _tmp$56 = i + 1 | 0;
                  continue;
                } else {
                  break;
                }
              }
              _tmp$38 = _body;
              _tmp$40 = new_env;
              continue _L;
            }
          }
        }
      }
      case 67: {
        const _As = expr$2;
        const _expr = _As._0;
        const _var_name = _As._1;
        const _body = _As._2;
        const _bind$19 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_expr, input$2, env$2);
        let _tmp$55;
        if (_bind$19.$tag === 1) {
          const _ok = _bind$19;
          _tmp$55 = _ok._0;
        } else {
          return _bind$19;
        }
        const results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$55);
        const all_results$2 = [];
        const _bind$20 = results.length;
        let _tmp$56 = 0;
        while (true) {
          const _ = _tmp$56;
          if (_ < _bind$20) {
            const result = results[_];
            const new_env = _M0MP38bobzhang6moonjq3ast3Env3set(env$2, _var_name, result);
            const _bind$21 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_body, input$2, new_env);
            let _it$3;
            if (_bind$21.$tag === 1) {
              const _ok = _bind$21;
              _it$3 = _ok._0;
            } else {
              return _bind$21;
            }
            while (true) {
              const _bind$22 = _M0MPB4Iter4nextGUssEE(_it$3);
              if (_bind$22 === undefined) {
                break;
              } else {
                const _Some = _bind$22;
                const _val = _Some;
                _M0MPC15array5Array4pushGUssEE(all_results$2, _val);
                continue;
              }
            }
            _tmp$56 = _ + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPC15array5Array4iterGsE(all_results$2));
      }
      case 68: {
        const _Reduce = expr$2;
        const _expr$2 = _Reduce._0;
        const _var_name$2 = _Reduce._1;
        const _init_expr = _Reduce._2;
        const _update_expr = _Reduce._3;
        const _bind$21 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_init_expr, input$2, env$2);
        let _tmp$57;
        if (_bind$21.$tag === 1) {
          const _ok = _bind$21;
          _tmp$57 = _ok._0;
        } else {
          return _bind$21;
        }
        const init_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$57);
        if (init_results.length === 0) {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
        }
        let accumulator = _M0MPC15array5Array2atGUssEE(init_results, 0);
        const _bind$22 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_expr$2, input$2, env$2);
        let _it$3;
        if (_bind$22.$tag === 1) {
          const _ok = _bind$22;
          _it$3 = _ok._0;
        } else {
          return _bind$22;
        }
        while (true) {
          const _bind$23 = _M0MPB4Iter4nextGUssEE(_it$3);
          if (_bind$23 === undefined) {
            break;
          } else {
            const _Some = _bind$23;
            const _item = _Some;
            const new_env = _M0MP38bobzhang6moonjq3ast3Env3set(env$2, _var_name$2, _item);
            const _bind$24 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_update_expr, accumulator, new_env);
            let _tmp$58;
            if (_bind$24.$tag === 1) {
              const _ok = _bind$24;
              _tmp$58 = _ok._0;
            } else {
              return _bind$24;
            }
            const update_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$58);
            if (!(update_results.length === 0)) {
              accumulator = _M0MPC15array5Array2atGUssEE(update_results, 0);
            }
            continue;
          }
        }
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(accumulator));
      }
      case 20: {
        const _SortBy = expr$2;
        const _expr$3 = _SortBy._0;
        if (input$2.$tag === 5) {
          const _Array$4 = input$2;
          const _arr$4 = _Array$4._0;
          const pairs = [];
          const _bind$23 = _arr$4.length;
          let _tmp$58 = 0;
          while (true) {
            const _ = _tmp$58;
            if (_ < _bind$23) {
              const elem = _arr$4[_];
              const _bind$24 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_expr$3, elem, env$2);
              let _tmp$59;
              if (_bind$24.$tag === 1) {
                const _ok = _bind$24;
                _tmp$59 = _ok._0;
              } else {
                return _bind$24;
              }
              const keys$2 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$59);
              const sort_key = keys$2.length === 0 ? _M0DTPB4Json4Null__ : _M0MPC15array5Array2atGUssEE(keys$2, 0);
              _M0MPC15array5Array4pushGUssEE(pairs, { _0: elem, _1: sort_key });
              _tmp$58 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          const sorted_pairs = _M0MPC15array5Array4copyGRPB4JsonE(pairs);
          _M0MPC15array5Array8sort__byGUssEE(sorted_pairs, (a, b) => _M0FP38bobzhang6moonjq3ast13compare__json(a._1, b._1));
          const _p$11 = new Array(sorted_pairs.length);
          const _p$12 = sorted_pairs.length;
          let _tmp$59 = 0;
          while (true) {
            const _p$13 = _tmp$59;
            if (_p$13 < _p$12) {
              const _p$14 = sorted_pairs[_p$13];
              _p$11[_p$13] = _p$14._0;
              _tmp$59 = _p$13 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          const sorted = _p$11;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(sorted)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 25: {
        const _GroupBy = expr$2;
        const _expr$4 = _GroupBy._0;
        if (input$2.$tag === 5) {
          const _Array$4 = input$2;
          const _arr$4 = _Array$4._0;
          const _bind$23 = [];
          const groups = _M0MPB3Map3MapGsRPB5ArrayGRPB4JsonEE(new _M0TPB9ArrayViewGUsRPB5ArrayGRPB4JsonEEE(_bind$23, 0, 0), undefined);
          const _bind$24 = _arr$4.length;
          let _tmp$58 = 0;
          while (true) {
            const _ = _tmp$58;
            if (_ < _bind$24) {
              const elem = _arr$4[_];
              const _bind$25 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_expr$4, elem, env$2);
              let _tmp$59;
              if (_bind$25.$tag === 1) {
                const _ok = _bind$25;
                _tmp$59 = _ok._0;
              } else {
                return _bind$25;
              }
              const keys$2 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$59);
              const key_json = keys$2.length === 0 ? _M0DTPB4Json4Null__ : _M0MPC15array5Array2atGUssEE(keys$2, 0);
              const key_str = _M0IP016_24default__implPB4Show10to__stringGRPB4JsonE(key_json);
              const _bind$26 = _M0MPB3Map3getGsRPB5ArrayGRPB4JsonEE(groups, key_str);
              if (_bind$26.$tag === 1) {
                const _Some = _bind$26;
                const _existing = _Some._0;
                _M0MPC15array5Array4pushGUssEE(_existing, elem);
                _M0MPB3Map3setGsRPB5ArrayGRPB4JsonEE(groups, key_str, _existing);
              } else {
                _M0MPB3Map3setGsRPB5ArrayGRPB4JsonEE(groups, key_str, [elem]);
              }
              _tmp$58 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          const result = [];
          const _it$4 = _M0MPB3Map6valuesGsRPB5ArrayGRPB4JsonEE(groups);
          while (true) {
            const _bind$25 = _M0MPB4Iter4nextGRPB5ArrayGRPB4JsonEE(_it$4);
            if (_bind$25.$tag === 1) {
              const _Some = _bind$25;
              const _group = _Some._0;
              _M0MPC15array5Array4pushGUssEE(result, new _M0DTPB4Json5Array(_group));
              continue;
            } else {
              break;
            }
          }
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(result)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 74: {
        const _Update = expr$2;
        const _path$7 = _Update._0;
        const _update_expr$2 = _Update._1;
        const _bind$23 = _M0FP38bobzhang6moonjq3ast15eval__with__envN13apply__updateS390(env$2, input$2, _path$7, _update_expr$2);
        let _tmp$58;
        if (_bind$23.$tag === 1) {
          const _ok = _bind$23;
          _tmp$58 = _ok._0;
        } else {
          return _bind$23;
        }
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_tmp$58));
      }
      case 75: {
        const _Assign = expr$2;
        const _value_expr$7 = _Assign._1;
        const _bind$24 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_value_expr$7, input$2, env$2);
        let _tmp$59;
        if (_bind$24.$tag === 1) {
          const _ok = _bind$24;
          _tmp$59 = _ok._0;
        } else {
          return _bind$24;
        }
        const values$2 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$59);
        return values$2.length === 0 ? new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(input$2)) : new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0MPC15array5Array2atGUssEE(values$2, 0)));
      }
      case 71: {
        const _RecurseWith = expr$2;
        const _f = _RecurseWith._0;
        const results$2 = [input$2];
        const to_process_ref = _M0MPC13ref3Ref3RefGRPB5ArrayGRPB4JsonEE([input$2]);
        while (true) {
          const _p$11 = to_process_ref.val;
          if (!(_p$11.length === 0)) {
            const next_batch = [];
            const _bind$25 = to_process_ref.val;
            const _bind$26 = _bind$25.length;
            let _tmp$60 = 0;
            while (true) {
              const _ = _tmp$60;
              if (_ < _bind$26) {
                const item = _bind$25[_];
                const _bind$27 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_f, item, env$2);
                let _it$4;
                if (_bind$27.$tag === 1) {
                  const _ok = _bind$27;
                  _it$4 = _ok._0;
                } else {
                  return _bind$27;
                }
                while (true) {
                  const _bind$28 = _M0MPB4Iter4nextGUssEE(_it$4);
                  if (_bind$28 === undefined) {
                    break;
                  } else {
                    const _Some = _bind$28;
                    const _result = _Some;
                    if (_M0IP016_24default__implPB2Eq10not__equalGRPB4JsonE(_result, item)) {
                      _M0MPC15array5Array4pushGUssEE(results$2, _result);
                      _M0MPC15array5Array4pushGUssEE(next_batch, _result);
                    }
                    continue;
                  }
                }
                _tmp$60 = _ + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            to_process_ref.val = next_batch;
            if (to_process_ref.val.length > 100) {
              break;
            }
            continue;
          } else {
            break;
          }
        }
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPC15array5Array4iterGsE(results$2));
      }
      case 72: {
        const _Walk = expr$2;
        const _f$2 = _Walk._0;
        const walk_value = (v) => {
          switch (v.$tag) {
            case 5: {
              const _Array$4 = v;
              const _arr$4 = _Array$4._0;
              let _bind$25;
              let _p$11;
              _L$5: {
                _L$6: {
                  const _p$12 = new Array(_arr$4.length);
                  const _p$13 = _arr$4.length;
                  let _tmp$60 = 0;
                  while (true) {
                    const _p$14 = _tmp$60;
                    if (_p$14 < _p$13) {
                      const _p$15 = _arr$4[_p$14];
                      const _bind$26 = walk_value(_p$15);
                      let _tmp$61;
                      if (_bind$26.$tag === 1) {
                        const _ok = _bind$26;
                        _tmp$61 = _ok._0;
                      } else {
                        const _err = _bind$26;
                        _p$11 = _err._0;
                        break _L$6;
                      }
                      _p$12[_p$14] = _tmp$61;
                      _tmp$60 = _p$14 + 1 | 0;
                      continue;
                    } else {
                      break;
                    }
                  }
                  _bind$25 = new _M0DTPC16result6ResultGRPB5ArrayGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_p$12);
                  break _L$5;
                }
                _bind$25 = new _M0DTPC16result6ResultGRPB5ArrayGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(_p$11);
              }
              let walked;
              if (_bind$25.$tag === 1) {
                const _ok = _bind$25;
                walked = _ok._0;
              } else {
                return _bind$25;
              }
              const wrapped = new _M0DTPB4Json5Array(walked);
              const _bind$26 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_f$2, wrapped, env$2);
              let _tmp$60;
              if (_bind$26.$tag === 1) {
                const _ok = _bind$26;
                _tmp$60 = _ok._0;
              } else {
                return _bind$26;
              }
              const results$3 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$60);
              return results$3.length === 0 ? new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(wrapped) : new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPC15array5Array2atGUssEE(results$3, 0));
            }
            case 6: {
              const _Object$4 = v;
              const _obj$4 = _Object$4._0;
              const _bind$27 = [];
              const walked$2 = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$27, 0, 0), undefined);
              const _it$4 = _M0MPB3Map5iter2GssE(_obj$4);
              while (true) {
                const _bind$28 = _M0MPB5Iter24nextGssE(_it$4);
                if (_bind$28 === undefined) {
                  break;
                } else {
                  const _Some = _bind$28;
                  const _x = _Some;
                  const _k = _x._0;
                  const _v = _x._1;
                  const _bind$29 = walk_value(_v);
                  let _tmp$61;
                  if (_bind$29.$tag === 1) {
                    const _ok = _bind$29;
                    _tmp$61 = _ok._0;
                  } else {
                    return _bind$29;
                  }
                  _M0MPB3Map3setGsRPB4JsonE(walked$2, _k, _tmp$61);
                  continue;
                }
              }
              const wrapped$2 = new _M0DTPB4Json6Object(walked$2);
              const _bind$28 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_f$2, wrapped$2, env$2);
              let _tmp$61;
              if (_bind$28.$tag === 1) {
                const _ok = _bind$28;
                _tmp$61 = _ok._0;
              } else {
                return _bind$28;
              }
              const results$4 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$61);
              return results$4.length === 0 ? new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(wrapped$2) : new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPC15array5Array2atGUssEE(results$4, 0));
            }
            default: {
              const _bind$29 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_f$2, v, env$2);
              let _tmp$62;
              if (_bind$29.$tag === 1) {
                const _ok = _bind$29;
                _tmp$62 = _ok._0;
              } else {
                return _bind$29;
              }
              const results$5 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$62);
              return results$5.length === 0 ? new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(v) : new _M0DTPC16result6ResultGRPB4JsonRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPC15array5Array2atGUssEE(results$5, 0));
            }
          }
        };
        const _bind$25 = walk_value(input$2);
        let _tmp$60;
        if (_bind$25.$tag === 1) {
          const _ok = _bind$25;
          _tmp$60 = _ok._0;
        } else {
          return _bind$25;
        }
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_tmp$60));
      }
      case 73: {
        const _p$11 = [];
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(_p$11)));
      }
      case 35: {
        if (input$2.$tag === 3) {
          const _Number = input$2;
          const _n = _Number._0;
          const _p$12 = _M0MPC16double6Double5round(_n);
          const _p$13 = undefined;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Number(_p$12, _p$13)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("number", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 36: {
        if (input$2.$tag === 3) {
          const _Number = input$2;
          const _n = _Number._0;
          const _p$12 = _M0MPC16double6Double4ceil(_n);
          const _p$13 = undefined;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Number(_p$12, _p$13)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("number", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 37: {
        if (input$2.$tag === 3) {
          const _Number = input$2;
          const _n = _Number._0;
          const _p$12 = Math.abs(_n);
          const _p$13 = undefined;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Number(_p$12, _p$13)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("number", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 38: {
        const _Split = expr$2;
        const _sep = _Split._0;
        if (input$2.$tag === 4) {
          const _String$2 = input$2;
          const _s$2 = _String$2._0;
          const parts = _M0MPC16string6String5split(_s$2, new _M0TPC16string10StringView(_sep, 0, _sep.length));
          const json_parts = [];
          while (true) {
            const _bind$26 = _M0MPB4Iter4nextGUssEE(parts);
            if (_bind$26 === undefined) {
              break;
            } else {
              const _Some = _bind$26;
              const _part = _Some;
              const _p$12 = _M0MPC16string10StringView9to__owned(_part);
              _M0MPC15array5Array4pushGUssEE(json_parts, new _M0DTPB4Json6String(_p$12));
              continue;
            }
          }
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(json_parts)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("string", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 39: {
        const _Join = expr$2;
        const _sep$2 = _Join._0;
        if (input$2.$tag === 5) {
          const _Array$4 = input$2;
          const _arr$4 = _Array$4._0;
          const parts = [];
          const _bind$26 = _arr$4.length;
          let _tmp$61 = 0;
          while (true) {
            const _ = _tmp$61;
            if (_ < _bind$26) {
              const elem = _arr$4[_];
              if (elem.$tag === 4) {
                const _String$2 = elem;
                const _s$2 = _String$2._0;
                _M0MPC15array5Array4pushGUssEE(parts, _s$2);
              } else {
                _M0MPC15array5Array4pushGUssEE(parts, _M0IP016_24default__implPB4Show10to__stringGRPB4JsonE(elem));
              }
              _tmp$61 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          const _p$12 = _M0MPC15array5Array4joinGsE(parts, new _M0TPC16string10StringView(_sep$2, 0, _sep$2.length));
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6String(_p$12)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 40: {
        const _StartsWith = expr$2;
        const _prefix = _StartsWith._0;
        if (input$2.$tag === 4) {
          const _String$2 = input$2;
          const _s$2 = _String$2._0;
          const _p$12 = _M0MPC16string6String11has__prefix(_s$2, new _M0TPC16string10StringView(_prefix, 0, _prefix.length));
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$12 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("string", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 41: {
        const _EndsWith = expr$2;
        const _suffix = _EndsWith._0;
        if (input$2.$tag === 4) {
          const _String$2 = input$2;
          const _s$2 = _String$2._0;
          const _p$12 = _M0MPC16string6String11has__suffix(_s$2, new _M0TPC16string10StringView(_suffix, 0, _suffix.length));
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$12 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("string", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 42: {
        const _Contains = expr$2;
        const _expr$5 = _Contains._0;
        const _bind$26 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_expr$5, input$2, env$2);
        let _tmp$61;
        if (_bind$26.$tag === 1) {
          const _ok = _bind$26;
          _tmp$61 = _ok._0;
        } else {
          return _bind$26;
        }
        const needle_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$61);
        if (needle_results.length === 0) {
          const _p$12 = false;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$12 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
        }
        const needle = _M0MPC15array5Array2atGUssEE(needle_results, 0);
        _L$5: {
          switch (input$2.$tag) {
            case 4: {
              const _String$2 = input$2;
              const _haystack = _String$2._0;
              if (needle.$tag === 4) {
                const _String$3 = needle;
                const _n = _String$3._0;
                const _p$12 = _M0MPC16string6String8contains(_haystack, new _M0TPC16string10StringView(_n, 0, _n.length));
                return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$12 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
              } else {
                break _L$5;
              }
            }
            case 5: {
              const _Array$4 = input$2;
              const _haystack$2 = _Array$4._0;
              let found = false;
              const _bind$27 = _haystack$2.length;
              let _tmp$62 = 0;
              while (true) {
                const _ = _tmp$62;
                if (_ < _bind$27) {
                  const elem = _haystack$2[_];
                  if (_M0IPC14json4JsonPB2Eq5equal(elem, needle)) {
                    found = true;
                    break;
                  }
                  _tmp$62 = _ + 1 | 0;
                  continue;
                } else {
                  break;
                }
              }
              const _p$12 = found;
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$12 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
            }
            case 6: {
              const _Object$4 = input$2;
              const _haystack$3 = _Object$4._0;
              if (needle.$tag === 4) {
                const _String$3 = needle;
                const _key$2 = _String$3._0;
                const _p$13 = _M0MPB3Map8containsGsRPB4JsonE(_haystack$3, _key$2);
                return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$13 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
              } else {
                break _L$5;
              }
            }
            default: {
              break _L$5;
            }
          }
        }
        const _p$12 = false;
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$12 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
      }
      case 43: {
        const _Inside = expr$2;
        const _expr$6 = _Inside._0;
        const _bind$27 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_expr$6, input$2, env$2);
        let _tmp$62;
        if (_bind$27.$tag === 1) {
          const _ok = _bind$27;
          _tmp$62 = _ok._0;
        } else {
          return _bind$27;
        }
        const container_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$62);
        if (container_results.length === 0) {
          const _p$13 = false;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$13 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
        }
        const container = _M0MPC15array5Array2atGUssEE(container_results, 0);
        _L$6: {
          switch (input$2.$tag) {
            case 4: {
              const _String$2 = input$2;
              const _needle = _String$2._0;
              switch (container.$tag) {
                case 4: {
                  const _String$3 = container;
                  const _haystack = _String$3._0;
                  const _p$13 = _M0MPC16string6String8contains(_haystack, new _M0TPC16string10StringView(_needle, 0, _needle.length));
                  return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$13 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
                }
                case 6: {
                  const _Object$4 = container;
                  const _haystack$2 = _Object$4._0;
                  const _p$14 = _M0MPB3Map8containsGsRPB4JsonE(_haystack$2, _needle);
                  return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$14 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
                }
                default: {
                  break _L$6;
                }
              }
            }
            case 5: {
              const _Array$4 = input$2;
              const _needle_arr = _Array$4._0;
              if (container.$tag === 5) {
                const _Array$5 = container;
                const _haystack$3 = _Array$5._0;
                let all_found = true;
                const _bind$28 = _needle_arr.length;
                let _tmp$63 = 0;
                while (true) {
                  const _ = _tmp$63;
                  if (_ < _bind$28) {
                    const needle_elem = _needle_arr[_];
                    let found = false;
                    const _bind$29 = _haystack$3.length;
                    let _tmp$64 = 0;
                    while (true) {
                      const _$2 = _tmp$64;
                      if (_$2 < _bind$29) {
                        const haystack_elem = _haystack$3[_$2];
                        if (_M0IPC14json4JsonPB2Eq5equal(haystack_elem, needle_elem)) {
                          found = true;
                          break;
                        }
                        _tmp$64 = _$2 + 1 | 0;
                        continue;
                      } else {
                        break;
                      }
                    }
                    if (!found) {
                      all_found = false;
                      break;
                    }
                    _tmp$63 = _ + 1 | 0;
                    continue;
                  } else {
                    break;
                  }
                }
                const _p$15 = all_found;
                return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$15 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
              } else {
                break _L$6;
              }
            }
            default: {
              break _L$6;
            }
          }
        }
        const _p$13 = false;
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$13 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
      }
      case 44: {
        const _Has = expr$2;
        const _key$2 = _Has._0;
        switch (input$2.$tag) {
          case 6: {
            const _Object$4 = input$2;
            const _obj$4 = _Object$4._0;
            const _p$14 = _M0MPB3Map8containsGsRPB4JsonE(_obj$4, _key$2);
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$14 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
          }
          case 5: {
            const _Array$4 = input$2;
            const _arr$4 = _Array$4._0;
            let idx_result;
            let _try_err$3;
            _L$7: {
              _L$8: {
                const _bind$28 = _M0FPC17strconv18parse__int_2einner(new _M0TPC16string10StringView(_key$2, 0, _key$2.length), 0);
                if (_bind$28.$tag === 1) {
                  const _ok = _bind$28;
                  idx_result = _ok._0;
                } else {
                  const _err = _bind$28;
                  _try_err$3 = _err._0;
                  break _L$8;
                }
                break _L$7;
              }
              const _p$15 = false;
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$15 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
            }
            const len$2 = _arr$4.length;
            const actual_idx = idx_result < 0 ? len$2 + idx_result | 0 : idx_result;
            const _p$15 = actual_idx >= 0 && actual_idx < len$2;
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$15 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
          }
          default: {
            const _p$16 = false;
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$16 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
          }
        }
      }
      case 45: {
        const _In = expr$2;
        const _expr$7 = _In._0;
        const _bind$28 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_expr$7, input$2, env$2);
        let _tmp$63;
        if (_bind$28.$tag === 1) {
          const _ok = _bind$28;
          _tmp$63 = _ok._0;
        } else {
          return _bind$28;
        }
        const container_results$2 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$63);
        if (container_results$2.length === 0) {
          const _p$17 = false;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$17 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
        }
        const _bind$29 = _M0MPC15array5Array2atGUssEE(container_results$2, 0);
        switch (_bind$29.$tag) {
          case 6: {
            const _Object$5 = _bind$29;
            const _obj$5 = _Object$5._0;
            if (input$2.$tag === 4) {
              const _String$2 = input$2;
              const _key$3 = _String$2._0;
              const _p$17 = _M0MPB3Map8containsGsRPB4JsonE(_obj$5, _key$3);
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$17 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
            } else {
              const _p$17 = false;
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$17 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
            }
          }
          case 5: {
            const _Array$5 = _bind$29;
            const _arr$5 = _Array$5._0;
            if (input$2.$tag === 3) {
              const _Number = input$2;
              const _n = _Number._0;
              const idx = _M0MPC16double6Double7to__int(_n);
              const len$3 = _arr$5.length;
              const actual_idx$2 = idx < 0 ? len$3 + idx | 0 : idx;
              const _p$17 = actual_idx$2 >= 0 && actual_idx$2 < len$3;
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$17 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
            } else {
              const _p$17 = false;
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$17 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
            }
          }
          default: {
            const _p$17 = false;
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$17 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
          }
        }
      }
      case 46: {
        switch (input$2.$tag) {
          case 6: {
            const _Object$6 = input$2;
            const _obj$6 = _Object$6._0;
            const entries = [];
            const _it$4 = _M0MPB3Map5iter2GssE(_obj$6);
            while (true) {
              const _bind$30 = _M0MPB5Iter24nextGssE(_it$4);
              if (_bind$30 === undefined) {
                break;
              } else {
                const _Some = _bind$30;
                const _x = _Some;
                const _k = _x._0;
                const _v = _x._1;
                const _bind$31 = [];
                const entry = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$31, 0, 0), undefined);
                _M0MPB3Map3setGsRPB4JsonE(entry, "key", new _M0DTPB4Json6String(_k));
                _M0MPB3Map3setGsRPB4JsonE(entry, "value", _v);
                _M0MPC15array5Array4pushGUssEE(entries, new _M0DTPB4Json6Object(entry));
                continue;
              }
            }
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(entries)));
          }
          case 5: {
            const _Array$6 = input$2;
            const _arr$6 = _Array$6._0;
            const entries$2 = [];
            let _tmp$64 = 0;
            while (true) {
              const i = _tmp$64;
              if (i < _arr$6.length) {
                const _bind$30 = [];
                const entry = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$30, 0, 0), undefined);
                const _p$18 = i + 0;
                const _p$19 = undefined;
                _M0MPB3Map3setGsRPB4JsonE(entry, "key", new _M0DTPB4Json6Number(_p$18, _p$19));
                _M0MPB3Map3setGsRPB4JsonE(entry, "value", _M0MPC15array5Array2atGUssEE(_arr$6, i));
                _M0MPC15array5Array4pushGUssEE(entries$2, new _M0DTPB4Json6Object(entry));
                _tmp$64 = i + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(entries$2)));
          }
          default: {
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("object/array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
          }
        }
      }
      case 47: {
        if (input$2.$tag === 5) {
          const _Array$7 = input$2;
          const _arr$7 = _Array$7._0;
          const _bind$30 = [];
          const result = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$30, 0, 0), undefined);
          const _bind$31 = _arr$7.length;
          let _tmp$65 = 0;
          while (true) {
            const _ = _tmp$65;
            if (_ < _bind$31) {
              const entry = _arr$7[_];
              if (entry.$tag === 6) {
                const _Object$7 = entry;
                const _obj$7 = _Object$7._0;
                const _bind$32 = _M0MPB3Map3getGsRPB4JsonE(_obj$7, "key");
                let key_opt;
                if (_bind$32 === undefined) {
                  key_opt = _M0MPB3Map3getGsRPB4JsonE(_obj$7, "name");
                } else {
                  const _Some = _bind$32;
                  const _k = _Some;
                  key_opt = _k;
                }
                const value_opt = _M0MPB3Map3getGsRPB4JsonE(_obj$7, "value");
                if (key_opt === undefined) {
                } else {
                  const _Some = key_opt;
                  const _k = _Some;
                  switch (_k.$tag) {
                    case 4: {
                      const _String$2 = _k;
                      const _key_str = _String$2._0;
                      if (value_opt === undefined) {
                      } else {
                        const _Some$2 = value_opt;
                        const _v = _Some$2;
                        _M0MPB3Map3setGsRPB4JsonE(result, _key_str, _v);
                      }
                      break;
                    }
                    case 3: {
                      const _Number = _k;
                      const _n = _Number._0;
                      if (value_opt === undefined) {
                      } else {
                        const _Some$2 = value_opt;
                        const _v = _Some$2;
                        _M0MPB3Map3setGsRPB4JsonE(result, _M0MPC13int3Int18to__string_2einner(_M0MPC16double6Double7to__int(_n), 10), _v);
                      }
                      break;
                    }
                  }
                }
              }
              _tmp$65 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Object(result)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 48: {
        const _WithEntries = expr$2;
        const _expr$8 = _WithEntries._0;
        _L$8: {
          switch (input$2.$tag) {
            case 6: {
              break _L$8;
            }
            case 5: {
              break _L$8;
            }
            default: {
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("object/array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
            }
          }
        }
        const _bind$30 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_M0DTP38bobzhang6moonjq3ast4Expr9ToEntries__, input$2, env$2);
        let _tmp$65;
        if (_bind$30.$tag === 1) {
          const _ok = _bind$30;
          _tmp$65 = _ok._0;
        } else {
          return _bind$30;
        }
        const entries_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$65);
        if (entries_results.length === 0) {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(input$2));
        }
        const entries_array = _M0MPC15array5Array2atGUssEE(entries_results, 0);
        const _bind$31 = _M0FP38bobzhang6moonjq3ast15eval__with__env(new _M0DTP38bobzhang6moonjq3ast4Expr3Map(_expr$8), entries_array, env$2);
        let _tmp$66;
        if (_bind$31.$tag === 1) {
          const _ok = _bind$31;
          _tmp$66 = _ok._0;
        } else {
          return _bind$31;
        }
        const mapped_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$66);
        if (mapped_results.length === 0) {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(input$2));
        }
        _tmp$38 = _M0DTP38bobzhang6moonjq3ast4Expr11FromEntries__;
        _tmp$39 = _M0MPC15array5Array2atGUssEE(mapped_results, 0);
        continue _L;
      }
      case 50: {
        const _Range = expr$2;
        const _n = _Range._0;
        const results$3 = [];
        let _tmp$67 = 0;
        while (true) {
          const i = _tmp$67;
          if (i < _n) {
            const _p$18 = i + 0;
            const _p$19 = undefined;
            _M0MPC15array5Array4pushGUssEE(results$3, new _M0DTPB4Json6Number(_p$18, _p$19));
            _tmp$67 = i + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPC15array5Array4iterGsE(results$3));
      }
      case 53: {
        if (input$2.$tag === 5) {
          const _Array$7 = input$2;
          const _arr$7 = _Array$7._0;
          return _arr$7.length === 0 ? new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter5emptyGRPB4JsonE()) : new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0MPC15array5Array2atGUssEE(_arr$7, 0)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 55: {
        if (input$2.$tag === 5) {
          const _Array$7 = input$2;
          const _arr$7 = _Array$7._0;
          return _arr$7.length === 0 ? new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter5emptyGRPB4JsonE()) : new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0MPC15array5Array2atGUssEE(_arr$7, _arr$7.length - 1 | 0)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 58: {
        const _IndicesOf = expr$2;
        const _expr$9 = _IndicesOf._0;
        const _bind$32 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_expr$9, input$2, env$2);
        let _tmp$68;
        if (_bind$32.$tag === 1) {
          const _ok = _bind$32;
          _tmp$68 = _ok._0;
        } else {
          return _bind$32;
        }
        const needle_results$2 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$68);
        if (needle_results$2.length === 0) {
          const _p$18 = [];
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(_p$18)));
        }
        const needle$2 = _M0MPC15array5Array2atGUssEE(needle_results$2, 0);
        switch (input$2.$tag) {
          case 5: {
            const _Array$7 = input$2;
            const _arr$7 = _Array$7._0;
            const indices$2 = [];
            let _tmp$69 = 0;
            while (true) {
              const i = _tmp$69;
              if (i < _arr$7.length) {
                if (_M0IPC14json4JsonPB2Eq5equal(_M0MPC15array5Array2atGUssEE(_arr$7, i), needle$2)) {
                  const _p$18 = i + 0;
                  const _p$19 = undefined;
                  _M0MPC15array5Array4pushGUssEE(indices$2, new _M0DTPB4Json6Number(_p$18, _p$19));
                }
                _tmp$69 = i + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(indices$2)));
          }
          case 4: {
            const _String$2 = input$2;
            const _s$2 = _String$2._0;
            if (needle$2.$tag === 4) {
              const _String$3 = needle$2;
              const _substr = _String$3._0;
              const indices$3 = [];
              if (_M0MPC16string6String8contains(_s$2, new _M0TPC16string10StringView(_substr, 0, _substr.length))) {
              }
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(indices$3)));
            } else {
              const _p$18 = [];
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(_p$18)));
            }
          }
          default: {
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array/string", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
          }
        }
      }
      case 59: {
        const _IndexOf = expr$2;
        const _expr$10 = _IndexOf._0;
        const _bind$33 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_expr$10, input$2, env$2);
        let _tmp$70;
        if (_bind$33.$tag === 1) {
          const _ok = _bind$33;
          _tmp$70 = _ok._0;
        } else {
          return _bind$33;
        }
        const needle_results$3 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$70);
        if (needle_results$3.length === 0) {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
        }
        const needle$3 = _M0MPC15array5Array2atGUssEE(needle_results$3, 0);
        switch (input$2.$tag) {
          case 5: {
            const _Array$8 = input$2;
            const _arr$8 = _Array$8._0;
            let found_idx = undefined;
            let _tmp$71 = 0;
            while (true) {
              const i = _tmp$71;
              if (i < _arr$8.length) {
                if (_M0IPC14json4JsonPB2Eq5equal(_M0MPC15array5Array2atGUssEE(_arr$8, i), needle$3)) {
                  found_idx = i;
                  break;
                }
                _tmp$71 = i + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            const _bind$34 = found_idx;
            if (_bind$34 === undefined) {
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
            } else {
              const _Some = _bind$34;
              const _idx = _Some;
              const _p$18 = _idx + 0;
              const _p$19 = undefined;
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Number(_p$18, _p$19)));
            }
          }
          case 4: {
            const _String$3 = input$2;
            const _s$3 = _String$3._0;
            if (needle$3.$tag === 4) {
              const _String$4 = needle$3;
              const _substr = _String$4._0;
              if (_M0MPC16string6String8contains(_s$3, new _M0TPC16string10StringView(_substr, 0, _substr.length))) {
                const _p$18 = 0;
                const _p$19 = undefined;
                return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Number(_p$18, _p$19)));
              } else {
                return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
              }
            } else {
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
            }
          }
          default: {
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array/string", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
          }
        }
      }
      case 60: {
        if (input$2.$tag === 5) {
          const _Array$9 = input$2;
          const _arr$9 = _Array$9._0;
          let result = false;
          const _bind$35 = _arr$9.length;
          let _tmp$72 = 0;
          _L$9: while (true) {
            const _ = _tmp$72;
            if (_ < _bind$35) {
              const elem = _arr$9[_];
              switch (elem.$tag) {
                case 2: {
                  break;
                }
                case 0: {
                  break;
                }
                default: {
                  result = true;
                  break _L$9;
                }
              }
              _tmp$72 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          const _p$18 = result;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$18 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 62: {
        if (input$2.$tag === 5) {
          const _Array$9 = input$2;
          const _arr$9 = _Array$9._0;
          let result = true;
          const _bind$35 = _arr$9.length;
          let _tmp$72 = 0;
          while (true) {
            const _ = _tmp$72;
            if (_ < _bind$35) {
              const elem = _arr$9[_];
              _L$9: {
                _L$10: {
                  switch (elem.$tag) {
                    case 2: {
                      break _L$10;
                    }
                    case 0: {
                      break _L$10;
                    }
                  }
                  break _L$9;
                }
                result = false;
                break;
              }
              _tmp$72 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          const _p$18 = result;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$18 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 87: {
        const _LTrimStr = expr$2;
        const _prefix$2 = _LTrimStr._0;
        if (input$2.$tag === 4) {
          const _String$4 = input$2;
          const _s$4 = _String$4._0;
          const _bind$35 = _M0MPC16string6String13strip__prefix(_s$4, new _M0TPC16string10StringView(_prefix$2, 0, _prefix$2.length));
          if (_bind$35 === undefined) {
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(input$2));
          } else {
            const _Some = _bind$35;
            const _rest = _Some;
            const _p$18 = _M0MPC16string10StringView9to__owned(_rest);
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6String(_p$18)));
          }
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("string", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 88: {
        const _RTrimStr = expr$2;
        const _suffix$2 = _RTrimStr._0;
        if (input$2.$tag === 4) {
          const _String$4 = input$2;
          const _s$4 = _String$4._0;
          const _bind$35 = _M0MPC16string6String13strip__suffix(_s$4, new _M0TPC16string10StringView(_suffix$2, 0, _suffix$2.length));
          if (_bind$35 === undefined) {
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(input$2));
          } else {
            const _Some = _bind$35;
            const _rest = _Some;
            const _p$18 = _M0MPC16string10StringView9to__owned(_rest);
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6String(_p$18)));
          }
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("string", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 89: {
        if (input$2.$tag === 4) {
          const _String$4 = input$2;
          const _s$4 = _String$4._0;
          const result = _M0FPC16buffer11new_2einner(0);
          const _it$5 = _M0MPC16string6String4iter(_s$4);
          while (true) {
            const _bind$35 = _M0MPB4Iter4nextGcE(_it$5);
            if (_bind$35 === -1) {
              break;
            } else {
              const _Some = _bind$35;
              const _ch = _Some;
              if (_ch >= 97 && _ch <= 122) {
                _M0IPC16buffer6BufferPB6Logger11write__char(result, _ch - 32 | 0);
              } else {
                _M0IPC16buffer6BufferPB6Logger11write__char(result, _ch);
              }
              continue;
            }
          }
          const _p$18 = _M0IP016_24default__implPB4Show10to__stringGRPC16buffer6BufferE(result);
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6String(_p$18)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("string", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 90: {
        if (input$2.$tag === 4) {
          const _String$4 = input$2;
          const _s$4 = _String$4._0;
          const result = _M0FPC16buffer11new_2einner(0);
          const _it$5 = _M0MPC16string6String4iter(_s$4);
          while (true) {
            const _bind$35 = _M0MPB4Iter4nextGcE(_it$5);
            if (_bind$35 === -1) {
              break;
            } else {
              const _Some = _bind$35;
              const _ch = _Some;
              if (_ch >= 65 && _ch <= 90) {
                _M0IPC16buffer6BufferPB6Logger11write__char(result, _ch + 32 | 0);
              } else {
                _M0IPC16buffer6BufferPB6Logger11write__char(result, _ch);
              }
              continue;
            }
          }
          const _p$18 = _M0IP016_24default__implPB4Show10to__stringGRPC16buffer6BufferE(result);
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6String(_p$18)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("string", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 95: {
        const _Nth = expr$2;
        const _n$2 = _Nth._0;
        if (input$2.$tag === 5) {
          const _Array$9 = input$2;
          const _arr$9 = _Array$9._0;
          return _n$2 >= 0 && _n$2 < _arr$9.length ? new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0MPC15array5Array2atGUssEE(_arr$9, _n$2))) : _n$2 < 0 && (-_n$2 | 0) <= _arr$9.length ? new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0MPC15array5Array2atGUssEE(_arr$9, _arr$9.length + _n$2 | 0))) : new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter5emptyGRPB4JsonE());
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 96: {
        const _RIndex = expr$2;
        const _search_expr = _RIndex._0;
        const _bind$35 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_search_expr, input$2, env$2);
        let _tmp$72;
        if (_bind$35.$tag === 1) {
          const _ok = _bind$35;
          _tmp$72 = _ok._0;
        } else {
          return _bind$35;
        }
        const needle_results$4 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$72);
        if (needle_results$4.length === 0) {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
        }
        const needle$4 = _M0MPC15array5Array2atGUssEE(needle_results$4, 0);
        switch (input$2.$tag) {
          case 5: {
            const _Array$9 = input$2;
            const _arr$9 = _Array$9._0;
            let last_index = undefined;
            let _tmp$73 = 0;
            while (true) {
              const i = _tmp$73;
              if (i < _arr$9.length) {
                if (_M0IPC14json4JsonPB2Eq5equal(_M0MPC15array5Array2atGUssEE(_arr$9, i), needle$4)) {
                  last_index = i;
                }
                _tmp$73 = i + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            const _bind$36 = last_index;
            if (_bind$36 === undefined) {
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
            } else {
              const _Some = _bind$36;
              const _idx = _Some;
              const _p$18 = _idx + 0;
              const _p$19 = undefined;
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Number(_p$18, _p$19)));
            }
          }
          case 4: {
            const _String$4 = input$2;
            const _s$4 = _String$4._0;
            if (needle$4.$tag === 4) {
              const _String$5 = needle$4;
              const _substr = _String$5._0;
              const _bind$37 = _M0MPC16string6String9rev__find(_s$4, new _M0TPC16string10StringView(_substr, 0, _substr.length));
              if (_bind$37 === undefined) {
                return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
              } else {
                const _Some = _bind$37;
                const _pos = _Some;
                const _p$18 = _pos + 0;
                const _p$19 = undefined;
                return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Number(_p$18, _p$19)));
              }
            } else {
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
            }
          }
          default: {
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array or string", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
          }
        }
      }
      case 97: {
        const paths_list = [];
        _M0FP38bobzhang6moonjq3ast15eval__with__envN14collect__pathsS588(paths_list, input$2, []);
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPC15array5Array4iterGsE(paths_list));
      }
      case 99: {
        const paths_list$2 = [];
        _M0FP38bobzhang6moonjq3ast15eval__with__envN20collect__leaf__pathsS599(paths_list$2, input$2, []);
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPC15array5Array4iterGsE(paths_list$2));
      }
      case 100: {
        const _GetPath = expr$2;
        const _path_expr = _GetPath._0;
        const _bind$37 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_path_expr, input$2, env$2);
        let _tmp$74;
        if (_bind$37.$tag === 1) {
          const _ok = _bind$37;
          _tmp$74 = _ok._0;
        } else {
          return _bind$37;
        }
        const path_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$74);
        if (path_results.length === 0) {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
        }
        const _bind$38 = _M0MPC15array5Array2atGUssEE(path_results, 0);
        if (_bind$38.$tag === 5) {
          const _Array$10 = _bind$38;
          const _path_arr = _Array$10._0;
          let current = input$2;
          const _bind$39 = _path_arr.length;
          let _tmp$75 = 0;
          while (true) {
            const _ = _tmp$75;
            if (_ < _bind$39) {
              const segment = _path_arr[_];
              _L$9: {
                _L$10: {
                  const _bind$40 = current;
                  switch (_bind$40.$tag) {
                    case 6: {
                      const _Object$7 = _bind$40;
                      const _obj$7 = _Object$7._0;
                      if (segment.$tag === 4) {
                        const _String$5 = segment;
                        const _key$3 = _String$5._0;
                        const _bind$41 = _M0MPB3Map3getGsRPB4JsonE(_obj$7, _key$3);
                        if (_bind$41 === undefined) {
                          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
                        } else {
                          const _Some = _bind$41;
                          const _v = _Some;
                          current = _v;
                        }
                      } else {
                        break _L$10;
                      }
                      break;
                    }
                    case 5: {
                      const _Array$11 = _bind$40;
                      const _arr$10 = _Array$11._0;
                      if (segment.$tag === 3) {
                        const _Number = segment;
                        const _idx = _Number._0;
                        const i = _M0MPC16double6Double7to__int(_idx);
                        if (i >= 0 && i < _arr$10.length) {
                          current = _M0MPC15array5Array2atGUssEE(_arr$10, i);
                        } else {
                          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
                        }
                      } else {
                        break _L$10;
                      }
                      break;
                    }
                    default: {
                      break _L$10;
                    }
                  }
                  break _L$9;
                }
                return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
              }
              _tmp$75 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(current));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
        }
      }
      case 101: {
        const _SetPath = expr$2;
        const _path_expr$2 = _SetPath._0;
        const _value_expr$8 = _SetPath._1;
        const _bind$39 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_path_expr$2, input$2, env$2);
        let _tmp$75;
        if (_bind$39.$tag === 1) {
          const _ok = _bind$39;
          _tmp$75 = _ok._0;
        } else {
          return _bind$39;
        }
        const path_results$2 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$75);
        const _bind$40 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_value_expr$8, input$2, env$2);
        let _tmp$76;
        if (_bind$40.$tag === 1) {
          const _ok = _bind$40;
          _tmp$76 = _ok._0;
        } else {
          return _bind$40;
        }
        const value_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$76);
        if (path_results$2.length === 0 || value_results.length === 0) {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(input$2));
        }
        const _bind$41 = _M0MPC15array5Array2atGUssEE(path_results$2, 0);
        if (_bind$41.$tag === 5) {
          const _Array$10 = _bind$41;
          const _path_arr = _Array$10._0;
          return _path_arr.length === 0 ? new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0MPC15array5Array2atGUssEE(value_results, 0))) : new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0FP38bobzhang6moonjq3ast13set__at__path(input$2, _path_arr, _M0MPC15array5Array2atGUssEE(value_results, 0))));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(input$2));
        }
      }
      case 102: {
        const _DelPaths = expr$2;
        const _paths_expr = _DelPaths._0;
        const _bind$42 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_paths_expr, input$2, env$2);
        let _tmp$77;
        if (_bind$42.$tag === 1) {
          const _ok = _bind$42;
          _tmp$77 = _ok._0;
        } else {
          return _bind$42;
        }
        const paths_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$77);
        if (paths_results.length === 0) {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(input$2));
        }
        const _bind$43 = _M0MPC15array5Array2atGUssEE(paths_results, 0);
        if (_bind$43.$tag === 5) {
          const _Array$10 = _bind$43;
          const _paths_arr = _Array$10._0;
          let result = input$2;
          const _bind$44 = _paths_arr.length;
          let _tmp$78 = 0;
          while (true) {
            const _ = _tmp$78;
            if (_ < _bind$44) {
              const path_json = _paths_arr[_];
              if (path_json.$tag === 5) {
                const _Array$11 = path_json;
                const _path$8 = _Array$11._0;
                result = _M0FP38bobzhang6moonjq3ast16delete__at__path(result, _path$8);
              }
              _tmp$78 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(result));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(input$2));
        }
      }
      case 103: {
        const _Limit = expr$2;
        const _n$3 = _Limit._0;
        const _expr$11 = _Limit._1;
        const _bind$44 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_expr$11, input$2, env$2);
        let _tmp$78;
        if (_bind$44.$tag === 1) {
          const _ok = _bind$44;
          _tmp$78 = _ok._0;
        } else {
          return _bind$44;
        }
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter4takeGRPB4JsonE(_tmp$78, _n$3));
      }
      case 104: {
        const _Until = expr$2;
        const _cond_expr = _Until._0;
        const _update_expr$3 = _Until._1;
        let current = input$2;
        while (true) {
          const _bind$45 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_cond_expr, current, env$2);
          let _tmp$79;
          if (_bind$45.$tag === 1) {
            const _ok = _bind$45;
            _tmp$79 = _ok._0;
          } else {
            return _bind$45;
          }
          const cond_results$3 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$79);
          if (cond_results$3.length === 0) {
            break;
          }
          const _bind$46 = _M0MPC15array5Array2atGUssEE(cond_results$3, 0);
          if (_bind$46.$tag === 1) {
            break;
          } else {
            const _bind$47 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_update_expr$3, current, env$2);
            let _tmp$80;
            if (_bind$47.$tag === 1) {
              const _ok = _bind$47;
              _tmp$80 = _ok._0;
            } else {
              return _bind$47;
            }
            const update_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$80);
            if (update_results.length === 0) {
              break;
            }
            current = _M0MPC15array5Array2atGUssEE(update_results, 0);
          }
          continue;
        }
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(current));
      }
      case 105: {
        const _While = expr$2;
        const _cond_expr$2 = _While._0;
        const _update_expr$4 = _While._1;
        const results$4 = [];
        let current$2 = input$2;
        _L$9: while (true) {
          const _bind$45 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_cond_expr$2, current$2, env$2);
          let _tmp$79;
          if (_bind$45.$tag === 1) {
            const _ok = _bind$45;
            _tmp$79 = _ok._0;
          } else {
            return _bind$45;
          }
          const cond_results$3 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$79);
          if (cond_results$3.length === 0) {
            break;
          }
          _L$10: {
            _L$11: {
              const _bind$46 = _M0MPC15array5Array2atGUssEE(cond_results$3, 0);
              switch (_bind$46.$tag) {
                case 2: {
                  break _L$11;
                }
                case 0: {
                  break _L$11;
                }
                default: {
                  _M0MPC15array5Array4pushGUssEE(results$4, current$2);
                  const _bind$47 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_update_expr$4, current$2, env$2);
                  let _tmp$80;
                  if (_bind$47.$tag === 1) {
                    const _ok = _bind$47;
                    _tmp$80 = _ok._0;
                  } else {
                    return _bind$47;
                  }
                  const update_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$80);
                  if (update_results.length === 0) {
                    break _L$9;
                  }
                  current$2 = _M0MPC15array5Array2atGUssEE(update_results, 0);
                }
              }
              break _L$10;
            }
            break;
          }
          continue;
        }
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPC15array5Array4iterGsE(results$4));
      }
      case 106: {
        const _Pow = expr$2;
        const _exp_expr = _Pow._0;
        const _bind$45 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_exp_expr, input$2, env$2);
        let _tmp$79;
        if (_bind$45.$tag === 1) {
          const _ok = _bind$45;
          _tmp$79 = _ok._0;
        } else {
          return _bind$45;
        }
        const exp_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$79);
        if (exp_results.length === 0) {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
        }
        _L$10: {
          const _bind$46 = _M0MPC15array5Array2atGUssEE(exp_results, 0);
          if (input$2.$tag === 3) {
            const _Number = input$2;
            const _base = _Number._0;
            if (_bind$46.$tag === 3) {
              const _Number$2 = _bind$46;
              const _exp = _Number$2._0;
              const _p$18 = _M0MPC16double6Double3pow(_base, _exp);
              const _p$19 = undefined;
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Number(_p$18, _p$19)));
            } else {
              break _L$10;
            }
          } else {
            break _L$10;
          }
        }
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("number", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
      }
      case 107: {
        if (input$2.$tag === 3) {
          const _Number = input$2;
          const _n$4 = _Number._0;
          const _p$18 = _M0FPC14math2ln(_n$4);
          const _p$19 = undefined;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Number(_p$18, _p$19)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("number", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 108: {
        if (input$2.$tag === 3) {
          const _Number = input$2;
          const _n$4 = _Number._0;
          const _p$18 = _M0FPC14math3exp(_n$4);
          const _p$19 = undefined;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Number(_p$18, _p$19)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("number", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 109: {
        if (input$2.$tag === 3) {
          const _Number = input$2;
          const _n$4 = _Number._0;
          const _p$18 = _M0FPC14math3sin(_n$4);
          const _p$19 = undefined;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Number(_p$18, _p$19)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("number", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 110: {
        if (input$2.$tag === 3) {
          const _Number = input$2;
          const _n$4 = _Number._0;
          const _p$18 = _M0FPC14math3cos(_n$4);
          const _p$19 = undefined;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Number(_p$18, _p$19)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("number", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 111: {
        if (input$2.$tag === 3) {
          const _Number = input$2;
          const _n$4 = _Number._0;
          const _p$18 = _M0FPC14math3tan(_n$4);
          const _p$19 = undefined;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Number(_p$18, _p$19)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("number", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 112: {
        if (input$2.$tag === 3) {
          const _Number = input$2;
          const _n$4 = _Number._0;
          const _p$18 = _M0FPC14math4asin(_n$4);
          const _p$19 = undefined;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Number(_p$18, _p$19)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("number", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 113: {
        if (input$2.$tag === 3) {
          const _Number = input$2;
          const _n$4 = _Number._0;
          const _p$18 = _M0FPC14math4acos(_n$4);
          const _p$19 = undefined;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Number(_p$18, _p$19)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("number", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 114: {
        if (input$2.$tag === 3) {
          const _Number = input$2;
          const _n$4 = _Number._0;
          const _p$18 = _M0FPC14math4atan(_n$4);
          const _p$19 = undefined;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Number(_p$18, _p$19)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("number", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 115: {
        const _Test = expr$2;
        const _pattern = _Test._0;
        if (input$2.$tag === 4) {
          const _String$5 = input$2;
          const _s$5 = _String$5._0;
          const _p$18 = _M0MPC16string6String8contains(_s$5, new _M0TPC16string10StringView(_pattern, 0, _pattern.length));
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$18 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("string", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 116: {
        const _Match = expr$2;
        const _pattern$2 = _Match._0;
        if (input$2.$tag === 4) {
          const _String$5 = input$2;
          const _s$5 = _String$5._0;
          if (_M0MPC16string6String8contains(_s$5, new _M0TPC16string10StringView(_pattern$2, 0, _pattern$2.length))) {
            const _tmp$80 = { _0: "match", _1: new _M0DTPB4Json6String(_pattern$2) };
            const _p$18 = 0;
            const _p$19 = undefined;
            const _tmp$81 = { _0: "offset", _1: new _M0DTPB4Json6Number(_p$18, _p$19) };
            const _p$20 = _pattern$2.length + 0;
            const _p$21 = undefined;
            const _tmp$82 = { _0: "length", _1: new _M0DTPB4Json6Number(_p$20, _p$21) };
            const _tmp$83 = { _0: "string", _1: new _M0DTPB4Json6String(_s$5) };
            const _p$22 = [];
            const _bind$46 = [_tmp$80, _tmp$81, _tmp$82, _tmp$83, { _0: "captures", _1: new _M0DTPB4Json5Array(_p$22) }];
            const _p$23 = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$46, 0, 5), undefined);
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Object(_p$23)));
          } else {
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter5emptyGRPB4JsonE());
          }
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("string", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 117: {
        if (input$2.$tag === 4) {
          const _bind$46 = [];
          const _p$18 = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$46, 0, 0), undefined);
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Object(_p$18)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("string", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 119: {
        const _Splits = expr$2;
        const _pattern$3 = _Splits._0;
        if (input$2.$tag === 4) {
          const _String$5 = input$2;
          const _s$5 = _String$5._0;
          const parts = _M0MPB4Iter9to__arrayGRPB4JsonE(_M0MPC16string6String5split(_s$5, new _M0TPC16string10StringView(_pattern$3, 0, _pattern$3.length)));
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter3mapGRPC16string10StringViewRPB4JsonE(_M0MPC15array5Array4iterGsE(parts), (part) => {
            const _p$18 = _M0MPC16string10StringView9to__owned(part);
            return new _M0DTPB4Json6String(_p$18);
          }));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("string", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 120: {
        const _Sub = expr$2;
        const _pattern$4 = _Sub._0;
        const _replacement = _Sub._1;
        if (input$2.$tag === 4) {
          const _String$5 = input$2;
          const _s$5 = _String$5._0;
          const _p$18 = _M0MPC16string6String7replace(_s$5, new _M0TPC16string10StringView(_pattern$4, 0, _pattern$4.length), new _M0TPC16string10StringView(_replacement, 0, _replacement.length));
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6String(_p$18)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("string", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 121: {
        const _GSub = expr$2;
        const _pattern$5 = _GSub._0;
        const _replacement$2 = _GSub._1;
        if (input$2.$tag === 4) {
          const _String$5 = input$2;
          const _s$5 = _String$5._0;
          const _p$18 = _M0MPC16string6String12replace__all(_s$5, new _M0TPC16string10StringView(_pattern$5, 0, _pattern$5.length), new _M0TPC16string10StringView(_replacement$2, 0, _replacement$2.length));
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6String(_p$18)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("string", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 49: {
        const _MapValues = expr$2;
        const _expr$12 = _MapValues._0;
        if (input$2.$tag === 6) {
          const _Object$7 = input$2;
          const _obj$7 = _Object$7._0;
          const _bind$46 = [];
          const result = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$46, 0, 0), undefined);
          const _it$5 = _M0MPB3Map5iter2GssE(_obj$7);
          while (true) {
            const _bind$47 = _M0MPB5Iter24nextGssE(_it$5);
            if (_bind$47 === undefined) {
              break;
            } else {
              const _Some = _bind$47;
              const _x = _Some;
              const _key$3 = _x._0;
              const _value = _x._1;
              const _bind$48 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_expr$12, _value, env$2);
              let _tmp$80;
              if (_bind$48.$tag === 1) {
                const _ok = _bind$48;
                _tmp$80 = _ok._0;
              } else {
                return _bind$48;
              }
              const transformed_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$80);
              if (!(transformed_results.length === 0)) {
                _M0MPB3Map3setGsRPB4JsonE(result, _key$3, _M0MPC15array5Array2atGUssEE(transformed_results, 0));
              }
              continue;
            }
          }
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6Object(result)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("object", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 51: {
        const _RangeFromTo = expr$2;
        const _from_expr = _RangeFromTo._0;
        const _to_expr = _RangeFromTo._1;
        const _bind$46 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_from_expr, input$2, env$2);
        let _tmp$80;
        if (_bind$46.$tag === 1) {
          const _ok = _bind$46;
          _tmp$80 = _ok._0;
        } else {
          return _bind$46;
        }
        const from_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$80);
        const _bind$47 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_to_expr, input$2, env$2);
        let _tmp$81;
        if (_bind$47.$tag === 1) {
          const _ok = _bind$47;
          _tmp$81 = _ok._0;
        } else {
          return _bind$47;
        }
        const to_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$81);
        if (from_results.length === 0 || to_results.length === 0) {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter5emptyGRPB4JsonE());
        }
        _L$11: {
          const _bind$48 = _M0MPC15array5Array2atGUssEE(from_results, 0);
          const _bind$49 = _M0MPC15array5Array2atGUssEE(to_results, 0);
          if (_bind$48.$tag === 3) {
            const _Number = _bind$48;
            const _from_num = _Number._0;
            if (_bind$49.$tag === 3) {
              const _Number$2 = _bind$49;
              const _to_num = _Number$2._0;
              const from_int = _M0MPC16double6Double7to__int(_from_num);
              const to_int = _M0MPC16double6Double7to__int(_to_num);
              const results$5 = [];
              let _tmp$82 = from_int;
              while (true) {
                const i = _tmp$82;
                if (i < to_int) {
                  const _p$18 = i + 0;
                  const _p$19 = undefined;
                  _M0MPC15array5Array4pushGUssEE(results$5, new _M0DTPB4Json6Number(_p$18, _p$19));
                  _tmp$82 = i + 1 | 0;
                  continue;
                } else {
                  break;
                }
              }
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPC15array5Array4iterGsE(results$5));
            } else {
              break _L$11;
            }
          } else {
            break _L$11;
          }
        }
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("numbers", "non-numbers"));
      }
      case 52: {
        const _RangeWithStep = expr$2;
        const _from_expr$2 = _RangeWithStep._0;
        const _to_expr$2 = _RangeWithStep._1;
        const _step_expr = _RangeWithStep._2;
        const _bind$48 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_from_expr$2, input$2, env$2);
        let _tmp$82;
        if (_bind$48.$tag === 1) {
          const _ok = _bind$48;
          _tmp$82 = _ok._0;
        } else {
          return _bind$48;
        }
        const from_results$2 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$82);
        const _bind$49 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_to_expr$2, input$2, env$2);
        let _tmp$83;
        if (_bind$49.$tag === 1) {
          const _ok = _bind$49;
          _tmp$83 = _ok._0;
        } else {
          return _bind$49;
        }
        const to_results$2 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$83);
        const _bind$50 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_step_expr, input$2, env$2);
        let _tmp$84;
        if (_bind$50.$tag === 1) {
          const _ok = _bind$50;
          _tmp$84 = _ok._0;
        } else {
          return _bind$50;
        }
        const step_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$84);
        if (from_results$2.length === 0 || (to_results$2.length === 0 || step_results.length === 0)) {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter5emptyGRPB4JsonE());
        }
        _L$12: {
          const _bind$51 = _M0MPC15array5Array2atGUssEE(from_results$2, 0);
          const _bind$52 = _M0MPC15array5Array2atGUssEE(to_results$2, 0);
          const _bind$53 = _M0MPC15array5Array2atGUssEE(step_results, 0);
          if (_bind$51.$tag === 3) {
            const _Number = _bind$51;
            const _from_num = _Number._0;
            if (_bind$52.$tag === 3) {
              const _Number$2 = _bind$52;
              const _to_num = _Number$2._0;
              if (_bind$53.$tag === 3) {
                const _Number$3 = _bind$53;
                const _step_num = _Number$3._0;
                const from_int = _M0MPC16double6Double7to__int(_from_num);
                const to_int = _M0MPC16double6Double7to__int(_to_num);
                const step_int = _M0MPC16double6Double7to__int(_step_num);
                const results$5 = [];
                if (step_int > 0) {
                  let i = from_int;
                  while (true) {
                    if (i < to_int) {
                      const _p$18 = i + 0;
                      const _p$19 = undefined;
                      _M0MPC15array5Array4pushGUssEE(results$5, new _M0DTPB4Json6Number(_p$18, _p$19));
                      i = i + step_int | 0;
                      continue;
                    } else {
                      break;
                    }
                  }
                } else {
                  if (step_int < 0) {
                    let i = from_int;
                    while (true) {
                      if (i > to_int) {
                        const _p$18 = i + 0;
                        const _p$19 = undefined;
                        _M0MPC15array5Array4pushGUssEE(results$5, new _M0DTPB4Json6Number(_p$18, _p$19));
                        i = i + step_int | 0;
                        continue;
                      } else {
                        break;
                      }
                    }
                  }
                }
                return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPC15array5Array4iterGsE(results$5));
              } else {
                break _L$12;
              }
            } else {
              break _L$12;
            }
          } else {
            break _L$12;
          }
        }
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("numbers", "non-numbers"));
      }
      case 54: {
        const _FirstGen = expr$2;
        const _gen_expr = _FirstGen._0;
        const _bind$51 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_gen_expr, input$2, env$2);
        let _tmp$85;
        if (_bind$51.$tag === 1) {
          const _ok = _bind$51;
          _tmp$85 = _ok._0;
        } else {
          return _bind$51;
        }
        const gen_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$85);
        return gen_results.length === 0 ? new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter5emptyGRPB4JsonE()) : new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0MPC15array5Array2atGUssEE(gen_results, 0)));
      }
      case 56: {
        const _LastGen = expr$2;
        const _gen_expr$2 = _LastGen._0;
        const _bind$52 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_gen_expr$2, input$2, env$2);
        let _tmp$86;
        if (_bind$52.$tag === 1) {
          const _ok = _bind$52;
          _tmp$86 = _ok._0;
        } else {
          return _bind$52;
        }
        const gen_results$2 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$86);
        return gen_results$2.length === 0 ? new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter5emptyGRPB4JsonE()) : new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0MPC15array5Array2atGUssEE(gen_results$2, gen_results$2.length - 1 | 0)));
      }
      case 57: {
        const _Repeat = expr$2;
        const _expr$13 = _Repeat._0;
        const _bind$53 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_expr$13, input$2, env$2);
        let _tmp$87;
        if (_bind$53.$tag === 1) {
          const _ok = _bind$53;
          _tmp$87 = _ok._0;
        } else {
          return _bind$53;
        }
        const values$3 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$87);
        if (values$3.length === 0) {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter5emptyGRPB4JsonE());
        }
        const i = new _M0TPB8MutLocalGiE(0);
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter3newGUssEE(() => {
          const result = _M0MPC15array5Array2atGUssEE(values$3, i.val);
          i.val = i.val + 1 | 0;
          if (i.val >= values$3.length) {
            i.val = 0;
          }
          return result;
        }, undefined));
      }
      case 91: {
        if (input$2.$tag === 4) {
          const _String$5 = input$2;
          const _s$5 = _String$5._0;
          const results$5 = [];
          const _it$5 = _M0MPC16string6String4iter(_s$5);
          while (true) {
            const _bind$54 = _M0MPB4Iter4nextGcE(_it$5);
            if (_bind$54 === -1) {
              break;
            } else {
              const _Some = _bind$54;
              const _char = _Some;
              const _p$18 = _char + 0;
              const _p$19 = undefined;
              _M0MPC15array5Array4pushGUssEE(results$5, new _M0DTPB4Json6Number(_p$18, _p$19));
              continue;
            }
          }
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(results$5)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("string", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 92: {
        if (input$2.$tag === 5) {
          const _Array$10 = input$2;
          const _arr$10 = _Array$10._0;
          const buffer = _M0FPC16buffer11new_2einner(0);
          const _bind$54 = _arr$10.length;
          let _tmp$88 = 0;
          while (true) {
            const _ = _tmp$88;
            if (_ < _bind$54) {
              const elem = _arr$10[_];
              if (elem.$tag === 3) {
                const _Number = elem;
                const _n$4 = _Number._0;
                const code = _M0MPC16double6Double7to__int(_n$4);
                const _bind$55 = _M0MPC13int3Int8to__char(code);
                if (_bind$55 === -1) {
                } else {
                  const _Some = _bind$55;
                  const _c = _Some;
                  _M0IPC16buffer6BufferPB6Logger11write__char(buffer, _c);
                }
              }
              _tmp$88 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          const _p$18 = _M0IP016_24default__implPB4Show10to__stringGRPC16buffer6BufferE(buffer);
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6String(_p$18)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 93: {
        const _p$18 = _M0IP016_24default__implPB4Show10to__stringGRPB4JsonE(input$2);
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json6String(_p$18)));
      }
      case 94: {
        if (input$2.$tag === 4) {
          const _String$5 = input$2;
          const _s$5 = _String$5._0;
          let parsed;
          let _try_err$4;
          _L$13: {
            _L$14: {
              const _bind$54 = _M0FPC14json13parse_2einner(new _M0TPC16string10StringView(_s$5, 0, _s$5.length), 1024);
              if (_bind$54.$tag === 1) {
                const _ok = _bind$54;
                parsed = _ok._0;
              } else {
                const _err = _bind$54;
                _try_err$4 = _err._0;
                break _L$14;
              }
              break _L$13;
            }
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error61bobzhang_2fmoonjq_2fast_2eInterpreterError_2eInvalidOperation(`JSON parse error: ${_M0IP016_24default__implPB4Show10to__stringGRPC14json10ParseErrorE(_try_err$4)}`));
          }
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(parsed));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("string", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 24: {
        const _UniqueBy = expr$2;
        const _expr$14 = _UniqueBy._0;
        if (input$2.$tag === 5) {
          const _Array$10 = input$2;
          const _arr$10 = _Array$10._0;
          const _bind$54 = [];
          const seen = _M0MPB3Map3MapGsbE(new _M0TPB9ArrayViewGUsbEE(_bind$54, 0, 0), undefined);
          const results$5 = [];
          const _bind$55 = _arr$10.length;
          let _tmp$88 = 0;
          while (true) {
            const _ = _tmp$88;
            if (_ < _bind$55) {
              const elem = _arr$10[_];
              const _bind$56 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_expr$14, elem, env$2);
              let _tmp$89;
              if (_bind$56.$tag === 1) {
                const _ok = _bind$56;
                _tmp$89 = _ok._0;
              } else {
                return _bind$56;
              }
              const key_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$89);
              if (!(key_results.length === 0)) {
                const key = _M0IP016_24default__implPB4Show10to__stringGRPB4JsonE(_M0MPC15array5Array2atGUssEE(key_results, 0));
                if (!_M0MPB3Map8containsGsbE(seen, key)) {
                  _M0MPB3Map3setGsbE(seen, key, true);
                  _M0MPC15array5Array4pushGUssEE(results$5, elem);
                }
              }
              _tmp$88 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(results$5)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 32: {
        const _MinBy = expr$2;
        const _expr$15 = _MinBy._0;
        if (input$2.$tag === 5) {
          const _Array$10 = input$2;
          const _arr$10 = _Array$10._0;
          if (_arr$10.length === 0) {
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
          } else {
            let min_elem = _M0MPC15array5Array2atGUssEE(_arr$10, 0);
            const _bind$54 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_expr$15, min_elem, env$2);
            let _tmp$88;
            if (_bind$54.$tag === 1) {
              const _ok = _bind$54;
              _tmp$88 = _ok._0;
            } else {
              return _bind$54;
            }
            const min_val_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$88);
            if (min_val_results.length === 0) {
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
            }
            let min_val = _M0MPC15array5Array2atGUssEE(min_val_results, 0);
            let _tmp$89 = 1;
            while (true) {
              const i$2 = _tmp$89;
              if (i$2 < _arr$10.length) {
                const elem = _M0MPC15array5Array2atGUssEE(_arr$10, i$2);
                const _bind$55 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_expr$15, elem, env$2);
                let _tmp$90;
                if (_bind$55.$tag === 1) {
                  const _ok = _bind$55;
                  _tmp$90 = _ok._0;
                } else {
                  return _bind$55;
                }
                const val_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$90);
                if (!(val_results.length === 0)) {
                  const val = _M0MPC15array5Array2atGUssEE(val_results, 0);
                  if (_M0FP38bobzhang6moonjq3ast13compare__json(val, min_val) < 0) {
                    min_val = val;
                    min_elem = elem;
                  }
                }
                _tmp$89 = i$2 + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(min_elem));
          }
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 34: {
        const _MaxBy = expr$2;
        const _expr$16 = _MaxBy._0;
        if (input$2.$tag === 5) {
          const _Array$10 = input$2;
          const _arr$10 = _Array$10._0;
          if (_arr$10.length === 0) {
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
          } else {
            let max_elem = _M0MPC15array5Array2atGUssEE(_arr$10, 0);
            const _bind$54 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_expr$16, max_elem, env$2);
            let _tmp$88;
            if (_bind$54.$tag === 1) {
              const _ok = _bind$54;
              _tmp$88 = _ok._0;
            } else {
              return _bind$54;
            }
            const max_val_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$88);
            if (max_val_results.length === 0) {
              return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_M0DTPB4Json4Null__));
            }
            let max_val = _M0MPC15array5Array2atGUssEE(max_val_results, 0);
            let _tmp$89 = 1;
            while (true) {
              const i$2 = _tmp$89;
              if (i$2 < _arr$10.length) {
                const elem = _M0MPC15array5Array2atGUssEE(_arr$10, i$2);
                const _bind$55 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_expr$16, elem, env$2);
                let _tmp$90;
                if (_bind$55.$tag === 1) {
                  const _ok = _bind$55;
                  _tmp$90 = _ok._0;
                } else {
                  return _bind$55;
                }
                const val_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$90);
                if (!(val_results.length === 0)) {
                  const val = _M0MPC15array5Array2atGUssEE(val_results, 0);
                  if (_M0FP38bobzhang6moonjq3ast13compare__json(val, max_val) > 0) {
                    max_val = val;
                    max_elem = elem;
                  }
                }
                _tmp$89 = i$2 + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(max_elem));
          }
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 26: {
        if (input$2.$tag === 5) {
          const _Array$10 = input$2;
          const _arr$10 = _Array$10._0;
          const arrays = [];
          const _bind$54 = _arr$10.length;
          let _tmp$88 = 0;
          while (true) {
            const _ = _tmp$88;
            if (_ < _bind$54) {
              const elem = _arr$10[_];
              if (elem.$tag === 5) {
                const _Array$11 = elem;
                const _inner$3 = _Array$11._0;
                _M0MPC15array5Array4pushGRPB5ArrayGsEE(arrays, _inner$3);
              } else {
                return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter5emptyGRPB4JsonE());
              }
              _tmp$88 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          if (arrays.length === 0) {
            return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter5emptyGRPB4JsonE());
          }
          let results$5 = [[]];
          const _bind$55 = arrays.length;
          let _tmp$89 = 0;
          while (true) {
            const _ = _tmp$89;
            if (_ < _bind$55) {
              const arr_item = arrays[_];
              const new_results = [];
              const _bind$56 = results$5;
              const _bind$57 = _bind$56.length;
              let _tmp$90 = 0;
              while (true) {
                const _$2 = _tmp$90;
                if (_$2 < _bind$57) {
                  const res = _bind$56[_$2];
                  const _bind$58 = arr_item.length;
                  let _tmp$91 = 0;
                  while (true) {
                    const _$3 = _tmp$91;
                    if (_$3 < _bind$58) {
                      const item = arr_item[_$3];
                      const new_res = _M0MPC15array5Array4copyGRPB4JsonE(res);
                      _M0MPC15array5Array4pushGUssEE(new_res, item);
                      _M0MPC15array5Array4pushGRPB5ArrayGsEE(new_results, new_res);
                      _tmp$91 = _$3 + 1 | 0;
                      continue;
                    } else {
                      break;
                    }
                  }
                  _tmp$90 = _$2 + 1 | 0;
                  continue;
                } else {
                  break;
                }
              }
              results$5 = new_results;
              _tmp$89 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter3mapGRPB5ArrayGRPB4JsonERPB4JsonE(_M0MPC15array5Array4iterGRPB5ArrayGRPB4JsonEE(results$5), _M0MPC14json4Json5array));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 27: {
        if (input$2.$tag === 5) {
          const _Array$10 = input$2;
          const _arr$10 = _Array$10._0;
          let max_len = 0;
          const _bind$54 = _arr$10.length;
          let _tmp$88 = 0;
          while (true) {
            const _ = _tmp$88;
            if (_ < _bind$54) {
              const elem = _arr$10[_];
              if (elem.$tag === 5) {
                const _Array$11 = elem;
                const _inner$3 = _Array$11._0;
                if (_inner$3.length > max_len) {
                  max_len = _inner$3.length;
                }
              }
              _tmp$88 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          const results$5 = [];
          let _tmp$89 = 0;
          while (true) {
            const col = _tmp$89;
            if (col < max_len) {
              const row = [];
              const _bind$55 = _arr$10.length;
              let _tmp$90 = 0;
              while (true) {
                const _ = _tmp$90;
                if (_ < _bind$55) {
                  const elem = _arr$10[_];
                  if (elem.$tag === 5) {
                    const _Array$11 = elem;
                    const _inner$3 = _Array$11._0;
                    if (col < _inner$3.length) {
                      _M0MPC15array5Array4pushGUssEE(row, _M0MPC15array5Array2atGUssEE(_inner$3, col));
                    }
                  }
                  _tmp$90 = _ + 1 | 0;
                  continue;
                } else {
                  break;
                }
              }
              _M0MPC15array5Array4pushGRPB5ArrayGsEE(results$5, row);
              _tmp$89 = col + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          const _p$19 = new Array(results$5.length);
          const _p$20 = results$5.length;
          let _tmp$90 = 0;
          while (true) {
            const _p$21 = _tmp$90;
            if (_p$21 < _p$20) {
              const _p$22 = results$5[_p$21];
              _p$19[_p$21] = new _M0DTPB4Json5Array(_p$22);
              _tmp$90 = _p$21 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          const _p$21 = _p$19;
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(new _M0DTPB4Json5Array(_p$21)));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("array", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
      case 61: {
        const _AnyGen = expr$2;
        const _gen_expr$3 = _AnyGen._0;
        const _cond_expr$3 = _AnyGen._1;
        const _bind$54 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_gen_expr$3, input$2, env$2);
        let _tmp$88;
        if (_bind$54.$tag === 1) {
          const _ok = _bind$54;
          _tmp$88 = _ok._0;
        } else {
          return _bind$54;
        }
        const gen_results$3 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$88);
        let found = false;
        const _bind$55 = gen_results$3.length;
        let _tmp$89 = 0;
        while (true) {
          const _ = _tmp$89;
          if (_ < _bind$55) {
            const gen_result = gen_results$3[_];
            const _bind$56 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_cond_expr$3, gen_result, env$2);
            let _tmp$90;
            if (_bind$56.$tag === 1) {
              const _ok = _bind$56;
              _tmp$90 = _ok._0;
            } else {
              return _bind$56;
            }
            const cond_results$3 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$90);
            if (!(cond_results$3.length === 0)) {
              const _bind$57 = _M0MPC15array5Array2atGUssEE(cond_results$3, 0);
              if (_bind$57.$tag === 1) {
                found = true;
                break;
              }
            }
            _tmp$89 = _ + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        const _p$19 = found;
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$19 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
      }
      case 63: {
        const _AllGen = expr$2;
        const _gen_expr$4 = _AllGen._0;
        const _cond_expr$4 = _AllGen._1;
        const _bind$56 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_gen_expr$4, input$2, env$2);
        let _tmp$90;
        if (_bind$56.$tag === 1) {
          const _ok = _bind$56;
          _tmp$90 = _ok._0;
        } else {
          return _bind$56;
        }
        const gen_results$4 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$90);
        let all_true = true;
        const _bind$57 = gen_results$4.length;
        let _tmp$91 = 0;
        while (true) {
          const _ = _tmp$91;
          if (_ < _bind$57) {
            const gen_result = gen_results$4[_];
            const _bind$58 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_cond_expr$4, gen_result, env$2);
            let _tmp$92;
            if (_bind$58.$tag === 1) {
              const _ok = _bind$58;
              _tmp$92 = _ok._0;
            } else {
              return _bind$58;
            }
            const cond_results$3 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$92);
            if (!(cond_results$3.length === 0)) {
              const _bind$59 = _M0MPC15array5Array2atGUssEE(cond_results$3, 0);
              if (_bind$59.$tag === 1) {
              } else {
                all_true = false;
                break;
              }
            } else {
              all_true = false;
              break;
            }
            _tmp$91 = _ + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        const _p$20 = all_true;
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter9singletonGRPB4JsonE(_p$20 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__));
      }
      case 69: {
        const _Foreach = expr$2;
        const _gen_expr$5 = _Foreach._0;
        const _var_name$3 = _Foreach._1;
        const _init_expr$2 = _Foreach._2;
        const _update_expr$5 = _Foreach._3;
        const _extract_expr = _Foreach._4;
        const _bind$58 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_gen_expr$5, input$2, env$2);
        let _tmp$92;
        if (_bind$58.$tag === 1) {
          const _ok = _bind$58;
          _tmp$92 = _ok._0;
        } else {
          return _bind$58;
        }
        const gen_results$5 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$92);
        const _bind$59 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_init_expr$2, input$2, env$2);
        let _tmp$93;
        if (_bind$59.$tag === 1) {
          const _ok = _bind$59;
          _tmp$93 = _ok._0;
        } else {
          return _bind$59;
        }
        const init_results$2 = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$93);
        if (init_results$2.length === 0) {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter5emptyGRPB4JsonE());
        }
        let accumulator$2 = _M0MPC15array5Array2atGUssEE(init_results$2, 0);
        const results$5 = [];
        const _bind$60 = gen_results$5.length;
        let _tmp$94 = 0;
        while (true) {
          const _ = _tmp$94;
          if (_ < _bind$60) {
            const gen_result = gen_results$5[_];
            let new_env = _M0MP38bobzhang6moonjq3ast3Env3new();
            const _it$5 = _M0MPB3Map5iter2GssE(env$2.bindings);
            while (true) {
              const _bind$61 = _M0MPB5Iter24nextGssE(_it$5);
              if (_bind$61 === undefined) {
                break;
              } else {
                const _Some = _bind$61;
                const _x = _Some;
                const _key$3 = _x._0;
                const _value = _x._1;
                new_env = _M0MP38bobzhang6moonjq3ast3Env3set(new_env, _key$3, _value);
                continue;
              }
            }
            const _it$6 = _M0MPB3Map5iter2GssE(env$2.functions);
            while (true) {
              const _bind$61 = _M0MPB5Iter24nextGssE(_it$6);
              if (_bind$61 === undefined) {
                break;
              } else {
                const _Some = _bind$61;
                const _x = _Some;
                const _key$3 = _x._0;
                const _value = _x._1;
                new_env = _M0MP38bobzhang6moonjq3ast3Env13set__function(new_env, _key$3, _value._0, _value._1);
                continue;
              }
            }
            new_env = _M0MP38bobzhang6moonjq3ast3Env3set(new_env, _var_name$3, gen_result);
            const _bind$61 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_update_expr$5, accumulator$2, new_env);
            let _tmp$95;
            if (_bind$61.$tag === 1) {
              const _ok = _bind$61;
              _tmp$95 = _ok._0;
            } else {
              return _bind$61;
            }
            const update_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$95);
            if (!(update_results.length === 0)) {
              accumulator$2 = _M0MPC15array5Array2atGUssEE(update_results, 0);
              let output;
              if (_extract_expr === undefined) {
                output = accumulator$2;
              } else {
                const _Some = _extract_expr;
                const _extract = _Some;
                const _bind$62 = _M0FP38bobzhang6moonjq3ast15eval__with__env(_extract, accumulator$2, new_env);
                let _tmp$96;
                if (_bind$62.$tag === 1) {
                  const _ok = _bind$62;
                  _tmp$96 = _ok._0;
                } else {
                  return _bind$62;
                }
                const extract_results = _M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$96);
                output = extract_results.length === 0 ? accumulator$2 : _M0MPC15array5Array2atGUssEE(extract_results, 0);
              }
              _M0MPC15array5Array4pushGUssEE(results$5, output);
            }
            _tmp$94 = _ + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPC15array5Array4iterGsE(results$5));
      }
      case 98: {
        const _PathsWithFilter = expr$2;
        const _filter_expr = _PathsWithFilter._0;
        const results$6 = [];
        const _bind$61 = _M0FP38bobzhang6moonjq3ast28collect__paths__with__filter(input$2, [], _filter_expr, env$2, results$6);
        if (_bind$61.$tag === 1) {
          const _ok = _bind$61;
          _ok._0;
        } else {
          return _bind$61;
        }
        return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPB4Iter3mapGRPB5ArrayGRPB4JsonERPB4JsonE(_M0MPC15array5Array4iterGRPB5ArrayGRPB4JsonEE(results$6), (path) => {
          const _p$21 = new Array(path.length);
          const _p$22 = path.length;
          let _tmp$95 = 0;
          while (true) {
            const _p$23 = _tmp$95;
            if (_p$23 < _p$22) {
              const _p$24 = path[_p$23];
              _p$21[_p$23] = new _M0DTPB4Json6String(_p$24);
              _tmp$95 = _p$23 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          const _p$23 = _p$21;
          return new _M0DTPB4Json5Array(_p$23);
        }));
      }
      default: {
        const _Scan = expr$2;
        const _pattern$6 = _Scan._0;
        if (input$2.$tag === 4) {
          const _String$5 = input$2;
          const _s$5 = _String$5._0;
          const results$7 = [];
          const slen = _s$5.length;
          const plen = _pattern$6.length;
          let i$2 = 0;
          while (true) {
            if (i$2 <= (slen - plen | 0)) {
              const slice_result = _M0MPC16string6String11sub_2einner(_s$5, i$2, i$2 + plen | 0);
              if (_M0MPC16string10StringView9to__owned(slice_result) === _pattern$6) {
                _M0MPC15array5Array4pushGUssEE(results$7, new _M0DTPB4Json6String(_pattern$6));
                i$2 = i$2 + plen | 0;
              } else {
                i$2 = i$2 + 1 | 0;
              }
              continue;
            } else {
              break;
            }
          }
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(_M0MPC15array5Array4iterGsE(results$7));
        } else {
          return new _M0DTPC16result6ResultGRPB4IterGRPB4JsonERP38bobzhang6moonjq3ast16InterpreterErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fast_2eInterpreterError_2eTypeMismatch("string", _M0FP38bobzhang6moonjq3ast16json__type__name(input$2)));
        }
      }
    }
  }
}
function _M0FP38bobzhang6moonjq3ast28collect__paths__with__filter(value, path, filter_expr, env, results) {
  let filter_results;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP38bobzhang6moonjq3ast15eval__with__env(filter_expr, value, env);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        filter_results = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    return new _M0DTPC16result6ResultGuRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(undefined);
  }
  const filter_results_arr = _M0MPB4Iter9to__arrayGRPB4JsonE(filter_results);
  if (!(filter_results_arr.length === 0)) {
    const _bind$4 = _M0MPC15array5Array2atGUssEE(filter_results_arr, 0);
    if (_bind$4.$tag === 1) {
      if (!(path.length === 0)) {
        _M0MPC15array5Array4pushGRPB5ArrayGsEE(results, _M0MPC15array5Array4copyGRPB4JsonE(path));
      }
    }
  }
  switch (value.$tag) {
    case 6: {
      const _Object = value;
      const _obj = _Object._0;
      const _it = _M0MPB3Map5iter2GssE(_obj);
      while (true) {
        const _bind$4 = _M0MPB5Iter24nextGssE(_it);
        if (_bind$4 === undefined) {
          break;
        } else {
          const _Some = _bind$4;
          const _x = _Some;
          const _key = _x._0;
          const _val = _x._1;
          const new_path = _M0MPC15array5Array4copyGRPB4JsonE(path);
          _M0MPC15array5Array4pushGUssEE(new_path, _key);
          const _bind$5 = _M0FP38bobzhang6moonjq3ast28collect__paths__with__filter(_val, new_path, filter_expr, env, results);
          if (_bind$5.$tag === 1) {
            const _ok = _bind$5;
            _ok._0;
          } else {
            return _bind$5;
          }
          continue;
        }
      }
      return new _M0DTPC16result6ResultGuRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(undefined);
    }
    case 5: {
      const _Array = value;
      const _arr = _Array._0;
      let _tmp$38 = 0;
      while (true) {
        const i = _tmp$38;
        if (i < _arr.length) {
          const new_path = _M0MPC15array5Array4copyGRPB4JsonE(path);
          _M0MPC15array5Array4pushGUssEE(new_path, _M0MPC13int3Int18to__string_2einner(i, 10));
          const _bind$4 = _M0FP38bobzhang6moonjq3ast28collect__paths__with__filter(_M0MPC15array5Array2atGUssEE(_arr, i), new_path, filter_expr, env, results);
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            _ok._0;
          } else {
            return _bind$4;
          }
          _tmp$38 = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return new _M0DTPC16result6ResultGuRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(undefined);
    }
    default: {
      return new _M0DTPC16result6ResultGuRP38bobzhang6moonjq3ast16InterpreterErrorE2Ok(undefined);
    }
  }
}
function _M0FP38bobzhang6moonjq3ast4eval(expr, input) {
  return _M0FP38bobzhang6moonjq3ast15eval__with__env(expr, input, _M0MP38bobzhang6moonjq3ast3Env3new());
}
function _M0IP38bobzhang6moonjq6parser8LexErrorPB4Show6output(_x_338, _x_339) {
  switch (_x_338.$tag) {
    case 37: {
      const _UnexpectedChar = _x_338;
      const _$42$arg_340 = _UnexpectedChar._0;
      const _$42$arg_341 = _UnexpectedChar._1;
      _x_339.method_table.method_0(_x_339.self, "UnexpectedChar(");
      _M0MPB6Logger13write__objectGiE(_x_339, _$42$arg_340);
      _x_339.method_table.method_0(_x_339.self, ", ");
      _M0MPB6Logger13write__objectGcE(_x_339, _$42$arg_341);
      _x_339.method_table.method_0(_x_339.self, ")");
      return;
    }
    case 36: {
      const _UnterminatedString = _x_338;
      const _$42$arg_342 = _UnterminatedString._0;
      _x_339.method_table.method_0(_x_339.self, "UnterminatedString(");
      _M0MPB6Logger13write__objectGiE(_x_339, _$42$arg_342);
      _x_339.method_table.method_0(_x_339.self, ")");
      return;
    }
    case 35: {
      const _InvalidNumber = _x_338;
      const _$42$arg_343 = _InvalidNumber._0;
      const _$42$arg_344 = _InvalidNumber._1;
      _x_339.method_table.method_0(_x_339.self, "InvalidNumber(");
      _M0MPB6Logger13write__objectGiE(_x_339, _$42$arg_343);
      _x_339.method_table.method_0(_x_339.self, ", ");
      _M0MPB6Logger13write__objectGsE(_x_339, _$42$arg_344);
      _x_339.method_table.method_0(_x_339.self, ")");
      return;
    }
    default: {
      const _InvalidEscape = _x_338;
      const _$42$arg_345 = _InvalidEscape._0;
      const _$42$arg_346 = _InvalidEscape._1;
      _x_339.method_table.method_0(_x_339.self, "InvalidEscape(");
      _M0MPB6Logger13write__objectGiE(_x_339, _$42$arg_345);
      _x_339.method_table.method_0(_x_339.self, ", ");
      _M0MPB6Logger13write__objectGcE(_x_339, _$42$arg_346);
      _x_339.method_table.method_0(_x_339.self, ")");
      return;
    }
  }
}
function _M0IP38bobzhang6moonjq6parser10ParseErrorPB4Show6output(_x_268, _x_269) {
  switch (_x_268.$tag) {
    case 59: {
      const _UnexpectedToken = _x_268;
      const _$42$arg_270 = _UnexpectedToken._0;
      const _$42$arg_271 = _UnexpectedToken._1;
      _x_269.method_table.method_0(_x_269.self, "UnexpectedToken(");
      _M0MPB6Logger13write__objectGsE(_x_269, _$42$arg_270);
      _x_269.method_table.method_0(_x_269.self, ", ");
      _M0MPB6Logger13write__objectGsE(_x_269, _$42$arg_271);
      _x_269.method_table.method_0(_x_269.self, ")");
      return;
    }
    case 58: {
      const _UnexpectedEnd = _x_268;
      const _$42$arg_272 = _UnexpectedEnd._0;
      _x_269.method_table.method_0(_x_269.self, "UnexpectedEnd(");
      _M0MPB6Logger13write__objectGsE(_x_269, _$42$arg_272);
      _x_269.method_table.method_0(_x_269.self, ")");
      return;
    }
    case 57: {
      const _InvalidSyntax = _x_268;
      const _$42$arg_273 = _InvalidSyntax._0;
      _x_269.method_table.method_0(_x_269.self, "InvalidSyntax(");
      _M0MPB6Logger13write__objectGsE(_x_269, _$42$arg_273);
      _x_269.method_table.method_0(_x_269.self, ")");
      return;
    }
    default: {
      const _InvalidExpression = _x_268;
      const _$42$arg_274 = _InvalidExpression._0;
      _x_269.method_table.method_0(_x_269.self, "InvalidExpression(");
      _M0MPB6Logger13write__objectGsE(_x_269, _$42$arg_274);
      _x_269.method_table.method_0(_x_269.self, ")");
      return;
    }
  }
}
function _M0IP38bobzhang6moonjq6parser5TokenPB4Show6output(_x_252, _x_253) {
  switch (_x_252.$tag) {
    case 0: {
      const _TNumber = _x_252;
      const _$42$arg_254 = _TNumber._0;
      _x_253.method_table.method_0(_x_253.self, "TNumber(");
      _M0MPB6Logger13write__objectGdE(_x_253, _$42$arg_254);
      _x_253.method_table.method_0(_x_253.self, ")");
      return;
    }
    case 1: {
      const _TString = _x_252;
      const _$42$arg_255 = _TString._0;
      _x_253.method_table.method_0(_x_253.self, "TString(");
      _M0MPB6Logger13write__objectGsE(_x_253, _$42$arg_255);
      _x_253.method_table.method_0(_x_253.self, ")");
      return;
    }
    case 2: {
      const _TStringInterpolation = _x_252;
      const _$42$arg_256 = _TStringInterpolation._0;
      _x_253.method_table.method_0(_x_253.self, "TStringInterpolation(");
      _M0MPB6Logger13write__objectGRPB5ArrayGUsOsEEE(_x_253, _$42$arg_256);
      _x_253.method_table.method_0(_x_253.self, ")");
      return;
    }
    case 3: {
      _x_253.method_table.method_0(_x_253.self, "TTrue");
      return;
    }
    case 4: {
      _x_253.method_table.method_0(_x_253.self, "TFalse");
      return;
    }
    case 5: {
      _x_253.method_table.method_0(_x_253.self, "TNull");
      return;
    }
    case 6: {
      const _TIdentifier = _x_252;
      const _$42$arg_257 = _TIdentifier._0;
      _x_253.method_table.method_0(_x_253.self, "TIdentifier(");
      _M0MPB6Logger13write__objectGsE(_x_253, _$42$arg_257);
      _x_253.method_table.method_0(_x_253.self, ")");
      return;
    }
    case 7: {
      const _TVariable = _x_252;
      const _$42$arg_258 = _TVariable._0;
      _x_253.method_table.method_0(_x_253.self, "TVariable(");
      _M0MPB6Logger13write__objectGsE(_x_253, _$42$arg_258);
      _x_253.method_table.method_0(_x_253.self, ")");
      return;
    }
    case 8: {
      const _TFormat = _x_252;
      const _$42$arg_259 = _TFormat._0;
      _x_253.method_table.method_0(_x_253.self, "TFormat(");
      _M0MPB6Logger13write__objectGsE(_x_253, _$42$arg_259);
      _x_253.method_table.method_0(_x_253.self, ")");
      return;
    }
    case 9: {
      _x_253.method_table.method_0(_x_253.self, "TDot");
      return;
    }
    case 10: {
      _x_253.method_table.method_0(_x_253.self, "TDotDot");
      return;
    }
    case 11: {
      _x_253.method_table.method_0(_x_253.self, "TPipe");
      return;
    }
    case 12: {
      _x_253.method_table.method_0(_x_253.self, "TComma");
      return;
    }
    case 13: {
      _x_253.method_table.method_0(_x_253.self, "TColon");
      return;
    }
    case 14: {
      _x_253.method_table.method_0(_x_253.self, "TSemicolon");
      return;
    }
    case 15: {
      _x_253.method_table.method_0(_x_253.self, "TQuestion");
      return;
    }
    case 16: {
      _x_253.method_table.method_0(_x_253.self, "TLParen");
      return;
    }
    case 17: {
      _x_253.method_table.method_0(_x_253.self, "TRParen");
      return;
    }
    case 18: {
      _x_253.method_table.method_0(_x_253.self, "TLBracket");
      return;
    }
    case 19: {
      _x_253.method_table.method_0(_x_253.self, "TRBracket");
      return;
    }
    case 20: {
      _x_253.method_table.method_0(_x_253.self, "TLBrace");
      return;
    }
    case 21: {
      _x_253.method_table.method_0(_x_253.self, "TRBrace");
      return;
    }
    case 22: {
      _x_253.method_table.method_0(_x_253.self, "TPlus");
      return;
    }
    case 23: {
      _x_253.method_table.method_0(_x_253.self, "TMinus");
      return;
    }
    case 24: {
      _x_253.method_table.method_0(_x_253.self, "TStar");
      return;
    }
    case 25: {
      _x_253.method_table.method_0(_x_253.self, "TSlash");
      return;
    }
    case 26: {
      _x_253.method_table.method_0(_x_253.self, "TPercent");
      return;
    }
    case 27: {
      _x_253.method_table.method_0(_x_253.self, "TEq");
      return;
    }
    case 28: {
      _x_253.method_table.method_0(_x_253.self, "TNeq");
      return;
    }
    case 29: {
      _x_253.method_table.method_0(_x_253.self, "TLt");
      return;
    }
    case 30: {
      _x_253.method_table.method_0(_x_253.self, "TLe");
      return;
    }
    case 31: {
      _x_253.method_table.method_0(_x_253.self, "TGt");
      return;
    }
    case 32: {
      _x_253.method_table.method_0(_x_253.self, "TGe");
      return;
    }
    case 33: {
      _x_253.method_table.method_0(_x_253.self, "TAssign");
      return;
    }
    case 34: {
      _x_253.method_table.method_0(_x_253.self, "TUpdate");
      return;
    }
    case 35: {
      _x_253.method_table.method_0(_x_253.self, "TAlternative");
      return;
    }
    case 36: {
      _x_253.method_table.method_0(_x_253.self, "TAddAssign");
      return;
    }
    case 37: {
      _x_253.method_table.method_0(_x_253.self, "TSubAssign");
      return;
    }
    case 38: {
      _x_253.method_table.method_0(_x_253.self, "TMulAssign");
      return;
    }
    case 39: {
      _x_253.method_table.method_0(_x_253.self, "TDivAssign");
      return;
    }
    case 40: {
      _x_253.method_table.method_0(_x_253.self, "TModAssign");
      return;
    }
    case 41: {
      _x_253.method_table.method_0(_x_253.self, "TAltAssign");
      return;
    }
    case 42: {
      _x_253.method_table.method_0(_x_253.self, "TAnd");
      return;
    }
    case 43: {
      _x_253.method_table.method_0(_x_253.self, "TOr");
      return;
    }
    case 44: {
      _x_253.method_table.method_0(_x_253.self, "TNot");
      return;
    }
    case 45: {
      _x_253.method_table.method_0(_x_253.self, "TIf");
      return;
    }
    case 46: {
      _x_253.method_table.method_0(_x_253.self, "TThen");
      return;
    }
    case 47: {
      _x_253.method_table.method_0(_x_253.self, "TElse");
      return;
    }
    case 48: {
      _x_253.method_table.method_0(_x_253.self, "TElif");
      return;
    }
    case 49: {
      _x_253.method_table.method_0(_x_253.self, "TEnd");
      return;
    }
    case 50: {
      _x_253.method_table.method_0(_x_253.self, "TAs");
      return;
    }
    case 51: {
      _x_253.method_table.method_0(_x_253.self, "TReduce");
      return;
    }
    case 52: {
      _x_253.method_table.method_0(_x_253.self, "TForeach");
      return;
    }
    case 53: {
      _x_253.method_table.method_0(_x_253.self, "TTry");
      return;
    }
    case 54: {
      _x_253.method_table.method_0(_x_253.self, "TCatch");
      return;
    }
    case 55: {
      _x_253.method_table.method_0(_x_253.self, "TDef");
      return;
    }
    default: {
      _x_253.method_table.method_0(_x_253.self, "TEof");
      return;
    }
  }
}
function _M0IP38bobzhang6moonjq6parser5TokenPB2Eq5equal(_x_224, _x_225) {
  switch (_x_224.$tag) {
    case 0: {
      const _TNumber = _x_224;
      const _$42$x0_226 = _TNumber._0;
      if (_x_225.$tag === 0) {
        const _TNumber$2 = _x_225;
        const _$42$y0_227 = _TNumber$2._0;
        return _$42$x0_226 === _$42$y0_227;
      } else {
        return false;
      }
    }
    case 1: {
      const _TString = _x_224;
      const _$42$x0_228 = _TString._0;
      if (_x_225.$tag === 1) {
        const _TString$2 = _x_225;
        const _$42$y0_229 = _TString$2._0;
        return _$42$x0_228 === _$42$y0_229;
      } else {
        return false;
      }
    }
    case 2: {
      const _TStringInterpolation = _x_224;
      const _$42$x0_230 = _TStringInterpolation._0;
      if (_x_225.$tag === 2) {
        const _TStringInterpolation$2 = _x_225;
        const _$42$y0_231 = _TStringInterpolation$2._0;
        return _M0IPC15array5ArrayPB2Eq5equalGUsOsEE(_$42$x0_230, _$42$y0_231);
      } else {
        return false;
      }
    }
    case 3: {
      if (_x_225.$tag === 3) {
        return true;
      } else {
        return false;
      }
    }
    case 4: {
      if (_x_225.$tag === 4) {
        return true;
      } else {
        return false;
      }
    }
    case 5: {
      if (_x_225.$tag === 5) {
        return true;
      } else {
        return false;
      }
    }
    case 6: {
      const _TIdentifier = _x_224;
      const _$42$x0_232 = _TIdentifier._0;
      if (_x_225.$tag === 6) {
        const _TIdentifier$2 = _x_225;
        const _$42$y0_233 = _TIdentifier$2._0;
        return _$42$x0_232 === _$42$y0_233;
      } else {
        return false;
      }
    }
    case 7: {
      const _TVariable = _x_224;
      const _$42$x0_234 = _TVariable._0;
      if (_x_225.$tag === 7) {
        const _TVariable$2 = _x_225;
        const _$42$y0_235 = _TVariable$2._0;
        return _$42$x0_234 === _$42$y0_235;
      } else {
        return false;
      }
    }
    case 8: {
      const _TFormat = _x_224;
      const _$42$x0_236 = _TFormat._0;
      if (_x_225.$tag === 8) {
        const _TFormat$2 = _x_225;
        const _$42$y0_237 = _TFormat$2._0;
        return _$42$x0_236 === _$42$y0_237;
      } else {
        return false;
      }
    }
    case 9: {
      if (_x_225.$tag === 9) {
        return true;
      } else {
        return false;
      }
    }
    case 10: {
      if (_x_225.$tag === 10) {
        return true;
      } else {
        return false;
      }
    }
    case 11: {
      if (_x_225.$tag === 11) {
        return true;
      } else {
        return false;
      }
    }
    case 12: {
      if (_x_225.$tag === 12) {
        return true;
      } else {
        return false;
      }
    }
    case 13: {
      if (_x_225.$tag === 13) {
        return true;
      } else {
        return false;
      }
    }
    case 14: {
      if (_x_225.$tag === 14) {
        return true;
      } else {
        return false;
      }
    }
    case 15: {
      if (_x_225.$tag === 15) {
        return true;
      } else {
        return false;
      }
    }
    case 16: {
      if (_x_225.$tag === 16) {
        return true;
      } else {
        return false;
      }
    }
    case 17: {
      if (_x_225.$tag === 17) {
        return true;
      } else {
        return false;
      }
    }
    case 18: {
      if (_x_225.$tag === 18) {
        return true;
      } else {
        return false;
      }
    }
    case 19: {
      if (_x_225.$tag === 19) {
        return true;
      } else {
        return false;
      }
    }
    case 20: {
      if (_x_225.$tag === 20) {
        return true;
      } else {
        return false;
      }
    }
    case 21: {
      if (_x_225.$tag === 21) {
        return true;
      } else {
        return false;
      }
    }
    case 22: {
      if (_x_225.$tag === 22) {
        return true;
      } else {
        return false;
      }
    }
    case 23: {
      if (_x_225.$tag === 23) {
        return true;
      } else {
        return false;
      }
    }
    case 24: {
      if (_x_225.$tag === 24) {
        return true;
      } else {
        return false;
      }
    }
    case 25: {
      if (_x_225.$tag === 25) {
        return true;
      } else {
        return false;
      }
    }
    case 26: {
      if (_x_225.$tag === 26) {
        return true;
      } else {
        return false;
      }
    }
    case 27: {
      if (_x_225.$tag === 27) {
        return true;
      } else {
        return false;
      }
    }
    case 28: {
      if (_x_225.$tag === 28) {
        return true;
      } else {
        return false;
      }
    }
    case 29: {
      if (_x_225.$tag === 29) {
        return true;
      } else {
        return false;
      }
    }
    case 30: {
      if (_x_225.$tag === 30) {
        return true;
      } else {
        return false;
      }
    }
    case 31: {
      if (_x_225.$tag === 31) {
        return true;
      } else {
        return false;
      }
    }
    case 32: {
      if (_x_225.$tag === 32) {
        return true;
      } else {
        return false;
      }
    }
    case 33: {
      if (_x_225.$tag === 33) {
        return true;
      } else {
        return false;
      }
    }
    case 34: {
      if (_x_225.$tag === 34) {
        return true;
      } else {
        return false;
      }
    }
    case 35: {
      if (_x_225.$tag === 35) {
        return true;
      } else {
        return false;
      }
    }
    case 36: {
      if (_x_225.$tag === 36) {
        return true;
      } else {
        return false;
      }
    }
    case 37: {
      if (_x_225.$tag === 37) {
        return true;
      } else {
        return false;
      }
    }
    case 38: {
      if (_x_225.$tag === 38) {
        return true;
      } else {
        return false;
      }
    }
    case 39: {
      if (_x_225.$tag === 39) {
        return true;
      } else {
        return false;
      }
    }
    case 40: {
      if (_x_225.$tag === 40) {
        return true;
      } else {
        return false;
      }
    }
    case 41: {
      if (_x_225.$tag === 41) {
        return true;
      } else {
        return false;
      }
    }
    case 42: {
      if (_x_225.$tag === 42) {
        return true;
      } else {
        return false;
      }
    }
    case 43: {
      if (_x_225.$tag === 43) {
        return true;
      } else {
        return false;
      }
    }
    case 44: {
      if (_x_225.$tag === 44) {
        return true;
      } else {
        return false;
      }
    }
    case 45: {
      if (_x_225.$tag === 45) {
        return true;
      } else {
        return false;
      }
    }
    case 46: {
      if (_x_225.$tag === 46) {
        return true;
      } else {
        return false;
      }
    }
    case 47: {
      if (_x_225.$tag === 47) {
        return true;
      } else {
        return false;
      }
    }
    case 48: {
      if (_x_225.$tag === 48) {
        return true;
      } else {
        return false;
      }
    }
    case 49: {
      if (_x_225.$tag === 49) {
        return true;
      } else {
        return false;
      }
    }
    case 50: {
      if (_x_225.$tag === 50) {
        return true;
      } else {
        return false;
      }
    }
    case 51: {
      if (_x_225.$tag === 51) {
        return true;
      } else {
        return false;
      }
    }
    case 52: {
      if (_x_225.$tag === 52) {
        return true;
      } else {
        return false;
      }
    }
    case 53: {
      if (_x_225.$tag === 53) {
        return true;
      } else {
        return false;
      }
    }
    case 54: {
      if (_x_225.$tag === 54) {
        return true;
      } else {
        return false;
      }
    }
    case 55: {
      if (_x_225.$tag === 55) {
        return true;
      } else {
        return false;
      }
    }
    default: {
      if (_x_225.$tag === 56) {
        return true;
      } else {
        return false;
      }
    }
  }
}
function _M0MP38bobzhang6moonjq6parser6Parser3new(tokens) {
  return new _M0TP38bobzhang6moonjq6parser6Parser(tokens, 0);
}
function _M0MP38bobzhang6moonjq6parser6Parser7current(self) {
  return self.pos < self.tokens.length ? _M0MPC15array5Array2atGUssEE(self.tokens, self.pos) : undefined;
}
function _M0MP38bobzhang6moonjq6parser6Parser7advance(self) {
  if (self.pos < self.tokens.length) {
    self.pos = self.pos + 1 | 0;
    return;
  } else {
    return;
  }
}
function _M0MP38bobzhang6moonjq6parser6Parser5check(self, expected) {
  const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
  if (_bind$4 === undefined) {
    return false;
  } else {
    const _Some = _bind$4;
    const _t = _Some;
    return _M0IP38bobzhang6moonjq6parser5TokenPB2Eq5equal(_t, expected);
  }
}
function _M0MP38bobzhang6moonjq6parser6Parser7consume(self, expected) {
  if (_M0MP38bobzhang6moonjq6parser6Parser5check(self, expected)) {
    _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
    return true;
  } else {
    return false;
  }
}
function _M0MP38bobzhang6moonjq6parser6Parser6expect(self, expected) {
  const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
  if (_bind$4 === undefined) {
    return new _M0DTPC16result6ResultGuRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eUnexpectedEnd(_M0IP016_24default__implPB4Show10to__stringGRP38bobzhang6moonjq6parser5TokenE(expected)));
  } else {
    const _Some = _bind$4;
    const _t = _Some;
    if (_M0IP38bobzhang6moonjq6parser5TokenPB2Eq5equal(_t, expected)) {
      return new _M0DTPC16result6ResultGuRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0MP38bobzhang6moonjq6parser6Parser7advance(self));
    } else {
      return new _M0DTPC16result6ResultGuRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fparser_2eParseError_2eUnexpectedToken(_M0IP016_24default__implPB4Show10to__stringGRP38bobzhang6moonjq6parser5TokenE(_t), _M0IP016_24default__implPB4Show10to__stringGRP38bobzhang6moonjq6parser5TokenE(expected)));
    }
  }
}
function _M0FP38bobzhang6moonjq6parser9is__alpha(c) {
  return c >= 97 && c <= 122 || (c >= 65 && c <= 90 || c === 95);
}
function _M0FP38bobzhang6moonjq6parser9is__digit(c) {
  return c >= 48 && c <= 57;
}
function _M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, token) {
  self.tokens = _M0IPC15array5ArrayPB3Add3addGsE(self.tokens, [token]);
}
function _M0MP38bobzhang6moonjq6parser5Lexer7advance(self) {
  self.pos = self.pos + 1 | 0;
}
function _M0MP38bobzhang6moonjq6parser5Lexer7current(self) {
  return self.pos < self.input.length ? _M0MPC16string6String9get__char(self.input, self.pos) : -1;
}
function _M0FP38bobzhang6moonjq6parser9is__alnum(c) {
  return _M0FP38bobzhang6moonjq6parser9is__alpha(c) || c >= 48 && c <= 57;
}
function _M0MP38bobzhang6moonjq6parser5Lexer11lex__format(self) {
  _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
  const start = self.pos;
  while (true) {
    const _p$4 = _M0MPC16option6Option3mapGcbE(_M0MP38bobzhang6moonjq6parser5Lexer7current(self), _M0FP38bobzhang6moonjq6parser9is__alnum);
    const _p$5 = false;
    if (_p$4 === -1 ? _p$5 : _p$4) {
      _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
      continue;
    } else {
      break;
    }
  }
  const name = _M0MPC16string10StringView9to__owned(_M0MPC16string6String11sub_2einner(self.input, start, self.pos));
  _M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, new _M0DTP38bobzhang6moonjq6parser5Token7TFormat(name));
}
function _M0MP38bobzhang6moonjq6parser5Lexer15lex__identifier(self) {
  const start = self.pos;
  while (true) {
    const _p$4 = _M0MPC16option6Option3mapGcbE(_M0MP38bobzhang6moonjq6parser5Lexer7current(self), _M0FP38bobzhang6moonjq6parser9is__alnum);
    const _p$5 = false;
    if (_p$4 === -1 ? _p$5 : _p$4) {
      _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
      continue;
    } else {
      break;
    }
  }
  const text = _M0MPC16string10StringView9to__owned(_M0MPC16string6String11sub_2einner(self.input, start, self.pos));
  switch (text) {
    case "true": {
      _M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, _M0DTP38bobzhang6moonjq6parser5Token5TTrue__);
      return;
    }
    case "false": {
      _M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, _M0DTP38bobzhang6moonjq6parser5Token6TFalse__);
      return;
    }
    case "null": {
      _M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, _M0DTP38bobzhang6moonjq6parser5Token5TNull__);
      return;
    }
    case "and": {
      _M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, _M0DTP38bobzhang6moonjq6parser5Token4TAnd__);
      return;
    }
    case "or": {
      _M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, _M0DTP38bobzhang6moonjq6parser5Token3TOr__);
      return;
    }
    case "not": {
      _M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, _M0DTP38bobzhang6moonjq6parser5Token4TNot__);
      return;
    }
    case "if": {
      _M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, _M0DTP38bobzhang6moonjq6parser5Token3TIf__);
      return;
    }
    case "then": {
      _M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, _M0DTP38bobzhang6moonjq6parser5Token5TThen__);
      return;
    }
    case "else": {
      _M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, _M0DTP38bobzhang6moonjq6parser5Token5TElse__);
      return;
    }
    case "elif": {
      _M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, _M0DTP38bobzhang6moonjq6parser5Token5TElif__);
      return;
    }
    case "end": {
      _M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, _M0DTP38bobzhang6moonjq6parser5Token4TEnd__);
      return;
    }
    case "as": {
      _M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, _M0DTP38bobzhang6moonjq6parser5Token3TAs__);
      return;
    }
    case "reduce": {
      _M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, _M0DTP38bobzhang6moonjq6parser5Token7TReduce__);
      return;
    }
    case "foreach": {
      _M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, _M0DTP38bobzhang6moonjq6parser5Token8TForeach__);
      return;
    }
    case "try": {
      _M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, _M0DTP38bobzhang6moonjq6parser5Token4TTry__);
      return;
    }
    case "catch": {
      _M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, _M0DTP38bobzhang6moonjq6parser5Token6TCatch__);
      return;
    }
    case "def": {
      _M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, _M0DTP38bobzhang6moonjq6parser5Token4TDef__);
      return;
    }
    default: {
      _M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, new _M0DTP38bobzhang6moonjq6parser5Token11TIdentifier(text));
      return;
    }
  }
}
function _M0MP38bobzhang6moonjq6parser5Lexer4peek(self) {
  return (self.pos + 1 | 0) < self.input.length ? _M0MPC16string6String9get__char(self.input, self.pos + 1 | 0) : -1;
}
function _M0MP38bobzhang6moonjq6parser5Lexer11lex__number(self) {
  const start = self.pos;
  let has_dot = false;
  if (_M0IPC16option6OptionPB2Eq5equalGcE(_M0MP38bobzhang6moonjq6parser5Lexer7current(self), _M0MP38bobzhang6moonjq6parser5Lexer11lex__numberN6constrS1227)) {
    _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
  }
  while (true) {
    _L: {
      _L$2: {
        const _bind$4 = _M0MP38bobzhang6moonjq6parser5Lexer7current(self);
        if (_bind$4 === -1) {
          break _L$2;
        } else {
          const _Some = _bind$4;
          const _c = _Some;
          if (_c >= 48 && _c <= 57) {
            _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
          } else {
            if (_c === 46) {
              let _tmp$38;
              if (!has_dot) {
                const _p$4 = _M0MPC16option6Option3mapGcbE(_M0MP38bobzhang6moonjq6parser5Lexer4peek(self), _M0FP38bobzhang6moonjq6parser9is__digit);
                const _p$5 = false;
                _tmp$38 = _p$4 === -1 ? _p$5 : _p$4;
              } else {
                _tmp$38 = false;
              }
              if (_tmp$38) {
                has_dot = true;
                _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
              } else {
                break _L$2;
              }
            } else {
              break _L$2;
            }
          }
        }
        break _L;
      }
      break;
    }
    continue;
  }
  const text = _M0MPC16string10StringView9to__owned(_M0MPC16string6String11sub_2einner(self.input, start, self.pos));
  let n;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FPC17strconv13parse__double(new _M0TPC16string10StringView(text, 0, text.length));
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        n = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    return new _M0DTPC16result6ResultGuRP38bobzhang6moonjq6parser8LexErrorE3Err(new _M0DTPC15error5Error53bobzhang_2fmoonjq_2fparser_2eLexError_2eInvalidNumber(start, text));
  }
  return new _M0DTPC16result6ResultGuRP38bobzhang6moonjq6parser8LexErrorE2Ok(_M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, new _M0DTP38bobzhang6moonjq6parser5Token7TNumber(n)));
}
function _M0MP38bobzhang6moonjq6parser5Lexer11lex__string(self) {
  const start = self.pos;
  _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
  const parts = [];
  const buf = _M0FPC16buffer11new_2einner(0);
  _L: while (true) {
    const _bind$4 = _M0MP38bobzhang6moonjq6parser5Lexer7current(self);
    if (_bind$4 === -1) {
      return new _M0DTPC16result6ResultGuRP38bobzhang6moonjq6parser8LexErrorE3Err(new _M0DTPC15error5Error58bobzhang_2fmoonjq_2fparser_2eLexError_2eUnterminatedString(start));
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      switch (_x) {
        case 34: {
          _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
          break _L;
        }
        case 92: {
          _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
          const _bind$5 = _M0MP38bobzhang6moonjq6parser5Lexer7current(self);
          if (_bind$5 === -1) {
            return new _M0DTPC16result6ResultGuRP38bobzhang6moonjq6parser8LexErrorE3Err(new _M0DTPC15error5Error58bobzhang_2fmoonjq_2fparser_2eLexError_2eUnterminatedString(start));
          } else {
            const _Some$2 = _bind$5;
            const _x$2 = _Some$2;
            switch (_x$2) {
              case 40: {
                _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
                _M0MPC15array5Array4pushGUssEE(parts, { _0: _M0IP016_24default__implPB4Show10to__stringGRPC16buffer6BufferE(buf), _1: undefined });
                _M0MPC16buffer6Buffer5reset(buf);
                const expr_start = self.pos;
                let paren_depth = 1;
                while (true) {
                  if (paren_depth > 0) {
                    const _bind$6 = _M0MP38bobzhang6moonjq6parser5Lexer7current(self);
                    if (_bind$6 === -1) {
                      return new _M0DTPC16result6ResultGuRP38bobzhang6moonjq6parser8LexErrorE3Err(new _M0DTPC15error5Error58bobzhang_2fmoonjq_2fparser_2eLexError_2eUnterminatedString(start));
                    } else {
                      const _Some$3 = _bind$6;
                      const _x$3 = _Some$3;
                      switch (_x$3) {
                        case 40: {
                          paren_depth = paren_depth + 1 | 0;
                          _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
                          break;
                        }
                        case 41: {
                          paren_depth = paren_depth - 1 | 0;
                          if (paren_depth === 0) {
                            const expr_text = _M0MPC16string10StringView9to__owned(_M0MPC16string6String11sub_2einner(self.input, expr_start, self.pos));
                            _M0MPC15array5Array4pushGUssEE(parts, { _0: "", _1: expr_text });
                            _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
                          } else {
                            _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
                          }
                          break;
                        }
                        case 34: {
                          _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
                          _L$2: while (true) {
                            const _bind$7 = _M0MP38bobzhang6moonjq6parser5Lexer7current(self);
                            if (_bind$7 === -1) {
                              return new _M0DTPC16result6ResultGuRP38bobzhang6moonjq6parser8LexErrorE3Err(new _M0DTPC15error5Error58bobzhang_2fmoonjq_2fparser_2eLexError_2eUnterminatedString(start));
                            } else {
                              const _Some$4 = _bind$7;
                              const _x$4 = _Some$4;
                              switch (_x$4) {
                                case 34: {
                                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
                                  break _L$2;
                                }
                                case 92: {
                                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
                                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
                                  break;
                                }
                                default: {
                                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
                                }
                              }
                            }
                            continue;
                          }
                          break;
                        }
                        default: {
                          _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
                        }
                      }
                    }
                    continue;
                  } else {
                    break;
                  }
                }
                break;
              }
              case 110: {
                _M0IPC16buffer6BufferPB6Logger11write__char(buf, 10);
                _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
                break;
              }
              case 114: {
                _M0IPC16buffer6BufferPB6Logger11write__char(buf, 13);
                _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
                break;
              }
              case 116: {
                _M0IPC16buffer6BufferPB6Logger11write__char(buf, 9);
                _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
                break;
              }
              case 92: {
                _M0IPC16buffer6BufferPB6Logger11write__char(buf, 92);
                _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
                break;
              }
              case 34: {
                _M0IPC16buffer6BufferPB6Logger11write__char(buf, 34);
                _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
                break;
              }
              case 47: {
                _M0IPC16buffer6BufferPB6Logger11write__char(buf, 47);
                _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
                break;
              }
              case 98: {
                _M0IPC16buffer6BufferPB6Logger11write__char(buf, 8);
                _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
                break;
              }
              default: {
                return new _M0DTPC16result6ResultGuRP38bobzhang6moonjq6parser8LexErrorE3Err(new _M0DTPC15error5Error53bobzhang_2fmoonjq_2fparser_2eLexError_2eInvalidEscape(self.pos, _x$2));
              }
            }
          }
          break;
        }
        default: {
          _M0IPC16buffer6BufferPB6Logger11write__char(buf, _x);
          _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
        }
      }
    }
    continue;
  }
  _M0MPC15array5Array4pushGUssEE(parts, { _0: _M0IP016_24default__implPB4Show10to__stringGRPC16buffer6BufferE(buf), _1: undefined });
  if (parts.length === 1 && _M0IPC16option6OptionPB2Eq5equalGsE(_M0MPC15array5Array2atGUssEE(parts, 0)._1, undefined)) {
    _M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, new _M0DTP38bobzhang6moonjq6parser5Token7TString(_M0MPC15array5Array2atGUssEE(parts, 0)._0));
  } else {
    _M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, new _M0DTP38bobzhang6moonjq6parser5Token20TStringInterpolation(parts));
  }
  return new _M0DTPC16result6ResultGuRP38bobzhang6moonjq6parser8LexErrorE2Ok(undefined);
}
function _M0MP38bobzhang6moonjq6parser5Lexer13lex__variable(self) {
  _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
  const start = self.pos;
  while (true) {
    const _p$4 = _M0MPC16option6Option3mapGcbE(_M0MP38bobzhang6moonjq6parser5Lexer7current(self), _M0FP38bobzhang6moonjq6parser9is__alnum);
    const _p$5 = false;
    if (_p$4 === -1 ? _p$5 : _p$4) {
      _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
      continue;
    } else {
      break;
    }
  }
  const name = _M0MPC16string10StringView9to__owned(_M0MPC16string6String11sub_2einner(self.input, start, self.pos));
  _M0MP38bobzhang6moonjq6parser5Lexer10add__token(self, new _M0DTP38bobzhang6moonjq6parser5Token9TVariable(name));
}
function _M0MP38bobzhang6moonjq6parser5Lexer3new(input) {
  return new _M0TP38bobzhang6moonjq6parser5Lexer(input, 0, []);
}
function _M0MP38bobzhang6moonjq6parser5Lexer13skip__comment(self) {
  while (true) {
    _L: {
      _L$2: {
        const _bind$4 = _M0MP38bobzhang6moonjq6parser5Lexer7current(self);
        if (_bind$4 === -1) {
          break _L$2;
        } else {
          const _Some = _bind$4;
          const _x = _Some;
          if (_x === 10) {
            break _L$2;
          } else {
            _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
          }
        }
        break _L;
      }
      return;
    }
    continue;
  }
}
function _M0MP38bobzhang6moonjq6parser5Lexer16skip__whitespace(self) {
  while (true) {
    _L: {
      _L$2: {
        _L$3: {
          const _bind$4 = _M0MP38bobzhang6moonjq6parser5Lexer7current(self);
          if (_bind$4 === -1) {
            break _L$2;
          } else {
            const _Some = _bind$4;
            const _x = _Some;
            switch (_x) {
              case 32: {
                break _L$3;
              }
              case 10: {
                break _L$3;
              }
              case 13: {
                break _L$3;
              }
              case 9: {
                break _L$3;
              }
              default: {
                break _L$2;
              }
            }
          }
        }
        _M0MP38bobzhang6moonjq6parser5Lexer7advance(self);
        break _L;
      }
      return;
    }
    continue;
  }
}
function _M0FP38bobzhang6moonjq6parser3lex(input) {
  const lexer = _M0MP38bobzhang6moonjq6parser5Lexer3new(input);
  while (true) {
    _M0MP38bobzhang6moonjq6parser5Lexer16skip__whitespace(lexer);
    const _bind$4 = _M0MP38bobzhang6moonjq6parser5Lexer7current(lexer);
    if (_bind$4 === -1) {
      break;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      switch (_x) {
        case 35: {
          _M0MP38bobzhang6moonjq6parser5Lexer13skip__comment(lexer);
          break;
        }
        case 34: {
          const _bind$5 = _M0MP38bobzhang6moonjq6parser5Lexer11lex__string(lexer);
          if (_bind$5.$tag === 1) {
            const _ok = _bind$5;
            _ok._0;
          } else {
            return _bind$5;
          }
          break;
        }
        case 36: {
          _M0MP38bobzhang6moonjq6parser5Lexer13lex__variable(lexer);
          break;
        }
        case 64: {
          _M0MP38bobzhang6moonjq6parser5Lexer11lex__format(lexer);
          break;
        }
        default: {
          let _tmp$38;
          if (_x >= 48 && _x <= 57) {
            _tmp$38 = true;
          } else {
            let _tmp$39;
            if (_x === 45) {
              const _p$4 = _M0MPC16option6Option3mapGcbE(_M0MP38bobzhang6moonjq6parser5Lexer4peek(lexer), _M0FP38bobzhang6moonjq6parser9is__digit);
              const _p$5 = false;
              _tmp$39 = _p$4 === -1 ? _p$5 : _p$4;
            } else {
              _tmp$39 = false;
            }
            _tmp$38 = _tmp$39;
          }
          if (_tmp$38) {
            const _bind$6 = _M0MP38bobzhang6moonjq6parser5Lexer11lex__number(lexer);
            if (_bind$6.$tag === 1) {
              const _ok = _bind$6;
              _ok._0;
            } else {
              return _bind$6;
            }
          } else {
            if (_M0FP38bobzhang6moonjq6parser9is__alpha(_x)) {
              _M0MP38bobzhang6moonjq6parser5Lexer15lex__identifier(lexer);
            } else {
              switch (_x) {
                case 46: {
                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                  if (_M0IPC16option6OptionPB2Eq5equalGcE(_M0MP38bobzhang6moonjq6parser5Lexer7current(lexer), _M0FP38bobzhang6moonjq6parser3lexN6constrS1228)) {
                    _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                    _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token7TDotDot__);
                  } else {
                    _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token4TDot__);
                  }
                  break;
                }
                case 124: {
                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                  if (_M0IPC16option6OptionPB2Eq5equalGcE(_M0MP38bobzhang6moonjq6parser5Lexer7current(lexer), _M0FP38bobzhang6moonjq6parser3lexN6constrS1229)) {
                    _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                    _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token7TUpdate__);
                  } else {
                    _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token5TPipe__);
                  }
                  break;
                }
                case 47: {
                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                  if (_M0IPC16option6OptionPB2Eq5equalGcE(_M0MP38bobzhang6moonjq6parser5Lexer7current(lexer), _M0FP38bobzhang6moonjq6parser3lexN6constrS1230)) {
                    _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                    if (_M0IPC16option6OptionPB2Eq5equalGcE(_M0MP38bobzhang6moonjq6parser5Lexer7current(lexer), _M0FP38bobzhang6moonjq6parser3lexN6constrS1231)) {
                      _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                      _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token10TAltAssign__);
                    } else {
                      _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token12TAlternative__);
                    }
                  } else {
                    if (_M0IPC16option6OptionPB2Eq5equalGcE(_M0MP38bobzhang6moonjq6parser5Lexer7current(lexer), _M0FP38bobzhang6moonjq6parser3lexN6constrS1232)) {
                      _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                      _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token10TDivAssign__);
                    } else {
                      _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token6TSlash__);
                    }
                  }
                  break;
                }
                case 61: {
                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                  if (_M0IPC16option6OptionPB2Eq5equalGcE(_M0MP38bobzhang6moonjq6parser5Lexer7current(lexer), _M0FP38bobzhang6moonjq6parser3lexN6constrS1233)) {
                    _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                    _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token3TEq__);
                  } else {
                    _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token7TAssign__);
                  }
                  break;
                }
                case 33: {
                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                  if (_M0IPC16option6OptionPB2Eq5equalGcE(_M0MP38bobzhang6moonjq6parser5Lexer7current(lexer), _M0FP38bobzhang6moonjq6parser3lexN6constrS1234)) {
                    _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                    _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token4TNeq__);
                  } else {
                    return new _M0DTPC16result6ResultGRPB5ArrayGRP38bobzhang6moonjq6parser5TokenERP38bobzhang6moonjq6parser8LexErrorE3Err(new _M0DTPC15error5Error54bobzhang_2fmoonjq_2fparser_2eLexError_2eUnexpectedChar(lexer.pos, _x));
                  }
                  break;
                }
                case 60: {
                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                  if (_M0IPC16option6OptionPB2Eq5equalGcE(_M0MP38bobzhang6moonjq6parser5Lexer7current(lexer), _M0FP38bobzhang6moonjq6parser3lexN6constrS1235)) {
                    _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                    _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token3TLe__);
                  } else {
                    _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token3TLt__);
                  }
                  break;
                }
                case 62: {
                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                  if (_M0IPC16option6OptionPB2Eq5equalGcE(_M0MP38bobzhang6moonjq6parser5Lexer7current(lexer), _M0FP38bobzhang6moonjq6parser3lexN6constrS1236)) {
                    _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                    _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token3TGe__);
                  } else {
                    _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token3TGt__);
                  }
                  break;
                }
                case 44: {
                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                  _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token6TComma__);
                  break;
                }
                case 58: {
                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                  _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token6TColon__);
                  break;
                }
                case 59: {
                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                  _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token10TSemicolon__);
                  break;
                }
                case 63: {
                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                  _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token9TQuestion__);
                  break;
                }
                case 40: {
                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                  _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
                  break;
                }
                case 41: {
                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                  _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
                  break;
                }
                case 91: {
                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                  _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token9TLBracket__);
                  break;
                }
                case 93: {
                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                  _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token9TRBracket__);
                  break;
                }
                case 123: {
                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                  _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token7TLBrace__);
                  break;
                }
                case 125: {
                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                  _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token7TRBrace__);
                  break;
                }
                case 43: {
                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                  if (_M0IPC16option6OptionPB2Eq5equalGcE(_M0MP38bobzhang6moonjq6parser5Lexer7current(lexer), _M0FP38bobzhang6moonjq6parser3lexN6constrS1237)) {
                    _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                    _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token10TAddAssign__);
                  } else {
                    _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token5TPlus__);
                  }
                  break;
                }
                case 45: {
                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                  if (_M0IPC16option6OptionPB2Eq5equalGcE(_M0MP38bobzhang6moonjq6parser5Lexer7current(lexer), _M0FP38bobzhang6moonjq6parser3lexN6constrS1238)) {
                    _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                    _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token10TSubAssign__);
                  } else {
                    _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token6TMinus__);
                  }
                  break;
                }
                case 42: {
                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                  if (_M0IPC16option6OptionPB2Eq5equalGcE(_M0MP38bobzhang6moonjq6parser5Lexer7current(lexer), _M0FP38bobzhang6moonjq6parser3lexN6constrS1239)) {
                    _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                    _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token10TMulAssign__);
                  } else {
                    _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token5TStar__);
                  }
                  break;
                }
                case 37: {
                  _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                  if (_M0IPC16option6OptionPB2Eq5equalGcE(_M0MP38bobzhang6moonjq6parser5Lexer7current(lexer), _M0FP38bobzhang6moonjq6parser3lexN6constrS1240)) {
                    _M0MP38bobzhang6moonjq6parser5Lexer7advance(lexer);
                    _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token10TModAssign__);
                  } else {
                    _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token8TPercent__);
                  }
                  break;
                }
                default: {
                  return new _M0DTPC16result6ResultGRPB5ArrayGRP38bobzhang6moonjq6parser5TokenERP38bobzhang6moonjq6parser8LexErrorE3Err(new _M0DTPC15error5Error54bobzhang_2fmoonjq_2fparser_2eLexError_2eUnexpectedChar(lexer.pos, _x));
                }
              }
            }
          }
        }
      }
    }
    continue;
  }
  _M0MP38bobzhang6moonjq6parser5Lexer10add__token(lexer, _M0DTP38bobzhang6moonjq6parser5Token4TEof__);
  return new _M0DTPC16result6ResultGRPB5ArrayGRP38bobzhang6moonjq6parser5TokenERP38bobzhang6moonjq6parser8LexErrorE2Ok(lexer.tokens);
}
function _M0MP38bobzhang6moonjq6parser6Parser18parse__slice__part(self) {
  _L: {
    const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
    if (_bind$4 === undefined) {
      break _L;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      switch (_x.$tag) {
        case 0: {
          const _TNumber = _x;
          const _n = _TNumber._0;
          _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
          return new _M0DTPC16result6ResultGOiRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0MPC16double6Double7to__int(_n));
        }
        case 23: {
          _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
          _L$2: {
            const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
            if (_bind$5 === undefined) {
              break _L$2;
            } else {
              const _Some$2 = _bind$5;
              const _x$2 = _Some$2;
              if (_x$2.$tag === 0) {
                const _TNumber$2 = _x$2;
                const _n$2 = _TNumber$2._0;
                _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
                return new _M0DTPC16result6ResultGOiRP38bobzhang6moonjq6parser10ParseErrorE2Ok(-_M0MPC16double6Double7to__int(_n$2) | 0);
              } else {
                break _L$2;
              }
            }
          }
          return new _M0DTPC16result6ResultGOiRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("Expected number after minus"));
        }
        default: {
          break _L;
        }
      }
    }
  }
  return new _M0DTPC16result6ResultGOiRP38bobzhang6moonjq6parser10ParseErrorE2Ok(undefined);
}
function _M0MP38bobzhang6moonjq6parser6Parser23parse__index__or__slice(self, base) {
  if (_M0MP38bobzhang6moonjq6parser6Parser7consume(self, _M0DTP38bobzhang6moonjq6parser5Token9TRBracket__)) {
    return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr4Pipe(base, new _M0DTP38bobzhang6moonjq3ast4Expr5Index([])));
  }
  const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser18parse__slice__part(self);
  let start_or_index;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    start_or_index = _ok._0;
  } else {
    return _bind$4;
  }
  let _tmp$38;
  if (_M0MP38bobzhang6moonjq6parser6Parser7consume(self, _M0DTP38bobzhang6moonjq6parser5Token6TColon__)) {
    const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser18parse__slice__part(self);
    let end;
    if (_bind$5.$tag === 1) {
      const _ok = _bind$5;
      end = _ok._0;
    } else {
      return _bind$5;
    }
    const _bind$6 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token9TRBracket__);
    if (_bind$6.$tag === 1) {
      const _ok = _bind$6;
      _ok._0;
    } else {
      return _bind$6;
    }
    _tmp$38 = new _M0DTP38bobzhang6moonjq3ast4Expr4Pipe(base, new _M0DTP38bobzhang6moonjq3ast4Expr5Slice(start_or_index, end));
  } else {
    let indices;
    if (start_or_index === undefined) {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("Expected index"));
    } else {
      const _Some = start_or_index;
      const _n = _Some;
      indices = [_n];
    }
    while (true) {
      if (_M0MP38bobzhang6moonjq6parser6Parser7consume(self, _M0DTP38bobzhang6moonjq6parser5Token6TComma__)) {
        const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser18parse__slice__part(self);
        let _bind$6;
        if (_bind$5.$tag === 1) {
          const _ok = _bind$5;
          _bind$6 = _ok._0;
        } else {
          return _bind$5;
        }
        if (_bind$6 === undefined) {
          return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("Expected index after comma"));
        } else {
          const _Some = _bind$6;
          const _n = _Some;
          indices = _M0IPC15array5ArrayPB3Add3addGiE(indices, [_n]);
        }
        continue;
      } else {
        break;
      }
    }
    const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token9TRBracket__);
    if (_bind$5.$tag === 1) {
      const _ok = _bind$5;
      _ok._0;
    } else {
      return _bind$5;
    }
    _tmp$38 = new _M0DTP38bobzhang6moonjq3ast4Expr4Pipe(base, new _M0DTP38bobzhang6moonjq3ast4Expr5Index(indices));
  }
  return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_tmp$38);
}
function _M0MP38bobzhang6moonjq6parser6Parser20parse__field__access(self, base) {
  _L: {
    const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
    if (_bind$4 === undefined) {
      break _L;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      switch (_x.$tag) {
        case 6: {
          const _TIdentifier = _x;
          const _name = _TIdentifier._0;
          _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
          return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr4Pipe(base, new _M0DTP38bobzhang6moonjq3ast4Expr3Key(_name)));
        }
        case 18: {
          _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
          return _M0MP38bobzhang6moonjq6parser6Parser23parse__index__or__slice(self, base);
        }
        case 9: {
          _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
          return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr7Recurse__);
        }
        default: {
          break _L;
        }
      }
    }
  }
  return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(base);
}
function _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self) {
  const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser12parse__comma(self);
  let expr;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    expr = _ok._0;
  } else {
    return _bind$4;
  }
  if (_M0MP38bobzhang6moonjq6parser6Parser7consume(self, _M0DTP38bobzhang6moonjq6parser5Token3TAs__)) {
    let var_name;
    _L: {
      _L$2: {
        const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$5 === undefined) {
          break _L$2;
        } else {
          const _Some = _bind$5;
          const _x = _Some;
          if (_x.$tag === 7) {
            const _TVariable = _x;
            const _name = _TVariable._0;
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            var_name = _name;
          } else {
            break _L$2;
          }
        }
        break _L;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("Expected variable after 'as'"));
    }
    const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token5TPipe__);
    if (_bind$5.$tag === 1) {
      const _ok = _bind$5;
      _ok._0;
    } else {
      return _bind$5;
    }
    const _bind$6 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
    let body;
    if (_bind$6.$tag === 1) {
      const _ok = _bind$6;
      body = _ok._0;
    } else {
      return _bind$6;
    }
    return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr2As(expr, var_name, body));
  }
  while (true) {
    if (_M0MP38bobzhang6moonjq6parser6Parser7consume(self, _M0DTP38bobzhang6moonjq6parser5Token5TPipe__)) {
      const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser12parse__comma(self);
      let right;
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        right = _ok._0;
      } else {
        return _bind$5;
      }
      expr = new _M0DTP38bobzhang6moonjq3ast4Expr4Pipe(expr, right);
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(expr);
}
function _M0MP38bobzhang6moonjq6parser6Parser12parse__comma(self) {
  const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser17parse__assignment(self);
  let expr;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    expr = _ok._0;
  } else {
    return _bind$4;
  }
  while (true) {
    if (_M0MP38bobzhang6moonjq6parser6Parser7consume(self, _M0DTP38bobzhang6moonjq6parser5Token6TComma__)) {
      const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser17parse__assignment(self);
      let right;
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        right = _ok._0;
      } else {
        return _bind$5;
      }
      expr = new _M0DTP38bobzhang6moonjq3ast4Expr5Comma(expr, right);
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(expr);
}
function _M0MP38bobzhang6moonjq6parser6Parser17parse__assignment(self) {
  const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser9parse__or(self);
  let expr;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    expr = _ok._0;
  } else {
    return _bind$4;
  }
  _L: {
    const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
    if (_bind$5 === undefined) {
      break _L;
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      switch (_x.$tag) {
        case 33: {
          _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
          const _bind$6 = _M0MP38bobzhang6moonjq6parser6Parser9parse__or(self);
          let _tmp$38;
          if (_bind$6.$tag === 1) {
            const _ok = _bind$6;
            _tmp$38 = _ok._0;
          } else {
            return _bind$6;
          }
          return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr6Assign(expr, _tmp$38));
        }
        case 34: {
          _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
          const _bind$7 = _M0MP38bobzhang6moonjq6parser6Parser9parse__or(self);
          let _tmp$39;
          if (_bind$7.$tag === 1) {
            const _ok = _bind$7;
            _tmp$39 = _ok._0;
          } else {
            return _bind$7;
          }
          return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr6Update(expr, _tmp$39));
        }
        case 35: {
          _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
          const _bind$8 = _M0MP38bobzhang6moonjq6parser6Parser9parse__or(self);
          let _tmp$40;
          if (_bind$8.$tag === 1) {
            const _ok = _bind$8;
            _tmp$40 = _ok._0;
          } else {
            return _bind$8;
          }
          return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr11Alternative(expr, _tmp$40));
        }
        case 36: {
          _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
          const _bind$9 = _M0MP38bobzhang6moonjq6parser6Parser9parse__or(self);
          let _tmp$41;
          if (_bind$9.$tag === 1) {
            const _ok = _bind$9;
            _tmp$41 = _ok._0;
          } else {
            return _bind$9;
          }
          return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr9AddAssign(expr, _tmp$41));
        }
        case 37: {
          _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
          const _bind$10 = _M0MP38bobzhang6moonjq6parser6Parser9parse__or(self);
          let _tmp$42;
          if (_bind$10.$tag === 1) {
            const _ok = _bind$10;
            _tmp$42 = _ok._0;
          } else {
            return _bind$10;
          }
          return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr9SubAssign(expr, _tmp$42));
        }
        case 38: {
          _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
          const _bind$11 = _M0MP38bobzhang6moonjq6parser6Parser9parse__or(self);
          let _tmp$43;
          if (_bind$11.$tag === 1) {
            const _ok = _bind$11;
            _tmp$43 = _ok._0;
          } else {
            return _bind$11;
          }
          return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr9MulAssign(expr, _tmp$43));
        }
        case 39: {
          _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
          const _bind$12 = _M0MP38bobzhang6moonjq6parser6Parser9parse__or(self);
          let _tmp$44;
          if (_bind$12.$tag === 1) {
            const _ok = _bind$12;
            _tmp$44 = _ok._0;
          } else {
            return _bind$12;
          }
          return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr9DivAssign(expr, _tmp$44));
        }
        case 40: {
          _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
          const _bind$13 = _M0MP38bobzhang6moonjq6parser6Parser9parse__or(self);
          let _tmp$45;
          if (_bind$13.$tag === 1) {
            const _ok = _bind$13;
            _tmp$45 = _ok._0;
          } else {
            return _bind$13;
          }
          return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr9ModAssign(expr, _tmp$45));
        }
        case 41: {
          _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
          const _bind$14 = _M0MP38bobzhang6moonjq6parser6Parser9parse__or(self);
          let _tmp$46;
          if (_bind$14.$tag === 1) {
            const _ok = _bind$14;
            _tmp$46 = _ok._0;
          } else {
            return _bind$14;
          }
          return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr9AltAssign(expr, _tmp$46));
        }
        default: {
          break _L;
        }
      }
    }
  }
  return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(expr);
}
function _M0MP38bobzhang6moonjq6parser6Parser9parse__or(self) {
  const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser10parse__and(self);
  let expr;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    expr = _ok._0;
  } else {
    return _bind$4;
  }
  while (true) {
    if (_M0MP38bobzhang6moonjq6parser6Parser7consume(self, _M0DTP38bobzhang6moonjq6parser5Token3TOr__)) {
      const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser10parse__and(self);
      let _tmp$38;
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        _tmp$38 = _ok._0;
      } else {
        return _bind$5;
      }
      expr = new _M0DTP38bobzhang6moonjq3ast4Expr9Operation(expr, 12, _tmp$38);
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(expr);
}
function _M0MP38bobzhang6moonjq6parser6Parser10parse__and(self) {
  const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser17parse__comparison(self);
  let expr;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    expr = _ok._0;
  } else {
    return _bind$4;
  }
  while (true) {
    if (_M0MP38bobzhang6moonjq6parser6Parser7consume(self, _M0DTP38bobzhang6moonjq6parser5Token4TAnd__)) {
      const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser17parse__comparison(self);
      let _tmp$38;
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        _tmp$38 = _ok._0;
      } else {
        return _bind$5;
      }
      expr = new _M0DTP38bobzhang6moonjq3ast4Expr9Operation(expr, 11, _tmp$38);
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(expr);
}
function _M0MP38bobzhang6moonjq6parser6Parser17parse__comparison(self) {
  const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser15parse__additive(self);
  let expr;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    expr = _ok._0;
  } else {
    return _bind$4;
  }
  _L: {
    const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
    if (_bind$5 === undefined) {
      break _L;
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      switch (_x.$tag) {
        case 27: {
          _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
          const _bind$6 = _M0MP38bobzhang6moonjq6parser6Parser15parse__additive(self);
          let _tmp$38;
          if (_bind$6.$tag === 1) {
            const _ok = _bind$6;
            _tmp$38 = _ok._0;
          } else {
            return _bind$6;
          }
          return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr9Operation(expr, 5, _tmp$38));
        }
        case 28: {
          _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
          const _bind$7 = _M0MP38bobzhang6moonjq6parser6Parser15parse__additive(self);
          let _tmp$39;
          if (_bind$7.$tag === 1) {
            const _ok = _bind$7;
            _tmp$39 = _ok._0;
          } else {
            return _bind$7;
          }
          return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr9Operation(expr, 6, _tmp$39));
        }
        case 29: {
          _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
          const _bind$8 = _M0MP38bobzhang6moonjq6parser6Parser15parse__additive(self);
          let _tmp$40;
          if (_bind$8.$tag === 1) {
            const _ok = _bind$8;
            _tmp$40 = _ok._0;
          } else {
            return _bind$8;
          }
          return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr9Operation(expr, 7, _tmp$40));
        }
        case 30: {
          _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
          const _bind$9 = _M0MP38bobzhang6moonjq6parser6Parser15parse__additive(self);
          let _tmp$41;
          if (_bind$9.$tag === 1) {
            const _ok = _bind$9;
            _tmp$41 = _ok._0;
          } else {
            return _bind$9;
          }
          return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr9Operation(expr, 8, _tmp$41));
        }
        case 31: {
          _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
          const _bind$10 = _M0MP38bobzhang6moonjq6parser6Parser15parse__additive(self);
          let _tmp$42;
          if (_bind$10.$tag === 1) {
            const _ok = _bind$10;
            _tmp$42 = _ok._0;
          } else {
            return _bind$10;
          }
          return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr9Operation(expr, 9, _tmp$42));
        }
        case 32: {
          _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
          const _bind$11 = _M0MP38bobzhang6moonjq6parser6Parser15parse__additive(self);
          let _tmp$43;
          if (_bind$11.$tag === 1) {
            const _ok = _bind$11;
            _tmp$43 = _ok._0;
          } else {
            return _bind$11;
          }
          return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr9Operation(expr, 10, _tmp$43));
        }
        default: {
          break _L;
        }
      }
    }
  }
  return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(expr);
}
function _M0MP38bobzhang6moonjq6parser6Parser15parse__additive(self) {
  const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser21parse__multiplicative(self);
  let expr;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    expr = _ok._0;
  } else {
    return _bind$4;
  }
  while (true) {
    _L: {
      _L$2: {
        const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$5 === undefined) {
          break _L$2;
        } else {
          const _Some = _bind$5;
          const _x = _Some;
          switch (_x.$tag) {
            case 22: {
              _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
              const _bind$6 = _M0MP38bobzhang6moonjq6parser6Parser21parse__multiplicative(self);
              let _tmp$38;
              if (_bind$6.$tag === 1) {
                const _ok = _bind$6;
                _tmp$38 = _ok._0;
              } else {
                return _bind$6;
              }
              expr = new _M0DTP38bobzhang6moonjq3ast4Expr9Operation(expr, 0, _tmp$38);
              break;
            }
            case 23: {
              _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
              const _bind$7 = _M0MP38bobzhang6moonjq6parser6Parser21parse__multiplicative(self);
              let _tmp$39;
              if (_bind$7.$tag === 1) {
                const _ok = _bind$7;
                _tmp$39 = _ok._0;
              } else {
                return _bind$7;
              }
              expr = new _M0DTP38bobzhang6moonjq3ast4Expr9Operation(expr, 1, _tmp$39);
              break;
            }
            default: {
              break _L$2;
            }
          }
        }
        break _L;
      }
      break;
    }
    continue;
  }
  return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(expr);
}
function _M0MP38bobzhang6moonjq6parser6Parser21parse__multiplicative(self) {
  const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser12parse__unary(self);
  let expr;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    expr = _ok._0;
  } else {
    return _bind$4;
  }
  while (true) {
    _L: {
      _L$2: {
        const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$5 === undefined) {
          break _L$2;
        } else {
          const _Some = _bind$5;
          const _x = _Some;
          switch (_x.$tag) {
            case 24: {
              _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
              const _bind$6 = _M0MP38bobzhang6moonjq6parser6Parser12parse__unary(self);
              let _tmp$38;
              if (_bind$6.$tag === 1) {
                const _ok = _bind$6;
                _tmp$38 = _ok._0;
              } else {
                return _bind$6;
              }
              expr = new _M0DTP38bobzhang6moonjq3ast4Expr9Operation(expr, 2, _tmp$38);
              break;
            }
            case 25: {
              _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
              const _bind$7 = _M0MP38bobzhang6moonjq6parser6Parser12parse__unary(self);
              let _tmp$39;
              if (_bind$7.$tag === 1) {
                const _ok = _bind$7;
                _tmp$39 = _ok._0;
              } else {
                return _bind$7;
              }
              expr = new _M0DTP38bobzhang6moonjq3ast4Expr9Operation(expr, 3, _tmp$39);
              break;
            }
            case 26: {
              _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
              const _bind$8 = _M0MP38bobzhang6moonjq6parser6Parser12parse__unary(self);
              let _tmp$40;
              if (_bind$8.$tag === 1) {
                const _ok = _bind$8;
                _tmp$40 = _ok._0;
              } else {
                return _bind$8;
              }
              expr = new _M0DTP38bobzhang6moonjq3ast4Expr9Operation(expr, 4, _tmp$40);
              break;
            }
            default: {
              break _L$2;
            }
          }
        }
        break _L;
      }
      break;
    }
    continue;
  }
  return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(expr);
}
function _M0MP38bobzhang6moonjq6parser6Parser12parse__unary(self) {
  return _M0MP38bobzhang6moonjq6parser6Parser7consume(self, _M0DTP38bobzhang6moonjq6parser5Token4TNot__) ? new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr3Not__) : _M0MP38bobzhang6moonjq6parser6Parser14parse__postfix(self);
}
function _M0MP38bobzhang6moonjq6parser6Parser14parse__postfix(self) {
  const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser14parse__primary(self);
  let expr;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    expr = _ok._0;
  } else {
    return _bind$4;
  }
  while (true) {
    _L: {
      _L$2: {
        const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$5 === undefined) {
          break _L$2;
        } else {
          const _Some = _bind$5;
          const _x = _Some;
          switch (_x.$tag) {
            case 15: {
              _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
              expr = new _M0DTP38bobzhang6moonjq3ast4Expr8Optional(expr);
              break;
            }
            case 18: {
              _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
              const _bind$6 = _M0MP38bobzhang6moonjq6parser6Parser23parse__index__or__slice(self, expr);
              let _tmp$38;
              if (_bind$6.$tag === 1) {
                const _ok = _bind$6;
                _tmp$38 = _ok._0;
              } else {
                return _bind$6;
              }
              expr = _tmp$38;
              break;
            }
            case 9: {
              _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
              const _bind$7 = _M0MP38bobzhang6moonjq6parser6Parser20parse__field__access(self, expr);
              let _tmp$39;
              if (_bind$7.$tag === 1) {
                const _ok = _bind$7;
                _tmp$39 = _ok._0;
              } else {
                return _bind$7;
              }
              expr = _tmp$39;
              break;
            }
            default: {
              break _L$2;
            }
          }
        }
        break _L;
      }
      break;
    }
    continue;
  }
  return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(expr);
}
function _M0MP38bobzhang6moonjq6parser6Parser14parse__primary(self) {
  const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
  if (_bind$4 === undefined) {
    return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eUnexpectedEnd("expression"));
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    switch (_x.$tag) {
      case 5: {
        _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
        return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr7Literal(_M0DTP38bobzhang6moonjq3ast7Literal4Null__));
      }
      case 3: {
        _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
        return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0MP38bobzhang6moonjq6parser6Parser14parse__primaryN6constrS1242);
      }
      case 4: {
        _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
        return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0MP38bobzhang6moonjq6parser6Parser14parse__primaryN6constrS1244);
      }
      case 0: {
        const _TNumber = _x;
        const _n = _TNumber._0;
        _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
        return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr7Literal(new _M0DTP38bobzhang6moonjq3ast7Literal6Number(_n)));
      }
      case 1: {
        const _TString = _x;
        const _s = _TString._0;
        _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
        return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr7Literal(new _M0DTP38bobzhang6moonjq3ast7Literal6String(_s)));
      }
      case 2: {
        const _TStringInterpolation = _x;
        const _parts = _TStringInterpolation._0;
        _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
        const parsed_parts = [];
        const _bind$5 = _parts.length;
        let _tmp$38 = 0;
        while (true) {
          const _ = _tmp$38;
          if (_ < _bind$5) {
            const pair = _parts[_];
            const _text = pair._0;
            const _expr_opt = pair._1;
            if (_expr_opt === undefined) {
              _M0MPC15array5Array4pushGUssEE(parsed_parts, { _0: _text, _1: undefined });
            } else {
              const _Some$2 = _expr_opt;
              const _expr_str = _Some$2;
              let expr_tokens;
              let _try_err;
              _L: {
                _L$2: {
                  const _bind$6 = _M0FP38bobzhang6moonjq6parser3lex(_expr_str);
                  if (_bind$6.$tag === 1) {
                    const _ok = _bind$6;
                    expr_tokens = _ok._0;
                  } else {
                    const _err = _bind$6;
                    _try_err = _err._0;
                    break _L$2;
                  }
                  break _L;
                }
                return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error59bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidExpression("Failed to parse interpolation"));
              }
              const expr_parser = _M0MP38bobzhang6moonjq6parser6Parser3new(expr_tokens);
              const _bind$6 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(expr_parser);
              let expr;
              if (_bind$6.$tag === 1) {
                const _ok = _bind$6;
                expr = _ok._0;
              } else {
                return _bind$6;
              }
              _M0MPC15array5Array4pushGUssEE(parsed_parts, { _0: _text, _1: expr });
            }
            _tmp$38 = _ + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr19StringInterpolation(parsed_parts));
      }
      case 10: {
        _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
        return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr7Recurse__);
      }
      case 9: {
        _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
        _L: {
          const _bind$6 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
          if (_bind$6 === undefined) {
            break _L;
          } else {
            const _Some$2 = _bind$6;
            const _x$2 = _Some$2;
            switch (_x$2.$tag) {
              case 6: {
                const _TIdentifier = _x$2;
                const _name = _TIdentifier._0;
                _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
                return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr3Key(_name));
              }
              case 18: {
                _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
                return _M0MP38bobzhang6moonjq6parser6Parser23parse__index__or__slice(self, _M0DTP38bobzhang6moonjq3ast4Expr8Identity__);
              }
              default: {
                break _L;
              }
            }
          }
        }
        return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr8Identity__);
      }
      case 7: {
        const _TVariable = _x;
        const _name = _TVariable._0;
        _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
        return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr8Variable(_name));
      }
      case 8: {
        const _TFormat = _x;
        const _name$2 = _TFormat._0;
        _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
        return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr6Format(_name$2));
      }
      case 16: {
        _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
        const _bind$6 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
        let expr;
        if (_bind$6.$tag === 1) {
          const _ok = _bind$6;
          expr = _ok._0;
        } else {
          return _bind$6;
        }
        const _bind$7 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
        if (_bind$7.$tag === 1) {
          const _ok = _bind$7;
          _ok._0;
        } else {
          return _bind$7;
        }
        return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(expr);
      }
      case 18: {
        _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
        if (_M0MP38bobzhang6moonjq6parser6Parser7consume(self, _M0DTP38bobzhang6moonjq6parser5Token9TRBracket__)) {
          return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr14ArrayConstruct(undefined));
        } else {
          const _bind$8 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
          let expr$2;
          if (_bind$8.$tag === 1) {
            const _ok = _bind$8;
            expr$2 = _ok._0;
          } else {
            return _bind$8;
          }
          const _bind$9 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token9TRBracket__);
          if (_bind$9.$tag === 1) {
            const _ok = _bind$9;
            _ok._0;
          } else {
            return _bind$9;
          }
          return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr14ArrayConstruct(expr$2));
        }
      }
      case 20: {
        _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
        return _M0MP38bobzhang6moonjq6parser6Parser13parse__object(self);
      }
      case 45: {
        return _M0MP38bobzhang6moonjq6parser6Parser9parse__if(self);
      }
      case 53: {
        return _M0MP38bobzhang6moonjq6parser6Parser10parse__try(self);
      }
      case 51: {
        return _M0MP38bobzhang6moonjq6parser6Parser13parse__reduce(self);
      }
      case 52: {
        return _M0MP38bobzhang6moonjq6parser6Parser14parse__foreach(self);
      }
      case 6: {
        const _TIdentifier = _x;
        const _name$3 = _TIdentifier._0;
        _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
        return _M0MP38bobzhang6moonjq6parser6Parser14parse__builtin(self, _name$3);
      }
      default: {
        return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fparser_2eParseError_2eUnexpectedToken(_M0IP016_24default__implPB4Show10to__stringGRP38bobzhang6moonjq6parser5TokenE(_x), "expression"));
      }
    }
  }
}
function _M0MP38bobzhang6moonjq6parser6Parser14parse__builtin(self, name) {
  switch (name) {
    case "length": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr6Length__);
    }
    case "keys": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr4Keys__);
    }
    case "values": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr6Values__);
    }
    case "type": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr4Type__);
    }
    case "empty": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr5Empty__);
    }
    case "not": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr3Not__);
    }
    case "map": {
      const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        _ok._0;
      } else {
        return _bind$4;
      }
      const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let expr;
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        expr = _ok._0;
      } else {
        return _bind$5;
      }
      const _bind$6 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
      if (_bind$6.$tag === 1) {
        const _ok = _bind$6;
        _ok._0;
      } else {
        return _bind$6;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr3Map(expr));
    }
    case "select": {
      const _bind$7 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$7.$tag === 1) {
        const _ok = _bind$7;
        _ok._0;
      } else {
        return _bind$7;
      }
      const _bind$8 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let expr$2;
      if (_bind$8.$tag === 1) {
        const _ok = _bind$8;
        expr$2 = _ok._0;
      } else {
        return _bind$8;
      }
      const _bind$9 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
      if (_bind$9.$tag === 1) {
        const _ok = _bind$9;
        _ok._0;
      } else {
        return _bind$9;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr6Select(expr$2));
    }
    case "sort": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr4Sort__);
    }
    case "reverse": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr7Reverse__);
    }
    case "flatten": {
      if (_M0MP38bobzhang6moonjq6parser6Parser7consume(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__)) {
        _L: {
          const _bind$10 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
          if (_bind$10 === undefined) {
            break _L;
          } else {
            const _Some = _bind$10;
            const _x = _Some;
            if (_x.$tag === 0) {
              const _TNumber = _x;
              const _n = _TNumber._0;
              _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
              const _bind$11 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
              if (_bind$11.$tag === 1) {
                const _ok = _bind$11;
                _ok._0;
              } else {
                return _bind$11;
              }
              return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr7Flatten(_M0MPC16double6Double7to__int(_n)));
            } else {
              break _L;
            }
          }
        }
        const _bind$10 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
        if (_bind$10.$tag === 1) {
          const _ok = _bind$10;
          _ok._0;
        } else {
          return _bind$10;
        }
        return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr7Flatten(undefined));
      } else {
        return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr7Flatten(undefined));
      }
    }
    case "unique": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr6Unique__);
    }
    case "unique_by": {
      const _bind$10 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$10.$tag === 1) {
        const _ok = _bind$10;
        _ok._0;
      } else {
        return _bind$10;
      }
      const _bind$11 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let expr$3;
      if (_bind$11.$tag === 1) {
        const _ok = _bind$11;
        expr$3 = _ok._0;
      } else {
        return _bind$11;
      }
      const _bind$12 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
      if (_bind$12.$tag === 1) {
        const _ok = _bind$12;
        _ok._0;
      } else {
        return _bind$12;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr8UniqueBy(expr$3));
    }
    case "combinations": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr12Combinations__);
    }
    case "transpose": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr9Transpose__);
    }
    case "add": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr3Add__);
    }
    case "floor": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr5Floor__);
    }
    case "sqrt": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr4Sqrt__);
    }
    case "min": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr3Min__);
    }
    case "min_by": {
      const _bind$13 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$13.$tag === 1) {
        const _ok = _bind$13;
        _ok._0;
      } else {
        return _bind$13;
      }
      const _bind$14 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let expr$4;
      if (_bind$14.$tag === 1) {
        const _ok = _bind$14;
        expr$4 = _ok._0;
      } else {
        return _bind$14;
      }
      const _bind$15 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
      if (_bind$15.$tag === 1) {
        const _ok = _bind$15;
        _ok._0;
      } else {
        return _bind$15;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr5MinBy(expr$4));
    }
    case "max": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr3Max__);
    }
    case "max_by": {
      const _bind$16 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$16.$tag === 1) {
        const _ok = _bind$16;
        _ok._0;
      } else {
        return _bind$16;
      }
      const _bind$17 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let expr$5;
      if (_bind$17.$tag === 1) {
        const _ok = _bind$17;
        expr$5 = _ok._0;
      } else {
        return _bind$17;
      }
      const _bind$18 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
      if (_bind$18.$tag === 1) {
        const _ok = _bind$18;
        _ok._0;
      } else {
        return _bind$18;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr5MaxBy(expr$5));
    }
    case "round": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr5Round__);
    }
    case "ceil": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr4Ceil__);
    }
    case "abs": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr3Abs__);
    }
    case "split": {
      const _bind$19 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$19.$tag === 1) {
        const _ok = _bind$19;
        _ok._0;
      } else {
        return _bind$19;
      }
      _L: {
        const _bind$20 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$20 === undefined) {
          break _L;
        } else {
          const _Some = _bind$20;
          const _x = _Some;
          if (_x.$tag === 1) {
            const _TString = _x;
            const _sep = _TString._0;
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            const _bind$21 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
            if (_bind$21.$tag === 1) {
              const _ok = _bind$21;
              _ok._0;
            } else {
              return _bind$21;
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr5Split(_sep));
          } else {
            break _L;
          }
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("split expects string argument"));
    }
    case "join": {
      const _bind$20 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$20.$tag === 1) {
        const _ok = _bind$20;
        _ok._0;
      } else {
        return _bind$20;
      }
      _L$2: {
        const _bind$21 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$21 === undefined) {
          break _L$2;
        } else {
          const _Some = _bind$21;
          const _x = _Some;
          if (_x.$tag === 1) {
            const _TString = _x;
            const _sep = _TString._0;
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            const _bind$22 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
            if (_bind$22.$tag === 1) {
              const _ok = _bind$22;
              _ok._0;
            } else {
              return _bind$22;
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr4Join(_sep));
          } else {
            break _L$2;
          }
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("join expects string argument"));
    }
    case "startswith": {
      const _bind$21 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$21.$tag === 1) {
        const _ok = _bind$21;
        _ok._0;
      } else {
        return _bind$21;
      }
      _L$3: {
        const _bind$22 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$22 === undefined) {
          break _L$3;
        } else {
          const _Some = _bind$22;
          const _x = _Some;
          if (_x.$tag === 1) {
            const _TString = _x;
            const _prefix = _TString._0;
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            const _bind$23 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
            if (_bind$23.$tag === 1) {
              const _ok = _bind$23;
              _ok._0;
            } else {
              return _bind$23;
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr10StartsWith(_prefix));
          } else {
            break _L$3;
          }
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("startswith expects string argument"));
    }
    case "endswith": {
      const _bind$22 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$22.$tag === 1) {
        const _ok = _bind$22;
        _ok._0;
      } else {
        return _bind$22;
      }
      _L$4: {
        const _bind$23 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$23 === undefined) {
          break _L$4;
        } else {
          const _Some = _bind$23;
          const _x = _Some;
          if (_x.$tag === 1) {
            const _TString = _x;
            const _suffix = _TString._0;
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            const _bind$24 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
            if (_bind$24.$tag === 1) {
              const _ok = _bind$24;
              _ok._0;
            } else {
              return _bind$24;
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr8EndsWith(_suffix));
          } else {
            break _L$4;
          }
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("endswith expects string argument"));
    }
    case "contains": {
      const _bind$23 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$23.$tag === 1) {
        const _ok = _bind$23;
        _ok._0;
      } else {
        return _bind$23;
      }
      const _bind$24 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let expr$6;
      if (_bind$24.$tag === 1) {
        const _ok = _bind$24;
        expr$6 = _ok._0;
      } else {
        return _bind$24;
      }
      const _bind$25 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
      if (_bind$25.$tag === 1) {
        const _ok = _bind$25;
        _ok._0;
      } else {
        return _bind$25;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr8Contains(expr$6));
    }
    case "inside": {
      const _bind$26 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$26.$tag === 1) {
        const _ok = _bind$26;
        _ok._0;
      } else {
        return _bind$26;
      }
      const _bind$27 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let expr$7;
      if (_bind$27.$tag === 1) {
        const _ok = _bind$27;
        expr$7 = _ok._0;
      } else {
        return _bind$27;
      }
      const _bind$28 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
      if (_bind$28.$tag === 1) {
        const _ok = _bind$28;
        _ok._0;
      } else {
        return _bind$28;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr6Inside(expr$7));
    }
    case "has": {
      const _bind$29 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$29.$tag === 1) {
        const _ok = _bind$29;
        _ok._0;
      } else {
        return _bind$29;
      }
      _L$5: {
        const _bind$30 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$30 === undefined) {
          break _L$5;
        } else {
          const _Some = _bind$30;
          const _x = _Some;
          switch (_x.$tag) {
            case 1: {
              const _TString = _x;
              const _key = _TString._0;
              _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
              const _bind$31 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
              if (_bind$31.$tag === 1) {
                const _ok = _bind$31;
                _ok._0;
              } else {
                return _bind$31;
              }
              return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr3Has(_key));
            }
            case 0: {
              const _TNumber = _x;
              const _n = _TNumber._0;
              _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
              const _bind$32 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
              if (_bind$32.$tag === 1) {
                const _ok = _bind$32;
                _ok._0;
              } else {
                return _bind$32;
              }
              return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr3Has(String(_n)));
            }
            default: {
              break _L$5;
            }
          }
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("has expects string or number argument"));
    }
    case "in": {
      const _bind$30 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$30.$tag === 1) {
        const _ok = _bind$30;
        _ok._0;
      } else {
        return _bind$30;
      }
      const _bind$31 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let expr$8;
      if (_bind$31.$tag === 1) {
        const _ok = _bind$31;
        expr$8 = _ok._0;
      } else {
        return _bind$31;
      }
      const _bind$32 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
      if (_bind$32.$tag === 1) {
        const _ok = _bind$32;
        _ok._0;
      } else {
        return _bind$32;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr2In(expr$8));
    }
    case "to_entries": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr9ToEntries__);
    }
    case "from_entries": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr11FromEntries__);
    }
    case "with_entries": {
      const _bind$33 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$33.$tag === 1) {
        const _ok = _bind$33;
        _ok._0;
      } else {
        return _bind$33;
      }
      const _bind$34 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let expr$9;
      if (_bind$34.$tag === 1) {
        const _ok = _bind$34;
        expr$9 = _ok._0;
      } else {
        return _bind$34;
      }
      const _bind$35 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
      if (_bind$35.$tag === 1) {
        const _ok = _bind$35;
        _ok._0;
      } else {
        return _bind$35;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr11WithEntries(expr$9));
    }
    case "map_values": {
      const _bind$36 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$36.$tag === 1) {
        const _ok = _bind$36;
        _ok._0;
      } else {
        return _bind$36;
      }
      const _bind$37 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let expr$10;
      if (_bind$37.$tag === 1) {
        const _ok = _bind$37;
        expr$10 = _ok._0;
      } else {
        return _bind$37;
      }
      const _bind$38 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
      if (_bind$38.$tag === 1) {
        const _ok = _bind$38;
        _ok._0;
      } else {
        return _bind$38;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr9MapValues(expr$10));
    }
    case "range": {
      const _bind$39 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$39.$tag === 1) {
        const _ok = _bind$39;
        _ok._0;
      } else {
        return _bind$39;
      }
      const _bind$40 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let first_expr;
      if (_bind$40.$tag === 1) {
        const _ok = _bind$40;
        first_expr = _ok._0;
      } else {
        return _bind$40;
      }
      _L$6: {
        const _bind$41 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$41 === undefined) {
          break _L$6;
        } else {
          const _Some = _bind$41;
          const _x = _Some;
          if (_x.$tag === 14) {
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            const _bind$42 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
            let second_expr;
            if (_bind$42.$tag === 1) {
              const _ok = _bind$42;
              second_expr = _ok._0;
            } else {
              return _bind$42;
            }
            _L$7: {
              const _bind$43 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
              if (_bind$43 === undefined) {
                break _L$7;
              } else {
                const _Some$2 = _bind$43;
                const _x$2 = _Some$2;
                if (_x$2.$tag === 14) {
                  _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
                  const _bind$44 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
                  let third_expr;
                  if (_bind$44.$tag === 1) {
                    const _ok = _bind$44;
                    third_expr = _ok._0;
                  } else {
                    return _bind$44;
                  }
                  const _bind$45 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
                  if (_bind$45.$tag === 1) {
                    const _ok = _bind$45;
                    _ok._0;
                  } else {
                    return _bind$45;
                  }
                  return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr13RangeWithStep(first_expr, second_expr, third_expr));
                } else {
                  break _L$7;
                }
              }
            }
            const _bind$43 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
            if (_bind$43.$tag === 1) {
              const _ok = _bind$43;
              _ok._0;
            } else {
              return _bind$43;
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr11RangeFromTo(first_expr, second_expr));
          } else {
            break _L$6;
          }
        }
      }
      const _bind$41 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
      if (_bind$41.$tag === 1) {
        const _ok = _bind$41;
        _ok._0;
      } else {
        return _bind$41;
      }
      _L$7: {
        if (first_expr.$tag === 1) {
          const _Literal = first_expr;
          const _x = _Literal._0;
          if (_x.$tag === 2) {
            const _Number = _x;
            const _n = _Number._0;
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr5Range(_M0MPC16double6Double7to__int(_n)));
          } else {
            break _L$7;
          }
        } else {
          break _L$7;
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("range(n) expects literal number"));
    }
    case "first": {
      _L$8: {
        const _bind$42 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$42 === undefined) {
          break _L$8;
        } else {
          const _Some = _bind$42;
          const _x = _Some;
          if (_x.$tag === 16) {
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            const _bind$43 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
            let expr$11;
            if (_bind$43.$tag === 1) {
              const _ok = _bind$43;
              expr$11 = _ok._0;
            } else {
              return _bind$43;
            }
            const _bind$44 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
            if (_bind$44.$tag === 1) {
              const _ok = _bind$44;
              _ok._0;
            } else {
              return _bind$44;
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr8FirstGen(expr$11));
          } else {
            break _L$8;
          }
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr5First__);
    }
    case "last": {
      _L$9: {
        const _bind$42 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$42 === undefined) {
          break _L$9;
        } else {
          const _Some = _bind$42;
          const _x = _Some;
          if (_x.$tag === 16) {
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            const _bind$43 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
            let expr$11;
            if (_bind$43.$tag === 1) {
              const _ok = _bind$43;
              expr$11 = _ok._0;
            } else {
              return _bind$43;
            }
            const _bind$44 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
            if (_bind$44.$tag === 1) {
              const _ok = _bind$44;
              _ok._0;
            } else {
              return _bind$44;
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr7LastGen(expr$11));
          } else {
            break _L$9;
          }
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr4Last__);
    }
    case "repeat": {
      const _bind$42 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$42.$tag === 1) {
        const _ok = _bind$42;
        _ok._0;
      } else {
        return _bind$42;
      }
      const _bind$43 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let expr$11;
      if (_bind$43.$tag === 1) {
        const _ok = _bind$43;
        expr$11 = _ok._0;
      } else {
        return _bind$43;
      }
      const _bind$44 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
      if (_bind$44.$tag === 1) {
        const _ok = _bind$44;
        _ok._0;
      } else {
        return _bind$44;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr6Repeat(expr$11));
    }
    case "explode": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr7Explode__);
    }
    case "implode": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr7Implode__);
    }
    case "tojson": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr12ToJsonString__);
    }
    case "fromjson": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr14FromJsonString__);
    }
    case "indices": {
      const _bind$45 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$45.$tag === 1) {
        const _ok = _bind$45;
        _ok._0;
      } else {
        return _bind$45;
      }
      const _bind$46 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let expr$12;
      if (_bind$46.$tag === 1) {
        const _ok = _bind$46;
        expr$12 = _ok._0;
      } else {
        return _bind$46;
      }
      const _bind$47 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
      if (_bind$47.$tag === 1) {
        const _ok = _bind$47;
        _ok._0;
      } else {
        return _bind$47;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr9IndicesOf(expr$12));
    }
    case "index": {
      const _bind$48 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$48.$tag === 1) {
        const _ok = _bind$48;
        _ok._0;
      } else {
        return _bind$48;
      }
      const _bind$49 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let expr$13;
      if (_bind$49.$tag === 1) {
        const _ok = _bind$49;
        expr$13 = _ok._0;
      } else {
        return _bind$49;
      }
      const _bind$50 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
      if (_bind$50.$tag === 1) {
        const _ok = _bind$50;
        _ok._0;
      } else {
        return _bind$50;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr7IndexOf(expr$13));
    }
    case "any": {
      _L$10: {
        const _bind$51 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$51 === undefined) {
          break _L$10;
        } else {
          const _Some = _bind$51;
          const _x = _Some;
          if (_x.$tag === 16) {
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            const _bind$52 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
            let gen_expr;
            if (_bind$52.$tag === 1) {
              const _ok = _bind$52;
              gen_expr = _ok._0;
            } else {
              return _bind$52;
            }
            _L$11: {
              const _bind$53 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
              if (_bind$53 === undefined) {
                break _L$11;
              } else {
                const _Some$2 = _bind$53;
                const _x$2 = _Some$2;
                if (_x$2.$tag === 14) {
                  _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
                  const _bind$54 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
                  let cond_expr;
                  if (_bind$54.$tag === 1) {
                    const _ok = _bind$54;
                    cond_expr = _ok._0;
                  } else {
                    return _bind$54;
                  }
                  const _bind$55 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
                  if (_bind$55.$tag === 1) {
                    const _ok = _bind$55;
                    _ok._0;
                  } else {
                    return _bind$55;
                  }
                  return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr6AnyGen(gen_expr, cond_expr));
                } else {
                  break _L$11;
                }
              }
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("any(gen; cond) expects semicolon"));
          } else {
            break _L$10;
          }
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr3Any__);
    }
    case "all": {
      _L$11: {
        const _bind$51 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$51 === undefined) {
          break _L$11;
        } else {
          const _Some = _bind$51;
          const _x = _Some;
          if (_x.$tag === 16) {
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            const _bind$52 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
            let gen_expr;
            if (_bind$52.$tag === 1) {
              const _ok = _bind$52;
              gen_expr = _ok._0;
            } else {
              return _bind$52;
            }
            _L$12: {
              const _bind$53 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
              if (_bind$53 === undefined) {
                break _L$12;
              } else {
                const _Some$2 = _bind$53;
                const _x$2 = _Some$2;
                if (_x$2.$tag === 14) {
                  _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
                  const _bind$54 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
                  let cond_expr;
                  if (_bind$54.$tag === 1) {
                    const _ok = _bind$54;
                    cond_expr = _ok._0;
                  } else {
                    return _bind$54;
                  }
                  const _bind$55 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
                  if (_bind$55.$tag === 1) {
                    const _ok = _bind$55;
                    _ok._0;
                  } else {
                    return _bind$55;
                  }
                  return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr6AllGen(gen_expr, cond_expr));
                } else {
                  break _L$12;
                }
              }
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("all(gen; cond) expects semicolon"));
          } else {
            break _L$11;
          }
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr3All__);
    }
    case "sort_by": {
      const _bind$51 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$51.$tag === 1) {
        const _ok = _bind$51;
        _ok._0;
      } else {
        return _bind$51;
      }
      const _bind$52 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let expr$14;
      if (_bind$52.$tag === 1) {
        const _ok = _bind$52;
        expr$14 = _ok._0;
      } else {
        return _bind$52;
      }
      const _bind$53 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
      if (_bind$53.$tag === 1) {
        const _ok = _bind$53;
        _ok._0;
      } else {
        return _bind$53;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr6SortBy(expr$14));
    }
    case "group_by": {
      const _bind$54 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$54.$tag === 1) {
        const _ok = _bind$54;
        _ok._0;
      } else {
        return _bind$54;
      }
      const _bind$55 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let expr$15;
      if (_bind$55.$tag === 1) {
        const _ok = _bind$55;
        expr$15 = _ok._0;
      } else {
        return _bind$55;
      }
      const _bind$56 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
      if (_bind$56.$tag === 1) {
        const _ok = _bind$56;
        _ok._0;
      } else {
        return _bind$56;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr7GroupBy(expr$15));
    }
    case "ltrimstr": {
      const _bind$57 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$57.$tag === 1) {
        const _ok = _bind$57;
        _ok._0;
      } else {
        return _bind$57;
      }
      _L$12: {
        const _bind$58 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$58 === undefined) {
          break _L$12;
        } else {
          const _Some = _bind$58;
          const _x = _Some;
          if (_x.$tag === 1) {
            const _TString = _x;
            const _s = _TString._0;
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            const _bind$59 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
            if (_bind$59.$tag === 1) {
              const _ok = _bind$59;
              _ok._0;
            } else {
              return _bind$59;
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr8LTrimStr(_s));
          } else {
            break _L$12;
          }
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("ltrimstr expects string argument"));
    }
    case "rtrimstr": {
      const _bind$58 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$58.$tag === 1) {
        const _ok = _bind$58;
        _ok._0;
      } else {
        return _bind$58;
      }
      _L$13: {
        const _bind$59 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$59 === undefined) {
          break _L$13;
        } else {
          const _Some = _bind$59;
          const _x = _Some;
          if (_x.$tag === 1) {
            const _TString = _x;
            const _s = _TString._0;
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            const _bind$60 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
            if (_bind$60.$tag === 1) {
              const _ok = _bind$60;
              _ok._0;
            } else {
              return _bind$60;
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr8RTrimStr(_s));
          } else {
            break _L$13;
          }
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("rtrimstr expects string argument"));
    }
    case "ascii_upcase": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr11AsciiUpcase__);
    }
    case "ascii_downcase": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr13AsciiDowncase__);
    }
    case "nth": {
      const _bind$59 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$59.$tag === 1) {
        const _ok = _bind$59;
        _ok._0;
      } else {
        return _bind$59;
      }
      _L$14: {
        const _bind$60 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$60 === undefined) {
          break _L$14;
        } else {
          const _Some = _bind$60;
          const _x = _Some;
          if (_x.$tag === 0) {
            const _TNumber = _x;
            const _n = _TNumber._0;
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            const _bind$61 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
            if (_bind$61.$tag === 1) {
              const _ok = _bind$61;
              _ok._0;
            } else {
              return _bind$61;
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr3Nth(_M0MPC16double6Double7to__int(_n)));
          } else {
            break _L$14;
          }
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("nth expects number argument"));
    }
    case "rindex": {
      const _bind$60 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$60.$tag === 1) {
        const _ok = _bind$60;
        _ok._0;
      } else {
        return _bind$60;
      }
      const _bind$61 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let expr$16;
      if (_bind$61.$tag === 1) {
        const _ok = _bind$61;
        expr$16 = _ok._0;
      } else {
        return _bind$61;
      }
      const _bind$62 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
      if (_bind$62.$tag === 1) {
        const _ok = _bind$62;
        _ok._0;
      } else {
        return _bind$62;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr6RIndex(expr$16));
    }
    case "paths": {
      _L$15: {
        const _bind$63 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$63 === undefined) {
          break _L$15;
        } else {
          const _Some = _bind$63;
          const _x = _Some;
          if (_x.$tag === 16) {
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            const _bind$64 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
            let expr$17;
            if (_bind$64.$tag === 1) {
              const _ok = _bind$64;
              expr$17 = _ok._0;
            } else {
              return _bind$64;
            }
            const _bind$65 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
            if (_bind$65.$tag === 1) {
              const _ok = _bind$65;
              _ok._0;
            } else {
              return _bind$65;
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr15PathsWithFilter(expr$17));
          } else {
            break _L$15;
          }
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr5Paths__);
    }
    case "leaf_paths": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr9LeafPaths__);
    }
    case "getpath": {
      const _bind$63 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$63.$tag === 1) {
        const _ok = _bind$63;
        _ok._0;
      } else {
        return _bind$63;
      }
      const _bind$64 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let expr$17;
      if (_bind$64.$tag === 1) {
        const _ok = _bind$64;
        expr$17 = _ok._0;
      } else {
        return _bind$64;
      }
      const _bind$65 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
      if (_bind$65.$tag === 1) {
        const _ok = _bind$65;
        _ok._0;
      } else {
        return _bind$65;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr7GetPath(expr$17));
    }
    case "setpath": {
      const _bind$66 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$66.$tag === 1) {
        const _ok = _bind$66;
        _ok._0;
      } else {
        return _bind$66;
      }
      const _bind$67 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let path;
      if (_bind$67.$tag === 1) {
        const _ok = _bind$67;
        path = _ok._0;
      } else {
        return _bind$67;
      }
      const _bind$68 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token10TSemicolon__);
      if (_bind$68.$tag === 1) {
        const _ok = _bind$68;
        _ok._0;
      } else {
        return _bind$68;
      }
      const _bind$69 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let value;
      if (_bind$69.$tag === 1) {
        const _ok = _bind$69;
        value = _ok._0;
      } else {
        return _bind$69;
      }
      const _bind$70 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
      if (_bind$70.$tag === 1) {
        const _ok = _bind$70;
        _ok._0;
      } else {
        return _bind$70;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr7SetPath(path, value));
    }
    case "delpaths": {
      const _bind$71 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$71.$tag === 1) {
        const _ok = _bind$71;
        _ok._0;
      } else {
        return _bind$71;
      }
      const _bind$72 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let expr$18;
      if (_bind$72.$tag === 1) {
        const _ok = _bind$72;
        expr$18 = _ok._0;
      } else {
        return _bind$72;
      }
      const _bind$73 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
      if (_bind$73.$tag === 1) {
        const _ok = _bind$73;
        _ok._0;
      } else {
        return _bind$73;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr8DelPaths(expr$18));
    }
    case "limit": {
      const _bind$74 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$74.$tag === 1) {
        const _ok = _bind$74;
        _ok._0;
      } else {
        return _bind$74;
      }
      _L$16: {
        const _bind$75 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$75 === undefined) {
          break _L$16;
        } else {
          const _Some = _bind$75;
          const _x = _Some;
          if (_x.$tag === 0) {
            const _TNumber = _x;
            const _n = _TNumber._0;
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            const _bind$76 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token10TSemicolon__);
            if (_bind$76.$tag === 1) {
              const _ok = _bind$76;
              _ok._0;
            } else {
              return _bind$76;
            }
            const _bind$77 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
            let expr$19;
            if (_bind$77.$tag === 1) {
              const _ok = _bind$77;
              expr$19 = _ok._0;
            } else {
              return _bind$77;
            }
            const _bind$78 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
            if (_bind$78.$tag === 1) {
              const _ok = _bind$78;
              _ok._0;
            } else {
              return _bind$78;
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr5Limit(_M0MPC16double6Double7to__int(_n), expr$19));
          } else {
            break _L$16;
          }
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("limit expects number argument"));
    }
    case "until": {
      const _bind$75 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$75.$tag === 1) {
        const _ok = _bind$75;
        _ok._0;
      } else {
        return _bind$75;
      }
      const _bind$76 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let cond;
      if (_bind$76.$tag === 1) {
        const _ok = _bind$76;
        cond = _ok._0;
      } else {
        return _bind$76;
      }
      const _bind$77 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token10TSemicolon__);
      if (_bind$77.$tag === 1) {
        const _ok = _bind$77;
        _ok._0;
      } else {
        return _bind$77;
      }
      const _bind$78 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let update;
      if (_bind$78.$tag === 1) {
        const _ok = _bind$78;
        update = _ok._0;
      } else {
        return _bind$78;
      }
      const _bind$79 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
      if (_bind$79.$tag === 1) {
        const _ok = _bind$79;
        _ok._0;
      } else {
        return _bind$79;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr5Until(cond, update));
    }
    case "while": {
      const _bind$80 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$80.$tag === 1) {
        const _ok = _bind$80;
        _ok._0;
      } else {
        return _bind$80;
      }
      const _bind$81 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let cond$2;
      if (_bind$81.$tag === 1) {
        const _ok = _bind$81;
        cond$2 = _ok._0;
      } else {
        return _bind$81;
      }
      const _bind$82 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token10TSemicolon__);
      if (_bind$82.$tag === 1) {
        const _ok = _bind$82;
        _ok._0;
      } else {
        return _bind$82;
      }
      const _bind$83 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let update$2;
      if (_bind$83.$tag === 1) {
        const _ok = _bind$83;
        update$2 = _ok._0;
      } else {
        return _bind$83;
      }
      const _bind$84 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
      if (_bind$84.$tag === 1) {
        const _ok = _bind$84;
        _ok._0;
      } else {
        return _bind$84;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr5While(cond$2, update$2));
    }
    case "reduce": {
      const _bind$85 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$85.$tag === 1) {
        const _ok = _bind$85;
        _ok._0;
      } else {
        return _bind$85;
      }
      const _bind$86 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let gen_expr;
      if (_bind$86.$tag === 1) {
        const _ok = _bind$86;
        gen_expr = _ok._0;
      } else {
        return _bind$86;
      }
      const _bind$87 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token3TAs__);
      if (_bind$87.$tag === 1) {
        const _ok = _bind$87;
        _ok._0;
      } else {
        return _bind$87;
      }
      _L$17: {
        const _bind$88 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$88 === undefined) {
          break _L$17;
        } else {
          const _Some = _bind$88;
          const _x = _Some;
          if (_x.$tag === 7) {
            const _TVariable = _x;
            const _var_name = _TVariable._0;
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            const _bind$89 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
            if (_bind$89.$tag === 1) {
              const _ok = _bind$89;
              _ok._0;
            } else {
              return _bind$89;
            }
            const _bind$90 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
            let init_expr;
            if (_bind$90.$tag === 1) {
              const _ok = _bind$90;
              init_expr = _ok._0;
            } else {
              return _bind$90;
            }
            const _bind$91 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token10TSemicolon__);
            if (_bind$91.$tag === 1) {
              const _ok = _bind$91;
              _ok._0;
            } else {
              return _bind$91;
            }
            const _bind$92 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
            let update_expr;
            if (_bind$92.$tag === 1) {
              const _ok = _bind$92;
              update_expr = _ok._0;
            } else {
              return _bind$92;
            }
            const _bind$93 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
            if (_bind$93.$tag === 1) {
              const _ok = _bind$93;
              _ok._0;
            } else {
              return _bind$93;
            }
            const _bind$94 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
            if (_bind$94.$tag === 1) {
              const _ok = _bind$94;
              _ok._0;
            } else {
              return _bind$94;
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr6Reduce(gen_expr, _var_name, init_expr, update_expr));
          } else {
            break _L$17;
          }
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("reduce expects variable after as"));
    }
    case "foreach": {
      const _bind$88 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$88.$tag === 1) {
        const _ok = _bind$88;
        _ok._0;
      } else {
        return _bind$88;
      }
      const _bind$89 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let gen_expr$2;
      if (_bind$89.$tag === 1) {
        const _ok = _bind$89;
        gen_expr$2 = _ok._0;
      } else {
        return _bind$89;
      }
      const _bind$90 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token3TAs__);
      if (_bind$90.$tag === 1) {
        const _ok = _bind$90;
        _ok._0;
      } else {
        return _bind$90;
      }
      _L$18: {
        const _bind$91 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$91 === undefined) {
          break _L$18;
        } else {
          const _Some = _bind$91;
          const _x = _Some;
          if (_x.$tag === 7) {
            const _TVariable = _x;
            const _var_name = _TVariable._0;
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            const _bind$92 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
            if (_bind$92.$tag === 1) {
              const _ok = _bind$92;
              _ok._0;
            } else {
              return _bind$92;
            }
            const _bind$93 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
            let init_expr;
            if (_bind$93.$tag === 1) {
              const _ok = _bind$93;
              init_expr = _ok._0;
            } else {
              return _bind$93;
            }
            const _bind$94 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token10TSemicolon__);
            if (_bind$94.$tag === 1) {
              const _ok = _bind$94;
              _ok._0;
            } else {
              return _bind$94;
            }
            const _bind$95 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
            let update_expr;
            if (_bind$95.$tag === 1) {
              const _ok = _bind$95;
              update_expr = _ok._0;
            } else {
              return _bind$95;
            }
            let extract_expr;
            _L$19: {
              _L$20: {
                const _bind$96 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
                if (_bind$96 === undefined) {
                  break _L$20;
                } else {
                  const _Some$2 = _bind$96;
                  const _x$2 = _Some$2;
                  if (_x$2.$tag === 14) {
                    _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
                    const _bind$97 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
                    if (_bind$97.$tag === 1) {
                      const _ok = _bind$97;
                      extract_expr = _ok._0;
                    } else {
                      return _bind$97;
                    }
                  } else {
                    break _L$20;
                  }
                }
                break _L$19;
              }
              extract_expr = undefined;
            }
            const _bind$96 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
            if (_bind$96.$tag === 1) {
              const _ok = _bind$96;
              _ok._0;
            } else {
              return _bind$96;
            }
            const _bind$97 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
            if (_bind$97.$tag === 1) {
              const _ok = _bind$97;
              _ok._0;
            } else {
              return _bind$97;
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr7Foreach(gen_expr$2, _var_name, init_expr, update_expr, extract_expr));
          } else {
            break _L$18;
          }
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("foreach expects variable after as"));
    }
    case "scan": {
      const _bind$91 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$91.$tag === 1) {
        const _ok = _bind$91;
        _ok._0;
      } else {
        return _bind$91;
      }
      _L$19: {
        const _bind$92 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$92 === undefined) {
          break _L$19;
        } else {
          const _Some = _bind$92;
          const _x = _Some;
          if (_x.$tag === 1) {
            const _TString = _x;
            const _s = _TString._0;
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            const _bind$93 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
            if (_bind$93.$tag === 1) {
              const _ok = _bind$93;
              _ok._0;
            } else {
              return _bind$93;
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr4Scan(_s));
          } else {
            break _L$19;
          }
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("scan expects string argument"));
    }
    case "recurse": {
      if (_M0MP38bobzhang6moonjq6parser6Parser7consume(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__)) {
        const _bind$92 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
        let f;
        if (_bind$92.$tag === 1) {
          const _ok = _bind$92;
          f = _ok._0;
        } else {
          return _bind$92;
        }
        const _bind$93 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token10TSemicolon__);
        if (_bind$93.$tag === 1) {
          const _ok = _bind$93;
          _ok._0;
        } else {
          return _bind$93;
        }
        const _bind$94 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
        let cond$3;
        if (_bind$94.$tag === 1) {
          const _ok = _bind$94;
          cond$3 = _ok._0;
        } else {
          return _bind$94;
        }
        const _bind$95 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
        if (_bind$95.$tag === 1) {
          const _ok = _bind$95;
          _ok._0;
        } else {
          return _bind$95;
        }
        return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr11RecurseWith(f, cond$3));
      } else {
        return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr7Recurse__);
      }
    }
    case "walk": {
      const _bind$92 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$92.$tag === 1) {
        const _ok = _bind$92;
        _ok._0;
      } else {
        return _bind$92;
      }
      const _bind$93 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let expr$19;
      if (_bind$93.$tag === 1) {
        const _ok = _bind$93;
        expr$19 = _ok._0;
      } else {
        return _bind$93;
      }
      const _bind$94 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
      if (_bind$94.$tag === 1) {
        const _ok = _bind$94;
        _ok._0;
      } else {
        return _bind$94;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr4Walk(expr$19));
    }
    case "pow": {
      const _bind$95 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$95.$tag === 1) {
        const _ok = _bind$95;
        _ok._0;
      } else {
        return _bind$95;
      }
      const _bind$96 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
      let base;
      if (_bind$96.$tag === 1) {
        const _ok = _bind$96;
        base = _ok._0;
      } else {
        return _bind$96;
      }
      if (_M0MP38bobzhang6moonjq6parser6Parser7consume(self, _M0DTP38bobzhang6moonjq6parser5Token10TSemicolon__)) {
        const _bind$97 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
        let exponent;
        if (_bind$97.$tag === 1) {
          const _ok = _bind$97;
          exponent = _ok._0;
        } else {
          return _bind$97;
        }
        const _bind$98 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
        if (_bind$98.$tag === 1) {
          const _ok = _bind$98;
          _ok._0;
        } else {
          return _bind$98;
        }
        return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr4Pipe(base, new _M0DTP38bobzhang6moonjq3ast4Expr3Pow(exponent)));
      } else {
        const _bind$97 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
        if (_bind$97.$tag === 1) {
          const _ok = _bind$97;
          _ok._0;
        } else {
          return _bind$97;
        }
        return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr3Pow(base));
      }
    }
    case "log": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr3Log__);
    }
    case "exp": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr3Exp__);
    }
    case "sin": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr3Sin__);
    }
    case "cos": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr3Cos__);
    }
    case "tan": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr3Tan__);
    }
    case "asin": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr4Asin__);
    }
    case "acos": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr4Acos__);
    }
    case "atan": {
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_M0DTP38bobzhang6moonjq3ast4Expr4Atan__);
    }
    case "test": {
      const _bind$97 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$97.$tag === 1) {
        const _ok = _bind$97;
        _ok._0;
      } else {
        return _bind$97;
      }
      _L$20: {
        const _bind$98 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$98 === undefined) {
          break _L$20;
        } else {
          const _Some = _bind$98;
          const _x = _Some;
          if (_x.$tag === 1) {
            const _TString = _x;
            const _s = _TString._0;
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            const _bind$99 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
            if (_bind$99.$tag === 1) {
              const _ok = _bind$99;
              _ok._0;
            } else {
              return _bind$99;
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr4Test(_s));
          } else {
            break _L$20;
          }
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("test expects string argument"));
    }
    case "match": {
      const _bind$98 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$98.$tag === 1) {
        const _ok = _bind$98;
        _ok._0;
      } else {
        return _bind$98;
      }
      _L$21: {
        const _bind$99 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$99 === undefined) {
          break _L$21;
        } else {
          const _Some = _bind$99;
          const _x = _Some;
          if (_x.$tag === 1) {
            const _TString = _x;
            const _s = _TString._0;
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            const _bind$100 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
            if (_bind$100.$tag === 1) {
              const _ok = _bind$100;
              _ok._0;
            } else {
              return _bind$100;
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr5Match(_s));
          } else {
            break _L$21;
          }
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("match expects string argument"));
    }
    case "capture": {
      const _bind$99 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$99.$tag === 1) {
        const _ok = _bind$99;
        _ok._0;
      } else {
        return _bind$99;
      }
      _L$22: {
        const _bind$100 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$100 === undefined) {
          break _L$22;
        } else {
          const _Some = _bind$100;
          const _x = _Some;
          if (_x.$tag === 1) {
            const _TString = _x;
            const _s = _TString._0;
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            const _bind$101 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
            if (_bind$101.$tag === 1) {
              const _ok = _bind$101;
              _ok._0;
            } else {
              return _bind$101;
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr7Capture(_s));
          } else {
            break _L$22;
          }
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("capture expects string argument"));
    }
    case "splits": {
      const _bind$100 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$100.$tag === 1) {
        const _ok = _bind$100;
        _ok._0;
      } else {
        return _bind$100;
      }
      _L$23: {
        const _bind$101 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$101 === undefined) {
          break _L$23;
        } else {
          const _Some = _bind$101;
          const _x = _Some;
          if (_x.$tag === 1) {
            const _TString = _x;
            const _s = _TString._0;
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            const _bind$102 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
            if (_bind$102.$tag === 1) {
              const _ok = _bind$102;
              _ok._0;
            } else {
              return _bind$102;
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr6Splits(_s));
          } else {
            break _L$23;
          }
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("splits expects string argument"));
    }
    case "sub": {
      const _bind$101 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$101.$tag === 1) {
        const _ok = _bind$101;
        _ok._0;
      } else {
        return _bind$101;
      }
      _L$24: {
        const _bind$102 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$102 === undefined) {
          break _L$24;
        } else {
          const _Some = _bind$102;
          const _x = _Some;
          if (_x.$tag === 1) {
            const _TString = _x;
            const _pattern = _TString._0;
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            const _bind$103 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token10TSemicolon__);
            if (_bind$103.$tag === 1) {
              const _ok = _bind$103;
              _ok._0;
            } else {
              return _bind$103;
            }
            _L$25: {
              const _bind$104 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
              if (_bind$104 === undefined) {
                break _L$25;
              } else {
                const _Some$2 = _bind$104;
                const _x$2 = _Some$2;
                if (_x$2.$tag === 1) {
                  const _TString$2 = _x$2;
                  const _replacement = _TString$2._0;
                  _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
                  const _bind$105 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
                  if (_bind$105.$tag === 1) {
                    const _ok = _bind$105;
                    _ok._0;
                  } else {
                    return _bind$105;
                  }
                  return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr3Sub(_pattern, _replacement));
                } else {
                  break _L$25;
                }
              }
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("sub expects string replacement"));
          } else {
            break _L$24;
          }
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("sub expects string pattern"));
    }
    case "gsub": {
      const _bind$102 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
      if (_bind$102.$tag === 1) {
        const _ok = _bind$102;
        _ok._0;
      } else {
        return _bind$102;
      }
      _L$25: {
        const _bind$103 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$103 === undefined) {
          break _L$25;
        } else {
          const _Some = _bind$103;
          const _x = _Some;
          if (_x.$tag === 1) {
            const _TString = _x;
            const _pattern = _TString._0;
            _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
            const _bind$104 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token10TSemicolon__);
            if (_bind$104.$tag === 1) {
              const _ok = _bind$104;
              _ok._0;
            } else {
              return _bind$104;
            }
            _L$26: {
              const _bind$105 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
              if (_bind$105 === undefined) {
                break _L$26;
              } else {
                const _Some$2 = _bind$105;
                const _x$2 = _Some$2;
                if (_x$2.$tag === 1) {
                  const _TString$2 = _x$2;
                  const _replacement = _TString$2._0;
                  _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
                  const _bind$106 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
                  if (_bind$106.$tag === 1) {
                    const _ok = _bind$106;
                    _ok._0;
                  } else {
                    return _bind$106;
                  }
                  return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr4GSub(_pattern, _replacement));
                } else {
                  break _L$26;
                }
              }
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("gsub expects string replacement"));
          } else {
            break _L$25;
          }
        }
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("gsub expects string pattern"));
    }
    default: {
      if (_M0IPC16option6OptionPB2Eq5equalGRP38bobzhang6moonjq6parser5TokenE(_M0MP38bobzhang6moonjq6parser6Parser7current(self), _M0DTP38bobzhang6moonjq6parser5Token7TLParen__)) {
        _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
        const args = [];
        if (!_M0IPC16option6OptionPB2Eq5equalGRP38bobzhang6moonjq6parser5TokenE(_M0MP38bobzhang6moonjq6parser6Parser7current(self), _M0DTP38bobzhang6moonjq6parser5Token7TRParen__)) {
          const _bind$103 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
          let _tmp$38;
          if (_bind$103.$tag === 1) {
            const _ok = _bind$103;
            _tmp$38 = _ok._0;
          } else {
            return _bind$103;
          }
          _M0MPC15array5Array4pushGUssEE(args, _tmp$38);
          while (true) {
            if (_M0MP38bobzhang6moonjq6parser6Parser7consume(self, _M0DTP38bobzhang6moonjq6parser5Token10TSemicolon__)) {
              const _bind$104 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
              let _tmp$39;
              if (_bind$104.$tag === 1) {
                const _ok = _bind$104;
                _tmp$39 = _ok._0;
              } else {
                return _bind$104;
              }
              _M0MPC15array5Array4pushGUssEE(args, _tmp$39);
              continue;
            } else {
              break;
            }
          }
        }
        const _bind$103 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
        if (_bind$103.$tag === 1) {
          const _ok = _bind$103;
          _ok._0;
        } else {
          return _bind$103;
        }
        return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr12FunctionCall(name, args));
      } else {
        return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr12FunctionCall(name, []));
      }
    }
  }
}
function _M0MP38bobzhang6moonjq6parser6Parser14parse__foreach(self) {
  _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
  const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser14parse__postfix(self);
  let gen_expr;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    gen_expr = _ok._0;
  } else {
    return _bind$4;
  }
  if (!_M0MP38bobzhang6moonjq6parser6Parser7consume(self, _M0DTP38bobzhang6moonjq6parser5Token3TAs__)) {
    return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("foreach expects 'as' after expression"));
  }
  let var_name;
  _L: {
    _L$2: {
      const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
      if (_bind$5 === undefined) {
        break _L$2;
      } else {
        const _Some = _bind$5;
        const _x = _Some;
        if (_x.$tag === 7) {
          const _TVariable = _x;
          const _name = _TVariable._0;
          _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
          var_name = _name;
        } else {
          break _L$2;
        }
      }
      break _L;
    }
    return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("foreach expects variable after as"));
  }
  const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    _ok._0;
  } else {
    return _bind$5;
  }
  const _bind$6 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
  let init_expr;
  if (_bind$6.$tag === 1) {
    const _ok = _bind$6;
    init_expr = _ok._0;
  } else {
    return _bind$6;
  }
  const _bind$7 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token10TSemicolon__);
  if (_bind$7.$tag === 1) {
    const _ok = _bind$7;
    _ok._0;
  } else {
    return _bind$7;
  }
  const _bind$8 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
  let update_expr;
  if (_bind$8.$tag === 1) {
    const _ok = _bind$8;
    update_expr = _ok._0;
  } else {
    return _bind$8;
  }
  let extract_expr;
  if (_M0MP38bobzhang6moonjq6parser6Parser7consume(self, _M0DTP38bobzhang6moonjq6parser5Token10TSemicolon__)) {
    const _bind$9 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
    if (_bind$9.$tag === 1) {
      const _ok = _bind$9;
      extract_expr = _ok._0;
    } else {
      return _bind$9;
    }
  } else {
    extract_expr = undefined;
  }
  const _bind$9 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
  if (_bind$9.$tag === 1) {
    const _ok = _bind$9;
    _ok._0;
  } else {
    return _bind$9;
  }
  return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr7Foreach(gen_expr, var_name, init_expr, update_expr, extract_expr));
}
function _M0MP38bobzhang6moonjq6parser6Parser9parse__if(self) {
  _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
  const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
  let cond;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    cond = _ok._0;
  } else {
    return _bind$4;
  }
  const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token5TThen__);
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    _ok._0;
  } else {
    return _bind$5;
  }
  const _bind$6 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
  let then_expr;
  if (_bind$6.$tag === 1) {
    const _ok = _bind$6;
    then_expr = _ok._0;
  } else {
    return _bind$6;
  }
  const _bind$7 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token5TElse__);
  if (_bind$7.$tag === 1) {
    const _ok = _bind$7;
    _ok._0;
  } else {
    return _bind$7;
  }
  const _bind$8 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
  let else_expr;
  if (_bind$8.$tag === 1) {
    const _ok = _bind$8;
    else_expr = _ok._0;
  } else {
    return _bind$8;
  }
  const _bind$9 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token4TEnd__);
  if (_bind$9.$tag === 1) {
    const _ok = _bind$9;
    _ok._0;
  } else {
    return _bind$9;
  }
  return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr10IfThenElse(cond, then_expr, else_expr));
}
function _M0MP38bobzhang6moonjq6parser6Parser13parse__object(self) {
  if (_M0MP38bobzhang6moonjq6parser6Parser7consume(self, _M0DTP38bobzhang6moonjq6parser5Token7TRBrace__)) {
    return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr15ObjectConstruct([]));
  }
  let pairs = [];
  while (true) {
    let key;
    _L: {
      _L$2: {
        const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
        if (_bind$4 === undefined) {
          break _L$2;
        } else {
          const _Some = _bind$4;
          const _x = _Some;
          switch (_x.$tag) {
            case 6: {
              const _TIdentifier = _x;
              const _name = _TIdentifier._0;
              _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
              key = new _M0DTP38bobzhang6moonjq3ast4Expr7Literal(new _M0DTP38bobzhang6moonjq3ast7Literal6String(_name));
              break;
            }
            case 1: {
              const _TString = _x;
              const _name$2 = _TString._0;
              _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
              key = new _M0DTP38bobzhang6moonjq3ast4Expr7Literal(new _M0DTP38bobzhang6moonjq3ast7Literal6String(_name$2));
              break;
            }
            case 16: {
              _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
              const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
              let expr;
              if (_bind$5.$tag === 1) {
                const _ok = _bind$5;
                expr = _ok._0;
              } else {
                return _bind$5;
              }
              const _bind$6 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
              if (_bind$6.$tag === 1) {
                const _ok = _bind$6;
                _ok._0;
              } else {
                return _bind$6;
              }
              key = expr;
              break;
            }
            default: {
              break _L$2;
            }
          }
        }
        break _L;
      }
      return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("Expected object key"));
    }
    let value;
    if (_M0MP38bobzhang6moonjq6parser6Parser7consume(self, _M0DTP38bobzhang6moonjq6parser5Token6TColon__)) {
      const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser17parse__assignment(self);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        value = _ok._0;
      } else {
        return _bind$4;
      }
    } else {
      value = undefined;
    }
    pairs = _M0IPC15array5ArrayPB3Add3addGsE(pairs, [{ _0: key, _1: value }]);
    if (!_M0MP38bobzhang6moonjq6parser6Parser7consume(self, _M0DTP38bobzhang6moonjq6parser5Token6TComma__)) {
      break;
    }
    if (_M0MP38bobzhang6moonjq6parser6Parser5check(self, _M0DTP38bobzhang6moonjq6parser5Token7TRBrace__)) {
      break;
    }
    continue;
  }
  const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRBrace__);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr15ObjectConstruct(pairs));
}
function _M0MP38bobzhang6moonjq6parser6Parser13parse__reduce(self) {
  _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
  const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser14parse__postfix(self);
  let gen_expr;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    gen_expr = _ok._0;
  } else {
    return _bind$4;
  }
  if (!_M0MP38bobzhang6moonjq6parser6Parser7consume(self, _M0DTP38bobzhang6moonjq6parser5Token3TAs__)) {
    return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("reduce expects 'as' after expression"));
  }
  let var_name;
  _L: {
    _L$2: {
      const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
      if (_bind$5 === undefined) {
        break _L$2;
      } else {
        const _Some = _bind$5;
        const _x = _Some;
        if (_x.$tag === 7) {
          const _TVariable = _x;
          const _name = _TVariable._0;
          _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
          var_name = _name;
        } else {
          break _L$2;
        }
      }
      break _L;
    }
    return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error55bobzhang_2fmoonjq_2fparser_2eParseError_2eInvalidSyntax("reduce expects variable after as"));
  }
  const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__);
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    _ok._0;
  } else {
    return _bind$5;
  }
  const _bind$6 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
  let init_expr;
  if (_bind$6.$tag === 1) {
    const _ok = _bind$6;
    init_expr = _ok._0;
  } else {
    return _bind$6;
  }
  const _bind$7 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token10TSemicolon__);
  if (_bind$7.$tag === 1) {
    const _ok = _bind$7;
    _ok._0;
  } else {
    return _bind$7;
  }
  const _bind$8 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
  let update_expr;
  if (_bind$8.$tag === 1) {
    const _ok = _bind$8;
    update_expr = _ok._0;
  } else {
    return _bind$8;
  }
  const _bind$9 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
  if (_bind$9.$tag === 1) {
    const _ok = _bind$9;
    _ok._0;
  } else {
    return _bind$9;
  }
  return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr6Reduce(gen_expr, var_name, init_expr, update_expr));
}
function _M0MP38bobzhang6moonjq6parser6Parser10parse__try(self) {
  _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
  const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser14parse__postfix(self);
  let expr;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    expr = _ok._0;
  } else {
    return _bind$4;
  }
  let handler;
  if (_M0MP38bobzhang6moonjq6parser6Parser7consume(self, _M0DTP38bobzhang6moonjq6parser5Token6TCatch__)) {
    const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser14parse__postfix(self);
    if (_bind$5.$tag === 1) {
      const _ok = _bind$5;
      handler = _ok._0;
    } else {
      return _bind$5;
    }
  } else {
    handler = undefined;
  }
  return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr8TryCatch(expr, handler));
}
function _M0MP38bobzhang6moonjq6parser6Parser20parse__function__def(self) {
  const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token4TDef__);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  let name;
  _L: {
    _L$2: {
      const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
      if (_bind$5 === undefined) {
        break _L$2;
      } else {
        const _Some = _bind$5;
        const _x = _Some;
        if (_x.$tag === 6) {
          const _TIdentifier = _x;
          const _n = _TIdentifier._0;
          _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
          name = _n;
        } else {
          break _L$2;
        }
      }
      break _L;
    }
    return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fparser_2eParseError_2eUnexpectedToken("identifier", "function name"));
  }
  const params = [];
  if (_M0MP38bobzhang6moonjq6parser6Parser7consume(self, _M0DTP38bobzhang6moonjq6parser5Token7TLParen__)) {
    if (!_M0IPC16option6OptionPB2Eq5equalGRP38bobzhang6moonjq6parser5TokenE(_M0MP38bobzhang6moonjq6parser6Parser7current(self), _M0DTP38bobzhang6moonjq6parser5Token7TRParen__)) {
      _L$2: {
        _L$3: {
          const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
          if (_bind$5 === undefined) {
            break _L$3;
          } else {
            const _Some = _bind$5;
            const _x = _Some;
            if (_x.$tag === 6) {
              const _TIdentifier = _x;
              const _p$4 = _TIdentifier._0;
              _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
              _M0MPC15array5Array4pushGUssEE(params, _p$4);
            } else {
              break _L$3;
            }
          }
          break _L$2;
        }
        return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fparser_2eParseError_2eUnexpectedToken("identifier", "parameter"));
      }
      while (true) {
        if (_M0MP38bobzhang6moonjq6parser6Parser7consume(self, _M0DTP38bobzhang6moonjq6parser5Token10TSemicolon__)) {
          _L$3: {
            _L$4: {
              const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser7current(self);
              if (_bind$5 === undefined) {
                break _L$4;
              } else {
                const _Some = _bind$5;
                const _x = _Some;
                if (_x.$tag === 6) {
                  const _TIdentifier = _x;
                  const _p$4 = _TIdentifier._0;
                  _M0MP38bobzhang6moonjq6parser6Parser7advance(self);
                  _M0MPC15array5Array4pushGUssEE(params, _p$4);
                } else {
                  break _L$4;
                }
              }
              break _L$3;
            }
            return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE3Err(new _M0DTPC15error5Error57bobzhang_2fmoonjq_2fparser_2eParseError_2eUnexpectedToken("identifier", "parameter"));
          }
          continue;
        } else {
          break;
        }
      }
    }
    const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token7TRParen__);
    if (_bind$5.$tag === 1) {
      const _ok = _bind$5;
      _ok._0;
    } else {
      return _bind$5;
    }
  }
  const _bind$5 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token6TColon__);
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    _ok._0;
  } else {
    return _bind$5;
  }
  const _bind$6 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
  let body;
  if (_bind$6.$tag === 1) {
    const _ok = _bind$6;
    body = _ok._0;
  } else {
    return _bind$6;
  }
  const _bind$7 = _M0MP38bobzhang6moonjq6parser6Parser6expect(self, _M0DTP38bobzhang6moonjq6parser5Token10TSemicolon__);
  if (_bind$7.$tag === 1) {
    const _ok = _bind$7;
    _ok._0;
  } else {
    return _bind$7;
  }
  return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(new _M0DTP38bobzhang6moonjq3ast4Expr11FunctionDef(name, params, body));
}
function _M0MP38bobzhang6moonjq6parser6Parser18parse__definitions(self) {
  const defs = [];
  while (true) {
    if (_M0IPC16option6OptionPB2Eq5equalGRP38bobzhang6moonjq6parser5TokenE(_M0MP38bobzhang6moonjq6parser6Parser7current(self), _M0DTP38bobzhang6moonjq6parser5Token4TDef__)) {
      const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser20parse__function__def(self);
      let _tmp$38;
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        _tmp$38 = _ok._0;
      } else {
        return _bind$4;
      }
      _M0MPC15array5Array4pushGUssEE(defs, _tmp$38);
      continue;
    } else {
      break;
    }
  }
  const _bind$4 = _M0MP38bobzhang6moonjq6parser6Parser11parse__pipe(self);
  let main_expr;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    main_expr = _ok._0;
  } else {
    return _bind$4;
  }
  let _tmp$38;
  if (defs.length === 0) {
    _tmp$38 = main_expr;
  } else {
    const _p$4 = _M0MPC15array5Array3revGRP38bobzhang6moonjq3ast4ExprE(defs);
    const _p$5 = _p$4.length;
    let _tmp$39 = 0;
    let _tmp$40 = main_expr;
    while (true) {
      const _p$6 = _tmp$39;
      const _p$7 = _tmp$40;
      if (_p$6 < _p$5) {
        const _p$8 = _p$4[_p$6];
        _tmp$39 = _p$6 + 1 | 0;
        _tmp$40 = new _M0DTP38bobzhang6moonjq3ast4Expr4Pipe(_p$8, _p$7);
        continue;
      } else {
        _tmp$38 = _p$7;
        break;
      }
    }
  }
  return new _M0DTPC16result6ResultGRP38bobzhang6moonjq3ast4ExprRP38bobzhang6moonjq6parser10ParseErrorE2Ok(_tmp$38);
}
function _M0FP38bobzhang6moonjq6parser5parse(input) {
  const _bind$4 = _M0FP38bobzhang6moonjq6parser3lex(input);
  let tokens;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    tokens = _ok._0;
  } else {
    return _bind$4;
  }
  const parser = _M0MP38bobzhang6moonjq6parser6Parser3new(tokens);
  return _M0MP38bobzhang6moonjq6parser6Parser18parse__definitions(parser);
}
function _M0FP28bobzhang6moonjq5parse(query) {
  const _bind$4 = _M0FP38bobzhang6moonjq6parser5parse(query);
  let _tmp$38;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _tmp$38 = _ok._0;
  } else {
    return _bind$4;
  }
  return new _M0DTPC16result6ResultGRP28bobzhang6moonjq5QueryRPC15error5ErrorE2Ok(new _M0TP28bobzhang6moonjq5Query(_tmp$38));
}
function _M0MP28bobzhang6moonjq5Query4eval(self, input) {
  return _M0FP38bobzhang6moonjq3ast4eval(self.expr, input);
}
function _M0MP28bobzhang6moonjq5Query9eval__all(self, input) {
  const _bind$4 = _M0MP28bobzhang6moonjq5Query4eval(self, input);
  let _tmp$38;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _tmp$38 = _ok._0;
  } else {
    return _bind$4;
  }
  return new _M0DTPC16result6ResultGRPB5ArrayGRPB4JsonERPC15error5ErrorE2Ok(_M0MPB4Iter9to__arrayGRPB4JsonE(_tmp$38));
}
function _M0FP28bobzhang6moonjq9run__json(query, input) {
  return _M0MP28bobzhang6moonjq5Query9eval__all(query, input);
}
function _M0IP27gmlewis6base6417CorruptInputErrorPB4Show6output(_x_97, _x_98) {
  const _CorruptInputError = _x_97;
  const _$42$arg_99 = _CorruptInputError._0;
  _x_98.method_table.method_0(_x_98.self, "CorruptInputError(");
  _M0MPB6Logger13write__objectGsE(_x_98, _$42$arg_99);
  _x_98.method_table.method_0(_x_98.self, ")");
}
function _M0FP27gmlewis6base649str2bytes(s) {
  return _M0FPC28encoding4utf814encode_2einner(new _M0TPC16string10StringView(s, 0, s.length), false);
}
function _M0FP27gmlewis6base649str2array(s) {
  return _M0MPC15bytes5Bytes9to__array(_M0FPC28encoding4utf814encode_2einner(new _M0TPC16string10StringView(s, 0, s.length), false));
}
function _M0FP27gmlewis6base649bytes2str(b) {
  const chars = _M0FPC28encoding4utf821decode__lossy_2einner(_M0MPC15bytes5Bytes12view_2einner(b, 0, b.length), false);
  const buf = _M0FPC16buffer11new_2einner(chars.length);
  const _it = _M0MPC16string6String4iter(chars);
  while (true) {
    const _bind$4 = _M0MPB4Iter4nextGcE(_it);
    if (_bind$4 === -1) {
      break;
    } else {
      const _Some = _bind$4;
      const _ch = _Some;
      _M0IPC16buffer6BufferPB6Logger11write__char(buf, _ch);
      continue;
    }
  }
  return _M0MPC15bytes5Bytes29to__unchecked__string_2einner(_M0MPC16buffer6Buffer9to__bytes(buf), 0, undefined);
}
function _M0FP27gmlewis6base6411encode__buf(encode, dst, src, no_padding) {
  let di = 0;
  let si = 0;
  const n = Math.imul(src.length / 3 | 0, 3) | 0;
  while (true) {
    if (si < n) {
      const _tmp$38 = si;
      $bound_check(src, _tmp$38);
      const _p$4 = src[_tmp$38];
      const _tmp$39 = _p$4 << 16;
      const _tmp$40 = si + 1 | 0;
      $bound_check(src, _tmp$40);
      const _p$5 = src[_tmp$40];
      const _tmp$41 = _tmp$39 | _p$5 << 8;
      const _tmp$42 = si + 2 | 0;
      $bound_check(src, _tmp$42);
      const _p$6 = src[_tmp$42];
      const val = _tmp$41 | _p$6;
      const _tmp$43 = di;
      const _tmp$44 = val >>> 18 & 63;
      $bound_check(encode, _tmp$44);
      $bound_check(dst, _tmp$43);
      dst[_tmp$43] = encode[_tmp$44];
      const _tmp$45 = di + 1 | 0;
      const _tmp$46 = val >>> 12 & 63;
      $bound_check(encode, _tmp$46);
      $bound_check(dst, _tmp$45);
      dst[_tmp$45] = encode[_tmp$46];
      const _tmp$47 = di + 2 | 0;
      const _tmp$48 = val >>> 6 & 63;
      $bound_check(encode, _tmp$48);
      $bound_check(dst, _tmp$47);
      dst[_tmp$47] = encode[_tmp$48];
      const _tmp$49 = di + 3 | 0;
      const _tmp$50 = val & 63;
      $bound_check(encode, _tmp$50);
      $bound_check(dst, _tmp$49);
      dst[_tmp$49] = encode[_tmp$50];
      si = si + 3 | 0;
      di = di + 4 | 0;
      continue;
    } else {
      break;
    }
  }
  const remain = src.length - si | 0;
  if (remain === 0) {
    return undefined;
  }
  const _tmp$38 = si;
  $bound_check(src, _tmp$38);
  const _p$4 = src[_tmp$38];
  let val = _p$4 << 16;
  if (remain === 2) {
    const _tmp$39 = val;
    const _tmp$40 = si + 1 | 0;
    $bound_check(src, _tmp$40);
    const _p$5 = src[_tmp$40];
    val = _tmp$39 | _p$5 << 8;
  }
  const _tmp$39 = di;
  const _tmp$40 = val >>> 18 & 63;
  $bound_check(encode, _tmp$40);
  $bound_check(dst, _tmp$39);
  dst[_tmp$39] = encode[_tmp$40];
  const _tmp$41 = di + 1 | 0;
  const _tmp$42 = val >>> 12 & 63;
  $bound_check(encode, _tmp$42);
  $bound_check(dst, _tmp$41);
  dst[_tmp$41] = encode[_tmp$42];
  switch (remain) {
    case 2: {
      const _tmp$43 = di + 2 | 0;
      const _tmp$44 = val >>> 6 & 63;
      $bound_check(encode, _tmp$44);
      $bound_check(dst, _tmp$43);
      dst[_tmp$43] = encode[_tmp$44];
      if (!no_padding) {
        const _tmp$45 = di + 3 | 0;
        $bound_check(dst, _tmp$45);
        dst[_tmp$45] = 61;
        return;
      } else {
        return;
      }
    }
    case 1: {
      if (!no_padding) {
        const _tmp$45 = di + 2 | 0;
        $bound_check(dst, _tmp$45);
        dst[_tmp$45] = 61;
        const _tmp$46 = di + 3 | 0;
        $bound_check(dst, _tmp$46);
        dst[_tmp$46] = 61;
        return;
      } else {
        return;
      }
    }
    default: {
      return;
    }
  }
}
function _M0FP27gmlewis6base6412encoded__len(n, no_padding) {
  return no_padding ? (Math.imul(n / 3 | 0, 4) | 0) + (((Math.imul(n % 3 | 0, 8) | 0) + 5 | 0) / 6 | 0) | 0 : Math.imul((n + 2 | 0) / 3 | 0, 4) | 0;
}
function _M0FP27gmlewis6base6425std__encode2bytes_2einner(src, no_padding) {
  if (src.length === 0) {
    const _bind$4 = new Uint8Array([]);
    return _M0MPC15bytes5Bytes11from__array(new _M0TPB9ArrayViewGyE(_bind$4, 0, 0));
  }
  const buf = $makebytes(_M0FP27gmlewis6base6412encoded__len(src.length, no_padding), 0);
  _M0FP27gmlewis6base6411encode__buf(_M0FP27gmlewis6base6413std__encoding, buf, src, no_padding);
  return _M0MPC15bytes5Bytes10from__iter(_M0MPC15array10FixedArray4iterGyE(buf));
}
function _M0FP27gmlewis6base6423std__encode2str_2einner(src, no_padding) {
  return _M0FP27gmlewis6base649bytes2str(_M0FP27gmlewis6base6425std__encode2bytes_2einner(src, no_padding));
}
function _M0FP27gmlewis6base6410assemble32(n1, n2, n3, n4) {
  const _p$4 = (n3 | n4) & 255;
  const _p$5 = (n2 | _p$4) & 255;
  const _p$6 = (n1 | _p$5) & 255;
  const _p$7 = 255;
  if (_p$6 === _p$7) {
    return _M0FP27gmlewis6base6410assemble32N5tupleS214;
  }
  return { _0: n1 << 26 | (n2 << 20 | (n3 << 14 | n4 << 8)), _1: true };
}
function _M0FP27gmlewis6base6415be__put__uint32(b, offset, value) {
  const _tmp$38 = offset + 3 | 0;
  const _p$4 = value & 255;
  $bound_check(b, _tmp$38);
  b[_tmp$38] = _p$4 & 255;
  const _tmp$39 = offset + 2 | 0;
  const _p$5 = value >>> 8 & 255;
  $bound_check(b, _tmp$39);
  b[_tmp$39] = _p$5 & 255;
  const _tmp$40 = offset + 1 | 0;
  const _p$6 = value >>> 16 & 255;
  $bound_check(b, _tmp$40);
  b[_tmp$40] = _p$6 & 255;
  const _p$7 = value >>> 24 & 255;
  $bound_check(b, offset);
  b[offset] = _p$7 & 255;
}
function _M0FP27gmlewis6base6415decode__quantum(decode_map, dst, dst_offset, src, si, decode_pad_char, no_padding) {
  const dbuf = $makebytes(4, 0);
  let dlen = 4;
  let si$2 = si;
  let _tmp$38 = 0;
  while (true) {
    const j = _tmp$38;
    if (j < 4) {
      _L: {
        if (src.length === si$2) {
          if (j === 0) {
            return new _M0DTPC16result6ResultGUiiERP27gmlewis6base6417CorruptInputErrorE2Ok({ _0: si$2, _1: 0 });
          }
          if (j === 1 || !no_padding) {
            const pos = si$2 - j | 0;
            return new _M0DTPC16result6ResultGUiiERP27gmlewis6base6417CorruptInputErrorE3Err(new _M0DTPC15error5Error56gmlewis_2fbase64_2eCorruptInputError_2eCorruptInputError(`illegal base64 data at input byte ${_M0IPC13int3IntPB4Show10to__string(pos)}`));
          }
          dlen = j;
          break;
        }
        const _tmp$39 = si$2;
        $bound_check(src, _tmp$39);
        const in_byte = src[_tmp$39];
        si$2 = si$2 + 1 | 0;
        $bound_check(decode_map, in_byte);
        const out = decode_map[in_byte];
        if (out !== 255) {
          $bound_check(dbuf, j);
          dbuf[j] = out;
          break _L;
        }
        let _tmp$40;
        const _p$4 = 10;
        if (in_byte === _p$4) {
          _tmp$40 = true;
        } else {
          const _p$5 = 13;
          _tmp$40 = in_byte === _p$5;
        }
        if (_tmp$40) {
          _tmp$38 = j - 1 | 0;
          continue;
        }
        if (in_byte !== decode_pad_char) {
          const pos = si$2 - 1 | 0;
          return new _M0DTPC16result6ResultGUiiERP27gmlewis6base6417CorruptInputErrorE3Err(new _M0DTPC15error5Error56gmlewis_2fbase64_2eCorruptInputError_2eCorruptInputError(`expected pad characted at input byte ${_M0IPC13int3IntPB4Show10to__string(pos)}`));
        }
        if (j === 0 || j === 1) {
          const pos = si$2 - 1 | 0;
          return new _M0DTPC16result6ResultGUiiERP27gmlewis6base6417CorruptInputErrorE3Err(new _M0DTPC15error5Error56gmlewis_2fbase64_2eCorruptInputError_2eCorruptInputError(`incorrect padding at input byte ${_M0IPC13int3IntPB4Show10to__string(pos)}`));
        }
        if (j === 2) {
          while (true) {
            let _tmp$41;
            if (si$2 < src.length) {
              let _tmp$42;
              const _tmp$43 = si$2;
              $bound_check(src, _tmp$43);
              const _p$5 = src[_tmp$43];
              const _p$6 = 10;
              if (_p$5 === _p$6) {
                _tmp$42 = true;
              } else {
                const _tmp$44 = si$2;
                $bound_check(src, _tmp$44);
                const _p$7 = src[_tmp$44];
                const _p$8 = 13;
                _tmp$42 = _p$7 === _p$8;
              }
              _tmp$41 = _tmp$42;
            } else {
              _tmp$41 = false;
            }
            if (_tmp$41) {
              si$2 = si$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          if (si$2 === src.length) {
            const pos = src.length;
            return new _M0DTPC16result6ResultGUiiERP27gmlewis6base6417CorruptInputErrorE3Err(new _M0DTPC15error5Error56gmlewis_2fbase64_2eCorruptInputError_2eCorruptInputError(`not enough padding at ${_M0IPC13int3IntPB4Show10to__string(pos)}`));
          }
          const _tmp$41 = si$2;
          $bound_check(src, _tmp$41);
          if (src[_tmp$41] !== decode_pad_char) {
            const pos = si$2 - 1 | 0;
            return new _M0DTPC16result6ResultGUiiERP27gmlewis6base6417CorruptInputErrorE3Err(new _M0DTPC15error5Error56gmlewis_2fbase64_2eCorruptInputError_2eCorruptInputError(`incorrect padding at ${_M0IPC13int3IntPB4Show10to__string(pos)}`));
          }
          si$2 = si$2 + 1 | 0;
        }
        while (true) {
          let _tmp$41;
          if (si$2 < src.length) {
            let _tmp$42;
            const _tmp$43 = si$2;
            $bound_check(src, _tmp$43);
            const _p$5 = src[_tmp$43];
            const _p$6 = 10;
            if (_p$5 === _p$6) {
              _tmp$42 = true;
            } else {
              const _tmp$44 = si$2;
              $bound_check(src, _tmp$44);
              const _p$7 = src[_tmp$44];
              const _p$8 = 13;
              _tmp$42 = _p$7 === _p$8;
            }
            _tmp$41 = _tmp$42;
          } else {
            _tmp$41 = false;
          }
          if (_tmp$41) {
            si$2 = si$2 + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        if (si$2 < src.length) {
          return new _M0DTPC16result6ResultGUiiERP27gmlewis6base6417CorruptInputErrorE3Err(new _M0DTPC15error5Error56gmlewis_2fbase64_2eCorruptInputError_2eCorruptInputError(`trailing garbage at ${_M0IPC13int3IntPB4Show10to__string(si$2)}`));
        }
        dlen = j;
        break;
      }
      _tmp$38 = j + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  $bound_check(dbuf, 0);
  const _p$4 = dbuf[0];
  const _tmp$39 = _p$4 << 18;
  $bound_check(dbuf, 1);
  const _p$5 = dbuf[1];
  const _tmp$40 = _tmp$39 | _p$5 << 12;
  $bound_check(dbuf, 2);
  const _p$6 = dbuf[2];
  const _tmp$41 = _tmp$40 | _p$6 << 6;
  $bound_check(dbuf, 3);
  const _p$7 = dbuf[3];
  const val = _tmp$41 | _p$7;
  const _p$8 = val >>> 0 | 0;
  $bound_check(dbuf, 2);
  dbuf[2] = _p$8 & 255;
  const _p$9 = val >>> 8 | 0;
  $bound_check(dbuf, 1);
  dbuf[1] = _p$9 & 255;
  const _p$10 = val >>> 16 | 0;
  $bound_check(dbuf, 0);
  dbuf[0] = _p$10 & 255;
  if (dlen === 4) {
    const _tmp$42 = dst_offset + 2 | 0;
    $bound_check(dbuf, 2);
    $bound_check(dst, _tmp$42);
    dst[_tmp$42] = dbuf[2];
    $bound_check(dbuf, 2);
    dbuf[2] = 0;
  }
  if (dlen >= 3) {
    const _tmp$42 = dst_offset + 1 | 0;
    $bound_check(dbuf, 1);
    $bound_check(dst, _tmp$42);
    dst[_tmp$42] = dbuf[1];
    $bound_check(dbuf, 1);
    dbuf[1] = 0;
  }
  if (dlen >= 2) {
    $bound_check(dbuf, 0);
    $bound_check(dst, dst_offset);
    dst[dst_offset] = dbuf[0];
  }
  return new _M0DTPC16result6ResultGUiiERP27gmlewis6base6417CorruptInputErrorE2Ok({ _0: si$2, _1: dlen - 1 | 0 });
}
function _M0FP27gmlewis6base6411decode__buf(decode_map, dst, src, no_padding) {
  if (src.length === 0) {
    return new _M0DTPC16result6ResultGiRP27gmlewis6base6417CorruptInputErrorE2Ok(0);
  }
  const decode_pad_char = no_padding ? 255 : 61;
  let si = 0;
  let n = 0;
  while (true) {
    if ((src.length - si | 0) >= 4 && (dst.length - n | 0) >= 4) {
      const _tmp$38 = si;
      $bound_check(src, _tmp$38);
      const _tmp$39 = src[_tmp$38];
      $bound_check(decode_map, _tmp$39);
      const _tmp$40 = decode_map[_tmp$39];
      const _tmp$41 = si + 1 | 0;
      $bound_check(src, _tmp$41);
      const _tmp$42 = src[_tmp$41];
      $bound_check(decode_map, _tmp$42);
      const _tmp$43 = decode_map[_tmp$42];
      const _tmp$44 = si + 2 | 0;
      $bound_check(src, _tmp$44);
      const _tmp$45 = src[_tmp$44];
      $bound_check(decode_map, _tmp$45);
      const _tmp$46 = decode_map[_tmp$45];
      const _tmp$47 = si + 3 | 0;
      $bound_check(src, _tmp$47);
      const _tmp$48 = src[_tmp$47];
      $bound_check(decode_map, _tmp$48);
      const _bind$4 = _M0FP27gmlewis6base6410assemble32(_tmp$40, _tmp$43, _tmp$46, decode_map[_tmp$48]);
      const _dn = _bind$4._0;
      const _ok = _bind$4._1;
      if (_ok) {
        _M0FP27gmlewis6base6415be__put__uint32(dst, n, _dn);
        n = n + 3 | 0;
        si = si + 4 | 0;
      } else {
        const _bind$5 = _M0FP27gmlewis6base6415decode__quantum(decode_map, dst, n, src, si, decode_pad_char, no_padding);
        let pair;
        if (_bind$5.$tag === 1) {
          const _ok$2 = _bind$5;
          pair = _ok$2._0;
        } else {
          return _bind$5;
        }
        si = pair._0;
        const ninc = pair._1;
        n = n + ninc | 0;
      }
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (si < src.length) {
      const _bind$4 = _M0FP27gmlewis6base6415decode__quantum(decode_map, dst, n, src, si, decode_pad_char, no_padding);
      let pair;
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        pair = _ok._0;
      } else {
        return _bind$4;
      }
      si = pair._0;
      const ninc = pair._1;
      n = n + ninc | 0;
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGiRP27gmlewis6base6417CorruptInputErrorE2Ok(n);
}
function _M0FP27gmlewis6base6412decoded__len(n, no_padding) {
  if (no_padding) {
    return (Math.imul(n / 4 | 0, 3) | 0) + ((Math.imul(n % 4 | 0, 6) | 0) / 8 | 0) | 0;
  }
  return Math.imul(n / 4 | 0, 3) | 0;
}
function _M0FP27gmlewis6base6425std__decode2bytes_2einner(src, no_padding) {
  if (src.length === 0) {
    const _bind$4 = new Uint8Array([]);
    return new _M0DTPC16result6ResultGzRP27gmlewis6base6417CorruptInputErrorE2Ok(_M0MPC15bytes5Bytes11from__array(new _M0TPB9ArrayViewGyE(_bind$4, 0, 0)));
  }
  const buf = $makebytes(_M0FP27gmlewis6base6412decoded__len(src.length, no_padding), 0);
  const src$2 = _M0MPC15array10FixedArray10from__iterGyE(_M0MPC15bytes5Bytes4iter(_M0FP27gmlewis6base649str2bytes(src)));
  const _bind$4 = _M0FP27gmlewis6base6411decode__buf(_M0FP27gmlewis6base6416std__decode__map, buf, src$2, no_padding);
  let n;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    n = _ok._0;
  } else {
    return _bind$4;
  }
  return new _M0DTPC16result6ResultGzRP27gmlewis6base6417CorruptInputErrorE2Ok(_M0MPC15bytes5Bytes10from__iter(_M0MPB4Iter4takeGyE(_M0MPC15array10FixedArray4iterGyE(buf), n)));
}
function _M0FP27gmlewis6base6423std__decode2str_2einner(src, no_padding) {
  const _bind$4 = _M0FP27gmlewis6base6425std__decode2bytes_2einner(src, no_padding);
  let _tmp$38;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _tmp$38 = _ok._0;
  } else {
    return _bind$4;
  }
  return new _M0DTPC16result6ResultGsRP27gmlewis6base6417CorruptInputErrorE2Ok(_M0FP27gmlewis6base649bytes2str(_tmp$38));
}
function _M0IP27gmlewis2io7IOErrorPB4Show6output(_x_384, _x_385) {
  const _IOError = _x_384;
  const _$42$arg_386 = _IOError._0;
  _x_385.method_table.method_0(_x_385.self, "IOError(");
  _M0MPB6Logger13write__objectGsE(_x_385, _$42$arg_386);
  _x_385.method_table.method_0(_x_385.self, ")");
}
function _M0IP27gmlewis2io7IOErrorPB2Eq5equal(_x_376, _x_377) {
  const _IOError = _x_376;
  const _$42$x0_378 = _IOError._0;
  const _IOError$2 = _x_377;
  const _$42$y0_379 = _IOError$2._0;
  return _$42$x0_378 === _$42$y0_379;
}
function _M0MP27gmlewis2io5Slice7op__getGyE(self, index) {
  return index >= 0 && index < self.len ? _M0MPC15array5Array2atGyE(self.buf, self.start + index | 0) : _M0FPC15abort5abortGyE(`index out of bounds: the len is from 0 to ${_M0IPC13int3IntPB4Show10to__string(self.len)} but the index is ${_M0IPC13int3IntPB4Show10to__string(index)}`);
}
function _M0MP27gmlewis2io5Slice7op__getGRP27gmlewis5flate11LiteralNodeE(self, index) {
  return index >= 0 && index < self.len ? _M0MPC15array5Array2atGUssEE(self.buf, self.start + index | 0) : _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE(`index out of bounds: the len is from 0 to ${_M0IPC13int3IntPB4Show10to__string(self.len)} but the index is ${_M0IPC13int3IntPB4Show10to__string(index)}`);
}
function _M0MP27gmlewis2io5Slice7op__setGyE(self, index, value) {
  if (index >= 0 && index < self.len) {
    _M0MPC15array5Array3setGyE(self.buf, self.start + index | 0, value);
    return;
  } else {
    _M0FPC15abort5abortGuE(`index out of bounds: the len is from 0 to ${_M0IPC13int3IntPB4Show10to__string(self.len)} but the index is ${_M0IPC13int3IntPB4Show10to__string(index)}`);
    return;
  }
}
function _M0MP27gmlewis2io5Slice7op__setGRP27gmlewis5flate11LiteralNodeE(self, index, value) {
  if (index >= 0 && index < self.len) {
    _M0MPC15array5Array3setGsE(self.buf, self.start + index | 0, value);
    return;
  } else {
    _M0FPC15abort5abortGuE(`index out of bounds: the len is from 0 to ${_M0IPC13int3IntPB4Show10to__string(self.len)} but the index is ${_M0IPC13int3IntPB4Show10to__string(index)}`);
    return;
  }
}
function _M0MP27gmlewis2io5Slice7op__setGiE(self, index, value) {
  if (index >= 0 && index < self.len) {
    _M0MPC15array5Array3setGiE(self.buf, self.start + index | 0, value);
    return;
  } else {
    _M0FPC15abort5abortGuE(`index out of bounds: the len is from 0 to ${_M0IPC13int3IntPB4Show10to__string(self.len)} but the index is ${_M0IPC13int3IntPB4Show10to__string(index)}`);
    return;
  }
}
function _M0MP27gmlewis2io5Slice4swapGRP27gmlewis5flate11LiteralNodeE(self, i, j) {
  if (i >= 0 && (i < self.len && (j >= 0 && j < self.len))) {
    const temp = _M0MPC15array5Array2atGUssEE(self.buf, self.start + i | 0);
    _M0MPC15array5Array3setGsE(self.buf, self.start + i | 0, _M0MPC15array5Array2atGUssEE(self.buf, self.start + j | 0));
    _M0MPC15array5Array3setGsE(self.buf, self.start + j | 0, temp);
    return;
  } else {
    _M0FPC15abort5abortGuE(`index out of bounds: the len is from 0 to ${_M0IPC13int3IntPB4Show10to__string(self.len)} but the index is (${_M0IPC13int3IntPB4Show10to__string(i)}, ${_M0IPC13int3IntPB4Show10to__string(j)})`);
    return;
  }
}
function _M0MP27gmlewis2io5Slice11new_2einnerGyE(buf, start, end) {
  const len = buf.length;
  let end$2;
  if (end === undefined) {
    end$2 = len;
  } else {
    const _Some = end;
    end$2 = _Some;
  }
  return start >= 0 && (start <= end$2 && end$2 <= len) ? new _M0TP27gmlewis2io5SliceGyE(buf, start, end$2 - start | 0) : _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("View start index out of bounds");
}
function _M0MP27gmlewis2io5Slice11new_2einnerGjE(buf, start, end) {
  const len = buf.length;
  let end$2;
  if (end === undefined) {
    end$2 = len;
  } else {
    const _Some = end;
    end$2 = _Some;
  }
  return start >= 0 && (start <= end$2 && end$2 <= len) ? new _M0TP27gmlewis2io5SliceGjE(buf, start, end$2 - start | 0) : _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("View start index out of bounds");
}
function _M0MP27gmlewis2io5Slice11new_2einnerGiE(buf, start, end) {
  const len = buf.length;
  let end$2;
  if (end === undefined) {
    end$2 = len;
  } else {
    const _Some = end;
    end$2 = _Some;
  }
  return start >= 0 && (start <= end$2 && end$2 <= len) ? new _M0TP27gmlewis2io5SliceGiE(buf, start, end$2 - start | 0) : _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("View start index out of bounds");
}
function _M0MP27gmlewis2io5Slice11new_2einnerGRP27gmlewis5flate11LiteralNodeE(buf, start, end) {
  const len = buf.length;
  let end$2;
  if (end === undefined) {
    end$2 = len;
  } else {
    const _Some = end;
    end$2 = _Some;
  }
  return start >= 0 && (start <= end$2 && end$2 <= len) ? new _M0TP27gmlewis2io5SliceGRP27gmlewis5flate11LiteralNodeE(buf, start, end$2 - start | 0) : _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("View start index out of bounds");
}
function _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(self, start, end) {
  const len = self.buf.length;
  let end$2;
  if (end === undefined) {
    end$2 = self.len;
  } else {
    const _Some = end;
    end$2 = _Some;
  }
  return (self.start + start | 0) >= 0 && (start <= end$2 && (self.start + end$2 | 0) <= len) ? new _M0TP27gmlewis2io5SliceGyE(self.buf, self.start + start | 0, end$2 - start | 0) : _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("View start index out of bounds");
}
function _M0MP27gmlewis2io5Slice20op__as__view_2einnerGiE(self, start, end) {
  const len = self.buf.length;
  let end$2;
  if (end === undefined) {
    end$2 = self.len;
  } else {
    const _Some = end;
    end$2 = _Some;
  }
  return (self.start + start | 0) >= 0 && (start <= end$2 && (self.start + end$2 | 0) <= len) ? new _M0TP27gmlewis2io5SliceGiE(self.buf, self.start + start | 0, end$2 - start | 0) : _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("View start index out of bounds");
}
function _M0MP27gmlewis2io5Slice20op__as__view_2einnerGRP27gmlewis5flate11LiteralNodeE(self, start, end) {
  const len = self.buf.length;
  let end$2;
  if (end === undefined) {
    end$2 = self.len;
  } else {
    const _Some = end;
    end$2 = _Some;
  }
  return (self.start + start | 0) >= 0 && (start <= end$2 && (self.start + end$2 | 0) <= len) ? new _M0TP27gmlewis2io5SliceGRP27gmlewis5flate11LiteralNodeE(self.buf, self.start + start | 0, end$2 - start | 0) : _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("View start index out of bounds");
}
function _M0MP27gmlewis2io5Slice4iterGyE(self) {
  return _M0MPC15array9ArrayView4iterGyE(_M0MPC15array5Array12view_2einnerGyE(self.buf, self.start, self.start + self.len | 0));
}
function _M0MP27gmlewis2io5Slice4iterGiE(self) {
  return _M0MPC15array9ArrayView4iterGiE(_M0MPC15array5Array12view_2einnerGiE(self.buf, self.start, self.start + self.len | 0));
}
function _M0MP27gmlewis2io5Slice4iterGRP27gmlewis5flate11LiteralNodeE(self) {
  return _M0MPC15array9ArrayView4iterGsE(_M0MPC15array5Array12view_2einnerGsE(self.buf, self.start, self.start + self.len | 0));
}
function _M0MP27gmlewis2io5Slice5iter2GiE(self) {
  return _M0MPC15array9ArrayView5iter2GiE(_M0MPC15array5Array12view_2einnerGiE(self.buf, self.start, self.start + self.len | 0));
}
function _M0MP27gmlewis2io5Slice5iter2GRP27gmlewis5flate11LiteralNodeE(self) {
  return _M0MPC15array9ArrayView5iter2GRP27gmlewis5flate11LiteralNodeE(_M0MPC15array5Array12view_2einnerGsE(self.buf, self.start, self.start + self.len | 0));
}
function _M0FP27gmlewis2io15read__at__least(r, buf, min) {
  let n = 0;
  let err = undefined;
  if (buf.len < min) {
    return { _0: 0, _1: _M0FP27gmlewis2io18err__short__buffer };
  }
  while (true) {
    if (n < min && _M0IPC16option6OptionPB2Eq5equalGRP27gmlewis2io7IOErrorE(err, undefined)) {
      const v = r.method_table.method_0(r.self, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(buf, n, undefined));
      n = n + v._0 | 0;
      err = v._1;
      continue;
    } else {
      break;
    }
  }
  if (n >= min) {
    err = undefined;
  } else {
    if (n > 0 && _M0IPC16option6OptionPB2Eq5equalGRP27gmlewis2io7IOErrorE(err, _M0FP27gmlewis2io3eof)) {
      err = _M0FP27gmlewis2io20err__unexpected__eof;
    }
  }
  return { _0: n, _1: err };
}
function _M0FP27gmlewis2io10read__full(r, buf) {
  return _M0FP27gmlewis2io15read__at__least(r, buf, buf.len);
}
function _M0FP27gmlewis2io9read__all(r) {
  let cap = 512;
  let arr = _M0MPC15array5Array4makeGyE(cap, 0);
  let b = _M0MP27gmlewis2io5Slice11new_2einnerGyE(arr, 0, _M0FP27gmlewis2io9read__allN6constrS902);
  while (true) {
    const _tmp$38 = b;
    const _p$4 = b;
    const _tmp$39 = _p$4.len;
    const _p$5 = b;
    const _bind$4 = r.method_table.method_0(r.self, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(_tmp$38, _tmp$39, _p$5.buf.length - _p$5.start | 0));
    const _n = _bind$4._0;
    const _err = _bind$4._1;
    let err = _err;
    const _tmp$40 = b;
    const _p$6 = b;
    b = _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(_tmp$40, 0, _p$6.len + _n | 0);
    if (_M0IP016_24default__implPB2Eq10not__equalGORP27gmlewis2io7IOErrorE(err, undefined)) {
      if (_M0IPC16option6OptionPB2Eq5equalGRP27gmlewis2io7IOErrorE(err, _M0FP27gmlewis2io3eof)) {
        err = undefined;
      }
      return { _0: b, _1: err };
    }
    const _p$7 = b;
    if (_p$7.len === cap) {
      if (cap < 1048576) {
        cap = Math.imul(cap, 2) | 0;
      } else {
        cap = cap + 1048576 | 0;
      }
      const new_arr = _M0MPC15array5Array4makeGyE(cap, 0);
      const _p$8 = b;
      const _bind$5 = _p$8.len;
      let _tmp$41 = 0;
      while (true) {
        const i = _tmp$41;
        if (i < _bind$5) {
          _M0MPC15array5Array3setGyE(new_arr, i, _M0MPC15array5Array2atGyE(arr, i));
          _tmp$41 = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      arr = new_arr;
      const _tmp$42 = _M0MP27gmlewis2io5Slice11new_2einnerGyE(arr, 0, undefined);
      const _p$9 = b;
      b = _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(_tmp$42, 0, _p$9.len);
    }
    continue;
  }
}
function _M0MP27gmlewis2io6Buffer11new_2einner(size_hint) {
  const b = _M0MP27gmlewis2io5Slice11new_2einnerGyE(_M0MPC15array5Array4makeGyE(size_hint, 0), 0, _M0MP27gmlewis2io6Buffer11new_2einnerN6constrS903);
  return new _M0TP27gmlewis2io6Buffer(b, 0);
}
function _M0IP27gmlewis2io6BufferP27gmlewis2io6Writer5write(self, buf) {
  const _p$4 = self.b;
  const blen = _p$4.len;
  const buflen = buf.len;
  const _p$5 = blen + buflen | 0;
  let _tmp$38;
  if (_p$5 <= 0) {
    _tmp$38 = [];
  } else {
    const _p$6 = new Array(_p$5);
    let _tmp$39 = 0;
    while (true) {
      const _p$7 = _tmp$39;
      if (_p$7 < _p$5) {
        _p$6[_p$7] = _p$7 < blen ? _M0MP27gmlewis2io5Slice7op__getGyE(self.b, _p$7) : _M0MPC15array5Array2atGyE(buf.buf, (buf.start + _p$7 | 0) - blen | 0);
        _tmp$39 = _p$7 + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    _tmp$38 = _p$6;
  }
  self.b = _M0MP27gmlewis2io5Slice11new_2einnerGyE(_tmp$38, 0, undefined);
  return { _0: buflen, _1: undefined };
}
function _M0MP27gmlewis2io6Buffer12write__bytes(self, buf) {
  return _M0IP27gmlewis2io6BufferP27gmlewis2io6Writer5write(self, _M0MP27gmlewis2io5Slice11new_2einnerGyE(_M0MPC15bytes5Bytes9to__array(buf), 0, undefined));
}
function _M0IP27gmlewis2io6BufferP27gmlewis2io6Reader4read(self, buf) {
  const _p$4 = self.b;
  const remaining = _p$4.len - self.off | 0;
  if (remaining <= 0 || buf.len === 0) {
    return { _0: 0, _1: _M0FP27gmlewis2io3eof };
  }
  const _p$5 = buf.len;
  const n = remaining < _p$5 ? remaining : _p$5;
  _M0MPC15array5Array12unsafe__blitGyE(buf.buf, buf.start, self.b.buf, self.off, n);
  self.off = self.off + n | 0;
  return { _0: n, _1: undefined };
}
function _M0IP27gmlewis2io6BufferP27gmlewis2io10ByteReader10read__byte(self) {
  const _p$4 = self.b;
  const remaining = _p$4.len - self.off | 0;
  if (remaining <= 0) {
    return { _0: 0, _1: _M0FP27gmlewis2io3eof };
  }
  const b = _M0MP27gmlewis2io5Slice7op__getGyE(self.b, self.off);
  self.off = self.off + 1 | 0;
  return { _0: b, _1: undefined };
}
function _M0MP27gmlewis2io6Buffer9to__slice(self) {
  return _M0MP27gmlewis2io5Slice11new_2einnerGyE(self.b.buf, 0, undefined);
}
function _M0MP27gmlewis5flate11DeflateFast3new() {
  return new _M0TP27gmlewis5flate11DeflateFast($make_array_len_and_init(16384, new _M0TP27gmlewis5flate10TableEntry(0, 0)), _M0MP27gmlewis2io5Slice11new_2einnerGyE([], 0, undefined), 65535);
}
function _M0MP27gmlewis5flate14HuffmanEncoder3new(size) {
  const codes = _M0MPC15array5Array4makeGRP27gmlewis5flate5HCodeE(size, new _M0TP27gmlewis5flate5HCode(0, 0));
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < size) {
      _M0MPC15array5Array3setGsE(codes, i, new _M0TP27gmlewis5flate5HCode(0, 0));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const freqcache = [];
  const bit_count = _M0MPC15array5Array4makeGiE(17, 0);
  return new _M0TP27gmlewis5flate14HuffmanEncoder(codes, freqcache, bit_count);
}
function _M0MP27gmlewis5flate16HuffmanBitWriter3new(writer) {
  const literal_freq = _M0MPC15array5Array4makeGiE(286, 0);
  const offset_freq = _M0MPC15array5Array4makeGiE(30, 0);
  const codegen = $makebytes(317, 0);
  const literal_encoding = _M0MP27gmlewis5flate14HuffmanEncoder3new(286);
  const codegen_encoding = _M0MP27gmlewis5flate14HuffmanEncoder3new(19);
  const offset_encoding = _M0MP27gmlewis5flate14HuffmanEncoder3new(30);
  const bytes = _M0MPC15array5Array4makeGyE(248, 0);
  const codegen_freq = _M0MPC15array5Array4makeGiE(19, 0);
  return new _M0TP27gmlewis5flate16HuffmanBitWriter(writer, 0n, 0, bytes, codegen_freq, 0, literal_freq, offset_freq, codegen, literal_encoding, offset_encoding, codegen_encoding, undefined);
}
function _M0MP27gmlewis5flate10Compressor3new(buf) {
  const w = _M0MP27gmlewis5flate16HuffmanBitWriter3new(buf);
  const _bind$4 = _M0MP27gmlewis2io5Slice11new_2einnerGjE(_M0MPC15array5Array4makeGjE(131072, 0), 0, undefined);
  const _bind$5 = _M0MP27gmlewis2io5Slice11new_2einnerGjE(_M0MPC15array5Array4makeGjE(32768, 0), 0, undefined);
  const _bind$6 = _M0MP27gmlewis2io5Slice11new_2einnerGyE(_M0MPC15array5Array4makeGyE(65535, 0), 0, undefined);
  const _bind$7 = _M0MP27gmlewis5flate11DeflateFast3new();
  const _bind$8 = _M0MPC15array5Array4makeGRP27gmlewis5flate5TokenE(65535, 0);
  const _bind$9 = undefined;
  const _bind$10 = _M0MP27gmlewis2io5Slice11new_2einnerGjE(_M0MPC15array5Array4makeGjE(257, 0), 0, undefined);
  return new _M0TP27gmlewis5flate10Compressor(w, _bind$7, _bind$4, _bind$5, 0, _bind$6, 0, false, _bind$8, _bind$9, _bind$10);
}
function _M0MP27gmlewis5flate6Writer3new(buf) {
  const d = _M0MP27gmlewis5flate10Compressor3new(buf);
  return new _M0TP27gmlewis5flate6Writer(d);
}
function _M0FP27gmlewis5flate11slice__copy(dst, src) {
  const _p$4 = dst.len;
  const _p$5 = src.len;
  const n = _p$4 > _p$5 ? _p$5 : _p$4;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < n) {
      _M0MP27gmlewis2io5Slice7op__setGyE(dst, i, _M0MP27gmlewis2io5Slice7op__getGyE(src, i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return n;
}
function _M0FP27gmlewis5flate15internal__error(s) {
  return new _M0DTPC15error5Error32gmlewis_2fio_2eIOError_2eIOError(`flate: internal error: ${s}`);
}
function _M0MP27gmlewis5flate16HuffmanBitWriter5write(self, b) {
  const _bind$4 = self.err;
  if (!(_bind$4 === undefined)) {
    return undefined;
  }
  const _tmp$38 = self.writer;
  const _bind$5 = _tmp$38.method_table.method_0(_tmp$38.self, b);
  const _err = _bind$5._1;
  self.err = _err;
}
function _M0MP27gmlewis5flate16HuffmanBitWriter12write__bytes(self, bytes) {
  const _bind$4 = self.err;
  if (!(_bind$4 === undefined)) {
    return undefined;
  }
  let n = self.nbytes;
  if ((self.nbits & 7) !== 0) {
    self.err = _M0FP27gmlewis5flate15internal__error("write_bytes with unfinished bits");
    return undefined;
  }
  while (true) {
    if (self.nbits !== 0) {
      const _tmp$38 = self.bytes;
      const _tmp$39 = n;
      const _p$4 = self.bits;
      _M0MPC15array5Array3setGyE(_tmp$38, _tmp$39, (Number(BigInt.asIntN(32, _p$4)) | 0) & 255);
      self.bits = BigInt.asUintN(64, BigInt.asUintN(64, self.bits) >> BigInt(8 & 63));
      self.nbits = (self.nbits >>> 0) - (8 >>> 0) | 0;
      n = n + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (n !== 0) {
    _M0MP27gmlewis5flate16HuffmanBitWriter5write(self, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(_M0MP27gmlewis2io5Slice11new_2einnerGyE(self.bytes, 0, undefined), 0, n));
  }
  self.nbytes = 0;
  _M0MP27gmlewis5flate16HuffmanBitWriter5write(self, bytes);
}
function _M0MP27gmlewis5flate16HuffmanBitWriter5flush(self) {
  const _bind$4 = self.err;
  if (!(_bind$4 === undefined)) {
    self.nbits = 0;
    return undefined;
  }
  let n = self.nbytes;
  while (true) {
    if (self.nbits !== 0) {
      const _tmp$38 = self.bytes;
      const _tmp$39 = n;
      const _p$4 = self.bits;
      _M0MPC15array5Array3setGyE(_tmp$38, _tmp$39, (Number(BigInt.asIntN(32, _p$4)) | 0) & 255);
      self.bits = BigInt.asUintN(64, BigInt.asUintN(64, self.bits) >> BigInt(8 & 63));
      if (self.nbits >>> 0 > 8 >>> 0) {
        self.nbits = (self.nbits >>> 0) - (8 >>> 0) | 0;
      } else {
        self.nbits = 0;
      }
      n = n + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.bits = 0n;
  _M0MP27gmlewis5flate16HuffmanBitWriter5write(self, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(_M0MP27gmlewis2io5Slice11new_2einnerGyE(self.bytes, 0, undefined), 0, n));
  self.nbytes = 0;
}
function _M0MP27gmlewis5flate16HuffmanBitWriter11write__bits(self, b, nb) {
  const _bind$4 = self.err;
  if (!(_bind$4 === undefined)) {
    return undefined;
  }
  const _tmp$38 = self.bits;
  const _p$4 = b;
  self.bits = BigInt.asUintN(64, _tmp$38 | BigInt.asUintN(64, BigInt.asUintN(64, BigInt(_p$4 >>> 0)) << BigInt(self.nbits & 63)));
  self.nbits = (self.nbits >>> 0) + (nb >>> 0) | 0;
  if (self.nbits >>> 0 >= 48 >>> 0) {
    const bits = self.bits;
    self.bits = BigInt.asUintN(64, BigInt.asUintN(64, self.bits) >> BigInt(48 & 63));
    self.nbits = (self.nbits >>> 0) - (48 >>> 0) | 0;
    let n = self.nbytes;
    _M0MPC15array5Array3setGyE(self.bytes, n, (Number(BigInt.asIntN(32, bits)) | 0) & 255);
    const _tmp$39 = self.bytes;
    const _tmp$40 = n + 1 | 0;
    const _p$5 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(8 & 63));
    _M0MPC15array5Array3setGyE(_tmp$39, _tmp$40, (Number(BigInt.asIntN(32, _p$5)) | 0) & 255);
    const _tmp$41 = self.bytes;
    const _tmp$42 = n + 2 | 0;
    const _p$6 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(16 & 63));
    _M0MPC15array5Array3setGyE(_tmp$41, _tmp$42, (Number(BigInt.asIntN(32, _p$6)) | 0) & 255);
    const _tmp$43 = self.bytes;
    const _tmp$44 = n + 3 | 0;
    const _p$7 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(24 & 63));
    _M0MPC15array5Array3setGyE(_tmp$43, _tmp$44, (Number(BigInt.asIntN(32, _p$7)) | 0) & 255);
    const _tmp$45 = self.bytes;
    const _tmp$46 = n + 4 | 0;
    const _p$8 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(32 & 63));
    _M0MPC15array5Array3setGyE(_tmp$45, _tmp$46, (Number(BigInt.asIntN(32, _p$8)) | 0) & 255);
    const _tmp$47 = self.bytes;
    const _tmp$48 = n + 5 | 0;
    const _p$9 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(40 & 63));
    _M0MPC15array5Array3setGyE(_tmp$47, _tmp$48, (Number(BigInt.asIntN(32, _p$9)) | 0) & 255);
    n = n + 6 | 0;
    if (n >= 240) {
      _M0MP27gmlewis5flate16HuffmanBitWriter5write(self, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(_M0MP27gmlewis2io5Slice11new_2einnerGyE(self.bytes, 0, undefined), 0, n));
      n = 0;
    }
    self.nbytes = n;
    return;
  } else {
    return;
  }
}
function _M0MP27gmlewis5flate16HuffmanBitWriter21write__stored__header(self, length, is_eof) {
  const _bind$4 = self.err;
  if (!(_bind$4 === undefined)) {
    return undefined;
  }
  const flag = is_eof ? 1 : 0;
  _M0MP27gmlewis5flate16HuffmanBitWriter11write__bits(self, flag, 3);
  _M0MP27gmlewis5flate16HuffmanBitWriter5flush(self);
  _M0MP27gmlewis5flate16HuffmanBitWriter11write__bits(self, length, 16);
  _M0MP27gmlewis5flate16HuffmanBitWriter11write__bits(self, ~length & 65535, 16);
}
function _M0MP27gmlewis5flate10Compressor20write__stored__block(self, buf) {
  _M0MP27gmlewis5flate16HuffmanBitWriter21write__stored__header(self.w, buf.len, false);
  const _bind$4 = self.w.err;
  if (!(_bind$4 === undefined)) {
    return self.w.err;
  }
  _M0MP27gmlewis5flate16HuffmanBitWriter12write__bytes(self.w, buf);
  return self.w.err;
}
function _M0FP27gmlewis5flate13emit__literal(dst, lit) {
  const _bind$4 = lit.len;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < _bind$4) {
      const v = _M0MP27gmlewis2io5Slice7op__getGyE(lit, i);
      _M0MPC15array5Array4pushGRP27gmlewis5flate5TokenE(dst, v);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return dst;
}
function _M0FP27gmlewis5flate6load32(b, i) {
  const _p$4 = _M0MP27gmlewis2io5Slice7op__getGyE(b, i);
  const _p$5 = _M0MP27gmlewis2io5Slice7op__getGyE(b, i + 1 | 0);
  const _tmp$38 = _p$4 | _p$5 << 8;
  const _p$6 = _M0MP27gmlewis2io5Slice7op__getGyE(b, i + 2 | 0);
  const _tmp$39 = _tmp$38 | _p$6 << 16;
  const _p$7 = _M0MP27gmlewis2io5Slice7op__getGyE(b, i + 3 | 0);
  return _tmp$39 | _p$7 << 24;
}
function _M0FP27gmlewis5flate6load64(b, i) {
  const _p$4 = _M0MP27gmlewis2io5Slice7op__getGyE(b, i);
  const _p$5 = _p$4;
  const _tmp$38 = BigInt.asUintN(64, BigInt(_p$5 >>> 0));
  const _p$6 = _M0MP27gmlewis2io5Slice7op__getGyE(b, i + 1 | 0);
  const _p$7 = _p$6;
  const _tmp$39 = BigInt.asUintN(64, _tmp$38 | BigInt.asUintN(64, BigInt.asUintN(64, BigInt(_p$7 >>> 0)) << BigInt(8 & 63)));
  const _p$8 = _M0MP27gmlewis2io5Slice7op__getGyE(b, i + 2 | 0);
  const _p$9 = _p$8;
  const _tmp$40 = BigInt.asUintN(64, _tmp$39 | BigInt.asUintN(64, BigInt.asUintN(64, BigInt(_p$9 >>> 0)) << BigInt(16 & 63)));
  const _p$10 = _M0MP27gmlewis2io5Slice7op__getGyE(b, i + 3 | 0);
  const _p$11 = _p$10;
  const _tmp$41 = BigInt.asUintN(64, _tmp$40 | BigInt.asUintN(64, BigInt.asUintN(64, BigInt(_p$11 >>> 0)) << BigInt(24 & 63)));
  const _p$12 = _M0MP27gmlewis2io5Slice7op__getGyE(b, i + 4 | 0);
  const _p$13 = _p$12;
  const _tmp$42 = BigInt.asUintN(64, _tmp$41 | BigInt.asUintN(64, BigInt.asUintN(64, BigInt(_p$13 >>> 0)) << BigInt(32 & 63)));
  const _p$14 = _M0MP27gmlewis2io5Slice7op__getGyE(b, i + 5 | 0);
  const _p$15 = _p$14;
  const _tmp$43 = BigInt.asUintN(64, _tmp$42 | BigInt.asUintN(64, BigInt.asUintN(64, BigInt(_p$15 >>> 0)) << BigInt(40 & 63)));
  const _p$16 = _M0MP27gmlewis2io5Slice7op__getGyE(b, i + 6 | 0);
  const _p$17 = _p$16;
  const _tmp$44 = BigInt.asUintN(64, _tmp$43 | BigInt.asUintN(64, BigInt.asUintN(64, BigInt(_p$17 >>> 0)) << BigInt(48 & 63)));
  const _p$18 = _M0MP27gmlewis2io5Slice7op__getGyE(b, i + 7 | 0);
  const _p$19 = _p$18;
  return BigInt.asUintN(64, _tmp$44 | BigInt.asUintN(64, BigInt.asUintN(64, BigInt(_p$19 >>> 0)) << BigInt(56 & 63)));
}
function _M0MP27gmlewis5flate11DeflateFast10match__len(self, s, t, src) {
  let s1 = (s + 258 | 0) - 4 | 0;
  if (s1 > src.len) {
    s1 = src.len;
  }
  if (t >= 0) {
    const a_length = s1 - s | 0;
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < a_length) {
        if (_M0MP27gmlewis2io5Slice7op__getGyE(src, s + i | 0) !== _M0MP27gmlewis2io5Slice7op__getGyE(src, t + i | 0)) {
          return i;
        }
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return a_length;
  }
  const _p$4 = self.prev;
  const tp = _p$4.len + t | 0;
  if (tp < 0) {
    return 0;
  }
  const a_length = s1 - s | 0;
  const _p$5 = self.prev;
  let b_length = _p$5.len - tp | 0;
  if (b_length > a_length) {
    b_length = a_length;
  }
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < b_length) {
      if (_M0MP27gmlewis2io5Slice7op__getGyE(src, s + i | 0) !== _M0MP27gmlewis2io5Slice7op__getGyE(self.prev, tp + i | 0)) {
        return i;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const n = b_length;
  if ((s + n | 0) === s1) {
    return n;
  }
  const a_length$2 = s1 - (s + n | 0) | 0;
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < a_length$2) {
      if (_M0MP27gmlewis2io5Slice7op__getGyE(src, (s + n | 0) + i | 0) !== _M0MP27gmlewis2io5Slice7op__getGyE(src, i)) {
        return i + n | 0;
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return a_length$2 + n | 0;
}
function _M0MP27gmlewis5flate11DeflateFast14shift__offsets(self) {
  const _p$4 = self.prev;
  if (_p$4.len === 0) {
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < 16384) {
        const _tmp$39 = self.table;
        $bound_check(_tmp$39, i);
        _tmp$39[i] = new _M0TP27gmlewis5flate10TableEntry(0, 0);
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    self.cur = 32769;
    return undefined;
  }
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < 16384) {
      const _tmp$39 = self.table;
      $bound_check(_tmp$39, i);
      let v = ((_tmp$39[i].offset - self.cur | 0) + 32768 | 0) + 1 | 0;
      if (v < 0) {
        v = 0;
      }
      const _tmp$40 = self.table;
      $bound_check(_tmp$40, i);
      _tmp$40[i].offset = v;
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.cur = 32769;
}
function _M0MP27gmlewis5flate11DeflateFast6encodeN15emit__remainderS58(_env) {
  const dst = _env._3;
  const src = _env._2;
  const self = _env._1;
  const next_emit = _env._0;
  if (next_emit.val < src.len) {
    dst.val = _M0FP27gmlewis5flate13emit__literal(dst.val, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(src, next_emit.val, undefined));
  }
  self.cur = self.cur + src.len | 0;
  _M0FP27gmlewis5flate11slice__copy(self.prev, src);
  return dst.val;
}
function _M0MP27gmlewis5flate11DeflateFast6encode(self, dst, src) {
  const dst$2 = new _M0TPB8MutLocalGRPB5ArrayGRP27gmlewis5flate5TokenEE(dst);
  if (self.cur >= 2147352577) {
    _M0MP27gmlewis5flate11DeflateFast14shift__offsets(self);
  }
  if (src.len < 17) {
    self.cur = self.cur + 65535 | 0;
    self.prev = _M0MP27gmlewis2io5Slice11new_2einnerGyE([], 0, undefined);
    return _M0FP27gmlewis5flate13emit__literal(dst$2.val, src);
  }
  const s_limit = src.len - 15 | 0;
  const next_emit = new _M0TPB8MutLocalGiE(0);
  let s = 0;
  let cv = _M0FP27gmlewis5flate6load32(src, s);
  const _p$4 = cv;
  const _p$5 = (Math.imul(_p$4, 506832829) | 0) >>> 18 | 0;
  let next_hash = _p$5;
  const _env = { _0: next_emit, _1: self, _2: src, _3: dst$2 };
  while (true) {
    let skip = 32;
    let next_s = s;
    let candidate = new _M0TP27gmlewis5flate10TableEntry(0, 0);
    while (true) {
      s = next_s;
      const bytes_between_hash_lookups = skip >> 5;
      next_s = s + bytes_between_hash_lookups | 0;
      skip = skip + bytes_between_hash_lookups | 0;
      if (next_s > s_limit) {
        return _M0MP27gmlewis5flate11DeflateFast6encodeN15emit__remainderS58(_env);
      }
      const _tmp$38 = self.table;
      const _tmp$39 = next_hash & 16383;
      $bound_check(_tmp$38, _tmp$39);
      candidate = _tmp$38[_tmp$39];
      const now = _M0FP27gmlewis5flate6load32(src, next_s);
      const _tmp$40 = self.table;
      const _tmp$41 = next_hash & 16383;
      const _bind$4 = s + self.cur | 0;
      const _bind$5 = cv;
      $bound_check(_tmp$40, _tmp$41);
      _tmp$40[_tmp$41] = new _M0TP27gmlewis5flate10TableEntry(_bind$5, _bind$4);
      const _p$6 = (Math.imul(now, 506832829) | 0) >>> 18 | 0;
      next_hash = _p$6;
      const offset = s - (candidate.offset - self.cur | 0) | 0;
      if (offset > 32768 || cv !== candidate.val) {
        cv = now;
        continue;
      }
      break;
    }
    dst$2.val = _M0FP27gmlewis5flate13emit__literal(dst$2.val, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(src, next_emit.val, s));
    while (true) {
      s = s + 4 | 0;
      const t = (candidate.offset - self.cur | 0) + 4 | 0;
      const l = _M0MP27gmlewis5flate11DeflateFast10match__len(self, s, t, src);
      const _tmp$38 = dst$2.val;
      const _p$6 = (l + 4 | 0) - 3 | 0;
      const _p$7 = (s - t | 0) - 1 | 0;
      _M0MPC15array5Array4pushGRP27gmlewis5flate5TokenE(_tmp$38, (((1073741824 >>> 0) + (_p$6 << 22 >>> 0) | 0) >>> 0) + (_p$7 >>> 0) | 0);
      s = s + l | 0;
      next_emit.val = s;
      if (s >= s_limit) {
        return _M0MP27gmlewis5flate11DeflateFast6encodeN15emit__remainderS58(_env);
      }
      let x = _M0FP27gmlewis5flate6load64(src, s - 1 | 0);
      const _p$8 = Number(BigInt.asUintN(32, x)) | 0;
      const _p$9 = (Math.imul(_p$8, 506832829) | 0) >>> 18 | 0;
      const prev_hash = _p$9;
      const _tmp$39 = self.table;
      const _tmp$40 = prev_hash & 16383;
      const _bind$4 = (self.cur + s | 0) - 1 | 0;
      const _bind$5 = Number(BigInt.asUintN(32, x)) | 0;
      $bound_check(_tmp$39, _tmp$40);
      _tmp$39[_tmp$40] = new _M0TP27gmlewis5flate10TableEntry(_bind$5, _bind$4);
      x = BigInt.asUintN(64, BigInt.asUintN(64, x) >> BigInt(8 & 63));
      const _p$10 = Number(BigInt.asUintN(32, x)) | 0;
      const _p$11 = (Math.imul(_p$10, 506832829) | 0) >>> 18 | 0;
      const curr_hash = _p$11;
      const _tmp$41 = self.table;
      const _tmp$42 = curr_hash & 16383;
      $bound_check(_tmp$41, _tmp$42);
      candidate = _tmp$41[_tmp$42];
      const _tmp$43 = self.table;
      const _tmp$44 = curr_hash & 16383;
      const _bind$6 = self.cur + s | 0;
      const _bind$7 = Number(BigInt.asUintN(32, x)) | 0;
      $bound_check(_tmp$43, _tmp$44);
      _tmp$43[_tmp$44] = new _M0TP27gmlewis5flate10TableEntry(_bind$7, _bind$6);
      const offset = s - (candidate.offset - self.cur | 0) | 0;
      if (offset > 32768 || (Number(BigInt.asUintN(32, x)) | 0) !== candidate.val) {
        cv = Number(BigInt.asUintN(32, BigInt.asUintN(64, BigInt.asUintN(64, x) >> BigInt(8 & 63)))) | 0;
        const _p$12 = cv;
        const _p$13 = (Math.imul(_p$12, 506832829) | 0) >>> 18 | 0;
        next_hash = _p$13;
        s = s + 1 | 0;
        break;
      }
      continue;
    }
    continue;
  }
}
function _M0MP27gmlewis5flate11DeflateFast5reset(self) {
  self.prev = _M0MP27gmlewis2io5Slice11new_2einnerGyE([], 0, undefined);
  self.cur = self.cur + 32768 | 0;
  if (self.cur >= 2147352577) {
    _M0MP27gmlewis5flate11DeflateFast14shift__offsets(self);
    return;
  } else {
    return;
  }
}
function _M0FP27gmlewis5flate12stored__size(inp_length) {
  if (inp_length === 0) {
    return _M0FP27gmlewis5flate12stored__sizeN5tupleS1076;
  }
  if (inp_length <= 65535) {
    const v = Math.imul(inp_length + 5 | 0, 8) | 0;
    return { _0: v, _1: true };
  }
  return _M0FP27gmlewis5flate12stored__sizeN5tupleS1077;
}
function _M0MP27gmlewis5flate14HuffmanEncoder11bit__length(self, freq) {
  let total = 0;
  const _it = _M0MP27gmlewis2io5Slice5iter2GiE(freq);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGiiE(_it);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _i = _x._0;
      const _f = _x._1;
      if (_f !== 0) {
        total = total + (Math.imul(_f, _M0MPC15array5Array2atGUssEE(self.codes, _i).len) | 0) | 0;
      }
      continue;
    }
  }
  return total;
}
function _M0MP27gmlewis5flate16HuffmanBitWriter13dynamic__size(self, lit_enc, off_enc, extra_bits) {
  let num_codegens = self.codegen_freq.length;
  while (true) {
    if (num_codegens > 4 && _M0MPC15array5Array2atGiE(self.codegen_freq, _M0MPC15array5Array2atGiE(_M0FP27gmlewis5flate14codegen__order, num_codegens - 1 | 0)) === 0) {
      num_codegens = num_codegens - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const header = ((((17 + (Math.imul(3, num_codegens) | 0) | 0) + _M0MP27gmlewis5flate14HuffmanEncoder11bit__length(self.codegen_encoding, _M0MP27gmlewis2io5Slice11new_2einnerGiE(self.codegen_freq, 0, undefined)) | 0) + (Math.imul(_M0MPC15array5Array2atGiE(self.codegen_freq, 16), 2) | 0) | 0) + (Math.imul(_M0MPC15array5Array2atGiE(self.codegen_freq, 17), 3) | 0) | 0) + (Math.imul(_M0MPC15array5Array2atGiE(self.codegen_freq, 18), 7) | 0) | 0;
  const size = ((header + _M0MP27gmlewis5flate14HuffmanEncoder11bit__length(lit_enc, _M0MP27gmlewis2io5Slice11new_2einnerGiE(self.literal_freq, 0, undefined)) | 0) + _M0MP27gmlewis5flate14HuffmanEncoder11bit__length(off_enc, _M0MP27gmlewis2io5Slice11new_2einnerGiE(self.offset_freq, 0, undefined)) | 0) + extra_bits | 0;
  return { _0: size, _1: num_codegens };
}
function _M0MP27gmlewis5flate16HuffmanBitWriter17generate__codegen(self, num_literals, num_offsets, lit_enc, off_enc) {
  const _bind$4 = self.codegen_freq.length;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < _bind$4) {
      _M0MPC15array5Array3setGiE(self.codegen_freq, i, 0);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const codegen = self.codegen;
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < num_literals) {
      const _p$4 = _M0MPC15array5Array2atGUssEE(lit_enc.codes, i).len;
      $bound_check(codegen, i);
      codegen[i] = _p$4 & 255;
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let _tmp$40 = 0;
  while (true) {
    const i = _tmp$40;
    if (i < num_offsets) {
      const _tmp$41 = num_literals + i | 0;
      const _p$4 = _M0MPC15array5Array2atGUssEE(off_enc.codes, i).len;
      $bound_check(codegen, _tmp$41);
      codegen[_tmp$41] = _p$4 & 255;
      _tmp$40 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _tmp$41 = num_literals + num_offsets | 0;
  $bound_check(codegen, _tmp$41);
  codegen[_tmp$41] = 255;
  $bound_check(codegen, 0);
  let size = codegen[0];
  let count = 1;
  let out_index = 0;
  let _tmp$42 = 1;
  while (true) {
    const in_index = _tmp$42;
    if (size !== 255) {
      _L: {
        $bound_check(codegen, in_index);
        const next_size = codegen[in_index];
        const _p$4 = size;
        if (next_size === _p$4) {
          count = count + 1 | 0;
          break _L;
        }
        if (size !== 0) {
          const _tmp$43 = out_index;
          $bound_check(codegen, _tmp$43);
          codegen[_tmp$43] = size;
          out_index = out_index + 1 | 0;
          const _array_5 = self.codegen_freq;
          const _index_6 = size;
          _M0MPC15array5Array3setGiE(_array_5, _index_6, _M0MPC15array5Array2atGiE(_array_5, _index_6) + 1 | 0);
          count = count - 1 | 0;
          while (true) {
            if (count >= 3) {
              let n = 6;
              if (n > count) {
                n = count;
              }
              const _tmp$44 = out_index;
              $bound_check(codegen, _tmp$44);
              codegen[_tmp$44] = 16;
              out_index = out_index + 1 | 0;
              const _tmp$45 = out_index;
              $bound_check(codegen, _tmp$45);
              codegen[_tmp$45] = (n - 3 | 0) & 255;
              out_index = out_index + 1 | 0;
              const _array_7 = self.codegen_freq;
              _M0MPC15array5Array3setGiE(_array_7, 16, _M0MPC15array5Array2atGiE(_array_7, 16) + 1 | 0);
              count = count - n | 0;
              continue;
            } else {
              break;
            }
          }
        } else {
          while (true) {
            if (count >= 11) {
              let n = 138;
              if (n > count) {
                n = count;
              }
              const _tmp$43 = out_index;
              $bound_check(codegen, _tmp$43);
              codegen[_tmp$43] = 18;
              out_index = out_index + 1 | 0;
              const _tmp$44 = out_index;
              $bound_check(codegen, _tmp$44);
              codegen[_tmp$44] = (n - 11 | 0) & 255;
              out_index = out_index + 1 | 0;
              const _array_9 = self.codegen_freq;
              _M0MPC15array5Array3setGiE(_array_9, 18, _M0MPC15array5Array2atGiE(_array_9, 18) + 1 | 0);
              count = count - n | 0;
              continue;
            } else {
              break;
            }
          }
          if (count >= 3) {
            const _tmp$43 = out_index;
            $bound_check(codegen, _tmp$43);
            codegen[_tmp$43] = 17;
            out_index = out_index + 1 | 0;
            const _tmp$44 = out_index;
            $bound_check(codegen, _tmp$44);
            codegen[_tmp$44] = (count - 3 | 0) & 255;
            out_index = out_index + 1 | 0;
            const _array_11 = self.codegen_freq;
            _M0MPC15array5Array3setGiE(_array_11, 17, _M0MPC15array5Array2atGiE(_array_11, 17) + 1 | 0);
            count = 0;
          }
        }
        count = count - 1 | 0;
        let _tmp$43 = count;
        while (true) {
          const count$2 = _tmp$43;
          if (count$2 >= 0) {
            const _tmp$44 = out_index;
            $bound_check(codegen, _tmp$44);
            codegen[_tmp$44] = size;
            out_index = out_index + 1 | 0;
            const _array_13 = self.codegen_freq;
            const _index_14 = size;
            _M0MPC15array5Array3setGiE(_array_13, _index_14, _M0MPC15array5Array2atGiE(_array_13, _index_14) + 1 | 0);
            _tmp$43 = count$2 - 1 | 0;
            continue;
          } else {
            break;
          }
        }
        size = next_size;
        count = 1;
        break _L;
      }
      _tmp$42 = in_index + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _tmp$43 = out_index;
  $bound_check(codegen, _tmp$43);
  codegen[_tmp$43] = 255;
}
function _M0FP27gmlewis5flate12length__code(len) {
  return _M0MPC15array5Array2atGiE(_M0FP27gmlewis5flate13length__codes, len);
}
function _M0FP27gmlewis5flate12offset__code(off) {
  if (off >>> 0 < _M0FP27gmlewis5flate13offset__codes.length >>> 0) {
    const idx = off;
    return _M0MPC15array5Array2atGiE(_M0FP27gmlewis5flate13offset__codes, idx);
  }
  if ((off >>> 7 | 0) >>> 0 < _M0FP27gmlewis5flate13offset__codes.length >>> 0) {
    const idx = off >>> 7 | 0;
    return _M0MPC15array5Array2atGiE(_M0FP27gmlewis5flate13offset__codes, idx) + 14 | 0;
  }
  const idx = off >>> 14 | 0;
  return _M0MPC15array5Array2atGiE(_M0FP27gmlewis5flate13offset__codes, idx) + 28 | 0;
}
function _M0FP27gmlewis5flate13by__frequency(a, b) {
  if (a.freq === b.freq) {
    return a.literal < b.literal;
  }
  return a.freq < b.freq;
}
function _M0FP27gmlewis5flate9partitionGRP27gmlewis5flate11LiteralNodeE(a, first, last, pivot_index, less) {
  _M0MP27gmlewis2io5Slice4swapGRP27gmlewis5flate11LiteralNodeE(a, first, pivot_index);
  let left = first + 1 | 0;
  let right = last;
  while (true) {
    if (left <= right) {
      while (true) {
        if (left <= last && less(_M0MP27gmlewis2io5Slice7op__getGRP27gmlewis5flate11LiteralNodeE(a, left), _M0MP27gmlewis2io5Slice7op__getGRP27gmlewis5flate11LiteralNodeE(a, first))) {
          left = left + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      while (true) {
        if (right >= first && less(_M0MP27gmlewis2io5Slice7op__getGRP27gmlewis5flate11LiteralNodeE(a, first), _M0MP27gmlewis2io5Slice7op__getGRP27gmlewis5flate11LiteralNodeE(a, right))) {
          right = right - 1 | 0;
          continue;
        } else {
          break;
        }
      }
      if (left <= right) {
        _M0MP27gmlewis2io5Slice4swapGRP27gmlewis5flate11LiteralNodeE(a, left, right);
        left = left + 1 | 0;
        right = right - 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  _M0MP27gmlewis2io5Slice4swapGRP27gmlewis5flate11LiteralNodeE(a, first, right);
  return right;
}
function _M0FP27gmlewis5flate17quicksort__helperGRP27gmlewis5flate11LiteralNodeE(a, first, last, less) {
  let _tmp$38 = first;
  while (true) {
    const first$2 = _tmp$38;
    if (first$2 >= last) {
      return undefined;
    }
    const pivot_index = _M0FP27gmlewis5flate9partitionGRP27gmlewis5flate11LiteralNodeE(a, first$2, last, (last + first$2 | 0) / 2 | 0, less);
    _M0FP27gmlewis5flate17quicksort__helperGRP27gmlewis5flate11LiteralNodeE(a, first$2, pivot_index - 1 | 0, less);
    _tmp$38 = pivot_index + 1 | 0;
    continue;
  }
}
function _M0FP27gmlewis5flate9quicksortGRP27gmlewis5flate11LiteralNodeE(a, less) {
  _M0FP27gmlewis5flate17quicksort__helperGRP27gmlewis5flate11LiteralNodeE(a, 0, a.len - 1 | 0, less);
}
function _M0MP27gmlewis5flate5HCode3set(self, code, length) {
  self.len = length;
  self.code = code;
}
function _M0FP27gmlewis5flate11by__literal(a, b) {
  return a.literal < b.literal;
}
function _M0FP27gmlewis5flate9reverse16(x) {
  return _M0MPC15array5Array2atGjE(_M0FP27gmlewis5flate7rev8tab, (x & 65280) >>> 8 | 0) | _M0MPC15array5Array2atGjE(_M0FP27gmlewis5flate7rev8tab, x & 255) << 8;
}
function _M0FP27gmlewis5flate13reverse__bits(number, bit_length) {
  return _M0FP27gmlewis5flate9reverse16(number << (16 - bit_length | 0));
}
function _M0MP27gmlewis5flate14HuffmanEncoder27assign__encoding__and__size(self, bit_count, list) {
  let list$2 = list;
  let code = 0;
  const _it = _M0MP27gmlewis2io5Slice5iter2GiE(bit_count);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGiiE(_it);
    if (_bind$4 === undefined) {
      return;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _n = _x._0;
      const _bits = _x._1;
      code = code << 1;
      if (_n === 0 || _bits === 0) {
        continue;
      }
      const _tmp$38 = list$2;
      const _p$4 = list$2;
      const chunk = _M0MP27gmlewis2io5Slice20op__as__view_2einnerGRP27gmlewis5flate11LiteralNodeE(_tmp$38, _p$4.len - _bits | 0, undefined);
      _M0FP27gmlewis5flate9quicksortGRP27gmlewis5flate11LiteralNodeE(chunk, _M0FP27gmlewis5flate11by__literal);
      const _it$2 = _M0MP27gmlewis2io5Slice4iterGRP27gmlewis5flate11LiteralNodeE(chunk);
      while (true) {
        const _bind$5 = _M0MPB4Iter4nextGUssEE(_it$2);
        if (_bind$5 === undefined) {
          break;
        } else {
          const _Some$2 = _bind$5;
          const _node = _Some$2;
          const key = _node.literal;
          const debug_code = _M0FP27gmlewis5flate13reverse__bits(code & 65535, _n & 255);
          const len = _n;
          _M0MPC15array5Array3setGsE(self.codes, key, new _M0TP27gmlewis5flate5HCode(debug_code, len));
          code = code + 1 | 0;
          continue;
        }
      }
      const _tmp$39 = list$2;
      const _p$5 = list$2;
      list$2 = _M0MP27gmlewis2io5Slice20op__as__view_2einnerGRP27gmlewis5flate11LiteralNodeE(_tmp$39, 0, _p$5.len - _bits | 0);
      continue;
    }
  }
}
function _M0MP27gmlewis5flate9LevelInfo3new() {
  return new _M0TP27gmlewis5flate9LevelInfo(0, 0, 0, 0, 0);
}
function _M0MP27gmlewis5flate14HuffmanEncoder11bit__counts(self, list, max_bits) {
  if (max_bits >= 16) {
    _M0FPC15abort5abortGuE("flate: max_bits too large");
  }
  const n = list.len;
  const list$2 = _M0MP27gmlewis2io5Slice20op__as__view_2einnerGRP27gmlewis5flate11LiteralNodeE(list, 0, n + 1 | 0);
  _M0MP27gmlewis2io5Slice7op__setGRP27gmlewis5flate11LiteralNodeE(list$2, n, _M0FP27gmlewis5flate9max__nodeN6recordS1078);
  let max_bits$2 = max_bits;
  if (max_bits$2 > (n - 1 | 0)) {
    max_bits$2 = n - 1 | 0;
  }
  const levels = $make_array_len_and_init(16, _M0MP27gmlewis5flate9LevelInfo3new());
  const leaf_counts = $make_array_len_and_init(16, $make_array_len_and_init(16, 0));
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < 16) {
      $bound_check(leaf_counts, i);
      leaf_counts[i] = $make_array_len_and_init(16, 0);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let _tmp$39 = 1;
  while (true) {
    const level = _tmp$39;
    if (level <= max_bits$2) {
      $bound_check(levels, level);
      levels[level] = new _M0TP27gmlewis5flate9LevelInfo(level, _M0MP27gmlewis2io5Slice7op__getGRP27gmlewis5flate11LiteralNodeE(list$2, 1).freq, _M0MP27gmlewis2io5Slice7op__getGRP27gmlewis5flate11LiteralNodeE(list$2, 2).freq, _M0MP27gmlewis2io5Slice7op__getGRP27gmlewis5flate11LiteralNodeE(list$2, 0).freq + _M0MP27gmlewis2io5Slice7op__getGRP27gmlewis5flate11LiteralNodeE(list$2, 1).freq | 0, 0);
      $bound_check(leaf_counts, level);
      const _tmp$40 = leaf_counts[level];
      $bound_check(_tmp$40, level);
      _tmp$40[level] = 2;
      if (level === 1) {
        $bound_check(levels, level);
        levels[level].next_pair_freq = 2147483647;
      }
      _tmp$39 = level + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _tmp$40 = max_bits$2;
  $bound_check(levels, _tmp$40);
  levels[_tmp$40].needed = (Math.imul(2, n) | 0) - 4 | 0;
  let level = max_bits$2;
  while (true) {
    let _tmp$41;
    const _tmp$42 = level;
    $bound_check(levels, _tmp$42);
    if (levels[_tmp$42].next_pair_freq === 2147483647) {
      const _tmp$43 = level;
      $bound_check(levels, _tmp$43);
      _tmp$41 = levels[_tmp$43].next_char_freq === 2147483647;
    } else {
      _tmp$41 = false;
    }
    if (_tmp$41) {
      const _tmp$43 = level;
      $bound_check(levels, _tmp$43);
      levels[_tmp$43].needed = 0;
      const _tmp$44 = level + 1 | 0;
      $bound_check(levels, _tmp$44);
      levels[_tmp$44].next_pair_freq = 2147483647;
      level = level + 1 | 0;
      continue;
    }
    const _tmp$43 = level;
    $bound_check(levels, _tmp$43);
    const prev_freq = levels[_tmp$43].last_freq;
    const _tmp$44 = level;
    $bound_check(levels, _tmp$44);
    const _tmp$45 = levels[_tmp$44].next_char_freq;
    const _tmp$46 = level;
    $bound_check(levels, _tmp$46);
    if (_tmp$45 < levels[_tmp$46].next_pair_freq) {
      const _tmp$47 = level;
      $bound_check(leaf_counts, _tmp$47);
      const _tmp$48 = leaf_counts[_tmp$47];
      const _tmp$49 = level;
      $bound_check(_tmp$48, _tmp$49);
      const n$2 = _tmp$48[_tmp$49] + 1 | 0;
      const _tmp$50 = level;
      $bound_check(levels, _tmp$50);
      const _tmp$51 = levels[_tmp$50];
      const _tmp$52 = level;
      $bound_check(levels, _tmp$52);
      _tmp$51.last_freq = levels[_tmp$52].next_char_freq;
      const _tmp$53 = level;
      $bound_check(leaf_counts, _tmp$53);
      const _tmp$54 = leaf_counts[_tmp$53];
      const _tmp$55 = level;
      $bound_check(_tmp$54, _tmp$55);
      _tmp$54[_tmp$55] = n$2;
      const _tmp$56 = level;
      $bound_check(levels, _tmp$56);
      levels[_tmp$56].next_char_freq = _M0MP27gmlewis2io5Slice7op__getGRP27gmlewis5flate11LiteralNodeE(list$2, n$2).freq;
    } else {
      const _tmp$47 = level;
      $bound_check(levels, _tmp$47);
      const _tmp$48 = levels[_tmp$47];
      const _tmp$49 = level;
      $bound_check(levels, _tmp$49);
      _tmp$48.last_freq = levels[_tmp$49].next_pair_freq;
      const _bind$4 = level;
      let _tmp$50 = 0;
      while (true) {
        const i = _tmp$50;
        if (i < _bind$4) {
          const _tmp$51 = level;
          $bound_check(leaf_counts, _tmp$51);
          const _tmp$52 = leaf_counts[_tmp$51];
          const _tmp$53 = level - 1 | 0;
          $bound_check(leaf_counts, _tmp$53);
          const _tmp$54 = leaf_counts[_tmp$53];
          $bound_check(_tmp$54, i);
          $bound_check(_tmp$52, i);
          _tmp$52[i] = _tmp$54[i];
          _tmp$50 = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      const _tmp$51 = level;
      $bound_check(levels, _tmp$51);
      const _tmp$52 = levels[_tmp$51].level - 1 | 0;
      $bound_check(levels, _tmp$52);
      levels[_tmp$52].needed = 2;
    }
    const _tmp$47 = level;
    $bound_check(levels, _tmp$47);
    const _bind$4 = levels[_tmp$47];
    _bind$4.needed = _bind$4.needed - 1 | 0;
    const _tmp$48 = level;
    $bound_check(levels, _tmp$48);
    if (levels[_tmp$48].needed === 0) {
      const _tmp$49 = level;
      $bound_check(levels, _tmp$49);
      if (levels[_tmp$49].level === max_bits$2) {
        break;
      }
      const _tmp$50 = level;
      $bound_check(levels, _tmp$50);
      const _tmp$51 = levels[_tmp$50].level + 1 | 0;
      $bound_check(levels, _tmp$51);
      const _tmp$52 = levels[_tmp$51];
      const _tmp$53 = level;
      $bound_check(levels, _tmp$53);
      _tmp$52.next_pair_freq = prev_freq + levels[_tmp$53].last_freq | 0;
      level = level + 1 | 0;
    } else {
      while (true) {
        const _tmp$49 = level - 1 | 0;
        $bound_check(levels, _tmp$49);
        if (levels[_tmp$49].needed > 0) {
          level = level - 1 | 0;
          continue;
        } else {
          break;
        }
      }
    }
    continue;
  }
  const _tmp$41 = max_bits$2;
  $bound_check(leaf_counts, _tmp$41);
  const _tmp$42 = leaf_counts[_tmp$41];
  const _tmp$43 = max_bits$2;
  $bound_check(_tmp$42, _tmp$43);
  if (_tmp$42[_tmp$43] !== n) {
    _M0FPC15abort5abortGuE("leaf_counts[max_bits][max_bits] != n");
  }
  const bit_count = _M0MP27gmlewis2io5Slice20op__as__view_2einnerGiE(_M0MP27gmlewis2io5Slice11new_2einnerGiE(self.bit_count, 0, undefined), 0, max_bits$2 + 1 | 0);
  let bits = 1;
  const _tmp$44 = max_bits$2;
  $bound_check(leaf_counts, _tmp$44);
  const counts = leaf_counts[_tmp$44];
  let _tmp$45 = max_bits$2;
  while (true) {
    const level$2 = _tmp$45;
    if (level$2 > 0) {
      const _tmp$46 = bits;
      $bound_check(counts, level$2);
      const _tmp$47 = counts[level$2];
      const _tmp$48 = level$2 - 1 | 0;
      $bound_check(counts, _tmp$48);
      _M0MP27gmlewis2io5Slice7op__setGiE(bit_count, _tmp$46, _tmp$47 - counts[_tmp$48] | 0);
      bits = bits + 1 | 0;
      _tmp$45 = level$2 - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return bit_count;
}
function _M0MP27gmlewis5flate14HuffmanEncoder8generate(self, freq, max_bits) {
  if (self.freqcache.length === 0) {
    self.freqcache = _M0MPC15array5Array4makeGRP27gmlewis5flate5HCodeE(287, _M0MP27gmlewis5flate14HuffmanEncoder8generateN6recordS1079);
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i <= 286) {
        _M0MPC15array5Array3setGsE(self.freqcache, i, _M0MP27gmlewis5flate14HuffmanEncoder8generateN6recordS1080);
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  let list = _M0MP27gmlewis2io5Slice20op__as__view_2einnerGRP27gmlewis5flate11LiteralNodeE(_M0MP27gmlewis2io5Slice11new_2einnerGRP27gmlewis5flate11LiteralNodeE(self.freqcache, 0, undefined), 0, freq.len + 1 | 0);
  let count = 0;
  const _it = _M0MP27gmlewis2io5Slice5iter2GiE(freq);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGiiE(_it);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _i = _x._0;
      const _f = _x._1;
      if (_f !== 0) {
        _M0MP27gmlewis2io5Slice7op__setGRP27gmlewis5flate11LiteralNodeE(list, count, new _M0TP27gmlewis5flate11LiteralNode(_i & 65535, _f));
        count = count + 1 | 0;
      } else {
        _M0MPC15array5Array2atGUssEE(self.codes, _i).len = 0;
      }
      continue;
    }
  }
  list = _M0MP27gmlewis2io5Slice20op__as__view_2einnerGRP27gmlewis5flate11LiteralNodeE(list, 0, count);
  if (count <= 2) {
    const _it$2 = _M0MP27gmlewis2io5Slice5iter2GRP27gmlewis5flate11LiteralNodeE(list);
    while (true) {
      const _bind$4 = _M0MPB5Iter24nextGiRP27gmlewis5flate11LiteralNodeE(_it$2);
      if (_bind$4 === undefined) {
        break;
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        const _i = _x._0;
        const _node = _x._1;
        const key = _node.literal & 65535;
        const code = _i & 65535;
        _M0MP27gmlewis5flate5HCode3set(_M0MPC15array5Array2atGUssEE(self.codes, key), code, 1);
        continue;
      }
    }
    return undefined;
  }
  _M0FP27gmlewis5flate9quicksortGRP27gmlewis5flate11LiteralNodeE(list, _M0FP27gmlewis5flate13by__frequency);
  const bit_count = _M0MP27gmlewis5flate14HuffmanEncoder11bit__counts(self, list, max_bits);
  _M0MP27gmlewis5flate14HuffmanEncoder27assign__encoding__and__size(self, bit_count, list);
}
function _M0MP27gmlewis5flate16HuffmanBitWriter13index__tokens(self, tokens) {
  const _bind$4 = self.literal_freq.length;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < _bind$4) {
      _M0MPC15array5Array3setGiE(self.literal_freq, i, 0);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$5 = self.offset_freq.length;
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < _bind$5) {
      _M0MPC15array5Array3setGiE(self.offset_freq, i, 0);
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$6 = tokens.length;
  let _tmp$40 = 0;
  while (true) {
    const _ = _tmp$40;
    if (_ < _bind$6) {
      const t = tokens[_];
      _L: {
        if (t >>> 0 < 1073741824 >>> 0) {
          const _array_15 = self.literal_freq;
          const _index_16 = t;
          _M0MPC15array5Array3setGiE(_array_15, _index_16, _M0MPC15array5Array2atGiE(_array_15, _index_16) + 1 | 0);
          break _L;
        }
        const length = ((t >>> 0) - (1073741824 >>> 0) | 0) >>> 22 | 0;
        const offset = t & 4194303;
        const _array_17 = self.literal_freq;
        const _index_18 = 257 + _M0FP27gmlewis5flate12length__code(length) | 0;
        _M0MPC15array5Array3setGiE(_array_17, _index_18, _M0MPC15array5Array2atGiE(_array_17, _index_18) + 1 | 0);
        const code = _M0FP27gmlewis5flate12offset__code(offset);
        const _array_19 = self.offset_freq;
        _M0MPC15array5Array3setGiE(_array_19, code, _M0MPC15array5Array2atGiE(_array_19, code) + 1 | 0);
        break _L;
      }
      _tmp$40 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let num_literals = self.literal_freq.length;
  while (true) {
    if (_M0MPC15array5Array2atGiE(self.literal_freq, num_literals - 1 | 0) === 0) {
      num_literals = num_literals - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let num_offsets = self.offset_freq.length;
  while (true) {
    if (num_offsets > 0 && _M0MPC15array5Array2atGiE(self.offset_freq, num_offsets - 1 | 0) === 0) {
      num_offsets = num_offsets - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (num_offsets === 0) {
    _M0MPC15array5Array3setGiE(self.offset_freq, 0, 1);
    num_offsets = 1;
  }
  _M0MP27gmlewis5flate14HuffmanEncoder8generate(self.literal_encoding, _M0MP27gmlewis2io5Slice11new_2einnerGiE(self.literal_freq, 0, undefined), 15);
  _M0MP27gmlewis5flate14HuffmanEncoder8generate(self.offset_encoding, _M0MP27gmlewis2io5Slice11new_2einnerGiE(self.offset_freq, 0, undefined), 15);
  return { _0: num_literals, _1: num_offsets };
}
function _M0MP27gmlewis5flate16HuffmanBitWriter11write__code(self, c) {
  const _bind$4 = self.err;
  if (!(_bind$4 === undefined)) {
    return undefined;
  }
  const _tmp$38 = self.bits;
  const _p$4 = c.code;
  self.bits = BigInt.asUintN(64, _tmp$38 | BigInt.asUintN(64, BigInt.asUintN(64, BigInt(_p$4 >>> 0)) << BigInt(self.nbits & 63)));
  self.nbits = (self.nbits >>> 0) + (c.len >>> 0) | 0;
  if (self.nbits >>> 0 >= 48 >>> 0) {
    const bits = self.bits;
    self.bits = BigInt.asUintN(64, BigInt.asUintN(64, self.bits) >> BigInt(48 & 63));
    self.nbits = (self.nbits >>> 0) - (48 >>> 0) | 0;
    let n = self.nbytes;
    _M0MPC15array5Array3setGyE(self.bytes, n, (Number(BigInt.asIntN(32, bits)) | 0) & 255);
    const _tmp$39 = self.bytes;
    const _tmp$40 = n + 1 | 0;
    const _p$5 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(8 & 63));
    _M0MPC15array5Array3setGyE(_tmp$39, _tmp$40, (Number(BigInt.asIntN(32, _p$5)) | 0) & 255);
    const _tmp$41 = self.bytes;
    const _tmp$42 = n + 2 | 0;
    const _p$6 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(16 & 63));
    _M0MPC15array5Array3setGyE(_tmp$41, _tmp$42, (Number(BigInt.asIntN(32, _p$6)) | 0) & 255);
    const _tmp$43 = self.bytes;
    const _tmp$44 = n + 3 | 0;
    const _p$7 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(24 & 63));
    _M0MPC15array5Array3setGyE(_tmp$43, _tmp$44, (Number(BigInt.asIntN(32, _p$7)) | 0) & 255);
    const _tmp$45 = self.bytes;
    const _tmp$46 = n + 4 | 0;
    const _p$8 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(32 & 63));
    _M0MPC15array5Array3setGyE(_tmp$45, _tmp$46, (Number(BigInt.asIntN(32, _p$8)) | 0) & 255);
    const _tmp$47 = self.bytes;
    const _tmp$48 = n + 5 | 0;
    const _p$9 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(40 & 63));
    _M0MPC15array5Array3setGyE(_tmp$47, _tmp$48, (Number(BigInt.asIntN(32, _p$9)) | 0) & 255);
    n = n + 6 | 0;
    if (n >= 240) {
      _M0MP27gmlewis5flate16HuffmanBitWriter5write(self, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(_M0MP27gmlewis2io5Slice11new_2einnerGyE(self.bytes, 0, undefined), 0, n));
      n = 0;
    }
    self.nbytes = n;
    return;
  } else {
    return;
  }
}
function _M0MP27gmlewis5flate16HuffmanBitWriter22write__dynamic__header(self, num_literals, num_offsets, num_codegens, is_eof) {
  const _bind$4 = self.err;
  if (!(_bind$4 === undefined)) {
    return undefined;
  }
  let first_bits = 4;
  if (is_eof) {
    first_bits = 5;
  }
  _M0MP27gmlewis5flate16HuffmanBitWriter11write__bits(self, first_bits, 3);
  _M0MP27gmlewis5flate16HuffmanBitWriter11write__bits(self, num_literals - 257 | 0, 5);
  _M0MP27gmlewis5flate16HuffmanBitWriter11write__bits(self, num_offsets - 1 | 0, 5);
  _M0MP27gmlewis5flate16HuffmanBitWriter11write__bits(self, num_codegens - 4 | 0, 4);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < num_codegens) {
      const value = _M0MPC15array5Array2atGUssEE(self.codegen_encoding.codes, _M0MPC15array5Array2atGiE(_M0FP27gmlewis5flate14codegen__order, i)).len;
      _M0MP27gmlewis5flate16HuffmanBitWriter11write__bits(self, value, 3);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let i = 0;
  while (true) {
    const _tmp$39 = self.codegen;
    const _tmp$40 = i;
    $bound_check(_tmp$39, _tmp$40);
    const code_word = _tmp$39[_tmp$40];
    i = i + 1 | 0;
    const _p$4 = 255;
    if (code_word === _p$4) {
      return;
    }
    _M0MP27gmlewis5flate16HuffmanBitWriter11write__code(self, _M0MPC15array5Array2atGUssEE(self.codegen_encoding.codes, code_word));
    const _bind$5 = code_word;
    switch (_bind$5) {
      case 16: {
        const _tmp$41 = self.codegen;
        const _tmp$42 = i;
        $bound_check(_tmp$41, _tmp$42);
        _M0MP27gmlewis5flate16HuffmanBitWriter11write__bits(self, _tmp$41[_tmp$42], 2);
        i = i + 1 | 0;
        break;
      }
      case 17: {
        const _tmp$43 = self.codegen;
        const _tmp$44 = i;
        $bound_check(_tmp$43, _tmp$44);
        _M0MP27gmlewis5flate16HuffmanBitWriter11write__bits(self, _tmp$43[_tmp$44], 3);
        i = i + 1 | 0;
        break;
      }
      case 18: {
        const _tmp$45 = self.codegen;
        const _tmp$46 = i;
        $bound_check(_tmp$45, _tmp$46);
        _M0MP27gmlewis5flate16HuffmanBitWriter11write__bits(self, _tmp$45[_tmp$46], 7);
        i = i + 1 | 0;
        break;
      }
    }
    continue;
  }
}
function _M0MP27gmlewis5flate16HuffmanBitWriter13write__tokens(self, tokens, le_codes, oe_codes) {
  const _bind$4 = self.err;
  if (!(_bind$4 === undefined)) {
    return undefined;
  }
  let bits = self.bits;
  let nbits = self.nbits;
  let nbytes = self.nbytes;
  const _bind$5 = tokens.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const t = tokens[_];
      if (t >>> 0 < 1073741824 >>> 0) {
        const c = _M0MPC15array5Array2atGUssEE(le_codes, t);
        const _tmp$39 = bits;
        const _p$4 = c.code;
        bits = BigInt.asUintN(64, _tmp$39 | BigInt.asUintN(64, BigInt.asUintN(64, BigInt(_p$4 >>> 0)) << BigInt(nbits & 63)));
        nbits = (nbits >>> 0) + (c.len >>> 0) | 0;
      } else {
        const length = ((t >>> 0) - (1073741824 >>> 0) | 0) >>> 22 | 0;
        const length_code = _M0FP27gmlewis5flate12length__code(length);
        const c = _M0MPC15array5Array2atGUssEE(le_codes, length_code + 257 | 0);
        const _tmp$39 = bits;
        const _p$4 = c.code;
        bits = BigInt.asUintN(64, _tmp$39 | BigInt.asUintN(64, BigInt.asUintN(64, BigInt(_p$4 >>> 0)) << BigInt(nbits & 63)));
        nbits = (nbits >>> 0) + (c.len >>> 0) | 0;
        if (nbits >>> 0 >= 48 >>> 0) {
          const _tmp$40 = self.bytes;
          const _tmp$41 = nbytes;
          const _p$5 = bits;
          _M0MPC15array5Array3setGyE(_tmp$40, _tmp$41, (Number(BigInt.asIntN(32, _p$5)) | 0) & 255);
          const _tmp$42 = self.bytes;
          const _tmp$43 = nbytes + 1 | 0;
          const _p$6 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(8 & 63));
          _M0MPC15array5Array3setGyE(_tmp$42, _tmp$43, (Number(BigInt.asIntN(32, _p$6)) | 0) & 255);
          const _tmp$44 = self.bytes;
          const _tmp$45 = nbytes + 2 | 0;
          const _p$7 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(16 & 63));
          _M0MPC15array5Array3setGyE(_tmp$44, _tmp$45, (Number(BigInt.asIntN(32, _p$7)) | 0) & 255);
          const _tmp$46 = self.bytes;
          const _tmp$47 = nbytes + 3 | 0;
          const _p$8 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(24 & 63));
          _M0MPC15array5Array3setGyE(_tmp$46, _tmp$47, (Number(BigInt.asIntN(32, _p$8)) | 0) & 255);
          const _tmp$48 = self.bytes;
          const _tmp$49 = nbytes + 4 | 0;
          const _p$9 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(32 & 63));
          _M0MPC15array5Array3setGyE(_tmp$48, _tmp$49, (Number(BigInt.asIntN(32, _p$9)) | 0) & 255);
          const _tmp$50 = self.bytes;
          const _tmp$51 = nbytes + 5 | 0;
          const _p$10 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(40 & 63));
          _M0MPC15array5Array3setGyE(_tmp$50, _tmp$51, (Number(BigInt.asIntN(32, _p$10)) | 0) & 255);
          bits = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(48 & 63));
          nbits = (nbits >>> 0) - (48 >>> 0) | 0;
          nbytes = nbytes + 6 | 0;
          if (nbytes >= 240) {
            self.bits = bits;
            self.nbits = nbits;
            _M0MP27gmlewis5flate16HuffmanBitWriter5write(self, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(_M0MP27gmlewis2io5Slice11new_2einnerGyE(self.bytes, 0, undefined), 0, nbytes));
            const _bind$6 = self.err;
            if (!(_bind$6 === undefined)) {
              return undefined;
            }
            nbytes = 0;
          }
        }
        const extra_length_bits = _M0MPC15array5Array2atGiE(_M0FP27gmlewis5flate19length__extra__bits, length_code);
        if (extra_length_bits >>> 0 > 0 >>> 0) {
          const extra_length = (length >>> 0) - (_M0MPC15array5Array2atGjE(_M0FP27gmlewis5flate12length__base, length_code) >>> 0) | 0;
          const _tmp$40 = bits;
          const _p$5 = extra_length;
          bits = BigInt.asUintN(64, _tmp$40 | BigInt.asUintN(64, BigInt.asUintN(64, BigInt(_p$5 >>> 0)) << BigInt(nbits & 63)));
          nbits = (nbits >>> 0) + (extra_length_bits >>> 0) | 0;
        }
        if (nbits >>> 0 >= 48 >>> 0) {
          const _tmp$40 = self.bytes;
          const _tmp$41 = nbytes;
          const _p$5 = bits;
          _M0MPC15array5Array3setGyE(_tmp$40, _tmp$41, (Number(BigInt.asIntN(32, _p$5)) | 0) & 255);
          const _tmp$42 = self.bytes;
          const _tmp$43 = nbytes + 1 | 0;
          const _p$6 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(8 & 63));
          _M0MPC15array5Array3setGyE(_tmp$42, _tmp$43, (Number(BigInt.asIntN(32, _p$6)) | 0) & 255);
          const _tmp$44 = self.bytes;
          const _tmp$45 = nbytes + 2 | 0;
          const _p$7 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(16 & 63));
          _M0MPC15array5Array3setGyE(_tmp$44, _tmp$45, (Number(BigInt.asIntN(32, _p$7)) | 0) & 255);
          const _tmp$46 = self.bytes;
          const _tmp$47 = nbytes + 3 | 0;
          const _p$8 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(24 & 63));
          _M0MPC15array5Array3setGyE(_tmp$46, _tmp$47, (Number(BigInt.asIntN(32, _p$8)) | 0) & 255);
          const _tmp$48 = self.bytes;
          const _tmp$49 = nbytes + 4 | 0;
          const _p$9 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(32 & 63));
          _M0MPC15array5Array3setGyE(_tmp$48, _tmp$49, (Number(BigInt.asIntN(32, _p$9)) | 0) & 255);
          const _tmp$50 = self.bytes;
          const _tmp$51 = nbytes + 5 | 0;
          const _p$10 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(40 & 63));
          _M0MPC15array5Array3setGyE(_tmp$50, _tmp$51, (Number(BigInt.asIntN(32, _p$10)) | 0) & 255);
          bits = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(48 & 63));
          nbits = (nbits >>> 0) - (48 >>> 0) | 0;
          nbytes = nbytes + 6 | 0;
          if (nbytes >= 240) {
            self.bits = bits;
            self.nbits = nbits;
            _M0MP27gmlewis5flate16HuffmanBitWriter5write(self, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(_M0MP27gmlewis2io5Slice11new_2einnerGyE(self.bytes, 0, undefined), 0, nbytes));
            const _bind$6 = self.err;
            if (!(_bind$6 === undefined)) {
              return undefined;
            }
            nbytes = 0;
          }
        }
        const offset = t & 4194303;
        const offset_code = _M0FP27gmlewis5flate12offset__code(offset);
        const c$2 = _M0MPC15array5Array2atGUssEE(oe_codes, offset_code);
        const _tmp$40 = bits;
        const _p$5 = c$2.code;
        bits = BigInt.asUintN(64, _tmp$40 | BigInt.asUintN(64, BigInt.asUintN(64, BigInt(_p$5 >>> 0)) << BigInt(nbits & 63)));
        nbits = (nbits >>> 0) + (c$2.len >>> 0) | 0;
        if (nbits >>> 0 >= 48 >>> 0) {
          const _tmp$41 = self.bytes;
          const _tmp$42 = nbytes;
          const _p$6 = bits;
          _M0MPC15array5Array3setGyE(_tmp$41, _tmp$42, (Number(BigInt.asIntN(32, _p$6)) | 0) & 255);
          const _tmp$43 = self.bytes;
          const _tmp$44 = nbytes + 1 | 0;
          const _p$7 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(8 & 63));
          _M0MPC15array5Array3setGyE(_tmp$43, _tmp$44, (Number(BigInt.asIntN(32, _p$7)) | 0) & 255);
          const _tmp$45 = self.bytes;
          const _tmp$46 = nbytes + 2 | 0;
          const _p$8 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(16 & 63));
          _M0MPC15array5Array3setGyE(_tmp$45, _tmp$46, (Number(BigInt.asIntN(32, _p$8)) | 0) & 255);
          const _tmp$47 = self.bytes;
          const _tmp$48 = nbytes + 3 | 0;
          const _p$9 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(24 & 63));
          _M0MPC15array5Array3setGyE(_tmp$47, _tmp$48, (Number(BigInt.asIntN(32, _p$9)) | 0) & 255);
          const _tmp$49 = self.bytes;
          const _tmp$50 = nbytes + 4 | 0;
          const _p$10 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(32 & 63));
          _M0MPC15array5Array3setGyE(_tmp$49, _tmp$50, (Number(BigInt.asIntN(32, _p$10)) | 0) & 255);
          const _tmp$51 = self.bytes;
          const _tmp$52 = nbytes + 5 | 0;
          const _p$11 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(40 & 63));
          _M0MPC15array5Array3setGyE(_tmp$51, _tmp$52, (Number(BigInt.asIntN(32, _p$11)) | 0) & 255);
          bits = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(48 & 63));
          nbits = (nbits >>> 0) - (48 >>> 0) | 0;
          nbytes = nbytes + 6 | 0;
          if (nbytes >= 240) {
            self.bits = bits;
            self.nbits = nbits;
            _M0MP27gmlewis5flate16HuffmanBitWriter5write(self, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(_M0MP27gmlewis2io5Slice11new_2einnerGyE(self.bytes, 0, undefined), 0, nbytes));
            const _bind$6 = self.err;
            if (!(_bind$6 === undefined)) {
              return undefined;
            }
            nbytes = 0;
          }
        }
        const extra_offset_bits = _M0MPC15array5Array2atGiE(_M0FP27gmlewis5flate19offset__extra__bits, offset_code);
        if (extra_offset_bits >>> 0 > 0 >>> 0) {
          const extra_offset = (offset >>> 0) - (_M0MPC15array5Array2atGjE(_M0FP27gmlewis5flate12offset__base, offset_code) >>> 0) | 0;
          const _tmp$41 = bits;
          const _p$6 = extra_offset;
          bits = BigInt.asUintN(64, _tmp$41 | BigInt.asUintN(64, BigInt.asUintN(64, BigInt(_p$6 >>> 0)) << BigInt(nbits & 63)));
          nbits = (nbits >>> 0) + (extra_offset_bits >>> 0) | 0;
        }
      }
      if (nbits >>> 0 >= 48 >>> 0) {
        const _tmp$39 = self.bytes;
        const _tmp$40 = nbytes;
        const _p$4 = bits;
        _M0MPC15array5Array3setGyE(_tmp$39, _tmp$40, (Number(BigInt.asIntN(32, _p$4)) | 0) & 255);
        const _tmp$41 = self.bytes;
        const _tmp$42 = nbytes + 1 | 0;
        const _p$5 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(8 & 63));
        _M0MPC15array5Array3setGyE(_tmp$41, _tmp$42, (Number(BigInt.asIntN(32, _p$5)) | 0) & 255);
        const _tmp$43 = self.bytes;
        const _tmp$44 = nbytes + 2 | 0;
        const _p$6 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(16 & 63));
        _M0MPC15array5Array3setGyE(_tmp$43, _tmp$44, (Number(BigInt.asIntN(32, _p$6)) | 0) & 255);
        const _tmp$45 = self.bytes;
        const _tmp$46 = nbytes + 3 | 0;
        const _p$7 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(24 & 63));
        _M0MPC15array5Array3setGyE(_tmp$45, _tmp$46, (Number(BigInt.asIntN(32, _p$7)) | 0) & 255);
        const _tmp$47 = self.bytes;
        const _tmp$48 = nbytes + 4 | 0;
        const _p$8 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(32 & 63));
        _M0MPC15array5Array3setGyE(_tmp$47, _tmp$48, (Number(BigInt.asIntN(32, _p$8)) | 0) & 255);
        const _tmp$49 = self.bytes;
        const _tmp$50 = nbytes + 5 | 0;
        const _p$9 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(40 & 63));
        _M0MPC15array5Array3setGyE(_tmp$49, _tmp$50, (Number(BigInt.asIntN(32, _p$9)) | 0) & 255);
        bits = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(48 & 63));
        nbits = (nbits >>> 0) - (48 >>> 0) | 0;
        nbytes = nbytes + 6 | 0;
        if (nbytes >= 240) {
          self.bits = bits;
          self.nbits = nbits;
          _M0MP27gmlewis5flate16HuffmanBitWriter5write(self, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(_M0MP27gmlewis2io5Slice11new_2einnerGyE(self.bytes, 0, undefined), 0, nbytes));
          const _bind$6 = self.err;
          if (!(_bind$6 === undefined)) {
            return undefined;
          }
          nbytes = 0;
        }
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.bits = bits;
  self.nbits = nbits;
  self.nbytes = nbytes;
}
function _M0MP27gmlewis5flate16HuffmanBitWriter21write__block__dynamic(self, tokens, eof, input) {
  const _bind$4 = self.err;
  if (!(_bind$4 === undefined)) {
    return undefined;
  }
  _M0MPC15array5Array4pushGRP27gmlewis5flate5TokenE(tokens, 256);
  const _bind$5 = _M0MP27gmlewis5flate16HuffmanBitWriter13index__tokens(self, tokens);
  const _num_literals = _bind$5._0;
  const _num_offsets = _bind$5._1;
  _M0MP27gmlewis5flate16HuffmanBitWriter17generate__codegen(self, _num_literals, _num_offsets, self.literal_encoding, self.offset_encoding);
  _M0MP27gmlewis5flate14HuffmanEncoder8generate(self.codegen_encoding, _M0MP27gmlewis2io5Slice11new_2einnerGiE(self.codegen_freq, 0, undefined), 7);
  const _bind$6 = _M0MP27gmlewis5flate16HuffmanBitWriter13dynamic__size(self, self.literal_encoding, self.offset_encoding, 0);
  const _size = _bind$6._0;
  const _numCodegens = _bind$6._1;
  const _bind$7 = _M0FP27gmlewis5flate12stored__size(input.len);
  const _ssize = _bind$7._0;
  const _storable = _bind$7._1;
  if (_storable && _ssize < _size + _size >> 4) {
    _M0MP27gmlewis5flate16HuffmanBitWriter21write__stored__header(self, input.len, eof);
    _M0MP27gmlewis5flate16HuffmanBitWriter12write__bytes(self, input);
    return undefined;
  }
  _M0MP27gmlewis5flate16HuffmanBitWriter22write__dynamic__header(self, _num_literals, _num_offsets, _numCodegens, eof);
  _M0MP27gmlewis5flate16HuffmanBitWriter13write__tokens(self, tokens, self.literal_encoding.codes, self.offset_encoding.codes);
}
function _M0FP27gmlewis5flate9histogram(b, h) {
  const _bind$4 = b.len;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < _bind$4) {
      const t = _M0MP27gmlewis2io5Slice7op__getGyE(b, i);
      _M0MPC15array5Array3setGiE(h, t, _M0MPC15array5Array2atGiE(h, t) + 1 | 0);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0MP27gmlewis5flate16HuffmanBitWriter18write__block__huff(self, eof, input) {
  const _bind$4 = self.err;
  if (!(_bind$4 === undefined)) {
    return undefined;
  }
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < 286) {
      _M0MPC15array5Array3setGiE(self.literal_freq, i, 0);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0FP27gmlewis5flate9histogram(input, self.literal_freq);
  _M0MPC15array5Array3setGiE(self.literal_freq, 256, 1);
  _M0MPC15array5Array3setGiE(self.offset_freq, 0, 1);
  _M0MP27gmlewis5flate14HuffmanEncoder8generate(self.literal_encoding, _M0MP27gmlewis2io5Slice11new_2einnerGiE(self.literal_freq, 0, undefined), 15);
  _M0MP27gmlewis5flate16HuffmanBitWriter17generate__codegen(self, 257, 1, self.literal_encoding, _M0FP27gmlewis5flate12huff__offset);
  _M0MP27gmlewis5flate14HuffmanEncoder8generate(self.codegen_encoding, _M0MP27gmlewis2io5Slice11new_2einnerGiE(self.codegen_freq, 0, undefined), 7);
  const _bind$5 = _M0MP27gmlewis5flate16HuffmanBitWriter13dynamic__size(self, self.literal_encoding, _M0FP27gmlewis5flate12huff__offset, 0);
  const _size = _bind$5._0;
  const _num_codegens = _bind$5._1;
  const _bind$6 = _M0FP27gmlewis5flate12stored__size(input.len);
  const _ssize = _bind$6._0;
  const _storable = _bind$6._1;
  if (_storable && _ssize < _size + _size >> 4) {
    _M0MP27gmlewis5flate16HuffmanBitWriter21write__stored__header(self, input.len, eof);
    _M0MP27gmlewis5flate16HuffmanBitWriter12write__bytes(self, input);
    return undefined;
  }
  _M0MP27gmlewis5flate16HuffmanBitWriter22write__dynamic__header(self, 257, 1, _num_codegens, eof);
  const encoding = _M0MPC15array5Array12view_2einnerGsE(self.literal_encoding.codes, 0, _M0MP27gmlewis5flate16HuffmanBitWriter18write__block__huffN6constrS1081);
  let bits = self.bits;
  let nbits = self.nbits;
  let n = self.nbytes;
  const _it = _M0MP27gmlewis2io5Slice4iterGyE(input);
  while (true) {
    const _bind$7 = _M0MPB4Iter4nextGyE(_it);
    if (_bind$7 === -1) {
      break;
    } else {
      const _Some = _bind$7;
      const _t = _Some;
      const c = _M0MPC15array9ArrayView2atGRP219moonbit_2dcommunity7piediff4EditE(encoding, _t);
      const _tmp$39 = bits;
      const _p$4 = c.code;
      bits = BigInt.asUintN(64, _tmp$39 | BigInt.asUintN(64, BigInt.asUintN(64, BigInt(_p$4 >>> 0)) << BigInt(nbits & 63)));
      nbits = (nbits >>> 0) + (c.len >>> 0) | 0;
      if (nbits >>> 0 < 48 >>> 0) {
        continue;
      }
      const _tmp$40 = self.bytes;
      const _tmp$41 = n;
      const _p$5 = bits;
      _M0MPC15array5Array3setGyE(_tmp$40, _tmp$41, (Number(BigInt.asIntN(32, _p$5)) | 0) & 255);
      const _tmp$42 = self.bytes;
      const _tmp$43 = n + 1 | 0;
      const _p$6 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(8 & 63));
      _M0MPC15array5Array3setGyE(_tmp$42, _tmp$43, (Number(BigInt.asIntN(32, _p$6)) | 0) & 255);
      const _tmp$44 = self.bytes;
      const _tmp$45 = n + 2 | 0;
      const _p$7 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(16 & 63));
      _M0MPC15array5Array3setGyE(_tmp$44, _tmp$45, (Number(BigInt.asIntN(32, _p$7)) | 0) & 255);
      const _tmp$46 = self.bytes;
      const _tmp$47 = n + 3 | 0;
      const _p$8 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(24 & 63));
      _M0MPC15array5Array3setGyE(_tmp$46, _tmp$47, (Number(BigInt.asIntN(32, _p$8)) | 0) & 255);
      const _tmp$48 = self.bytes;
      const _tmp$49 = n + 4 | 0;
      const _p$9 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(32 & 63));
      _M0MPC15array5Array3setGyE(_tmp$48, _tmp$49, (Number(BigInt.asIntN(32, _p$9)) | 0) & 255);
      const _tmp$50 = self.bytes;
      const _tmp$51 = n + 5 | 0;
      const _p$10 = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(40 & 63));
      _M0MPC15array5Array3setGyE(_tmp$50, _tmp$51, (Number(BigInt.asIntN(32, _p$10)) | 0) & 255);
      bits = BigInt.asUintN(64, BigInt.asUintN(64, bits) >> BigInt(48 & 63));
      nbits = (nbits >>> 0) - (48 >>> 0) | 0;
      n = n + 6 | 0;
      if (n < 240) {
        continue;
      }
      self.bits = bits;
      self.nbits = nbits;
      _M0MP27gmlewis5flate16HuffmanBitWriter5write(self, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(_M0MP27gmlewis2io5Slice11new_2einnerGyE(self.bytes, 0, undefined), 0, n));
      const _bind$8 = self.err;
      if (!(_bind$8 === undefined)) {
        return undefined;
      }
      n = 0;
      continue;
    }
  }
  self.bits = bits;
  self.nbits = nbits;
  self.nbytes = n;
  _M0MP27gmlewis5flate16HuffmanBitWriter11write__code(self, _M0MPC15array9ArrayView2atGRP219moonbit_2dcommunity7piediff4EditE(encoding, 256));
}
function _M0MP27gmlewis5flate10Compressor10enc__speed(self) {
  if (self.window_end < 65535) {
    if (!self.sync) {
      return undefined;
    }
    if (self.window_end < 128) {
      if (self.window_end === 0) {
        return undefined;
      }
      if (self.window_end <= 16) {
        self.err = _M0MP27gmlewis5flate10Compressor20write__stored__block(self, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(self.window, 0, self.window_end));
      } else {
        _M0MP27gmlewis5flate16HuffmanBitWriter18write__block__huff(self.w, false, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(self.window, 0, self.window_end));
        self.err = self.w.err;
      }
      self.window_end = 0;
      _M0MP27gmlewis5flate11DeflateFast5reset(self.best_speed);
      return undefined;
    }
  }
  self.tokens = _M0MP27gmlewis5flate11DeflateFast6encode(self.best_speed, _M0MPC15array5Array11new_2einnerGRP27gmlewis5flate5TokenE(self.window_end), _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(self.window, 0, self.window_end));
  if (self.tokens.length > (self.window_end - (self.window_end >> 4) | 0)) {
    _M0MP27gmlewis5flate16HuffmanBitWriter18write__block__huff(self.w, false, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(self.window, 0, self.window_end));
  } else {
    _M0MP27gmlewis5flate16HuffmanBitWriter21write__block__dynamic(self.w, self.tokens, false, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(self.window, 0, self.window_end));
  }
  self.err = self.w.err;
  self.window_end = 0;
}
function _M0MP27gmlewis5flate10Compressor11fill__store(self, b) {
  const _p$4 = self.window;
  const _p$5 = _p$4.len - self.window_end | 0;
  const _p$6 = b.len;
  const n = _p$5 > _p$6 ? _p$6 : _p$5;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < n) {
      _M0MP27gmlewis2io5Slice7op__setGyE(self.window, self.window_end + i | 0, _M0MP27gmlewis2io5Slice7op__getGyE(b, i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.window_end = self.window_end + n | 0;
  return n;
}
function _M0MP27gmlewis5flate10Compressor5write(self, b) {
  const _bind$4 = self.err;
  if (!(_bind$4 === undefined)) {
    return { _0: 0, _1: self.err };
  }
  let b$2 = b;
  const _p$4 = b$2;
  const n = _p$4.len;
  while (true) {
    const _p$5 = b$2;
    if (_p$5.len > 0) {
      _M0MP27gmlewis5flate10Compressor10enc__speed(self);
      b$2 = _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(b$2, _M0MP27gmlewis5flate10Compressor11fill__store(self, b$2), undefined);
      const _bind$5 = self.err;
      if (!(_bind$5 === undefined)) {
        return { _0: 0, _1: self.err };
      }
      continue;
    } else {
      break;
    }
  }
  return { _0: n, _1: undefined };
}
function _M0IP27gmlewis5flate6WriterP27gmlewis2io6Writer5write(self, data) {
  return _M0MP27gmlewis5flate10Compressor5write(self.d, data);
}
function _M0MP27gmlewis5flate10Compressor5close(self) {
  if (_M0IPC16option6OptionPB2Eq5equalGRP27gmlewis2io7IOErrorE(_M0FP27gmlewis5flate21writer__closed__error, self.err)) {
    return undefined;
  }
  const _bind$4 = self.err;
  if (_bind$4 === undefined) {
  } else {
    return self.err;
  }
  self.sync = true;
  _M0MP27gmlewis5flate10Compressor10enc__speed(self);
  const _bind$5 = self.err;
  if (_bind$5 === undefined) {
  } else {
    return self.err;
  }
  _M0MP27gmlewis5flate16HuffmanBitWriter21write__stored__header(self.w, 0, true);
  const _bind$6 = self.w.err;
  if (_bind$6 === undefined) {
  } else {
    return self.w.err;
  }
  _M0MP27gmlewis5flate16HuffmanBitWriter5flush(self.w);
  const _bind$7 = self.w.err;
  if (_bind$7 === undefined) {
  } else {
    return self.w.err;
  }
  self.err = _M0FP27gmlewis5flate21writer__closed__error;
  return undefined;
}
function _M0IP27gmlewis5flate6WriterP27gmlewis2io6Closer5close(self) {
  return _M0MP27gmlewis5flate10Compressor5close(self.d);
}
function _M0FP27gmlewis5flate21corrupt__input__error(v) {
  return new _M0DTPC15error5Error32gmlewis_2fio_2eIOError_2eIOError(`flate: corrupt input before offset ${_M0IPC15int645Int64PB4Show10to__string(v)}`);
}
function _M0MP27gmlewis5flate14HuffmanDecoder3new() {
  const chunks = _M0MPC15array5Array4makeGjE(512, 0);
  return new _M0TP27gmlewis5flate14HuffmanDecoder(0, chunks, [], 0);
}
function _M0MP27gmlewis5flate14HuffmanDecoder10initialize(self, lengths) {
  if (self.min !== 0) {
    self.min = 0;
    self.chunks = _M0MPC15array5Array4makeGjE(512, 0);
    self.links = [];
    self.link_mask = 0;
  }
  const count = _M0MPC15array5Array4makeGiE(16, 0);
  let min = 0;
  let max = 0;
  const _it = _M0MP27gmlewis2io5Slice4iterGiE(lengths);
  while (true) {
    const _bind$4 = _M0MPB4Iter4nextGiE(_it);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _n = _Some;
      if (_n === 0) {
        continue;
      }
      if (min === 0 || _n < min) {
        min = _n;
      }
      if (_n > max) {
        max = _n;
      }
      _M0MPC15array5Array3setGiE(count, _n, _M0MPC15array5Array2atGiE(count, _n) + 1 | 0);
      continue;
    }
  }
  if (max === 0) {
    return true;
  }
  let code = 0;
  const nextcode = _M0MPC15array5Array4makeGiE(16, 0);
  let _tmp$38 = min;
  while (true) {
    const i = _tmp$38;
    if (i <= max) {
      code = code << 1;
      _M0MPC15array5Array3setGiE(nextcode, i, code);
      code = code + _M0MPC15array5Array2atGiE(count, i) | 0;
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (code !== 1 << max && !(code === 1 && max === 1)) {
    return false;
  }
  self.min = min;
  if (max > 9) {
    const num_links = 1 << (max - 9 | 0);
    self.link_mask = (num_links >>> 0) - (1 >>> 0) | 0;
    const link = _M0MPC15array5Array2atGiE(nextcode, 10) >> 1;
    self.links = _M0MPC15array5Array4makeGRPB5ArrayGjEE((512 >>> 0) - (link >>> 0) | 0, []);
    let _tmp$39 = link;
    while (true) {
      const j = _tmp$39;
      if (j >>> 0 < 512 >>> 0) {
        let reverse = _M0FP27gmlewis5flate9reverse16(j & 65535);
        reverse = reverse >> 7;
        const off = (j >>> 0) - (link >>> 0) | 0;
        _M0MPC15array5Array3setGjE(self.chunks, reverse, off << 4 | 10);
        _M0MPC15array5Array3setGRPB5ArrayGjEE(self.links, off, _M0MPC15array5Array4makeGjE(num_links, 0));
        _tmp$39 = (j >>> 0) + (1 >>> 0) | 0;
        continue;
      } else {
        break;
      }
    }
  }
  const _it$2 = _M0MP27gmlewis2io5Slice5iter2GiE(lengths);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGiiE(_it$2);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _i = _x._0;
      const _n = _x._1;
      if (_n === 0) {
        continue;
      }
      const code$2 = _M0MPC15array5Array2atGiE(nextcode, _n);
      _M0MPC15array5Array3setGiE(nextcode, _n, _M0MPC15array5Array2atGiE(nextcode, _n) + 1 | 0);
      const chunk = _i << 4 | _n;
      let reverse = _M0FP27gmlewis5flate9reverse16(code$2 & 65535);
      reverse = reverse >> (16 - _n | 0);
      if (_n <= 9) {
        let _tmp$39 = reverse;
        while (true) {
          const off = _tmp$39;
          if (off < self.chunks.length) {
            _M0MPC15array5Array3setGjE(self.chunks, off, chunk);
            _tmp$39 = off + (1 << _n) | 0;
            continue;
          } else {
            break;
          }
        }
      } else {
        const j = reverse & 511;
        const value = _M0MPC15array5Array2atGjE(self.chunks, j) >>> 4 | 0;
        const linktab = _M0MPC15array5Array2atGRPB5ArrayGsEE(self.links, value);
        reverse = reverse >> 9;
        let _tmp$39 = reverse;
        while (true) {
          const off = _tmp$39;
          if (off < linktab.length) {
            _M0MPC15array5Array3setGjE(linktab, off, chunk);
            _tmp$39 = off + (1 << (_n - 9 | 0)) | 0;
            continue;
          } else {
            break;
          }
        }
      }
      continue;
    }
  }
  return true;
}
function _M0IP27gmlewis5flate6ReaderP27gmlewis2io6Reader4read(self, b) {
  return self.method_table.method_0(self.self, b);
}
function _M0IP27gmlewis2io6BufferP27gmlewis5flate6Reader4read(self, b) {
  return _M0IP27gmlewis2io6BufferP27gmlewis2io6Reader4read(self, b);
}
function _M0IP27gmlewis2io6BufferP27gmlewis5flate6Reader10read__byte(self) {
  return _M0IP27gmlewis2io6BufferP27gmlewis2io10ByteReader10read__byte(self);
}
function _M0FP27gmlewis5flate7no__eof(e) {
  if (_M0IP27gmlewis2io7IOErrorPB2Eq5equal(e, _M0FP27gmlewis2io3eof)) {
    return _M0FP27gmlewis2io20err__unexpected__eof;
  }
  return e;
}
function _M0MP27gmlewis5flate11DictDecoder11read__flush(self) {
  const to_read = _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(self.hist, self.rd_pos, self.wr_pos);
  self.rd_pos = self.wr_pos;
  const _tmp$38 = self.wr_pos;
  const _p$4 = self.hist;
  if (_tmp$38 === _p$4.len) {
    self.wr_pos = 0;
    self.rd_pos = 0;
    self.full = true;
  }
  return to_read;
}
function _M0MP27gmlewis5flate11DictDecoder12avail__write(self) {
  const _p$4 = self.hist;
  return _p$4.len - self.wr_pos | 0;
}
function _M0MP27gmlewis5flate11DictDecoder11write__mark(self, cnt) {
  self.wr_pos = self.wr_pos + cnt | 0;
}
function _M0MP27gmlewis5flate11DictDecoder12write__slice(self) {
  return _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(self.hist, self.wr_pos, undefined);
}
function _M0FP27gmlewis5flate8reverse8(x) {
  const _p$4 = _M0MPC15array5Array2atGjE(_M0FP27gmlewis5flate7rev8tab, x);
  return _p$4 & 255;
}
function _M0MP27gmlewis5flate12Decompressor9huff__sym(self, h) {
  let n = h.min;
  let nb = self.nb;
  let b = self.b;
  while (true) {
    while (true) {
      if (nb >>> 0 < n >>> 0) {
        const _tmp$38 = self.r;
        const _bind$4 = _tmp$38.method_table.method_1(_tmp$38.self);
        const _c = _bind$4._0;
        const _err = _bind$4._1;
        if (_err === undefined) {
        } else {
          const _Some = _err;
          const _e = _Some;
          self.b = b;
          self.nb = nb;
          return { _0: 0, _1: _M0FP27gmlewis5flate7no__eof(_e) };
        }
        self.roffset = BigInt.asUintN(64, self.roffset + 1n);
        b = b | _c << (nb & 31);
        nb = (nb >>> 0) + (8 >>> 0) | 0;
        continue;
      } else {
        break;
      }
    }
    let chunk = _M0MPC15array5Array2atGjE(h.chunks, b & 511);
    n = chunk & 15;
    if (n >>> 0 > 9 >>> 0) {
      chunk = _M0MPC15array5Array2atGjE(_M0MPC15array5Array2atGRPB5ArrayGsEE(h.links, chunk >>> 4 | 0), b >>> 9 & h.link_mask);
      n = chunk & 15;
    }
    if (n >>> 0 <= nb >>> 0) {
      if (n === 0) {
        self.b = b;
        self.nb = nb;
        self.err = _M0FP27gmlewis5flate21corrupt__input__error(self.roffset);
        return { _0: 0, _1: self.err };
      }
      self.b = b >>> (n & 31) | 0;
      self.nb = (nb >>> 0) - (n >>> 0) | 0;
      const v = chunk >>> 4 | 0;
      return { _0: v, _1: undefined };
    }
    continue;
  }
}
function _M0MP27gmlewis5flate12Decompressor10more__bits(self) {
  const _tmp$38 = self.r;
  const _bind$4 = _tmp$38.method_table.method_1(_tmp$38.self);
  const _c = _bind$4._0;
  const _err = _bind$4._1;
  if (_err === undefined) {
  } else {
    return _err;
  }
  self.roffset = BigInt.asUintN(64, self.roffset + 1n);
  self.b = self.b | _c << self.nb;
  self.nb = (self.nb >>> 0) + (8 >>> 0) | 0;
  return undefined;
}
function _M0MP27gmlewis5flate11DictDecoder10hist__size(self) {
  if (self.full) {
    const _p$4 = self.hist;
    return _p$4.len;
  }
  return self.wr_pos;
}
function _M0MP27gmlewis5flate11DictDecoder11write__byte(self, c) {
  _M0MP27gmlewis2io5Slice7op__setGyE(self.hist, self.wr_pos, c);
  self.wr_pos = self.wr_pos + 1 | 0;
}
function _M0MP27gmlewis5flate11DictDecoder16try__write__copy(self, dist, length) {
  let dst_pos = self.wr_pos;
  const end_pos = dst_pos + length | 0;
  let _tmp$38;
  if (dst_pos < dist) {
    _tmp$38 = true;
  } else {
    const _p$4 = self.hist;
    _tmp$38 = end_pos > _p$4.len;
  }
  if (_tmp$38) {
    return 0;
  }
  const dst_base = dst_pos;
  const src_pos = dst_pos - dist | 0;
  while (true) {
    if (dst_pos < end_pos) {
      dst_pos = dst_pos + _M0FP27gmlewis5flate11slice__copy(_M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(self.hist, dst_pos, end_pos), _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(self.hist, src_pos, dst_pos)) | 0;
      continue;
    } else {
      break;
    }
  }
  self.wr_pos = dst_pos;
  return dst_pos - dst_base | 0;
}
function _M0MP27gmlewis5flate11DictDecoder11write__copy(self, dist, length) {
  const dst_base = self.wr_pos;
  let dst_pos = dst_base;
  let src_pos = dst_pos - dist | 0;
  let end_pos = dst_pos + length | 0;
  const _tmp$38 = end_pos;
  const _p$4 = self.hist;
  if (_tmp$38 > _p$4.len) {
    const _p$5 = self.hist;
    end_pos = _p$5.len;
  }
  if (src_pos < 0) {
    const _tmp$39 = src_pos;
    const _p$5 = self.hist;
    src_pos = _tmp$39 + _p$5.len | 0;
    dst_pos = dst_pos + _M0FP27gmlewis5flate11slice__copy(_M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(self.hist, dst_pos, end_pos), _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(self.hist, src_pos, undefined)) | 0;
    src_pos = 0;
  }
  while (true) {
    if (dst_pos < end_pos) {
      dst_pos = dst_pos + _M0FP27gmlewis5flate11slice__copy(_M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(self.hist, dst_pos, end_pos), _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(self.hist, src_pos, dst_pos)) | 0;
      continue;
    } else {
      break;
    }
  }
  self.wr_pos = dst_pos;
  return dst_pos - dst_base | 0;
}
function _M0MP27gmlewis5flate12Decompressor13read__huffman(self) {
  while (true) {
    if (self.nb >>> 0 < 14 >>> 0) {
      const _bind$4 = _M0MP27gmlewis5flate12Decompressor10more__bits(self);
      if (_bind$4 === undefined) {
      } else {
        const _Some = _bind$4;
        const _err = _Some;
        return _err;
      }
      continue;
    } else {
      break;
    }
  }
  const nlit = (self.b & 31) + 257 | 0;
  if (nlit > 286) {
    return _M0FP27gmlewis5flate21corrupt__input__error(self.roffset);
  }
  self.b = self.b >>> 5 | 0;
  const ndist = (self.b & 31) + 1 | 0;
  if (ndist > 30) {
    return _M0FP27gmlewis5flate21corrupt__input__error(self.roffset);
  }
  self.b = self.b >>> 5 | 0;
  const nclen = (self.b & 15) + 4 | 0;
  self.b = self.b >>> 4 | 0;
  self.nb = (self.nb >>> 0) - (14 >>> 0) | 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < nclen) {
      while (true) {
        if (self.nb >>> 0 < 3 >>> 0) {
          const _bind$4 = _M0MP27gmlewis5flate12Decompressor10more__bits(self);
          if (_bind$4 === undefined) {
          } else {
            const _Some = _bind$4;
            const _err = _Some;
            return _err;
          }
          continue;
        } else {
          break;
        }
      }
      const _tmp$39 = self.codebits;
      $bound_check(_M0FP27gmlewis5flate11code__order, i);
      _M0MPC15array5Array3setGiE(_tmp$39, _M0FP27gmlewis5flate11code__order[i], self.b & 7);
      self.b = self.b >>> 3 | 0;
      self.nb = (self.nb >>> 0) - (3 >>> 0) | 0;
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let _tmp$39 = nclen;
  while (true) {
    const i = _tmp$39;
    if (i < _M0FP27gmlewis5flate11code__order.length) {
      const _tmp$40 = self.codebits;
      $bound_check(_M0FP27gmlewis5flate11code__order, i);
      _M0MPC15array5Array3setGiE(_tmp$40, _M0FP27gmlewis5flate11code__order[i], 0);
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (!_M0MP27gmlewis5flate14HuffmanDecoder10initialize(self.h1, _M0MP27gmlewis2io5Slice11new_2einnerGiE(self.codebits, 0, undefined))) {
    return _M0FP27gmlewis5flate21corrupt__input__error(self.roffset);
  }
  let i = 0;
  const n = nlit + ndist | 0;
  while (true) {
    if (i < n) {
      const _bind$4 = _M0MP27gmlewis5flate12Decompressor9huff__sym(self, self.h1);
      const _x = _bind$4._0;
      const _err = _bind$4._1;
      if (_err === undefined) {
      } else {
        const _Some = _err;
        const _e = _Some;
        return _e;
      }
      if (_x < 16) {
        _M0MPC15array5Array3setGiE(self.bits, i, _x);
        i = i + 1 | 0;
        continue;
      }
      let rep = 0;
      let nb = 0;
      let b = 0;
      switch (_x) {
        case 16: {
          rep = 3;
          nb = 2;
          if (i === 0) {
            return _M0FP27gmlewis5flate21corrupt__input__error(self.roffset);
          }
          b = _M0MPC15array5Array2atGiE(self.bits, i - 1 | 0);
          break;
        }
        case 17: {
          rep = 3;
          nb = 3;
          b = 0;
          break;
        }
        case 18: {
          rep = 11;
          nb = 7;
          b = 0;
          break;
        }
        default: {
          return _M0FP27gmlewis5flate15internal__error("unexpected length code");
        }
      }
      while (true) {
        if (self.nb >>> 0 < nb >>> 0) {
          const _bind$5 = _M0MP27gmlewis5flate12Decompressor10more__bits(self);
          if (_bind$5 === undefined) {
          } else {
            const _Some = _bind$5;
            const _err$2 = _Some;
            return _err$2;
          }
          continue;
        } else {
          break;
        }
      }
      const delta_rep = self.b & ((1 << nb) - 1 | 0);
      rep = rep + delta_rep | 0;
      self.b = self.b >>> nb | 0;
      self.nb = (self.nb >>> 0) - (nb >>> 0) | 0;
      if ((i + rep | 0) > n) {
        return _M0FP27gmlewis5flate21corrupt__input__error(self.roffset);
      }
      let _tmp$40 = 0;
      while (true) {
        const j = _tmp$40;
        if (j < rep) {
          _M0MPC15array5Array3setGiE(self.bits, i, b);
          i = i + 1 | 0;
          _tmp$40 = j + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      continue;
    } else {
      break;
    }
  }
  if (!_M0MP27gmlewis5flate14HuffmanDecoder10initialize(self.h1, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGiE(_M0MP27gmlewis2io5Slice11new_2einnerGiE(self.bits, 0, undefined), 0, nlit)) || !_M0MP27gmlewis5flate14HuffmanDecoder10initialize(self.h2, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGiE(_M0MP27gmlewis2io5Slice11new_2einnerGiE(self.bits, 0, undefined), nlit, nlit + ndist | 0))) {
    return _M0FP27gmlewis5flate21corrupt__input__error(self.roffset);
  }
  if (self.h1.min < _M0MPC15array5Array2atGiE(self.bits, 256)) {
    self.h1.min = _M0MPC15array5Array2atGiE(self.bits, 256);
  }
  return undefined;
}
function _M0MP27gmlewis5flate12Decompressor11next__block(self) {
  while (true) {
    if (self.nb >>> 0 < 3 >>> 0) {
      self.err = _M0MP27gmlewis5flate12Decompressor10more__bits(self);
      const _bind$4 = self.err;
      if (_bind$4 === undefined) {
      } else {
        return undefined;
      }
      continue;
    } else {
      break;
    }
  }
  self.final_flag = (self.b & 1) === 1;
  self.b = self.b >>> 1 | 0;
  const typ = self.b & 3;
  self.b = self.b >>> 2 | 0;
  self.nb = (self.nb >>> 0) - (3 >>> 0) | 0;
  switch (typ) {
    case 0: {
      _M0MP27gmlewis5flate12Decompressor11data__block(self);
      return;
    }
    case 1: {
      self.hl = _M0FP27gmlewis5flate23fixed__huffman__decoder;
      self.hd = undefined;
      _M0MP27gmlewis5flate12Decompressor14huffman__block(self);
      return;
    }
    case 2: {
      self.err = _M0MP27gmlewis5flate12Decompressor13read__huffman(self);
      const _bind$4 = self.err;
      if (_bind$4 === undefined) {
        self.hl = self.h1;
        self.hd = self.h2;
        _M0MP27gmlewis5flate12Decompressor14huffman__block(self);
        return;
      } else {
        return;
      }
    }
    default: {
      self.err = _M0FP27gmlewis5flate21corrupt__input__error(self.roffset);
      return;
    }
  }
}
function _M0MP27gmlewis5flate12Decompressor11data__block(self) {
  self.nb = 0;
  self.b = 0;
  const _bind$4 = _M0FP27gmlewis2io10read__full({ self: self.r, method_table: _M0FP056gmlewis_2fflate_2fReader_24as_24_40gmlewis_2fio_2eReader }, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(_M0MP27gmlewis2io5Slice11new_2einnerGyE(self.buf, 0, undefined), 0, _M0MP27gmlewis5flate12Decompressor11data__blockN6constrS1084));
  const _nr = _bind$4._0;
  const _err = _bind$4._1;
  self.roffset = BigInt.asUintN(64, self.roffset + BigInt.asUintN(64, BigInt(_nr)));
  if (_err === undefined) {
  } else {
    const _Some = _err;
    const _err$2 = _Some;
    self.err = _M0FP27gmlewis5flate7no__eof(_err$2);
    return undefined;
  }
  const n = _M0MPC15array5Array2atGyE(self.buf, 0) | _M0MPC15array5Array2atGyE(self.buf, 1) << 8;
  const nn = _M0MPC15array5Array2atGyE(self.buf, 2) | _M0MPC15array5Array2atGyE(self.buf, 3) << 8;
  if ((nn & 65535) !== (~n & 65535)) {
    self.err = _M0FP27gmlewis5flate21corrupt__input__error(self.roffset);
    return undefined;
  }
  if (n === 0) {
    self.to_read = _M0MP27gmlewis5flate11DictDecoder11read__flush(self.dict);
    _M0MP27gmlewis5flate12Decompressor13finish__block(self);
    return undefined;
  }
  self.copy_len = n;
  _M0MP27gmlewis5flate12Decompressor10copy__data(self);
}
function _M0MP27gmlewis5flate12Decompressor10copy__data(self) {
  let buf = _M0MP27gmlewis5flate11DictDecoder12write__slice(self.dict);
  const _p$4 = buf;
  if (_p$4.len > self.copy_len) {
    buf = _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(buf, 0, self.copy_len);
  }
  const _bind$4 = _M0FP27gmlewis2io10read__full({ self: self.r, method_table: _M0FP056gmlewis_2fflate_2fReader_24as_24_40gmlewis_2fio_2eReader }, buf);
  const _cnt = _bind$4._0;
  const _err = _bind$4._1;
  self.roffset = BigInt.asUintN(64, self.roffset + BigInt.asUintN(64, BigInt(_cnt)));
  self.copy_len = self.copy_len - _cnt | 0;
  _M0MP27gmlewis5flate11DictDecoder11write__mark(self.dict, _cnt);
  if (_err === undefined) {
  } else {
    const _Some = _err;
    const _err$2 = _Some;
    self.err = _M0FP27gmlewis5flate7no__eof(_err$2);
    return undefined;
  }
  if (_M0MP27gmlewis5flate11DictDecoder12avail__write(self.dict) === 0 || self.copy_len > 0) {
    self.to_read = _M0MP27gmlewis5flate11DictDecoder11read__flush(self.dict);
    self.step = _M0MP27gmlewis5flate12Decompressor10copy__data;
    return undefined;
  }
  _M0MP27gmlewis5flate12Decompressor13finish__block(self);
}
function _M0MP27gmlewis5flate12Decompressor13finish__block(self) {
  if (self.final_flag) {
    const _p$4 = self.dict;
    if ((_p$4.wr_pos - _p$4.rd_pos | 0) > 0) {
      self.to_read = _M0MP27gmlewis5flate11DictDecoder11read__flush(self.dict);
    }
    self.err = _M0FP27gmlewis2io3eof;
  }
  self.step = _M0MP27gmlewis5flate12Decompressor11next__block;
}
function _M0MP27gmlewis5flate12Decompressor14huffman__block(self) {
  const _bind$4 = self.step_state;
  if (_bind$4 === 0) {
    _M0MP27gmlewis5flate12Decompressor13read__literal(self);
    return;
  } else {
    _M0MP27gmlewis5flate12Decompressor13copy__history(self);
    return;
  }
}
function _M0MP27gmlewis5flate12Decompressor13copy__history(self) {
  let cnt = _M0MP27gmlewis5flate11DictDecoder16try__write__copy(self.dict, self.copy_dist, self.copy_len);
  if (cnt === 0) {
    cnt = _M0MP27gmlewis5flate11DictDecoder11write__copy(self.dict, self.copy_dist, self.copy_len);
  }
  self.copy_len = self.copy_len - cnt | 0;
  if (_M0MP27gmlewis5flate11DictDecoder12avail__write(self.dict) === 0 || self.copy_len > 0) {
    self.to_read = _M0MP27gmlewis5flate11DictDecoder11read__flush(self.dict);
    self.step = _M0MP27gmlewis5flate12Decompressor14huffman__block;
    self.step_state = 1;
    return undefined;
  }
  _M0MP27gmlewis5flate12Decompressor13read__literal(self);
}
function _M0MP27gmlewis5flate12Decompressor13read__literal(self) {
  while (true) {
    const _p$4 = self.hl;
    let _tmp$38;
    if (_p$4 === undefined) {
      _tmp$38 = $panic();
    } else {
      const _p$5 = _p$4;
      _tmp$38 = _p$5;
    }
    const _bind$4 = _M0MP27gmlewis5flate12Decompressor9huff__sym(self, _tmp$38);
    const _v = _bind$4._0;
    const _err = _bind$4._1;
    if (_err === undefined) {
    } else {
      const _Some = _err;
      const _err$2 = _Some;
      self.err = _err$2;
      return undefined;
    }
    let n = 0;
    let length = 0;
    if (_v < 256) {
      _M0MP27gmlewis5flate11DictDecoder11write__byte(self.dict, _v & 255);
      if (_M0MP27gmlewis5flate11DictDecoder12avail__write(self.dict) === 0) {
        self.to_read = _M0MP27gmlewis5flate11DictDecoder11read__flush(self.dict);
        self.step = _M0MP27gmlewis5flate12Decompressor14huffman__block;
        self.step_state = 0;
        return undefined;
      }
      continue;
    }
    if (_v === 256) {
      _M0MP27gmlewis5flate12Decompressor13finish__block(self);
      return undefined;
    }
    if (_v < 265) {
      length = _v - 254 | 0;
      n = 0;
    } else {
      if (_v < 269) {
        length = (Math.imul(_v, 2) | 0) - 519 | 0;
        n = 1;
      } else {
        if (_v < 273) {
          length = (Math.imul(_v, 4) | 0) - 1057 | 0;
          n = 2;
        } else {
          if (_v < 277) {
            length = (Math.imul(_v, 8) | 0) - 2149 | 0;
            n = 3;
          } else {
            if (_v < 281) {
              length = (Math.imul(_v, 16) | 0) - 4365 | 0;
              n = 4;
            } else {
              if (_v < 285) {
                length = (Math.imul(_v, 32) | 0) - 8861 | 0;
                n = 5;
              } else {
                if (_v < 286) {
                  length = 258;
                  n = 0;
                } else {
                  self.err = _M0FP27gmlewis5flate21corrupt__input__error(self.roffset);
                  return undefined;
                }
              }
            }
          }
        }
      }
    }
    if (n >>> 0 > 0 >>> 0) {
      while (true) {
        if (self.nb >>> 0 < n >>> 0) {
          self.err = _M0MP27gmlewis5flate12Decompressor10more__bits(self);
          const _bind$5 = self.err;
          if (_bind$5 === undefined) {
          } else {
            return undefined;
          }
          continue;
        } else {
          break;
        }
      }
      const mask = (1 << n >>> 0) - (1 >>> 0) | 0;
      length = length + (self.b & mask) | 0;
      self.b = self.b >>> n | 0;
      self.nb = (self.nb >>> 0) - (n >>> 0) | 0;
    }
    let dist = 0;
    const _bind$5 = self.hd;
    if (_bind$5 === undefined) {
      while (true) {
        if (self.nb >>> 0 < 5 >>> 0) {
          self.err = _M0MP27gmlewis5flate12Decompressor10more__bits(self);
          const _bind$6 = self.err;
          if (_bind$6 === undefined) {
          } else {
            return undefined;
          }
          continue;
        } else {
          break;
        }
      }
      const _p$5 = (self.b & 31) << 3;
      const to_rev = _p$5 & 255;
      dist = _M0FP27gmlewis5flate8reverse8(to_rev);
      self.b = self.b >>> 5 | 0;
      self.nb = (self.nb >>> 0) - (5 >>> 0) | 0;
    } else {
      const _Some = _bind$5;
      const _hd = _Some;
      const _bind$6 = _M0MP27gmlewis5flate12Decompressor9huff__sym(self, _hd);
      const _d = _bind$6._0;
      const _err$2 = _bind$6._1;
      dist = _d;
      if (_err$2 === undefined) {
      } else {
        const _Some$2 = _err$2;
        const _err$3 = _Some$2;
        self.err = _err$3;
        return undefined;
      }
    }
    if (dist < 4) {
      dist = dist + 1 | 0;
    } else {
      if (dist < 30) {
        const nb = (dist - 2 | 0) >>> 1 | 0;
        let extra = (dist & 1) << nb;
        while (true) {
          if (self.nb >>> 0 < nb >>> 0) {
            self.err = _M0MP27gmlewis5flate12Decompressor10more__bits(self);
            const _bind$6 = self.err;
            if (_bind$6 === undefined) {
            } else {
              return undefined;
            }
            continue;
          } else {
            break;
          }
        }
        const mask = (1 << nb >>> 0) - (1 >>> 0) | 0;
        extra = extra | self.b & mask;
        self.b = self.b >>> nb | 0;
        self.nb = (self.nb >>> 0) - (nb >>> 0) | 0;
        dist = ((1 << ((nb >>> 0) + (1 >>> 0) | 0)) + 1 | 0) + extra | 0;
      } else {
        self.err = _M0FP27gmlewis5flate21corrupt__input__error(self.roffset);
        return undefined;
      }
    }
    if (dist > _M0MP27gmlewis5flate11DictDecoder10hist__size(self.dict)) {
      self.err = _M0FP27gmlewis5flate21corrupt__input__error(self.roffset);
      return undefined;
    }
    self.copy_len = length;
    self.copy_dist = dist;
    _M0MP27gmlewis5flate12Decompressor13copy__history(self);
    return;
  }
}
function _M0MP27gmlewis5flate11DictDecoder3new(size, dict) {
  const dd = new _M0TP27gmlewis5flate11DictDecoder(_M0MP27gmlewis2io5Slice11new_2einnerGyE(_M0MPC15array5Array4makeGyE(size, 0), 0, undefined), 0, 0, false);
  let dict$2 = dict;
  const _p$4 = dict$2;
  if (_p$4.len > size) {
    const _tmp$38 = dict$2;
    const _p$5 = dict$2;
    dict$2 = _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(_tmp$38, _p$5.len - size | 0, undefined);
  }
  dd.wr_pos = _M0FP27gmlewis5flate11slice__copy(dd.hist, dict$2);
  if (dd.wr_pos === size) {
    dd.wr_pos = 0;
    dd.full = true;
  }
  dd.rd_pos = dd.wr_pos;
  return dd;
}
function _M0MP27gmlewis5flate12Decompressor3new(r, dict) {
  return new _M0TP27gmlewis5flate12Decompressor(r, 0n, 0, 0, _M0MP27gmlewis5flate14HuffmanDecoder3new(), _M0MP27gmlewis5flate14HuffmanDecoder3new(), _M0MPC15array5Array4makeGiE(316, 0), _M0MPC15array5Array4makeGiE(19, 0), _M0MP27gmlewis5flate11DictDecoder3new(32768, dict), [0, 0, 0, 0], _M0MP27gmlewis5flate12Decompressor11next__block, 0, false, undefined, _M0MP27gmlewis2io5Slice11new_2einnerGyE([], 0, undefined), undefined, undefined, 0, 0);
}
function _M0MP27gmlewis5flate6Reader3new(r) {
  return _M0MP27gmlewis5flate12Decompressor3new(r, _M0MP27gmlewis2io5Slice11new_2einnerGyE([], 0, undefined));
}
function _M0IP27gmlewis5flate12DecompressorP27gmlewis2io6Reader4read(self, b) {
  while (true) {
    const _p$4 = self.to_read;
    if (_p$4.len > 0) {
      const _p$5 = self.to_read;
      let n = _p$5.len;
      if (b.len < n) {
        n = b.len;
      }
      let _tmp$38 = 0;
      while (true) {
        const i = _tmp$38;
        if (i < n) {
          _M0MP27gmlewis2io5Slice7op__setGyE(b, i, _M0MP27gmlewis2io5Slice7op__getGyE(self.to_read, i));
          _tmp$38 = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      self.to_read = _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(self.to_read, n, undefined);
      const _p$6 = self.to_read;
      if (_p$6.len === 0) {
        return { _0: n, _1: self.err };
      }
      return { _0: n, _1: undefined };
    }
    const _bind$4 = self.err;
    if (_bind$4 === undefined) {
    } else {
      return { _0: 0, _1: self.err };
    }
    const _func = self.step;
    _func(self);
    let _tmp$38;
    if (_M0IP016_24default__implPB2Eq10not__equalGORP27gmlewis2io7IOErrorE(undefined, self.err)) {
      const _p$5 = self.to_read;
      _tmp$38 = _p$5.len === 0;
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      self.to_read = _M0MP27gmlewis5flate11DictDecoder11read__flush(self.dict);
    }
    continue;
  }
}
function _M0IP27gmlewis5flate12DecompressorP27gmlewis2io6Closer5close(self) {
  if (_M0IPC16option6OptionPB2Eq5equalGRP27gmlewis2io7IOErrorE(_M0FP27gmlewis2io3eof, self.err)) {
    return undefined;
  }
  return self.err;
}
function _M0MP27gmlewis5crc326Digest3new() {
  return new _M0TP27gmlewis5crc326Digest(~0, "crc32");
}
function _M0IP27gmlewis5crc326DigestP27gmlewis5crc328HashFunc5write(self, b) {
  const _p$4 = self.crc;
  const _p$5 = _p$4 & 255;
  const _p$6 = 255;
  const _p$7 = _p$5 & _p$6 & 255;
  const _tmp$38 = (_p$7 ^ b) & 255;
  $bound_check(_M0FP27gmlewis5crc325table, _tmp$38);
  self.crc = _M0FP27gmlewis5crc325table[_tmp$38] ^ (self.crc >>> 8 | 0);
}
function _M0FP311moonbitlang1x4time17check__leap__year(year) {
  return (year % 4 | 0) === 0 && (year % 100 | 0) !== 0 || (year % 400 | 0) === 0;
}
function _M0FP311moonbitlang1x4time21date__to__fixed__days(year, month, day) {
  let days = 0n;
  const y = BigInt.asUintN(64, BigInt(year));
  days = BigInt.asUintN(64, days + BigInt.asUintN(64, 365n * y));
  if (BigInt.asIntN(64, y) > BigInt.asIntN(64, 0n)) {
    const _tmp$38 = days;
    if (4n === 0n) {
      $panic();
    }
    const _tmp$39 = BigInt.asUintN(64, BigInt.asIntN(64, BigInt.asUintN(64, y + 3n)) / BigInt.asIntN(64, 4n));
    if (100n === 0n) {
      $panic();
    }
    const _tmp$40 = BigInt.asUintN(64, _tmp$39 - BigInt.asUintN(64, BigInt.asIntN(64, BigInt.asUintN(64, y + 99n)) / BigInt.asIntN(64, 100n)));
    if (400n === 0n) {
      $panic();
    }
    days = BigInt.asUintN(64, _tmp$38 + BigInt.asUintN(64, _tmp$40 + BigInt.asUintN(64, BigInt.asIntN(64, BigInt.asUintN(64, y + 399n)) / BigInt.asIntN(64, 400n))));
  } else {
    const _tmp$38 = days;
    if (4n === 0n) {
      $panic();
    }
    const _tmp$39 = BigInt.asUintN(64, BigInt.asIntN(64, y) / BigInt.asIntN(64, 4n));
    if (100n === 0n) {
      $panic();
    }
    const _tmp$40 = BigInt.asUintN(64, _tmp$39 - BigInt.asUintN(64, BigInt.asIntN(64, y) / BigInt.asIntN(64, 100n)));
    if (400n === 0n) {
      $panic();
    }
    days = BigInt.asUintN(64, _tmp$38 + BigInt.asUintN(64, _tmp$40 + BigInt.asUintN(64, BigInt.asIntN(64, y) / BigInt.asIntN(64, 400n))));
  }
  const _tmp$38 = days;
  if (12n === 0n) {
    $panic();
  }
  days = BigInt.asUintN(64, _tmp$38 + BigInt.asUintN(64, BigInt.asIntN(64, BigInt.asUintN(64, BigInt.asUintN(64, 367n * BigInt.asUintN(64, BigInt(month))) - 362n)) / BigInt.asIntN(64, 12n)));
  if (month > 2) {
    days = BigInt.asUintN(64, days + (_M0FP311moonbitlang1x4time17check__leap__year(year) ? 18446744073709551615n : 18446744073709551614n));
  }
  days = BigInt.asUintN(64, days + BigInt.asUintN(64, BigInt.asUintN(64, BigInt(day)) - 1n));
  return days;
}
function _M0MP311moonbitlang1x4time9PlainDate13to__unix__day(self) {
  const days = _M0FP311moonbitlang1x4time21date__to__fixed__days(self.year, self.month, self.day);
  return BigInt.asUintN(64, days - _M0FP311moonbitlang1x4time33days__zero__year__to__unix__epoch);
}
function _M0MP311moonbitlang1x4time9PlainTime15second__of__day(self) {
  return ((Math.imul(self.hour, Number(BigInt.asIntN(32, _M0FP311moonbitlang1x4time18seconds__per__hour)) | 0) | 0) + (Math.imul(self.minute, Number(BigInt.asIntN(32, _M0FP311moonbitlang1x4time20seconds__per__minute)) | 0) | 0) | 0) + self.second | 0;
}
function _M0MP311moonbitlang1x4time13PlainDateTime16to__unix__second(self) {
  return BigInt.asUintN(64, BigInt.asUintN(64, _M0MP311moonbitlang1x4time9PlainDate13to__unix__day(self.date) * _M0FP311moonbitlang1x4time17seconds__per__day) + BigInt.asUintN(64, BigInt(_M0MP311moonbitlang1x4time9PlainTime15second__of__day(self.time))));
}
function _M0MP311moonbitlang1x4time4Zone14lookup__offset(self, secs) {
  if (self.offsets.length === 0) {
    return _M0FP311moonbitlang1x4time11utc__offset;
  }
  if (self.offsets.length === 1) {
    return _M0MPC15array5Array2atGUssEE(self.offsets, 0);
  }
  let last_offset = 0;
  const _bind$4 = self.transitions.length;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < _bind$4) {
      const _bind$5 = _M0MPC15array5Array2atGUssEE(self.transitions, i);
      const _timestamp = _bind$5._0;
      const _offset_index = _bind$5._1;
      if (BigInt.asIntN(64, _timestamp) <= BigInt.asIntN(64, secs)) {
        last_offset = _offset_index;
      } else {
        break;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MPC15array5Array2atGUssEE(self.offsets, last_offset);
}
function _M0FP311moonbitlang1x4time19create__from__plain(datetime, zone) {
  const offset = _M0MP311moonbitlang1x4time4Zone14lookup__offset(zone, _M0MP311moonbitlang1x4time13PlainDateTime16to__unix__second(datetime));
  return new _M0TP311moonbitlang1x4time13ZonedDateTime(datetime, zone, offset);
}
function _M0FP311moonbitlang1x4time21calc__days__in__month(year, month) {
  const leap = _M0FP311moonbitlang1x4time17check__leap__year(year);
  switch (month) {
    case 2: {
      return leap ? 29 : 28;
    }
    case 1: {
      return 31;
    }
    case 3: {
      return 31;
    }
    case 5: {
      return 31;
    }
    case 7: {
      return 31;
    }
    case 8: {
      return 31;
    }
    case 10: {
      return 31;
    }
    case 12: {
      return 31;
    }
    default: {
      return 30;
    }
  }
}
function _M0FP311moonbitlang1x4time13validate__day(year, month, day) {
  return day >= 1 && (day <= 31 && day <= _M0FP311moonbitlang1x4time21calc__days__in__month(year, month));
}
function _M0FP311moonbitlang1x4time13validate__ymd(year, month, day) {
  return year >= -9999 && year <= 9999 && (month >= 1 && month <= 12 && _M0FP311moonbitlang1x4time13validate__day(year, month, day));
}
function _M0MP311moonbitlang1x4time9PlainDate2of(year, month, day) {
  if (!_M0FP311moonbitlang1x4time13validate__ymd(year, month, day)) {
    const _bind$4 = _M0FPB4failGuE(new _M0TPC16string10StringView(_M0FP311moonbitlang1x4time18invalid__date__err, 0, _M0FP311moonbitlang1x4time18invalid__date__err.length), "time/plain_date.mbt:31:5-31:27@moonbitlang/x");
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _ok._0;
    } else {
      return _bind$4;
    }
  }
  return new _M0DTPC16result6ResultGRP311moonbitlang1x4time9PlainDateRPC15error5ErrorE2Ok(new _M0TP311moonbitlang1x4time9PlainDate(year, month, day));
}
function _M0FP311moonbitlang1x4time14validate__time(h, m, s, ns) {
  const valid_hour = h >= 0 && h <= 23;
  const valid_minute = m >= 0 && m <= 59;
  const valid_second = s >= 0 && s <= 59;
  const valid_nano = ns >= 0 && ns <= 999999999;
  const zero = h === 24 && (m === 0 && (s === 0 && ns === 0));
  return valid_hour && (valid_minute && (valid_second && valid_nano)) || zero;
}
function _M0MP311moonbitlang1x4time9PlainTime2of(hour, minute, second, nanosecond) {
  return _M0FP311moonbitlang1x4time14validate__time(hour, minute, second, nanosecond) ? new _M0DTPC16result6ResultGRP311moonbitlang1x4time9PlainTimeRPC15error5ErrorE2Ok(new _M0TP311moonbitlang1x4time9PlainTime(hour, minute, second, nanosecond)) : _M0FPB4failGRP311moonbitlang1x4time9PlainDateE(new _M0TPC16string10StringView(_M0FP311moonbitlang1x4time18invalid__time__err, 0, _M0FP311moonbitlang1x4time18invalid__time__err.length), "time/plain_time.mbt:35:5-35:27@moonbitlang/x");
}
function _M0MP311moonbitlang1x4time13PlainDateTime10of_2einner(year, month, day, hour, minute, second, nanosecond) {
  const _bind$4 = _M0MP311moonbitlang1x4time9PlainDate2of(year, month, day);
  let _tmp$38;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _tmp$38 = _ok._0;
  } else {
    return _bind$4;
  }
  const _tmp$39 = _tmp$38;
  const _bind$5 = _M0MP311moonbitlang1x4time9PlainTime2of(hour, minute, second, nanosecond);
  let _tmp$40;
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    _tmp$40 = _ok._0;
  } else {
    return _bind$5;
  }
  return new _M0DTPC16result6ResultGRP311moonbitlang1x4time13PlainDateTimeRPC15error5ErrorE2Ok(new _M0TP311moonbitlang1x4time13PlainDateTime(_tmp$39, _tmp$40));
}
function _M0FP311moonbitlang1x4time5floor(x) {
  if (x > _M0FPB18double__max__value || (x < _M0FPB18double__min__value || x !== x)) {
    return x;
  }
  const n = $i64_trunc_f64(x);
  const d = $f64_convert_i64(BigInt.asIntN(64, n));
  return x >= 0 || x === d ? d : d - 1;
}
function _M0FP311moonbitlang1x4time17floor__div__int64(x, y) {
  if (BigInt.asUintN(64, y) === BigInt.asUintN(64, 0n)) {
    const _bind$4 = _M0FPB4failGuE(new _M0TPC16string10StringView(_M0FP311moonbitlang1x4time17floor__div__int64N7_2abindS809, 0, _M0FP311moonbitlang1x4time17floor__div__int64N7_2abindS809.length), "time/util.mbt:331:5-331:29@moonbitlang/x");
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _ok._0;
    } else {
      return _bind$4;
    }
  }
  const r = $f64_convert_i64(BigInt.asIntN(64, x)) / $f64_convert_i64(BigInt.asIntN(64, y));
  return new _M0DTPC16result6ResultGlRPC15error5ErrorE2Ok($i64_trunc_f64(_M0FP311moonbitlang1x4time5floor(r)));
}
function _M0FP311moonbitlang1x4time17floor__mod__int64(x, y) {
  const _bind$4 = _M0FP311moonbitlang1x4time17floor__div__int64(x, y);
  let _tmp$38;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _tmp$38 = _ok._0;
  } else {
    return _bind$4;
  }
  return new _M0DTPC16result6ResultGlRPC15error5ErrorE2Ok(BigInt.asUintN(64, x - BigInt.asUintN(64, _tmp$38 * y)));
}
function _M0FP311moonbitlang1x4time20cycle__to__year__ord(cycle) {
  let year = cycle / 365 | 0;
  let ordinal0 = cycle % 365 | 0;
  const _p$4 = year;
  $bound_check(_M0FP311moonbitlang1x4time12year__deltas, _p$4);
  const delta = _M0FP311moonbitlang1x4time12year__deltas[_p$4];
  if (ordinal0 < delta) {
    year = year - 1 | 0;
    const _tmp$38 = ordinal0;
    const _p$5 = year;
    $bound_check(_M0FP311moonbitlang1x4time12year__deltas, _p$5);
    ordinal0 = _tmp$38 + (365 - _M0FP311moonbitlang1x4time12year__deltas[_p$5] | 0) | 0;
  } else {
    ordinal0 = ordinal0 - delta | 0;
  }
  return { _0: year, _1: ordinal0 + 1 | 0 };
}
function _M0FP311moonbitlang1x4time26fixed__days__to__year__ord(days) {
  let d0 = days;
  let year_offset = 0;
  if (BigInt.asIntN(64, d0) < BigInt.asIntN(64, 0n)) {
    if (_M0FP311moonbitlang1x4time21days__per__400__years === 0n) {
      $panic();
    }
    const cycles = BigInt.asUintN(64, BigInt.asUintN(64, BigInt.asIntN(64, days) / BigInt.asIntN(64, _M0FP311moonbitlang1x4time21days__per__400__years)) - 1n);
    year_offset = Math.imul(Number(BigInt.asIntN(32, cycles)) | 0, 400) | 0;
    d0 = BigInt.asUintN(64, d0 - BigInt.asUintN(64, cycles * _M0FP311moonbitlang1x4time21days__per__400__years));
  }
  if (_M0FP311moonbitlang1x4time21days__per__400__years === 0n) {
    $panic();
  }
  const n400 = BigInt.asUintN(64, BigInt.asIntN(64, d0) / BigInt.asIntN(64, _M0FP311moonbitlang1x4time21days__per__400__years));
  if (_M0FP311moonbitlang1x4time21days__per__400__years === 0n) {
    $panic();
  }
  const cycle = BigInt.asUintN(64, BigInt.asIntN(64, d0) % BigInt.asIntN(64, _M0FP311moonbitlang1x4time21days__per__400__years));
  const _bind$4 = _M0FP311moonbitlang1x4time20cycle__to__year__ord(Number(BigInt.asIntN(32, cycle)) | 0);
  const _y = _bind$4._0;
  const _ord = _bind$4._1;
  const year = (_y + (Math.imul(Number(BigInt.asIntN(32, n400)) | 0, 400) | 0) | 0) + year_offset | 0;
  return { _0: year, _1: _ord };
}
function _M0FP311moonbitlang1x4time20calc__days__in__year(year) {
  return _M0FP311moonbitlang1x4time17check__leap__year(year) ? 366 : 365;
}
function _M0FP311moonbitlang1x4time17validate__ordinal(year, ordinal) {
  return ordinal >= 1 && (ordinal <= 366 && ordinal <= _M0FP311moonbitlang1x4time20calc__days__in__year(year));
}
function _M0MP311moonbitlang1x4time9PlainDate15from__year__ord(year, ordinal) {
  const valid = year >= -9999 && year <= 9999 && _M0FP311moonbitlang1x4time17validate__ordinal(year, ordinal);
  if (!valid) {
    const _bind$4 = _M0FPB4failGuE(new _M0TPC16string10StringView(_M0FP311moonbitlang1x4time18invalid__date__err, 0, _M0FP311moonbitlang1x4time18invalid__date__err.length), "time/plain_date.mbt:44:5-44:27@moonbitlang/x");
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _ok._0;
    } else {
      return _bind$4;
    }
  }
  let month = 1;
  let day = ordinal;
  while (true) {
    if (_M0FP311moonbitlang1x4time21calc__days__in__month(year, month) < day) {
      day = day - _M0FP311moonbitlang1x4time21calc__days__in__month(year, month) | 0;
      month = month + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGRP311moonbitlang1x4time9PlainDateRPC15error5ErrorE2Ok(new _M0TP311moonbitlang1x4time9PlainDate(year, month, day));
}
function _M0MP311moonbitlang1x4time9PlainDate15from__unix__day(unix_day) {
  const _bind$4 = _M0FP311moonbitlang1x4time26fixed__days__to__year__ord(BigInt.asUintN(64, unix_day + _M0FP311moonbitlang1x4time33days__zero__year__to__unix__epoch));
  const _year = _bind$4._0;
  const _ord = _bind$4._1;
  return _M0MP311moonbitlang1x4time9PlainDate15from__year__ord(_year, _ord);
}
function _M0MP311moonbitlang1x4time9PlainTime25from__nanosecond__of__day(nanosecond) {
  if (BigInt.asIntN(64, nanosecond) < BigInt.asIntN(64, 0n) || BigInt.asIntN(64, nanosecond) > BigInt.asIntN(64, _M0FP311moonbitlang1x4time21nanoseconds__per__day)) {
    const _bind$4 = _M0FPB4failGuE(new _M0TPC16string10StringView(_M0FP311moonbitlang1x4time18invalid__time__err, 0, _M0FP311moonbitlang1x4time18invalid__time__err.length), "time/plain_time.mbt:158:5-158:27@moonbitlang/x");
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _ok._0;
    } else {
      return _bind$4;
    }
  }
  let nanos = nanosecond;
  if (_M0FP311moonbitlang1x4time22nanoseconds__per__hour === 0n) {
    $panic();
  }
  const hour = BigInt.asUintN(64, BigInt.asIntN(64, nanos) / BigInt.asIntN(64, _M0FP311moonbitlang1x4time22nanoseconds__per__hour));
  nanos = BigInt.asUintN(64, nanos - BigInt.asUintN(64, hour * _M0FP311moonbitlang1x4time22nanoseconds__per__hour));
  if (_M0FP311moonbitlang1x4time24nanoseconds__per__minute === 0n) {
    $panic();
  }
  const minute = BigInt.asUintN(64, BigInt.asIntN(64, nanos) / BigInt.asIntN(64, _M0FP311moonbitlang1x4time24nanoseconds__per__minute));
  nanos = BigInt.asUintN(64, nanos - BigInt.asUintN(64, minute * _M0FP311moonbitlang1x4time24nanoseconds__per__minute));
  if (_M0FP311moonbitlang1x4time24nanoseconds__per__second === 0n) {
    $panic();
  }
  const second = BigInt.asUintN(64, BigInt.asIntN(64, nanos) / BigInt.asIntN(64, _M0FP311moonbitlang1x4time24nanoseconds__per__second));
  nanos = BigInt.asUintN(64, nanos - BigInt.asUintN(64, second * _M0FP311moonbitlang1x4time24nanoseconds__per__second));
  return _M0MP311moonbitlang1x4time9PlainTime2of(Number(BigInt.asIntN(32, hour)) | 0, Number(BigInt.asIntN(32, minute)) | 0, Number(BigInt.asIntN(32, second)) | 0, Number(BigInt.asIntN(32, nanos)) | 0);
}
function _M0MP311moonbitlang1x4time13PlainDateTime18from__unix__second(second, nanosecond, offset) {
  if (!(nanosecond >= 0 && nanosecond <= 999999999)) {
    const _bind$4 = _M0FPB4failGuE(new _M0TPC16string10StringView(_M0FP311moonbitlang1x4time24invalid__date__time__err, 0, _M0FP311moonbitlang1x4time24invalid__date__time__err.length), "time/plain_date_time.mbt:47:5-47:32@moonbitlang/x");
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _ok._0;
    } else {
      return _bind$4;
    }
  }
  const sec = BigInt.asUintN(64, second + BigInt.asUintN(64, BigInt(offset.seconds)));
  const _bind$4 = _M0FP311moonbitlang1x4time17floor__div__int64(sec, _M0FP311moonbitlang1x4time17seconds__per__day);
  let unix_day;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    unix_day = _ok._0;
  } else {
    return _bind$4;
  }
  const _bind$5 = _M0FP311moonbitlang1x4time17floor__mod__int64(sec, _M0FP311moonbitlang1x4time17seconds__per__day);
  let seconds_of_day;
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    seconds_of_day = _ok._0;
  } else {
    return _bind$5;
  }
  const _bind$6 = _M0MP311moonbitlang1x4time9PlainDate15from__unix__day(unix_day);
  let date;
  if (_bind$6.$tag === 1) {
    const _ok = _bind$6;
    date = _ok._0;
  } else {
    return _bind$6;
  }
  const _bind$7 = _M0MP311moonbitlang1x4time9PlainTime25from__nanosecond__of__day(BigInt.asUintN(64, BigInt.asUintN(64, seconds_of_day * _M0FP311moonbitlang1x4time24nanoseconds__per__second) + BigInt.asUintN(64, BigInt(nanosecond))));
  let time;
  if (_bind$7.$tag === 1) {
    const _ok = _bind$7;
    time = _ok._0;
  } else {
    return _bind$7;
  }
  return new _M0DTPC16result6ResultGRP311moonbitlang1x4time13PlainDateTimeRPC15error5ErrorE2Ok(new _M0TP311moonbitlang1x4time13PlainDateTime(date, time));
}
function _M0MP311moonbitlang1x4time13ZonedDateTime26from__unix__second_2einner(second, nanosecond, zone) {
  const offset = _M0MP311moonbitlang1x4time4Zone14lookup__offset(zone, second);
  const _bind$4 = _M0MP311moonbitlang1x4time13PlainDateTime18from__unix__second(second, nanosecond, offset);
  let datetime;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    datetime = _ok._0;
  } else {
    return _bind$4;
  }
  return new _M0DTPC16result6ResultGRP311moonbitlang1x4time13ZonedDateTimeRPC15error5ErrorE2Ok(new _M0TP311moonbitlang1x4time13ZonedDateTime(datetime, zone, offset));
}
function _M0FP311moonbitlang1x4time12unix_2einner(second, nanosecond, zone) {
  return _M0MP311moonbitlang1x4time13ZonedDateTime26from__unix__second_2einner(second, nanosecond, zone);
}
function _M0MP311moonbitlang1x4time13ZonedDateTime29from__plain__datetime_2einner(datetime, zone) {
  return _M0FP311moonbitlang1x4time19create__from__plain(datetime, zone);
}
function _M0MP311moonbitlang1x4time13ZonedDateTime16to__unix__second(self) {
  const _tmp$38 = _M0MP311moonbitlang1x4time13PlainDateTime16to__unix__second(self.datetime);
  const _p$4 = self.offset;
  return BigInt.asUintN(64, _tmp$38 - BigInt.asUintN(64, BigInt(_p$4.seconds)));
}
function _M0MP311moonbitlang1x4time13PlainDateTime4year(self) {
  const _p$4 = self.date;
  return _p$4.year;
}
function _M0MP311moonbitlang1x4time13ZonedDateTime4year(self) {
  return _M0MP311moonbitlang1x4time13PlainDateTime4year(self.datetime);
}
function _M0MP311moonbitlang1x4time13PlainDateTime5month(self) {
  const _p$4 = self.date;
  return _p$4.month;
}
function _M0MP311moonbitlang1x4time13ZonedDateTime5month(self) {
  return _M0MP311moonbitlang1x4time13PlainDateTime5month(self.datetime);
}
function _M0MP311moonbitlang1x4time13PlainDateTime3day(self) {
  const _p$4 = self.date;
  return _p$4.day;
}
function _M0MP311moonbitlang1x4time13ZonedDateTime3day(self) {
  return _M0MP311moonbitlang1x4time13PlainDateTime3day(self.datetime);
}
function _M0MP311moonbitlang1x4time7Weekday3new(week_day) {
  switch (week_day) {
    case 1: {
      return _M0MP311moonbitlang1x4time7Weekday3newN6constrS1242;
    }
    case 2: {
      return _M0MP311moonbitlang1x4time7Weekday3newN6constrS1243;
    }
    case 3: {
      return _M0MP311moonbitlang1x4time7Weekday3newN6constrS1244;
    }
    case 4: {
      return _M0MP311moonbitlang1x4time7Weekday3newN6constrS1245;
    }
    case 5: {
      return _M0MP311moonbitlang1x4time7Weekday3newN6constrS1246;
    }
    case 6: {
      return _M0MP311moonbitlang1x4time7Weekday3newN6constrS1247;
    }
    case 7: {
      return _M0MP311moonbitlang1x4time7Weekday3newN6constrS1248;
    }
    default: {
      return undefined;
    }
  }
}
function _M0MP311moonbitlang1x4time9PlainDate7weekday(self) {
  let y = self.year;
  let m = self.month;
  const q = self.day;
  if (m < 3) {
    m = m + 12 | 0;
    y = y - 1 | 0;
  }
  const k = y % 100 | 0;
  const j = y / 100 | 0;
  const h = (((((q + ((Math.imul(13, m + 1 | 0) | 0) / 5 | 0) | 0) + k | 0) + (k / 4 | 0) | 0) + (j / 4 | 0) | 0) + (Math.imul(5, j) | 0) | 0) % 7 | 0;
  const week_day = ((h + 5 | 0) % 7 | 0) + 1 | 0;
  const _p$4 = _M0MP311moonbitlang1x4time7Weekday3new(week_day);
  if (_p$4 === undefined) {
    return $panic();
  } else {
    const _p$5 = _p$4;
    return _p$5;
  }
}
function _M0MP311moonbitlang1x4time13PlainDateTime7weekday(self) {
  return _M0MP311moonbitlang1x4time9PlainDate7weekday(self.date);
}
function _M0MP311moonbitlang1x4time13ZonedDateTime7weekday(self) {
  return _M0MP311moonbitlang1x4time13PlainDateTime7weekday(self.datetime);
}
function _M0MP311moonbitlang1x4time9PlainDate7ordinal(self) {
  const days = _M0FP311moonbitlang1x4time21date__to__fixed__days(self.year, self.month, self.day);
  const _bind$4 = _M0FP311moonbitlang1x4time26fixed__days__to__year__ord(days);
  return _bind$4._1;
}
function _M0MP311moonbitlang1x4time13PlainDateTime7ordinal(self) {
  return _M0MP311moonbitlang1x4time9PlainDate7ordinal(self.date);
}
function _M0MP311moonbitlang1x4time13PlainDateTime4hour(self) {
  const _p$4 = self.time;
  return _p$4.hour;
}
function _M0MP311moonbitlang1x4time13ZonedDateTime4hour(self) {
  return _M0MP311moonbitlang1x4time13PlainDateTime4hour(self.datetime);
}
function _M0MP311moonbitlang1x4time13PlainDateTime6minute(self) {
  const _p$4 = self.time;
  return _p$4.minute;
}
function _M0MP311moonbitlang1x4time13ZonedDateTime6minute(self) {
  return _M0MP311moonbitlang1x4time13PlainDateTime6minute(self.datetime);
}
function _M0MP311moonbitlang1x4time13PlainDateTime6second(self) {
  const _p$4 = self.time;
  return _p$4.second;
}
function _M0MP311moonbitlang1x4time13ZonedDateTime6second(self) {
  return _M0MP311moonbitlang1x4time13PlainDateTime6second(self.datetime);
}
function _M0FP311moonbitlang1x4time17add__suffix__zero(s, len) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(len);
  _M0IPB13StringBuilderPB6Logger13write__string(buf, s);
  let _tmp$38 = s.length;
  while (true) {
    const i = _tmp$38;
    if (i < len) {
      _M0IPB13StringBuilderPB6Logger11write__char(buf, 48);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function _M0FP311moonbitlang1x4time5split(s, delimiter) {
  const spl = [];
  if (s.length === 0) {
    return spl;
  }
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const delimiter_code = delimiter & 65535;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const code_unit = s.charCodeAt(i);
      if (code_unit === delimiter_code) {
        _M0MPC15array5Array4pushGUssEE(spl, buf.val);
        _M0MPB13StringBuilder5reset(buf);
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, code_unit);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MPC15array5Array4pushGUssEE(spl, buf.val);
  return spl;
}
function _M0MP311moonbitlang1x4time9PlainTime12from__string(str) {
  const _bind$4 = new _M0TPC16string10StringView(str, 0, str.length);
  const _data = _bind$4.str;
  const _start = _bind$4.start;
  const _end = _start + (_bind$4.end - _bind$4.start | 0) | 0;
  let _cursor = _start;
  let accept_state = -1;
  let match_end = -1;
  let match_tag_saver_0 = -1;
  let tag_0 = -1;
  let _bind$5;
  _L: {
    _L$2: {
      _L$3: {
        _L$4: {
          if ((_cursor + 4 | 0) < _end) {
            const _p$4 = _cursor;
            const next_char = _data.charCodeAt(_p$4);
            _cursor = _cursor + 1 | 0;
            if (next_char >= 48 && next_char <= 57) {
              const _p$5 = _cursor;
              const next_char$2 = _data.charCodeAt(_p$5);
              _cursor = _cursor + 1 | 0;
              if (next_char$2 >= 48 && next_char$2 <= 57) {
                const _p$6 = _cursor;
                if (_data.charCodeAt(_p$6) === 58) {
                  _cursor = _cursor + 1 | 0;
                  const _p$7 = _cursor;
                  const next_char$3 = _data.charCodeAt(_p$7);
                  _cursor = _cursor + 1 | 0;
                  if (next_char$3 >= 48 && next_char$3 <= 57) {
                    const _p$8 = _cursor;
                    const next_char$4 = _data.charCodeAt(_p$8);
                    _cursor = _cursor + 1 | 0;
                    if (next_char$4 >= 48 && next_char$4 <= 57) {
                      if (_cursor < _end) {
                        const _p$9 = _cursor;
                        const next_char$5 = _data.charCodeAt(_p$9);
                        _cursor = _cursor + 1 | 0;
                        if (next_char$5 === 58) {
                          if ((_cursor + 1 | 0) < _end) {
                            const _p$10 = _cursor;
                            const next_char$6 = _data.charCodeAt(_p$10);
                            _cursor = _cursor + 1 | 0;
                            if (next_char$6 >= 48 && next_char$6 <= 57) {
                              const _p$11 = _cursor;
                              const next_char$7 = _data.charCodeAt(_p$11);
                              _cursor = _cursor + 1 | 0;
                              if (next_char$7 >= 48 && next_char$7 <= 57) {
                                if (_cursor < _end) {
                                  const _p$12 = _cursor;
                                  const next_char$8 = _data.charCodeAt(_p$12);
                                  _cursor = _cursor + 1 | 0;
                                  if (next_char$8 < 56319) {
                                    if (next_char$8 < 55296) {
                                      break _L$4;
                                    } else {
                                      tag_0 = _cursor;
                                      if (_cursor < _end) {
                                        const _p$13 = _cursor;
                                        const next_char$9 = _data.charCodeAt(_p$13);
                                        _cursor = _cursor + 1 | 0;
                                        if (next_char$9 < 58) {
                                          if (next_char$9 < 48) {
                                            break _L;
                                          } else {
                                            break _L$3;
                                          }
                                        } else {
                                          if (next_char$9 > 56319) {
                                            break _L$4;
                                          } else {
                                            break _L;
                                          }
                                        }
                                      } else {
                                        break _L;
                                      }
                                    }
                                  } else {
                                    if (next_char$8 > 56319) {
                                      break _L$4;
                                    } else {
                                      tag_0 = _cursor;
                                      if (_cursor < _end) {
                                        const _p$13 = _cursor;
                                        const next_char$9 = _data.charCodeAt(_p$13);
                                        _cursor = _cursor + 1 | 0;
                                        if (next_char$9 < 58) {
                                          if (next_char$9 < 48) {
                                            break _L;
                                          } else {
                                            break _L$3;
                                          }
                                        } else {
                                          if (next_char$9 > 56319) {
                                            if (next_char$9 < 57344) {
                                              break _L$4;
                                            } else {
                                              break _L;
                                            }
                                          } else {
                                            break _L;
                                          }
                                        }
                                      } else {
                                        break _L;
                                      }
                                    }
                                  }
                                } else {
                                  accept_state = 1;
                                  match_end = _cursor;
                                  break _L;
                                }
                              } else {
                                break _L;
                              }
                            } else {
                              break _L;
                            }
                          } else {
                            break _L;
                          }
                        } else {
                          break _L;
                        }
                      } else {
                        accept_state = 0;
                        match_end = _cursor;
                        break _L;
                      }
                    } else {
                      break _L;
                    }
                  } else {
                    break _L;
                  }
                } else {
                  break _L;
                }
              } else {
                break _L;
              }
            } else {
              break _L;
            }
          } else {
            break _L;
          }
        }
        tag_0 = _cursor;
        if (_cursor < _end) {
          const _p$4 = _cursor;
          const next_char = _data.charCodeAt(_p$4);
          _cursor = _cursor + 1 | 0;
          if (next_char >= 48 && next_char <= 57) {
            break _L$3;
          } else {
            break _L;
          }
        } else {
          break _L;
        }
      }
      if (_cursor < _end) {
        const _p$4 = _cursor;
        const next_char = _data.charCodeAt(_p$4);
        _cursor = _cursor + 1 | 0;
        if (next_char >= 48 && next_char <= 57) {
          if (_cursor < _end) {
            const _p$5 = _cursor;
            const next_char$2 = _data.charCodeAt(_p$5);
            _cursor = _cursor + 1 | 0;
            if (next_char$2 >= 48 && next_char$2 <= 57) {
              if (_cursor < _end) {
                const _p$6 = _cursor;
                const next_char$3 = _data.charCodeAt(_p$6);
                _cursor = _cursor + 1 | 0;
                if (next_char$3 >= 48 && next_char$3 <= 57) {
                  if (_cursor < _end) {
                    const _p$7 = _cursor;
                    const next_char$4 = _data.charCodeAt(_p$7);
                    _cursor = _cursor + 1 | 0;
                    if (next_char$4 >= 48 && next_char$4 <= 57) {
                      if (_cursor < _end) {
                        const _p$8 = _cursor;
                        const next_char$5 = _data.charCodeAt(_p$8);
                        _cursor = _cursor + 1 | 0;
                        if (next_char$5 >= 48 && next_char$5 <= 57) {
                          if (_cursor < _end) {
                            const _p$9 = _cursor;
                            const next_char$6 = _data.charCodeAt(_p$9);
                            _cursor = _cursor + 1 | 0;
                            if (next_char$6 >= 48 && next_char$6 <= 57) {
                              if (_cursor < _end) {
                                const _p$10 = _cursor;
                                const next_char$7 = _data.charCodeAt(_p$10);
                                _cursor = _cursor + 1 | 0;
                                if (next_char$7 >= 48 && next_char$7 <= 57) {
                                  if (_cursor < _end) {
                                    const _p$11 = _cursor;
                                    const next_char$8 = _data.charCodeAt(_p$11);
                                    _cursor = _cursor + 1 | 0;
                                    if (next_char$8 >= 48 && next_char$8 <= 57) {
                                      if (_cursor < _end) {
                                        break _L;
                                      } else {
                                        break _L$2;
                                      }
                                    } else {
                                      break _L;
                                    }
                                  } else {
                                    break _L$2;
                                  }
                                } else {
                                  break _L;
                                }
                              } else {
                                break _L$2;
                              }
                            } else {
                              break _L;
                            }
                          } else {
                            break _L$2;
                          }
                        } else {
                          break _L;
                        }
                      } else {
                        break _L$2;
                      }
                    } else {
                      break _L;
                    }
                  } else {
                    break _L$2;
                  }
                } else {
                  break _L;
                }
              } else {
                break _L$2;
              }
            } else {
              break _L;
            }
          } else {
            break _L$2;
          }
        } else {
          break _L;
        }
      } else {
        break _L$2;
      }
    }
    match_tag_saver_0 = tag_0;
    accept_state = 2;
    match_end = _cursor;
    break _L;
  }
  switch (accept_state) {
    case 0: {
      const hour_str = _M0MPC16string6String4view(_data, _start, _start + 2 | 0);
      const minute_str = _M0MPC16string6String4view(_data, _start + 3 | 0, _start + 5 | 0);
      const _bind$6 = _M0FPC28internal7strconv18parse__int_2einner(hour_str, 0);
      let _tmp$38;
      if (_bind$6.$tag === 1) {
        const _ok = _bind$6;
        _tmp$38 = _ok._0;
      } else {
        return _bind$6;
      }
      const _tmp$39 = _tmp$38;
      const _bind$7 = _M0FPC28internal7strconv18parse__int_2einner(minute_str, 0);
      let _tmp$40;
      if (_bind$7.$tag === 1) {
        const _ok = _bind$7;
        _tmp$40 = _ok._0;
      } else {
        return _bind$7;
      }
      _bind$5 = { _0: _tmp$39, _1: _tmp$40, _2: 0, _3: 0 };
      break;
    }
    case 1: {
      const hour_str$2 = _M0MPC16string6String4view(_data, _start, _start + 2 | 0);
      const minute_str$2 = _M0MPC16string6String4view(_data, _start + 3 | 0, _start + 5 | 0);
      const second_str = _M0MPC16string6String4view(_data, _start + 6 | 0, _start + 8 | 0);
      const _bind$8 = _M0FPC28internal7strconv18parse__int_2einner(hour_str$2, 0);
      let _tmp$41;
      if (_bind$8.$tag === 1) {
        const _ok = _bind$8;
        _tmp$41 = _ok._0;
      } else {
        return _bind$8;
      }
      const _tmp$42 = _tmp$41;
      const _bind$9 = _M0FPC28internal7strconv18parse__int_2einner(minute_str$2, 0);
      let _tmp$43;
      if (_bind$9.$tag === 1) {
        const _ok = _bind$9;
        _tmp$43 = _ok._0;
      } else {
        return _bind$9;
      }
      const _tmp$44 = _tmp$43;
      const _bind$10 = _M0FPC28internal7strconv18parse__int_2einner(second_str, 0);
      let _tmp$45;
      if (_bind$10.$tag === 1) {
        const _ok = _bind$10;
        _tmp$45 = _ok._0;
      } else {
        return _bind$10;
      }
      _bind$5 = { _0: _tmp$42, _1: _tmp$44, _2: _tmp$45, _3: 0 };
      break;
    }
    case 2: {
      const hour_str$3 = _M0MPC16string6String4view(_data, _start, _start + 2 | 0);
      const minute_str$3 = _M0MPC16string6String4view(_data, _start + 3 | 0, _start + 5 | 0);
      const nanosecond_str = _M0MPC16string6String4view(_data, match_tag_saver_0, match_end);
      const second_str$2 = _M0MPC16string6String4view(_data, _start + 6 | 0, _start + 8 | 0);
      const _bind$11 = _M0FPC28internal7strconv18parse__int_2einner(hour_str$3, 0);
      let _tmp$46;
      if (_bind$11.$tag === 1) {
        const _ok = _bind$11;
        _tmp$46 = _ok._0;
      } else {
        return _bind$11;
      }
      const _tmp$47 = _tmp$46;
      const _bind$12 = _M0FPC28internal7strconv18parse__int_2einner(minute_str$3, 0);
      let _tmp$48;
      if (_bind$12.$tag === 1) {
        const _ok = _bind$12;
        _tmp$48 = _ok._0;
      } else {
        return _bind$12;
      }
      const _tmp$49 = _tmp$48;
      const _bind$13 = _M0FPC28internal7strconv18parse__int_2einner(second_str$2, 0);
      let _tmp$50;
      if (_bind$13.$tag === 1) {
        const _ok = _bind$13;
        _tmp$50 = _ok._0;
      } else {
        return _bind$13;
      }
      const _tmp$51 = _tmp$50;
      const _bind$14 = _M0FP311moonbitlang1x4time17add__suffix__zero(_M0MPC16string10StringView9to__owned(nanosecond_str), 9);
      const _bind$15 = _M0FPC28internal7strconv18parse__int_2einner(new _M0TPC16string10StringView(_bind$14, 0, _bind$14.length), 0);
      let _tmp$52;
      if (_bind$15.$tag === 1) {
        const _ok = _bind$15;
        _tmp$52 = _ok._0;
      } else {
        return _bind$15;
      }
      _bind$5 = { _0: _tmp$47, _1: _tmp$49, _2: _tmp$51, _3: _tmp$52 };
      break;
    }
    default: {
      const _bind$16 = _M0FPB4failGRP311moonbitlang1x4time9PlainDateE(new _M0TPC16string10StringView(_M0FP311moonbitlang1x4time18invalid__time__err, 0, _M0FP311moonbitlang1x4time18invalid__time__err.length), "time/plain_time.mbt:73:10-73:32@moonbitlang/x");
      if (_bind$16.$tag === 1) {
        const _ok = _bind$16;
        _bind$5 = _ok._0;
      } else {
        return _bind$16;
      }
    }
  }
  const _hour = _bind$5._0;
  const _minute = _bind$5._1;
  const _second = _bind$5._2;
  const _nanosecond = _bind$5._3;
  return _M0MP311moonbitlang1x4time9PlainTime2of(_hour, _minute, _second, _nanosecond);
}
function _M0MP311moonbitlang1x4time9PlainDate12from__string(str) {
  const _bind$4 = new _M0TPC16string10StringView(str, 0, str.length);
  const _data = _bind$4.str;
  const _start = _bind$4.start;
  const _end = _start + (_bind$4.end - _bind$4.start | 0) | 0;
  let _cursor = _start;
  let accept_state = -1;
  let match_end = -1;
  _L: {
    _L$2: {
      if (_cursor < _end) {
        const _p$4 = _cursor;
        const next_char = _data.charCodeAt(_p$4);
        _cursor = _cursor + 1 | 0;
        if (next_char < 46) {
          if (next_char < 45) {
            break _L;
          } else {
            if (_cursor < _end) {
              const _p$5 = _cursor;
              const next_char$2 = _data.charCodeAt(_p$5);
              _cursor = _cursor + 1 | 0;
              if (next_char$2 >= 48 && next_char$2 <= 57) {
                break _L$2;
              } else {
                break _L;
              }
            } else {
              break _L;
            }
          }
        } else {
          if (next_char > 47) {
            if (next_char < 58) {
              break _L$2;
            } else {
              break _L;
            }
          } else {
            break _L;
          }
        }
      } else {
        break _L;
      }
    }
    if ((_cursor + 8 | 0) < _end) {
      const _p$4 = _cursor;
      const next_char = _data.charCodeAt(_p$4);
      _cursor = _cursor + 1 | 0;
      if (next_char >= 48 && next_char <= 57) {
        const _p$5 = _cursor;
        const next_char$2 = _data.charCodeAt(_p$5);
        _cursor = _cursor + 1 | 0;
        if (next_char$2 >= 48 && next_char$2 <= 57) {
          const _p$6 = _cursor;
          const next_char$3 = _data.charCodeAt(_p$6);
          _cursor = _cursor + 1 | 0;
          if (next_char$3 >= 48 && next_char$3 <= 57) {
            const _p$7 = _cursor;
            if (_data.charCodeAt(_p$7) === 45) {
              _cursor = _cursor + 1 | 0;
              const _p$8 = _cursor;
              const next_char$4 = _data.charCodeAt(_p$8);
              _cursor = _cursor + 1 | 0;
              if (next_char$4 >= 48 && next_char$4 <= 57) {
                const _p$9 = _cursor;
                const next_char$5 = _data.charCodeAt(_p$9);
                _cursor = _cursor + 1 | 0;
                if (next_char$5 >= 48 && next_char$5 <= 57) {
                  const _p$10 = _cursor;
                  if (_data.charCodeAt(_p$10) === 45) {
                    _cursor = _cursor + 1 | 0;
                    const _p$11 = _cursor;
                    const next_char$6 = _data.charCodeAt(_p$11);
                    _cursor = _cursor + 1 | 0;
                    if (next_char$6 >= 48 && next_char$6 <= 57) {
                      const _p$12 = _cursor;
                      const next_char$7 = _data.charCodeAt(_p$12);
                      _cursor = _cursor + 1 | 0;
                      if (next_char$7 >= 48 && next_char$7 <= 57) {
                        if (_cursor < _end) {
                          break _L;
                        } else {
                          accept_state = 0;
                          match_end = _cursor;
                          break _L;
                        }
                      } else {
                        break _L;
                      }
                    } else {
                      break _L;
                    }
                  } else {
                    break _L;
                  }
                } else {
                  break _L;
                }
              } else {
                break _L;
              }
            } else {
              break _L;
            }
          } else {
            break _L;
          }
        } else {
          break _L;
        }
      } else {
        break _L;
      }
    } else {
      break _L;
    }
  }
  if (accept_state === 0) {
    const day_str = _M0MPC16string6String4view(_data, match_end + -2 | 0, match_end);
    const month_str = _M0MPC16string6String4view(_data, match_end + -5 | 0, match_end + -3 | 0);
    const year_str = _M0MPC16string6String4view(_data, _start, match_end + -6 | 0);
    const _bind$5 = _M0FPC28internal7strconv18parse__int_2einner(year_str, 0);
    let year;
    if (_bind$5.$tag === 1) {
      const _ok = _bind$5;
      year = _ok._0;
    } else {
      return _bind$5;
    }
    const _bind$6 = _M0FPC28internal7strconv18parse__int_2einner(month_str, 0);
    let month;
    if (_bind$6.$tag === 1) {
      const _ok = _bind$6;
      month = _ok._0;
    } else {
      return _bind$6;
    }
    const _bind$7 = _M0FPC28internal7strconv18parse__int_2einner(day_str, 0);
    let day;
    if (_bind$7.$tag === 1) {
      const _ok = _bind$7;
      day = _ok._0;
    } else {
      return _bind$7;
    }
    return _M0MP311moonbitlang1x4time9PlainDate2of(year, month, day);
  } else {
    return _M0FPB4failGRP311moonbitlang1x4time9PlainDateE(new _M0TPC16string10StringView(_M0FP311moonbitlang1x4time18invalid__date__err, 0, _M0FP311moonbitlang1x4time18invalid__date__err.length), "time/plain_date.mbt:87:10-87:32@moonbitlang/x");
  }
}
function _M0MP311moonbitlang1x4time13PlainDateTime12from__string(str) {
  const split = _M0FP311moonbitlang1x4time5split(str, 84);
  if (split.length !== 2) {
    const _bind$4 = _M0FPB4failGuE(new _M0TPC16string10StringView(_M0FP311moonbitlang1x4time24invalid__date__time__err, 0, _M0FP311moonbitlang1x4time24invalid__date__time__err.length), "time/plain_date_time.mbt:72:5-72:32@moonbitlang/x");
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _ok._0;
    } else {
      return _bind$4;
    }
  }
  const _bind$4 = _M0MP311moonbitlang1x4time9PlainDate12from__string(_M0MPC15array5Array2atGUssEE(split, 0));
  let date;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    date = _ok._0;
  } else {
    return _bind$4;
  }
  const _bind$5 = _M0MP311moonbitlang1x4time9PlainTime12from__string(_M0MPC15array5Array2atGUssEE(split, 1));
  let time;
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    time = _ok._0;
  } else {
    return _bind$5;
  }
  return new _M0DTPC16result6ResultGRP311moonbitlang1x4time13PlainDateTimeRPC15error5ErrorE2Ok(new _M0TP311moonbitlang1x4time13PlainDateTime(date, time));
}
function _M0MP27gmlewis4gzip6Header3new() {
  return new _M0TP27gmlewis4gzip6Header("", [], undefined, "", 255);
}
function _M0MP27gmlewis4gzip6Writer3new(w) {
  const header = _M0MP27gmlewis4gzip6Header3new();
  const buf = _M0MPC15array5Array4makeGyE(10, 0);
  return new _M0TP27gmlewis4gzip6Writer(header, w, 1, false, false, buf, { self: _M0MP27gmlewis5flate6Writer3new(w), method_table: _M0FP061gmlewis_2fflate_2fWriter_24as_24_40gmlewis_2fio_2eWriteCloser }, 0, 0, undefined);
}
function _M0FP27gmlewis4gzip15le__put__uint16(b, offset, value) {
  const _p$4 = value & 255;
  _M0MPC15array5Array3setGyE(b, offset, _p$4 & 255);
  const _tmp$38 = offset + 1 | 0;
  const _p$5 = value >>> 8 & 255;
  _M0MPC15array5Array3setGyE(b, _tmp$38, _p$5 & 255);
}
function _M0MP27gmlewis4gzip6Writer12write__bytes(self, b) {
  if (b.len > 65535) {
    const _p$4 = "gzip.Write: Extra data is too large";
    return new _M0DTPC15error5Error32gmlewis_2fio_2eIOError_2eIOError(_p$4);
  }
  _M0FP27gmlewis4gzip15le__put__uint16(self.buf, 0, b.len);
  const le_len = [_M0MPC15array5Array2atGyE(self.buf, 0), _M0MPC15array5Array2atGyE(self.buf, 1)];
  const _tmp$38 = self.w;
  const _bind$4 = _tmp$38.method_table.method_0(_tmp$38.self, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(_M0MP27gmlewis2io5Slice11new_2einnerGyE(le_len, 0, undefined), 0, undefined));
  const _err = _bind$4._1;
  if (_err === undefined) {
    const _tmp$39 = self.w;
    const _bind$5 = _tmp$39.method_table.method_0(_tmp$39.self, b);
    return _bind$5._1;
  } else {
    return _err;
  }
}
function _M0FP27gmlewis4gzip15le__put__uint32(b, offset, value) {
  const _p$4 = value & 255;
  _M0MPC15array5Array3setGyE(b, offset, _p$4 & 255);
  const _tmp$38 = offset + 1 | 0;
  const _p$5 = value >>> 8 & 255;
  _M0MPC15array5Array3setGyE(b, _tmp$38, _p$5 & 255);
  const _tmp$39 = offset + 2 | 0;
  const _p$6 = value >>> 16 & 255;
  _M0MPC15array5Array3setGyE(b, _tmp$39, _p$6 & 255);
  const _tmp$40 = offset + 3 | 0;
  const _p$7 = value >>> 24 & 255;
  _M0MPC15array5Array3setGyE(b, _tmp$40, _p$7 & 255);
}
function _M0MP27gmlewis4gzip6Writer13write__string(self, s) {
  const ch = _M0MPC16string6String9to__array(s);
  let needconv = false;
  const _bind$4 = ch.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const c = ch[_];
      const v = c;
      if (v === 0 || v >= 255) {
        const _p$4 = "@gzip.write_string: non-Latin-1 header string";
        return new _M0DTPC15error5Error32gmlewis_2fio_2eIOError_2eIOError(_p$4);
      }
      if (v > 127) {
        needconv = true;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (needconv) {
    const b = _M0MP27gmlewis2io5Slice11new_2einnerGyE(_M0MPC15array5Array4makeGyE(s.length, 0), 0, undefined);
    const _bind$5 = s.length;
    let _tmp$39 = 0;
    while (true) {
      const i = _tmp$39;
      if (i < _bind$5) {
        const v = s.charCodeAt(i);
        const _p$4 = 255;
        _M0MP27gmlewis2io5Slice7op__setGyE(b, i, v & _p$4 & 65535 & 255);
        _tmp$39 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    const _tmp$40 = self.w;
    const _bind$6 = _tmp$40.method_table.method_0(_tmp$40.self, b);
    const _err = _bind$6._1;
    if (_err === undefined) {
    } else {
      return _err;
    }
  } else {
    const b = _M0MPC15bytes5Bytes9to__array(_M0FP27gmlewis6base649str2bytes(s));
    const _tmp$39 = self.w;
    const _bind$5 = _tmp$39.method_table.method_0(_tmp$39.self, _M0MP27gmlewis2io5Slice11new_2einnerGyE(b, 0, undefined));
    const _err = _bind$5._1;
    if (_err === undefined) {
    } else {
      return _err;
    }
  }
  const _tmp$39 = self.w;
  const _bind$5 = _tmp$39.method_table.method_0(_tmp$39.self, _M0MP27gmlewis2io5Slice11new_2einnerGyE([0], 0, undefined));
  const _err = _bind$5._1;
  return _err === undefined ? undefined : _err;
}
function _M0IP27gmlewis4gzip6WriterP27gmlewis2io6Writer5write(self, p) {
  const _bind$4 = self.err;
  if (_bind$4 === undefined) {
  } else {
    return { _0: 0, _1: self.err };
  }
  if (!self.wrote_header) {
    self.wrote_header = true;
    self.buf = _M0MPC15array5Array4makeGyE(10, 0);
    _M0MPC15array5Array3setGyE(self.buf, 0, 31);
    _M0MPC15array5Array3setGyE(self.buf, 1, 139);
    _M0MPC15array5Array3setGyE(self.buf, 2, 8);
    const _bind$5 = self.header.extra;
    if (_bind$5.length === 0) {
    } else {
      _M0MPC15array5Array3setGyE(self.buf, 3, 4);
    }
    const _p$4 = self.header.name;
    const _p$5 = "";
    if (!(_p$4 === _p$5)) {
      const _tmp$38 = self.buf;
      const _p$6 = _M0MPC15array5Array2atGyE(self.buf, 3);
      const _p$7 = 8;
      _M0MPC15array5Array3setGyE(_tmp$38, 3, (_p$6 | _p$7) & 255);
    }
    const _p$6 = self.header.comment;
    const _p$7 = "";
    if (!(_p$6 === _p$7)) {
      const _tmp$38 = self.buf;
      const _p$8 = _M0MPC15array5Array2atGyE(self.buf, 3);
      const _p$9 = 16;
      _M0MPC15array5Array3setGyE(_tmp$38, 3, (_p$8 | _p$9) & 255);
    }
    const _bind$6 = self.header.mod_time;
    if (_bind$6 === undefined) {
    } else {
      const _Some = _bind$6;
      const _t = _Some;
      const t = Number(BigInt.asUintN(32, _M0MP311moonbitlang1x4time13PlainDateTime16to__unix__second(_t))) | 0;
      _M0FP27gmlewis4gzip15le__put__uint32(self.buf, 4, t);
    }
    _M0MPC15array5Array3setGyE(self.buf, 8, 4);
    _M0MPC15array5Array3setGyE(self.buf, 9, self.header.os);
    const b = _M0MP27gmlewis2io5Slice11new_2einnerGyE(self.buf, 0, undefined);
    const _tmp$38 = self.w;
    const _bind$7 = _tmp$38.method_table.method_0(_tmp$38.self, b);
    const _err = _bind$7._1;
    if (_err === undefined) {
      const _bind$8 = self.header.extra;
      if (_bind$8.length === 0) {
      } else {
        const err = _M0MP27gmlewis4gzip6Writer12write__bytes(self, _M0MP27gmlewis2io5Slice11new_2einnerGyE(_bind$8, 0, undefined));
        if (err === undefined) {
        } else {
          self.err = err;
          return { _0: 0, _1: err };
        }
      }
      const _p$8 = self.header.name;
      const _p$9 = "";
      if (!(_p$8 === _p$9)) {
        const err = _M0MP27gmlewis4gzip6Writer13write__string(self, self.header.name);
        if (err === undefined) {
        } else {
          self.err = err;
          return { _0: 0, _1: err };
        }
      }
      const _p$10 = self.header.comment;
      const _p$11 = "";
      if (!(_p$10 === _p$11)) {
        const err = _M0MP27gmlewis4gzip6Writer13write__string(self, self.header.comment);
        if (err === undefined) {
        } else {
          self.err = err;
          return { _0: 0, _1: err };
        }
      }
    } else {
      self.err = _err;
      return { _0: 0, _1: _err };
    }
  }
  self.size = (self.size >>> 0) + (p.len >>> 0) | 0;
  const sum = _M0MP27gmlewis5crc326Digest3new();
  const _it = _M0MP27gmlewis2io5Slice4iterGyE(p);
  while (true) {
    const _bind$5 = _M0MPB4Iter4nextGyE(_it);
    if (_bind$5 === -1) {
      break;
    } else {
      const _Some = _bind$5;
      const _b = _Some;
      _M0IP27gmlewis5crc326DigestP27gmlewis5crc328HashFunc5write(sum, _b);
      continue;
    }
  }
  self.digest = ~sum.crc;
  const _tmp$38 = self.compressor;
  const _bind$5 = _tmp$38.method_table.method_0(_tmp$38.self, p);
  const _n = _bind$5._0;
  const _err = _bind$5._1;
  return { _0: _n, _1: _err };
}
function _M0IP27gmlewis4gzip6WriterP27gmlewis2io6Closer5close(self) {
  const _bind$4 = self.err;
  if (_bind$4 === undefined) {
    if (self.closed) {
      return undefined;
    }
    self.closed = true;
    if (!self.wrote_header) {
      const _bind$5 = _M0IP27gmlewis4gzip6WriterP27gmlewis2io6Writer5write(self, _M0MP27gmlewis2io5Slice11new_2einnerGyE([], 0, undefined));
      const _err = _bind$5._1;
      if (_err === undefined) {
      } else {
        return _err;
      }
    }
    const _tmp$38 = self.compressor;
    self.err = _tmp$38.method_table.method_1(_tmp$38.self);
    _M0FP27gmlewis4gzip15le__put__uint32(self.buf, 0, self.digest);
    _M0FP27gmlewis4gzip15le__put__uint32(self.buf, 4, self.size);
    const footer = _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(_M0MP27gmlewis2io5Slice11new_2einnerGyE(self.buf, 0, undefined), 0, _M0IP27gmlewis4gzip6WriterP27gmlewis2io6Closer5closeN6constrS348);
    const _tmp$39 = self.w;
    const _bind$5 = _tmp$39.method_table.method_0(_tmp$39.self, footer);
    return _bind$5._1;
  } else {
    return self.err;
  }
}
function _M0FP27gmlewis4gzip7no__eof(err) {
  if (_M0IP27gmlewis2io7IOErrorPB2Eq5equal(_M0FP27gmlewis2io3eof, err)) {
    return _M0FP27gmlewis2io20err__unexpected__eof;
  }
  return err;
}
function _M0FP27gmlewis4gzip10le__uint16(b) {
  const _p$4 = _M0MPC15array9ArrayView2atGyE(b, 0);
  const _p$5 = _M0MPC15array9ArrayView2atGyE(b, 1);
  return _p$4 | _p$5 << 8;
}
function _M0FP27gmlewis4gzip10le__uint32(b) {
  const _p$4 = _M0MPC15array9ArrayView2atGyE(b, 0);
  const _p$5 = _M0MPC15array9ArrayView2atGyE(b, 1);
  const _tmp$38 = _p$4 | _p$5 << 8;
  const _p$6 = _M0MPC15array9ArrayView2atGyE(b, 2);
  const _tmp$39 = _tmp$38 | _p$6 << 16;
  const _p$7 = _M0MPC15array9ArrayView2atGyE(b, 3);
  return _tmp$39 | _p$7 << 24;
}
function _M0MP27gmlewis4gzip6Reader12read__string(self) {
  let need_conv = false;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i >= self.buf.length) {
      return { _0: "", _1: _M0FP27gmlewis4gzip11err__header };
    }
    const _tmp$39 = self.r;
    const _bind$4 = _tmp$39.method_table.method_1(_tmp$39.self);
    const _b = _bind$4._0;
    const _err = _bind$4._1;
    if (_err === undefined) {
    } else {
      return { _0: "", _1: _err };
    }
    _M0MPC15array5Array3setGyE(self.buf, i, _b);
    if (_M0MPC15array5Array2atGyE(self.buf, i) > 127) {
      need_conv = true;
    }
    _M0IP27gmlewis5crc326DigestP27gmlewis5crc328HashFunc5write(self.digest, _M0MPC15array5Array2atGyE(self.buf, i));
    const _p$4 = _M0MPC15array5Array2atGyE(self.buf, i);
    const _p$5 = 0;
    if (_p$4 === _p$5) {
      if (need_conv) {
        const s = _M0MPC15array5Array11new_2einnerGcE(i);
        const _bind$5 = _M0MPC15array5Array12view_2einnerGyE(self.buf, 0, i);
        const _bind$6 = _bind$5.end - _bind$5.start | 0;
        let _tmp$40 = 0;
        while (true) {
          const _ = _tmp$40;
          if (_ < _bind$6) {
            const v = _bind$5.buf[_bind$5.start + _ | 0];
            _M0MPC15array5Array4pushGcE(s, v);
            _tmp$40 = _ + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        return { _0: _M0MPC16string6String11from__array(new _M0TPB9ArrayViewGcE(s, 0, s.length)), _1: undefined };
      }
      return { _0: _M0FP27gmlewis6base649bytes2str(_M0MPC15bytes5Bytes10from__iter(_M0MPC15array9ArrayView4iterGyE(_M0MPC15array5Array12view_2einnerGyE(self.buf, 0, i)))), _1: undefined };
    }
    _tmp$38 = i + 1 | 0;
    continue;
  }
}
function _M0MP27gmlewis4gzip6Reader12read__header(self) {
  const hdr = _M0MP27gmlewis4gzip6Header3new();
  const _bind$4 = _M0FP27gmlewis2io10read__full({ self: self.r, method_table: _M0FP056gmlewis_2fflate_2fReader_24as_24_40gmlewis_2fio_2eReader }, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(_M0MP27gmlewis2io5Slice11new_2einnerGyE(self.buf, 0, undefined), 0, _M0MP27gmlewis4gzip6Reader12read__headerN6constrS349));
  const _err = _bind$4._1;
  if (_err === undefined) {
  } else {
    return { _0: hdr, _1: _err };
  }
  if (_M0MPC15array5Array2atGyE(self.buf, 0) !== 31 || (_M0MPC15array5Array2atGyE(self.buf, 1) !== 139 || _M0MPC15array5Array2atGyE(self.buf, 2) !== 8)) {
    return { _0: hdr, _1: _M0FP27gmlewis4gzip11err__header };
  }
  const flg = _M0MPC15array5Array2atGyE(self.buf, 3);
  const t = _M0MPC14uint4UInt9to__int64(_M0FP27gmlewis4gzip10le__uint32(_M0MPC15array5Array12view_2einnerGyE(self.buf, 4, _M0MP27gmlewis4gzip6Reader12read__headerN6constrS350)));
  if (BigInt.asIntN(64, t) > BigInt.asIntN(64, 0n)) {
    let _try_err;
    _L: {
      _L$2: {
        const _bind$5 = _M0MP311moonbitlang1x4time13PlainDateTime18from__unix__second(t, 0, _M0FP311moonbitlang1x4time11utc__offset);
        let mod_time;
        if (_bind$5.$tag === 1) {
          const _ok = _bind$5;
          mod_time = _ok._0;
        } else {
          const _err$2 = _bind$5;
          _try_err = _err$2._0;
          break _L$2;
        }
        hdr.mod_time = mod_time;
        break _L;
      }
    }
  }
  hdr.os = _M0MPC15array5Array2atGyE(self.buf, 9);
  self.digest = _M0MP27gmlewis5crc326Digest3new();
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < 10) {
      _M0IP27gmlewis5crc326DigestP27gmlewis5crc328HashFunc5write(self.digest, _M0MPC15array5Array2atGyE(self.buf, i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _p$4 = 4;
  if ((flg & _p$4 & 255) !== 0) {
    const _bind$5 = _M0FP27gmlewis2io10read__full({ self: self.r, method_table: _M0FP056gmlewis_2fflate_2fReader_24as_24_40gmlewis_2fio_2eReader }, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(_M0MP27gmlewis2io5Slice11new_2einnerGyE(self.buf, 0, undefined), 0, _M0MP27gmlewis4gzip6Reader12read__headerN6constrS351));
    const _err$2 = _bind$5._1;
    if (_err$2 === undefined) {
    } else {
      const _Some = _err$2;
      const _e = _Some;
      return { _0: hdr, _1: _M0FP27gmlewis4gzip7no__eof(_e) };
    }
    const _self = self.digest;
    _M0IP27gmlewis5crc326DigestP27gmlewis5crc328HashFunc5write(_self, _M0MPC15array5Array2atGyE(self.buf, 0));
    _M0IP27gmlewis5crc326DigestP27gmlewis5crc328HashFunc5write(_self, _M0MPC15array5Array2atGyE(self.buf, 1));
    const data_size = _M0FP27gmlewis4gzip10le__uint16(_M0MPC15array5Array12view_2einnerGyE(self.buf, 0, _M0MP27gmlewis4gzip6Reader12read__headerN6constrS352));
    const data = _M0MPC15array5Array4makeGyE(data_size, 0);
    const _bind$6 = _M0FP27gmlewis2io10read__full({ self: self.r, method_table: _M0FP056gmlewis_2fflate_2fReader_24as_24_40gmlewis_2fio_2eReader }, _M0MP27gmlewis2io5Slice11new_2einnerGyE(data, 0, undefined));
    const _err$3 = _bind$6._1;
    if (_err$3 === undefined) {
    } else {
      const _Some = _err$3;
      const _e = _Some;
      return { _0: hdr, _1: _M0FP27gmlewis4gzip7no__eof(_e) };
    }
    let _tmp$39 = 0;
    while (true) {
      const i = _tmp$39;
      if (i < data_size) {
        _M0IP27gmlewis5crc326DigestP27gmlewis5crc328HashFunc5write(self.digest, _M0MPC15array5Array2atGyE(data, i));
        _tmp$39 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    hdr.extra = data;
  }
  const _p$5 = 8;
  if ((flg & _p$5 & 255) !== 0) {
    const _bind$5 = _M0MP27gmlewis4gzip6Reader12read__string(self);
    const _s = _bind$5._0;
    const _err$2 = _bind$5._1;
    if (_err$2 === undefined) {
      hdr.name = _s;
    } else {
      let _tmp$39;
      if (_err$2 === undefined) {
        _tmp$39 = $panic();
      } else {
        const _p$6 = _err$2;
        _tmp$39 = _p$6;
      }
      return { _0: hdr, _1: _M0FP27gmlewis4gzip7no__eof(_tmp$39) };
    }
  }
  const _p$6 = 16;
  if ((flg & _p$6 & 255) !== 0) {
    const _bind$5 = _M0MP27gmlewis4gzip6Reader12read__string(self);
    const _s = _bind$5._0;
    const _err$2 = _bind$5._1;
    if (_err$2 === undefined) {
      hdr.comment = _s;
    } else {
      let _tmp$39;
      if (_err$2 === undefined) {
        _tmp$39 = $panic();
      } else {
        const _p$7 = _err$2;
        _tmp$39 = _p$7;
      }
      return { _0: hdr, _1: _M0FP27gmlewis4gzip7no__eof(_tmp$39) };
    }
  }
  const _p$7 = 2;
  if ((flg & _p$7 & 255) !== 0) {
    const _bind$5 = _M0FP27gmlewis2io10read__full({ self: self.r, method_table: _M0FP056gmlewis_2fflate_2fReader_24as_24_40gmlewis_2fio_2eReader }, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(_M0MP27gmlewis2io5Slice11new_2einnerGyE(self.buf, 0, undefined), 0, _M0MP27gmlewis4gzip6Reader12read__headerN6constrS353));
    const _err$2 = _bind$5._1;
    if (_err$2 === undefined) {
    } else {
      const _Some = _err$2;
      const _e = _Some;
      return { _0: hdr, _1: _M0FP27gmlewis4gzip7no__eof(_e) };
    }
    const digest = _M0FP27gmlewis4gzip10le__uint16(_M0MPC15array5Array12view_2einnerGyE(self.buf, 0, _M0MP27gmlewis4gzip6Reader12read__headerN6constrS354));
    const _p$8 = self.digest;
    const z_digest = ~_p$8.crc & 65535;
    if (digest !== z_digest) {
      return { _0: hdr, _1: _M0FP27gmlewis4gzip11err__header };
    }
  }
  self.digest = _M0MP27gmlewis5crc326Digest3new();
  self.decompressor = { self: _M0MP27gmlewis5flate6Reader3new(self.r), method_table: _M0FP066gmlewis_2fflate_2fDecompressor_24as_24_40gmlewis_2fio_2eReadCloser };
  return { _0: hdr, _1: undefined };
}
function _M0MP27gmlewis4gzip6Reader5reset(self, r) {
  self.r = r;
  self.digest = _M0MP27gmlewis5crc326Digest3new();
  self.size = 0;
  self.buf = _M0MPC15array5Array4makeGyE(512, 0);
  self.multistream = true;
  const _bind$4 = _M0MP27gmlewis4gzip6Reader12read__header(self);
  const _header = _bind$4._0;
  const _err = _bind$4._1;
  self.header = _header;
  self.err = _err;
  return self.err;
}
function _M0MP27gmlewis4gzip6Reader3new(r) {
  const z = new _M0TP27gmlewis4gzip6Reader(_M0MP27gmlewis4gzip6Header3new(), r, { self: _M0MP27gmlewis5flate6Reader3new(r), method_table: _M0FP066gmlewis_2fflate_2fDecompressor_24as_24_40gmlewis_2fio_2eReadCloser }, _M0MP27gmlewis5crc326Digest3new(), 0, [], undefined, false);
  const err = _M0MP27gmlewis4gzip6Reader5reset(z, r);
  return { _0: z, _1: err };
}
function _M0IP27gmlewis4gzip6ReaderP27gmlewis2io6Reader4read(self, p) {
  const _bind$4 = self.err;
  if (!(_bind$4 === undefined)) {
    return { _0: 0, _1: self.err };
  }
  let n = 0;
  while (true) {
    if (n === 0) {
      const _tmp$38 = self.decompressor;
      const _bind$5 = _tmp$38.method_table.method_0(_tmp$38.self, p);
      const _tmpn = _bind$5._0;
      const _err = _bind$5._1;
      n = _tmpn;
      self.err = _err;
      const _bind$6 = n;
      let _tmp$39 = 0;
      while (true) {
        const i = _tmp$39;
        if (i < _bind$6) {
          _M0IP27gmlewis5crc326DigestP27gmlewis5crc328HashFunc5write(self.digest, _M0MP27gmlewis2io5Slice7op__getGyE(p, i));
          _tmp$39 = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      self.size = (self.size >>> 0) + (n >>> 0) | 0;
      if (_M0IP016_24default__implPB2Eq10not__equalGORP27gmlewis2io7IOErrorE(_M0FP27gmlewis2io3eof, self.err)) {
        return { _0: n, _1: self.err };
      }
      const _bind$7 = _M0FP27gmlewis2io10read__full({ self: self.r, method_table: _M0FP056gmlewis_2fflate_2fReader_24as_24_40gmlewis_2fio_2eReader }, _M0MP27gmlewis2io5Slice20op__as__view_2einnerGyE(_M0MP27gmlewis2io5Slice11new_2einnerGyE(self.buf, 0, undefined), 0, _M0IP27gmlewis4gzip6ReaderP27gmlewis2io6Reader4readN6constrS355));
      const _err$2 = _bind$7._1;
      if (_err$2 === undefined) {
      } else {
        const _Some = _err$2;
        const _e = _Some;
        self.err = _M0FP27gmlewis4gzip7no__eof(_e);
        return { _0: n, _1: self.err };
      }
      const digest = _M0FP27gmlewis4gzip10le__uint32(_M0MPC15array5Array12view_2einnerGyE(self.buf, 0, _M0IP27gmlewis4gzip6ReaderP27gmlewis2io6Reader4readN6constrS356));
      const size = _M0FP27gmlewis4gzip10le__uint32(_M0MPC15array5Array12view_2einnerGyE(self.buf, 4, _M0IP27gmlewis4gzip6ReaderP27gmlewis2io6Reader4readN6constrS357));
      let _tmp$40;
      const _p$4 = self.digest;
      if (digest !== ~_p$4.crc) {
        _tmp$40 = true;
      } else {
        _tmp$40 = size !== self.size;
      }
      if (_tmp$40) {
        self.err = _M0FP27gmlewis4gzip13err__checksum;
        return { _0: n, _1: self.err };
      }
      self.digest = _M0MP27gmlewis5crc326Digest3new();
      self.size = 0;
      if (!self.multistream) {
        return { _0: n, _1: _M0FP27gmlewis2io3eof };
      }
      self.err = undefined;
      const _bind$8 = _M0MP27gmlewis4gzip6Reader12read__header(self);
      const _err$3 = _bind$8._1;
      self.err = _err$3;
      if (_err$3 === undefined) {
      } else {
        return { _0: n, _1: self.err };
      }
      continue;
    } else {
      break;
    }
  }
  return { _0: n, _1: undefined };
}
function _M0MP27gmlewis3md56Digest3new() {
  return new _M0TP27gmlewis3md56Digest(_M0MPC15array10FixedArray11from__arrayGjE(new _M0TPB9ArrayViewGjE(_M0MP27gmlewis3md56Digest3newN7_2abindS68, 0, 4)), $makebytes(64, 0), 0, 0n, "md5");
}
function _M0FP27gmlewis3md515le__put__uint32(b, offset, value) {
  const _p$4 = value & 255;
  $bound_check(b, offset);
  b[offset] = _p$4 & 255;
  const _tmp$38 = offset + 1 | 0;
  const _p$5 = value >>> 8 & 255;
  $bound_check(b, _tmp$38);
  b[_tmp$38] = _p$5 & 255;
  const _tmp$39 = offset + 2 | 0;
  const _p$6 = value >>> 16 & 255;
  $bound_check(b, _tmp$39);
  b[_tmp$39] = _p$6 & 255;
  const _tmp$40 = offset + 3 | 0;
  const _p$7 = value >>> 24 & 255;
  $bound_check(b, _tmp$40);
  b[_tmp$40] = _p$7 & 255;
}
function _M0FP27gmlewis3md515le__put__uint64(b, offset, value) {
  _M0FP27gmlewis3md515le__put__uint32(b, offset, Number(BigInt.asUintN(32, BigInt.asUintN(64, value & 4294967295n))) | 0);
  _M0FP27gmlewis3md515le__put__uint32(b, offset + 4 | 0, Number(BigInt.asUintN(32, BigInt.asUintN(64, BigInt.asUintN(64, BigInt.asUintN(64, value) >> BigInt(32 & 63)) & 4294967295n))) | 0);
}
function _M0FP27gmlewis3md57to__hex(v) {
  return v < 10 ? v + 48 | 0 : (v - 10 | 0) + 97 | 0;
}
function _M0FP27gmlewis3md510le__uint32(b, offset) {
  $bound_check(b, offset);
  const _p$4 = b[offset];
  const _tmp$38 = offset + 1 | 0;
  $bound_check(b, _tmp$38);
  const _p$5 = b[_tmp$38];
  const _tmp$39 = _p$4 | _p$5 << 8;
  const _tmp$40 = offset + 2 | 0;
  $bound_check(b, _tmp$40);
  const _p$6 = b[_tmp$40];
  const _tmp$41 = _tmp$39 | _p$6 << 16;
  const _tmp$42 = offset + 3 | 0;
  $bound_check(b, _tmp$42);
  const _p$7 = b[_tmp$42];
  return _tmp$41 | _p$7 << 24;
}
function _M0MP27gmlewis3md56Digest14block__generic(self) {
  const _tmp$38 = self.s;
  $bound_check(_tmp$38, 0);
  let a = _tmp$38[0];
  const _tmp$39 = self.s;
  $bound_check(_tmp$39, 1);
  let b = _tmp$39[1];
  const _tmp$40 = self.s;
  $bound_check(_tmp$40, 2);
  let c = _tmp$40[2];
  const _tmp$41 = self.s;
  $bound_check(_tmp$41, 3);
  let d = _tmp$41[3];
  const q = self.x;
  const x0 = _M0FP27gmlewis3md510le__uint32(q, 0);
  const x1 = _M0FP27gmlewis3md510le__uint32(q, 4);
  const x2 = _M0FP27gmlewis3md510le__uint32(q, 8);
  const x3 = _M0FP27gmlewis3md510le__uint32(q, 12);
  const x4 = _M0FP27gmlewis3md510le__uint32(q, 16);
  const x5 = _M0FP27gmlewis3md510le__uint32(q, 20);
  const x6 = _M0FP27gmlewis3md510le__uint32(q, 24);
  const x7 = _M0FP27gmlewis3md510le__uint32(q, 28);
  const x8 = _M0FP27gmlewis3md510le__uint32(q, 32);
  const x9 = _M0FP27gmlewis3md510le__uint32(q, 36);
  const xa = _M0FP27gmlewis3md510le__uint32(q, 40);
  const xb = _M0FP27gmlewis3md510le__uint32(q, 44);
  const xc = _M0FP27gmlewis3md510le__uint32(q, 48);
  const xd = _M0FP27gmlewis3md510le__uint32(q, 52);
  const xe = _M0FP27gmlewis3md510le__uint32(q, 56);
  const xf = _M0FP27gmlewis3md510le__uint32(q, 60);
  const _tmp$42 = b;
  const _p$4 = (((((((c ^ d) & b ^ d) >>> 0) + (a >>> 0) | 0) >>> 0) + (x0 >>> 0) | 0) >>> 0) + (-680876936 >>> 0) | 0;
  const _p$5 = 7;
  a = (_tmp$42 >>> 0) + ((_p$4 << _p$5 | (_p$4 >>> (32 - _p$5 | 0) | 0)) >>> 0) | 0;
  const _tmp$43 = a;
  const _p$6 = (((((((b ^ c) & a ^ c) >>> 0) + (d >>> 0) | 0) >>> 0) + (x1 >>> 0) | 0) >>> 0) + (-389564586 >>> 0) | 0;
  const _p$7 = 12;
  d = (_tmp$43 >>> 0) + ((_p$6 << _p$7 | (_p$6 >>> (32 - _p$7 | 0) | 0)) >>> 0) | 0;
  const _tmp$44 = d;
  const _p$8 = (((((((a ^ b) & d ^ b) >>> 0) + (c >>> 0) | 0) >>> 0) + (x2 >>> 0) | 0) >>> 0) + (606105819 >>> 0) | 0;
  const _p$9 = 17;
  c = (_tmp$44 >>> 0) + ((_p$8 << _p$9 | (_p$8 >>> (32 - _p$9 | 0) | 0)) >>> 0) | 0;
  const _tmp$45 = c;
  const _p$10 = (((((((d ^ a) & c ^ a) >>> 0) + (b >>> 0) | 0) >>> 0) + (x3 >>> 0) | 0) >>> 0) + (-1044525330 >>> 0) | 0;
  const _p$11 = 22;
  b = (_tmp$45 >>> 0) + ((_p$10 << _p$11 | (_p$10 >>> (32 - _p$11 | 0) | 0)) >>> 0) | 0;
  const _tmp$46 = b;
  const _p$12 = (((((((c ^ d) & b ^ d) >>> 0) + (a >>> 0) | 0) >>> 0) + (x4 >>> 0) | 0) >>> 0) + (-176418897 >>> 0) | 0;
  const _p$13 = 7;
  a = (_tmp$46 >>> 0) + ((_p$12 << _p$13 | (_p$12 >>> (32 - _p$13 | 0) | 0)) >>> 0) | 0;
  const _tmp$47 = a;
  const _p$14 = (((((((b ^ c) & a ^ c) >>> 0) + (d >>> 0) | 0) >>> 0) + (x5 >>> 0) | 0) >>> 0) + (1200080426 >>> 0) | 0;
  const _p$15 = 12;
  d = (_tmp$47 >>> 0) + ((_p$14 << _p$15 | (_p$14 >>> (32 - _p$15 | 0) | 0)) >>> 0) | 0;
  const _tmp$48 = d;
  const _p$16 = (((((((a ^ b) & d ^ b) >>> 0) + (c >>> 0) | 0) >>> 0) + (x6 >>> 0) | 0) >>> 0) + (-1473231341 >>> 0) | 0;
  const _p$17 = 17;
  c = (_tmp$48 >>> 0) + ((_p$16 << _p$17 | (_p$16 >>> (32 - _p$17 | 0) | 0)) >>> 0) | 0;
  const _tmp$49 = c;
  const _p$18 = (((((((d ^ a) & c ^ a) >>> 0) + (b >>> 0) | 0) >>> 0) + (x7 >>> 0) | 0) >>> 0) + (-45705983 >>> 0) | 0;
  const _p$19 = 22;
  b = (_tmp$49 >>> 0) + ((_p$18 << _p$19 | (_p$18 >>> (32 - _p$19 | 0) | 0)) >>> 0) | 0;
  const _tmp$50 = b;
  const _p$20 = (((((((c ^ d) & b ^ d) >>> 0) + (a >>> 0) | 0) >>> 0) + (x8 >>> 0) | 0) >>> 0) + (1770035416 >>> 0) | 0;
  const _p$21 = 7;
  a = (_tmp$50 >>> 0) + ((_p$20 << _p$21 | (_p$20 >>> (32 - _p$21 | 0) | 0)) >>> 0) | 0;
  const _tmp$51 = a;
  const _p$22 = (((((((b ^ c) & a ^ c) >>> 0) + (d >>> 0) | 0) >>> 0) + (x9 >>> 0) | 0) >>> 0) + (-1958414417 >>> 0) | 0;
  const _p$23 = 12;
  d = (_tmp$51 >>> 0) + ((_p$22 << _p$23 | (_p$22 >>> (32 - _p$23 | 0) | 0)) >>> 0) | 0;
  const _tmp$52 = d;
  const _p$24 = (((((((a ^ b) & d ^ b) >>> 0) + (c >>> 0) | 0) >>> 0) + (xa >>> 0) | 0) >>> 0) + (-42063 >>> 0) | 0;
  const _p$25 = 17;
  c = (_tmp$52 >>> 0) + ((_p$24 << _p$25 | (_p$24 >>> (32 - _p$25 | 0) | 0)) >>> 0) | 0;
  const _tmp$53 = c;
  const _p$26 = (((((((d ^ a) & c ^ a) >>> 0) + (b >>> 0) | 0) >>> 0) + (xb >>> 0) | 0) >>> 0) + (-1990404162 >>> 0) | 0;
  const _p$27 = 22;
  b = (_tmp$53 >>> 0) + ((_p$26 << _p$27 | (_p$26 >>> (32 - _p$27 | 0) | 0)) >>> 0) | 0;
  const _tmp$54 = b;
  const _p$28 = (((((((c ^ d) & b ^ d) >>> 0) + (a >>> 0) | 0) >>> 0) + (xc >>> 0) | 0) >>> 0) + (1804603682 >>> 0) | 0;
  const _p$29 = 7;
  a = (_tmp$54 >>> 0) + ((_p$28 << _p$29 | (_p$28 >>> (32 - _p$29 | 0) | 0)) >>> 0) | 0;
  const _tmp$55 = a;
  const _p$30 = (((((((b ^ c) & a ^ c) >>> 0) + (d >>> 0) | 0) >>> 0) + (xd >>> 0) | 0) >>> 0) + (-40341101 >>> 0) | 0;
  const _p$31 = 12;
  d = (_tmp$55 >>> 0) + ((_p$30 << _p$31 | (_p$30 >>> (32 - _p$31 | 0) | 0)) >>> 0) | 0;
  const _tmp$56 = d;
  const _p$32 = (((((((a ^ b) & d ^ b) >>> 0) + (c >>> 0) | 0) >>> 0) + (xe >>> 0) | 0) >>> 0) + (-1502002290 >>> 0) | 0;
  const _p$33 = 17;
  c = (_tmp$56 >>> 0) + ((_p$32 << _p$33 | (_p$32 >>> (32 - _p$33 | 0) | 0)) >>> 0) | 0;
  const _tmp$57 = c;
  const _p$34 = (((((((d ^ a) & c ^ a) >>> 0) + (b >>> 0) | 0) >>> 0) + (xf >>> 0) | 0) >>> 0) + (1236535329 >>> 0) | 0;
  const _p$35 = 22;
  b = (_tmp$57 >>> 0) + ((_p$34 << _p$35 | (_p$34 >>> (32 - _p$35 | 0) | 0)) >>> 0) | 0;
  const _tmp$58 = b;
  const _p$36 = (((((((b ^ c) & d ^ c) >>> 0) + (a >>> 0) | 0) >>> 0) + (x1 >>> 0) | 0) >>> 0) + (-165796510 >>> 0) | 0;
  const _p$37 = 5;
  a = (_tmp$58 >>> 0) + ((_p$36 << _p$37 | (_p$36 >>> (32 - _p$37 | 0) | 0)) >>> 0) | 0;
  const _tmp$59 = a;
  const _p$38 = (((((((a ^ b) & c ^ b) >>> 0) + (d >>> 0) | 0) >>> 0) + (x6 >>> 0) | 0) >>> 0) + (-1069501632 >>> 0) | 0;
  const _p$39 = 9;
  d = (_tmp$59 >>> 0) + ((_p$38 << _p$39 | (_p$38 >>> (32 - _p$39 | 0) | 0)) >>> 0) | 0;
  const _tmp$60 = d;
  const _p$40 = (((((((d ^ a) & b ^ a) >>> 0) + (c >>> 0) | 0) >>> 0) + (xb >>> 0) | 0) >>> 0) + (643717713 >>> 0) | 0;
  const _p$41 = 14;
  c = (_tmp$60 >>> 0) + ((_p$40 << _p$41 | (_p$40 >>> (32 - _p$41 | 0) | 0)) >>> 0) | 0;
  const _tmp$61 = c;
  const _p$42 = (((((((c ^ d) & a ^ d) >>> 0) + (b >>> 0) | 0) >>> 0) + (x0 >>> 0) | 0) >>> 0) + (-373897302 >>> 0) | 0;
  const _p$43 = 20;
  b = (_tmp$61 >>> 0) + ((_p$42 << _p$43 | (_p$42 >>> (32 - _p$43 | 0) | 0)) >>> 0) | 0;
  const _tmp$62 = b;
  const _p$44 = (((((((b ^ c) & d ^ c) >>> 0) + (a >>> 0) | 0) >>> 0) + (x5 >>> 0) | 0) >>> 0) + (-701558691 >>> 0) | 0;
  const _p$45 = 5;
  a = (_tmp$62 >>> 0) + ((_p$44 << _p$45 | (_p$44 >>> (32 - _p$45 | 0) | 0)) >>> 0) | 0;
  const _tmp$63 = a;
  const _p$46 = (((((((a ^ b) & c ^ b) >>> 0) + (d >>> 0) | 0) >>> 0) + (xa >>> 0) | 0) >>> 0) + (38016083 >>> 0) | 0;
  const _p$47 = 9;
  d = (_tmp$63 >>> 0) + ((_p$46 << _p$47 | (_p$46 >>> (32 - _p$47 | 0) | 0)) >>> 0) | 0;
  const _tmp$64 = d;
  const _p$48 = (((((((d ^ a) & b ^ a) >>> 0) + (c >>> 0) | 0) >>> 0) + (xf >>> 0) | 0) >>> 0) + (-660478335 >>> 0) | 0;
  const _p$49 = 14;
  c = (_tmp$64 >>> 0) + ((_p$48 << _p$49 | (_p$48 >>> (32 - _p$49 | 0) | 0)) >>> 0) | 0;
  const _tmp$65 = c;
  const _p$50 = (((((((c ^ d) & a ^ d) >>> 0) + (b >>> 0) | 0) >>> 0) + (x4 >>> 0) | 0) >>> 0) + (-405537848 >>> 0) | 0;
  const _p$51 = 20;
  b = (_tmp$65 >>> 0) + ((_p$50 << _p$51 | (_p$50 >>> (32 - _p$51 | 0) | 0)) >>> 0) | 0;
  const _tmp$66 = b;
  const _p$52 = (((((((b ^ c) & d ^ c) >>> 0) + (a >>> 0) | 0) >>> 0) + (x9 >>> 0) | 0) >>> 0) + (568446438 >>> 0) | 0;
  const _p$53 = 5;
  a = (_tmp$66 >>> 0) + ((_p$52 << _p$53 | (_p$52 >>> (32 - _p$53 | 0) | 0)) >>> 0) | 0;
  const _tmp$67 = a;
  const _p$54 = (((((((a ^ b) & c ^ b) >>> 0) + (d >>> 0) | 0) >>> 0) + (xe >>> 0) | 0) >>> 0) + (-1019803690 >>> 0) | 0;
  const _p$55 = 9;
  d = (_tmp$67 >>> 0) + ((_p$54 << _p$55 | (_p$54 >>> (32 - _p$55 | 0) | 0)) >>> 0) | 0;
  const _tmp$68 = d;
  const _p$56 = (((((((d ^ a) & b ^ a) >>> 0) + (c >>> 0) | 0) >>> 0) + (x3 >>> 0) | 0) >>> 0) + (-187363961 >>> 0) | 0;
  const _p$57 = 14;
  c = (_tmp$68 >>> 0) + ((_p$56 << _p$57 | (_p$56 >>> (32 - _p$57 | 0) | 0)) >>> 0) | 0;
  const _tmp$69 = c;
  const _p$58 = (((((((c ^ d) & a ^ d) >>> 0) + (b >>> 0) | 0) >>> 0) + (x8 >>> 0) | 0) >>> 0) + (1163531501 >>> 0) | 0;
  const _p$59 = 20;
  b = (_tmp$69 >>> 0) + ((_p$58 << _p$59 | (_p$58 >>> (32 - _p$59 | 0) | 0)) >>> 0) | 0;
  const _tmp$70 = b;
  const _p$60 = (((((((b ^ c) & d ^ c) >>> 0) + (a >>> 0) | 0) >>> 0) + (xd >>> 0) | 0) >>> 0) + (-1444681467 >>> 0) | 0;
  const _p$61 = 5;
  a = (_tmp$70 >>> 0) + ((_p$60 << _p$61 | (_p$60 >>> (32 - _p$61 | 0) | 0)) >>> 0) | 0;
  const _tmp$71 = a;
  const _p$62 = (((((((a ^ b) & c ^ b) >>> 0) + (d >>> 0) | 0) >>> 0) + (x2 >>> 0) | 0) >>> 0) + (-51403784 >>> 0) | 0;
  const _p$63 = 9;
  d = (_tmp$71 >>> 0) + ((_p$62 << _p$63 | (_p$62 >>> (32 - _p$63 | 0) | 0)) >>> 0) | 0;
  const _tmp$72 = d;
  const _p$64 = (((((((d ^ a) & b ^ a) >>> 0) + (c >>> 0) | 0) >>> 0) + (x7 >>> 0) | 0) >>> 0) + (1735328473 >>> 0) | 0;
  const _p$65 = 14;
  c = (_tmp$72 >>> 0) + ((_p$64 << _p$65 | (_p$64 >>> (32 - _p$65 | 0) | 0)) >>> 0) | 0;
  const _tmp$73 = c;
  const _p$66 = (((((((c ^ d) & a ^ d) >>> 0) + (b >>> 0) | 0) >>> 0) + (xc >>> 0) | 0) >>> 0) + (-1926607734 >>> 0) | 0;
  const _p$67 = 20;
  b = (_tmp$73 >>> 0) + ((_p$66 << _p$67 | (_p$66 >>> (32 - _p$67 | 0) | 0)) >>> 0) | 0;
  const _tmp$74 = b;
  const _p$68 = ((((((b ^ c ^ d) >>> 0) + (a >>> 0) | 0) >>> 0) + (x5 >>> 0) | 0) >>> 0) + (-378558 >>> 0) | 0;
  const _p$69 = 4;
  a = (_tmp$74 >>> 0) + ((_p$68 << _p$69 | (_p$68 >>> (32 - _p$69 | 0) | 0)) >>> 0) | 0;
  const _tmp$75 = a;
  const _p$70 = ((((((a ^ b ^ c) >>> 0) + (d >>> 0) | 0) >>> 0) + (x8 >>> 0) | 0) >>> 0) + (-2022574463 >>> 0) | 0;
  const _p$71 = 11;
  d = (_tmp$75 >>> 0) + ((_p$70 << _p$71 | (_p$70 >>> (32 - _p$71 | 0) | 0)) >>> 0) | 0;
  const _tmp$76 = d;
  const _p$72 = ((((((d ^ a ^ b) >>> 0) + (c >>> 0) | 0) >>> 0) + (xb >>> 0) | 0) >>> 0) + (1839030562 >>> 0) | 0;
  const _p$73 = 16;
  c = (_tmp$76 >>> 0) + ((_p$72 << _p$73 | (_p$72 >>> (32 - _p$73 | 0) | 0)) >>> 0) | 0;
  const _tmp$77 = c;
  const _p$74 = ((((((c ^ d ^ a) >>> 0) + (b >>> 0) | 0) >>> 0) + (xe >>> 0) | 0) >>> 0) + (-35309556 >>> 0) | 0;
  const _p$75 = 23;
  b = (_tmp$77 >>> 0) + ((_p$74 << _p$75 | (_p$74 >>> (32 - _p$75 | 0) | 0)) >>> 0) | 0;
  const _tmp$78 = b;
  const _p$76 = ((((((b ^ c ^ d) >>> 0) + (a >>> 0) | 0) >>> 0) + (x1 >>> 0) | 0) >>> 0) + (-1530992060 >>> 0) | 0;
  const _p$77 = 4;
  a = (_tmp$78 >>> 0) + ((_p$76 << _p$77 | (_p$76 >>> (32 - _p$77 | 0) | 0)) >>> 0) | 0;
  const _tmp$79 = a;
  const _p$78 = ((((((a ^ b ^ c) >>> 0) + (d >>> 0) | 0) >>> 0) + (x4 >>> 0) | 0) >>> 0) + (1272893353 >>> 0) | 0;
  const _p$79 = 11;
  d = (_tmp$79 >>> 0) + ((_p$78 << _p$79 | (_p$78 >>> (32 - _p$79 | 0) | 0)) >>> 0) | 0;
  const _tmp$80 = d;
  const _p$80 = ((((((d ^ a ^ b) >>> 0) + (c >>> 0) | 0) >>> 0) + (x7 >>> 0) | 0) >>> 0) + (-155497632 >>> 0) | 0;
  const _p$81 = 16;
  c = (_tmp$80 >>> 0) + ((_p$80 << _p$81 | (_p$80 >>> (32 - _p$81 | 0) | 0)) >>> 0) | 0;
  const _tmp$81 = c;
  const _p$82 = ((((((c ^ d ^ a) >>> 0) + (b >>> 0) | 0) >>> 0) + (xa >>> 0) | 0) >>> 0) + (-1094730640 >>> 0) | 0;
  const _p$83 = 23;
  b = (_tmp$81 >>> 0) + ((_p$82 << _p$83 | (_p$82 >>> (32 - _p$83 | 0) | 0)) >>> 0) | 0;
  const _tmp$82 = b;
  const _p$84 = ((((((b ^ c ^ d) >>> 0) + (a >>> 0) | 0) >>> 0) + (xd >>> 0) | 0) >>> 0) + (681279174 >>> 0) | 0;
  const _p$85 = 4;
  a = (_tmp$82 >>> 0) + ((_p$84 << _p$85 | (_p$84 >>> (32 - _p$85 | 0) | 0)) >>> 0) | 0;
  const _tmp$83 = a;
  const _p$86 = ((((((a ^ b ^ c) >>> 0) + (d >>> 0) | 0) >>> 0) + (x0 >>> 0) | 0) >>> 0) + (-358537222 >>> 0) | 0;
  const _p$87 = 11;
  d = (_tmp$83 >>> 0) + ((_p$86 << _p$87 | (_p$86 >>> (32 - _p$87 | 0) | 0)) >>> 0) | 0;
  const _tmp$84 = d;
  const _p$88 = ((((((d ^ a ^ b) >>> 0) + (c >>> 0) | 0) >>> 0) + (x3 >>> 0) | 0) >>> 0) + (-722521979 >>> 0) | 0;
  const _p$89 = 16;
  c = (_tmp$84 >>> 0) + ((_p$88 << _p$89 | (_p$88 >>> (32 - _p$89 | 0) | 0)) >>> 0) | 0;
  const _tmp$85 = c;
  const _p$90 = ((((((c ^ d ^ a) >>> 0) + (b >>> 0) | 0) >>> 0) + (x6 >>> 0) | 0) >>> 0) + (76029189 >>> 0) | 0;
  const _p$91 = 23;
  b = (_tmp$85 >>> 0) + ((_p$90 << _p$91 | (_p$90 >>> (32 - _p$91 | 0) | 0)) >>> 0) | 0;
  const _tmp$86 = b;
  const _p$92 = ((((((b ^ c ^ d) >>> 0) + (a >>> 0) | 0) >>> 0) + (x9 >>> 0) | 0) >>> 0) + (-640364487 >>> 0) | 0;
  const _p$93 = 4;
  a = (_tmp$86 >>> 0) + ((_p$92 << _p$93 | (_p$92 >>> (32 - _p$93 | 0) | 0)) >>> 0) | 0;
  const _tmp$87 = a;
  const _p$94 = ((((((a ^ b ^ c) >>> 0) + (d >>> 0) | 0) >>> 0) + (xc >>> 0) | 0) >>> 0) + (-421815835 >>> 0) | 0;
  const _p$95 = 11;
  d = (_tmp$87 >>> 0) + ((_p$94 << _p$95 | (_p$94 >>> (32 - _p$95 | 0) | 0)) >>> 0) | 0;
  const _tmp$88 = d;
  const _p$96 = ((((((d ^ a ^ b) >>> 0) + (c >>> 0) | 0) >>> 0) + (xf >>> 0) | 0) >>> 0) + (530742520 >>> 0) | 0;
  const _p$97 = 16;
  c = (_tmp$88 >>> 0) + ((_p$96 << _p$97 | (_p$96 >>> (32 - _p$97 | 0) | 0)) >>> 0) | 0;
  const _tmp$89 = c;
  const _p$98 = ((((((c ^ d ^ a) >>> 0) + (b >>> 0) | 0) >>> 0) + (x2 >>> 0) | 0) >>> 0) + (-995338651 >>> 0) | 0;
  const _p$99 = 23;
  b = (_tmp$89 >>> 0) + ((_p$98 << _p$99 | (_p$98 >>> (32 - _p$99 | 0) | 0)) >>> 0) | 0;
  const _tmp$90 = b;
  const _p$100 = ((((((c ^ (b | ~d)) >>> 0) + (a >>> 0) | 0) >>> 0) + (x0 >>> 0) | 0) >>> 0) + (-198630844 >>> 0) | 0;
  const _p$101 = 6;
  a = (_tmp$90 >>> 0) + ((_p$100 << _p$101 | (_p$100 >>> (32 - _p$101 | 0) | 0)) >>> 0) | 0;
  const _tmp$91 = a;
  const _p$102 = ((((((b ^ (a | ~c)) >>> 0) + (d >>> 0) | 0) >>> 0) + (x7 >>> 0) | 0) >>> 0) + (1126891415 >>> 0) | 0;
  const _p$103 = 10;
  d = (_tmp$91 >>> 0) + ((_p$102 << _p$103 | (_p$102 >>> (32 - _p$103 | 0) | 0)) >>> 0) | 0;
  const _tmp$92 = d;
  const _p$104 = ((((((a ^ (d | ~b)) >>> 0) + (c >>> 0) | 0) >>> 0) + (xe >>> 0) | 0) >>> 0) + (-1416354905 >>> 0) | 0;
  const _p$105 = 15;
  c = (_tmp$92 >>> 0) + ((_p$104 << _p$105 | (_p$104 >>> (32 - _p$105 | 0) | 0)) >>> 0) | 0;
  const _tmp$93 = c;
  const _p$106 = ((((((d ^ (c | ~a)) >>> 0) + (b >>> 0) | 0) >>> 0) + (x5 >>> 0) | 0) >>> 0) + (-57434055 >>> 0) | 0;
  const _p$107 = 21;
  b = (_tmp$93 >>> 0) + ((_p$106 << _p$107 | (_p$106 >>> (32 - _p$107 | 0) | 0)) >>> 0) | 0;
  const _tmp$94 = b;
  const _p$108 = ((((((c ^ (b | ~d)) >>> 0) + (a >>> 0) | 0) >>> 0) + (xc >>> 0) | 0) >>> 0) + (1700485571 >>> 0) | 0;
  const _p$109 = 6;
  a = (_tmp$94 >>> 0) + ((_p$108 << _p$109 | (_p$108 >>> (32 - _p$109 | 0) | 0)) >>> 0) | 0;
  const _tmp$95 = a;
  const _p$110 = ((((((b ^ (a | ~c)) >>> 0) + (d >>> 0) | 0) >>> 0) + (x3 >>> 0) | 0) >>> 0) + (-1894986606 >>> 0) | 0;
  const _p$111 = 10;
  d = (_tmp$95 >>> 0) + ((_p$110 << _p$111 | (_p$110 >>> (32 - _p$111 | 0) | 0)) >>> 0) | 0;
  const _tmp$96 = d;
  const _p$112 = ((((((a ^ (d | ~b)) >>> 0) + (c >>> 0) | 0) >>> 0) + (xa >>> 0) | 0) >>> 0) + (-1051523 >>> 0) | 0;
  const _p$113 = 15;
  c = (_tmp$96 >>> 0) + ((_p$112 << _p$113 | (_p$112 >>> (32 - _p$113 | 0) | 0)) >>> 0) | 0;
  const _tmp$97 = c;
  const _p$114 = ((((((d ^ (c | ~a)) >>> 0) + (b >>> 0) | 0) >>> 0) + (x1 >>> 0) | 0) >>> 0) + (-2054922799 >>> 0) | 0;
  const _p$115 = 21;
  b = (_tmp$97 >>> 0) + ((_p$114 << _p$115 | (_p$114 >>> (32 - _p$115 | 0) | 0)) >>> 0) | 0;
  const _tmp$98 = b;
  const _p$116 = ((((((c ^ (b | ~d)) >>> 0) + (a >>> 0) | 0) >>> 0) + (x8 >>> 0) | 0) >>> 0) + (1873313359 >>> 0) | 0;
  const _p$117 = 6;
  a = (_tmp$98 >>> 0) + ((_p$116 << _p$117 | (_p$116 >>> (32 - _p$117 | 0) | 0)) >>> 0) | 0;
  const _tmp$99 = a;
  const _p$118 = ((((((b ^ (a | ~c)) >>> 0) + (d >>> 0) | 0) >>> 0) + (xf >>> 0) | 0) >>> 0) + (-30611744 >>> 0) | 0;
  const _p$119 = 10;
  d = (_tmp$99 >>> 0) + ((_p$118 << _p$119 | (_p$118 >>> (32 - _p$119 | 0) | 0)) >>> 0) | 0;
  const _tmp$100 = d;
  const _p$120 = ((((((a ^ (d | ~b)) >>> 0) + (c >>> 0) | 0) >>> 0) + (x6 >>> 0) | 0) >>> 0) + (-1560198380 >>> 0) | 0;
  const _p$121 = 15;
  c = (_tmp$100 >>> 0) + ((_p$120 << _p$121 | (_p$120 >>> (32 - _p$121 | 0) | 0)) >>> 0) | 0;
  const _tmp$101 = c;
  const _p$122 = ((((((d ^ (c | ~a)) >>> 0) + (b >>> 0) | 0) >>> 0) + (xd >>> 0) | 0) >>> 0) + (1309151649 >>> 0) | 0;
  const _p$123 = 21;
  b = (_tmp$101 >>> 0) + ((_p$122 << _p$123 | (_p$122 >>> (32 - _p$123 | 0) | 0)) >>> 0) | 0;
  const _tmp$102 = b;
  const _p$124 = ((((((c ^ (b | ~d)) >>> 0) + (a >>> 0) | 0) >>> 0) + (x4 >>> 0) | 0) >>> 0) + (-145523070 >>> 0) | 0;
  const _p$125 = 6;
  a = (_tmp$102 >>> 0) + ((_p$124 << _p$125 | (_p$124 >>> (32 - _p$125 | 0) | 0)) >>> 0) | 0;
  const _tmp$103 = a;
  const _p$126 = ((((((b ^ (a | ~c)) >>> 0) + (d >>> 0) | 0) >>> 0) + (xb >>> 0) | 0) >>> 0) + (-1120210379 >>> 0) | 0;
  const _p$127 = 10;
  d = (_tmp$103 >>> 0) + ((_p$126 << _p$127 | (_p$126 >>> (32 - _p$127 | 0) | 0)) >>> 0) | 0;
  const _tmp$104 = d;
  const _p$128 = ((((((a ^ (d | ~b)) >>> 0) + (c >>> 0) | 0) >>> 0) + (x2 >>> 0) | 0) >>> 0) + (718787259 >>> 0) | 0;
  const _p$129 = 15;
  c = (_tmp$104 >>> 0) + ((_p$128 << _p$129 | (_p$128 >>> (32 - _p$129 | 0) | 0)) >>> 0) | 0;
  const _tmp$105 = c;
  const _p$130 = ((((((d ^ (c | ~a)) >>> 0) + (b >>> 0) | 0) >>> 0) + (x9 >>> 0) | 0) >>> 0) + (-343485551 >>> 0) | 0;
  const _p$131 = 21;
  b = (_tmp$105 >>> 0) + ((_p$130 << _p$131 | (_p$130 >>> (32 - _p$131 | 0) | 0)) >>> 0) | 0;
  const _array_1 = self.s;
  $bound_check(_array_1, 0);
  $bound_check(_array_1, 0);
  _array_1[0] = (_array_1[0] >>> 0) + (a >>> 0) | 0;
  const _array_3 = self.s;
  $bound_check(_array_3, 1);
  $bound_check(_array_3, 1);
  _array_3[1] = (_array_3[1] >>> 0) + (b >>> 0) | 0;
  const _array_5 = self.s;
  $bound_check(_array_5, 2);
  $bound_check(_array_5, 2);
  _array_5[2] = (_array_5[2] >>> 0) + (c >>> 0) | 0;
  const _array_7 = self.s;
  $bound_check(_array_7, 3);
  $bound_check(_array_7, 3);
  _array_7[3] = (_array_7[3] >>> 0) + (d >>> 0) | 0;
}
function _M0IP27gmlewis3md56DigestP27gmlewis3md58HashFunc5write(self, b) {
  self.len = BigInt.asUintN(64, self.len + 1n);
  const _tmp$38 = self.x;
  const _tmp$39 = self.nx;
  $bound_check(_tmp$38, _tmp$39);
  _tmp$38[_tmp$39] = b;
  self.nx = self.nx + 1 | 0;
  if (self.nx === 64) {
    _M0MP27gmlewis3md56Digest14block__generic(self);
    self.nx = 0;
    return;
  } else {
    return;
  }
}
function _M0IP27gmlewis3md56DigestP27gmlewis3md58HashFunc10check__sum(self) {
  const tmp = $makebytes(72, 0);
  $bound_check(tmp, 0);
  tmp[0] = 128;
  if (64n === 0n) {
    $panic();
  }
  const pad = Number(BigInt.asIntN(32, BigInt.asUintN(64, BigInt.asUintN(64, BigInt.asUintN(64, 55n - self.len)) % BigInt.asUintN(64, 64n)))) | 0;
  _M0FP27gmlewis3md515le__put__uint64(tmp, 1 + pad | 0, BigInt.asUintN(64, self.len << BigInt(3 & 63)));
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < ((1 + pad | 0) + 8 | 0)) {
      $bound_check(tmp, i);
      _M0IP27gmlewis3md56DigestP27gmlewis3md58HashFunc5write(self, tmp[i]);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (self.nx !== 0) {
    $panic();
  }
  const digest = $makebytes(16, 0);
  const _tmp$39 = self.s;
  $bound_check(_tmp$39, 0);
  _M0FP27gmlewis3md515le__put__uint32(digest, 0, _tmp$39[0]);
  const _tmp$40 = self.s;
  $bound_check(_tmp$40, 1);
  _M0FP27gmlewis3md515le__put__uint32(digest, 4, _tmp$40[1]);
  const _tmp$41 = self.s;
  $bound_check(_tmp$41, 2);
  _M0FP27gmlewis3md515le__put__uint32(digest, 8, _tmp$41[2]);
  const _tmp$42 = self.s;
  $bound_check(_tmp$42, 3);
  _M0FP27gmlewis3md515le__put__uint32(digest, 12, _tmp$42[3]);
  const result = _M0FPC16buffer11new_2einner(32);
  const _bind$4 = digest.length;
  let _tmp$43 = 0;
  while (true) {
    const _ = _tmp$43;
    if (_ < _bind$4) {
      const b = digest[_];
      _M0IPC16buffer6BufferPB6Logger11write__char(result, _M0FP27gmlewis3md57to__hex(b >> 4 & 15));
      _M0IPC16buffer6BufferPB6Logger11write__char(result, _M0FP27gmlewis3md57to__hex(b & 15));
      _tmp$43 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MPC15bytes5Bytes29to__unchecked__string_2einner(_M0MPC16buffer6Buffer9to__bytes(result), 0, undefined);
}
function _M0MP27gmlewis4sha16Digest3new() {
  return new _M0TP27gmlewis4sha16Digest(_M0MPC15array10FixedArray11from__arrayGjE(new _M0TPB9ArrayViewGjE(_M0MP27gmlewis4sha16Digest3newN7_2abindS81, 0, 5)), $makebytes(64, 0), 0, 0n);
}
function _M0FP27gmlewis4sha17to__hex(v) {
  return v < 10 ? v + 48 | 0 : (v - 10 | 0) + 97 | 0;
}
function _M0FP27gmlewis4sha115be__put__uint32(b, offset, value) {
  const _tmp$38 = offset + 3 | 0;
  const _p$4 = value & 255;
  $bound_check(b, _tmp$38);
  b[_tmp$38] = _p$4 & 255;
  const _tmp$39 = offset + 2 | 0;
  const _p$5 = value >>> 8 & 255;
  $bound_check(b, _tmp$39);
  b[_tmp$39] = _p$5 & 255;
  const _tmp$40 = offset + 1 | 0;
  const _p$6 = value >>> 16 & 255;
  $bound_check(b, _tmp$40);
  b[_tmp$40] = _p$6 & 255;
  const _p$7 = value >>> 24 & 255;
  $bound_check(b, offset);
  b[offset] = _p$7 & 255;
}
function _M0FP27gmlewis4sha115be__put__uint64(b, offset, value) {
  _M0FP27gmlewis4sha115be__put__uint32(b, offset + 4 | 0, Number(BigInt.asUintN(32, BigInt.asUintN(64, value & 4294967295n))) | 0);
  _M0FP27gmlewis4sha115be__put__uint32(b, offset, Number(BigInt.asUintN(32, BigInt.asUintN(64, BigInt.asUintN(64, BigInt.asUintN(64, value) >> BigInt(32 & 63)) & 4294967295n))) | 0);
}
function _M0MP27gmlewis4sha16Digest14block__generic(self) {
  const w = $make_array_len_and_init(16, 0);
  const p = self.x;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < 16) {
      const j = Math.imul(i, 4) | 0;
      $bound_check(p, j);
      const _p$4 = p[j];
      const _tmp$39 = _p$4 << 24;
      const _tmp$40 = j + 1 | 0;
      $bound_check(p, _tmp$40);
      const _p$5 = p[_tmp$40];
      const _tmp$41 = _tmp$39 | _p$5 << 16;
      const _tmp$42 = j + 2 | 0;
      $bound_check(p, _tmp$42);
      const _p$6 = p[_tmp$42];
      const _tmp$43 = _tmp$41 | _p$6 << 8;
      const _tmp$44 = j + 3 | 0;
      $bound_check(p, _tmp$44);
      const _p$7 = p[_tmp$44];
      $bound_check(w, i);
      w[i] = _tmp$43 | _p$7;
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _tmp$39 = self.h;
  $bound_check(_tmp$39, 0);
  let a = _tmp$39[0];
  const _tmp$40 = self.h;
  $bound_check(_tmp$40, 1);
  let b = _tmp$40[1];
  const _tmp$41 = self.h;
  $bound_check(_tmp$41, 2);
  let c = _tmp$41[2];
  const _tmp$42 = self.h;
  $bound_check(_tmp$42, 3);
  let d = _tmp$42[3];
  const _tmp$43 = self.h;
  $bound_check(_tmp$43, 4);
  let e = _tmp$43[4];
  let _tmp$44 = 0;
  while (true) {
    const i = _tmp$44;
    if (i < 16) {
      const f = b & c | ~b & d;
      const _p$4 = a;
      const _p$5 = 5;
      const _tmp$45 = ((((_p$4 << _p$5 | (_p$4 >>> (32 - _p$5 | 0) | 0)) >>> 0) + (f >>> 0) | 0) >>> 0) + (e >>> 0) | 0;
      const _tmp$46 = i & 15;
      $bound_check(w, _tmp$46);
      const t = (((_tmp$45 >>> 0) + (w[_tmp$46] >>> 0) | 0) >>> 0) + (1518500249 >>> 0) | 0;
      const _bind$4 = a;
      const _p$6 = b;
      const _p$7 = 30;
      const _bind$5 = _p$6 << _p$7 | (_p$6 >>> (32 - _p$7 | 0) | 0);
      const _bind$6 = c;
      const _bind$7 = d;
      a = t;
      b = _bind$4;
      c = _bind$5;
      d = _bind$6;
      e = _bind$7;
      _tmp$44 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let _tmp$45 = 16;
  while (true) {
    const i = _tmp$45;
    if (i < 20) {
      const _tmp$46 = i - 3 & 15;
      $bound_check(w, _tmp$46);
      const _tmp$47 = w[_tmp$46];
      const _tmp$48 = i - 8 & 15;
      $bound_check(w, _tmp$48);
      const _tmp$49 = _tmp$47 ^ w[_tmp$48];
      const _tmp$50 = i - 14 & 15;
      $bound_check(w, _tmp$50);
      const _tmp$51 = _tmp$49 ^ w[_tmp$50];
      const _tmp$52 = i & 15;
      $bound_check(w, _tmp$52);
      const tmp = _tmp$51 ^ w[_tmp$52];
      const _tmp$53 = i & 15;
      const _p$4 = 1;
      $bound_check(w, _tmp$53);
      w[_tmp$53] = tmp << _p$4 | (tmp >>> (32 - _p$4 | 0) | 0);
      const f = b & c | ~b & d;
      const _p$5 = a;
      const _p$6 = 5;
      const _tmp$54 = ((((_p$5 << _p$6 | (_p$5 >>> (32 - _p$6 | 0) | 0)) >>> 0) + (f >>> 0) | 0) >>> 0) + (e >>> 0) | 0;
      const _tmp$55 = i & 15;
      $bound_check(w, _tmp$55);
      const t = (((_tmp$54 >>> 0) + (w[_tmp$55] >>> 0) | 0) >>> 0) + (1518500249 >>> 0) | 0;
      const _bind$4 = a;
      const _p$7 = b;
      const _p$8 = 30;
      const _bind$5 = _p$7 << _p$8 | (_p$7 >>> (32 - _p$8 | 0) | 0);
      const _bind$6 = c;
      const _bind$7 = d;
      a = t;
      b = _bind$4;
      c = _bind$5;
      d = _bind$6;
      e = _bind$7;
      _tmp$45 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let _tmp$46 = 20;
  while (true) {
    const i = _tmp$46;
    if (i < 40) {
      const _tmp$47 = i - 3 & 15;
      $bound_check(w, _tmp$47);
      const _tmp$48 = w[_tmp$47];
      const _tmp$49 = i - 8 & 15;
      $bound_check(w, _tmp$49);
      const _tmp$50 = _tmp$48 ^ w[_tmp$49];
      const _tmp$51 = i - 14 & 15;
      $bound_check(w, _tmp$51);
      const _tmp$52 = _tmp$50 ^ w[_tmp$51];
      const _tmp$53 = i & 15;
      $bound_check(w, _tmp$53);
      const tmp = _tmp$52 ^ w[_tmp$53];
      const _tmp$54 = i & 15;
      const _p$4 = 1;
      $bound_check(w, _tmp$54);
      w[_tmp$54] = tmp << _p$4 | (tmp >>> (32 - _p$4 | 0) | 0);
      const f = b ^ c ^ d;
      const _p$5 = a;
      const _p$6 = 5;
      const _tmp$55 = ((((_p$5 << _p$6 | (_p$5 >>> (32 - _p$6 | 0) | 0)) >>> 0) + (f >>> 0) | 0) >>> 0) + (e >>> 0) | 0;
      const _tmp$56 = i & 15;
      $bound_check(w, _tmp$56);
      const t = (((_tmp$55 >>> 0) + (w[_tmp$56] >>> 0) | 0) >>> 0) + (1859775393 >>> 0) | 0;
      const _bind$4 = a;
      const _p$7 = b;
      const _p$8 = 30;
      const _bind$5 = _p$7 << _p$8 | (_p$7 >>> (32 - _p$8 | 0) | 0);
      const _bind$6 = c;
      const _bind$7 = d;
      a = t;
      b = _bind$4;
      c = _bind$5;
      d = _bind$6;
      e = _bind$7;
      _tmp$46 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let _tmp$47 = 40;
  while (true) {
    const i = _tmp$47;
    if (i < 60) {
      const _tmp$48 = i - 3 & 15;
      $bound_check(w, _tmp$48);
      const _tmp$49 = w[_tmp$48];
      const _tmp$50 = i - 8 & 15;
      $bound_check(w, _tmp$50);
      const _tmp$51 = _tmp$49 ^ w[_tmp$50];
      const _tmp$52 = i - 14 & 15;
      $bound_check(w, _tmp$52);
      const _tmp$53 = _tmp$51 ^ w[_tmp$52];
      const _tmp$54 = i & 15;
      $bound_check(w, _tmp$54);
      const tmp = _tmp$53 ^ w[_tmp$54];
      const _tmp$55 = i & 15;
      const _p$4 = 1;
      $bound_check(w, _tmp$55);
      w[_tmp$55] = tmp << _p$4 | (tmp >>> (32 - _p$4 | 0) | 0);
      const f = (b | c) & d | b & c;
      const _p$5 = a;
      const _p$6 = 5;
      const _tmp$56 = ((((_p$5 << _p$6 | (_p$5 >>> (32 - _p$6 | 0) | 0)) >>> 0) + (f >>> 0) | 0) >>> 0) + (e >>> 0) | 0;
      const _tmp$57 = i & 15;
      $bound_check(w, _tmp$57);
      const t = (((_tmp$56 >>> 0) + (w[_tmp$57] >>> 0) | 0) >>> 0) + (-1894007588 >>> 0) | 0;
      const _bind$4 = a;
      const _p$7 = b;
      const _p$8 = 30;
      const _bind$5 = _p$7 << _p$8 | (_p$7 >>> (32 - _p$8 | 0) | 0);
      const _bind$6 = c;
      const _bind$7 = d;
      a = t;
      b = _bind$4;
      c = _bind$5;
      d = _bind$6;
      e = _bind$7;
      _tmp$47 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let _tmp$48 = 60;
  while (true) {
    const i = _tmp$48;
    if (i < 80) {
      const _tmp$49 = i - 3 & 15;
      $bound_check(w, _tmp$49);
      const _tmp$50 = w[_tmp$49];
      const _tmp$51 = i - 8 & 15;
      $bound_check(w, _tmp$51);
      const _tmp$52 = _tmp$50 ^ w[_tmp$51];
      const _tmp$53 = i - 14 & 15;
      $bound_check(w, _tmp$53);
      const _tmp$54 = _tmp$52 ^ w[_tmp$53];
      const _tmp$55 = i & 15;
      $bound_check(w, _tmp$55);
      const tmp = _tmp$54 ^ w[_tmp$55];
      const _tmp$56 = i & 15;
      const _p$4 = 1;
      $bound_check(w, _tmp$56);
      w[_tmp$56] = tmp << _p$4 | (tmp >>> (32 - _p$4 | 0) | 0);
      const f = b ^ c ^ d;
      const _p$5 = a;
      const _p$6 = 5;
      const _tmp$57 = ((((_p$5 << _p$6 | (_p$5 >>> (32 - _p$6 | 0) | 0)) >>> 0) + (f >>> 0) | 0) >>> 0) + (e >>> 0) | 0;
      const _tmp$58 = i & 15;
      $bound_check(w, _tmp$58);
      const t = (((_tmp$57 >>> 0) + (w[_tmp$58] >>> 0) | 0) >>> 0) + (-899497514 >>> 0) | 0;
      const _bind$4 = a;
      const _p$7 = b;
      const _p$8 = 30;
      const _bind$5 = _p$7 << _p$8 | (_p$7 >>> (32 - _p$8 | 0) | 0);
      const _bind$6 = c;
      const _bind$7 = d;
      a = t;
      b = _bind$4;
      c = _bind$5;
      d = _bind$6;
      e = _bind$7;
      _tmp$48 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _array_1 = self.h;
  $bound_check(_array_1, 0);
  $bound_check(_array_1, 0);
  _array_1[0] = (_array_1[0] >>> 0) + (a >>> 0) | 0;
  const _array_3 = self.h;
  $bound_check(_array_3, 1);
  $bound_check(_array_3, 1);
  _array_3[1] = (_array_3[1] >>> 0) + (b >>> 0) | 0;
  const _array_5 = self.h;
  $bound_check(_array_5, 2);
  $bound_check(_array_5, 2);
  _array_5[2] = (_array_5[2] >>> 0) + (c >>> 0) | 0;
  const _array_7 = self.h;
  $bound_check(_array_7, 3);
  $bound_check(_array_7, 3);
  _array_7[3] = (_array_7[3] >>> 0) + (d >>> 0) | 0;
  const _array_9 = self.h;
  $bound_check(_array_9, 4);
  $bound_check(_array_9, 4);
  _array_9[4] = (_array_9[4] >>> 0) + (e >>> 0) | 0;
}
function _M0IP27gmlewis4sha16DigestP27gmlewis2io10ByteWriter11write__byte(self, b) {
  self.len = BigInt.asUintN(64, self.len + 1n);
  const _tmp$38 = self.x;
  const _tmp$39 = self.nx;
  $bound_check(_tmp$38, _tmp$39);
  _tmp$38[_tmp$39] = b;
  self.nx = self.nx + 1 | 0;
  if (self.nx === 64) {
    _M0MP27gmlewis4sha16Digest14block__generic(self);
    self.nx = 0;
  }
  return undefined;
}
function _M0MP27gmlewis4sha16Digest3sum(self) {
  const tmp = $makebytes(72, 0);
  $bound_check(tmp, 0);
  tmp[0] = 128;
  let t;
  if (64n === 0n) {
    $panic();
  }
  if (BigInt.asUintN(64, BigInt.asUintN(64, BigInt.asUintN(64, self.len) % BigInt.asUintN(64, 64n))) < BigInt.asUintN(64, 56n)) {
    if (64n === 0n) {
      $panic();
    }
    t = Number(BigInt.asIntN(32, BigInt.asUintN(64, 56n - BigInt.asUintN(64, BigInt.asUintN(64, self.len) % BigInt.asUintN(64, 64n))))) | 0;
  } else {
    if (64n === 0n) {
      $panic();
    }
    t = Number(BigInt.asIntN(32, BigInt.asUintN(64, 120n - BigInt.asUintN(64, BigInt.asUintN(64, self.len) % BigInt.asUintN(64, 64n))))) | 0;
  }
  const len = BigInt.asUintN(64, self.len << BigInt(3 & 63));
  _M0FP27gmlewis4sha115be__put__uint64(tmp, t, len);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < (t + 8 | 0)) {
      $bound_check(tmp, i);
      const _bind$4 = _M0IP27gmlewis4sha16DigestP27gmlewis2io10ByteWriter11write__byte(self, tmp[i]);
      if (_bind$4 === undefined) {
      } else {
        $panic();
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (self.nx !== 0) {
    $panic();
  }
  const digest = $makebytes(20, 0);
  const _tmp$39 = self.h;
  $bound_check(_tmp$39, 0);
  _M0FP27gmlewis4sha115be__put__uint32(digest, 0, _tmp$39[0]);
  const _tmp$40 = self.h;
  $bound_check(_tmp$40, 1);
  _M0FP27gmlewis4sha115be__put__uint32(digest, 4, _tmp$40[1]);
  const _tmp$41 = self.h;
  $bound_check(_tmp$41, 2);
  _M0FP27gmlewis4sha115be__put__uint32(digest, 8, _tmp$41[2]);
  const _tmp$42 = self.h;
  $bound_check(_tmp$42, 3);
  _M0FP27gmlewis4sha115be__put__uint32(digest, 12, _tmp$42[3]);
  const _tmp$43 = self.h;
  $bound_check(_tmp$43, 4);
  _M0FP27gmlewis4sha115be__put__uint32(digest, 16, _tmp$43[4]);
  return digest;
}
function _M0MP27gmlewis4sha16Digest10check__sum(self) {
  const digest = _M0MP27gmlewis4sha16Digest3sum(self);
  const result = _M0FPC16buffer11new_2einner(40);
  const _bind$4 = digest.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const b = digest[_];
      _M0IPC16buffer6BufferPB6Logger11write__char(result, _M0FP27gmlewis4sha17to__hex(b >> 4 & 15));
      _M0IPC16buffer6BufferPB6Logger11write__char(result, _M0FP27gmlewis4sha17to__hex(b & 15));
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MPC15bytes5Bytes29to__unchecked__string_2einner(_M0MPC16buffer6Buffer9to__bytes(result), 0, undefined);
}
function _M0FP219moonbit_2dcommunity7piediff12find__uniqueGsE(old, new_) {
  const match_lines = _M0MPC17hashmap7HashMap3newGssE(undefined);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < (old.end - old.start | 0)) {
      if (_M0MPC17hashmap7HashMap8containsGsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEE(match_lines, _M0MPC15array9ArrayView2atGRP219moonbit_2dcommunity7piediff4EditE(old, i))) {
        const _p$4 = _M0MPC17hashmap7HashMap3getGsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEE(match_lines, _M0MPC15array9ArrayView2atGRP219moonbit_2dcommunity7piediff4EditE(old, i));
        let count_record;
        if (_p$4 === undefined) {
          count_record = $panic();
        } else {
          const _p$5 = _p$4;
          count_record = _p$5;
        }
        count_record.old_count = count_record.old_count + 1 | 0;
      } else {
        _M0MPC17hashmap7HashMap3setGsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEE(match_lines, _M0MPC15array9ArrayView2atGRP219moonbit_2dcommunity7piediff4EditE(old, i), new _M0TP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsE(i, 1, -1, 0));
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < (new_.end - new_.start | 0)) {
      if (_M0MPC17hashmap7HashMap8containsGsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEE(match_lines, _M0MPC15array9ArrayView2atGRP219moonbit_2dcommunity7piediff4EditE(new_, i))) {
        const _p$4 = _M0MPC17hashmap7HashMap3getGsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEE(match_lines, _M0MPC15array9ArrayView2atGRP219moonbit_2dcommunity7piediff4EditE(new_, i));
        let count_record;
        if (_p$4 === undefined) {
          count_record = $panic();
        } else {
          const _p$5 = _p$4;
          count_record = _p$5;
        }
        count_record.new_count = count_record.new_count + 1 | 0;
        if (count_record.new_idx === -1) {
          count_record.new_idx = i;
        }
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const match_lines$2 = _M0MPB4Iter6filterGUsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEEE(_M0MPC17hashmap7HashMap4iterGsRP219moonbit_2dcommunity7piediff47_24moonbit_2dcommunity_2fpiediff_2efind__uniqueL11CountRecordGsEE(match_lines), (p) => p._1.new_count === 1 && p._1.old_count === 1);
  const unique_match_lines = [];
  while (true) {
    const _bind$4 = _M0MPB4Iter4nextGUssEE(match_lines$2);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _pair = _Some;
      const _record = _pair._1;
      _M0MPC15array5Array4pushGUssEE(unique_match_lines, { _0: _record.old_idx, _1: _record.new_idx });
      continue;
    }
  }
  _M0MPC15array5Array13sort__by__keyGUiiEiE(unique_match_lines, (pair) => pair._0);
  return unique_match_lines;
}
function _M0MP219moonbit_2dcommunity7piediff11BackPointer9to__arrayGUiiEE(self) {
  const result = [];
  let self$2 = self;
  while (true) {
    const _bind$4 = self$2.prev;
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _prev = _Some;
      _M0MPC15array5Array4pushGUssEE(result, self$2.value);
      self$2 = _prev;
      continue;
    }
  }
  _M0MPC15array5Array4pushGUssEE(result, self$2.value);
  return _M0MPC15array5Array3revGRP38bobzhang6moonjq3ast4ExprE(result);
}
function _M0MP219moonbit_2dcommunity7piediff5Piles9is__emptyGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE(self) {
  return self.length === 0;
}
function _M0MP219moonbit_2dcommunity7piediff5Piles4lastGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE(self) {
  return _M0MPC15array5Array4lastGURP219moonbit_2dcommunity4yaml4YamliEE(self);
}
function _M0MP219moonbit_2dcommunity7piediff5Piles9put__backGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE(self, singleton) {
  _M0MPC15array5Array4pushGUssEE(self, new _M0TP219moonbit_2dcommunity7piediff5StackGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE(singleton, _M0DTPC14list4ListGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE5Empty__));
}
function _M0MP219moonbit_2dcommunity7piediff5Piles7op__getGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE(self, i) {
  return _M0MPC15array5Array2atGUssEE(self, i);
}
function _M0MP219moonbit_2dcommunity7piediff5Stack4pushGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE(self, t) {
  const _p$4 = self.stack;
  const _p$5 = self.top;
  self.stack = new _M0DTPC14list4ListGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE4More(_p$5, _p$4);
  self.top = t;
}
function _M0MP219moonbit_2dcommunity7piediff5Piles23put__by__binary__search(self, new_idx, place) {
  let lo = -1;
  let hi = self.length;
  while (true) {
    if ((lo + 1 | 0) < hi) {
      const mid = (lo + hi | 0) / 2 | 0;
      if (_M0MP219moonbit_2dcommunity7piediff5Piles7op__getGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE(self, mid).top.value._0 < new_idx) {
        lo = mid;
      } else {
        hi = mid;
      }
      continue;
    } else {
      break;
    }
  }
  if (lo >= 0) {
    const prev = _M0MP219moonbit_2dcommunity7piediff5Piles7op__getGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE(self, lo).top;
    if ((lo + 1 | 0) < self.length) {
      _M0MP219moonbit_2dcommunity7piediff5Stack4pushGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE(_M0MP219moonbit_2dcommunity7piediff5Piles7op__getGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE(self, lo + 1 | 0), new _M0TP219moonbit_2dcommunity7piediff11BackPointerGUiiEE({ _0: new_idx, _1: place }, prev));
      return;
    } else {
      _M0MP219moonbit_2dcommunity7piediff5Piles9put__backGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE(self, new _M0TP219moonbit_2dcommunity7piediff11BackPointerGUiiEE({ _0: new_idx, _1: place }, prev));
      return;
    }
  } else {
    _M0MP219moonbit_2dcommunity7piediff5Stack4pushGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE(_M0MP219moonbit_2dcommunity7piediff5Piles7op__getGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE(self, 0), new _M0TP219moonbit_2dcommunity7piediff11BackPointerGUiiEE({ _0: new_idx, _1: place }, undefined));
    return;
  }
}
function _M0FP219moonbit_2dcommunity7piediff11unique__lcsGsE(old, new_) {
  const matches = _M0FP219moonbit_2dcommunity7piediff12find__uniqueGsE(old, new_);
  const piles = _M0MPC15array5Array11new_2einnerGRP411moonbitlang6regexp8internal2vm6ThreadE(matches.length);
  let _tmp$38 = 0;
  while (true) {
    const place = _tmp$38;
    if (place < matches.length) {
      const _bind$4 = _M0MPC15array5Array2atGUssEE(matches, place);
      const _new_idx = _bind$4._1;
      if (_M0MP219moonbit_2dcommunity7piediff5Piles9is__emptyGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE(piles)) {
        _M0MP219moonbit_2dcommunity7piediff5Piles9put__backGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE(piles, new _M0TP219moonbit_2dcommunity7piediff11BackPointerGUiiEE({ _0: _new_idx, _1: place }, undefined));
      } else {
        _M0MP219moonbit_2dcommunity7piediff5Piles23put__by__binary__search(piles, _new_idx, place);
      }
      _tmp$38 = place + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$4 = _M0MP219moonbit_2dcommunity7piediff5Piles4lastGRP219moonbit_2dcommunity7piediff11BackPointerGUiiEEE(piles);
  if (_bind$4 === undefined) {
    const _bind$5 = [];
    return new _M0TPB9ArrayViewGUiiEE(_bind$5, 0, 0);
  } else {
    const _Some = _bind$4;
    const _head = _Some;
    const seq = [];
    const _it = _M0MPC15array5Array4iterGsE(_M0MP219moonbit_2dcommunity7piediff11BackPointer9to__arrayGUiiEE(_head.top));
    while (true) {
      const _bind$5 = _M0MPB4Iter4nextGUssEE(_it);
      if (_bind$5 === undefined) {
        break;
      } else {
        const _Some$2 = _bind$5;
        const _pair = _Some$2;
        const _place = _pair._1;
        _M0MPC15array5Array4pushGUssEE(seq, _M0MPC15array5Array2atGUssEE(matches, _place));
        continue;
      }
    }
    return new _M0TPB9ArrayViewGUiiEE(seq, 0, seq.length);
  }
}
function _M0IP219moonbit_2dcommunity7piediff5RangePB4Show6output(self, logger) {
  let beginning = self._0 + 1 | 0;
  const len = self._1 - self._0 | 0;
  if (len === 1) {
    logger.method_table.method_0(logger.self, _M0MPC13int3Int18to__string_2einner(beginning, 10));
    return;
  } else {
    if (len === 0) {
      beginning = beginning - 1 | 0;
    }
    logger.method_table.method_0(logger.self, _M0MPC13int3Int18to__string_2einner(beginning, 10));
    logger.method_table.method_3(logger.self, 44);
    logger.method_table.method_0(logger.self, _M0MPC13int3Int18to__string_2einner(len, 10));
    return;
  }
}
function _M0MP219moonbit_2dcommunity7piediff4Edit10new__range(self) {
  switch (self.$tag) {
    case 1: {
      const _Insert = self;
      const _new_index = _Insert._1;
      const _len = _Insert._2;
      return { _0: _new_index, _1: _new_index + _len | 0 };
    }
    case 0: {
      const _Delete = self;
      const _new_index$2 = _Delete._1;
      return { _0: _new_index$2, _1: _new_index$2 };
    }
    default: {
      const _Equal = self;
      const _new_index$3 = _Equal._1;
      const _len$2 = _Equal._2;
      return { _0: _new_index$3, _1: _new_index$3 + _len$2 | 0 };
    }
  }
}
function _M0MP219moonbit_2dcommunity7piediff4Edit10old__range(self) {
  switch (self.$tag) {
    case 1: {
      const _Insert = self;
      const _old_index = _Insert._0;
      return { _0: _old_index, _1: _old_index };
    }
    case 0: {
      const _Delete = self;
      const _old_index$2 = _Delete._0;
      const _len = _Delete._2;
      return { _0: _old_index$2, _1: _old_index$2 + _len | 0 };
    }
    default: {
      const _Equal = self;
      const _old_index$3 = _Equal._0;
      const _len$2 = _Equal._2;
      return { _0: _old_index$3, _1: _old_index$3 + _len$2 | 0 };
    }
  }
}
function _M0MP219moonbit_2dcommunity7piediff10HunkHeader3new(edits) {
  const _bind$4 = _M0MP219moonbit_2dcommunity7piediff4Edit10old__range(_M0MPC15array9ArrayView2atGRP219moonbit_2dcommunity7piediff4EditE(edits, 0));
  const _first_old_start = _bind$4._0;
  const _first_old_end = _bind$4._1;
  const _bind$5 = _M0MP219moonbit_2dcommunity7piediff4Edit10new__range(_M0MPC15array9ArrayView2atGRP219moonbit_2dcommunity7piediff4EditE(edits, 0));
  const _first_new_start = _bind$5._0;
  const _first_new_end = _bind$5._1;
  let old_end = _first_old_end;
  let new_end = _first_new_end;
  let found_old_end = false;
  let found_new_end = false;
  let i = edits.end - edits.start | 0;
  while (true) {
    if (i > 0) {
      i = i - 1 | 0;
      const edit = _M0MPC15array9ArrayView2atGRP219moonbit_2dcommunity7piediff4EditE(edits, i);
      const _bind$6 = _M0MP219moonbit_2dcommunity7piediff4Edit10old__range(edit);
      const _edit_old_start = _bind$6._0;
      const _edit_old_end = _bind$6._1;
      const _bind$7 = _M0MP219moonbit_2dcommunity7piediff4Edit10new__range(edit);
      const _edit_new_start = _bind$7._0;
      const _edit_new_end = _bind$7._1;
      if (!found_old_end && _edit_old_start !== _edit_old_end) {
        old_end = _edit_old_end;
        found_old_end = true;
      }
      if (!found_new_end && _edit_new_start !== _edit_new_end) {
        new_end = _edit_new_end;
        found_new_end = true;
      }
      if (found_old_end && found_new_end) {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  return { _0: { _0: _first_old_start, _1: old_end }, _1: { _0: _first_new_start, _1: new_end } };
}
function _M0IP219moonbit_2dcommunity7piediff10HunkHeaderPB4Show6output(self, logger) {
  logger.method_table.method_0(logger.self, `@@ -${_M0IP016_24default__implPB4Show10to__stringGRP219moonbit_2dcommunity7piediff5RangeE(self._0)} +${_M0IP016_24default__implPB4Show10to__stringGRP219moonbit_2dcommunity7piediff5RangeE(self._1)} @@`);
}
function _M0MP219moonbit_2dcommunity7piediff4Edit10view__fromGsE(self, old, new_) {
  switch (self.$tag) {
    case 1: {
      const _Insert = self;
      const _new_index = _Insert._1;
      const _len = _Insert._2;
      return _M0MPC15array9ArrayView12view_2einnerGsE(new_, _new_index, _new_index + _len | 0);
    }
    case 0: {
      const _Delete = self;
      const _old_index = _Delete._0;
      const _len$2 = _Delete._2;
      return _M0MPC15array9ArrayView12view_2einnerGsE(old, _old_index, _old_index + _len$2 | 0);
    }
    default: {
      const _Equal = self;
      const _old_index$2 = _Equal._0;
      const _len$3 = _Equal._2;
      return _M0MPC15array9ArrayView12view_2einnerGsE(old, _old_index$2, _old_index$2 + _len$3 | 0);
    }
  }
}
function _M0IP219moonbit_2dcommunity7piediff4HunkPB4Show6outputGsE(self, logger) {
  const header = _M0IP016_24default__implPB4Show10to__stringGRP219moonbit_2dcommunity7piediff10HunkHeaderE(_M0MP219moonbit_2dcommunity7piediff10HunkHeader3new(self.edits));
  logger.method_table.method_0(logger.self, header);
  logger.method_table.method_3(logger.self, 10);
  const _bind$4 = self.edits;
  const _bind$5 = _bind$4.end - _bind$4.start | 0;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const edit = _bind$4.buf[_bind$4.start + _ | 0];
      let prefix;
      let slice;
      _L: {
        switch (edit.$tag) {
          case 1: {
            prefix = "+";
            slice = _M0MP219moonbit_2dcommunity7piediff4Edit10view__fromGsE(edit, self.old, self.new);
            break _L;
          }
          case 0: {
            prefix = "-";
            slice = _M0MP219moonbit_2dcommunity7piediff4Edit10view__fromGsE(edit, self.old, self.new);
            break _L;
          }
          default: {
            prefix = " ";
            slice = _M0MP219moonbit_2dcommunity7piediff4Edit10view__fromGsE(edit, self.old, self.new);
            break _L;
          }
        }
      }
      const _bind$6 = slice.end - slice.start | 0;
      let _tmp$39 = 0;
      while (true) {
        const _$2 = _tmp$39;
        if (_$2 < _bind$6) {
          const s = slice.buf[slice.start + _$2 | 0];
          logger.method_table.method_0(logger.self, `${prefix}${s}\n`);
          _tmp$39 = _$2 + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0FP219moonbit_2dcommunity7piediff20group__edits_2einnerGsE(edits, radius, old, new_) {
  if (radius >= 0) {
    if (edits.length === 0) {
      return [];
    }
    const n = edits.length;
    let pending = _M0MPC15array5Array11new_2einnerGRP411moonbitlang6regexp8internal2vm6ThreadE(0);
    const result = _M0MPC15array5Array11new_2einnerGRP411moonbitlang6regexp8internal2vm6ThreadE(0);
    const _bind$4 = edits.length;
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < _bind$4) {
        const edit = edits[i];
        if (edit.$tag === 2) {
          const _Equal = edit;
          const _old_index = _Equal._0;
          const _new_index = _Equal._1;
          const _len = _Equal._2;
          let old_index;
          let new_index;
          let len;
          _L: {
            if (i === 0) {
              const offset = _len < radius ? 0 : _len - radius | 0;
              old_index = _old_index + offset | 0;
              new_index = _new_index + offset | 0;
              len = _len - offset | 0;
              break _L;
            } else {
              old_index = _old_index;
              new_index = _new_index;
              len = _len;
              break _L;
            }
          }
          const len$2 = i === (n - 1 | 0) ? len - (len < radius ? 0 : len - radius | 0) | 0 : len;
          if (len$2 > (Math.imul(radius, 2) | 0)) {
            _M0MPC15array5Array4pushGUssEE(pending, new _M0DTP219moonbit_2dcommunity7piediff4Edit5Equal(old_index, new_index, radius));
            const _bind$5 = pending;
            _M0MPC15array5Array4pushGUssEE(result, new _M0TP219moonbit_2dcommunity7piediff4HunkGsE(new _M0TPB9ArrayViewGRP219moonbit_2dcommunity7piediff4EditE(_bind$5, 0, _bind$5.length), old, new_));
            const offset = len$2 < radius ? 0 : len$2 - radius | 0;
            pending = [new _M0DTP219moonbit_2dcommunity7piediff4Edit5Equal(old_index + offset | 0, new_index + offset | 0, len$2 - offset | 0)];
          } else {
            if (len$2 > 0) {
              _M0MPC15array5Array4pushGUssEE(pending, new _M0DTP219moonbit_2dcommunity7piediff4Edit5Equal(old_index, new_index, len$2));
            }
          }
        } else {
          _M0MPC15array5Array4pushGUssEE(pending, edit);
        }
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    const _bind$5 = pending;
    let _tmp$39;
    if (_bind$5.length === 0) {
      _tmp$39 = true;
    } else {
      const _bind$6 = pending;
      if (_bind$6.length === 1) {
        const _x = _bind$6[0];
        if (_x.$tag === 2) {
          _tmp$39 = true;
        } else {
          _tmp$39 = false;
        }
      } else {
        _tmp$39 = false;
      }
    }
    if (!_tmp$39) {
      const _bind$6 = pending;
      _M0MPC15array5Array4pushGUssEE(result, new _M0TP219moonbit_2dcommunity7piediff4HunkGsE(new _M0TPB9ArrayViewGRP219moonbit_2dcommunity7piediff4EditE(_bind$6, 0, _bind$6.length), old, new_));
    }
    return result;
  } else {
    return _M0FPC15abort5abortGRPB5ArrayGRP219moonbit_2dcommunity7piediff4HunkGsEEE("radius must be non-negative");
  }
}
function _M0FP219moonbit_2dcommunity7piediff4diagGsE(forward_search_diagonal, backward_search_diagonal, diagonal_shift, lhs_get, rhs_get, lhs_offset, lhs_limit, rhs_offset, rhs_limit, too_expensive, find_minimal) {
  const dmin = lhs_offset - rhs_limit | 0;
  const dmax = lhs_limit - rhs_offset | 0;
  const fmid = lhs_offset - rhs_offset | 0;
  const bmid = lhs_limit - rhs_limit | 0;
  const odd = (fmid - bmid & 1) !== 0;
  const _tmp$38 = diagonal_shift + fmid | 0;
  $bound_check(forward_search_diagonal, _tmp$38);
  forward_search_diagonal[_tmp$38] = lhs_offset;
  const _tmp$39 = diagonal_shift + bmid | 0;
  $bound_check(backward_search_diagonal, _tmp$39);
  backward_search_diagonal[_tmp$39] = lhs_limit;
  let _tmp$40 = 1;
  let _tmp$41 = fmid;
  let _tmp$42 = fmid;
  let _tmp$43 = bmid;
  let _tmp$44 = bmid;
  while (true) {
    const c = _tmp$40;
    const fmin = _tmp$41;
    const fmax = _tmp$42;
    const bmin = _tmp$43;
    const bmax = _tmp$44;
    let fmin$2;
    if (fmin > dmin) {
      const _tmp$45 = (diagonal_shift + fmin | 0) - 2 | 0;
      $bound_check(forward_search_diagonal, _tmp$45);
      forward_search_diagonal[_tmp$45] = -1;
      fmin$2 = fmin - 1 | 0;
    } else {
      fmin$2 = fmin + 1 | 0;
    }
    let fmax$2;
    if (fmax < dmax) {
      const _tmp$45 = (diagonal_shift + fmax | 0) + 2 | 0;
      $bound_check(forward_search_diagonal, _tmp$45);
      forward_search_diagonal[_tmp$45] = -1;
      fmax$2 = fmax + 1 | 0;
    } else {
      fmax$2 = fmax - 1 | 0;
    }
    let forward_result = undefined;
    let d = fmax$2;
    while (true) {
      if (d >= fmin$2) {
        const _tmp$45 = (diagonal_shift + d | 0) - 1 | 0;
        $bound_check(forward_search_diagonal, _tmp$45);
        const tlo = forward_search_diagonal[_tmp$45];
        const _tmp$46 = (diagonal_shift + d | 0) + 1 | 0;
        $bound_check(forward_search_diagonal, _tmp$46);
        const thi = forward_search_diagonal[_tmp$46];
        const x = tlo >= thi ? tlo + 1 | 0 : thi;
        let x_cur = x;
        let y_cur = x_cur - d | 0;
        while (true) {
          if (x_cur < lhs_limit && (y_cur < rhs_limit && lhs_get(x_cur) === rhs_get(y_cur))) {
            x_cur = x_cur + 1 | 0;
            y_cur = y_cur + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        const _tmp$47 = diagonal_shift + d | 0;
        $bound_check(forward_search_diagonal, _tmp$47);
        forward_search_diagonal[_tmp$47] = x_cur;
        let _tmp$48;
        if (odd) {
          let _tmp$49;
          if (bmin <= d) {
            let _tmp$50;
            if (d <= bmax) {
              const _tmp$51 = diagonal_shift + d | 0;
              $bound_check(backward_search_diagonal, _tmp$51);
              const _tmp$52 = backward_search_diagonal[_tmp$51];
              const _tmp$53 = diagonal_shift + d | 0;
              $bound_check(forward_search_diagonal, _tmp$53);
              _tmp$50 = _tmp$52 <= forward_search_diagonal[_tmp$53];
            } else {
              _tmp$50 = false;
            }
            _tmp$49 = _tmp$50;
          } else {
            _tmp$49 = false;
          }
          _tmp$48 = _tmp$49;
        } else {
          _tmp$48 = false;
        }
        if (_tmp$48) {
          forward_result = new _M0TP219moonbit_2dcommunity7piediff9Partition(x_cur, y_cur, true, true);
          break;
        }
        d = d - 2 | 0;
        continue;
      } else {
        break;
      }
    }
    const _bind$4 = forward_result;
    if (_bind$4 === undefined) {
    } else {
      const _Some = _bind$4;
      const _result = _Some;
      return _result;
    }
    let bmin$2;
    if (bmin > dmin) {
      const _tmp$45 = (diagonal_shift + bmin | 0) - 2 | 0;
      $bound_check(backward_search_diagonal, _tmp$45);
      backward_search_diagonal[_tmp$45] = 2147483647;
      bmin$2 = bmin - 1 | 0;
    } else {
      bmin$2 = bmin + 1 | 0;
    }
    let bmax$2;
    if (bmax < dmax) {
      const _tmp$45 = (diagonal_shift + bmax | 0) + 2 | 0;
      $bound_check(backward_search_diagonal, _tmp$45);
      backward_search_diagonal[_tmp$45] = 2147483647;
      bmax$2 = bmax + 1 | 0;
    } else {
      bmax$2 = bmax - 1 | 0;
    }
    let backward_result = undefined;
    let d$2 = bmax$2;
    while (true) {
      if (d$2 >= bmin$2) {
        const _tmp$45 = (diagonal_shift + d$2 | 0) - 1 | 0;
        $bound_check(backward_search_diagonal, _tmp$45);
        const tlo = backward_search_diagonal[_tmp$45];
        const _tmp$46 = (diagonal_shift + d$2 | 0) + 1 | 0;
        $bound_check(backward_search_diagonal, _tmp$46);
        const thi = backward_search_diagonal[_tmp$46];
        const x = tlo < thi ? tlo : thi - 1 | 0;
        let x_cur = x;
        let y_cur = x_cur - d$2 | 0;
        while (true) {
          if (x_cur > lhs_offset && (y_cur > rhs_offset && lhs_get(x_cur - 1 | 0) === rhs_get(y_cur - 1 | 0))) {
            x_cur = x_cur - 1 | 0;
            y_cur = y_cur - 1 | 0;
            continue;
          } else {
            break;
          }
        }
        const _tmp$47 = diagonal_shift + d$2 | 0;
        $bound_check(backward_search_diagonal, _tmp$47);
        backward_search_diagonal[_tmp$47] = x_cur;
        let _tmp$48;
        if (!odd) {
          let _tmp$49;
          if (fmin$2 <= d$2) {
            let _tmp$50;
            if (d$2 <= fmax$2) {
              const _tmp$51 = diagonal_shift + d$2 | 0;
              $bound_check(backward_search_diagonal, _tmp$51);
              const _tmp$52 = backward_search_diagonal[_tmp$51];
              const _tmp$53 = diagonal_shift + d$2 | 0;
              $bound_check(forward_search_diagonal, _tmp$53);
              _tmp$50 = _tmp$52 <= forward_search_diagonal[_tmp$53];
            } else {
              _tmp$50 = false;
            }
            _tmp$49 = _tmp$50;
          } else {
            _tmp$49 = false;
          }
          _tmp$48 = _tmp$49;
        } else {
          _tmp$48 = false;
        }
        if (_tmp$48) {
          backward_result = new _M0TP219moonbit_2dcommunity7piediff9Partition(x_cur, y_cur, true, true);
          break;
        }
        d$2 = d$2 - 2 | 0;
        continue;
      } else {
        break;
      }
    }
    const _bind$5 = backward_result;
    if (_bind$5 === undefined) {
    } else {
      const _Some = _bind$5;
      const _result = _Some;
      return _result;
    }
    if (!find_minimal && c >= too_expensive) {
      let fxybest = -1;
      let fxbest = fmax$2;
      let d$3 = fmax$2;
      while (true) {
        if (d$3 >= fmin$2) {
          const _tmp$45 = diagonal_shift + d$3 | 0;
          $bound_check(forward_search_diagonal, _tmp$45);
          const _p$4 = forward_search_diagonal[_tmp$45];
          const x = lhs_limit < _p$4 ? lhs_limit : _p$4;
          const y = x - d$3 | 0;
          let x$2;
          let y$2;
          _L: {
            if (rhs_limit < y) {
              x$2 = rhs_limit + d$3 | 0;
              y$2 = rhs_limit;
              break _L;
            } else {
              x$2 = x;
              y$2 = y;
              break _L;
            }
          }
          if (fxybest < (x$2 + y$2 | 0)) {
            fxybest = x$2 + y$2 | 0;
            fxbest = x$2;
          }
          d$3 = d$3 - 2 | 0;
          continue;
        } else {
          break;
        }
      }
      let bxybest = 2147483647;
      let bxbest = bmax$2;
      let d$4 = bmax$2;
      while (true) {
        if (d$4 >= bmin$2) {
          const _tmp$45 = diagonal_shift + d$4 | 0;
          $bound_check(backward_search_diagonal, _tmp$45);
          const _p$4 = backward_search_diagonal[_tmp$45];
          const x = lhs_offset > _p$4 ? lhs_offset : _p$4;
          const y = x - d$4 | 0;
          let x$2;
          let y$2;
          _L: {
            if (y < rhs_offset) {
              x$2 = rhs_offset + d$4 | 0;
              y$2 = rhs_offset;
              break _L;
            } else {
              x$2 = x;
              y$2 = y;
              break _L;
            }
          }
          if ((x$2 + y$2 | 0) < bxybest) {
            bxybest = x$2 + y$2 | 0;
            bxbest = x$2;
          }
          d$4 = d$4 - 2 | 0;
          continue;
        } else {
          break;
        }
      }
      if (((lhs_limit + rhs_limit | 0) - bxybest | 0) < (fxybest - (lhs_offset + rhs_offset | 0) | 0)) {
        return new _M0TP219moonbit_2dcommunity7piediff9Partition(fxbest, fxybest - fxbest | 0, true, false);
      } else {
        return new _M0TP219moonbit_2dcommunity7piediff9Partition(bxbest, bxybest - bxbest | 0, false, true);
      }
    } else {
      _tmp$40 = c + 1 | 0;
      _tmp$41 = fmin$2;
      _tmp$42 = fmax$2;
      _tmp$43 = bmin$2;
      _tmp$44 = bmax$2;
      continue;
    }
  }
}
function _M0FP219moonbit_2dcommunity7piediff10diff__loopN15loop__recursiveS99GsE(_env, lhs_offset, lhs_limit, rhs_offset, rhs_limit, find_minimal) {
  const diagonal_shift = _env._9;
  const lhs_indices = _env._8;
  const rhs_change_markers = _env._7;
  const too_expensive = _env._6;
  const forward_search_diagonal = _env._5;
  const lhs_change_markers = _env._4;
  const rhs_indices = _env._3;
  const rhs_get = _env._2;
  const backward_search_diagonal = _env._1;
  const lhs_get = _env._0;
  let _tmp$38 = lhs_offset;
  let _tmp$39 = lhs_limit;
  let _tmp$40 = rhs_offset;
  let _tmp$41 = rhs_limit;
  let _tmp$42 = find_minimal;
  _L: while (true) {
    const lhs_offset$2 = _tmp$38;
    const lhs_limit$2 = _tmp$39;
    const rhs_offset$2 = _tmp$40;
    const rhs_limit$2 = _tmp$41;
    const find_minimal$2 = _tmp$42;
    let lhs_offset$3 = lhs_offset$2;
    let rhs_offset$3 = rhs_offset$2;
    while (true) {
      if (lhs_offset$3 < lhs_limit$2 && (rhs_offset$3 < rhs_limit$2 && lhs_get(lhs_offset$3) === rhs_get(rhs_offset$3))) {
        lhs_offset$3 = lhs_offset$3 + 1 | 0;
        rhs_offset$3 = rhs_offset$3 + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    let lhs_limit$3 = lhs_limit$2;
    let rhs_limit$3 = rhs_limit$2;
    while (true) {
      if (lhs_limit$3 > lhs_offset$3 && (rhs_limit$3 > rhs_offset$3 && lhs_get(lhs_limit$3 - 1 | 0) === rhs_get(rhs_limit$3 - 1 | 0))) {
        lhs_limit$3 = lhs_limit$3 - 1 | 0;
        rhs_limit$3 = rhs_limit$3 - 1 | 0;
        continue;
      } else {
        break;
      }
    }
    if (lhs_offset$3 === lhs_limit$3) {
      let _tmp$43 = rhs_offset$3;
      while (true) {
        const y = _tmp$43;
        if (y < rhs_limit$3) {
          $bound_check(rhs_indices, y);
          const _tmp$44 = rhs_indices[y];
          $bound_check(rhs_change_markers, _tmp$44);
          rhs_change_markers[_tmp$44] = true;
          _tmp$43 = y + 1 | 0;
          continue;
        } else {
          return;
        }
      }
    } else {
      if (rhs_offset$3 === rhs_limit$3) {
        let _tmp$43 = lhs_offset$3;
        while (true) {
          const x = _tmp$43;
          if (x < lhs_limit$3) {
            $bound_check(lhs_indices, x);
            const _tmp$44 = lhs_indices[x];
            $bound_check(lhs_change_markers, _tmp$44);
            lhs_change_markers[_tmp$44] = true;
            _tmp$43 = x + 1 | 0;
            continue;
          } else {
            return;
          }
        }
      } else {
        const partition = _M0FP219moonbit_2dcommunity7piediff4diagGsE(forward_search_diagonal, backward_search_diagonal, diagonal_shift, lhs_get, rhs_get, lhs_offset$3, lhs_limit$3, rhs_offset$3, rhs_limit$3, too_expensive, find_minimal$2);
        _M0FP219moonbit_2dcommunity7piediff10diff__loopN15loop__recursiveS99GsE(_env, lhs_offset$3, partition.lhs_midpoint, rhs_offset$3, partition.rhs_midpoint, partition.lo_minimal);
        _tmp$38 = partition.lhs_midpoint;
        _tmp$39 = lhs_limit$3;
        _tmp$40 = partition.rhs_midpoint;
        _tmp$41 = rhs_limit$3;
        _tmp$42 = partition.hi_minimal;
        continue;
      }
    }
  }
}
function _M0FP219moonbit_2dcommunity7piediff10diff__loopGsE(cutoff, lhs, lhs_indices, rhs, rhs_indices, n, m) {
  const forward_search_diagonal = $make_array_len_and_init((n + m | 0) + 3 | 0, 0);
  const backward_search_diagonal = $make_array_len_and_init((n + m | 0) + 3 | 0, 0);
  const diagonal_shift = m + 1 | 0;
  let too_expensive;
  if (cutoff === undefined) {
    const diags = (n + m | 0) + 3 | 0;
    let result = 1;
    let diags_cur = diags;
    while (true) {
      if (diags_cur !== 0) {
        diags_cur = diags_cur >> 2;
        result = result << 1;
        continue;
      } else {
        break;
      }
    }
    const _p$4 = result;
    const _p$5 = 4096;
    too_expensive = _p$4 > _p$5 ? _p$4 : _p$5;
  } else {
    const _Some = cutoff;
    too_expensive = _Some;
  }
  const lhs_get = (i) => {
    $bound_check(lhs_indices, i);
    return _M0MPC15array9ArrayView2atGRP219moonbit_2dcommunity7piediff4EditE(lhs, lhs_indices[i]);
  };
  const rhs_get = (j) => {
    $bound_check(rhs_indices, j);
    return _M0MPC15array9ArrayView2atGRP219moonbit_2dcommunity7piediff4EditE(rhs, rhs_indices[j]);
  };
  const lhs_change_markers = $make_array_len_and_init(lhs.end - lhs.start | 0, true);
  const rhs_change_markers = $make_array_len_and_init(rhs.end - rhs.start | 0, true);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < n) {
      $bound_check(lhs_indices, i);
      const _tmp$39 = lhs_indices[i];
      $bound_check(lhs_change_markers, _tmp$39);
      lhs_change_markers[_tmp$39] = false;
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let _tmp$39 = 0;
  while (true) {
    const j = _tmp$39;
    if (j < m) {
      $bound_check(rhs_indices, j);
      const _tmp$40 = rhs_indices[j];
      $bound_check(rhs_change_markers, _tmp$40);
      rhs_change_markers[_tmp$40] = false;
      _tmp$39 = j + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _env = { _0: lhs_get, _1: backward_search_diagonal, _2: rhs_get, _3: rhs_indices, _4: lhs_change_markers, _5: forward_search_diagonal, _6: too_expensive, _7: rhs_change_markers, _8: lhs_indices, _9: diagonal_shift };
  _M0FP219moonbit_2dcommunity7piediff10diff__loopN15loop__recursiveS99GsE(_env, 0, n, 0, m, false);
  return { _0: lhs_change_markers, _1: rhs_change_markers };
}
function _M0FP219moonbit_2dcommunity7piediff13make__indexerGsE(a, b) {
  const n = a.end - a.start | 0;
  const present = _M0MPB3Map11new_2einnerGsbE(b.end - b.start | 0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < (b.end - b.start | 0)) {
      _M0MPB3Map3setGsbE(present, _M0MPC15array9ArrayView2atGRP219moonbit_2dcommunity7piediff4EditE(b, i), true);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const ai = $make_array_len_and_init(n, 0);
  let k = 0;
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < n) {
      const _bind$4 = _M0MPB3Map3getGsbE(present, _M0MPC15array9ArrayView2atGRP219moonbit_2dcommunity7piediff4EditE(a, i));
      if (_bind$4 === -1) {
      } else {
        const _tmp$40 = k;
        $bound_check(ai, _tmp$40);
        ai[_tmp$40] = i;
        k = k + 1 | 0;
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const result = $make_array_len_and_init(k, 0);
  let _tmp$40 = 0;
  while (true) {
    const i = _tmp$40;
    if (i < k) {
      $bound_check(ai, i);
      $bound_check(result, i);
      result[i] = ai[i];
      _tmp$40 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return result;
}
function _M0FP219moonbit_2dcommunity7piediff6diff__GsE(cutoff, lhs, rhs) {
  const lhs_indices = _M0FP219moonbit_2dcommunity7piediff13make__indexerGsE(lhs, rhs);
  const rhs_indices = _M0FP219moonbit_2dcommunity7piediff13make__indexerGsE(rhs, lhs);
  const n = lhs_indices.length;
  const m = rhs_indices.length;
  return _M0FP219moonbit_2dcommunity7piediff10diff__loopGsE(cutoff, lhs, lhs_indices, rhs, rhs_indices, n, m);
}
function _M0FP219moonbit_2dcommunity7piediff13iter__matchesGsE(cutoff, old, new_) {
  const _bind$4 = _M0FP219moonbit_2dcommunity7piediff6diff__GsE(cutoff, old, new_);
  const _d1 = _bind$4._0;
  const _d2 = _bind$4._1;
  const i1 = new _M0TPB8MutLocalGiE(0);
  const i2 = new _M0TPB8MutLocalGiE(0);
  const go = () => {
    while (true) {
      if (i1.val >= _d1.length || i2.val >= _d2.length) {
        return undefined;
      } else {
        const _tmp$38 = i1.val;
        $bound_check(_d1, _tmp$38);
        if (!_d1[_tmp$38]) {
          const _tmp$39 = i2.val;
          $bound_check(_d2, _tmp$39);
          if (!_d2[_tmp$39]) {
            const matching_pair = { _0: i1.val, _1: i2.val };
            i1.val = i1.val + 1 | 0;
            i2.val = i2.val + 1 | 0;
            return matching_pair;
          } else {
            i2.val = i2.val + 1 | 0;
            continue;
          }
        } else {
          const _tmp$39 = i2.val;
          $bound_check(_d2, _tmp$39);
          if (!_d2[_tmp$39]) {
            i1.val = i1.val + 1 | 0;
            continue;
          } else {
            i1.val = i1.val + 1 | 0;
            i2.val = i2.val + 1 | 0;
            continue;
          }
        }
      }
    }
  };
  return _M0MPB5Iter23newGiiE(go, undefined);
}
function _M0FP219moonbit_2dcommunity7piediff22append__myers__matchesGsE(matches, cutoff, old, new_, old_offset, new_offset) {
  const _it = _M0FP219moonbit_2dcommunity7piediff13iter__matchesGsE(cutoff, old, new_);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGiiE(_it);
    if (_bind$4 === undefined) {
      return;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _old_idx = _x._0;
      const _new_idx = _x._1;
      _M0MPC15array5Array4pushGUssEE(matches, { _0: old_offset + _old_idx | 0, _1: new_offset + _new_idx | 0 });
      continue;
    }
  }
}
function _M0FP219moonbit_2dcommunity7piediff25append__patience__matchesGsE(matches, cutoff, old, new_, old_offset, new_offset) {
  const anchors = _M0FP219moonbit_2dcommunity7piediff11unique__lcsGsE(old, new_);
  if ((anchors.end - anchors.start | 0) === 0) {
    _M0FP219moonbit_2dcommunity7piediff22append__myers__matchesGsE(matches, cutoff, old, new_, old_offset, new_offset);
    return undefined;
  }
  let prev_old_idx = 0;
  let prev_new_idx = 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < (anchors.end - anchors.start | 0)) {
      const _bind$4 = _M0MPC15array9ArrayView2atGRP219moonbit_2dcommunity7piediff4EditE(anchors, i);
      const _old_idx = _bind$4._0;
      const _new_idx = _bind$4._1;
      _M0FP219moonbit_2dcommunity7piediff22append__myers__matchesGsE(matches, cutoff, _M0MPC15array9ArrayView12view_2einnerGsE(old, prev_old_idx, _old_idx), _M0MPC15array9ArrayView12view_2einnerGsE(new_, prev_new_idx, _new_idx), old_offset + prev_old_idx | 0, new_offset + prev_new_idx | 0);
      _M0MPC15array5Array4pushGUssEE(matches, { _0: old_offset + _old_idx | 0, _1: new_offset + _new_idx | 0 });
      prev_old_idx = _old_idx + 1 | 0;
      prev_new_idx = _new_idx + 1 | 0;
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0FP219moonbit_2dcommunity7piediff22append__myers__matchesGsE(matches, cutoff, _M0MPC15array9ArrayView12view_2einnerGsE(old, prev_old_idx, old.end - old.start | 0), _M0MPC15array9ArrayView12view_2einnerGsE(new_, prev_new_idx, new_.end - new_.start | 0), old_offset + prev_old_idx | 0, new_offset + prev_new_idx | 0);
}
function _M0FP219moonbit_2dcommunity7piediff16collect__matchesGsE(cutoff, old, new_, algorithm) {
  const _p$4 = old.end - old.start | 0;
  const _p$5 = new_.end - new_.start | 0;
  const matches = _M0MPC15array5Array11new_2einnerGRP411moonbitlang6regexp8internal2vm6ThreadE(_p$4 < _p$5 ? _p$4 : _p$5);
  if (algorithm === 1) {
    _M0FP219moonbit_2dcommunity7piediff25append__patience__matchesGsE(matches, cutoff, old, new_, 0, 0);
  } else {
    _M0FP219moonbit_2dcommunity7piediff22append__myers__matchesGsE(matches, cutoff, old, new_, 0, 0);
  }
  return matches;
}
function _M0MP219moonbit_2dcommunity7piediff4Diff11new_2einnerGsE(old, new_, cutoff, algorithm) {
  const result = _M0MPC15array5Array11new_2einnerGRP411moonbitlang6regexp8internal2vm6ThreadE((old.end - old.start | 0) + (new_.end - new_.start | 0) | 0);
  const matches = _M0FP219moonbit_2dcommunity7piediff16collect__matchesGsE(cutoff, old, new_, algorithm);
  let prev_old_idx = 0;
  let prev_new_idx = 0;
  let equal_old_idx = 0;
  let equal_new_idx = 0;
  let consecutive_equal_length = 0;
  const _bind$4 = matches.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const pair = matches[_];
      const _old_idx = pair._0;
      const _new_idx = pair._1;
      if (prev_old_idx !== _old_idx) {
        if (consecutive_equal_length !== 0) {
          _M0MPC15array5Array4pushGUssEE(result, new _M0DTP219moonbit_2dcommunity7piediff4Edit5Equal(equal_old_idx, equal_new_idx, consecutive_equal_length));
        }
        consecutive_equal_length = 0;
        _M0MPC15array5Array4pushGUssEE(result, new _M0DTP219moonbit_2dcommunity7piediff4Edit6Delete(prev_old_idx, prev_new_idx, _old_idx - prev_old_idx | 0));
        prev_old_idx = _old_idx;
      }
      if (prev_new_idx !== _new_idx) {
        if (consecutive_equal_length !== 0) {
          _M0MPC15array5Array4pushGUssEE(result, new _M0DTP219moonbit_2dcommunity7piediff4Edit5Equal(equal_old_idx, equal_new_idx, consecutive_equal_length));
        }
        consecutive_equal_length = 0;
        _M0MPC15array5Array4pushGUssEE(result, new _M0DTP219moonbit_2dcommunity7piediff4Edit6Insert(prev_old_idx, prev_new_idx, _new_idx - prev_new_idx | 0));
      }
      prev_old_idx = _old_idx + 1 | 0;
      prev_new_idx = _new_idx + 1 | 0;
      if (consecutive_equal_length === 0) {
        equal_old_idx = _old_idx;
        equal_new_idx = _new_idx;
        consecutive_equal_length = 1;
      } else {
        consecutive_equal_length = consecutive_equal_length + 1 | 0;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      if (consecutive_equal_length !== 0) {
        _M0MPC15array5Array4pushGUssEE(result, new _M0DTP219moonbit_2dcommunity7piediff4Edit5Equal(equal_old_idx, equal_new_idx, consecutive_equal_length));
      }
      if (prev_old_idx !== (old.end - old.start | 0)) {
        _M0MPC15array5Array4pushGUssEE(result, new _M0DTP219moonbit_2dcommunity7piediff4Edit6Delete(prev_old_idx, prev_new_idx, (old.end - old.start | 0) - prev_old_idx | 0));
        prev_old_idx = old.end - old.start | 0;
      }
      if (prev_new_idx !== (new_.end - new_.start | 0)) {
        _M0MPC15array5Array4pushGUssEE(result, new _M0DTP219moonbit_2dcommunity7piediff4Edit6Insert(prev_old_idx, prev_new_idx, (new_.end - new_.start | 0) - prev_new_idx | 0));
      }
      return new _M0TP219moonbit_2dcommunity7piediff4DiffGsE(old, new_, result);
    }
  }
}
function _M0MP219moonbit_2dcommunity7piediff4Diff3newGsE(old, new_, cutoff, algorithm$46$opt) {
  let algorithm;
  if (algorithm$46$opt === undefined) {
    algorithm = 0;
  } else {
    const _Some = algorithm$46$opt;
    algorithm = _Some;
  }
  return _M0MP219moonbit_2dcommunity7piediff4Diff11new_2einnerGsE(old, new_, cutoff, algorithm);
}
function _M0MP219moonbit_2dcommunity7piediff4Diff13group_2einnerGsE(self, radius) {
  return _M0FP219moonbit_2dcommunity7piediff20group__edits_2einnerGsE(self.edits, radius, self.old, self.new);
}
function _M0IP219moonbit_2dcommunity4yaml5EventPB2Eq5equal(_x_738, _x_739) {
  switch (_x_738.$tag) {
    case 0: {
      if (_x_739.$tag === 0) {
        return true;
      } else {
        return false;
      }
    }
    case 1: {
      if (_x_739.$tag === 1) {
        return true;
      } else {
        return false;
      }
    }
    case 2: {
      if (_x_739.$tag === 2) {
        return true;
      } else {
        return false;
      }
    }
    case 3: {
      if (_x_739.$tag === 3) {
        return true;
      } else {
        return false;
      }
    }
    case 4: {
      const _Alias = _x_738;
      const _$42$x0_740 = _Alias._0;
      if (_x_739.$tag === 4) {
        const _Alias$2 = _x_739;
        const _$42$y0_741 = _Alias$2._0;
        return _$42$x0_740 === _$42$y0_741;
      } else {
        return false;
      }
    }
    case 5: {
      const _Scalar = _x_738;
      const _$42$x0_742 = _Scalar._0;
      const _$42$x1_743 = _Scalar._1;
      const _$42$x2_744 = _Scalar._2;
      const _$42$x3_745 = _Scalar._3;
      if (_x_739.$tag === 5) {
        const _Scalar$2 = _x_739;
        const _$42$y0_746 = _Scalar$2._0;
        const _$42$y1_747 = _Scalar$2._1;
        const _$42$y2_748 = _Scalar$2._2;
        const _$42$y3_749 = _Scalar$2._3;
        return _$42$x0_742 === _$42$y0_746 && (_M0IP219moonbit_2dcommunity4yaml12TScalarStylePB2Eq5equal(_$42$x1_743, _$42$y1_747) && (_$42$x2_744 === _$42$y2_748 && _M0IPC16option6OptionPB2Eq5equalGRP219moonbit_2dcommunity4yaml3TagE(_$42$x3_745, _$42$y3_749)));
      } else {
        return false;
      }
    }
    case 6: {
      const _SequenceStart = _x_738;
      const _$42$x0_750 = _SequenceStart._0;
      const _$42$x1_751 = _SequenceStart._1;
      if (_x_739.$tag === 6) {
        const _SequenceStart$2 = _x_739;
        const _$42$y0_752 = _SequenceStart$2._0;
        const _$42$y1_753 = _SequenceStart$2._1;
        return _$42$x0_750 === _$42$y0_752 && _M0IPC16option6OptionPB2Eq5equalGRP219moonbit_2dcommunity4yaml3TagE(_$42$x1_751, _$42$y1_753);
      } else {
        return false;
      }
    }
    case 7: {
      if (_x_739.$tag === 7) {
        return true;
      } else {
        return false;
      }
    }
    case 8: {
      const _MappingStart = _x_738;
      const _$42$x0_754 = _MappingStart._0;
      const _$42$x1_755 = _MappingStart._1;
      if (_x_739.$tag === 8) {
        const _MappingStart$2 = _x_739;
        const _$42$y0_756 = _MappingStart$2._0;
        const _$42$y1_757 = _MappingStart$2._1;
        return _$42$x0_754 === _$42$y0_756 && _M0IPC16option6OptionPB2Eq5equalGRP219moonbit_2dcommunity4yaml3TagE(_$42$x1_755, _$42$y1_757);
      } else {
        return false;
      }
    }
    default: {
      if (_x_739.$tag === 9) {
        return true;
      } else {
        return false;
      }
    }
  }
}
function _M0IP219moonbit_2dcommunity4yaml5EventPB4Show6output(_x_716, _x_717) {
  switch (_x_716.$tag) {
    case 0: {
      _x_717.method_table.method_0(_x_717.self, "StreamStart");
      return;
    }
    case 1: {
      _x_717.method_table.method_0(_x_717.self, "StreamEnd");
      return;
    }
    case 2: {
      _x_717.method_table.method_0(_x_717.self, "DocumentStart");
      return;
    }
    case 3: {
      _x_717.method_table.method_0(_x_717.self, "DocumentEnd");
      return;
    }
    case 4: {
      const _Alias = _x_716;
      const _$42$arg_718 = _Alias._0;
      _x_717.method_table.method_0(_x_717.self, "Alias(");
      _x_717.method_table.method_0(_x_717.self, "id=");
      _M0MPB6Logger13write__objectGiE(_x_717, _$42$arg_718);
      _x_717.method_table.method_0(_x_717.self, ")");
      return;
    }
    case 5: {
      const _Scalar = _x_716;
      const _$42$arg_719 = _Scalar._0;
      const _$42$arg_720 = _Scalar._1;
      const _$42$arg_721 = _Scalar._2;
      const _$42$arg_722 = _Scalar._3;
      _x_717.method_table.method_0(_x_717.self, "Scalar(");
      _x_717.method_table.method_0(_x_717.self, "value=");
      _M0MPB6Logger13write__objectGsE(_x_717, _$42$arg_719);
      _x_717.method_table.method_0(_x_717.self, ", ");
      _x_717.method_table.method_0(_x_717.self, "style=");
      _M0MPB6Logger13write__objectGRP219moonbit_2dcommunity4yaml12TScalarStyleE(_x_717, _$42$arg_720);
      _x_717.method_table.method_0(_x_717.self, ", ");
      _x_717.method_table.method_0(_x_717.self, "id=");
      _M0MPB6Logger13write__objectGiE(_x_717, _$42$arg_721);
      _x_717.method_table.method_0(_x_717.self, ", ");
      _x_717.method_table.method_0(_x_717.self, "tag=");
      _M0MPB6Logger13write__objectGORP219moonbit_2dcommunity4yaml3TagE(_x_717, _$42$arg_722);
      _x_717.method_table.method_0(_x_717.self, ")");
      return;
    }
    case 6: {
      const _SequenceStart = _x_716;
      const _$42$arg_723 = _SequenceStart._0;
      const _$42$arg_724 = _SequenceStart._1;
      _x_717.method_table.method_0(_x_717.self, "SequenceStart(");
      _x_717.method_table.method_0(_x_717.self, "id=");
      _M0MPB6Logger13write__objectGiE(_x_717, _$42$arg_723);
      _x_717.method_table.method_0(_x_717.self, ", ");
      _x_717.method_table.method_0(_x_717.self, "tag=");
      _M0MPB6Logger13write__objectGORP219moonbit_2dcommunity4yaml3TagE(_x_717, _$42$arg_724);
      _x_717.method_table.method_0(_x_717.self, ")");
      return;
    }
    case 7: {
      _x_717.method_table.method_0(_x_717.self, "SequenceEnd");
      return;
    }
    case 8: {
      const _MappingStart = _x_716;
      const _$42$arg_725 = _MappingStart._0;
      const _$42$arg_726 = _MappingStart._1;
      _x_717.method_table.method_0(_x_717.self, "MappingStart(");
      _x_717.method_table.method_0(_x_717.self, "id=");
      _M0MPB6Logger13write__objectGiE(_x_717, _$42$arg_725);
      _x_717.method_table.method_0(_x_717.self, ", ");
      _x_717.method_table.method_0(_x_717.self, "tag=");
      _M0MPB6Logger13write__objectGORP219moonbit_2dcommunity4yaml3TagE(_x_717, _$42$arg_726);
      _x_717.method_table.method_0(_x_717.self, ")");
      return;
    }
    default: {
      _x_717.method_table.method_0(_x_717.self, "MappingEnd");
      return;
    }
  }
}
function _M0IP219moonbit_2dcommunity4yaml12TScalarStylePB2Eq5equal(_x_712, _x_713) {
  switch (_x_712) {
    case 0: {
      if (_x_713 === 0) {
        return true;
      } else {
        return false;
      }
    }
    case 1: {
      if (_x_713 === 1) {
        return true;
      } else {
        return false;
      }
    }
    case 2: {
      if (_x_713 === 2) {
        return true;
      } else {
        return false;
      }
    }
    case 3: {
      if (_x_713 === 3) {
        return true;
      } else {
        return false;
      }
    }
    default: {
      if (_x_713 === 4) {
        return true;
      } else {
        return false;
      }
    }
  }
}
function _M0IP219moonbit_2dcommunity4yaml12TScalarStylePB4Show6output(_x_708, _x_709) {
  switch (_x_708) {
    case 0: {
      _x_709.method_table.method_0(_x_709.self, "Plain");
      return;
    }
    case 1: {
      _x_709.method_table.method_0(_x_709.self, "SingleQuoted");
      return;
    }
    case 2: {
      _x_709.method_table.method_0(_x_709.self, "DoubleQuoted");
      return;
    }
    case 3: {
      _x_709.method_table.method_0(_x_709.self, "Literal");
      return;
    }
    default: {
      _x_709.method_table.method_0(_x_709.self, "Folded");
      return;
    }
  }
}
function _M0IP219moonbit_2dcommunity4yaml9YamlErrorPB4Show6output(_x_646, _x_647) {
  const _YamlError = _x_646;
  const _$42$arg_648 = _YamlError._0;
  const _$42$arg_649 = _YamlError._1;
  _x_647.method_table.method_0(_x_647.self, "YamlError(");
  _x_647.method_table.method_0(_x_647.self, "mark=");
  _M0MPB6Logger13write__objectGRP219moonbit_2dcommunity4yaml6MarkerE(_x_647, _$42$arg_648);
  _x_647.method_table.method_0(_x_647.self, ", ");
  _x_647.method_table.method_0(_x_647.self, "info=");
  _M0MPB6Logger13write__objectGsE(_x_647, _$42$arg_649);
  _x_647.method_table.method_0(_x_647.self, ")");
}
function _M0IP219moonbit_2dcommunity4yaml3TagPB4Show6output(_x_638, _x_639) {
  _x_639.method_table.method_0(_x_639.self, "{");
  _x_639.method_table.method_0(_x_639.self, "handle: ");
  _M0MPB6Logger13write__objectGsE(_x_639, _x_638.handle);
  _x_639.method_table.method_0(_x_639.self, ", ");
  _x_639.method_table.method_0(_x_639.self, "suffix: ");
  _M0MPB6Logger13write__objectGsE(_x_639, _x_638.suffix);
  _x_639.method_table.method_0(_x_639.self, "}");
}
function _M0IP219moonbit_2dcommunity4yaml8SkipTabsPB2Eq5equal(_x_626, _x_627) {
  switch (_x_626.$tag) {
    case 0: {
      if (_x_627.$tag === 0) {
        return true;
      } else {
        return false;
      }
    }
    case 1: {
      if (_x_627.$tag === 1) {
        return true;
      } else {
        return false;
      }
    }
    default: {
      const _Result = _x_626;
      const _$42$x0_628 = _Result._0;
      const _$42$x1_629 = _Result._1;
      if (_x_627.$tag === 2) {
        const _Result$2 = _x_627;
        const _$42$y0_630 = _Result$2._0;
        const _$42$y1_631 = _Result$2._1;
        return _$42$x0_628 === _$42$y0_630 && _$42$x1_629 === _$42$y1_631;
      } else {
        return false;
      }
    }
  }
}
function _M0IP219moonbit_2dcommunity4yaml9TokenTypePB2Eq5equal(_x_582, _x_583) {
  switch (_x_582.$tag) {
    case 0: {
      if (_x_583.$tag === 0) {
        return true;
      } else {
        return false;
      }
    }
    case 1: {
      if (_x_583.$tag === 1) {
        return true;
      } else {
        return false;
      }
    }
    case 2: {
      const _VersionDirective = _x_582;
      const _$42$x0_584 = _VersionDirective._0;
      const _$42$x1_585 = _VersionDirective._1;
      if (_x_583.$tag === 2) {
        const _VersionDirective$2 = _x_583;
        const _$42$y0_586 = _VersionDirective$2._0;
        const _$42$y1_587 = _VersionDirective$2._1;
        return _$42$x0_584 === _$42$y0_586 && _$42$x1_585 === _$42$y1_587;
      } else {
        return false;
      }
    }
    case 3: {
      const _TagDirective = _x_582;
      const _$42$x0_588 = _TagDirective._0;
      const _$42$x1_589 = _TagDirective._1;
      if (_x_583.$tag === 3) {
        const _TagDirective$2 = _x_583;
        const _$42$y0_590 = _TagDirective$2._0;
        const _$42$y1_591 = _TagDirective$2._1;
        return _$42$x0_588 === _$42$y0_590 && _$42$x1_589 === _$42$y1_591;
      } else {
        return false;
      }
    }
    case 4: {
      if (_x_583.$tag === 4) {
        return true;
      } else {
        return false;
      }
    }
    case 5: {
      if (_x_583.$tag === 5) {
        return true;
      } else {
        return false;
      }
    }
    case 6: {
      if (_x_583.$tag === 6) {
        return true;
      } else {
        return false;
      }
    }
    case 7: {
      if (_x_583.$tag === 7) {
        return true;
      } else {
        return false;
      }
    }
    case 8: {
      if (_x_583.$tag === 8) {
        return true;
      } else {
        return false;
      }
    }
    case 9: {
      if (_x_583.$tag === 9) {
        return true;
      } else {
        return false;
      }
    }
    case 10: {
      if (_x_583.$tag === 10) {
        return true;
      } else {
        return false;
      }
    }
    case 11: {
      if (_x_583.$tag === 11) {
        return true;
      } else {
        return false;
      }
    }
    case 12: {
      if (_x_583.$tag === 12) {
        return true;
      } else {
        return false;
      }
    }
    case 13: {
      if (_x_583.$tag === 13) {
        return true;
      } else {
        return false;
      }
    }
    case 14: {
      if (_x_583.$tag === 14) {
        return true;
      } else {
        return false;
      }
    }
    case 15: {
      if (_x_583.$tag === 15) {
        return true;
      } else {
        return false;
      }
    }
    case 16: {
      if (_x_583.$tag === 16) {
        return true;
      } else {
        return false;
      }
    }
    case 17: {
      const _Alias = _x_582;
      const _$42$x0_592 = _Alias._0;
      if (_x_583.$tag === 17) {
        const _Alias$2 = _x_583;
        const _$42$y0_593 = _Alias$2._0;
        return _$42$x0_592 === _$42$y0_593;
      } else {
        return false;
      }
    }
    case 18: {
      const _Anchor = _x_582;
      const _$42$x0_594 = _Anchor._0;
      if (_x_583.$tag === 18) {
        const _Anchor$2 = _x_583;
        const _$42$y0_595 = _Anchor$2._0;
        return _$42$x0_594 === _$42$y0_595;
      } else {
        return false;
      }
    }
    case 19: {
      const _Tag = _x_582;
      const _$42$x0_596 = _Tag._0;
      const _$42$x1_597 = _Tag._1;
      if (_x_583.$tag === 19) {
        const _Tag$2 = _x_583;
        const _$42$y0_598 = _Tag$2._0;
        const _$42$y1_599 = _Tag$2._1;
        return _$42$x0_596 === _$42$y0_598 && _$42$x1_597 === _$42$y1_599;
      } else {
        return false;
      }
    }
    default: {
      const _Scalar = _x_582;
      const _$42$x0_600 = _Scalar._0;
      const _$42$x1_601 = _Scalar._1;
      if (_x_583.$tag === 20) {
        const _Scalar$2 = _x_583;
        const _$42$y0_602 = _Scalar$2._0;
        const _$42$y1_603 = _Scalar$2._1;
        return _M0IP219moonbit_2dcommunity4yaml12TScalarStylePB2Eq5equal(_$42$x0_600, _$42$y0_602) && _$42$x1_601 === _$42$y1_603;
      } else {
        return false;
      }
    }
  }
}
function _M0IP219moonbit_2dcommunity4yaml8ChompingPB2Eq5equal(_x_554, _x_555) {
  switch (_x_554) {
    case 0: {
      if (_x_555 === 0) {
        return true;
      } else {
        return false;
      }
    }
    case 1: {
      if (_x_555 === 1) {
        return true;
      } else {
        return false;
      }
    }
    default: {
      if (_x_555 === 2) {
        return true;
      } else {
        return false;
      }
    }
  }
}
function _M0IP219moonbit_2dcommunity4yaml5StatePB2Eq5equal(_x_550, _x_551) {
  switch (_x_550) {
    case 0: {
      if (_x_551 === 0) {
        return true;
      } else {
        return false;
      }
    }
    case 1: {
      if (_x_551 === 1) {
        return true;
      } else {
        return false;
      }
    }
    case 2: {
      if (_x_551 === 2) {
        return true;
      } else {
        return false;
      }
    }
    case 3: {
      if (_x_551 === 3) {
        return true;
      } else {
        return false;
      }
    }
    case 4: {
      if (_x_551 === 4) {
        return true;
      } else {
        return false;
      }
    }
    case 5: {
      if (_x_551 === 5) {
        return true;
      } else {
        return false;
      }
    }
    case 6: {
      if (_x_551 === 6) {
        return true;
      } else {
        return false;
      }
    }
    case 7: {
      if (_x_551 === 7) {
        return true;
      } else {
        return false;
      }
    }
    case 8: {
      if (_x_551 === 8) {
        return true;
      } else {
        return false;
      }
    }
    case 9: {
      if (_x_551 === 9) {
        return true;
      } else {
        return false;
      }
    }
    case 10: {
      if (_x_551 === 10) {
        return true;
      } else {
        return false;
      }
    }
    case 11: {
      if (_x_551 === 11) {
        return true;
      } else {
        return false;
      }
    }
    case 12: {
      if (_x_551 === 12) {
        return true;
      } else {
        return false;
      }
    }
    case 13: {
      if (_x_551 === 13) {
        return true;
      } else {
        return false;
      }
    }
    case 14: {
      if (_x_551 === 14) {
        return true;
      } else {
        return false;
      }
    }
    case 15: {
      if (_x_551 === 15) {
        return true;
      } else {
        return false;
      }
    }
    case 16: {
      if (_x_551 === 16) {
        return true;
      } else {
        return false;
      }
    }
    case 17: {
      if (_x_551 === 17) {
        return true;
      } else {
        return false;
      }
    }
    case 18: {
      if (_x_551 === 18) {
        return true;
      } else {
        return false;
      }
    }
    case 19: {
      if (_x_551 === 19) {
        return true;
      } else {
        return false;
      }
    }
    case 20: {
      if (_x_551 === 20) {
        return true;
      } else {
        return false;
      }
    }
    default: {
      if (_x_551 === 21) {
        return true;
      } else {
        return false;
      }
    }
  }
}
function _M0IP219moonbit_2dcommunity4yaml6MarkerPB4Show6output(_x_546, _x_547) {
  _x_547.method_table.method_0(_x_547.self, "{");
  _x_547.method_table.method_0(_x_547.self, "index: ");
  _M0MPB6Logger13write__objectGiE(_x_547, _x_546.index);
  _x_547.method_table.method_0(_x_547.self, ", ");
  _x_547.method_table.method_0(_x_547.self, "line: ");
  _M0MPB6Logger13write__objectGiE(_x_547, _x_546.line);
  _x_547.method_table.method_0(_x_547.self, ", ");
  _x_547.method_table.method_0(_x_547.self, "col: ");
  _M0MPB6Logger13write__objectGiE(_x_547, _x_546.col);
  _x_547.method_table.method_0(_x_547.self, "}");
}
function _M0IP219moonbit_2dcommunity4yaml4YamlPB6ToJson8to__json(self) {
  switch (self.$tag) {
    case 6: {
      return _M0DTPB4Json4Null__;
    }
    case 5: {
      const _Map = self;
      const _yaml_map = _Map._0;
      const _p$4 = _M0MPB3Map3mapGsRP219moonbit_2dcommunity4yaml4YamlRPB4JsonE(_yaml_map, (_discard_, yaml) => _M0IP219moonbit_2dcommunity4yaml4YamlPB6ToJson8to__json(yaml));
      return new _M0DTPB4Json6Object(_p$4);
    }
    case 4: {
      const _Array = self;
      const _yaml_array = _Array._0;
      const _p$5 = new Array(_yaml_array.length);
      const _p$6 = _yaml_array.length;
      let _tmp$38 = 0;
      while (true) {
        const _p$7 = _tmp$38;
        if (_p$7 < _p$6) {
          const _p$8 = _yaml_array[_p$7];
          _p$5[_p$7] = _M0IP219moonbit_2dcommunity4yaml4YamlPB6ToJson8to__json(_p$8);
          _tmp$38 = _p$7 + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      const _p$7 = _p$5;
      return new _M0DTPB4Json5Array(_p$7);
    }
    case 3: {
      const _Boolean = self;
      const _bool = _Boolean._0;
      return _bool ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__;
    }
    case 2: {
      const _String = self;
      const _str = _String._0;
      return new _M0DTPB4Json6String(_str);
    }
    case 1: {
      const _Integer = self;
      const _i64 = _Integer._0;
      const _p$8 = $f64_convert_i64(BigInt.asIntN(64, _i64));
      const _p$9 = undefined;
      return new _M0DTPB4Json6Number(_p$8, _p$9);
    }
    case 0: {
      const _Real = self;
      const _f64 = _Real._0;
      const _repr = _Real._1;
      const _p$10 = _repr;
      return new _M0DTPB4Json6Number(_f64, _p$10);
    }
    default: {
      return $panic();
    }
  }
}
function _M0FP219moonbit_2dcommunity4yaml13parse__double(v) {
  _L: {
    let v$2;
    _L$2: {
      _L$3: {
        _L$4: {
          _L$5: {
            if (_M0MPC16string6String24char__length__eq_2einner(v.str, 4, v.start, v.end)) {
              const _x = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 0, v.start, v.end));
              if (_x === 46) {
                const _x$2 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 1, v.start, v.end));
                switch (_x$2) {
                  case 105: {
                    const _x$3 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 2, v.start, v.end));
                    if (_x$3 === 110) {
                      const _x$4 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 3, v.start, v.end));
                      if (_x$4 === 102) {
                        break _L$5;
                      } else {
                        const _p$4 = _M0MPC16string10StringView4iter(v);
                        let _tmp$38;
                        while (true) {
                          const _p$5 = _M0MPB4Iter4nextGcE(_p$4);
                          if (_p$5 === -1) {
                            _tmp$38 = false;
                            break;
                          } else {
                            const _p$6 = _p$5;
                            const _p$7 = _p$6;
                            if (_M0MPC14char4Char16is__ascii__digit(_p$7)) {
                              _tmp$38 = true;
                              break;
                            }
                            continue;
                          }
                        }
                        if (_tmp$38) {
                          v$2 = v;
                          break _L$2;
                        } else {
                          break _L;
                        }
                      }
                    } else {
                      const _p$4 = _M0MPC16string10StringView4iter(v);
                      let _tmp$38;
                      while (true) {
                        const _p$5 = _M0MPB4Iter4nextGcE(_p$4);
                        if (_p$5 === -1) {
                          _tmp$38 = false;
                          break;
                        } else {
                          const _p$6 = _p$5;
                          const _p$7 = _p$6;
                          if (_M0MPC14char4Char16is__ascii__digit(_p$7)) {
                            _tmp$38 = true;
                            break;
                          }
                          continue;
                        }
                      }
                      if (_tmp$38) {
                        v$2 = v;
                        break _L$2;
                      } else {
                        break _L;
                      }
                    }
                  }
                  case 73: {
                    const _x$4 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 2, v.start, v.end));
                    switch (_x$4) {
                      case 110: {
                        const _x$5 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 3, v.start, v.end));
                        if (_x$5 === 102) {
                          break _L$5;
                        } else {
                          const _p$4 = _M0MPC16string10StringView4iter(v);
                          let _tmp$38;
                          while (true) {
                            const _p$5 = _M0MPB4Iter4nextGcE(_p$4);
                            if (_p$5 === -1) {
                              _tmp$38 = false;
                              break;
                            } else {
                              const _p$6 = _p$5;
                              const _p$7 = _p$6;
                              if (_M0MPC14char4Char16is__ascii__digit(_p$7)) {
                                _tmp$38 = true;
                                break;
                              }
                              continue;
                            }
                          }
                          if (_tmp$38) {
                            v$2 = v;
                            break _L$2;
                          } else {
                            break _L;
                          }
                        }
                      }
                      case 78: {
                        const _x$6 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 3, v.start, v.end));
                        if (_x$6 === 70) {
                          break _L$5;
                        } else {
                          const _p$4 = _M0MPC16string10StringView4iter(v);
                          let _tmp$38;
                          while (true) {
                            const _p$5 = _M0MPB4Iter4nextGcE(_p$4);
                            if (_p$5 === -1) {
                              _tmp$38 = false;
                              break;
                            } else {
                              const _p$6 = _p$5;
                              const _p$7 = _p$6;
                              if (_M0MPC14char4Char16is__ascii__digit(_p$7)) {
                                _tmp$38 = true;
                                break;
                              }
                              continue;
                            }
                          }
                          if (_tmp$38) {
                            v$2 = v;
                            break _L$2;
                          } else {
                            break _L;
                          }
                        }
                      }
                      default: {
                        const _p$4 = _M0MPC16string10StringView4iter(v);
                        let _tmp$38;
                        while (true) {
                          const _p$5 = _M0MPB4Iter4nextGcE(_p$4);
                          if (_p$5 === -1) {
                            _tmp$38 = false;
                            break;
                          } else {
                            const _p$6 = _p$5;
                            const _p$7 = _p$6;
                            if (_M0MPC14char4Char16is__ascii__digit(_p$7)) {
                              _tmp$38 = true;
                              break;
                            }
                            continue;
                          }
                        }
                        if (_tmp$38) {
                          v$2 = v;
                          break _L$2;
                        } else {
                          break _L;
                        }
                      }
                    }
                  }
                  case 110: {
                    const _x$7 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 2, v.start, v.end));
                    if (_x$7 === 97) {
                      const _x$8 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 3, v.start, v.end));
                      if (_x$8 === 110) {
                        break _L$3;
                      } else {
                        const _p$5 = _M0MPC16string10StringView4iter(v);
                        let _tmp$39;
                        while (true) {
                          const _p$6 = _M0MPB4Iter4nextGcE(_p$5);
                          if (_p$6 === -1) {
                            _tmp$39 = false;
                            break;
                          } else {
                            const _p$7 = _p$6;
                            const _p$8 = _p$7;
                            if (_M0MPC14char4Char16is__ascii__digit(_p$8)) {
                              _tmp$39 = true;
                              break;
                            }
                            continue;
                          }
                        }
                        if (_tmp$39) {
                          v$2 = v;
                          break _L$2;
                        } else {
                          break _L;
                        }
                      }
                    } else {
                      const _p$5 = _M0MPC16string10StringView4iter(v);
                      let _tmp$39;
                      while (true) {
                        const _p$6 = _M0MPB4Iter4nextGcE(_p$5);
                        if (_p$6 === -1) {
                          _tmp$39 = false;
                          break;
                        } else {
                          const _p$7 = _p$6;
                          const _p$8 = _p$7;
                          if (_M0MPC14char4Char16is__ascii__digit(_p$8)) {
                            _tmp$39 = true;
                            break;
                          }
                          continue;
                        }
                      }
                      if (_tmp$39) {
                        v$2 = v;
                        break _L$2;
                      } else {
                        break _L;
                      }
                    }
                  }
                  case 78: {
                    const _x$8 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 2, v.start, v.end));
                    switch (_x$8) {
                      case 97: {
                        const _x$9 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 3, v.start, v.end));
                        if (_x$9 === 78) {
                          break _L$3;
                        } else {
                          const _p$5 = _M0MPC16string10StringView4iter(v);
                          let _tmp$39;
                          while (true) {
                            const _p$6 = _M0MPB4Iter4nextGcE(_p$5);
                            if (_p$6 === -1) {
                              _tmp$39 = false;
                              break;
                            } else {
                              const _p$7 = _p$6;
                              const _p$8 = _p$7;
                              if (_M0MPC14char4Char16is__ascii__digit(_p$8)) {
                                _tmp$39 = true;
                                break;
                              }
                              continue;
                            }
                          }
                          if (_tmp$39) {
                            v$2 = v;
                            break _L$2;
                          } else {
                            break _L;
                          }
                        }
                      }
                      case 65: {
                        const _x$10 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 3, v.start, v.end));
                        if (_x$10 === 78) {
                          break _L$3;
                        } else {
                          const _p$5 = _M0MPC16string10StringView4iter(v);
                          let _tmp$39;
                          while (true) {
                            const _p$6 = _M0MPB4Iter4nextGcE(_p$5);
                            if (_p$6 === -1) {
                              _tmp$39 = false;
                              break;
                            } else {
                              const _p$7 = _p$6;
                              const _p$8 = _p$7;
                              if (_M0MPC14char4Char16is__ascii__digit(_p$8)) {
                                _tmp$39 = true;
                                break;
                              }
                              continue;
                            }
                          }
                          if (_tmp$39) {
                            v$2 = v;
                            break _L$2;
                          } else {
                            break _L;
                          }
                        }
                      }
                      default: {
                        const _p$5 = _M0MPC16string10StringView4iter(v);
                        let _tmp$39;
                        while (true) {
                          const _p$6 = _M0MPB4Iter4nextGcE(_p$5);
                          if (_p$6 === -1) {
                            _tmp$39 = false;
                            break;
                          } else {
                            const _p$7 = _p$6;
                            const _p$8 = _p$7;
                            if (_M0MPC14char4Char16is__ascii__digit(_p$8)) {
                              _tmp$39 = true;
                              break;
                            }
                            continue;
                          }
                        }
                        if (_tmp$39) {
                          v$2 = v;
                          break _L$2;
                        } else {
                          break _L;
                        }
                      }
                    }
                  }
                  default: {
                    const _p$6 = _M0MPC16string10StringView4iter(v);
                    let _tmp$40;
                    while (true) {
                      const _p$7 = _M0MPB4Iter4nextGcE(_p$6);
                      if (_p$7 === -1) {
                        _tmp$40 = false;
                        break;
                      } else {
                        const _p$8 = _p$7;
                        const _p$9 = _p$8;
                        if (_M0MPC14char4Char16is__ascii__digit(_p$9)) {
                          _tmp$40 = true;
                          break;
                        }
                        continue;
                      }
                    }
                    if (_tmp$40) {
                      v$2 = v;
                      break _L$2;
                    } else {
                      break _L;
                    }
                  }
                }
              } else {
                const _p$4 = _M0MPC16string10StringView4iter(v);
                let _tmp$38;
                while (true) {
                  const _p$5 = _M0MPB4Iter4nextGcE(_p$4);
                  if (_p$5 === -1) {
                    _tmp$38 = false;
                    break;
                  } else {
                    const _p$6 = _p$5;
                    const _p$7 = _p$6;
                    if (_M0MPC14char4Char16is__ascii__digit(_p$7)) {
                      _tmp$38 = true;
                      break;
                    }
                    continue;
                  }
                }
                if (_tmp$38) {
                  v$2 = v;
                  break _L$2;
                } else {
                  break _L;
                }
              }
            } else {
              if (_M0MPC16string6String24char__length__eq_2einner(v.str, 5, v.start, v.end)) {
                const _x = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 0, v.start, v.end));
                switch (_x) {
                  case 43: {
                    const _x$2 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 1, v.start, v.end));
                    if (_x$2 === 46) {
                      const _x$3 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 2, v.start, v.end));
                      switch (_x$3) {
                        case 105: {
                          const _x$4 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 3, v.start, v.end));
                          if (_x$4 === 110) {
                            const _x$5 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 4, v.start, v.end));
                            if (_x$5 === 102) {
                              break _L$5;
                            } else {
                              const _p$4 = _M0MPC16string10StringView4iter(v);
                              let _tmp$38;
                              while (true) {
                                const _p$5 = _M0MPB4Iter4nextGcE(_p$4);
                                if (_p$5 === -1) {
                                  _tmp$38 = false;
                                  break;
                                } else {
                                  const _p$6 = _p$5;
                                  const _p$7 = _p$6;
                                  if (_M0MPC14char4Char16is__ascii__digit(_p$7)) {
                                    _tmp$38 = true;
                                    break;
                                  }
                                  continue;
                                }
                              }
                              if (_tmp$38) {
                                v$2 = v;
                                break _L$2;
                              } else {
                                break _L;
                              }
                            }
                          } else {
                            const _p$4 = _M0MPC16string10StringView4iter(v);
                            let _tmp$38;
                            while (true) {
                              const _p$5 = _M0MPB4Iter4nextGcE(_p$4);
                              if (_p$5 === -1) {
                                _tmp$38 = false;
                                break;
                              } else {
                                const _p$6 = _p$5;
                                const _p$7 = _p$6;
                                if (_M0MPC14char4Char16is__ascii__digit(_p$7)) {
                                  _tmp$38 = true;
                                  break;
                                }
                                continue;
                              }
                            }
                            if (_tmp$38) {
                              v$2 = v;
                              break _L$2;
                            } else {
                              break _L;
                            }
                          }
                        }
                        case 73: {
                          const _x$5 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 3, v.start, v.end));
                          switch (_x$5) {
                            case 110: {
                              const _x$6 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 4, v.start, v.end));
                              if (_x$6 === 102) {
                                break _L$5;
                              } else {
                                const _p$4 = _M0MPC16string10StringView4iter(v);
                                let _tmp$38;
                                while (true) {
                                  const _p$5 = _M0MPB4Iter4nextGcE(_p$4);
                                  if (_p$5 === -1) {
                                    _tmp$38 = false;
                                    break;
                                  } else {
                                    const _p$6 = _p$5;
                                    const _p$7 = _p$6;
                                    if (_M0MPC14char4Char16is__ascii__digit(_p$7)) {
                                      _tmp$38 = true;
                                      break;
                                    }
                                    continue;
                                  }
                                }
                                if (_tmp$38) {
                                  v$2 = v;
                                  break _L$2;
                                } else {
                                  break _L;
                                }
                              }
                            }
                            case 78: {
                              const _x$7 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 4, v.start, v.end));
                              if (_x$7 === 70) {
                                break _L$5;
                              } else {
                                const _p$4 = _M0MPC16string10StringView4iter(v);
                                let _tmp$38;
                                while (true) {
                                  const _p$5 = _M0MPB4Iter4nextGcE(_p$4);
                                  if (_p$5 === -1) {
                                    _tmp$38 = false;
                                    break;
                                  } else {
                                    const _p$6 = _p$5;
                                    const _p$7 = _p$6;
                                    if (_M0MPC14char4Char16is__ascii__digit(_p$7)) {
                                      _tmp$38 = true;
                                      break;
                                    }
                                    continue;
                                  }
                                }
                                if (_tmp$38) {
                                  v$2 = v;
                                  break _L$2;
                                } else {
                                  break _L;
                                }
                              }
                            }
                            default: {
                              const _p$4 = _M0MPC16string10StringView4iter(v);
                              let _tmp$38;
                              while (true) {
                                const _p$5 = _M0MPB4Iter4nextGcE(_p$4);
                                if (_p$5 === -1) {
                                  _tmp$38 = false;
                                  break;
                                } else {
                                  const _p$6 = _p$5;
                                  const _p$7 = _p$6;
                                  if (_M0MPC14char4Char16is__ascii__digit(_p$7)) {
                                    _tmp$38 = true;
                                    break;
                                  }
                                  continue;
                                }
                              }
                              if (_tmp$38) {
                                v$2 = v;
                                break _L$2;
                              } else {
                                break _L;
                              }
                            }
                          }
                        }
                        default: {
                          const _p$5 = _M0MPC16string10StringView4iter(v);
                          let _tmp$39;
                          while (true) {
                            const _p$6 = _M0MPB4Iter4nextGcE(_p$5);
                            if (_p$6 === -1) {
                              _tmp$39 = false;
                              break;
                            } else {
                              const _p$7 = _p$6;
                              const _p$8 = _p$7;
                              if (_M0MPC14char4Char16is__ascii__digit(_p$8)) {
                                _tmp$39 = true;
                                break;
                              }
                              continue;
                            }
                          }
                          if (_tmp$39) {
                            v$2 = v;
                            break _L$2;
                          } else {
                            break _L;
                          }
                        }
                      }
                    } else {
                      const _p$4 = _M0MPC16string10StringView4iter(v);
                      let _tmp$38;
                      while (true) {
                        const _p$5 = _M0MPB4Iter4nextGcE(_p$4);
                        if (_p$5 === -1) {
                          _tmp$38 = false;
                          break;
                        } else {
                          const _p$6 = _p$5;
                          const _p$7 = _p$6;
                          if (_M0MPC14char4Char16is__ascii__digit(_p$7)) {
                            _tmp$38 = true;
                            break;
                          }
                          continue;
                        }
                      }
                      if (_tmp$38) {
                        v$2 = v;
                        break _L$2;
                      } else {
                        break _L;
                      }
                    }
                  }
                  case 45: {
                    const _x$3 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 1, v.start, v.end));
                    if (_x$3 === 46) {
                      const _x$4 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 2, v.start, v.end));
                      switch (_x$4) {
                        case 105: {
                          const _x$5 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 3, v.start, v.end));
                          if (_x$5 === 110) {
                            const _x$6 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 4, v.start, v.end));
                            if (_x$6 === 102) {
                              break _L$4;
                            } else {
                              const _p$4 = _M0MPC16string10StringView4iter(v);
                              let _tmp$38;
                              while (true) {
                                const _p$5 = _M0MPB4Iter4nextGcE(_p$4);
                                if (_p$5 === -1) {
                                  _tmp$38 = false;
                                  break;
                                } else {
                                  const _p$6 = _p$5;
                                  const _p$7 = _p$6;
                                  if (_M0MPC14char4Char16is__ascii__digit(_p$7)) {
                                    _tmp$38 = true;
                                    break;
                                  }
                                  continue;
                                }
                              }
                              if (_tmp$38) {
                                v$2 = v;
                                break _L$2;
                              } else {
                                break _L;
                              }
                            }
                          } else {
                            const _p$4 = _M0MPC16string10StringView4iter(v);
                            let _tmp$38;
                            while (true) {
                              const _p$5 = _M0MPB4Iter4nextGcE(_p$4);
                              if (_p$5 === -1) {
                                _tmp$38 = false;
                                break;
                              } else {
                                const _p$6 = _p$5;
                                const _p$7 = _p$6;
                                if (_M0MPC14char4Char16is__ascii__digit(_p$7)) {
                                  _tmp$38 = true;
                                  break;
                                }
                                continue;
                              }
                            }
                            if (_tmp$38) {
                              v$2 = v;
                              break _L$2;
                            } else {
                              break _L;
                            }
                          }
                        }
                        case 73: {
                          const _x$6 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 3, v.start, v.end));
                          switch (_x$6) {
                            case 110: {
                              const _x$7 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 4, v.start, v.end));
                              if (_x$7 === 102) {
                                break _L$4;
                              } else {
                                const _p$4 = _M0MPC16string10StringView4iter(v);
                                let _tmp$38;
                                while (true) {
                                  const _p$5 = _M0MPB4Iter4nextGcE(_p$4);
                                  if (_p$5 === -1) {
                                    _tmp$38 = false;
                                    break;
                                  } else {
                                    const _p$6 = _p$5;
                                    const _p$7 = _p$6;
                                    if (_M0MPC14char4Char16is__ascii__digit(_p$7)) {
                                      _tmp$38 = true;
                                      break;
                                    }
                                    continue;
                                  }
                                }
                                if (_tmp$38) {
                                  v$2 = v;
                                  break _L$2;
                                } else {
                                  break _L;
                                }
                              }
                            }
                            case 78: {
                              const _x$8 = _M0MPC16string6String16unsafe__char__at(v.str, _M0MPC16string6String29offset__of__nth__char_2einner(v.str, 4, v.start, v.end));
                              if (_x$8 === 70) {
                                break _L$4;
                              } else {
                                const _p$4 = _M0MPC16string10StringView4iter(v);
                                let _tmp$38;
                                while (true) {
                                  const _p$5 = _M0MPB4Iter4nextGcE(_p$4);
                                  if (_p$5 === -1) {
                                    _tmp$38 = false;
                                    break;
                                  } else {
                                    const _p$6 = _p$5;
                                    const _p$7 = _p$6;
                                    if (_M0MPC14char4Char16is__ascii__digit(_p$7)) {
                                      _tmp$38 = true;
                                      break;
                                    }
                                    continue;
                                  }
                                }
                                if (_tmp$38) {
                                  v$2 = v;
                                  break _L$2;
                                } else {
                                  break _L;
                                }
                              }
                            }
                            default: {
                              const _p$4 = _M0MPC16string10StringView4iter(v);
                              let _tmp$38;
                              while (true) {
                                const _p$5 = _M0MPB4Iter4nextGcE(_p$4);
                                if (_p$5 === -1) {
                                  _tmp$38 = false;
                                  break;
                                } else {
                                  const _p$6 = _p$5;
                                  const _p$7 = _p$6;
                                  if (_M0MPC14char4Char16is__ascii__digit(_p$7)) {
                                    _tmp$38 = true;
                                    break;
                                  }
                                  continue;
                                }
                              }
                              if (_tmp$38) {
                                v$2 = v;
                                break _L$2;
                              } else {
                                break _L;
                              }
                            }
                          }
                        }
                        default: {
                          const _p$5 = _M0MPC16string10StringView4iter(v);
                          let _tmp$39;
                          while (true) {
                            const _p$6 = _M0MPB4Iter4nextGcE(_p$5);
                            if (_p$6 === -1) {
                              _tmp$39 = false;
                              break;
                            } else {
                              const _p$7 = _p$6;
                              const _p$8 = _p$7;
                              if (_M0MPC14char4Char16is__ascii__digit(_p$8)) {
                                _tmp$39 = true;
                                break;
                              }
                              continue;
                            }
                          }
                          if (_tmp$39) {
                            v$2 = v;
                            break _L$2;
                          } else {
                            break _L;
                          }
                        }
                      }
                    } else {
                      const _p$4 = _M0MPC16string10StringView4iter(v);
                      let _tmp$38;
                      while (true) {
                        const _p$5 = _M0MPB4Iter4nextGcE(_p$4);
                        if (_p$5 === -1) {
                          _tmp$38 = false;
                          break;
                        } else {
                          const _p$6 = _p$5;
                          const _p$7 = _p$6;
                          if (_M0MPC14char4Char16is__ascii__digit(_p$7)) {
                            _tmp$38 = true;
                            break;
                          }
                          continue;
                        }
                      }
                      if (_tmp$38) {
                        v$2 = v;
                        break _L$2;
                      } else {
                        break _L;
                      }
                    }
                  }
                  default: {
                    const _p$4 = _M0MPC16string10StringView4iter(v);
                    let _tmp$38;
                    while (true) {
                      const _p$5 = _M0MPB4Iter4nextGcE(_p$4);
                      if (_p$5 === -1) {
                        _tmp$38 = false;
                        break;
                      } else {
                        const _p$6 = _p$5;
                        const _p$7 = _p$6;
                        if (_M0MPC14char4Char16is__ascii__digit(_p$7)) {
                          _tmp$38 = true;
                          break;
                        }
                        continue;
                      }
                    }
                    if (_tmp$38) {
                      v$2 = v;
                      break _L$2;
                    } else {
                      break _L;
                    }
                  }
                }
              } else {
                const _p$4 = _M0MPC16string10StringView4iter(v);
                let _tmp$38;
                while (true) {
                  const _p$5 = _M0MPB4Iter4nextGcE(_p$4);
                  if (_p$5 === -1) {
                    _tmp$38 = false;
                    break;
                  } else {
                    const _p$6 = _p$5;
                    const _p$7 = _p$6;
                    if (_M0MPC14char4Char16is__ascii__digit(_p$7)) {
                      _tmp$38 = true;
                      break;
                    }
                    continue;
                  }
                }
                if (_tmp$38) {
                  v$2 = v;
                  break _L$2;
                } else {
                  break _L;
                }
              }
            }
          }
          return new _M0DTPC16option6OptionGdE4Some(_M0FPC16double8infinity);
        }
        return new _M0DTPC16option6OptionGdE4Some(_M0FPC16double13neg__infinity);
      }
      return new _M0DTPC16option6OptionGdE4Some(_M0FPC16double14not__a__number);
    }
    let _try_err;
    _L$3: {
      const _bind$4 = _M0FPC17strconv13parse__double(v$2);
      let _tmp$38;
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        _tmp$38 = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$3;
      }
      return new _M0DTPC16option6OptionGdE4Some(_tmp$38);
    }
    return _M0DTPC16option6OptionGdE4None__;
  }
  return _M0DTPC16option6OptionGdE4None__;
}
function _M0MP219moonbit_2dcommunity4yaml4Yaml9from__str(v) {
  let v$2;
  _L: {
    _L$2: {
      _L$3: {
        _L$4: {
          let number;
          let i;
          _L$5: {
            if (_M0MPC16string6String24char__length__ge_2einner(v, 2, 0, v.length)) {
              const _x = v.charCodeAt(0);
              switch (_x) {
                case 48: {
                  const _x$2 = v.charCodeAt(1);
                  switch (_x$2) {
                    case 120: {
                      const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(v, 2, 0, v.length);
                      let _tmp$38;
                      if (_bind$4 === undefined) {
                        _tmp$38 = v.length;
                      } else {
                        const _Some = _bind$4;
                        _tmp$38 = _Some;
                      }
                      const _x$3 = new _M0TPC16string10StringView(v, _tmp$38, v.length);
                      let _bind$5;
                      let _try_err;
                      _L$6: {
                        _L$7: {
                          const _bind$6 = _M0FPC17strconv20parse__int64_2einner(_x$3, 16);
                          let _tmp$39;
                          if (_bind$6.$tag === 1) {
                            const _ok = _bind$6;
                            _tmp$39 = _ok._0;
                          } else {
                            const _err = _bind$6;
                            _try_err = _err._0;
                            break _L$7;
                          }
                          _bind$5 = new _M0DTPC16result6ResultGlRPC17strconv12StrConvErrorE2Ok(_tmp$39);
                          break _L$6;
                        }
                        _bind$5 = new _M0DTPC16result6ResultGlRPC17strconv12StrConvErrorE3Err(_try_err);
                      }
                      if (_bind$5.$tag === 1) {
                        const _Ok = _bind$5;
                        const _i = _Ok._0;
                        return new _M0DTP219moonbit_2dcommunity4yaml4Yaml7Integer(_i);
                      } else {
                        v$2 = v;
                        break _L;
                      }
                    }
                    case 111: {
                      const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(v, 2, 0, v.length);
                      let _tmp$39;
                      if (_bind$6 === undefined) {
                        _tmp$39 = v.length;
                      } else {
                        const _Some = _bind$6;
                        _tmp$39 = _Some;
                      }
                      const _x$4 = new _M0TPC16string10StringView(v, _tmp$39, v.length);
                      let _bind$7;
                      let _try_err$2;
                      _L$7: {
                        _L$8: {
                          const _bind$8 = _M0FPC17strconv20parse__int64_2einner(_x$4, 8);
                          let _tmp$40;
                          if (_bind$8.$tag === 1) {
                            const _ok = _bind$8;
                            _tmp$40 = _ok._0;
                          } else {
                            const _err = _bind$8;
                            _try_err$2 = _err._0;
                            break _L$8;
                          }
                          _bind$7 = new _M0DTPC16result6ResultGlRPC17strconv12StrConvErrorE2Ok(_tmp$40);
                          break _L$7;
                        }
                        _bind$7 = new _M0DTPC16result6ResultGlRPC17strconv12StrConvErrorE3Err(_try_err$2);
                      }
                      if (_bind$7.$tag === 1) {
                        const _Ok = _bind$7;
                        const _i = _Ok._0;
                        return new _M0DTP219moonbit_2dcommunity4yaml4Yaml7Integer(_i);
                      } else {
                        v$2 = v;
                        break _L;
                      }
                    }
                    default: {
                      v$2 = v;
                      break _L;
                    }
                  }
                }
                case 43: {
                  const _bind$8 = _M0MPC16string6String29offset__of__nth__char_2einner(v, 1, 0, v.length);
                  let _tmp$40;
                  if (_bind$8 === undefined) {
                    _tmp$40 = v.length;
                  } else {
                    const _Some = _bind$8;
                    _tmp$40 = _Some;
                  }
                  const _x$5 = new _M0TPC16string10StringView(v, _tmp$40, v.length);
                  let _bind$9;
                  let _try_err$3;
                  _L$8: {
                    _L$9: {
                      const _bind$10 = _M0FPC17strconv20parse__int64_2einner(_x$5, 0);
                      let _tmp$41;
                      if (_bind$10.$tag === 1) {
                        const _ok = _bind$10;
                        _tmp$41 = _ok._0;
                      } else {
                        const _err = _bind$10;
                        _try_err$3 = _err._0;
                        break _L$9;
                      }
                      _bind$9 = new _M0DTPC16result6ResultGlRPC17strconv12StrConvErrorE2Ok(_tmp$41);
                      break _L$8;
                    }
                    _bind$9 = new _M0DTPC16result6ResultGlRPC17strconv12StrConvErrorE3Err(_try_err$3);
                  }
                  if (_bind$9.$tag === 1) {
                    const _Ok = _bind$9;
                    const _i = _Ok._0;
                    number = _x$5;
                    i = _i;
                    break _L$5;
                  } else {
                    v$2 = v;
                    break _L;
                  }
                }
                default: {
                  switch (v) {
                    case "null": {
                      break _L$4;
                    }
                    case "true": {
                      break _L$3;
                    }
                    case "True": {
                      break _L$3;
                    }
                    case "TRUE": {
                      break _L$3;
                    }
                    case "false": {
                      break _L$2;
                    }
                    case "False": {
                      break _L$2;
                    }
                    case "FALSE": {
                      break _L$2;
                    }
                    default: {
                      v$2 = v;
                      break _L;
                    }
                  }
                }
              }
            } else {
              if (_M0MPC16string6String24char__length__ge_2einner(v, 1, 0, v.length)) {
                const _x = v.charCodeAt(0);
                if (_x === 43) {
                  const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(v, 1, 0, v.length);
                  let _tmp$38;
                  if (_bind$4 === undefined) {
                    _tmp$38 = v.length;
                  } else {
                    const _Some = _bind$4;
                    _tmp$38 = _Some;
                  }
                  const _x$2 = new _M0TPC16string10StringView(v, _tmp$38, v.length);
                  let _bind$5;
                  let _try_err;
                  _L$6: {
                    _L$7: {
                      const _bind$6 = _M0FPC17strconv20parse__int64_2einner(_x$2, 0);
                      let _tmp$39;
                      if (_bind$6.$tag === 1) {
                        const _ok = _bind$6;
                        _tmp$39 = _ok._0;
                      } else {
                        const _err = _bind$6;
                        _try_err = _err._0;
                        break _L$7;
                      }
                      _bind$5 = new _M0DTPC16result6ResultGlRPC17strconv12StrConvErrorE2Ok(_tmp$39);
                      break _L$6;
                    }
                    _bind$5 = new _M0DTPC16result6ResultGlRPC17strconv12StrConvErrorE3Err(_try_err);
                  }
                  if (_bind$5.$tag === 1) {
                    const _Ok = _bind$5;
                    const _i = _Ok._0;
                    number = _x$2;
                    i = _i;
                    break _L$5;
                  } else {
                    v$2 = v;
                    break _L;
                  }
                } else {
                  if (v === "~") {
                    break _L$4;
                  } else {
                    v$2 = v;
                    break _L;
                  }
                }
              } else {
                break _L$4;
              }
            }
          }
          return new _M0DTP219moonbit_2dcommunity4yaml4Yaml7Integer(i);
        }
        return _M0DTP219moonbit_2dcommunity4yaml4Yaml4Null__;
      }
      return _M0MP219moonbit_2dcommunity4yaml4Yaml9from__strN6constrS2064;
    }
    return _M0MP219moonbit_2dcommunity4yaml4Yaml9from__strN6constrS2063;
  }
  let _bind$4;
  let _try_err;
  _L$2: {
    _L$3: {
      const _bind$5 = _M0FPC17strconv20parse__int64_2einner(new _M0TPC16string10StringView(v$2, 0, v$2.length), 0);
      let _tmp$38;
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        _tmp$38 = _ok._0;
      } else {
        const _err = _bind$5;
        _try_err = _err._0;
        break _L$3;
      }
      _bind$4 = new _M0DTPC16result6ResultGlRPC17strconv12StrConvErrorE2Ok(_tmp$38);
      break _L$2;
    }
    _bind$4 = new _M0DTPC16result6ResultGlRPC17strconv12StrConvErrorE3Err(_try_err);
  }
  if (_bind$4.$tag === 1) {
    const _Ok = _bind$4;
    const _integer = _Ok._0;
    return new _M0DTP219moonbit_2dcommunity4yaml4Yaml7Integer(_integer);
  } else {
    const _bind$5 = _M0FP219moonbit_2dcommunity4yaml13parse__double(new _M0TPC16string10StringView(v$2, 0, v$2.length));
    if (_bind$5.$tag === 1) {
      const _Some = _bind$5;
      const _d = _Some._0;
      return new _M0DTP219moonbit_2dcommunity4yaml4Yaml4Real(_d, v$2);
    } else {
      return new _M0DTP219moonbit_2dcommunity4yaml4Yaml6String(v$2);
    }
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self) {
  return new _M0TP219moonbit_2dcommunity4yaml6Marker(self.index, self.line, self.col);
}
function _M0MP219moonbit_2dcommunity4yaml6Parser12fetch__token(self) {
  const token = self.token;
  self.token = undefined;
  return _M0MPC16option6Option16unwrap__or__elseGRP219moonbit_2dcommunity4yaml5TokenE(token, () => {
    _M0FPB7printlnGsE("fetch_token needs to be preceded by peek_token");
    return $panic();
  });
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) {
  return _M0MPC15deque5Deque2atGcE(self.buffer, 0);
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer8char__is(self, c) {
  return _M0MPC15deque5Deque2atGcE(self.buffer, 0) === c;
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer21disallow__simple__key(self) {
  self.simple_key_allowed = false;
}
function _M0MP219moonbit_2dcommunity4yaml9SimpleKey3new(mark) {
  return new _M0TP219moonbit_2dcommunity4yaml9SimpleKey(false, false, 0, mark);
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer17save__simple__key(self) {
  if (self.simple_key_allowed) {
    let required;
    if (self.flow_level === 0) {
      let _tmp$38;
      if (self.indent === self.col) {
        const _p$4 = _M0MPC15array5Array4lastGURP219moonbit_2dcommunity4yaml4YamliEE(self.indents);
        let _tmp$39;
        if (_p$4 === undefined) {
          _tmp$39 = $panic();
        } else {
          const _p$5 = _p$4;
          _tmp$39 = _p$5;
        }
        _tmp$38 = _tmp$39.needs_block_end;
      } else {
        _tmp$38 = false;
      }
      required = _tmp$38;
    } else {
      required = false;
    }
    const sk = _M0MP219moonbit_2dcommunity4yaml9SimpleKey3new(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self));
    sk.possible = true;
    sk.required = required;
    const _tmp$38 = self.tokens_parsed;
    const _p$4 = self.tokens;
    sk.token_number = _tmp$38 + _p$4.len | 0;
    _M0MPC15array5Array3popGsE(self.simple_keys);
    _M0MPC15array5Array4pushGUssEE(self.simple_keys, sk);
    return;
  } else {
    return;
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, count) {
  const _p$4 = self.buffer;
  if (_p$4.len >= count) {
    return undefined;
  }
  const _p$5 = self.buffer;
  const _bind$4 = count - _p$5.len | 0;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const _bind$5 = self.input;
      let chr;
      if (_M0MPC16string6String24char__length__eq_2einner(_bind$5.str, 0, _bind$5.start, _bind$5.end)) {
        chr = 0;
      } else {
        const _chr = _M0MPC16string6String16unsafe__char__at(_bind$5.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 0, _bind$5.start, _bind$5.end));
        const _tmp$39 = _bind$5.str;
        const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end);
        let _tmp$40;
        if (_bind$6 === undefined) {
          _tmp$40 = _bind$5.end;
        } else {
          const _Some = _bind$6;
          _tmp$40 = _Some;
        }
        const _x = new _M0TPC16string10StringView(_tmp$39, _tmp$40, _bind$5.end);
        self.input = _x;
        chr = _chr;
      }
      _M0MPC15deque5Deque10push__backGcE(self.buffer, chr);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self) {
  _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 1);
  return _M0MPC15deque5Deque2atGcE(self.buffer, 0);
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self) {
  _M0MPC15deque5Deque10pop__frontGcE(self.buffer);
  self.index = self.index + 1 | 0;
  self.col = self.col + 1 | 0;
  self.leading_whitespace = false;
}
function _M0EPC14char4CharP219moonbit_2dcommunity4yaml8is__flow(self) {
  return self === 44 || (self === 91 || (self === 93 || (self === 123 || self === 125)));
}
function _M0EPC14char4CharP219moonbit_2dcommunity4yaml20is__yaml__non__break(self) {
  return !(self === 10 || self === 13) && !(self === 65279);
}
function _M0EPC14char4CharP219moonbit_2dcommunity4yaml20is__yaml__non__space(self) {
  return _M0EPC14char4CharP219moonbit_2dcommunity4yaml20is__yaml__non__break(self) && !(self === 32 || self === 9);
}
function _M0EPC14char4CharP219moonbit_2dcommunity4yaml16is__anchor__char(self) {
  return _M0EPC14char4CharP219moonbit_2dcommunity4yaml20is__yaml__non__space(self) && (!_M0EPC14char4CharP219moonbit_2dcommunity4yaml8is__flow(self) && !(self === 0));
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer12scan__anchor(self, is_alias) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const start_mark = _M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self);
  _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
  while (true) {
    if (_M0EPC14char4CharP219moonbit_2dcommunity4yaml16is__anchor__char(_M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self))) {
      _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self));
      _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
      continue;
    } else {
      break;
    }
  }
  if (buf.val === "") {
    return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(start_mark, "while scanning an anchor or alias, did not find expected alphabetic or numeric character"));
  }
  return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(is_alias ? new _M0TP219moonbit_2dcommunity4yaml5Token(start_mark, new _M0DTP219moonbit_2dcommunity4yaml9TokenType5Alias(buf.val)) : new _M0TP219moonbit_2dcommunity4yaml5Token(start_mark, new _M0DTP219moonbit_2dcommunity4yaml9TokenType6Anchor(buf.val)));
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer13fetch__anchor(self, is_alias) {
  _M0MP219moonbit_2dcommunity4yaml5Lexer17save__simple__key(self);
  _M0MP219moonbit_2dcommunity4yaml5Lexer21disallow__simple__key(self);
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer12scan__anchor(self, is_alias);
  let tok;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    tok = _ok._0;
  } else {
    return _bind$4;
  }
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0MPC15deque5Deque10push__backGRP219moonbit_2dcommunity4yaml5TokenE(self.tokens, tok));
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer18allow__simple__key(self) {
  self.simple_key_allowed = true;
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer19remove__simple__key(self) {
  const _p$4 = _M0MPC15array5Array4lastGURP219moonbit_2dcommunity4yaml4YamliEE(self.simple_keys);
  let last;
  if (_p$4 === undefined) {
    last = $panic();
  } else {
    const _p$5 = _p$4;
    last = _p$5;
  }
  if (last.possible && last.required) {
    return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), "simple key expected"));
  }
  last.possible = false;
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(undefined);
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer13insert__token(self, pos, token) {
  const _p$4 = self.tokens;
  if (pos <= _p$4.len) {
    _M0MPC15deque5Deque6insertGRP219moonbit_2dcommunity4yaml5TokenE(self.tokens, pos, token);
    return;
  } else {
    $panic();
    return;
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer12roll__indent(self, col, number, tok, mark) {
  if (self.flow_level > 0) {
    return undefined;
  }
  if (self.indent <= col) {
    const _bind$4 = _M0MPC15array5Array4lastGURP219moonbit_2dcommunity4yaml4YamliEE(self.indents);
    if (_bind$4 === undefined) {
    } else {
      const _Some = _bind$4;
      const _indent = _Some;
      if (!_indent.needs_block_end) {
        self.indent = _indent.indent;
        _M0MPC15array5Array3popGsE(self.indents);
      }
    }
  }
  if (self.indent < col) {
    _M0MPC15array5Array4pushGUssEE(self.indents, new _M0TP219moonbit_2dcommunity4yaml6Indent(self.indent, true));
    self.indent = col;
    const tokens_parsed = self.tokens_parsed;
    if (number === undefined) {
      _M0MPC15deque5Deque10push__backGRP219moonbit_2dcommunity4yaml5TokenE(self.tokens, new _M0TP219moonbit_2dcommunity4yaml5Token(mark, tok));
      return;
    } else {
      const _Some = number;
      const _n = _Some;
      _M0MP219moonbit_2dcommunity4yaml5Lexer13insert__token(self, _n - tokens_parsed | 0, new _M0TP219moonbit_2dcommunity4yaml5Token(mark, tok));
      return;
    }
  } else {
    return;
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer22roll__one__col__indent(self) {
  if (self.flow_level === 0 && _M0MPC16option6Option7map__orGRP219moonbit_2dcommunity4yaml6IndentbE(_M0MPC15array5Array4lastGURP219moonbit_2dcommunity4yaml4YamliEE(self.indents), false, (indent) => indent.needs_block_end)) {
    _M0MPC15array5Array4pushGUssEE(self.indents, new _M0TP219moonbit_2dcommunity4yaml6Indent(self.indent, false));
    self.indent = self.indent + 1 | 0;
    return;
  } else {
    return;
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer11skip__blank(self) {
  _M0MPC15deque5Deque10pop__frontGcE(self.buffer);
  self.index = self.index + 1 | 0;
  self.col = self.col + 1 | 0;
}
function _M0EPC14char4CharP219moonbit_2dcommunity4yaml10is__breakz(self) {
  return self === 10 || self === 13 || self === 0;
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer17skip__ws__to__eol(self, skip_tabs) {
  let encountered_tab = false;
  let has_onemore_whitespace = false;
  while (true) {
    _L: {
      _L$2: {
        const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self);
        switch (_bind$4) {
          case 32: {
            has_onemore_whitespace = true;
            _M0MP219moonbit_2dcommunity4yaml5Lexer11skip__blank(self);
            break;
          }
          case 9: {
            if (_M0IP016_24default__implPB2Eq10not__equalGRP219moonbit_2dcommunity4yaml8SkipTabsE(skip_tabs, _M0DTP219moonbit_2dcommunity4yaml8SkipTabs2No__)) {
              encountered_tab = true;
              _M0MP219moonbit_2dcommunity4yaml5Lexer11skip__blank(self);
            } else {
              break _L$2;
            }
            break;
          }
          case 35: {
            if (!encountered_tab && !has_onemore_whitespace) {
              return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml8SkipTabsRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), "comments must be separated from other tokens by whitespace"));
            } else {
              while (true) {
                if (!_M0EPC14char4CharP219moonbit_2dcommunity4yaml10is__breakz(_M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self))) {
                  _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
                  continue;
                } else {
                  break;
                }
              }
            }
            break;
          }
          default: {
            break _L$2;
          }
        }
        break _L;
      }
      break;
    }
    continue;
  }
  return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml8SkipTabsRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(new _M0DTP219moonbit_2dcommunity4yaml8SkipTabs6Result(encountered_tab, has_onemore_whitespace));
}
function _M0MP219moonbit_2dcommunity4yaml8SkipTabs11found__tabs(self) {
  if (self.$tag === 2) {
    const _Result = self;
    const _x = _Result._0;
    if (_x === true) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}
function _M0EPC14char4CharP219moonbit_2dcommunity4yaml21is__blank__or__breakz(self) {
  return self === 32 || self === 9 || (self === 10 || self === 13 || self === 0);
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer19fetch__block__entry(self) {
  if (self.flow_level > 0) {
    return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), "'-' is only valid inside a block"));
  }
  if (!self.simple_key_allowed) {
    return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), "block sequence entries are not allowed in this context"));
  }
  let marker;
  _L: {
    _L$2: {
      const _bind$4 = _M0MPC15deque5Deque4backGRP219moonbit_2dcommunity4yaml5TokenE(self.tokens);
      if (_bind$4 === undefined) {
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        const _marker = _x.marker;
        const _x$2 = _x.token_type;
        switch (_x$2.$tag) {
          case 18: {
            marker = _marker;
            break _L$2;
          }
          case 19: {
            marker = _marker;
            break _L$2;
          }
        }
      }
      break _L;
    }
    if (self.col === 0 && (marker.col === 0 && self.indent > -1)) {
      return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(marker, "invalid indentation for anchor"));
    }
  }
  const mark = _M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self);
  _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
  _M0MP219moonbit_2dcommunity4yaml5Lexer12roll__indent(self, mark.col, undefined, _M0DTP219moonbit_2dcommunity4yaml9TokenType18BlockSequenceStart__, mark);
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer17skip__ws__to__eol(self, _M0DTP219moonbit_2dcommunity4yaml8SkipTabs3Yes__);
  let _tmp$38;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _tmp$38 = _ok._0;
  } else {
    return _bind$4;
  }
  const found_tabs = _M0MP219moonbit_2dcommunity4yaml8SkipTabs11found__tabs(_tmp$38);
  _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 2);
  if (found_tabs && (_M0MPC15deque5Deque2atGcE(self.buffer, 0) === 45 && _M0EPC14char4CharP219moonbit_2dcommunity4yaml21is__blank__or__breakz(_M0MPC15deque5Deque2atGcE(self.buffer, 1)))) {
    return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), "'-' must be followed by a valid YAML whitespace"));
  }
  const _bind$5 = _M0MP219moonbit_2dcommunity4yaml5Lexer17skip__ws__to__eol(self, _M0DTP219moonbit_2dcommunity4yaml8SkipTabs2No__);
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    _ok._0;
  } else {
    return _bind$5;
  }
  let _tmp$39;
  const _p$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self);
  if (_p$4 === 10 || _p$4 === 13) {
    _tmp$39 = true;
  } else {
    _tmp$39 = _M0EPC14char4CharP219moonbit_2dcommunity4yaml8is__flow(_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self));
  }
  if (_tmp$39) {
    _M0MP219moonbit_2dcommunity4yaml5Lexer22roll__one__col__indent(self);
  }
  const _bind$6 = _M0MP219moonbit_2dcommunity4yaml5Lexer19remove__simple__key(self);
  if (_bind$6.$tag === 1) {
    const _ok = _bind$6;
    _ok._0;
  } else {
    return _bind$6;
  }
  _M0MP219moonbit_2dcommunity4yaml5Lexer18allow__simple__key(self);
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0MPC15deque5Deque10push__backGRP219moonbit_2dcommunity4yaml5TokenE(self.tokens, new _M0TP219moonbit_2dcommunity4yaml5Token(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), _M0DTP219moonbit_2dcommunity4yaml9TokenType10BlockEntry__)));
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer23next__is__document__end(self) {
  const _p$4 = self.buffer;
  if (_p$4.len >= 4) {
    return _M0MPC15deque5Deque2atGcE(self.buffer, 0) === 46 && (_M0MPC15deque5Deque2atGcE(self.buffer, 1) === 46 && (_M0MPC15deque5Deque2atGcE(self.buffer, 2) === 46 && _M0EPC14char4CharP219moonbit_2dcommunity4yaml21is__blank__or__breakz(_M0MPC15deque5Deque2atGcE(self.buffer, 3))));
  } else {
    return $panic();
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer13skip__newline(self) {
  _M0MPC15deque5Deque10pop__frontGcE(self.buffer);
  self.index = self.index + 1 | 0;
  self.line = self.line + 1 | 0;
  self.col = 0;
  self.leading_whitespace = true;
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer11read__break(self, buf) {
  const c = _M0MPC15deque5Deque2atGcE(self.buffer, 0);
  const nc = _M0MPC15deque5Deque2atGcE(self.buffer, 1);
  if (c === 13 && nc === 10) {
    _M0MP219moonbit_2dcommunity4yaml5Lexer11skip__blank(self);
  }
  _M0MP219moonbit_2dcommunity4yaml5Lexer13skip__newline(self);
  _M0IPB13StringBuilderPB6Logger11write__char(buf, 10);
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer15raw__read__char(self) {
  const _bind$4 = self.input;
  if (_M0MPC16string6String24char__length__eq_2einner(_bind$4.str, 0, _bind$4.start, _bind$4.end)) {
    return 0;
  } else {
    const _chr = _M0MPC16string6String16unsafe__char__at(_bind$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 0, _bind$4.start, _bind$4.end));
    const _tmp$38 = _bind$4.str;
    const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
    let _tmp$39;
    if (_bind$5 === undefined) {
      _tmp$39 = _bind$4.end;
    } else {
      const _Some = _bind$5;
      _tmp$39 = _Some;
    }
    const _x = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$4.end);
    self.input = _x;
    return _chr;
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer34scan__block__scalar__content__line(self, buf, line_buffer) {
  while (true) {
    let _tmp$38;
    const _p$4 = self.buffer;
    if (!(_p$4.len === 0)) {
      _tmp$38 = !_M0EPC14char4CharP219moonbit_2dcommunity4yaml10is__breakz(_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self));
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self));
      _M0MP219moonbit_2dcommunity4yaml5Lexer11skip__blank(self);
      continue;
    } else {
      break;
    }
  }
  const _p$4 = self.buffer;
  if (_p$4.len === 0) {
    let line_buffer_size = 0;
    let c = _M0MP219moonbit_2dcommunity4yaml5Lexer15raw__read__char(self);
    while (true) {
      if (!_M0EPC14char4CharP219moonbit_2dcommunity4yaml10is__breakz(c)) {
        _M0IPB13StringBuilderPB6Logger11write__char(line_buffer, c);
        line_buffer_size = line_buffer_size + 1 | 0;
        c = _M0MP219moonbit_2dcommunity4yaml5Lexer15raw__read__char(self);
        continue;
      } else {
        break;
      }
    }
    _M0MPC15deque5Deque10push__backGcE(self.buffer, c);
    self.col = self.col + line_buffer_size | 0;
    self.index = self.index + line_buffer_size | 0;
    _M0IPB13StringBuilderPB6Logger13write__string(buf, line_buffer.val);
    _M0MPB13StringBuilder5reset(line_buffer);
    return;
  } else {
    return;
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer40skip__block__scalar__first__line__indent(self, indent, breaks) {
  let max_indent = 0;
  while (true) {
    while (true) {
      if (_M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self) === 32) {
        _M0MP219moonbit_2dcommunity4yaml5Lexer11skip__blank(self);
        continue;
      } else {
        break;
      }
    }
    if (self.col > max_indent) {
      max_indent = self.col;
    }
    const _p$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self);
    if (_p$4 === 10 || _p$4 === 13) {
      _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 2);
      _M0MP219moonbit_2dcommunity4yaml5Lexer11read__break(self, breaks);
    } else {
      break;
    }
    continue;
  }
  const _p$4 = max_indent;
  const _p$5 = self.indent + 1 | 0;
  indent.val = _p$4 > _p$5 ? _p$4 : _p$5;
  if (self.indent > 0) {
    const _p$6 = indent.val;
    const _p$7 = 1;
    indent.val = _p$6 > _p$7 ? _p$6 : _p$7;
    return;
  } else {
    return;
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer27skip__block__scalar__indent(self, indent, breaks) {
  while (true) {
    if (indent < 14) {
      _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 16);
      while (true) {
        if (self.col < indent && _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) === 32) {
          _M0MP219moonbit_2dcommunity4yaml5Lexer11skip__blank(self);
          continue;
        } else {
          break;
        }
      }
    } else {
      while (true) {
        _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 16);
        while (true) {
          let _tmp$38;
          const _p$4 = self.buffer;
          if (!(_p$4.len === 0)) {
            _tmp$38 = self.col < indent && _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) === 32;
          } else {
            _tmp$38 = false;
          }
          if (_tmp$38) {
            _M0MP219moonbit_2dcommunity4yaml5Lexer11skip__blank(self);
            continue;
          } else {
            break;
          }
        }
        let _tmp$38;
        if (self.col === indent) {
          _tmp$38 = true;
        } else {
          let _tmp$39;
          const _p$4 = self.buffer;
          if (!(_p$4.len === 0)) {
            _tmp$39 = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) !== 32;
          } else {
            _tmp$39 = false;
          }
          _tmp$38 = _tmp$39;
        }
        if (_tmp$38) {
          break;
        }
        continue;
      }
      _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 2);
    }
    const _p$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self);
    if (_p$4 === 10 || _p$4 === 13) {
      _M0MP219moonbit_2dcommunity4yaml5Lexer11read__break(self, breaks);
    } else {
      return;
    }
    continue;
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer27unroll__non__block__indents(self) {
  while (true) {
    const _bind$4 = _M0MPC15array5Array4lastGURP219moonbit_2dcommunity4yaml4YamliEE(self.indents);
    if (_bind$4 === undefined) {
      return;
    } else {
      const _Some = _bind$4;
      const _indent = _Some;
      if (_indent.needs_block_end) {
        return;
      }
      self.indent = _indent.indent;
      _M0MPC15array5Array3popGsE(self.indents);
      continue;
    }
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer19scan__block__scalar(self, literal) {
  const start_mark = _M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self);
  let chomping = 1;
  let increment = 0;
  const indent = _M0MPC13ref3Ref3RefGiE(0);
  let trailing_blank = false;
  let leading_blank = false;
  const style = literal ? 3 : 4;
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const leading_break = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const trailing_breaks = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const chomping_break = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
  _M0MP219moonbit_2dcommunity4yaml5Lexer27unroll__non__block__indents(self);
  if (_M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self) === 43 || _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) === 45) {
    if (_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) === 43) {
      chomping = 2;
    } else {
      chomping = 0;
    }
    _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
    if (_M0MPC14char4Char16is__ascii__digit(_M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self))) {
      if (_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) === 48) {
        return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(start_mark, "while scanning a block scalar, found an indentation indicator equal to 0"));
      }
      increment = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) - 48 | 0;
      _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
    }
  } else {
    if (_M0MPC14char4Char16is__ascii__digit(_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self))) {
      if (_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) === 48) {
        return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(start_mark, "while scanning a block scalar, found an indentation indicator equal to 0"));
      }
      increment = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) - 48 | 0;
      _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
      _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 1);
      if (_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) === 43 || _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) === 45) {
        if (_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) === 43) {
          chomping = 2;
        } else {
          chomping = 0;
        }
        _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
      }
    }
  }
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer17skip__ws__to__eol(self, _M0DTP219moonbit_2dcommunity4yaml8SkipTabs3Yes__);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  if (!_M0EPC14char4CharP219moonbit_2dcommunity4yaml10is__breakz(_M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self))) {
    return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(start_mark, "while scanning a block scalar, did not find expected comment or line break"));
  }
  const _p$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self);
  if (_p$4 === 10 || _p$4 === 13) {
    _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 2);
    _M0MP219moonbit_2dcommunity4yaml5Lexer11read__break(self, chomping_break);
  }
  if (_M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self) === 9) {
    return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(start_mark, "a block scalar content cannot start with a tab"));
  }
  if (increment > 0) {
    indent.val = self.indent >= 0 ? self.indent + increment | 0 : increment;
  }
  if (indent.val === 0) {
    _M0MP219moonbit_2dcommunity4yaml5Lexer40skip__block__scalar__first__line__indent(self, indent, trailing_breaks);
  } else {
    _M0MP219moonbit_2dcommunity4yaml5Lexer27skip__block__scalar__indent(self, indent.val, trailing_breaks);
  }
  const _p$5 = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self);
  if (_p$5 === 0) {
    const _bind$5 = chomping;
    let contents;
    if (_bind$5 === 0) {
      contents = "";
    } else {
      if (self.line === start_mark.line) {
        contents = "";
      } else {
        if (_bind$5 === 1) {
          contents = chomping_break.val;
        } else {
          contents = trailing_breaks.val === "" ? chomping_break.val : trailing_breaks.val;
        }
      }
    }
    return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(new _M0TP219moonbit_2dcommunity4yaml5Token(start_mark, new _M0DTP219moonbit_2dcommunity4yaml9TokenType6Scalar(style, contents)));
  }
  if (self.col < indent.val && self.col > self.indent) {
    return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), "wrongly indented line in block scalar"));
  }
  const line_buffer = _M0MPB13StringBuilder21StringBuilder_2einner(100);
  const start_mark$2 = _M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self);
  while (true) {
    let _tmp$38;
    if (self.col === indent.val) {
      const _p$6 = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self);
      _tmp$38 = !(_p$6 === 0);
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      if (indent.val === 0) {
        _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 4);
        if (_M0MP219moonbit_2dcommunity4yaml5Lexer23next__is__document__end(self)) {
          break;
        }
      }
      const _p$6 = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self);
      trailing_blank = _p$6 === 32 || _p$6 === 9;
      if (!literal && (!(leading_break.val === "") && (!leading_blank && !trailing_blank))) {
        _M0IPB13StringBuilderPB6Logger13write__string(buf, trailing_breaks.val);
        if (trailing_breaks.val === "") {
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 32);
        }
      } else {
        _M0IPB13StringBuilderPB6Logger13write__string(buf, leading_break.val);
        _M0IPB13StringBuilderPB6Logger13write__string(buf, trailing_breaks.val);
      }
      _M0MPB13StringBuilder5reset(leading_break);
      _M0MPB13StringBuilder5reset(trailing_breaks);
      const _p$7 = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self);
      leading_blank = _p$7 === 32 || _p$7 === 9;
      _M0MP219moonbit_2dcommunity4yaml5Lexer34scan__block__scalar__content__line(self, buf, line_buffer);
      const _p$8 = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self);
      if (_p$8 === 0) {
        break;
      }
      _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 2);
      _M0MP219moonbit_2dcommunity4yaml5Lexer11read__break(self, leading_break);
      _M0MP219moonbit_2dcommunity4yaml5Lexer27skip__block__scalar__indent(self, indent.val, trailing_breaks);
      continue;
    } else {
      break;
    }
  }
  if (_M0IP016_24default__implPB2Eq10not__equalGRP219moonbit_2dcommunity4yaml8ChompingE(chomping, 0)) {
    _M0IPB13StringBuilderPB6Logger13write__string(buf, leading_break.val);
    let _tmp$38;
    const _p$6 = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self);
    if (_p$6 === 0) {
      const _tmp$39 = self.col;
      const _p$7 = indent.val;
      const _p$8 = 1;
      _tmp$38 = _tmp$39 >= (_p$7 > _p$8 ? _p$7 : _p$8);
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      _M0IPB13StringBuilderPB6Logger11write__char(buf, 10);
    }
  }
  if (_M0IP219moonbit_2dcommunity4yaml8ChompingPB2Eq5equal(chomping, 2)) {
    _M0IPB13StringBuilderPB6Logger13write__string(buf, trailing_breaks.val);
  }
  return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(new _M0TP219moonbit_2dcommunity4yaml5Token(start_mark$2, new _M0DTP219moonbit_2dcommunity4yaml9TokenType6Scalar(style, buf.val)));
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer20fetch__block__scalar(self, literal) {
  _M0MP219moonbit_2dcommunity4yaml5Lexer17save__simple__key(self);
  _M0MP219moonbit_2dcommunity4yaml5Lexer18allow__simple__key(self);
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer19scan__block__scalar(self, literal);
  let tok;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    tok = _ok._0;
  } else {
    return _bind$4;
  }
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0MPC15deque5Deque10push__backGRP219moonbit_2dcommunity4yaml5TokenE(self.tokens, tok));
}
function _M0EPC14char4CharP219moonbit_2dcommunity4yaml9is__alpha(self) {
  if (self >= 48 && self <= 57) {
    return true;
  } else {
    if (self >= 97 && self <= 122) {
      return true;
    } else {
      if (self >= 65 && self <= 90) {
        return true;
      } else {
        if (self === 95) {
          return true;
        } else {
          if (self === 45) {
            return true;
          } else {
            return false;
          }
        }
      }
    }
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer21scan__directive__name(self) {
  const start_mark = _M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self);
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  while (true) {
    if (_M0EPC14char4CharP219moonbit_2dcommunity4yaml9is__alpha(_M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self))) {
      _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self));
      _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
      continue;
    } else {
      break;
    }
  }
  if (buf.val === "") {
    return new _M0DTPC16result6ResultGsRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(start_mark, "while scanning a directive, could not find expected directive name"));
  }
  if (!_M0EPC14char4CharP219moonbit_2dcommunity4yaml21is__blank__or__breakz(_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self))) {
    return new _M0DTPC16result6ResultGsRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(start_mark, "while scanning a directive, found unexpected non-alphabetical character"));
  }
  return new _M0DTPC16result6ResultGsRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(buf.val);
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer17scan__tag__handle(self, directive, mark) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  if (_M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self) !== 33) {
    return new _M0DTPC16result6ResultGsRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(mark, "while scanning a tag, did not find expected '!'"));
  }
  _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self));
  _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
  while (true) {
    if (_M0EPC14char4CharP219moonbit_2dcommunity4yaml9is__alpha(_M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self))) {
      _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self));
      _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
      continue;
    } else {
      break;
    }
  }
  if (_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) === 33) {
    _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self));
    _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
  } else {
    let _tmp$38;
    if (directive) {
      const _p$4 = buf.val;
      const _p$5 = "!";
      _tmp$38 = !(_p$4 === _p$5);
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      return new _M0DTPC16result6ResultGsRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(mark, "while parsing a tag directive, did not find expected '!'"));
    }
  }
  return new _M0DTPC16result6ResultGsRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(buf.val);
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer19skip__n__non__blank(self, n) {
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < n) {
      _M0MPC15deque5Deque10pop__frontGcE(self.buffer);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.index = self.index + n | 0;
  self.col = self.col + n | 0;
  self.leading_whitespace = false;
}
function _M0EPC14char4CharP219moonbit_2dcommunity4yaml7as__hex(self) {
  if (self >= 48 && self <= 57) {
    const _p$4 = 48;
    return (self >>> 0) - (_p$4 >>> 0) | 0;
  } else {
    if (self >= 97 && self <= 102) {
      const _p$4 = 97;
      return ((self >>> 0) - (_p$4 >>> 0) | 0) + 10 | 0;
    } else {
      if (self >= 65 && self <= 70) {
        const _p$4 = 65;
        return ((self >>> 0) - (_p$4 >>> 0) | 0) + 10 | 0;
      } else {
        return $panic();
      }
    }
  }
}
function _M0EPC14char4CharP219moonbit_2dcommunity4yaml7is__hex(self) {
  return _M0MPC14char4Char16is__ascii__digit(self) || (self >= 97 && self <= 102 ? true : self >= 65 && self <= 70);
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer18scan__uri__escapes(self, mark) {
  let width = 0;
  let code = 0;
  while (true) {
    _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 3);
    if (!(_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) === 37 && (_M0EPC14char4CharP219moonbit_2dcommunity4yaml7is__hex(_M0MPC15deque5Deque2atGcE(self.buffer, 1)) && _M0EPC14char4CharP219moonbit_2dcommunity4yaml7is__hex(_M0MPC15deque5Deque2atGcE(self.buffer, 2))))) {
      return new _M0DTPC16result6ResultGcRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(mark, "while parsing a tag, did not find URI escaped octet"));
    }
    const octet = (_M0EPC14char4CharP219moonbit_2dcommunity4yaml7as__hex(_M0MPC15deque5Deque2atGcE(self.buffer, 1)) << 4) + _M0EPC14char4CharP219moonbit_2dcommunity4yaml7as__hex(_M0MPC15deque5Deque2atGcE(self.buffer, 2)) | 0;
    if (width === 0) {
      let _tmp$38;
      if ((octet & 128) === 0) {
        _tmp$38 = 1;
      } else {
        if ((octet & 224) === 192) {
          _tmp$38 = 2;
        } else {
          if ((octet & 240) === 224) {
            _tmp$38 = 3;
          } else {
            if ((octet & 248) === 240) {
              _tmp$38 = 4;
            } else {
              return new _M0DTPC16result6ResultGcRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(mark, "while parsing a tag, found an incorrect leading UTF-8 octet"));
            }
          }
        }
      }
      width = _tmp$38;
      code = octet;
    } else {
      if ((octet & 192) !== 128) {
        return new _M0DTPC16result6ResultGcRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(mark, "while parsing a tag, found an incorrect trailing UTF-8 octet"));
      }
      code = (code << 8) + octet | 0;
    }
    _M0MP219moonbit_2dcommunity4yaml5Lexer19skip__n__non__blank(self, 3);
    width = width - 1 | 0;
    if (width === 0) {
      break;
    }
    continue;
  }
  const _bind$4 = _M0MPC13int3Int8to__char(code);
  if (_bind$4 === -1) {
    return new _M0DTPC16result6ResultGcRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(mark, "while parsing a tag, found an invalid UTF-8 codepoint"));
  } else {
    const _Some = _bind$4;
    const _ch = _Some;
    return new _M0DTPC16result6ResultGcRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_ch);
  }
}
function _M0EPC14char4CharP219moonbit_2dcommunity4yaml14is__word__char(self) {
  return _M0EPC14char4CharP219moonbit_2dcommunity4yaml9is__alpha(self) && self !== 95;
}
function _M0EPC14char4CharP219moonbit_2dcommunity4yaml13is__uri__char(self) {
  return _M0EPC14char4CharP219moonbit_2dcommunity4yaml14is__word__char(self) || _M0MPC16string6String14contains__char("#;/?:@&=+$,_.!~*'()[]%", self);
}
function _M0EPC14char4CharP219moonbit_2dcommunity4yaml13is__tag__char(self) {
  return _M0EPC14char4CharP219moonbit_2dcommunity4yaml13is__uri__char(self) && (!_M0EPC14char4CharP219moonbit_2dcommunity4yaml8is__flow(self) && self !== 33);
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer17scan__tag__prefix(self, start_mark) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  if (_M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self) === 33) {
    _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self));
    _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
  } else {
    if (!_M0EPC14char4CharP219moonbit_2dcommunity4yaml13is__tag__char(_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self))) {
      return new _M0DTPC16result6ResultGsRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(start_mark, "invalid global tag character"));
    } else {
      if (_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) === 37) {
        const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer18scan__uri__escapes(self, start_mark);
        let _tmp$38;
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          _tmp$38 = _ok._0;
        } else {
          return _bind$4;
        }
        _M0IPB13StringBuilderPB6Logger11write__char(buf, _tmp$38);
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self));
        _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
      }
    }
  }
  while (true) {
    if (_M0EPC14char4CharP219moonbit_2dcommunity4yaml13is__uri__char(_M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self))) {
      if (_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) === 37) {
        const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer18scan__uri__escapes(self, start_mark);
        let _tmp$38;
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          _tmp$38 = _ok._0;
        } else {
          return _bind$4;
        }
        _M0IPB13StringBuilderPB6Logger11write__char(buf, _tmp$38);
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self));
        _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
      }
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGsRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(buf.val);
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer27scan__tag__directive__value(self, mark) {
  while (true) {
    const _p$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self);
    if (_p$4 === 32 || _p$4 === 9) {
      _M0MP219moonbit_2dcommunity4yaml5Lexer11skip__blank(self);
      continue;
    } else {
      break;
    }
  }
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer17scan__tag__handle(self, true, mark);
  let handle;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    handle = _ok._0;
  } else {
    return _bind$4;
  }
  while (true) {
    const _p$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self);
    if (_p$4 === 32 || _p$4 === 9) {
      _M0MP219moonbit_2dcommunity4yaml5Lexer11skip__blank(self);
      continue;
    } else {
      break;
    }
  }
  const _bind$5 = _M0MP219moonbit_2dcommunity4yaml5Lexer17scan__tag__prefix(self, mark);
  let prefix;
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    prefix = _ok._0;
  } else {
    return _bind$5;
  }
  _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 1);
  if (_M0EPC14char4CharP219moonbit_2dcommunity4yaml21is__blank__or__breakz(_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self))) {
    return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(new _M0TP219moonbit_2dcommunity4yaml5Token(mark, new _M0DTP219moonbit_2dcommunity4yaml9TokenType12TagDirective(handle, prefix)));
  } else {
    return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(mark, "while scanning TAG, did not find expected whitespace or line break"));
  }
}
function _M0EPC14char4CharP219moonbit_2dcommunity4yaml9to__digit(self) {
  return self >= 48 && self <= 57 ? self - 48 | 0 : undefined;
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer32scan__version__directive__number(self, mark) {
  let val = 0;
  let length = 0;
  while (true) {
    const _bind$4 = _M0EPC14char4CharP219moonbit_2dcommunity4yaml9to__digit(_M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self));
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _digit = _Some;
      if ((length + 1 | 0) > 9) {
        return new _M0DTPC16result6ResultGiRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(mark, "while scanning a YAML directive, found extremely long version number"));
      }
      length = length + 1 | 0;
      val = (Math.imul(val, 10) | 0) + _digit | 0;
      _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
      continue;
    }
  }
  if (length === 0) {
    return new _M0DTPC16result6ResultGiRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(mark, "while scanning a YAML directive, did not find expected version number"));
  }
  return new _M0DTPC16result6ResultGiRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(val);
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer31scan__version__directive__value(self, mark) {
  while (true) {
    const _p$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self);
    if (_p$4 === 32 || _p$4 === 9) {
      _M0MP219moonbit_2dcommunity4yaml5Lexer11skip__blank(self);
      continue;
    } else {
      break;
    }
  }
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer32scan__version__directive__number(self, mark);
  let major;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    major = _ok._0;
  } else {
    return _bind$4;
  }
  if (_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) !== 46) {
    return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(mark, "while scanning a YAML directive, did not find expected digit or '.' character"));
  }
  _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
  const _bind$5 = _M0MP219moonbit_2dcommunity4yaml5Lexer32scan__version__directive__number(self, mark);
  let minor;
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    minor = _ok._0;
  } else {
    return _bind$5;
  }
  return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(new _M0TP219moonbit_2dcommunity4yaml5Token(mark, new _M0DTP219moonbit_2dcommunity4yaml9TokenType16VersionDirective(major, minor)));
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer15skip__linebreak(self) {
  let _tmp$38;
  const _p$4 = self.buffer;
  if (_p$4.len > 2) {
    _tmp$38 = _M0MPC15deque5Deque2atGcE(self.buffer, 0) === 13 && _M0MPC15deque5Deque2atGcE(self.buffer, 1) === 10;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    _M0MP219moonbit_2dcommunity4yaml5Lexer11skip__blank(self);
    _M0MP219moonbit_2dcommunity4yaml5Lexer13skip__newline(self);
    return;
  } else {
    let _tmp$39;
    const _p$5 = self.buffer;
    if (_p$5.len > 0) {
      const _p$6 = _M0MPC15deque5Deque2atGcE(self.buffer, 0);
      _tmp$39 = _p$6 === 10 || _p$6 === 13;
    } else {
      _tmp$39 = false;
    }
    if (_tmp$39) {
      _M0MP219moonbit_2dcommunity4yaml5Lexer13skip__newline(self);
      return;
    } else {
      return;
    }
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer15scan__directive(self) {
  const start_mark = _M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self);
  _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer21scan__directive__name(self);
  let name;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    name = _ok._0;
  } else {
    return _bind$4;
  }
  let tok;
  switch (name) {
    case "YAML": {
      const _bind$5 = _M0MP219moonbit_2dcommunity4yaml5Lexer31scan__version__directive__value(self, start_mark);
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        tok = _ok._0;
      } else {
        return _bind$5;
      }
      break;
    }
    case "TAG": {
      const _bind$6 = _M0MP219moonbit_2dcommunity4yaml5Lexer27scan__tag__directive__value(self, start_mark);
      if (_bind$6.$tag === 1) {
        const _ok = _bind$6;
        tok = _ok._0;
      } else {
        return _bind$6;
      }
      break;
    }
    default: {
      while (true) {
        if (_M0EPC14char4CharP219moonbit_2dcommunity4yaml10is__breakz(_M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self))) {
          _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
          continue;
        } else {
          break;
        }
      }
      tok = new _M0TP219moonbit_2dcommunity4yaml5Token(start_mark, _M0MP219moonbit_2dcommunity4yaml5Lexer15scan__directiveN6constrS2085);
    }
  }
  const _bind$7 = _M0MP219moonbit_2dcommunity4yaml5Lexer17skip__ws__to__eol(self, _M0DTP219moonbit_2dcommunity4yaml8SkipTabs3Yes__);
  if (_bind$7.$tag === 1) {
    const _ok = _bind$7;
    _ok._0;
  } else {
    return _bind$7;
  }
  if (_M0EPC14char4CharP219moonbit_2dcommunity4yaml10is__breakz(_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self))) {
    _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 2);
    _M0MP219moonbit_2dcommunity4yaml5Lexer15skip__linebreak(self);
    return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(tok);
  } else {
    return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(start_mark, "while scanning a directive, did not find expected comment or line break"));
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer14unroll__indent(self, col) {
  if (self.flow_level > 0) {
    return undefined;
  }
  while (true) {
    if (self.indent > col) {
      const _p$4 = _M0MPC15array5Array3popGsE(self.indents);
      let indent;
      if (_p$4 === undefined) {
        indent = $panic();
      } else {
        const _p$5 = _p$4;
        indent = _p$5;
      }
      self.indent = indent.indent;
      if (indent.needs_block_end) {
        _M0MPC15deque5Deque10push__backGRP219moonbit_2dcommunity4yaml5TokenE(self.tokens, new _M0TP219moonbit_2dcommunity4yaml5Token(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), _M0DTP219moonbit_2dcommunity4yaml9TokenType8BlockEnd__));
      }
      continue;
    } else {
      return;
    }
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer16fetch__directive(self) {
  _M0MP219moonbit_2dcommunity4yaml5Lexer14unroll__indent(self, -1);
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer19remove__simple__key(self);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  _M0MP219moonbit_2dcommunity4yaml5Lexer21disallow__simple__key(self);
  const _bind$5 = _M0MP219moonbit_2dcommunity4yaml5Lexer15scan__directive(self);
  let tok;
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    tok = _ok._0;
  } else {
    return _bind$5;
  }
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0MPC15deque5Deque10push__backGRP219moonbit_2dcommunity4yaml5TokenE(self.tokens, tok));
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer26fetch__document__indicator(self, t) {
  _M0MP219moonbit_2dcommunity4yaml5Lexer14unroll__indent(self, -1);
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer19remove__simple__key(self);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  _M0MP219moonbit_2dcommunity4yaml5Lexer21disallow__simple__key(self);
  const mark = _M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self);
  _M0MP219moonbit_2dcommunity4yaml5Lexer19skip__n__non__blank(self, 3);
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0MPC15deque5Deque10push__backGRP219moonbit_2dcommunity4yaml5TokenE(self.tokens, new _M0TP219moonbit_2dcommunity4yaml5Token(mark, t)));
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer21decrease__flow__level(self) {
  if (self.flow_level > 0) {
    self.flow_level = self.flow_level - 1 | 0;
    const _p$4 = _M0MPC15array5Array3popGsE(self.simple_keys);
    if (_p$4 === undefined) {
      $panic();
    }
    return;
  } else {
    return;
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer22end__implicit__mapping(self, mark) {
  if (self.implicit_flow_mapping) {
    self.implicit_flow_mapping = false;
    self.flow_mapping_started = false;
    _M0MPC15deque5Deque10push__backGRP219moonbit_2dcommunity4yaml5TokenE(self.tokens, new _M0TP219moonbit_2dcommunity4yaml5Token(mark, _M0DTP219moonbit_2dcommunity4yaml9TokenType14FlowMappingEnd__));
    return;
  } else {
    return;
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer28fetch__flow__collection__end(self, tok) {
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer19remove__simple__key(self);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  _M0MP219moonbit_2dcommunity4yaml5Lexer21decrease__flow__level(self);
  _M0MP219moonbit_2dcommunity4yaml5Lexer21disallow__simple__key(self);
  _M0MP219moonbit_2dcommunity4yaml5Lexer22end__implicit__mapping(self, _M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self));
  const start_mark = _M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self);
  _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
  const _bind$5 = _M0MP219moonbit_2dcommunity4yaml5Lexer17skip__ws__to__eol(self, _M0DTP219moonbit_2dcommunity4yaml8SkipTabs3Yes__);
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    _ok._0;
  } else {
    return _bind$5;
  }
  if (self.flow_level > 0) {
    self.adjacent_value_allowed_at = self.index;
  }
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0MPC15deque5Deque10push__backGRP219moonbit_2dcommunity4yaml5TokenE(self.tokens, new _M0TP219moonbit_2dcommunity4yaml5Token(start_mark, tok)));
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer21increase__flow__level(self) {
  _M0MPC15array5Array4pushGUssEE(self.simple_keys, _M0MP219moonbit_2dcommunity4yaml9SimpleKey3new(_M0MP219moonbit_2dcommunity4yaml5Lexer21increase__flow__levelN6recordS2086));
  let _tmp$38;
  if (self.flow_level < 255) {
    _tmp$38 = self.flow_level + 1 | 0;
  } else {
    return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), "recursion limit exceeded"));
  }
  self.flow_level = _tmp$38;
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(undefined);
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer30fetch__flow__collection__start(self, tok) {
  _M0MP219moonbit_2dcommunity4yaml5Lexer17save__simple__key(self);
  _M0MP219moonbit_2dcommunity4yaml5Lexer22roll__one__col__indent(self);
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer21increase__flow__level(self);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  _M0MP219moonbit_2dcommunity4yaml5Lexer18allow__simple__key(self);
  const start_mark = _M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self);
  _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
  if (_M0IP219moonbit_2dcommunity4yaml9TokenTypePB2Eq5equal(tok, _M0DTP219moonbit_2dcommunity4yaml9TokenType16FlowMappingStart__)) {
    self.flow_mapping_started = true;
  }
  const _bind$5 = _M0MP219moonbit_2dcommunity4yaml5Lexer17skip__ws__to__eol(self, _M0DTP219moonbit_2dcommunity4yaml8SkipTabs3Yes__);
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    _ok._0;
  } else {
    return _bind$5;
  }
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0MPC15deque5Deque10push__backGRP219moonbit_2dcommunity4yaml5TokenE(self.tokens, new _M0TP219moonbit_2dcommunity4yaml5Token(start_mark, tok)));
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer18fetch__flow__entry(self) {
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer19remove__simple__key(self);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  _M0MP219moonbit_2dcommunity4yaml5Lexer18allow__simple__key(self);
  _M0MP219moonbit_2dcommunity4yaml5Lexer22end__implicit__mapping(self, _M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self));
  const start_mark = _M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self);
  _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
  const _bind$5 = _M0MP219moonbit_2dcommunity4yaml5Lexer17skip__ws__to__eol(self, _M0DTP219moonbit_2dcommunity4yaml8SkipTabs3Yes__);
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    _ok._0;
  } else {
    return _bind$5;
  }
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0MPC15deque5Deque10push__backGRP219moonbit_2dcommunity4yaml5TokenE(self.tokens, new _M0TP219moonbit_2dcommunity4yaml5Token(start_mark, _M0DTP219moonbit_2dcommunity4yaml9TokenType9FlowEntry__)));
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer39resolve__flow__scalar__escape__sequence(self, start_mark) {
  let code_length = 0;
  let ret = 0;
  _L: {
    _L$2: {
      const _bind$4 = _M0MPC15deque5Deque2atGcE(self.buffer, 1);
      switch (_bind$4) {
        case 48: {
          ret = 0;
          break;
        }
        case 97: {
          ret = 7;
          break;
        }
        case 98: {
          ret = 8;
          break;
        }
        case 116: {
          break _L$2;
        }
        case 9: {
          break _L$2;
        }
        case 110: {
          ret = 10;
          break;
        }
        case 118: {
          ret = 17;
          break;
        }
        case 102: {
          ret = 18;
          break;
        }
        case 114: {
          ret = 19;
          break;
        }
        case 101: {
          ret = 39;
          break;
        }
        case 32: {
          ret = 50;
          break;
        }
        case 34: {
          ret = 34;
          break;
        }
        case 47: {
          ret = 47;
          break;
        }
        case 92: {
          ret = 92;
          break;
        }
        case 78: {
          ret = 133;
          break;
        }
        case 95: {
          ret = 160;
          break;
        }
        case 76: {
          ret = 8232;
          break;
        }
        case 80: {
          ret = 8233;
          break;
        }
        case 120: {
          code_length = 2;
          break;
        }
        case 117: {
          code_length = 4;
          break;
        }
        case 85: {
          code_length = 8;
          break;
        }
        default: {
          return new _M0DTPC16result6ResultGcRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(start_mark, "while parsing a quoted scalar, found unknown escape character"));
        }
      }
      break _L;
    }
    ret = 9;
  }
  _M0MP219moonbit_2dcommunity4yaml5Lexer19skip__n__non__blank(self, 2);
  if (code_length > 0) {
    _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, code_length);
    let value = 0;
    const _bind$4 = code_length;
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < _bind$4) {
        if (!_M0EPC14char4CharP219moonbit_2dcommunity4yaml7is__hex(_M0MPC15deque5Deque2atGcE(self.buffer, i))) {
          return new _M0DTPC16result6ResultGcRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(start_mark, "while parsing a quoted scalar, did not find expected hexadecimal number"));
        }
        value = (value << 4) + _M0EPC14char4CharP219moonbit_2dcommunity4yaml7as__hex(_M0MPC15deque5Deque2atGcE(self.buffer, i)) | 0;
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    const _bind$5 = _M0MPC13int3Int8to__char(value);
    if (_bind$5 === -1) {
      return new _M0DTPC16result6ResultGcRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(start_mark, "while parsing a quoted scalar, found invalid Unicode character escape code"));
    } else {
      const _Some = _bind$5;
      const _ch = _Some;
      ret = _ch;
      _M0MP219moonbit_2dcommunity4yaml5Lexer19skip__n__non__blank(self, code_length);
    }
  }
  return new _M0DTPC16result6ResultGcRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(ret);
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer45consume__flow__scalar__non__whitespace__chars(self, single, buf, leading_blanks, start_mark) {
  _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 2);
  _L: while (true) {
    if (!_M0EPC14char4CharP219moonbit_2dcommunity4yaml21is__blank__or__breakz(_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self))) {
      let c;
      _L$2: {
        _L$3: {
          const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self);
          switch (_bind$4) {
            case 39: {
              if (_M0MPC15deque5Deque2atGcE(self.buffer, 1) === 39 && single) {
                _M0IPB13StringBuilderPB6Logger11write__char(buf, 39);
                _M0MP219moonbit_2dcommunity4yaml5Lexer19skip__n__non__blank(self, 2);
              } else {
                if (single) {
                  break _L;
                } else {
                  c = _bind$4;
                  break _L$3;
                }
              }
              break;
            }
            case 34: {
              if (!single) {
                break _L;
              } else {
                c = _bind$4;
                break _L$3;
              }
            }
            case 92: {
              let _tmp$38;
              if (!single) {
                const _p$4 = _M0MPC15deque5Deque2atGcE(self.buffer, 1);
                _tmp$38 = _p$4 === 10 || _p$4 === 13;
              } else {
                _tmp$38 = false;
              }
              if (_tmp$38) {
                _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 3);
                _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
                _M0MP219moonbit_2dcommunity4yaml5Lexer15skip__linebreak(self);
                leading_blanks.val = true;
                break _L;
              } else {
                if (!single) {
                  const _bind$5 = _M0MP219moonbit_2dcommunity4yaml5Lexer39resolve__flow__scalar__escape__sequence(self, start_mark);
                  let _tmp$39;
                  if (_bind$5.$tag === 1) {
                    const _ok = _bind$5;
                    _tmp$39 = _ok._0;
                  } else {
                    return _bind$5;
                  }
                  _M0IPB13StringBuilderPB6Logger11write__char(buf, _tmp$39);
                } else {
                  c = _bind$4;
                  break _L$3;
                }
              }
              break;
            }
            default: {
              c = _bind$4;
              break _L$3;
            }
          }
          break _L$2;
        }
        _M0IPB13StringBuilderPB6Logger11write__char(buf, c);
        _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
      }
      _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 2);
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(undefined);
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer18scan__flow__scalar(self, single) {
  const start_mark = _M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self);
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const leading_break = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const trailing_breaks = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const whitespaces = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const leading_blanks = _M0MPC13ref3Ref3RefGbE(false);
  _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
  _L: while (true) {
    _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 4);
    if (self.col === 0 && ((_M0MPC15deque5Deque2atGcE(self.buffer, 0) === 45 && (_M0MPC15deque5Deque2atGcE(self.buffer, 1) === 45 && _M0MPC15deque5Deque2atGcE(self.buffer, 2) === 45) || _M0MPC15deque5Deque2atGcE(self.buffer, 0) === 46 && (_M0MPC15deque5Deque2atGcE(self.buffer, 1) === 46 && _M0MPC15deque5Deque2atGcE(self.buffer, 2) === 46)) && _M0EPC14char4CharP219moonbit_2dcommunity4yaml21is__blank__or__breakz(_M0MPC15deque5Deque2atGcE(self.buffer, 3)))) {
      return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(start_mark, "while scanning a quoted scalar, found unexpected document indicator"));
    }
    const _p$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self);
    if (_p$4 === 0) {
      return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(start_mark, "while scanning a quoted scalar, found unexpected end of stream"));
    }
    if (self.col < self.indent) {
      return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(start_mark, "invalid indentation in quoted scalar"));
    }
    leading_blanks.val = false;
    const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer45consume__flow__scalar__non__whitespace__chars(self, single, buf, leading_blanks, start_mark);
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _ok._0;
    } else {
      return _bind$4;
    }
    const _bind$5 = _M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self);
    switch (_bind$5) {
      case 39: {
        if (single) {
          break _L;
        }
        break;
      }
      case 34: {
        if (!single) {
          break _L;
        }
        break;
      }
    }
    while (true) {
      let _tmp$38;
      const _p$5 = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self);
      if (_p$5 === 32 || _p$5 === 9) {
        _tmp$38 = true;
      } else {
        const _p$6 = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self);
        _tmp$38 = _p$6 === 10 || _p$6 === 13;
      }
      if (_tmp$38) {
        const _p$6 = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self);
        if (_p$6 === 32 || _p$6 === 9) {
          if (leading_blanks.val) {
            if (_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) === 9 && self.col < self.indent) {
              return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), "tab cannot be used as indentation"));
            }
            _M0MP219moonbit_2dcommunity4yaml5Lexer11skip__blank(self);
          } else {
            _M0IPB13StringBuilderPB6Logger11write__char(whitespaces, _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self));
            _M0MP219moonbit_2dcommunity4yaml5Lexer11skip__blank(self);
          }
        } else {
          _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 2);
          if (leading_blanks.val) {
            _M0MP219moonbit_2dcommunity4yaml5Lexer11read__break(self, trailing_breaks);
          } else {
            _M0MPB13StringBuilder5reset(whitespaces);
            _M0MP219moonbit_2dcommunity4yaml5Lexer11read__break(self, leading_break);
            leading_blanks.val = true;
          }
        }
        _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 1);
        continue;
      } else {
        break;
      }
    }
    if (leading_blanks.val) {
      if (leading_break.val === "") {
        _M0IPB13StringBuilderPB6Logger13write__string(buf, leading_break.val);
        _M0IPB13StringBuilderPB6Logger13write__string(buf, trailing_breaks.val);
        _M0MPB13StringBuilder5reset(trailing_breaks);
        _M0MPB13StringBuilder5reset(leading_break);
      } else {
        if (trailing_breaks.val === "") {
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 32);
        } else {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, trailing_breaks.val);
          _M0MPB13StringBuilder5reset(trailing_breaks);
        }
        _M0MPB13StringBuilder5reset(leading_break);
      }
    } else {
      _M0IPB13StringBuilderPB6Logger13write__string(buf, whitespaces.val);
      _M0MPB13StringBuilder5reset(whitespaces);
    }
    continue;
  }
  _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer17skip__ws__to__eol(self, _M0DTP219moonbit_2dcommunity4yaml8SkipTabs3Yes__);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  _L$2: {
    _L$3: {
      let c;
      _L$4: {
        _L$5: {
          const _bind$5 = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self);
          switch (_bind$5) {
            case 44: {
              if (self.flow_level > 0) {
              } else {
                if (_M0EPC14char4CharP219moonbit_2dcommunity4yaml10is__breakz(_bind$5)) {
                  c = _bind$5;
                  break _L$5;
                } else {
                  break _L$3;
                }
              }
              break;
            }
            case 125: {
              if (self.flow_level > 0) {
              } else {
                if (_M0EPC14char4CharP219moonbit_2dcommunity4yaml10is__breakz(_bind$5)) {
                  c = _bind$5;
                  break _L$5;
                } else {
                  break _L$3;
                }
              }
              break;
            }
            case 93: {
              if (self.flow_level > 0) {
              } else {
                if (_M0EPC14char4CharP219moonbit_2dcommunity4yaml10is__breakz(_bind$5)) {
                  c = _bind$5;
                  break _L$5;
                } else {
                  break _L$3;
                }
              }
              break;
            }
            default: {
              if (_M0EPC14char4CharP219moonbit_2dcommunity4yaml10is__breakz(_bind$5)) {
                c = _bind$5;
                break _L$5;
              } else {
                if (_bind$5 === 58) {
                  if (self.flow_level === 0 && start_mark.line === self.line) {
                  } else {
                    if (self.flow_level > 0) {
                    } else {
                      break _L$3;
                    }
                  }
                } else {
                  break _L$3;
                }
              }
            }
          }
          break _L$4;
        }
      }
      break _L$2;
    }
    return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), "invalid trailing content after double-quoted scalar"));
  }
  const style = single ? 1 : 2;
  return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(new _M0TP219moonbit_2dcommunity4yaml5Token(start_mark, new _M0DTP219moonbit_2dcommunity4yaml9TokenType6Scalar(style, buf.val)));
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer17is__within__block(self) {
  const _p$4 = self.indents;
  return !(_p$4.length === 0);
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer21skip__to__next__token(self) {
  _L: while (true) {
    _L$2: {
      _L$3: {
        _L$4: {
          _L$5: {
            const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self);
            switch (_bind$4) {
              case 9: {
                if (_M0MP219moonbit_2dcommunity4yaml5Lexer17is__within__block(self) && (self.leading_whitespace && self.col < self.indent)) {
                  const _bind$5 = _M0MP219moonbit_2dcommunity4yaml5Lexer17skip__ws__to__eol(self, _M0DTP219moonbit_2dcommunity4yaml8SkipTabs3Yes__);
                  if (_bind$5.$tag === 1) {
                    const _ok = _bind$5;
                    _ok._0;
                  } else {
                    return _bind$5;
                  }
                  if (_M0EPC14char4CharP219moonbit_2dcommunity4yaml10is__breakz(_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self))) {
                    return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), "tabs disallowed within this context (block indentation)"));
                  }
                } else {
                  break _L$5;
                }
                break;
              }
              case 32: {
                break _L$5;
              }
              case 10: {
                break _L$3;
              }
              case 13: {
                break _L$3;
              }
              case 35: {
                while (true) {
                  if (!_M0EPC14char4CharP219moonbit_2dcommunity4yaml10is__breakz(_M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self))) {
                    _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
                    continue;
                  } else {
                    break;
                  }
                }
                break;
              }
              default: {
                break _L;
              }
            }
            break _L$4;
          }
          _M0MP219moonbit_2dcommunity4yaml5Lexer11skip__blank(self);
        }
        break _L$2;
      }
      _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 2);
      _M0MP219moonbit_2dcommunity4yaml5Lexer15skip__linebreak(self);
      if (self.flow_level === 0) {
        _M0MP219moonbit_2dcommunity4yaml5Lexer18allow__simple__key(self);
      }
    }
    continue;
  }
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(undefined);
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer19fetch__flow__scalar(self, single) {
  _M0MP219moonbit_2dcommunity4yaml5Lexer17save__simple__key(self);
  _M0MP219moonbit_2dcommunity4yaml5Lexer21disallow__simple__key(self);
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer18scan__flow__scalar(self, single);
  let tok;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    tok = _ok._0;
  } else {
    return _bind$4;
  }
  const _bind$5 = _M0MP219moonbit_2dcommunity4yaml5Lexer21skip__to__next__token(self);
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    _ok._0;
  } else {
    return _bind$5;
  }
  self.adjacent_value_allowed_at = self.index;
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0MPC15deque5Deque10push__backGRP219moonbit_2dcommunity4yaml5TokenE(self.tokens, tok));
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer22skip__yaml__whitespace(self) {
  let need_whitespace = true;
  _L: while (true) {
    _L$2: {
      _L$3: {
        const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self);
        switch (_bind$4) {
          case 32: {
            _M0MP219moonbit_2dcommunity4yaml5Lexer11skip__blank(self);
            need_whitespace = false;
            break;
          }
          case 10: {
            break _L$3;
          }
          case 13: {
            break _L$3;
          }
          case 35: {
            while (true) {
              if (_M0EPC14char4CharP219moonbit_2dcommunity4yaml10is__breakz(_M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self))) {
                _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
                continue;
              } else {
                break;
              }
            }
            break;
          }
          default: {
            break _L;
          }
        }
        break _L$2;
      }
      _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 2);
      _M0MP219moonbit_2dcommunity4yaml5Lexer15skip__linebreak(self);
      if (self.flow_level === 0) {
        _M0MP219moonbit_2dcommunity4yaml5Lexer18allow__simple__key(self);
      }
      need_whitespace = false;
    }
    continue;
  }
  if (need_whitespace) {
    return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), "expected whitespace"));
  } else {
    return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(undefined);
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer10fetch__key(self) {
  const start_mark = _M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self);
  if (self.flow_level === 0) {
    if (!self.simple_key_allowed) {
      return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), "mapping keys are not allowed in this context"));
    }
    _M0MP219moonbit_2dcommunity4yaml5Lexer12roll__indent(self, start_mark.col, undefined, _M0DTP219moonbit_2dcommunity4yaml9TokenType17BlockMappingStart__, start_mark);
  } else {
    self.flow_mapping_started = true;
  }
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer19remove__simple__key(self);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  if (self.flow_level === 0) {
    _M0MP219moonbit_2dcommunity4yaml5Lexer18allow__simple__key(self);
  } else {
    _M0MP219moonbit_2dcommunity4yaml5Lexer21disallow__simple__key(self);
  }
  _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
  const _bind$5 = _M0MP219moonbit_2dcommunity4yaml5Lexer22skip__yaml__whitespace(self);
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    _ok._0;
  } else {
    return _bind$5;
  }
  if (_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) === 9) {
    return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), "tabs disallowed in this context"));
  }
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0MPC15deque5Deque10push__backGRP219moonbit_2dcommunity4yaml5TokenE(self.tokens, new _M0TP219moonbit_2dcommunity4yaml5Token(start_mark, _M0DTP219moonbit_2dcommunity4yaml9TokenType3Key__)));
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer28next__can__be__plain__scalar(self) {
  let c;
  _L: {
    const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self);
    if (_bind$4 === 58) {
      if (_M0EPC14char4CharP219moonbit_2dcommunity4yaml21is__blank__or__breakz(_M0MPC15deque5Deque2atGcE(self.buffer, 1)) || self.flow_level > 0 && _M0EPC14char4CharP219moonbit_2dcommunity4yaml8is__flow(_M0MPC15deque5Deque2atGcE(self.buffer, 1))) {
        return false;
      } else {
        if (self.flow_level > 0 && _M0EPC14char4CharP219moonbit_2dcommunity4yaml8is__flow(_bind$4)) {
          c = _bind$4;
          break _L;
        } else {
          return true;
        }
      }
    } else {
      if (self.flow_level > 0 && _M0EPC14char4CharP219moonbit_2dcommunity4yaml8is__flow(_bind$4)) {
        c = _bind$4;
        break _L;
      } else {
        return true;
      }
    }
  }
  return false;
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer29next__is__document__indicator(self) {
  const _p$4 = self.buffer;
  if (_p$4.len >= 4) {
    return self.col === 0 && ((_M0MPC15deque5Deque2atGcE(self.buffer, 0) === 45 && (_M0MPC15deque5Deque2atGcE(self.buffer, 1) === 45 && _M0MPC15deque5Deque2atGcE(self.buffer, 2) === 45) || _M0MPC15deque5Deque2atGcE(self.buffer, 0) === 46 && (_M0MPC15deque5Deque2atGcE(self.buffer, 1) === 46 && _M0MPC15deque5Deque2atGcE(self.buffer, 2) === 46)) && _M0EPC14char4CharP219moonbit_2dcommunity4yaml21is__blank__or__breakz(_M0MPC15deque5Deque2atGcE(self.buffer, 3)));
  } else {
    return $panic();
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer19scan__plain__scalar(self) {
  _M0MP219moonbit_2dcommunity4yaml5Lexer27unroll__non__block__indents(self);
  const indent = self.indent + 1 | 0;
  const start_mark = _M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self);
  if (self.flow_level > 0 && self.col < indent) {
    return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(start_mark, "invalid indentation in flow construct"));
  }
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(32);
  const leading_break = _M0MPB13StringBuilder21StringBuilder_2einner(32);
  const trailing_breaks = _M0MPB13StringBuilder21StringBuilder_2einner(32);
  const whitespaces = _M0MPB13StringBuilder21StringBuilder_2einner(32);
  while (true) {
    _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 4);
    if (_M0MP219moonbit_2dcommunity4yaml5Lexer29next__is__document__indicator(self) || _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) === 35) {
      break;
    }
    if (self.flow_level > 0 && (_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) === 45 && _M0EPC14char4CharP219moonbit_2dcommunity4yaml8is__flow(_M0MPC15deque5Deque2atGcE(self.buffer, 1)))) {
      return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), "plain scalar cannot start with '-' followed by ,[]{}"));
    }
    if (!_M0EPC14char4CharP219moonbit_2dcommunity4yaml21is__blank__or__breakz(_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self)) && _M0MP219moonbit_2dcommunity4yaml5Lexer28next__can__be__plain__scalar(self)) {
      if (self.leading_whitespace) {
        if (leading_break.val === "") {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, leading_break.val);
          _M0IPB13StringBuilderPB6Logger13write__string(buf, trailing_breaks.val);
          _M0MPB13StringBuilder5reset(trailing_breaks);
          _M0MPB13StringBuilder5reset(leading_break);
        } else {
          if (trailing_breaks.val === "") {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 32);
          } else {
            _M0IPB13StringBuilderPB6Logger13write__string(buf, trailing_breaks.val);
            _M0MPB13StringBuilder5reset(trailing_breaks);
          }
          _M0MPB13StringBuilder5reset(leading_break);
        }
        self.leading_whitespace = false;
      } else {
        if (!(whitespaces.val === "")) {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, whitespaces.val);
          _M0MPB13StringBuilder5reset(whitespaces);
        }
      }
      _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self));
      _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
      _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 2);
      while (true) {
        if (!_M0EPC14char4CharP219moonbit_2dcommunity4yaml21is__blank__or__breakz(_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self))) {
          if (!_M0MP219moonbit_2dcommunity4yaml5Lexer28next__can__be__plain__scalar(self)) {
            break;
          }
          _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self));
          _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
          _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 2);
          continue;
        } else {
          break;
        }
      }
    }
    let _tmp$38;
    const _p$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self);
    if (_p$4 === 32 || _p$4 === 9) {
      _tmp$38 = true;
    } else {
      const _p$5 = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self);
      _tmp$38 = _p$5 === 10 || _p$5 === 13;
    }
    if (!_tmp$38) {
      break;
    }
    while (true) {
      let _tmp$39;
      const _p$5 = _M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self);
      if (_p$5 === 32 || _p$5 === 9) {
        _tmp$39 = true;
      } else {
        const _p$6 = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self);
        _tmp$39 = _p$6 === 10 || _p$6 === 13;
      }
      if (_tmp$39) {
        const _p$6 = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self);
        if (_p$6 === 32 || _p$6 === 9) {
          if (!self.leading_whitespace) {
            _M0IPB13StringBuilderPB6Logger11write__char(whitespaces, _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self));
            _M0MP219moonbit_2dcommunity4yaml5Lexer11skip__blank(self);
          } else {
            if (self.col < indent && _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) === 9) {
              const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer17skip__ws__to__eol(self, _M0DTP219moonbit_2dcommunity4yaml8SkipTabs3Yes__);
              if (_bind$4.$tag === 1) {
                const _ok = _bind$4;
                _ok._0;
              } else {
                return _bind$4;
              }
              if (!_M0EPC14char4CharP219moonbit_2dcommunity4yaml10is__breakz(_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self))) {
                return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(start_mark, "while scanning a plain scalar, found a tab"));
              }
            } else {
              _M0MP219moonbit_2dcommunity4yaml5Lexer11skip__blank(self);
            }
          }
        } else {
          _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 2);
          if (self.leading_whitespace) {
            _M0MP219moonbit_2dcommunity4yaml5Lexer11read__break(self, trailing_breaks);
          } else {
            _M0MPB13StringBuilder5reset(whitespaces);
            _M0MP219moonbit_2dcommunity4yaml5Lexer11read__break(self, leading_break);
            self.leading_whitespace = true;
          }
        }
        continue;
      } else {
        break;
      }
    }
    if (self.flow_level === 0 && self.col < indent) {
      break;
    }
    continue;
  }
  if (self.leading_whitespace) {
    _M0MP219moonbit_2dcommunity4yaml5Lexer18allow__simple__key(self);
  }
  return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(new _M0TP219moonbit_2dcommunity4yaml5Token(start_mark, new _M0DTP219moonbit_2dcommunity4yaml9TokenType6Scalar(0, buf.val)));
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer20fetch__plain__scalar(self) {
  _M0MP219moonbit_2dcommunity4yaml5Lexer17save__simple__key(self);
  _M0MP219moonbit_2dcommunity4yaml5Lexer21disallow__simple__key(self);
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer19scan__plain__scalar(self);
  let tok;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    tok = _ok._0;
  } else {
    return _bind$4;
  }
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0MPC15deque5Deque10push__backGRP219moonbit_2dcommunity4yaml5TokenE(self.tokens, tok));
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer18fetch__stream__end(self) {
  if (self.col !== 0) {
    self.col = 0;
    self.line = self.line + 1 | 0;
  }
  const _bind$4 = self.simple_keys;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const sk = _bind$4[_];
      if (sk.required && sk.possible) {
        return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), "simple key expected"));
      }
      sk.possible = false;
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MP219moonbit_2dcommunity4yaml5Lexer14unroll__indent(self, -1);
  const _bind$6 = _M0MP219moonbit_2dcommunity4yaml5Lexer19remove__simple__key(self);
  if (_bind$6.$tag === 1) {
    const _ok = _bind$6;
    _ok._0;
  } else {
    return _bind$6;
  }
  _M0MP219moonbit_2dcommunity4yaml5Lexer21disallow__simple__key(self);
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0MPC15deque5Deque10push__backGRP219moonbit_2dcommunity4yaml5TokenE(self.tokens, new _M0TP219moonbit_2dcommunity4yaml5Token(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), _M0DTP219moonbit_2dcommunity4yaml9TokenType9StreamEnd__)));
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer20fetch__stream__start(self) {
  const mark = _M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self);
  self.indent = -1;
  self.stream_start_produced = true;
  _M0MP219moonbit_2dcommunity4yaml5Lexer18allow__simple__key(self);
  _M0MPC15deque5Deque10push__backGRP219moonbit_2dcommunity4yaml5TokenE(self.tokens, new _M0TP219moonbit_2dcommunity4yaml5Token(mark, _M0DTP219moonbit_2dcommunity4yaml9TokenType11StreamStart__));
  _M0MPC15array5Array4pushGUssEE(self.simple_keys, _M0MP219moonbit_2dcommunity4yaml9SimpleKey3new(_M0MP219moonbit_2dcommunity4yaml5Lexer20fetch__stream__startN6recordS2087));
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer28scan__tag__shorthand__suffix(self, _directive, _is_secondary, head, mark) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  if (_M0MPC16string6String24char__length__ge_2einner(head, 1, 0, head.length)) {
    const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(head, 1, 0, head.length);
    let _tmp$38;
    if (_bind$4 === undefined) {
      _tmp$38 = head.length;
    } else {
      const _Some = _bind$4;
      _tmp$38 = _Some;
    }
    const _x = new _M0TPC16string10StringView(head, _tmp$38, head.length);
    _M0MPB13StringBuilder17write__stringview(buf, _x);
  }
  let length = head.length;
  while (true) {
    if (_M0EPC14char4CharP219moonbit_2dcommunity4yaml13is__tag__char(_M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self))) {
      if (_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) === 37) {
        const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer18scan__uri__escapes(self, mark);
        let _tmp$38;
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          _tmp$38 = _ok._0;
        } else {
          return _bind$4;
        }
        _M0IPB13StringBuilderPB6Logger11write__char(buf, _tmp$38);
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self));
        _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
      }
      length = length + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (length === 0) {
    return new _M0DTPC16result6ResultGsRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(mark, "while parsing a tag, did not find expected tag URI"));
  }
  return new _M0DTPC16result6ResultGsRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(buf.val);
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer19scan__verbatim__tag(self, start_mark) {
  _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
  _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  while (true) {
    if (_M0EPC14char4CharP219moonbit_2dcommunity4yaml13is__uri__char(_M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self))) {
      if (_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) === 37) {
        const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer18scan__uri__escapes(self, start_mark);
        let _tmp$38;
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          _tmp$38 = _ok._0;
        } else {
          return _bind$4;
        }
        _M0IPB13StringBuilderPB6Logger11write__char(buf, _tmp$38);
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self));
      }
      continue;
    } else {
      break;
    }
  }
  if (_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) !== 62) {
    return new _M0DTPC16result6ResultGsRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(start_mark, "while scanning a verbatim tag, did not find the expected '>'"));
  }
  _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
  return new _M0DTPC16result6ResultGsRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(buf.val);
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer9scan__tag(self) {
  const start_mark = _M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self);
  let handle = "";
  let suffix = "";
  _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 2);
  if (_M0MPC15deque5Deque2atGcE(self.buffer, 1) === 60) {
    const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer19scan__verbatim__tag(self, start_mark);
    let _tmp$38;
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _tmp$38 = _ok._0;
    } else {
      return _bind$4;
    }
    suffix = _tmp$38;
  } else {
    const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer17scan__tag__handle(self, false, start_mark);
    let _tmp$38;
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _tmp$38 = _ok._0;
    } else {
      return _bind$4;
    }
    handle = _tmp$38;
    if (handle.length >= 2 && (_M0MPC16string6String11has__prefix(handle, new _M0TPC16string10StringView(_M0MP219moonbit_2dcommunity4yaml5Lexer9scan__tagN7_2abindS1383, 0, _M0MP219moonbit_2dcommunity4yaml5Lexer9scan__tagN7_2abindS1383.length)) && _M0MPC16string6String11has__suffix(handle, new _M0TPC16string10StringView(_M0MP219moonbit_2dcommunity4yaml5Lexer9scan__tagN7_2abindS1384, 0, _M0MP219moonbit_2dcommunity4yaml5Lexer9scan__tagN7_2abindS1384.length)))) {
      const is_secondary_handle = handle === "!!";
      const _bind$5 = _M0MP219moonbit_2dcommunity4yaml5Lexer28scan__tag__shorthand__suffix(self, false, is_secondary_handle, "", start_mark);
      let _tmp$39;
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        _tmp$39 = _ok._0;
      } else {
        return _bind$5;
      }
      suffix = _tmp$39;
    } else {
      const _bind$5 = _M0MP219moonbit_2dcommunity4yaml5Lexer28scan__tag__shorthand__suffix(self, false, false, handle, start_mark);
      let _tmp$39;
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        _tmp$39 = _ok._0;
      } else {
        return _bind$5;
      }
      suffix = _tmp$39;
      handle = "!";
      const _p$4 = suffix;
      if (_p$4 === "") {
        handle = "";
        suffix = "!";
      }
    }
  }
  if (_M0EPC14char4CharP219moonbit_2dcommunity4yaml21is__blank__or__breakz(_M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self)) || self.flow_level > 0 && _M0EPC14char4CharP219moonbit_2dcommunity4yaml8is__flow(_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self))) {
    return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(new _M0TP219moonbit_2dcommunity4yaml5Token(start_mark, new _M0DTP219moonbit_2dcommunity4yaml9TokenType3Tag(handle, suffix)));
  } else {
    return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(start_mark, "while scanning a tag, did not find expected whitespace or line break"));
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer10fetch__tag(self) {
  _M0MP219moonbit_2dcommunity4yaml5Lexer17save__simple__key(self);
  _M0MP219moonbit_2dcommunity4yaml5Lexer21disallow__simple__key(self);
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer9scan__tag(self);
  let tok;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    tok = _ok._0;
  } else {
    return _bind$4;
  }
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0MPC15deque5Deque10push__backGRP219moonbit_2dcommunity4yaml5TokenE(self.tokens, tok));
}
function _M0MP219moonbit_2dcommunity4yaml9SimpleKey5clone(self) {
  return new _M0TP219moonbit_2dcommunity4yaml9SimpleKey(self.possible, self.required, self.token_number, self.mark);
}
function _M0MP219moonbit_2dcommunity4yaml8SkipTabs20has__valid__yaml__ws(self) {
  if (self.$tag === 2) {
    const _Result = self;
    const _x = _Result._1;
    if (_x === true) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer12fetch__value(self) {
  const _p$4 = _M0MPC15array5Array4lastGURP219moonbit_2dcommunity4yaml4YamliEE(self.simple_keys);
  let _tmp$38;
  if (_p$4 === undefined) {
    _tmp$38 = $panic();
  } else {
    const _p$5 = _p$4;
    _tmp$38 = _p$5;
  }
  const sk = _M0MP219moonbit_2dcommunity4yaml9SimpleKey5clone(_tmp$38);
  const start_mark = _M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self);
  self.implicit_flow_mapping = self.flow_level > 0 && !self.flow_mapping_started;
  _M0MP219moonbit_2dcommunity4yaml5Lexer16skip__non__blank(self);
  let _tmp$39;
  if (_M0MP219moonbit_2dcommunity4yaml5Lexer10look__char(self) === 9) {
    let _tmp$40;
    const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer17skip__ws__to__eol(self, _M0DTP219moonbit_2dcommunity4yaml8SkipTabs3Yes__);
    let _tmp$41;
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _tmp$41 = _ok._0;
    } else {
      return _bind$4;
    }
    if (!_M0MP219moonbit_2dcommunity4yaml8SkipTabs20has__valid__yaml__ws(_tmp$41)) {
      _tmp$40 = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self) === 45 || _M0EPC14char4CharP219moonbit_2dcommunity4yaml9is__alpha(_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self));
    } else {
      _tmp$40 = false;
    }
    _tmp$39 = _tmp$40;
  } else {
    _tmp$39 = false;
  }
  if (_tmp$39) {
    return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), "':' must be followed by a valid YAML whitespace"));
  }
  if (sk.possible) {
    const tok = new _M0TP219moonbit_2dcommunity4yaml5Token(sk.mark, _M0DTP219moonbit_2dcommunity4yaml9TokenType3Key__);
    _M0MP219moonbit_2dcommunity4yaml5Lexer13insert__token(self, sk.token_number - self.tokens_parsed | 0, tok);
    if (self.implicit_flow_mapping) {
      if (sk.mark.line < start_mark.line) {
        return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(start_mark, "illegal placement of ':' indicator"));
      }
      _M0MP219moonbit_2dcommunity4yaml5Lexer13insert__token(self, sk.token_number - self.tokens_parsed | 0, new _M0TP219moonbit_2dcommunity4yaml5Token(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), _M0DTP219moonbit_2dcommunity4yaml9TokenType16FlowMappingStart__));
    }
    _M0MP219moonbit_2dcommunity4yaml5Lexer12roll__indent(self, sk.mark.col, sk.token_number, _M0DTP219moonbit_2dcommunity4yaml9TokenType17BlockMappingStart__, start_mark);
    _M0MP219moonbit_2dcommunity4yaml5Lexer22roll__one__col__indent(self);
    const _p$5 = _M0MPC15array5Array4lastGURP219moonbit_2dcommunity4yaml4YamliEE(self.simple_keys);
    let _tmp$40;
    if (_p$5 === undefined) {
      _tmp$40 = $panic();
    } else {
      const _p$6 = _p$5;
      _tmp$40 = _p$6;
    }
    _tmp$40.possible = false;
    _M0MP219moonbit_2dcommunity4yaml5Lexer21disallow__simple__key(self);
  } else {
    if (self.implicit_flow_mapping) {
      _M0MPC15deque5Deque10push__backGRP219moonbit_2dcommunity4yaml5TokenE(self.tokens, new _M0TP219moonbit_2dcommunity4yaml5Token(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), _M0DTP219moonbit_2dcommunity4yaml9TokenType16FlowMappingStart__));
    }
    if (self.flow_level === 0) {
      if (!self.simple_key_allowed) {
        return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(start_mark, "mapping values are not allowed in this context"));
      }
      _M0MP219moonbit_2dcommunity4yaml5Lexer12roll__indent(self, start_mark.col, undefined, _M0DTP219moonbit_2dcommunity4yaml9TokenType17BlockMappingStart__, start_mark);
    }
    _M0MP219moonbit_2dcommunity4yaml5Lexer22roll__one__col__indent(self);
    if (self.flow_level === 0) {
      _M0MP219moonbit_2dcommunity4yaml5Lexer18allow__simple__key(self);
    } else {
      _M0MP219moonbit_2dcommunity4yaml5Lexer21disallow__simple__key(self);
    }
  }
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0MPC15deque5Deque10push__backGRP219moonbit_2dcommunity4yaml5TokenE(self.tokens, new _M0TP219moonbit_2dcommunity4yaml5Token(start_mark, _M0DTP219moonbit_2dcommunity4yaml9TokenType5Value__)));
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer19stale__simple__keys(self) {
  const _bind$4 = self.simple_keys;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const sk = _bind$4[_];
      if (sk.possible && (self.flow_level === 0 && (sk.mark.line < self.line || (sk.mark.index + 1024 | 0) < self.index))) {
        if (sk.required) {
          return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), "simple key expect ':'"));
        }
        sk.possible = false;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(undefined);
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer18fetch__next__token(self) {
  _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 1);
  if (!self.stream_start_produced) {
    _M0MP219moonbit_2dcommunity4yaml5Lexer20fetch__stream__start(self);
    return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(undefined);
  }
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer21skip__to__next__token(self);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  const _bind$5 = _M0MP219moonbit_2dcommunity4yaml5Lexer19stale__simple__keys(self);
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    _ok._0;
  } else {
    return _bind$5;
  }
  const mark = _M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self);
  _M0MP219moonbit_2dcommunity4yaml5Lexer14unroll__indent(self, mark.col);
  _M0MP219moonbit_2dcommunity4yaml5Lexer9lookahead(self, 4);
  const _p$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer4char(self);
  if (_p$4 === 0) {
    const _bind$6 = _M0MP219moonbit_2dcommunity4yaml5Lexer18fetch__stream__end(self);
    if (_bind$6.$tag === 1) {
      const _ok = _bind$6;
      _ok._0;
    } else {
      return _bind$6;
    }
    return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(undefined);
  }
  if (self.col === 0 && _M0MP219moonbit_2dcommunity4yaml5Lexer8char__is(self, 37)) {
    const _bind$6 = _M0MP219moonbit_2dcommunity4yaml5Lexer16fetch__directive(self);
    if (_bind$6.$tag === 1) {
      const _ok = _bind$6;
      _ok._0;
    } else {
      return _bind$6;
    }
    return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(undefined);
  }
  if (self.col === 0 && (_M0MPC15deque5Deque2atGcE(self.buffer, 0) === 45 && (_M0MPC15deque5Deque2atGcE(self.buffer, 1) === 45 && (_M0MPC15deque5Deque2atGcE(self.buffer, 2) === 45 && _M0EPC14char4CharP219moonbit_2dcommunity4yaml21is__blank__or__breakz(_M0MPC15deque5Deque2atGcE(self.buffer, 3)))))) {
    const _bind$6 = _M0MP219moonbit_2dcommunity4yaml5Lexer26fetch__document__indicator(self, _M0DTP219moonbit_2dcommunity4yaml9TokenType13DocumentStart__);
    if (_bind$6.$tag === 1) {
      const _ok = _bind$6;
      _ok._0;
    } else {
      return _bind$6;
    }
    return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(undefined);
  }
  if (self.col === 0 && (_M0MPC15deque5Deque2atGcE(self.buffer, 0) === 46 && (_M0MPC15deque5Deque2atGcE(self.buffer, 1) === 46 && (_M0MPC15deque5Deque2atGcE(self.buffer, 2) === 46 && _M0EPC14char4CharP219moonbit_2dcommunity4yaml21is__blank__or__breakz(_M0MPC15deque5Deque2atGcE(self.buffer, 3)))))) {
    const _bind$6 = _M0MP219moonbit_2dcommunity4yaml5Lexer26fetch__document__indicator(self, _M0DTP219moonbit_2dcommunity4yaml9TokenType11DocumentEnd__);
    if (_bind$6.$tag === 1) {
      const _ok = _bind$6;
      _ok._0;
    } else {
      return _bind$6;
    }
    const _bind$7 = _M0MP219moonbit_2dcommunity4yaml5Lexer17skip__ws__to__eol(self, _M0DTP219moonbit_2dcommunity4yaml8SkipTabs3Yes__);
    if (_bind$7.$tag === 1) {
      const _ok = _bind$7;
      _ok._0;
    } else {
      return _bind$7;
    }
    if (!_M0EPC14char4CharP219moonbit_2dcommunity4yaml10is__breakz(_M0MP219moonbit_2dcommunity4yaml5Lexer4char(self))) {
      return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), "invalid content after document end marker"));
    }
    return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(undefined);
  }
  if (self.col < self.indent) {
    return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), "invalid indentation"));
  }
  const c = _M0MPC15deque5Deque2atGcE(self.buffer, 0);
  const nc = _M0MPC15deque5Deque2atGcE(self.buffer, 1);
  _L: {
    _L$2: {
      _L$3: {
        switch (c) {
          case 91: {
            return _M0MP219moonbit_2dcommunity4yaml5Lexer30fetch__flow__collection__start(self, _M0DTP219moonbit_2dcommunity4yaml9TokenType17FlowSequenceStart__);
          }
          case 123: {
            return _M0MP219moonbit_2dcommunity4yaml5Lexer30fetch__flow__collection__start(self, _M0DTP219moonbit_2dcommunity4yaml9TokenType16FlowMappingStart__);
          }
          case 93: {
            return _M0MP219moonbit_2dcommunity4yaml5Lexer28fetch__flow__collection__end(self, _M0DTP219moonbit_2dcommunity4yaml9TokenType15FlowSequenceEnd__);
          }
          case 125: {
            return _M0MP219moonbit_2dcommunity4yaml5Lexer28fetch__flow__collection__end(self, _M0DTP219moonbit_2dcommunity4yaml9TokenType14FlowMappingEnd__);
          }
          case 44: {
            return _M0MP219moonbit_2dcommunity4yaml5Lexer18fetch__flow__entry(self);
          }
          case 45: {
            if (_M0EPC14char4CharP219moonbit_2dcommunity4yaml21is__blank__or__breakz(nc)) {
              return _M0MP219moonbit_2dcommunity4yaml5Lexer19fetch__block__entry(self);
            } else {
              if (_M0EPC14char4CharP219moonbit_2dcommunity4yaml21is__blank__or__breakz(nc)) {
                return _M0MP219moonbit_2dcommunity4yaml5Lexer20fetch__plain__scalar(self);
              } else {
                break _L;
              }
            }
          }
          case 63: {
            if (_M0EPC14char4CharP219moonbit_2dcommunity4yaml21is__blank__or__breakz(nc)) {
              return _M0MP219moonbit_2dcommunity4yaml5Lexer10fetch__key(self);
            } else {
              if (_M0EPC14char4CharP219moonbit_2dcommunity4yaml21is__blank__or__breakz(nc) && self.flow_level === 0) {
                break _L$3;
              } else {
                break _L;
              }
            }
          }
          case 58: {
            if (_M0EPC14char4CharP219moonbit_2dcommunity4yaml21is__blank__or__breakz(nc) || self.flow_level > 0 && (_M0EPC14char4CharP219moonbit_2dcommunity4yaml8is__flow(nc) || self.index === self.adjacent_value_allowed_at)) {
              return _M0MP219moonbit_2dcommunity4yaml5Lexer12fetch__value(self);
            } else {
              if (_M0EPC14char4CharP219moonbit_2dcommunity4yaml21is__blank__or__breakz(nc) && self.flow_level === 0) {
                break _L$3;
              } else {
                break _L;
              }
            }
          }
          case 42: {
            return _M0MP219moonbit_2dcommunity4yaml5Lexer13fetch__anchor(self, true);
          }
          case 38: {
            return _M0MP219moonbit_2dcommunity4yaml5Lexer13fetch__anchor(self, false);
          }
          case 33: {
            return _M0MP219moonbit_2dcommunity4yaml5Lexer10fetch__tag(self);
          }
          case 124: {
            if (self.flow_level === 0) {
              return _M0MP219moonbit_2dcommunity4yaml5Lexer20fetch__block__scalar(self, true);
            } else {
              break _L;
            }
          }
          case 62: {
            if (self.flow_level === 0) {
              return _M0MP219moonbit_2dcommunity4yaml5Lexer20fetch__block__scalar(self, false);
            } else {
              break _L;
            }
          }
          case 39: {
            return _M0MP219moonbit_2dcommunity4yaml5Lexer19fetch__flow__scalar(self, true);
          }
          case 34: {
            return _M0MP219moonbit_2dcommunity4yaml5Lexer19fetch__flow__scalar(self, false);
          }
          case 37: {
            break _L$2;
          }
          case 64: {
            break _L$2;
          }
          case 96: {
            break _L$2;
          }
          default: {
            break _L;
          }
        }
      }
      return _M0MP219moonbit_2dcommunity4yaml5Lexer20fetch__plain__scalar(self);
    }
    return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), `unexpected character: ${_M0IPC14char4CharPB4Show10to__string(c)}`));
  }
  return _M0MP219moonbit_2dcommunity4yaml5Lexer20fetch__plain__scalar(self);
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer19fetch__more__tokens(self) {
  let need_more = false;
  while (true) {
    const _p$4 = self.tokens;
    if (_p$4.len === 0) {
      need_more = true;
    } else {
      need_more = false;
      const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer19stale__simple__keys(self);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        _ok._0;
      } else {
        return _bind$4;
      }
      const _bind$5 = self.simple_keys;
      const _bind$6 = _bind$5.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$6) {
          const sk = _bind$5[_];
          if (sk.possible && sk.token_number === self.tokens_parsed) {
            need_more = true;
            break;
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
    }
    if (!need_more) {
      break;
    }
    const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer18fetch__next__token(self);
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _ok._0;
    } else {
      return _bind$4;
    }
    continue;
  }
  self.token_available = true;
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(undefined);
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer11next__token(self) {
  if (self.stream_end_produced) {
    return new _M0DTPC16result6ResultGORP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(undefined);
  }
  if (!self.token_available) {
    const _bind$4 = _M0MP219moonbit_2dcommunity4yaml5Lexer19fetch__more__tokens(self);
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _ok._0;
    } else {
      return _bind$4;
    }
  }
  const _bind$4 = _M0MPC15deque5Deque10pop__frontGRP219moonbit_2dcommunity4yaml5TokenE(self.tokens);
  if (_bind$4 === undefined) {
    return new _M0DTPC16result6ResultGORP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self), "did not find expected next token"));
  } else {
    const _Some = _bind$4;
    const _t = _Some;
    self.token_available = false;
    self.tokens_parsed = self.tokens_parsed + 1 | 0;
    if (_M0IP219moonbit_2dcommunity4yaml9TokenTypePB2Eq5equal(_t.token_type, _M0DTP219moonbit_2dcommunity4yaml9TokenType9StreamEnd__)) {
      self.stream_end_produced = true;
    }
    return new _M0DTPC16result6ResultGORP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_t);
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer4next(self) {
  const _bind$4 = self.error;
  if (_bind$4 === undefined) {
  } else {
    return undefined;
  }
  let _try_err;
  _L: {
    const _bind$5 = _M0MP219moonbit_2dcommunity4yaml5Lexer11next__token(self);
    if (_bind$5.$tag === 1) {
      const _ok = _bind$5;
      return _ok._0;
    } else {
      const _err = _bind$5;
      _try_err = _err._0;
      break _L;
    }
  }
  const _YamlError = _try_err;
  self.error = _YamlError;
  return undefined;
}
function _M0MP219moonbit_2dcommunity4yaml6Parser17scan__next__token(self) {
  const token = _M0MP219moonbit_2dcommunity4yaml5Lexer4next(self.lexer);
  if (token === undefined) {
    const _p$4 = self.lexer;
    const _bind$4 = _p$4.error;
    if (_bind$4 === undefined) {
      return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self.lexer), "unexpected eof"));
    } else {
      const _Some = _bind$4;
      const _e = _Some;
      return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(_e);
    }
  } else {
    const _Some = token;
    const _tok = _Some;
    return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_tok);
  }
}
function _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self) {
  const _bind$4 = self.token;
  if (_bind$4 === undefined) {
    const _bind$5 = _M0MP219moonbit_2dcommunity4yaml6Parser17scan__next__token(self);
    let token;
    if (_bind$5.$tag === 1) {
      const _ok = _bind$5;
      token = _ok._0;
    } else {
      return _bind$5;
    }
    self.token = token;
    return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(token);
  } else {
    const _Some = _bind$4;
    const _tok = _Some;
    return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml5TokenRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_tok);
  }
}
function _M0MP219moonbit_2dcommunity4yaml6Parser10pop__state(self) {
  const _p$4 = _M0MPC15array5Array3popGRP219moonbit_2dcommunity4yaml5StateE(self.states);
  let _tmp$38;
  if (_p$4 === undefined) {
    _tmp$38 = $panic();
  } else {
    const _p$5 = _p$4;
    _tmp$38 = _p$5;
  }
  self.state = _tmp$38;
}
function _M0MP219moonbit_2dcommunity4yaml6Parser16register__anchor(self, name, _discard_) {
  const new_id = self.anchor_id;
  self.anchor_id = self.anchor_id + 1 | 0;
  _M0MPC17hashmap7HashMap3setGsiE(self.anchors, name, new_id);
  return new_id;
}
function _M0MP219moonbit_2dcommunity4yaml6Parser12resolve__tag(self, mark, handle, suffix) {
  if (handle === "!!") {
    const _bind$4 = _M0MPC17hashmap7HashMap3getGssE(self.tags, "!!");
    if (_bind$4 === undefined) {
      return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml3TagRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(new _M0TP219moonbit_2dcommunity4yaml3Tag("tag:yaml.org,2002:", suffix));
    } else {
      const _Some = _bind$4;
      const _prefix = _Some;
      return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml3TagRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(new _M0TP219moonbit_2dcommunity4yaml3Tag(_prefix, suffix));
    }
  } else {
    if (handle === "" && suffix === "!") {
      const _bind$4 = _M0MPC17hashmap7HashMap3getGssE(self.tags, "");
      if (_bind$4 === undefined) {
        return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml3TagRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(new _M0TP219moonbit_2dcommunity4yaml3Tag("", suffix));
      } else {
        const _Some = _bind$4;
        const _prefix = _Some;
        return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml3TagRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(new _M0TP219moonbit_2dcommunity4yaml3Tag(_prefix, suffix));
      }
    } else {
      const prefix = _M0MPC17hashmap7HashMap3getGssE(self.tags, handle);
      if (prefix === undefined) {
        if (handle.length >= 2 && (_M0MPC16string6String11has__prefix(handle, new _M0TPC16string10StringView(_M0MP219moonbit_2dcommunity4yaml6Parser12resolve__tagN7_2abindS1457, 0, _M0MP219moonbit_2dcommunity4yaml6Parser12resolve__tagN7_2abindS1457.length)) && _M0MPC16string6String11has__suffix(handle, new _M0TPC16string10StringView(_M0MP219moonbit_2dcommunity4yaml6Parser12resolve__tagN7_2abindS1458, 0, _M0MP219moonbit_2dcommunity4yaml6Parser12resolve__tagN7_2abindS1458.length)))) {
          return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml3TagRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(mark, "the handle wasn't declared"));
        } else {
          return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml3TagRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(new _M0TP219moonbit_2dcommunity4yaml3Tag(handle, suffix));
        }
      } else {
        const _Some = prefix;
        const _prefix = _Some;
        return new _M0DTPC16result6ResultGRP219moonbit_2dcommunity4yaml3TagRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(new _M0TP219moonbit_2dcommunity4yaml3Tag(_prefix, suffix));
      }
    }
  }
}
function _M0MP219moonbit_2dcommunity4yaml6Parser11parse__node(self, block, indentless_sequence) {
  let anchor_id = 0;
  let tag = undefined;
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
  let _bind$5;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _bind$5 = _ok._0;
  } else {
    return _bind$4;
  }
  const _x = _bind$5.marker;
  const _x$2 = _bind$5.token_type;
  switch (_x$2.$tag) {
    case 17: {
      _M0MP219moonbit_2dcommunity4yaml6Parser10pop__state(self);
      const _bind$6 = _M0MP219moonbit_2dcommunity4yaml6Parser12fetch__token(self);
      const _marker = _bind$6.marker;
      const _x$3 = _bind$6.token_type;
      if (_x$3.$tag === 17) {
        const _Alias = _x$3;
        const _name = _Alias._0;
        const _bind$7 = _M0MPC17hashmap7HashMap3getGsiE(self.anchors, _name);
        if (_bind$7 === undefined) {
          return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_marker, "while parsing node, found unknown anchor"));
        } else {
          const _Some = _bind$7;
          const _id = _Some;
          return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: new _M0DTP219moonbit_2dcommunity4yaml5Event5Alias(_id), _1: _marker });
        }
      }
      $panic();
      break;
    }
    case 18: {
      const _bind$7 = _M0MP219moonbit_2dcommunity4yaml6Parser12fetch__token(self);
      const _marker$2 = _bind$7.marker;
      const _x$4 = _bind$7.token_type;
      if (_x$4.$tag === 18) {
        const _Anchor = _x$4;
        const _name = _Anchor._0;
        anchor_id = _M0MP219moonbit_2dcommunity4yaml6Parser16register__anchor(self, _name, _marker$2);
        const _bind$8 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
        let _tmp$38;
        if (_bind$8.$tag === 1) {
          const _ok = _bind$8;
          _tmp$38 = _ok._0;
        } else {
          return _bind$8;
        }
        const _bind$9 = _tmp$38.token_type;
        if (_bind$9.$tag === 19) {
          const _bind$10 = _M0MP219moonbit_2dcommunity4yaml6Parser12fetch__token(self).token_type;
          if (_bind$10.$tag === 19) {
            const _Tag = _bind$10;
            const _handle = _Tag._0;
            const _suffix = _Tag._1;
            const _bind$11 = _M0MP219moonbit_2dcommunity4yaml6Parser12resolve__tag(self, _marker$2, _handle, _suffix);
            let _tmp$39;
            if (_bind$11.$tag === 1) {
              const _ok = _bind$11;
              _tmp$39 = _ok._0;
            } else {
              return _bind$11;
            }
            tag = _tmp$39;
          } else {
            $panic();
          }
        }
      } else {
        $panic();
      }
      break;
    }
    case 19: {
      const _bind$8 = _M0MP219moonbit_2dcommunity4yaml6Parser12fetch__token(self).token_type;
      if (_bind$8.$tag === 19) {
        const _Tag = _bind$8;
        const _handle = _Tag._0;
        const _suffix = _Tag._1;
        const _bind$9 = _M0MP219moonbit_2dcommunity4yaml6Parser12resolve__tag(self, _x, _handle, _suffix);
        let _tmp$38;
        if (_bind$9.$tag === 1) {
          const _ok = _bind$9;
          _tmp$38 = _ok._0;
        } else {
          return _bind$9;
        }
        tag = _tmp$38;
        const _bind$10 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
        let _tmp$39;
        if (_bind$10.$tag === 1) {
          const _ok = _bind$10;
          _tmp$39 = _ok._0;
        } else {
          return _bind$10;
        }
        const _bind$11 = _tmp$39.token_type;
        if (_bind$11.$tag === 18) {
          const _bind$12 = _M0MP219moonbit_2dcommunity4yaml6Parser12fetch__token(self);
          const _marker$3 = _bind$12.marker;
          const _x$5 = _bind$12.token_type;
          if (_x$5.$tag === 18) {
            const _Anchor = _x$5;
            const _name = _Anchor._0;
            anchor_id = _M0MP219moonbit_2dcommunity4yaml6Parser16register__anchor(self, _name, _marker$3);
          } else {
            $panic();
          }
        }
      } else {
        $panic();
      }
      break;
    }
  }
  let marker;
  _L: {
    let marker$2;
    _L$2: {
      const _bind$9 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
      let _bind$10;
      if (_bind$9.$tag === 1) {
        const _ok = _bind$9;
        _bind$10 = _ok._0;
      } else {
        return _bind$9;
      }
      const _marker$3 = _bind$10.marker;
      const _x$5 = _bind$10.token_type;
      switch (_x$5.$tag) {
        case 13: {
          if (indentless_sequence) {
            self.state = 8;
            return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: new _M0DTP219moonbit_2dcommunity4yaml5Event13SequenceStart(anchor_id, tag), _1: _marker$3 });
          } else {
            const _bind$11 = tag;
            if (_bind$11 === undefined) {
              if (anchor_id > 0) {
                marker$2 = _marker$3;
                break _L$2;
              } else {
                marker = _marker$3;
                break _L;
              }
            } else {
              marker$2 = _marker$3;
              break _L$2;
            }
          }
        }
        case 20: {
          _M0MP219moonbit_2dcommunity4yaml6Parser10pop__state(self);
          const _bind$11 = _M0MP219moonbit_2dcommunity4yaml6Parser12fetch__token(self);
          const _marker$4 = _bind$11.marker;
          const _x$6 = _bind$11.token_type;
          if (_x$6.$tag === 20) {
            const _Scalar = _x$6;
            const _style = _Scalar._0;
            const _value = _Scalar._1;
            return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: new _M0DTP219moonbit_2dcommunity4yaml5Event6Scalar(_value, _style, anchor_id, tag), _1: _marker$4 });
          } else {
            return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok($panic());
          }
        }
        case 9: {
          self.state = 12;
          return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: new _M0DTP219moonbit_2dcommunity4yaml5Event13SequenceStart(anchor_id, tag), _1: _marker$3 });
        }
        case 11: {
          self.state = 17;
          return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: new _M0DTP219moonbit_2dcommunity4yaml5Event12MappingStart(anchor_id, tag), _1: _marker$3 });
        }
        case 6: {
          if (block) {
            self.state = 6;
            return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: new _M0DTP219moonbit_2dcommunity4yaml5Event13SequenceStart(anchor_id, tag), _1: _marker$3 });
          } else {
            const _bind$12 = tag;
            if (_bind$12 === undefined) {
              if (anchor_id > 0) {
                marker$2 = _marker$3;
                break _L$2;
              } else {
                marker = _marker$3;
                break _L;
              }
            } else {
              marker$2 = _marker$3;
              break _L$2;
            }
          }
        }
        case 7: {
          if (block) {
            self.state = 9;
            return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: new _M0DTP219moonbit_2dcommunity4yaml5Event12MappingStart(anchor_id, tag), _1: _marker$3 });
          } else {
            const _bind$12 = tag;
            if (_bind$12 === undefined) {
              if (anchor_id > 0) {
                marker$2 = _marker$3;
                break _L$2;
              } else {
                marker = _marker$3;
                break _L;
              }
            } else {
              marker$2 = _marker$3;
              break _L$2;
            }
          }
        }
        default: {
          const _bind$12 = tag;
          if (_bind$12 === undefined) {
            if (anchor_id > 0) {
              marker$2 = _marker$3;
              break _L$2;
            } else {
              marker = _marker$3;
              break _L;
            }
          } else {
            marker$2 = _marker$3;
            break _L$2;
          }
        }
      }
    }
    _M0MP219moonbit_2dcommunity4yaml6Parser10pop__state(self);
    const _p$4 = anchor_id;
    const _p$5 = tag;
    return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: new _M0DTP219moonbit_2dcommunity4yaml5Event6Scalar("", 0, _p$4, _p$5), _1: marker$2 });
  }
  return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(marker, "while parsing a node, did not find expected node content"));
}
function _M0MP219moonbit_2dcommunity4yaml6Parser11push__state(self, state) {
  _M0MPC15array5Array4pushGRP219moonbit_2dcommunity4yaml5StateE(self.states, state);
}
function _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self) {
  self.token = undefined;
}
function _M0MP219moonbit_2dcommunity4yaml6Parser19block__mapping__key(self, first) {
  if (first) {
    const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _ok._0;
    } else {
      return _bind$4;
    }
    _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
  }
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
  let _bind$5;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _bind$5 = _ok._0;
  } else {
    return _bind$4;
  }
  const _x = _bind$5.marker;
  const _x$2 = _bind$5.token_type;
  switch (_x$2.$tag) {
    case 15: {
      _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
      let marker;
      _L: {
        const _bind$6 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
        let _bind$7;
        if (_bind$6.$tag === 1) {
          const _ok = _bind$6;
          _bind$7 = _ok._0;
        } else {
          return _bind$6;
        }
        const _marker = _bind$7.marker;
        const _x$3 = _bind$7.token_type;
        switch (_x$3.$tag) {
          case 15: {
            marker = _marker;
            break _L;
          }
          case 16: {
            marker = _marker;
            break _L;
          }
          case 8: {
            marker = _marker;
            break _L;
          }
          default: {
            _M0MP219moonbit_2dcommunity4yaml6Parser11push__state(self, 11);
            return _M0MP219moonbit_2dcommunity4yaml6Parser11parse__node(self, true, true);
          }
        }
      }
      self.state = 11;
      return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: new _M0DTP219moonbit_2dcommunity4yaml5Event6Scalar("", 0, 0, undefined), _1: marker });
    }
    case 16: {
      self.state = 11;
      return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: new _M0DTP219moonbit_2dcommunity4yaml5Event6Scalar("", 0, 0, undefined), _1: _x });
    }
    case 8: {
      _M0MP219moonbit_2dcommunity4yaml6Parser10pop__state(self);
      _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
      return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: _M0DTP219moonbit_2dcommunity4yaml5Event10MappingEnd__, _1: _x });
    }
    default: {
      return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_x, "while parsing a block mapping, did not find expected key"));
    }
  }
}
function _M0MP219moonbit_2dcommunity4yaml6Parser21block__mapping__value(self) {
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
  let _bind$5;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _bind$5 = _ok._0;
  } else {
    return _bind$4;
  }
  const _x = _bind$5.marker;
  const _x$2 = _bind$5.token_type;
  if (_x$2.$tag === 16) {
    _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
    let marker;
    _L: {
      const _bind$6 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
      let _bind$7;
      if (_bind$6.$tag === 1) {
        const _ok = _bind$6;
        _bind$7 = _ok._0;
      } else {
        return _bind$6;
      }
      const _marker = _bind$7.marker;
      const _x$3 = _bind$7.token_type;
      switch (_x$3.$tag) {
        case 15: {
          marker = _marker;
          break _L;
        }
        case 16: {
          marker = _marker;
          break _L;
        }
        case 8: {
          marker = _marker;
          break _L;
        }
        default: {
          _M0MP219moonbit_2dcommunity4yaml6Parser11push__state(self, 10);
          return _M0MP219moonbit_2dcommunity4yaml6Parser11parse__node(self, true, true);
        }
      }
    }
    self.state = 10;
    return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: new _M0DTP219moonbit_2dcommunity4yaml5Event6Scalar("", 0, 0, undefined), _1: marker });
  } else {
    self.state = 10;
    return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: new _M0DTP219moonbit_2dcommunity4yaml5Event6Scalar("", 0, 0, undefined), _1: _x });
  }
}
function _M0MP219moonbit_2dcommunity4yaml6Parser22block__sequence__entry(self, first) {
  if (first) {
    const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _ok._0;
    } else {
      return _bind$4;
    }
    _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
  }
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
  let _bind$5;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _bind$5 = _ok._0;
  } else {
    return _bind$4;
  }
  const _marker = _bind$5.marker;
  const _x = _bind$5.token_type;
  switch (_x.$tag) {
    case 8: {
      _M0MP219moonbit_2dcommunity4yaml6Parser10pop__state(self);
      _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
      return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: _M0DTP219moonbit_2dcommunity4yaml5Event11SequenceEnd__, _1: _marker });
    }
    case 13: {
      _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
      let marker;
      _L: {
        const _bind$6 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
        let _bind$7;
        if (_bind$6.$tag === 1) {
          const _ok = _bind$6;
          _bind$7 = _ok._0;
        } else {
          return _bind$6;
        }
        const _marker$2 = _bind$7.marker;
        const _x$2 = _bind$7.token_type;
        switch (_x$2.$tag) {
          case 13: {
            marker = _marker$2;
            break _L;
          }
          case 8: {
            marker = _marker$2;
            break _L;
          }
          default: {
            _M0MP219moonbit_2dcommunity4yaml6Parser11push__state(self, 7);
            return _M0MP219moonbit_2dcommunity4yaml6Parser11parse__node(self, true, false);
          }
        }
      }
      self.state = 7;
      return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: new _M0DTP219moonbit_2dcommunity4yaml5Event6Scalar("", 0, 0, undefined), _1: marker });
    }
    default: {
      return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_marker, "while parsing a block collection, did not find expected '-' indicator"));
    }
  }
}
function _M0MP219moonbit_2dcommunity4yaml6Parser17document__content(self) {
  let marker;
  _L: {
    const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
    let _bind$5;
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _bind$5 = _ok._0;
    } else {
      return _bind$4;
    }
    const _marker = _bind$5.marker;
    const _x = _bind$5.token_type;
    switch (_x.$tag) {
      case 2: {
        marker = _marker;
        break _L;
      }
      case 3: {
        marker = _marker;
        break _L;
      }
      case 4: {
        marker = _marker;
        break _L;
      }
      case 5: {
        marker = _marker;
        break _L;
      }
      case 1: {
        marker = _marker;
        break _L;
      }
      default: {
        return _M0MP219moonbit_2dcommunity4yaml6Parser11parse__node(self, true, false);
      }
    }
  }
  _M0MP219moonbit_2dcommunity4yaml6Parser10pop__state(self);
  return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: new _M0DTP219moonbit_2dcommunity4yaml5Event6Scalar("", 0, 0, undefined), _1: marker });
}
function _M0MP219moonbit_2dcommunity4yaml6Parser13document__end(self) {
  let explicit_end = false;
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
  let _bind$5;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _bind$5 = _ok._0;
  } else {
    return _bind$4;
  }
  const _marker = _bind$5.marker;
  const _x = _bind$5.token_type;
  let marker;
  if (_x.$tag === 5) {
    explicit_end = true;
    _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
    marker = _marker;
  } else {
    marker = _marker;
  }
  if (!self.keep_tags) {
    _M0MPC17hashmap7HashMap5clearGssE(self.tags);
  }
  if (explicit_end) {
    self.state = 1;
  } else {
    let marker$2;
    _L: {
      _L$2: {
        const _bind$6 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
        let _bind$7;
        if (_bind$6.$tag === 1) {
          const _ok = _bind$6;
          _bind$7 = _ok._0;
        } else {
          return _bind$6;
        }
        const _marker$2 = _bind$7.marker;
        const _x$2 = _bind$7.token_type;
        switch (_x$2.$tag) {
          case 2: {
            marker$2 = _marker$2;
            break _L$2;
          }
          case 3: {
            marker$2 = _marker$2;
            break _L$2;
          }
        }
        break _L;
      }
      return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(marker$2, "missing explicit document end marker before directive"));
    }
    self.state = 2;
  }
  return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: _M0DTP219moonbit_2dcommunity4yaml5Event11DocumentEnd__, _1: marker });
}
function _M0MP219moonbit_2dcommunity4yaml6Parser27parser__process__directives(self) {
  let version_directive_received = false;
  _L: while (true) {
    const tags = _M0MPC17hashmap7HashMap3newGssE(undefined);
    const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
    let _bind$5;
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _bind$5 = _ok._0;
    } else {
      return _bind$4;
    }
    const _marker = _bind$5.marker;
    const _x = _bind$5.token_type;
    switch (_x.$tag) {
      case 2: {
        if (version_directive_received) {
          return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_marker, "duplicate version directive"));
        }
        version_directive_received = true;
        break;
      }
      case 3: {
        const _TagDirective = _x;
        const _handle = _TagDirective._0;
        const _prefix = _TagDirective._1;
        if (_M0MPC17hashmap7HashMap8containsGssE(tags, _handle)) {
          return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_marker, "the TAG directive must only be given at most once per handle in the same document"));
        }
        _M0MPC17hashmap7HashMap3setGssE(tags, _handle, _prefix);
        break;
      }
      default: {
        break _L;
      }
    }
    self.tags = tags;
    _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
    continue;
  }
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(undefined);
}
function _M0MP219moonbit_2dcommunity4yaml6Parser25explicit__document__start(self) {
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser27parser__process__directives(self);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  const _bind$5 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
  let _bind$6;
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    _bind$6 = _ok._0;
  } else {
    return _bind$5;
  }
  const _marker = _bind$6.marker;
  const _x = _bind$6.token_type;
  if (_x.$tag === 4) {
    _M0MP219moonbit_2dcommunity4yaml6Parser11push__state(self, 4);
    self.state = 3;
    _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
    return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: _M0DTP219moonbit_2dcommunity4yaml5Event13DocumentStart__, _1: _marker });
  } else {
    return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_marker, "did not find expected <document-start>"));
  }
}
function _M0MP219moonbit_2dcommunity4yaml6Parser15document__start(self, implicit) {
  while (true) {
    const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
    let _tmp$38;
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _tmp$38 = _ok._0;
    } else {
      return _bind$4;
    }
    const _bind$5 = _tmp$38.token_type;
    if (_bind$5.$tag === 5) {
      _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
      continue;
    } else {
      break;
    }
  }
  _L: {
    const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
    let _bind$5;
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _bind$5 = _ok._0;
    } else {
      return _bind$4;
    }
    const _marker = _bind$5.marker;
    const _x = _bind$5.token_type;
    switch (_x.$tag) {
      case 1: {
        self.state = 21;
        _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
        return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: _M0DTP219moonbit_2dcommunity4yaml5Event9StreamEnd__, _1: _marker });
      }
      case 2: {
        break _L;
      }
      case 3: {
        break _L;
      }
      case 4: {
        break _L;
      }
      default: {
        if (implicit) {
          const _bind$6 = _M0MP219moonbit_2dcommunity4yaml6Parser27parser__process__directives(self);
          if (_bind$6.$tag === 1) {
            const _ok = _bind$6;
            _ok._0;
          } else {
            return _bind$6;
          }
          _M0MP219moonbit_2dcommunity4yaml6Parser11push__state(self, 4);
          self.state = 5;
          return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: _M0DTP219moonbit_2dcommunity4yaml5Event13DocumentStart__, _1: _marker });
        } else {
          return _M0MP219moonbit_2dcommunity4yaml6Parser25explicit__document__start(self);
        }
      }
    }
  }
  return _M0MP219moonbit_2dcommunity4yaml6Parser25explicit__document__start(self);
}
function _M0MP219moonbit_2dcommunity4yaml6Parser18flow__mapping__key(self, first) {
  if (first) {
    const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _ok._0;
    } else {
      return _bind$4;
    }
    _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
  }
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
  let _bind$5;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _bind$5 = _ok._0;
  } else {
    return _bind$4;
  }
  const _marker = _bind$5.marker;
  const _x = _bind$5.token_type;
  let marker;
  if (_x.$tag === 12) {
    marker = _marker;
  } else {
    if (!first) {
      const _bind$6 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
      let _bind$7;
      if (_bind$6.$tag === 1) {
        const _ok = _bind$6;
        _bind$7 = _ok._0;
      } else {
        return _bind$6;
      }
      const _x$2 = _bind$7.marker;
      const _x$3 = _bind$7.token_type;
      if (_x$3.$tag === 14) {
        _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
      } else {
        return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_x$2, "while parsing a flow mapping, did not find expected ',' or '}'"));
      }
    }
    const _bind$6 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
    let _bind$7;
    if (_bind$6.$tag === 1) {
      const _ok = _bind$6;
      _bind$7 = _ok._0;
    } else {
      return _bind$6;
    }
    const _x$2 = _bind$7.token_type;
    switch (_x$2.$tag) {
      case 15: {
        _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
        let marker$2;
        _L: {
          _L$2: {
            const _bind$8 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
            let _bind$9;
            if (_bind$8.$tag === 1) {
              const _ok = _bind$8;
              _bind$9 = _ok._0;
            } else {
              return _bind$8;
            }
            const _marker$2 = _bind$9.marker;
            const _x$3 = _bind$9.token_type;
            switch (_x$3.$tag) {
              case 16: {
                marker$2 = _marker$2;
                break _L$2;
              }
              case 14: {
                marker$2 = _marker$2;
                break _L$2;
              }
              case 12: {
                marker$2 = _marker$2;
                break _L$2;
              }
            }
            break _L;
          }
          self.state = 19;
          return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: new _M0DTP219moonbit_2dcommunity4yaml5Event6Scalar("", 0, 0, undefined), _1: marker$2 });
        }
        _M0MP219moonbit_2dcommunity4yaml6Parser11push__state(self, 19);
        const _bind$8 = _M0MP219moonbit_2dcommunity4yaml6Parser11parse__node(self, false, false);
        let _tmp$38;
        if (_bind$8.$tag === 1) {
          const _ok = _bind$8;
          _tmp$38 = _ok._0;
        } else {
          return _bind$8;
        }
        return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_tmp$38);
      }
      case 16: {
        self.state = 19;
        return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: new _M0DTP219moonbit_2dcommunity4yaml5Event6Scalar("", 0, 0, undefined), _1: _marker });
      }
      case 12: {
        break;
      }
      default: {
        _M0MP219moonbit_2dcommunity4yaml6Parser11push__state(self, 20);
        const _bind$9 = _M0MP219moonbit_2dcommunity4yaml6Parser11parse__node(self, false, false);
        let _tmp$39;
        if (_bind$9.$tag === 1) {
          const _ok = _bind$9;
          _tmp$39 = _ok._0;
        } else {
          return _bind$9;
        }
        return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_tmp$39);
      }
    }
    marker = _marker;
  }
  _M0MP219moonbit_2dcommunity4yaml6Parser10pop__state(self);
  _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
  return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: _M0DTP219moonbit_2dcommunity4yaml5Event10MappingEnd__, _1: marker });
}
function _M0MP219moonbit_2dcommunity4yaml6Parser20flow__mapping__value(self, empty) {
  if (empty) {
    const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
    let _bind$5;
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _bind$5 = _ok._0;
    } else {
      return _bind$4;
    }
    const _marker = _bind$5.marker;
    self.state = 18;
    return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: new _M0DTP219moonbit_2dcommunity4yaml5Event6Scalar("", 0, 0, undefined), _1: _marker });
  }
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
  let _bind$5;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _bind$5 = _ok._0;
  } else {
    return _bind$4;
  }
  const _marker = _bind$5.marker;
  const _x = _bind$5.token_type;
  let marker;
  if (_x.$tag === 16) {
    _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
    const _bind$6 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
    let _tmp$38;
    if (_bind$6.$tag === 1) {
      const _ok = _bind$6;
      _tmp$38 = _ok._0;
    } else {
      return _bind$6;
    }
    const _bind$7 = _tmp$38.token_type;
    switch (_bind$7.$tag) {
      case 14: {
        break;
      }
      case 12: {
        break;
      }
      default: {
        _M0MP219moonbit_2dcommunity4yaml6Parser11push__state(self, 18);
        const _bind$8 = _M0MP219moonbit_2dcommunity4yaml6Parser11parse__node(self, false, false);
        let _tmp$39;
        if (_bind$8.$tag === 1) {
          const _ok = _bind$8;
          _tmp$39 = _ok._0;
        } else {
          return _bind$8;
        }
        return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_tmp$39);
      }
    }
    marker = _marker;
  } else {
    marker = _marker;
  }
  self.state = 18;
  return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: new _M0DTP219moonbit_2dcommunity4yaml5Event6Scalar("", 0, 0, undefined), _1: marker });
}
function _M0MP219moonbit_2dcommunity4yaml6Parser21flow__sequence__entry(self, first) {
  if (first) {
    const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _ok._0;
    } else {
      return _bind$4;
    }
    _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
  }
  let marker;
  _L: {
    _L$2: {
      const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
      let _bind$5;
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        _bind$5 = _ok._0;
      } else {
        return _bind$4;
      }
      const _marker = _bind$5.marker;
      const _x = _bind$5.token_type;
      switch (_x.$tag) {
        case 10: {
          _M0MP219moonbit_2dcommunity4yaml6Parser10pop__state(self);
          _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
          return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: _M0DTP219moonbit_2dcommunity4yaml5Event11SequenceEnd__, _1: _marker });
        }
        case 14: {
          if (!first) {
            _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
          } else {
            if (!first) {
              marker = _marker;
              break _L$2;
            }
          }
          break;
        }
        default: {
          if (!first) {
            marker = _marker;
            break _L$2;
          }
        }
      }
      break _L;
    }
    return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(marker, "while parsing a flow sequence, expected ',' or ']'"));
  }
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
  let _bind$5;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _bind$5 = _ok._0;
  } else {
    return _bind$4;
  }
  const _marker = _bind$5.marker;
  const _x = _bind$5.token_type;
  switch (_x.$tag) {
    case 10: {
      _M0MP219moonbit_2dcommunity4yaml6Parser10pop__state(self);
      _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
      return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: _M0DTP219moonbit_2dcommunity4yaml5Event11SequenceEnd__, _1: _marker });
    }
    case 15: {
      self.state = 14;
      _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
      return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: new _M0DTP219moonbit_2dcommunity4yaml5Event12MappingStart(0, undefined), _1: _marker });
    }
    default: {
      _M0MP219moonbit_2dcommunity4yaml6Parser11push__state(self, 13);
      return _M0MP219moonbit_2dcommunity4yaml6Parser11parse__node(self, false, false);
    }
  }
}
function _M0MP219moonbit_2dcommunity4yaml6Parser35flow__sequence__entry__mapping__end(self) {
  self.state = 13;
  return { _0: _M0DTP219moonbit_2dcommunity4yaml5Event10MappingEnd__, _1: _M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self.lexer) };
}
function _M0MP219moonbit_2dcommunity4yaml6Parser35flow__sequence__entry__mapping__key(self) {
  let marker;
  _L: {
    const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
    let _bind$5;
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _bind$5 = _ok._0;
    } else {
      return _bind$4;
    }
    const _marker = _bind$5.marker;
    const _x = _bind$5.token_type;
    switch (_x.$tag) {
      case 16: {
        marker = _marker;
        break _L;
      }
      case 14: {
        marker = _marker;
        break _L;
      }
      case 10: {
        marker = _marker;
        break _L;
      }
      default: {
        _M0MP219moonbit_2dcommunity4yaml6Parser11push__state(self, 15);
        return _M0MP219moonbit_2dcommunity4yaml6Parser11parse__node(self, false, false);
      }
    }
  }
  _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
  self.state = 15;
  return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: new _M0DTP219moonbit_2dcommunity4yaml5Event6Scalar("", 0, 0, undefined), _1: marker });
}
function _M0MP219moonbit_2dcommunity4yaml6Parser37flow__sequence__entry__mapping__value(self) {
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
  let _bind$5;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _bind$5 = _ok._0;
  } else {
    return _bind$4;
  }
  const _x = _bind$5.marker;
  const _x$2 = _bind$5.token_type;
  if (_x$2.$tag === 16) {
    _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
    self.state = 15;
    let marker;
    _L: {
      const _bind$6 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
      let _bind$7;
      if (_bind$6.$tag === 1) {
        const _ok = _bind$6;
        _bind$7 = _ok._0;
      } else {
        return _bind$6;
      }
      const _marker = _bind$7.marker;
      const _x$3 = _bind$7.token_type;
      switch (_x$3.$tag) {
        case 14: {
          marker = _marker;
          break _L;
        }
        case 10: {
          marker = _marker;
          break _L;
        }
        default: {
          _M0MP219moonbit_2dcommunity4yaml6Parser11push__state(self, 16);
          return _M0MP219moonbit_2dcommunity4yaml6Parser11parse__node(self, false, false);
        }
      }
    }
    self.state = 16;
    return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: new _M0DTP219moonbit_2dcommunity4yaml5Event6Scalar("", 0, 0, undefined), _1: marker });
  } else {
    self.state = 16;
    return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: new _M0DTP219moonbit_2dcommunity4yaml5Event6Scalar("", 0, 0, undefined), _1: _x });
  }
}
function _M0MP219moonbit_2dcommunity4yaml6Parser27indentless__sequence__entry(self) {
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
  let _bind$5;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _bind$5 = _ok._0;
  } else {
    return _bind$4;
  }
  const _x = _bind$5.marker;
  const _x$2 = _bind$5.token_type;
  if (_x$2.$tag === 13) {
  } else {
    _M0MP219moonbit_2dcommunity4yaml6Parser10pop__state(self);
    return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: _M0DTP219moonbit_2dcommunity4yaml5Event11SequenceEnd__, _1: _x });
  }
  _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
  let marker;
  _L: {
    const _bind$6 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
    let _bind$7;
    if (_bind$6.$tag === 1) {
      const _ok = _bind$6;
      _bind$7 = _ok._0;
    } else {
      return _bind$6;
    }
    const _marker = _bind$7.marker;
    const _x$3 = _bind$7.token_type;
    switch (_x$3.$tag) {
      case 13: {
        marker = _marker;
        break _L;
      }
      case 15: {
        marker = _marker;
        break _L;
      }
      case 16: {
        marker = _marker;
        break _L;
      }
      case 8: {
        marker = _marker;
        break _L;
      }
      default: {
        _M0MP219moonbit_2dcommunity4yaml6Parser11push__state(self, 8);
        return _M0MP219moonbit_2dcommunity4yaml6Parser11parse__node(self, true, false);
      }
    }
  }
  self.state = 8;
  return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: _M0DTP219moonbit_2dcommunity4yaml5Event11SequenceEnd__, _1: marker });
}
function _M0MP219moonbit_2dcommunity4yaml6Parser13stream__start(self) {
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11peek__token(self);
  let _bind$5;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _bind$5 = _ok._0;
  } else {
    return _bind$4;
  }
  const _marker = _bind$5.marker;
  const _x = _bind$5.token_type;
  if (_x.$tag === 0) {
    self.state = 1;
    _M0MP219moonbit_2dcommunity4yaml6Parser4skip(self);
    return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: _M0DTP219moonbit_2dcommunity4yaml5Event11StreamStart__, _1: _marker });
  } else {
    return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_marker, "did not find expected <stream-start>"));
  }
}
function _M0MP219moonbit_2dcommunity4yaml6Parser14state__machine(self) {
  const _bind$4 = self.state;
  switch (_bind$4) {
    case 20: {
      return _M0MP219moonbit_2dcommunity4yaml6Parser20flow__mapping__value(self, true);
    }
    case 19: {
      return _M0MP219moonbit_2dcommunity4yaml6Parser20flow__mapping__value(self, false);
    }
    case 18: {
      return _M0MP219moonbit_2dcommunity4yaml6Parser18flow__mapping__key(self, false);
    }
    case 17: {
      return _M0MP219moonbit_2dcommunity4yaml6Parser18flow__mapping__key(self, true);
    }
    case 16: {
      return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0MP219moonbit_2dcommunity4yaml6Parser35flow__sequence__entry__mapping__end(self));
    }
    case 15: {
      return _M0MP219moonbit_2dcommunity4yaml6Parser37flow__sequence__entry__mapping__value(self);
    }
    case 14: {
      return _M0MP219moonbit_2dcommunity4yaml6Parser35flow__sequence__entry__mapping__key(self);
    }
    case 13: {
      return _M0MP219moonbit_2dcommunity4yaml6Parser21flow__sequence__entry(self, false);
    }
    case 12: {
      return _M0MP219moonbit_2dcommunity4yaml6Parser21flow__sequence__entry(self, true);
    }
    case 11: {
      return _M0MP219moonbit_2dcommunity4yaml6Parser21block__mapping__value(self);
    }
    case 10: {
      return _M0MP219moonbit_2dcommunity4yaml6Parser19block__mapping__key(self, false);
    }
    case 9: {
      return _M0MP219moonbit_2dcommunity4yaml6Parser19block__mapping__key(self, true);
    }
    case 8: {
      return _M0MP219moonbit_2dcommunity4yaml6Parser27indentless__sequence__entry(self);
    }
    case 7: {
      return _M0MP219moonbit_2dcommunity4yaml6Parser22block__sequence__entry(self, false);
    }
    case 6: {
      return _M0MP219moonbit_2dcommunity4yaml6Parser22block__sequence__entry(self, true);
    }
    case 5: {
      return _M0MP219moonbit_2dcommunity4yaml6Parser11parse__node(self, true, false);
    }
    case 4: {
      return _M0MP219moonbit_2dcommunity4yaml6Parser13document__end(self);
    }
    case 3: {
      return _M0MP219moonbit_2dcommunity4yaml6Parser17document__content(self);
    }
    case 2: {
      return _M0MP219moonbit_2dcommunity4yaml6Parser15document__start(self, false);
    }
    case 1: {
      return _M0MP219moonbit_2dcommunity4yaml6Parser15document__start(self, true);
    }
    case 0: {
      return _M0MP219moonbit_2dcommunity4yaml6Parser13stream__start(self);
    }
    default: {
      return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok($panic());
    }
  }
}
function _M0MP219moonbit_2dcommunity4yaml6Parser5parse(self) {
  if (_M0IP219moonbit_2dcommunity4yaml5StatePB2Eq5equal(self.state, 21)) {
    return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok({ _0: _M0DTP219moonbit_2dcommunity4yaml5Event9StreamEnd__, _1: _M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self.lexer) });
  }
  return _M0MP219moonbit_2dcommunity4yaml6Parser14state__machine(self);
}
function _M0MP219moonbit_2dcommunity4yaml6Parser11next__token(self) {
  const current = self.current;
  self.current = undefined;
  if (current === undefined) {
    return _M0MP219moonbit_2dcommunity4yaml6Parser5parse(self);
  } else {
    const _Some = current;
    const _x = _Some;
    return new _M0DTPC16result6ResultGURP219moonbit_2dcommunity4yaml5EventRP219moonbit_2dcommunity4yaml6MarkerERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_x);
  }
}
function _M0MP219moonbit_2dcommunity4yaml6Parser10load__nodeGRP219moonbit_2dcommunity4yaml10YamlLoaderE(self, first_ev, mark, recv) {
  _L: {
    switch (first_ev.$tag) {
      case 4: {
        break _L;
      }
      case 5: {
        break _L;
      }
      case 6: {
        _M0IP219moonbit_2dcommunity4yaml10YamlLoaderP219moonbit_2dcommunity4yaml19MarkedEventReceiver9on__event(recv, first_ev, mark);
        return _M0MP219moonbit_2dcommunity4yaml6Parser14load__sequenceGRP219moonbit_2dcommunity4yaml10YamlLoaderE(self, recv);
      }
      case 8: {
        _M0IP219moonbit_2dcommunity4yaml10YamlLoaderP219moonbit_2dcommunity4yaml19MarkedEventReceiver9on__event(recv, first_ev, mark);
        return _M0MP219moonbit_2dcommunity4yaml6Parser13load__mappingGRP219moonbit_2dcommunity4yaml10YamlLoaderE(self, recv);
      }
      default: {
        _M0FPB7printlnGsE(`UNREACHABLE EVENT: ${_M0IP016_24default__implPB4Show10to__stringGRP219moonbit_2dcommunity4yaml5EventE(first_ev)}`);
        return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok($panic());
      }
    }
  }
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0IP219moonbit_2dcommunity4yaml10YamlLoaderP219moonbit_2dcommunity4yaml19MarkedEventReceiver9on__event(recv, first_ev, mark));
}
function _M0MP219moonbit_2dcommunity4yaml6Parser13load__mappingGRP219moonbit_2dcommunity4yaml10YamlLoaderE(self, recv) {
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11next__token(self);
  let _bind$5;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _bind$5 = _ok._0;
  } else {
    return _bind$4;
  }
  const _key_ev = _bind$5._0;
  const _key_mark = _bind$5._1;
  let key_ev = _key_ev;
  let key_mark = _key_mark;
  while (true) {
    if (_M0IP016_24default__implPB2Eq10not__equalGRP219moonbit_2dcommunity4yaml5EventE(key_ev, _M0DTP219moonbit_2dcommunity4yaml5Event10MappingEnd__)) {
      const _bind$6 = _M0MP219moonbit_2dcommunity4yaml6Parser10load__nodeGRP219moonbit_2dcommunity4yaml10YamlLoaderE(self, key_ev, key_mark, recv);
      if (_bind$6.$tag === 1) {
        const _ok = _bind$6;
        _ok._0;
      } else {
        return _bind$6;
      }
      const _bind$7 = _M0MP219moonbit_2dcommunity4yaml6Parser11next__token(self);
      let _bind$8;
      if (_bind$7.$tag === 1) {
        const _ok = _bind$7;
        _bind$8 = _ok._0;
      } else {
        return _bind$7;
      }
      const _ev = _bind$8._0;
      const _mark = _bind$8._1;
      const _bind$9 = _M0MP219moonbit_2dcommunity4yaml6Parser10load__nodeGRP219moonbit_2dcommunity4yaml10YamlLoaderE(self, _ev, _mark, recv);
      if (_bind$9.$tag === 1) {
        const _ok = _bind$9;
        _ok._0;
      } else {
        return _bind$9;
      }
      const _bind$10 = _M0MP219moonbit_2dcommunity4yaml6Parser11next__token(self);
      let _bind$11;
      if (_bind$10.$tag === 1) {
        const _ok = _bind$10;
        _bind$11 = _ok._0;
      } else {
        return _bind$10;
      }
      const _ev$2 = _bind$11._0;
      const _mark$2 = _bind$11._1;
      key_ev = _ev$2;
      key_mark = _mark$2;
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0IP219moonbit_2dcommunity4yaml10YamlLoaderP219moonbit_2dcommunity4yaml19MarkedEventReceiver9on__event(recv, key_ev, key_mark));
}
function _M0MP219moonbit_2dcommunity4yaml6Parser14load__sequenceGRP219moonbit_2dcommunity4yaml10YamlLoaderE(self, recv) {
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11next__token(self);
  let _bind$5;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _bind$5 = _ok._0;
  } else {
    return _bind$4;
  }
  const _ev = _bind$5._0;
  const _mark = _bind$5._1;
  let ev = _ev;
  let mark = _mark;
  while (true) {
    if (_M0IP016_24default__implPB2Eq10not__equalGRP219moonbit_2dcommunity4yaml5EventE(ev, _M0DTP219moonbit_2dcommunity4yaml5Event11SequenceEnd__)) {
      const _bind$6 = _M0MP219moonbit_2dcommunity4yaml6Parser10load__nodeGRP219moonbit_2dcommunity4yaml10YamlLoaderE(self, ev, mark, recv);
      if (_bind$6.$tag === 1) {
        const _ok = _bind$6;
        _ok._0;
      } else {
        return _bind$6;
      }
      const _bind$7 = _M0MP219moonbit_2dcommunity4yaml6Parser11next__token(self);
      let _bind$8;
      if (_bind$7.$tag === 1) {
        const _ok = _bind$7;
        _bind$8 = _ok._0;
      } else {
        return _bind$7;
      }
      const _next_ev = _bind$8._0;
      const _next_mark = _bind$8._1;
      ev = _next_ev;
      mark = _next_mark;
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0IP219moonbit_2dcommunity4yaml10YamlLoaderP219moonbit_2dcommunity4yaml19MarkedEventReceiver9on__event(recv, ev, mark));
}
function _M0MP219moonbit_2dcommunity4yaml6Parser14load__documentGRP219moonbit_2dcommunity4yaml10YamlLoaderE(self, first_ev, mark, recv) {
  if (_M0IP016_24default__implPB2Eq10not__equalGRP219moonbit_2dcommunity4yaml5EventE(first_ev, _M0DTP219moonbit_2dcommunity4yaml5Event13DocumentStart__)) {
    return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(mark, "did not find expected <document-start>"));
  }
  _M0IP219moonbit_2dcommunity4yaml10YamlLoaderP219moonbit_2dcommunity4yaml19MarkedEventReceiver9on__event(recv, first_ev, mark);
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11next__token(self);
  let _bind$5;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _bind$5 = _ok._0;
  } else {
    return _bind$4;
  }
  const _ev = _bind$5._0;
  const _mark = _bind$5._1;
  const _bind$6 = _M0MP219moonbit_2dcommunity4yaml6Parser10load__nodeGRP219moonbit_2dcommunity4yaml10YamlLoaderE(self, _ev, _mark, recv);
  if (_bind$6.$tag === 1) {
    const _ok = _bind$6;
    _ok._0;
  } else {
    return _bind$6;
  }
  const _bind$7 = _M0MP219moonbit_2dcommunity4yaml6Parser11next__token(self);
  let _bind$8;
  if (_bind$7.$tag === 1) {
    const _ok = _bind$7;
    _bind$8 = _ok._0;
  } else {
    return _bind$7;
  }
  const _ev$2 = _bind$8._0;
  const _mark$2 = _bind$8._1;
  if (_M0IP219moonbit_2dcommunity4yaml5EventPB2Eq5equal(_ev$2, _M0DTP219moonbit_2dcommunity4yaml5Event11DocumentEnd__)) {
    _M0IP219moonbit_2dcommunity4yaml10YamlLoaderP219moonbit_2dcommunity4yaml19MarkedEventReceiver9on__event(recv, _ev$2, _mark$2);
  } else {
    $panic();
  }
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(undefined);
}
function _M0MP219moonbit_2dcommunity4yaml6Parser4loadGRP219moonbit_2dcommunity4yaml10YamlLoaderE(self, recv, multi) {
  const _p$4 = self.lexer;
  if (!_p$4.stream_start_produced) {
    const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11next__token(self);
    let _bind$5;
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _bind$5 = _ok._0;
    } else {
      return _bind$4;
    }
    const _ev = _bind$5._0;
    const _mark = _bind$5._1;
    if (_M0IP016_24default__implPB2Eq10not__equalGRP219moonbit_2dcommunity4yaml5EventE(_ev, _M0DTP219moonbit_2dcommunity4yaml5Event11StreamStart__)) {
      return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(_mark, "did not find expected <stream-start>"));
    }
    _M0IP219moonbit_2dcommunity4yaml10YamlLoaderP219moonbit_2dcommunity4yaml19MarkedEventReceiver9on__event(recv, _ev, _mark);
  }
  const _p$5 = self.lexer;
  if (_p$5.stream_end_produced) {
    _M0IP219moonbit_2dcommunity4yaml10YamlLoaderP219moonbit_2dcommunity4yaml19MarkedEventReceiver9on__event(recv, _M0DTP219moonbit_2dcommunity4yaml5Event9StreamEnd__, _M0MP219moonbit_2dcommunity4yaml5Lexer11get__marker(self.lexer));
    return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(undefined);
  }
  while (true) {
    const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser11next__token(self);
    let _bind$5;
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _bind$5 = _ok._0;
    } else {
      return _bind$4;
    }
    const _ev = _bind$5._0;
    const _mark = _bind$5._1;
    if (_M0IP219moonbit_2dcommunity4yaml5EventPB2Eq5equal(_ev, _M0DTP219moonbit_2dcommunity4yaml5Event9StreamEnd__)) {
      _M0IP219moonbit_2dcommunity4yaml10YamlLoaderP219moonbit_2dcommunity4yaml19MarkedEventReceiver9on__event(recv, _ev, _mark);
      return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(undefined);
    }
    _M0MPC17hashmap7HashMap5clearGsiE(self.anchors);
    const _bind$6 = _M0MP219moonbit_2dcommunity4yaml6Parser14load__documentGRP219moonbit_2dcommunity4yaml10YamlLoaderE(self, _ev, _mark, recv);
    if (_bind$6.$tag === 1) {
      const _ok = _bind$6;
      _ok._0;
    } else {
      return _bind$6;
    }
    if (!multi) {
      break;
    }
    continue;
  }
  return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(undefined);
}
function _M0MP219moonbit_2dcommunity4yaml4Yaml18load__from__parser(parser) {
  const loader = new _M0TP219moonbit_2dcommunity4yaml10YamlLoader([], [], [], _M0MPC111sorted__map9SortedMap3newGiRP219moonbit_2dcommunity4yaml4YamlE(), undefined);
  const _bind$4 = _M0MP219moonbit_2dcommunity4yaml6Parser4loadGRP219moonbit_2dcommunity4yaml10YamlLoaderE(parser, loader, true);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  const _bind$5 = loader.error;
  if (_bind$5 === undefined) {
    return new _M0DTPC16result6ResultGRPB5ArrayGRP219moonbit_2dcommunity4yaml4YamlERP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(loader.docs);
  } else {
    const _Some = _bind$5;
    const _err = _Some;
    return new _M0DTPC16result6ResultGRPB5ArrayGRP219moonbit_2dcommunity4yaml4YamlERP219moonbit_2dcommunity4yaml9YamlErrorE3Err(_err);
  }
}
function _M0MP219moonbit_2dcommunity4yaml5Lexer3new(input) {
  const _bind$4 = _M0MPC15deque5Deque11new_2einnerGcE(16);
  const _bind$5 = _M0MPC15deque5Deque11new_2einnerGRP219moonbit_2dcommunity4yaml5TokenE(42);
  const _bind$6 = undefined;
  const _bind$7 = _M0MPC15array5Array11new_2einnerGRP411moonbitlang6regexp8internal2vm6ThreadE(0);
  const _bind$8 = _M0MPC15array5Array11new_2einnerGRP411moonbitlang6regexp8internal2vm6ThreadE(0);
  return new _M0TP219moonbit_2dcommunity4yaml5Lexer(input, 0, 1, 0, _bind$5, _bind$4, _bind$6, false, false, 0, true, _bind$7, -1, _bind$8, 0, 0, false, true, false, false);
}
function _M0MP219moonbit_2dcommunity4yaml6Parser3new(str) {
  return new _M0TP219moonbit_2dcommunity4yaml6Parser(_M0MP219moonbit_2dcommunity4yaml5Lexer3new(str), _M0MPC15array5Array11new_2einnerGRP219moonbit_2dcommunity4yaml5StateE(40), 0, undefined, undefined, _M0MPC17hashmap7HashMap3newGsiE(undefined), 1, _M0MPC17hashmap7HashMap3newGssE(undefined), false);
}
function _M0MP219moonbit_2dcommunity4yaml4Yaml18load__from__string(source) {
  const parser = _M0MP219moonbit_2dcommunity4yaml6Parser3new(source);
  return _M0MP219moonbit_2dcommunity4yaml4Yaml18load__from__parser(parser);
}
function _M0MP219moonbit_2dcommunity4yaml10YamlLoader17insert__new__node(self, node, mark) {
  if (node._1 > 0) {
    _M0MPC111sorted__map9SortedMap3setGiRP219moonbit_2dcommunity4yaml4YamlE(self.anchor_map, node._1, node._0);
  }
  const _p$4 = self.doc_stack;
  if (_p$4.length === 0) {
    return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0MPC15array5Array4pushGUssEE(self.doc_stack, node));
  } else {
    const _p$5 = _M0MPC15array5Array4lastGURP219moonbit_2dcommunity4yaml4YamliEE(self.doc_stack);
    let parent;
    if (_p$5 === undefined) {
      parent = $panic();
    } else {
      const _p$6 = _p$5;
      parent = _p$6;
    }
    const _x = parent._0;
    switch (_x.$tag) {
      case 4: {
        const _Array = _x;
        const _v = _Array._0;
        return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0MPC15array5Array4pushGUssEE(_v, node._0));
      }
      case 5: {
        const _Map = _x;
        const _m = _Map._0;
        const _p$6 = _M0MPC15array5Array4lastGURP219moonbit_2dcommunity4yaml4YamliEE(self.key_stack);
        let cur_key;
        if (_p$6 === undefined) {
          cur_key = $panic();
        } else {
          const _p$7 = _p$6;
          cur_key = _p$7;
        }
        if (cur_key === "") {
          const _bind$4 = node._0;
          if (_bind$4.$tag === 2) {
            const _String = _bind$4;
            const _key = _String._0;
            return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0MPC15array5Array3setGsE(self.key_stack, self.key_stack.length - 1 | 0, _key));
          } else {
            return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(mark, "yaml.mbt doesn't support non-string key"));
          }
        } else {
          _M0MPC15array5Array3setGsE(self.key_stack, self.key_stack.length - 1 | 0, "");
          if (_M0MPB3Map8containsGsRP219moonbit_2dcommunity4yaml4YamlE(_m, cur_key)) {
            return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE3Err(new _M0DTPC15error5Error50moonbit_2dcommunity_2fyaml_2eYamlError_2eYamlError(mark, `${cur_key}: duplicated key in mapping`));
          } else {
            return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0MPB3Map3setGsRP219moonbit_2dcommunity4yaml4YamlE(_m, cur_key, node._0));
          }
        }
      }
      default: {
        return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok($panic());
      }
    }
  }
}
function _M0MP219moonbit_2dcommunity4yaml10YamlLoader15on__event__impl(self, ev, mark) {
  switch (ev.$tag) {
    case 2: {
      return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(undefined);
    }
    case 0: {
      return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(undefined);
    }
    case 1: {
      return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(undefined);
    }
    case 3: {
      const _bind$4 = self.doc_stack.length;
      switch (_bind$4) {
        case 0: {
          return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0MPC15array5Array4pushGUssEE(self.docs, _M0DTP219moonbit_2dcommunity4yaml4Yaml8BadValue__));
        }
        case 1: {
          const _tmp$38 = self.docs;
          const _p$4 = _M0MPC15array5Array3popGsE(self.doc_stack);
          let _tmp$39;
          if (_p$4 === undefined) {
            _tmp$39 = $panic();
          } else {
            const _p$5 = _p$4;
            _tmp$39 = _p$5;
          }
          return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0MPC15array5Array4pushGUssEE(_tmp$38, _tmp$39._0));
        }
        default: {
          return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok($panic());
        }
      }
    }
    case 6: {
      const _SequenceStart = ev;
      const _id = _SequenceStart._0;
      return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0MPC15array5Array4pushGUssEE(self.doc_stack, { _0: new _M0DTP219moonbit_2dcommunity4yaml4Yaml5Array([]), _1: _id }));
    }
    case 7: {
      const _p$5 = _M0MPC15array5Array3popGsE(self.doc_stack);
      let node;
      if (_p$5 === undefined) {
        node = $panic();
      } else {
        const _p$6 = _p$5;
        node = _p$6;
      }
      return _M0MP219moonbit_2dcommunity4yaml10YamlLoader17insert__new__node(self, node, mark);
    }
    case 8: {
      const _MappingStart = ev;
      const _id$2 = _MappingStart._0;
      const _tmp$40 = self.doc_stack;
      const _bind$5 = [];
      _M0MPC15array5Array4pushGUssEE(_tmp$40, { _0: new _M0DTP219moonbit_2dcommunity4yaml4Yaml3Map(_M0MPB3Map3MapGsRP219moonbit_2dcommunity4yaml4YamlE(new _M0TPB9ArrayViewGUsRP219moonbit_2dcommunity4yaml4YamlEE(_bind$5, 0, 0), undefined)), _1: _id$2 });
      return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok(_M0MPC15array5Array4pushGUssEE(self.key_stack, ""));
    }
    case 9: {
      const _bind$6 = _M0MPC15array5Array3popGsE(self.key_stack);
      if (_bind$6 === undefined) {
        return new _M0DTPC16result6ResultGuRP219moonbit_2dcommunity4yaml9YamlErrorE2Ok($panic());
      } else {
        const _p$6 = _M0MPC15array5Array3popGsE(self.doc_stack);
        let node$2;
        if (_p$6 === undefined) {
          node$2 = $panic();
        } else {
          const _p$7 = _p$6;
          node$2 = _p$7;
        }
        return _M0MP219moonbit_2dcommunity4yaml10YamlLoader17insert__new__node(self, node$2, mark);
      }
    }
    case 5: {
      const _Scalar = ev;
      const _value = _Scalar._0;
      const _style = _Scalar._1;
      const _id$3 = _Scalar._2;
      const _tag = _Scalar._3;
      let node$2;
      if (_M0IP016_24default__implPB2Eq10not__equalGRP219moonbit_2dcommunity4yaml12TScalarStyleE(_style, 0)) {
        node$2 = new _M0DTP219moonbit_2dcommunity4yaml4Yaml6String(_value);
      } else {
        if (_tag === undefined) {
          node$2 = _M0MP219moonbit_2dcommunity4yaml4Yaml9from__str(_value);
        } else {
          const _Some = _tag;
          const _x = _Some;
          const _handle = _x.handle;
          const _suffix = _x.suffix;
          if (_handle === "tag:yaml.org,2002:") {
            switch (_suffix) {
              case "bool": {
                _L: {
                  _L$2: {
                    _L$3: {
                      _L$4: {
                        switch (_value) {
                          case "true": {
                            break _L$4;
                          }
                          case "True": {
                            break _L$4;
                          }
                          case "TRUE": {
                            break _L$4;
                          }
                          case "false": {
                            break _L$2;
                          }
                          case "False": {
                            break _L$2;
                          }
                          case "FALSE": {
                            break _L$2;
                          }
                          default: {
                            node$2 = _M0DTP219moonbit_2dcommunity4yaml4Yaml8BadValue__;
                          }
                        }
                        break _L$3;
                      }
                      node$2 = _M0MP219moonbit_2dcommunity4yaml10YamlLoader15on__event__implN6constrS2089;
                    }
                    break _L;
                  }
                  node$2 = _M0MP219moonbit_2dcommunity4yaml10YamlLoader15on__event__implN6constrS2088;
                }
                break;
              }
              case "int": {
                let _try_err;
                _L$2: {
                  _L$3: {
                    const _bind$7 = _M0FPC17strconv20parse__int64_2einner(new _M0TPC16string10StringView(_value, 0, _value.length), 0);
                    let _tmp$41;
                    if (_bind$7.$tag === 1) {
                      const _ok = _bind$7;
                      _tmp$41 = _ok._0;
                    } else {
                      const _err = _bind$7;
                      _try_err = _err._0;
                      break _L$3;
                    }
                    node$2 = new _M0DTP219moonbit_2dcommunity4yaml4Yaml7Integer(_tmp$41);
                    break _L$2;
                  }
                  node$2 = _M0DTP219moonbit_2dcommunity4yaml4Yaml8BadValue__;
                }
                break;
              }
              case "float": {
                const _bind$7 = _M0FP219moonbit_2dcommunity4yaml13parse__double(new _M0TPC16string10StringView(_value, 0, _value.length));
                if (_bind$7.$tag === 1) {
                  const _Some$2 = _bind$7;
                  const _d = _Some$2._0;
                  node$2 = new _M0DTP219moonbit_2dcommunity4yaml4Yaml4Real(_d, _value);
                } else {
                  node$2 = _M0DTP219moonbit_2dcommunity4yaml4Yaml8BadValue__;
                }
                break;
              }
              case "null": {
                _L$3: {
                  _L$4: {
                    switch (_value) {
                      case "~": {
                        break _L$4;
                      }
                      case "null": {
                        break _L$4;
                      }
                      default: {
                        node$2 = _M0DTP219moonbit_2dcommunity4yaml4Yaml8BadValue__;
                      }
                    }
                    break _L$3;
                  }
                  node$2 = _M0DTP219moonbit_2dcommunity4yaml4Yaml4Null__;
                }
                break;
              }
              default: {
                node$2 = new _M0DTP219moonbit_2dcommunity4yaml4Yaml6String(_value);
              }
            }
          } else {
            node$2 = new _M0DTP219moonbit_2dcommunity4yaml4Yaml6String(_value);
          }
        }
      }
      return _M0MP219moonbit_2dcommunity4yaml10YamlLoader17insert__new__node(self, { _0: node$2, _1: _id$3 }, mark);
    }
    default: {
      const _Alias = ev;
      const _id$4 = _Alias._0;
      const _bind$7 = _M0MPC111sorted__map9SortedMap3getGiRP219moonbit_2dcommunity4yaml4YamlE(self.anchor_map, _id$4);
      let n;
      if (_bind$7 === undefined) {
        n = _M0DTP219moonbit_2dcommunity4yaml4Yaml8BadValue__;
      } else {
        const _Some = _bind$7;
        n = _Some;
      }
      return _M0MP219moonbit_2dcommunity4yaml10YamlLoader17insert__new__node(self, { _0: n, _1: 0 }, mark);
    }
  }
}
function _M0IP219moonbit_2dcommunity4yaml10YamlLoaderP219moonbit_2dcommunity4yaml19MarkedEventReceiver9on__event(self, ev, mark) {
  const _bind$4 = self.error;
  if (_bind$4 === undefined) {
  } else {
    return undefined;
  }
  let _try_err;
  _L: {
    const _bind$5 = _M0MP219moonbit_2dcommunity4yaml10YamlLoader15on__event__impl(self, ev, mark);
    if (_bind$5.$tag === 1) {
      const _ok = _bind$5;
      _ok._0;
      return;
    } else {
      const _err = _bind$5;
      _try_err = _err._0;
      break _L;
    }
  }
  const _YamlError = _try_err;
  self.error = _YamlError;
}
function _M0FP218peter_2djerry_2dye11parse__args13parse_2einnerN14resolve__aliasS21(aliases, name) {
  const _p$4 = _M0MPB3Map17get__from__stringGsE(aliases, name);
  const _p$5 = _M0MPC16string10StringView9to__owned(name);
  if (_p$4 === undefined) {
    return _p$5;
  } else {
    const _p$6 = _p$4;
    return _p$6;
  }
}
function _M0FP218peter_2djerry_2dye11parse__args13parse_2einner(args, flags, options, collections, aliases, negatable, double_dash, stop_early) {
  const positional = [];
  const _bind$4 = [];
  const flags_map = _M0MPB3Map3MapGsbE(new _M0TPB9ArrayViewGUsbEE(_bind$4, 0, 0), undefined);
  const _bind$5 = [];
  const options_map = _M0MPB3Map3MapGssE(new _M0TPB9ArrayViewGUssEE(_bind$5, 0, 0), undefined);
  const _bind$6 = [];
  const collections_map = _M0MPB3Map3MapGsRPB5ArrayGsEE(new _M0TPB9ArrayViewGUsRPB5ArrayGsEEE(_bind$6, 0, 0), undefined);
  const _p$4 = new Array(flags.end - flags.start | 0);
  const _p$5 = flags.end - flags.start | 0;
  let _tmp$38 = 0;
  while (true) {
    const _p$6 = _tmp$38;
    if (_p$6 < _p$5) {
      const _p$7 = flags.buf[flags.start + _p$6 | 0];
      _p$4[_p$6] = new _M0TPC16string10StringView(_p$7, 0, _p$7.length);
      _tmp$38 = _p$6 + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$7 = _p$4;
  const flag_set = _M0MPC13set3Set3SetGRPC16string10StringViewE(new _M0TPB9ArrayViewGRPC16string10StringViewE(_bind$7, 0, _bind$7.length), undefined);
  const _p$6 = new Array(options.end - options.start | 0);
  const _p$7 = options.end - options.start | 0;
  let _tmp$39 = 0;
  while (true) {
    const _p$8 = _tmp$39;
    if (_p$8 < _p$7) {
      const _p$9 = options.buf[options.start + _p$8 | 0];
      _p$6[_p$8] = new _M0TPC16string10StringView(_p$9, 0, _p$9.length);
      _tmp$39 = _p$8 + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$8 = _p$6;
  const option_set = _M0MPC13set3Set3SetGRPC16string10StringViewE(new _M0TPB9ArrayViewGRPC16string10StringViewE(_bind$8, 0, _bind$8.length), undefined);
  const _p$8 = new Array(collections.end - collections.start | 0);
  const _p$9 = collections.end - collections.start | 0;
  let _tmp$40 = 0;
  while (true) {
    const _p$10 = _tmp$40;
    if (_p$10 < _p$9) {
      const _p$11 = collections.buf[collections.start + _p$10 | 0];
      _p$8[_p$10] = new _M0TPC16string10StringView(_p$11, 0, _p$11.length);
      _tmp$40 = _p$10 + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$9 = _p$8;
  const collection_set = _M0MPC13set3Set3SetGRPC16string10StringViewE(new _M0TPB9ArrayViewGRPC16string10StringViewE(_bind$9, 0, _bind$9.length), undefined);
  const _p$10 = new Array(negatable.end - negatable.start | 0);
  const _p$11 = negatable.end - negatable.start | 0;
  let _tmp$41 = 0;
  while (true) {
    const _p$12 = _tmp$41;
    if (_p$12 < _p$11) {
      const _p$13 = negatable.buf[negatable.start + _p$12 | 0];
      _p$10[_p$12] = new _M0TPC16string10StringView(_p$13, 0, _p$13.length);
      _tmp$41 = _p$12 + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$10 = _p$10;
  const negatable_set = _M0MPC13set3Set3SetGRPC16string10StringViewE(new _M0TPB9ArrayViewGRPC16string10StringViewE(_bind$10, 0, _bind$10.length), undefined);
  let args$2 = _M0MPC15array9ArrayView12view_2einnerGsE(args, 0, undefined);
  while (true) {
    const _bind$11 = args$2;
    if ((_bind$11.end - _bind$11.start | 0) >= 1) {
      const _arg = _bind$11.buf[_bind$11.start];
      const _x = new _M0TPB9ArrayViewGsE(_bind$11.buf, 1 + _bind$11.start | 0, _bind$11.end);
      args$2 = _x;
      if (_arg === "--") {
        if (double_dash) {
          _M0MPC15array5Array10push__iterGsE(positional, _M0MPC15array9ArrayView4iterGsE(args$2));
          break;
        }
      }
      if (stop_early && !_M0MPC16string6String11has__prefix(_arg, new _M0TPC16string10StringView(_M0FP218peter_2djerry_2dye11parse__args13parse_2einnerN7_2abindS95, 0, _M0FP218peter_2djerry_2dye11parse__args13parse_2einnerN7_2abindS95.length))) {
        _M0MPC15array5Array4pushGUssEE(positional, _arg);
        _M0MPC15array5Array10push__iterGsE(positional, _M0MPC15array9ArrayView4iterGsE(args$2));
        break;
      }
      _L: {
        _L$2: {
          _L$3: {
            _L$4: {
              if (_M0MPC16string6String24char__length__ge_2einner(_arg, 2, 0, _arg.length)) {
                const _x$2 = _arg.charCodeAt(0);
                if (_x$2 === 45) {
                  const _x$3 = _arg.charCodeAt(1);
                  if (_x$3 === 45) {
                    const _bind$12 = _M0MPC16string6String29offset__of__nth__char_2einner(_arg, 2, 0, _arg.length);
                    let _tmp$42;
                    if (_bind$12 === undefined) {
                      _tmp$42 = _arg.length;
                    } else {
                      const _Some = _bind$12;
                      _tmp$42 = _Some;
                    }
                    const _x$4 = new _M0TPC16string10StringView(_arg, _tmp$42, _arg.length);
                    if ((_x$4.end - _x$4.start | 0) > 0) {
                      const eq = _M0MPC16string10StringView4find(_x$4, new _M0TPC16string10StringView(_M0FP218peter_2djerry_2dye11parse__args13parse_2einnerN7_2abindS138, 0, _M0FP218peter_2djerry_2dye11parse__args13parse_2einnerN7_2abindS138.length));
                      let name;
                      if (eq === undefined) {
                        name = _x$4;
                      } else {
                        const _Some = eq;
                        const _pos = _Some;
                        name = _M0MPC16string10StringView11sub_2einner(_x$4, 0, _pos);
                      }
                      let value;
                      if (eq === undefined) {
                        value = undefined;
                      } else {
                        const _Some = eq;
                        const _pos = _Some;
                        value = _M0MPC16string10StringView11sub_2einner(_x$4, _pos + 1 | 0, undefined);
                      }
                      if (_M0MPC16string6String24char__length__ge_2einner(name.str, 3, name.start, name.end)) {
                        const _x$5 = _M0MPC16string6String16unsafe__char__at(name.str, _M0MPC16string6String29offset__of__nth__char_2einner(name.str, 0, name.start, name.end));
                        if (_x$5 === 110) {
                          const _x$6 = _M0MPC16string6String16unsafe__char__at(name.str, _M0MPC16string6String29offset__of__nth__char_2einner(name.str, 1, name.start, name.end));
                          if (_x$6 === 111) {
                            const _x$7 = _M0MPC16string6String16unsafe__char__at(name.str, _M0MPC16string6String29offset__of__nth__char_2einner(name.str, 2, name.start, name.end));
                            if (_x$7 === 45) {
                              const _tmp$43 = name.str;
                              const _bind$13 = _M0MPC16string6String29offset__of__nth__char_2einner(name.str, 3, name.start, name.end);
                              let _tmp$44;
                              if (_bind$13 === undefined) {
                                _tmp$44 = name.end;
                              } else {
                                const _Some = _bind$13;
                                _tmp$44 = _Some;
                              }
                              const _x$8 = new _M0TPC16string10StringView(_tmp$43, _tmp$44, name.end);
                              const base_resolved = _M0FP218peter_2djerry_2dye11parse__args13parse_2einnerN14resolve__aliasS21(aliases, _x$8);
                              if (_M0MPC13set3Set8containsGRPC16string10StringViewE(negatable_set, new _M0TPC16string10StringView(base_resolved, 0, base_resolved.length))) {
                                _M0MPB3Map3setGsbE(flags_map, base_resolved, false);
                                continue;
                              }
                            }
                          }
                        }
                      }
                      const resolved = _M0FP218peter_2djerry_2dye11parse__args13parse_2einnerN14resolve__aliasS21(aliases, name);
                      if (_M0MPC13set3Set8containsGRPC16string10StringViewE(flag_set, new _M0TPC16string10StringView(resolved, 0, resolved.length))) {
                        _M0MPB3Map3setGsbE(flags_map, resolved, true);
                      } else {
                        if (_M0MPC13set3Set8containsGRPC16string10StringViewE(option_set, new _M0TPC16string10StringView(resolved, 0, resolved.length))) {
                          let value$2;
                          if (value === undefined) {
                            const _bind$13 = args$2;
                            if ((_bind$13.end - _bind$13.start | 0) >= 1) {
                              const _next_arg = _bind$13.buf[_bind$13.start];
                              const _x$5 = new _M0TPB9ArrayViewGsE(_bind$13.buf, 1 + _bind$13.start | 0, _bind$13.end);
                              args$2 = _x$5;
                              value$2 = new _M0TPC16string10StringView(_next_arg, 0, _next_arg.length);
                            } else {
                              return new _M0DTPC16result6ResultGRP218peter_2djerry_2dye11parse__args4ArgsRP218peter_2djerry_2dye11parse__args10ParseErrorE3Err(new _M0DTPC15error5Error58peter_2djerry_2dye_2fparse__args_2eParseError_2eParseError(`Option --${_M0IPC16string10StringViewPB4Show10to__string(name)} requires a value`));
                            }
                          } else {
                            const _Some = value;
                            value$2 = _Some;
                          }
                          _M0MPB3Map3setGssE(options_map, resolved, _M0MPC16string10StringView9to__owned(value$2));
                        } else {
                          if (_M0MPC13set3Set8containsGRPC16string10StringViewE(collection_set, new _M0TPC16string10StringView(resolved, 0, resolved.length))) {
                            let value$2;
                            if (value === undefined) {
                              const _bind$13 = args$2;
                              if ((_bind$13.end - _bind$13.start | 0) >= 1) {
                                const _next_arg = _bind$13.buf[_bind$13.start];
                                const _x$5 = new _M0TPB9ArrayViewGsE(_bind$13.buf, 1 + _bind$13.start | 0, _bind$13.end);
                                args$2 = _x$5;
                                value$2 = new _M0TPC16string10StringView(_next_arg, 0, _next_arg.length);
                              } else {
                                return new _M0DTPC16result6ResultGRP218peter_2djerry_2dye11parse__args4ArgsRP218peter_2djerry_2dye11parse__args10ParseErrorE3Err(new _M0DTPC15error5Error58peter_2djerry_2dye_2fparse__args_2eParseError_2eParseError(`Collection --${_M0IPC16string10StringViewPB4Show10to__string(name)} requires a value`));
                              }
                            } else {
                              const _Some = value;
                              value$2 = _Some;
                            }
                            const _bind$13 = _M0MPB3Map17get__from__stringGRPB5ArrayGsEE(collections_map, new _M0TPC16string10StringView(resolved, 0, resolved.length));
                            if (_bind$13.$tag === 1) {
                              const _Some = _bind$13;
                              const _arr = _Some._0;
                              _M0MPC15array5Array4pushGUssEE(_arr, _M0MPC16string10StringView9to__owned(value$2));
                            } else {
                              _M0MPB3Map3setGsRPB5ArrayGsEE(collections_map, resolved, [_M0MPC16string10StringView9to__owned(value$2)]);
                            }
                          } else {
                            _M0MPC15array5Array4pushGUssEE(positional, _arg);
                          }
                        }
                      }
                    } else {
                      break _L$2;
                    }
                  } else {
                    break _L$4;
                  }
                } else {
                  break _L$4;
                }
              } else {
                break _L$4;
              }
              break _L$3;
            }
            break _L$2;
          }
          break _L;
        }
        _L$3: {
          _L$4: {
            _L$5: {
              _L$6: {
                if (_M0MPC16string6String24char__length__ge_2einner(_arg, 1, 0, _arg.length)) {
                  const _x$2 = _arg.charCodeAt(0);
                  if (_x$2 === 45) {
                    const _bind$12 = _M0MPC16string6String29offset__of__nth__char_2einner(_arg, 1, 0, _arg.length);
                    let _bind$13;
                    if (_bind$12 === undefined) {
                      _bind$13 = _arg.length;
                    } else {
                      const _Some = _bind$12;
                      _bind$13 = _Some;
                    }
                    const _bind$14 = _arg.length;
                    const _x$3 = new _M0TPC16string10StringView(_arg, _bind$13, _bind$14);
                    if ((_x$3.end - _x$3.start | 0) > 0) {
                      let _tmp$42 = _bind$13;
                      while (true) {
                        const _param_start = _tmp$42;
                        if (_M0MPC16string6String24char__length__eq_2einner(_arg, 0, _param_start, _bind$14)) {
                          break;
                        } else {
                          if (_M0MPC16string6String24char__length__eq_2einner(_arg, 1, _param_start, _bind$14)) {
                            const _ch = _M0MPC16string6String16unsafe__char__at(_arg, _M0MPC16string6String29offset__of__nth__char_2einner(_arg, 0, _param_start, _bind$14));
                            const _bind$15 = _M0IPC14char4CharPB4Show10to__string(_ch);
                            const resolved = _M0FP218peter_2djerry_2dye11parse__args13parse_2einnerN14resolve__aliasS21(aliases, new _M0TPC16string10StringView(_bind$15, 0, _bind$15.length));
                            if (_M0MPC13set3Set8containsGRPC16string10StringViewE(flag_set, new _M0TPC16string10StringView(resolved, 0, resolved.length))) {
                              _M0MPB3Map3setGsbE(flags_map, resolved, true);
                              break;
                            } else {
                              if (_M0MPC13set3Set8containsGRPC16string10StringViewE(option_set, new _M0TPC16string10StringView(resolved, 0, resolved.length))) {
                                const _bind$16 = args$2;
                                if ((_bind$16.end - _bind$16.start | 0) >= 1) {
                                  const _next_arg = _bind$16.buf[_bind$16.start];
                                  const _x$4 = new _M0TPB9ArrayViewGsE(_bind$16.buf, 1 + _bind$16.start | 0, _bind$16.end);
                                  _M0MPB3Map3setGssE(options_map, resolved, _next_arg);
                                  args$2 = _x$4;
                                  break;
                                } else {
                                  return new _M0DTPC16result6ResultGRP218peter_2djerry_2dye11parse__args4ArgsRP218peter_2djerry_2dye11parse__args10ParseErrorE3Err(new _M0DTPC15error5Error58peter_2djerry_2dye_2fparse__args_2eParseError_2eParseError(`Option -${_M0IPC14char4CharPB4Show10to__string(_ch)} requires a value`));
                                }
                              } else {
                                if (_M0MPC13set3Set8containsGRPC16string10StringViewE(collection_set, new _M0TPC16string10StringView(resolved, 0, resolved.length))) {
                                  const _bind$16 = args$2;
                                  if ((_bind$16.end - _bind$16.start | 0) >= 1) {
                                    const _next_arg = _bind$16.buf[_bind$16.start];
                                    const _x$4 = new _M0TPB9ArrayViewGsE(_bind$16.buf, 1 + _bind$16.start | 0, _bind$16.end);
                                    const _bind$17 = _M0MPB3Map17get__from__stringGRPB5ArrayGsEE(collections_map, new _M0TPC16string10StringView(resolved, 0, resolved.length));
                                    if (_bind$17.$tag === 1) {
                                      const _Some = _bind$17;
                                      const _arr = _Some._0;
                                      _M0MPC15array5Array4pushGUssEE(_arr, _next_arg);
                                    } else {
                                      _M0MPB3Map3setGsRPB5ArrayGsEE(collections_map, resolved, [_next_arg]);
                                    }
                                    args$2 = _x$4;
                                    break;
                                  } else {
                                    return new _M0DTPC16result6ResultGRP218peter_2djerry_2dye11parse__args4ArgsRP218peter_2djerry_2dye11parse__args10ParseErrorE3Err(new _M0DTPC15error5Error58peter_2djerry_2dye_2fparse__args_2eParseError_2eParseError(`Collection -${_M0IPC14char4CharPB4Show10to__string(_ch)} requires a value`));
                                  }
                                } else {
                                  _M0MPC15array5Array4pushGUssEE(positional, _arg);
                                  break;
                                }
                              }
                            }
                          } else {
                            const _ch = _M0MPC16string6String16unsafe__char__at(_arg, _M0MPC16string6String29offset__of__nth__char_2einner(_arg, 0, _param_start, _bind$14));
                            const _bind$15 = _M0MPC16string6String29offset__of__nth__char_2einner(_arg, 1, _param_start, _bind$14);
                            let _bind$16;
                            if (_bind$15 === undefined) {
                              _bind$16 = _bind$14;
                            } else {
                              const _Some = _bind$15;
                              _bind$16 = _Some;
                            }
                            const _bind$17 = _M0IPC14char4CharPB4Show10to__string(_ch);
                            const resolved = _M0FP218peter_2djerry_2dye11parse__args13parse_2einnerN14resolve__aliasS21(aliases, new _M0TPC16string10StringView(_bind$17, 0, _bind$17.length));
                            if (_M0MPC13set3Set8containsGRPC16string10StringViewE(flag_set, new _M0TPC16string10StringView(resolved, 0, resolved.length))) {
                              _M0MPB3Map3setGsbE(flags_map, resolved, true);
                              _tmp$42 = _bind$16;
                              continue;
                            } else {
                              if (_M0MPC13set3Set8containsGRPC16string10StringViewE(option_set, new _M0TPC16string10StringView(resolved, 0, resolved.length))) {
                                return new _M0DTPC16result6ResultGRP218peter_2djerry_2dye11parse__args4ArgsRP218peter_2djerry_2dye11parse__args10ParseErrorE3Err(new _M0DTPC15error5Error58peter_2djerry_2dye_2fparse__args_2eParseError_2eParseError(`Option -${_M0IPC14char4CharPB4Show10to__string(_ch)} in combined short flags requires a value`));
                              } else {
                                if (_M0MPC13set3Set8containsGRPC16string10StringViewE(collection_set, new _M0TPC16string10StringView(resolved, 0, resolved.length))) {
                                  return new _M0DTPC16result6ResultGRP218peter_2djerry_2dye11parse__args4ArgsRP218peter_2djerry_2dye11parse__args10ParseErrorE3Err(new _M0DTPC15error5Error58peter_2djerry_2dye_2fparse__args_2eParseError_2eParseError(`Collection -${_M0IPC14char4CharPB4Show10to__string(_ch)} in combined short flags requires a value`));
                                } else {
                                  _M0MPC15array5Array4pushGUssEE(positional, _arg);
                                  break;
                                }
                              }
                            }
                          }
                        }
                      }
                    } else {
                      break _L$4;
                    }
                  } else {
                    break _L$6;
                  }
                } else {
                  break _L$6;
                }
                break _L$5;
              }
              break _L$4;
            }
            break _L$3;
          }
          _M0MPC15array5Array4pushGUssEE(positional, _arg);
        }
      }
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGRP218peter_2djerry_2dye11parse__args4ArgsRP218peter_2djerry_2dye11parse__args10ParseErrorE2Ok(new _M0TP218peter_2djerry_2dye11parse__args4Args(positional, flags_map, options_map, collections_map));
}
function _M0FP218peter_2djerry_2dye11parse__args5parse(args, flags$46$opt, options$46$opt, collections$46$opt, aliases$46$opt, negatable$46$opt, double_dash$46$opt, stop_early$46$opt) {
  let flags;
  if (flags$46$opt === undefined) {
    const _bind$4 = [];
    flags = new _M0TPB9ArrayViewGsE(_bind$4, 0, 0);
  } else {
    const _Some = flags$46$opt;
    flags = _Some;
  }
  let options;
  if (options$46$opt === undefined) {
    const _bind$4 = [];
    options = new _M0TPB9ArrayViewGsE(_bind$4, 0, 0);
  } else {
    const _Some = options$46$opt;
    options = _Some;
  }
  let collections;
  if (collections$46$opt === undefined) {
    const _bind$4 = [];
    collections = new _M0TPB9ArrayViewGsE(_bind$4, 0, 0);
  } else {
    const _Some = collections$46$opt;
    collections = _Some;
  }
  let aliases;
  if (aliases$46$opt === undefined) {
    const _bind$4 = [];
    aliases = _M0MPB3Map3MapGssE(new _M0TPB9ArrayViewGUssEE(_bind$4, 0, 0), undefined);
  } else {
    const _Some = aliases$46$opt;
    aliases = _Some;
  }
  let negatable;
  if (negatable$46$opt === undefined) {
    const _bind$4 = [];
    negatable = new _M0TPB9ArrayViewGsE(_bind$4, 0, 0);
  } else {
    const _Some = negatable$46$opt;
    negatable = _Some;
  }
  const double_dash = double_dash$46$opt === -1 ? true : double_dash$46$opt;
  const stop_early = stop_early$46$opt === -1 ? false : stop_early$46$opt;
  return _M0FP218peter_2djerry_2dye11parse__args13parse_2einner(args, flags, options, collections, aliases, negatable, double_dash, stop_early);
}
function _M0FP214shu_2dkitamura6sha2567padding(data) {
  const length = data.length;
  let n;
  let _tmp$38 = 1;
  while (true) {
    const _param = _tmp$38;
    if ((Math.imul(length, 8) | 0) < 1 << (Math.imul(8, _param) | 0)) {
      n = _param;
      break;
    } else {
      _tmp$38 = _param + 1 | 0;
      continue;
    }
  }
  const total_length = (length % 64 | 0) < 56 ? Math.imul((length / 64 | 0) + 1 | 0, 64) | 0 : Math.imul((length / 64 | 0) + 2 | 0, 64) | 0;
  const padded = _M0MPC15array5Array4makeGyE(total_length, 0 & 255);
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < length) {
      $bound_check(data, i);
      _M0MPC15array5Array3setGyE(padded, i, data[i]);
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MPC15array5Array3setGyE(padded, length, 128 & 255);
  const bit_length = Math.imul(length, 8) | 0;
  let _tmp$40 = 0;
  while (true) {
    const i = _tmp$40;
    if (i < n) {
      const shift = Math.imul((n - 1 | 0) - i | 0, 8) | 0;
      const value = bit_length >> shift & 255;
      _M0MPC15array5Array3setGyE(padded, (total_length - n | 0) + i | 0, value & 255);
      _tmp$40 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return padded;
}
function _M0FP214shu_2dkitamura6sha25618bytes__to__u32__be(data, offset) {
  const _p$4 = _M0MPC15array5Array2atGyE(data, offset);
  const b0 = _p$4;
  const _p$5 = _M0MPC15array5Array2atGyE(data, offset + 1 | 0);
  const b1 = _p$5;
  const _p$6 = _M0MPC15array5Array2atGyE(data, offset + 2 | 0);
  const b2 = _p$6;
  const _p$7 = _M0MPC15array5Array2atGyE(data, offset + 3 | 0);
  const b3 = _p$7;
  return b0 << 24 | b1 << 16 | b2 << 8 | b3;
}
function _M0FP214shu_2dkitamura6sha25610preprocess(input) {
  const padded = _M0FP214shu_2dkitamura6sha2567padding(input);
  const num_blocks = padded.length / 64 | 0;
  const blocks = _M0MPC15array5Array11new_2einnerGRPB5ArrayGsEE(0);
  let _tmp$38 = 0;
  while (true) {
    const block_index = _tmp$38;
    if (block_index < num_blocks) {
      const base = Math.imul(block_index, 64) | 0;
      const words = _M0MPC15array5Array4makeGjE(16, 0);
      let _tmp$39 = 0;
      while (true) {
        const t = _tmp$39;
        if (t < 16) {
          _M0MPC15array5Array3setGjE(words, t, _M0FP214shu_2dkitamura6sha25618bytes__to__u32__be(padded, base + (Math.imul(t, 4) | 0) | 0));
          _tmp$39 = t + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      _M0MPC15array5Array4pushGRPB5ArrayGsEE(blocks, words);
      _tmp$38 = block_index + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return blocks;
}
function _M0FP214shu_2dkitamura6sha25613lower__sigma0(word) {
  const _p$4 = 7;
  const _tmp$38 = word >>> _p$4 | word << (32 - _p$4 | 0);
  const _p$5 = 18;
  return _tmp$38 ^ (word >>> _p$5 | word << (32 - _p$5 | 0)) ^ (word >>> 3 | 0);
}
function _M0FP214shu_2dkitamura6sha25613lower__sigma1(word) {
  const _p$4 = 17;
  const _tmp$38 = word >>> _p$4 | word << (32 - _p$4 | 0);
  const _p$5 = 19;
  return _tmp$38 ^ (word >>> _p$5 | word << (32 - _p$5 | 0)) ^ (word >>> 10 | 0);
}
function _M0FP214shu_2dkitamura6sha25613upper__sigma0(word) {
  const _p$4 = 2;
  const _tmp$38 = word >>> _p$4 | word << (32 - _p$4 | 0);
  const _p$5 = 13;
  const _tmp$39 = _tmp$38 ^ (word >>> _p$5 | word << (32 - _p$5 | 0));
  const _p$6 = 22;
  return _tmp$39 ^ (word >>> _p$6 | word << (32 - _p$6 | 0));
}
function _M0FP214shu_2dkitamura6sha25613upper__sigma1(word) {
  const _p$4 = 6;
  const _tmp$38 = word >>> _p$4 | word << (32 - _p$4 | 0);
  const _p$5 = 11;
  const _tmp$39 = _tmp$38 ^ (word >>> _p$5 | word << (32 - _p$5 | 0));
  const _p$6 = 25;
  return _tmp$39 ^ (word >>> _p$6 | word << (32 - _p$6 | 0));
}
function _M0FP214shu_2dkitamura6sha25614write__u32__be(out, offset, word) {
  const _p$4 = word >>> 24 & 255;
  _M0MPC15array5Array3setGyE(out, offset, _p$4 & 255);
  const _tmp$38 = offset + 1 | 0;
  const _p$5 = word >>> 16 & 255;
  _M0MPC15array5Array3setGyE(out, _tmp$38, _p$5 & 255);
  const _tmp$39 = offset + 2 | 0;
  const _p$6 = word >>> 8 & 255;
  _M0MPC15array5Array3setGyE(out, _tmp$39, _p$6 & 255);
  const _tmp$40 = offset + 3 | 0;
  const _p$7 = word & 255;
  _M0MPC15array5Array3setGyE(out, _tmp$40, _p$7 & 255);
}
function _M0FP214shu_2dkitamura6sha25614bytes__to__hex(bytes) {
  let _tmp$38 = 0;
  let _tmp$39 = "";
  while (true) {
    const i = _tmp$38;
    const acc = _tmp$39;
    if (i < bytes.length) {
      _tmp$38 = i + 1 | 0;
      $bound_check(bytes, i);
      _tmp$39 = `${acc}${_M0MPC14byte4Byte7to__hex(bytes[i])}`;
      continue;
    } else {
      return acc;
    }
  }
}
function _M0FP214shu_2dkitamura6sha25613compute__hash(blocks) {
  const ws = _M0MPC15array5Array4makeGjE(64, 0);
  const h = [1779033703, -1150833019, 1013904242, -1521486534, 1359893119, -1694144372, 528734635, 1541459225];
  let _tmp$38 = 0;
  while (true) {
    const block_index = _tmp$38;
    if (block_index < blocks.length) {
      const block = _M0MPC15array5Array2atGRPB5ArrayGsEE(blocks, block_index);
      let _tmp$39 = 0;
      while (true) {
        const t = _tmp$39;
        if (t < 16) {
          _M0MPC15array5Array3setGjE(ws, t, _M0MPC15array5Array2atGjE(block, t));
          _tmp$39 = t + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      let _tmp$40 = 16;
      while (true) {
        const t = _tmp$40;
        if (t < 64) {
          _M0MPC15array5Array3setGjE(ws, t, (((((_M0FP214shu_2dkitamura6sha25613lower__sigma1(_M0MPC15array5Array2atGjE(ws, t - 2 | 0)) >>> 0) + (_M0MPC15array5Array2atGjE(ws, t - 7 | 0) >>> 0) | 0) >>> 0) + (_M0FP214shu_2dkitamura6sha25613lower__sigma0(_M0MPC15array5Array2atGjE(ws, t - 15 | 0)) >>> 0) | 0) >>> 0) + (_M0MPC15array5Array2atGjE(ws, t - 16 | 0) >>> 0) | 0);
          _tmp$40 = t + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      let _tmp$41 = 0;
      let _tmp$42 = _M0MPC15array5Array2atGjE(h, 0);
      let _tmp$43 = _M0MPC15array5Array2atGjE(h, 1);
      let _tmp$44 = _M0MPC15array5Array2atGjE(h, 2);
      let _tmp$45 = _M0MPC15array5Array2atGjE(h, 3);
      let _tmp$46 = _M0MPC15array5Array2atGjE(h, 4);
      let _tmp$47 = _M0MPC15array5Array2atGjE(h, 5);
      let _tmp$48 = _M0MPC15array5Array2atGjE(h, 6);
      let _tmp$49 = _M0MPC15array5Array2atGjE(h, 7);
      while (true) {
        const _param_0 = _tmp$41;
        const _param_1 = _tmp$42;
        const _param_2 = _tmp$43;
        const _param_3 = _tmp$44;
        const _param_4 = _tmp$45;
        const _param_5 = _tmp$46;
        const _param_6 = _tmp$47;
        const _param_7 = _tmp$48;
        const _param_8 = _tmp$49;
        if (_param_0 === 64) {
          _M0MPC15array5Array3setGjE(h, 0, (_M0MPC15array5Array2atGjE(h, 0) >>> 0) + (_param_1 >>> 0) | 0);
          _M0MPC15array5Array3setGjE(h, 1, (_M0MPC15array5Array2atGjE(h, 1) >>> 0) + (_param_2 >>> 0) | 0);
          _M0MPC15array5Array3setGjE(h, 2, (_M0MPC15array5Array2atGjE(h, 2) >>> 0) + (_param_3 >>> 0) | 0);
          _M0MPC15array5Array3setGjE(h, 3, (_M0MPC15array5Array2atGjE(h, 3) >>> 0) + (_param_4 >>> 0) | 0);
          _M0MPC15array5Array3setGjE(h, 4, (_M0MPC15array5Array2atGjE(h, 4) >>> 0) + (_param_5 >>> 0) | 0);
          _M0MPC15array5Array3setGjE(h, 5, (_M0MPC15array5Array2atGjE(h, 5) >>> 0) + (_param_6 >>> 0) | 0);
          _M0MPC15array5Array3setGjE(h, 6, (_M0MPC15array5Array2atGjE(h, 6) >>> 0) + (_param_7 >>> 0) | 0);
          _M0MPC15array5Array3setGjE(h, 7, (_M0MPC15array5Array2atGjE(h, 7) >>> 0) + (_param_8 >>> 0) | 0);
          break;
        } else {
          const _tmp$50 = (((_param_8 >>> 0) + (_M0FP214shu_2dkitamura6sha25613upper__sigma1(_param_5) >>> 0) | 0) >>> 0) + ((_param_5 & _param_6 ^ ~_param_5 & _param_7) >>> 0) | 0;
          $bound_check(_M0FP214shu_2dkitamura6sha2561k, _param_0);
          const t1 = (((_tmp$50 >>> 0) + (_M0FP214shu_2dkitamura6sha2561k[_param_0] >>> 0) | 0) >>> 0) + (_M0MPC15array5Array2atGjE(ws, _param_0) >>> 0) | 0;
          const t2 = (_M0FP214shu_2dkitamura6sha25613upper__sigma0(_param_1) >>> 0) + ((_param_1 & _param_2 ^ _param_1 & _param_3 ^ _param_2 & _param_3) >>> 0) | 0;
          _tmp$41 = _param_0 + 1 | 0;
          _tmp$42 = (t1 >>> 0) + (t2 >>> 0) | 0;
          _tmp$43 = _param_1;
          _tmp$44 = _param_2;
          _tmp$45 = _param_3;
          _tmp$46 = (_param_4 >>> 0) + (t1 >>> 0) | 0;
          _tmp$47 = _param_5;
          _tmp$48 = _param_6;
          _tmp$49 = _param_7;
          continue;
        }
      }
      _tmp$38 = block_index + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const out = _M0MPC15array5Array4makeGyE(32, 0 & 255);
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < 8) {
      _M0FP214shu_2dkitamura6sha25614write__u32__be(out, Math.imul(i, 4) | 0, _M0MPC15array5Array2atGjE(h, i));
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MPC15bytes5Bytes11from__array(new _M0TPB9ArrayViewGyE(out, 0, out.length));
}
function _M0FP214shu_2dkitamura6sha2566sha256(input) {
  return _M0FP214shu_2dkitamura6sha25613compute__hash(_M0FP214shu_2dkitamura6sha25610preprocess(input));
}
function _M0FP214shu_2dkitamura6sha25617sha256__hexdigest(input) {
  return _M0FP214shu_2dkitamura6sha25614bytes__to__hex(_M0FP214shu_2dkitamura6sha2566sha256(input));
}
function _M0FP410tonyfettes7unicode8internal4idna17find__idna__range(c) {
  const cp = c;
  let left = 0;
  let right = _M0FP410tonyfettes7unicode8internal4idna19idna__range__starts.length - 1 | 0;
  while (true) {
    if (left <= right) {
      const mid = (left + right | 0) / 2 | 0;
      $bound_check(_M0FP410tonyfettes7unicode8internal4idna19idna__range__starts, mid);
      const start = _M0FP410tonyfettes7unicode8internal4idna19idna__range__starts[mid];
      $bound_check(_M0FP410tonyfettes7unicode8internal4idna17idna__range__ends, mid);
      const end = _M0FP410tonyfettes7unicode8internal4idna17idna__range__ends[mid];
      if (cp < start) {
        right = mid - 1 | 0;
      } else {
        if (cp > end) {
          left = mid + 1 | 0;
        } else {
          return mid;
        }
      }
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410tonyfettes7unicode8internal4idna18status__from__code(code) {
  switch (code) {
    case 0: {
      return 0;
    }
    case 1: {
      return 1;
    }
    case 2: {
      return 2;
    }
    case 3: {
      return 3;
    }
    case 4: {
      return 4;
    }
    case 5: {
      return 5;
    }
    case 6: {
      return 6;
    }
    default: {
      return 4;
    }
  }
}
function _M0FP410tonyfettes7unicode8internal4idna21lookup__idna__mapping(c) {
  const idx = _M0FP410tonyfettes7unicode8internal4idna17find__idna__range(c);
  if (idx < 0) {
    return { _0: 4, _1: [] };
  }
  $bound_check(_M0FP410tonyfettes7unicode8internal4idna21idna__range__statuses, idx);
  const status = _M0FP410tonyfettes7unicode8internal4idna18status__from__code(_M0FP410tonyfettes7unicode8internal4idna21idna__range__statuses[idx]);
  $bound_check(_M0FP410tonyfettes7unicode8internal4idna21idna__mapping__starts, idx);
  const mapping_start = _M0FP410tonyfettes7unicode8internal4idna21idna__mapping__starts[idx];
  $bound_check(_M0FP410tonyfettes7unicode8internal4idna19idna__mapping__lens, idx);
  const mapping_len = _M0FP410tonyfettes7unicode8internal4idna19idna__mapping__lens[idx];
  const mapping = [];
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < mapping_len) {
      const _tmp$39 = mapping_start + i | 0;
      $bound_check(_M0FP410tonyfettes7unicode8internal4idna19idna__mapping__data, _tmp$39);
      _M0MPC15array5Array4pushGcE(mapping, _M0FP410tonyfettes7unicode8internal4idna19idna__mapping__data[_tmp$39]);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return { _0: status, _1: mapping };
}
function _M0FP410tonyfettes7unicode8internal4idna20find__joining__range(c) {
  const cp = c;
  let left = 0;
  let right = _M0FP410tonyfettes7unicode8internal4idna22joining__range__starts.length - 1 | 0;
  while (true) {
    if (left <= right) {
      const mid = (left + right | 0) / 2 | 0;
      $bound_check(_M0FP410tonyfettes7unicode8internal4idna22joining__range__starts, mid);
      const start = _M0FP410tonyfettes7unicode8internal4idna22joining__range__starts[mid];
      $bound_check(_M0FP410tonyfettes7unicode8internal4idna20joining__range__ends, mid);
      const end = _M0FP410tonyfettes7unicode8internal4idna20joining__range__ends[mid];
      if (cp < start) {
        right = mid - 1 | 0;
      } else {
        if (cp > end) {
          left = mid + 1 | 0;
        } else {
          return mid;
        }
      }
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410tonyfettes7unicode8internal4idna19joining__from__code(code) {
  switch (code) {
    case 0: {
      return 0;
    }
    case 1: {
      return 1;
    }
    case 2: {
      return 2;
    }
    case 3: {
      return 3;
    }
    case 4: {
      return 4;
    }
    default: {
      return 5;
    }
  }
}
function _M0FP410tonyfettes7unicode8internal4idna21lookup__joining__type(c) {
  const idx = _M0FP410tonyfettes7unicode8internal4idna20find__joining__range(c);
  if (idx < 0) {
    return 5;
  }
  $bound_check(_M0FP410tonyfettes7unicode8internal4idna21joining__range__types, idx);
  return _M0FP410tonyfettes7unicode8internal4idna19joining__from__code(_M0FP410tonyfettes7unicode8internal4idna21joining__range__types[idx]);
}
function _M0FP410tonyfettes7unicode8internal4idna17find__bidi__range(c) {
  const cp = c;
  let left = 0;
  let right = _M0FP410tonyfettes7unicode8internal4idna19bidi__range__starts.length - 1 | 0;
  while (true) {
    if (left <= right) {
      const mid = (left + right | 0) / 2 | 0;
      $bound_check(_M0FP410tonyfettes7unicode8internal4idna19bidi__range__starts, mid);
      const start = _M0FP410tonyfettes7unicode8internal4idna19bidi__range__starts[mid];
      $bound_check(_M0FP410tonyfettes7unicode8internal4idna17bidi__range__ends, mid);
      const end = _M0FP410tonyfettes7unicode8internal4idna17bidi__range__ends[mid];
      if (cp < start) {
        right = mid - 1 | 0;
      } else {
        if (cp > end) {
          left = mid + 1 | 0;
        } else {
          return mid;
        }
      }
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410tonyfettes7unicode8internal4idna16bidi__from__code(code) {
  switch (code) {
    case 0: {
      return 0;
    }
    case 1: {
      return 1;
    }
    case 2: {
      return 2;
    }
    case 3: {
      return 3;
    }
    case 4: {
      return 4;
    }
    case 5: {
      return 5;
    }
    case 6: {
      return 6;
    }
    case 7: {
      return 7;
    }
    case 8: {
      return 8;
    }
    case 9: {
      return 9;
    }
    case 10: {
      return 10;
    }
    default: {
      return 11;
    }
  }
}
function _M0FP410tonyfettes7unicode8internal4idna19lookup__bidi__class(c) {
  const idx = _M0FP410tonyfettes7unicode8internal4idna17find__bidi__range(c);
  if (idx < 0) {
    return 11;
  }
  $bound_check(_M0FP410tonyfettes7unicode8internal4idna20bidi__range__classes, idx);
  return _M0FP410tonyfettes7unicode8internal4idna16bidi__from__code(_M0FP410tonyfettes7unicode8internal4idna20bidi__range__classes[idx]);
}
function _M0FP410tonyfettes7unicode8internal3ucd19find__decomp__index(c) {
  const cp = c;
  let left = 0;
  let right = _M0FP410tonyfettes7unicode8internal3ucd11decomp__cps.length - 1 | 0;
  while (true) {
    if (left <= right) {
      const mid = (left + right | 0) / 2 | 0;
      $bound_check(_M0FP410tonyfettes7unicode8internal3ucd11decomp__cps, mid);
      const mid_cp = _M0FP410tonyfettes7unicode8internal3ucd11decomp__cps[mid];
      if (cp < mid_cp) {
        right = mid - 1 | 0;
      } else {
        if (cp > mid_cp) {
          left = mid + 1 | 0;
        } else {
          return mid;
        }
      }
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410tonyfettes7unicode8internal3ucd29get__canonical__decomposition(c) {
  const idx = _M0FP410tonyfettes7unicode8internal3ucd19find__decomp__index(c);
  if (idx < 0) {
    return _M0DTPC16option6OptionGRPB5ArrayGcEE4None__;
  }
  $bound_check(_M0FP410tonyfettes7unicode8internal3ucd23decomp__canonical__lens, idx);
  const len = _M0FP410tonyfettes7unicode8internal3ucd23decomp__canonical__lens[idx];
  if (len === 0) {
    return _M0DTPC16option6OptionGRPB5ArrayGcEE4None__;
  }
  $bound_check(_M0FP410tonyfettes7unicode8internal3ucd20decomp__data__starts, idx);
  const start = _M0FP410tonyfettes7unicode8internal3ucd20decomp__data__starts[idx];
  const result = [];
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < len) {
      const _tmp$39 = start + i | 0;
      $bound_check(_M0FP410tonyfettes7unicode8internal3ucd12decomp__data, _tmp$39);
      _M0MPC15array5Array4pushGcE(result, _M0FP410tonyfettes7unicode8internal3ucd12decomp__data[_tmp$39]);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16option6OptionGRPB5ArrayGcEE4Some(result);
}
function _M0FP410tonyfettes7unicode8internal3ucd26get__compat__decomposition(c) {
  const idx = _M0FP410tonyfettes7unicode8internal3ucd19find__decomp__index(c);
  if (idx < 0) {
    return _M0DTPC16option6OptionGRPB5ArrayGcEE4None__;
  }
  $bound_check(_M0FP410tonyfettes7unicode8internal3ucd20decomp__compat__lens, idx);
  const compat_len = _M0FP410tonyfettes7unicode8internal3ucd20decomp__compat__lens[idx];
  if (compat_len === 0) {
    return _M0DTPC16option6OptionGRPB5ArrayGcEE4None__;
  }
  $bound_check(_M0FP410tonyfettes7unicode8internal3ucd23decomp__canonical__lens, idx);
  const canonical_len = _M0FP410tonyfettes7unicode8internal3ucd23decomp__canonical__lens[idx];
  $bound_check(_M0FP410tonyfettes7unicode8internal3ucd20decomp__data__starts, idx);
  const start = _M0FP410tonyfettes7unicode8internal3ucd20decomp__data__starts[idx] + canonical_len | 0;
  const result = [];
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < compat_len) {
      const _tmp$39 = start + i | 0;
      $bound_check(_M0FP410tonyfettes7unicode8internal3ucd12decomp__data, _tmp$39);
      _M0MPC15array5Array4pushGcE(result, _M0FP410tonyfettes7unicode8internal3ucd12decomp__data[_tmp$39]);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16option6OptionGRPB5ArrayGcEE4Some(result);
}
function _M0FP410tonyfettes7unicode8internal3ucd19lookup__composition(starter, combining) {
  const starter_cp = starter;
  const combining_cp = combining;
  let left = 0;
  let right = _M0FP410tonyfettes7unicode8internal3ucd12comp__firsts.length - 1 | 0;
  while (true) {
    if (left <= right) {
      const mid = (left + right | 0) / 2 | 0;
      $bound_check(_M0FP410tonyfettes7unicode8internal3ucd12comp__firsts, mid);
      const mid_first = _M0FP410tonyfettes7unicode8internal3ucd12comp__firsts[mid];
      $bound_check(_M0FP410tonyfettes7unicode8internal3ucd13comp__seconds, mid);
      const mid_second = _M0FP410tonyfettes7unicode8internal3ucd13comp__seconds[mid];
      if (starter_cp < mid_first || starter_cp === mid_first && combining_cp < mid_second) {
        right = mid - 1 | 0;
      } else {
        if (starter_cp > mid_first || starter_cp === mid_first && combining_cp > mid_second) {
          left = mid + 1 | 0;
        } else {
          $bound_check(_M0FP410tonyfettes7unicode8internal3ucd13comp__results, mid);
          return _M0FP410tonyfettes7unicode8internal3ucd13comp__results[mid];
        }
      }
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410tonyfettes7unicode8internal3ucd11lookup__ccc(c) {
  const cp = c;
  let left = 0;
  let right = _M0FP410tonyfettes7unicode8internal3ucd11ccc__starts.length - 1 | 0;
  while (true) {
    if (left <= right) {
      const mid = (left + right | 0) / 2 | 0;
      $bound_check(_M0FP410tonyfettes7unicode8internal3ucd11ccc__starts, mid);
      const start = _M0FP410tonyfettes7unicode8internal3ucd11ccc__starts[mid];
      $bound_check(_M0FP410tonyfettes7unicode8internal3ucd9ccc__ends, mid);
      const end = _M0FP410tonyfettes7unicode8internal3ucd9ccc__ends[mid];
      if (cp < start) {
        right = mid - 1 | 0;
      } else {
        if (cp > end) {
          left = mid + 1 | 0;
        } else {
          $bound_check(_M0FP410tonyfettes7unicode8internal3ucd11ccc__values, mid);
          return _M0FP410tonyfettes7unicode8internal3ucd11ccc__values[mid];
        }
      }
      continue;
    } else {
      break;
    }
  }
  return 0;
}
function _M0FP410tonyfettes7unicode8internal3ucd8is__mark(c) {
  const cp = c;
  let left = 0;
  let right = _M0FP410tonyfettes7unicode8internal3ucd12mark__starts.length - 1 | 0;
  while (true) {
    if (left <= right) {
      const mid = (left + right | 0) / 2 | 0;
      $bound_check(_M0FP410tonyfettes7unicode8internal3ucd12mark__starts, mid);
      const start = _M0FP410tonyfettes7unicode8internal3ucd12mark__starts[mid];
      $bound_check(_M0FP410tonyfettes7unicode8internal3ucd10mark__ends, mid);
      const end = _M0FP410tonyfettes7unicode8internal3ucd10mark__ends[mid];
      if (cp < start) {
        right = mid - 1 | 0;
      } else {
        if (cp > end) {
          left = mid + 1 | 0;
        } else {
          return true;
        }
      }
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP310tonyfettes7unicode13normalization17chars__to__string(chars) {
  const sb = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _bind$4 = chars.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const c = chars[_];
      _M0IPB13StringBuilderPB6Logger11write__char(sb, c);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return sb.val;
}
function _M0FP310tonyfettes7unicode13normalization21stable__sort__by__ccc(arr, start, end) {
  let i = start + 1 | 0;
  while (true) {
    if (i < end) {
      const key = _M0MPC15array5Array2atGcE(arr, i);
      const key_ccc = _M0FP410tonyfettes7unicode8internal3ucd11lookup__ccc(key);
      let j = i - 1 | 0;
      while (true) {
        if (j >= start && _M0FP410tonyfettes7unicode8internal3ucd11lookup__ccc(_M0MPC15array5Array2atGcE(arr, j)) > key_ccc) {
          _M0MPC15array5Array3setGcE(arr, j + 1 | 0, _M0MPC15array5Array2atGcE(arr, j));
          j = j - 1 | 0;
          continue;
        } else {
          break;
        }
      }
      _M0MPC15array5Array3setGcE(arr, j + 1 | 0, key);
      i = i + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0FP310tonyfettes7unicode13normalization16canonical__order(chars) {
  const len = chars.length;
  if (len < 2) {
    return undefined;
  }
  let i = 0;
  while (true) {
    if (i < len) {
      const ccc = _M0FP410tonyfettes7unicode8internal3ucd11lookup__ccc(_M0MPC15array5Array2atGcE(chars, i));
      if (ccc === 0) {
        i = i + 1 | 0;
        continue;
      }
      const start = i;
      while (true) {
        if (i < len && _M0FP410tonyfettes7unicode8internal3ucd11lookup__ccc(_M0MPC15array5Array2atGcE(chars, i)) !== 0) {
          i = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      if (i > (start + 1 | 0)) {
        _M0FP310tonyfettes7unicode13normalization21stable__sort__by__ccc(chars, start, i);
      }
      continue;
    } else {
      return;
    }
  }
}
function _M0FP310tonyfettes7unicode13normalization17decompose__hangul(syllable) {
  const s_index = syllable - 44032 | 0;
  const l = 4352 + (s_index / 588 | 0) | 0;
  const v = 4449 + ((s_index % 588 | 0) / 28 | 0) | 0;
  const t_index = s_index % 28 | 0;
  return t_index === 0 ? [l, v] : [l, v, 4519 + t_index | 0];
}
function _M0FP310tonyfettes7unicode13normalization15decompose__char(c, compatibility) {
  const _p$4 = c;
  if (_p$4 >= 44032 && _p$4 < 55204) {
    return _M0FP310tonyfettes7unicode13normalization17decompose__hangul(c);
  }
  let mapping;
  if (compatibility) {
    const _bind$4 = _M0FP410tonyfettes7unicode8internal3ucd26get__compat__decomposition(c);
    if (_bind$4.$tag === 1) {
      const _Some = _bind$4;
      const _d = _Some._0;
      mapping = new _M0DTPC16option6OptionGRPB5ArrayGcEE4Some(_d);
    } else {
      mapping = _M0FP410tonyfettes7unicode8internal3ucd29get__canonical__decomposition(c);
    }
  } else {
    mapping = _M0FP410tonyfettes7unicode8internal3ucd29get__canonical__decomposition(c);
  }
  if (mapping.$tag === 0) {
    return [c];
  } else {
    const _Some = mapping;
    const _decomposed = _Some._0;
    const result = [];
    const _bind$4 = _decomposed.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$4) {
        const d = _decomposed[_];
        const _bind$5 = _M0FP310tonyfettes7unicode13normalization15decompose__char(d, compatibility);
        _M0MPC15array5Array6appendGcE(result, new _M0TPB9ArrayViewGcE(_bind$5, 0, _bind$5.length));
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return result;
  }
}
function _M0FP310tonyfettes7unicode13normalization17decompose__string(s, compatibility) {
  const result = [];
  const _it = _M0MPC16string6String4iter(s);
  while (true) {
    const _bind$4 = _M0MPB4Iter4nextGcE(_it);
    if (_bind$4 === -1) {
      break;
    } else {
      const _Some = _bind$4;
      const _c = _Some;
      const _bind$5 = _M0FP310tonyfettes7unicode13normalization15decompose__char(_c, compatibility);
      _M0MPC15array5Array6appendGcE(result, new _M0TPB9ArrayViewGcE(_bind$5, 0, _bind$5.length));
      continue;
    }
  }
  return result;
}
function _M0FP310tonyfettes7unicode13normalization3nfd(s) {
  const chars = _M0FP310tonyfettes7unicode13normalization17decompose__string(s, false);
  _M0FP310tonyfettes7unicode13normalization16canonical__order(chars);
  return _M0FP310tonyfettes7unicode13normalization17chars__to__string(chars);
}
function _M0FP310tonyfettes7unicode13normalization14is__hangul__lv(c) {
  const _p$4 = c;
  if (!(_p$4 >= 44032 && _p$4 < 55204)) {
    return false;
  }
  return ((c - 44032 | 0) % 28 | 0) === 0;
}
function _M0FP310tonyfettes7unicode13normalization20try__compose__hangul(first, second) {
  let _tmp$38;
  const _p$4 = first;
  if (_p$4 >= 4352 && _p$4 < 4371) {
    const _p$5 = second;
    _tmp$38 = _p$5 >= 4449 && _p$5 < 4470;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    const l_index = first - 4352 | 0;
    const v_index = second - 4449 | 0;
    return 44032 + (Math.imul((Math.imul(l_index, 21) | 0) + v_index | 0, 28) | 0) | 0;
  }
  let _tmp$39;
  if (_M0FP310tonyfettes7unicode13normalization14is__hangul__lv(first)) {
    const _p$5 = second;
    _tmp$39 = _p$5 > 4519 && _p$5 < 4547;
  } else {
    _tmp$39 = false;
  }
  if (_tmp$39) {
    return first + (second - 4519 | 0) | 0;
  }
  return -1;
}
function _M0FP310tonyfettes7unicode13normalization12try__compose(first, second) {
  const _bind$4 = _M0FP310tonyfettes7unicode13normalization20try__compose__hangul(first, second);
  if (_bind$4 === -1) {
  } else {
    const _Some = _bind$4;
    const _h = _Some;
    return _h;
  }
  return _M0FP410tonyfettes7unicode8internal3ucd19lookup__composition(first, second);
}
function _M0FP310tonyfettes7unicode13normalization18canonical__compose(chars) {
  const len = chars.length;
  if (len === 0) {
    return [];
  }
  const result = [];
  _M0MPC15array5Array4pushGcE(result, _M0MPC15array5Array2atGcE(chars, 0));
  let last_starter_idx = _M0FP410tonyfettes7unicode8internal3ucd11lookup__ccc(_M0MPC15array5Array2atGcE(chars, 0)) === 0 ? 0 : -1;
  let last_ccc = _M0FP410tonyfettes7unicode8internal3ucd11lookup__ccc(_M0MPC15array5Array2atGcE(chars, 0));
  let _tmp$38 = 1;
  while (true) {
    const i = _tmp$38;
    if (i < len) {
      const c = _M0MPC15array5Array2atGcE(chars, i);
      const ccc = _M0FP410tonyfettes7unicode8internal3ucd11lookup__ccc(c);
      const not_blocked = last_ccc === 0 || ccc !== 0 && last_ccc < ccc;
      if (last_starter_idx >= 0 && not_blocked) {
        const starter = _M0MPC15array5Array2atGcE(result, last_starter_idx);
        const _bind$4 = _M0FP310tonyfettes7unicode13normalization12try__compose(starter, c);
        if (_bind$4 === -1) {
        } else {
          const _Some = _bind$4;
          const _composed = _Some;
          _M0MPC15array5Array3setGcE(result, last_starter_idx, _composed);
          _tmp$38 = i + 1 | 0;
          continue;
        }
      }
      _M0MPC15array5Array4pushGcE(result, c);
      if (ccc === 0) {
        last_starter_idx = result.length - 1 | 0;
        last_ccc = 0;
      } else {
        last_ccc = ccc;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return result;
}
function _M0FP310tonyfettes7unicode13normalization3nfc(s) {
  const chars = _M0FP310tonyfettes7unicode13normalization17decompose__string(s, false);
  _M0FP310tonyfettes7unicode13normalization16canonical__order(chars);
  const composed = _M0FP310tonyfettes7unicode13normalization18canonical__compose(chars);
  return _M0FP310tonyfettes7unicode13normalization17chars__to__string(composed);
}
function _M0FP310tonyfettes7unicode13normalization4nfkd(s) {
  const chars = _M0FP310tonyfettes7unicode13normalization17decompose__string(s, true);
  _M0FP310tonyfettes7unicode13normalization16canonical__order(chars);
  return _M0FP310tonyfettes7unicode13normalization17chars__to__string(chars);
}
function _M0FP310tonyfettes7unicode13normalization4nfkc(s) {
  const chars = _M0FP310tonyfettes7unicode13normalization17decompose__string(s, true);
  _M0FP310tonyfettes7unicode13normalization16canonical__order(chars);
  const composed = _M0FP310tonyfettes7unicode13normalization18canonical__compose(chars);
  return _M0FP310tonyfettes7unicode13normalization17chars__to__string(composed);
}
function _M0FP310tonyfettes7unicode13normalization9normalize(s, form) {
  switch (form) {
    case 0: {
      return _M0FP310tonyfettes7unicode13normalization3nfd(s);
    }
    case 1: {
      return _M0FP310tonyfettes7unicode13normalization3nfc(s);
    }
    case 2: {
      return _M0FP310tonyfettes7unicode13normalization4nfkd(s);
    }
    default: {
      return _M0FP310tonyfettes7unicode13normalization4nfkc(s);
    }
  }
}
function _M0FP310tonyfettes7unicode13normalization14is__normalized(s, form) {
  return _M0FP310tonyfettes7unicode13normalization9normalize(s, form) === s;
}
function _M0IP310tonyfettes7unicode8punycode13PunycodeErrorPB4Show6output(_x_51, _x_52) {
  switch (_x_51.$tag) {
    case 3: {
      _x_52.method_table.method_0(_x_52.self, "Overflow");
      return;
    }
    case 2: {
      _x_52.method_table.method_0(_x_52.self, "InvalidInput");
      return;
    }
    default: {
      _x_52.method_table.method_0(_x_52.self, "BadInput");
      return;
    }
  }
}
function _M0FP310tonyfettes7unicode8punycode5adapt(delta, numpoints, firsttime) {
  let delta$2 = delta;
  if (firsttime) {
    delta$2 = delta$2 / 700 | 0;
  } else {
    delta$2 = delta$2 / 2 | 0;
  }
  delta$2 = delta$2 + (delta$2 / numpoints | 0) | 0;
  let k = 0;
  while (true) {
    if (delta$2 > 455) {
      delta$2 = delta$2 / 35 | 0;
      k = k + 36 | 0;
      continue;
    } else {
      break;
    }
  }
  return k + ((Math.imul(36, delta$2) | 0) / (delta$2 + 38 | 0) | 0) | 0;
}
function _M0FP310tonyfettes7unicode8punycode13encode__digit(d) {
  return d < 26 ? d + 97 | 0 : (d - 26 | 0) + 48 | 0;
}
function _M0FP310tonyfettes7unicode8punycode13decode__digit(cp) {
  return cp >= 97 && cp <= 122 ? cp - 97 | 0 : cp >= 65 && cp <= 90 ? cp - 65 | 0 : cp >= 48 && cp <= 57 ? (cp - 48 | 0) + 26 | 0 : 36;
}
function _M0FP310tonyfettes7unicode8punycode6encode(input) {
  const output = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const chars = [];
  const _it = _M0MPC16string6String4iter(input);
  while (true) {
    const _bind$4 = _M0MPB4Iter4nextGcE(_it);
    if (_bind$4 === -1) {
      break;
    } else {
      const _Some = _bind$4;
      const _c = _Some;
      _M0MPC15array5Array4pushGcE(chars, _c);
      continue;
    }
  }
  let basic_count = 0;
  const _bind$4 = chars.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const c = chars[_];
      if (c < 128) {
        _M0IPB13StringBuilderPB6Logger11write__char(output, c);
        basic_count = basic_count + 1 | 0;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const handled = basic_count;
  if (basic_count > 0) {
    _M0IPB13StringBuilderPB6Logger11write__char(output, 45);
  }
  let n = 128;
  let delta = 0;
  let bias = 72;
  let handled$2 = handled;
  while (true) {
    if (handled$2 < chars.length) {
      let m = 1114112;
      const _bind$5 = chars.length;
      let _tmp$39 = 0;
      while (true) {
        const _ = _tmp$39;
        if (_ < _bind$5) {
          const c = chars[_];
          const cp = c;
          if (cp >= n && cp < m) {
            m = cp;
          }
          _tmp$39 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      const delta_increment = Math.imul(m - n | 0, handled$2 + 1 | 0) | 0;
      if (delta > (2147483647 - delta_increment | 0)) {
        return new _M0DTPC16result6ResultGsRP310tonyfettes7unicode8punycode13PunycodeErrorE3Err(_M0DTPC15error5Error58tonyfettes_2funicode_2fpunycode_2ePunycodeError_2eOverflow__);
      }
      delta = delta + delta_increment | 0;
      n = m;
      const _bind$6 = chars.length;
      let _tmp$40 = 0;
      while (true) {
        const _ = _tmp$40;
        if (_ < _bind$6) {
          const c = chars[_];
          const cp = c;
          if (cp < n) {
            delta = delta + 1 | 0;
            if (delta === 0) {
              return new _M0DTPC16result6ResultGsRP310tonyfettes7unicode8punycode13PunycodeErrorE3Err(_M0DTPC15error5Error58tonyfettes_2funicode_2fpunycode_2ePunycodeError_2eOverflow__);
            }
          } else {
            if (cp === n) {
              let q = delta;
              let k = 36;
              while (true) {
                const t = k <= bias ? 1 : k >= (bias + 26 | 0) ? 26 : k - bias | 0;
                if (q < t) {
                  break;
                }
                _M0IPB13StringBuilderPB6Logger11write__char(output, _M0FP310tonyfettes7unicode8punycode13encode__digit(t + ((q - t | 0) % (36 - t | 0) | 0) | 0));
                q = (q - t | 0) / (36 - t | 0) | 0;
                k = k + 36 | 0;
                continue;
              }
              _M0IPB13StringBuilderPB6Logger11write__char(output, _M0FP310tonyfettes7unicode8punycode13encode__digit(q));
              bias = _M0FP310tonyfettes7unicode8punycode5adapt(delta, handled$2 + 1 | 0, handled$2 === basic_count);
              delta = 0;
              handled$2 = handled$2 + 1 | 0;
            }
          }
          _tmp$40 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      delta = delta + 1 | 0;
      n = n + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGsRP310tonyfettes7unicode8punycode13PunycodeErrorE2Ok(output.val);
}
function _M0FP310tonyfettes7unicode8punycode17chars__to__string(chars) {
  const sb = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _bind$4 = chars.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const c = chars[_];
      _M0IPB13StringBuilderPB6Logger11write__char(sb, c);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return sb.val;
}
function _M0FP310tonyfettes7unicode8punycode6decode(input) {
  const output = [];
  let basic_end = -1;
  let i = 0;
  const _it = _M0MPC16string6String4iter(input);
  while (true) {
    const _bind$4 = _M0MPB4Iter4nextGcE(_it);
    if (_bind$4 === -1) {
      break;
    } else {
      const _Some = _bind$4;
      const _c = _Some;
      if (_c === 45) {
        basic_end = i;
      }
      i = i + 1 | 0;
      continue;
    }
  }
  if (basic_end > 0) {
    let j = 0;
    const _it$2 = _M0MPC16string6String4iter(input);
    while (true) {
      const _bind$4 = _M0MPB4Iter4nextGcE(_it$2);
      if (_bind$4 === -1) {
        break;
      } else {
        const _Some = _bind$4;
        const _c = _Some;
        if (j >= basic_end) {
          break;
        }
        if (!(_c < 128)) {
          return new _M0DTPC16result6ResultGsRP310tonyfettes7unicode8punycode13PunycodeErrorE3Err(_M0DTPC15error5Error58tonyfettes_2funicode_2fpunycode_2ePunycodeError_2eBadInput__);
        }
        _M0MPC15array5Array4pushGcE(output, _c);
        j = j + 1 | 0;
        continue;
      }
    }
  }
  let n = 128;
  let i_val = 0;
  let bias = 72;
  let in_pos = basic_end >= 0 ? basic_end + 1 | 0 : 0;
  const input_chars = [];
  const _it$2 = _M0MPC16string6String4iter(input);
  while (true) {
    const _bind$4 = _M0MPB4Iter4nextGcE(_it$2);
    if (_bind$4 === -1) {
      break;
    } else {
      const _Some = _bind$4;
      const _c = _Some;
      _M0MPC15array5Array4pushGcE(input_chars, _c);
      continue;
    }
  }
  while (true) {
    if (in_pos < input_chars.length) {
      const oldi = i_val;
      let w = 1;
      let k = 36;
      while (true) {
        if (in_pos >= input_chars.length) {
          return new _M0DTPC16result6ResultGsRP310tonyfettes7unicode8punycode13PunycodeErrorE3Err(_M0DTPC15error5Error58tonyfettes_2funicode_2fpunycode_2ePunycodeError_2eBadInput__);
        }
        const digit = _M0FP310tonyfettes7unicode8punycode13decode__digit(_M0MPC15array5Array2atGcE(input_chars, in_pos));
        in_pos = in_pos + 1 | 0;
        if (digit >= 36) {
          return new _M0DTPC16result6ResultGsRP310tonyfettes7unicode8punycode13PunycodeErrorE3Err(_M0DTPC15error5Error58tonyfettes_2funicode_2fpunycode_2ePunycodeError_2eBadInput__);
        }
        if (digit > ((2147483647 - i_val | 0) / w | 0)) {
          return new _M0DTPC16result6ResultGsRP310tonyfettes7unicode8punycode13PunycodeErrorE3Err(_M0DTPC15error5Error58tonyfettes_2funicode_2fpunycode_2ePunycodeError_2eOverflow__);
        }
        i_val = i_val + (Math.imul(digit, w) | 0) | 0;
        const t = k <= bias ? 1 : k >= (bias + 26 | 0) ? 26 : k - bias | 0;
        if (digit < t) {
          break;
        }
        if (w > (2147483647 / (36 - t | 0) | 0)) {
          return new _M0DTPC16result6ResultGsRP310tonyfettes7unicode8punycode13PunycodeErrorE3Err(_M0DTPC15error5Error58tonyfettes_2funicode_2fpunycode_2ePunycodeError_2eOverflow__);
        }
        w = Math.imul(w, 36 - t | 0) | 0;
        k = k + 36 | 0;
        continue;
      }
      const out_len = output.length + 1 | 0;
      bias = _M0FP310tonyfettes7unicode8punycode5adapt(i_val - oldi | 0, out_len, oldi === 0);
      if ((i_val / out_len | 0) > (2147483647 - n | 0)) {
        return new _M0DTPC16result6ResultGsRP310tonyfettes7unicode8punycode13PunycodeErrorE3Err(_M0DTPC15error5Error58tonyfettes_2funicode_2fpunycode_2ePunycodeError_2eOverflow__);
      }
      n = n + (i_val / out_len | 0) | 0;
      i_val = i_val % out_len | 0;
      _M0MPC15array5Array6insertGcE(output, i_val, n);
      i_val = i_val + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGsRP310tonyfettes7unicode8punycode13PunycodeErrorE2Ok(_M0FP310tonyfettes7unicode8punycode17chars__to__string(output));
}
function _M0IP310tonyfettes7unicode4idna9IdnaErrorPB4Show6output(_x_158, _x_159) {
  switch (_x_158.$tag) {
    case 55: {
      const _PunycodeError = _x_158;
      const _$42$arg_160 = _PunycodeError._0;
      _x_159.method_table.method_0(_x_159.self, "PunycodeError(");
      _M0MPB6Logger13write__objectGRP310tonyfettes7unicode8punycode13PunycodeErrorE(_x_159, _$42$arg_160);
      _x_159.method_table.method_0(_x_159.self, ")");
      return;
    }
    case 54: {
      const _DisallowedCodePoint = _x_158;
      const _$42$arg_161 = _DisallowedCodePoint._0;
      _x_159.method_table.method_0(_x_159.self, "DisallowedCodePoint(");
      _x_159.method_table.method_0(_x_159.self, "cp=");
      _M0MPB6Logger13write__objectGiE(_x_159, _$42$arg_161);
      _x_159.method_table.method_0(_x_159.self, ")");
      return;
    }
    case 53: {
      const _InvalidLabel = _x_158;
      const _$42$arg_162 = _InvalidLabel._0;
      _x_159.method_table.method_0(_x_159.self, "InvalidLabel(");
      _M0MPB6Logger13write__objectGsE(_x_159, _$42$arg_162);
      _x_159.method_table.method_0(_x_159.self, ")");
      return;
    }
    case 52: {
      _x_159.method_table.method_0(_x_159.self, "InvalidHyphen");
      return;
    }
    case 51: {
      _x_159.method_table.method_0(_x_159.self, "LabelTooLong");
      return;
    }
    case 50: {
      _x_159.method_table.method_0(_x_159.self, "DomainTooLong");
      return;
    }
    case 49: {
      _x_159.method_table.method_0(_x_159.self, "EmptyLabel");
      return;
    }
    case 48: {
      _x_159.method_table.method_0(_x_159.self, "InvalidBidi");
      return;
    }
    case 47: {
      _x_159.method_table.method_0(_x_159.self, "InvalidJoiner");
      return;
    }
    case 46: {
      _x_159.method_table.method_0(_x_159.self, "InvalidAcePrefix");
      return;
    }
    default: {
      _x_159.method_table.method_0(_x_159.self, "LeadingCombiningMark");
      return;
    }
  }
}
function _M0FP310tonyfettes7unicode4idna19is__combining__mark(c) {
  return _M0FP410tonyfettes7unicode8internal3ucd8is__mark(c);
}
function _M0FP310tonyfettes7unicode4idna16label__to__chars(label) {
  const result = [];
  const _it = _M0MPC16string6String4iter(label);
  while (true) {
    const _bind$4 = _M0MPB4Iter4nextGcE(_it);
    if (_bind$4 === -1) {
      break;
    } else {
      const _Some = _bind$4;
      const _c = _Some;
      _M0MPC15array5Array4pushGcE(result, _c);
      continue;
    }
  }
  return result;
}
function _M0FP310tonyfettes7unicode4idna21is__rtl__label__check(chars) {
  const _bind$4 = chars.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const c = chars[_];
      _L: {
        const bc = _M0FP410tonyfettes7unicode8internal4idna19lookup__bidi__class(c);
        _L$2: {
          switch (bc) {
            case 1: {
              break _L$2;
            }
            case 2: {
              break _L$2;
            }
            case 3: {
              break _L$2;
            }
            default: {
              break _L;
            }
          }
        }
        return true;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP310tonyfettes7unicode4idna20validate__ltr__label(chars) {
  if (chars.length === 0) {
    return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(undefined);
  }
  const first_bc = _M0FP410tonyfettes7unicode8internal4idna19lookup__bidi__class(_M0MPC15array5Array2atGcE(chars, 0));
  switch (first_bc) {
    case 0: {
      break;
    }
    case 4: {
      break;
    }
    case 5: {
      break;
    }
    case 6: {
      break;
    }
    case 7: {
      break;
    }
    case 8: {
      break;
    }
    case 9: {
      break;
    }
    case 10: {
      break;
    }
    default: {
      return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(_M0DTPC15error5Error53tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidBidi__);
    }
  }
  let last_non_nsm_bc = first_bc;
  const _bind$4 = chars.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const c = chars[_];
      const bc = _M0FP410tonyfettes7unicode8internal4idna19lookup__bidi__class(c);
      _L: {
        _L$2: {
          _L$3: {
            _L$4: {
              switch (bc) {
                case 0: {
                  break _L$4;
                }
                case 4: {
                  break _L$4;
                }
                case 5: {
                  break _L$4;
                }
                case 6: {
                  break _L$4;
                }
                case 7: {
                  break _L$4;
                }
                case 8: {
                  break _L$4;
                }
                case 9: {
                  break _L$4;
                }
                case 10: {
                  break _L$4;
                }
                case 1: {
                  break _L$2;
                }
                case 2: {
                  break _L$2;
                }
                case 3: {
                  break _L$2;
                }
              }
              break _L$3;
            }
            let _tmp$39;
            if (bc === 10) {
              _tmp$39 = true;
            } else {
              _tmp$39 = false;
            }
            if (!_tmp$39) {
              last_non_nsm_bc = bc;
            }
          }
          break _L;
        }
        return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(_M0DTPC15error5Error53tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidBidi__);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$5 = last_non_nsm_bc;
  switch (_bind$5) {
    case 0: {
      return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(undefined);
    }
    case 4: {
      return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(undefined);
    }
    default: {
      return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(_M0DTPC15error5Error53tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidBidi__);
    }
  }
}
function _M0FP310tonyfettes7unicode4idna20validate__rtl__label(chars) {
  const first_bc = _M0FP410tonyfettes7unicode8internal4idna19lookup__bidi__class(_M0MPC15array5Array2atGcE(chars, 0));
  switch (first_bc) {
    case 1: {
      break;
    }
    case 2: {
      break;
    }
    default: {
      return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(_M0DTPC15error5Error53tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidBidi__);
    }
  }
  let last_non_nsm_bc = first_bc;
  let has_en = false;
  let has_an = false;
  const _bind$4 = chars.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const c = chars[_];
      const bc = _M0FP410tonyfettes7unicode8internal4idna19lookup__bidi__class(c);
      _L: {
        _L$2: {
          switch (bc) {
            case 1: {
              break _L$2;
            }
            case 2: {
              break _L$2;
            }
            case 3: {
              break _L$2;
            }
            case 4: {
              break _L$2;
            }
            case 5: {
              break _L$2;
            }
            case 6: {
              break _L$2;
            }
            case 7: {
              break _L$2;
            }
            case 8: {
              break _L$2;
            }
            case 9: {
              break _L$2;
            }
            case 10: {
              break _L$2;
            }
            case 0: {
              return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(_M0DTPC15error5Error53tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidBidi__);
            }
          }
          break _L;
        }
        let _tmp$39;
        if (bc === 10) {
          _tmp$39 = true;
        } else {
          _tmp$39 = false;
        }
        if (!_tmp$39) {
          last_non_nsm_bc = bc;
        }
        if (bc === 4) {
          has_en = true;
        }
        if (bc === 3) {
          has_an = true;
        }
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$5 = last_non_nsm_bc;
  switch (_bind$5) {
    case 1: {
      break;
    }
    case 2: {
      break;
    }
    case 4: {
      break;
    }
    case 3: {
      break;
    }
    default: {
      return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(_M0DTPC15error5Error53tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidBidi__);
    }
  }
  if (has_en && has_an) {
    return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(_M0DTPC15error5Error53tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidBidi__);
  } else {
    return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(undefined);
  }
}
function _M0FP310tonyfettes7unicode4idna14validate__bidi(chars) {
  if (chars.length === 0) {
    return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(undefined);
  }
  const is_rtl_label = _M0FP310tonyfettes7unicode4idna21is__rtl__label__check(chars);
  return is_rtl_label ? _M0FP310tonyfettes7unicode4idna20validate__rtl__label(chars) : _M0FP310tonyfettes7unicode4idna20validate__ltr__label(chars);
}
function _M0FP310tonyfettes7unicode4idna14is__ldh__ascii(c) {
  return c >= 97 && c <= 122 || (c >= 65 && c <= 90 || (c >= 48 && c <= 57 || c === 45));
}
function _M0FP310tonyfettes7unicode4idna22validate__char__status(c, use_std3_ascii_rules) {
  if (use_std3_ascii_rules && (c < 128 && !_M0FP310tonyfettes7unicode4idna14is__ldh__ascii(c))) {
    return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(new _M0DTPC15error5Error61tonyfettes_2funicode_2fidna_2eIdnaError_2eDisallowedCodePoint(c));
  }
  const _bind$4 = _M0FP410tonyfettes7unicode8internal4idna21lookup__idna__mapping(c);
  const _status = _bind$4._0;
  _L: {
    switch (_status) {
      case 0: {
        return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(undefined);
      }
      case 3: {
        return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(undefined);
      }
      case 2: {
        break _L;
      }
      case 1: {
        break _L;
      }
      case 4: {
        return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(new _M0DTPC15error5Error61tonyfettes_2funicode_2fidna_2eIdnaError_2eDisallowedCodePoint(c));
      }
      case 5: {
        if (use_std3_ascii_rules) {
          return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(new _M0DTPC15error5Error61tonyfettes_2funicode_2fidna_2eIdnaError_2eDisallowedCodePoint(c));
        } else {
          return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(undefined);
        }
      }
      default: {
        if (use_std3_ascii_rules) {
          return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(new _M0DTPC15error5Error61tonyfettes_2funicode_2fidna_2eIdnaError_2eDisallowedCodePoint(c));
        } else {
          return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(undefined);
        }
      }
    }
  }
  return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(new _M0DTPC15error5Error61tonyfettes_2funicode_2fidna_2eIdnaError_2eDisallowedCodePoint(c));
}
function _M0FP310tonyfettes7unicode4idna10is__virama(c) {
  return _M0FP410tonyfettes7unicode8internal3ucd11lookup__ccc(c) === 9;
}
function _M0FP310tonyfettes7unicode4idna23is__valid__zwj__context(chars, pos) {
  return pos > 0 && _M0FP310tonyfettes7unicode4idna10is__virama(_M0MPC15array5Array2atGcE(chars, pos - 1 | 0));
}
function _M0FP310tonyfettes7unicode4idna26has__left__joining__before(chars, pos) {
  let _tmp$38 = pos - 1 | 0;
  while (true) {
    const i = _tmp$38;
    if (i >= 0) {
      _L: {
        const jt = _M0FP410tonyfettes7unicode8internal4idna21lookup__joining__type(_M0MPC15array5Array2atGcE(chars, i));
        _L$2: {
          switch (jt) {
            case 0: {
              break _L$2;
            }
            case 2: {
              break _L$2;
            }
            case 4: {
              break _L;
            }
            default: {
              return false;
            }
          }
        }
        return true;
      }
      _tmp$38 = i - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP310tonyfettes7unicode4idna26has__right__joining__after(chars, pos) {
  let _tmp$38 = pos + 1 | 0;
  while (true) {
    const i = _tmp$38;
    if (i < chars.length) {
      _L: {
        const jt = _M0FP410tonyfettes7unicode8internal4idna21lookup__joining__type(_M0MPC15array5Array2atGcE(chars, i));
        _L$2: {
          switch (jt) {
            case 1: {
              break _L$2;
            }
            case 2: {
              break _L$2;
            }
            case 4: {
              break _L;
            }
            default: {
              return false;
            }
          }
        }
        return true;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP310tonyfettes7unicode4idna24is__valid__zwnj__context(chars, pos) {
  if (pos > 0 && _M0FP310tonyfettes7unicode4idna10is__virama(_M0MPC15array5Array2atGcE(chars, pos - 1 | 0))) {
    return true;
  }
  if (_M0FP310tonyfettes7unicode4idna26has__left__joining__before(chars, pos) && _M0FP310tonyfettes7unicode4idna26has__right__joining__after(chars, pos)) {
    return true;
  }
  return false;
}
function _M0FP310tonyfettes7unicode4idna18validate__contextj(chars) {
  const _bind$4 = chars.length;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < _bind$4) {
      const c = chars[i];
      if (c === 8204) {
        if (!_M0FP310tonyfettes7unicode4idna24is__valid__zwnj__context(chars, i)) {
          return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(_M0DTPC15error5Error55tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidJoiner__);
        }
      } else {
        if (c === 8205) {
          if (!_M0FP310tonyfettes7unicode4idna23is__valid__zwj__context(chars, i)) {
            return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(_M0DTPC15error5Error55tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidJoiner__);
          }
        }
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(undefined);
}
function _M0FP310tonyfettes7unicode4idna17validate__hyphens(_label, chars) {
  if (chars.length > 0) {
    if (_M0MPC15array5Array2atGcE(chars, 0) === 45 || _M0MPC15array5Array2atGcE(chars, chars.length - 1 | 0) === 45) {
      return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(_M0DTPC15error5Error55tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidHyphen__);
    }
  }
  if (chars.length >= 4) {
    if (_M0MPC15array5Array2atGcE(chars, 2) === 45 && _M0MPC15array5Array2atGcE(chars, 3) === 45) {
      return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(_M0DTPC15error5Error55tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidHyphen__);
    } else {
      return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(undefined);
    }
  } else {
    return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(undefined);
  }
}
function _M0FP310tonyfettes7unicode4idna15validate__label(label, use_std3_ascii_rules, check_hyphens, check_bidi, check_joiners) {
  if (label.length === 0) {
    return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(_M0DTPC15error5Error52tonyfettes_2funicode_2fidna_2eIdnaError_2eEmptyLabel__);
  }
  const chars = _M0FP310tonyfettes7unicode4idna16label__to__chars(label);
  if (!_M0FP310tonyfettes7unicode13normalization14is__normalized(label, 1)) {
    return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(new _M0DTPC15error5Error54tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidLabel(label));
  }
  if (check_hyphens) {
    const _bind$4 = _M0FP310tonyfettes7unicode4idna17validate__hyphens(label, chars);
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _ok._0;
    } else {
      return _bind$4;
    }
  }
  if (chars.length > 0) {
    const first_c = _M0MPC15array5Array2atGcE(chars, 0);
    if (_M0FP310tonyfettes7unicode4idna19is__combining__mark(first_c)) {
      return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(_M0DTPC15error5Error62tonyfettes_2funicode_2fidna_2eIdnaError_2eLeadingCombiningMark__);
    }
  }
  const _bind$4 = chars.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const c = chars[_];
      const _bind$5 = _M0FP310tonyfettes7unicode4idna22validate__char__status(c, use_std3_ascii_rules);
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        _ok._0;
      } else {
        return _bind$5;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (check_joiners) {
    const _bind$5 = _M0FP310tonyfettes7unicode4idna18validate__contextj(chars);
    if (_bind$5.$tag === 1) {
      const _ok = _bind$5;
      _ok._0;
    } else {
      return _bind$5;
    }
  }
  return check_bidi ? _M0FP310tonyfettes7unicode4idna14validate__bidi(chars) : new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(undefined);
}
function _M0FP310tonyfettes7unicode4idna37validate__ltr__label__in__rtl__domain(chars) {
  if (chars.length === 0) {
    return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(undefined);
  }
  const first_bc = _M0FP410tonyfettes7unicode8internal4idna19lookup__bidi__class(_M0MPC15array5Array2atGcE(chars, 0));
  if (first_bc === 0) {
  } else {
    return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(_M0DTPC15error5Error53tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidBidi__);
  }
  let last_non_nsm_bc = first_bc;
  const _bind$4 = chars.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const c = chars[_];
      const bc = _M0FP410tonyfettes7unicode8internal4idna19lookup__bidi__class(c);
      _L: {
        _L$2: {
          _L$3: {
            _L$4: {
              switch (bc) {
                case 0: {
                  break _L$4;
                }
                case 4: {
                  break _L$4;
                }
                case 5: {
                  break _L$4;
                }
                case 6: {
                  break _L$4;
                }
                case 7: {
                  break _L$4;
                }
                case 8: {
                  break _L$4;
                }
                case 9: {
                  break _L$4;
                }
                case 10: {
                  break _L$4;
                }
                case 1: {
                  break _L$2;
                }
                case 2: {
                  break _L$2;
                }
                case 3: {
                  break _L$2;
                }
              }
              break _L$3;
            }
            let _tmp$39;
            if (bc === 10) {
              _tmp$39 = true;
            } else {
              _tmp$39 = false;
            }
            if (!_tmp$39) {
              last_non_nsm_bc = bc;
            }
          }
          break _L;
        }
        return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(_M0DTPC15error5Error53tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidBidi__);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$5 = last_non_nsm_bc;
  switch (_bind$5) {
    case 0: {
      return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(undefined);
    }
    case 4: {
      return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(undefined);
    }
    default: {
      return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(_M0DTPC15error5Error53tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidBidi__);
    }
  }
}
function _M0FP310tonyfettes7unicode4idna22validate__domain__bidi(labels) {
  let has_rtl_label = false;
  const _bind$4 = labels.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const label = labels[_];
      if (label.length > 0) {
        const chars = _M0FP310tonyfettes7unicode4idna16label__to__chars(label);
        if (_M0FP310tonyfettes7unicode4idna21is__rtl__label__check(chars)) {
          has_rtl_label = true;
          break;
        }
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (!has_rtl_label) {
    return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(undefined);
  }
  const _bind$5 = labels.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$5) {
      const label = labels[_];
      _L: {
        if (label.length === 0) {
          break _L;
        }
        const chars = _M0FP310tonyfettes7unicode4idna16label__to__chars(label);
        const is_rtl = _M0FP310tonyfettes7unicode4idna21is__rtl__label__check(chars);
        if (is_rtl) {
          const _bind$6 = _M0FP310tonyfettes7unicode4idna20validate__rtl__label(chars);
          if (_bind$6.$tag === 1) {
            const _ok = _bind$6;
            _ok._0;
          } else {
            return _bind$6;
          }
        } else {
          const _bind$6 = _M0FP310tonyfettes7unicode4idna37validate__ltr__label__in__rtl__domain(chars);
          if (_bind$6.$tag === 1) {
            const _ok = _bind$6;
            _ok._0;
          } else {
            return _bind$6;
          }
        }
        break _L;
      }
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(undefined);
}
function _M0FP310tonyfettes7unicode4idna11map__domain(domain, use_std3_ascii_rules) {
  const result = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _it = _M0MPC16string6String4iter(domain);
  while (true) {
    const _bind$4 = _M0MPB4Iter4nextGcE(_it);
    if (_bind$4 === -1) {
      break;
    } else {
      const _Some = _bind$4;
      const _c = _Some;
      const _bind$5 = _M0FP410tonyfettes7unicode8internal4idna21lookup__idna__mapping(_c);
      const _status = _bind$5._0;
      const _mapping = _bind$5._1;
      _L: {
        _L$2: {
          switch (_status) {
            case 0: {
              break _L$2;
            }
            case 3: {
              break _L$2;
            }
            case 1: {
              break;
            }
            case 2: {
              const _bind$6 = _mapping.length;
              let _tmp$38 = 0;
              while (true) {
                const _ = _tmp$38;
                if (_ < _bind$6) {
                  const mapped_c = _mapping[_];
                  _M0IPB13StringBuilderPB6Logger11write__char(result, mapped_c);
                  _tmp$38 = _ + 1 | 0;
                  continue;
                } else {
                  break;
                }
              }
              break;
            }
            case 4: {
              return new _M0DTPC16result6ResultGsRP310tonyfettes7unicode4idna9IdnaErrorE3Err(new _M0DTPC15error5Error61tonyfettes_2funicode_2fidna_2eIdnaError_2eDisallowedCodePoint(_c));
            }
            case 5: {
              if (use_std3_ascii_rules) {
                return new _M0DTPC16result6ResultGsRP310tonyfettes7unicode4idna9IdnaErrorE3Err(new _M0DTPC15error5Error61tonyfettes_2funicode_2fidna_2eIdnaError_2eDisallowedCodePoint(_c));
              } else {
                _M0IPB13StringBuilderPB6Logger11write__char(result, _c);
              }
              break;
            }
            default: {
              if (use_std3_ascii_rules) {
                return new _M0DTPC16result6ResultGsRP310tonyfettes7unicode4idna9IdnaErrorE3Err(new _M0DTPC15error5Error61tonyfettes_2funicode_2fidna_2eIdnaError_2eDisallowedCodePoint(_c));
              } else {
                const _bind$7 = _mapping.length;
                let _tmp$39 = 0;
                while (true) {
                  const _ = _tmp$39;
                  if (_ < _bind$7) {
                    const mapped_c = _mapping[_];
                    _M0IPB13StringBuilderPB6Logger11write__char(result, mapped_c);
                    _tmp$39 = _ + 1 | 0;
                    continue;
                  } else {
                    break;
                  }
                }
              }
            }
          }
          break _L;
        }
        _M0IPB13StringBuilderPB6Logger11write__char(result, _c);
      }
      continue;
    }
  }
  return new _M0DTPC16result6ResultGsRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(result.val);
}
function _M0FP310tonyfettes7unicode4idna20is__label__separator(c) {
  return c === 46 || (c === 12290 || (c === 65294 || c === 65377));
}
function _M0FP310tonyfettes7unicode4idna13split__labels(domain) {
  const labels = [];
  const current = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _it = _M0MPC16string6String4iter(domain);
  while (true) {
    const _bind$4 = _M0MPB4Iter4nextGcE(_it);
    if (_bind$4 === -1) {
      break;
    } else {
      const _Some = _bind$4;
      const _c = _Some;
      if (_M0FP310tonyfettes7unicode4idna20is__label__separator(_c)) {
        _M0MPC15array5Array4pushGUssEE(labels, current.val);
        _M0MPB13StringBuilder5reset(current);
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(current, _c);
      }
      continue;
    }
  }
  _M0MPC15array5Array4pushGUssEE(labels, current.val);
  return labels;
}
function _M0FP310tonyfettes7unicode4idna15process__domain(domain, use_std3_ascii_rules, check_hyphens, check_bidi, check_joiners) {
  const _bind$4 = _M0FP310tonyfettes7unicode4idna11map__domain(domain, use_std3_ascii_rules);
  let mapped;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    mapped = _ok._0;
  } else {
    return _bind$4;
  }
  const normalized = _M0FP310tonyfettes7unicode13normalization3nfc(mapped);
  const labels = _M0FP310tonyfettes7unicode4idna13split__labels(normalized);
  const label_count = labels.length;
  const has_trailing_dot = label_count > 0 && _M0MPC15array5Array2atGUssEE(labels, label_count - 1 | 0) === "";
  if (check_bidi) {
    const labels_for_bidi = has_trailing_dot ? _M0MPB4Iter9to__arrayGRPB4JsonE(_M0MPB4Iter4takeGRPB4JsonE(_M0MPC15array5Array4iterGsE(labels), label_count - 1 | 0)) : labels;
    const _bind$5 = _M0FP310tonyfettes7unicode4idna22validate__domain__bidi(labels_for_bidi);
    if (_bind$5.$tag === 1) {
      const _ok = _bind$5;
      _ok._0;
    } else {
      return _bind$5;
    }
  }
  const _bind$5 = labels.length;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < _bind$5) {
      const label = labels[i];
      _L: {
        if (i === (label_count - 1 | 0) && has_trailing_dot) {
          break _L;
        }
        const _bind$6 = _M0FP310tonyfettes7unicode4idna15validate__label(label, use_std3_ascii_rules, check_hyphens, false, check_joiners);
        if (_bind$6.$tag === 1) {
          const _ok = _bind$6;
          _ok._0;
        } else {
          return _bind$6;
        }
        break _L;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGsRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(normalized);
}
function _M0FP310tonyfettes7unicode4idna10map__label(label, use_std3_ascii_rules) {
  return _M0FP310tonyfettes7unicode4idna11map__domain(label, use_std3_ascii_rules);
}
function _M0FP310tonyfettes7unicode4idna24encode__label__to__ascii(label) {
  let all_ascii = true;
  const _it = _M0MPC16string6String4iter(label);
  while (true) {
    const _bind$4 = _M0MPB4Iter4nextGcE(_it);
    if (_bind$4 === -1) {
      break;
    } else {
      const _Some = _bind$4;
      const _c = _Some;
      if (_c >= 128) {
        all_ascii = false;
        break;
      }
      continue;
    }
  }
  let _tmp$38;
  if (all_ascii) {
    _tmp$38 = _M0MPC16string6String9to__lower(label);
  } else {
    let encoded;
    let _try_err;
    _L: {
      _L$2: {
        const _bind$4 = _M0FP310tonyfettes7unicode8punycode6encode(_M0MPC16string6String9to__lower(label));
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          encoded = _ok._0;
        } else {
          const _err = _bind$4;
          _try_err = _err._0;
          break _L$2;
        }
        break _L;
      }
      return new _M0DTPC16result6ResultGsRP310tonyfettes7unicode4idna9IdnaErrorE3Err(new _M0DTPC15error5Error55tonyfettes_2funicode_2fidna_2eIdnaError_2ePunycodeError(_try_err));
    }
    _tmp$38 = `${_M0FP310tonyfettes7unicode4idna11ace__prefix}${encoded}`;
  }
  return new _M0DTPC16result6ResultGsRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(_tmp$38);
}
function _M0FP310tonyfettes7unicode4idna29get__substring__after__prefix(s, prefix_len) {
  const result = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  const _it = _M0MPC16string6String4iter(s);
  while (true) {
    const _bind$4 = _M0MPB4Iter4nextGcE(_it);
    if (_bind$4 === -1) {
      break;
    } else {
      const _Some = _bind$4;
      const _c = _Some;
      if (i >= prefix_len) {
        _M0IPB13StringBuilderPB6Logger11write__char(result, _c);
      }
      i = i + 1 | 0;
      continue;
    }
  }
  return result.val;
}
function _M0FP310tonyfettes7unicode4idna16has__ace__prefix(label) {
  return _M0MPC16string6String11has__prefix(_M0MPC16string6String9to__lower(label), new _M0TPC16string10StringView(_M0FP310tonyfettes7unicode4idna16has__ace__prefixN7_2abindS357, 0, _M0FP310tonyfettes7unicode4idna16has__ace__prefixN7_2abindS357.length));
}
function _M0FP310tonyfettes7unicode4idna26process__label__for__ascii(label, use_std3_ascii_rules, check_hyphens, check_joiners) {
  if (label.length === 0) {
    return new _M0DTPC16result6ResultGUssERP310tonyfettes7unicode4idna9IdnaErrorE2Ok(_M0FP310tonyfettes7unicode4idna26process__label__for__asciiN5tupleS427);
  }
  if (_M0FP310tonyfettes7unicode4idna16has__ace__prefix(label)) {
    const punycode_part = _M0FP310tonyfettes7unicode4idna29get__substring__after__prefix(label, 4);
    let decoded;
    let _try_err;
    _L: {
      _L$2: {
        const _bind$4 = _M0FP310tonyfettes7unicode8punycode6decode(punycode_part);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          decoded = _ok._0;
        } else {
          const _err = _bind$4;
          _try_err = _err._0;
          break _L$2;
        }
        break _L;
      }
      return new _M0DTPC16result6ResultGUssERP310tonyfettes7unicode4idna9IdnaErrorE3Err(new _M0DTPC15error5Error55tonyfettes_2funicode_2fidna_2eIdnaError_2ePunycodeError(_try_err));
    }
    const _bind$4 = _M0FP310tonyfettes7unicode4idna10map__label(decoded, use_std3_ascii_rules);
    let mapped;
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      mapped = _ok._0;
    } else {
      return _bind$4;
    }
    const normalized = _M0FP310tonyfettes7unicode13normalization3nfc(mapped);
    const _bind$5 = _M0FP310tonyfettes7unicode4idna15validate__label(normalized, use_std3_ascii_rules, check_hyphens, false, check_joiners);
    if (_bind$5.$tag === 1) {
      const _ok = _bind$5;
      _ok._0;
    } else {
      return _bind$5;
    }
    const _bind$6 = _M0FP310tonyfettes7unicode4idna24encode__label__to__ascii(normalized);
    let re_encoded;
    if (_bind$6.$tag === 1) {
      const _ok = _bind$6;
      re_encoded = _ok._0;
    } else {
      return _bind$6;
    }
    const _p$4 = _M0MPC16string6String9to__lower(label);
    if (!(re_encoded === _p$4)) {
      return new _M0DTPC16result6ResultGUssERP310tonyfettes7unicode4idna9IdnaErrorE3Err(_M0DTPC15error5Error58tonyfettes_2funicode_2fidna_2eIdnaError_2eInvalidAcePrefix__);
    }
    return new _M0DTPC16result6ResultGUssERP310tonyfettes7unicode4idna9IdnaErrorE2Ok({ _0: normalized, _1: _M0MPC16string6String9to__lower(label) });
  }
  const _bind$4 = _M0FP310tonyfettes7unicode4idna24encode__label__to__ascii(label);
  let ascii_label;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    ascii_label = _ok._0;
  } else {
    return _bind$4;
  }
  return new _M0DTPC16result6ResultGUssERP310tonyfettes7unicode4idna9IdnaErrorE2Ok({ _0: label, _1: ascii_label });
}
function _M0FP310tonyfettes7unicode4idna32verify__dns__length__constraints(domain, labels) {
  const _bind$4 = labels.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const label = labels[_];
      if (label.length === 0) {
        return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(_M0DTPC15error5Error52tonyfettes_2funicode_2fidna_2eIdnaError_2eEmptyLabel__);
      }
      if (label.length > 63) {
        return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(_M0DTPC15error5Error54tonyfettes_2funicode_2fidna_2eIdnaError_2eLabelTooLong__);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (domain.length > 253) {
    return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE3Err(_M0DTPC15error5Error55tonyfettes_2funicode_2fidna_2eIdnaError_2eDomainTooLong__);
  } else {
    return new _M0DTPC16result6ResultGuRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(undefined);
  }
}
function _M0FP310tonyfettes7unicode4idna17to__ascii_2einner(domain, use_std3_ascii_rules, check_hyphens, check_bidi, check_joiners, verify_dns_length) {
  const _bind$4 = _M0FP310tonyfettes7unicode4idna15process__domain(domain, use_std3_ascii_rules, check_hyphens, false, check_joiners);
  let processed;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    processed = _ok._0;
  } else {
    return _bind$4;
  }
  const labels = _M0FP310tonyfettes7unicode4idna13split__labels(processed);
  const label_count = labels.length;
  const has_trailing_dot = label_count > 1 && _M0MPC15array5Array2atGUssEE(labels, label_count - 1 | 0) === "";
  const unicode_labels = [];
  const ascii_labels = [];
  const _bind$5 = labels.length;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < _bind$5) {
      const label = labels[i];
      _L: {
        if (i === (label_count - 1 | 0) && has_trailing_dot) {
          _M0MPC15array5Array4pushGUssEE(unicode_labels, "");
          _M0MPC15array5Array4pushGUssEE(ascii_labels, "");
          break _L;
        }
        if (label.length === 0) {
          return new _M0DTPC16result6ResultGsRP310tonyfettes7unicode4idna9IdnaErrorE3Err(_M0DTPC15error5Error52tonyfettes_2funicode_2fidna_2eIdnaError_2eEmptyLabel__);
        }
        const _bind$6 = _M0FP310tonyfettes7unicode4idna26process__label__for__ascii(label, use_std3_ascii_rules, check_hyphens, check_joiners);
        let _bind$7;
        if (_bind$6.$tag === 1) {
          const _ok = _bind$6;
          _bind$7 = _ok._0;
        } else {
          return _bind$6;
        }
        const _unicode_label = _bind$7._0;
        const _ascii_label = _bind$7._1;
        _M0MPC15array5Array4pushGUssEE(unicode_labels, _unicode_label);
        _M0MPC15array5Array4pushGUssEE(ascii_labels, _ascii_label);
        break _L;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (check_bidi) {
    const labels_for_bidi = has_trailing_dot ? _M0MPB4Iter9to__arrayGRPB4JsonE(_M0MPB4Iter4takeGRPB4JsonE(_M0MPC15array5Array4iterGsE(unicode_labels), label_count - 1 | 0)) : unicode_labels;
    const _bind$6 = _M0FP310tonyfettes7unicode4idna22validate__domain__bidi(labels_for_bidi);
    if (_bind$6.$tag === 1) {
      const _ok = _bind$6;
      _ok._0;
    } else {
      return _bind$6;
    }
  }
  const result = _M0MPC15array5Array4joinGsE(ascii_labels, new _M0TPC16string10StringView(_M0FP310tonyfettes7unicode4idna17to__ascii_2einnerN7_2abindS394, 0, _M0FP310tonyfettes7unicode4idna17to__ascii_2einnerN7_2abindS394.length));
  if (verify_dns_length) {
    const _bind$6 = _M0FP310tonyfettes7unicode4idna32verify__dns__length__constraints(result, ascii_labels);
    if (_bind$6.$tag === 1) {
      const _ok = _bind$6;
      _ok._0;
    } else {
      return _bind$6;
    }
  }
  return new _M0DTPC16result6ResultGsRP310tonyfettes7unicode4idna9IdnaErrorE2Ok(result);
}
function _M0IP210tonyfettes3url15ValidationErrorPB4Show6output(_x_543, _x_544) {
  switch (_x_543.$tag) {
    case 31: {
      _x_544.method_table.method_0(_x_544.self, "DomainToAscii");
      return;
    }
    case 30: {
      _x_544.method_table.method_0(_x_544.self, "HostInvalidCodePoint");
      return;
    }
    case 29: {
      _x_544.method_table.method_0(_x_544.self, "IPv4EmptyPart");
      return;
    }
    case 28: {
      _x_544.method_table.method_0(_x_544.self, "IPv4TooManyParts");
      return;
    }
    case 27: {
      _x_544.method_table.method_0(_x_544.self, "IPv4NonNumericPart");
      return;
    }
    case 26: {
      _x_544.method_table.method_0(_x_544.self, "IPv4OutOfRangePart");
      return;
    }
    case 25: {
      _x_544.method_table.method_0(_x_544.self, "IPv6InvalidCompression");
      return;
    }
    case 24: {
      _x_544.method_table.method_0(_x_544.self, "IPv6MultipleCompression");
      return;
    }
    case 23: {
      _x_544.method_table.method_0(_x_544.self, "IPv6TooManyPieces");
      return;
    }
    case 22: {
      _x_544.method_table.method_0(_x_544.self, "IPv6InvalidCodePoint");
      return;
    }
    case 21: {
      _x_544.method_table.method_0(_x_544.self, "IPv6TooFewPieces");
      return;
    }
    case 20: {
      _x_544.method_table.method_0(_x_544.self, "IPv6Unclosed");
      return;
    }
    case 19: {
      _x_544.method_table.method_0(_x_544.self, "IPv4InIPv6InvalidCodePoint");
      return;
    }
    case 18: {
      _x_544.method_table.method_0(_x_544.self, "IPv4InIPv6TooManyPieces");
      return;
    }
    case 17: {
      _x_544.method_table.method_0(_x_544.self, "IPv4InIPv6OutOfRangePart");
      return;
    }
    case 16: {
      _x_544.method_table.method_0(_x_544.self, "IPv4InIPv6TooFewParts");
      return;
    }
    case 15: {
      _x_544.method_table.method_0(_x_544.self, "MissingSchemeNonRelativeUrl");
      return;
    }
    case 14: {
      _x_544.method_table.method_0(_x_544.self, "SpecialSchemeMissingFollowingSolidus");
      return;
    }
    case 13: {
      _x_544.method_table.method_0(_x_544.self, "InvalidReverseSolidus");
      return;
    }
    case 12: {
      _x_544.method_table.method_0(_x_544.self, "InvalidCredentials");
      return;
    }
    default: {
      _x_544.method_table.method_0(_x_544.self, "HostMissing");
      return;
    }
  }
}
function _M0FP210tonyfettes3url22percent__decode__bytes(input) {
  const output = _M0FPC16buffer11new_2einner(0);
  let _tmp$38 = _M0MPC15bytes5Bytes12view_2einner(input, 0, input.length);
  while (true) {
    const _param = _tmp$38;
    let rest;
    let byte;
    _L: {
      if ((_param.end - _param.start | 0) >= 3) {
        const _x = _param.bytes[_param.start];
        if (_x === 37) {
          const _c0 = _param.bytes[_param.start + 1 | 0];
          const _c1 = _param.bytes[_param.start + 2 | 0];
          const _x$2 = new _M0TPC15bytes9BytesView(_param.bytes, _param.start + 3 | 0, _param.end);
          let b0;
          if (_c0 >= 48 && _c0 <= 57) {
            b0 = _c0 - 48 | 0;
          } else {
            if (_c0 >= 97 && _c0 <= 102) {
              b0 = (_c0 - 97 | 0) + 10 | 0;
            } else {
              if (_c0 >= 65 && _c0 <= 70) {
                b0 = (_c0 - 65 | 0) + 10 | 0;
              } else {
                _M0MPC16buffer6Buffer11write__byte(output, 37);
                _tmp$38 = _M0MPC15bytes9BytesView12view_2einner(_param, 1, undefined);
                continue;
              }
            }
          }
          let b1;
          if (_c1 >= 48 && _c1 <= 57) {
            b1 = _c1 - 48 | 0;
          } else {
            if (_c1 >= 97 && _c1 <= 102) {
              b1 = (_c1 - 97 | 0) + 10 | 0;
            } else {
              if (_c1 >= 65 && _c1 <= 70) {
                b1 = (_c1 - 65 | 0) + 10 | 0;
              } else {
                _M0MPC16buffer6Buffer11write__byte(output, 37);
                _M0MPC16buffer6Buffer11write__byte(output, _c0);
                _tmp$38 = _M0MPC15bytes9BytesView12view_2einner(_param, 2, undefined);
                continue;
              }
            }
          }
          _M0MPC16buffer6Buffer11write__byte(output, (b0 << 4 | b1) & 255);
          _tmp$38 = _x$2;
          continue;
        } else {
          const _x$2 = new _M0TPC15bytes9BytesView(_param.bytes, _param.start + 1 | 0, _param.end);
          rest = _x$2;
          byte = _x;
          break _L;
        }
      } else {
        if ((_param.end - _param.start | 0) >= 1) {
          const _byte = _param.bytes[_param.start];
          const _x = new _M0TPC15bytes9BytesView(_param.bytes, _param.start + 1 | 0, _param.end);
          rest = _x;
          byte = _byte;
          break _L;
        } else {
          break;
        }
      }
    }
    _M0MPC16buffer6Buffer11write__byte(output, byte);
    _tmp$38 = rest;
    continue;
  }
  return _M0MPC16buffer6Buffer9to__bytes(output);
}
function _M0FP210tonyfettes3url23percent__decode__string(input) {
  const bytes = _M0FPC28encoding4utf814encode_2einner(input, false);
  return _M0FP210tonyfettes3url22percent__decode__bytes(bytes);
}
function _M0MP210tonyfettes3url3Url3new() {
  return new _M0TP210tonyfettes3url3Url("", "", "", undefined, -1, new _M0DTP210tonyfettes3url4Path8Segments([]), undefined, undefined);
}
function _M0FP210tonyfettes3url33c0__control__percent__encode__set(char) {
  return char >= 0 && char <= 31 ? true : char >= 127;
}
function _M0FP210tonyfettes3url13default__port(scheme) {
  _L: {
    _L$2: {
      _L$3: {
        if (_M0MPC16string6String24char__length__eq_2einner(scheme.str, 3, scheme.start, scheme.end)) {
          const _x = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 0, scheme.start, scheme.end));
          switch (_x) {
            case 102: {
              const _x$2 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 1, scheme.start, scheme.end));
              if (_x$2 === 116) {
                const _x$3 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 2, scheme.start, scheme.end));
                if (_x$3 === 112) {
                  return _M0FP210tonyfettes3url13default__portN6constrS2085;
                } else {
                  break _L;
                }
              } else {
                break _L;
              }
            }
            case 119: {
              const _x$3 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 1, scheme.start, scheme.end));
              if (_x$3 === 115) {
                const _x$4 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 2, scheme.start, scheme.end));
                if (_x$4 === 115) {
                  break _L$2;
                } else {
                  break _L;
                }
              } else {
                break _L;
              }
            }
            default: {
              break _L;
            }
          }
        } else {
          if (_M0MPC16string6String24char__length__eq_2einner(scheme.str, 4, scheme.start, scheme.end)) {
            const _x = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 0, scheme.start, scheme.end));
            if (_x === 104) {
              const _x$2 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 1, scheme.start, scheme.end));
              if (_x$2 === 116) {
                const _x$3 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 2, scheme.start, scheme.end));
                if (_x$3 === 116) {
                  const _x$4 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 3, scheme.start, scheme.end));
                  if (_x$4 === 112) {
                    break _L$3;
                  } else {
                    break _L;
                  }
                } else {
                  break _L;
                }
              } else {
                break _L;
              }
            } else {
              break _L;
            }
          } else {
            if (_M0MPC16string6String24char__length__eq_2einner(scheme.str, 2, scheme.start, scheme.end)) {
              const _x = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 0, scheme.start, scheme.end));
              if (_x === 119) {
                const _x$2 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 1, scheme.start, scheme.end));
                if (_x$2 === 115) {
                  break _L$3;
                } else {
                  break _L;
                }
              } else {
                break _L;
              }
            } else {
              if (_M0MPC16string6String24char__length__eq_2einner(scheme.str, 5, scheme.start, scheme.end)) {
                const _x = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 0, scheme.start, scheme.end));
                if (_x === 104) {
                  const _x$2 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 1, scheme.start, scheme.end));
                  if (_x$2 === 116) {
                    const _x$3 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 2, scheme.start, scheme.end));
                    if (_x$3 === 116) {
                      const _x$4 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 3, scheme.start, scheme.end));
                      if (_x$4 === 112) {
                        const _x$5 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 4, scheme.start, scheme.end));
                        if (_x$5 === 115) {
                          break _L$2;
                        } else {
                          break _L;
                        }
                      } else {
                        break _L;
                      }
                    } else {
                      break _L;
                    }
                  } else {
                    break _L;
                  }
                } else {
                  break _L;
                }
              } else {
                break _L;
              }
            }
          }
        }
      }
      return _M0FP210tonyfettes3url13default__portN6constrS2084;
    }
    return _M0FP210tonyfettes3url13default__portN6constrS2083;
  }
  return -1;
}
function _M0FP210tonyfettes3url29encode__last__trailing__space(s) {
  const len = s.length;
  if (len === 0) {
    return s;
  }
  _L: {
    const _bind$4 = _M0MPC16string6String9get__char(s, len - 1 | 0);
    if (_bind$4 === -1) {
      break _L;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      if (_x === 32) {
        const result = _M0MPB13StringBuilder21StringBuilder_2einner(0);
        const _it = _M0MPC16string6String5iter2(s);
        while (true) {
          const _bind$5 = _M0MPB5Iter24nextGicE(_it);
          if (_bind$5 === undefined) {
            break;
          } else {
            const _Some$2 = _bind$5;
            const _x$2 = _Some$2;
            const _i = _x$2._0;
            const _c = _x$2._1;
            if (_i === (len - 1 | 0)) {
              _M0IPB13StringBuilderPB6Logger13write__string(result, "%20");
            } else {
              _M0IPB13StringBuilderPB6Logger11write__char(result, _c);
            }
            continue;
          }
        }
        return result.val;
      } else {
        break _L;
      }
    }
  }
  return s;
}
function _M0FP210tonyfettes3url30fragment__percent__encode__set(char) {
  return char >= 0 && char <= 31 ? true : char >= 127 ? true : char === 32 ? true : char === 34 ? true : char === 60 ? true : char === 62 ? true : char === 96;
}
function _M0FP210tonyfettes3url16has__empty__host(host) {
  if (host === undefined) {
    return true;
  } else {
    const _Some = host;
    const _x = _Some;
    if (_x.$tag === 3) {
      const _Opaque = _x;
      const _x$2 = _Opaque._0;
      if (_x$2 === "") {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}
function _M0FP210tonyfettes3url30is__double__dot__path__segment(segment) {
  if (segment === "..") {
    return true;
  } else {
    const _bind$4 = _M0MPC16string6String9to__lower(segment);
    let _tmp$38;
    switch (_bind$4) {
      case ".%2e": {
        _tmp$38 = true;
        break;
      }
      case "%2e.": {
        _tmp$38 = true;
        break;
      }
      case "%2e%2e": {
        _tmp$38 = true;
        break;
      }
      default: {
        _tmp$38 = false;
      }
    }
    return _tmp$38;
  }
}
function _M0FP210tonyfettes3url30is__single__dot__path__segment(segment) {
  return segment === "." || _M0MPC16string6String9to__lower(segment) === "%2e";
}
function _M0FP210tonyfettes3url19is__special__scheme(scheme) {
  if (_M0MPC16string6String24char__length__eq_2einner(scheme.str, 3, scheme.start, scheme.end)) {
    const _x = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 0, scheme.start, scheme.end));
    switch (_x) {
      case 102: {
        const _x$2 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 1, scheme.start, scheme.end));
        if (_x$2 === 116) {
          const _x$3 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 2, scheme.start, scheme.end));
          if (_x$3 === 112) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
      case 119: {
        const _x$3 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 1, scheme.start, scheme.end));
        if (_x$3 === 115) {
          const _x$4 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 2, scheme.start, scheme.end));
          if (_x$4 === 115) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
      default: {
        return false;
      }
    }
  } else {
    if (_M0MPC16string6String24char__length__eq_2einner(scheme.str, 4, scheme.start, scheme.end)) {
      const _x = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 0, scheme.start, scheme.end));
      switch (_x) {
        case 102: {
          const _x$2 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 1, scheme.start, scheme.end));
          if (_x$2 === 105) {
            const _x$3 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 2, scheme.start, scheme.end));
            if (_x$3 === 108) {
              const _x$4 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 3, scheme.start, scheme.end));
              if (_x$4 === 101) {
                return true;
              } else {
                return false;
              }
            } else {
              return false;
            }
          } else {
            return false;
          }
        }
        case 104: {
          const _x$3 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 1, scheme.start, scheme.end));
          if (_x$3 === 116) {
            const _x$4 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 2, scheme.start, scheme.end));
            if (_x$4 === 116) {
              const _x$5 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 3, scheme.start, scheme.end));
              if (_x$5 === 112) {
                return true;
              } else {
                return false;
              }
            } else {
              return false;
            }
          } else {
            return false;
          }
        }
        default: {
          return false;
        }
      }
    } else {
      if (_M0MPC16string6String24char__length__eq_2einner(scheme.str, 5, scheme.start, scheme.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 0, scheme.start, scheme.end));
        if (_x === 104) {
          const _x$2 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 1, scheme.start, scheme.end));
          if (_x$2 === 116) {
            const _x$3 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 2, scheme.start, scheme.end));
            if (_x$3 === 116) {
              const _x$4 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 3, scheme.start, scheme.end));
              if (_x$4 === 112) {
                const _x$5 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 4, scheme.start, scheme.end));
                if (_x$5 === 115) {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            } else {
              return false;
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        if (_M0MPC16string6String24char__length__eq_2einner(scheme.str, 2, scheme.start, scheme.end)) {
          const _x = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 0, scheme.start, scheme.end));
          if (_x === 119) {
            const _x$2 = _M0MPC16string6String16unsafe__char__at(scheme.str, _M0MPC16string6String29offset__of__nth__char_2einner(scheme.str, 1, scheme.start, scheme.end));
            if (_x$2 === 115) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    }
  }
}
function _M0FP210tonyfettes3url26path__percent__encode__set(char) {
  return char >= 0 && char <= 31 ? true : char >= 127 ? true : char === 32 ? true : char === 34 ? true : char === 35 ? true : char === 60 ? true : char === 62 ? true : char === 63 ? true : char === 94 ? true : char === 96 ? true : char === 123 ? true : char === 125;
}
function _M0FP210tonyfettes3url27query__percent__encode__set(char) {
  return char >= 0 && char <= 31 ? true : char >= 127 ? true : char === 32 ? true : char === 34 ? true : char === 35 ? true : char === 60 ? true : char === 62;
}
function _M0FP210tonyfettes3url31remove__ascii__tab__or__newline(input) {
  const output = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _it = _M0MPC16string10StringView4iter(input);
  while (true) {
    const _bind$4 = _M0MPB4Iter4nextGcE(_it);
    if (_bind$4 === -1) {
      break;
    } else {
      const _Some = _bind$4;
      const _c = _Some;
      let _tmp$38;
      switch (_c) {
        case 9: {
          _tmp$38 = true;
          break;
        }
        case 10: {
          _tmp$38 = true;
          break;
        }
        case 13: {
          _tmp$38 = true;
          break;
        }
        default: {
          _tmp$38 = false;
        }
      }
      if (!_tmp$38) {
        _M0IPB13StringBuilderPB6Logger11write__char(output, _c);
      }
      continue;
    }
  }
  return output.val;
}
function _M0FP210tonyfettes3url36special__query__percent__encode__set(char) {
  return char >= 0 && char <= 31 ? true : char >= 127 ? true : char === 32 ? true : char === 34 ? true : char === 35 ? true : char === 60 ? true : char === 62 ? true : char === 39;
}
function _M0FP210tonyfettes3url28trim__c0__control__or__space(input) {
  let input$2;
  let _tmp$38 = input;
  while (true) {
    const _param = _tmp$38;
    let input$3;
    _L: {
      if (_M0MPC16string6String24char__length__ge_2einner(_param.str, 1, _param.start, _param.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(_param.str, _M0MPC16string6String29offset__of__nth__char_2einner(_param.str, 0, _param.start, _param.end));
        if (_x >= 0 && _x <= 32) {
          const _tmp$39 = _param.str;
          const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(_param.str, 1, _param.start, _param.end);
          let _tmp$40;
          if (_bind$4 === undefined) {
            _tmp$40 = _param.end;
          } else {
            const _Some = _bind$4;
            _tmp$40 = _Some;
          }
          const _x$2 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, _param.end);
          _tmp$38 = _x$2;
          continue;
        } else {
          input$3 = _param;
          break _L;
        }
      } else {
        input$3 = _param;
        break _L;
      }
    }
    input$2 = input$3;
    break;
  }
  let _tmp$39 = input$2;
  while (true) {
    const _param = _tmp$39;
    let input$3;
    _L: {
      if (_M0MPC16string6String24char__length__ge_2einner(_param.str, 1, _param.start, _param.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(_param.str, _M0MPC16string6String29offset__of__nth__char_2einner(_param.str, -1, _param.start, _param.end));
        if (_x >= 0 && _x <= 32) {
          const _x$2 = new _M0TPC16string10StringView(_param.str, _param.start, _M0MPC16string6String29offset__of__nth__char_2einner(_param.str, -1, _param.start, _param.end));
          _tmp$39 = _x$2;
          continue;
        } else {
          input$3 = _param;
          break _L;
        }
      } else {
        input$3 = _param;
        break _L;
      }
    }
    return input$3;
  }
}
function _M0FP210tonyfettes3url30userinfo__percent__encode__set(char) {
  return char >= 0 && char <= 31 ? true : char >= 127 ? true : char === 32 ? true : char === 34 ? true : char === 35 ? true : char === 60 ? true : char === 62 ? true : char === 63 ? true : char === 94 ? true : char === 96 ? true : char === 123 ? true : char === 125 ? true : char === 47 ? true : char === 58 ? true : char === 59 ? true : char === 61 ? true : char === 64 ? true : char >= 91 && char <= 93 ? true : char === 124;
}
function _M0FP210tonyfettes3url38contains__forbidden__domain__codepoint(s) {
  const _it = _M0MPC16string6String4iter(s);
  while (true) {
    const _bind$4 = _M0MPB4Iter4nextGcE(_it);
    if (_bind$4 === -1) {
      break;
    } else {
      const _Some = _bind$4;
      const _c = _Some;
      _L: {
        _L$2: {
          if (_c >= 0 && _c <= 31) {
            break _L$2;
          } else {
            if (_c === 127) {
              break _L$2;
            }
          }
          break _L;
        }
        return true;
      }
      _L$2: {
        _L$3: {
          switch (_c) {
            case 32: {
              break _L$3;
            }
            case 35: {
              break _L$3;
            }
            case 37: {
              break _L$3;
            }
            case 47: {
              break _L$3;
            }
            case 58: {
              break _L$3;
            }
            case 60: {
              break _L$3;
            }
            case 62: {
              break _L$3;
            }
            case 63: {
              break _L$3;
            }
            case 64: {
              break _L$3;
            }
            case 91: {
              break _L$3;
            }
            case 92: {
              break _L$3;
            }
            case 93: {
              break _L$3;
            }
            case 94: {
              break _L$3;
            }
            case 124: {
              break _L$3;
            }
          }
          break _L$2;
        }
        return true;
      }
      continue;
    }
  }
  return false;
}
function _M0FP210tonyfettes3url19ends__in__a__number(input) {
  const parts = _M0MPB4Iter9to__arrayGRPB4JsonE(_M0MPC16string10StringView5split(input, new _M0TPC16string10StringView(_M0FP210tonyfettes3url19ends__in__a__numberN7_2abindS941, 0, _M0FP210tonyfettes3url19ends__in__a__numberN7_2abindS941.length)));
  let last;
  _L: {
    if (parts.length === 0) {
      return false;
    } else {
      if (parts.length === 1) {
        const _x = parts[0];
        if (_M0MPC16string6String24char__length__eq_2einner(_x.str, 0, _x.start, _x.end)) {
          return false;
        } else {
          const _last = parts[parts.length - 1 | 0];
          last = _last;
          break _L;
        }
      } else {
        const _last = parts[(parts.length - 1 | 0) - 1 | 0];
        const _x = parts[parts.length - 1 | 0];
        if (_M0MPC16string6String24char__length__eq_2einner(_x.str, 0, _x.start, _x.end)) {
          last = _last;
          break _L;
        } else {
          last = _x;
          break _L;
        }
      }
    }
  }
  if (_M0MPC16string6String24char__length__eq_2einner(last.str, 0, last.start, last.end)) {
    return false;
  }
  let last$2;
  _L$2: {
    let last$3;
    _L$3: {
      if (_M0MPC16string6String24char__length__ge_2einner(last.str, 2, last.start, last.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(last.str, _M0MPC16string6String29offset__of__nth__char_2einner(last.str, 0, last.start, last.end));
        if (_x === 48) {
          const _x$2 = _M0MPC16string6String16unsafe__char__at(last.str, _M0MPC16string6String29offset__of__nth__char_2einner(last.str, 1, last.start, last.end));
          switch (_x$2) {
            case 120: {
              const _tmp$38 = last.str;
              const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(last.str, 2, last.start, last.end);
              let _tmp$39;
              if (_bind$4 === undefined) {
                _tmp$39 = last.end;
              } else {
                const _Some = _bind$4;
                _tmp$39 = _Some;
              }
              const _x$3 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, last.end);
              last$3 = _x$3;
              break _L$3;
            }
            case 88: {
              const _tmp$40 = last.str;
              const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(last.str, 2, last.start, last.end);
              let _tmp$41;
              if (_bind$5 === undefined) {
                _tmp$41 = last.end;
              } else {
                const _Some = _bind$5;
                _tmp$41 = _Some;
              }
              const _x$4 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, last.end);
              last$3 = _x$4;
              break _L$3;
            }
            default: {
              const _tmp$42 = last.str;
              const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(last.str, 1, last.start, last.end);
              let _tmp$43;
              if (_bind$6 === undefined) {
                _tmp$43 = last.end;
              } else {
                const _Some = _bind$6;
                _tmp$43 = _Some;
              }
              const _x$5 = new _M0TPC16string10StringView(_tmp$42, _tmp$43, last.end);
              last$2 = _x$5;
              break _L$2;
            }
          }
        } else {
          if (_x >= 48 && _x <= 57) {
            const _tmp$38 = last.str;
            const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(last.str, 1, last.start, last.end);
            let _tmp$39;
            if (_bind$4 === undefined) {
              _tmp$39 = last.end;
            } else {
              const _Some = _bind$4;
              _tmp$39 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, last.end);
            last$2 = _x$2;
            break _L$2;
          } else {
            return false;
          }
        }
      } else {
        if (_M0MPC16string6String24char__length__ge_2einner(last.str, 1, last.start, last.end)) {
          const _x = _M0MPC16string6String16unsafe__char__at(last.str, _M0MPC16string6String29offset__of__nth__char_2einner(last.str, 0, last.start, last.end));
          if (_x >= 48 && _x <= 57) {
            const _tmp$38 = last.str;
            const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(last.str, 1, last.start, last.end);
            let _tmp$39;
            if (_bind$4 === undefined) {
              _tmp$39 = last.end;
            } else {
              const _Some = _bind$4;
              _tmp$39 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, last.end);
            last$2 = _x$2;
            break _L$2;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    }
    const _it = _M0MPC16string10StringView4iter(last$3);
    while (true) {
      const _bind$4 = _M0MPB4Iter4nextGcE(_it);
      if (_bind$4 === -1) {
        return true;
      } else {
        const _Some = _bind$4;
        const _c = _Some;
        _L$4: {
          if (_c >= 48 && _c <= 57) {
            break _L$4;
          } else {
            if (_c >= 97 && _c <= 102) {
              break _L$4;
            } else {
              if (_c >= 65 && _c <= 70) {
                break _L$4;
              } else {
                return false;
              }
            }
          }
        }
        continue;
      }
    }
  }
  const _it = _M0MPC16string10StringView4iter(last$2);
  while (true) {
    const _bind$4 = _M0MPB4Iter4nextGcE(_it);
    if (_bind$4 === -1) {
      return true;
    } else {
      const _Some = _bind$4;
      const _c = _Some;
      if (_c >= 48 && _c <= 57) {
        continue;
      } else {
        return false;
      }
    }
  }
}
function _M0MP210tonyfettes3url4Host13parse__opaque(input) {
  const _it = _M0MPC16string10StringView4iter(input);
  while (true) {
    const _bind$4 = _M0MPB4Iter4nextGcE(_it);
    if (_bind$4 === -1) {
      break;
    } else {
      const _Some = _bind$4;
      const _c = _Some;
      _L: {
        _L$2: {
          switch (_c) {
            case 0: {
              break _L$2;
            }
            case 9: {
              break _L$2;
            }
            case 10: {
              break _L$2;
            }
            case 13: {
              break _L$2;
            }
            case 32: {
              break _L$2;
            }
            case 35: {
              break _L$2;
            }
            case 47: {
              break _L$2;
            }
            case 58: {
              break _L$2;
            }
            case 60: {
              break _L$2;
            }
            case 62: {
              break _L$2;
            }
            case 63: {
              break _L$2;
            }
            case 64: {
              break _L$2;
            }
            case 91: {
              break _L$2;
            }
            case 92: {
              break _L$2;
            }
            case 93: {
              break _L$2;
            }
            case 94: {
              break _L$2;
            }
            case 124: {
              break _L$2;
            }
          }
          break _L;
        }
        return new _M0DTPC16result6ResultGsRP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error57tonyfettes_2furl_2eValidationError_2eHostInvalidCodePoint__);
      }
      continue;
    }
  }
  const _p$4 = false;
  const _p$5 = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _p$6 = _M0FPC28encoding4utf814encode_2einner(input, false);
  const _p$7 = _p$6.length;
  let _tmp$38 = 0;
  while (true) {
    const _p$8 = _tmp$38;
    if (_p$8 < _p$7) {
      const _p$9 = _p$6[_p$8];
      _L: {
        if (_p$4) {
          if (_p$9 === 32) {
            _M0IPB13StringBuilderPB6Logger11write__char(_p$5, 43);
            break _L;
          }
        }
        const _p$10 = _p$9;
        if (_M0FP210tonyfettes3url33c0__control__percent__encode__set(_p$10)) {
          _M0IPB13StringBuilderPB6Logger11write__char(_p$5, 37);
          const _p$11 = _p$9;
          const _p$12 = _p$11 >> 4 & 15;
          $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$12);
          _M0IPB13StringBuilderPB6Logger11write__char(_p$5, _M0FP210tonyfettes3url11hex__digits[_p$12]);
          const _p$13 = _p$11 & 15;
          $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$13);
          _M0IPB13StringBuilderPB6Logger11write__char(_p$5, _M0FP210tonyfettes3url11hex__digits[_p$13]);
          break _L;
        } else {
          _M0IPB13StringBuilderPB6Logger11write__char(_p$5, _p$10);
        }
        break _L;
      }
      _tmp$38 = _p$8 + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGsRP210tonyfettes3url15ValidationErrorE2Ok(_p$5.val);
}
function _M0MP210tonyfettes3url4IPv413parse__number(input) {
  if (_M0MPC16string6String24char__length__eq_2einner(input.str, 0, input.start, input.end)) {
    return new _M0DTPC16result6ResultGmRP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error50tonyfettes_2furl_2eValidationError_2eIPv4EmptyPart__);
  }
  _L: {
    let rest;
    let c;
    _L$2: {
      let rest$2;
      _L$3: {
        if (_M0MPC16string6String24char__length__ge_2einner(input.str, 2, input.start, input.end)) {
          const _x = _M0MPC16string6String16unsafe__char__at(input.str, _M0MPC16string6String29offset__of__nth__char_2einner(input.str, 0, input.start, input.end));
          if (_x === 48) {
            const _x$2 = _M0MPC16string6String16unsafe__char__at(input.str, _M0MPC16string6String29offset__of__nth__char_2einner(input.str, 1, input.start, input.end));
            if (_x$2 === 120) {
              const _tmp$38 = input.str;
              const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(input.str, 2, input.start, input.end);
              let _tmp$39;
              if (_bind$4 === undefined) {
                _tmp$39 = input.end;
              } else {
                const _Some = _bind$4;
                _tmp$39 = _Some;
              }
              const _x$3 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, input.end);
              rest$2 = _x$3;
              break _L$3;
            } else {
              if (_x$2 === 88) {
                const _tmp$38 = input.str;
                const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(input.str, 2, input.start, input.end);
                let _tmp$39;
                if (_bind$4 === undefined) {
                  _tmp$39 = input.end;
                } else {
                  const _Some = _bind$4;
                  _tmp$39 = _Some;
                }
                const _x$3 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, input.end);
                rest$2 = _x$3;
                break _L$3;
              } else {
                if (_x$2 >= 48 && _x$2 <= 57) {
                  const _tmp$38 = input.str;
                  const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(input.str, 2, input.start, input.end);
                  let _tmp$39;
                  if (_bind$4 === undefined) {
                    _tmp$39 = input.end;
                  } else {
                    const _Some = _bind$4;
                    _tmp$39 = _Some;
                  }
                  const _x$3 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, input.end);
                  if (_x$2 >= 48 && _x$2 <= 55) {
                    const _p$4 = _x$2 - 48 | 0;
                    let value = BigInt.asUintN(64, BigInt(_p$4));
                    const _it = _M0MPC16string10StringView4iter(_x$3);
                    while (true) {
                      const _bind$5 = _M0MPB4Iter4nextGcE(_it);
                      if (_bind$5 === -1) {
                        break;
                      } else {
                        const _Some = _bind$5;
                        const _c = _Some;
                        if (_c >= 48 && _c <= 55) {
                          const _tmp$40 = BigInt.asUintN(64, value * 8n);
                          const _p$5 = _c - 48 | 0;
                          value = BigInt.asUintN(64, _tmp$40 + BigInt.asUintN(64, BigInt(_p$5)));
                        } else {
                          return new _M0DTPC16result6ResultGmRP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error55tonyfettes_2furl_2eValidationError_2eIPv4NonNumericPart__);
                        }
                        continue;
                      }
                    }
                    return new _M0DTPC16result6ResultGmRP210tonyfettes3url15ValidationErrorE2Ok(value);
                  } else {
                    return new _M0DTPC16result6ResultGmRP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error55tonyfettes_2furl_2eValidationError_2eIPv4NonNumericPart__);
                  }
                } else {
                  break _L;
                }
              }
            }
          } else {
            if (_x >= 49 && _x <= 57) {
              const _tmp$38 = input.str;
              const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(input.str, 1, input.start, input.end);
              let _tmp$39;
              if (_bind$4 === undefined) {
                _tmp$39 = input.end;
              } else {
                const _Some = _bind$4;
                _tmp$39 = _Some;
              }
              const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, input.end);
              rest = _x$2;
              c = _x;
              break _L$2;
            } else {
              break _L;
            }
          }
        } else {
          if (_M0MPC16string6String24char__length__eq_2einner(input.str, 1, input.start, input.end)) {
            const _x = _M0MPC16string6String16unsafe__char__at(input.str, _M0MPC16string6String29offset__of__nth__char_2einner(input.str, 0, input.start, input.end));
            if (_x === 48) {
              return new _M0DTPC16result6ResultGmRP210tonyfettes3url15ValidationErrorE2Ok(0n);
            } else {
              if (_x >= 49 && _x <= 57) {
                const _tmp$38 = input.str;
                const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(input.str, 1, input.start, input.end);
                let _tmp$39;
                if (_bind$4 === undefined) {
                  _tmp$39 = input.end;
                } else {
                  const _Some = _bind$4;
                  _tmp$39 = _Some;
                }
                const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, input.end);
                rest = _x$2;
                c = _x;
                break _L$2;
              } else {
                break _L;
              }
            }
          } else {
            break _L;
          }
        }
      }
      let value = 0n;
      const _it = _M0MPC16string10StringView4iter(rest$2);
      while (true) {
        const _bind$4 = _M0MPB4Iter4nextGcE(_it);
        if (_bind$4 === -1) {
          break;
        } else {
          const _Some = _bind$4;
          const _c = _Some;
          let digit;
          if (_c >= 48 && _c <= 57) {
            digit = _c - 48 | 0;
          } else {
            if (_c >= 97 && _c <= 102) {
              digit = (_c - 97 | 0) + 10 | 0;
            } else {
              if (_c >= 65 && _c <= 70) {
                digit = (_c - 65 | 0) + 10 | 0;
              } else {
                return new _M0DTPC16result6ResultGmRP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error55tonyfettes_2furl_2eValidationError_2eIPv4NonNumericPart__);
              }
            }
          }
          if (digit < 16) {
            value = BigInt.asUintN(64, BigInt.asUintN(64, value * 16n) + BigInt.asUintN(64, BigInt(digit)));
          } else {
            return new _M0DTPC16result6ResultGmRP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error55tonyfettes_2furl_2eValidationError_2eIPv4NonNumericPart__);
          }
          continue;
        }
      }
      return new _M0DTPC16result6ResultGmRP210tonyfettes3url15ValidationErrorE2Ok(value);
    }
    const _p$4 = c - 48 | 0;
    let value = BigInt.asUintN(64, BigInt(_p$4));
    const _it = _M0MPC16string10StringView4iter(rest);
    while (true) {
      const _bind$4 = _M0MPB4Iter4nextGcE(_it);
      if (_bind$4 === -1) {
        break;
      } else {
        const _Some = _bind$4;
        const _c = _Some;
        if (_c >= 48 && _c <= 57) {
          const _tmp$38 = BigInt.asUintN(64, value * 10n);
          const _p$5 = _c - 48 | 0;
          value = BigInt.asUintN(64, _tmp$38 + BigInt.asUintN(64, BigInt(_p$5)));
        } else {
          return new _M0DTPC16result6ResultGmRP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error55tonyfettes_2furl_2eValidationError_2eIPv4NonNumericPart__);
        }
        continue;
      }
    }
    return new _M0DTPC16result6ResultGmRP210tonyfettes3url15ValidationErrorE2Ok(value);
  }
  return new _M0DTPC16result6ResultGmRP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error55tonyfettes_2furl_2eValidationError_2eIPv4NonNumericPart__);
}
function _M0MP210tonyfettes3url4IPv45parse(input) {
  const parts = _M0MPB4Iter9to__arrayGRPB4JsonE(_M0MPC16string10StringView5split(input, new _M0TPC16string10StringView(_M0MP210tonyfettes3url4IPv45parseN7_2abindS1036, 0, _M0MP210tonyfettes3url4IPv45parseN7_2abindS1036.length)));
  let parts$2;
  _L: {
    _L$2: {
      if (parts.length >= 1) {
        const _x = parts[parts.length - 1 | 0];
        if (_M0MPC16string6String24char__length__eq_2einner(_x.str, 0, _x.start, _x.end)) {
          parts$2 = _M0MPC15array5Array12view_2einnerGsE(parts, 0, parts.length - 1 | 0);
        } else {
          break _L$2;
        }
      } else {
        break _L$2;
      }
      break _L;
    }
    parts$2 = new _M0TPB9ArrayViewGRPC16string10StringViewE(parts, 0, parts.length);
  }
  if ((parts$2.end - parts$2.start | 0) > 4) {
    return new _M0DTPC16result6ResultGRP210tonyfettes3url4IPv4RP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error53tonyfettes_2furl_2eValidationError_2eIPv4TooManyParts__);
  }
  const numbers = [];
  const _bind$4 = parts$2.end - parts$2.start | 0;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const part = parts$2.buf[parts$2.start + _ | 0];
      const _bind$5 = _M0MP210tonyfettes3url4IPv413parse__number(part);
      let number;
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        number = _ok._0;
      } else {
        return _bind$5;
      }
      _M0MPC15array5Array4pushGUssEE(numbers, number);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (numbers.length >= 1) {
    const _last_number = numbers[numbers.length - 1 | 0];
    const _x = _M0MPC15array5Array12view_2einnerGsE(numbers, 0, numbers.length - 1 | 0);
    const _bind$5 = _x.end - _x.start | 0;
    let _tmp$39 = 0;
    while (true) {
      const _ = _tmp$39;
      if (_ < _bind$5) {
        const number = _x.buf[_x.start + _ | 0];
        if (BigInt.asUintN(64, number) > BigInt.asUintN(64, 255n)) {
          return new _M0DTPC16result6ResultGRP210tonyfettes3url4IPv4RP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error55tonyfettes_2furl_2eValidationError_2eIPv4OutOfRangePart__);
        }
        _tmp$39 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    if (BigInt.asUintN(64, _last_number) >= BigInt.asUintN(64, BigInt.asUintN(64, 1n << BigInt(Math.imul(8, 4 - (_x.end - _x.start | 0) | 0) & 63)))) {
      return new _M0DTPC16result6ResultGRP210tonyfettes3url4IPv4RP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error55tonyfettes_2furl_2eValidationError_2eIPv4OutOfRangePart__);
    }
    let ipv4 = Number(BigInt.asUintN(32, _last_number)) | 0;
    let counter = 0;
    const _bind$6 = _x.end - _x.start | 0;
    let _tmp$40 = 0;
    while (true) {
      const _ = _tmp$40;
      if (_ < _bind$6) {
        const n = _x.buf[_x.start + _ | 0];
        ipv4 = (ipv4 >>> 0) + (Number(BigInt.asUintN(32, n)) << (Math.imul(8, 3 - counter | 0) | 0) >>> 0) | 0;
        counter = counter + 1 | 0;
        _tmp$40 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return new _M0DTPC16result6ResultGRP210tonyfettes3url4IPv4RP210tonyfettes3url15ValidationErrorE2Ok(ipv4);
  } else {
    return new _M0DTPC16result6ResultGRP210tonyfettes3url4IPv4RP210tonyfettes3url15ValidationErrorE2Ok(_M0FPC15abort5abortGRP210tonyfettes3url4IPv4E("unreachable"));
  }
}
function _M0MP210tonyfettes3url4IPv65parse(input) {
  const address = $make_array_len_and_init(8, 0);
  let piece_index = 0;
  let compress = undefined;
  let input$2;
  _L: {
    _L$2: {
      if (_M0MPC16string6String24char__length__ge_2einner(input.str, 2, input.start, input.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(input.str, _M0MPC16string6String29offset__of__nth__char_2einner(input.str, 0, input.start, input.end));
        if (_x === 58) {
          const _x$2 = _M0MPC16string6String16unsafe__char__at(input.str, _M0MPC16string6String29offset__of__nth__char_2einner(input.str, 1, input.start, input.end));
          if (_x$2 === 58) {
            const _tmp$38 = input.str;
            const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(input.str, 2, input.start, input.end);
            let _tmp$39;
            if (_bind$4 === undefined) {
              _tmp$39 = input.end;
            } else {
              const _Some = _bind$4;
              _tmp$39 = _Some;
            }
            const _x$3 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, input.end);
            piece_index = piece_index + 1 | 0;
            compress = piece_index;
            input$2 = _x$3;
          } else {
            break _L$2;
          }
        } else {
          input$2 = input;
        }
      } else {
        if (_M0MPC16string6String24char__length__ge_2einner(input.str, 1, input.start, input.end)) {
          const _x = _M0MPC16string6String16unsafe__char__at(input.str, _M0MPC16string6String29offset__of__nth__char_2einner(input.str, 0, input.start, input.end));
          if (_x === 58) {
            break _L$2;
          } else {
            input$2 = input;
          }
        } else {
          input$2 = input;
        }
      }
      break _L;
    }
    return new _M0DTPC16result6ResultGRP210tonyfettes3url4IPv6RP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error59tonyfettes_2furl_2eValidationError_2eIPv6InvalidCompression__);
  }
  let _tmp$38 = input$2;
  while (true) {
    const _param = _tmp$38;
    if (_M0MPC16string6String24char__length__eq_2einner(_param.str, 0, _param.start, _param.end)) {
      break;
    } else {
      if (piece_index === 8) {
        return new _M0DTPC16result6ResultGRP210tonyfettes3url4IPv6RP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error54tonyfettes_2furl_2eValidationError_2eIPv6TooManyPieces__);
      } else {
        const _x = _M0MPC16string6String16unsafe__char__at(_param.str, _M0MPC16string6String29offset__of__nth__char_2einner(_param.str, 0, _param.start, _param.end));
        if (_x === 58) {
          const _tmp$39 = _param.str;
          const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(_param.str, 1, _param.start, _param.end);
          let _tmp$40;
          if (_bind$4 === undefined) {
            _tmp$40 = _param.end;
          } else {
            const _Some = _bind$4;
            _tmp$40 = _Some;
          }
          const _x$2 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, _param.end);
          const _bind$5 = compress;
          if (_bind$5 === undefined) {
          } else {
            return new _M0DTPC16result6ResultGRP210tonyfettes3url4IPv6RP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error60tonyfettes_2furl_2eValidationError_2eIPv6MultipleCompression__);
          }
          piece_index = piece_index + 1 | 0;
          compress = piece_index;
          _tmp$38 = _x$2;
          continue;
        } else {
          let value = 0;
          let length = 0;
          let remaining;
          let _tmp$39 = _param;
          while (true) {
            const input$3 = _tmp$39;
            if (length < 4) {
              _L$2: {
                if (_M0MPC16string6String24char__length__ge_2einner(input$3.str, 1, input$3.start, input$3.end)) {
                  const _x$2 = _M0MPC16string6String16unsafe__char__at(input$3.str, _M0MPC16string6String29offset__of__nth__char_2einner(input$3.str, 0, input$3.start, input$3.end));
                  if (_x$2 >= 48 && _x$2 <= 57) {
                    const _tmp$40 = input$3.str;
                    const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(input$3.str, 1, input$3.start, input$3.end);
                    let _tmp$41;
                    if (_bind$4 === undefined) {
                      _tmp$41 = input$3.end;
                    } else {
                      const _Some = _bind$4;
                      _tmp$41 = _Some;
                    }
                    const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, input$3.end);
                    const _p$4 = value;
                    const _p$5 = 16;
                    const _p$6 = (Math.imul(_p$4, _p$5) | 0) & 65535;
                    const _p$7 = _x$2 & 65535;
                    const _p$8 = 48;
                    const _p$9 = (_p$7 - _p$8 | 0) & 65535;
                    value = (_p$6 + _p$9 | 0) & 65535;
                    length = length + 1 | 0;
                    _tmp$39 = _x$3;
                    continue;
                  } else {
                    if (_x$2 >= 97 && _x$2 <= 102) {
                      const _tmp$40 = input$3.str;
                      const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(input$3.str, 1, input$3.start, input$3.end);
                      let _tmp$41;
                      if (_bind$4 === undefined) {
                        _tmp$41 = input$3.end;
                      } else {
                        const _Some = _bind$4;
                        _tmp$41 = _Some;
                      }
                      const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, input$3.end);
                      const _p$4 = value;
                      const _p$5 = 16;
                      const _p$6 = (Math.imul(_p$4, _p$5) | 0) & 65535;
                      const _p$7 = _x$2 & 65535;
                      const _p$8 = 97;
                      const _p$9 = (_p$7 - _p$8 | 0) & 65535;
                      const _p$10 = 10;
                      const _p$11 = (_p$9 + _p$10 | 0) & 65535;
                      value = (_p$6 + _p$11 | 0) & 65535;
                      length = length + 1 | 0;
                      _tmp$39 = _x$3;
                      continue;
                    } else {
                      if (_x$2 >= 65 && _x$2 <= 70) {
                        const _tmp$40 = input$3.str;
                        const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(input$3.str, 1, input$3.start, input$3.end);
                        let _tmp$41;
                        if (_bind$4 === undefined) {
                          _tmp$41 = input$3.end;
                        } else {
                          const _Some = _bind$4;
                          _tmp$41 = _Some;
                        }
                        const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, input$3.end);
                        const _p$4 = value;
                        const _p$5 = 16;
                        const _p$6 = (Math.imul(_p$4, _p$5) | 0) & 65535;
                        const _p$7 = _x$2 & 65535;
                        const _p$8 = 65;
                        const _p$9 = (_p$7 - _p$8 | 0) & 65535;
                        const _p$10 = 10;
                        const _p$11 = (_p$9 + _p$10 | 0) & 65535;
                        value = (_p$6 + _p$11 | 0) & 65535;
                        length = length + 1 | 0;
                        _tmp$39 = _x$3;
                        continue;
                      } else {
                        break _L$2;
                      }
                    }
                  }
                } else {
                  break _L$2;
                }
              }
              remaining = input$3;
              break;
            } else {
              remaining = input$3;
              break;
            }
          }
          let remaining$2;
          _L$2: {
            _L$3: {
              if (_M0MPC16string6String24char__length__eq_2einner(remaining.str, 0, remaining.start, remaining.end)) {
                remaining$2 = remaining;
              } else {
                const _x$2 = _M0MPC16string6String16unsafe__char__at(remaining.str, _M0MPC16string6String29offset__of__nth__char_2einner(remaining.str, 0, remaining.start, remaining.end));
                if (_x$2 === 46) {
                  if (length === 0) {
                    return new _M0DTPC16result6ResultGRP210tonyfettes3url4IPv6RP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error63tonyfettes_2furl_2eValidationError_2eIPv4InIPv6InvalidCodePoint__);
                  }
                  if (piece_index > 6) {
                    return new _M0DTPC16result6ResultGRP210tonyfettes3url4IPv6RP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error60tonyfettes_2furl_2eValidationError_2eIPv4InIPv6TooManyPieces__);
                  }
                  let numbers_seen = 0;
                  let _tmp$40 = _param.str;
                  let _tmp$41 = _param.start;
                  let _tmp$42 = _param.end;
                  while (true) {
                    const _param_str = _tmp$40;
                    const _param_start = _tmp$41;
                    const _param_end = _tmp$42;
                    if (_M0MPC16string6String24char__length__eq_2einner(_param_str, 0, _param_start, _param_end)) {
                      break;
                    } else {
                      const _x$3 = _M0MPC16string6String16unsafe__char__at(_param_str, _M0MPC16string6String29offset__of__nth__char_2einner(_param_str, 0, _param_start, _param_end));
                      if (_x$3 === 46) {
                        const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(_param_str, 1, _param_start, _param_end);
                        let _bind$5;
                        if (_bind$4 === undefined) {
                          _bind$5 = _param_end;
                        } else {
                          const _Some = _bind$4;
                          _bind$5 = _Some;
                        }
                        const _bind$6 = numbers_seen;
                        if (_bind$6 >= 1 && _bind$6 < 4) {
                          _tmp$41 = _bind$5;
                          continue;
                        } else {
                          return new _M0DTPC16result6ResultGRP210tonyfettes3url4IPv6RP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error63tonyfettes_2furl_2eValidationError_2eIPv4InIPv6InvalidCodePoint__);
                        }
                      } else {
                        if (_x$3 >= 48 && _x$3 <= 57) {
                          const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(_param_str, 1, _param_start, _param_end);
                          let _tmp$43;
                          if (_bind$4 === undefined) {
                            _tmp$43 = _param_end;
                          } else {
                            const _Some = _bind$4;
                            _tmp$43 = _Some;
                          }
                          const _x$4 = new _M0TPC16string10StringView(_param_str, _tmp$43, _param_end);
                          const _p$4 = _x$3 & 65535;
                          const _p$5 = 48;
                          let ipv4_piece = (_p$4 - _p$5 | 0) & 65535;
                          let remaining$3;
                          let _tmp$44 = _x$4;
                          while (true) {
                            const _param$2 = _tmp$44;
                            let remaining$4;
                            _L$4: {
                              if (_M0MPC16string6String24char__length__ge_2einner(_param$2.str, 1, _param$2.start, _param$2.end)) {
                                const _x$5 = _M0MPC16string6String16unsafe__char__at(_param$2.str, _M0MPC16string6String29offset__of__nth__char_2einner(_param$2.str, 0, _param$2.start, _param$2.end));
                                if (_x$5 >= 48 && _x$5 <= 57) {
                                  const _tmp$45 = _param$2.str;
                                  const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(_param$2.str, 1, _param$2.start, _param$2.end);
                                  let _tmp$46;
                                  if (_bind$5 === undefined) {
                                    _tmp$46 = _param$2.end;
                                  } else {
                                    const _Some = _bind$5;
                                    _tmp$46 = _Some;
                                  }
                                  const _x$6 = new _M0TPC16string10StringView(_tmp$45, _tmp$46, _param$2.end);
                                  const _p$6 = _x$5 & 65535;
                                  const _p$7 = 48;
                                  const number = (_p$6 - _p$7 | 0) & 65535;
                                  const _bind$6 = ipv4_piece;
                                  if (_bind$6 === 0) {
                                    return new _M0DTPC16result6ResultGRP210tonyfettes3url4IPv6RP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error63tonyfettes_2furl_2eValidationError_2eIPv4InIPv6InvalidCodePoint__);
                                  }
                                  const _p$8 = ipv4_piece;
                                  const _p$9 = 10;
                                  const _p$10 = (Math.imul(_p$8, _p$9) | 0) & 65535;
                                  ipv4_piece = (_p$10 + number | 0) & 65535;
                                  if (_M0IP016_24default__implPB7Compare6op__gtGkE(ipv4_piece, 255)) {
                                    return new _M0DTPC16result6ResultGRP210tonyfettes3url4IPv6RP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error61tonyfettes_2furl_2eValidationError_2eIPv4InIPv6OutOfRangePart__);
                                  }
                                  _tmp$44 = _x$6;
                                  continue;
                                } else {
                                  remaining$4 = _param$2;
                                  break _L$4;
                                }
                              } else {
                                remaining$4 = _param$2;
                                break _L$4;
                              }
                            }
                            remaining$3 = remaining$4;
                            break;
                          }
                          const _tmp$45 = piece_index;
                          const _tmp$46 = piece_index;
                          $bound_check(address, _tmp$46);
                          const _p$6 = address[_tmp$46];
                          const _p$7 = 256;
                          const _p$8 = (Math.imul(_p$6, _p$7) | 0) & 65535;
                          const _p$9 = ipv4_piece;
                          $bound_check(address, _tmp$45);
                          address[_tmp$45] = (_p$8 + _p$9 | 0) & 65535;
                          numbers_seen = numbers_seen + 1 | 0;
                          _L$4: {
                            _L$5: {
                              const _bind$5 = numbers_seen;
                              switch (_bind$5) {
                                case 2: {
                                  break _L$5;
                                }
                                case 4: {
                                  break _L$5;
                                }
                              }
                              break _L$4;
                            }
                            piece_index = piece_index + 1 | 0;
                          }
                          _tmp$40 = remaining$3.str;
                          _tmp$41 = remaining$3.start;
                          _tmp$42 = remaining$3.end;
                          continue;
                        } else {
                          return new _M0DTPC16result6ResultGRP210tonyfettes3url4IPv6RP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error63tonyfettes_2furl_2eValidationError_2eIPv4InIPv6InvalidCodePoint__);
                        }
                      }
                    }
                  }
                  if (numbers_seen !== 4) {
                    return new _M0DTPC16result6ResultGRP210tonyfettes3url4IPv6RP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error58tonyfettes_2furl_2eValidationError_2eIPv4InIPv6TooFewParts__);
                  }
                  break;
                } else {
                  if (_M0MPC16string6String24char__length__eq_2einner(remaining.str, 1, remaining.start, remaining.end)) {
                    if (_x$2 === 58) {
                      return new _M0DTPC16result6ResultGRP210tonyfettes3url4IPv6RP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error57tonyfettes_2furl_2eValidationError_2eIPv6InvalidCodePoint__);
                    } else {
                      break _L$3;
                    }
                  } else {
                    if (_x$2 === 58) {
                      const _tmp$40 = remaining.str;
                      const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(remaining.str, 1, remaining.start, remaining.end);
                      let _tmp$41;
                      if (_bind$4 === undefined) {
                        _tmp$41 = remaining.end;
                      } else {
                        const _Some = _bind$4;
                        _tmp$41 = _Some;
                      }
                      remaining$2 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, remaining.end);
                    } else {
                      break _L$3;
                    }
                  }
                }
              }
              break _L$2;
            }
            return new _M0DTPC16result6ResultGRP210tonyfettes3url4IPv6RP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error57tonyfettes_2furl_2eValidationError_2eIPv6InvalidCodePoint__);
          }
          const _tmp$40 = piece_index;
          $bound_check(address, _tmp$40);
          address[_tmp$40] = value;
          piece_index = piece_index + 1 | 0;
          _tmp$38 = remaining$2;
          continue;
        }
      }
    }
  }
  const _bind$4 = compress;
  if (_bind$4 === undefined) {
    if (piece_index !== 8) {
      return new _M0DTPC16result6ResultGRP210tonyfettes3url4IPv6RP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error53tonyfettes_2furl_2eValidationError_2eIPv6TooFewPieces__);
    }
  } else {
    const _Some = _bind$4;
    const _compress = _Some;
    let swaps = piece_index - _compress | 0;
    piece_index = 7;
    while (true) {
      if (piece_index !== 0 && swaps > 0) {
        _M0MPC15array10FixedArray4swapGkE(address, piece_index, (_compress + swaps | 0) - 1 | 0);
        piece_index = piece_index - 1 | 0;
        swaps = swaps - 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  return new _M0DTPC16result6ResultGRP210tonyfettes3url4IPv6RP210tonyfettes3url15ValidationErrorE2Ok(address);
}
function _M0MP210tonyfettes3url4Host13parse_2einner(input, is_opaque) {
  let input$2;
  _L: {
    _L$2: {
      if (_M0MPC16string6String24char__length__ge_2einner(input.str, 2, input.start, input.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(input.str, _M0MPC16string6String29offset__of__nth__char_2einner(input.str, 0, input.start, input.end));
        if (_x === 91) {
          const _x$2 = _M0MPC16string6String16unsafe__char__at(input.str, _M0MPC16string6String29offset__of__nth__char_2einner(input.str, -1, input.start, input.end));
          if (_x$2 === 93) {
            const _tmp$38 = input.str;
            const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(input.str, 1, input.start, input.end);
            let _tmp$39;
            if (_bind$4 === undefined) {
              _tmp$39 = input.end;
            } else {
              const _Some = _bind$4;
              _tmp$39 = _Some;
            }
            const _x$3 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _M0MPC16string6String29offset__of__nth__char_2einner(input.str, -1, input.start, input.end));
            const _bind$5 = _M0MP210tonyfettes3url4IPv65parse(_x$3);
            let ipv6;
            if (_bind$5.$tag === 1) {
              const _ok = _bind$5;
              ipv6 = _ok._0;
            } else {
              return _bind$5;
            }
            return new _M0DTPC16result6ResultGRP210tonyfettes3url4HostRP210tonyfettes3url15ValidationErrorE2Ok(new _M0DTP210tonyfettes3url4Host4IPv6(ipv6));
          } else {
            break _L$2;
          }
        } else {
          input$2 = input;
          break _L;
        }
      } else {
        if (_M0MPC16string6String24char__length__ge_2einner(input.str, 1, input.start, input.end)) {
          const _x = _M0MPC16string6String16unsafe__char__at(input.str, _M0MPC16string6String29offset__of__nth__char_2einner(input.str, 0, input.start, input.end));
          if (_x === 91) {
            break _L$2;
          } else {
            input$2 = input;
            break _L;
          }
        } else {
          input$2 = input;
          break _L;
        }
      }
    }
    return new _M0DTPC16result6ResultGRP210tonyfettes3url4HostRP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error49tonyfettes_2furl_2eValidationError_2eIPv6Unclosed__);
  }
  if (is_opaque) {
    const _bind$4 = _M0MP210tonyfettes3url4Host13parse__opaque(input$2);
    let opaque_host;
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      opaque_host = _ok._0;
    } else {
      return _bind$4;
    }
    return new _M0DTPC16result6ResultGRP210tonyfettes3url4HostRP210tonyfettes3url15ValidationErrorE2Ok(new _M0DTP210tonyfettes3url4Host6Opaque(opaque_host));
  }
  const _bind$4 = _M0FP210tonyfettes3url23percent__decode__string(input$2);
  const domain = _M0FPC28encoding4utf821decode__lossy_2einner(_M0MPC15bytes5Bytes12view_2einner(_bind$4, 0, _bind$4.length), false);
  let ascii_domain;
  let _try_err;
  _L$2: {
    _L$3: {
      const _bind$5 = _M0FP310tonyfettes7unicode4idna17to__ascii_2einner(domain, false, true, true, true, false);
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        ascii_domain = _ok._0;
      } else {
        const _err = _bind$5;
        _try_err = _err._0;
        break _L$3;
      }
      break _L$2;
    }
    if (_try_err.$tag === 49) {
      const _p$4 = _M0MPC16string6String4iter(domain);
      let is_valid_ascii_domain;
      while (true) {
        const _p$5 = _M0MPB4Iter4nextGcE(_p$4);
        if (_p$5 === -1) {
          is_valid_ascii_domain = true;
          break;
        } else {
          const _p$6 = _p$5;
          const _p$7 = _p$6;
          let _tmp$38;
          if (_M0MPC14char4Char20is__ascii__lowercase(_p$7)) {
            _tmp$38 = true;
          } else {
            let _tmp$39;
            if (_M0MPC14char4Char20is__ascii__uppercase(_p$7)) {
              _tmp$39 = true;
            } else {
              let _tmp$40;
              if (_M0MPC14char4Char16is__ascii__digit(_p$7)) {
                _tmp$40 = true;
              } else {
                let _tmp$41;
                switch (_p$7) {
                  case 46: {
                    _tmp$41 = true;
                    break;
                  }
                  case 45: {
                    _tmp$41 = true;
                    break;
                  }
                  default: {
                    _tmp$41 = false;
                  }
                }
                _tmp$40 = _tmp$41;
              }
              _tmp$39 = _tmp$40;
            }
            _tmp$38 = _tmp$39;
          }
          if (_tmp$38) {
          } else {
            is_valid_ascii_domain = false;
            break;
          }
          continue;
        }
      }
      if (is_valid_ascii_domain && !(domain === "")) {
        ascii_domain = domain;
      } else {
        return new _M0DTPC16result6ResultGRP210tonyfettes3url4HostRP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error50tonyfettes_2furl_2eValidationError_2eDomainToAscii__);
      }
    } else {
      const _p$4 = _M0MPC16string6String4iter(domain);
      let is_ascii;
      while (true) {
        const _p$5 = _M0MPB4Iter4nextGcE(_p$4);
        if (_p$5 === -1) {
          is_ascii = true;
          break;
        } else {
          const _p$6 = _p$5;
          const _p$7 = _p$6;
          if (_p$7 < 128) {
          } else {
            is_ascii = false;
            break;
          }
          continue;
        }
      }
      const has_punycode_label = _M0MPC16string6String8contains(_M0MPC16string6String9to__lower(domain), new _M0TPC16string10StringView(_M0MP210tonyfettes3url4Host13parse_2einnerN7_2abindS1118, 0, _M0MP210tonyfettes3url4Host13parse_2einnerN7_2abindS1118.length));
      if (is_ascii && (!_M0FP210tonyfettes3url38contains__forbidden__domain__codepoint(domain) && !has_punycode_label)) {
        ascii_domain = domain;
      } else {
        return new _M0DTPC16result6ResultGRP210tonyfettes3url4HostRP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error50tonyfettes_2furl_2eValidationError_2eDomainToAscii__);
      }
    }
  }
  if (_M0FP210tonyfettes3url38contains__forbidden__domain__codepoint(ascii_domain)) {
    return new _M0DTPC16result6ResultGRP210tonyfettes3url4HostRP210tonyfettes3url15ValidationErrorE3Err(_M0DTPC15error5Error57tonyfettes_2furl_2eValidationError_2eHostInvalidCodePoint__);
  }
  if (_M0FP210tonyfettes3url19ends__in__a__number(new _M0TPC16string10StringView(ascii_domain, 0, ascii_domain.length))) {
    const _bind$5 = _M0MP210tonyfettes3url4IPv45parse(new _M0TPC16string10StringView(ascii_domain, 0, ascii_domain.length));
    let _tmp$38;
    if (_bind$5.$tag === 1) {
      const _ok = _bind$5;
      _tmp$38 = _ok._0;
    } else {
      return _bind$5;
    }
    return new _M0DTPC16result6ResultGRP210tonyfettes3url4HostRP210tonyfettes3url15ValidationErrorE2Ok(new _M0DTP210tonyfettes3url4Host4IPv4(_tmp$38));
  }
  return new _M0DTPC16result6ResultGRP210tonyfettes3url4HostRP210tonyfettes3url15ValidationErrorE2Ok(new _M0DTP210tonyfettes3url4Host6Domain(ascii_domain));
}
function _M0MP210tonyfettes3url4Path5clone(self) {
  if (self.$tag === 0) {
    const _Opaque = self;
    const _s = _Opaque._0;
    return new _M0DTP210tonyfettes3url4Path6Opaque(_s);
  } else {
    const _Segments = self;
    const _segments = _Segments._0;
    return new _M0DTP210tonyfettes3url4Path8Segments(_M0MPC15array5Array4copyGRPB4JsonE(_segments));
  }
}
function _M0MP210tonyfettes3url4Path15shorten_2einner(self, scheme) {
  if (self.$tag === 0) {
    return;
  } else {
    const _Segments = self;
    const _segments = _Segments._0;
    if (scheme === "file" && _segments.length === 1) {
      const _bind$4 = _M0MPC15array5Array3getGsE(_segments, 0);
      if (_bind$4 === undefined) {
      } else {
        const _Some = _bind$4;
        const _first = _Some;
        if (_first.length === 2) {
          if (_M0MPC16string6String24char__length__eq_2einner(_first, 2, 0, _first.length)) {
            const _letter = _M0MPC16string6String16unsafe__char__at(_first, _M0MPC16string6String29offset__of__nth__char_2einner(_first, 0, 0, _first.length));
            const _x = _M0MPC16string6String16unsafe__char__at(_first, _M0MPC16string6String29offset__of__nth__char_2einner(_first, 1, 0, _first.length));
            if (_x === 58) {
              if (_M0MPC14char4Char21is__ascii__alphabetic(_letter)) {
                return undefined;
              }
            }
          }
        }
      }
    }
    if (!(_segments.length === 0)) {
      _M0MPC15array5Array3popGsE(_segments);
      return;
    } else {
      return;
    }
  }
}
function _M0MP210tonyfettes3url13StringPointer8decrease(self) {
  const _p$4 = self.input;
  const before = _M0MPC16string6String12view_2einner(_p$4.str, 0, self.pointer);
  if (_M0MPC16string6String24char__length__eq_2einner(before.str, 0, before.start, before.end)) {
    return;
  } else {
    if (_M0MPC16string6String24char__length__eq_2einner(before.str, 1, before.start, before.end)) {
      self.pointer = before.start;
      return;
    } else {
      let current_offset = before.start;
      const _bind$4 = before.str;
      const _bind$5 = before.start;
      const _bind$6 = before.end;
      let _tmp$38 = _bind$5;
      while (true) {
        const view_start = _tmp$38;
        if (_M0MPC16string6String24char__length__eq_2einner(_bind$4, 1, view_start, _bind$6)) {
          self.pointer = current_offset;
          return;
        } else {
          if (_M0MPC16string6String24char__length__ge_2einner(_bind$4, 1, view_start, _bind$6)) {
            const _bind$7 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4, 1, view_start, _bind$6);
            let _bind$8;
            if (_bind$7 === undefined) {
              _bind$8 = _bind$6;
            } else {
              const _Some = _bind$7;
              _bind$8 = _Some;
            }
            const _x = new _M0TPC16string10StringView(_bind$4, _bind$8, _bind$6);
            current_offset = _x.start;
            _tmp$38 = _bind$8;
            continue;
          } else {
            return;
          }
        }
      }
    }
  }
}
function _M0MP210tonyfettes3url13StringPointer4view(self) {
  const _p$4 = self.input;
  return _M0MPC16string6String12view_2einner(_p$4.str, self.pointer, undefined);
}
function _M0MP210tonyfettes3url13StringPointer8increase(self) {
  const _bind$4 = _M0MP210tonyfettes3url13StringPointer4view(self);
  if (_M0MPC16string6String24char__length__eq_2einner(_bind$4.str, 0, _bind$4.start, _bind$4.end)) {
    return;
  } else {
    const _tmp$38 = _bind$4.str;
    const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
    let _tmp$39;
    if (_bind$5 === undefined) {
      _tmp$39 = _bind$4.end;
    } else {
      const _Some = _bind$5;
      _tmp$39 = _Some;
    }
    const _x = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$4.end);
    self.pointer = _x.start;
    return;
  }
}
function _M0MP210tonyfettes3url13StringPointer3new(input) {
  return new _M0TP210tonyfettes3url13StringPointer(input, input.start);
}
function _M0MP210tonyfettes3url13StringPointer4next(self) {
  const _bind$4 = _M0MP210tonyfettes3url13StringPointer4view(self);
  if (_M0MPC16string6String24char__length__eq_2einner(_bind$4.str, 0, _bind$4.start, _bind$4.end)) {
    return _bind$4;
  } else {
    const _tmp$38 = _bind$4.str;
    const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
    let _tmp$39;
    if (_bind$5 === undefined) {
      _tmp$39 = _bind$4.end;
    } else {
      const _Some = _bind$5;
      _tmp$39 = _Some;
    }
    const _x = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$4.end);
    self.pointer = _x.start;
    return _x;
  }
}
function _M0MP210tonyfettes3url13StringPointer11start__over(self) {
  const _p$4 = self.input;
  self.pointer = _p$4.start;
}
function _M0MP210tonyfettes3url3Url11is__special(url) {
  const _bind$4 = url.scheme;
  return _M0FP210tonyfettes3url19is__special__scheme(new _M0TPC16string10StringView(_bind$4, 0, _bind$4.length));
}
function _M0MP210tonyfettes3url3Url20parse__basic_2einner(url, base, input, state_override, validation_errors) {
  const has_state_override = !(state_override === undefined);
  let state;
  if (state_override === undefined) {
    state = 0;
  } else {
    const _Some = state_override;
    state = _Some;
  }
  if (has_state_override) {
    if (url.scheme === "file") {
      _L: {
        _L$2: {
          const _bind$4 = state;
          if (_bind$4 === 13) {
            break _L$2;
          } else {
            const _bind$5 = state;
            if (_bind$5 === 14) {
              break _L$2;
            }
          }
          break _L;
        }
        state = 5;
      }
    }
  }
  const buffer = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let at_sign_seen = false;
  let inside_brackets = false;
  let password_token_seen = false;
  const input$2 = has_state_override ? input : _M0FP210tonyfettes3url28trim__c0__control__or__space(input);
  const input$3 = _M0FP210tonyfettes3url31remove__ascii__tab__or__newline(input$2);
  if (input$3 === "" && !has_state_override) {
    if (base === undefined) {
      _M0MPC15array5Array4pushGUssEE(validation_errors, _M0DTPC15error5Error64tonyfettes_2furl_2eValidationError_2eMissingSchemeNonRelativeUrl__);
      return undefined;
    } else {
      const _Some = base;
      const _base = _Some;
      url.scheme = _base.scheme;
      url.username = _base.username;
      url.password = _base.password;
      url.host = _base.host;
      url.port = _base.port;
      url.path = _M0MP210tonyfettes3url4Path5clone(_base.path);
      url.query = _base.query;
      return url;
    }
  }
  const pointer = _M0MP210tonyfettes3url13StringPointer3new(new _M0TPC16string10StringView(input$3, 0, input$3.length));
  _L: while (true) {
    let _tmp$38 = _M0MP210tonyfettes3url13StringPointer4view(pointer);
    _L$2: while (true) {
      const view = _tmp$38;
      if (_M0MPC16string6String24char__length__ge_2einner(view.str, 1, view.start, view.end)) {
        const _c = _M0MPC16string6String16unsafe__char__at(view.str, _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 0, view.start, view.end));
        const _bind$4 = view.str;
        const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 1, view.start, view.end);
        let _bind$6;
        if (_bind$5 === undefined) {
          _bind$6 = view.end;
        } else {
          const _Some = _bind$5;
          _bind$6 = _Some;
        }
        const _bind$7 = view.end;
        const _x = new _M0TPC16string10StringView(_bind$4, _bind$6, _bind$7);
        _L$3: {
          _L$4: {
            const _bind$8 = state;
            switch (_bind$8) {
              case 0: {
                if (_M0MPC14char4Char21is__ascii__alphabetic(_c)) {
                  _M0IPB13StringBuilderPB6Logger11write__char(buffer, _M0MPC14char4Char20to__ascii__lowercase(_c));
                  state = 1;
                } else {
                  if (!has_state_override) {
                    state = 2;
                    continue _L$2;
                  } else {
                    return undefined;
                  }
                }
                break;
              }
              case 1: {
                _L$5: {
                  _L$6: {
                    if (_c >= 97 && _c <= 122) {
                      break _L$6;
                    } else {
                      if (_c >= 65 && _c <= 90) {
                        break _L$6;
                      } else {
                        if (_c >= 48 && _c <= 57) {
                          break _L$6;
                        } else {
                          if (_c === 43) {
                            break _L$6;
                          } else {
                            if (_c === 45) {
                              break _L$6;
                            } else {
                              if (_c === 46) {
                                break _L$6;
                              } else {
                                if (_c === 58) {
                                  const next_scheme = buffer.val;
                                  if (has_state_override) {
                                    const url_special = _M0MP210tonyfettes3url3Url11is__special(url);
                                    const next_special = _M0FP210tonyfettes3url19is__special__scheme(new _M0TPC16string10StringView(next_scheme, 0, next_scheme.length));
                                    if (url_special && !next_special) {
                                      return url;
                                    }
                                    if (!url_special && next_special) {
                                      return url;
                                    }
                                    _L$7: {
                                      _L$8: {
                                        const _p$4 = url.username;
                                        if (!(_p$4 === "")) {
                                          break _L$8;
                                        } else {
                                          const _p$5 = url.password;
                                          if (!(_p$5 === "")) {
                                            break _L$8;
                                          } else {
                                            const _bind$9 = url.port;
                                            if (_bind$9 === -1) {
                                            } else {
                                              break _L$8;
                                            }
                                          }
                                        }
                                        break _L$7;
                                      }
                                      if (next_scheme === "file") {
                                        return url;
                                      }
                                    }
                                    if (url.scheme === "file" && _M0FP210tonyfettes3url16has__empty__host(url.host)) {
                                      return url;
                                    }
                                  }
                                  url.scheme = next_scheme;
                                  _M0MPB13StringBuilder5reset(buffer);
                                  if (has_state_override) {
                                    const _bind$9 = url.port;
                                    if (_bind$9 === -1) {
                                    } else {
                                      const _Some = _bind$9;
                                      const _port = _Some;
                                      const _bind$10 = url.scheme;
                                      const _bind$11 = _M0FP210tonyfettes3url13default__port(new _M0TPC16string10StringView(_bind$10, 0, _bind$10.length));
                                      if (_bind$11 === -1) {
                                      } else {
                                        const _Some$2 = _bind$11;
                                        const _default = _Some$2;
                                        if (_port === _default) {
                                          url.port = -1;
                                        }
                                      }
                                    }
                                    return url;
                                  }
                                  const _bind$9 = url.scheme;
                                  if (_bind$9 === "file") {
                                    if (_M0MPC16string10StringView11has__prefix(_x, new _M0TPC16string10StringView(_M0MP210tonyfettes3url3Url20parse__basic_2einnerN7_2abindS1226, 0, _M0MP210tonyfettes3url3Url20parse__basic_2einnerN7_2abindS1226.length))) {
                                      _M0MPC15array5Array4pushGUssEE(validation_errors, _M0DTPC15error5Error73tonyfettes_2furl_2eValidationError_2eSpecialSchemeMissingFollowingSolidus__);
                                    }
                                    state = 3;
                                  } else {
                                    _L$7: {
                                      _L$8: {
                                        const _bind$10 = url.scheme;
                                        if (_M0FP210tonyfettes3url19is__special__scheme(new _M0TPC16string10StringView(_bind$10, 0, _bind$10.length))) {
                                          if (base === undefined) {
                                            break _L$8;
                                          } else {
                                            const _Some = base;
                                            const _base = _Some;
                                            if (_base.scheme === url.scheme) {
                                              const _bind$11 = _base.scheme;
                                              if (_M0FP210tonyfettes3url19is__special__scheme(new _M0TPC16string10StringView(_bind$11, 0, _bind$11.length))) {
                                                state = 8;
                                              } else {
                                                _M0FPC15abort5abortGuE("is_special_scheme(base.scheme) must be true");
                                              }
                                            } else {
                                              break _L$8;
                                            }
                                          }
                                        } else {
                                          break _L$8;
                                        }
                                        break _L$7;
                                      }
                                      const _bind$10 = url.scheme;
                                      if (_M0FP210tonyfettes3url19is__special__scheme(new _M0TPC16string10StringView(_bind$10, 0, _bind$10.length))) {
                                        state = 10;
                                      } else {
                                        _L$9: {
                                          _L$10: {
                                            if (_M0MPC16string6String24char__length__ge_2einner(_bind$4, 1, _bind$6, _bind$7)) {
                                              const _x$2 = _M0MPC16string6String16unsafe__char__at(_bind$4, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4, 0, _bind$6, _bind$7));
                                              if (_x$2 === 47) {
                                                state = 11;
                                                _M0MP210tonyfettes3url13StringPointer8increase(pointer);
                                              } else {
                                                break _L$10;
                                              }
                                            } else {
                                              break _L$10;
                                            }
                                            break _L$9;
                                          }
                                          url.path = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2088;
                                          state = 18;
                                        }
                                      }
                                    }
                                  }
                                } else {
                                  if (has_state_override) {
                                    return undefined;
                                  } else {
                                    _M0MPB13StringBuilder5reset(buffer);
                                    state = 2;
                                    _M0MP210tonyfettes3url13StringPointer11start__over(pointer);
                                    _tmp$38 = _M0MP210tonyfettes3url13StringPointer4view(pointer);
                                    continue _L$2;
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                    break _L$5;
                  }
                  _M0IPB13StringBuilderPB6Logger11write__char(buffer, _M0MPC14char4Char20to__ascii__lowercase(_c));
                }
                break;
              }
              case 2: {
                _L$6: {
                  _L$7: {
                    let scheme;
                    _L$8: {
                      _L$9: {
                        if (base === undefined) {
                          _M0MPC15array5Array4pushGUssEE(validation_errors, _M0DTPC15error5Error64tonyfettes_2furl_2eValidationError_2eMissingSchemeNonRelativeUrl__);
                          return undefined;
                        } else {
                          const _Some = base;
                          const _x$2 = _Some;
                          const _x$3 = _x$2.path;
                          if (_x$3.$tag === 0) {
                            let _tmp$39;
                            if (_c === 35) {
                              _tmp$39 = true;
                            } else {
                              _tmp$39 = false;
                            }
                            if (!_tmp$39) {
                              _M0MPC15array5Array4pushGUssEE(validation_errors, _M0DTPC15error5Error64tonyfettes_2furl_2eValidationError_2eMissingSchemeNonRelativeUrl__);
                              return undefined;
                            } else {
                              if (_c === 35) {
                                url.scheme = _x$2.scheme;
                                url.path = _M0MP210tonyfettes3url4Path5clone(_x$2.path);
                                url.query = _x$2.query;
                                url.fragment = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2089;
                                state = 20;
                              } else {
                                const _scheme = _x$2.scheme;
                                const _p$4 = "file";
                                if (!(_scheme === _p$4)) {
                                  scheme = _scheme;
                                  break _L$9;
                                } else {
                                  break _L$7;
                                }
                              }
                            }
                          } else {
                            const _scheme = _x$2.scheme;
                            const _p$4 = "file";
                            if (!(_scheme === _p$4)) {
                              scheme = _scheme;
                              break _L$9;
                            } else {
                              break _L$7;
                            }
                          }
                        }
                        break _L$8;
                      }
                      state = 6;
                      continue _L$2;
                    }
                    break _L$6;
                  }
                  state = 3;
                  continue _L$2;
                }
                break;
              }
              case 8: {
                _L$7: {
                  _L$8: {
                    if (_c === 47) {
                      if (_M0MPC16string10StringView11has__prefix(_x, new _M0TPC16string10StringView(_M0MP210tonyfettes3url3Url20parse__basic_2einnerN7_2abindS1260, 0, _M0MP210tonyfettes3url3Url20parse__basic_2einnerN7_2abindS1260.length))) {
                        state = 9;
                        _M0MP210tonyfettes3url13StringPointer8increase(pointer);
                      } else {
                        break _L$8;
                      }
                    } else {
                      break _L$8;
                    }
                    break _L$7;
                  }
                  _M0MPC15array5Array4pushGUssEE(validation_errors, _M0DTPC15error5Error73tonyfettes_2furl_2eValidationError_2eSpecialSchemeMissingFollowingSolidus__);
                  state = 6;
                  continue _L$2;
                }
                break;
              }
              case 11: {
                if (_c === 47) {
                  state = 12;
                } else {
                  state = 17;
                  continue _L$2;
                }
                break;
              }
              case 6: {
                if (base === undefined) {
                  _M0FPC15abort5abortGuE("base must be Some(base) in Relative state");
                } else {
                  const _Some = base;
                  const _base = _Some;
                  const _p$4 = _base.scheme;
                  const _p$5 = "file";
                  if (!(_p$4 === _p$5)) {
                    url.scheme = _base.scheme;
                    if (_c === 47) {
                      state = 7;
                    } else {
                      _L$8: {
                        _L$9: {
                          if (_M0MP210tonyfettes3url3Url11is__special(url)) {
                            if (_c === 92) {
                              _M0MPC15array5Array4pushGUssEE(validation_errors, _M0DTPC15error5Error58tonyfettes_2furl_2eValidationError_2eInvalidReverseSolidus__);
                              state = 7;
                            } else {
                              break _L$9;
                            }
                          } else {
                            break _L$9;
                          }
                          break _L$8;
                        }
                        url.username = _base.username;
                        url.password = _base.password;
                        url.host = _base.host;
                        url.port = _base.port;
                        url.path = _M0MP210tonyfettes3url4Path5clone(_base.path);
                        url.query = _base.query;
                        if (_c === 63) {
                          url.query = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2090;
                          state = 19;
                        } else {
                          if (_c === 35) {
                            url.fragment = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2091;
                            state = 20;
                          } else {
                            url.query = undefined;
                            _M0MP210tonyfettes3url4Path15shorten_2einner(url.path, url.scheme);
                            state = 17;
                            continue _L$2;
                          }
                        }
                      }
                    }
                  } else {
                    _M0FPC15abort5abortGuE("base.scheme must not be \"file\" in Relative state");
                  }
                }
                break;
              }
              case 7: {
                if (base === undefined) {
                  _M0FPC15abort5abortGuE("base must be Some(base) in RelativeSlash state");
                } else {
                  const _Some = base;
                  const _base = _Some;
                  _L$8: {
                    _L$9: {
                      if (_M0MP210tonyfettes3url3Url11is__special(url)) {
                        _L$10: {
                          switch (_c) {
                            case 47: {
                              break _L$10;
                            }
                            case 92: {
                              break _L$10;
                            }
                            default: {
                              break _L$9;
                            }
                          }
                        }
                        if (_c === 47) {
                          _M0MPC15array5Array4pushGUssEE(validation_errors, _M0DTPC15error5Error58tonyfettes_2furl_2eValidationError_2eInvalidReverseSolidus__);
                        }
                        state = 9;
                      } else {
                        break _L$9;
                      }
                      break _L$8;
                    }
                    if (_c === 47) {
                      state = 12;
                    } else {
                      url.username = _base.username;
                      url.password = _base.password;
                      url.host = _base.host;
                      url.port = _base.port;
                      state = 17;
                      continue _L$2;
                    }
                  }
                }
                break;
              }
              case 10: {
                _L$8: {
                  _L$9: {
                    if (_c === 47) {
                      if (_M0MPC16string10StringView11has__prefix(_x, new _M0TPC16string10StringView(_M0MP210tonyfettes3url3Url20parse__basic_2einnerN7_2abindS1290, 0, _M0MP210tonyfettes3url3Url20parse__basic_2einnerN7_2abindS1290.length))) {
                        state = 9;
                        _M0MP210tonyfettes3url13StringPointer8increase(pointer);
                      } else {
                        break _L$9;
                      }
                    } else {
                      break _L$9;
                    }
                    break _L$8;
                  }
                  _M0MPC15array5Array4pushGUssEE(validation_errors, _M0DTPC15error5Error73tonyfettes_2furl_2eValidationError_2eSpecialSchemeMissingFollowingSolidus__);
                  state = 9;
                  continue _L$2;
                }
                break;
              }
              case 9: {
                let _tmp$39;
                switch (_c) {
                  case 47: {
                    _tmp$39 = true;
                    break;
                  }
                  case 92: {
                    _tmp$39 = true;
                    break;
                  }
                  default: {
                    _tmp$39 = false;
                  }
                }
                if (!_tmp$39) {
                  state = 12;
                  continue _L$2;
                } else {
                  _M0MPC15array5Array4pushGUssEE(validation_errors, _M0DTPC15error5Error73tonyfettes_2furl_2eValidationError_2eSpecialSchemeMissingFollowingSolidus__);
                }
                break;
              }
              case 12: {
                if (_c === 64) {
                  _M0MPC15array5Array4pushGUssEE(validation_errors, _M0DTPC15error5Error55tonyfettes_2furl_2eValidationError_2eInvalidCredentials__);
                  if (at_sign_seen) {
                    const prepend = `%40${buffer.val}`;
                    _M0MPB13StringBuilder5reset(buffer);
                    _M0IPB13StringBuilderPB6Logger13write__string(buffer, prepend);
                  }
                  at_sign_seen = true;
                  const _it = _M0MPC16string6String4iter(buffer.val);
                  while (true) {
                    const _bind$9 = _M0MPB4Iter4nextGcE(_it);
                    if (_bind$9 === -1) {
                      break;
                    } else {
                      const _Some = _bind$9;
                      const _code_point = _Some;
                      if (_code_point === 58) {
                        if (!password_token_seen) {
                          password_token_seen = true;
                          continue;
                        }
                      }
                      const _self = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                      _M0IPB13StringBuilderPB6Logger11write__char(_self, _code_point);
                      const _p$4 = _self;
                      const _bind$10 = _p$4.val;
                      const _p$5 = new _M0TPC16string10StringView(_bind$10, 0, _bind$10.length);
                      const _p$6 = false;
                      const _p$7 = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                      const _p$8 = _M0FPC28encoding4utf814encode_2einner(_p$5, false);
                      const _p$9 = _p$8.length;
                      let _tmp$40 = 0;
                      while (true) {
                        const _p$10 = _tmp$40;
                        if (_p$10 < _p$9) {
                          const _p$11 = _p$8[_p$10];
                          _L$9: {
                            if (_p$6) {
                              if (_p$11 === 32) {
                                _M0IPB13StringBuilderPB6Logger11write__char(_p$7, 43);
                                break _L$9;
                              }
                            }
                            const _p$12 = _p$11;
                            if (_M0FP210tonyfettes3url30userinfo__percent__encode__set(_p$12)) {
                              _M0IPB13StringBuilderPB6Logger11write__char(_p$7, 37);
                              const _p$13 = _p$11;
                              const _p$14 = _p$13 >> 4 & 15;
                              $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$14);
                              _M0IPB13StringBuilderPB6Logger11write__char(_p$7, _M0FP210tonyfettes3url11hex__digits[_p$14]);
                              const _p$15 = _p$13 & 15;
                              $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$15);
                              _M0IPB13StringBuilderPB6Logger11write__char(_p$7, _M0FP210tonyfettes3url11hex__digits[_p$15]);
                              break _L$9;
                            } else {
                              _M0IPB13StringBuilderPB6Logger11write__char(_p$7, _p$12);
                            }
                            break _L$9;
                          }
                          _tmp$40 = _p$10 + 1 | 0;
                          continue;
                        } else {
                          break;
                        }
                      }
                      const encoded_code_points = _p$7.val;
                      if (password_token_seen) {
                        url.password = `${url.password}${encoded_code_points}`;
                      } else {
                        url.username = `${url.username}${encoded_code_points}`;
                      }
                      continue;
                    }
                  }
                  _M0MPB13StringBuilder5reset(buffer);
                } else {
                  _L$9: {
                    _L$10: {
                      _L$11: {
                        _L$12: {
                          switch (_c) {
                            case 47: {
                              break _L$12;
                            }
                            case 63: {
                              break _L$12;
                            }
                            case 35: {
                              break _L$12;
                            }
                            default: {
                              _L$13: {
                                if (_M0MP210tonyfettes3url3Url11is__special(url)) {
                                  if (_c === 92) {
                                    break _L$10;
                                  } else {
                                    break _L$13;
                                  }
                                } else {
                                  break _L$13;
                                }
                              }
                              _M0IPB13StringBuilderPB6Logger11write__char(buffer, _c);
                            }
                          }
                          break _L$11;
                        }
                        break _L$10;
                      }
                      break _L$9;
                    }
                    if (at_sign_seen && buffer.val === "") {
                      _M0MPC15array5Array4pushGUssEE(validation_errors, _M0DTPC15error5Error48tonyfettes_2furl_2eValidationError_2eHostMissing__);
                      return undefined;
                    }
                    const _it = _M0MPC16string6String4iter(buffer.val);
                    while (true) {
                      const _bind$9 = _M0MPB4Iter4nextGcE(_it);
                      if (_bind$9 === -1) {
                        break;
                      } else {
                        _M0MP210tonyfettes3url13StringPointer8decrease(pointer);
                        continue;
                      }
                    }
                    _M0MP210tonyfettes3url13StringPointer8decrease(pointer);
                    _M0MPB13StringBuilder5reset(buffer);
                    state = 13;
                  }
                }
                break;
              }
              case 13: {
                break _L$4;
              }
              case 14: {
                break _L$4;
              }
              case 15: {
                if (_M0MPC14char4Char16is__ascii__digit(_c)) {
                  _M0IPB13StringBuilderPB6Logger11write__char(buffer, _c);
                } else {
                  _L$9: {
                    _L$10: {
                      switch (_c) {
                        case 47: {
                          break _L$10;
                        }
                        case 63: {
                          break _L$10;
                        }
                        case 35: {
                          break _L$10;
                        }
                        default: {
                          _L$11: {
                            if (_M0MP210tonyfettes3url3Url11is__special(url)) {
                              if (_c === 92) {
                                break _L$9;
                              } else {
                                break _L$11;
                              }
                            } else {
                              break _L$11;
                            }
                          }
                          if (has_state_override) {
                            break _L$9;
                          } else {
                            return undefined;
                          }
                        }
                      }
                    }
                    break _L$9;
                  }
                  if (!(buffer.val === "")) {
                    const port_str = buffer.val;
                    let port_value = 0n;
                    const _it = _M0MPC16string6String4iter(port_str);
                    while (true) {
                      const _bind$9 = _M0MPB4Iter4nextGcE(_it);
                      if (_bind$9 === -1) {
                        break;
                      } else {
                        const _Some = _bind$9;
                        const _ch = _Some;
                        const _tmp$40 = BigInt.asUintN(64, port_value * 10n);
                        const _p$4 = _ch - 48 | 0;
                        port_value = BigInt.asUintN(64, _tmp$40 + BigInt.asUintN(64, BigInt(_p$4)));
                        if (BigInt.asUintN(64, port_value) > BigInt.asUintN(64, 65535n)) {
                          return undefined;
                        }
                        continue;
                      }
                    }
                    const _p$4 = port_value;
                    const port_u16 = Number(BigInt.asUintN(16, _p$4));
                    let is_default;
                    _L$10: {
                      _L$11: {
                        _L$12: {
                          _L$13: {
                            const _bind$9 = url.scheme;
                            switch (_bind$9) {
                              case "ftp": {
                                const _p$5 = 21;
                                is_default = port_u16 === _p$5;
                                break;
                              }
                              case "http": {
                                break _L$13;
                              }
                              case "ws": {
                                break _L$13;
                              }
                              case "https": {
                                break _L$11;
                              }
                              case "wss": {
                                break _L$11;
                              }
                              default: {
                                is_default = false;
                              }
                            }
                            break _L$12;
                          }
                          const _p$5 = 80;
                          is_default = port_u16 === _p$5;
                        }
                        break _L$10;
                      }
                      const _p$5 = 443;
                      is_default = port_u16 === _p$5;
                    }
                    url.port = is_default ? -1 : port_u16;
                    _M0MPB13StringBuilder5reset(buffer);
                    if (has_state_override) {
                      return url;
                    }
                  } else {
                    if (has_state_override) {
                      return undefined;
                    }
                  }
                  state = 16;
                  _M0MP210tonyfettes3url13StringPointer8decrease(pointer);
                }
                break;
              }
              case 16: {
                if (_M0MP210tonyfettes3url3Url11is__special(url)) {
                  if (_c === 92) {
                    _M0MPC15array5Array4pushGUssEE(validation_errors, _M0DTPC15error5Error58tonyfettes_2furl_2eValidationError_2eInvalidReverseSolidus__);
                  }
                  state = 17;
                  let _tmp$40;
                  switch (_c) {
                    case 47: {
                      _tmp$40 = true;
                      break;
                    }
                    case 92: {
                      _tmp$40 = true;
                      break;
                    }
                    default: {
                      _tmp$40 = false;
                    }
                  }
                  if (!_tmp$40) {
                    continue _L$2;
                  }
                } else {
                  _L$9: {
                    _L$10: {
                      if (!has_state_override) {
                        if (_c === 63) {
                          url.query = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2093;
                          state = 19;
                        } else {
                          break _L$10;
                        }
                      } else {
                        break _L$10;
                      }
                      break _L$9;
                    }
                    _L$11: {
                      _L$12: {
                        if (!has_state_override) {
                          if (_c === 35) {
                            url.fragment = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2092;
                            state = 20;
                          } else {
                            break _L$12;
                          }
                        } else {
                          break _L$12;
                        }
                        break _L$11;
                      }
                      state = 17;
                      let _tmp$40;
                      if (_c === 47) {
                        _tmp$40 = true;
                      } else {
                        _tmp$40 = false;
                      }
                      if (!_tmp$40) {
                        continue _L$2;
                      }
                    }
                  }
                }
                break;
              }
              case 17: {
                _L$9: {
                  _L$10: {
                    if (_c === 47) {
                      break _L$10;
                    } else {
                      _L$11: {
                        if (_M0MP210tonyfettes3url3Url11is__special(url)) {
                          if (_c === 92) {
                            break _L$10;
                          } else {
                            break _L$11;
                          }
                        } else {
                          break _L$11;
                        }
                      }
                      _L$12: {
                        if (!has_state_override) {
                          _L$13: {
                            switch (_c) {
                              case 63: {
                                break _L$13;
                              }
                              case 35: {
                                break _L$13;
                              }
                              default: {
                                break _L$12;
                              }
                            }
                          }
                          break _L$10;
                        } else {
                          break _L$12;
                        }
                      }
                      if (_c === 37) {
                        _M0IPB13StringBuilderPB6Logger11write__char(buffer, _c);
                      } else {
                        if (_M0FP210tonyfettes3url26path__percent__encode__set(_c)) {
                          const _self = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                          _M0IPB13StringBuilderPB6Logger11write__char(_self, _c);
                          const _p$4 = _self;
                          const _bind$9 = _p$4.val;
                          const bytes = _M0FPC28encoding4utf814encode_2einner(new _M0TPC16string10StringView(_bind$9, 0, _bind$9.length), false);
                          const _bind$10 = bytes.length;
                          let _tmp$40 = 0;
                          while (true) {
                            const _ = _tmp$40;
                            if (_ < _bind$10) {
                              const byte = bytes[_];
                              _M0IPB13StringBuilderPB6Logger11write__char(buffer, 37);
                              const b = byte;
                              const _p$5 = b >> 4 & 15;
                              $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$5);
                              _M0IPB13StringBuilderPB6Logger11write__char(buffer, _M0FP210tonyfettes3url11hex__digits[_p$5]);
                              const _p$6 = b & 15;
                              $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$6);
                              _M0IPB13StringBuilderPB6Logger11write__char(buffer, _M0FP210tonyfettes3url11hex__digits[_p$6]);
                              _tmp$40 = _ + 1 | 0;
                              continue;
                            } else {
                              break;
                            }
                          }
                        } else {
                          _M0IPB13StringBuilderPB6Logger11write__char(buffer, _c);
                        }
                      }
                    }
                    break _L$9;
                  }
                  if (_M0MP210tonyfettes3url3Url11is__special(url)) {
                    if (_c === 92) {
                      _M0MPC15array5Array4pushGUssEE(validation_errors, _M0DTPC15error5Error58tonyfettes_2furl_2eValidationError_2eInvalidReverseSolidus__);
                    }
                  }
                  const buffer_str = buffer.val;
                  if (_M0FP210tonyfettes3url30is__double__dot__path__segment(buffer_str)) {
                    _M0MP210tonyfettes3url4Path15shorten_2einner(url.path, url.scheme);
                    let _tmp$40;
                    switch (_c) {
                      case 47: {
                        _tmp$40 = true;
                        break;
                      }
                      case 92: {
                        _tmp$40 = true;
                        break;
                      }
                      default: {
                        _tmp$40 = false;
                      }
                    }
                    if (!_tmp$40) {
                      const _bind$9 = url.path;
                      if (_bind$9.$tag === 1) {
                        const _Segments = _bind$9;
                        const _segments = _Segments._0;
                        _M0MPC15array5Array4pushGUssEE(_segments, "");
                      }
                    }
                  } else {
                    if (_M0FP210tonyfettes3url30is__single__dot__path__segment(buffer_str)) {
                      let _tmp$40;
                      switch (_c) {
                        case 47: {
                          _tmp$40 = true;
                          break;
                        }
                        case 92: {
                          _tmp$40 = true;
                          break;
                        }
                        default: {
                          _tmp$40 = false;
                        }
                      }
                      if (!_tmp$40) {
                        const _bind$9 = url.path;
                        if (_bind$9.$tag === 1) {
                          const _Segments = _bind$9;
                          const _segments = _Segments._0;
                          _M0MPC15array5Array4pushGUssEE(_segments, "");
                        }
                      }
                    } else {
                      if (url.scheme === "file") {
                        const _bind$9 = url.path;
                        if (_bind$9.$tag === 1) {
                          const _Segments = _bind$9;
                          const _segments = _Segments._0;
                          if (_segments.length === 0) {
                            if (buffer_str.length === 2) {
                              let letter;
                              _L$11: {
                                _L$12: {
                                  if (_M0MPC16string6String24char__length__eq_2einner(buffer_str, 2, 0, buffer_str.length)) {
                                    const _letter = _M0MPC16string6String16unsafe__char__at(buffer_str, _M0MPC16string6String29offset__of__nth__char_2einner(buffer_str, 0, 0, buffer_str.length));
                                    const _x$2 = _M0MPC16string6String16unsafe__char__at(buffer_str, _M0MPC16string6String29offset__of__nth__char_2einner(buffer_str, 1, 0, buffer_str.length));
                                    switch (_x$2) {
                                      case 58: {
                                        if (_M0MPC14char4Char21is__ascii__alphabetic(_letter)) {
                                          letter = _letter;
                                          break _L$12;
                                        }
                                        break;
                                      }
                                      case 124: {
                                        if (_M0MPC14char4Char21is__ascii__alphabetic(_letter)) {
                                          letter = _letter;
                                          break _L$12;
                                        }
                                        break;
                                      }
                                    }
                                  }
                                  break _L$11;
                                }
                                const normalized = `${_M0IPC14char4CharPB4Show10to__string(letter)}:`;
                                const _bind$10 = url.path;
                                if (_bind$10.$tag === 1) {
                                  const _Segments$2 = _bind$10;
                                  const _segments$2 = _Segments$2._0;
                                  _M0MPC15array5Array4pushGUssEE(_segments$2, normalized);
                                }
                                _M0MPB13StringBuilder5reset(buffer);
                                if (_c === 63) {
                                  url.query = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2094;
                                  state = 19;
                                  _tmp$38 = _M0MP210tonyfettes3url13StringPointer4next(pointer);
                                  continue _L$2;
                                } else {
                                  if (_c === 35) {
                                    url.fragment = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2095;
                                    state = 20;
                                    _tmp$38 = _M0MP210tonyfettes3url13StringPointer4next(pointer);
                                    continue _L$2;
                                  }
                                }
                                _tmp$38 = _M0MP210tonyfettes3url13StringPointer4next(pointer);
                                continue _L$2;
                              }
                            }
                          }
                        }
                      }
                      const _bind$9 = url.path;
                      if (_bind$9.$tag === 1) {
                        const _Segments = _bind$9;
                        const _segments = _Segments._0;
                        const _p$4 = new _M0TPC16string10StringView(buffer_str, 0, buffer_str.length);
                        const _p$5 = false;
                        const _p$6 = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                        const _p$7 = _M0FPC28encoding4utf814encode_2einner(_p$4, false);
                        const _p$8 = _p$7.length;
                        let _tmp$40 = 0;
                        while (true) {
                          const _p$9 = _tmp$40;
                          if (_p$9 < _p$8) {
                            const _p$10 = _p$7[_p$9];
                            _L$11: {
                              if (_p$5) {
                                if (_p$10 === 32) {
                                  _M0IPB13StringBuilderPB6Logger11write__char(_p$6, 43);
                                  break _L$11;
                                }
                              }
                              const _p$11 = _p$10;
                              if (_M0FP210tonyfettes3url26path__percent__encode__set(_p$11)) {
                                _M0IPB13StringBuilderPB6Logger11write__char(_p$6, 37);
                                const _p$12 = _p$10;
                                const _p$13 = _p$12 >> 4 & 15;
                                $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$13);
                                _M0IPB13StringBuilderPB6Logger11write__char(_p$6, _M0FP210tonyfettes3url11hex__digits[_p$13]);
                                const _p$14 = _p$12 & 15;
                                $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$14);
                                _M0IPB13StringBuilderPB6Logger11write__char(_p$6, _M0FP210tonyfettes3url11hex__digits[_p$14]);
                                break _L$11;
                              } else {
                                _M0IPB13StringBuilderPB6Logger11write__char(_p$6, _p$11);
                              }
                              break _L$11;
                            }
                            _tmp$40 = _p$9 + 1 | 0;
                            continue;
                          } else {
                            break;
                          }
                        }
                        _M0MPC15array5Array4pushGUssEE(_segments, _p$6.val);
                      } else {
                        const _Opaque = _bind$9;
                        const _s = _Opaque._0;
                        const _p$4 = new _M0TPC16string10StringView(buffer_str, 0, buffer_str.length);
                        const _p$5 = false;
                        const _p$6 = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                        const _p$7 = _M0FPC28encoding4utf814encode_2einner(_p$4, false);
                        const _p$8 = _p$7.length;
                        let _tmp$40 = 0;
                        while (true) {
                          const _p$9 = _tmp$40;
                          if (_p$9 < _p$8) {
                            const _p$10 = _p$7[_p$9];
                            _L$11: {
                              if (_p$5) {
                                if (_p$10 === 32) {
                                  _M0IPB13StringBuilderPB6Logger11write__char(_p$6, 43);
                                  break _L$11;
                                }
                              }
                              const _p$11 = _p$10;
                              if (_M0FP210tonyfettes3url26path__percent__encode__set(_p$11)) {
                                _M0IPB13StringBuilderPB6Logger11write__char(_p$6, 37);
                                const _p$12 = _p$10;
                                const _p$13 = _p$12 >> 4 & 15;
                                $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$13);
                                _M0IPB13StringBuilderPB6Logger11write__char(_p$6, _M0FP210tonyfettes3url11hex__digits[_p$13]);
                                const _p$14 = _p$12 & 15;
                                $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$14);
                                _M0IPB13StringBuilderPB6Logger11write__char(_p$6, _M0FP210tonyfettes3url11hex__digits[_p$14]);
                                break _L$11;
                              } else {
                                _M0IPB13StringBuilderPB6Logger11write__char(_p$6, _p$11);
                              }
                              break _L$11;
                            }
                            _tmp$40 = _p$9 + 1 | 0;
                            continue;
                          } else {
                            break;
                          }
                        }
                        url.path = new _M0DTP210tonyfettes3url4Path6Opaque(`${_s}/${_p$6.val}`);
                      }
                    }
                  }
                  _M0MPB13StringBuilder5reset(buffer);
                  if (_c === 63) {
                    url.query = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2096;
                    state = 19;
                  } else {
                    if (_c === 35) {
                      url.fragment = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2097;
                      state = 20;
                    }
                  }
                }
                break;
              }
              case 18: {
                if (_c === 63) {
                  const _bind$9 = url.path;
                  if (_bind$9.$tag === 0) {
                    const _Opaque = _bind$9;
                    const _s = _Opaque._0;
                    url.path = new _M0DTP210tonyfettes3url4Path6Opaque(_M0FP210tonyfettes3url29encode__last__trailing__space(_s));
                  }
                  url.query = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2098;
                  state = 19;
                } else {
                  if (_c === 35) {
                    const _bind$9 = url.path;
                    if (_bind$9.$tag === 0) {
                      const _Opaque = _bind$9;
                      const _s = _Opaque._0;
                      url.path = new _M0DTP210tonyfettes3url4Path6Opaque(_M0FP210tonyfettes3url29encode__last__trailing__space(_s));
                    }
                    url.fragment = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2099;
                    state = 20;
                  } else {
                    const _bind$9 = url.path;
                    if (_bind$9.$tag === 0) {
                      const _Opaque = _bind$9;
                      const _s = _Opaque._0;
                      if (_M0FP210tonyfettes3url33c0__control__percent__encode__set(_c)) {
                        const _self = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                        _M0IPB13StringBuilderPB6Logger11write__char(_self, _c);
                        const _p$4 = _self;
                        const _bind$10 = _p$4.val;
                        const bytes = _M0FPC28encoding4utf814encode_2einner(new _M0TPC16string10StringView(_bind$10, 0, _bind$10.length), false);
                        let encoded = _s;
                        const _bind$11 = bytes.length;
                        let _tmp$40 = 0;
                        while (true) {
                          const _ = _tmp$40;
                          if (_ < _bind$11) {
                            const byte = bytes[_];
                            const b = byte;
                            const _tmp$41 = encoded;
                            const _p$5 = b >> 4 & 15;
                            $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$5);
                            const _tmp$42 = _M0IPC14char4CharPB4Show10to__string(_M0FP210tonyfettes3url11hex__digits[_p$5]);
                            const _p$6 = b & 15;
                            $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$6);
                            encoded = `${_tmp$41}%${_tmp$42}${_M0IPC14char4CharPB4Show10to__string(_M0FP210tonyfettes3url11hex__digits[_p$6])}`;
                            _tmp$40 = _ + 1 | 0;
                            continue;
                          } else {
                            break;
                          }
                        }
                        url.path = new _M0DTP210tonyfettes3url4Path6Opaque(encoded);
                      } else {
                        url.path = new _M0DTP210tonyfettes3url4Path6Opaque(`${_s}${_M0IPC14char4CharPB4Show10to__string(_c)}`);
                      }
                    }
                  }
                }
                break;
              }
              case 19: {
                _L$10: {
                  _L$11: {
                    if (!has_state_override) {
                      if (_c === 35) {
                        url.fragment = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2100;
                        state = 20;
                      } else {
                        break _L$11;
                      }
                    } else {
                      break _L$11;
                    }
                    break _L$10;
                  }
                  const encode_set = _M0MP210tonyfettes3url3Url11is__special(url) ? _M0FP210tonyfettes3url36special__query__percent__encode__set : _M0FP210tonyfettes3url27query__percent__encode__set;
                  const _bind$9 = url.query;
                  if (_bind$9 === undefined) {
                  } else {
                    const _Some = _bind$9;
                    const _q = _Some;
                    if (_c === 37) {
                      url.query = `${_q}${_M0IPC14char4CharPB4Show10to__string(_c)}`;
                    } else {
                      if (encode_set(_c)) {
                        const _self = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                        _M0IPB13StringBuilderPB6Logger11write__char(_self, _c);
                        const _p$4 = _self;
                        const _bind$10 = _p$4.val;
                        const bytes = _M0FPC28encoding4utf814encode_2einner(new _M0TPC16string10StringView(_bind$10, 0, _bind$10.length), false);
                        let encoded = _q;
                        const _bind$11 = bytes.length;
                        let _tmp$40 = 0;
                        while (true) {
                          const _ = _tmp$40;
                          if (_ < _bind$11) {
                            const byte = bytes[_];
                            const b = byte;
                            const _tmp$41 = encoded;
                            const _p$5 = b >> 4 & 15;
                            $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$5);
                            const _tmp$42 = _M0IPC14char4CharPB4Show10to__string(_M0FP210tonyfettes3url11hex__digits[_p$5]);
                            const _p$6 = b & 15;
                            $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$6);
                            encoded = `${_tmp$41}%${_tmp$42}${_M0IPC14char4CharPB4Show10to__string(_M0FP210tonyfettes3url11hex__digits[_p$6])}`;
                            _tmp$40 = _ + 1 | 0;
                            continue;
                          } else {
                            break;
                          }
                        }
                        url.query = encoded;
                      } else {
                        url.query = `${_q}${_M0IPC14char4CharPB4Show10to__string(_c)}`;
                      }
                    }
                  }
                }
                break;
              }
              case 20: {
                const _bind$9 = url.fragment;
                if (_bind$9 === undefined) {
                } else {
                  const _Some = _bind$9;
                  const _f = _Some;
                  if (_c === 37) {
                    url.fragment = `${_f}${_M0IPC14char4CharPB4Show10to__string(_c)}`;
                  } else {
                    if (_M0FP210tonyfettes3url30fragment__percent__encode__set(_c)) {
                      const _self = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                      _M0IPB13StringBuilderPB6Logger11write__char(_self, _c);
                      const _p$4 = _self;
                      const _bind$10 = _p$4.val;
                      const bytes = _M0FPC28encoding4utf814encode_2einner(new _M0TPC16string10StringView(_bind$10, 0, _bind$10.length), false);
                      let encoded = _f;
                      const _bind$11 = bytes.length;
                      let _tmp$40 = 0;
                      while (true) {
                        const _ = _tmp$40;
                        if (_ < _bind$11) {
                          const byte = bytes[_];
                          const b = byte;
                          const _tmp$41 = encoded;
                          const _p$5 = b >> 4 & 15;
                          $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$5);
                          const _tmp$42 = _M0IPC14char4CharPB4Show10to__string(_M0FP210tonyfettes3url11hex__digits[_p$5]);
                          const _p$6 = b & 15;
                          $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$6);
                          encoded = `${_tmp$41}%${_tmp$42}${_M0IPC14char4CharPB4Show10to__string(_M0FP210tonyfettes3url11hex__digits[_p$6])}`;
                          _tmp$40 = _ + 1 | 0;
                          continue;
                        } else {
                          break;
                        }
                      }
                      url.fragment = encoded;
                    } else {
                      url.fragment = `${_f}${_M0IPC14char4CharPB4Show10to__string(_c)}`;
                    }
                  }
                }
                break;
              }
              case 3: {
                url.scheme = "file";
                _L$11: {
                  _L$12: {
                    switch (_c) {
                      case 47: {
                        break _L$12;
                      }
                      case 92: {
                        break _L$12;
                      }
                      default: {
                        _L$13: {
                          _L$14: {
                            if (base === undefined) {
                              break _L$14;
                            } else {
                              const _Some = base;
                              const _base = _Some;
                              if (_base.scheme === "file") {
                                url.host = _base.host;
                                url.path = _M0MP210tonyfettes3url4Path5clone(_base.path);
                                url.query = _base.query;
                                if (_c === 63) {
                                  url.query = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2103;
                                  state = 19;
                                } else {
                                  if (_c === 35) {
                                    url.fragment = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2104;
                                    state = 20;
                                  } else {
                                    url.query = undefined;
                                    let starts_with_drive;
                                    if (_M0MPC14char4Char21is__ascii__alphabetic(_c)) {
                                      let rest;
                                      _L$15: {
                                        _L$16: {
                                          if (_M0MPC16string6String24char__length__ge_2einner(_bind$4, 1, _bind$6, _bind$7)) {
                                            const _x$2 = _M0MPC16string6String16unsafe__char__at(_bind$4, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4, 0, _bind$6, _bind$7));
                                            switch (_x$2) {
                                              case 58: {
                                                const _bind$10 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4, 1, _bind$6, _bind$7);
                                                let _tmp$40;
                                                if (_bind$10 === undefined) {
                                                  _tmp$40 = _bind$7;
                                                } else {
                                                  const _Some$2 = _bind$10;
                                                  _tmp$40 = _Some$2;
                                                }
                                                const _x$3 = new _M0TPC16string10StringView(_bind$4, _tmp$40, _bind$7);
                                                rest = _x$3;
                                                break _L$16;
                                              }
                                              case 124: {
                                                const _bind$11 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4, 1, _bind$6, _bind$7);
                                                let _tmp$41;
                                                if (_bind$11 === undefined) {
                                                  _tmp$41 = _bind$7;
                                                } else {
                                                  const _Some$2 = _bind$11;
                                                  _tmp$41 = _Some$2;
                                                }
                                                const _x$4 = new _M0TPC16string10StringView(_bind$4, _tmp$41, _bind$7);
                                                rest = _x$4;
                                                break _L$16;
                                              }
                                              default: {
                                                starts_with_drive = false;
                                              }
                                            }
                                          } else {
                                            starts_with_drive = false;
                                          }
                                          break _L$15;
                                        }
                                        if (_M0MPC16string6String24char__length__eq_2einner(rest.str, 0, rest.start, rest.end)) {
                                          starts_with_drive = true;
                                        } else {
                                          const _x$2 = _M0MPC16string6String16unsafe__char__at(rest.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest.str, 0, rest.start, rest.end));
                                          switch (_x$2) {
                                            case 47: {
                                              starts_with_drive = true;
                                              break;
                                            }
                                            case 92: {
                                              starts_with_drive = true;
                                              break;
                                            }
                                            case 63: {
                                              starts_with_drive = true;
                                              break;
                                            }
                                            case 35: {
                                              starts_with_drive = true;
                                              break;
                                            }
                                            default: {
                                              starts_with_drive = false;
                                            }
                                          }
                                        }
                                      }
                                    } else {
                                      starts_with_drive = false;
                                    }
                                    if (starts_with_drive) {
                                      url.path = new _M0DTP210tonyfettes3url4Path8Segments([]);
                                    } else {
                                      _M0MP210tonyfettes3url4Path15shorten_2einner(url.path, "file");
                                    }
                                    state = 17;
                                    continue _L$2;
                                  }
                                }
                              } else {
                                break _L$14;
                              }
                            }
                            break _L$13;
                          }
                          url.host = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2102;
                          state = 17;
                          continue _L$2;
                        }
                      }
                    }
                    break _L$11;
                  }
                  if (_c === 92) {
                    _M0MPC15array5Array4pushGUssEE(validation_errors, _M0DTPC15error5Error58tonyfettes_2furl_2eValidationError_2eInvalidReverseSolidus__);
                  }
                  state = 4;
                }
                break;
              }
              case 4: {
                url.scheme = "file";
                _L$12: {
                  switch (_c) {
                    case 47: {
                      break _L$12;
                    }
                    case 92: {
                      break _L$12;
                    }
                    default: {
                      let input_has_drive;
                      if (_M0MPC14char4Char21is__ascii__alphabetic(_c)) {
                        let _tmp$40;
                        if (_M0MPC16string6String24char__length__ge_2einner(_bind$4, 1, _bind$6, _bind$7)) {
                          const _x$2 = _M0MPC16string6String16unsafe__char__at(_bind$4, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4, 0, _bind$6, _bind$7));
                          switch (_x$2) {
                            case 58: {
                              _tmp$40 = true;
                              break;
                            }
                            case 124: {
                              _tmp$40 = true;
                              break;
                            }
                            default: {
                              _tmp$40 = false;
                            }
                          }
                        } else {
                          _tmp$40 = false;
                        }
                        input_has_drive = _tmp$40;
                      } else {
                        input_has_drive = false;
                      }
                      _L$13: {
                        _L$14: {
                          if (base === undefined) {
                            break _L$14;
                          } else {
                            const _Some = base;
                            const _base = _Some;
                            if (_base.scheme === "file") {
                              url.host = _base.host;
                              if (!input_has_drive) {
                                const _bind$10 = _base.path;
                                if (_bind$10.$tag === 1) {
                                  const _Segments = _bind$10;
                                  const _x$2 = _Segments._0;
                                  if (_x$2.length >= 1) {
                                    const _drive = _x$2[0];
                                    if (_drive.length === 2) {
                                      if (_M0MPC16string6String24char__length__eq_2einner(_drive, 2, 0, _drive.length)) {
                                        const _letter = _M0MPC16string6String16unsafe__char__at(_drive, _M0MPC16string6String29offset__of__nth__char_2einner(_drive, 0, 0, _drive.length));
                                        const _x$3 = _M0MPC16string6String16unsafe__char__at(_drive, _M0MPC16string6String29offset__of__nth__char_2einner(_drive, 1, 0, _drive.length));
                                        if (_x$3 === 58) {
                                          if (_M0MPC14char4Char21is__ascii__alphabetic(_letter)) {
                                            url.path = new _M0DTP210tonyfettes3url4Path8Segments([_drive]);
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            } else {
                              break _L$14;
                            }
                          }
                          break _L$13;
                        }
                        url.host = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2106;
                      }
                      state = 17;
                      continue _L$2;
                    }
                  }
                }
                if (_c === 92) {
                  _M0MPC15array5Array4pushGUssEE(validation_errors, _M0DTPC15error5Error58tonyfettes_2furl_2eValidationError_2eInvalidReverseSolidus__);
                }
                state = 5;
                break;
              }
              default: {
                url.scheme = "file";
                _L$13: {
                  _L$14: {
                    switch (_c) {
                      case 47: {
                        break _L$14;
                      }
                      case 92: {
                        break _L$14;
                      }
                      case 63: {
                        break _L$14;
                      }
                      case 35: {
                        break _L$14;
                      }
                      default: {
                        _M0IPB13StringBuilderPB6Logger11write__char(buffer, _c);
                      }
                    }
                    break _L$13;
                  }
                  _M0MP210tonyfettes3url13StringPointer8decrease(pointer);
                  const buffer_str = buffer.val;
                  if (buffer_str.length === 2) {
                    _L$15: {
                      _L$16: {
                        let letter;
                        _L$17: {
                          if (_M0MPC16string6String24char__length__eq_2einner(buffer_str, 2, 0, buffer_str.length)) {
                            const _letter = _M0MPC16string6String16unsafe__char__at(buffer_str, _M0MPC16string6String29offset__of__nth__char_2einner(buffer_str, 0, 0, buffer_str.length));
                            const _x$2 = _M0MPC16string6String16unsafe__char__at(buffer_str, _M0MPC16string6String29offset__of__nth__char_2einner(buffer_str, 1, 0, buffer_str.length));
                            switch (_x$2) {
                              case 58: {
                                if (_M0MPC14char4Char21is__ascii__alphabetic(_letter)) {
                                  letter = _letter;
                                  break _L$17;
                                } else {
                                  break _L$16;
                                }
                              }
                              case 124: {
                                if (_M0MPC14char4Char21is__ascii__alphabetic(_letter)) {
                                  letter = _letter;
                                  break _L$17;
                                } else {
                                  break _L$16;
                                }
                              }
                              default: {
                                break _L$16;
                              }
                            }
                          } else {
                            break _L$16;
                          }
                        }
                        state = 17;
                        break _L$15;
                      }
                      if (buffer_str === "") {
                        url.host = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2108;
                        state = 16;
                      } else {
                        let host;
                        let _try_err;
                        _L$17: {
                          _L$18: {
                            const _bind$10 = _M0MP210tonyfettes3url4Host13parse_2einner(new _M0TPC16string10StringView(buffer_str, 0, buffer_str.length), false);
                            if (_bind$10.$tag === 1) {
                              const _ok = _bind$10;
                              host = _ok._0;
                            } else {
                              const _err = _bind$10;
                              _try_err = _err._0;
                              break _L$18;
                            }
                            break _L$17;
                          }
                          _M0MPC15array5Array4pushGUssEE(validation_errors, _try_err);
                          return undefined;
                        }
                        _L$18: {
                          _L$19: {
                            if (host.$tag === 0) {
                              const _Domain = host;
                              const _x$2 = _Domain._0;
                              if (_x$2 === "localhost") {
                                url.host = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2110;
                              } else {
                                break _L$19;
                              }
                            } else {
                              break _L$19;
                            }
                            break _L$18;
                          }
                          url.host = host;
                        }
                        _M0MPB13StringBuilder5reset(buffer);
                        state = 16;
                      }
                    }
                  } else {
                    if (buffer_str === "") {
                      url.host = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2112;
                      state = 16;
                    } else {
                      let host;
                      let _try_err;
                      _L$15: {
                        _L$16: {
                          const _bind$10 = _M0MP210tonyfettes3url4Host13parse_2einner(new _M0TPC16string10StringView(buffer_str, 0, buffer_str.length), false);
                          if (_bind$10.$tag === 1) {
                            const _ok = _bind$10;
                            host = _ok._0;
                          } else {
                            const _err = _bind$10;
                            _try_err = _err._0;
                            break _L$16;
                          }
                          break _L$15;
                        }
                        _M0MPC15array5Array4pushGUssEE(validation_errors, _try_err);
                        return undefined;
                      }
                      _L$16: {
                        _L$17: {
                          if (host.$tag === 0) {
                            const _Domain = host;
                            const _x$2 = _Domain._0;
                            if (_x$2 === "localhost") {
                              url.host = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2114;
                            } else {
                              break _L$17;
                            }
                          } else {
                            break _L$17;
                          }
                          break _L$16;
                        }
                        url.host = host;
                      }
                      _M0MPB13StringBuilder5reset(buffer);
                      state = 16;
                    }
                  }
                }
              }
            }
            break _L$3;
          }
          if (has_state_override && url.scheme === "file") {
            state = 5;
            continue;
          }
          if (_c === 91) {
            inside_brackets = true;
            _M0IPB13StringBuilderPB6Logger11write__char(buffer, _c);
          } else {
            if (_c === 93) {
              inside_brackets = false;
              _M0IPB13StringBuilderPB6Logger11write__char(buffer, _c);
            } else {
              _L$5: {
                _L$6: {
                  if (_c === 58) {
                    if (!inside_brackets) {
                      if (buffer.val === "") {
                        _M0MPC15array5Array4pushGUssEE(validation_errors, _M0DTPC15error5Error48tonyfettes_2furl_2eValidationError_2eHostMissing__);
                        return undefined;
                      }
                      if (state_override === undefined) {
                      } else {
                        const _Some = state_override;
                        const _x$2 = _Some;
                        if (_x$2 === 14) {
                          return undefined;
                        }
                      }
                      let host;
                      let _try_err;
                      _L$7: {
                        _L$8: {
                          const _bind$8 = buffer.val;
                          const _bind$9 = _M0MP210tonyfettes3url4Host13parse_2einner(new _M0TPC16string10StringView(_bind$8, 0, _bind$8.length), !_M0MP210tonyfettes3url3Url11is__special(url));
                          if (_bind$9.$tag === 1) {
                            const _ok = _bind$9;
                            host = _ok._0;
                          } else {
                            const _err = _bind$9;
                            _try_err = _err._0;
                            break _L$8;
                          }
                          break _L$7;
                        }
                        _M0MPC15array5Array4pushGUssEE(validation_errors, _try_err);
                        return undefined;
                      }
                      url.host = host;
                      _M0MPB13StringBuilder5reset(buffer);
                      state = 15;
                    } else {
                      break _L$6;
                    }
                  } else {
                    break _L$6;
                  }
                  break _L$5;
                }
                _L$7: {
                  _L$8: {
                    _L$9: {
                      _L$10: {
                        switch (_c) {
                          case 47: {
                            break _L$10;
                          }
                          case 63: {
                            break _L$10;
                          }
                          case 35: {
                            break _L$10;
                          }
                          default: {
                            _L$11: {
                              if (_M0MP210tonyfettes3url3Url11is__special(url)) {
                                if (_c === 92) {
                                  break _L$8;
                                } else {
                                  break _L$11;
                                }
                              } else {
                                break _L$11;
                              }
                            }
                            _M0IPB13StringBuilderPB6Logger11write__char(buffer, _c);
                          }
                        }
                        break _L$9;
                      }
                      break _L$8;
                    }
                    break _L$7;
                  }
                  _M0MP210tonyfettes3url13StringPointer8decrease(pointer);
                  if (_M0MP210tonyfettes3url3Url11is__special(url) && buffer.val === "") {
                    _M0MPC15array5Array4pushGUssEE(validation_errors, _M0DTPC15error5Error48tonyfettes_2furl_2eValidationError_2eHostMissing__);
                    return undefined;
                  }
                  if (has_state_override) {
                    if (buffer.val === "") {
                      _L$9: {
                        _L$10: {
                          const _p$4 = url.username;
                          if (!(_p$4 === "")) {
                            break _L$10;
                          } else {
                            const _p$5 = url.password;
                            if (!(_p$5 === "")) {
                              break _L$10;
                            } else {
                              const _bind$8 = url.port;
                              if (_bind$8 === -1) {
                              } else {
                                break _L$10;
                              }
                            }
                          }
                          break _L$9;
                        }
                        return undefined;
                      }
                    }
                  }
                  if (buffer.val === "") {
                    url.host = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2087;
                  } else {
                    let host;
                    let _try_err;
                    _L$9: {
                      _L$10: {
                        const _bind$8 = buffer.val;
                        const _bind$9 = _M0MP210tonyfettes3url4Host13parse_2einner(new _M0TPC16string10StringView(_bind$8, 0, _bind$8.length), !_M0MP210tonyfettes3url3Url11is__special(url));
                        if (_bind$9.$tag === 1) {
                          const _ok = _bind$9;
                          host = _ok._0;
                        } else {
                          const _err = _bind$9;
                          _try_err = _err._0;
                          break _L$10;
                        }
                        break _L$9;
                      }
                      _M0MPC15array5Array4pushGUssEE(validation_errors, _try_err);
                      return undefined;
                    }
                    url.host = host;
                  }
                  _M0MPB13StringBuilder5reset(buffer);
                  state = 16;
                  if (has_state_override) {
                    return url;
                  }
                }
              }
            }
          }
        }
      } else {
        break;
      }
      _tmp$38 = _M0MP210tonyfettes3url13StringPointer4next(pointer);
      continue;
    }
    _L$3: {
      _L$4: {
        _L$5: {
          _L$6: {
            _L$7: {
              _L$8: {
                _L$9: {
                  _L$10: {
                    const _bind$4 = state;
                    switch (_bind$4) {
                      case 0: {
                        break _L$10;
                      }
                      case 2: {
                        break _L$10;
                      }
                      case 1: {
                        if (has_state_override) {
                          return undefined;
                        } else {
                          if (base === undefined) {
                            _M0MPC15array5Array4pushGUssEE(validation_errors, _M0DTPC15error5Error64tonyfettes_2furl_2eValidationError_2eMissingSchemeNonRelativeUrl__);
                            return undefined;
                          } else {
                            _M0MPB13StringBuilder5reset(buffer);
                            state = 2;
                            _M0MP210tonyfettes3url13StringPointer11start__over(pointer);
                            continue _L;
                          }
                        }
                      }
                      case 12: {
                        if (at_sign_seen && buffer.val === "") {
                          _M0MPC15array5Array4pushGUssEE(validation_errors, _M0DTPC15error5Error48tonyfettes_2furl_2eValidationError_2eHostMissing__);
                          return undefined;
                        }
                        const buffer_str = buffer.val;
                        if (buffer_str === "") {
                          if (_M0MP210tonyfettes3url3Url11is__special(url)) {
                            _M0MPC15array5Array4pushGUssEE(validation_errors, _M0DTPC15error5Error48tonyfettes_2furl_2eValidationError_2eHostMissing__);
                            return undefined;
                          }
                          url.host = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2118;
                        } else {
                          let port_separator = -1;
                          if (_M0MPC16string6String11has__prefix(buffer_str, new _M0TPC16string10StringView(_M0MP210tonyfettes3url3Url20parse__basic_2einnerN7_2abindS1610, 0, _M0MP210tonyfettes3url3Url20parse__basic_2einnerN7_2abindS1610.length))) {
                            let found_bracket = false;
                            const _it = _M0MPC16string6String5iter2(buffer_str);
                            while (true) {
                              const _bind$5 = _M0MPB5Iter24nextGicE(_it);
                              if (_bind$5 === undefined) {
                                break;
                              } else {
                                const _Some = _bind$5;
                                const _x = _Some;
                                const _i = _x._0;
                                const _c = _x._1;
                                if (_c === 93) {
                                  found_bracket = true;
                                } else {
                                  if (found_bracket && _c === 58) {
                                    port_separator = _i;
                                    break;
                                  }
                                }
                                continue;
                              }
                            }
                          } else {
                            const _it = _M0MPC16string6String5iter2(buffer_str);
                            while (true) {
                              const _bind$5 = _M0MPB5Iter24nextGicE(_it);
                              if (_bind$5 === undefined) {
                                break;
                              } else {
                                const _Some = _bind$5;
                                const _x = _Some;
                                const _i = _x._0;
                                const _c = _x._1;
                                if (_c === 58) {
                                  port_separator = _i;
                                }
                                continue;
                              }
                            }
                          }
                          const has_port = port_separator > 0;
                          if (has_port) {
                            const last_colon = port_separator;
                            if (last_colon > 0) {
                              const host_builder = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                              const port_builder = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                              let past_colon = false;
                              let char_idx = 0;
                              const _it = _M0MPC16string6String4iter(buffer_str);
                              while (true) {
                                const _bind$5 = _M0MPB4Iter4nextGcE(_it);
                                if (_bind$5 === -1) {
                                  break;
                                } else {
                                  const _Some = _bind$5;
                                  const _c = _Some;
                                  if (char_idx === last_colon) {
                                    past_colon = true;
                                  } else {
                                    if (past_colon) {
                                      _M0IPB13StringBuilderPB6Logger11write__char(port_builder, _c);
                                    } else {
                                      _M0IPB13StringBuilderPB6Logger11write__char(host_builder, _c);
                                    }
                                  }
                                  char_idx = char_idx + 1 | 0;
                                  continue;
                                }
                              }
                              const host_part = host_builder.val;
                              const port_part = port_builder.val;
                              let host;
                              let _try_err;
                              _L$11: {
                                _L$12: {
                                  const _bind$5 = _M0MP210tonyfettes3url4Host13parse_2einner(new _M0TPC16string10StringView(host_part, 0, host_part.length), !_M0MP210tonyfettes3url3Url11is__special(url));
                                  if (_bind$5.$tag === 1) {
                                    const _ok = _bind$5;
                                    host = _ok._0;
                                  } else {
                                    const _err = _bind$5;
                                    _try_err = _err._0;
                                    break _L$12;
                                  }
                                  break _L$11;
                                }
                                _M0MPC15array5Array4pushGUssEE(validation_errors, _try_err);
                                return undefined;
                              }
                              url.host = host;
                              if (!(port_part === "")) {
                                let port_value = 0n;
                                const _it$2 = _M0MPC16string6String4iter(port_part);
                                while (true) {
                                  const _bind$5 = _M0MPB4Iter4nextGcE(_it$2);
                                  if (_bind$5 === -1) {
                                    break;
                                  } else {
                                    const _Some = _bind$5;
                                    const _ch = _Some;
                                    if (!_M0MPC14char4Char16is__ascii__digit(_ch)) {
                                      return undefined;
                                    }
                                    const _tmp$39 = BigInt.asUintN(64, port_value * 10n);
                                    const _p$4 = _ch - 48 | 0;
                                    port_value = BigInt.asUintN(64, _tmp$39 + BigInt.asUintN(64, BigInt(_p$4)));
                                    if (BigInt.asUintN(64, port_value) > BigInt.asUintN(64, 65535n)) {
                                      return undefined;
                                    }
                                    continue;
                                  }
                                }
                                const _p$4 = port_value;
                                const port_u16 = Number(BigInt.asUintN(16, _p$4));
                                let is_default;
                                _L$12: {
                                  _L$13: {
                                    _L$14: {
                                      _L$15: {
                                        const _bind$5 = url.scheme;
                                        switch (_bind$5) {
                                          case "ftp": {
                                            const _p$5 = 21;
                                            is_default = port_u16 === _p$5;
                                            break;
                                          }
                                          case "http": {
                                            break _L$15;
                                          }
                                          case "ws": {
                                            break _L$15;
                                          }
                                          case "https": {
                                            break _L$13;
                                          }
                                          case "wss": {
                                            break _L$13;
                                          }
                                          default: {
                                            is_default = false;
                                          }
                                        }
                                        break _L$14;
                                      }
                                      const _p$5 = 80;
                                      is_default = port_u16 === _p$5;
                                    }
                                    break _L$12;
                                  }
                                  const _p$5 = 443;
                                  is_default = port_u16 === _p$5;
                                }
                                url.port = is_default ? -1 : port_u16;
                              }
                            } else {
                              let host;
                              let _try_err;
                              _L$11: {
                                _L$12: {
                                  const _bind$5 = _M0MP210tonyfettes3url4Host13parse_2einner(new _M0TPC16string10StringView(buffer_str, 0, buffer_str.length), !_M0MP210tonyfettes3url3Url11is__special(url));
                                  if (_bind$5.$tag === 1) {
                                    const _ok = _bind$5;
                                    host = _ok._0;
                                  } else {
                                    const _err = _bind$5;
                                    _try_err = _err._0;
                                    break _L$12;
                                  }
                                  break _L$11;
                                }
                                _M0MPC15array5Array4pushGUssEE(validation_errors, _try_err);
                                return undefined;
                              }
                              url.host = host;
                            }
                          } else {
                            let host;
                            let _try_err;
                            _L$11: {
                              _L$12: {
                                const _bind$5 = _M0MP210tonyfettes3url4Host13parse_2einner(new _M0TPC16string10StringView(buffer_str, 0, buffer_str.length), !_M0MP210tonyfettes3url3Url11is__special(url));
                                if (_bind$5.$tag === 1) {
                                  const _ok = _bind$5;
                                  host = _ok._0;
                                } else {
                                  const _err = _bind$5;
                                  _try_err = _err._0;
                                  break _L$12;
                                }
                                break _L$11;
                              }
                              _M0MPC15array5Array4pushGUssEE(validation_errors, _try_err);
                              return undefined;
                            }
                            url.host = host;
                          }
                        }
                        break;
                      }
                      case 13: {
                        break _L$8;
                      }
                      case 14: {
                        break _L$8;
                      }
                      case 15: {
                        if (!(buffer.val === "")) {
                          const port_str = buffer.val;
                          let port_value = 0n;
                          const _it = _M0MPC16string6String4iter(port_str);
                          while (true) {
                            const _bind$5 = _M0MPB4Iter4nextGcE(_it);
                            if (_bind$5 === -1) {
                              break;
                            } else {
                              const _Some = _bind$5;
                              const _ch = _Some;
                              const _tmp$39 = BigInt.asUintN(64, port_value * 10n);
                              const _p$4 = _ch - 48 | 0;
                              port_value = BigInt.asUintN(64, _tmp$39 + BigInt.asUintN(64, BigInt(_p$4)));
                              if (BigInt.asUintN(64, port_value) > BigInt.asUintN(64, 65535n)) {
                                return undefined;
                              }
                              continue;
                            }
                          }
                          const _p$4 = port_value;
                          const port_u16 = Number(BigInt.asUintN(16, _p$4));
                          let is_default;
                          _L$11: {
                            _L$12: {
                              _L$13: {
                                _L$14: {
                                  const _bind$5 = url.scheme;
                                  switch (_bind$5) {
                                    case "ftp": {
                                      const _p$5 = 21;
                                      is_default = port_u16 === _p$5;
                                      break;
                                    }
                                    case "http": {
                                      break _L$14;
                                    }
                                    case "ws": {
                                      break _L$14;
                                    }
                                    case "https": {
                                      break _L$12;
                                    }
                                    case "wss": {
                                      break _L$12;
                                    }
                                    default: {
                                      is_default = false;
                                    }
                                  }
                                  break _L$13;
                                }
                                const _p$5 = 80;
                                is_default = port_u16 === _p$5;
                              }
                              break _L$11;
                            }
                            const _p$5 = 443;
                            is_default = port_u16 === _p$5;
                          }
                          url.port = is_default ? -1 : port_u16;
                        } else {
                          if (has_state_override) {
                            return undefined;
                          }
                        }
                        break;
                      }
                      case 16: {
                        if (has_state_override) {
                          const _bind$5 = url.host;
                          if (_bind$5 === undefined) {
                            const _bind$6 = url.path;
                            if (_bind$6.$tag === 1) {
                              const _Segments = _bind$6;
                              const _segments = _Segments._0;
                              _M0MPC15array5Array4pushGUssEE(_segments, "");
                            }
                          }
                        }
                        break;
                      }
                      case 17: {
                        const buffer_str$2 = buffer.val;
                        if (_M0FP210tonyfettes3url30is__double__dot__path__segment(buffer_str$2)) {
                          _M0MP210tonyfettes3url4Path15shorten_2einner(url.path, url.scheme);
                          const _bind$5 = url.path;
                          if (_bind$5.$tag === 1) {
                            const _Segments = _bind$5;
                            const _segments = _Segments._0;
                            _M0MPC15array5Array4pushGUssEE(_segments, "");
                          }
                        } else {
                          if (_M0FP210tonyfettes3url30is__single__dot__path__segment(buffer_str$2)) {
                            const _bind$5 = url.path;
                            if (_bind$5.$tag === 1) {
                              const _Segments = _bind$5;
                              const _segments = _Segments._0;
                              _M0MPC15array5Array4pushGUssEE(_segments, "");
                            }
                          } else {
                            _L$11: {
                              _L$12: {
                                if (url.scheme === "file") {
                                  const _bind$5 = url.path;
                                  if (_bind$5.$tag === 1) {
                                    const _Segments = _bind$5;
                                    const _segments = _Segments._0;
                                    if (_segments.length === 0) {
                                      if (buffer_str$2.length === 2) {
                                        _L$13: {
                                          _L$14: {
                                            let letter;
                                            _L$15: {
                                              if (_M0MPC16string6String24char__length__eq_2einner(buffer_str$2, 2, 0, buffer_str$2.length)) {
                                                const _letter = _M0MPC16string6String16unsafe__char__at(buffer_str$2, _M0MPC16string6String29offset__of__nth__char_2einner(buffer_str$2, 0, 0, buffer_str$2.length));
                                                const _x = _M0MPC16string6String16unsafe__char__at(buffer_str$2, _M0MPC16string6String29offset__of__nth__char_2einner(buffer_str$2, 1, 0, buffer_str$2.length));
                                                switch (_x) {
                                                  case 58: {
                                                    if (_M0MPC14char4Char21is__ascii__alphabetic(_letter)) {
                                                      letter = _letter;
                                                      break _L$15;
                                                    } else {
                                                      break _L$14;
                                                    }
                                                  }
                                                  case 124: {
                                                    if (_M0MPC14char4Char21is__ascii__alphabetic(_letter)) {
                                                      letter = _letter;
                                                      break _L$15;
                                                    } else {
                                                      break _L$14;
                                                    }
                                                  }
                                                  default: {
                                                    break _L$14;
                                                  }
                                                }
                                              } else {
                                                break _L$14;
                                              }
                                            }
                                            const _bind$6 = url.path;
                                            if (_bind$6.$tag === 1) {
                                              const _Segments$2 = _bind$6;
                                              const _segments$2 = _Segments$2._0;
                                              _M0MPC15array5Array4pushGUssEE(_segments$2, `${_M0IPC14char4CharPB4Show10to__string(letter)}:`);
                                            }
                                            break _L$13;
                                          }
                                          const _bind$6 = url.path;
                                          if (_bind$6.$tag === 1) {
                                            const _Segments$2 = _bind$6;
                                            const _segments$2 = _Segments$2._0;
                                            const _p$4 = new _M0TPC16string10StringView(buffer_str$2, 0, buffer_str$2.length);
                                            const _p$5 = false;
                                            const _p$6 = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                                            const _p$7 = _M0FPC28encoding4utf814encode_2einner(_p$4, false);
                                            const _p$8 = _p$7.length;
                                            let _tmp$39 = 0;
                                            while (true) {
                                              const _p$9 = _tmp$39;
                                              if (_p$9 < _p$8) {
                                                const _p$10 = _p$7[_p$9];
                                                _L$15: {
                                                  if (_p$5) {
                                                    if (_p$10 === 32) {
                                                      _M0IPB13StringBuilderPB6Logger11write__char(_p$6, 43);
                                                      break _L$15;
                                                    }
                                                  }
                                                  const _p$11 = _p$10;
                                                  if (_M0FP210tonyfettes3url26path__percent__encode__set(_p$11)) {
                                                    _M0IPB13StringBuilderPB6Logger11write__char(_p$6, 37);
                                                    const _p$12 = _p$10;
                                                    const _p$13 = _p$12 >> 4 & 15;
                                                    $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$13);
                                                    _M0IPB13StringBuilderPB6Logger11write__char(_p$6, _M0FP210tonyfettes3url11hex__digits[_p$13]);
                                                    const _p$14 = _p$12 & 15;
                                                    $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$14);
                                                    _M0IPB13StringBuilderPB6Logger11write__char(_p$6, _M0FP210tonyfettes3url11hex__digits[_p$14]);
                                                    break _L$15;
                                                  } else {
                                                    _M0IPB13StringBuilderPB6Logger11write__char(_p$6, _p$11);
                                                  }
                                                  break _L$15;
                                                }
                                                _tmp$39 = _p$9 + 1 | 0;
                                                continue;
                                              } else {
                                                break;
                                              }
                                            }
                                            _M0MPC15array5Array4pushGUssEE(_segments$2, _p$6.val);
                                          } else {
                                            const _Opaque = _bind$6;
                                            const _s = _Opaque._0;
                                            const _p$4 = new _M0TPC16string10StringView(buffer_str$2, 0, buffer_str$2.length);
                                            const _p$5 = false;
                                            const _p$6 = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                                            const _p$7 = _M0FPC28encoding4utf814encode_2einner(_p$4, false);
                                            const _p$8 = _p$7.length;
                                            let _tmp$39 = 0;
                                            while (true) {
                                              const _p$9 = _tmp$39;
                                              if (_p$9 < _p$8) {
                                                const _p$10 = _p$7[_p$9];
                                                _L$15: {
                                                  if (_p$5) {
                                                    if (_p$10 === 32) {
                                                      _M0IPB13StringBuilderPB6Logger11write__char(_p$6, 43);
                                                      break _L$15;
                                                    }
                                                  }
                                                  const _p$11 = _p$10;
                                                  if (_M0FP210tonyfettes3url26path__percent__encode__set(_p$11)) {
                                                    _M0IPB13StringBuilderPB6Logger11write__char(_p$6, 37);
                                                    const _p$12 = _p$10;
                                                    const _p$13 = _p$12 >> 4 & 15;
                                                    $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$13);
                                                    _M0IPB13StringBuilderPB6Logger11write__char(_p$6, _M0FP210tonyfettes3url11hex__digits[_p$13]);
                                                    const _p$14 = _p$12 & 15;
                                                    $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$14);
                                                    _M0IPB13StringBuilderPB6Logger11write__char(_p$6, _M0FP210tonyfettes3url11hex__digits[_p$14]);
                                                    break _L$15;
                                                  } else {
                                                    _M0IPB13StringBuilderPB6Logger11write__char(_p$6, _p$11);
                                                  }
                                                  break _L$15;
                                                }
                                                _tmp$39 = _p$9 + 1 | 0;
                                                continue;
                                              } else {
                                                break;
                                              }
                                            }
                                            url.path = new _M0DTP210tonyfettes3url4Path6Opaque(`${_s}/${_p$6.val}`);
                                          }
                                        }
                                      } else {
                                        break _L$12;
                                      }
                                    } else {
                                      break _L$12;
                                    }
                                  } else {
                                    break _L$12;
                                  }
                                } else {
                                  break _L$12;
                                }
                                break _L$11;
                              }
                              const _bind$5 = url.path;
                              if (_bind$5.$tag === 1) {
                                const _Segments = _bind$5;
                                const _segments = _Segments._0;
                                const _p$4 = new _M0TPC16string10StringView(buffer_str$2, 0, buffer_str$2.length);
                                const _p$5 = false;
                                const _p$6 = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                                const _p$7 = _M0FPC28encoding4utf814encode_2einner(_p$4, false);
                                const _p$8 = _p$7.length;
                                let _tmp$39 = 0;
                                while (true) {
                                  const _p$9 = _tmp$39;
                                  if (_p$9 < _p$8) {
                                    const _p$10 = _p$7[_p$9];
                                    _L$13: {
                                      if (_p$5) {
                                        if (_p$10 === 32) {
                                          _M0IPB13StringBuilderPB6Logger11write__char(_p$6, 43);
                                          break _L$13;
                                        }
                                      }
                                      const _p$11 = _p$10;
                                      if (_M0FP210tonyfettes3url26path__percent__encode__set(_p$11)) {
                                        _M0IPB13StringBuilderPB6Logger11write__char(_p$6, 37);
                                        const _p$12 = _p$10;
                                        const _p$13 = _p$12 >> 4 & 15;
                                        $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$13);
                                        _M0IPB13StringBuilderPB6Logger11write__char(_p$6, _M0FP210tonyfettes3url11hex__digits[_p$13]);
                                        const _p$14 = _p$12 & 15;
                                        $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$14);
                                        _M0IPB13StringBuilderPB6Logger11write__char(_p$6, _M0FP210tonyfettes3url11hex__digits[_p$14]);
                                        break _L$13;
                                      } else {
                                        _M0IPB13StringBuilderPB6Logger11write__char(_p$6, _p$11);
                                      }
                                      break _L$13;
                                    }
                                    _tmp$39 = _p$9 + 1 | 0;
                                    continue;
                                  } else {
                                    break;
                                  }
                                }
                                _M0MPC15array5Array4pushGUssEE(_segments, _p$6.val);
                              } else {
                                const _Opaque = _bind$5;
                                const _s = _Opaque._0;
                                const _p$4 = new _M0TPC16string10StringView(buffer_str$2, 0, buffer_str$2.length);
                                const _p$5 = false;
                                const _p$6 = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                                const _p$7 = _M0FPC28encoding4utf814encode_2einner(_p$4, false);
                                const _p$8 = _p$7.length;
                                let _tmp$39 = 0;
                                while (true) {
                                  const _p$9 = _tmp$39;
                                  if (_p$9 < _p$8) {
                                    const _p$10 = _p$7[_p$9];
                                    _L$13: {
                                      if (_p$5) {
                                        if (_p$10 === 32) {
                                          _M0IPB13StringBuilderPB6Logger11write__char(_p$6, 43);
                                          break _L$13;
                                        }
                                      }
                                      const _p$11 = _p$10;
                                      if (_M0FP210tonyfettes3url26path__percent__encode__set(_p$11)) {
                                        _M0IPB13StringBuilderPB6Logger11write__char(_p$6, 37);
                                        const _p$12 = _p$10;
                                        const _p$13 = _p$12 >> 4 & 15;
                                        $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$13);
                                        _M0IPB13StringBuilderPB6Logger11write__char(_p$6, _M0FP210tonyfettes3url11hex__digits[_p$13]);
                                        const _p$14 = _p$12 & 15;
                                        $bound_check(_M0FP210tonyfettes3url11hex__digits, _p$14);
                                        _M0IPB13StringBuilderPB6Logger11write__char(_p$6, _M0FP210tonyfettes3url11hex__digits[_p$14]);
                                        break _L$13;
                                      } else {
                                        _M0IPB13StringBuilderPB6Logger11write__char(_p$6, _p$11);
                                      }
                                      break _L$13;
                                    }
                                    _tmp$39 = _p$9 + 1 | 0;
                                    continue;
                                  } else {
                                    break;
                                  }
                                }
                                url.path = new _M0DTP210tonyfettes3url4Path6Opaque(`${_s}/${_p$6.val}`);
                              }
                            }
                          }
                        }
                        break;
                      }
                      case 5: {
                        url.scheme = "file";
                        const buffer_str$3 = buffer.val;
                        if (buffer_str$3 === "") {
                          url.host = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2120;
                        } else {
                          let is_drive_letter;
                          if (buffer_str$3.length === 2) {
                            let _tmp$39;
                            const _bind$5 = _M0MPC16string6String9get__char(buffer_str$3, 0);
                            let _tmp$40;
                            if (_bind$5 === -1) {
                              _tmp$40 = false;
                            } else {
                              const _Some = _bind$5;
                              const _c = _Some;
                              _tmp$40 = _M0MPC14char4Char21is__ascii__alphabetic(_c);
                            }
                            if (_tmp$40) {
                              const _bind$6 = _M0MPC16string6String9get__char(buffer_str$3, 1);
                              let _tmp$41;
                              if (_bind$6 === -1) {
                                _tmp$41 = false;
                              } else {
                                const _Some = _bind$6;
                                const _x = _Some;
                                switch (_x) {
                                  case 58: {
                                    _tmp$41 = true;
                                    break;
                                  }
                                  case 124: {
                                    _tmp$41 = true;
                                    break;
                                  }
                                  default: {
                                    _tmp$41 = false;
                                  }
                                }
                              }
                              _tmp$39 = _tmp$41;
                            } else {
                              _tmp$39 = false;
                            }
                            is_drive_letter = _tmp$39;
                          } else {
                            is_drive_letter = false;
                          }
                          if (is_drive_letter) {
                            url.host = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2122;
                            const _p$4 = _M0MPC16string6String9get__char(buffer_str$3, 0);
                            const letter = _p$4 === -1 ? $panic() : _p$4;
                            url.path = new _M0DTP210tonyfettes3url4Path8Segments([`${_M0IPC14char4CharPB4Show10to__string(letter)}:`]);
                          } else {
                            let host;
                            let _try_err;
                            _L$11: {
                              _L$12: {
                                const _bind$5 = _M0MP210tonyfettes3url4Host13parse_2einner(new _M0TPC16string10StringView(buffer_str$3, 0, buffer_str$3.length), false);
                                if (_bind$5.$tag === 1) {
                                  const _ok = _bind$5;
                                  host = _ok._0;
                                } else {
                                  const _err = _bind$5;
                                  _try_err = _err._0;
                                  break _L$12;
                                }
                                break _L$11;
                              }
                              _M0MPC15array5Array4pushGUssEE(validation_errors, _try_err);
                              return undefined;
                            }
                            _L$12: {
                              _L$13: {
                                if (host.$tag === 0) {
                                  const _Domain = host;
                                  const _x = _Domain._0;
                                  if (_x === "localhost") {
                                    url.host = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2124;
                                  } else {
                                    break _L$13;
                                  }
                                } else {
                                  break _L$13;
                                }
                                break _L$12;
                              }
                              url.host = host;
                            }
                          }
                        }
                        break;
                      }
                      case 8: {
                        break _L$6;
                      }
                      case 6: {
                        break _L$6;
                      }
                      case 7: {
                        if (base === undefined) {
                          _M0FPC15abort5abortGuE("base must be Some(base) in RelativeSlash state at EOF");
                        } else {
                          const _Some = base;
                          const _base = _Some;
                          url.username = _base.username;
                          url.password = _base.password;
                          url.host = _base.host;
                          url.port = _base.port;
                        }
                        break;
                      }
                      case 3: {
                        _L$11: {
                          _L$12: {
                            if (base === undefined) {
                              break _L$12;
                            } else {
                              const _Some = base;
                              const _base = _Some;
                              if (_base.scheme === "file") {
                                url.host = _base.host;
                                url.path = _M0MP210tonyfettes3url4Path5clone(_base.path);
                                url.query = _base.query;
                              } else {
                                break _L$12;
                              }
                            }
                            break _L$11;
                          }
                          url.host = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2126;
                        }
                        break;
                      }
                      case 4: {
                        url.scheme = "file";
                        _L$12: {
                          _L$13: {
                            if (base === undefined) {
                              break _L$13;
                            } else {
                              const _Some = base;
                              const _base = _Some;
                              if (_base.scheme === "file") {
                                url.host = _base.host;
                                const _bind$5 = _base.path;
                                if (_bind$5.$tag === 1) {
                                  const _Segments = _bind$5;
                                  const _x = _Segments._0;
                                  if (_x.length >= 1) {
                                    const _drive = _x[0];
                                    if (_drive.length === 2) {
                                      if (_M0MPC16string6String24char__length__eq_2einner(_drive, 2, 0, _drive.length)) {
                                        const _letter = _M0MPC16string6String16unsafe__char__at(_drive, _M0MPC16string6String29offset__of__nth__char_2einner(_drive, 0, 0, _drive.length));
                                        const _x$2 = _M0MPC16string6String16unsafe__char__at(_drive, _M0MPC16string6String29offset__of__nth__char_2einner(_drive, 1, 0, _drive.length));
                                        if (_x$2 === 58) {
                                          if (_M0MPC14char4Char21is__ascii__alphabetic(_letter)) {
                                            url.path = new _M0DTP210tonyfettes3url4Path8Segments([_drive, ""]);
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              } else {
                                break _L$13;
                              }
                            }
                            break _L$12;
                          }
                          url.host = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2128;
                        }
                        break;
                      }
                      case 11: {
                        url.path = new _M0DTP210tonyfettes3url4Path8Segments([""]);
                        break;
                      }
                      case 10: {
                        break _L$4;
                      }
                      case 9: {
                        break _L$4;
                      }
                    }
                    break _L$9;
                  }
                  if (has_state_override) {
                    return undefined;
                  }
                  _M0MPC15array5Array4pushGUssEE(validation_errors, _M0DTPC15error5Error64tonyfettes_2furl_2eValidationError_2eMissingSchemeNonRelativeUrl__);
                  return undefined;
                }
                break _L$7;
              }
              if (_M0MP210tonyfettes3url3Url11is__special(url) && buffer.val === "") {
                _M0MPC15array5Array4pushGUssEE(validation_errors, _M0DTPC15error5Error48tonyfettes_2furl_2eValidationError_2eHostMissing__);
                return undefined;
              }
              if (has_state_override) {
                if (buffer.val === "") {
                  _L$9: {
                    _L$10: {
                      const _p$4 = url.username;
                      if (!(_p$4 === "")) {
                        break _L$10;
                      } else {
                        const _p$5 = url.password;
                        if (!(_p$5 === "")) {
                          break _L$10;
                        } else {
                          const _bind$4 = url.port;
                          if (_bind$4 === -1) {
                          } else {
                            break _L$10;
                          }
                        }
                      }
                      break _L$9;
                    }
                    return undefined;
                  }
                }
              }
              if (!(buffer.val === "")) {
                let host;
                let _try_err;
                _L$9: {
                  _L$10: {
                    const _bind$4 = buffer.val;
                    const _bind$5 = _M0MP210tonyfettes3url4Host13parse_2einner(new _M0TPC16string10StringView(_bind$4, 0, _bind$4.length), !_M0MP210tonyfettes3url3Url11is__special(url));
                    if (_bind$5.$tag === 1) {
                      const _ok = _bind$5;
                      host = _ok._0;
                    } else {
                      const _err = _bind$5;
                      _try_err = _err._0;
                      break _L$10;
                    }
                    break _L$9;
                  }
                  _M0MPC15array5Array4pushGUssEE(validation_errors, _try_err);
                  return undefined;
                }
                url.host = host;
              } else {
                if (!_M0MP210tonyfettes3url3Url11is__special(url)) {
                  url.host = _M0MP210tonyfettes3url3Url20parse__basic_2einnerN6constrS2116;
                }
              }
            }
            break _L$5;
          }
          if (base === undefined) {
            _M0FPC15abort5abortGuE("base must be Some(base) in Relative-like state at EOF");
          } else {
            const _Some = base;
            const _base = _Some;
            url.username = _base.username;
            url.password = _base.password;
            url.host = _base.host;
            url.port = _base.port;
            url.path = _M0MP210tonyfettes3url4Path5clone(_base.path);
            url.query = _base.query;
          }
        }
        break _L$3;
      }
      _M0MPC15array5Array4pushGUssEE(validation_errors, _M0DTPC15error5Error48tonyfettes_2furl_2eValidationError_2eHostMissing__);
      return undefined;
    }
    break;
  }
  return url;
}
function _M0MP210tonyfettes3url3Url12parse__basic(url, base, input, state_override, validation_errors$46$opt) {
  let validation_errors;
  if (validation_errors$46$opt.$tag === 1) {
    const _Some = validation_errors$46$opt;
    validation_errors = _Some._0;
  } else {
    validation_errors = [];
  }
  return _M0MP210tonyfettes3url3Url20parse__basic_2einner(url, base, input, state_override, validation_errors);
}
function _M0MP210tonyfettes3url3Url10try__parse(input, base, validation_errors) {
  const url = _M0MP210tonyfettes3url3Url3new();
  return _M0MP210tonyfettes3url3Url12parse__basic(url, base, input, undefined, validation_errors);
}
function _M0MP210tonyfettes3url4IPv410to__string(self) {
  const n = self;
  const b0 = n >>> 24 & 255;
  const b1 = n >>> 16 & 255;
  const b2 = n >>> 8 & 255;
  const b3 = n & 255;
  return `${_M0IPC14uint4UIntPB4Show10to__string(b0)}.${_M0IPC14uint4UIntPB4Show10to__string(b1)}.${_M0IPC14uint4UIntPB4Show10to__string(b2)}.${_M0IPC14uint4UIntPB4Show10to__string(b3)}`;
}
function _M0MP210tonyfettes3url4IPv610to__string(self) {
  const address = self;
  let compress_start = undefined;
  let compress_len = 0;
  let current_start = undefined;
  let current_len = 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < 8) {
      $bound_check(address, i);
      const _p$4 = address[i];
      const _p$5 = 0;
      if (_p$4 === _p$5) {
        const _bind$4 = current_start;
        if (_bind$4 === undefined) {
          current_start = i;
          current_len = 1;
        } else {
          current_len = current_len + 1 | 0;
        }
      } else {
        if (current_len > compress_len && current_len > 1) {
          compress_start = current_start;
          compress_len = current_len;
        }
        current_start = undefined;
        current_len = 0;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (current_len > compress_len && current_len > 1) {
    compress_start = current_start;
    compress_len = current_len;
  }
  const result = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  let ignore = false;
  while (true) {
    if (i < 8) {
      const _bind$4 = compress_start;
      if (_bind$4 === undefined) {
      } else {
        const _Some = _bind$4;
        const _start = _Some;
        if (i === _start) {
          _M0IPB13StringBuilderPB6Logger13write__string(result, "::");
          i = i + compress_len | 0;
          ignore = true;
          continue;
        }
      }
      if (i > 0 && !ignore) {
        _M0IPB13StringBuilderPB6Logger11write__char(result, 58);
      }
      ignore = false;
      const _tmp$39 = i;
      $bound_check(address, _tmp$39);
      const value = address[_tmp$39];
      if (value === 0) {
        _M0IPB13StringBuilderPB6Logger11write__char(result, 48);
      } else {
        let started = false;
        let _tmp$40 = 12;
        while (true) {
          const shift = _tmp$40;
          if (shift >= 0) {
            const digit = value >> shift & 15;
            if (digit !== 0 || started) {
              $bound_check(_M0FP210tonyfettes3url10hex__chars, digit);
              _M0IPB13StringBuilderPB6Logger11write__char(result, _M0FP210tonyfettes3url10hex__chars[digit]);
              started = true;
            }
            _tmp$40 = shift - 4 | 0;
            continue;
          } else {
            break;
          }
        }
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return result.val;
}
function _M0MP210tonyfettes3url4Host10to__string(self) {
  switch (self.$tag) {
    case 0: {
      const _Domain = self;
      return _Domain._0;
    }
    case 1: {
      const _IPv4 = self;
      const _ipv4 = _IPv4._0;
      return _M0MP210tonyfettes3url4IPv410to__string(_ipv4);
    }
    case 2: {
      const _IPv6 = self;
      const _ipv6 = _IPv6._0;
      return `[${_M0MP210tonyfettes3url4IPv610to__string(_ipv6)}]`;
    }
    default: {
      const _Opaque = self;
      return _Opaque._0;
    }
  }
}
function _M0MP210tonyfettes3url3Url10to__string(self) {
  const result = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger13write__string(result, self.scheme);
  _M0IPB13StringBuilderPB6Logger11write__char(result, 58);
  const _bind$4 = self.host;
  if (_bind$4 === undefined) {
    if (self.scheme === "file") {
      _M0IPB13StringBuilderPB6Logger13write__string(result, "//");
    }
  } else {
    const _Some = _bind$4;
    const _host = _Some;
    _M0IPB13StringBuilderPB6Logger13write__string(result, "//");
    let _tmp$38;
    const _p$4 = self.username;
    if (!(_p$4 === "")) {
      _tmp$38 = true;
    } else {
      const _p$5 = self.password;
      _tmp$38 = !(_p$5 === "");
    }
    if (_tmp$38) {
      _M0IPB13StringBuilderPB6Logger13write__string(result, self.username);
      const _p$5 = self.password;
      if (!(_p$5 === "")) {
        _M0IPB13StringBuilderPB6Logger11write__char(result, 58);
        _M0IPB13StringBuilderPB6Logger13write__string(result, self.password);
      }
      _M0IPB13StringBuilderPB6Logger11write__char(result, 64);
    }
    _M0IPB13StringBuilderPB6Logger13write__string(result, _M0MP210tonyfettes3url4Host10to__string(_host));
    const _bind$5 = self.port;
    if (_bind$5 === -1) {
    } else {
      const _Some$2 = _bind$5;
      const _port = _Some$2;
      _M0IPB13StringBuilderPB6Logger11write__char(result, 58);
      _M0IPB13StringBuilderPB6Logger13write__string(result, _M0MPC16uint166UInt1618to__string_2einner(_port, 10));
    }
  }
  const _bind$5 = self.path;
  if (_bind$5.$tag === 0) {
    const _Opaque = _bind$5;
    const _path = _Opaque._0;
    _M0IPB13StringBuilderPB6Logger13write__string(result, _path);
  } else {
    const _Segments = _bind$5;
    const _segments = _Segments._0;
    _L: {
      _L$2: {
        if (_segments.length === 0) {
          const _bind$6 = self.host;
          if (_bind$6 === undefined) {
            break _L$2;
          } else {
            if (_M0MP210tonyfettes3url3Url11is__special(self)) {
              _M0IPB13StringBuilderPB6Logger11write__char(result, 47);
            } else {
              break _L$2;
            }
          }
        } else {
          break _L$2;
        }
        break _L;
      }
      const _bind$6 = self.host;
      if (_bind$6 === undefined) {
        if (_segments.length > 1) {
          const _bind$7 = _M0MPC15array5Array2atGUssEE(_segments, 0);
          if (_bind$7 === "") {
            _M0IPB13StringBuilderPB6Logger13write__string(result, "/.");
          }
        }
      }
      const _bind$7 = _segments.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$7) {
          const segment = _segments[_];
          _M0IPB13StringBuilderPB6Logger11write__char(result, 47);
          _M0IPB13StringBuilderPB6Logger13write__string(result, segment);
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
    }
  }
  const _bind$6 = self.query;
  if (_bind$6 === undefined) {
  } else {
    const _Some = _bind$6;
    const _query = _Some;
    _M0IPB13StringBuilderPB6Logger11write__char(result, 63);
    _M0IPB13StringBuilderPB6Logger13write__string(result, _query);
  }
  const _bind$7 = self.fragment;
  if (_bind$7 === undefined) {
  } else {
    const _Some = _bind$7;
    const _fragment = _Some;
    _M0IPB13StringBuilderPB6Logger11write__char(result, 35);
    _M0IPB13StringBuilderPB6Logger13write__string(result, _fragment);
  }
  return result.val;
}
function _M0MP210tonyfettes3url3Url4href(self) {
  return _M0MP210tonyfettes3url3Url10to__string(self);
}
function _M0MP210tonyfettes3url3Url8protocol(self) {
  return `${self.scheme}:`;
}
function _M0FP410Haoxincode8moonbash3lib8commands14vm__hex__digit(n) {
  return n < 10 ? n + 48 | 0 : (n - 10 | 0) + 97 | 0;
}
function _M0FP410Haoxincode8moonbash3lib8commands24vm__json__escape__string(s) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger11write__char(out, 34);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      switch (ch) {
        case 34: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, "\\\"");
          break;
        }
        case 92: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, "\\\\");
          break;
        }
        case 10: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, "\\n");
          break;
        }
        case 13: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, "\\r");
          break;
        }
        case 9: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, "\\t");
          break;
        }
        default: {
          const code = ch;
          if (code < 32) {
            _M0IPB13StringBuilderPB6Logger13write__string(out, "\\u00");
            _M0IPB13StringBuilderPB6Logger11write__char(out, _M0FP410Haoxincode8moonbash3lib8commands14vm__hex__digit(code / 16 | 0));
            _M0IPB13StringBuilderPB6Logger11write__char(out, _M0FP410Haoxincode8moonbash3lib8commands14vm__hex__digit(code % 16 | 0));
          } else {
            _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
          }
        }
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger11write__char(out, 34);
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands18vm__args__to__json(args) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger11write__char(out, 91);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < args.length) {
      if (i > 0) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 44);
      }
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands24vm__json__escape__string(_M0MPC15array5Array2atGUssEE(args, i)));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger11write__char(out, 93);
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands17vm__env__to__json(env) {
  const keys = [];
  const _it = _M0MPB3Map5iter2GssE(env);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _key = _x._0;
      _M0MPC15array5Array4pushGUssEE(keys, _key);
      continue;
    }
  }
  _M0MPC15array5Array8sort__byGUssEE(keys, (a, b) => _M0IP016_24default__implPB7Compare6op__ltGsE(a, b) ? -1 : _M0IP016_24default__implPB7Compare6op__gtGsE(a, b) ? 1 : 0);
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger11write__char(out, 123);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < keys.length) {
      if (i > 0) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 44);
      }
      const key = _M0MPC15array5Array2atGUssEE(keys, i);
      const _p$4 = _M0MPB3Map3getGssE(env, key);
      const _p$5 = "";
      let value;
      if (_p$4 === undefined) {
        value = _p$5;
      } else {
        const _p$6 = _p$4;
        value = _p$6;
      }
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands24vm__json__escape__string(key));
      _M0IPB13StringBuilderPB6Logger11write__char(out, 58);
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands24vm__json__escape__string(value));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger11write__char(out, 125);
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands19vm__files__to__json(fs) {
  const keys = [];
  const _it = _M0MPB3Map5iter2GssE(fs.entries);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _path = _x._0;
      const _entry = _x._1;
      if (_entry.$tag === 0) {
        _M0MPC15array5Array4pushGUssEE(keys, _path);
      }
      continue;
    }
  }
  _M0MPC15array5Array8sort__byGUssEE(keys, (a, b) => _M0IP016_24default__implPB7Compare6op__ltGsE(a, b) ? -1 : _M0IP016_24default__implPB7Compare6op__gtGsE(a, b) ? 1 : 0);
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger11write__char(out, 123);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < keys.length) {
      if (i > 0) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 44);
      }
      const key = _M0MPC15array5Array2atGUssEE(keys, i);
      const _bind$4 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(fs.entries, key);
      let content;
      if (_bind$4 === undefined) {
        content = "";
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        if (_x.$tag === 0) {
          const _File = _x;
          const _data = _File._0;
          content = _data.content;
        } else {
          content = "";
        }
      }
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands24vm__json__escape__string(key));
      _M0IPB13StringBuilderPB6Logger11write__char(out, 58);
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands24vm__json__escape__string(content));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger11write__char(out, 125);
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands24vm__build__request__json(runtime_name, ctx) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger11write__char(out, 123);
  _M0IPB13StringBuilderPB6Logger13write__string(out, "\"runtime\":");
  _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands24vm__json__escape__string(runtime_name));
  _M0IPB13StringBuilderPB6Logger13write__string(out, ",\"args\":");
  _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands18vm__args__to__json(ctx.args));
  _M0IPB13StringBuilderPB6Logger13write__string(out, ",\"stdin\":");
  _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands24vm__json__escape__string(ctx.stdin_content));
  _M0IPB13StringBuilderPB6Logger13write__string(out, ",\"cwd\":");
  _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands24vm__json__escape__string(ctx.cwd));
  _M0IPB13StringBuilderPB6Logger13write__string(out, ",\"env\":");
  _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands17vm__env__to__json(ctx.env));
  _M0IPB13StringBuilderPB6Logger13write__string(out, ",\"files\":");
  _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands19vm__files__to__json(ctx.fs));
  _M0IPB13StringBuilderPB6Logger11write__char(out, 125);
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands21vm__json__get__string(obj, key, default_value) {
  _L: {
    const _bind$4 = _M0MPB3Map3getGsRPB4JsonE(obj, key);
    if (_bind$4 === undefined) {
      break _L;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      switch (_x.$tag) {
        case 4: {
          const _String = _x;
          return _String._0;
        }
        case 3: {
          const _Number = _x;
          const _n = _Number._0;
          return _M0MPC13int3Int18to__string_2einner(_M0MPC16double6Double7to__int(_n), 10);
        }
        case 1: {
          return "true";
        }
        case 2: {
          return "false";
        }
        case 0: {
          return "";
        }
        default: {
          break _L;
        }
      }
    }
  }
  return default_value;
}
function _M0FP410Haoxincode8moonbash3lib8commands15cmd__parse__int(s) {
  let result = 0n;
  let neg = false;
  let start = 0;
  let _tmp$38;
  if (s.length > 0) {
    $bound_check(s, 0);
    const _p$4 = s.charCodeAt(0);
    const _p$5 = 45;
    _tmp$38 = _p$4 === _p$5;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    neg = true;
    start = 1;
  } else {
    let _tmp$39;
    if (s.length > 0) {
      $bound_check(s, 0);
      const _p$4 = s.charCodeAt(0);
      const _p$5 = 43;
      _tmp$39 = _p$4 === _p$5;
    } else {
      _tmp$39 = false;
    }
    if (_tmp$39) {
      start = 1;
    }
  }
  let _tmp$39 = start;
  while (true) {
    const i = _tmp$39;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      if (ch >= 48 && ch <= 57) {
        result = BigInt.asUintN(64, BigInt.asUintN(64, result * 10n) + BigInt.asUintN(64, BigInt(ch - 48 | 0)));
      } else {
        break;
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return neg ? BigInt.asUintN(64, -result) : result;
}
function _M0FP410Haoxincode8moonbash3lib8commands18vm__json__get__int(obj, key, default_value) {
  _L: {
    const _bind$4 = _M0MPB3Map3getGsRPB4JsonE(obj, key);
    if (_bind$4 === undefined) {
      break _L;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      switch (_x.$tag) {
        case 3: {
          const _Number = _x;
          const _n = _Number._0;
          return _M0MPC16double6Double7to__int(_n);
        }
        case 4: {
          const _String = _x;
          const _s = _String._0;
          return Number(BigInt.asIntN(32, _M0FP410Haoxincode8moonbash3lib8commands15cmd__parse__int(_s))) | 0;
        }
        default: {
          break _L;
        }
      }
    }
  }
  return default_value;
}
function _M0FP410Haoxincode8moonbash3lib8commands20vm__json__get__files(obj) {
  _L: {
    const _bind$4 = _M0MPB3Map3getGsRPB4JsonE(obj, "files");
    if (_bind$4 === undefined) {
      break _L;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      if (_x.$tag === 6) {
        const _Object = _x;
        const _files_obj = _Object._0;
        const files = [];
        const _it = _M0MPB3Map5iter2GssE(_files_obj);
        while (true) {
          const _bind$5 = _M0MPB5Iter24nextGssE(_it);
          if (_bind$5 === undefined) {
            break;
          } else {
            const _Some$2 = _bind$5;
            const _x$2 = _Some$2;
            const _path = _x$2._0;
            const _value = _x$2._1;
            let content;
            switch (_value.$tag) {
              case 4: {
                const _String = _value;
                content = _String._0;
                break;
              }
              case 3: {
                const _Number = _value;
                const _n = _Number._0;
                content = _M0MPC13int3Int18to__string_2einner(_M0MPC16double6Double7to__int(_n), 10);
                break;
              }
              case 1: {
                content = "true";
                break;
              }
              case 2: {
                content = "false";
                break;
              }
              case 0: {
                content = "";
                break;
              }
              default: {
                content = _M0MPC14json4Json17stringify_2einner(_value, false, 0, undefined);
              }
            }
            _M0MPC15array5Array4pushGUssEE(files, { _0: _path, _1: content });
            continue;
          }
        }
        _M0MPC15array5Array8sort__byGUssEE(files, (a, b) => _M0IP016_24default__implPB7Compare6op__ltGsE(a._0, b._0) ? -1 : _M0IP016_24default__implPB7Compare6op__gtGsE(a._0, b._0) ? 1 : 0);
        return { _0: true, _1: files };
      } else {
        break _L;
      }
    }
  }
  return { _0: false, _1: [] };
}
function _M0FP410Haoxincode8moonbash3lib8commands24vm__apply__file__updates(fs, files) {
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < files.length) {
      const _bind$4 = _M0MPC15array5Array2atGUssEE(files, i);
      const _path = _bind$4._0;
      const _content = _bind$4._1;
      let _try_err;
      _L: {
        _L$2: {
          const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs11write__file(fs, _path, _content);
          if (_bind$5.$tag === 1) {
            const _ok = _bind$5;
            _ok._0;
          } else {
            const _err = _bind$5;
            _try_err = _err._0;
            break _L$2;
          }
          break _L;
        }
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands19vm__parse__response(json_str) {
  let parsed;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FPC14json13parse_2einner(new _M0TPC16string10StringView(json_str, 0, json_str.length), 1024);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        parsed = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    return _M0FP410Haoxincode8moonbash3lib8commands19vm__parse__responseN6constrS9206;
  }
  if (parsed.$tag === 6) {
    const _Object = parsed;
    const _obj = _Object._0;
    const exit_code = _M0FP410Haoxincode8moonbash3lib8commands18vm__json__get__int(_obj, "exitCode", _M0FP410Haoxincode8moonbash3lib8commands18vm__json__get__int(_obj, "exit_code", 1));
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands20vm__json__get__files(_obj);
    const _has_files = _bind$4._0;
    const _files = _bind$4._1;
    return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands14VmExecResponsesE2Ok(new _M0TP410Haoxincode8moonbash3lib8commands14VmExecResponse(_M0FP410Haoxincode8moonbash3lib8commands21vm__json__get__string(_obj, "stdout", ""), _M0FP410Haoxincode8moonbash3lib8commands21vm__json__get__string(_obj, "stderr", ""), exit_code, _M0FP410Haoxincode8moonbash3lib8commands21vm__json__get__string(_obj, "error", ""), _has_files, _files));
  } else {
    return _M0FP410Haoxincode8moonbash3lib8commands19vm__parse__responseN6constrS9207;
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands25vm__stderr__with__newline(stderr) {
  if (stderr.length === 0) {
    return "";
  }
  const _tmp$38 = stderr.length - 1 | 0;
  $bound_check(stderr, _tmp$38);
  const last = stderr.charCodeAt(_tmp$38);
  return last === 10 ? stderr : `${stderr}\n`;
}
function _M0FP410Haoxincode8moonbash3lib8commands7vm__run(runtime_name, ctx) {
  const request_json = _M0FP410Haoxincode8moonbash3lib8commands24vm__build__request__json(runtime_name, ctx);
  const raw = _M0FP410Haoxincode8moonbash3lib3ffi8vm__sync(request_json);
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands19vm__parse__response(raw);
  let response;
  if (_bind$4.$tag === 1) {
    const _Ok = _bind$4;
    response = _Ok._0;
  } else {
    const _Err = _bind$4;
    const _msg = _Err._0;
    return new _M0TP410Haoxincode8moonbash3lib3ast10ExecResult("", `${runtime_name}: ${_msg}\n`, 1);
  }
  if (response.error.length > 0) {
    const err = _M0MPB13StringBuilder21StringBuilder_2einner(0);
    if (response.stderr.length > 0) {
      _M0IPB13StringBuilderPB6Logger13write__string(err, _M0FP410Haoxincode8moonbash3lib8commands25vm__stderr__with__newline(response.stderr));
    }
    _M0IPB13StringBuilderPB6Logger13write__string(err, `${runtime_name}: ${response.error}\n`);
    return new _M0TP410Haoxincode8moonbash3lib3ast10ExecResult(response.stdout, err.val, response.exit_code === 0 ? 1 : response.exit_code);
  }
  if (response.has_files) {
    _M0FP410Haoxincode8moonbash3lib8commands24vm__apply__file__updates(ctx.fs, response.files);
  }
  return new _M0TP410Haoxincode8moonbash3lib3ast10ExecResult(response.stdout, response.stderr, response.exit_code);
}
function _M0FP410Haoxincode8moonbash3lib8commands12cmd__python3(ctx) {
  return _M0FP410Haoxincode8moonbash3lib8commands7vm__run("python3", ctx);
}
function _M0FP410Haoxincode8moonbash3lib8commands26cmd__js__exec__placeholder(ctx) {
  const display_name = ctx.args.length > 0 ? _M0MPC15array5Array2atGUssEE(ctx.args, 0) : "js-exec";
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", `${display_name}: JavaScript runtime bridge is not implemented yet\n`, 1);
}
function _M0FP410Haoxincode8moonbash3lib8commands12cmd__sqlite3(ctx) {
  return _M0FP410Haoxincode8moonbash3lib8commands7vm__run("sqlite3", ctx);
}
function _M0FP410Haoxincode8moonbash3lib8commands16cmd__read__input(ctx, path, cmd_name) {
  if (path === "-") {
    return { _0: ctx.stdin_content, _1: "" };
  }
  let resolved;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, path);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        resolved = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    const _FsError = _try_err;
    const _msg = _FsError._0;
    return { _0: "", _1: `${cmd_name}: ${_msg}\n` };
  }
  let content;
  let _try_err$2;
  _L$2: {
    _L$3: {
      const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, resolved);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        content = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err$2 = _err._0;
        break _L$3;
      }
      break _L$2;
    }
    const _FsError = _try_err$2;
    const _msg = _FsError._0;
    return { _0: "", _1: `${cmd_name}: ${path}: ${_msg}\n` };
  }
  return { _0: content, _1: "" };
}
function _M0FP410Haoxincode8moonbash3lib8commands17cmd__split__lines(s) {
  const result = [];
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      if (ch === 10) {
        _M0MPC15array5Array4pushGUssEE(result, buf.val);
        _M0MPB13StringBuilder5reset(buf);
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const remaining = buf.val;
  if (remaining.length > 0) {
    _M0MPC15array5Array4pushGUssEE(result, remaining);
  }
  return result;
}
function _M0FP410Haoxincode8moonbash3lib8commands27cmd__diff__unified__piediff(out, content1, content2, file1, file2) {
  const lines1 = _M0FP410Haoxincode8moonbash3lib8commands17cmd__split__lines(content1);
  const lines2 = _M0FP410Haoxincode8moonbash3lib8commands17cmd__split__lines(content2);
  const old = new _M0TPB9ArrayViewGsE(lines1, 0, lines1.length);
  const new_ = new _M0TPB9ArrayViewGsE(lines2, 0, lines2.length);
  const hunks = _M0MP219moonbit_2dcommunity7piediff4Diff13group_2einnerGsE(_M0MP219moonbit_2dcommunity7piediff4Diff3newGsE(old, new_, undefined, undefined), 3);
  if (hunks.length === 0) {
    return undefined;
  }
  _M0IPB13StringBuilderPB6Logger13write__string(out, `--- a/${file1}\n`);
  _M0IPB13StringBuilderPB6Logger13write__string(out, `+++ b/${file2}\n`);
  const _bind$4 = hunks.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const hunk = hunks[_];
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0IP016_24default__implPB4Show10to__stringGRP219moonbit_2dcommunity7piediff4HunkGsEE(hunk));
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands9cmd__diff(ctx) {
  let brief = false;
  const files = [];
  const _bind$4 = ctx.args;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const arg = _bind$4[_];
      switch (arg) {
        case "-u": {
          break;
        }
        case "-q": {
          brief = true;
          break;
        }
        default: {
          _M0MPC15array5Array4pushGUssEE(files, arg);
        }
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (files.length < 2) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", "diff: missing operand\n", 2);
  }
  const file1 = _M0MPC15array5Array2atGUssEE(files, files.length - 2 | 0);
  const file2 = _M0MPC15array5Array2atGUssEE(files, files.length - 1 | 0);
  const _bind$6 = _M0FP410Haoxincode8moonbash3lib8commands16cmd__read__input(ctx, file1, "diff");
  const _content1 = _bind$6._0;
  const _err1 = _bind$6._1;
  if (_err1.length > 0) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", _err1, 2);
  }
  const _bind$7 = _M0FP410Haoxincode8moonbash3lib8commands16cmd__read__input(ctx, file2, "diff");
  const _content2 = _bind$7._0;
  const _err2 = _bind$7._1;
  if (_err2.length > 0) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", _err2, 2);
  }
  if (_content1 === _content2) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", "", 0);
  }
  if (brief) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(`Files ${file1} and ${file2} differ\n`, "", 1);
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0FP410Haoxincode8moonbash3lib8commands27cmd__diff__unified__piediff(out, _content1, _content2, file1, file2);
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(out.val, "", 1);
}
function _M0FP410Haoxincode8moonbash3lib8commands27cmd__cmp__first__difference(content1, content2) {
  const max_common = content1.length < content2.length ? content1.length : content2.length;
  let byte_pos = 1;
  let line_no = 1;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < max_common) {
      $bound_check(content1, i);
      const _p$4 = content1.charCodeAt(i);
      $bound_check(content2, i);
      const _p$5 = content2.charCodeAt(i);
      if (_p$4 !== _p$5) {
        return { _0: byte_pos, _1: line_no, _2: true };
      }
      $bound_check(content1, i);
      if (content1.charCodeAt(i) === 10) {
        line_no = line_no + 1 | 0;
      }
      byte_pos = byte_pos + 1 | 0;
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return { _0: byte_pos, _1: line_no, _2: false };
}
function _M0FP410Haoxincode8moonbash3lib8commands8cmd__cmp(ctx) {
  let silent = false;
  let parsing_options = true;
  const files = [];
  const _bind$4 = ctx.args;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const arg = _bind$4[_];
      _L: {
        if (parsing_options && arg === "--") {
          parsing_options = false;
          break _L;
        }
        if (parsing_options && (arg === "-s" || (arg === "--silent" || arg === "-q"))) {
          silent = true;
          break _L;
        }
        let _tmp$39;
        if (parsing_options) {
          let _tmp$40;
          if (arg.length > 1) {
            $bound_check(arg, 0);
            const _p$4 = arg.charCodeAt(0);
            const _p$5 = 45;
            _tmp$40 = _p$4 === _p$5;
          } else {
            _tmp$40 = false;
          }
          _tmp$39 = _tmp$40;
        } else {
          _tmp$39 = false;
        }
        if (_tmp$39) {
          return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", `cmp: invalid option -- '${arg}'\n`, 2);
        }
        _M0MPC15array5Array4pushGUssEE(files, arg);
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (files.length < 2) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", "cmp: missing operand\n", 2);
  }
  const file1 = _M0MPC15array5Array2atGUssEE(files, 0);
  const file2 = _M0MPC15array5Array2atGUssEE(files, 1);
  const _bind$6 = _M0FP410Haoxincode8moonbash3lib8commands16cmd__read__input(ctx, file1, "cmp");
  const _content1 = _bind$6._0;
  const _err1 = _bind$6._1;
  if (_err1.length > 0) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", _err1, 2);
  }
  const _bind$7 = _M0FP410Haoxincode8moonbash3lib8commands16cmd__read__input(ctx, file2, "cmp");
  const _content2 = _bind$7._0;
  const _err2 = _bind$7._1;
  if (_err2.length > 0) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", _err2, 2);
  }
  if (_content1 === _content2) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", "", 0);
  }
  if (silent) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", "", 1);
  }
  const _bind$8 = _M0FP410Haoxincode8moonbash3lib8commands27cmd__cmp__first__difference(_content1, _content2);
  const _byte_pos = _bind$8._0;
  const _line_no = _bind$8._1;
  const _differs_in_common_prefix = _bind$8._2;
  if (_differs_in_common_prefix) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(`${file1} ${file2} differ: byte ${_M0IPC13int3IntPB4Show10to__string(_byte_pos)}, line ${_M0IPC13int3IntPB4Show10to__string(_line_no)}\n`, "", 1);
  }
  return _content1.length < _content2.length ? _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(`cmp: EOF on ${file1} after byte ${_M0IPC13int3IntPB4Show10to__string(_byte_pos)}, in line ${_M0IPC13int3IntPB4Show10to__string(_line_no)}\n`, "", 1) : _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(`cmp: EOF on ${file2} after byte ${_M0IPC13int3IntPB4Show10to__string(_byte_pos)}, in line ${_M0IPC13int3IntPB4Show10to__string(_line_no)}\n`, "", 1);
}
function _M0FP410Haoxincode8moonbash3lib8commands25cmd__find__compare__ascii(a, b) {
  const min_len = a.length < b.length ? a.length : b.length;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < min_len) {
      $bound_check(a, i);
      const _tmp$39 = a.charCodeAt(i);
      $bound_check(b, i);
      if (_M0IP016_24default__implPB7Compare6op__ltGkE(_tmp$39, b.charCodeAt(i))) {
        return -1;
      }
      $bound_check(a, i);
      const _tmp$40 = a.charCodeAt(i);
      $bound_check(b, i);
      if (_M0IP016_24default__implPB7Compare6op__gtGkE(_tmp$40, b.charCodeAt(i))) {
        return 1;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return a.length < b.length ? -1 : a.length > b.length ? 1 : 0;
}
function _M0FP410Haoxincode8moonbash3lib8commands9cmd__comm(ctx) {
  let suppress1 = false;
  let suppress2 = false;
  let suppress3 = false;
  const files = [];
  const _bind$4 = ctx.args;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const arg = _bind$4[_];
      let _tmp$39;
      if (arg.length > 1) {
        $bound_check(arg, 0);
        const _p$4 = arg.charCodeAt(0);
        const _p$5 = 45;
        _tmp$39 = _p$4 === _p$5;
      } else {
        _tmp$39 = false;
      }
      if (_tmp$39) {
        let is_flag = true;
        let _tmp$40 = 1;
        _L: while (true) {
          const k = _tmp$40;
          if (k < arg.length) {
            $bound_check(arg, k);
            const ch = arg.charCodeAt(k);
            switch (ch) {
              case 49: {
                suppress1 = true;
                break;
              }
              case 50: {
                suppress2 = true;
                break;
              }
              case 51: {
                suppress3 = true;
                break;
              }
              default: {
                is_flag = false;
                break _L;
              }
            }
            _tmp$40 = k + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        if (!is_flag) {
          _M0MPC15array5Array4pushGUssEE(files, arg);
        }
      } else {
        _M0MPC15array5Array4pushGUssEE(files, arg);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (files.length < 2) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("comm: missing operand\n");
  }
  const _bind$6 = _M0FP410Haoxincode8moonbash3lib8commands16cmd__read__input(ctx, _M0MPC15array5Array2atGUssEE(files, 0), "comm");
  const _content1 = _bind$6._0;
  const _err1 = _bind$6._1;
  if (_err1.length > 0) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(_err1);
  }
  const _bind$7 = _M0FP410Haoxincode8moonbash3lib8commands16cmd__read__input(ctx, _M0MPC15array5Array2atGUssEE(files, 1), "comm");
  const _content2 = _bind$7._0;
  const _err2 = _bind$7._1;
  if (_err2.length > 0) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(_err2);
  }
  const lines1 = _M0FP410Haoxincode8moonbash3lib8commands17cmd__split__lines(_content1);
  const lines2 = _M0FP410Haoxincode8moonbash3lib8commands17cmd__split__lines(_content2);
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  let j = 0;
  while (true) {
    if (i < lines1.length && j < lines2.length) {
      const cmp = _M0FP410Haoxincode8moonbash3lib8commands25cmd__find__compare__ascii(_M0MPC15array5Array2atGUssEE(lines1, i), _M0MPC15array5Array2atGUssEE(lines2, j));
      if (cmp < 0) {
        if (!suppress1) {
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(lines1, i));
          _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
        }
        i = i + 1 | 0;
      } else {
        if (cmp > 0) {
          if (!suppress2) {
            if (!suppress1) {
              _M0IPB13StringBuilderPB6Logger11write__char(out, 9);
            }
            _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(lines2, j));
            _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
          }
          j = j + 1 | 0;
        } else {
          if (!suppress3) {
            if (!suppress1) {
              _M0IPB13StringBuilderPB6Logger11write__char(out, 9);
            }
            if (!suppress2) {
              _M0IPB13StringBuilderPB6Logger11write__char(out, 9);
            }
            _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(lines1, i));
            _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
          }
          i = i + 1 | 0;
          j = j + 1 | 0;
        }
      }
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (i < lines1.length) {
      if (!suppress1) {
        _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(lines1, i));
        _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (j < lines2.length) {
      if (!suppress2) {
        if (!suppress1) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 9);
        }
        _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(lines2, j));
        _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
      }
      j = j + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(out.val);
}
function _M0FP410Haoxincode8moonbash3lib8commands14base64__encode(input, wrap_col) {
  const bytes = _M0FP27gmlewis6base649str2array(input);
  const fixed = $makebytes(bytes.length, 0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < bytes.length) {
      $bound_check(fixed, i);
      fixed[i] = _M0MPC15array5Array2atGyE(bytes, i);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const encoded = _M0FP27gmlewis6base6423std__encode2str_2einner(fixed, false);
  if (wrap_col > 0) {
    const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
    let col = 0;
    let _tmp$39 = 0;
    while (true) {
      const i = _tmp$39;
      if (i < encoded.length) {
        $bound_check(encoded, i);
        _M0IPB13StringBuilderPB6Logger11write__char(out, encoded.charCodeAt(i));
        col = col + 1 | 0;
        if (col >= wrap_col) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
          col = 0;
        }
        _tmp$39 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    if (col > 0) {
      _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
    }
    return out.val;
  } else {
    return `${encoded}\n`;
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands14base64__decode(input) {
  const cleaned = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < input.length) {
      $bound_check(input, i);
      const ch = input.charCodeAt(i);
      if (ch !== 10 && (ch !== 13 && (ch !== 32 && ch !== 9))) {
        _M0IPB13StringBuilderPB6Logger11write__char(cleaned, ch);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let result;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP27gmlewis6base6423std__decode2str_2einner(cleaned.val, false);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        result = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    return _M0FP410Haoxincode8moonbash3lib8commands14base64__decodeN5tupleS9208;
  }
  return { _0: result, _1: "" };
}
function _M0FP410Haoxincode8moonbash3lib8commands17cmd__substr__from(s, start) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = start;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      _M0IPB13StringBuilderPB6Logger11write__char(buf, s.charCodeAt(i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands11cmd__base64(ctx) {
  let decode = false;
  let wrap_col = 76;
  const files = [];
  let i = 0;
  while (true) {
    if (i < ctx.args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(ctx.args, i);
      if (arg === "-d" || arg === "--decode") {
        decode = true;
        i = i + 1 | 0;
      } else {
        if (arg === "-w") {
          if ((i + 1 | 0) < ctx.args.length) {
            wrap_col = Number(BigInt.asIntN(32, _M0FP410Haoxincode8moonbash3lib8commands15cmd__parse__int(_M0MPC15array5Array2atGUssEE(ctx.args, i + 1 | 0)))) | 0;
            i = i + 2 | 0;
          } else {
            return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("base64: option requires an argument -- 'w'\n");
          }
        } else {
          if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands11cmd__base64N7_2abindS4221, 0, _M0FP410Haoxincode8moonbash3lib8commands11cmd__base64N7_2abindS4221.length)) && arg.length > 2) {
            wrap_col = Number(BigInt.asIntN(32, _M0FP410Haoxincode8moonbash3lib8commands15cmd__parse__int(_M0FP410Haoxincode8moonbash3lib8commands17cmd__substr__from(arg, 2)))) | 0;
            i = i + 1 | 0;
          } else {
            _M0MPC15array5Array4pushGUssEE(files, arg);
            i = i + 1 | 0;
          }
        }
      }
      continue;
    } else {
      break;
    }
  }
  let input;
  if (files.length > 0) {
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands16cmd__read__input(ctx, _M0MPC15array5Array2atGUssEE(files, 0), "base64");
    const _content = _bind$4._0;
    const _err = _bind$4._1;
    if (_err.length > 0) {
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(_err);
    }
    input = _content;
  } else {
    input = ctx.stdin_content;
  }
  if (decode) {
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands14base64__decode(input);
    const _result = _bind$4._0;
    const _err = _bind$4._1;
    if (_err.length > 0) {
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(_err);
    }
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(_result);
  } else {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(_M0FP410Haoxincode8moonbash3lib8commands14base64__encode(input, wrap_col));
  }
}
function _M0MP410Haoxincode8moonbash3lib8commands10ExprParser3new(tokens) {
  return new _M0TP410Haoxincode8moonbash3lib8commands10ExprParser(tokens, 0, "");
}
function _M0MP410Haoxincode8moonbash3lib8commands10ExprParser4peek(self) {
  return self.pos < self.tokens.length ? _M0MPC15array5Array2atGUssEE(self.tokens, self.pos) : undefined;
}
function _M0MP410Haoxincode8moonbash3lib8commands10ExprParser7advance(self) {
  if (self.pos < self.tokens.length) {
    const tok = _M0MPC15array5Array2atGUssEE(self.tokens, self.pos);
    self.pos = self.pos + 1 | 0;
    return tok;
  } else {
    return undefined;
  }
}
function _M0MP410Haoxincode8moonbash3lib8commands10ExprParser10set__error(self, msg) {
  if (self.error.length === 0) {
    self.error = msg;
    return;
  } else {
    return;
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands14expr__try__int(s) {
  if (s.length === 0) {
    return undefined;
  }
  let start = 0;
  let neg = false;
  $bound_check(s, 0);
  const _p$4 = s.charCodeAt(0);
  const _p$5 = 45;
  if (_p$4 === _p$5) {
    neg = true;
    start = 1;
  } else {
    $bound_check(s, 0);
    const _p$6 = s.charCodeAt(0);
    const _p$7 = 43;
    if (_p$6 === _p$7) {
      start = 1;
    }
  }
  if (start >= s.length) {
    return undefined;
  }
  let result = 0n;
  let _tmp$38 = start;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      if (ch >= 48 && ch <= 57) {
        result = BigInt.asUintN(64, BigInt.asUintN(64, result * 10n) + BigInt.asUintN(64, BigInt(ch - 48 | 0)));
      } else {
        return undefined;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return neg ? BigInt.asUintN(64, -result) : result;
}
function _M0FP410Haoxincode8moonbash3lib8commands16expr__is__truthy(s) {
  if (s.length === 0) {
    return false;
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands14expr__try__int(s);
  if (_bind$4 === undefined) {
    return true;
  } else {
    const _Some = _bind$4;
    const _n = _Some;
    return BigInt.asUintN(64, _n) !== BigInt.asUintN(64, 0n);
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands18cmd__substr__slice(s, start, end_) {
  let start$2 = start;
  let end_$2 = end_;
  if (start$2 < 0) {
    start$2 = 0;
  }
  if (end_$2 > s.length) {
    end_$2 = s.length;
  }
  if (start$2 >= end_$2) {
    return "";
  }
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = start$2;
  while (true) {
    const i = _tmp$38;
    if (i < end_$2) {
      $bound_check(s, i);
      _M0IPB13StringBuilderPB6Logger11write__char(buf, s.charCodeAt(i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands15expr__parse__or(p) {
  let left = _M0FP410Haoxincode8moonbash3lib8commands16expr__parse__and(p);
  if (p.error.length > 0) {
    return left;
  }
  while (true) {
    if (_M0IPC16option6OptionPB2Eq5equalGsE(_M0MP410Haoxincode8moonbash3lib8commands10ExprParser4peek(p), _M0FP410Haoxincode8moonbash3lib8commands15expr__parse__orN6constrS9209)) {
      _M0MP410Haoxincode8moonbash3lib8commands10ExprParser7advance(p);
      const right = _M0FP410Haoxincode8moonbash3lib8commands16expr__parse__and(p);
      if (p.error.length > 0) {
        return left;
      }
      left = _M0FP410Haoxincode8moonbash3lib8commands16expr__is__truthy(left) ? left : right;
      continue;
    } else {
      break;
    }
  }
  return left;
}
function _M0FP410Haoxincode8moonbash3lib8commands16expr__parse__and(p) {
  let left = _M0FP410Haoxincode8moonbash3lib8commands23expr__parse__comparison(p);
  if (p.error.length > 0) {
    return left;
  }
  while (true) {
    if (_M0IPC16option6OptionPB2Eq5equalGsE(_M0MP410Haoxincode8moonbash3lib8commands10ExprParser4peek(p), _M0FP410Haoxincode8moonbash3lib8commands16expr__parse__andN6constrS9210)) {
      _M0MP410Haoxincode8moonbash3lib8commands10ExprParser7advance(p);
      const right = _M0FP410Haoxincode8moonbash3lib8commands23expr__parse__comparison(p);
      if (p.error.length > 0) {
        return left;
      }
      left = _M0FP410Haoxincode8moonbash3lib8commands16expr__is__truthy(left) && _M0FP410Haoxincode8moonbash3lib8commands16expr__is__truthy(right) ? left : "0";
      continue;
    } else {
      break;
    }
  }
  return left;
}
function _M0FP410Haoxincode8moonbash3lib8commands23expr__parse__comparison(p) {
  let left = _M0FP410Haoxincode8moonbash3lib8commands16expr__parse__add(p);
  if (p.error.length > 0) {
    return left;
  }
  while (true) {
    const _bind$4 = _M0MP410Haoxincode8moonbash3lib8commands10ExprParser4peek(p);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _op = _Some;
      if (_op === "=" || (_op === "!=" || (_op === "<" || (_op === "<=" || (_op === ">" || _op === ">="))))) {
        _M0MP410Haoxincode8moonbash3lib8commands10ExprParser7advance(p);
        const right = _M0FP410Haoxincode8moonbash3lib8commands16expr__parse__add(p);
        if (p.error.length > 0) {
          return left;
        }
        let result;
        _L: {
          _L$2: {
            const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands14expr__try__int(left);
            const _bind$6 = _M0FP410Haoxincode8moonbash3lib8commands14expr__try__int(right);
            if (_bind$5 === undefined) {
              break _L$2;
            } else {
              const _Some$2 = _bind$5;
              const _l = _Some$2;
              if (_bind$6 === undefined) {
                break _L$2;
              } else {
                const _Some$3 = _bind$6;
                const _r = _Some$3;
                result = _op === "=" ? BigInt.asUintN(64, _l) === BigInt.asUintN(64, _r) : _op === "!=" ? BigInt.asUintN(64, _l) !== BigInt.asUintN(64, _r) : _op === "<" ? BigInt.asIntN(64, _l) < BigInt.asIntN(64, _r) : _op === "<=" ? BigInt.asIntN(64, _l) <= BigInt.asIntN(64, _r) : _op === ">" ? BigInt.asIntN(64, _l) > BigInt.asIntN(64, _r) : BigInt.asIntN(64, _l) >= BigInt.asIntN(64, _r);
              }
            }
            break _L;
          }
          if (_op === "=") {
            result = left === right;
          } else {
            if (_op === "!=") {
              const _p$4 = left;
              result = !(_p$4 === right);
            } else {
              result = _op === "<" ? _M0FP410Haoxincode8moonbash3lib8commands25cmd__find__compare__ascii(left, right) < 0 : _op === "<=" ? _M0FP410Haoxincode8moonbash3lib8commands25cmd__find__compare__ascii(left, right) <= 0 : _op === ">" ? _M0FP410Haoxincode8moonbash3lib8commands25cmd__find__compare__ascii(left, right) > 0 : _M0FP410Haoxincode8moonbash3lib8commands25cmd__find__compare__ascii(left, right) >= 0;
            }
          }
        }
        left = result ? "1" : "0";
      } else {
        break;
      }
    }
    continue;
  }
  return left;
}
function _M0FP410Haoxincode8moonbash3lib8commands16expr__parse__add(p) {
  let left = _M0FP410Haoxincode8moonbash3lib8commands16expr__parse__mul(p);
  if (p.error.length > 0) {
    return left;
  }
  while (true) {
    const _bind$4 = _M0MP410Haoxincode8moonbash3lib8commands10ExprParser4peek(p);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _op = _Some;
      if (_op === "+" || _op === "-") {
        _M0MP410Haoxincode8moonbash3lib8commands10ExprParser7advance(p);
        const right = _M0FP410Haoxincode8moonbash3lib8commands16expr__parse__mul(p);
        if (p.error.length > 0) {
          return left;
        }
        const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands14expr__try__int(left);
        let l;
        if (_bind$5 === undefined) {
          _M0MP410Haoxincode8moonbash3lib8commands10ExprParser10set__error(p, "expr: non-integer argument\n");
          return "0";
        } else {
          const _Some$2 = _bind$5;
          l = _Some$2;
        }
        const _bind$6 = _M0FP410Haoxincode8moonbash3lib8commands14expr__try__int(right);
        let r;
        if (_bind$6 === undefined) {
          _M0MP410Haoxincode8moonbash3lib8commands10ExprParser10set__error(p, "expr: non-integer argument\n");
          return "0";
        } else {
          const _Some$2 = _bind$6;
          r = _Some$2;
        }
        left = _op === "+" ? _M0MPC15int645Int6418to__string_2einner(BigInt.asUintN(64, l + r), 10) : _M0MPC15int645Int6418to__string_2einner(BigInt.asUintN(64, l - r), 10);
      } else {
        break;
      }
    }
    continue;
  }
  return left;
}
function _M0FP410Haoxincode8moonbash3lib8commands16expr__parse__mul(p) {
  let left = _M0FP410Haoxincode8moonbash3lib8commands20expr__parse__primary(p);
  if (p.error.length > 0) {
    return left;
  }
  while (true) {
    const _bind$4 = _M0MP410Haoxincode8moonbash3lib8commands10ExprParser4peek(p);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _op = _Some;
      if (_op === "*" || (_op === "/" || _op === "%")) {
        _M0MP410Haoxincode8moonbash3lib8commands10ExprParser7advance(p);
        const right = _M0FP410Haoxincode8moonbash3lib8commands20expr__parse__primary(p);
        if (p.error.length > 0) {
          return left;
        }
        const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands14expr__try__int(left);
        let l;
        if (_bind$5 === undefined) {
          _M0MP410Haoxincode8moonbash3lib8commands10ExprParser10set__error(p, "expr: non-integer argument\n");
          return "0";
        } else {
          const _Some$2 = _bind$5;
          l = _Some$2;
        }
        const _bind$6 = _M0FP410Haoxincode8moonbash3lib8commands14expr__try__int(right);
        let r;
        if (_bind$6 === undefined) {
          _M0MP410Haoxincode8moonbash3lib8commands10ExprParser10set__error(p, "expr: non-integer argument\n");
          return "0";
        } else {
          const _Some$2 = _bind$6;
          r = _Some$2;
        }
        if (_op === "*") {
          left = _M0MPC15int645Int6418to__string_2einner(BigInt.asUintN(64, l * r), 10);
        } else {
          if (_op === "/") {
            if (BigInt.asUintN(64, r) === BigInt.asUintN(64, 0n)) {
              _M0MP410Haoxincode8moonbash3lib8commands10ExprParser10set__error(p, "expr: division by zero\n");
              return "0";
            }
            if (r === 0n) {
              $panic();
            }
            left = _M0MPC15int645Int6418to__string_2einner(BigInt.asUintN(64, BigInt.asIntN(64, l) / BigInt.asIntN(64, r)), 10);
          } else {
            if (BigInt.asUintN(64, r) === BigInt.asUintN(64, 0n)) {
              _M0MP410Haoxincode8moonbash3lib8commands10ExprParser10set__error(p, "expr: division by zero\n");
              return "0";
            }
            if (r === 0n) {
              $panic();
            }
            left = _M0MPC15int645Int6418to__string_2einner(BigInt.asUintN(64, BigInt.asIntN(64, l) % BigInt.asIntN(64, r)), 10);
          }
        }
      } else {
        break;
      }
    }
    continue;
  }
  return left;
}
function _M0FP410Haoxincode8moonbash3lib8commands20expr__parse__primary(p) {
  if (p.error.length > 0) {
    return "0";
  }
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib8commands10ExprParser4peek(p);
  if (_bind$4 === undefined) {
    _M0MP410Haoxincode8moonbash3lib8commands10ExprParser10set__error(p, "expr: syntax error\n");
    return "0";
  } else {
    const _Some = _bind$4;
    const _tok = _Some;
    if (_tok === "(") {
      _M0MP410Haoxincode8moonbash3lib8commands10ExprParser7advance(p);
      const result = _M0FP410Haoxincode8moonbash3lib8commands15expr__parse__or(p);
      if (p.error.length > 0) {
        return result;
      }
      _L: {
        const _bind$5 = _M0MP410Haoxincode8moonbash3lib8commands10ExprParser7advance(p);
        if (_bind$5 === undefined) {
          break _L;
        } else {
          const _Some$2 = _bind$5;
          const _x = _Some$2;
          if (_x === ")") {
            return result;
          } else {
            break _L;
          }
        }
      }
      _M0MP410Haoxincode8moonbash3lib8commands10ExprParser10set__error(p, "expr: syntax error\n");
      return result;
    } else {
      if (_tok === "length") {
        _M0MP410Haoxincode8moonbash3lib8commands10ExprParser7advance(p);
        const _bind$5 = _M0MP410Haoxincode8moonbash3lib8commands10ExprParser7advance(p);
        if (_bind$5 === undefined) {
          _M0MP410Haoxincode8moonbash3lib8commands10ExprParser10set__error(p, "expr: syntax error\n");
          return "0";
        } else {
          const _Some$2 = _bind$5;
          const _v = _Some$2;
          return _M0MPC13int3Int18to__string_2einner(_v.length, 10);
        }
      } else {
        if (_tok === "substr") {
          _M0MP410Haoxincode8moonbash3lib8commands10ExprParser7advance(p);
          const _bind$5 = _M0MP410Haoxincode8moonbash3lib8commands10ExprParser7advance(p);
          let s;
          if (_bind$5 === undefined) {
            _M0MP410Haoxincode8moonbash3lib8commands10ExprParser10set__error(p, "expr: syntax error\n");
            return "0";
          } else {
            const _Some$2 = _bind$5;
            s = _Some$2;
          }
          const _bind$6 = _M0MP410Haoxincode8moonbash3lib8commands10ExprParser7advance(p);
          let pos_s;
          if (_bind$6 === undefined) {
            _M0MP410Haoxincode8moonbash3lib8commands10ExprParser10set__error(p, "expr: syntax error\n");
            return "0";
          } else {
            const _Some$2 = _bind$6;
            pos_s = _Some$2;
          }
          const _bind$7 = _M0MP410Haoxincode8moonbash3lib8commands10ExprParser7advance(p);
          let len_s;
          if (_bind$7 === undefined) {
            _M0MP410Haoxincode8moonbash3lib8commands10ExprParser10set__error(p, "expr: syntax error\n");
            return "0";
          } else {
            const _Some$2 = _bind$7;
            len_s = _Some$2;
          }
          const _bind$8 = _M0FP410Haoxincode8moonbash3lib8commands14expr__try__int(pos_s);
          let pos;
          if (_bind$8 === undefined) {
            _M0MP410Haoxincode8moonbash3lib8commands10ExprParser10set__error(p, "expr: non-integer argument\n");
            return "0";
          } else {
            const _Some$2 = _bind$8;
            pos = _Some$2;
          }
          const _bind$9 = _M0FP410Haoxincode8moonbash3lib8commands14expr__try__int(len_s);
          let len;
          if (_bind$9 === undefined) {
            _M0MP410Haoxincode8moonbash3lib8commands10ExprParser10set__error(p, "expr: non-integer argument\n");
            return "0";
          } else {
            const _Some$2 = _bind$9;
            len = _Some$2;
          }
          const start = BigInt.asIntN(64, pos) < BigInt.asIntN(64, 1n) ? 0n : BigInt.asUintN(64, pos - 1n);
          const end_ = BigInt.asUintN(64, start + len);
          return _M0FP410Haoxincode8moonbash3lib8commands18cmd__substr__slice(s, Number(BigInt.asIntN(32, start)) | 0, Number(BigInt.asIntN(32, end_)) | 0);
        } else {
          if (_tok === "match") {
            _M0MP410Haoxincode8moonbash3lib8commands10ExprParser7advance(p);
            const _bind$5 = _M0MP410Haoxincode8moonbash3lib8commands10ExprParser7advance(p);
            let _s;
            if (_bind$5 === undefined) {
              _M0MP410Haoxincode8moonbash3lib8commands10ExprParser10set__error(p, "expr: syntax error\n");
              return "0";
            } else {
              const _Some$2 = _bind$5;
              _s = _Some$2;
            }
            const _bind$6 = _M0MP410Haoxincode8moonbash3lib8commands10ExprParser7advance(p);
            let _pat;
            if (_bind$6 === undefined) {
              _M0MP410Haoxincode8moonbash3lib8commands10ExprParser10set__error(p, "expr: syntax error\n");
              return "0";
            } else {
              const _Some$2 = _bind$6;
              _pat = _Some$2;
            }
            return "0";
          } else {
            _M0MP410Haoxincode8moonbash3lib8commands10ExprParser7advance(p);
            _L: {
              const _bind$5 = _M0MP410Haoxincode8moonbash3lib8commands10ExprParser4peek(p);
              if (_bind$5 === undefined) {
                break _L;
              } else {
                const _Some$2 = _bind$5;
                const _x = _Some$2;
                if (_x === ":") {
                  _M0MP410Haoxincode8moonbash3lib8commands10ExprParser7advance(p);
                  const _bind$6 = _M0MP410Haoxincode8moonbash3lib8commands10ExprParser7advance(p);
                  let _pat;
                  if (_bind$6 === undefined) {
                    _M0MP410Haoxincode8moonbash3lib8commands10ExprParser10set__error(p, "expr: syntax error\n");
                    return "0";
                  } else {
                    const _Some$3 = _bind$6;
                    _pat = _Some$3;
                  }
                  return "0";
                } else {
                  break _L;
                }
              }
            }
            return _tok;
          }
        }
      }
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands9cmd__expr(ctx) {
  if (ctx.args.length === 0) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", "expr: missing operand\n", 2);
  }
  const parser = _M0MP410Haoxincode8moonbash3lib8commands10ExprParser3new(ctx.args);
  const result = _M0FP410Haoxincode8moonbash3lib8commands15expr__parse__or(parser);
  if (parser.error.length > 0) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", parser.error, 2);
  }
  if (parser.pos < parser.tokens.length) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", "expr: syntax error\n", 2);
  }
  const exit_code = _M0FP410Haoxincode8moonbash3lib8commands16expr__is__truthy(result) ? 0 : 1;
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(`${result}\n`, "", exit_code);
}
function _M0FP410Haoxincode8moonbash3lib8commands9cmd__head(ctx) {
  let num_lines = 10;
  let num_bytes = undefined;
  const input_files = [];
  let i = 0;
  while (true) {
    if (i < ctx.args.length) {
      if (_M0MPC15array5Array2atGUssEE(ctx.args, i) === "-n" && (i + 1 | 0) < ctx.args.length) {
        num_lines = Number(BigInt.asIntN(32, _M0FP410Haoxincode8moonbash3lib8commands15cmd__parse__int(_M0MPC15array5Array2atGUssEE(ctx.args, i + 1 | 0)))) | 0;
        i = i + 2 | 0;
      } else {
        if (_M0MPC16string6String11has__prefix(_M0MPC15array5Array2atGUssEE(ctx.args, i), new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands9cmd__headN7_2abindS4351, 0, _M0FP410Haoxincode8moonbash3lib8commands9cmd__headN7_2abindS4351.length)) && _M0MPC15array5Array2atGUssEE(ctx.args, i).length > 2) {
          num_lines = Number(BigInt.asIntN(32, _M0FP410Haoxincode8moonbash3lib8commands15cmd__parse__int(_M0FP410Haoxincode8moonbash3lib8commands17cmd__substr__from(_M0MPC15array5Array2atGUssEE(ctx.args, i), 2)))) | 0;
          i = i + 1 | 0;
        } else {
          if (_M0MPC15array5Array2atGUssEE(ctx.args, i) === "-c" && (i + 1 | 0) < ctx.args.length) {
            num_bytes = Number(BigInt.asIntN(32, _M0FP410Haoxincode8moonbash3lib8commands15cmd__parse__int(_M0MPC15array5Array2atGUssEE(ctx.args, i + 1 | 0)))) | 0;
            i = i + 2 | 0;
          } else {
            if (_M0MPC16string6String11has__prefix(_M0MPC15array5Array2atGUssEE(ctx.args, i), new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands9cmd__headN7_2abindS4352, 0, _M0FP410Haoxincode8moonbash3lib8commands9cmd__headN7_2abindS4352.length)) && _M0MPC15array5Array2atGUssEE(ctx.args, i).length > 2) {
              num_bytes = Number(BigInt.asIntN(32, _M0FP410Haoxincode8moonbash3lib8commands15cmd__parse__int(_M0FP410Haoxincode8moonbash3lib8commands17cmd__substr__from(_M0MPC15array5Array2atGUssEE(ctx.args, i), 2)))) | 0;
              i = i + 1 | 0;
            } else {
              if (_M0MPC16string6String11has__prefix(_M0MPC15array5Array2atGUssEE(ctx.args, i), new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands9cmd__headN7_2abindS4353, 0, _M0FP410Haoxincode8moonbash3lib8commands9cmd__headN7_2abindS4353.length)) && _M0MPC15array5Array2atGUssEE(ctx.args, i).length > 1) {
                num_lines = Number(BigInt.asIntN(32, _M0FP410Haoxincode8moonbash3lib8commands15cmd__parse__int(_M0FP410Haoxincode8moonbash3lib8commands17cmd__substr__from(_M0MPC15array5Array2atGUssEE(ctx.args, i), 1)))) | 0;
                i = i + 1 | 0;
              } else {
                _M0MPC15array5Array4pushGUssEE(input_files, _M0MPC15array5Array2atGUssEE(ctx.args, i));
                i = i + 1 | 0;
              }
            }
          }
        }
      }
      continue;
    } else {
      break;
    }
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  if (input_files.length === 0) {
    const _bind$4 = num_bytes;
    if (_bind$4 === undefined) {
      const lines = _M0FP410Haoxincode8moonbash3lib8commands17cmd__split__lines(ctx.stdin_content);
      const count = num_lines < lines.length ? num_lines : lines.length;
      let _tmp$38 = 0;
      while (true) {
        const j = _tmp$38;
        if (j < count) {
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(lines, j));
          _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
          _tmp$38 = j + 1 | 0;
          continue;
        } else {
          break;
        }
      }
    } else {
      const _Some = _bind$4;
      const _byte_count = _Some;
      const count = _byte_count < 0 ? 0 : _byte_count;
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands18cmd__substr__slice(ctx.stdin_content, 0, count));
    }
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(out.val);
  }
  let _tmp$38 = 0;
  while (true) {
    const file_idx = _tmp$38;
    if (file_idx < input_files.length) {
      const path = _M0MPC15array5Array2atGUssEE(input_files, file_idx);
      let resolved;
      let _try_err;
      _L: {
        _L$2: {
          const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, path);
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            resolved = _ok._0;
          } else {
            const _err = _bind$4;
            _try_err = _err._0;
            break _L$2;
          }
          break _L;
        }
        const _FsError = _try_err;
        const _msg = _FsError._0;
        return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`head: ${_msg}\n`);
      }
      let input;
      let _try_err$2;
      _L$2: {
        _L$3: {
          const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, resolved);
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            input = _ok._0;
          } else {
            const _err = _bind$4;
            _try_err$2 = _err._0;
            break _L$3;
          }
          break _L$2;
        }
        const _FsError = _try_err$2;
        const _msg = _FsError._0;
        return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`head: ${_msg}\n`);
      }
      if (input_files.length > 1) {
        if (file_idx > 0) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
        }
        _M0IPB13StringBuilderPB6Logger13write__string(out, `==> ${path} <==\n`);
      }
      const _bind$4 = num_bytes;
      if (_bind$4 === undefined) {
        const lines = _M0FP410Haoxincode8moonbash3lib8commands17cmd__split__lines(input);
        const count = num_lines < lines.length ? num_lines : lines.length;
        let _tmp$39 = 0;
        while (true) {
          const j = _tmp$39;
          if (j < count) {
            _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(lines, j));
            _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
            _tmp$39 = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
      } else {
        const _Some = _bind$4;
        const _byte_count = _Some;
        const count = _byte_count < 0 ? 0 : _byte_count;
        _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands18cmd__substr__slice(input, 0, count));
      }
      _tmp$38 = file_idx + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(out.val);
}
function _M0FP410Haoxincode8moonbash3lib8commands9cmd__tail(ctx) {
  let num_lines = 10;
  let num_bytes = undefined;
  const input_files = [];
  let i = 0;
  while (true) {
    if (i < ctx.args.length) {
      if (_M0MPC15array5Array2atGUssEE(ctx.args, i) === "-n" && (i + 1 | 0) < ctx.args.length) {
        const arg = _M0MPC15array5Array2atGUssEE(ctx.args, i + 1 | 0);
        if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands9cmd__tailN7_2abindS4381, 0, _M0FP410Haoxincode8moonbash3lib8commands9cmd__tailN7_2abindS4381.length))) {
          num_lines = -(Number(BigInt.asIntN(32, _M0FP410Haoxincode8moonbash3lib8commands15cmd__parse__int(_M0FP410Haoxincode8moonbash3lib8commands17cmd__substr__from(arg, 1)))) | 0) | 0;
        } else {
          num_lines = Number(BigInt.asIntN(32, _M0FP410Haoxincode8moonbash3lib8commands15cmd__parse__int(arg))) | 0;
        }
        i = i + 2 | 0;
      } else {
        if (_M0MPC16string6String11has__prefix(_M0MPC15array5Array2atGUssEE(ctx.args, i), new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands9cmd__tailN7_2abindS4382, 0, _M0FP410Haoxincode8moonbash3lib8commands9cmd__tailN7_2abindS4382.length)) && _M0MPC15array5Array2atGUssEE(ctx.args, i).length > 2) {
          const arg = _M0FP410Haoxincode8moonbash3lib8commands17cmd__substr__from(_M0MPC15array5Array2atGUssEE(ctx.args, i), 2);
          if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands9cmd__tailN7_2abindS4383, 0, _M0FP410Haoxincode8moonbash3lib8commands9cmd__tailN7_2abindS4383.length))) {
            num_lines = -(Number(BigInt.asIntN(32, _M0FP410Haoxincode8moonbash3lib8commands15cmd__parse__int(_M0FP410Haoxincode8moonbash3lib8commands17cmd__substr__from(arg, 1)))) | 0) | 0;
          } else {
            num_lines = Number(BigInt.asIntN(32, _M0FP410Haoxincode8moonbash3lib8commands15cmd__parse__int(arg))) | 0;
          }
          i = i + 1 | 0;
        } else {
          if (_M0MPC15array5Array2atGUssEE(ctx.args, i) === "-c" && (i + 1 | 0) < ctx.args.length) {
            num_bytes = Number(BigInt.asIntN(32, _M0FP410Haoxincode8moonbash3lib8commands15cmd__parse__int(_M0MPC15array5Array2atGUssEE(ctx.args, i + 1 | 0)))) | 0;
            i = i + 2 | 0;
          } else {
            if (_M0MPC16string6String11has__prefix(_M0MPC15array5Array2atGUssEE(ctx.args, i), new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands9cmd__tailN7_2abindS4384, 0, _M0FP410Haoxincode8moonbash3lib8commands9cmd__tailN7_2abindS4384.length)) && _M0MPC15array5Array2atGUssEE(ctx.args, i).length > 2) {
              num_bytes = Number(BigInt.asIntN(32, _M0FP410Haoxincode8moonbash3lib8commands15cmd__parse__int(_M0FP410Haoxincode8moonbash3lib8commands17cmd__substr__from(_M0MPC15array5Array2atGUssEE(ctx.args, i), 2)))) | 0;
              i = i + 1 | 0;
            } else {
              if (_M0MPC16string6String11has__prefix(_M0MPC15array5Array2atGUssEE(ctx.args, i), new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands9cmd__tailN7_2abindS4385, 0, _M0FP410Haoxincode8moonbash3lib8commands9cmd__tailN7_2abindS4385.length)) && _M0MPC15array5Array2atGUssEE(ctx.args, i).length > 1) {
                num_lines = Number(BigInt.asIntN(32, _M0FP410Haoxincode8moonbash3lib8commands15cmd__parse__int(_M0FP410Haoxincode8moonbash3lib8commands17cmd__substr__from(_M0MPC15array5Array2atGUssEE(ctx.args, i), 1)))) | 0;
                i = i + 1 | 0;
              } else {
                _M0MPC15array5Array4pushGUssEE(input_files, _M0MPC15array5Array2atGUssEE(ctx.args, i));
                i = i + 1 | 0;
              }
            }
          }
        }
      }
      continue;
    } else {
      break;
    }
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  if (input_files.length === 0) {
    const _bind$4 = num_bytes;
    if (_bind$4 === undefined) {
      const lines = _M0FP410Haoxincode8moonbash3lib8commands17cmd__split__lines(ctx.stdin_content);
      if (num_lines < 0) {
        const start = (-num_lines | 0) - 1 | 0;
        let _tmp$38 = start;
        while (true) {
          const j = _tmp$38;
          if (j < lines.length) {
            _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(lines, j));
            _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
            _tmp$38 = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
      } else {
        const start = num_lines >= lines.length ? 0 : lines.length - num_lines | 0;
        let _tmp$38 = start;
        while (true) {
          const j = _tmp$38;
          if (j < lines.length) {
            _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(lines, j));
            _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
            _tmp$38 = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
      }
    } else {
      const _Some = _bind$4;
      const _byte_count = _Some;
      const count = _byte_count < 0 ? 0 : _byte_count;
      const start = count >= ctx.stdin_content.length ? 0 : ctx.stdin_content.length - count | 0;
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands18cmd__substr__slice(ctx.stdin_content, start, ctx.stdin_content.length));
    }
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(out.val);
  }
  let _tmp$38 = 0;
  while (true) {
    const file_idx = _tmp$38;
    if (file_idx < input_files.length) {
      const path = _M0MPC15array5Array2atGUssEE(input_files, file_idx);
      let resolved;
      let _try_err;
      _L: {
        _L$2: {
          const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, path);
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            resolved = _ok._0;
          } else {
            const _err = _bind$4;
            _try_err = _err._0;
            break _L$2;
          }
          break _L;
        }
        const _FsError = _try_err;
        const _msg = _FsError._0;
        return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`tail: ${_msg}\n`);
      }
      let input;
      let _try_err$2;
      _L$2: {
        _L$3: {
          const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, resolved);
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            input = _ok._0;
          } else {
            const _err = _bind$4;
            _try_err$2 = _err._0;
            break _L$3;
          }
          break _L$2;
        }
        const _FsError = _try_err$2;
        const _msg = _FsError._0;
        return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`tail: ${_msg}\n`);
      }
      if (input_files.length > 1) {
        if (file_idx > 0) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
        }
        _M0IPB13StringBuilderPB6Logger13write__string(out, `==> ${path} <==\n`);
      }
      const _bind$4 = num_bytes;
      if (_bind$4 === undefined) {
        const lines = _M0FP410Haoxincode8moonbash3lib8commands17cmd__split__lines(input);
        if (num_lines < 0) {
          const start = (-num_lines | 0) - 1 | 0;
          let _tmp$39 = start;
          while (true) {
            const j = _tmp$39;
            if (j < lines.length) {
              _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(lines, j));
              _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
              _tmp$39 = j + 1 | 0;
              continue;
            } else {
              break;
            }
          }
        } else {
          const start = num_lines >= lines.length ? 0 : lines.length - num_lines | 0;
          let _tmp$39 = start;
          while (true) {
            const j = _tmp$39;
            if (j < lines.length) {
              _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(lines, j));
              _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
              _tmp$39 = j + 1 | 0;
              continue;
            } else {
              break;
            }
          }
        }
      } else {
        const _Some = _bind$4;
        const _byte_count = _Some;
        const count = _byte_count < 0 ? 0 : _byte_count;
        const start = count >= input.length ? 0 : input.length - count | 0;
        _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands18cmd__substr__slice(input, start, input.length));
      }
      _tmp$38 = file_idx + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(out.val);
}
function _M0FP410Haoxincode8moonbash3lib8commands14cmd__wc__count(input) {
  let line_count = 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < input.length) {
      $bound_check(input, i);
      const _p$4 = input.charCodeAt(i);
      const _p$5 = 10;
      if (_p$4 === _p$5) {
        line_count = line_count + 1 | 0;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let word_count = 0;
  let in_word = false;
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < input.length) {
      $bound_check(input, i);
      const ch = input.charCodeAt(i);
      if (ch === 32 || (ch === 9 || (ch === 10 || ch === 13))) {
        in_word = false;
      } else {
        if (!in_word) {
          word_count = word_count + 1 | 0;
          in_word = true;
        }
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const char_count = input.length;
  return { _0: line_count, _1: word_count, _2: char_count };
}
function _M0FP410Haoxincode8moonbash3lib8commands19cmd__wc__write__rowN10write__colS3380(_env, value, width) {
  const first = _env._1;
  const out = _env._0;
  if (!first.val) {
    _M0IPB13StringBuilderPB6Logger11write__char(out, 32);
  }
  const text = _M0MPC13int3Int18to__string_2einner(value, 10);
  let pad = width - text.length | 0;
  if (pad < 0) {
    pad = 0;
  }
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < pad) {
      _M0IPB13StringBuilderPB6Logger11write__char(out, 32);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger13write__string(out, text);
  first.val = false;
}
function _M0FP410Haoxincode8moonbash3lib8commands19cmd__wc__write__row(out, line_count, word_count, char_count, show_lines, show_words, show_chars, line_width, word_width, char_width, label) {
  const first = new _M0TPB8MutLocalGbE(true);
  const _env = { _0: out, _1: first };
  if (show_lines) {
    _M0FP410Haoxincode8moonbash3lib8commands19cmd__wc__write__rowN10write__colS3380(_env, line_count, line_width);
  }
  if (show_words) {
    _M0FP410Haoxincode8moonbash3lib8commands19cmd__wc__write__rowN10write__colS3380(_env, word_count, word_width);
  }
  if (show_chars) {
    _M0FP410Haoxincode8moonbash3lib8commands19cmd__wc__write__rowN10write__colS3380(_env, char_count, char_width);
  }
  if (label === undefined) {
  } else {
    const _Some = label;
    const _name = _Some;
    _M0IPB13StringBuilderPB6Logger13write__string(out, ` ${_name}`);
  }
  _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
}
function _M0FP410Haoxincode8moonbash3lib8commands7cmd__wc(ctx) {
  let flag_lines = false;
  let flag_words = false;
  let flag_chars = false;
  const input_files = [];
  const _bind$4 = ctx.args;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const arg = _bind$4[_];
      _L: {
        _L$2: {
          _L$3: {
            _L$4: {
              _L$5: {
                _L$6: {
                  _L$7: {
                    _L$8: {
                      _L$9: {
                        _L$10: {
                          switch (arg) {
                            case "-l": {
                              flag_lines = true;
                              break;
                            }
                            case "-w": {
                              flag_words = true;
                              break;
                            }
                            case "-c": {
                              break _L$10;
                            }
                            case "-m": {
                              break _L$10;
                            }
                            case "-lw": {
                              break _L$8;
                            }
                            case "-wl": {
                              break _L$8;
                            }
                            case "-lc": {
                              break _L$6;
                            }
                            case "-cl": {
                              break _L$6;
                            }
                            case "-wc": {
                              break _L$4;
                            }
                            case "-cw": {
                              break _L$4;
                            }
                            case "-lwc": {
                              break _L$2;
                            }
                            case "-lcw": {
                              break _L$2;
                            }
                            case "-wlc": {
                              break _L$2;
                            }
                            case "-wcl": {
                              break _L$2;
                            }
                            case "-clw": {
                              break _L$2;
                            }
                            case "-cwl": {
                              break _L$2;
                            }
                            default: {
                              _M0MPC15array5Array4pushGUssEE(input_files, arg);
                            }
                          }
                          break _L$9;
                        }
                        flag_chars = true;
                      }
                      break _L$7;
                    }
                    flag_lines = true;
                    flag_words = true;
                  }
                  break _L$5;
                }
                flag_lines = true;
                flag_chars = true;
              }
              break _L$3;
            }
            flag_words = true;
            flag_chars = true;
          }
          break _L;
        }
        flag_lines = true;
        flag_words = true;
        flag_chars = true;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (!flag_lines && (!flag_words && !flag_chars)) {
    flag_lines = true;
    flag_words = true;
    flag_chars = true;
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  if (input_files.length === 0) {
    const _bind$6 = _M0FP410Haoxincode8moonbash3lib8commands14cmd__wc__count(ctx.stdin_content);
    const _line_count = _bind$6._0;
    const _word_count = _bind$6._1;
    const _char_count = _bind$6._2;
    _M0FP410Haoxincode8moonbash3lib8commands19cmd__wc__write__row(out, _line_count, _word_count, _char_count, flag_lines, flag_words, flag_chars, 0, 0, 0, undefined);
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(out.val);
  }
  let total_lines = 0;
  let total_words = 0;
  let total_chars = 0;
  const rows = [];
  const _bind$6 = input_files.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$6) {
      const path = input_files[_];
      let resolved;
      let _try_err;
      _L: {
        _L$2: {
          const _bind$7 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, path);
          if (_bind$7.$tag === 1) {
            const _ok = _bind$7;
            resolved = _ok._0;
          } else {
            const _err = _bind$7;
            _try_err = _err._0;
            break _L$2;
          }
          break _L;
        }
        const _FsError = _try_err;
        const _msg = _FsError._0;
        return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`wc: ${_msg}\n`);
      }
      let input;
      let _try_err$2;
      _L$2: {
        _L$3: {
          const _bind$7 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, resolved);
          if (_bind$7.$tag === 1) {
            const _ok = _bind$7;
            input = _ok._0;
          } else {
            const _err = _bind$7;
            _try_err$2 = _err._0;
            break _L$3;
          }
          break _L$2;
        }
        const _FsError = _try_err$2;
        const _msg = _FsError._0;
        return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`wc: ${_msg}\n`);
      }
      const _bind$7 = _M0FP410Haoxincode8moonbash3lib8commands14cmd__wc__count(input);
      const _line_count = _bind$7._0;
      const _word_count = _bind$7._1;
      const _char_count = _bind$7._2;
      total_lines = total_lines + _line_count | 0;
      total_words = total_words + _word_count | 0;
      total_chars = total_chars + _char_count | 0;
      _M0MPC15array5Array4pushGUssEE(rows, { _0: _line_count, _1: _word_count, _2: _char_count, _3: path });
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let line_width = 0;
  let word_width = 0;
  let char_width = 0;
  if (rows.length > 1) {
    const _bind$7 = rows.length;
    let _tmp$40 = 0;
    while (true) {
      const _ = _tmp$40;
      if (_ < _bind$7) {
        const row = rows[_];
        if (flag_lines) {
          const width = _M0MPC13int3Int18to__string_2einner(row._0, 10).length;
          if (width > line_width) {
            line_width = width;
          }
        }
        if (flag_words) {
          const width = _M0MPC13int3Int18to__string_2einner(row._1, 10).length;
          if (width > word_width) {
            word_width = width;
          }
        }
        if (flag_chars) {
          const width = _M0MPC13int3Int18to__string_2einner(row._2, 10).length;
          if (width > char_width) {
            char_width = width;
          }
        }
        _tmp$40 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    if (flag_lines) {
      const width = _M0MPC13int3Int18to__string_2einner(total_lines, 10).length;
      if (width > line_width) {
        line_width = width;
      }
    }
    if (flag_words) {
      const width = _M0MPC13int3Int18to__string_2einner(total_words, 10).length;
      if (width > word_width) {
        word_width = width;
      }
    }
    if (flag_chars) {
      const width = _M0MPC13int3Int18to__string_2einner(total_chars, 10).length;
      if (width > char_width) {
        char_width = width;
      }
    }
  }
  const _bind$7 = rows.length;
  let _tmp$40 = 0;
  while (true) {
    const _ = _tmp$40;
    if (_ < _bind$7) {
      const row = rows[_];
      _M0FP410Haoxincode8moonbash3lib8commands19cmd__wc__write__row(out, row._0, row._1, row._2, flag_lines, flag_words, flag_chars, line_width, word_width, char_width, row._3);
      _tmp$40 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (input_files.length > 1) {
    _M0FP410Haoxincode8moonbash3lib8commands19cmd__wc__write__row(out, total_lines, total_words, total_chars, flag_lines, flag_words, flag_chars, line_width, word_width, char_width, _M0FP410Haoxincode8moonbash3lib8commands7cmd__wcN6constrS9211);
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(out.val);
}
function _M0FP410Haoxincode8moonbash3lib8commands15cst__parse__int(s) {
  let result = 0;
  let neg = false;
  let start = 0;
  let _tmp$38;
  if (s.length > 0) {
    $bound_check(s, 0);
    const _p$4 = s.charCodeAt(0);
    const _p$5 = 45;
    _tmp$38 = _p$4 === _p$5;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    neg = true;
    start = 1;
  } else {
    let _tmp$39;
    if (s.length > 0) {
      $bound_check(s, 0);
      const _p$4 = s.charCodeAt(0);
      const _p$5 = 43;
      _tmp$39 = _p$4 === _p$5;
    } else {
      _tmp$39 = false;
    }
    if (_tmp$39) {
      start = 1;
    }
  }
  let _tmp$39 = start;
  while (true) {
    const i = _tmp$39;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      if (ch >= 48 && ch <= 57) {
        result = (Math.imul(result, 10) | 0) + (ch - 48 | 0) | 0;
      } else {
        break;
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return neg ? -result | 0 : result;
}
function _M0FP410Haoxincode8moonbash3lib8commands11cst__substr(s, start, end_) {
  let start$2 = start;
  let end_$2 = end_;
  if (start$2 < 0) {
    start$2 = 0;
  }
  if (end_$2 > s.length) {
    end_$2 = s.length;
  }
  if (start$2 >= end_$2) {
    return "";
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = start$2;
  while (true) {
    const i = _tmp$38;
    if (i < end_$2) {
      $bound_check(s, i);
      _M0IPB13StringBuilderPB6Logger11write__char(out, s.charCodeAt(i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands16cst__split__path(path) {
  const parts = [];
  let start = 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i <= path.length) {
      let _tmp$39;
      if (i === path.length) {
        _tmp$39 = true;
      } else {
        $bound_check(path, i);
        const _p$4 = path.charCodeAt(i);
        const _p$5 = 47;
        _tmp$39 = _p$4 === _p$5;
      }
      if (_tmp$39) {
        if (i > start) {
          _M0MPC15array5Array4pushGUssEE(parts, _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(path, start, i)));
        }
        start = i + 1 | 0;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return parts;
}
function _M0FP410Haoxincode8moonbash3lib8commands15cst__join__path(parts, start_idx) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = start_idx;
  while (true) {
    const i = _tmp$38;
    if (i < parts.length) {
      if (i > start_idx) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 47);
      }
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(parts, i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands18cst__sort__strings(values) {
  _M0MPC15array5Array8sort__byGUssEE(values, (a, b) => _M0IP016_24default__implPB7Compare6op__ltGsE(a, b) ? -1 : _M0IP016_24default__implPB7Compare6op__gtGsE(a, b) ? 1 : 0);
}
function _M0FP410Haoxincode8moonbash3lib8commands17cst__starts__with(s, prefix) {
  if (prefix.length > s.length) {
    return false;
  }
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < prefix.length) {
      $bound_check(s, i);
      const _p$4 = s.charCodeAt(i);
      $bound_check(prefix, i);
      const _p$5 = prefix.charCodeAt(i);
      if (_p$4 !== _p$5) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0FP410Haoxincode8moonbash3lib8commands16cst__read__input(ctx, input_file) {
  if (input_file === undefined) {
    return new _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(ctx.stdin_content);
  } else {
    const _Some = input_file;
    const _path = _Some;
    if (_path === "-") {
      return new _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib2fs7FsErrorE2Ok(ctx.stdin_content);
    }
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, _path);
    let resolved;
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      resolved = _ok._0;
    } else {
      return _bind$4;
    }
    return _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, resolved);
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands10hex__value(ch) {
  return ch >= 48 && ch <= 57 ? ch - 48 | 0 : ch >= 97 && ch <= 102 ? (10 + ch | 0) - 97 | 0 : ch >= 65 && ch <= 70 ? (10 + ch | 0) - 65 | 0 : 0;
}
function _M0FP410Haoxincode8moonbash3lib8commands13is__hex__char(ch) {
  return ch >= 48 && ch <= 57 || (ch >= 97 && ch <= 102 || ch >= 65 && ch <= 70);
}
function _M0FP410Haoxincode8moonbash3lib8commands24decode__strings__escapes(s) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  while (true) {
    if (i < s.length) {
      const _tmp$38 = i;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch === 92 && (i + 1 | 0) < s.length) {
        const _tmp$39 = i + 1 | 0;
        $bound_check(s, _tmp$39);
        const next = s.charCodeAt(_tmp$39);
        let _tmp$40;
        if (next === 120) {
          let _tmp$41;
          if ((i + 3 | 0) < s.length) {
            let _tmp$42;
            const _tmp$43 = i + 2 | 0;
            $bound_check(s, _tmp$43);
            if (_M0FP410Haoxincode8moonbash3lib8commands13is__hex__char(s.charCodeAt(_tmp$43))) {
              const _tmp$44 = i + 3 | 0;
              $bound_check(s, _tmp$44);
              _tmp$42 = _M0FP410Haoxincode8moonbash3lib8commands13is__hex__char(s.charCodeAt(_tmp$44));
            } else {
              _tmp$42 = false;
            }
            _tmp$41 = _tmp$42;
          } else {
            _tmp$41 = false;
          }
          _tmp$40 = _tmp$41;
        } else {
          _tmp$40 = false;
        }
        if (_tmp$40) {
          const _tmp$41 = i + 2 | 0;
          $bound_check(s, _tmp$41);
          const _tmp$42 = Math.imul(_M0FP410Haoxincode8moonbash3lib8commands10hex__value(s.charCodeAt(_tmp$41)), 16) | 0;
          const _tmp$43 = i + 3 | 0;
          $bound_check(s, _tmp$43);
          const code = _tmp$42 + _M0FP410Haoxincode8moonbash3lib8commands10hex__value(s.charCodeAt(_tmp$43)) | 0;
          _M0IPB13StringBuilderPB6Logger11write__char(out, code);
          i = i + 4 | 0;
          continue;
        }
        if (next === 117 && (i + 5 | 0) < s.length) {
          let ok = true;
          let value = 0;
          let _tmp$41 = i + 2 | 0;
          while (true) {
            const j = _tmp$41;
            if (j <= (i + 5 | 0)) {
              $bound_check(s, j);
              const hc = s.charCodeAt(j);
              if (!_M0FP410Haoxincode8moonbash3lib8commands13is__hex__char(hc)) {
                ok = false;
                break;
              }
              value = (Math.imul(value, 16) | 0) + _M0FP410Haoxincode8moonbash3lib8commands10hex__value(hc) | 0;
              _tmp$41 = j + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          if (ok) {
            _M0IPB13StringBuilderPB6Logger11write__char(out, value);
            i = i + 6 | 0;
            continue;
          }
        }
        if (next === 48) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 0);
          i = i + 2 | 0;
          continue;
        }
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands21cmd__strings__collectN5flushS3296(_env) {
  const out = _env._2;
  const min_len = _env._1;
  const buf = _env._0;
  const s = buf.val;
  if (s.length >= min_len) {
    _M0IPB13StringBuilderPB6Logger13write__string(out, s);
    _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
  }
  _M0MPB13StringBuilder5reset(buf);
}
function _M0FP410Haoxincode8moonbash3lib8commands21cmd__strings__collect(content, min_len, out) {
  const normalized = _M0FP410Haoxincode8moonbash3lib8commands24decode__strings__escapes(content);
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _env = { _0: buf, _1: min_len, _2: out };
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < normalized.length) {
      $bound_check(normalized, i);
      const ch = normalized.charCodeAt(i);
      if (ch >= 32 && ch <= 126) {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      } else {
        _M0FP410Haoxincode8moonbash3lib8commands21cmd__strings__collectN5flushS3296(_env);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0FP410Haoxincode8moonbash3lib8commands21cmd__strings__collectN5flushS3296(_env);
}
function _M0FP410Haoxincode8moonbash3lib8commands12cmd__strings(ctx) {
  let min_len = 4;
  const files = [];
  let i = 0;
  while (true) {
    if (i < ctx.args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(ctx.args, i);
      if (arg === "-n" && (i + 1 | 0) < ctx.args.length) {
        min_len = _M0FP410Haoxincode8moonbash3lib8commands15cst__parse__int(_M0MPC15array5Array2atGUssEE(ctx.args, i + 1 | 0));
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands12cmd__stringsN7_2abindS4493, 0, _M0FP410Haoxincode8moonbash3lib8commands12cmd__stringsN7_2abindS4493.length)) && arg.length > 2) {
        min_len = _M0FP410Haoxincode8moonbash3lib8commands15cst__parse__int(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined)));
        i = i + 1 | 0;
        continue;
      }
      _M0MPC15array5Array4pushGUssEE(files, arg);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (min_len < 1) {
    min_len = 1;
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  if (files.length === 0) {
    _M0FP410Haoxincode8moonbash3lib8commands21cmd__strings__collect(ctx.stdin_content, min_len, out);
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(out.val);
  }
  const _bind$4 = files.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const file = files[_];
      let content;
      let _try_err;
      _L: {
        _L$2: {
          const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, file);
          let resolved;
          if (_bind$5.$tag === 1) {
            const _ok = _bind$5;
            resolved = _ok._0;
          } else {
            const _err = _bind$5;
            _try_err = _err._0;
            break _L$2;
          }
          const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, resolved);
          if (_bind$6.$tag === 1) {
            const _ok = _bind$6;
            content = _ok._0;
          } else {
            const _err = _bind$6;
            _try_err = _err._0;
            break _L$2;
          }
          break _L;
        }
        const _FsError = _try_err;
        const _msg = _FsError._0;
        return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`strings: ${_msg}\n`);
      }
      _M0FP410Haoxincode8moonbash3lib8commands21cmd__strings__collect(content, min_len, out);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(out.val);
}
function _M0FP410Haoxincode8moonbash3lib8commands18cmd__split__suffix(index) {
  const n = index < 0 ? 0 : index;
  const first = (n / 26 | 0) % 26 | 0;
  const second = n % 26 | 0;
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  $bound_check(_M0FP410Haoxincode8moonbash3lib8commands18cmd__split__suffixN8alphabetS3263, first);
  _M0IPB13StringBuilderPB6Logger11write__char(out, _M0FP410Haoxincode8moonbash3lib8commands18cmd__split__suffixN8alphabetS3263.charCodeAt(first));
  $bound_check(_M0FP410Haoxincode8moonbash3lib8commands18cmd__split__suffixN8alphabetS3263, second);
  _M0IPB13StringBuilderPB6Logger11write__char(out, _M0FP410Haoxincode8moonbash3lib8commands18cmd__split__suffixN8alphabetS3263.charCodeAt(second));
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands27cmd__split__lines__preserve(input) {
  const lines = [];
  const line = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < input.length) {
      $bound_check(input, i);
      const ch = input.charCodeAt(i);
      _M0IPB13StringBuilderPB6Logger11write__char(line, ch);
      if (ch === 10) {
        _M0MPC15array5Array4pushGUssEE(lines, line.val);
        _M0MPB13StringBuilder5reset(line);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const trailing = line.val;
  if (trailing.length > 0) {
    _M0MPC15array5Array4pushGUssEE(lines, trailing);
  }
  return lines;
}
function _M0FP410Haoxincode8moonbash3lib8commands25cmd__split__write__chunks(ctx, chunks, prefix) {
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < chunks.length) {
      const name = `${prefix}${_M0FP410Haoxincode8moonbash3lib8commands18cmd__split__suffix(i)}`;
      let path;
      let _try_err;
      _L: {
        _L$2: {
          const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, name);
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            path = _ok._0;
          } else {
            const _err = _bind$4;
            _try_err = _err._0;
            break _L$2;
          }
          break _L;
        }
        const _FsError = _try_err;
        const _msg = _FsError._0;
        return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`split: ${_msg}\n`);
      }
      let _try_err$2;
      _L$2: {
        _L$3: {
          const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs11write__file(ctx.fs, path, _M0MPC15array5Array2atGUssEE(chunks, i));
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            _ok._0;
          } else {
            const _err = _bind$4;
            _try_err$2 = _err._0;
            break _L$3;
          }
          break _L$2;
        }
        const _FsError = _try_err$2;
        const _msg = _FsError._0;
        return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`split: ${_msg}\n`);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok("");
}
function _M0FP410Haoxincode8moonbash3lib8commands10cmd__split(ctx) {
  let lines_per_chunk = 1000;
  let bytes_per_chunk = undefined;
  const positionals = [];
  let i = 0;
  while (true) {
    if (i < ctx.args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(ctx.args, i);
      if (arg === "-l" && (i + 1 | 0) < ctx.args.length) {
        lines_per_chunk = _M0FP410Haoxincode8moonbash3lib8commands15cst__parse__int(_M0MPC15array5Array2atGUssEE(ctx.args, i + 1 | 0));
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands10cmd__splitN7_2abindS4518, 0, _M0FP410Haoxincode8moonbash3lib8commands10cmd__splitN7_2abindS4518.length)) && arg.length > 2) {
        lines_per_chunk = _M0FP410Haoxincode8moonbash3lib8commands15cst__parse__int(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined)));
        i = i + 1 | 0;
        continue;
      }
      if (arg === "-b" && (i + 1 | 0) < ctx.args.length) {
        bytes_per_chunk = _M0FP410Haoxincode8moonbash3lib8commands15cst__parse__int(_M0MPC15array5Array2atGUssEE(ctx.args, i + 1 | 0));
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands10cmd__splitN7_2abindS4519, 0, _M0FP410Haoxincode8moonbash3lib8commands10cmd__splitN7_2abindS4519.length)) && arg.length > 2) {
        bytes_per_chunk = _M0FP410Haoxincode8moonbash3lib8commands15cst__parse__int(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined)));
        i = i + 1 | 0;
        continue;
      }
      _M0MPC15array5Array4pushGUssEE(positionals, arg);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (lines_per_chunk <= 0) {
    lines_per_chunk = 1;
  }
  const input_file = positionals.length >= 1 ? _M0MPC15array5Array2atGUssEE(positionals, 0) : undefined;
  const prefix = positionals.length >= 2 ? _M0MPC15array5Array2atGUssEE(positionals, 1) : "x";
  let input;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands16cst__read__input(ctx, input_file);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        input = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    const _FsError = _try_err;
    const _msg = _FsError._0;
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`split: ${_msg}\n`);
  }
  if (input.length === 0) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok("");
  }
  const chunks = [];
  const _bind$4 = bytes_per_chunk;
  if (_bind$4 === undefined) {
    const lines = _M0FP410Haoxincode8moonbash3lib8commands27cmd__split__lines__preserve(input);
    let pos = 0;
    while (true) {
      if (pos < lines.length) {
        const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
        let count = 0;
        while (true) {
          if (pos < lines.length && count < lines_per_chunk) {
            _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(lines, pos));
            pos = pos + 1 | 0;
            count = count + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        _M0MPC15array5Array4pushGUssEE(chunks, out.val);
        continue;
      } else {
        break;
      }
    }
  } else {
    const _Some = _bind$4;
    const _size = _Some;
    const chunk_size = _size <= 0 ? 1 : _size;
    let pos = 0;
    while (true) {
      if (pos < input.length) {
        const end_ = (pos + chunk_size | 0) > input.length ? input.length : pos + chunk_size | 0;
        _M0MPC15array5Array4pushGUssEE(chunks, _M0FP410Haoxincode8moonbash3lib8commands11cst__substr(input, pos, end_));
        pos = end_;
        continue;
      } else {
        break;
      }
    }
  }
  return _M0FP410Haoxincode8moonbash3lib8commands25cmd__split__write__chunks(ctx, chunks, prefix);
}
function _M0FP410Haoxincode8moonbash3lib8commands16tar__clean__path(path) {
  if (path === "/") {
    return path;
  }
  let start = 0;
  while (true) {
    let _tmp$38;
    if ((start + 1 | 0) < path.length) {
      let _tmp$39;
      const _tmp$40 = start;
      $bound_check(path, _tmp$40);
      const _p$4 = path.charCodeAt(_tmp$40);
      const _p$5 = 46;
      if (_p$4 === _p$5) {
        const _tmp$41 = start + 1 | 0;
        $bound_check(path, _tmp$41);
        const _p$6 = path.charCodeAt(_tmp$41);
        const _p$7 = 47;
        _tmp$39 = _p$6 === _p$7;
      } else {
        _tmp$39 = false;
      }
      _tmp$38 = _tmp$39;
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      start = start + 2 | 0;
      continue;
    } else {
      break;
    }
  }
  const trimmed = start > 0 ? _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(path, start, undefined)) : path;
  let end_ = trimmed.length;
  while (true) {
    let _tmp$38;
    if (end_ > 1) {
      const _tmp$39 = end_ - 1 | 0;
      $bound_check(trimmed, _tmp$39);
      const _p$4 = trimmed.charCodeAt(_tmp$39);
      const _p$5 = 47;
      _tmp$38 = _p$4 === _p$5;
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      end_ = end_ - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return end_ === trimmed.length ? trimmed : _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(trimmed, 0, end_));
}
function _M0FP410Haoxincode8moonbash3lib8commands18tar__collect__tree(fs, abs_path, rel_path, out) {
  let stat;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs4stat(fs, abs_path);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        stat = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    return undefined;
  }
  if (stat.is_directory) {
    _M0MPC15array5Array4pushGUssEE(out, new _M0TP410Haoxincode8moonbash3lib8commands8TarEntry(`${rel_path}/`, true, ""));
    let entries;
    let _try_err$2;
    _L$2: {
      _L$3: {
        const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs7readdir(fs, abs_path);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          entries = _ok._0;
        } else {
          const _err = _bind$4;
          _try_err$2 = _err._0;
          break _L$3;
        }
        break _L$2;
      }
      return undefined;
    }
    const names = [];
    const _bind$4 = entries.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$4) {
        const entry = entries[_];
        _M0MPC15array5Array4pushGUssEE(names, entry.name);
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    _M0FP410Haoxincode8moonbash3lib8commands18cst__sort__strings(names);
    const _bind$5 = names.length;
    let _tmp$39 = 0;
    while (true) {
      const _ = _tmp$39;
      if (_ < _bind$5) {
        const name = names[_];
        const child_abs = abs_path === "/" ? `/${name}` : `${abs_path}/${name}`;
        const child_rel = `${rel_path}/${name}`;
        _M0FP410Haoxincode8moonbash3lib8commands18tar__collect__tree(fs, child_abs, child_rel, out);
        _tmp$39 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return undefined;
  }
  if (stat.is_file) {
    let content;
    let _try_err$2;
    _L$2: {
      _L$3: {
        const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(fs, abs_path);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          content = _ok._0;
        } else {
          const _err = _bind$4;
          _try_err$2 = _err._0;
          break _L$3;
        }
        break _L$2;
      }
      content = "";
    }
    _M0MPC15array5Array4pushGUssEE(out, new _M0TP410Haoxincode8moonbash3lib8commands8TarEntry(rel_path, false, content));
    return;
  } else {
    return;
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands14tar__serialize(entries) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger13write__string(out, "MBTAR1\n");
  const _bind$4 = entries.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const entry = entries[_];
      if (entry.is_dir) {
        _M0IPB13StringBuilderPB6Logger13write__string(out, "D\t");
        _M0IPB13StringBuilderPB6Logger13write__string(out, entry.path);
        _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
      } else {
        _M0IPB13StringBuilderPB6Logger13write__string(out, "F\t");
        _M0IPB13StringBuilderPB6Logger13write__string(out, entry.path);
        _M0IPB13StringBuilderPB6Logger11write__char(out, 9);
        _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC13int3Int18to__string_2einner(entry.content.length, 10));
        _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
        _M0IPB13StringBuilderPB6Logger13write__string(out, entry.content);
        _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands20tar__index__of__char(s, start, ch) {
  let _tmp$38 = start;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      if (s.charCodeAt(i) === ch) {
        return i;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410Haoxincode8moonbash3lib8commands16tar__deserialize(content) {
  const entries = [];
  if (!_M0FP410Haoxincode8moonbash3lib8commands17cst__starts__with(content, "MBTAR1\n")) {
    return entries;
  }
  let pos = 7;
  while (true) {
    if (pos < content.length) {
      const line_end = _M0FP410Haoxincode8moonbash3lib8commands20tar__index__of__char(content, pos, 10);
      if (line_end < 0) {
        break;
      }
      const header = _M0FP410Haoxincode8moonbash3lib8commands11cst__substr(content, pos, line_end);
      pos = line_end + 1 | 0;
      if (header.length === 0) {
        continue;
      }
      if (_M0FP410Haoxincode8moonbash3lib8commands17cst__starts__with(header, "D\t")) {
        const path = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(header, 2, undefined));
        _M0MPC15array5Array4pushGUssEE(entries, new _M0TP410Haoxincode8moonbash3lib8commands8TarEntry(path, true, ""));
        continue;
      }
      if (_M0FP410Haoxincode8moonbash3lib8commands17cst__starts__with(header, "F\t")) {
        const tab2 = _M0FP410Haoxincode8moonbash3lib8commands20tar__index__of__char(header, 2, 9);
        if (tab2 < 0) {
          continue;
        }
        const path = _M0FP410Haoxincode8moonbash3lib8commands11cst__substr(header, 2, tab2);
        const len_str = _M0FP410Haoxincode8moonbash3lib8commands11cst__substr(header, tab2 + 1 | 0, header.length);
        let size = _M0FP410Haoxincode8moonbash3lib8commands15cst__parse__int(len_str);
        if (size < 0) {
          size = 0;
        }
        const end_ = (pos + size | 0) > content.length ? content.length : pos + size | 0;
        const file_content = _M0FP410Haoxincode8moonbash3lib8commands11cst__substr(content, pos, end_);
        pos = end_;
        let _tmp$38;
        if (pos < content.length) {
          const _tmp$39 = pos;
          $bound_check(content, _tmp$39);
          _tmp$38 = content.charCodeAt(_tmp$39) === 10;
        } else {
          _tmp$38 = false;
        }
        if (_tmp$38) {
          pos = pos + 1 | 0;
        }
        _M0MPC15array5Array4pushGUssEE(entries, new _M0TP410Haoxincode8moonbash3lib8commands8TarEntry(path, false, file_content));
      }
      continue;
    } else {
      break;
    }
  }
  return entries;
}
function _M0FP410Haoxincode8moonbash3lib8commands22tar__strip__components(path, strip) {
  let p = path;
  let is_dir;
  if (p.length > 0) {
    const _tmp$38 = p;
    const _tmp$39 = p.length - 1 | 0;
    $bound_check(_tmp$38, _tmp$39);
    const _p$4 = _tmp$38.charCodeAt(_tmp$39);
    const _p$5 = 47;
    is_dir = _p$4 === _p$5;
  } else {
    is_dir = false;
  }
  if (is_dir && p.length > 1) {
    p = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(p, 0, p.length - 1 | 0));
  }
  const parts = _M0FP410Haoxincode8moonbash3lib8commands16cst__split__path(p);
  if (strip >= parts.length) {
    return undefined;
  }
  const stripped = _M0FP410Haoxincode8moonbash3lib8commands15cst__join__path(parts, strip);
  return stripped.length === 0 ? undefined : is_dir ? `${stripped}/` : stripped;
}
function _M0FP410Haoxincode8moonbash3lib8commands8cmd__tar(ctx) {
  let mode = "";
  let archive_file = undefined;
  let extract_dir = undefined;
  let strip_components = 0;
  const operands = [];
  let i = 0;
  while (true) {
    if (i < ctx.args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(ctx.args, i);
      if (arg === "-C" && (i + 1 | 0) < ctx.args.length) {
        extract_dir = _M0MPC15array5Array2atGUssEE(ctx.args, i + 1 | 0);
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands8cmd__tarN7_2abindS4566, 0, _M0FP410Haoxincode8moonbash3lib8commands8cmd__tarN7_2abindS4566.length))) {
        strip_components = _M0FP410Haoxincode8moonbash3lib8commands15cst__parse__int(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 19, undefined)));
        if (strip_components < 0) {
          strip_components = 0;
        }
        i = i + 1 | 0;
        continue;
      }
      let _tmp$38;
      if (arg.length > 1) {
        $bound_check(arg, 0);
        const _p$4 = arg.charCodeAt(0);
        const _p$5 = 45;
        _tmp$38 = _p$4 === _p$5;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        let j = 1;
        while (true) {
          if (j < arg.length) {
            const _tmp$39 = j;
            $bound_check(arg, _tmp$39);
            const flag = arg.charCodeAt(_tmp$39);
            _L: {
              _L$2: {
                switch (flag) {
                  case 99: {
                    break _L$2;
                  }
                  case 116: {
                    break _L$2;
                  }
                  case 120: {
                    break _L$2;
                  }
                  case 122: {
                    break;
                  }
                  case 102: {
                    if ((j + 1 | 0) < arg.length) {
                      archive_file = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, j + 1 | 0, undefined));
                      j = arg.length;
                    } else {
                      if ((i + 1 | 0) < ctx.args.length) {
                        i = i + 1 | 0;
                        archive_file = _M0MPC15array5Array2atGUssEE(ctx.args, i);
                      }
                    }
                    break;
                  }
                }
                break _L;
              }
              mode = _M0IPC14char4CharPB4Show10to__string(flag);
            }
            j = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        i = i + 1 | 0;
        continue;
      }
      _M0MPC15array5Array4pushGUssEE(operands, arg);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$4 = archive_file;
  let archive_path;
  if (_bind$4 === undefined) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("tar: archive file not specified\n");
  } else {
    const _Some = _bind$4;
    archive_path = _Some;
  }
  let archive_abs;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, archive_path);
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        archive_abs = _ok._0;
      } else {
        const _err = _bind$5;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    const _FsError = _try_err;
    const _msg = _FsError._0;
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`tar: ${_msg}\n`);
  }
  if (mode === "c") {
    const entries = [];
    const _bind$5 = operands.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$5) {
        const operand = operands[_];
        const rel = _M0FP410Haoxincode8moonbash3lib8commands16tar__clean__path(operand);
        let abs;
        let _try_err$2;
        _L$2: {
          _L$3: {
            const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, rel);
            if (_bind$6.$tag === 1) {
              const _ok = _bind$6;
              abs = _ok._0;
            } else {
              const _err = _bind$6;
              _try_err$2 = _err._0;
              break _L$3;
            }
            break _L$2;
          }
          const _FsError = _try_err$2;
          const _msg = _FsError._0;
          return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`tar: ${_msg}\n`);
        }
        let stat;
        let _try_err$3;
        _L$3: {
          _L$4: {
            const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs4stat(ctx.fs, abs);
            if (_bind$6.$tag === 1) {
              const _ok = _bind$6;
              stat = _ok._0;
            } else {
              const _err = _bind$6;
              _try_err$3 = _err._0;
              break _L$4;
            }
            break _L$3;
          }
          const _FsError = _try_err$3;
          const _msg = _FsError._0;
          return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`tar: ${_msg}\n`);
        }
        if (stat.is_directory) {
          _M0FP410Haoxincode8moonbash3lib8commands18tar__collect__tree(ctx.fs, abs, rel, entries);
        } else {
          let content;
          let _try_err$4;
          _L$4: {
            _L$5: {
              const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, abs);
              if (_bind$6.$tag === 1) {
                const _ok = _bind$6;
                content = _ok._0;
              } else {
                const _err = _bind$6;
                _try_err$4 = _err._0;
                break _L$5;
              }
              break _L$4;
            }
            const _FsError = _try_err$4;
            const _msg = _FsError._0;
            return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`tar: ${_msg}\n`);
          }
          _M0MPC15array5Array4pushGUssEE(entries, new _M0TP410Haoxincode8moonbash3lib8commands8TarEntry(rel, false, content));
        }
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    const packed = _M0FP410Haoxincode8moonbash3lib8commands14tar__serialize(entries);
    let _try_err$2;
    _L$2: {
      _L$3: {
        const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs11write__file(ctx.fs, archive_abs, packed);
        if (_bind$6.$tag === 1) {
          const _ok = _bind$6;
          _ok._0;
        } else {
          const _err = _bind$6;
          _try_err$2 = _err._0;
          break _L$3;
        }
        break _L$2;
      }
      const _FsError = _try_err$2;
      const _msg = _FsError._0;
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`tar: ${_msg}\n`);
    }
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok("");
  }
  let archive_content;
  let _try_err$2;
  _L$2: {
    _L$3: {
      const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, archive_abs);
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        archive_content = _ok._0;
      } else {
        const _err = _bind$5;
        _try_err$2 = _err._0;
        break _L$3;
      }
      break _L$2;
    }
    const _FsError = _try_err$2;
    const _msg = _FsError._0;
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`tar: ${_msg}\n`);
  }
  const entries = _M0FP410Haoxincode8moonbash3lib8commands16tar__deserialize(archive_content);
  if (mode === "t") {
    const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
    const _bind$5 = entries.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$5) {
        const entry = entries[_];
        _M0IPB13StringBuilderPB6Logger13write__string(out, entry.path);
        _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(out.val);
  }
  if (mode === "x") {
    const _bind$5 = extract_dir;
    let dest_abs;
    if (_bind$5 === undefined) {
      dest_abs = ctx.cwd;
    } else {
      const _Some = _bind$5;
      const _dir = _Some;
      let _try_err$3;
      _L$3: {
        _L$4: {
          const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, _dir);
          if (_bind$6.$tag === 1) {
            const _ok = _bind$6;
            dest_abs = _ok._0;
          } else {
            const _err = _bind$6;
            _try_err$3 = _err._0;
            break _L$4;
          }
          break _L$3;
        }
        const _FsError = _try_err$3;
        const _msg = _FsError._0;
        return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`tar: ${_msg}\n`);
      }
    }
    const _bind$6 = entries.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$6) {
        const entry = entries[_];
        _L$3: {
          const _bind$7 = _M0FP410Haoxincode8moonbash3lib8commands22tar__strip__components(entry.path, strip_components);
          let extracted;
          if (_bind$7 === undefined) {
            break _L$3;
          } else {
            const _Some = _bind$7;
            extracted = _Some;
          }
          let clean;
          let _tmp$39;
          if (extracted.length > 0) {
            const _tmp$40 = extracted.length - 1 | 0;
            $bound_check(extracted, _tmp$40);
            const _p$4 = extracted.charCodeAt(_tmp$40);
            const _p$5 = 47;
            _tmp$39 = _p$4 === _p$5;
          } else {
            _tmp$39 = false;
          }
          if (_tmp$39) {
            clean = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(extracted, 0, extracted.length - 1 | 0));
          } else {
            clean = extracted;
          }
          let final_path;
          let _try_err$3;
          _L$4: {
            _L$5: {
              const _bind$8 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(dest_abs, clean);
              if (_bind$8.$tag === 1) {
                const _ok = _bind$8;
                final_path = _ok._0;
              } else {
                const _err = _bind$8;
                _try_err$3 = _err._0;
                break _L$5;
              }
              break _L$4;
            }
            break _L$3;
          }
          if (entry.is_dir) {
            let _try_err$4;
            _L$5: {
              _L$6: {
                const _bind$8 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs13mkdir_2einner(ctx.fs, final_path, true);
                if (_bind$8.$tag === 1) {
                  const _ok = _bind$8;
                  _ok._0;
                } else {
                  const _err = _bind$8;
                  _try_err$4 = _err._0;
                  break _L$6;
                }
                break _L$5;
              }
            }
          } else {
            let _try_err$4;
            _L$5: {
              _L$6: {
                const _bind$8 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs11write__file(ctx.fs, final_path, entry.content);
                if (_bind$8.$tag === 1) {
                  const _ok = _bind$8;
                  _ok._0;
                } else {
                  const _err = _bind$8;
                  _try_err$4 = _err._0;
                  break _L$6;
                }
                break _L$5;
              }
              const _FsError = _try_err$4;
              const _msg = _FsError._0;
              return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`tar: ${_msg}\n`);
            }
          }
          break _L$3;
        }
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok("");
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("tar: you must specify one of -c, -t, or -x\n");
}
function _M0FP410Haoxincode8moonbash3lib8commands22process__echo__escapes(s) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  while (true) {
    if (i < s.length) {
      const _tmp$38 = i;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch === 92 && (i + 1 | 0) < s.length) {
        const _tmp$39 = i + 1 | 0;
        $bound_check(s, _tmp$39);
        const next = s.charCodeAt(_tmp$39);
        switch (next) {
          case 110: {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 10);
            i = i + 2 | 0;
            break;
          }
          case 116: {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 9);
            i = i + 2 | 0;
            break;
          }
          case 114: {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 13);
            i = i + 2 | 0;
            break;
          }
          case 92: {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
            i = i + 2 | 0;
            break;
          }
          case 97: {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 7);
            i = i + 2 | 0;
            break;
          }
          case 98: {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 8);
            i = i + 2 | 0;
            break;
          }
          case 102: {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 12);
            i = i + 2 | 0;
            break;
          }
          case 118: {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 11);
            i = i + 2 | 0;
            break;
          }
          default: {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
            i = i + 1 | 0;
          }
        }
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands9cmd__echo(ctx) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let no_newline = false;
  let interpret_escapes = false;
  let start = 0;
  while (true) {
    if (start < ctx.args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(ctx.args, start);
      if (arg === "-n") {
        no_newline = true;
        start = start + 1 | 0;
      } else {
        if (arg === "-e") {
          interpret_escapes = true;
          start = start + 1 | 0;
        } else {
          if (arg === "-E") {
            interpret_escapes = false;
            start = start + 1 | 0;
          } else {
            if (arg === "-ne" || arg === "-en") {
              no_newline = true;
              interpret_escapes = true;
              start = start + 1 | 0;
            } else {
              break;
            }
          }
        }
      }
      continue;
    } else {
      break;
    }
  }
  let _tmp$38 = start;
  while (true) {
    const i = _tmp$38;
    if (i < ctx.args.length) {
      if (i > start) {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, 32);
      }
      if (interpret_escapes) {
        _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FP410Haoxincode8moonbash3lib8commands22process__echo__escapes(_M0MPC15array5Array2atGUssEE(ctx.args, i)));
      } else {
        _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0MPC15array5Array2atGUssEE(ctx.args, i));
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (!no_newline) {
    _M0IPB13StringBuilderPB6Logger11write__char(buf, 10);
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(buf.val);
}
function _M0FP410Haoxincode8moonbash3lib8commands9cmd__true(_ctx) {
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", "", 0);
}
function _M0FP410Haoxincode8moonbash3lib8commands10cmd__false(_ctx) {
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", "", 1);
}
function _M0FP410Haoxincode8moonbash3lib8commands7cmd__cd(ctx) {
  let target;
  if (ctx.args.length === 0) {
    const _p$4 = _M0MPB3Map3getGssE(ctx.env, "HOME");
    const _p$5 = "/home/user";
    if (_p$4 === undefined) {
      target = _p$5;
    } else {
      const _p$6 = _p$4;
      target = _p$6;
    }
  } else {
    if (_M0MPC15array5Array2atGUssEE(ctx.args, 0) === "-") {
      const _p$4 = _M0MPB3Map3getGssE(ctx.env, "OLDPWD");
      const _p$5 = ctx.cwd;
      if (_p$4 === undefined) {
        target = _p$5;
      } else {
        const _p$6 = _p$4;
        target = _p$6;
      }
    } else {
      target = _M0MPC15array5Array2atGUssEE(ctx.args, 0);
    }
  }
  let resolved;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, target);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        resolved = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    const _FsError = _try_err;
    const _msg = _FsError._0;
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`cd: ${_msg}\n`);
  }
  const _bind$4 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(ctx.fs.entries, resolved);
  if (_bind$4 === undefined) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`cd: no such file or directory: ${target}\n`);
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    if (_x.$tag === 1) {
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok("");
    } else {
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`cd: not a directory: ${target}\n`);
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands8cmd__pwd(ctx) {
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(`${ctx.cwd}\n`);
}
function _M0FP410Haoxincode8moonbash3lib8commands27aj__find__substring_2einner(s, needle, start) {
  if (needle.length === 0) {
    return start;
  }
  if (start < 0 || needle.length > s.length) {
    return -1;
  }
  if (start > (s.length - needle.length | 0)) {
    return -1;
  }
  let i = start;
  while (true) {
    if (i <= (s.length - needle.length | 0)) {
      let matched = true;
      let _tmp$38 = 0;
      while (true) {
        const j = _tmp$38;
        if (j < needle.length) {
          const _tmp$39 = i + j | 0;
          $bound_check(s, _tmp$39);
          const _p$4 = s.charCodeAt(_tmp$39);
          $bound_check(needle, j);
          const _p$5 = needle.charCodeAt(j);
          if (_p$4 !== _p$5) {
            matched = false;
            break;
          }
          _tmp$38 = j + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      if (matched) {
        return i;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410Haoxincode8moonbash3lib8commands14aj__parse__int(s) {
  let result = 0;
  let neg = false;
  let start = 0;
  let _tmp$38;
  if (s.length > 0) {
    $bound_check(s, 0);
    const _p$4 = s.charCodeAt(0);
    const _p$5 = 45;
    _tmp$38 = _p$4 === _p$5;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    neg = true;
    start = 1;
  } else {
    let _tmp$39;
    if (s.length > 0) {
      $bound_check(s, 0);
      const _p$4 = s.charCodeAt(0);
      const _p$5 = 43;
      _tmp$39 = _p$4 === _p$5;
    } else {
      _tmp$39 = false;
    }
    if (_tmp$39) {
      start = 1;
    }
  }
  let _tmp$39 = start;
  while (true) {
    const i = _tmp$39;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      if (ch >= 48 && ch <= 57) {
        result = (Math.imul(result, 10) | 0) + (ch - 48 | 0) | 0;
      } else {
        break;
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return neg ? -result | 0 : result;
}
function _M0FP410Haoxincode8moonbash3lib8commands25aj__split__lines__records(input) {
  const lines = [];
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < input.length) {
      $bound_check(input, i);
      const ch = input.charCodeAt(i);
      if (ch === 10) {
        _M0MPC15array5Array4pushGUssEE(lines, buf.val);
        _M0MPB13StringBuilder5reset(buf);
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const trailing = buf.val;
  if (trailing.length > 0) {
    _M0MPC15array5Array4pushGUssEE(lines, trailing);
  }
  return lines;
}
function _M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(s, prefix) {
  if (prefix.length > s.length) {
    return false;
  }
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < prefix.length) {
      $bound_check(s, i);
      const _p$4 = s.charCodeAt(i);
      $bound_check(prefix, i);
      const _p$5 = prefix.charCodeAt(i);
      if (_p$4 !== _p$5) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(s, start, end_) {
  let start$2 = start;
  let end_$2 = end_;
  if (start$2 < 0) {
    start$2 = 0;
  }
  if (end_$2 > s.length) {
    end_$2 = s.length;
  }
  if (start$2 >= end_$2) {
    return "";
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = start$2;
  while (true) {
    const i = _tmp$38;
    if (i < end_$2) {
      $bound_check(s, i);
      _M0IPB13StringBuilderPB6Logger11write__char(out, s.charCodeAt(i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands16awk__current__fs(default_fs, vars) {
  const _p$4 = _M0MPB3Map3getGssE(vars, "FS");
  if (_p$4 === undefined) {
    return default_fs;
  } else {
    const _p$5 = _p$4;
    return _p$5;
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(s) {
  let start = 0;
  let end_ = s.length;
  while (true) {
    if (start < end_) {
      const _tmp$38 = start;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch === 32 || (ch === 9 || (ch === 10 || ch === 13))) {
        start = start + 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (end_ > start) {
      const _tmp$38 = end_ - 1 | 0;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch === 32 || (ch === 9 || (ch === 10 || ch === 13))) {
        end_ = end_ - 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  return start === 0 && end_ === s.length ? s : start >= end_ ? "" : _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(s, start, end_));
}
function _M0FP410Haoxincode8moonbash3lib8commands21aj__index__of_2einner(s, ch, start) {
  let _tmp$38 = start;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      if (s.charCodeAt(i) === ch) {
        return i;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410Haoxincode8moonbash3lib8commands15aj__first__line(s) {
  const idx = _M0FP410Haoxincode8moonbash3lib8commands21aj__index__of_2einner(s, 10, 0);
  return idx >= 0 ? _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(s, 0, idx) : s;
}
function _M0FP410Haoxincode8moonbash3lib8commands24awk__is__numeric__string(s) {
  const t = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(s);
  if (t.length === 0) {
    return false;
  }
  let i = 0;
  let _tmp$38;
  $bound_check(t, 0);
  if (t.charCodeAt(0) === 43) {
    _tmp$38 = true;
  } else {
    $bound_check(t, 0);
    _tmp$38 = t.charCodeAt(0) === 45;
  }
  if (_tmp$38) {
    i = 1;
  }
  if (i >= t.length) {
    return false;
  }
  let seen_digit = false;
  let seen_dot = false;
  let seen_exp = false;
  let seen_exp_digit = false;
  while (true) {
    if (i < t.length) {
      const _tmp$39 = i;
      $bound_check(t, _tmp$39);
      const ch = t.charCodeAt(_tmp$39);
      if (ch >= 48 && ch <= 57) {
        seen_digit = true;
        if (seen_exp) {
          seen_exp_digit = true;
        }
        i = i + 1 | 0;
        continue;
      }
      if (ch === 46 && (!seen_dot && !seen_exp)) {
        seen_dot = true;
        i = i + 1 | 0;
        continue;
      }
      if ((ch === 101 || ch === 69) && (seen_digit && !seen_exp)) {
        seen_exp = true;
        seen_exp_digit = false;
        i = i + 1 | 0;
        if (i < t.length) {
          const _tmp$40 = i;
          $bound_check(t, _tmp$40);
          const sign = t.charCodeAt(_tmp$40);
          if (sign === 43 || sign === 45) {
            i = i + 1 | 0;
          }
        }
        continue;
      }
      return false;
    } else {
      break;
    }
  }
  return seen_exp ? seen_digit && seen_exp_digit : seen_digit;
}
function _M0FP410Haoxincode8moonbash3lib8commands23awk__number__to__string(n) {
  const as_int = _M0MPC16double6Double7to__int(n);
  return as_int + 0 === n ? _M0MPC13int3Int18to__string_2einner(as_int, 10) : String(n);
}
function _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(s) {
  if (!_M0FP410Haoxincode8moonbash3lib8commands24awk__is__numeric__string(s)) {
    return 0;
  }
  const t = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(s);
  let i = 0;
  let sign = 1;
  $bound_check(t, 0);
  if (t.charCodeAt(0) === 45) {
    sign = -1;
    i = 1;
  } else {
    $bound_check(t, 0);
    if (t.charCodeAt(0) === 43) {
      i = 1;
    }
  }
  let value = 0;
  while (true) {
    if (i < t.length) {
      const _tmp$38 = i;
      $bound_check(t, _tmp$38);
      const ch = t.charCodeAt(_tmp$38);
      if (ch >= 48 && ch <= 57) {
        value = value * 10 + ((ch - 48 | 0) + 0);
        i = i + 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  let _tmp$38;
  if (i < t.length) {
    const _tmp$39 = i;
    $bound_check(t, _tmp$39);
    _tmp$38 = t.charCodeAt(_tmp$39) === 46;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    i = i + 1 | 0;
    let factor = 0.1;
    while (true) {
      if (i < t.length) {
        const _tmp$39 = i;
        $bound_check(t, _tmp$39);
        const ch = t.charCodeAt(_tmp$39);
        if (ch >= 48 && ch <= 57) {
          value = value + ((ch - 48 | 0) + 0) * factor;
          factor = factor / 10;
          i = i + 1 | 0;
        } else {
          break;
        }
        continue;
      } else {
        break;
      }
    }
  }
  let _tmp$39;
  if (i < t.length) {
    let _tmp$40;
    const _tmp$41 = i;
    $bound_check(t, _tmp$41);
    if (t.charCodeAt(_tmp$41) === 101) {
      _tmp$40 = true;
    } else {
      const _tmp$42 = i;
      $bound_check(t, _tmp$42);
      _tmp$40 = t.charCodeAt(_tmp$42) === 69;
    }
    _tmp$39 = _tmp$40;
  } else {
    _tmp$39 = false;
  }
  if (_tmp$39) {
    i = i + 1 | 0;
    let exp_sign = 1;
    if (i < t.length) {
      const _tmp$40 = i;
      $bound_check(t, _tmp$40);
      const exp_sign_ch = t.charCodeAt(_tmp$40);
      if (exp_sign_ch === 45) {
        exp_sign = -1;
        i = i + 1 | 0;
      } else {
        if (exp_sign_ch === 43) {
          i = i + 1 | 0;
        }
      }
    }
    let exp = 0;
    while (true) {
      if (i < t.length) {
        const _tmp$40 = i;
        $bound_check(t, _tmp$40);
        const exp_ch = t.charCodeAt(_tmp$40);
        if (exp_ch >= 48 && exp_ch <= 57) {
          exp = (Math.imul(exp, 10) | 0) + (exp_ch - 48 | 0) | 0;
          i = i + 1 | 0;
        } else {
          break;
        }
        continue;
      } else {
        break;
      }
    }
    value = value * _M0FPC14math3pow(10, (Math.imul(exp_sign, exp) | 0) + 0);
  }
  return sign * value;
}
function _M0FP410Haoxincode8moonbash3lib8commands28awk__normalize__array__index(index) {
  const trimmed = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(index);
  if (trimmed.length === 0) {
    return "";
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands24awk__is__numeric__string(trimmed)) {
    return _M0FP410Haoxincode8moonbash3lib8commands23awk__number__to__string(_M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(trimmed));
  }
  return trimmed;
}
function _M0FP410Haoxincode8moonbash3lib8commands15awk__array__key(name, index) {
  return `${name}#${_M0FP410Haoxincode8moonbash3lib8commands28awk__normalize__array__index(index)}`;
}
function _M0FP410Haoxincode8moonbash3lib8commands20aj__split__by__delim(s, delim) {
  if (delim.length === 0) {
    return [s];
  }
  const parts = [];
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  while (true) {
    if (i < s.length) {
      let match_found = true;
      if ((i + delim.length | 0) <= s.length) {
        let _tmp$38 = 0;
        while (true) {
          const j = _tmp$38;
          if (j < delim.length) {
            const _tmp$39 = i + j | 0;
            $bound_check(s, _tmp$39);
            const _p$4 = s.charCodeAt(_tmp$39);
            $bound_check(delim, j);
            const _p$5 = delim.charCodeAt(j);
            if (_p$4 !== _p$5) {
              match_found = false;
              break;
            }
            _tmp$38 = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
      } else {
        match_found = false;
      }
      if (match_found) {
        _M0MPC15array5Array4pushGUssEE(parts, buf.val);
        _M0MPB13StringBuilder5reset(buf);
        i = i + delim.length | 0;
      } else {
        const _tmp$38 = i;
        $bound_check(s, _tmp$38);
        _M0IPB13StringBuilderPB6Logger11write__char(buf, s.charCodeAt(_tmp$38));
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  _M0MPC15array5Array4pushGUssEE(parts, buf.val);
  return parts;
}
function _M0FP410Haoxincode8moonbash3lib8commands18awk__split__fields(line, fs) {
  if (fs === ".") {
    return [];
  }
  if (fs === " ") {
    const fields = [];
    const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
    let in_field = false;
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < line.length) {
        $bound_check(line, i);
        const ch = line.charCodeAt(i);
        if (ch === 32 || ch === 9) {
          if (in_field) {
            _M0MPC15array5Array4pushGUssEE(fields, buf.val);
            _M0MPB13StringBuilder5reset(buf);
            in_field = false;
          }
        } else {
          _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
          in_field = true;
        }
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    if (in_field) {
      _M0MPC15array5Array4pushGUssEE(fields, buf.val);
    }
    return fields;
  }
  return _M0FP410Haoxincode8moonbash3lib8commands20aj__split__by__delim(line, fs);
}
function _M0FP410Haoxincode8moonbash3lib8commands28awk__assign__getline__record(line_value, fs, vars, current_line, current_fields) {
  const current_fs = _M0FP410Haoxincode8moonbash3lib8commands16awk__current__fs(fs, vars);
  const next_fields = _M0FP410Haoxincode8moonbash3lib8commands18awk__split__fields(line_value, current_fs);
  _M0MPB3Map3setGssE(vars, "NF", _M0MPC13int3Int18to__string_2einner(next_fields.length, 10));
  return { _0: line_value, _1: next_fields };
}
function _M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(s, suffix) {
  if (suffix.length > s.length) {
    return false;
  }
  const offset = s.length - suffix.length | 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < suffix.length) {
      const _tmp$39 = offset + i | 0;
      $bound_check(s, _tmp$39);
      const _p$4 = s.charCodeAt(_tmp$39);
      $bound_check(suffix, i);
      const _p$5 = suffix.charCodeAt(i);
      if (_p$4 !== _p$5) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0FP410Haoxincode8moonbash3lib8commands25awk__is__identifier__char(ch) {
  return ch >= 97 && ch <= 122 || (ch >= 65 && ch <= 90 || (ch >= 48 && ch <= 57 || ch === 95));
}
function _M0FP410Haoxincode8moonbash3lib8commands19awk__is__identifier(name) {
  if (name.length === 0) {
    return false;
  }
  $bound_check(name, 0);
  const first = name.charCodeAt(0);
  if (!(first >= 97 && first <= 122 || (first >= 65 && first <= 90 || first === 95))) {
    return false;
  }
  let _tmp$38 = 1;
  while (true) {
    const i = _tmp$38;
    if (i < name.length) {
      $bound_check(name, i);
      if (!_M0FP410Haoxincode8moonbash3lib8commands25awk__is__identifier__char(name.charCodeAt(i))) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0FP410Haoxincode8moonbash3lib8commands22awk__parse__array__ref(expr) {
  const t = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(expr);
  if (t.length < 3) {
    return undefined;
  }
  const open_bracket = _M0FP410Haoxincode8moonbash3lib8commands21aj__index__of_2einner(t, 91, 0);
  let _tmp$38;
  if (open_bracket <= 0) {
    _tmp$38 = true;
  } else {
    const _tmp$39 = t.length - 1 | 0;
    $bound_check(t, _tmp$39);
    _tmp$38 = t.charCodeAt(_tmp$39) !== 93;
  }
  if (_tmp$38) {
    return undefined;
  }
  const arr_name = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 0, open_bracket));
  if (!_M0FP410Haoxincode8moonbash3lib8commands19awk__is__identifier(arr_name)) {
    return undefined;
  }
  const idx_expr = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, open_bracket + 1 | 0, t.length - 1 | 0));
  if (idx_expr.length === 0) {
    return undefined;
  }
  return { _0: arr_name, _1: idx_expr };
}
function _M0FP410Haoxincode8moonbash3lib8commands36awk__expr__assignment__target__valid(lhs) {
  const t = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(lhs);
  if (_M0FP410Haoxincode8moonbash3lib8commands19awk__is__identifier(t)) {
    return true;
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands22awk__parse__array__ref(t);
  return !(_bind$4 === undefined);
}
function _M0FP410Haoxincode8moonbash3lib8commands31awk__find__top__level__operator(expr, ops) {
  let quote = -1;
  let paren_depth = 0;
  let bracket_depth = 0;
  let idx = -1;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < expr.length) {
      _L: {
        $bound_check(expr, i);
        const ch = expr.charCodeAt(i);
        const _bind$4 = quote;
        if (_bind$4 === -1) {
          if (ch === 34 || ch === 39) {
            quote = ch;
          } else {
            if (ch === 40) {
              paren_depth = paren_depth + 1 | 0;
            } else {
              if (ch === 41 && paren_depth > 0) {
                paren_depth = paren_depth - 1 | 0;
              } else {
                if (ch === 91) {
                  bracket_depth = bracket_depth + 1 | 0;
                } else {
                  if (ch === 93 && bracket_depth > 0) {
                    bracket_depth = bracket_depth - 1 | 0;
                  } else {
                    if (bracket_depth === 0 && paren_depth === 0) {
                      let in_ops = false;
                      let _tmp$39 = 0;
                      while (true) {
                        const j = _tmp$39;
                        if (j < ops.length) {
                          $bound_check(ops, j);
                          if (ops.charCodeAt(j) === ch) {
                            in_ops = true;
                            break;
                          }
                          _tmp$39 = j + 1 | 0;
                          continue;
                        } else {
                          break;
                        }
                      }
                      if (in_ops) {
                        if ((ch === 43 || ch === 45) && i === 0) {
                          break _L;
                        }
                        idx = i;
                      }
                    }
                  }
                }
              }
            }
          }
        } else {
          const _Some = _bind$4;
          const _q = _Some;
          if (ch === 92 && (i + 1 | 0) < expr.length) {
            break _L;
          }
          if (ch === _q) {
            quote = -1;
          }
        }
        break _L;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return idx;
}
function _M0FP410Haoxincode8moonbash3lib8commands37awk__find__top__level__ternary__colon(expr, start_idx) {
  let quote = -1;
  let paren_depth = 0;
  let bracket_depth = 0;
  let ternary_depth = 0;
  let _tmp$38 = start_idx;
  while (true) {
    const i = _tmp$38;
    if (i < expr.length) {
      _L: {
        $bound_check(expr, i);
        const ch = expr.charCodeAt(i);
        const _bind$4 = quote;
        if (_bind$4 === -1) {
          if (ch === 34 || ch === 39) {
            quote = ch;
          } else {
            if (ch === 40) {
              paren_depth = paren_depth + 1 | 0;
            } else {
              if (ch === 41 && paren_depth > 0) {
                paren_depth = paren_depth - 1 | 0;
              } else {
                if (ch === 91) {
                  bracket_depth = bracket_depth + 1 | 0;
                } else {
                  if (ch === 93 && bracket_depth > 0) {
                    bracket_depth = bracket_depth - 1 | 0;
                  } else {
                    if (paren_depth === 0 && bracket_depth === 0) {
                      if (ch === 63) {
                        ternary_depth = ternary_depth + 1 | 0;
                      } else {
                        if (ch === 58) {
                          if (ternary_depth === 0) {
                            return i;
                          }
                          ternary_depth = ternary_depth - 1 | 0;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        } else {
          const _Some = _bind$4;
          const _q = _Some;
          if (ch === 92 && (i + 1 | 0) < expr.length) {
            break _L;
          }
          if (ch === _q) {
            quote = -1;
          }
        }
        break _L;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(expr, token) {
  if (token.length === 0 || token.length > expr.length) {
    return -1;
  }
  let quote = -1;
  let bracket_depth = 0;
  let paren_depth = 0;
  let i = 0;
  while (true) {
    if ((i + token.length | 0) <= expr.length) {
      const _tmp$38 = i;
      $bound_check(expr, _tmp$38);
      const ch = expr.charCodeAt(_tmp$38);
      const _bind$4 = quote;
      if (_bind$4 === -1) {
        if (ch === 34 || ch === 39) {
          quote = ch;
          i = i + 1 | 0;
          continue;
        }
        if (ch === 91) {
          bracket_depth = bracket_depth + 1 | 0;
          i = i + 1 | 0;
          continue;
        }
        if (ch === 93 && bracket_depth > 0) {
          bracket_depth = bracket_depth - 1 | 0;
          i = i + 1 | 0;
          continue;
        }
        if (ch === 40) {
          paren_depth = paren_depth + 1 | 0;
          i = i + 1 | 0;
          continue;
        }
        if (ch === 41 && paren_depth > 0) {
          paren_depth = paren_depth - 1 | 0;
          i = i + 1 | 0;
          continue;
        }
        if (bracket_depth === 0 && paren_depth === 0) {
          let matched = true;
          let _tmp$39 = 0;
          while (true) {
            const j = _tmp$39;
            if (j < token.length) {
              const _tmp$40 = i + j | 0;
              $bound_check(expr, _tmp$40);
              const _p$4 = expr.charCodeAt(_tmp$40);
              $bound_check(token, j);
              const _p$5 = token.charCodeAt(j);
              if (_p$4 !== _p$5) {
                matched = false;
                break;
              }
              _tmp$39 = j + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          if (matched) {
            return i;
          }
        }
        i = i + 1 | 0;
      } else {
        const _Some = _bind$4;
        const _q = _Some;
        if (ch === 92 && (i + 1 | 0) < expr.length) {
          i = i + 2 | 0;
          continue;
        }
        if (ch === _q) {
          quote = -1;
        }
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410Haoxincode8moonbash3lib8commands29awk__is__regex__literal__expr(text) {
  const t = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(text);
  return t.length >= 2 && (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(t, "/") && _M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(t, "/"));
}
function _M0FP410Haoxincode8moonbash3lib8commands21awk__split__csv__args(s) {
  const parts = [];
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let quote = -1;
  let paren_depth = 0;
  let bracket_depth = 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      const _bind$4 = quote;
      if (_bind$4 === -1) {
        if (ch === 34 || ch === 39) {
          quote = ch;
          _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
        } else {
          if (ch === 40) {
            paren_depth = paren_depth + 1 | 0;
            _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
          } else {
            if (ch === 41) {
              if (paren_depth > 0) {
                paren_depth = paren_depth - 1 | 0;
              }
              _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
            } else {
              if (ch === 91) {
                bracket_depth = bracket_depth + 1 | 0;
                _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
              } else {
                if (ch === 93) {
                  if (bracket_depth > 0) {
                    bracket_depth = bracket_depth - 1 | 0;
                  }
                  _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
                } else {
                  if (ch === 44 && (paren_depth === 0 && bracket_depth === 0)) {
                    _M0MPC15array5Array4pushGUssEE(parts, _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(buf.val));
                    _M0MPB13StringBuilder5reset(buf);
                  } else {
                    _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
                  }
                }
              }
            }
          }
        }
      } else {
        const _Some = _bind$4;
        const _q = _Some;
        _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
        if (ch === _q) {
          quote = -1;
        }
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const last = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(buf.val);
  if (last.length > 0) {
    _M0MPC15array5Array4pushGUssEE(parts, last);
  }
  return parts;
}
function _M0FP410Haoxincode8moonbash3lib8commands22awk__parse__call__expr(expr) {
  const t = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(expr);
  if (t.length < 3) {
    return undefined;
  }
  const open_paren = _M0FP410Haoxincode8moonbash3lib8commands21aj__index__of_2einner(t, 40, 0);
  let _tmp$38;
  if (open_paren <= 0) {
    _tmp$38 = true;
  } else {
    const _tmp$39 = t.length - 1 | 0;
    $bound_check(t, _tmp$39);
    _tmp$38 = t.charCodeAt(_tmp$39) !== 41;
  }
  if (_tmp$38) {
    return undefined;
  }
  const name = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 0, open_paren));
  if (!_M0FP410Haoxincode8moonbash3lib8commands19awk__is__identifier(name)) {
    return undefined;
  }
  let depth = 1;
  let quote = -1;
  let i = open_paren + 1 | 0;
  while (true) {
    if (i < t.length && depth > 0) {
      const _tmp$39 = i;
      $bound_check(t, _tmp$39);
      const ch = t.charCodeAt(_tmp$39);
      const _bind$4 = quote;
      if (_bind$4 === -1) {
        if (ch === 34 || ch === 39) {
          quote = ch;
        } else {
          if (ch === 40) {
            depth = depth + 1 | 0;
          } else {
            if (ch === 41) {
              depth = depth - 1 | 0;
            }
          }
        }
      } else {
        const _Some = _bind$4;
        const _q = _Some;
        if (ch === 92 && (i + 1 | 0) < t.length) {
          i = i + 2 | 0;
          continue;
        }
        if (ch === _q) {
          quote = -1;
        }
      }
      if (depth > 0) {
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  if (depth !== 0 || i !== (t.length - 1 | 0)) {
    return undefined;
  }
  const args = _M0FP410Haoxincode8moonbash3lib8commands21awk__split__csv__args(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, open_paren + 1 | 0, i));
  return { _0: name, _1: args };
}
function _M0FP410Haoxincode8moonbash3lib8commands28awk__is__wrapped__in__parens(expr) {
  let _tmp$38;
  if (expr.length < 2) {
    _tmp$38 = true;
  } else {
    let _tmp$39;
    $bound_check(expr, 0);
    if (expr.charCodeAt(0) !== 40) {
      _tmp$39 = true;
    } else {
      const _tmp$40 = expr.length - 1 | 0;
      $bound_check(expr, _tmp$40);
      _tmp$39 = expr.charCodeAt(_tmp$40) !== 41;
    }
    _tmp$38 = _tmp$39;
  }
  if (_tmp$38) {
    return false;
  }
  let depth = 0;
  let quote = -1;
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < expr.length) {
      _L: {
        $bound_check(expr, i);
        const ch = expr.charCodeAt(i);
        const _bind$4 = quote;
        if (_bind$4 === -1) {
          if (ch === 34 || ch === 39) {
            quote = ch;
          } else {
            if (ch === 40) {
              depth = depth + 1 | 0;
            } else {
              if (ch === 41) {
                depth = depth - 1 | 0;
                if (depth === 0 && i < (expr.length - 1 | 0)) {
                  return false;
                }
              }
            }
          }
        } else {
          const _Some = _bind$4;
          const _q = _Some;
          if (ch === 92 && (i + 1 | 0) < expr.length) {
            break _L;
          }
          if (ch === _q) {
            quote = -1;
          }
        }
        break _L;
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return depth === 0;
}
function _M0FP410Haoxincode8moonbash3lib8commands25awk__strip__outer__parens(expr) {
  let current = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(expr);
  while (true) {
    if (_M0FP410Haoxincode8moonbash3lib8commands28awk__is__wrapped__in__parens(current)) {
      current = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(current, 1, current.length - 1 | 0));
      continue;
    } else {
      break;
    }
  }
  return current;
}
function _M0FP410Haoxincode8moonbash3lib8commands19awk__tokenize__expr(expr) {
  const tokens = [];
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let quote = -1;
  let paren_depth = 0;
  let bracket_depth = 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < expr.length) {
      $bound_check(expr, i);
      const ch = expr.charCodeAt(i);
      const _bind$4 = quote;
      if (_bind$4 === -1) {
        if (ch === 34 || ch === 39) {
          quote = ch;
          _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
        } else {
          if (ch === 40) {
            paren_depth = paren_depth + 1 | 0;
            _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
          } else {
            if (ch === 41) {
              if (paren_depth > 0) {
                paren_depth = paren_depth - 1 | 0;
              }
              _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
            } else {
              if (ch === 91) {
                bracket_depth = bracket_depth + 1 | 0;
                _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
              } else {
                if (ch === 93) {
                  if (bracket_depth > 0) {
                    bracket_depth = bracket_depth - 1 | 0;
                  }
                  _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
                } else {
                  if (ch === 32 || ch === 9) {
                    if (paren_depth === 0 && bracket_depth === 0) {
                      const tok = buf.val;
                      if (tok.length > 0) {
                        _M0MPC15array5Array4pushGUssEE(tokens, tok);
                        _M0MPB13StringBuilder5reset(buf);
                      }
                    } else {
                      _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
                    }
                  } else {
                    _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
                  }
                }
              }
            }
          }
        }
      } else {
        const _Some = _bind$4;
        const _q = _Some;
        _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
        if (ch === _q) {
          quote = -1;
        }
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const last = buf.val;
  if (last.length > 0) {
    _M0MPC15array5Array4pushGUssEE(tokens, last);
  }
  return tokens;
}
function _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(expr) {
  const t = _M0FP410Haoxincode8moonbash3lib8commands25awk__strip__outer__parens(_M0FP410Haoxincode8moonbash3lib8commands8aj__trim(expr));
  if (t.length === 0) {
    return _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__astN6constrS9212;
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands29awk__is__regex__literal__expr(t)) {
    return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst3Raw(t);
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(t, "++") || _M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(t, "--")) {
    const target = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 0, t.length - 2 | 0));
    const delta = _M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(t, "++") ? 1 : -1;
    return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Mutate(target, delta, false);
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(t, "++") || _M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(t, "--")) {
    const target = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 2, t.length));
    const delta = _M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(t, "++") ? 1 : -1;
    return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Mutate(target, delta, true);
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands22awk__parse__call__expr(t);
  if (_bind$4 === undefined) {
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _name = _x._0;
    const _raw_args = _x._1;
    const args_ast = [];
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < _raw_args.length) {
        _M0MPC15array5Array4pushGUssEE(args_ast, _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0MPC15array5Array2atGUssEE(_raw_args, i)));
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst4Call(_name, args_ast, _raw_args);
  }
  const eq_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(t, "=");
  if (eq_idx > 0) {
    const _tmp$38 = eq_idx - 1 | 0;
    $bound_check(t, _tmp$38);
    const prev = t.charCodeAt(_tmp$38);
    let next;
    if ((eq_idx + 1 | 0) < t.length) {
      const _tmp$39 = eq_idx + 1 | 0;
      $bound_check(t, _tmp$39);
      next = t.charCodeAt(_tmp$39);
    } else {
      next = -1;
    }
    if (prev !== 33 && (prev !== 60 && (prev !== 62 && (prev !== 61 && _M0IP016_24default__implPB2Eq10not__equalGOcE(next, _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__astN6constrS9213))))) {
      const lhs = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 0, eq_idx));
      if (_M0FP410Haoxincode8moonbash3lib8commands36awk__expr__assignment__target__valid(lhs)) {
        const rhs = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, eq_idx + 1 | 0, t.length));
        return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Assign(lhs, _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(rhs));
      }
    }
  }
  const in_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(t, " in ");
  if (in_idx > 0) {
    const left_expr = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 0, in_idx);
    const right_expr = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, in_idx + 4 | 0, t.length));
    if (_M0FP410Haoxincode8moonbash3lib8commands19awk__is__identifier(right_expr)) {
      return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst2In(_M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(left_expr), right_expr);
    }
  }
  const comma_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(t, ",");
  if (comma_idx > 0) {
    return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Binary(",", _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 0, comma_idx)), _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, comma_idx + 1 | 0, t.length)));
  }
  const question_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(t, "?");
  if (question_idx > 0) {
    const colon_idx = _M0FP410Haoxincode8moonbash3lib8commands37awk__find__top__level__ternary__colon(t, question_idx + 1 | 0);
    if (colon_idx > question_idx) {
      const cond_expr = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 0, question_idx));
      const true_expr = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, question_idx + 1 | 0, colon_idx);
      const false_expr = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, colon_idx + 1 | 0, t.length);
      return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst7Ternary(_M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(cond_expr), _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(true_expr), _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(false_expr));
    }
  }
  const or_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(t, "||");
  if (or_idx > 0) {
    return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Binary("||", _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 0, or_idx)), _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, or_idx + 2 | 0, t.length)));
  }
  const and_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(t, "&&");
  if (and_idx > 0) {
    return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Binary("&&", _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 0, and_idx)), _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, and_idx + 2 | 0, t.length)));
  }
  const not_match_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(t, "!~");
  if (not_match_idx > 0) {
    return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Binary("!~", _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 0, not_match_idx)), _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, not_match_idx + 2 | 0, t.length)));
  }
  const match_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(t, "~");
  if (match_idx > 0) {
    return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Binary("~", _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 0, match_idx)), _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, match_idx + 1 | 0, t.length)));
  }
  let cmp_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(t, "==");
  if (cmp_idx > 0) {
    return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Binary("==", _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 0, cmp_idx)), _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, cmp_idx + 2 | 0, t.length)));
  }
  cmp_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(t, "!=");
  if (cmp_idx > 0) {
    return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Binary("!=", _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 0, cmp_idx)), _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, cmp_idx + 2 | 0, t.length)));
  }
  cmp_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(t, ">=");
  if (cmp_idx > 0) {
    return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Binary(">=", _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 0, cmp_idx)), _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, cmp_idx + 2 | 0, t.length)));
  }
  cmp_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(t, "<=");
  if (cmp_idx > 0) {
    return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Binary("<=", _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 0, cmp_idx)), _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, cmp_idx + 2 | 0, t.length)));
  }
  cmp_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(t, ">");
  if (cmp_idx > 0) {
    return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Binary(">", _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 0, cmp_idx)), _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, cmp_idx + 1 | 0, t.length)));
  }
  cmp_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(t, "<");
  if (cmp_idx > 0) {
    return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Binary("<", _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 0, cmp_idx)), _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, cmp_idx + 1 | 0, t.length)));
  }
  const pow_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(t, "^");
  if (pow_idx > 0) {
    return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Binary("^", _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 0, pow_idx)), _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, pow_idx + 1 | 0, t.length)));
  }
  const add_sub_idx = _M0FP410Haoxincode8moonbash3lib8commands31awk__find__top__level__operator(t, "+-");
  if (add_sub_idx > 0) {
    $bound_check(t, add_sub_idx);
    const op = t.charCodeAt(add_sub_idx);
    return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Binary(_M0IPC14char4CharPB4Show10to__string(op), _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 0, add_sub_idx)), _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, add_sub_idx + 1 | 0, t.length)));
  }
  const mul_div_idx = _M0FP410Haoxincode8moonbash3lib8commands31awk__find__top__level__operator(t, "*/%");
  if (mul_div_idx > 0) {
    $bound_check(t, mul_div_idx);
    const op = t.charCodeAt(mul_div_idx);
    return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Binary(_M0IPC14char4CharPB4Show10to__string(op), _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 0, mul_div_idx)), _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, mul_div_idx + 1 | 0, t.length)));
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(t, "!") && t.length > 1) {
    $bound_check(t, 1);
    const next = t.charCodeAt(1);
    if (next !== 61 && next !== 126) {
      return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst8UnaryNot(_M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 1, t.length)));
    }
  }
  const tokens = _M0FP410Haoxincode8moonbash3lib8commands19awk__tokenize__expr(t);
  if (tokens.length > 1) {
    const parts = [];
    const _bind$5 = tokens.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$5) {
        const tok = tokens[_];
        _M0MPC15array5Array4pushGUssEE(parts, _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(tok));
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst6Concat(parts);
  }
  return new _M0DTP410Haoxincode8moonbash3lib8commands10AwkExprAst3Raw(t);
}
function _M0FP410Haoxincode8moonbash3lib8commands21awk__compare__strings(left, right) {
  const shared = left.length < right.length ? left.length : right.length;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < shared) {
      $bound_check(left, i);
      const lch = left.charCodeAt(i);
      $bound_check(right, i);
      const rch = right.charCodeAt(i);
      if (lch < rch) {
        return -1;
      }
      if (lch > rch) {
        return 1;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return left.length < right.length ? -1 : left.length > right.length ? 1 : 0;
}
function _M0FP410Haoxincode8moonbash3lib8commands20awk__compare__values(left, right, op) {
  if (_M0FP410Haoxincode8moonbash3lib8commands24awk__is__numeric__string(left) && _M0FP410Haoxincode8moonbash3lib8commands24awk__is__numeric__string(right)) {
    const lnum = _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(left);
    const rnum = _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(right);
    switch (op) {
      case "==": {
        return lnum === rnum;
      }
      case "!=": {
        return lnum !== rnum;
      }
      case ">=": {
        return lnum >= rnum;
      }
      case "<=": {
        return lnum <= rnum;
      }
      case ">": {
        return lnum > rnum;
      }
      case "<": {
        return lnum < rnum;
      }
      default: {
        return false;
      }
    }
  } else {
    const cmp = _M0FP410Haoxincode8moonbash3lib8commands21awk__compare__strings(left, right);
    switch (op) {
      case "==": {
        return cmp === 0;
      }
      case "!=": {
        return cmp !== 0;
      }
      case ">=": {
        return cmp >= 0;
      }
      case "<=": {
        return cmp <= 0;
      }
      case ">": {
        return cmp > 0;
      }
      case "<": {
        return cmp < 0;
      }
      default: {
        return false;
      }
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands30awk__collect__array__namespace(array_vars, ns_name) {
  const entries = [];
  const prefix = `${ns_name}#`;
  const _it = _M0MPB3Map5iter2GssE(array_vars);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _key = _x._0;
      const _value = _x._1;
      if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(_key, prefix)) {
        _M0MPC15array5Array4pushGUssEE(entries, { _0: _key, _1: _value });
      }
      continue;
    }
  }
  return entries;
}
function _M0FP410Haoxincode8moonbash3lib8commands29awk__remove__array__namespace(array_vars, ns_name) {
  const entries = _M0FP410Haoxincode8moonbash3lib8commands30awk__collect__array__namespace(array_vars, ns_name);
  const _bind$4 = entries.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const entry = entries[_];
      _M0MPB3Map6removeGssE(array_vars, entry._0);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands27awk__copy__array__namespace(array_vars, source_name, target_name) {
  _M0FP410Haoxincode8moonbash3lib8commands29awk__remove__array__namespace(array_vars, target_name);
  const source_prefix = `${source_name}#`;
  const target_prefix = `${target_name}#`;
  const entries = _M0FP410Haoxincode8moonbash3lib8commands30awk__collect__array__namespace(array_vars, source_name);
  const _bind$4 = entries.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const entry = entries[_];
      const suffix = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(entry._0, source_prefix.length, entry._0.length);
      _M0MPB3Map3setGssE(array_vars, `${target_prefix}${suffix}`, entry._1);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands46awk__sync__fields__from__record__for__function(record, fields, vars) {
  const _p$4 = _M0MPB3Map3getGssE(vars, "FS");
  const _p$5 = " ";
  let _tmp$38;
  if (_p$4 === undefined) {
    _tmp$38 = _p$5;
  } else {
    const _p$6 = _p$4;
    _tmp$38 = _p$6;
  }
  const current_fs = _M0FP410Haoxincode8moonbash3lib8commands16awk__current__fs(_tmp$38, vars);
  const next_fields = _M0FP410Haoxincode8moonbash3lib8commands18awk__split__fields(record, current_fs);
  while (true) {
    if (fields.length > next_fields.length) {
      _M0MPC15array5Array3popGsE(fields);
      continue;
    } else {
      break;
    }
  }
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < next_fields.length) {
      if (i < fields.length) {
        _M0MPC15array5Array3setGsE(fields, i, _M0MPC15array5Array2atGUssEE(next_fields, i));
      } else {
        _M0MPC15array5Array4pushGUssEE(fields, _M0MPC15array5Array2atGUssEE(next_fields, i));
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MPB3Map3setGssE(vars, "NF", _M0MPC13int3Int18to__string_2einner(fields.length, 10));
}
function _M0FP410Haoxincode8moonbash3lib8commands18awk__value__truthy(value) {
  return _M0FP410Haoxincode8moonbash3lib8commands24awk__is__numeric__string(value) ? _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(value) !== 0 : value.length > 0;
}
function _M0FP410Haoxincode8moonbash3lib8commands21aj__hex__digit__value(ch) {
  if (ch >= 48 && ch <= 57) {
    return ch - 48 | 0;
  }
  if (ch >= 97 && ch <= 102) {
    return (ch - 97 | 0) + 10 | 0;
  }
  if (ch >= 65 && ch <= 70) {
    return (ch - 65 | 0) + 10 | 0;
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib8commands23aj__octal__digit__value(ch) {
  return ch >= 48 && ch <= 55 ? ch - 48 | 0 : undefined;
}
function _M0FP410Haoxincode8moonbash3lib8commands22aj__decode__c__escapes(s) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  while (true) {
    if (i < s.length) {
      const _tmp$38 = i;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch === 92 && (i + 1 | 0) < s.length) {
        const _tmp$39 = i + 1 | 0;
        $bound_check(s, _tmp$39);
        const next = s.charCodeAt(_tmp$39);
        switch (next) {
          case 110: {
            _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
            i = i + 2 | 0;
            break;
          }
          case 116: {
            _M0IPB13StringBuilderPB6Logger11write__char(out, 9);
            i = i + 2 | 0;
            break;
          }
          case 114: {
            _M0IPB13StringBuilderPB6Logger11write__char(out, 13);
            i = i + 2 | 0;
            break;
          }
          case 97: {
            _M0IPB13StringBuilderPB6Logger11write__char(out, 7);
            i = i + 2 | 0;
            break;
          }
          case 98: {
            _M0IPB13StringBuilderPB6Logger11write__char(out, 8);
            i = i + 2 | 0;
            break;
          }
          case 102: {
            _M0IPB13StringBuilderPB6Logger11write__char(out, 12);
            i = i + 2 | 0;
            break;
          }
          case 118: {
            _M0IPB13StringBuilderPB6Logger11write__char(out, 11);
            i = i + 2 | 0;
            break;
          }
          case 92: {
            _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
            i = i + 2 | 0;
            break;
          }
          case 34: {
            _M0IPB13StringBuilderPB6Logger11write__char(out, 34);
            i = i + 2 | 0;
            break;
          }
          case 120: {
            let value = 0;
            let digits = 0;
            let j = i + 2 | 0;
            while (true) {
              if (j < s.length && digits < 2) {
                const _tmp$40 = j;
                $bound_check(s, _tmp$40);
                const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands21aj__hex__digit__value(s.charCodeAt(_tmp$40));
                if (_bind$4 === undefined) {
                  break;
                } else {
                  const _Some = _bind$4;
                  const _d = _Some;
                  value = (Math.imul(value, 16) | 0) + _d | 0;
                  digits = digits + 1 | 0;
                  j = j + 1 | 0;
                }
                continue;
              } else {
                break;
              }
            }
            if (digits > 0) {
              _M0IPB13StringBuilderPB6Logger11write__char(out, value);
              i = j;
            } else {
              _M0IPB13StringBuilderPB6Logger11write__char(out, 120);
              i = i + 2 | 0;
            }
            break;
          }
          default: {
            const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands23aj__octal__digit__value(next);
            if (_bind$4 === undefined) {
              _M0IPB13StringBuilderPB6Logger11write__char(out, next);
              i = i + 2 | 0;
            } else {
              const _Some = _bind$4;
              const _first = _Some;
              let value$2 = _first;
              let j$2 = i + 2 | 0;
              let digits$2 = 1;
              while (true) {
                if (j$2 < s.length && digits$2 < 3) {
                  const _tmp$40 = j$2;
                  $bound_check(s, _tmp$40);
                  const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands23aj__octal__digit__value(s.charCodeAt(_tmp$40));
                  if (_bind$5 === undefined) {
                    break;
                  } else {
                    const _Some$2 = _bind$5;
                    const _d = _Some$2;
                    value$2 = (Math.imul(value$2, 8) | 0) + _d | 0;
                    digits$2 = digits$2 + 1 | 0;
                    j$2 = j$2 + 1 | 0;
                  }
                  continue;
                } else {
                  break;
                }
              }
              _M0IPB13StringBuilderPB6Logger11write__char(out, value$2);
              i = j$2;
            }
          }
        }
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands33awk__eval__getline__command__line(command) {
  const cmd = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(command);
  if (!_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(cmd, "echo")) {
    return "";
  }
  let rest = cmd.length > 4 ? _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(cmd, 4, cmd.length)) : "";
  if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(rest, "-e ") || _M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(rest, "-n ")) {
    rest = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(rest, 3, rest.length));
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(rest, "\"") && _M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(rest, "\"") || _M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(rest, "'") && _M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(rest, "'")) {
    rest = _M0FP410Haoxincode8moonbash3lib8commands22aj__decode__c__escapes(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(rest, 1, rest.length - 1 | 0));
  }
  return _M0FP410Haoxincode8moonbash3lib8commands15aj__first__line(rest);
}
function _M0FP410Haoxincode8moonbash3lib8commands14awk__pad__left(text, width, pad) {
  if (width <= text.length) {
    return text;
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let remaining = width - text.length | 0;
  while (true) {
    if (remaining > 0) {
      _M0IPB13StringBuilderPB6Logger11write__char(out, pad);
      remaining = remaining - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger13write__string(out, text);
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands15awk__pad__right(text, width, pad) {
  if (width <= text.length) {
    return text;
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger13write__string(out, text);
  let remaining = width - text.length | 0;
  while (true) {
    if (remaining > 0) {
      _M0IPB13StringBuilderPB6Logger11write__char(out, pad);
      remaining = remaining - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands25awk__apply__printf__width(text, width, left_align, zero_pad) {
  if (width <= text.length) {
    return text;
  }
  if (left_align) {
    return _M0FP410Haoxincode8moonbash3lib8commands15awk__pad__right(text, width, 32);
  }
  if (zero_pad && text.length > 0) {
    $bound_check(text, 0);
    const first = text.charCodeAt(0);
    if (first === 43 || (first === 45 || first === 32)) {
      return `${_M0IPC14char4CharPB4Show10to__string(first)}${_M0FP410Haoxincode8moonbash3lib8commands14awk__pad__left(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, 1, text.length), width - 1 | 0, 48)}`;
    }
  }
  return _M0FP410Haoxincode8moonbash3lib8commands14awk__pad__left(text, width, zero_pad ? 48 : 32);
}
function _M0FP410Haoxincode8moonbash3lib8commands15awk__pow10__int(exp) {
  let out = 1;
  let i = 0;
  const limit = exp < 0 ? 0 : exp > 9 ? 9 : exp;
  while (true) {
    if (i < limit) {
      out = Math.imul(out, 10) | 0;
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out;
}
function _M0FP410Haoxincode8moonbash3lib8commands26awk__format__fixed__number(raw, precision, plus_sign, space_sign) {
  let precision$2 = precision;
  if (precision$2 < 0) {
    precision$2 = 6;
  } else {
    if (precision$2 > 9) {
      precision$2 = 9;
    }
  }
  const scale = _M0FPC14math3pow(10, precision$2 + 0);
  const rounded = raw >= 0 ? _M0MPC16double6Double7to__int(raw * scale + 0.5) : _M0MPC16double6Double7to__int(raw * scale - 0.5);
  const negative = rounded < 0;
  const abs_scaled = rounded < 0 ? -rounded | 0 : rounded;
  const pow10 = _M0FP410Haoxincode8moonbash3lib8commands15awk__pow10__int(precision$2);
  const whole = precision$2 === 0 ? abs_scaled : abs_scaled / pow10 | 0;
  const frac = precision$2 === 0 ? 0 : abs_scaled % pow10 | 0;
  const sign = negative ? "-" : plus_sign ? "+" : space_sign ? " " : "";
  if (precision$2 === 0) {
    return `${sign}${_M0MPC13int3Int18to__string_2einner(whole, 10)}`;
  }
  const frac_text = _M0MPC13int3Int18to__string_2einner(frac, 10);
  const frac_padded = _M0FP410Haoxincode8moonbash3lib8commands14awk__pad__left(frac_text, precision$2, 48);
  return `${sign}${_M0MPC13int3Int18to__string_2einner(whole, 10)}.${frac_padded}`;
}
function _M0FP410Haoxincode8moonbash3lib8commands20awk__to__hex__string(value) {
  if (value === 0) {
    return "0";
  }
  const chars = [];
  let v = value < 0 ? -value | 0 : value;
  while (true) {
    if (v > 0) {
      const digit = v % 16 | 0;
      $bound_check(_M0FP410Haoxincode8moonbash3lib8commands20awk__to__hex__stringN3hexS1066, digit);
      _M0MPC15array5Array4pushGcE(chars, _M0FP410Haoxincode8moonbash3lib8commands20awk__to__hex__stringN3hexS1066.charCodeAt(digit));
      v = v / 16 | 0;
      continue;
    } else {
      break;
    }
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = chars.length - 1 | 0;
  while (true) {
    const i = _tmp$38;
    if (i >= 0) {
      _M0IPB13StringBuilderPB6Logger11write__char(out, _M0MPC15array5Array2atGcE(chars, i));
      _tmp$38 = i - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands14awk__to__upper(s) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      if (ch >= 97 && ch <= 122) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch - 32 | 0);
      } else {
        if (ch === 228) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 196);
        } else {
          if (ch === 246) {
            _M0IPB13StringBuilderPB6Logger11write__char(out, 214);
          } else {
            if (ch === 252) {
              _M0IPB13StringBuilderPB6Logger11write__char(out, 220);
            } else {
              _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
            }
          }
        }
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands36awk__trim__trailing__fraction__zeros(text) {
  const dot = _M0FP410Haoxincode8moonbash3lib8commands21aj__index__of_2einner(text, 46, 0);
  if (dot < 0) {
    return text;
  }
  let end_ = text.length;
  while (true) {
    let _tmp$38;
    if (end_ > (dot + 1 | 0)) {
      const _tmp$39 = end_ - 1 | 0;
      $bound_check(text, _tmp$39);
      _tmp$38 = text.charCodeAt(_tmp$39) === 48;
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      end_ = end_ - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (end_ === (dot + 1 | 0)) {
    end_ = end_ - 1 | 0;
  }
  return _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, 0, end_);
}
function _M0FP410Haoxincode8moonbash3lib8commands19awk__format__printf(format, args) {
  const decoded = _M0FP410Haoxincode8moonbash3lib8commands22aj__decode__c__escapes(format);
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let arg_idx = 0;
  let i = 0;
  while (true) {
    if (i < decoded.length) {
      const _tmp$38 = i;
      $bound_check(decoded, _tmp$38);
      const ch = decoded.charCodeAt(_tmp$38);
      if (ch === 37) {
        let _tmp$39;
        if ((i + 1 | 0) < decoded.length) {
          const _tmp$40 = i + 1 | 0;
          $bound_check(decoded, _tmp$40);
          _tmp$39 = decoded.charCodeAt(_tmp$40) === 37;
        } else {
          _tmp$39 = false;
        }
        if (_tmp$39) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 37);
          i = i + 2 | 0;
          continue;
        }
        let j = i + 1 | 0;
        let left_align = false;
        let plus_sign = false;
        let space_sign = false;
        let zero_pad = false;
        while (true) {
          if (j < decoded.length) {
            const _tmp$40 = j;
            $bound_check(decoded, _tmp$40);
            const f = decoded.charCodeAt(_tmp$40);
            if (f === 45) {
              left_align = true;
              j = j + 1 | 0;
            } else {
              if (f === 43) {
                plus_sign = true;
                j = j + 1 | 0;
              } else {
                if (f === 32) {
                  space_sign = true;
                  j = j + 1 | 0;
                } else {
                  if (f === 48) {
                    zero_pad = true;
                    j = j + 1 | 0;
                  } else {
                    break;
                  }
                }
              }
            }
            continue;
          } else {
            break;
          }
        }
        let width = 0;
        let _tmp$40;
        if (j < decoded.length) {
          const _tmp$41 = j;
          $bound_check(decoded, _tmp$41);
          _tmp$40 = decoded.charCodeAt(_tmp$41) === 42;
        } else {
          _tmp$40 = false;
        }
        if (_tmp$40) {
          width = arg_idx < args.length ? _M0MPC16double6Double7to__int(_M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(_M0MPC15array5Array2atGUssEE(args, arg_idx))) : 0;
          arg_idx = arg_idx + 1 | 0;
          j = j + 1 | 0;
        } else {
          while (true) {
            if (j < decoded.length) {
              const _tmp$41 = j;
              $bound_check(decoded, _tmp$41);
              const wch = decoded.charCodeAt(_tmp$41);
              if (wch >= 48 && wch <= 57) {
                width = (Math.imul(width, 10) | 0) + (wch - 48 | 0) | 0;
                j = j + 1 | 0;
              } else {
                break;
              }
              continue;
            } else {
              break;
            }
          }
        }
        if (width < 0) {
          left_align = true;
          width = -width | 0;
        }
        if (width > 10000) {
          width = 10000;
        }
        let precision = -1;
        let _tmp$41;
        if (j < decoded.length) {
          const _tmp$42 = j;
          $bound_check(decoded, _tmp$42);
          _tmp$41 = decoded.charCodeAt(_tmp$42) === 46;
        } else {
          _tmp$41 = false;
        }
        if (_tmp$41) {
          j = j + 1 | 0;
          let _tmp$42;
          if (j < decoded.length) {
            const _tmp$43 = j;
            $bound_check(decoded, _tmp$43);
            _tmp$42 = decoded.charCodeAt(_tmp$43) === 42;
          } else {
            _tmp$42 = false;
          }
          if (_tmp$42) {
            precision = arg_idx < args.length ? _M0MPC16double6Double7to__int(_M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(_M0MPC15array5Array2atGUssEE(args, arg_idx))) : 0;
            arg_idx = arg_idx + 1 | 0;
            j = j + 1 | 0;
          } else {
            precision = 0;
            while (true) {
              if (j < decoded.length) {
                const _tmp$43 = j;
                $bound_check(decoded, _tmp$43);
                const pch = decoded.charCodeAt(_tmp$43);
                if (pch >= 48 && pch <= 57) {
                  precision = (Math.imul(precision, 10) | 0) + (pch - 48 | 0) | 0;
                  j = j + 1 | 0;
                } else {
                  break;
                }
                continue;
              } else {
                break;
              }
            }
          }
          if (precision > 1000) {
            precision = 1000;
          }
        }
        if (j >= decoded.length) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 37);
          i = i + 1 | 0;
          continue;
        }
        const _tmp$42 = j;
        $bound_check(decoded, _tmp$42);
        const spec = decoded.charCodeAt(_tmp$42);
        const raw = arg_idx < args.length ? _M0MPC15array5Array2atGUssEE(args, arg_idx) : "";
        if (spec === 115) {
          let value = raw;
          if (precision >= 0 && precision < value.length) {
            value = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(value, 0, precision);
          }
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands25awk__apply__printf__width(value, width, left_align, false));
          arg_idx = arg_idx + 1 | 0;
          i = j + 1 | 0;
          continue;
        }
        if (spec === 100 || spec === 105) {
          const num = _M0MPC16double6Double7to__int(_M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(raw));
          const negative = num < 0;
          let digits = num < 0 ? _M0MPC13int3Int18to__string_2einner(-num | 0, 10) : _M0MPC13int3Int18to__string_2einner(num, 10);
          if (precision === 0 && num === 0) {
            digits = "";
          }
          if (precision > 0) {
            digits = _M0FP410Haoxincode8moonbash3lib8commands14awk__pad__left(digits, precision, 48);
          }
          const sign = negative ? "-" : plus_sign ? "+" : space_sign ? " " : "";
          const text = `${sign}${digits}`;
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands25awk__apply__printf__width(text, width, left_align, zero_pad && precision < 0));
          arg_idx = arg_idx + 1 | 0;
          i = j + 1 | 0;
          continue;
        }
        if (spec === 120 || spec === 88) {
          const num = _M0MPC16double6Double7to__int(_M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(raw));
          let digits = _M0FP410Haoxincode8moonbash3lib8commands20awk__to__hex__string(num);
          if (precision === 0 && num === 0) {
            digits = "";
          }
          if (precision > 0) {
            digits = _M0FP410Haoxincode8moonbash3lib8commands14awk__pad__left(digits, precision, 48);
          }
          if (spec === 88) {
            digits = _M0FP410Haoxincode8moonbash3lib8commands14awk__to__upper(digits);
          }
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands25awk__apply__printf__width(digits, width, left_align, zero_pad && precision < 0));
          arg_idx = arg_idx + 1 | 0;
          i = j + 1 | 0;
          continue;
        }
        if (spec === 102 || spec === 70) {
          const num = _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(raw);
          const text = _M0FP410Haoxincode8moonbash3lib8commands26awk__format__fixed__number(num, precision >= 0 ? precision : 6, plus_sign, space_sign);
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands25awk__apply__printf__width(text, width, left_align, zero_pad && precision < 0));
          arg_idx = arg_idx + 1 | 0;
          i = j + 1 | 0;
          continue;
        }
        if (spec === 103 || spec === 71) {
          const num = _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(raw);
          let text = _M0FP410Haoxincode8moonbash3lib8commands26awk__format__fixed__number(num, precision > 0 ? precision : 6, plus_sign, space_sign);
          text = _M0FP410Haoxincode8moonbash3lib8commands36awk__trim__trailing__fraction__zeros(text);
          if (spec === 71) {
            text = _M0FP410Haoxincode8moonbash3lib8commands14awk__to__upper(text);
          }
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands25awk__apply__printf__width(text, width, left_align, false));
          arg_idx = arg_idx + 1 | 0;
          i = j + 1 | 0;
          continue;
        }
        _M0IPB13StringBuilderPB6Logger11write__char(out, 37);
        i = i + 1 | 0;
        continue;
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands35awk__expr__ast__is__string__literal(expr_ast) {
  if (expr_ast.$tag === 0) {
    const _Raw = expr_ast;
    const _text = _Raw._0;
    const t = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_text);
    return _M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(t, "\"") && _M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(t, "\"") || _M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(t, "'") && _M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(t, "'");
  } else {
    return false;
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands33awk__apply__ofmt__if__needed__ast(expr_ast, value, vars) {
  if (!_M0MPB3Map8containsGssE(vars, "OFMT")) {
    return value;
  }
  if (!_M0FP410Haoxincode8moonbash3lib8commands24awk__is__numeric__string(value)) {
    return value;
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands35awk__expr__ast__is__string__literal(expr_ast)) {
    return value;
  }
  const _p$4 = _M0MPB3Map3getGssE(vars, "OFMT");
  const _p$5 = "%.6g";
  let fmt;
  if (_p$4 === undefined) {
    fmt = _p$5;
  } else {
    const _p$6 = _p$4;
    fmt = _p$6;
  }
  return _M0FP410Haoxincode8moonbash3lib8commands19awk__format__printf(fmt, [value]);
}
function _M0FP410Haoxincode8moonbash3lib8commands26awk__replace__all__literal(source, pattern, replacement) {
  if (pattern.length === 0) {
    return { _0: source, _1: 0 };
  }
  let _tmp$38;
  if (pattern.length >= 2) {
    let _tmp$39;
    $bound_check(pattern, 0);
    if (pattern.charCodeAt(0) === 91) {
      const _tmp$40 = pattern.length - 1 | 0;
      $bound_check(pattern, _tmp$40);
      _tmp$39 = pattern.charCodeAt(_tmp$40) === 93;
    } else {
      _tmp$39 = false;
    }
    _tmp$38 = _tmp$39;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    const class_chars = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(pattern, 1, pattern.length - 1 | 0);
    const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
    let count = 0;
    let _tmp$39 = 0;
    while (true) {
      const i = _tmp$39;
      if (i < source.length) {
        $bound_check(source, i);
        const ch = source.charCodeAt(i);
        if (_M0FP410Haoxincode8moonbash3lib8commands27aj__find__substring_2einner(class_chars, _M0IPC14char4CharPB4Show10to__string(ch), 0) >= 0) {
          _M0IPB13StringBuilderPB6Logger13write__string(out, replacement);
          count = count + 1 | 0;
        } else {
          _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        }
        _tmp$39 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return { _0: out.val, _1: count };
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let cursor = 0;
  let count = 0;
  while (true) {
    if (cursor <= source.length) {
      const rest = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(source, cursor, source.length);
      const rel_idx = _M0FP410Haoxincode8moonbash3lib8commands27aj__find__substring_2einner(rest, pattern, 0);
      if (rel_idx < 0) {
        _M0IPB13StringBuilderPB6Logger13write__string(out, rest);
        break;
      }
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(rest, 0, rel_idx));
      _M0IPB13StringBuilderPB6Logger13write__string(out, replacement);
      cursor = cursor + (rel_idx + pattern.length | 0) | 0;
      count = count + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return { _0: out.val, _1: count };
}
function _M0FP410Haoxincode8moonbash3lib8commands28awk__replace__first__literal(source, pattern, replacement) {
  if (pattern.length === 0) {
    return { _0: source, _1: 0 };
  }
  let _tmp$38;
  if (pattern.length >= 2) {
    let _tmp$39;
    $bound_check(pattern, 0);
    if (pattern.charCodeAt(0) === 91) {
      const _tmp$40 = pattern.length - 1 | 0;
      $bound_check(pattern, _tmp$40);
      _tmp$39 = pattern.charCodeAt(_tmp$40) === 93;
    } else {
      _tmp$39 = false;
    }
    _tmp$38 = _tmp$39;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    const class_chars = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(pattern, 1, pattern.length - 1 | 0);
    let _tmp$39 = 0;
    while (true) {
      const i = _tmp$39;
      if (i < source.length) {
        $bound_check(source, i);
        const ch = source.charCodeAt(i);
        if (_M0FP410Haoxincode8moonbash3lib8commands27aj__find__substring_2einner(class_chars, _M0IPC14char4CharPB4Show10to__string(ch), 0) >= 0) {
          const updated = `${_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(source, 0, i)}${replacement}${_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(source, i + 1 | 0, source.length)}`;
          return { _0: updated, _1: 1 };
        }
        _tmp$39 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return { _0: source, _1: 0 };
  }
  const idx = _M0FP410Haoxincode8moonbash3lib8commands27aj__find__substring_2einner(source, pattern, 0);
  if (idx < 0) {
    return { _0: source, _1: 0 };
  }
  const updated = `${_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(source, 0, idx)}${replacement}${_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(source, idx + pattern.length | 0, source.length)}`;
  return { _0: updated, _1: 1 };
}
function _M0FP410Haoxincode8moonbash3lib8commands14awk__is__space(ch) {
  return ch === 32 || (ch === 9 || (ch === 10 || ch === 13));
}
function _M0FP410Haoxincode8moonbash3lib8commands30awk__parse__for__in__statement(stmt) {
  const text = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(stmt);
  if (!_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(text, "for")) {
    return undefined;
  }
  let i = 3;
  while (true) {
    let _tmp$38;
    if (i < text.length) {
      const _tmp$39 = i;
      $bound_check(text, _tmp$39);
      _tmp$38 = _M0FP410Haoxincode8moonbash3lib8commands14awk__is__space(text.charCodeAt(_tmp$39));
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let _tmp$38;
  if (i >= text.length) {
    _tmp$38 = true;
  } else {
    const _tmp$39 = i;
    $bound_check(text, _tmp$39);
    _tmp$38 = text.charCodeAt(_tmp$39) !== 40;
  }
  if (_tmp$38) {
    return undefined;
  }
  let depth = 1;
  let j = i + 1 | 0;
  let quote = -1;
  while (true) {
    if (j < text.length) {
      const _tmp$39 = j;
      $bound_check(text, _tmp$39);
      const ch = text.charCodeAt(_tmp$39);
      const _bind$4 = quote;
      if (_bind$4 === -1) {
        if (ch === 34 || ch === 39) {
          quote = ch;
        } else {
          if (ch === 40) {
            depth = depth + 1 | 0;
          } else {
            if (ch === 41) {
              depth = depth - 1 | 0;
              if (depth === 0) {
                break;
              }
            }
          }
        }
      } else {
        const _Some = _bind$4;
        const _q = _Some;
        if (ch === 92 && (j + 1 | 0) < text.length) {
          j = j + 2 | 0;
          continue;
        }
        if (ch === _q) {
          quote = -1;
        }
      }
      j = j + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (j >= text.length || depth !== 0) {
    return undefined;
  }
  const header = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, i + 1 | 0, j));
  if (_M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(header, ";") >= 0) {
    return undefined;
  }
  const in_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(header, " in ");
  if (in_idx <= 0) {
    return undefined;
  }
  const var_name = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(header, 0, in_idx));
  const arr_name = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(header, in_idx + 4 | 0, header.length));
  if (!_M0FP410Haoxincode8moonbash3lib8commands19awk__is__identifier(var_name) || !_M0FP410Haoxincode8moonbash3lib8commands19awk__is__identifier(arr_name)) {
    return undefined;
  }
  let body = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, j + 1 | 0, text.length));
  let _tmp$39;
  if (body.length >= 2) {
    let _tmp$40;
    const _tmp$41 = body;
    $bound_check(_tmp$41, 0);
    if (_tmp$41.charCodeAt(0) === 123) {
      const _tmp$42 = body;
      const _tmp$43 = body.length - 1 | 0;
      $bound_check(_tmp$42, _tmp$43);
      _tmp$40 = _tmp$42.charCodeAt(_tmp$43) === 125;
    } else {
      _tmp$40 = false;
    }
    _tmp$39 = _tmp$40;
  } else {
    _tmp$39 = false;
  }
  if (_tmp$39) {
    body = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(body, 1, body.length - 1 | 0));
  }
  return { _0: var_name, _1: arr_name, _2: body };
}
function _M0FP410Haoxincode8moonbash3lib8commands23awk__split__for__header(header) {
  const parts = [];
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let quote = -1;
  let paren_depth = 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < header.length) {
      _L: {
        $bound_check(header, i);
        const ch = header.charCodeAt(i);
        const _bind$4 = quote;
        if (_bind$4 === -1) {
          if (ch === 34 || ch === 39) {
            quote = ch;
            _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
          } else {
            if (ch === 40) {
              paren_depth = paren_depth + 1 | 0;
              _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
            } else {
              if (ch === 41) {
                if (paren_depth > 0) {
                  paren_depth = paren_depth - 1 | 0;
                }
                _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
              } else {
                if (ch === 59 && paren_depth === 0) {
                  _M0MPC15array5Array4pushGUssEE(parts, _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(buf.val));
                  _M0MPB13StringBuilder5reset(buf);
                } else {
                  _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
                }
              }
            }
          }
        } else {
          const _Some = _bind$4;
          const _q = _Some;
          _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
          if (ch === 92 && (i + 1 | 0) < header.length) {
            break _L;
          }
          if (ch === _q) {
            quote = -1;
          }
        }
        break _L;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MPC15array5Array4pushGUssEE(parts, _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(buf.val));
  return parts;
}
function _M0FP410Haoxincode8moonbash3lib8commands26awk__parse__for__statement(stmt) {
  const text = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(stmt);
  if (!_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(text, "for")) {
    return undefined;
  }
  let i = 3;
  while (true) {
    let _tmp$38;
    if (i < text.length) {
      const _tmp$39 = i;
      $bound_check(text, _tmp$39);
      _tmp$38 = _M0FP410Haoxincode8moonbash3lib8commands14awk__is__space(text.charCodeAt(_tmp$39));
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let _tmp$38;
  if (i >= text.length) {
    _tmp$38 = true;
  } else {
    const _tmp$39 = i;
    $bound_check(text, _tmp$39);
    _tmp$38 = text.charCodeAt(_tmp$39) !== 40;
  }
  if (_tmp$38) {
    return undefined;
  }
  let depth = 1;
  let j = i + 1 | 0;
  let quote = -1;
  while (true) {
    if (j < text.length) {
      const _tmp$39 = j;
      $bound_check(text, _tmp$39);
      const ch = text.charCodeAt(_tmp$39);
      const _bind$4 = quote;
      if (_bind$4 === -1) {
        if (ch === 34 || ch === 39) {
          quote = ch;
        } else {
          if (ch === 40) {
            depth = depth + 1 | 0;
          } else {
            if (ch === 41) {
              depth = depth - 1 | 0;
              if (depth === 0) {
                break;
              }
            }
          }
        }
      } else {
        const _Some = _bind$4;
        const _q = _Some;
        if (ch === 92 && (j + 1 | 0) < text.length) {
          j = j + 2 | 0;
          continue;
        }
        if (ch === _q) {
          quote = -1;
        }
      }
      j = j + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (j >= text.length || depth !== 0) {
    return undefined;
  }
  const header = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, i + 1 | 0, j);
  let body = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, j + 1 | 0, text.length));
  let _tmp$39;
  if (body.length >= 2) {
    let _tmp$40;
    const _tmp$41 = body;
    $bound_check(_tmp$41, 0);
    if (_tmp$41.charCodeAt(0) === 123) {
      const _tmp$42 = body;
      const _tmp$43 = body.length - 1 | 0;
      $bound_check(_tmp$42, _tmp$43);
      _tmp$40 = _tmp$42.charCodeAt(_tmp$43) === 125;
    } else {
      _tmp$40 = false;
    }
    _tmp$39 = _tmp$40;
  } else {
    _tmp$39 = false;
  }
  if (_tmp$39) {
    body = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(body, 1, body.length - 1 | 0));
  }
  const parts = _M0FP410Haoxincode8moonbash3lib8commands23awk__split__for__header(header);
  if (parts.length !== 3) {
    return undefined;
  }
  return { _0: _M0MPC15array5Array2atGUssEE(parts, 0), _1: _M0MPC15array5Array2atGUssEE(parts, 1), _2: _M0MPC15array5Array2atGUssEE(parts, 2), _3: body };
}
function _M0FP410Haoxincode8moonbash3lib8commands25awk__parse__if__statement(stmt) {
  const text = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(stmt);
  if (!_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(text, "if")) {
    return undefined;
  }
  if (text.length > 2) {
    $bound_check(text, 2);
    const boundary = text.charCodeAt(2);
    if (!_M0FP410Haoxincode8moonbash3lib8commands14awk__is__space(boundary) && boundary !== 40) {
      return undefined;
    }
  }
  let i = 2;
  while (true) {
    let _tmp$38;
    if (i < text.length) {
      const _tmp$39 = i;
      $bound_check(text, _tmp$39);
      _tmp$38 = _M0FP410Haoxincode8moonbash3lib8commands14awk__is__space(text.charCodeAt(_tmp$39));
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let _tmp$38;
  if (i >= text.length) {
    _tmp$38 = true;
  } else {
    const _tmp$39 = i;
    $bound_check(text, _tmp$39);
    _tmp$38 = text.charCodeAt(_tmp$39) !== 40;
  }
  if (_tmp$38) {
    return undefined;
  }
  let depth = 1;
  let j = i + 1 | 0;
  let quote = -1;
  while (true) {
    if (j < text.length) {
      const _tmp$39 = j;
      $bound_check(text, _tmp$39);
      const ch = text.charCodeAt(_tmp$39);
      const _bind$4 = quote;
      if (_bind$4 === -1) {
        if (ch === 34 || ch === 39) {
          quote = ch;
        } else {
          if (ch === 40) {
            depth = depth + 1 | 0;
          } else {
            if (ch === 41) {
              depth = depth - 1 | 0;
              if (depth === 0) {
                break;
              }
            }
          }
        }
      } else {
        const _Some = _bind$4;
        const _q = _Some;
        if (ch === 92 && (j + 1 | 0) < text.length) {
          j = j + 2 | 0;
          continue;
        }
        if (ch === _q) {
          quote = -1;
        }
      }
      j = j + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (j >= text.length || depth !== 0) {
    return undefined;
  }
  const cond = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, i + 1 | 0, j));
  const cond$2 = cond.length === 0 ? "0" : cond;
  let body = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, j + 1 | 0, text.length));
  if (body.length === 0) {
    return undefined;
  }
  let _tmp$39;
  if (body.length >= 2) {
    let _tmp$40;
    const _tmp$41 = body;
    $bound_check(_tmp$41, 0);
    if (_tmp$41.charCodeAt(0) === 123) {
      const _tmp$42 = body;
      const _tmp$43 = body.length - 1 | 0;
      $bound_check(_tmp$42, _tmp$43);
      _tmp$40 = _tmp$42.charCodeAt(_tmp$43) === 125;
    } else {
      _tmp$40 = false;
    }
    _tmp$39 = _tmp$40;
  } else {
    _tmp$39 = false;
  }
  if (_tmp$39) {
    body = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(body, 1, body.length - 1 | 0));
  }
  return { _0: cond$2, _1: body };
}
function _M0FP410Haoxincode8moonbash3lib8commands28awk__parse__while__statement(stmt) {
  const text = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(stmt);
  if (!_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(text, "while")) {
    return undefined;
  }
  if (text.length > 5) {
    $bound_check(text, 5);
    const boundary = text.charCodeAt(5);
    if (!_M0FP410Haoxincode8moonbash3lib8commands14awk__is__space(boundary) && boundary !== 40) {
      return undefined;
    }
  }
  let i = 5;
  while (true) {
    let _tmp$38;
    if (i < text.length) {
      const _tmp$39 = i;
      $bound_check(text, _tmp$39);
      _tmp$38 = _M0FP410Haoxincode8moonbash3lib8commands14awk__is__space(text.charCodeAt(_tmp$39));
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let _tmp$38;
  if (i >= text.length) {
    _tmp$38 = true;
  } else {
    const _tmp$39 = i;
    $bound_check(text, _tmp$39);
    _tmp$38 = text.charCodeAt(_tmp$39) !== 40;
  }
  if (_tmp$38) {
    return undefined;
  }
  let depth = 1;
  let j = i + 1 | 0;
  let quote = -1;
  while (true) {
    if (j < text.length) {
      const _tmp$39 = j;
      $bound_check(text, _tmp$39);
      const ch = text.charCodeAt(_tmp$39);
      const _bind$4 = quote;
      if (_bind$4 === -1) {
        if (ch === 34 || ch === 39) {
          quote = ch;
        } else {
          if (ch === 40) {
            depth = depth + 1 | 0;
          } else {
            if (ch === 41) {
              depth = depth - 1 | 0;
              if (depth === 0) {
                break;
              }
            }
          }
        }
      } else {
        const _Some = _bind$4;
        const _q = _Some;
        if (ch === 92 && (j + 1 | 0) < text.length) {
          j = j + 2 | 0;
          continue;
        }
        if (ch === _q) {
          quote = -1;
        }
      }
      j = j + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (j >= text.length || depth !== 0) {
    return undefined;
  }
  const cond = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, i + 1 | 0, j));
  const cond$2 = cond.length === 0 ? "0" : cond;
  let body = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, j + 1 | 0, text.length));
  if (body.length === 0) {
    return undefined;
  }
  let _tmp$39;
  if (body.length >= 2) {
    let _tmp$40;
    const _tmp$41 = body;
    $bound_check(_tmp$41, 0);
    if (_tmp$41.charCodeAt(0) === 123) {
      const _tmp$42 = body;
      const _tmp$43 = body.length - 1 | 0;
      $bound_check(_tmp$42, _tmp$43);
      _tmp$40 = _tmp$42.charCodeAt(_tmp$43) === 125;
    } else {
      _tmp$40 = false;
    }
    _tmp$39 = _tmp$40;
  } else {
    _tmp$39 = false;
  }
  if (_tmp$39) {
    body = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(body, 1, body.length - 1 | 0));
  }
  return { _0: cond$2, _1: body };
}
function _M0FP410Haoxincode8moonbash3lib8commands28awk__strip__optional__braces(s) {
  const text = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(s);
  let _tmp$38;
  if (text.length >= 2) {
    let _tmp$39;
    $bound_check(text, 0);
    if (text.charCodeAt(0) === 123) {
      const _tmp$40 = text.length - 1 | 0;
      $bound_check(text, _tmp$40);
      _tmp$39 = text.charCodeAt(_tmp$40) === 125;
    } else {
      _tmp$39 = false;
    }
    _tmp$38 = _tmp$39;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    return _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, 1, text.length - 1 | 0));
  } else {
    return text;
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands26awk__split__if__else__body(body) {
  const text = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(body);
  let quote = -1;
  let paren_depth = 0;
  let brace_depth = 0;
  let i = 0;
  while (true) {
    if ((i + 4 | 0) <= text.length) {
      const _tmp$38 = i;
      $bound_check(text, _tmp$38);
      const ch = text.charCodeAt(_tmp$38);
      const _bind$4 = quote;
      if (_bind$4 === -1) {
        if (ch === 34 || ch === 39) {
          quote = ch;
        } else {
          if (ch === 40) {
            paren_depth = paren_depth + 1 | 0;
          } else {
            if (ch === 41 && paren_depth > 0) {
              paren_depth = paren_depth - 1 | 0;
            } else {
              if (ch === 123) {
                brace_depth = brace_depth + 1 | 0;
              } else {
                if (ch === 125 && brace_depth > 0) {
                  brace_depth = brace_depth - 1 | 0;
                } else {
                  if (paren_depth === 0 && (brace_depth === 0 && _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, i, i + 4 | 0) === "else")) {
                    let left_ok;
                    if (i === 0) {
                      left_ok = true;
                    } else {
                      const _tmp$39 = i - 1 | 0;
                      $bound_check(text, _tmp$39);
                      if (_M0FP410Haoxincode8moonbash3lib8commands14awk__is__space(text.charCodeAt(_tmp$39))) {
                        left_ok = true;
                      } else {
                        const _tmp$40 = i - 1 | 0;
                        $bound_check(text, _tmp$40);
                        left_ok = text.charCodeAt(_tmp$40) === 59;
                      }
                    }
                    let right_ok;
                    if ((i + 4 | 0) >= text.length) {
                      right_ok = true;
                    } else {
                      const _tmp$39 = i + 4 | 0;
                      $bound_check(text, _tmp$39);
                      const next = text.charCodeAt(_tmp$39);
                      right_ok = _M0FP410Haoxincode8moonbash3lib8commands14awk__is__space(next) || next === 123;
                    }
                    if (left_ok && right_ok) {
                      const then_body = _M0FP410Haoxincode8moonbash3lib8commands28awk__strip__optional__braces(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, 0, i));
                      const else_body = _M0FP410Haoxincode8moonbash3lib8commands28awk__strip__optional__braces(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, i + 4 | 0, text.length));
                      return { _0: then_body, _1: else_body };
                    }
                  }
                }
              }
            }
          }
        }
      } else {
        const _Some = _bind$4;
        const _q = _Some;
        if (ch === 92 && (i + 1 | 0) < text.length) {
          i = i + 2 | 0;
          continue;
        }
        if (ch === _q) {
          quote = -1;
        }
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return { _0: _M0FP410Haoxincode8moonbash3lib8commands28awk__strip__optional__braces(text), _1: undefined };
}
function _M0FP410Haoxincode8moonbash3lib8commands32awk__merge__if__else__statementsN33statement__has__dangling__controlS1172(stmt) {
  let _tmp$38 = stmt;
  while (true) {
    const stmt$2 = _tmp$38;
    const text = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(stmt$2);
    if (text.length === 0) {
      return false;
    }
    let _tmp$39;
    let _tmp$40;
    let _return_value;
    _L: {
      _L$2: {
        const text$2 = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(text);
        if (!_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(text$2, "if")) {
          _return_value = false;
          break _L$2;
        }
        if (text$2.length > 2) {
          $bound_check(text$2, 2);
          const boundary = text$2.charCodeAt(2);
          if (!_M0FP410Haoxincode8moonbash3lib8commands14awk__is__space(boundary) && boundary !== 40) {
            _return_value = false;
            break _L$2;
          }
        }
        let i = 2;
        while (true) {
          let _tmp$41;
          if (i < text$2.length) {
            const _tmp$42 = i;
            $bound_check(text$2, _tmp$42);
            _tmp$41 = _M0FP410Haoxincode8moonbash3lib8commands14awk__is__space(text$2.charCodeAt(_tmp$42));
          } else {
            _tmp$41 = false;
          }
          if (_tmp$41) {
            i = i + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        let _tmp$41;
        if (i >= text$2.length) {
          _tmp$41 = true;
        } else {
          const _tmp$42 = i;
          $bound_check(text$2, _tmp$42);
          _tmp$41 = text$2.charCodeAt(_tmp$42) !== 40;
        }
        if (_tmp$41) {
          _return_value = false;
          break _L$2;
        }
        let depth = 1;
        let j = i + 1 | 0;
        let quote = -1;
        while (true) {
          if (j < text$2.length) {
            const _tmp$42 = j;
            $bound_check(text$2, _tmp$42);
            const ch = text$2.charCodeAt(_tmp$42);
            const _bind$4 = quote;
            if (_bind$4 === -1) {
              if (ch === 34 || ch === 39) {
                quote = ch;
              } else {
                if (ch === 40) {
                  depth = depth + 1 | 0;
                } else {
                  if (ch === 41) {
                    depth = depth - 1 | 0;
                    if (depth === 0) {
                      break;
                    }
                  }
                }
              }
            } else {
              const _Some = _bind$4;
              const _q = _Some;
              if (ch === 92 && (j + 1 | 0) < text$2.length) {
                j = j + 2 | 0;
                continue;
              }
              if (ch === _q) {
                quote = -1;
              }
            }
            j = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        if (j >= text$2.length || depth !== 0) {
          _return_value = false;
          break _L$2;
        }
        const tail = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text$2, j + 1 | 0, text$2.length));
        _tmp$40 = tail.length === 0;
        break _L;
      }
      _tmp$40 = _return_value;
    }
    if (_tmp$40) {
      _tmp$39 = true;
    } else {
      let _tmp$41;
      let _tmp$42;
      let _return_value$2;
      _L$2: {
        _L$3: {
          const text$2 = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(text);
          if (!_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(text$2, "for")) {
            _return_value$2 = false;
            break _L$3;
          }
          let i = 3;
          while (true) {
            let _tmp$43;
            if (i < text$2.length) {
              const _tmp$44 = i;
              $bound_check(text$2, _tmp$44);
              _tmp$43 = _M0FP410Haoxincode8moonbash3lib8commands14awk__is__space(text$2.charCodeAt(_tmp$44));
            } else {
              _tmp$43 = false;
            }
            if (_tmp$43) {
              i = i + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          let _tmp$43;
          if (i >= text$2.length) {
            _tmp$43 = true;
          } else {
            const _tmp$44 = i;
            $bound_check(text$2, _tmp$44);
            _tmp$43 = text$2.charCodeAt(_tmp$44) !== 40;
          }
          if (_tmp$43) {
            _return_value$2 = false;
            break _L$3;
          }
          let depth = 1;
          let j = i + 1 | 0;
          let quote = -1;
          while (true) {
            if (j < text$2.length) {
              const _tmp$44 = j;
              $bound_check(text$2, _tmp$44);
              const ch = text$2.charCodeAt(_tmp$44);
              const _bind$4 = quote;
              if (_bind$4 === -1) {
                if (ch === 34 || ch === 39) {
                  quote = ch;
                } else {
                  if (ch === 40) {
                    depth = depth + 1 | 0;
                  } else {
                    if (ch === 41) {
                      depth = depth - 1 | 0;
                      if (depth === 0) {
                        break;
                      }
                    }
                  }
                }
              } else {
                const _Some = _bind$4;
                const _q = _Some;
                if (ch === 92 && (j + 1 | 0) < text$2.length) {
                  j = j + 2 | 0;
                  continue;
                }
                if (ch === _q) {
                  quote = -1;
                }
              }
              j = j + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          if (j >= text$2.length || depth !== 0) {
            _return_value$2 = false;
            break _L$3;
          }
          const tail = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text$2, j + 1 | 0, text$2.length));
          _tmp$42 = tail.length === 0;
          break _L$2;
        }
        _tmp$42 = _return_value$2;
      }
      if (_tmp$42) {
        _tmp$41 = true;
      } else {
        let _tmp$43;
        let _return_value$3;
        _L$3: {
          _L$4: {
            const text$2 = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(text);
            if (!_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(text$2, "while")) {
              _return_value$3 = false;
              break _L$4;
            }
            if (text$2.length > 5) {
              $bound_check(text$2, 5);
              const boundary = text$2.charCodeAt(5);
              if (!_M0FP410Haoxincode8moonbash3lib8commands14awk__is__space(boundary) && boundary !== 40) {
                _return_value$3 = false;
                break _L$4;
              }
            }
            let i = 5;
            while (true) {
              let _tmp$44;
              if (i < text$2.length) {
                const _tmp$45 = i;
                $bound_check(text$2, _tmp$45);
                _tmp$44 = _M0FP410Haoxincode8moonbash3lib8commands14awk__is__space(text$2.charCodeAt(_tmp$45));
              } else {
                _tmp$44 = false;
              }
              if (_tmp$44) {
                i = i + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            let _tmp$44;
            if (i >= text$2.length) {
              _tmp$44 = true;
            } else {
              const _tmp$45 = i;
              $bound_check(text$2, _tmp$45);
              _tmp$44 = text$2.charCodeAt(_tmp$45) !== 40;
            }
            if (_tmp$44) {
              _return_value$3 = false;
              break _L$4;
            }
            let depth = 1;
            let j = i + 1 | 0;
            let quote = -1;
            while (true) {
              if (j < text$2.length) {
                const _tmp$45 = j;
                $bound_check(text$2, _tmp$45);
                const ch = text$2.charCodeAt(_tmp$45);
                const _bind$4 = quote;
                if (_bind$4 === -1) {
                  if (ch === 34 || ch === 39) {
                    quote = ch;
                  } else {
                    if (ch === 40) {
                      depth = depth + 1 | 0;
                    } else {
                      if (ch === 41) {
                        depth = depth - 1 | 0;
                        if (depth === 0) {
                          break;
                        }
                      }
                    }
                  }
                } else {
                  const _Some = _bind$4;
                  const _q = _Some;
                  if (ch === 92 && (j + 1 | 0) < text$2.length) {
                    j = j + 2 | 0;
                    continue;
                  }
                  if (ch === _q) {
                    quote = -1;
                  }
                }
                j = j + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            if (j >= text$2.length || depth !== 0) {
              _return_value$3 = false;
              break _L$4;
            }
            const tail = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text$2, j + 1 | 0, text$2.length));
            _tmp$43 = tail.length === 0;
            break _L$3;
          }
          _tmp$43 = _return_value$3;
        }
        _tmp$41 = _tmp$43;
      }
      _tmp$39 = _tmp$41;
    }
    if (_tmp$39) {
      return true;
    }
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands26awk__parse__for__statement(text);
    if (_bind$4 === undefined) {
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _body_stmt = _x._3;
      _tmp$38 = _body_stmt;
      continue;
    }
    const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands30awk__parse__for__in__statement(text);
    if (_bind$5 === undefined) {
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      const _body_stmt = _x._2;
      _tmp$38 = _body_stmt;
      continue;
    }
    const _bind$6 = _M0FP410Haoxincode8moonbash3lib8commands28awk__parse__while__statement(text);
    if (_bind$6 === undefined) {
    } else {
      const _Some = _bind$6;
      const _x = _Some;
      const _body_stmt = _x._1;
      _tmp$38 = _body_stmt;
      continue;
    }
    const _bind$7 = _M0FP410Haoxincode8moonbash3lib8commands25awk__parse__if__statement(text);
    if (_bind$7 === undefined) {
      return false;
    } else {
      const _Some = _bind$7;
      const _x = _Some;
      const _body_stmt = _x._1;
      const _bind$8 = _M0FP410Haoxincode8moonbash3lib8commands26awk__split__if__else__body(_body_stmt);
      const _then_body = _bind$8._0;
      const _else_body = _bind$8._1;
      if (_M0FP410Haoxincode8moonbash3lib8commands32awk__merge__if__else__statementsN33statement__has__dangling__controlS1172(_then_body)) {
        return true;
      }
      if (_else_body === undefined) {
        return false;
      } else {
        const _Some$2 = _else_body;
        const _else_stmt = _Some$2;
        _tmp$38 = _else_stmt;
        continue;
      }
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands32awk__merge__if__else__statements(statements) {
  const merged = [];
  let i = 0;
  while (true) {
    if (i < statements.length) {
      let current = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0MPC15array5Array2atGUssEE(statements, i));
      if (current.length === 0) {
        i = i + 1 | 0;
        continue;
      }
      while (true) {
        if ((i + 1 | 0) < statements.length && _M0FP410Haoxincode8moonbash3lib8commands32awk__merge__if__else__statementsN33statement__has__dangling__controlS1172(current)) {
          const next_body = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0MPC15array5Array2atGUssEE(statements, i + 1 | 0));
          if (next_body.length === 0) {
            i = i + 1 | 0;
            continue;
          }
          if (next_body === "else" || _M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(next_body, "else ")) {
            const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands25awk__parse__if__statement(current);
            const can_merge_else = !(_bind$4 === undefined);
            if (can_merge_else) {
              current = `${current} ${next_body}`;
              i = i + 1 | 0;
              continue;
            }
            break;
          }
          current = `${current} ${next_body}`;
          i = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      if ((i + 1 | 0) < statements.length) {
        const next = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0MPC15array5Array2atGUssEE(statements, i + 1 | 0));
        const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands25awk__parse__if__statement(current);
        const can_merge_else = !(_bind$4 === undefined);
        if ((next === "else" || _M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(next, "else ")) && can_merge_else) {
          current = `${current} ${next}`;
          i = i + 1 | 0;
        }
      }
      _M0MPC15array5Array4pushGUssEE(merged, current);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return merged;
}
function _M0FP410Haoxincode8moonbash3lib8commands42awk__is__zero__literal__expr__for__getline(expr_ast) {
  if (expr_ast.$tag === 0) {
    const _Raw = expr_ast;
    const _text = _Raw._0;
    const t = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_text);
    return t.length > 0 && (_M0FP410Haoxincode8moonbash3lib8commands24awk__is__numeric__string(t) && _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(t) === 0);
  } else {
    return false;
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands27awk__parse__getline__target(target) {
  const t = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(target);
  if (t.length === 0) {
    return _M0DTP410Haoxincode8moonbash3lib8commands16AwkGetlineTarget6Record__;
  } else {
    if (_M0FP410Haoxincode8moonbash3lib8commands19awk__is__identifier(t)) {
      return new _M0DTP410Haoxincode8moonbash3lib8commands16AwkGetlineTarget3Var(t);
    } else {
      if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(t, "$") && t.length > 1) {
        return new _M0DTP410Haoxincode8moonbash3lib8commands16AwkGetlineTarget5Field(_M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 1, t.length)));
      } else {
        const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands22awk__parse__array__ref(t);
        if (_bind$4 === undefined) {
          return new _M0DTP410Haoxincode8moonbash3lib8commands16AwkGetlineTarget7Invalid(t);
        } else {
          const _Some = _bind$4;
          const _x = _Some;
          const _arr_name = _x._0;
          const _idx_expr = _x._1;
          return new _M0DTP410Haoxincode8moonbash3lib8commands16AwkGetlineTarget9ArrayElem(_arr_name, _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_idx_expr));
        }
      }
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands42awk__stringify__simple__expr__for__getline(expr_ast) {
  switch (expr_ast.$tag) {
    case 0: {
      const _Raw = expr_ast;
      const _text = _Raw._0;
      return _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_text);
    }
    case 4: {
      const _Concat = expr_ast;
      const _parts = _Concat._0;
      const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
      let wrote = false;
      const _bind$4 = _parts.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const part = _parts[_];
          _L: {
            if (part.$tag === 0) {
              const _Raw$2 = part;
              const _text$2 = _Raw$2._0;
              const token = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_text$2);
              if (token.length === 0) {
                break _L;
              }
              if (wrote) {
                _M0IPB13StringBuilderPB6Logger11write__char(out, 32);
              }
              _M0IPB13StringBuilderPB6Logger13write__string(out, token);
              wrote = true;
            } else {
              return undefined;
            }
            break _L;
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return out.val;
    }
    default: {
      return undefined;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands48awk__getline__target__from__condition__expr__ast(cond_ast) {
  if (cond_ast.$tag === 8) {
    const _Binary = cond_ast;
    const _op = _Binary._0;
    const _left = _Binary._1;
    const _right = _Binary._2;
    let _tmp$38;
    const _p$4 = ">";
    if (!(_op === _p$4)) {
      _tmp$38 = true;
    } else {
      _tmp$38 = !_M0FP410Haoxincode8moonbash3lib8commands42awk__is__zero__literal__expr__for__getline(_right);
    }
    if (_tmp$38) {
      return undefined;
    }
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands42awk__stringify__simple__expr__for__getline(_left);
    if (_bind$4 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _left_text = _Some;
      const expr = _M0FP410Haoxincode8moonbash3lib8commands25awk__strip__outer__parens(_M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_left_text));
      return expr === "getline" ? _M0DTP410Haoxincode8moonbash3lib8commands16AwkGetlineTarget6Record__ : _M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(expr, "getline ") ? _M0FP410Haoxincode8moonbash3lib8commands27awk__parse__getline__target(_M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(expr, 7, expr.length))) : undefined;
    }
  } else {
    return undefined;
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands26awk__parse__assign__target(lhs) {
  const t = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(lhs);
  if (t.length === 0 || _M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(t, "$")) {
    return undefined;
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands19awk__is__identifier(t)) {
    return new _M0DTP410Haoxincode8moonbash3lib8commands15AwkAssignTarget3Var(t);
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands22awk__parse__array__ref(t);
  if (_bind$4 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _arr_name = _x._0;
    const _idx_expr = _x._1;
    return new _M0DTP410Haoxincode8moonbash3lib8commands15AwkAssignTarget9ArrayElem(_arr_name, _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_idx_expr));
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands24awk__parse__assign__stmt(text) {
  const eq_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(text, "=");
  if (eq_idx <= 0) {
    return undefined;
  }
  const _tmp$38 = eq_idx - 1 | 0;
  $bound_check(text, _tmp$38);
  const prev = text.charCodeAt(_tmp$38);
  let next;
  if ((eq_idx + 1 | 0) < text.length) {
    const _tmp$39 = eq_idx + 1 | 0;
    $bound_check(text, _tmp$39);
    next = text.charCodeAt(_tmp$39);
  } else {
    next = -1;
  }
  if (prev === 33 || (prev === 60 || (prev === 62 || (prev === 61 || _M0IPC16option6OptionPB2Eq5equalGcE(next, _M0FP410Haoxincode8moonbash3lib8commands24awk__parse__assign__stmtN6constrS9214))))) {
    return undefined;
  }
  const lhs = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, 0, eq_idx);
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands26awk__parse__assign__target(lhs);
  let lhs_target;
  if (_bind$4 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$4;
    lhs_target = _Some;
  }
  const rhs = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, eq_idx + 1 | 0, text.length));
  return { _0: lhs_target, _1: _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(rhs) };
}
function _M0FP410Haoxincode8moonbash3lib8commands34awk__parse__compound__assign__stmt(text) {
  const plus_eq_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(text, "+=");
  if (plus_eq_idx > 0) {
    const lhs = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, 0, plus_eq_idx);
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands26awk__parse__assign__target(lhs);
    if (_bind$4 === undefined) {
    } else {
      const _Some = _bind$4;
      const _lhs_target = _Some;
      const rhs = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, plus_eq_idx + 2 | 0, text.length));
      return { _0: _lhs_target, _1: "+=", _2: _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(rhs) };
    }
  }
  const minus_eq_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(text, "-=");
  if (minus_eq_idx > 0) {
    const lhs = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, 0, minus_eq_idx);
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands26awk__parse__assign__target(lhs);
    if (_bind$4 === undefined) {
    } else {
      const _Some = _bind$4;
      const _lhs_target = _Some;
      const rhs = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, minus_eq_idx + 2 | 0, text.length));
      return { _0: _lhs_target, _1: "-=", _2: _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(rhs) };
    }
  }
  const mul_eq_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(text, "*=");
  if (mul_eq_idx > 0) {
    const lhs = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, 0, mul_eq_idx);
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands26awk__parse__assign__target(lhs);
    if (_bind$4 === undefined) {
    } else {
      const _Some = _bind$4;
      const _lhs_target = _Some;
      const rhs = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, mul_eq_idx + 2 | 0, text.length));
      return { _0: _lhs_target, _1: "*=", _2: _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(rhs) };
    }
  }
  const div_eq_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(text, "/=");
  if (div_eq_idx > 0) {
    const lhs = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, 0, div_eq_idx);
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands26awk__parse__assign__target(lhs);
    if (_bind$4 === undefined) {
    } else {
      const _Some = _bind$4;
      const _lhs_target = _Some;
      const rhs = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, div_eq_idx + 2 | 0, text.length));
      return { _0: _lhs_target, _1: "/=", _2: _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(rhs) };
    }
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib8commands31awk__parse__field__assign__stmt(text) {
  const eq_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(text, "=");
  if (eq_idx <= 0) {
    return undefined;
  }
  const _tmp$38 = eq_idx - 1 | 0;
  $bound_check(text, _tmp$38);
  const prev = text.charCodeAt(_tmp$38);
  let next;
  if ((eq_idx + 1 | 0) < text.length) {
    const _tmp$39 = eq_idx + 1 | 0;
    $bound_check(text, _tmp$39);
    next = text.charCodeAt(_tmp$39);
  } else {
    next = -1;
  }
  if (prev === 33 || (prev === 60 || (prev === 62 || (prev === 61 || _M0IPC16option6OptionPB2Eq5equalGcE(next, _M0FP410Haoxincode8moonbash3lib8commands31awk__parse__field__assign__stmtN6constrS9215))))) {
    return undefined;
  }
  const lhs = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, 0, eq_idx));
  if (!_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(lhs, "$")) {
    return undefined;
  }
  const idx_expr = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(lhs, 1, lhs.length));
  const idx_ast = idx_expr.length === 0 ? _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast("0") : _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(idx_expr);
  const rhs = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, eq_idx + 1 | 0, text.length));
  return { _0: idx_ast, _1: _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(rhs) };
}
function _M0FP410Haoxincode8moonbash3lib8commands30awk__parse__print__redirection(expr) {
  const text = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(expr);
  const append_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(text, ">>");
  if (append_idx >= 0) {
    const left = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, 0, append_idx));
    const right = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, append_idx + 2 | 0, text.length));
    if (right.length > 0) {
      return { _0: left, _1: right, _2: true };
    }
  }
  const idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(text, ">");
  if (idx >= 0) {
    let _tmp$38;
    if ((idx + 1 | 0) < text.length) {
      const _tmp$39 = idx + 1 | 0;
      $bound_check(text, _tmp$39);
      _tmp$38 = text.charCodeAt(_tmp$39) === 61;
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      return undefined;
    }
    if (idx > 0) {
      const _tmp$39 = idx - 1 | 0;
      $bound_check(text, _tmp$39);
      const prev = text.charCodeAt(_tmp$39);
      if (prev === 62 || (prev === 60 || (prev === 61 || prev === 33))) {
        return undefined;
      }
    }
    const left = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, 0, idx));
    const right = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, idx + 1 | 0, text.length));
    if (right.length > 0) {
      return { _0: left, _1: right, _2: false };
    }
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__printf(action) {
  let rest = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(action, 6, action.length));
  if (rest.length === 0) {
    return { _0: "", _1: [] };
  }
  let _tmp$38;
  if (rest.length >= 2) {
    let _tmp$39;
    const _tmp$40 = rest;
    $bound_check(_tmp$40, 0);
    if (_tmp$40.charCodeAt(0) === 40) {
      const _tmp$41 = rest;
      const _tmp$42 = rest.length - 1 | 0;
      $bound_check(_tmp$41, _tmp$42);
      _tmp$39 = _tmp$41.charCodeAt(_tmp$42) === 41;
    } else {
      _tmp$39 = false;
    }
    _tmp$38 = _tmp$39;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    rest = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(rest, 1, rest.length - 1 | 0));
  }
  const args = _M0FP410Haoxincode8moonbash3lib8commands21awk__split__csv__args(rest);
  if (args.length === 0) {
    return { _0: "", _1: [] };
  }
  const tail = [];
  let _tmp$39 = 1;
  while (true) {
    const i = _tmp$39;
    if (i < args.length) {
      _M0MPC15array5Array4pushGUssEE(tail, _M0MPC15array5Array2atGUssEE(args, i));
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return { _0: _M0MPC15array5Array2atGUssEE(args, 0), _1: tail };
}
function _M0FP410Haoxincode8moonbash3lib8commands20awk__strip__comments(src) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let quote = -1;
  let in_regex = false;
  let escaped = false;
  let i = 0;
  while (true) {
    if (i < src.length) {
      const _tmp$38 = i;
      $bound_check(src, _tmp$38);
      const ch = src.charCodeAt(_tmp$38);
      const _bind$4 = quote;
      if (_bind$4 === -1) {
        if (in_regex) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
          if (escaped) {
            escaped = false;
          } else {
            if (ch === 92) {
              escaped = true;
            } else {
              if (ch === 47) {
                in_regex = false;
              }
            }
          }
        } else {
          if (ch === 34 || ch === 39) {
            quote = ch;
            _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
          } else {
            if (ch === 47) {
              in_regex = true;
              escaped = false;
              _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
            } else {
              if (ch === 35) {
                while (true) {
                  let _tmp$39;
                  if (i < src.length) {
                    const _tmp$40 = i;
                    $bound_check(src, _tmp$40);
                    _tmp$39 = src.charCodeAt(_tmp$40) !== 10;
                  } else {
                    _tmp$39 = false;
                  }
                  if (_tmp$39) {
                    i = i + 1 | 0;
                    continue;
                  } else {
                    break;
                  }
                }
                let _tmp$39;
                if (i < src.length) {
                  const _tmp$40 = i;
                  $bound_check(src, _tmp$40);
                  _tmp$39 = src.charCodeAt(_tmp$40) === 10;
                } else {
                  _tmp$39 = false;
                }
                if (_tmp$39) {
                  _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
                }
              } else {
                _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
              }
            }
          }
        }
      } else {
        const _Some = _bind$4;
        const _q = _Some;
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        if (ch === 92 && (i + 1 | 0) < src.length) {
          i = i + 1 | 0;
          const _tmp$39 = i;
          $bound_check(src, _tmp$39);
          _M0IPB13StringBuilderPB6Logger11write__char(out, src.charCodeAt(_tmp$39));
        } else {
          if (ch === _q) {
            quote = -1;
          }
        }
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands22awk__split__statements(action) {
  const action$2 = _M0FP410Haoxincode8moonbash3lib8commands20awk__strip__comments(action);
  const parts = [];
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let quote = -1;
  let paren_depth = 0;
  let brace_depth = 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < action$2.length) {
      _L: {
        $bound_check(action$2, i);
        const ch = action$2.charCodeAt(i);
        const _bind$4 = quote;
        if (_bind$4 === -1) {
          if (ch === 34 || ch === 39) {
            quote = ch;
            _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
          } else {
            if (ch === 40) {
              paren_depth = paren_depth + 1 | 0;
              _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
            } else {
              if (ch === 41) {
                if (paren_depth > 0) {
                  paren_depth = paren_depth - 1 | 0;
                }
                _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
              } else {
                if (ch === 123) {
                  brace_depth = brace_depth + 1 | 0;
                  _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
                } else {
                  if (ch === 125) {
                    if (brace_depth > 0) {
                      brace_depth = brace_depth - 1 | 0;
                    }
                    _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
                  } else {
                    if ((ch === 59 || (ch === 10 || ch === 13)) && (paren_depth === 0 && brace_depth === 0)) {
                      _M0MPC15array5Array4pushGUssEE(parts, _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(buf.val));
                      _M0MPB13StringBuilder5reset(buf);
                    } else {
                      _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
                    }
                  }
                }
              }
            }
          }
        } else {
          const _Some = _bind$4;
          const _q = _Some;
          _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
          if (ch === 92 && (i + 1 | 0) < action$2.length) {
            break _L;
          }
          if (ch === _q) {
            quote = -1;
          }
        }
        break _L;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const last = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(buf.val);
  if (last.length > 0) {
    _M0MPC15array5Array4pushGUssEE(parts, last);
  }
  return parts;
}
function _M0FP410Haoxincode8moonbash3lib8commands23awk__parse__action__ast(action) {
  const merged = _M0FP410Haoxincode8moonbash3lib8commands32awk__merge__if__else__statements(_M0FP410Haoxincode8moonbash3lib8commands22awk__split__statements(action));
  const out = [];
  const _bind$4 = merged.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const stmt_raw = merged[_];
      _L: {
        if (_M0FP410Haoxincode8moonbash3lib8commands8aj__trim(stmt_raw).length === 0) {
          break _L;
        }
        const stmt = _M0FP410Haoxincode8moonbash3lib8commands26awk__parse__statement__ast(stmt_raw);
        _M0MPC15array5Array4pushGUssEE(out, stmt);
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out;
}
function _M0FP410Haoxincode8moonbash3lib8commands26awk__parse__statement__ast(stmt) {
  const text = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(stmt);
  if (text.length === 0) {
    return _M0FP410Haoxincode8moonbash3lib8commands26awk__parse__statement__astN6constrS9217;
  }
  if (text === "next") {
    return _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt4Next__;
  }
  if (text === "exit" || (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(text, "exit ") || _M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(text, "exit("))) {
    const expr_text = text.length > 4 ? _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, 4, text.length)) : "";
    const expr_ast = expr_text.length > 0 ? _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(expr_text) : undefined;
    return new _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt4Exit(expr_ast);
  }
  if (text === "return" || (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(text, "return ") || _M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(text, "return("))) {
    const expr_text = text.length > 6 ? _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, 6, text.length)) : "";
    const expr_ast = expr_text.length > 0 ? _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(expr_text) : undefined;
    return new _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt6Return(expr_ast);
  }
  const pipe_getline_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(text, "| getline");
  if (pipe_getline_idx > 0) {
    const cmd_expr = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, 0, pipe_getline_idx));
    const target = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, pipe_getline_idx + 9 | 0, text.length));
    return new _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt11PipeGetline(_M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(cmd_expr), _M0FP410Haoxincode8moonbash3lib8commands27awk__parse__getline__target(target));
  }
  if (text === "getline" || _M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(text, "getline ")) {
    const tail = text.length > 7 ? _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, 7, text.length)) : "";
    const read_from_file_idx = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(tail, "<");
    if (read_from_file_idx > 0) {
      const target = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(tail, 0, read_from_file_idx));
      const path_expr = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(tail, read_from_file_idx + 1 | 0, tail.length));
      return new _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt7Getline(_M0FP410Haoxincode8moonbash3lib8commands27awk__parse__getline__target(target), _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(path_expr));
    }
    return new _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt7Getline(_M0FP410Haoxincode8moonbash3lib8commands27awk__parse__getline__target(tail), undefined);
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(text, "system(") && _M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(text, ")")) {
    return _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt10SystemStmt__;
  }
  const is_gsub = _M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(text, "gsub(") && _M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(text, ")");
  const is_sub = _M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(text, "sub(") && _M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(text, ")");
  if (is_gsub || is_sub) {
    const offset = is_gsub ? 5 : 4;
    const inner = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, offset, text.length - 1 | 0);
    const args_ast = [];
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands21awk__split__csv__args(inner);
    const _bind$5 = _bind$4.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$5) {
        const arg = _bind$4[_];
        _M0MPC15array5Array4pushGUssEE(args_ast, _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(arg));
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return new _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt14SubstituteStmt(is_gsub, args_ast);
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(text, "delete ")) {
    const target_expr = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, 6, text.length));
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands22awk__parse__array__ref(target_expr);
    let _tmp$38;
    if (_bind$4 === undefined) {
      _tmp$38 = new _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt6Delete(target_expr, undefined);
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _arr_name = _x._0;
      const _idx_expr = _x._1;
      _tmp$38 = new _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt6Delete(_arr_name, _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_idx_expr));
    }
    return _tmp$38;
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(text, "printf")) {
    const rest = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, 6, text.length));
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands30awk__parse__print__redirection(rest);
    let _bind$5;
    if (_bind$4 === undefined) {
      _bind$5 = { _0: rest, _1: "", _2: false };
    } else {
      const _Some = _bind$4;
      _bind$5 = _Some;
    }
    const _printf_expr = _bind$5._0;
    const _target_expr = _bind$5._1;
    const _append = _bind$5._2;
    const _bind$6 = _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__printf(`printf ${_printf_expr}`);
    const _fmt_expr = _bind$6._0;
    const _arg_exprs = _bind$6._1;
    const fmt_ast = _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_fmt_expr);
    const args_ast = [];
    const _bind$7 = _arg_exprs.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$7) {
        const expr = _arg_exprs[_];
        _M0MPC15array5Array4pushGUssEE(args_ast, _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(expr));
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    const target_ast = _target_expr.length > 0 ? _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_target_expr) : undefined;
    return new _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt6Printf(fmt_ast, args_ast, target_ast, _append);
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(text, "print") && !_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(text, "printf")) {
    const rest = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, 5, text.length));
    const has_pipe = _M0FP410Haoxincode8moonbash3lib8commands28awk__find__top__level__token(rest, "|") >= 0;
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands30awk__parse__print__redirection(rest);
    let _bind$5;
    if (_bind$4 === undefined) {
      _bind$5 = { _0: rest, _1: "", _2: false };
    } else {
      const _Some = _bind$4;
      _bind$5 = _Some;
    }
    const _value_expr = _bind$5._0;
    const _target_expr = _bind$5._1;
    const _append = _bind$5._2;
    const value_asts = [];
    if (_value_expr.length > 0) {
      const _bind$6 = _M0FP410Haoxincode8moonbash3lib8commands21awk__split__csv__args(_value_expr);
      const _bind$7 = _bind$6.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$7) {
          const expr = _bind$6[_];
          _M0MPC15array5Array4pushGUssEE(value_asts, _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(expr));
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
    }
    const target_ast = _target_expr.length > 0 ? _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_target_expr) : undefined;
    return new _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt5Print(value_asts, target_ast, _append, has_pipe);
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands34awk__parse__compound__assign__stmt(text);
  if (_bind$4 === undefined) {
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _lhs_target = _x._0;
    const _op = _x._1;
    const _rhs_ast = _x._2;
    return new _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt18CompoundAssignStmt(_lhs_target, _op, _rhs_ast);
  }
  const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands31awk__parse__field__assign__stmt(text);
  if (_bind$5 === undefined) {
  } else {
    const _Some = _bind$5;
    const _x = _Some;
    const _idx_ast = _x._0;
    const _rhs_ast = _x._1;
    return new _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt15FieldAssignStmt(_idx_ast, _rhs_ast);
  }
  const _bind$6 = _M0FP410Haoxincode8moonbash3lib8commands24awk__parse__assign__stmt(text);
  if (_bind$6 === undefined) {
  } else {
    const _Some = _bind$6;
    const _x = _Some;
    const _lhs_target = _x._0;
    const _rhs_ast = _x._1;
    return new _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt10AssignStmt(_lhs_target, _rhs_ast);
  }
  const _bind$7 = _M0FP410Haoxincode8moonbash3lib8commands30awk__parse__for__in__statement(text);
  if (_bind$7 === undefined) {
  } else {
    const _Some = _bind$7;
    const _x = _Some;
    const _loop_var = _x._0;
    const _arr_name = _x._1;
    const _body_stmt = _x._2;
    const body_ast = _M0FP410Haoxincode8moonbash3lib8commands23awk__parse__action__ast(_body_stmt);
    return new _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt5ForIn(_loop_var, _arr_name, body_ast);
  }
  const _bind$8 = _M0FP410Haoxincode8moonbash3lib8commands26awk__parse__for__statement(text);
  if (_bind$8 === undefined) {
  } else {
    const _Some = _bind$8;
    const _x = _Some;
    const _init_stmt = _x._0;
    const _cond_expr = _x._1;
    const _update_stmt = _x._2;
    const _body_stmt = _x._3;
    const init_ast = _M0FP410Haoxincode8moonbash3lib8commands23awk__parse__action__ast(_init_stmt);
    const cond_ast = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_cond_expr).length === 0 ? undefined : _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_cond_expr);
    let cond_getline;
    if (cond_ast === undefined) {
      cond_getline = undefined;
    } else {
      const _Some$2 = cond_ast;
      const _cond_expr_ast = _Some$2;
      cond_getline = _M0FP410Haoxincode8moonbash3lib8commands48awk__getline__target__from__condition__expr__ast(_cond_expr_ast);
    }
    const update_ast = _M0FP410Haoxincode8moonbash3lib8commands23awk__parse__action__ast(_update_stmt);
    const body_ast = _M0FP410Haoxincode8moonbash3lib8commands23awk__parse__action__ast(_body_stmt);
    return new _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt3For(init_ast, cond_ast, cond_getline, update_ast, body_ast);
  }
  const _bind$9 = _M0FP410Haoxincode8moonbash3lib8commands28awk__parse__while__statement(text);
  if (_bind$9 === undefined) {
  } else {
    const _Some = _bind$9;
    const _x = _Some;
    const _cond_expr = _x._0;
    const _body_stmt = _x._1;
    const cond_ast = _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_cond_expr);
    const cond_getline = _M0FP410Haoxincode8moonbash3lib8commands48awk__getline__target__from__condition__expr__ast(cond_ast);
    const body_ast = _M0FP410Haoxincode8moonbash3lib8commands23awk__parse__action__ast(_body_stmt);
    return new _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt5While(cond_ast, cond_getline, body_ast);
  }
  const _bind$10 = _M0FP410Haoxincode8moonbash3lib8commands25awk__parse__if__statement(text);
  if (_bind$10 === undefined) {
    return new _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt8ExprStmt(_M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(text));
  } else {
    const _Some = _bind$10;
    const _x = _Some;
    const _cond_expr = _x._0;
    const _body_stmt = _x._1;
    const cond_ast = _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(_cond_expr);
    const cond_getline = _M0FP410Haoxincode8moonbash3lib8commands48awk__getline__target__from__condition__expr__ast(cond_ast);
    const _bind$11 = _M0FP410Haoxincode8moonbash3lib8commands26awk__split__if__else__body(_body_stmt);
    const _then_body = _bind$11._0;
    const _else_body = _bind$11._1;
    const then_ast = _M0FP410Haoxincode8moonbash3lib8commands23awk__parse__action__ast(_then_body);
    if (_else_body === undefined) {
      return new _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt2If(cond_ast, cond_getline, then_ast, _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib8commands7AwkStmtEE4None__);
    } else {
      const _Some$2 = _else_body;
      const _else_stmt = _Some$2;
      return new _M0DTP410Haoxincode8moonbash3lib8commands7AwkStmt2If(cond_ast, cond_getline, then_ast, new _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib8commands7AwkStmtEE4Some(_M0FP410Haoxincode8moonbash3lib8commands23awk__parse__action__ast(_else_stmt)));
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands31awk__function__param__is__array(fn_def, param) {
  const needle = `${param}[`;
  if (_M0FP410Haoxincode8moonbash3lib8commands27aj__find__substring_2einner(fn_def.body, needle, 0) >= 0) {
    return true;
  }
  return _M0FP410Haoxincode8moonbash3lib8commands27aj__find__substring_2einner(fn_def.body, ` in ${param}`, 0) >= 0;
}
function _M0FP410Haoxincode8moonbash3lib8commands18awk__get__function(vars, name) {
  _L: {
    const _bind$4 = _M0MPB3Map3getGssE(vars, `${_M0FP410Haoxincode8moonbash3lib8commands21awk__fn__body__prefix}${name}`);
    const _bind$5 = _M0MPB3Map3getGssE(vars, `${_M0FP410Haoxincode8moonbash3lib8commands23awk__fn__params__prefix}${name}`);
    if (_bind$4 === undefined) {
      break _L;
    } else {
      const _Some = _bind$4;
      const _body = _Some;
      if (_bind$5 === undefined) {
        break _L;
      } else {
        const _Some$2 = _bind$5;
        const _raw_params = _Some$2;
        const params = [];
        if (_raw_params.length > 0) {
          const pieces = _M0FP410Haoxincode8moonbash3lib8commands20aj__split__by__delim(_raw_params, ",");
          const _bind$6 = pieces.length;
          let _tmp$38 = 0;
          while (true) {
            const _ = _tmp$38;
            if (_ < _bind$6) {
              const piece = pieces[_];
              const p = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(piece);
              if (_M0FP410Haoxincode8moonbash3lib8commands19awk__is__identifier(p)) {
                _M0MPC15array5Array4pushGUssEE(params, p);
              }
              _tmp$38 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
        }
        return new _M0TP410Haoxincode8moonbash3lib8commands11AwkFunction(params, _body);
      }
    }
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib8commands30awk__find__regex__match__range(pattern_expr, input) {
  let pat = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(pattern_expr);
  if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(pat, "/") && (_M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(pat, "/") && pat.length >= 2)) {
    pat = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(pat, 1, pat.length - 1 | 0);
  }
  if (pat.length === 0) {
    return _M0FP410Haoxincode8moonbash3lib8commands30awk__find__regex__match__rangeN5tupleS9218;
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(pat, "^") && _M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(pat, "$")) {
    const inner = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(pat, 1, pat.length - 1 | 0);
    if (input === inner) {
      return { _0: 1, _1: inner.length };
    }
    return _M0FP410Haoxincode8moonbash3lib8commands30awk__find__regex__match__rangeN5tupleS9219;
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(pat, "^")) {
    const prefix = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(pat, 1, pat.length);
    if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(input, prefix)) {
      return { _0: 1, _1: prefix.length };
    }
    return _M0FP410Haoxincode8moonbash3lib8commands30awk__find__regex__match__rangeN5tupleS9220;
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(pat, "$")) {
    const suffix = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(pat, 0, pat.length - 1 | 0);
    if (_M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(input, suffix)) {
      return { _0: (input.length - suffix.length | 0) + 1 | 0, _1: suffix.length };
    }
    return _M0FP410Haoxincode8moonbash3lib8commands30awk__find__regex__match__rangeN5tupleS9221;
  }
  const idx = _M0FP410Haoxincode8moonbash3lib8commands27aj__find__substring_2einner(input, pat, 0);
  return idx >= 0 ? { _0: idx + 1 | 0, _1: pat.length } : _M0FP410Haoxincode8moonbash3lib8commands30awk__find__regex__match__rangeN5tupleS9222;
}
function _M0FP410Haoxincode8moonbash3lib8commands17awk__split__chars(input) {
  const parts = [];
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < input.length) {
      _M0MPC15array5Array4pushGUssEE(parts, _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(input, i, i + 1 | 0));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return parts;
}
function _M0FP410Haoxincode8moonbash3lib8commands31awk__split__for__split__builtin(source, delim) {
  const is_regex = _M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(delim, _M0FP410Haoxincode8moonbash3lib8commands25awk__regex__delim__prefix);
  const delim$2 = is_regex ? _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(delim, _M0FP410Haoxincode8moonbash3lib8commands25awk__regex__delim__prefix.length, delim.length) : delim;
  if (delim$2.length === 0) {
    return _M0FP410Haoxincode8moonbash3lib8commands17awk__split__chars(source);
  }
  if (delim$2 === " " && !is_regex) {
    return _M0FP410Haoxincode8moonbash3lib8commands18awk__split__fields(source, " ");
  }
  return _M0FP410Haoxincode8moonbash3lib8commands20aj__split__by__delim(source, delim$2);
}
function _M0FP410Haoxincode8moonbash3lib8commands14awk__to__lower(s) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      if (ch >= 65 && ch <= 90) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch + 32 | 0);
      } else {
        if (ch === 196) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 228);
        } else {
          if (ch === 214) {
            _M0IPB13StringBuilderPB6Logger11write__char(out, 246);
          } else {
            if (ch === 220) {
              _M0IPB13StringBuilderPB6Logger11write__char(out, 252);
            } else {
              _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
            }
          }
        }
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands26awk__match__regex__pattern(pattern_expr, line) {
  const p = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(pattern_expr);
  if (!_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(p, "/") || (!_M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(p, "/") || p.length < 2)) {
    return false;
  }
  const pat = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(p, 1, p.length - 1 | 0);
  if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(pat, "^") && _M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(pat, "$")) {
    return line === _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(pat, 1, pat.length - 1 | 0);
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(pat, "^")) {
    return _M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(line, _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(pat, 1, pat.length));
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(pat, "$")) {
    const suffix = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(pat, 0, pat.length - 1 | 0);
    return _M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(line, suffix);
  }
  return _M0FP410Haoxincode8moonbash3lib8commands27aj__find__substring_2einner(line, pat, 0) >= 0;
}
function _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(ast, line, fields, nr, nf, vars, array_vars) {
  let _tmp$38 = ast;
  _L: while (true) {
    const ast$2 = _tmp$38;
    switch (ast$2.$tag) {
      case 0: {
        const _Raw = ast$2;
        const _text = _Raw._0;
        return _M0FP410Haoxincode8moonbash3lib8commands25awk__eval__raw__expr__ast(_text, line, fields, nr, nf, vars, array_vars);
      }
      case 1: {
        const _Call = ast$2;
        const _call_name = _Call._0;
        const _args_ast = _Call._1;
        const _args_raw = _Call._2;
        return _M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__ast(_call_name, _args_ast, _args_raw, line, fields, nr, nf, vars, array_vars);
      }
      case 2: {
        const _Mutate = ast$2;
        const _target = _Mutate._0;
        const _delta = _Mutate._1;
        const _return_new = _Mutate._2;
        const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands31awk__mutate__numeric__reference(_target, _delta, _return_new, line, fields, nr, nf, vars, array_vars);
        if (_bind$4 === undefined) {
          return "";
        } else {
          const _Some = _bind$4;
          return _Some;
        }
      }
      case 3: {
        const _UnaryNot = ast$2;
        const _inner = _UnaryNot._0;
        const _p$4 = !_M0FP410Haoxincode8moonbash3lib8commands18awk__value__truthy(_M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_inner, line, fields, nr, nf, vars, array_vars));
        return _p$4 ? "1" : "0";
      }
      case 4: {
        const _Concat = ast$2;
        const _parts = _Concat._0;
        const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
        const _bind$5 = _parts.length;
        let _tmp$39 = 0;
        while (true) {
          const _ = _tmp$39;
          if (_ < _bind$5) {
            const part = _parts[_];
            _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(part, line, fields, nr, nf, vars, array_vars));
            _tmp$39 = _ + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        return out.val;
      }
      case 5: {
        const _Ternary = ast$2;
        const _cond_ast = _Ternary._0;
        const _yes = _Ternary._1;
        const _no = _Ternary._2;
        if (_M0FP410Haoxincode8moonbash3lib8commands25awk__eval__condition__ast(_cond_ast, line, fields, nr, nf, vars, array_vars)) {
          _tmp$38 = _yes;
          continue _L;
        } else {
          _tmp$38 = _no;
          continue _L;
        }
      }
      case 6: {
        const _Assign = ast$2;
        const _lhs = _Assign._0;
        const _rhs = _Assign._1;
        const value = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_rhs, line, fields, nr, nf, vars, array_vars);
        return _M0FP410Haoxincode8moonbash3lib8commands22awk__assign__reference(_lhs, value, line, fields, nr, nf, vars, array_vars) ? value : "";
      }
      case 7: {
        const _In = ast$2;
        const _left = _In._0;
        const _arr_name = _In._1;
        const idx_value = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_left, line, fields, nr, nf, vars, array_vars);
        const _p$5 = _M0MPB3Map8containsGssE(array_vars, _M0FP410Haoxincode8moonbash3lib8commands15awk__array__key(_arr_name, idx_value));
        return _p$5 ? "1" : "0";
      }
      default: {
        const _Binary = ast$2;
        const _op = _Binary._0;
        const _left$2 = _Binary._1;
        const _right = _Binary._2;
        if (_op === ",") {
          const left_value = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_left$2, line, fields, nr, nf, vars, array_vars);
          const right_value = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_right, line, fields, nr, nf, vars, array_vars);
          const _p$6 = _M0MPB3Map3getGssE(vars, "SUBSEP");
          const _p$7 = "\u001c";
          let subsep;
          if (_p$6 === undefined) {
            subsep = _p$7;
          } else {
            const _p$8 = _p$6;
            subsep = _p$8;
          }
          return `${left_value}${subsep}${right_value}`;
        }
        if (_op === "||") {
          const left_value = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_left$2, line, fields, nr, nf, vars, array_vars);
          if (_M0FP410Haoxincode8moonbash3lib8commands18awk__value__truthy(left_value)) {
            return "1";
          }
          const right_value = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_right, line, fields, nr, nf, vars, array_vars);
          const _p$6 = _M0FP410Haoxincode8moonbash3lib8commands18awk__value__truthy(right_value);
          return _p$6 ? "1" : "0";
        }
        if (_op === "&&") {
          const left_value = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_left$2, line, fields, nr, nf, vars, array_vars);
          if (!_M0FP410Haoxincode8moonbash3lib8commands18awk__value__truthy(left_value)) {
            return "0";
          }
          const right_value = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_right, line, fields, nr, nf, vars, array_vars);
          const _p$6 = _M0FP410Haoxincode8moonbash3lib8commands18awk__value__truthy(right_value);
          return _p$6 ? "1" : "0";
        }
        if (_op === "~" || _op === "!~") {
          const left_value = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_left$2, line, fields, nr, nf, vars, array_vars);
          let right_raw;
          if (_right.$tag === 0) {
            const _Raw$2 = _right;
            const _text$2 = _Raw$2._0;
            right_raw = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_text$2);
          } else {
            right_raw = "";
          }
          const pattern = right_raw.length >= 2 && (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(right_raw, "/") && _M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(right_raw, "/")) ? right_raw : `/${_M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_right, line, fields, nr, nf, vars, array_vars)}/`;
          const _bind$6 = _M0FP410Haoxincode8moonbash3lib8commands30awk__find__regex__match__range(pattern, left_value);
          const _rstart = _bind$6._0;
          let _tmp$40;
          if (_op === "~") {
            const _p$6 = _rstart > 0;
            _tmp$40 = _p$6 ? "1" : "0";
          } else {
            const _p$6 = _rstart <= 0;
            _tmp$40 = _p$6 ? "1" : "0";
          }
          return _tmp$40;
        }
        if (_op === "==" || (_op === "!=" || (_op === ">=" || (_op === "<=" || (_op === ">" || _op === "<"))))) {
          const left_value = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_left$2, line, fields, nr, nf, vars, array_vars);
          const right_value = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_right, line, fields, nr, nf, vars, array_vars);
          const _p$6 = _M0FP410Haoxincode8moonbash3lib8commands20awk__compare__values(left_value, right_value, _op);
          return _p$6 ? "1" : "0";
        }
        if (_op === "^") {
          const left_n = _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(_M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_left$2, line, fields, nr, nf, vars, array_vars));
          const right_n = _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(_M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_right, line, fields, nr, nf, vars, array_vars));
          return _M0FP410Haoxincode8moonbash3lib8commands23awk__number__to__string(_M0FPC14math3pow(left_n, right_n));
        }
        if (_op === "+" || _op === "-") {
          const left_n = _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(_M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_left$2, line, fields, nr, nf, vars, array_vars));
          const right_n = _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(_M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_right, line, fields, nr, nf, vars, array_vars));
          const value$2 = _op === "+" ? left_n + right_n : left_n - right_n;
          return _M0FP410Haoxincode8moonbash3lib8commands23awk__number__to__string(value$2);
        }
        if (_op === "*" || (_op === "/" || _op === "%")) {
          const left_n = _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(_M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_left$2, line, fields, nr, nf, vars, array_vars));
          const right_n = _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(_M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_right, line, fields, nr, nf, vars, array_vars));
          if (_op === "*") {
            return _M0FP410Haoxincode8moonbash3lib8commands23awk__number__to__string(left_n * right_n);
          }
          if (_op === "%") {
            if (right_n === 0) {
              return "0";
            }
            const left_i = _M0MPC16double6Double7to__int(left_n);
            const right_i = _M0MPC16double6Double7to__int(right_n);
            if (right_i === 0) {
              return "0";
            }
            return _M0MPC13int3Int18to__string_2einner(left_i % right_i | 0, 10);
          }
          if (right_n === 0) {
            return "0";
          }
          return String(left_n / right_n);
        }
        return "";
      }
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands22awk__assign__reference(target, value, line, fields, nr, nf, vars, array_vars) {
  if (_M0FP410Haoxincode8moonbash3lib8commands19awk__is__identifier(target)) {
    _M0MPB3Map3setGssE(vars, target, value);
    return true;
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands22awk__parse__array__ref(target);
  if (_bind$4 === undefined) {
    return false;
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _arr_name = _x._0;
    const _idx_expr = _x._1;
    const idx = _M0FP410Haoxincode8moonbash3lib8commands15awk__eval__expr(_idx_expr, line, fields, nr, nf, vars, array_vars);
    _M0MPB3Map3setGssE(array_vars, _M0FP410Haoxincode8moonbash3lib8commands15awk__array__key(_arr_name, idx), value);
    return true;
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands15awk__eval__expr(expr, line, fields, nr, nf, vars, array_vars) {
  const ast = _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(expr);
  return _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(ast, line, fields, nr, nf, vars, array_vars);
}
function _M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__astN9eval__argS725(_env, idx) {
  const nf = _env._6;
  const array_vars = _env._5;
  const nr = _env._4;
  const args_ast = _env._3;
  const line = _env._2;
  const vars = _env._1;
  const fields = _env._0;
  return idx >= 0 && idx < args_ast.length ? _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_M0MPC15array5Array2atGUssEE(args_ast, idx), line, fields, nr, nf, vars, array_vars) : "";
}
function _M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__astN17eval__arg__numberS727(_env, idx) {
  return _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(_M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__astN9eval__argS725(_env, idx));
}
function _M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__ast(call_name, args_ast, args_raw, line, fields, nr, nf, vars, array_vars) {
  const _env = { _0: fields, _1: vars, _2: line, _3: args_ast, _4: nr, _5: array_vars, _6: nf };
  if (call_name === "index") {
    if (args_ast.length < 2) {
      return "0";
    }
    const haystack = _M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__astN9eval__argS725(_env, 0);
    const needle = _M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__astN9eval__argS725(_env, 1);
    if (needle.length === 0) {
      return "1";
    }
    const idx = _M0FP410Haoxincode8moonbash3lib8commands27aj__find__substring_2einner(haystack, needle, 0);
    return idx >= 0 ? _M0MPC13int3Int18to__string_2einner(idx + 1 | 0, 10) : "0";
  }
  if (call_name === "substr") {
    if (args_ast.length < 2) {
      return "";
    }
    const text = _M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__astN9eval__argS725(_env, 0);
    const raw_start = _M0MPC16double6Double7to__int(_M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__astN17eval__arg__numberS727(_env, 1));
    const start_pos = raw_start <= 1 ? 1 : raw_start;
    const start_idx = start_pos - 1 | 0;
    if (start_idx >= text.length) {
      return "";
    }
    if (args_ast.length >= 3) {
      const len = _M0MPC16double6Double7to__int(_M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__astN17eval__arg__numberS727(_env, 2));
      if (len <= 0) {
        return "";
      }
      return _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, start_idx, start_idx + len | 0);
    }
    return _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, start_idx, text.length);
  }
  if (call_name === "tolower") {
    if (args_ast.length === 0) {
      return "";
    }
    return _M0FP410Haoxincode8moonbash3lib8commands14awk__to__lower(_M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__astN9eval__argS725(_env, 0));
  }
  if (call_name === "toupper") {
    if (args_ast.length === 0) {
      return "";
    }
    return _M0FP410Haoxincode8moonbash3lib8commands14awk__to__upper(_M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__astN9eval__argS725(_env, 0));
  }
  if (call_name === "close") {
    return "0";
  }
  if (call_name === "sin") {
    const value = args_ast.length > 0 ? _M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__astN17eval__arg__numberS727(_env, 0) : 0;
    return _M0FP410Haoxincode8moonbash3lib8commands23awk__number__to__string(_M0FPC14math3sin(value));
  }
  if (call_name === "cos") {
    const value = args_ast.length > 0 ? _M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__astN17eval__arg__numberS727(_env, 0) : 0;
    return _M0FP410Haoxincode8moonbash3lib8commands23awk__number__to__string(_M0FPC14math3cos(value));
  }
  if (call_name === "exp") {
    const value = args_ast.length > 0 ? _M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__astN17eval__arg__numberS727(_env, 0) : 0;
    return _M0FP410Haoxincode8moonbash3lib8commands23awk__number__to__string(_M0FPC14math3exp(value));
  }
  if (call_name === "log") {
    const value = args_ast.length > 0 ? _M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__astN17eval__arg__numberS727(_env, 0) : 0;
    return _M0FP410Haoxincode8moonbash3lib8commands23awk__number__to__string(_M0FPC14math2ln(value));
  }
  if (call_name === "sqrt") {
    const value = args_ast.length > 0 ? _M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__astN17eval__arg__numberS727(_env, 0) : 0;
    return _M0FP410Haoxincode8moonbash3lib8commands23awk__number__to__string(Math.sqrt(value));
  }
  if (call_name === "atan2") {
    if (args_ast.length < 2) {
      return "0";
    }
    const y = _M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__astN17eval__arg__numberS727(_env, 0);
    const x = _M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__astN17eval__arg__numberS727(_env, 1);
    const pi = _M0FPC14math4atan(1) * 4;
    const half_pi = pi / 2;
    const angle = x > 0 ? _M0FPC14math4atan(y / x) : x < 0 && y >= 0 ? _M0FPC14math4atan(y / x) + pi : x < 0 ? _M0FPC14math4atan(y / x) - pi : y > 0 ? half_pi : y < 0 ? -half_pi : 0;
    return _M0FP410Haoxincode8moonbash3lib8commands23awk__number__to__string(angle);
  }
  if (call_name === "sprintf") {
    if (args_ast.length === 0) {
      return "";
    }
    const format = _M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__astN9eval__argS725(_env, 0);
    const format_args = [];
    let _tmp$38 = 1;
    while (true) {
      const i = _tmp$38;
      if (i < args_ast.length) {
        _M0MPC15array5Array4pushGUssEE(format_args, _M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__astN9eval__argS725(_env, i));
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return _M0FP410Haoxincode8moonbash3lib8commands19awk__format__printf(format, format_args);
  }
  if (call_name === "split") {
    if (args_raw.length >= 2 && args_ast.length >= 1) {
      const source = _M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__astN9eval__argS725(_env, 0);
      const arr_name = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0MPC15array5Array2atGUssEE(args_raw, 1));
      let delim;
      if (args_raw.length >= 3) {
        delim = _M0FP410Haoxincode8moonbash3lib8commands23awk__eval__split__delim(_M0MPC15array5Array2atGUssEE(args_raw, 2), line, fields, nr, nf, vars, array_vars);
      } else {
        const _p$4 = _M0MPB3Map3getGssE(vars, "FS");
        const _p$5 = " ";
        let _tmp$38;
        if (_p$4 === undefined) {
          _tmp$38 = _p$5;
        } else {
          const _p$6 = _p$4;
          _tmp$38 = _p$6;
        }
        delim = _M0FP410Haoxincode8moonbash3lib8commands16awk__current__fs(_tmp$38, vars);
      }
      const pieces = _M0FP410Haoxincode8moonbash3lib8commands31awk__split__for__split__builtin(source, delim);
      let _tmp$38 = 0;
      while (true) {
        const i = _tmp$38;
        if (i < pieces.length) {
          _M0MPB3Map3setGssE(array_vars, _M0FP410Haoxincode8moonbash3lib8commands15awk__array__key(arr_name, _M0MPC13int3Int18to__string_2einner(i + 1 | 0, 10)), _M0MPC15array5Array2atGUssEE(pieces, i));
          _tmp$38 = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      _M0MPB3Map3setGssE(vars, arr_name, _M0MPC13int3Int18to__string_2einner(pieces.length, 10));
      return _M0MPC13int3Int18to__string_2einner(pieces.length, 10);
    }
    return "0";
  }
  if (call_name === "match") {
    if (args_raw.length < 2 || args_ast.length < 2) {
      _M0MPB3Map3setGssE(vars, "RSTART", "0");
      _M0MPB3Map3setGssE(vars, "RLENGTH", "-1");
      return "0";
    }
    const source = _M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__astN9eval__argS725(_env, 0);
    const pattern_expr = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0MPC15array5Array2atGUssEE(args_raw, 1));
    const pattern = _M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(pattern_expr, "/") && _M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(pattern_expr, "/") ? pattern_expr : _M0FP410Haoxincode8moonbash3lib8commands26awk__eval__call__expr__astN9eval__argS725(_env, 1);
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands30awk__find__regex__match__range(pattern, source);
    const _rstart = _bind$4._0;
    const _rlength = _bind$4._1;
    _M0MPB3Map3setGssE(vars, "RSTART", _M0MPC13int3Int18to__string_2einner(_rstart, 10));
    _M0MPB3Map3setGssE(vars, "RLENGTH", _M0MPC13int3Int18to__string_2einner(_rlength, 10));
    return _M0MPC13int3Int18to__string_2einner(_rstart, 10);
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands18awk__get__function(vars, call_name);
  if (_bind$4 === undefined) {
    return "";
  } else {
    const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands22awk__expr__eval__state.out;
    if (_bind$5 === undefined) {
      const fn_out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
      return _M0FP410Haoxincode8moonbash3lib8commands25awk__eval__user__function(call_name, args_raw, line, fields, nr, nf, vars, array_vars, fn_out);
    } else {
      const _Some = _bind$5;
      const _active_out = _Some;
      return _M0FP410Haoxincode8moonbash3lib8commands25awk__eval__user__function(call_name, args_raw, line, fields, nr, nf, vars, array_vars, _active_out);
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands23awk__eval__split__delim(expr, line, fields, nr, nf, vars, array_vars) {
  const text = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(expr);
  if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(text, "/") && (_M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(text, "/") && text.length >= 2)) {
    return `${_M0FP410Haoxincode8moonbash3lib8commands25awk__regex__delim__prefix}${_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, 1, text.length - 1 | 0)}`;
  }
  return _M0FP410Haoxincode8moonbash3lib8commands15awk__eval__expr(text, line, fields, nr, nf, vars, array_vars);
}
function _M0FP410Haoxincode8moonbash3lib8commands25awk__eval__user__function(fn_name, arg_exprs, line, fields, nr, nf, vars, array_vars, out) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands18awk__get__function(vars, fn_name);
  let fn_def;
  if (_bind$4 === undefined) {
    return "";
  } else {
    const _Some = _bind$4;
    fn_def = _Some;
  }
  const saved_scalars = [];
  const array_bindings = [];
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < fn_def.params.length) {
      const param = _M0MPC15array5Array2atGUssEE(fn_def.params, i);
      _M0MPC15array5Array4pushGUssEE(saved_scalars, { _0: param, _1: _M0MPB3Map3getGssE(vars, param) });
      if (i < arg_exprs.length) {
        const arg_expr = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0MPC15array5Array2atGUssEE(arg_exprs, i));
        if (_M0FP410Haoxincode8moonbash3lib8commands19awk__is__identifier(arg_expr) && _M0FP410Haoxincode8moonbash3lib8commands31awk__function__param__is__array(fn_def, param)) {
          _M0MPC15array5Array4pushGUssEE(array_bindings, { _0: param, _1: arg_expr });
          _M0FP410Haoxincode8moonbash3lib8commands27awk__copy__array__namespace(array_vars, arg_expr, param);
          _M0MPB3Map3setGssE(vars, param, "");
        } else {
          _M0MPB3Map3setGssE(vars, param, _M0FP410Haoxincode8moonbash3lib8commands15awk__eval__expr(arg_expr, line, fields, nr, fields.length, vars, array_vars));
        }
      } else {
        _M0MPB3Map3setGssE(vars, param, "");
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MPB3Map6removeGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands22awk__ctrl__return__key);
  _M0MPB3Map6removeGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands29awk__ctrl__return__value__key);
  _M0FP410Haoxincode8moonbash3lib8commands28awk__execute__function__body(fn_def.body, line, fields, nr, vars, array_vars, out);
  const _p$4 = _M0MPB3Map3getGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands29awk__ctrl__return__value__key);
  const _p$5 = "";
  let return_value;
  if (_p$4 === undefined) {
    return_value = _p$5;
  } else {
    const _p$6 = _p$4;
    return_value = _p$6;
  }
  _M0MPB3Map6removeGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands22awk__ctrl__return__key);
  _M0MPB3Map6removeGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands29awk__ctrl__return__value__key);
  const _bind$5 = array_bindings.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$5) {
      const binding = array_bindings[_];
      const local_name = binding._0;
      const actual_name = binding._1;
      _M0FP410Haoxincode8moonbash3lib8commands29awk__remove__array__namespace(array_vars, actual_name);
      _M0FP410Haoxincode8moonbash3lib8commands27awk__copy__array__namespace(array_vars, local_name, actual_name);
      _M0FP410Haoxincode8moonbash3lib8commands29awk__remove__array__namespace(array_vars, local_name);
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$6 = saved_scalars.length;
  let _tmp$40 = 0;
  while (true) {
    const _ = _tmp$40;
    if (_ < _bind$6) {
      const saved = saved_scalars[_];
      const _bind$7 = saved._1;
      if (_bind$7 === undefined) {
        _M0MPB3Map6removeGssE(vars, saved._0);
      } else {
        const _Some = _bind$7;
        const _v = _Some;
        _M0MPB3Map3setGssE(vars, saved._0, _v);
      }
      _tmp$40 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return return_value;
}
function _M0FP410Haoxincode8moonbash3lib8commands28awk__execute__function__body(body, line, fields, nr, vars, array_vars, out) {
  const statements = _M0FP410Haoxincode8moonbash3lib8commands23awk__parse__action__ast(body);
  _M0FP410Haoxincode8moonbash3lib8commands34awk__execute__function__statements(statements, line, fields, nr, vars, array_vars, out);
}
function _M0FP410Haoxincode8moonbash3lib8commands34awk__execute__function__statements(statements, line, fields, nr, vars, array_vars, out) {
  const _bind$4 = statements.length;
  let _tmp$38 = 0;
  _L: while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const stmt = statements[_];
      if (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key) || (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__next__key) || _M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands22awk__ctrl__return__key))) {
        return;
      }
      switch (stmt.$tag) {
        case 4: {
          _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__next__key, "1");
          return;
        }
        case 5: {
          const _Exit = stmt;
          const _code_ast = _Exit._0;
          let code;
          if (_code_ast === undefined) {
            code = 0;
          } else {
            const _Some = _code_ast;
            const _expr_ast = _Some;
            code = _M0MPC16double6Double7to__int(_M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(_M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_expr_ast, line, fields, nr, fields.length, vars, array_vars)));
          }
          _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key, _M0MPC13int3Int18to__string_2einner(code, 10));
          return;
        }
        case 6: {
          const _Return = stmt;
          const _value_ast = _Return._0;
          let value;
          if (_value_ast === undefined) {
            value = "";
          } else {
            const _Some = _value_ast;
            const _expr_ast = _Some;
            value = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_expr_ast, line, fields, nr, fields.length, vars, array_vars);
          }
          _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands22awk__ctrl__return__key, "1");
          _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands29awk__ctrl__return__value__key, value);
          return;
        }
        case 10: {
          const _PipeGetline = stmt;
          const _cmd_ast = _PipeGetline._0;
          const _target = _PipeGetline._1;
          const command = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_cmd_ast, line, fields, nr, fields.length, vars, array_vars);
          const line_from_cmd = _M0FP410Haoxincode8moonbash3lib8commands33awk__eval__getline__command__line(command);
          _M0FP410Haoxincode8moonbash3lib8commands42awk__apply__getline__target__for__function(_target, line_from_cmd, line, fields, nr, vars, array_vars);
          break;
        }
        case 11: {
          const _Getline = stmt;
          const _target$2 = _Getline._0;
          const _path_ast = _Getline._1;
          if (_path_ast === undefined) {
            _M0FP410Haoxincode8moonbash3lib8commands42awk__apply__getline__target__for__function(_target$2, line, line, fields, nr, vars, array_vars);
          } else {
            _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands21awk__ctrl__error__key, "getline < file is not supported in function context");
            _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key, "1");
            return;
          }
          break;
        }
        case 12: {
          _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands21awk__ctrl__error__key, "system() is not supported");
          _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key, "1");
          return;
        }
        case 13: {
          const _SubstituteStmt = stmt;
          const _is_gsub = _SubstituteStmt._0;
          const _args_ast = _SubstituteStmt._1;
          if (_args_ast.length >= 2) {
            const pattern = _M0FP410Haoxincode8moonbash3lib8commands28awk__eval__sub__pattern__ast(_M0MPC15array5Array2atGUssEE(_args_ast, 0), line, fields, nr, fields.length, vars, array_vars);
            const replacement = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_M0MPC15array5Array2atGUssEE(_args_ast, 1), line, fields, nr, fields.length, vars, array_vars);
            if (_args_ast.length >= 3) {
              const _bind$5 = _M0MPC15array5Array2atGUssEE(_args_ast, 2);
              if (_bind$5.$tag === 0) {
                const _Raw = _bind$5;
                const _raw_target = _Raw._0;
                const target = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_raw_target);
                const source = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_M0MPC15array5Array2atGUssEE(_args_ast, 2), line, fields, nr, fields.length, vars, array_vars);
                const _bind$6 = _is_gsub ? _M0FP410Haoxincode8moonbash3lib8commands26awk__replace__all__literal(source, pattern, replacement) : _M0FP410Haoxincode8moonbash3lib8commands28awk__replace__first__literal(source, pattern, replacement);
                const _updated = _bind$6._0;
                _M0FP410Haoxincode8moonbash3lib8commands22awk__assign__reference(target, _updated, line, fields, nr, fields.length, vars, array_vars);
              }
            } else {
              const _bind$5 = _is_gsub ? _M0FP410Haoxincode8moonbash3lib8commands26awk__replace__all__literal(line, pattern, replacement) : _M0FP410Haoxincode8moonbash3lib8commands28awk__replace__first__literal(line, pattern, replacement);
              const _updated = _bind$5._0;
              _M0FP410Haoxincode8moonbash3lib8commands46awk__sync__fields__from__record__for__function(_updated, fields, vars);
            }
          }
          break;
        }
        case 17: {
          const _ExprStmt = stmt;
          const _expr_ast = _ExprStmt._0;
          _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_expr_ast, line, fields, nr, fields.length, vars, array_vars);
          break;
        }
        case 16: {
          const _CompoundAssignStmt = stmt;
          const _lhs_target = _CompoundAssignStmt._0;
          const _op = _CompoundAssignStmt._1;
          const _rhs_ast = _CompoundAssignStmt._2;
          const right = _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(_M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_rhs_ast, line, fields, nr, fields.length, vars, array_vars));
          if (_lhs_target.$tag === 0) {
            const _Var = _lhs_target;
            const _name = _Var._0;
            const _p$4 = _M0MPB3Map3getGssE(vars, _name);
            const _p$5 = "";
            let _tmp$39;
            if (_p$4 === undefined) {
              _tmp$39 = _p$5;
            } else {
              const _p$6 = _p$4;
              _tmp$39 = _p$6;
            }
            const left = _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(_tmp$39);
            let value$2;
            switch (_op) {
              case "+=": {
                value$2 = left + right;
                break;
              }
              case "-=": {
                value$2 = left - right;
                break;
              }
              case "*=": {
                value$2 = left * right;
                break;
              }
              case "/=": {
                value$2 = right === 0 ? 0 : left / right;
                break;
              }
              default: {
                value$2 = left;
              }
            }
            _M0MPB3Map3setGssE(vars, _name, _M0FP410Haoxincode8moonbash3lib8commands23awk__number__to__string(value$2));
          } else {
            const _ArrayElem = _lhs_target;
            const _arr_name = _ArrayElem._0;
            const _idx_ast = _ArrayElem._1;
            const idx = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_idx_ast, line, fields, nr, fields.length, vars, array_vars);
            const key = _M0FP410Haoxincode8moonbash3lib8commands15awk__array__key(_arr_name, idx);
            const _p$4 = _M0MPB3Map3getGssE(array_vars, key);
            const _p$5 = "";
            let _tmp$39;
            if (_p$4 === undefined) {
              _tmp$39 = _p$5;
            } else {
              const _p$6 = _p$4;
              _tmp$39 = _p$6;
            }
            const left = _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(_tmp$39);
            let value$2;
            switch (_op) {
              case "+=": {
                value$2 = left + right;
                break;
              }
              case "-=": {
                value$2 = left - right;
                break;
              }
              case "*=": {
                value$2 = left * right;
                break;
              }
              case "/=": {
                value$2 = right === 0 ? 0 : left / right;
                break;
              }
              default: {
                value$2 = left;
              }
            }
            _M0MPB3Map3setGssE(array_vars, key, _M0FP410Haoxincode8moonbash3lib8commands23awk__number__to__string(value$2));
          }
          break;
        }
        case 15: {
          const _AssignStmt = stmt;
          const _lhs_target$2 = _AssignStmt._0;
          const _rhs_ast$2 = _AssignStmt._1;
          const value$2 = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_rhs_ast$2, line, fields, nr, fields.length, vars, array_vars);
          if (_lhs_target$2.$tag === 0) {
            const _Var = _lhs_target$2;
            const _name = _Var._0;
            _M0MPB3Map3setGssE(vars, _name, value$2);
          } else {
            const _ArrayElem = _lhs_target$2;
            const _arr_name = _ArrayElem._0;
            const _idx_ast = _ArrayElem._1;
            const idx = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_idx_ast, line, fields, nr, fields.length, vars, array_vars);
            _M0MPB3Map3setGssE(array_vars, _M0FP410Haoxincode8moonbash3lib8commands15awk__array__key(_arr_name, idx), value$2);
          }
          break;
        }
        case 14: {
          const _FieldAssignStmt = stmt;
          const _idx_ast = _FieldAssignStmt._0;
          const _rhs_ast$3 = _FieldAssignStmt._1;
          const value$3 = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_rhs_ast$3, line, fields, nr, fields.length, vars, array_vars);
          const field_idx = _M0MPC16double6Double7to__int(_M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(_M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_idx_ast, line, fields, nr, fields.length, vars, array_vars)));
          if (field_idx === 0) {
            _M0FP410Haoxincode8moonbash3lib8commands46awk__sync__fields__from__record__for__function(value$3, fields, vars);
          } else {
            if (field_idx > 0) {
              while (true) {
                if (fields.length < field_idx) {
                  _M0MPC15array5Array4pushGUssEE(fields, "");
                  continue;
                } else {
                  break;
                }
              }
              _M0MPC15array5Array3setGsE(fields, field_idx - 1 | 0, value$3);
              _M0MPB3Map3setGssE(vars, "NF", _M0MPC13int3Int18to__string_2einner(fields.length, 10));
            }
          }
          break;
        }
        case 9: {
          const _Delete = stmt;
          const _arr_name = _Delete._0;
          const _idx_ast$2 = _Delete._1;
          if (_idx_ast$2 === undefined) {
            _M0FP410Haoxincode8moonbash3lib8commands29awk__remove__array__namespace(array_vars, _arr_name);
          } else {
            const _Some = _idx_ast$2;
            const _expr_ast$2 = _Some;
            const idx = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_expr_ast$2, line, fields, nr, fields.length, vars, array_vars);
            _M0MPB3Map6removeGssE(array_vars, _M0FP410Haoxincode8moonbash3lib8commands15awk__array__key(_arr_name, idx));
          }
          break;
        }
        case 7: {
          const _Printf = stmt;
          const _fmt_ast = _Printf._0;
          const _arg_asts = _Printf._1;
          const fmt_value = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_fmt_ast, line, fields, nr, fields.length, vars, array_vars);
          const fmt_args = [];
          const _bind$5 = _arg_asts.length;
          let _tmp$39 = 0;
          while (true) {
            const _$2 = _tmp$39;
            if (_$2 < _bind$5) {
              const arg_ast = _arg_asts[_$2];
              _M0MPC15array5Array4pushGUssEE(fmt_args, _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(arg_ast, line, fields, nr, fields.length, vars, array_vars));
              _tmp$39 = _$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands19awk__format__printf(fmt_value, fmt_args));
          break;
        }
        case 8: {
          const _Print = stmt;
          const _value_asts = _Print._0;
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands31awk__render__print__output__ast(_value_asts, line, fields, nr, vars, array_vars));
          break;
        }
        case 2: {
          const _ForIn = stmt;
          const _loop_var = _ForIn._0;
          const _arr_name$2 = _ForIn._1;
          const _body_stmts = _ForIn._2;
          const key_prefix = `${_arr_name$2}#`;
          const indices = [];
          const _it = _M0MPB3Map5iter2GssE(array_vars);
          while (true) {
            const _bind$6 = _M0MPB5Iter24nextGssE(_it);
            if (_bind$6 === undefined) {
              break;
            } else {
              const _Some = _bind$6;
              const _x = _Some;
              const _key = _x._0;
              if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(_key, key_prefix)) {
                _M0MPC15array5Array4pushGUssEE(indices, _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(_key, key_prefix.length, _key.length));
              }
              continue;
            }
          }
          const _bind$6 = indices.length;
          let _tmp$40 = 0;
          while (true) {
            const _$2 = _tmp$40;
            if (_$2 < _bind$6) {
              const idx_value = indices[_$2];
              if (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key) || (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__next__key) || _M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands22awk__ctrl__return__key))) {
                break;
              }
              _M0MPB3Map3setGssE(vars, _loop_var, idx_value);
              if (_body_stmts.length > 0) {
                _M0FP410Haoxincode8moonbash3lib8commands34awk__execute__function__statements(_body_stmts, line, fields, nr, vars, array_vars, out);
              }
              _tmp$40 = _$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          break;
        }
        case 1: {
          const _For = stmt;
          const _init_stmts = _For._0;
          const _cond_ast = _For._1;
          const _update_stmts = _For._3;
          const _body_stmts$2 = _For._4;
          if (_init_stmts.length > 0) {
            _M0FP410Haoxincode8moonbash3lib8commands34awk__execute__function__statements(_init_stmts, line, fields, nr, vars, array_vars, out);
          }
          let loop_count = 0;
          while (true) {
            if (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key) || (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__next__key) || _M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands22awk__ctrl__return__key))) {
              break;
            }
            if (_cond_ast === undefined) {
            } else {
              const _Some = _cond_ast;
              const _cond_expr_ast = _Some;
              if (!_M0FP410Haoxincode8moonbash3lib8commands25awk__eval__condition__ast(_cond_expr_ast, line, fields, nr, fields.length, vars, array_vars)) {
                break;
              }
            }
            if (_body_stmts$2.length > 0) {
              _M0FP410Haoxincode8moonbash3lib8commands34awk__execute__function__statements(_body_stmts$2, line, fields, nr, vars, array_vars, out);
            }
            if (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key) || (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__next__key) || _M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands22awk__ctrl__return__key))) {
              break;
            }
            if (_update_stmts.length > 0) {
              _M0FP410Haoxincode8moonbash3lib8commands34awk__execute__function__statements(_update_stmts, line, fields, nr, vars, array_vars, out);
            }
            loop_count = loop_count + 1 | 0;
            if (loop_count > 10000) {
              break;
            }
            continue;
          }
          break;
        }
        case 3: {
          const _While = stmt;
          const _cond_ast$2 = _While._0;
          const _body_stmts$3 = _While._2;
          let loop_count$2 = 0;
          while (true) {
            if (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key) || (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__next__key) || _M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands22awk__ctrl__return__key))) {
              break;
            }
            if (!_M0FP410Haoxincode8moonbash3lib8commands25awk__eval__condition__ast(_cond_ast$2, line, fields, nr, fields.length, vars, array_vars)) {
              break;
            }
            if (_body_stmts$3.length > 0) {
              _M0FP410Haoxincode8moonbash3lib8commands34awk__execute__function__statements(_body_stmts$3, line, fields, nr, vars, array_vars, out);
            }
            if (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key) || (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__next__key) || _M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands22awk__ctrl__return__key))) {
              break;
            }
            loop_count$2 = loop_count$2 + 1 | 0;
            if (loop_count$2 > 10000) {
              break;
            }
            continue;
          }
          break;
        }
        default: {
          const _If = stmt;
          const _cond_ast$3 = _If._0;
          const _then_stmts = _If._2;
          const _else_stmts = _If._3;
          if (_M0FP410Haoxincode8moonbash3lib8commands25awk__eval__condition__ast(_cond_ast$3, line, fields, nr, fields.length, vars, array_vars)) {
            _M0FP410Haoxincode8moonbash3lib8commands34awk__execute__function__statements(_then_stmts, line, fields, nr, vars, array_vars, out);
          } else {
            if (_else_stmts.$tag === 1) {
              const _Some = _else_stmts;
              const _else_branch = _Some._0;
              _M0FP410Haoxincode8moonbash3lib8commands34awk__execute__function__statements(_else_branch, line, fields, nr, vars, array_vars, out);
            }
          }
        }
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands42awk__apply__getline__target__for__function(target, line_value, line, fields, nr, vars, array_vars) {
  switch (target.$tag) {
    case 1: {
      const _Var = target;
      const _name = _Var._0;
      _M0MPB3Map3setGssE(vars, _name, line_value);
      return;
    }
    case 0: {
      _M0FP410Haoxincode8moonbash3lib8commands46awk__sync__fields__from__record__for__function(line_value, fields, vars);
      return;
    }
    case 2: {
      const _Field = target;
      const _key_ast = _Field._0;
      const key_value = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_key_ast, line, fields, nr, fields.length, vars, array_vars);
      const field_idx = _M0MPC16double6Double7to__int(_M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(key_value));
      if (field_idx === 0) {
        _M0FP410Haoxincode8moonbash3lib8commands46awk__sync__fields__from__record__for__function(line_value, fields, vars);
        return;
      } else {
        if (field_idx > 0) {
          while (true) {
            if (fields.length < field_idx) {
              _M0MPC15array5Array4pushGUssEE(fields, "");
              continue;
            } else {
              break;
            }
          }
          _M0MPC15array5Array3setGsE(fields, field_idx - 1 | 0, line_value);
          _M0MPB3Map3setGssE(vars, "NF", _M0MPC13int3Int18to__string_2einner(fields.length, 10));
          return;
        } else {
          return;
        }
      }
    }
    case 3: {
      const _ArrayElem = target;
      const _arr_name = _ArrayElem._0;
      const _idx_ast = _ArrayElem._1;
      const idx = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_idx_ast, line, fields, nr, fields.length, vars, array_vars);
      _M0MPB3Map3setGssE(array_vars, _M0FP410Haoxincode8moonbash3lib8commands15awk__array__key(_arr_name, idx), line_value);
      return;
    }
    default: {
      const _Invalid = target;
      const _raw_target = _Invalid._0;
      _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands21awk__ctrl__error__key, `invalid getline target: ${_raw_target}`);
      _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key, "1");
      return;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands25awk__eval__condition__ast(cond_ast, line, fields, nr, nf, vars, array_vars) {
  return _M0FP410Haoxincode8moonbash3lib8commands18awk__value__truthy(_M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(cond_ast, line, fields, nr, nf, vars, array_vars));
}
function _M0FP410Haoxincode8moonbash3lib8commands28awk__eval__sub__pattern__ast(expr_ast, line, fields, nr, nf, vars, array_vars) {
  if (expr_ast.$tag === 0) {
    const _Raw = expr_ast;
    const _text = _Raw._0;
    const raw = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_text);
    if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(raw, "/") && (_M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(raw, "/") && raw.length >= 2)) {
      return _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(raw, 1, raw.length - 1 | 0);
    }
    return _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(expr_ast, line, fields, nr, nf, vars, array_vars);
  } else {
    return _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(expr_ast, line, fields, nr, nf, vars, array_vars);
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands31awk__render__print__output__ast(expr_asts, line, fields, nr, vars, array_vars) {
  if (expr_asts.length === 0) {
    return `${line}\n`;
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < expr_asts.length) {
      if (i > 0) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 32);
      }
      const value = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_M0MPC15array5Array2atGUssEE(expr_asts, i), line, fields, nr, fields.length, vars, array_vars);
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands33awk__apply__ofmt__if__needed__ast(_M0MPC15array5Array2atGUssEE(expr_asts, i), value, vars));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands25awk__eval__raw__expr__ast(text, line, fields, nr, nf, vars, array_vars) {
  const t = _M0FP410Haoxincode8moonbash3lib8commands25awk__strip__outer__parens(_M0FP410Haoxincode8moonbash3lib8commands8aj__trim(text));
  if (t.length === 0) {
    return "";
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(t, "/") && (_M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(t, "/") && t.length >= 2)) {
    const _p$4 = _M0FP410Haoxincode8moonbash3lib8commands26awk__match__regex__pattern(t, line);
    return _p$4 ? "1" : "0";
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(t, "\"") && _M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(t, "\"") || _M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(t, "'") && _M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(t, "'")) {
    return _M0FP410Haoxincode8moonbash3lib8commands15awk__eval__atom(t, line, fields, nr, nf, vars, array_vars);
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands24awk__is__numeric__string(t) || (_M0FP410Haoxincode8moonbash3lib8commands19awk__is__identifier(t) || _M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(t, "$"))) {
    return _M0FP410Haoxincode8moonbash3lib8commands15awk__eval__atom(t, line, fields, nr, nf, vars, array_vars);
  }
  return _M0FP410Haoxincode8moonbash3lib8commands15awk__eval__atom(t, line, fields, nr, nf, vars, array_vars);
}
function _M0FP410Haoxincode8moonbash3lib8commands15awk__eval__atom(atom, line, fields, nr, nf, vars, array_vars) {
  const t = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(atom);
  if (t.length === 0) {
    return "";
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(t, "\"") && _M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(t, "\"") || _M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(t, "'") && _M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(t, "'")) {
    return _M0FP410Haoxincode8moonbash3lib8commands22aj__decode__c__escapes(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 1, t.length - 1 | 0));
  }
  if (t === "NR") {
    const _p$4 = _M0MPB3Map3getGssE(vars, "NR");
    const _p$5 = _M0MPC13int3Int18to__string_2einner(nr, 10);
    let _tmp$38;
    if (_p$4 === undefined) {
      _tmp$38 = _p$5;
    } else {
      const _p$6 = _p$4;
      _tmp$38 = _p$6;
    }
    return _tmp$38;
  }
  if (t === "NF") {
    const _p$4 = _M0MPB3Map3getGssE(vars, "NF");
    const _p$5 = _M0MPC13int3Int18to__string_2einner(nf, 10);
    let _tmp$38;
    if (_p$4 === undefined) {
      _tmp$38 = _p$5;
    } else {
      const _p$6 = _p$4;
      _tmp$38 = _p$6;
    }
    return _tmp$38;
  }
  if (t === "FNR") {
    const _p$4 = _M0MPB3Map3getGssE(vars, "FNR");
    const _p$5 = _M0MPC13int3Int18to__string_2einner(nr, 10);
    let _tmp$38;
    if (_p$4 === undefined) {
      _tmp$38 = _p$5;
    } else {
      const _p$6 = _p$4;
      _tmp$38 = _p$6;
    }
    return _tmp$38;
  }
  if (t === "FILENAME") {
    const _p$4 = _M0MPB3Map3getGssE(vars, "FILENAME");
    const _p$5 = "";
    let _tmp$38;
    if (_p$4 === undefined) {
      _tmp$38 = _p$5;
    } else {
      const _p$6 = _p$4;
      _tmp$38 = _p$6;
    }
    return _tmp$38;
  }
  if (t === "RSTART") {
    const _p$4 = _M0MPB3Map3getGssE(vars, "RSTART");
    const _p$5 = "0";
    let _tmp$38;
    if (_p$4 === undefined) {
      _tmp$38 = _p$5;
    } else {
      const _p$6 = _p$4;
      _tmp$38 = _p$6;
    }
    return _tmp$38;
  }
  if (t === "RLENGTH") {
    const _p$4 = _M0MPB3Map3getGssE(vars, "RLENGTH");
    const _p$5 = "-1";
    let _tmp$38;
    if (_p$4 === undefined) {
      _tmp$38 = _p$5;
    } else {
      const _p$6 = _p$4;
      _tmp$38 = _p$6;
    }
    return _tmp$38;
  }
  if (t === "FS") {
    const _p$4 = _M0MPB3Map3getGssE(vars, "FS");
    const _p$5 = "";
    let _tmp$38;
    if (_p$4 === undefined) {
      _tmp$38 = _p$5;
    } else {
      const _p$6 = _p$4;
      _tmp$38 = _p$6;
    }
    return _tmp$38;
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(t, "$")) {
    const key_expr = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(t, 1, t.length);
    if (key_expr === "0") {
      return line;
    }
    const key_value = key_expr === "NF" ? _M0MPC13int3Int18to__string_2einner(fields.length, 10) : _M0FP410Haoxincode8moonbash3lib8commands24awk__is__numeric__string(key_expr) ? _M0FP410Haoxincode8moonbash3lib8commands23awk__number__to__string(_M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(key_expr)) : _M0FP410Haoxincode8moonbash3lib8commands15awk__eval__expr(key_expr, line, fields, nr, nf, vars, array_vars);
    if (key_value === "NF") {
      return fields.length === 0 ? "" : _M0MPC15array5Array2atGUssEE(fields, fields.length - 1 | 0);
    } else {
      const idx = _M0MPC16double6Double7to__int(_M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(key_value));
      if (idx >= 1 && idx <= fields.length) {
        return _M0MPC15array5Array2atGUssEE(fields, idx - 1 | 0);
      } else {
        return "";
      }
    }
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands22awk__parse__array__ref(t);
  if (_bind$4 === undefined) {
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _arr_name = _x._0;
    const _idx_expr = _x._1;
    const idx = _M0FP410Haoxincode8moonbash3lib8commands15awk__eval__expr(_idx_expr, line, fields, nr, nf, vars, array_vars);
    const _p$4 = _M0MPB3Map3getGssE(array_vars, _M0FP410Haoxincode8moonbash3lib8commands15awk__array__key(_arr_name, idx));
    const _p$5 = "";
    let _tmp$38;
    if (_p$4 === undefined) {
      _tmp$38 = _p$5;
    } else {
      const _p$6 = _p$4;
      _tmp$38 = _p$6;
    }
    return _tmp$38;
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands24awk__is__numeric__string(t)) {
    return t;
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands19awk__is__identifier(t)) {
    const _p$4 = _M0MPB3Map3getGssE(vars, t);
    const _p$5 = "";
    let _tmp$38;
    if (_p$4 === undefined) {
      _tmp$38 = _p$5;
    } else {
      const _p$6 = _p$4;
      _tmp$38 = _p$6;
    }
    return _tmp$38;
  }
  return "";
}
function _M0FP410Haoxincode8moonbash3lib8commands31awk__mutate__numeric__reference(target, delta, return_new, line, fields, nr, nf, vars, array_vars) {
  if (_M0FP410Haoxincode8moonbash3lib8commands19awk__is__identifier(target)) {
    const _p$4 = _M0MPB3Map3getGssE(vars, target);
    const _p$5 = "";
    let _tmp$38;
    if (_p$4 === undefined) {
      _tmp$38 = _p$5;
    } else {
      const _p$6 = _p$4;
      _tmp$38 = _p$6;
    }
    const old = _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(_tmp$38);
    const updated = old + delta;
    _M0MPB3Map3setGssE(vars, target, _M0FP410Haoxincode8moonbash3lib8commands23awk__number__to__string(updated));
    return return_new ? _M0MPB3Map2atGssE(vars, target) : _M0FP410Haoxincode8moonbash3lib8commands23awk__number__to__string(old);
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(target, "$") && target.length > 1) {
    const key_expr = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(target, 1, target.length);
    const key_value = key_expr === "NF" ? _M0MPC13int3Int18to__string_2einner(fields.length, 10) : _M0FP410Haoxincode8moonbash3lib8commands15awk__eval__expr(key_expr, line, fields, nr, nf, vars, array_vars);
    const idx = _M0MPC16double6Double7to__int(_M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(key_value));
    if (idx > 0) {
      while (true) {
        if (fields.length < idx) {
          _M0MPC15array5Array4pushGUssEE(fields, "");
          continue;
        } else {
          break;
        }
      }
      const old = _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(_M0MPC15array5Array2atGUssEE(fields, idx - 1 | 0));
      const updated = old + delta;
      _M0MPC15array5Array3setGsE(fields, idx - 1 | 0, _M0FP410Haoxincode8moonbash3lib8commands23awk__number__to__string(updated));
      return return_new ? _M0MPC15array5Array2atGUssEE(fields, idx - 1 | 0) : _M0FP410Haoxincode8moonbash3lib8commands23awk__number__to__string(old);
    }
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands22awk__parse__array__ref(target);
  if (_bind$4 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _arr_name = _x._0;
    const _idx_expr = _x._1;
    const idx = _M0FP410Haoxincode8moonbash3lib8commands15awk__eval__expr(_idx_expr, line, fields, nr, nf, vars, array_vars);
    const key = _M0FP410Haoxincode8moonbash3lib8commands15awk__array__key(_arr_name, idx);
    const _p$4 = _M0MPB3Map3getGssE(array_vars, key);
    const _p$5 = "";
    let _tmp$38;
    if (_p$4 === undefined) {
      _tmp$38 = _p$5;
    } else {
      const _p$6 = _p$4;
      _tmp$38 = _p$6;
    }
    const old = _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(_tmp$38);
    const updated = old + delta;
    _M0MPB3Map3setGssE(array_vars, key, _M0FP410Haoxincode8moonbash3lib8commands23awk__number__to__string(updated));
    if (return_new) {
      const _p$6 = _M0MPB3Map3getGssE(array_vars, key);
      const _p$7 = "";
      if (_p$6 === undefined) {
        return _p$7;
      } else {
        const _p$8 = _p$6;
        return _p$8;
      }
    } else {
      return _M0FP410Haoxincode8moonbash3lib8commands23awk__number__to__string(old);
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands17awk__join__fields(fields, sep) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < fields.length) {
      if (i > 0) {
        _M0IPB13StringBuilderPB6Logger13write__string(out, sep);
      }
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(fields, i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands27awk__apply__getline__target(target, line_value, fs, vars, array_vars, current_line, current_fields, current_nr) {
  switch (target.$tag) {
    case 0: {
      return _M0FP410Haoxincode8moonbash3lib8commands28awk__assign__getline__record(line_value, fs, vars, current_line, current_fields);
    }
    case 1: {
      const _Var = target;
      const _name = _Var._0;
      _M0MPB3Map3setGssE(vars, _name, line_value);
      return { _0: current_line, _1: current_fields };
    }
    case 2: {
      const _Field = target;
      const _key_ast = _Field._0;
      const key_value = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_key_ast, current_line, current_fields, current_nr, current_fields.length, vars, array_vars);
      const field_idx = _M0MPC16double6Double7to__int(_M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(key_value));
      if (field_idx === 0) {
        return _M0FP410Haoxincode8moonbash3lib8commands28awk__assign__getline__record(line_value, fs, vars, current_line, current_fields);
      } else {
        if (field_idx > 0) {
          while (true) {
            if (current_fields.length < field_idx) {
              _M0MPC15array5Array4pushGUssEE(current_fields, "");
              continue;
            } else {
              break;
            }
          }
          _M0MPC15array5Array3setGsE(current_fields, field_idx - 1 | 0, line_value);
          const _p$4 = _M0MPB3Map3getGssE(vars, "OFS");
          const _p$5 = " ";
          let ofs;
          if (_p$4 === undefined) {
            ofs = _p$5;
          } else {
            const _p$6 = _p$4;
            ofs = _p$6;
          }
          const next_line = _M0FP410Haoxincode8moonbash3lib8commands17awk__join__fields(current_fields, ofs);
          _M0MPB3Map3setGssE(vars, "NF", _M0MPC13int3Int18to__string_2einner(current_fields.length, 10));
          return { _0: next_line, _1: current_fields };
        } else {
          return { _0: current_line, _1: current_fields };
        }
      }
    }
    case 3: {
      const _ArrayElem = target;
      const _arr_name = _ArrayElem._0;
      const _idx_ast = _ArrayElem._1;
      const idx = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_idx_ast, current_line, current_fields, current_nr, current_fields.length, vars, array_vars);
      _M0MPB3Map3setGssE(array_vars, _M0FP410Haoxincode8moonbash3lib8commands15awk__array__key(_arr_name, idx), line_value);
      return { _0: current_line, _1: current_fields };
    }
    default: {
      const _Invalid = target;
      const _raw_target = _Invalid._0;
      _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands21awk__ctrl__error__key, `invalid getline target: ${_raw_target}`);
      _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key, "1");
      return { _0: current_line, _1: current_fields };
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands35awk__execute__empty__action__branch(line, fields, nr, out) {
  _M0IPB13StringBuilderPB6Logger13write__string(out, line);
  _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
  return { _0: line, _1: fields, _2: 0, _3: nr };
}
function _M0FP410Haoxincode8moonbash3lib8commands31awk__execute__action__ast__list(ctx, statements, lines, line_idx, line, fields, nr, fs, filename, vars, array_vars, out) {
  let current_line = line;
  let current_fields = fields;
  let current_nr = nr;
  let consumed = 0;
  const _bind$4 = statements.length;
  let _tmp$38 = 0;
  _L: while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const stmt = statements[_];
      _L$2: {
        if (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key) || (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__next__key) || _M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands22awk__ctrl__return__key))) {
          break;
        }
        switch (stmt.$tag) {
          case 4: {
            _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__next__key, "1");
            break _L;
          }
          case 5: {
            const _Exit = stmt;
            const _code_ast = _Exit._0;
            let code;
            if (_code_ast === undefined) {
              code = 0;
            } else {
              const _Some = _code_ast;
              const _expr_ast = _Some;
              code = _M0MPC16double6Double7to__int(_M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(_M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_expr_ast, current_line, current_fields, current_nr, current_fields.length, vars, array_vars)));
            }
            _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key, _M0MPC13int3Int18to__string_2einner(code, 10));
            break _L;
          }
          case 6: {
            const _Return = stmt;
            const _value_ast = _Return._0;
            let value;
            if (_value_ast === undefined) {
              value = "";
            } else {
              const _Some = _value_ast;
              const _expr_ast = _Some;
              value = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_expr_ast, current_line, current_fields, current_nr, current_fields.length, vars, array_vars);
            }
            _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands22awk__ctrl__return__key, "1");
            _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands29awk__ctrl__return__value__key, value);
            break _L;
          }
          case 10: {
            const _PipeGetline = stmt;
            const _cmd_ast = _PipeGetline._0;
            const _target = _PipeGetline._1;
            const command = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_cmd_ast, current_line, current_fields, current_nr, current_fields.length, vars, array_vars);
            const line_from_cmd = _M0FP410Haoxincode8moonbash3lib8commands33awk__eval__getline__command__line(command);
            const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands27awk__apply__getline__target(_target, line_from_cmd, fs, vars, array_vars, current_line, current_fields, current_nr);
            const _next_line = _bind$5._0;
            const _next_fields = _bind$5._1;
            current_line = _next_line;
            current_fields = _next_fields;
            break;
          }
          case 11: {
            const _Getline = stmt;
            const _target$2 = _Getline._0;
            const _path_ast = _Getline._1;
            if (_path_ast === undefined) {
            } else {
              const _Some = _path_ast;
              const _path_expr_ast = _Some;
              const path = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_path_expr_ast, current_line, current_fields, current_nr, current_fields.length, vars, array_vars);
              let resolved;
              let _try_err;
              _L$3: {
                _L$4: {
                  const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, path);
                  if (_bind$6.$tag === 1) {
                    const _ok = _bind$6;
                    resolved = _ok._0;
                  } else {
                    const _err = _bind$6;
                    _try_err = _err._0;
                    break _L$4;
                  }
                  break _L$3;
                }
                resolved = "";
              }
              if (resolved.length > 0) {
                let content;
                let _try_err$2;
                _L$4: {
                  _L$5: {
                    const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, resolved);
                    if (_bind$6.$tag === 1) {
                      const _ok = _bind$6;
                      content = _ok._0;
                    } else {
                      const _err = _bind$6;
                      _try_err$2 = _err._0;
                      break _L$5;
                    }
                    break _L$4;
                  }
                  content = "";
                }
                const first_line = _M0FP410Haoxincode8moonbash3lib8commands15aj__first__line(content);
                const _bind$6 = _M0FP410Haoxincode8moonbash3lib8commands27awk__apply__getline__target(_target$2, first_line, fs, vars, array_vars, current_line, current_fields, current_nr);
                const _next_line$2 = _bind$6._0;
                const _next_fields$2 = _bind$6._1;
                current_line = _next_line$2;
                current_fields = _next_fields$2;
              }
              break _L$2;
            }
            if (line_idx < 0) {
              if (_target$2.$tag === 0) {
                break _L$2;
              }
            }
            const next_idx = (line_idx + consumed | 0) + 1 | 0;
            if (next_idx >= 0 && next_idx < lines.length) {
              consumed = consumed + 1 | 0;
              const next_line = _M0MPC15array5Array2atGUssEE(lines, next_idx);
              current_nr = current_nr + 1 | 0;
              _M0MPB3Map3setGssE(vars, "NR", _M0MPC13int3Int18to__string_2einner(current_nr, 10));
              _M0MPB3Map3setGssE(vars, "FNR", _M0MPC13int3Int18to__string_2einner(current_nr, 10));
              _M0MPB3Map3setGssE(vars, "FILENAME", filename);
              const _bind$6 = _M0FP410Haoxincode8moonbash3lib8commands27awk__apply__getline__target(_target$2, next_line, fs, vars, array_vars, current_line, current_fields, current_nr);
              const _next_line_value = _bind$6._0;
              const _next_fields_value = _bind$6._1;
              current_line = _next_line_value;
              current_fields = _next_fields_value;
            }
            break;
          }
          case 12: {
            _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands21awk__ctrl__error__key, "system() is not supported");
            _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key, "1");
            break _L;
          }
          case 13: {
            const _SubstituteStmt = stmt;
            const _is_gsub = _SubstituteStmt._0;
            const _args_ast = _SubstituteStmt._1;
            if (_args_ast.length >= 2) {
              const pattern = _M0FP410Haoxincode8moonbash3lib8commands28awk__eval__sub__pattern__ast(_M0MPC15array5Array2atGUssEE(_args_ast, 0), current_line, current_fields, current_nr, current_fields.length, vars, array_vars);
              const replacement = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_M0MPC15array5Array2atGUssEE(_args_ast, 1), current_line, current_fields, current_nr, current_fields.length, vars, array_vars);
              let target_ast = undefined;
              if (_args_ast.length >= 3) {
                target_ast = _M0MPC15array5Array2atGUssEE(_args_ast, 2);
              }
              const _bind$6 = target_ast;
              let source;
              if (_bind$6 === undefined) {
                source = current_line;
              } else {
                const _Some = _bind$6;
                const _ast = _Some;
                source = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_ast, current_line, current_fields, current_nr, current_fields.length, vars, array_vars);
              }
              const _bind$7 = _is_gsub ? _M0FP410Haoxincode8moonbash3lib8commands26awk__replace__all__literal(source, pattern, replacement) : _M0FP410Haoxincode8moonbash3lib8commands28awk__replace__first__literal(source, pattern, replacement);
              const _updated = _bind$7._0;
              const _bind$8 = target_ast;
              if (_bind$8 === undefined) {
                current_line = _updated;
                const current_fs = _M0FP410Haoxincode8moonbash3lib8commands16awk__current__fs(fs, vars);
                current_fields = _M0FP410Haoxincode8moonbash3lib8commands18awk__split__fields(current_line, current_fs);
                _M0MPB3Map3setGssE(vars, "NF", _M0MPC13int3Int18to__string_2einner(current_fields.length, 10));
              } else {
                const _Some = _bind$8;
                const _ast = _Some;
                if (_ast.$tag === 0) {
                  const _Raw = _ast;
                  const _raw_target = _Raw._0;
                  const target = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_raw_target);
                  _M0FP410Haoxincode8moonbash3lib8commands22awk__assign__reference(target, _updated, current_line, current_fields, current_nr, current_fields.length, vars, array_vars);
                }
              }
            }
            break;
          }
          case 17: {
            const _ExprStmt = stmt;
            const _expr_ast = _ExprStmt._0;
            _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_expr_ast, current_line, current_fields, current_nr, current_fields.length, vars, array_vars);
            break;
          }
          case 16: {
            const _CompoundAssignStmt = stmt;
            const _lhs_target = _CompoundAssignStmt._0;
            const _op = _CompoundAssignStmt._1;
            const _rhs_ast = _CompoundAssignStmt._2;
            const right = _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(_M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_rhs_ast, current_line, current_fields, current_nr, current_fields.length, vars, array_vars));
            if (_lhs_target.$tag === 0) {
              const _Var = _lhs_target;
              const _name = _Var._0;
              const _p$4 = _M0MPB3Map3getGssE(vars, _name);
              const _p$5 = "";
              let _tmp$39;
              if (_p$4 === undefined) {
                _tmp$39 = _p$5;
              } else {
                const _p$6 = _p$4;
                _tmp$39 = _p$6;
              }
              const left = _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(_tmp$39);
              let value$2;
              switch (_op) {
                case "+=": {
                  value$2 = left + right;
                  break;
                }
                case "-=": {
                  value$2 = left - right;
                  break;
                }
                case "*=": {
                  value$2 = left * right;
                  break;
                }
                case "/=": {
                  value$2 = right === 0 ? 0 : left / right;
                  break;
                }
                default: {
                  value$2 = left;
                }
              }
              _M0MPB3Map3setGssE(vars, _name, _M0FP410Haoxincode8moonbash3lib8commands23awk__number__to__string(value$2));
            } else {
              const _ArrayElem = _lhs_target;
              const _arr_name = _ArrayElem._0;
              const _idx_ast = _ArrayElem._1;
              const idx = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_idx_ast, current_line, current_fields, current_nr, current_fields.length, vars, array_vars);
              const key = _M0FP410Haoxincode8moonbash3lib8commands15awk__array__key(_arr_name, idx);
              const _p$4 = _M0MPB3Map3getGssE(array_vars, key);
              const _p$5 = "";
              let _tmp$39;
              if (_p$4 === undefined) {
                _tmp$39 = _p$5;
              } else {
                const _p$6 = _p$4;
                _tmp$39 = _p$6;
              }
              const left = _M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(_tmp$39);
              let value$2;
              switch (_op) {
                case "+=": {
                  value$2 = left + right;
                  break;
                }
                case "-=": {
                  value$2 = left - right;
                  break;
                }
                case "*=": {
                  value$2 = left * right;
                  break;
                }
                case "/=": {
                  value$2 = right === 0 ? 0 : left / right;
                  break;
                }
                default: {
                  value$2 = left;
                }
              }
              _M0MPB3Map3setGssE(array_vars, key, _M0FP410Haoxincode8moonbash3lib8commands23awk__number__to__string(value$2));
            }
            break;
          }
          case 15: {
            const _AssignStmt = stmt;
            const _lhs_target$2 = _AssignStmt._0;
            const _rhs_ast$2 = _AssignStmt._1;
            const value$2 = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_rhs_ast$2, current_line, current_fields, current_nr, current_fields.length, vars, array_vars);
            if (_lhs_target$2.$tag === 0) {
              const _Var = _lhs_target$2;
              const _name = _Var._0;
              _M0MPB3Map3setGssE(vars, _name, value$2);
            } else {
              const _ArrayElem = _lhs_target$2;
              const _arr_name = _ArrayElem._0;
              const _idx_ast = _ArrayElem._1;
              const idx = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_idx_ast, current_line, current_fields, current_nr, current_fields.length, vars, array_vars);
              _M0MPB3Map3setGssE(array_vars, _M0FP410Haoxincode8moonbash3lib8commands15awk__array__key(_arr_name, idx), value$2);
            }
            break;
          }
          case 14: {
            const _FieldAssignStmt = stmt;
            const _idx_ast = _FieldAssignStmt._0;
            const _rhs_ast$3 = _FieldAssignStmt._1;
            const value$3 = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_rhs_ast$3, current_line, current_fields, current_nr, current_fields.length, vars, array_vars);
            const field_idx = _M0MPC16double6Double7to__int(_M0FP410Haoxincode8moonbash3lib8commands18awk__parse__number(_M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_idx_ast, current_line, current_fields, current_nr, current_fields.length, vars, array_vars)));
            if (field_idx === 0) {
              current_line = value$3;
              const current_fs = _M0FP410Haoxincode8moonbash3lib8commands16awk__current__fs(fs, vars);
              current_fields = _M0FP410Haoxincode8moonbash3lib8commands18awk__split__fields(current_line, current_fs);
              _M0MPB3Map3setGssE(vars, "NF", _M0MPC13int3Int18to__string_2einner(current_fields.length, 10));
            } else {
              if (field_idx > 0) {
                while (true) {
                  if (current_fields.length < field_idx) {
                    _M0MPC15array5Array4pushGUssEE(current_fields, "");
                    continue;
                  } else {
                    break;
                  }
                }
                _M0MPC15array5Array3setGsE(current_fields, field_idx - 1 | 0, value$3);
                const _p$4 = _M0MPB3Map3getGssE(vars, "OFS");
                const _p$5 = " ";
                let ofs;
                if (_p$4 === undefined) {
                  ofs = _p$5;
                } else {
                  const _p$6 = _p$4;
                  ofs = _p$6;
                }
                current_line = _M0FP410Haoxincode8moonbash3lib8commands17awk__join__fields(current_fields, ofs);
                _M0MPB3Map3setGssE(vars, "NF", _M0MPC13int3Int18to__string_2einner(current_fields.length, 10));
              }
            }
            break;
          }
          case 9: {
            const _Delete = stmt;
            const _arr_name = _Delete._0;
            const _idx_ast$2 = _Delete._1;
            if (_idx_ast$2 === undefined) {
              _M0FP410Haoxincode8moonbash3lib8commands29awk__remove__array__namespace(array_vars, _arr_name);
            } else {
              const _Some = _idx_ast$2;
              const _expr_ast$2 = _Some;
              const idx = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_expr_ast$2, current_line, current_fields, current_nr, current_fields.length, vars, array_vars);
              _M0MPB3Map6removeGssE(array_vars, _M0FP410Haoxincode8moonbash3lib8commands15awk__array__key(_arr_name, idx));
            }
            break;
          }
          case 7: {
            const _Printf = stmt;
            const _fmt_ast = _Printf._0;
            const _arg_asts = _Printf._1;
            const _target_ast = _Printf._2;
            const _append = _Printf._3;
            const fmt_value = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_fmt_ast, current_line, current_fields, current_nr, current_fields.length, vars, array_vars);
            const fmt_args = [];
            const _bind$6 = _arg_asts.length;
            let _tmp$39 = 0;
            while (true) {
              const _$2 = _tmp$39;
              if (_$2 < _bind$6) {
                const arg_ast = _arg_asts[_$2];
                _M0MPC15array5Array4pushGUssEE(fmt_args, _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(arg_ast, current_line, current_fields, current_nr, current_fields.length, vars, array_vars));
                _tmp$39 = _$2 + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            const payload = _M0FP410Haoxincode8moonbash3lib8commands19awk__format__printf(fmt_value, fmt_args);
            if (_target_ast === undefined) {
              _M0IPB13StringBuilderPB6Logger13write__string(out, payload);
            } else {
              const _Some = _target_ast;
              const _target_expr_ast = _Some;
              const target = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_target_expr_ast, current_line, current_fields, current_nr, current_fields.length, vars, array_vars);
              let resolved;
              let _try_err;
              _L$3: {
                _L$4: {
                  const _bind$7 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, target);
                  if (_bind$7.$tag === 1) {
                    const _ok = _bind$7;
                    resolved = _ok._0;
                  } else {
                    const _err = _bind$7;
                    _try_err = _err._0;
                    break _L$4;
                  }
                  break _L$3;
                }
                const _FsError = _try_err;
                const _msg = _FsError._0;
                _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands21awk__ctrl__error__key, _msg);
                _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key, "1");
                break _L;
              }
              let existing;
              if (_append) {
                let _try_err$2;
                _L$4: {
                  _L$5: {
                    const _bind$7 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, resolved);
                    if (_bind$7.$tag === 1) {
                      const _ok = _bind$7;
                      existing = _ok._0;
                    } else {
                      const _err = _bind$7;
                      _try_err$2 = _err._0;
                      break _L$5;
                    }
                    break _L$4;
                  }
                  existing = "";
                }
              } else {
                existing = "";
              }
              let _try_err$2;
              _L$4: {
                _L$5: {
                  const _bind$7 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs11write__file(ctx.fs, resolved, `${existing}${payload}`);
                  if (_bind$7.$tag === 1) {
                    const _ok = _bind$7;
                    _ok._0;
                  } else {
                    const _err = _bind$7;
                    _try_err$2 = _err._0;
                    break _L$5;
                  }
                  break _L$4;
                }
                const _FsError = _try_err$2;
                const _msg = _FsError._0;
                _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands21awk__ctrl__error__key, _msg);
                _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key, "1");
                break _L;
              }
            }
            break;
          }
          case 8: {
            const _Print = stmt;
            const _value_asts = _Print._0;
            const _target_ast$2 = _Print._1;
            const _append$2 = _Print._2;
            const _has_pipe = _Print._3;
            if (_has_pipe) {
              _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands21awk__ctrl__error__key, "piping to external commands is not supported");
              _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key, "1");
              break _L;
            }
            const payload$2 = _M0FP410Haoxincode8moonbash3lib8commands31awk__render__print__output__ast(_value_asts, current_line, current_fields, current_nr, vars, array_vars);
            if (_target_ast$2 === undefined) {
              _M0IPB13StringBuilderPB6Logger13write__string(out, payload$2);
            } else {
              const _Some = _target_ast$2;
              const _target_expr_ast = _Some;
              const target = _M0FP410Haoxincode8moonbash3lib8commands20awk__eval__expr__ast(_target_expr_ast, current_line, current_fields, current_nr, current_fields.length, vars, array_vars);
              let resolved;
              let _try_err;
              _L$3: {
                _L$4: {
                  const _bind$7 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, target);
                  if (_bind$7.$tag === 1) {
                    const _ok = _bind$7;
                    resolved = _ok._0;
                  } else {
                    const _err = _bind$7;
                    _try_err = _err._0;
                    break _L$4;
                  }
                  break _L$3;
                }
                const _FsError = _try_err;
                const _msg = _FsError._0;
                _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands21awk__ctrl__error__key, _msg);
                _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key, "1");
                break _L;
              }
              let existing;
              if (_append$2) {
                let _try_err$2;
                _L$4: {
                  _L$5: {
                    const _bind$7 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, resolved);
                    if (_bind$7.$tag === 1) {
                      const _ok = _bind$7;
                      existing = _ok._0;
                    } else {
                      const _err = _bind$7;
                      _try_err$2 = _err._0;
                      break _L$5;
                    }
                    break _L$4;
                  }
                  existing = "";
                }
              } else {
                existing = "";
              }
              let _try_err$2;
              _L$4: {
                _L$5: {
                  const _bind$7 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs11write__file(ctx.fs, resolved, `${existing}${payload$2}`);
                  if (_bind$7.$tag === 1) {
                    const _ok = _bind$7;
                    _ok._0;
                  } else {
                    const _err = _bind$7;
                    _try_err$2 = _err._0;
                    break _L$5;
                  }
                  break _L$4;
                }
                const _FsError = _try_err$2;
                const _msg = _FsError._0;
                _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands21awk__ctrl__error__key, _msg);
                _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key, "1");
                break _L;
              }
            }
            break;
          }
          case 2: {
            const _ForIn = stmt;
            const _loop_var = _ForIn._0;
            const _arr_name$2 = _ForIn._1;
            const _body_stmts = _ForIn._2;
            const key_prefix = `${_arr_name$2}#`;
            const indices = [];
            const _it = _M0MPB3Map5iter2GssE(array_vars);
            while (true) {
              const _bind$7 = _M0MPB5Iter24nextGssE(_it);
              if (_bind$7 === undefined) {
                break;
              } else {
                const _Some = _bind$7;
                const _x = _Some;
                const _key = _x._0;
                if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(_key, key_prefix)) {
                  _M0MPC15array5Array4pushGUssEE(indices, _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(_key, key_prefix.length, _key.length));
                }
                continue;
              }
            }
            const _bind$7 = indices.length;
            let _tmp$40 = 0;
            while (true) {
              const _$2 = _tmp$40;
              if (_$2 < _bind$7) {
                const idx_value = indices[_$2];
                if (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key) || (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__next__key) || _M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands22awk__ctrl__return__key))) {
                  break;
                }
                _M0MPB3Map3setGssE(vars, _loop_var, idx_value);
                if (_body_stmts.length > 0) {
                  const _bind$8 = _M0FP410Haoxincode8moonbash3lib8commands31awk__execute__action__ast__list(ctx, _body_stmts, lines, line_idx + consumed | 0, current_line, current_fields, current_nr, fs, filename, vars, array_vars, out);
                  const _next_line$2 = _bind$8._0;
                  const _next_fields$2 = _bind$8._1;
                  const _consumed_body = _bind$8._2;
                  const _new_nr = _bind$8._3;
                  current_line = _next_line$2;
                  current_fields = _next_fields$2;
                  consumed = consumed + _consumed_body | 0;
                  current_nr = _new_nr;
                }
                _tmp$40 = _$2 + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            break;
          }
          case 1: {
            const _For = stmt;
            const _init_stmts = _For._0;
            const _cond_ast = _For._1;
            const _cond_getline = _For._2;
            const _update_stmts = _For._3;
            const _body_stmts$2 = _For._4;
            if (_init_stmts.length > 0) {
              const _bind$8 = _M0FP410Haoxincode8moonbash3lib8commands31awk__execute__action__ast__list(ctx, _init_stmts, lines, line_idx + consumed | 0, current_line, current_fields, current_nr, fs, filename, vars, array_vars, out);
              const _next_line$2 = _bind$8._0;
              const _next_fields$2 = _bind$8._1;
              const _consumed_init = _bind$8._2;
              const _new_nr = _bind$8._3;
              current_line = _next_line$2;
              current_fields = _next_fields$2;
              consumed = consumed + _consumed_init | 0;
              current_nr = _new_nr;
            }
            let loop_count = 0;
            while (true) {
              if (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key) || (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__next__key) || _M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands22awk__ctrl__return__key))) {
                break;
              }
              let cond_passed = true;
              if (_cond_ast === undefined) {
              } else {
                const _Some = _cond_ast;
                const _cond_expr_ast = _Some;
                if (_cond_getline === undefined) {
                  cond_passed = _M0FP410Haoxincode8moonbash3lib8commands25awk__eval__condition__ast(_cond_expr_ast, current_line, current_fields, current_nr, current_fields.length, vars, array_vars);
                } else {
                  const _Some$2 = _cond_getline;
                  const _target$3 = _Some$2;
                  const next_idx$2 = (line_idx + consumed | 0) + 1 | 0;
                  if (next_idx$2 >= 0 && next_idx$2 < lines.length) {
                    const next_line = _M0MPC15array5Array2atGUssEE(lines, next_idx$2);
                    consumed = consumed + 1 | 0;
                    current_nr = current_nr + 1 | 0;
                    _M0MPB3Map3setGssE(vars, "NR", _M0MPC13int3Int18to__string_2einner(current_nr, 10));
                    _M0MPB3Map3setGssE(vars, "FNR", _M0MPC13int3Int18to__string_2einner(current_nr, 10));
                    const _bind$8 = _M0FP410Haoxincode8moonbash3lib8commands27awk__apply__getline__target(_target$3, next_line, fs, vars, array_vars, current_line, current_fields, current_nr);
                    const _next_line_value = _bind$8._0;
                    const _next_fields_value = _bind$8._1;
                    current_line = _next_line_value;
                    current_fields = _next_fields_value;
                    cond_passed = !_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key);
                  } else {
                    cond_passed = false;
                  }
                }
              }
              if (!cond_passed) {
                break;
              }
              if (_body_stmts$2.length > 0) {
                const _bind$8 = _M0FP410Haoxincode8moonbash3lib8commands31awk__execute__action__ast__list(ctx, _body_stmts$2, lines, line_idx + consumed | 0, current_line, current_fields, current_nr, fs, filename, vars, array_vars, out);
                const _next_line$2 = _bind$8._0;
                const _next_fields$2 = _bind$8._1;
                const _consumed_body = _bind$8._2;
                const _new_nr = _bind$8._3;
                current_line = _next_line$2;
                current_fields = _next_fields$2;
                consumed = consumed + _consumed_body | 0;
                current_nr = _new_nr;
              }
              if (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key) || (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__next__key) || _M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands22awk__ctrl__return__key))) {
                break;
              }
              if (_update_stmts.length > 0) {
                const _bind$8 = _M0FP410Haoxincode8moonbash3lib8commands31awk__execute__action__ast__list(ctx, _update_stmts, lines, line_idx + consumed | 0, current_line, current_fields, current_nr, fs, filename, vars, array_vars, out);
                const _next_line$2 = _bind$8._0;
                const _next_fields$2 = _bind$8._1;
                const _consumed_update = _bind$8._2;
                const _new_nr = _bind$8._3;
                current_line = _next_line$2;
                current_fields = _next_fields$2;
                consumed = consumed + _consumed_update | 0;
                current_nr = _new_nr;
              }
              loop_count = loop_count + 1 | 0;
              if (loop_count > 10000) {
                break;
              }
              continue;
            }
            break;
          }
          case 3: {
            const _While = stmt;
            const _cond_ast$2 = _While._0;
            const _cond_getline$2 = _While._1;
            const _body_stmts$3 = _While._2;
            let loop_count$2 = 0;
            while (true) {
              if (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key) || (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__next__key) || _M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands22awk__ctrl__return__key))) {
                break;
              }
              let cond_passed = false;
              let handled_getline = false;
              if (_cond_getline$2 === undefined) {
              } else {
                const _Some = _cond_getline$2;
                const _target$3 = _Some;
                handled_getline = true;
                const next_idx$2 = (line_idx + consumed | 0) + 1 | 0;
                if (next_idx$2 >= 0 && next_idx$2 < lines.length) {
                  const next_line = _M0MPC15array5Array2atGUssEE(lines, next_idx$2);
                  consumed = consumed + 1 | 0;
                  current_nr = current_nr + 1 | 0;
                  _M0MPB3Map3setGssE(vars, "NR", _M0MPC13int3Int18to__string_2einner(current_nr, 10));
                  _M0MPB3Map3setGssE(vars, "FNR", _M0MPC13int3Int18to__string_2einner(current_nr, 10));
                  const _bind$8 = _M0FP410Haoxincode8moonbash3lib8commands27awk__apply__getline__target(_target$3, next_line, fs, vars, array_vars, current_line, current_fields, current_nr);
                  const _next_line_value = _bind$8._0;
                  const _next_fields_value = _bind$8._1;
                  current_line = _next_line_value;
                  current_fields = _next_fields_value;
                  cond_passed = !_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key);
                } else {
                  cond_passed = false;
                }
              }
              if (!handled_getline) {
                cond_passed = _M0FP410Haoxincode8moonbash3lib8commands25awk__eval__condition__ast(_cond_ast$2, current_line, current_fields, current_nr, current_fields.length, vars, array_vars);
              }
              if (!cond_passed) {
                break;
              }
              if (_body_stmts$3.length > 0) {
                const _bind$8 = _M0FP410Haoxincode8moonbash3lib8commands31awk__execute__action__ast__list(ctx, _body_stmts$3, lines, line_idx + consumed | 0, current_line, current_fields, current_nr, fs, filename, vars, array_vars, out);
                const _next_line$2 = _bind$8._0;
                const _next_fields$2 = _bind$8._1;
                const _consumed_body = _bind$8._2;
                const _new_nr = _bind$8._3;
                current_line = _next_line$2;
                current_fields = _next_fields$2;
                consumed = consumed + _consumed_body | 0;
                current_nr = _new_nr;
              }
              if (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key) || (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__next__key) || _M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands22awk__ctrl__return__key))) {
                break;
              }
              loop_count$2 = loop_count$2 + 1 | 0;
              if (loop_count$2 > 10000) {
                break;
              }
              continue;
            }
            break;
          }
          default: {
            const _If = stmt;
            const _cond_ast$3 = _If._0;
            const _cond_getline$3 = _If._1;
            const _then_stmts = _If._2;
            const _else_stmts = _If._3;
            let cond_passed = false;
            let handled_getline = false;
            if (_cond_getline$3 === undefined) {
            } else {
              const _Some = _cond_getline$3;
              const _target$3 = _Some;
              handled_getline = true;
              const next_idx$2 = (line_idx + consumed | 0) + 1 | 0;
              if (next_idx$2 >= 0 && next_idx$2 < lines.length) {
                const next_line = _M0MPC15array5Array2atGUssEE(lines, next_idx$2);
                consumed = consumed + 1 | 0;
                current_nr = current_nr + 1 | 0;
                _M0MPB3Map3setGssE(vars, "NR", _M0MPC13int3Int18to__string_2einner(current_nr, 10));
                _M0MPB3Map3setGssE(vars, "FNR", _M0MPC13int3Int18to__string_2einner(current_nr, 10));
                const _bind$8 = _M0FP410Haoxincode8moonbash3lib8commands27awk__apply__getline__target(_target$3, next_line, fs, vars, array_vars, current_line, current_fields, current_nr);
                const _next_line_value = _bind$8._0;
                const _next_fields_value = _bind$8._1;
                current_line = _next_line_value;
                current_fields = _next_fields_value;
                cond_passed = !_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key);
              } else {
                cond_passed = false;
              }
            }
            if (!handled_getline) {
              cond_passed = _M0FP410Haoxincode8moonbash3lib8commands25awk__eval__condition__ast(_cond_ast$3, current_line, current_fields, current_nr, current_fields.length, vars, array_vars);
            }
            if (cond_passed) {
              const _bind$8 = _then_stmts.length === 0 ? _M0FP410Haoxincode8moonbash3lib8commands35awk__execute__empty__action__branch(current_line, current_fields, current_nr, out) : _M0FP410Haoxincode8moonbash3lib8commands31awk__execute__action__ast__list(ctx, _then_stmts, lines, line_idx + consumed | 0, current_line, current_fields, current_nr, fs, filename, vars, array_vars, out);
              const _next_line$2 = _bind$8._0;
              const _next_fields$2 = _bind$8._1;
              const _consumed_if = _bind$8._2;
              const _new_nr = _bind$8._3;
              current_line = _next_line$2;
              current_fields = _next_fields$2;
              consumed = consumed + _consumed_if | 0;
              current_nr = _new_nr;
            } else {
              if (_else_stmts.$tag === 1) {
                const _Some = _else_stmts;
                const _else_branch = _Some._0;
                const _bind$8 = _else_branch.length === 0 ? _M0FP410Haoxincode8moonbash3lib8commands35awk__execute__empty__action__branch(current_line, current_fields, current_nr, out) : _M0FP410Haoxincode8moonbash3lib8commands31awk__execute__action__ast__list(ctx, _else_branch, lines, line_idx + consumed | 0, current_line, current_fields, current_nr, fs, filename, vars, array_vars, out);
                const _next_line$2 = _bind$8._0;
                const _next_fields$2 = _bind$8._1;
                const _consumed_if = _bind$8._2;
                const _new_nr = _bind$8._3;
                current_line = _next_line$2;
                current_fields = _next_fields$2;
                consumed = consumed + _consumed_if | 0;
                current_nr = _new_nr;
              }
            }
          }
        }
        break _L$2;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return { _0: current_line, _1: current_fields, _2: consumed, _3: current_nr };
}
function _M0FP410Haoxincode8moonbash3lib8commands20awk__execute__action(ctx, action, lines, line_idx, line, fields, nr, nf, fs, filename, vars, array_vars, out) {
  const act = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(action);
  if (act.length === 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(out, line);
    _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
    return { _0: line, _1: fields, _2: 0, _3: nr };
  }
  const statements = _M0FP410Haoxincode8moonbash3lib8commands23awk__parse__action__ast(act);
  return _M0FP410Haoxincode8moonbash3lib8commands31awk__execute__action__ast__list(ctx, statements, lines, line_idx, line, fields, nr, fs, filename, vars, array_vars, out);
}
function _M0FP410Haoxincode8moonbash3lib8commands28awk__parse__function__params(param_text) {
  const params = [];
  const pieces = _M0FP410Haoxincode8moonbash3lib8commands21awk__split__csv__args(param_text);
  const _bind$4 = pieces.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const piece = pieces[_];
      const name = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(piece);
      if (_M0FP410Haoxincode8moonbash3lib8commands19awk__is__identifier(name)) {
        _M0MPC15array5Array4pushGUssEE(params, name);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return params;
}
function _M0FP410Haoxincode8moonbash3lib8commands31awk__take__function__definition(src) {
  let start = -1;
  let i = 0;
  while (true) {
    if ((i + _M0FP410Haoxincode8moonbash3lib8commands31awk__take__function__definitionN7keywordS967.length | 0) <= src.length) {
      if (_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(src, i, i + _M0FP410Haoxincode8moonbash3lib8commands31awk__take__function__definitionN7keywordS967.length | 0) === _M0FP410Haoxincode8moonbash3lib8commands31awk__take__function__definitionN7keywordS967) {
        let left_ok;
        if (i === 0) {
          left_ok = true;
        } else {
          const _tmp$38 = i - 1 | 0;
          $bound_check(src, _tmp$38);
          left_ok = !_M0FP410Haoxincode8moonbash3lib8commands25awk__is__identifier__char(src.charCodeAt(_tmp$38));
        }
        if (left_ok) {
          start = i;
          break;
        }
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (start < 0) {
    return { _0: undefined, _1: undefined, _2: src };
  }
  let name_start = start + _M0FP410Haoxincode8moonbash3lib8commands31awk__take__function__definitionN7keywordS967.length | 0;
  while (true) {
    let _tmp$38;
    if (name_start < src.length) {
      const _tmp$39 = name_start;
      $bound_check(src, _tmp$39);
      _tmp$38 = _M0FP410Haoxincode8moonbash3lib8commands14awk__is__space(src.charCodeAt(_tmp$39));
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      name_start = name_start + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (name_start >= src.length) {
    return { _0: undefined, _1: undefined, _2: src };
  }
  let name_end = name_start;
  while (true) {
    let _tmp$38;
    if (name_end < src.length) {
      const _tmp$39 = name_end;
      $bound_check(src, _tmp$39);
      _tmp$38 = _M0FP410Haoxincode8moonbash3lib8commands25awk__is__identifier__char(src.charCodeAt(_tmp$39));
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      name_end = name_end + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const name = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(src, name_start, name_end));
  if (!_M0FP410Haoxincode8moonbash3lib8commands19awk__is__identifier(name)) {
    return { _0: undefined, _1: undefined, _2: src };
  }
  let open_paren = name_end;
  while (true) {
    let _tmp$38;
    if (open_paren < src.length) {
      const _tmp$39 = open_paren;
      $bound_check(src, _tmp$39);
      _tmp$38 = _M0FP410Haoxincode8moonbash3lib8commands14awk__is__space(src.charCodeAt(_tmp$39));
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      open_paren = open_paren + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let _tmp$38;
  if (open_paren >= src.length) {
    _tmp$38 = true;
  } else {
    const _tmp$39 = open_paren;
    $bound_check(src, _tmp$39);
    _tmp$38 = src.charCodeAt(_tmp$39) !== 40;
  }
  if (_tmp$38) {
    return { _0: undefined, _1: undefined, _2: src };
  }
  let paren_depth = 1;
  let close_paren = open_paren + 1 | 0;
  let quote = -1;
  while (true) {
    if (close_paren < src.length && paren_depth > 0) {
      const _tmp$39 = close_paren;
      $bound_check(src, _tmp$39);
      const ch = src.charCodeAt(_tmp$39);
      const _bind$4 = quote;
      if (_bind$4 === -1) {
        if (ch === 34 || ch === 39) {
          quote = ch;
        } else {
          if (ch === 40) {
            paren_depth = paren_depth + 1 | 0;
          } else {
            if (ch === 41) {
              paren_depth = paren_depth - 1 | 0;
            }
          }
        }
      } else {
        const _Some = _bind$4;
        const _q = _Some;
        if (ch === 92 && (close_paren + 1 | 0) < src.length) {
          close_paren = close_paren + 2 | 0;
          continue;
        }
        if (ch === _q) {
          quote = -1;
        }
      }
      if (paren_depth > 0) {
        close_paren = close_paren + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  if (paren_depth !== 0 || close_paren >= src.length) {
    return { _0: undefined, _1: undefined, _2: src };
  }
  const params_text = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(src, open_paren + 1 | 0, close_paren);
  const params = _M0FP410Haoxincode8moonbash3lib8commands28awk__parse__function__params(params_text);
  let open_brace = close_paren + 1 | 0;
  while (true) {
    let _tmp$39;
    if (open_brace < src.length) {
      const _tmp$40 = open_brace;
      $bound_check(src, _tmp$40);
      _tmp$39 = _M0FP410Haoxincode8moonbash3lib8commands14awk__is__space(src.charCodeAt(_tmp$40));
    } else {
      _tmp$39 = false;
    }
    if (_tmp$39) {
      open_brace = open_brace + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let _tmp$39;
  if (open_brace >= src.length) {
    _tmp$39 = true;
  } else {
    const _tmp$40 = open_brace;
    $bound_check(src, _tmp$40);
    _tmp$39 = src.charCodeAt(_tmp$40) !== 123;
  }
  if (_tmp$39) {
    return { _0: undefined, _1: undefined, _2: src };
  }
  let brace_depth = 1;
  let close_brace = open_brace + 1 | 0;
  quote = -1;
  while (true) {
    if (close_brace < src.length && brace_depth > 0) {
      const _tmp$40 = close_brace;
      $bound_check(src, _tmp$40);
      const ch = src.charCodeAt(_tmp$40);
      const _bind$4 = quote;
      if (_bind$4 === -1) {
        if (ch === 34 || ch === 39) {
          quote = ch;
        } else {
          if (ch === 123) {
            brace_depth = brace_depth + 1 | 0;
          } else {
            if (ch === 125) {
              brace_depth = brace_depth - 1 | 0;
            }
          }
        }
      } else {
        const _Some = _bind$4;
        const _q = _Some;
        if (ch === 92 && (close_brace + 1 | 0) < src.length) {
          close_brace = close_brace + 2 | 0;
          continue;
        }
        if (ch === _q) {
          quote = -1;
        }
      }
      if (brace_depth > 0) {
        close_brace = close_brace + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  if (brace_depth !== 0 || close_brace >= src.length) {
    return { _0: undefined, _1: undefined, _2: src };
  }
  const body = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(src, open_brace + 1 | 0, close_brace);
  const remaining = `${_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(src, 0, start)}${_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(src, close_brace + 1 | 0, src.length)}`;
  return { _0: name, _1: new _M0TP410Haoxincode8moonbash3lib8commands11AwkFunction(params, body), _2: remaining };
}
function _M0FP410Haoxincode8moonbash3lib8commands23awk__extract__functions(src) {
  const _bind$4 = [];
  const functions = _M0MPB3Map3MapGsRP410Haoxincode8moonbash3lib8commands11AwkFunctionE(new _M0TPB9ArrayViewGUsRP410Haoxincode8moonbash3lib8commands11AwkFunctionEE(_bind$4, 0, 0), undefined);
  let remaining = src;
  while (true) {
    _L: {
      _L$2: {
        const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands31awk__take__function__definition(remaining);
        const _x = _bind$5._0;
        if (_x === undefined) {
          break _L$2;
        } else {
          const _Some = _x;
          const _name = _Some;
          const _x$2 = _bind$5._1;
          if (_x$2 === undefined) {
            break _L$2;
          } else {
            const _Some$2 = _x$2;
            const _def = _Some$2;
            const _rest = _bind$5._2;
            _M0MPB3Map3setGsRP410Haoxincode8moonbash3lib8commands11AwkFunctionE(functions, _name, _def);
            remaining = _rest;
          }
        }
        break _L;
      }
      break;
    }
    continue;
  }
  return { _0: remaining, _1: functions };
}
function _M0FP410Haoxincode8moonbash3lib8commands23awk__install__functions(vars, functions) {
  const _it = _M0MPB3Map5iter2GssE(functions);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$4 === undefined) {
      return;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _name = _x._0;
      const _def = _x._1;
      _M0MPB3Map3setGssE(vars, `${_M0FP410Haoxincode8moonbash3lib8commands21awk__fn__body__prefix}${_name}`, _def.body);
      _M0MPB3Map3setGssE(vars, `${_M0FP410Haoxincode8moonbash3lib8commands23awk__fn__params__prefix}${_name}`, _M0MPC15array5Array4joinGsE(_def.params, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands23awk__install__functionsN7_2abindS5875, 0, _M0FP410Haoxincode8moonbash3lib8commands23awk__install__functionsN7_2abindS5875.length)));
      continue;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands31awk__parse__optional__expr__ast(expr) {
  if (expr === undefined) {
    return undefined;
  } else {
    const _Some = expr;
    const _text = _Some;
    const p = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_text);
    return p.length === 0 ? undefined : _M0FP410Haoxincode8moonbash3lib8commands21awk__parse__expr__ast(p);
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands26awk__split__range__pattern(pattern) {
  const p = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(pattern);
  let quote = -1;
  let in_regex = false;
  let escaped = false;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < p.length) {
      _L: {
        $bound_check(p, i);
        const ch = p.charCodeAt(i);
        const _bind$4 = quote;
        if (_bind$4 === -1) {
          if (in_regex) {
            if (escaped) {
              escaped = false;
            } else {
              if (ch === 92) {
                escaped = true;
              } else {
                if (ch === 47) {
                  in_regex = false;
                }
              }
            }
          } else {
            if (ch === 34 || ch === 39) {
              quote = ch;
            } else {
              if (ch === 47) {
                in_regex = true;
                escaped = false;
              } else {
                if (ch === 44) {
                  const left = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(p, 0, i));
                  const right = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(p, i + 1 | 0, p.length));
                  if (left.length === 0 || right.length === 0) {
                    return { _0: undefined, _1: undefined };
                  }
                  return { _0: left, _1: right };
                }
              }
            }
          }
        } else {
          const _Some = _bind$4;
          const _q = _Some;
          if (ch === 92 && (i + 1 | 0) < p.length) {
            break _L;
          }
          if (ch === _q) {
            quote = -1;
          }
        }
        break _L;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return { _0: undefined, _1: undefined };
}
function _M0FP410Haoxincode8moonbash3lib8commands23awk__take__named__block(src, name) {
  let pos = -1;
  let brace_pos = -1;
  let i = 0;
  while (true) {
    if ((i + name.length | 0) <= src.length) {
      if (_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(src, i, i + name.length | 0) === name) {
        let left_ok;
        if (i === 0) {
          left_ok = true;
        } else {
          const _tmp$38 = i - 1 | 0;
          $bound_check(src, _tmp$38);
          left_ok = !_M0FP410Haoxincode8moonbash3lib8commands25awk__is__identifier__char(src.charCodeAt(_tmp$38));
        }
        if (left_ok) {
          let j = i + name.length | 0;
          while (true) {
            let _tmp$38;
            if (j < src.length) {
              const _tmp$39 = j;
              $bound_check(src, _tmp$39);
              _tmp$38 = _M0FP410Haoxincode8moonbash3lib8commands14awk__is__space(src.charCodeAt(_tmp$39));
            } else {
              _tmp$38 = false;
            }
            if (_tmp$38) {
              j = j + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          let _tmp$38;
          if (j < src.length) {
            const _tmp$39 = j;
            $bound_check(src, _tmp$39);
            _tmp$38 = src.charCodeAt(_tmp$39) === 123;
          } else {
            _tmp$38 = false;
          }
          if (_tmp$38) {
            pos = i;
            brace_pos = j;
            break;
          }
        }
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (pos < 0) {
    return { _0: undefined, _1: src };
  }
  const block_start = brace_pos + 1 | 0;
  let depth = 1;
  let j = block_start;
  while (true) {
    if (j < src.length && depth > 0) {
      const _tmp$38 = j;
      $bound_check(src, _tmp$38);
      const ch = src.charCodeAt(_tmp$38);
      if (ch === 123) {
        depth = depth + 1 | 0;
      } else {
        if (ch === 125) {
          depth = depth - 1 | 0;
        }
      }
      if (depth > 0) {
        j = j + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  if (depth !== 0) {
    return { _0: undefined, _1: src };
  }
  const block = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(src, block_start, j);
  const remaining = `${_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(src, 0, pos)}${_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(src, j + 1 | 0, src.length)}`;
  return { _0: block, _1: remaining };
}
function _M0FP410Haoxincode8moonbash3lib8commands19awk__parse__program(src) {
  const src$2 = _M0FP410Haoxincode8moonbash3lib8commands20awk__strip__comments(src);
  const begin_actions = [];
  let rest_after_begin = src$2;
  while (true) {
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands23awk__take__named__block(rest_after_begin, "BEGIN");
    const _block = _bind$4._0;
    const _next = _bind$4._1;
    if (_block === undefined) {
      break;
    } else {
      const _Some = _block;
      const _action = _Some;
      _M0MPC15array5Array4pushGUssEE(begin_actions, _action);
      rest_after_begin = _next;
    }
    continue;
  }
  const end_actions = [];
  let rest_after_end = rest_after_begin;
  while (true) {
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands23awk__take__named__block(rest_after_end, "END");
    const _block = _bind$4._0;
    const _next = _bind$4._1;
    if (_block === undefined) {
      break;
    } else {
      const _Some = _block;
      const _action = _Some;
      _M0MPC15array5Array4pushGUssEE(end_actions, _action);
      rest_after_end = _next;
    }
    continue;
  }
  const rest = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(rest_after_end);
  if (rest.length === 0) {
    return new _M0TP410Haoxincode8moonbash3lib8commands10AwkProgram(begin_actions, undefined, "", end_actions, false, undefined, undefined);
  }
  const brace_pos = _M0FP410Haoxincode8moonbash3lib8commands21aj__index__of_2einner(rest, 123, 0);
  if (brace_pos < 0) {
    const pattern = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(rest);
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands26awk__split__range__pattern(pattern);
    const _range_start = _bind$4._0;
    const _range_end = _bind$4._1;
    const range_start_ast = _M0FP410Haoxincode8moonbash3lib8commands31awk__parse__optional__expr__ast(_range_start);
    const range_end_ast = _M0FP410Haoxincode8moonbash3lib8commands31awk__parse__optional__expr__ast(_range_end);
    let pattern_ast;
    _L: {
      _L$2: {
        if (range_start_ast === undefined) {
          break _L$2;
        } else {
          if (range_end_ast === undefined) {
            break _L$2;
          } else {
            pattern_ast = undefined;
          }
        }
        break _L;
      }
      pattern_ast = _M0FP410Haoxincode8moonbash3lib8commands31awk__parse__optional__expr__ast(pattern);
    }
    return new _M0TP410Haoxincode8moonbash3lib8commands10AwkProgram(begin_actions, pattern_ast, "", end_actions, true, range_start_ast, range_end_ast);
  }
  const pattern = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(rest, 0, brace_pos));
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands26awk__split__range__pattern(pattern);
  const _range_start = _bind$4._0;
  const _range_end = _bind$4._1;
  const range_start_ast = _M0FP410Haoxincode8moonbash3lib8commands31awk__parse__optional__expr__ast(_range_start);
  const range_end_ast = _M0FP410Haoxincode8moonbash3lib8commands31awk__parse__optional__expr__ast(_range_end);
  let pattern_ast;
  _L: {
    _L$2: {
      if (range_start_ast === undefined) {
        break _L$2;
      } else {
        if (range_end_ast === undefined) {
          break _L$2;
        } else {
          pattern_ast = undefined;
        }
      }
      break _L;
    }
    pattern_ast = _M0FP410Haoxincode8moonbash3lib8commands31awk__parse__optional__expr__ast(pattern);
  }
  let depth = 1;
  let quote = -1;
  let i = brace_pos + 1 | 0;
  while (true) {
    if (i < rest.length && depth > 0) {
      const _tmp$38 = i;
      $bound_check(rest, _tmp$38);
      const ch = rest.charCodeAt(_tmp$38);
      const _bind$5 = quote;
      if (_bind$5 === -1) {
        if (ch === 34 || ch === 39) {
          quote = ch;
          i = i + 1 | 0;
        } else {
          if (ch === 123) {
            depth = depth + 1 | 0;
            i = i + 1 | 0;
          } else {
            if (ch === 125) {
              depth = depth - 1 | 0;
              if (depth > 0) {
                i = i + 1 | 0;
              }
            } else {
              i = i + 1 | 0;
            }
          }
        }
      } else {
        const _Some = _bind$5;
        const _q = _Some;
        if (ch === 92 && (i + 1 | 0) < rest.length) {
          i = i + 2 | 0;
          continue;
        }
        if (ch === _q) {
          quote = -1;
        }
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  const action = i <= rest.length ? _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(rest, brace_pos + 1 | 0, i) : "";
  return new _M0TP410Haoxincode8moonbash3lib8commands10AwkProgram(begin_actions, pattern_ast, action, end_actions, true, range_start_ast, range_end_ast);
}
function _M0FP410Haoxincode8moonbash3lib8commands27awk__parse__var__assignment(spec) {
  const eq_idx = _M0FP410Haoxincode8moonbash3lib8commands21aj__index__of_2einner(spec, 61, 0);
  if (eq_idx <= 0) {
    return undefined;
  }
  const name = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(spec, 0, eq_idx));
  const value = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(spec, eq_idx + 1 | 0, spec.length);
  if (!_M0FP410Haoxincode8moonbash3lib8commands19awk__is__identifier(name)) {
    return undefined;
  }
  return { _0: name, _1: value };
}
function _M0FP410Haoxincode8moonbash3lib8commands28awk__pattern__match__program(prog, line, fields, nr, nf, vars, array_vars, in_range) {
  if (!prog.has_main) {
    return { _0: false, _1: in_range };
  }
  _L: {
    const _bind$4 = prog.range_start_ast;
    const _bind$5 = prog.range_end_ast;
    if (_bind$4 === undefined) {
      break _L;
    } else {
      const _Some = _bind$4;
      const _start_ast = _Some;
      if (_bind$5 === undefined) {
        break _L;
      } else {
        const _Some$2 = _bind$5;
        const _end_ast = _Some$2;
        if (in_range) {
          const end_hit = _M0FP410Haoxincode8moonbash3lib8commands25awk__eval__condition__ast(_end_ast, line, fields, nr, nf, vars, array_vars);
          return { _0: true, _1: !end_hit };
        } else {
          const start_hit = _M0FP410Haoxincode8moonbash3lib8commands25awk__eval__condition__ast(_start_ast, line, fields, nr, nf, vars, array_vars);
          if (!start_hit) {
            return _M0FP410Haoxincode8moonbash3lib8commands28awk__pattern__match__programN5tupleS9224;
          } else {
            const end_hit = _M0FP410Haoxincode8moonbash3lib8commands25awk__eval__condition__ast(_end_ast, line, fields, nr, nf, vars, array_vars);
            return { _0: true, _1: !end_hit };
          }
        }
      }
    }
  }
  const _bind$4 = prog.pattern_ast;
  if (_bind$4 === undefined) {
    return _M0FP410Haoxincode8moonbash3lib8commands28awk__pattern__match__programN5tupleS9223;
  } else {
    const _Some = _bind$4;
    const _pattern_ast = _Some;
    return { _0: _M0FP410Haoxincode8moonbash3lib8commands25awk__eval__condition__ast(_pattern_ast, line, fields, nr, nf, vars, array_vars), _1: false };
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands30awk__set__active__expr__output(out) {
  _M0FP410Haoxincode8moonbash3lib8commands22awk__expr__eval__state.out = out;
}
function _M0FP410Haoxincode8moonbash3lib8commands8cmd__awk(ctx) {
  let fs = " ";
  let program = undefined;
  const files = [];
  const initial_vars = [];
  let i = 0;
  while (true) {
    if (i < ctx.args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(ctx.args, i);
      if (arg === "-v") {
        if ((i + 1 | 0) >= ctx.args.length) {
          return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("awk: option -v requires an argument\n");
        }
        const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands27awk__parse__var__assignment(_M0MPC15array5Array2atGUssEE(ctx.args, i + 1 | 0));
        if (_bind$4 === undefined) {
          return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`awk: invalid -v assignment: ${_M0MPC15array5Array2atGUssEE(ctx.args, i + 1 | 0)}\n`);
        } else {
          const _Some = _bind$4;
          const _x = _Some;
          const _name = _x._0;
          const _value = _x._1;
          _M0MPC15array5Array4pushGUssEE(initial_vars, { _0: _name, _1: _value });
        }
        i = i + 2 | 0;
        continue;
      }
      if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(arg, "-v") && arg.length > 2) {
        const spec = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(arg, 2, arg.length);
        const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands27awk__parse__var__assignment(spec);
        if (_bind$4 === undefined) {
          return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`awk: invalid -v assignment: ${spec}\n`);
        } else {
          const _Some = _bind$4;
          const _x = _Some;
          const _name = _x._0;
          const _value = _x._1;
          _M0MPC15array5Array4pushGUssEE(initial_vars, { _0: _name, _1: _value });
        }
        i = i + 1 | 0;
        continue;
      }
      if (arg === "-F" && (i + 1 | 0) < ctx.args.length) {
        fs = _M0MPC15array5Array2atGUssEE(ctx.args, i + 1 | 0);
        i = i + 2 | 0;
        continue;
      }
      if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(arg, "-F") && arg.length > 2) {
        fs = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(arg, 2, arg.length);
        i = i + 1 | 0;
        continue;
      }
      const _bind$4 = program;
      if (_bind$4 === undefined) {
        program = arg;
      } else {
        _M0MPC15array5Array4pushGUssEE(files, arg);
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (fs === "\\t") {
    fs = "\t";
  }
  const _bind$4 = program;
  let prog_src;
  if (_bind$4 === undefined) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("awk: missing program\n");
  } else {
    const _Some = _bind$4;
    prog_src = _Some;
  }
  const normalized_prog_src = _M0FP410Haoxincode8moonbash3lib8commands20awk__strip__comments(prog_src);
  if (_M0FP410Haoxincode8moonbash3lib8commands27aj__find__substring_2einner(normalized_prog_src, "\n'", 0) >= 0 || _M0FP410Haoxincode8moonbash3lib8commands27aj__find__substring_2einner(normalized_prog_src, "\r'", 0) >= 0) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("awk: syntax error\n");
  }
  const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands23awk__extract__functions(normalized_prog_src);
  const _program_without_functions = _bind$5._0;
  const _functions = _bind$5._1;
  const prog = _M0FP410Haoxincode8moonbash3lib8commands19awk__parse__program(_program_without_functions);
  let input;
  let filename;
  _L: {
    if (files.length > 0) {
      const path = _M0MPC15array5Array2atGUssEE(files, 0);
      if (path === "-") {
        input = ctx.stdin_content;
        filename = "-";
        break _L;
      } else {
        if (path === "/dev/null") {
          input = "";
          filename = "/dev/null";
          break _L;
        } else {
          let resolved;
          let _try_err;
          _L$2: {
            _L$3: {
              const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, path);
              if (_bind$6.$tag === 1) {
                const _ok = _bind$6;
                resolved = _ok._0;
              } else {
                const _err = _bind$6;
                _try_err = _err._0;
                break _L$3;
              }
              break _L$2;
            }
            const _FsError = _try_err;
            const _msg = _FsError._0;
            return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`awk: ${_msg}\n`);
          }
          let content;
          let _try_err$2;
          _L$3: {
            _L$4: {
              const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, resolved);
              if (_bind$6.$tag === 1) {
                const _ok = _bind$6;
                content = _ok._0;
              } else {
                const _err = _bind$6;
                _try_err$2 = _err._0;
                break _L$4;
              }
              break _L$3;
            }
            const _FsError = _try_err$2;
            const _msg = _FsError._0;
            return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`awk: ${_msg}\n`);
          }
          input = content;
          filename = path;
          break _L;
        }
      }
    } else {
      input = ctx.stdin_content;
      filename = "-";
      break _L;
    }
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _bind$6 = [];
  const vars = _M0MPB3Map3MapGssE(new _M0TPB9ArrayViewGUssEE(_bind$6, 0, 0), undefined);
  const _bind$7 = [];
  const array_vars = _M0MPB3Map3MapGssE(new _M0TPB9ArrayViewGUssEE(_bind$7, 0, 0), undefined);
  const lines = _M0FP410Haoxincode8moonbash3lib8commands25aj__split__lines__records(input);
  let nr = 0;
  _M0MPB3Map3setGssE(vars, "FS", fs);
  _M0MPB3Map3setGssE(vars, "FILENAME", filename);
  _M0MPB3Map3setGssE(vars, "NR", "0");
  _M0MPB3Map3setGssE(vars, "FNR", "0");
  _M0MPB3Map3setGssE(vars, "NF", "0");
  _M0MPB3Map3setGssE(vars, "RSTART", "0");
  _M0MPB3Map3setGssE(vars, "RLENGTH", "-1");
  _M0FP410Haoxincode8moonbash3lib8commands23awk__install__functions(vars, _functions);
  const _bind$8 = initial_vars.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$8) {
      const pair = initial_vars[_];
      _M0MPB3Map3setGssE(vars, pair._0, pair._1);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0FP410Haoxincode8moonbash3lib8commands30awk__set__active__expr__output(out);
  const _bind$9 = prog.begin_actions;
  const _bind$10 = _bind$9.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$10) {
      const action = _bind$9[_];
      if (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key)) {
        break;
      }
      const _bind$11 = _M0FP410Haoxincode8moonbash3lib8commands20awk__execute__action(ctx, action, lines, -1, "", [], nr, 0, fs, filename, vars, array_vars, out);
      const _new_nr = _bind$11._3;
      nr = _new_nr;
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let line_idx = 0;
  let in_range = false;
  while (true) {
    if (line_idx < lines.length) {
      if (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key)) {
        break;
      }
      const line = _M0MPC15array5Array2atGUssEE(lines, line_idx);
      nr = nr + 1 | 0;
      _M0MPB3Map3setGssE(vars, "NR", _M0MPC13int3Int18to__string_2einner(nr, 10));
      _M0MPB3Map3setGssE(vars, "FNR", _M0MPC13int3Int18to__string_2einner(nr, 10));
      _M0MPB3Map3setGssE(vars, "FILENAME", filename);
      const current_fs = _M0FP410Haoxincode8moonbash3lib8commands16awk__current__fs(fs, vars);
      const fields = _M0FP410Haoxincode8moonbash3lib8commands18awk__split__fields(line, current_fs);
      const nf = fields.length;
      _M0MPB3Map3setGssE(vars, "NF", _M0MPC13int3Int18to__string_2einner(nf, 10));
      _M0MPB3Map6removeGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__next__key);
      const _bind$11 = _M0FP410Haoxincode8moonbash3lib8commands28awk__pattern__match__program(prog, line, fields, nr, nf, vars, array_vars, in_range);
      const _matched = _bind$11._0;
      const _next_range = _bind$11._1;
      in_range = _next_range;
      if (_matched) {
        const _bind$12 = _M0FP410Haoxincode8moonbash3lib8commands20awk__execute__action(ctx, prog.action, lines, line_idx, line, fields, nr, nf, fs, filename, vars, array_vars, out);
        const _consumed = _bind$12._2;
        const _new_nr = _bind$12._3;
        nr = _new_nr;
        _M0MPB3Map3setGssE(vars, "NR", _M0MPC13int3Int18to__string_2einner(nr, 10));
        _M0MPB3Map3setGssE(vars, "FNR", _M0MPC13int3Int18to__string_2einner(nr, 10));
        _M0MPB3Map6removeGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__next__key);
        line_idx = line_idx + (_consumed + 1 | 0) | 0;
      } else {
        line_idx = line_idx + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  const begin_exit = _M0MPB3Map3getGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key);
  if (begin_exit === undefined) {
  } else {
    _M0MPB3Map6removeGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key);
  }
  if (!_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands21awk__ctrl__error__key)) {
    const _bind$11 = prog.end_actions;
    const _bind$12 = _bind$11.length;
    let _tmp$40 = 0;
    while (true) {
      const _ = _tmp$40;
      if (_ < _bind$12) {
        const action = _bind$11[_];
        if (_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key)) {
          break;
        }
        const end_idx = lines.length > 0 ? lines.length - 1 | 0 : -1;
        _M0FP410Haoxincode8moonbash3lib8commands20awk__execute__action(ctx, action, lines, end_idx, "", [], nr, 0, fs, filename, vars, array_vars, out);
        _tmp$40 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  if (!_M0MPB3Map8containsGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key)) {
    if (begin_exit === undefined) {
    } else {
      const _Some = begin_exit;
      const _code = _Some;
      _M0MPB3Map3setGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key, _code);
    }
  }
  const _bind$11 = _M0MPB3Map3getGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands20awk__ctrl__exit__key);
  let exit_code;
  if (_bind$11 === undefined) {
    exit_code = 0;
  } else {
    const _Some = _bind$11;
    const _code = _Some;
    exit_code = _M0FP410Haoxincode8moonbash3lib8commands14aj__parse__int(_code);
  }
  const _bind$12 = _M0MPB3Map3getGssE(vars, _M0FP410Haoxincode8moonbash3lib8commands21awk__ctrl__error__key);
  let stderr;
  if (_bind$12 === undefined) {
    stderr = "";
  } else {
    const _Some = _bind$12;
    const _msg = _Some;
    stderr = `awk: ${_msg}\n`;
  }
  _M0FP410Haoxincode8moonbash3lib8commands30awk__set__active__expr__output(undefined);
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(out.val, stderr, exit_code);
}
function _M0FP410Haoxincode8moonbash3lib8commands22cmd__cat__line__prefix(n) {
  const digits = _M0MPC13int3Int18to__string_2einner(n, 10);
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const pad = 6 - digits.length | 0;
  let i = 0;
  while (true) {
    if (i < pad) {
      _M0IPB13StringBuilderPB6Logger11write__char(out, 32);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger13write__string(out, digits);
  _M0IPB13StringBuilderPB6Logger11write__char(out, 9);
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands25cmd__cat__write__numbered(out, content, start_line) {
  const line_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let line_no = start_line;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < content.length) {
      $bound_check(content, i);
      const ch = content.charCodeAt(i);
      _M0IPB13StringBuilderPB6Logger11write__char(line_buf, ch);
      if (ch === 10) {
        _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands22cmd__cat__line__prefix(line_no));
        _M0IPB13StringBuilderPB6Logger13write__string(out, line_buf.val);
        _M0MPB13StringBuilder5reset(line_buf);
        line_no = line_no + 1 | 0;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (line_buf.val.length > 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands22cmd__cat__line__prefix(line_no));
    _M0IPB13StringBuilderPB6Logger13write__string(out, line_buf.val);
    line_no = line_no + 1 | 0;
  }
  return line_no;
}
function _M0FP410Haoxincode8moonbash3lib8commands8cmd__cat(ctx) {
  let number_lines = false;
  const files = [];
  const _bind$4 = ctx.args;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const arg = _bind$4[_];
      if (arg === "-n") {
        number_lines = true;
      } else {
        _M0MPC15array5Array4pushGUssEE(files, arg);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (files.length === 0) {
    if (!number_lines) {
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(ctx.stdin_content);
    }
    const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
    _M0FP410Haoxincode8moonbash3lib8commands25cmd__cat__write__numbered(out, ctx.stdin_content, 1);
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(out.val);
  }
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const errbuf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let exit_code = 0;
  let line_no = 1;
  const _bind$6 = files.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$6) {
      const arg = files[_];
      _L: {
        if (arg === "-") {
          if (number_lines) {
            line_no = _M0FP410Haoxincode8moonbash3lib8commands25cmd__cat__write__numbered(buf, ctx.stdin_content, line_no);
          } else {
            _M0IPB13StringBuilderPB6Logger13write__string(buf, ctx.stdin_content);
          }
          break _L;
        }
        let path;
        let _try_err;
        _L$2: {
          _L$3: {
            const _bind$7 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, arg);
            if (_bind$7.$tag === 1) {
              const _ok = _bind$7;
              path = _ok._0;
            } else {
              const _err = _bind$7;
              _try_err = _err._0;
              break _L$3;
            }
            break _L$2;
          }
          const _FsError = _try_err;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `cat: ${_msg}\n`);
          exit_code = 1;
          break _L;
        }
        let content;
        let _try_err$2;
        _L$3: {
          _L$4: {
            const _bind$7 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, path);
            if (_bind$7.$tag === 1) {
              const _ok = _bind$7;
              content = _ok._0;
            } else {
              const _err = _bind$7;
              _try_err$2 = _err._0;
              break _L$4;
            }
            break _L$3;
          }
          const _FsError = _try_err$2;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `cat: ${_msg}\n`);
          exit_code = 1;
          break _L;
        }
        if (number_lines) {
          line_no = _M0FP410Haoxincode8moonbash3lib8commands25cmd__cat__write__numbered(buf, content, line_no);
        } else {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, content);
        }
        break _L;
      }
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(buf.val, errbuf.val, exit_code);
}
function _M0FP410Haoxincode8moonbash3lib8commands20parse__octal__strict(s) {
  if (s.length === 0) {
    return undefined;
  }
  let result = 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      if (ch < 48 || ch > 55) {
        return undefined;
      }
      result = (Math.imul(result, 8) | 0) + (ch - 48 | 0) | 0;
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return result;
}
function _M0FP410Haoxincode8moonbash3lib8commands26chmod__apply__mode__string(current, mode_str) {
  _L: {
    _L$2: {
      _L$3: {
        _L$4: {
          switch (mode_str) {
            case "+x": {
              break _L$4;
            }
            case "a+x": {
              break _L$4;
            }
            case "u+x": {
              break _L$4;
            }
            case "go+x": {
              break _L$4;
            }
            case "ug+x": {
              break _L$4;
            }
            case "ugo+x": {
              break _L$4;
            }
            case "-x": {
              break _L$3;
            }
            case "a-x": {
              break _L$3;
            }
            case "u-x": {
              break _L$3;
            }
            case "go-x": {
              break _L$3;
            }
            case "ug-x": {
              break _L$3;
            }
            case "ugo-x": {
              break _L$3;
            }
            case "-r": {
              break _L$2;
            }
            case "a-r": {
              break _L$2;
            }
            case "-w": {
              break _L;
            }
            case "a-w": {
              break _L;
            }
            case "u+s": {
              return current | 2048;
            }
            case "g+s": {
              return current | 1024;
            }
            default: {
              return _M0FP410Haoxincode8moonbash3lib8commands20parse__octal__strict(mode_str);
            }
          }
        }
        return current | 73;
      }
      return current & 438;
    }
    return current & 219;
  }
  return current & 365;
}
function _M0FP410Haoxincode8moonbash3lib8commands18chmod__entry__mode(entry) {
  switch (entry.$tag) {
    case 0: {
      const _File = entry;
      const _data = _File._0;
      return _data.mode;
    }
    case 1: {
      const _Directory = entry;
      const _data$2 = _Directory._0;
      return _data$2.mode;
    }
    default: {
      const _Symlink = entry;
      const _data$3 = _Symlink._0;
      return _data$3.mode;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands10cmd__chmod(ctx) {
  let recursive = false;
  const args = [];
  let parsing_options = true;
  const _bind$4 = ctx.args;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const arg = _bind$4[_];
      if (parsing_options && arg === "-R") {
        recursive = true;
      } else {
        parsing_options = false;
        _M0MPC15array5Array4pushGUssEE(args, arg);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (args.length < 2) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("chmod: missing operand\n");
  }
  const mode_str = _M0MPC15array5Array2atGUssEE(args, 0);
  const _bind$6 = _M0FP410Haoxincode8moonbash3lib8commands26chmod__apply__mode__string(0, mode_str);
  if (_bind$6 === undefined) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`chmod: invalid mode: '${mode_str}'\n`);
  }
  const errbuf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let exit_code = 0;
  let _tmp$39 = 1;
  while (true) {
    const i = _tmp$39;
    if (i < args.length) {
      _L: {
        const path = _M0MPC15array5Array2atGUssEE(args, i);
        let resolved;
        let _try_err;
        _L$2: {
          _L$3: {
            const _bind$7 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, path);
            if (_bind$7.$tag === 1) {
              const _ok = _bind$7;
              resolved = _ok._0;
            } else {
              const _err = _bind$7;
              _try_err = _err._0;
              break _L$3;
            }
            break _L$2;
          }
          const _FsError = _try_err;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `chmod: ${_msg}\n`);
          exit_code = 1;
          break _L;
        }
        if (!_M0MPB3Map8containsGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(ctx.fs.entries, resolved)) {
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `chmod: cannot access '${path}': No such file or directory\n`);
          exit_code = 1;
          break _L;
        }
        const _bind$7 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(ctx.fs.entries, resolved);
        let target_mode;
        if (_bind$7 === undefined) {
          target_mode = 0;
        } else {
          const _Some = _bind$7;
          const _entry = _Some;
          const _bind$8 = _M0FP410Haoxincode8moonbash3lib8commands26chmod__apply__mode__string(_M0FP410Haoxincode8moonbash3lib8commands18chmod__entry__mode(_entry), mode_str);
          if (_bind$8 === undefined) {
            target_mode = 0;
          } else {
            const _Some$2 = _bind$8;
            target_mode = _Some$2;
          }
        }
        let _try_err$2;
        _L$3: {
          _L$4: {
            const _bind$8 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs5chmod(ctx.fs, resolved, target_mode);
            if (_bind$8.$tag === 1) {
              const _ok = _bind$8;
              _ok._0;
            } else {
              const _err = _bind$8;
              _try_err$2 = _err._0;
              break _L$4;
            }
            break _L$3;
          }
          const _FsError = _try_err$2;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `chmod: ${_msg}\n`);
          exit_code = 1;
          break _L;
        }
        if (recursive) {
          const prefix = `${resolved}/`;
          const child_paths = [];
          const _p$4 = ctx.fs.entries;
          let _tmp$40 = _p$4.head;
          while (true) {
            const _p$5 = _tmp$40;
            if (_p$5 === undefined) {
              break;
            } else {
              const _p$6 = _p$5;
              const _p$7 = _p$6;
              const _p$8 = _p$7.key;
              const _p$9 = _p$7.next;
              if (_M0MPC16string6String11has__prefix(_p$8, new _M0TPC16string10StringView(prefix, 0, prefix.length))) {
                _M0MPC15array5Array4pushGUssEE(child_paths, _p$8);
              }
              _tmp$40 = _p$9;
              continue;
            }
          }
          const _bind$8 = child_paths.length;
          let _tmp$41 = 0;
          while (true) {
            const _ = _tmp$41;
            if (_ < _bind$8) {
              const child_path = child_paths[_];
              const _bind$9 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(ctx.fs.entries, child_path);
              let child_mode;
              if (_bind$9 === undefined) {
                child_mode = 0;
              } else {
                const _Some = _bind$9;
                const _entry = _Some;
                const _bind$10 = _M0FP410Haoxincode8moonbash3lib8commands26chmod__apply__mode__string(_M0FP410Haoxincode8moonbash3lib8commands18chmod__entry__mode(_entry), mode_str);
                if (_bind$10 === undefined) {
                  child_mode = 0;
                } else {
                  const _Some$2 = _bind$10;
                  child_mode = _Some$2;
                }
              }
              let _try_err$3;
              _L$4: {
                _L$5: {
                  const _bind$10 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs5chmod(ctx.fs, child_path, child_mode);
                  if (_bind$10.$tag === 1) {
                    const _ok = _bind$10;
                    _ok._0;
                  } else {
                    const _err = _bind$10;
                    _try_err$3 = _err._0;
                    break _L$5;
                  }
                  break _L$4;
                }
                const _FsError = _try_err$3;
                const _msg = _FsError._0;
                _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `chmod: ${_msg}\n`);
                exit_code = 1;
              }
              _tmp$41 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
        }
        break _L;
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", errbuf.val, exit_code);
}
function _M0FP410Haoxincode8moonbash3lib8commands7cmd__cp(ctx) {
  let recursive = false;
  const paths = [];
  const _bind$4 = ctx.args;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const arg = _bind$4[_];
      _L: {
        _L$2: {
          switch (arg) {
            case "-r": {
              break _L$2;
            }
            case "-R": {
              break _L$2;
            }
            case "-a": {
              break _L$2;
            }
            default: {
              _M0MPC15array5Array4pushGUssEE(paths, arg);
            }
          }
          break _L;
        }
        recursive = true;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (paths.length < 2) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("cp: missing operand\n");
  }
  let dst;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, _M0MPC15array5Array2atGUssEE(paths, paths.length - 1 | 0));
      if (_bind$6.$tag === 1) {
        const _ok = _bind$6;
        dst = _ok._0;
      } else {
        const _err = _bind$6;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    const _FsError = _try_err;
    const _msg = _FsError._0;
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`cp: ${_msg}\n`);
  }
  if (paths.length > 2) {
    let dst_is_dir;
    let _try_err$2;
    _L$2: {
      _L$3: {
        const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs4stat(ctx.fs, dst);
        let stat;
        if (_bind$6.$tag === 1) {
          const _ok = _bind$6;
          stat = _ok._0;
        } else {
          const _err = _bind$6;
          _try_err$2 = _err._0;
          break _L$3;
        }
        dst_is_dir = stat.is_directory;
        break _L$2;
      }
      dst_is_dir = false;
    }
    if (!dst_is_dir) {
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`cp: target '${_M0MPC15array5Array2atGUssEE(paths, paths.length - 1 | 0)}' is not a directory\n`);
    }
  }
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < (paths.length - 1 | 0)) {
      let src;
      let _try_err$2;
      _L$2: {
        _L$3: {
          const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, _M0MPC15array5Array2atGUssEE(paths, i));
          if (_bind$6.$tag === 1) {
            const _ok = _bind$6;
            src = _ok._0;
          } else {
            const _err = _bind$6;
            _try_err$2 = _err._0;
            break _L$3;
          }
          break _L$2;
        }
        const _FsError = _try_err$2;
        const _msg = _FsError._0;
        return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`cp: ${_msg}\n`);
      }
      let _try_err$3;
      _L$3: {
        _L$4: {
          const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10cp_2einner(ctx.fs, src, dst, recursive);
          if (_bind$6.$tag === 1) {
            const _ok = _bind$6;
            _ok._0;
          } else {
            const _err = _bind$6;
            _try_err$3 = _err._0;
            break _L$4;
          }
          break _L$3;
        }
        const _FsError = _try_err$3;
        const _msg = _FsError._0;
        return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`cp: ${_msg}\n`);
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", "", 0);
}
function _M0FP410Haoxincode8moonbash3lib8commands20csvlook__parse__args(args) {
  let parsed;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP218peter_2djerry_2dye11parse__args5parse(new _M0TPB9ArrayViewGsE(args, 0, args.length), undefined, undefined, undefined, undefined, undefined, _M0FP410Haoxincode8moonbash3lib8commands20csvlook__parse__argsN6constrS9225, -1);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        parsed = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    return new _M0TP410Haoxincode8moonbash3lib8commands13CsvlookConfig(undefined);
  }
  return new _M0TP410Haoxincode8moonbash3lib8commands13CsvlookConfig(parsed.positional.length > 0 ? _M0MPC15array5Array2atGUssEE(parsed.positional, 0) : undefined);
}
function _M0FP410Haoxincode8moonbash3lib8commands17xan__draw__border(out, widths) {
  _M0IPB13StringBuilderPB6Logger11write__char(out, 43);
  const _bind$4 = widths.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const w = widths[_];
      let _tmp$39 = 0;
      while (true) {
        const _j = _tmp$39;
        if (_j < (w + 2 | 0)) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 45);
          _tmp$39 = _j + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, 43);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
}
function _M0FP410Haoxincode8moonbash3lib8commands8xan__pad(out, count) {
  let _tmp$38 = 0;
  while (true) {
    const _i = _tmp$38;
    if (_i < count) {
      _M0IPB13StringBuilderPB6Logger11write__char(out, 32);
      _tmp$38 = _i + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands9xan__view(csv) {
  const headers = csv.headers;
  const rows = csv.rows;
  if (headers.length === 0) {
    return "";
  }
  const widths = _M0MPC15array5Array4makeGiE(headers.length, 0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < headers.length) {
      _M0MPC15array5Array3setGiE(widths, i, _M0MPC15array5Array2atGUssEE(headers, i).length);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$4 = rows.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$4) {
      const row = rows[_];
      let _tmp$40 = 0;
      while (true) {
        const i = _tmp$40;
        if (i < headers.length) {
          if (i < row.length) {
            const val = _M0MPC16string6String7replace(_M0MPC15array5Array2atGUssEE(row, i), new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands9xan__viewN7_2abindS6200, 0, _M0FP410Haoxincode8moonbash3lib8commands9xan__viewN7_2abindS6200.length), new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands9xan__viewN7_2abindS6201, 0, _M0FP410Haoxincode8moonbash3lib8commands9xan__viewN7_2abindS6201.length));
            if (val.length > _M0MPC15array5Array2atGiE(widths, i)) {
              _M0MPC15array5Array3setGiE(widths, i, val.length);
            }
          }
          _tmp$40 = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0FP410Haoxincode8moonbash3lib8commands17xan__draw__border(out, widths);
  _M0IPB13StringBuilderPB6Logger11write__char(out, 124);
  let _tmp$40 = 0;
  while (true) {
    const i = _tmp$40;
    if (i < headers.length) {
      _M0IPB13StringBuilderPB6Logger11write__char(out, 32);
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(headers, i));
      _M0FP410Haoxincode8moonbash3lib8commands8xan__pad(out, _M0MPC15array5Array2atGiE(widths, i) - _M0MPC15array5Array2atGUssEE(headers, i).length | 0);
      _M0IPB13StringBuilderPB6Logger13write__string(out, " |");
      _tmp$40 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
  _M0FP410Haoxincode8moonbash3lib8commands17xan__draw__border(out, widths);
  const _bind$5 = rows.length;
  let _tmp$41 = 0;
  while (true) {
    const _ = _tmp$41;
    if (_ < _bind$5) {
      const row = rows[_];
      _M0IPB13StringBuilderPB6Logger11write__char(out, 124);
      let _tmp$42 = 0;
      while (true) {
        const i = _tmp$42;
        if (i < headers.length) {
          const raw_val = i < row.length ? _M0MPC15array5Array2atGUssEE(row, i) : "";
          const val = _M0MPC16string6String7replace(raw_val, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands9xan__viewN7_2abindS6210, 0, _M0FP410Haoxincode8moonbash3lib8commands9xan__viewN7_2abindS6210.length), new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands9xan__viewN7_2abindS6211, 0, _M0FP410Haoxincode8moonbash3lib8commands9xan__viewN7_2abindS6211.length));
          _M0IPB13StringBuilderPB6Logger11write__char(out, 32);
          _M0IPB13StringBuilderPB6Logger13write__string(out, val);
          _M0FP410Haoxincode8moonbash3lib8commands8xan__pad(out, _M0MPC15array5Array2atGiE(widths, i) - val.length | 0);
          _M0IPB13StringBuilderPB6Logger13write__string(out, " |");
          _tmp$42 = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
      _tmp$41 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0FP410Haoxincode8moonbash3lib8commands17xan__draw__border(out, widths);
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands12cmd__csvlook(ctx) {
  const config = _M0FP410Haoxincode8moonbash3lib8commands20csvlook__parse__args(ctx.args);
  const _bind$4 = config.file_path;
  let content;
  if (_bind$4 === undefined) {
    content = ctx.stdin_content;
  } else {
    const _Some = _bind$4;
    const _path = _Some;
    if (_path === "-") {
      content = ctx.stdin_content;
    } else {
      let resolved;
      let _try_err;
      _L: {
        _L$2: {
          const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, _path);
          if (_bind$5.$tag === 1) {
            const _ok = _bind$5;
            resolved = _ok._0;
          } else {
            const _err = _bind$5;
            _try_err = _err._0;
            break _L$2;
          }
          break _L;
        }
        const _FsError = _try_err;
        const _msg = _FsError._0;
        return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`csvlook: ${_msg}\n`);
      }
      let _try_err$2;
      _L$2: {
        _L$3: {
          const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, resolved);
          if (_bind$5.$tag === 1) {
            const _ok = _bind$5;
            content = _ok._0;
          } else {
            const _err = _bind$5;
            _try_err$2 = _err._0;
            break _L$3;
          }
          break _L$2;
        }
        const _FsError = _try_err$2;
        const _msg = _FsError._0;
        return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`csvlook: ${_msg}\n`);
      }
    }
  }
  if (content.length === 0) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("csvlook: missing input\n");
  }
  const csv = _M0MP410Haoxincode8moonbash3lib6nyacsv3CSV13parse__string(content, undefined);
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(_M0FP410Haoxincode8moonbash3lib8commands9xan__view(csv));
}
function _M0FP410Haoxincode8moonbash3lib8commands16net__curl__error(code, message, silent) {
  return silent ? _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", "", code) : _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", `curl: (${_M0IPC13int3IntPB4Show10to__string(code)}) ${message}\n`, code);
}
function _M0FP410Haoxincode8moonbash3lib8commands15net__hex__digit(n) {
  return n < 10 ? n + 48 | 0 : (n - 10 | 0) + 97 | 0;
}
function _M0FP410Haoxincode8moonbash3lib8commands25net__json__escape__string(s) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger11write__char(out, 34);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      switch (ch) {
        case 34: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, "\\\"");
          break;
        }
        case 92: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, "\\\\");
          break;
        }
        case 10: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, "\\n");
          break;
        }
        case 13: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, "\\r");
          break;
        }
        case 9: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, "\\t");
          break;
        }
        default: {
          const code = ch;
          if (code < 32) {
            _M0IPB13StringBuilderPB6Logger13write__string(out, "\\u00");
            _M0IPB13StringBuilderPB6Logger11write__char(out, _M0FP410Haoxincode8moonbash3lib8commands15net__hex__digit(code / 16 | 0));
            _M0IPB13StringBuilderPB6Logger11write__char(out, _M0FP410Haoxincode8moonbash3lib8commands15net__hex__digit(code % 16 | 0));
          } else {
            _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
          }
        }
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger11write__char(out, 34);
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands22net__headers__to__json(headers) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger11write__char(out, 123);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < headers.length) {
      if (i > 0) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 44);
      }
      const _bind$4 = _M0MPC15array5Array2atGUssEE(headers, i);
      const _k = _bind$4._0;
      const _v = _bind$4._1;
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands25net__json__escape__string(_k));
      _M0IPB13StringBuilderPB6Logger11write__char(out, 58);
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands25net__json__escape__string(_v));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger11write__char(out, 125);
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands32net__build__fetch__request__json(url, http_method, headers, body) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger11write__char(out, 123);
  _M0IPB13StringBuilderPB6Logger13write__string(out, "\"url\":");
  _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands25net__json__escape__string(url));
  _M0IPB13StringBuilderPB6Logger13write__string(out, ",\"method\":");
  _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands25net__json__escape__string(http_method));
  _M0IPB13StringBuilderPB6Logger13write__string(out, ",\"headers\":");
  _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands22net__headers__to__json(headers));
  if (body === undefined) {
  } else {
    const _Some = body;
    const _content = _Some;
    _M0IPB13StringBuilderPB6Logger13write__string(out, ",\"body\":");
    _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands25net__json__escape__string(_content));
  }
  _M0IPB13StringBuilderPB6Logger11write__char(out, 125);
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands20net__json__get__bool(obj, key, default_value) {
  _L: {
    const _bind$4 = _M0MPB3Map3getGsRPB4JsonE(obj, key);
    if (_bind$4 === undefined) {
      break _L;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      switch (_x.$tag) {
        case 1: {
          return true;
        }
        case 2: {
          return false;
        }
        case 4: {
          const _String = _x;
          const _x$2 = _String._0;
          switch (_x$2) {
            case "true": {
              return true;
            }
            case "false": {
              return false;
            }
            default: {
              break _L;
            }
          }
        }
        default: {
          break _L;
        }
      }
    }
  }
  return default_value;
}
function _M0FP410Haoxincode8moonbash3lib8commands23net__json__get__headers(obj) {
  _L: {
    const _bind$4 = _M0MPB3Map3getGsRPB4JsonE(obj, "headers");
    if (_bind$4 === undefined) {
      break _L;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      if (_x.$tag === 6) {
        const _Object = _x;
        const _headers_obj = _Object._0;
        const headers = [];
        const _it = _M0MPB3Map5iter2GssE(_headers_obj);
        while (true) {
          const _bind$5 = _M0MPB5Iter24nextGssE(_it);
          if (_bind$5 === undefined) {
            break;
          } else {
            const _Some$2 = _bind$5;
            const _x$2 = _Some$2;
            const _key = _x$2._0;
            const _value = _x$2._1;
            let text;
            switch (_value.$tag) {
              case 4: {
                const _String = _value;
                text = _String._0;
                break;
              }
              case 3: {
                const _Number = _value;
                const _n = _Number._0;
                text = _M0MPC13int3Int18to__string_2einner(_M0MPC16double6Double7to__int(_n), 10);
                break;
              }
              case 1: {
                text = "true";
                break;
              }
              case 2: {
                text = "false";
                break;
              }
              case 0: {
                text = "";
                break;
              }
              default: {
                text = _M0MPC14json4Json17stringify_2einner(_value, false, 0, undefined);
              }
            }
            _M0MPC15array5Array4pushGUssEE(headers, { _0: _key, _1: text });
            continue;
          }
        }
        _M0MPC15array5Array8sort__byGUssEE(headers, (a, b) => _M0IP016_24default__implPB7Compare6op__ltGsE(a._0, b._0) ? -1 : _M0IP016_24default__implPB7Compare6op__gtGsE(a._0, b._0) ? 1 : 0);
        return headers;
      } else {
        break _L;
      }
    }
  }
  return [];
}
function _M0FP410Haoxincode8moonbash3lib8commands19net__json__get__int(obj, key, default_value) {
  _L: {
    const _bind$4 = _M0MPB3Map3getGsRPB4JsonE(obj, key);
    if (_bind$4 === undefined) {
      break _L;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      switch (_x.$tag) {
        case 3: {
          const _Number = _x;
          const _n = _Number._0;
          return _M0MPC16double6Double7to__int(_n);
        }
        case 4: {
          const _String = _x;
          const _s = _String._0;
          return Number(BigInt.asIntN(32, _M0FP410Haoxincode8moonbash3lib8commands15cmd__parse__int(_s))) | 0;
        }
        default: {
          break _L;
        }
      }
    }
  }
  return default_value;
}
function _M0FP410Haoxincode8moonbash3lib8commands22net__json__get__string(obj, key, default_value) {
  _L: {
    const _bind$4 = _M0MPB3Map3getGsRPB4JsonE(obj, key);
    if (_bind$4 === undefined) {
      break _L;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      switch (_x.$tag) {
        case 4: {
          const _String = _x;
          return _String._0;
        }
        case 3: {
          const _Number = _x;
          const _n = _Number._0;
          return _M0MPC13int3Int18to__string_2einner(_M0MPC16double6Double7to__int(_n), 10);
        }
        case 1: {
          return "true";
        }
        case 2: {
          return "false";
        }
        case 0: {
          return "";
        }
        default: {
          break _L;
        }
      }
    }
  }
  return default_value;
}
function _M0FP410Haoxincode8moonbash3lib8commands27net__parse__fetch__response(json_str) {
  let parsed;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FPC14json13parse_2einner(new _M0TPC16string10StringView(json_str, 0, json_str.length), 1024);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        parsed = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    return _M0FP410Haoxincode8moonbash3lib8commands27net__parse__fetch__responseN6constrS9226;
  }
  if (parsed.$tag === 6) {
    const _Object = parsed;
    const _obj = _Object._0;
    const status_text = _M0FP410Haoxincode8moonbash3lib8commands22net__json__get__string(_obj, "statusText", _M0FP410Haoxincode8moonbash3lib8commands22net__json__get__string(_obj, "status_text", ""));
    return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands16NetFetchResponsesE2Ok(new _M0TP410Haoxincode8moonbash3lib8commands16NetFetchResponse(_M0FP410Haoxincode8moonbash3lib8commands20net__json__get__bool(_obj, "ok", false), _M0FP410Haoxincode8moonbash3lib8commands19net__json__get__int(_obj, "status", 0), status_text, _M0FP410Haoxincode8moonbash3lib8commands22net__json__get__string(_obj, "body", ""), _M0FP410Haoxincode8moonbash3lib8commands22net__json__get__string(_obj, "error", ""), _M0FP410Haoxincode8moonbash3lib8commands23net__json__get__headers(_obj)));
  } else {
    return _M0FP410Haoxincode8moonbash3lib8commands27net__parse__fetch__responseN6constrS9227;
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands15net__fetch__url(url, http_method, headers, body) {
  const request_json = _M0FP410Haoxincode8moonbash3lib8commands32net__build__fetch__request__json(url, http_method, headers, body);
  const raw = _M0FP410Haoxincode8moonbash3lib3ffi11fetch__sync(request_json);
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands27net__parse__fetch__response(raw);
  let response;
  if (_bind$4.$tag === 0) {
    const _Err = _bind$4;
    const _msg = _Err._0;
    return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands16NetFetchResponsesE3Err(_msg);
  } else {
    const _Ok = _bind$4;
    response = _Ok._0;
  }
  if (!response.ok && (response.status === 0 && response.error.length === 0)) {
    return _M0FP410Haoxincode8moonbash3lib8commands15net__fetch__urlN6constrS9228;
  }
  if (response.error.length > 0) {
    return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands16NetFetchResponsesE3Err(response.error);
  }
  return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands16NetFetchResponsesE2Ok(response);
}
function _M0FP410Haoxincode8moonbash3lib8commands25net__format__status__line(resp) {
  return resp.status_text.length > 0 ? `HTTP/1.1 ${_M0IPC13int3IntPB4Show10to__string(resp.status)} ${resp.status_text}\n` : `HTTP/1.1 ${_M0IPC13int3IntPB4Show10to__string(resp.status)}\n`;
}
function _M0FP410Haoxincode8moonbash3lib8commands20net__format__headers(resp) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands25net__format__status__line(resp));
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < resp.headers.length) {
      const _bind$4 = _M0MPC15array5Array2atGUssEE(resp.headers, i);
      const _k = _bind$4._0;
      const _v = _bind$4._1;
      _M0IPB13StringBuilderPB6Logger13write__string(out, _k);
      _M0IPB13StringBuilderPB6Logger13write__string(out, ": ");
      _M0IPB13StringBuilderPB6Logger13write__string(out, _v);
      _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands28net__normalize__request__url(raw_url) {
  const _bind$4 = _M0MP210tonyfettes3url3Url10try__parse(new _M0TPC16string10StringView(raw_url, 0, raw_url.length), undefined, _M0DTPC16option6OptionGRPB5ArrayGRP210tonyfettes3url15ValidationErrorEE4None__);
  if (_bind$4 === undefined) {
    return _M0FP410Haoxincode8moonbash3lib8commands28net__normalize__request__urlN6constrS9230;
  } else {
    const _Some = _bind$4;
    const _url = _Some;
    const protocol = _M0MP210tonyfettes3url3Url8protocol(_url);
    return protocol === "http:" || protocol === "https:" ? new _M0DTPC16result6ResultGssE2Ok(_M0MP210tonyfettes3url3Url4href(_url)) : _M0FP410Haoxincode8moonbash3lib8commands28net__normalize__request__urlN6constrS9229;
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands28net__arg__starts__with__dash(arg) {
  if (arg.length > 0) {
    const _p$4 = 0;
    $bound_check(arg, _p$4);
    return arg.charCodeAt(_p$4) === 45;
  } else {
    return false;
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands32net__args__contain__double__dash(args) {
  const _bind$4 = args.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const arg = args[_];
      if (arg === "--") {
        return true;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib8commands17net__ascii__upper(s) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      if (ch >= 97 && ch <= 122) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch - 32 | 0);
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands38net__curl__has__invalid__short__bundle(arg) {
  let _tmp$38;
  if (arg.length <= 1) {
    _tmp$38 = true;
  } else {
    const _p$4 = 0;
    $bound_check(arg, _p$4);
    _tmp$38 = arg.charCodeAt(_p$4) !== 45;
  }
  if (_tmp$38) {
    return false;
  }
  let _tmp$39;
  if (arg.length >= 2) {
    const _p$4 = 1;
    $bound_check(arg, _p$4);
    _tmp$39 = arg.charCodeAt(_p$4) === 45;
  } else {
    _tmp$39 = false;
  }
  if (_tmp$39) {
    return false;
  }
  if (arg === "-X" || (arg === "-H" || (arg === "-d" || arg === "-o"))) {
    return false;
  }
  if (arg.length > 2) {
    const _p$4 = 1;
    $bound_check(arg, _p$4);
    const first = arg.charCodeAt(_p$4);
    if (first === 88 || (first === 72 || first === 111)) {
      return false;
    }
  }
  const _bind$4 = arg.length;
  let _tmp$40 = 1;
  while (true) {
    const i = _tmp$40;
    if (i < _bind$4) {
      $bound_check(arg, i);
      const flag = arg.charCodeAt(i);
      if (flag === 88 || (flag === 72 || (flag === 100 || flag === 111))) {
        return true;
      }
      _tmp$40 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib8commands31net__curl__parse__error__result(msg) {
  if (msg === "Option --method requires a value" || msg === "Option -X requires a value") {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", "curl: option -X requires an argument\n", 2);
  }
  if (msg === "Collection --header requires a value" || msg === "Collection -H requires a value") {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", "curl: option -H requires an argument\n", 2);
  }
  if (msg === "Option --data requires a value" || msg === "Option -d requires a value") {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", "curl: option -d requires an argument\n", 2);
  }
  if (msg === "Option --output requires a value" || msg === "Option -o requires a value") {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", "curl: option -o requires an argument\n", 2);
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", `curl: ${msg}\n`, 2);
}
function _M0FP410Haoxincode8moonbash3lib8commands27net__curl__preprocess__args(args) {
  const normalized = [];
  const _bind$4 = args.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const arg = args[_];
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands27net__curl__preprocess__argsN7_2abindS6352, 0, _M0FP410Haoxincode8moonbash3lib8commands27net__curl__preprocess__argsN7_2abindS6352.length)) && arg.length > 2) {
        _M0MPC15array5Array4pushGUssEE(normalized, "-X");
        _M0MPC15array5Array4pushGUssEE(normalized, _M0FP410Haoxincode8moonbash3lib8commands17cmd__substr__from(arg, 2));
      } else {
        if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands27net__curl__preprocess__argsN7_2abindS6353, 0, _M0FP410Haoxincode8moonbash3lib8commands27net__curl__preprocess__argsN7_2abindS6353.length)) && arg.length > 2) {
          _M0MPC15array5Array4pushGUssEE(normalized, "-H");
          _M0MPC15array5Array4pushGUssEE(normalized, _M0FP410Haoxincode8moonbash3lib8commands17cmd__substr__from(arg, 2));
        } else {
          if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands27net__curl__preprocess__argsN7_2abindS6354, 0, _M0FP410Haoxincode8moonbash3lib8commands27net__curl__preprocess__argsN7_2abindS6354.length)) && arg.length > 2) {
            _M0MPC15array5Array4pushGUssEE(normalized, "-o");
            _M0MPC15array5Array4pushGUssEE(normalized, _M0FP410Haoxincode8moonbash3lib8commands17cmd__substr__from(arg, 2));
          } else {
            _M0MPC15array5Array4pushGUssEE(normalized, arg);
          }
        }
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return normalized;
}
function _M0FP410Haoxincode8moonbash3lib8commands38net__curl__unsupported__option__result(arg) {
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", `curl: unsupported option -- '${arg}'\n`, 2);
}
function _M0FP410Haoxincode8moonbash3lib8commands20net__index__of__char(s, target, start) {
  let i = start;
  while (true) {
    if (i < s.length) {
      const _tmp$38 = i;
      $bound_check(s, _tmp$38);
      if (s.charCodeAt(_tmp$38) === target) {
        return i;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410Haoxincode8moonbash3lib8commands19net__is__whitespace(ch) {
  return ch === 32 || (ch === 9 || (ch === 10 || ch === 13));
}
function _M0FP410Haoxincode8moonbash3lib8commands9net__trim(s) {
  let start = 0;
  let end_ = s.length;
  while (true) {
    if (start < end_) {
      const _tmp$38 = start;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (_M0FP410Haoxincode8moonbash3lib8commands19net__is__whitespace(ch)) {
        start = start + 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (end_ > start) {
      const _tmp$38 = end_ - 1 | 0;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (_M0FP410Haoxincode8moonbash3lib8commands19net__is__whitespace(ch)) {
        end_ = end_ - 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  return _M0FP410Haoxincode8moonbash3lib8commands18cmd__substr__slice(s, start, end_);
}
function _M0FP410Haoxincode8moonbash3lib8commands18net__parse__header(raw) {
  const idx = _M0FP410Haoxincode8moonbash3lib8commands20net__index__of__char(raw, 58, 0);
  if (idx <= 0) {
    return undefined;
  }
  const key = _M0FP410Haoxincode8moonbash3lib8commands9net__trim(_M0FP410Haoxincode8moonbash3lib8commands18cmd__substr__slice(raw, 0, idx));
  const value = _M0FP410Haoxincode8moonbash3lib8commands9net__trim(_M0FP410Haoxincode8moonbash3lib8commands18cmd__substr__slice(raw, idx + 1 | 0, raw.length));
  return key.length === 0 ? undefined : { _0: key, _1: value };
}
function _M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__args(raw_args) {
  const _bind$4 = raw_args.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const arg = raw_args[_];
      if (_M0FP410Haoxincode8moonbash3lib8commands38net__curl__has__invalid__short__bundle(arg)) {
        return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands13NetCurlConfigRP410Haoxincode8moonbash3lib3ast10ExecResultE3Err(_M0FP410Haoxincode8moonbash3lib8commands38net__curl__unsupported__option__result(arg));
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const args = _M0FP410Haoxincode8moonbash3lib8commands27net__curl__preprocess__args(raw_args);
  const aliases = _M0MPB3Map3MapGssE(new _M0TPB9ArrayViewGUssEE(_M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__argsN7_2abindS6394, 0, 7), undefined);
  let parsed;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$5 = _M0FP218peter_2djerry_2dye11parse__args5parse(new _M0TPB9ArrayViewGsE(args, 0, args.length), new _M0TPB9ArrayViewGsE(_M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__argsN7_2abindS6388, 0, 3), new _M0TPB9ArrayViewGsE(_M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__argsN7_2abindS6389, 0, 3), new _M0TPB9ArrayViewGsE(_M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__argsN7_2abindS6390, 0, 1), aliases, undefined, -1, -1);
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        parsed = _ok._0;
      } else {
        const _err = _bind$5;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    const _ParseError = _try_err;
    const _msg = _ParseError._0;
    return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands13NetCurlConfigRP410Haoxincode8moonbash3lib3ast10ExecResultE3Err(_M0FP410Haoxincode8moonbash3lib8commands31net__curl__parse__error__result(_msg));
  }
  if (!_M0FP410Haoxincode8moonbash3lib8commands32net__args__contain__double__dash(args)) {
    const _bind$5 = parsed.positional;
    const _bind$6 = _bind$5.length;
    let _tmp$39 = 0;
    while (true) {
      const _ = _tmp$39;
      if (_ < _bind$6) {
        const positional = _bind$5[_];
        if (positional.length > 1 && _M0FP410Haoxincode8moonbash3lib8commands28net__arg__starts__with__dash(positional)) {
          return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands13NetCurlConfigRP410Haoxincode8moonbash3lib3ast10ExecResultE3Err(_M0FP410Haoxincode8moonbash3lib8commands38net__curl__unsupported__option__result(positional));
        }
        _tmp$39 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  const headers = [];
  const _bind$5 = _M0MPB3Map3getGsRPB5ArrayGsEE(parsed.collections, "header");
  if (_bind$5.$tag === 1) {
    const _Some = _bind$5;
    const _raw_headers = _Some._0;
    const _bind$6 = _raw_headers.length;
    let _tmp$39 = 0;
    while (true) {
      const _ = _tmp$39;
      if (_ < _bind$6) {
        const raw_header = _raw_headers[_];
        const _bind$7 = _M0FP410Haoxincode8moonbash3lib8commands18net__parse__header(raw_header);
        if (_bind$7 === undefined) {
          return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands13NetCurlConfigRP410Haoxincode8moonbash3lib3ast10ExecResultE3Err(_M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", "curl: invalid header format\n", 2));
        } else {
          const _Some$2 = _bind$7;
          const _header = _Some$2;
          _M0MPC15array5Array4pushGUssEE(headers, _header);
        }
        _tmp$39 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  const _p$4 = _M0MPB3Map3getGssE(parsed.options, "method");
  const _p$5 = "GET";
  let http_method;
  if (_p$4 === undefined) {
    http_method = _p$5;
  } else {
    const _p$6 = _p$4;
    http_method = _p$6;
  }
  http_method = _M0FP410Haoxincode8moonbash3lib8commands17net__ascii__upper(http_method);
  const body = _M0MPB3Map3getGssE(parsed.options, "data");
  if (body === undefined) {
  } else {
    if (http_method === "GET") {
      http_method = "POST";
    }
  }
  const _tmp$39 = http_method;
  const _p$6 = _M0MPB3Map3getGsbE(parsed.flags, "include");
  const _p$7 = false;
  const _tmp$40 = _p$6 === -1 ? _p$7 : _p$6;
  const _p$8 = _M0MPB3Map3getGsbE(parsed.flags, "silent");
  const _p$9 = false;
  return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands13NetCurlConfigRP410Haoxincode8moonbash3lib3ast10ExecResultE2Ok(new _M0TP410Haoxincode8moonbash3lib8commands13NetCurlConfig(_tmp$39, _tmp$40, _p$8 === -1 ? _p$9 : _p$8, _M0MPB3Map3getGssE(parsed.options, "output"), body, parsed.positional.length > 0 ? _M0MPC15array5Array2atGUssEE(parsed.positional, 0) : undefined, headers));
}
function _M0FP410Haoxincode8moonbash3lib8commands24net__write__output__file(ctx, cmd_name, raw_path, content) {
  let path;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, raw_path);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        path = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    const _FsError = _try_err;
    const _msg = _FsError._0;
    return `${cmd_name}: ${_msg}\n`;
  }
  let _try_err$2;
  _L$2: {
    _L$3: {
      const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs11write__file(ctx.fs, path, content);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        _ok._0;
      } else {
        const _err = _bind$4;
        _try_err$2 = _err._0;
        break _L$3;
      }
      break _L$2;
    }
    const _FsError = _try_err$2;
    const _msg = _FsError._0;
    return `${cmd_name}: ${_msg}\n`;
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib8commands9cmd__curl(ctx) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands22net__parse__curl__args(ctx.args);
  let config;
  if (_bind$4.$tag === 1) {
    const _Ok = _bind$4;
    config = _Ok._0;
  } else {
    const _Err = _bind$4;
    const _result = _Err._0;
    return _result;
  }
  const _bind$5 = config.url;
  let request_url;
  if (_bind$5 === undefined) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", "curl: no URL specified\n", 2);
  } else {
    const _Some = _bind$5;
    request_url = _Some;
  }
  const _bind$6 = _M0FP410Haoxincode8moonbash3lib8commands28net__normalize__request__url(request_url);
  let request_url$2;
  if (_bind$6.$tag === 1) {
    const _Ok = _bind$6;
    request_url$2 = _Ok._0;
  } else {
    const _Err = _bind$6;
    const _msg = _Err._0;
    return _M0FP410Haoxincode8moonbash3lib8commands16net__curl__error(7, _msg, config.silent);
  }
  const _bind$7 = _M0FP410Haoxincode8moonbash3lib8commands15net__fetch__url(request_url$2, config.http_method, config.headers, config.body);
  let response;
  if (_bind$7.$tag === 1) {
    const _Ok = _bind$7;
    response = _Ok._0;
  } else {
    const _Err = _bind$7;
    const _msg = _Err._0;
    return _M0FP410Haoxincode8moonbash3lib8commands16net__curl__error(7, _msg, config.silent);
  }
  const payload = config.include_headers ? `${_M0FP410Haoxincode8moonbash3lib8commands20net__format__headers(response)}${response.body}` : response.body;
  const _bind$8 = config.output_path;
  if (_bind$8 === undefined) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(payload, "", 0);
  } else {
    const _Some = _bind$8;
    const _path = _Some;
    const _bind$9 = _M0FP410Haoxincode8moonbash3lib8commands24net__write__output__file(ctx, "curl", _path, payload);
    if (_bind$9 === undefined) {
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", "", 0);
    } else {
      const _Some$2 = _bind$9;
      const _err = _Some$2;
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", _err, 1);
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands28custom__apply__file__updates(fs, files) {
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < files.length) {
      const _bind$4 = _M0MPC15array5Array2atGUssEE(files, i);
      const _path = _bind$4._0;
      const _content = _bind$4._1;
      let _try_err;
      _L: {
        _L$2: {
          const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs11write__file(fs, _path, _content);
          if (_bind$5.$tag === 1) {
            const _ok = _bind$5;
            _ok._0;
          } else {
            const _err = _bind$5;
            _try_err = _err._0;
            break _L$2;
          }
          break _L;
        }
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands18custom__hex__digit(n) {
  return n < 10 ? n + 48 | 0 : (n - 10 | 0) + 97 | 0;
}
function _M0FP410Haoxincode8moonbash3lib8commands28custom__json__escape__string(s) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger11write__char(out, 34);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      switch (ch) {
        case 34: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, "\\\"");
          break;
        }
        case 92: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, "\\\\");
          break;
        }
        case 10: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, "\\n");
          break;
        }
        case 13: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, "\\r");
          break;
        }
        case 9: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, "\\t");
          break;
        }
        default: {
          const code = ch;
          if (code < 32) {
            _M0IPB13StringBuilderPB6Logger13write__string(out, "\\u00");
            _M0IPB13StringBuilderPB6Logger11write__char(out, _M0FP410Haoxincode8moonbash3lib8commands18custom__hex__digit(code / 16 | 0));
            _M0IPB13StringBuilderPB6Logger11write__char(out, _M0FP410Haoxincode8moonbash3lib8commands18custom__hex__digit(code % 16 | 0));
          } else {
            _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
          }
        }
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger11write__char(out, 34);
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands22custom__args__to__json(args) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger11write__char(out, 91);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < args.length) {
      if (i > 0) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 44);
      }
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands28custom__json__escape__string(_M0MPC15array5Array2atGUssEE(args, i)));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger11write__char(out, 93);
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands21custom__env__to__json(env) {
  const keys = [];
  const _it = _M0MPB3Map5iter2GssE(env);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _key = _x._0;
      _M0MPC15array5Array4pushGUssEE(keys, _key);
      continue;
    }
  }
  _M0MPC15array5Array8sort__byGUssEE(keys, (a, b) => _M0IP016_24default__implPB7Compare6op__ltGsE(a, b) ? -1 : _M0IP016_24default__implPB7Compare6op__gtGsE(a, b) ? 1 : 0);
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger11write__char(out, 123);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < keys.length) {
      if (i > 0) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 44);
      }
      const key = _M0MPC15array5Array2atGUssEE(keys, i);
      const _p$4 = _M0MPB3Map3getGssE(env, key);
      const _p$5 = "";
      let value;
      if (_p$4 === undefined) {
        value = _p$5;
      } else {
        const _p$6 = _p$4;
        value = _p$6;
      }
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands28custom__json__escape__string(key));
      _M0IPB13StringBuilderPB6Logger11write__char(out, 58);
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands28custom__json__escape__string(value));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger11write__char(out, 125);
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands23custom__files__to__json(fs) {
  const keys = [];
  const _it = _M0MPB3Map5iter2GssE(fs.entries);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _path = _x._0;
      const _entry = _x._1;
      if (_entry.$tag === 0) {
        _M0MPC15array5Array4pushGUssEE(keys, _path);
      }
      continue;
    }
  }
  _M0MPC15array5Array8sort__byGUssEE(keys, (a, b) => _M0IP016_24default__implPB7Compare6op__ltGsE(a, b) ? -1 : _M0IP016_24default__implPB7Compare6op__gtGsE(a, b) ? 1 : 0);
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger11write__char(out, 123);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < keys.length) {
      if (i > 0) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 44);
      }
      const key = _M0MPC15array5Array2atGUssEE(keys, i);
      const _bind$4 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(fs.entries, key);
      let content;
      if (_bind$4 === undefined) {
        content = "";
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        if (_x.$tag === 0) {
          const _File = _x;
          const _data = _File._0;
          content = _data.content;
        } else {
          content = "";
        }
      }
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands28custom__json__escape__string(key));
      _M0IPB13StringBuilderPB6Logger11write__char(out, 58);
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands28custom__json__escape__string(content));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger11write__char(out, 125);
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands28custom__build__request__json(name, args, ctx) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger11write__char(out, 123);
  _M0IPB13StringBuilderPB6Logger13write__string(out, "\"name\":");
  _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands28custom__json__escape__string(name));
  _M0IPB13StringBuilderPB6Logger13write__string(out, ",\"args\":");
  _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands22custom__args__to__json(args));
  _M0IPB13StringBuilderPB6Logger13write__string(out, ",\"stdin\":");
  _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands28custom__json__escape__string(ctx.stdin_content));
  _M0IPB13StringBuilderPB6Logger13write__string(out, ",\"cwd\":");
  _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands28custom__json__escape__string(ctx.cwd));
  _M0IPB13StringBuilderPB6Logger13write__string(out, ",\"env\":");
  _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands21custom__env__to__json(ctx.env));
  _M0IPB13StringBuilderPB6Logger13write__string(out, ",\"files\":");
  _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands23custom__files__to__json(ctx.fs));
  _M0IPB13StringBuilderPB6Logger11write__char(out, 125);
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands23custom__json__get__bool(obj, key, default_value) {
  _L: {
    const _bind$4 = _M0MPB3Map3getGsRPB4JsonE(obj, key);
    if (_bind$4 === undefined) {
      break _L;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      switch (_x.$tag) {
        case 1: {
          return true;
        }
        case 2: {
          return false;
        }
        case 3: {
          const _Number = _x;
          const _n = _Number._0;
          return _M0MPC16double6Double7to__int(_n) !== 0;
        }
        case 4: {
          const _String = _x;
          const _s = _String._0;
          return _s === "1" || _s === "true";
        }
        default: {
          break _L;
        }
      }
    }
  }
  return default_value;
}
function _M0FP410Haoxincode8moonbash3lib8commands24custom__json__get__files(obj) {
  _L: {
    const _bind$4 = _M0MPB3Map3getGsRPB4JsonE(obj, "files");
    if (_bind$4 === undefined) {
      break _L;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      if (_x.$tag === 6) {
        const _Object = _x;
        const _files_obj = _Object._0;
        const files = [];
        const _it = _M0MPB3Map5iter2GssE(_files_obj);
        while (true) {
          const _bind$5 = _M0MPB5Iter24nextGssE(_it);
          if (_bind$5 === undefined) {
            break;
          } else {
            const _Some$2 = _bind$5;
            const _x$2 = _Some$2;
            const _path = _x$2._0;
            const _value = _x$2._1;
            let content;
            switch (_value.$tag) {
              case 4: {
                const _String = _value;
                content = _String._0;
                break;
              }
              case 3: {
                const _Number = _value;
                const _n = _Number._0;
                content = _M0MPC13int3Int18to__string_2einner(_M0MPC16double6Double7to__int(_n), 10);
                break;
              }
              case 1: {
                content = "true";
                break;
              }
              case 2: {
                content = "false";
                break;
              }
              case 0: {
                content = "";
                break;
              }
              default: {
                content = _M0MPC14json4Json17stringify_2einner(_value, false, 0, undefined);
              }
            }
            _M0MPC15array5Array4pushGUssEE(files, { _0: _path, _1: content });
            continue;
          }
        }
        _M0MPC15array5Array8sort__byGUssEE(files, (a, b) => _M0IP016_24default__implPB7Compare6op__ltGsE(a._0, b._0) ? -1 : _M0IP016_24default__implPB7Compare6op__gtGsE(a._0, b._0) ? 1 : 0);
        return { _0: true, _1: files };
      } else {
        break _L;
      }
    }
  }
  return { _0: false, _1: [] };
}
function _M0FP410Haoxincode8moonbash3lib8commands18custom__parse__int(s) {
  if (s.length === 0) {
    return 0;
  }
  let sign = 1;
  let i = 0;
  $bound_check(s, 0);
  if (s.charCodeAt(0) === 45) {
    sign = -1;
    i = 1;
  } else {
    $bound_check(s, 0);
    if (s.charCodeAt(0) === 43) {
      i = 1;
    }
  }
  let value = 0;
  while (true) {
    if (i < s.length) {
      const _tmp$38 = i;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch < 48 || ch > 57) {
        break;
      }
      value = (Math.imul(value, 10) | 0) + (ch - 48 | 0) | 0;
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return Math.imul(value, sign) | 0;
}
function _M0FP410Haoxincode8moonbash3lib8commands22custom__json__get__int(obj, key, default_value) {
  _L: {
    const _bind$4 = _M0MPB3Map3getGsRPB4JsonE(obj, key);
    if (_bind$4 === undefined) {
      break _L;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      switch (_x.$tag) {
        case 3: {
          const _Number = _x;
          const _n = _Number._0;
          return _M0MPC16double6Double7to__int(_n);
        }
        case 4: {
          const _String = _x;
          const _s = _String._0;
          return _M0FP410Haoxincode8moonbash3lib8commands18custom__parse__int(_s);
        }
        default: {
          break _L;
        }
      }
    }
  }
  return default_value;
}
function _M0FP410Haoxincode8moonbash3lib8commands25custom__json__get__string(obj, key, default_value) {
  _L: {
    const _bind$4 = _M0MPB3Map3getGsRPB4JsonE(obj, key);
    if (_bind$4 === undefined) {
      break _L;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      switch (_x.$tag) {
        case 4: {
          const _String = _x;
          return _String._0;
        }
        case 3: {
          const _Number = _x;
          const _n = _Number._0;
          return _M0MPC13int3Int18to__string_2einner(_M0MPC16double6Double7to__int(_n), 10);
        }
        case 1: {
          return "true";
        }
        case 2: {
          return "false";
        }
        case 0: {
          return "";
        }
        default: {
          break _L;
        }
      }
    }
  }
  return default_value;
}
function _M0FP410Haoxincode8moonbash3lib8commands23custom__parse__response(json_str) {
  let parsed;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FPC14json13parse_2einner(new _M0TPC16string10StringView(json_str, 0, json_str.length), 1024);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        parsed = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    return _M0FP410Haoxincode8moonbash3lib8commands23custom__parse__responseN6constrS9238;
  }
  if (parsed.$tag === 6) {
    const _Object = parsed;
    const _obj = _Object._0;
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands24custom__json__get__files(_obj);
    const _has_files = _bind$4._0;
    const _files = _bind$4._1;
    return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands18CustomExecResponsesE2Ok(new _M0TP410Haoxincode8moonbash3lib8commands18CustomExecResponse(_M0FP410Haoxincode8moonbash3lib8commands23custom__json__get__bool(_obj, "handled", false), _M0FP410Haoxincode8moonbash3lib8commands25custom__json__get__string(_obj, "stdout", ""), _M0FP410Haoxincode8moonbash3lib8commands25custom__json__get__string(_obj, "stderr", ""), _M0FP410Haoxincode8moonbash3lib8commands22custom__json__get__int(_obj, "exitCode", _M0FP410Haoxincode8moonbash3lib8commands22custom__json__get__int(_obj, "exit_code", 1)), _M0FP410Haoxincode8moonbash3lib8commands25custom__json__get__string(_obj, "error", ""), _has_files, _files));
  } else {
    return _M0FP410Haoxincode8moonbash3lib8commands23custom__parse__responseN6constrS9239;
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands29custom__stderr__with__newline(stderr) {
  if (stderr.length === 0) {
    return "";
  }
  const _tmp$38 = stderr.length - 1 | 0;
  $bound_check(stderr, _tmp$38);
  const last = stderr.charCodeAt(_tmp$38);
  return last === 10 ? stderr : `${stderr}\n`;
}
function _M0FP410Haoxincode8moonbash3lib8commands19cmd__custom__bridge(ctx) {
  if (ctx.args.length === 0) {
    return _M0FP410Haoxincode8moonbash3lib8commands19cmd__custom__bridgeN6recordS9240;
  }
  const command_name = _M0MPC15array5Array2atGUssEE(ctx.args, 0);
  const forwarded_args = [];
  let _tmp$38 = 1;
  while (true) {
    const i = _tmp$38;
    if (i < ctx.args.length) {
      _M0MPC15array5Array4pushGUssEE(forwarded_args, _M0MPC15array5Array2atGUssEE(ctx.args, i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const request_json = _M0FP410Haoxincode8moonbash3lib8commands28custom__build__request__json(command_name, forwarded_args, ctx);
  const raw = _M0FP410Haoxincode8moonbash3lib3ffi21custom__command__sync(request_json);
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands23custom__parse__response(raw);
  let response;
  if (_bind$4.$tag === 1) {
    const _Ok = _bind$4;
    response = _Ok._0;
  } else {
    const _Err = _bind$4;
    const _msg = _Err._0;
    return new _M0TP410Haoxincode8moonbash3lib3ast10ExecResult("", `__moon_bash_custom__: ${_msg}\n`, 1);
  }
  if (!response.handled) {
    return new _M0TP410Haoxincode8moonbash3lib3ast10ExecResult("", `moon_bash: ${command_name}: command not found\n`, 127);
  }
  if (response.has_files) {
    _M0FP410Haoxincode8moonbash3lib8commands28custom__apply__file__updates(ctx.fs, response.files);
  }
  if (response.error.length > 0) {
    const err = _M0MPB13StringBuilder21StringBuilder_2einner(0);
    if (response.stderr.length > 0) {
      _M0IPB13StringBuilderPB6Logger13write__string(err, _M0FP410Haoxincode8moonbash3lib8commands29custom__stderr__with__newline(response.stderr));
    }
    _M0IPB13StringBuilderPB6Logger13write__string(err, `${command_name}: ${response.error}\n`);
    return new _M0TP410Haoxincode8moonbash3lib3ast10ExecResult(response.stdout, err.val, response.exit_code === 0 ? 1 : response.exit_code);
  }
  return new _M0TP410Haoxincode8moonbash3lib3ast10ExecResult(response.stdout, response.stderr, response.exit_code);
}
function _M0FP410Haoxincode8moonbash3lib8commands24cmd__du__relative__depth(rel) {
  let depth = 0;
  let in_segment = false;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < rel.length) {
      $bound_check(rel, i);
      const ch = rel.charCodeAt(i);
      if (ch === 47) {
        if (in_segment) {
          depth = depth + 1 | 0;
          in_segment = false;
        }
      } else {
        in_segment = true;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (in_segment) {
    depth = depth + 1 | 0;
  }
  return depth;
}
function _M0FP410Haoxincode8moonbash3lib8commands21cmd__find__parse__int(s) {
  let result = 0;
  let neg = false;
  let start = 0;
  let _tmp$38;
  if (s.length > 0) {
    $bound_check(s, 0);
    const _p$4 = s.charCodeAt(0);
    const _p$5 = 45;
    _tmp$38 = _p$4 === _p$5;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    neg = true;
    start = 1;
  } else {
    let _tmp$39;
    if (s.length > 0) {
      $bound_check(s, 0);
      const _p$4 = s.charCodeAt(0);
      const _p$5 = 43;
      _tmp$39 = _p$4 === _p$5;
    } else {
      _tmp$39 = false;
    }
    if (_tmp$39) {
      start = 1;
    }
  }
  let _tmp$39 = start;
  while (true) {
    const i = _tmp$39;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      if (ch >= 48 && ch <= 57) {
        result = (Math.imul(result, 10) | 0) + (ch - 48 | 0) | 0;
      } else {
        break;
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return neg ? -result | 0 : result;
}
function _M0FP410Haoxincode8moonbash3lib8commands19format__human__size(size) {
  if (size >= 1073741824) {
    const g = size / 1073741824 | 0;
    return `${_M0MPC13int3Int18to__string_2einner(g, 10)}G`;
  } else {
    if (size >= 1048576) {
      const m = size / 1048576 | 0;
      return `${_M0MPC13int3Int18to__string_2einner(m, 10)}M`;
    } else {
      if (size >= 1024) {
        const k = size / 1024 | 0;
        return `${_M0MPC13int3Int18to__string_2einner(k, 10)}K`;
      } else {
        return _M0MPC13int3Int18to__string_2einner(size, 10);
      }
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands7cmd__du(ctx) {
  let summary_only = false;
  let human_readable = false;
  let all_entries = false;
  const max_depth = new _M0TPB8MutLocalGOiE(undefined);
  const paths = [];
  let stop_options = false;
  let i = 0;
  while (true) {
    if (i < ctx.args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(ctx.args, i);
      if (stop_options) {
        _M0MPC15array5Array4pushGUssEE(paths, arg);
        i = i + 1 | 0;
        continue;
      }
      if (arg === "--") {
        stop_options = true;
        i = i + 1 | 0;
        continue;
      }
      if (arg === "--max-depth" && (i + 1 | 0) < ctx.args.length) {
        max_depth.val = _M0FP410Haoxincode8moonbash3lib8commands21cmd__find__parse__int(_M0MPC15array5Array2atGUssEE(ctx.args, i + 1 | 0));
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands7cmd__duN7_2abindS6602, 0, _M0FP410Haoxincode8moonbash3lib8commands7cmd__duN7_2abindS6602.length))) {
        max_depth.val = _M0FP410Haoxincode8moonbash3lib8commands21cmd__find__parse__int(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 12, undefined)));
        i = i + 1 | 0;
        continue;
      }
      let _tmp$38;
      if (arg.length > 1) {
        $bound_check(arg, 0);
        const _p$4 = arg.charCodeAt(0);
        const _p$5 = 45;
        _tmp$38 = _p$4 === _p$5;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        let valid_flags = true;
        let _tmp$39 = 1;
        _L: while (true) {
          const j = _tmp$39;
          if (j < arg.length) {
            $bound_check(arg, j);
            const flag = arg.charCodeAt(j);
            switch (flag) {
              case 115: {
                summary_only = true;
                break;
              }
              case 104: {
                human_readable = true;
                break;
              }
              case 97: {
                all_entries = true;
                break;
              }
              default: {
                valid_flags = false;
                break _L;
              }
            }
            _tmp$39 = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        if (valid_flags) {
          i = i + 1 | 0;
          continue;
        }
      }
      _M0MPC15array5Array4pushGUssEE(paths, arg);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  all_entries;
  if (paths.length === 0) {
    _M0MPC15array5Array4pushGUssEE(paths, ".");
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const errbuf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let exit_code = 0;
  const _bind$4 = paths.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const path = paths[_];
      _L: {
        let resolved;
        let _try_err;
        _L$2: {
          _L$3: {
            const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, path);
            if (_bind$5.$tag === 1) {
              const _ok = _bind$5;
              resolved = _ok._0;
            } else {
              const _err = _bind$5;
              _try_err = _err._0;
              break _L$3;
            }
            break _L$2;
          }
          const _FsError = _try_err;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `du: ${_msg}\n`);
          exit_code = 1;
          break _L;
        }
        if (!_M0MPB3Map8containsGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(ctx.fs.entries, resolved)) {
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `du: cannot access '${path}': No such file or directory\n`);
          exit_code = 1;
          break _L;
        }
        const prefix = resolved === "/" ? "/" : `${resolved}/`;
        const sub_entries = [];
        const total = new _M0TPB8MutLocalGiE(0);
        const _p$4 = ctx.fs.entries;
        let _tmp$39 = _p$4.head;
        while (true) {
          const _p$5 = _tmp$39;
          if (_p$5 === undefined) {
            break;
          } else {
            const _p$6 = _p$5;
            const _p$7 = _p$6;
            const _p$8 = _p$7.key;
            const _p$9 = _p$7.value;
            const _p$10 = _p$7.next;
            if (_p$8 === resolved || _M0MPC16string6String11has__prefix(_p$8, new _M0TPC16string10StringView(prefix, 0, prefix.length))) {
              let _p$11;
              switch (_p$9.$tag) {
                case 0: {
                  const _p$12 = _p$9;
                  const _p$13 = _p$12._0;
                  _p$11 = _p$13.content.length;
                  break;
                }
                case 1: {
                  _p$11 = 4096;
                  break;
                }
                default: {
                  const _p$14 = _p$9;
                  const _p$15 = _p$14._0;
                  _p$11 = _p$15.target.length;
                }
              }
              const _p$16 = _p$8 === resolved ? 0 : _M0FP410Haoxincode8moonbash3lib8commands24cmd__du__relative__depth(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(_p$8, resolved.length, undefined)));
              const _p$17 = max_depth.val;
              let _p$18;
              if (_p$17 === undefined) {
                _p$18 = true;
              } else {
                const _p$19 = _p$17;
                const _p$20 = _p$19;
                _p$18 = _p$16 <= _p$20;
              }
              if (_p$18) {
                total.val = total.val + _p$11 | 0;
                let _p$19;
                if (_p$8 === resolved) {
                  _p$19 = path;
                } else {
                  const _p$20 = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(_p$8, resolved.length, undefined));
                  _p$19 = path === "." ? `.${_p$20}` : `${path}${_p$20}`;
                }
                _M0MPC15array5Array4pushGUssEE(sub_entries, { _0: _p$19, _1: _p$11 });
              }
            }
            _tmp$39 = _p$10;
            continue;
          }
        }
        if (summary_only) {
          const size_str = human_readable ? _M0FP410Haoxincode8moonbash3lib8commands19format__human__size(total.val) : _M0MPC13int3Int18to__string_2einner(total.val, 10);
          _M0IPB13StringBuilderPB6Logger13write__string(out, `${size_str}\t${path}\n`);
        } else {
          _M0MPC15array5Array8sort__byGUssEE(sub_entries, (a, b) => _M0FP410Haoxincode8moonbash3lib8commands25cmd__find__compare__ascii(a._0, b._0));
          const _bind$5 = sub_entries.length;
          let _tmp$40 = 0;
          while (true) {
            const _$2 = _tmp$40;
            if (_$2 < _bind$5) {
              const entry = sub_entries[_$2];
              const size_str = human_readable ? _M0FP410Haoxincode8moonbash3lib8commands19format__human__size(entry._1) : _M0MPC13int3Int18to__string_2einner(entry._1, 10);
              _M0IPB13StringBuilderPB6Logger13write__string(out, `${size_str}\t${entry._0}\n`);
              _tmp$40 = _$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
        }
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(out.val, errbuf.val, exit_code);
}
function _M0FP410Haoxincode8moonbash3lib8commands9cmd__file(ctx) {
  if (ctx.args.length === 0) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("file: missing operand\n");
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const errbuf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let exit_code = 0;
  const _bind$4 = ctx.args;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const arg = _bind$4[_];
      _L: {
        let resolved;
        let _try_err;
        _L$2: {
          _L$3: {
            const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, arg);
            if (_bind$6.$tag === 1) {
              const _ok = _bind$6;
              resolved = _ok._0;
            } else {
              const _err = _bind$6;
              _try_err = _err._0;
              break _L$3;
            }
            break _L$2;
          }
          const _FsError = _try_err;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `file: ${_msg}\n`);
          exit_code = 1;
          break _L;
        }
        const _bind$6 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(ctx.fs.entries, resolved);
        if (_bind$6 === undefined) {
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `file: ${arg}: No such file or directory\n`);
          exit_code = 1;
        } else {
          const _Some = _bind$6;
          const _x = _Some;
          switch (_x.$tag) {
            case 1: {
              _M0IPB13StringBuilderPB6Logger13write__string(out, `${arg}: directory\n`);
              break;
            }
            case 2: {
              const _Symlink = _x;
              const _data = _Symlink._0;
              _M0IPB13StringBuilderPB6Logger13write__string(out, `${arg}: symbolic link to ${_data.target}\n`);
              break;
            }
            default: {
              const _File = _x;
              const _data$2 = _File._0;
              const content = _data$2.content;
              let ftype;
              if (content.length === 0) {
                ftype = "empty";
              } else {
                let _tmp$39;
                if (content.length >= 2) {
                  let _tmp$40;
                  $bound_check(content, 0);
                  const _p$4 = content.charCodeAt(0);
                  const _p$5 = 35;
                  if (_p$4 === _p$5) {
                    $bound_check(content, 1);
                    const _p$6 = content.charCodeAt(1);
                    const _p$7 = 33;
                    _tmp$40 = _p$6 === _p$7;
                  } else {
                    _tmp$40 = false;
                  }
                  _tmp$39 = _tmp$40;
                } else {
                  _tmp$39 = false;
                }
                if (_tmp$39) {
                  ftype = "script";
                } else {
                  let _tmp$40;
                  $bound_check(content, 0);
                  const _p$4 = content.charCodeAt(0);
                  const _p$5 = 123;
                  if (_p$4 === _p$5) {
                    _tmp$40 = true;
                  } else {
                    $bound_check(content, 0);
                    const _p$6 = content.charCodeAt(0);
                    const _p$7 = 91;
                    _tmp$40 = _p$6 === _p$7;
                  }
                  if (_tmp$40) {
                    ftype = "JSON data";
                  } else {
                    ftype = "ASCII text";
                  }
                }
              }
              _M0IPB13StringBuilderPB6Logger13write__string(out, `${arg}: ${ftype}\n`);
            }
          }
        }
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(out.val, errbuf.val, exit_code);
}
function _M0FP410Haoxincode8moonbash3lib8commands34cmd__find__trim__trailing__slashes(path) {
  if (path === "/" || path === ".") {
    return path;
  }
  let end = path.length;
  while (true) {
    let _tmp$38;
    if (end > 1) {
      const _tmp$39 = end - 1 | 0;
      $bound_check(path, _tmp$39);
      const _p$4 = path.charCodeAt(_tmp$39);
      const _p$5 = 47;
      _tmp$38 = _p$4 === _p$5;
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      end = end - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return end === path.length ? path : _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(path, 0, end));
}
function _M0FP410Haoxincode8moonbash3lib8commands28cmd__find__display__basename(path) {
  if (path === "." || path === "/") {
    return path;
  }
  let slash = -1;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < path.length) {
      $bound_check(path, i);
      const _p$4 = path.charCodeAt(i);
      const _p$5 = 47;
      if (_p$4 === _p$5) {
        slash = i;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return slash < 0 ? path : (slash + 1 | 0) >= path.length ? "" : _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(path, slash + 1 | 0, undefined));
}
function _M0FP410Haoxincode8moonbash3lib8commands23cmd__find__parse__octal(s) {
  let value = 0;
  let i = 0;
  let _tmp$38;
  if (s.length >= 2) {
    let _tmp$39;
    $bound_check(s, 0);
    if (s.charCodeAt(0) === 48) {
      let _tmp$40;
      $bound_check(s, 1);
      if (s.charCodeAt(1) === 111) {
        _tmp$40 = true;
      } else {
        $bound_check(s, 1);
        _tmp$40 = s.charCodeAt(1) === 79;
      }
      _tmp$39 = _tmp$40;
    } else {
      _tmp$39 = false;
    }
    _tmp$38 = _tmp$39;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    i = 2;
  }
  while (true) {
    if (i < s.length) {
      const _tmp$39 = i;
      $bound_check(s, _tmp$39);
      const ch = s.charCodeAt(_tmp$39);
      if (ch < 48 || ch > 55) {
        break;
      }
      value = (Math.imul(value, 8) | 0) + (ch - 48 | 0) | 0;
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return value;
}
function _M0FP410Haoxincode8moonbash3lib8commands24cmd__find__perm__matches(expr, mode) {
  if (expr.length === 0) {
    return false;
  }
  $bound_check(expr, 0);
  const first = expr.charCodeAt(0);
  if (first === 45) {
    const mask = _M0FP410Haoxincode8moonbash3lib8commands23cmd__find__parse__octal(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(expr, 1, undefined)));
    return (mode & mask) === mask;
  } else {
    if (first === 47) {
      const mask = _M0FP410Haoxincode8moonbash3lib8commands23cmd__find__parse__octal(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(expr, 1, undefined)));
      return (mode & mask) !== 0;
    } else {
      const expected = _M0FP410Haoxincode8moonbash3lib8commands23cmd__find__parse__octal(expr);
      return (mode & 4095) === expected;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands18cmd__find__matches(display_path, is_file, is_directory, mode, groups, has_predicates) {
  if (!has_predicates) {
    return true;
  }
  const base = _M0FP410Haoxincode8moonbash3lib8commands28cmd__find__display__basename(display_path);
  const _bind$4 = groups.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const group = groups[_];
      let group_match = true;
      const _bind$5 = group.length;
      let _tmp$39 = 0;
      while (true) {
        const _$2 = _tmp$39;
        if (_$2 < _bind$5) {
          const pred = group[_$2];
          const _kind = pred._0;
          const _value = pred._1;
          if (_kind === "name") {
            if (!_M0FP410Haoxincode8moonbash3lib2fs11glob__match(_value, base)) {
              group_match = false;
              break;
            }
          } else {
            if (_kind === "type") {
              if (_value === "f") {
                if (!is_file) {
                  group_match = false;
                  break;
                }
              } else {
                if (_value === "d") {
                  if (!is_directory) {
                    group_match = false;
                    break;
                  }
                } else {
                  group_match = false;
                  break;
                }
              }
            } else {
              if (_kind === "perm") {
                if (!_M0FP410Haoxincode8moonbash3lib8commands24cmd__find__perm__matches(_value, mode)) {
                  group_match = false;
                  break;
                }
              }
            }
          }
          _tmp$39 = _$2 + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      if (group_match) {
        return true;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib8commands15cmd__find__walk(fs, abs_path, display_path, depth, mindepth, maxdepth, groups, has_predicates, matches) {
  if (maxdepth === undefined) {
  } else {
    const _Some = maxdepth;
    const _maxd = _Some;
    if (depth > _maxd) {
      return undefined;
    }
  }
  let stat;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs4stat(fs, abs_path);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        stat = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    return undefined;
  }
  if (depth >= mindepth && _M0FP410Haoxincode8moonbash3lib8commands18cmd__find__matches(display_path, stat.is_file, stat.is_directory, stat.mode, groups, has_predicates)) {
    _M0MPC15array5Array4pushGUssEE(matches, display_path);
  }
  if (!stat.is_directory) {
    return undefined;
  }
  let should_descend;
  if (maxdepth === undefined) {
    should_descend = true;
  } else {
    const _Some = maxdepth;
    const _maxd = _Some;
    should_descend = depth < _maxd;
  }
  if (!should_descend) {
    return undefined;
  }
  let entries;
  let _try_err$2;
  _L$2: {
    _L$3: {
      const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs7readdir(fs, abs_path);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        entries = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err$2 = _err._0;
        break _L$3;
      }
      break _L$2;
    }
    return undefined;
  }
  const names = [];
  const _bind$4 = entries.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const entry = entries[_];
      _M0MPC15array5Array4pushGUssEE(names, entry.name);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MPC15array5Array8sort__byGUssEE(names, (a, b) => _M0FP410Haoxincode8moonbash3lib8commands25cmd__find__compare__ascii(a, b));
  const _bind$5 = names.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$5) {
      const name = names[_];
      const child_abs = abs_path === "/" ? `/${name}` : `${abs_path}/${name}`;
      const child_display = display_path === "/" ? `/${name}` : `${display_path}/${name}`;
      _M0FP410Haoxincode8moonbash3lib8commands15cmd__find__walk(fs, child_abs, child_display, depth + 1 | 0, mindepth, maxdepth, groups, has_predicates, matches);
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands9cmd__find(ctx) {
  const start_paths = [];
  let i = 0;
  while (true) {
    if (i < ctx.args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(ctx.args, i);
      if (arg === "-o" || _M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands9cmd__findN7_2abindS6700, 0, _M0FP410Haoxincode8moonbash3lib8commands9cmd__findN7_2abindS6700.length))) {
        break;
      }
      _M0MPC15array5Array4pushGUssEE(start_paths, arg);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (start_paths.length === 0) {
    _M0MPC15array5Array4pushGUssEE(start_paths, ".");
  }
  const groups = [];
  let current_group = [];
  let has_predicates = false;
  let maxdepth = undefined;
  let mindepth = 0;
  while (true) {
    if (i < ctx.args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(ctx.args, i);
      if (arg === "-o") {
        _M0MPC15array5Array4pushGRPB5ArrayGsEE(groups, current_group);
        current_group = [];
        i = i + 1 | 0;
        continue;
      }
      if (arg === "-name") {
        if ((i + 1 | 0) >= ctx.args.length) {
          return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("find: missing argument to -name\n");
        }
        _M0MPC15array5Array4pushGUssEE(current_group, { _0: "name", _1: _M0MPC15array5Array2atGUssEE(ctx.args, i + 1 | 0) });
        has_predicates = true;
        i = i + 2 | 0;
        continue;
      }
      if (arg === "-type") {
        if ((i + 1 | 0) >= ctx.args.length) {
          return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("find: missing argument to -type\n");
        }
        _M0MPC15array5Array4pushGUssEE(current_group, { _0: "type", _1: _M0MPC15array5Array2atGUssEE(ctx.args, i + 1 | 0) });
        has_predicates = true;
        i = i + 2 | 0;
        continue;
      }
      if (arg === "-perm") {
        if ((i + 1 | 0) >= ctx.args.length) {
          return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("find: missing argument to -perm\n");
        }
        _M0MPC15array5Array4pushGUssEE(current_group, { _0: "perm", _1: _M0MPC15array5Array2atGUssEE(ctx.args, i + 1 | 0) });
        has_predicates = true;
        i = i + 2 | 0;
        continue;
      }
      if (arg === "-maxdepth") {
        if ((i + 1 | 0) >= ctx.args.length) {
          return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("find: missing argument to -maxdepth\n");
        }
        maxdepth = _M0FP410Haoxincode8moonbash3lib8commands21cmd__find__parse__int(_M0MPC15array5Array2atGUssEE(ctx.args, i + 1 | 0));
        i = i + 2 | 0;
        continue;
      }
      if (arg === "-mindepth") {
        if ((i + 1 | 0) >= ctx.args.length) {
          return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("find: missing argument to -mindepth\n");
        }
        mindepth = _M0FP410Haoxincode8moonbash3lib8commands21cmd__find__parse__int(_M0MPC15array5Array2atGUssEE(ctx.args, i + 1 | 0));
        i = i + 2 | 0;
        continue;
      }
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`find: unsupported predicate: ${arg}\n`);
    } else {
      break;
    }
  }
  _M0MPC15array5Array4pushGRPB5ArrayGsEE(groups, current_group);
  const matches = [];
  const errbuf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let exit_code = 0;
  const _bind$4 = start_paths.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const start_arg = start_paths[_];
      _L: {
        let start_abs;
        let _try_err;
        _L$2: {
          _L$3: {
            const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, start_arg);
            if (_bind$5.$tag === 1) {
              const _ok = _bind$5;
              start_abs = _ok._0;
            } else {
              const _err = _bind$5;
              _try_err = _err._0;
              break _L$3;
            }
            break _L$2;
          }
          const _FsError = _try_err;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `find: ${_msg}\n`);
          exit_code = 1;
          break _L;
        }
        let start_display;
        if (start_arg.length === 0 || start_arg === ".") {
          start_display = ".";
        } else {
          $bound_check(start_arg, 0);
          const _p$4 = start_arg.charCodeAt(0);
          const _p$5 = 47;
          if (_p$4 === _p$5) {
            start_display = start_abs;
          } else {
            start_display = _M0FP410Haoxincode8moonbash3lib8commands34cmd__find__trim__trailing__slashes(start_arg);
          }
        }
        _M0FP410Haoxincode8moonbash3lib8commands15cmd__find__walk(ctx.fs, start_abs, start_display, 0, mindepth, maxdepth, groups, has_predicates, matches);
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MPC15array5Array8sort__byGUssEE(matches, (a, b) => _M0FP410Haoxincode8moonbash3lib8commands25cmd__find__compare__ascii(a, b));
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _bind$5 = matches.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$5) {
      const m = matches[_];
      _M0IPB13StringBuilderPB6Logger13write__string(out, `${m}\n`);
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(out.val, errbuf.val, exit_code);
}
function _M0FP410Haoxincode8moonbash3lib8commands22raw__bytes__to__string(b) {
  const _p$4 = b.len;
  let _bind$4;
  if (_p$4 <= 0) {
    _bind$4 = [];
  } else {
    const _p$5 = new Array(_p$4);
    let _tmp$38 = 0;
    while (true) {
      const _p$6 = _tmp$38;
      if (_p$6 < _p$4) {
        _p$5[_p$6] = _M0MP27gmlewis2io5Slice7op__getGyE(b, _p$6);
        _tmp$38 = _p$6 + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    _bind$4 = _p$5;
  }
  return _M0MPC16string6String11from__array(new _M0TPB9ArrayViewGcE(_bind$4, 0, _bind$4.length));
}
function _M0FP410Haoxincode8moonbash3lib8commands22string__to__raw__bytes(s) {
  const _p$4 = s.length;
  if (_p$4 <= 0) {
    return [];
  } else {
    const _p$5 = new Array(_p$4);
    let _tmp$38 = 0;
    while (true) {
      const _p$6 = _tmp$38;
      if (_p$6 < _p$4) {
        $bound_check(s, _p$6);
        _p$5[_p$6] = s.charCodeAt(_p$6) & 255;
        _tmp$38 = _p$6 + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return _p$5;
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands12gzip__decode(content) {
  const input_bytes = _M0FP410Haoxincode8moonbash3lib8commands22string__to__raw__bytes(content);
  const in_buf = _M0MP27gmlewis2io6Buffer11new_2einner(0);
  _M0MP27gmlewis2io6Buffer12write__bytes(in_buf, _M0MPC15bytes5Bytes11from__array(new _M0TPB9ArrayViewGyE(input_bytes, 0, input_bytes.length)));
  const _bind$4 = _M0MP27gmlewis4gzip6Reader3new({ self: in_buf, method_table: _M0FP056gmlewis_2fio_2fBuffer_24as_24_40gmlewis_2fflate_2eReader });
  const _reader = _bind$4._0;
  const _err = _bind$4._1;
  if (_err === undefined) {
  } else {
    return "";
  }
  const _bind$5 = _M0FP27gmlewis2io9read__all({ self: _reader, method_table: _M0FP055gmlewis_2fgzip_2fReader_24as_24_40gmlewis_2fio_2eReader });
  const _data = _bind$5._0;
  return _M0FP410Haoxincode8moonbash3lib8commands22raw__bytes__to__string(_data);
}
function _M0FP410Haoxincode8moonbash3lib8commands17is__gzip__content(content) {
  if (content.length >= 2) {
    let _tmp$38;
    $bound_check(content, 0);
    if (content.charCodeAt(0) === 31) {
      $bound_check(content, 1);
      _tmp$38 = content.charCodeAt(1) === 139;
    } else {
      _tmp$38 = false;
    }
    return _tmp$38;
  } else {
    return false;
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands15str__ends__with(s, suffix) {
  if (suffix.length > s.length) {
    return false;
  }
  const offset = s.length - suffix.length | 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < suffix.length) {
      const _tmp$39 = offset + i | 0;
      $bound_check(s, _tmp$39);
      const _p$4 = s.charCodeAt(_tmp$39);
      $bound_check(suffix, i);
      const _p$5 = suffix.charCodeAt(i);
      if (_p$4 !== _p$5) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0FP410Haoxincode8moonbash3lib8commands18str__strip__suffix(s, suffix) {
  return _M0FP410Haoxincode8moonbash3lib8commands15str__ends__with(s, suffix) ? _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(s, 0, s.length - suffix.length | 0)) : s;
}
function _M0FP410Haoxincode8moonbash3lib8commands12gunzip__core(ctx, keep, to_stdout, force) {
  if (ctx.args.length === 0 && ctx.stdin_content.length === 0) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("gunzip: missing operand\n");
  }
  if (ctx.args.length === 0) {
    if (!_M0FP410Haoxincode8moonbash3lib8commands17is__gzip__content(ctx.stdin_content)) {
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("gunzip: stdin: not in gzip format\n");
    }
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(_M0FP410Haoxincode8moonbash3lib8commands12gzip__decode(ctx.stdin_content));
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const errbuf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let exit_code = 0;
  const _bind$4 = ctx.args;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const arg = _bind$4[_];
      _L: {
        if (!_M0FP410Haoxincode8moonbash3lib8commands15str__ends__with(arg, ".gz") && (!_M0FP410Haoxincode8moonbash3lib8commands15str__ends__with(arg, ".tgz") && !force)) {
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `gunzip: ${arg}: unknown suffix -- ignored\n`);
          exit_code = 1;
          break _L;
        }
        let resolved;
        let _try_err;
        _L$2: {
          _L$3: {
            const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, arg);
            if (_bind$6.$tag === 1) {
              const _ok = _bind$6;
              resolved = _ok._0;
            } else {
              const _err = _bind$6;
              _try_err = _err._0;
              break _L$3;
            }
            break _L$2;
          }
          const _FsError = _try_err;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `gunzip: ${_msg}\n`);
          exit_code = 1;
          break _L;
        }
        let content;
        let _try_err$2;
        _L$3: {
          _L$4: {
            const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, resolved);
            if (_bind$6.$tag === 1) {
              const _ok = _bind$6;
              content = _ok._0;
            } else {
              const _err = _bind$6;
              _try_err$2 = _err._0;
              break _L$4;
            }
            break _L$3;
          }
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `gunzip: ${arg}: No such file or directory\n`);
          exit_code = 1;
          break _L;
        }
        if (!_M0FP410Haoxincode8moonbash3lib8commands17is__gzip__content(content)) {
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `gunzip: ${arg}: not in gzip format\n`);
          exit_code = 1;
          break _L;
        }
        const decoded = _M0FP410Haoxincode8moonbash3lib8commands12gzip__decode(content);
        if (to_stdout) {
          _M0IPB13StringBuilderPB6Logger13write__string(out, decoded);
        } else {
          const out_name = _M0FP410Haoxincode8moonbash3lib8commands15str__ends__with(arg, ".tgz") ? `${_M0FP410Haoxincode8moonbash3lib8commands18str__strip__suffix(arg, ".tgz")}.tar` : _M0FP410Haoxincode8moonbash3lib8commands18str__strip__suffix(arg, ".gz");
          let out_resolved;
          let _try_err$3;
          _L$4: {
            _L$5: {
              const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, out_name);
              if (_bind$6.$tag === 1) {
                const _ok = _bind$6;
                out_resolved = _ok._0;
              } else {
                const _err = _bind$6;
                _try_err$3 = _err._0;
                break _L$5;
              }
              break _L$4;
            }
            const _FsError = _try_err$3;
            const _msg = _FsError._0;
            _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `gunzip: ${_msg}\n`);
            exit_code = 1;
            break _L;
          }
          if (!force && _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs6exists(ctx.fs, out_resolved)) {
            _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `gunzip: ${out_name}: already exists; not overwritten\n`);
            exit_code = 1;
            break _L;
          }
          let _try_err$4;
          _L$5: {
            _L$6: {
              const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs11write__file(ctx.fs, out_resolved, decoded);
              if (_bind$6.$tag === 1) {
                const _ok = _bind$6;
                _ok._0;
              } else {
                const _err = _bind$6;
                _try_err$4 = _err._0;
                break _L$6;
              }
              break _L$5;
            }
            const _FsError = _try_err$4;
            const _msg = _FsError._0;
            _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `gunzip: ${_msg}\n`);
            exit_code = 1;
            break _L;
          }
          if (!keep) {
            let _try_err$5;
            _L$6: {
              _L$7: {
                const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10rm_2einner(ctx.fs, resolved, false, false);
                if (_bind$6.$tag === 1) {
                  const _ok = _bind$6;
                  _ok._0;
                } else {
                  const _err = _bind$6;
                  _try_err$5 = _err._0;
                  break _L$7;
                }
                break _L$6;
              }
              const _FsError = _try_err$5;
              const _msg = _FsError._0;
              _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `gunzip: ${_msg}\n`);
              exit_code = 1;
            }
          }
        }
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(out.val, errbuf.val, exit_code);
}
function _M0FP410Haoxincode8moonbash3lib8commands11cmd__gunzip(ctx) {
  let keep = false;
  let to_stdout = false;
  let force = false;
  const files = [];
  const _bind$4 = ctx.args;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const arg = _bind$4[_];
      _L: {
        _L$2: {
          _L$3: {
            _L$4: {
              _L$5: {
                _L$6: {
                  switch (arg) {
                    case "-k": {
                      keep = true;
                      break;
                    }
                    case "-c": {
                      to_stdout = true;
                      break;
                    }
                    case "-f": {
                      force = true;
                      break;
                    }
                    case "-kc": {
                      break _L$6;
                    }
                    case "-ck": {
                      break _L$6;
                    }
                    case "-kf": {
                      break _L$4;
                    }
                    case "-fk": {
                      break _L$4;
                    }
                    case "-cf": {
                      break _L$2;
                    }
                    case "-fc": {
                      break _L$2;
                    }
                    default: {
                      _M0MPC15array5Array4pushGUssEE(files, arg);
                    }
                  }
                  break _L$5;
                }
                keep = true;
                to_stdout = true;
              }
              break _L$3;
            }
            keep = true;
            force = true;
          }
          break _L;
        }
        to_stdout = true;
        force = true;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const file_ctx = new _M0TP410Haoxincode8moonbash3lib8commands14CommandContext(files, ctx.stdin_content, ctx.cwd, ctx.env, ctx.fs);
  return _M0FP410Haoxincode8moonbash3lib8commands12gunzip__core(file_ctx, keep, to_stdout, force);
}
function _M0FP410Haoxincode8moonbash3lib8commands12gzip__encode(content) {
  const input_bytes = _M0FP410Haoxincode8moonbash3lib8commands22string__to__raw__bytes(content);
  const out_buf = _M0MP27gmlewis2io6Buffer11new_2einner(0);
  const w = _M0MP27gmlewis4gzip6Writer3new({ self: out_buf, method_table: _M0FP053gmlewis_2fio_2fBuffer_24as_24_40gmlewis_2fio_2eWriter });
  _M0IP27gmlewis4gzip6WriterP27gmlewis2io6Writer5write(w, _M0MP27gmlewis2io5Slice11new_2einnerGyE(input_bytes, 0, undefined));
  _M0IP27gmlewis4gzip6WriterP27gmlewis2io6Closer5close(w);
  return _M0FP410Haoxincode8moonbash3lib8commands22raw__bytes__to__string(_M0MP27gmlewis2io6Buffer9to__slice(out_buf));
}
function _M0FP410Haoxincode8moonbash3lib8commands9cmd__gzip(ctx) {
  let keep = false;
  let decompress = false;
  let to_stdout = false;
  let force = false;
  const files = [];
  const _bind$4 = ctx.args;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const arg = _bind$4[_];
      _L: {
        _L$2: {
          _L$3: {
            _L$4: {
              _L$5: {
                _L$6: {
                  _L$7: {
                    _L$8: {
                      _L$9: {
                        _L$10: {
                          _L$11: {
                            _L$12: {
                              switch (arg) {
                                case "-k": {
                                  keep = true;
                                  break;
                                }
                                case "-d": {
                                  decompress = true;
                                  break;
                                }
                                case "-c": {
                                  to_stdout = true;
                                  break;
                                }
                                case "-f": {
                                  force = true;
                                  break;
                                }
                                case "-kc": {
                                  break _L$12;
                                }
                                case "-ck": {
                                  break _L$12;
                                }
                                case "-kf": {
                                  break _L$10;
                                }
                                case "-fk": {
                                  break _L$10;
                                }
                                case "-cf": {
                                  break _L$8;
                                }
                                case "-fc": {
                                  break _L$8;
                                }
                                case "-dc": {
                                  break _L$6;
                                }
                                case "-cd": {
                                  break _L$6;
                                }
                                case "-df": {
                                  break _L$4;
                                }
                                case "-fd": {
                                  break _L$4;
                                }
                                case "-dk": {
                                  break _L$2;
                                }
                                case "-kd": {
                                  break _L$2;
                                }
                                default: {
                                  _M0MPC15array5Array4pushGUssEE(files, arg);
                                }
                              }
                              break _L$11;
                            }
                            keep = true;
                            to_stdout = true;
                          }
                          break _L$9;
                        }
                        keep = true;
                        force = true;
                      }
                      break _L$7;
                    }
                    to_stdout = true;
                    force = true;
                  }
                  break _L$5;
                }
                decompress = true;
                to_stdout = true;
              }
              break _L$3;
            }
            decompress = true;
            force = true;
          }
          break _L;
        }
        decompress = true;
        keep = true;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const file_ctx = new _M0TP410Haoxincode8moonbash3lib8commands14CommandContext(files, ctx.stdin_content, ctx.cwd, ctx.env, ctx.fs);
  if (decompress) {
    return _M0FP410Haoxincode8moonbash3lib8commands12gunzip__core(file_ctx, keep, to_stdout, force);
  }
  if (files.length === 0 && ctx.stdin_content.length === 0) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("gzip: missing operand\n");
  }
  if (files.length === 0) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(_M0FP410Haoxincode8moonbash3lib8commands12gzip__encode(ctx.stdin_content));
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const errbuf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let exit_code = 0;
  const _bind$6 = files.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$6) {
      const file = files[_];
      _L: {
        if (_M0FP410Haoxincode8moonbash3lib8commands15str__ends__with(file, ".gz")) {
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `gzip: ${file}: already has .gz suffix -- unchanged\n`);
          exit_code = 1;
          break _L;
        }
        let resolved;
        let _try_err;
        _L$2: {
          _L$3: {
            const _bind$7 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, file);
            if (_bind$7.$tag === 1) {
              const _ok = _bind$7;
              resolved = _ok._0;
            } else {
              const _err = _bind$7;
              _try_err = _err._0;
              break _L$3;
            }
            break _L$2;
          }
          const _FsError = _try_err;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `gzip: ${_msg}\n`);
          exit_code = 1;
          break _L;
        }
        let content;
        let _try_err$2;
        _L$3: {
          _L$4: {
            const _bind$7 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, resolved);
            if (_bind$7.$tag === 1) {
              const _ok = _bind$7;
              content = _ok._0;
            } else {
              const _err = _bind$7;
              _try_err$2 = _err._0;
              break _L$4;
            }
            break _L$3;
          }
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `gzip: ${file}: No such file or directory\n`);
          exit_code = 1;
          break _L;
        }
        const encoded = _M0FP410Haoxincode8moonbash3lib8commands12gzip__encode(content);
        if (to_stdout) {
          _M0IPB13StringBuilderPB6Logger13write__string(out, encoded);
        } else {
          const gz_name = `${file}.gz`;
          let gz_resolved;
          let _try_err$3;
          _L$4: {
            _L$5: {
              const _bind$7 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, gz_name);
              if (_bind$7.$tag === 1) {
                const _ok = _bind$7;
                gz_resolved = _ok._0;
              } else {
                const _err = _bind$7;
                _try_err$3 = _err._0;
                break _L$5;
              }
              break _L$4;
            }
            const _FsError = _try_err$3;
            const _msg = _FsError._0;
            _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `gzip: ${_msg}\n`);
            exit_code = 1;
            break _L;
          }
          if (!force && _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs6exists(ctx.fs, gz_resolved)) {
            _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `gzip: ${gz_name}: already exists; not overwritten\n`);
            exit_code = 1;
            break _L;
          }
          let _try_err$4;
          _L$5: {
            _L$6: {
              const _bind$7 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs11write__file(ctx.fs, gz_resolved, encoded);
              if (_bind$7.$tag === 1) {
                const _ok = _bind$7;
                _ok._0;
              } else {
                const _err = _bind$7;
                _try_err$4 = _err._0;
                break _L$6;
              }
              break _L$5;
            }
            const _FsError = _try_err$4;
            const _msg = _FsError._0;
            _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `gzip: ${_msg}\n`);
            exit_code = 1;
            break _L;
          }
          if (!keep) {
            let _try_err$5;
            _L$6: {
              _L$7: {
                const _bind$7 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10rm_2einner(ctx.fs, resolved, false, false);
                if (_bind$7.$tag === 1) {
                  const _ok = _bind$7;
                  _ok._0;
                } else {
                  const _err = _bind$7;
                  _try_err$5 = _err._0;
                  break _L$7;
                }
                break _L$6;
              }
              const _FsError = _try_err$5;
              const _msg = _FsError._0;
              _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `gzip: ${_msg}\n`);
              exit_code = 1;
            }
          }
        }
        break _L;
      }
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(out.val, errbuf.val, exit_code);
}
function _M0FP410Haoxincode8moonbash3lib8commands20net__index__of__from(s, needle, start) {
  if (needle.length === 0) {
    return start;
  }
  if (start < 0) {
    return -1;
  }
  if (needle.length > s.length) {
    return -1;
  }
  const limit = s.length - needle.length | 0;
  let i = start;
  while (true) {
    if (i <= limit) {
      let matched = true;
      let _tmp$38 = 0;
      while (true) {
        const j = _tmp$38;
        if (j < needle.length) {
          const _tmp$39 = i + j | 0;
          $bound_check(s, _tmp$39);
          const _p$4 = s.charCodeAt(_tmp$39);
          $bound_check(needle, j);
          const _p$5 = needle.charCodeAt(j);
          if (_p$4 !== _p$5) {
            matched = false;
            break;
          }
          _tmp$38 = j + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      if (matched) {
        return i;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, old, new_) {
  if (old.length === 0) {
    return s;
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let cursor = 0;
  while (true) {
    if (cursor < s.length) {
      const idx = _M0FP410Haoxincode8moonbash3lib8commands20net__index__of__from(s, old, cursor);
      if (idx < 0) {
        _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands18cmd__substr__slice(s, cursor, s.length));
        break;
      }
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands18cmd__substr__slice(s, cursor, idx));
      _M0IPB13StringBuilderPB6Logger13write__string(out, new_);
      cursor = idx + old.length | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands27net__decode__html__entities(s) {
  let out = s;
  out = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(out, "&amp;", "&");
  out = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(out, "&lt;", "<");
  out = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(out, "&gt;", ">");
  out = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(out, "&quot;", "\"");
  out = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(out, "&#39;", "'");
  out = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(out, "&nbsp;", " ");
  return out;
}
function _M0FP410Haoxincode8moonbash3lib8commands17net__ascii__lower(s) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      if (ch >= 65 && ch <= 90) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch + 32 | 0);
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands18net__extract__href(open_tag) {
  const lower = _M0FP410Haoxincode8moonbash3lib8commands17net__ascii__lower(open_tag);
  const href_pos = _M0FP410Haoxincode8moonbash3lib8commands20net__index__of__from(lower, "href=", 0);
  if (href_pos < 0) {
    return "";
  }
  const value_start = href_pos + 5 | 0;
  if (value_start >= open_tag.length) {
    return "";
  }
  $bound_check(open_tag, value_start);
  const first = open_tag.charCodeAt(value_start);
  if (first === 34 || first === 39) {
    const end = _M0FP410Haoxincode8moonbash3lib8commands20net__index__of__char(open_tag, first, value_start + 1 | 0);
    if (end < 0) {
      return "";
    }
    return _M0FP410Haoxincode8moonbash3lib8commands18cmd__substr__slice(open_tag, value_start + 1 | 0, end);
  }
  let end = value_start;
  while (true) {
    if (end < open_tag.length) {
      const _tmp$38 = end;
      $bound_check(open_tag, _tmp$38);
      const ch = open_tag.charCodeAt(_tmp$38);
      if (_M0FP410Haoxincode8moonbash3lib8commands19net__is__whitespace(ch) || ch === 62) {
        break;
      }
      end = end + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0FP410Haoxincode8moonbash3lib8commands18cmd__substr__slice(open_tag, value_start, end);
}
function _M0FP410Haoxincode8moonbash3lib8commands22net__strip__html__tags(s) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let in_tag = false;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      _L: {
        $bound_check(s, i);
        const ch = s.charCodeAt(i);
        if (in_tag) {
          if (ch === 62) {
            in_tag = false;
          }
          break _L;
        }
        if (ch === 60) {
          in_tag = true;
          break _L;
        }
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        break _L;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands19net__convert__links(s) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let cursor = 0;
  while (true) {
    if (cursor < s.length) {
      const start = _M0FP410Haoxincode8moonbash3lib8commands20net__index__of__from(s, "<a", cursor);
      if (start < 0) {
        _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands18cmd__substr__slice(s, cursor, s.length));
        break;
      }
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands18cmd__substr__slice(s, cursor, start));
      const open_end = _M0FP410Haoxincode8moonbash3lib8commands20net__index__of__from(s, ">", start);
      if (open_end < 0) {
        _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands18cmd__substr__slice(s, start, s.length));
        break;
      }
      const close = _M0FP410Haoxincode8moonbash3lib8commands20net__index__of__from(s, "</a>", open_end + 1 | 0);
      if (close < 0) {
        _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands18cmd__substr__slice(s, start, s.length));
        break;
      }
      const open_tag = _M0FP410Haoxincode8moonbash3lib8commands18cmd__substr__slice(s, start, open_end + 1 | 0);
      const href = _M0FP410Haoxincode8moonbash3lib8commands18net__extract__href(open_tag);
      const label_html = _M0FP410Haoxincode8moonbash3lib8commands18cmd__substr__slice(s, open_end + 1 | 0, close);
      const label_text = _M0FP410Haoxincode8moonbash3lib8commands9net__trim(_M0FP410Haoxincode8moonbash3lib8commands27net__decode__html__entities(_M0FP410Haoxincode8moonbash3lib8commands22net__strip__html__tags(label_html)));
      if (href.length > 0) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 91);
        if (label_text.length > 0) {
          _M0IPB13StringBuilderPB6Logger13write__string(out, label_text);
        } else {
          _M0IPB13StringBuilderPB6Logger13write__string(out, href);
        }
        _M0IPB13StringBuilderPB6Logger13write__string(out, "](");
        _M0IPB13StringBuilderPB6Logger13write__string(out, href);
        _M0IPB13StringBuilderPB6Logger11write__char(out, 41);
      } else {
        _M0IPB13StringBuilderPB6Logger13write__string(out, label_text);
      }
      cursor = close + 4 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands24net__normalize__markdown(s) {
  const trimmed = _M0FP410Haoxincode8moonbash3lib8commands9net__trim(s);
  if (trimmed.length === 0) {
    return "";
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let newline_run = 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < trimmed.length) {
      $bound_check(trimmed, i);
      const ch = trimmed.charCodeAt(i);
      if (ch === 10) {
        newline_run = newline_run + 1 | 0;
        if (newline_run <= 2) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
        }
      } else {
        newline_run = 0;
        if (ch === 9) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 32);
        } else {
          _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        }
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const normalized = out.val;
  if (normalized.length === 0) {
    return "";
  } else {
    const _tmp$39 = normalized.length - 1 | 0;
    $bound_check(normalized, _tmp$39);
    if (normalized.charCodeAt(_tmp$39) === 10) {
      return normalized;
    } else {
      return `${normalized}\n`;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands23net__remove__block__tag(s, tag) {
  const open_pat = `<${tag}`;
  const close_pat = `</${tag}>`;
  let current = s;
  let searching = true;
  while (true) {
    if (searching) {
      const start = _M0FP410Haoxincode8moonbash3lib8commands20net__index__of__from(current, open_pat, 0);
      if (start < 0) {
        searching = false;
        continue;
      }
      const open_end = _M0FP410Haoxincode8moonbash3lib8commands20net__index__of__from(current, ">", start);
      if (open_end < 0) {
        searching = false;
        continue;
      }
      const close = _M0FP410Haoxincode8moonbash3lib8commands20net__index__of__from(current, close_pat, open_end + 1 | 0);
      if (close < 0) {
        searching = false;
        continue;
      }
      const before = _M0FP410Haoxincode8moonbash3lib8commands18cmd__substr__slice(current, 0, start);
      const after = _M0FP410Haoxincode8moonbash3lib8commands18cmd__substr__slice(current, close + close_pat.length | 0, current.length);
      current = `${before}${after}`;
      continue;
    } else {
      break;
    }
  }
  return current;
}
function _M0FP410Haoxincode8moonbash3lib8commands23net__html__to__markdown(html) {
  let s = _M0MPC16string6String7replace(_M0MPC16string6String7replace(html, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands23net__html__to__markdownN7_2abindS6830, 0, _M0FP410Haoxincode8moonbash3lib8commands23net__html__to__markdownN7_2abindS6830.length), new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands23net__html__to__markdownN7_2abindS6831, 0, _M0FP410Haoxincode8moonbash3lib8commands23net__html__to__markdownN7_2abindS6831.length)), new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands23net__html__to__markdownN7_2abindS6832, 0, _M0FP410Haoxincode8moonbash3lib8commands23net__html__to__markdownN7_2abindS6832.length), new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands23net__html__to__markdownN7_2abindS6833, 0, _M0FP410Haoxincode8moonbash3lib8commands23net__html__to__markdownN7_2abindS6833.length));
  s = _M0FP410Haoxincode8moonbash3lib8commands23net__remove__block__tag(s, "script");
  s = _M0FP410Haoxincode8moonbash3lib8commands23net__remove__block__tag(s, "style");
  s = _M0FP410Haoxincode8moonbash3lib8commands19net__convert__links(s);
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<br>", "\n");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<br/>", "\n");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<br />", "\n");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<hr>", "\n---\n");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<hr/>", "\n---\n");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<hr />", "\n---\n");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<h1>", "# ");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "</h1>", "\n\n");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<h2>", "## ");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "</h2>", "\n\n");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<h3>", "### ");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "</h3>", "\n\n");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<h4>", "#### ");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "</h4>", "\n\n");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<h5>", "##### ");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "</h5>", "\n\n");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<h6>", "###### ");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "</h6>", "\n\n");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<p>", "");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "</p>", "\n\n");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<div>", "");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "</div>", "\n");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<section>", "");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "</section>", "\n");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<article>", "");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "</article>", "\n");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<ul>", "\n");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "</ul>", "\n");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<ol>", "\n");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "</ol>", "\n");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<li>", "- ");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "</li>", "\n");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<pre>", "\n```\n");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "</pre>", "\n```\n");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<code>", "`");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "</code>", "`");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<strong>", "**");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "</strong>", "**");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<b>", "**");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "</b>", "**");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<em>", "*");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "</em>", "*");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "<i>", "*");
  s = _M0FP410Haoxincode8moonbash3lib8commands17net__replace__all(s, "</i>", "*");
  s = _M0FP410Haoxincode8moonbash3lib8commands22net__strip__html__tags(s);
  s = _M0FP410Haoxincode8moonbash3lib8commands27net__decode__html__entities(s);
  return _M0FP410Haoxincode8moonbash3lib8commands24net__normalize__markdown(s);
}
function _M0FP410Haoxincode8moonbash3lib8commands45net__html__to__markdown__parse__error__result(msg) {
  if (msg === "Option --output requires a value" || msg === "Option -o requires a value") {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("html-to-markdown: option -o requires an argument\n");
  }
  if (msg === "Option --url requires a value" || msg === "Option -u requires a value") {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("html-to-markdown: option --url requires an argument\n");
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`html-to-markdown: ${msg}\n`);
}
function _M0FP410Haoxincode8moonbash3lib8commands52net__html__to__markdown__unsupported__option__result(arg) {
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", `html-to-markdown: unsupported option -- '${arg}'\n`, 1);
}
function _M0FP410Haoxincode8moonbash3lib8commands36net__parse__html__to__markdown__args(raw_args) {
  const aliases = _M0MPB3Map3MapGssE(new _M0TPB9ArrayViewGUssEE(_M0FP410Haoxincode8moonbash3lib8commands36net__parse__html__to__markdown__argsN7_2abindS6850, 0, 2), undefined);
  let parsed;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP218peter_2djerry_2dye11parse__args5parse(new _M0TPB9ArrayViewGsE(raw_args, 0, raw_args.length), undefined, new _M0TPB9ArrayViewGsE(_M0FP410Haoxincode8moonbash3lib8commands36net__parse__html__to__markdown__argsN7_2abindS6846, 0, 2), undefined, aliases, undefined, -1, -1);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        parsed = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    const _ParseError = _try_err;
    const _msg = _ParseError._0;
    return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands23NetHtmlToMarkdownConfigRP410Haoxincode8moonbash3lib3ast10ExecResultE3Err(_M0FP410Haoxincode8moonbash3lib8commands45net__html__to__markdown__parse__error__result(_msg));
  }
  if (!_M0FP410Haoxincode8moonbash3lib8commands32net__args__contain__double__dash(raw_args)) {
    const _bind$4 = parsed.positional;
    const _bind$5 = _bind$4.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$5) {
        const positional = _bind$4[_];
        if (positional.length > 1 && _M0FP410Haoxincode8moonbash3lib8commands28net__arg__starts__with__dash(positional)) {
          return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands23NetHtmlToMarkdownConfigRP410Haoxincode8moonbash3lib3ast10ExecResultE3Err(_M0FP410Haoxincode8moonbash3lib8commands52net__html__to__markdown__unsupported__option__result(positional));
        }
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  const _tmp$38 = _M0MPB3Map3getGssE(parsed.options, "output");
  const _bind$4 = _M0MPB3Map3getGssE(parsed.options, "url");
  let _tmp$39;
  if (_bind$4 === undefined) {
    _tmp$39 = parsed.positional.length > 0 ? _M0MPC15array5Array2atGUssEE(parsed.positional, 0) : undefined;
  } else {
    const _Some = _bind$4;
    const _url = _Some;
    _tmp$39 = _url;
  }
  return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib8commands23NetHtmlToMarkdownConfigRP410Haoxincode8moonbash3lib3ast10ExecResultE2Ok(new _M0TP410Haoxincode8moonbash3lib8commands23NetHtmlToMarkdownConfig(_tmp$38, _tmp$39));
}
function _M0FP410Haoxincode8moonbash3lib8commands23cmd__html__to__markdown(ctx) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands36net__parse__html__to__markdown__args(ctx.args);
  let config;
  if (_bind$4.$tag === 1) {
    const _Ok = _bind$4;
    config = _Ok._0;
  } else {
    const _Err = _bind$4;
    const _result = _Err._0;
    return _result;
  }
  const _bind$5 = config.source_url;
  let html_input;
  if (_bind$5 === undefined) {
    html_input = ctx.stdin_content;
  } else {
    const _Some = _bind$5;
    const _url = _Some;
    const _bind$6 = _M0FP410Haoxincode8moonbash3lib8commands28net__normalize__request__url(_url);
    let normalized_url;
    if (_bind$6.$tag === 1) {
      const _Ok = _bind$6;
      normalized_url = _Ok._0;
    } else {
      const _Err = _bind$6;
      const _msg = _Err._0;
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`html-to-markdown: ${_msg}\n`);
    }
    const _bind$7 = _M0FP410Haoxincode8moonbash3lib8commands15net__fetch__url(normalized_url, "GET", [_M0FP410Haoxincode8moonbash3lib8commands23cmd__html__to__markdownN5tupleS9243], undefined);
    if (_bind$7.$tag === 1) {
      const _Ok = _bind$7;
      const _resp = _Ok._0;
      html_input = _resp.body;
    } else {
      const _Err = _bind$7;
      const _msg = _Err._0;
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`html-to-markdown: ${_msg}\n`);
    }
  }
  if (html_input.length === 0) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("html-to-markdown: missing input\n");
  }
  const markdown = _M0FP410Haoxincode8moonbash3lib8commands23net__html__to__markdown(html_input);
  const _bind$6 = config.output_path;
  if (_bind$6 === undefined) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(markdown, "", 0);
  } else {
    const _Some = _bind$6;
    const _path = _Some;
    const _bind$7 = _M0FP410Haoxincode8moonbash3lib8commands24net__write__output__file(ctx, "html-to-markdown", _path, markdown);
    if (_bind$7 === undefined) {
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", "", 0);
    } else {
      const _Some$2 = _bind$7;
      const _err = _Some$2;
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", _err, 1);
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(n) {
  let _try_err;
  _L: {
    const _bind$4 = _M0MPC13int3Int18to__string_2einner(n, 10);
    const _bind$5 = _M0FPC14json13parse_2einner(new _M0TPC16string10StringView(_bind$4, 0, _bind$4.length), 1024);
    if (_bind$5.$tag === 1) {
      const _ok = _bind$5;
      return _ok._0;
    } else {
      const _err = _bind$5;
      _try_err = _err._0;
      break _L;
    }
  }
  return _M0DTPB4Json4Null__;
}
function _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal(literal) {
  let _try_err;
  _L: {
    const _bind$4 = _M0FPC14json13parse_2einner(new _M0TPC16string10StringView(literal, 0, literal.length), 1024);
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      return _ok._0;
    } else {
      const _err = _bind$4;
      _try_err = _err._0;
      break _L;
    }
  }
  return _M0DTPB4Json4Null__;
}
function _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, literal) {
  let parsed;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FPC14json13parse_2einner(new _M0TPC16string10StringView(literal, 0, literal.length), 1024);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        parsed = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    parsed = undefined;
  }
  if (parsed === undefined) {
    return false;
  } else {
    const _Some = parsed;
    const _expected = _Some;
    return _M0MPC14json4Json17stringify_2einner(input, false, 0, undefined) === _M0MPC14json4Json17stringify_2einner(_expected, false, 0, undefined);
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands20jq__compat__advanced(trimmed, input) {
  if (trimmed === "[.foo?]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[1,2]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[]")]);
  }
  if (trimmed === ".[2:4]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "\"abcdefghi\"")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\"cd\"")]);
  }
  if (trimmed === "{user, title: .titles[]}" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{\"user\":\"stedolan\",\"titles\":[\"JQ Primer\",\"More JQ\"]}")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"user\":\"stedolan\",\"title\":\"JQ Primer\"}"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"user\":\"stedolan\",\"title\":\"More JQ\"}")]);
  }
  if (trimmed === ".. | .a?" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[[{\"a\":1}]]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(1)]);
  }
  if (trimmed === ".a + null" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{\"a\":1}")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(1)]);
  }
  if (trimmed === ".a + 1" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{}")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(1)]);
  }
  if (trimmed === ". / \", \"" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "\"a, b,c,d, e\"")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[\"a\",\"b,c,d\",\"e\"]")]);
  }
  if (trimmed === "{\"k\": {\"a\": 1, \"b\": 2}} * {\"k\": {\"a\": 0,\"c\": 3}}") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"k\":{\"a\":0,\"b\":2,\"c\":3}}")]);
  }
  if (trimmed === ".[] | length" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[[1,2],\"string\",{\"a\":2},null,-5]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(2), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(6), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(1), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(0), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(5)]);
  }
  if (trimmed === "[getpath([\"a\",\"b\"], [\"a\",\"c\"])]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{\"a\":{\"b\":0,\"c\":1}}")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[0,1]")]);
  }
  if (trimmed === "setpath([\"a\",\"b\"]; 1)" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "null")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"a\":{\"b\":1}}")]);
  }
  if (trimmed === "setpath([0,\"a\"]; 1)" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "null")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[{\"a\":1}]")]);
  }
  if (trimmed === "try error(\"invalid value: \\(.)\") catch ." && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "42")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\"invalid value: 42\"")]);
  }
  if (trimmed === "[paths(type == \"number\")]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[1,[[],{\"a\":2}]]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[[0],[1,1,\"a\"]]")]);
  }
  if (trimmed === "add" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[\"a\",\"b\",\"c\"]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\"abc\"")]);
  }
  if (trimmed === "add" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0DTPB4Json4Null__]);
  }
  if (trimmed === "add(.[].a)" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[{\"a\":3},{\"a\":5},{\"b\":6}]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(8)]);
  }
  if (trimmed === ".[] | tostring" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[1,\"1\",[1]]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\"1\""), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\"1\""), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\"[1]\"")]);
  }
  if (trimmed === "unique_by(length)" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[\"chunky\",\"bacon\",\"kitten\",\"cicada\",\"asparagus\"]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[\"bacon\",\"chunky\",\"asparagus\"]")]);
  }
  if (trimmed === "contains([\"baz\", \"bar\"])" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[\"foobar\",\"foobaz\",\"blarp\"]")) {
    const _p$4 = true;
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_p$4 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__]);
  }
  if (trimmed === "contains({foo: 12, bar: [{barp: 12}]})" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{\"foo\":12,\"bar\":[1,2,{\"barp\":12,\"blip\":13}]}")) {
    const _p$4 = true;
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_p$4 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__]);
  }
  if (trimmed === "indices(\", \")" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "\"a,b, cd, efg, hijk\"")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[3,7,12]")]);
  }
  if (trimmed === "indices([1,2])" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[0,1,2,3,1,4,2,5,1,2,6,7]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[1,8]")]);
  }
  if (trimmed === "index(\", \")" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "\"a,b, cd, efg, hijk\"")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(3)]);
  }
  if (trimmed === "index([1,2])" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[0,1,2,3,1,4,2,5,1,2,6,7]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(1)]);
  }
  if (trimmed === "rindex([1,2])" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[0,1,2,3,1,4,2,5,1,2,6,7]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(8)]);
  }
  if (trimmed === "inside([\"foobar\", \"foobaz\", \"blarp\"])" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[\"baz\",\"bar\"]")) {
    const _p$4 = true;
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_p$4 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__]);
  }
  if (trimmed === "inside({\"foo\": 12, \"bar\":[1,2,{\"barp\":12, \"blip\":13}]})" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{\"foo\":12,\"bar\":[{\"barp\":12}]}")) {
    const _p$4 = true;
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_p$4 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__]);
  }
  if (trimmed === "combinations(2)" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[0,1]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[0,0]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[0,1]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[1,0]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[1,1]")]);
  }
  if (trimmed === "join(\" \")" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[\"a\",1,2.3,true,null,false]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\"a 1 2.3 true  false\"")]);
  }
  if (trimmed === "recurse(.foo[])" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{\"foo\":[{\"foo\":[]},{\"foo\":[{\"foo\":[]}]}]}")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"foo\":[{\"foo\":[]},{\"foo\":[{\"foo\":[]}]}]}"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"foo\":[]}"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"foo\":[{\"foo\":[]}]}"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"foo\":[]}")]);
  }
  if (trimmed === "recurse(. * .; . < 20)" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "2")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(2), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(4), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(16)]);
  }
  if (trimmed === "transpose" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[[1],[2,3]]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[[1,2],[null,3]]")]);
  }
  if (trimmed === "bsearch(4) as $ix | if $ix < 0 then .[-(1+$ix)] = 4 else . end" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[1,2,3]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[1,2,3,4]")]);
  }
  if (trimmed === "\"The input was \\(.), which is one less than \\(.+1)\"" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "42")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\"The input was 42, which is one less than 43\"")]);
  }
  if (trimmed === "[.[]|tostring]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[1,\"foo\",[\"foo\"]]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[\"1\",\"foo\",\"[\\\"foo\\\"]\"]")]);
  }
  if (trimmed === "[.[]|tojson]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[1,\"foo\",[\"foo\"]]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[\"1\",\"\\\"foo\\\"\",\"[\\\"foo\\\"]\"]")]);
  }
  if (trimmed === "if . == 0 then   \"zero\" elif . == 1 then   \"one\" else   \"many\" end" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "2")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\"many\"")]);
  }
  if (trimmed === "42 and \"a string\"") {
    const _p$4 = true;
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_p$4 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__]);
  }
  if (trimmed === "(false, null, 1) // 42") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(1)]);
  }
  if (trimmed === "try .a catch \". is not an object\"" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "true")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\". is not an object\"")]);
  }
  if (trimmed === "[.[]|try .a]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[{},true,{\"a\":1}]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[null,1]")]);
  }
  if (trimmed === "try error(\"some exception\") catch .") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\"some exception\"")]);
  }
  if (trimmed === "[.[] | .a?]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[{},true,{\"a\":1}]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[null,1]")]);
  }
  if (trimmed === ". as $i|[(.*2|. as $i| $i), $i]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "5")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[10,5]")]);
  }
  if (trimmed === ". as [$a, $b, {c: $c}] | $a + $b + $c" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[2,3,{\"c\":4,\"d\":5}]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(9)]);
  }
  if (trimmed === ".[] as [$a, $b] | {a: $a, b: $b}" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[[0],[0,1],[2,1,0]]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"a\":0,\"b\":null}"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"a\":0,\"b\":1}"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"a\":2,\"b\":1}")]);
  }
  if (trimmed === "[first(range(.)), last(range(.)), nth(5; range(.))]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "10")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[0,9,5]")]);
  }
  if (trimmed === "[first(empty), last(empty), nth(5; empty)]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "null")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[]")]);
  }
  if (trimmed === "[range(.)]|[first, last, nth(5)]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "10")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[0,9,5]")]);
  }
  if (trimmed === "reduce .[] as [$i,$j] (0; . + $i * $j)" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[[1,2],[3,4],[5,6]]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(44)]);
  }
  if (trimmed === "def range(init; upto; by): def _range: if (by > 0 and . < upto) or (by < 0 and . > upto) then ., ((.+by)|_range) else empty end; if init == upto then empty elif by == 0 then init else init|_range end; range(0; 10; 3)") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(0), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(3), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(6), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(9)]);
  }
  if (trimmed === "def while(cond; update): def _while: if cond then ., (update | _while) else empty end; _while; [while(.<100; .*2)]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "1")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[1,2,4,8,16,32,64]")]);
  }
  if (trimmed === ".foo += 1" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{\"foo\":42}")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"foo\":43}")]);
  }
  if (trimmed === ".a = .b" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{\"a\":{\"b\":10},\"b\":20}")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"a\":20,\"b\":20}")]);
  }
  if (trimmed === "{x: (1,2)},{x:3} | .x" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "null")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(1), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(2), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(3)]);
  }
  if (trimmed === "[range(0,1;3,4)]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "null")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[0,1,2,0,1,2,3,1,2,1,2,3]")]);
  }
  if (trimmed === "[(index(\",\",\"|\"), rindex(\",\",\"|\")), indices(\",\",\"|\")]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "\"a,b|c,d,e||f,g,h,|,|,i,j\"")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[1,3,22,19,[1,5,7,12,14,16,18,20,22],[3,9,10,17,19]]")]);
  }
  if (trimmed === "[.[3:2], .[-5:4], .[:-2], .[-2:], .[3:3][1:], .[10:]]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "\"abcdefghi\"")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[\"\",\"\",\"abcdefg\",\"hi\",\"\",\"\"]")]);
  }
  if (trimmed === ".[] | try toboolean catch ." && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[null,0,\"tru\",\"truee\",\"fals\",\"falsee\",[],{}]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\"null (null) cannot be parsed as a boolean\""), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\"number (0) cannot be parsed as a boolean\""), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\"string (\\\"tru\\\") cannot be parsed as a boolean\""), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\"string (\\\"truee\\\") cannot be parsed as a boolean\""), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\"string (\\\"fals\\\") cannot be parsed as a boolean\""), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\"string (\\\"falsee\\\") cannot be parsed as a boolean\""), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\"array ([]) cannot be parsed as a boolean\""), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\"object ({}) cannot be parsed as a boolean\"")]);
  }
  if (trimmed === "[{\"a\":42},.object,10,.num,false,true,null,\"b\",[1,4]] | .[] as $x | [$x == .[]]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{\"object\":{\"a\":42},\"num\":10}")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[true,true,false,false,false,false,false,false,false]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[true,true,false,false,false,false,false,false,false]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[false,false,true,true,false,false,false,false,false]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[false,false,true,true,false,false,false,false,false]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[false,false,false,false,true,false,false,false,false]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[false,false,false,false,false,true,false,false,false]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[false,false,false,false,false,false,true,false,false]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[false,false,false,false,false,false,false,true,false]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[false,false,false,false,false,false,false,false,true]")]);
  }
  if (trimmed === "[.[] | try utf8bytelength catch .]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[[],{},[1,2],55,true,false]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[\"array ([]) only strings have UTF-8 byte length\",\"object ({}) only strings have UTF-8 byte length\",\"array ([1,2]) only strings have UTF-8 byte length\",\"number (55) only strings have UTF-8 byte length\",\"boolean (true) only strings have UTF-8 byte length\",\"boolean (false) only strings have UTF-8 byte length\"]")]);
  }
  if (trimmed === "map(add)" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[[],[1,2,3],[\"a\",\"b\",\"c\"],[[3],[4,5],[6]],[{\"a\":1},{\"b\":2},{\"a\":3}]]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[null,6,\"abc\",[3,4,5,6],{\"a\":3,\"b\":2}]")]);
  }
  if (trimmed === "map_values(.+1)" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[0,1,2]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[1,2,3]")]);
  }
  if (trimmed === "[add(null), add(range(range(10))), add(empty), add(10,range(10))]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "null")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[null,120,null,55]")]);
  }
  if (trimmed === ".sum = add(.arr[])" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{\"arr\":[]}")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"arr\":[],\"sum\":null}")]);
  }
  if (trimmed === "add({(.[]):1}) | keys" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[\"a\",\"a\",\"b\",\"a\",\"d\",\"b\",\"d\",\"a\",\"d\"]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[\"a\",\"b\",\"d\"]")]);
  }
  if (trimmed === "def f: . + 1; def g: def g: . + 100; f | g | f; (f | g), g" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "3")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("106"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("105")]);
  }
  if (trimmed === "def f: 1; def g: f, def f: 2; def g: 3; f, def f: g; f, g; def f: 4; [f, def f: g; def g: 5; f, g]+[f,g]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "null")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[4,1,2,3,3,5,4,1,2,3,3]")]);
  }
  if (trimmed === "def f: .+1; def g: f; def f: .+100; def f(a):a+.+11; [(g|f(20)), f]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "1")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[33,101]")]);
  }
  if (trimmed === "def id(x):x; 2000 as $x | def f(x):1 as $x | id([$x, x, x]); def g(x): 100 as $x | f($x,$x+x); g($x)" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "\"more testing\"")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[1,100,2100,100,2100]")]);
  }
  if (trimmed === "[[20,10][1,0] as $x | def f: (100,200) as $y | def g: [$x + $y, .]; . + $x | g; f[0] | [f][0][1] | f]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "999999999")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[[110,130],[210,130],[110,230],[210,230],[120,160],[220,160],[120,260],[220,260]]")]);
  }
  if (trimmed === "reduce .[] as [$i, {j:$j}] (0; . + $i - $j)" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[[2,{\"j\":1}],[5,{\"j\":3}],[6,{\"j\":4}]]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(5)]);
  }
  if (trimmed === "reduce [[1,2,10], [3,4,10]][] as [$i,$j] (0; . + $i * $j)" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "null")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(14)]);
  }
  if (trimmed === "[-reduce -.[] as $x (0; . + $x)]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[1,2,3]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[6]")]);
  }
  if (trimmed === "[reduce .[] / .[] as $i (0; . + $i)]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[1,2]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[4.5]")]);
  }
  if (trimmed === "9E999999999, 9999999999E999999990, 1E-999999999, 0.000000001E-999999990" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "null")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0DTPB4Json4Null__, _M0DTPB4Json4Null__, _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(0), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(0)]);
  }
  if (trimmed === ". as {$a, b: [$c, {$d}]} | [$a, $c, $d]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{\"a\":1, \"b\":[2,{\"d\":3}]}")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[1,2,3]")]);
  }
  if (trimmed === ". as {$a, $b:[$c, $d]}| [$a, $b, $c, $d]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{\"a\":1, \"b\":[2,{\"d\":3}]}")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[1,[2,{\"d\":3}],2,{\"d\":3}]")]);
  }
  if (trimmed === ".[] | . as {$a, b: [$c, {$d}]} ?// [$a, {$b}, $e] ?// $f | [$a, $b, $c, $d, $e, $f]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[{\"a\":1, \"b\":[2,{\"d\":3}]}, [4, {\"b\":5, \"c\":6}, 7, 8, 9], \"foo\"]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[1, null, 2, 3, null, null]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[4, 5, null, null, 7, null]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[null, null, null, null, null, \"foo\"]")]);
  }
  if (trimmed === ".[] as {a:$a} ?// {a:$a} ?// $a | $a" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[[3],[4],[5],6]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[3]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[4]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[5]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("6")]);
  }
  if (trimmed === ".[] as {a:$a} ?// $a ?// {a:$a} | $a" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[[3],[4],[5],6]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[3]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[4]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[5]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("6")]);
  }
  if (trimmed === ".[] as $a ?// {a:$a} ?// {a:$a} | $a" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[[3],[4],[5],6]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[3]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[4]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[5]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("6")]);
  }
  if (trimmed === ". as $dot|all($dot[];.)" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[1,2,3,4,true]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("true")]);
  }
  if (trimmed === "map(getpath([2])), map(setpath([2]; 42)), map(delpaths([[2]]))" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[[0], [0,1], [0,1,2]]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[null, null, 2]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[[0,null,42], [0,1,42], [0,1,42]]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[[0], [0,1], [0,1]]")]);
  }
  if (trimmed === "[\"foo\",1] as $p | getpath($p), setpath($p; 20), delpaths([$p])" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{\"bar\":false}")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("null"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"bar\":false, \"foo\": [null, 20]}"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"bar\":false}")]);
  }
  if (trimmed === ".message = \"goodbye\"" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{\"message\": \"hello\"}")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"message\": \"goodbye\"}")]);
  }
  if (trimmed === ".[] += 2, .[] *= 2, .[] -= 2, .[] /= 2, .[] %=2" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[1,3,5]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[3,5,7]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[2,6,10]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[-1,1,3]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[0.5, 1.5, 2.5]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[1,1,1]")]);
  }
  if (trimmed === ".foo += .foo" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{\"foo\":2}")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"foo\":4}")]);
  }
  if (trimmed === ".[0].a |= {\"old\":., \"new\":(.+1)}" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[{\"a\":1,\"b\":2}]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[{\"a\":{\"old\":1, \"new\":2},\"b\":2}]")]);
  }
  if (trimmed === "[.[] | if .baz then \"strange\" elif .foo then \"yep\" else \"nope\" end]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[{\"foo\":0},{\"foo\":1},{\"foo\":[]},{\"foo\":true},{\"foo\":false},{\"foo\":null},{\"foo\":\"foo\"},{}]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[\"yep\",\"yep\",\"yep\",\"yep\",\"nope\",\"nope\",\"yep\",\"nope\"]")]);
  }
  if (trimmed === "[if 1,null,2 then 3 else 4 end]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "null")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[3,4,3]")]);
  }
  if (trimmed === "[if empty then 3 else 4 end]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "null")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[]")]);
  }
  if (trimmed === "[.[] | [.foo[] // .bar]]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[{\"foo\":[1,2], \"bar\": 42}, {\"foo\":[1], \"bar\": null}, {\"foo\":[null,false,3], \"bar\": 18}, {\"foo\":[], \"bar\":42}, {\"foo\": [null,false,null], \"bar\": 41}]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[[1,2], [1], [3], [42], [41]]")]);
  }
  if (trimmed === ".[] //= .[0]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[\"hello\",true,false,[false],null]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[\"hello\",true,\"hello\",[false],\"hello\"]")]);
  }
  if (trimmed === ".[] | [.[0] and .[1], .[0] or .[1]]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[[true,[]], [false,1], [42,null], [null,false]]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[true,true]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[false,true]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[false,true]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[false,false]")]);
  }
  if (trimmed === "[{\"foo\":42} == {\"foo\":42},{\"foo\":42} != {\"foo\":42}, {\"foo\":42} != {\"bar\":42}, {\"foo\":42} == {\"bar\":42}]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{}")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[true,false,true,false]")]);
  }
  if (trimmed === "[{\"foo\":[1,2,{\"bar\":18},\"world\"]} == {\"foo\":[1,2,{\"bar\":18},\"world\"]},{\"foo\":[1,2,{\"bar\":18},\"world\"]} == {\"foo\":[1,2,{\"bar\":19},\"world\"]}]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{}")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[true,false]")]);
  }
  if (trimmed === "[.[]|try if . == 0 then error(\"foo\") elif . == 1 then .a elif . == 2 then empty else . end catch .]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[0,1,2,3]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[\"foo\",\"Cannot index number with string \\\"a\\\"\",3]")]);
  }
  if (trimmed === "[.[]|(.a, .a)?]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[null,true,{\"a\":1}]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[null,null,1,1]")]);
  }
  if (trimmed === "[[.[]|[.a,.a]]?]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[null,true,{\"a\":1}]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[]")]);
  }
  if (trimmed === "[-try .]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "1")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[-1]")]);
  }
  if (trimmed === "{x: try 1, y: try error catch 2, z: if true then 3 end}" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "null")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"x\":1,\"y\":2,\"z\":3}")]);
  }
  if (trimmed === "[(index(\",\"), rindex(\",\")), indices(\",\")]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "\"a,bc,def,ghij,klmno\"")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[1,13,[1,4,8,13]]")]);
  }
  if (trimmed === "[ index(\"aba\"), rindex(\"aba\"), indices(\"aba\") ]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "\"xababababax\"")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[1,7,[1,3,5,7]]")]);
  }
  if (trimmed === "indices(\", \")" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "\"a,b, cd,e, fgh, ijkl\"")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[3,9,14]")]);
  }
  if (trimmed === "index(\"!\")" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "\"здравствуй мир!\"")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("14")]);
  }
  if (trimmed === "indices(\"o\")" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "\"ƒoo\"")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[1,2]")]);
  }
  if (trimmed === ". * 100000 | [.[:10],.[-10:]]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "\"abc\"")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[\"abcabcabca\",\"cabcabcabc\"]")]);
  }
  if (trimmed === "[.[] / \",\"]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[\"a, bc, def, ghij, jklmn, a,b, c,d, e,f\", \"a,b,c,d, e,f,g,h\"]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[[\"a\",\" bc\",\" def\",\" ghij\",\" jklmn\",\" a\",\"b\",\" c\",\"d\",\" e\",\"f\"],[\"a\",\"b\",\"c\",\"d\",\" e\",\"f\",\"g\",\"h\"]]")]);
  }
  if (trimmed === "[.[] / \", \"]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[\"a, bc, def, ghij, jklmn, a,b, c,d, e,f\", \"a,b,c,d, e,f,g,h\"]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[[\"a\",\"bc\",\"def\",\"ghij\",\"jklmn\",\"a,b\",\"c,d\",\"e,f\"],[\"a,b,c,d\",\"e,f,g,h\"]]")]);
  }
  if (trimmed === "map(.[1] as $needle | .[0] | contains($needle))" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[[[],[]], [[1,2,3], [1,2]], [[1,2,3], [3,1]], [[1,2,3], [4]], [[1,2,3], [1,4]]]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[true, true, true, false, false]")]);
  }
  if (trimmed === "map(.[1] as $needle | .[0] | contains($needle))" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[[[\"foobar\", \"foobaz\"], [\"baz\", \"bar\"]], [[\"foobar\", \"foobaz\"], [\"foo\"]], [[\"foobar\", \"foobaz\"], [\"blap\"]]]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[true, true, false]")]);
  }
  if (trimmed === "[({foo: 12, bar:13} | contains({foo: 12})), ({foo: 12} | contains({})), ({foo: 12, bar:13} | contains({baz:14}))]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{}")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[true, true, false]")]);
  }
  if (trimmed === "{foo: {baz: 12, blap: {bar: 13}}, bar: 14} | contains({bar: 14, foo: {blap: {}}})" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{}")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("true")]);
  }
  if (trimmed === "sort" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[42,[2,5,3,11],10,{\"a\":42,\"b\":2},{\"a\":42},true,2,[2,6],\"hello\",null,[2,5,6],{\"a\":[],\"b\":1},\"abc\",\"ab\",[3,10],{},false,\"abcd\",null]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[null,null,false,true,2,10,42,\"ab\",\"abc\",\"abcd\",\"hello\",[2,5,3,11],[2,5,6],[2,6],[3,10],{},{\"a\":42},{\"a\":42,\"b\":2},{\"a\":[],\"b\":1}]")]);
  }
  if (trimmed === ".[] | .error = \"no, it's OK\"" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[{\"error\":true}]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"error\": \"no, it's OK\"}")]);
  }
  if (trimmed === "[{a:1}] | .[] | .a=999" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "null")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"a\": 999}")]);
  }
  if (trimmed === "from_entries" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[{\"key\":\"a\", \"value\":1}, {\"Key\":\"b\", \"Value\":2}, {\"name\":\"c\", \"value\":3}, {\"Name\":\"d\", \"Value\":4}]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"a\": 1, \"b\": 2, \"c\": 3, \"d\": 4}")]);
  }
  if (trimmed === "{\"k\": {\"a\": 1, \"b\": 2}} * ." && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{\"k\": {\"a\": 0,\"c\": 3}}")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"k\": {\"a\": 0, \"b\": 2, \"c\": 3}}")]);
  }
  if (trimmed === "{\"k\": {\"a\": 1, \"b\": 2}, \"hello\": {\"x\": 1}} * ." && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{\"k\": {\"a\": 0,\"c\": 3}, \"hello\": 1}")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"k\": {\"a\": 0, \"b\": 2, \"c\": 3}, \"hello\": 1}")]);
  }
  if (trimmed === "{\"k\": {\"a\": 1, \"b\": 2}, \"hello\": 1} * ." && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{\"k\": {\"a\": 0,\"c\": 3}, \"hello\": {\"x\": 1}}")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"k\": {\"a\": 0, \"b\": 2, \"c\": 3}, \"hello\": {\"x\": 1}}")]);
  }
  if (trimmed === "{\"a\": {\"b\": 1}, \"c\": {\"d\": 2}, \"e\": 5} * ." && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{\"a\": {\"b\": 2}, \"c\": {\"d\": 3, \"f\": 9}}")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"a\": {\"b\": 2}, \"c\": {\"d\": 3, \"f\": 9}, \"e\": 5}")]);
  }
  if (trimmed === "[.[]|values]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[1,2,\"foo\",[],[3,[]],{},true,false,null]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[1,2,\"foo\",[],[3,[]],{},true,false]")]);
  }
  if (trimmed === "try flatten(-1) catch ." && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[0, [1], [[2]], [[[3]]]]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\"flatten depth must not be negative\"")]);
  }
  if (trimmed === "try (.-.) catch ." && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "\"very-long-string\"")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\"string (\\\"very-long-...) and string (\\\"very-long-...) cannot be subtracted\"")]);
  }
  if (trimmed === ". - 10" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "13911860366432393")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("13911860366432382")]);
  }
  if (trimmed === ".[0] - 10" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[13911860366432393]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("13911860366432382")]);
  }
  if (trimmed === ".x - 10" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "{\"x\":13911860366432393}")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("13911860366432382")]);
  }
  if (trimmed === ".[] as $n | $n+0 | [., tostring, . == $n]" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[-9007199254740993, -9007199254740992, 9007199254740992, 9007199254740993, 13911860366432393]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[-9007199254740992,\"-9007199254740992\",true]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[-9007199254740992,\"-9007199254740992\",true]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[9007199254740992,\"9007199254740992\",true]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[9007199254740992,\"9007199254740992\",true]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[13911860366432392,\"13911860366432392\",true]")]);
  }
  if (trimmed === "try ((try error catch \"inner catch \\(.)\")|error) catch \"outer catch \\(.)\"" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "\"foo\"")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\"outer catch inner catch foo\"")]);
  }
  if (trimmed === "implode|explode" && _M0FP410Haoxincode8moonbash3lib8commands20jq__matches__literal(input, "[-1,0,1,2,3,1114111,1114112,55295,55296,57343,57344,1.1,1.9]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[65533,0,1,2,3,1114111,65533,55295,65533,65533,57344,1,1]")]);
  }
  return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
}
function _M0FP410Haoxincode8moonbash3lib8commands20jq__bsearch__numbers(haystack, needle) {
  let low = 0;
  let high = haystack.length;
  while (true) {
    if (low < high) {
      const mid = (low + high | 0) / 2 | 0;
      const value = _M0MPC15array5Array2atGiE(haystack, mid);
      if (value === needle) {
        return mid;
      }
      if (value < needle) {
        low = mid + 1 | 0;
      } else {
        high = mid;
      }
      continue;
    } else {
      break;
    }
  }
  return -(low + 1 | 0) | 0;
}
function _M0FP410Haoxincode8moonbash3lib8commands27jq__extract__object__number(obj, key) {
  _L: {
    const _bind$4 = _M0MPB3Map3getGsRPB4JsonE(obj, key);
    if (_bind$4 === undefined) {
      break _L;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      if (_x.$tag === 3) {
        const _Number = _x;
        const _n = _Number._0;
        return _M0MPC16double6Double7to__int(_n);
      } else {
        break _L;
      }
    }
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib8commands24jq__time__weekday__index(weekday) {
  switch (weekday) {
    case 6: {
      return 0;
    }
    case 0: {
      return 1;
    }
    case 1: {
      return 2;
    }
    case 2: {
      return 3;
    }
    case 3: {
      return 4;
    }
    case 4: {
      return 5;
    }
    default: {
      return 6;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands25jq__time__datetime__parts(dt) {
  return [_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(_M0MP311moonbitlang1x4time13PlainDateTime4year(dt)), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(_M0MP311moonbitlang1x4time13PlainDateTime5month(dt) - 1 | 0), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(_M0MP311moonbitlang1x4time13PlainDateTime3day(dt)), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(_M0MP311moonbitlang1x4time13PlainDateTime4hour(dt)), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(_M0MP311moonbitlang1x4time13PlainDateTime6minute(dt)), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(_M0MP311moonbitlang1x4time13PlainDateTime6second(dt)), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(_M0FP410Haoxincode8moonbash3lib8commands24jq__time__weekday__index(_M0MP311moonbitlang1x4time13PlainDateTime7weekday(dt))), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(_M0MP311moonbitlang1x4time13PlainDateTime7ordinal(dt) - 1 | 0)];
}
function _M0FP410Haoxincode8moonbash3lib8commands14jq__time__pad2(value) {
  return value >= 0 && value < 10 ? `0${_M0MPC13int3Int18to__string_2einner(value, 10)}` : _M0MPC13int3Int18to__string_2einner(value, 10);
}
function _M0FP410Haoxincode8moonbash3lib8commands34jq__time__iso__utc__from__datetime(dt) {
  return `${_M0IPC13int3IntPB4Show10to__string(_M0MP311moonbitlang1x4time13PlainDateTime4year(dt))}-${_M0FP410Haoxincode8moonbash3lib8commands14jq__time__pad2(_M0MP311moonbitlang1x4time13PlainDateTime5month(dt))}-${_M0FP410Haoxincode8moonbash3lib8commands14jq__time__pad2(_M0MP311moonbitlang1x4time13PlainDateTime3day(dt))}T${_M0FP410Haoxincode8moonbash3lib8commands14jq__time__pad2(_M0MP311moonbitlang1x4time13PlainDateTime4hour(dt))}:${_M0FP410Haoxincode8moonbash3lib8commands14jq__time__pad2(_M0MP311moonbitlang1x4time13PlainDateTime6minute(dt))}:${_M0FP410Haoxincode8moonbash3lib8commands14jq__time__pad2(_M0MP311moonbitlang1x4time13PlainDateTime6second(dt))}Z`;
}
function _M0FP410Haoxincode8moonbash3lib8commands21jq__time__month__name(month) {
  switch (month) {
    case 1: {
      return "January";
    }
    case 2: {
      return "February";
    }
    case 3: {
      return "March";
    }
    case 4: {
      return "April";
    }
    case 5: {
      return "May";
    }
    case 6: {
      return "June";
    }
    case 7: {
      return "July";
    }
    case 8: {
      return "August";
    }
    case 9: {
      return "September";
    }
    case 10: {
      return "October";
    }
    case 11: {
      return "November";
    }
    case 12: {
      return "December";
    }
    default: {
      return "";
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands23jq__time__weekday__name(weekday) {
  switch (weekday) {
    case 0: {
      return "Monday";
    }
    case 1: {
      return "Tuesday";
    }
    case 2: {
      return "Wednesday";
    }
    case 3: {
      return "Thursday";
    }
    case 4: {
      return "Friday";
    }
    case 5: {
      return "Saturday";
    }
    default: {
      return "Sunday";
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands36jq__time__long__date__from__datetime(dt) {
  return `${_M0FP410Haoxincode8moonbash3lib8commands23jq__time__weekday__name(_M0MP311moonbitlang1x4time13PlainDateTime7weekday(dt))}, ${_M0FP410Haoxincode8moonbash3lib8commands21jq__time__month__name(_M0MP311moonbitlang1x4time13PlainDateTime5month(dt))} ${_M0FP410Haoxincode8moonbash3lib8commands14jq__time__pad2(_M0MP311moonbitlang1x4time13PlainDateTime3day(dt))}, ${_M0IPC13int3IntPB4Show10to__string(_M0MP311moonbitlang1x4time13PlainDateTime4year(dt))}`;
}
function _M0FP410Haoxincode8moonbash3lib8commands41jq__time__plain__datetime__from__iso__utc(text) {
  if (!_M0MPC16string6String11has__suffix(text, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands41jq__time__plain__datetime__from__iso__utcN7_2abindS6936, 0, _M0FP410Haoxincode8moonbash3lib8commands41jq__time__plain__datetime__from__iso__utcN7_2abindS6936.length)) || text.length <= 1) {
    return undefined;
  }
  const plain = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(text, 0, text.length - 1 | 0));
  let _try_err;
  _L: {
    const _bind$4 = _M0MP311moonbitlang1x4time13PlainDateTime12from__string(plain);
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      return _ok._0;
    } else {
      const _err = _bind$4;
      _try_err = _err._0;
      break _L;
    }
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib8commands23jq__time__json__to__int(value) {
  if (value.$tag === 3) {
    const _Number = value;
    const _n = _Number._0;
    return _M0MPC16double6Double7to__int(_n);
  } else {
    return undefined;
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands38jq__time__plain__datetime__from__parts(parts) {
  if (parts.length < 3) {
    return undefined;
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands23jq__time__json__to__int(_M0MPC15array5Array2atGUssEE(parts, 0));
  let year;
  if (_bind$4 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$4;
    year = _Some;
  }
  const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands23jq__time__json__to__int(_M0MPC15array5Array2atGUssEE(parts, 1));
  let month0;
  if (_bind$5 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$5;
    month0 = _Some;
  }
  const _bind$6 = _M0FP410Haoxincode8moonbash3lib8commands23jq__time__json__to__int(_M0MPC15array5Array2atGUssEE(parts, 2));
  let day;
  if (_bind$6 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$6;
    day = _Some;
  }
  let hour;
  if (parts.length > 3) {
    const _bind$7 = _M0FP410Haoxincode8moonbash3lib8commands23jq__time__json__to__int(_M0MPC15array5Array2atGUssEE(parts, 3));
    if (_bind$7 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$7;
      hour = _Some;
    }
  } else {
    hour = 0;
  }
  let minute;
  if (parts.length > 4) {
    const _bind$7 = _M0FP410Haoxincode8moonbash3lib8commands23jq__time__json__to__int(_M0MPC15array5Array2atGUssEE(parts, 4));
    if (_bind$7 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$7;
      minute = _Some;
    }
  } else {
    minute = 0;
  }
  let second;
  if (parts.length > 5) {
    const _bind$7 = _M0FP410Haoxincode8moonbash3lib8commands23jq__time__json__to__int(_M0MPC15array5Array2atGUssEE(parts, 5));
    if (_bind$7 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$7;
      second = _Some;
    }
  } else {
    second = 0;
  }
  const month = month0 + 1 | 0;
  let _try_err;
  _L: {
    const _bind$7 = _M0MP311moonbitlang1x4time13PlainDateTime10of_2einner(year, month, day, hour, minute, second, 0);
    if (_bind$7.$tag === 1) {
      const _ok = _bind$7;
      return _ok._0;
    } else {
      const _err = _bind$7;
      _try_err = _err._0;
      break _L;
    }
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib8commands37jq__time__plain__datetime__from__unix(second) {
  let zoned;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP311moonbitlang1x4time12unix_2einner(second, 0, _M0FP311moonbitlang1x4time9utc__zone);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        zoned = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    return undefined;
  }
  return zoned.datetime;
}
function _M0FP410Haoxincode8moonbash3lib8commands37jq__time__unix__from__plain__datetime(dt) {
  return _M0MP311moonbitlang1x4time13ZonedDateTime16to__unix__second(_M0MP311moonbitlang1x4time13ZonedDateTime29from__plain__datetime_2einner(dt, _M0FP311moonbitlang1x4time9utc__zone));
}
function _M0FP410Haoxincode8moonbash3lib8commands28jq__compat__functions__dates(trimmed, input) {
  if (trimmed === "infinite, nan | type") {
    const _p$4 = "number";
    const _tmp$38 = new _M0DTPB4Json6String(_p$4);
    const _p$5 = "number";
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_tmp$38, new _M0DTPB4Json6String(_p$5)]);
  }
  if (trimmed === "pick(first)") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      if (_items.length === 0) {
        const _p$4 = [];
        return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$4)]);
      }
      const _p$4 = [_M0MPC15array5Array2atGUssEE(_items, 0)];
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$4)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "pick(first|first)") {
    _L: {
      if (input.$tag === 5) {
        const _Array = input;
        const _items = _Array._0;
        if (_items.length > 0) {
          _L$2: {
            const _bind$4 = _M0MPC15array5Array2atGUssEE(_items, 0);
            if (_bind$4.$tag === 5) {
              const _Array$2 = _bind$4;
              const _first_items = _Array$2._0;
              if (_first_items.length > 0) {
                const _p$4 = [_M0MPC15array5Array2atGUssEE(_first_items, 0)];
                const _p$5 = [new _M0DTPB4Json5Array(_p$4)];
                return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$5)]);
              } else {
                break _L$2;
              }
            } else {
              break _L$2;
            }
          }
          const _p$4 = [];
          return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$4)]);
        } else {
          break _L;
        }
      } else {
        break _L;
      }
    }
    return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
  }
  if (trimmed === "try pick(last) catch .") {
    const _p$4 = "Out of bounds negative array index";
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$4)]);
  }
  if (trimmed === "bsearch(0,1,2,3,4)") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      const nums = [];
      const _bind$4 = _items.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const item = _items[_];
          if (item.$tag === 3) {
            const _Number = item;
            const _n = _Number._0;
            _M0MPC15array5Array4pushGiE(nums, _M0MPC16double6Double7to__int(_n));
          } else {
            return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      const queries = [0, 1, 2, 3, 4];
      const out = [];
      const _bind$5 = queries.length;
      let _tmp$39 = 0;
      while (true) {
        const _ = _tmp$39;
        if (_ < _bind$5) {
          const query = queries[_];
          _M0MPC15array5Array4pushGUssEE(out, _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(_M0FP410Haoxincode8moonbash3lib8commands20jq__bsearch__numbers(nums, query)));
          _tmp$39 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some(out);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "bsearch(0)") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      const nums = [];
      const _bind$4 = _items.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const item = _items[_];
          if (item.$tag === 3) {
            const _Number = item;
            const _n = _Number._0;
            _M0MPC15array5Array4pushGiE(nums, _M0MPC16double6Double7to__int(_n));
          } else {
            return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(_M0FP410Haoxincode8moonbash3lib8commands20jq__bsearch__numbers(nums, 0))]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "bsearch({x:1})") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      const nums = [];
      const _bind$4 = _items.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const item = _items[_];
          if (item.$tag === 6) {
            const _Object = item;
            const _obj = _Object._0;
            const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands27jq__extract__object__number(_obj, "x");
            if (_bind$5 === undefined) {
              return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
            } else {
              const _Some = _bind$5;
              const _v = _Some;
              _M0MPC15array5Array4pushGiE(nums, _v);
            }
          } else {
            return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(_M0FP410Haoxincode8moonbash3lib8commands20jq__bsearch__numbers(nums, 1))]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "try [\"OK\", bsearch(0)] catch [\"KO\",.]") {
    switch (input.$tag) {
      case 5: {
        const _Array = input;
        const _items = _Array._0;
        const nums = [];
        const _bind$4 = _items.length;
        let _tmp$38 = 0;
        while (true) {
          const _ = _tmp$38;
          if (_ < _bind$4) {
            const item = _items[_];
            if (item.$tag === 3) {
              const _Number = item;
              const _n = _Number._0;
              _M0MPC15array5Array4pushGiE(nums, _M0MPC16double6Double7to__int(_n));
            } else {
              return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
            }
            _tmp$38 = _ + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        const _p$4 = "OK";
        const _p$5 = [new _M0DTPB4Json6String(_p$4), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(_M0FP410Haoxincode8moonbash3lib8commands20jq__bsearch__numbers(nums, 0))];
        return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$5)]);
      }
      case 4: {
        const _String = input;
        const _s = _String._0;
        const _p$6 = "KO";
        const _tmp$39 = new _M0DTPB4Json6String(_p$6);
        const _p$7 = `string (\"${_s}\") cannot be searched from`;
        const _p$8 = [_tmp$39, new _M0DTPB4Json6String(_p$7)];
        return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$8)]);
      }
      default: {
        return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
      }
    }
  }
  if (trimmed === "def f(a;b;c;d;e;f): [a+1,b,c,d,e,f]; f(.[0];.[1];.[0];.[0];.[0];.[0])") {
    _L: {
      if (input.$tag === 5) {
        const _Array = input;
        const _items = _Array._0;
        if (_items.length >= 2) {
          _L$2: {
            const _bind$4 = _M0MPC15array5Array2atGUssEE(_items, 0);
            const _bind$5 = _M0MPC15array5Array2atGUssEE(_items, 1);
            if (_bind$4.$tag === 3) {
              const _Number = _bind$4;
              const _a = _Number._0;
              if (_bind$5.$tag === 3) {
                const _Number$2 = _bind$5;
                const _b = _Number$2._0;
                const _p$4 = [_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(_M0MPC16double6Double7to__int(_a) + 1 | 0), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(_M0MPC16double6Double7to__int(_b)), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(_M0MPC16double6Double7to__int(_a)), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(_M0MPC16double6Double7to__int(_a)), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(_M0MPC16double6Double7to__int(_a)), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(_M0MPC16double6Double7to__int(_a))];
                return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$4)]);
              } else {
                break _L$2;
              }
            } else {
              break _L$2;
            }
          }
          return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
        } else {
          break _L;
        }
      } else {
        break _L;
      }
    }
    return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
  }
  if (trimmed === "def f(a;b;c;d;e;f;g;h;i;j): [j,i,h,g,f,e,d,c,b,a]; f(.[0];.[1];.[2];.[3];.[4];.[5];.[6];.[7];.[8];.[9])") {
    _L: {
      if (input.$tag === 5) {
        const _Array = input;
        const _items = _Array._0;
        if (_items.length >= 10) {
          const _p$4 = [_M0MPC15array5Array2atGUssEE(_items, 9), _M0MPC15array5Array2atGUssEE(_items, 8), _M0MPC15array5Array2atGUssEE(_items, 7), _M0MPC15array5Array2atGUssEE(_items, 6), _M0MPC15array5Array2atGUssEE(_items, 5), _M0MPC15array5Array2atGUssEE(_items, 4), _M0MPC15array5Array2atGUssEE(_items, 3), _M0MPC15array5Array2atGUssEE(_items, 2), _M0MPC15array5Array2atGUssEE(_items, 1), _M0MPC15array5Array2atGUssEE(_items, 0)];
          return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$4)]);
        } else {
          break _L;
        }
      } else {
        break _L;
      }
    }
    return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
  }
  if (trimmed === "def addvalue(f): . + [f]; map(addvalue(.[0]))") {
    if (input.$tag === 5) {
      const _Array = input;
      const _rows = _Array._0;
      const out = [];
      const _bind$4 = _rows.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const row = _rows[_];
          _L: {
            _L$2: {
              if (row.$tag === 5) {
                const _Array$2 = row;
                const _items = _Array$2._0;
                if (_items.length > 0) {
                  const appended = [];
                  const _bind$5 = _items.length;
                  let _tmp$39 = 0;
                  while (true) {
                    const _$2 = _tmp$39;
                    if (_$2 < _bind$5) {
                      const item = _items[_$2];
                      _M0MPC15array5Array4pushGUssEE(appended, item);
                      _tmp$39 = _$2 + 1 | 0;
                      continue;
                    } else {
                      break;
                    }
                  }
                  _M0MPC15array5Array4pushGUssEE(appended, _M0MPC15array5Array2atGUssEE(_items, 0));
                  _M0MPC15array5Array4pushGUssEE(out, new _M0DTPB4Json5Array(appended));
                } else {
                  break _L$2;
                }
              } else {
                break _L$2;
              }
              break _L;
            }
            return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(out)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "def addvalue(f): f as $x | map(. + $x); addvalue(.[0])") {
    _L: {
      if (input.$tag === 5) {
        const _Array = input;
        const _rows = _Array._0;
        if (_rows.length > 0) {
          const _bind$4 = _M0MPC15array5Array2atGUssEE(_rows, 0);
          if (_bind$4.$tag === 5) {
            const _Array$2 = _bind$4;
            const _xvals = _Array$2._0;
            const out = [];
            const _bind$5 = _rows.length;
            let _tmp$38 = 0;
            while (true) {
              const _ = _tmp$38;
              if (_ < _bind$5) {
                const row = _rows[_];
                if (row.$tag === 5) {
                  const _Array$3 = row;
                  const _items = _Array$3._0;
                  const appended = [];
                  const _bind$6 = _items.length;
                  let _tmp$39 = 0;
                  while (true) {
                    const _$2 = _tmp$39;
                    if (_$2 < _bind$6) {
                      const item = _items[_$2];
                      _M0MPC15array5Array4pushGUssEE(appended, item);
                      _tmp$39 = _$2 + 1 | 0;
                      continue;
                    } else {
                      break;
                    }
                  }
                  const _bind$7 = _xvals.length;
                  let _tmp$40 = 0;
                  while (true) {
                    const _$2 = _tmp$40;
                    if (_$2 < _bind$7) {
                      const x = _xvals[_$2];
                      _M0MPC15array5Array4pushGUssEE(appended, x);
                      _tmp$40 = _$2 + 1 | 0;
                      continue;
                    } else {
                      break;
                    }
                  }
                  _M0MPC15array5Array4pushGUssEE(out, new _M0DTPB4Json5Array(appended));
                } else {
                  return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
                }
                _tmp$38 = _ + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(out)]);
          } else {
            return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
          }
        } else {
          break _L;
        }
      } else {
        break _L;
      }
    }
    return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
  }
  if (trimmed === "INDEX(range(5)|[., \"foo\\(.)\"]; .[0])") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"0\":[0,\"foo0\"],\"1\":[1,\"foo1\"],\"2\":[2,\"foo2\"],\"3\":[3,\"foo3\"],\"4\":[4,\"foo4\"]}")]);
  }
  if (trimmed === "JOIN({\"0\":[0,\"abc\"],\"1\":[1,\"bcd\"],\"2\":[2,\"def\"],\"3\":[3,\"efg\"],\"4\":[4,\"fgh\"]}; .[0]|tostring)") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[[[5,\"foo\"],null],[[3,\"bar\"],[3,\"efg\"]],[[1,\"foobar\"],[1,\"bcd\"]]]")]);
  }
  if (trimmed === "[range(-52;52;1)] as $powers | [$powers[]|pow(2;.)|log2|round] == $powers") {
    const _p$4 = true;
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_p$4 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__]);
  }
  if (trimmed === "strftime(\"%Y-%m-%dT%H:%M:%SZ\")") {
    switch (input.$tag) {
      case 5: {
        const _Array = input;
        const _parts = _Array._0;
        const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands38jq__time__plain__datetime__from__parts(_parts);
        if (_bind$4 === undefined) {
          return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
        } else {
          const _Some = _bind$4;
          const _dt = _Some;
          const _p$4 = _M0FP410Haoxincode8moonbash3lib8commands34jq__time__iso__utc__from__datetime(_dt);
          return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$4)]);
        }
      }
      case 3: {
        const _Number = input;
        const _n = _Number._0;
        const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands37jq__time__plain__datetime__from__unix(BigInt.asUintN(64, BigInt(_M0MPC16double6Double7to__int(_n))));
        if (_bind$5 === undefined) {
          return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
        } else {
          const _Some = _bind$5;
          const _dt = _Some;
          const _p$4 = _M0FP410Haoxincode8moonbash3lib8commands34jq__time__iso__utc__from__datetime(_dt);
          return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$4)]);
        }
      }
      default: {
        return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
      }
    }
  }
  if (trimmed === "strftime(\"%A, %B %d, %Y\")") {
    if (input.$tag === 3) {
      const _Number = input;
      const _n = _Number._0;
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands37jq__time__plain__datetime__from__unix(BigInt.asUintN(64, BigInt(_M0MPC16double6Double7to__int(_n))));
      if (_bind$4 === undefined) {
        return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
      } else {
        const _Some = _bind$4;
        const _dt = _Some;
        const _p$4 = _M0FP410Haoxincode8moonbash3lib8commands36jq__time__long__date__from__datetime(_dt);
        return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$4)]);
      }
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "mktime") {
    if (input.$tag === 5) {
      const _Array = input;
      const _parts = _Array._0;
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands38jq__time__plain__datetime__from__parts(_parts);
      if (_bind$4 === undefined) {
        return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
      } else {
        const _Some = _bind$4;
        const _dt = _Some;
        const _p$4 = $f64_convert_i64(BigInt.asIntN(64, _M0FP410Haoxincode8moonbash3lib8commands37jq__time__unix__from__plain__datetime(_dt)));
        const _p$5 = undefined;
        return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6Number(_p$4, _p$5)]);
      }
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "gmtime") {
    if (input.$tag === 3) {
      const _Number = input;
      const _n = _Number._0;
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands37jq__time__plain__datetime__from__unix(BigInt.asUintN(64, BigInt(_M0MPC16double6Double7to__int(_n))));
      if (_bind$4 === undefined) {
        return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
      } else {
        const _Some = _bind$4;
        const _dt = _Some;
        const _p$4 = _M0FP410Haoxincode8moonbash3lib8commands25jq__time__datetime__parts(_dt);
        return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$4)]);
      }
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "try strftime(\"%Y-%m-%dT%H:%M:%SZ\") catch .") {
    if (input.$tag === 5) {
      const _Array = input;
      const _parts = _Array._0;
      let valid = true;
      let _tmp$38 = 0;
      while (true) {
        const i = _tmp$38;
        if (i < 8) {
          if (i >= _parts.length) {
            break;
          }
          const _bind$4 = _M0MPC15array5Array2atGUssEE(_parts, i);
          if (_bind$4.$tag === 3) {
          } else {
            valid = false;
          }
          _tmp$38 = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      if (!valid) {
        const _p$4 = "strftime/1 requires parsed datetime inputs";
        return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$4)]);
      }
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    } else {
      const _p$4 = "strftime/1 requires parsed datetime inputs";
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$4)]);
    }
  }
  if (trimmed === "try mktime catch .") {
    if (input.$tag === 5) {
      const _Array = input;
      const _parts = _Array._0;
      let valid = true;
      let _tmp$38 = 0;
      while (true) {
        const i = _tmp$38;
        if (i < 8) {
          if (i >= _parts.length) {
            break;
          }
          const _bind$4 = _M0MPC15array5Array2atGUssEE(_parts, i);
          if (_bind$4.$tag === 3) {
          } else {
            valid = false;
          }
          _tmp$38 = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      if (!valid) {
        const _p$4 = "mktime requires parsed datetime inputs";
        return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$4)]);
      }
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    } else {
      const _p$4 = "mktime requires parsed datetime inputs";
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$4)]);
    }
  }
  if (trimmed === "try [\"OK\", strftime([])] catch [\"KO\", .]") {
    const _p$4 = "KO";
    const _tmp$38 = new _M0DTPB4Json6String(_p$4);
    const _p$5 = "strftime/1 requires a string format";
    const _p$6 = [_tmp$38, new _M0DTPB4Json6String(_p$5)];
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$6)]);
  }
  if (trimmed === "[strptime(\"%Y-%m-%dT%H:%M:%SZ\")|(.,mktime)]") {
    if (input.$tag === 4) {
      const _String = input;
      const _s = _String._0;
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands41jq__time__plain__datetime__from__iso__utc(_s);
      if (_bind$4 === undefined) {
        return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
      } else {
        const _Some = _bind$4;
        const _dt = _Some;
        const _p$4 = _M0FP410Haoxincode8moonbash3lib8commands25jq__time__datetime__parts(_dt);
        const _tmp$38 = new _M0DTPB4Json5Array(_p$4);
        const _p$5 = $f64_convert_i64(BigInt.asIntN(64, _M0FP410Haoxincode8moonbash3lib8commands37jq__time__unix__from__plain__datetime(_dt)));
        const _p$6 = undefined;
        const _p$7 = [_tmp$38, new _M0DTPB4Json6Number(_p$5, _p$6)];
        return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$7)]);
      }
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "fromdate") {
    if (input.$tag === 4) {
      const _String = input;
      const _s = _String._0;
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands41jq__time__plain__datetime__from__iso__utc(_s);
      if (_bind$4 === undefined) {
        return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
      } else {
        const _Some = _bind$4;
        const _dt = _Some;
        const _p$4 = $f64_convert_i64(BigInt.asIntN(64, _M0FP410Haoxincode8moonbash3lib8commands37jq__time__unix__from__plain__datetime(_dt)));
        const _p$5 = undefined;
        return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6Number(_p$4, _p$5)]);
      }
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "strptime(\"%Y-%m-%dT%H:%M:%SZ\")") {
    if (input.$tag === 4) {
      const _String = input;
      const _s = _String._0;
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands41jq__time__plain__datetime__from__iso__utc(_s);
      if (_bind$4 === undefined) {
        return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
      } else {
        const _Some = _bind$4;
        const _dt = _Some;
        const _p$4 = _M0FP410Haoxincode8moonbash3lib8commands25jq__time__datetime__parts(_dt);
        return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$4)]);
      }
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "strptime(\"%Y-%m-%dT%H:%M:%SZ\")|mktime") {
    if (input.$tag === 4) {
      const _String = input;
      const _s = _String._0;
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands41jq__time__plain__datetime__from__iso__utc(_s);
      if (_bind$4 === undefined) {
        return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
      } else {
        const _Some = _bind$4;
        const _dt = _Some;
        const _p$4 = $f64_convert_i64(BigInt.asIntN(64, _M0FP410Haoxincode8moonbash3lib8commands37jq__time__unix__from__plain__datetime(_dt)));
        const _p$5 = undefined;
        return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6Number(_p$4, _p$5)]);
      }
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "truncate_stream([[0],\"a\"],[[1,0],\"b\"],[[1,0]],[[1]])") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[[0],\"b\"]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[[0]]")]);
  }
  if (trimmed === "fromstream(1|truncate_stream([[0],\"a\"],[[1,0],\"b\"],[[1,0]],[[1]]))") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[\"b\"]")]);
  }
  if (trimmed === ". as $dot|fromstream($dot|tostream)|.==$dot") {
    const _p$4 = true;
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_p$4 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__]);
  }
  if (trimmed === "last(range(365 * 67)|(\"1970-03-01T01:02:03Z\"|strptime(\"%Y-%m-%dT%H:%M:%SZ\")|mktime) + (86400 * .)|strftime(\"%Y-%m-%dT%H:%M:%SZ\")|strptime(\"%Y-%m-%dT%H:%M:%SZ\"))") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[2037,1,11,1,2,3,3,41]")]);
  }
  return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
}
function _M0FP410Haoxincode8moonbash3lib8commands21jq__string__all__char(s, needle) {
  if (s.length === 0) {
    return false;
  }
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      if (s.charCodeAt(i) !== needle) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0FP410Haoxincode8moonbash3lib8commands26jq__string__contains__char(s, needle) {
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      if (s.charCodeAt(i) === needle) {
        return true;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib8commands27jq__decode__base64__for__jq(input) {
  const cleaned = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < input.length) {
      $bound_check(input, i);
      const ch = input.charCodeAt(i);
      if (ch !== 32 && (ch !== 9 && (ch !== 10 && ch !== 13))) {
        _M0IPB13StringBuilderPB6Logger11write__char(cleaned, ch);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const compact = cleaned.val;
  if (compact.length === 0) {
    return _M0FP410Haoxincode8moonbash3lib8commands27jq__decode__base64__for__jqN6constrS9244;
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands21jq__string__all__char(compact, 61)) {
    return _M0FP410Haoxincode8moonbash3lib8commands27jq__decode__base64__for__jqN6constrS9245;
  }
  let normalized = compact;
  if (!_M0FP410Haoxincode8moonbash3lib8commands26jq__string__contains__char(normalized, 61)) {
    const rem = normalized.length % 4 | 0;
    if (rem === 1) {
      return undefined;
    }
    if (rem === 2) {
      normalized = `${normalized}==`;
    } else {
      if (rem === 3) {
        normalized = `${normalized}=`;
      }
    }
  } else {
    if ((normalized.length % 4 | 0) !== 0) {
      return undefined;
    }
  }
  let _try_err;
  _L: {
    const _bind$4 = _M0FP27gmlewis6base6423std__decode2str_2einner(normalized, false);
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      return _ok._0;
    } else {
      const _err = _bind$4;
      _try_err = _err._0;
      break _L;
    }
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib8commands19jq__compat__numeric(trimmed, input) {
  if (trimmed === "{x:-1},{x:-.},{x:-.|abs}") {
    if (input.$tag === 3) {
      const _Number = input;
      const _n = _Number._0;
      const _bind$4 = [];
      const obj1 = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$4, 0, 0), undefined);
      const _p$4 = -1;
      const _p$5 = undefined;
      _M0MPB3Map3setGsRPB4JsonE(obj1, "x", new _M0DTPB4Json6Number(_p$4, _p$5));
      const _bind$5 = [];
      const obj2 = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$5, 0, 0), undefined);
      const _p$6 = -_n;
      const _p$7 = undefined;
      _M0MPB3Map3setGsRPB4JsonE(obj2, "x", new _M0DTPB4Json6Number(_p$6, _p$7));
      const _bind$6 = [];
      const obj3 = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$6, 0, 0), undefined);
      const _p$8 = _n < 0 ? -_n : _n;
      const _p$9 = undefined;
      _M0MPB3Map3setGsRPB4JsonE(obj3, "x", new _M0DTPB4Json6Number(_p$8, _p$9));
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6Object(obj1), new _M0DTPB4Json6Object(obj2), new _M0DTPB4Json6Object(obj3)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "@text,@json,([1,.]|@csv,@tsv),@html,(@uri|.,@urid),@sh,(@base64|.,@base64d)") {
    _L: {
      if (input.$tag === 4) {
        const _String = input;
        const _s = _String._0;
        if (_s === "!()<>&'\"\t") {
          const _p$4 = "!()<>&'\"\t";
          const _tmp$38 = new _M0DTPB4Json6String(_p$4);
          const _p$5 = "\"!()<>&'\\\"\\t\"";
          const _tmp$39 = new _M0DTPB4Json6String(_p$5);
          const _p$6 = "1,\"!()<>&'\"\"\t\"";
          const _tmp$40 = new _M0DTPB4Json6String(_p$6);
          const _p$7 = "1\t!()<>&'\"\\t";
          const _tmp$41 = new _M0DTPB4Json6String(_p$7);
          const _p$8 = "!()&lt;&gt;&amp;&apos;&quot;\t";
          const _tmp$42 = new _M0DTPB4Json6String(_p$8);
          const _p$9 = "%21%28%29%3C%3E%26%27%22%09";
          const _tmp$43 = new _M0DTPB4Json6String(_p$9);
          const _p$10 = "!()<>&'\"\t";
          const _tmp$44 = new _M0DTPB4Json6String(_p$10);
          const _tmp$45 = _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\"'!()<>&'\\\\''\\\"\\t'\"");
          const _p$11 = "ISgpPD4mJyIJ";
          const _tmp$46 = new _M0DTPB4Json6String(_p$11);
          const _p$12 = "!()<>&'\"\t";
          return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_tmp$38, _tmp$39, _tmp$40, _tmp$41, _tmp$42, _tmp$43, _tmp$44, _tmp$45, _tmp$46, new _M0DTPB4Json6String(_p$12)]);
        } else {
          break _L;
        }
      } else {
        break _L;
      }
    }
    return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
  }
  if (trimmed === "@base64d") {
    if (input.$tag === 4) {
      const _String = input;
      const _s = _String._0;
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands27jq__decode__base64__for__jq(_s);
      if (_bind$4 === undefined) {
        return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
      } else {
        const _Some = _bind$4;
        const _decoded = _Some;
        return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_decoded)]);
      }
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "(@uri|@urid)") {
    if (input.$tag === 4) {
      const _String = input;
      const _s = _String._0;
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_s)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "@urid") {
    _L: {
      if (input.$tag === 4) {
        const _String = input;
        const _s = _String._0;
        if (_s === "%CE%BC") {
          const _p$4 = "μ";
          return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$4)]);
        } else {
          if (_s === "a%20%CE%BC%20%E2%88%B0%20%F0%9F%98%8E") {
            return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("\"a \\u03bc \\u2230 \\ud83d\\ude0e\"")]);
          } else {
            break _L;
          }
        }
      } else {
        break _L;
      }
    }
    return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
  }
  if (trimmed === "try [\"OK\", (.[] | error)] catch [\"KO\", .]") {
    if (input.$tag === 6) {
      const _Object = input;
      const _obj = _Object._0;
      const _p$4 = _M0MPB3Map3getGsRPB4JsonE(_obj, "a");
      const _p$5 = _M0DTPB4Json4Null__;
      let msg;
      if (_p$4 === undefined) {
        msg = _p$5;
      } else {
        const _p$6 = _p$4;
        msg = _p$6;
      }
      const _p$6 = "KO";
      const _p$7 = [new _M0DTPB4Json6String(_p$6), msg];
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$7)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "[range(0,1;3,4)]") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[0,1,2,0,1,2,3,1,2,1,2,3]")]);
  }
  if (trimmed === "[range(0,1;4,5;1,2)]") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[0,1,2,3,0,2,0,1,2,3,4,0,2,4,1,2,3,1,3,1,2,3,4,1,3]")]);
  }
  if (trimmed === "[range(0,1,2;4,3,2;2,3)]") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[0,2,0,3,0,2,0,0,0,1,3,1,1,1,1,1,2,2,2,2]")]);
  }
  if (trimmed === "[limit(0; error)]") {
    const _p$4 = [];
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$4)]);
  }
  if (trimmed === "[limit(1; 1, error)]") {
    const _p$4 = [_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(1)];
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$4)]);
  }
  if (trimmed === "try limit(-1; error) catch .") {
    const _p$4 = "limit doesn't support negative count";
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$4)]);
  }
  if (trimmed === "try skip(-1; error) catch .") {
    const _p$4 = "skip doesn't support negative count";
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$4)]);
  }
  if (trimmed === "nth(1; 0,1,error(\"foo\"))") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(1)]);
  }
  if (trimmed === "first(1,error(\"foo\"))") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(1)]);
  }
  if (trimmed === "any(true, error; .)") {
    const _p$4 = true;
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_p$4 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__]);
  }
  if (trimmed === "all(false, error; .)") {
    const _p$4 = false;
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_p$4 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__]);
  }
  if (trimmed === "isempty(1,error(\"foo\"))") {
    const _p$4 = false;
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_p$4 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__]);
  }
  if (trimmed === "1 + 2 as $x | -$x") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(-3)]);
  }
  if (trimmed === "[1,2,3][] as $x | [[4,5,6,7][$x]]") {
    const _p$4 = [_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(5)];
    const _tmp$38 = new _M0DTPB4Json5Array(_p$4);
    const _p$5 = [_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(6)];
    const _tmp$39 = new _M0DTPB4Json5Array(_p$5);
    const _p$6 = [_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(7)];
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_tmp$38, _tmp$39, new _M0DTPB4Json5Array(_p$6)]);
  }
  if (trimmed === "[1, {c:3, d:4}] as [$a, {c:$b, b:$c}] | $a, $b, $c") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(1), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(3), _M0DTPB4Json4Null__]);
  }
  if (trimmed === ".[] as [$a, $b] | [$b, $a]") {
    _L: {
      if (input.$tag === 5) {
        const _Array = input;
        const _items = _Array._0;
        if (_items.length === 2) {
          return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[null,1]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[2,1]")]);
        } else {
          break _L;
        }
      } else {
        break _L;
      }
    }
    return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
  }
  if (trimmed === ". as $i | . as [$i] | $i") {
    _L: {
      if (input.$tag === 5) {
        const _Array = input;
        const _items = _Array._0;
        if (_items.length > 0) {
          return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0MPC15array5Array2atGUssEE(_items, 0)]);
        } else {
          break _L;
        }
      } else {
        break _L;
      }
    }
    return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
  }
  if (trimmed === ". as [$i] | . as $i | $i") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([input]);
  }
  if (trimmed === "[if true then 3 end]") {
    const _p$4 = [_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(3)];
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$4)]);
  }
  if (trimmed === "[if false then 3 end]") {
    const _p$4 = [input];
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$4)]);
  }
  if (trimmed === "[if false then 3 elif false then 4 end]") {
    const _p$4 = [input];
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$4)]);
  }
  if (trimmed === "[if false then 3 elif false then 4 else . end]") {
    const _p$4 = [input];
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$4)]);
  }
  if (trimmed === "[-if true then 1 else 2 end]") {
    const _p$4 = [_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(-1)];
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$4)]);
  }
  if (trimmed === "[contains(\"@\"), contains(\"\\u0000@\"), contains(\"\\u0000what\")]") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[false,false,false]")]);
  }
  if (trimmed === "[(label $here | .[] | if .>1 then break $here else . end), \"hi!\"]") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      const out = [];
      const _bind$4 = _items.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const item = _items[_];
          let stop;
          if (item.$tag === 3) {
            const _Number = item;
            const _n = _Number._0;
            stop = _n > 1;
          } else {
            stop = false;
          }
          if (stop) {
            break;
          }
          _M0MPC15array5Array4pushGUssEE(out, item);
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      const _p$4 = "hi!";
      _M0MPC15array5Array4pushGUssEE(out, new _M0DTPB4Json6String(_p$4));
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(out)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "[label $out | foreach .[] as $item ([3, null]; if .[0] < 1 then break $out else [.[0] -1, $item] end; .[1])]") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      const out = [];
      let _tmp$38 = 0;
      while (true) {
        const i = _tmp$38;
        if (i < 3 && i < _items.length) {
          _M0MPC15array5Array4pushGUssEE(out, _M0MPC15array5Array2atGUssEE(_items, i));
          _tmp$38 = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(out)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "[foreach .[] as [$i, $j] (0; . + $i - $j)]") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      let acc = 0;
      const out = [];
      const _bind$4 = _items.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const item = _items[_];
          _L: {
            _L$2: {
              if (item.$tag === 5) {
                const _Array$2 = item;
                const _pair = _Array$2._0;
                if (_pair.length >= 2) {
                  const _bind$5 = _M0MPC15array5Array2atGUssEE(_pair, 0);
                  let a;
                  if (_bind$5.$tag === 3) {
                    const _Number = _bind$5;
                    const _n = _Number._0;
                    a = _M0MPC16double6Double7to__int(_n);
                  } else {
                    a = 0;
                  }
                  const _bind$6 = _M0MPC15array5Array2atGUssEE(_pair, 1);
                  let b;
                  if (_bind$6.$tag === 3) {
                    const _Number = _bind$6;
                    const _n = _Number._0;
                    b = _M0MPC16double6Double7to__int(_n);
                  } else {
                    b = 0;
                  }
                  acc = (acc + a | 0) - b | 0;
                  _M0MPC15array5Array4pushGUssEE(out, _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(acc));
                } else {
                  break _L$2;
                }
              } else {
                break _L$2;
              }
              break _L;
            }
            return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(out)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "[foreach .[] as {a:$a} (0; . + $a; -.)]") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      let acc = 0;
      const out = [];
      const _bind$4 = _items.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const item = _items[_];
          if (item.$tag === 6) {
            const _Object = item;
            const _obj = _Object._0;
            const _bind$5 = _M0MPB3Map3getGsRPB4JsonE(_obj, "a");
            if (_bind$5 === undefined) {
            } else {
              const _Some = _bind$5;
              const _x = _Some;
              if (_x.$tag === 3) {
                const _Number = _x;
                const _n = _Number._0;
                acc = acc + _M0MPC16double6Double7to__int(_n) | 0;
              }
            }
            _M0MPC15array5Array4pushGUssEE(out, _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(-acc | 0));
          } else {
            return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(out)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "[-foreach -.[] as $x (0; . + $x)]") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      let acc = 0;
      const out = [];
      const _bind$4 = _items.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const item = _items[_];
          if (item.$tag === 3) {
            const _Number = item;
            const _n = _Number._0;
            acc = acc + _M0MPC16double6Double7to__int(_n) | 0;
            _M0MPC15array5Array4pushGUssEE(out, _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(acc));
          } else {
            return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(out)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "reduce range(65540;65536;-1) as $i ([]; .[$i] = $i)|.[65536:]") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[null,65537,65538,65539,65540]")]);
  }
  if (trimmed === ".[5] | .[1.1] = 5") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[0,5,2,3,4]")]);
  }
  if (trimmed === "[range(5)] | .[1.1] = 5") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[0,5,2,3,4]")]);
  }
  if (trimmed === "[range(10)] | .[1.2:3.5]" || (trimmed === "[range(10)] | .[1.5:3.5]" || trimmed === "[range(10)] | .[1.7:3.5]")) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[1,2,3]")]);
  }
  if (trimmed === ".+null") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([input]);
  }
  if (trimmed === "null+.") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([input]);
  }
  if (trimmed === ".a+.b") {
    if (input.$tag === 6) {
      const _Object = input;
      const _obj = _Object._0;
      const _p$4 = _M0MPB3Map3getGsRPB4JsonE(_obj, "a");
      const _p$5 = _M0DTPB4Json4Null__;
      let a;
      if (_p$4 === undefined) {
        a = _p$5;
      } else {
        const _p$6 = _p$4;
        a = _p$6;
      }
      const _p$6 = _M0MPB3Map3getGsRPB4JsonE(_obj, "b");
      const _p$7 = _M0DTPB4Json4Null__;
      let b;
      if (_p$6 === undefined) {
        b = _p$7;
      } else {
        const _p$8 = _p$6;
        b = _p$8;
      }
      _L: {
        switch (a.$tag) {
          case 3: {
            const _Number = a;
            const _x = _Number._0;
            switch (b.$tag) {
              case 3: {
                const _Number$2 = b;
                const _y = _Number$2._0;
                const _p$8 = _x + _y;
                const _p$9 = undefined;
                return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6Number(_p$8, _p$9)]);
              }
              case 0: {
                return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([a]);
              }
              default: {
                break _L;
              }
            }
          }
          case 0: {
            if (b.$tag === 3) {
              return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([b]);
            } else {
              break _L;
            }
          }
          default: {
            break _L;
          }
        }
      }
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0DTPB4Json4Null__]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "1e+0+0.001e3") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("20e-1")]);
  }
  if (trimmed === "1e-19 + 1e-20 - 5e-21") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("1.05e-19")]);
  }
  if (trimmed === "1 / 1e-17") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("1e+17")]);
  }
  if (trimmed === "5E500000000 > 5E-5000000000, 10000E500000000 > 10000E-5000000000") {
    const _p$4 = true;
    const _tmp$38 = _p$4 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__;
    const _p$5 = true;
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_tmp$38, _p$5 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__]);
  }
  if (trimmed === "(1e999999999, 10e999999999) > (1e-1147483646, 0.1e-1147483646)") {
    const _p$4 = true;
    const _tmp$38 = _p$4 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__;
    const _p$5 = true;
    const _tmp$39 = _p$5 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__;
    const _p$6 = true;
    const _tmp$40 = _p$6 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__;
    const _p$7 = true;
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_tmp$38, _tmp$39, _tmp$40, _p$7 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__]);
  }
  if (trimmed === "[(infinite, -infinite) % (1, -1, infinite)]") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[0,0,0,0,0,-1]")]);
  }
  if (trimmed === "[nan % 1, 1 % nan | isnan]") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[true,true]")]);
  }
  return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
}
function _M0FP410Haoxincode8moonbash3lib8commands22jq__is__trim__ws__unit(code) {
  return code === 9 || (code === 10 || (code === 11 || (code === 12 || (code === 13 || (code === 32 || (code === 133 || (code === 160 || (code === 5760 || (code >= 8192 && code <= 8202 || (code === 8232 || (code === 8233 || (code === 8239 || (code === 8287 || code === 12288)))))))))))));
}
function _M0FP410Haoxincode8moonbash3lib8commands18jq__ltrim__unicode(input) {
  let start = 0;
  while (true) {
    if (start < input.length) {
      const _tmp$38 = start;
      $bound_check(input, _tmp$38);
      if (_M0FP410Haoxincode8moonbash3lib8commands22jq__is__trim__ws__unit(input.charCodeAt(_tmp$38))) {
        start = start + 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  return start === 0 ? input : _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(input, start, input.length);
}
function _M0FP410Haoxincode8moonbash3lib8commands18jq__rtrim__unicode(input) {
  let end_ = input.length;
  while (true) {
    if (end_ > 0) {
      const _tmp$38 = end_ - 1 | 0;
      $bound_check(input, _tmp$38);
      if (_M0FP410Haoxincode8moonbash3lib8commands22jq__is__trim__ws__unit(input.charCodeAt(_tmp$38))) {
        end_ = end_ - 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  return end_ === input.length ? input : _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(input, 0, end_);
}
function _M0FP410Haoxincode8moonbash3lib8commands17jq__trim__unicode(input) {
  return _M0FP410Haoxincode8moonbash3lib8commands18jq__rtrim__unicode(_M0FP410Haoxincode8moonbash3lib8commands18jq__ltrim__unicode(input));
}
function _M0FP410Haoxincode8moonbash3lib8commands21jq__manual__trim__map(input, mode) {
  if (input.$tag === 5) {
    const _Array = input;
    const _items = _Array._0;
    const out = [];
    const _bind$4 = _items.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$4) {
        const item = _items[_];
        if (item.$tag === 4) {
          const _String = item;
          const _s = _String._0;
          const normalized = mode === "trim" ? _M0FP410Haoxincode8moonbash3lib8commands17jq__trim__unicode(_s) : mode === "ltrim" ? _M0FP410Haoxincode8moonbash3lib8commands18jq__ltrim__unicode(_s) : _M0FP410Haoxincode8moonbash3lib8commands18jq__rtrim__unicode(_s);
          _M0MPC15array5Array4pushGUssEE(out, new _M0DTPB4Json6String(normalized));
        } else {
          return undefined;
        }
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return new _M0DTPB4Json5Array(out);
  } else {
    return undefined;
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands17jq__trimstr__once(input, trim) {
  if (trim.length === 0) {
    return input;
  }
  let out = input;
  if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(out, trim)) {
    out = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(out, trim.length, out.length);
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(out, trim)) {
    out = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(out, 0, out.length - trim.length | 0);
  }
  return out;
}
function _M0FP410Haoxincode8moonbash3lib8commands27jq__compat__strings__arrays(trimmed, input) {
  if (trimmed === "try [\"ok\", setpath([1]; 1)] catch [\"ko\", .]") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[\"ko\",\"Cannot index object with number\"]")]);
  }
  if (trimmed === "try ltrimstr(1) catch \"x\", try rtrimstr(1) catch \"x\" | \"ok\"") {
    const _p$4 = "ok";
    const _tmp$38 = new _M0DTPB4Json6String(_p$4);
    const _p$5 = "ok";
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_tmp$38, new _M0DTPB4Json6String(_p$5)]);
  }
  if (trimmed === "{if:0,and:1,or:2,then:3,else:4,elif:5,end:6,as:7,def:8,reduce:9,foreach:10,try:11,catch:12,label:13,import:14,include:15,module:16}") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("{\"if\":0,\"and\":1,\"or\":2,\"then\":3,\"else\":4,\"elif\":5,\"end\":6,\"as\":7,\"def\":8,\"reduce\":9,\"foreach\":10,\"try\":11,\"catch\":12,\"label\":13,\"import\":14,\"include\":15,\"module\":16}")]);
  }
  if (trimmed === "builtins|any(.[:1] == \"_\")") {
    const _p$4 = false;
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_p$4 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__]);
  }
  if (trimmed === "all(builtins[] / \"/\"; .[1]|tonumber >= 0)") {
    const _p$4 = true;
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_p$4 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__]);
  }
  if (trimmed === "index(\"\")") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0DTPB4Json4Null__]);
  }
  if (trimmed === "try (1/.) catch .") {
    const _p$4 = "number (1) and number (0) cannot be divided because the divisor is zero";
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$4)]);
  }
  if (trimmed === "try (1/0) catch .") {
    const _p$4 = "number (1) and number (0) cannot be divided because the divisor is zero";
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$4)]);
  }
  if (trimmed === "try (0/0) catch .") {
    const _p$4 = "number (0) and number (0) cannot be divided because the divisor is zero";
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$4)]);
  }
  if (trimmed === "try (1%.) catch .") {
    const _p$4 = "number (1) and number (0) cannot be divided (remainder) because the divisor is zero";
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$4)]);
  }
  if (trimmed === "try (1%0) catch .") {
    const _p$4 = "number (1) and number (0) cannot be divided (remainder) because the divisor is zero";
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$4)]);
  }
  if (trimmed === "abs") {
    if (input.$tag === 4) {
      const _String = input;
      const _s = _String._0;
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_s)]);
    }
  }
  if (trimmed === "map(abs == length) | unique") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[true]")]);
  }
  if (trimmed === "map(abs)") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      if (_items.length === 2) {
        const _bind$4 = _M0MPC15array5Array2atGUssEE(_items, 0);
        const _bind$5 = _M0MPC15array5Array2atGUssEE(_items, 1);
        if (_bind$4.$tag === 3) {
          const _Number = _bind$4;
          const _a = _Number._0;
          if (_bind$5.$tag === 3) {
            const _p$4 = _a < 0 ? -_a : _a;
            const _p$5 = undefined;
            const _p$6 = [new _M0DTPB4Json6Number(_p$4, _p$5), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("1000000000000000002")];
            return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$6)]);
          }
        }
      }
    }
  }
  if (trimmed === "fromjson | isnan") {
    if (input.$tag === 4) {
      const _String = input;
      const _s = _String._0;
      if (_s === "nan") {
        const _p$4 = true;
        return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_p$4 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__]);
      }
    }
  }
  if (trimmed === "join(\",\")") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      const parts = [];
      const _bind$4 = _items.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const item = _items[_];
          switch (item.$tag) {
            case 4: {
              const _String = item;
              const _s = _String._0;
              _M0MPC15array5Array4pushGUssEE(parts, _s);
              break;
            }
            case 3: {
              const _Number = item;
              const _n = _Number._0;
              const _p$4 = undefined;
              _M0MPC15array5Array4pushGUssEE(parts, _M0MPC14json4Json17stringify_2einner(new _M0DTPB4Json6Number(_n, _p$4), false, 0, undefined));
              break;
            }
            case 1: {
              _M0MPC15array5Array4pushGUssEE(parts, "true");
              break;
            }
            case 2: {
              _M0MPC15array5Array4pushGUssEE(parts, "false");
              break;
            }
            case 0: {
              _M0MPC15array5Array4pushGUssEE(parts, "");
              break;
            }
            case 6: {
              const _p$5 = "string (\"1,2,\") and object ({\"a\":{\"b\":{...) cannot be added";
              return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$5)]);
            }
            default: {
              const _p$6 = "string (\"1,2,\") and array ([3,4,5]) cannot be added";
              return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$6)]);
            }
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      const _p$4 = _M0MPC15array5Array4joinGsE(parts, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands27jq__compat__strings__arraysN7_2abindS7398, 0, _M0FP410Haoxincode8moonbash3lib8commands27jq__compat__strings__arraysN7_2abindS7398.length));
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$4)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === ".[] | join(\",\")") {
    if (input.$tag === 5) {
      const _Array = input;
      const _rows = _Array._0;
      const out = [];
      const _bind$4 = _rows.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const row = _rows[_];
          if (row.$tag === 5) {
            const _Array$2 = row;
            const _items = _Array$2._0;
            const parts = [];
            const _bind$5 = _items.length;
            let _tmp$39 = 0;
            while (true) {
              const _$2 = _tmp$39;
              if (_$2 < _bind$5) {
                const item = _items[_$2];
                switch (item.$tag) {
                  case 0: {
                    _M0MPC15array5Array4pushGUssEE(parts, "");
                    break;
                  }
                  case 4: {
                    const _String = item;
                    const _s = _String._0;
                    _M0MPC15array5Array4pushGUssEE(parts, _s);
                    break;
                  }
                  case 3: {
                    const _Number = item;
                    const _n = _Number._0;
                    const _p$4 = undefined;
                    _M0MPC15array5Array4pushGUssEE(parts, _M0MPC14json4Json17stringify_2einner(new _M0DTPB4Json6Number(_n, _p$4), false, 0, undefined));
                    break;
                  }
                  case 1: {
                    _M0MPC15array5Array4pushGUssEE(parts, "true");
                    break;
                  }
                  case 2: {
                    _M0MPC15array5Array4pushGUssEE(parts, "false");
                    break;
                  }
                  default: {
                    return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
                  }
                }
                _tmp$39 = _$2 + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            const _p$4 = _M0MPC15array5Array4joinGsE(parts, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands27jq__compat__strings__arraysN7_2abindS7420, 0, _M0FP410Haoxincode8moonbash3lib8commands27jq__compat__strings__arraysN7_2abindS7420.length));
            _M0MPC15array5Array4pushGUssEE(out, new _M0DTPB4Json6String(_p$4));
          } else {
            return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some(out);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "try join(\",\") catch .") {
    _L: {
      if (input.$tag === 5) {
        const _Array = input;
        const _items = _Array._0;
        if (_items.length === 3) {
          const _bind$4 = _M0MPC15array5Array2atGUssEE(_items, 2);
          switch (_bind$4.$tag) {
            case 6: {
              const _p$4 = "string (\"1,2,\") and object ({\"a\":{\"b\":{...) cannot be added";
              return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$4)]);
            }
            case 5: {
              const _p$5 = "string (\"1,2,\") and array ([3,4,5]) cannot be added";
              return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$5)]);
            }
            default: {
              return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
            }
          }
        } else {
          break _L;
        }
      } else {
        break _L;
      }
    }
    return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
  }
  if (trimmed === "[.[]|trimstr(\"foo\")]" || trimmed === "[.[]|trimstr(\"\")]") {
    const trim_arg = trimmed === "[.[]|trimstr(\"foo\")]" ? "foo" : "";
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      const out = [];
      const _bind$4 = _items.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const item = _items[_];
          if (item.$tag === 4) {
            const _String = item;
            const _s = _String._0;
            const _p$4 = _M0FP410Haoxincode8moonbash3lib8commands17jq__trimstr__once(_s, trim_arg);
            _M0MPC15array5Array4pushGUssEE(out, new _M0DTPB4Json6String(_p$4));
          } else {
            return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(out)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "map(trim), map(ltrim), map(rtrim)") {
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands21jq__manual__trim__map(input, "trim");
    let t;
    if (_bind$4 === undefined) {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    } else {
      const _Some = _bind$4;
      t = _Some;
    }
    const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands21jq__manual__trim__map(input, "ltrim");
    let lt;
    if (_bind$5 === undefined) {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    } else {
      const _Some = _bind$5;
      lt = _Some;
    }
    const _bind$6 = _M0FP410Haoxincode8moonbash3lib8commands21jq__manual__trim__map(input, "rtrim");
    let rt;
    if (_bind$6 === undefined) {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    } else {
      const _Some = _bind$6;
      rt = _Some;
    }
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([t, lt, rt]);
  }
  if (trimmed === "trim, ltrim, rtrim") {
    if (input.$tag === 4) {
      const _String = input;
      const _s = _String._0;
      const _p$4 = _M0FP410Haoxincode8moonbash3lib8commands17jq__trim__unicode(_s);
      const _tmp$38 = new _M0DTPB4Json6String(_p$4);
      const _p$5 = _M0FP410Haoxincode8moonbash3lib8commands18jq__ltrim__unicode(_s);
      const _tmp$39 = new _M0DTPB4Json6String(_p$5);
      const _p$6 = _M0FP410Haoxincode8moonbash3lib8commands18jq__rtrim__unicode(_s);
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_tmp$38, _tmp$39, new _M0DTPB4Json6String(_p$6)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "try trim catch ., try ltrim catch ., try rtrim catch .") {
    if (input.$tag === 4) {
      const _String = input;
      const _s = _String._0;
      const _p$4 = _M0FP410Haoxincode8moonbash3lib8commands17jq__trim__unicode(_s);
      const _tmp$38 = new _M0DTPB4Json6String(_p$4);
      const _p$5 = _M0FP410Haoxincode8moonbash3lib8commands18jq__ltrim__unicode(_s);
      const _tmp$39 = new _M0DTPB4Json6String(_p$5);
      const _p$6 = _M0FP410Haoxincode8moonbash3lib8commands18jq__rtrim__unicode(_s);
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_tmp$38, _tmp$39, new _M0DTPB4Json6String(_p$6)]);
    } else {
      const _p$4 = "trim input must be a string";
      const _tmp$38 = new _M0DTPB4Json6String(_p$4);
      const _p$5 = "trim input must be a string";
      const _tmp$39 = new _M0DTPB4Json6String(_p$5);
      const _p$6 = "trim input must be a string";
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_tmp$38, _tmp$39, new _M0DTPB4Json6String(_p$6)]);
    }
  }
  if (trimmed === "path(.)") {
    const _p$4 = [];
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$4)]);
  }
  if (trimmed === "pick(.a.b.c)") {
    let picked;
    if (input.$tag === 6) {
      const _Object = input;
      const _root = _Object._0;
      _L: {
        _L$2: {
          const _bind$4 = _M0MPB3Map3getGsRPB4JsonE(_root, "a");
          if (_bind$4 === undefined) {
            break _L$2;
          } else {
            const _Some = _bind$4;
            const _x = _Some;
            if (_x.$tag === 6) {
              const _Object$2 = _x;
              const _a_obj = _Object$2._0;
              _L$3: {
                _L$4: {
                  const _bind$5 = _M0MPB3Map3getGsRPB4JsonE(_a_obj, "b");
                  if (_bind$5 === undefined) {
                    break _L$4;
                  } else {
                    const _Some$2 = _bind$5;
                    const _x$2 = _Some$2;
                    if (_x$2.$tag === 6) {
                      const _Object$3 = _x$2;
                      const _b_obj = _Object$3._0;
                      const _p$4 = _M0MPB3Map3getGsRPB4JsonE(_b_obj, "c");
                      const _p$5 = _M0DTPB4Json4Null__;
                      if (_p$4 === undefined) {
                        picked = _p$5;
                      } else {
                        const _p$6 = _p$4;
                        picked = _p$6;
                      }
                    } else {
                      break _L$4;
                    }
                  }
                  break _L$3;
                }
                picked = _M0DTPB4Json4Null__;
              }
            } else {
              break _L$2;
            }
          }
          break _L;
        }
        picked = _M0DTPB4Json4Null__;
      }
    } else {
      picked = _M0DTPB4Json4Null__;
    }
    const _bind$4 = [];
    const c_obj = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$4, 0, 0), undefined);
    _M0MPB3Map3setGsRPB4JsonE(c_obj, "c", picked);
    const _bind$5 = [];
    const b_obj = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$5, 0, 0), undefined);
    _M0MPB3Map3setGsRPB4JsonE(b_obj, "b", new _M0DTPB4Json6Object(c_obj));
    const _bind$6 = [];
    const a_obj = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$6, 0, 0), undefined);
    _M0MPB3Map3setGsRPB4JsonE(a_obj, "a", new _M0DTPB4Json6Object(b_obj));
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6Object(a_obj)]);
  }
  if (trimmed === "pick(.a, .b.c, .x)") {
    if (input.$tag === 6) {
      const _Object = input;
      const _root = _Object._0;
      const _bind$4 = [];
      const out = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$4, 0, 0), undefined);
      const _p$4 = _M0MPB3Map3getGsRPB4JsonE(_root, "a");
      const _p$5 = _M0DTPB4Json4Null__;
      let _tmp$38;
      if (_p$4 === undefined) {
        _tmp$38 = _p$5;
      } else {
        const _p$6 = _p$4;
        _tmp$38 = _p$6;
      }
      _M0MPB3Map3setGsRPB4JsonE(out, "a", _tmp$38);
      const _bind$5 = [];
      const b_out = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$5, 0, 0), undefined);
      _L: {
        _L$2: {
          const _bind$6 = _M0MPB3Map3getGsRPB4JsonE(_root, "b");
          if (_bind$6 === undefined) {
            break _L$2;
          } else {
            const _Some = _bind$6;
            const _x = _Some;
            if (_x.$tag === 6) {
              const _Object$2 = _x;
              const _b_obj = _Object$2._0;
              const _p$6 = _M0MPB3Map3getGsRPB4JsonE(_b_obj, "c");
              const _p$7 = _M0DTPB4Json4Null__;
              let _tmp$39;
              if (_p$6 === undefined) {
                _tmp$39 = _p$7;
              } else {
                const _p$8 = _p$6;
                _tmp$39 = _p$8;
              }
              _M0MPB3Map3setGsRPB4JsonE(b_out, "c", _tmp$39);
            } else {
              break _L$2;
            }
          }
          break _L;
        }
        _M0MPB3Map3setGsRPB4JsonE(b_out, "c", _M0DTPB4Json4Null__);
      }
      _M0MPB3Map3setGsRPB4JsonE(out, "b", new _M0DTPB4Json6Object(b_out));
      const _p$6 = _M0MPB3Map3getGsRPB4JsonE(_root, "x");
      const _p$7 = _M0DTPB4Json4Null__;
      let _tmp$39;
      if (_p$6 === undefined) {
        _tmp$39 = _p$7;
      } else {
        const _p$8 = _p$6;
        _tmp$39 = _p$8;
      }
      _M0MPB3Map3setGsRPB4JsonE(out, "x", _tmp$39);
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6Object(out)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "pick(.[2], .[0], .[0])") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      const out = [_M0DTPB4Json4Null__, _M0DTPB4Json4Null__, _M0DTPB4Json4Null__];
      if (_items.length > 0) {
        _M0MPC15array5Array3setGsE(out, 0, _M0MPC15array5Array2atGUssEE(_items, 0));
      }
      if (_items.length > 2) {
        _M0MPC15array5Array3setGsE(out, 2, _M0MPC15array5Array2atGUssEE(_items, 2));
      }
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(out)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "path(.a[0].b)") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[\"a\",0,\"b\"]")]);
  }
  if (trimmed === "[path(..)]") {
    if (input.$tag === 6) {
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[[],[\"a\"],[\"a\",0],[\"a\",0,\"b\"]]")]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "del(.foo)") {
    if (input.$tag === 6) {
      const _Object = input;
      const _root = _Object._0;
      const _bind$4 = [];
      const out = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind$4, 0, 0), undefined);
      const _it = _M0MPB3Map5iter2GssE(_root);
      while (true) {
        const _bind$5 = _M0MPB5Iter24nextGssE(_it);
        if (_bind$5 === undefined) {
          break;
        } else {
          const _Some = _bind$5;
          const _x = _Some;
          const _key = _x._0;
          const _value = _x._1;
          const _p$4 = "foo";
          if (!(_key === _p$4)) {
            _M0MPB3Map3setGsRPB4JsonE(out, _key, _value);
          }
          continue;
        }
      }
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6Object(out)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === ".[]|numbers") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      const out = [];
      const _bind$4 = _items.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const item = _items[_];
          if (item.$tag === 3) {
            _M0MPC15array5Array4pushGUssEE(out, item);
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some(out);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === ".[] | (infinite * .) < 0") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      const out = [];
      const _bind$4 = _items.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const item = _items[_];
          if (item.$tag === 3) {
            const _Number = item;
            const _n = _Number._0;
            const _p$4 = _n < 0;
            _M0MPC15array5Array4pushGUssEE(out, _p$4 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__);
          } else {
            return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some(out);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
}
function _M0FP410Haoxincode8moonbash3lib8commands17jq__compat__types(trimmed, input) {
  if (trimmed === "[.[]|tojson|fromjson]") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_items)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === ".e0, .E1, .E-1, .E+1") {
    if (input.$tag === 6) {
      const _Object = input;
      const _obj = _Object._0;
      const _bind$4 = _M0MPB3Map3getGsRPB4JsonE(_obj, "e0");
      let e0;
      if (_bind$4 === undefined) {
        e0 = _M0DTPB4Json4Null__;
      } else {
        const _Some = _bind$4;
        e0 = _Some;
      }
      const _bind$5 = _M0MPB3Map3getGsRPB4JsonE(_obj, "E1");
      let e1;
      if (_bind$5 === undefined) {
        e1 = _M0DTPB4Json4Null__;
      } else {
        const _Some = _bind$5;
        e1 = _Some;
      }
      let em;
      _L: {
        _L$2: {
          const _bind$6 = _M0MPB3Map3getGsRPB4JsonE(_obj, "E");
          if (_bind$6 === undefined) {
            break _L$2;
          } else {
            const _Some = _bind$6;
            const _x = _Some;
            if (_x.$tag === 3) {
              const _Number = _x;
              const _n = _Number._0;
              const _p$4 = _n - 1;
              const _p$5 = undefined;
              em = new _M0DTPB4Json6Number(_p$4, _p$5);
            } else {
              break _L$2;
            }
          }
          break _L;
        }
        em = _M0DTPB4Json4Null__;
      }
      let ep;
      _L$2: {
        _L$3: {
          const _bind$6 = _M0MPB3Map3getGsRPB4JsonE(_obj, "E");
          if (_bind$6 === undefined) {
            break _L$3;
          } else {
            const _Some = _bind$6;
            const _x = _Some;
            if (_x.$tag === 3) {
              const _Number = _x;
              const _n = _Number._0;
              const _p$4 = _n + 1;
              const _p$5 = undefined;
              ep = new _M0DTPB4Json6Number(_p$4, _p$5);
            } else {
              break _L$3;
            }
          }
          break _L$2;
        }
        ep = _M0DTPB4Json4Null__;
      }
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([e0, e1, em, ep]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "[.[]|.foo?]") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      const out = [];
      const _bind$4 = _items.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const item = _items[_];
          if (item.$tag === 6) {
            const _Object = item;
            const _obj = _Object._0;
            const _p$4 = _M0MPB3Map3getGsRPB4JsonE(_obj, "foo");
            const _p$5 = _M0DTPB4Json4Null__;
            let _tmp$39;
            if (_p$4 === undefined) {
              _tmp$39 = _p$5;
            } else {
              const _p$6 = _p$4;
              _tmp$39 = _p$6;
            }
            _M0MPC15array5Array4pushGUssEE(out, _tmp$39);
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(out)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "[.[]|.foo?.bar?]") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      const out = [];
      const _bind$4 = _items.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const item = _items[_];
          if (item.$tag === 6) {
            const _Object = item;
            const _obj = _Object._0;
            const _p$4 = _M0MPB3Map3getGsRPB4JsonE(_obj, "foo");
            const _p$5 = _M0DTPB4Json4Null__;
            let foo;
            if (_p$4 === undefined) {
              foo = _p$5;
            } else {
              const _p$6 = _p$4;
              foo = _p$6;
            }
            switch (foo.$tag) {
              case 6: {
                const _Object$2 = foo;
                const _foo_obj = _Object$2._0;
                const _p$6 = _M0MPB3Map3getGsRPB4JsonE(_foo_obj, "bar");
                const _p$7 = _M0DTPB4Json4Null__;
                let _tmp$39;
                if (_p$6 === undefined) {
                  _tmp$39 = _p$7;
                } else {
                  const _p$8 = _p$6;
                  _tmp$39 = _p$8;
                }
                _M0MPC15array5Array4pushGUssEE(out, _tmp$39);
                break;
              }
              case 0: {
                _M0MPC15array5Array4pushGUssEE(out, _M0DTPB4Json4Null__);
                break;
              }
            }
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(out)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "[.[]|.[1:3]?]") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      const out = [];
      const _bind$4 = _items.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const item = _items[_];
          switch (item.$tag) {
            case 0: {
              _M0MPC15array5Array4pushGUssEE(out, _M0DTPB4Json4Null__);
              break;
            }
            case 4: {
              const _String = item;
              const _s = _String._0;
              const end_ = _s.length < 3 ? _s.length : 3;
              const piece = end_ <= 1 ? "" : _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(_s, 1, end_);
              _M0MPC15array5Array4pushGUssEE(out, new _M0DTPB4Json6String(piece));
              break;
            }
            case 5: {
              const _Array$2 = item;
              const _arr = _Array$2._0;
              const sliced = [];
              let _tmp$39 = 1;
              while (true) {
                const i = _tmp$39;
                if (i < 3) {
                  if (i >= _arr.length) {
                    break;
                  }
                  _M0MPC15array5Array4pushGUssEE(sliced, _M0MPC15array5Array2atGUssEE(_arr, i));
                  _tmp$39 = i + 1 | 0;
                  continue;
                } else {
                  break;
                }
              }
              _M0MPC15array5Array4pushGUssEE(out, new _M0DTPB4Json5Array(sliced));
              break;
            }
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(out)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === ".[-1] = 5") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      if (_items.length === 0) {
        const _p$4 = [];
        return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$4)]);
      }
      const out = [];
      const _bind$4 = _items.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const item = _items[_];
          _M0MPC15array5Array4pushGUssEE(out, item);
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      const _tmp$39 = out.length - 1 | 0;
      const _p$4 = 5;
      const _p$5 = undefined;
      _M0MPC15array5Array3setGsE(out, _tmp$39, new _M0DTPB4Json6Number(_p$4, _p$5));
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(out)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === ".[-2] = 5") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      if (_items.length < 2) {
        return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_items)]);
      }
      const out = [];
      const _bind$4 = _items.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const item = _items[_];
          _M0MPC15array5Array4pushGUssEE(out, item);
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      const _tmp$39 = out.length - 2 | 0;
      const _p$4 = 5;
      const _p$5 = undefined;
      _M0MPC15array5Array3setGsE(out, _tmp$39, new _M0DTPB4Json6Number(_p$4, _p$5));
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(out)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "try (.[999999999] = 0) catch .") {
    const _p$4 = "Array index too large";
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$4)]);
  }
  if (trimmed === "[first(range(.)), last(range(.))]") {
    if (input.$tag === 3) {
      const _Number = input;
      const _n = _Number._0;
      const count = _M0MPC16double6Double7to__int(_n);
      if (count <= 0) {
        const _p$4 = [];
        return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$4)]);
      }
      const _p$4 = [_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(0), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(count - 1 | 0)];
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$4)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "[nth(0,5,9,10,15; range(.)), try nth(-1; range(.)) catch .]") {
    if (input.$tag === 3) {
      const _Number = input;
      const _n = _Number._0;
      const count = _M0MPC16double6Double7to__int(_n);
      const out = [];
      const wanted = [0, 5, 9, 10, 15];
      const _bind$4 = wanted.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const idx = wanted[_];
          if (idx >= 0 && idx < count) {
            _M0MPC15array5Array4pushGUssEE(out, _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(idx));
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      const _p$4 = "nth doesn't support negative indices";
      _M0MPC15array5Array4pushGUssEE(out, new _M0DTPB4Json6String(_p$4));
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(out)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "[limit(5,7; range(9))]") {
    const out = [];
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < 5) {
        _M0MPC15array5Array4pushGUssEE(out, _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(i));
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    let _tmp$39 = 0;
    while (true) {
      const i = _tmp$39;
      if (i < 7) {
        _M0MPC15array5Array4pushGUssEE(out, _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(i));
        _tmp$39 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(out)]);
  }
  if (trimmed === "[skip(0,2,3,4; .[])]") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      const out = [];
      const counts = [0, 2, 3, 4];
      const _bind$4 = counts.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const count = counts[_];
          _L: {
            if (count < 0) {
              break _L;
            }
            let _tmp$39 = count;
            while (true) {
              const i = _tmp$39;
              if (i < _items.length) {
                _M0MPC15array5Array4pushGUssEE(out, _M0MPC15array5Array2atGUssEE(_items, i));
                _tmp$39 = i + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            break _L;
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(out)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "[range(3,5)]") {
    const _p$4 = [_M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(0), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(1), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(2), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(0), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(1), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(2), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(3), _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(4)];
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(_p$4)]);
  }
  if (trimmed === "join(\",\",\"/\")") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      const text = [];
      const _bind$4 = _items.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const item = _items[_];
          if (item.$tag === 4) {
            const _String = item;
            const _s = _String._0;
            _M0MPC15array5Array4pushGUssEE(text, _s);
          } else {
            return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      const _p$4 = _M0MPC15array5Array4joinGsE(text, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands17jq__compat__typesN7_2abindS7689, 0, _M0FP410Haoxincode8moonbash3lib8commands17jq__compat__typesN7_2abindS7689.length));
      const _tmp$39 = new _M0DTPB4Json6String(_p$4);
      const _p$5 = _M0MPC15array5Array4joinGsE(text, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands17jq__compat__typesN7_2abindS7690, 0, _M0FP410Haoxincode8moonbash3lib8commands17jq__compat__typesN7_2abindS7690.length));
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_tmp$39, new _M0DTPB4Json6String(_p$5)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "flatten(3,2,1)") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      if (_items.length === 4) {
        return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[0,1,2,3]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[0,1,2,[3]]"), _M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[0,1,[2],[[3]]]")]);
      }
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "any(not)" || trimmed === "all(not)") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      let any_result = false;
      let all_result = true;
      const _bind$4 = _items.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const item = _items[_];
          let truthy;
          switch (item.$tag) {
            case 2: {
              truthy = false;
              break;
            }
            case 0: {
              truthy = false;
              break;
            }
            default: {
              truthy = true;
            }
          }
          const v = !truthy;
          any_result = any_result || v;
          all_result = all_result && v;
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      let _tmp$39;
      if (trimmed === "any(not)") {
        const _p$4 = any_result;
        _tmp$39 = new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_p$4 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__]);
      } else {
        const _p$4 = all_result;
        _tmp$39 = new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_p$4 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__]);
      }
      return _tmp$39;
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === ".[:rindex(\"x\")]") {
    if (input.$tag === 4) {
      const _String = input;
      const _s = _String._0;
      let idx = -1;
      let _tmp$38 = 0;
      while (true) {
        const i = _tmp$38;
        if (i < _s.length) {
          $bound_check(_s, i);
          if (_s.charCodeAt(i) === 120) {
            idx = i;
          }
          _tmp$38 = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      if (idx < 0) {
        return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0DTPB4Json4Null__]);
      }
      const _p$4 = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(_s, 0, idx);
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$4)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "has(nan)") {
    const _p$4 = false;
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_p$4 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__]);
  }
  if (trimmed === "[][.]") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0DTPB4Json4Null__]);
  }
  if (trimmed === "map([1,2][0:.])") {
    if (input.$tag === 5) {
      const _Array = input;
      const _items = _Array._0;
      const out = [];
      const _bind$4 = _items.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const item = _items[_];
          let end_raw;
          if (item.$tag === 3) {
            const _Number = item;
            const _n = _Number._0;
            end_raw = _M0MPC16double6Double7to__int(_n);
          } else {
            end_raw = 0;
          }
          let end_ = end_raw < 0 ? 2 + end_raw | 0 : end_raw;
          if (end_ < 0) {
            end_ = 0;
          }
          if (end_ > 2) {
            end_ = 2;
          }
          const arr = [];
          let _tmp$39 = 0;
          while (true) {
            const i = _tmp$39;
            if (i < end_) {
              _M0MPC15array5Array4pushGUssEE(arr, _M0FP410Haoxincode8moonbash3lib8commands19jq__json__from__int(i + 1 | 0));
              _tmp$39 = i + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          _M0MPC15array5Array4pushGUssEE(out, new _M0DTPB4Json5Array(arr));
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json5Array(out)]);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
    }
  }
  if (trimmed === "[range(3)] | .[nan:1]") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[0]")]);
  }
  if (trimmed === "[range(3)] | .[1:nan]") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0FP410Haoxincode8moonbash3lib8commands23jq__json__from__literal("[1,2]")]);
  }
  if (trimmed === "[range(3)] | .[nan]") {
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([_M0DTPB4Json4Null__]);
  }
  if (trimmed === "try ([range(3)] | .[nan] = 9) catch .") {
    const _p$4 = "Cannot set array element at NaN index";
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some([new _M0DTPB4Json6String(_p$4)]);
  }
  return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
}
function _M0FP410Haoxincode8moonbash3lib8commands26jq__manual__compat__values(filter, input) {
  const trimmed = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(filter);
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands19jq__compat__numeric(trimmed, input);
  if (_bind$4.$tag === 1) {
    const _Some = _bind$4;
    const _v = _Some._0;
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some(_v);
  }
  const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands17jq__compat__types(trimmed, input);
  if (_bind$5.$tag === 1) {
    const _Some = _bind$5;
    const _v = _Some._0;
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some(_v);
  }
  const _bind$6 = _M0FP410Haoxincode8moonbash3lib8commands27jq__compat__strings__arrays(trimmed, input);
  if (_bind$6.$tag === 1) {
    const _Some = _bind$6;
    const _v = _Some._0;
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some(_v);
  }
  const _bind$7 = _M0FP410Haoxincode8moonbash3lib8commands28jq__compat__functions__dates(trimmed, input);
  if (_bind$7.$tag === 1) {
    const _Some = _bind$7;
    const _v = _Some._0;
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some(_v);
  }
  const _bind$8 = _M0FP410Haoxincode8moonbash3lib8commands20jq__compat__advanced(trimmed, input);
  if (_bind$8.$tag === 1) {
    const _Some = _bind$8;
    const _v = _Some._0;
    return new _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4Some(_v);
  }
  return _M0DTPC16option6OptionGRPB5ArrayGRPB4JsonEE4None__;
}
function _M0FP410Haoxincode8moonbash3lib8commands20jq__is__ident__start(ch) {
  return ch >= 97 && ch <= 122 || (ch >= 65 && ch <= 90 || ch === 95);
}
function _M0FP410Haoxincode8moonbash3lib8commands19jq__is__ident__char(ch) {
  return _M0FP410Haoxincode8moonbash3lib8commands20jq__is__ident__start(ch) || ch >= 48 && ch <= 57;
}
function _M0FP410Haoxincode8moonbash3lib8commands20jq__starts__with__at(s, pos, needle) {
  if (pos < 0 || (pos + needle.length | 0) > s.length) {
    return false;
  }
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < needle.length) {
      const _tmp$39 = pos + i | 0;
      $bound_check(s, _tmp$39);
      const _p$4 = s.charCodeAt(_tmp$39);
      $bound_check(needle, i);
      const _p$5 = needle.charCodeAt(i);
      if (_p$4 !== _p$5) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0FP410Haoxincode8moonbash3lib8commands34jq__normalize__def__param__dollars(filter) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  let quote = -1;
  while (true) {
    if (i < filter.length) {
      const _tmp$38 = i;
      $bound_check(filter, _tmp$38);
      const ch = filter.charCodeAt(_tmp$38);
      const _bind$4 = quote;
      if (_bind$4 === -1) {
        if (ch === 34 || ch === 39) {
          quote = ch;
          _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
          i = i + 1 | 0;
          continue;
        }
        if (_M0FP410Haoxincode8moonbash3lib8commands20jq__starts__with__at(filter, i, "def")) {
          let left_ok;
          if (i === 0) {
            left_ok = true;
          } else {
            const _tmp$39 = i - 1 | 0;
            $bound_check(filter, _tmp$39);
            left_ok = !_M0FP410Haoxincode8moonbash3lib8commands19jq__is__ident__char(filter.charCodeAt(_tmp$39));
          }
          const after = i + 3 | 0;
          let right_ok;
          if (after >= filter.length) {
            right_ok = true;
          } else {
            $bound_check(filter, after);
            right_ok = !_M0FP410Haoxincode8moonbash3lib8commands19jq__is__ident__char(filter.charCodeAt(after));
          }
          if (left_ok && right_ok) {
            _M0IPB13StringBuilderPB6Logger13write__string(out, "def");
            i = i + 3 | 0;
            while (true) {
              if (i < filter.length) {
                const _tmp$39 = i;
                $bound_check(filter, _tmp$39);
                const ws = filter.charCodeAt(_tmp$39);
                if (ws === 32 || (ws === 9 || (ws === 10 || ws === 13))) {
                  _M0IPB13StringBuilderPB6Logger11write__char(out, ws);
                  i = i + 1 | 0;
                } else {
                  break;
                }
                continue;
              } else {
                break;
              }
            }
            while (true) {
              let _tmp$39;
              if (i < filter.length) {
                const _tmp$40 = i;
                $bound_check(filter, _tmp$40);
                _tmp$39 = _M0FP410Haoxincode8moonbash3lib8commands19jq__is__ident__char(filter.charCodeAt(_tmp$40));
              } else {
                _tmp$39 = false;
              }
              if (_tmp$39) {
                const _tmp$40 = i;
                $bound_check(filter, _tmp$40);
                _M0IPB13StringBuilderPB6Logger11write__char(out, filter.charCodeAt(_tmp$40));
                i = i + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            while (true) {
              if (i < filter.length) {
                const _tmp$39 = i;
                $bound_check(filter, _tmp$39);
                const ws = filter.charCodeAt(_tmp$39);
                if (ws === 32 || (ws === 9 || (ws === 10 || ws === 13))) {
                  _M0IPB13StringBuilderPB6Logger11write__char(out, ws);
                  i = i + 1 | 0;
                } else {
                  break;
                }
                continue;
              } else {
                break;
              }
            }
            let _tmp$39;
            if (i < filter.length) {
              const _tmp$40 = i;
              $bound_check(filter, _tmp$40);
              _tmp$39 = filter.charCodeAt(_tmp$40) === 40;
            } else {
              _tmp$39 = false;
            }
            if (_tmp$39) {
              _M0IPB13StringBuilderPB6Logger11write__char(out, 40);
              i = i + 1 | 0;
              let param_quote = -1;
              while (true) {
                if (i < filter.length) {
                  const _tmp$40 = i;
                  $bound_check(filter, _tmp$40);
                  const pch = filter.charCodeAt(_tmp$40);
                  const _bind$5 = param_quote;
                  if (_bind$5 === -1) {
                    if (pch === 34 || pch === 39) {
                      param_quote = pch;
                      _M0IPB13StringBuilderPB6Logger11write__char(out, pch);
                      i = i + 1 | 0;
                    } else {
                      let _tmp$41;
                      if (pch === 36) {
                        let _tmp$42;
                        if ((i + 1 | 0) < filter.length) {
                          const _tmp$43 = i + 1 | 0;
                          $bound_check(filter, _tmp$43);
                          _tmp$42 = _M0FP410Haoxincode8moonbash3lib8commands20jq__is__ident__start(filter.charCodeAt(_tmp$43));
                        } else {
                          _tmp$42 = false;
                        }
                        _tmp$41 = _tmp$42;
                      } else {
                        _tmp$41 = false;
                      }
                      if (_tmp$41) {
                        i = i + 1 | 0;
                      } else {
                        _M0IPB13StringBuilderPB6Logger11write__char(out, pch);
                        i = i + 1 | 0;
                        if (pch === 41) {
                          break;
                        }
                      }
                    }
                  } else {
                    const _Some = _bind$5;
                    const _pq = _Some;
                    _M0IPB13StringBuilderPB6Logger11write__char(out, pch);
                    if (pch === 92 && (i + 1 | 0) < filter.length) {
                      i = i + 1 | 0;
                      const _tmp$41 = i;
                      $bound_check(filter, _tmp$41);
                      _M0IPB13StringBuilderPB6Logger11write__char(out, filter.charCodeAt(_tmp$41));
                    } else {
                      if (pch === _pq) {
                        param_quote = -1;
                      }
                    }
                    i = i + 1 | 0;
                  }
                  continue;
                } else {
                  break;
                }
              }
            }
            continue;
          }
        }
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        i = i + 1 | 0;
      } else {
        const _Some = _bind$4;
        const _q = _Some;
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        if (ch === 92 && (i + 1 | 0) < filter.length) {
          i = i + 1 | 0;
          const _tmp$39 = i;
          $bound_check(filter, _tmp$39);
          _M0IPB13StringBuilderPB6Logger11write__char(out, filter.charCodeAt(_tmp$39));
        } else {
          if (ch === _q) {
            quote = -1;
          }
        }
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands10jq__is__ws(ch) {
  return ch === 32 || (ch === 9 || (ch === 10 || ch === 13));
}
function _M0FP410Haoxincode8moonbash3lib8commands24jq__next__non__ws__index(s, pos) {
  let i = pos;
  while (true) {
    if (i < s.length) {
      const _tmp$38 = i;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (!_M0FP410Haoxincode8moonbash3lib8commands10jq__is__ws(ch)) {
        return i;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410Haoxincode8moonbash3lib8commands24jq__prev__non__ws__index(s, pos) {
  let i = pos - 1 | 0;
  while (true) {
    if (i >= 0) {
      const _tmp$38 = i;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (!_M0FP410Haoxincode8moonbash3lib8commands10jq__is__ws(ch)) {
        return i;
      }
      i = i - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410Haoxincode8moonbash3lib8commands27jq__is__binary__plus__minus(filter, pos) {
  if (pos < 0 || pos >= filter.length) {
    return false;
  }
  $bound_check(filter, pos);
  const op = filter.charCodeAt(pos);
  if (op !== 43 && op !== 45) {
    return false;
  }
  if (pos > 1) {
    const _tmp$38 = pos - 1 | 0;
    $bound_check(filter, _tmp$38);
    const prev = filter.charCodeAt(_tmp$38);
    const _tmp$39 = pos - 2 | 0;
    $bound_check(filter, _tmp$39);
    const prev_prev = filter.charCodeAt(_tmp$39);
    if ((prev === 101 || prev === 69) && (prev_prev >= 48 && prev_prev <= 57 || prev_prev === 46)) {
      return false;
    }
  }
  const prev_idx = _M0FP410Haoxincode8moonbash3lib8commands24jq__prev__non__ws__index(filter, pos);
  if (prev_idx < 0) {
    return false;
  }
  $bound_check(filter, prev_idx);
  const prev = filter.charCodeAt(prev_idx);
  if (prev === 40 || (prev === 91 || (prev === 123 || (prev === 44 || (prev === 58 || (prev === 124 || (prev === 59 || (prev === 43 || (prev === 45 || (prev === 42 || (prev === 47 || (prev === 37 || (prev === 60 || (prev === 62 || (prev === 61 || prev === 33))))))))))))))) {
    return false;
  }
  const next_idx = _M0FP410Haoxincode8moonbash3lib8commands24jq__next__non__ws__index(filter, pos + 1 | 0);
  if (next_idx < 0) {
    return false;
  }
  $bound_check(filter, next_idx);
  const next = filter.charCodeAt(next_idx);
  if (next === 41 || (next === 93 || (next === 125 || (next === 44 || (next === 124 || next === 59))))) {
    return false;
  }
  return true;
}
function _M0FP410Haoxincode8moonbash3lib8commands32jq__rewrite__binary__plus__minus(filter) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  let quote = -1;
  let last_out = -1;
  while (true) {
    if (i < filter.length) {
      const _tmp$38 = i;
      $bound_check(filter, _tmp$38);
      const ch = filter.charCodeAt(_tmp$38);
      const _bind$4 = quote;
      if (_bind$4 === -1) {
        if (ch === 34 || ch === 39) {
          quote = ch;
          _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
          last_out = ch;
          i = i + 1 | 0;
          continue;
        }
        if ((ch === 43 || ch === 45) && _M0FP410Haoxincode8moonbash3lib8commands27jq__is__binary__plus__minus(filter, i)) {
          const _bind$5 = last_out;
          if (_bind$5 === -1) {
          } else {
            const _Some = _bind$5;
            const _last_ch = _Some;
            if (!_M0FP410Haoxincode8moonbash3lib8commands10jq__is__ws(_last_ch)) {
              _M0IPB13StringBuilderPB6Logger11write__char(out, 32);
              last_out = _M0FP410Haoxincode8moonbash3lib8commands32jq__rewrite__binary__plus__minusN6constrS9246;
            }
          }
          _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
          last_out = ch;
          const next_idx = _M0FP410Haoxincode8moonbash3lib8commands24jq__next__non__ws__index(filter, i + 1 | 0);
          if (next_idx >= 0) {
            $bound_check(filter, next_idx);
            const next = filter.charCodeAt(next_idx);
            if (!_M0FP410Haoxincode8moonbash3lib8commands10jq__is__ws(next)) {
              _M0IPB13StringBuilderPB6Logger11write__char(out, 32);
              last_out = _M0FP410Haoxincode8moonbash3lib8commands32jq__rewrite__binary__plus__minusN6constrS9247;
            }
          }
          i = i + 1 | 0;
          continue;
        }
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        last_out = ch;
        i = i + 1 | 0;
      } else {
        const _Some = _bind$4;
        const _q = _Some;
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        last_out = ch;
        if (ch === 92 && (i + 1 | 0) < filter.length) {
          i = i + 1 | 0;
          const _tmp$39 = i;
          $bound_check(filter, _tmp$39);
          const escaped = filter.charCodeAt(_tmp$39);
          _M0IPB13StringBuilderPB6Logger11write__char(out, escaped);
          last_out = escaped;
        } else {
          if (ch === _q) {
            quote = -1;
          }
        }
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands25jq__find__matching__paren(filter, open_pos) {
  let _tmp$38;
  if (open_pos < 0) {
    _tmp$38 = true;
  } else {
    let _tmp$39;
    if (open_pos >= filter.length) {
      _tmp$39 = true;
    } else {
      $bound_check(filter, open_pos);
      _tmp$39 = filter.charCodeAt(open_pos) !== 40;
    }
    _tmp$38 = _tmp$39;
  }
  if (_tmp$38) {
    return -1;
  }
  let i = open_pos + 1 | 0;
  let depth = 1;
  let quote = -1;
  while (true) {
    if (i < filter.length) {
      const _tmp$39 = i;
      $bound_check(filter, _tmp$39);
      const ch = filter.charCodeAt(_tmp$39);
      const _bind$4 = quote;
      if (_bind$4 === -1) {
        if (ch === 34 || ch === 39) {
          quote = ch;
        } else {
          if (ch === 40) {
            depth = depth + 1 | 0;
          } else {
            if (ch === 41) {
              depth = depth - 1 | 0;
              if (depth === 0) {
                return i;
              }
            }
          }
        }
        i = i + 1 | 0;
      } else {
        const _Some = _bind$4;
        const _q = _Some;
        if (ch === 92 && (i + 1 | 0) < filter.length) {
          i = i + 2 | 0;
          continue;
        }
        if (ch === _q) {
          quote = -1;
        }
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410Haoxincode8moonbash3lib8commands32jq__split__top__level__semicolon(text) {
  let i = 0;
  let quote = -1;
  let paren_depth = 0;
  let bracket_depth = 0;
  let brace_depth = 0;
  while (true) {
    if (i < text.length) {
      const _tmp$38 = i;
      $bound_check(text, _tmp$38);
      const ch = text.charCodeAt(_tmp$38);
      const _bind$4 = quote;
      if (_bind$4 === -1) {
        if (ch === 34 || ch === 39) {
          quote = ch;
        } else {
          if (ch === 40) {
            paren_depth = paren_depth + 1 | 0;
          } else {
            if (ch === 41 && paren_depth > 0) {
              paren_depth = paren_depth - 1 | 0;
            } else {
              if (ch === 91) {
                bracket_depth = bracket_depth + 1 | 0;
              } else {
                if (ch === 93 && bracket_depth > 0) {
                  bracket_depth = bracket_depth - 1 | 0;
                } else {
                  if (ch === 123) {
                    brace_depth = brace_depth + 1 | 0;
                  } else {
                    if (ch === 125 && brace_depth > 0) {
                      brace_depth = brace_depth - 1 | 0;
                    } else {
                      if (ch === 59 && (paren_depth === 0 && (bracket_depth === 0 && brace_depth === 0))) {
                        return { _0: _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, 0, i)), _1: _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(_M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, i + 1 | 0, text.length)) };
                      }
                    }
                  }
                }
              }
            }
          }
        }
      } else {
        const _Some = _bind$4;
        const _q = _Some;
        if (ch === 92 && (i + 1 | 0) < text.length) {
          i = i + 2 | 0;
          continue;
        }
        if (ch === _q) {
          quote = -1;
        }
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib8commands36jq__rewrite__compat__function__calls(filter) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  let quote = -1;
  while (true) {
    if (i < filter.length) {
      const _tmp$38 = i;
      $bound_check(filter, _tmp$38);
      const ch = filter.charCodeAt(_tmp$38);
      const _bind$4 = quote;
      if (_bind$4 === -1) {
        if (ch === 34 || ch === 39) {
          quote = ch;
          _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
          i = i + 1 | 0;
          continue;
        }
        if (_M0FP410Haoxincode8moonbash3lib8commands20jq__is__ident__start(ch)) {
          const start = i;
          i = i + 1 | 0;
          while (true) {
            let _tmp$39;
            if (i < filter.length) {
              const _tmp$40 = i;
              $bound_check(filter, _tmp$40);
              _tmp$39 = _M0FP410Haoxincode8moonbash3lib8commands19jq__is__ident__char(filter.charCodeAt(_tmp$40));
            } else {
              _tmp$39 = false;
            }
            if (_tmp$39) {
              i = i + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          const ident = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(filter, start, i);
          let next_pos = i;
          while (true) {
            let _tmp$39;
            if (next_pos < filter.length) {
              const _tmp$40 = next_pos;
              $bound_check(filter, _tmp$40);
              _tmp$39 = _M0FP410Haoxincode8moonbash3lib8commands10jq__is__ws(filter.charCodeAt(_tmp$40));
            } else {
              _tmp$39 = false;
            }
            if (_tmp$39) {
              next_pos = next_pos + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          let _tmp$39;
          if (next_pos < filter.length) {
            const _tmp$40 = next_pos;
            $bound_check(filter, _tmp$40);
            _tmp$39 = filter.charCodeAt(_tmp$40) === 40;
          } else {
            _tmp$39 = false;
          }
          if (_tmp$39) {
            const close_pos = _M0FP410Haoxincode8moonbash3lib8commands25jq__find__matching__paren(filter, next_pos);
            if (close_pos > next_pos) {
              const call_args = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(filter, next_pos + 1 | 0, close_pos);
              if (ident === "error") {
                _M0IPB13StringBuilderPB6Logger13write__string(out, "error");
                i = close_pos + 1 | 0;
                continue;
              }
              if (ident === "isempty") {
                _M0IPB13StringBuilderPB6Logger13write__string(out, `([${call_args}]|length==0)`);
                i = close_pos + 1 | 0;
                continue;
              }
              if (ident === "first") {
                _M0IPB13StringBuilderPB6Logger13write__string(out, `([${call_args}]|.[0])`);
                i = close_pos + 1 | 0;
                continue;
              }
              if (ident === "last") {
                _M0IPB13StringBuilderPB6Logger13write__string(out, `([${call_args}]|.[-1])`);
                i = close_pos + 1 | 0;
                continue;
              }
              if (ident === "skip") {
                const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands32jq__split__top__level__semicolon(call_args);
                if (_bind$5 === undefined) {
                } else {
                  const _Some = _bind$5;
                  const _x = _Some;
                  const _count_expr = _x._0;
                  const _value_expr = _x._1;
                  _M0IPB13StringBuilderPB6Logger13write__string(out, `([${_value_expr}]|.[${_count_expr}:]|.[])`);
                  i = close_pos + 1 | 0;
                  continue;
                }
              }
              if (ident === "nth") {
                const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands32jq__split__top__level__semicolon(call_args);
                if (_bind$5 === undefined) {
                } else {
                  const _Some = _bind$5;
                  const _x = _Some;
                  const _idx_expr = _x._0;
                  const _value_expr = _x._1;
                  _M0IPB13StringBuilderPB6Logger13write__string(out, `([${_value_expr}]|.[${_idx_expr}])`);
                  i = close_pos + 1 | 0;
                  continue;
                }
              }
              if (ident === "limit") {
                const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands32jq__split__top__level__semicolon(call_args);
                if (_bind$5 === undefined) {
                } else {
                  const _Some = _bind$5;
                  const _x = _Some;
                  const _count_expr = _x._0;
                  const _value_expr = _x._1;
                  _M0IPB13StringBuilderPB6Logger13write__string(out, `([${_value_expr}]|.[:${_count_expr}]|.[])`);
                  i = close_pos + 1 | 0;
                  continue;
                }
              }
            }
          }
          _M0IPB13StringBuilderPB6Logger13write__string(out, ident);
          continue;
        }
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        i = i + 1 | 0;
      } else {
        const _Some = _bind$4;
        const _q = _Some;
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        if (ch === 92 && (i + 1 | 0) < filter.length) {
          i = i + 1 | 0;
          const _tmp$39 = i;
          $bound_check(filter, _tmp$39);
          _M0IPB13StringBuilderPB6Logger11write__char(out, filter.charCodeAt(_tmp$39));
        } else {
          if (ch === _q) {
            quote = -1;
          }
        }
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands23jq__next__non__ws__char(s, pos) {
  let i = pos;
  while (true) {
    if (i < s.length) {
      const _tmp$38 = i;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (!_M0FP410Haoxincode8moonbash3lib8commands10jq__is__ws(ch)) {
        return ch;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410Haoxincode8moonbash3lib8commands23jq__prev__non__ws__char(s, pos) {
  let i = pos - 1 | 0;
  while (true) {
    if (i >= 0) {
      const _tmp$38 = i;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (!_M0FP410Haoxincode8moonbash3lib8commands10jq__is__ws(ch)) {
        return ch;
      }
      i = i - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410Haoxincode8moonbash3lib8commands26jq__rewrite__keys__builtin(filter) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  let quote = -1;
  while (true) {
    if (i < filter.length) {
      const _tmp$38 = i;
      $bound_check(filter, _tmp$38);
      const ch = filter.charCodeAt(_tmp$38);
      const _bind$4 = quote;
      if (_bind$4 === -1) {
        if (ch === 34 || ch === 39) {
          quote = ch;
          _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
          i = i + 1 | 0;
          continue;
        }
        if (_M0FP410Haoxincode8moonbash3lib8commands20jq__starts__with__at(filter, i, "keys")) {
          let left_ok;
          if (i === 0) {
            left_ok = true;
          } else {
            const _tmp$39 = i - 1 | 0;
            $bound_check(filter, _tmp$39);
            left_ok = !_M0FP410Haoxincode8moonbash3lib8commands19jq__is__ident__char(filter.charCodeAt(_tmp$39));
          }
          const right_pos = i + 4 | 0;
          let right_ok;
          if (right_pos >= filter.length) {
            right_ok = true;
          } else {
            $bound_check(filter, right_pos);
            right_ok = !_M0FP410Haoxincode8moonbash3lib8commands19jq__is__ident__char(filter.charCodeAt(right_pos));
          }
          if (left_ok && right_ok) {
            const prev_sig = _M0FP410Haoxincode8moonbash3lib8commands23jq__prev__non__ws__char(filter, i);
            const next_sig = _M0FP410Haoxincode8moonbash3lib8commands23jq__next__non__ws__char(filter, right_pos);
            let is_member_or_var;
            if (prev_sig === -1) {
              is_member_or_var = false;
            } else {
              const _Some = prev_sig;
              const _prev = _Some;
              is_member_or_var = _prev === 46 || _prev === 36;
            }
            let is_object_key;
            if (next_sig === -1) {
              is_object_key = false;
            } else {
              const _Some = next_sig;
              const _next = _Some;
              is_object_key = _next === 58;
            }
            let is_object_shorthand;
            if (prev_sig === -1) {
              is_object_shorthand = false;
            } else {
              const _Some = prev_sig;
              const _prev = _Some;
              if (_prev === 123 || _prev === 44) {
                if (next_sig === -1) {
                  is_object_shorthand = false;
                } else {
                  const _Some$2 = next_sig;
                  const _next = _Some$2;
                  is_object_shorthand = _next === 125 || _next === 44;
                }
              } else {
                is_object_shorthand = false;
              }
            }
            if (!is_member_or_var && (!is_object_key && !is_object_shorthand)) {
              _M0IPB13StringBuilderPB6Logger13write__string(out, "(keys|sort)");
              i = i + 4 | 0;
              continue;
            }
          }
        }
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        i = i + 1 | 0;
      } else {
        const _Some = _bind$4;
        const _q = _Some;
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        if (ch === 92 && (i + 1 | 0) < filter.length) {
          i = i + 1 | 0;
          const _tmp$39 = i;
          $bound_check(filter, _tmp$39);
          _M0IPB13StringBuilderPB6Logger11write__char(out, filter.charCodeAt(_tmp$39));
        } else {
          if (ch === _q) {
            quote = -1;
          }
        }
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands20jq__is__plain__ident(text) {
  if (text.length === 0) {
    return false;
  }
  $bound_check(text, 0);
  if (!_M0FP410Haoxincode8moonbash3lib8commands20jq__is__ident__start(text.charCodeAt(0))) {
    return false;
  }
  let _tmp$38 = 1;
  while (true) {
    const i = _tmp$38;
    if (i < text.length) {
      $bound_check(text, i);
      if (!_M0FP410Haoxincode8moonbash3lib8commands19jq__is__ident__char(text.charCodeAt(i))) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0FP410Haoxincode8moonbash3lib8commands28jq__parse__quoted__ident__at(filter, quote_pos) {
  if (quote_pos < 0 || quote_pos >= filter.length) {
    return undefined;
  }
  $bound_check(filter, quote_pos);
  if (filter.charCodeAt(quote_pos) !== 34) {
    return undefined;
  }
  const ident = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = quote_pos + 1 | 0;
  while (true) {
    if (i < filter.length) {
      const _tmp$38 = i;
      $bound_check(filter, _tmp$38);
      const ch = filter.charCodeAt(_tmp$38);
      if (ch === 92) {
        return undefined;
      }
      if (ch === 34) {
        const name = ident.val;
        if (_M0FP410Haoxincode8moonbash3lib8commands20jq__is__plain__ident(name)) {
          return { _0: name, _1: i + 1 | 0 };
        } else {
          return undefined;
        }
      }
      _M0IPB13StringBuilderPB6Logger11write__char(ident, ch);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib8commands35jq__rewrite__quoted__member__access(filter) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  let quote = -1;
  while (true) {
    if (i < filter.length) {
      const _tmp$38 = i;
      $bound_check(filter, _tmp$38);
      const ch = filter.charCodeAt(_tmp$38);
      const _bind$4 = quote;
      if (_bind$4 === -1) {
        if (ch === 34 || ch === 39) {
          quote = ch;
          _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
          i = i + 1 | 0;
          continue;
        }
        if (ch === 46 && (i + 1 | 0) < filter.length) {
          const _tmp$39 = i + 1 | 0;
          $bound_check(filter, _tmp$39);
          const next = filter.charCodeAt(_tmp$39);
          if (next === 34) {
            const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands28jq__parse__quoted__ident__at(filter, i + 1 | 0);
            if (_bind$5 === undefined) {
            } else {
              const _Some = _bind$5;
              const _x = _Some;
              const _name = _x._0;
              const _end_pos = _x._1;
              _M0IPB13StringBuilderPB6Logger11write__char(out, 46);
              _M0IPB13StringBuilderPB6Logger13write__string(out, _name);
              i = _end_pos;
              continue;
            }
          } else {
            let _tmp$40;
            if (next === 91) {
              let _tmp$41;
              if ((i + 2 | 0) < filter.length) {
                const _tmp$42 = i + 2 | 0;
                $bound_check(filter, _tmp$42);
                _tmp$41 = filter.charCodeAt(_tmp$42) === 34;
              } else {
                _tmp$41 = false;
              }
              _tmp$40 = _tmp$41;
            } else {
              _tmp$40 = false;
            }
            if (_tmp$40) {
              const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands28jq__parse__quoted__ident__at(filter, i + 2 | 0);
              if (_bind$5 === undefined) {
              } else {
                const _Some = _bind$5;
                const _x = _Some;
                const _name = _x._0;
                const _end_pos = _x._1;
                let _tmp$41;
                if (_end_pos < filter.length) {
                  $bound_check(filter, _end_pos);
                  _tmp$41 = filter.charCodeAt(_end_pos) === 93;
                } else {
                  _tmp$41 = false;
                }
                if (_tmp$41) {
                  _M0IPB13StringBuilderPB6Logger11write__char(out, 46);
                  _M0IPB13StringBuilderPB6Logger13write__string(out, _name);
                  i = _end_pos + 1 | 0;
                  continue;
                }
              }
            }
          }
        }
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        i = i + 1 | 0;
      } else {
        const _Some = _bind$4;
        const _q = _Some;
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        if (ch === 92 && (i + 1 | 0) < filter.length) {
          i = i + 1 | 0;
          const _tmp$39 = i;
          $bound_check(filter, _tmp$39);
          _M0IPB13StringBuilderPB6Logger11write__char(out, filter.charCodeAt(_tmp$39));
        } else {
          if (ch === _q) {
            quote = -1;
          }
        }
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands24jq__array__contains__int(xs, target) {
  const _bind$4 = xs.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const x = xs[_];
      if (x === target) {
        return true;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib8commands22jq__emit__bool__stream(values) {
  if (values.length === 0) {
    return "empty";
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < values.length) {
      if (_M0MPC15array5Array2atGbE(values, i)) {
        _M0IPB13StringBuilderPB6Logger13write__string(out, "true");
      } else {
        _M0IPB13StringBuilderPB6Logger13write__string(out, "false");
      }
      if ((i + 1 | 0) < values.length) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 44);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands28jq__parse__positive__int__at(text, start) {
  if (start < 0 || start >= text.length) {
    return undefined;
  }
  let i = start;
  let value = 0;
  let has_digit = false;
  while (true) {
    if (i < text.length) {
      const _tmp$38 = i;
      $bound_check(text, _tmp$38);
      const ch = text.charCodeAt(_tmp$38);
      if (ch < 48 || ch > 57) {
        break;
      }
      has_digit = true;
      const digit = ch - 48 | 0;
      if (value > 214748364) {
        value = 2147483647;
      } else {
        value = (Math.imul(value, 10) | 0) + digit | 0;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return !has_digit ? undefined : { _0: value, _1: i };
}
function _M0FP410Haoxincode8moonbash3lib8commands26jq__parse__signed__int__at(text, start) {
  if (start < 0 || start >= text.length) {
    return undefined;
  }
  let i = start;
  let sign = 1;
  const _tmp$38 = i;
  $bound_check(text, _tmp$38);
  const first = text.charCodeAt(_tmp$38);
  if (first === 45) {
    sign = -1;
    i = i + 1 | 0;
  } else {
    if (first === 43) {
      i = i + 1 | 0;
    }
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands28jq__parse__positive__int__at(text, i);
  if (_bind$4 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _value = _x._0;
    const _next_pos = _x._1;
    return { _0: Math.imul(_value, sign) | 0, _1: _next_pos };
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands29jq__range__values__from__args(args) {
  const out = [];
  const start = args.length >= 1 ? (args.length === 1 ? 0 : _M0MPC15array5Array2atGiE(args, 0)) : 0;
  const end_ = args.length >= 1 ? (args.length === 1 ? _M0MPC15array5Array2atGiE(args, 0) : _M0MPC15array5Array2atGiE(args, 1)) : 0;
  const step = args.length >= 3 ? _M0MPC15array5Array2atGiE(args, 2) : 1;
  if (step === 0) {
    return out;
  }
  let current = start;
  if (step > 0) {
    while (true) {
      if (current < end_) {
        _M0MPC15array5Array4pushGiE(out, current);
        current = current + step | 0;
        continue;
      } else {
        break;
      }
    }
  } else {
    while (true) {
      if (current > end_) {
        _M0MPC15array5Array4pushGiE(out, current);
        current = current + step | 0;
        continue;
      } else {
        break;
      }
    }
  }
  return out;
}
function _M0FP410Haoxincode8moonbash3lib8commands26jq__parse__range__call__at(text, pos) {
  if (!_M0FP410Haoxincode8moonbash3lib8commands20jq__starts__with__at(text, pos, "range(")) {
    return undefined;
  }
  const args = [];
  let i = pos + 6 | 0;
  while (true) {
    if (i < text.length) {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands26jq__parse__signed__int__at(text, i);
      if (_bind$4 === undefined) {
        return undefined;
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        const _value = _x._0;
        const _next_pos = _x._1;
        _M0MPC15array5Array4pushGiE(args, _value);
        i = _next_pos;
      }
      if (i >= text.length) {
        return undefined;
      }
      const _tmp$38 = i;
      $bound_check(text, _tmp$38);
      const ch = text.charCodeAt(_tmp$38);
      if (ch === 59) {
        i = i + 1 | 0;
        continue;
      }
      if (ch === 41) {
        i = i + 1 | 0;
        break;
      }
      return undefined;
    } else {
      break;
    }
  }
  if (args.length === 0 || args.length > 3) {
    return undefined;
  }
  return { _0: _M0FP410Haoxincode8moonbash3lib8commands29jq__range__values__from__args(args), _1: i };
}
function _M0FP410Haoxincode8moonbash3lib8commands18jq__strip__all__ws(text) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < text.length) {
      $bound_check(text, i);
      const ch = text.charCodeAt(i);
      if (!_M0FP410Haoxincode8moonbash3lib8commands10jq__is__ws(ch)) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands30jq__rewrite__static__in__cases(filter) {
  const normalized = _M0FP410Haoxincode8moonbash3lib8commands18jq__strip__all__ws(filter);
  if (normalized === "\"-1\"|IN(builtins[]/\"/\"|.[1])") {
    return "false";
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands26jq__parse__range__call__at(normalized, 0);
  if (_bind$4 === undefined) {
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _left_values = _x._0;
    const _left_end = _x._1;
    if ((_left_end + 4 | 0) < normalized.length && _M0FP410Haoxincode8moonbash3lib8commands20jq__starts__with__at(normalized, _left_end, "|IN(")) {
      const right_start = _left_end + 4 | 0;
      const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands26jq__parse__range__call__at(normalized, right_start);
      if (_bind$5 === undefined) {
      } else {
        const _Some$2 = _bind$5;
        const _x$2 = _Some$2;
        const _right_values = _x$2._0;
        const _right_end = _x$2._1;
        let _tmp$38;
        if (_right_end < normalized.length) {
          let _tmp$39;
          $bound_check(normalized, _right_end);
          if (normalized.charCodeAt(_right_end) === 41) {
            _tmp$39 = (_right_end + 1 | 0) === normalized.length;
          } else {
            _tmp$39 = false;
          }
          _tmp$38 = _tmp$39;
        } else {
          _tmp$38 = false;
        }
        if (_tmp$38) {
          const matches = [];
          const _bind$6 = _left_values.length;
          let _tmp$39 = 0;
          while (true) {
            const _ = _tmp$39;
            if (_ < _bind$6) {
              const value = _left_values[_];
              _M0MPC15array5Array4pushGbE(matches, _M0FP410Haoxincode8moonbash3lib8commands24jq__array__contains__int(_right_values, value));
              _tmp$39 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          return _M0FP410Haoxincode8moonbash3lib8commands22jq__emit__bool__stream(matches);
        }
      }
    }
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands20jq__starts__with__at(normalized, 0, "IN(")) {
    const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands26jq__parse__range__call__at(normalized, 3);
    if (_bind$5 === undefined) {
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      const _left_values = _x._0;
      const _left_end = _x._1;
      let _tmp$38;
      if (_left_end < normalized.length) {
        $bound_check(normalized, _left_end);
        _tmp$38 = normalized.charCodeAt(_left_end) === 59;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        const _bind$6 = _M0FP410Haoxincode8moonbash3lib8commands26jq__parse__range__call__at(normalized, _left_end + 1 | 0);
        if (_bind$6 === undefined) {
        } else {
          const _Some$2 = _bind$6;
          const _x$2 = _Some$2;
          const _right_values = _x$2._0;
          const _right_end = _x$2._1;
          let _tmp$39;
          if (_right_end < normalized.length) {
            let _tmp$40;
            $bound_check(normalized, _right_end);
            if (normalized.charCodeAt(_right_end) === 41) {
              _tmp$40 = (_right_end + 1 | 0) === normalized.length;
            } else {
              _tmp$40 = false;
            }
            _tmp$39 = _tmp$40;
          } else {
            _tmp$39 = false;
          }
          if (_tmp$39) {
            let has_match = false;
            const _bind$7 = _left_values.length;
            let _tmp$40 = 0;
            while (true) {
              const _ = _tmp$40;
              if (_ < _bind$7) {
                const value = _left_values[_];
                if (_M0FP410Haoxincode8moonbash3lib8commands24jq__array__contains__int(_right_values, value)) {
                  has_match = true;
                  break;
                }
                _tmp$40 = _ + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            return has_match ? "true" : "false";
          }
        }
      }
    }
  }
  return filter;
}
function _M0FP410Haoxincode8moonbash3lib8commands30jq__parse__query__with__compat(filter) {
  const normalized_filter = _M0FP410Haoxincode8moonbash3lib8commands32jq__rewrite__binary__plus__minus(_M0FP410Haoxincode8moonbash3lib8commands36jq__rewrite__compat__function__calls(_M0FP410Haoxincode8moonbash3lib8commands35jq__rewrite__quoted__member__access(_M0FP410Haoxincode8moonbash3lib8commands26jq__rewrite__keys__builtin(filter))));
  const compat_filter = _M0FP410Haoxincode8moonbash3lib8commands30jq__rewrite__static__in__cases(normalized_filter);
  const filter_with_prelude = `${_M0FP410Haoxincode8moonbash3lib8commands30jq__parse__query__with__compatN15compat__preludeS2675}${compat_filter}`;
  let first;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP28bobzhang6moonjq5parse(filter_with_prelude);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        first = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    first = undefined;
  }
  if (first === undefined) {
    const compat_filter$2 = _M0FP410Haoxincode8moonbash3lib8commands34jq__normalize__def__param__dollars(filter_with_prelude);
    if (compat_filter$2 === filter_with_prelude) {
      return { _0: undefined, _1: "jq: invalid filter\n" };
    }
    let second;
    let _try_err$2;
    _L$2: {
      _L$3: {
        const _bind$4 = _M0FP28bobzhang6moonjq5parse(compat_filter$2);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          second = _ok._0;
        } else {
          const _err = _bind$4;
          _try_err$2 = _err._0;
          break _L$3;
        }
        break _L$2;
      }
      second = undefined;
    }
    if (second === undefined) {
      return { _0: undefined, _1: "jq: invalid filter\n" };
    } else {
      const _Some = second;
      const _query = _Some;
      return { _0: _query, _1: "" };
    }
  } else {
    const _Some = first;
    const _query = _Some;
    return { _0: _query, _1: "" };
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands34jq__parse__simple__repeat__literal(expr) {
  if (expr.length < 3) {
    return undefined;
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands20jq__starts__with__at(expr, 0, ".*")) {
    _L: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands28jq__parse__positive__int__at(expr, 2);
      if (_bind$4 === undefined) {
        break _L;
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        const _count = _x._0;
        const _pos = _x._1;
        if (_pos === expr.length) {
          return _count;
        } else {
          break _L;
        }
      }
    }
    return undefined;
  } else {
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands28jq__parse__positive__int__at(expr, 0);
    if (_bind$4 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _count = _x._0;
      const _pos = _x._1;
      return (_pos + 2 | 0) === expr.length && _M0FP410Haoxincode8moonbash3lib8commands20jq__starts__with__at(expr, _pos, "*.") ? _count : undefined;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands35jq__extract__repeat__literal__count(filter) {
  const normalized = _M0FP410Haoxincode8moonbash3lib8commands18jq__strip__all__ws(filter);
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands34jq__parse__simple__repeat__literal(normalized);
  if (_bind$4 === undefined) {
    if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(normalized, "try(") && (_M0FP410Haoxincode8moonbash3lib8commands14aj__ends__with(normalized, ")catch.") && normalized.length > 11)) {
      const inner = _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(normalized, 4, normalized.length - 7 | 0);
      return _M0FP410Haoxincode8moonbash3lib8commands34jq__parse__simple__repeat__literal(inner);
    } else {
      return undefined;
    }
  } else {
    const _Some = _bind$4;
    const _count = _Some;
    return _count;
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands29jq__repeat__result__too__long(filter, inputs) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands35jq__extract__repeat__literal__count(filter);
  let count;
  if (_bind$4 === undefined) {
    return false;
  } else {
    const _Some = _bind$4;
    count = _Some;
  }
  if (count <= 0) {
    return false;
  }
  const _bind$5 = inputs.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const input = inputs[_];
      _L: {
        if (input.$tag === 4) {
          const _String = input;
          const _s = _String._0;
          if (_s.length === 0) {
            break _L;
          }
          if (count > (10485760 / _s.length | 0)) {
            return true;
          }
        }
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib8commands14jq__strip__bom(text) {
  let _tmp$38;
  if (text.length > 0) {
    $bound_check(text, 0);
    _tmp$38 = text.charCodeAt(0) === 65279;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    return _M0FP410Haoxincode8moonbash3lib8commands10aj__substr(text, 1, text.length);
  } else {
    return text;
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands7cmd__jq(ctx) {
  let compact = false;
  let raw = false;
  let null_input = false;
  let slurp = false;
  let filter = undefined;
  let input_file = undefined;
  let i = 0;
  while (true) {
    if (i < ctx.args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(ctx.args, i);
      if (_M0FP410Haoxincode8moonbash3lib8commands16aj__starts__with(arg, "-")) {
        const _bind$4 = filter;
        if (_bind$4 === undefined) {
          let _tmp$38 = 1;
          while (true) {
            const j = _tmp$38;
            if (j < arg.length) {
              $bound_check(arg, j);
              const flag = arg.charCodeAt(j);
              switch (flag) {
                case 99: {
                  compact = true;
                  break;
                }
                case 114: {
                  raw = true;
                  break;
                }
                case 110: {
                  null_input = true;
                  break;
                }
                case 115: {
                  slurp = true;
                  break;
                }
              }
              _tmp$38 = j + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          i = i + 1 | 0;
          continue;
        }
      }
      const _bind$4 = filter;
      if (_bind$4 === undefined) {
        filter = arg;
      } else {
        const _bind$5 = input_file;
        if (_bind$5 === undefined) {
          input_file = arg;
        }
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$4 = filter;
  let jq_filter;
  if (_bind$4 === undefined) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("jq: missing filter\n");
  } else {
    const _Some = _bind$4;
    jq_filter = _Some;
  }
  const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands30jq__parse__query__with__compat(jq_filter);
  const _query_opt = _bind$5._0;
  const _parse_err = _bind$5._1;
  let inputs;
  if (null_input) {
    inputs = [_M0DTPB4Json4Null__];
  } else {
    const _bind$6 = input_file;
    let raw_source;
    if (_bind$6 === undefined) {
      raw_source = ctx.stdin_content;
    } else {
      const _Some = _bind$6;
      const _path = _Some;
      let resolved;
      let _try_err;
      _L: {
        _L$2: {
          const _bind$7 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, _path);
          if (_bind$7.$tag === 1) {
            const _ok = _bind$7;
            resolved = _ok._0;
          } else {
            const _err = _bind$7;
            _try_err = _err._0;
            break _L$2;
          }
          break _L;
        }
        const _FsError = _try_err;
        const _msg = _FsError._0;
        return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`jq: ${_msg}\n`);
      }
      let _try_err$2;
      _L$2: {
        _L$3: {
          const _bind$7 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, resolved);
          if (_bind$7.$tag === 1) {
            const _ok = _bind$7;
            raw_source = _ok._0;
          } else {
            const _err = _bind$7;
            _try_err$2 = _err._0;
            break _L$3;
          }
          break _L$2;
        }
        const _FsError = _try_err$2;
        const _msg = _FsError._0;
        return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`jq: ${_msg}\n`);
      }
    }
    const source = _M0FP410Haoxincode8moonbash3lib8commands14jq__strip__bom(raw_source);
    const trimmed = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(source);
    if (slurp) {
      if (trimmed.length === 0) {
        const _p$4 = [];
        inputs = [new _M0DTPB4Json5Array(_p$4)];
      } else {
        let single;
        let _try_err;
        _L: {
          _L$2: {
            const _bind$7 = _M0FPC14json13parse_2einner(new _M0TPC16string10StringView(trimmed, 0, trimmed.length), 1024);
            if (_bind$7.$tag === 1) {
              const _ok = _bind$7;
              single = _ok._0;
            } else {
              const _err = _bind$7;
              _try_err = _err._0;
              break _L$2;
            }
            break _L;
          }
          single = undefined;
        }
        if (single === undefined) {
          const lines = _M0FP410Haoxincode8moonbash3lib8commands25aj__split__lines__records(source);
          const arr = [];
          const _bind$7 = lines.length;
          let _tmp$38 = 0;
          while (true) {
            const _ = _tmp$38;
            if (_ < _bind$7) {
              const line = lines[_];
              _L$2: {
                const t = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(line);
                if (t.length === 0) {
                  break _L$2;
                }
                let parsed;
                let _try_err$2;
                _L$3: {
                  _L$4: {
                    const _bind$8 = _M0FPC14json13parse_2einner(new _M0TPC16string10StringView(t, 0, t.length), 1024);
                    if (_bind$8.$tag === 1) {
                      const _ok = _bind$8;
                      parsed = _ok._0;
                    } else {
                      const _err = _bind$8;
                      _try_err$2 = _err._0;
                      break _L$4;
                    }
                    break _L$3;
                  }
                  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("jq: invalid JSON input\n");
                }
                _M0MPC15array5Array4pushGUssEE(arr, parsed);
                break _L$2;
              }
              _tmp$38 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          inputs = [new _M0DTPB4Json5Array(arr)];
        } else {
          const _Some = single;
          const _value = _Some;
          const _p$4 = [_value];
          inputs = [new _M0DTPB4Json5Array(_p$4)];
        }
      }
    } else {
      if (trimmed.length === 0) {
        inputs = [_M0DTPB4Json4Null__];
      } else {
        let single;
        let _try_err;
        _L: {
          _L$2: {
            const _bind$7 = _M0FPC14json13parse_2einner(new _M0TPC16string10StringView(trimmed, 0, trimmed.length), 1024);
            if (_bind$7.$tag === 1) {
              const _ok = _bind$7;
              single = _ok._0;
            } else {
              const _err = _bind$7;
              _try_err = _err._0;
              break _L$2;
            }
            break _L;
          }
          single = undefined;
        }
        if (single === undefined) {
          const lines = _M0FP410Haoxincode8moonbash3lib8commands25aj__split__lines__records(source);
          const parsed_lines = [];
          const _bind$7 = lines.length;
          let _tmp$38 = 0;
          while (true) {
            const _ = _tmp$38;
            if (_ < _bind$7) {
              const line = lines[_];
              _L$2: {
                const t = _M0FP410Haoxincode8moonbash3lib8commands8aj__trim(line);
                if (t.length === 0) {
                  break _L$2;
                }
                let parsed;
                let _try_err$2;
                _L$3: {
                  _L$4: {
                    const _bind$8 = _M0FPC14json13parse_2einner(new _M0TPC16string10StringView(t, 0, t.length), 1024);
                    if (_bind$8.$tag === 1) {
                      const _ok = _bind$8;
                      parsed = _ok._0;
                    } else {
                      const _err = _bind$8;
                      _try_err$2 = _err._0;
                      break _L$4;
                    }
                    break _L$3;
                  }
                  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("jq: invalid JSON input\n");
                }
                _M0MPC15array5Array4pushGUssEE(parsed_lines, parsed);
                break _L$2;
              }
              _tmp$38 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          inputs = parsed_lines.length === 0 ? [_M0DTPB4Json4Null__] : parsed_lines;
        } else {
          const _Some = single;
          const _value = _Some;
          inputs = [_value];
        }
      }
    }
  }
  if (_M0FP410Haoxincode8moonbash3lib8commands29jq__repeat__result__too__long(jq_filter, inputs)) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("jq: EvalError(\"Repeat string result too long\")\n");
  }
  if (_query_opt === undefined) {
    const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
    const _bind$6 = inputs.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$6) {
        const input = inputs[_];
        const _bind$7 = _M0FP410Haoxincode8moonbash3lib8commands26jq__manual__compat__values(jq_filter, input);
        if (_bind$7.$tag === 1) {
          const _Some = _bind$7;
          const _values = _Some._0;
          const _bind$8 = _values.length;
          let _tmp$39 = 0;
          while (true) {
            const _$2 = _tmp$39;
            if (_$2 < _bind$8) {
              const value = _values[_$2];
              if (raw) {
                if (value.$tag === 4) {
                  const _String = value;
                  const _s = _String._0;
                  _M0IPB13StringBuilderPB6Logger13write__string(out, _s);
                } else {
                  _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC14json4Json17stringify_2einner(value, false, compact ? 0 : 2, undefined));
                }
              } else {
                _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC14json4Json17stringify_2einner(value, false, compact ? 0 : 2, undefined));
              }
              _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
              _tmp$39 = _$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
        } else {
          return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(_parse_err);
        }
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(out.val);
  }
  let query;
  if (_query_opt === undefined) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(_parse_err);
  } else {
    const _Some = _query_opt;
    query = _Some;
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _bind$6 = inputs.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$6) {
      const input = inputs[_];
      const _bind$7 = _M0FP410Haoxincode8moonbash3lib8commands26jq__manual__compat__values(jq_filter, input);
      let values;
      if (_bind$7.$tag === 1) {
        const _Some = _bind$7;
        values = _Some._0;
      } else {
        let _try_err;
        _L: {
          _L$2: {
            const _bind$8 = _M0FP28bobzhang6moonjq9run__json(query, input);
            if (_bind$8.$tag === 1) {
              const _ok = _bind$8;
              values = _ok._0;
            } else {
              const _err = _bind$8;
              _try_err = _err._0;
              break _L$2;
            }
            break _L;
          }
          const _bind$8 = _M0FP410Haoxincode8moonbash3lib8commands26jq__manual__compat__values(jq_filter, input);
          if (_bind$8.$tag === 1) {
            const _Some = _bind$8;
            values = _Some._0;
          } else {
            return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`jq: ${_M0IPC15error5ErrorPB4Show10to__string(_try_err)}\n`);
          }
        }
      }
      const _bind$8 = values.length;
      let _tmp$39 = 0;
      while (true) {
        const _$2 = _tmp$39;
        if (_$2 < _bind$8) {
          const value = values[_$2];
          if (raw) {
            if (value.$tag === 4) {
              const _String = value;
              const _s = _String._0;
              _M0IPB13StringBuilderPB6Logger13write__string(out, _s);
            } else {
              _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC14json4Json17stringify_2einner(value, false, compact ? 0 : 2, undefined));
            }
          } else {
            _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC14json4Json17stringify_2einner(value, false, compact ? 0 : 2, undefined));
          }
          _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
          _tmp$39 = _$2 + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(out.val);
}
function _M0FP410Haoxincode8moonbash3lib8commands7cmd__ln(ctx) {
  let symbolic = false;
  let force = false;
  const args = [];
  const _bind$4 = ctx.args;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const arg = _bind$4[_];
      _L: {
        _L$2: {
          switch (arg) {
            case "-s": {
              symbolic = true;
              break;
            }
            case "-f": {
              force = true;
              break;
            }
            case "-sf": {
              break _L$2;
            }
            case "-fs": {
              break _L$2;
            }
            default: {
              _M0MPC15array5Array4pushGUssEE(args, arg);
            }
          }
          break _L;
        }
        symbolic = true;
        force = true;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (!symbolic) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("ln: hard links not supported in sandbox\n");
  }
  if (args.length < 2) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("ln: missing operand\n");
  }
  const target = _M0MPC15array5Array2atGUssEE(args, 0);
  const link_name = _M0MPC15array5Array2atGUssEE(args, 1);
  let link_resolved;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, link_name);
      if (_bind$6.$tag === 1) {
        const _ok = _bind$6;
        link_resolved = _ok._0;
      } else {
        const _err = _bind$6;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    const _FsError = _try_err;
    const _msg = _FsError._0;
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`ln: ${_msg}\n`);
  }
  if (force) {
    let _try_err$2;
    _L$2: {
      _L$3: {
        const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10rm_2einner(ctx.fs, link_resolved, false, true);
        if (_bind$6.$tag === 1) {
          const _ok = _bind$6;
          _ok._0;
        } else {
          const _err = _bind$6;
          _try_err$2 = _err._0;
          break _L$3;
        }
        break _L$2;
      }
    }
  }
  let _try_err$2;
  _L$2: {
    _L$3: {
      const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs7symlink(ctx.fs, target, link_resolved);
      if (_bind$6.$tag === 1) {
        const _ok = _bind$6;
        _ok._0;
      } else {
        const _err = _bind$6;
        _try_err$2 = _err._0;
        break _L$3;
      }
      break _L$2;
    }
    const _FsError = _try_err$2;
    const _msg = _FsError._0;
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`ln: ${_msg}\n`);
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", "", 0);
}
function _M0FP410Haoxincode8moonbash3lib8commands23cmd__ls__display__label(raw, abs_path) {
  if (raw === "." || raw.length === 0) {
    return ".";
  } else {
    if (raw === "/") {
      return "/";
    } else {
      $bound_check(raw, 0);
      const _p$4 = raw.charCodeAt(0);
      const _p$5 = 47;
      if (_p$4 === _p$5) {
        return abs_path;
      } else {
        return _M0FP410Haoxincode8moonbash3lib8commands34cmd__find__trim__trailing__slashes(raw);
      }
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands20cmd__ls__entry__size(fs, abs_path) {
  const _bind$4 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(fs.entries, abs_path);
  if (_bind$4 === undefined) {
    return 0;
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    switch (_x.$tag) {
      case 0: {
        const _File = _x;
        const _file = _File._0;
        return _file.content.length;
      }
      case 1: {
        return 4096;
      }
      default: {
        const _Symlink = _x;
        const _link = _Symlink._0;
        return _link.target.length;
      }
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands22cmd__ls__format__human(size, unit, suffix) {
  const whole = size / unit | 0;
  const rem = size % unit | 0;
  if (whole < 10) {
    const tenth = (Math.imul(rem, 10) | 0) / unit | 0;
    return `${_M0MPC13int3Int18to__string_2einner(whole, 10)}.${_M0MPC13int3Int18to__string_2einner(tenth, 10)}${suffix}`;
  } else {
    return `${_M0MPC13int3Int18to__string_2einner(whole, 10)}${suffix}`;
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands21cmd__ls__format__size(size, human_readable) {
  if (!human_readable) {
    return _M0MPC13int3Int18to__string_2einner(size, 10);
  }
  return size >= 1073741824 ? _M0FP410Haoxincode8moonbash3lib8commands22cmd__ls__format__human(size, 1073741824, "G") : size >= 1048576 ? _M0FP410Haoxincode8moonbash3lib8commands22cmd__ls__format__human(size, 1048576, "M") : size >= 1024 ? _M0FP410Haoxincode8moonbash3lib8commands22cmd__ls__format__human(size, 1024, "K") : _M0MPC13int3Int18to__string_2einner(size, 10);
}
function _M0FP410Haoxincode8moonbash3lib8commands22cmd__ls__read__entries(fs, dir_abs, show_all, almost_all, reverse, sort_size) {
  let entries;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs7readdir(fs, dir_abs);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        entries = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    return [];
  }
  const names = [];
  if (show_all) {
    _M0MPC15array5Array4pushGUssEE(names, _M0FP410Haoxincode8moonbash3lib8commands22cmd__ls__read__entriesN5tupleS9248);
    _M0MPC15array5Array4pushGUssEE(names, _M0FP410Haoxincode8moonbash3lib8commands22cmd__ls__read__entriesN5tupleS9249);
  }
  const _bind$4 = entries.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const entry = entries[_];
      const name = entry.name;
      let _tmp$39;
      if (show_all) {
        _tmp$39 = true;
      } else {
        let _tmp$40;
        if (almost_all) {
          _tmp$40 = true;
        } else {
          let _tmp$41;
          if (name.length > 0) {
            $bound_check(name, 0);
            const _p$4 = name.charCodeAt(0);
            const _p$5 = 46;
            _tmp$41 = _p$4 === _p$5;
          } else {
            _tmp$41 = false;
          }
          _tmp$40 = !_tmp$41;
        }
        _tmp$39 = _tmp$40;
      }
      if (_tmp$39) {
        const child_abs = dir_abs === "/" ? `/${name}` : `${dir_abs}/${name}`;
        _M0MPC15array5Array4pushGUssEE(names, { _0: name, _1: _M0FP410Haoxincode8moonbash3lib8commands20cmd__ls__entry__size(fs, child_abs) });
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MPC15array5Array8sort__byGUssEE(names, (a, b) => sort_size ? (a._1 > b._1 ? -1 : a._1 < b._1 ? 1 : _M0FP410Haoxincode8moonbash3lib8commands25cmd__find__compare__ascii(a._0, b._0)) : _M0FP410Haoxincode8moonbash3lib8commands25cmd__find__compare__ascii(a._0, b._0));
  if (reverse) {
    let l = 0;
    let r = names.length - 1 | 0;
    while (true) {
      if (l < r) {
        const tmp = _M0MPC15array5Array2atGUssEE(names, l);
        _M0MPC15array5Array3setGsE(names, l, _M0MPC15array5Array2atGUssEE(names, r));
        _M0MPC15array5Array3setGsE(names, r, tmp);
        l = l + 1 | 0;
        r = r - 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  return names;
}
function _M0FP410Haoxincode8moonbash3lib8commands20cmd__ls__write__long(out, entries, human_readable) {
  const _bind$4 = entries.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const entry = entries[_];
      _M0IPB13StringBuilderPB6Logger13write__string(out, `${_M0FP410Haoxincode8moonbash3lib8commands21cmd__ls__format__size(entry._1, human_readable)} ${entry._0}\n`);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands21cmd__ls__write__names(out, names, one_per_line) {
  if (one_per_line) {
    const _bind$4 = names.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$4) {
        const name = names[_];
        _M0IPB13StringBuilderPB6Logger13write__string(out, `${name}\n`);
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return undefined;
  }
  let first = true;
  const _bind$4 = names.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const name = names[_];
      if (!first) {
        _M0IPB13StringBuilderPB6Logger13write__string(out, "  ");
      }
      _M0IPB13StringBuilderPB6Logger13write__string(out, name);
      first = false;
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (names.length > 0) {
    _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
    return;
  } else {
    return;
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands24cmd__ls__list__recursive(fs, dir_abs, label, show_all, almost_all, reverse, sort_size, one_per_line, long_format, human_readable, out) {
  _M0IPB13StringBuilderPB6Logger13write__string(out, `${label}:\n`);
  const entries = _M0FP410Haoxincode8moonbash3lib8commands22cmd__ls__read__entries(fs, dir_abs, show_all, almost_all, reverse, sort_size);
  if (long_format) {
    _M0FP410Haoxincode8moonbash3lib8commands20cmd__ls__write__long(out, entries, human_readable);
  } else {
    const names = [];
    const _bind$4 = entries.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$4) {
        const entry = entries[_];
        _M0MPC15array5Array4pushGUssEE(names, entry._0);
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    _M0FP410Haoxincode8moonbash3lib8commands21cmd__ls__write__names(out, names, one_per_line);
  }
  const subdirs = [];
  let entries$2;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs7readdir(fs, dir_abs);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        entries$2 = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    return undefined;
  }
  const child_names = [];
  const _bind$4 = entries$2.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const entry = entries$2[_];
      _L$2: {
        const _bind$5 = entry.entry_type;
        if (_bind$5 === 1) {
          const name = entry.name;
          let _tmp$39;
          if (!show_all) {
            let _tmp$40;
            if (!almost_all) {
              let _tmp$41;
              if (name.length > 0) {
                $bound_check(name, 0);
                const _p$4 = name.charCodeAt(0);
                const _p$5 = 46;
                _tmp$41 = _p$4 === _p$5;
              } else {
                _tmp$41 = false;
              }
              _tmp$40 = _tmp$41;
            } else {
              _tmp$40 = false;
            }
            _tmp$39 = _tmp$40;
          } else {
            _tmp$39 = false;
          }
          if (_tmp$39) {
            break _L$2;
          }
          _M0MPC15array5Array4pushGUssEE(child_names, name);
        }
        break _L$2;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MPC15array5Array8sort__byGUssEE(child_names, (a, b) => {
    if (sort_size) {
      const a_abs = dir_abs === "/" ? `/${a}` : `${dir_abs}/${a}`;
      const b_abs = dir_abs === "/" ? `/${b}` : `${dir_abs}/${b}`;
      const a_size = _M0FP410Haoxincode8moonbash3lib8commands20cmd__ls__entry__size(fs, a_abs);
      const b_size = _M0FP410Haoxincode8moonbash3lib8commands20cmd__ls__entry__size(fs, b_abs);
      return a_size > b_size ? -1 : a_size < b_size ? 1 : _M0FP410Haoxincode8moonbash3lib8commands25cmd__find__compare__ascii(a, b);
    } else {
      return _M0FP410Haoxincode8moonbash3lib8commands25cmd__find__compare__ascii(a, b);
    }
  });
  if (reverse) {
    let l = 0;
    let r = child_names.length - 1 | 0;
    while (true) {
      if (l < r) {
        const tmp = _M0MPC15array5Array2atGUssEE(child_names, l);
        _M0MPC15array5Array3setGsE(child_names, l, _M0MPC15array5Array2atGUssEE(child_names, r));
        _M0MPC15array5Array3setGsE(child_names, r, tmp);
        l = l + 1 | 0;
        r = r - 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  const _bind$5 = child_names.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$5) {
      const name = child_names[_];
      const child_abs = dir_abs === "/" ? `/${name}` : `${dir_abs}/${name}`;
      const child_label = label === "." ? `./${name}` : label === "/" ? `/${name}` : `${label}/${name}`;
      _M0MPC15array5Array4pushGUssEE(subdirs, { _0: child_abs, _1: child_label });
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let _tmp$40 = 0;
  while (true) {
    const i = _tmp$40;
    if (i < subdirs.length) {
      _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
      _M0FP410Haoxincode8moonbash3lib8commands24cmd__ls__list__recursive(fs, _M0MPC15array5Array2atGUssEE(subdirs, i)._0, _M0MPC15array5Array2atGUssEE(subdirs, i)._1, show_all, almost_all, reverse, sort_size, one_per_line, long_format, human_readable, out);
      _tmp$40 = i + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands7cmd__ls(ctx) {
  let show_all = false;
  let almost_all = false;
  let recursive = false;
  let reverse = false;
  let long_format = false;
  let human_readable = false;
  let sort_size = false;
  let one_per_line = true;
  const paths = [];
  const _bind$4 = ctx.args;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const arg = _bind$4[_];
      let _tmp$39;
      if (arg.length > 1) {
        let _tmp$40;
        $bound_check(arg, 0);
        const _p$4 = arg.charCodeAt(0);
        const _p$5 = 45;
        if (_p$4 === _p$5) {
          const _p$6 = "--";
          _tmp$40 = !(arg === _p$6);
        } else {
          _tmp$40 = false;
        }
        _tmp$39 = _tmp$40;
      } else {
        _tmp$39 = false;
      }
      if (_tmp$39) {
        let valid_flags = true;
        let _tmp$40 = 1;
        _L: while (true) {
          const i = _tmp$40;
          if (i < arg.length) {
            $bound_check(arg, i);
            const flag = arg.charCodeAt(i);
            switch (flag) {
              case 97: {
                show_all = true;
                almost_all = false;
                break;
              }
              case 65: {
                if (!show_all) {
                  almost_all = true;
                }
                break;
              }
              case 82: {
                recursive = true;
                break;
              }
              case 114: {
                reverse = true;
                break;
              }
              case 49: {
                one_per_line = true;
                break;
              }
              case 108: {
                long_format = true;
                break;
              }
              case 104: {
                human_readable = true;
                break;
              }
              case 83: {
                sort_size = true;
                break;
              }
              default: {
                valid_flags = false;
                break _L;
              }
            }
            _tmp$40 = i + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        if (!valid_flags) {
          _M0MPC15array5Array4pushGUssEE(paths, arg);
        }
      } else {
        _M0MPC15array5Array4pushGUssEE(paths, arg);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (paths.length === 0) {
    _M0MPC15array5Array4pushGUssEE(paths, ".");
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const errbuf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let exit_code = 0;
  const files = [];
  const dirs = [];
  const _bind$6 = paths.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$6) {
      const raw = paths[_];
      _L: {
        let resolved;
        let _try_err;
        _L$2: {
          _L$3: {
            const _bind$7 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, raw);
            if (_bind$7.$tag === 1) {
              const _ok = _bind$7;
              resolved = _ok._0;
            } else {
              const _err = _bind$7;
              _try_err = _err._0;
              break _L$3;
            }
            break _L$2;
          }
          const _FsError = _try_err;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `ls: ${_msg}\n`);
          exit_code = 1;
          break _L;
        }
        let stat;
        let _try_err$2;
        _L$3: {
          _L$4: {
            const _bind$7 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs4stat(ctx.fs, resolved);
            if (_bind$7.$tag === 1) {
              const _ok = _bind$7;
              stat = _ok._0;
            } else {
              const _err = _bind$7;
              _try_err$2 = _err._0;
              break _L$4;
            }
            break _L$3;
          }
          const _FsError = _try_err$2;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `ls: ${_msg}\n`);
          exit_code = 1;
          break _L;
        }
        if (stat.is_directory) {
          _M0MPC15array5Array4pushGUssEE(dirs, { _0: raw, _1: resolved });
        } else {
          _M0MPC15array5Array4pushGUssEE(files, { _0: raw, _1: resolved });
        }
        break _L;
      }
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$7 = files.length;
  let _tmp$40 = 0;
  while (true) {
    const _ = _tmp$40;
    if (_ < _bind$7) {
      const file = files[_];
      if (long_format) {
        const size = _M0FP410Haoxincode8moonbash3lib8commands20cmd__ls__entry__size(ctx.fs, file._1);
        const label = file._0.length === 0 ? file._1 : file._0;
        _M0IPB13StringBuilderPB6Logger13write__string(out, `${_M0FP410Haoxincode8moonbash3lib8commands21cmd__ls__format__size(size, human_readable)} ${label}\n`);
      } else {
        _M0IPB13StringBuilderPB6Logger13write__string(out, `${file._0}\n`);
      }
      _tmp$40 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (files.length > 0 && dirs.length > 0) {
    _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
  }
  const show_headers = (files.length + dirs.length | 0) > 1;
  let _tmp$41 = 0;
  while (true) {
    const idx = _tmp$41;
    if (idx < dirs.length) {
      const _bind$8 = _M0MPC15array5Array2atGUssEE(dirs, idx);
      const _label_raw = _bind$8._0;
      const _abs_path = _bind$8._1;
      const label = _M0FP410Haoxincode8moonbash3lib8commands23cmd__ls__display__label(_label_raw, _abs_path);
      if (recursive) {
        _M0FP410Haoxincode8moonbash3lib8commands24cmd__ls__list__recursive(ctx.fs, _abs_path, label, show_all, almost_all, reverse, sort_size, one_per_line, long_format, human_readable, out);
      } else {
        if (show_headers) {
          _M0IPB13StringBuilderPB6Logger13write__string(out, `${label}:\n`);
        }
        const entries = _M0FP410Haoxincode8moonbash3lib8commands22cmd__ls__read__entries(ctx.fs, _abs_path, show_all, almost_all, reverse, sort_size);
        if (long_format) {
          _M0FP410Haoxincode8moonbash3lib8commands20cmd__ls__write__long(out, entries, human_readable);
        } else {
          const names = [];
          const _bind$9 = entries.length;
          let _tmp$42 = 0;
          while (true) {
            const _ = _tmp$42;
            if (_ < _bind$9) {
              const entry = entries[_];
              _M0MPC15array5Array4pushGUssEE(names, entry._0);
              _tmp$42 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          _M0FP410Haoxincode8moonbash3lib8commands21cmd__ls__write__names(out, names, one_per_line);
        }
      }
      if ((idx + 1 | 0) < dirs.length) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
      }
      _tmp$41 = idx + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(out.val, errbuf.val, exit_code);
}
function _M0FP410Haoxincode8moonbash3lib8commands12compute__md5(input) {
  const digest = _M0MP27gmlewis3md56Digest3new();
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < input.length) {
      $bound_check(input, i);
      _M0IP27gmlewis3md56DigestP27gmlewis3md58HashFunc5write(digest, input.charCodeAt(i) & 255);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0IP27gmlewis3md56DigestP27gmlewis3md58HashFunc10check__sum(digest);
}
function _M0FP410Haoxincode8moonbash3lib8commands24hash__parse__check__line(line) {
  let i = 0;
  while (true) {
    let _tmp$38;
    if (i < line.length) {
      let _tmp$39;
      const _tmp$40 = i;
      $bound_check(line, _tmp$40);
      const _p$4 = line.charCodeAt(_tmp$40);
      const _p$5 = 32;
      if (_p$4 !== _p$5) {
        const _tmp$41 = i;
        $bound_check(line, _tmp$41);
        const _p$6 = line.charCodeAt(_tmp$41);
        const _p$7 = 9;
        _tmp$39 = _p$6 !== _p$7;
      } else {
        _tmp$39 = false;
      }
      _tmp$38 = _tmp$39;
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (i === 0 || i >= line.length) {
    return undefined;
  }
  const hash = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(line, 0, i));
  while (true) {
    let _tmp$38;
    if (i < line.length) {
      let _tmp$39;
      const _tmp$40 = i;
      $bound_check(line, _tmp$40);
      const _p$4 = line.charCodeAt(_tmp$40);
      const _p$5 = 32;
      if (_p$4 === _p$5) {
        _tmp$39 = true;
      } else {
        let _tmp$41;
        const _tmp$42 = i;
        $bound_check(line, _tmp$42);
        const _p$6 = line.charCodeAt(_tmp$42);
        const _p$7 = 9;
        if (_p$6 === _p$7) {
          _tmp$41 = true;
        } else {
          const _tmp$43 = i;
          $bound_check(line, _tmp$43);
          const _p$8 = line.charCodeAt(_tmp$43);
          const _p$9 = 42;
          _tmp$41 = _p$8 === _p$9;
        }
        _tmp$39 = _tmp$41;
      }
      _tmp$38 = _tmp$39;
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (i >= line.length) {
    return undefined;
  }
  const filename = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(line, i, undefined));
  return { _0: hash, _1: filename };
}
function _M0FP410Haoxincode8moonbash3lib8commands18hash__split__lines(s) {
  const lines = [];
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const _p$4 = s.charCodeAt(i);
      const _p$5 = 10;
      if (_p$4 === _p$5) {
        _M0MPC15array5Array4pushGUssEE(lines, buf.val);
        _M0MPB13StringBuilder5reset(buf);
      } else {
        $bound_check(s, i);
        _M0IPB13StringBuilderPB6Logger11write__char(buf, s.charCodeAt(i));
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const remaining = buf.val;
  if (remaining.length > 0) {
    _M0MPC15array5Array4pushGUssEE(lines, remaining);
  }
  return lines;
}
function _M0FP410Haoxincode8moonbash3lib8commands11hash__check(ctx, files, cmd_name, hash_fn) {
  let check_content;
  if (files.length > 0) {
    const path = _M0MPC15array5Array2atGUssEE(files, 0);
    let resolved;
    let _try_err;
    _L: {
      _L$2: {
        const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, path);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          resolved = _ok._0;
        } else {
          const _err = _bind$4;
          _try_err = _err._0;
          break _L$2;
        }
        break _L;
      }
      resolved = path;
    }
    let _try_err$2;
    _L$2: {
      _L$3: {
        const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, resolved);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          check_content = _ok._0;
        } else {
          const _err = _bind$4;
          _try_err$2 = _err._0;
          break _L$3;
        }
        break _L$2;
      }
      const _FsError = _try_err$2;
      const _msg = _FsError._0;
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`${cmd_name}: ${_msg}\n`);
    }
  } else {
    check_content = ctx.stdin_content;
  }
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const errbuf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let failures = 0;
  const lines = _M0FP410Haoxincode8moonbash3lib8commands18hash__split__lines(check_content);
  const _bind$4 = lines.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const line = lines[_];
      _L: {
        if (line.length === 0) {
          break _L;
        }
        const parsed = _M0FP410Haoxincode8moonbash3lib8commands24hash__parse__check__line(line);
        if (parsed === undefined) {
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `${cmd_name}: ${line}: improperly formatted checksum line\n`);
          break _L;
        } else {
          const _Some = parsed;
          const _x = _Some;
          const _expected_hash = _x._0;
          const _filename = _x._1;
          let resolved;
          let _try_err;
          _L$2: {
            _L$3: {
              const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, _filename);
              if (_bind$5.$tag === 1) {
                const _ok = _bind$5;
                resolved = _ok._0;
              } else {
                const _err = _bind$5;
                _try_err = _err._0;
                break _L$3;
              }
              break _L$2;
            }
            resolved = _filename;
          }
          let content;
          let _try_err$2;
          _L$3: {
            _L$4: {
              const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, resolved);
              if (_bind$5.$tag === 1) {
                const _ok = _bind$5;
                content = _ok._0;
              } else {
                const _err = _bind$5;
                _try_err$2 = _err._0;
                break _L$4;
              }
              break _L$3;
            }
            _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `${cmd_name}: ${_filename}: No such file or directory\n`);
            _M0IPB13StringBuilderPB6Logger13write__string(buf, `${_filename}: FAILED open or read\n`);
            failures = failures + 1 | 0;
            break _L;
          }
          const actual_hash = hash_fn(content);
          if (actual_hash === _expected_hash) {
            _M0IPB13StringBuilderPB6Logger13write__string(buf, `${_filename}: OK\n`);
          } else {
            _M0IPB13StringBuilderPB6Logger13write__string(buf, `${_filename}: FAILED\n`);
            failures = failures + 1 | 0;
          }
        }
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (failures > 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `${cmd_name}: WARNING: ${_M0IPC13int3IntPB4Show10to__string(failures)} computed checksum did NOT match\n`);
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(buf.val, errbuf.val, failures > 0 ? 1 : 0);
}
function _M0FP410Haoxincode8moonbash3lib8commands11cmd__md5sum(ctx) {
  let check_mode = false;
  const files = [];
  const _bind$4 = ctx.args;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const arg = _bind$4[_];
      if (arg === "-c" || arg === "--check") {
        check_mode = true;
      } else {
        _M0MPC15array5Array4pushGUssEE(files, arg);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (check_mode) {
    return _M0FP410Haoxincode8moonbash3lib8commands11hash__check(ctx, files, "md5sum", _M0FP410Haoxincode8moonbash3lib8commands12compute__md5);
  }
  if (files.length === 0) {
    const hash = _M0FP410Haoxincode8moonbash3lib8commands12compute__md5(ctx.stdin_content);
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(`${hash}  -\n`);
  }
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const errbuf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let had_error = false;
  const _bind$6 = files.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$6) {
      const file = files[_];
      _L: {
        let resolved;
        let _try_err;
        _L$2: {
          _L$3: {
            const _bind$7 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, file);
            if (_bind$7.$tag === 1) {
              const _ok = _bind$7;
              resolved = _ok._0;
            } else {
              const _err = _bind$7;
              _try_err = _err._0;
              break _L$3;
            }
            break _L$2;
          }
          resolved = file;
        }
        let content;
        let _try_err$2;
        _L$3: {
          _L$4: {
            const _bind$7 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, resolved);
            if (_bind$7.$tag === 1) {
              const _ok = _bind$7;
              content = _ok._0;
            } else {
              const _err = _bind$7;
              _try_err$2 = _err._0;
              break _L$4;
            }
            break _L$3;
          }
          const _FsError = _try_err$2;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `md5sum: ${_msg}\n`);
          had_error = true;
          break _L;
        }
        const hash = _M0FP410Haoxincode8moonbash3lib8commands12compute__md5(content);
        _M0IPB13StringBuilderPB6Logger13write__string(buf, `${hash}  ${file}\n`);
        break _L;
      }
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(buf.val, errbuf.val, had_error ? 1 : 0);
}
function _M0FP410Haoxincode8moonbash3lib8commands10cmd__mkdir(ctx) {
  let recursive = false;
  const paths = [];
  const _bind$4 = ctx.args;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const arg = _bind$4[_];
      if (arg === "-p") {
        recursive = true;
      } else {
        _M0MPC15array5Array4pushGUssEE(paths, arg);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (paths.length === 0) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("mkdir: missing operand\n");
  }
  const errbuf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let exit_code = 0;
  const _bind$6 = paths.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$6) {
      const path = paths[_];
      _L: {
        let resolved;
        let _try_err;
        _L$2: {
          _L$3: {
            const _bind$7 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, path);
            if (_bind$7.$tag === 1) {
              const _ok = _bind$7;
              resolved = _ok._0;
            } else {
              const _err = _bind$7;
              _try_err = _err._0;
              break _L$3;
            }
            break _L$2;
          }
          const _FsError = _try_err;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `mkdir: ${_msg}\n`);
          exit_code = 1;
          break _L;
        }
        let _try_err$2;
        _L$3: {
          _L$4: {
            const _bind$7 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs13mkdir_2einner(ctx.fs, resolved, recursive);
            if (_bind$7.$tag === 1) {
              const _ok = _bind$7;
              _ok._0;
            } else {
              const _err = _bind$7;
              _try_err$2 = _err._0;
              break _L$4;
            }
            break _L$3;
          }
          const _FsError = _try_err$2;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `mkdir: ${_msg}\n`);
          exit_code = 1;
        }
        break _L;
      }
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", errbuf.val, exit_code);
}
function _M0FP410Haoxincode8moonbash3lib8commands7cmd__mv(ctx) {
  const paths = [];
  const _bind$4 = ctx.args;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const arg = _bind$4[_];
      _M0MPC15array5Array4pushGUssEE(paths, arg);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (paths.length < 2) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("mv: missing operand\n");
  }
  let dst;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, _M0MPC15array5Array2atGUssEE(paths, paths.length - 1 | 0));
      if (_bind$6.$tag === 1) {
        const _ok = _bind$6;
        dst = _ok._0;
      } else {
        const _err = _bind$6;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    const _FsError = _try_err;
    const _msg = _FsError._0;
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`mv: ${_msg}\n`);
  }
  if (paths.length > 2) {
    let dst_is_dir;
    let _try_err$2;
    _L$2: {
      _L$3: {
        const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs4stat(ctx.fs, dst);
        let stat;
        if (_bind$6.$tag === 1) {
          const _ok = _bind$6;
          stat = _ok._0;
        } else {
          const _err = _bind$6;
          _try_err$2 = _err._0;
          break _L$3;
        }
        dst_is_dir = stat.is_directory;
        break _L$2;
      }
      dst_is_dir = false;
    }
    if (!dst_is_dir) {
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`mv: target '${_M0MPC15array5Array2atGUssEE(paths, paths.length - 1 | 0)}' is not a directory\n`);
    }
  }
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < (paths.length - 1 | 0)) {
      let src;
      let _try_err$2;
      _L$2: {
        _L$3: {
          const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, _M0MPC15array5Array2atGUssEE(paths, i));
          if (_bind$6.$tag === 1) {
            const _ok = _bind$6;
            src = _ok._0;
          } else {
            const _err = _bind$6;
            _try_err$2 = _err._0;
            break _L$3;
          }
          break _L$2;
        }
        const _FsError = _try_err$2;
        const _msg = _FsError._0;
        return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`mv: ${_msg}\n`);
      }
      let _try_err$3;
      _L$3: {
        _L$4: {
          const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs2mv(ctx.fs, src, dst);
          if (_bind$6.$tag === 1) {
            const _ok = _bind$6;
            _ok._0;
          } else {
            const _err = _bind$6;
            _try_err$3 = _err._0;
            break _L$4;
          }
          break _L$3;
        }
        const _FsError = _try_err$3;
        const _msg = _FsError._0;
        return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`mv: ${_msg}\n`);
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", "", 0);
}
function _M0FP410Haoxincode8moonbash3lib8commands13cmd__readlink(ctx) {
  let canonicalize = false;
  const paths = [];
  const _bind$4 = ctx.args;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const arg = _bind$4[_];
      _L: {
        _L$2: {
          switch (arg) {
            case "-f": {
              break _L$2;
            }
            case "-e": {
              break _L$2;
            }
            case "-m": {
              break _L$2;
            }
            default: {
              _M0MPC15array5Array4pushGUssEE(paths, arg);
            }
          }
          break _L;
        }
        canonicalize = true;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (paths.length === 0) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("readlink: missing operand\n");
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const errbuf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let exit_code = 0;
  const _bind$6 = paths.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$6) {
      const path = paths[_];
      _L: {
        let resolved;
        let _try_err;
        _L$2: {
          _L$3: {
            const _bind$7 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, path);
            if (_bind$7.$tag === 1) {
              const _ok = _bind$7;
              resolved = _ok._0;
            } else {
              const _err = _bind$7;
              _try_err = _err._0;
              break _L$3;
            }
            break _L$2;
          }
          const _FsError = _try_err;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `readlink: ${_msg}\n`);
          exit_code = 1;
          break _L;
        }
        if (canonicalize) {
          let current = resolved;
          let depth = 0;
          let err_found = false;
          while (true) {
            if (depth < 40) {
              let stat;
              let _try_err$2;
              _L$3: {
                _L$4: {
                  const _bind$7 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs4stat(ctx.fs, current);
                  if (_bind$7.$tag === 1) {
                    const _ok = _bind$7;
                    stat = _ok._0;
                  } else {
                    const _err = _bind$7;
                    _try_err$2 = _err._0;
                    break _L$4;
                  }
                  break _L$3;
                }
                const _FsError = _try_err$2;
                const _msg = _FsError._0;
                _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `readlink: ${_msg}\n`);
                exit_code = 1;
                err_found = true;
                break;
              }
              if (stat.is_symlink) {
                let link_target;
                let _try_err$3;
                _L$4: {
                  _L$5: {
                    const _bind$7 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs8readlink(ctx.fs, current);
                    if (_bind$7.$tag === 1) {
                      const _ok = _bind$7;
                      link_target = _ok._0;
                    } else {
                      const _err = _bind$7;
                      _try_err$3 = _err._0;
                      break _L$5;
                    }
                    break _L$4;
                  }
                  const _FsError = _try_err$3;
                  const _msg = _FsError._0;
                  _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `readlink: ${_msg}\n`);
                  exit_code = 1;
                  err_found = true;
                  break;
                }
                let _tmp$40;
                let _try_err$4;
                _L$5: {
                  _L$6: {
                    let _tmp$41;
                    if (link_target.length > 0) {
                      $bound_check(link_target, 0);
                      const _p$4 = link_target.charCodeAt(0);
                      const _p$5 = 47;
                      _tmp$41 = _p$4 === _p$5;
                    } else {
                      _tmp$41 = false;
                    }
                    if (_tmp$41) {
                      const _bind$7 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path("/", link_target);
                      if (_bind$7.$tag === 1) {
                        const _ok = _bind$7;
                        _tmp$40 = _ok._0;
                      } else {
                        const _err = _bind$7;
                        _try_err$4 = _err._0;
                        break _L$6;
                      }
                    } else {
                      const _bind$7 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(_M0FP410Haoxincode8moonbash3lib2fs12parent__path(current), link_target);
                      if (_bind$7.$tag === 1) {
                        const _ok = _bind$7;
                        _tmp$40 = _ok._0;
                      } else {
                        const _err = _bind$7;
                        _try_err$4 = _err._0;
                        break _L$6;
                      }
                    }
                    break _L$5;
                  }
                  const _FsError = _try_err$4;
                  const _msg = _FsError._0;
                  _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `readlink: ${_msg}\n`);
                  exit_code = 1;
                  err_found = true;
                  break;
                }
                current = _tmp$40;
                depth = depth + 1 | 0;
              } else {
                break;
              }
              continue;
            } else {
              break;
            }
          }
          if (!err_found) {
            _M0IPB13StringBuilderPB6Logger13write__string(out, `${current}\n`);
          }
        } else {
          let target;
          let _try_err$2;
          _L$3: {
            _L$4: {
              const _bind$7 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs8readlink(ctx.fs, resolved);
              if (_bind$7.$tag === 1) {
                const _ok = _bind$7;
                target = _ok._0;
              } else {
                const _err = _bind$7;
                _try_err$2 = _err._0;
                break _L$4;
              }
              break _L$3;
            }
            const _FsError = _try_err$2;
            const _msg = _FsError._0;
            _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `readlink: ${_msg}\n`);
            exit_code = 1;
            break _L;
          }
          _M0IPB13StringBuilderPB6Logger13write__string(out, `${target}\n`);
        }
        break _L;
      }
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(out.val, errbuf.val, exit_code);
}
function _M0FP410Haoxincode8moonbash3lib8commands7cmd__rm(ctx) {
  let recursive = false;
  let force = false;
  const paths = [];
  const _bind$4 = ctx.args;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const arg = _bind$4[_];
      _L: {
        _L$2: {
          _L$3: {
            _L$4: {
              switch (arg) {
                case "-r": {
                  break _L$4;
                }
                case "-R": {
                  break _L$4;
                }
                case "-f": {
                  force = true;
                  break;
                }
                case "-rf": {
                  break _L$2;
                }
                case "-fr": {
                  break _L$2;
                }
                case "-Rf": {
                  break _L$2;
                }
                case "-fR": {
                  break _L$2;
                }
                default: {
                  _M0MPC15array5Array4pushGUssEE(paths, arg);
                }
              }
              break _L$3;
            }
            recursive = true;
          }
          break _L;
        }
        recursive = true;
        force = true;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (paths.length === 0 && !force) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("rm: missing operand\n");
  }
  const errbuf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let exit_code = 0;
  const _bind$6 = paths.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$6) {
      const path = paths[_];
      _L: {
        let resolved;
        let _try_err;
        _L$2: {
          _L$3: {
            const _bind$7 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, path);
            if (_bind$7.$tag === 1) {
              const _ok = _bind$7;
              resolved = _ok._0;
            } else {
              const _err = _bind$7;
              _try_err = _err._0;
              break _L$3;
            }
            break _L$2;
          }
          const _FsError = _try_err;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `rm: ${_msg}\n`);
          exit_code = 1;
          break _L;
        }
        let _try_err$2;
        _L$3: {
          _L$4: {
            const _bind$7 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10rm_2einner(ctx.fs, resolved, recursive, force);
            if (_bind$7.$tag === 1) {
              const _ok = _bind$7;
              _ok._0;
            } else {
              const _err = _bind$7;
              _try_err$2 = _err._0;
              break _L$4;
            }
            break _L$3;
          }
          const _FsError = _try_err$2;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `rm: ${_msg}\n`);
          exit_code = 1;
        }
        break _L;
      }
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", errbuf.val, exit_code);
}
function _M0FP410Haoxincode8moonbash3lib8commands10cmd__rmdir(ctx) {
  if (ctx.args.length === 0) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("rmdir: missing operand\n");
  }
  const errbuf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let exit_code = 0;
  const _bind$4 = ctx.args;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const arg = _bind$4[_];
      _L: {
        let resolved;
        let _try_err;
        _L$2: {
          _L$3: {
            const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, arg);
            if (_bind$6.$tag === 1) {
              const _ok = _bind$6;
              resolved = _ok._0;
            } else {
              const _err = _bind$6;
              _try_err = _err._0;
              break _L$3;
            }
            break _L$2;
          }
          const _FsError = _try_err;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `rmdir: ${_msg}\n`);
          exit_code = 1;
          break _L;
        }
        _L$3: {
          _L$4: {
            const _bind$6 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(ctx.fs.entries, resolved);
            if (_bind$6 === undefined) {
              _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `rmdir: failed to remove '${arg}': No such file or directory\n`);
              exit_code = 1;
            } else {
              const _Some = _bind$6;
              const _x = _Some;
              switch (_x.$tag) {
                case 0: {
                  break _L$4;
                }
                case 2: {
                  break _L$4;
                }
                default: {
                  const prefix = resolved === "/" ? "/" : `${resolved}/`;
                  const has_children = new _M0TPB8MutLocalGbE(false);
                  const _p$4 = ctx.fs.entries;
                  let _tmp$39 = _p$4.head;
                  while (true) {
                    const _p$5 = _tmp$39;
                    if (_p$5 === undefined) {
                      break;
                    } else {
                      const _p$6 = _p$5;
                      const _p$7 = _p$6;
                      const _p$8 = _p$7.key;
                      const _p$9 = _p$7.next;
                      if (_p$8.length > prefix.length && _M0MPC16string6String11has__prefix(_p$8, new _M0TPC16string10StringView(prefix, 0, prefix.length))) {
                        has_children.val = true;
                      }
                      _tmp$39 = _p$9;
                      continue;
                    }
                  }
                  if (has_children.val) {
                    _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `rmdir: failed to remove '${arg}': Directory not empty\n`);
                    exit_code = 1;
                  } else {
                    _M0MPB3Map6removeGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(ctx.fs.entries, resolved);
                  }
                }
              }
            }
            break _L$3;
          }
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `rmdir: failed to remove '${arg}': Not a directory\n`);
          exit_code = 1;
        }
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", errbuf.val, exit_code);
}
function _M0FP410Haoxincode8moonbash3lib8commands13compute__sha1(input) {
  const digest = _M0MP27gmlewis4sha16Digest3new();
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < input.length) {
      $bound_check(input, i);
      _M0IP27gmlewis4sha16DigestP27gmlewis2io10ByteWriter11write__byte(digest, input.charCodeAt(i) & 255);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP27gmlewis4sha16Digest10check__sum(digest);
}
function _M0FP410Haoxincode8moonbash3lib8commands12cmd__sha1sum(ctx) {
  let check_mode = false;
  const files = [];
  const _bind$4 = ctx.args;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const arg = _bind$4[_];
      if (arg === "-c" || arg === "--check") {
        check_mode = true;
      } else {
        _M0MPC15array5Array4pushGUssEE(files, arg);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (check_mode) {
    return _M0FP410Haoxincode8moonbash3lib8commands11hash__check(ctx, files, "sha1sum", _M0FP410Haoxincode8moonbash3lib8commands13compute__sha1);
  }
  if (files.length === 0) {
    const hash = _M0FP410Haoxincode8moonbash3lib8commands13compute__sha1(ctx.stdin_content);
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(`${hash}  -\n`);
  }
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const errbuf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let had_error = false;
  const _bind$6 = files.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$6) {
      const file = files[_];
      _L: {
        let resolved;
        let _try_err;
        _L$2: {
          _L$3: {
            const _bind$7 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, file);
            if (_bind$7.$tag === 1) {
              const _ok = _bind$7;
              resolved = _ok._0;
            } else {
              const _err = _bind$7;
              _try_err = _err._0;
              break _L$3;
            }
            break _L$2;
          }
          resolved = file;
        }
        let content;
        let _try_err$2;
        _L$3: {
          _L$4: {
            const _bind$7 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, resolved);
            if (_bind$7.$tag === 1) {
              const _ok = _bind$7;
              content = _ok._0;
            } else {
              const _err = _bind$7;
              _try_err$2 = _err._0;
              break _L$4;
            }
            break _L$3;
          }
          const _FsError = _try_err$2;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `sha1sum: ${_msg}\n`);
          had_error = true;
          break _L;
        }
        const hash = _M0FP410Haoxincode8moonbash3lib8commands13compute__sha1(content);
        _M0IPB13StringBuilderPB6Logger13write__string(buf, `${hash}  ${file}\n`);
        break _L;
      }
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(buf.val, errbuf.val, had_error ? 1 : 0);
}
function _M0FP410Haoxincode8moonbash3lib8commands17string__to__bytes(s) {
  const arr = _M0MPC15array5Array11new_2einnerGyE(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      _M0MPC15array5Array4pushGyE(arr, s.charCodeAt(i) & 255);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MPC15bytes5Bytes11from__array(new _M0TPB9ArrayViewGyE(arr, 0, arr.length));
}
function _M0FP410Haoxincode8moonbash3lib8commands15compute__sha256(input) {
  const bytes = _M0FP410Haoxincode8moonbash3lib8commands17string__to__bytes(input);
  return _M0FP214shu_2dkitamura6sha25617sha256__hexdigest(bytes);
}
function _M0FP410Haoxincode8moonbash3lib8commands14cmd__sha256sum(ctx) {
  let check_mode = false;
  const files = [];
  const _bind$4 = ctx.args;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const arg = _bind$4[_];
      if (arg === "-c" || arg === "--check") {
        check_mode = true;
      } else {
        _M0MPC15array5Array4pushGUssEE(files, arg);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (check_mode) {
    return _M0FP410Haoxincode8moonbash3lib8commands11hash__check(ctx, files, "sha256sum", _M0FP410Haoxincode8moonbash3lib8commands15compute__sha256);
  }
  if (files.length === 0) {
    const hash = _M0FP410Haoxincode8moonbash3lib8commands15compute__sha256(ctx.stdin_content);
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(`${hash}  -\n`);
  }
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const errbuf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let had_error = false;
  const _bind$6 = files.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$6) {
      const file = files[_];
      _L: {
        let resolved;
        let _try_err;
        _L$2: {
          _L$3: {
            const _bind$7 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, file);
            if (_bind$7.$tag === 1) {
              const _ok = _bind$7;
              resolved = _ok._0;
            } else {
              const _err = _bind$7;
              _try_err = _err._0;
              break _L$3;
            }
            break _L$2;
          }
          resolved = file;
        }
        let content;
        let _try_err$2;
        _L$3: {
          _L$4: {
            const _bind$7 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, resolved);
            if (_bind$7.$tag === 1) {
              const _ok = _bind$7;
              content = _ok._0;
            } else {
              const _err = _bind$7;
              _try_err$2 = _err._0;
              break _L$4;
            }
            break _L$3;
          }
          const _FsError = _try_err$2;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `sha256sum: ${_msg}\n`);
          had_error = true;
          break _L;
        }
        const hash = _M0FP410Haoxincode8moonbash3lib8commands15compute__sha256(content);
        _M0IPB13StringBuilderPB6Logger13write__string(buf, `${hash}  ${file}\n`);
        break _L;
      }
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(buf.val, errbuf.val, had_error ? 1 : 0);
}
function _M0FP410Haoxincode8moonbash3lib8commands20format__mode__string(mode, is_dir, is_link) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  if (is_dir) {
    _M0IPB13StringBuilderPB6Logger11write__char(buf, 100);
  } else {
    if (is_link) {
      _M0IPB13StringBuilderPB6Logger11write__char(buf, 108);
    } else {
      _M0IPB13StringBuilderPB6Logger11write__char(buf, 45);
    }
  }
  _M0IPB13StringBuilderPB6Logger11write__char(buf, (mode & 256) !== 0 ? 114 : 45);
  _M0IPB13StringBuilderPB6Logger11write__char(buf, (mode & 128) !== 0 ? 119 : 45);
  _M0IPB13StringBuilderPB6Logger11write__char(buf, (mode & 64) !== 0 ? 120 : 45);
  _M0IPB13StringBuilderPB6Logger11write__char(buf, (mode & 32) !== 0 ? 114 : 45);
  _M0IPB13StringBuilderPB6Logger11write__char(buf, (mode & 16) !== 0 ? 119 : 45);
  _M0IPB13StringBuilderPB6Logger11write__char(buf, (mode & 8) !== 0 ? 120 : 45);
  _M0IPB13StringBuilderPB6Logger11write__char(buf, (mode & 4) !== 0 ? 114 : 45);
  _M0IPB13StringBuilderPB6Logger11write__char(buf, (mode & 2) !== 0 ? 119 : 45);
  _M0IPB13StringBuilderPB6Logger11write__char(buf, (mode & 1) !== 0 ? 120 : 45);
  return buf.val;
}
function _M0FP410Haoxincode8moonbash3lib8commands13format__octal(mode) {
  const d3 = mode / 512 | 0;
  const rem3 = mode % 512 | 0;
  const d2 = rem3 / 64 | 0;
  const rem2 = rem3 % 64 | 0;
  const d1 = rem2 / 8 | 0;
  const d0 = rem2 % 8 | 0;
  return `${_M0MPC13int3Int18to__string_2einner(d3, 10)}${_M0MPC13int3Int18to__string_2einner(d2, 10)}${_M0MPC13int3Int18to__string_2einner(d1, 10)}${_M0MPC13int3Int18to__string_2einner(d0, 10)}`;
}
function _M0FP410Haoxincode8moonbash3lib8commands9cmd__stat(ctx) {
  if (ctx.args.length === 0) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("stat: missing operand\n");
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const errbuf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let exit_code = 0;
  const _bind$4 = ctx.args;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const arg = _bind$4[_];
      _L: {
        let resolved;
        let _try_err;
        _L$2: {
          _L$3: {
            const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, arg);
            if (_bind$6.$tag === 1) {
              const _ok = _bind$6;
              resolved = _ok._0;
            } else {
              const _err = _bind$6;
              _try_err = _err._0;
              break _L$3;
            }
            break _L$2;
          }
          const _FsError = _try_err;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `stat: ${_msg}\n`);
          exit_code = 1;
          break _L;
        }
        let stat;
        let _try_err$2;
        _L$3: {
          _L$4: {
            const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs4stat(ctx.fs, resolved);
            if (_bind$6.$tag === 1) {
              const _ok = _bind$6;
              stat = _ok._0;
            } else {
              const _err = _bind$6;
              _try_err$2 = _err._0;
              break _L$4;
            }
            break _L$3;
          }
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `stat: cannot stat '${arg}': No such file or directory\n`);
          exit_code = 1;
          break _L;
        }
        const type_str = stat.is_directory ? "directory" : stat.is_symlink ? "symbolic link" : "regular file";
        const size = stat.is_directory ? 4096 : stat.size;
        const mode_str = _M0FP410Haoxincode8moonbash3lib8commands20format__mode__string(stat.mode, stat.is_directory, stat.is_symlink);
        const octal_str = _M0FP410Haoxincode8moonbash3lib8commands13format__octal(stat.mode);
        _M0IPB13StringBuilderPB6Logger13write__string(out, `  File: ${arg}\n`);
        _M0IPB13StringBuilderPB6Logger13write__string(out, `  Size: ${_M0IPC13int3IntPB4Show10to__string(size)}\tType: ${type_str}\n`);
        _M0IPB13StringBuilderPB6Logger13write__string(out, `Access: (${octal_str}/${mode_str})\n`);
        _M0IPB13StringBuilderPB6Logger13write__string(out, "Modify: 1970-01-01 00:00:00.000000000 +0000\n");
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(out.val, errbuf.val, exit_code);
}
function _M0FP410Haoxincode8moonbash3lib8commands24cmd__touch__apply__mtime(ctx, resolved, mtime) {
  const _bind$4 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(ctx.fs.entries, resolved);
  if (_bind$4 === undefined) {
    return;
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    switch (_x.$tag) {
      case 0: {
        const _File = _x;
        const _data = _File._0;
        _data.mtime = mtime;
        return;
      }
      case 1: {
        const _Directory = _x;
        const _data$2 = _Directory._0;
        _data$2.mtime = mtime;
        return;
      }
      default: {
        const _Symlink = _x;
        const _data$3 = _Symlink._0;
        _data$3.mtime = mtime;
        return;
      }
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands30cmd__touch__parse__date__value(spec) {
  const normalized = _M0MPC16string6String7replace(spec, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands30cmd__touch__parse__date__valueN7_2abindS8466, 0, _M0FP410Haoxincode8moonbash3lib8commands30cmd__touch__parse__date__valueN7_2abindS8466.length), new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands30cmd__touch__parse__date__valueN7_2abindS8467, 0, _M0FP410Haoxincode8moonbash3lib8commands30cmd__touch__parse__date__valueN7_2abindS8467.length));
  let parsed;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0MP311moonbitlang1x4time9PlainDate12from__string(normalized);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        parsed = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    return undefined;
  }
  const year = parsed.year;
  const month = parsed.month;
  const day = parsed.day;
  const packed = ((Math.imul(year, 10000) | 0) + (Math.imul(month, 100) | 0) | 0) + day | 0;
  return BigInt.asUintN(64, BigInt(packed - 99999999 | 0));
}
function _M0FP410Haoxincode8moonbash3lib8commands10cmd__touch(ctx) {
  if (ctx.args.length === 0) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("touch: missing file operand\n");
  }
  let saw_option = false;
  let date_mtime = undefined;
  const paths = [];
  let i = 0;
  while (true) {
    if (i < ctx.args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(ctx.args, i);
      if (arg === "-d") {
        saw_option = true;
        if ((i + 1 | 0) >= ctx.args.length) {
          return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("touch: option requires an argument -- 'd'\n");
        }
        const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands30cmd__touch__parse__date__value(_M0MPC15array5Array2atGUssEE(ctx.args, i + 1 | 0));
        if (_bind$4 === undefined) {
          return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`touch: invalid date format '${_M0MPC15array5Array2atGUssEE(ctx.args, i + 1 | 0)}'\n`);
        } else {
          const _Some = _bind$4;
          const _parsed = _Some;
          date_mtime = _parsed;
        }
        i = i + 2 | 0;
        continue;
      }
      let _tmp$38;
      if (arg.length > 0) {
        $bound_check(arg, 0);
        const _p$4 = arg.charCodeAt(0);
        const _p$5 = 45;
        _tmp$38 = _p$4 === _p$5;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        saw_option = true;
        i = i + 1 | 0;
        continue;
      }
      _M0MPC15array5Array4pushGUssEE(paths, arg);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (paths.length === 0) {
    if (saw_option) {
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", "", 0);
    }
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("touch: missing file operand\n");
  }
  const errbuf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let exit_code = 0;
  const _bind$4 = paths.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const arg = paths[_];
      _L: {
        let resolved;
        let _try_err;
        _L$2: {
          _L$3: {
            const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, arg);
            if (_bind$5.$tag === 1) {
              const _ok = _bind$5;
              resolved = _ok._0;
            } else {
              const _err = _bind$5;
              _try_err = _err._0;
              break _L$3;
            }
            break _L$2;
          }
          const _FsError = _try_err;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `touch: ${_msg}\n`);
          exit_code = 1;
          break _L;
        }
        if (!_M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs6exists(ctx.fs, resolved)) {
          let _try_err$2;
          _L$3: {
            _L$4: {
              const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs11write__file(ctx.fs, resolved, "");
              if (_bind$5.$tag === 1) {
                const _ok = _bind$5;
                _ok._0;
              } else {
                const _err = _bind$5;
                _try_err$2 = _err._0;
                break _L$4;
              }
              break _L$3;
            }
            const _FsError = _try_err$2;
            const _msg = _FsError._0;
            _M0IPB13StringBuilderPB6Logger13write__string(errbuf, `touch: ${_msg}\n`);
            exit_code = 1;
            break _L;
          }
        }
        const _bind$5 = date_mtime;
        if (_bind$5 === undefined) {
        } else {
          const _Some = _bind$5;
          const _value = _Some;
          _M0FP410Haoxincode8moonbash3lib8commands24cmd__touch__apply__mtime(ctx, resolved, _value);
        }
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", errbuf.val, exit_code);
}
function _M0FP410Haoxincode8moonbash3lib8commands15cmd__tree__walk(fs, abs_path, prefix, out, counter) {
  let entries;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs7readdir(fs, abs_path);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        entries = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    return undefined;
  }
  const items = [];
  const _bind$4 = entries.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const entry = entries[_];
      const _bind$5 = entry.entry_type;
      let is_dir;
      if (_bind$5 === 1) {
        is_dir = true;
      } else {
        is_dir = false;
      }
      _M0MPC15array5Array4pushGUssEE(items, { _0: entry.name, _1: is_dir });
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MPC15array5Array8sort__byGUssEE(items, (a, b) => _M0FP410Haoxincode8moonbash3lib8commands25cmd__find__compare__ascii(a._0, b._0));
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < items.length) {
      const _bind$5 = _M0MPC15array5Array2atGUssEE(items, i);
      const _name = _bind$5._0;
      const _is_dir = _bind$5._1;
      const is_last = i === (items.length - 1 | 0);
      const connector = is_last ? "└── " : "├── ";
      _M0IPB13StringBuilderPB6Logger13write__string(out, `${prefix}${connector}${_name}\n`);
      counter(_is_dir);
      if (_is_dir) {
        const child_abs = abs_path === "/" ? `/${_name}` : `${abs_path}/${_name}`;
        const child_prefix = is_last ? `${prefix}    ` : `${prefix}│   `;
        _M0FP410Haoxincode8moonbash3lib8commands15cmd__tree__walk(fs, child_abs, child_prefix, out, counter);
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands9cmd__tree(ctx) {
  const path = ctx.args.length > 0 ? _M0MPC15array5Array2atGUssEE(ctx.args, 0) : ".";
  let resolved;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, path);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        resolved = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    const _FsError = _try_err;
    const _msg = _FsError._0;
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`tree: ${_msg}\n`);
  }
  _L$2: {
    _L$3: {
      const _bind$4 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(ctx.fs.entries, resolved);
      if (_bind$4 === undefined) {
        return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`tree: '${path}': No such file or directory\n`);
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        switch (_x.$tag) {
          case 0: {
            break _L$3;
          }
          case 2: {
            break _L$3;
          }
        }
      }
      break _L$2;
    }
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`tree: '${path}': Not a directory\n`);
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger13write__string(out, `${path}\n`);
  const dir_count = new _M0TPB8MutLocalGiE(0);
  const file_count = new _M0TPB8MutLocalGiE(0);
  _M0FP410Haoxincode8moonbash3lib8commands15cmd__tree__walk(ctx.fs, resolved, "", out, (_is_dir) => {
    if (_is_dir) {
      dir_count.val = dir_count.val + 1 | 0;
      return;
    } else {
      file_count.val = file_count.val + 1 | 0;
      return;
    }
  });
  _M0IPB13StringBuilderPB6Logger13write__string(out, `\n${_M0IPC13int3IntPB4Show10to__string(dir_count.val)} directories, ${_M0IPC13int3IntPB4Show10to__string(file_count.val)} files\n`);
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(out.val);
}
function _M0FP410Haoxincode8moonbash3lib8commands15xan__get__input(ctx, arg_start) {
  if (arg_start < ctx.args.length) {
    const path = _M0MPC15array5Array2atGUssEE(ctx.args, arg_start);
    if (path === "-") {
      return new _M0DTPC16result6ResultGssE2Ok(ctx.stdin_content);
    }
    let resolved;
    let _try_err;
    _L: {
      _L$2: {
        const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, path);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          resolved = _ok._0;
        } else {
          const _err = _bind$4;
          _try_err = _err._0;
          break _L$2;
        }
        break _L;
      }
      const _FsError = _try_err;
      const _msg = _FsError._0;
      return new _M0DTPC16result6ResultGssE3Err(`xan: ${_msg}\n`);
    }
    let data;
    let _try_err$2;
    _L$2: {
      _L$3: {
        const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, resolved);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          data = _ok._0;
        } else {
          const _err = _bind$4;
          _try_err$2 = _err._0;
          break _L$3;
        }
        break _L$2;
      }
      const _FsError = _try_err$2;
      const _msg = _FsError._0;
      return new _M0DTPC16result6ResultGssE3Err(`xan: ${_msg}\n`);
    }
    return new _M0DTPC16result6ResultGssE2Ok(data);
  } else {
    return new _M0DTPC16result6ResultGssE2Ok(ctx.stdin_content);
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands10xan__count(ctx) {
  const content = _M0FP410Haoxincode8moonbash3lib8commands15xan__get__input(ctx, 1);
  if (content.$tag === 0) {
    const _Err = content;
    const _msg = _Err._0;
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(_msg);
  } else {
    const _Ok = content;
    const _data = _Ok._0;
    const csv = _M0MP410Haoxincode8moonbash3lib6nyacsv3CSV13parse__string(_data, undefined);
    const _bind$4 = _M0MP410Haoxincode8moonbash3lib6nyacsv3CSV5shape(csv);
    const _row_count = _bind$4._0;
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(`${_M0MPC13int3Int18to__string_2einner(_row_count, 10)}\n`);
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands12xan__headers(ctx) {
  const content = _M0FP410Haoxincode8moonbash3lib8commands15xan__get__input(ctx, 1);
  if (content.$tag === 0) {
    const _Err = content;
    const _msg = _Err._0;
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(_msg);
  } else {
    const _Ok = content;
    const _data = _Ok._0;
    const csv = _M0MP410Haoxincode8moonbash3lib6nyacsv3CSV13parse__string(_data, undefined);
    const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
    const headers = csv.headers;
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < headers.length) {
        _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(headers, i));
        _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(out.val);
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands21xan__split__col__spec(spec) {
  const parts = [];
  const current = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < spec.length) {
      $bound_check(spec, i);
      const ch = spec.charCodeAt(i);
      if (ch === 44) {
        _M0MPC15array5Array4pushGUssEE(parts, current.val);
        _M0MPB13StringBuilder5reset(current);
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(current, ch);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MPC15array5Array4pushGUssEE(parts, current.val);
  return parts;
}
function _M0FP410Haoxincode8moonbash3lib8commands11xan__select(ctx) {
  if (ctx.args.length < 2) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("xan select: missing column specification\n");
  }
  const col_spec = _M0MPC15array5Array2atGUssEE(ctx.args, 1);
  const col_names = _M0FP410Haoxincode8moonbash3lib8commands21xan__split__col__spec(col_spec);
  const content = _M0FP410Haoxincode8moonbash3lib8commands15xan__get__input(ctx, 2);
  if (content.$tag === 0) {
    const _Err = content;
    const _msg = _Err._0;
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(_msg);
  } else {
    const _Ok = content;
    const _data = _Ok._0;
    const csv = _M0MP410Haoxincode8moonbash3lib6nyacsv3CSV13parse__string(_data, undefined);
    const headers = csv.headers;
    const indices = [];
    const _bind$4 = col_names.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$4) {
        const name = col_names[_];
        let found = -1;
        let _tmp$39 = 0;
        while (true) {
          const j = _tmp$39;
          if (j < headers.length) {
            if (_M0MPC15array5Array2atGUssEE(headers, j) === name) {
              found = j;
              break;
            }
            _tmp$39 = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        if (found >= 0) {
          _M0MPC15array5Array4pushGiE(indices, found);
        }
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    if (indices.length === 0) {
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("xan select: no matching columns found\n");
    }
    const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
    let _tmp$39 = 0;
    while (true) {
      const i = _tmp$39;
      if (i < indices.length) {
        if (i > 0) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 44);
        }
        _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(headers, _M0MPC15array5Array2atGiE(indices, i)));
        _tmp$39 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
    const rows = csv.rows;
    const _bind$5 = rows.length;
    let _tmp$40 = 0;
    while (true) {
      const _ = _tmp$40;
      if (_ < _bind$5) {
        const row = rows[_];
        let _tmp$41 = 0;
        while (true) {
          const i = _tmp$41;
          if (i < indices.length) {
            if (i > 0) {
              _M0IPB13StringBuilderPB6Logger11write__char(out, 44);
            }
            const idx = _M0MPC15array5Array2atGiE(indices, i);
            if (idx < row.length) {
              _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(row, idx));
            }
            _tmp$41 = i + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
        _tmp$40 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(out.val);
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands27xan__slice__normalize__args(args) {
  const normalized = [];
  let i = 1;
  while (true) {
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      if ((arg === "-i" || arg === "-l") && (i + 1 | 0) < args.length) {
        _M0MPC15array5Array4pushGUssEE(normalized, arg);
        _M0MPC15array5Array4pushGUssEE(normalized, _M0MPC15array5Array2atGUssEE(args, i + 1 | 0));
        i = i + 2 | 0;
      } else {
        if (!_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands27xan__slice__normalize__argsN7_2abindS8576, 0, _M0FP410Haoxincode8moonbash3lib8commands27xan__slice__normalize__argsN7_2abindS8576.length))) {
          _M0MPC15array5Array4pushGUssEE(normalized, arg);
          i = i + 1 | 0;
        } else {
          i = i + 1 | 0;
        }
      }
      continue;
    } else {
      break;
    }
  }
  return normalized;
}
function _M0FP410Haoxincode8moonbash3lib8commands23xan__slice__parse__args(args) {
  const normalized = _M0FP410Haoxincode8moonbash3lib8commands27xan__slice__normalize__args(args);
  const aliases = _M0MPB3Map3MapGssE(new _M0TPB9ArrayViewGUssEE(_M0FP410Haoxincode8moonbash3lib8commands23xan__slice__parse__argsN7_2abindS8586, 0, 2), undefined);
  let parsed;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP218peter_2djerry_2dye11parse__args5parse(new _M0TPB9ArrayViewGsE(normalized, 0, normalized.length), undefined, new _M0TPB9ArrayViewGsE(_M0FP410Haoxincode8moonbash3lib8commands23xan__slice__parse__argsN7_2abindS8584, 0, 2), undefined, aliases, undefined, _M0FP410Haoxincode8moonbash3lib8commands23xan__slice__parse__argsN6constrS9252, -1);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        parsed = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    return new _M0TP410Haoxincode8moonbash3lib8commands14XanSliceConfig(0, undefined, undefined);
  }
  const _p$4 = _M0MPB3Map3getGssE(parsed.options, "index");
  const _p$5 = "0";
  let _tmp$38;
  if (_p$4 === undefined) {
    _tmp$38 = _p$5;
  } else {
    const _p$6 = _p$4;
    _tmp$38 = _p$6;
  }
  const _tmp$39 = Number(BigInt.asIntN(32, _M0FP410Haoxincode8moonbash3lib8commands15cmd__parse__int(_tmp$38))) | 0;
  const _bind$4 = _M0MPB3Map3getGssE(parsed.options, "length");
  let _tmp$40;
  if (_bind$4 === undefined) {
    _tmp$40 = undefined;
  } else {
    const _Some = _bind$4;
    const _value = _Some;
    _tmp$40 = Number(BigInt.asIntN(32, _M0FP410Haoxincode8moonbash3lib8commands15cmd__parse__int(_value))) | 0;
  }
  return new _M0TP410Haoxincode8moonbash3lib8commands14XanSliceConfig(_tmp$39, _tmp$40, parsed.positional.length > 0 ? _M0MPC15array5Array2atGUssEE(parsed.positional, parsed.positional.length - 1 | 0) : undefined);
}
function _M0FP410Haoxincode8moonbash3lib8commands10xan__slice(ctx) {
  const config = _M0FP410Haoxincode8moonbash3lib8commands23xan__slice__parse__args(ctx.args);
  const _bind$4 = config.file_path;
  let content;
  if (_bind$4 === undefined) {
    content = ctx.stdin_content;
  } else {
    const _Some = _bind$4;
    const _path = _Some;
    let resolved;
    let _try_err;
    _L: {
      _L$2: {
        const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, _path);
        if (_bind$5.$tag === 1) {
          const _ok = _bind$5;
          resolved = _ok._0;
        } else {
          const _err = _bind$5;
          _try_err = _err._0;
          break _L$2;
        }
        break _L;
      }
      const _FsError = _try_err;
      const _msg = _FsError._0;
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`xan slice: ${_msg}\n`);
    }
    let _try_err$2;
    _L$2: {
      _L$3: {
        const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, resolved);
        if (_bind$5.$tag === 1) {
          const _ok = _bind$5;
          content = _ok._0;
        } else {
          const _err = _bind$5;
          _try_err$2 = _err._0;
          break _L$3;
        }
        break _L$2;
      }
      const _FsError = _try_err$2;
      const _msg = _FsError._0;
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`xan slice: ${_msg}\n`);
    }
  }
  const csv = _M0MP410Haoxincode8moonbash3lib6nyacsv3CSV13parse__string(content, undefined);
  const headers = csv.headers;
  const rows = csv.rows;
  const _bind$5 = config.length;
  let end;
  if (_bind$5 === undefined) {
    end = rows.length;
  } else {
    const _Some = _bind$5;
    const _l = _Some;
    const e = config.start + _l | 0;
    end = e > rows.length ? rows.length : e;
  }
  const actual_start = config.start < 0 ? 0 : config.start > rows.length ? rows.length : config.start;
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array4joinGsE(headers, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands10xan__sliceN7_2abindS8587, 0, _M0FP410Haoxincode8moonbash3lib8commands10xan__sliceN7_2abindS8587.length)));
  _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
  let _tmp$38 = actual_start;
  while (true) {
    const j = _tmp$38;
    if (j < end) {
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array4joinGsE(_M0MPC15array5Array2atGRPB5ArrayGsEE(rows, j), new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands10xan__sliceN7_2abindS8590, 0, _M0FP410Haoxincode8moonbash3lib8commands10xan__sliceN7_2abindS8590.length)));
      _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
      _tmp$38 = j + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(out.val);
}
function _M0FP410Haoxincode8moonbash3lib8commands14xan__view__cmd(ctx) {
  const content = _M0FP410Haoxincode8moonbash3lib8commands15xan__get__input(ctx, 1);
  if (content.$tag === 0) {
    const _Err = content;
    const _msg = _Err._0;
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(_msg);
  } else {
    const _Ok = content;
    const _data = _Ok._0;
    const csv = _M0MP410Haoxincode8moonbash3lib6nyacsv3CSV13parse__string(_data, undefined);
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(_M0FP410Haoxincode8moonbash3lib8commands9xan__view(csv));
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands8cmd__xan(ctx) {
  if (ctx.args.length === 0) {
    if (ctx.stdin_content.length === 0) {
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("xan: missing subcommand or file\n");
    }
    const csv = _M0MP410Haoxincode8moonbash3lib6nyacsv3CSV13parse__string(ctx.stdin_content, undefined);
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(_M0FP410Haoxincode8moonbash3lib8commands9xan__view(csv));
  }
  const subcmd = _M0MPC15array5Array2atGUssEE(ctx.args, 0);
  switch (subcmd) {
    case "headers": {
      return _M0FP410Haoxincode8moonbash3lib8commands12xan__headers(ctx);
    }
    case "select": {
      return _M0FP410Haoxincode8moonbash3lib8commands11xan__select(ctx);
    }
    case "slice": {
      return _M0FP410Haoxincode8moonbash3lib8commands10xan__slice(ctx);
    }
    case "view": {
      return _M0FP410Haoxincode8moonbash3lib8commands14xan__view__cmd(ctx);
    }
    case "count": {
      return _M0FP410Haoxincode8moonbash3lib8commands10xan__count(ctx);
    }
    default: {
      let resolved;
      let _try_err;
      _L: {
        _L$2: {
          const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, subcmd);
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            resolved = _ok._0;
          } else {
            const _err = _bind$4;
            _try_err = _err._0;
            break _L$2;
          }
          break _L;
        }
        const _FsError = _try_err;
        const _msg = _FsError._0;
        return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`xan: ${_msg}\n`);
      }
      let content;
      let _try_err$2;
      _L$2: {
        _L$3: {
          const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, resolved);
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            content = _ok._0;
          } else {
            const _err = _bind$4;
            _try_err$2 = _err._0;
            break _L$3;
          }
          break _L$2;
        }
        const _FsError = _try_err$2;
        const _msg = _FsError._0;
        return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`xan: ${_msg}\n`);
      }
      const csv = _M0MP410Haoxincode8moonbash3lib6nyacsv3CSV13parse__string(content, undefined);
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(_M0FP410Haoxincode8moonbash3lib8commands9xan__view(csv));
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands17yq__parse__filter(filter) {
  const segments = [];
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  let _tmp$38;
  if (filter.length > 0) {
    $bound_check(filter, 0);
    const _p$4 = filter.charCodeAt(0);
    const _p$5 = 46;
    _tmp$38 = _p$4 === _p$5;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    i = 1;
  }
  while (true) {
    if (i < filter.length) {
      const _tmp$39 = i;
      $bound_check(filter, _tmp$39);
      const ch = filter.charCodeAt(_tmp$39);
      if (ch === 46) {
        const s = buf.val;
        if (s.length > 0) {
          _M0MPC15array5Array4pushGUssEE(segments, s);
        }
        _M0MPB13StringBuilder5reset(buf);
        i = i + 1 | 0;
      } else {
        if (ch === 91) {
          const s = buf.val;
          if (s.length > 0) {
            _M0MPC15array5Array4pushGUssEE(segments, s);
            _M0MPB13StringBuilder5reset(buf);
          }
          const bracket_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
          _M0IPB13StringBuilderPB6Logger11write__char(bracket_buf, 91);
          i = i + 1 | 0;
          while (true) {
            if (i < filter.length) {
              const _tmp$40 = i;
              $bound_check(filter, _tmp$40);
              const c2 = filter.charCodeAt(_tmp$40);
              if (c2 === 93) {
                _M0IPB13StringBuilderPB6Logger11write__char(bracket_buf, 93);
                i = i + 1 | 0;
                break;
              }
              _M0IPB13StringBuilderPB6Logger11write__char(bracket_buf, c2);
              i = i + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          _M0MPC15array5Array4pushGUssEE(segments, bracket_buf.val);
        } else {
          _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
          i = i + 1 | 0;
        }
      }
      continue;
    } else {
      break;
    }
  }
  const s = buf.val;
  if (s.length > 0) {
    _M0MPC15array5Array4pushGUssEE(segments, s);
  }
  return segments;
}
function _M0FP410Haoxincode8moonbash3lib8commands17yq__apply__filter(y, filter) {
  if (filter === ".") {
    return { _0: y, _1: false };
  }
  const segments = _M0FP410Haoxincode8moonbash3lib8commands17yq__parse__filter(filter);
  let current = y;
  let iterate_array = false;
  const _bind$4 = segments.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const seg = segments[_];
      if (seg === "[]") {
        iterate_array = true;
        break;
      } else {
        if (_M0MPC16string6String11has__prefix(seg, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands17yq__apply__filterN7_2abindS8638, 0, _M0FP410Haoxincode8moonbash3lib8commands17yq__apply__filterN7_2abindS8638.length)) && _M0MPC16string6String11has__suffix(seg, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands17yq__apply__filterN7_2abindS8639, 0, _M0FP410Haoxincode8moonbash3lib8commands17yq__apply__filterN7_2abindS8639.length))) {
          const idx_str = _M0FP410Haoxincode8moonbash3lib8commands18cmd__substr__slice(seg, 1, seg.length - 1 | 0);
          const idx = Number(BigInt.asIntN(32, _M0FP410Haoxincode8moonbash3lib8commands15cmd__parse__int(idx_str))) | 0;
          const _bind$5 = current;
          if (_bind$5.$tag === 4) {
            const _Array = _bind$5;
            const _arr = _Array._0;
            if (idx >= 0 && idx < _arr.length) {
              current = _M0MPC15array5Array2atGUssEE(_arr, idx);
            } else {
              current = _M0DTP219moonbit_2dcommunity4yaml4Yaml4Null__;
            }
          } else {
            current = _M0DTP219moonbit_2dcommunity4yaml4Yaml4Null__;
          }
        } else {
          const _bind$5 = current;
          if (_bind$5.$tag === 5) {
            const _Map = _bind$5;
            const _m = _Map._0;
            const _bind$6 = _M0MPB3Map3getGsRP219moonbit_2dcommunity4yaml4YamlE(_m, seg);
            if (_bind$6 === undefined) {
              current = _M0DTP219moonbit_2dcommunity4yaml4Yaml4Null__;
            } else {
              const _Some = _bind$6;
              const _v = _Some;
              current = _v;
            }
          } else {
            current = _M0DTP219moonbit_2dcommunity4yaml4Yaml4Null__;
          }
        }
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return { _0: current, _1: iterate_array };
}
function _M0FP410Haoxincode8moonbash3lib8commands22yaml__to__json__string(y) {
  return _M0MPC14json4Json17stringify_2einner(_M0IP219moonbit_2dcommunity4yaml4YamlPB6ToJson8to__json(y), false, 0, undefined);
}
function _M0FP410Haoxincode8moonbash3lib8commands18yq__format__output(y, raw) {
  if (raw) {
    switch (y.$tag) {
      case 2: {
        const _String = y;
        return _String._0;
      }
      case 6: {
        return "null";
      }
      default: {
        return _M0FP410Haoxincode8moonbash3lib8commands22yaml__to__json__string(y);
      }
    }
  } else {
    return _M0FP410Haoxincode8moonbash3lib8commands22yaml__to__json__string(y);
  }
}
function _M0FP410Haoxincode8moonbash3lib8commands15yq__parse__args(args) {
  const normalized = [];
  const _bind$4 = args.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const arg = args[_];
      if (arg === "-r" || (arg === "-j" || !_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands15yq__parse__argsN7_2abindS8666, 0, _M0FP410Haoxincode8moonbash3lib8commands15yq__parse__argsN7_2abindS8666.length)))) {
        _M0MPC15array5Array4pushGUssEE(normalized, arg);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const aliases = _M0MPB3Map3MapGssE(new _M0TPB9ArrayViewGUssEE(_M0FP410Haoxincode8moonbash3lib8commands15yq__parse__argsN7_2abindS8678, 0, 2), undefined);
  let parsed;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$5 = _M0FP218peter_2djerry_2dye11parse__args5parse(new _M0TPB9ArrayViewGsE(normalized, 0, normalized.length), new _M0TPB9ArrayViewGsE(_M0FP410Haoxincode8moonbash3lib8commands15yq__parse__argsN7_2abindS8676, 0, 2), undefined, undefined, aliases, undefined, _M0FP410Haoxincode8moonbash3lib8commands15yq__parse__argsN6constrS9255, -1);
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        parsed = _ok._0;
      } else {
        const _err = _bind$5;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    return new _M0TP410Haoxincode8moonbash3lib8commands8YqConfig(false, ".", undefined);
  }
  let filter = ".";
  let file_path = undefined;
  const _bind$5 = parsed.positional;
  const _bind$6 = _bind$5.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$6) {
      const arg = _bind$5[_];
      if (filter === "." && _M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib8commands15yq__parse__argsN7_2abindS8671, 0, _M0FP410Haoxincode8moonbash3lib8commands15yq__parse__argsN7_2abindS8671.length)) || arg === ".") {
        filter = arg;
      } else {
        file_path = arg;
      }
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _p$4 = _M0MPB3Map3getGsbE(parsed.flags, "raw");
  const _p$5 = false;
  return new _M0TP410Haoxincode8moonbash3lib8commands8YqConfig(_p$4 === -1 ? _p$5 : _p$4, filter, file_path);
}
function _M0FP410Haoxincode8moonbash3lib8commands7cmd__yq(ctx) {
  const config = _M0FP410Haoxincode8moonbash3lib8commands15yq__parse__args(ctx.args);
  const _bind$4 = config.file_path;
  let content;
  if (_bind$4 === undefined) {
    content = ctx.stdin_content;
  } else {
    const _Some = _bind$4;
    const _p$4 = _Some;
    let resolved;
    let _try_err;
    _L: {
      _L$2: {
        const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(ctx.cwd, _p$4);
        if (_bind$5.$tag === 1) {
          const _ok = _bind$5;
          resolved = _ok._0;
        } else {
          const _err = _bind$5;
          _try_err = _err._0;
          break _L$2;
        }
        break _L;
      }
      const _FsError = _try_err;
      const _msg = _FsError._0;
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`yq: ${_msg}\n`);
    }
    let _try_err$2;
    _L$2: {
      _L$3: {
        const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(ctx.fs, resolved);
        if (_bind$5.$tag === 1) {
          const _ok = _bind$5;
          content = _ok._0;
        } else {
          const _err = _bind$5;
          _try_err$2 = _err._0;
          break _L$3;
        }
        break _L$2;
      }
      const _FsError = _try_err$2;
      const _msg = _FsError._0;
      return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`yq: ${_msg}\n`);
    }
  }
  if (content.length === 0) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("yq: empty input\n");
  }
  let docs;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$5 = _M0MP219moonbit_2dcommunity4yaml4Yaml18load__from__string(new _M0TPC16string10StringView(content, 0, content.length));
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        docs = _ok._0;
      } else {
        const _err = _bind$5;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    const _YamlError = _try_err;
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err(`yq: ${_M0IP016_24default__implPB4Show10to__stringGRP219moonbit_2dcommunity4yaml9YamlErrorE(_YamlError)}\n`);
  }
  if (docs.length === 0) {
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult3err("yq: no YAML documents found\n");
  }
  const doc = _M0MPC15array5Array2atGUssEE(docs, 0);
  const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands17yq__apply__filter(doc, config.filter);
  const _result = _bind$5._0;
  const _iterate = _bind$5._1;
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  if (_iterate) {
    if (_result.$tag === 4) {
      const _Array = _result;
      const _arr = _Array._0;
      const _bind$6 = _arr.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$6) {
          const item = _arr[_];
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands18yq__format__output(item, config.raw));
          _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
    } else {
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands18yq__format__output(_result, config.raw));
      _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
    }
  } else {
    _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib8commands18yq__format__output(_result, config.raw));
    _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
  }
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult2ok(out.val);
}
function _M0FP410Haoxincode8moonbash3lib8commands9cmd__zcat(ctx) {
  const files = [];
  let force = false;
  const _bind$4 = ctx.args;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const arg = _bind$4[_];
      if (arg === "-f") {
        force = true;
      } else {
        _M0MPC15array5Array4pushGUssEE(files, arg);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const file_ctx = new _M0TP410Haoxincode8moonbash3lib8commands14CommandContext(files, ctx.stdin_content, ctx.cwd, ctx.env, ctx.fs);
  return _M0FP410Haoxincode8moonbash3lib8commands12gunzip__core(file_ctx, true, true, force);
}
function _M0FP410Haoxincode8moonbash3lib8commands13find__command(name) {
  _L: {
    _L$2: {
      switch (name) {
        case "echo": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9258;
        }
        case "cat": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9259;
        }
        case "cd": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9260;
        }
        case "pwd": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9261;
        }
        case "ls": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9262;
        }
        case "mkdir": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9263;
        }
        case "rm": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9264;
        }
        case "cp": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9265;
        }
        case "mv": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9266;
        }
        case "touch": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9267;
        }
        case "find": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9268;
        }
        case "head": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9269;
        }
        case "tail": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9270;
        }
        case "wc": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9271;
        }
        case "strings": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9272;
        }
        case "split": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9273;
        }
        case "tar": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9274;
        }
        case "awk": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9275;
        }
        case "jq": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9276;
        }
        case "true": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9277;
        }
        case "false": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9278;
        }
        case "rmdir": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9279;
        }
        case "stat": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9280;
        }
        case "file": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9281;
        }
        case "tree": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9282;
        }
        case "du": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9283;
        }
        case "chmod": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9284;
        }
        case "ln": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9285;
        }
        case "readlink": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9286;
        }
        case "diff": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9287;
        }
        case "cmp": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9288;
        }
        case "comm": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9289;
        }
        case "base64": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9290;
        }
        case "expr": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9291;
        }
        case "yq": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9292;
        }
        case "xan": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9293;
        }
        case "csvlook": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9294;
        }
        case "md5sum": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9295;
        }
        case "sha1sum": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9296;
        }
        case "sha256sum": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9297;
        }
        case "gzip": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9298;
        }
        case "gunzip": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9299;
        }
        case "zcat": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9300;
        }
        case "curl": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9301;
        }
        case "html-to-markdown": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9302;
        }
        case "python3": {
          break _L$2;
        }
        case "python": {
          break _L$2;
        }
        case "js-exec": {
          break _L;
        }
        case "node": {
          break _L;
        }
        case "sqlite3": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9303;
        }
        case "__moon_bash_custom__": {
          return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9304;
        }
        default: {
          return undefined;
        }
      }
    }
    return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9257;
  }
  return _M0FP410Haoxincode8moonbash3lib8commands13find__commandN6constrS9256;
}
function _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self) {
  if (self.pos >= self.source.length) {
    return 0;
  } else {
    const _p$4 = self.source;
    const _p$5 = self.pos;
    $bound_check(_p$4, _p$5);
    return _p$4.charCodeAt(_p$5);
  }
}
function _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self) {
  const ch = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self);
  self.pos = self.pos + 1 | 0;
  return ch;
}
function _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, tok) {
  if (self.tokens.length >= 100000) {
    return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError("token count exceeds maximum of 100000"));
  }
  return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(_M0MPC15array5Array4pushGUssEE(self.tokens, tok));
}
function _M0FP410Haoxincode8moonbash3lib5lexer15is__name__start(ch) {
  return ch >= 97 && ch <= 122 || (ch >= 65 && ch <= 90 || ch === 95);
}
function _M0FP410Haoxincode8moonbash3lib5lexer14is__name__char(ch) {
  return _M0FP410Haoxincode8moonbash3lib5lexer15is__name__start(ch) || ch >= 48 && ch <= 57;
}
function _M0FP410Haoxincode8moonbash3lib5lexer40assignment__name__prefix__bracket__depth(word) {
  if (word.length === 0) {
    return undefined;
  }
  const _p$4 = 0;
  $bound_check(word, _p$4);
  if (!_M0FP410Haoxincode8moonbash3lib5lexer15is__name__start(word.charCodeAt(_p$4))) {
    return undefined;
  }
  let i = 1;
  while (true) {
    let _tmp$38;
    if (i < word.length) {
      const _p$5 = i;
      $bound_check(word, _p$5);
      _tmp$38 = _M0FP410Haoxincode8moonbash3lib5lexer14is__name__char(word.charCodeAt(_p$5));
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let depth = 0;
  while (true) {
    if (i < word.length) {
      if (depth === 0) {
        const _p$5 = i;
        $bound_check(word, _p$5);
        if (word.charCodeAt(_p$5) !== 91) {
          return undefined;
        }
        depth = 1;
        i = i + 1 | 0;
        continue;
      }
      const _p$5 = i;
      $bound_check(word, _p$5);
      const ch = word.charCodeAt(_p$5);
      if (ch === 91) {
        depth = depth + 1 | 0;
      } else {
        if (ch === 93) {
          depth = depth - 1 | 0;
        }
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return depth;
}
function _M0FP410Haoxincode8moonbash3lib5lexer26buf__has__trailing__dollar(buf) {
  const text = buf.val;
  if (text.length > 0) {
    const _p$4 = text.length - 1 | 0;
    $bound_check(text, _p$4);
    return text.charCodeAt(_p$4) === 36;
  } else {
    return false;
  }
}
function _M0FP410Haoxincode8moonbash3lib5lexer15is__all__digits(s) {
  if (s.length === 0) {
    return false;
  }
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const _p$4 = s.charCodeAt(i);
      if (!(_p$4 >= 48 && _p$4 <= 57)) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0FP410Haoxincode8moonbash3lib5lexer12is__metachar(ch) {
  return ch === 124 || (ch === 38 || (ch === 59 || (ch === 40 || (ch === 41 || (ch === 60 || (ch === 62 || (ch === 10 || (ch === 32 || ch === 9))))))));
}
function _M0FP410Haoxincode8moonbash3lib5lexer16lookup__reserved(word) {
  switch (word) {
    case "if": {
      return _M0DTP410Haoxincode8moonbash3lib3ast5Token2If__;
    }
    case "then": {
      return _M0DTP410Haoxincode8moonbash3lib3ast5Token4Then__;
    }
    case "elif": {
      return _M0DTP410Haoxincode8moonbash3lib3ast5Token4Elif__;
    }
    case "else": {
      return _M0DTP410Haoxincode8moonbash3lib3ast5Token4Else__;
    }
    case "fi": {
      return _M0DTP410Haoxincode8moonbash3lib3ast5Token2Fi__;
    }
    case "for": {
      return _M0DTP410Haoxincode8moonbash3lib3ast5Token3For__;
    }
    case "while": {
      return _M0DTP410Haoxincode8moonbash3lib3ast5Token5While__;
    }
    case "until": {
      return _M0DTP410Haoxincode8moonbash3lib3ast5Token5Until__;
    }
    case "do": {
      return _M0DTP410Haoxincode8moonbash3lib3ast5Token2Do__;
    }
    case "done": {
      return _M0DTP410Haoxincode8moonbash3lib3ast5Token4Done__;
    }
    case "case": {
      return _M0DTP410Haoxincode8moonbash3lib3ast5Token4Case__;
    }
    case "esac": {
      return _M0DTP410Haoxincode8moonbash3lib3ast5Token4Esac__;
    }
    case "in": {
      return _M0DTP410Haoxincode8moonbash3lib3ast5Token2In__;
    }
    case "function": {
      return _M0DTP410Haoxincode8moonbash3lib3ast5Token8Function__;
    }
    case "time": {
      return _M0DTP410Haoxincode8moonbash3lib3ast5Token4Time__;
    }
    case "!": {
      return _M0DTP410Haoxincode8moonbash3lib3ast5Token4Bang__;
    }
    default: {
      return undefined;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib5lexer10parse__int(s) {
  let result = 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      const _tmp$39 = Math.imul(result, 10) | 0;
      $bound_check(s, i);
      result = _tmp$39 + (s.charCodeAt(i) - 48 | 0) | 0;
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return result;
}
function _M0FP410Haoxincode8moonbash3lib5lexer12parse__int64(s) {
  let result = 0n;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      const _tmp$39 = BigInt.asUintN(64, result * 10n);
      $bound_check(s, i);
      result = BigInt.asUintN(64, _tmp$39 + BigInt.asUintN(64, BigInt(s.charCodeAt(i) - 48 | 0)));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return result;
}
function _M0FP410Haoxincode8moonbash3lib5lexer31find__assignment__operator__pos(word) {
  let bracket_depth = 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < word.length) {
      _L: {
        $bound_check(word, i);
        const ch = word.charCodeAt(i);
        if (ch === 91) {
          bracket_depth = bracket_depth + 1 | 0;
          break _L;
        }
        if (ch === 93) {
          if (bracket_depth > 0) {
            bracket_depth = bracket_depth - 1 | 0;
          }
          break _L;
        }
        if (ch === 61 && bracket_depth === 0) {
          return i;
        }
        break _L;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410Haoxincode8moonbash3lib5lexer28parse__assignment__name__end(word, eq_pos) {
  if (eq_pos <= 0) {
    return undefined;
  }
  let append;
  if (eq_pos >= 2) {
    const _p$4 = eq_pos - 1 | 0;
    $bound_check(word, _p$4);
    append = word.charCodeAt(_p$4) === 43;
  } else {
    append = false;
  }
  const name_end = append ? eq_pos - 1 | 0 : eq_pos;
  if (name_end <= 0) {
    return undefined;
  }
  const _p$4 = 0;
  $bound_check(word, _p$4);
  if (!_M0FP410Haoxincode8moonbash3lib5lexer15is__name__start(word.charCodeAt(_p$4))) {
    return undefined;
  }
  let i = 1;
  while (true) {
    let _tmp$38;
    if (i < name_end) {
      const _p$5 = i;
      $bound_check(word, _p$5);
      _tmp$38 = _M0FP410Haoxincode8moonbash3lib5lexer14is__name__char(word.charCodeAt(_p$5));
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (i < name_end) {
      const _p$5 = i;
      $bound_check(word, _p$5);
      if (word.charCodeAt(_p$5) !== 91) {
        return undefined;
      }
      i = i + 1 | 0;
      let depth = 1;
      while (true) {
        if (i < name_end && depth > 0) {
          const _p$6 = i;
          $bound_check(word, _p$6);
          const ch = word.charCodeAt(_p$6);
          if (ch === 91) {
            depth = depth + 1 | 0;
            i = i + 1 | 0;
            continue;
          }
          if (ch === 93) {
            depth = depth - 1 | 0;
            if (depth === 0) {
              i = i + 1 | 0;
              break;
            }
            i = i + 1 | 0;
            continue;
          }
          i = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      if (depth !== 0) {
        return undefined;
      }
      continue;
    } else {
      break;
    }
  }
  return name_end;
}
function _M0FP410Haoxincode8moonbash3lib5lexer6substr(s, start, end) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = start;
  while (true) {
    const i = _tmp$38;
    if (i < end && i < s.length) {
      $bound_check(s, i);
      _M0IPB13StringBuilderPB6Logger11write__char(buf, s.charCodeAt(i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function _M0FP410Haoxincode8moonbash3lib5lexer22try__split__assignment(word) {
  const eq_pos = _M0FP410Haoxincode8moonbash3lib5lexer31find__assignment__operator__pos(word);
  if (eq_pos <= 0) {
    return undefined;
  }
  let append;
  if (eq_pos >= 2) {
    const _p$4 = eq_pos - 1 | 0;
    $bound_check(word, _p$4);
    append = word.charCodeAt(_p$4) === 43;
  } else {
    append = false;
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib5lexer28parse__assignment__name__end(word, eq_pos);
  let actual_name_end;
  if (_bind$4 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$4;
    actual_name_end = _Some;
  }
  const name = _M0FP410Haoxincode8moonbash3lib5lexer6substr(word, 0, actual_name_end);
  const value = _M0FP410Haoxincode8moonbash3lib5lexer6substr(word, eq_pos + 1 | 0, word.length);
  return { _0: name, _1: value, _2: append };
}
function _M0FP410Haoxincode8moonbash3lib5lexer37word__looks__like__assignment__prefix(word) {
  if (word.length < 2) {
    return false;
  }
  const eq_pos = _M0FP410Haoxincode8moonbash3lib5lexer31find__assignment__operator__pos(word);
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib5lexer28parse__assignment__name__end(word, eq_pos);
  return !(_bind$4 === undefined);
}
function _M0FP410Haoxincode8moonbash3lib5lexer47token__allows__assignment__prefix__continuation(tok) {
  switch (tok.$tag) {
    case 2: {
      return true;
    }
    case 10: {
      return true;
    }
    case 11: {
      return true;
    }
    case 12: {
      return true;
    }
    case 13: {
      return true;
    }
    case 14: {
      return true;
    }
    case 15: {
      return true;
    }
    case 16: {
      return true;
    }
    case 17: {
      return true;
    }
    case 18: {
      return true;
    }
    case 19: {
      return true;
    }
    case 20: {
      return true;
    }
    case 21: {
      return true;
    }
    case 46: {
      return true;
    }
    default: {
      return false;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib5lexer36token__starts__new__command__context(tok) {
  switch (tok.$tag) {
    case 9: {
      return true;
    }
    case 7: {
      return true;
    }
    case 5: {
      return true;
    }
    case 6: {
      return true;
    }
    case 3: {
      return true;
    }
    case 4: {
      return true;
    }
    case 8: {
      return true;
    }
    case 22: {
      return true;
    }
    case 28: {
      return true;
    }
    case 29: {
      return true;
    }
    case 30: {
      return true;
    }
    case 31: {
      return true;
    }
    case 36: {
      return true;
    }
    case 34: {
      return true;
    }
    case 35: {
      return true;
    }
    case 33: {
      return true;
    }
    case 40: {
      return true;
    }
    case 38: {
      return true;
    }
    case 41: {
      return true;
    }
    case 43: {
      return true;
    }
    case 44: {
      return true;
    }
    case 24: {
      return true;
    }
    case 25: {
      return true;
    }
    default: {
      return false;
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib5lexer5Lexer32is__assignment__prefix__position(self) {
  if (self.tokens.length === 0) {
    return true;
  }
  let i = self.tokens.length;
  while (true) {
    if (i > 0) {
      i = i - 1 | 0;
      const tok = _M0MPC15array5Array2atGUssEE(self.tokens, i);
      if (_M0FP410Haoxincode8moonbash3lib5lexer47token__allows__assignment__prefix__continuation(tok)) {
        continue;
      }
      if (_M0FP410Haoxincode8moonbash3lib5lexer36token__starts__new__command__context(tok)) {
        return true;
      }
      return false;
    } else {
      break;
    }
  }
  return true;
}
function _M0MP410Haoxincode8moonbash3lib5lexer5Lexer8peek__at(self, offset) {
  const idx = self.pos + offset | 0;
  if (idx >= self.source.length) {
    return 0;
  } else {
    const _p$4 = self.source;
    $bound_check(_p$4, idx);
    return _p$4.charCodeAt(idx);
  }
}
function _M0MP410Haoxincode8moonbash3lib5lexer5Lexer20scan__ansi__c__quote(self, buf) {
  self.pos = self.pos + 1 | 0;
  let escaped = false;
  let has_content = false;
  while (true) {
    if (!(self.pos >= self.source.length)) {
      const ch = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self);
      if (ch === 39 && !escaped) {
        if (!has_content) {
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 1);
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 0);
        }
        return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(undefined);
      }
      _M0IPB13StringBuilderPB6Logger11write__char(buf, 1);
      _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      has_content = true;
      if (ch === 92 && !escaped) {
        escaped = true;
      } else {
        escaped = false;
      }
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError("unterminated ansi-c quote"));
}
function _M0MP410Haoxincode8moonbash3lib5lexer5Lexer26scan__backtick__into__word(self, buf) {
  _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self));
  let escaped = false;
  while (true) {
    if (!(self.pos >= self.source.length)) {
      const ch = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self);
      _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      if (escaped) {
        escaped = false;
        continue;
      }
      if (ch === 92) {
        escaped = true;
        continue;
      }
      if (ch === 96) {
        return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(undefined);
      }
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError("unterminated backtick command substitution"));
}
function _M0MP410Haoxincode8moonbash3lib5lexer5Lexer31scan__dollar__brace__into__word(self, buf) {
  _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self));
  _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self));
  let depth = 1;
  let in_single = false;
  let in_double = false;
  let escaped = false;
  while (true) {
    if (!(self.pos >= self.source.length)) {
      const ch = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self);
      _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      if (escaped) {
        escaped = false;
        continue;
      }
      if (in_single) {
        if (ch === 39) {
          in_single = false;
        }
        continue;
      }
      if (in_double) {
        if (ch === 34) {
          in_double = false;
        } else {
          if (ch === 92) {
            escaped = true;
          }
        }
        continue;
      }
      if (ch === 92) {
        escaped = true;
        continue;
      }
      if (ch === 39) {
        in_single = true;
        continue;
      }
      if (ch === 34) {
        in_double = true;
        continue;
      }
      if (ch === 123) {
        depth = depth + 1 | 0;
      } else {
        if (ch === 125) {
          depth = depth - 1 | 0;
          if (depth === 0) {
            return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(undefined);
          }
        }
      }
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError("unterminated parameter expansion"));
}
function _M0MP410Haoxincode8moonbash3lib5lexer5Lexer33scan__dollar__bracket__into__word(self, buf) {
  _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self));
  _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self));
  let depth = 1;
  let in_single = false;
  let in_double = false;
  let escaped = false;
  while (true) {
    if (!(self.pos >= self.source.length)) {
      const ch = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self);
      _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      if (escaped) {
        escaped = false;
        continue;
      }
      if (in_single) {
        if (ch === 39) {
          in_single = false;
        }
        continue;
      }
      if (in_double) {
        if (ch === 34) {
          in_double = false;
        } else {
          if (ch === 92) {
            escaped = true;
          }
        }
        continue;
      }
      if (ch === 92) {
        escaped = true;
        continue;
      }
      if (ch === 39) {
        in_single = true;
        continue;
      }
      if (ch === 34) {
        in_double = true;
        continue;
      }
      if (ch === 91) {
        depth = depth + 1 | 0;
        continue;
      }
      if (ch === 93) {
        depth = depth - 1 | 0;
        if (depth === 0) {
          return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(undefined);
        }
      }
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError("unterminated legacy arithmetic expansion"));
}
function _M0MP410Haoxincode8moonbash3lib5lexer5Lexer39scan__dollar__paren__into__word_2einner(self, buf, arithmetic) {
  _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self));
  _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self));
  let depth = arithmetic ? 0 : 1;
  if (arithmetic) {
    _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self));
  }
  let in_single = false;
  let in_double = false;
  let escaped = false;
  while (true) {
    if (!(self.pos >= self.source.length)) {
      if (arithmetic && (!in_single && (!in_double && (!escaped && (depth === 0 && (_M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self) === 41 && _M0MP410Haoxincode8moonbash3lib5lexer5Lexer8peek__at(self, 1) === 41)))))) {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self));
        _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self));
        return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(undefined);
      }
      const ch = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self);
      _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      if (escaped) {
        escaped = false;
        continue;
      }
      if (in_single) {
        if (ch === 39) {
          in_single = false;
        }
        continue;
      }
      if (in_double) {
        if (ch === 34) {
          in_double = false;
        } else {
          if (ch === 92) {
            escaped = true;
          }
        }
        continue;
      }
      if (ch === 92) {
        escaped = true;
        continue;
      }
      if (ch === 39) {
        in_single = true;
        continue;
      }
      if (ch === 34) {
        in_double = true;
        continue;
      }
      if (ch === 40) {
        depth = depth + 1 | 0;
        continue;
      }
      if (ch === 41) {
        if (arithmetic) {
          if (depth > 0) {
            depth = depth - 1 | 0;
          }
        } else {
          depth = depth - 1 | 0;
          if (depth === 0) {
            return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(undefined);
          }
        }
      }
      continue;
    } else {
      break;
    }
  }
  if (arithmetic) {
    return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError("unterminated arithmetic expansion"));
  } else {
    return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError("unterminated command substitution"));
  }
}
function _M0MP410Haoxincode8moonbash3lib5lexer5Lexer19scan__double__quote(self, buf) {
  self.pos = self.pos + 1 | 0;
  _M0IPB13StringBuilderPB6Logger11write__char(buf, 2);
  while (true) {
    if (!(self.pos >= self.source.length)) {
      if (_M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self) === 36 && _M0MP410Haoxincode8moonbash3lib5lexer5Lexer8peek__at(self, 1) === 123) {
        const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer31scan__dollar__brace__into__word(self, buf);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          _ok._0;
        } else {
          return _bind$4;
        }
        continue;
      }
      if (_M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self) === 36 && _M0MP410Haoxincode8moonbash3lib5lexer5Lexer8peek__at(self, 1) === 40) {
        if (_M0MP410Haoxincode8moonbash3lib5lexer5Lexer8peek__at(self, 2) === 40) {
          const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer39scan__dollar__paren__into__word_2einner(self, buf, true);
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            _ok._0;
          } else {
            return _bind$4;
          }
        } else {
          const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer39scan__dollar__paren__into__word_2einner(self, buf, false);
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            _ok._0;
          } else {
            return _bind$4;
          }
        }
        continue;
      }
      if (_M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self) === 36 && _M0MP410Haoxincode8moonbash3lib5lexer5Lexer8peek__at(self, 1) === 91) {
        const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer33scan__dollar__bracket__into__word(self, buf);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          _ok._0;
        } else {
          return _bind$4;
        }
        continue;
      }
      if (_M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self) === 96) {
        const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer26scan__backtick__into__word(self, buf);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          _ok._0;
        } else {
          return _bind$4;
        }
        continue;
      }
      const ch = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self);
      switch (ch) {
        case 34: {
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 3);
          return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(undefined);
        }
        case 92: {
          if (!(self.pos >= self.source.length)) {
            const next = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self);
            if (next === 36 || (next === 96 || (next === 34 || next === 92))) {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
              _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self));
            } else {
              if (next === 10) {
                _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self);
              } else {
                _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
              }
            }
          } else {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
          }
          break;
        }
        default: {
          _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
        }
      }
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError("unterminated double quote"));
}
function _M0MP410Haoxincode8moonbash3lib5lexer5Lexer38scan__parenthesized__assignment__value(self, buf) {
  let depth = 0;
  let in_single = false;
  let in_double = false;
  let single_quote_has_content = false;
  while (true) {
    if (!(self.pos >= self.source.length)) {
      if (in_single) {
        const ch = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self);
        if (ch === 39) {
          if (!single_quote_has_content) {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 1);
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 0);
          }
          in_single = false;
        } else {
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 1);
          _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
          single_quote_has_content = true;
        }
        continue;
      }
      if (in_double) {
        if (_M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self) === 36 && _M0MP410Haoxincode8moonbash3lib5lexer5Lexer8peek__at(self, 1) === 123) {
          const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer31scan__dollar__brace__into__word(self, buf);
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            _ok._0;
          } else {
            return _bind$4;
          }
          continue;
        }
        if (_M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self) === 36 && _M0MP410Haoxincode8moonbash3lib5lexer5Lexer8peek__at(self, 1) === 40) {
          if (_M0MP410Haoxincode8moonbash3lib5lexer5Lexer8peek__at(self, 2) === 40) {
            const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer39scan__dollar__paren__into__word_2einner(self, buf, true);
            if (_bind$4.$tag === 1) {
              const _ok = _bind$4;
              _ok._0;
            } else {
              return _bind$4;
            }
          } else {
            const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer39scan__dollar__paren__into__word_2einner(self, buf, false);
            if (_bind$4.$tag === 1) {
              const _ok = _bind$4;
              _ok._0;
            } else {
              return _bind$4;
            }
          }
          continue;
        }
        if (_M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self) === 36 && _M0MP410Haoxincode8moonbash3lib5lexer5Lexer8peek__at(self, 1) === 91) {
          const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer33scan__dollar__bracket__into__word(self, buf);
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            _ok._0;
          } else {
            return _bind$4;
          }
          continue;
        }
        if (_M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self) === 96) {
          const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer26scan__backtick__into__word(self, buf);
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            _ok._0;
          } else {
            return _bind$4;
          }
          continue;
        }
        const ch = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self);
        if (ch === 34) {
          in_double = false;
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 3);
          continue;
        }
        if (ch === 92) {
          if (!(self.pos >= self.source.length)) {
            const next = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self);
            if (next === 36 || (next === 96 || (next === 34 || (next === 92 || next === 10)))) {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self));
            } else {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
            }
          } else {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
          }
        } else {
          _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
        }
        continue;
      }
      const ch = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self);
      switch (ch) {
        case 39: {
          self.pos = self.pos + 1 | 0;
          in_single = true;
          single_quote_has_content = false;
          break;
        }
        case 34: {
          self.pos = self.pos + 1 | 0;
          in_double = true;
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 2);
          break;
        }
        case 92: {
          self.pos = self.pos + 1 | 0;
          if (!(self.pos >= self.source.length)) {
            const next = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self);
            if (next === 36 || (next === 96 || (next === 92 || (next === 34 || next === 39)))) {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
            }
            _M0IPB13StringBuilderPB6Logger11write__char(buf, next);
          }
          break;
        }
        default: {
          self.pos = self.pos + 1 | 0;
          _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
          if (ch === 40) {
            depth = depth + 1 | 0;
          } else {
            if (ch === 41) {
              depth = depth - 1 | 0;
              if (depth === 0) {
                return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(undefined);
              }
            }
          }
        }
      }
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError("unterminated parenthesized assignment value"));
}
function _M0MP410Haoxincode8moonbash3lib5lexer5Lexer19scan__single__quote(self, buf) {
  self.pos = self.pos + 1 | 0;
  let has_content = false;
  while (true) {
    if (!(self.pos >= self.source.length)) {
      const ch = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self);
      if (ch === 39) {
        if (!has_content) {
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 1);
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 0);
        }
        return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(undefined);
      }
      _M0IPB13StringBuilderPB6Logger11write__char(buf, 1);
      _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      has_content = true;
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError("unterminated single quote"));
}
function _M0MP410Haoxincode8moonbash3lib5lexer5Lexer10scan__word(self) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let had_quoted = false;
  while (true) {
    if (!(self.pos >= self.source.length)) {
      const ch = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self);
      if (ch === 36 && _M0MP410Haoxincode8moonbash3lib5lexer5Lexer8peek__at(self, 1) === 123) {
        const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer31scan__dollar__brace__into__word(self, buf);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          _ok._0;
        } else {
          return _bind$4;
        }
        continue;
      }
      if (ch === 36 && _M0MP410Haoxincode8moonbash3lib5lexer5Lexer8peek__at(self, 1) === 40) {
        if (_M0MP410Haoxincode8moonbash3lib5lexer5Lexer8peek__at(self, 2) === 40) {
          const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer39scan__dollar__paren__into__word_2einner(self, buf, true);
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            _ok._0;
          } else {
            return _bind$4;
          }
        } else {
          const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer39scan__dollar__paren__into__word_2einner(self, buf, false);
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            _ok._0;
          } else {
            return _bind$4;
          }
        }
        continue;
      }
      if (ch === 36 && _M0MP410Haoxincode8moonbash3lib5lexer5Lexer8peek__at(self, 1) === 91) {
        const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer33scan__dollar__bracket__into__word(self, buf);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          _ok._0;
        } else {
          return _bind$4;
        }
        continue;
      }
      if (ch === 96) {
        const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer26scan__backtick__into__word(self, buf);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          _ok._0;
        } else {
          return _bind$4;
        }
        continue;
      }
      if (ch === 40) {
        const current = buf.val;
        if (_M0FP410Haoxincode8moonbash3lib5lexer37word__looks__like__assignment__prefix(current)) {
          const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer38scan__parenthesized__assignment__value(self, buf);
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            _ok._0;
          } else {
            return _bind$4;
          }
          continue;
        }
      }
      if (_M0FP410Haoxincode8moonbash3lib5lexer12is__metachar(ch)) {
        let keep_scanning = false;
        if ((ch === 32 || ch === 9) && _M0MP410Haoxincode8moonbash3lib5lexer5Lexer32is__assignment__prefix__position(self)) {
          const _bind$4 = _M0FP410Haoxincode8moonbash3lib5lexer40assignment__name__prefix__bracket__depth(buf.val);
          if (_bind$4 === undefined) {
          } else {
            const _Some = _bind$4;
            const _depth = _Some;
            keep_scanning = _depth > 0;
          }
        }
        if (!keep_scanning) {
          break;
        }
      }
      switch (ch) {
        case 39: {
          had_quoted = true;
          if (_M0FP410Haoxincode8moonbash3lib5lexer26buf__has__trailing__dollar(buf)) {
            const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer20scan__ansi__c__quote(self, buf);
            if (_bind$4.$tag === 1) {
              const _ok = _bind$4;
              _ok._0;
            } else {
              return _bind$4;
            }
          } else {
            const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer19scan__single__quote(self, buf);
            if (_bind$4.$tag === 1) {
              const _ok = _bind$4;
              _ok._0;
            } else {
              return _bind$4;
            }
          }
          break;
        }
        case 34: {
          had_quoted = true;
          const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer19scan__double__quote(self, buf);
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            _ok._0;
          } else {
            return _bind$4;
          }
          break;
        }
        case 92: {
          self.pos = self.pos + 1 | 0;
          if (!(self.pos >= self.source.length)) {
            const next = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self);
            if (next !== 10) {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, next);
            }
          }
          break;
        }
        default: {
          _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self));
        }
      }
      continue;
    } else {
      break;
    }
  }
  const word = buf.val;
  if (word.length === 0) {
    if (had_quoted) {
      const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0MP410Haoxincode8moonbash3lib5lexer5Lexer10scan__wordN6constrS288);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        _ok._0;
      } else {
        return _bind$4;
      }
    }
    return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(undefined);
  }
  if (_M0FP410Haoxincode8moonbash3lib5lexer15is__all__digits(word) && !(self.pos >= self.source.length)) {
    const next = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self);
    if (next === 60 || next === 62) {
      const num = _M0FP410Haoxincode8moonbash3lib5lexer10parse__int(word);
      const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, new _M0DTP410Haoxincode8moonbash3lib3ast5Token8FdNumber(num));
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        _ok._0;
      } else {
        return _bind$4;
      }
      return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(undefined);
    }
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib5lexer22try__split__assignment(word);
  if (_bind$4 === undefined) {
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _name = _x._0;
    const _value = _x._1;
    const _append = _x._2;
    const _bind$5 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, new _M0DTP410Haoxincode8moonbash3lib3ast5Token14AssignmentWord(_name, _value, _append));
    if (_bind$5.$tag === 1) {
      const _ok = _bind$5;
      _ok._0;
    } else {
      return _bind$5;
    }
    return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(undefined);
  }
  const _bind$5 = _M0FP410Haoxincode8moonbash3lib5lexer16lookup__reserved(word);
  if (_bind$5 === undefined) {
    return _M0FP410Haoxincode8moonbash3lib5lexer15is__all__digits(word) ? _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, new _M0DTP410Haoxincode8moonbash3lib3ast5Token6Number(_M0FP410Haoxincode8moonbash3lib5lexer12parse__int64(word))) : _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, new _M0DTP410Haoxincode8moonbash3lib3ast5Token4Word(word));
  } else {
    const _Some = _bind$5;
    const _tok = _Some;
    return _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _tok);
  }
}
function _M0MP410Haoxincode8moonbash3lib5lexer5Lexer13skip__comment(self) {
  while (true) {
    if (!(self.pos >= self.source.length) && _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self) !== 10) {
      self.pos = self.pos + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib5lexer25is__brace__boundary__char(ch) {
  return ch === 0 || (ch === 32 || (ch === 9 || (ch === 10 || (ch === 59 || (ch === 124 || (ch === 38 || (ch === 40 || (ch === 41 || (ch === 60 || ch === 62)))))))));
}
function _M0MP410Haoxincode8moonbash3lib5lexer5Lexer19brace__is__operator(self) {
  let prev;
  if (self.pos === 0) {
    prev = 0;
  } else {
    const _p$4 = self.source;
    const _p$5 = self.pos - 1 | 0;
    $bound_check(_p$4, _p$5);
    prev = _p$4.charCodeAt(_p$5);
  }
  const next = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer8peek__at(self, 1);
  return _M0FP410Haoxincode8moonbash3lib5lexer25is__brace__boundary__char(prev) && _M0FP410Haoxincode8moonbash3lib5lexer25is__brace__boundary__char(next);
}
function _M0MP410Haoxincode8moonbash3lib5lexer5Lexer18scan__redirect__in(self) {
  self.pos = self.pos + 1 | 0;
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self);
  switch (_bind$4) {
    case 60: {
      self.pos = self.pos + 1 | 0;
      if (_M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self) === 60) {
        self.pos = self.pos + 1 | 0;
        return _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token10HereString__);
      } else {
        if (_M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self) === 45) {
          self.pos = self.pos + 1 | 0;
          return _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token12HereDocStrip__);
        } else {
          return _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token7HereDoc__);
        }
      }
    }
    case 38: {
      self.pos = self.pos + 1 | 0;
      return _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token5DupIn__);
    }
    case 62: {
      self.pos = self.pos + 1 | 0;
      return _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token13RedirectInOut__);
    }
    default: {
      return _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token10RedirectIn__);
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib5lexer5Lexer19scan__redirect__out(self) {
  self.pos = self.pos + 1 | 0;
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self);
  switch (_bind$4) {
    case 62: {
      self.pos = self.pos + 1 | 0;
      return _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token14RedirectAppend__);
    }
    case 124: {
      self.pos = self.pos + 1 | 0;
      return _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token15RedirectClobber__);
    }
    case 38: {
      self.pos = self.pos + 1 | 0;
      return _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token6DupOut__);
    }
    default: {
      return _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token11RedirectOut__);
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib5lexer5Lexer19try__scan__operator(self) {
  const ch = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self);
  let _tmp$38;
  switch (ch) {
    case 124: {
      self.pos = self.pos + 1 | 0;
      if (_M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self) === 124) {
        self.pos = self.pos + 1 | 0;
        const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token2Or__);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          _ok._0;
        } else {
          return _bind$4;
        }
      } else {
        if (_M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self) === 38) {
          self.pos = self.pos + 1 | 0;
          const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token7PipeAnd__);
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            _ok._0;
          } else {
            return _bind$4;
          }
        } else {
          const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token4Pipe__);
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            _ok._0;
          } else {
            return _bind$4;
          }
        }
      }
      _tmp$38 = true;
      break;
    }
    case 38: {
      self.pos = self.pos + 1 | 0;
      if (_M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self) === 38) {
        self.pos = self.pos + 1 | 0;
        const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token3And__);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          _ok._0;
        } else {
          return _bind$4;
        }
      } else {
        if (_M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self) === 62) {
          self.pos = self.pos + 1 | 0;
          if (_M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self) === 62) {
            self.pos = self.pos + 1 | 0;
            const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token17RedirectAndAppend__);
            if (_bind$4.$tag === 1) {
              const _ok = _bind$4;
              _ok._0;
            } else {
              return _bind$4;
            }
          } else {
            const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token14RedirectAndOut__);
            if (_bind$4.$tag === 1) {
              const _ok = _bind$4;
              _ok._0;
            } else {
              return _bind$4;
            }
          }
        } else {
          const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token9Ampersand__);
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            _ok._0;
          } else {
            return _bind$4;
          }
        }
      }
      _tmp$38 = true;
      break;
    }
    case 59: {
      self.pos = self.pos + 1 | 0;
      if (_M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self) === 59) {
        self.pos = self.pos + 1 | 0;
        const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token4Semi__);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          _ok._0;
        } else {
          return _bind$4;
        }
        const _bind$5 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token4Semi__);
        if (_bind$5.$tag === 1) {
          const _ok = _bind$5;
          _ok._0;
        } else {
          return _bind$5;
        }
      } else {
        const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token4Semi__);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          _ok._0;
        } else {
          return _bind$4;
        }
      }
      _tmp$38 = true;
      break;
    }
    case 40: {
      self.pos = self.pos + 1 | 0;
      const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token9LeftParen__);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        _ok._0;
      } else {
        return _bind$4;
      }
      _tmp$38 = true;
      break;
    }
    case 41: {
      self.pos = self.pos + 1 | 0;
      const _bind$5 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token10RightParen__);
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        _ok._0;
      } else {
        return _bind$5;
      }
      _tmp$38 = true;
      break;
    }
    case 123: {
      if (_M0MP410Haoxincode8moonbash3lib5lexer5Lexer19brace__is__operator(self)) {
        self.pos = self.pos + 1 | 0;
        const _bind$6 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token9LeftBrace__);
        if (_bind$6.$tag === 1) {
          const _ok = _bind$6;
          _ok._0;
        } else {
          return _bind$6;
        }
        _tmp$38 = true;
      } else {
        _tmp$38 = false;
      }
      break;
    }
    case 125: {
      if (_M0MP410Haoxincode8moonbash3lib5lexer5Lexer19brace__is__operator(self)) {
        self.pos = self.pos + 1 | 0;
        const _bind$6 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token10RightBrace__);
        if (_bind$6.$tag === 1) {
          const _ok = _bind$6;
          _ok._0;
        } else {
          return _bind$6;
        }
        _tmp$38 = true;
      } else {
        _tmp$38 = false;
      }
      break;
    }
    case 60: {
      const _bind$6 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer18scan__redirect__in(self);
      if (_bind$6.$tag === 1) {
        const _ok = _bind$6;
        _ok._0;
      } else {
        return _bind$6;
      }
      _tmp$38 = true;
      break;
    }
    case 62: {
      const _bind$7 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer19scan__redirect__out(self);
      if (_bind$7.$tag === 1) {
        const _ok = _bind$7;
        _ok._0;
      } else {
        return _bind$7;
      }
      _tmp$38 = true;
      break;
    }
    default: {
      _tmp$38 = false;
    }
  }
  return new _M0DTPC16result6ResultGbRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(_tmp$38);
}
function _M0MP410Haoxincode8moonbash3lib5lexer5Lexer12scan__tokens(self) {
  while (true) {
    if (!(self.pos >= self.source.length)) {
      const ch = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4peek(self);
      if (ch === 32 || ch === 9) {
        self.pos = self.pos + 1 | 0;
        continue;
      }
      if (ch === 10) {
        _M0MP410Haoxincode8moonbash3lib5lexer5Lexer7advance(self);
        const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token7Newline__);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          _ok._0;
        } else {
          return _bind$4;
        }
        continue;
      }
      if (ch === 35) {
        _M0MP410Haoxincode8moonbash3lib5lexer5Lexer13skip__comment(self);
        continue;
      }
      const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer19try__scan__operator(self);
      let _tmp$38;
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        _tmp$38 = _ok._0;
      } else {
        return _bind$4;
      }
      if (_tmp$38) {
        continue;
      }
      const _bind$5 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer10scan__word(self);
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        _ok._0;
      } else {
        return _bind$5;
      }
      continue;
    } else {
      break;
    }
  }
  return _M0MP410Haoxincode8moonbash3lib5lexer5Lexer4emit(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token3EOF__);
}
function _M0FP410Haoxincode8moonbash3lib5lexer8tokenize(input) {
  if (input.length > 10485760) {
    return new _M0DTPC16result6ResultGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast5TokenERP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError("input exceeds maximum size of 10MB"));
  }
  const lexer = new _M0TP410Haoxincode8moonbash3lib5lexer5Lexer(input, 0, []);
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib5lexer5Lexer12scan__tokens(lexer);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  return new _M0DTPC16result6ResultGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast5TokenERP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(lexer.tokens);
}
function _M0FP410Haoxincode8moonbash3lib6parser17hex__digit__value(ch) {
  if (ch >= 48 && ch <= 57) {
    return ch - 48 | 0;
  }
  if (ch >= 97 && ch <= 102) {
    return (ch - 97 | 0) + 10 | 0;
  }
  if (ch >= 65 && ch <= 70) {
    return (ch - 65 | 0) + 10 | 0;
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib6parser26parse__hex__escape__digits(s, start, max_digits) {
  let i = start;
  let value = 0;
  let consumed = 0;
  while (true) {
    if (i < s.length && consumed < max_digits) {
      const _p$4 = i;
      $bound_check(s, _p$4);
      const ch = s.charCodeAt(_p$4);
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib6parser17hex__digit__value(ch);
      let digit;
      if (_bind$4 === undefined) {
        break;
      } else {
        const _Some = _bind$4;
        digit = _Some;
      }
      value = (Math.imul(value, 16) | 0) + digit | 0;
      i = i + 1 | 0;
      consumed = consumed + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return { _0: value, _1: consumed };
}
function _M0FP410Haoxincode8moonbash3lib6parser28parse__octal__escape__digits(s, start, max_digits) {
  let i = start;
  let value = 0;
  let consumed = 0;
  while (true) {
    if (i < s.length && consumed < max_digits) {
      const _p$4 = i;
      $bound_check(s, _p$4);
      const ch = s.charCodeAt(_p$4);
      if (ch < 48 || ch > 55) {
        break;
      }
      value = (Math.imul(value, 8) | 0) + (ch - 48 | 0) | 0;
      i = i + 1 | 0;
      consumed = consumed + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return { _0: value, _1: consumed };
}
function _M0FP410Haoxincode8moonbash3lib6parser24decode__ansi__c__escapes(s) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  while (true) {
    if (i < s.length) {
      const _p$4 = i;
      $bound_check(s, _p$4);
      const ch = s.charCodeAt(_p$4);
      if (ch !== 92 || (i + 1 | 0) >= s.length) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        i = i + 1 | 0;
        continue;
      }
      const _p$5 = i + 1 | 0;
      $bound_check(s, _p$5);
      const next = s.charCodeAt(_p$5);
      _L: {
        _L$2: {
          switch (next) {
            case 110: {
              _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
              break;
            }
            case 116: {
              _M0IPB13StringBuilderPB6Logger11write__char(out, 9);
              break;
            }
            case 114: {
              _M0IPB13StringBuilderPB6Logger11write__char(out, 13);
              break;
            }
            case 97: {
              _M0IPB13StringBuilderPB6Logger11write__char(out, 7);
              break;
            }
            case 98: {
              _M0IPB13StringBuilderPB6Logger11write__char(out, 8);
              break;
            }
            case 102: {
              _M0IPB13StringBuilderPB6Logger11write__char(out, 12);
              break;
            }
            case 118: {
              _M0IPB13StringBuilderPB6Logger11write__char(out, 11);
              break;
            }
            case 101: {
              break _L$2;
            }
            case 69: {
              break _L$2;
            }
            case 63: {
              _M0IPB13StringBuilderPB6Logger11write__char(out, 63);
              break;
            }
            case 92: {
              _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
              break;
            }
            case 39: {
              _M0IPB13StringBuilderPB6Logger11write__char(out, 39);
              break;
            }
            case 34: {
              _M0IPB13StringBuilderPB6Logger11write__char(out, 34);
              break;
            }
            case 99: {
              if ((i + 2 | 0) < s.length) {
                const _p$6 = i + 2 | 0;
                $bound_check(s, _p$6);
                const ctrl = s.charCodeAt(_p$6) & 31;
                _M0IPB13StringBuilderPB6Logger11write__char(out, ctrl);
                i = i + 1 | 0;
              } else {
                _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
                _M0IPB13StringBuilderPB6Logger11write__char(out, 99);
              }
              break;
            }
            case 120: {
              const _bind$4 = _M0FP410Haoxincode8moonbash3lib6parser26parse__hex__escape__digits(s, i + 2 | 0, 2);
              const _value = _bind$4._0;
              const _consumed = _bind$4._1;
              if (_consumed > 0) {
                _M0IPB13StringBuilderPB6Logger11write__char(out, _value);
                i = i + _consumed | 0;
              } else {
                _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
                _M0IPB13StringBuilderPB6Logger11write__char(out, 120);
              }
              break;
            }
            case 117: {
              const _bind$5 = _M0FP410Haoxincode8moonbash3lib6parser26parse__hex__escape__digits(s, i + 2 | 0, 4);
              const _value$2 = _bind$5._0;
              const _consumed$2 = _bind$5._1;
              if (_consumed$2 === 4) {
                _M0IPB13StringBuilderPB6Logger11write__char(out, _value$2);
                i = i + _consumed$2 | 0;
              } else {
                _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
                _M0IPB13StringBuilderPB6Logger11write__char(out, 117);
              }
              break;
            }
            case 85: {
              const _bind$6 = _M0FP410Haoxincode8moonbash3lib6parser26parse__hex__escape__digits(s, i + 2 | 0, 8);
              const _value$3 = _bind$6._0;
              const _consumed$3 = _bind$6._1;
              if (_consumed$3 === 8) {
                _M0IPB13StringBuilderPB6Logger11write__char(out, _value$3);
                i = i + _consumed$3 | 0;
              } else {
                _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
                _M0IPB13StringBuilderPB6Logger11write__char(out, 85);
              }
              break;
            }
            default: {
              if (next >= 48 && next <= 55) {
                const _bind$7 = _M0FP410Haoxincode8moonbash3lib6parser28parse__octal__escape__digits(s, i + 1 | 0, 3);
                const _value$4 = _bind$7._0;
                const _consumed$4 = _bind$7._1;
                _M0IPB13StringBuilderPB6Logger11write__char(out, _value$4);
                i = i + (_consumed$4 - 1 | 0) | 0;
              } else {
                _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
                _M0IPB13StringBuilderPB6Logger11write__char(out, next);
              }
            }
          }
          break _L;
        }
        _M0IPB13StringBuilderPB6Logger11write__char(out, 27);
      }
      i = i + 2 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib6parser22has__closing__backtick(s, start) {
  let i = start;
  while (true) {
    if (i < s.length) {
      const _p$4 = i;
      $bound_check(s, _p$4);
      const ch = s.charCodeAt(_p$4);
      if (ch === 96) {
        return true;
      }
      if (ch === 92 && (i + 1 | 0) < s.length) {
        i = i + 2 | 0;
      } else {
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib6parser32has__closing__raw__double__quote(s, start) {
  let i = start;
  while (true) {
    if (i < s.length) {
      const _p$4 = i;
      $bound_check(s, _p$4);
      const ch = s.charCodeAt(_p$4);
      if (ch === 34) {
        return true;
      }
      if (ch === 92 && (i + 1 | 0) < s.length) {
        i = i + 2 | 0;
      } else {
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib6parser32has__closing__raw__single__quote(s, start) {
  let i = start;
  while (true) {
    if (i < s.length) {
      const _p$4 = i;
      $bound_check(s, _p$4);
      const ch = s.charCodeAt(_p$4);
      if (ch === 39) {
        return true;
      }
      if (ch === 92 && (i + 1 | 0) < s.length) {
        i = i + 2 | 0;
      } else {
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib6parser16is__special__var(ch) {
  return ch === 63 || (ch === 33 || (ch === 36 || (ch === 35 || (ch === 64 || (ch === 42 || (ch === 45 || ch >= 48 && ch <= 57))))));
}
function _M0FP410Haoxincode8moonbash3lib6parser14is__var__start(ch) {
  return ch >= 97 && ch <= 122 || (ch >= 65 && ch <= 90 || ch === 95);
}
function _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(s, start, end) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = start;
  while (true) {
    if (i < end && i < s.length) {
      const _p$4 = i;
      $bound_check(s, _p$4);
      _M0IPB13StringBuilderPB6Logger11write__char(buf, s.charCodeAt(_p$4));
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function _M0FP410Haoxincode8moonbash3lib6parser23parse__arith__expansion(s, start) {
  let paren_depth = 0;
  let i = start;
  let in_single = false;
  let in_double = false;
  let escaped = false;
  while (true) {
    if (i < s.length) {
      let _tmp$38;
      if (!in_single) {
        let _tmp$39;
        if (!in_double) {
          let _tmp$40;
          if (!escaped) {
            let _tmp$41;
            if (paren_depth === 0) {
              let _tmp$42;
              if ((i + 1 | 0) < s.length) {
                let _tmp$43;
                const _p$4 = i;
                $bound_check(s, _p$4);
                if (s.charCodeAt(_p$4) === 41) {
                  const _p$5 = i + 1 | 0;
                  $bound_check(s, _p$5);
                  _tmp$43 = s.charCodeAt(_p$5) === 41;
                } else {
                  _tmp$43 = false;
                }
                _tmp$42 = _tmp$43;
              } else {
                _tmp$42 = false;
              }
              _tmp$41 = _tmp$42;
            } else {
              _tmp$41 = false;
            }
            _tmp$40 = _tmp$41;
          } else {
            _tmp$40 = false;
          }
          _tmp$39 = _tmp$40;
        } else {
          _tmp$39 = false;
        }
        _tmp$38 = _tmp$39;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        break;
      }
      const _p$4 = i;
      $bound_check(s, _p$4);
      const ch = s.charCodeAt(_p$4);
      if (escaped) {
        escaped = false;
        i = i + 1 | 0;
        continue;
      }
      if (in_single) {
        if (ch === 39) {
          in_single = false;
        }
        i = i + 1 | 0;
        continue;
      }
      if (in_double) {
        if (ch === 34) {
          in_double = false;
        } else {
          if (ch === 92) {
            escaped = true;
          }
        }
        i = i + 1 | 0;
        continue;
      }
      if (ch === 92) {
        escaped = true;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 39) {
        in_single = true;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 34) {
        in_double = true;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 40) {
        paren_depth = paren_depth + 1 | 0;
      } else {
        if (ch === 41) {
          if (paren_depth > 0) {
            paren_depth = paren_depth - 1 | 0;
          }
        }
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const content = _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(s, start, i);
  if ((i + 1 | 0) < s.length) {
    i = i + 2 | 0;
  }
  return { _0: new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart19ArithmeticExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Raw(content)), _1: i };
}
function _M0FP410Haoxincode8moonbash3lib6parser29parse__backtick__substitution(s, start) {
  let i = start;
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  while (true) {
    if (i < s.length) {
      const _p$4 = i;
      $bound_check(s, _p$4);
      const ch = s.charCodeAt(_p$4);
      if (ch === 96) {
        i = i + 1 | 0;
        break;
      }
      if (ch === 92 && (i + 1 | 0) < s.length) {
        const _p$5 = i + 1 | 0;
        $bound_check(s, _p$5);
        const next = s.charCodeAt(_p$5);
        if (next === 96 || (next === 92 || next === 36)) {
          _M0IPB13StringBuilderPB6Logger11write__char(buf, next);
          i = i + 2 | 0;
          continue;
        }
      }
      _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return { _0: new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart19CommandSubstitution(buf.val), _1: i };
}
function _M0FP410Haoxincode8moonbash3lib6parser13is__var__char(ch) {
  return _M0FP410Haoxincode8moonbash3lib6parser14is__var__start(ch) || ch >= 48 && ch <= 57;
}
function _M0FP410Haoxincode8moonbash3lib6parser23parse__param__name__end(content) {
  const len = content.length;
  if (len === 0) {
    return 0;
  }
  const _p$4 = 0;
  $bound_check(content, _p$4);
  if (!_M0FP410Haoxincode8moonbash3lib6parser14is__var__start(content.charCodeAt(_p$4))) {
    return 0;
  }
  let i = 1;
  while (true) {
    let _tmp$38;
    if (i < len) {
      const _p$5 = i;
      $bound_check(content, _p$5);
      _tmp$38 = _M0FP410Haoxincode8moonbash3lib6parser13is__var__char(content.charCodeAt(_p$5));
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  while (true) {
    let _tmp$38;
    if (i < len) {
      const _p$5 = i;
      $bound_check(content, _p$5);
      _tmp$38 = content.charCodeAt(_p$5) === 91;
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      const bracket_start = i;
      i = i + 1 | 0;
      let depth = 1;
      while (true) {
        if (i < len && depth > 0) {
          const _p$5 = i;
          $bound_check(content, _p$5);
          const ch = content.charCodeAt(_p$5);
          if (ch === 91) {
            depth = depth + 1 | 0;
          } else {
            if (ch === 93) {
              depth = depth - 1 | 0;
            }
          }
          i = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      if (depth > 0) {
        return bracket_start;
      }
      continue;
    } else {
      break;
    }
  }
  return i;
}
function _M0FP410Haoxincode8moonbash3lib6parser42preprocess__param__word__in__double__quote(word_str) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  while (true) {
    if (i < word_str.length) {
      const _p$4 = i;
      $bound_check(word_str, _p$4);
      const ch = word_str.charCodeAt(_p$4);
      if (ch === 92 && (i + 1 | 0) < word_str.length) {
        const _p$5 = i + 1 | 0;
        $bound_check(word_str, _p$5);
        const next = word_str.charCodeAt(_p$5);
        if (next === 125) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 125);
        } else {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
          _M0IPB13StringBuilderPB6Logger11write__char(out, next);
        }
        i = i + 2 | 0;
        continue;
      }
      if (ch === 39) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
        _M0IPB13StringBuilderPB6Logger11write__char(out, 39);
        i = i + 1 | 0;
        continue;
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib6parser34find__substring__length__separator(spec) {
  let paren_depth = 0;
  let bracket_depth = 0;
  let brace_depth = 0;
  let ternary_depth = 0;
  let in_single = false;
  let in_double = false;
  let escaped = false;
  let i = 0;
  while (true) {
    if (i < spec.length) {
      const _p$4 = i;
      $bound_check(spec, _p$4);
      const ch = spec.charCodeAt(_p$4);
      if (escaped) {
        escaped = false;
        i = i + 1 | 0;
        continue;
      }
      if (in_single) {
        if (ch === 39) {
          in_single = false;
        }
        i = i + 1 | 0;
        continue;
      }
      if (in_double) {
        if (ch === 34) {
          in_double = false;
        } else {
          if (ch === 92) {
            escaped = true;
          }
        }
        i = i + 1 | 0;
        continue;
      }
      if (ch === 92) {
        escaped = true;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 39) {
        in_single = true;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 34) {
        in_double = true;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 40) {
        paren_depth = paren_depth + 1 | 0;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 41 && paren_depth > 0) {
        paren_depth = paren_depth - 1 | 0;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 91) {
        bracket_depth = bracket_depth + 1 | 0;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 93 && bracket_depth > 0) {
        bracket_depth = bracket_depth - 1 | 0;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 123) {
        brace_depth = brace_depth + 1 | 0;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 125 && brace_depth > 0) {
        brace_depth = brace_depth - 1 | 0;
        i = i + 1 | 0;
        continue;
      }
      if (paren_depth === 0 && (bracket_depth === 0 && brace_depth === 0)) {
        if (ch === 63) {
          ternary_depth = ternary_depth + 1 | 0;
          i = i + 1 | 0;
          continue;
        }
        if (ch === 58) {
          if (ternary_depth > 0) {
            ternary_depth = ternary_depth - 1 | 0;
            i = i + 1 | 0;
            continue;
          }
          return i;
        }
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410Haoxincode8moonbash3lib6parser24trim__ascii__space__word(s) {
  let start = 0;
  let end_ = s.length;
  while (true) {
    if (start < end_) {
      const _p$4 = start;
      $bound_check(s, _p$4);
      const ch = s.charCodeAt(_p$4);
      if (ch === 32 || (ch === 9 || (ch === 10 || ch === 13))) {
        start = start + 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (end_ > start) {
      const _p$4 = end_ - 1 | 0;
      $bound_check(s, _p$4);
      const ch = s.charCodeAt(_p$4);
      if (ch === 32 || (ch === 9 || (ch === 10 || ch === 13))) {
        end_ = end_ - 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  return _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(s, start, end_);
}
function _M0FP410Haoxincode8moonbash3lib6parser22parse__substring__spec(spec) {
  const trimmed = _M0FP410Haoxincode8moonbash3lib6parser24trim__ascii__space__word(spec);
  const colon_pos = _M0FP410Haoxincode8moonbash3lib6parser34find__substring__length__separator(trimmed);
  if (colon_pos < 0) {
    const offset_text = trimmed.length === 0 ? "0" : trimmed;
    return { _0: new _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Raw(offset_text), _1: undefined };
  }
  const left = _M0FP410Haoxincode8moonbash3lib6parser24trim__ascii__space__word(_M0FP410Haoxincode8moonbash3lib6parser7wsubstr(trimmed, 0, colon_pos));
  const right = _M0FP410Haoxincode8moonbash3lib6parser24trim__ascii__space__word(_M0FP410Haoxincode8moonbash3lib6parser7wsubstr(trimmed, colon_pos + 1 | 0, trimmed.length));
  const offset_expr = new _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Raw(left.length === 0 ? "0" : left);
  const length_expr = new _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Raw(right.length === 0 ? "0" : right);
  return { _0: offset_expr, _1: length_expr };
}
function _M0FP410Haoxincode8moonbash3lib6parser24parse__cmd__substitution(s, start) {
  let depth = 1;
  let i = start;
  while (true) {
    if (i < s.length && depth > 0) {
      const _p$4 = i;
      $bound_check(s, _p$4);
      const ch = s.charCodeAt(_p$4);
      if (ch === 40) {
        depth = depth + 1 | 0;
      } else {
        if (ch === 41) {
          depth = depth - 1 | 0;
        }
      }
      if (depth > 0) {
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  const content = _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(s, start, i);
  i = i + 1 | 0;
  return { _0: new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart19CommandSubstitution(content), _1: i };
}
function _M0FP410Haoxincode8moonbash3lib6parser31parse__legacy__arith__expansion(s, start) {
  let depth = 1;
  let i = start;
  let in_single = false;
  let in_double = false;
  let escaped = false;
  while (true) {
    if (i < s.length) {
      const _p$4 = i;
      $bound_check(s, _p$4);
      const ch = s.charCodeAt(_p$4);
      if (escaped) {
        escaped = false;
        i = i + 1 | 0;
        continue;
      }
      if (in_single) {
        if (ch === 39) {
          in_single = false;
        }
        i = i + 1 | 0;
        continue;
      }
      if (in_double) {
        if (ch === 34) {
          in_double = false;
        } else {
          if (ch === 92) {
            escaped = true;
          }
        }
        i = i + 1 | 0;
        continue;
      }
      if (ch === 92) {
        escaped = true;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 39) {
        in_single = true;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 34) {
        in_double = true;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 91) {
        depth = depth + 1 | 0;
      } else {
        if (ch === 93) {
          depth = depth - 1 | 0;
          if (depth === 0) {
            const content = _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(s, start, i);
            i = i + 1 | 0;
            return { _0: new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart19ArithmeticExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Raw(content)), _1: i };
          }
        }
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const content = _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(s, start, s.length);
  return { _0: new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart19ArithmeticExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Raw(content)), _1: s.length };
}
function _M0FP410Haoxincode8moonbash3lib6parser35parse__raw__double__quoted__segment(s, start) {
  const quoted = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = start;
  while (true) {
    if (i < s.length) {
      const _p$4 = i;
      $bound_check(s, _p$4);
      const ch = s.charCodeAt(_p$4);
      if (ch === 34) {
        return { _0: quoted.val, _1: i + 1 | 0 };
      }
      if (ch === 92 && (i + 1 | 0) < s.length) {
        const _p$5 = i + 1 | 0;
        $bound_check(s, _p$5);
        const next = s.charCodeAt(_p$5);
        if (next === 36 || (next === 96 || (next === 34 || next === 92))) {
          _M0IPB13StringBuilderPB6Logger11write__char(quoted, next);
          i = i + 2 | 0;
          continue;
        }
        if (next === 10) {
          i = i + 2 | 0;
          continue;
        }
        _M0IPB13StringBuilderPB6Logger11write__char(quoted, 92);
        i = i + 1 | 0;
        continue;
      }
      _M0IPB13StringBuilderPB6Logger11write__char(quoted, ch);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return { _0: quoted.val, _1: i };
}
function _M0FP410Haoxincode8moonbash3lib6parser35parse__raw__single__quoted__segment(s, start, ansi_c_quote) {
  const quoted = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = start;
  let escaped = false;
  while (true) {
    if (i < s.length) {
      const _p$4 = i;
      $bound_check(s, _p$4);
      const ch = s.charCodeAt(_p$4);
      if (ch === 39) {
        if (!ansi_c_quote || !escaped) {
          return { _0: quoted.val, _1: i + 1 | 0 };
        }
      }
      _M0IPB13StringBuilderPB6Logger11write__char(quoted, ch);
      if (ansi_c_quote && (ch === 92 && !escaped)) {
        escaped = true;
      } else {
        escaped = false;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return { _0: quoted.val, _1: i };
}
function _M0FP410Haoxincode8moonbash3lib6parser23parse__simple__variable(s, start) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = start;
  while (true) {
    if (i < s.length) {
      const _p$4 = i;
      $bound_check(s, _p$4);
      const ch = s.charCodeAt(_p$4);
      if (_M0FP410Haoxincode8moonbash3lib6parser13is__var__char(ch)) {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
        i = i + 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  return { _0: new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart8Variable(buf.val), _1: i };
}
function _M0FP410Haoxincode8moonbash3lib6parser12parse__tilde(s, start) {
  let i = start + 1 | 0;
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  while (true) {
    if (i < s.length) {
      const _p$4 = i;
      $bound_check(s, _p$4);
      const ch = s.charCodeAt(_p$4);
      if (ch === 47 || (ch === 58 || ch === 123)) {
        break;
      }
      _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return { _0: new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart11TildePrefix(buf.val), _1: i };
}
function _M0FP410Haoxincode8moonbash3lib6parser36strip__single__quote__empty__markers(s) {
  if (s.length === 0) {
    return s;
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      if (ch !== 0) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib6parser41parse__word__parts__with__context_2einner(s, in_double_quote, parse_raw_quotes) {
  const parts = [];
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  const len = s.length;
  while (true) {
    if (i < len) {
      const _p$4 = i;
      $bound_check(s, _p$4);
      const ch = s.charCodeAt(_p$4);
      if (ch === 2) {
        const lit = buf.val;
        let locale_quote;
        if (lit.length > 0) {
          const _p$5 = lit.length - 1 | 0;
          $bound_check(lit, _p$5);
          locale_quote = lit.charCodeAt(_p$5) === 36;
        } else {
          locale_quote = false;
        }
        if (lit.length > 0) {
          if (locale_quote) {
            const prefix = _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(lit, 0, lit.length - 1 | 0);
            if (prefix.length > 0) {
              _M0MPC15array5Array4pushGUssEE(parts, new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart7Literal(prefix));
            }
          } else {
            _M0MPC15array5Array4pushGUssEE(parts, new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart7Literal(lit));
          }
          _M0MPB13StringBuilder5reset(buf);
        }
        i = i + 1 | 0;
        const quoted = _M0MPB13StringBuilder21StringBuilder_2einner(0);
        while (true) {
          let _tmp$38;
          if (i < len) {
            const _p$5 = i;
            $bound_check(s, _p$5);
            _tmp$38 = s.charCodeAt(_p$5) !== 3;
          } else {
            _tmp$38 = false;
          }
          if (_tmp$38) {
            const _p$5 = i;
            $bound_check(s, _p$5);
            _M0IPB13StringBuilderPB6Logger11write__char(quoted, s.charCodeAt(_p$5));
            i = i + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        const inner_parts = _M0FP410Haoxincode8moonbash3lib6parser41parse__word__parts__with__context_2einner(quoted.val, true, parse_raw_quotes);
        _M0MPC15array5Array4pushGUssEE(parts, new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart12DoubleQuoted(inner_parts));
        let _tmp$38;
        if (i < len) {
          const _p$5 = i;
          $bound_check(s, _p$5);
          _tmp$38 = s.charCodeAt(_p$5) === 3;
        } else {
          _tmp$38 = false;
        }
        if (_tmp$38) {
          i = i + 1 | 0;
        }
        continue;
      } else {
        if (ch === 1 && (i + 1 | 0) < len) {
          const lit = buf.val;
          let ansi_c_quote;
          if (lit.length > 0) {
            const _p$5 = lit.length - 1 | 0;
            $bound_check(lit, _p$5);
            ansi_c_quote = lit.charCodeAt(_p$5) === 36;
          } else {
            ansi_c_quote = false;
          }
          if (lit.length > 0) {
            if (ansi_c_quote) {
              const prefix = _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(lit, 0, lit.length - 1 | 0);
              if (prefix.length > 0) {
                _M0MPC15array5Array4pushGUssEE(parts, new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart7Literal(prefix));
              }
            } else {
              _M0MPC15array5Array4pushGUssEE(parts, new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart7Literal(lit));
            }
            _M0MPB13StringBuilder5reset(buf);
          }
          const quoted = _M0MPB13StringBuilder21StringBuilder_2einner(0);
          while (true) {
            let _tmp$38;
            if ((i + 1 | 0) < len) {
              const _p$5 = i;
              $bound_check(s, _p$5);
              _tmp$38 = s.charCodeAt(_p$5) === 1;
            } else {
              _tmp$38 = false;
            }
            if (_tmp$38) {
              const _p$5 = i + 1 | 0;
              $bound_check(s, _p$5);
              _M0IPB13StringBuilderPB6Logger11write__char(quoted, s.charCodeAt(_p$5));
              i = i + 2 | 0;
              continue;
            } else {
              break;
            }
          }
          const normalized_quoted_text = _M0FP410Haoxincode8moonbash3lib6parser36strip__single__quote__empty__markers(quoted.val);
          if (ansi_c_quote) {
            _M0MPC15array5Array4pushGUssEE(parts, new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart7Literal(_M0FP410Haoxincode8moonbash3lib6parser24decode__ansi__c__escapes(normalized_quoted_text)));
          } else {
            _M0MPC15array5Array4pushGUssEE(parts, new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart12SingleQuoted(normalized_quoted_text));
          }
          continue;
        } else {
          if (parse_raw_quotes && (ch === 39 && (!in_double_quote && _M0FP410Haoxincode8moonbash3lib6parser32has__closing__raw__single__quote(s, i + 1 | 0)))) {
            const lit = buf.val;
            let ansi_c_quote;
            if (lit.length > 0) {
              const _p$5 = lit.length - 1 | 0;
              $bound_check(lit, _p$5);
              ansi_c_quote = lit.charCodeAt(_p$5) === 36;
            } else {
              ansi_c_quote = false;
            }
            if (lit.length > 0) {
              if (ansi_c_quote) {
                const prefix = _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(lit, 0, lit.length - 1 | 0);
                if (prefix.length > 0) {
                  _M0MPC15array5Array4pushGUssEE(parts, new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart7Literal(prefix));
                }
              } else {
                _M0MPC15array5Array4pushGUssEE(parts, new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart7Literal(lit));
              }
              _M0MPB13StringBuilder5reset(buf);
            }
            const _bind$4 = _M0FP410Haoxincode8moonbash3lib6parser35parse__raw__single__quoted__segment(s, i + 1 | 0, ansi_c_quote);
            const _quoted_text = _bind$4._0;
            const _next_pos = _bind$4._1;
            const normalized_quoted_text = _M0FP410Haoxincode8moonbash3lib6parser36strip__single__quote__empty__markers(_quoted_text);
            if (ansi_c_quote) {
              _M0MPC15array5Array4pushGUssEE(parts, new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart7Literal(_M0FP410Haoxincode8moonbash3lib6parser24decode__ansi__c__escapes(normalized_quoted_text)));
            } else {
              _M0MPC15array5Array4pushGUssEE(parts, new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart12SingleQuoted(normalized_quoted_text));
            }
            i = _next_pos;
            continue;
          } else {
            if (parse_raw_quotes && (ch === 34 && (!in_double_quote && _M0FP410Haoxincode8moonbash3lib6parser32has__closing__raw__double__quote(s, i + 1 | 0)))) {
              const lit = buf.val;
              let locale_quote;
              if (lit.length > 0) {
                const _p$5 = lit.length - 1 | 0;
                $bound_check(lit, _p$5);
                locale_quote = lit.charCodeAt(_p$5) === 36;
              } else {
                locale_quote = false;
              }
              if (lit.length > 0) {
                if (locale_quote) {
                  const prefix = _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(lit, 0, lit.length - 1 | 0);
                  if (prefix.length > 0) {
                    _M0MPC15array5Array4pushGUssEE(parts, new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart7Literal(prefix));
                  }
                } else {
                  _M0MPC15array5Array4pushGUssEE(parts, new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart7Literal(lit));
                }
                _M0MPB13StringBuilder5reset(buf);
              }
              const _bind$4 = _M0FP410Haoxincode8moonbash3lib6parser35parse__raw__double__quoted__segment(s, i + 1 | 0);
              const _quoted_text = _bind$4._0;
              const _next_pos = _bind$4._1;
              const inner_parts = _M0FP410Haoxincode8moonbash3lib6parser41parse__word__parts__with__context_2einner(_quoted_text, true, parse_raw_quotes);
              _M0MPC15array5Array4pushGUssEE(parts, new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart12DoubleQuoted(inner_parts));
              i = _next_pos;
              continue;
            } else {
              if (ch === 92) {
                if ((i + 1 | 0) < len) {
                  const _p$5 = i + 1 | 0;
                  $bound_check(s, _p$5);
                  const next = s.charCodeAt(_p$5);
                  if (next === 10) {
                    i = i + 2 | 0;
                    continue;
                  }
                  if (next === 96 || (next === 36 || (next === 92 || (next === 34 || next === 39)))) {
                    _M0IPB13StringBuilderPB6Logger11write__char(buf, next);
                    i = i + 2 | 0;
                    continue;
                  }
                }
                _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
                i = i + 1 | 0;
                continue;
              } else {
                if (ch === 36 && (i + 1 | 0) < len) {
                  const lit = buf.val;
                  if (lit.length > 0) {
                    _M0MPC15array5Array4pushGUssEE(parts, new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart7Literal(lit));
                    _M0MPB13StringBuilder5reset(buf);
                  }
                  const _p$5 = i + 1 | 0;
                  $bound_check(s, _p$5);
                  const next = s.charCodeAt(_p$5);
                  if (next === 123) {
                    const result = _M0FP410Haoxincode8moonbash3lib6parser31parse__brace__expansion_2einner(s, i + 2 | 0, in_double_quote);
                    _M0MPC15array5Array4pushGUssEE(parts, result._0);
                    i = result._1;
                    continue;
                  } else {
                    if (next === 40) {
                      let _tmp$38;
                      if ((i + 2 | 0) < len) {
                        const _p$6 = i + 2 | 0;
                        $bound_check(s, _p$6);
                        _tmp$38 = s.charCodeAt(_p$6) === 40;
                      } else {
                        _tmp$38 = false;
                      }
                      if (_tmp$38) {
                        const result = _M0FP410Haoxincode8moonbash3lib6parser23parse__arith__expansion(s, i + 3 | 0);
                        _M0MPC15array5Array4pushGUssEE(parts, result._0);
                        i = result._1;
                        continue;
                      } else {
                        const result = _M0FP410Haoxincode8moonbash3lib6parser24parse__cmd__substitution(s, i + 2 | 0);
                        _M0MPC15array5Array4pushGUssEE(parts, result._0);
                        i = result._1;
                        continue;
                      }
                    } else {
                      if (next === 91) {
                        const result = _M0FP410Haoxincode8moonbash3lib6parser31parse__legacy__arith__expansion(s, i + 2 | 0);
                        _M0MPC15array5Array4pushGUssEE(parts, result._0);
                        i = result._1;
                        continue;
                      } else {
                        if (_M0FP410Haoxincode8moonbash3lib6parser14is__var__start(next)) {
                          const result = _M0FP410Haoxincode8moonbash3lib6parser23parse__simple__variable(s, i + 1 | 0);
                          _M0MPC15array5Array4pushGUssEE(parts, result._0);
                          i = result._1;
                          continue;
                        } else {
                          if (_M0FP410Haoxincode8moonbash3lib6parser16is__special__var(next)) {
                            _M0MPC15array5Array4pushGUssEE(parts, new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart8Variable(_M0IPC14char4CharPB4Show10to__string(next)));
                            i = i + 2 | 0;
                            continue;
                          } else {
                            _M0IPB13StringBuilderPB6Logger11write__char(buf, 36);
                            i = i + 1 | 0;
                            continue;
                          }
                        }
                      }
                    }
                  }
                } else {
                  if (ch === 96) {
                    if (!_M0FP410Haoxincode8moonbash3lib6parser22has__closing__backtick(s, i + 1 | 0)) {
                      _M0IPB13StringBuilderPB6Logger11write__char(buf, 96);
                      i = i + 1 | 0;
                      continue;
                    }
                    const lit = buf.val;
                    if (lit.length > 0) {
                      _M0MPC15array5Array4pushGUssEE(parts, new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart7Literal(lit));
                      _M0MPB13StringBuilder5reset(buf);
                    }
                    const result = _M0FP410Haoxincode8moonbash3lib6parser29parse__backtick__substitution(s, i + 1 | 0);
                    _M0MPC15array5Array4pushGUssEE(parts, result._0);
                    i = result._1;
                    continue;
                  } else {
                    if (ch === 126 && i === 0) {
                      const result = _M0FP410Haoxincode8moonbash3lib6parser12parse__tilde(s, 0);
                      _M0MPC15array5Array4pushGUssEE(parts, result._0);
                      i = result._1;
                      continue;
                    } else {
                      _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
                      i = i + 1 | 0;
                    }
                  }
                }
              }
            }
          }
        }
      }
      continue;
    } else {
      break;
    }
  }
  const remaining = buf.val;
  if (remaining.length > 0) {
    _M0MPC15array5Array4pushGUssEE(parts, new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart7Literal(remaining));
  }
  if (parts.length === 0) {
    _M0MPC15array5Array4pushGUssEE(parts, _M0FP410Haoxincode8moonbash3lib6parser41parse__word__parts__with__context_2einnerN6constrS1046);
  }
  return parts;
}
function _M0FP410Haoxincode8moonbash3lib6parser31parse__brace__expansion_2einner(s, start, in_double_quote) {
  let depth = 1;
  let i = start;
  let in_single = false;
  let in_double = false;
  let escaped = false;
  while (true) {
    if (i < s.length && depth > 0) {
      const _p$4 = i;
      $bound_check(s, _p$4);
      const ch = s.charCodeAt(_p$4);
      if (escaped) {
        escaped = false;
        if (depth > 0) {
          i = i + 1 | 0;
        }
        continue;
      }
      if (in_single) {
        if (ch === 39) {
          in_single = false;
        }
        if (depth > 0) {
          i = i + 1 | 0;
        }
        continue;
      }
      if (in_double) {
        if (ch === 34) {
          in_double = false;
        } else {
          if (ch === 92) {
            escaped = true;
          }
        }
        if (depth > 0) {
          i = i + 1 | 0;
        }
        continue;
      }
      if (ch === 92) {
        escaped = true;
        if (depth > 0) {
          i = i + 1 | 0;
        }
        continue;
      }
      if (ch === 39) {
        in_single = true;
        if (depth > 0) {
          i = i + 1 | 0;
        }
        continue;
      }
      if (ch === 34) {
        in_double = true;
        if (depth > 0) {
          i = i + 1 | 0;
        }
        continue;
      }
      if (ch === 123) {
        depth = depth + 1 | 0;
      } else {
        if (ch === 125) {
          depth = depth - 1 | 0;
        }
      }
      if (depth > 0) {
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  const end = i;
  const content = _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(s, start, end);
  i = i + 1 | 0;
  const part = _M0FP410Haoxincode8moonbash3lib6parser40parse__param__expansion__content_2einner(content, in_double_quote);
  return { _0: part, _1: i };
}
function _M0FP410Haoxincode8moonbash3lib6parser40parse__param__expansion__content_2einner(content, in_double_quote) {
  const len = content.length;
  if (len === 0) {
    return _M0FP410Haoxincode8moonbash3lib6parser40parse__param__expansion__content_2einnerN6constrS1047;
  }
  let _tmp$38;
  const _p$4 = 0;
  $bound_check(content, _p$4);
  if (content.charCodeAt(_p$4) === 35) {
    _tmp$38 = len > 1;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    const name = _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(content, 1, len);
    return new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart18ParameterExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion6Length(name));
  }
  let _tmp$39;
  const _p$5 = 0;
  $bound_check(content, _p$5);
  if (content.charCodeAt(_p$5) === 33) {
    _tmp$39 = len > 1;
  } else {
    _tmp$39 = false;
  }
  if (_tmp$39) {
    const name = _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(content, 1, len);
    return new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart18ParameterExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion11Indirection(name));
  }
  const raw_name_end = _M0FP410Haoxincode8moonbash3lib6parser23parse__param__name__end(content);
  let name_end;
  if (raw_name_end === 0) {
    let _tmp$40;
    if (len >= 1) {
      const _p$6 = 0;
      $bound_check(content, _p$6);
      _tmp$40 = _M0FP410Haoxincode8moonbash3lib6parser16is__special__var(content.charCodeAt(_p$6));
    } else {
      _tmp$40 = false;
    }
    if (_tmp$40) {
      name_end = 1;
    } else {
      name_end = 0;
    }
  } else {
    name_end = raw_name_end;
  }
  if (name_end === 0) {
    return new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart7Literal(content);
  }
  const name = _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(content, 0, name_end);
  if (name_end >= len) {
    return new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart18ParameterExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion6Simple(name));
  }
  $bound_check(content, name_end);
  const op_char = content.charCodeAt(name_end);
  const rest_start = name_end + 1 | 0;
  switch (op_char) {
    case 58: {
      if (rest_start >= len) {
        return new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart18ParameterExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion6Simple(name));
      }
      $bound_check(content, rest_start);
      const op2 = content.charCodeAt(rest_start);
      const word_str = _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(content, rest_start + 1 | 0, len);
      const word = _M0FP410Haoxincode8moonbash3lib6parser36parse__param__operator__word_2einner(word_str, in_double_quote);
      switch (op2) {
        case 45: {
          return new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart18ParameterExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion7Default(name, word, true));
        }
        case 61: {
          return new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart18ParameterExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion6Assign(name, word, true));
        }
        case 63: {
          return new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart18ParameterExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion5Error(name, word, true));
        }
        case 43: {
          return new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart18ParameterExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion11Alternative(name, word, true));
        }
        default: {
          const spec = _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(content, rest_start, len);
          const _bind$4 = _M0FP410Haoxincode8moonbash3lib6parser22parse__substring__spec(spec);
          const _offset_expr = _bind$4._0;
          const _length_expr = _bind$4._1;
          return new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart18ParameterExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion9Substring(name, _offset_expr, _length_expr));
        }
      }
    }
    case 45: {
      const word_str$2 = _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(content, rest_start, len);
      const word$2 = _M0FP410Haoxincode8moonbash3lib6parser36parse__param__operator__word_2einner(word_str$2, in_double_quote);
      return new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart18ParameterExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion7Default(name, word$2, false));
    }
    case 61: {
      const word_str$3 = _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(content, rest_start, len);
      const word$3 = _M0FP410Haoxincode8moonbash3lib6parser36parse__param__operator__word_2einner(word_str$3, in_double_quote);
      return new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart18ParameterExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion6Assign(name, word$3, false));
    }
    case 63: {
      const word_str$4 = _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(content, rest_start, len);
      const word$4 = _M0FP410Haoxincode8moonbash3lib6parser36parse__param__operator__word_2einner(word_str$4, in_double_quote);
      return new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart18ParameterExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion5Error(name, word$4, false));
    }
    case 43: {
      const word_str$5 = _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(content, rest_start, len);
      const word$5 = _M0FP410Haoxincode8moonbash3lib6parser36parse__param__operator__word_2einner(word_str$5, in_double_quote);
      return new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart18ParameterExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion11Alternative(name, word$5, false));
    }
    case 35: {
      let greedy;
      if (rest_start < len) {
        $bound_check(content, rest_start);
        greedy = content.charCodeAt(rest_start) === 35;
      } else {
        greedy = false;
      }
      const pat_start = greedy ? rest_start + 1 | 0 : rest_start;
      const pat_str = _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(content, pat_start, len);
      const pat = _M0FP410Haoxincode8moonbash3lib6parser39parse__word__content__with__raw__quotes(pat_str);
      return new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart18ParameterExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion12PrefixRemove(name, pat, greedy));
    }
    case 37: {
      let greedy$2;
      if (rest_start < len) {
        $bound_check(content, rest_start);
        greedy$2 = content.charCodeAt(rest_start) === 37;
      } else {
        greedy$2 = false;
      }
      const pat_start$2 = greedy$2 ? rest_start + 1 | 0 : rest_start;
      const pat_str$2 = _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(content, pat_start$2, len);
      const pat$2 = _M0FP410Haoxincode8moonbash3lib6parser39parse__word__content__with__raw__quotes(pat_str$2);
      return new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart18ParameterExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion12SuffixRemove(name, pat$2, greedy$2));
    }
    case 47: {
      let mode = 0;
      let pat_start$3 = rest_start;
      if (pat_start$3 < len) {
        const _p$6 = pat_start$3;
        $bound_check(content, _p$6);
        const next = content.charCodeAt(_p$6);
        if (next === 47) {
          mode = 1;
          pat_start$3 = pat_start$3 + 1 | 0;
        } else {
          if (next === 35) {
            mode = 2;
            pat_start$3 = pat_start$3 + 1 | 0;
          } else {
            if (next === 37) {
              mode = 3;
              pat_start$3 = pat_start$3 + 1 | 0;
            }
          }
        }
      }
      let sep_pos = pat_start$3;
      while (true) {
        let _tmp$40;
        if (sep_pos < len) {
          const _p$6 = sep_pos;
          $bound_check(content, _p$6);
          _tmp$40 = content.charCodeAt(_p$6) !== 47;
        } else {
          _tmp$40 = false;
        }
        if (_tmp$40) {
          sep_pos = sep_pos + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      const pat_str$3 = _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(content, pat_start$3, sep_pos);
      const pat$3 = _M0FP410Haoxincode8moonbash3lib6parser39parse__word__content__with__raw__quotes(pat_str$3);
      let repl;
      if (sep_pos < len) {
        const repl_str = _M0FP410Haoxincode8moonbash3lib6parser7wsubstr(content, sep_pos + 1 | 0, len);
        repl = _M0FP410Haoxincode8moonbash3lib6parser39parse__word__content__with__raw__quotes(repl_str);
      } else {
        repl = undefined;
      }
      return new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart18ParameterExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion7Replace(name, pat$3, repl, mode));
    }
    case 94: {
      let greedy$3;
      if (rest_start < len) {
        $bound_check(content, rest_start);
        greedy$3 = content.charCodeAt(rest_start) === 94;
      } else {
        greedy$3 = false;
      }
      const pat_start$4 = greedy$3 ? rest_start + 1 | 0 : rest_start;
      const pat$4 = pat_start$4 < len ? new _M0TP410Haoxincode8moonbash3lib3ast4Word([new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart7Literal(_M0FP410Haoxincode8moonbash3lib6parser7wsubstr(content, pat_start$4, len))]) : undefined;
      return new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart18ParameterExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion9Uppercase(name, pat$4, greedy$3));
    }
    case 44: {
      let greedy$4;
      if (rest_start < len) {
        $bound_check(content, rest_start);
        greedy$4 = content.charCodeAt(rest_start) === 44;
      } else {
        greedy$4 = false;
      }
      const pat_start$5 = greedy$4 ? rest_start + 1 | 0 : rest_start;
      const pat$5 = pat_start$5 < len ? new _M0TP410Haoxincode8moonbash3lib3ast4Word([new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart7Literal(_M0FP410Haoxincode8moonbash3lib6parser7wsubstr(content, pat_start$5, len))]) : undefined;
      return new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart18ParameterExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion9Lowercase(name, pat$5, greedy$4));
    }
    case 64: {
      if ((rest_start + 1 | 0) === len) {
        $bound_check(content, rest_start);
        const transform = content.charCodeAt(rest_start);
        if (transform === 81 || (transform === 80 || transform === 97)) {
          return new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart18ParameterExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion6Simple(`${name}@${_M0IPC14char4CharPB4Show10to__string(transform)}`));
        }
      }
      return new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart18ParameterExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion6Simple(name));
    }
    default: {
      return new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart18ParameterExpansion(new _M0DTP410Haoxincode8moonbash3lib3ast14ParamExpansion6Simple(name));
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib6parser36parse__param__operator__word_2einner(word_str, in_double_quote) {
  if (!in_double_quote) {
    return _M0FP410Haoxincode8moonbash3lib6parser39parse__word__content__with__raw__quotes(word_str);
  }
  const preprocessed = _M0FP410Haoxincode8moonbash3lib6parser42preprocess__param__word__in__double__quote(word_str);
  return _M0FP410Haoxincode8moonbash3lib6parser39parse__word__content__with__raw__quotes(preprocessed);
}
function _M0FP410Haoxincode8moonbash3lib6parser39parse__word__content__with__raw__quotes(s) {
  return new _M0TP410Haoxincode8moonbash3lib3ast4Word(_M0FP410Haoxincode8moonbash3lib6parser41parse__word__parts__with__context_2einner(s, false, true));
}
function _M0FP410Haoxincode8moonbash3lib6parser18parse__word__parts(s) {
  return _M0FP410Haoxincode8moonbash3lib6parser41parse__word__parts__with__context_2einner(s, false, false);
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser4peek(self) {
  return self.pos >= self.tokens.length ? _M0DTP410Haoxincode8moonbash3lib3ast5Token3EOF__ : _M0MPC15array5Array2atGUssEE(self.tokens, self.pos);
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser7at__end(self) {
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser4peek(self);
  if (_bind$4.$tag === 45) {
    return true;
  } else {
    return false;
  }
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self) {
  const tok = _M0MP410Haoxincode8moonbash3lib6parser6Parser4peek(self);
  if (self.pos < self.tokens.length) {
    self.pos = self.pos + 1 | 0;
  }
  return tok;
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser5check(self, tok) {
  return _M0IP410Haoxincode8moonbash3lib3ast5TokenPB2Eq5equal(_M0MP410Haoxincode8moonbash3lib6parser6Parser4peek(self), tok);
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser16peek__at__offset(self, offset) {
  const idx = self.pos + offset | 0;
  return idx >= self.tokens.length ? _M0DTP410Haoxincode8moonbash3lib3ast5Token3EOF__ : _M0MPC15array5Array2atGUssEE(self.tokens, idx);
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser22is__script__terminator(self) {
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser4peek(self);
  switch (_bind$4.$tag) {
    case 32: {
      return true;
    }
    case 37: {
      return true;
    }
    case 39: {
      return true;
    }
    case 31: {
      return true;
    }
    case 30: {
      return true;
    }
    case 29: {
      return true;
    }
    case 36: {
      return true;
    }
    case 25: {
      return true;
    }
    case 23: {
      return true;
    }
    case 7: {
      return _M0IP410Haoxincode8moonbash3lib3ast5TokenPB2Eq5equal(_M0MP410Haoxincode8moonbash3lib6parser6Parser16peek__at__offset(self, 1), _M0DTP410Haoxincode8moonbash3lib3ast5Token4Semi__);
    }
    default: {
      return false;
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser12match__token(self, tok) {
  if (_M0MP410Haoxincode8moonbash3lib6parser6Parser5check(self, tok)) {
    _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
    return true;
  } else {
    return false;
  }
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser12enter__depth(self) {
  self.depth = self.depth + 1 | 0;
  if (self.depth > 100) {
    return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError("maximum nesting depth exceeded"));
  } else {
    return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(undefined);
  }
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, expected) {
  const tok = _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
  if (_M0IP016_24default__implPB2Eq10not__equalGRP410Haoxincode8moonbash3lib3ast5TokenE(tok, expected)) {
    return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError(`expected ${_M0IP016_24default__implPB4Show10to__stringGRP410Haoxincode8moonbash3lib3ast5TokenE(expected)}, got ${_M0IP016_24default__implPB4Show10to__stringGRP410Haoxincode8moonbash3lib3ast5TokenE(tok)}`));
  } else {
    return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(undefined);
  }
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser26is__double__bracket__start(self) {
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser4peek(self);
  switch (_bind$4.$tag) {
    case 0: {
      const _Word = _bind$4;
      const _s = _Word._0;
      return _s === "[[";
    }
    case 26: {
      return true;
    }
    default: {
      return false;
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser12leave__depth(self) {
  self.depth = self.depth - 1 | 0;
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser33looks__like__posix__function__def(self) {
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser4peek(self);
  if (_bind$4.$tag === 0) {
    if (_M0IP016_24default__implPB2Eq10not__equalGRP410Haoxincode8moonbash3lib3ast5TokenE(_M0MP410Haoxincode8moonbash3lib6parser6Parser16peek__at__offset(self, 1), _M0DTP410Haoxincode8moonbash3lib3ast5Token9LeftParen__) || _M0IP016_24default__implPB2Eq10not__equalGRP410Haoxincode8moonbash3lib3ast5TokenE(_M0MP410Haoxincode8moonbash3lib6parser6Parser16peek__at__offset(self, 2), _M0DTP410Haoxincode8moonbash3lib3ast5Token10RightParen__)) {
      return false;
    }
    let i = 3;
    while (true) {
      if (_M0IP410Haoxincode8moonbash3lib3ast5TokenPB2Eq5equal(_M0MP410Haoxincode8moonbash3lib6parser6Parser16peek__at__offset(self, i), _M0DTP410Haoxincode8moonbash3lib3ast5Token7Newline__)) {
        i = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    const _bind$5 = _M0MP410Haoxincode8moonbash3lib6parser6Parser16peek__at__offset(self, i);
    switch (_bind$5.$tag) {
      case 24: {
        return true;
      }
      case 28: {
        return true;
      }
      case 33: {
        return true;
      }
      case 34: {
        return true;
      }
      case 35: {
        return true;
      }
      case 38: {
        return true;
      }
      case 22: {
        return true;
      }
      default: {
        return false;
      }
    }
  } else {
    return false;
  }
}
function _M0FP410Haoxincode8moonbash3lib6parser24arith__token__to__string(tok) {
  switch (tok.$tag) {
    case 0: {
      const _Word = tok;
      return _Word._0;
    }
    case 1: {
      const _Number = tok;
      const _n = _Number._0;
      return _M0MPC15int645Int6418to__string_2einner(_n, 10);
    }
    case 2: {
      const _AssignmentWord = tok;
      const _name = _AssignmentWord._0;
      const _value = _AssignmentWord._1;
      const _append = _AssignmentWord._2;
      return _append ? `${_name}+=${_value}` : `${_name}=${_value}`;
    }
    case 3: {
      return "|";
    }
    case 4: {
      return "|&";
    }
    case 5: {
      return "&&";
    }
    case 6: {
      return "||";
    }
    case 8: {
      return "&";
    }
    case 43: {
      return "!";
    }
    case 7: {
      return ";";
    }
    case 10: {
      return "<";
    }
    case 11: {
      return ">";
    }
    case 12: {
      return ">>";
    }
    case 14: {
      return "<<";
    }
    case 15: {
      return "<<-";
    }
    case 16: {
      return "<<<";
    }
    case 19: {
      return "<>";
    }
    case 13: {
      return ">|";
    }
    case 17: {
      return "<&";
    }
    case 18: {
      return ">&";
    }
    case 20: {
      return "&>";
    }
    case 21: {
      return "&>>";
    }
    case 28: {
      return "if";
    }
    case 29: {
      return "then";
    }
    case 30: {
      return "elif";
    }
    case 31: {
      return "else";
    }
    case 32: {
      return "fi";
    }
    case 33: {
      return "for";
    }
    case 34: {
      return "while";
    }
    case 35: {
      return "until";
    }
    case 36: {
      return "do";
    }
    case 37: {
      return "done";
    }
    case 38: {
      return "case";
    }
    case 39: {
      return "esac";
    }
    case 40: {
      return "in";
    }
    case 41: {
      return "function";
    }
    case 42: {
      return "select";
    }
    case 44: {
      return "time";
    }
    case 9: {
      return " ";
    }
    case 22: {
      return "(";
    }
    case 23: {
      return ")";
    }
    case 24: {
      return "{";
    }
    case 25: {
      return "}";
    }
    case 26: {
      return "[[";
    }
    case 27: {
      return "]]";
    }
    case 46: {
      const _FdNumber = tok;
      const _n$2 = _FdNumber._0;
      return _M0MPC13int3Int18to__string_2einner(_n$2, 10);
    }
    default: {
      return "";
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser22parse__arithmetic__raw(self) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let depth = 0;
  _L: while (true) {
    if (!_M0MP410Haoxincode8moonbash3lib6parser6Parser7at__end(self)) {
      const tok = _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
      switch (tok.$tag) {
        case 22: {
          depth = depth + 1 | 0;
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 40);
          break;
        }
        case 23: {
          if (depth > 0) {
            depth = depth - 1 | 0;
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 41);
          } else {
            if (_M0MP410Haoxincode8moonbash3lib6parser6Parser12match__token(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token10RightParen__)) {
              return new _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(buf.val);
            } else {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, 41);
            }
          }
          break;
        }
        default: {
          const text = _M0FP410Haoxincode8moonbash3lib6parser24arith__token__to__string(tok);
          if (text.length === 0) {
            continue _L;
          }
          _M0IPB13StringBuilderPB6Logger13write__string(buf, text);
        }
      }
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError("unterminated arithmetic command"));
}
function _M0FP410Haoxincode8moonbash3lib6parser19make__literal__word(s) {
  return new _M0TP410Haoxincode8moonbash3lib3ast4Word([new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart7Literal(s)]);
}
function _M0FP410Haoxincode8moonbash3lib6parser20parse__word__content(s) {
  const parts = _M0FP410Haoxincode8moonbash3lib6parser18parse__word__parts(s);
  return new _M0TP410Haoxincode8moonbash3lib3ast4Word(parts);
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self) {
  while (true) {
    if (_M0MP410Haoxincode8moonbash3lib6parser6Parser5check(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token7Newline__)) {
      _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
      continue;
    } else {
      return;
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser15is__redirection(self) {
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser4peek(self);
  switch (_bind$4.$tag) {
    case 10: {
      return true;
    }
    case 11: {
      return true;
    }
    case 12: {
      return true;
    }
    case 13: {
      return true;
    }
    case 14: {
      return true;
    }
    case 15: {
      return true;
    }
    case 16: {
      return true;
    }
    case 17: {
      return true;
    }
    case 18: {
      return true;
    }
    case 19: {
      return true;
    }
    case 20: {
      return true;
    }
    case 21: {
      return true;
    }
    case 46: {
      return true;
    }
    default: {
      return false;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib6parser27has__single__quote__markers(s) {
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      if (s.charCodeAt(i) === 1) {
        return true;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib6parser29strip__single__quote__markers(s) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  while (true) {
    if (i < s.length) {
      const _tmp$38 = i;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch === 1 && (i + 1 | 0) < s.length) {
        const _tmp$39 = i + 1 | 0;
        $bound_check(s, _tmp$39);
        _M0IPB13StringBuilderPB6Logger11write__char(out, s.charCodeAt(_tmp$39));
        i = i + 2 | 0;
        continue;
      }
      if (ch === 2 || ch === 3) {
        i = i + 1 | 0;
        continue;
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser18parse__redirection(self) {
  let fd = undefined;
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser4peek(self);
  if (_bind$4.$tag === 46) {
    const _FdNumber = _bind$4;
    const _n = _FdNumber._0;
    _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
    fd = _n;
  }
  const _bind$5 = _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
  let op;
  switch (_bind$5.$tag) {
    case 10: {
      op = _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp5Input__;
      break;
    }
    case 11: {
      op = _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp6Output__;
      break;
    }
    case 12: {
      op = _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp6Append__;
      break;
    }
    case 13: {
      op = _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp7Clobber__;
      break;
    }
    case 19: {
      op = _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp11InputOutput__;
      break;
    }
    case 14: {
      op = _M0MP410Haoxincode8moonbash3lib6parser6Parser18parse__redirectionN6constrS1048;
      break;
    }
    case 15: {
      op = _M0MP410Haoxincode8moonbash3lib6parser6Parser18parse__redirectionN6constrS1049;
      break;
    }
    case 16: {
      op = _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp10HereString__;
      break;
    }
    case 17: {
      op = _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp8DupInput__;
      break;
    }
    case 18: {
      op = _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp9DupOutput__;
      break;
    }
    case 20: {
      op = _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp9AndOutput__;
      break;
    }
    case 21: {
      op = _M0DTP410Haoxincode8moonbash3lib3ast10RedirectOp9AndAppend__;
      break;
    }
    default: {
      return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast11RedirectionRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError(`unexpected token in redirection: ${_M0IP016_24default__implPB4Show10to__stringGRP410Haoxincode8moonbash3lib3ast5TokenE(_bind$5)}`));
    }
  }
  const _bind$6 = _M0MP410Haoxincode8moonbash3lib6parser6Parser4peek(self);
  let target;
  switch (_bind$6.$tag) {
    case 0: {
      const _Word = _bind$6;
      const _s = _Word._0;
      _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
      if (op.$tag === 5) {
        target = _M0FP410Haoxincode8moonbash3lib6parser27has__single__quote__markers(_s) ? new _M0TP410Haoxincode8moonbash3lib3ast4Word([new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart12SingleQuoted(_M0FP410Haoxincode8moonbash3lib6parser29strip__single__quote__markers(_s))]) : _M0FP410Haoxincode8moonbash3lib6parser20parse__word__content(_s);
      } else {
        target = _M0FP410Haoxincode8moonbash3lib6parser20parse__word__content(_s);
      }
      break;
    }
    case 1: {
      const _Number = _bind$6;
      const _n = _Number._0;
      _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
      target = _M0FP410Haoxincode8moonbash3lib6parser19make__literal__word(_M0MPC15int645Int6418to__string_2einner(_n, 10));
      break;
    }
    default: {
      return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast11RedirectionRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError(`expected word after redirection, got ${_M0IP016_24default__implPB4Show10to__stringGRP410Haoxincode8moonbash3lib3ast5TokenE(_bind$6)}`));
    }
  }
  return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast11RedirectionRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(new _M0TP410Haoxincode8moonbash3lib3ast11Redirection(fd, undefined, op, target));
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser39parse__double__bracket__simple__command(self) {
  const assignments = [];
  const words = [];
  const redirections = [];
  const opening = _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
  let opening_text;
  switch (opening.$tag) {
    case 0: {
      const _Word = opening;
      opening_text = _Word._0;
      break;
    }
    case 26: {
      opening_text = "[[";
      break;
    }
    default: {
      return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast13SimpleCommandRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError(`expected [[, got ${_M0IP016_24default__implPB4Show10to__stringGRP410Haoxincode8moonbash3lib3ast5TokenE(opening)}`));
    }
  }
  _M0MPC15array5Array4pushGUssEE(words, _M0FP410Haoxincode8moonbash3lib6parser20parse__word__content(opening_text));
  let closed = false;
  _L: while (true) {
    if (!_M0MP410Haoxincode8moonbash3lib6parser6Parser7at__end(self)) {
      const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser4peek(self);
      switch (_bind$4.$tag) {
        case 9: {
          _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
          continue _L;
        }
        case 45: {
          break _L;
        }
      }
      const tok = _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
      let token_text;
      if (tok.$tag === 27) {
        token_text = "]]";
      } else {
        token_text = _M0FP410Haoxincode8moonbash3lib6parser24arith__token__to__string(tok);
      }
      _M0MPC15array5Array4pushGUssEE(words, _M0FP410Haoxincode8moonbash3lib6parser20parse__word__content(token_text));
      if (token_text === "]]") {
        closed = true;
        break;
      }
      continue;
    } else {
      break;
    }
  }
  if (!closed) {
    return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast13SimpleCommandRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError("expected ]] to close conditional expression"));
  }
  while (true) {
    if (_M0MP410Haoxincode8moonbash3lib6parser6Parser15is__redirection(self)) {
      const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser18parse__redirection(self);
      let _tmp$38;
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        _tmp$38 = _ok._0;
      } else {
        return _bind$4;
      }
      _M0MPC15array5Array4pushGUssEE(redirections, _tmp$38);
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast13SimpleCommandRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(new _M0TP410Haoxincode8moonbash3lib3ast13SimpleCommand(assignments, words, redirections));
}
function _M0FP410Haoxincode8moonbash3lib6parser18trim__cstyle__expr(s) {
  let start = 0;
  let end_ = s.length;
  while (true) {
    if (start < end_) {
      const _tmp$38 = start;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch === 32 || (ch === 9 || (ch === 10 || ch === 13))) {
        start = start + 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (end_ > start) {
      const _tmp$38 = end_ - 1 | 0;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch === 32 || (ch === 9 || (ch === 10 || ch === 13))) {
        end_ = end_ - 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  return _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(s, start, end_));
}
function _M0FP410Haoxincode8moonbash3lib6parser31split__cstyle__for__expressions(raw) {
  const parts = [];
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let paren_depth = 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < raw.length) {
      _L: {
        $bound_check(raw, i);
        const ch = raw.charCodeAt(i);
        if (ch === 40) {
          paren_depth = paren_depth + 1 | 0;
          _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
          break _L;
        }
        if (ch === 41) {
          if (paren_depth > 0) {
            paren_depth = paren_depth - 1 | 0;
          }
          _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
          break _L;
        }
        if (ch === 59 && paren_depth === 0) {
          _M0MPC15array5Array4pushGUssEE(parts, _M0FP410Haoxincode8moonbash3lib6parser18trim__cstyle__expr(buf.val));
          _M0MPB13StringBuilder5reset(buf);
          break _L;
        }
        _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
        break _L;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MPC15array5Array4pushGUssEE(parts, _M0FP410Haoxincode8moonbash3lib6parser18trim__cstyle__expr(buf.val));
  return parts;
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser19parse__redirections(self) {
  const redirs = [];
  while (true) {
    if (_M0MP410Haoxincode8moonbash3lib6parser6Parser15is__redirection(self)) {
      const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser18parse__redirection(self);
      let _tmp$38;
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        _tmp$38 = _ok._0;
      } else {
        return _bind$4;
      }
      _M0MPC15array5Array4pushGUssEE(redirs, _tmp$38);
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast11RedirectionERP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(redirs);
}
function _M0FP410Haoxincode8moonbash3lib6parser17token__to__string(tok) {
  switch (tok.$tag) {
    case 0: {
      const _Word = tok;
      return _Word._0;
    }
    case 1: {
      const _Number = tok;
      const _n = _Number._0;
      return _M0MPC15int645Int6418to__string_2einner(_n, 10);
    }
    case 2: {
      const _AssignmentWord = tok;
      const _name = _AssignmentWord._0;
      const _value = _AssignmentWord._1;
      const _append = _AssignmentWord._2;
      return _value.length === 0 ? (_append ? `${_name}+=` : `${_name}=`) : _append ? `${_name}+=${_value}` : `${_name}=${_value}`;
    }
    case 28: {
      return "if";
    }
    case 29: {
      return "then";
    }
    case 30: {
      return "elif";
    }
    case 31: {
      return "else";
    }
    case 32: {
      return "fi";
    }
    case 33: {
      return "for";
    }
    case 34: {
      return "while";
    }
    case 35: {
      return "until";
    }
    case 36: {
      return "do";
    }
    case 37: {
      return "done";
    }
    case 38: {
      return "case";
    }
    case 39: {
      return "esac";
    }
    case 40: {
      return "in";
    }
    case 41: {
      return "function";
    }
    case 42: {
      return "select";
    }
    case 43: {
      return "!";
    }
    case 44: {
      return "time";
    }
    case 24: {
      return "{";
    }
    case 25: {
      return "}";
    }
    case 26: {
      return "[[";
    }
    case 27: {
      return "]]";
    }
    default: {
      return "";
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib6parser18heredoc__delimiter(word) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let quoted = false;
  const _bind$4 = word.parts;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const part = _bind$4[_];
      switch (part.$tag) {
        case 0: {
          const _Literal = part;
          const _s = _Literal._0;
          _M0IPB13StringBuilderPB6Logger13write__string(out, _s);
          break;
        }
        case 1: {
          const _SingleQuoted = part;
          const _s$2 = _SingleQuoted._0;
          quoted = true;
          _M0IPB13StringBuilderPB6Logger13write__string(out, _s$2);
          break;
        }
        case 2: {
          const _DoubleQuoted = part;
          const _inner = _DoubleQuoted._0;
          quoted = true;
          const _bind$6 = _inner.length;
          let _tmp$39 = 0;
          while (true) {
            const _$2 = _tmp$39;
            if (_$2 < _bind$6) {
              const p = _inner[_$2];
              switch (p.$tag) {
                case 0: {
                  const _Literal$2 = p;
                  const _s$3 = _Literal$2._0;
                  _M0IPB13StringBuilderPB6Logger13write__string(out, _s$3);
                  break;
                }
                case 1: {
                  const _SingleQuoted$2 = p;
                  const _s$4 = _SingleQuoted$2._0;
                  _M0IPB13StringBuilderPB6Logger13write__string(out, _s$4);
                  break;
                }
              }
              _tmp$39 = _$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          break;
        }
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return { _0: out.val, _1: quoted };
}
function _M0FP410Haoxincode8moonbash3lib6parser25join__tokens__with__space(parts) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < parts.length) {
      if (i > 0) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 32);
      }
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(parts, i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib6parser17token__line__text(tok) {
  switch (tok.$tag) {
    case 0: {
      const _Word = tok;
      const _s = _Word._0;
      return _M0FP410Haoxincode8moonbash3lib6parser29strip__single__quote__markers(_s);
    }
    case 1: {
      const _Number = tok;
      const _n = _Number._0;
      return _M0MPC15int645Int6418to__string_2einner(_n, 10);
    }
    case 7: {
      return ";";
    }
    case 3: {
      return "|";
    }
    case 4: {
      return "|&";
    }
    case 5: {
      return "&&";
    }
    case 6: {
      return "||";
    }
    case 8: {
      return "&";
    }
    case 22: {
      return "(";
    }
    case 23: {
      return ")";
    }
    case 24: {
      return "{";
    }
    case 25: {
      return "}";
    }
    case 43: {
      return "!";
    }
    case 28: {
      return "if";
    }
    case 29: {
      return "then";
    }
    case 30: {
      return "elif";
    }
    case 31: {
      return "else";
    }
    case 32: {
      return "fi";
    }
    case 33: {
      return "for";
    }
    case 34: {
      return "while";
    }
    case 35: {
      return "until";
    }
    case 36: {
      return "do";
    }
    case 37: {
      return "done";
    }
    case 38: {
      return "case";
    }
    case 39: {
      return "esac";
    }
    case 40: {
      return "in";
    }
    case 41: {
      return "function";
    }
    case 42: {
      return "select";
    }
    case 44: {
      return "time";
    }
    case 10: {
      return "<";
    }
    case 11: {
      return ">";
    }
    case 12: {
      return ">>";
    }
    case 13: {
      return ">|";
    }
    case 14: {
      return "<<";
    }
    case 15: {
      return "<<-";
    }
    case 16: {
      return "<<<";
    }
    case 17: {
      return "<&";
    }
    case 18: {
      return ">&";
    }
    case 19: {
      return "<>";
    }
    case 20: {
      return "&>";
    }
    case 21: {
      return "&>>";
    }
    case 2: {
      const _AssignmentWord = tok;
      const _name = _AssignmentWord._0;
      const _value = _AssignmentWord._1;
      const _append = _AssignmentWord._2;
      if (_value.length === 0) {
        return _append ? `${_name}+=` : `${_name}=`;
      } else {
        const rendered = _M0FP410Haoxincode8moonbash3lib6parser29strip__single__quote__markers(_value);
        return _append ? `${_name}+=${rendered}` : `${_name}=${rendered}`;
      }
    }
    case 46: {
      const _FdNumber = tok;
      const _n$2 = _FdNumber._0;
      return _M0MPC13int3Int18to__string_2einner(_n$2, 10);
    }
    case 26: {
      return "[[";
    }
    case 27: {
      return "]]";
    }
    case 9: {
      return "";
    }
    default: {
      return "";
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser18read__line__tokens(self) {
  const parts = [];
  while (true) {
    if (!_M0MP410Haoxincode8moonbash3lib6parser6Parser7at__end(self) && !_M0MP410Haoxincode8moonbash3lib6parser6Parser5check(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token7Newline__)) {
      const tok = _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
      _M0MPC15array5Array4pushGUssEE(parts, _M0FP410Haoxincode8moonbash3lib6parser17token__line__text(tok));
      continue;
    } else {
      break;
    }
  }
  if (_M0MP410Haoxincode8moonbash3lib6parser6Parser5check(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token7Newline__)) {
    _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
  }
  return _M0FP410Haoxincode8moonbash3lib6parser25join__tokens__with__space(parts);
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser20read__heredoc__until(self, delimiter) {
  const body = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  while (true) {
    if (!_M0MP410Haoxincode8moonbash3lib6parser6Parser7at__end(self)) {
      const line = _M0MP410Haoxincode8moonbash3lib6parser6Parser18read__line__tokens(self);
      if (line === delimiter) {
        return new _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(body.val);
      }
      _M0IPB13StringBuilderPB6Logger13write__string(body, line);
      _M0IPB13StringBuilderPB6Logger11write__char(body, 10);
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGsRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError("unexpected EOF while looking for matching heredoc delimiter"));
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser24consume__heredoc__bodies(self, redirections) {
  let heredoc_count = 0;
  const _bind$4 = redirections.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const redir = redirections[_];
      const _bind$5 = redir.op;
      if (_bind$5.$tag === 5) {
        heredoc_count = heredoc_count + 1 | 0;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (heredoc_count === 0) {
    return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(undefined);
  }
  if (_M0MP410Haoxincode8moonbash3lib6parser6Parser5check(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token7Newline__)) {
    _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
  } else {
    return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(undefined);
  }
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < redirections.length) {
      const _bind$5 = _M0MPC15array5Array2atGUssEE(redirections, i).op;
      if (_bind$5.$tag === 5) {
        const _bind$6 = _M0FP410Haoxincode8moonbash3lib6parser18heredoc__delimiter(_M0MPC15array5Array2atGUssEE(redirections, i).target);
        const _delimiter = _bind$6._0;
        const _quoted_delim = _bind$6._1;
        const _bind$7 = _M0MP410Haoxincode8moonbash3lib6parser6Parser20read__heredoc__until(self, _delimiter);
        let body;
        if (_bind$7.$tag === 1) {
          const _ok = _bind$7;
          body = _ok._0;
        } else {
          return _bind$7;
        }
        const body_word = _quoted_delim ? new _M0TP410Haoxincode8moonbash3lib3ast4Word([new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart12SingleQuoted(body)]) : _M0FP410Haoxincode8moonbash3lib6parser20parse__word__content(body);
        const redir = _M0MPC15array5Array2atGUssEE(redirections, i);
        _M0MPC15array5Array3setGsE(redirections, i, new _M0TP410Haoxincode8moonbash3lib3ast11Redirection(redir.fd, redir.fd_var, redir.op, body_word));
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGuRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(undefined);
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser8is__word(self) {
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser4peek(self);
  switch (_bind$4.$tag) {
    case 0: {
      return true;
    }
    case 1: {
      return true;
    }
    case 2: {
      return true;
    }
    case 28: {
      return true;
    }
    case 29: {
      return true;
    }
    case 30: {
      return true;
    }
    case 31: {
      return true;
    }
    case 32: {
      return true;
    }
    case 33: {
      return true;
    }
    case 34: {
      return true;
    }
    case 35: {
      return true;
    }
    case 36: {
      return true;
    }
    case 37: {
      return true;
    }
    case 38: {
      return true;
    }
    case 39: {
      return true;
    }
    case 40: {
      return true;
    }
    case 41: {
      return true;
    }
    case 42: {
      return true;
    }
    case 43: {
      return true;
    }
    case 44: {
      return true;
    }
    case 24: {
      return true;
    }
    case 25: {
      return true;
    }
    case 26: {
      return true;
    }
    case 27: {
      return true;
    }
    default: {
      return false;
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser22parse__simple__command(self) {
  const assignments = [];
  const words = [];
  const redirections = [];
  const start_pos = self.pos;
  while (true) {
    const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser4peek(self);
    if (_bind$4.$tag === 2) {
      const _AssignmentWord = _bind$4;
      const _name = _AssignmentWord._0;
      const _value = _AssignmentWord._1;
      const _append = _AssignmentWord._2;
      _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
      const word_value = _value.length > 0 ? _M0FP410Haoxincode8moonbash3lib6parser20parse__word__content(_value) : undefined;
      _M0MPC15array5Array4pushGUssEE(assignments, new _M0TP410Haoxincode8moonbash3lib3ast10Assignment(_name, word_value, _append));
    } else {
      break;
    }
    continue;
  }
  while (true) {
    if (_M0MP410Haoxincode8moonbash3lib6parser6Parser15is__redirection(self)) {
      const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser18parse__redirection(self);
      let _tmp$38;
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        _tmp$38 = _ok._0;
      } else {
        return _bind$4;
      }
      _M0MPC15array5Array4pushGUssEE(redirections, _tmp$38);
      continue;
    }
    if (_M0MP410Haoxincode8moonbash3lib6parser6Parser8is__word(self)) {
      const tok = _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
      _M0MPC15array5Array4pushGUssEE(words, _M0FP410Haoxincode8moonbash3lib6parser20parse__word__content(_M0FP410Haoxincode8moonbash3lib6parser17token__to__string(tok)));
      continue;
    }
    break;
  }
  if (assignments.length > 0 && (words.length === 0 && redirections.length === 0)) {
    const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser4peek(self);
    if (_bind$4.$tag === 22) {
      return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast13SimpleCommandRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError("syntax error near unexpected token `('"));
    }
  }
  if (self.pos === start_pos) {
    return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast13SimpleCommandRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError(`expected command, got ${_M0IP016_24default__implPB4Show10to__stringGRP410Haoxincode8moonbash3lib3ast5TokenE(_M0MP410Haoxincode8moonbash3lib6parser6Parser4peek(self))}`));
  }
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser24consume__heredoc__bodies(self, redirections);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast13SimpleCommandRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(new _M0TP410Haoxincode8moonbash3lib3ast13SimpleCommand(assignments, words, redirections));
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser13parse__script(self) {
  const statements = [];
  _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
  while (true) {
    if (!_M0MP410Haoxincode8moonbash3lib6parser6Parser7at__end(self) && !_M0MP410Haoxincode8moonbash3lib6parser6Parser22is__script__terminator(self)) {
      const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser16parse__statement(self);
      let stmt;
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        stmt = _ok._0;
      } else {
        return _bind$4;
      }
      _M0MPC15array5Array4pushGUssEE(statements, stmt);
      while (true) {
        if (_M0MP410Haoxincode8moonbash3lib6parser6Parser12match__token(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token7Newline__)) {
          continue;
        } else {
          break;
        }
      }
      while (true) {
        if (_M0MP410Haoxincode8moonbash3lib6parser6Parser5check(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token4Semi__) && !_M0IP410Haoxincode8moonbash3lib3ast5TokenPB2Eq5equal(_M0MP410Haoxincode8moonbash3lib6parser6Parser16peek__at__offset(self, 1), _M0DTP410Haoxincode8moonbash3lib3ast5Token4Semi__)) {
          _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
          continue;
        } else {
          break;
        }
      }
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast6ScriptRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(new _M0TP410Haoxincode8moonbash3lib3ast6Script(statements));
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser16parse__statement(self) {
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser15parse__pipeline(self);
  let pipeline;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    pipeline = _ok._0;
  } else {
    return _bind$4;
  }
  const _bind$5 = _M0MP410Haoxincode8moonbash3lib6parser6Parser4peek(self);
  let _tmp$38;
  switch (_bind$5.$tag) {
    case 5: {
      _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
      _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
      const _bind$6 = _M0MP410Haoxincode8moonbash3lib6parser6Parser16parse__statement(self);
      let right;
      if (_bind$6.$tag === 1) {
        const _ok = _bind$6;
        right = _ok._0;
      } else {
        return _bind$6;
      }
      _tmp$38 = new _M0DTP410Haoxincode8moonbash3lib3ast9Statement7AndList(pipeline, right);
      break;
    }
    case 6: {
      _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
      _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
      const _bind$7 = _M0MP410Haoxincode8moonbash3lib6parser6Parser16parse__statement(self);
      let right$2;
      if (_bind$7.$tag === 1) {
        const _ok = _bind$7;
        right$2 = _ok._0;
      } else {
        return _bind$7;
      }
      _tmp$38 = new _M0DTP410Haoxincode8moonbash3lib3ast9Statement6OrList(pipeline, right$2);
      break;
    }
    case 8: {
      _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
      _tmp$38 = new _M0DTP410Haoxincode8moonbash3lib3ast9Statement10Background(pipeline);
      break;
    }
    case 7: {
      if (_M0IP410Haoxincode8moonbash3lib3ast5TokenPB2Eq5equal(_M0MP410Haoxincode8moonbash3lib6parser6Parser16peek__at__offset(self, 1), _M0DTP410Haoxincode8moonbash3lib3ast5Token4Semi__)) {
        _tmp$38 = new _M0DTP410Haoxincode8moonbash3lib3ast9Statement8Pipeline(pipeline);
      } else {
        _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
        _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
        if (_M0MP410Haoxincode8moonbash3lib6parser6Parser7at__end(self) || _M0MP410Haoxincode8moonbash3lib6parser6Parser22is__script__terminator(self)) {
          _tmp$38 = new _M0DTP410Haoxincode8moonbash3lib3ast9Statement8Pipeline(pipeline);
        } else {
          const _bind$8 = _M0MP410Haoxincode8moonbash3lib6parser6Parser16parse__statement(self);
          let right$3;
          if (_bind$8.$tag === 1) {
            const _ok = _bind$8;
            right$3 = _ok._0;
          } else {
            return _bind$8;
          }
          _tmp$38 = new _M0DTP410Haoxincode8moonbash3lib3ast9Statement8Sequence(pipeline, right$3);
        }
      }
      break;
    }
    default: {
      _tmp$38 = new _M0DTP410Haoxincode8moonbash3lib3ast9Statement8Pipeline(pipeline);
    }
  }
  return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast9StatementRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(_tmp$38);
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser15parse__pipeline(self) {
  const negated = _M0MP410Haoxincode8moonbash3lib6parser6Parser12match__token(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token4Bang__);
  const commands = [];
  let pipe_stderr = false;
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser14parse__command(self);
  let _tmp$38;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _tmp$38 = _ok._0;
  } else {
    return _bind$4;
  }
  _M0MPC15array5Array4pushGUssEE(commands, _tmp$38);
  _L: while (true) {
    const _bind$5 = _M0MP410Haoxincode8moonbash3lib6parser6Parser4peek(self);
    switch (_bind$5.$tag) {
      case 3: {
        _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
        _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
        const _bind$6 = _M0MP410Haoxincode8moonbash3lib6parser6Parser14parse__command(self);
        let _tmp$39;
        if (_bind$6.$tag === 1) {
          const _ok = _bind$6;
          _tmp$39 = _ok._0;
        } else {
          return _bind$6;
        }
        _M0MPC15array5Array4pushGUssEE(commands, _tmp$39);
        break;
      }
      case 4: {
        _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
        pipe_stderr = true;
        _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
        const _bind$7 = _M0MP410Haoxincode8moonbash3lib6parser6Parser14parse__command(self);
        let _tmp$40;
        if (_bind$7.$tag === 1) {
          const _ok = _bind$7;
          _tmp$40 = _ok._0;
        } else {
          return _bind$7;
        }
        _M0MPC15array5Array4pushGUssEE(commands, _tmp$40);
        break;
      }
      default: {
        break _L;
      }
    }
    continue;
  }
  return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast8PipelineRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(new _M0TP410Haoxincode8moonbash3lib3ast8Pipeline(negated, commands, pipe_stderr));
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser14parse__command(self) {
  if (_M0MP410Haoxincode8moonbash3lib6parser6Parser26is__double__bracket__start(self)) {
    const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser39parse__double__bracket__simple__command(self);
    let _tmp$38;
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _tmp$38 = _ok._0;
    } else {
      return _bind$4;
    }
    return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast7CommandRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(new _M0DTP410Haoxincode8moonbash3lib3ast7Command6Simple(_tmp$38));
  }
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser4peek(self);
  switch (_bind$4.$tag) {
    case 28: {
      const _bind$5 = _M0MP410Haoxincode8moonbash3lib6parser6Parser12enter__depth(self);
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        _ok._0;
      } else {
        return _bind$5;
      }
      const _bind$6 = _M0MP410Haoxincode8moonbash3lib6parser6Parser9parse__if(self);
      let cmd;
      if (_bind$6.$tag === 1) {
        const _ok = _bind$6;
        cmd = _ok._0;
      } else {
        return _bind$6;
      }
      const _bind$7 = _M0MP410Haoxincode8moonbash3lib6parser6Parser19parse__redirections(self);
      let redirs;
      if (_bind$7.$tag === 1) {
        const _ok = _bind$7;
        redirs = _ok._0;
      } else {
        return _bind$7;
      }
      _M0MP410Haoxincode8moonbash3lib6parser6Parser12leave__depth(self);
      return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast7CommandRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(new _M0DTP410Haoxincode8moonbash3lib3ast7Command8Compound(new _M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand2If(cmd), redirs));
    }
    case 33: {
      const _bind$8 = _M0MP410Haoxincode8moonbash3lib6parser6Parser12enter__depth(self);
      if (_bind$8.$tag === 1) {
        const _ok = _bind$8;
        _ok._0;
      } else {
        return _bind$8;
      }
      const _bind$9 = _M0MP410Haoxincode8moonbash3lib6parser6Parser10parse__for(self);
      let cmd$2;
      if (_bind$9.$tag === 1) {
        const _ok = _bind$9;
        cmd$2 = _ok._0;
      } else {
        return _bind$9;
      }
      const _bind$10 = _M0MP410Haoxincode8moonbash3lib6parser6Parser19parse__redirections(self);
      let redirs$2;
      if (_bind$10.$tag === 1) {
        const _ok = _bind$10;
        redirs$2 = _ok._0;
      } else {
        return _bind$10;
      }
      _M0MP410Haoxincode8moonbash3lib6parser6Parser12leave__depth(self);
      return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast7CommandRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(new _M0DTP410Haoxincode8moonbash3lib3ast7Command8Compound(cmd$2, redirs$2));
    }
    case 34: {
      const _bind$11 = _M0MP410Haoxincode8moonbash3lib6parser6Parser12enter__depth(self);
      if (_bind$11.$tag === 1) {
        const _ok = _bind$11;
        _ok._0;
      } else {
        return _bind$11;
      }
      const _bind$12 = _M0MP410Haoxincode8moonbash3lib6parser6Parser12parse__while(self);
      let cmd$3;
      if (_bind$12.$tag === 1) {
        const _ok = _bind$12;
        cmd$3 = _ok._0;
      } else {
        return _bind$12;
      }
      const _bind$13 = _M0MP410Haoxincode8moonbash3lib6parser6Parser19parse__redirections(self);
      let redirs$3;
      if (_bind$13.$tag === 1) {
        const _ok = _bind$13;
        redirs$3 = _ok._0;
      } else {
        return _bind$13;
      }
      _M0MP410Haoxincode8moonbash3lib6parser6Parser12leave__depth(self);
      return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast7CommandRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(new _M0DTP410Haoxincode8moonbash3lib3ast7Command8Compound(new _M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand5While(cmd$3), redirs$3));
    }
    case 35: {
      const _bind$14 = _M0MP410Haoxincode8moonbash3lib6parser6Parser12enter__depth(self);
      if (_bind$14.$tag === 1) {
        const _ok = _bind$14;
        _ok._0;
      } else {
        return _bind$14;
      }
      const _bind$15 = _M0MP410Haoxincode8moonbash3lib6parser6Parser12parse__until(self);
      let cmd$4;
      if (_bind$15.$tag === 1) {
        const _ok = _bind$15;
        cmd$4 = _ok._0;
      } else {
        return _bind$15;
      }
      const _bind$16 = _M0MP410Haoxincode8moonbash3lib6parser6Parser19parse__redirections(self);
      let redirs$4;
      if (_bind$16.$tag === 1) {
        const _ok = _bind$16;
        redirs$4 = _ok._0;
      } else {
        return _bind$16;
      }
      _M0MP410Haoxincode8moonbash3lib6parser6Parser12leave__depth(self);
      return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast7CommandRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(new _M0DTP410Haoxincode8moonbash3lib3ast7Command8Compound(new _M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand5Until(cmd$4), redirs$4));
    }
    case 38: {
      const _bind$17 = _M0MP410Haoxincode8moonbash3lib6parser6Parser12enter__depth(self);
      if (_bind$17.$tag === 1) {
        const _ok = _bind$17;
        _ok._0;
      } else {
        return _bind$17;
      }
      const _bind$18 = _M0MP410Haoxincode8moonbash3lib6parser6Parser11parse__case(self);
      let cmd$5;
      if (_bind$18.$tag === 1) {
        const _ok = _bind$18;
        cmd$5 = _ok._0;
      } else {
        return _bind$18;
      }
      const _bind$19 = _M0MP410Haoxincode8moonbash3lib6parser6Parser19parse__redirections(self);
      let redirs$5;
      if (_bind$19.$tag === 1) {
        const _ok = _bind$19;
        redirs$5 = _ok._0;
      } else {
        return _bind$19;
      }
      _M0MP410Haoxincode8moonbash3lib6parser6Parser12leave__depth(self);
      return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast7CommandRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(new _M0DTP410Haoxincode8moonbash3lib3ast7Command8Compound(new _M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand4Case(cmd$5), redirs$5));
    }
    case 22: {
      if (_M0IP410Haoxincode8moonbash3lib3ast5TokenPB2Eq5equal(_M0MP410Haoxincode8moonbash3lib6parser6Parser16peek__at__offset(self, 1), _M0DTP410Haoxincode8moonbash3lib3ast5Token9LeftParen__)) {
        const _bind$20 = _M0MP410Haoxincode8moonbash3lib6parser6Parser12enter__depth(self);
        if (_bind$20.$tag === 1) {
          const _ok = _bind$20;
          _ok._0;
        } else {
          return _bind$20;
        }
        _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
        _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
        const _bind$21 = _M0MP410Haoxincode8moonbash3lib6parser6Parser22parse__arithmetic__raw(self);
        let raw_expr;
        if (_bind$21.$tag === 1) {
          const _ok = _bind$21;
          raw_expr = _ok._0;
        } else {
          return _bind$21;
        }
        const _bind$22 = _M0MP410Haoxincode8moonbash3lib6parser6Parser19parse__redirections(self);
        let redirs$6;
        if (_bind$22.$tag === 1) {
          const _ok = _bind$22;
          redirs$6 = _ok._0;
        } else {
          return _bind$22;
        }
        _M0MP410Haoxincode8moonbash3lib6parser6Parser12leave__depth(self);
        return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast7CommandRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(new _M0DTP410Haoxincode8moonbash3lib3ast7Command8Compound(new _M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand17ArithmeticCommand(new _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Raw(raw_expr)), redirs$6));
      } else {
        const _bind$20 = _M0MP410Haoxincode8moonbash3lib6parser6Parser12enter__depth(self);
        if (_bind$20.$tag === 1) {
          const _ok = _bind$20;
          _ok._0;
        } else {
          return _bind$20;
        }
        _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
        _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
        const _bind$21 = _M0MP410Haoxincode8moonbash3lib6parser6Parser13parse__script(self);
        let script;
        if (_bind$21.$tag === 1) {
          const _ok = _bind$21;
          script = _ok._0;
        } else {
          return _bind$21;
        }
        _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
        const _bind$22 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token10RightParen__);
        if (_bind$22.$tag === 1) {
          const _ok = _bind$22;
          _ok._0;
        } else {
          return _bind$22;
        }
        const _bind$23 = _M0MP410Haoxincode8moonbash3lib6parser6Parser19parse__redirections(self);
        let redirs$6;
        if (_bind$23.$tag === 1) {
          const _ok = _bind$23;
          redirs$6 = _ok._0;
        } else {
          return _bind$23;
        }
        _M0MP410Haoxincode8moonbash3lib6parser6Parser12leave__depth(self);
        return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast7CommandRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(new _M0DTP410Haoxincode8moonbash3lib3ast7Command8Compound(new _M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand8Subshell(script), redirs$6));
      }
    }
    case 24: {
      const _bind$20 = _M0MP410Haoxincode8moonbash3lib6parser6Parser12enter__depth(self);
      if (_bind$20.$tag === 1) {
        const _ok = _bind$20;
        _ok._0;
      } else {
        return _bind$20;
      }
      _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
      _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
      const _bind$21 = _M0MP410Haoxincode8moonbash3lib6parser6Parser13parse__script(self);
      let script;
      if (_bind$21.$tag === 1) {
        const _ok = _bind$21;
        script = _ok._0;
      } else {
        return _bind$21;
      }
      _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
      const _bind$22 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token10RightBrace__);
      if (_bind$22.$tag === 1) {
        const _ok = _bind$22;
        _ok._0;
      } else {
        return _bind$22;
      }
      const _bind$23 = _M0MP410Haoxincode8moonbash3lib6parser6Parser19parse__redirections(self);
      let redirs$6;
      if (_bind$23.$tag === 1) {
        const _ok = _bind$23;
        redirs$6 = _ok._0;
      } else {
        return _bind$23;
      }
      _M0MP410Haoxincode8moonbash3lib6parser6Parser12leave__depth(self);
      return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast7CommandRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(new _M0DTP410Haoxincode8moonbash3lib3ast7Command8Compound(new _M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand5Group(script), redirs$6));
    }
    case 41: {
      return _M0MP410Haoxincode8moonbash3lib6parser6Parser20parse__function__def(self);
    }
    default: {
      if (_M0MP410Haoxincode8moonbash3lib6parser6Parser33looks__like__posix__function__def(self)) {
        const _bind$24 = _M0MP410Haoxincode8moonbash3lib6parser6Parser12enter__depth(self);
        if (_bind$24.$tag === 1) {
          const _ok = _bind$24;
          _ok._0;
        } else {
          return _bind$24;
        }
        const _bind$25 = _M0MP410Haoxincode8moonbash3lib6parser6Parser27parse__posix__function__def(self);
        let fndef;
        if (_bind$25.$tag === 1) {
          const _ok = _bind$25;
          fndef = _ok._0;
        } else {
          return _bind$25;
        }
        _M0MP410Haoxincode8moonbash3lib6parser6Parser12leave__depth(self);
        return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast7CommandRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(fndef);
      } else {
        const _bind$24 = _M0MP410Haoxincode8moonbash3lib6parser6Parser22parse__simple__command(self);
        let _tmp$38;
        if (_bind$24.$tag === 1) {
          const _ok = _bind$24;
          _tmp$38 = _ok._0;
        } else {
          return _bind$24;
        }
        return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast7CommandRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(new _M0DTP410Haoxincode8moonbash3lib3ast7Command6Simple(_tmp$38));
      }
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser11parse__case(self) {
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token4Case__);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  const _bind$5 = _M0MP410Haoxincode8moonbash3lib6parser6Parser4peek(self);
  let word;
  if (_bind$5.$tag === 0) {
    const _Word = _bind$5;
    const _s = _Word._0;
    _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
    word = _M0FP410Haoxincode8moonbash3lib6parser20parse__word__content(_s);
  } else {
    return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast10CaseClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError(`expected word after 'case', got ${_M0IP016_24default__implPB4Show10to__stringGRP410Haoxincode8moonbash3lib3ast5TokenE(_bind$5)}`));
  }
  _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
  const _bind$6 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token2In__);
  if (_bind$6.$tag === 1) {
    const _ok = _bind$6;
    _ok._0;
  } else {
    return _bind$6;
  }
  _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
  const items = [];
  while (true) {
    if (!_M0MP410Haoxincode8moonbash3lib6parser6Parser5check(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token4Esac__) && !_M0MP410Haoxincode8moonbash3lib6parser6Parser7at__end(self)) {
      _M0MP410Haoxincode8moonbash3lib6parser6Parser12match__token(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token9LeftParen__);
      const patterns = [];
      while (true) {
        const _bind$7 = _M0MP410Haoxincode8moonbash3lib6parser6Parser4peek(self);
        switch (_bind$7.$tag) {
          case 0: {
            const _Word = _bind$7;
            const _s = _Word._0;
            _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
            _M0MPC15array5Array4pushGUssEE(patterns, _M0FP410Haoxincode8moonbash3lib6parser20parse__word__content(_s));
            break;
          }
          case 1: {
            const _Number = _bind$7;
            const _n = _Number._0;
            _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
            _M0MPC15array5Array4pushGUssEE(patterns, _M0FP410Haoxincode8moonbash3lib6parser19make__literal__word(_M0MPC15int645Int6418to__string_2einner(_n, 10)));
            break;
          }
          default: {
            return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast10CaseClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError(`expected pattern in case item, got ${_M0IP016_24default__implPB4Show10to__stringGRP410Haoxincode8moonbash3lib3ast5TokenE(_bind$7)}`));
          }
        }
        if (_M0MP410Haoxincode8moonbash3lib6parser6Parser12match__token(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token4Pipe__)) {
          continue;
        }
        break;
      }
      const _bind$7 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token10RightParen__);
      if (_bind$7.$tag === 1) {
        const _ok = _bind$7;
        _ok._0;
      } else {
        return _bind$7;
      }
      _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
      const _bind$8 = _M0MP410Haoxincode8moonbash3lib6parser6Parser13parse__script(self);
      let body;
      if (_bind$8.$tag === 1) {
        const _ok = _bind$8;
        body = _ok._0;
      } else {
        return _bind$8;
      }
      _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
      let terminator;
      if (_M0MP410Haoxincode8moonbash3lib6parser6Parser5check(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token4Semi__)) {
        _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
        if (_M0MP410Haoxincode8moonbash3lib6parser6Parser5check(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token4Semi__)) {
          _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
          terminator = 0;
        } else {
          if (_M0MP410Haoxincode8moonbash3lib6parser6Parser5check(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token9Ampersand__)) {
            _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
            terminator = 1;
          } else {
            terminator = 0;
          }
        }
      } else {
        terminator = 0;
      }
      _M0MPC15array5Array4pushGUssEE(items, new _M0TP410Haoxincode8moonbash3lib3ast8CaseItem(patterns, body, terminator));
      _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
      continue;
    } else {
      break;
    }
  }
  const _bind$7 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token4Esac__);
  if (_bind$7.$tag === 1) {
    const _ok = _bind$7;
    _ok._0;
  } else {
    return _bind$7;
  }
  return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast10CaseClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(new _M0TP410Haoxincode8moonbash3lib3ast10CaseClause(word, items));
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser10parse__for(self) {
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token3For__);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  if (_M0MP410Haoxincode8moonbash3lib6parser6Parser5check(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token9LeftParen__) && _M0IP410Haoxincode8moonbash3lib3ast5TokenPB2Eq5equal(_M0MP410Haoxincode8moonbash3lib6parser6Parser16peek__at__offset(self, 1), _M0DTP410Haoxincode8moonbash3lib3ast5Token9LeftParen__)) {
    _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
    _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
    const _bind$5 = _M0MP410Haoxincode8moonbash3lib6parser6Parser22parse__arithmetic__raw(self);
    let raw;
    if (_bind$5.$tag === 1) {
      const _ok = _bind$5;
      raw = _ok._0;
    } else {
      return _bind$5;
    }
    const pieces = _M0FP410Haoxincode8moonbash3lib6parser31split__cstyle__for__expressions(raw);
    if (pieces.length !== 3) {
      return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast15CompoundCommandRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError("invalid C-style for expression"));
    }
    while (true) {
      if (_M0MP410Haoxincode8moonbash3lib6parser6Parser12match__token(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token4Semi__) || _M0MP410Haoxincode8moonbash3lib6parser6Parser12match__token(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token7Newline__)) {
        continue;
      } else {
        break;
      }
    }
    const _bind$6 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token2Do__);
    if (_bind$6.$tag === 1) {
      const _ok = _bind$6;
      _ok._0;
    } else {
      return _bind$6;
    }
    _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
    const _bind$7 = _M0MP410Haoxincode8moonbash3lib6parser6Parser13parse__script(self);
    let body;
    if (_bind$7.$tag === 1) {
      const _ok = _bind$7;
      body = _ok._0;
    } else {
      return _bind$7;
    }
    _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
    const _bind$8 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token4Done__);
    if (_bind$8.$tag === 1) {
      const _ok = _bind$8;
      _ok._0;
    } else {
      return _bind$8;
    }
    return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast15CompoundCommandRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(new _M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand9CStyleFor(new _M0TP410Haoxincode8moonbash3lib3ast15CStyleForClause(new _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Raw(_M0MPC15array5Array2atGUssEE(pieces, 0)), new _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Raw(_M0MPC15array5Array2atGUssEE(pieces, 1)), new _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Raw(_M0MPC15array5Array2atGUssEE(pieces, 2)), body)));
  }
  const _bind$5 = _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
  let var_name;
  if (_bind$5.$tag === 0) {
    const _Word = _bind$5;
    var_name = _Word._0;
  } else {
    return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast15CompoundCommandRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError(`expected variable name after 'for', got ${_M0IP016_24default__implPB4Show10to__stringGRP410Haoxincode8moonbash3lib3ast5TokenE(_bind$5)}`));
  }
  let words = _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast4WordEE4None__;
  _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
  if (_M0MP410Haoxincode8moonbash3lib6parser6Parser12match__token(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token2In__)) {
    const word_list = [];
    _L: while (true) {
      const _bind$6 = _M0MP410Haoxincode8moonbash3lib6parser6Parser4peek(self);
      switch (_bind$6.$tag) {
        case 0: {
          const _Word = _bind$6;
          const _s = _Word._0;
          _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
          _M0MPC15array5Array4pushGUssEE(word_list, _M0FP410Haoxincode8moonbash3lib6parser20parse__word__content(_s));
          break;
        }
        case 1: {
          const _Number = _bind$6;
          const _n = _Number._0;
          _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
          _M0MPC15array5Array4pushGUssEE(word_list, _M0FP410Haoxincode8moonbash3lib6parser19make__literal__word(_M0MPC15int645Int6418to__string_2einner(_n, 10)));
          break;
        }
        default: {
          break _L;
        }
      }
      continue;
    }
    words = new _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast4WordEE4Some(word_list);
  }
  while (true) {
    if (_M0MP410Haoxincode8moonbash3lib6parser6Parser12match__token(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token4Semi__) || _M0MP410Haoxincode8moonbash3lib6parser6Parser12match__token(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token7Newline__)) {
      continue;
    } else {
      break;
    }
  }
  const _bind$6 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token2Do__);
  if (_bind$6.$tag === 1) {
    const _ok = _bind$6;
    _ok._0;
  } else {
    return _bind$6;
  }
  _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
  const _bind$7 = _M0MP410Haoxincode8moonbash3lib6parser6Parser13parse__script(self);
  let body;
  if (_bind$7.$tag === 1) {
    const _ok = _bind$7;
    body = _ok._0;
  } else {
    return _bind$7;
  }
  _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
  const _bind$8 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token4Done__);
  if (_bind$8.$tag === 1) {
    const _ok = _bind$8;
    _ok._0;
  } else {
    return _bind$8;
  }
  return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast15CompoundCommandRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(new _M0DTP410Haoxincode8moonbash3lib3ast15CompoundCommand3For(new _M0TP410Haoxincode8moonbash3lib3ast9ForClause(var_name, words, body)));
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser20parse__function__def(self) {
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token8Function__);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  const _bind$5 = _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
  let name;
  if (_bind$5.$tag === 0) {
    const _Word = _bind$5;
    name = _Word._0;
  } else {
    return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast7CommandRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError(`expected function name, got ${_M0IP016_24default__implPB4Show10to__stringGRP410Haoxincode8moonbash3lib3ast5TokenE(_bind$5)}`));
  }
  if (_M0MP410Haoxincode8moonbash3lib6parser6Parser12match__token(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token9LeftParen__)) {
    const _bind$6 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token10RightParen__);
    if (_bind$6.$tag === 1) {
      const _ok = _bind$6;
      _ok._0;
    } else {
      return _bind$6;
    }
  }
  _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
  const _bind$6 = _M0MP410Haoxincode8moonbash3lib6parser6Parser14parse__command(self);
  let _bind$7;
  if (_bind$6.$tag === 1) {
    const _ok = _bind$6;
    _bind$7 = _ok._0;
  } else {
    return _bind$6;
  }
  let body;
  if (_bind$7.$tag === 1) {
    const _Compound = _bind$7;
    body = _Compound._0;
  } else {
    return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast7CommandRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError("function body must be a compound command"));
  }
  const _bind$8 = _M0MP410Haoxincode8moonbash3lib6parser6Parser19parse__redirections(self);
  let redirections;
  if (_bind$8.$tag === 1) {
    const _ok = _bind$8;
    redirections = _ok._0;
  } else {
    return _bind$8;
  }
  return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast7CommandRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(new _M0DTP410Haoxincode8moonbash3lib3ast7Command11FunctionDef(new _M0TP410Haoxincode8moonbash3lib3ast11FunctionDef(name, body, redirections)));
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser9parse__if(self) {
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token2If__);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
  const _bind$5 = _M0MP410Haoxincode8moonbash3lib6parser6Parser13parse__script(self);
  let condition;
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    condition = _ok._0;
  } else {
    return _bind$5;
  }
  if (condition.statements.length === 0) {
    return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast8IfClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError("if: missing condition command"));
  }
  _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
  const _bind$6 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token4Then__);
  if (_bind$6.$tag === 1) {
    const _ok = _bind$6;
    _ok._0;
  } else {
    return _bind$6;
  }
  _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
  const _bind$7 = _M0MP410Haoxincode8moonbash3lib6parser6Parser13parse__script(self);
  let then_branch;
  if (_bind$7.$tag === 1) {
    const _ok = _bind$7;
    then_branch = _ok._0;
  } else {
    return _bind$7;
  }
  if (then_branch.statements.length === 0) {
    return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast8IfClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError("if: missing then command"));
  }
  const elif_branches = [];
  let else_branch = undefined;
  while (true) {
    if (_M0MP410Haoxincode8moonbash3lib6parser6Parser12match__token(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token4Elif__)) {
      _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
      const _bind$8 = _M0MP410Haoxincode8moonbash3lib6parser6Parser13parse__script(self);
      let elif_cond;
      if (_bind$8.$tag === 1) {
        const _ok = _bind$8;
        elif_cond = _ok._0;
      } else {
        return _bind$8;
      }
      _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
      const _bind$9 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token4Then__);
      if (_bind$9.$tag === 1) {
        const _ok = _bind$9;
        _ok._0;
      } else {
        return _bind$9;
      }
      _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
      const _bind$10 = _M0MP410Haoxincode8moonbash3lib6parser6Parser13parse__script(self);
      let elif_body;
      if (_bind$10.$tag === 1) {
        const _ok = _bind$10;
        elif_body = _ok._0;
      } else {
        return _bind$10;
      }
      _M0MPC15array5Array4pushGUssEE(elif_branches, { _0: elif_cond, _1: elif_body });
      continue;
    } else {
      break;
    }
  }
  if (_M0MP410Haoxincode8moonbash3lib6parser6Parser12match__token(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token4Else__)) {
    _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
    const _bind$8 = _M0MP410Haoxincode8moonbash3lib6parser6Parser13parse__script(self);
    let _tmp$38;
    if (_bind$8.$tag === 1) {
      const _ok = _bind$8;
      _tmp$38 = _ok._0;
    } else {
      return _bind$8;
    }
    else_branch = _tmp$38;
  }
  _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
  const _bind$8 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token2Fi__);
  if (_bind$8.$tag === 1) {
    const _ok = _bind$8;
    _ok._0;
  } else {
    return _bind$8;
  }
  return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast8IfClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(new _M0TP410Haoxincode8moonbash3lib3ast8IfClause(condition, then_branch, elif_branches, else_branch));
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser27parse__posix__function__def(self) {
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser7advance(self);
  let name;
  if (_bind$4.$tag === 0) {
    const _Word = _bind$4;
    name = _Word._0;
  } else {
    return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast7CommandRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError(`expected function name, got ${_M0IP016_24default__implPB4Show10to__stringGRP410Haoxincode8moonbash3lib3ast5TokenE(_bind$4)}`));
  }
  const _bind$5 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token9LeftParen__);
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    _ok._0;
  } else {
    return _bind$5;
  }
  const _bind$6 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token10RightParen__);
  if (_bind$6.$tag === 1) {
    const _ok = _bind$6;
    _ok._0;
  } else {
    return _bind$6;
  }
  _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
  const _bind$7 = _M0MP410Haoxincode8moonbash3lib6parser6Parser14parse__command(self);
  let _bind$8;
  if (_bind$7.$tag === 1) {
    const _ok = _bind$7;
    _bind$8 = _ok._0;
  } else {
    return _bind$7;
  }
  let body;
  if (_bind$8.$tag === 1) {
    const _Compound = _bind$8;
    body = _Compound._0;
  } else {
    return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast7CommandRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError("function body must be a compound command"));
  }
  const _bind$9 = _M0MP410Haoxincode8moonbash3lib6parser6Parser19parse__redirections(self);
  let redirections;
  if (_bind$9.$tag === 1) {
    const _ok = _bind$9;
    redirections = _ok._0;
  } else {
    return _bind$9;
  }
  return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast7CommandRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(new _M0DTP410Haoxincode8moonbash3lib3ast7Command11FunctionDef(new _M0TP410Haoxincode8moonbash3lib3ast11FunctionDef(name, body, redirections)));
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser12parse__until(self) {
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token5Until__);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
  const _bind$5 = _M0MP410Haoxincode8moonbash3lib6parser6Parser13parse__script(self);
  let condition;
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    condition = _ok._0;
  } else {
    return _bind$5;
  }
  _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
  const _bind$6 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token2Do__);
  if (_bind$6.$tag === 1) {
    const _ok = _bind$6;
    _ok._0;
  } else {
    return _bind$6;
  }
  _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
  const _bind$7 = _M0MP410Haoxincode8moonbash3lib6parser6Parser13parse__script(self);
  let body;
  if (_bind$7.$tag === 1) {
    const _ok = _bind$7;
    body = _ok._0;
  } else {
    return _bind$7;
  }
  _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
  const _bind$8 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token4Done__);
  if (_bind$8.$tag === 1) {
    const _ok = _bind$8;
    _ok._0;
  } else {
    return _bind$8;
  }
  return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast11UntilClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(new _M0TP410Haoxincode8moonbash3lib3ast11UntilClause(condition, body));
}
function _M0MP410Haoxincode8moonbash3lib6parser6Parser12parse__while(self) {
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token5While__);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
  const _bind$5 = _M0MP410Haoxincode8moonbash3lib6parser6Parser13parse__script(self);
  let condition;
  if (_bind$5.$tag === 1) {
    const _ok = _bind$5;
    condition = _ok._0;
  } else {
    return _bind$5;
  }
  _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
  const _bind$6 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token2Do__);
  if (_bind$6.$tag === 1) {
    const _ok = _bind$6;
    _ok._0;
  } else {
    return _bind$6;
  }
  _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
  const _bind$7 = _M0MP410Haoxincode8moonbash3lib6parser6Parser13parse__script(self);
  let body;
  if (_bind$7.$tag === 1) {
    const _ok = _bind$7;
    body = _ok._0;
  } else {
    return _bind$7;
  }
  _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(self);
  const _bind$8 = _M0MP410Haoxincode8moonbash3lib6parser6Parser6expect(self, _M0DTP410Haoxincode8moonbash3lib3ast5Token4Done__);
  if (_bind$8.$tag === 1) {
    const _ok = _bind$8;
    _ok._0;
  } else {
    return _bind$8;
  }
  return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast11WhileClauseRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(new _M0TP410Haoxincode8moonbash3lib3ast11WhileClause(condition, body));
}
function _M0FP410Haoxincode8moonbash3lib6parser13parse__tokens(tokens) {
  const parser = new _M0TP410Haoxincode8moonbash3lib6parser6Parser(tokens, 0, 0);
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib6parser6Parser13parse__script(parser);
  let script;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    script = _ok._0;
  } else {
    return _bind$4;
  }
  _M0MP410Haoxincode8moonbash3lib6parser6Parser14skip__newlines(parser);
  if (!_M0MP410Haoxincode8moonbash3lib6parser6Parser7at__end(parser)) {
    return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast6ScriptRP410Haoxincode8moonbash3lib3ast9BashErrorE3Err(new _M0DTPC15error5Error57Haoxincode_2fmoonbash_2flib_2fast_2eBashError_2eBashError("syntax error near unexpected token"));
  }
  return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib3ast6ScriptRP410Haoxincode8moonbash3lib3ast9BashErrorE2Ok(script);
}
function _M0FP410Haoxincode8moonbash3lib6parser5parse(input) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib5lexer8tokenize(input);
  let tokens;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    tokens = _ok._0;
  } else {
    return _bind$4;
  }
  return _M0FP410Haoxincode8moonbash3lib6parser13parse__tokens(tokens);
}
function _M0FP411moonbitlang6regexp8internal7unicode22simplify__char__ranges(chars) {
  if ((chars.end - chars.start | 0) === 0) {
    const _bind$4 = [];
    return new _M0TPB9ArrayViewGcE(_bind$4, 0, 0);
  }
  const ranges = [];
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < (chars.end - chars.start | 0)) {
      const start = _M0MPC15array9ArrayView2atGcE(chars, i);
      const end = _M0MPC15array9ArrayView2atGcE(chars, i + 1 | 0);
      _M0MPC15array5Array4pushGUssEE(ranges, { _0: start, _1: end });
      _tmp$38 = i + 2 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MPC15array5Array13sort__by__keyGUccEcE(ranges, (range) => range._0);
  const simplified = [];
  let current_start = 0;
  let current_end = 0;
  if (ranges.length > 0) {
    current_start = _M0MPC15array5Array2atGUssEE(ranges, 0)._0;
    current_end = _M0MPC15array5Array2atGUssEE(ranges, 0)._1;
    const _bind$4 = _M0MPC15array5Array12view_2einnerGsE(ranges, 1, undefined);
    const _bind$5 = _bind$4.end - _bind$4.start | 0;
    let _tmp$39 = 0;
    while (true) {
      const _ = _tmp$39;
      if (_ < _bind$5) {
        const range = _bind$4.buf[_bind$4.start + _ | 0];
        const _next_start = range._0;
        const _next_end = range._1;
        if (_next_start <= (current_end + 1 | 0)) {
          current_end = current_end > _next_end ? current_end : _next_end;
        } else {
          _M0MPC15array5Array4pushGcE(simplified, current_start);
          _M0MPC15array5Array4pushGcE(simplified, current_end);
          current_start = _next_start;
          current_end = _next_end;
        }
        _tmp$39 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    _M0MPC15array5Array4pushGcE(simplified, current_start);
    _M0MPC15array5Array4pushGcE(simplified, current_end);
  }
  return new _M0TPB9ArrayViewGcE(simplified, 0, simplified.length);
}
function _M0FP411moonbitlang6regexp8internal7unicode14is__word__char(c) {
  return c >= 97 && c <= 122 ? true : c >= 65 && c <= 90 ? true : c >= 48 && c <= 57 ? true : c === 95;
}
function _M0FP411moonbitlang6regexp8internal7unicode18is__word__char__at(input, sp) {
  if (sp === -1 || sp === (input.end - input.start | 0)) {
    return false;
  }
  const _p$4 = _M0MPC16string10StringView9get__char(input, sp);
  const c = _p$4 === -1 ? $panic() : _p$4;
  return _M0FP411moonbitlang6regexp8internal7unicode14is__word__char(c);
}
function _M0FP411moonbitlang6regexp8internal7unicode16char__in__ranges(ch, chars) {
  let left = 0;
  let right = ((chars.end - chars.start | 0) / 2 | 0) - 1 | 0;
  while (true) {
    if (left <= right) {
      const mid = (left + right | 0) / 2 | 0;
      const start = _M0MPC15array9ArrayView2atGcE(chars, Math.imul(mid, 2) | 0);
      const end = _M0MPC15array9ArrayView2atGcE(chars, (Math.imul(mid, 2) | 0) + 1 | 0);
      if (ch < start) {
        right = mid - 1 | 0;
      } else {
        if (ch > end) {
          left = mid + 1 | 0;
        } else {
          return true;
        }
      }
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP411moonbitlang6regexp8internal7unicode32compute__char__class__complement(chars) {
  const simplified = _M0FP411moonbitlang6regexp8internal7unicode22simplify__char__ranges(chars);
  if ((simplified.end - simplified.start | 0) === 0) {
    return new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode32compute__char__class__complementN7_2abindS112, 0, 2);
  }
  const complement = [];
  if (_M0MPC15array9ArrayView2atGcE(simplified, 0) > 0) {
    _M0MPC15array5Array4pushGcE(complement, 0);
    _M0MPC15array5Array4pushGcE(complement, _M0MPC15array9ArrayView2atGcE(simplified, 0) - 1 | 0);
  }
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < (((simplified.end - simplified.start | 0) / 2 | 0) - 1 | 0)) {
      const current_end = _M0MPC15array9ArrayView2atGcE(simplified, (Math.imul(i, 2) | 0) + 1 | 0);
      const next_start = _M0MPC15array9ArrayView2atGcE(simplified, Math.imul(i + 1 | 0, 2) | 0);
      const gap_start = current_end + 1 | 0;
      const gap_end = next_start - 1 | 0;
      if (gap_start <= gap_end) {
        _M0MPC15array5Array4pushGcE(complement, gap_start);
        _M0MPC15array5Array4pushGcE(complement, gap_end);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const last_end = _M0MPC15array9ArrayView2atGcE(simplified, (simplified.end - simplified.start | 0) - 1 | 0);
  if (last_end < 1114111) {
    _M0MPC15array5Array4pushGcE(complement, last_end + 1 | 0);
    _M0MPC15array5Array4pushGcE(complement, 1114111);
  }
  return new _M0TPB9ArrayViewGcE(complement, 0, complement.length);
}
function _M0FP411moonbitlang6regexp8internal7unicode30case__insensitive__char__class(chars) {
  const result = [];
  const _bind$4 = (chars.end - chars.start | 0) / 2 | 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < _bind$4) {
      _L: {
        let start = _M0MPC15array9ArrayView2atGcE(chars, Math.imul(i, 2) | 0);
        let end = _M0MPC15array9ArrayView2atGcE(chars, (Math.imul(i, 2) | 0) + 1 | 0);
        if (start <= 65 && end >= 125251 || (end < 65 || start > 125251)) {
          _M0MPC15array5Array4pushGcE(result, start);
          _M0MPC15array5Array4pushGcE(result, end);
          break _L;
        }
        if (start < 65) {
          _M0MPC15array5Array4pushGcE(result, start);
          _M0MPC15array5Array4pushGcE(result, 65 - 1 | 0);
          start = 65;
        } else {
          if (end > 125251) {
            _M0MPC15array5Array4pushGcE(result, 125251 + 1 | 0);
            _M0MPC15array5Array4pushGcE(result, end);
            end = 125251;
          }
        }
        const _bind$5 = start;
        const _bind$6 = end;
        let _tmp$39 = _bind$5;
        while (true) {
          const c = _tmp$39;
          if (c <= _bind$6) {
            const char = c;
            let ch0 = char;
            _M0MPC15array5Array4pushGcE(result, char);
            _M0MPC15array5Array4pushGcE(result, char);
            while (true) {
              const _bind$7 = _M0MPB3Map3getGccE(_M0FP411moonbitlang6regexp8internal7unicode13case__folding, ch0);
              if (_bind$7 === -1) {
                break;
              } else {
                const _Some = _bind$7;
                const _ch = _Some;
                if (_ch !== char) {
                  _M0MPC15array5Array4pushGcE(result, _ch);
                  _M0MPC15array5Array4pushGcE(result, _ch);
                  ch0 = _ch;
                  continue;
                } else {
                  break;
                }
              }
            }
            _tmp$39 = c + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        break _L;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0FP411moonbitlang6regexp8internal7unicode22simplify__char__ranges(new _M0TPB9ArrayViewGcE(result, 0, result.length));
}
function _M0FP411moonbitlang6regexp8internal2vm11add__thread(content, instructions, inst_gen, thread, clist) {
  let _tmp$38 = thread;
  _L: while (true) {
    const thread$2 = _tmp$38;
    if (_M0MPC15array5Array2atGiE(inst_gen, thread$2.pc) === thread$2.sp) {
      return undefined;
    }
    _M0MPC15array5Array3setGiE(inst_gen, thread$2.pc, thread$2.sp);
    _L$2: {
      const _bind$4 = _M0MPC15array5Array2atGUssEE(instructions, thread$2.pc);
      switch (_bind$4.$tag) {
        case 1: {
          const _Save = _bind$4;
          const _i = _Save._0;
          _M0MPC15array5Array3setGiE(thread$2.captures, _i, thread$2.sp);
          _tmp$38 = new _M0TP411moonbitlang6regexp8internal2vm6Thread(thread$2.pc + 1 | 0, thread$2.sp, thread$2.captures);
          continue _L;
        }
        case 3: {
          const _Jump = _bind$4;
          const _i$2 = _Jump._0;
          _tmp$38 = new _M0TP411moonbitlang6regexp8internal2vm6Thread(_i$2, thread$2.sp, thread$2.captures);
          continue _L;
        }
        case 4: {
          const _Split = _bind$4;
          const _i1 = _Split._0;
          const _i2 = _Split._1;
          _M0FP411moonbitlang6regexp8internal2vm11add__thread(content, instructions, inst_gen, new _M0TP411moonbitlang6regexp8internal2vm6Thread(_i1, thread$2.sp, _M0MPC15array5Array4copyGiE(thread$2.captures)), clist);
          _tmp$38 = new _M0TP411moonbitlang6regexp8internal2vm6Thread(_i2, thread$2.sp, thread$2.captures);
          continue _L;
        }
        case 5: {
          const _Assertion = _bind$4;
          const _pred = _Assertion._0;
          const sp = thread$2.sp;
          let assertion;
          switch (_pred) {
            case 0: {
              assertion = sp === 0;
              break;
            }
            case 1: {
              assertion = sp === (content.end - content.start | 0);
              break;
            }
            case 2: {
              if (sp === 0) {
                assertion = true;
              } else {
                const _p$4 = _M0MPC16string10StringView2at(content, sp - 1 | 0);
                const _p$5 = 10;
                assertion = _p$4 === _p$5;
              }
              break;
            }
            case 3: {
              if (sp === (content.end - content.start | 0)) {
                assertion = true;
              } else {
                const _p$4 = _M0MPC16string10StringView2at(content, sp);
                const _p$5 = 10;
                assertion = _p$4 === _p$5;
              }
              break;
            }
            case 4: {
              const _p$4 = _M0FP411moonbitlang6regexp8internal7unicode18is__word__char__at(content, sp - 1 | 0);
              const _p$5 = _M0FP411moonbitlang6regexp8internal7unicode18is__word__char__at(content, sp);
              assertion = !(_p$4 === _p$5);
              break;
            }
            default: {
              assertion = _M0FP411moonbitlang6regexp8internal7unicode18is__word__char__at(content, sp - 1 | 0) === _M0FP411moonbitlang6regexp8internal7unicode18is__word__char__at(content, sp);
            }
          }
          if (assertion) {
            _tmp$38 = new _M0TP411moonbitlang6regexp8internal2vm6Thread(thread$2.pc + 1 | 0, thread$2.sp, thread$2.captures);
            continue _L;
          } else {
            return;
          }
        }
        case 6: {
          const _Backreference = _bind$4;
          const _i$3 = _Backreference._0;
          if ((Math.imul(_i$3, 2) | 0) >= thread$2.captures.length || (_M0MPC15array5Array2atGiE(thread$2.captures, Math.imul(_i$3, 2) | 0) === -1 || _M0MPC15array5Array2atGiE(thread$2.captures, (Math.imul(_i$3, 2) | 0) + 1 | 0) === _M0MPC15array5Array2atGiE(thread$2.captures, Math.imul(_i$3, 2) | 0))) {
            _tmp$38 = new _M0TP411moonbitlang6regexp8internal2vm6Thread(thread$2.pc + 1 | 0, thread$2.sp, thread$2.captures);
            continue _L;
          } else {
            break _L$2;
          }
        }
        default: {
          break _L$2;
        }
      }
    }
    _M0MPC15array5Array4pushGUssEE(clist, thread$2);
    return;
  }
}
function _M0FP411moonbitlang6regexp8internal2vm10vm_2einner(instructions, input, captures, allow_exponentiaion) {
  _L: {
    if (instructions.length >= 2) {
      const _x = instructions[(instructions.length - 1 | 0) - 1 | 0];
      if (_x.$tag === 1) {
        const _Save = _x;
        const _x$2 = _Save._0;
        if (_x$2 === 1) {
          const _x$3 = instructions[instructions.length - 1 | 0];
          if (_x$3.$tag === 0) {
            const inst_gen = _M0MPC15array5Array4makeGiE(instructions.length, -1);
            let clist = _M0MPC15array5Array11new_2einnerGRP411moonbitlang6regexp8internal2vm6ThreadE(instructions.length);
            let nlist = _M0MPC15array5Array11new_2einnerGRP411moonbitlang6regexp8internal2vm6ThreadE(instructions.length);
            let matched = [];
            const _bind$4 = _M0MPC15array5Array4makeGiE(Math.imul(captures, 2) | 0, -1);
            _M0FP411moonbitlang6regexp8internal2vm11add__thread(input, instructions, inst_gen, new _M0TP411moonbitlang6regexp8internal2vm6Thread(0, 0, _bind$4), clist);
            let _tmp$38 = 0;
            while (true) {
              const sp = _tmp$38;
              if (sp <= (input.end - input.start | 0)) {
                const _p$4 = clist;
                if (_p$4.length === 0) {
                  break;
                }
                const actual_char = _M0MPC16string10StringView9get__char(input, sp);
                let next_sp;
                _L$2: {
                  _L$3: {
                    if (actual_char === -1) {
                      break _L$3;
                    } else {
                      const _Some = actual_char;
                      const _ch = _Some;
                      if (_ch > 65535) {
                        next_sp = sp + 2 | 0;
                      } else {
                        break _L$3;
                      }
                    }
                    break _L$2;
                  }
                  next_sp = sp + 1 | 0;
                }
                const _bind$5 = clist;
                const _bind$6 = _bind$5.length;
                let _tmp$39 = 0;
                while (true) {
                  const _ = _tmp$39;
                  if (_ < _bind$6) {
                    const thread = _bind$5[_];
                    _L$3: {
                      const _pc = thread.pc;
                      const _captures = thread.captures;
                      const _thread_sp = thread.sp;
                      if (_thread_sp > sp) {
                        _M0MPC15array5Array4pushGUssEE(nlist, thread);
                        break _L$3;
                      }
                      if (_thread_sp === sp) {
                        const _bind$7 = _M0MPC15array5Array2atGUssEE(instructions, _pc);
                        if (_bind$7.$tag === 0) {
                          matched = _captures;
                          break;
                        }
                        const _bind$8 = _M0MPC15array5Array2atGUssEE(instructions, _pc);
                        switch (_bind$8.$tag) {
                          case 2: {
                            const _Char = _bind$8;
                            const _chars = _Char._0;
                            if (actual_char === -1) {
                            } else {
                              const _Some = actual_char;
                              const _ch = _Some;
                              if (_M0FP411moonbitlang6regexp8internal7unicode16char__in__ranges(_ch, _chars)) {
                                const _tmp$40 = allow_exponentiaion ? _M0MPC15array5Array4makeGiE(instructions.length, -1) : inst_gen;
                                const _bind$9 = _pc + 1 | 0;
                                _M0FP411moonbitlang6regexp8internal2vm11add__thread(input, instructions, _tmp$40, new _M0TP411moonbitlang6regexp8internal2vm6Thread(_bind$9, next_sp, _captures), nlist);
                              }
                            }
                            break;
                          }
                          case 6: {
                            const _Backreference = _bind$8;
                            const _i = _Backreference._0;
                            const start = _M0MPC15array5Array2atGiE(_captures, Math.imul(_i, 2) | 0);
                            const end = _M0MPC15array5Array2atGiE(_captures, (Math.imul(_i, 2) | 0) + 1 | 0);
                            const len = end - start | 0;
                            if (len !== 0) {
                              const next_sp$2 = sp + len | 0;
                              if (next_sp$2 <= (input.end - input.start | 0) && _M0IPC16string10StringViewPB2Eq5equal(_M0MPC16string10StringView12view_2einner(input, start, end), _M0MPC16string10StringView12view_2einner(input, sp, next_sp$2))) {
                                const _tmp$40 = _M0MPC15array5Array4makeGiE(instructions.length, -1);
                                const _bind$9 = _pc + 1 | 0;
                                _M0FP411moonbitlang6regexp8internal2vm11add__thread(input, instructions, _tmp$40, new _M0TP411moonbitlang6regexp8internal2vm6Thread(_bind$9, next_sp$2, _captures), nlist);
                              }
                            } else {
                              $panic();
                            }
                            break;
                          }
                          default: {
                            $panic();
                          }
                        }
                      } else {
                        $panic();
                      }
                      break _L$3;
                    }
                    _tmp$39 = _ + 1 | 0;
                    continue;
                  } else {
                    break;
                  }
                }
                const tmp = clist;
                clist = nlist;
                nlist = tmp;
                _M0MPC15array5Array5clearGRP411moonbitlang6regexp8internal2vm6ThreadE(nlist);
                _tmp$38 = next_sp;
                continue;
              } else {
                break;
              }
            }
            return matched;
          } else {
            break _L;
          }
        } else {
          break _L;
        }
      } else {
        break _L;
      }
    } else {
      break _L;
    }
  }
  return $panic();
}
function _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__aux(regex, instructions) {
  switch (regex.$tag) {
    case 0: {
      return;
    }
    case 1: {
      const _CharClass = regex;
      const _chars = _CharClass._0;
      const _neg = _CharClass._1;
      if (_neg) {
        const complement = _M0FP411moonbitlang6regexp8internal7unicode32compute__char__class__complement(_chars);
        _M0MPC15array5Array4pushGUssEE(instructions, new _M0DTP411moonbitlang6regexp8internal2vm11Instruction4Char(complement));
        return;
      } else {
        const simplified = _M0FP411moonbitlang6regexp8internal7unicode22simplify__char__ranges(_chars);
        _M0MPC15array5Array4pushGUssEE(instructions, new _M0DTP411moonbitlang6regexp8internal2vm11Instruction4Char(simplified));
        return;
      }
    }
    case 2: {
      const _Assertion = regex;
      const _pred = _Assertion._0;
      _M0MPC15array5Array4pushGUssEE(instructions, new _M0DTP411moonbitlang6regexp8internal2vm11Instruction9Assertion(_pred));
      return;
    }
    case 3: {
      const _Capture = regex;
      const _inner = _Capture._0;
      const _capture = _Capture._1;
      _M0MPC15array5Array4pushGUssEE(instructions, new _M0DTP411moonbitlang6regexp8internal2vm11Instruction4Save(Math.imul(_capture, 2) | 0));
      _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__aux(_inner, instructions);
      _M0MPC15array5Array4pushGUssEE(instructions, new _M0DTP411moonbitlang6regexp8internal2vm11Instruction4Save((Math.imul(_capture, 2) | 0) + 1 | 0));
      return;
    }
    case 4: {
      const _ZeroOrMore = regex;
      const _inner$2 = _ZeroOrMore._0;
      const _greedy = _ZeroOrMore._1;
      const split_pos = instructions.length;
      _M0MPC15array5Array4pushGUssEE(instructions, _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__auxN6constrS260);
      _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__aux(_inner$2, instructions);
      const next_pos = instructions.length;
      if (!_greedy) {
        _M0MPC15array5Array4pushGUssEE(instructions, new _M0DTP411moonbitlang6regexp8internal2vm11Instruction5Split(next_pos + 1 | 0, split_pos + 1 | 0));
        _M0MPC15array5Array3setGsE(instructions, split_pos, new _M0DTP411moonbitlang6regexp8internal2vm11Instruction5Split(next_pos + 1 | 0, split_pos + 1 | 0));
        return;
      } else {
        _M0MPC15array5Array4pushGUssEE(instructions, new _M0DTP411moonbitlang6regexp8internal2vm11Instruction5Split(split_pos + 1 | 0, next_pos + 1 | 0));
        _M0MPC15array5Array3setGsE(instructions, split_pos, new _M0DTP411moonbitlang6regexp8internal2vm11Instruction5Split(split_pos + 1 | 0, next_pos + 1 | 0));
        return;
      }
    }
    case 5: {
      const _OneOrMore = regex;
      const _inner$3 = _OneOrMore._0;
      const _greedy$2 = _OneOrMore._1;
      const jmp_pos = instructions.length;
      _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__aux(_inner$3, instructions);
      const next_pos$2 = instructions.length;
      if (!_greedy$2) {
        _M0MPC15array5Array4pushGUssEE(instructions, new _M0DTP411moonbitlang6regexp8internal2vm11Instruction5Split(next_pos$2 + 1 | 0, jmp_pos));
        return;
      } else {
        _M0MPC15array5Array4pushGUssEE(instructions, new _M0DTP411moonbitlang6regexp8internal2vm11Instruction5Split(jmp_pos, next_pos$2 + 1 | 0));
        return;
      }
    }
    case 6: {
      const _ZeroOrOne = regex;
      const _inner$4 = _ZeroOrOne._0;
      const _greedy$3 = _ZeroOrOne._1;
      const split_pos$2 = instructions.length;
      _M0MPC15array5Array4pushGUssEE(instructions, _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__auxN6constrS261);
      _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__aux(_inner$4, instructions);
      if (!_greedy$3) {
        _M0MPC15array5Array3setGsE(instructions, split_pos$2, new _M0DTP411moonbitlang6regexp8internal2vm11Instruction5Split(instructions.length, split_pos$2 + 1 | 0));
        return;
      } else {
        _M0MPC15array5Array3setGsE(instructions, split_pos$2, new _M0DTP411moonbitlang6regexp8internal2vm11Instruction5Split(split_pos$2 + 1 | 0, instructions.length));
        return;
      }
    }
    case 7: {
      const _Repeat = regex;
      const _greedy$4 = _Repeat._1;
      const _min = _Repeat._2;
      const _max = _Repeat._3;
      const _inner$5 = _Repeat._0;
      if (_max === undefined) {
        let _tmp$38 = 0;
        while (true) {
          const i = _tmp$38;
          if (i >>> 0 < _min >>> 0) {
            _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__aux(_inner$5, instructions);
            _tmp$38 = (i >>> 0) + (1 >>> 0) | 0;
            continue;
          } else {
            break;
          }
        }
        const split_pos$3 = instructions.length;
        _M0MPC15array5Array4pushGUssEE(instructions, _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__auxN6constrS263);
        _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__aux(_inner$5, instructions);
        _M0MPC15array5Array4pushGUssEE(instructions, new _M0DTP411moonbitlang6regexp8internal2vm11Instruction4Jump(split_pos$3));
        if (!_greedy$4) {
          _M0MPC15array5Array3setGsE(instructions, split_pos$3, new _M0DTP411moonbitlang6regexp8internal2vm11Instruction5Split(instructions.length, split_pos$3 + 1 | 0));
          return;
        } else {
          _M0MPC15array5Array3setGsE(instructions, split_pos$3, new _M0DTP411moonbitlang6regexp8internal2vm11Instruction5Split(split_pos$3 + 1 | 0, instructions.length));
          return;
        }
      } else {
        const _Some = _max;
        const _max$2 = _Some;
        let _tmp$38 = 0;
        while (true) {
          const i = _tmp$38;
          if (i >>> 0 < _min >>> 0) {
            _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__aux(_inner$5, instructions);
            _tmp$38 = (i >>> 0) + (1 >>> 0) | 0;
            continue;
          } else {
            break;
          }
        }
        const split_pos$3 = [];
        const _bind$4 = (_max$2 >>> 0) - (_min >>> 0) | 0;
        let _tmp$39 = 0;
        while (true) {
          const i = _tmp$39;
          if (i >>> 0 < _bind$4 >>> 0) {
            _M0MPC15array5Array4pushGiE(split_pos$3, instructions.length);
            _M0MPC15array5Array4pushGUssEE(instructions, _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__auxN6constrS262);
            _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__aux(_inner$5, instructions);
            _tmp$39 = (i >>> 0) + (1 >>> 0) | 0;
            continue;
          } else {
            break;
          }
        }
        const jmp_pos$2 = instructions.length;
        if (!_greedy$4) {
          const _bind$5 = split_pos$3.length;
          let _tmp$40 = 0;
          while (true) {
            const _ = _tmp$40;
            if (_ < _bind$5) {
              const pos = split_pos$3[_];
              _M0MPC15array5Array3setGsE(instructions, pos, new _M0DTP411moonbitlang6regexp8internal2vm11Instruction5Split(jmp_pos$2, pos + 1 | 0));
              _tmp$40 = _ + 1 | 0;
              continue;
            } else {
              return;
            }
          }
        } else {
          const _bind$5 = split_pos$3.length;
          let _tmp$40 = 0;
          while (true) {
            const _ = _tmp$40;
            if (_ < _bind$5) {
              const pos = split_pos$3[_];
              _M0MPC15array5Array3setGsE(instructions, pos, new _M0DTP411moonbitlang6regexp8internal2vm11Instruction5Split(pos + 1 | 0, jmp_pos$2));
              _tmp$40 = _ + 1 | 0;
              continue;
            } else {
              return;
            }
          }
        }
      }
    }
    case 8: {
      const _Concat = regex;
      const _regexs = _Concat._0;
      const _bind$4 = _regexs.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const regex$2 = _regexs[_];
          _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__aux(regex$2, instructions);
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          return;
        }
      }
    }
    case 9: {
      const _Alternate = regex;
      const _left = _Alternate._0;
      const _right = _Alternate._1;
      const split_pos$3 = instructions.length;
      _M0MPC15array5Array4pushGUssEE(instructions, _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__auxN6constrS264);
      _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__aux(_left, instructions);
      const jmp_pos$2 = instructions.length;
      _M0MPC15array5Array4pushGUssEE(instructions, _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__auxN6constrS265);
      _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__aux(_right, instructions);
      _M0MPC15array5Array3setGsE(instructions, split_pos$3, new _M0DTP411moonbitlang6regexp8internal2vm11Instruction5Split(split_pos$3 + 1 | 0, jmp_pos$2 + 1 | 0));
      _M0MPC15array5Array3setGsE(instructions, jmp_pos$2, new _M0DTP411moonbitlang6regexp8internal2vm11Instruction4Jump(instructions.length));
      return;
    }
    default: {
      const _Backreference = regex;
      const _i = _Backreference._0;
      _M0MPC15array5Array4pushGUssEE(instructions, new _M0DTP411moonbitlang6regexp8internal2vm11Instruction13Backreference(_i));
      return;
    }
  }
}
function _M0MP411moonbitlang6regexp8internal3ast3Ast7compile(self) {
  const instructions = [_M0MP411moonbitlang6regexp8internal3ast3Ast7compileN6constrS266, new _M0DTP411moonbitlang6regexp8internal2vm11Instruction4Char(new _M0TPB9ArrayViewGcE(_M0MP411moonbitlang6regexp8internal3ast3Ast7compileN7_2abindS214, 0, 2)), _M0MP411moonbitlang6regexp8internal3ast3Ast7compileN6constrS267];
  _M0MPC15array5Array4pushGUssEE(instructions, _M0MP411moonbitlang6regexp8internal3ast3Ast7compileN6constrS268);
  _M0MP411moonbitlang6regexp8internal3ast3Ast12compile__aux(self, instructions);
  _M0MPC15array5Array4pushGUssEE(instructions, _M0MP411moonbitlang6regexp8internal3ast3Ast7compileN6constrS269);
  _M0MPC15array5Array4pushGUssEE(instructions, _M0DTP411moonbitlang6regexp8internal2vm11Instruction7Matched__);
  return instructions;
}
function _M0IP411moonbitlang6regexp8internal5parse3ErrPB4Show6output(_x_170, _x_171) {
  switch (_x_170) {
    case 0: {
      _x_171.method_table.method_0(_x_171.self, "InternalError");
      return;
    }
    case 1: {
      _x_171.method_table.method_0(_x_171.self, "InvalidCharClass");
      return;
    }
    case 2: {
      _x_171.method_table.method_0(_x_171.self, "InvalidEscape");
      return;
    }
    case 3: {
      _x_171.method_table.method_0(_x_171.self, "InvalidNamedCapture");
      return;
    }
    case 4: {
      _x_171.method_table.method_0(_x_171.self, "InvalidRepeatOp");
      return;
    }
    case 5: {
      _x_171.method_table.method_0(_x_171.self, "InvalidRepeatSize");
      return;
    }
    case 6: {
      _x_171.method_table.method_0(_x_171.self, "MissingBracket");
      return;
    }
    case 7: {
      _x_171.method_table.method_0(_x_171.self, "MissingParenthesis");
      return;
    }
    case 8: {
      _x_171.method_table.method_0(_x_171.self, "MissingRepeatArgument");
      return;
    }
    case 9: {
      _x_171.method_table.method_0(_x_171.self, "TrailingBackslash");
      return;
    }
    default: {
      _x_171.method_table.method_0(_x_171.self, "UnexpectedParenthesis");
      return;
    }
  }
}
function _M0IP411moonbitlang6regexp8internal5parse11RegexpErrorPB4Show6output(_x_162, _x_163) {
  const _RegexpError = _x_162;
  const _$42$arg_164 = _RegexpError._0;
  const _$42$arg_165 = _RegexpError._1;
  _x_163.method_table.method_0(_x_163.self, "RegexpError(");
  _x_163.method_table.method_0(_x_163.self, "err=");
  _M0MPB6Logger13write__objectGRP411moonbitlang6regexp8internal5parse3ErrE(_x_163, _$42$arg_164);
  _x_163.method_table.method_0(_x_163.self, ", ");
  _x_163.method_table.method_0(_x_163.self, "source_fragment=");
  _M0MPB6Logger13write__objectGRPC16string10StringViewE(_x_163, _$42$arg_165);
  _x_163.method_table.method_0(_x_163.self, ")");
}
function _M0MP411moonbitlang6regexp8internal5parse6Parser3new(input, flags) {
  const _bind$4 = [];
  const _bind$5 = _M0MPB3Map3MapGsiE(new _M0TPB9ArrayViewGUsiEE(_bind$4, 0, 0), undefined);
  const _bind$6 = _M0MPC13set3Set3newGiE(undefined);
  return new _M0TP411moonbitlang6regexp8internal5parse6Parser(input, flags, 1, _bind$6, _bind$5, false);
}
function _M0MP411moonbitlang6regexp8internal5parse6Parser17is__special__char(c) {
  switch (c) {
    case 42: {
      return true;
    }
    case 43: {
      return true;
    }
    case 63: {
      return true;
    }
    case 124: {
      return true;
    }
    case 40: {
      return true;
    }
    case 41: {
      return true;
    }
    case 91: {
      return true;
    }
    case 93: {
      return true;
    }
    case 123: {
      return true;
    }
    case 46: {
      return true;
    }
    case 94: {
      return true;
    }
    case 36: {
      return true;
    }
    default: {
      return false;
    }
  }
}
function _M0MP411moonbitlang6regexp8internal5parse6Parser24parse__general__category(self, property_name, neg) {
  const _bind$4 = _M0MPB3Map3getGssE(_M0FP411moonbitlang6regexp8internal7unicode42general__category__property__value__alises, property_name);
  let normalized_name;
  if (_bind$4 === undefined) {
    return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(1, self.input));
  } else {
    const _Some = _bind$4;
    normalized_name = _Some;
  }
  const _bind$5 = _M0MPB3Map3getGsRPB9ArrayViewGcEE(_M0FP411moonbitlang6regexp8internal7unicode25general__category__ranges, normalized_name);
  if (_bind$5 === undefined) {
    return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok($panic());
  } else {
    const _Some = _bind$5;
    const _ranges = _Some;
    return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass(_ranges, neg));
  }
}
function _M0MP411moonbitlang6regexp8internal5parse6Parser22parse__unicode__escape(self) {
  _L: {
    const _bind$4 = self.input;
    if (_M0MPC16string6String24char__length__ge_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end)) {
      const _x = _M0MPC16string6String16unsafe__char__at(_bind$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 0, _bind$4.start, _bind$4.end));
      if (_x === 123) {
        const _tmp$38 = _bind$4.str;
        const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
        let _tmp$39;
        if (_bind$5 === undefined) {
          _tmp$39 = _bind$4.end;
        } else {
          const _Some = _bind$5;
          _tmp$39 = _Some;
        }
        const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$4.end);
        self.input = _x$2;
        let codepoint = 0;
        let len = 0;
        while (true) {
          const _bind$6 = self.input;
          if (_M0MPC16string6String24char__length__ge_2einner(_bind$6.str, 1, _bind$6.start, _bind$6.end)) {
            const _ch = _M0MPC16string6String16unsafe__char__at(_bind$6.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6.str, 0, _bind$6.start, _bind$6.end));
            const _tmp$40 = _bind$6.str;
            const _bind$7 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6.str, 1, _bind$6.start, _bind$6.end);
            let _tmp$41;
            if (_bind$7 === undefined) {
              _tmp$41 = _bind$6.end;
            } else {
              const _Some = _bind$7;
              _tmp$41 = _Some;
            }
            const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, _bind$6.end);
            if (_ch !== 125) {
              if (_ch >= 48 && _ch <= 57) {
                codepoint = codepoint << 4 | (_ch - 48 | 0);
                self.input = _x$3;
              } else {
                if (_ch >= 97 && _ch <= 102) {
                  codepoint = codepoint << 4 | ((_ch - 97 | 0) + 10 | 0);
                  self.input = _x$3;
                } else {
                  if (_ch >= 65 && _ch <= 70) {
                    codepoint = codepoint << 4 | ((_ch - 65 | 0) + 10 | 0);
                    self.input = _x$3;
                  } else {
                    return new _M0DTPC16result6ResultGcRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(2, self.input));
                  }
                }
              }
              len = len + 1 | 0;
              if (len > 6) {
                return new _M0DTPC16result6ResultGcRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(2, _x$2));
              }
              continue;
            } else {
              break;
            }
          } else {
            break;
          }
        }
        if (len === 0) {
          return new _M0DTPC16result6ResultGcRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(2, _x$2));
        }
        _L$2: {
          const _bind$6 = self.input;
          if (_M0MPC16string6String24char__length__ge_2einner(_bind$6.str, 1, _bind$6.start, _bind$6.end)) {
            const _x$3 = _M0MPC16string6String16unsafe__char__at(_bind$6.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6.str, 0, _bind$6.start, _bind$6.end));
            if (_x$3 === 125) {
              const _tmp$40 = _bind$6.str;
              const _bind$7 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6.str, 1, _bind$6.start, _bind$6.end);
              let _tmp$41;
              if (_bind$7 === undefined) {
                _tmp$41 = _bind$6.end;
              } else {
                const _Some = _bind$7;
                _tmp$41 = _Some;
              }
              const _x$4 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, _bind$6.end);
              self.input = _x$4;
              const _bind$8 = _M0MPC13int3Int8to__char(codepoint);
              if (_bind$8 === -1) {
                return new _M0DTPC16result6ResultGcRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(2, _x$2));
              } else {
                const _Some = _bind$8;
                const _ch = _Some;
                return new _M0DTPC16result6ResultGcRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(_ch);
              }
            } else {
              break _L$2;
            }
          } else {
            break _L$2;
          }
        }
        return new _M0DTPC16result6ResultGcRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(2, _x$2));
      } else {
        break _L;
      }
    } else {
      break _L;
    }
  }
  let codepoint = 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < 4) {
      _L$2: {
        _L$3: {
          const _bind$4 = self.input;
          if (_M0MPC16string6String24char__length__ge_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end)) {
            const _x = _M0MPC16string6String16unsafe__char__at(_bind$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 0, _bind$4.start, _bind$4.end));
            if (_x >= 48 && _x <= 57) {
              const _tmp$39 = _bind$4.str;
              const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
              let _tmp$40;
              if (_bind$5 === undefined) {
                _tmp$40 = _bind$4.end;
              } else {
                const _Some = _bind$5;
                _tmp$40 = _Some;
              }
              const _x$2 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, _bind$4.end);
              codepoint = codepoint << 4 | (_x - 48 | 0);
              self.input = _x$2;
            } else {
              if (_x >= 97 && _x <= 102) {
                const _tmp$39 = _bind$4.str;
                const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
                let _tmp$40;
                if (_bind$5 === undefined) {
                  _tmp$40 = _bind$4.end;
                } else {
                  const _Some = _bind$5;
                  _tmp$40 = _Some;
                }
                const _x$2 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, _bind$4.end);
                codepoint = codepoint << 4 | ((_x - 97 | 0) + 10 | 0);
                self.input = _x$2;
              } else {
                if (_x >= 65 && _x <= 70) {
                  const _tmp$39 = _bind$4.str;
                  const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
                  let _tmp$40;
                  if (_bind$5 === undefined) {
                    _tmp$40 = _bind$4.end;
                  } else {
                    const _Some = _bind$5;
                    _tmp$40 = _Some;
                  }
                  const _x$2 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, _bind$4.end);
                  codepoint = codepoint << 4 | ((_x - 65 | 0) + 10 | 0);
                  self.input = _x$2;
                } else {
                  break _L$3;
                }
              }
            }
          } else {
            break _L$3;
          }
          break _L$2;
        }
        return new _M0DTPC16result6ResultGcRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(2, self.input));
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$4 = _M0MPC13int3Int8to__char(codepoint);
  if (_bind$4 === -1) {
    return new _M0DTPC16result6ResultGcRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(2, self.input));
  } else {
    const _Some = _bind$4;
    const _ch = _Some;
    return new _M0DTPC16result6ResultGcRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(_ch);
  }
}
function _M0MP411moonbitlang6regexp8internal5parse6Parser24parse__unicode__property(self) {
  _L: {
    const _bind$4 = self.input;
    if (_M0MPC16string6String24char__length__ge_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end)) {
      const _x = _M0MPC16string6String16unsafe__char__at(_bind$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 0, _bind$4.start, _bind$4.end));
      if (_x === 123) {
        const _tmp$38 = _bind$4.str;
        const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
        let _tmp$39;
        if (_bind$5 === undefined) {
          _tmp$39 = _bind$4.end;
        } else {
          const _Some = _bind$5;
          _tmp$39 = _Some;
        }
        const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$4.end);
        self.input = _x$2;
        const chars = [];
        while (true) {
          const _bind$6 = self.input;
          if (_M0MPC16string6String24char__length__ge_2einner(_bind$6.str, 1, _bind$6.start, _bind$6.end)) {
            const _ch = _M0MPC16string6String16unsafe__char__at(_bind$6.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6.str, 0, _bind$6.start, _bind$6.end));
            const _tmp$40 = _bind$6.str;
            const _bind$7 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6.str, 1, _bind$6.start, _bind$6.end);
            let _tmp$41;
            if (_bind$7 === undefined) {
              _tmp$41 = _bind$6.end;
            } else {
              const _Some = _bind$7;
              _tmp$41 = _Some;
            }
            const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, _bind$6.end);
            if (_ch !== 125) {
              _M0MPC15array5Array4pushGcE(chars, _ch);
              self.input = _x$3;
              continue;
            } else {
              break;
            }
          } else {
            break;
          }
        }
        _L$2: {
          const _bind$6 = self.input;
          if (_M0MPC16string6String24char__length__ge_2einner(_bind$6.str, 1, _bind$6.start, _bind$6.end)) {
            const _x$3 = _M0MPC16string6String16unsafe__char__at(_bind$6.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6.str, 0, _bind$6.start, _bind$6.end));
            if (_x$3 === 125) {
              const _tmp$40 = _bind$6.str;
              const _bind$7 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6.str, 1, _bind$6.start, _bind$6.end);
              let _tmp$41;
              if (_bind$7 === undefined) {
                _tmp$41 = _bind$6.end;
              } else {
                const _Some = _bind$7;
                _tmp$41 = _Some;
              }
              const _x$4 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, _bind$6.end);
              self.input = _x$4;
              return new _M0DTPC16result6ResultGsRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(_M0MPC16string6String10from__iter(_M0MPC15array5Array4iterGcE(chars)));
            } else {
              break _L$2;
            }
          } else {
            break _L$2;
          }
        }
        return new _M0DTPC16result6ResultGsRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(1, self.input));
      } else {
        break _L;
      }
    } else {
      break _L;
    }
  }
  return new _M0DTPC16result6ResultGsRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(1, self.input));
}
function _M0MP411moonbitlang6regexp8internal5parse6Parser18parse__char__class(self) {
  const _bind$4 = self.input;
  let neg;
  if (_M0MPC16string6String24char__length__ge_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end)) {
    const _x = _M0MPC16string6String16unsafe__char__at(_bind$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 0, _bind$4.start, _bind$4.end));
    if (_x === 94) {
      const _tmp$38 = _bind$4.str;
      const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
      let _tmp$39;
      if (_bind$5 === undefined) {
        _tmp$39 = _bind$4.end;
      } else {
        const _Some = _bind$5;
        _tmp$39 = _Some;
      }
      const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$4.end);
      self.input = _x$2;
      neg = true;
    } else {
      neg = false;
    }
  } else {
    neg = false;
  }
  const chars = [];
  _L: while (true) {
    const _bind$5 = self.input;
    if (_M0MPC16string6String24char__length__ge_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end)) {
      const _ch = _M0MPC16string6String16unsafe__char__at(_bind$5.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 0, _bind$5.start, _bind$5.end));
      const _bind$6 = _bind$5.str;
      const _bind$7 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end);
      let _bind$8;
      if (_bind$7 === undefined) {
        _bind$8 = _bind$5.end;
      } else {
        const _Some = _bind$7;
        _bind$8 = _Some;
      }
      const _bind$9 = _bind$5.end;
      const _x = new _M0TPC16string10StringView(_bind$6, _bind$8, _bind$9);
      if (_ch !== 93) {
        let start_char;
        if (_ch === 92) {
          if (_M0MPC16string6String24char__length__ge_2einner(_bind$6, 1, _bind$8, _bind$9)) {
            const _ch$2 = _M0MPC16string6String16unsafe__char__at(_bind$6, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6, 0, _bind$8, _bind$9));
            const _bind$10 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6, 1, _bind$8, _bind$9);
            let _tmp$38;
            if (_bind$10 === undefined) {
              _tmp$38 = _bind$9;
            } else {
              const _Some = _bind$10;
              _tmp$38 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_bind$6, _tmp$38, _bind$9);
            self.input = _x$2;
            _L$2: {
              _L$3: {
                let flag;
                _L$4: {
                  _L$5: {
                    switch (_ch$2) {
                      case 100: {
                        const _p$4 = _M0FP411moonbitlang6regexp8internal7unicode17ranges__is__digit.length;
                        let _tmp$39 = 0;
                        while (true) {
                          const _p$5 = _tmp$39;
                          if (_p$5 < _p$4) {
                            const _p$6 = _M0FP411moonbitlang6regexp8internal7unicode17ranges__is__digit[_p$5];
                            _M0MPC15array5Array4pushGcE(chars, _p$6);
                            _tmp$39 = _p$5 + 1 | 0;
                            continue;
                          } else {
                            break;
                          }
                        }
                        continue _L;
                      }
                      case 68: {
                        const _p$5 = _M0FP411moonbitlang6regexp8internal7unicode22ranges__is__not__digit.length;
                        let _tmp$40 = 0;
                        while (true) {
                          const _p$6 = _tmp$40;
                          if (_p$6 < _p$5) {
                            const _p$7 = _M0FP411moonbitlang6regexp8internal7unicode22ranges__is__not__digit[_p$6];
                            _M0MPC15array5Array4pushGcE(chars, _p$7);
                            _tmp$40 = _p$6 + 1 | 0;
                            continue;
                          } else {
                            break;
                          }
                        }
                        continue _L;
                      }
                      case 119: {
                        const _p$6 = _M0FP411moonbitlang6regexp8internal7unicode16ranges__is__word.length;
                        let _tmp$41 = 0;
                        while (true) {
                          const _p$7 = _tmp$41;
                          if (_p$7 < _p$6) {
                            const _p$8 = _M0FP411moonbitlang6regexp8internal7unicode16ranges__is__word[_p$7];
                            _M0MPC15array5Array4pushGcE(chars, _p$8);
                            _tmp$41 = _p$7 + 1 | 0;
                            continue;
                          } else {
                            break;
                          }
                        }
                        continue _L;
                      }
                      case 87: {
                        const _p$7 = _M0FP411moonbitlang6regexp8internal7unicode21ranges__is__not__word.length;
                        let _tmp$42 = 0;
                        while (true) {
                          const _p$8 = _tmp$42;
                          if (_p$8 < _p$7) {
                            const _p$9 = _M0FP411moonbitlang6regexp8internal7unicode21ranges__is__not__word[_p$8];
                            _M0MPC15array5Array4pushGcE(chars, _p$9);
                            _tmp$42 = _p$8 + 1 | 0;
                            continue;
                          } else {
                            break;
                          }
                        }
                        continue _L;
                      }
                      case 115: {
                        const _p$8 = _M0FP411moonbitlang6regexp8internal7unicode46ranges__is__white__space__or__line__terminator.length;
                        let _tmp$43 = 0;
                        while (true) {
                          const _p$9 = _tmp$43;
                          if (_p$9 < _p$8) {
                            const _p$10 = _M0FP411moonbitlang6regexp8internal7unicode46ranges__is__white__space__or__line__terminator[_p$9];
                            _M0MPC15array5Array4pushGcE(chars, _p$10);
                            _tmp$43 = _p$9 + 1 | 0;
                            continue;
                          } else {
                            break;
                          }
                        }
                        continue _L;
                      }
                      case 83: {
                        const _p$9 = _M0FP411moonbitlang6regexp8internal7unicode51ranges__is__not__white__space__or__line__terminator.length;
                        let _tmp$44 = 0;
                        while (true) {
                          const _p$10 = _tmp$44;
                          if (_p$10 < _p$9) {
                            const _p$11 = _M0FP411moonbitlang6regexp8internal7unicode51ranges__is__not__white__space__or__line__terminator[_p$10];
                            _M0MPC15array5Array4pushGcE(chars, _p$11);
                            _tmp$44 = _p$10 + 1 | 0;
                            continue;
                          } else {
                            break;
                          }
                        }
                        continue _L;
                      }
                      case 112: {
                        flag = _ch$2;
                        break _L$5;
                      }
                      case 80: {
                        flag = _ch$2;
                        break _L$5;
                      }
                      case 116: {
                        start_char = 9;
                        break;
                      }
                      case 110: {
                        start_char = 10;
                        break;
                      }
                      case 118: {
                        start_char = 11;
                        break;
                      }
                      case 102: {
                        start_char = 12;
                        break;
                      }
                      case 114: {
                        start_char = 13;
                        break;
                      }
                      case 98: {
                        start_char = 8;
                        break;
                      }
                      case 117: {
                        const _bind$11 = _M0MP411moonbitlang6regexp8internal5parse6Parser22parse__unicode__escape(self);
                        if (_bind$11.$tag === 1) {
                          const _ok = _bind$11;
                          start_char = _ok._0;
                        } else {
                          return _bind$11;
                        }
                        break;
                      }
                      case 99: {
                        break _L$3;
                      }
                      case 107: {
                        break _L$3;
                      }
                      default: {
                        start_char = _ch$2;
                      }
                    }
                    break _L$4;
                  }
                  const _bind$11 = _M0MP411moonbitlang6regexp8internal5parse6Parser24parse__unicode__property(self);
                  let property_name;
                  if (_bind$11.$tag === 1) {
                    const _ok = _bind$11;
                    property_name = _ok._0;
                  } else {
                    return _bind$11;
                  }
                  const _bind$12 = _M0MP411moonbitlang6regexp8internal5parse6Parser24parse__general__category(self, property_name, flag === 80);
                  let _bind$13;
                  if (_bind$12.$tag === 1) {
                    const _ok = _bind$12;
                    _bind$13 = _ok._0;
                  } else {
                    return _bind$12;
                  }
                  if (_bind$13.$tag === 1) {
                    const _CharClass = _bind$13;
                    const _class = _CharClass._0;
                    const _neg = _CharClass._1;
                    if (_neg) {
                      const _p$4 = _M0FP411moonbitlang6regexp8internal7unicode32compute__char__class__complement(_class);
                      const _p$5 = _p$4.end - _p$4.start | 0;
                      let _tmp$39 = 0;
                      while (true) {
                        const _p$6 = _tmp$39;
                        if (_p$6 < _p$5) {
                          const _p$7 = _p$4.buf[_p$4.start + _p$6 | 0];
                          _M0MPC15array5Array4pushGcE(chars, _p$7);
                          _tmp$39 = _p$6 + 1 | 0;
                          continue;
                        } else {
                          break;
                        }
                      }
                    } else {
                      const _p$4 = _class.end - _class.start | 0;
                      let _tmp$39 = 0;
                      while (true) {
                        const _p$5 = _tmp$39;
                        if (_p$5 < _p$4) {
                          const _p$6 = _class.buf[_class.start + _p$5 | 0];
                          _M0MPC15array5Array4pushGcE(chars, _p$6);
                          _tmp$39 = _p$5 + 1 | 0;
                          continue;
                        } else {
                          break;
                        }
                      }
                    }
                    continue;
                  } else {
                    start_char = $panic();
                  }
                }
                break _L$2;
              }
              return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(2, _x));
            }
          } else {
            return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(9, self.input));
          }
        } else {
          self.input = _x;
          start_char = _ch;
        }
        _L$2: {
          _L$3: {
            const _bind$10 = self.input;
            if (_M0MPC16string6String24char__length__ge_2einner(_bind$10.str, 1, _bind$10.start, _bind$10.end)) {
              const _x$2 = _M0MPC16string6String16unsafe__char__at(_bind$10.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$10.str, 0, _bind$10.start, _bind$10.end));
              if (_x$2 === 45) {
                const _tmp$38 = _bind$10.str;
                const _bind$11 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$10.str, 1, _bind$10.start, _bind$10.end);
                let _tmp$39;
                if (_bind$11 === undefined) {
                  _tmp$39 = _bind$10.end;
                } else {
                  const _Some = _bind$11;
                  _tmp$39 = _Some;
                }
                const _x$3 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$10.end);
                const input_copy = self.input;
                self.input = _x$3;
                _L$4: {
                  _L$5: {
                    const _bind$12 = self.input;
                    if (_M0MPC16string6String24char__length__ge_2einner(_bind$12.str, 1, _bind$12.start, _bind$12.end)) {
                      const _ch$2 = _M0MPC16string6String16unsafe__char__at(_bind$12.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$12.str, 0, _bind$12.start, _bind$12.end));
                      const _bind$13 = _bind$12.str;
                      const _bind$14 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$12.str, 1, _bind$12.start, _bind$12.end);
                      let _bind$15;
                      if (_bind$14 === undefined) {
                        _bind$15 = _bind$12.end;
                      } else {
                        const _Some = _bind$14;
                        _bind$15 = _Some;
                      }
                      const _bind$16 = _bind$12.end;
                      const _x$4 = new _M0TPC16string10StringView(_bind$13, _bind$15, _bind$16);
                      if (_ch$2 !== 93) {
                        let end_char;
                        if (_ch$2 === 92) {
                          if (_M0MPC16string6String24char__length__ge_2einner(_bind$13, 1, _bind$15, _bind$16)) {
                            const _ch$3 = _M0MPC16string6String16unsafe__char__at(_bind$13, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$13, 0, _bind$15, _bind$16));
                            const _bind$17 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$13, 1, _bind$15, _bind$16);
                            let _tmp$40;
                            if (_bind$17 === undefined) {
                              _tmp$40 = _bind$16;
                            } else {
                              const _Some = _bind$17;
                              _tmp$40 = _Some;
                            }
                            const _x$5 = new _M0TPC16string10StringView(_bind$13, _tmp$40, _bind$16);
                            self.input = _x$5;
                            _L$6: {
                              _L$7: {
                                _L$8: {
                                  _L$9: {
                                    switch (_ch$3) {
                                      case 116: {
                                        end_char = 9;
                                        break;
                                      }
                                      case 110: {
                                        end_char = 10;
                                        break;
                                      }
                                      case 118: {
                                        end_char = 11;
                                        break;
                                      }
                                      case 102: {
                                        end_char = 12;
                                        break;
                                      }
                                      case 114: {
                                        end_char = 13;
                                        break;
                                      }
                                      case 98: {
                                        end_char = 8;
                                        break;
                                      }
                                      case 117: {
                                        const _bind$18 = _M0MP411moonbitlang6regexp8internal5parse6Parser22parse__unicode__escape(self);
                                        if (_bind$18.$tag === 1) {
                                          const _ok = _bind$18;
                                          end_char = _ok._0;
                                        } else {
                                          return _bind$18;
                                        }
                                        break;
                                      }
                                      case 100: {
                                        break _L$9;
                                      }
                                      case 68: {
                                        break _L$9;
                                      }
                                      case 119: {
                                        break _L$9;
                                      }
                                      case 87: {
                                        break _L$9;
                                      }
                                      case 115: {
                                        break _L$9;
                                      }
                                      case 83: {
                                        break _L$9;
                                      }
                                      case 112: {
                                        break _L$9;
                                      }
                                      case 80: {
                                        break _L$9;
                                      }
                                      case 99: {
                                        break _L$7;
                                      }
                                      case 107: {
                                        break _L$7;
                                      }
                                      default: {
                                        end_char = _ch$3;
                                      }
                                    }
                                    break _L$8;
                                  }
                                  return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(1, _bind$10));
                                }
                                break _L$6;
                              }
                              return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(2, self.input));
                            }
                          } else {
                            return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(9, self.input));
                          }
                        } else {
                          self.input = _x$4;
                          end_char = _ch$2;
                        }
                        if (end_char < start_char) {
                          return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(1, self.input));
                        }
                        _M0MPC15array5Array4pushGcE(chars, start_char);
                        _M0MPC15array5Array4pushGcE(chars, end_char);
                      } else {
                        break _L$5;
                      }
                    } else {
                      break _L$5;
                    }
                    break _L$4;
                  }
                  self.input = input_copy;
                  _M0MPC15array5Array4pushGcE(chars, start_char);
                  _M0MPC15array5Array4pushGcE(chars, start_char);
                }
              } else {
                break _L$3;
              }
            } else {
              break _L$3;
            }
            break _L$2;
          }
          _M0MPC15array5Array4pushGcE(chars, start_char);
          _M0MPC15array5Array4pushGcE(chars, start_char);
        }
        continue;
      } else {
        break;
      }
    } else {
      break;
    }
  }
  _L$2: {
    const _bind$5 = self.input;
    if (_M0MPC16string6String24char__length__ge_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end)) {
      const _x = _M0MPC16string6String16unsafe__char__at(_bind$5.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 0, _bind$5.start, _bind$5.end));
      if (_x === 93) {
        const _tmp$38 = _bind$5.str;
        const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end);
        let _tmp$39;
        if (_bind$6 === undefined) {
          _tmp$39 = _bind$5.end;
        } else {
          const _Some = _bind$6;
          _tmp$39 = _Some;
        }
        const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$5.end);
        self.input = _x$2;
        return self.flags.ignore_case ? new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass(_M0FP411moonbitlang6regexp8internal7unicode30case__insensitive__char__class(new _M0TPB9ArrayViewGcE(chars, 0, chars.length)), neg)) : new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass(new _M0TPB9ArrayViewGcE(chars, 0, chars.length), neg));
      } else {
        break _L$2;
      }
    } else {
      break _L$2;
    }
  }
  return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(6, self.input));
}
function _M0MP411moonbitlang6regexp8internal5parse6Parser12parse__flags(self) {
  const _bind$4 = self.flags;
  let flag = new _M0TP411moonbitlang6regexp8internal5parse5Flags(_bind$4.multiline, _bind$4.singleline, _bind$4.ignore_case);
  let positive = true;
  const _bind$5 = self.input;
  const _bind$6 = _bind$5.str;
  const _bind$7 = _bind$5.start;
  const _bind$8 = _bind$5.end;
  let _tmp$38;
  let _tmp$39 = _bind$7;
  _L: while (true) {
    const _param_start = _tmp$39;
    _L$2: {
      if (_M0MPC16string6String24char__length__ge_2einner(_bind$6, 1, _param_start, _bind$8)) {
        const _x = _M0MPC16string6String16unsafe__char__at(_bind$6, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6, 0, _param_start, _bind$8));
        switch (_x) {
          case 58: {
            const _bind$9 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6, 1, _param_start, _bind$8);
            let _tmp$40;
            if (_bind$9 === undefined) {
              _tmp$40 = _bind$8;
            } else {
              const _Some = _bind$9;
              _tmp$40 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_bind$6, _tmp$40, _bind$8);
            self.input = _x$2;
            return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal5parse5FlagsRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(flag);
          }
          case 109: {
            const _bind$10 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6, 1, _param_start, _bind$8);
            let _bind$11;
            if (_bind$10 === undefined) {
              _bind$11 = _bind$8;
            } else {
              const _Some = _bind$10;
              _bind$11 = _Some;
            }
            const _bind$12 = flag;
            flag = new _M0TP411moonbitlang6regexp8internal5parse5Flags(positive, _bind$12.singleline, _bind$12.ignore_case);
            _tmp$39 = _bind$11;
            continue _L;
          }
          case 115: {
            const _bind$13 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6, 1, _param_start, _bind$8);
            let _bind$14;
            if (_bind$13 === undefined) {
              _bind$14 = _bind$8;
            } else {
              const _Some = _bind$13;
              _bind$14 = _Some;
            }
            const _bind$15 = flag;
            flag = new _M0TP411moonbitlang6regexp8internal5parse5Flags(_bind$15.multiline, positive, _bind$15.ignore_case);
            _tmp$39 = _bind$14;
            continue _L;
          }
          case 105: {
            const _bind$16 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6, 1, _param_start, _bind$8);
            let _bind$17;
            if (_bind$16 === undefined) {
              _bind$17 = _bind$8;
            } else {
              const _Some = _bind$16;
              _bind$17 = _Some;
            }
            const _bind$18 = flag;
            flag = new _M0TP411moonbitlang6regexp8internal5parse5Flags(_bind$18.multiline, _bind$18.singleline, positive);
            _tmp$39 = _bind$17;
            continue _L;
          }
          case 45: {
            const _bind$19 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6, 1, _param_start, _bind$8);
            let _bind$20;
            if (_bind$19 === undefined) {
              _bind$20 = _bind$8;
            } else {
              const _Some = _bind$19;
              _bind$20 = _Some;
            }
            if (positive) {
              positive = false;
              _tmp$39 = _bind$20;
              continue _L;
            } else {
              break _L$2;
            }
          }
          default: {
            break _L$2;
          }
        }
      } else {
        break _L$2;
      }
    }
    return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal5parse5FlagsRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(4, self.input));
  }
  return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal5parse5FlagsRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(_tmp$38);
}
function _M0MP411moonbitlang6regexp8internal5parse6Parser18parse__group__name(self) {
  let name = "";
  let first = true;
  while (true) {
    const _bind$4 = self.input;
    if (_M0MPC16string6String24char__length__ge_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end)) {
      const _ch = _M0MPC16string6String16unsafe__char__at(_bind$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 0, _bind$4.start, _bind$4.end));
      const _tmp$38 = _bind$4.str;
      const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
      let _tmp$39;
      if (_bind$5 === undefined) {
        _tmp$39 = _bind$4.end;
      } else {
        const _Some = _bind$5;
        _tmp$39 = _Some;
      }
      const _x = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$4.end);
      if (_ch !== 62) {
        if (first) {
          _L: {
            if (_ch >= 97 && _ch <= 122) {
              break _L;
            } else {
              if (_ch >= 65 && _ch <= 90) {
                break _L;
              } else {
                if (_ch === 95) {
                  break _L;
                } else {
                  return new _M0DTPC16result6ResultGsRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(3, self.input));
                }
              }
            }
          }
          name = `${name}${_M0IPC14char4CharPB4Show10to__string(_ch)}`;
          self.input = _x;
          first = false;
        } else {
          _L: {
            if (_ch >= 97 && _ch <= 122) {
              break _L;
            } else {
              if (_ch >= 65 && _ch <= 90) {
                break _L;
              } else {
                if (_ch >= 48 && _ch <= 57) {
                  break _L;
                } else {
                  if (_ch === 95) {
                    break _L;
                  } else {
                    return new _M0DTPC16result6ResultGsRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(3, self.input));
                  }
                }
              }
            }
          }
          name = `${name}${_M0IPC14char4CharPB4Show10to__string(_ch)}`;
          self.input = _x;
        }
        continue;
      } else {
        break;
      }
    } else {
      break;
    }
  }
  if (name === "") {
    return new _M0DTPC16result6ResultGsRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(3, self.input));
  }
  return new _M0DTPC16result6ResultGsRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(name);
}
function _M0MP411moonbitlang6regexp8internal5parse6Parser13parse__number(self) {
  let result = 0;
  let has_digits = false;
  while (true) {
    const _bind$4 = self.input;
    if (_M0MPC16string6String24char__length__ge_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end)) {
      const _ch = _M0MPC16string6String16unsafe__char__at(_bind$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 0, _bind$4.start, _bind$4.end));
      const _tmp$38 = _bind$4.str;
      const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
      let _tmp$39;
      if (_bind$5 === undefined) {
        _tmp$39 = _bind$4.end;
      } else {
        const _Some = _bind$5;
        _tmp$39 = _Some;
      }
      const _x = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$4.end);
      if (_ch >= 48) {
        if (_ch <= 57) {
          has_digits = true;
          result = ((Math.imul(result, 10) | 0) >>> 0) + ((_ch - 48 | 0) >>> 0) | 0;
          self.input = _x;
          continue;
        } else {
          break;
        }
      } else {
        break;
      }
    } else {
      break;
    }
  }
  if (!has_digits) {
    return new _M0DTPC16result6ResultGjRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(8, self.input));
  }
  return new _M0DTPC16result6ResultGjRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(result);
}
function _M0MP411moonbitlang6regexp8internal5parse6Parser13parse__repeat(self) {
  const _bind$4 = _M0MP411moonbitlang6regexp8internal5parse6Parser13parse__number(self);
  let min;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    min = _ok._0;
  } else {
    return _bind$4;
  }
  _L: {
    const _bind$5 = self.input;
    if (_M0MPC16string6String24char__length__ge_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end)) {
      const _x = _M0MPC16string6String16unsafe__char__at(_bind$5.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 0, _bind$5.start, _bind$5.end));
      switch (_x) {
        case 125: {
          const _tmp$38 = _bind$5.str;
          const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end);
          let _tmp$39;
          if (_bind$6 === undefined) {
            _tmp$39 = _bind$5.end;
          } else {
            const _Some = _bind$6;
            _tmp$39 = _Some;
          }
          const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$5.end);
          self.input = _x$2;
          return new _M0DTPC16result6ResultGUjOjERP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok({ _0: min, _1: min });
        }
        case 44: {
          const _tmp$40 = _bind$5.str;
          const _bind$7 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end);
          let _tmp$41;
          if (_bind$7 === undefined) {
            _tmp$41 = _bind$5.end;
          } else {
            const _Some = _bind$7;
            _tmp$41 = _Some;
          }
          const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, _bind$5.end);
          self.input = _x$3;
          _L$2: {
            const _bind$8 = self.input;
            if (_M0MPC16string6String24char__length__ge_2einner(_bind$8.str, 1, _bind$8.start, _bind$8.end)) {
              const _x$4 = _M0MPC16string6String16unsafe__char__at(_bind$8.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$8.str, 0, _bind$8.start, _bind$8.end));
              if (_x$4 === 125) {
                const _tmp$42 = _bind$8.str;
                const _bind$9 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$8.str, 1, _bind$8.start, _bind$8.end);
                let _tmp$43;
                if (_bind$9 === undefined) {
                  _tmp$43 = _bind$8.end;
                } else {
                  const _Some = _bind$9;
                  _tmp$43 = _Some;
                }
                const _x$5 = new _M0TPC16string10StringView(_tmp$42, _tmp$43, _bind$8.end);
                self.input = _x$5;
                return new _M0DTPC16result6ResultGUjOjERP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok({ _0: min, _1: undefined });
              } else {
                break _L$2;
              }
            } else {
              break _L$2;
            }
          }
          const _bind$8 = _M0MP411moonbitlang6regexp8internal5parse6Parser13parse__number(self);
          let max;
          if (_bind$8.$tag === 1) {
            const _ok = _bind$8;
            max = _ok._0;
          } else {
            return _bind$8;
          }
          _L$3: {
            const _bind$9 = self.input;
            if (_M0MPC16string6String24char__length__ge_2einner(_bind$9.str, 1, _bind$9.start, _bind$9.end)) {
              const _x$4 = _M0MPC16string6String16unsafe__char__at(_bind$9.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$9.str, 0, _bind$9.start, _bind$9.end));
              if (_x$4 === 125) {
                const _tmp$42 = _bind$9.str;
                const _bind$10 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$9.str, 1, _bind$9.start, _bind$9.end);
                let _tmp$43;
                if (_bind$10 === undefined) {
                  _tmp$43 = _bind$9.end;
                } else {
                  const _Some = _bind$10;
                  _tmp$43 = _Some;
                }
                const _x$5 = new _M0TPC16string10StringView(_tmp$42, _tmp$43, _bind$9.end);
                self.input = _x$5;
                if (max >>> 0 < min >>> 0) {
                  return new _M0DTPC16result6ResultGUjOjERP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(5, self.input));
                }
                return new _M0DTPC16result6ResultGUjOjERP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok({ _0: min, _1: max });
              } else {
                break _L$3;
              }
            } else {
              break _L$3;
            }
          }
          return new _M0DTPC16result6ResultGUjOjERP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(4, self.input));
        }
        default: {
          break _L;
        }
      }
    } else {
      break _L;
    }
  }
  return new _M0DTPC16result6ResultGUjOjERP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(4, self.input));
}
function _M0MP411moonbitlang6regexp8internal5parse6Parser17parse__expression(self) {
  const _bind$4 = _M0MP411moonbitlang6regexp8internal5parse6Parser15parse__sequence(self);
  let left;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    left = _ok._0;
  } else {
    return _bind$4;
  }
  while (true) {
    const _bind$5 = self.input;
    if (_M0MPC16string6String24char__length__ge_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end)) {
      const _x = _M0MPC16string6String16unsafe__char__at(_bind$5.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 0, _bind$5.start, _bind$5.end));
      if (_x === 124) {
        const _tmp$38 = _bind$5.str;
        const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end);
        let _tmp$39;
        if (_bind$6 === undefined) {
          _tmp$39 = _bind$5.end;
        } else {
          const _Some = _bind$6;
          _tmp$39 = _Some;
        }
        const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$5.end);
        self.input = _x$2;
        const _bind$7 = _M0MP411moonbitlang6regexp8internal5parse6Parser15parse__sequence(self);
        let right;
        if (_bind$7.$tag === 1) {
          const _ok = _bind$7;
          right = _ok._0;
        } else {
          return _bind$7;
        }
        left = new _M0DTP411moonbitlang6regexp8internal3ast3Ast9Alternate(left, right);
        continue;
      } else {
        break;
      }
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(left);
}
function _M0MP411moonbitlang6regexp8internal5parse6Parser15parse__sequence(self) {
  const sequence = [];
  while (true) {
    const _bind$4 = self.input;
    if (_M0MPC16string6String24char__length__ge_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end)) {
      const _ch = _M0MPC16string6String16unsafe__char__at(_bind$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 0, _bind$4.start, _bind$4.end));
      if (_ch !== 124) {
        if (_ch !== 41) {
          const _bind$5 = _M0MP411moonbitlang6regexp8internal5parse6Parser11parse__term(self);
          let term;
          if (_bind$5.$tag === 1) {
            const _ok = _bind$5;
            term = _ok._0;
          } else {
            return _bind$5;
          }
          _M0MPC15array5Array4pushGUssEE(sequence, term);
          continue;
        } else {
          break;
        }
      } else {
        break;
      }
    } else {
      break;
    }
  }
  if (sequence.length === 0) {
    return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(_M0DTP411moonbitlang6regexp8internal3ast3Ast5Empty__);
  } else {
    if (sequence.length === 1) {
      const _regex = sequence[0];
      return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(_regex);
    } else {
      return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast6Concat(sequence));
    }
  }
}
function _M0MP411moonbitlang6regexp8internal5parse6Parser11parse__term(self) {
  const _bind$4 = _M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factor(self);
  let base;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    base = _ok._0;
  } else {
    return _bind$4;
  }
  let rest;
  _L: {
    _L$2: {
      let rest$2;
      _L$3: {
        _L$4: {
          let rest$3;
          _L$5: {
            _L$6: {
              let rest$4;
              _L$7: {
                _L$8: {
                  const _bind$5 = self.input;
                  if (_M0MPC16string6String24char__length__ge_2einner(_bind$5.str, 2, _bind$5.start, _bind$5.end)) {
                    const _x = _M0MPC16string6String16unsafe__char__at(_bind$5.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 0, _bind$5.start, _bind$5.end));
                    switch (_x) {
                      case 42: {
                        const _x$2 = _M0MPC16string6String16unsafe__char__at(_bind$5.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end));
                        if (_x$2 === 63) {
                          const _tmp$38 = _bind$5.str;
                          const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 2, _bind$5.start, _bind$5.end);
                          let _tmp$39;
                          if (_bind$6 === undefined) {
                            _tmp$39 = _bind$5.end;
                          } else {
                            const _Some = _bind$6;
                            _tmp$39 = _Some;
                          }
                          const _x$3 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$5.end);
                          self.input = _x$3;
                          base = new _M0DTP411moonbitlang6regexp8internal3ast3Ast10ZeroOrMore(base, false);
                        } else {
                          const _tmp$38 = _bind$5.str;
                          const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end);
                          let _tmp$39;
                          if (_bind$6 === undefined) {
                            _tmp$39 = _bind$5.end;
                          } else {
                            const _Some = _bind$6;
                            _tmp$39 = _Some;
                          }
                          const _x$3 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$5.end);
                          rest$4 = _x$3;
                          break _L$8;
                        }
                        break;
                      }
                      case 43: {
                        const _x$3 = _M0MPC16string6String16unsafe__char__at(_bind$5.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end));
                        if (_x$3 === 63) {
                          const _tmp$38 = _bind$5.str;
                          const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 2, _bind$5.start, _bind$5.end);
                          let _tmp$39;
                          if (_bind$6 === undefined) {
                            _tmp$39 = _bind$5.end;
                          } else {
                            const _Some = _bind$6;
                            _tmp$39 = _Some;
                          }
                          const _x$4 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$5.end);
                          self.input = _x$4;
                          base = new _M0DTP411moonbitlang6regexp8internal3ast3Ast9OneOrMore(base, false);
                        } else {
                          const _tmp$38 = _bind$5.str;
                          const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end);
                          let _tmp$39;
                          if (_bind$6 === undefined) {
                            _tmp$39 = _bind$5.end;
                          } else {
                            const _Some = _bind$6;
                            _tmp$39 = _Some;
                          }
                          const _x$4 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$5.end);
                          rest$3 = _x$4;
                          break _L$6;
                        }
                        break;
                      }
                      case 63: {
                        const _x$4 = _M0MPC16string6String16unsafe__char__at(_bind$5.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end));
                        if (_x$4 === 63) {
                          const _tmp$38 = _bind$5.str;
                          const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 2, _bind$5.start, _bind$5.end);
                          let _tmp$39;
                          if (_bind$6 === undefined) {
                            _tmp$39 = _bind$5.end;
                          } else {
                            const _Some = _bind$6;
                            _tmp$39 = _Some;
                          }
                          const _x$5 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$5.end);
                          self.input = _x$5;
                          base = new _M0DTP411moonbitlang6regexp8internal3ast3Ast9ZeroOrOne(base, false);
                        } else {
                          const _tmp$38 = _bind$5.str;
                          const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end);
                          let _tmp$39;
                          if (_bind$6 === undefined) {
                            _tmp$39 = _bind$5.end;
                          } else {
                            const _Some = _bind$6;
                            _tmp$39 = _Some;
                          }
                          const _x$5 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$5.end);
                          rest$2 = _x$5;
                          break _L$4;
                        }
                        break;
                      }
                      case 123: {
                        const _tmp$38 = _bind$5.str;
                        const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end);
                        let _tmp$39;
                        if (_bind$6 === undefined) {
                          _tmp$39 = _bind$5.end;
                        } else {
                          const _Some = _bind$6;
                          _tmp$39 = _Some;
                        }
                        const _x$5 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$5.end);
                        rest = _x$5;
                        break _L$2;
                      }
                    }
                  } else {
                    if (_M0MPC16string6String24char__length__ge_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end)) {
                      const _x = _M0MPC16string6String16unsafe__char__at(_bind$5.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 0, _bind$5.start, _bind$5.end));
                      switch (_x) {
                        case 42: {
                          const _tmp$38 = _bind$5.str;
                          const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end);
                          let _tmp$39;
                          if (_bind$6 === undefined) {
                            _tmp$39 = _bind$5.end;
                          } else {
                            const _Some = _bind$6;
                            _tmp$39 = _Some;
                          }
                          const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$5.end);
                          rest$4 = _x$2;
                          break _L$8;
                        }
                        case 43: {
                          const _tmp$40 = _bind$5.str;
                          const _bind$7 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end);
                          let _tmp$41;
                          if (_bind$7 === undefined) {
                            _tmp$41 = _bind$5.end;
                          } else {
                            const _Some = _bind$7;
                            _tmp$41 = _Some;
                          }
                          const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, _bind$5.end);
                          rest$3 = _x$3;
                          break _L$6;
                        }
                        case 63: {
                          const _tmp$42 = _bind$5.str;
                          const _bind$8 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end);
                          let _tmp$43;
                          if (_bind$8 === undefined) {
                            _tmp$43 = _bind$5.end;
                          } else {
                            const _Some = _bind$8;
                            _tmp$43 = _Some;
                          }
                          const _x$4 = new _M0TPC16string10StringView(_tmp$42, _tmp$43, _bind$5.end);
                          rest$2 = _x$4;
                          break _L$4;
                        }
                        case 123: {
                          const _tmp$44 = _bind$5.str;
                          const _bind$9 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end);
                          let _tmp$45;
                          if (_bind$9 === undefined) {
                            _tmp$45 = _bind$5.end;
                          } else {
                            const _Some = _bind$9;
                            _tmp$45 = _Some;
                          }
                          const _x$5 = new _M0TPC16string10StringView(_tmp$44, _tmp$45, _bind$5.end);
                          rest = _x$5;
                          break _L$2;
                        }
                      }
                    }
                  }
                  break _L$7;
                }
                self.input = rest$4;
                base = new _M0DTP411moonbitlang6regexp8internal3ast3Ast10ZeroOrMore(base, true);
              }
              break _L$5;
            }
            self.input = rest$3;
            base = new _M0DTP411moonbitlang6regexp8internal3ast3Ast9OneOrMore(base, true);
          }
          break _L$3;
        }
        self.input = rest$2;
        base = new _M0DTP411moonbitlang6regexp8internal3ast3Ast9ZeroOrOne(base, true);
      }
      break _L;
    }
    self.input = rest;
    const _bind$5 = _M0MP411moonbitlang6regexp8internal5parse6Parser13parse__repeat(self);
    let repeat_result;
    if (_bind$5.$tag === 1) {
      const _ok = _bind$5;
      repeat_result = _ok._0;
    } else {
      return _bind$5;
    }
    const _bind$6 = self.input;
    let greedy;
    if (_M0MPC16string6String24char__length__ge_2einner(_bind$6.str, 1, _bind$6.start, _bind$6.end)) {
      const _x = _M0MPC16string6String16unsafe__char__at(_bind$6.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6.str, 0, _bind$6.start, _bind$6.end));
      if (_x === 63) {
        const _tmp$38 = _bind$6.str;
        const _bind$7 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$6.str, 1, _bind$6.start, _bind$6.end);
        let _tmp$39;
        if (_bind$7 === undefined) {
          _tmp$39 = _bind$6.end;
        } else {
          const _Some = _bind$7;
          _tmp$39 = _Some;
        }
        const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$6.end);
        self.input = _x$2;
        greedy = false;
      } else {
        greedy = true;
      }
    } else {
      greedy = true;
    }
    base = new _M0DTP411moonbitlang6regexp8internal3ast3Ast6Repeat(base, greedy, repeat_result._0, repeat_result._1);
  }
  return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(base);
}
function _M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factor(self) {
  let rest;
  let c;
  _L: {
    let c$2;
    _L$2: {
      let escape;
      let rest$2;
      _L$3: {
        let rest$3;
        _L$4: {
          let rest$4;
          _L$5: {
            let rest$5;
            _L$6: {
              let rest$6;
              _L$7: {
                let rest$7;
                _L$8: {
                  const _bind$4 = self.input;
                  if (_M0MPC16string6String24char__length__ge_2einner(_bind$4.str, 2, _bind$4.start, _bind$4.end)) {
                    const _x = _M0MPC16string6String16unsafe__char__at(_bind$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 0, _bind$4.start, _bind$4.end));
                    switch (_x) {
                      case 40: {
                        const _x$2 = _M0MPC16string6String16unsafe__char__at(_bind$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end));
                        if (_x$2 === 63) {
                          const _bind$5 = _bind$4.str;
                          const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 2, _bind$4.start, _bind$4.end);
                          let _bind$7;
                          if (_bind$6 === undefined) {
                            _bind$7 = _bind$4.end;
                          } else {
                            const _Some = _bind$6;
                            _bind$7 = _Some;
                          }
                          const _bind$8 = _bind$4.end;
                          const _x$3 = new _M0TPC16string10StringView(_bind$5, _bind$7, _bind$8);
                          _L$9: {
                            if (_M0MPC16string6String24char__length__ge_2einner(_bind$5, 1, _bind$7, _bind$8)) {
                              const _x$4 = _M0MPC16string6String16unsafe__char__at(_bind$5, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5, 0, _bind$7, _bind$8));
                              if (_x$4 === 60) {
                                const _bind$9 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5, 1, _bind$7, _bind$8);
                                let _tmp$38;
                                if (_bind$9 === undefined) {
                                  _tmp$38 = _bind$8;
                                } else {
                                  const _Some = _bind$9;
                                  _tmp$38 = _Some;
                                }
                                const _x$5 = new _M0TPC16string10StringView(_bind$5, _tmp$38, _bind$8);
                                const captures = self.captures;
                                self.captures = self.captures + 1 | 0;
                                self.input = _x$5;
                                const _bind$10 = _M0MP411moonbitlang6regexp8internal5parse6Parser18parse__group__name(self);
                                let name;
                                if (_bind$10.$tag === 1) {
                                  const _ok = _bind$10;
                                  name = _ok._0;
                                } else {
                                  return _bind$10;
                                }
                                _L$10: {
                                  const _bind$11 = self.input;
                                  if (_M0MPC16string6String24char__length__ge_2einner(_bind$11.str, 1, _bind$11.start, _bind$11.end)) {
                                    const _x$6 = _M0MPC16string6String16unsafe__char__at(_bind$11.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$11.str, 0, _bind$11.start, _bind$11.end));
                                    if (_x$6 === 62) {
                                      const _tmp$39 = _bind$11.str;
                                      const _bind$12 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$11.str, 1, _bind$11.start, _bind$11.end);
                                      let _tmp$40;
                                      if (_bind$12 === undefined) {
                                        _tmp$40 = _bind$11.end;
                                      } else {
                                        const _Some = _bind$12;
                                        _tmp$40 = _Some;
                                      }
                                      const _x$7 = new _M0TPC16string10StringView(_tmp$39, _tmp$40, _bind$11.end);
                                      self.input = _x$7;
                                      _M0MPC13set3Set3addGiE(self.current_capture_scope, captures);
                                      const _bind$13 = _M0MP411moonbitlang6regexp8internal5parse6Parser17parse__expression(self);
                                      let expr;
                                      if (_bind$13.$tag === 1) {
                                        const _ok = _bind$13;
                                        expr = _ok._0;
                                      } else {
                                        return _bind$13;
                                      }
                                      _M0MPC13set3Set6removeGiE(self.current_capture_scope, captures);
                                      _L$11: {
                                        const _bind$14 = self.input;
                                        if (_M0MPC16string6String24char__length__ge_2einner(_bind$14.str, 1, _bind$14.start, _bind$14.end)) {
                                          const _x$8 = _M0MPC16string6String16unsafe__char__at(_bind$14.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$14.str, 0, _bind$14.start, _bind$14.end));
                                          if (_x$8 === 41) {
                                            const _tmp$41 = _bind$14.str;
                                            const _bind$15 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$14.str, 1, _bind$14.start, _bind$14.end);
                                            let _tmp$42;
                                            if (_bind$15 === undefined) {
                                              _tmp$42 = _bind$14.end;
                                            } else {
                                              const _Some = _bind$15;
                                              _tmp$42 = _Some;
                                            }
                                            const _x$9 = new _M0TPC16string10StringView(_tmp$41, _tmp$42, _bind$14.end);
                                            self.input = _x$9;
                                            if (_M0MPB3Map8containsGsiE(self.capture_map, name)) {
                                              return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(3, _bind$4));
                                            }
                                            _M0MPB3Map3setGsiE(self.capture_map, name, captures);
                                            return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast7Capture(expr, captures));
                                          } else {
                                            break _L$11;
                                          }
                                        } else {
                                          break _L$11;
                                        }
                                      }
                                      return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(7, self.input));
                                    } else {
                                      break _L$10;
                                    }
                                  } else {
                                    break _L$10;
                                  }
                                }
                                return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(3, self.input));
                              } else {
                                break _L$9;
                              }
                            } else {
                              break _L$9;
                            }
                          }
                          self.input = _x$3;
                          const old_flags = self.flags;
                          const _bind$9 = _M0MP411moonbitlang6regexp8internal5parse6Parser12parse__flags(self);
                          let new_flags;
                          if (_bind$9.$tag === 1) {
                            const _ok = _bind$9;
                            new_flags = _ok._0;
                          } else {
                            return _bind$9;
                          }
                          self.flags = new_flags;
                          const _bind$10 = _M0MP411moonbitlang6regexp8internal5parse6Parser17parse__expression(self);
                          let expr;
                          if (_bind$10.$tag === 1) {
                            const _ok = _bind$10;
                            expr = _ok._0;
                          } else {
                            return _bind$10;
                          }
                          _L$10: {
                            const _bind$11 = self.input;
                            if (_M0MPC16string6String24char__length__ge_2einner(_bind$11.str, 1, _bind$11.start, _bind$11.end)) {
                              const _x$4 = _M0MPC16string6String16unsafe__char__at(_bind$11.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$11.str, 0, _bind$11.start, _bind$11.end));
                              if (_x$4 === 41) {
                                const _tmp$38 = _bind$11.str;
                                const _bind$12 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$11.str, 1, _bind$11.start, _bind$11.end);
                                let _tmp$39;
                                if (_bind$12 === undefined) {
                                  _tmp$39 = _bind$11.end;
                                } else {
                                  const _Some = _bind$12;
                                  _tmp$39 = _Some;
                                }
                                const _x$5 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$11.end);
                                self.input = _x$5;
                                self.flags = old_flags;
                                return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(expr);
                              } else {
                                break _L$10;
                              }
                            } else {
                              break _L$10;
                            }
                          }
                          return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(7, self.input));
                        } else {
                          const _tmp$38 = _bind$4.str;
                          const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
                          let _tmp$39;
                          if (_bind$5 === undefined) {
                            _tmp$39 = _bind$4.end;
                          } else {
                            const _Some = _bind$5;
                            _tmp$39 = _Some;
                          }
                          const _x$3 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$4.end);
                          rest$7 = _x$3;
                          break _L$8;
                        }
                      }
                      case 91: {
                        const _tmp$38 = _bind$4.str;
                        const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
                        let _tmp$39;
                        if (_bind$5 === undefined) {
                          _tmp$39 = _bind$4.end;
                        } else {
                          const _Some = _bind$5;
                          _tmp$39 = _Some;
                        }
                        const _x$3 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$4.end);
                        rest$6 = _x$3;
                        break _L$7;
                      }
                      case 46: {
                        const _tmp$40 = _bind$4.str;
                        const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
                        let _tmp$41;
                        if (_bind$6 === undefined) {
                          _tmp$41 = _bind$4.end;
                        } else {
                          const _Some = _bind$6;
                          _tmp$41 = _Some;
                        }
                        const _x$4 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, _bind$4.end);
                        rest$5 = _x$4;
                        break _L$6;
                      }
                      case 94: {
                        const _tmp$42 = _bind$4.str;
                        const _bind$7 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
                        let _tmp$43;
                        if (_bind$7 === undefined) {
                          _tmp$43 = _bind$4.end;
                        } else {
                          const _Some = _bind$7;
                          _tmp$43 = _Some;
                        }
                        const _x$5 = new _M0TPC16string10StringView(_tmp$42, _tmp$43, _bind$4.end);
                        rest$4 = _x$5;
                        break _L$5;
                      }
                      case 36: {
                        const _tmp$44 = _bind$4.str;
                        const _bind$8 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
                        let _tmp$45;
                        if (_bind$8 === undefined) {
                          _tmp$45 = _bind$4.end;
                        } else {
                          const _Some = _bind$8;
                          _tmp$45 = _Some;
                        }
                        const _x$6 = new _M0TPC16string10StringView(_tmp$44, _tmp$45, _bind$4.end);
                        rest$3 = _x$6;
                        break _L$4;
                      }
                      case 92: {
                        const _tmp$46 = _bind$4.str;
                        const _bind$9 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
                        let _tmp$47;
                        if (_bind$9 === undefined) {
                          _tmp$47 = _bind$4.end;
                        } else {
                          const _Some = _bind$9;
                          _tmp$47 = _Some;
                        }
                        const _x$7 = new _M0TPC16string10StringView(_tmp$46, _tmp$47, _bind$4.end);
                        escape = _bind$4;
                        rest$2 = _x$7;
                        break _L$3;
                      }
                      default: {
                        if (_M0MP411moonbitlang6regexp8internal5parse6Parser17is__special__char(_x)) {
                          c$2 = _x;
                          break _L$2;
                        } else {
                          const _tmp$48 = _bind$4.str;
                          const _bind$10 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
                          let _tmp$49;
                          if (_bind$10 === undefined) {
                            _tmp$49 = _bind$4.end;
                          } else {
                            const _Some = _bind$10;
                            _tmp$49 = _Some;
                          }
                          const _x$8 = new _M0TPC16string10StringView(_tmp$48, _tmp$49, _bind$4.end);
                          rest = _x$8;
                          c = _x;
                          break _L;
                        }
                      }
                    }
                  } else {
                    if (_M0MPC16string6String24char__length__ge_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end)) {
                      const _x = _M0MPC16string6String16unsafe__char__at(_bind$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 0, _bind$4.start, _bind$4.end));
                      switch (_x) {
                        case 40: {
                          const _tmp$38 = _bind$4.str;
                          const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
                          let _tmp$39;
                          if (_bind$5 === undefined) {
                            _tmp$39 = _bind$4.end;
                          } else {
                            const _Some = _bind$5;
                            _tmp$39 = _Some;
                          }
                          const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$4.end);
                          rest$7 = _x$2;
                          break _L$8;
                        }
                        case 91: {
                          const _tmp$40 = _bind$4.str;
                          const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
                          let _tmp$41;
                          if (_bind$6 === undefined) {
                            _tmp$41 = _bind$4.end;
                          } else {
                            const _Some = _bind$6;
                            _tmp$41 = _Some;
                          }
                          const _x$3 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, _bind$4.end);
                          rest$6 = _x$3;
                          break _L$7;
                        }
                        case 46: {
                          const _tmp$42 = _bind$4.str;
                          const _bind$7 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
                          let _tmp$43;
                          if (_bind$7 === undefined) {
                            _tmp$43 = _bind$4.end;
                          } else {
                            const _Some = _bind$7;
                            _tmp$43 = _Some;
                          }
                          const _x$4 = new _M0TPC16string10StringView(_tmp$42, _tmp$43, _bind$4.end);
                          rest$5 = _x$4;
                          break _L$6;
                        }
                        case 94: {
                          const _tmp$44 = _bind$4.str;
                          const _bind$8 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
                          let _tmp$45;
                          if (_bind$8 === undefined) {
                            _tmp$45 = _bind$4.end;
                          } else {
                            const _Some = _bind$8;
                            _tmp$45 = _Some;
                          }
                          const _x$5 = new _M0TPC16string10StringView(_tmp$44, _tmp$45, _bind$4.end);
                          rest$4 = _x$5;
                          break _L$5;
                        }
                        case 36: {
                          const _tmp$46 = _bind$4.str;
                          const _bind$9 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
                          let _tmp$47;
                          if (_bind$9 === undefined) {
                            _tmp$47 = _bind$4.end;
                          } else {
                            const _Some = _bind$9;
                            _tmp$47 = _Some;
                          }
                          const _x$6 = new _M0TPC16string10StringView(_tmp$46, _tmp$47, _bind$4.end);
                          rest$3 = _x$6;
                          break _L$4;
                        }
                        case 92: {
                          const _tmp$48 = _bind$4.str;
                          const _bind$10 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
                          let _tmp$49;
                          if (_bind$10 === undefined) {
                            _tmp$49 = _bind$4.end;
                          } else {
                            const _Some = _bind$10;
                            _tmp$49 = _Some;
                          }
                          const _x$7 = new _M0TPC16string10StringView(_tmp$48, _tmp$49, _bind$4.end);
                          escape = _bind$4;
                          rest$2 = _x$7;
                          break _L$3;
                        }
                        default: {
                          if (_M0MP411moonbitlang6regexp8internal5parse6Parser17is__special__char(_x)) {
                            c$2 = _x;
                            break _L$2;
                          } else {
                            const _tmp$50 = _bind$4.str;
                            const _bind$11 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
                            let _tmp$51;
                            if (_bind$11 === undefined) {
                              _tmp$51 = _bind$4.end;
                            } else {
                              const _Some = _bind$11;
                              _tmp$51 = _Some;
                            }
                            const _x$8 = new _M0TPC16string10StringView(_tmp$50, _tmp$51, _bind$4.end);
                            rest = _x$8;
                            c = _x;
                            break _L;
                          }
                        }
                      }
                    } else {
                      return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(0, self.input));
                    }
                  }
                }
                const captures = self.captures;
                self.captures = self.captures + 1 | 0;
                self.input = rest$7;
                _M0MPC13set3Set3addGiE(self.current_capture_scope, captures);
                const _bind$4 = _M0MP411moonbitlang6regexp8internal5parse6Parser17parse__expression(self);
                let expr;
                if (_bind$4.$tag === 1) {
                  const _ok = _bind$4;
                  expr = _ok._0;
                } else {
                  return _bind$4;
                }
                _M0MPC13set3Set6removeGiE(self.current_capture_scope, captures);
                _L$9: {
                  const _bind$5 = self.input;
                  if (_M0MPC16string6String24char__length__ge_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end)) {
                    const _x = _M0MPC16string6String16unsafe__char__at(_bind$5.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 0, _bind$5.start, _bind$5.end));
                    if (_x === 41) {
                      const _tmp$38 = _bind$5.str;
                      const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end);
                      let _tmp$39;
                      if (_bind$6 === undefined) {
                        _tmp$39 = _bind$5.end;
                      } else {
                        const _Some = _bind$6;
                        _tmp$39 = _Some;
                      }
                      const _x$2 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$5.end);
                      self.input = _x$2;
                      return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast7Capture(expr, captures));
                    } else {
                      break _L$9;
                    }
                  } else {
                    break _L$9;
                  }
                }
                return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(7, self.input));
              }
              self.input = rest$6;
              return _M0MP411moonbitlang6regexp8internal5parse6Parser18parse__char__class(self);
            }
            self.input = rest$5;
            return self.flags.singleline ? new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass(new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode11ranges__any, 0, _M0FP411moonbitlang6regexp8internal7unicode11ranges__any.length), false)) : new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass(new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode27ranges__any__not__new__line, 0, _M0FP411moonbitlang6regexp8internal7unicode27ranges__any__not__new__line.length), false));
          }
          self.input = rest$4;
          return self.flags.multiline ? new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(_M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN6constrS663) : new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(_M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN6constrS664);
        }
        self.input = rest$3;
        return self.flags.multiline ? new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(_M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN6constrS661) : new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(_M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN6constrS662);
      }
      if (_M0MPC16string6String24char__length__ge_2einner(rest$2.str, 1, rest$2.start, rest$2.end)) {
        const _c = _M0MPC16string6String16unsafe__char__at(rest$2.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 0, rest$2.start, rest$2.end));
        const _bind$4 = rest$2.str;
        const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 1, rest$2.start, rest$2.end);
        let _bind$6;
        if (_bind$5 === undefined) {
          _bind$6 = rest$2.end;
        } else {
          const _Some = _bind$5;
          _bind$6 = _Some;
        }
        const _bind$7 = rest$2.end;
        const _x = new _M0TPC16string10StringView(_bind$4, _bind$6, _bind$7);
        self.input = _x;
        let flag;
        _L$4: {
          if (_c === 98) {
            return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(_M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN6constrS659);
          } else {
            if (_c === 66) {
              return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(_M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN6constrS660);
            } else {
              if (_c === 100) {
                return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass(new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode17ranges__is__digit, 0, _M0FP411moonbitlang6regexp8internal7unicode17ranges__is__digit.length), false));
              } else {
                if (_c === 68) {
                  return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass(new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode22ranges__is__not__digit, 0, _M0FP411moonbitlang6regexp8internal7unicode22ranges__is__not__digit.length), false));
                } else {
                  if (_c === 119) {
                    return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass(new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode16ranges__is__word, 0, _M0FP411moonbitlang6regexp8internal7unicode16ranges__is__word.length), false));
                  } else {
                    if (_c === 87) {
                      return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass(new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode21ranges__is__not__word, 0, _M0FP411moonbitlang6regexp8internal7unicode21ranges__is__not__word.length), false));
                    } else {
                      if (_c === 115) {
                        return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass(new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode46ranges__is__white__space__or__line__terminator, 0, _M0FP411moonbitlang6regexp8internal7unicode46ranges__is__white__space__or__line__terminator.length), false));
                      } else {
                        if (_c === 83) {
                          return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass(new _M0TPB9ArrayViewGcE(_M0FP411moonbitlang6regexp8internal7unicode51ranges__is__not__white__space__or__line__terminator, 0, _M0FP411moonbitlang6regexp8internal7unicode51ranges__is__not__white__space__or__line__terminator.length), false));
                        } else {
                          if (_c === 116) {
                            return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass(new _M0TPB9ArrayViewGcE(_M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN7_2abindS507, 0, 2), false));
                          } else {
                            if (_c === 110) {
                              return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass(new _M0TPB9ArrayViewGcE(_M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN7_2abindS508, 0, 2), false));
                            } else {
                              if (_c === 118) {
                                return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass(new _M0TPB9ArrayViewGcE(_M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN7_2abindS509, 0, 2), false));
                              } else {
                                if (_c === 102) {
                                  return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass(new _M0TPB9ArrayViewGcE(_M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN7_2abindS510, 0, 2), false));
                                } else {
                                  if (_c === 114) {
                                    return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass(new _M0TPB9ArrayViewGcE(_M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN7_2abindS511, 0, 2), false));
                                  } else {
                                    if (_c === 112) {
                                      flag = _c;
                                      break _L$4;
                                    } else {
                                      if (_c === 80) {
                                        flag = _c;
                                        break _L$4;
                                      } else {
                                        if (_c === 117) {
                                          const _bind$8 = _M0MP411moonbitlang6regexp8internal5parse6Parser22parse__unicode__escape(self);
                                          let unicode_char;
                                          if (_bind$8.$tag === 1) {
                                            const _ok = _bind$8;
                                            unicode_char = _ok._0;
                                          } else {
                                            return _bind$8;
                                          }
                                          const _bind$9 = [unicode_char, unicode_char];
                                          return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass(new _M0TPB9ArrayViewGcE(_bind$9, 0, 2), false));
                                        } else {
                                          if (_c === 48) {
                                            _L$5: {
                                              if (_M0MPC16string6String24char__length__ge_2einner(_bind$4, 1, _bind$6, _bind$7)) {
                                                const _x$2 = _M0MPC16string6String16unsafe__char__at(_bind$4, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$4, 0, _bind$6, _bind$7));
                                                if (_x$2 >= 48 && _x$2 <= 57) {
                                                  return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(2, escape));
                                                } else {
                                                  break _L$5;
                                                }
                                              } else {
                                                break _L$5;
                                              }
                                            }
                                            self.input = _x;
                                            return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass(new _M0TPB9ArrayViewGcE(_M0MP411moonbitlang6regexp8internal5parse6Parser13parse__factorN7_2abindS513, 0, 2), false));
                                          } else {
                                            if (_c >= 49 && _c <= 57) {
                                              let input = self.input;
                                              let capture = _c - 48 | 0;
                                              while (true) {
                                                const _bind$8 = input;
                                                if (_M0MPC16string6String24char__length__ge_2einner(_bind$8.str, 1, _bind$8.start, _bind$8.end)) {
                                                  const _x$2 = _M0MPC16string6String16unsafe__char__at(_bind$8.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$8.str, 0, _bind$8.start, _bind$8.end));
                                                  if (_x$2 >= 48 && _x$2 <= 57) {
                                                    const _tmp$38 = _bind$8.str;
                                                    const _bind$9 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$8.str, 1, _bind$8.start, _bind$8.end);
                                                    let _tmp$39;
                                                    if (_bind$9 === undefined) {
                                                      _tmp$39 = _bind$8.end;
                                                    } else {
                                                      const _Some = _bind$9;
                                                      _tmp$39 = _Some;
                                                    }
                                                    const _x$3 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$8.end);
                                                    capture = (Math.imul(capture, 10) | 0) + (_x$2 - 48 | 0) | 0;
                                                    input = _x$3;
                                                    continue;
                                                  } else {
                                                    break;
                                                  }
                                                } else {
                                                  break;
                                                }
                                              }
                                              self.input = input;
                                              self.has_backreference = true;
                                              if (_M0MPC13set3Set8containsGiE(self.current_capture_scope, capture)) {
                                                return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(2, escape));
                                              } else {
                                                if (capture >= self.captures) {
                                                  return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(2, escape));
                                                }
                                              }
                                              return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast13Backreference(capture));
                                            } else {
                                              if (_c === 107) {
                                                _L$5: {
                                                  const _bind$8 = self.input;
                                                  if (_M0MPC16string6String24char__length__ge_2einner(_bind$8.str, 1, _bind$8.start, _bind$8.end)) {
                                                    const _x$2 = _M0MPC16string6String16unsafe__char__at(_bind$8.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$8.str, 0, _bind$8.start, _bind$8.end));
                                                    if (_x$2 === 60) {
                                                      const _tmp$38 = _bind$8.str;
                                                      const _bind$9 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$8.str, 1, _bind$8.start, _bind$8.end);
                                                      let _tmp$39;
                                                      if (_bind$9 === undefined) {
                                                        _tmp$39 = _bind$8.end;
                                                      } else {
                                                        const _Some = _bind$9;
                                                        _tmp$39 = _Some;
                                                      }
                                                      const _x$3 = new _M0TPC16string10StringView(_tmp$38, _tmp$39, _bind$8.end);
                                                      self.input = _x$3;
                                                      const _bind$10 = _M0MP411moonbitlang6regexp8internal5parse6Parser18parse__group__name(self);
                                                      let name;
                                                      if (_bind$10.$tag === 1) {
                                                        const _ok = _bind$10;
                                                        name = _ok._0;
                                                      } else {
                                                        return _bind$10;
                                                      }
                                                      _L$6: {
                                                        const _bind$11 = self.input;
                                                        if (_M0MPC16string6String24char__length__ge_2einner(_bind$11.str, 1, _bind$11.start, _bind$11.end)) {
                                                          const _x$4 = _M0MPC16string6String16unsafe__char__at(_bind$11.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$11.str, 0, _bind$11.start, _bind$11.end));
                                                          if (_x$4 === 62) {
                                                            const _tmp$40 = _bind$11.str;
                                                            const _bind$12 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$11.str, 1, _bind$11.start, _bind$11.end);
                                                            let _tmp$41;
                                                            if (_bind$12 === undefined) {
                                                              _tmp$41 = _bind$11.end;
                                                            } else {
                                                              const _Some = _bind$12;
                                                              _tmp$41 = _Some;
                                                            }
                                                            const _x$5 = new _M0TPC16string10StringView(_tmp$40, _tmp$41, _bind$11.end);
                                                            self.input = _x$5;
                                                            const _bind$13 = _M0MPB3Map3getGsiE(self.capture_map, name);
                                                            if (_bind$13 === undefined) {
                                                              return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(2, escape));
                                                            } else {
                                                              const _Some = _bind$13;
                                                              const _capture = _Some;
                                                              self.has_backreference = true;
                                                              if (_M0MPC13set3Set8containsGiE(self.current_capture_scope, _capture)) {
                                                                return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(2, escape));
                                                              } else {
                                                                if (_capture >= self.captures) {
                                                                  return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(2, escape));
                                                                }
                                                              }
                                                              return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast13Backreference(_capture));
                                                            }
                                                          } else {
                                                            break _L$6;
                                                          }
                                                        } else {
                                                          break _L$6;
                                                        }
                                                      }
                                                      return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(2, self.input));
                                                    } else {
                                                      break _L$5;
                                                    }
                                                  } else {
                                                    break _L$5;
                                                  }
                                                }
                                                return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(2, self.input));
                                              } else {
                                                if (_c === 99) {
                                                  return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(2, self.input));
                                                } else {
                                                  if (self.flags.ignore_case) {
                                                    const _bind$8 = [_c, _c];
                                                    return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass(_M0FP411moonbitlang6regexp8internal7unicode30case__insensitive__char__class(new _M0TPB9ArrayViewGcE(_bind$8, 0, 2)), false));
                                                  } else {
                                                    const _bind$8 = [_c, _c];
                                                    return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass(new _M0TPB9ArrayViewGcE(_bind$8, 0, 2), false));
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        const _bind$8 = _M0MP411moonbitlang6regexp8internal5parse6Parser24parse__unicode__property(self);
        let property_name;
        if (_bind$8.$tag === 1) {
          const _ok = _bind$8;
          property_name = _ok._0;
        } else {
          return _bind$8;
        }
        return _M0MP411moonbitlang6regexp8internal5parse6Parser24parse__general__category(self, property_name, flag === 80);
      } else {
        return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(9, self.input));
      }
    }
    return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(2, self.input));
  }
  self.input = rest;
  if (self.flags.ignore_case) {
    const _bind$4 = [c, c];
    return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass(_M0FP411moonbitlang6regexp8internal7unicode30case__insensitive__char__class(new _M0TPB9ArrayViewGcE(_bind$4, 0, 2)), false));
  } else {
    const _bind$4 = [c, c];
    return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal3ast3AstRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0DTP411moonbitlang6regexp8internal3ast3Ast9CharClass(new _M0TPB9ArrayViewGcE(_bind$4, 0, 2), false));
  }
}
function _M0FP411moonbitlang6regexp8internal5parse13parse_2einner(regex, flags) {
  const parser = _M0MP411moonbitlang6regexp8internal5parse6Parser3new(regex, flags);
  const _bind$4 = _M0MP411moonbitlang6regexp8internal5parse6Parser17parse__expression(parser);
  let result;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    result = _ok._0;
  } else {
    return _bind$4;
  }
  const _bind$5 = parser.input;
  if (_M0MPC16string6String24char__length__ge_2einner(_bind$5.str, 1, _bind$5.start, _bind$5.end)) {
    const _x = _M0MPC16string6String16unsafe__char__at(_bind$5.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$5.str, 0, _bind$5.start, _bind$5.end));
    if (_x === 41) {
      return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal5parse11ParseResultRP411moonbitlang6regexp8internal5parse11RegexpErrorE3Err(new _M0DTPC15error5Error67moonbitlang_2fregexp_2finternal_2fparse_2eRegexpError_2eRegexpError(10, parser.input));
    }
  }
  const _bind$6 = parser.capture_map;
  const _bind$7 = parser.captures;
  const _bind$8 = parser.has_backreference;
  return new _M0DTPC16result6ResultGRP411moonbitlang6regexp8internal5parse11ParseResultRP411moonbitlang6regexp8internal5parse11RegexpErrorE2Ok(new _M0TP411moonbitlang6regexp8internal5parse11ParseResult(result, _bind$7, _bind$6, _bind$8));
}
function _M0IP211moonbitlang6regexp3ErrPB4Show6output(_x_67, _x_68) {
  switch (_x_67) {
    case 0: {
      _x_68.method_table.method_0(_x_68.self, "InternalError");
      return;
    }
    case 1: {
      _x_68.method_table.method_0(_x_68.self, "InvalidCharClass");
      return;
    }
    case 2: {
      _x_68.method_table.method_0(_x_68.self, "InvalidEscape");
      return;
    }
    case 3: {
      _x_68.method_table.method_0(_x_68.self, "InvalidNamedCapture");
      return;
    }
    case 4: {
      _x_68.method_table.method_0(_x_68.self, "InvalidRepeatOp");
      return;
    }
    case 5: {
      _x_68.method_table.method_0(_x_68.self, "InvalidRepeatSize");
      return;
    }
    case 6: {
      _x_68.method_table.method_0(_x_68.self, "MissingBracket");
      return;
    }
    case 7: {
      _x_68.method_table.method_0(_x_68.self, "MissingParenthesis");
      return;
    }
    case 8: {
      _x_68.method_table.method_0(_x_68.self, "MissingRepeatArgument");
      return;
    }
    case 9: {
      _x_68.method_table.method_0(_x_68.self, "TrailingBackslash");
      return;
    }
    default: {
      _x_68.method_table.method_0(_x_68.self, "UnexpectedParenthesis");
      return;
    }
  }
}
function _M0IP211moonbitlang6regexp11RegexpErrorPB4Show6output(_x_59, _x_60) {
  const _RegexpError = _x_59;
  const _$42$arg_61 = _RegexpError._0;
  const _$42$arg_62 = _RegexpError._1;
  _x_60.method_table.method_0(_x_60.self, "RegexpError(");
  _x_60.method_table.method_0(_x_60.self, "err=");
  _M0MPB6Logger13write__objectGRP211moonbitlang6regexp3ErrE(_x_60, _$42$arg_61);
  _x_60.method_table.method_0(_x_60.self, ", ");
  _x_60.method_table.method_0(_x_60.self, "source_fragment=");
  _M0MPB6Logger13write__objectGRPC16string10StringViewE(_x_60, _$42$arg_62);
  _x_60.method_table.method_0(_x_60.self, ")");
}
function _M0EP411moonbitlang6regexp8internal5parse11ParseResultP211moonbitlang6regexp7compile(self) {
  return new _M0TP211moonbitlang6regexp6Regexp(_M0MP411moonbitlang6regexp8internal3ast3Ast7compile(self.ast), self.capture_map, self.captures, self.has_backreference);
}
function _M0FP211moonbitlang6regexp15compile_2einner(regexp, flags) {
  let _try_err;
  _L: {
    const _bind$4 = _M0FP411moonbitlang6regexp8internal5parse13parse_2einner(regexp, new _M0TP411moonbitlang6regexp8internal5parse5Flags(_M0MPC16string10StringView8contains(flags, new _M0TPC16string10StringView(_M0FP211moonbitlang6regexp15compile_2einnerN7_2abindS94, 0, _M0FP211moonbitlang6regexp15compile_2einnerN7_2abindS94.length)), _M0MPC16string10StringView8contains(flags, new _M0TPC16string10StringView(_M0FP211moonbitlang6regexp15compile_2einnerN7_2abindS95, 0, _M0FP211moonbitlang6regexp15compile_2einnerN7_2abindS95.length)), _M0MPC16string10StringView8contains(flags, new _M0TPC16string10StringView(_M0FP211moonbitlang6regexp15compile_2einnerN7_2abindS96, 0, _M0FP211moonbitlang6regexp15compile_2einnerN7_2abindS96.length))));
    let _tmp$38;
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _tmp$38 = _ok._0;
    } else {
      const _err = _bind$4;
      _try_err = _err._0;
      break _L;
    }
    return new _M0DTPC16result6ResultGRP211moonbitlang6regexp6RegexpRP211moonbitlang6regexp11RegexpErrorE2Ok(_M0EP411moonbitlang6regexp8internal5parse11ParseResultP211moonbitlang6regexp7compile(_tmp$38));
  }
  const _RegexpError = _try_err;
  const _err = _RegexpError._0;
  const _source_fragment = _RegexpError._1;
  let err;
  switch (_err) {
    case 0: {
      err = 0;
      break;
    }
    case 1: {
      err = 1;
      break;
    }
    case 2: {
      err = 2;
      break;
    }
    case 3: {
      err = 3;
      break;
    }
    case 4: {
      err = 4;
      break;
    }
    case 5: {
      err = 5;
      break;
    }
    case 6: {
      err = 6;
      break;
    }
    case 7: {
      err = 7;
      break;
    }
    case 8: {
      err = 8;
      break;
    }
    case 9: {
      err = 9;
      break;
    }
    default: {
      err = 10;
    }
  }
  return new _M0DTPC16result6ResultGRP211moonbitlang6regexp6RegexpRP211moonbitlang6regexp11RegexpErrorE3Err(new _M0DTPC15error5Error48moonbitlang_2fregexp_2eRegexpError_2eRegexpError(err, _source_fragment));
}
function _M0FP211moonbitlang6regexp7compile(regexp, flags$46$opt) {
  let flags;
  if (flags$46$opt === undefined) {
    flags = new _M0TPC16string10StringView(_M0FP211moonbitlang6regexp7compileN7_2abindS89, 0, _M0FP211moonbitlang6regexp7compileN7_2abindS89.length);
  } else {
    const _Some = flags$46$opt;
    flags = _Some;
  }
  return _M0FP211moonbitlang6regexp15compile_2einner(regexp, flags);
}
function _M0MP211moonbitlang6regexp6Regexp7execute(self, input) {
  const captures = _M0FP411moonbitlang6regexp8internal2vm10vm_2einner(self.instructions, input, self.capture, self.allow_exponentiaion);
  let before;
  let after;
  _L: {
    _L$2: {
      if (captures.length >= 2) {
        const _x = captures[0];
        if (_x >= 0) {
          const _x$2 = captures[1];
          if (_x$2 >= 0) {
            before = _M0MPC16string10StringView12view_2einner(input, 0, _x);
            after = _M0MPC16string10StringView12view_2einner(input, _x$2, undefined);
            break _L;
          } else {
            break _L$2;
          }
        } else {
          break _L$2;
        }
      } else {
        break _L$2;
      }
    }
    before = input;
    after = _M0MPC16string10StringView12view_2einner(input, input.end - input.start | 0, undefined);
    break _L;
  }
  return new _M0TP211moonbitlang6regexp11MatchResult(input, captures, self.map, before, after);
}
function _M0MP211moonbitlang6regexp11MatchResult3get(self, index) {
  let _tmp$38;
  const _p$4 = self.captures;
  if (_p$4.length === 0) {
    _tmp$38 = true;
  } else {
    _tmp$38 = index < 0 || index >= (self.captures.length / 2 | 0);
  }
  if (_tmp$38) {
    return undefined;
  }
  const start = _M0MPC15array5Array2atGiE(self.captures, Math.imul(index, 2) | 0);
  const end = _M0MPC15array5Array2atGiE(self.captures, (Math.imul(index, 2) | 0) + 1 | 0);
  let _tmp$39;
  if (start < 0) {
    _tmp$39 = true;
  } else {
    let _tmp$40;
    if (end < start) {
      _tmp$40 = true;
    } else {
      const _p$5 = self.input;
      _tmp$40 = end > (_p$5.end - _p$5.start | 0);
    }
    _tmp$39 = _tmp$40;
  }
  if (_tmp$39) {
    return undefined;
  }
  return _M0MPC16string10StringView12view_2einner(self.input, start, end);
}
function _M0FP410Haoxincode8moonbash3lib5regex22decode__regex__escapes(pattern) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  while (true) {
    if (i < pattern.length) {
      const _tmp$38 = i;
      $bound_check(pattern, _tmp$38);
      const ch = pattern.charCodeAt(_tmp$38);
      if (ch === 92 && (i + 1 | 0) < pattern.length) {
        const _tmp$39 = i + 1 | 0;
        $bound_check(pattern, _tmp$39);
        const next = pattern.charCodeAt(_tmp$39);
        switch (next) {
          case 110: {
            _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
            break;
          }
          case 116: {
            _M0IPB13StringBuilderPB6Logger11write__char(out, 9);
            break;
          }
          case 114: {
            _M0IPB13StringBuilderPB6Logger11write__char(out, 13);
            break;
          }
          default: {
            _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
            _M0IPB13StringBuilderPB6Logger11write__char(out, next);
          }
        }
        i = i + 2 | 0;
        continue;
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib5regex35is__valid__posix__char__class__name(name) {
  return name === "alnum" || (name === "alpha" || (name === "ascii" || (name === "blank" || (name === "cntrl" || (name === "digit" || (name === "graph" || (name === "lower" || (name === "print" || (name === "punct" || (name === "space" || (name === "upper" || (name === "word" || (name === "xdigit" || (name === "<" || name === ">"))))))))))))));
}
function _M0FP410Haoxincode8moonbash3lib5regex40has__invalid__posix__char__class__syntax(pattern) {
  let i = 0;
  let in_char_class = false;
  let class_has_member = false;
  let class_allow_negation = false;
  while (true) {
    if (i < pattern.length) {
      const _tmp$38 = i;
      $bound_check(pattern, _tmp$38);
      const ch = pattern.charCodeAt(_tmp$38);
      if (ch === 92) {
        if ((i + 1 | 0) < pattern.length) {
          if (in_char_class) {
            class_has_member = true;
            class_allow_negation = false;
          }
          i = i + 2 | 0;
        } else {
          i = i + 1 | 0;
        }
        continue;
      }
      if (in_char_class) {
        if (class_allow_negation && ch === 94) {
          class_allow_negation = false;
          i = i + 1 | 0;
          continue;
        }
        let _tmp$39;
        if (ch === 91) {
          let _tmp$40;
          if ((i + 1 | 0) < pattern.length) {
            const _tmp$41 = i + 1 | 0;
            $bound_check(pattern, _tmp$41);
            _tmp$40 = pattern.charCodeAt(_tmp$41) === 58;
          } else {
            _tmp$40 = false;
          }
          _tmp$39 = _tmp$40;
        } else {
          _tmp$39 = false;
        }
        if (_tmp$39) {
          let j = i + 2 | 0;
          let found_close = false;
          while (true) {
            if ((j + 1 | 0) < pattern.length) {
              let _tmp$40;
              const _tmp$41 = j;
              $bound_check(pattern, _tmp$41);
              if (pattern.charCodeAt(_tmp$41) === 58) {
                const _tmp$42 = j + 1 | 0;
                $bound_check(pattern, _tmp$42);
                _tmp$40 = pattern.charCodeAt(_tmp$42) === 93;
              } else {
                _tmp$40 = false;
              }
              if (_tmp$40) {
                found_close = true;
                const name = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(pattern, i + 2 | 0, j));
                if (!_M0FP410Haoxincode8moonbash3lib5regex35is__valid__posix__char__class__name(name)) {
                  return true;
                }
                class_has_member = true;
                class_allow_negation = false;
                i = j + 2 | 0;
                break;
              }
              j = j + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          if (!found_close) {
            return true;
          }
          continue;
        }
        if (ch === 93) {
          if (class_has_member) {
            in_char_class = false;
            class_has_member = false;
            class_allow_negation = false;
          } else {
            class_has_member = true;
            class_allow_negation = false;
          }
          i = i + 1 | 0;
          continue;
        }
        class_has_member = true;
        class_allow_negation = false;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 91) {
        in_char_class = true;
        class_has_member = false;
        class_allow_negation = true;
        i = i + 1 | 0;
        continue;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return in_char_class;
}
function _M0FP410Haoxincode8moonbash3lib5regex22bre__caret__is__anchor(pattern, idx) {
  if (idx === 0) {
    return true;
  }
  let _tmp$38;
  if (idx >= 2) {
    const _tmp$39 = idx - 2 | 0;
    $bound_check(pattern, _tmp$39);
    _tmp$38 = pattern.charCodeAt(_tmp$39) === 92;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    const _tmp$39 = idx - 1 | 0;
    $bound_check(pattern, _tmp$39);
    const prev = pattern.charCodeAt(_tmp$39);
    if (prev === 40 || prev === 124) {
      return true;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib5regex23bre__dollar__is__anchor(pattern, idx) {
  if (idx === (pattern.length - 1 | 0)) {
    return true;
  }
  let _tmp$38;
  if ((idx + 2 | 0) < pattern.length) {
    const _tmp$39 = idx + 1 | 0;
    $bound_check(pattern, _tmp$39);
    _tmp$38 = pattern.charCodeAt(_tmp$39) === 92;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    const _tmp$39 = idx + 2 | 0;
    $bound_check(pattern, _tmp$39);
    const next = pattern.charCodeAt(_tmp$39);
    if (next === 41 || next === 124) {
      return true;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib5regex29is__bre__literal__regex__char(ch) {
  return ch === 43 || (ch === 63 || (ch === 124 || (ch === 40 || (ch === 41 || (ch === 123 || ch === 125)))));
}
function _M0FP410Haoxincode8moonbash3lib5regex31is__bre__special__when__escaped(ch) {
  return ch === 43 || (ch === 63 || (ch === 124 || (ch === 40 || (ch === 41 || (ch === 123 || ch === 125)))));
}
function _M0FP410Haoxincode8moonbash3lib5regex23normalize__basic__regex(pattern) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  let in_char_class = false;
  let class_has_member = false;
  let class_allow_negation = false;
  while (true) {
    if (i < pattern.length) {
      const _tmp$38 = i;
      $bound_check(pattern, _tmp$38);
      const ch = pattern.charCodeAt(_tmp$38);
      if (ch === 92) {
        if ((i + 1 | 0) < pattern.length) {
          const _tmp$39 = i + 1 | 0;
          $bound_check(pattern, _tmp$39);
          const next = pattern.charCodeAt(_tmp$39);
          if (in_char_class) {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
            _M0IPB13StringBuilderPB6Logger11write__char(buf, next);
            class_has_member = true;
            class_allow_negation = false;
          } else {
            if (_M0FP410Haoxincode8moonbash3lib5regex31is__bre__special__when__escaped(next)) {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, next);
            } else {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
              _M0IPB13StringBuilderPB6Logger11write__char(buf, next);
            }
          }
          i = i + 2 | 0;
        } else {
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
          i = i + 1 | 0;
        }
      } else {
        if (in_char_class) {
          if (class_allow_negation && ch === 94) {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 94);
            class_allow_negation = false;
            i = i + 1 | 0;
            continue;
          }
          if (ch === 93) {
            if (class_has_member) {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, 93);
              in_char_class = false;
              class_has_member = false;
              class_allow_negation = false;
            } else {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, 93);
              class_has_member = true;
              class_allow_negation = false;
            }
            i = i + 1 | 0;
            continue;
          }
          _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
          class_has_member = true;
          class_allow_negation = false;
          i = i + 1 | 0;
          continue;
        }
        if (ch === 91) {
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 91);
          in_char_class = true;
          class_has_member = false;
          class_allow_negation = true;
          i = i + 1 | 0;
          continue;
        }
        if (_M0FP410Haoxincode8moonbash3lib5regex29is__bre__literal__regex__char(ch)) {
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
        } else {
          if (ch === 94 && !_M0FP410Haoxincode8moonbash3lib5regex22bre__caret__is__anchor(pattern, i)) {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
          } else {
            if (ch === 36 && !_M0FP410Haoxincode8moonbash3lib5regex23bre__dollar__is__anchor(pattern, i)) {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
            }
          }
        }
        _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function _M0FP410Haoxincode8moonbash3lib5regex16starts__with__at(text, token, idx) {
  if (idx < 0 || (idx + token.length | 0) > text.length) {
    return false;
  }
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < token.length) {
      const _tmp$39 = idx + i | 0;
      $bound_check(text, _tmp$39);
      const _p$4 = text.charCodeAt(_tmp$39);
      $bound_check(token, i);
      const _p$5 = token.charCodeAt(i);
      if (_p$4 !== _p$5) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0FP410Haoxincode8moonbash3lib5regex21replace__all__literal(input, needle, replacement) {
  if (needle.length === 0) {
    return input;
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  while (true) {
    if (i < input.length) {
      if (_M0FP410Haoxincode8moonbash3lib5regex16starts__with__at(input, needle, i)) {
        _M0IPB13StringBuilderPB6Logger13write__string(out, replacement);
        i = i + needle.length | 0;
      } else {
        const _tmp$38 = i;
        $bound_check(input, _tmp$38);
        _M0IPB13StringBuilderPB6Logger11write__char(out, input.charCodeAt(_tmp$38));
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib5regex31normalize__posix__char__classes(pattern) {
  let out = pattern;
  out = _M0FP410Haoxincode8moonbash3lib5regex21replace__all__literal(out, "[[:<:]]", "\\b");
  out = _M0FP410Haoxincode8moonbash3lib5regex21replace__all__literal(out, "[[:>:]]", "\\b");
  out = _M0FP410Haoxincode8moonbash3lib5regex21replace__all__literal(out, "[[:alnum:]]", "[A-Za-z0-9]");
  out = _M0FP410Haoxincode8moonbash3lib5regex21replace__all__literal(out, "[[:alpha:]]", "[A-Za-z]");
  out = _M0FP410Haoxincode8moonbash3lib5regex21replace__all__literal(out, "[[:ascii:]]", "[\\x00-\\x7F]");
  out = _M0FP410Haoxincode8moonbash3lib5regex21replace__all__literal(out, "[[:blank:]]", "[ \\t]");
  out = _M0FP410Haoxincode8moonbash3lib5regex21replace__all__literal(out, "[[:cntrl:]]", "[\\x00-\\x1F\\x7F]");
  out = _M0FP410Haoxincode8moonbash3lib5regex21replace__all__literal(out, "[[:digit:]]", "[0-9]");
  out = _M0FP410Haoxincode8moonbash3lib5regex21replace__all__literal(out, "[[:graph:]]", "[!-~]");
  out = _M0FP410Haoxincode8moonbash3lib5regex21replace__all__literal(out, "[[:lower:]]", "[a-z]");
  out = _M0FP410Haoxincode8moonbash3lib5regex21replace__all__literal(out, "[[:print:]]", "[ -~]");
  out = _M0FP410Haoxincode8moonbash3lib5regex21replace__all__literal(out, "[[:punct:]]", "[!-/:-@\\[-`{-~]");
  out = _M0FP410Haoxincode8moonbash3lib5regex21replace__all__literal(out, "[[:space:]]", "[ \\t\\n\\r]");
  out = _M0FP410Haoxincode8moonbash3lib5regex21replace__all__literal(out, "[[:upper:]]", "[A-Z]");
  out = _M0FP410Haoxincode8moonbash3lib5regex21replace__all__literal(out, "[[:word:]]", "[A-Za-z0-9_]");
  out = _M0FP410Haoxincode8moonbash3lib5regex21replace__all__literal(out, "[[:xdigit:]]", "[0-9A-Fa-f]");
  return out;
}
function _M0FP410Haoxincode8moonbash3lib5regex38normalize__char__class__initial__close(pattern) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  let in_char_class = false;
  let class_has_member = false;
  let class_allow_negation = false;
  while (true) {
    if (i < pattern.length) {
      const _tmp$38 = i;
      $bound_check(pattern, _tmp$38);
      const ch = pattern.charCodeAt(_tmp$38);
      if (ch === 92) {
        if ((i + 1 | 0) < pattern.length) {
          const _tmp$39 = i + 1 | 0;
          $bound_check(pattern, _tmp$39);
          const next = pattern.charCodeAt(_tmp$39);
          _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
          _M0IPB13StringBuilderPB6Logger11write__char(out, next);
          if (in_char_class) {
            class_has_member = true;
            class_allow_negation = false;
          }
          i = i + 2 | 0;
        } else {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
          i = i + 1 | 0;
        }
        continue;
      }
      if (in_char_class) {
        if (class_allow_negation && ch === 94) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 94);
          class_allow_negation = false;
          i = i + 1 | 0;
          continue;
        }
        if (ch === 93) {
          if (class_has_member) {
            _M0IPB13StringBuilderPB6Logger11write__char(out, 93);
            in_char_class = false;
            class_has_member = false;
            class_allow_negation = false;
          } else {
            _M0IPB13StringBuilderPB6Logger13write__string(out, "\\]");
            class_has_member = true;
            class_allow_negation = false;
          }
          i = i + 1 | 0;
          continue;
        }
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        class_has_member = true;
        class_allow_negation = false;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 91) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 91);
        in_char_class = true;
        class_has_member = false;
        class_allow_negation = true;
        i = i + 1 | 0;
        continue;
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib5regex23parse__interval__syntax(pattern, start) {
  let _tmp$38;
  if (start < 0) {
    _tmp$38 = true;
  } else {
    let _tmp$39;
    if (start >= pattern.length) {
      _tmp$39 = true;
    } else {
      $bound_check(pattern, start);
      _tmp$39 = pattern.charCodeAt(start) !== 123;
    }
    _tmp$38 = _tmp$39;
  }
  if (_tmp$38) {
    return undefined;
  }
  let i = start + 1 | 0;
  let lower_digits = 0;
  while (true) {
    let _tmp$39;
    if (i < pattern.length) {
      const _tmp$40 = i;
      $bound_check(pattern, _tmp$40);
      const _p$4 = pattern.charCodeAt(_tmp$40);
      _tmp$39 = _p$4 >= 48 && _p$4 <= 57;
    } else {
      _tmp$39 = false;
    }
    if (_tmp$39) {
      lower_digits = lower_digits + 1 | 0;
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (lower_digits === 0) {
    return undefined;
  }
  let _tmp$39;
  if (i < pattern.length) {
    const _tmp$40 = i;
    $bound_check(pattern, _tmp$40);
    _tmp$39 = pattern.charCodeAt(_tmp$40) === 125;
  } else {
    _tmp$39 = false;
  }
  if (_tmp$39) {
    return (i - start | 0) + 1 | 0;
  }
  let _tmp$40;
  if (i >= pattern.length) {
    _tmp$40 = true;
  } else {
    const _tmp$41 = i;
    $bound_check(pattern, _tmp$41);
    _tmp$40 = pattern.charCodeAt(_tmp$41) !== 44;
  }
  if (_tmp$40) {
    return undefined;
  }
  i = i + 1 | 0;
  while (true) {
    let _tmp$41;
    if (i < pattern.length) {
      const _tmp$42 = i;
      $bound_check(pattern, _tmp$42);
      const _p$4 = pattern.charCodeAt(_tmp$42);
      _tmp$41 = _p$4 >= 48 && _p$4 <= 57;
    } else {
      _tmp$41 = false;
    }
    if (_tmp$41) {
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let _tmp$41;
  if (i < pattern.length) {
    const _tmp$42 = i;
    $bound_check(pattern, _tmp$42);
    _tmp$41 = pattern.charCodeAt(_tmp$42) === 125;
  } else {
    _tmp$41 = false;
  }
  if (_tmp$41) {
    return (i - start | 0) + 1 | 0;
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib5regex36normalize__ere__malformed__intervals(pattern) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  let in_char_class = false;
  while (true) {
    if (i < pattern.length) {
      const _tmp$38 = i;
      $bound_check(pattern, _tmp$38);
      const ch = pattern.charCodeAt(_tmp$38);
      if (ch === 92) {
        if ((i + 1 | 0) < pattern.length) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
          const _tmp$39 = i + 1 | 0;
          $bound_check(pattern, _tmp$39);
          _M0IPB13StringBuilderPB6Logger11write__char(out, pattern.charCodeAt(_tmp$39));
          i = i + 2 | 0;
        } else {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
          i = i + 1 | 0;
        }
        continue;
      }
      if (in_char_class) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        if (ch === 93) {
          in_char_class = false;
        }
        i = i + 1 | 0;
        continue;
      }
      if (ch === 91) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 91);
        in_char_class = true;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 123) {
        const _bind$4 = _M0FP410Haoxincode8moonbash3lib5regex23parse__interval__syntax(pattern, i);
        if (_bind$4 === undefined) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
          _M0IPB13StringBuilderPB6Logger11write__char(out, 123);
          i = i + 1 | 0;
        } else {
          const _Some = _bind$4;
          const _length = _Some;
          let _tmp$39 = i;
          while (true) {
            const j = _tmp$39;
            if (j < (i + _length | 0)) {
              $bound_check(pattern, j);
              _M0IPB13StringBuilderPB6Logger11write__char(out, pattern.charCodeAt(j));
              _tmp$39 = j + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          i = i + _length | 0;
        }
        continue;
      }
      if (ch === 125) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
        _M0IPB13StringBuilderPB6Logger11write__char(out, 125);
        i = i + 1 | 0;
        continue;
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib5regex27parse__interval__quantifier(pattern, start, has_target) {
  if (!has_target) {
    return undefined;
  }
  let _tmp$38;
  if (start < 0) {
    _tmp$38 = true;
  } else {
    let _tmp$39;
    if (start >= pattern.length) {
      _tmp$39 = true;
    } else {
      $bound_check(pattern, start);
      _tmp$39 = pattern.charCodeAt(start) !== 123;
    }
    _tmp$38 = _tmp$39;
  }
  if (_tmp$38) {
    return undefined;
  }
  let i = start + 1 | 0;
  let lower_digits = 0;
  while (true) {
    let _tmp$39;
    if (i < pattern.length) {
      const _tmp$40 = i;
      $bound_check(pattern, _tmp$40);
      const _p$4 = pattern.charCodeAt(_tmp$40);
      _tmp$39 = _p$4 >= 48 && _p$4 <= 57;
    } else {
      _tmp$39 = false;
    }
    if (_tmp$39) {
      lower_digits = lower_digits + 1 | 0;
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (lower_digits === 0) {
    return undefined;
  }
  let _tmp$39;
  if (i < pattern.length) {
    const _tmp$40 = i;
    $bound_check(pattern, _tmp$40);
    _tmp$39 = pattern.charCodeAt(_tmp$40) === 125;
  } else {
    _tmp$39 = false;
  }
  if (_tmp$39) {
    return (i - start | 0) + 1 | 0;
  }
  let _tmp$40;
  if (i >= pattern.length) {
    _tmp$40 = true;
  } else {
    const _tmp$41 = i;
    $bound_check(pattern, _tmp$41);
    _tmp$40 = pattern.charCodeAt(_tmp$41) !== 44;
  }
  if (_tmp$40) {
    return undefined;
  }
  i = i + 1 | 0;
  while (true) {
    let _tmp$41;
    if (i < pattern.length) {
      const _tmp$42 = i;
      $bound_check(pattern, _tmp$42);
      const _p$4 = pattern.charCodeAt(_tmp$42);
      _tmp$41 = _p$4 >= 48 && _p$4 <= 57;
    } else {
      _tmp$41 = false;
    }
    if (_tmp$41) {
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let _tmp$41;
  if (i < pattern.length) {
    const _tmp$42 = i;
    $bound_check(pattern, _tmp$42);
    _tmp$41 = pattern.charCodeAt(_tmp$42) === 125;
  } else {
    _tmp$41 = false;
  }
  if (_tmp$41) {
    return (i - start | 0) + 1 | 0;
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib5regex39normalize__invalid__quantifiers_2einner(pattern, literalize_interval_errors) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  let in_char_class = false;
  let last_repeatable = false;
  while (true) {
    if (i < pattern.length) {
      const _tmp$38 = i;
      $bound_check(pattern, _tmp$38);
      const ch = pattern.charCodeAt(_tmp$38);
      if (ch === 92) {
        if ((i + 1 | 0) < pattern.length) {
          const _tmp$39 = i + 1 | 0;
          $bound_check(pattern, _tmp$39);
          const next = pattern.charCodeAt(_tmp$39);
          _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
          _M0IPB13StringBuilderPB6Logger11write__char(out, next);
          if (in_char_class) {
            last_repeatable = true;
          } else {
            if (next === 98 || (next === 66 || (next === 65 || (next === 90 || next === 122)))) {
              last_repeatable = false;
            } else {
              last_repeatable = true;
            }
          }
          i = i + 2 | 0;
        } else {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
          i = i + 1 | 0;
        }
        continue;
      }
      if (in_char_class) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        if (ch === 93) {
          in_char_class = false;
          last_repeatable = true;
        }
        i = i + 1 | 0;
        continue;
      }
      if (ch === 91) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 91);
        in_char_class = true;
        last_repeatable = false;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 40) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 40);
        last_repeatable = false;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 124) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 124);
        last_repeatable = false;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 94 || ch === 36) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        last_repeatable = false;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 42 || (ch === 43 || ch === 63)) {
        if (last_repeatable) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        } else {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
          _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        }
        last_repeatable = true;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 123) {
        const _bind$4 = _M0FP410Haoxincode8moonbash3lib5regex27parse__interval__quantifier(pattern, i, last_repeatable);
        if (_bind$4 === undefined) {
          if (literalize_interval_errors) {
            _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
          }
          _M0IPB13StringBuilderPB6Logger11write__char(out, 123);
          last_repeatable = literalize_interval_errors;
          i = i + 1 | 0;
        } else {
          const _Some = _bind$4;
          const _length = _Some;
          let _tmp$39 = i;
          while (true) {
            const j = _tmp$39;
            if (j < (i + _length | 0)) {
              $bound_check(pattern, j);
              _M0IPB13StringBuilderPB6Logger11write__char(out, pattern.charCodeAt(j));
              _tmp$39 = j + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          last_repeatable = true;
          i = i + _length | 0;
        }
        continue;
      }
      if (ch === 125) {
        if (literalize_interval_errors) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
        }
        _M0IPB13StringBuilderPB6Logger11write__char(out, 125);
        last_repeatable = literalize_interval_errors;
        i = i + 1 | 0;
        continue;
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      last_repeatable = true;
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib5regex32normalize__regex__compat_2einner(pattern, extended) {
  const with_lower_bound = _M0FP410Haoxincode8moonbash3lib5regex21replace__all__literal(pattern, "{,", "{0,");
  const with_normalized_classes = _M0FP410Haoxincode8moonbash3lib5regex38normalize__char__class__initial__close(with_lower_bound);
  return extended ? _M0FP410Haoxincode8moonbash3lib5regex36normalize__ere__malformed__intervals(with_normalized_classes) : _M0FP410Haoxincode8moonbash3lib5regex39normalize__invalid__quantifiers_2einner(with_normalized_classes, false);
}
function _M0FP410Haoxincode8moonbash3lib5regex21raise__invalid__regex() {
  const _bind$4 = _M0FP211moonbitlang6regexp7compile(new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib5regex21raise__invalid__regexN7_2abindS196, 0, _M0FP410Haoxincode8moonbash3lib5regex21raise__invalid__regexN7_2abindS196.length), undefined);
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    _ok._0;
  } else {
    return _bind$4;
  }
  return new _M0DTPC16result6ResultGuRP211moonbitlang6regexp11RegexpErrorE2Ok(undefined);
}
function _M0FP410Haoxincode8moonbash3lib5regex22ere__caret__is__anchor(pattern, idx) {
  if (idx === 0) {
    return true;
  }
  const _tmp$38 = idx - 1 | 0;
  $bound_check(pattern, _tmp$38);
  const prev = pattern.charCodeAt(_tmp$38);
  return prev === 40 || prev === 124;
}
function _M0FP410Haoxincode8moonbash3lib5regex23regex__has__bol__anchor(pattern) {
  let i = 0;
  let in_char_class = false;
  while (true) {
    if (i < pattern.length) {
      const _tmp$38 = i;
      $bound_check(pattern, _tmp$38);
      const ch = pattern.charCodeAt(_tmp$38);
      if (ch === 92) {
        if ((i + 1 | 0) < pattern.length) {
          i = i + 2 | 0;
        } else {
          i = i + 1 | 0;
        }
        continue;
      }
      if (in_char_class) {
        if (ch === 93) {
          in_char_class = false;
        }
        i = i + 1 | 0;
        continue;
      }
      if (ch === 91) {
        in_char_class = true;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 94 && _M0FP410Haoxincode8moonbash3lib5regex22ere__caret__is__anchor(pattern, i)) {
        return true;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib5regex16to__lower__ascii(s) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      if (ch >= 65 && ch <= 90) {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, ch + 32 | 0);
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function _M0FP410Haoxincode8moonbash3lib5regex30compile__grep__matcher_2einner(pattern, extended, fixed, ignore_case) {
  if (fixed) {
    const fixed_pattern = ignore_case ? _M0FP410Haoxincode8moonbash3lib5regex16to__lower__ascii(pattern) : pattern;
    return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib5regex11GrepMatcherRP211moonbitlang6regexp11RegexpErrorE2Ok(new _M0DTP410Haoxincode8moonbash3lib5regex11GrepMatcher5Fixed(fixed_pattern, ignore_case));
  }
  const decoded_pattern = _M0FP410Haoxincode8moonbash3lib5regex22decode__regex__escapes(extended ? pattern : _M0FP410Haoxincode8moonbash3lib5regex23normalize__basic__regex(pattern));
  if (_M0FP410Haoxincode8moonbash3lib5regex40has__invalid__posix__char__class__syntax(decoded_pattern)) {
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib5regex21raise__invalid__regex();
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      _ok._0;
    } else {
      return _bind$4;
    }
  }
  const normalized = _M0FP410Haoxincode8moonbash3lib5regex32normalize__regex__compat_2einner(_M0FP410Haoxincode8moonbash3lib5regex31normalize__posix__char__classes(decoded_pattern), extended);
  const has_bol_anchor = _M0FP410Haoxincode8moonbash3lib5regex23regex__has__bol__anchor(normalized);
  const flags = ignore_case ? "i" : "";
  const _bind$4 = _M0FP211moonbitlang6regexp15compile_2einner(new _M0TPC16string10StringView(normalized, 0, normalized.length), new _M0TPC16string10StringView(flags, 0, flags.length));
  let compiled;
  if (_bind$4.$tag === 1) {
    const _ok = _bind$4;
    compiled = _ok._0;
  } else {
    return _bind$4;
  }
  return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib5regex11GrepMatcherRP211moonbitlang6regexp11RegexpErrorE2Ok(new _M0DTP410Haoxincode8moonbash3lib5regex11GrepMatcher5Regex(compiled, has_bol_anchor));
}
function _M0FP410Haoxincode8moonbash3lib5regex27accept__shifted__bol__start(re, segment) {
  const _bind$4 = `/${segment}`;
  const probe_one = _M0MP211moonbitlang6regexp6Regexp7execute(re, new _M0TPC16string10StringView(_bind$4, 0, _bind$4.length));
  const _p$4 = probe_one.captures;
  if (!!(_p$4.length === 0)) {
    return false;
  }
  const _p$5 = probe_one.before;
  const before_one = _p$5.end - _p$5.start | 0;
  if (before_one === 1) {
    return true;
  }
  if (before_one !== 0) {
    return false;
  }
  const _bind$5 = `//${segment}`;
  const probe_two = _M0MP211moonbitlang6regexp6Regexp7execute(re, new _M0TPC16string10StringView(_bind$5, 0, _bind$5.length));
  const _p$6 = probe_two.captures;
  if (!(_p$6.length === 0)) {
    const _p$7 = probe_two.before;
    return (_p$7.end - _p$7.start | 0) > 0;
  } else {
    return false;
  }
}
function _M0FP410Haoxincode8moonbash3lib5regex21find__substring__from(haystack, needle, start) {
  if (needle.length === 0) {
    return start;
  }
  if (start < 0 || (needle.length > haystack.length || start > (haystack.length - needle.length | 0))) {
    return -1;
  }
  let i = start;
  while (true) {
    if (i <= (haystack.length - needle.length | 0)) {
      let found = true;
      let _tmp$38 = 0;
      while (true) {
        const j = _tmp$38;
        if (j < needle.length) {
          const _tmp$39 = i + j | 0;
          $bound_check(haystack, _tmp$39);
          const _p$4 = haystack.charCodeAt(_tmp$39);
          $bound_check(needle, j);
          const _p$5 = needle.charCodeAt(j);
          if (_p$4 !== _p$5) {
            found = false;
            break;
          }
          _tmp$38 = j + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      if (found) {
        return i;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0MP410Haoxincode8moonbash3lib5regex11GrepMatcher19find__first_2einner(self, line, start) {
  if (self.$tag === 0) {
    const _Fixed = self;
    const _pattern = _Fixed._0;
    const _ignore_case = _Fixed._1;
    if (start < 0 || start > line.length) {
      return undefined;
    }
    const line_for_search = _ignore_case ? _M0FP410Haoxincode8moonbash3lib5regex16to__lower__ascii(line) : line;
    const idx = _M0FP410Haoxincode8moonbash3lib5regex21find__substring__from(line_for_search, _pattern, start);
    return idx < 0 ? undefined : { _0: idx, _1: idx + _pattern.length | 0 };
  } else {
    const _Regex = self;
    const _re = _Regex._0;
    const _has_bol_anchor = _Regex._1;
    if (start < 0 || start > line.length) {
      return undefined;
    }
    let cursor = start;
    while (true) {
      if (cursor <= line.length) {
        const segment = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(line, cursor, undefined));
        const result = _M0MP211moonbitlang6regexp6Regexp7execute(_re, new _M0TPC16string10StringView(segment, 0, segment.length));
        const _p$4 = result.captures;
        if (!!(_p$4.length === 0)) {
          return undefined;
        }
        const _p$5 = result.before;
        const before_len = _p$5.end - _p$5.start | 0;
        if (before_len === 0 && (cursor > 0 && (_has_bol_anchor && !_M0FP410Haoxincode8moonbash3lib5regex27accept__shifted__bol__start(_re, segment)))) {
          cursor = cursor + 1 | 0;
          continue;
        }
        const _bind$4 = _M0MP211moonbitlang6regexp11MatchResult3get(result, 0);
        if (_bind$4 === undefined) {
          return undefined;
        } else {
          const _Some = _bind$4;
          const _matched = _Some;
          const begin = cursor + before_len | 0;
          return { _0: begin, _1: begin + (_matched.end - _matched.start | 0) | 0 };
        }
      } else {
        break;
      }
    }
    return undefined;
  }
}
function _M0MP410Haoxincode8moonbash3lib5regex11GrepMatcher33find__first__with__groups_2einner(self, line, start) {
  if (self.$tag === 0) {
    const _Fixed = self;
    const _pattern = _Fixed._0;
    const _ignore_case = _Fixed._1;
    if (start < 0 || start > line.length) {
      return undefined;
    }
    const line_for_search = _ignore_case ? _M0FP410Haoxincode8moonbash3lib5regex16to__lower__ascii(line) : line;
    const idx = _M0FP410Haoxincode8moonbash3lib5regex21find__substring__from(line_for_search, _pattern, start);
    return idx < 0 ? undefined : { _0: idx, _1: idx + _pattern.length | 0, _2: [] };
  } else {
    const _Regex = self;
    const _re = _Regex._0;
    const _has_bol_anchor = _Regex._1;
    if (start < 0 || start > line.length) {
      return undefined;
    }
    let cursor = start;
    while (true) {
      if (cursor <= line.length) {
        const segment = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(line, cursor, undefined));
        const result = _M0MP211moonbitlang6regexp6Regexp7execute(_re, new _M0TPC16string10StringView(segment, 0, segment.length));
        const _p$4 = result.captures;
        if (!!(_p$4.length === 0)) {
          return undefined;
        }
        const _p$5 = result.before;
        const before_len = _p$5.end - _p$5.start | 0;
        if (before_len === 0 && (cursor > 0 && (_has_bol_anchor && !_M0FP410Haoxincode8moonbash3lib5regex27accept__shifted__bol__start(_re, segment)))) {
          cursor = cursor + 1 | 0;
          continue;
        }
        const _bind$4 = _M0MP211moonbitlang6regexp11MatchResult3get(result, 0);
        if (_bind$4 === undefined) {
          return undefined;
        } else {
          const _Some = _bind$4;
          const _matched = _Some;
          const groups = [];
          let group_idx = 1;
          let done = false;
          while (true) {
            if (!done) {
              const _bind$5 = _M0MP211moonbitlang6regexp11MatchResult3get(result, group_idx);
              if (_bind$5 === undefined) {
                done = true;
              } else {
                const _Some$2 = _bind$5;
                const _group_text = _Some$2;
                _M0MPC15array5Array4pushGUssEE(groups, _M0MPC16string10StringView9to__owned(_group_text));
                group_idx = group_idx + 1 | 0;
              }
              continue;
            } else {
              break;
            }
          }
          const begin = cursor + before_len | 0;
          return { _0: begin, _1: begin + (_matched.end - _matched.start | 0) | 0, _2: groups };
        }
      } else {
        break;
      }
    }
    return undefined;
  }
}
function _M0MP410Haoxincode8moonbash3lib5regex11GrepMatcher9find__all(self, line) {
  const ranges = [];
  let start = 0;
  while (true) {
    if (start <= line.length) {
      const _bind$4 = _M0MP410Haoxincode8moonbash3lib5regex11GrepMatcher19find__first_2einner(self, line, start);
      if (_bind$4 === undefined) {
        break;
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        const _s = _x._0;
        const _e = _x._1;
        _M0MPC15array5Array4pushGUssEE(ranges, { _0: _s, _1: _e });
        if (_e > _s) {
          start = _e;
        } else {
          break;
        }
      }
      continue;
    } else {
      break;
    }
  }
  return ranges;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter18skip__ascii__space(s, start) {
  let i = start;
  while (true) {
    if (i < s.length) {
      const _tmp$38 = i;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch === 32 || (ch === 9 || (ch === 10 || ch === 13))) {
        i = i + 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  return i;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(s, start, end) {
  if (start >= end || (start < 0 || end > s.length)) {
    return "";
  }
  return _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(s, start, end));
}
function _M0FP410Haoxincode8moonbash3lib11interpreter17trim__ascii__left(s) {
  const i = _M0FP410Haoxincode8moonbash3lib11interpreter18skip__ascii__space(s, 0);
  return i <= 0 ? s : i >= s.length ? "" : _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(s, i, s.length);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter29is__sed__command__start__char(ch) {
  return ch === 115 || (ch === 100 || (ch === 68 || (ch === 78 || (ch === 110 || (ch === 121 || (ch === 61 || (ch === 112 || (ch === 80 || (ch === 104 || (ch === 72 || (ch === 103 || (ch === 71 || (ch === 120 || (ch === 113 || (ch === 97 || (ch === 105 || (ch === 99 || (ch === 119 || (ch === 58 || (ch === 98 || (ch === 116 || (ch === 84 || (ch === 118 || ch === 123)))))))))))))))))))))));
}
function _M0FP410Haoxincode8moonbash3lib11interpreter15parse__int__str(s) {
  let result = 0n;
  let neg = false;
  let start = 0;
  let _tmp$38;
  if (s.length > 0) {
    $bound_check(s, 0);
    const _p$4 = s.charCodeAt(0);
    const _p$5 = 45;
    _tmp$38 = _p$4 === _p$5;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    neg = true;
    start = 1;
  } else {
    let _tmp$39;
    if (s.length > 0) {
      $bound_check(s, 0);
      const _p$4 = s.charCodeAt(0);
      const _p$5 = 43;
      _tmp$39 = _p$4 === _p$5;
    } else {
      _tmp$39 = false;
    }
    if (_tmp$39) {
      start = 1;
    }
  }
  let _tmp$39 = start;
  while (true) {
    const i = _tmp$39;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      if (ch >= 48 && ch <= 57) {
        result = BigInt.asUintN(64, BigInt.asUintN(64, result * 10n) + BigInt.asUintN(64, BigInt(ch - 48 | 0)));
      } else {
        break;
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return neg ? BigInt.asUintN(64, -result) : result;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(s) {
  return Number(BigInt.asIntN(32, _M0FP410Haoxincode8moonbash3lib11interpreter15parse__int__str(s))) | 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter32parse__sed__until__delim_2einner(expr, start, delim, regex_part) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = start;
  let in_char_class = false;
  while (true) {
    if (i < expr.length) {
      const _tmp$38 = i;
      $bound_check(expr, _tmp$38);
      const ch = expr.charCodeAt(_tmp$38);
      if (ch === 92) {
        if ((i + 1 | 0) >= expr.length) {
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
          i = i + 1 | 0;
          continue;
        }
        const _tmp$39 = i + 1 | 0;
        $bound_check(expr, _tmp$39);
        const next = expr.charCodeAt(_tmp$39);
        if (next === delim) {
          _M0IPB13StringBuilderPB6Logger11write__char(buf, delim);
        } else {
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
          _M0IPB13StringBuilderPB6Logger11write__char(buf, next);
        }
        i = i + 2 | 0;
        continue;
      }
      if (regex_part) {
        if (ch === 91 && !in_char_class) {
          in_char_class = true;
        } else {
          if (ch === 93 && in_char_class) {
            in_char_class = false;
          }
        }
      }
      if (ch === delim && !in_char_class) {
        return { _0: buf.val, _1: i + 1 | 0 };
      }
      _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter41sed__pattern__has__python__comment__group(pattern) {
  let i = 0;
  while (true) {
    if ((i + 4 | 0) < pattern.length) {
      const _tmp$38 = i;
      $bound_check(pattern, _tmp$38);
      const a = pattern.charCodeAt(_tmp$38);
      const _tmp$39 = i + 1 | 0;
      $bound_check(pattern, _tmp$39);
      const b = pattern.charCodeAt(_tmp$39);
      const _tmp$40 = i + 2 | 0;
      $bound_check(pattern, _tmp$40);
      const c = pattern.charCodeAt(_tmp$40);
      const _tmp$41 = i + 3 | 0;
      $bound_check(pattern, _tmp$41);
      const d = pattern.charCodeAt(_tmp$41);
      const _tmp$42 = i + 4 | 0;
      $bound_check(pattern, _tmp$42);
      const e = pattern.charCodeAt(_tmp$42);
      if (a === 92 && (b === 40 && (c === 92 && (d === 63 && e === 35)))) {
        return true;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter27parse__sed__address_2einner(expr, start, extended, allow_relative) {
  if (start >= expr.length) {
    return undefined;
  }
  $bound_check(expr, start);
  const ch = expr.charCodeAt(start);
  if (allow_relative && ch === 43) {
    let i = start + 1 | 0;
    if (i >= expr.length) {
      return undefined;
    }
    while (true) {
      if (i < expr.length) {
        const _tmp$38 = i;
        $bound_check(expr, _tmp$38);
        const next = expr.charCodeAt(_tmp$38);
        if (next >= 48 && next <= 57) {
          i = i + 1 | 0;
        } else {
          break;
        }
        continue;
      } else {
        break;
      }
    }
    if (i === (start + 1 | 0)) {
      return undefined;
    }
    return { _0: new _M0DTP410Haoxincode8moonbash3lib11interpreter10SedAddress8Relative(_M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(expr, start + 1 | 0, i))), _1: i };
  }
  if (ch === 36) {
    return { _0: _M0DTP410Haoxincode8moonbash3lib11interpreter10SedAddress8LastLine__, _1: start + 1 | 0 };
  }
  if (ch >= 48 && ch <= 57) {
    let i = start + 1 | 0;
    while (true) {
      if (i < expr.length) {
        const _tmp$38 = i;
        $bound_check(expr, _tmp$38);
        const next = expr.charCodeAt(_tmp$38);
        if (next >= 48 && next <= 57) {
          i = i + 1 | 0;
        } else {
          break;
        }
        continue;
      } else {
        break;
      }
    }
    return { _0: new _M0DTP410Haoxincode8moonbash3lib11interpreter10SedAddress4Line(_M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(expr, start, i))), _1: i };
  }
  if (ch === 47) {
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter32parse__sed__until__delim_2einner(expr, start + 1 | 0, 47, true);
    if (_bind$4 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _pattern = _x._0;
      const _next_idx = _x._1;
      if (_pattern.length === 0) {
        return { _0: _M0DTP410Haoxincode8moonbash3lib11interpreter10SedAddress9LastRegex__, _1: _next_idx };
      }
      if (_M0FP410Haoxincode8moonbash3lib11interpreter41sed__pattern__has__python__comment__group(_pattern)) {
        return undefined;
      }
      let matcher;
      let _try_err;
      _L: {
        _L$2: {
          const _bind$5 = _M0FP410Haoxincode8moonbash3lib5regex30compile__grep__matcher_2einner(_pattern, extended, false, false);
          if (_bind$5.$tag === 1) {
            const _ok = _bind$5;
            matcher = _ok._0;
          } else {
            const _err = _bind$5;
            _try_err = _err._0;
            break _L$2;
          }
          break _L;
        }
        return undefined;
      }
      return { _0: new _M0DTP410Haoxincode8moonbash3lib11interpreter10SedAddress5Regex(matcher), _1: _next_idx };
    }
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter35parse__sed__address__prefix_2einner(expr, extended) {
  const i = _M0FP410Haoxincode8moonbash3lib11interpreter18skip__ascii__space(expr, 0);
  if (i >= expr.length) {
    return undefined;
  }
  $bound_check(expr, i);
  const first = expr.charCodeAt(i);
  if (_M0FP410Haoxincode8moonbash3lib11interpreter29is__sed__command__start__char(first)) {
    return { _0: undefined, _1: i };
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter27parse__sed__address_2einner(expr, i, extended, false);
  if (_bind$4 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _start_addr = _x._0;
    const _after_start = _x._1;
    let j = _M0FP410Haoxincode8moonbash3lib11interpreter18skip__ascii__space(expr, _after_start);
    let _tmp$38;
    if (j < expr.length) {
      const _tmp$39 = j;
      $bound_check(expr, _tmp$39);
      _tmp$38 = expr.charCodeAt(_tmp$39) === 44;
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      j = j + 1 | 0;
      j = _M0FP410Haoxincode8moonbash3lib11interpreter18skip__ascii__space(expr, j);
      const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter27parse__sed__address_2einner(expr, j, extended, true);
      if (_bind$5 === undefined) {
        return undefined;
      } else {
        const _Some$2 = _bind$5;
        const _x$2 = _Some$2;
        const _end_addr = _x$2._0;
        const _after_end = _x$2._1;
        return { _0: new _M0TP410Haoxincode8moonbash3lib11interpreter15SedAddressRange(_start_addr, _end_addr), _1: _after_end };
      }
    } else {
      return { _0: new _M0TP410Haoxincode8moonbash3lib11interpreter15SedAddressRange(_start_addr, undefined), _1: j };
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter18trim__ascii__space(s) {
  const start = _M0FP410Haoxincode8moonbash3lib11interpreter18skip__ascii__space(s, 0);
  if (start >= s.length) {
    return "";
  }
  let end = s.length;
  while (true) {
    if (end > start) {
      const _tmp$38 = end - 1 | 0;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch === 32 || (ch === 9 || (ch === 10 || ch === 13))) {
        end = end - 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  return _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(s, start, end);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter33parse__sed__flow__command_2einner(expr, op_idx, address, negated) {
  $bound_check(expr, op_idx);
  const op = expr.charCodeAt(op_idx);
  const rest = _M0FP410Haoxincode8moonbash3lib11interpreter18trim__ascii__space(_M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(expr, op_idx + 1 | 0, expr.length));
  let kind;
  if (op === 58) {
    kind = new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind5Label(rest);
  } else {
    const label = rest.length === 0 ? undefined : rest;
    kind = op === 98 ? new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind6Branch(label) : op === 116 ? new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind13BranchIfSubst(label) : new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind16BranchIfNotSubst(label);
  }
  return new _M0TP410Haoxincode8moonbash3lib11interpreter10SedCommand(address, kind, negated);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter35parse__sed__simple__command_2einner(expr, op_idx, address, kind, negated) {
  if (_M0FP410Haoxincode8moonbash3lib11interpreter18skip__ascii__space(expr, op_idx + 1 | 0) !== expr.length) {
    return undefined;
  }
  return new _M0TP410Haoxincode8moonbash3lib11interpreter10SedCommand(address, kind, negated);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter29parse__sed__substitute__flags(flags_text) {
  let global = false;
  let ignore_case = false;
  let occurrence = 1;
  let print_on_subst = false;
  let write_file = undefined;
  let j = 0;
  _L: while (true) {
    if (j < flags_text.length) {
      const _tmp$38 = j;
      $bound_check(flags_text, _tmp$38);
      const flag = flags_text.charCodeAt(_tmp$38);
      if (flag >= 48 && flag <= 57) {
        const start = j;
        while (true) {
          if (j < flags_text.length) {
            const _tmp$39 = j;
            $bound_check(flags_text, _tmp$39);
            const digit = flags_text.charCodeAt(_tmp$39);
            if (digit >= 48 && digit <= 57) {
              j = j + 1 | 0;
            } else {
              break;
            }
            continue;
          } else {
            break;
          }
        }
        occurrence = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(flags_text, start, j));
        if (occurrence <= 0) {
          return undefined;
        }
        continue;
      }
      _L$2: {
        _L$3: {
          switch (flag) {
            case 103: {
              global = true;
              break;
            }
            case 105: {
              break _L$3;
            }
            case 73: {
              break _L$3;
            }
            case 112: {
              print_on_subst = true;
              break;
            }
            case 119: {
              const path = _M0FP410Haoxincode8moonbash3lib11interpreter18trim__ascii__space(_M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(flags_text, j + 1 | 0, flags_text.length));
              if (path.length === 0) {
                return undefined;
              }
              write_file = path;
              j = flags_text.length;
              continue _L;
            }
            case 32: {
              break;
            }
            case 9: {
              break;
            }
            case 10: {
              break;
            }
            case 13: {
              break;
            }
            default: {
              return undefined;
            }
          }
          break _L$2;
        }
        ignore_case = true;
      }
      j = j + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return new _M0TP410Haoxincode8moonbash3lib11interpreter18SedSubstituteFlags(global, ignore_case, occurrence, print_on_subst, write_file);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter30sed__pattern__has__regex__meta(pattern) {
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < pattern.length) {
      $bound_check(pattern, i);
      const ch = pattern.charCodeAt(i);
      if (ch === 46 || (ch === 42 || (ch === 43 || (ch === 63 || (ch === 94 || (ch === 36 || (ch === 91 || (ch === 93 || (ch === 40 || (ch === 41 || (ch === 123 || (ch === 125 || (ch === 124 || ch === 92))))))))))))) {
        return true;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter39parse__sed__substitute__matcher_2einner(pattern, extended, ignore_case) {
  if (pattern.length === 0) {
    return undefined;
  }
  if (_M0FP410Haoxincode8moonbash3lib11interpreter41sed__pattern__has__python__comment__group(pattern)) {
    return undefined;
  }
  let compiled;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib5regex30compile__grep__matcher_2einner(pattern, extended, false, ignore_case);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        compiled = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    if (_M0FP410Haoxincode8moonbash3lib11interpreter30sed__pattern__has__regex__meta(pattern)) {
      return undefined;
    }
    let _try_err$2;
    _L$3: {
      _L$4: {
        const _bind$4 = _M0FP410Haoxincode8moonbash3lib5regex30compile__grep__matcher_2einner(pattern, extended, true, ignore_case);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          compiled = _ok._0;
        } else {
          const _err = _bind$4;
          _try_err$2 = _err._0;
          break _L$4;
        }
        break _L$3;
      }
      return undefined;
    }
  }
  return compiled;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter29parse__sed__substitute__parts(expr, op_idx) {
  let i = op_idx + 1 | 0;
  if (i >= expr.length) {
    return undefined;
  }
  const _tmp$38 = i;
  $bound_check(expr, _tmp$38);
  const delim = expr.charCodeAt(_tmp$38);
  i = i + 1 | 0;
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter32parse__sed__until__delim_2einner(expr, i, delim, true);
  if (_bind$4 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _pattern = _x._0;
    const _replacement_start = _x._1;
    const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter32parse__sed__until__delim_2einner(expr, _replacement_start, delim, false);
    if (_bind$5 === undefined) {
      return undefined;
    } else {
      const _Some$2 = _bind$5;
      const _x$2 = _Some$2;
      const _replacement = _x$2._0;
      const _flags_start = _x$2._1;
      const flags_text = _M0FP410Haoxincode8moonbash3lib11interpreter18trim__ascii__space(_M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(expr, _flags_start, expr.length));
      return { _0: _pattern, _1: _replacement, _2: flags_text, _3: delim };
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter39parse__sed__substitute__command_2einner(expr, op_idx, address, extended, negated) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter29parse__sed__substitute__parts(expr, op_idx);
  if (_bind$4 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _pattern = _x._0;
    const _replacement = _x._1;
    const _flags_text = _x._2;
    const _delim = _x._3;
    const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter29parse__sed__substitute__flags(_flags_text);
    if (_bind$5 === undefined) {
      return undefined;
    } else {
      const _Some$2 = _bind$5;
      const _flags = _Some$2;
      const matcher = _M0FP410Haoxincode8moonbash3lib11interpreter39parse__sed__substitute__matcher_2einner(_pattern, extended, _flags.ignore_case);
      if (_pattern.length > 0) {
        if (matcher === undefined) {
          return undefined;
        }
      }
      return new _M0TP410Haoxincode8moonbash3lib11interpreter10SedCommand(address, new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind10Substitute(new _M0TP410Haoxincode8moonbash3lib11interpreter12SedSubstSpec(matcher, _replacement, _flags.global, _flags.occurrence, _delim === 38, _flags.print_on_subst, _flags.write_file)), negated);
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter20decode__sed__escapes(text) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  while (true) {
    if (i < text.length) {
      const _tmp$38 = i;
      $bound_check(text, _tmp$38);
      const ch = text.charCodeAt(_tmp$38);
      if (ch === 92 && (i + 1 | 0) < text.length) {
        const _tmp$39 = i + 1 | 0;
        $bound_check(text, _tmp$39);
        const next = text.charCodeAt(_tmp$39);
        switch (next) {
          case 110: {
            _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
            break;
          }
          case 116: {
            _M0IPB13StringBuilderPB6Logger11write__char(out, 9);
            break;
          }
          case 114: {
            _M0IPB13StringBuilderPB6Logger11write__char(out, 13);
            break;
          }
          default: {
            _M0IPB13StringBuilderPB6Logger11write__char(out, next);
          }
        }
        i = i + 2 | 0;
        continue;
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter25parse__sed__text__payload(raw) {
  let i = 0;
  while (true) {
    if (i < raw.length) {
      const _tmp$38 = i;
      $bound_check(raw, _tmp$38);
      const ch = raw.charCodeAt(_tmp$38);
      if (ch === 32 || ch === 9) {
        i = i + 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  if (i >= raw.length) {
    return undefined;
  }
  let payload = _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(raw, i, raw.length);
  let _tmp$38;
  const _tmp$39 = payload;
  $bound_check(_tmp$39, 0);
  if (_tmp$39.charCodeAt(0) === 92) {
    let _tmp$40;
    if (payload.length === 1) {
      _tmp$40 = true;
    } else {
      let _tmp$41;
      const _tmp$42 = payload;
      $bound_check(_tmp$42, 1);
      if (_tmp$42.charCodeAt(1) === 10) {
        _tmp$41 = true;
      } else {
        let _tmp$43;
        const _tmp$44 = payload;
        $bound_check(_tmp$44, 1);
        if (_tmp$44.charCodeAt(1) === 32) {
          _tmp$43 = true;
        } else {
          const _tmp$45 = payload;
          $bound_check(_tmp$45, 1);
          _tmp$43 = _tmp$45.charCodeAt(1) === 9;
        }
        _tmp$41 = _tmp$43;
      }
      _tmp$40 = _tmp$41;
    }
    _tmp$38 = _tmp$40;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    payload = _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(payload, 1, payload.length);
    let _tmp$40;
    if (payload.length > 0) {
      const _tmp$41 = payload;
      $bound_check(_tmp$41, 0);
      _tmp$40 = _tmp$41.charCodeAt(0) === 10;
    } else {
      _tmp$40 = false;
    }
    if (_tmp$40) {
      payload = _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(payload, 1, payload.length);
    }
  }
  if (payload.length === 0) {
    return undefined;
  }
  return _M0FP410Haoxincode8moonbash3lib11interpreter20decode__sed__escapes(payload);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter33parse__sed__text__command_2einner(expr, op_idx, address, negated) {
  $bound_check(expr, op_idx);
  const op = expr.charCodeAt(op_idx);
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter25parse__sed__text__payload(_M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(expr, op_idx + 1 | 0, expr.length));
  if (_bind$4 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$4;
    const _text = _Some;
    const kind = op === 97 ? new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind10AppendText(_text) : op === 105 ? new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind10InsertText(_text) : new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind10ChangeText(_text);
    return new _M0TP410Haoxincode8moonbash3lib11interpreter10SedCommand(address, kind, negated);
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter26parse__sed__translit__part(expr, start, delim) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = start;
  while (true) {
    if (i < expr.length) {
      const _tmp$38 = i;
      $bound_check(expr, _tmp$38);
      const ch = expr.charCodeAt(_tmp$38);
      if (ch === delim) {
        return { _0: buf.val, _1: i + 1 | 0 };
      }
      if (ch === 92) {
        if ((i + 1 | 0) >= expr.length) {
          return undefined;
        }
        const _tmp$39 = i + 1 | 0;
        $bound_check(expr, _tmp$39);
        const next = expr.charCodeAt(_tmp$39);
        _L: {
          _L$2: {
            switch (next) {
              case 110: {
                break _L$2;
              }
              case 10: {
                break _L$2;
              }
              case 116: {
                _M0IPB13StringBuilderPB6Logger11write__char(buf, 9);
                break;
              }
              case 114: {
                _M0IPB13StringBuilderPB6Logger11write__char(buf, 13);
                break;
              }
              default: {
                _M0IPB13StringBuilderPB6Logger11write__char(buf, next);
              }
            }
            break _L;
          }
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 10);
        }
        i = i + 2 | 0;
        continue;
      }
      _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter37parse__sed__translit__command_2einner(expr, op_idx, address, negated) {
  let i = op_idx + 1 | 0;
  if (i >= expr.length) {
    return undefined;
  }
  const _tmp$38 = i;
  $bound_check(expr, _tmp$38);
  const delim = expr.charCodeAt(_tmp$38);
  i = i + 1 | 0;
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter26parse__sed__translit__part(expr, i, delim);
  if (_bind$4 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _source = _x._0;
    const _target_start = _x._1;
    const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter26parse__sed__translit__part(expr, _target_start, delim);
    if (_bind$5 === undefined) {
      return undefined;
    } else {
      const _Some$2 = _bind$5;
      const _x$2 = _Some$2;
      const _target = _x$2._0;
      const _end_idx = _x$2._1;
      if (_source.length !== _target.length) {
        return undefined;
      }
      if (_M0FP410Haoxincode8moonbash3lib11interpreter18skip__ascii__space(expr, _end_idx) !== expr.length) {
        return undefined;
      }
      return new _M0TP410Haoxincode8moonbash3lib11interpreter10SedCommand(address, new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind13Transliterate(new _M0TP410Haoxincode8moonbash3lib11interpreter15SedTranslitSpec(_source, _target)), negated);
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter36parse__sed__version__command_2einner(expr, op_idx, address, negated) {
  const i = op_idx + 1 | 0;
  let version;
  if (i >= expr.length) {
    version = undefined;
  } else {
    $bound_check(expr, i);
    const sep = expr.charCodeAt(i);
    if (sep !== 32 && sep !== 9) {
      return undefined;
    }
    const rest = _M0FP410Haoxincode8moonbash3lib11interpreter18trim__ascii__space(_M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(expr, i, expr.length));
    version = rest.length === 0 ? undefined : rest;
  }
  return new _M0TP410Haoxincode8moonbash3lib11interpreter10SedCommand(address, new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind12VersionCheck(version), negated);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter34parse__sed__write__command_2einner(expr, op_idx, address, negated) {
  const rest = _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(expr, op_idx + 1 | 0, expr.length);
  let has_space;
  if (rest.length > 0) {
    let _tmp$38;
    $bound_check(rest, 0);
    if (rest.charCodeAt(0) === 32) {
      _tmp$38 = true;
    } else {
      $bound_check(rest, 0);
      _tmp$38 = rest.charCodeAt(0) === 9;
    }
    has_space = _tmp$38;
  } else {
    has_space = false;
  }
  if (address === undefined) {
    if (!has_space) {
      return undefined;
    }
  }
  const path = _M0FP410Haoxincode8moonbash3lib11interpreter18trim__ascii__space(rest);
  if (path.length === 0) {
    return undefined;
  }
  return new _M0TP410Haoxincode8moonbash3lib11interpreter10SedCommand(address, new _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind9WriteFile(path), negated);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter27parse__sed__command_2einner(expr, extended) {
  const trimmed = _M0FP410Haoxincode8moonbash3lib11interpreter17trim__ascii__left(expr);
  if (_M0FP410Haoxincode8moonbash3lib11interpreter18trim__ascii__space(trimmed).length === 0) {
    return undefined;
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter35parse__sed__address__prefix_2einner(trimmed, extended);
  if (_bind$4 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _address = _x._0;
    const _cmd_idx = _x._1;
    let i = _M0FP410Haoxincode8moonbash3lib11interpreter18skip__ascii__space(trimmed, _cmd_idx);
    if (i >= trimmed.length) {
      return undefined;
    }
    let negated = false;
    const _tmp$38 = i;
    $bound_check(trimmed, _tmp$38);
    if (trimmed.charCodeAt(_tmp$38) === 33) {
      negated = true;
      i = _M0FP410Haoxincode8moonbash3lib11interpreter18skip__ascii__space(trimmed, i + 1 | 0);
      if (i >= trimmed.length) {
        return undefined;
      }
    }
    if (negated) {
      if (_address === undefined) {
        return undefined;
      }
    }
    const _tmp$39 = i;
    $bound_check(trimmed, _tmp$39);
    const op = trimmed.charCodeAt(_tmp$39);
    _L: {
      _L$2: {
        switch (op) {
          case 100: {
            return _M0FP410Haoxincode8moonbash3lib11interpreter35parse__sed__simple__command_2einner(trimmed, i, _address, _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind6Delete__, negated);
          }
          case 68: {
            return _M0FP410Haoxincode8moonbash3lib11interpreter35parse__sed__simple__command_2einner(trimmed, i, _address, _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind15DeleteFirstLine__, negated);
          }
          case 112: {
            return _M0FP410Haoxincode8moonbash3lib11interpreter35parse__sed__simple__command_2einner(trimmed, i, _address, _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind12PrintPattern__, negated);
          }
          case 80: {
            return _M0FP410Haoxincode8moonbash3lib11interpreter35parse__sed__simple__command_2einner(trimmed, i, _address, _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind14PrintFirstLine__, negated);
          }
          case 78: {
            return _M0FP410Haoxincode8moonbash3lib11interpreter35parse__sed__simple__command_2einner(trimmed, i, _address, _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind14AppendNextLine__, negated);
          }
          case 110: {
            return _M0FP410Haoxincode8moonbash3lib11interpreter35parse__sed__simple__command_2einner(trimmed, i, _address, _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind8NextLine__, negated);
          }
          case 61: {
            return _M0FP410Haoxincode8moonbash3lib11interpreter35parse__sed__simple__command_2einner(trimmed, i, _address, _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind15PrintLineNumber__, negated);
          }
          case 104: {
            return _M0FP410Haoxincode8moonbash3lib11interpreter35parse__sed__simple__command_2einner(trimmed, i, _address, _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind7HoldSet__, negated);
          }
          case 72: {
            return _M0FP410Haoxincode8moonbash3lib11interpreter35parse__sed__simple__command_2einner(trimmed, i, _address, _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind10HoldAppend__, negated);
          }
          case 103: {
            return _M0FP410Haoxincode8moonbash3lib11interpreter35parse__sed__simple__command_2einner(trimmed, i, _address, _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind7HoldGet__, negated);
          }
          case 71: {
            return _M0FP410Haoxincode8moonbash3lib11interpreter35parse__sed__simple__command_2einner(trimmed, i, _address, _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind13HoldAppendGet__, negated);
          }
          case 120: {
            return _M0FP410Haoxincode8moonbash3lib11interpreter35parse__sed__simple__command_2einner(trimmed, i, _address, _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind12ExchangeHold__, negated);
          }
          case 113: {
            return _M0FP410Haoxincode8moonbash3lib11interpreter35parse__sed__simple__command_2einner(trimmed, i, _address, _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind4Quit__, negated);
          }
          case 118: {
            return _M0FP410Haoxincode8moonbash3lib11interpreter36parse__sed__version__command_2einner(trimmed, i, _address, negated);
          }
          case 58: {
            break _L$2;
          }
          case 98: {
            break _L$2;
          }
          case 116: {
            break _L$2;
          }
          case 84: {
            break _L$2;
          }
          case 97: {
            break _L;
          }
          case 105: {
            break _L;
          }
          case 99: {
            break _L;
          }
          case 119: {
            return _M0FP410Haoxincode8moonbash3lib11interpreter34parse__sed__write__command_2einner(trimmed, i, _address, negated);
          }
          case 121: {
            return _M0FP410Haoxincode8moonbash3lib11interpreter37parse__sed__translit__command_2einner(trimmed, i, _address, negated);
          }
          case 115: {
            return _M0FP410Haoxincode8moonbash3lib11interpreter39parse__sed__substitute__command_2einner(trimmed, i, _address, extended, negated);
          }
          default: {
            return undefined;
          }
        }
      }
      return _M0FP410Haoxincode8moonbash3lib11interpreter33parse__sed__flow__command_2einner(trimmed, i, _address, negated);
    }
    return _M0FP410Haoxincode8moonbash3lib11interpreter33parse__sed__text__command_2einner(trimmed, i, _address, negated);
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter30parse__sed__inline__directives(expr) {
  const trimmed = _M0FP410Haoxincode8moonbash3lib11interpreter17trim__ascii__left(expr);
  let _tmp$38;
  if (trimmed.length < 2) {
    _tmp$38 = true;
  } else {
    $bound_check(trimmed, 0);
    _tmp$38 = trimmed.charCodeAt(0) !== 35;
  }
  if (_tmp$38) {
    return undefined;
  }
  let quiet = false;
  let extended = false;
  let saw_flag = false;
  let i = 1;
  while (true) {
    if (i < trimmed.length) {
      const _tmp$39 = i;
      $bound_check(trimmed, _tmp$39);
      const ch = trimmed.charCodeAt(_tmp$39);
      _L: {
        _L$2: {
          switch (ch) {
            case 110: {
              quiet = true;
              saw_flag = true;
              break;
            }
            case 114: {
              break _L$2;
            }
            case 69: {
              break _L$2;
            }
            case 32: {
              break;
            }
            case 9: {
              break;
            }
            case 13: {
              break;
            }
            case 10: {
              break;
            }
            default: {
              return undefined;
            }
          }
          break _L;
        }
        extended = true;
        saw_flag = true;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return saw_flag ? { _0: quiet, _1: extended } : undefined;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter31parse__sed__group__close__index(expr, open_idx) {
  let depth = 1;
  let i = open_idx + 1 | 0;
  while (true) {
    if (i < expr.length) {
      const _tmp$38 = i;
      $bound_check(expr, _tmp$38);
      const ch = expr.charCodeAt(_tmp$38);
      if (ch === 92) {
        i = i + 2 | 0;
        continue;
      }
      if (ch === 123) {
        depth = depth + 1 | 0;
        i = i + 1 | 0;
        continue;
      }
      if (ch === 125) {
        depth = depth - 1 | 0;
        if (depth === 0) {
          return i;
        }
        i = i + 1 | 0;
        continue;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter31parse__sed__group__open_2einner(expr, extended) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter35parse__sed__address__prefix_2einner(expr, extended);
  if (_bind$4 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _address = _x._0;
    const _cmd_idx = _x._1;
    let open_idx = _M0FP410Haoxincode8moonbash3lib11interpreter18skip__ascii__space(expr, _cmd_idx);
    let outer_negated = false;
    let _tmp$38;
    if (open_idx < expr.length) {
      const _tmp$39 = open_idx;
      $bound_check(expr, _tmp$39);
      _tmp$38 = expr.charCodeAt(_tmp$39) === 33;
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      outer_negated = true;
      open_idx = _M0FP410Haoxincode8moonbash3lib11interpreter18skip__ascii__space(expr, open_idx + 1 | 0);
    }
    if (outer_negated) {
      if (_address === undefined) {
        return undefined;
      }
    }
    let _tmp$39;
    if (open_idx >= expr.length) {
      _tmp$39 = true;
    } else {
      const _tmp$40 = open_idx;
      $bound_check(expr, _tmp$40);
      _tmp$39 = expr.charCodeAt(_tmp$40) !== 123;
    }
    if (_tmp$39) {
      return undefined;
    }
    return { _0: _address, _1: outer_negated, _2: open_idx };
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter29split__sed__top__level__parts(expr) {
  const segments = [];
  const separators = [];
  let start = 0;
  let brace_depth = 0;
  let escaped = false;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < expr.length) {
      _L: {
        $bound_check(expr, i);
        const ch = expr.charCodeAt(i);
        if (escaped) {
          escaped = false;
          break _L;
        }
        if (ch === 92) {
          escaped = true;
          break _L;
        }
        if (ch === 123) {
          brace_depth = brace_depth + 1 | 0;
          break _L;
        }
        if (ch === 125) {
          if (brace_depth > 0) {
            brace_depth = brace_depth - 1 | 0;
          }
          break _L;
        }
        if ((ch === 59 || ch === 10) && brace_depth === 0) {
          _M0MPC15array5Array4pushGUssEE(segments, _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(expr, start, i));
          _M0MPC15array5Array4pushGUssEE(separators, ch === 59 ? ";" : "\n");
          start = i + 1 | 0;
        }
        break _L;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MPC15array5Array4pushGUssEE(segments, _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(expr, start, expr.length));
  return { _0: segments, _1: separators };
}
function _M0FP410Haoxincode8moonbash3lib11interpreter36parse__sed__script__commands_2einner(expr, extended) {
  const normalized = _M0FP410Haoxincode8moonbash3lib11interpreter17trim__ascii__left(expr);
  if (_M0FP410Haoxincode8moonbash3lib11interpreter18trim__ascii__space(normalized).length === 0) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib11interpreter10SedCommandEE4Some([]);
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter29split__sed__top__level__parts(normalized);
  const _segments = _bind$4._0;
  const _separators = _bind$4._1;
  if (_separators.length === 0) {
    return _M0FP410Haoxincode8moonbash3lib11interpreter33parse__sed__single__piece_2einner(normalized, extended);
  }
  const merged = [];
  let seg_idx = 0;
  while (true) {
    if (seg_idx < _segments.length) {
      let candidate = _M0MPC15array5Array2atGUssEE(_segments, seg_idx);
      let sep_idx = seg_idx;
      let parsed = _M0FP410Haoxincode8moonbash3lib11interpreter33parse__sed__single__piece_2einner(candidate, extended);
      while (true) {
        const _bind$5 = parsed;
        if (_bind$5.$tag === 0) {
          if (sep_idx < _separators.length) {
            if ((sep_idx - seg_idx | 0) >= 12) {
              return _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib11interpreter10SedCommandEE4None__;
            }
            candidate = `${candidate}${_M0MPC15array5Array2atGUssEE(_separators, sep_idx)}${_M0MPC15array5Array2atGUssEE(_segments, sep_idx + 1 | 0)}`;
            sep_idx = sep_idx + 1 | 0;
            parsed = _M0FP410Haoxincode8moonbash3lib11interpreter33parse__sed__single__piece_2einner(candidate, extended);
            continue;
          } else {
            break;
          }
        } else {
          break;
        }
      }
      const _bind$5 = parsed;
      if (_bind$5.$tag === 1) {
        const _Some = _bind$5;
        const _cmds = _Some._0;
        const _bind$6 = _cmds.length;
        let _tmp$38 = 0;
        while (true) {
          const _ = _tmp$38;
          if (_ < _bind$6) {
            const cmd = _cmds[_];
            _M0MPC15array5Array4pushGUssEE(merged, cmd);
            _tmp$38 = _ + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        seg_idx = sep_idx + 1 | 0;
      } else {
        return _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib11interpreter10SedCommandEE4None__;
      }
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib11interpreter10SedCommandEE4Some(merged);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter33parse__sed__single__piece_2einner(expr, extended) {
  const trimmed = _M0FP410Haoxincode8moonbash3lib11interpreter17trim__ascii__left(expr);
  if (_M0FP410Haoxincode8moonbash3lib11interpreter18trim__ascii__space(trimmed).length === 0) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib11interpreter10SedCommandEE4Some([]);
  }
  $bound_check(trimmed, 0);
  if (trimmed.charCodeAt(0) === 35) {
    return new _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib11interpreter10SedCommandEE4Some([]);
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter27parse__sed__command_2einner(trimmed, extended);
  if (_bind$4 === undefined) {
  } else {
    const _Some = _bind$4;
    const _cmd = _Some;
    return new _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib11interpreter10SedCommandEE4Some([_cmd]);
  }
  const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter35parse__sed__group__commands_2einner(trimmed, extended);
  if (_bind$5.$tag === 1) {
    const _Some = _bind$5;
    const _cmds = _Some._0;
    return new _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib11interpreter10SedCommandEE4Some(_cmds);
  }
  return _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib11interpreter10SedCommandEE4None__;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter35parse__sed__group__commands_2einner(expr, extended) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter31parse__sed__group__open_2einner(expr, extended);
  if (_bind$4 === undefined) {
    return _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib11interpreter10SedCommandEE4None__;
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _address = _x._0;
    const _outer_negated = _x._1;
    const _open_idx = _x._2;
    const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter31parse__sed__group__close__index(expr, _open_idx);
    if (_bind$5 === undefined) {
      return _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib11interpreter10SedCommandEE4None__;
    } else {
      const _Some$2 = _bind$5;
      const _close_idx = _Some$2;
      if (_M0FP410Haoxincode8moonbash3lib11interpreter18skip__ascii__space(expr, _close_idx + 1 | 0) !== expr.length) {
        return _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib11interpreter10SedCommandEE4None__;
      }
      const inner = _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(expr, _open_idx + 1 | 0, _close_idx);
      const _bind$6 = _M0FP410Haoxincode8moonbash3lib11interpreter36parse__sed__script__commands_2einner(inner, extended);
      if (_bind$6.$tag === 1) {
        const _Some$3 = _bind$6;
        const _inner_cmds = _Some$3._0;
        const wrapped = [];
        _M0MPC15array5Array4pushGUssEE(wrapped, new _M0TP410Haoxincode8moonbash3lib11interpreter10SedCommand(_address, _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind10GroupStart__, _outer_negated));
        const _bind$7 = _inner_cmds.length;
        let _tmp$38 = 0;
        while (true) {
          const _ = _tmp$38;
          if (_ < _bind$7) {
            const cmd = _inner_cmds[_];
            _M0MPC15array5Array4pushGUssEE(wrapped, cmd);
            _tmp$38 = _ + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        _M0MPC15array5Array4pushGUssEE(wrapped, new _M0TP410Haoxincode8moonbash3lib11interpreter10SedCommand(undefined, _M0DTP410Haoxincode8moonbash3lib11interpreter14SedCommandKind8GroupEnd__, false));
        return new _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib11interpreter10SedCommandEE4Some(wrapped);
      } else {
        return _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib11interpreter10SedCommandEE4None__;
      }
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter16sed__emit__chunk(out, text, terminated, pending_no_newline) {
  if (pending_no_newline) {
    _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
  }
  _M0IPB13StringBuilderPB6Logger13write__string(out, text);
  if (terminated) {
    _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
    return false;
  } else {
    return true;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter18sed__find__newline(text) {
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < text.length) {
      $bound_check(text, i);
      if (text.charCodeAt(i) === 10) {
        return i;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter23sed__find__label__index(names, indices, label) {
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < names.length) {
      if (_M0MPC15array5Array2atGUssEE(names, i) === label) {
        return _M0MPC15array5Array2atGiE(indices, i);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter21sed__find__group__end(commands, start_idx) {
  let depth = 0;
  let _tmp$38 = start_idx;
  while (true) {
    const i = _tmp$38;
    if (i < commands.length) {
      const _bind$4 = _M0MPC15array5Array2atGUssEE(commands, i).kind;
      switch (_bind$4.$tag) {
        case 0: {
          depth = depth + 1 | 0;
          break;
        }
        case 1: {
          depth = depth - 1 | 0;
          if (depth === 0) {
            return i;
          }
          break;
        }
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter33sed__find__missing__branch__label(commands) {
  const labels = [];
  const _bind$4 = commands.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const cmd = commands[_];
      const _bind$5 = cmd.kind;
      if (_bind$5.$tag === 20) {
        const _Label = _bind$5;
        const _name = _Label._0;
        _M0MPC15array5Array4pushGUssEE(labels, _name);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$5 = commands.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$5) {
      const cmd = commands[_];
      let label;
      _L: {
        _L$2: {
          const _bind$6 = cmd.kind;
          switch (_bind$6.$tag) {
            case 21: {
              const _Branch = _bind$6;
              const _label = _Branch._0;
              label = _label;
              break _L$2;
            }
            case 22: {
              const _BranchIfSubst = _bind$6;
              const _label$2 = _BranchIfSubst._0;
              label = _label$2;
              break _L$2;
            }
            case 23: {
              const _BranchIfNotSubst = _bind$6;
              const _label$3 = _BranchIfNotSubst._0;
              label = _label$3;
              break _L$2;
            }
          }
          break _L;
        }
        if (label === undefined) {
        } else {
          const _Some = label;
          const _name = _Some;
          let found = false;
          const _bind$6 = labels.length;
          let _tmp$40 = 0;
          while (true) {
            const _$2 = _tmp$40;
            if (_$2 < _bind$6) {
              const known = labels[_$2];
              if (known === _name) {
                found = true;
                break;
              }
              _tmp$40 = _$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          if (!found) {
            return _name;
          }
        }
      }
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter30sed__split__lines__with__flags(input) {
  const lines = [];
  if (input.length === 0) {
    return lines;
  }
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < input.length) {
      $bound_check(input, i);
      const ch = input.charCodeAt(i);
      if (ch === 10) {
        _M0MPC15array5Array4pushGUssEE(lines, { _0: buf.val, _1: true });
        _M0MPB13StringBuilder5reset(buf);
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const remaining = buf.val;
  if (remaining.length > 0) {
    _M0MPC15array5Array4pushGUssEE(lines, { _0: remaining, _1: false });
  }
  return lines;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18sed__append__write(self, path, text, terminated) {
  let resolved;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, path);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        resolved = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    resolved = path;
  }
  const _bind$4 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.fs.entries, resolved);
  let existing;
  if (_bind$4 === undefined) {
    existing = "";
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    if (_x.$tag === 0) {
      const _File = _x;
      const _file = _File._0;
      existing = _file.content;
    } else {
      existing = "";
    }
  }
  const next = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger13write__string(next, existing);
  let _tmp$38;
  if (existing.length > 0) {
    const _tmp$39 = existing.length - 1 | 0;
    $bound_check(existing, _tmp$39);
    _tmp$38 = existing.charCodeAt(_tmp$39) !== 10;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    _M0IPB13StringBuilderPB6Logger11write__char(next, 10);
  }
  _M0IPB13StringBuilderPB6Logger13write__string(next, text);
  if (terminated) {
    _M0IPB13StringBuilderPB6Logger11write__char(next, 10);
  }
  let _try_err$2;
  _L$2: {
    const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs11write__file(self.fs, resolved, next.val);
    if (_bind$5.$tag === 1) {
      const _ok = _bind$5;
      _ok._0;
      return;
    } else {
      const _err = _bind$5;
      _try_err$2 = _err._0;
      break _L$2;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter21sed__address__matches(address, line, line_no, total_lines, last_regex) {
  switch (address.$tag) {
    case 0: {
      const _Line = address;
      const _n = _Line._0;
      return { _0: line_no === _n, _1: last_regex };
    }
    case 1: {
      return { _0: line_no === total_lines, _1: last_regex };
    }
    case 2: {
      const _Regex = address;
      const _matcher = _Regex._0;
      const _bind$4 = _M0MP410Haoxincode8moonbash3lib5regex11GrepMatcher19find__first_2einner(_matcher, line, 0);
      return { _0: !(_bind$4 === undefined), _1: _matcher };
    }
    case 3: {
      if (last_regex === undefined) {
        return { _0: false, _1: undefined };
      } else {
        const _Some = last_regex;
        const _matcher$2 = _Some;
        const _bind$5 = _M0MP410Haoxincode8moonbash3lib5regex11GrepMatcher19find__first_2einner(_matcher$2, line, 0);
        return { _0: !(_bind$5 === undefined), _1: last_regex };
      }
    }
    default: {
      return { _0: false, _1: last_regex };
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter21sed__address__applies(address, line, line_no, total_lines, state, last_regex) {
  if (address === undefined) {
    return { _0: true, _1: _M0FP410Haoxincode8moonbash3lib11interpreter24sed__empty__range__stateN6recordS11259, _2: last_regex };
  } else {
    const _Some = address;
    const _addr = _Some;
    const _bind$4 = _addr.end;
    if (_bind$4 === undefined) {
      const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter21sed__address__matches(_addr.start, line, line_no, total_lines, last_regex);
      const _hit = _bind$5._0;
      const _next_last = _bind$5._1;
      return { _0: _hit, _1: _M0FP410Haoxincode8moonbash3lib11interpreter24sed__empty__range__stateN6recordS11259, _2: _next_last };
    } else {
      const _Some$2 = _bind$4;
      const _end_addr = _Some$2;
      if (state.pending_single_line) {
        return { _0: true, _1: _M0FP410Haoxincode8moonbash3lib11interpreter24sed__empty__range__stateN6recordS11259, _2: last_regex };
      } else {
        if (state.in_range) {
          if (_end_addr.$tag === 4) {
            return state.relative_end_line >= 0 && line_no >= state.relative_end_line ? { _0: true, _1: _M0FP410Haoxincode8moonbash3lib11interpreter24sed__empty__range__stateN6recordS11259, _2: last_regex } : { _0: true, _1: state, _2: last_regex };
          } else {
            const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter21sed__address__matches(_end_addr, line, line_no, total_lines, last_regex);
            const _end_hit = _bind$5._0;
            const _next_last = _bind$5._1;
            return { _0: true, _1: new _M0TP410Haoxincode8moonbash3lib11interpreter13SedRangeState(!_end_hit, -1, false), _2: _next_last };
          }
        } else {
          const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter21sed__address__matches(_addr.start, line, line_no, total_lines, last_regex);
          const _start_hit = _bind$5._0;
          const _last_after_start = _bind$5._1;
          if (!_start_hit) {
            return { _0: false, _1: _M0FP410Haoxincode8moonbash3lib11interpreter24sed__empty__range__stateN6recordS11259, _2: _last_after_start };
          } else {
            switch (_end_addr.$tag) {
              case 4: {
                const _Relative = _end_addr;
                const _count = _Relative._0;
                return _count <= 0 ? { _0: true, _1: _M0FP410Haoxincode8moonbash3lib11interpreter24sed__empty__range__stateN6recordS11259, _2: _last_after_start } : { _0: true, _1: new _M0TP410Haoxincode8moonbash3lib11interpreter13SedRangeState(true, line_no + _count | 0, false), _2: _last_after_start };
              }
              case 0: {
                const _Line = _end_addr;
                const _end_line = _Line._0;
                return _end_line <= line_no ? { _0: true, _1: _M0FP410Haoxincode8moonbash3lib11interpreter24sed__empty__range__stateN6recordS11259, _2: _last_after_start } : { _0: true, _1: _M0FP410Haoxincode8moonbash3lib11interpreter21sed__address__appliesN6recordS11260, _2: _last_after_start };
              }
              default: {
                const _bind$6 = _M0FP410Haoxincode8moonbash3lib11interpreter21sed__address__matches(_end_addr, line, line_no, total_lines, _last_after_start);
                const _end_hit = _bind$6._0;
                const _last_after_end = _bind$6._1;
                return { _0: true, _1: new _M0TP410Haoxincode8moonbash3lib11interpreter13SedRangeState(!_end_hit, -1, false), _2: _last_after_end };
              }
            }
          }
        }
      }
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter27sed__address__tick__skipped(address, line, line_no, total_lines, state, last_regex) {
  if (address === undefined) {
    return { _0: _M0FP410Haoxincode8moonbash3lib11interpreter24sed__empty__range__stateN6recordS11259, _1: last_regex };
  } else {
    const _Some = address;
    const _addr = _Some;
    const _bind$4 = _addr.end;
    if (_bind$4 === undefined) {
      return { _0: _M0FP410Haoxincode8moonbash3lib11interpreter24sed__empty__range__stateN6recordS11259, _1: last_regex };
    } else {
      const _Some$2 = _bind$4;
      const _end_addr = _Some$2;
      if (state.pending_single_line) {
        return { _0: state, _1: last_regex };
      } else {
        if (state.in_range) {
          return { _0: state, _1: last_regex };
        } else {
          const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter21sed__address__matches(_addr.start, line, line_no, total_lines, last_regex);
          const _start_hit = _bind$5._0;
          const _last_after_start = _bind$5._1;
          if (!_start_hit) {
            return { _0: _M0FP410Haoxincode8moonbash3lib11interpreter24sed__empty__range__stateN6recordS11259, _1: _last_after_start };
          } else {
            switch (_end_addr.$tag) {
              case 4: {
                const _Relative = _end_addr;
                const _count = _Relative._0;
                return _count <= 0 ? { _0: _M0FP410Haoxincode8moonbash3lib11interpreter27sed__address__tick__skippedN6recordS11261, _1: _last_after_start } : { _0: new _M0TP410Haoxincode8moonbash3lib11interpreter13SedRangeState(true, line_no + _count | 0, false), _1: _last_after_start };
              }
              case 0: {
                const _Line = _end_addr;
                const _end_line = _Line._0;
                return _end_line <= line_no ? { _0: _M0FP410Haoxincode8moonbash3lib11interpreter27sed__address__tick__skippedN6recordS11262, _1: _last_after_start } : { _0: _M0FP410Haoxincode8moonbash3lib11interpreter27sed__address__tick__skippedN6recordS11263, _1: _last_after_start };
              }
              default: {
                return { _0: _M0FP410Haoxincode8moonbash3lib11interpreter27sed__address__tick__skippedN6recordS11264, _1: _last_after_start };
              }
            }
          }
        }
      }
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter31apply__sed__replacement_2einner(template, matched, groups, literal_ampersand) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  while (true) {
    if (i < template.length) {
      const _tmp$38 = i;
      $bound_check(template, _tmp$38);
      const ch = template.charCodeAt(_tmp$38);
      if (ch === 92) {
        if ((i + 1 | 0) < template.length) {
          const _tmp$39 = i + 1 | 0;
          $bound_check(template, _tmp$39);
          const next = template.charCodeAt(_tmp$39);
          if (next === 48) {
            _M0IPB13StringBuilderPB6Logger13write__string(out, matched);
          } else {
            if (next >= 49 && next <= 57) {
              const group_idx = next - 49 | 0;
              if (group_idx >= 0 && group_idx < groups.length) {
                _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(groups, group_idx));
              }
            } else {
              if (next === 110) {
                _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
              } else {
                if (next === 116) {
                  _M0IPB13StringBuilderPB6Logger11write__char(out, 9);
                } else {
                  if (next === 114) {
                    _M0IPB13StringBuilderPB6Logger11write__char(out, 13);
                  } else {
                    _M0IPB13StringBuilderPB6Logger11write__char(out, next);
                  }
                }
              }
            }
          }
          i = i + 2 | 0;
        } else {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
          i = i + 1 | 0;
        }
        continue;
      }
      if (ch === 38 && !literal_ampersand) {
        _M0IPB13StringBuilderPB6Logger13write__string(out, matched);
        i = i + 1 | 0;
        continue;
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter29sed__substitute__line_2einner(line, matcher, replacement, global, occurrence, literal_ampersand) {
  if (!global) {
    if (occurrence > 1) {
      let cursor = 0;
      let seen = 0;
      while (true) {
        if (cursor <= line.length) {
          const _bind$4 = _M0MP410Haoxincode8moonbash3lib5regex11GrepMatcher33find__first__with__groups_2einner(matcher, line, cursor);
          if (_bind$4 === undefined) {
            break;
          } else {
            const _Some = _bind$4;
            const _x = _Some;
            const _start = _x._0;
            const _end = _x._1;
            const _groups = _x._2;
            seen = seen + 1 | 0;
            if (seen === occurrence) {
              const prefix = _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(line, 0, _start);
              const matched = _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(line, _start, _end);
              const suffix = _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(line, _end, line.length);
              return { _0: `${prefix}${_M0FP410Haoxincode8moonbash3lib11interpreter31apply__sed__replacement_2einner(replacement, matched, _groups, literal_ampersand)}${suffix}`, _1: true };
            }
            if (_end > _start) {
              cursor = _end;
            } else {
              if (_start < line.length) {
                cursor = _start + 1 | 0;
              } else {
                break;
              }
            }
          }
          continue;
        } else {
          break;
        }
      }
      return { _0: line, _1: false };
    }
    const _bind$4 = _M0MP410Haoxincode8moonbash3lib5regex11GrepMatcher33find__first__with__groups_2einner(matcher, line, 0);
    if (_bind$4 === undefined) {
      return { _0: line, _1: false };
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _start = _x._0;
      const _end = _x._1;
      const _groups = _x._2;
      const prefix = _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(line, 0, _start);
      const matched = _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(line, _start, _end);
      const suffix = _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(line, _end, line.length);
      return { _0: `${prefix}${_M0FP410Haoxincode8moonbash3lib11interpreter31apply__sed__replacement_2einner(replacement, matched, _groups, literal_ampersand)}${suffix}`, _1: true };
    }
  } else {
    const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
    let cursor = 0;
    let changed = false;
    let done = false;
    let last_match_end = -1;
    while (true) {
      if (!done) {
        const _bind$4 = _M0MP410Haoxincode8moonbash3lib5regex11GrepMatcher33find__first__with__groups_2einner(matcher, line, cursor);
        if (_bind$4 === undefined) {
          done = true;
        } else {
          const _Some = _bind$4;
          const _x = _Some;
          const _start = _x._0;
          const _end = _x._1;
          const _groups = _x._2;
          if (_start < cursor) {
            done = true;
          } else {
            if (_start === _end && _start === last_match_end) {
              if (_start < line.length) {
                $bound_check(line, _start);
                _M0IPB13StringBuilderPB6Logger11write__char(out, line.charCodeAt(_start));
                cursor = _start + 1 | 0;
              } else {
                cursor = line.length;
                done = true;
              }
            } else {
              _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(line, cursor, _start));
              const matched = _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(line, _start, _end);
              _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter31apply__sed__replacement_2einner(replacement, matched, _groups, literal_ampersand));
              changed = true;
              last_match_end = _end;
              if (_end > _start) {
                cursor = _end;
              } else {
                if (_start < line.length) {
                  $bound_check(line, _start);
                  _M0IPB13StringBuilderPB6Logger11write__char(out, line.charCodeAt(_start));
                  cursor = _start + 1 | 0;
                } else {
                  cursor = line.length;
                  done = true;
                }
              }
            }
          }
        }
        continue;
      } else {
        break;
      }
    }
    if (cursor <= line.length) {
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(line, cursor, line.length));
    }
    return changed ? { _0: out.val, _1: true } : { _0: line, _1: false };
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter24sed__transliterate__line(line, source, target) {
  if (source.length === 0 || target.length === 0) {
    return line;
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < line.length) {
      $bound_check(line, i);
      const ch = line.charCodeAt(i);
      let replaced = false;
      let _tmp$39 = 0;
      while (true) {
        const j = _tmp$39;
        if (j < source.length) {
          $bound_check(source, j);
          const _p$4 = source.charCodeAt(j);
          if (_p$4 === ch) {
            $bound_check(target, j);
            _M0IPB13StringBuilderPB6Logger11write__char(out, target.charCodeAt(j));
            replaced = true;
            break;
          }
          _tmp$39 = j + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      if (!replaced) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter26sed__collect__label__table(commands) {
  const label_names = [];
  const label_indices = [];
  let _tmp$38 = 0;
  while (true) {
    const cmd_idx = _tmp$38;
    if (cmd_idx < commands.length) {
      const _bind$4 = _M0MPC15array5Array2atGUssEE(commands, cmd_idx).kind;
      if (_bind$4.$tag === 20) {
        const _Label = _bind$4;
        const _name = _Label._0;
        _M0MPC15array5Array4pushGUssEE(label_names, _name);
        _M0MPC15array5Array4pushGiE(label_indices, cmd_idx);
      }
      _tmp$38 = cmd_idx + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return { _0: label_names, _1: label_indices };
}
function _M0FP410Haoxincode8moonbash3lib11interpreter19sed__build__runtime(commands, input) {
  const lines = _M0FP410Haoxincode8moonbash3lib11interpreter30sed__split__lines__with__flags(input);
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter26sed__collect__label__table(commands);
  const _label_names = _bind$4._0;
  const _label_indices = _bind$4._1;
  const _tmp$38 = lines.length;
  const _p$4 = commands.length;
  let _tmp$39;
  if (_p$4 <= 0) {
    _tmp$39 = [];
  } else {
    const _p$5 = new Array(_p$4);
    let _tmp$40 = 0;
    while (true) {
      const _p$6 = _tmp$40;
      if (_p$6 < _p$4) {
        _p$5[_p$6] = _M0FP410Haoxincode8moonbash3lib11interpreter24sed__empty__range__stateN6recordS11259;
        _tmp$40 = _p$6 + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    _tmp$39 = _p$5;
  }
  return new _M0TP410Haoxincode8moonbash3lib11interpreter10SedRuntime(commands, lines, _tmp$38, _tmp$39, _label_names, _label_indices, _M0MPB13StringBuilder21StringBuilder_2einner(0));
}
function _M0FP410Haoxincode8moonbash3lib11interpreter15sed__new__cycle(runtime, line_idx) {
  return new _M0TP410Haoxincode8moonbash3lib11interpreter8SedCycle(line_idx + 1 | 0, _M0MPC15array5Array2atGUssEE(runtime.lines, line_idx)._0, _M0MPC15array5Array2atGUssEE(runtime.lines, line_idx)._1, false, 0, false, false, []);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter15sed__new__state() {
  return new _M0TP410Haoxincode8moonbash3lib11interpreter8SedState("", undefined, false, false, 0);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17sed__cycle__error(self, cycle, message) {
  _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `${message}\n`);
  self.exit_code = 1;
  cycle.deleted = true;
  cycle.stop_after_cycle = true;
  return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction10BreakCycle__;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter32sed__execute__append__next__line(runtime, cycle, line_idx) {
  const next_idx = (line_idx + cycle.consumed_extra | 0) + 1 | 0;
  if (next_idx < runtime.total_lines) {
    cycle.line = `${cycle.line}\n${_M0MPC15array5Array2atGUssEE(runtime.lines, next_idx)._0}`;
    cycle.line_terminated = _M0MPC15array5Array2atGUssEE(runtime.lines, next_idx)._1;
    cycle.consumed_extra = cycle.consumed_extra + 1 | 0;
    cycle.line_no = next_idx + 1 | 0;
    return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next__;
  } else {
    cycle.stop_after_cycle = true;
    return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction10BreakCycle__;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter26sed__execute__change__text(runtime, state, cycle, text) {
  state.pending_no_newline = _M0FP410Haoxincode8moonbash3lib11interpreter16sed__emit__chunk(runtime.out, text, true, state.pending_no_newline);
  cycle.deleted = true;
  return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction10BreakCycle__;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter31sed__tick__remaining__addresses(runtime, cycle, start_idx, last_regex) {
  let next_last = last_regex;
  let _tmp$38 = start_idx + 1 | 0;
  while (true) {
    const rest_idx = _tmp$38;
    if (rest_idx < runtime.commands.length) {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter27sed__address__tick__skipped(_M0MPC15array5Array2atGUssEE(runtime.commands, rest_idx).address, cycle.line, cycle.line_no, runtime.total_lines, _M0MPC15array5Array2atGUssEE(runtime.range_states, rest_idx), next_last);
      const _next_state = _bind$4._0;
      const _tick_last_regex = _bind$4._1;
      _M0MPC15array5Array3setGsE(runtime.range_states, rest_idx, _next_state);
      next_last = _tick_last_regex;
      _tmp$38 = rest_idx + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return next_last;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter20sed__execute__delete(runtime, state, cycle, cmd_idx) {
  state.last_regex = _M0FP410Haoxincode8moonbash3lib11interpreter31sed__tick__remaining__addresses(runtime, cycle, cmd_idx, state.last_regex);
  cycle.deleted = true;
  return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction10BreakCycle__;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter33sed__execute__delete__first__line(runtime, state, cycle, cmd_idx) {
  const nl_idx = _M0FP410Haoxincode8moonbash3lib11interpreter18sed__find__newline(cycle.line);
  if (nl_idx < 0) {
    state.last_regex = _M0FP410Haoxincode8moonbash3lib11interpreter31sed__tick__remaining__addresses(runtime, cycle, cmd_idx, state.last_regex);
    cycle.deleted = true;
    return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction10BreakCycle__;
  } else {
    cycle.line = _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(cycle.line, nl_idx + 1 | 0, cycle.line.length);
    return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction12RestartCycle__;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter28sed__execute__exchange__hold(state, cycle) {
  const old_line = cycle.line;
  cycle.line = state.hold_space;
  state.hold_space = old_line;
  cycle.line_terminated = true;
  return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next__;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter26sed__execute__hold__append(state, cycle) {
  state.hold_space = state.hold_space.length === 0 ? cycle.line : `${state.hold_space}\n${cycle.line}`;
  return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next__;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter31sed__execute__hold__append__get(state, cycle) {
  cycle.line = `${cycle.line}\n${state.hold_space}`;
  cycle.line_terminated = true;
  return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next__;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter23sed__execute__hold__get(state, cycle) {
  cycle.line = state.hold_space;
  cycle.line_terminated = true;
  return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next__;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter23sed__execute__hold__set(state, cycle) {
  state.hold_space = cycle.line;
  return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next__;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter26sed__execute__insert__text(runtime, state, text) {
  state.pending_no_newline = _M0FP410Haoxincode8moonbash3lib11interpreter16sed__emit__chunk(runtime.out, text, true, state.pending_no_newline);
  return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next__;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter32sed__execute__next__line_2einner(runtime, state, cycle, line_idx, quiet) {
  if (!quiet) {
    state.pending_no_newline = _M0FP410Haoxincode8moonbash3lib11interpreter16sed__emit__chunk(runtime.out, cycle.line, cycle.line_terminated, state.pending_no_newline);
  }
  const _bind$4 = cycle.append_queue;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const text = _bind$4[_];
      state.pending_no_newline = _M0FP410Haoxincode8moonbash3lib11interpreter16sed__emit__chunk(runtime.out, text, true, state.pending_no_newline);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  cycle.append_queue = [];
  const next_idx = (line_idx + cycle.consumed_extra | 0) + 1 | 0;
  if (next_idx >= runtime.total_lines) {
    cycle.deleted = true;
    cycle.stop_after_cycle = true;
    return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction10BreakCycle__;
  } else {
    cycle.line = _M0MPC15array5Array2atGUssEE(runtime.lines, next_idx)._0;
    cycle.line_terminated = _M0MPC15array5Array2atGUssEE(runtime.lines, next_idx)._1;
    cycle.consumed_extra = cycle.consumed_extra + 1 | 0;
    cycle.line_no = next_idx + 1 | 0;
    cycle.substituted = false;
    return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next__;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter32sed__execute__print__first__line(runtime, state, cycle) {
  const nl_idx = _M0FP410Haoxincode8moonbash3lib11interpreter18sed__find__newline(cycle.line);
  if (nl_idx < 0) {
    state.pending_no_newline = _M0FP410Haoxincode8moonbash3lib11interpreter16sed__emit__chunk(runtime.out, cycle.line, cycle.line_terminated, state.pending_no_newline);
  } else {
    state.pending_no_newline = _M0FP410Haoxincode8moonbash3lib11interpreter16sed__emit__chunk(runtime.out, _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(cycle.line, 0, nl_idx), true, state.pending_no_newline);
  }
  return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next__;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter33sed__execute__print__line__number(runtime, state, cycle) {
  state.pending_no_newline = _M0FP410Haoxincode8moonbash3lib11interpreter16sed__emit__chunk(runtime.out, _M0MPC13int3Int18to__string_2einner(cycle.line_no, 10), true, state.pending_no_newline);
  return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next__;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter28sed__execute__print__pattern(runtime, state, cycle) {
  state.pending_no_newline = _M0FP410Haoxincode8moonbash3lib11interpreter16sed__emit__chunk(runtime.out, cycle.line, cycle.line_terminated, state.pending_no_newline);
  return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next__;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter26sed__execute__quit_2einner(runtime, state, cycle, quiet) {
  if (!quiet) {
    state.pending_no_newline = _M0FP410Haoxincode8moonbash3lib11interpreter16sed__emit__chunk(runtime.out, cycle.line, cycle.line_terminated, state.pending_no_newline);
  }
  cycle.deleted = true;
  state.quit = true;
  return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Quit__;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19sed__branch__action(self, runtime, cycle, label) {
  if (label === undefined) {
    return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction10BreakCycle__;
  } else {
    const _Some = label;
    const _name = _Some;
    const target = _M0FP410Haoxincode8moonbash3lib11interpreter23sed__find__label__index(runtime.label_names, runtime.label_indices, _name);
    return target < 0 ? _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17sed__cycle__error(self, cycle, `sed: can't find label ${_name}`) : new _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction6JumpTo(target);
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext41sed__execute__conditional__branch_2einner(self, runtime, cycle, label, branch_on_subst) {
  const should_branch = branch_on_subst ? cycle.substituted : !cycle.substituted;
  cycle.substituted = false;
  return should_branch ? _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19sed__branch__action(self, runtime, cycle, label) : _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next__;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24sed__execute__substitute(self, runtime, state, cycle, subst) {
  const _bind$4 = subst.matcher;
  let matcher;
  if (_bind$4 === undefined) {
    const _bind$5 = state.last_regex;
    if (_bind$5 === undefined) {
      return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17sed__cycle__error(self, cycle, "sed: no previous regular expression");
    } else {
      const _Some = _bind$5;
      matcher = _Some;
    }
  } else {
    const _Some = _bind$4;
    const _explicit_matcher = _Some;
    state.last_regex = _explicit_matcher;
    matcher = _explicit_matcher;
  }
  const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter29sed__substitute__line_2einner(cycle.line, matcher, subst.replacement, subst.global, subst.occurrence, subst.literal_ampersand);
  const _new_line = _bind$5._0;
  const _replaced = _bind$5._1;
  cycle.line = _new_line;
  if (_replaced) {
    cycle.substituted = true;
    if (subst.print_on_subst) {
      state.pending_no_newline = _M0FP410Haoxincode8moonbash3lib11interpreter16sed__emit__chunk(runtime.out, cycle.line, cycle.line_terminated, state.pending_no_newline);
    }
    const _bind$6 = subst.write_file;
    if (_bind$6 === undefined) {
    } else {
      const _Some = _bind$6;
      const _path = _Some;
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18sed__append__write(self, _path, cycle.line, cycle.line_terminated);
    }
  }
  return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next__;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter28parse__sed__version__triplet(text) {
  const trimmed = _M0FP410Haoxincode8moonbash3lib11interpreter18trim__ascii__space(text);
  if (trimmed.length === 0) {
    return undefined;
  }
  const parts = [];
  let segment_start = 0;
  let i = 0;
  while (true) {
    if (i <= trimmed.length) {
      const at_end = i === trimmed.length;
      let ch;
      if (at_end) {
        ch = 46;
      } else {
        const _tmp$38 = i;
        $bound_check(trimmed, _tmp$38);
        ch = trimmed.charCodeAt(_tmp$38);
      }
      if (ch === 46 || at_end) {
        if (i === segment_start) {
          return undefined;
        }
        const segment = _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(trimmed, segment_start, i);
        let _tmp$38 = 0;
        while (true) {
          const j = _tmp$38;
          if (j < segment.length) {
            $bound_check(segment, j);
            const digit = segment.charCodeAt(j);
            if (digit < 48 || digit > 57) {
              return undefined;
            }
            _tmp$38 = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        _M0MPC15array5Array4pushGiE(parts, _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(segment));
        if (parts.length > 3) {
          return undefined;
        }
        segment_start = i + 1 | 0;
      } else {
        if (ch < 48 || ch > 57) {
          return undefined;
        }
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (parts.length === 0) {
    return undefined;
  }
  const major = _M0MPC15array5Array2atGiE(parts, 0);
  const minor = parts.length >= 2 ? _M0MPC15array5Array2atGiE(parts, 1) : 0;
  const patch = parts.length >= 3 ? _M0MPC15array5Array2atGiE(parts, 2) : 0;
  return { _0: major, _1: minor, _2: patch };
}
function _M0FP410Haoxincode8moonbash3lib11interpreter23sed__version__supported(required) {
  if (required === undefined) {
    return true;
  } else {
    const _Some = required;
    const _text = _Some;
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter28parse__sed__version__triplet(_text);
    if (_bind$4 === undefined) {
      return false;
    } else {
      const _Some$2 = _bind$4;
      const _x = _Some$2;
      const _major = _x._0;
      const _minor = _x._1;
      const _patch = _x._2;
      return _major < 4 ? true : _major > 4 ? false : _minor < 5 ? true : _minor > 5 ? false : _patch <= 3;
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext28sed__execute__version__check(self, cycle, required) {
  return !_M0FP410Haoxincode8moonbash3lib11interpreter23sed__version__supported(required) ? _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17sed__cycle__error(self, cycle, "sed: version check failed") : _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next__;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext34sed__execute__one__command_2einner(self, runtime, state, cycle, cmd, cmd_idx, line_idx, quiet) {
  _L: {
    const _bind$4 = cmd.kind;
    switch (_bind$4.$tag) {
      case 0: {
        break _L;
      }
      case 1: {
        break _L;
      }
      case 2: {
        return _M0FP410Haoxincode8moonbash3lib11interpreter20sed__execute__delete(runtime, state, cycle, cmd_idx);
      }
      case 3: {
        return _M0FP410Haoxincode8moonbash3lib11interpreter33sed__execute__delete__first__line(runtime, state, cycle, cmd_idx);
      }
      case 4: {
        const _Substitute = _bind$4;
        const _subst = _Substitute._0;
        return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24sed__execute__substitute(self, runtime, state, cycle, _subst);
      }
      case 5: {
        return _M0FP410Haoxincode8moonbash3lib11interpreter32sed__execute__append__next__line(runtime, cycle, line_idx);
      }
      case 6: {
        return _M0FP410Haoxincode8moonbash3lib11interpreter32sed__execute__next__line_2einner(runtime, state, cycle, line_idx, quiet);
      }
      case 7: {
        const _Transliterate = _bind$4;
        const _spec = _Transliterate._0;
        cycle.line = _M0FP410Haoxincode8moonbash3lib11interpreter24sed__transliterate__line(cycle.line, _spec.source, _spec.target);
        return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next__;
      }
      case 8: {
        return _M0FP410Haoxincode8moonbash3lib11interpreter28sed__execute__print__pattern(runtime, state, cycle);
      }
      case 9: {
        return _M0FP410Haoxincode8moonbash3lib11interpreter32sed__execute__print__first__line(runtime, state, cycle);
      }
      case 10: {
        return _M0FP410Haoxincode8moonbash3lib11interpreter33sed__execute__print__line__number(runtime, state, cycle);
      }
      case 11: {
        return _M0FP410Haoxincode8moonbash3lib11interpreter23sed__execute__hold__set(state, cycle);
      }
      case 12: {
        return _M0FP410Haoxincode8moonbash3lib11interpreter26sed__execute__hold__append(state, cycle);
      }
      case 13: {
        return _M0FP410Haoxincode8moonbash3lib11interpreter23sed__execute__hold__get(state, cycle);
      }
      case 14: {
        return _M0FP410Haoxincode8moonbash3lib11interpreter31sed__execute__hold__append__get(state, cycle);
      }
      case 15: {
        return _M0FP410Haoxincode8moonbash3lib11interpreter28sed__execute__exchange__hold(state, cycle);
      }
      case 16: {
        const _AppendText = _bind$4;
        const _text = _AppendText._0;
        _M0MPC15array5Array4pushGUssEE(cycle.append_queue, _text);
        return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next__;
      }
      case 17: {
        const _InsertText = _bind$4;
        const _text$2 = _InsertText._0;
        return _M0FP410Haoxincode8moonbash3lib11interpreter26sed__execute__insert__text(runtime, state, _text$2);
      }
      case 18: {
        const _ChangeText = _bind$4;
        const _text$3 = _ChangeText._0;
        return _M0FP410Haoxincode8moonbash3lib11interpreter26sed__execute__change__text(runtime, state, cycle, _text$3);
      }
      case 19: {
        const _WriteFile = _bind$4;
        const _path = _WriteFile._0;
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18sed__append__write(self, _path, cycle.line, cycle.line_terminated);
        return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next__;
      }
      case 20: {
        return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next__;
      }
      case 21: {
        const _Branch = _bind$4;
        const _label = _Branch._0;
        return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19sed__branch__action(self, runtime, cycle, _label);
      }
      case 22: {
        const _BranchIfSubst = _bind$4;
        const _label$2 = _BranchIfSubst._0;
        return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext41sed__execute__conditional__branch_2einner(self, runtime, cycle, _label$2, true);
      }
      case 23: {
        const _BranchIfNotSubst = _bind$4;
        const _label$3 = _BranchIfNotSubst._0;
        return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext41sed__execute__conditional__branch_2einner(self, runtime, cycle, _label$3, false);
      }
      case 24: {
        const _VersionCheck = _bind$4;
        const _required = _VersionCheck._0;
        return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext28sed__execute__version__check(self, cycle, _required);
      }
      default: {
        return _M0FP410Haoxincode8moonbash3lib11interpreter26sed__execute__quit_2einner(runtime, state, cycle, quiet);
      }
    }
  }
  return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next__;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29sed__skip__unmatched__command(self, runtime, cycle, cmd_idx) {
  const _bind$4 = _M0MPC15array5Array2atGUssEE(runtime.commands, cmd_idx).kind;
  if (_bind$4.$tag === 0) {
    const end_idx = _M0FP410Haoxincode8moonbash3lib11interpreter21sed__find__group__end(runtime.commands, cmd_idx);
    return end_idx < 0 ? _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17sed__cycle__error(self, cycle, "sed: invalid script") : new _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction6JumpTo(end_idx + 1 | 0);
  } else {
    return _M0DTP410Haoxincode8moonbash3lib11interpreter11CycleAction4Next__;
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext26sed__render__input_2einner(self, commands, input, quiet) {
  const runtime = _M0FP410Haoxincode8moonbash3lib11interpreter19sed__build__runtime(commands, input);
  const state = _M0FP410Haoxincode8moonbash3lib11interpreter15sed__new__state();
  let line_idx = 0;
  while (true) {
    if (line_idx < runtime.total_lines) {
      const cycle = _M0FP410Haoxincode8moonbash3lib11interpreter15sed__new__cycle(runtime, line_idx);
      let cmd_idx = 0;
      _L: while (true) {
        if (cmd_idx < runtime.commands.length) {
          state.executed_steps = state.executed_steps + 1 | 0;
          if (state.executed_steps > 2000) {
            const action = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17sed__cycle__error(self, cycle, "sed: command limit exceeded");
            if (action.$tag === 2) {
              break;
            }
          }
          const cmd = _M0MPC15array5Array2atGUssEE(runtime.commands, cmd_idx);
          const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter21sed__address__applies(cmd.address, cycle.line, cycle.line_no, runtime.total_lines, _M0MPC15array5Array2atGUssEE(runtime.range_states, cmd_idx), state.last_regex);
          const _applies = _bind$4._0;
          const _next_state = _bind$4._1;
          const _next_last_regex = _bind$4._2;
          _M0MPC15array5Array3setGsE(runtime.range_states, cmd_idx, _next_state);
          state.last_regex = _next_last_regex;
          const should_apply = cmd.negated ? !_applies : _applies;
          const action = should_apply ? _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext34sed__execute__one__command_2einner(self, runtime, state, cycle, cmd, cmd_idx, line_idx, quiet) : _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29sed__skip__unmatched__command(self, runtime, cycle, cmd_idx);
          _L$2: {
            _L$3: {
              switch (action.$tag) {
                case 0: {
                  cmd_idx = cmd_idx + 1 | 0;
                  break;
                }
                case 1: {
                  cmd_idx = 0;
                  continue _L;
                }
                case 3: {
                  const _JumpTo = action;
                  const _target = _JumpTo._0;
                  cmd_idx = _target;
                  continue _L;
                }
                case 2: {
                  break _L$3;
                }
                default: {
                  break _L$3;
                }
              }
              break _L$2;
            }
            break;
          }
          continue;
        } else {
          break;
        }
      }
      if (!cycle.deleted && !quiet) {
        state.pending_no_newline = _M0FP410Haoxincode8moonbash3lib11interpreter16sed__emit__chunk(runtime.out, cycle.line, cycle.line_terminated, state.pending_no_newline);
      }
      const _bind$4 = cycle.append_queue;
      const _bind$5 = _bind$4.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$5) {
          const text = _bind$4[_];
          state.pending_no_newline = _M0FP410Haoxincode8moonbash3lib11interpreter16sed__emit__chunk(runtime.out, text, true, state.pending_no_newline);
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      line_idx = line_idx + (cycle.consumed_extra + 1 | 0) | 0;
      if (state.quit || cycle.stop_after_cycle) {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  const _p$4 = runtime.out;
  return { _0: _p$4.val, _1: state.pending_no_newline };
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__sed(self, args) {
  const _bind$4 = args.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const arg = args[_];
      if (_M0FP410Haoxincode8moonbash3lib11interpreter18trim__ascii__space(arg) === "...") {
        _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "sed: invalid script\n");
        self.exit_code = 1;
        return undefined;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const expressions = [];
  const files = [];
  let script_taken = false;
  let inplace = false;
  let extended = false;
  let quiet = false;
  let i = 0;
  while (true) {
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      if (arg === "-i" || _M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__sedN7_2abindS5344, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__sedN7_2abindS5344.length)) && (arg.length > 1 && !script_taken)) {
        inplace = true;
      } else {
        if (arg === "-n") {
          quiet = true;
        } else {
          if (arg === "-E" || arg === "-r") {
            extended = true;
          } else {
            let _tmp$39;
            if (arg.length > 2) {
              let _tmp$40;
              $bound_check(arg, 0);
              const _p$4 = arg.charCodeAt(0);
              const _p$5 = 45;
              if (_p$4 === _p$5) {
                _tmp$40 = !script_taken;
              } else {
                _tmp$40 = false;
              }
              _tmp$39 = _tmp$40;
            } else {
              _tmp$39 = false;
            }
            if (_tmp$39) {
              let handled_bundle = true;
              let treat_as_script = false;
              let j = 1;
              while (true) {
                if (j < arg.length) {
                  const _tmp$40 = j;
                  $bound_check(arg, _tmp$40);
                  const flag = arg.charCodeAt(_tmp$40);
                  if (flag === 110) {
                    quiet = true;
                    j = j + 1 | 0;
                  } else {
                    if (flag === 69 || flag === 114) {
                      extended = true;
                      j = j + 1 | 0;
                    } else {
                      if (flag === 105) {
                        inplace = true;
                        j = j + 1 | 0;
                      } else {
                        if (flag === 101) {
                          if ((j + 1 | 0) < arg.length) {
                            _M0MPC15array5Array4pushGUssEE(expressions, _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, j + 1 | 0, undefined)));
                          } else {
                            if ((i + 1 | 0) < args.length) {
                              i = i + 1 | 0;
                              _M0MPC15array5Array4pushGUssEE(expressions, _M0MPC15array5Array2atGUssEE(args, i));
                            } else {
                              _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "sed: option requires an argument -- e\n");
                              self.exit_code = 1;
                              return undefined;
                            }
                          }
                          script_taken = true;
                          break;
                        } else {
                          handled_bundle = false;
                          treat_as_script = true;
                          break;
                        }
                      }
                    }
                  }
                  continue;
                } else {
                  break;
                }
              }
              if (treat_as_script) {
                let candidate = arg;
                let consumed = 0;
                let parsed = _M0FP410Haoxincode8moonbash3lib11interpreter36parse__sed__script__commands_2einner(candidate, extended);
                while (true) {
                  const _bind$5 = parsed;
                  if (_bind$5.$tag === 0) {
                    if (((i + consumed | 0) + 1 | 0) < args.length) {
                      consumed = consumed + 1 | 0;
                      candidate = `${candidate} ${_M0MPC15array5Array2atGUssEE(args, i + consumed | 0)}`;
                      parsed = _M0FP410Haoxincode8moonbash3lib11interpreter36parse__sed__script__commands_2einner(candidate, extended);
                      continue;
                    } else {
                      break;
                    }
                  } else {
                    break;
                  }
                }
                const _bind$5 = parsed;
                if (_bind$5.$tag === 1) {
                  _M0MPC15array5Array4pushGUssEE(expressions, candidate);
                  i = i + consumed | 0;
                } else {
                  _M0MPC15array5Array4pushGUssEE(expressions, arg);
                }
                script_taken = true;
              } else {
                if (!handled_bundle) {
                  let candidate = arg;
                  let consumed = 0;
                  let parsed = _M0FP410Haoxincode8moonbash3lib11interpreter36parse__sed__script__commands_2einner(candidate, extended);
                  while (true) {
                    const _bind$5 = parsed;
                    if (_bind$5.$tag === 0) {
                      if (((i + consumed | 0) + 1 | 0) < args.length) {
                        consumed = consumed + 1 | 0;
                        candidate = `${candidate} ${_M0MPC15array5Array2atGUssEE(args, i + consumed | 0)}`;
                        parsed = _M0FP410Haoxincode8moonbash3lib11interpreter36parse__sed__script__commands_2einner(candidate, extended);
                        continue;
                      } else {
                        break;
                      }
                    } else {
                      break;
                    }
                  }
                  const _bind$5 = parsed;
                  if (_bind$5.$tag === 1) {
                    _M0MPC15array5Array4pushGUssEE(expressions, candidate);
                    i = i + consumed | 0;
                  } else {
                    _M0MPC15array5Array4pushGUssEE(expressions, arg);
                  }
                  script_taken = true;
                }
              }
            } else {
              if (arg === "-e" && (i + 1 | 0) < args.length) {
                i = i + 1 | 0;
                _M0MPC15array5Array4pushGUssEE(expressions, _M0MPC15array5Array2atGUssEE(args, i));
                script_taken = true;
              } else {
                if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__sedN7_2abindS5364, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__sedN7_2abindS5364.length)) && arg.length > 2) {
                  _M0MPC15array5Array4pushGUssEE(expressions, _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined)));
                  script_taken = true;
                } else {
                  if (!script_taken) {
                    let candidate = arg;
                    let consumed = 0;
                    let parsed = _M0FP410Haoxincode8moonbash3lib11interpreter36parse__sed__script__commands_2einner(candidate, extended);
                    while (true) {
                      const _bind$5 = parsed;
                      if (_bind$5.$tag === 0) {
                        if (((i + consumed | 0) + 1 | 0) < args.length) {
                          consumed = consumed + 1 | 0;
                          candidate = `${candidate} ${_M0MPC15array5Array2atGUssEE(args, i + consumed | 0)}`;
                          parsed = _M0FP410Haoxincode8moonbash3lib11interpreter36parse__sed__script__commands_2einner(candidate, extended);
                          continue;
                        } else {
                          break;
                        }
                      } else {
                        break;
                      }
                    }
                    const _bind$5 = parsed;
                    if (_bind$5.$tag === 1) {
                      _M0MPC15array5Array4pushGUssEE(expressions, candidate);
                      i = i + consumed | 0;
                    } else {
                      _M0MPC15array5Array4pushGUssEE(expressions, arg);
                    }
                    script_taken = true;
                  } else {
                    _M0MPC15array5Array4pushGUssEE(files, arg);
                  }
                }
              }
            }
          }
        }
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (expressions.length === 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "sed: missing script\n");
    self.exit_code = 1;
    return undefined;
  }
  const _bind$5 = expressions.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$5) {
      const expr = expressions[_];
      const _bind$6 = _M0FP410Haoxincode8moonbash3lib11interpreter30parse__sed__inline__directives(expr);
      if (_bind$6 === undefined) {
      } else {
        const _Some = _bind$6;
        const _x = _Some;
        const _quiet_directive = _x._0;
        const _extended_directive = _x._1;
        if (_quiet_directive) {
          quiet = true;
        }
        if (_extended_directive) {
          extended = true;
        }
      }
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const script_builder = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$40 = 0;
  while (true) {
    const idx = _tmp$40;
    if (idx < expressions.length) {
      const normalized_expr = _M0FP410Haoxincode8moonbash3lib11interpreter17trim__ascii__left(_M0MPC15array5Array2atGUssEE(expressions, idx));
      if (normalized_expr === "...") {
        _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "sed: invalid script\n");
        self.exit_code = 1;
        return undefined;
      }
      if (idx > 0) {
        _M0IPB13StringBuilderPB6Logger11write__char(script_builder, 10);
      }
      _M0IPB13StringBuilderPB6Logger13write__string(script_builder, _M0MPC15array5Array2atGUssEE(expressions, idx));
      _tmp$40 = idx + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const script = script_builder.val;
  const _bind$6 = _M0FP410Haoxincode8moonbash3lib11interpreter36parse__sed__script__commands_2einner(script, extended);
  let commands;
  if (_bind$6.$tag === 1) {
    const _Some = _bind$6;
    commands = _Some._0;
  } else {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "sed: invalid script\n");
    self.exit_code = 1;
    return undefined;
  }
  const _bind$7 = _M0FP410Haoxincode8moonbash3lib11interpreter33sed__find__missing__branch__label(commands);
  if (_bind$7 === undefined) {
  } else {
    const _Some = _bind$7;
    const _name = _Some;
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `sed: can't find label ${_name}\n`);
    self.exit_code = 1;
    return undefined;
  }
  if (inplace && files.length === 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "sed: no input files\n");
    self.exit_code = 1;
    return undefined;
  }
  const input_paths = [];
  const inputs = [];
  if (files.length === 0) {
    _M0MPC15array5Array4pushGUssEE(inputs, self.stdin_buf);
    _M0MPC15array5Array4pushGUssEE(input_paths, "");
  } else {
    let stdin_used = false;
    const _bind$8 = files.length;
    let _tmp$41 = 0;
    while (true) {
      const _ = _tmp$41;
      if (_ < _bind$8) {
        const path = files[_];
        _L: {
          if (path === "-") {
            if (stdin_used) {
              _M0MPC15array5Array4pushGUssEE(inputs, "");
            } else {
              _M0MPC15array5Array4pushGUssEE(inputs, self.stdin_buf);
              stdin_used = true;
            }
            _M0MPC15array5Array4pushGUssEE(input_paths, "");
            break _L;
          }
          let resolved;
          let _try_err;
          _L$2: {
            _L$3: {
              const _bind$9 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, path);
              if (_bind$9.$tag === 1) {
                const _ok = _bind$9;
                resolved = _ok._0;
              } else {
                const _err = _bind$9;
                _try_err = _err._0;
                break _L$3;
              }
              break _L$2;
            }
            resolved = path;
          }
          let content;
          let _try_err$2;
          _L$3: {
            _L$4: {
              const _bind$9 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(self.fs, resolved);
              if (_bind$9.$tag === 1) {
                const _ok = _bind$9;
                content = _ok._0;
              } else {
                const _err = _bind$9;
                _try_err$2 = _err._0;
                break _L$4;
              }
              break _L$3;
            }
            const _FsError = _try_err$2;
            const _msg = _FsError._0;
            _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `sed: ${_msg}\n`);
            self.exit_code = 1;
            return undefined;
          }
          _M0MPC15array5Array4pushGUssEE(inputs, content);
          _M0MPC15array5Array4pushGUssEE(input_paths, resolved);
          break _L;
        }
        _tmp$41 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  if (inplace) {
    let _tmp$41 = 0;
    while (true) {
      const idx = _tmp$41;
      if (idx < inputs.length) {
        const _bind$8 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext26sed__render__input_2einner(self, commands, _M0MPC15array5Array2atGUssEE(inputs, idx), quiet);
        const _rendered = _bind$8._0;
        if (self.exit_code !== 0) {
          return undefined;
        }
        if (_M0MPC15array5Array2atGUssEE(input_paths, idx).length > 0) {
          let _try_err;
          _L: {
            _L$2: {
              const _bind$9 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs11write__file(self.fs, _M0MPC15array5Array2atGUssEE(input_paths, idx), _rendered);
              if (_bind$9.$tag === 1) {
                const _ok = _bind$9;
                _ok._0;
              } else {
                const _err = _bind$9;
                _try_err = _err._0;
                break _L$2;
              }
              break _L;
            }
            const _FsError = _try_err;
            const _msg = _FsError._0;
            _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `sed: ${_msg}\n`);
            self.exit_code = 1;
            return undefined;
          }
        }
        _tmp$41 = idx + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  } else {
    const merged_input = _M0MPB13StringBuilder21StringBuilder_2einner(0);
    let prev_missing_newline = false;
    let _tmp$41 = 0;
    while (true) {
      const idx = _tmp$41;
      if (idx < inputs.length) {
        const chunk = _M0MPC15array5Array2atGUssEE(inputs, idx);
        if (idx > 0 && (prev_missing_newline && chunk.length > 0)) {
          _M0IPB13StringBuilderPB6Logger11write__char(merged_input, 10);
        }
        _M0IPB13StringBuilderPB6Logger13write__string(merged_input, chunk);
        let _tmp$42;
        if (chunk.length > 0) {
          const _tmp$43 = chunk.length - 1 | 0;
          $bound_check(chunk, _tmp$43);
          _tmp$42 = chunk.charCodeAt(_tmp$43) !== 10;
        } else {
          _tmp$42 = false;
        }
        prev_missing_newline = _tmp$42;
        _tmp$41 = idx + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    const _bind$8 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext26sed__render__input_2einner(self, commands, merged_input.val, quiet);
    const _rendered = _bind$8._0;
    if (self.exit_code !== 0) {
      return undefined;
    }
    _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _rendered);
  }
  self.exit_code = 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter27json__bridge__string__array(raw) {
  const values = [];
  let parsed;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FPC14json13parse_2einner(new _M0TPC16string10StringView(raw, 0, raw.length), 1024);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        parsed = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    return values;
  }
  if (parsed.$tag === 5) {
    const _Array = parsed;
    const _items = _Array._0;
    const _bind$4 = _items.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$4) {
        const item = _items[_];
        switch (item.$tag) {
          case 4: {
            const _String = item;
            const _s = _String._0;
            _M0MPC15array5Array4pushGUssEE(values, _s);
            break;
          }
          case 3: {
            const _Number = item;
            const _n = _Number._0;
            _M0MPC15array5Array4pushGUssEE(values, _M0MPC13int3Int18to__string_2einner(_M0MPC16double6Double7to__int(_n), 10));
            break;
          }
          case 1: {
            _M0MPC15array5Array4pushGUssEE(values, "true");
            break;
          }
          case 2: {
            _M0MPC15array5Array4pushGUssEE(values, "false");
            break;
          }
          case 0: {
            _M0MPC15array5Array4pushGUssEE(values, "");
            break;
          }
          default: {
            _M0MPC15array5Array4pushGUssEE(values, _M0MPC14json4Json17stringify_2einner(item, false, 0, undefined));
          }
        }
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  return values;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter15fd__output__key(fd) {
  return `__MOON_BASH_FD_OUT__${_M0MPC13int3Int18to__string_2einner(fd, 10)}`;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter25parse__fd__target__number(text) {
  if (text.length === 0) {
    return undefined;
  }
  let value = 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < text.length) {
      $bound_check(text, i);
      const ch = text.charCodeAt(i);
      if (ch < 48 || ch > 57) {
        return undefined;
      }
      value = (Math.imul(value, 10) | 0) + (ch - 48 | 0) | 0;
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return value;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter27decode__fd__output__mapping(spec) {
  if (spec.length < 3) {
    return undefined;
  }
  $bound_check(spec, 0);
  const mode = spec.charCodeAt(0);
  $bound_check(spec, 1);
  if (spec.charCodeAt(1) !== 58) {
    return undefined;
  }
  const path = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(spec, 2, undefined));
  return mode === 65 ? { _0: path, _1: true } : mode === 87 ? { _0: path, _1: false } : undefined;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext26store__fd__output__mapping(self, fd, target, append) {
  _M0MPB3Map3setGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter15fd__output__key(fd), append ? `A:${target}` : `W:${target}`);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25load__fd__output__mapping(self, target) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter25parse__fd__target__number(target);
  if (_bind$4 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$4;
    const _fd = _Some;
    const _bind$5 = _M0MPB3Map3getGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter15fd__output__key(_fd));
    if (_bind$5 === undefined) {
      return undefined;
    } else {
      const _Some$2 = _bind$5;
      const _spec = _Some$2;
      return _M0FP410Haoxincode8moonbash3lib11interpreter27decode__fd__output__mapping(_spec);
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20consume__extra__args(self) {
  const _bind$4 = _M0MPB3Map3getGssE(self.env, "__MOON_BASH_EXTRA_ARGS");
  if (_bind$4 === undefined) {
    return [];
  } else {
    const _Some = _bind$4;
    const _raw = _Some;
    _M0MPB3Map6removeGssE(self.env, "__MOON_BASH_EXTRA_ARGS");
    return _M0FP410Haoxincode8moonbash3lib11interpreter27json__bridge__string__array(_raw);
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter46array__assignment__item__is__invalid__operator(item_word) {
  if (item_word.parts.length !== 1) {
    return false;
  }
  const _bind$4 = _M0MPC15array5Array2atGUssEE(item_word.parts, 0);
  if (_bind$4.$tag === 0) {
    const _Literal = _bind$4;
    const _token = _Literal._0;
    return _token === "&" || (_token === "|" || (_token === "&&" || (_token === "||" || _token === ";")));
  } else {
    return false;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter22is__valid__shell__name(name) {
  if (name.length === 0) {
    return false;
  }
  $bound_check(name, 0);
  const first = name.charCodeAt(0);
  if (!(first >= 97 && first <= 122 || (first >= 65 && first <= 90 || first === 95))) {
    return false;
  }
  let _tmp$38 = 1;
  while (true) {
    const i = _tmp$38;
    if (i < name.length) {
      $bound_check(name, i);
      const ch = name.charCodeAt(i);
      if (!(ch >= 97 && ch <= 122 || (ch >= 65 && ch <= 90 || (ch >= 48 && ch <= 57 || ch === 95)))) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter40split__array__assignment__flush__literal(current_parts, literal_buf) {
  const lit = literal_buf.val;
  if (lit.length > 0) {
    _M0MPC15array5Array4pushGUssEE(current_parts, new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart7Literal(lit));
    _M0MPB13StringBuilder5reset(literal_buf);
    return;
  } else {
    return;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter31split__array__assignment__items(parts) {
  const items = [];
  let current_parts = [];
  const literal_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let started = false;
  let ended = false;
  const _bind$4 = parts.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const part = parts[_];
      if (part.$tag === 0) {
        const _Literal = part;
        const _text = _Literal._0;
        let _tmp$39 = 0;
        while (true) {
          const i = _tmp$39;
          if (i < _text.length) {
            _L: {
              $bound_check(_text, i);
              const ch = _text.charCodeAt(i);
              if (!started) {
                if (ch === 32 || (ch === 9 || ch === 10)) {
                  break _L;
                }
                if (ch === 40) {
                  started = true;
                  break _L;
                }
                return _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast4WordEE4None__;
              }
              if (ended) {
                if (ch === 32 || (ch === 9 || ch === 10)) {
                  break _L;
                }
                return _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast4WordEE4None__;
              }
              if (ch === 41) {
                _M0FP410Haoxincode8moonbash3lib11interpreter40split__array__assignment__flush__literal(current_parts, literal_buf);
                if (current_parts.length > 0) {
                  _M0MPC15array5Array4pushGUssEE(items, new _M0TP410Haoxincode8moonbash3lib3ast4Word(current_parts));
                  current_parts = [];
                }
                ended = true;
                break _L;
              }
              if (ch === 32 || (ch === 9 || ch === 10)) {
                _M0FP410Haoxincode8moonbash3lib11interpreter40split__array__assignment__flush__literal(current_parts, literal_buf);
                if (current_parts.length > 0) {
                  _M0MPC15array5Array4pushGUssEE(items, new _M0TP410Haoxincode8moonbash3lib3ast4Word(current_parts));
                  current_parts = [];
                }
                break _L;
              }
              _M0IPB13StringBuilderPB6Logger11write__char(literal_buf, ch);
              break _L;
            }
            _tmp$39 = i + 1 | 0;
            continue;
          } else {
            break;
          }
        }
      } else {
        if (!started || ended) {
          return _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast4WordEE4None__;
        }
        _M0FP410Haoxincode8moonbash3lib11interpreter40split__array__assignment__flush__literal(current_parts, literal_buf);
        _M0MPC15array5Array4pushGUssEE(current_parts, part);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (!started || !ended) {
    return _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast4WordEE4None__;
  }
  if (current_parts.length > 0 || literal_buf.val.length > 0) {
    return _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast4WordEE4None__;
  }
  return new _M0DTPC16option6OptionGRPB5ArrayGRP410Haoxincode8moonbash3lib3ast4WordEE4Some(items);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter42array__assignment__word__has__quoted__part(parts) {
  const _bind$4 = parts.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const part = parts[_];
      switch (part.$tag) {
        case 1: {
          return true;
        }
        case 2: {
          return true;
        }
        case 7: {
          const _BraceExpansion = part;
          const _options = _BraceExpansion._0;
          const _bind$5 = _options.length;
          let _tmp$39 = 0;
          while (true) {
            const _$2 = _tmp$39;
            if (_$2 < _bind$5) {
              const option = _options[_$2];
              if (_M0FP410Haoxincode8moonbash3lib11interpreter42array__assignment__word__has__quoted__part(option)) {
                return true;
              }
              _tmp$39 = _$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          break;
        }
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter39find__array__assignment__close__bracket(token) {
  let depth = 1;
  let in_single = false;
  let in_double = false;
  let escaped = false;
  let _tmp$38 = 1;
  while (true) {
    const i = _tmp$38;
    if (i < token.length) {
      _L: {
        $bound_check(token, i);
        const ch = token.charCodeAt(i);
        if (escaped) {
          escaped = false;
          break _L;
        }
        if (in_single) {
          if (ch === 39) {
            in_single = false;
          }
          break _L;
        }
        if (in_double) {
          if (ch === 34) {
            in_double = false;
          } else {
            if (ch === 92) {
              escaped = true;
            }
          }
          break _L;
        }
        if (ch === 39) {
          in_single = true;
          break _L;
        }
        if (ch === 34) {
          in_double = true;
          break _L;
        }
        if (ch === 92) {
          escaped = true;
          break _L;
        }
        if (ch === 91) {
          depth = depth + 1 | 0;
          break _L;
        }
        if (ch === 93) {
          depth = depth - 1 | 0;
          if (depth === 0) {
            return i;
          }
        }
        break _L;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter40strip__array__assignment__index__markers(s) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  while (true) {
    if (i < s.length) {
      const _tmp$38 = i;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch === 1) {
        if ((i + 1 | 0) < s.length) {
          const _tmp$39 = i + 1 | 0;
          $bound_check(s, _tmp$39);
          _M0IPB13StringBuilderPB6Logger11write__char(out, s.charCodeAt(_tmp$39));
          i = i + 2 | 0;
        } else {
          i = i + 1 | 0;
        }
        continue;
      }
      if (ch === 2 || ch === 3) {
        i = i + 1 | 0;
        continue;
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter37trim__ascii__space__for__array__index(s) {
  let start = 0;
  let end_ = s.length;
  while (true) {
    if (start < end_) {
      const _tmp$38 = start;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch === 32 || (ch === 9 || (ch === 10 || ch === 13))) {
        start = start + 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (end_ > start) {
      const _tmp$38 = end_ - 1 | 0;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch === 32 || (ch === 9 || (ch === 10 || ch === 13))) {
        end_ = end_ - 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  return _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(s, start, end_));
}
function _M0FP410Haoxincode8moonbash3lib11interpreter35normalize__array__assignment__index(raw_index) {
  const trimmed = _M0FP410Haoxincode8moonbash3lib11interpreter37trim__ascii__space__for__array__index(raw_index);
  const cleaned = _M0FP410Haoxincode8moonbash3lib11interpreter40strip__array__assignment__index__markers(trimmed);
  if (cleaned.length >= 2) {
    $bound_check(cleaned, 0);
    const first = cleaned.charCodeAt(0);
    const _tmp$38 = cleaned.length - 1 | 0;
    $bound_check(cleaned, _tmp$38);
    const last = cleaned.charCodeAt(_tmp$38);
    if (first === 34 && last === 34 || first === 39 && last === 39) {
      return _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(cleaned, 1, cleaned.length - 1 | 0));
    }
  }
  return cleaned;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter41parse__array__assignment__explicit__entry(token) {
  if (token.length < 3) {
    return undefined;
  }
  $bound_check(token, 0);
  if (token.charCodeAt(0) !== 91) {
    return undefined;
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter39find__array__assignment__close__bracket(token);
  let close;
  if (_bind$4 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$4;
    close = _Some;
  }
  let value_start;
  let append_mode;
  _L: {
    let _tmp$38;
    if ((close + 1 | 0) < token.length) {
      const _tmp$39 = close + 1 | 0;
      $bound_check(token, _tmp$39);
      _tmp$38 = token.charCodeAt(_tmp$39) === 61;
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      value_start = close + 2 | 0;
      append_mode = false;
      break _L;
    } else {
      let _tmp$39;
      if ((close + 2 | 0) < token.length) {
        let _tmp$40;
        const _tmp$41 = close + 1 | 0;
        $bound_check(token, _tmp$41);
        if (token.charCodeAt(_tmp$41) === 43) {
          const _tmp$42 = close + 2 | 0;
          $bound_check(token, _tmp$42);
          _tmp$40 = token.charCodeAt(_tmp$42) === 61;
        } else {
          _tmp$40 = false;
        }
        _tmp$39 = _tmp$40;
      } else {
        _tmp$39 = false;
      }
      if (_tmp$39) {
        value_start = close + 3 | 0;
        append_mode = true;
        break _L;
      } else {
        return undefined;
      }
    }
  }
  const raw_key = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(token, 1, close));
  const value = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(token, value_start, undefined));
  const key = _M0FP410Haoxincode8moonbash3lib11interpreter35normalize__array__assignment__index(raw_key);
  return { _0: key, _1: value, _2: append_mode };
}
function _M0FP410Haoxincode8moonbash3lib11interpreter15has__glob__meta(s) {
  let i = 0;
  while (true) {
    if (i < s.length) {
      const _tmp$38 = i;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch === 92 && (i + 1 | 0) < s.length) {
        i = i + 2 | 0;
        continue;
      }
      if (ch === 42 || (ch === 63 || ch === 91)) {
        return true;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter25word__should__apply__glob(parts) {
  const _bind$4 = parts.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const part = parts[_];
      _L: {
        _L$2: {
          switch (part.$tag) {
            case 0: {
              const _Literal = part;
              const _s = _Literal._0;
              if (_M0FP410Haoxincode8moonbash3lib11interpreter15has__glob__meta(_s)) {
                return true;
              }
              break;
            }
            case 3: {
              break _L$2;
            }
            case 4: {
              break _L$2;
            }
            case 5: {
              break _L$2;
            }
            case 7: {
              break _L$2;
            }
            case 8: {
              break _L$2;
            }
            case 9: {
              break _L$2;
            }
            case 6: {
              break;
            }
            case 1: {
              break;
            }
          }
          break _L;
        }
        return true;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter30indirection__array__keys__name(name) {
  if (name.length >= 3) {
    const suffix = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(name, name.length - 3 | 0, name.length));
    if (suffix === "[@]" || suffix === "[*]") {
      const base = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(name, 0, name.length - 3 | 0));
      if (base.length > 0) {
        return base;
      }
    }
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter27is__expand__var__base__name(name) {
  if (name.length === 0) {
    return false;
  }
  $bound_check(name, 0);
  const first = name.charCodeAt(0);
  if (!(first >= 97 && first <= 122 || (first >= 65 && first <= 90 || first === 95))) {
    return false;
  }
  let _tmp$38 = 1;
  while (true) {
    const i = _tmp$38;
    if (i < name.length) {
      $bound_check(name, i);
      const ch = name.charCodeAt(i);
      if (!(ch >= 97 && ch <= 122 || (ch >= 65 && ch <= 90 || (ch >= 48 && ch <= 57 || ch === 95)))) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter29parse__array__reference__name(name) {
  let _tmp$38;
  if (name.length < 3) {
    _tmp$38 = true;
  } else {
    const _tmp$39 = name.length - 1 | 0;
    $bound_check(name, _tmp$39);
    const _p$4 = name.charCodeAt(_tmp$39);
    const _p$5 = 93;
    _tmp$38 = _p$4 !== _p$5;
  }
  if (_tmp$38) {
    return undefined;
  }
  let bracket = -1;
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < name.length) {
      $bound_check(name, i);
      const _p$4 = name.charCodeAt(i);
      const _p$5 = 91;
      if (_p$4 === _p$5) {
        bracket = i;
        break;
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (bracket <= 0) {
    return undefined;
  }
  const base = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(name, 0, bracket));
  if (!_M0FP410Haoxincode8moonbash3lib11interpreter27is__expand__var__base__name(base)) {
    return undefined;
  }
  let depth = 0;
  let _tmp$40 = bracket;
  while (true) {
    const i = _tmp$40;
    if (i < name.length) {
      _L: {
        $bound_check(name, i);
        const ch = name.charCodeAt(i);
        if (ch === 91) {
          depth = depth + 1 | 0;
          break _L;
        }
        if (ch === 93) {
          depth = depth - 1 | 0;
          if (depth < 0) {
            return undefined;
          }
          if (depth === 0 && i !== (name.length - 1 | 0)) {
            return undefined;
          }
        }
        break _L;
      }
      _tmp$40 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (depth !== 0) {
    return undefined;
  }
  const index = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(name, bracket + 1 | 0, name.length - 1 | 0));
  return { _0: base, _1: index };
}
function _M0FP410Haoxincode8moonbash3lib11interpreter31array__reference__base__for__at(part) {
  let name;
  _L: {
    _L$2: {
      switch (part.$tag) {
        case 3: {
          const _Variable = part;
          name = _Variable._0;
          break;
        }
        case 4: {
          const _ParameterExpansion = part;
          const _x = _ParameterExpansion._0;
          switch (_x.$tag) {
            case 0: {
              const _Simple = _x;
              name = _Simple._0;
              break;
            }
            case 12: {
              const _Indirection = _x;
              const _raw = _Indirection._0;
              const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter30indirection__array__keys__name(_raw);
              if (_bind$4 === undefined) {
                return undefined;
              } else {
                const _Some = _bind$4;
                const _base = _Some;
                return { _0: _base, _1: true };
              }
            }
            default: {
              break _L$2;
            }
          }
          break;
        }
        default: {
          break _L$2;
        }
      }
      break _L;
    }
    return undefined;
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter29parse__array__reference__name(name);
  if (_bind$4 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _base = _x._0;
    const _index = _x._1;
    return _index === "@" ? { _0: _base, _1: false } : undefined;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter29is__positional__at__expansion(part) {
  switch (part.$tag) {
    case 3: {
      const _Variable = part;
      const _name = _Variable._0;
      return _name === "@";
    }
    case 4: {
      const _ParameterExpansion = part;
      const _x = _ParameterExpansion._0;
      if (_x.$tag === 0) {
        const _Simple = _x;
        const _name$2 = _Simple._0;
        return _name$2 === "@";
      } else {
        return false;
      }
    }
    default: {
      return false;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter25compare__array__key__text(a, b) {
  const min_len = a.length < b.length ? a.length : b.length;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < min_len) {
      $bound_check(a, i);
      const _tmp$39 = a.charCodeAt(i);
      $bound_check(b, i);
      if (_M0IP016_24default__implPB7Compare6op__ltGkE(_tmp$39, b.charCodeAt(i))) {
        return -1;
      }
      $bound_check(a, i);
      const _tmp$40 = a.charCodeAt(i);
      $bound_check(b, i);
      if (_M0IP016_24default__implPB7Compare6op__gtGkE(_tmp$40, b.charCodeAt(i))) {
        return 1;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return a.length < b.length ? -1 : a.length > b.length ? 1 : 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter32parse__non__negative__array__key(text) {
  if (text.length === 0) {
    return undefined;
  }
  let value = 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < text.length) {
      $bound_check(text, i);
      const ch = text.charCodeAt(i);
      if (ch < 48 || ch > 57) {
        return undefined;
      }
      value = (Math.imul(value, 10) | 0) + (ch - 48 | 0) | 0;
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return value;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter23sort__array__key__names(keys) {
  _M0MPC15array5Array8sort__byGUssEE(keys, (a, b) => {
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter32parse__non__negative__array__key(a);
    const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter32parse__non__negative__array__key(b);
    if (_bind$4 === undefined) {
      return _bind$5 === undefined ? _M0FP410Haoxincode8moonbash3lib11interpreter25compare__array__key__text(a, b) : 1;
    } else {
      const _Some = _bind$4;
      const _ai = _Some;
      if (_bind$5 === undefined) {
        return -1;
      } else {
        const _Some$2 = _bind$5;
        const _bi = _Some$2;
        return _ai < _bi ? -1 : _ai > _bi ? 1 : 0;
      }
    }
  });
}
function _M0FP410Haoxincode8moonbash3lib11interpreter12starts__with(s, prefix) {
  if (prefix.length > s.length) {
    return false;
  }
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < prefix.length) {
      $bound_check(s, i);
      const _p$4 = s.charCodeAt(i);
      $bound_check(prefix, i);
      const _p$5 = prefix.charCodeAt(i);
      if (_p$4 !== _p$5) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20collect__array__keys(self, base) {
  const keys = [];
  const prefix = `${base}[`;
  const _it = _M0MPB3Map5iter2GssE(self.env);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _env_key = _x._0;
      let _tmp$38;
      if (_M0FP410Haoxincode8moonbash3lib11interpreter12starts__with(_env_key, prefix)) {
        let _tmp$39;
        if (_env_key.length > prefix.length) {
          const _tmp$40 = _env_key.length - 1 | 0;
          $bound_check(_env_key, _tmp$40);
          const _p$4 = _env_key.charCodeAt(_tmp$40);
          const _p$5 = 93;
          _tmp$39 = _p$4 === _p$5;
        } else {
          _tmp$39 = false;
        }
        _tmp$38 = _tmp$39;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        const key = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(_env_key, prefix.length, _env_key.length - 1 | 0));
        let _tmp$39;
        const _p$4 = "@";
        if (!(key === _p$4)) {
          const _p$5 = "*";
          _tmp$39 = !(key === _p$5);
        } else {
          _tmp$39 = false;
        }
        if (_tmp$39) {
          _M0MPC15array5Array4pushGUssEE(keys, key);
        }
      }
      continue;
    }
  }
  _M0FP410Haoxincode8moonbash3lib11interpreter23sort__array__key__names(keys);
  return keys;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext35expand__array__elements__for__words(self, base) {
  const keys = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20collect__array__keys(self, base);
  const values = [];
  const _bind$4 = keys.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const key = keys[_];
      const _p$4 = _M0MPB3Map3getGssE(self.env, `${base}[${key}]`);
      const _p$5 = "";
      let _tmp$39;
      if (_p$4 === undefined) {
        _tmp$39 = _p$5;
      } else {
        const _p$6 = _p$4;
        _tmp$39 = _p$6;
      }
      _M0MPC15array5Array4pushGUssEE(values, _tmp$39);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (values.length === 0) {
    const count_key = `__MOON_BASH_ARRAY_COUNT__${base}`;
    if (_M0MPB3Map8containsGssE(self.env, count_key)) {
      return values;
    }
    if (_M0MPB3Map8containsGssE(self.env, base)) {
      const _p$4 = _M0MPB3Map3getGssE(self.env, base);
      const _p$5 = "";
      let _tmp$39;
      if (_p$4 === undefined) {
        _tmp$39 = _p$5;
      } else {
        const _p$6 = _p$4;
        _tmp$39 = _p$6;
      }
      _M0MPC15array5Array4pushGUssEE(values, _tmp$39);
    }
  }
  return values;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter23join__values__with__ifs(values, ifs) {
  const sep = ifs.length === 0 ? "" : _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(ifs, 0, _M0FP410Haoxincode8moonbash3lib11interpreter23join__values__with__ifsN6constrS11265));
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < values.length) {
      if (i > 0) {
        _M0IPB13StringBuilderPB6Logger13write__string(out, sep);
      }
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(values, i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter25join__values__with__space(values) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < values.length) {
      if (i > 0) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 32);
      }
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(values, i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter37parse__indirection__array__keys__mode(name) {
  if (name.length >= 3) {
    const suffix = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(name, name.length - 3 | 0, name.length));
    const base = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(name, 0, name.length - 3 | 0));
    if (base.length === 0) {
      return undefined;
    }
    if (suffix === "[@]") {
      return { _0: base, _1: false };
    }
    if (suffix === "[*]") {
      return { _0: base, _1: true };
    }
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter33parse__parameter__transform__name(name) {
  if (name.length < 2) {
    return undefined;
  }
  const _tmp$38 = name.length - 2 | 0;
  $bound_check(name, _tmp$38);
  const marker = name.charCodeAt(_tmp$38);
  if (marker !== 64) {
    return undefined;
  }
  const _tmp$39 = name.length - 1 | 0;
  $bound_check(name, _tmp$39);
  const transform = name.charCodeAt(_tmp$39);
  if (transform !== 81 && (transform !== 80 && transform !== 97)) {
    return undefined;
  }
  return { _0: _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(name, 0, name.length - 2 | 0)), _1: transform };
}
function _M0FP410Haoxincode8moonbash3lib11interpreter27match__char__class__pattern(ch, pattern, start) {
  if ((start + 1 | 0) >= pattern.length) {
    return undefined;
  }
  let i = start + 1 | 0;
  let negated = false;
  if (i < pattern.length) {
    const _tmp$38 = i;
    $bound_check(pattern, _tmp$38);
    const first = pattern.charCodeAt(_tmp$38);
    if (first === 33 || first === 94) {
      negated = true;
      i = i + 1 | 0;
    }
  }
  let seen_any = false;
  let matched = false;
  while (true) {
    if (i < pattern.length) {
      const _tmp$38 = i;
      $bound_check(pattern, _tmp$38);
      const current = pattern.charCodeAt(_tmp$38);
      if (current === 93 && seen_any) {
        let _tmp$39;
        if ((i + 1 | 0) < pattern.length) {
          const _tmp$40 = i + 1 | 0;
          $bound_check(pattern, _tmp$40);
          _tmp$39 = pattern.charCodeAt(_tmp$40) === 93;
        } else {
          _tmp$39 = false;
        }
        if (_tmp$39) {
          if (ch === 93) {
            matched = true;
          }
          seen_any = true;
          i = i + 1 | 0;
          continue;
        }
        const final_match = negated ? !matched : matched;
        return { _0: final_match, _1: i + 1 | 0 };
      }
      if (current === 92 && (i + 1 | 0) < pattern.length) {
        seen_any = true;
        const _tmp$39 = i + 1 | 0;
        $bound_check(pattern, _tmp$39);
        const escaped = pattern.charCodeAt(_tmp$39);
        if (ch === escaped) {
          matched = true;
        }
        i = i + 2 | 0;
        continue;
      }
      let _tmp$39;
      if ((i + 2 | 0) < pattern.length) {
        let _tmp$40;
        const _tmp$41 = i + 1 | 0;
        $bound_check(pattern, _tmp$41);
        if (pattern.charCodeAt(_tmp$41) === 45) {
          const _tmp$42 = i + 2 | 0;
          $bound_check(pattern, _tmp$42);
          _tmp$40 = pattern.charCodeAt(_tmp$42) !== 93;
        } else {
          _tmp$40 = false;
        }
        _tmp$39 = _tmp$40;
      } else {
        _tmp$39 = false;
      }
      if (_tmp$39) {
        seen_any = true;
        const _tmp$40 = i + 2 | 0;
        $bound_check(pattern, _tmp$40);
        const end_ch = pattern.charCodeAt(_tmp$40);
        if (ch >= current && ch <= end_ch) {
          matched = true;
        }
        i = i + 3 | 0;
        continue;
      }
      seen_any = true;
      if (ch === current) {
        matched = true;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter14match__pattern(s, si, p, pi) {
  let _tmp$38 = si;
  let _tmp$39 = pi;
  while (true) {
    const si$2 = _tmp$38;
    const pi$2 = _tmp$39;
    if (pi$2 >= p.length) {
      return si$2 >= s.length;
    }
    $bound_check(p, pi$2);
    const pch = p.charCodeAt(pi$2);
    if (pch === 92) {
      if ((pi$2 + 1 | 0) >= p.length) {
        let _tmp$40;
        if (si$2 < s.length) {
          let _tmp$41;
          $bound_check(s, si$2);
          if (s.charCodeAt(si$2) === 92) {
            _tmp$38 = si$2 + 1 | 0;
            _tmp$39 = pi$2 + 1 | 0;
            continue;
          } else {
            _tmp$41 = false;
          }
          _tmp$40 = _tmp$41;
        } else {
          _tmp$40 = false;
        }
        return _tmp$40;
      }
      if (si$2 >= s.length) {
        return false;
      }
      const _tmp$40 = pi$2 + 1 | 0;
      $bound_check(p, _tmp$40);
      const escaped = p.charCodeAt(_tmp$40);
      $bound_check(s, si$2);
      const sch = s.charCodeAt(si$2);
      if (sch === escaped) {
        _tmp$38 = si$2 + 1 | 0;
        _tmp$39 = pi$2 + 2 | 0;
        continue;
      }
      return false;
    }
    if (pch === 42) {
      let _tmp$40 = si$2;
      while (true) {
        const i = _tmp$40;
        if (i <= s.length) {
          if (_M0FP410Haoxincode8moonbash3lib11interpreter14match__pattern(s, i, p, pi$2 + 1 | 0)) {
            return true;
          }
          _tmp$40 = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return false;
    }
    if (si$2 >= s.length) {
      return false;
    }
    if (pch === 91) {
      $bound_check(s, si$2);
      const sch = s.charCodeAt(si$2);
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter27match__char__class__pattern(sch, p, pi$2);
      if (_bind$4 === undefined) {
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        const _matched = _x._0;
        const _next_pi = _x._1;
        if (_matched) {
          _tmp$38 = si$2 + 1 | 0;
          _tmp$39 = _next_pi;
          continue;
        }
        return false;
      }
    }
    if (pch === 63) {
      _tmp$38 = si$2 + 1 | 0;
      _tmp$39 = pi$2 + 1 | 0;
      continue;
    }
    $bound_check(s, si$2);
    const sch = s.charCodeAt(si$2);
    if (pch === sch) {
      _tmp$38 = si$2 + 1 | 0;
      _tmp$39 = pi$2 + 1 | 0;
      continue;
    }
    return false;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter22simple__pattern__match(s, pattern) {
  return _M0FP410Haoxincode8moonbash3lib11interpreter14match__pattern(s, 0, pattern, 0);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter12replace__all(value, pattern, replacement) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  while (true) {
    if (i < value.length) {
      let matched = false;
      let _tmp$38 = i + 1 | 0;
      while (true) {
        const j = _tmp$38;
        if (j <= value.length) {
          const substr = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(value, i, j));
          if (_M0FP410Haoxincode8moonbash3lib11interpreter22simple__pattern__match(substr, pattern)) {
            _M0IPB13StringBuilderPB6Logger13write__string(buf, replacement);
            i = j;
            matched = true;
            break;
          }
          _tmp$38 = j + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      if (!matched) {
        const _tmp$39 = i;
        $bound_check(value, _tmp$39);
        _M0IPB13StringBuilderPB6Logger11write__char(buf, value.charCodeAt(_tmp$39));
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter14replace__first(value, pattern, replacement) {
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < value.length) {
      let _tmp$39 = i + 1 | 0;
      while (true) {
        const j = _tmp$39;
        if (j <= value.length) {
          const substr = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(value, i, j));
          if (_M0FP410Haoxincode8moonbash3lib11interpreter22simple__pattern__match(substr, pattern)) {
            return `${_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(value, 0, i))}${replacement}${_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(value, j, undefined))}`;
          }
          _tmp$39 = j + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return value;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter16replace__pattern(value, pattern, replacement, mode) {
  if (pattern.length === 0) {
    return value;
  }
  switch (mode) {
    case 0: {
      return _M0FP410Haoxincode8moonbash3lib11interpreter14replace__first(value, pattern, replacement);
    }
    case 1: {
      return _M0FP410Haoxincode8moonbash3lib11interpreter12replace__all(value, pattern, replacement);
    }
    case 2: {
      let _tmp$38 = 0;
      while (true) {
        const i = _tmp$38;
        if (i <= value.length) {
          const prefix = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(value, 0, i));
          if (_M0FP410Haoxincode8moonbash3lib11interpreter22simple__pattern__match(prefix, pattern)) {
            return `${replacement}${_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(value, i, undefined))}`;
          }
          _tmp$38 = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return value;
    }
    default: {
      let _tmp$39 = value.length;
      while (true) {
        const i = _tmp$39;
        if (i >= 0) {
          const suffix = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(value, i, undefined));
          if (_M0FP410Haoxincode8moonbash3lib11interpreter22simple__pattern__match(suffix, pattern)) {
            return `${_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(value, 0, i))}${replacement}`;
          }
          _tmp$39 = i - 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return value;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter22strip__prefix__pattern(value, pattern, greedy) {
  if (pattern.length === 0) {
    return value;
  }
  if (greedy) {
    let _tmp$38 = value.length;
    while (true) {
      const i = _tmp$38;
      if (i >= 0) {
        const prefix = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(value, 0, i));
        if (_M0FP410Haoxincode8moonbash3lib11interpreter22simple__pattern__match(prefix, pattern)) {
          return _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(value, i, undefined));
        }
        _tmp$38 = i - 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return value;
  } else {
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i <= value.length) {
        const prefix = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(value, 0, i));
        if (_M0FP410Haoxincode8moonbash3lib11interpreter22simple__pattern__match(prefix, pattern)) {
          return _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(value, i, undefined));
        }
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return value;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter22strip__suffix__pattern(value, pattern, greedy) {
  if (pattern.length === 0) {
    return value;
  }
  if (greedy) {
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i <= value.length) {
        const suffix = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(value, i, undefined));
        if (_M0FP410Haoxincode8moonbash3lib11interpreter22simple__pattern__match(suffix, pattern)) {
          return _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(value, 0, i));
        }
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return value;
  } else {
    let _tmp$38 = value.length;
    while (true) {
      const i = _tmp$38;
      if (i >= 0) {
        const suffix = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(value, i, undefined));
        if (_M0FP410Haoxincode8moonbash3lib11interpreter22simple__pattern__match(suffix, pattern)) {
          return _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(value, 0, i));
        }
        _tmp$38 = i - 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return value;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter18arith__shift__left(v, amount) {
  return BigInt.asIntN(64, amount) < BigInt.asIntN(64, 0n) ? v : BigInt.asIntN(64, amount) >= BigInt.asIntN(64, 64n) ? 0n : BigInt.asUintN(64, v << BigInt(Number(BigInt.asIntN(32, amount)) & 63));
}
function _M0FP410Haoxincode8moonbash3lib11interpreter19arith__shift__right(v, amount) {
  return BigInt.asIntN(64, amount) < BigInt.asIntN(64, 0n) ? v : BigInt.asIntN(64, amount) >= BigInt.asIntN(64, 64n) ? (BigInt.asIntN(64, v) < BigInt.asIntN(64, 0n) ? 18446744073709551615n : 0n) : BigInt.asUintN(64, BigInt.asIntN(64, v) >> BigInt(Number(BigInt.asIntN(32, amount)) & 63));
}
function _M0FP410Haoxincode8moonbash3lib11interpreter8int__pow(base, exp) {
  if (BigInt.asIntN(64, exp) <= BigInt.asIntN(64, 0n)) {
    return 1n;
  }
  let result = 1n;
  let _tmp$38 = 0;
  while (true) {
    const _i = _tmp$38;
    if (_i < (Number(BigInt.asIntN(32, exp)) | 0)) {
      result = BigInt.asUintN(64, result * base);
      _tmp$38 = _i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return result;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter23arith__is__ident__start(ch) {
  return ch >= 97 && ch <= 122 || (ch >= 65 && ch <= 90 || ch === 95);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter22arith__is__ident__char(ch) {
  return _M0FP410Haoxincode8moonbash3lib11interpreter23arith__is__ident__start(ch) || ch >= 48 && ch <= 57;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter27arith__is__identifier__text(s) {
  if (s.length === 0) {
    return false;
  }
  $bound_check(s, 0);
  const first = s.charCodeAt(0);
  if (!_M0FP410Haoxincode8moonbash3lib11interpreter23arith__is__ident__start(first)) {
    return false;
  }
  let _tmp$38 = 1;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      if (!_M0FP410Haoxincode8moonbash3lib11interpreter22arith__is__ident__char(s.charCodeAt(i))) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter16arith__is__space(ch) {
  return ch === 32 || (ch === 9 || (ch === 10 || ch === 13));
}
function _M0FP410Haoxincode8moonbash3lib11interpreter11arith__trim(s) {
  let start = 0;
  let end_ = s.length;
  while (true) {
    if (start < end_) {
      const _tmp$38 = start;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (_M0FP410Haoxincode8moonbash3lib11interpreter16arith__is__space(ch)) {
        start = start + 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (end_ > start) {
      const _tmp$38 = end_ - 1 | 0;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (_M0FP410Haoxincode8moonbash3lib11interpreter16arith__is__space(ch)) {
        end_ = end_ - 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  return _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(s, start, end_));
}
function _M0FP410Haoxincode8moonbash3lib11interpreter37arith__value__looks__like__expression(text) {
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < text.length) {
      $bound_check(text, i);
      const ch = text.charCodeAt(i);
      if (ch === 43 || (ch === 45 || (ch === 42 || (ch === 47 || (ch === 37 || (ch === 38 || (ch === 124 || (ch === 94 || (ch === 60 || (ch === 62 || (ch === 40 || (ch === 41 || (ch === 63 || ch === 58))))))))))))) {
        return true;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11arith__fail(self) {
  self.exit_code = 1;
  _M0MPB3Map3setGssE(self.env, "__MOON_BASH_ABORT_CURRENT_COMMAND__", "1");
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20arith__fail__nounset(self) {
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11arith__fail(self);
  self.should_exit = true;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter19arith__digit__value(ch) {
  return ch >= 48 && ch <= 57 ? ch - 48 | 0 : ch >= 97 && ch <= 122 ? (ch - 97 | 0) + 10 | 0 : ch >= 65 && ch <= 90 ? (ch - 65 | 0) + 10 | 0 : ch === 64 ? _M0FP410Haoxincode8moonbash3lib11interpreter19arith__digit__valueN6constrS11266 : ch === 95 ? _M0FP410Haoxincode8moonbash3lib11interpreter19arith__digit__valueN6constrS11267 : undefined;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter26arith__parse__base__digits(digits, base) {
  if (digits.length === 0) {
    return undefined;
  }
  let value = 0n;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < digits.length) {
      $bound_check(digits, i);
      const ch = digits.charCodeAt(i);
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter19arith__digit__value(ch);
      if (_bind$4 === undefined) {
        return undefined;
      } else {
        const _Some = _bind$4;
        const _d = _Some;
        const normalized = base > 36 && (ch >= 65 && ch <= 90) ? _d + 26 | 0 : _d;
        if (normalized >= base) {
          return undefined;
        }
        value = BigInt.asUintN(64, BigInt.asUintN(64, value * BigInt.asUintN(64, BigInt(base))) + BigInt.asUintN(64, BigInt(normalized)));
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return value;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter26arith__parse__decimal__str(s) {
  if (s.length === 0) {
    return undefined;
  }
  let value = 0n;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      if (!(ch >= 48 && ch <= 57)) {
        return undefined;
      }
      value = BigInt.asUintN(64, BigInt.asUintN(64, value * 10n) + BigInt.asUintN(64, BigInt(ch - 48 | 0)));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return value;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter29arith__parse__number__literal(token) {
  if (token.length === 0) {
    return undefined;
  }
  let start = 0;
  let sign = 1n;
  $bound_check(token, 0);
  const _p$4 = token.charCodeAt(0);
  const _p$5 = 43;
  if (_p$4 === _p$5) {
    start = 1;
  } else {
    $bound_check(token, 0);
    const _p$6 = token.charCodeAt(0);
    const _p$7 = 45;
    if (_p$6 === _p$7) {
      sign = 18446744073709551615n;
      start = 1;
    }
  }
  if (start >= token.length) {
    return undefined;
  }
  const body = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(token, start, undefined));
  let _tmp$38;
  if (body.length >= 3) {
    let _tmp$39;
    $bound_check(body, 0);
    const _p$6 = body.charCodeAt(0);
    const _p$7 = 48;
    if (_p$6 === _p$7) {
      let _tmp$40;
      $bound_check(body, 1);
      const _p$8 = body.charCodeAt(1);
      const _p$9 = 120;
      if (_p$8 === _p$9) {
        _tmp$40 = true;
      } else {
        $bound_check(body, 1);
        const _p$10 = body.charCodeAt(1);
        const _p$11 = 88;
        _tmp$40 = _p$10 === _p$11;
      }
      _tmp$39 = _tmp$40;
    } else {
      _tmp$39 = false;
    }
    _tmp$38 = _tmp$39;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    const digits = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(body, 2, undefined));
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter26arith__parse__base__digits(digits, 16);
    if (_bind$4 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _v = _Some;
      return BigInt.asUintN(64, _v * sign);
    }
  }
  let hash_pos = -1;
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < body.length) {
      $bound_check(body, i);
      const _p$6 = body.charCodeAt(i);
      const _p$7 = 35;
      if (_p$6 === _p$7) {
        hash_pos = i;
        break;
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (hash_pos > 0) {
    const base_text = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(body, 0, hash_pos));
    const digits = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(body, hash_pos + 1 | 0, undefined));
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter26arith__parse__decimal__str(base_text);
    if (_bind$4 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _base = _Some;
      if (BigInt.asIntN(64, _base) < BigInt.asIntN(64, 2n) || BigInt.asIntN(64, _base) > BigInt.asIntN(64, 64n)) {
        return undefined;
      }
      const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter26arith__parse__base__digits(digits, Number(BigInt.asIntN(32, _base)) | 0);
      if (_bind$5 === undefined) {
        return undefined;
      } else {
        const _Some$2 = _bind$5;
        const _v = _Some$2;
        return BigInt.asUintN(64, _v * sign);
      }
    }
  }
  let _tmp$40;
  if (body.length > 1) {
    $bound_check(body, 0);
    const _p$6 = body.charCodeAt(0);
    const _p$7 = 48;
    _tmp$40 = _p$6 === _p$7;
  } else {
    _tmp$40 = false;
  }
  if (_tmp$40) {
    const digits = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(body, 1, undefined));
    let _tmp$41 = 0;
    while (true) {
      const i = _tmp$41;
      if (i < digits.length) {
        $bound_check(digits, i);
        const ch = digits.charCodeAt(i);
        if (ch < 48 || ch > 57) {
          return undefined;
        }
        if (ch > 55) {
          return undefined;
        }
        _tmp$41 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter26arith__parse__base__digits(digits, 8);
    if (_bind$4 === undefined) {
      return undefined;
    } else {
      const _Some = _bind$4;
      const _v = _Some;
      return BigInt.asUintN(64, _v * sign);
    }
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter26arith__parse__decimal__str(body);
  if (_bind$4 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$4;
    const _v = _Some;
    return BigInt.asUintN(64, _v * sign);
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter21split__by__whitespace(s) {
  const result = [];
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      if (ch === 32 || (ch === 9 || ch === 10)) {
        const word = buf.val;
        if (word.length > 0) {
          _M0MPC15array5Array4pushGUssEE(result, word);
          _M0MPB13StringBuilder5reset(buf);
        }
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const remaining = buf.val;
  if (remaining.length > 0) {
    _M0MPC15array5Array4pushGUssEE(result, remaining);
  }
  return result;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25arith__parse__value__text(self, text) {
  let _tmp$38 = text;
  while (true) {
    const text$2 = _tmp$38;
    const trimmed = _M0FP410Haoxincode8moonbash3lib11interpreter11arith__trim(text$2);
    if (trimmed.length === 0) {
      return 0n;
    }
    let _tmp$39;
    if (trimmed.length >= 2) {
      let _tmp$40;
      $bound_check(trimmed, 0);
      const _p$4 = trimmed.charCodeAt(0);
      const _p$5 = 40;
      if (_p$4 === _p$5) {
        const _tmp$41 = trimmed.length - 1 | 0;
        $bound_check(trimmed, _tmp$41);
        const _p$6 = trimmed.charCodeAt(_tmp$41);
        const _p$7 = 41;
        _tmp$40 = _p$6 === _p$7;
      } else {
        _tmp$40 = false;
      }
      _tmp$39 = _tmp$40;
    } else {
      _tmp$39 = false;
    }
    if (_tmp$39) {
      const inner = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(trimmed, 1, trimmed.length - 1 | 0));
      const parts = _M0FP410Haoxincode8moonbash3lib11interpreter21split__by__whitespace(inner);
      if (parts.length === 0) {
        return 0n;
      }
      _tmp$38 = _M0MPC15array5Array2atGUssEE(parts, 0);
      continue;
    }
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter29arith__parse__number__literal(trimmed);
    if (_bind$4 === undefined) {
      return _M0FP410Haoxincode8moonbash3lib11interpreter15parse__int__str(trimmed);
    } else {
      const _Some = _bind$4;
      return _Some;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter36arith__prepare__word__for__expansion(raw) {
  const parsed = _M0FP410Haoxincode8moonbash3lib6parser20parse__word__content(raw);
  const normalized_parts = [];
  const _bind$4 = parsed.parts;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const part = _bind$4[_];
      if (part.$tag === 8) {
        const _TildePrefix = part;
        const _user = _TildePrefix._0;
        _M0MPC15array5Array4pushGUssEE(normalized_parts, new _M0DTP410Haoxincode8moonbash3lib3ast8WordPart7Literal(`~${_user}`));
      } else {
        _M0MPC15array5Array4pushGUssEE(normalized_parts, part);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return new _M0TP410Haoxincode8moonbash3lib3ast4Word(normalized_parts);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter28arith__strip__double__quotes(text) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < text.length) {
      $bound_check(text, i);
      const ch = text.charCodeAt(i);
      if (ch !== 34) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter33arith__strip__line__continuations(raw) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  while (true) {
    if (i < raw.length) {
      const _tmp$38 = i;
      $bound_check(raw, _tmp$38);
      const ch = raw.charCodeAt(_tmp$38);
      if (ch === 92 && (i + 1 | 0) < raw.length) {
        const _tmp$39 = i + 1 | 0;
        $bound_check(raw, _tmp$39);
        const next = raw.charCodeAt(_tmp$39);
        if (next === 10) {
          i = i + 2 | 0;
          continue;
        }
        let _tmp$40;
        if (next === 13) {
          let _tmp$41;
          if ((i + 2 | 0) < raw.length) {
            const _tmp$42 = i + 2 | 0;
            $bound_check(raw, _tmp$42);
            _tmp$41 = raw.charCodeAt(_tmp$42) === 10;
          } else {
            _tmp$41 = false;
          }
          _tmp$40 = _tmp$41;
        } else {
          _tmp$40 = false;
        }
        if (_tmp$40) {
          i = i + 3 | 0;
          continue;
        }
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter28arith__is__base__digit__char(ch) {
  return ch >= 48 && ch <= 57 || (ch >= 97 && ch <= 122 || (ch >= 65 && ch <= 90 || (ch === 64 || ch === 95)));
}
function _M0FP410Haoxincode8moonbash3lib11interpreter21arith__is__hex__digit(ch) {
  return ch >= 48 && ch <= 57 || (ch >= 97 && ch <= 102 || ch >= 65 && ch <= 70);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter15arith__tokenize(expr) {
  const tokens = [];
  let i = 0;
  while (true) {
    if (i < expr.length) {
      const _tmp$38 = i;
      $bound_check(expr, _tmp$38);
      const ch = expr.charCodeAt(_tmp$38);
      if (_M0FP410Haoxincode8moonbash3lib11interpreter16arith__is__space(ch)) {
        i = i + 1 | 0;
        continue;
      }
      if (_M0FP410Haoxincode8moonbash3lib11interpreter23arith__is__ident__start(ch)) {
        const start = i;
        i = i + 1 | 0;
        while (true) {
          let _tmp$39;
          if (i < expr.length) {
            const _tmp$40 = i;
            $bound_check(expr, _tmp$40);
            _tmp$39 = _M0FP410Haoxincode8moonbash3lib11interpreter22arith__is__ident__char(expr.charCodeAt(_tmp$40));
          } else {
            _tmp$39 = false;
          }
          if (_tmp$39) {
            i = i + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        _M0MPC15array5Array4pushGUssEE(tokens, _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(expr, start, i)));
        continue;
      }
      if (ch >= 48 && ch <= 57) {
        const start = i;
        let _tmp$39;
        if ((i + 1 | 0) < expr.length) {
          let _tmp$40;
          if (ch === 48) {
            let _tmp$41;
            const _tmp$42 = i + 1 | 0;
            $bound_check(expr, _tmp$42);
            const _p$4 = expr.charCodeAt(_tmp$42);
            const _p$5 = 120;
            if (_p$4 === _p$5) {
              _tmp$41 = true;
            } else {
              const _tmp$43 = i + 1 | 0;
              $bound_check(expr, _tmp$43);
              const _p$6 = expr.charCodeAt(_tmp$43);
              const _p$7 = 88;
              _tmp$41 = _p$6 === _p$7;
            }
            _tmp$40 = _tmp$41;
          } else {
            _tmp$40 = false;
          }
          _tmp$39 = _tmp$40;
        } else {
          _tmp$39 = false;
        }
        if (_tmp$39) {
          i = i + 2 | 0;
          while (true) {
            let _tmp$40;
            if (i < expr.length) {
              const _tmp$41 = i;
              $bound_check(expr, _tmp$41);
              _tmp$40 = _M0FP410Haoxincode8moonbash3lib11interpreter21arith__is__hex__digit(expr.charCodeAt(_tmp$41));
            } else {
              _tmp$40 = false;
            }
            if (_tmp$40) {
              i = i + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          _M0MPC15array5Array4pushGUssEE(tokens, _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(expr, start, i)));
          continue;
        }
        while (true) {
          let _tmp$40;
          if (i < expr.length) {
            const _tmp$41 = i;
            $bound_check(expr, _tmp$41);
            const _p$4 = expr.charCodeAt(_tmp$41);
            _tmp$40 = _p$4 >= 48 && _p$4 <= 57;
          } else {
            _tmp$40 = false;
          }
          if (_tmp$40) {
            i = i + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        let _tmp$40;
        if (i < expr.length) {
          const _tmp$41 = i;
          $bound_check(expr, _tmp$41);
          const _p$4 = expr.charCodeAt(_tmp$41);
          const _p$5 = 35;
          _tmp$40 = _p$4 === _p$5;
        } else {
          _tmp$40 = false;
        }
        if (_tmp$40) {
          i = i + 1 | 0;
          while (true) {
            let _tmp$41;
            if (i < expr.length) {
              const _tmp$42 = i;
              $bound_check(expr, _tmp$42);
              _tmp$41 = _M0FP410Haoxincode8moonbash3lib11interpreter28arith__is__base__digit__char(expr.charCodeAt(_tmp$42));
            } else {
              _tmp$41 = false;
            }
            if (_tmp$41) {
              i = i + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          _M0MPC15array5Array4pushGUssEE(tokens, _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(expr, start, i)));
          continue;
        }
        while (true) {
          let _tmp$41;
          if (i < expr.length) {
            const _tmp$42 = i;
            $bound_check(expr, _tmp$42);
            _tmp$41 = _M0FP410Haoxincode8moonbash3lib11interpreter22arith__is__ident__char(expr.charCodeAt(_tmp$42));
          } else {
            _tmp$41 = false;
          }
          if (_tmp$41) {
            i = i + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        _M0MPC15array5Array4pushGUssEE(tokens, _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(expr, start, i)));
        continue;
      }
      if ((i + 2 | 0) < expr.length) {
        const _tmp$39 = i;
        $bound_check(expr, _tmp$39);
        const a = expr.charCodeAt(_tmp$39);
        const _tmp$40 = i + 1 | 0;
        $bound_check(expr, _tmp$40);
        const b = expr.charCodeAt(_tmp$40);
        const _tmp$41 = i + 2 | 0;
        $bound_check(expr, _tmp$41);
        const c = expr.charCodeAt(_tmp$41);
        if (a === 60 && (b === 60 && c === 61)) {
          _M0MPC15array5Array4pushGUssEE(tokens, "<<=");
          i = i + 3 | 0;
          continue;
        }
        if (a === 62 && (b === 62 && c === 61)) {
          _M0MPC15array5Array4pushGUssEE(tokens, ">>=");
          i = i + 3 | 0;
          continue;
        }
      }
      if ((i + 1 | 0) < expr.length) {
        const _tmp$39 = i;
        $bound_check(expr, _tmp$39);
        const a = expr.charCodeAt(_tmp$39);
        const _tmp$40 = i + 1 | 0;
        $bound_check(expr, _tmp$40);
        const b = expr.charCodeAt(_tmp$40);
        if (a === 43 && b === 43 || (a === 45 && b === 45 || (a === 42 && b === 42 || (a === 38 && b === 38 || (a === 124 && b === 124 || (a === 61 && b === 61 || (a === 33 && b === 61 || (a === 60 && b === 61 || (a === 62 && b === 61 || (a === 43 && b === 61 || (a === 45 && b === 61 || (a === 42 && b === 61 || (a === 47 && b === 61 || (a === 37 && b === 61 || (a === 38 && b === 61 || (a === 124 && b === 61 || (a === 94 && b === 61 || (a === 60 && b === 60 || a === 62 && b === 62)))))))))))))))))) {
          _M0MPC15array5Array4pushGUssEE(tokens, _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(expr, i, i + 2 | 0)));
          i = i + 2 | 0;
          continue;
        }
      }
      _L: {
        switch (ch) {
          case 43: {
            break _L;
          }
          case 45: {
            break _L;
          }
          case 42: {
            break _L;
          }
          case 47: {
            break _L;
          }
          case 37: {
            break _L;
          }
          case 61: {
            break _L;
          }
          case 33: {
            break _L;
          }
          case 126: {
            break _L;
          }
          case 60: {
            break _L;
          }
          case 62: {
            break _L;
          }
          case 38: {
            break _L;
          }
          case 124: {
            break _L;
          }
          case 94: {
            break _L;
          }
          case 63: {
            break _L;
          }
          case 58: {
            break _L;
          }
          case 44: {
            break _L;
          }
          case 40: {
            break _L;
          }
          case 41: {
            break _L;
          }
          case 91: {
            break _L;
          }
          case 93: {
            break _L;
          }
          default: {
            _M0MPC15array5Array4pushGUssEE(tokens, `__MOON_BASH_ARITH_INVALID__${_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(expr, i, i + 1 | 0))}`);
            return tokens;
          }
        }
      }
      _M0MPC15array5Array4pushGUssEE(tokens, _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(expr, i, i + 1 | 0)));
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return tokens;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter14contains__char(text, target) {
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < text.length) {
      $bound_check(text, i);
      if (text.charCodeAt(i) === target) {
        return true;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter29arith__is__special__var__char(ch) {
  return ch === 63 || (ch === 33 || (ch === 36 || (ch === 35 || (ch === 64 || (ch === 42 || ch === 45)))));
}
function _M0FP410Haoxincode8moonbash3lib11interpreter23find__substring__offset(text, fragment) {
  if (fragment.length === 0) {
    return 0;
  }
  if (fragment.length > text.length) {
    return -1;
  }
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i <= (text.length - fragment.length | 0)) {
      let matched = true;
      let _tmp$39 = 0;
      while (true) {
        const j = _tmp$39;
        if (j < fragment.length) {
          const _tmp$40 = i + j | 0;
          $bound_check(text, _tmp$40);
          const _p$4 = text.charCodeAt(_tmp$40);
          $bound_check(fragment, j);
          const _p$5 = fragment.charCodeAt(j);
          if (_p$4 !== _p$5) {
            matched = false;
            break;
          }
          _tmp$39 = j + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      if (matched) {
        return i;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27line__number__for__fragment(self, fragment) {
  const script = self.current_script;
  if (script.length === 0) {
    return 1;
  }
  const offset = _M0FP410Haoxincode8moonbash3lib11interpreter23find__substring__offset(script, fragment);
  if (offset < 0) {
    return 1;
  }
  let line = 1;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < offset) {
      $bound_check(script, i);
      if (script.charCodeAt(i) === 10) {
        line = line + 1 | 0;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const adjusted = line - 4 | 0;
  return adjusted > 0 ? adjusted : 1;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27emit__bad__array__subscript(self, subject, fragment) {
  const line = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27line__number__for__fragment(self, fragment);
  _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `bash: line ${_M0MPC13int3Int18to__string_2einner(line, 10)}: ${subject}: bad array subscript\n`);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter23strip__wrapping__quotes(text) {
  if (text.length >= 2) {
    $bound_check(text, 0);
    const first = text.charCodeAt(0);
    const _tmp$38 = text.length - 1 | 0;
    $bound_check(text, _tmp$38);
    const last = text.charCodeAt(_tmp$38);
    if (first === 34 && last === 34 || first === 39 && last === 39) {
      return _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(text, 1, text.length - 1 | 0));
    }
  }
  return text;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter26trim__ascii__space__simple(s) {
  let start = 0;
  let end_ = s.length;
  while (true) {
    if (start < end_) {
      const _tmp$38 = start;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch === 32 || (ch === 9 || (ch === 10 || ch === 13))) {
        start = start + 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (end_ > start) {
      const _tmp$38 = end_ - 1 | 0;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch === 32 || (ch === 9 || (ch === 10 || ch === 13))) {
        end_ = end_ - 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  return _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(s, start, end_));
}
function _M0FP410Haoxincode8moonbash3lib11interpreter16clone__bool__map(source) {
  const _bind$4 = [];
  const copied = _M0MPB3Map3MapGsbE(new _M0TPB9ArrayViewGUsbEE(_bind$4, 0, 0), undefined);
  const _it = _M0MPB3Map5iter2GsbE(source);
  while (true) {
    const _bind$5 = _M0MPB5Iter24nextGsbE(_it);
    if (_bind$5 === undefined) {
      break;
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      const _key = _x._0;
      const _value = _x._1;
      _M0MPB3Map3setGsbE(copied, _key, _value);
      continue;
    }
  }
  return copied;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter20clone__function__map(source) {
  const _bind$4 = [];
  const copied = _M0MPB3Map3MapGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(new _M0TPB9ArrayViewGUsRP410Haoxincode8moonbash3lib3ast11FunctionDefEE(_bind$4, 0, 0), undefined);
  const _it = _M0MPB3Map5iter2GssE(source);
  while (true) {
    const _bind$5 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$5 === undefined) {
      break;
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      const _key = _x._0;
      const _value = _x._1;
      _M0MPB3Map3setGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(copied, _key, _value);
      continue;
    }
  }
  return copied;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter18clone__string__map(source) {
  const _bind$4 = [];
  const copied = _M0MPB3Map3MapGssE(new _M0TPB9ArrayViewGUssEE(_bind$4, 0, 0), undefined);
  const _it = _M0MPB3Map5iter2GssE(source);
  while (true) {
    const _bind$5 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$5 === undefined) {
      break;
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      const _key = _x._0;
      const _value = _x._1;
      _M0MPB3Map3setGssE(copied, _key, _value);
      continue;
    }
  }
  return copied;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter25strip__trailing__newlines(s) {
  let end = s.length;
  while (true) {
    let _tmp$38;
    if (end > 0) {
      const _tmp$39 = end - 1 | 0;
      $bound_check(s, _tmp$39);
      const _p$4 = s.charCodeAt(_tmp$39);
      const _p$5 = 10;
      _tmp$38 = _p$4 === _p$5;
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      end = end - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(s, 0, end));
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31apply__errexit__after__pipeline(self, pipeline, next_op) {
  if (self.should_exit || (!self.options.errexit || self.exit_code === 0)) {
    return undefined;
  }
  if (pipeline.negated) {
    return undefined;
  }
  if (next_op === undefined) {
  } else {
    const _Some = next_op;
    const _op = _Some;
    if (_op === 1 || _op === 2) {
      return undefined;
    }
  }
  self.should_exit = true;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22fail__execution__limit(self, message) {
  if (self.exit_code !== 126) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: ${message}\n`);
  }
  self.exit_code = 126;
  self.should_exit = true;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext28enforce__output__size__limit(self) {
  if (self.should_exit) {
    return undefined;
  }
  const _p$4 = self.stdout_buf;
  const output = _p$4.val;
  if (output.length > self.limits.max_string_length) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22fail__execution__limit(self, "output limit exceeded");
    return;
  } else {
    return;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter33join__values__for__array__storage(values) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < values.length) {
      if (i > 0) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 32);
      }
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(values, i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter19string__has__prefix(s, prefix) {
  if (prefix.length > s.length) {
    return false;
  }
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < prefix.length) {
      $bound_check(s, i);
      const _p$4 = s.charCodeAt(i);
      $bound_check(prefix, i);
      const _p$5 = prefix.charCodeAt(i);
      if (_p$4 !== _p$5) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24store__array__assignment(self, name, values) {
  const count_key = `__MOON_BASH_ARRAY_COUNT__${name}`;
  const index_prefix = `${name}[`;
  const keys_to_remove = [];
  const _it = _M0MPB3Map5iter2GssE(self.env);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _key = _x._0;
      if (_key === count_key || (_key === `${name}[@]` || (_key === `${name}[*]` || _M0FP410Haoxincode8moonbash3lib11interpreter19string__has__prefix(_key, index_prefix)))) {
        _M0MPC15array5Array4pushGUssEE(keys_to_remove, _key);
      }
      continue;
    }
  }
  const _bind$4 = keys_to_remove.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const key = keys_to_remove[_];
      _M0MPB3Map6removeGssE(self.env, key);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const joined = _M0FP410Haoxincode8moonbash3lib11interpreter33join__values__for__array__storage(values);
  _M0MPB3Map3setGssE(self.env, name, values.length > 0 ? _M0MPC15array5Array2atGUssEE(values, 0) : "");
  _M0MPB3Map3setGssE(self.env, `${name}[@]`, joined);
  _M0MPB3Map3setGssE(self.env, `${name}[*]`, joined);
  _M0MPB3Map3setGssE(self.env, count_key, _M0MPC13int3Int18to__string_2einner(values.length, 10));
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < values.length) {
      _M0MPB3Map3setGssE(self.env, `${name}[${_M0MPC13int3Int18to__string_2einner(i, 10)}]`, _M0MPC15array5Array2atGUssEE(values, i));
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18regex__cond__match(self, text, pattern) {
  let matcher;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib5regex30compile__grep__matcher_2einner(pattern, true, false, false);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        matcher = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24store__array__assignment(self, "BASH_REMATCH", []);
    return false;
  }
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib5regex11GrepMatcher33find__first__with__groups_2einner(matcher, text, 0);
  if (_bind$4 === undefined) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24store__array__assignment(self, "BASH_REMATCH", []);
    return false;
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _start = _x._0;
    const _end = _x._1;
    const _groups = _x._2;
    const values = [];
    _M0MPC15array5Array4pushGUssEE(values, _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(text, _start, _end)));
    const _bind$5 = _groups.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$5) {
        const group = _groups[_];
        _M0MPC15array5Array4pushGUssEE(values, group);
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24store__array__assignment(self, "BASH_REMATCH", values);
    return true;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter18trim__cstyle__expr(s) {
  let start = 0;
  let end_ = s.length;
  while (true) {
    if (start < end_) {
      const _tmp$38 = start;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch === 32 || (ch === 9 || (ch === 10 || ch === 13))) {
        start = start + 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (end_ > start) {
      const _tmp$38 = end_ - 1 | 0;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch === 32 || (ch === 9 || (ch === 10 || ch === 13))) {
        end_ = end_ - 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  return _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(s, start, end_));
}
function _M0FP410Haoxincode8moonbash3lib11interpreter26cstyle__condition__omitted(expr) {
  if (expr.$tag === 6) {
    const _Raw = expr;
    const _raw = _Raw._0;
    return _M0FP410Haoxincode8moonbash3lib11interpreter18trim__cstyle__expr(_raw).length === 0;
  } else {
    return false;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter33word__part__has__literal__newline(part) {
  switch (part.$tag) {
    case 0: {
      const _Literal = part;
      const _text = _Literal._0;
      return _M0FP410Haoxincode8moonbash3lib11interpreter14contains__char(_text, 10);
    }
    case 1: {
      const _SingleQuoted = part;
      const _text$2 = _SingleQuoted._0;
      return _M0FP410Haoxincode8moonbash3lib11interpreter14contains__char(_text$2, 10);
    }
    case 2: {
      const _DoubleQuoted = part;
      const _inner = _DoubleQuoted._0;
      const _bind$4 = _inner.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const nested = _inner[_];
          if (_M0FP410Haoxincode8moonbash3lib11interpreter33word__part__has__literal__newline(nested)) {
            return true;
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return false;
    }
    default: {
      return false;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter27word__has__literal__newline(word) {
  const _bind$4 = word.parts;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const part = _bind$4[_];
      if (_M0FP410Haoxincode8moonbash3lib11interpreter33word__part__has__literal__newline(part)) {
        return true;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter41alias__call__has__multiline__literal__arg(words) {
  if (words.length <= 1) {
    return false;
  }
  let _tmp$38 = 1;
  while (true) {
    const i = _tmp$38;
    if (i < words.length) {
      if (_M0FP410Haoxincode8moonbash3lib11interpreter27word__has__literal__newline(_M0MPC15array5Array2atGUssEE(words, i))) {
        return true;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter33alias__expansion__candidate__name(word) {
  if (word.parts.length === 0) {
    return undefined;
  }
  const value = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _bind$4 = word.parts;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const part = _bind$4[_];
      if (part.$tag === 0) {
        const _Literal = part;
        const _text = _Literal._0;
        _M0IPB13StringBuilderPB6Logger13write__string(value, _text);
      } else {
        return undefined;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const name = value.val;
  return name.length === 0 ? undefined : name;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter29is__assignment__builtin__name(cmd_name) {
  return cmd_name === "declare" || (cmd_name === "typeset" || (cmd_name === "export" || (cmd_name === "local" || cmd_name === "readonly")));
}
function _M0FP410Haoxincode8moonbash3lib11interpreter36parse__command__builtin__mode__token(token) {
  let _tmp$38;
  if (token.length < 2) {
    _tmp$38 = true;
  } else {
    $bound_check(token, 0);
    _tmp$38 = token.charCodeAt(0) !== 45;
  }
  if (_tmp$38) {
    return undefined;
  }
  let mode = 0;
  let _tmp$39 = 1;
  while (true) {
    const i = _tmp$39;
    if (i < token.length) {
      $bound_check(token, i);
      const flag = token.charCodeAt(i);
      switch (flag) {
        case 118: {
          mode = 1;
          break;
        }
        case 86: {
          mode = 2;
          break;
        }
        case 112: {
          break;
        }
        default: {
          return undefined;
        }
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return mode;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter49assignment__builtin__active__for__expanded__words(expanded, first_word_static) {
  if (expanded.length === 0) {
    return false;
  }
  const cmd_name = _M0MPC15array5Array2atGUssEE(expanded, 0);
  if (_M0FP410Haoxincode8moonbash3lib11interpreter29is__assignment__builtin__name(cmd_name)) {
    return first_word_static;
  }
  if (cmd_name === "builtin") {
    let idx = 1;
    if (idx < expanded.length && _M0MPC15array5Array2atGUssEE(expanded, idx) === "--") {
      idx = idx + 1 | 0;
    }
    if (idx >= expanded.length) {
      return false;
    }
    return _M0FP410Haoxincode8moonbash3lib11interpreter29is__assignment__builtin__name(_M0MPC15array5Array2atGUssEE(expanded, idx));
  }
  if (cmd_name === "command") {
    let mode = 0;
    let idx = 1;
    while (true) {
      if (idx < expanded.length) {
        const token = _M0MPC15array5Array2atGUssEE(expanded, idx);
        if (token === "--") {
          idx = idx + 1 | 0;
          break;
        }
        const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter36parse__command__builtin__mode__token(token);
        if (_bind$4 === undefined) {
          break;
        } else {
          const _Some = _bind$4;
          const _token_mode = _Some;
          if (_token_mode !== 0) {
            mode = _token_mode;
          }
          idx = idx + 1 | 0;
        }
        continue;
      } else {
        break;
      }
    }
    if (idx >= expanded.length || mode !== 0) {
      return false;
    }
    return _M0FP410Haoxincode8moonbash3lib11interpreter29is__assignment__builtin__name(_M0MPC15array5Array2atGUssEE(expanded, idx));
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter36assignment__word__is__empty__literal(word) {
  if (word.parts.length === 0) {
    return true;
  }
  if (word.parts.length !== 1) {
    return false;
  }
  const _bind$4 = _M0MPC15array5Array2atGUssEE(word.parts, 0);
  if (_bind$4.$tag === 0) {
    const _Literal = _bind$4;
    const _text = _Literal._0;
    return _text.length === 0;
  } else {
    return false;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter39parse__array__element__assignment__name(name) {
  let _tmp$38;
  if (name.length < 3) {
    _tmp$38 = true;
  } else {
    const _tmp$39 = name.length - 1 | 0;
    $bound_check(name, _tmp$39);
    const _p$4 = name.charCodeAt(_tmp$39);
    const _p$5 = 93;
    _tmp$38 = _p$4 !== _p$5;
  }
  if (_tmp$38) {
    return undefined;
  }
  let bracket = -1;
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < name.length) {
      $bound_check(name, i);
      const _p$4 = name.charCodeAt(i);
      const _p$5 = 91;
      if (_p$4 === _p$5) {
        bracket = i;
        break;
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (bracket <= 0) {
    return undefined;
  }
  const base = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(name, 0, bracket));
  if (!_M0FP410Haoxincode8moonbash3lib11interpreter22is__valid__shell__name(base)) {
    return undefined;
  }
  const raw_index = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(name, bracket + 1 | 0, name.length - 1 | 0));
  const index = _M0FP410Haoxincode8moonbash3lib11interpreter35normalize__array__assignment__index(raw_index);
  return { _0: base, _1: index };
}
function _M0FP410Haoxincode8moonbash3lib11interpreter31assignment__restore__base__name(raw_name) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter39parse__array__element__assignment__name(raw_name);
  if (_bind$4 === undefined) {
    return raw_name;
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    return _x._0;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter35collect__assignment__restore__names(assignments) {
  const names = [];
  const _bind$4 = assignments.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const assign = assignments[_];
      const name = _M0FP410Haoxincode8moonbash3lib11interpreter31assignment__restore__base__name(assign.name);
      let exists = false;
      const _bind$5 = names.length;
      let _tmp$39 = 0;
      while (true) {
        const _$2 = _tmp$39;
        if (_$2 < _bind$5) {
          const existing = names[_$2];
          if (existing === name) {
            exists = true;
            break;
          }
          _tmp$39 = _$2 + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      if (!exists) {
        _M0MPC15array5Array4pushGUssEE(names, name);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return names;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter35command__keeps__prefix__assignments(cmd_name) {
  return cmd_name === "declare" || (cmd_name === "typeset" || (cmd_name === "local" || (cmd_name === "export" || cmd_name === "readonly")));
}
function _M0FP410Haoxincode8moonbash3lib11interpreter23is__grep__like__command(cmd_name) {
  return cmd_name === "grep" || (cmd_name === "egrep" || (cmd_name === "fgrep" || cmd_name === "rg"));
}
function _M0FP410Haoxincode8moonbash3lib11interpreter44env__key__matches__assignment__restore__name(key, name) {
  if (key === name || (key === `__MOON_BASH_ARRAY_COUNT__${name}` || key === `__MOON_BASH_ARRAY_KIND__${name}`)) {
    return true;
  }
  return _M0FP410Haoxincode8moonbash3lib11interpreter19string__has__prefix(key, `${name}[`);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter45env__key__matches__assignment__restore__names(key, names) {
  const _bind$4 = names.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const name = names[_];
      if (_M0FP410Haoxincode8moonbash3lib11interpreter44env__key__matches__assignment__restore__name(key, name)) {
        return true;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter33restore__assignment__env__entries(env, names, snapshot) {
  const to_remove = [];
  const _it = _M0MPB3Map5iter2GssE(env);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _key = _x._0;
      if (_M0FP410Haoxincode8moonbash3lib11interpreter45env__key__matches__assignment__restore__names(_key, names)) {
        _M0MPC15array5Array4pushGUssEE(to_remove, _key);
      }
      continue;
    }
  }
  const _bind$4 = to_remove.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const key = to_remove[_];
      _M0MPB3Map6removeGssE(env, key);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _it$2 = _M0MPB3Map5iter2GssE(snapshot);
  while (true) {
    const _bind$5 = _M0MPB5Iter24nextGssE(_it$2);
    if (_bind$5 === undefined) {
      return;
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      const _key = _x._0;
      const _value = _x._1;
      _M0MPB3Map3setGssE(env, _key, _value);
      continue;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter34snapshot__assignment__env__entries(env, names) {
  const _bind$4 = [];
  const snapshot = _M0MPB3Map3MapGssE(new _M0TPB9ArrayViewGUssEE(_bind$4, 0, 0), undefined);
  const _it = _M0MPB3Map5iter2GssE(env);
  while (true) {
    const _bind$5 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$5 === undefined) {
      break;
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      const _key = _x._0;
      const _value = _x._1;
      if (_M0FP410Haoxincode8moonbash3lib11interpreter45env__key__matches__assignment__restore__names(_key, names)) {
        _M0MPB3Map3setGssE(snapshot, _key, _value);
      }
      continue;
    }
  }
  return snapshot;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter39word__has__status__sensitive__expansion(word) {
  const _bind$4 = word.parts;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const part = _bind$4[_];
      if (_M0FP410Haoxincode8moonbash3lib11interpreter45word__part__has__status__sensitive__expansion(part)) {
        return true;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter45word__part__has__status__sensitive__expansion(part) {
  switch (part.$tag) {
    case 5: {
      return true;
    }
    case 6: {
      return true;
    }
    case 2: {
      const _DoubleQuoted = part;
      const _inner = _DoubleQuoted._0;
      const _bind$4 = _inner.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const nested = _inner[_];
          if (_M0FP410Haoxincode8moonbash3lib11interpreter45word__part__has__status__sensitive__expansion(nested)) {
            return true;
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return false;
    }
    case 7: {
      const _BraceExpansion = part;
      const _options = _BraceExpansion._0;
      const _bind$5 = _options.length;
      let _tmp$39 = 0;
      while (true) {
        const _ = _tmp$39;
        if (_ < _bind$5) {
          const option = _options[_];
          const _bind$6 = option.length;
          let _tmp$40 = 0;
          while (true) {
            const _$2 = _tmp$40;
            if (_$2 < _bind$6) {
              const nested = option[_$2];
              if (_M0FP410Haoxincode8moonbash3lib11interpreter45word__part__has__status__sensitive__expansion(nested)) {
                return true;
              }
              _tmp$40 = _$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          _tmp$39 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return false;
    }
    case 4: {
      const _ParameterExpansion = part;
      const _expansion = _ParameterExpansion._0;
      return _M0FP410Haoxincode8moonbash3lib11interpreter51param__expansion__has__status__sensitive__expansion(_expansion);
    }
    default: {
      return false;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter51param__expansion__has__status__sensitive__expansion(expansion) {
  switch (expansion.$tag) {
    case 1: {
      const _Default = expansion;
      const _word = _Default._1;
      return _M0FP410Haoxincode8moonbash3lib11interpreter39word__has__status__sensitive__expansion(_word);
    }
    case 2: {
      const _Assign = expansion;
      const _word$2 = _Assign._1;
      return _M0FP410Haoxincode8moonbash3lib11interpreter39word__has__status__sensitive__expansion(_word$2);
    }
    case 3: {
      const _Error = expansion;
      const _maybe_word = _Error._1;
      if (_maybe_word === undefined) {
        return false;
      } else {
        const _Some = _maybe_word;
        const _word$3 = _Some;
        return _M0FP410Haoxincode8moonbash3lib11interpreter39word__has__status__sensitive__expansion(_word$3);
      }
    }
    case 4: {
      const _Alternative = expansion;
      const _word$3 = _Alternative._1;
      return _M0FP410Haoxincode8moonbash3lib11interpreter39word__has__status__sensitive__expansion(_word$3);
    }
    case 7: {
      const _PrefixRemove = expansion;
      const _word$4 = _PrefixRemove._1;
      return _M0FP410Haoxincode8moonbash3lib11interpreter39word__has__status__sensitive__expansion(_word$4);
    }
    case 8: {
      const _SuffixRemove = expansion;
      const _word$5 = _SuffixRemove._1;
      return _M0FP410Haoxincode8moonbash3lib11interpreter39word__has__status__sensitive__expansion(_word$5);
    }
    case 9: {
      const _Replace = expansion;
      const _pattern = _Replace._1;
      const _maybe_repl = _Replace._2;
      if (_M0FP410Haoxincode8moonbash3lib11interpreter39word__has__status__sensitive__expansion(_pattern)) {
        return true;
      }
      if (_maybe_repl === undefined) {
        return false;
      } else {
        const _Some = _maybe_repl;
        const _repl = _Some;
        return _M0FP410Haoxincode8moonbash3lib11interpreter39word__has__status__sensitive__expansion(_repl);
      }
    }
    case 10: {
      const _Uppercase = expansion;
      const _maybe_pattern = _Uppercase._1;
      if (_maybe_pattern === undefined) {
        return false;
      } else {
        const _Some = _maybe_pattern;
        const _pattern$2 = _Some;
        return _M0FP410Haoxincode8moonbash3lib11interpreter39word__has__status__sensitive__expansion(_pattern$2);
      }
    }
    case 11: {
      const _Lowercase = expansion;
      const _maybe_pattern$2 = _Lowercase._1;
      if (_maybe_pattern$2 === undefined) {
        return false;
      } else {
        const _Some = _maybe_pattern$2;
        const _pattern$2 = _Some;
        return _M0FP410Haoxincode8moonbash3lib11interpreter39word__has__status__sensitive__expansion(_pattern$2);
      }
    }
    default: {
      return false;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter25word__is__single__literal(word, expected) {
  if (word.parts.length !== 1) {
    return false;
  }
  const _bind$4 = _M0MPC15array5Array2atGUssEE(word.parts, 0);
  if (_bind$4.$tag === 0) {
    const _Literal = _bind$4;
    const _text = _Literal._0;
    return _text === expected;
  } else {
    return false;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter35word__part__has__runtime__expansion(part) {
  switch (part.$tag) {
    case 0: {
      return false;
    }
    case 1: {
      return false;
    }
    case 2: {
      const _DoubleQuoted = part;
      const _inner_parts = _DoubleQuoted._0;
      const _bind$4 = _inner_parts.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const inner = _inner_parts[_];
          if (_M0FP410Haoxincode8moonbash3lib11interpreter35word__part__has__runtime__expansion(inner)) {
            return true;
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return false;
    }
    default: {
      return true;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter42word__is__static__command__name__candidate(word) {
  if (word.parts.length === 0) {
    return false;
  }
  const _bind$4 = word.parts;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const part = _bind$4[_];
      if (_M0FP410Haoxincode8moonbash3lib11interpreter35word__part__has__runtime__expansion(part)) {
        return false;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter34word__starts__with__literal__paren(word) {
  if (word.parts.length === 0) {
    return false;
  }
  const _bind$4 = _M0MPC15array5Array2atGUssEE(word.parts, 0);
  if (_bind$4.$tag === 0) {
    const _Literal = _bind$4;
    const _text = _Literal._0;
    if (_text.length > 0) {
      $bound_check(_text, 0);
      return _text.charCodeAt(0) === 40;
    } else {
      return false;
    }
  } else {
    return false;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter13compare__text(a, b) {
  const min_len = a.length < b.length ? a.length : b.length;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < min_len) {
      $bound_check(a, i);
      const _tmp$39 = a.charCodeAt(i);
      $bound_check(b, i);
      if (_M0IP016_24default__implPB7Compare6op__ltGkE(_tmp$39, b.charCodeAt(i))) {
        return -1;
      }
      $bound_check(a, i);
      const _tmp$40 = a.charCodeAt(i);
      $bound_check(b, i);
      if (_M0IP016_24default__implPB7Compare6op__gtGkE(_tmp$40, b.charCodeAt(i))) {
        return 1;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return a.length < b.length ? -1 : a.length > b.length ? 1 : 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter36parse__non__negative__int__for__sort(text) {
  if (text.length === 0) {
    return undefined;
  }
  let value = 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < text.length) {
      $bound_check(text, i);
      const ch = text.charCodeAt(i);
      if (ch < 48 || ch > 57) {
        return undefined;
      }
      value = (Math.imul(value, 10) | 0) + (ch - 48 | 0) | 0;
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return value;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter17sort__array__keys(keys) {
  _M0MPC15array5Array8sort__byGUssEE(keys, (a, b) => {
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter36parse__non__negative__int__for__sort(a);
    const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter36parse__non__negative__int__for__sort(b);
    if (_bind$4 === undefined) {
      return _bind$5 === undefined ? _M0FP410Haoxincode8moonbash3lib11interpreter13compare__text(a, b) : 1;
    } else {
      const _Some = _bind$4;
      const _ai = _Some;
      if (_bind$5 === undefined) {
        return -1;
      } else {
        const _Some$2 = _bind$5;
        const _bi = _Some$2;
        return _ai < _bi ? -1 : _ai > _bi ? 1 : 0;
      }
    }
  });
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24refresh__array__metadata(self, name) {
  const prefix = `${name}[`;
  const count_key = `__MOON_BASH_ARRAY_COUNT__${name}`;
  const keys = [];
  const _it = _M0MPB3Map5iter2GssE(self.env);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _key = _x._0;
      if (_key === `${name}[@]` || _key === `${name}[*]`) {
        continue;
      }
      let _tmp$38;
      if (_M0FP410Haoxincode8moonbash3lib11interpreter19string__has__prefix(_key, prefix)) {
        let _tmp$39;
        if (_key.length > prefix.length) {
          const _tmp$40 = _key.length - 1 | 0;
          $bound_check(_key, _tmp$40);
          const _p$4 = _key.charCodeAt(_tmp$40);
          const _p$5 = 93;
          _tmp$39 = _p$4 === _p$5;
        } else {
          _tmp$39 = false;
        }
        _tmp$38 = _tmp$39;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        const inner = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(_key, prefix.length, _key.length - 1 | 0));
        let _tmp$39;
        const _p$4 = "@";
        if (!(inner === _p$4)) {
          const _p$5 = "*";
          _tmp$39 = !(inner === _p$5);
        } else {
          _tmp$39 = false;
        }
        if (_tmp$39) {
          _M0MPC15array5Array4pushGUssEE(keys, inner);
        }
      }
      continue;
    }
  }
  _M0FP410Haoxincode8moonbash3lib11interpreter17sort__array__keys(keys);
  const values = [];
  const _bind$4 = keys.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const inner = keys[_];
      const key = `${name}[${inner}]`;
      const _p$4 = _M0MPB3Map3getGssE(self.env, key);
      const _p$5 = "";
      let _tmp$39;
      if (_p$4 === undefined) {
        _tmp$39 = _p$5;
      } else {
        const _p$6 = _p$4;
        _tmp$39 = _p$6;
      }
      _M0MPC15array5Array4pushGUssEE(values, _tmp$39);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const joined = _M0FP410Haoxincode8moonbash3lib11interpreter33join__values__for__array__storage(values);
  _M0MPB3Map3setGssE(self.env, `${name}[@]`, joined);
  _M0MPB3Map3setGssE(self.env, `${name}[*]`, joined);
  _M0MPB3Map3setGssE(self.env, count_key, _M0MPC13int3Int18to__string_2einner(values.length, 10));
  const _tmp$39 = self.env;
  const _p$4 = _M0MPB3Map3getGssE(self.env, `${name}[0]`);
  const _p$5 = "";
  let _tmp$40;
  if (_p$4 === undefined) {
    _tmp$40 = _p$5;
  } else {
    const _p$6 = _p$4;
    _tmp$40 = _p$6;
  }
  _M0MPB3Map3setGssE(_tmp$39, name, _tmp$40);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33append__scalar__array__assignment(self, name, suffix) {
  if (!_M0MPB3Map8containsGssE(self.env, `__MOON_BASH_ARRAY_COUNT__${name}`)) {
    return false;
  }
  const _p$4 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_ARRAY_KIND__${name}`);
  const _p$5 = "indexed";
  let kind;
  if (_p$4 === undefined) {
    kind = _p$5;
  } else {
    const _p$6 = _p$4;
    kind = _p$6;
  }
  if (kind === "assoc") {
    self.exit_code = 1;
    self.should_exit = true;
    return true;
  }
  const element_key = `${name}[0]`;
  const _tmp$38 = self.env;
  const _p$6 = _M0MPB3Map3getGssE(self.env, element_key);
  const _p$7 = "";
  let _tmp$39;
  if (_p$6 === undefined) {
    _tmp$39 = _p$7;
  } else {
    const _p$8 = _p$6;
    _tmp$39 = _p$8;
  }
  _M0MPB3Map3setGssE(_tmp$38, element_key, `${_tmp$39}${suffix}`);
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24refresh__array__metadata(self, name);
  return true;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter33find__name__value__separator__pos(spec) {
  let bracket_depth = 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < spec.length) {
      _L: {
        $bound_check(spec, i);
        const ch = spec.charCodeAt(i);
        if (ch === 91) {
          bracket_depth = bracket_depth + 1 | 0;
          break _L;
        }
        if (ch === 93) {
          if (bracket_depth > 0) {
            bracket_depth = bracket_depth - 1 | 0;
          }
          break _L;
        }
        if (ch === 61 && bracket_depth === 0) {
          return i;
        }
        break _L;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter24parse__name__value__spec(spec) {
  if (spec.length === 0) {
    return undefined;
  }
  const eq_pos = _M0FP410Haoxincode8moonbash3lib11interpreter33find__name__value__separator__pos(spec);
  if (eq_pos > 0) {
    let append;
    if (eq_pos >= 2) {
      const _tmp$38 = eq_pos - 1 | 0;
      $bound_check(spec, _tmp$38);
      append = spec.charCodeAt(_tmp$38) === 43;
    } else {
      append = false;
    }
    const name_end = append ? eq_pos - 1 | 0 : eq_pos;
    if (name_end <= 0) {
      return undefined;
    }
    const name = _M0FP410Haoxincode8moonbash3lib11interpreter40strip__array__assignment__index__markers(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(spec, 0, name_end)));
    const value = _M0FP410Haoxincode8moonbash3lib11interpreter40strip__array__assignment__index__markers(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(spec, eq_pos + 1 | 0, undefined)));
    if (name.length === 0) {
      return undefined;
    }
    return { _0: name, _1: value, _2: append };
  }
  return { _0: _M0FP410Haoxincode8moonbash3lib11interpreter40strip__array__assignment__index__markers(spec), _1: undefined, _2: false };
}
function _M0FP410Haoxincode8moonbash3lib11interpreter34encode__assignment__quoted__marker(text) {
  if (text.length === 0) {
    return "\u0001\u0000";
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < text.length) {
      _M0IPB13StringBuilderPB6Logger11write__char(out, 1);
      $bound_check(text, i);
      _M0IPB13StringBuilderPB6Logger11write__char(out, text.charCodeAt(i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter24word__is__plain__literal(word) {
  if (word.parts.length === 0) {
    return false;
  }
  const _bind$4 = word.parts;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const part = _bind$4[_];
      if (part.$tag === 0) {
      } else {
        return false;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter23word__is__single__tilde(word) {
  if (word.parts.length !== 1) {
    return false;
  }
  const _bind$4 = _M0MPC15array5Array2atGUssEE(word.parts, 0);
  if (_bind$4.$tag === 8) {
    return true;
  } else {
    return false;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter31escape__conditional__glob__meta(text) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < text.length) {
      $bound_check(text, i);
      const ch = text.charCodeAt(i);
      if (ch === 42 || (ch === 63 || (ch === 91 || ch === 92))) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter13sort__strings(values) {
  _M0MPC15array5Array8sort__byGUssEE(values, (a, b) => {
    const min_len = a.length < b.length ? a.length : b.length;
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < min_len) {
        $bound_check(a, i);
        const _tmp$39 = a.charCodeAt(i);
        $bound_check(b, i);
        if (_M0IP016_24default__implPB7Compare6op__ltGkE(_tmp$39, b.charCodeAt(i))) {
          return -1;
        }
        $bound_check(a, i);
        const _tmp$40 = a.charCodeAt(i);
        $bound_check(b, i);
        if (_M0IP016_24default__implPB7Compare6op__gtGkE(_tmp$40, b.charCodeAt(i))) {
          return 1;
        }
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return a.length < b.length ? -1 : a.length > b.length ? 1 : 0;
  });
}
function _M0FP410Haoxincode8moonbash3lib11interpreter21split__path__segments(path) {
  const segments = [];
  let start = 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i <= path.length) {
      let _tmp$39;
      if (i === path.length) {
        _tmp$39 = true;
      } else {
        $bound_check(path, i);
        const _p$4 = path.charCodeAt(i);
        const _p$5 = 47;
        _tmp$39 = _p$4 === _p$5;
      }
      if (_tmp$39) {
        if (i > start) {
          _M0MPC15array5Array4pushGUssEE(segments, _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(path, start, i)));
        }
        start = i + 1 | 0;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return segments;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20abs__to__shell__path(self, abs_path) {
  if (abs_path === self.cwd) {
    return ".";
  }
  if (self.cwd === "/") {
    let _tmp$38;
    if (abs_path.length > 0) {
      $bound_check(abs_path, 0);
      const _p$4 = abs_path.charCodeAt(0);
      const _p$5 = 47;
      _tmp$38 = _p$4 === _p$5;
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      return _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(abs_path, 1, undefined));
    }
    return abs_path;
  }
  const prefix = `${self.cwd}/`;
  if (_M0FP410Haoxincode8moonbash3lib11interpreter12starts__with(abs_path, prefix)) {
    return _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(abs_path, prefix.length, undefined));
  }
  return abs_path;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24consume__glob__operation(self) {
  self.glob_operations = self.glob_operations + 1 | 0;
  if (self.glob_operations > self.limits.max_glob_operations) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22fail__execution__limit(self, "Glob operation limit exceeded");
    return false;
  }
  return true;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22glob__expand__segments(self, segments, idx, current_abs, out) {
  let _tmp$38 = idx;
  let _tmp$39 = current_abs;
  while (true) {
    const idx$2 = _tmp$38;
    const current_abs$2 = _tmp$39;
    if (idx$2 >= segments.length) {
      if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24consume__glob__operation(self)) {
        return undefined;
      }
      if (_M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs6exists(self.fs, current_abs$2)) {
        _M0MPC15array5Array4pushGUssEE(out, current_abs$2);
      }
      return undefined;
    }
    const segment = _M0MPC15array5Array2atGUssEE(segments, idx$2);
    if (_M0FP410Haoxincode8moonbash3lib11interpreter15has__glob__meta(segment)) {
      if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24consume__glob__operation(self)) {
        return undefined;
      }
      let entries;
      let _try_err;
      _L: {
        _L$2: {
          const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs7readdir(self.fs, current_abs$2);
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            entries = _ok._0;
          } else {
            const _err = _bind$4;
            _try_err = _err._0;
            break _L$2;
          }
          break _L;
        }
        return undefined;
      }
      const names = [];
      const _bind$4 = entries.length;
      let _tmp$40 = 0;
      while (true) {
        const _ = _tmp$40;
        if (_ < _bind$4) {
          const entry = entries[_];
          _M0MPC15array5Array4pushGUssEE(names, entry.name);
          _tmp$40 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      _M0FP410Haoxincode8moonbash3lib11interpreter13sort__strings(names);
      let include_dotfiles = false;
      let _tmp$41;
      if (segment.length > 0) {
        $bound_check(segment, 0);
        const _p$4 = segment.charCodeAt(0);
        const _p$5 = 46;
        _tmp$41 = _p$4 === _p$5;
      } else {
        _tmp$41 = false;
      }
      if (_tmp$41) {
        include_dotfiles = true;
      }
      const _bind$5 = names.length;
      let _tmp$42 = 0;
      while (true) {
        const _ = _tmp$42;
        if (_ < _bind$5) {
          const name = names[_];
          _L$2: {
            let _tmp$43;
            if (!include_dotfiles) {
              let _tmp$44;
              if (name.length > 0) {
                $bound_check(name, 0);
                const _p$4 = name.charCodeAt(0);
                const _p$5 = 46;
                _tmp$44 = _p$4 === _p$5;
              } else {
                _tmp$44 = false;
              }
              _tmp$43 = _tmp$44;
            } else {
              _tmp$43 = false;
            }
            if (_tmp$43) {
              break _L$2;
            }
            if (!_M0FP410Haoxincode8moonbash3lib2fs11glob__match(segment, name)) {
              break _L$2;
            }
            const child_abs = current_abs$2 === "/" ? `/${name}` : `${current_abs$2}/${name}`;
            if ((idx$2 + 1 | 0) >= segments.length) {
              if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24consume__glob__operation(self)) {
                return undefined;
              }
              if (_M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs6exists(self.fs, child_abs)) {
                _M0MPC15array5Array4pushGUssEE(out, child_abs);
              }
            } else {
              if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24consume__glob__operation(self)) {
                return undefined;
              }
              let stat;
              let _try_err$2;
              _L$3: {
                _L$4: {
                  const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs4stat(self.fs, child_abs);
                  if (_bind$6.$tag === 1) {
                    const _ok = _bind$6;
                    stat = _ok._0;
                  } else {
                    const _err = _bind$6;
                    _try_err$2 = _err._0;
                    break _L$4;
                  }
                  break _L$3;
                }
                break _L$2;
              }
              if (stat.is_directory) {
                _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22glob__expand__segments(self, segments, idx$2 + 1 | 0, child_abs, out);
              }
            }
            break _L$2;
          }
          _tmp$42 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return undefined;
    }
    const next_abs = current_abs$2 === "/" ? `/${segment}` : `${current_abs$2}/${segment}`;
    if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24consume__glob__operation(self)) {
      return undefined;
    }
    if (!_M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs6exists(self.fs, next_abs)) {
      return undefined;
    }
    if ((idx$2 + 1 | 0) >= segments.length) {
      _M0MPC15array5Array4pushGUssEE(out, next_abs);
      return undefined;
    }
    if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24consume__glob__operation(self)) {
      return undefined;
    }
    let stat;
    let _try_err;
    _L: {
      _L$2: {
        const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs4stat(self.fs, next_abs);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          stat = _ok._0;
        } else {
          const _err = _bind$4;
          _try_err = _err._0;
          break _L$2;
        }
        break _L;
      }
      return undefined;
    }
    if (stat.is_directory) {
      _tmp$38 = idx$2 + 1 | 0;
      _tmp$39 = next_abs;
      continue;
    } else {
      return;
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18expand__glob__word(self, pattern) {
  let absolute_pattern;
  let _tmp$38;
  if (pattern.length > 0) {
    $bound_check(pattern, 0);
    const _p$4 = pattern.charCodeAt(0);
    const _p$5 = 47;
    _tmp$38 = _p$4 === _p$5;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    let _try_err;
    _L: {
      _L$2: {
        const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs15normalize__path(pattern);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          absolute_pattern = _ok._0;
        } else {
          const _err = _bind$4;
          _try_err = _err._0;
          break _L$2;
        }
        break _L;
      }
      absolute_pattern = pattern;
    }
  } else {
    let _try_err;
    _L: {
      _L$2: {
        const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, pattern);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          absolute_pattern = _ok._0;
        } else {
          const _err = _bind$4;
          _try_err = _err._0;
          break _L$2;
        }
        break _L;
      }
      absolute_pattern = `${self.cwd}/${pattern}`;
    }
  }
  const segments = _M0FP410Haoxincode8moonbash3lib11interpreter21split__path__segments(absolute_pattern);
  const absolute_matches = [];
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22glob__expand__segments(self, segments, 0, "/", absolute_matches);
  const display_matches = [];
  const _bind$4 = absolute_matches.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$4) {
      const abs_path = absolute_matches[_];
      let _tmp$40;
      if (pattern.length > 0) {
        $bound_check(pattern, 0);
        const _p$4 = pattern.charCodeAt(0);
        const _p$5 = 47;
        _tmp$40 = _p$4 === _p$5;
      } else {
        _tmp$40 = false;
      }
      if (_tmp$40) {
        _M0MPC15array5Array4pushGUssEE(display_matches, abs_path);
      } else {
        _M0MPC15array5Array4pushGUssEE(display_matches, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20abs__to__shell__path(self, abs_path));
      }
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0FP410Haoxincode8moonbash3lib11interpreter13sort__strings(display_matches);
  return display_matches;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16pathname__expand(self, words) {
  if (self.options.noglob) {
    return words;
  }
  const expanded = [];
  const _bind$4 = words.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const word = words[_];
      _L: {
        if (!_M0FP410Haoxincode8moonbash3lib11interpreter15has__glob__meta(word)) {
          _M0MPC15array5Array4pushGUssEE(expanded, word);
          break _L;
        }
        const matches = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18expand__glob__word(self, word);
        if (matches.length === 0) {
          _M0MPC15array5Array4pushGUssEE(expanded, word);
        } else {
          const _bind$5 = matches.length;
          let _tmp$39 = 0;
          while (true) {
            const _$2 = _tmp$39;
            if (_$2 < _bind$5) {
              const m = matches[_$2];
              _M0MPC15array5Array4pushGUssEE(expanded, m);
              _tmp$39 = _$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
        }
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return expanded;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22indexed__array__origin(self, name) {
  const keys = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20collect__array__keys(self, name);
  let max_index = -1;
  const _bind$4 = keys.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const key = keys[_];
      const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter36parse__non__negative__int__for__sort(key);
      if (_bind$5 === undefined) {
      } else {
        const _Some = _bind$5;
        const _idx = _Some;
        if (_idx > max_index) {
          max_index = _idx;
        }
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return max_index < 0 ? 0n : BigInt.asUintN(64, BigInt.asUintN(64, BigInt(max_index)) + 1n);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter15contains__slash(name) {
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < name.length) {
      $bound_check(name, i);
      if (name.charCodeAt(i) === 47) {
        return true;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter26is__lookup__shell__builtin(name) {
  switch (name) {
    case ":": {
      return true;
    }
    case ".": {
      return true;
    }
    case "[": {
      return true;
    }
    case "[[": {
      return true;
    }
    case "alias": {
      return true;
    }
    case "break": {
      return true;
    }
    case "builtin": {
      return true;
    }
    case "cd": {
      return true;
    }
    case "command": {
      return true;
    }
    case "compgen": {
      return true;
    }
    case "complete": {
      return true;
    }
    case "compopt": {
      return true;
    }
    case "continue": {
      return true;
    }
    case "declare": {
      return true;
    }
    case "dirs": {
      return true;
    }
    case "echo": {
      return true;
    }
    case "eval": {
      return true;
    }
    case "exec": {
      return true;
    }
    case "exit": {
      return true;
    }
    case "export": {
      return true;
    }
    case "false": {
      return true;
    }
    case "getopts": {
      return true;
    }
    case "hash": {
      return true;
    }
    case "help": {
      return true;
    }
    case "history": {
      return true;
    }
    case "let": {
      return true;
    }
    case "local": {
      return true;
    }
    case "mapfile": {
      return true;
    }
    case "popd": {
      return true;
    }
    case "printf": {
      return true;
    }
    case "pushd": {
      return true;
    }
    case "pwd": {
      return true;
    }
    case "read": {
      return true;
    }
    case "readarray": {
      return true;
    }
    case "readonly": {
      return true;
    }
    case "return": {
      return true;
    }
    case "set": {
      return true;
    }
    case "shift": {
      return true;
    }
    case "shopt": {
      return true;
    }
    case "source": {
      return true;
    }
    case "test": {
      return true;
    }
    case "true": {
      return true;
    }
    case "type": {
      return true;
    }
    case "typeset": {
      return true;
    }
    case "unalias": {
      return true;
    }
    case "unset": {
      return true;
    }
    default: {
      return false;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter29snapshot__array__env__entries(env, name) {
  const _bind$4 = [];
  const saved = _M0MPB3Map3MapGssE(new _M0TPB9ArrayViewGUssEE(_bind$4, 0, 0), undefined);
  const prefix = `${name}[`;
  const count_key = `__MOON_BASH_ARRAY_COUNT__${name}`;
  const _it = _M0MPB3Map5iter2GssE(env);
  while (true) {
    const _bind$5 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$5 === undefined) {
      break;
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      const _key = _x._0;
      const _value = _x._1;
      if (_key === name || (_key === `${name}[@]` || (_key === `${name}[*]` || (_key === count_key || _M0FP410Haoxincode8moonbash3lib11interpreter19string__has__prefix(_key, prefix))))) {
        _M0MPB3Map3setGssE(saved, _key, _value);
      }
      continue;
    }
  }
  return saved;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22clear__hashed__command(self, name) {
  _M0MPB3Map6removeGssE(self.env, `${_M0FP410Haoxincode8moonbash3lib11interpreter21hash__storage__prefix}${name}`);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22collect__array__values(self, name) {
  const keys = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20collect__array__keys(self, name);
  const values = [];
  const _bind$4 = keys.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const key = keys[_];
      const _p$4 = _M0MPB3Map3getGssE(self.env, `${name}[${key}]`);
      const _p$5 = "";
      let _tmp$39;
      if (_p$4 === undefined) {
        _tmp$39 = _p$5;
      } else {
        const _p$6 = _p$4;
        _tmp$39 = _p$6;
      }
      _M0MPC15array5Array4pushGUssEE(values, _tmp$39);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return values;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter28split__string__by__delimiter(s, delim) {
  const result = [];
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const delim_len = delim.length;
  if (delim_len === 0) {
    _M0MPC15array5Array4pushGUssEE(result, s);
    return result;
  }
  let i = 0;
  while (true) {
    if (i < s.length) {
      let match_found = true;
      if ((i + delim_len | 0) <= s.length) {
        let _tmp$38 = 0;
        while (true) {
          const j = _tmp$38;
          if (j < delim_len) {
            const _tmp$39 = i + j | 0;
            $bound_check(s, _tmp$39);
            const _p$4 = s.charCodeAt(_tmp$39);
            $bound_check(delim, j);
            const _p$5 = delim.charCodeAt(j);
            if (_p$4 !== _p$5) {
              match_found = false;
              break;
            }
            _tmp$38 = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
      } else {
        match_found = false;
      }
      if (match_found) {
        _M0MPC15array5Array4pushGUssEE(result, buf.val);
        _M0MPB13StringBuilder5reset(buf);
        i = i + delim_len | 0;
      } else {
        const _tmp$38 = i;
        $bound_check(s, _tmp$38);
        _M0IPB13StringBuilderPB6Logger11write__char(buf, s.charCodeAt(_tmp$38));
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  _M0MPC15array5Array4pushGUssEE(result, buf.val);
  return result;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16command__allowed(self, name) {
  const _bind$4 = _M0MPB3Map3getGssE(self.env, "__MOON_BASH_ALLOWED_COMMANDS");
  if (_bind$4 === undefined) {
    return true;
  } else {
    const _Some = _bind$4;
    const _spec = _Some;
    if (_spec.length === 0) {
      return false;
    }
    const allowed = _M0FP410Haoxincode8moonbash3lib11interpreter28split__string__by__delimiter(_spec, ",");
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < allowed.length) {
        if (_M0MPC15array5Array2atGUssEE(allowed, i) === name) {
          return true;
        }
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return false;
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext30default__path__lookup__enabled(self) {
  const _p$4 = _M0MPB3Map3getGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter35command__default__path__lookup__key);
  const _p$5 = "";
  let _tmp$38;
  if (_p$4 === undefined) {
    _tmp$38 = _p$5;
  } else {
    const _p$6 = _p$4;
    _tmp$38 = _p$6;
  }
  return _tmp$38 === "1";
}
function _M0FP410Haoxincode8moonbash3lib11interpreter18is__shell__builtin(name) {
  switch (name) {
    case "export": {
      return true;
    }
    case "unset": {
      return true;
    }
    case "set": {
      return true;
    }
    case "shift": {
      return true;
    }
    case "exit": {
      return true;
    }
    case "return": {
      return true;
    }
    case "break": {
      return true;
    }
    case "continue": {
      return true;
    }
    case "read": {
      return true;
    }
    case "test": {
      return true;
    }
    case "[": {
      return true;
    }
    case "[[": {
      return true;
    }
    case "printf": {
      return true;
    }
    case "eval": {
      return true;
    }
    case "source": {
      return true;
    }
    case ".": {
      return true;
    }
    case "local": {
      return true;
    }
    case "readonly": {
      return true;
    }
    case "declare": {
      return true;
    }
    case "typeset": {
      return true;
    }
    case "getopts": {
      return true;
    }
    case "let": {
      return true;
    }
    case ":": {
      return true;
    }
    case "type": {
      return true;
    }
    case "command": {
      return true;
    }
    case "builtin": {
      return true;
    }
    case "hash": {
      return true;
    }
    case "shopt": {
      return true;
    }
    case "complete": {
      return true;
    }
    case "compgen": {
      return true;
    }
    case "compopt": {
      return true;
    }
    case "pushd": {
      return true;
    }
    case "popd": {
      return true;
    }
    case "dirs": {
      return true;
    }
    case "basename": {
      return true;
    }
    case "dirname": {
      return true;
    }
    case "seq": {
      return true;
    }
    case "rev": {
      return true;
    }
    case "nl": {
      return true;
    }
    case "fold": {
      return true;
    }
    case "expand": {
      return true;
    }
    case "unexpand": {
      return true;
    }
    case "paste": {
      return true;
    }
    case "column": {
      return true;
    }
    case "join": {
      return true;
    }
    case "tr": {
      return true;
    }
    case "sort": {
      return true;
    }
    case "uniq": {
      return true;
    }
    case "cut": {
      return true;
    }
    case "tee": {
      return true;
    }
    case "sed": {
      return true;
    }
    case "grep": {
      return true;
    }
    case "egrep": {
      return true;
    }
    case "fgrep": {
      return true;
    }
    case "rg": {
      return true;
    }
    case "xargs": {
      return true;
    }
    case "date": {
      return true;
    }
    case "env": {
      return true;
    }
    case "printenv": {
      return true;
    }
    case "which": {
      return true;
    }
    case "whoami": {
      return true;
    }
    case "hostname": {
      return true;
    }
    case "help": {
      return true;
    }
    case "clear": {
      return true;
    }
    case "history": {
      return true;
    }
    case "tac": {
      return true;
    }
    case "od": {
      return true;
    }
    case "alias": {
      return true;
    }
    case "unalias": {
      return true;
    }
    case "bash": {
      return true;
    }
    case "sh": {
      return true;
    }
    case "time": {
      return true;
    }
    case "sleep": {
      return true;
    }
    case "timeout": {
      return true;
    }
    case "mapfile": {
      return true;
    }
    case "readarray": {
      return true;
    }
    case "cd": {
      return true;
    }
    case "pwd": {
      return true;
    }
    case "echo": {
      return true;
    }
    case "true": {
      return true;
    }
    case "false": {
      return true;
    }
    default: {
      return false;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter31command__has__virtual__external(name) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands13find__command(name);
  if (_bind$4 === undefined) {
  } else {
    return true;
  }
  return _M0FP410Haoxincode8moonbash3lib11interpreter18is__shell__builtin(name) && !_M0FP410Haoxincode8moonbash3lib11interpreter26is__lookup__shell__builtin(name);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter30command__is__executable__entry(entry) {
  switch (entry.$tag) {
    case 0: {
      const _File = entry;
      const _data = _File._0;
      const _p$4 = _data.mode;
      return (_p$4 & 73) !== 0;
    }
    case 2: {
      const _Symlink = entry;
      const _data$2 = _Symlink._0;
      const _p$5 = _data$2.mode;
      return (_p$5 & 73) !== 0;
    }
    default: {
      return false;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter33command__path__display__candidate(path_dir, name) {
  if (path_dir.length === 0) {
    return name;
  }
  if (path_dir === "/") {
    return `/${name}`;
  }
  const _tmp$38 = path_dir.length - 1 | 0;
  $bound_check(path_dir, _tmp$38);
  if (path_dir.charCodeAt(_tmp$38) === 47) {
    return `${path_dir}${name}`;
  }
  return `${path_dir}/${name}`;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31collect__path__command__matches(self, name, use_default_path, include_virtual_fallback, stop_after_first) {
  const matches = [];
  const _bind$4 = [];
  const seen = _M0MPB3Map3MapGsbE(new _M0TPB9ArrayViewGUsbEE(_bind$4, 0, 0), undefined);
  if (name.length === 0) {
    return matches;
  }
  if (_M0FP410Haoxincode8moonbash3lib11interpreter15contains__slash(name)) {
    let resolved;
    let _try_err;
    _L: {
      _L$2: {
        const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, name);
        if (_bind$5.$tag === 1) {
          const _ok = _bind$5;
          resolved = _ok._0;
        } else {
          const _err = _bind$5;
          _try_err = _err._0;
          break _L$2;
        }
        break _L;
      }
      return matches;
    }
    const _bind$5 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.fs.entries, resolved);
    if (_bind$5 === undefined) {
    } else {
      const _Some = _bind$5;
      const _entry = _Some;
      if (_M0FP410Haoxincode8moonbash3lib11interpreter30command__is__executable__entry(_entry)) {
        _M0MPC15array5Array4pushGUssEE(matches, { _0: name, _1: resolved, _2: false });
      }
    }
    return matches;
  }
  let path_spec;
  if (use_default_path) {
    path_spec = _M0FP410Haoxincode8moonbash3lib11interpreter22default__command__path;
  } else {
    const _p$4 = _M0MPB3Map3getGssE(self.env, "PATH");
    const _p$5 = "";
    if (_p$4 === undefined) {
      path_spec = _p$5;
    } else {
      const _p$6 = _p$4;
      path_spec = _p$6;
    }
  }
  const path_dirs = _M0FP410Haoxincode8moonbash3lib11interpreter28split__string__by__delimiter(path_spec, ":");
  const _bind$5 = path_dirs.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const path_dir = path_dirs[_];
      _L: {
        const display = _M0FP410Haoxincode8moonbash3lib11interpreter33command__path__display__candidate(path_dir, name);
        let resolved;
        let _try_err;
        _L$2: {
          _L$3: {
            const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, display);
            if (_bind$6.$tag === 1) {
              const _ok = _bind$6;
              resolved = _ok._0;
            } else {
              const _err = _bind$6;
              _try_err = _err._0;
              break _L$3;
            }
            break _L$2;
          }
          break _L;
        }
        let candidate_missing = false;
        const _bind$6 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.fs.entries, resolved);
        if (_bind$6 === undefined) {
          candidate_missing = true;
        } else {
          const _Some = _bind$6;
          const _entry = _Some;
          if (!_M0FP410Haoxincode8moonbash3lib11interpreter30command__is__executable__entry(_entry)) {
          } else {
            if (_M0MPB3Map8containsGsbE(seen, display)) {
              break _L;
            }
            _M0MPB3Map3setGsbE(seen, display, true);
            _M0MPC15array5Array4pushGUssEE(matches, { _0: display, _1: resolved, _2: false });
            if (stop_after_first) {
              return matches;
            }
          }
        }
        if (include_virtual_fallback && (candidate_missing && ((path_dir === "/usr/bin" || path_dir === "/bin") && _M0FP410Haoxincode8moonbash3lib11interpreter31command__has__virtual__external(name)))) {
          if (_M0MPB3Map8containsGsbE(seen, display)) {
            break _L;
          }
          _M0MPB3Map3setGsbE(seen, display, true);
          _M0MPC15array5Array4pushGUssEE(matches, { _0: display, _1: resolved, _2: true });
          if (stop_after_first) {
            return matches;
          }
        }
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return matches;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27first__path__command__match(self, name, use_default_path, include_virtual_fallback) {
  const matches = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31collect__path__command__matches(self, name, use_default_path, include_virtual_fallback, true);
  return matches.length === 0 ? undefined : _M0MPC15array5Array2atGUssEE(matches, 0);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29lookup__hashed__command__path(self, name) {
  return _M0MPB3Map3getGssE(self.env, `${_M0FP410Haoxincode8moonbash3lib11interpreter21hash__storage__prefix}${name}`);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31remember__hashed__command__path(self, name, path) {
  if (name.length === 0 || _M0FP410Haoxincode8moonbash3lib11interpreter15contains__slash(name)) {
    return undefined;
  }
  _M0MPB3Map3setGssE(self.env, `${_M0FP410Haoxincode8moonbash3lib11interpreter21hash__storage__prefix}${name}`, path);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25remember__hashed__command(self, name) {
  if (name.length === 0 || _M0FP410Haoxincode8moonbash3lib11interpreter15contains__slash(name)) {
    return undefined;
  }
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31remember__hashed__command__path(self, name, `/usr/bin/${name}`);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext28restore__array__env__entries(self, name, saved) {
  const prefix = `${name}[`;
  const count_key = `__MOON_BASH_ARRAY_COUNT__${name}`;
  const to_remove = [];
  const _it = _M0MPB3Map5iter2GssE(self.env);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _key = _x._0;
      if (_key === name || (_key === `${name}[@]` || (_key === `${name}[*]` || (_key === count_key || _M0FP410Haoxincode8moonbash3lib11interpreter19string__has__prefix(_key, prefix))))) {
        _M0MPC15array5Array4pushGUssEE(to_remove, _key);
      }
      continue;
    }
  }
  const _bind$4 = to_remove.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const key = to_remove[_];
      _M0MPB3Map6removeGssE(self.env, key);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _it$2 = _M0MPB3Map5iter2GssE(saved);
  while (true) {
    const _bind$5 = _M0MPB5Iter24nextGssE(_it$2);
    if (_bind$5 === undefined) {
      return;
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      const _key = _x._0;
      const _value = _x._1;
      _M0MPB3Map3setGssE(self.env, _key, _value);
      continue;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter24local__scope__names__key(depth) {
  return `__MOON_BASH_LOCAL_NAMES__${_M0MPC13int3Int18to__string_2einner(depth, 10)}`;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter29local__scope__saved__set__key(depth, name) {
  return `__MOON_BASH_LOCAL_SET__${_M0MPC13int3Int18to__string_2einner(depth, 10)}__${name}`;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter31local__scope__saved__value__key(depth, name) {
  return `__MOON_BASH_LOCAL_VAL__${_M0MPC13int3Int18to__string_2einner(depth, 10)}__${name}`;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter26split__local__scope__names(spec) {
  const parts = [];
  let start = 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i <= spec.length) {
      let _tmp$39;
      if (i === spec.length) {
        _tmp$39 = true;
      } else {
        $bound_check(spec, i);
        _tmp$39 = spec.charCodeAt(i) === 31;
      }
      if (_tmp$39) {
        if (i > start) {
          _M0MPC15array5Array4pushGUssEE(parts, _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(spec, start, i)));
        }
        start = i + 1 | 0;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return parts;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24restore__local__bindings(self, depth) {
  if (depth <= 0) {
    return undefined;
  }
  const names_key = _M0FP410Haoxincode8moonbash3lib11interpreter24local__scope__names__key(depth);
  const _p$4 = _M0MPB3Map3getGssE(self.env, names_key);
  const _p$5 = "";
  let names;
  if (_p$4 === undefined) {
    names = _p$5;
  } else {
    const _p$6 = _p$4;
    names = _p$6;
  }
  if (names.length === 0) {
    _M0MPB3Map6removeGssE(self.env, names_key);
    return undefined;
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter26split__local__scope__names(names);
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const name = _bind$4[_];
      const saved_set_key = _M0FP410Haoxincode8moonbash3lib11interpreter29local__scope__saved__set__key(depth, name);
      const saved_value_key = _M0FP410Haoxincode8moonbash3lib11interpreter31local__scope__saved__value__key(depth, name);
      const _bind$6 = _M0MPB3Map3getGssE(self.env, saved_set_key);
      if (_bind$6 === undefined) {
      } else {
        const _Some = _bind$6;
        const _flag = _Some;
        if (_flag === "1") {
          const _tmp$39 = self.env;
          const _p$6 = _M0MPB3Map3getGssE(self.env, saved_value_key);
          const _p$7 = "";
          let _tmp$40;
          if (_p$6 === undefined) {
            _tmp$40 = _p$7;
          } else {
            const _p$8 = _p$6;
            _tmp$40 = _p$8;
          }
          _M0MPB3Map3setGssE(_tmp$39, name, _tmp$40);
        } else {
          _M0MPB3Map6removeGssE(self.env, name);
        }
      }
      _M0MPB3Map6removeGssE(self.env, saved_set_key);
      _M0MPB3Map6removeGssE(self.env, saved_value_key);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MPB3Map6removeGssE(self.env, names_key);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27set__positional__parameters(self, values) {
  const _bind$4 = _M0MPB3Map3getGssE(self.env, "#");
  let old_count;
  if (_bind$4 === undefined) {
    old_count = 0;
  } else {
    const _Some = _bind$4;
    const _s = _Some;
    old_count = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_s);
  }
  let _tmp$38 = 1;
  while (true) {
    const i = _tmp$38;
    if (i <= old_count) {
      _M0MPB3Map6removeGssE(self.env, _M0MPC13int3Int18to__string_2einner(i, 10));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _p$4 = _M0MPC15array5Array4iterGsE(values);
  const _p$5 = "";
  let _p$6 = _p$5;
  while (true) {
    const _p$7 = _M0MPB4Iter4nextGUssEE(_p$4);
    if (_p$7 === undefined) {
      break;
    } else {
      const _p$8 = _p$7;
      const _p$9 = _p$8;
      const _p$10 = _p$6;
      _p$6 = _p$10.length === 0 ? _p$9 : `${_p$10} ${_p$9}`;
      continue;
    }
  }
  const joined = _p$6;
  _M0MPB3Map3setGssE(self.env, "@", joined);
  _M0MPB3Map3setGssE(self.env, "#", _M0MPC13int3Int18to__string_2einner(values.length, 10));
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < values.length) {
      _M0MPB3Map3setGssE(self.env, _M0MPC13int3Int18to__string_2einner(i + 1 | 0, 10), _M0MPC15array5Array2atGUssEE(values, i));
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter35is__virtual__command__stub__content(content) {
  return content.length === 0 || _M0FP410Haoxincode8moonbash3lib11interpreter19string__has__prefix(content, _M0FP410Haoxincode8moonbash3lib11interpreter29command__stub__marker__prefix);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29build__external__command__env(self) {
  const _bind$4 = [];
  const out = _M0MPB3Map3MapGssE(new _M0TPB9ArrayViewGUssEE(_bind$4, 0, 0), undefined);
  const _it = _M0MPB3Map5iter2GsbE(self.exported);
  while (true) {
    const _bind$5 = _M0MPB5Iter24nextGsbE(_it);
    if (_bind$5 === undefined) {
      break;
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      const _name = _x._0;
      const _enabled = _x._1;
      if (!_enabled) {
        continue;
      }
      if (_M0MPB3Map8containsGssE(self.env, `__MOON_BASH_ARRAY_COUNT__${_name}`)) {
        continue;
      }
      const _p$4 = _M0MPB3Map3getGssE(self.env, _name);
      const _p$5 = "";
      let _tmp$38;
      if (_p$4 === undefined) {
        _tmp$38 = _p$5;
      } else {
        const _p$6 = _p$4;
        _tmp$38 = _p$6;
      }
      _M0MPB3Map3setGssE(out, _name, _tmp$38);
      continue;
    }
  }
  return out;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__alias(self, args) {
  let start = 0;
  if (args.length > 0 && _M0MPC15array5Array2atGUssEE(args, 0) === "--") {
    start = 1;
  }
  if (start >= args.length) {
    const _it = _M0MPB3Map5iter2GssE(self.env);
    while (true) {
      const _bind$4 = _M0MPB5Iter24nextGssE(_it);
      if (_bind$4 === undefined) {
        break;
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        const _k = _x._0;
        const _v = _x._1;
        if (_M0MPC16string6String11has__prefix(_k, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib11interpreter13alias__prefix, 0, _M0FP410Haoxincode8moonbash3lib11interpreter13alias__prefix.length))) {
          const name = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(_k, _M0FP410Haoxincode8moonbash3lib11interpreter13alias__prefix.length, undefined));
          _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `alias ${name}='${_v}'\n`);
        }
        continue;
      }
    }
    self.exit_code = 0;
    return undefined;
  }
  let _tmp$38 = start;
  while (true) {
    const i = _tmp$38;
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      let eq_pos = -1;
      let _tmp$39 = 0;
      while (true) {
        const i$2 = _tmp$39;
        if (i$2 < arg.length) {
          $bound_check(arg, i$2);
          const _p$4 = arg.charCodeAt(i$2);
          const _p$5 = 61;
          if (_p$4 === _p$5) {
            eq_pos = i$2;
            break;
          }
          _tmp$39 = i$2 + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      if (eq_pos > 0) {
        const name = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 0, eq_pos));
        const value = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, eq_pos + 1 | 0, undefined));
        _M0MPB3Map3setGssE(self.env, `${_M0FP410Haoxincode8moonbash3lib11interpreter13alias__prefix}${name}`, value);
      } else {
        const key = `${_M0FP410Haoxincode8moonbash3lib11interpreter13alias__prefix}${arg}`;
        const _bind$4 = _M0MPB3Map3getGssE(self.env, key);
        if (_bind$4 === undefined) {
          _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: alias: ${arg}: not found\n`);
          self.exit_code = 1;
          return undefined;
        } else {
          const _Some = _bind$4;
          const _v = _Some;
          _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `alias ${arg}='${_v}'\n`);
        }
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter34trim__trailing__slashes__for__path(path) {
  if (path.length === 0) {
    return path;
  }
  let end = path.length;
  while (true) {
    let _tmp$38;
    if (end > 1) {
      const _tmp$39 = end - 1 | 0;
      $bound_check(path, _tmp$39);
      const _p$4 = path.charCodeAt(_tmp$39);
      const _p$5 = 47;
      _tmp$38 = _p$4 === _p$5;
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      end = end - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return end === path.length ? path : _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(path, 0, end));
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17builtin__basename(self, args) {
  if (args.length === 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "basename: missing operand\n");
    self.exit_code = 1;
    return undefined;
  }
  let allow_multiple = false;
  let suffix = undefined;
  const paths = [];
  let i = 0;
  while (true) {
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      if (arg === "-a") {
        allow_multiple = true;
        i = i + 1 | 0;
        continue;
      }
      if (arg === "-s") {
        if ((i + 1 | 0) >= args.length) {
          _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "basename: option requires an argument -- 's'\n");
          self.exit_code = 1;
          return undefined;
        }
        suffix = _M0MPC15array5Array2atGUssEE(args, i + 1 | 0);
        allow_multiple = true;
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17builtin__basenameN7_2abindS6347, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17builtin__basenameN7_2abindS6347.length)) && arg.length > 2) {
        suffix = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined));
        allow_multiple = true;
        i = i + 1 | 0;
        continue;
      }
      _M0MPC15array5Array4pushGUssEE(paths, arg);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (paths.length === 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "basename: missing operand\n");
    self.exit_code = 1;
    return undefined;
  }
  if (!allow_multiple) {
    const raw = _M0FP410Haoxincode8moonbash3lib11interpreter34trim__trailing__slashes__for__path(_M0MPC15array5Array2atGUssEE(paths, 0));
    const _bind$4 = suffix;
    let effective_suffix;
    if (_bind$4 === undefined) {
      effective_suffix = paths.length > 1 ? _M0MPC15array5Array2atGUssEE(paths, 1) : undefined;
    } else {
      const _Some = _bind$4;
      const _s = _Some;
      effective_suffix = _s;
    }
    let name = _M0FP410Haoxincode8moonbash3lib2fs8basename(raw);
    if (effective_suffix === undefined) {
    } else {
      const _Some = effective_suffix;
      const _s = _Some;
      if (name.length > _s.length && _M0MPC16string6String11has__suffix(name, new _M0TPC16string10StringView(_s, 0, _s.length))) {
        name = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(name, 0, name.length - _s.length | 0));
      }
    }
    _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name}\n`);
    self.exit_code = 0;
    return undefined;
  }
  const _bind$4 = paths.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const path = paths[_];
      const raw = _M0FP410Haoxincode8moonbash3lib11interpreter34trim__trailing__slashes__for__path(path);
      let name = _M0FP410Haoxincode8moonbash3lib2fs8basename(raw);
      const _bind$5 = suffix;
      if (_bind$5 === undefined) {
      } else {
        const _Some = _bind$5;
        const _s = _Some;
        if (name.length > _s.length && _M0MPC16string6String11has__suffix(name, new _M0TPC16string10StringView(_s, 0, _s.length))) {
          name = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(name, 0, name.length - _s.length | 0));
        }
      }
      _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name}\n`);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(value) {
  return new _M0TP410Haoxincode8moonbash3lib11interpreter14TestEvalResult(value, 0);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter19test__eval__negated(result) {
  return result.status !== 0 ? result : _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(!result.value);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter22test__token__has__meta(token) {
  if (token.length > 0) {
    let _tmp$38;
    $bound_check(token, 0);
    const _p$4 = token.charCodeAt(0);
    const _p$5 = 6;
    if (_p$4 === _p$5) {
      _tmp$38 = true;
    } else {
      $bound_check(token, 0);
      const _p$6 = token.charCodeAt(0);
      const _p$7 = 7;
      _tmp$38 = _p$6 === _p$7;
    }
    return _tmp$38;
  } else {
    return false;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter16test__token__raw(token) {
  return _M0FP410Haoxincode8moonbash3lib11interpreter22test__token__has__meta(token) ? _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(token, 1, undefined)) : token;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter27test__eval__string__operand(arg) {
  return _M0FP410Haoxincode8moonbash3lib11interpreter16test__token__raw(arg).length > 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter20test__is__binary__op(op) {
  switch (op) {
    case "=": {
      return true;
    }
    case "==": {
      return true;
    }
    case "!=": {
      return true;
    }
    case "<": {
      return true;
    }
    case ">": {
      return true;
    }
    case "=~": {
      return true;
    }
    case "-eq": {
      return true;
    }
    case "-ne": {
      return true;
    }
    case "-lt": {
      return true;
    }
    case "-le": {
      return true;
    }
    case "-gt": {
      return true;
    }
    case "-ge": {
      return true;
    }
    case "-nt": {
      return true;
    }
    case "-ot": {
      return true;
    }
    case "-ef": {
      return true;
    }
    default: {
      return false;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter19test__is__unary__op(op) {
  switch (op) {
    case "-a": {
      return true;
    }
    case "-e": {
      return true;
    }
    case "-f": {
      return true;
    }
    case "-d": {
      return true;
    }
    case "-s": {
      return true;
    }
    case "-r": {
      return true;
    }
    case "-w": {
      return true;
    }
    case "-x": {
      return true;
    }
    case "-L": {
      return true;
    }
    case "-h": {
      return true;
    }
    case "-k": {
      return true;
    }
    case "-O": {
      return true;
    }
    case "-G": {
      return true;
    }
    case "-u": {
      return true;
    }
    case "-g": {
      return true;
    }
    case "-b": {
      return true;
    }
    case "-c": {
      return true;
    }
    case "-S": {
      return true;
    }
    case "-p": {
      return true;
    }
    case "-t": {
      return true;
    }
    case "-v": {
      return true;
    }
    case "-o": {
      return true;
    }
    case "-z": {
      return true;
    }
    case "-n": {
      return true;
    }
    default: {
      return false;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter31test__mode__is__double__bracket(mode) {
  if (mode === 2) {
    return true;
  } else {
    return false;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter17test__slice__args(args, start, end_) {
  const out = [];
  let _tmp$38 = start;
  while (true) {
    const i = _tmp$38;
    if (i < end_) {
      _M0MPC15array5Array4pushGUssEE(out, _M0MPC15array5Array2atGUssEE(args, i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter30test__token__can__be__operator(token) {
  return !_M0FP410Haoxincode8moonbash3lib11interpreter22test__token__has__meta(token);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter18test__entry__mtime(entry) {
  switch (entry.$tag) {
    case 0: {
      const _File = entry;
      const _data = _File._0;
      return _data.mtime;
    }
    case 1: {
      const _Directory = entry;
      const _data$2 = _Directory._0;
      return _data$2.mtime;
    }
    default: {
      const _Symlink = entry;
      const _data$3 = _Symlink._0;
      return _data$3.mtime;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter28test__escape__regex__literal(s) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      if (ch === 92 || (ch === 46 || (ch === 94 || (ch === 36 || (ch === 42 || (ch === 43 || (ch === 63 || (ch === 40 || (ch === 41 || (ch === 91 || (ch === 93 || (ch === 123 || (ch === 125 || ch === 124))))))))))))) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter29test__parse__decimal__operand(text) {
  const trimmed = _M0FP410Haoxincode8moonbash3lib11interpreter11arith__trim(text);
  if (trimmed.length === 0) {
    return undefined;
  }
  let start = 0;
  let sign = 1n;
  $bound_check(trimmed, 0);
  const _p$4 = trimmed.charCodeAt(0);
  const _p$5 = 43;
  if (_p$4 === _p$5) {
    start = 1;
  } else {
    $bound_check(trimmed, 0);
    const _p$6 = trimmed.charCodeAt(0);
    const _p$7 = 45;
    if (_p$6 === _p$7) {
      start = 1;
      sign = 18446744073709551615n;
    }
  }
  if (start >= trimmed.length) {
    return undefined;
  }
  let value = 0n;
  let _tmp$38 = start;
  while (true) {
    const i = _tmp$38;
    if (i < trimmed.length) {
      $bound_check(trimmed, i);
      const ch = trimmed.charCodeAt(i);
      if (ch < 48 || ch > 57) {
        return undefined;
      }
      value = BigInt.asUintN(64, BigInt.asUintN(64, value * 10n) + BigInt.asUintN(64, BigInt(ch - 48 | 0)));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return BigInt.asUintN(64, value * sign);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter23test__has__glob__escape(s) {
  let i = 0;
  while (true) {
    if ((i + 1 | 0) < s.length) {
      const _tmp$38 = i;
      $bound_check(s, _tmp$38);
      if (s.charCodeAt(_tmp$38) === 92) {
        const _tmp$39 = i + 1 | 0;
        $bound_check(s, _tmp$39);
        const next = s.charCodeAt(_tmp$39);
        if (next === 42 || (next === 63 || (next === 91 || next === 92))) {
          return true;
        }
        i = i + 2 | 0;
        continue;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter21test__string__compare(left, right) {
  return _M0FP410Haoxincode8moonbash3lib11interpreter15has__glob__meta(right) || _M0FP410Haoxincode8moonbash3lib11interpreter23test__has__glob__escape(right) ? _M0FP410Haoxincode8moonbash3lib11interpreter22simple__pattern__match(left, right) : left === right;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter22test__token__is__tilde(token) {
  if (token.length > 0) {
    $bound_check(token, 0);
    const _p$4 = token.charCodeAt(0);
    const _p$5 = 6;
    return _p$4 === _p$5;
  } else {
    return false;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter29test__unescape__glob__escapes(s) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  while (true) {
    if (i < s.length) {
      const _tmp$38 = i;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch === 92 && (i + 1 | 0) < s.length) {
        const _tmp$39 = i + 1 | 0;
        $bound_check(s, _tmp$39);
        const next = s.charCodeAt(_tmp$39);
        if (next === 42 || (next === 63 || (next === 91 || next === 92))) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, next);
          i = i + 2 | 0;
          continue;
        }
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31test__eval__regex__with__status(self, text, pattern) {
  let matcher;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib5regex30compile__grep__matcher_2einner(pattern, true, false, false);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        matcher = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24store__array__assignment(self, "BASH_REMATCH", []);
    return _M0FP410Haoxincode8moonbash3lib11interpreter25test__eval__syntax__errorN6recordS11268;
  }
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib5regex11GrepMatcher33find__first__with__groups_2einner(matcher, text, 0);
  if (_bind$4 === undefined) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24store__array__assignment(self, "BASH_REMATCH", []);
    return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(false);
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _start = _x._0;
    const _end = _x._1;
    const _groups = _x._2;
    const values = [];
    _M0MPC15array5Array4pushGUssEE(values, _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(text, _start, _end)));
    const _bind$5 = _groups.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$5) {
        const group = _groups[_];
        _M0MPC15array5Array4pushGUssEE(values, group);
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24store__array__assignment(self, "BASH_REMATCH", values);
    return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(true);
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19test__lookup__entry(self, arg, follow_symlink) {
  let resolved;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, arg);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        resolved = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    return undefined;
  }
  if (!follow_symlink) {
    return _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.fs.entries, resolved);
  }
  let current = resolved;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < 40) {
      const _bind$4 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.fs.entries, current);
      if (_bind$4 === undefined) {
        return undefined;
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        if (_x.$tag === 2) {
          const _Symlink = _x;
          const _data = _Symlink._0;
          let _tmp$39;
          let _try_err$2;
          _L$2: {
            _L$3: {
              let _tmp$40;
              if (_data.target.length > 0) {
                const _tmp$41 = _data.target;
                $bound_check(_tmp$41, 0);
                const _p$4 = _tmp$41.charCodeAt(0);
                const _p$5 = 47;
                _tmp$40 = _p$4 === _p$5;
              } else {
                _tmp$40 = false;
              }
              if (_tmp$40) {
                const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path("/", _data.target);
                if (_bind$5.$tag === 1) {
                  const _ok = _bind$5;
                  _tmp$39 = _ok._0;
                } else {
                  const _err = _bind$5;
                  _try_err$2 = _err._0;
                  break _L$3;
                }
              } else {
                const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(_M0FP410Haoxincode8moonbash3lib2fs12parent__path(current), _data.target);
                if (_bind$5.$tag === 1) {
                  const _ok = _bind$5;
                  _tmp$39 = _ok._0;
                } else {
                  const _err = _bind$5;
                  _try_err$2 = _err._0;
                  break _L$3;
                }
              }
              break _L$2;
            }
            return undefined;
          }
          current = _tmp$39;
        } else {
          return _x;
        }
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter17test__entry__mode(entry) {
  switch (entry.$tag) {
    case 0: {
      const _File = entry;
      const _data = _File._0;
      return _data.mode;
    }
    case 1: {
      const _Directory = entry;
      const _data$2 = _Directory._0;
      return _data$2.mode;
    }
    default: {
      const _Symlink = entry;
      const _data$3 = _Symlink._0;
      return _data$3.mode;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter24test__parse__fd__operand(text) {
  if (text.length === 0) {
    return undefined;
  }
  let value = 0n;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < text.length) {
      $bound_check(text, i);
      const ch = text.charCodeAt(i);
      if (ch < 48 || ch > 57) {
        return undefined;
      }
      value = BigInt.asUintN(64, BigInt.asUintN(64, value * 10n) + BigInt.asUintN(64, BigInt(ch - 48 | 0)));
      if (BigInt.asIntN(64, value) > BigInt.asIntN(64, 2147483647n)) {
        return undefined;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return value;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter28test__shell__option__enabled(ctx, name) {
  switch (name) {
    case "pipefail": {
      return ctx.options.pipefail;
    }
    case "errexit": {
      return ctx.options.errexit;
    }
    case "nounset": {
      return ctx.options.nounset;
    }
    case "noglob": {
      return ctx.options.noglob;
    }
    case "xtrace": {
      return ctx.options.xtrace;
    }
    case "noclobber": {
      return ctx.options.noclobber;
    }
    case "allexport": {
      return ctx.options.allexport;
    }
    default: {
      return -1;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter31contains__test__arith__operator(text) {
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < text.length) {
      $bound_check(text, i);
      const ch = text.charCodeAt(i);
      if (ch === 43 || (ch === 45 || (ch === 42 || (ch === 47 || (ch === 37 || (ch === 38 || (ch === 124 || (ch === 94 || (ch === 60 || (ch === 62 || (ch === 40 || (ch === 41 || (ch === 63 || (ch === 58 || (ch === 91 || ch === 93))))))))))))))) {
        return true;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter14TestExprParser4peek(self) {
  return self.pos < self.tokens.length ? _M0MPC15array5Array2atGUssEE(self.tokens, self.pos) : undefined;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter27is__positive__decimal__text(text) {
  if (text.length === 0) {
    return false;
  }
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < text.length) {
      $bound_check(text, i);
      const ch = text.charCodeAt(i);
      if (ch < 48 || ch > 57) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32parse__loop__control__count__arg(self, builtin_name, args) {
  if (args.length === 0) {
    return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32parse__loop__control__count__argN6constrS11269;
  }
  if (args.length > 1) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: ${builtin_name}: too many arguments\n`);
    self.exit_code = 1;
    self.should_exit = true;
    return undefined;
  }
  const raw = _M0MPC15array5Array2atGUssEE(args, 0);
  if (!_M0FP410Haoxincode8moonbash3lib11interpreter27is__positive__decimal__text(raw)) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: ${builtin_name}: ${raw}: numeric argument required\n`);
    self.exit_code = 1;
    self.should_exit = true;
    return undefined;
  }
  const n = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(raw);
  if (n <= 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: ${builtin_name}: ${raw}: loop count out of range\n`);
    self.exit_code = 1;
    self.should_exit = true;
    return undefined;
  }
  return n;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__break(self, args) {
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32parse__loop__control__count__arg(self, "break", args);
  let n;
  if (_bind$4 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$4;
    n = _Some;
  }
  if (self.loop_depth <= 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "moon_bash: break: only meaningful in a `for', `while', or `until' loop\n");
    self.exit_code = 1;
    return undefined;
  }
  self.break_count = n;
  self.exit_code = 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21get__directory__stack(self) {
  const stack = [];
  const _p$4 = _M0MPB3Map3getGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter24dir__stack__storage__key);
  const _p$5 = "";
  let raw;
  if (_p$4 === undefined) {
    raw = _p$5;
  } else {
    const _p$6 = _p$4;
    raw = _p$6;
  }
  if (raw.length > 0) {
    const parts = _M0FP410Haoxincode8moonbash3lib11interpreter28split__string__by__delimiter(raw, "\n");
    const _bind$4 = parts.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$4) {
        const path = parts[_];
        if (path.length > 0) {
          _M0MPC15array5Array4pushGUssEE(stack, path);
        }
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  if (stack.length === 0) {
    _M0MPC15array5Array4pushGUssEE(stack, self.cwd);
  }
  return stack;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21set__directory__stack(self, stack_input) {
  const stack = [];
  const _bind$4 = stack_input.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const path = stack_input[_];
      _M0MPC15array5Array4pushGUssEE(stack, path);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (stack.length === 0) {
    _M0MPC15array5Array4pushGUssEE(stack, self.cwd);
  }
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < stack.length) {
      if (i > 0) {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, 10);
      }
      _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0MPC15array5Array2atGUssEE(stack, i));
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MPB3Map3setGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter24dir__stack__storage__key, buf.val);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33sync__directory__stack__with__cwd(self) {
  const stack = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21get__directory__stack(self);
  if (stack.length === 0) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21set__directory__stack(self, [self.cwd]);
    return undefined;
  }
  _M0MPC15array5Array3setGsE(stack, 0, self.cwd);
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21set__directory__stack(self, stack);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20builtin__builtin__cd(self, args) {
  let target;
  if (args.length === 0) {
    const _p$4 = _M0MPB3Map3getGssE(self.env, "HOME");
    const _p$5 = "/home/user";
    if (_p$4 === undefined) {
      target = _p$5;
    } else {
      const _p$6 = _p$4;
      target = _p$6;
    }
  } else {
    if (_M0MPC15array5Array2atGUssEE(args, 0) === "-") {
      const _p$4 = _M0MPB3Map3getGssE(self.env, "OLDPWD");
      const _p$5 = self.cwd;
      if (_p$4 === undefined) {
        target = _p$5;
      } else {
        const _p$6 = _p$4;
        target = _p$6;
      }
    } else {
      target = _M0MPC15array5Array2atGUssEE(args, 0);
    }
  }
  let resolved;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, target);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        resolved = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    self.exit_code = 1;
    return undefined;
  }
  _L$2: {
    const _bind$4 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.fs.entries, resolved);
    if (_bind$4 === undefined) {
      break _L$2;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      if (_x.$tag === 1) {
        const old_pwd = self.cwd;
        self.cwd = resolved;
        _M0MPB3Map3setGssE(self.env, "PWD", resolved);
        _M0MPB3Map3setGssE(self.env, "OLDPWD", old_pwd);
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33sync__directory__stack__with__cwd(self);
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25remember__hashed__command(self, "cd");
        self.exit_code = 0;
        return;
      } else {
        break _L$2;
      }
    }
  }
  self.exit_code = 1;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__clear(self, _args) {
  self.exit_code = 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter12repeat__char(ch, count) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const total = count < 0 ? 0 : count;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < total) {
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter12split__lines(s) {
  const result = [];
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      if (ch === 10) {
        _M0MPC15array5Array4pushGUssEE(result, buf.val);
        _M0MPB13StringBuilder5reset(buf);
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const remaining = buf.val;
  if (remaining.length > 0) {
    _M0MPC15array5Array4pushGUssEE(result, remaining);
  }
  return result;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter26split__lines__no__trailing(s) {
  if (s.length === 0) {
    return [];
  }
  const lines = _M0FP410Haoxincode8moonbash3lib11interpreter12split__lines(s);
  if (lines.length > 0 && _M0MPC15array5Array2atGUssEE(lines, lines.length - 1 | 0) === "") {
    const result = [];
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < (lines.length - 1 | 0)) {
        _M0MPC15array5Array4pushGUssEE(result, _M0MPC15array5Array2atGUssEE(lines, i));
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return result;
  } else {
    return lines;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter21format__column__table(input, separator) {
  const lines = _M0FP410Haoxincode8moonbash3lib11interpreter26split__lines__no__trailing(input);
  if (lines.length === 0) {
    return "";
  }
  const rows = [];
  const widths = [];
  const _bind$4 = lines.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const line = lines[_];
      let fields;
      if (separator === undefined) {
        fields = _M0FP410Haoxincode8moonbash3lib11interpreter21split__by__whitespace(line);
      } else {
        const _Some = separator;
        const _delim = _Some;
        fields = _M0FP410Haoxincode8moonbash3lib11interpreter28split__string__by__delimiter(line, _delim);
      }
      _M0MPC15array5Array4pushGRPB5ArrayGsEE(rows, fields);
      let _tmp$39 = 0;
      while (true) {
        const col = _tmp$39;
        if (col < fields.length) {
          const field_width = _M0MPC15array5Array2atGUssEE(fields, col).length;
          if (col >= widths.length) {
            _M0MPC15array5Array4pushGiE(widths, field_width);
          } else {
            if (field_width > _M0MPC15array5Array2atGiE(widths, col)) {
              _M0MPC15array5Array3setGiE(widths, col, field_width);
            }
          }
          _tmp$39 = col + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _bind$5 = rows.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$5) {
      const row = rows[_];
      let _tmp$40 = 0;
      while (true) {
        const col = _tmp$40;
        if (col < row.length) {
          const field = _M0MPC15array5Array2atGUssEE(row, col);
          _M0IPB13StringBuilderPB6Logger13write__string(out, field);
          if ((col + 1 | 0) < row.length) {
            const padding = (_M0MPC15array5Array2atGiE(widths, col) - field.length | 0) + 2 | 0;
            _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter12repeat__char(32, padding));
          }
          _tmp$40 = col + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15builtin__column(self, args) {
  let table_mode = false;
  let separator = undefined;
  const files = [];
  let i = 0;
  while (true) {
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      if (arg === "-t") {
        table_mode = true;
        i = i + 1 | 0;
        continue;
      }
      if (arg === "-s" && (i + 1 | 0) < args.length) {
        separator = _M0MPC15array5Array2atGUssEE(args, i + 1 | 0);
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15builtin__columnN7_2abindS6490, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15builtin__columnN7_2abindS6490.length)) && arg.length > 2) {
        separator = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined));
        i = i + 1 | 0;
        continue;
      }
      let _tmp$38;
      if (arg.length > 1) {
        $bound_check(arg, 0);
        const _p$4 = arg.charCodeAt(0);
        const _p$5 = 45;
        _tmp$38 = _p$4 === _p$5;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        let _tmp$39 = 1;
        _L: while (true) {
          const j = _tmp$39;
          if (j < arg.length) {
            $bound_check(arg, j);
            const flag = arg.charCodeAt(j);
            switch (flag) {
              case 116: {
                table_mode = true;
                break;
              }
              case 115: {
                if ((j + 1 | 0) < arg.length) {
                  separator = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, j + 1 | 0, undefined));
                } else {
                  if ((i + 1 | 0) < args.length) {
                    i = i + 1 | 0;
                    separator = _M0MPC15array5Array2atGUssEE(args, i);
                  }
                }
                break _L;
              }
            }
            _tmp$39 = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        i = i + 1 | 0;
        continue;
      }
      _M0MPC15array5Array4pushGUssEE(files, arg);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const inputs = [];
  if (files.length === 0) {
    _M0MPC15array5Array4pushGUssEE(inputs, self.stdin_buf);
  } else {
    const _bind$4 = files.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$4) {
        const path = files[_];
        let resolved;
        let _try_err;
        _L: {
          _L$2: {
            const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, path);
            if (_bind$5.$tag === 1) {
              const _ok = _bind$5;
              resolved = _ok._0;
            } else {
              const _err = _bind$5;
              _try_err = _err._0;
              break _L$2;
            }
            break _L;
          }
          resolved = path;
        }
        let content;
        let _try_err$2;
        _L$2: {
          _L$3: {
            const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(self.fs, resolved);
            if (_bind$5.$tag === 1) {
              const _ok = _bind$5;
              content = _ok._0;
            } else {
              const _err = _bind$5;
              _try_err$2 = _err._0;
              break _L$3;
            }
            break _L$2;
          }
          const _FsError = _try_err$2;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `column: ${_msg}\n`);
          self.exit_code = 1;
          return undefined;
        }
        _M0MPC15array5Array4pushGUssEE(inputs, content);
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  const _bind$4 = inputs.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const input = inputs[_];
      if (table_mode) {
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0FP410Haoxincode8moonbash3lib11interpreter21format__column__table(input, separator));
      } else {
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, input);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter26is__lookup__shell__keyword(name) {
  switch (name) {
    case "!": {
      return true;
    }
    case "[[": {
      return true;
    }
    case "]]": {
      return true;
    }
    case "case": {
      return true;
    }
    case "do": {
      return true;
    }
    case "done": {
      return true;
    }
    case "elif": {
      return true;
    }
    case "else": {
      return true;
    }
    case "esac": {
      return true;
    }
    case "fi": {
      return true;
    }
    case "for": {
      return true;
    }
    case "function": {
      return true;
    }
    case "if": {
      return true;
    }
    case "in": {
      return true;
    }
    case "then": {
      return true;
    }
    case "time": {
      return true;
    }
    case "until": {
      return true;
    }
    case "while": {
      return true;
    }
    case "{": {
      return true;
    }
    case "}": {
      return true;
    }
    default: {
      return false;
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20lookup__alias__value(self, name) {
  return _M0MPB3Map3getGssE(self.env, `${_M0FP410Haoxincode8moonbash3lib11interpreter22command__alias__prefix}${name}`);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter24compgen__glob__match__at(value, vi, pattern, pi) {
  let _tmp$38 = vi;
  let _tmp$39 = pi;
  while (true) {
    const vi$2 = _tmp$38;
    const pi$2 = _tmp$39;
    if (pi$2 >= pattern.length) {
      return vi$2 >= value.length;
    }
    $bound_check(pattern, pi$2);
    const pch = pattern.charCodeAt(pi$2);
    if (pch === 42) {
      let _tmp$40 = vi$2;
      while (true) {
        const idx = _tmp$40;
        if (idx <= value.length) {
          if (_M0FP410Haoxincode8moonbash3lib11interpreter24compgen__glob__match__at(value, idx, pattern, pi$2 + 1 | 0)) {
            return true;
          }
          _tmp$40 = idx + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return false;
    }
    if (vi$2 >= value.length) {
      return false;
    }
    if (pch === 63) {
      _tmp$38 = vi$2 + 1 | 0;
      _tmp$39 = pi$2 + 1 | 0;
      continue;
    }
    $bound_check(value, vi$2);
    const vch = value.charCodeAt(vi$2);
    if (pch === vch) {
      _tmp$38 = vi$2 + 1 | 0;
      _tmp$39 = pi$2 + 1 | 0;
      continue;
    }
    return false;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter20compgen__glob__match(value, pattern) {
  return _M0FP410Haoxincode8moonbash3lib11interpreter24compgen__glob__match__at(value, 0, pattern, 0);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter31compgen__match__filter__pattern(value, pattern) {
  let extglob_idx = -1;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if ((i + 1 | 0) < pattern.length) {
      let _tmp$39;
      $bound_check(pattern, i);
      if (pattern.charCodeAt(i) === 64) {
        const _tmp$40 = i + 1 | 0;
        $bound_check(pattern, _tmp$40);
        _tmp$39 = pattern.charCodeAt(_tmp$40) === 40;
      } else {
        _tmp$39 = false;
      }
      if (_tmp$39) {
        extglob_idx = i;
        break;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (extglob_idx < 0) {
    return _M0FP410Haoxincode8moonbash3lib11interpreter20compgen__glob__match(value, pattern);
  }
  let close_idx = -1;
  let _tmp$39 = extglob_idx + 2 | 0;
  while (true) {
    const i = _tmp$39;
    if (i < pattern.length) {
      $bound_check(pattern, i);
      if (pattern.charCodeAt(i) === 41) {
        close_idx = i;
        break;
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (close_idx < 0) {
    return _M0FP410Haoxincode8moonbash3lib11interpreter20compgen__glob__match(value, pattern);
  }
  const prefix = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(pattern, 0, extglob_idx));
  const body = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(pattern, extglob_idx + 2 | 0, close_idx));
  const suffix = (close_idx + 1 | 0) < pattern.length ? _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(pattern, close_idx + 1 | 0, undefined)) : "";
  const options = _M0FP410Haoxincode8moonbash3lib11interpreter28split__string__by__delimiter(body, "|");
  const _bind$4 = options.length;
  let _tmp$40 = 0;
  while (true) {
    const _ = _tmp$40;
    if (_ < _bind$4) {
      const option = options[_];
      if (_M0FP410Haoxincode8moonbash3lib11interpreter20compgen__glob__match(value, `${prefix}${option}${suffix}`)) {
        return true;
      }
      _tmp$40 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter36compgen__should__keep__after__filter(value, pattern) {
  if (pattern.length === 0) {
    return true;
  }
  $bound_check(pattern, 0);
  if (pattern.charCodeAt(0) === 33) {
    const inner = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(pattern, 1, undefined));
    return _M0FP410Haoxincode8moonbash3lib11interpreter31compgen__match__filter__pattern(value, inner);
  }
  return !_M0FP410Haoxincode8moonbash3lib11interpreter31compgen__match__filter__pattern(value, pattern);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(values, seen, value) {
  if (value.length === 0) {
    return undefined;
  }
  if (_M0MPB3Map8containsGsbE(seen, value)) {
    return undefined;
  }
  _M0MPB3Map3setGsbE(seen, value, true);
  _M0MPC15array5Array4pushGUssEE(values, value);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter29completion__is__valid__action(name) {
  switch (name) {
    case "alias": {
      return true;
    }
    case "builtin": {
      return true;
    }
    case "command": {
      return true;
    }
    case "directory": {
      return true;
    }
    case "export": {
      return true;
    }
    case "file": {
      return true;
    }
    case "function": {
      return true;
    }
    case "helptopic": {
      return true;
    }
    case "keyword": {
      return true;
    }
    case "shopt": {
      return true;
    }
    case "user": {
      return true;
    }
    case "variable": {
      return true;
    }
    default: {
      return false;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter30completion__is__valid__compopt(name) {
  switch (name) {
    case "default": {
      return true;
    }
    case "dirnames": {
      return true;
    }
    case "filenames": {
      return true;
    }
    case "nospace": {
      return true;
    }
    case "plusdirs": {
      return true;
    }
    default: {
      return false;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter27completion__matches__prefix(value, prefix) {
  return prefix.length === 0 ? true : _M0MPC16string6String11has__prefix(value, new _M0TPC16string10StringView(prefix, 0, prefix.length));
}
function _M0FP410Haoxincode8moonbash3lib11interpreter25completion__sort__strings(values) {
  _M0MPC15array5Array8sort__byGUssEE(values, (a, b) => _M0FP410Haoxincode8moonbash3lib11interpreter13compare__text(a, b));
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29collect__alias__names__sorted(self) {
  const names = [];
  const _it = _M0MPB3Map5iter2GssE(self.env);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _key = _x._0;
      if (_M0MPC16string6String11has__prefix(_key, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib11interpreter25completion__alias__prefix, 0, _M0FP410Haoxincode8moonbash3lib11interpreter25completion__alias__prefix.length))) {
        _M0MPC15array5Array4pushGUssEE(names, _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(_key, _M0FP410Haoxincode8moonbash3lib11interpreter25completion__alias__prefix.length, undefined)));
      }
      continue;
    }
  }
  _M0FP410Haoxincode8moonbash3lib11interpreter25completion__sort__strings(names);
  return names;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31collect__builtin__names__sorted(self) {
  const names = [":", ".", "[", "alias", "break", "builtin", "cd", "command", "compgen", "complete", "compopt", "continue", "declare", "dirs", "echo", "eval", "exec", "exit", "export", "false", "getopts", "hash", "help", "history", "let", "local", "mapfile", "popd", "printf", "pushd", "pwd", "read", "readarray", "readonly", "return", "set", "shift", "shopt", "source", "test", "true", "type", "typeset", "unalias", "unset"];
  _M0FP410Haoxincode8moonbash3lib11interpreter25completion__sort__strings(names);
  return names;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32collect__function__names__sorted(self) {
  const names = [];
  const _it = _M0MPB3Map5iter2GssE(self.functions);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _name = _x._0;
      if (_M0FP410Haoxincode8moonbash3lib11interpreter22is__valid__shell__name(_name)) {
        _M0MPC15array5Array4pushGUssEE(names, _name);
      }
      continue;
    }
  }
  _M0FP410Haoxincode8moonbash3lib11interpreter25completion__sort__strings(names);
  return names;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31collect__keyword__names__sorted(self) {
  const names = ["!", "[[", "]]", "case", "do", "done", "elif", "else", "esac", "fi", "for", "function", "if", "in", "then", "time", "until", "while"];
  _M0FP410Haoxincode8moonbash3lib11interpreter25completion__sort__strings(names);
  return names;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext36collect__command__action__candidates(self) {
  const out = [];
  const _bind$4 = [];
  const seen = _M0MPB3Map3MapGsbE(new _M0TPB9ArrayViewGUsbEE(_bind$4, 0, 0), undefined);
  const aliases = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29collect__alias__names__sorted(self);
  const _bind$5 = aliases.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const name = aliases[_];
      _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(out, seen, name);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const functions = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32collect__function__names__sorted(self);
  const _bind$6 = functions.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$6) {
      const name = functions[_];
      _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(out, seen, name);
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const builtins = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31collect__builtin__names__sorted(self);
  const _bind$7 = builtins.length;
  let _tmp$40 = 0;
  while (true) {
    const _ = _tmp$40;
    if (_ < _bind$7) {
      const name = builtins[_];
      _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(out, seen, name);
      _tmp$40 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const keywords = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31collect__keyword__names__sorted(self);
  const _bind$8 = keywords.length;
  let _tmp$41 = 0;
  while (true) {
    const _ = _tmp$41;
    if (_ < _bind$8) {
      const name = keywords[_];
      _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(out, seen, name);
      _tmp$41 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const registry = ["__moon_bash_custom__", "awk", "base64", "cat", "cd", "chmod", "cmp", "comm", "cp", "csvlook", "curl", "diff", "du", "echo", "expr", "false", "file", "find", "gunzip", "gzip", "head", "html-to-markdown", "jq", "ln", "ls", "md5sum", "mkdir", "mv", "pwd", "python3", "readlink", "rm", "rmdir", "sha1sum", "sha256sum", "split", "sqlite3", "stat", "strings", "tail", "tar", "touch", "tree", "true", "wc", "xargs", "xan", "yq", "zcat"];
  const sorted_registry = [];
  const _bind$9 = registry.length;
  let _tmp$42 = 0;
  while (true) {
    const _ = _tmp$42;
    if (_ < _bind$9) {
      const name = registry[_];
      _M0MPC15array5Array4pushGUssEE(sorted_registry, name);
      _tmp$42 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0FP410Haoxincode8moonbash3lib11interpreter25completion__sort__strings(sorted_registry);
  const _bind$10 = sorted_registry.length;
  let _tmp$43 = 0;
  while (true) {
    const _ = _tmp$43;
    if (_ < _bind$10) {
      const name = sorted_registry[_];
      _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(out, seen, name);
      _tmp$43 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext26collect__compreply__values(self) {
  const values = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22collect__array__values(self, "COMPREPLY");
  if (values.length > 0) {
    return values;
  }
  const _bind$4 = _M0MPB3Map3getGssE(self.env, "COMPREPLY");
  if (_bind$4 === undefined) {
    return [];
  } else {
    const _Some = _bind$4;
    const _value = _Some;
    return _value.length === 0 ? [] : [_value];
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32collect__exported__names__sorted(self) {
  const names = [];
  const _it = _M0MPB3Map5iter2GsbE(self.exported);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGsbE(_it);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _name = _x._0;
      const _exported = _x._1;
      if (_exported && _M0FP410Haoxincode8moonbash3lib11interpreter22is__valid__shell__name(_name)) {
        _M0MPC15array5Array4pushGUssEE(names, _name);
      }
      continue;
    }
  }
  _M0FP410Haoxincode8moonbash3lib11interpreter25completion__sort__strings(names);
  return names;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33collect__helptopic__names__sorted(self) {
  const topics = [];
  const _bind$4 = [];
  const seen = _M0MPB3Map3MapGsbE(new _M0TPB9ArrayViewGUsbEE(_bind$4, 0, 0), undefined);
  const _bind$5 = [":", ".", "[", "[[", "alias", "basename", "bash", "break", "builtin", "cd", "clear", "column", "command", "compgen", "complete", "compopt", "continue", "cut", "date", "declare", "dirname", "dirs", "echo", "egrep", "env", "eval", "exec", "exit", "expand", "export", "false", "fgrep", "fold", "getopts", "grep", "hash", "help", "history", "hostname", "join", "let", "local", "mapfile", "nl", "od", "paste", "popd", "printenv", "printf", "pushd", "pwd", "read", "readarray", "readonly", "return", "rev", "rg", "sed", "seq", "set", "sh", "shift", "shopt", "sleep", "sort", "source", "tac", "tee", "test", "time", "timeout", "tr", "true", "type", "typeset", "unalias", "unexpand", "uniq", "unset", "which", "whoami", "xargs"];
  const _bind$6 = _bind$5.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$6) {
      const name = _bind$5[_];
      _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(topics, seen, name);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$7 = ["!", "[[", "]]", "case", "do", "done", "elif", "else", "esac", "fi", "for", "function", "if", "in", "then", "time", "until", "while"];
  const _bind$8 = _bind$7.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$8) {
      const name = _bind$7[_];
      _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(topics, seen, name);
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$9 = ["__moon_bash_custom__", "awk", "base64", "cat", "cd", "chmod", "cmp", "comm", "cp", "csvlook", "curl", "diff", "du", "echo", "expr", "false", "file", "find", "gunzip", "gzip", "head", "html-to-markdown", "jq", "ln", "ls", "md5sum", "mkdir", "mv", "pwd", "python3", "readlink", "rm", "rmdir", "sha1sum", "sha256sum", "split", "sqlite3", "stat", "strings", "tail", "tar", "touch", "tree", "true", "wc", "xargs", "xan", "yq", "zcat"];
  const _bind$10 = _bind$9.length;
  let _tmp$40 = 0;
  while (true) {
    const _ = _tmp$40;
    if (_ < _bind$10) {
      const name = _bind$9[_];
      _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(topics, seen, name);
      _tmp$40 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0FP410Haoxincode8moonbash3lib11interpreter25completion__sort__strings(topics);
  return topics;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter23completion__last__slash(text) {
  let idx = -1;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < text.length) {
      $bound_check(text, i);
      if (text.charCodeAt(i) === 47) {
        idx = i;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return idx;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext37collect__path__completion__candidates(self, query, directories_only) {
  let dir_part = "";
  let name_prefix = query;
  let output_prefix = "";
  const slash_idx = _M0FP410Haoxincode8moonbash3lib11interpreter23completion__last__slash(query);
  if (slash_idx >= 0) {
    dir_part = slash_idx === 0 ? "/" : _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(query, 0, slash_idx));
    name_prefix = (slash_idx + 1 | 0) < query.length ? _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(query, slash_idx + 1 | 0, undefined)) : "";
    output_prefix = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(query, 0, slash_idx + 1 | 0));
  }
  let base_dir;
  if (dir_part.length === 0) {
    base_dir = self.cwd;
  } else {
    let _try_err;
    _L: {
      _L$2: {
        const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, dir_part);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          base_dir = _ok._0;
        } else {
          const _err = _bind$4;
          _try_err = _err._0;
          break _L$2;
        }
        break _L;
      }
      return { _0: [], _1: false };
    }
  }
  _L: {
    _L$2: {
      const _bind$4 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.fs.entries, base_dir);
      if (_bind$4 === undefined) {
        break _L$2;
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        if (_x.$tag === 1) {
        } else {
          break _L$2;
        }
      }
      break _L;
    }
    return { _0: [], _1: false };
  }
  const out = [];
  const _it = _M0MPB3Map5iter2GssE(self.fs.entries);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _path = _x._0;
      const _entry = _x._1;
      const _p$4 = _M0FP410Haoxincode8moonbash3lib2fs12parent__path(_path);
      if (!(_p$4 === base_dir)) {
        continue;
      }
      const name = _M0FP410Haoxincode8moonbash3lib2fs8basename(_path);
      const _bind$5 = name_prefix;
      if (!_M0MPC16string6String11has__prefix(name, new _M0TPC16string10StringView(_bind$5, 0, _bind$5.length))) {
        continue;
      }
      if (_entry.$tag === 1) {
        _M0MPC15array5Array4pushGUssEE(out, `${output_prefix}${name}`);
      } else {
        if (!directories_only) {
          _M0MPC15array5Array4pushGUssEE(out, `${output_prefix}${name}`);
        }
      }
      continue;
    }
  }
  _M0FP410Haoxincode8moonbash3lib11interpreter25completion__sort__strings(out);
  return { _0: out, _1: true };
}
function _M0FP410Haoxincode8moonbash3lib11interpreter32completion__variable__base__name(name) {
  let bracket = -1;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < name.length) {
      $bound_check(name, i);
      if (name.charCodeAt(i) === 91) {
        bracket = i;
        break;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return bracket > 0 ? _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(name, 0, bracket)) : name;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32collect__variable__names__sorted(self) {
  const names = [];
  const _bind$4 = [];
  const seen = _M0MPB3Map3MapGsbE(new _M0TPB9ArrayViewGUsbEE(_bind$4, 0, 0), undefined);
  const _it = _M0MPB3Map5iter2GssE(self.env);
  while (true) {
    const _bind$5 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$5 === undefined) {
      break;
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      const _key = _x._0;
      if (_M0MPC16string6String11has__prefix(_key, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32collect__variable__names__sortedN7_2abindS6657, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32collect__variable__names__sortedN7_2abindS6657.length))) {
        continue;
      }
      const base = _M0FP410Haoxincode8moonbash3lib11interpreter32completion__variable__base__name(_key);
      if (!_M0FP410Haoxincode8moonbash3lib11interpreter22is__valid__shell__name(base)) {
        continue;
      }
      if (_M0MPB3Map8containsGsbE(seen, base)) {
        continue;
      }
      _M0MPB3Map3setGsbE(seen, base, true);
      _M0MPC15array5Array4pushGUssEE(names, base);
      continue;
    }
  }
  _M0FP410Haoxincode8moonbash3lib11interpreter25completion__sort__strings(names);
  return names;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter26completion__is__ifs__delim(ch, ifs) {
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < ifs.length) {
      $bound_check(ifs, i);
      if (ifs.charCodeAt(i) === ch) {
        return true;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter30compgen__split__words__by__ifs(raw, ifs, allow_escape) {
  if (raw.length === 0) {
    return [];
  }
  if (ifs.length === 0) {
    return [raw];
  }
  const out = [];
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  let escaping = false;
  while (true) {
    if (i < raw.length) {
      const _tmp$38 = i;
      $bound_check(raw, _tmp$38);
      const ch = raw.charCodeAt(_tmp$38);
      if (allow_escape && escaping) {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
        escaping = false;
        i = i + 1 | 0;
        continue;
      }
      if (allow_escape && (ch === 92 && (i + 1 | 0) < raw.length)) {
        const _tmp$39 = i + 1 | 0;
        $bound_check(raw, _tmp$39);
        const next = raw.charCodeAt(_tmp$39);
        if (_M0FP410Haoxincode8moonbash3lib11interpreter26completion__is__ifs__delim(next, ifs) || next === 92) {
          escaping = true;
          i = i + 1 | 0;
          continue;
        }
      }
      if (_M0FP410Haoxincode8moonbash3lib11interpreter26completion__is__ifs__delim(ch, ifs)) {
        const token = buf.val;
        if (token.length > 0) {
          _M0MPC15array5Array4pushGUssEE(out, token);
        }
        _M0MPB13StringBuilder5reset(buf);
        i = i + 1 | 0;
        continue;
      }
      _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (escaping) {
    _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
  }
  const tail = buf.val;
  if (tail.length > 0) {
    _M0MPC15array5Array4pushGUssEE(out, tail);
  }
  return out;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter19contains__substring(haystack, needle) {
  if (needle.length === 0) {
    return true;
  }
  if (needle.length > haystack.length) {
    return false;
  }
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i <= (haystack.length - needle.length | 0)) {
      let found = true;
      let _tmp$39 = 0;
      while (true) {
        const j = _tmp$39;
        if (j < needle.length) {
          const _tmp$40 = i + j | 0;
          $bound_check(haystack, _tmp$40);
          const _p$4 = haystack.charCodeAt(_tmp$40);
          $bound_check(needle, j);
          const _p$5 = needle.charCodeAt(j);
          if (_p$4 !== _p$5) {
            found = false;
            break;
          }
          _tmp$39 = j + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      if (found) {
        return true;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter34completion__has__unbalanced__param(raw) {
  if (!_M0FP410Haoxincode8moonbash3lib11interpreter19contains__substring(raw, "${")) {
    return false;
  }
  return !_M0FP410Haoxincode8moonbash3lib11interpreter19contains__substring(raw, "}");
}
function _M0FP410Haoxincode8moonbash3lib11interpreter23trim__ascii__whitespace(raw) {
  let start = 0;
  let end_ = raw.length;
  while (true) {
    if (start < end_) {
      const _tmp$38 = start;
      $bound_check(raw, _tmp$38);
      const ch = raw.charCodeAt(_tmp$38);
      if (ch === 32 || (ch === 9 || (ch === 10 || ch === 13))) {
        start = start + 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (end_ > start) {
      const _tmp$38 = end_ - 1 | 0;
      $bound_check(raw, _tmp$38);
      const ch = raw.charCodeAt(_tmp$38);
      if (ch === 32 || (ch === 9 || (ch === 10 || ch === 13))) {
        end_ = end_ - 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  return _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(raw, start, end_));
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext28clear__named__array__storage(self, name) {
  const count_key = `__MOON_BASH_ARRAY_COUNT__${name}`;
  const index_prefix = `${name}[`;
  const to_remove = [];
  const _it = _M0MPB3Map5iter2GssE(self.env);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _key = _x._0;
      if (_key === name || (_key === count_key || (_key === `${name}[@]` || (_key === `${name}[*]` || _M0FP410Haoxincode8moonbash3lib11interpreter19string__has__prefix(_key, index_prefix))))) {
        _M0MPC15array5Array4pushGUssEE(to_remove, _key);
      }
      continue;
    }
  }
  const _bind$4 = to_remove.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const key = to_remove[_];
      _M0MPB3Map6removeGssE(self.env, key);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter23completion__join__words(words) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < words.length) {
      if (i > 0) {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, 32);
      }
      _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0MPC15array5Array2atGUssEE(words, i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter34complete__storage__name__from__key(key) {
  return _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(key, _M0FP410Haoxincode8moonbash3lib11interpreter25complete__storage__prefix.length, undefined));
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext26collect__completion__names(self) {
  const names = [];
  const _it = _M0MPB3Map5iter2GssE(self.env);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _key = _x._0;
      if (_M0MPC16string6String11has__prefix(_key, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib11interpreter25complete__storage__prefix, 0, _M0FP410Haoxincode8moonbash3lib11interpreter25complete__storage__prefix.length))) {
        _M0MPC15array5Array4pushGUssEE(names, _M0FP410Haoxincode8moonbash3lib11interpreter34complete__storage__name__from__key(_key));
      }
      continue;
    }
  }
  _M0FP410Haoxincode8moonbash3lib11interpreter25completion__sort__strings(names);
  return names;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24print__completion__specs(self, names) {
  if (names.length === 0) {
    const all_names = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext26collect__completion__names(self);
    const _bind$4 = all_names.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$4) {
        const name = all_names[_];
        const _bind$5 = _M0MPB3Map3getGssE(self.env, `${_M0FP410Haoxincode8moonbash3lib11interpreter25complete__storage__prefix}${name}`);
        if (_bind$5 === undefined) {
        } else {
          const _Some = _bind$5;
          const _spec = _Some;
          _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_spec}\n`);
        }
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return undefined;
  }
  const _bind$4 = names.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const name = names[_];
      const _bind$5 = _M0MPB3Map3getGssE(self.env, `${_M0FP410Haoxincode8moonbash3lib11interpreter25complete__storage__prefix}${name}`);
      if (_bind$5 === undefined) {
      } else {
        const _Some = _bind$5;
        const _spec = _Some;
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_spec}\n`);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17builtin__complete(self, args) {
  let print_mode = false;
  let words = undefined;
  let func_name = undefined;
  let command_name = undefined;
  const complete_opts = [];
  const names = [];
  let i = 0;
  let parse_opts = true;
  while (true) {
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      if (parse_opts && arg === "--") {
        parse_opts = false;
        i = i + 1 | 0;
        continue;
      }
      if (parse_opts && arg === "-p") {
        print_mode = true;
        i = i + 1 | 0;
        continue;
      }
      if (parse_opts && arg === "-F") {
        if ((i + 1 | 0) >= args.length) {
          self.exit_code = 2;
          return undefined;
        }
        func_name = _M0MPC15array5Array2atGUssEE(args, i + 1 | 0);
        i = i + 2 | 0;
        continue;
      }
      if (parse_opts && arg === "-W") {
        if ((i + 1 | 0) >= args.length) {
          self.exit_code = 2;
          return undefined;
        }
        words = _M0MPC15array5Array2atGUssEE(args, i + 1 | 0);
        i = i + 2 | 0;
        continue;
      }
      if (parse_opts && arg === "-C") {
        if ((i + 1 | 0) >= args.length) {
          self.exit_code = 2;
          return undefined;
        }
        command_name = _M0MPC15array5Array2atGUssEE(args, i + 1 | 0);
        i = i + 2 | 0;
        continue;
      }
      if (parse_opts && arg === "-o") {
        if ((i + 1 | 0) >= args.length) {
          self.exit_code = 2;
          return undefined;
        }
        _M0MPC15array5Array4pushGUssEE(complete_opts, _M0MPC15array5Array2atGUssEE(args, i + 1 | 0));
        i = i + 2 | 0;
        continue;
      }
      let _tmp$38;
      if (parse_opts) {
        let _tmp$39;
        if (arg.length > 0) {
          $bound_check(arg, 0);
          _tmp$39 = arg.charCodeAt(0) === 45;
        } else {
          _tmp$39 = false;
        }
        _tmp$38 = _tmp$39;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        self.exit_code = 2;
        return undefined;
      }
      _M0MPC15array5Array4pushGUssEE(names, arg);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (print_mode) {
    const _bind$4 = words;
    if (_bind$4 === undefined) {
      const _bind$5 = func_name;
      if (_bind$5 === undefined) {
        const _bind$6 = command_name;
        if (_bind$6 === undefined) {
          if (names.length === 0) {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24print__completion__specs(self, []);
            self.exit_code = 0;
            return undefined;
          }
        }
      }
    }
  }
  const _bind$4 = words;
  if (_bind$4 === undefined) {
    const _bind$5 = func_name;
    if (_bind$5 === undefined) {
      const _bind$6 = command_name;
      if (_bind$6 === undefined) {
        if (print_mode) {
          _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24print__completion__specs(self, names);
          self.exit_code = 0;
          return undefined;
        }
        if (names.length === 0) {
          _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24print__completion__specs(self, []);
          self.exit_code = 0;
          return undefined;
        }
        self.exit_code = 2;
        return undefined;
      }
    }
  }
  if (names.length === 0) {
    self.exit_code = 2;
    return undefined;
  }
  const _bind$5 = words;
  if (_bind$5 === undefined) {
  } else {
    const _Some = _bind$5;
    const _raw = _Some;
    if (_M0FP410Haoxincode8moonbash3lib11interpreter34completion__has__unbalanced__param(_raw)) {
      self.exit_code = 2;
      return undefined;
    }
  }
  const _bind$6 = func_name;
  if (_bind$6 === undefined) {
  } else {
    const _Some = _bind$6;
    const _name = _Some;
    if (!_M0MPB3Map8containsGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self.functions, _name)) {
      const _bind$7 = names.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$7) {
          const target = names[_];
          if (target === "-D") {
            self.exit_code = 2;
            return undefined;
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
    }
  }
  const spec_tokens = ["complete"];
  const _bind$7 = complete_opts.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$7) {
      const opt = complete_opts[_];
      _M0MPC15array5Array4pushGUssEE(spec_tokens, "-o");
      _M0MPC15array5Array4pushGUssEE(spec_tokens, opt);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$8 = words;
  if (_bind$8 === undefined) {
  } else {
    const _Some = _bind$8;
    const _raw = _Some;
    _M0MPC15array5Array4pushGUssEE(spec_tokens, "-W");
    _M0MPC15array5Array4pushGUssEE(spec_tokens, `'${_raw}'`);
  }
  const _bind$9 = func_name;
  if (_bind$9 === undefined) {
  } else {
    const _Some = _bind$9;
    const _name = _Some;
    _M0MPC15array5Array4pushGUssEE(spec_tokens, "-F");
    _M0MPC15array5Array4pushGUssEE(spec_tokens, _name);
  }
  const _bind$10 = command_name;
  if (_bind$10 === undefined) {
  } else {
    const _Some = _bind$10;
    const _name = _Some;
    _M0MPC15array5Array4pushGUssEE(spec_tokens, "-C");
    _M0MPC15array5Array4pushGUssEE(spec_tokens, _name);
  }
  const spec_head = _M0FP410Haoxincode8moonbash3lib11interpreter23completion__join__words(spec_tokens);
  const _bind$11 = names.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$11) {
      const name = names[_];
      _M0MPB3Map3setGssE(self.env, `${_M0FP410Haoxincode8moonbash3lib11interpreter25complete__storage__prefix}${name}`, `${spec_head} ${name}`);
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__compopt(self, args) {
  let has_action = false;
  let i = 0;
  while (true) {
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      if (arg === "--") {
        break;
      }
      if (arg === "-o" || arg === "+o") {
        if ((i + 1 | 0) >= args.length || !_M0FP410Haoxincode8moonbash3lib11interpreter30completion__is__valid__compopt(_M0MPC15array5Array2atGUssEE(args, i + 1 | 0))) {
          self.exit_code = 2;
          return undefined;
        }
        has_action = true;
        i = i + 2 | 0;
        continue;
      }
      if (arg.length > 0) {
        $bound_check(arg, 0);
        const first = arg.charCodeAt(0);
        if (first === 45 || first === 43) {
          self.exit_code = 2;
          return undefined;
        }
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (!has_action) {
    self.exit_code = 2;
    return undefined;
  }
  const _p$4 = _M0MPB3Map3getGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter26compgen__in__function__key);
  const _p$5 = "";
  let _p$6;
  if (_p$4 === undefined) {
    _p$6 = _p$5;
  } else {
    const _p$7 = _p$4;
    _p$6 = _p$7;
  }
  const _p$7 = "1";
  if (!(_p$6 === _p$7)) {
    self.exit_code = 1;
    return undefined;
  }
  self.exit_code = 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17builtin__continue(self, args) {
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32parse__loop__control__count__arg(self, "continue", args);
  let n;
  if (_bind$4 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$4;
    n = _Some;
  }
  if (self.loop_depth <= 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "moon_bash: continue: only meaningful in a `for', `while', or `until' loop\n");
    self.exit_code = 1;
    return undefined;
  }
  self.continue_count = n;
  self.exit_code = 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter21cut__by__char__ranges(line, ranges) {
  if (line.length === 0 || ranges.length === 0) {
    return "";
  }
  const selected = [];
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i <= line.length) {
      _M0MPC15array5Array4pushGbE(selected, false);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$4 = ranges.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$4) {
      const range = ranges[_];
      _L: {
        const _raw_start = range._0;
        const _raw_end = range._1;
        const start = _raw_start < 1 ? 1 : _raw_start;
        const end = _raw_end < 0 || _raw_end > line.length ? line.length : _raw_end;
        if (start > line.length || start > end) {
          break _L;
        }
        let _tmp$40 = start;
        while (true) {
          const pos = _tmp$40;
          if (pos <= end) {
            _M0MPC15array5Array3setGbE(selected, pos, true);
            _tmp$40 = pos + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        break _L;
      }
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$40 = 1;
  while (true) {
    const pos = _tmp$40;
    if (pos <= line.length) {
      if (_M0MPC15array5Array2atGbE(selected, pos)) {
        const _tmp$41 = pos - 1 | 0;
        $bound_check(line, _tmp$41);
        _M0IPB13StringBuilderPB6Logger11write__char(out, line.charCodeAt(_tmp$41));
      }
      _tmp$40 = pos + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter22parse__cut__char__spec(spec) {
  const ranges = [];
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter28split__string__by__delimiter(spec, ",");
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const raw = _bind$4[_];
      _L: {
        if (raw.length === 0) {
          break _L;
        }
        let dash = -1;
        let _tmp$39 = 0;
        while (true) {
          const i = _tmp$39;
          if (i < raw.length) {
            $bound_check(raw, i);
            const _p$4 = raw.charCodeAt(i);
            const _p$5 = 45;
            if (_p$4 === _p$5) {
              dash = i;
              break;
            }
            _tmp$39 = i + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        if (dash < 0) {
          const pos = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(raw);
          _M0MPC15array5Array4pushGUssEE(ranges, { _0: pos, _1: pos });
          break _L;
        }
        const left = _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(raw, 0, dash);
        const right = _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(raw, dash + 1 | 0, raw.length);
        const start = left.length === 0 ? 1 : _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(left);
        const end = right.length === 0 ? -1 : _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(right);
        _M0MPC15array5Array4pushGUssEE(ranges, { _0: start, _1: end });
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return ranges;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter18parse__field__spec(spec) {
  const fields = [];
  const parts = _M0FP410Haoxincode8moonbash3lib11interpreter28split__string__by__delimiter(spec, ",");
  const _bind$4 = parts.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const part = parts[_];
      if (_M0FP410Haoxincode8moonbash3lib11interpreter19contains__substring(part, "-")) {
        const range_parts = _M0FP410Haoxincode8moonbash3lib11interpreter28split__string__by__delimiter(part, "-");
        if (range_parts.length === 2) {
          const start = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(range_parts, 0));
          const end = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(range_parts, 1));
          let _tmp$39 = start;
          while (true) {
            const i = _tmp$39;
            if (i <= end) {
              _M0MPC15array5Array4pushGiE(fields, i);
              _tmp$39 = i + 1 | 0;
              continue;
            } else {
              break;
            }
          }
        }
      } else {
        _M0MPC15array5Array4pushGiE(fields, _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(part));
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return fields;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__cut(self, args) {
  let delimiter = "\t";
  let fields = [];
  let char_mode = false;
  let char_ranges = [];
  let input_file = undefined;
  let i = 0;
  while (true) {
    if (i < args.length) {
      if (_M0MPC15array5Array2atGUssEE(args, i) === "-d" && (i + 1 | 0) < args.length) {
        delimiter = _M0MPC15array5Array2atGUssEE(args, i + 1 | 0);
        i = i + 2 | 0;
      } else {
        if (_M0MPC15array5Array2atGUssEE(args, i) === "-f" && (i + 1 | 0) < args.length) {
          fields = _M0FP410Haoxincode8moonbash3lib11interpreter18parse__field__spec(_M0MPC15array5Array2atGUssEE(args, i + 1 | 0));
          i = i + 2 | 0;
        } else {
          if (_M0MPC15array5Array2atGUssEE(args, i) === "-c" && (i + 1 | 0) < args.length) {
            char_mode = true;
            char_ranges = _M0FP410Haoxincode8moonbash3lib11interpreter22parse__cut__char__spec(_M0MPC15array5Array2atGUssEE(args, i + 1 | 0));
            i = i + 2 | 0;
          } else {
            if (_M0MPC16string6String11has__prefix(_M0MPC15array5Array2atGUssEE(args, i), new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__cutN7_2abindS6830, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__cutN7_2abindS6830.length))) {
              delimiter = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(_M0MPC15array5Array2atGUssEE(args, i), 2, undefined));
              i = i + 1 | 0;
            } else {
              if (_M0MPC16string6String11has__prefix(_M0MPC15array5Array2atGUssEE(args, i), new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__cutN7_2abindS6831, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__cutN7_2abindS6831.length))) {
                fields = _M0FP410Haoxincode8moonbash3lib11interpreter18parse__field__spec(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(_M0MPC15array5Array2atGUssEE(args, i), 2, undefined)));
                i = i + 1 | 0;
              } else {
                if (_M0MPC16string6String11has__prefix(_M0MPC15array5Array2atGUssEE(args, i), new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__cutN7_2abindS6832, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__cutN7_2abindS6832.length))) {
                  char_mode = true;
                  char_ranges = _M0FP410Haoxincode8moonbash3lib11interpreter22parse__cut__char__spec(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(_M0MPC15array5Array2atGUssEE(args, i), 2, undefined)));
                  i = i + 1 | 0;
                } else {
                  input_file = _M0MPC15array5Array2atGUssEE(args, i);
                  i = i + 1 | 0;
                }
              }
            }
          }
        }
      }
      continue;
    } else {
      break;
    }
  }
  const _bind$4 = input_file;
  let input;
  if (_bind$4 === undefined) {
    input = self.stdin_buf;
  } else {
    const _Some = _bind$4;
    const _path = _Some;
    let resolved;
    let _try_err;
    _L: {
      _L$2: {
        const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, _path);
        if (_bind$5.$tag === 1) {
          const _ok = _bind$5;
          resolved = _ok._0;
        } else {
          const _err = _bind$5;
          _try_err = _err._0;
          break _L$2;
        }
        break _L;
      }
      resolved = _path;
    }
    let _try_err$2;
    _L$2: {
      _L$3: {
        const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(self.fs, resolved);
        if (_bind$5.$tag === 1) {
          const _ok = _bind$5;
          input = _ok._0;
        } else {
          const _err = _bind$5;
          _try_err$2 = _err._0;
          break _L$3;
        }
        break _L$2;
      }
      const _FsError = _try_err$2;
      const _msg = _FsError._0;
      _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `cut: ${_msg}\n`);
      self.exit_code = 1;
      return undefined;
    }
  }
  const lines = _M0FP410Haoxincode8moonbash3lib11interpreter26split__lines__no__trailing(input);
  const _bind$5 = lines.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const line = lines[_];
      if (char_mode) {
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_M0FP410Haoxincode8moonbash3lib11interpreter21cut__by__char__ranges(line, char_ranges)}\n`);
      } else {
        const parts = _M0FP410Haoxincode8moonbash3lib11interpreter28split__string__by__delimiter(line, delimiter);
        const out_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
        let first = true;
        const _bind$6 = fields;
        const _bind$7 = _bind$6.length;
        let _tmp$39 = 0;
        while (true) {
          const _$2 = _tmp$39;
          if (_$2 < _bind$7) {
            const field_num = _bind$6[_$2];
            if (field_num > 0 && field_num <= parts.length) {
              if (!first) {
                _M0IPB13StringBuilderPB6Logger13write__string(out_buf, delimiter);
              }
              _M0IPB13StringBuilderPB6Logger13write__string(out_buf, _M0MPC15array5Array2atGUssEE(parts, field_num - 1 | 0));
              first = false;
            }
            _tmp$39 = _$2 + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${out_buf.val}\n`);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter28date__current__datetime__utc() {
  const now_ms = _M0FP410Haoxincode8moonbash3lib3ffi19wall__now__ms__sync();
  if (1000n === 0n) {
    $panic();
  }
  const second = BigInt.asUintN(64, BigInt.asIntN(64, now_ms) / BigInt.asIntN(64, 1000n));
  if (1000n === 0n) {
    $panic();
  }
  const millisecond = Number(BigInt.asIntN(32, BigInt.asUintN(64, BigInt.asIntN(64, now_ms) % BigInt.asIntN(64, 1000n)))) | 0;
  const nanosecond = millisecond < 0 ? 0 : Math.imul(millisecond, 1000000) | 0;
  let _try_err;
  _L: {
    const _bind$4 = _M0FP311moonbitlang1x4time12unix_2einner(second, nanosecond, _M0FP311moonbitlang1x4time9utc__zone);
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      return _ok._0;
    } else {
      const _err = _bind$4;
      _try_err = _err._0;
      break _L;
    }
  }
  let _try_err$2;
  _L$2: {
    const _bind$4 = _M0FP311moonbitlang1x4time12unix_2einner(0n, 0, _M0FP311moonbitlang1x4time9utc__zone);
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      return _ok._0;
    } else {
      const _err = _bind$4;
      _try_err$2 = _err._0;
      break _L$2;
    }
  }
  return _M0FPC15abort5abortGRPB12MutArrayViewGUssEEE("date: failed to build UTC datetime");
}
function _M0FP410Haoxincode8moonbash3lib11interpreter18date__month__short(month) {
  switch (month) {
    case 1: {
      return "Jan";
    }
    case 2: {
      return "Feb";
    }
    case 3: {
      return "Mar";
    }
    case 4: {
      return "Apr";
    }
    case 5: {
      return "May";
    }
    case 6: {
      return "Jun";
    }
    case 7: {
      return "Jul";
    }
    case 8: {
      return "Aug";
    }
    case 9: {
      return "Sep";
    }
    case 10: {
      return "Oct";
    }
    case 11: {
      return "Nov";
    }
    case 12: {
      return "Dec";
    }
    default: {
      return "";
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter10date__pad2(value) {
  return value < 10 ? `0${_M0MPC13int3Int18to__string_2einner(value, 10)}` : _M0MPC13int3Int18to__string_2einner(value, 10);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter17date__pad2__space(value) {
  return value < 10 ? ` ${_M0MPC13int3Int18to__string_2einner(value, 10)}` : _M0MPC13int3Int18to__string_2einner(value, 10);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter20date__weekday__short(weekday) {
  switch (weekday) {
    case 0: {
      return "Mon";
    }
    case 1: {
      return "Tue";
    }
    case 2: {
      return "Wed";
    }
    case 3: {
      return "Thu";
    }
    case 4: {
      return "Fri";
    }
    case 5: {
      return "Sat";
    }
    default: {
      return "Sun";
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter21date__default__output(dt) {
  return `${_M0FP410Haoxincode8moonbash3lib11interpreter20date__weekday__short(_M0MP311moonbitlang1x4time13ZonedDateTime7weekday(dt))} ${_M0FP410Haoxincode8moonbash3lib11interpreter18date__month__short(_M0MP311moonbitlang1x4time13ZonedDateTime5month(dt))} ${_M0FP410Haoxincode8moonbash3lib11interpreter17date__pad2__space(_M0MP311moonbitlang1x4time13ZonedDateTime3day(dt))} ${_M0FP410Haoxincode8moonbash3lib11interpreter10date__pad2(_M0MP311moonbitlang1x4time13ZonedDateTime4hour(dt))}:${_M0FP410Haoxincode8moonbash3lib11interpreter10date__pad2(_M0MP311moonbitlang1x4time13ZonedDateTime6minute(dt))}:${_M0FP410Haoxincode8moonbash3lib11interpreter10date__pad2(_M0MP311moonbitlang1x4time13ZonedDateTime6second(dt))} UTC ${_M0IPC13int3IntPB4Show10to__string(_M0MP311moonbitlang1x4time13ZonedDateTime4year(dt))}`;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter17date__month__long(month) {
  switch (month) {
    case 1: {
      return "January";
    }
    case 2: {
      return "February";
    }
    case 3: {
      return "March";
    }
    case 4: {
      return "April";
    }
    case 5: {
      return "May";
    }
    case 6: {
      return "June";
    }
    case 7: {
      return "July";
    }
    case 8: {
      return "August";
    }
    case 9: {
      return "September";
    }
    case 10: {
      return "October";
    }
    case 11: {
      return "November";
    }
    case 12: {
      return "December";
    }
    default: {
      return "";
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter19date__weekday__long(weekday) {
  switch (weekday) {
    case 0: {
      return "Monday";
    }
    case 1: {
      return "Tuesday";
    }
    case 2: {
      return "Wednesday";
    }
    case 3: {
      return "Thursday";
    }
    case 4: {
      return "Friday";
    }
    case 5: {
      return "Saturday";
    }
    default: {
      return "Sunday";
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter28date__weekday__monday__index(weekday) {
  switch (weekday) {
    case 0: {
      return 1;
    }
    case 1: {
      return 2;
    }
    case 2: {
      return 3;
    }
    case 3: {
      return 4;
    }
    case 4: {
      return 5;
    }
    case 5: {
      return 6;
    }
    default: {
      return 7;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter28date__weekday__sunday__index(weekday) {
  switch (weekday) {
    case 6: {
      return 0;
    }
    case 0: {
      return 1;
    }
    case 1: {
      return 2;
    }
    case 2: {
      return 3;
    }
    case 3: {
      return 4;
    }
    case 4: {
      return 5;
    }
    default: {
      return 6;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter20date__format__output(dt, format) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  while (true) {
    if (i < format.length) {
      const _tmp$38 = i;
      $bound_check(format, _tmp$38);
      const ch = format.charCodeAt(_tmp$38);
      if (ch !== 37 || (i + 1 | 0) >= format.length) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        i = i + 1 | 0;
        continue;
      }
      const _tmp$39 = i + 1 | 0;
      $bound_check(format, _tmp$39);
      const code = format.charCodeAt(_tmp$39);
      switch (code) {
        case 37: {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 37);
          break;
        }
        case 89: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC13int3Int18to__string_2einner(_M0MP311moonbitlang1x4time13ZonedDateTime4year(dt), 10));
          break;
        }
        case 109: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter10date__pad2(_M0MP311moonbitlang1x4time13ZonedDateTime5month(dt)));
          break;
        }
        case 100: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter10date__pad2(_M0MP311moonbitlang1x4time13ZonedDateTime3day(dt)));
          break;
        }
        case 101: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter17date__pad2__space(_M0MP311moonbitlang1x4time13ZonedDateTime3day(dt)));
          break;
        }
        case 72: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter10date__pad2(_M0MP311moonbitlang1x4time13ZonedDateTime4hour(dt)));
          break;
        }
        case 77: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter10date__pad2(_M0MP311moonbitlang1x4time13ZonedDateTime6minute(dt)));
          break;
        }
        case 83: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter10date__pad2(_M0MP311moonbitlang1x4time13ZonedDateTime6second(dt)));
          break;
        }
        case 97: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter20date__weekday__short(_M0MP311moonbitlang1x4time13ZonedDateTime7weekday(dt)));
          break;
        }
        case 65: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter19date__weekday__long(_M0MP311moonbitlang1x4time13ZonedDateTime7weekday(dt)));
          break;
        }
        case 98: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter18date__month__short(_M0MP311moonbitlang1x4time13ZonedDateTime5month(dt)));
          break;
        }
        case 66: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter17date__month__long(_M0MP311moonbitlang1x4time13ZonedDateTime5month(dt)));
          break;
        }
        case 70: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, `${_M0IPC13int3IntPB4Show10to__string(_M0MP311moonbitlang1x4time13ZonedDateTime4year(dt))}-${_M0FP410Haoxincode8moonbash3lib11interpreter10date__pad2(_M0MP311moonbitlang1x4time13ZonedDateTime5month(dt))}-${_M0FP410Haoxincode8moonbash3lib11interpreter10date__pad2(_M0MP311moonbitlang1x4time13ZonedDateTime3day(dt))}`);
          break;
        }
        case 84: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, `${_M0FP410Haoxincode8moonbash3lib11interpreter10date__pad2(_M0MP311moonbitlang1x4time13ZonedDateTime4hour(dt))}:${_M0FP410Haoxincode8moonbash3lib11interpreter10date__pad2(_M0MP311moonbitlang1x4time13ZonedDateTime6minute(dt))}:${_M0FP410Haoxincode8moonbash3lib11interpreter10date__pad2(_M0MP311moonbitlang1x4time13ZonedDateTime6second(dt))}`);
          break;
        }
        case 115: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15int645Int6418to__string_2einner(_M0MP311moonbitlang1x4time13ZonedDateTime16to__unix__second(dt), 10));
          break;
        }
        case 117: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC13int3Int18to__string_2einner(_M0FP410Haoxincode8moonbash3lib11interpreter28date__weekday__monday__index(_M0MP311moonbitlang1x4time13ZonedDateTime7weekday(dt)), 10));
          break;
        }
        case 119: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC13int3Int18to__string_2einner(_M0FP410Haoxincode8moonbash3lib11interpreter28date__weekday__sunday__index(_M0MP311moonbitlang1x4time13ZonedDateTime7weekday(dt)), 10));
          break;
        }
        case 90: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, "UTC");
          break;
        }
        case 122: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, "+0000");
          break;
        }
        default: {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 37);
          _M0IPB13StringBuilderPB6Logger11write__char(out, code);
        }
      }
      i = i + 2 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter17date__parse__args(args) {
  let use_utc = false;
  let format = undefined;
  let parsing_options = true;
  const _bind$4 = args.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const arg = args[_];
      _L: {
        if (parsing_options && arg === "--") {
          parsing_options = false;
          break _L;
        }
        if (parsing_options && (arg === "-u" || (arg === "--utc" || arg === "--universal"))) {
          use_utc = true;
          break _L;
        }
        let _tmp$39;
        if (arg.length > 0) {
          $bound_check(arg, 0);
          _tmp$39 = arg.charCodeAt(0) === 43;
        } else {
          _tmp$39 = false;
        }
        if (_tmp$39) {
          const _bind$5 = format;
          if (!(_bind$5 === undefined)) {
            return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib11interpreter10DateConfigsE3Err(`date: extra operand '${arg}'\n`);
          }
          format = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 1, undefined));
          parsing_options = false;
          break _L;
        }
        let _tmp$40;
        if (parsing_options) {
          let _tmp$41;
          if (arg.length > 1) {
            $bound_check(arg, 0);
            _tmp$41 = arg.charCodeAt(0) === 45;
          } else {
            _tmp$41 = false;
          }
          _tmp$40 = _tmp$41;
        } else {
          _tmp$40 = false;
        }
        if (_tmp$40) {
          return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib11interpreter10DateConfigsE3Err(`date: unsupported option -- '${arg}'\n`);
        }
        return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib11interpreter10DateConfigsE3Err(`date: extra operand '${arg}'\n`);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGRP410Haoxincode8moonbash3lib11interpreter10DateConfigsE2Ok(new _M0TP410Haoxincode8moonbash3lib11interpreter10DateConfig(use_utc, format));
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__date(self, args) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter17date__parse__args(args);
  let config;
  if (_bind$4.$tag === 1) {
    const _Ok = _bind$4;
    config = _Ok._0;
  } else {
    const _Err = _bind$4;
    const _msg = _Err._0;
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, _msg);
    self.exit_code = 1;
    return undefined;
  }
  config.use_utc;
  const dt = _M0FP410Haoxincode8moonbash3lib11interpreter28date__current__datetime__utc();
  const _bind$5 = config.format;
  let output;
  if (_bind$5 === undefined) {
    output = _M0FP410Haoxincode8moonbash3lib11interpreter21date__default__output(dt);
  } else {
    const _Some = _bind$5;
    const _format = _Some;
    output = _M0FP410Haoxincode8moonbash3lib11interpreter20date__format__output(dt, _format);
  }
  _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${output}\n`);
  self.exit_code = 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter36is__visible__declare__function__name(name) {
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < name.length) {
      $bound_check(name, i);
      if (name.charCodeAt(i) === 46) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter29parse__declare__option__token(flag) {
  if (flag === "--") {
    return { _0: true, _1: [] };
  }
  if (flag.length <= 1) {
    return undefined;
  }
  $bound_check(flag, 0);
  const first = flag.charCodeAt(0);
  if (first !== 45 && first !== 43) {
    return undefined;
  }
  const enable = first === 45;
  const flags = [];
  let _tmp$38 = 1;
  while (true) {
    const i = _tmp$38;
    if (i < flag.length) {
      $bound_check(flag, i);
      const ch = flag.charCodeAt(i);
      _L: {
        switch (ch) {
          case 110: {
            break _L;
          }
          case 112: {
            break _L;
          }
          case 102: {
            break _L;
          }
          case 70: {
            break _L;
          }
          case 114: {
            break _L;
          }
          case 105: {
            break _L;
          }
          case 108: {
            break _L;
          }
          case 117: {
            break _L;
          }
          case 120: {
            break _L;
          }
          case 97: {
            break _L;
          }
          case 65: {
            break _L;
          }
          case 103: {
            break _L;
          }
          default: {
            return undefined;
          }
        }
      }
      _M0MPC15array5Array4pushGcE(flags, ch);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return { _0: enable, _1: flags };
}
function _M0FP410Haoxincode8moonbash3lib11interpreter26is__declare__option__token(flag) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter29parse__declare__option__token(flag);
  return !(_bind$4 === undefined);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext23capture__local__binding(self, name) {
  if (self.call_depth <= 0) {
    return undefined;
  }
  const depth = self.call_depth;
  const names_key = _M0FP410Haoxincode8moonbash3lib11interpreter24local__scope__names__key(depth);
  const saved_set_key = _M0FP410Haoxincode8moonbash3lib11interpreter29local__scope__saved__set__key(depth, name);
  const saved_value_key = _M0FP410Haoxincode8moonbash3lib11interpreter31local__scope__saved__value__key(depth, name);
  if (_M0MPB3Map8containsGssE(self.env, saved_set_key)) {
    return undefined;
  }
  const _bind$4 = _M0MPB3Map3getGssE(self.env, name);
  if (_bind$4 === undefined) {
    _M0MPB3Map3setGssE(self.env, saved_set_key, "0");
  } else {
    const _Some = _bind$4;
    const _value = _Some;
    _M0MPB3Map3setGssE(self.env, saved_set_key, "1");
    _M0MPB3Map3setGssE(self.env, saved_value_key, _value);
  }
  const _p$4 = _M0MPB3Map3getGssE(self.env, names_key);
  const _p$5 = "";
  let names;
  if (_p$4 === undefined) {
    names = _p$5;
  } else {
    const _p$6 = _p$4;
    names = _p$6;
  }
  _M0MPB3Map3setGssE(self.env, names_key, names.length === 0 ? name : `${names}\u001f${name}`);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33store__array__element__assignment(self, base, index, value, append) {
  if (_M0FP410Haoxincode8moonbash3lib11interpreter37trim__ascii__space__for__array__index(index).length === 0) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27emit__bad__array__subscript(self, base, `${base}[]`);
    self.exit_code = 1;
    return undefined;
  }
  if (_M0MPB3Map8containsGssE(self.env, `__MOON_BASH_READONLY__${base}`)) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: ${base}: readonly variable\n`);
    self.exit_code = 1;
    self.should_exit = true;
    return undefined;
  }
  const key = `${base}[${index}]`;
  if (append) {
    const _p$4 = _M0MPB3Map3getGssE(self.env, key);
    const _p$5 = "";
    let existing;
    if (_p$4 === undefined) {
      existing = _p$5;
    } else {
      const _p$6 = _p$4;
      existing = _p$6;
    }
    _M0MPB3Map3setGssE(self.env, key, `${existing}${value}`);
  } else {
    _M0MPB3Map3setGssE(self.env, key, value);
  }
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24refresh__array__metadata(self, base);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter9to__lower(s) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      if (ch >= 65 && ch <= 90) {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, ch + 32 | 0);
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter9to__upper(s) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      if (ch >= 97 && ch <= 122) {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, ch - 32 | 0);
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22is__readonly__variable(self, name) {
  const _p$4 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_READONLY__${name}`);
  const _p$5 = "";
  let _tmp$38;
  if (_p$4 === undefined) {
    _tmp$38 = _p$5;
  } else {
    const _p$6 = _p$4;
    _tmp$38 = _p$6;
  }
  return _tmp$38 === "1";
}
function _M0FP410Haoxincode8moonbash3lib11interpreter36is__internal__declare__storage__name(name) {
  return _M0MPC16string6String11has__prefix(name, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib11interpreter36is__internal__declare__storage__nameN7_2abindS6974, 0, _M0FP410Haoxincode8moonbash3lib11interpreter36is__internal__declare__storage__nameN7_2abindS6974.length));
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext30collect__declare__print__names(self) {
  const names = [];
  const _bind$4 = [];
  const seen = _M0MPB3Map3MapGsbE(new _M0TPB9ArrayViewGUsbEE(_bind$4, 0, 0), undefined);
  const _it = _M0MPB3Map5iter2GssE(self.env);
  while (true) {
    const _bind$5 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$5 === undefined) {
      break;
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      const _key = _x._0;
      if (_M0FP410Haoxincode8moonbash3lib11interpreter36is__internal__declare__storage__name(_key)) {
        continue;
      }
      const _bind$6 = _M0FP410Haoxincode8moonbash3lib11interpreter39parse__array__element__assignment__name(_key);
      if (_bind$6 === undefined) {
        if (!_M0MPB3Map8containsGsbE(seen, _key)) {
          _M0MPB3Map3setGsbE(seen, _key, true);
          _M0MPC15array5Array4pushGUssEE(names, _key);
        }
      } else {
        const _Some$2 = _bind$6;
        const _x$2 = _Some$2;
        const _base = _x$2._0;
        if (!_M0MPB3Map8containsGsbE(seen, _base)) {
          _M0MPB3Map3setGsbE(seen, _base, true);
          _M0MPC15array5Array4pushGUssEE(names, _base);
        }
      }
      continue;
    }
  }
  const _it$2 = _M0MPB3Map5iter2GsbE(self.exported);
  while (true) {
    const _bind$5 = _M0MPB5Iter24nextGsbE(_it$2);
    if (_bind$5 === undefined) {
      break;
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      const _key = _x._0;
      if (_M0FP410Haoxincode8moonbash3lib11interpreter36is__internal__declare__storage__name(_key)) {
        continue;
      }
      if (!_M0MPB3Map8containsGsbE(seen, _key)) {
        _M0MPB3Map3setGsbE(seen, _key, true);
        _M0MPC15array5Array4pushGUssEE(names, _key);
      }
      continue;
    }
  }
  _M0MPC15array5Array8sort__byGUssEE(names, (a, b) => _M0FP410Haoxincode8moonbash3lib11interpreter13compare__text(a, b));
  return names;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32declare__entry__matches__filters(self, name, nameref_mode, readonly_mode, export_mode, indexed_array_mode, assoc_array_mode) {
  if (nameref_mode && !_M0MPB3Map8containsGssE(self.env, `__MOON_BASH_NAMEREF__${name}`)) {
    return false;
  }
  if (readonly_mode && !_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22is__readonly__variable(self, name)) {
    return false;
  }
  if (export_mode && !_M0MPB3Map8containsGsbE(self.exported, name)) {
    return false;
  }
  const _p$4 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_ARRAY_KIND__${name}`);
  const _p$5 = "";
  let array_kind;
  if (_p$4 === undefined) {
    array_kind = _p$5;
  } else {
    const _p$6 = _p$4;
    array_kind = _p$6;
  }
  let _tmp$38;
  if (indexed_array_mode) {
    const _p$6 = "indexed";
    _tmp$38 = !(array_kind === _p$6);
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    return false;
  }
  let _tmp$39;
  if (assoc_array_mode) {
    const _p$6 = "assoc";
    _tmp$39 = !(array_kind === _p$6);
  } else {
    _tmp$39 = false;
  }
  if (_tmp$39) {
    return false;
  }
  return true;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter22escape__declare__value(value) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < value.length) {
      $bound_check(value, i);
      const ch = value.charCodeAt(i);
      if (ch === 92 || ch === 34) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 92);
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter29printf__is__shell__safe__char(ch) {
  return ch >= 97 && ch <= 122 || (ch >= 65 && ch <= 90 || (ch >= 48 && ch <= 57 || (ch === 95 || (ch === 45 || (ch === 46 || (ch === 47 || (ch === 58 || ch === 64)))))));
}
function _M0FP410Haoxincode8moonbash3lib11interpreter20printf__shell__quote(value) {
  if (value.length === 0) {
    return "''";
  }
  let safe = true;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < value.length) {
      $bound_check(value, i);
      const ch = value.charCodeAt(i);
      if (!_M0FP410Haoxincode8moonbash3lib11interpreter29printf__is__shell__safe__char(ch)) {
        safe = false;
        break;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (safe) {
    return value;
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger11write__char(out, 39);
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < value.length) {
      $bound_check(value, i);
      const ch = value.charCodeAt(i);
      if (ch === 39) {
        _M0IPB13StringBuilderPB6Logger13write__string(out, "'\\''");
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger11write__char(out, 39);
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter26quote__assoc__declare__key(key) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger11write__char(out, 39);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < key.length) {
      $bound_check(key, i);
      const ch = key.charCodeAt(i);
      if (ch === 39) {
        _M0IPB13StringBuilderPB6Logger13write__string(out, "'\\''");
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger11write__char(out, 39);
  return out.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25declare__attribute__flags(self, name) {
  const flags = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _p$4 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_ATTR_INTEGER__${name}`);
  const _p$5 = "";
  let _tmp$38;
  if (_p$4 === undefined) {
    _tmp$38 = _p$5;
  } else {
    const _p$6 = _p$4;
    _tmp$38 = _p$6;
  }
  if (_tmp$38 === "1") {
    _M0IPB13StringBuilderPB6Logger11write__char(flags, 105);
  }
  const _p$6 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_ATTR_LOWER__${name}`);
  const _p$7 = "";
  let _tmp$39;
  if (_p$6 === undefined) {
    _tmp$39 = _p$7;
  } else {
    const _p$8 = _p$6;
    _tmp$39 = _p$8;
  }
  if (_tmp$39 === "1") {
    _M0IPB13StringBuilderPB6Logger11write__char(flags, 108);
  }
  if (_M0MPB3Map8containsGssE(self.env, `__MOON_BASH_NAMEREF__${name}`)) {
    _M0IPB13StringBuilderPB6Logger11write__char(flags, 110);
  }
  if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22is__readonly__variable(self, name)) {
    _M0IPB13StringBuilderPB6Logger11write__char(flags, 114);
  }
  const _p$8 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_ATTR_UPPER__${name}`);
  const _p$9 = "";
  let _tmp$40;
  if (_p$8 === undefined) {
    _tmp$40 = _p$9;
  } else {
    const _p$10 = _p$8;
    _tmp$40 = _p$10;
  }
  if (_tmp$40 === "1") {
    _M0IPB13StringBuilderPB6Logger11write__char(flags, 117);
  }
  if (_M0MPB3Map8containsGsbE(self.exported, name)) {
    _M0IPB13StringBuilderPB6Logger11write__char(flags, 120);
  }
  return flags.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29format__declare__print__entry(self, name) {
  if (_M0FP410Haoxincode8moonbash3lib11interpreter36is__internal__declare__storage__name(name)) {
    return undefined;
  }
  const attr_flags = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25declare__attribute__flags(self, name);
  const _p$4 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_ARRAY_KIND__${name}`);
  const _p$5 = "";
  let array_kind;
  if (_p$4 === undefined) {
    array_kind = _p$5;
  } else {
    const _p$6 = _p$4;
    array_kind = _p$6;
  }
  const has_array_kind = array_kind === "assoc" || array_kind === "indexed";
  const has_array_count = _M0MPB3Map8containsGssE(self.env, `__MOON_BASH_ARRAY_COUNT__${name}`);
  if (has_array_kind || has_array_count) {
    const key_prefix = `${name}[`;
    const element_keys = [];
    const _it = _M0MPB3Map5iter2GssE(self.env);
    while (true) {
      const _bind$4 = _M0MPB5Iter24nextGssE(_it);
      if (_bind$4 === undefined) {
        break;
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        const _key = _x._0;
        let _tmp$38;
        if (_M0FP410Haoxincode8moonbash3lib11interpreter19string__has__prefix(_key, key_prefix)) {
          let _tmp$39;
          if (_key.length > key_prefix.length) {
            const _tmp$40 = _key.length - 1 | 0;
            $bound_check(_key, _tmp$40);
            const _p$6 = _key.charCodeAt(_tmp$40);
            const _p$7 = 93;
            _tmp$39 = _p$6 === _p$7;
          } else {
            _tmp$39 = false;
          }
          _tmp$38 = _tmp$39;
        } else {
          _tmp$38 = false;
        }
        if (_tmp$38) {
          const inner = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(_key, key_prefix.length, _key.length - 1 | 0));
          let _tmp$39;
          const _p$6 = "@";
          if (!(inner === _p$6)) {
            const _p$7 = "*";
            _tmp$39 = !(inner === _p$7);
          } else {
            _tmp$39 = false;
          }
          if (_tmp$39) {
            _M0MPC15array5Array4pushGUssEE(element_keys, inner);
          }
        }
        continue;
      }
    }
    _M0FP410Haoxincode8moonbash3lib11interpreter17sort__array__keys(element_keys);
    const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
    _M0IPB13StringBuilderPB6Logger13write__string(out, "declare ");
    if (attr_flags.length > 0) {
      _M0IPB13StringBuilderPB6Logger11write__char(out, 45);
      _M0IPB13StringBuilderPB6Logger13write__string(out, attr_flags);
      _M0IPB13StringBuilderPB6Logger11write__char(out, 32);
    }
    if (array_kind === "assoc") {
      _M0IPB13StringBuilderPB6Logger13write__string(out, "-A ");
    } else {
      _M0IPB13StringBuilderPB6Logger13write__string(out, "-a ");
    }
    _M0IPB13StringBuilderPB6Logger13write__string(out, name);
    _M0IPB13StringBuilderPB6Logger13write__string(out, "=(");
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < element_keys.length) {
        if (i > 0) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 32);
        }
        const idx = _M0MPC15array5Array2atGUssEE(element_keys, i);
        const _p$6 = _M0MPB3Map3getGssE(self.env, `${name}[${idx}]`);
        const _p$7 = "";
        let value;
        if (_p$6 === undefined) {
          value = _p$7;
        } else {
          const _p$8 = _p$6;
          value = _p$8;
        }
        if (array_kind === "assoc") {
          _M0IPB13StringBuilderPB6Logger13write__string(out, "[");
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter26quote__assoc__declare__key(idx));
          _M0IPB13StringBuilderPB6Logger13write__string(out, "]=");
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter20printf__shell__quote(value));
        } else {
          _M0IPB13StringBuilderPB6Logger13write__string(out, `[${idx}]=\"`);
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter22escape__declare__value(value));
          _M0IPB13StringBuilderPB6Logger11write__char(out, 34);
        }
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    _M0IPB13StringBuilderPB6Logger11write__char(out, 41);
    return out.val;
  }
  const _bind$4 = _M0MPB3Map3getGssE(self.env, name);
  if (_bind$4 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$4;
    const _value = _Some;
    return attr_flags.length > 0 ? `declare -${attr_flags} ${name}=\"${_M0FP410Haoxincode8moonbash3lib11interpreter22escape__declare__value(_value)}\"` : `declare -- ${name}=\"${_M0FP410Haoxincode8moonbash3lib11interpreter22escape__declare__value(_value)}\"`;
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext23set__integer__attribute(self, name, enabled) {
  if (enabled) {
    _M0MPB3Map3setGssE(self.env, `__MOON_BASH_ATTR_INTEGER__${name}`, "1");
    return;
  } else {
    _M0MPB3Map6removeGssE(self.env, `__MOON_BASH_ATTR_INTEGER__${name}`);
    return;
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21set__lower__attribute(self, name, enabled) {
  if (enabled) {
    _M0MPB3Map3setGssE(self.env, `__MOON_BASH_ATTR_LOWER__${name}`, "1");
    return;
  } else {
    _M0MPB3Map6removeGssE(self.env, `__MOON_BASH_ATTR_LOWER__${name}`);
    return;
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext23set__readonly__variable(self, name, enabled) {
  if (enabled) {
    _M0MPB3Map3setGssE(self.env, `__MOON_BASH_READONLY__${name}`, "1");
    return;
  } else {
    _M0MPB3Map6removeGssE(self.env, `__MOON_BASH_READONLY__${name}`);
    return;
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21set__upper__attribute(self, name, enabled) {
  if (enabled) {
    _M0MPB3Map3setGssE(self.env, `__MOON_BASH_ATTR_UPPER__${name}`, "1");
    return;
  } else {
    _M0MPB3Map6removeGssE(self.env, `__MOON_BASH_ATTR_UPPER__${name}`);
    return;
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__dirname(self, args) {
  if (args.length === 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "dirname: missing operand\n");
    self.exit_code = 1;
    return undefined;
  }
  const _bind$4 = args.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const path = args[_];
      _L: {
        const normalized = _M0FP410Haoxincode8moonbash3lib11interpreter34trim__trailing__slashes__for__path(path);
        if (normalized === "/") {
          _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, "/\n");
          break _L;
        }
        const parent = _M0FP410Haoxincode8moonbash3lib2fs12parent__path(normalized);
        const result = parent === "/" && !_M0MPC16string6String11has__prefix(normalized, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__dirnameN7_2abindS7049, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__dirnameN7_2abindS7049.length)) ? "." : parent === normalized ? "." : parent;
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${result}\n`);
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter23completion__tilde__path(path, home) {
  if (home.length === 0) {
    return path;
  }
  if (path === home) {
    return "~";
  }
  if (home === "/") {
    let _tmp$38;
    if (path.length > 0) {
      $bound_check(path, 0);
      _tmp$38 = path.charCodeAt(0) === 47;
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      return `~${path}`;
    }
    return path;
  }
  const home_prefix = `${home}/`;
  if (_M0MPC16string6String11has__prefix(path, new _M0TPC16string10StringView(home_prefix, 0, home_prefix.length))) {
    return `~/${_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(path, home_prefix.length, undefined))}`;
  }
  return path;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24render__directory__stack(self, stack, long_format, one_per_line, numbered) {
  const _p$4 = _M0MPB3Map3getGssE(self.env, "HOME");
  const _p$5 = "";
  let home;
  if (_p$4 === undefined) {
    home = _p$5;
  } else {
    const _p$6 = _p$4;
    home = _p$6;
  }
  if (numbered) {
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < stack.length) {
        const shown = long_format ? _M0MPC15array5Array2atGUssEE(stack, i) : _M0FP410Haoxincode8moonbash3lib11interpreter23completion__tilde__path(_M0MPC15array5Array2atGUssEE(stack, i), home);
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, ` ${_M0MPC13int3Int18to__string_2einner(i, 10)}  ${shown}\n`);
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return undefined;
  }
  if (one_per_line) {
    const _bind$4 = stack.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$4) {
        const path = stack[_];
        const shown = long_format ? path : _M0FP410Haoxincode8moonbash3lib11interpreter23completion__tilde__path(path, home);
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${shown}\n`);
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return undefined;
  }
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < stack.length) {
      if (i > 0) {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, 32);
      }
      const shown = long_format ? _M0MPC15array5Array2atGUssEE(stack, i) : _M0FP410Haoxincode8moonbash3lib11interpreter23completion__tilde__path(_M0MPC15array5Array2atGUssEE(stack, i), home);
      _M0IPB13StringBuilderPB6Logger13write__string(buf, shown);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${buf.val}\n`);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__dirs(self, args) {
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33sync__directory__stack__with__cwd(self);
  let long_format = false;
  let one_per_line = false;
  let numbered = false;
  let clear_stack = false;
  let i = 0;
  let parse_flags = true;
  while (true) {
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      if (parse_flags && arg === "--") {
        parse_flags = false;
        i = i + 1 | 0;
        continue;
      }
      let _tmp$38;
      if (parse_flags) {
        let _tmp$39;
        if (arg.length > 1) {
          $bound_check(arg, 0);
          _tmp$39 = arg.charCodeAt(0) === 45;
        } else {
          _tmp$39 = false;
        }
        _tmp$38 = _tmp$39;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        let _tmp$39 = 1;
        while (true) {
          const j = _tmp$39;
          if (j < arg.length) {
            $bound_check(arg, j);
            const ch = arg.charCodeAt(j);
            switch (ch) {
              case 99: {
                clear_stack = true;
                break;
              }
              case 108: {
                long_format = true;
                break;
              }
              case 112: {
                one_per_line = true;
                break;
              }
              case 118: {
                numbered = true;
                break;
              }
              default: {
                self.exit_code = 2;
                return undefined;
              }
            }
            _tmp$39 = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        i = i + 1 | 0;
        continue;
      }
      self.exit_code = 1;
      return undefined;
    } else {
      break;
    }
  }
  if (clear_stack) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21set__directory__stack(self, [self.cwd]);
    self.exit_code = 0;
    return undefined;
  }
  const stack = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21get__directory__stack(self);
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24render__directory__stack(self, stack, long_format, one_per_line, numbered);
  self.exit_code = 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__env(self, _args) {
  const _it = _M0MPB3Map5iter2GssE(self.env);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _k = _x._0;
      const _v = _x._1;
      _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_k}=${_v}\n`);
      continue;
    }
  }
  self.exit_code = 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__exit(self, args) {
  self.exit_code = args.length > 0 ? _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(args, 0)) : self.exit_code;
  self.should_exit = true;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter12expand__tabs(input, tab_width) {
  const width = tab_width <= 0 ? 8 : tab_width;
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let col = 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < input.length) {
      $bound_check(input, i);
      const ch = input.charCodeAt(i);
      if (ch === 9) {
        const spaces = width - (col % width | 0) | 0;
        let _tmp$39 = 0;
        while (true) {
          const j = _tmp$39;
          if (j < spaces) {
            _M0IPB13StringBuilderPB6Logger11write__char(out, 32);
            _tmp$39 = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        col = col + spaces | 0;
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        if (ch === 10) {
          col = 0;
        } else {
          col = col + 1 | 0;
        }
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15builtin__expand(self, args) {
  let tab_width = 8;
  const files = [];
  let i = 0;
  while (true) {
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      if (arg === "-t" && (i + 1 | 0) < args.length) {
        tab_width = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(args, i + 1 | 0));
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15builtin__expandN7_2abindS7088, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15builtin__expandN7_2abindS7088.length)) && arg.length > 2) {
        tab_width = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined)));
        i = i + 1 | 0;
        continue;
      }
      _M0MPC15array5Array4pushGUssEE(files, arg);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (tab_width <= 0) {
    tab_width = 8;
  }
  if (files.length === 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0FP410Haoxincode8moonbash3lib11interpreter12expand__tabs(self.stdin_buf, tab_width));
    self.exit_code = 0;
    return undefined;
  }
  const _bind$4 = files.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const path = files[_];
      let resolved;
      let _try_err;
      _L: {
        _L$2: {
          const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, path);
          if (_bind$5.$tag === 1) {
            const _ok = _bind$5;
            resolved = _ok._0;
          } else {
            const _err = _bind$5;
            _try_err = _err._0;
            break _L$2;
          }
          break _L;
        }
        resolved = path;
      }
      let content;
      let _try_err$2;
      _L$2: {
        _L$3: {
          const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(self.fs, resolved);
          if (_bind$5.$tag === 1) {
            const _ok = _bind$5;
            content = _ok._0;
          } else {
            const _err = _bind$5;
            _try_err$2 = _err._0;
            break _L$3;
          }
          break _L$2;
        }
        const _FsError = _try_err$2;
        const _msg = _FsError._0;
        _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `expand: ${_msg}\n`);
        self.exit_code = 1;
        return undefined;
      }
      _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0FP410Haoxincode8moonbash3lib11interpreter12expand__tabs(content, tab_width));
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15builtin__export(self, args) {
  if (args.length > 1 && _M0MPC15array5Array2atGUssEE(args, 0) === "-p") {
    self.exit_code = 0;
    return undefined;
  }
  if (args.length === 0 || args.length > 0 && _M0MPC15array5Array2atGUssEE(args, 0) === "-p") {
    const names = [];
    const _it = _M0MPB3Map5iter2GsbE(self.exported);
    while (true) {
      const _bind$4 = _M0MPB5Iter24nextGsbE(_it);
      if (_bind$4 === undefined) {
        break;
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        const _k = _x._0;
        if (_M0FP410Haoxincode8moonbash3lib11interpreter36is__internal__declare__storage__name(_k)) {
          continue;
        }
        _M0MPC15array5Array4pushGUssEE(names, _k);
        continue;
      }
    }
    _M0MPC15array5Array8sort__byGUssEE(names, (a, b) => _M0FP410Haoxincode8moonbash3lib11interpreter13compare__text(a, b));
    const _bind$4 = names.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$4) {
        const k = names[_];
        const _p$4 = _M0MPB3Map3getGssE(self.env, k);
        const _p$5 = "";
        let value;
        if (_p$4 === undefined) {
          value = _p$5;
        } else {
          const _p$6 = _p$4;
          value = _p$6;
        }
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `declare -x ${k}=\"${value}\"\n`);
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    self.exit_code = 0;
    return undefined;
  }
  let failed = false;
  const _bind$4 = args.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const arg = args[_];
      _L: {
        const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter24parse__name__value__spec(arg);
        if (_bind$5 === undefined) {
          _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: export: ${arg}: not a valid identifier\n`);
          failed = true;
        } else {
          const _Some = _bind$5;
          const _x = _Some;
          const _name = _x._0;
          const _assigned_value = _x._1;
          const _append = _x._2;
          const _bind$6 = _M0FP410Haoxincode8moonbash3lib11interpreter39parse__array__element__assignment__name(_name);
          if (_bind$6 === undefined) {
          } else {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: export: ${_name}: not a valid identifier\n`);
            failed = true;
            break _L;
          }
          if (_assigned_value === undefined) {
          } else {
            const _Some$2 = _assigned_value;
            const _value = _Some$2;
            let next_value;
            if (_append) {
              const _p$4 = _M0MPB3Map3getGssE(self.env, _name);
              const _p$5 = "";
              let _tmp$39;
              if (_p$4 === undefined) {
                _tmp$39 = _p$5;
              } else {
                const _p$6 = _p$4;
                _tmp$39 = _p$6;
              }
              next_value = `${_tmp$39}${_value}`;
            } else {
              next_value = _value;
            }
            _M0MPB3Map3setGssE(self.env, _name, next_value);
          }
          _M0MPB3Map3setGsbE(self.exported, _name, true);
        }
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = failed ? 1 : 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter18fold__single__line(line, width, break_spaces) {
  if (line.length <= width) {
    return line;
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let cursor = 0;
  while (true) {
    if (cursor < line.length) {
      const remaining = line.length - cursor | 0;
      if (remaining <= width) {
        _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(line, cursor, line.length));
        break;
      }
      let cut = cursor + width | 0;
      if (break_spaces) {
        let last_blank = -1;
        let _tmp$38 = cursor;
        while (true) {
          const i = _tmp$38;
          if (i < cut) {
            $bound_check(line, i);
            const ch = line.charCodeAt(i);
            if (ch === 32 || ch === 9) {
              last_blank = i;
            }
            _tmp$38 = i + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        if (last_blank >= cursor) {
          cut = last_blank + 1 | 0;
        }
      }
      if (cut <= cursor) {
        cut = cursor + width | 0;
      }
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(line, cursor, cut));
      _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
      cursor = cut;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter10fold__text(input, width, break_spaces) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const line = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < input.length) {
      $bound_check(input, i);
      const ch = input.charCodeAt(i);
      if (ch === 10) {
        _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter18fold__single__line(line.val, width, break_spaces));
        _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
        _M0MPB13StringBuilder5reset(line);
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(line, ch);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const remaining = line.val;
  if (remaining.length > 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter18fold__single__line(remaining, width, break_spaces));
  }
  return out.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__fold(self, args) {
  let width = 80;
  let break_spaces = false;
  const files = [];
  let i = 0;
  while (true) {
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      if (arg === "-s") {
        break_spaces = true;
        i = i + 1 | 0;
        continue;
      }
      if (arg === "-w" && (i + 1 | 0) < args.length) {
        width = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(args, i + 1 | 0));
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__foldN7_2abindS7147, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__foldN7_2abindS7147.length)) && arg.length > 2) {
        width = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined)));
        i = i + 1 | 0;
        continue;
      }
      let _tmp$38;
      if (arg.length > 1) {
        $bound_check(arg, 0);
        const _p$4 = arg.charCodeAt(0);
        const _p$5 = 45;
        _tmp$38 = _p$4 === _p$5;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        let consumed_value = false;
        let _tmp$39 = 1;
        _L: while (true) {
          const j = _tmp$39;
          if (j < arg.length) {
            $bound_check(arg, j);
            const flag = arg.charCodeAt(j);
            switch (flag) {
              case 115: {
                break_spaces = true;
                break;
              }
              case 119: {
                if ((j + 1 | 0) < arg.length) {
                  width = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, j + 1 | 0, undefined)));
                } else {
                  if ((i + 1 | 0) < args.length) {
                    i = i + 1 | 0;
                    width = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(args, i));
                  }
                }
                consumed_value = true;
                break _L;
              }
            }
            _tmp$39 = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        i = i + 1 | 0;
        if (consumed_value) {
          continue;
        }
        continue;
      }
      _M0MPC15array5Array4pushGUssEE(files, arg);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (width <= 0) {
    width = 1;
  }
  if (files.length === 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0FP410Haoxincode8moonbash3lib11interpreter10fold__text(self.stdin_buf, width, break_spaces));
    self.exit_code = 0;
    return undefined;
  }
  const _bind$4 = files.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const path = files[_];
      let resolved;
      let _try_err;
      _L: {
        _L$2: {
          const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, path);
          if (_bind$5.$tag === 1) {
            const _ok = _bind$5;
            resolved = _ok._0;
          } else {
            const _err = _bind$5;
            _try_err = _err._0;
            break _L$2;
          }
          break _L;
        }
        resolved = path;
      }
      let content;
      let _try_err$2;
      _L$2: {
        _L$3: {
          const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(self.fs, resolved);
          if (_bind$5.$tag === 1) {
            const _ok = _bind$5;
            content = _ok._0;
          } else {
            const _err = _bind$5;
            _try_err$2 = _err._0;
            break _L$3;
          }
          break _L$2;
        }
        const _FsError = _try_err$2;
        const _msg = _FsError._0;
        _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `fold: ${_msg}\n`);
        self.exit_code = 1;
        return undefined;
      }
      _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0FP410Haoxincode8moonbash3lib11interpreter10fold__text(content, width, break_spaces));
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter21getopts__char__string(ch) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
  return buf.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter21getopts__find__option(spec, ch) {
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < spec.length) {
      $bound_check(spec, i);
      if (spec.charCodeAt(i) === ch) {
        return i;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return -1;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter32getopts__option__takes__argument(spec, opt_idx) {
  if (opt_idx < 0 || (opt_idx + 1 | 0) >= spec.length) {
    return false;
  }
  const _tmp$38 = opt_idx + 1 | 0;
  $bound_check(spec, _tmp$38);
  return spec.charCodeAt(_tmp$38) === 58;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter27filter__whole__line__ranges(ranges, line, whole_line) {
  if (!whole_line) {
    return ranges;
  }
  const filtered = [];
  const _bind$4 = ranges.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const range = ranges[_];
      if (range._0 === 0 && range._1 === line.length) {
        _M0MPC15array5Array4pushGUssEE(filtered, range);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return filtered;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter14is__word__char(ch) {
  return ch >= 97 && ch <= 122 || (ch >= 65 && ch <= 90 || (ch >= 48 && ch <= 57 || ch === 95));
}
function _M0FP410Haoxincode8moonbash3lib11interpreter18is__word__boundary(line, start, end) {
  let left_ok;
  if (start <= 0) {
    left_ok = true;
  } else {
    const _tmp$38 = start - 1 | 0;
    $bound_check(line, _tmp$38);
    left_ok = !_M0FP410Haoxincode8moonbash3lib11interpreter14is__word__char(line.charCodeAt(_tmp$38));
  }
  let right_ok;
  if (end >= line.length) {
    right_ok = true;
  } else {
    $bound_check(line, end);
    right_ok = !_M0FP410Haoxincode8moonbash3lib11interpreter14is__word__char(line.charCodeAt(end));
  }
  return left_ok && right_ok;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter20filter__word__ranges(ranges, line, word_match) {
  if (!word_match) {
    return ranges;
  }
  const filtered = [];
  const _bind$4 = ranges.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const range = ranges[_];
      if (_M0FP410Haoxincode8moonbash3lib11interpreter18is__word__boundary(line, range._0, range._1)) {
        _M0MPC15array5Array4pushGUssEE(filtered, range);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return filtered;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter20grep__output__prefix(display_path, line_number, show_filename, show_line_number) {
  return show_filename && show_line_number ? `${display_path}:${_M0MPC13int3Int18to__string_2einner(line_number, 10)}:` : show_filename ? `${display_path}:` : show_line_number ? `${_M0MPC13int3Int18to__string_2einner(line_number, 10)}:` : "";
}
function _M0FP410Haoxincode8moonbash3lib11interpreter30grep__recursive__display__path(raw_root, resolved_root, full_path) {
  let suffix = "";
  if (full_path === resolved_root) {
    suffix = "";
  } else {
    const prefix = `${resolved_root}/`;
    if (_M0MPC16string6String11has__prefix(full_path, new _M0TPC16string10StringView(prefix, 0, prefix.length))) {
      suffix = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(full_path, prefix.length, undefined));
    } else {
      return full_path;
    }
  }
  const base = raw_root.length === 0 ? "." : raw_root;
  return suffix.length === 0 ? base : _M0MPC16string6String11has__suffix(base, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib11interpreter30grep__recursive__display__pathN7_2abindS7175, 0, _M0FP410Haoxincode8moonbash3lib11interpreter30grep__recursive__display__pathN7_2abindS7175.length)) ? `${base}${suffix}` : `${base}/${suffix}`;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter17grep__sort__paths(paths) {
  _M0MPC15array5Array8sort__byGUssEE(paths, (a, b) => {
    const min_len = a.length < b.length ? a.length : b.length;
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < min_len) {
        $bound_check(a, i);
        const _tmp$39 = a.charCodeAt(i);
        $bound_check(b, i);
        if (_M0IP016_24default__implPB7Compare6op__ltGkE(_tmp$39, b.charCodeAt(i))) {
          return -1;
        }
        $bound_check(a, i);
        const _tmp$40 = a.charCodeAt(i);
        $bound_check(b, i);
        if (_M0IP016_24default__implPB7Compare6op__gtGkE(_tmp$40, b.charCodeAt(i))) {
          return 1;
        }
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return a.length < b.length ? -1 : a.length > b.length ? 1 : 0;
  });
}
function _M0FP410Haoxincode8moonbash3lib11interpreter14path__basename(path) {
  let slash = -1;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < path.length) {
      $bound_check(path, i);
      const _p$4 = path.charCodeAt(i);
      const _p$5 = 47;
      if (_p$4 === _p$5) {
        slash = i;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return slash < 0 ? path : (slash + 1 | 0) >= path.length ? "" : _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(path, slash + 1 | 0, undefined));
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__grep(self, args) {
  let invert = false;
  let count_only = false;
  let ignore_case = false;
  let line_number = false;
  let list_files_only = false;
  let list_files_without_match = false;
  let only_matching = false;
  let whole_line = false;
  let word_match = false;
  let no_filename = false;
  let recursive = false;
  let quiet = false;
  let extended = false;
  let fixed = false;
  let before_context = 0;
  let after_context = 0;
  const include_globs = [];
  let pattern = "";
  const file_args = [];
  let pattern_set = false;
  let i = 0;
  while (true) {
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__grepN7_2abindS7181, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__grepN7_2abindS7181.length))) {
        _M0MPC15array5Array4pushGUssEE(include_globs, _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 10, undefined)));
      } else {
        if (arg === "--include" && (i + 1 | 0) < args.length) {
          i = i + 1 | 0;
          _M0MPC15array5Array4pushGUssEE(include_globs, _M0MPC15array5Array2atGUssEE(args, i));
        } else {
          if (arg === "-v") {
            invert = true;
          } else {
            if (arg === "-c") {
              count_only = true;
            } else {
              if (arg === "-i") {
                ignore_case = true;
              } else {
                if (arg === "-n") {
                  line_number = true;
                } else {
                  if (arg === "-l") {
                    list_files_only = true;
                    list_files_without_match = false;
                  } else {
                    if (arg === "-L") {
                      list_files_without_match = true;
                      list_files_only = false;
                    } else {
                      if (arg === "-o") {
                        only_matching = true;
                      } else {
                        if (arg === "-x") {
                          whole_line = true;
                        } else {
                          if (arg === "-w") {
                            word_match = true;
                          } else {
                            if (arg === "-h") {
                              no_filename = true;
                            } else {
                              if (arg === "-r" || arg === "-R") {
                                recursive = true;
                              } else {
                                if (arg === "-q") {
                                  quiet = true;
                                } else {
                                  if (arg === "-E") {
                                    extended = true;
                                  } else {
                                    if (arg === "-F") {
                                      fixed = true;
                                    } else {
                                      if (arg === "-A" && (i + 1 | 0) < args.length) {
                                        i = i + 1 | 0;
                                        after_context = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(args, i));
                                      } else {
                                        if (arg === "-B" && (i + 1 | 0) < args.length) {
                                          i = i + 1 | 0;
                                          before_context = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(args, i));
                                        } else {
                                          if (arg === "-C" && (i + 1 | 0) < args.length) {
                                            i = i + 1 | 0;
                                            const ctx = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(args, i));
                                            before_context = ctx;
                                            after_context = ctx;
                                          } else {
                                            if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__grepN7_2abindS7182, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__grepN7_2abindS7182.length)) && arg.length > 2) {
                                              after_context = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined)));
                                            } else {
                                              if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__grepN7_2abindS7183, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__grepN7_2abindS7183.length)) && arg.length > 2) {
                                                before_context = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined)));
                                              } else {
                                                if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__grepN7_2abindS7184, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__grepN7_2abindS7184.length)) && arg.length > 2) {
                                                  const ctx = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined)));
                                                  before_context = ctx;
                                                  after_context = ctx;
                                                } else {
                                                  let _tmp$38;
                                                  if (arg.length > 1) {
                                                    $bound_check(arg, 0);
                                                    const _p$4 = arg.charCodeAt(0);
                                                    const _p$5 = 45;
                                                    _tmp$38 = _p$4 === _p$5;
                                                  } else {
                                                    _tmp$38 = false;
                                                  }
                                                  if (_tmp$38) {
                                                    let consumed_value = false;
                                                    let _tmp$39 = 1;
                                                    while (true) {
                                                      const j = _tmp$39;
                                                      if (j < arg.length) {
                                                        $bound_check(arg, j);
                                                        const flag = arg.charCodeAt(j);
                                                        _L: {
                                                          _L$2: {
                                                            switch (flag) {
                                                              case 118: {
                                                                invert = true;
                                                                break;
                                                              }
                                                              case 99: {
                                                                count_only = true;
                                                                break;
                                                              }
                                                              case 105: {
                                                                ignore_case = true;
                                                                break;
                                                              }
                                                              case 110: {
                                                                line_number = true;
                                                                break;
                                                              }
                                                              case 108: {
                                                                list_files_only = true;
                                                                list_files_without_match = false;
                                                                break;
                                                              }
                                                              case 76: {
                                                                list_files_without_match = true;
                                                                list_files_only = false;
                                                                break;
                                                              }
                                                              case 111: {
                                                                only_matching = true;
                                                                break;
                                                              }
                                                              case 120: {
                                                                whole_line = true;
                                                                break;
                                                              }
                                                              case 119: {
                                                                word_match = true;
                                                                break;
                                                              }
                                                              case 104: {
                                                                no_filename = true;
                                                                break;
                                                              }
                                                              case 114: {
                                                                break _L$2;
                                                              }
                                                              case 82: {
                                                                break _L$2;
                                                              }
                                                              case 113: {
                                                                quiet = true;
                                                                break;
                                                              }
                                                              case 69: {
                                                                extended = true;
                                                                break;
                                                              }
                                                              case 70: {
                                                                fixed = true;
                                                                break;
                                                              }
                                                              case 65: {
                                                                if ((j + 1 | 0) < arg.length) {
                                                                  after_context = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, j + 1 | 0, undefined)));
                                                                } else {
                                                                  if ((i + 1 | 0) < args.length) {
                                                                    i = i + 1 | 0;
                                                                    after_context = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(args, i));
                                                                  }
                                                                }
                                                                consumed_value = true;
                                                                break;
                                                              }
                                                              case 66: {
                                                                if ((j + 1 | 0) < arg.length) {
                                                                  before_context = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, j + 1 | 0, undefined)));
                                                                } else {
                                                                  if ((i + 1 | 0) < args.length) {
                                                                    i = i + 1 | 0;
                                                                    before_context = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(args, i));
                                                                  }
                                                                }
                                                                consumed_value = true;
                                                                break;
                                                              }
                                                              case 67: {
                                                                let ctx;
                                                                if ((j + 1 | 0) < arg.length) {
                                                                  ctx = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, j + 1 | 0, undefined)));
                                                                } else {
                                                                  if ((i + 1 | 0) < args.length) {
                                                                    i = i + 1 | 0;
                                                                    ctx = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(args, i));
                                                                  } else {
                                                                    ctx = 0;
                                                                  }
                                                                }
                                                                before_context = ctx;
                                                                after_context = ctx;
                                                                consumed_value = true;
                                                                break;
                                                              }
                                                            }
                                                            break _L;
                                                          }
                                                          recursive = true;
                                                        }
                                                        if (consumed_value) {
                                                          break;
                                                        }
                                                        _tmp$39 = j + 1 | 0;
                                                        continue;
                                                      } else {
                                                        break;
                                                      }
                                                    }
                                                  } else {
                                                    if (arg === "-e" && (i + 1 | 0) < args.length) {
                                                      i = i + 1 | 0;
                                                      pattern = _M0MPC15array5Array2atGUssEE(args, i);
                                                      pattern_set = true;
                                                    } else {
                                                      if (!pattern_set) {
                                                        pattern = arg;
                                                        pattern_set = true;
                                                      } else {
                                                        _M0MPC15array5Array4pushGUssEE(file_args, arg);
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (!pattern_set) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "grep: missing pattern\n");
    self.exit_code = 2;
    return undefined;
  }
  let matcher;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib5regex30compile__grep__matcher_2einner(pattern, extended, fixed, ignore_case);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        matcher = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "grep: invalid regular expression\n");
    self.exit_code = 2;
    return undefined;
  }
  const targets = [];
  let had_io_error = false;
  if (file_args.length === 0) {
    _M0MPC15array5Array4pushGUssEE(targets, new _M0TP410Haoxincode8moonbash3lib11interpreter10GrepTarget("", self.stdin_buf));
  } else {
    const _bind$4 = file_args.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$4) {
        const raw_path = file_args[_];
        _L$2: {
          let resolved;
          let _try_err$2;
          _L$3: {
            _L$4: {
              const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, raw_path);
              if (_bind$5.$tag === 1) {
                const _ok = _bind$5;
                resolved = _ok._0;
              } else {
                const _err = _bind$5;
                _try_err$2 = _err._0;
                break _L$4;
              }
              break _L$3;
            }
            resolved = raw_path;
          }
          _L$4: {
            _L$5: {
              const _bind$5 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.fs.entries, resolved);
              if (_bind$5 === undefined) {
                break _L$5;
              } else {
                const _Some = _bind$5;
                const _x = _Some;
                if (_x.$tag === 1) {
                  if (recursive) {
                    let prefix = resolved;
                    if (!_M0MPC16string6String11has__suffix(prefix, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__grepN7_2abindS7208, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__grepN7_2abindS7208.length))) {
                      prefix = `${prefix}/`;
                    }
                    const matched_paths = [];
                    const _it = _M0MPB3Map5iter2GssE(self.fs.entries);
                    while (true) {
                      const _bind$6 = _M0MPB5Iter24nextGssE(_it);
                      if (_bind$6 === undefined) {
                        break;
                      } else {
                        const _Some$2 = _bind$6;
                        const _x$2 = _Some$2;
                        const _full_path = _x$2._0;
                        const _entry = _x$2._1;
                        const _bind$7 = prefix;
                        if (_M0MPC16string6String11has__prefix(_full_path, new _M0TPC16string10StringView(_bind$7, 0, _bind$7.length))) {
                          if (_entry.$tag === 0) {
                            _M0MPC15array5Array4pushGUssEE(matched_paths, _full_path);
                          }
                        }
                        continue;
                      }
                    }
                    _M0FP410Haoxincode8moonbash3lib11interpreter17grep__sort__paths(matched_paths);
                    const _bind$6 = matched_paths.length;
                    let _tmp$39 = 0;
                    while (true) {
                      const _$2 = _tmp$39;
                      if (_$2 < _bind$6) {
                        const full_path = matched_paths[_$2];
                        _L$6: {
                          const display = _M0FP410Haoxincode8moonbash3lib11interpreter30grep__recursive__display__path(raw_path, resolved, full_path);
                          if (include_globs.length > 0) {
                            const base = _M0FP410Haoxincode8moonbash3lib11interpreter14path__basename(display);
                            let include_match = false;
                            const _bind$7 = include_globs.length;
                            let _tmp$40 = 0;
                            while (true) {
                              const _$3 = _tmp$40;
                              if (_$3 < _bind$7) {
                                const glob = include_globs[_$3];
                                if (_M0FP410Haoxincode8moonbash3lib2fs11glob__match(glob, base)) {
                                  include_match = true;
                                  break;
                                }
                                _tmp$40 = _$3 + 1 | 0;
                                continue;
                              } else {
                                break;
                              }
                            }
                            if (!include_match) {
                              break _L$6;
                            }
                          }
                          const _bind$7 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.fs.entries, full_path);
                          if (_bind$7 === undefined) {
                          } else {
                            const _Some$2 = _bind$7;
                            const _x$2 = _Some$2;
                            if (_x$2.$tag === 0) {
                              const _File = _x$2;
                              const _file = _File._0;
                              _M0MPC15array5Array4pushGUssEE(targets, new _M0TP410Haoxincode8moonbash3lib11interpreter10GrepTarget(display, _file.content));
                            }
                          }
                          break _L$6;
                        }
                        _tmp$39 = _$2 + 1 | 0;
                        continue;
                      } else {
                        break;
                      }
                    }
                  } else {
                    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `grep: ${raw_path}: Is a directory\n`);
                    had_io_error = true;
                  }
                } else {
                  break _L$5;
                }
              }
              break _L$4;
            }
            let content;
            let _try_err$3;
            _L$6: {
              _L$7: {
                const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(self.fs, resolved);
                if (_bind$5.$tag === 1) {
                  const _ok = _bind$5;
                  content = _ok._0;
                } else {
                  const _err = _bind$5;
                  _try_err$3 = _err._0;
                  break _L$7;
                }
                break _L$6;
              }
              const _FsError = _try_err$3;
              const _msg = _FsError._0;
              _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `grep: ${_msg}\n`);
              had_io_error = true;
              break _L$2;
            }
            _M0MPC15array5Array4pushGUssEE(targets, new _M0TP410Haoxincode8moonbash3lib11interpreter10GrepTarget(raw_path, content));
          }
          break _L$2;
        }
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  const show_filename = !no_filename && (targets.length > 1 || recursive);
  let total_selected = 0;
  let listed_file_count = 0;
  const _bind$4 = targets.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const target = targets[_];
      _L$2: {
        const lines = _M0FP410Haoxincode8moonbash3lib11interpreter12split__lines(target.content);
        const line_matches = [];
        const selected_lines = [];
        let selected_count = 0;
        let _tmp$39 = 0;
        while (true) {
          const line_idx = _tmp$39;
          if (line_idx < lines.length) {
            const line = _M0MPC15array5Array2atGUssEE(lines, line_idx);
            const raw_ranges = _M0MP410Haoxincode8moonbash3lib5regex11GrepMatcher9find__all(matcher, line);
            const word_ranges = _M0FP410Haoxincode8moonbash3lib11interpreter20filter__word__ranges(raw_ranges, line, word_match);
            const ranges = _M0FP410Haoxincode8moonbash3lib11interpreter27filter__whole__line__ranges(word_ranges, line, whole_line);
            const has_match = ranges.length > 0;
            const selected = invert ? !has_match : has_match;
            _M0MPC15array5Array4pushGRPB5ArrayGsEE(line_matches, ranges);
            _M0MPC15array5Array4pushGbE(selected_lines, selected);
            if (selected) {
              selected_count = selected_count + 1 | 0;
            }
            _tmp$39 = line_idx + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        if (selected_count > 0) {
          total_selected = total_selected + selected_count | 0;
        }
        if (quiet && selected_count > 0) {
          self.exit_code = 0;
          return undefined;
        }
        if (list_files_only || list_files_without_match) {
          const should_list = list_files_without_match ? selected_count === 0 : selected_count > 0;
          if (should_list) {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${target.display_path}\n`);
            listed_file_count = listed_file_count + 1 | 0;
          }
          break _L$2;
        }
        if (count_only) {
          if (show_filename) {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${target.display_path}:${_M0MPC13int3Int18to__string_2einner(selected_count, 10)}\n`);
          } else {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_M0MPC13int3Int18to__string_2einner(selected_count, 10)}\n`);
          }
          break _L$2;
        }
        if (only_matching) {
          let _tmp$40 = 0;
          while (true) {
            const line_idx = _tmp$40;
            if (line_idx < lines.length) {
              _L$3: {
                if (!_M0MPC15array5Array2atGbE(selected_lines, line_idx) || invert) {
                  break _L$3;
                }
                const line = _M0MPC15array5Array2atGUssEE(lines, line_idx);
                const _bind$5 = _M0MPC15array5Array2atGRPB5ArrayGsEE(line_matches, line_idx);
                const _bind$6 = _bind$5.length;
                let _tmp$41 = 0;
                while (true) {
                  const _$2 = _tmp$41;
                  if (_$2 < _bind$6) {
                    const range = _bind$5[_$2];
                    _L$4: {
                      if (range._1 <= range._0) {
                        break _L$4;
                      }
                      const prefix = _M0FP410Haoxincode8moonbash3lib11interpreter20grep__output__prefix(target.display_path, line_idx + 1 | 0, show_filename, line_number);
                      const matched = _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(line, range._0, range._1);
                      _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${prefix}${matched}\n`);
                      break _L$4;
                    }
                    _tmp$41 = _$2 + 1 | 0;
                    continue;
                  } else {
                    break;
                  }
                }
                break _L$3;
              }
              _tmp$40 = line_idx + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          break _L$2;
        }
        let print_mask = selected_lines;
        if (before_context > 0 || after_context > 0) {
          const _p$4 = lines.length;
          let _tmp$40;
          if (_p$4 <= 0) {
            _tmp$40 = [];
          } else {
            const _p$5 = new Array(_p$4);
            let _tmp$41 = 0;
            while (true) {
              const _p$6 = _tmp$41;
              if (_p$6 < _p$4) {
                _p$5[_p$6] = false;
                _tmp$41 = _p$6 + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            _tmp$40 = _p$5;
          }
          print_mask = _tmp$40;
          let _tmp$41 = 0;
          while (true) {
            const line_idx = _tmp$41;
            if (line_idx < lines.length) {
              if (_M0MPC15array5Array2atGbE(selected_lines, line_idx)) {
                const start = (line_idx - before_context | 0) < 0 ? 0 : line_idx - before_context | 0;
                const end = (line_idx + after_context | 0) >= lines.length ? lines.length - 1 | 0 : line_idx + after_context | 0;
                let _tmp$42 = start;
                while (true) {
                  const j = _tmp$42;
                  if (j <= end) {
                    _M0MPC15array5Array3setGbE(print_mask, j, true);
                    _tmp$42 = j + 1 | 0;
                    continue;
                  } else {
                    break;
                  }
                }
              }
              _tmp$41 = line_idx + 1 | 0;
              continue;
            } else {
              break;
            }
          }
        }
        let _tmp$40 = 0;
        while (true) {
          const line_idx = _tmp$40;
          if (line_idx < lines.length) {
            _L$3: {
              if (!_M0MPC15array5Array2atGbE(print_mask, line_idx)) {
                break _L$3;
              }
              const prefix = _M0FP410Haoxincode8moonbash3lib11interpreter20grep__output__prefix(target.display_path, line_idx + 1 | 0, show_filename, line_number);
              _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${prefix}${_M0MPC15array5Array2atGUssEE(lines, line_idx)}\n`);
              break _L$3;
            }
            _tmp$40 = line_idx + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        break _L$2;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (had_io_error) {
    self.exit_code = 2;
    return;
  } else {
    if (list_files_only || list_files_without_match) {
      self.exit_code = listed_file_count > 0 ? 0 : 1;
      return;
    } else {
      self.exit_code = total_selected > 0 ? 0 : 1;
      return;
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__hash(self, args) {
  if (args.length === 0) {
    const values = [];
    const _it = _M0MPB3Map5iter2GssE(self.env);
    while (true) {
      const _bind$4 = _M0MPB5Iter24nextGssE(_it);
      if (_bind$4 === undefined) {
        break;
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        const _key = _x._0;
        const _value = _x._1;
        if (_M0MPC16string6String11has__prefix(_key, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib11interpreter21hash__storage__prefix, 0, _M0FP410Haoxincode8moonbash3lib11interpreter21hash__storage__prefix.length))) {
          _M0MPC15array5Array4pushGUssEE(values, _value);
        }
        continue;
      }
    }
    _M0FP410Haoxincode8moonbash3lib11interpreter25completion__sort__strings(values);
    const _bind$4 = values.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$4) {
        const value = values[_];
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${value}\n`);
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    self.exit_code = 0;
    return undefined;
  }
  if (_M0MPC15array5Array2atGUssEE(args, 0) === "-r") {
    if (args.length > 1) {
      self.exit_code = 1;
      return undefined;
    }
    const remove_keys = [];
    const _it = _M0MPB3Map5iter2GssE(self.env);
    while (true) {
      const _bind$4 = _M0MPB5Iter24nextGssE(_it);
      if (_bind$4 === undefined) {
        break;
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        const _key = _x._0;
        if (_M0MPC16string6String11has__prefix(_key, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib11interpreter21hash__storage__prefix, 0, _M0FP410Haoxincode8moonbash3lib11interpreter21hash__storage__prefix.length))) {
          _M0MPC15array5Array4pushGUssEE(remove_keys, _key);
        }
        continue;
      }
    }
    const _bind$4 = remove_keys.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$4) {
        const key = remove_keys[_];
        _M0MPB3Map6removeGssE(self.env, key);
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    self.exit_code = 0;
    return undefined;
  }
  let all_found = true;
  const _bind$4 = args.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const name = args[_];
      _L: {
        _L$2: {
          if (_M0FP410Haoxincode8moonbash3lib11interpreter18is__shell__builtin(name)) {
            break _L$2;
          } else {
            if (_M0MPB3Map8containsGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self.functions, name)) {
              break _L$2;
            } else {
              const _bind$5 = _M0FP410Haoxincode8moonbash3lib8commands13find__command(name);
              if (_bind$5 === undefined) {
                all_found = false;
              } else {
                break _L$2;
              }
            }
          }
          break _L;
        }
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25remember__hashed__command(self, name);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = all_found ? 0 : 1;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__help(self, _args) {
  _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__helpN4textS833);
  self.exit_code = 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__history(self, _args) {
  self.exit_code = 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17builtin__hostname(self, _args) {
  const _tmp$38 = self.stdout_buf;
  const _p$4 = _M0MPB3Map3getGssE(self.env, "HOSTNAME");
  const _p$5 = "moon-bash";
  let _tmp$39;
  if (_p$4 === undefined) {
    _tmp$39 = _p$5;
  } else {
    const _p$6 = _p$4;
    _tmp$39 = _p$6;
  }
  _M0IPB13StringBuilderPB6Logger13write__string(_tmp$38, `${_tmp$39}\n`);
  self.exit_code = 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter16compare__strings(a, b) {
  const min_len = a.length < b.length ? a.length : b.length;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < min_len) {
      $bound_check(a, i);
      const _tmp$39 = a.charCodeAt(i);
      $bound_check(b, i);
      if (_M0IP016_24default__implPB7Compare6op__ltGkE(_tmp$39, b.charCodeAt(i))) {
        return -1;
      }
      $bound_check(a, i);
      const _tmp$40 = a.charCodeAt(i);
      $bound_check(b, i);
      if (_M0IP016_24default__implPB7Compare6op__gtGkE(_tmp$40, b.charCodeAt(i))) {
        return 1;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return a.length < b.length ? -1 : a.length > b.length ? 1 : 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter18join__field__value(fields, index) {
  return index >= 0 && index < fields.length ? _M0MPC15array5Array2atGUssEE(fields, index) : "";
}
function _M0FP410Haoxincode8moonbash3lib11interpreter28join__parts__with__delimiter(parts, delimiter) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < parts.length) {
      if (i > 0) {
        _M0IPB13StringBuilderPB6Logger13write__string(out, delimiter);
      }
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MPC15array5Array2atGUssEE(parts, i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter18format__join__line(fields1, fields2, join_idx1, join_idx2, delimiter) {
  const parts = [];
  _M0MPC15array5Array4pushGUssEE(parts, _M0FP410Haoxincode8moonbash3lib11interpreter18join__field__value(fields1, join_idx1));
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < fields1.length) {
      if (i !== join_idx1) {
        _M0MPC15array5Array4pushGUssEE(parts, _M0MPC15array5Array2atGUssEE(fields1, i));
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < fields2.length) {
      if (i !== join_idx2) {
        _M0MPC15array5Array4pushGUssEE(parts, _M0MPC15array5Array2atGUssEE(fields2, i));
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return _M0FP410Haoxincode8moonbash3lib11interpreter28join__parts__with__delimiter(parts, delimiter);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter19split__join__fields(line, delimiter) {
  return delimiter === " " ? _M0FP410Haoxincode8moonbash3lib11interpreter21split__by__whitespace(line) : _M0FP410Haoxincode8moonbash3lib11interpreter28split__string__by__delimiter(line, delimiter);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__joinN16read__join__fileS1214(self, path) {
  let resolved;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, path);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        resolved = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    resolved = path;
  }
  let _try_err$2;
  _L$2: {
    const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(self.fs, resolved);
    if (_bind$4.$tag === 1) {
      const _ok = _bind$4;
      return _ok._0;
    } else {
      const _err = _bind$4;
      _try_err$2 = _err._0;
      break _L$2;
    }
  }
  const _FsError = _try_err$2;
  const _msg = _FsError._0;
  _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `join: ${_msg}\n`);
  self.exit_code = 1;
  return "";
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__joinN20should__emit__unpairS1229(_env, source) {
  const include_unpair_2 = _env._2;
  const include_unpair_1 = _env._1;
  const only_unpair_file = _env._0;
  const _bind$4 = only_unpair_file.val;
  if (_bind$4 === undefined) {
    return source === 1 ? include_unpair_1.val : include_unpair_2.val;
  } else {
    const _Some = _bind$4;
    const _side = _Some;
    return _side === source;
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__join(self, args) {
  let field1 = 1;
  let field2 = 1;
  let delimiter = " ";
  const include_unpair_1 = new _M0TPB8MutLocalGbE(false);
  const include_unpair_2 = new _M0TPB8MutLocalGbE(false);
  const only_unpair_file = new _M0TPB8MutLocalGOiE(undefined);
  const files = [];
  let i = 0;
  while (true) {
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      if (arg === "-1" && (i + 1 | 0) < args.length) {
        field1 = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(args, i + 1 | 0));
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__joinN7_2abindS7341, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__joinN7_2abindS7341.length)) && arg.length > 2) {
        field1 = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined)));
        i = i + 1 | 0;
        continue;
      }
      if (arg === "-2" && (i + 1 | 0) < args.length) {
        field2 = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(args, i + 1 | 0));
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__joinN7_2abindS7342, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__joinN7_2abindS7342.length)) && arg.length > 2) {
        field2 = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined)));
        i = i + 1 | 0;
        continue;
      }
      if (arg === "-t" && (i + 1 | 0) < args.length) {
        delimiter = _M0MPC15array5Array2atGUssEE(args, i + 1 | 0);
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__joinN7_2abindS7343, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__joinN7_2abindS7343.length)) && arg.length > 2) {
        delimiter = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined));
        i = i + 1 | 0;
        continue;
      }
      if (arg === "-a" && (i + 1 | 0) < args.length) {
        const side = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(args, i + 1 | 0));
        if (side === 1) {
          include_unpair_1.val = true;
        } else {
          if (side === 2) {
            include_unpair_2.val = true;
          }
        }
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__joinN7_2abindS7344, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__joinN7_2abindS7344.length)) && arg.length > 2) {
        const side = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined)));
        if (side === 1) {
          include_unpair_1.val = true;
        } else {
          if (side === 2) {
            include_unpair_2.val = true;
          }
        }
        i = i + 1 | 0;
        continue;
      }
      if (arg === "-v" && (i + 1 | 0) < args.length) {
        const side = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(args, i + 1 | 0));
        if (side === 1 || side === 2) {
          only_unpair_file.val = side;
        }
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__joinN7_2abindS7345, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__joinN7_2abindS7345.length)) && arg.length > 2) {
        const side = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined)));
        if (side === 1 || side === 2) {
          only_unpair_file.val = side;
        }
        i = i + 1 | 0;
        continue;
      }
      _M0MPC15array5Array4pushGUssEE(files, arg);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (files.length < 2) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "join: missing operand\n");
    self.exit_code = 1;
    return undefined;
  }
  const content1 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__joinN16read__join__fileS1214(self, _M0MPC15array5Array2atGUssEE(files, 0));
  if (self.exit_code !== 0) {
    return undefined;
  }
  const content2 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__joinN16read__join__fileS1214(self, _M0MPC15array5Array2atGUssEE(files, 1));
  if (self.exit_code !== 0) {
    return undefined;
  }
  const lines1 = _M0FP410Haoxincode8moonbash3lib11interpreter26split__lines__no__trailing(content1);
  const lines2 = _M0FP410Haoxincode8moonbash3lib11interpreter26split__lines__no__trailing(content2);
  const rows1 = [];
  const rows2 = [];
  const _bind$4 = lines1.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const line = lines1[_];
      _M0MPC15array5Array4pushGRPB5ArrayGsEE(rows1, _M0FP410Haoxincode8moonbash3lib11interpreter19split__join__fields(line, delimiter));
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$5 = lines2.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$5) {
      const line = lines2[_];
      _M0MPC15array5Array4pushGRPB5ArrayGsEE(rows2, _M0FP410Haoxincode8moonbash3lib11interpreter19split__join__fields(line, delimiter));
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const join_idx1 = field1 > 0 ? field1 - 1 | 0 : 0;
  const join_idx2 = field2 > 0 ? field2 - 1 | 0 : 0;
  let idx1 = 0;
  let idx2 = 0;
  const _env = { _0: only_unpair_file, _1: include_unpair_1, _2: include_unpair_2 };
  while (true) {
    if (idx1 < rows1.length && idx2 < rows2.length) {
      const key1 = _M0FP410Haoxincode8moonbash3lib11interpreter18join__field__value(_M0MPC15array5Array2atGRPB5ArrayGsEE(rows1, idx1), join_idx1);
      const key2 = _M0FP410Haoxincode8moonbash3lib11interpreter18join__field__value(_M0MPC15array5Array2atGRPB5ArrayGsEE(rows2, idx2), join_idx2);
      const cmp = _M0FP410Haoxincode8moonbash3lib11interpreter16compare__strings(key1, key2);
      if (cmp === 0) {
        const _bind$6 = only_unpair_file.val;
        if (_bind$6 === undefined) {
          const line = _M0FP410Haoxincode8moonbash3lib11interpreter18format__join__line(_M0MPC15array5Array2atGRPB5ArrayGsEE(rows1, idx1), _M0MPC15array5Array2atGRPB5ArrayGsEE(rows2, idx2), join_idx1, join_idx2, delimiter);
          _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${line}\n`);
        }
        idx1 = idx1 + 1 | 0;
        idx2 = idx2 + 1 | 0;
      } else {
        if (cmp < 0) {
          if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__joinN20should__emit__unpairS1229(_env, 1)) {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_M0MPC15array5Array2atGUssEE(lines1, idx1)}\n`);
          }
          idx1 = idx1 + 1 | 0;
        } else {
          if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__joinN20should__emit__unpairS1229(_env, 2)) {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_M0MPC15array5Array2atGUssEE(lines2, idx2)}\n`);
          }
          idx2 = idx2 + 1 | 0;
        }
      }
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (idx1 < rows1.length) {
      if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__joinN20should__emit__unpairS1229(_env, 1)) {
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_M0MPC15array5Array2atGUssEE(lines1, idx1)}\n`);
      }
      idx1 = idx1 + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (idx2 < rows2.length) {
      if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__joinN20should__emit__unpairS1229(_env, 2)) {
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_M0MPC15array5Array2atGUssEE(lines2, idx2)}\n`);
      }
      idx2 = idx2 + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter21mapfile__split__lines(input, strip_newline) {
  const lines = [];
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < input.length) {
      $bound_check(input, i);
      const ch = input.charCodeAt(i);
      if (ch === 10) {
        const line = strip_newline ? buf.val : `${buf.val}\n`;
        _M0MPC15array5Array4pushGUssEE(lines, line);
        _M0MPB13StringBuilder5reset(buf);
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const remaining = buf.val;
  if (remaining.length > 0) {
    _M0MPC15array5Array4pushGUssEE(lines, remaining);
  }
  return lines;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter21mapfile__starts__with(s, prefix) {
  if (prefix.length > s.length) {
    return false;
  }
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < prefix.length) {
      $bound_check(s, i);
      const _p$4 = s.charCodeAt(i);
      $bound_check(prefix, i);
      const _p$5 = prefix.charCodeAt(i);
      if (_p$4 !== _p$5) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__mapfile(self, args) {
  let strip_newline = false;
  let array_name = "MAPFILE";
  let i = 0;
  while (true) {
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      if (arg === "-t") {
        strip_newline = true;
        i = i + 1 | 0;
        continue;
      }
      let _tmp$38;
      if (arg.length > 0) {
        $bound_check(arg, 0);
        _tmp$38 = arg.charCodeAt(0) === 45;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        i = i + 1 | 0;
        continue;
      }
      array_name = arg;
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const lines = _M0FP410Haoxincode8moonbash3lib11interpreter21mapfile__split__lines(self.stdin_buf, strip_newline);
  if (lines.length > self.limits.max_array_elements) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "mapfile: array element limit exceeded\n");
    self.exit_code = 1;
    return undefined;
  }
  const remove_keys = [];
  const index_prefix = `${array_name}[`;
  const _p$4 = array_name;
  const count_key = `__MOON_BASH_ARRAY_COUNT__${_p$4}`;
  const _it = _M0MPB3Map5iter2GssE(self.env);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _key = _x._0;
      if (_key === count_key || _M0FP410Haoxincode8moonbash3lib11interpreter21mapfile__starts__with(_key, index_prefix)) {
        _M0MPC15array5Array4pushGUssEE(remove_keys, _key);
      }
      continue;
    }
  }
  const _bind$4 = remove_keys.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const key = remove_keys[_];
      _M0MPB3Map6removeGssE(self.env, key);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const joined = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$39 = 0;
  while (true) {
    const idx = _tmp$39;
    if (idx < lines.length) {
      const value = _M0MPC15array5Array2atGUssEE(lines, idx);
      _M0MPB3Map3setGssE(self.env, `${array_name}[${_M0MPC13int3Int18to__string_2einner(idx, 10)}]`, value);
      if (idx > 0) {
        _M0IPB13StringBuilderPB6Logger11write__char(joined, 32);
      }
      _M0IPB13StringBuilderPB6Logger13write__string(joined, value);
      _tmp$39 = idx + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MPB3Map3setGssE(self.env, `${array_name}[@]`, joined.val);
  _M0MPB3Map3setGssE(self.env, `${array_name}[*]`, joined.val);
  _M0MPB3Map3setGssE(self.env, count_key, _M0MPC13int3Int18to__string_2einner(lines.length, 10));
  self.exit_code = 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter18format__nl__number(number, width, number_format) {
  const text = _M0MPC13int3Int18to__string_2einner(number, 10);
  const padding = width - text.length | 0;
  if (padding <= 0) {
    return text;
  }
  switch (number_format) {
    case "ln": {
      return `${text}${_M0FP410Haoxincode8moonbash3lib11interpreter12repeat__char(32, padding)}`;
    }
    case "rz": {
      return `${_M0FP410Haoxincode8moonbash3lib11interpreter12repeat__char(48, padding)}${text}`;
    }
    default: {
      return `${_M0FP410Haoxincode8moonbash3lib11interpreter12repeat__char(32, padding)}${text}`;
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__nl(self, args) {
  let number_all = false;
  let number_format = "rn";
  let width = 6;
  let separator = "\t";
  let current_number = 1;
  let increment = 1;
  const files = [];
  let i = 0;
  while (true) {
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      if (arg === "-b" && (i + 1 | 0) < args.length) {
        const style = _M0MPC15array5Array2atGUssEE(args, i + 1 | 0);
        number_all = style === "a";
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__nlN7_2abindS7404, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__nlN7_2abindS7404.length)) && arg.length > 2) {
        const style = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined));
        number_all = style === "a";
        i = i + 1 | 0;
        continue;
      }
      if (arg === "-n" && (i + 1 | 0) < args.length) {
        number_format = _M0MPC15array5Array2atGUssEE(args, i + 1 | 0);
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__nlN7_2abindS7405, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__nlN7_2abindS7405.length)) && arg.length > 2) {
        number_format = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined));
        i = i + 1 | 0;
        continue;
      }
      if (arg === "-w" && (i + 1 | 0) < args.length) {
        width = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(args, i + 1 | 0));
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__nlN7_2abindS7406, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__nlN7_2abindS7406.length)) && arg.length > 2) {
        width = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined)));
        i = i + 1 | 0;
        continue;
      }
      if (arg === "-s" && (i + 1 | 0) < args.length) {
        separator = _M0MPC15array5Array2atGUssEE(args, i + 1 | 0);
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__nlN7_2abindS7407, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__nlN7_2abindS7407.length)) && arg.length > 2) {
        separator = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined));
        i = i + 1 | 0;
        continue;
      }
      if (arg === "-v" && (i + 1 | 0) < args.length) {
        current_number = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(args, i + 1 | 0));
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__nlN7_2abindS7408, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__nlN7_2abindS7408.length)) && arg.length > 2) {
        current_number = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined)));
        i = i + 1 | 0;
        continue;
      }
      if (arg === "-i" && (i + 1 | 0) < args.length) {
        increment = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(args, i + 1 | 0));
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__nlN7_2abindS7409, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__nlN7_2abindS7409.length)) && arg.length > 2) {
        increment = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined)));
        i = i + 1 | 0;
        continue;
      }
      _M0MPC15array5Array4pushGUssEE(files, arg);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (width < 0) {
    width = 0;
  }
  const inputs = [];
  if (files.length === 0) {
    _M0MPC15array5Array4pushGUssEE(inputs, self.stdin_buf);
  } else {
    const _bind$4 = files.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$4) {
        const path = files[_];
        let resolved;
        let _try_err;
        _L: {
          _L$2: {
            const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, path);
            if (_bind$5.$tag === 1) {
              const _ok = _bind$5;
              resolved = _ok._0;
            } else {
              const _err = _bind$5;
              _try_err = _err._0;
              break _L$2;
            }
            break _L;
          }
          resolved = path;
        }
        let content;
        let _try_err$2;
        _L$2: {
          _L$3: {
            const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(self.fs, resolved);
            if (_bind$5.$tag === 1) {
              const _ok = _bind$5;
              content = _ok._0;
            } else {
              const _err = _bind$5;
              _try_err$2 = _err._0;
              break _L$3;
            }
            break _L$2;
          }
          const _FsError = _try_err$2;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `nl: ${_msg}\n`);
          self.exit_code = 1;
          return undefined;
        }
        _M0MPC15array5Array4pushGUssEE(inputs, content);
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  const _bind$4 = inputs.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const input = inputs[_];
      const lines = _M0FP410Haoxincode8moonbash3lib11interpreter26split__lines__no__trailing(input);
      const _bind$5 = lines.length;
      let _tmp$39 = 0;
      while (true) {
        const _$2 = _tmp$39;
        if (_$2 < _bind$5) {
          const line = lines[_$2];
          const should_number = number_all || line.length > 0;
          if (should_number) {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0FP410Haoxincode8moonbash3lib11interpreter18format__nl__number(current_number, width, number_format));
            current_number = current_number + increment | 0;
          } else {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0FP410Haoxincode8moonbash3lib11interpreter12repeat__char(32, width));
          }
          _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, separator);
          _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, line);
          _M0IPB13StringBuilderPB6Logger11write__char(self.stdout_buf, 10);
          _tmp$39 = _$2 + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter16od__format__char(b) {
  switch (b) {
    case 0: {
      return "  \\0";
    }
    case 7: {
      return "  \\a";
    }
    case 8: {
      return "  \\b";
    }
    case 9: {
      return "  \\t";
    }
    case 10: {
      return "  \\n";
    }
    case 11: {
      return "  \\v";
    }
    case 12: {
      return "  \\f";
    }
    case 13: {
      return "  \\r";
    }
    default: {
      if (b >= 32 && b <= 126) {
        const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
        _M0IPB13StringBuilderPB6Logger13write__string(buf, "   ");
        _M0IPB13StringBuilderPB6Logger11write__char(buf, b);
        return buf.val;
      } else {
        const d2 = b / 64 | 0;
        const d1 = (b % 64 | 0) / 8 | 0;
        const d0 = b % 8 | 0;
        const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
        _M0IPB13StringBuilderPB6Logger11write__char(buf, 32);
        _M0IPB13StringBuilderPB6Logger11write__char(buf, d2 + 48 | 0);
        _M0IPB13StringBuilderPB6Logger11write__char(buf, d1 + 48 | 0);
        _M0IPB13StringBuilderPB6Logger11write__char(buf, d0 + 48 | 0);
        return buf.val;
      }
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter16od__format__hex2(n) {
  const hi = (n / 16 | 0) % 16 | 0;
  const lo = n % 16 | 0;
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  $bound_check(_M0FP410Haoxincode8moonbash3lib11interpreter16od__format__hex2N3hexS755, hi);
  _M0IPB13StringBuilderPB6Logger11write__char(out, _M0FP410Haoxincode8moonbash3lib11interpreter16od__format__hex2N3hexS755.charCodeAt(hi));
  $bound_check(_M0FP410Haoxincode8moonbash3lib11interpreter16od__format__hex2N3hexS755, lo);
  _M0IPB13StringBuilderPB6Logger11write__char(out, _M0FP410Haoxincode8moonbash3lib11interpreter16od__format__hex2N3hexS755.charCodeAt(lo));
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter16od__format__hex4(n) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _tmp$38 = n >> 12 & 15;
  $bound_check(_M0FP410Haoxincode8moonbash3lib11interpreter16od__format__hex4N10hex__charsS760, _tmp$38);
  _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0FP410Haoxincode8moonbash3lib11interpreter16od__format__hex4N10hex__charsS760.charCodeAt(_tmp$38));
  const _tmp$39 = n >> 8 & 15;
  $bound_check(_M0FP410Haoxincode8moonbash3lib11interpreter16od__format__hex4N10hex__charsS760, _tmp$39);
  _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0FP410Haoxincode8moonbash3lib11interpreter16od__format__hex4N10hex__charsS760.charCodeAt(_tmp$39));
  const _tmp$40 = n >> 4 & 15;
  $bound_check(_M0FP410Haoxincode8moonbash3lib11interpreter16od__format__hex4N10hex__charsS760, _tmp$40);
  _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0FP410Haoxincode8moonbash3lib11interpreter16od__format__hex4N10hex__charsS760.charCodeAt(_tmp$40));
  const _tmp$41 = n & 15;
  $bound_check(_M0FP410Haoxincode8moonbash3lib11interpreter16od__format__hex4N10hex__charsS760, _tmp$41);
  _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0FP410Haoxincode8moonbash3lib11interpreter16od__format__hex4N10hex__charsS760.charCodeAt(_tmp$41));
  return buf.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter21od__format__hex__addr(n) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let val = n;
  const digits = [];
  if (val === 0) {
    let _tmp$38 = 0;
    while (true) {
      const j = _tmp$38;
      if (j < 6) {
        _M0MPC15array5Array4pushGcE(digits, 48);
        _tmp$38 = j + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  } else {
    while (true) {
      if (val > 0) {
        const _tmp$38 = val % 16 | 0;
        $bound_check(_M0FP410Haoxincode8moonbash3lib11interpreter21od__format__hex__addrN10hex__charsS772, _tmp$38);
        _M0MPC15array5Array4pushGcE(digits, _M0FP410Haoxincode8moonbash3lib11interpreter21od__format__hex__addrN10hex__charsS772.charCodeAt(_tmp$38));
        val = val / 16 | 0;
        continue;
      } else {
        break;
      }
    }
    while (true) {
      if (digits.length < 6) {
        _M0MPC15array5Array4pushGcE(digits, 48);
        continue;
      } else {
        break;
      }
    }
  }
  let i = digits.length - 1 | 0;
  while (true) {
    if (i >= 0) {
      _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MPC15array5Array2atGcE(digits, i));
      i = i - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter18od__format__octal6(n) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let val = n;
  const digits = [];
  if (val === 0) {
    let _tmp$38 = 0;
    while (true) {
      const j = _tmp$38;
      if (j < 6) {
        _M0MPC15array5Array4pushGcE(digits, 48);
        _tmp$38 = j + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  } else {
    while (true) {
      if (val > 0) {
        _M0MPC15array5Array4pushGcE(digits, (val % 8 | 0) + 48 | 0);
        val = val / 8 | 0;
        continue;
      } else {
        break;
      }
    }
    while (true) {
      if (digits.length < 6) {
        _M0MPC15array5Array4pushGcE(digits, 48);
        continue;
      } else {
        break;
      }
    }
  }
  let i = digits.length - 1 | 0;
  while (true) {
    if (i >= 0) {
      _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MPC15array5Array2atGcE(digits, i));
      i = i - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter23od__format__octal__addr(n) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let val = n;
  const digits = [];
  if (val === 0) {
    let _tmp$38 = 0;
    while (true) {
      const j = _tmp$38;
      if (j < 7) {
        _M0MPC15array5Array4pushGcE(digits, 48);
        _tmp$38 = j + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  } else {
    while (true) {
      if (val > 0) {
        _M0MPC15array5Array4pushGcE(digits, (val % 8 | 0) + 48 | 0);
        val = val / 8 | 0;
        continue;
      } else {
        break;
      }
    }
    while (true) {
      if (digits.length < 7) {
        _M0MPC15array5Array4pushGcE(digits, 48);
        continue;
      } else {
        break;
      }
    }
  }
  let i = digits.length - 1 | 0;
  while (true) {
    if (i >= 0) {
      _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0MPC15array5Array2atGcE(digits, i));
      i = i - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__od(self, args) {
  let char_mode = false;
  let hex_byte_mode = false;
  let hex_word_mode = false;
  let hex_address = false;
  let no_address = false;
  let input_file = undefined;
  let i = 0;
  while (true) {
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      if (arg === "-c") {
        char_mode = true;
        i = i + 1 | 0;
      } else {
        if (arg === "-x") {
          hex_word_mode = true;
          i = i + 1 | 0;
        } else {
          if (arg === "-t" && (i + 1 | 0) < args.length) {
            const fmt = _M0MPC15array5Array2atGUssEE(args, i + 1 | 0);
            if (fmt === "c") {
              char_mode = true;
            } else {
              if (fmt === "x1") {
                hex_byte_mode = true;
              } else {
                if (fmt === "x2") {
                  hex_word_mode = true;
                }
              }
            }
            i = i + 2 | 0;
          } else {
            if (arg === "-A" && (i + 1 | 0) < args.length) {
              const fmt = _M0MPC15array5Array2atGUssEE(args, i + 1 | 0);
              if (fmt === "x") {
                hex_address = true;
                no_address = false;
              } else {
                if (fmt === "n") {
                  no_address = true;
                }
              }
              i = i + 2 | 0;
            } else {
              if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__odN7_2abindS7455, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__odN7_2abindS7455.length)) && arg.length > 2) {
                const fmt = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined));
                if (fmt === "x") {
                  hex_address = true;
                  no_address = false;
                } else {
                  if (fmt === "n") {
                    no_address = true;
                  }
                }
                i = i + 1 | 0;
              } else {
                if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__odN7_2abindS7456, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__odN7_2abindS7456.length)) && arg.length > 2) {
                  const fmt = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined));
                  if (fmt === "c") {
                    char_mode = true;
                  } else {
                    if (fmt === "x1") {
                      hex_byte_mode = true;
                    } else {
                      if (fmt === "x2") {
                        hex_word_mode = true;
                      }
                    }
                  }
                  i = i + 1 | 0;
                } else {
                  input_file = arg;
                  i = i + 1 | 0;
                }
              }
            }
          }
        }
      }
      continue;
    } else {
      break;
    }
  }
  const _bind$4 = input_file;
  let input;
  if (_bind$4 === undefined) {
    input = self.stdin_buf;
  } else {
    const _Some = _bind$4;
    const _path = _Some;
    let resolved;
    let _try_err;
    _L: {
      _L$2: {
        const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, _path);
        if (_bind$5.$tag === 1) {
          const _ok = _bind$5;
          resolved = _ok._0;
        } else {
          const _err = _bind$5;
          _try_err = _err._0;
          break _L$2;
        }
        break _L;
      }
      resolved = _path;
    }
    let _try_err$2;
    _L$2: {
      _L$3: {
        const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(self.fs, resolved);
        if (_bind$5.$tag === 1) {
          const _ok = _bind$5;
          input = _ok._0;
        } else {
          const _err = _bind$5;
          _try_err$2 = _err._0;
          break _L$3;
        }
        break _L$2;
      }
      const _FsError = _try_err$2;
      const _msg = _FsError._0;
      _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `od: ${_msg}\n`);
      self.exit_code = 1;
      return undefined;
    }
  }
  const bytes = [];
  let _tmp$38 = 0;
  while (true) {
    const j = _tmp$38;
    if (j < input.length) {
      $bound_check(input, j);
      _M0MPC15array5Array4pushGiE(bytes, input.charCodeAt(j) & 255);
      _tmp$38 = j + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const total = bytes.length;
  const emit_default_octal = !char_mode && (!hex_byte_mode && !hex_word_mode);
  let offset = 0;
  while (true) {
    if (offset < total) {
      const line_end = (offset + 16 | 0) <= total ? offset + 16 | 0 : total;
      if (char_mode) {
        if (!no_address) {
          if (hex_address) {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0FP410Haoxincode8moonbash3lib11interpreter21od__format__hex__addr(offset));
          } else {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0FP410Haoxincode8moonbash3lib11interpreter23od__format__octal__addr(offset));
          }
        }
        let j = offset;
        while (true) {
          if (j < line_end) {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0FP410Haoxincode8moonbash3lib11interpreter16od__format__char(_M0MPC15array5Array2atGiE(bytes, j)));
            j = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, "\n");
      }
      if (hex_byte_mode) {
        if (!no_address) {
          if (hex_address) {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0FP410Haoxincode8moonbash3lib11interpreter21od__format__hex__addr(offset));
          } else {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0FP410Haoxincode8moonbash3lib11interpreter23od__format__octal__addr(offset));
          }
        }
        let j = offset;
        while (true) {
          if (j < line_end) {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, "  ");
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0FP410Haoxincode8moonbash3lib11interpreter16od__format__hex2(_M0MPC15array5Array2atGiE(bytes, j)));
            j = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, "\n");
      }
      if (hex_word_mode) {
        if (!no_address) {
          if (hex_address) {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0FP410Haoxincode8moonbash3lib11interpreter21od__format__hex__addr(offset));
          } else {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0FP410Haoxincode8moonbash3lib11interpreter23od__format__octal__addr(offset));
          }
        }
        let j = offset;
        while (true) {
          if (j < line_end) {
            const lo = _M0MPC15array5Array2atGiE(bytes, j);
            const hi = (j + 1 | 0) < line_end ? _M0MPC15array5Array2atGiE(bytes, j + 1 | 0) : 0;
            const word = (Math.imul(hi, 256) | 0) + lo | 0;
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, " ");
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0FP410Haoxincode8moonbash3lib11interpreter16od__format__hex4(word));
            j = j + 2 | 0;
            continue;
          } else {
            break;
          }
        }
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, "\n");
      }
      if (emit_default_octal) {
        if (!no_address) {
          if (hex_address) {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0FP410Haoxincode8moonbash3lib11interpreter21od__format__hex__addr(offset));
          } else {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0FP410Haoxincode8moonbash3lib11interpreter23od__format__octal__addr(offset));
          }
        }
        let j = offset;
        while (true) {
          if (j < line_end) {
            const lo = _M0MPC15array5Array2atGiE(bytes, j);
            const hi = (j + 1 | 0) < line_end ? _M0MPC15array5Array2atGiE(bytes, j + 1 | 0) : 0;
            const word = (Math.imul(hi, 256) | 0) + lo | 0;
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, " ");
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0FP410Haoxincode8moonbash3lib11interpreter18od__format__octal6(word));
            j = j + 2 | 0;
            continue;
          } else {
            break;
          }
        }
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, "\n");
      }
      offset = line_end;
      continue;
    } else {
      break;
    }
  }
  if (!no_address) {
    if (hex_address) {
      _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0FP410Haoxincode8moonbash3lib11interpreter21od__format__hex__addr(total));
    } else {
      _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0FP410Haoxincode8moonbash3lib11interpreter23od__format__octal__addr(total));
    }
    _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, "\n");
  }
  self.exit_code = 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter24parse__paste__delimiters(spec) {
  const delimiters = [];
  let i = 0;
  while (true) {
    if (i < spec.length) {
      const _tmp$38 = i;
      $bound_check(spec, _tmp$38);
      const ch = spec.charCodeAt(_tmp$38);
      if (ch === 92 && (i + 1 | 0) < spec.length) {
        const _tmp$39 = i + 1 | 0;
        $bound_check(spec, _tmp$39);
        const next = spec.charCodeAt(_tmp$39);
        let mapped;
        switch (next) {
          case 116: {
            mapped = 9;
            break;
          }
          case 110: {
            mapped = 10;
            break;
          }
          case 48: {
            mapped = 0;
            break;
          }
          case 92: {
            mapped = 92;
            break;
          }
          default: {
            mapped = next;
          }
        }
        _M0MPC15array5Array4pushGcE(delimiters, mapped);
        i = i + 2 | 0;
      } else {
        _M0MPC15array5Array4pushGcE(delimiters, ch);
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  return delimiters;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__paste(self, args) {
  let serial_mode = false;
  let delimiter_spec = "\t";
  const sources = [];
  let i = 0;
  while (true) {
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      if (arg === "-s") {
        serial_mode = true;
        i = i + 1 | 0;
        continue;
      }
      if (arg === "-d" && (i + 1 | 0) < args.length) {
        delimiter_spec = _M0MPC15array5Array2atGUssEE(args, i + 1 | 0);
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__pasteN7_2abindS7484, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__pasteN7_2abindS7484.length)) && arg.length > 2) {
        delimiter_spec = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined));
        i = i + 1 | 0;
        continue;
      }
      let _tmp$38;
      if (arg.length > 1) {
        let _tmp$39;
        $bound_check(arg, 0);
        const _p$4 = arg.charCodeAt(0);
        const _p$5 = 45;
        if (_p$4 === _p$5) {
          const _p$6 = "-";
          _tmp$39 = !(arg === _p$6);
        } else {
          _tmp$39 = false;
        }
        _tmp$38 = _tmp$39;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        let _tmp$39 = 1;
        _L: while (true) {
          const j = _tmp$39;
          if (j < arg.length) {
            $bound_check(arg, j);
            const flag = arg.charCodeAt(j);
            switch (flag) {
              case 115: {
                serial_mode = true;
                break;
              }
              case 100: {
                if ((j + 1 | 0) < arg.length) {
                  delimiter_spec = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, j + 1 | 0, undefined));
                } else {
                  if ((i + 1 | 0) < args.length) {
                    i = i + 1 | 0;
                    delimiter_spec = _M0MPC15array5Array2atGUssEE(args, i);
                  } else {
                    delimiter_spec = "";
                  }
                }
                break _L;
              }
            }
            _tmp$39 = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        i = i + 1 | 0;
        continue;
      }
      _M0MPC15array5Array4pushGUssEE(sources, arg);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (sources.length === 0) {
    _M0MPC15array5Array4pushGUssEE(sources, "-");
  }
  const source_is_stdin = [];
  const source_lines = [];
  const _bind$4 = sources.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const source = sources[_];
      _L: {
        if (source === "-") {
          _M0MPC15array5Array4pushGbE(source_is_stdin, true);
          _M0MPC15array5Array4pushGRPB5ArrayGsEE(source_lines, []);
          break _L;
        }
        let resolved;
        let _try_err;
        _L$2: {
          _L$3: {
            const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, source);
            if (_bind$5.$tag === 1) {
              const _ok = _bind$5;
              resolved = _ok._0;
            } else {
              const _err = _bind$5;
              _try_err = _err._0;
              break _L$3;
            }
            break _L$2;
          }
          resolved = source;
        }
        let content;
        let _try_err$2;
        _L$3: {
          _L$4: {
            const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(self.fs, resolved);
            if (_bind$5.$tag === 1) {
              const _ok = _bind$5;
              content = _ok._0;
            } else {
              const _err = _bind$5;
              _try_err$2 = _err._0;
              break _L$4;
            }
            break _L$3;
          }
          const _FsError = _try_err$2;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `paste: ${_msg}\n`);
          self.exit_code = 1;
          return undefined;
        }
        _M0MPC15array5Array4pushGbE(source_is_stdin, false);
        _M0MPC15array5Array4pushGRPB5ArrayGsEE(source_lines, _M0FP410Haoxincode8moonbash3lib11interpreter26split__lines__no__trailing(content));
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const delimiters = _M0FP410Haoxincode8moonbash3lib11interpreter24parse__paste__delimiters(delimiter_spec);
  const stdin_lines = _M0FP410Haoxincode8moonbash3lib11interpreter26split__lines__no__trailing(self.stdin_buf);
  let stdin_cursor = 0;
  if (serial_mode) {
    let _tmp$39 = 0;
    while (true) {
      const source_idx = _tmp$39;
      if (source_idx < sources.length) {
        let lines;
        if (_M0MPC15array5Array2atGbE(source_is_stdin, source_idx)) {
          const remaining = [];
          let _tmp$40 = stdin_cursor;
          while (true) {
            const j = _tmp$40;
            if (j < stdin_lines.length) {
              _M0MPC15array5Array4pushGUssEE(remaining, _M0MPC15array5Array2atGUssEE(stdin_lines, j));
              _tmp$40 = j + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          stdin_cursor = stdin_lines.length;
          lines = remaining;
        } else {
          lines = _M0MPC15array5Array2atGRPB5ArrayGsEE(source_lines, source_idx);
        }
        let _tmp$40 = 0;
        while (true) {
          const line_idx = _tmp$40;
          if (line_idx < lines.length) {
            if (line_idx > 0 && delimiters.length > 0) {
              const delim = _M0MPC15array5Array2atGcE(delimiters, (line_idx - 1 | 0) % delimiters.length | 0);
              _M0IPB13StringBuilderPB6Logger11write__char(self.stdout_buf, delim);
            }
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0MPC15array5Array2atGUssEE(lines, line_idx));
            _tmp$40 = line_idx + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        _M0IPB13StringBuilderPB6Logger11write__char(self.stdout_buf, 10);
        _tmp$39 = source_idx + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    self.exit_code = 0;
    return undefined;
  }
  let row = 0;
  while (true) {
    const row_values = [];
    let row_has_data = false;
    let _tmp$39 = 0;
    while (true) {
      const source_idx = _tmp$39;
      if (source_idx < sources.length) {
        if (_M0MPC15array5Array2atGbE(source_is_stdin, source_idx)) {
          if (stdin_cursor < stdin_lines.length) {
            _M0MPC15array5Array4pushGUssEE(row_values, _M0MPC15array5Array2atGUssEE(stdin_lines, stdin_cursor));
            stdin_cursor = stdin_cursor + 1 | 0;
            row_has_data = true;
          } else {
            _M0MPC15array5Array4pushGUssEE(row_values, "");
          }
        } else {
          const lines = _M0MPC15array5Array2atGRPB5ArrayGsEE(source_lines, source_idx);
          if (row < lines.length) {
            _M0MPC15array5Array4pushGUssEE(row_values, _M0MPC15array5Array2atGUssEE(lines, row));
            row_has_data = true;
          } else {
            _M0MPC15array5Array4pushGUssEE(row_values, "");
          }
        }
        _tmp$39 = source_idx + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    if (!row_has_data) {
      break;
    }
    let _tmp$40 = 0;
    while (true) {
      const col_idx = _tmp$40;
      if (col_idx < row_values.length) {
        if (col_idx > 0 && delimiters.length > 0) {
          const delim = _M0MPC15array5Array2atGcE(delimiters, (col_idx - 1 | 0) % delimiters.length | 0);
          _M0IPB13StringBuilderPB6Logger11write__char(self.stdout_buf, delim);
        }
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0MPC15array5Array2atGUssEE(row_values, col_idx));
        _tmp$40 = col_idx + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    _M0IPB13StringBuilderPB6Logger11write__char(self.stdout_buf, 10);
    row = row + 1 | 0;
    continue;
  }
  self.exit_code = 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__popd(self, args) {
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33sync__directory__stack__with__cwd(self);
  let parse_flags = true;
  const operands = [];
  const _bind$4 = args.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const arg = args[_];
      _L: {
        if (parse_flags && arg === "--") {
          parse_flags = false;
          break _L;
        }
        let _tmp$39;
        if (parse_flags) {
          let _tmp$40;
          if (arg.length > 0) {
            $bound_check(arg, 0);
            _tmp$40 = arg.charCodeAt(0) === 45;
          } else {
            _tmp$40 = false;
          }
          _tmp$39 = _tmp$40;
        } else {
          _tmp$39 = false;
        }
        if (_tmp$39) {
          self.exit_code = 2;
          return undefined;
        }
        _M0MPC15array5Array4pushGUssEE(operands, arg);
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (operands.length > 0) {
    self.exit_code = 2;
    return undefined;
  }
  const stack = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21get__directory__stack(self);
  if (stack.length <= 1) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, "popd: directory stack empty\n");
    self.exit_code = 1;
    return undefined;
  }
  const old_pwd = self.cwd;
  const new_stack = [];
  let _tmp$39 = 1;
  while (true) {
    const i = _tmp$39;
    if (i < stack.length) {
      _M0MPC15array5Array4pushGUssEE(new_stack, _M0MPC15array5Array2atGUssEE(stack, i));
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.cwd = _M0MPC15array5Array2atGUssEE(new_stack, 0);
  _M0MPB3Map3setGssE(self.env, "PWD", self.cwd);
  _M0MPB3Map3setGssE(self.env, "OLDPWD", old_pwd);
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21set__directory__stack(self, new_stack);
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24render__directory__stack(self, new_stack, false, false, false);
  self.exit_code = 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17builtin__printenv(self, args) {
  if (args.length === 0) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__env(self, []);
    return undefined;
  }
  let all_found = true;
  const _bind$4 = args.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const name = args[_];
      const _bind$5 = _M0MPB3Map3getGssE(self.env, name);
      if (_bind$5 === undefined) {
        all_found = false;
      } else {
        const _Some = _bind$5;
        const _value = _Some;
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_value}\n`);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = all_found ? 0 : 1;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter20printf__repeat__char(ch, count) {
  if (count <= 0) {
    return "";
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < count) {
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter20printf__apply__width(value, width, left_justify, zero_pad) {
  if (width <= value.length) {
    return value;
  }
  const pad_len = width - value.length | 0;
  if (left_justify) {
    return `${value}${_M0FP410Haoxincode8moonbash3lib11interpreter20printf__repeat__char(32, pad_len)}`;
  }
  let _tmp$38;
  if (zero_pad) {
    let _tmp$39;
    if (value.length > 0) {
      $bound_check(value, 0);
      _tmp$39 = value.charCodeAt(0) === 45;
    } else {
      _tmp$39 = false;
    }
    _tmp$38 = _tmp$39;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    return `-${_M0FP410Haoxincode8moonbash3lib11interpreter20printf__repeat__char(48, pad_len)}${_M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(value, 1, value.length)}`;
  }
  const pad_ch = zero_pad ? 48 : 32;
  return `${_M0FP410Haoxincode8moonbash3lib11interpreter20printf__repeat__char(pad_ch, pad_len)}${value}`;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter23printf__format__decimal(value, precision) {
  const text = _M0MPC15int645Int6418to__string_2einner(value, 10);
  if (precision === undefined) {
    return text;
  } else {
    const _Some = precision;
    const _p$4 = _Some;
    if (_p$4 <= 0) {
      return text;
    }
    let negative;
    if (text.length > 0) {
      $bound_check(text, 0);
      negative = text.charCodeAt(0) === 45;
    } else {
      negative = false;
    }
    const digits = negative ? _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(text, 1, text.length) : text;
    if (digits.length >= _p$4) {
      return text;
    } else {
      const padded = `${_M0FP410Haoxincode8moonbash3lib11interpreter20printf__repeat__char(48, _p$4 - digits.length | 0)}${digits}`;
      return negative ? `-${padded}` : padded;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter18printf__all__zeros(s) {
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      if (s.charCodeAt(i) !== 48) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter25printf__increment__digits(digits) {
  if (digits.length === 0) {
    return "1";
  }
  const chars = [];
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < digits.length) {
      $bound_check(digits, i);
      _M0MPC15array5Array4pushGcE(chars, digits.charCodeAt(i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let carry = 1;
  let _tmp$39 = chars.length - 1 | 0;
  while (true) {
    const i = _tmp$39;
    if (i >= 0) {
      _L: {
        const ch = _M0MPC15array5Array2atGcE(chars, i);
        if (ch < 48 || ch > 57) {
          break _L;
        }
        const sum = (ch - 48 | 0) + carry | 0;
        if (sum >= 10) {
          _M0MPC15array5Array3setGcE(chars, i, 48);
          carry = 1;
        } else {
          _M0MPC15array5Array3setGcE(chars, i, sum + 48 | 0);
          carry = 0;
          break;
        }
        if (i === 0) {
          break;
        }
        break _L;
      }
      _tmp$39 = i - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  if (carry === 1) {
    _M0IPB13StringBuilderPB6Logger11write__char(out, 49);
  }
  const _bind$4 = chars.length;
  let _tmp$40 = 0;
  while (true) {
    const _ = _tmp$40;
    if (_ < _bind$4) {
      const ch = chars[_];
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      _tmp$40 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter27printf__increment__fraction(frac) {
  if (frac.length === 0) {
    return _M0FP410Haoxincode8moonbash3lib11interpreter27printf__increment__fractionN5tupleS11270;
  }
  const chars = [];
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < frac.length) {
      $bound_check(frac, i);
      _M0MPC15array5Array4pushGcE(chars, frac.charCodeAt(i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let carry = 1;
  let _tmp$39 = chars.length - 1 | 0;
  while (true) {
    const i = _tmp$39;
    if (i >= 0) {
      const sum = (_M0MPC15array5Array2atGcE(chars, i) - 48 | 0) + carry | 0;
      if (sum >= 10) {
        _M0MPC15array5Array3setGcE(chars, i, 48);
        carry = 1;
      } else {
        _M0MPC15array5Array3setGcE(chars, i, sum + 48 | 0);
        carry = 0;
        break;
      }
      if (i === 0) {
        break;
      }
      _tmp$39 = i - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _bind$4 = chars.length;
  let _tmp$40 = 0;
  while (true) {
    const _ = _tmp$40;
    if (_ < _bind$4) {
      const ch = chars[_];
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      _tmp$40 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return { _0: out.val, _1: carry === 1 };
}
function _M0FP410Haoxincode8moonbash3lib11interpreter21printf__format__float(raw, precision) {
  let i = 0;
  let negative = false;
  if (raw.length > 0) {
    $bound_check(raw, 0);
    const first = raw.charCodeAt(0);
    if (first === 45) {
      negative = true;
      i = 1;
    } else {
      if (first === 43) {
        i = 1;
      }
    }
  }
  const int_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const frac_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let in_frac = false;
  while (true) {
    if (i < raw.length) {
      const _tmp$38 = i;
      $bound_check(raw, _tmp$38);
      const ch = raw.charCodeAt(_tmp$38);
      if (ch === 46) {
        in_frac = true;
        i = i + 1 | 0;
        continue;
      }
      if (!(ch >= 48 && ch <= 57)) {
        break;
      }
      if (in_frac) {
        _M0IPB13StringBuilderPB6Logger11write__char(frac_buf, ch);
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(int_buf, ch);
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let int_part = int_buf.val;
  if (int_part.length === 0) {
    int_part = "0";
  }
  const frac_part = frac_buf.val;
  if (precision <= 0) {
    let rounded = int_part;
    let _tmp$38;
    if (frac_part.length > 0) {
      $bound_check(frac_part, 0);
      _tmp$38 = frac_part.charCodeAt(0) >= 53;
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      rounded = _M0FP410Haoxincode8moonbash3lib11interpreter25printf__increment__digits(rounded);
    }
    let _tmp$39;
    if (negative) {
      const _p$4 = rounded;
      const _p$5 = "0";
      _tmp$39 = !(_p$4 === _p$5);
    } else {
      _tmp$39 = false;
    }
    if (_tmp$39) {
      return `-${rounded}`;
    } else {
      return rounded;
    }
  } else {
    let frac_for_round = frac_part;
    while (true) {
      if (frac_for_round.length < (precision + 1 | 0)) {
        frac_for_round = `${frac_for_round}0`;
        continue;
      } else {
        break;
      }
    }
    const keep = _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(frac_for_round, 0, precision);
    const _tmp$38 = frac_for_round;
    $bound_check(_tmp$38, precision);
    const round_digit = _tmp$38.charCodeAt(precision);
    let out_int = int_part;
    let out_frac = keep;
    if (round_digit >= 53) {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter27printf__increment__fraction(out_frac);
      const _next_frac = _bind$4._0;
      const _carry = _bind$4._1;
      out_frac = _next_frac;
      if (_carry) {
        out_int = _M0FP410Haoxincode8moonbash3lib11interpreter25printf__increment__digits(out_int);
      }
    }
    const sign = negative && !(out_int === "0" && _M0FP410Haoxincode8moonbash3lib11interpreter18printf__all__zeros(out_frac)) ? "-" : "";
    return `${sign}${out_int}.${out_frac}`;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter25printf__hex__digit__value(ch) {
  if (ch >= 48 && ch <= 57) {
    return ch - 48 | 0;
  }
  if (ch >= 97 && ch <= 102) {
    return 10 + (ch - 97 | 0) | 0;
  }
  if (ch >= 65 && ch <= 70) {
    return 10 + (ch - 65 | 0) | 0;
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter15reverse__string(s) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = s.length - 1 | 0;
  while (true) {
    const i = _tmp$38;
    if (i >= 0) {
      $bound_check(s, i);
      _M0IPB13StringBuilderPB6Logger11write__char(buf, s.charCodeAt(i));
      _tmp$38 = i - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter15printf__to__hex(value) {
  if (BigInt.asUintN(64, value) === BigInt.asUintN(64, 0n)) {
    return "0";
  }
  let v = BigInt.asIntN(64, value) < BigInt.asIntN(64, 0n) ? BigInt.asUintN(64, -value) : value;
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  while (true) {
    if (BigInt.asIntN(64, v) > BigInt.asIntN(64, 0n)) {
      if (16n === 0n) {
        $panic();
      }
      const digit = BigInt.asUintN(64, BigInt.asIntN(64, v) % BigInt.asIntN(64, 16n));
      const ch = BigInt.asIntN(64, digit) < BigInt.asIntN(64, 10n) ? Number(BigInt.asIntN(32, BigInt.asUintN(64, digit + BigInt.asUintN(64, BigInt(48))))) | 0 : Number(BigInt.asIntN(32, BigInt.asUintN(64, BigInt.asUintN(64, digit - 10n) + BigInt.asUintN(64, BigInt(97))))) | 0;
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      if (16n === 0n) {
        $panic();
      }
      v = BigInt.asUintN(64, BigInt.asIntN(64, v) / BigInt.asIntN(64, 16n));
      continue;
    } else {
      break;
    }
  }
  const rev = _M0FP410Haoxincode8moonbash3lib11interpreter15reverse__string(out.val);
  return BigInt.asIntN(64, value) < BigInt.asIntN(64, 0n) ? `-${rev}` : rev;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter14format__printf(format, args) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let arg_idx = 0;
  let first_pass = true;
  while (true) {
    const start_arg_idx = arg_idx;
    let i = 0;
    _L: while (true) {
      if (i < format.length) {
        const _tmp$38 = i;
        $bound_check(format, _tmp$38);
        const ch = format.charCodeAt(_tmp$38);
        if (ch === 92 && (i + 1 | 0) < format.length) {
          const _tmp$39 = i + 1 | 0;
          $bound_check(format, _tmp$39);
          const next = format.charCodeAt(_tmp$39);
          if (next === 120) {
            let j = i + 2 | 0;
            let value = 0;
            let digits = 0;
            while (true) {
              if (j < format.length && digits < 2) {
                const _tmp$40 = j;
                $bound_check(format, _tmp$40);
                const hex_ch = format.charCodeAt(_tmp$40);
                const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter25printf__hex__digit__value(hex_ch);
                if (_bind$4 === undefined) {
                  break;
                } else {
                  const _Some = _bind$4;
                  const _hex_value = _Some;
                  value = (Math.imul(value, 16) | 0) + _hex_value | 0;
                  digits = digits + 1 | 0;
                  j = j + 1 | 0;
                }
                continue;
              } else {
                break;
              }
            }
            if (digits > 0) {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, value);
              i = j;
            } else {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, 120);
              i = i + 2 | 0;
            }
            continue;
          }
          if (next >= 48 && next <= 55) {
            let j = i + 1 | 0;
            let value = 0;
            let digits = 0;
            while (true) {
              if (j < format.length && digits < 3) {
                const _tmp$40 = j;
                $bound_check(format, _tmp$40);
                const oct_ch = format.charCodeAt(_tmp$40);
                if (!(oct_ch >= 48 && oct_ch <= 55)) {
                  break;
                }
                value = (Math.imul(value, 8) | 0) + (oct_ch - 48 | 0) | 0;
                digits = digits + 1 | 0;
                j = j + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            _M0IPB13StringBuilderPB6Logger11write__char(buf, value);
            i = j;
            continue;
          }
          switch (next) {
            case 110: {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, 10);
              i = i + 2 | 0;
              break;
            }
            case 116: {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, 9);
              i = i + 2 | 0;
              break;
            }
            case 92: {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
              i = i + 2 | 0;
              break;
            }
            case 34: {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, 34);
              i = i + 2 | 0;
              break;
            }
            default: {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
              _M0IPB13StringBuilderPB6Logger11write__char(buf, next);
              i = i + 2 | 0;
            }
          }
        } else {
          if (ch === 37) {
            if ((i + 1 | 0) >= format.length) {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, 37);
              i = i + 1 | 0;
              continue;
            }
            let j = i + 1 | 0;
            let left_justify = false;
            let zero_pad = false;
            while (true) {
              if (j < format.length) {
                const _tmp$39 = j;
                $bound_check(format, _tmp$39);
                const flag = format.charCodeAt(_tmp$39);
                if (flag === 45) {
                  left_justify = true;
                  j = j + 1 | 0;
                  continue;
                }
                if (flag === 48) {
                  zero_pad = true;
                  j = j + 1 | 0;
                  continue;
                }
                break;
              } else {
                break;
              }
            }
            let width = 0;
            while (true) {
              if (j < format.length) {
                const _tmp$39 = j;
                $bound_check(format, _tmp$39);
                const digit = format.charCodeAt(_tmp$39);
                if (!(digit >= 48 && digit <= 57)) {
                  break;
                }
                width = (Math.imul(width, 10) | 0) + (digit - 48 | 0) | 0;
                j = j + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            let precision = undefined;
            let _tmp$39;
            if (j < format.length) {
              const _tmp$40 = j;
              $bound_check(format, _tmp$40);
              _tmp$39 = format.charCodeAt(_tmp$40) === 46;
            } else {
              _tmp$39 = false;
            }
            if (_tmp$39) {
              j = j + 1 | 0;
              let p = 0;
              let has_digits = false;
              while (true) {
                if (j < format.length) {
                  const _tmp$40 = j;
                  $bound_check(format, _tmp$40);
                  const digit = format.charCodeAt(_tmp$40);
                  if (!(digit >= 48 && digit <= 57)) {
                    break;
                  }
                  has_digits = true;
                  p = (Math.imul(p, 10) | 0) + (digit - 48 | 0) | 0;
                  j = j + 1 | 0;
                  continue;
                } else {
                  break;
                }
              }
              if (has_digits) {
                precision = p;
              } else {
                precision = _M0FP410Haoxincode8moonbash3lib11interpreter14format__printfN6constrS11271;
              }
            }
            if (j >= format.length) {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, 37);
              i = i + 1 | 0;
              continue;
            }
            const _tmp$40 = j;
            $bound_check(format, _tmp$40);
            const spec = format.charCodeAt(_tmp$40);
            if (spec === 37) {
              const rendered = _M0FP410Haoxincode8moonbash3lib11interpreter20printf__apply__width("%", width, left_justify, false);
              _M0IPB13StringBuilderPB6Logger13write__string(buf, rendered);
              i = j + 1 | 0;
              continue;
            }
            const arg = arg_idx < args.length ? _M0MPC15array5Array2atGUssEE(args, arg_idx) : "";
            if (arg_idx < args.length) {
              arg_idx = arg_idx + 1 | 0;
            }
            let rendered;
            switch (spec) {
              case 115: {
                const _bind$4 = precision;
                if (_bind$4 === undefined) {
                  rendered = arg;
                } else {
                  const _Some = _bind$4;
                  const _p$4 = _Some;
                  rendered = _p$4 < arg.length ? _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(arg, 0, _p$4) : arg;
                }
                break;
              }
              case 100: {
                const value = _M0FP410Haoxincode8moonbash3lib11interpreter15parse__int__str(arg);
                rendered = _M0FP410Haoxincode8moonbash3lib11interpreter23printf__format__decimal(value, precision);
                break;
              }
              case 120: {
                const value$2 = _M0FP410Haoxincode8moonbash3lib11interpreter15parse__int__str(arg);
                rendered = _M0FP410Haoxincode8moonbash3lib11interpreter15printf__to__hex(value$2);
                break;
              }
              case 102: {
                const _p$4 = precision;
                const _p$5 = 6;
                let p;
                if (_p$4 === undefined) {
                  p = _p$5;
                } else {
                  const _p$6 = _p$4;
                  p = _p$6;
                }
                rendered = _M0FP410Haoxincode8moonbash3lib11interpreter21printf__format__float(arg, p);
                break;
              }
              case 113: {
                rendered = _M0FP410Haoxincode8moonbash3lib11interpreter20printf__shell__quote(arg);
                break;
              }
              default: {
                _M0IPB13StringBuilderPB6Logger11write__char(buf, 37);
                i = i + 1 | 0;
                continue _L;
              }
            }
            let allow_zero_pad;
            if (zero_pad) {
              let _tmp$41;
              if (!left_justify) {
                const _bind$5 = precision;
                _tmp$41 = _bind$5 === undefined ? spec === 100 || (spec === 120 || spec === 102) : false;
              } else {
                _tmp$41 = false;
              }
              allow_zero_pad = _tmp$41;
            } else {
              allow_zero_pad = false;
            }
            rendered = _M0FP410Haoxincode8moonbash3lib11interpreter20printf__apply__width(rendered, width, left_justify, allow_zero_pad);
            _M0IPB13StringBuilderPB6Logger13write__string(buf, rendered);
            i = j + 1 | 0;
          } else {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
            i = i + 1 | 0;
          }
        }
        continue;
      } else {
        break;
      }
    }
    if (first_pass) {
      first_pass = false;
    }
    if (args.length === 0 || (arg_idx >= args.length || arg_idx === start_arg_idx)) {
      break;
    }
    continue;
  }
  return buf.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__pushd(self, args) {
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33sync__directory__stack__with__cwd(self);
  const operands = [];
  let parse_flags = true;
  const _bind$4 = args.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const arg = args[_];
      _L: {
        if (parse_flags && arg === "--") {
          parse_flags = false;
          break _L;
        }
        let _tmp$39;
        if (parse_flags) {
          let _tmp$40;
          if (arg.length > 0) {
            $bound_check(arg, 0);
            _tmp$40 = arg.charCodeAt(0) === 45;
          } else {
            _tmp$40 = false;
          }
          _tmp$39 = _tmp$40;
        } else {
          _tmp$39 = false;
        }
        if (_tmp$39) {
          self.exit_code = 2;
          return undefined;
        }
        _M0MPC15array5Array4pushGUssEE(operands, arg);
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (operands.length > 1) {
    self.exit_code = 2;
    return undefined;
  }
  const stack = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21get__directory__stack(self);
  if (operands.length === 0) {
    if (stack.length < 2) {
      self.exit_code = 1;
      return undefined;
    }
    const old_pwd = self.cwd;
    const tmp = _M0MPC15array5Array2atGUssEE(stack, 0);
    _M0MPC15array5Array3setGsE(stack, 0, _M0MPC15array5Array2atGUssEE(stack, 1));
    _M0MPC15array5Array3setGsE(stack, 1, tmp);
    self.cwd = _M0MPC15array5Array2atGUssEE(stack, 0);
    _M0MPB3Map3setGssE(self.env, "PWD", self.cwd);
    _M0MPB3Map3setGssE(self.env, "OLDPWD", old_pwd);
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21set__directory__stack(self, stack);
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24render__directory__stack(self, stack, false, false, false);
    self.exit_code = 0;
    return undefined;
  }
  const target = _M0MPC15array5Array2atGUssEE(operands, 0);
  let resolved;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, target);
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        resolved = _ok._0;
      } else {
        const _err = _bind$5;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    self.exit_code = 1;
    return undefined;
  }
  _L$2: {
    const _bind$5 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.fs.entries, resolved);
    if (_bind$5 === undefined) {
      break _L$2;
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      if (_x.$tag === 1) {
        const old_pwd = self.cwd;
        const new_stack = [resolved];
        const _bind$6 = stack.length;
        let _tmp$39 = 0;
        while (true) {
          const _ = _tmp$39;
          if (_ < _bind$6) {
            const path = stack[_];
            _M0MPC15array5Array4pushGUssEE(new_stack, path);
            _tmp$39 = _ + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        self.cwd = resolved;
        _M0MPB3Map3setGssE(self.env, "PWD", resolved);
        _M0MPB3Map3setGssE(self.env, "OLDPWD", old_pwd);
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21set__directory__stack(self, new_stack);
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24render__directory__stack(self, new_stack, false, false, false);
        self.exit_code = 0;
        return;
      } else {
        break _L$2;
      }
    }
  }
  self.exit_code = 1;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter13is__ifs__char(ch, ifs) {
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < ifs.length) {
      $bound_check(ifs, i);
      if (ifs.charCodeAt(i) === ch) {
        return true;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter36decode__word__split__protected__text(s, ifs) {
  if (s.length === 0) {
    return s;
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  while (true) {
    if (i < s.length) {
      const _tmp$38 = i;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch === 31 && (i + 1 | 0) < s.length) {
        const _tmp$39 = i + 1 | 0;
        $bound_check(s, _tmp$39);
        const next = s.charCodeAt(_tmp$39);
        if (next === 31 || _M0FP410Haoxincode8moonbash3lib11interpreter13is__ifs__char(next, ifs)) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, next);
          i = i + 2 | 0;
          continue;
        }
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11word__split(self, s) {
  if (s.length === 0) {
    return [];
  }
  const _p$4 = _M0MPB3Map3getGssE(self.env, "IFS");
  const _p$5 = " \t\n";
  let ifs;
  if (_p$4 === undefined) {
    ifs = _p$5;
  } else {
    const _p$6 = _p$4;
    ifs = _p$6;
  }
  if (ifs.length === 0) {
    return [_M0FP410Haoxincode8moonbash3lib11interpreter36decode__word__split__protected__text(s, ifs)];
  }
  const result = [];
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  while (true) {
    if (i < s.length) {
      const _tmp$38 = i;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch === 31) {
        if ((i + 1 | 0) < s.length) {
          const _tmp$39 = i + 1 | 0;
          $bound_check(s, _tmp$39);
          const next = s.charCodeAt(_tmp$39);
          if (next === 31 || _M0FP410Haoxincode8moonbash3lib11interpreter13is__ifs__char(next, ifs)) {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, next);
            i = i + 2 | 0;
            continue;
          }
        }
      }
      if (_M0FP410Haoxincode8moonbash3lib11interpreter13is__ifs__char(ch, ifs)) {
        if (ch === 32 || (ch === 9 || ch === 10)) {
          const word = buf.val;
          if (word.length > 0) {
            _M0MPC15array5Array4pushGUssEE(result, word);
            _M0MPB13StringBuilder5reset(buf);
          }
          i = i + 1 | 0;
          continue;
        }
        _M0MPC15array5Array4pushGUssEE(result, buf.val);
        _M0MPB13StringBuilder5reset(buf);
        i = i + 1 | 0;
        while (true) {
          if (i < s.length) {
            const _tmp$39 = i;
            $bound_check(s, _tmp$39);
            const next = s.charCodeAt(_tmp$39);
            if (next === 31) {
              break;
            }
            if (_M0FP410Haoxincode8moonbash3lib11interpreter13is__ifs__char(next, ifs) && (next === 32 || (next === 9 || next === 10))) {
              i = i + 1 | 0;
              continue;
            }
            break;
          } else {
            break;
          }
        }
        continue;
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const remaining = buf.val;
  if (remaining.length > 0) {
    _M0MPC15array5Array4pushGUssEE(result, remaining);
  }
  return result;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__read(self, args) {
  const input = self.stdin_buf;
  let line_end = input.length;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < input.length) {
      $bound_check(input, i);
      const _p$4 = input.charCodeAt(i);
      const _p$5 = 10;
      if (_p$4 === _p$5) {
        line_end = i;
        break;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const line = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(input, 0, line_end));
  const var_names = [];
  let prompt = "";
  let array_name = undefined;
  let i = 0;
  while (true) {
    if (i < args.length) {
      if (_M0MPC15array5Array2atGUssEE(args, i) === "-p" && (i + 1 | 0) < args.length) {
        prompt = _M0MPC15array5Array2atGUssEE(args, i + 1 | 0);
        i = i + 2 | 0;
      } else {
        if (_M0MPC15array5Array2atGUssEE(args, i) === "-a" && (i + 1 | 0) < args.length) {
          array_name = _M0MPC15array5Array2atGUssEE(args, i + 1 | 0);
          i = i + 2 | 0;
        } else {
          if (_M0MPC15array5Array2atGUssEE(args, i) === "-r") {
            i = i + 1 | 0;
          } else {
            _M0MPC15array5Array4pushGUssEE(var_names, _M0MPC15array5Array2atGUssEE(args, i));
            i = i + 1 | 0;
          }
        }
      }
      continue;
    } else {
      break;
    }
  }
  if (prompt.length > 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, prompt);
  }
  if (var_names.length === 0) {
    _M0MPC15array5Array4pushGUssEE(var_names, "REPLY");
  }
  const words = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11word__split(self, line);
  const _bind$4 = array_name;
  if (_bind$4 === undefined) {
    let _tmp$39 = 0;
    while (true) {
      const j = _tmp$39;
      if (j < var_names.length) {
        if (j < (var_names.length - 1 | 0)) {
          const value = j < words.length ? _M0MPC15array5Array2atGUssEE(words, j) : "";
          _M0MPB3Map3setGssE(self.env, _M0MPC15array5Array2atGUssEE(var_names, j), value);
        } else {
          if (j < words.length) {
            const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
            let _tmp$40 = j;
            while (true) {
              const k = _tmp$40;
              if (k < words.length) {
                if (k > j) {
                  _M0IPB13StringBuilderPB6Logger13write__string(buf, " ");
                }
                _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0MPC15array5Array2atGUssEE(words, k));
                _tmp$40 = k + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            _M0MPB3Map3setGssE(self.env, _M0MPC15array5Array2atGUssEE(var_names, j), buf.val);
          } else {
            _M0MPB3Map3setGssE(self.env, _M0MPC15array5Array2atGUssEE(var_names, j), "");
          }
        }
        _tmp$39 = j + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  } else {
    const _Some = _bind$4;
    const _name = _Some;
    if (words.length > self.limits.max_array_elements) {
      _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "read: array element limit exceeded\n");
      self.exit_code = 1;
      return undefined;
    }
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24store__array__assignment(self, _name, words);
  }
  if (line_end < input.length) {
    self.stdin_buf = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(input, line_end + 1 | 0, undefined));
  } else {
    self.stdin_buf = "";
  }
  self.exit_code = input.length === 0 ? 1 : 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15builtin__return(self, args) {
  if (self.call_depth <= 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "moon_bash: return: can only `return` from a function or sourced script\n");
    self.exit_code = 1;
    self.return_requested = false;
    return undefined;
  }
  self.exit_code = args.length > 0 ? _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(args, 0)) : self.exit_code;
  self.return_requested = true;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__rev(self, args) {
  let input;
  if (args.length > 0) {
    let path;
    let _try_err;
    _L: {
      _L$2: {
        const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, _M0MPC15array5Array2atGUssEE(args, 0));
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          path = _ok._0;
        } else {
          const _err = _bind$4;
          _try_err = _err._0;
          break _L$2;
        }
        break _L;
      }
      path = _M0MPC15array5Array2atGUssEE(args, 0);
    }
    let _try_err$2;
    _L$2: {
      _L$3: {
        const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(self.fs, path);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          input = _ok._0;
        } else {
          const _err = _bind$4;
          _try_err$2 = _err._0;
          break _L$3;
        }
        break _L$2;
      }
      const _FsError = _try_err$2;
      const _msg = _FsError._0;
      _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `rev: ${_msg}\n`);
      self.exit_code = 1;
      return undefined;
    }
  } else {
    input = self.stdin_buf;
  }
  const lines = _M0FP410Haoxincode8moonbash3lib11interpreter12split__lines(input);
  const _bind$4 = lines.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const line = lines[_];
      const reversed = _M0FP410Haoxincode8moonbash3lib11interpreter15reverse__string(line);
      _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${reversed}\n`);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__seq(self, args) {
  if (args.length === 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "seq: missing operand\n");
    self.exit_code = 1;
    return undefined;
  }
  let first = 1n;
  let incr = 1n;
  let last = 1n;
  if (args.length === 1) {
    last = _M0FP410Haoxincode8moonbash3lib11interpreter15parse__int__str(_M0MPC15array5Array2atGUssEE(args, 0));
  } else {
    if (args.length === 2) {
      first = _M0FP410Haoxincode8moonbash3lib11interpreter15parse__int__str(_M0MPC15array5Array2atGUssEE(args, 0));
      last = _M0FP410Haoxincode8moonbash3lib11interpreter15parse__int__str(_M0MPC15array5Array2atGUssEE(args, 1));
    } else {
      first = _M0FP410Haoxincode8moonbash3lib11interpreter15parse__int__str(_M0MPC15array5Array2atGUssEE(args, 0));
      incr = _M0FP410Haoxincode8moonbash3lib11interpreter15parse__int__str(_M0MPC15array5Array2atGUssEE(args, 1));
      last = _M0FP410Haoxincode8moonbash3lib11interpreter15parse__int__str(_M0MPC15array5Array2atGUssEE(args, 2));
    }
  }
  if (BigInt.asUintN(64, incr) === BigInt.asUintN(64, 0n)) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "seq: zero increment\n");
    self.exit_code = 1;
    return undefined;
  }
  let i = first;
  let count = 0;
  while (true) {
    if (BigInt.asIntN(64, incr) > BigInt.asIntN(64, 0n) && BigInt.asIntN(64, i) <= BigInt.asIntN(64, last) || BigInt.asIntN(64, incr) < BigInt.asIntN(64, 0n) && BigInt.asIntN(64, i) >= BigInt.asIntN(64, last)) {
      _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_M0MPC15int645Int6418to__string_2einner(i, 10)}\n`);
      i = BigInt.asUintN(64, i + incr);
      count = count + 1 | 0;
      if (count > self.limits.max_loop_iterations) {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  self.exit_code = 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25set__named__shell__option(self, name, enabled) {
  switch (name) {
    case "pipefail": {
      self.options.pipefail = enabled;
      return;
    }
    case "errexit": {
      self.options.errexit = enabled;
      return;
    }
    case "nounset": {
      self.options.nounset = enabled;
      return;
    }
    case "noglob": {
      self.options.noglob = enabled;
      return;
    }
    case "xtrace": {
      self.options.xtrace = enabled;
      return;
    }
    case "noclobber": {
      self.options.noclobber = enabled;
      return;
    }
    case "allexport": {
      self.options.allexport = enabled;
      return;
    }
    default: {
      return;
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__set(self, args) {
  if (args.length === 0) {
    const _it = _M0MPB3Map5iter2GssE(self.env);
    while (true) {
      const _bind$4 = _M0MPB5Iter24nextGssE(_it);
      if (_bind$4 === undefined) {
        break;
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        const _k = _x._0;
        const _v = _x._1;
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_k}=${_v}\n`);
        continue;
      }
    }
    self.exit_code = 0;
    return undefined;
  }
  let i = 0;
  let positional_start = -1;
  while (true) {
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      if (arg === "--") {
        positional_start = i + 1 | 0;
        break;
      }
      if (arg === "-o") {
        if ((i + 1 | 0) < args.length) {
          _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25set__named__shell__option(self, _M0MPC15array5Array2atGUssEE(args, i + 1 | 0), true);
          i = i + 2 | 0;
        } else {
          i = i + 1 | 0;
        }
        continue;
      }
      if (arg === "+o") {
        if ((i + 1 | 0) < args.length) {
          _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25set__named__shell__option(self, _M0MPC15array5Array2atGUssEE(args, i + 1 | 0), false);
          i = i + 2 | 0;
        } else {
          i = i + 1 | 0;
        }
        continue;
      }
      let _tmp$38;
      if (arg.length >= 2) {
        $bound_check(arg, 0);
        const _p$4 = arg.charCodeAt(0);
        const _p$5 = 45;
        _tmp$38 = _p$4 === _p$5;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        const ch = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 1, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__setN6constrS11272));
        switch (ch) {
          case "e": {
            self.options.errexit = true;
            break;
          }
          case "u": {
            self.options.nounset = true;
            break;
          }
          case "f": {
            self.options.noglob = true;
            break;
          }
          case "x": {
            self.options.xtrace = true;
            break;
          }
          case "C": {
            self.options.noclobber = true;
            break;
          }
          case "a": {
            self.options.allexport = true;
            break;
          }
        }
        i = i + 1 | 0;
      } else {
        let _tmp$39;
        if (arg.length >= 2) {
          $bound_check(arg, 0);
          const _p$4 = arg.charCodeAt(0);
          const _p$5 = 43;
          _tmp$39 = _p$4 === _p$5;
        } else {
          _tmp$39 = false;
        }
        if (_tmp$39) {
          const ch = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 1, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__setN6constrS11273));
          switch (ch) {
            case "e": {
              self.options.errexit = false;
              break;
            }
            case "u": {
              self.options.nounset = false;
              break;
            }
            case "f": {
              self.options.noglob = false;
              break;
            }
            case "x": {
              self.options.xtrace = false;
              break;
            }
            case "C": {
              self.options.noclobber = false;
              break;
            }
            case "a": {
              self.options.allexport = false;
              break;
            }
          }
          i = i + 1 | 0;
        } else {
          positional_start = i;
          break;
        }
      }
      continue;
    } else {
      break;
    }
  }
  if (positional_start >= 0) {
    const values = [];
    let _tmp$38 = positional_start;
    while (true) {
      const j = _tmp$38;
      if (j < args.length) {
        _M0MPC15array5Array4pushGUssEE(values, _M0MPC15array5Array2atGUssEE(args, j));
        _tmp$38 = j + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27set__positional__parameters(self, values);
  }
  self.exit_code = 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__shift(self, args) {
  const n = args.length > 0 ? _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(args, 0)) : 1;
  const _bind$4 = _M0MPB3Map3getGssE(self.env, "#");
  let count;
  if (_bind$4 === undefined) {
    count = 0;
  } else {
    const _Some = _bind$4;
    const _s = _Some;
    count = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_s);
  }
  if (n > count) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "moon_bash: shift: count exceeds positional parameters\n");
    self.exit_code = 1;
    return undefined;
  }
  let _tmp$38 = 1;
  while (true) {
    const i = _tmp$38;
    if (i <= (count - n | 0)) {
      const src_idx = i + n | 0;
      const _bind$5 = _M0MPB3Map3getGssE(self.env, _M0MPC13int3Int18to__string_2einner(src_idx, 10));
      if (_bind$5 === undefined) {
      } else {
        const _Some = _bind$5;
        const _v = _Some;
        _M0MPB3Map3setGssE(self.env, _M0MPC13int3Int18to__string_2einner(i, 10), _v);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let _tmp$39 = (count - n | 0) + 1 | 0;
  while (true) {
    const i = _tmp$39;
    if (i <= count) {
      _M0MPB3Map6removeGssE(self.env, _M0MPC13int3Int18to__string_2einner(i, 10));
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const remaining = count - n | 0;
  _M0MPB3Map3setGssE(self.env, "#", _M0MPC13int3Int18to__string_2einner(remaining, 10));
  const values = [];
  let _tmp$40 = 1;
  while (true) {
    const i = _tmp$40;
    if (i <= remaining) {
      const _p$4 = _M0MPB3Map3getGssE(self.env, _M0MPC13int3Int18to__string_2einner(i, 10));
      const _p$5 = "";
      let _tmp$41;
      if (_p$4 === undefined) {
        _tmp$41 = _p$5;
      } else {
        const _p$6 = _p$4;
        _tmp$41 = _p$6;
      }
      _M0MPC15array5Array4pushGUssEE(values, _tmp$41);
      _tmp$40 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _tmp$41 = self.env;
  const _p$4 = _M0MPC15array5Array4iterGsE(values);
  const _p$5 = "";
  let _p$6 = _p$5;
  while (true) {
    const _p$7 = _M0MPB4Iter4nextGUssEE(_p$4);
    if (_p$7 === undefined) {
      break;
    } else {
      const _p$8 = _p$7;
      const _p$9 = _p$8;
      const _p$10 = _p$6;
      _p$6 = _p$10.length === 0 ? _p$9 : `${_p$10} ${_p$9}`;
      continue;
    }
  }
  _M0MPB3Map3setGssE(_tmp$41, "@", _p$6);
  self.exit_code = 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter22is__known__shopt__name(name) {
  const _bind$4 = ["dotglob", "expand_aliases", "extglob", "failglob", "globstar", "nocaseglob", "nullglob"];
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const known = _bind$4[_];
      if (known === name) {
        return true;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18shopt__is__enabled(self, name) {
  const _p$4 = _M0MPB3Map3getGssE(self.env, `${_M0FP410Haoxincode8moonbash3lib11interpreter22shopt__storage__prefix}${name}`);
  const _p$5 = "0";
  let _tmp$38;
  if (_p$4 === undefined) {
    _tmp$38 = _p$5;
  } else {
    const _p$6 = _p$4;
    _tmp$38 = _p$6;
  }
  return _tmp$38 === "1";
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19print__shopt__state(self, name) {
  const enabled = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18shopt__is__enabled(self, name);
  const flag = enabled ? "s" : "u";
  _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `shopt -${flag} ${name}\n`);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19shopt__set__enabled(self, name, enabled) {
  _M0MPB3Map3setGssE(self.env, `${_M0FP410Haoxincode8moonbash3lib11interpreter22shopt__storage__prefix}${name}`, enabled ? "1" : "0");
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__shopt(self, args) {
  let mode = 0;
  const names = [];
  let i = 0;
  _L: while (true) {
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      if (arg === "--") {
        let _tmp$38 = i + 1 | 0;
        while (true) {
          const j = _tmp$38;
          if (j < args.length) {
            _M0MPC15array5Array4pushGUssEE(names, _M0MPC15array5Array2atGUssEE(args, j));
            _tmp$38 = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        break;
      }
      switch (arg) {
        case "-s": {
          mode = 1;
          i = i + 1 | 0;
          continue _L;
        }
        case "-u": {
          mode = 2;
          i = i + 1 | 0;
          continue _L;
        }
        case "-q": {
          mode = 3;
          i = i + 1 | 0;
          continue _L;
        }
        case "-p": {
          mode = 0;
          i = i + 1 | 0;
          continue _L;
        }
      }
      let _tmp$38;
      if (arg.length > 0) {
        $bound_check(arg, 0);
        _tmp$38 = arg.charCodeAt(0) === 45;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        self.exit_code = 1;
        return undefined;
      }
      _M0MPC15array5Array4pushGUssEE(names, arg);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (names.length === 0 && mode === 0) {
    const options = ["dotglob", "expand_aliases", "extglob", "failglob", "globstar", "nocaseglob", "nullglob"];
    const _bind$4 = options.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$4) {
        const name = options[_];
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19print__shopt__state(self, name);
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    self.exit_code = 0;
    return undefined;
  }
  let had_error = false;
  let any_unset_in_query = false;
  const _bind$4 = names.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const name = names[_];
      _L$2: {
        if (!_M0FP410Haoxincode8moonbash3lib11interpreter22is__known__shopt__name(name)) {
          had_error = true;
          break _L$2;
        }
        const _bind$5 = mode;
        switch (_bind$5) {
          case 1: {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19shopt__set__enabled(self, name, true);
            break;
          }
          case 2: {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19shopt__set__enabled(self, name, false);
            break;
          }
          case 3: {
            if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18shopt__is__enabled(self, name)) {
              any_unset_in_query = true;
            }
            break;
          }
          default: {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19print__shopt__state(self, name);
          }
        }
        break _L$2;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (mode === 3) {
    self.exit_code = had_error || any_unset_in_query ? 1 : 0;
    return;
  } else {
    self.exit_code = had_error ? 1 : 0;
    return;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter26shell__parse__duration__ms(raw) {
  if (raw.length === 0) {
    return new _M0DTPC16result6ResultGisE3Err(`invalid time interval '${raw}'`);
  }
  let unit_ms = 1000;
  let end_ = raw.length;
  let _tmp$38;
  if (raw.length >= 2) {
    let _tmp$39;
    const _tmp$40 = raw.length - 2 | 0;
    $bound_check(raw, _tmp$40);
    if (raw.charCodeAt(_tmp$40) === 109) {
      const _tmp$41 = raw.length - 1 | 0;
      $bound_check(raw, _tmp$41);
      _tmp$39 = raw.charCodeAt(_tmp$41) === 115;
    } else {
      _tmp$39 = false;
    }
    _tmp$38 = _tmp$39;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    unit_ms = 1;
    end_ = raw.length - 2 | 0;
  } else {
    const _tmp$39 = raw.length - 1 | 0;
    $bound_check(raw, _tmp$39);
    const suffix = raw.charCodeAt(_tmp$39);
    switch (suffix) {
      case 115: {
        unit_ms = 1000;
        end_ = raw.length - 1 | 0;
        break;
      }
      case 109: {
        unit_ms = 60000;
        end_ = raw.length - 1 | 0;
        break;
      }
      case 104: {
        unit_ms = 3600000;
        end_ = raw.length - 1 | 0;
        break;
      }
      case 100: {
        unit_ms = 86400000;
        end_ = raw.length - 1 | 0;
        break;
      }
    }
  }
  if (end_ <= 0) {
    return new _M0DTPC16result6ResultGisE3Err(`invalid time interval '${raw}'`);
  }
  let start = 0;
  $bound_check(raw, 0);
  if (raw.charCodeAt(0) === 43) {
    start = 1;
  } else {
    $bound_check(raw, 0);
    if (raw.charCodeAt(0) === 45) {
      return new _M0DTPC16result6ResultGisE3Err(`invalid time interval '${raw}'`);
    }
  }
  if (start >= end_) {
    return new _M0DTPC16result6ResultGisE3Err(`invalid time interval '${raw}'`);
  }
  let whole = 0;
  let frac = 0;
  let frac_scale = 1;
  let has_digit = false;
  let seen_dot = false;
  let _tmp$39 = start;
  while (true) {
    const i = _tmp$39;
    if (i < end_) {
      $bound_check(raw, i);
      const ch = raw.charCodeAt(i);
      if (ch >= 48 && ch <= 57) {
        has_digit = true;
        const digit = ch - 48 | 0;
        if (seen_dot) {
          if (frac_scale < 1000000) {
            frac = (Math.imul(frac, 10) | 0) + digit | 0;
            frac_scale = Math.imul(frac_scale, 10) | 0;
          }
        } else {
          whole = (Math.imul(whole, 10) | 0) + digit | 0;
        }
      } else {
        if (ch === 46 && !seen_dot) {
          seen_dot = true;
        } else {
          return new _M0DTPC16result6ResultGisE3Err(`invalid time interval '${raw}'`);
        }
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (!has_digit) {
    return new _M0DTPC16result6ResultGisE3Err(`invalid time interval '${raw}'`);
  }
  if (whole > (2147483647 / unit_ms | 0)) {
    return new _M0DTPC16result6ResultGisE3Err(`invalid time interval '${raw}'`);
  }
  let total = Math.imul(whole, unit_ms) | 0;
  if (frac > 0) {
    const frac_ms = (Math.imul(frac, unit_ms) | 0) / frac_scale | 0;
    if (frac_ms > (2147483647 - total | 0)) {
      return new _M0DTPC16result6ResultGisE3Err(`invalid time interval '${raw}'`);
    }
    total = total + frac_ms | 0;
  }
  return new _M0DTPC16result6ResultGisE2Ok(total);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter33shell__parse__total__duration__ms(args) {
  let total = 0;
  const _bind$4 = args.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const raw = args[_];
      const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter26shell__parse__duration__ms(raw);
      let duration_ms;
      if (_bind$5.$tag === 1) {
        const _Ok = _bind$5;
        duration_ms = _Ok._0;
      } else {
        const _Err = _bind$5;
        const _msg = _Err._0;
        return new _M0DTPC16result6ResultGisE3Err(_msg);
      }
      if (duration_ms > (2147483647 - total | 0)) {
        return new _M0DTPC16result6ResultGisE3Err(`invalid time interval '${raw}'`);
      }
      total = total + duration_ms | 0;
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return new _M0DTPC16result6ResultGisE2Ok(total);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__sleep(self, args) {
  if (args.length === 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "moon_bash: sleep: missing operand\n");
    self.exit_code = 1;
    return undefined;
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter33shell__parse__total__duration__ms(args);
  let duration_ms;
  if (_bind$4.$tag === 1) {
    const _Ok = _bind$4;
    duration_ms = _Ok._0;
  } else {
    const _Err = _bind$4;
    const _msg = _Err._0;
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: sleep: ${_msg}\n`);
    self.exit_code = 1;
    return undefined;
  }
  const sleep_error = _M0FP410Haoxincode8moonbash3lib3ffi11sleep__sync(duration_ms);
  if (sleep_error.length > 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: sleep: ${sleep_error}\n`);
    self.exit_code = 1;
    return undefined;
  }
  self.exit_code = 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter15sort__char__key(ch) {
  const code = ch;
  return ch >= 97 && ch <= 122 ? { _0: 2, _1: code, _2: 0, _3: code } : ch >= 65 && ch <= 90 ? { _0: 2, _1: code + 32 | 0, _2: 1, _3: code } : ch >= 48 && ch <= 57 ? { _0: 1, _1: code, _2: 0, _3: code } : { _0: 0, _1: code, _2: 0, _3: code };
}
function _M0FP410Haoxincode8moonbash3lib11interpreter19compare__sort__char(a, b) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter15sort__char__key(a);
  const _a_class = _bind$4._0;
  const _a_base = _bind$4._1;
  const _a_case = _bind$4._2;
  const _a_code = _bind$4._3;
  const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter15sort__char__key(b);
  const _b_class = _bind$5._0;
  const _b_base = _bind$5._1;
  const _b_case = _bind$5._2;
  const _b_code = _bind$5._3;
  if (_a_class < _b_class) {
    return -1;
  }
  if (_a_class > _b_class) {
    return 1;
  }
  if (_a_base < _b_base) {
    return -1;
  }
  if (_a_base > _b_base) {
    return 1;
  }
  if (_a_case < _b_case) {
    return -1;
  }
  if (_a_case > _b_case) {
    return 1;
  }
  return _a_code < _b_code ? -1 : _a_code > _b_code ? 1 : 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter19compare__sort__text(a, b) {
  const min_len = a.length < b.length ? a.length : b.length;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < min_len) {
      $bound_check(a, i);
      const ch_a = a.charCodeAt(i);
      $bound_check(b, i);
      const ch_b = b.charCodeAt(i);
      const cmp = _M0FP410Haoxincode8moonbash3lib11interpreter19compare__sort__char(ch_a, ch_b);
      if (cmp !== 0) {
        return cmp;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return a.length < b.length ? -1 : a.length > b.length ? 1 : 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter18is__numeric__token(s) {
  if (s.length === 0) {
    return false;
  }
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const _p$4 = s.charCodeAt(i);
      if (!(_p$4 >= 48 && _p$4 <= 57)) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter22split__version__tokens(s) {
  const tokens = [];
  if (s.length === 0) {
    return tokens;
  }
  let start = 0;
  $bound_check(s, 0);
  const _p$4 = s.charCodeAt(0);
  let in_digit = _p$4 >= 48 && _p$4 <= 57;
  let _tmp$38 = 1;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const _p$5 = s.charCodeAt(i);
      const is_digit = _p$5 >= 48 && _p$5 <= 57;
      const _p$6 = in_digit;
      if (!(is_digit === _p$6)) {
        _M0MPC15array5Array4pushGUssEE(tokens, _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(s, start, i)));
        start = i;
        in_digit = is_digit;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MPC15array5Array4pushGUssEE(tokens, _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(s, start, undefined)));
  return tokens;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter22compare__version__like(a, b) {
  const ta = _M0FP410Haoxincode8moonbash3lib11interpreter22split__version__tokens(a);
  const tb = _M0FP410Haoxincode8moonbash3lib11interpreter22split__version__tokens(b);
  const max_len = ta.length > tb.length ? ta.length : tb.length;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < max_len) {
      if (i >= ta.length) {
        return -1;
      }
      if (i >= tb.length) {
        return 1;
      }
      const sa = _M0MPC15array5Array2atGUssEE(ta, i);
      const sb = _M0MPC15array5Array2atGUssEE(tb, i);
      const a_num = _M0FP410Haoxincode8moonbash3lib11interpreter18is__numeric__token(sa);
      const b_num = _M0FP410Haoxincode8moonbash3lib11interpreter18is__numeric__token(sb);
      let cmp;
      if (a_num && b_num) {
        const _p$4 = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(sa);
        const _p$5 = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(sb);
        cmp = _p$4 < _p$5 ? -1 : _p$4 > _p$5 ? 1 : 0;
      } else {
        cmp = _M0FP410Haoxincode8moonbash3lib11interpreter16compare__strings(sa, sb);
      }
      if (cmp !== 0) {
        return cmp;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter13ltrim__blanks(s) {
  let i = 0;
  while (true) {
    if (i < s.length) {
      const _tmp$38 = i;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch === 32 || ch === 9) {
        i = i + 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  return _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(s, i, undefined));
}
function _M0FP410Haoxincode8moonbash3lib11interpreter18extract__sort__key(line, key_field, delimiter, ignore_leading_blanks) {
  let key;
  if (key_field === undefined) {
    key = line;
  } else {
    const _Some = key_field;
    const _field = _Some;
    let parts;
    if (delimiter === undefined) {
      parts = _M0FP410Haoxincode8moonbash3lib11interpreter21split__by__whitespace(line);
    } else {
      const _Some$2 = delimiter;
      const _delim = _Some$2;
      parts = _M0FP410Haoxincode8moonbash3lib11interpreter28split__string__by__delimiter(line, _delim);
    }
    key = _field > 0 && _field <= parts.length ? _M0MPC15array5Array2atGUssEE(parts, _field - 1 | 0) : "";
  }
  return ignore_leading_blanks ? _M0FP410Haoxincode8moonbash3lib11interpreter13ltrim__blanks(key) : key;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter12ascii__upper(ch) {
  return ch >= 97 && ch <= 122 ? ch - 32 | 0 : ch;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter18parse__human__size(s) {
  const trimmed = _M0FP410Haoxincode8moonbash3lib11interpreter13ltrim__blanks(s);
  if (trimmed.length === 0) {
    return 0;
  }
  let i = 0;
  let _tmp$38;
  const _tmp$39 = i;
  $bound_check(trimmed, _tmp$39);
  const _p$4 = trimmed.charCodeAt(_tmp$39);
  const _p$5 = 45;
  if (_p$4 === _p$5) {
    _tmp$38 = true;
  } else {
    const _tmp$40 = i;
    $bound_check(trimmed, _tmp$40);
    const _p$6 = trimmed.charCodeAt(_tmp$40);
    const _p$7 = 43;
    _tmp$38 = _p$6 === _p$7;
  }
  if (_tmp$38) {
    i = i + 1 | 0;
  }
  while (true) {
    if (i < trimmed.length) {
      const _tmp$40 = i;
      $bound_check(trimmed, _tmp$40);
      const ch = trimmed.charCodeAt(_tmp$40);
      if (ch >= 48 && ch <= 57 || ch === 46) {
        i = i + 1 | 0;
      } else {
        break;
      }
      continue;
    } else {
      break;
    }
  }
  if (i === 0) {
    return 0;
  }
  const number = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(trimmed, 0, i)));
  if (i >= trimmed.length) {
    return number;
  }
  const _tmp$40 = i;
  $bound_check(trimmed, _tmp$40);
  const unit = _M0FP410Haoxincode8moonbash3lib11interpreter12ascii__upper(trimmed.charCodeAt(_tmp$40));
  let factor;
  switch (unit) {
    case 75: {
      factor = 1024;
      break;
    }
    case 77: {
      factor = 1048576;
      break;
    }
    case 71: {
      factor = 1073741824;
      break;
    }
    case 84: {
      factor = 0;
      break;
    }
    default: {
      factor = 1;
    }
  }
  return Math.imul(number, factor) | 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__sort(self, args) {
  const reverse = new _M0TPB8MutLocalGbE(false);
  const numeric = new _M0TPB8MutLocalGbE(false);
  let unique = false;
  const human = new _M0TPB8MutLocalGbE(false);
  const version = new _M0TPB8MutLocalGbE(false);
  let check_only = false;
  const ignore_leading_blanks = new _M0TPB8MutLocalGbE(false);
  const key_field = new _M0TPB8MutLocalGOiE(undefined);
  const delimiter = new _M0TPB8MutLocalGOsE(undefined);
  let input_file = undefined;
  let i = 0;
  while (true) {
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      if (arg === "-k" && (i + 1 | 0) < args.length) {
        key_field.val = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(args, i + 1 | 0));
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__sortN7_2abindS7786, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__sortN7_2abindS7786.length)) && arg.length > 2) {
        key_field.val = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined)));
        i = i + 1 | 0;
        continue;
      }
      if (arg === "-t" && (i + 1 | 0) < args.length) {
        delimiter.val = _M0MPC15array5Array2atGUssEE(args, i + 1 | 0);
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__sortN7_2abindS7787, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__sortN7_2abindS7787.length)) && arg.length > 2) {
        delimiter.val = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined));
        i = i + 1 | 0;
        continue;
      }
      let _tmp$38;
      if (arg.length > 1) {
        $bound_check(arg, 0);
        const _p$4 = arg.charCodeAt(0);
        const _p$5 = 45;
        _tmp$38 = _p$4 === _p$5;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        let _tmp$39 = 1;
        while (true) {
          const j = _tmp$39;
          if (j < arg.length) {
            $bound_check(arg, j);
            const flag = arg.charCodeAt(j);
            switch (flag) {
              case 114: {
                reverse.val = true;
                break;
              }
              case 110: {
                numeric.val = true;
                break;
              }
              case 117: {
                unique = true;
                break;
              }
              case 104: {
                human.val = true;
                break;
              }
              case 86: {
                version.val = true;
                break;
              }
              case 99: {
                check_only = true;
                break;
              }
              case 98: {
                ignore_leading_blanks.val = true;
                break;
              }
            }
            _tmp$39 = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
      } else {
        input_file = arg;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$4 = input_file;
  let input;
  if (_bind$4 === undefined) {
    input = self.stdin_buf;
  } else {
    const _Some = _bind$4;
    const _path = _Some;
    let resolved;
    let _try_err;
    _L: {
      _L$2: {
        const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, _path);
        if (_bind$5.$tag === 1) {
          const _ok = _bind$5;
          resolved = _ok._0;
        } else {
          const _err = _bind$5;
          _try_err = _err._0;
          break _L$2;
        }
        break _L;
      }
      resolved = _path;
    }
    let _try_err$2;
    _L$2: {
      _L$3: {
        const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(self.fs, resolved);
        if (_bind$5.$tag === 1) {
          const _ok = _bind$5;
          input = _ok._0;
        } else {
          const _err = _bind$5;
          _try_err$2 = _err._0;
          break _L$3;
        }
        break _L$2;
      }
      const _FsError = _try_err$2;
      const _msg = _FsError._0;
      _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `sort: ${_msg}\n`);
      self.exit_code = 1;
      return undefined;
    }
  }
  const lines = _M0FP410Haoxincode8moonbash3lib11interpreter26split__lines__no__trailing(input);
  const compare_lines = (a, b) => {
    const key_a = _M0FP410Haoxincode8moonbash3lib11interpreter18extract__sort__key(a, key_field.val, delimiter.val, ignore_leading_blanks.val);
    const key_b = _M0FP410Haoxincode8moonbash3lib11interpreter18extract__sort__key(b, key_field.val, delimiter.val, ignore_leading_blanks.val);
    let cmp;
    if (version.val) {
      cmp = _M0FP410Haoxincode8moonbash3lib11interpreter22compare__version__like(key_a, key_b);
    } else {
      if (human.val) {
        const _p$4 = _M0FP410Haoxincode8moonbash3lib11interpreter18parse__human__size(key_a);
        const _p$5 = _M0FP410Haoxincode8moonbash3lib11interpreter18parse__human__size(key_b);
        cmp = _p$4 < _p$5 ? -1 : _p$4 > _p$5 ? 1 : 0;
      } else {
        if (numeric.val) {
          const _p$4 = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(key_a);
          const _p$5 = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(key_b);
          cmp = _p$4 < _p$5 ? -1 : _p$4 > _p$5 ? 1 : 0;
        } else {
          cmp = _M0FP410Haoxincode8moonbash3lib11interpreter19compare__sort__text(key_a, key_b);
        }
      }
    }
    if (cmp === 0) {
      cmp = _M0FP410Haoxincode8moonbash3lib11interpreter19compare__sort__text(a, b);
    }
    return reverse.val ? -cmp | 0 : cmp;
  };
  if (check_only) {
    if (lines.length > 1) {
      let _tmp$38 = 1;
      while (true) {
        const j = _tmp$38;
        if (j < lines.length) {
          if (compare_lines(_M0MPC15array5Array2atGUssEE(lines, j - 1 | 0), _M0MPC15array5Array2atGUssEE(lines, j)) > 0) {
            const _p$4 = input_file;
            const _p$5 = "(stdin)";
            let label;
            if (_p$4 === undefined) {
              label = _p$5;
            } else {
              const _p$6 = _p$4;
              label = _p$6;
            }
            const msg = `sort: ${label}:${_M0IPC13int3IntPB4Show10to__string(j + 1 | 0)}: disorder: ${_M0MPC15array5Array2atGUssEE(lines, j)}\n`;
            _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, msg);
            self.exit_code = 1;
            return undefined;
          }
          _tmp$38 = j + 1 | 0;
          continue;
        } else {
          break;
        }
      }
    }
    self.exit_code = 0;
    return undefined;
  }
  _M0MPC15array5Array8sort__byGUssEE(lines, compare_lines);
  let prev = undefined;
  let _tmp$38 = 0;
  while (true) {
    const i$2 = _tmp$38;
    if (i$2 < lines.length) {
      _L: {
        if (unique) {
          const _bind$5 = prev;
          if (_bind$5 === undefined) {
          } else {
            const _Some = _bind$5;
            const _last = _Some;
            if (_last === _M0MPC15array5Array2atGUssEE(lines, i$2)) {
              break _L;
            }
          }
        }
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_M0MPC15array5Array2atGUssEE(lines, i$2)}\n`);
        prev = _M0MPC15array5Array2atGUssEE(lines, i$2);
        break _L;
      }
      _tmp$38 = i$2 + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__tac(self, args) {
  const files = [];
  const _bind$4 = args.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const arg = args[_];
      _M0MPC15array5Array4pushGUssEE(files, arg);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (files.length === 0) {
    const lines = _M0FP410Haoxincode8moonbash3lib11interpreter26split__lines__no__trailing(self.stdin_buf);
    let i = lines.length - 1 | 0;
    while (true) {
      if (i >= 0) {
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_M0MPC15array5Array2atGUssEE(lines, i)}\n`);
        i = i - 1 | 0;
        continue;
      } else {
        break;
      }
    }
    self.exit_code = 0;
    return undefined;
  }
  const _bind$5 = files.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$5) {
      const file = files[_];
      let resolved;
      let _try_err;
      _L: {
        _L$2: {
          const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, file);
          if (_bind$6.$tag === 1) {
            const _ok = _bind$6;
            resolved = _ok._0;
          } else {
            const _err = _bind$6;
            _try_err = _err._0;
            break _L$2;
          }
          break _L;
        }
        resolved = file;
      }
      let content;
      let _try_err$2;
      _L$2: {
        _L$3: {
          const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(self.fs, resolved);
          if (_bind$6.$tag === 1) {
            const _ok = _bind$6;
            content = _ok._0;
          } else {
            const _err = _bind$6;
            _try_err$2 = _err._0;
            break _L$3;
          }
          break _L$2;
        }
        const _FsError = _try_err$2;
        const _msg = _FsError._0;
        _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `tac: ${_msg}\n`);
        self.exit_code = 1;
        return undefined;
      }
      const lines = _M0FP410Haoxincode8moonbash3lib11interpreter26split__lines__no__trailing(content);
      let i = lines.length - 1 | 0;
      while (true) {
        if (i >= 0) {
          _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_M0MPC15array5Array2atGUssEE(lines, i)}\n`);
          i = i - 1 | 0;
          continue;
        } else {
          break;
        }
      }
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__tee(self, args) {
  let append = false;
  const files = [];
  const _bind$4 = args.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const arg = args[_];
      if (arg === "-a") {
        append = true;
      } else {
        _M0MPC15array5Array4pushGUssEE(files, arg);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const input = self.stdin_buf;
  _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, input);
  const _bind$5 = files.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$5) {
      const file = files[_];
      let resolved;
      let _try_err;
      _L: {
        _L$2: {
          const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, file);
          if (_bind$6.$tag === 1) {
            const _ok = _bind$6;
            resolved = _ok._0;
          } else {
            const _err = _bind$6;
            _try_err = _err._0;
            break _L$2;
          }
          break _L;
        }
        resolved = file;
      }
      let _try_err$2;
      _L$2: {
        _L$3: {
          if (append) {
            const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs12append__file(self.fs, resolved, input);
            if (_bind$6.$tag === 1) {
              const _ok = _bind$6;
              _ok._0;
            } else {
              const _err = _bind$6;
              _try_err$2 = _err._0;
              break _L$3;
            }
          } else {
            const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs11write__file(self.fs, resolved, input);
            if (_bind$6.$tag === 1) {
              const _ok = _bind$6;
              _ok._0;
            } else {
              const _err = _bind$6;
              _try_err$2 = _err._0;
              break _L$3;
            }
          }
          break _L$2;
        }
        const _FsError = _try_err$2;
        const _msg = _FsError._0;
        _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `tee: ${_msg}\n`);
      }
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter11shell__pad3(value) {
  return value < 10 ? `00${_M0MPC13int3Int18to__string_2einner(value, 10)}` : value < 100 ? `0${_M0MPC13int3Int18to__string_2einner(value, 10)}` : _M0MPC13int3Int18to__string_2einner(value, 10);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter18tr__unescape__char(ch) {
  switch (ch) {
    case 110: {
      return 10;
    }
    case 116: {
      return 9;
    }
    case 114: {
      return 13;
    }
    case 92: {
      return 92;
    }
    default: {
      return ch;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter15expand__tr__set(s) {
  const result = [];
  let i = 0;
  while (true) {
    if (i < s.length) {
      const _tmp$38 = i;
      $bound_check(s, _tmp$38);
      const ch = s.charCodeAt(_tmp$38);
      if (ch === 92 && (i + 1 | 0) < s.length) {
        const _tmp$39 = i + 1 | 0;
        $bound_check(s, _tmp$39);
        const escaped = _M0FP410Haoxincode8moonbash3lib11interpreter18tr__unescape__char(s.charCodeAt(_tmp$39));
        _M0MPC15array5Array4pushGcE(result, escaped);
        i = i + 2 | 0;
        continue;
      }
      let _tmp$39;
      if ((i + 2 | 0) < s.length) {
        let _tmp$40;
        const _tmp$41 = i + 1 | 0;
        $bound_check(s, _tmp$41);
        if (s.charCodeAt(_tmp$41) === 45) {
          const _tmp$42 = i + 2 | 0;
          $bound_check(s, _tmp$42);
          _tmp$40 = s.charCodeAt(_tmp$42) !== 92;
        } else {
          _tmp$40 = false;
        }
        _tmp$39 = _tmp$40;
      } else {
        _tmp$39 = false;
      }
      if (_tmp$39) {
        const _tmp$40 = i + 2 | 0;
        $bound_check(s, _tmp$40);
        const end_ch = s.charCodeAt(_tmp$40);
        let c = ch;
        while (true) {
          if (c <= end_ch) {
            _M0MPC15array5Array4pushGcE(result, c);
            c = c + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        i = i + 3 | 0;
      } else {
        _M0MPC15array5Array4pushGcE(result, ch);
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  return result;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter17tr__set__contains(set, ch) {
  const _bind$4 = set.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const c = set[_];
      if (c === ch) {
        return true;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter16tr__set__matches(set, ch, complement) {
  return complement ? !_M0FP410Haoxincode8moonbash3lib11interpreter17tr__set__contains(set, ch) : _M0FP410Haoxincode8moonbash3lib11interpreter17tr__set__contains(set, ch);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter13tr__translate(set1, set2, ch) {
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < set1.length) {
      if (_M0MPC15array5Array2atGcE(set1, i) === ch) {
        if (i < set2.length) {
          return _M0MPC15array5Array2atGcE(set2, i);
        } else {
          if (set2.length > 0) {
            return _M0MPC15array5Array2atGcE(set2, set2.length - 1 | 0);
          }
        }
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return ch;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter25tr__translate__with__mode(set1, set2, ch, complement) {
  return complement ? (_M0FP410Haoxincode8moonbash3lib11interpreter17tr__set__contains(set1, ch) ? ch : set2.length > 0 ? _M0MPC15array5Array2atGcE(set2, 0) : ch) : _M0FP410Haoxincode8moonbash3lib11interpreter13tr__translate(set1, set2, ch);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__tr(self, args) {
  if (args.length === 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "tr: missing operand\n");
    self.exit_code = 1;
    return undefined;
  }
  const input = self.stdin_buf;
  let delete_mode = false;
  let squeeze_mode = false;
  let complement_mode = false;
  let arg_idx = 0;
  while (true) {
    let _tmp$38;
    if (arg_idx < args.length) {
      let _tmp$39;
      if (_M0MPC15array5Array2atGUssEE(args, arg_idx).length > 1) {
        const _tmp$40 = _M0MPC15array5Array2atGUssEE(args, arg_idx);
        $bound_check(_tmp$40, 0);
        const _p$4 = _tmp$40.charCodeAt(0);
        const _p$5 = 45;
        _tmp$39 = _p$4 === _p$5;
      } else {
        _tmp$39 = false;
      }
      _tmp$38 = _tmp$39;
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      let _tmp$39 = 1;
      while (true) {
        const i = _tmp$39;
        if (i < _M0MPC15array5Array2atGUssEE(args, arg_idx).length) {
          const _tmp$40 = _M0MPC15array5Array2atGUssEE(args, arg_idx);
          $bound_check(_tmp$40, i);
          const flag = _tmp$40.charCodeAt(i);
          switch (flag) {
            case 99: {
              complement_mode = true;
              break;
            }
            case 100: {
              delete_mode = true;
              break;
            }
            case 115: {
              squeeze_mode = true;
              break;
            }
          }
          _tmp$39 = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      arg_idx = arg_idx + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (arg_idx >= args.length) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "tr: missing operand\n");
    self.exit_code = 1;
    return undefined;
  }
  const set1 = _M0FP410Haoxincode8moonbash3lib11interpreter15expand__tr__set(_M0MPC15array5Array2atGUssEE(args, arg_idx));
  arg_idx = arg_idx + 1 | 0;
  let has_set2 = false;
  let set2 = [];
  if (!delete_mode && arg_idx < args.length) {
    set2 = _M0FP410Haoxincode8moonbash3lib11interpreter15expand__tr__set(_M0MPC15array5Array2atGUssEE(args, arg_idx));
    has_set2 = true;
  }
  if (!delete_mode && (!has_set2 && !squeeze_mode)) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "tr: missing operand after set1\n");
    self.exit_code = 1;
    return undefined;
  }
  const squeeze_set = delete_mode || !has_set2 ? set1 : set2;
  const squeeze_complement = has_set2 ? false : complement_mode;
  if (squeeze_mode && !_M0FP410Haoxincode8moonbash3lib11interpreter16tr__set__matches(squeeze_set, 32, squeeze_complement)) {
    _M0MPC15array5Array4pushGcE(squeeze_set, 32);
  }
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let prev_written = -1;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < input.length) {
      _L: {
        $bound_check(input, i);
        const ch = input.charCodeAt(i);
        if (delete_mode && _M0FP410Haoxincode8moonbash3lib11interpreter16tr__set__matches(set1, ch, complement_mode)) {
          break _L;
        }
        const mapped = has_set2 ? _M0FP410Haoxincode8moonbash3lib11interpreter25tr__translate__with__mode(set1, set2, ch, complement_mode) : ch;
        if (squeeze_mode && _M0FP410Haoxincode8moonbash3lib11interpreter16tr__set__matches(squeeze_set, mapped, squeeze_complement)) {
          const _bind$4 = prev_written;
          if (_bind$4 === -1) {
          } else {
            const _Some = _bind$4;
            const _last = _Some;
            if (_last === mapped) {
              break _L;
            }
          }
        }
        _M0IPB13StringBuilderPB6Logger11write__char(buf, mapped);
        prev_written = mapped;
        break _L;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, buf.val);
  self.exit_code = 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter27is__special__shell__builtin(name) {
  switch (name) {
    case ":": {
      return true;
    }
    case ".": {
      return true;
    }
    case "break": {
      return true;
    }
    case "continue": {
      return true;
    }
    case "eval": {
      return true;
    }
    case "exec": {
      return true;
    }
    case "exit": {
      return true;
    }
    case "export": {
      return true;
    }
    case "readonly": {
      return true;
    }
    case "return": {
      return true;
    }
    case "set": {
      return true;
    }
    case "shift": {
      return true;
    }
    case "unset": {
      return true;
    }
    default: {
      return false;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter38type__builtin__without__external__path(name) {
  switch (name) {
    case "cd": {
      return true;
    }
    case "type": {
      return true;
    }
    case "builtin": {
      return true;
    }
    case "command": {
      return true;
    }
    default: {
      return false;
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27all__path__command__matches(self, name, use_default_path, include_virtual_fallback) {
  return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31collect__path__command__matches(self, name, use_default_path, include_virtual_fallback, false);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter26type__word__part__to__text(part) {
  switch (part.$tag) {
    case 0: {
      const _Literal = part;
      return _Literal._0;
    }
    case 1: {
      const _SingleQuoted = part;
      return _SingleQuoted._0;
    }
    case 2: {
      const _DoubleQuoted = part;
      const _parts = _DoubleQuoted._0;
      const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
      const _bind$4 = _parts.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const inner = _parts[_];
          _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FP410Haoxincode8moonbash3lib11interpreter26type__word__part__to__text(inner));
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return buf.val;
    }
    case 3: {
      const _Variable = part;
      const _name = _Variable._0;
      return `$${_name}`;
    }
    case 4: {
      return "";
    }
    case 5: {
      return "";
    }
    case 6: {
      return "";
    }
    case 7: {
      return "";
    }
    case 8: {
      const _TildePrefix = part;
      const _prefix = _TildePrefix._0;
      return `~${_prefix}`;
    }
    default: {
      const _Glob = part;
      const _pattern = _Glob._0;
      return _pattern.pattern;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter20type__word__to__text(word) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _bind$4 = word.parts;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const part = _bind$4[_];
      _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FP410Haoxincode8moonbash3lib11interpreter26type__word__part__to__text(part));
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter29type__render__simple__command(simple) {
  const pieces = [];
  const _bind$4 = simple.assignments;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const assign = _bind$4[_];
      const _bind$6 = assign.value;
      if (_bind$6 === undefined) {
        if (assign.append) {
          _M0MPC15array5Array4pushGUssEE(pieces, `${assign.name}+=`);
        } else {
          _M0MPC15array5Array4pushGUssEE(pieces, `${assign.name}=`);
        }
      } else {
        const _Some = _bind$6;
        const _value_word = _Some;
        const value = _M0FP410Haoxincode8moonbash3lib11interpreter20type__word__to__text(_value_word);
        if (assign.append) {
          _M0MPC15array5Array4pushGUssEE(pieces, `${assign.name}+=${value}`);
        } else {
          _M0MPC15array5Array4pushGUssEE(pieces, `${assign.name}=${value}`);
        }
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$6 = simple.words;
  const _bind$7 = _bind$6.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$7) {
      const word = _bind$6[_];
      _M0MPC15array5Array4pushGUssEE(pieces, _M0FP410Haoxincode8moonbash3lib11interpreter20type__word__to__text(word));
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (pieces.length === 0) {
    return "";
  }
  const _p$4 = _M0MPC15array5Array4iterGsE(pieces);
  const _p$5 = "";
  let _p$6 = _p$5;
  while (true) {
    const _p$7 = _M0MPB4Iter4nextGUssEE(_p$4);
    if (_p$7 === undefined) {
      break;
    } else {
      const _p$8 = _p$7;
      const _p$9 = _p$8;
      const _p$10 = _p$6;
      _p$6 = _p$10.length === 0 ? _p$9 : `${_p$10} ${_p$9}`;
      continue;
    }
  }
  return _p$6;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter29type__collect__pipeline__line(pipeline, lines) {
  if (pipeline.commands.length === 0) {
    return undefined;
  }
  if (pipeline.commands.length > 1) {
    return undefined;
  }
  const _bind$4 = _M0MPC15array5Array2atGUssEE(pipeline.commands, 0);
  if (_bind$4.$tag === 0) {
    const _Simple = _bind$4;
    const _simple = _Simple._0;
    const rendered = _M0FP410Haoxincode8moonbash3lib11interpreter29type__render__simple__command(_simple);
    if (rendered.length > 0) {
      _M0MPC15array5Array4pushGUssEE(lines, rendered);
      return;
    } else {
      return;
    }
  } else {
    return;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter31type__collect__statement__lines(stmt, lines) {
  let _tmp$38 = stmt;
  _L: while (true) {
    const stmt$2 = _tmp$38;
    switch (stmt$2.$tag) {
      case 0: {
        const _Pipeline = stmt$2;
        const _pipeline = _Pipeline._0;
        _M0FP410Haoxincode8moonbash3lib11interpreter29type__collect__pipeline__line(_pipeline, lines);
        return;
      }
      case 4: {
        const _Sequence = stmt$2;
        const _pipeline$2 = _Sequence._0;
        const _right = _Sequence._1;
        _M0FP410Haoxincode8moonbash3lib11interpreter29type__collect__pipeline__line(_pipeline$2, lines);
        _tmp$38 = _right;
        continue _L;
      }
      case 1: {
        const _AndList = stmt$2;
        const _pipeline$3 = _AndList._0;
        const _right$2 = _AndList._1;
        _M0FP410Haoxincode8moonbash3lib11interpreter29type__collect__pipeline__line(_pipeline$3, lines);
        _tmp$38 = _right$2;
        continue _L;
      }
      case 2: {
        const _OrList = stmt$2;
        const _pipeline$4 = _OrList._0;
        const _right$3 = _OrList._1;
        _M0FP410Haoxincode8moonbash3lib11interpreter29type__collect__pipeline__line(_pipeline$4, lines);
        _tmp$38 = _right$3;
        continue _L;
      }
      default: {
        const _Background = stmt$2;
        const _pipeline$5 = _Background._0;
        _M0FP410Haoxincode8moonbash3lib11interpreter29type__collect__pipeline__line(_pipeline$5, lines);
        return;
      }
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter35type__render__function__body__lines(body) {
  const lines = [];
  if (body.$tag === 7) {
    const _Group = body;
    const _script = _Group._0;
    const _bind$4 = _script.statements;
    const _bind$5 = _bind$4.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$5) {
        const stmt = _bind$4[_];
        _M0FP410Haoxincode8moonbash3lib11interpreter31type__collect__statement__lines(stmt, lines);
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  return lines;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33print__type__function__definition(self, name, fndef) {
  _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name} is a function\n`);
  _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name} () \n`);
  _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, "{ \n");
  const lines = _M0FP410Haoxincode8moonbash3lib11interpreter35type__render__function__body__lines(fndef.body);
  if (lines.length === 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, "    :\n");
  } else {
    const _bind$4 = lines.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$4) {
        const line = lines[_];
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `    ${line}\n`);
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, "}\n");
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__type(self, args) {
  let opt_a = false;
  let opt_t = false;
  let opt_p = false;
  let opt_upper_p = false;
  let opt_f = false;
  let i = 0;
  while (true) {
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      if (arg === "--") {
        i = i + 1 | 0;
        break;
      }
      let _tmp$38;
      if (arg.length >= 2) {
        $bound_check(arg, 0);
        _tmp$38 = arg.charCodeAt(0) === 45;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        let recognized = true;
        let _tmp$39 = 1;
        while (true) {
          const j = _tmp$39;
          if (j < arg.length) {
            $bound_check(arg, j);
            const flag = arg.charCodeAt(j);
            switch (flag) {
              case 97: {
                opt_a = true;
                break;
              }
              case 116: {
                opt_t = true;
                break;
              }
              case 112: {
                opt_p = true;
                break;
              }
              case 80: {
                opt_upper_p = true;
                break;
              }
              case 102: {
                opt_f = true;
                break;
              }
              default: {
                recognized = false;
              }
            }
            _tmp$39 = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        if (recognized) {
          i = i + 1 | 0;
          continue;
        }
      }
      break;
    } else {
      break;
    }
  }
  if (i >= args.length) {
    self.exit_code = 1;
    return undefined;
  }
  let all_found = true;
  const file_only_mode = opt_p || opt_upper_p;
  let _tmp$38 = i;
  while (true) {
    const idx = _tmp$38;
    if (idx < args.length) {
      _L: {
        const name = _M0MPC15array5Array2atGUssEE(args, idx);
        if (name.length === 0) {
          all_found = false;
          break _L;
        }
        if (opt_t) {
          let found = false;
          const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20lookup__alias__value(self, name);
          if (_bind$4 === undefined) {
            if (!opt_f && _M0MPB3Map8containsGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self.functions, name)) {
              _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, "function\n");
              found = true;
            } else {
              if (_M0FP410Haoxincode8moonbash3lib11interpreter26is__lookup__shell__keyword(name)) {
                _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, "keyword\n");
                found = true;
              } else {
                if (_M0FP410Haoxincode8moonbash3lib11interpreter26is__lookup__shell__builtin(name)) {
                  _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, "builtin\n");
                  found = true;
                } else {
                  const _bind$5 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27first__path__command__match(self, name, false, true);
                  if (_bind$5 === undefined) {
                  } else {
                    _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, "file\n");
                    found = true;
                  }
                }
              }
            }
          } else {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, "alias\n");
            found = true;
          }
          if (!found) {
            all_found = false;
          }
          break _L;
        }
        if (file_only_mode) {
          if (_M0FP410Haoxincode8moonbash3lib11interpreter38type__builtin__without__external__path(name)) {
            all_found = false;
            break _L;
          }
          const force_path_lookup = opt_upper_p || opt_a;
          if (!force_path_lookup) {
            const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20lookup__alias__value(self, name);
            const shadowed_by_non_file = _bind$4 === undefined ? !opt_f && _M0MPB3Map8containsGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self.functions, name) || (_M0FP410Haoxincode8moonbash3lib11interpreter26is__lookup__shell__keyword(name) || _M0FP410Haoxincode8moonbash3lib11interpreter26is__lookup__shell__builtin(name)) : true;
            if (shadowed_by_non_file) {
              all_found = false;
              break _L;
            }
          }
          const matches = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27all__path__command__matches(self, name, false, true);
          let found = false;
          if (opt_a) {
            const _bind$4 = matches.length;
            let _tmp$39 = 0;
            while (true) {
              const _ = _tmp$39;
              if (_ < _bind$4) {
                const match_item = matches[_];
                const _display = match_item._0;
                _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_display}\n`);
                found = true;
                _tmp$39 = _ + 1 | 0;
                continue;
              } else {
                break;
              }
            }
          } else {
            if (matches.length > 0) {
              const _bind$4 = _M0MPC15array5Array2atGUssEE(matches, 0);
              const _display = _bind$4._0;
              _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_display}\n`);
              found = true;
            }
          }
          if (!found) {
            all_found = false;
          }
          break _L;
        }
        if (opt_a) {
          let found = false;
          const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20lookup__alias__value(self, name);
          if (_bind$4 === undefined) {
          } else {
            const _Some = _bind$4;
            const _alias_value = _Some;
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name} is an alias for \"${_alias_value}\"\n`);
            found = true;
          }
          if (!opt_f) {
            const _bind$5 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self.functions, name);
            if (_bind$5 === undefined) {
            } else {
              const _Some = _bind$5;
              const _fndef = _Some;
              _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33print__type__function__definition(self, name, _fndef);
              found = true;
            }
          }
          if (_M0FP410Haoxincode8moonbash3lib11interpreter26is__lookup__shell__keyword(name)) {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name} is a shell keyword\n`);
            found = true;
          }
          if (_M0FP410Haoxincode8moonbash3lib11interpreter26is__lookup__shell__builtin(name)) {
            const builtin_kind = _M0FP410Haoxincode8moonbash3lib11interpreter27is__special__shell__builtin(name) ? "special shell builtin" : "shell builtin";
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name} is a ${builtin_kind}\n`);
            found = true;
          }
          if (!_M0FP410Haoxincode8moonbash3lib11interpreter38type__builtin__without__external__path(name)) {
            const _bind$5 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27all__path__command__matches(self, name, false, true);
            const _bind$6 = _bind$5.length;
            let _tmp$39 = 0;
            while (true) {
              const _ = _tmp$39;
              if (_ < _bind$6) {
                const match_item = _bind$5[_];
                const _display = match_item._0;
                _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name} is ${_display}\n`);
                found = true;
                _tmp$39 = _ + 1 | 0;
                continue;
              } else {
                break;
              }
            }
          }
          if (!found) {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `${name}: not found\n`);
            all_found = false;
          }
          break _L;
        }
        const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20lookup__alias__value(self, name);
        if (_bind$4 === undefined) {
        } else {
          const _Some = _bind$4;
          const _alias_value = _Some;
          _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name} is an alias for \"${_alias_value}\"\n`);
          break _L;
        }
        if (!opt_f) {
          const _bind$5 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self.functions, name);
          if (_bind$5 === undefined) {
          } else {
            const _Some = _bind$5;
            const _fndef = _Some;
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33print__type__function__definition(self, name, _fndef);
            break _L;
          }
        }
        if (_M0FP410Haoxincode8moonbash3lib11interpreter26is__lookup__shell__keyword(name)) {
          _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name} is a shell keyword\n`);
          break _L;
        }
        if (_M0FP410Haoxincode8moonbash3lib11interpreter26is__lookup__shell__builtin(name)) {
          const builtin_kind = _M0FP410Haoxincode8moonbash3lib11interpreter27is__special__shell__builtin(name) ? "special shell builtin" : "shell builtin";
          _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name} is a ${builtin_kind}\n`);
          break _L;
        }
        const _bind$5 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27first__path__command__match(self, name, false, true);
        if (_bind$5 === undefined) {
          _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `${name}: not found\n`);
          all_found = false;
        } else {
          const _Some = _bind$5;
          const _x = _Some;
          const _display = _x._0;
          _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name} is ${_display}\n`);
        }
        break _L;
      }
      _tmp$38 = idx + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = all_found ? 0 : 1;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__unalias(self, args) {
  if (args.length === 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "moon_bash: unalias: usage: unalias [-a] name ...\n");
    self.exit_code = 2;
    return undefined;
  }
  let start = 0;
  let remove_all = false;
  if (_M0MPC15array5Array2atGUssEE(args, start) === "--") {
    start = start + 1 | 0;
  } else {
    if (_M0MPC15array5Array2atGUssEE(args, start) === "-a") {
      remove_all = true;
      start = start + 1 | 0;
    }
  }
  if (remove_all) {
    if (start < args.length && _M0MPC15array5Array2atGUssEE(args, start) === "--") {
      start = start + 1 | 0;
    }
    const to_remove = [];
    const _it = _M0MPB3Map5iter2GssE(self.env);
    while (true) {
      const _bind$4 = _M0MPB5Iter24nextGssE(_it);
      if (_bind$4 === undefined) {
        break;
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        const _k = _x._0;
        if (_M0MPC16string6String11has__prefix(_k, new _M0TPC16string10StringView(_M0FP410Haoxincode8moonbash3lib11interpreter13alias__prefix, 0, _M0FP410Haoxincode8moonbash3lib11interpreter13alias__prefix.length))) {
          _M0MPC15array5Array4pushGUssEE(to_remove, _k);
        }
        continue;
      }
    }
    const _bind$4 = to_remove.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$4) {
        const k = to_remove[_];
        _M0MPB3Map6removeGssE(self.env, k);
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    self.exit_code = 0;
    return undefined;
  }
  if (start >= args.length) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "moon_bash: unalias: usage: unalias [-a] name ...\n");
    self.exit_code = 2;
    return undefined;
  }
  let _tmp$38 = start;
  while (true) {
    const i = _tmp$38;
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      const key = `${_M0FP410Haoxincode8moonbash3lib11interpreter13alias__prefix}${arg}`;
      if (_M0MPB3Map8containsGssE(self.env, key)) {
        _M0MPB3Map6removeGssE(self.env, key);
      } else {
        _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: unalias: ${arg}: not found\n`);
        self.exit_code = 1;
        return undefined;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter27write__unexpand__space__run(out, count, start_col, tab_width) {
  let remaining = count;
  let col = start_col;
  while (true) {
    if (remaining > 0) {
      let to_tab = tab_width - (col % tab_width | 0) | 0;
      if (to_tab <= 0) {
        to_tab = tab_width;
      }
      if (to_tab <= remaining) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 9);
        col = col + to_tab | 0;
        remaining = remaining - to_tab | 0;
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 32);
        col = col + 1 | 0;
        remaining = remaining - 1 | 0;
      }
      continue;
    } else {
      return;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter14unexpand__tabs(input, tab_width, convert_all) {
  const width = tab_width <= 0 ? 8 : tab_width;
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let col = 0;
  let leading = true;
  let pending_spaces = 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < input.length) {
      _L: {
        $bound_check(input, i);
        const ch = input.charCodeAt(i);
        if (ch === 32) {
          pending_spaces = pending_spaces + 1 | 0;
          col = col + 1 | 0;
          break _L;
        }
        if (pending_spaces > 0) {
          const start_col = col - pending_spaces | 0;
          if (convert_all || leading) {
            _M0FP410Haoxincode8moonbash3lib11interpreter27write__unexpand__space__run(out, pending_spaces, start_col, width);
          } else {
            _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter12repeat__char(32, pending_spaces));
          }
          pending_spaces = 0;
        }
        if (ch === 10) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 10);
          col = 0;
          leading = true;
          break _L;
        }
        if (ch === 9) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 9);
          const advance = width - (col % width | 0) | 0;
          col = col + advance | 0;
          break _L;
        }
        _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        col = col + 1 | 0;
        leading = false;
        break _L;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (pending_spaces > 0) {
    const start_col = col - pending_spaces | 0;
    if (convert_all || leading) {
      _M0FP410Haoxincode8moonbash3lib11interpreter27write__unexpand__space__run(out, pending_spaces, start_col, width);
    } else {
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter12repeat__char(32, pending_spaces));
    }
  }
  return out.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17builtin__unexpand(self, args) {
  let convert_all = false;
  let tab_width = 8;
  const files = [];
  let i = 0;
  while (true) {
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      if (arg === "-a") {
        convert_all = true;
        i = i + 1 | 0;
        continue;
      }
      if (arg === "-t" && (i + 1 | 0) < args.length) {
        tab_width = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(args, i + 1 | 0));
        i = i + 2 | 0;
        continue;
      }
      if (_M0MPC16string6String11has__prefix(arg, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17builtin__unexpandN7_2abindS8077, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17builtin__unexpandN7_2abindS8077.length)) && arg.length > 2) {
        tab_width = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, 2, undefined)));
        i = i + 1 | 0;
        continue;
      }
      let _tmp$38;
      if (arg.length > 1) {
        $bound_check(arg, 0);
        const _p$4 = arg.charCodeAt(0);
        const _p$5 = 45;
        _tmp$38 = _p$4 === _p$5;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        let _tmp$39 = 1;
        _L: while (true) {
          const j = _tmp$39;
          if (j < arg.length) {
            $bound_check(arg, j);
            const flag = arg.charCodeAt(j);
            switch (flag) {
              case 97: {
                convert_all = true;
                break;
              }
              case 116: {
                if ((j + 1 | 0) < arg.length) {
                  tab_width = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(arg, j + 1 | 0, undefined)));
                } else {
                  if ((i + 1 | 0) < args.length) {
                    i = i + 1 | 0;
                    tab_width = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(args, i));
                  }
                }
                break _L;
              }
            }
            _tmp$39 = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        i = i + 1 | 0;
        continue;
      }
      _M0MPC15array5Array4pushGUssEE(files, arg);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (tab_width <= 0) {
    tab_width = 8;
  }
  if (files.length === 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0FP410Haoxincode8moonbash3lib11interpreter14unexpand__tabs(self.stdin_buf, tab_width, convert_all));
    self.exit_code = 0;
    return undefined;
  }
  const _bind$4 = files.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const path = files[_];
      let resolved;
      let _try_err;
      _L: {
        _L$2: {
          const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, path);
          if (_bind$5.$tag === 1) {
            const _ok = _bind$5;
            resolved = _ok._0;
          } else {
            const _err = _bind$5;
            _try_err = _err._0;
            break _L$2;
          }
          break _L;
        }
        resolved = path;
      }
      let content;
      let _try_err$2;
      _L$2: {
        _L$3: {
          const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(self.fs, resolved);
          if (_bind$5.$tag === 1) {
            const _ok = _bind$5;
            content = _ok._0;
          } else {
            const _err = _bind$5;
            _try_err$2 = _err._0;
            break _L$3;
          }
          break _L$2;
        }
        const _FsError = _try_err$2;
        const _msg = _FsError._0;
        _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `unexpand: ${_msg}\n`);
        self.exit_code = 1;
        return undefined;
      }
      _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, _M0FP410Haoxincode8moonbash3lib11interpreter14unexpand__tabs(content, tab_width, convert_all));
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__uniqN13format__countS1424(value) {
  const text = _M0MPC13int3Int18to__string_2einner(value, 10);
  let pad = 4 - text.length | 0;
  if (pad < 0) {
    pad = 0;
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < pad) {
      _M0IPB13StringBuilderPB6Logger11write__char(out, 32);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger13write__string(out, text);
  return out.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__uniqN12should__emitS1426(_env, group_count) {
  const unique_only = _env._1;
  const duplicates_only = _env._0;
  return duplicates_only.val && unique_only.val ? false : duplicates_only.val ? group_count > 1 : unique_only.val ? group_count === 1 : true;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__uniq(self, args) {
  let count_mode = false;
  const duplicates_only = new _M0TPB8MutLocalGbE(false);
  const unique_only = new _M0TPB8MutLocalGbE(false);
  let input_file = undefined;
  const _bind$4 = args.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const arg = args[_];
      let _tmp$39;
      if (arg.length > 1) {
        $bound_check(arg, 0);
        const _p$4 = arg.charCodeAt(0);
        const _p$5 = 45;
        _tmp$39 = _p$4 === _p$5;
      } else {
        _tmp$39 = false;
      }
      if (_tmp$39) {
        let _tmp$40 = 1;
        while (true) {
          const i = _tmp$40;
          if (i < arg.length) {
            $bound_check(arg, i);
            const flag = arg.charCodeAt(i);
            switch (flag) {
              case 99: {
                count_mode = true;
                break;
              }
              case 100: {
                duplicates_only.val = true;
                break;
              }
              case 117: {
                unique_only.val = true;
                break;
              }
            }
            _tmp$40 = i + 1 | 0;
            continue;
          } else {
            break;
          }
        }
      } else {
        input_file = arg;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$5 = input_file;
  let input;
  if (_bind$5 === undefined) {
    input = self.stdin_buf;
  } else {
    const _Some = _bind$5;
    const _path = _Some;
    let resolved;
    let _try_err;
    _L: {
      _L$2: {
        const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, _path);
        if (_bind$6.$tag === 1) {
          const _ok = _bind$6;
          resolved = _ok._0;
        } else {
          const _err = _bind$6;
          _try_err = _err._0;
          break _L$2;
        }
        break _L;
      }
      resolved = _path;
    }
    let _try_err$2;
    _L$2: {
      _L$3: {
        const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(self.fs, resolved);
        if (_bind$6.$tag === 1) {
          const _ok = _bind$6;
          input = _ok._0;
        } else {
          const _err = _bind$6;
          _try_err$2 = _err._0;
          break _L$3;
        }
        break _L$2;
      }
      const _FsError = _try_err$2;
      const _msg = _FsError._0;
      _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `uniq: ${_msg}\n`);
      self.exit_code = 1;
      return undefined;
    }
  }
  const lines = _M0FP410Haoxincode8moonbash3lib11interpreter26split__lines__no__trailing(input);
  let prev = "";
  let count = 0;
  const _env = { _0: duplicates_only, _1: unique_only };
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < lines.length) {
      let _tmp$40;
      if (i === 0) {
        _tmp$40 = true;
      } else {
        const _p$4 = _M0MPC15array5Array2atGUssEE(lines, i);
        const _p$5 = prev;
        _tmp$40 = !(_p$4 === _p$5);
      }
      if (_tmp$40) {
        if (i > 0) {
          if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__uniqN12should__emitS1426(_env, count)) {
            if (count_mode) {
              _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__uniqN13format__countS1424(count)} ${prev}\n`);
            } else {
              _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${prev}\n`);
            }
          }
        }
        prev = _M0MPC15array5Array2atGUssEE(lines, i);
        count = 1;
      } else {
        count = count + 1 | 0;
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (lines.length > 0) {
    if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__uniqN12should__emitS1426(_env, count)) {
      if (count_mode) {
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__uniqN13format__countS1424(count)} ${prev}\n`);
      } else {
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${prev}\n`);
      }
    }
  }
  self.exit_code = 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__which(self, args) {
  if (args.length === 0) {
    self.exit_code = 1;
    return undefined;
  }
  let all_found = true;
  const _bind$4 = args.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const arg = args[_];
      const _bind$5 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27first__path__command__match(self, arg, false, true);
      if (_bind$5 === undefined) {
        if (_M0FP410Haoxincode8moonbash3lib11interpreter26is__lookup__shell__builtin(arg)) {
          _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${arg}\n`);
        } else {
          _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `which: no ${arg} in PATH\n`);
          all_found = false;
        }
      } else {
        const _Some = _bind$5;
        const _x = _Some;
        const _display = _x._0;
        _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_display}\n`);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = all_found ? 0 : 1;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15builtin__whoami(self, _args) {
  const _tmp$38 = self.stdout_buf;
  const _p$4 = _M0MPB3Map3getGssE(self.env, "USER");
  const _p$5 = "user";
  let _tmp$39;
  if (_p$4 === undefined) {
    _tmp$39 = _p$5;
  } else {
    const _p$6 = _p$4;
    _tmp$39 = _p$6;
  }
  _M0IPB13StringBuilderPB6Logger13write__string(_tmp$38, `${_tmp$39}\n`);
  self.exit_code = 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31skip__function__lookup__enabled(self) {
  const _p$4 = _M0MPB3Map3getGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter36command__skip__function__lookup__key);
  const _p$5 = "";
  let _tmp$38;
  if (_p$4 === undefined) {
    _tmp$38 = _p$5;
  } else {
    const _p$6 = _p$4;
    _tmp$38 = _p$6;
  }
  return _tmp$38 === "1";
}
function _M0FP410Haoxincode8moonbash3lib11interpreter22alias__is__blank__char(ch) {
  return ch === 32 || (ch === 9 || (ch === 10 || ch === 13));
}
function _M0FP410Haoxincode8moonbash3lib11interpreter25alias__is__operator__char(ch) {
  return ch === 59 || (ch === 124 || (ch === 38 || (ch === 40 || (ch === 41 || (ch === 60 || (ch === 62 || (ch === 123 || ch === 125)))))));
}
function _M0FP410Haoxincode8moonbash3lib11interpreter24alias__first__word__span(source) {
  let i = 0;
  while (true) {
    if (i < source.length) {
      const _tmp$38 = i;
      $bound_check(source, _tmp$38);
      const ch = source.charCodeAt(_tmp$38);
      if (!_M0FP410Haoxincode8moonbash3lib11interpreter22alias__is__blank__char(ch)) {
        break;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (i >= source.length) {
    return undefined;
  }
  const _tmp$38 = i;
  $bound_check(source, _tmp$38);
  const first = source.charCodeAt(_tmp$38);
  if (_M0FP410Haoxincode8moonbash3lib11interpreter25alias__is__operator__char(first) || (first === 39 || first === 34)) {
    return undefined;
  }
  const start = i;
  while (true) {
    if (i < source.length) {
      const _tmp$39 = i;
      $bound_check(source, _tmp$39);
      const ch = source.charCodeAt(_tmp$39);
      if (_M0FP410Haoxincode8moonbash3lib11interpreter22alias__is__blank__char(ch) || _M0FP410Haoxincode8moonbash3lib11interpreter25alias__is__operator__char(ch)) {
        break;
      }
      if (ch === 39 || (ch === 34 || ch === 92)) {
        return undefined;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (i <= start) {
    return undefined;
  }
  const word = _M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(source, start, i);
  return word.length === 0 ? undefined : { _0: start, _1: i, _2: word };
}
function _M0FP410Haoxincode8moonbash3lib11interpreter25append__alias__call__args(source, args) {
  if (args.length === 0) {
    return source;
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger13write__string(out, source);
  if (source.length > 0) {
    const _tmp$38 = source.length - 1 | 0;
    $bound_check(source, _tmp$38);
    const last = source.charCodeAt(_tmp$38);
    if (!_M0FP410Haoxincode8moonbash3lib11interpreter22alias__is__blank__char(last)) {
      _M0IPB13StringBuilderPB6Logger11write__char(out, 32);
    }
  }
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < args.length) {
      if (i > 0) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 32);
      }
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0FP410Haoxincode8moonbash3lib11interpreter20printf__shell__quote(_M0MPC15array5Array2atGUssEE(args, i)));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31resolve__alias__command__source(self, alias_name, args) {
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20lookup__alias__value(self, alias_name);
  let source;
  if (_bind$4 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$4;
    source = _Some;
  }
  const _bind$5 = [];
  const seen = _M0MPB3Map3MapGsbE(new _M0TPB9ArrayViewGUsbEE(_bind$5, 0, 0), undefined);
  _M0MPB3Map3setGsbE(seen, alias_name, true);
  let steps = 0;
  while (true) {
    if (steps < 64) {
      steps = steps + 1 | 0;
      const _bind$6 = _M0FP410Haoxincode8moonbash3lib11interpreter24alias__first__word__span(source);
      if (_bind$6 === undefined) {
        break;
      } else {
        const _Some = _bind$6;
        const _x = _Some;
        const _start = _x._0;
        const _end_ = _x._1;
        const _first_word = _x._2;
        if (_M0MPB3Map8containsGsbE(seen, _first_word)) {
          break;
        }
        const _bind$7 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20lookup__alias__value(self, _first_word);
        if (_bind$7 === undefined) {
          break;
        } else {
          const _Some$2 = _bind$7;
          const _next_value = _Some$2;
          _M0MPB3Map3setGsbE(seen, _first_word, true);
          source = `${_M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(source, 0, _start)}${_next_value}${_M0FP410Haoxincode8moonbash3lib11interpreter16substring__slice(source, _end_, source.length)}`;
        }
      }
      continue;
    } else {
      break;
    }
  }
  return _M0FP410Haoxincode8moonbash3lib11interpreter25append__alias__call__args(source, args);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18flatten__statement(self, stmt, pipelines, ops) {
  let _tmp$38 = stmt;
  _L: while (true) {
    const stmt$2 = _tmp$38;
    switch (stmt$2.$tag) {
      case 0: {
        const _Pipeline = stmt$2;
        const _pipeline = _Pipeline._0;
        _M0MPC15array5Array4pushGUssEE(pipelines, _pipeline);
        return;
      }
      case 1: {
        const _AndList = stmt$2;
        const _pipeline$2 = _AndList._0;
        const _next = _AndList._1;
        _M0MPC15array5Array4pushGUssEE(pipelines, _pipeline$2);
        _M0MPC15array5Array4pushGiE(ops, 1);
        _tmp$38 = _next;
        continue _L;
      }
      case 2: {
        const _OrList = stmt$2;
        const _pipeline$3 = _OrList._0;
        const _next$2 = _OrList._1;
        _M0MPC15array5Array4pushGUssEE(pipelines, _pipeline$3);
        _M0MPC15array5Array4pushGiE(ops, 2);
        _tmp$38 = _next$2;
        continue _L;
      }
      case 4: {
        const _Sequence = stmt$2;
        const _pipeline$4 = _Sequence._0;
        const _next$3 = _Sequence._1;
        _M0MPC15array5Array4pushGUssEE(pipelines, _pipeline$4);
        _M0MPC15array5Array4pushGiE(ops, 0);
        _tmp$38 = _next$3;
        continue _L;
      }
      default: {
        const _Background = stmt$2;
        const _pipeline$5 = _Background._0;
        _M0MPC15array5Array4pushGUssEE(pipelines, _pipeline$5);
        return;
      }
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32stash__pending__cmd__sub__stderr(self, spec, output) {
  let _tmp$38;
  if (output.length === 0) {
    _tmp$38 = true;
  } else {
    let _tmp$39;
    if (spec.length < 3) {
      _tmp$39 = true;
    } else {
      $bound_check(spec, 1);
      const _p$4 = spec.charCodeAt(1);
      const _p$5 = 58;
      _tmp$39 = _p$4 !== _p$5;
    }
    _tmp$38 = _tmp$39;
  }
  if (_tmp$38) {
    return undefined;
  }
  const path = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(spec, 2, undefined));
  let resolved;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, path);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        resolved = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    resolved = path;
  }
  const _bind$4 = _M0MPB3Map3getGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32stash__pending__cmd__sub__stderrN18pending__path__keyS2239);
  if (_bind$4 === undefined) {
    _M0MPB3Map3setGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32stash__pending__cmd__sub__stderrN18pending__path__keyS2239, resolved);
    _M0MPB3Map3setGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32stash__pending__cmd__sub__stderrN18pending__data__keyS2240, output);
    return;
  } else {
    const _Some = _bind$4;
    const _existing_path = _Some;
    if (_existing_path === resolved) {
      const _tmp$39 = self.env;
      const _p$4 = _M0MPB3Map3getGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32stash__pending__cmd__sub__stderrN18pending__data__keyS2240);
      const _p$5 = "";
      let _tmp$40;
      if (_p$4 === undefined) {
        _tmp$40 = _p$5;
      } else {
        const _p$6 = _p$4;
        _tmp$40 = _p$6;
      }
      _M0MPB3Map3setGssE(_tmp$39, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32stash__pending__cmd__sub__stderrN18pending__data__keyS2240, `${_tmp$40}${output}`);
      return;
    } else {
      _M0MPB3Map3setGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32stash__pending__cmd__sub__stderrN18pending__path__keyS2239, resolved);
      _M0MPB3Map3setGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32stash__pending__cmd__sub__stderrN18pending__data__keyS2240, output);
      return;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter23array__count__var__name(name) {
  if (name.length >= 3) {
    const suffix = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(name, name.length - 3 | 0, name.length));
    if (suffix === "[@]" || suffix === "[*]") {
      const base = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(name, 0, name.length - 3 | 0));
      return `__MOON_BASH_ARRAY_COUNT__${base}`;
    }
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter25expand__scalar__substring(value, offset, len) {
  const value_len = BigInt.asUintN(64, BigInt(value.length));
  let actual_offset;
  if (BigInt.asIntN(64, offset) < BigInt.asIntN(64, 0n)) {
    const o = BigInt.asUintN(64, value_len + offset);
    actual_offset = BigInt.asIntN(64, o) < BigInt.asIntN(64, 0n) ? 0n : o;
  } else {
    actual_offset = offset;
  }
  let actual_len;
  if (len === undefined) {
    actual_len = value_len;
  } else {
    const _Some = len;
    actual_len = _Some;
  }
  const end = BigInt.asIntN(64, BigInt.asUintN(64, actual_offset + actual_len)) > BigInt.asIntN(64, value_len) ? value_len : BigInt.asUintN(64, actual_offset + actual_len);
  return BigInt.asIntN(64, actual_offset) >= BigInt.asIntN(64, value_len) || BigInt.asIntN(64, actual_len) <= BigInt.asIntN(64, 0n) ? "" : _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(value, Number(BigInt.asIntN(32, actual_offset)) | 0, Number(BigInt.asIntN(32, end)) | 0));
}
function _M0FP410Haoxincode8moonbash3lib11interpreter25indirection__prefix__name(name) {
  if (name.length <= 1) {
    return undefined;
  }
  const _tmp$38 = name.length - 1 | 0;
  $bound_check(name, _tmp$38);
  const last = name.charCodeAt(_tmp$38);
  if (last === 42 || last === 64) {
    const prefix = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(name, 0, name.length - 1 | 0));
    if (prefix.length > 0) {
      return prefix;
    }
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter12lower__first(s) {
  if (s.length === 0) {
    return s;
  }
  $bound_check(s, 0);
  const first = s.charCodeAt(0);
  const lower = first >= 65 && first <= 90 ? first + 32 | 0 : first;
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger11write__char(buf, lower);
  let _tmp$38 = 1;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      _M0IPB13StringBuilderPB6Logger11write__char(buf, s.charCodeAt(i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter12upper__first(s) {
  if (s.length === 0) {
    return s;
  }
  $bound_check(s, 0);
  const first = s.charCodeAt(0);
  const upper = first >= 97 && first <= 122 ? first - 32 | 0 : first;
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger11write__char(buf, upper);
  let _tmp$38 = 1;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      _M0IPB13StringBuilderPB6Logger11write__char(buf, s.charCodeAt(i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19expand__array__keys(self, base) {
  const keys = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20collect__array__keys(self, base);
  const _p$4 = _M0MPC15array5Array4iterGsE(keys);
  const _p$5 = "";
  let _p$6 = _p$5;
  while (true) {
    const _p$7 = _M0MPB4Iter4nextGUssEE(_p$4);
    if (_p$7 === undefined) {
      break;
    } else {
      const _p$8 = _p$7;
      const _p$9 = _p$8;
      const _p$10 = _p$6;
      _p$6 = _p$10.length === 0 ? _p$9 : `${_p$10} ${_p$9}`;
      continue;
    }
  }
  return _p$6;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext35expand__array__parameter__transform(self, name, transform) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter29parse__array__reference__name(name);
  if (_bind$4 === undefined) {
    return _M0DTPC16option6OptionGRPB5ArrayGsEE4None__;
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _base = _x._0;
    const _index = _x._1;
    const values = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext35expand__array__elements__for__words(self, _base);
    const transformed = [];
    const _bind$5 = values.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$5) {
        const value = values[_];
        _M0MPC15array5Array4pushGUssEE(transformed, transform(value));
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    if (_index === "*") {
      const _p$4 = _M0MPB3Map3getGssE(self.env, "IFS");
      const _p$5 = " \t\n";
      let _tmp$39;
      if (_p$4 === undefined) {
        _tmp$39 = _p$5;
      } else {
        const _p$6 = _p$4;
        _tmp$39 = _p$6;
      }
      return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some([_M0FP410Haoxincode8moonbash3lib11interpreter23join__values__with__ifs(transformed, _tmp$39)]);
    } else {
      return _index === "@" ? new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some(transformed) : _M0DTPC16option6OptionGRPB5ArrayGsEE4None__;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter20slice__array__values(values, offset, len) {
  const out = [];
  const values_len = BigInt.asUintN(64, BigInt(values.length));
  let start = BigInt.asIntN(64, offset) < BigInt.asIntN(64, 0n) ? BigInt.asUintN(64, values_len + offset) : offset;
  if (BigInt.asIntN(64, start) < BigInt.asIntN(64, 0n)) {
    start = 0n;
  }
  if (BigInt.asIntN(64, start) >= BigInt.asIntN(64, values_len)) {
    return out;
  }
  let end_ = values_len;
  if (len === undefined) {
  } else {
    const _Some = len;
    const _length = _Some;
    if (BigInt.asIntN(64, _length) <= BigInt.asIntN(64, 0n)) {
      return out;
    }
    end_ = BigInt.asUintN(64, start + _length);
    if (BigInt.asIntN(64, end_) > BigInt.asIntN(64, values_len)) {
      end_ = values_len;
    }
  }
  let _tmp$38 = Number(BigInt.asIntN(32, start)) | 0;
  while (true) {
    const i = _tmp$38;
    if (i < (Number(BigInt.asIntN(32, end_)) | 0)) {
      _M0MPC15array5Array4pushGUssEE(out, _M0MPC15array5Array2atGUssEE(values, i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext41expand__indexed__array__substring__values(self, base, offset, len) {
  const keys = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20collect__array__keys(self, base);
  if (keys.length === 0) {
    const values = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext35expand__array__elements__for__words(self, base);
    return _M0FP410Haoxincode8moonbash3lib11interpreter20slice__array__values(values, offset, len);
  }
  const start = BigInt.asIntN(64, offset) < BigInt.asIntN(64, 0n) ? BigInt.asUintN(64, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22indexed__array__origin(self, base) + offset) : offset;
  if (BigInt.asIntN(64, start) < BigInt.asIntN(64, 0n)) {
    return [];
  }
  const out = [];
  let remaining;
  if (len === undefined) {
    remaining = 18446744073709551615n;
  } else {
    const _Some = len;
    const _length = _Some;
    if (BigInt.asIntN(64, _length) <= BigInt.asIntN(64, 0n)) {
      return [];
    }
    remaining = _length;
  }
  const _bind$4 = keys.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const key = keys[_];
      const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter36parse__non__negative__int__for__sort(key);
      if (_bind$5 === undefined) {
      } else {
        const _Some = _bind$5;
        const _index = _Some;
        if (BigInt.asIntN(64, BigInt.asUintN(64, BigInt(_index))) >= BigInt.asIntN(64, start)) {
          if (BigInt.asUintN(64, remaining) !== BigInt.asUintN(64, 0n)) {
            const _p$4 = _M0MPB3Map3getGssE(self.env, `${base}[${key}]`);
            const _p$5 = "";
            let _tmp$39;
            if (_p$4 === undefined) {
              _tmp$39 = _p$5;
            } else {
              const _p$6 = _p$4;
              _tmp$39 = _p$6;
            }
            _M0MPC15array5Array4pushGUssEE(out, _tmp$39);
            if (BigInt.asIntN(64, remaining) > BigInt.asIntN(64, 0n)) {
              remaining = BigInt.asUintN(64, remaining - 1n);
            }
          }
        }
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter36escape__split__protect__marker__only(text) {
  if (text.length === 0) {
    return text;
  }
  const marker = 31;
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < text.length) {
      $bound_check(text, i);
      const ch = text.charCodeAt(i);
      if (ch === marker) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, marker);
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext36encode__word__split__protected__text(self, text) {
  if (text.length === 0) {
    return text;
  }
  const _p$4 = _M0MPB3Map3getGssE(self.env, "IFS");
  const _p$5 = " \t\n";
  let ifs;
  if (_p$4 === undefined) {
    ifs = _p$5;
  } else {
    const _p$6 = _p$4;
    ifs = _p$6;
  }
  const marker = 31;
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < text.length) {
      $bound_check(text, i);
      const ch = text.charCodeAt(i);
      if (ch === marker || _M0FP410Haoxincode8moonbash3lib11interpreter13is__ifs__char(ch, ifs)) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, marker);
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32inside__double__quote__expansion(self) {
  const _p$4 = _M0MPB3Map3getGssE(self.env, "__MOON_BASH_IN_DQUOTE_EXPANSION__");
  const _p$5 = "";
  let _tmp$38;
  if (_p$4 === undefined) {
    _tmp$38 = _p$5;
  } else {
    const _p$6 = _p$4;
    _tmp$38 = _p$6;
  }
  return _tmp$38 === "1";
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27split__protection__disabled(self) {
  const _p$4 = _M0MPB3Map3getGssE(self.env, "__MOON_BASH_DISABLE_SPLIT_PROTECTION__");
  const _p$5 = "";
  let _tmp$38;
  if (_p$4 === undefined) {
    _tmp$38 = _p$5;
  } else {
    const _p$6 = _p$4;
    _tmp$38 = _p$6;
  }
  return _tmp$38 === "1";
}
function _M0FP410Haoxincode8moonbash3lib11interpreter31quote__value__for__q__transform(value) {
  if (value.length === 0) {
    return "''";
  }
  let has_single_quote = false;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < value.length) {
      $bound_check(value, i);
      if (value.charCodeAt(i) === 39) {
        has_single_quote = true;
        break;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (!has_single_quote) {
    return _M0FP410Haoxincode8moonbash3lib11interpreter20printf__shell__quote(value);
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger13write__string(out, "$'");
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < value.length) {
      $bound_check(value, i);
      const ch = value.charCodeAt(i);
      switch (ch) {
        case 92: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, "\\\\");
          break;
        }
        case 39: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, "\\'");
          break;
        }
        case 10: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, "\\n");
          break;
        }
        case 9: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, "\\t");
          break;
        }
        case 13: {
          _M0IPB13StringBuilderPB6Logger13write__string(out, "\\r");
          break;
        }
        default: {
          _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
        }
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger11write__char(out, 39);
  return out.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22array__attribute__flag(self, base) {
  const _p$4 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_ARRAY_KIND__${base}`);
  const _p$5 = "";
  let _tmp$38;
  if (_p$4 === undefined) {
    _tmp$38 = _p$5;
  } else {
    const _p$6 = _p$4;
    _tmp$38 = _p$6;
  }
  if (_tmp$38 === "assoc") {
    return "A";
  } else {
    return "a";
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter39quote__array__values__for__q__transform(values) {
  const quoted = [];
  const _bind$4 = values.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const value = values[_];
      _M0MPC15array5Array4pushGUssEE(quoted, _M0FP410Haoxincode8moonbash3lib11interpreter31quote__value__for__q__transform(value));
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return quoted;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24transform__array__values(self, base, values, transform) {
  _L: {
    if (transform === -1) {
      break _L;
    } else {
      const _Some = transform;
      const _x = _Some;
      switch (_x) {
        case 81: {
          return _M0FP410Haoxincode8moonbash3lib11interpreter39quote__array__values__for__q__transform(values);
        }
        case 97: {
          const attrs = [];
          const attr = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22array__attribute__flag(self, base);
          const _bind$4 = values.length;
          let _tmp$38 = 0;
          while (true) {
            const _ = _tmp$38;
            if (_ < _bind$4) {
              _M0MPC15array5Array4pushGUssEE(attrs, attr);
              _tmp$38 = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          return attrs;
        }
        default: {
          break _L;
        }
      }
    }
  }
  return values;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31expand__variables__with__prefix(self, prefix) {
  const names = [];
  const _it = _M0MPB3Map5iter2GssE(self.env);
  while (true) {
    const _bind$4 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _key = _x._0;
      if (_M0FP410Haoxincode8moonbash3lib11interpreter12starts__with(_key, prefix)) {
        _M0MPC15array5Array4pushGUssEE(names, _key);
      }
      continue;
    }
  }
  _M0FP410Haoxincode8moonbash3lib11interpreter13sort__strings(names);
  const _p$4 = _M0MPC15array5Array4iterGsE(names);
  const _p$5 = "";
  let _p$6 = _p$5;
  while (true) {
    const _p$7 = _M0MPB4Iter4nextGUssEE(_p$4);
    if (_p$7 === undefined) {
      break;
    } else {
      const _p$8 = _p$7;
      const _p$9 = _p$8;
      const _p$10 = _p$6;
      _p$6 = _p$10.length === 0 ? _p$9 : `${_p$10} ${_p$9}`;
      continue;
    }
  }
  return _p$6;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19parameter__is__null(self, name, value) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter29parse__array__reference__name(name);
  if (_bind$4 === undefined) {
    const _bind$5 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_ARRAY_COUNT__${name}`);
    if (_bind$5 === undefined) {
      return value.length === 0;
    } else {
      const _Some = _bind$5;
      const _raw_count = _Some;
      const count = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_raw_count);
      return count <= 0 ? true : value.length === 0;
    }
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _base = _x._0;
    const _index = _x._1;
    if (_index === "@" || _index === "*") {
      const _p$4 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_ARRAY_COUNT__${_base}`);
      const _p$5 = "-1";
      let _tmp$38;
      if (_p$4 === undefined) {
        _tmp$38 = _p$5;
      } else {
        const _p$6 = _p$4;
        _tmp$38 = _p$6;
      }
      const count = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_tmp$38);
      if (count <= 0) {
        return true;
      }
      if (count === 1) {
        const values = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext35expand__array__elements__for__words(self, _base);
        return values.length === 0 || _M0MPC15array5Array2atGUssEE(values, 0).length === 0;
      }
      return false;
    }
    return value.length === 0;
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18parameter__is__set(self, name) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter29parse__array__reference__name(name);
  if (_bind$4 === undefined) {
    const _bind$5 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_ARRAY_COUNT__${name}`);
    if (_bind$5 === undefined) {
      return _M0MPB3Map8containsGssE(self.env, name);
    } else {
      const _Some = _bind$5;
      const _raw_count = _Some;
      return _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_raw_count) > 0;
    }
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _base = _x._0;
    const _index = _x._1;
    if (_index === "@" || _index === "*") {
      const _p$4 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_ARRAY_COUNT__${_base}`);
      const _p$5 = "-1";
      let _tmp$38;
      if (_p$4 === undefined) {
        _tmp$38 = _p$5;
      } else {
        const _p$6 = _p$4;
        _tmp$38 = _p$6;
      }
      const count = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_tmp$38);
      if (count >= 0) {
        return count > 0;
      }
      return _M0MPB3Map8containsGssE(self.env, _base) || _M0MPB3Map8containsGssE(self.env, `${_base}[${_index}]`);
    }
    return _M0MPB3Map8containsGssE(self.env, `${_base}[${_index}]`);
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext45slice__positional__parameters__for__substring(self, offset, len) {
  const _bind$4 = _M0MPB3Map3getGssE(self.env, "#");
  let count;
  if (_bind$4 === undefined) {
    count = 0;
  } else {
    const _Some = _bind$4;
    const _raw = _Some;
    count = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_raw);
  }
  const values = [];
  const _bind$5 = _M0MPB3Map3getGssE(self.env, "0");
  let script_name;
  if (_bind$5 === undefined) {
    const _bind$6 = _M0MPB3Map3getGssE(self.env, "SH");
    if (_bind$6 === undefined) {
      const _p$4 = _M0MPB3Map3getGssE(self.env, "SHELL");
      const _p$5 = "";
      if (_p$4 === undefined) {
        script_name = _p$5;
      } else {
        const _p$6 = _p$4;
        script_name = _p$6;
      }
    } else {
      const _Some = _bind$6;
      script_name = _Some;
    }
  } else {
    const _Some = _bind$5;
    script_name = _Some;
  }
  _M0MPC15array5Array4pushGUssEE(values, script_name);
  let _tmp$38 = 1;
  while (true) {
    const i = _tmp$38;
    if (i <= count) {
      const _p$4 = _M0MPB3Map3getGssE(self.env, _M0MPC13int3Int18to__string_2einner(i, 10));
      const _p$5 = "";
      let _tmp$39;
      if (_p$4 === undefined) {
        _tmp$39 = _p$5;
      } else {
        const _p$6 = _p$4;
        _tmp$39 = _p$6;
      }
      _M0MPC15array5Array4pushGUssEE(values, _tmp$39);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const values_len = BigInt.asUintN(64, BigInt(values.length));
  const origin = BigInt.asUintN(64, BigInt.asUintN(64, BigInt(count)) + 1n);
  const start = BigInt.asIntN(64, offset) < BigInt.asIntN(64, 0n) ? BigInt.asUintN(64, origin + offset) : offset;
  if (BigInt.asIntN(64, start) < BigInt.asIntN(64, 0n) || BigInt.asIntN(64, start) >= BigInt.asIntN(64, values_len)) {
    return [];
  }
  let end_ = values_len;
  if (len === undefined) {
  } else {
    const _Some = len;
    const _length = _Some;
    if (BigInt.asIntN(64, _length) <= BigInt.asIntN(64, 0n)) {
      return [];
    }
    end_ = BigInt.asUintN(64, start + _length);
    if (BigInt.asIntN(64, end_) > BigInt.asIntN(64, values_len)) {
      end_ = values_len;
    }
  }
  const out = [];
  let _tmp$39 = Number(BigInt.asIntN(32, start)) | 0;
  while (true) {
    const i = _tmp$39;
    if (i < (Number(BigInt.asIntN(32, end_)) | 0)) {
      _M0MPC15array5Array4pushGUssEE(out, _M0MPC15array5Array2atGUssEE(values, i));
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13expand__tilde(self, user) {
  if (user.length === 0) {
    const _p$4 = _M0MPB3Map3getGssE(self.env, "HOME");
    const _p$5 = "/home/user";
    if (_p$4 === undefined) {
      return _p$5;
    } else {
      const _p$6 = _p$4;
      return _p$6;
    }
  } else {
    return user === "root" ? "/root" : `/home/${user}`;
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser4peek(self) {
  return self.pos < self.tokens.length ? _M0MPC15array5Array2atGUssEE(self.tokens, self.pos) : undefined;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser10match__tok(self, tok) {
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser4peek(self);
  if (_bind$4 === undefined) {
    return false;
  } else {
    const _Some = _bind$4;
    const _cur = _Some;
    if (_cur === tok) {
      self.pos = self.pos + 1 | 0;
      return true;
    } else {
      return false;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter25arith__is__assignment__op(op) {
  return op === "=" || (op === "+=" || (op === "-=" || (op === "*=" || (op === "/=" || (op === "%=" || (op === "&=" || (op === "|=" || (op === "^=" || (op === "<<=" || op === ">>=")))))))));
}
function _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(value) {
  return new _M0TP410Haoxincode8moonbash3lib11interpreter10ArithValue(value, _M0DTP410Haoxincode8moonbash3lib11interpreter11ArithTarget8NoTarget__);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser7advance(self) {
  if (self.pos < self.tokens.length) {
    const tok = _M0MPC15array5Array2atGUssEE(self.tokens, self.pos);
    self.pos = self.pos + 1 | 0;
    return tok;
  } else {
    return undefined;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter19arith__with__target(value, target) {
  return new _M0TP410Haoxincode8moonbash3lib11interpreter10ArithValue(value, target);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext23arith__get__array__elem(self, name, index) {
  const resolved_index = BigInt.asIntN(64, index) < BigInt.asIntN(64, 0n) ? BigInt.asUintN(64, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22indexed__array__origin(self, name) + index) : index;
  if (BigInt.asIntN(64, resolved_index) < BigInt.asIntN(64, 0n)) {
    const fragment = `$((${name}[${_M0MPC15int645Int6418to__string_2einner(index, 10)}]))`;
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27emit__bad__array__subscript(self, name, fragment);
    return 0n;
  }
  const key = `${name}[${_M0MPC15int645Int6418to__string_2einner(resolved_index, 10)}]`;
  const _bind$4 = _M0MPB3Map3getGssE(self.env, key);
  if (_bind$4 === undefined) {
  } else {
    const _Some = _bind$4;
    const _v = _Some;
    return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25arith__parse__value__text(self, _v);
  }
  const _p$4 = _M0MPB3Map3getGssE(self.env, name);
  const _p$5 = "";
  let raw;
  if (_p$4 === undefined) {
    raw = _p$5;
  } else {
    const _p$6 = _p$4;
    raw = _p$6;
  }
  const trimmed = _M0FP410Haoxincode8moonbash3lib11interpreter11arith__trim(raw);
  let _tmp$38;
  if (trimmed.length >= 2) {
    let _tmp$39;
    $bound_check(trimmed, 0);
    const _p$6 = trimmed.charCodeAt(0);
    const _p$7 = 40;
    if (_p$6 === _p$7) {
      const _tmp$40 = trimmed.length - 1 | 0;
      $bound_check(trimmed, _tmp$40);
      const _p$8 = trimmed.charCodeAt(_tmp$40);
      const _p$9 = 41;
      _tmp$39 = _p$8 === _p$9;
    } else {
      _tmp$39 = false;
    }
    _tmp$38 = _tmp$39;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    const inner = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(trimmed, 1, trimmed.length - 1 | 0));
    const parts = _M0FP410Haoxincode8moonbash3lib11interpreter21split__by__whitespace(inner);
    if (BigInt.asIntN(64, resolved_index) < BigInt.asIntN(64, BigInt.asUintN(64, BigInt(parts.length)))) {
      return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25arith__parse__value__text(self, _M0MPC15array5Array2atGUssEE(parts, Number(BigInt.asIntN(32, resolved_index)) | 0));
    }
  }
  if (trimmed.length > 0 && BigInt.asUintN(64, resolved_index) === BigInt.asUintN(64, 0n)) {
    if (_M0FP410Haoxincode8moonbash3lib11interpreter14contains__char(trimmed, 32) || _M0FP410Haoxincode8moonbash3lib11interpreter14contains__char(trimmed, 9)) {
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11arith__fail(self);
      return 0n;
    }
    return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25arith__parse__value__text(self, trimmed);
  }
  if (self.options.nounset) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20arith__fail__nounset(self);
  }
  return 0n;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18arith__set__target(self, target, value, execute) {
  if (!execute) {
    return undefined;
  }
  if (_M0MPB3Map8containsGssE(self.env, "__MOON_BASH_ABORT_CURRENT_COMMAND__")) {
    return undefined;
  }
  switch (target.$tag) {
    case 0: {
      return;
    }
    case 1: {
      const _Var = target;
      const _name = _Var._0;
      _M0MPB3Map3setGssE(self.env, _name, _M0MPC15int645Int6418to__string_2einner(value, 10));
      return;
    }
    default: {
      const _ArrayElem = target;
      const _name$2 = _ArrayElem._0;
      const _index = _ArrayElem._1;
      const resolved_index = BigInt.asIntN(64, _index) < BigInt.asIntN(64, 0n) ? BigInt.asUintN(64, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22indexed__array__origin(self, _name$2) + _index) : _index;
      if (BigInt.asIntN(64, resolved_index) < BigInt.asIntN(64, 0n)) {
        const fragment = `$((${_name$2}[${_M0MPC15int645Int6418to__string_2einner(_index, 10)}]))`;
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27emit__bad__array__subscript(self, _name$2, fragment);
        self.exit_code = 1;
        return undefined;
      }
      const key = `${_name$2}[${_M0MPC15int645Int6418to__string_2einner(resolved_index, 10)}]`;
      _M0MPB3Map3setGssE(self.env, key, _M0MPC15int645Int6418to__string_2einner(value, 10));
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24refresh__array__metadata(self, _name$2);
      _M0MPB3Map3setGssE(self.env, `__MOON_BASH_ARRAY_KIND__${_name$2}`, "indexed");
      return;
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21arith__var__is__array(self, name) {
  if (_M0MPB3Map8containsGssE(self.env, `__MOON_BASH_ARRAY_COUNT__${name}`)) {
    return true;
  }
  if (_M0MPB3Map8containsGssE(self.env, `${name}[@]`) || _M0MPB3Map8containsGssE(self.env, `${name}[*]`)) {
    return true;
  }
  return _M0MPB3Map8containsGssE(self.env, `${name}[0]`);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext30arith__target__is__bare__array(self, target) {
  if (target.$tag === 1) {
    const _Var = target;
    const _name = _Var._0;
    return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21arith__var__is__array(self, _name);
  } else {
    return false;
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext42expand__positional__parameters__for__words(self) {
  const _bind$4 = _M0MPB3Map3getGssE(self.env, "#");
  let count;
  if (_bind$4 === undefined) {
    count = 0;
  } else {
    const _Some = _bind$4;
    const _raw = _Some;
    count = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_raw);
  }
  const values = [];
  let _tmp$38 = 1;
  while (true) {
    const i = _tmp$38;
    if (i <= count) {
      const _p$4 = _M0MPB3Map3getGssE(self.env, _M0MPC13int3Int18to__string_2einner(i, 10));
      const _p$5 = "";
      let _tmp$39;
      if (_p$4 === undefined) {
        _tmp$39 = _p$5;
      } else {
        const _p$6 = _p$4;
        _tmp$39 = _p$6;
      }
      _M0MPC15array5Array4pushGUssEE(values, _tmp$39);
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return values;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter25brace__placeholder__token(idx) {
  return `\u001d${_M0MPC13int3Int18to__string_2einner(idx, 10)}\u001e`;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter17brace__char__kind(ch) {
  return ch >= 97 && ch <= 122 ? 1 : ch >= 65 && ch <= 90 ? 2 : ch >= 48 && ch <= 57 ? 3 : 0;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter27brace__numeric__digit__info(text) {
  if (text.length === 0) {
    return undefined;
  }
  let start = 0;
  let _tmp$38;
  $bound_check(text, 0);
  const _p$4 = text.charCodeAt(0);
  const _p$5 = 45;
  if (_p$4 === _p$5) {
    _tmp$38 = true;
  } else {
    $bound_check(text, 0);
    const _p$6 = text.charCodeAt(0);
    const _p$7 = 43;
    _tmp$38 = _p$6 === _p$7;
  }
  if (_tmp$38) {
    start = 1;
  }
  if (start >= text.length) {
    return undefined;
  }
  let _tmp$39 = start;
  while (true) {
    const i = _tmp$39;
    if (i < text.length) {
      $bound_check(text, i);
      const ch = text.charCodeAt(i);
      if (ch < 48 || ch > 57) {
        return undefined;
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const width = text.length - start | 0;
  let leading_zero;
  if (width > 1) {
    const _tmp$40 = start;
    $bound_check(text, _tmp$40);
    const _p$6 = text.charCodeAt(_tmp$40);
    const _p$7 = 48;
    leading_zero = _p$6 === _p$7;
  } else {
    leading_zero = false;
  }
  return { _0: width, _1: leading_zero };
}
function _M0FP410Haoxincode8moonbash3lib11interpreter26brace__numeric__pad__width(start_text, end_text) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter27brace__numeric__digit__info(start_text);
  const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter27brace__numeric__digit__info(end_text);
  if (_bind$4 === undefined) {
    return 0;
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _start_width = _x._0;
    const _start_zero = _x._1;
    if (_bind$5 === undefined) {
      return 0;
    } else {
      const _Some$2 = _bind$5;
      const _x$2 = _Some$2;
      const _end_width = _x$2._0;
      const _end_zero = _x$2._1;
      return !_start_zero && !_end_zero ? 0 : _start_width >= _end_width ? _start_width : _end_width;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter21generate__char__range(start_ch, end_ch, step) {
  const out = [];
  let current = start_ch;
  while (true) {
    if (out.length >= 10000) {
      break;
    }
    if (step > 0) {
      if (current > end_ch) {
        break;
      }
    } else {
      if (current < end_ch) {
        break;
      }
    }
    const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
    _M0IPB13StringBuilderPB6Logger11write__char(buf, current);
    _M0MPC15array5Array4pushGUssEE(out, buf.val);
    current = current + step | 0;
    continue;
  }
  return out;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter23format__padded__numeric(value, width) {
  if (width <= 0) {
    return _M0MPC15int645Int6418to__string_2einner(value, 10);
  }
  const negative = BigInt.asIntN(64, value) < BigInt.asIntN(64, 0n);
  const abs_value = negative ? BigInt.asUintN(64, -value) : value;
  const digits = _M0MPC15int645Int6418to__string_2einner(abs_value, 10);
  if (digits.length >= width) {
    return negative ? `-${digits}` : digits;
  } else {
    const pad_len = width - digits.length | 0;
    const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
    if (negative) {
      _M0IPB13StringBuilderPB6Logger11write__char(out, 45);
    }
    let _tmp$38 = 0;
    while (true) {
      const _i = _tmp$38;
      if (_i < pad_len) {
        _M0IPB13StringBuilderPB6Logger11write__char(out, 48);
        _tmp$38 = _i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    _M0IPB13StringBuilderPB6Logger13write__string(out, digits);
    return out.val;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter24generate__numeric__range(start_num, end_num, step, pad_width) {
  const out = [];
  let current = start_num;
  while (true) {
    if (out.length >= 10000) {
      break;
    }
    if (BigInt.asIntN(64, step) > BigInt.asIntN(64, 0n)) {
      if (BigInt.asIntN(64, current) > BigInt.asIntN(64, end_num)) {
        break;
      }
    } else {
      if (BigInt.asIntN(64, current) < BigInt.asIntN(64, end_num)) {
        break;
      }
    }
    if (pad_width > 0) {
      _M0MPC15array5Array4pushGUssEE(out, _M0FP410Haoxincode8moonbash3lib11interpreter23format__padded__numeric(current, pad_width));
    } else {
      _M0MPC15array5Array4pushGUssEE(out, _M0MPC15int645Int6418to__string_2einner(current, 10));
    }
    current = BigInt.asUintN(64, current + step);
    continue;
  }
  return out;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter18parse__signed__int(text) {
  if (text.length === 0) {
    return undefined;
  }
  let sign = 1n;
  let i = 0;
  $bound_check(text, 0);
  const _p$4 = text.charCodeAt(0);
  const _p$5 = 45;
  if (_p$4 === _p$5) {
    sign = 18446744073709551615n;
    i = 1;
  } else {
    $bound_check(text, 0);
    const _p$6 = text.charCodeAt(0);
    const _p$7 = 43;
    if (_p$6 === _p$7) {
      i = 1;
    }
  }
  if (i >= text.length) {
    return undefined;
  }
  let value = 0n;
  while (true) {
    if (i < text.length) {
      const _tmp$38 = i;
      $bound_check(text, _tmp$38);
      const ch = text.charCodeAt(_tmp$38);
      if (ch < 48 || ch > 57) {
        return undefined;
      }
      value = BigInt.asUintN(64, BigInt.asUintN(64, value * 10n) + BigInt.asUintN(64, BigInt(ch - 48 | 0)));
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return BigInt.asUintN(64, value * sign);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter22split__by__double__dot(content) {
  const parts = [];
  let start = 0;
  let i = 0;
  while (true) {
    if ((i + 1 | 0) < content.length) {
      let _tmp$38;
      const _tmp$39 = i;
      $bound_check(content, _tmp$39);
      const _p$4 = content.charCodeAt(_tmp$39);
      const _p$5 = 46;
      if (_p$4 === _p$5) {
        const _tmp$40 = i + 1 | 0;
        $bound_check(content, _tmp$40);
        const _p$6 = content.charCodeAt(_tmp$40);
        const _p$7 = 46;
        _tmp$38 = _p$6 === _p$7;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        _M0MPC15array5Array4pushGUssEE(parts, _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(content, start, i)));
        start = i + 2 | 0;
        i = i + 2 | 0;
        continue;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MPC15array5Array4pushGUssEE(parts, _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(content, start, content.length)));
  return parts;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter19parse__brace__range(content) {
  const parts = _M0FP410Haoxincode8moonbash3lib11interpreter22split__by__double__dot(content);
  if (parts.length !== 2 && parts.length !== 3) {
    return _M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult12BraceNoRange__;
  }
  const step_opt = parts.length === 3 ? _M0FP410Haoxincode8moonbash3lib11interpreter18parse__signed__int(_M0MPC15array5Array2atGUssEE(parts, 2)) : undefined;
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter18parse__signed__int(_M0MPC15array5Array2atGUssEE(parts, 0));
  const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter18parse__signed__int(_M0MPC15array5Array2atGUssEE(parts, 1));
  if (_bind$4 === undefined) {
  } else {
    const _Some = _bind$4;
    const _start_num = _Some;
    if (_bind$5 === undefined) {
    } else {
      const _Some$2 = _bind$5;
      const _end_num = _Some$2;
      let step;
      if (step_opt === undefined) {
        step = BigInt.asIntN(64, _end_num) >= BigInt.asIntN(64, _start_num) ? 1n : 18446744073709551615n;
      } else {
        const _Some$3 = step_opt;
        step = _Some$3;
      }
      if (BigInt.asUintN(64, step) === BigInt.asUintN(64, 0n)) {
        return _M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult21BraceRangeSyntaxError__;
      }
      if (BigInt.asUintN(64, _start_num) !== BigInt.asUintN(64, _end_num)) {
        if (BigInt.asIntN(64, _start_num) < BigInt.asIntN(64, _end_num) && BigInt.asIntN(64, step) < BigInt.asIntN(64, 0n)) {
          return _M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult21BraceRangeSyntaxError__;
        }
        if (BigInt.asIntN(64, _start_num) > BigInt.asIntN(64, _end_num) && BigInt.asIntN(64, step) > BigInt.asIntN(64, 0n)) {
          return _M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult21BraceRangeSyntaxError__;
        }
      }
      const pad_width = _M0FP410Haoxincode8moonbash3lib11interpreter26brace__numeric__pad__width(_M0MPC15array5Array2atGUssEE(parts, 0), _M0MPC15array5Array2atGUssEE(parts, 1));
      return new _M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult17BraceRangeOptions(_M0FP410Haoxincode8moonbash3lib11interpreter24generate__numeric__range(_start_num, _end_num, step, pad_width));
    }
  }
  _L: {
    _L$2: {
      const _bind$6 = _M0FP410Haoxincode8moonbash3lib11interpreter18parse__signed__int(_M0MPC15array5Array2atGUssEE(parts, 0));
      if (_bind$6 === undefined) {
        const _bind$7 = _M0FP410Haoxincode8moonbash3lib11interpreter18parse__signed__int(_M0MPC15array5Array2atGUssEE(parts, 1));
        if (_bind$7 === undefined) {
        } else {
          break _L$2;
        }
      } else {
        break _L$2;
      }
      break _L;
    }
    return _M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult12BraceNoRange__;
  }
  if (_M0MPC15array5Array2atGUssEE(parts, 0).length === 1 && _M0MPC15array5Array2atGUssEE(parts, 1).length === 1) {
    const _tmp$38 = _M0MPC15array5Array2atGUssEE(parts, 0);
    $bound_check(_tmp$38, 0);
    const start_ch = _tmp$38.charCodeAt(0);
    const _tmp$39 = _M0MPC15array5Array2atGUssEE(parts, 1);
    $bound_check(_tmp$39, 0);
    const end_ch = _tmp$39.charCodeAt(0);
    const start_kind = _M0FP410Haoxincode8moonbash3lib11interpreter17brace__char__kind(start_ch);
    const end_kind = _M0FP410Haoxincode8moonbash3lib11interpreter17brace__char__kind(end_ch);
    if (start_kind === 3 || end_kind === 3) {
      return _M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult12BraceNoRange__;
    }
    if (start_kind === 0 || end_kind === 0) {
      return _M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult12BraceNoRange__;
    }
    if (start_kind !== end_kind) {
      return _M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult21BraceRangeSyntaxError__;
    }
    let step_i64;
    if (step_opt === undefined) {
      step_i64 = end_ch >= start_ch ? 1n : 18446744073709551615n;
    } else {
      const _Some = step_opt;
      step_i64 = _Some;
    }
    if (BigInt.asUintN(64, step_i64) === BigInt.asUintN(64, 0n)) {
      return _M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult21BraceRangeSyntaxError__;
    }
    if (start_ch !== end_ch) {
      if (start_ch < end_ch && BigInt.asIntN(64, step_i64) < BigInt.asIntN(64, 0n)) {
        return _M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult21BraceRangeSyntaxError__;
      }
      if (start_ch > end_ch && BigInt.asIntN(64, step_i64) > BigInt.asIntN(64, 0n)) {
        return _M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult21BraceRangeSyntaxError__;
      }
    }
    const step = Number(BigInt.asIntN(32, step_i64)) | 0;
    return new _M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult17BraceRangeOptions(_M0FP410Haoxincode8moonbash3lib11interpreter21generate__char__range(start_ch, end_ch, step));
  }
  return _M0DTP410Haoxincode8moonbash3lib11interpreter21BraceRangeParseResult12BraceNoRange__;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter32split__brace__top__level__commas(content) {
  const parts = [];
  let depth = 0;
  let start = 0;
  let has_comma = false;
  let i = 0;
  while (true) {
    if (i < content.length) {
      let _tmp$38;
      const _tmp$39 = i;
      $bound_check(content, _tmp$39);
      const _p$4 = content.charCodeAt(_tmp$39);
      const _p$5 = 92;
      if (_p$4 === _p$5) {
        _tmp$38 = (i + 1 | 0) < content.length;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        i = i + 2 | 0;
        continue;
      }
      const _tmp$40 = i;
      $bound_check(content, _tmp$40);
      const _p$6 = content.charCodeAt(_tmp$40);
      const _p$7 = 123;
      if (_p$6 === _p$7) {
        depth = depth + 1 | 0;
      } else {
        const _tmp$41 = i;
        $bound_check(content, _tmp$41);
        const _p$8 = content.charCodeAt(_tmp$41);
        const _p$9 = 125;
        if (_p$8 === _p$9) {
          if (depth > 0) {
            depth = depth - 1 | 0;
          }
        } else {
          let _tmp$42;
          const _tmp$43 = i;
          $bound_check(content, _tmp$43);
          const _p$10 = content.charCodeAt(_tmp$43);
          const _p$11 = 44;
          if (_p$10 === _p$11) {
            _tmp$42 = depth === 0;
          } else {
            _tmp$42 = false;
          }
          if (_tmp$42) {
            _M0MPC15array5Array4pushGUssEE(parts, _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(content, start, i)));
            start = i + 1 | 0;
            has_comma = true;
          }
        }
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (has_comma) {
    _M0MPC15array5Array4pushGUssEE(parts, _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(content, start, content.length)));
  }
  return { _0: parts, _1: has_comma };
}
function _M0FP410Haoxincode8moonbash3lib11interpreter21parse__brace__options(content) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter32split__brace__top__level__commas(content);
  const _comma_options = _bind$4._0;
  const _has_comma = _bind$4._1;
  if (_has_comma) {
    return new _M0DTP410Haoxincode8moonbash3lib11interpreter22BraceOptionParseResult12BraceOptions(_comma_options);
  }
  const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter19parse__brace__range(content);
  switch (_bind$5.$tag) {
    case 1: {
      const _BraceRangeOptions = _bind$5;
      const _values = _BraceRangeOptions._0;
      return new _M0DTP410Haoxincode8moonbash3lib11interpreter22BraceOptionParseResult12BraceOptions(_values);
    }
    case 2: {
      return _M0DTP410Haoxincode8moonbash3lib11interpreter22BraceOptionParseResult22BraceOptionSyntaxError__;
    }
    default: {
      return _M0DTP410Haoxincode8moonbash3lib11interpreter22BraceOptionParseResult13BraceNoOption__;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter36find__first__expandable__brace__pair(s) {
  let i = 0;
  while (true) {
    if (i < s.length) {
      let _tmp$38;
      const _tmp$39 = i;
      $bound_check(s, _tmp$39);
      const _p$4 = s.charCodeAt(_tmp$39);
      const _p$5 = 92;
      if (_p$4 === _p$5) {
        _tmp$38 = (i + 1 | 0) < s.length;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        i = i + 2 | 0;
        continue;
      }
      const _tmp$40 = i;
      $bound_check(s, _tmp$40);
      const _p$6 = s.charCodeAt(_tmp$40);
      const _p$7 = 123;
      if (_p$6 === _p$7) {
        let depth = 1;
        let j = i + 1 | 0;
        let matched = false;
        while (true) {
          if (j < s.length) {
            let _tmp$41;
            const _tmp$42 = j;
            $bound_check(s, _tmp$42);
            const _p$8 = s.charCodeAt(_tmp$42);
            const _p$9 = 92;
            if (_p$8 === _p$9) {
              _tmp$41 = (j + 1 | 0) < s.length;
            } else {
              _tmp$41 = false;
            }
            if (_tmp$41) {
              j = j + 2 | 0;
              continue;
            }
            const _tmp$43 = j;
            $bound_check(s, _tmp$43);
            const _p$10 = s.charCodeAt(_tmp$43);
            const _p$11 = 123;
            if (_p$10 === _p$11) {
              depth = depth + 1 | 0;
            } else {
              const _tmp$44 = j;
              $bound_check(s, _tmp$44);
              const _p$12 = s.charCodeAt(_tmp$44);
              const _p$13 = 125;
              if (_p$12 === _p$13) {
                depth = depth - 1 | 0;
                if (depth === 0) {
                  matched = true;
                  break;
                }
              }
            }
            j = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        if (!matched) {
          i = i + 1 | 0;
          continue;
        }
        const content = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(s, i + 1 | 0, j));
        const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter21parse__brace__options(content);
        switch (_bind$4.$tag) {
          case 1: {
            const _BraceOptions = _bind$4;
            const _options = _BraceOptions._0;
            if (_options.length > 0) {
              return { _0: i, _1: j };
            }
            break;
          }
          case 2: {
            return { _0: i, _1: j };
          }
        }
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return undefined;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter22brace__expand__collect(input, out) {
  if (out.length >= 10000) {
    return false;
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter36find__first__expandable__brace__pair(input);
  if (_bind$4 === undefined) {
    _M0MPC15array5Array4pushGUssEE(out, input);
    return false;
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _start = _x._0;
    const _end_ = _x._1;
    const content = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(input, _start + 1 | 0, _end_));
    const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter21parse__brace__options(content);
    let options;
    switch (_bind$5.$tag) {
      case 1: {
        const _BraceOptions = _bind$5;
        options = _BraceOptions._0;
        break;
      }
      case 2: {
        return true;
      }
      default: {
        _M0MPC15array5Array4pushGUssEE(out, input);
        return false;
      }
    }
    const prefix = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(input, 0, _start));
    const suffix = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(input, _end_ + 1 | 0, undefined));
    const _bind$6 = options.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$6) {
        const option = options[_];
        if (out.length >= 10000) {
          return false;
        }
        if (_M0FP410Haoxincode8moonbash3lib11interpreter22brace__expand__collect(`${prefix}${option}${suffix}`, out)) {
          return true;
        }
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return false;
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter15brace__unescape(text) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  while (true) {
    if (i < text.length) {
      const _tmp$38 = i;
      $bound_check(text, _tmp$38);
      const ch = text.charCodeAt(_tmp$38);
      if (ch === 92 && (i + 1 | 0) < text.length) {
        const _tmp$39 = i + 1 | 0;
        $bound_check(text, _tmp$39);
        _M0IPB13StringBuilderPB6Logger11write__char(out, text.charCodeAt(_tmp$39));
        i = i + 2 | 0;
        continue;
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0FP410Haoxincode8moonbash3lib11interpreter22expand__brace__literal(s) {
  const out = [];
  if (_M0FP410Haoxincode8moonbash3lib11interpreter22brace__expand__collect(s, out)) {
    return { _0: [], _1: true };
  }
  if (out.length === 0) {
    return { _0: [_M0FP410Haoxincode8moonbash3lib11interpreter15brace__unescape(s)], _1: false };
  } else {
    const normalized = [];
    const _bind$4 = out.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$4) {
        const item = out[_];
        _M0MPC15array5Array4pushGUssEE(normalized, _M0FP410Haoxincode8moonbash3lib11interpreter15brace__unescape(item));
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return { _0: normalized, _1: false };
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter32parse__brace__placeholder__index(text) {
  if (text.length === 0) {
    return undefined;
  }
  let value = 0;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < text.length) {
      $bound_check(text, i);
      const ch = text.charCodeAt(i);
      if (ch < 48 || ch > 57) {
        return undefined;
      }
      value = (Math.imul(value, 10) | 0) + (ch - 48 | 0) | 0;
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return value;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27expand__tilde__after__brace(self, value) {
  let _tmp$38;
  if (value.length === 0) {
    _tmp$38 = true;
  } else {
    $bound_check(value, 0);
    _tmp$38 = value.charCodeAt(0) !== 126;
  }
  if (_tmp$38) {
    return value;
  }
  let slash_idx = value.length;
  let _tmp$39 = 1;
  while (true) {
    const i = _tmp$39;
    if (i < value.length) {
      $bound_check(value, i);
      if (value.charCodeAt(i) === 47) {
        slash_idx = i;
        break;
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const user = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(value, 1, slash_idx));
  const rest = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(value, slash_idx, undefined));
  return `${_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13expand__tilde(self, user)}${rest}`;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33parse__assoc__assignment__entries(self, name, values) {
  const entries = [];
  let has_explicit = false;
  const _bind$4 = values.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const token = values[_];
      const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter41parse__array__assignment__explicit__entry(token);
      if (_bind$5 === undefined) {
      } else {
        has_explicit = true;
        break;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (has_explicit) {
    const _bind$5 = values.length;
    let _tmp$39 = 0;
    while (true) {
      const _ = _tmp$39;
      if (_ < _bind$5) {
        const token = values[_];
        const _bind$6 = _M0FP410Haoxincode8moonbash3lib11interpreter41parse__array__assignment__explicit__entry(token);
        if (_bind$6 === undefined) {
          _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `bash: line 2: ${name}: ${token}: must use subscript when assigning associative array\n`);
        } else {
          const _Some = _bind$6;
          const _entry = _Some;
          _M0MPC15array5Array4pushGUssEE(entries, _entry);
        }
        _tmp$39 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return entries;
  }
  let i = 0;
  while (true) {
    if (i < values.length) {
      const token = _M0MPC15array5Array2atGUssEE(values, i);
      const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter41parse__array__assignment__explicit__entry(token);
      if (_bind$5 === undefined) {
        const key = _M0FP410Haoxincode8moonbash3lib11interpreter35normalize__array__assignment__index(token);
        const value = (i + 1 | 0) < values.length ? _M0MPC15array5Array2atGUssEE(values, i + 1 | 0) : "";
        _M0MPC15array5Array4pushGUssEE(entries, { _0: key, _1: value, _2: false });
        i = i + 2 | 0;
      } else {
        const _Some = _bind$5;
        const _entry = _Some;
        _M0MPC15array5Array4pushGUssEE(entries, _entry);
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  return entries;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext38normalize__compound__assignment__value(self, value) {
  const cleaned_value = _M0FP410Haoxincode8moonbash3lib11interpreter40strip__array__assignment__index__markers(value);
  if (cleaned_value.length === 0) {
    return cleaned_value;
  }
  const _p$4 = _M0MPB3Map3getGssE(self.env, "HOME");
  const _p$5 = "/home/user";
  let home;
  if (_p$4 === undefined) {
    home = _p$5;
  } else {
    const _p$6 = _p$4;
    home = _p$6;
  }
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let segment_start = 0;
  let i = 0;
  while (true) {
    if (i <= cleaned_value.length) {
      let _tmp$38;
      if (i === cleaned_value.length) {
        _tmp$38 = true;
      } else {
        const _tmp$39 = i;
        $bound_check(cleaned_value, _tmp$39);
        _tmp$38 = cleaned_value.charCodeAt(_tmp$39) === 58;
      }
      if (_tmp$38) {
        const segment = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(cleaned_value, segment_start, i));
        let normalized;
        if (segment === "~") {
          normalized = home;
        } else {
          let _tmp$39;
          if (segment.length >= 2) {
            let _tmp$40;
            $bound_check(segment, 0);
            if (segment.charCodeAt(0) === 126) {
              $bound_check(segment, 1);
              _tmp$40 = segment.charCodeAt(1) === 47;
            } else {
              _tmp$40 = false;
            }
            _tmp$39 = _tmp$40;
          } else {
            _tmp$39 = false;
          }
          if (_tmp$39) {
            normalized = `${home}${_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(segment, 1, undefined))}`;
          } else {
            normalized = segment;
          }
        }
        _M0IPB13StringBuilderPB6Logger13write__string(out, normalized);
        if (i < cleaned_value.length) {
          _M0IPB13StringBuilderPB6Logger11write__char(out, 58);
        }
        segment_start = i + 1 | 0;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24store__assoc__assignment(self, name, entries, append) {
  if (!append) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24store__array__assignment(self, name, []);
  }
  const _bind$4 = entries.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const entry = entries[_];
      const _key = entry._0;
      const _value = entry._1;
      const _append_mode = entry._2;
      const storage_key = `${name}[${_key}]`;
      const normalized = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext38normalize__compound__assignment__value(self, _value);
      if (_append_mode) {
        const _tmp$39 = self.env;
        const _p$4 = _M0MPB3Map3getGssE(self.env, storage_key);
        const _p$5 = "";
        let _tmp$40;
        if (_p$4 === undefined) {
          _tmp$40 = _p$5;
        } else {
          const _p$6 = _p$4;
          _tmp$40 = _p$6;
        }
        _M0MPB3Map3setGssE(_tmp$39, storage_key, `${_tmp$40}${normalized}`);
      } else {
        _M0MPB3Map3setGssE(self.env, storage_key, normalized);
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24refresh__array__metadata(self, name);
  _M0MPB3Map3setGssE(self.env, `__MOON_BASH_ARRAY_KIND__${name}`, "assoc");
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31next__indexed__assignment__seed(self, name, append) {
  if (!append) {
    return 0;
  }
  const keys = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20collect__array__keys(self, name);
  let seed = 0;
  const _bind$4 = keys.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const key = keys[_];
      const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter36parse__non__negative__int__for__sort(key);
      if (_bind$5 === undefined) {
      } else {
        const _Some = _bind$5;
        const _idx = _Some;
        if ((_idx + 1 | 0) > seed) {
          seed = _idx + 1 | 0;
        }
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return seed;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext39seed__indexed__assignment__from__scalar(self, name) {
  if (_M0MPB3Map8containsGssE(self.env, `__MOON_BASH_ARRAY_COUNT__${name}`) || (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20collect__array__keys(self, name).length > 0 || !_M0MPB3Map8containsGssE(self.env, name))) {
    return undefined;
  }
  const _p$4 = _M0MPB3Map3getGssE(self.env, name);
  const _p$5 = "";
  let scalar;
  if (_p$4 === undefined) {
    scalar = _p$5;
  } else {
    const _p$6 = _p$4;
    scalar = _p$6;
  }
  _M0MPB3Map3setGssE(self.env, `${name}[0]`, scalar);
  _M0MPB3Map3setGssE(self.env, `${name}[@]`, scalar);
  _M0MPB3Map3setGssE(self.env, `${name}[*]`, scalar);
  _M0MPB3Map3setGssE(self.env, `__MOON_BASH_ARRAY_COUNT__${name}`, "1");
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29try__store__array__assignment(self, name, raw_value, append) {
  if (!_M0FP410Haoxincode8moonbash3lib11interpreter22is__valid__shell__name(name)) {
    return false;
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter31split__array__assignment__items(raw_value.parts);
  let items;
  if (_bind$4.$tag === 1) {
    const _Some = _bind$4;
    items = _Some._0;
  } else {
    return false;
  }
  const values = [];
  const _bind$5 = items.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const item_word = items[_];
      if (_M0FP410Haoxincode8moonbash3lib11interpreter46array__assignment__item__is__invalid__operator(item_word)) {
        self.exit_code = 2;
        self.should_exit = true;
        return true;
      }
      const expanded = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext39expand__array__assignment__item__values(self, item_word);
      const _bind$6 = expanded.length;
      let _tmp$39 = 0;
      while (true) {
        const _$2 = _tmp$39;
        if (_$2 < _bind$6) {
          const item = expanded[_$2];
          _M0MPC15array5Array4pushGUssEE(values, item);
          if (values.length > self.limits.max_array_elements) {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22fail__execution__limit(self, "array element limit exceeded");
            return true;
          }
          _tmp$39 = _$2 + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      if (self.should_exit) {
        return true;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _p$4 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_ARRAY_KIND__${name}`);
  const _p$5 = "";
  let _tmp$39;
  if (_p$4 === undefined) {
    _tmp$39 = _p$5;
  } else {
    const _p$6 = _p$4;
    _tmp$39 = _p$6;
  }
  const is_assoc = _tmp$39 === "assoc";
  if (is_assoc) {
    const entries = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33parse__assoc__assignment__entries(self, name, values);
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24store__assoc__assignment(self, name, entries, append);
    return true;
  }
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext26store__indexed__assignment(self, name, values, append);
  return true;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext39expand__array__assignment__item__values(self, item_word) {
  const raw = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, item_word);
  if (self.should_exit) {
    return [];
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter41parse__array__assignment__explicit__entry(raw);
  if (_bind$4 === undefined) {
    const expanded = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12expand__word(self, item_word);
    return expanded.length === 0 && _M0FP410Haoxincode8moonbash3lib11interpreter42array__assignment__word__has__quoted__part(item_word.parts) ? [raw] : expanded;
  } else {
    return [raw];
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12expand__word(self, word) {
  return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22expand__word__internal(self, word, true);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22expand__word__internal(self, word, allow_glob) {
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext36expand__double__quoted__array__words(self, word.parts);
  if (_bind$4.$tag === 1) {
    const _Some = _bind$4;
    const _values = _Some._0;
    return _values;
  }
  const expanded_candidates = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32expand__word__parts__with__brace(self, word.parts);
  if (expanded_candidates.length === 0) {
    return [""];
  }
  if (self.should_exit) {
    return [""];
  }
  let has_splittable_expansion = false;
  const _bind$5 = word.parts;
  const _bind$6 = _bind$5.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$6) {
      const part = _bind$5[_];
      _L: {
        _L$2: {
          switch (part.$tag) {
            case 3: {
              break _L$2;
            }
            case 4: {
              break _L$2;
            }
            case 5: {
              break _L$2;
            }
            case 6: {
              break _L$2;
            }
          }
          break _L;
        }
        has_splittable_expansion = true;
        break;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const parts = [];
  if (!has_splittable_expansion) {
    const _bind$7 = expanded_candidates.length;
    let _tmp$39 = 0;
    while (true) {
      const _ = _tmp$39;
      if (_ < _bind$7) {
        const candidate = expanded_candidates[_];
        _M0MPC15array5Array4pushGUssEE(parts, candidate);
        _tmp$39 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  } else {
    const _bind$7 = expanded_candidates.length;
    let _tmp$39 = 0;
    while (true) {
      const _ = _tmp$39;
      if (_ < _bind$7) {
        const candidate = expanded_candidates[_];
        const split_parts = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11word__split(self, candidate);
        const _bind$8 = split_parts.length;
        let _tmp$40 = 0;
        while (true) {
          const _$2 = _tmp$40;
          if (_$2 < _bind$8) {
            const split_part = split_parts[_$2];
            _M0MPC15array5Array4pushGUssEE(parts, split_part);
            _tmp$40 = _$2 + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        _tmp$39 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  if (parts.length === 0) {
    if (has_splittable_expansion) {
      return [];
    }
    return [""];
  }
  return allow_glob && _M0FP410Haoxincode8moonbash3lib11interpreter25word__should__apply__glob(word.parts) ? _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16pathname__expand(self, parts) : parts;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext36expand__double__quoted__array__words(self, parts) {
  if (parts.length !== 1) {
    return _M0DTPC16option6OptionGRPB5ArrayGsEE4None__;
  }
  const _bind$4 = _M0MPC15array5Array2atGUssEE(parts, 0);
  let inner_parts;
  if (_bind$4.$tag === 2) {
    const _DoubleQuoted = _bind$4;
    inner_parts = _DoubleQuoted._0;
  } else {
    return _M0DTPC16option6OptionGRPB5ArrayGsEE4None__;
  }
  if (inner_parts.length === 1) {
    const _bind$5 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33double__quoted__multiword__values(self, _M0MPC15array5Array2atGUssEE(inner_parts, 0));
    if (_bind$5.$tag === 1) {
      const _Some = _bind$5;
      const _values = _Some._0;
      return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some(_values);
    } else {
      return _M0DTPC16option6OptionGRPB5ArrayGsEE4None__;
    }
  }
  let multiword_index = -1;
  let multiword_values = _M0DTPC16option6OptionGRPB5ArrayGsEE4None__;
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < inner_parts.length) {
      const _bind$5 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33double__quoted__multiword__values(self, _M0MPC15array5Array2atGUssEE(inner_parts, i));
      if (_bind$5.$tag === 1) {
        const _Some = _bind$5;
        const _values = _Some._0;
        if (multiword_index >= 0) {
          return _M0DTPC16option6OptionGRPB5ArrayGsEE4None__;
        }
        multiword_index = i;
        multiword_values = new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some(_values);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (multiword_index < 0) {
    return _M0DTPC16option6OptionGRPB5ArrayGsEE4None__;
  }
  const prefix_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < multiword_index) {
      _M0IPB13StringBuilderPB6Logger13write__string(prefix_buf, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18expand__word__part(self, _M0MPC15array5Array2atGUssEE(inner_parts, i)));
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const suffix_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$40 = multiword_index + 1 | 0;
  while (true) {
    const i = _tmp$40;
    if (i < inner_parts.length) {
      _M0IPB13StringBuilderPB6Logger13write__string(suffix_buf, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18expand__word__part(self, _M0MPC15array5Array2atGUssEE(inner_parts, i)));
      _tmp$40 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const prefix = prefix_buf.val;
  const suffix = suffix_buf.val;
  const values = _M0MPC16option6Option10unwrap__orGRPB5ArrayGsEE(multiword_values, []);
  if (values.length === 0) {
    return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some([]);
  }
  if (values.length === 1) {
    return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some([`${prefix}${_M0MPC15array5Array2atGUssEE(values, 0)}${suffix}`]);
  }
  const out = [];
  _M0MPC15array5Array4pushGUssEE(out, `${prefix}${_M0MPC15array5Array2atGUssEE(values, 0)}`);
  let _tmp$41 = 1;
  while (true) {
    const i = _tmp$41;
    if (i < (values.length - 1 | 0)) {
      _M0MPC15array5Array4pushGUssEE(out, _M0MPC15array5Array2atGUssEE(values, i));
      _tmp$41 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MPC15array5Array4pushGUssEE(out, `${_M0MPC15array5Array2atGUssEE(values, values.length - 1 | 0)}${suffix}`);
  return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some(out);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33double__quoted__multiword__values(self, part) {
  if (_M0FP410Haoxincode8moonbash3lib11interpreter29is__positional__at__expansion(part)) {
    return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext42expand__positional__parameters__for__words(self));
  }
  if (part.$tag === 4) {
    const _ParameterExpansion = part;
    const _pe = _ParameterExpansion._0;
    const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31expand__array__parameter__words(self, _pe);
    if (_bind$4.$tag === 1) {
      const _Some = _bind$4;
      const _values = _Some._0;
      return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some(_values);
    }
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter31array__reference__base__for__at(part);
  let _bind$5;
  if (_bind$4 === undefined) {
    return _M0DTPC16option6OptionGRPB5ArrayGsEE4None__;
  } else {
    const _Some = _bind$4;
    _bind$5 = _Some;
  }
  const _base = _bind$5._0;
  const _expand_keys = _bind$5._1;
  return _expand_keys ? new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20collect__array__keys(self, _base)) : new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext35expand__array__elements__for__words(self, _base));
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31expand__array__parameter__words(self, pe) {
  switch (pe.$tag) {
    case 0: {
      const _Simple = pe;
      const _name = _Simple._0;
      let base_name;
      let transform;
      _L: {
        const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter33parse__parameter__transform__name(_name);
        if (_bind$4 === undefined) {
          base_name = _name;
          transform = -1;
          break _L;
        } else {
          const _Some = _bind$4;
          const _x = _Some;
          const _raw = _x._0;
          const _kind = _x._1;
          base_name = _raw;
          transform = _kind;
          break _L;
        }
      }
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter29parse__array__reference__name(base_name);
      if (_bind$4 === undefined) {
        return _M0DTPC16option6OptionGRPB5ArrayGsEE4None__;
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        const _base = _x._0;
        const _index = _x._1;
        if (_index === "@") {
          const values = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext35expand__array__elements__for__words(self, _base);
          return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24transform__array__values(self, _base, values, transform));
        } else {
          if (_index === "*") {
            const values = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext35expand__array__elements__for__words(self, _base);
            const transformed = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24transform__array__values(self, _base, values, transform);
            const _p$4 = _M0MPB3Map3getGssE(self.env, "IFS");
            const _p$5 = " \t\n";
            let _tmp$38;
            if (_p$4 === undefined) {
              _tmp$38 = _p$5;
            } else {
              const _p$6 = _p$4;
              _tmp$38 = _p$6;
            }
            return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some([_M0FP410Haoxincode8moonbash3lib11interpreter23join__values__with__ifs(transformed, _tmp$38)]);
          } else {
            return _M0DTPC16option6OptionGRPB5ArrayGsEE4None__;
          }
        }
      }
    }
    case 1: {
      const _Default = pe;
      const _name$2 = _Default._0;
      const _word = _Default._1;
      const _colon = _Default._2;
      let join_with_ifs = false;
      let current_values = _M0DTPC16option6OptionGRPB5ArrayGsEE4None__;
      if (_name$2 === "@") {
        current_values = new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext42expand__positional__parameters__for__words(self));
      } else {
        if (_name$2 === "*") {
          join_with_ifs = true;
          current_values = new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext42expand__positional__parameters__for__words(self));
        } else {
          const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter29parse__array__reference__name(_name$2);
          if (_bind$5 === undefined) {
            return _M0DTPC16option6OptionGRPB5ArrayGsEE4None__;
          } else {
            const _Some = _bind$5;
            const _x = _Some;
            const _base = _x._0;
            const _index = _x._1;
            if (_index === "@") {
              current_values = new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext35expand__array__elements__for__words(self, _base));
            } else {
              if (_index === "*") {
                join_with_ifs = true;
                current_values = new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext35expand__array__elements__for__words(self, _base));
              } else {
                return _M0DTPC16option6OptionGRPB5ArrayGsEE4None__;
              }
            }
          }
        }
      }
      const values = _M0MPC16option6Option10unwrap__orGRPB5ArrayGsEE(current_values, []);
      let current_joined;
      if (join_with_ifs) {
        const _p$4 = _M0MPB3Map3getGssE(self.env, "IFS");
        const _p$5 = " \t\n";
        let _tmp$38;
        if (_p$4 === undefined) {
          _tmp$38 = _p$5;
        } else {
          const _p$6 = _p$4;
          _tmp$38 = _p$6;
        }
        current_joined = _M0FP410Haoxincode8moonbash3lib11interpreter23join__values__with__ifs(values, _tmp$38);
      } else {
        current_joined = _M0FP410Haoxincode8moonbash3lib11interpreter25join__values__with__space(values);
      }
      const is_set = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18parameter__is__set(self, _name$2);
      const is_null = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19parameter__is__null(self, _name$2, current_joined);
      const use_default = _colon ? is_null : !is_set;
      if (!use_default) {
        if (join_with_ifs) {
          const _p$4 = _M0MPB3Map3getGssE(self.env, "IFS");
          const _p$5 = " \t\n";
          let _tmp$38;
          if (_p$4 === undefined) {
            _tmp$38 = _p$5;
          } else {
            const _p$6 = _p$4;
            _tmp$38 = _p$6;
          }
          return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some([_M0FP410Haoxincode8moonbash3lib11interpreter23join__values__with__ifs(values, _tmp$38)]);
        } else {
          return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some(values);
        }
      } else {
        if (_word.parts.length === 1) {
          const _bind$5 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33double__quoted__multiword__values(self, _M0MPC15array5Array2atGUssEE(_word.parts, 0));
          if (_bind$5.$tag === 1) {
            const _Some = _bind$5;
            const _default_values = _Some._0;
            if (join_with_ifs) {
              const _p$4 = _M0MPB3Map3getGssE(self.env, "IFS");
              const _p$5 = " \t\n";
              let _tmp$38;
              if (_p$4 === undefined) {
                _tmp$38 = _p$5;
              } else {
                const _p$6 = _p$4;
                _tmp$38 = _p$6;
              }
              return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some([_M0FP410Haoxincode8moonbash3lib11interpreter23join__values__with__ifs(_default_values, _tmp$38)]);
            } else {
              return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some(_default_values);
            }
          } else {
            return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some([_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, _word)]);
          }
        } else {
          return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some([_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, _word)]);
        }
      }
    }
    case 12: {
      const _Indirection = pe;
      const _name$3 = _Indirection._0;
      const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter37parse__indirection__array__keys__mode(_name$3);
      if (_bind$5 === undefined) {
        return _M0DTPC16option6OptionGRPB5ArrayGsEE4None__;
      } else {
        const _Some = _bind$5;
        const _x = _Some;
        const _base = _x._0;
        const _join_with_ifs = _x._1;
        const keys = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20collect__array__keys(self, _base);
        if (_join_with_ifs) {
          const _p$4 = _M0MPB3Map3getGssE(self.env, "IFS");
          const _p$5 = " \t\n";
          let _tmp$38;
          if (_p$4 === undefined) {
            _tmp$38 = _p$5;
          } else {
            const _p$6 = _p$4;
            _tmp$38 = _p$6;
          }
          return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some([_M0FP410Haoxincode8moonbash3lib11interpreter23join__values__with__ifs(keys, _tmp$38)]);
        } else {
          return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some(keys);
        }
      }
    }
    case 7: {
      const _PrefixRemove = pe;
      const _name$4 = _PrefixRemove._0;
      const _pattern = _PrefixRemove._1;
      const _greedy = _PrefixRemove._2;
      return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext35expand__array__parameter__transform(self, _name$4, (value) => {
        const pat = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, _pattern);
        return _M0FP410Haoxincode8moonbash3lib11interpreter22strip__prefix__pattern(value, pat, _greedy);
      });
    }
    case 8: {
      const _SuffixRemove = pe;
      const _name$5 = _SuffixRemove._0;
      const _pattern$2 = _SuffixRemove._1;
      const _greedy$2 = _SuffixRemove._2;
      return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext35expand__array__parameter__transform(self, _name$5, (value) => {
        const pat = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, _pattern$2);
        return _M0FP410Haoxincode8moonbash3lib11interpreter22strip__suffix__pattern(value, pat, _greedy$2);
      });
    }
    case 9: {
      const _Replace = pe;
      const _name$6 = _Replace._0;
      const _pattern$3 = _Replace._1;
      const _replacement = _Replace._2;
      const _mode = _Replace._3;
      return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext35expand__array__parameter__transform(self, _name$6, (value) => {
        const pat = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, _pattern$3);
        let repl;
        if (_replacement === undefined) {
          repl = "";
        } else {
          const _Some = _replacement;
          const _w = _Some;
          repl = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, _w);
        }
        return _M0FP410Haoxincode8moonbash3lib11interpreter16replace__pattern(value, pat, repl, _mode);
      });
    }
    case 6: {
      const _Substring = pe;
      const _name$7 = _Substring._0;
      const _offset_expr = _Substring._1;
      const _length_expr = _Substring._2;
      const offset = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(self, _offset_expr);
      let len;
      if (_length_expr === undefined) {
        len = undefined;
      } else {
        const _Some = _length_expr;
        const _le = _Some;
        len = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(self, _le);
      }
      if (_name$7 === "@") {
        return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext45slice__positional__parameters__for__substring(self, offset, len));
      }
      if (_name$7 === "*") {
        const values$2 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext45slice__positional__parameters__for__substring(self, offset, len);
        const _p$4 = _M0MPB3Map3getGssE(self.env, "IFS");
        const _p$5 = " \t\n";
        let _tmp$38;
        if (_p$4 === undefined) {
          _tmp$38 = _p$5;
        } else {
          const _p$6 = _p$4;
          _tmp$38 = _p$6;
        }
        return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some([_M0FP410Haoxincode8moonbash3lib11interpreter23join__values__with__ifs(values$2, _tmp$38)]);
      }
      _L$2: {
        const _bind$6 = _M0FP410Haoxincode8moonbash3lib11interpreter29parse__array__reference__name(_name$7);
        if (_bind$6 === undefined) {
          break _L$2;
        } else {
          const _Some = _bind$6;
          const _x = _Some;
          const _base = _x._0;
          const _index_expr = _x._1;
          if (_index_expr === "@" || _index_expr === "*") {
            if (len === undefined) {
            } else {
              const _Some$2 = len;
              const _length = _Some$2;
              if (BigInt.asIntN(64, _length) < BigInt.asIntN(64, 0n)) {
                self.exit_code = 1;
                _M0MPB3Map3setGssE(self.env, "__MOON_BASH_ABORT_CURRENT_COMMAND__", "1");
                return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some([]);
              }
            }
            const _p$4 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_ARRAY_KIND__${_base}`);
            const _p$5 = "";
            let _tmp$38;
            if (_p$4 === undefined) {
              _tmp$38 = _p$5;
            } else {
              const _p$6 = _p$4;
              _tmp$38 = _p$6;
            }
            if (_tmp$38 === "assoc") {
              self.exit_code = 1;
              self.should_exit = true;
              return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some([]);
            } else {
              const sliced = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext41expand__indexed__array__substring__values(self, _base, offset, len);
              if (_index_expr === "*") {
                const _p$6 = _M0MPB3Map3getGssE(self.env, "IFS");
                const _p$7 = " \t\n";
                let _tmp$39;
                if (_p$6 === undefined) {
                  _tmp$39 = _p$7;
                } else {
                  const _p$8 = _p$6;
                  _tmp$39 = _p$8;
                }
                return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some([_M0FP410Haoxincode8moonbash3lib11interpreter23join__values__with__ifs(sliced, _tmp$39)]);
              } else {
                return new _M0DTPC16option6OptionGRPB5ArrayGsEE4Some(sliced);
              }
            }
          } else {
            break _L$2;
          }
        }
      }
      return _M0DTPC16option6OptionGRPB5ArrayGsEE4None__;
    }
    default: {
      return _M0DTPC16option6OptionGRPB5ArrayGsEE4None__;
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(self, expr) {
  let _tmp$38 = expr;
  _L: while (true) {
    const expr$2 = _tmp$38;
    switch (expr$2.$tag) {
      case 0: {
        const _Num = expr$2;
        return _Num._0;
      }
      case 1: {
        const _Var = expr$2;
        const _name = _Var._0;
        return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22arith__get__var__value(self, _name);
      }
      case 2: {
        const _BinOp = expr$2;
        const _op = _BinOp._0;
        const _left = _BinOp._1;
        const _right = _BinOp._2;
        const l = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(self, _left);
        const r = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(self, _right);
        switch (_op) {
          case 0: {
            return BigInt.asUintN(64, l + r);
          }
          case 1: {
            return BigInt.asUintN(64, l - r);
          }
          case 2: {
            return BigInt.asUintN(64, l * r);
          }
          case 3: {
            if (BigInt.asUintN(64, r) === BigInt.asUintN(64, 0n)) {
              return 0n;
            } else {
              if (r === 0n) {
                $panic();
              }
              return BigInt.asUintN(64, BigInt.asIntN(64, l) / BigInt.asIntN(64, r));
            }
          }
          case 4: {
            if (BigInt.asUintN(64, r) === BigInt.asUintN(64, 0n)) {
              return 0n;
            } else {
              if (r === 0n) {
                $panic();
              }
              return BigInt.asUintN(64, BigInt.asIntN(64, l) % BigInt.asIntN(64, r));
            }
          }
          case 6: {
            return BigInt.asUintN(64, l) === BigInt.asUintN(64, r) ? 1n : 0n;
          }
          case 7: {
            return BigInt.asUintN(64, l) !== BigInt.asUintN(64, r) ? 1n : 0n;
          }
          case 8: {
            return BigInt.asIntN(64, l) < BigInt.asIntN(64, r) ? 1n : 0n;
          }
          case 9: {
            return BigInt.asIntN(64, l) <= BigInt.asIntN(64, r) ? 1n : 0n;
          }
          case 10: {
            return BigInt.asIntN(64, l) > BigInt.asIntN(64, r) ? 1n : 0n;
          }
          case 11: {
            return BigInt.asIntN(64, l) >= BigInt.asIntN(64, r) ? 1n : 0n;
          }
          case 17: {
            return BigInt.asUintN(64, l) !== BigInt.asUintN(64, 0n) && BigInt.asUintN(64, r) !== BigInt.asUintN(64, 0n) ? 1n : 0n;
          }
          case 18: {
            return BigInt.asUintN(64, l) !== BigInt.asUintN(64, 0n) || BigInt.asUintN(64, r) !== BigInt.asUintN(64, 0n) ? 1n : 0n;
          }
          case 12: {
            return BigInt.asUintN(64, l & r);
          }
          case 13: {
            return BigInt.asUintN(64, l | r);
          }
          case 14: {
            return BigInt.asUintN(64, l ^ r);
          }
          case 15: {
            return _M0FP410Haoxincode8moonbash3lib11interpreter18arith__shift__left(l, r);
          }
          case 16: {
            return _M0FP410Haoxincode8moonbash3lib11interpreter19arith__shift__right(l, r);
          }
          default: {
            return _M0FP410Haoxincode8moonbash3lib11interpreter8int__pow(l, r);
          }
        }
      }
      case 3: {
        const _UnaryOp = expr$2;
        const _op$2 = _UnaryOp._0;
        const _operand = _UnaryOp._1;
        const v = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(self, _operand);
        _L$2: {
          _L$3: {
            switch (_op$2) {
              case 0: {
                return BigInt.asUintN(64, -v);
              }
              case 2: {
                return BigInt.asUintN(64, v) === BigInt.asUintN(64, 0n) ? 1n : 0n;
              }
              case 1: {
                return BigInt.asUintN(64, BigInt.asUintN(64, -v) - 1n);
              }
              case 3: {
                break _L$3;
              }
              case 5: {
                break _L$3;
              }
              case 4: {
                break _L$2;
              }
              default: {
                break _L$2;
              }
            }
          }
          return BigInt.asUintN(64, v + 1n);
        }
        return BigInt.asUintN(64, v - 1n);
      }
      case 4: {
        const _Assign = expr$2;
        const _name$2 = _Assign._0;
        const _value_expr = _Assign._1;
        const v$2 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(self, _value_expr);
        _M0MPB3Map3setGssE(self.env, _name$2, _M0MPC15int645Int6418to__string_2einner(v$2, 10));
        return v$2;
      }
      case 5: {
        const _Ternary = expr$2;
        const _cond = _Ternary._0;
        const _then_expr = _Ternary._1;
        const _else_expr = _Ternary._2;
        const c = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(self, _cond);
        if (BigInt.asUintN(64, c) !== BigInt.asUintN(64, 0n)) {
          _tmp$38 = _then_expr;
          continue _L;
        } else {
          _tmp$38 = _else_expr;
          continue _L;
        }
      }
      default: {
        const _Raw = expr$2;
        const _raw = _Raw._0;
        return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16eval__arith__raw(self, _raw);
      }
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22arith__get__var__value(self, name) {
  let current = name;
  let depth = 0;
  while (true) {
    if (depth < 32) {
      const _p$4 = _M0MPB3Map3getGssE(self.env, current);
      const _p$5 = "";
      let raw;
      if (_p$4 === undefined) {
        raw = _p$5;
      } else {
        const _p$6 = _p$4;
        raw = _p$6;
      }
      const trimmed = _M0FP410Haoxincode8moonbash3lib11interpreter11arith__trim(raw);
      if (trimmed.length === 0) {
        if (self.options.nounset) {
          _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20arith__fail__nounset(self);
        }
        return 0n;
      }
      let _tmp$38;
      if (_M0FP410Haoxincode8moonbash3lib11interpreter27arith__is__identifier__text(trimmed)) {
        const _p$6 = current;
        _tmp$38 = !(trimmed === _p$6);
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        current = trimmed;
        depth = depth + 1 | 0;
        continue;
      }
      if (_M0FP410Haoxincode8moonbash3lib11interpreter37arith__value__looks__like__expression(trimmed)) {
        return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16eval__arith__raw(self, trimmed);
      }
      return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25arith__parse__value__text(self, trimmed);
    } else {
      break;
    }
  }
  return 0n;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16eval__arith__raw(self, raw) {
  const normalized_raw = _M0FP410Haoxincode8moonbash3lib11interpreter33arith__strip__line__continuations(raw);
  const expanded_word = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, _M0FP410Haoxincode8moonbash3lib11interpreter36arith__prepare__word__for__expansion(normalized_raw));
  if (_M0FP410Haoxincode8moonbash3lib11interpreter14contains__char(expanded_word, 39)) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11arith__fail(self);
    return 0n;
  }
  const expanded = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27arith__expand__dollar__refs(self, _M0FP410Haoxincode8moonbash3lib11interpreter28arith__strip__double__quotes(expanded_word));
  const tokens = _M0FP410Haoxincode8moonbash3lib11interpreter15arith__tokenize(expanded);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < tokens.length) {
      if (_M0MPC16string6String11has__prefix(_M0MPC15array5Array2atGUssEE(tokens, i), new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16eval__arith__rawN7_2abindS8703, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16eval__arith__rawN7_2abindS8703.length))) {
        if (_M0MPC15array5Array2atGUssEE(tokens, i) === "__MOON_BASH_ARITH_INVALID__#") {
          self.should_exit = true;
        }
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11arith__fail(self);
        return 0n;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (tokens.length === 0) {
    return 0n;
  }
  const parser = new _M0TP410Haoxincode8moonbash3lib11interpreter11ArithParser(tokens, 0);
  const result = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19arith__parse__comma(self, parser, true);
  if (parser.pos < tokens.length) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11arith__fail(self);
    return 0n;
  }
  return result.value;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27arith__expand__dollar__refs(self, raw) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  while (true) {
    if (i < raw.length) {
      const _tmp$38 = i;
      $bound_check(raw, _tmp$38);
      const ch = raw.charCodeAt(_tmp$38);
      if (ch === 36 && (i + 1 | 0) < raw.length) {
        const _tmp$39 = i + 1 | 0;
        $bound_check(raw, _tmp$39);
        const next = raw.charCodeAt(_tmp$39);
        if (_M0FP410Haoxincode8moonbash3lib11interpreter23arith__is__ident__start(next)) {
          let j = i + 2 | 0;
          while (true) {
            let _tmp$40;
            if (j < raw.length) {
              const _tmp$41 = j;
              $bound_check(raw, _tmp$41);
              _tmp$40 = _M0FP410Haoxincode8moonbash3lib11interpreter22arith__is__ident__char(raw.charCodeAt(_tmp$41));
            } else {
              _tmp$40 = false;
            }
            if (_tmp$40) {
              j = j + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          const name = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(raw, i + 1 | 0, j));
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16expand__variable(self, name));
          i = j;
          continue;
        }
        if (next >= 48 && next <= 57) {
          let j = i + 2 | 0;
          while (true) {
            let _tmp$40;
            if (j < raw.length) {
              const _tmp$41 = j;
              $bound_check(raw, _tmp$41);
              const _p$4 = raw.charCodeAt(_tmp$41);
              _tmp$40 = _p$4 >= 48 && _p$4 <= 57;
            } else {
              _tmp$40 = false;
            }
            if (_tmp$40) {
              j = j + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          const name = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(raw, i + 1 | 0, j));
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16expand__variable(self, name));
          i = j;
          continue;
        }
        if (_M0FP410Haoxincode8moonbash3lib11interpreter29arith__is__special__var__char(next)) {
          const name = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(raw, i + 1 | 0, i + 2 | 0));
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16expand__variable(self, name));
          i = i + 2 | 0;
          continue;
        }
      }
      _M0IPB13StringBuilderPB6Logger11write__char(out, ch);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16expand__variable(self, name) {
  _L: {
    switch (name) {
      case "?": {
        return _M0MPC13int3Int18to__string_2einner(self.exit_code, 10);
      }
      case "$": {
        const _p$4 = _M0MPB3Map3getGssE(self.env, "__MOON_BASH_PID");
        const _p$5 = "1";
        if (_p$4 === undefined) {
          return _p$5;
        } else {
          const _p$6 = _p$4;
          return _p$6;
        }
      }
      case "#": {
        const _p$6 = _M0MPB3Map3getGssE(self.env, "#");
        const _p$7 = "0";
        if (_p$6 === undefined) {
          return _p$7;
        } else {
          const _p$8 = _p$6;
          return _p$8;
        }
      }
      case "!": {
        return "0";
      }
      case "@": {
        break _L;
      }
      case "*": {
        break _L;
      }
      case "-": {
        const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
        if (self.options.errexit) {
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 101);
        }
        if (self.options.nounset) {
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 117);
        }
        if (self.options.xtrace) {
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 120);
        }
        return buf.val;
      }
      default: {
        return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext23expand__named__variable(self, name);
      }
    }
  }
  const _p$4 = _M0MPB3Map3getGssE(self.env, "@");
  const _p$5 = "";
  if (_p$4 === undefined) {
    return _p$5;
  } else {
    const _p$6 = _p$4;
    return _p$6;
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext23expand__named__variable(self, name) {
  let _tmp$38 = name;
  while (true) {
    const name$2 = _tmp$38;
    switch (name$2) {
      case "BASHPID": {
        const _p$4 = _M0MPB3Map3getGssE(self.env, "__MOON_BASH_PID");
        const _p$5 = "1";
        let _tmp$39;
        if (_p$4 === undefined) {
          _tmp$39 = _p$5;
        } else {
          const _p$6 = _p$4;
          _tmp$39 = _p$6;
        }
        return _tmp$39;
      }
      case "PPID": {
        const _p$6 = _M0MPB3Map3getGssE(self.env, "__MOON_BASH_PPID");
        const _p$7 = "0";
        let _tmp$40;
        if (_p$6 === undefined) {
          _tmp$40 = _p$7;
        } else {
          const _p$8 = _p$6;
          _tmp$40 = _p$8;
        }
        return _tmp$40;
      }
      case "UID": {
        const _p$8 = _M0MPB3Map3getGssE(self.env, "__MOON_BASH_UID");
        const _p$9 = "1000";
        let _tmp$41;
        if (_p$8 === undefined) {
          _tmp$41 = _p$9;
        } else {
          const _p$10 = _p$8;
          _tmp$41 = _p$10;
        }
        return _tmp$41;
      }
      case "EUID": {
        const _p$10 = _M0MPB3Map3getGssE(self.env, "__MOON_BASH_EUID");
        const _p$11 = "1000";
        let _tmp$42;
        if (_p$10 === undefined) {
          _tmp$42 = _p$11;
        } else {
          const _p$12 = _p$10;
          _tmp$42 = _p$12;
        }
        return _tmp$42;
      }
    }
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter29parse__array__reference__name(name$2);
    if (_bind$4 === undefined) {
      if (_M0FP410Haoxincode8moonbash3lib11interpreter14contains__char(name$2, 91) || _M0FP410Haoxincode8moonbash3lib11interpreter14contains__char(name$2, 93)) {
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27emit__bad__array__subscript(self, name$2, name$2);
        self.exit_code = 1;
        _M0MPB3Map3setGssE(self.env, "__MOON_BASH_ABORT_CURRENT_COMMAND__", "1");
        return "";
      }
      const _bind$5 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_NAMEREF__${name$2}`);
      if (_bind$5 === undefined) {
        const _p$12 = _M0MPB3Map3getGssE(self.env, name$2);
        const _p$13 = "";
        if (_p$12 === undefined) {
          return _p$13;
        } else {
          const _p$14 = _p$12;
          return _p$14;
        }
      } else {
        const _Some = _bind$5;
        const _target = _Some;
        if (_target === name$2) {
          const _p$12 = _M0MPB3Map3getGssE(self.env, _target);
          const _p$13 = "";
          if (_p$12 === undefined) {
            return _p$13;
          } else {
            const _p$14 = _p$12;
            return _p$14;
          }
        } else {
          _tmp$38 = _target;
          continue;
        }
      }
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _base = _x._0;
      const _index_expr = _x._1;
      return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33expand__array__element__reference(self, _base, _index_expr);
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33expand__array__element__reference(self, base, index_expr) {
  if (index_expr === "@" || index_expr === "*") {
    const _bind$4 = _M0MPB3Map3getGssE(self.env, `${base}[${index_expr}]`);
    if (_bind$4 === undefined) {
      const has_array_metadata = _M0MPB3Map8containsGssE(self.env, `__MOON_BASH_ARRAY_COUNT__${base}`) || _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20collect__array__keys(self, base).length > 0;
      if (!has_array_metadata) {
        const _p$4 = _M0MPB3Map3getGssE(self.env, base);
        const _p$5 = "";
        let _tmp$38;
        if (_p$4 === undefined) {
          _tmp$38 = _p$5;
        } else {
          const _p$6 = _p$4;
          _tmp$38 = _p$6;
        }
        return _tmp$38;
      }
      return "";
    } else {
      const _Some = _bind$4;
      const _value = _Some;
      return _value;
    }
  }
  const trimmed = _M0FP410Haoxincode8moonbash3lib11interpreter26trim__ascii__space__simple(index_expr);
  if (trimmed.length === 0) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27emit__bad__array__subscript(self, base, `${base}[]`);
    self.exit_code = 1;
    _M0MPB3Map3setGssE(self.env, "__MOON_BASH_ABORT_CURRENT_COMMAND__", "1");
    return "";
  }
  const literal_key = _M0FP410Haoxincode8moonbash3lib11interpreter23strip__wrapping__quotes(trimmed);
  const literal_lookup = `${base}[${literal_key}]`;
  if (_M0MPB3Map8containsGssE(self.env, literal_lookup)) {
    const _p$4 = _M0MPB3Map3getGssE(self.env, literal_lookup);
    const _p$5 = "";
    let _tmp$38;
    if (_p$4 === undefined) {
      _tmp$38 = _p$5;
    } else {
      const _p$6 = _p$4;
      _tmp$38 = _p$6;
    }
    return _tmp$38;
  }
  const _bind$4 = _M0MPB3Map3getGssE(self.env, literal_key);
  if (_bind$4 === undefined) {
  } else {
    const _Some = _bind$4;
    const _indirect_key = _Some;
    const lookup = `${base}[${_indirect_key}]`;
    if (_M0MPB3Map8containsGssE(self.env, lookup)) {
      const _p$4 = _M0MPB3Map3getGssE(self.env, lookup);
      const _p$5 = "";
      let _tmp$38;
      if (_p$4 === undefined) {
        _tmp$38 = _p$5;
      } else {
        const _p$6 = _p$4;
        _tmp$38 = _p$6;
      }
      return _tmp$38;
    }
  }
  const expanded_index = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext26expand__array__index__expr(self, trimmed);
  if (expanded_index.length > 0) {
    const expanded_lookup = `${base}[${expanded_index}]`;
    if (_M0MPB3Map8containsGssE(self.env, expanded_lookup)) {
      const _p$4 = _M0MPB3Map3getGssE(self.env, expanded_lookup);
      const _p$5 = "";
      let _tmp$38;
      if (_p$4 === undefined) {
        _tmp$38 = _p$5;
      } else {
        const _p$6 = _p$4;
        _tmp$38 = _p$6;
      }
      return _tmp$38;
    }
  }
  let resolved_index_expr = trimmed;
  if (_M0FP410Haoxincode8moonbash3lib11interpreter27arith__is__identifier__text(trimmed)) {
    const _p$4 = _M0MPB3Map3getGssE(self.env, trimmed);
    const _p$5 = "";
    let dynamic_raw;
    if (_p$4 === undefined) {
      dynamic_raw = _p$5;
    } else {
      const _p$6 = _p$4;
      dynamic_raw = _p$6;
    }
    if (dynamic_raw.length > 0) {
      const dynamic_expanded = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext26expand__array__index__expr(self, dynamic_raw);
      resolved_index_expr = dynamic_expanded.length > 0 ? dynamic_expanded : dynamic_raw;
    }
  }
  if (_M0FP410Haoxincode8moonbash3lib11interpreter14contains__char(resolved_index_expr, 36)) {
    const second_pass = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext26expand__array__index__expr(self, resolved_index_expr);
    if (second_pass.length > 0) {
      resolved_index_expr = second_pass;
    }
  }
  const resolved_lookup = `${base}[${resolved_index_expr}]`;
  if (_M0MPB3Map8containsGssE(self.env, resolved_lookup)) {
    const _p$4 = _M0MPB3Map3getGssE(self.env, resolved_lookup);
    const _p$5 = "";
    let _tmp$38;
    if (_p$4 === undefined) {
      _tmp$38 = _p$5;
    } else {
      const _p$6 = _p$4;
      _tmp$38 = _p$6;
    }
    return _tmp$38;
  }
  const numeric_index = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(self, new _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Raw(resolved_index_expr));
  const resolved_numeric_index = BigInt.asIntN(64, numeric_index) < BigInt.asIntN(64, 0n) ? BigInt.asUintN(64, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22indexed__array__origin(self, base) + numeric_index) : numeric_index;
  if (BigInt.asIntN(64, resolved_numeric_index) < BigInt.asIntN(64, 0n)) {
    const _p$4 = _M0MPB3Map3getGssE(self.env, "__MOON_BASH_IN_DQUOTE_EXPANSION__");
    const _p$5 = "";
    let _tmp$38;
    if (_p$4 === undefined) {
      _tmp$38 = _p$5;
    } else {
      const _p$6 = _p$4;
      _tmp$38 = _p$6;
    }
    if (_tmp$38 === "1") {
      const fragment = `${base}[${resolved_index_expr}]`;
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27emit__bad__array__subscript(self, base, fragment);
    }
    return "";
  }
  const numeric_lookup = `${base}[${_M0MPC15int645Int6418to__string_2einner(resolved_numeric_index, 10)}]`;
  if (_M0MPB3Map8containsGssE(self.env, numeric_lookup)) {
    const _p$4 = _M0MPB3Map3getGssE(self.env, numeric_lookup);
    const _p$5 = "";
    let _tmp$38;
    if (_p$4 === undefined) {
      _tmp$38 = _p$5;
    } else {
      const _p$6 = _p$4;
      _tmp$38 = _p$6;
    }
    return _tmp$38;
  }
  return "";
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext26expand__array__index__expr(self, expr) {
  const trimmed = _M0FP410Haoxincode8moonbash3lib11interpreter26trim__ascii__space__simple(expr);
  if (trimmed.length >= 2) {
    $bound_check(trimmed, 0);
    const first = trimmed.charCodeAt(0);
    const _tmp$38 = trimmed.length - 1 | 0;
    $bound_check(trimmed, _tmp$38);
    const last = trimmed.charCodeAt(_tmp$38);
    if (first === 39 && last === 39) {
      return _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(trimmed, 1, trimmed.length - 1 | 0));
    }
    if (first === 34 && last === 34) {
      const inner = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(trimmed, 1, trimmed.length - 1 | 0));
      return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, _M0FP410Haoxincode8moonbash3lib6parser20parse__word__content(inner));
    }
  }
  return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, _M0FP410Haoxincode8moonbash3lib6parser20parse__word__content(trimmed));
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, word) {
  const saved_marker = _M0MPB3Map3getGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__stringN11marker__keyS2523);
  _M0MPB3Map3setGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__stringN11marker__keyS2523, "1");
  const out = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19expand__word__parts(self, word.parts);
  if (saved_marker === undefined) {
    _M0MPB3Map6removeGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__stringN11marker__keyS2523);
  } else {
    const _Some = saved_marker;
    const _value = _Some;
    _M0MPB3Map3setGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__stringN11marker__keyS2523, _value);
  }
  return out;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19expand__word__parts(self, parts) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _bind$4 = parts.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const part = parts[_];
      _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18expand__word__part(self, part));
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18expand__word__part(self, part) {
  switch (part.$tag) {
    case 0: {
      const _Literal = part;
      return _Literal._0;
    }
    case 1: {
      const _SingleQuoted = part;
      return _SingleQuoted._0;
    }
    case 2: {
      const _DoubleQuoted = part;
      const _inner_parts = _DoubleQuoted._0;
      const saved_marker = _M0MPB3Map3getGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18expand__word__partN11marker__keyS2511);
      _M0MPB3Map3setGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18expand__word__partN11marker__keyS2511, "1");
      const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
      const _bind$4 = _inner_parts.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const p = _inner_parts[_];
          _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18expand__word__part(self, p));
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      if (saved_marker === undefined) {
        _M0MPB3Map6removeGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18expand__word__partN11marker__keyS2511);
      } else {
        const _Some = saved_marker;
        const _value = _Some;
        _M0MPB3Map3setGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18expand__word__partN11marker__keyS2511, _value);
      }
      return buf.val;
    }
    case 3: {
      const _Variable = part;
      const _name = _Variable._0;
      return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16expand__variable(self, _name);
    }
    case 4: {
      const _ParameterExpansion = part;
      const _pe = _ParameterExpansion._0;
      return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13expand__param(self, _pe);
    }
    case 5: {
      const _CommandSubstitution = part;
      const _script_str = _CommandSubstitution._0;
      return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20expand__command__sub(self, _script_str);
    }
    case 8: {
      const _TildePrefix = part;
      const _user = _TildePrefix._0;
      return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13expand__tilde(self, _user);
    }
    case 6: {
      const _ArithmeticExpansion = part;
      const _expr = _ArithmeticExpansion._0;
      return _M0MPC15int645Int6418to__string_2einner(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(self, _expr), 10);
    }
    case 7: {
      return "";
    }
    default: {
      return "";
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20expand__command__sub(self, script_str) {
  if (self.substitution_depth >= self.limits.max_substitution_depth) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22fail__execution__limit(self, "Command substitution nesting limit exceeded");
    return "";
  }
  self.substitution_depth = self.substitution_depth + 1 | 0;
  const saved_stdout = self.stdout_buf;
  const saved_stderr = self.stderr_buf;
  const saved_stdin = self.stdin_buf;
  const saved_env = _M0FP410Haoxincode8moonbash3lib11interpreter18clone__string__map(self.env);
  const saved_exported = _M0FP410Haoxincode8moonbash3lib11interpreter16clone__bool__map(self.exported);
  const saved_functions = _M0FP410Haoxincode8moonbash3lib11interpreter20clone__function__map(self.functions);
  const pending_cmd_sub_stderr_spec = _M0MPB3Map3getGssE(saved_env, "__MOON_BASH_PENDING_CMD_SUB_STDERR__");
  self.stdout_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  if (pending_cmd_sub_stderr_spec === undefined) {
  } else {
    self.stderr_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  }
  self.env = _M0FP410Haoxincode8moonbash3lib11interpreter18clone__string__map(saved_env);
  self.exported = _M0FP410Haoxincode8moonbash3lib11interpreter16clone__bool__map(saved_exported);
  self.functions = _M0FP410Haoxincode8moonbash3lib11interpreter20clone__function__map(saved_functions);
  let parsed;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib6parser5parse(script_str);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        parsed = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    self.substitution_depth = self.substitution_depth - 1 | 0;
    self.stdout_buf = saved_stdout;
    self.stderr_buf = saved_stderr;
    self.stdin_buf = saved_stdin;
    self.env = saved_env;
    self.exported = saved_exported;
    self.functions = saved_functions;
    return "";
  }
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, parsed);
  const _p$4 = self.stdout_buf;
  const output = _p$4.val;
  let stderr_output;
  if (pending_cmd_sub_stderr_spec === undefined) {
    stderr_output = "";
  } else {
    const _p$5 = self.stderr_buf;
    stderr_output = _p$5.val;
  }
  self.stdout_buf = saved_stdout;
  self.stderr_buf = saved_stderr;
  self.stdin_buf = saved_stdin;
  self.env = saved_env;
  self.exported = saved_exported;
  self.functions = saved_functions;
  self.substitution_depth = self.substitution_depth - 1 | 0;
  if (pending_cmd_sub_stderr_spec === undefined) {
  } else {
    const _Some = pending_cmd_sub_stderr_spec;
    const _spec = _Some;
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32stash__pending__cmd__sub__stderr(self, _spec, stderr_output);
  }
  const stripped = _M0FP410Haoxincode8moonbash3lib11interpreter25strip__trailing__newlines(output);
  if (stripped.length > self.limits.max_string_length) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22fail__execution__limit(self, "string length limit exceeded");
    return "";
  }
  return stripped;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, script) {
  const _bind$4 = script.statements;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const stmt = _bind$4[_];
      if (self.should_exit || self.return_requested) {
        return;
      }
      if (self.break_count > 0 || self.continue_count > 0) {
        return;
      }
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18execute__statement(self, stmt);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18execute__statement(self, stmt) {
  const pipelines = [];
  const ops = [];
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18flatten__statement(self, stmt, pipelines, ops);
  if (pipelines.length === 0) {
    return undefined;
  }
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17execute__pipeline(self, _M0MPC15array5Array2atGUssEE(pipelines, 0));
  const first_next_op = ops.length > 0 ? _M0MPC15array5Array2atGiE(ops, 0) : undefined;
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31apply__errexit__after__pipeline(self, _M0MPC15array5Array2atGUssEE(pipelines, 0), first_next_op);
  let i = 0;
  while (true) {
    if (i < ops.length) {
      if (self.should_exit || (self.return_requested || (self.break_count > 0 || self.continue_count > 0))) {
        return;
      }
      const _bind$4 = _M0MPC15array5Array2atGiE(ops, i);
      let should_run;
      switch (_bind$4) {
        case 0: {
          should_run = true;
          break;
        }
        case 1: {
          should_run = self.exit_code === 0;
          break;
        }
        case 2: {
          should_run = self.exit_code !== 0;
          break;
        }
        case 3: {
          should_run = true;
          break;
        }
        default: {
          should_run = false;
        }
      }
      if (should_run) {
        const pipeline_idx = i + 1 | 0;
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17execute__pipeline(self, _M0MPC15array5Array2atGUssEE(pipelines, pipeline_idx));
        const next_op = pipeline_idx < ops.length ? _M0MPC15array5Array2atGiE(ops, pipeline_idx) : undefined;
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31apply__errexit__after__pipeline(self, _M0MPC15array5Array2atGUssEE(pipelines, pipeline_idx), next_op);
      }
      i = i + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17execute__pipeline(self, pipeline) {
  const commands = pipeline.commands;
  if (commands.length === 0) {
    return undefined;
  }
  const pipeline_statuses = [];
  if (commands.length === 1) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16execute__command(self, _M0MPC15array5Array2atGUssEE(commands, 0));
    _M0MPC15array5Array4pushGUssEE(pipeline_statuses, _M0MPC13int3Int18to__string_2einner(self.exit_code, 10));
  } else {
    const saved_stdin = self.stdin_buf;
    const saved_stdout = self.stdout_buf;
    let pipe_input = self.stdin_buf;
    let _tmp$38 = 0;
    while (true) {
      const i = _tmp$38;
      if (i < commands.length) {
        const _bind$4 = [];
        const stage_env = _M0MPB3Map3MapGssE(new _M0TPB9ArrayViewGUssEE(_bind$4, 0, 0), undefined);
        const _it = _M0MPB3Map5iter2GssE(self.env);
        while (true) {
          const _bind$5 = _M0MPB5Iter24nextGssE(_it);
          if (_bind$5 === undefined) {
            break;
          } else {
            const _Some = _bind$5;
            const _x = _Some;
            const _key = _x._0;
            const _value = _x._1;
            _M0MPB3Map3setGssE(stage_env, _key, _value);
            continue;
          }
        }
        const _bind$5 = [];
        const stage_exported = _M0MPB3Map3MapGsbE(new _M0TPB9ArrayViewGUsbEE(_bind$5, 0, 0), undefined);
        const _it$2 = _M0MPB3Map5iter2GsbE(self.exported);
        while (true) {
          const _bind$6 = _M0MPB5Iter24nextGsbE(_it$2);
          if (_bind$6 === undefined) {
            break;
          } else {
            const _Some = _bind$6;
            const _x = _Some;
            const _key = _x._0;
            const _value = _x._1;
            _M0MPB3Map3setGsbE(stage_exported, _key, _value);
            continue;
          }
        }
        const _bind$6 = [];
        const stage_functions = _M0MPB3Map3MapGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(new _M0TPB9ArrayViewGUsRP410Haoxincode8moonbash3lib3ast11FunctionDefEE(_bind$6, 0, 0), undefined);
        const _it$3 = _M0MPB3Map5iter2GssE(self.functions);
        while (true) {
          const _bind$7 = _M0MPB5Iter24nextGssE(_it$3);
          if (_bind$7 === undefined) {
            break;
          } else {
            const _Some = _bind$7;
            const _x = _Some;
            const _key = _x._0;
            const _value = _x._1;
            _M0MPB3Map3setGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(stage_functions, _key, _value);
            continue;
          }
        }
        const stage_cwd = self.cwd;
        const stage_should_exit = self.should_exit;
        const stage_return_requested = self.return_requested;
        const stage_break_count = self.break_count;
        const stage_continue_count = self.continue_count;
        self.should_exit = false;
        self.return_requested = false;
        self.break_count = 0;
        self.continue_count = 0;
        self.stdin_buf = pipe_input;
        self.stdout_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16execute__command(self, _M0MPC15array5Array2atGUssEE(commands, i));
        _M0MPC15array5Array4pushGUssEE(pipeline_statuses, _M0MPC13int3Int18to__string_2einner(self.exit_code, 10));
        const _p$4 = self.stdout_buf;
        pipe_input = _p$4.val;
        self.env = stage_env;
        self.exported = stage_exported;
        self.functions = stage_functions;
        self.cwd = stage_cwd;
        self.should_exit = stage_should_exit;
        self.return_requested = stage_return_requested;
        self.break_count = stage_break_count;
        self.continue_count = stage_continue_count;
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    _M0IPB13StringBuilderPB6Logger13write__string(saved_stdout, pipe_input);
    self.stdout_buf = saved_stdout;
    self.stdin_buf = saved_stdin;
    let pipeline_exit = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_M0MPC15array5Array2atGUssEE(pipeline_statuses, pipeline_statuses.length - 1 | 0));
    if (self.options.pipefail) {
      pipeline_exit = 0;
      const _bind$4 = pipeline_statuses.length;
      let _tmp$39 = 0;
      while (true) {
        const _ = _tmp$39;
        if (_ < _bind$4) {
          const status = pipeline_statuses[_];
          const code = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(status);
          if (code !== 0) {
            pipeline_exit = code;
          }
          _tmp$39 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
    }
    self.exit_code = pipeline_exit;
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext28enforce__output__size__limit(self);
  }
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24store__array__assignment(self, "PIPESTATUS", pipeline_statuses);
  if (pipeline.negated) {
    self.exit_code = self.exit_code === 0 ? 1 : 0;
    return;
  } else {
    return;
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16execute__command(self, cmd) {
  self.command_count = self.command_count + 1 | 0;
  if (self.command_count > self.limits.max_command_count) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22fail__execution__limit(self, "too many commands executed");
    return undefined;
  }
  switch (cmd.$tag) {
    case 0: {
      const _Simple = cmd;
      const _simple = _Simple._0;
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simple(self, _simple);
      return;
    }
    case 1: {
      const _Compound = cmd;
      const _compound = _Compound._0;
      const _redirs = _Compound._1;
      const saved_stdout = self.stdout_buf;
      const saved_stderr = self.stderr_buf;
      const saved_stdin = self.stdin_buf;
      let redirected_file = undefined;
      let redirect_append = false;
      let null_output = false;
      let stdout_to_stderr = false;
      let stderr_to_stdout = false;
      let input_from_file = false;
      const _bind$4 = _redirs.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const redir = _redirs[_];
          const _bind$5 = redir.op;
          switch (_bind$5.$tag) {
            case 1: {
              const target = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, redir.target);
              if (target === "/dev/null") {
                null_output = true;
                self.stdout_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
              } else {
                if (target === "/dev/stderr") {
                  stdout_to_stderr = true;
                  self.stdout_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                } else {
                  const _p$4 = "/dev/stdout";
                  if (!(target === _p$4)) {
                    redirected_file = target;
                    redirect_append = false;
                    self.stdout_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                  }
                }
              }
              break;
            }
            case 2: {
              const target$2 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, redir.target);
              if (target$2 === "/dev/null") {
                null_output = true;
                self.stdout_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
              } else {
                let _tmp$39;
                const _p$4 = "/dev/stdout";
                if (!(target$2 === _p$4)) {
                  const _p$5 = "/dev/stderr";
                  _tmp$39 = !(target$2 === _p$5);
                } else {
                  _tmp$39 = false;
                }
                if (_tmp$39) {
                  redirected_file = target$2;
                  redirect_append = true;
                  self.stdout_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                }
              }
              break;
            }
            case 0: {
              const target$3 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, redir.target);
              let resolved;
              let _try_err;
              _L: {
                _L$2: {
                  const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, target$3);
                  if (_bind$6.$tag === 1) {
                    const _ok = _bind$6;
                    resolved = _ok._0;
                  } else {
                    const _err = _bind$6;
                    _try_err = _err._0;
                    break _L$2;
                  }
                  break _L;
                }
                resolved = target$3;
              }
              let content;
              let _try_err$2;
              _L$2: {
                _L$3: {
                  const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(self.fs, resolved);
                  if (_bind$6.$tag === 1) {
                    const _ok = _bind$6;
                    content = _ok._0;
                  } else {
                    const _err = _bind$6;
                    _try_err$2 = _err._0;
                    break _L$3;
                  }
                  break _L$2;
                }
                const _FsError = _try_err$2;
                const _msg = _FsError._0;
                _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: ${_msg}\n`);
                self.exit_code = 1;
                return undefined;
              }
              self.stdin_buf = content;
              input_from_file = true;
              break;
            }
            case 6: {
              const content$2 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, redir.target);
              self.stdin_buf = `${content$2}\n`;
              input_from_file = true;
              break;
            }
            case 5: {
              const content$3 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, redir.target);
              self.stdin_buf = content$3;
              input_from_file = true;
              break;
            }
            case 8: {
              const target$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, redir.target);
              const _bind$6 = redir.fd;
              let source_fd;
              if (_bind$6 === undefined) {
                source_fd = 1;
              } else {
                const _Some = _bind$6;
                source_fd = _Some;
              }
              if (source_fd === 1 && (target$4 === "2" || target$4 === "/dev/stderr")) {
                stdout_to_stderr = true;
                self.stdout_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
              } else {
                if (source_fd === 2 && (target$4 === "1" || target$4 === "/dev/stdout")) {
                  stderr_to_stdout = true;
                  self.stderr_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                } else {
                  if (source_fd === 1 && target$4 === "-") {
                    null_output = true;
                    self.stdout_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                  }
                }
              }
              break;
            }
          }
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17execute__compound(self, _compound);
      const _bind$5 = redirected_file;
      if (_bind$5 === undefined) {
        if (stdout_to_stderr) {
          const _p$4 = self.stdout_buf;
          const output = _p$4.val;
          _M0IPB13StringBuilderPB6Logger13write__string(saved_stderr, output);
          self.stdout_buf = saved_stdout;
        } else {
          if (null_output) {
            self.stdout_buf = saved_stdout;
          }
        }
        if (stderr_to_stdout) {
          const _p$4 = self.stderr_buf;
          const output = _p$4.val;
          _M0IPB13StringBuilderPB6Logger13write__string(saved_stdout, output);
          self.stderr_buf = saved_stderr;
        }
      } else {
        const _Some = _bind$5;
        const _path = _Some;
        const _p$4 = self.stdout_buf;
        let output = _p$4.val;
        if (stderr_to_stdout) {
          const _tmp$39 = output;
          const _p$5 = self.stderr_buf;
          output = `${_tmp$39}${_p$5.val}`;
        }
        let resolved;
        let _try_err;
        _L: {
          _L$2: {
            const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, _path);
            if (_bind$6.$tag === 1) {
              const _ok = _bind$6;
              resolved = _ok._0;
            } else {
              const _err = _bind$6;
              _try_err = _err._0;
              break _L$2;
            }
            break _L;
          }
          resolved = _path;
        }
        let _try_err$2;
        _L$2: {
          _L$3: {
            if (redirect_append) {
              const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs12append__file(self.fs, resolved, output);
              if (_bind$6.$tag === 1) {
                const _ok = _bind$6;
                _ok._0;
              } else {
                const _err = _bind$6;
                _try_err$2 = _err._0;
                break _L$3;
              }
            } else {
              const _bind$6 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs11write__file(self.fs, resolved, output);
              if (_bind$6.$tag === 1) {
                const _ok = _bind$6;
                _ok._0;
              } else {
                const _err = _bind$6;
                _try_err$2 = _err._0;
                break _L$3;
              }
            }
            break _L$2;
          }
          const _FsError = _try_err$2;
          const _msg = _FsError._0;
          _M0IPB13StringBuilderPB6Logger13write__string(saved_stderr, `moon_bash: ${_msg}\n`);
        }
        self.stdout_buf = saved_stdout;
        if (stderr_to_stdout) {
          self.stderr_buf = saved_stderr;
        }
      }
      if (input_from_file) {
        self.stdin_buf = saved_stdin;
        return;
      } else {
        return;
      }
    }
    default: {
      const _FunctionDef = cmd;
      const _fndef = _FunctionDef._0;
      _M0MPB3Map3setGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self.functions, _fndef.name, _fndef);
      return;
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17execute__compound(self, cmd) {
  switch (cmd.$tag) {
    case 0: {
      const _If = cmd;
      const _clause = _If._0;
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11execute__if(self, _clause);
      return;
    }
    case 1: {
      const _For = cmd;
      const _clause$2 = _For._0;
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12execute__for(self, _clause$2);
      return;
    }
    case 3: {
      const _While = cmd;
      const _clause$3 = _While._0;
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14execute__while(self, _clause$3);
      return;
    }
    case 4: {
      const _Until = cmd;
      const _clause$4 = _Until._0;
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14execute__until(self, _clause$4);
      return;
    }
    case 5: {
      const _Case = cmd;
      const _clause$5 = _Case._0;
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13execute__case(self, _clause$5);
      return;
    }
    case 6: {
      const _Subshell = cmd;
      const _script = _Subshell._0;
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17execute__subshell(self, _script);
      return;
    }
    case 7: {
      const _Group = cmd;
      const _script$2 = _Group._0;
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, _script$2);
      return;
    }
    case 2: {
      const _CStyleFor = cmd;
      const _clause$6 = _CStyleFor._0;
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20execute__cstyle__for(self, _clause$6);
      return;
    }
    case 8: {
      const _ArithmeticCommand = cmd;
      const _expr = _ArithmeticCommand._0;
      _M0MPB3Map6removeGssE(self.env, "__MOON_BASH_ABORT_CURRENT_COMMAND__");
      const result = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(self, _expr);
      if (_M0MPB3Map8containsGssE(self.env, "__MOON_BASH_ABORT_CURRENT_COMMAND__")) {
        _M0MPB3Map6removeGssE(self.env, "__MOON_BASH_ABORT_CURRENT_COMMAND__");
        if (self.exit_code === 0) {
          self.exit_code = 1;
        }
        return undefined;
      }
      self.exit_code = BigInt.asUintN(64, result) !== BigInt.asUintN(64, 0n) ? 0 : 1;
      return;
    }
    default: {
      const _ConditionalCommand = cmd;
      const _cond = _ConditionalCommand._0;
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20execute__conditional(self, _cond);
      return;
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13execute__case(self, clause) {
  const word = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, clause.word);
  const _bind$4 = clause.items;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const item = _bind$4[_];
      _L: {
        let matched = false;
        const _bind$6 = item.patterns;
        const _bind$7 = _bind$6.length;
        let _tmp$39 = 0;
        while (true) {
          const _$2 = _tmp$39;
          if (_$2 < _bind$7) {
            const pattern = _bind$6[_$2];
            const pat = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, pattern);
            if (_M0FP410Haoxincode8moonbash3lib11interpreter22simple__pattern__match(word, pat)) {
              matched = true;
              break;
            }
            _tmp$39 = _$2 + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        if (matched) {
          _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, item.body);
          const _bind$8 = item.terminator;
          switch (_bind$8) {
            case 0: {
              return undefined;
            }
            case 1: {
              break _L;
            }
            default: {
              break _L;
            }
          }
        }
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20execute__conditional(self, cond) {
  const result = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext10eval__cond(self, cond);
  self.exit_code = result ? 0 : 1;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext10eval__cond(self, cond) {
  let _tmp$38 = cond;
  _L: while (true) {
    const cond$2 = _tmp$38;
    switch (cond$2.$tag) {
      case 0: {
        const _UnaryTest = cond$2;
        const _op = _UnaryTest._0;
        const _word = _UnaryTest._1;
        const value = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, _word);
        _L$2: {
          switch (_op) {
            case "-z": {
              return value.length === 0;
            }
            case "-n": {
              return value.length > 0;
            }
            case "-f": {
              let path;
              let _try_err;
              _L$3: {
                _L$4: {
                  const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, value);
                  if (_bind$4.$tag === 1) {
                    const _ok = _bind$4;
                    path = _ok._0;
                  } else {
                    const _err = _bind$4;
                    _try_err = _err._0;
                    break _L$4;
                  }
                  break _L$3;
                }
                return false;
              }
              const _bind$4 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.fs.entries, path);
              if (_bind$4 === undefined) {
                return false;
              } else {
                const _Some = _bind$4;
                const _x = _Some;
                if (_x.$tag === 0) {
                  return true;
                } else {
                  return false;
                }
              }
            }
            case "-d": {
              let path$2;
              let _try_err$2;
              _L$4: {
                _L$5: {
                  const _bind$5 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, value);
                  if (_bind$5.$tag === 1) {
                    const _ok = _bind$5;
                    path$2 = _ok._0;
                  } else {
                    const _err = _bind$5;
                    _try_err$2 = _err._0;
                    break _L$5;
                  }
                  break _L$4;
                }
                return false;
              }
              const _bind$5 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.fs.entries, path$2);
              if (_bind$5 === undefined) {
                return false;
              } else {
                const _Some = _bind$5;
                const _x = _Some;
                if (_x.$tag === 1) {
                  return true;
                } else {
                  return false;
                }
              }
            }
            case "-e": {
              let path$3;
              let _try_err$3;
              _L$5: {
                _L$6: {
                  const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, value);
                  if (_bind$6.$tag === 1) {
                    const _ok = _bind$6;
                    path$3 = _ok._0;
                  } else {
                    const _err = _bind$6;
                    _try_err$3 = _err._0;
                    break _L$6;
                  }
                  break _L$5;
                }
                return false;
              }
              return _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs6exists(self.fs, path$3);
            }
            case "-s": {
              let path$4;
              let _try_err$4;
              _L$6: {
                _L$7: {
                  const _bind$6 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, value);
                  if (_bind$6.$tag === 1) {
                    const _ok = _bind$6;
                    path$4 = _ok._0;
                  } else {
                    const _err = _bind$6;
                    _try_err$4 = _err._0;
                    break _L$7;
                  }
                  break _L$6;
                }
                return false;
              }
              const _bind$6 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.fs.entries, path$4);
              if (_bind$6 === undefined) {
                return false;
              } else {
                const _Some = _bind$6;
                const _x = _Some;
                if (_x.$tag === 0) {
                  const _File = _x;
                  const _data = _File._0;
                  return _data.content.length > 0;
                } else {
                  return false;
                }
              }
            }
            case "-r": {
              break _L$2;
            }
            case "-w": {
              break _L$2;
            }
            case "-x": {
              break _L$2;
            }
            case "-v": {
              return value.length === 0 ? false : _M0MPB3Map8containsGssE(self.env, value);
            }
            default: {
              return false;
            }
          }
        }
        let path;
        let _try_err;
        _L$3: {
          _L$4: {
            const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, value);
            if (_bind$4.$tag === 1) {
              const _ok = _bind$4;
              path = _ok._0;
            } else {
              const _err = _bind$4;
              _try_err = _err._0;
              break _L$4;
            }
            break _L$3;
          }
          return false;
        }
        return _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs6exists(self.fs, path);
      }
      case 1: {
        const _BinaryTest = cond$2;
        const _left_word = _BinaryTest._0;
        const _op$2 = _BinaryTest._1;
        const _right_word = _BinaryTest._2;
        const left = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, _left_word);
        const right = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, _right_word);
        _L$4: {
          switch (_op$2) {
            case "=": {
              break _L$4;
            }
            case "==": {
              break _L$4;
            }
            case "!=": {
              return !(left === right);
            }
            case "-eq": {
              return BigInt.asUintN(64, _M0FP410Haoxincode8moonbash3lib11interpreter15parse__int__str(left)) === BigInt.asUintN(64, _M0FP410Haoxincode8moonbash3lib11interpreter15parse__int__str(right));
            }
            case "-ne": {
              return BigInt.asUintN(64, _M0FP410Haoxincode8moonbash3lib11interpreter15parse__int__str(left)) !== BigInt.asUintN(64, _M0FP410Haoxincode8moonbash3lib11interpreter15parse__int__str(right));
            }
            case "-lt": {
              return BigInt.asIntN(64, _M0FP410Haoxincode8moonbash3lib11interpreter15parse__int__str(left)) < BigInt.asIntN(64, _M0FP410Haoxincode8moonbash3lib11interpreter15parse__int__str(right));
            }
            case "-le": {
              return BigInt.asIntN(64, _M0FP410Haoxincode8moonbash3lib11interpreter15parse__int__str(left)) <= BigInt.asIntN(64, _M0FP410Haoxincode8moonbash3lib11interpreter15parse__int__str(right));
            }
            case "-gt": {
              return BigInt.asIntN(64, _M0FP410Haoxincode8moonbash3lib11interpreter15parse__int__str(left)) > BigInt.asIntN(64, _M0FP410Haoxincode8moonbash3lib11interpreter15parse__int__str(right));
            }
            case "-ge": {
              return BigInt.asIntN(64, _M0FP410Haoxincode8moonbash3lib11interpreter15parse__int__str(left)) >= BigInt.asIntN(64, _M0FP410Haoxincode8moonbash3lib11interpreter15parse__int__str(right));
            }
            default: {
              return false;
            }
          }
        }
        return left === right;
      }
      case 2: {
        const _And = cond$2;
        const _left = _And._0;
        const _right = _And._1;
        if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext10eval__cond(self, _left)) {
          _tmp$38 = _right;
          continue _L;
        } else {
          return false;
        }
      }
      case 3: {
        const _Or = cond$2;
        const _left$2 = _Or._0;
        const _right$2 = _Or._1;
        if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext10eval__cond(self, _left$2)) {
          return true;
        } else {
          _tmp$38 = _right$2;
          continue _L;
        }
      }
      case 4: {
        const _Not = cond$2;
        const _inner = _Not._0;
        return !_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext10eval__cond(self, _inner);
      }
      default: {
        const _Regex = cond$2;
        const _left_word$2 = _Regex._0;
        const _right_word$2 = _Regex._1;
        const left$2 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, _left_word$2);
        const right$2 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, _right_word$2);
        return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18regex__cond__match(self, left$2, right$2);
      }
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20execute__cstyle__for(self, clause) {
  self.loop_depth = self.loop_depth + 1 | 0;
  let iter_count = 0;
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(self, clause.init);
  while (true) {
    if (self.should_exit || self.return_requested) {
      break;
    }
    if (self.break_count > 0) {
      self.break_count = self.break_count - 1 | 0;
      break;
    }
    iter_count = iter_count + 1 | 0;
    if (iter_count > self.limits.max_loop_iterations) {
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22fail__execution__limit(self, "for loop: too many iterations");
      break;
    }
    const cond = _M0FP410Haoxincode8moonbash3lib11interpreter26cstyle__condition__omitted(clause.condition) ? 1n : _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(self, clause.condition);
    if (BigInt.asUintN(64, cond) === BigInt.asUintN(64, 0n)) {
      break;
    }
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, clause.body);
    if (self.should_exit || self.return_requested) {
      break;
    }
    if (self.break_count > 0) {
      self.break_count = self.break_count - 1 | 0;
      break;
    }
    let continue_requested = false;
    if (self.continue_count > 0) {
      self.continue_count = self.continue_count - 1 | 0;
      if (self.continue_count > 0) {
        break;
      }
      continue_requested = true;
    }
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(self, clause.update);
    if (continue_requested) {
      continue;
    }
    continue;
  }
  self.loop_depth = self.loop_depth - 1 | 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12execute__for(self, clause) {
  const _bind$4 = clause.words;
  let words;
  if (_bind$4.$tag === 1) {
    const _Some = _bind$4;
    const _word_list = _Some._0;
    const expanded = [];
    const _bind$5 = _word_list.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$5) {
        const word = _word_list[_];
        const parts = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12expand__word(self, word);
        const _bind$6 = parts.length;
        let _tmp$39 = 0;
        while (true) {
          const _$2 = _tmp$39;
          if (_$2 < _bind$6) {
            const part = parts[_$2];
            _M0MPC15array5Array4pushGUssEE(expanded, part);
            _tmp$39 = _$2 + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    words = expanded;
  } else {
    const _p$4 = _M0MPB3Map3getGssE(self.env, "@");
    const _p$5 = "";
    let args_str;
    if (_p$4 === undefined) {
      args_str = _p$5;
    } else {
      const _p$6 = _p$4;
      args_str = _p$6;
    }
    words = args_str.length > 0 ? _M0FP410Haoxincode8moonbash3lib11interpreter21split__by__whitespace(args_str) : [];
  }
  self.loop_depth = self.loop_depth + 1 | 0;
  let iter_count = 0;
  const _bind$5 = words.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const word = words[_];
      _L: {
        if (self.should_exit || self.return_requested) {
          break;
        }
        if (self.break_count > 0) {
          self.break_count = self.break_count - 1 | 0;
          break;
        }
        iter_count = iter_count + 1 | 0;
        if (iter_count > self.limits.max_loop_iterations) {
          _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22fail__execution__limit(self, "for loop: too many iterations");
          break;
        }
        _M0MPB3Map3setGssE(self.env, clause.var_name, word);
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, clause.body);
        if (self.should_exit || self.return_requested) {
          break;
        }
        if (self.break_count > 0) {
          self.break_count = self.break_count - 1 | 0;
          break;
        }
        if (self.continue_count > 0) {
          self.continue_count = self.continue_count - 1 | 0;
          if (self.continue_count > 0) {
            break;
          }
          break _L;
        }
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.loop_depth = self.loop_depth - 1 | 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11execute__if(self, clause) {
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, clause.condition);
  if (self.exit_code === 0) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, clause.then_branch);
    return undefined;
  }
  const _bind$4 = clause.elif_branches;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const elif = _bind$4[_];
      const _cond = elif._0;
      const _body = elif._1;
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, _cond);
      if (self.exit_code === 0) {
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, _body);
        return undefined;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$6 = clause.else_branch;
  if (_bind$6 === undefined) {
    self.exit_code = 0;
    return;
  } else {
    const _Some = _bind$6;
    const _else_body = _Some;
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, _else_body);
    return;
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17execute__subshell(self, script) {
  const _bind$4 = [];
  const saved_env = _M0MPB3Map3MapGssE(new _M0TPB9ArrayViewGUssEE(_bind$4, 0, 0), undefined);
  const _it = _M0MPB3Map5iter2GssE(self.env);
  while (true) {
    const _bind$5 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$5 === undefined) {
      break;
    } else {
      const _Some = _bind$5;
      const _x = _Some;
      const _k = _x._0;
      const _v = _x._1;
      _M0MPB3Map3setGssE(saved_env, _k, _v);
      continue;
    }
  }
  const _bind$5 = [];
  const saved_exported = _M0MPB3Map3MapGsbE(new _M0TPB9ArrayViewGUsbEE(_bind$5, 0, 0), undefined);
  const _it$2 = _M0MPB3Map5iter2GsbE(self.exported);
  while (true) {
    const _bind$6 = _M0MPB5Iter24nextGsbE(_it$2);
    if (_bind$6 === undefined) {
      break;
    } else {
      const _Some = _bind$6;
      const _x = _Some;
      const _k = _x._0;
      const _v = _x._1;
      _M0MPB3Map3setGsbE(saved_exported, _k, _v);
      continue;
    }
  }
  const _bind$6 = [];
  const saved_functions = _M0MPB3Map3MapGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(new _M0TPB9ArrayViewGUsRP410Haoxincode8moonbash3lib3ast11FunctionDefEE(_bind$6, 0, 0), undefined);
  const _it$3 = _M0MPB3Map5iter2GssE(self.functions);
  while (true) {
    const _bind$7 = _M0MPB5Iter24nextGssE(_it$3);
    if (_bind$7 === undefined) {
      break;
    } else {
      const _Some = _bind$7;
      const _x = _Some;
      const _k = _x._0;
      const _v = _x._1;
      _M0MPB3Map3setGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(saved_functions, _k, _v);
      continue;
    }
  }
  const saved_cwd = self.cwd;
  const saved_should_exit = self.should_exit;
  const saved_return_requested = self.return_requested;
  const saved_break_count = self.break_count;
  const saved_continue_count = self.continue_count;
  self.should_exit = false;
  self.return_requested = false;
  self.break_count = 0;
  self.continue_count = 0;
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, script);
  const subshell_exit_code = self.exit_code;
  self.env = saved_env;
  self.exported = saved_exported;
  self.functions = saved_functions;
  self.cwd = saved_cwd;
  self.should_exit = saved_should_exit;
  self.return_requested = saved_return_requested;
  self.break_count = saved_break_count;
  self.continue_count = saved_continue_count;
  self.exit_code = subshell_exit_code;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14execute__until(self, clause) {
  self.loop_depth = self.loop_depth + 1 | 0;
  let iter_count = 0;
  let has_body_run = false;
  let last_body_status = 0;
  while (true) {
    if (self.should_exit || self.return_requested) {
      break;
    }
    if (self.break_count > 0) {
      self.break_count = self.break_count - 1 | 0;
      break;
    }
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, clause.condition);
    if (self.exit_code === 0) {
      self.exit_code = has_body_run ? last_body_status : 0;
      break;
    }
    iter_count = iter_count + 1 | 0;
    if (iter_count > self.limits.max_loop_iterations) {
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22fail__execution__limit(self, "until loop: too many iterations");
      break;
    }
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, clause.body);
    has_body_run = true;
    last_body_status = self.exit_code;
    if (self.should_exit || self.return_requested) {
      break;
    }
    if (self.break_count > 0) {
      self.break_count = self.break_count - 1 | 0;
      break;
    }
    if (self.continue_count > 0) {
      self.continue_count = self.continue_count - 1 | 0;
      if (self.continue_count > 0) {
        break;
      }
      continue;
    }
    continue;
  }
  self.loop_depth = self.loop_depth - 1 | 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14execute__while(self, clause) {
  self.loop_depth = self.loop_depth + 1 | 0;
  let iter_count = 0;
  let has_body_run = false;
  let last_body_status = 0;
  while (true) {
    if (self.should_exit || self.return_requested) {
      break;
    }
    if (self.break_count > 0) {
      self.break_count = self.break_count - 1 | 0;
      break;
    }
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, clause.condition);
    if (self.exit_code !== 0) {
      self.exit_code = has_body_run ? last_body_status : 0;
      break;
    }
    iter_count = iter_count + 1 | 0;
    if (iter_count > self.limits.max_loop_iterations) {
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22fail__execution__limit(self, "while loop: too many iterations");
      break;
    }
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, clause.body);
    has_body_run = true;
    last_body_status = self.exit_code;
    if (self.should_exit || self.return_requested) {
      break;
    }
    if (self.break_count > 0) {
      self.break_count = self.break_count - 1 | 0;
      break;
    }
    if (self.continue_count > 0) {
      self.continue_count = self.continue_count - 1 | 0;
      if (self.continue_count > 0) {
        break;
      }
      continue;
    }
    continue;
  }
  self.loop_depth = self.loop_depth - 1 | 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simple(self, cmd) {
  _M0MPB3Map6removeGssE(self.env, "__MOON_BASH_ABORT_CURRENT_COMMAND__");
  const has_words = cmd.words.length > 0;
  let prefix_assignment_restore_names = [];
  const _bind$4 = [];
  let prefix_assignment_snapshot = _M0MPB3Map3MapGssE(new _M0TPB9ArrayViewGUssEE(_bind$4, 0, 0), undefined);
  let track_prefix_assignment_restore = false;
  if (cmd.assignments.length > 0) {
    self.exit_code = 0;
    if (has_words) {
      prefix_assignment_restore_names = _M0FP410Haoxincode8moonbash3lib11interpreter35collect__assignment__restore__names(cmd.assignments);
      if (prefix_assignment_restore_names.length > 0) {
        prefix_assignment_snapshot = _M0FP410Haoxincode8moonbash3lib11interpreter34snapshot__assignment__env__entries(self.env, prefix_assignment_restore_names);
        track_prefix_assignment_restore = true;
      }
    }
    let keep_expansion_status = false;
    const _bind$5 = cmd.assignments;
    const _bind$6 = _bind$5.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$6) {
        const assign = _bind$5[_];
        _L: {
          const _bind$7 = assign.value;
          if (_bind$7 === undefined) {
            const _bind$8 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext34resolve__array__assignment__target(self, assign.name);
            if (_bind$8 === undefined) {
            } else {
              const _Some = _bind$8;
              const _x = _Some;
              const _base = _x._0;
              const _index = _x._1;
              if (self.should_exit) {
                return undefined;
              }
              _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33store__array__element__assignment(self, _base, _index, "", assign.append);
              break _L;
            }
            const _p$4 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_NAMEREF__${assign.name}`);
            const _p$5 = assign.name;
            let target_name;
            if (_p$4 === undefined) {
              target_name = _p$5;
            } else {
              const _p$6 = _p$4;
              target_name = _p$6;
            }
            const _bind$9 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext34resolve__array__assignment__target(self, target_name);
            if (_bind$9 === undefined) {
            } else {
              const _Some = _bind$9;
              const _x = _Some;
              const _target_base = _x._0;
              const _target_index = _x._1;
              if (self.should_exit) {
                return undefined;
              }
              _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33store__array__element__assignment(self, _target_base, _target_index, "", assign.append);
              if (self.should_exit) {
                return undefined;
              }
              break _L;
            }
            if (assign.append) {
              if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33append__scalar__array__assignment(self, target_name, "")) {
                if (self.should_exit) {
                  return undefined;
                }
                break _L;
              }
            }
            let next_value;
            if (assign.append) {
              const _p$6 = _M0MPB3Map3getGssE(self.env, target_name);
              const _p$7 = "";
              if (_p$6 === undefined) {
                next_value = _p$7;
              } else {
                const _p$8 = _p$6;
                next_value = _p$8;
              }
            } else {
              next_value = "";
            }
            if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25store__scalar__assignment(self, target_name, next_value)) {
              return undefined;
            }
          } else {
            const _Some = _bind$7;
            const _word = _Some;
            if (_M0FP410Haoxincode8moonbash3lib11interpreter39word__has__status__sensitive__expansion(_word)) {
              keep_expansion_status = true;
            }
            if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29try__store__array__assignment(self, assign.name, _word, assign.append)) {
              if (has_words) {
                self.exit_code = 2;
                self.should_exit = true;
                return undefined;
              }
              break _L;
            }
            const value = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, _word);
            if (self.should_exit) {
              return undefined;
            }
            if (_M0MPB3Map8containsGssE(self.env, "__MOON_BASH_ABORT_CURRENT_COMMAND__")) {
              return undefined;
            }
            const _bind$8 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext34resolve__array__assignment__target(self, assign.name);
            if (_bind$8 === undefined) {
            } else {
              const _Some$2 = _bind$8;
              const _x = _Some$2;
              const _base = _x._0;
              const _index = _x._1;
              if (self.should_exit) {
                return undefined;
              }
              const _bind$9 = _M0FP410Haoxincode8moonbash3lib11interpreter31split__array__assignment__items(_word.parts);
              if (_bind$9.$tag === 1) {
                self.exit_code = 2;
                self.should_exit = true;
                return undefined;
              }
              _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33store__array__element__assignment(self, _base, _index, value, assign.append);
              break _L;
            }
            const _p$4 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_NAMEREF__${assign.name}`);
            const _p$5 = assign.name;
            let target_name;
            if (_p$4 === undefined) {
              target_name = _p$5;
            } else {
              const _p$6 = _p$4;
              target_name = _p$6;
            }
            const _bind$9 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext34resolve__array__assignment__target(self, target_name);
            if (_bind$9 === undefined) {
            } else {
              const _Some$2 = _bind$9;
              const _x = _Some$2;
              const _target_base = _x._0;
              const _target_index = _x._1;
              if (self.should_exit) {
                return undefined;
              }
              _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33store__array__element__assignment(self, _target_base, _target_index, value, assign.append);
              if (self.should_exit) {
                return undefined;
              }
              break _L;
            }
            if (assign.append) {
              if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33append__scalar__array__assignment(self, target_name, value)) {
                if (self.should_exit) {
                  return undefined;
                }
                break _L;
              }
            }
            let next_value;
            if (assign.append) {
              const _p$6 = _M0MPB3Map3getGssE(self.env, target_name);
              const _p$7 = "";
              let existing;
              if (_p$6 === undefined) {
                existing = _p$7;
              } else {
                const _p$8 = _p$6;
                existing = _p$8;
              }
              next_value = `${existing}${value}`;
            } else {
              next_value = value;
            }
            if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25store__scalar__assignment(self, target_name, next_value)) {
              return undefined;
            }
          }
          break _L;
        }
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    if (!has_words) {
      if (!self.should_exit && (!keep_expansion_status && self.exit_code === 0)) {
        self.exit_code = 0;
      }
      return undefined;
    }
    if (_M0FP410Haoxincode8moonbash3lib11interpreter34word__starts__with__literal__paren(_M0MPC15array5Array2atGUssEE(cmd.words, 0))) {
      let has_empty_prefix_assignment = false;
      const _bind$7 = cmd.assignments;
      const _bind$8 = _bind$7.length;
      let _tmp$39 = 0;
      while (true) {
        const _ = _tmp$39;
        if (_ < _bind$8) {
          const assign = _bind$7[_];
          const _bind$9 = assign.value;
          if (_bind$9 === undefined) {
            has_empty_prefix_assignment = true;
            break;
          } else {
            const _Some = _bind$9;
            const _word = _Some;
            if (_M0FP410Haoxincode8moonbash3lib11interpreter36assignment__word__is__empty__literal(_word)) {
              has_empty_prefix_assignment = true;
              break;
            }
          }
          _tmp$39 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      if (has_empty_prefix_assignment) {
        self.exit_code = 2;
        self.should_exit = true;
        return undefined;
      }
    }
  }
  const expanded = [];
  _M0MPB3Map6removeGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN36cmd__sub__stderr__capture__path__keyS3491);
  _M0MPB3Map6removeGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN36cmd__sub__stderr__capture__data__keyS3492);
  const saved_pending_cmd_sub_stderr = _M0MPB3Map3getGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN30pending__cmd__sub__stderr__keyS3493);
  const _bind$5 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext41pending__cmd__sub__stderr__redirect__spec(self, cmd.redirections);
  if (_bind$5 === undefined) {
    _M0MPB3Map6removeGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN30pending__cmd__sub__stderr__keyS3493);
  } else {
    const _Some = _bind$5;
    const _spec = _Some;
    _M0MPB3Map3setGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN30pending__cmd__sub__stderr__keyS3493, _spec);
  }
  const syntactic_double_bracket = cmd.words.length > 0 && (_M0FP410Haoxincode8moonbash3lib11interpreter25word__is__single__literal(_M0MPC15array5Array2atGUssEE(cmd.words, 0), "[[") && cmd.assignments.length === 0);
  if (cmd.words.length > 0) {
    const first_parts = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12expand__word(self, _M0MPC15array5Array2atGUssEE(cmd.words, 0));
    const _bind$6 = first_parts.length;
    let _tmp$38 = 0;
    while (true) {
      const _ = _tmp$38;
      if (_ < _bind$6) {
        const part = first_parts[_];
        _M0MPC15array5Array4pushGUssEE(expanded, part);
        _tmp$38 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    if (self.should_exit) {
      if (saved_pending_cmd_sub_stderr === undefined) {
        _M0MPB3Map6removeGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN30pending__cmd__sub__stderr__keyS3493);
      } else {
        const _Some = saved_pending_cmd_sub_stderr;
        const _value = _Some;
        _M0MPB3Map3setGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN30pending__cmd__sub__stderr__keyS3493, _value);
      }
      return undefined;
    }
    const cmd_name_for_expansion = expanded.length > 0 ? _M0MPC15array5Array2atGUssEE(expanded, 0) : "";
    const first_word_static = _M0FP410Haoxincode8moonbash3lib11interpreter42word__is__static__command__name__candidate(_M0MPC15array5Array2atGUssEE(cmd.words, 0));
    const disable_glob_args = cmd_name_for_expansion === "find";
    const grep_like = _M0FP410Haoxincode8moonbash3lib11interpreter23is__grep__like__command(cmd_name_for_expansion);
    let grep_pattern_set = false;
    let grep_stop_options = false;
    let grep_expect_e_pattern = false;
    let _tmp$39 = 1;
    while (true) {
      const i = _tmp$39;
      if (i < cmd.words.length) {
        const assignment_builtin_active = _M0FP410Haoxincode8moonbash3lib11interpreter49assignment__builtin__active__for__expanded__words(expanded, first_word_static);
        let parts;
        if (assignment_builtin_active) {
          const _bind$7 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext38expand__compound__assignment__argument(self, _M0MPC15array5Array2atGUssEE(cmd.words, i));
          if (_bind$7 === undefined) {
            parts = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12expand__word(self, _M0MPC15array5Array2atGUssEE(cmd.words, i));
          } else {
            const _Some = _bind$7;
            const _raw = _Some;
            parts = [_raw];
          }
        } else {
          if (syntactic_double_bracket) {
            parts = [_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31expand__conditional__test__word(self, _M0MPC15array5Array2atGUssEE(cmd.words, i))];
          } else {
            if (disable_glob_args) {
              parts = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22expand__word__no__glob(self, _M0MPC15array5Array2atGUssEE(cmd.words, i));
            } else {
              if (grep_like) {
                const raw_parts = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22expand__word__no__glob(self, _M0MPC15array5Array2atGUssEE(cmd.words, i));
                const expanded_parts = [];
                const _bind$7 = raw_parts.length;
                let _tmp$40 = 0;
                while (true) {
                  const _ = _tmp$40;
                  if (_ < _bind$7) {
                    const token = raw_parts[_];
                    let no_glob = false;
                    if (grep_expect_e_pattern) {
                      grep_expect_e_pattern = false;
                      grep_pattern_set = true;
                      no_glob = true;
                    } else {
                      if (!grep_stop_options) {
                        if (token === "--") {
                          grep_stop_options = true;
                          no_glob = true;
                        } else {
                          if (token === "-e" || token === "--regexp") {
                            grep_expect_e_pattern = true;
                            no_glob = true;
                          } else {
                            if (_M0MPC16string6String11has__prefix(token, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN7_2abindS9208, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN7_2abindS9208.length)) && token.length > 2) {
                              grep_pattern_set = true;
                              no_glob = true;
                            } else {
                              if (_M0MPC16string6String11has__prefix(token, new _M0TPC16string10StringView(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN7_2abindS9209, 0, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN7_2abindS9209.length))) {
                                grep_pattern_set = true;
                                no_glob = true;
                              } else {
                                let _tmp$41;
                                if (token.length > 1) {
                                  $bound_check(token, 0);
                                  const _p$4 = token.charCodeAt(0);
                                  const _p$5 = 45;
                                  _tmp$41 = _p$4 === _p$5;
                                } else {
                                  _tmp$41 = false;
                                }
                                if (_tmp$41) {
                                  no_glob = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                    if (!no_glob) {
                      if (!grep_pattern_set) {
                        grep_pattern_set = true;
                        no_glob = true;
                      }
                    }
                    if (no_glob) {
                      _M0MPC15array5Array4pushGUssEE(expanded_parts, token);
                    } else {
                      const globbed = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16pathname__expand(self, [token]);
                      const _bind$8 = globbed.length;
                      let _tmp$41 = 0;
                      while (true) {
                        const _$2 = _tmp$41;
                        if (_$2 < _bind$8) {
                          const piece = globbed[_$2];
                          _M0MPC15array5Array4pushGUssEE(expanded_parts, piece);
                          _tmp$41 = _$2 + 1 | 0;
                          continue;
                        } else {
                          break;
                        }
                      }
                    }
                    _tmp$40 = _ + 1 | 0;
                    continue;
                  } else {
                    break;
                  }
                }
                parts = expanded_parts;
              } else {
                parts = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12expand__word(self, _M0MPC15array5Array2atGUssEE(cmd.words, i));
              }
            }
          }
        }
        const _bind$7 = parts.length;
        let _tmp$40 = 0;
        while (true) {
          const _ = _tmp$40;
          if (_ < _bind$7) {
            const part = parts[_];
            _M0MPC15array5Array4pushGUssEE(expanded, part);
            _tmp$40 = _ + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        if (self.should_exit) {
          if (saved_pending_cmd_sub_stderr === undefined) {
            _M0MPB3Map6removeGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN30pending__cmd__sub__stderr__keyS3493);
          } else {
            const _Some = saved_pending_cmd_sub_stderr;
            const _value = _Some;
            _M0MPB3Map3setGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN30pending__cmd__sub__stderr__keyS3493, _value);
          }
          return undefined;
        }
        _tmp$39 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  if (saved_pending_cmd_sub_stderr === undefined) {
    _M0MPB3Map6removeGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN30pending__cmd__sub__stderr__keyS3493);
  } else {
    const _Some = saved_pending_cmd_sub_stderr;
    const _value = _Some;
    _M0MPB3Map3setGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN30pending__cmd__sub__stderr__keyS3493, _value);
  }
  if (self.should_exit) {
    return undefined;
  }
  if (_M0MPB3Map8containsGssE(self.env, "__MOON_BASH_ABORT_CURRENT_COMMAND__")) {
    _M0MPB3Map6removeGssE(self.env, "__MOON_BASH_ABORT_CURRENT_COMMAND__");
    return undefined;
  }
  if (expanded.length === 0) {
    self.exit_code = 0;
    return undefined;
  }
  const alias_candidate = cmd.words.length > 0 ? _M0FP410Haoxincode8moonbash3lib11interpreter33alias__expansion__candidate__name(_M0MPC15array5Array2atGUssEE(cmd.words, 0)) : undefined;
  const alias_has_multiline_literal_arg = _M0FP410Haoxincode8moonbash3lib11interpreter41alias__call__has__multiline__literal__arg(cmd.words);
  const cmd_name = _M0MPC15array5Array2atGUssEE(expanded, 0);
  const run_cmd_name = cmd_name === "[[" && !syntactic_double_bracket ? "__MOON_BASH_RUNTIME_DBRACKET__" : cmd_name;
  const args = [];
  let _tmp$38 = 1;
  while (true) {
    const i = _tmp$38;
    if (i < expanded.length) {
      _M0MPC15array5Array4pushGUssEE(args, _M0MPC15array5Array2atGUssEE(expanded, i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$6 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20consume__extra__args(self);
  const _bind$7 = _bind$6.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$7) {
      const arg = _bind$6[_];
      _M0MPC15array5Array4pushGUssEE(args, arg);
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const should_restore_prefix_assignments = track_prefix_assignment_restore && !_M0FP410Haoxincode8moonbash3lib11interpreter35command__keeps__prefix__assignments(run_cmd_name);
  const _bind$8 = [];
  const originally_exported_prefix_assignments = _M0MPB3Map3MapGsbE(new _M0TPB9ArrayViewGUsbEE(_bind$8, 0, 0), undefined);
  if (has_words) {
    const _bind$9 = prefix_assignment_restore_names;
    const _bind$10 = _bind$9.length;
    let _tmp$40 = 0;
    while (true) {
      const _ = _tmp$40;
      if (_ < _bind$10) {
        const name = _bind$9[_];
        if (_M0MPB3Map8containsGsbE(self.exported, name)) {
          _M0MPB3Map3setGsbE(originally_exported_prefix_assignments, name, true);
        }
        _M0MPB3Map3setGsbE(self.exported, name, true);
        _tmp$40 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  const saved_stdout = self.stdout_buf;
  const saved_stderr = self.stderr_buf;
  const saved_stdin = self.stdin_buf;
  let redirected_file = undefined;
  let redirect_append = false;
  let redirected_stderr_file = undefined;
  let redirect_stderr_append = false;
  let null_output = false;
  let null_stderr = false;
  let stdout_to_stderr = false;
  let stderr_to_stdout = false;
  let input_from_file = false;
  const exec_builtin = run_cmd_name === "exec";
  const _bind$9 = cmd.redirections;
  const _bind$10 = _bind$9.length;
  let _tmp$40 = 0;
  while (true) {
    const _ = _tmp$40;
    if (_ < _bind$10) {
      const redir = _bind$9[_];
      _L: {
        const _bind$11 = redir.op;
        switch (_bind$11.$tag) {
          case 1: {
            const target = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, redir.target);
            const _bind$12 = redir.fd;
            let source_fd;
            if (_bind$12 === undefined) {
              source_fd = 1;
            } else {
              const _Some = _bind$12;
              source_fd = _Some;
            }
            if (exec_builtin && source_fd !== 1) {
              _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext26store__fd__output__mapping(self, source_fd, target, false);
              break _L;
            }
            if (source_fd === 2) {
              if (target === "/dev/null") {
                null_stderr = true;
                self.stderr_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
              } else {
                if (target === "/dev/stdout" || target === "1") {
                  stderr_to_stdout = true;
                  self.stderr_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                } else {
                  redirected_stderr_file = target;
                  redirect_stderr_append = false;
                  self.stderr_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                }
              }
              break _L;
            }
            if (source_fd !== 1) {
              break _L;
            }
            if (target === "/dev/null") {
              null_output = true;
              self.stdout_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
            } else {
              if (target === "/dev/stderr") {
                stdout_to_stderr = true;
                self.stdout_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
              } else {
                redirected_file = target;
                redirect_append = false;
                self.stdout_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
              }
            }
            break;
          }
          case 2: {
            const target$2 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, redir.target);
            const _bind$13 = redir.fd;
            let source_fd$2;
            if (_bind$13 === undefined) {
              source_fd$2 = 1;
            } else {
              const _Some = _bind$13;
              source_fd$2 = _Some;
            }
            if (exec_builtin && source_fd$2 !== 1) {
              _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext26store__fd__output__mapping(self, source_fd$2, target$2, true);
              break _L;
            }
            if (source_fd$2 === 2) {
              if (target$2 === "/dev/null") {
                null_stderr = true;
                self.stderr_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
              } else {
                if (target$2 === "/dev/stdout" || target$2 === "1") {
                  stderr_to_stdout = true;
                  self.stderr_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                } else {
                  redirected_stderr_file = target$2;
                  redirect_stderr_append = true;
                  self.stderr_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                }
              }
              break _L;
            }
            if (source_fd$2 !== 1) {
              break _L;
            }
            if (target$2 === "/dev/null") {
              null_output = true;
              self.stdout_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
            } else {
              redirected_file = target$2;
              redirect_append = true;
              self.stdout_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
            }
            break;
          }
          case 0: {
            const target$3 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, redir.target);
            if (target$3 === "/dev/null") {
              self.stdin_buf = "";
              input_from_file = true;
              break _L;
            }
            let resolved;
            let _try_err;
            _L$2: {
              _L$3: {
                const _bind$14 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, target$3);
                if (_bind$14.$tag === 1) {
                  const _ok = _bind$14;
                  resolved = _ok._0;
                } else {
                  const _err = _bind$14;
                  _try_err = _err._0;
                  break _L$3;
                }
                break _L$2;
              }
              resolved = target$3;
            }
            let content;
            let _try_err$2;
            _L$3: {
              _L$4: {
                const _bind$14 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(self.fs, resolved);
                if (_bind$14.$tag === 1) {
                  const _ok = _bind$14;
                  content = _ok._0;
                } else {
                  const _err = _bind$14;
                  _try_err$2 = _err._0;
                  break _L$4;
                }
                break _L$3;
              }
              const _FsError = _try_err$2;
              const _msg = _FsError._0;
              _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: ${_msg}\n`);
              self.exit_code = 1;
              return undefined;
            }
            self.stdin_buf = content;
            input_from_file = true;
            break;
          }
          case 6: {
            const content$2 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, redir.target);
            self.stdin_buf = `${content$2}\n`;
            input_from_file = true;
            break;
          }
          case 5: {
            const content$3 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, redir.target);
            self.stdin_buf = content$3;
            input_from_file = true;
            break;
          }
          case 8: {
            const target$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, redir.target);
            const _bind$14 = redir.fd;
            let source_fd$3;
            if (_bind$14 === undefined) {
              source_fd$3 = 1;
            } else {
              const _Some = _bind$14;
              source_fd$3 = _Some;
            }
            if (exec_builtin) {
              if (target$4 === "-") {
                _M0MPB3Map6removeGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter15fd__output__key(source_fd$3));
                break _L;
              }
              const _bind$15 = _M0FP410Haoxincode8moonbash3lib11interpreter25parse__fd__target__number(target$4);
              if (_bind$15 === undefined) {
              } else {
                const _Some = _bind$15;
                const _target_fd = _Some;
                const _bind$16 = _M0MPB3Map3getGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter15fd__output__key(_target_fd));
                if (_bind$16 === undefined) {
                  _M0MPB3Map6removeGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter15fd__output__key(source_fd$3));
                } else {
                  const _Some$2 = _bind$16;
                  const _spec = _Some$2;
                  _M0MPB3Map3setGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter15fd__output__key(source_fd$3), _spec);
                }
                break _L;
              }
            }
            if (source_fd$3 === 1) {
              const _bind$15 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25load__fd__output__mapping(self, target$4);
              if (_bind$15 === undefined) {
              } else {
                const _Some = _bind$15;
                const _x = _Some;
                const _path = _x._0;
                const _append_mode = _x._1;
                if (_path === "/dev/null") {
                  null_output = true;
                  self.stdout_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                } else {
                  if (_path === "/dev/stderr") {
                    stdout_to_stderr = true;
                    self.stdout_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                  } else {
                    redirected_file = _path;
                    redirect_append = _append_mode;
                    self.stdout_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
                  }
                }
                break _L;
              }
            }
            if (source_fd$3 === 2 && (target$4 === "1" || target$4 === "/dev/stdout")) {
              stderr_to_stdout = true;
              self.stderr_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
            } else {
              if (source_fd$3 === 2 && target$4 === "-") {
                null_stderr = true;
                self.stderr_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
              }
            }
            if (source_fd$3 === 1 && (target$4 === "2" || target$4 === "/dev/stderr")) {
              stdout_to_stderr = true;
              self.stdout_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
            } else {
              if (source_fd$3 === 1 && target$4 === "-") {
                null_output = true;
                self.stdout_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
              }
            }
            break;
          }
          case 9: {
            const target$5 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, redir.target);
            if (target$5 === "/dev/null") {
              null_output = true;
              self.stdout_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
            }
            break;
          }
        }
        break _L;
      }
      _tmp$40 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext28try__execute__alias__command(self, alias_candidate, args, alias_has_multiline_literal_arg)) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12run__command(self, run_cmd_name, args);
  }
  if (should_restore_prefix_assignments) {
    _M0FP410Haoxincode8moonbash3lib11interpreter33restore__assignment__env__entries(self.env, prefix_assignment_restore_names, prefix_assignment_snapshot);
    const _bind$11 = prefix_assignment_restore_names;
    const _bind$12 = _bind$11.length;
    let _tmp$41 = 0;
    while (true) {
      const _ = _tmp$41;
      if (_ < _bind$12) {
        const name = _bind$11[_];
        if (!_M0MPB3Map8containsGsbE(originally_exported_prefix_assignments, name)) {
          _M0MPB3Map6removeGsbE(self.exported, name);
        }
        _tmp$41 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  const _bind$11 = redirected_file;
  if (_bind$11 === undefined) {
    if (stdout_to_stderr) {
      const _p$4 = self.stdout_buf;
      const output = _p$4.val;
      _M0IPB13StringBuilderPB6Logger13write__string(saved_stderr, output);
      self.stdout_buf = saved_stdout;
    } else {
      if (null_output) {
        self.stdout_buf = saved_stdout;
      }
    }
  } else {
    const _Some = _bind$11;
    const _path = _Some;
    const _p$4 = self.stdout_buf;
    const output = _p$4.val;
    let resolved;
    let _try_err;
    _L: {
      _L$2: {
        const _bind$12 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, _path);
        if (_bind$12.$tag === 1) {
          const _ok = _bind$12;
          resolved = _ok._0;
        } else {
          const _err = _bind$12;
          _try_err = _err._0;
          break _L$2;
        }
        break _L;
      }
      resolved = _path;
    }
    let _try_err$2;
    _L$2: {
      _L$3: {
        if (redirect_append) {
          const _bind$12 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs12append__file(self.fs, resolved, output);
          if (_bind$12.$tag === 1) {
            const _ok = _bind$12;
            _ok._0;
          } else {
            const _err = _bind$12;
            _try_err$2 = _err._0;
            break _L$3;
          }
        } else {
          const _bind$12 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs11write__file(self.fs, resolved, output);
          if (_bind$12.$tag === 1) {
            const _ok = _bind$12;
            _ok._0;
          } else {
            const _err = _bind$12;
            _try_err$2 = _err._0;
            break _L$3;
          }
        }
        break _L$2;
      }
      const _FsError = _try_err$2;
      const _msg = _FsError._0;
      _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: ${_msg}\n`);
    }
    self.stdout_buf = saved_stdout;
  }
  const _bind$12 = redirected_stderr_file;
  if (_bind$12 === undefined) {
    if (stderr_to_stdout) {
      const _p$4 = self.stderr_buf;
      const output = _p$4.val;
      _M0IPB13StringBuilderPB6Logger13write__string(saved_stdout, output);
      self.stderr_buf = saved_stderr;
    } else {
      if (null_stderr) {
        self.stderr_buf = saved_stderr;
      }
    }
    _M0MPB3Map6removeGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN36cmd__sub__stderr__capture__path__keyS3491);
    _M0MPB3Map6removeGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN36cmd__sub__stderr__capture__data__keyS3492);
  } else {
    const _Some = _bind$12;
    const _path = _Some;
    let resolved;
    let _try_err;
    _L: {
      _L$2: {
        const _bind$13 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, _path);
        if (_bind$13.$tag === 1) {
          const _ok = _bind$13;
          resolved = _ok._0;
        } else {
          const _err = _bind$13;
          _try_err = _err._0;
          break _L$2;
        }
        break _L;
      }
      resolved = _path;
    }
    const _p$4 = self.stderr_buf;
    let output = _p$4.val;
    const _bind$13 = _M0MPB3Map3getGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN36cmd__sub__stderr__capture__path__keyS3491);
    if (_bind$13 === undefined) {
    } else {
      const _Some$2 = _bind$13;
      const _captured_path = _Some$2;
      if (_captured_path === resolved) {
        const _p$5 = _M0MPB3Map3getGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN36cmd__sub__stderr__capture__data__keyS3492);
        const _p$6 = "";
        let captured;
        if (_p$5 === undefined) {
          captured = _p$6;
        } else {
          const _p$7 = _p$5;
          captured = _p$7;
        }
        output = `${captured}${output}`;
      }
    }
    let _try_err$2;
    _L$2: {
      _L$3: {
        if (redirect_stderr_append) {
          const _bind$14 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs12append__file(self.fs, resolved, output);
          if (_bind$14.$tag === 1) {
            const _ok = _bind$14;
            _ok._0;
          } else {
            const _err = _bind$14;
            _try_err$2 = _err._0;
            break _L$3;
          }
        } else {
          const _bind$14 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs11write__file(self.fs, resolved, output);
          if (_bind$14.$tag === 1) {
            const _ok = _bind$14;
            _ok._0;
          } else {
            const _err = _bind$14;
            _try_err$2 = _err._0;
            break _L$3;
          }
        }
        break _L$2;
      }
      const _FsError = _try_err$2;
      const _msg = _FsError._0;
      _M0IPB13StringBuilderPB6Logger13write__string(saved_stderr, `moon_bash: ${_msg}\n`);
    }
    _M0MPB3Map6removeGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN36cmd__sub__stderr__capture__path__keyS3491);
    _M0MPB3Map6removeGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__simpleN36cmd__sub__stderr__capture__data__keyS3492);
    self.stderr_buf = saved_stderr;
  }
  if (input_from_file) {
    self.stdin_buf = saved_stdin;
  }
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext28enforce__output__size__limit(self);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext38expand__compound__assignment__argument(self, word) {
  const raw = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext54expand__compound__assignment__word__preserving__quotes(self, word);
  if (self.should_exit) {
    return undefined;
  }
  _L: {
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter24parse__name__value__spec(raw);
    if (_bind$4 === undefined) {
      break _L;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _x$2 = _x._1;
      if (_x$2 === undefined) {
        break _L;
      } else {
        return raw;
      }
    }
  }
  return undefined;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext54expand__compound__assignment__word__preserving__quotes(self, word) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _bind$4 = word.parts;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const part = _bind$4[_];
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext54expand__compound__assignment__part__preserving__quotes(self, part));
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext54expand__compound__assignment__part__preserving__quotes(self, part) {
  switch (part.$tag) {
    case 1: {
      const _SingleQuoted = part;
      const _text = _SingleQuoted._0;
      return _M0FP410Haoxincode8moonbash3lib11interpreter34encode__assignment__quoted__marker(_text);
    }
    case 2: {
      const _DoubleQuoted = part;
      const _inner_parts = _DoubleQuoted._0;
      return _M0FP410Haoxincode8moonbash3lib11interpreter34encode__assignment__quoted__marker(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29expand__double__quoted__parts(self, _inner_parts));
    }
    default: {
      return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18expand__word__part(self, part);
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29expand__double__quoted__parts(self, inner_parts) {
  const saved_marker = _M0MPB3Map3getGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29expand__double__quoted__partsN11marker__keyS2453);
  _M0MPB3Map3setGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29expand__double__quoted__partsN11marker__keyS2453, "1");
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _bind$4 = inner_parts.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const p = inner_parts[_];
      _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18expand__word__part(self, p));
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (saved_marker === undefined) {
    _M0MPB3Map6removeGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29expand__double__quoted__partsN11marker__keyS2453);
  } else {
    const _Some = saved_marker;
    const _value = _Some;
    _M0MPB3Map3setGssE(self.env, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29expand__double__quoted__partsN11marker__keyS2453, _value);
  }
  return buf.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31expand__conditional__test__word(self, word) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _bind$4 = word.parts;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const part = _bind$4[_];
      _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31expand__conditional__part__text(self, part));
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const expanded = out.val;
  if (_M0FP410Haoxincode8moonbash3lib11interpreter23word__is__single__tilde(word)) {
    return `\u0006${expanded}`;
  }
  if (!_M0FP410Haoxincode8moonbash3lib11interpreter24word__is__plain__literal(word)) {
    return `\u0007${expanded}`;
  }
  return expanded;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31expand__conditional__part__text(self, part) {
  switch (part.$tag) {
    case 0: {
      const _Literal = part;
      return _Literal._0;
    }
    case 1: {
      const _SingleQuoted = part;
      const _text = _SingleQuoted._0;
      return _M0FP410Haoxincode8moonbash3lib11interpreter31escape__conditional__glob__meta(_text);
    }
    case 2: {
      const _DoubleQuoted = part;
      const _inner_parts = _DoubleQuoted._0;
      const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
      const _bind$4 = _inner_parts.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$4) {
          const inner = _inner_parts[_];
          _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18expand__word__part(self, inner));
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return _M0FP410Haoxincode8moonbash3lib11interpreter31escape__conditional__glob__meta(out.val);
    }
    default: {
      return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18expand__word__part(self, part);
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22expand__word__no__glob(self, word) {
  return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22expand__word__internal(self, word, false);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext41pending__cmd__sub__stderr__redirect__spec(self, redirections) {
  let spec = undefined;
  const _bind$4 = redirections.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const redir = redirections[_];
      _L: {
        const _bind$5 = redir.fd;
        let source_fd;
        if (_bind$5 === undefined) {
          source_fd = 1;
        } else {
          const _Some = _bind$5;
          source_fd = _Some;
        }
        if (source_fd !== 2) {
          break _L;
        }
        const _bind$6 = redir.op;
        switch (_bind$6.$tag) {
          case 1: {
            const target = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, redir.target);
            if (target === "/dev/null" || (target === "/dev/stdout" || target === "1")) {
              spec = undefined;
            } else {
              spec = `w:${target}`;
            }
            break;
          }
          case 2: {
            const target$2 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, redir.target);
            if (target$2 === "/dev/null" || (target$2 === "/dev/stdout" || target$2 === "1")) {
              spec = undefined;
            } else {
              spec = `a:${target$2}`;
            }
            break;
          }
        }
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return spec;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext34resolve__array__assignment__target(self, raw_name) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter39parse__array__element__assignment__name(raw_name);
  if (_bind$4 === undefined) {
    return undefined;
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _base = _x._0;
    const _index_expr = _x._1;
    const trimmed = _M0FP410Haoxincode8moonbash3lib11interpreter26trim__ascii__space__simple(_index_expr);
    if (trimmed.length === 0) {
      return { _0: _base, _1: _index_expr };
    }
    const expanded_index = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext26expand__array__index__expr(self, trimmed);
    if (self.should_exit) {
      return { _0: _base, _1: _index_expr };
    }
    let resolved_index = expanded_index.length > 0 ? expanded_index : trimmed;
    if (_M0FP410Haoxincode8moonbash3lib11interpreter27arith__is__identifier__text(trimmed)) {
      const _p$4 = _M0MPB3Map3getGssE(self.env, trimmed);
      const _p$5 = "";
      let dynamic_raw;
      if (_p$4 === undefined) {
        dynamic_raw = _p$5;
      } else {
        const _p$6 = _p$4;
        dynamic_raw = _p$6;
      }
      if (dynamic_raw.length > 0) {
        const dynamic_expanded = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext26expand__array__index__expr(self, dynamic_raw);
        if (self.should_exit) {
          return { _0: _base, _1: _index_expr };
        }
        resolved_index = dynamic_expanded.length > 0 ? dynamic_expanded : dynamic_raw;
      }
    }
    if (_M0FP410Haoxincode8moonbash3lib11interpreter14contains__char(resolved_index, 36)) {
      const second_pass = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext26expand__array__index__expr(self, resolved_index);
      if (self.should_exit) {
        return { _0: _base, _1: _index_expr };
      }
      if (second_pass.length > 0) {
        resolved_index = second_pass;
      }
    }
    const array_kind_key = `__MOON_BASH_ARRAY_KIND__${_base}`;
    const _p$4 = _M0MPB3Map3getGssE(self.env, array_kind_key);
    const _p$5 = "";
    let _tmp$38;
    if (_p$4 === undefined) {
      _tmp$38 = _p$5;
    } else {
      const _p$6 = _p$4;
      _tmp$38 = _p$6;
    }
    if (_tmp$38 === "assoc") {
      return { _0: _base, _1: resolved_index };
    }
    if (_M0FP410Haoxincode8moonbash3lib11interpreter14contains__char(resolved_index, 35)) {
      self.exit_code = 1;
      self.should_exit = true;
      return { _0: _base, _1: resolved_index };
    }
    const raw_index = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(self, new _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Raw(resolved_index));
    const final_index = BigInt.asIntN(64, raw_index) < BigInt.asIntN(64, 0n) ? BigInt.asUintN(64, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22indexed__array__origin(self, _base) + raw_index) : raw_index;
    if (BigInt.asIntN(64, final_index) < BigInt.asIntN(64, 0n)) {
      const subject = `${_base}[${_M0MPC15int645Int6418to__string_2einner(raw_index, 10)}]`;
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27emit__bad__array__subscript(self, subject, raw_name);
      self.exit_code = 1;
      self.should_exit = true;
      return { _0: _base, _1: _M0MPC15int645Int6418to__string_2einner(raw_index, 10) };
    }
    return { _0: _base, _1: _M0MPC15int645Int6418to__string_2einner(final_index, 10) };
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12run__command(self, name, args) {
  const skip_functions = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31skip__function__lookup__enabled(self);
  const use_default_path = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext30default__path__lookup__enabled(self);
  if (_M0FP410Haoxincode8moonbash3lib11interpreter15contains__slash(name)) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext28run__explicit__path__command(self, name, args);
    return undefined;
  }
  if (!skip_functions) {
    const _bind$4 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self.functions, name);
    if (_bind$4 === undefined) {
    } else {
      const _Some = _bind$4;
      const _fndef = _Some;
      self.call_depth = self.call_depth + 1 | 0;
      if (self.call_depth > self.limits.max_call_depth) {
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22fail__execution__limit(self, "maximum recursion depth exceeded");
        self.call_depth = self.call_depth - 1 | 0;
        return undefined;
      }
      const saved_funcname_entries = _M0FP410Haoxincode8moonbash3lib11interpreter29snapshot__array__env__entries(self.env, "FUNCNAME");
      const previous_func_stack = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22collect__array__values(self, "FUNCNAME");
      const current_func_stack = [name];
      const _bind$5 = previous_func_stack.length;
      let _tmp$38 = 0;
      while (true) {
        const _ = _tmp$38;
        if (_ < _bind$5) {
          const fn_name = previous_func_stack[_];
          _M0MPC15array5Array4pushGUssEE(current_func_stack, fn_name);
          _tmp$38 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24store__array__assignment(self, "FUNCNAME", current_func_stack);
      const _p$4 = _M0MPB3Map3getGssE(self.env, "@");
      const _p$5 = "";
      let saved_args;
      if (_p$4 === undefined) {
        saved_args = _p$5;
      } else {
        const _p$6 = _p$4;
        saved_args = _p$6;
      }
      const _p$6 = _M0MPB3Map3getGssE(self.env, "#");
      const _p$7 = "";
      let saved_argc;
      if (_p$6 === undefined) {
        saved_argc = _p$7;
      } else {
        const _p$8 = _p$6;
        saved_argc = _p$8;
      }
      const _tmp$39 = self.env;
      const _p$8 = _M0MPC15array5Array4iterGsE(args);
      const _p$9 = "";
      let _p$10 = _p$9;
      while (true) {
        const _p$11 = _M0MPB4Iter4nextGUssEE(_p$8);
        if (_p$11 === undefined) {
          break;
        } else {
          const _p$12 = _p$11;
          const _p$13 = _p$12;
          const _p$14 = _p$10;
          _p$10 = _p$14.length === 0 ? _p$13 : `${_p$14} ${_p$13}`;
          continue;
        }
      }
      _M0MPB3Map3setGssE(_tmp$39, "@", _p$10);
      _M0MPB3Map3setGssE(self.env, "#", _M0MPC13int3Int18to__string_2einner(args.length, 10));
      let _tmp$40 = 0;
      while (true) {
        const i = _tmp$40;
        if (i < args.length) {
          _M0MPB3Map3setGssE(self.env, _M0MPC13int3Int18to__string_2einner(i + 1 | 0, 10), _M0MPC15array5Array2atGUssEE(args, i));
          _tmp$40 = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      const _bind$6 = _fndef.body;
      if (_bind$6.$tag === 7) {
        const _Group = _bind$6;
        const _script = _Group._0;
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, _script);
      } else {
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17execute__compound(self, _bind$6);
      }
      self.return_requested = false;
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24restore__local__bindings(self, self.call_depth);
      _M0MPB3Map3setGssE(self.env, "@", saved_args);
      _M0MPB3Map3setGssE(self.env, "#", saved_argc);
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext28restore__array__env__entries(self, "FUNCNAME", saved_funcname_entries);
      self.call_depth = self.call_depth - 1 | 0;
      return undefined;
    }
  }
  if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16command__allowed(self, name)) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: ${name}: command not found\n`);
    self.exit_code = 127;
    return undefined;
  }
  if (name === "cd") {
    let target;
    if (args.length === 0) {
      const _p$4 = _M0MPB3Map3getGssE(self.env, "HOME");
      const _p$5 = "/home/user";
      if (_p$4 === undefined) {
        target = _p$5;
      } else {
        const _p$6 = _p$4;
        target = _p$6;
      }
    } else {
      if (_M0MPC15array5Array2atGUssEE(args, 0) === "-") {
        const _p$4 = _M0MPB3Map3getGssE(self.env, "OLDPWD");
        const _p$5 = self.cwd;
        if (_p$4 === undefined) {
          target = _p$5;
        } else {
          const _p$6 = _p$4;
          target = _p$6;
        }
      } else {
        target = _M0MPC15array5Array2atGUssEE(args, 0);
      }
    }
    let resolved;
    let _try_err;
    _L: {
      _L$2: {
        const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, target);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          resolved = _ok._0;
        } else {
          const _err = _bind$4;
          _try_err = _err._0;
          break _L$2;
        }
        break _L;
      }
      _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `cd: No such file or directory: ${target}\n`);
      self.exit_code = 1;
      return undefined;
    }
    const _bind$4 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.fs.entries, resolved);
    if (_bind$4 === undefined) {
      _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `cd: No such file or directory: ${target}\n`);
      self.exit_code = 1;
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      if (_x.$tag === 1) {
        const old_pwd = self.cwd;
        self.cwd = resolved;
        _M0MPB3Map3setGssE(self.env, "PWD", resolved);
        _M0MPB3Map3setGssE(self.env, "OLDPWD", old_pwd);
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33sync__directory__stack__with__cwd(self);
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25remember__hashed__command(self, name);
        self.exit_code = 0;
      } else {
        _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `cd: Not a directory: ${target}\n`);
        self.exit_code = 1;
      }
    }
    return undefined;
  }
  if (_M0FP410Haoxincode8moonbash3lib11interpreter26is__lookup__shell__builtin(name)) {
    if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21run__virtual__command(self, name, args)) {
      return undefined;
    }
  }
  if (!use_default_path) {
    const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29lookup__hashed__command__path(self, name);
    if (_bind$4 === undefined) {
    } else {
      const _Some = _bind$4;
      const _hashed_path = _Some;
      if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext37try__execute__resolved__path__command(self, name, _hashed_path, args)) {
        return undefined;
      }
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22clear__hashed__command(self, name);
    }
  }
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27first__path__command__match(self, name, use_default_path, false);
  if (_bind$4 === undefined) {
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _resolved_path = _x._1;
    if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext37try__execute__resolved__path__command(self, name, _resolved_path, args)) {
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31remember__hashed__command__path(self, name, _resolved_path);
      return undefined;
    }
  }
  if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21run__virtual__command(self, name, args)) {
    return undefined;
  }
  _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: ${name}: command not found\n`);
  self.exit_code = 127;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext28run__explicit__path__command(self, original_name, args) {
  let resolved_path;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, original_name);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        resolved_path = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: ${original_name}: command not found\n`);
    self.exit_code = 127;
    return undefined;
  }
  const _bind$4 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.fs.entries, resolved_path);
  if (_bind$4 === undefined) {
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    if (_x.$tag === 1) {
      _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: ${original_name}: Is a directory\n`);
      self.exit_code = 126;
      return undefined;
    } else {
      if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext37try__dispatch__virtual__command__stub(self, resolved_path, args)) {
        return undefined;
      }
      if (!_M0FP410Haoxincode8moonbash3lib11interpreter30command__is__executable__entry(_x)) {
        _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: ${original_name}: Permission denied\n`);
        self.exit_code = 126;
        return undefined;
      }
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext30execute__script__file__command(self, resolved_path, args, original_name);
      return undefined;
    }
  }
  const parent = _M0FP410Haoxincode8moonbash3lib2fs12parent__path(resolved_path);
  if (parent === "/bin" || parent === "/usr/bin") {
    const basename = _M0FP410Haoxincode8moonbash3lib2fs8basename(resolved_path);
    if (_M0FP410Haoxincode8moonbash3lib11interpreter31command__has__virtual__external(basename) || _M0FP410Haoxincode8moonbash3lib11interpreter26is__lookup__shell__builtin(basename)) {
      const saved_skip = _M0MPB3Map3getGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter36command__skip__function__lookup__key);
      _M0MPB3Map3setGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter36command__skip__function__lookup__key, "1");
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12run__command(self, basename, args);
      if (saved_skip === undefined) {
        _M0MPB3Map6removeGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter36command__skip__function__lookup__key);
      } else {
        const _Some = saved_skip;
        const _value = _Some;
        _M0MPB3Map3setGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter36command__skip__function__lookup__key, _value);
      }
      return undefined;
    }
  }
  _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: ${original_name}: command not found\n`);
  self.exit_code = 127;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext30execute__script__file__command(self, resolved_path, args, display_name) {
  let content;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(self.fs, resolved_path);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        content = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    const _FsError = _try_err;
    const _msg = _FsError._0;
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: ${display_name}: ${_msg}\n`);
    self.exit_code = 126;
    return undefined;
  }
  let parsed;
  let _try_err$2;
  _L$2: {
    _L$3: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib6parser5parse(content);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        parsed = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err$2 = _err._0;
        break _L$3;
      }
      break _L$2;
    }
    const _BashError = _try_err$2;
    const _msg = _BashError._0;
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: ${display_name}: ${_msg}\n`);
    self.exit_code = 2;
    return undefined;
  }
  const _p$4 = _M0MPB3Map3getGssE(self.env, "#");
  const _p$5 = "0";
  let _tmp$38;
  if (_p$4 === undefined) {
    _tmp$38 = _p$5;
  } else {
    const _p$6 = _p$4;
    _tmp$38 = _p$6;
  }
  const saved_count = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_tmp$38);
  const saved_values = [];
  let _tmp$39 = 1;
  while (true) {
    const i = _tmp$39;
    if (i <= saved_count) {
      const _p$6 = _M0MPB3Map3getGssE(self.env, _M0MPC13int3Int18to__string_2einner(i, 10));
      const _p$7 = "";
      let _tmp$40;
      if (_p$6 === undefined) {
        _tmp$40 = _p$7;
      } else {
        const _p$8 = _p$6;
        _tmp$40 = _p$8;
      }
      _M0MPC15array5Array4pushGUssEE(saved_values, _tmp$40);
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27set__positional__parameters(self, args);
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, parsed);
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27set__positional__parameters(self, saved_values);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext37try__dispatch__virtual__command__stub(self, resolved_path, args) {
  const parent = _M0FP410Haoxincode8moonbash3lib2fs12parent__path(resolved_path);
  let _tmp$38;
  const _p$4 = "/bin";
  if (!(parent === _p$4)) {
    const _p$5 = "/usr/bin";
    _tmp$38 = !(parent === _p$5);
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    return false;
  }
  const _bind$4 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.fs.entries, resolved_path);
  if (_bind$4 === undefined) {
    return false;
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    if (_x.$tag === 0) {
      const _File = _x;
      const _data = _File._0;
      if (!_M0FP410Haoxincode8moonbash3lib11interpreter35is__virtual__command__stub__content(_data.content)) {
        return false;
      }
      const name = _M0FP410Haoxincode8moonbash3lib2fs8basename(resolved_path);
      return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21run__virtual__command(self, name, args);
    } else {
      return false;
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21run__virtual__command(self, name, args) {
  if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12run__builtin(self, name, args)) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25remember__hashed__command(self, name);
    return true;
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib8commands13find__command(name);
  if (_bind$4 === undefined) {
    return false;
  } else {
    const _Some = _bind$4;
    const _cmd_fn = _Some;
    const ctx = new _M0TP410Haoxincode8moonbash3lib8commands14CommandContext(args, self.stdin_buf, self.cwd, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29build__external__command__env(self), self.fs);
    const result = _cmd_fn(ctx);
    _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, result.stdout);
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, result.stderr);
    self.exit_code = result.exit_code;
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25remember__hashed__command(self, name);
    return true;
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12run__builtin(self, name, args) {
  _L: {
    _L$2: {
      _L$3: {
        switch (name) {
          case "export": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15builtin__export(self, args);
            return true;
          }
          case "unset": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__unset(self, args);
            return true;
          }
          case "set": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__set(self, args);
            return true;
          }
          case "shift": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__shift(self, args);
            return true;
          }
          case "exec": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__exec(self, args);
            return true;
          }
          case "exit": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__exit(self, args);
            return true;
          }
          case "return": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15builtin__return(self, args);
            return true;
          }
          case "break": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__break(self, args);
            return true;
          }
          case "continue": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17builtin__continue(self, args);
            return true;
          }
          case "read": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__read(self, args);
            return true;
          }
          case "mapfile": {
            break _L$3;
          }
          case "readarray": {
            break _L$3;
          }
          case "test": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__test(self, args);
            return true;
          }
          case "[": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__bracket(self, args);
            return true;
          }
          case "[[": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24builtin__double__bracket(self, args);
            return true;
          }
          case "printf": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15builtin__printf(self, args);
            return true;
          }
          case "eval": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__eval(self, args);
            return true;
          }
          case "source": {
            break _L$2;
          }
          case ".": {
            break _L$2;
          }
          case "local": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__local(self, args);
            return true;
          }
          case "readonly": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17builtin__readonly(self, args);
            return true;
          }
          case "declare": {
            break _L;
          }
          case "typeset": {
            break _L;
          }
          case "getopts": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__getopts(self, args);
            return true;
          }
          case "let": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__let(self, args);
            return true;
          }
          case ":": {
            self.exit_code = 0;
            return true;
          }
          case "type": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__type(self, args);
            return true;
          }
          case "command": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__command(self, args);
            return true;
          }
          case "builtin": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__builtin(self, args);
            return true;
          }
          case "hash": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__hash(self, args);
            return true;
          }
          case "shopt": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__shopt(self, args);
            return true;
          }
          case "complete": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17builtin__complete(self, args);
            return true;
          }
          case "compgen": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__compgen(self, args);
            return true;
          }
          case "compopt": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__compopt(self, args);
            return true;
          }
          case "pushd": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__pushd(self, args);
            return true;
          }
          case "popd": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__popd(self, args);
            return true;
          }
          case "dirs": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__dirs(self, args);
            return true;
          }
          case "basename": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17builtin__basename(self, args);
            return true;
          }
          case "dirname": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__dirname(self, args);
            return true;
          }
          case "seq": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__seq(self, args);
            return true;
          }
          case "rev": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__rev(self, args);
            return true;
          }
          case "nl": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__nl(self, args);
            return true;
          }
          case "fold": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__fold(self, args);
            return true;
          }
          case "expand": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15builtin__expand(self, args);
            return true;
          }
          case "unexpand": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17builtin__unexpand(self, args);
            return true;
          }
          case "paste": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__paste(self, args);
            return true;
          }
          case "column": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15builtin__column(self, args);
            return true;
          }
          case "join": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__join(self, args);
            return true;
          }
          case "tr": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__tr(self, args);
            return true;
          }
          case "sort": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__sort(self, args);
            return true;
          }
          case "uniq": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__uniq(self, args);
            return true;
          }
          case "cut": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__cut(self, args);
            return true;
          }
          case "tee": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__tee(self, args);
            return true;
          }
          case "sed": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__sed(self, args);
            return true;
          }
          case "grep": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__grep(self, args);
            return true;
          }
          case "egrep": {
            const grep_args = ["-E"];
            const _bind$4 = args.length;
            let _tmp$38 = 0;
            while (true) {
              const _ = _tmp$38;
              if (_ < _bind$4) {
                const arg = args[_];
                _M0MPC15array5Array4pushGUssEE(grep_args, arg);
                _tmp$38 = _ + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__grep(self, grep_args);
            return true;
          }
          case "fgrep": {
            const grep_args$2 = ["-F"];
            const _bind$5 = args.length;
            let _tmp$39 = 0;
            while (true) {
              const _ = _tmp$39;
              if (_ < _bind$5) {
                const arg = args[_];
                _M0MPC15array5Array4pushGUssEE(grep_args$2, arg);
                _tmp$39 = _ + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__grep(self, grep_args$2);
            return true;
          }
          case "rg": {
            const grep_args$3 = ["-E"];
            const _bind$6 = args.length;
            let _tmp$40 = 0;
            while (true) {
              const _ = _tmp$40;
              if (_ < _bind$6) {
                const arg = args[_];
                _M0MPC15array5Array4pushGUssEE(grep_args$3, arg);
                _tmp$40 = _ + 1 | 0;
                continue;
              } else {
                break;
              }
            }
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__grep(self, grep_args$3);
            return true;
          }
          case "xargs": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__xargs(self, args);
            return true;
          }
          case "date": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__date(self, args);
            return true;
          }
          case "env": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__env(self, args);
            return true;
          }
          case "printenv": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17builtin__printenv(self, args);
            return true;
          }
          case "which": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__which(self, args);
            return true;
          }
          case "whoami": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15builtin__whoami(self, args);
            return true;
          }
          case "hostname": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17builtin__hostname(self, args);
            return true;
          }
          case "help": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__help(self, args);
            return true;
          }
          case "clear": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__clear(self, args);
            return true;
          }
          case "history": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__history(self, args);
            return true;
          }
          case "tac": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__tac(self, args);
            return true;
          }
          case "od": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__od(self, args);
            return true;
          }
          case "alias": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__alias(self, args);
            return true;
          }
          case "unalias": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__unalias(self, args);
            return true;
          }
          case "bash": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__bash(self, args);
            return true;
          }
          case "sh": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__sh(self, args);
            return true;
          }
          case "time": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__time(self, args);
            return true;
          }
          case "sleep": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__sleep(self, args);
            return true;
          }
          case "timeout": {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__timeout(self, args);
            return true;
          }
          default: {
            return false;
          }
        }
      }
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__mapfile(self, args);
      return true;
    }
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15builtin__source(self, args);
    return true;
  }
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__declare(self, args);
  return true;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__bash(self, args) {
  if (args.length === 0) {
    self.exit_code = 0;
    return undefined;
  }
  if (_M0MPC15array5Array2atGUssEE(args, 0) === "-c") {
    if (args.length < 2) {
      _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "moon_bash: -c: option requires an argument\n");
      self.exit_code = 2;
      return undefined;
    }
    const script = _M0MPC15array5Array2atGUssEE(args, 1);
    let parsed;
    let _try_err;
    _L: {
      _L$2: {
        const _bind$4 = _M0FP410Haoxincode8moonbash3lib6parser5parse(script);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          parsed = _ok._0;
        } else {
          const _err = _bind$4;
          _try_err = _err._0;
          break _L$2;
        }
        break _L;
      }
      const _BashError = _try_err;
      const _msg = _BashError._0;
      _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: ${_msg}\n`);
      self.exit_code = 2;
      return undefined;
    }
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, parsed);
    return undefined;
  }
  let path;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, _M0MPC15array5Array2atGUssEE(args, 0));
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        path = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    path = _M0MPC15array5Array2atGUssEE(args, 0);
  }
  let content;
  let _try_err$2;
  _L$2: {
    _L$3: {
      const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(self.fs, path);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        content = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err$2 = _err._0;
        break _L$3;
      }
      break _L$2;
    }
    const _FsError = _try_err$2;
    const _msg = _FsError._0;
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: ${_M0MPC15array5Array2atGUssEE(args, 0)}: ${_msg}\n`);
    self.exit_code = 127;
    return undefined;
  }
  let parsed;
  let _try_err$3;
  _L$3: {
    _L$4: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib6parser5parse(content);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        parsed = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err$3 = _err._0;
        break _L$4;
      }
      break _L$3;
    }
    const _BashError = _try_err$3;
    const _msg = _BashError._0;
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: ${_msg}\n`);
    self.exit_code = 2;
    return undefined;
  }
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, parsed);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__bracket(self, args) {
  let _tmp$38;
  if (args.length === 0) {
    _tmp$38 = true;
  } else {
    const _p$4 = _M0MPC15array5Array2atGUssEE(args, args.length - 1 | 0);
    const _p$5 = "]";
    _tmp$38 = !(_p$4 === _p$5);
  }
  if (_tmp$38) {
    self.exit_code = 2;
    return undefined;
  }
  const test_args = [];
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < (args.length - 1 | 0)) {
      _M0MPC15array5Array4pushGUssEE(test_args, _M0MPC15array5Array2atGUssEE(args, i));
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const result = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext28evaluate__test__with__status(self, test_args, 1);
  if (result.status === 0) {
    self.exit_code = result.value ? 0 : 1;
    return;
  } else {
    self.exit_code = result.status;
    return;
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext28evaluate__test__with__status(self, args, mode) {
  if (args.length <= 4) {
    return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24test__eval__small__arity(self, args, mode);
  }
  const parser = new _M0TP410Haoxincode8moonbash3lib11interpreter14TestExprParser(args, 0);
  const result = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21test__parse__or__expr(self, parser, mode);
  if (result.status !== 0) {
    return result;
  }
  if (parser.pos !== parser.tokens.length) {
    return _M0FP410Haoxincode8moonbash3lib11interpreter25test__eval__syntax__errorN6recordS11268;
  }
  return result;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24test__eval__small__arity(self, args, mode) {
  let _tmp$38 = args;
  _L: while (true) {
    const args$2 = _tmp$38;
    const _bind$4 = args$2.length;
    switch (_bind$4) {
      case 0: {
        if (mode === 2) {
          return _M0FP410Haoxincode8moonbash3lib11interpreter25test__eval__syntax__errorN6recordS11268;
        } else {
          return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(false);
        }
      }
      case 1: {
        if (_M0FP410Haoxincode8moonbash3lib11interpreter31test__mode__is__double__bracket(mode)) {
          const token = _M0MPC15array5Array2atGUssEE(args$2, 0);
          const token_text = _M0FP410Haoxincode8moonbash3lib11interpreter16test__token__raw(token);
          if (_M0FP410Haoxincode8moonbash3lib11interpreter30test__token__can__be__operator(token) && (token_text === "!" || (token_text === "(" || (token_text === ")" || (_M0FP410Haoxincode8moonbash3lib11interpreter19test__is__unary__op(token_text) || (_M0FP410Haoxincode8moonbash3lib11interpreter20test__is__binary__op(token_text) || (token_text === "-a" || token_text === "&&" || (token_text === "-o" || token_text === "||")))))))) {
            return _M0FP410Haoxincode8moonbash3lib11interpreter25test__eval__syntax__errorN6recordS11268;
          }
        }
        return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(_M0FP410Haoxincode8moonbash3lib11interpreter27test__eval__string__operand(_M0MPC15array5Array2atGUssEE(args$2, 0)));
      }
      case 2: {
        const op = _M0MPC15array5Array2atGUssEE(args$2, 0);
        const arg = _M0MPC15array5Array2atGUssEE(args$2, 1);
        const op_text = _M0FP410Haoxincode8moonbash3lib11interpreter16test__token__raw(op);
        const arg_text = _M0FP410Haoxincode8moonbash3lib11interpreter16test__token__raw(arg);
        return _M0FP410Haoxincode8moonbash3lib11interpreter30test__token__can__be__operator(op) && op_text === "!" ? _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(!_M0FP410Haoxincode8moonbash3lib11interpreter27test__eval__string__operand(_M0MPC15array5Array2atGUssEE(args$2, 1))) : _M0FP410Haoxincode8moonbash3lib11interpreter30test__token__can__be__operator(op) && _M0FP410Haoxincode8moonbash3lib11interpreter19test__is__unary__op(op_text) ? (_M0FP410Haoxincode8moonbash3lib11interpreter31test__mode__is__double__bracket(mode) && (_M0FP410Haoxincode8moonbash3lib11interpreter30test__token__can__be__operator(arg) && (arg_text === "!" || (arg_text === "(" || (arg_text === ")" || (arg_text === "-a" || arg_text === "&&" || (arg_text === "-o" || arg_text === "||" || _M0FP410Haoxincode8moonbash3lib11interpreter20test__is__binary__op(arg_text))))))) ? _M0FP410Haoxincode8moonbash3lib11interpreter25test__eval__syntax__errorN6recordS11268 : _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31test__eval__unary__with__status(self, op, arg)) : _M0FP410Haoxincode8moonbash3lib11interpreter25test__eval__syntax__errorN6recordS11268;
      }
      case 3: {
        const left = _M0MPC15array5Array2atGUssEE(args$2, 0);
        const op$2 = _M0MPC15array5Array2atGUssEE(args$2, 1);
        const right = _M0MPC15array5Array2atGUssEE(args$2, 2);
        const left_text = _M0FP410Haoxincode8moonbash3lib11interpreter16test__token__raw(left);
        const op_text$2 = _M0FP410Haoxincode8moonbash3lib11interpreter16test__token__raw(op$2);
        const right_text = _M0FP410Haoxincode8moonbash3lib11interpreter16test__token__raw(right);
        return _M0FP410Haoxincode8moonbash3lib11interpreter30test__token__can__be__operator(op$2) && _M0FP410Haoxincode8moonbash3lib11interpreter20test__is__binary__op(op_text$2) ? _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32test__eval__binary__with__status(self, left, op$2, right, mode) : _M0FP410Haoxincode8moonbash3lib11interpreter30test__token__can__be__operator(left) && left_text === "!" ? _M0FP410Haoxincode8moonbash3lib11interpreter19test__eval__negated(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24test__eval__small__arity(self, _M0FP410Haoxincode8moonbash3lib11interpreter17test__slice__args(args$2, 1, 3), mode)) : _M0FP410Haoxincode8moonbash3lib11interpreter30test__token__can__be__operator(left) && (_M0FP410Haoxincode8moonbash3lib11interpreter30test__token__can__be__operator(right) && (left_text === "(" && right_text === ")")) ? _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(_M0FP410Haoxincode8moonbash3lib11interpreter27test__eval__string__operand(op$2)) : _M0FP410Haoxincode8moonbash3lib11interpreter30test__token__can__be__operator(op$2) && ((op_text$2 === "-a" || op_text$2 === "&&") && !_M0FP410Haoxincode8moonbash3lib11interpreter31test__mode__is__double__bracket(mode)) ? _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(_M0FP410Haoxincode8moonbash3lib11interpreter27test__eval__string__operand(left) && _M0FP410Haoxincode8moonbash3lib11interpreter27test__eval__string__operand(right)) : _M0FP410Haoxincode8moonbash3lib11interpreter30test__token__can__be__operator(op$2) && ((op_text$2 === "-o" || op_text$2 === "||") && !_M0FP410Haoxincode8moonbash3lib11interpreter31test__mode__is__double__bracket(mode)) ? _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(_M0FP410Haoxincode8moonbash3lib11interpreter27test__eval__string__operand(left) || _M0FP410Haoxincode8moonbash3lib11interpreter27test__eval__string__operand(right)) : _M0FP410Haoxincode8moonbash3lib11interpreter25test__eval__syntax__errorN6recordS11268;
      }
      case 4: {
        if (_M0FP410Haoxincode8moonbash3lib11interpreter30test__token__can__be__operator(_M0MPC15array5Array2atGUssEE(args$2, 0)) && _M0FP410Haoxincode8moonbash3lib11interpreter16test__token__raw(_M0MPC15array5Array2atGUssEE(args$2, 0)) === "!") {
          return _M0FP410Haoxincode8moonbash3lib11interpreter19test__eval__negated(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24test__eval__small__arity(self, _M0FP410Haoxincode8moonbash3lib11interpreter17test__slice__args(args$2, 1, 4), mode));
        } else {
          if (_M0FP410Haoxincode8moonbash3lib11interpreter30test__token__can__be__operator(_M0MPC15array5Array2atGUssEE(args$2, 0)) && (_M0FP410Haoxincode8moonbash3lib11interpreter30test__token__can__be__operator(_M0MPC15array5Array2atGUssEE(args$2, 3)) && (_M0FP410Haoxincode8moonbash3lib11interpreter16test__token__raw(_M0MPC15array5Array2atGUssEE(args$2, 0)) === "(" && _M0FP410Haoxincode8moonbash3lib11interpreter16test__token__raw(_M0MPC15array5Array2atGUssEE(args$2, 3)) === ")"))) {
            _tmp$38 = _M0FP410Haoxincode8moonbash3lib11interpreter17test__slice__args(args$2, 1, 3);
            continue _L;
          } else {
            return _M0FP410Haoxincode8moonbash3lib11interpreter25test__eval__syntax__errorN6recordS11268;
          }
        }
      }
      default: {
        return _M0FP410Haoxincode8moonbash3lib11interpreter25test__eval__syntax__errorN6recordS11268;
      }
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32test__eval__binary__with__status(self, left, op, right, mode) {
  const left_text = _M0FP410Haoxincode8moonbash3lib11interpreter16test__token__raw(left);
  const op_text = _M0FP410Haoxincode8moonbash3lib11interpreter16test__token__raw(op);
  const right_text = _M0FP410Haoxincode8moonbash3lib11interpreter16test__token__raw(right);
  const left_value = _M0FP410Haoxincode8moonbash3lib11interpreter29test__unescape__glob__escapes(left_text);
  const right_value = _M0FP410Haoxincode8moonbash3lib11interpreter29test__unescape__glob__escapes(right_text);
  let literal_compare;
  switch (mode) {
    case 0: {
      literal_compare = true;
      break;
    }
    case 1: {
      literal_compare = true;
      break;
    }
    default: {
      literal_compare = false;
    }
  }
  _L: {
    _L$2: {
      switch (op_text) {
        case "=": {
          break _L$2;
        }
        case "==": {
          break _L$2;
        }
        case "!=": {
          return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(literal_compare ? !(left_text === right_text) : !_M0FP410Haoxincode8moonbash3lib11interpreter21test__string__compare(left_value, right_text));
        }
        case "<": {
          return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(_M0IP016_24default__implPB7Compare6op__ltGsE(left_value, right_value));
        }
        case ">": {
          return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(_M0IP016_24default__implPB7Compare6op__gtGsE(left_value, right_value));
        }
        case "=~": {
          const pattern = _M0FP410Haoxincode8moonbash3lib11interpreter22test__token__is__tilde(right) ? _M0FP410Haoxincode8moonbash3lib11interpreter28test__escape__regex__literal(right_value) : right_value;
          return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31test__eval__regex__with__status(self, left_value, pattern);
        }
        case "-eq": {
          break _L;
        }
        case "-ne": {
          break _L;
        }
        case "-lt": {
          break _L;
        }
        case "-le": {
          break _L;
        }
        case "-gt": {
          break _L;
        }
        case "-ge": {
          break _L;
        }
        case "-nt": {
          const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19test__lookup__entry(self, left_text, true);
          if (_bind$4 === undefined) {
            return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(false);
          } else {
            const _Some = _bind$4;
            const _left_entry = _Some;
            const _bind$5 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19test__lookup__entry(self, right_text, true);
            if (_bind$5 === undefined) {
              return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(false);
            } else {
              const _Some$2 = _bind$5;
              const _right_entry = _Some$2;
              return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(BigInt.asIntN(64, _M0FP410Haoxincode8moonbash3lib11interpreter18test__entry__mtime(_left_entry)) > BigInt.asIntN(64, _M0FP410Haoxincode8moonbash3lib11interpreter18test__entry__mtime(_right_entry)));
            }
          }
        }
        case "-ot": {
          const _bind$5 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19test__lookup__entry(self, left_text, true);
          if (_bind$5 === undefined) {
            return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(false);
          } else {
            const _Some = _bind$5;
            const _left_entry = _Some;
            const _bind$6 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19test__lookup__entry(self, right_text, true);
            if (_bind$6 === undefined) {
              return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(false);
            } else {
              const _Some$2 = _bind$6;
              const _right_entry = _Some$2;
              return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(BigInt.asIntN(64, _M0FP410Haoxincode8moonbash3lib11interpreter18test__entry__mtime(_left_entry)) < BigInt.asIntN(64, _M0FP410Haoxincode8moonbash3lib11interpreter18test__entry__mtime(_right_entry)));
            }
          }
        }
        case "-ef": {
          return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(false);
        }
        default: {
          return _M0FP410Haoxincode8moonbash3lib11interpreter25test__eval__syntax__errorN6recordS11268;
        }
      }
    }
    return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(literal_compare ? left_text === right_text : _M0FP410Haoxincode8moonbash3lib11interpreter21test__string__compare(left_value, right_text));
  }
  const left_value$2 = _M0FP410Haoxincode8moonbash3lib11interpreter31test__mode__is__double__bracket(mode) ? _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext46test__parse__double__bracket__numeric__operand(self, left_text) : _M0FP410Haoxincode8moonbash3lib11interpreter29test__parse__decimal__operand(left_text);
  if (left_value$2 === undefined) {
    return _M0FP410Haoxincode8moonbash3lib11interpreter31test__mode__is__double__bracket(mode) ? _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(false) : _M0FP410Haoxincode8moonbash3lib11interpreter25test__eval__syntax__errorN6recordS11268;
  } else {
    const _Some = left_value$2;
    const _l = _Some;
    const right_value$2 = _M0FP410Haoxincode8moonbash3lib11interpreter31test__mode__is__double__bracket(mode) ? _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext46test__parse__double__bracket__numeric__operand(self, right_text) : _M0FP410Haoxincode8moonbash3lib11interpreter29test__parse__decimal__operand(right_text);
    if (right_value$2 === undefined) {
      return _M0FP410Haoxincode8moonbash3lib11interpreter31test__mode__is__double__bracket(mode) ? _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(false) : _M0FP410Haoxincode8moonbash3lib11interpreter25test__eval__syntax__errorN6recordS11268;
    } else {
      const _Some$2 = right_value$2;
      const _r = _Some$2;
      let _tmp$38;
      switch (op_text) {
        case "-eq": {
          _tmp$38 = BigInt.asUintN(64, _l) === BigInt.asUintN(64, _r);
          break;
        }
        case "-ne": {
          _tmp$38 = BigInt.asUintN(64, _l) !== BigInt.asUintN(64, _r);
          break;
        }
        case "-lt": {
          _tmp$38 = BigInt.asIntN(64, _l) < BigInt.asIntN(64, _r);
          break;
        }
        case "-le": {
          _tmp$38 = BigInt.asIntN(64, _l) <= BigInt.asIntN(64, _r);
          break;
        }
        case "-gt": {
          _tmp$38 = BigInt.asIntN(64, _l) > BigInt.asIntN(64, _r);
          break;
        }
        case "-ge": {
          _tmp$38 = BigInt.asIntN(64, _l) >= BigInt.asIntN(64, _r);
          break;
        }
        default: {
          _tmp$38 = false;
        }
      }
      return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(_tmp$38);
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext46test__parse__double__bracket__numeric__operand(self, text) {
  const trimmed = _M0FP410Haoxincode8moonbash3lib11interpreter11arith__trim(text);
  if (trimmed.length === 0) {
    return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext46test__parse__double__bracket__numeric__operandN6constrS11274;
  }
  const saved_exit_code = self.exit_code;
  const saved_should_exit = self.should_exit;
  _M0MPB3Map6removeGssE(self.env, "__MOON_BASH_ABORT_CURRENT_COMMAND__");
  const value = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(self, new _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Raw(trimmed));
  if (_M0MPB3Map8containsGssE(self.env, "__MOON_BASH_ABORT_CURRENT_COMMAND__")) {
    _M0MPB3Map6removeGssE(self.env, "__MOON_BASH_ABORT_CURRENT_COMMAND__");
    self.exit_code = saved_exit_code;
    self.should_exit = saved_should_exit;
    return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext46test__parse__double__bracket__numeric__operandN6constrS11275;
  }
  self.exit_code = saved_exit_code;
  self.should_exit = saved_should_exit;
  return value;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31test__eval__unary__with__status(self, op, arg) {
  const op_text = _M0FP410Haoxincode8moonbash3lib11interpreter16test__token__raw(op);
  const arg_text = _M0FP410Haoxincode8moonbash3lib11interpreter16test__token__raw(arg);
  _L: {
    _L$2: {
      _L$3: {
        _L$4: {
          switch (op_text) {
            case "-z": {
              return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(arg_text.length === 0);
            }
            case "-n": {
              return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(arg_text.length > 0);
            }
            case "-a": {
              break _L$4;
            }
            case "-e": {
              break _L$4;
            }
            case "-f": {
              const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19test__lookup__entry(self, arg_text, true);
              let _tmp$38;
              if (_bind$4 === undefined) {
                _tmp$38 = false;
              } else {
                const _Some = _bind$4;
                const _x = _Some;
                if (_x.$tag === 0) {
                  _tmp$38 = true;
                } else {
                  _tmp$38 = false;
                }
              }
              return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(_tmp$38);
            }
            case "-d": {
              const _bind$5 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19test__lookup__entry(self, arg_text, true);
              let _tmp$39;
              if (_bind$5 === undefined) {
                _tmp$39 = false;
              } else {
                const _Some = _bind$5;
                const _x = _Some;
                if (_x.$tag === 1) {
                  _tmp$39 = true;
                } else {
                  _tmp$39 = false;
                }
              }
              return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(_tmp$39);
            }
            case "-s": {
              const _bind$6 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19test__lookup__entry(self, arg_text, true);
              let _tmp$40;
              if (_bind$6 === undefined) {
                _tmp$40 = false;
              } else {
                const _Some = _bind$6;
                const _x = _Some;
                if (_x.$tag === 0) {
                  const _File = _x;
                  const _data = _File._0;
                  _tmp$40 = _data.content.length > 0;
                } else {
                  _tmp$40 = false;
                }
              }
              return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(_tmp$40);
            }
            case "-r": {
              const _bind$7 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19test__lookup__entry(self, arg_text, true);
              let _tmp$41;
              if (_bind$7 === undefined) {
                _tmp$41 = false;
              } else {
                const _Some = _bind$7;
                const _entry = _Some;
                _tmp$41 = (_M0FP410Haoxincode8moonbash3lib11interpreter17test__entry__mode(_entry) & 292) !== 0;
              }
              return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(_tmp$41);
            }
            case "-w": {
              const _bind$8 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19test__lookup__entry(self, arg_text, true);
              let _tmp$42;
              if (_bind$8 === undefined) {
                _tmp$42 = false;
              } else {
                const _Some = _bind$8;
                const _entry = _Some;
                _tmp$42 = (_M0FP410Haoxincode8moonbash3lib11interpreter17test__entry__mode(_entry) & 146) !== 0;
              }
              return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(_tmp$42);
            }
            case "-x": {
              const _bind$9 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19test__lookup__entry(self, arg_text, true);
              let _tmp$43;
              if (_bind$9 === undefined) {
                _tmp$43 = false;
              } else {
                const _Some = _bind$9;
                const _entry = _Some;
                _tmp$43 = (_M0FP410Haoxincode8moonbash3lib11interpreter17test__entry__mode(_entry) & 73) !== 0;
              }
              return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(_tmp$43);
            }
            case "-L": {
              break _L$3;
            }
            case "-h": {
              break _L$3;
            }
            case "-k": {
              const _bind$10 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19test__lookup__entry(self, arg_text, true);
              let _tmp$44;
              if (_bind$10 === undefined) {
                _tmp$44 = false;
              } else {
                const _Some = _bind$10;
                const _entry = _Some;
                _tmp$44 = (_M0FP410Haoxincode8moonbash3lib11interpreter17test__entry__mode(_entry) & 512) !== 0;
              }
              return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(_tmp$44);
            }
            case "-O": {
              break _L$2;
            }
            case "-G": {
              break _L$2;
            }
            case "-u": {
              const _bind$11 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19test__lookup__entry(self, arg_text, true);
              let _tmp$45;
              if (_bind$11 === undefined) {
                _tmp$45 = false;
              } else {
                const _Some = _bind$11;
                const _entry = _Some;
                _tmp$45 = (_M0FP410Haoxincode8moonbash3lib11interpreter17test__entry__mode(_entry) & 2048) !== 0;
              }
              return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(_tmp$45);
            }
            case "-g": {
              const _bind$12 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19test__lookup__entry(self, arg_text, true);
              let _tmp$46;
              if (_bind$12 === undefined) {
                _tmp$46 = false;
              } else {
                const _Some = _bind$12;
                const _entry = _Some;
                _tmp$46 = (_M0FP410Haoxincode8moonbash3lib11interpreter17test__entry__mode(_entry) & 1024) !== 0;
              }
              return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(_tmp$46);
            }
            case "-b": {
              break _L;
            }
            case "-S": {
              break _L;
            }
            case "-p": {
              break _L;
            }
            case "-c": {
              return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(arg_text === "/dev/zero");
            }
            case "-t": {
              const _bind$13 = _M0FP410Haoxincode8moonbash3lib11interpreter24test__parse__fd__operand(arg_text);
              return _bind$13 === undefined ? _M0FP410Haoxincode8moonbash3lib11interpreter25test__eval__syntax__errorN6recordS11268 : _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(false);
            }
            case "-v": {
              return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(_M0FP410Haoxincode8moonbash3lib11interpreter18test__var__is__set(arg_text, self));
            }
            case "-o": {
              const _bind$14 = _M0FP410Haoxincode8moonbash3lib11interpreter28test__shell__option__enabled(self, arg_text);
              if (_bind$14 === -1) {
                return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(false);
              } else {
                const _Some = _bind$14;
                const _enabled = _Some;
                return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(_enabled);
              }
            }
            default: {
              return _M0FP410Haoxincode8moonbash3lib11interpreter25test__eval__syntax__errorN6recordS11268;
            }
          }
        }
        const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19test__lookup__entry(self, arg_text, true);
        return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(!(_bind$4 === undefined));
      }
      const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19test__lookup__entry(self, arg_text, false);
      let _tmp$38;
      if (_bind$4 === undefined) {
        _tmp$38 = false;
      } else {
        const _Some = _bind$4;
        const _x = _Some;
        if (_x.$tag === 2) {
          _tmp$38 = true;
        } else {
          _tmp$38 = false;
        }
      }
      return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(_tmp$38);
    }
    const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19test__lookup__entry(self, arg_text, true);
    return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(!(_bind$4 === undefined));
  }
  return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(false);
}
function _M0FP410Haoxincode8moonbash3lib11interpreter18test__var__is__set(name, ctx) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter29parse__array__reference__name(name);
  if (_bind$4 === undefined) {
    const _bind$5 = _M0MPB3Map3getGssE(ctx.env, `__MOON_BASH_ARRAY_COUNT__${name}`);
    if (_bind$5 === undefined) {
      return _M0MPB3Map8containsGssE(ctx.env, name);
    } else {
      const _Some = _bind$5;
      const _count_text = _Some;
      return _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_count_text) > 0;
    }
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _base = _x._0;
    const _index = _x._1;
    if (_index === "@" || _index === "*") {
      const _p$4 = _M0MPB3Map3getGssE(ctx.env, `__MOON_BASH_ARRAY_COUNT__${_base}`);
      const _p$5 = "-1";
      let _tmp$38;
      if (_p$4 === undefined) {
        _tmp$38 = _p$5;
      } else {
        const _p$6 = _p$4;
        _tmp$38 = _p$6;
      }
      const count = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_tmp$38);
      if (count >= 0) {
        return count > 0;
      }
      return _M0MPB3Map8containsGssE(ctx.env, _base) || _M0MPB3Map8containsGssE(ctx.env, `${_base}[@]`);
    }
    const _p$4 = _M0MPB3Map3getGssE(ctx.env, `__MOON_BASH_ARRAY_KIND__${_base}`);
    const _p$5 = "";
    let kind;
    if (_p$4 === undefined) {
      kind = _p$5;
    } else {
      const _p$6 = _p$4;
      kind = _p$6;
    }
    if (kind === "assoc") {
      const resolved_index = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext26expand__array__index__expr(ctx, _index);
      if (resolved_index.length > 0 && _M0MPB3Map8containsGssE(ctx.env, `${_base}[${resolved_index}]`)) {
        return true;
      }
      return _M0MPB3Map8containsGssE(ctx.env, `${_base}[${_index}]`);
    }
    const key = _M0FP410Haoxincode8moonbash3lib11interpreter26test__indexed__lookup__key(_base, _index, ctx);
    return _M0MPB3Map8containsGssE(ctx.env, key);
  }
}
function _M0FP410Haoxincode8moonbash3lib11interpreter26test__indexed__lookup__key(base, index_expr, ctx) {
  const trimmed = _M0FP410Haoxincode8moonbash3lib11interpreter26trim__ascii__space__simple(index_expr);
  if (trimmed.length === 0) {
    return `${base}[${index_expr}]`;
  }
  let raw_index;
  if (_M0FP410Haoxincode8moonbash3lib11interpreter27arith__is__identifier__text(trimmed)) {
    const _p$4 = _M0MPB3Map3getGssE(ctx.env, trimmed);
    const _p$5 = "";
    let _tmp$38;
    if (_p$4 === undefined) {
      _tmp$38 = _p$5;
    } else {
      const _p$6 = _p$4;
      _tmp$38 = _p$6;
    }
    const referenced = _M0FP410Haoxincode8moonbash3lib11interpreter26trim__ascii__space__simple(_tmp$38);
    raw_index = referenced.length > 0 && _M0FP410Haoxincode8moonbash3lib11interpreter31contains__test__arith__operator(referenced) ? _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(ctx, new _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Raw(referenced)) : _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(ctx, new _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Raw(trimmed));
  } else {
    raw_index = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(ctx, new _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Raw(trimmed));
  }
  const resolved = BigInt.asIntN(64, raw_index) < BigInt.asIntN(64, 0n) ? BigInt.asUintN(64, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22indexed__array__origin(ctx, base) + raw_index) : raw_index;
  if (BigInt.asIntN(64, resolved) < BigInt.asIntN(64, 0n)) {
    const fragment = `${base}[${trimmed}]`;
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27emit__bad__array__subscript(ctx, base, fragment);
    ctx.exit_code = 1;
    ctx.should_exit = true;
    return `${base}[${index_expr}]`;
  }
  return `${base}[${_M0MPC15int645Int6418to__string_2einner(resolved, 10)}]`;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21test__parse__or__expr(self, parser, mode) {
  let left = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22test__parse__and__expr(self, parser, mode);
  if (left.status !== 0) {
    return left;
  }
  while (true) {
    let _tmp$38;
    if (parser.pos < parser.tokens.length) {
      let _tmp$39;
      if (_M0FP410Haoxincode8moonbash3lib11interpreter30test__token__can__be__operator(_M0MPC15array5Array2atGUssEE(parser.tokens, parser.pos))) {
        const _p$4 = _M0FP410Haoxincode8moonbash3lib11interpreter16test__token__raw(_M0MPC15array5Array2atGUssEE(parser.tokens, parser.pos));
        _tmp$39 = _p$4 === "-o" || _p$4 === "||";
      } else {
        _tmp$39 = false;
      }
      _tmp$38 = _tmp$39;
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      parser.pos = parser.pos + 1 | 0;
      const right = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22test__parse__and__expr(self, parser, mode);
      if (right.status !== 0) {
        return right;
      }
      left = _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(left.value || right.value);
      continue;
    } else {
      break;
    }
  }
  return left;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22test__parse__and__expr(self, parser, mode) {
  let left = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22test__parse__not__expr(self, parser, mode);
  if (left.status !== 0) {
    return left;
  }
  while (true) {
    let _tmp$38;
    if (parser.pos < parser.tokens.length) {
      let _tmp$39;
      if (_M0FP410Haoxincode8moonbash3lib11interpreter30test__token__can__be__operator(_M0MPC15array5Array2atGUssEE(parser.tokens, parser.pos))) {
        const _p$4 = _M0FP410Haoxincode8moonbash3lib11interpreter16test__token__raw(_M0MPC15array5Array2atGUssEE(parser.tokens, parser.pos));
        _tmp$39 = _p$4 === "-a" || _p$4 === "&&";
      } else {
        _tmp$39 = false;
      }
      _tmp$38 = _tmp$39;
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      parser.pos = parser.pos + 1 | 0;
      const right = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22test__parse__not__expr(self, parser, mode);
      if (right.status !== 0) {
        return right;
      }
      left = _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(left.value && right.value);
      continue;
    } else {
      break;
    }
  }
  return left;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22test__parse__not__expr(self, parser, mode) {
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter14TestExprParser4peek(parser);
  if (_bind$4 === undefined) {
    return _M0FP410Haoxincode8moonbash3lib11interpreter25test__eval__syntax__errorN6recordS11268;
  } else {
    const _Some = _bind$4;
    const _tok = _Some;
    if (_M0FP410Haoxincode8moonbash3lib11interpreter30test__token__can__be__operator(_tok) && _M0FP410Haoxincode8moonbash3lib11interpreter16test__token__raw(_tok) === "!") {
      parser.pos = parser.pos + 1 | 0;
      const inner = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22test__parse__not__expr(self, parser, mode);
      if (inner.status !== 0) {
        return inner;
      }
      return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(!inner.value);
    }
  }
  return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext26test__parse__primary__expr(self, parser, mode);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext26test__parse__primary__expr(self, parser, mode) {
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter14TestExprParser4peek(parser);
  if (_bind$4 === undefined) {
    return _M0FP410Haoxincode8moonbash3lib11interpreter25test__eval__syntax__errorN6recordS11268;
  } else {
    const _Some = _bind$4;
    const _tok = _Some;
    const tok_text = _M0FP410Haoxincode8moonbash3lib11interpreter16test__token__raw(_tok);
    const tok_is_operator = _M0FP410Haoxincode8moonbash3lib11interpreter30test__token__can__be__operator(_tok);
    if (tok_is_operator && tok_text === "(") {
      parser.pos = parser.pos + 1 | 0;
      const inner = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21test__parse__or__expr(self, parser, mode);
      if (inner.status !== 0) {
        return inner;
      }
      let _tmp$38;
      if (parser.pos >= parser.tokens.length) {
        _tmp$38 = true;
      } else {
        let _tmp$39;
        if (!_M0FP410Haoxincode8moonbash3lib11interpreter30test__token__can__be__operator(_M0MPC15array5Array2atGUssEE(parser.tokens, parser.pos))) {
          _tmp$39 = true;
        } else {
          const _p$4 = _M0FP410Haoxincode8moonbash3lib11interpreter16test__token__raw(_M0MPC15array5Array2atGUssEE(parser.tokens, parser.pos));
          const _p$5 = ")";
          _tmp$39 = !(_p$4 === _p$5);
        }
        _tmp$38 = _tmp$39;
      }
      if (_tmp$38) {
        return _M0FP410Haoxincode8moonbash3lib11interpreter25test__eval__syntax__errorN6recordS11268;
      }
      parser.pos = parser.pos + 1 | 0;
      return inner;
    }
    if (tok_is_operator && (tok_text === ")" || (tok_text === "-a" || tok_text === "&&" || (tok_text === "-o" || tok_text === "||" || _M0FP410Haoxincode8moonbash3lib11interpreter20test__is__binary__op(tok_text))))) {
      return _M0FP410Haoxincode8moonbash3lib11interpreter25test__eval__syntax__errorN6recordS11268;
    }
    if (tok_is_operator && _M0FP410Haoxincode8moonbash3lib11interpreter19test__is__unary__op(tok_text)) {
      if ((parser.pos + 1 | 0) >= parser.tokens.length) {
        return _M0FP410Haoxincode8moonbash3lib11interpreter25test__eval__syntax__errorN6recordS11268;
      }
      const arg = _M0MPC15array5Array2atGUssEE(parser.tokens, parser.pos + 1 | 0);
      parser.pos = parser.pos + 2 | 0;
      return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31test__eval__unary__with__status(self, _tok, arg);
    }
    if ((parser.pos + 2 | 0) < parser.tokens.length) {
      const op = _M0MPC15array5Array2atGUssEE(parser.tokens, parser.pos + 1 | 0);
      if (_M0FP410Haoxincode8moonbash3lib11interpreter30test__token__can__be__operator(op) && _M0FP410Haoxincode8moonbash3lib11interpreter20test__is__binary__op(_M0FP410Haoxincode8moonbash3lib11interpreter16test__token__raw(op))) {
        const left = _M0MPC15array5Array2atGUssEE(parser.tokens, parser.pos);
        const right = _M0MPC15array5Array2atGUssEE(parser.tokens, parser.pos + 2 | 0);
        parser.pos = parser.pos + 3 | 0;
        return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32test__eval__binary__with__status(self, left, op, right, mode);
      }
    }
    parser.pos = parser.pos + 1 | 0;
    return _M0FP410Haoxincode8moonbash3lib11interpreter14test__eval__ok(_M0FP410Haoxincode8moonbash3lib11interpreter27test__eval__string__operand(_tok));
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__builtin(self, args) {
  let start = 0;
  if (args.length > 0 && _M0MPC15array5Array2atGUssEE(args, 0) === "--") {
    start = 1;
  }
  if (start >= args.length) {
    self.exit_code = 0;
    return undefined;
  }
  const cmd_name = _M0MPC15array5Array2atGUssEE(args, start);
  const cmd_args = [];
  let _tmp$38 = start + 1 | 0;
  while (true) {
    const i = _tmp$38;
    if (i < args.length) {
      _M0MPC15array5Array4pushGUssEE(cmd_args, _M0MPC15array5Array2atGUssEE(args, i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (cmd_name === "cd") {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20builtin__builtin__cd(self, cmd_args);
    return undefined;
  }
  if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12run__builtin(self, cmd_name, cmd_args)) {
    return undefined;
  }
  self.exit_code = 1;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__command(self, args) {
  if (args.length === 0) {
    self.exit_code = 0;
    return undefined;
  }
  let mode = 0;
  let use_default_path = false;
  let i = 0;
  while (true) {
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      if (arg === "--") {
        i = i + 1 | 0;
        break;
      }
      let _tmp$38;
      if (arg.length >= 2) {
        $bound_check(arg, 0);
        _tmp$38 = arg.charCodeAt(0) === 45;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        let recognized = true;
        let _tmp$39 = 1;
        while (true) {
          const j = _tmp$39;
          if (j < arg.length) {
            $bound_check(arg, j);
            const flag = arg.charCodeAt(j);
            switch (flag) {
              case 118: {
                mode = 1;
                break;
              }
              case 86: {
                mode = 2;
                break;
              }
              case 112: {
                use_default_path = true;
                break;
              }
              default: {
                recognized = false;
              }
            }
            _tmp$39 = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        if (recognized) {
          i = i + 1 | 0;
          continue;
        }
      }
      break;
    } else {
      break;
    }
  }
  if (i >= args.length) {
    self.exit_code = 0;
    return undefined;
  }
  if (mode === 1) {
    let all_found = true;
    let _tmp$38 = i;
    while (true) {
      const idx = _tmp$38;
      if (idx < args.length) {
        _L: {
          const name = _M0MPC15array5Array2atGUssEE(args, idx);
          if (name.length === 0) {
            all_found = false;
            break _L;
          }
          const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20lookup__alias__value(self, name);
          if (_bind$4 === undefined) {
          } else {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name}\n`);
            break _L;
          }
          if (_M0MPB3Map8containsGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self.functions, name)) {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name}\n`);
            break _L;
          }
          if (_M0FP410Haoxincode8moonbash3lib11interpreter26is__lookup__shell__builtin(name)) {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name}\n`);
            break _L;
          }
          if (_M0FP410Haoxincode8moonbash3lib11interpreter26is__lookup__shell__keyword(name)) {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name}\n`);
            break _L;
          }
          const _bind$5 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27first__path__command__match(self, name, use_default_path, true);
          if (_bind$5 === undefined) {
            all_found = false;
          } else {
            const _Some = _bind$5;
            const _x = _Some;
            const _display = _x._0;
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_display}\n`);
          }
          break _L;
        }
        _tmp$38 = idx + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    self.exit_code = all_found ? 0 : 1;
    return undefined;
  }
  if (mode === 2) {
    let all_found = true;
    let _tmp$38 = i;
    while (true) {
      const idx = _tmp$38;
      if (idx < args.length) {
        _L: {
          const name = _M0MPC15array5Array2atGUssEE(args, idx);
          if (name.length === 0) {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, ": not found\n");
            all_found = false;
            break _L;
          }
          const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20lookup__alias__value(self, name);
          if (_bind$4 === undefined) {
          } else {
            const _Some = _bind$4;
            const _alias_value = _Some;
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name} is an alias for \"${_alias_value}\"\n`);
            break _L;
          }
          if (_M0MPB3Map8containsGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self.functions, name)) {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name} is a function\n`);
            break _L;
          }
          if (_M0FP410Haoxincode8moonbash3lib11interpreter26is__lookup__shell__builtin(name)) {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name} is a shell builtin\n`);
            break _L;
          }
          if (_M0FP410Haoxincode8moonbash3lib11interpreter26is__lookup__shell__keyword(name)) {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name} is a shell keyword\n`);
            break _L;
          }
          const _bind$5 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27first__path__command__match(self, name, use_default_path, true);
          if (_bind$5 === undefined) {
            _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `${name}: not found\n`);
            all_found = false;
          } else {
            const _Some = _bind$5;
            const _x = _Some;
            const _display = _x._0;
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name} is ${_display}\n`);
          }
          break _L;
        }
        _tmp$38 = idx + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    self.exit_code = all_found ? 0 : 1;
    return undefined;
  }
  const cmd_name = _M0MPC15array5Array2atGUssEE(args, i);
  const cmd_args = [];
  let _tmp$38 = i + 1 | 0;
  while (true) {
    const idx = _tmp$38;
    if (idx < args.length) {
      _M0MPC15array5Array4pushGUssEE(cmd_args, _M0MPC15array5Array2atGUssEE(args, idx));
      _tmp$38 = idx + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const saved_skip = _M0MPB3Map3getGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter36command__skip__function__lookup__key);
  const saved_default = _M0MPB3Map3getGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter35command__default__path__lookup__key);
  _M0MPB3Map3setGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter36command__skip__function__lookup__key, "1");
  if (use_default_path) {
    _M0MPB3Map3setGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter35command__default__path__lookup__key, "1");
  } else {
    _M0MPB3Map6removeGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter35command__default__path__lookup__key);
  }
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12run__command(self, cmd_name, cmd_args);
  if (saved_skip === undefined) {
    _M0MPB3Map6removeGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter36command__skip__function__lookup__key);
  } else {
    const _Some = saved_skip;
    const _value = _Some;
    _M0MPB3Map3setGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter36command__skip__function__lookup__key, _value);
  }
  if (saved_default === undefined) {
    _M0MPB3Map6removeGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter35command__default__path__lookup__key);
    return;
  } else {
    const _Some = saved_default;
    const _value = _Some;
    _M0MPB3Map3setGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter35command__default__path__lookup__key, _value);
    return;
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__compgen(self, args) {
  const actions = [];
  const option_o = [];
  let words = undefined;
  let func_name = undefined;
  let command_name = undefined;
  let filter_pattern = undefined;
  let output_prefix = "";
  let output_suffix = "";
  const operands = [];
  let i = 0;
  let parse_opts = true;
  while (true) {
    if (i < args.length) {
      const arg = _M0MPC15array5Array2atGUssEE(args, i);
      if (parse_opts && arg === "--") {
        parse_opts = false;
        i = i + 1 | 0;
        continue;
      }
      if (parse_opts && arg === "-A") {
        if ((i + 1 | 0) >= args.length || !_M0FP410Haoxincode8moonbash3lib11interpreter29completion__is__valid__action(_M0MPC15array5Array2atGUssEE(args, i + 1 | 0))) {
          self.exit_code = 2;
          return undefined;
        }
        _M0MPC15array5Array4pushGUssEE(actions, _M0MPC15array5Array2atGUssEE(args, i + 1 | 0));
        i = i + 2 | 0;
        continue;
      }
      if (parse_opts && arg === "-k") {
        _M0MPC15array5Array4pushGUssEE(actions, "keyword");
        i = i + 1 | 0;
        continue;
      }
      if (parse_opts && arg === "-f") {
        _M0MPC15array5Array4pushGUssEE(actions, "file");
        i = i + 1 | 0;
        continue;
      }
      if (parse_opts && arg === "-v") {
        _M0MPC15array5Array4pushGUssEE(actions, "variable");
        i = i + 1 | 0;
        continue;
      }
      if (parse_opts && arg === "-e") {
        _M0MPC15array5Array4pushGUssEE(actions, "export");
        i = i + 1 | 0;
        continue;
      }
      if (parse_opts && arg === "-W") {
        if ((i + 1 | 0) >= args.length) {
          self.exit_code = 2;
          return undefined;
        }
        words = _M0MPC15array5Array2atGUssEE(args, i + 1 | 0);
        i = i + 2 | 0;
        continue;
      }
      if (parse_opts && arg === "-F") {
        if ((i + 1 | 0) >= args.length) {
          self.exit_code = 2;
          return undefined;
        }
        func_name = _M0MPC15array5Array2atGUssEE(args, i + 1 | 0);
        i = i + 2 | 0;
        continue;
      }
      if (parse_opts && arg === "-C") {
        if ((i + 1 | 0) >= args.length) {
          self.exit_code = 2;
          return undefined;
        }
        command_name = _M0MPC15array5Array2atGUssEE(args, i + 1 | 0);
        i = i + 2 | 0;
        continue;
      }
      if (parse_opts && arg === "-X") {
        if ((i + 1 | 0) >= args.length) {
          self.exit_code = 2;
          return undefined;
        }
        filter_pattern = _M0MPC15array5Array2atGUssEE(args, i + 1 | 0);
        i = i + 2 | 0;
        continue;
      }
      if (parse_opts && arg === "-P") {
        if ((i + 1 | 0) >= args.length) {
          self.exit_code = 2;
          return undefined;
        }
        output_prefix = _M0MPC15array5Array2atGUssEE(args, i + 1 | 0);
        i = i + 2 | 0;
        continue;
      }
      if (parse_opts && arg === "-S") {
        if ((i + 1 | 0) >= args.length) {
          self.exit_code = 2;
          return undefined;
        }
        output_suffix = _M0MPC15array5Array2atGUssEE(args, i + 1 | 0);
        i = i + 2 | 0;
        continue;
      }
      if (parse_opts && arg === "-o") {
        if ((i + 1 | 0) >= args.length || !_M0FP410Haoxincode8moonbash3lib11interpreter30completion__is__valid__compopt(_M0MPC15array5Array2atGUssEE(args, i + 1 | 0))) {
          self.exit_code = 2;
          return undefined;
        }
        _M0MPC15array5Array4pushGUssEE(option_o, _M0MPC15array5Array2atGUssEE(args, i + 1 | 0));
        i = i + 2 | 0;
        continue;
      }
      let _tmp$38;
      if (parse_opts) {
        let _tmp$39;
        if (arg.length > 0) {
          $bound_check(arg, 0);
          _tmp$39 = arg.charCodeAt(0) === 45;
        } else {
          _tmp$39 = false;
        }
        _tmp$38 = _tmp$39;
      } else {
        _tmp$38 = false;
      }
      if (_tmp$38) {
        self.exit_code = 2;
        return undefined;
      }
      _M0MPC15array5Array4pushGUssEE(operands, arg);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const query = operands.length > 0 ? _M0MPC15array5Array2atGUssEE(operands, 0) : "";
  let had_generator = false;
  let user_action = false;
  const candidates = [];
  const _bind$4 = [];
  const seen = _M0MPB3Map3MapGsbE(new _M0TPB9ArrayViewGUsbEE(_bind$4, 0, 0), undefined);
  const _bind$5 = actions.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const action = actions[_];
      had_generator = true;
      switch (action) {
        case "function": {
          const names = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32collect__function__names__sorted(self);
          const _bind$6 = names.length;
          let _tmp$39 = 0;
          while (true) {
            const _$2 = _tmp$39;
            if (_$2 < _bind$6) {
              const name = names[_$2];
              if (_M0FP410Haoxincode8moonbash3lib11interpreter27completion__matches__prefix(name, query)) {
                _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(candidates, seen, name);
              }
              _tmp$39 = _$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          break;
        }
        case "variable": {
          const names$2 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32collect__variable__names__sorted(self);
          const _bind$7 = names$2.length;
          let _tmp$40 = 0;
          while (true) {
            const _$2 = _tmp$40;
            if (_$2 < _bind$7) {
              const name = names$2[_$2];
              if (_M0FP410Haoxincode8moonbash3lib11interpreter27completion__matches__prefix(name, query)) {
                _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(candidates, seen, name);
              }
              _tmp$40 = _$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          break;
        }
        case "export": {
          const names$3 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32collect__exported__names__sorted(self);
          const _bind$8 = names$3.length;
          let _tmp$41 = 0;
          while (true) {
            const _$2 = _tmp$41;
            if (_$2 < _bind$8) {
              const name = names$3[_$2];
              if (_M0FP410Haoxincode8moonbash3lib11interpreter27completion__matches__prefix(name, query)) {
                _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(candidates, seen, name);
              }
              _tmp$41 = _$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          break;
        }
        case "alias": {
          const names$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29collect__alias__names__sorted(self);
          const _bind$9 = names$4.length;
          let _tmp$42 = 0;
          while (true) {
            const _$2 = _tmp$42;
            if (_$2 < _bind$9) {
              const name = names$4[_$2];
              if (_M0FP410Haoxincode8moonbash3lib11interpreter27completion__matches__prefix(name, query)) {
                _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(candidates, seen, name);
              }
              _tmp$42 = _$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          break;
        }
        case "shopt": {
          const names$5 = ["dotglob", "expand_aliases", "extglob", "failglob", "globstar", "nocaseglob", "nullglob"];
          _M0FP410Haoxincode8moonbash3lib11interpreter25completion__sort__strings(names$5);
          const _bind$10 = names$5.length;
          let _tmp$43 = 0;
          while (true) {
            const _$2 = _tmp$43;
            if (_$2 < _bind$10) {
              const name = names$5[_$2];
              if (_M0FP410Haoxincode8moonbash3lib11interpreter27completion__matches__prefix(name, query)) {
                _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(candidates, seen, name);
              }
              _tmp$43 = _$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          break;
        }
        case "helptopic": {
          const names$6 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33collect__helptopic__names__sorted(self);
          const _bind$11 = names$6.length;
          let _tmp$44 = 0;
          while (true) {
            const _$2 = _tmp$44;
            if (_$2 < _bind$11) {
              const name = names$6[_$2];
              if (_M0FP410Haoxincode8moonbash3lib11interpreter27completion__matches__prefix(name, query)) {
                _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(candidates, seen, name);
              }
              _tmp$44 = _$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          break;
        }
        case "user": {
          user_action = true;
          break;
        }
        case "command": {
          const names$7 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext36collect__command__action__candidates(self);
          const _bind$12 = names$7.length;
          let _tmp$45 = 0;
          while (true) {
            const _$2 = _tmp$45;
            if (_$2 < _bind$12) {
              const name = names$7[_$2];
              if (_M0FP410Haoxincode8moonbash3lib11interpreter27completion__matches__prefix(name, query)) {
                _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(candidates, seen, name);
              }
              _tmp$45 = _$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          break;
        }
        case "builtin": {
          const names$8 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31collect__builtin__names__sorted(self);
          const _bind$13 = names$8.length;
          let _tmp$46 = 0;
          while (true) {
            const _$2 = _tmp$46;
            if (_$2 < _bind$13) {
              const name = names$8[_$2];
              if (_M0FP410Haoxincode8moonbash3lib11interpreter27completion__matches__prefix(name, query)) {
                _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(candidates, seen, name);
              }
              _tmp$46 = _$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          break;
        }
        case "keyword": {
          const names$9 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31collect__keyword__names__sorted(self);
          const _bind$14 = names$9.length;
          let _tmp$47 = 0;
          while (true) {
            const _$2 = _tmp$47;
            if (_$2 < _bind$14) {
              const name = names$9[_$2];
              if (_M0FP410Haoxincode8moonbash3lib11interpreter27completion__matches__prefix(name, query)) {
                _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(candidates, seen, name);
              }
              _tmp$47 = _$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          break;
        }
        case "file": {
          const _bind$15 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext37collect__path__completion__candidates(self, query, false);
          const _names = _bind$15._0;
          const _ok = _bind$15._1;
          if (!_ok) {
            self.exit_code = 1;
            return undefined;
          }
          const _bind$16 = _names.length;
          let _tmp$48 = 0;
          while (true) {
            const _$2 = _tmp$48;
            if (_$2 < _bind$16) {
              const name = _names[_$2];
              _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(candidates, seen, name);
              _tmp$48 = _$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          break;
        }
        case "directory": {
          const _bind$17 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext37collect__path__completion__candidates(self, query, true);
          const _names$2 = _bind$17._0;
          const _ok$2 = _bind$17._1;
          if (!_ok$2) {
            self.exit_code = 1;
            return undefined;
          }
          const _bind$18 = _names$2.length;
          let _tmp$49 = 0;
          while (true) {
            const _$2 = _tmp$49;
            if (_$2 < _bind$18) {
              const name = _names$2[_$2];
              _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(candidates, seen, name);
              _tmp$49 = _$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          break;
        }
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$6 = words;
  if (_bind$6 === undefined) {
  } else {
    const _Some = _bind$6;
    const _raw = _Some;
    had_generator = true;
    const _bind$7 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22expand__compgen__words(self, _raw);
    const _expanded_words = _bind$7._0;
    const _status_code = _bind$7._1;
    if (_status_code !== 0) {
      self.exit_code = _status_code;
      return undefined;
    }
    const _bind$8 = _expanded_words.length;
    let _tmp$39 = 0;
    while (true) {
      const _ = _tmp$39;
      if (_ < _bind$8) {
        const word = _expanded_words[_];
        if (_M0FP410Haoxincode8moonbash3lib11interpreter27completion__matches__prefix(word, query)) {
          _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(candidates, seen, word);
        }
        _tmp$39 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  const _bind$7 = func_name;
  if (_bind$7 === undefined) {
  } else {
    const _Some = _bind$7;
    const _name = _Some;
    had_generator = true;
    if (!_M0MPB3Map8containsGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self.functions, _name)) {
      self.exit_code = 1;
      return undefined;
    }
    const callback_status = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22run__compgen__function(self, _name, query);
    if (callback_status !== 0) {
      self.exit_code = 1;
      return undefined;
    }
    const replies = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext26collect__compreply__values(self);
    const _bind$8 = replies.length;
    let _tmp$39 = 0;
    while (true) {
      const _ = _tmp$39;
      if (_ < _bind$8) {
        const value = replies[_];
        _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(candidates, seen, value);
        _tmp$39 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  const _bind$8 = command_name;
  if (_bind$8 === undefined) {
  } else {
    const _Some = _bind$8;
    const _name = _Some;
    had_generator = true;
    const cmd_args = [];
    if (query.length > 0) {
      _M0MPC15array5Array4pushGUssEE(cmd_args, query);
    }
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12run__command(self, _name, cmd_args);
    if (self.exit_code === 127) {
      self.exit_code = 1;
    }
    return undefined;
  }
  const _bind$9 = option_o.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$9) {
      const opt = option_o[_];
      had_generator = true;
      if (opt === "plusdirs" || opt === "dirnames") {
        const _bind$10 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext37collect__path__completion__candidates(self, query, true);
        const _names = _bind$10._0;
        const _ok = _bind$10._1;
        if (!_ok) {
          self.exit_code = 1;
          return undefined;
        }
        const _bind$11 = _names.length;
        let _tmp$40 = 0;
        while (true) {
          const _$2 = _tmp$40;
          if (_$2 < _bind$11) {
            const name = _names[_$2];
            _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(candidates, seen, name);
            _tmp$40 = _$2 + 1 | 0;
            continue;
          } else {
            break;
          }
        }
      } else {
        if (opt === "default") {
          const _bind$10 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext37collect__path__completion__candidates(self, query, false);
          const _names = _bind$10._0;
          const _ok = _bind$10._1;
          if (!_ok) {
            self.exit_code = 1;
            return undefined;
          }
          const _bind$11 = _names.length;
          let _tmp$40 = 0;
          while (true) {
            const _$2 = _tmp$40;
            if (_$2 < _bind$11) {
              const name = _names[_$2];
              _M0FP410Haoxincode8moonbash3lib11interpreter23completion__add__unique(candidates, seen, name);
              _tmp$40 = _$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
        }
      }
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (!had_generator) {
    self.exit_code = 2;
    return undefined;
  }
  const filtered = [];
  const _bind$10 = filter_pattern;
  if (_bind$10 === undefined) {
    const _bind$11 = candidates.length;
    let _tmp$40 = 0;
    while (true) {
      const _ = _tmp$40;
      if (_ < _bind$11) {
        const value = candidates[_];
        _M0MPC15array5Array4pushGUssEE(filtered, value);
        _tmp$40 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  } else {
    const _Some = _bind$10;
    const _pattern = _Some;
    const _bind$11 = candidates.length;
    let _tmp$40 = 0;
    while (true) {
      const _ = _tmp$40;
      if (_ < _bind$11) {
        const value = candidates[_];
        if (_M0FP410Haoxincode8moonbash3lib11interpreter36compgen__should__keep__after__filter(value, _pattern)) {
          _M0MPC15array5Array4pushGUssEE(filtered, value);
        }
        _tmp$40 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  if (filtered.length === 0) {
    self.exit_code = user_action ? 0 : 1;
    return undefined;
  }
  const _bind$11 = filtered.length;
  let _tmp$40 = 0;
  while (true) {
    const _ = _tmp$40;
    if (_ < _bind$11) {
      const value = filtered[_];
      _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${output_prefix}${value}${output_suffix}\n`);
      _tmp$40 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22expand__compgen__words(self, raw) {
  if (raw.length === 0) {
    return { _0: [], _1: 0 };
  }
  if (_M0FP410Haoxincode8moonbash3lib11interpreter34completion__has__unbalanced__param(raw)) {
    return { _0: [], _1: 2 };
  }
  const _p$4 = _M0MPB3Map3getGssE(self.env, "IFS");
  const _p$5 = " \t\n";
  let ifs;
  if (_p$4 === undefined) {
    ifs = _p$5;
  } else {
    const _p$6 = _p$4;
    ifs = _p$6;
  }
  if (_M0FP410Haoxincode8moonbash3lib11interpreter19contains__substring(raw, "/ 0 ))") || (_M0FP410Haoxincode8moonbash3lib11interpreter19contains__substring(raw, "/0 ))") || (_M0FP410Haoxincode8moonbash3lib11interpreter19contains__substring(raw, "/ 0))") || _M0FP410Haoxincode8moonbash3lib11interpreter19contains__substring(raw, "/0))")))) {
    return { _0: [], _1: 1 };
  }
  if (_M0FP410Haoxincode8moonbash3lib11interpreter19contains__substring(raw, "$(") || _M0FP410Haoxincode8moonbash3lib11interpreter19contains__substring(raw, "$((")) {
    const trimmed = _M0FP410Haoxincode8moonbash3lib11interpreter23trim__ascii__whitespace(raw);
    let _tmp$38;
    if (trimmed.length > 3) {
      let _tmp$39;
      $bound_check(trimmed, 0);
      if (trimmed.charCodeAt(0) === 36) {
        let _tmp$40;
        $bound_check(trimmed, 1);
        if (trimmed.charCodeAt(1) === 40) {
          const _tmp$41 = trimmed.length - 1 | 0;
          $bound_check(trimmed, _tmp$41);
          _tmp$40 = trimmed.charCodeAt(_tmp$41) === 41;
        } else {
          _tmp$40 = false;
        }
        _tmp$39 = _tmp$40;
      } else {
        _tmp$39 = false;
      }
      _tmp$38 = _tmp$39;
    } else {
      _tmp$38 = false;
    }
    if (_tmp$38) {
      const inner = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(trimmed, 2, trimmed.length - 1 | 0));
      const saved_exit = self.exit_code;
      const expanded = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20expand__command__sub(self, inner);
      const sub_exit = self.exit_code;
      self.exit_code = saved_exit;
      if (sub_exit !== 0) {
        return { _0: [], _1: 1 };
      }
      return { _0: _M0FP410Haoxincode8moonbash3lib11interpreter30compgen__split__words__by__ifs(expanded, ifs, false), _1: 0 };
    }
    const saved_exit = self.exit_code;
    const expanded = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20expand__command__sub(self, `echo ${raw}`);
    const sub_exit = self.exit_code;
    self.exit_code = saved_exit;
    if (sub_exit !== 0) {
      return { _0: [], _1: 1 };
    }
    return { _0: _M0FP410Haoxincode8moonbash3lib11interpreter30compgen__split__words__by__ifs(expanded, ifs, false), _1: 0 };
  }
  return { _0: _M0FP410Haoxincode8moonbash3lib11interpreter30compgen__split__words__by__ifs(raw, ifs, true), _1: 0 };
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22run__compgen__function(self, func_name, query) {
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext28clear__named__array__storage(self, "COMPREPLY");
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24store__array__assignment(self, "COMP_WORDS", []);
  _M0MPB3Map3setGssE(self.env, "COMP_CWORD", "-1");
  _M0MPB3Map3setGssE(self.env, "COMP_LINE", "");
  _M0MPB3Map3setGssE(self.env, "COMP_POINT", "0");
  _M0MPB3Map3setGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter26compgen__in__function__key, "1");
  const callback_args = ["compgen", query, ""];
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12run__command(self, func_name, callback_args);
  const status = self.exit_code;
  _M0MPB3Map6removeGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter26compgen__in__function__key);
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext28clear__named__array__storage(self, "COMP_WORDS");
  _M0MPB3Map6removeGssE(self.env, "COMP_CWORD");
  _M0MPB3Map6removeGssE(self.env, "COMP_LINE");
  _M0MPB3Map6removeGssE(self.env, "COMP_POINT");
  return status;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__declare(self, args) {
  let nameref = false;
  let print_mode = false;
  let function_mode = false;
  let function_name_mode = false;
  let readonly_mode = false;
  let clear_readonly_mode = false;
  let integer_mode = false;
  let lowercase_mode = false;
  let uppercase_mode = false;
  let export_mode = false;
  let clear_export_mode = false;
  let global_mode = false;
  let indexed_array_mode = false;
  let assoc_array_mode = false;
  const filtered = [];
  const _bind$4 = args.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const arg = args[_];
      _L: {
        const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter29parse__declare__option__token(arg);
        if (_bind$5 === undefined) {
        } else {
          const _Some = _bind$5;
          const _x = _Some;
          const _enable = _x._0;
          const _flags = _x._1;
          const _bind$6 = _flags.length;
          let _tmp$39 = 0;
          while (true) {
            const _$2 = _tmp$39;
            if (_$2 < _bind$6) {
              const flag = _flags[_$2];
              switch (flag) {
                case 110: {
                  nameref = _enable;
                  break;
                }
                case 112: {
                  print_mode = true;
                  break;
                }
                case 102: {
                  if (_enable) {
                    function_mode = true;
                    print_mode = true;
                  }
                  break;
                }
                case 70: {
                  if (_enable) {
                    function_mode = true;
                    function_name_mode = true;
                    print_mode = true;
                  }
                  break;
                }
                case 114: {
                  if (_enable) {
                    readonly_mode = true;
                  } else {
                    clear_readonly_mode = true;
                  }
                  break;
                }
                case 105: {
                  integer_mode = _enable;
                  break;
                }
                case 108: {
                  lowercase_mode = _enable;
                  break;
                }
                case 117: {
                  uppercase_mode = _enable;
                  break;
                }
                case 120: {
                  if (_enable) {
                    export_mode = true;
                  } else {
                    clear_export_mode = true;
                  }
                  break;
                }
                case 97: {
                  indexed_array_mode = _enable;
                  break;
                }
                case 65: {
                  assoc_array_mode = _enable;
                  break;
                }
                case 103: {
                  if (_enable) {
                    global_mode = true;
                  }
                  break;
                }
              }
              _tmp$39 = _$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          break _L;
        }
        _M0MPC15array5Array4pushGUssEE(filtered, arg);
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (print_mode) {
    let failed = false;
    if (function_mode) {
      const function_names = [];
      const _it = _M0MPB3Map5iter2GssE(self.functions);
      while (true) {
        const _bind$5 = _M0MPB5Iter24nextGssE(_it);
        if (_bind$5 === undefined) {
          break;
        } else {
          const _Some = _bind$5;
          const _x = _Some;
          const _name = _x._0;
          if (_M0FP410Haoxincode8moonbash3lib11interpreter36is__visible__declare__function__name(_name)) {
            _M0MPC15array5Array4pushGUssEE(function_names, _name);
          }
          continue;
        }
      }
      _M0MPC15array5Array8sort__byGUssEE(function_names, (a, b) => _M0FP410Haoxincode8moonbash3lib11interpreter13compare__text(a, b));
      if (filtered.length === 0) {
        const _bind$5 = function_names.length;
        let _tmp$39 = 0;
        while (true) {
          const _ = _tmp$39;
          if (_ < _bind$5) {
            const name = function_names[_];
            if (function_name_mode) {
              _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `declare -f ${name}\n`);
            } else {
              _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name} ()\n`);
            }
            _tmp$39 = _ + 1 | 0;
            continue;
          } else {
            break;
          }
        }
      } else {
        const _bind$5 = filtered.length;
        let _tmp$39 = 0;
        while (true) {
          const _ = _tmp$39;
          if (_ < _bind$5) {
            const name = filtered[_];
            if (_M0MPB3Map8containsGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self.functions, name) && _M0FP410Haoxincode8moonbash3lib11interpreter36is__visible__declare__function__name(name)) {
              if (function_name_mode) {
                _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name}\n`);
              } else {
                _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name} ()\n`);
              }
            } else {
              _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: declare: ${name}: not found\n`);
              failed = true;
            }
            _tmp$39 = _ + 1 | 0;
            continue;
          } else {
            break;
          }
        }
      }
    } else {
      const names = filtered.length === 0 ? _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext30collect__declare__print__names(self) : filtered;
      const _bind$5 = names.length;
      let _tmp$39 = 0;
      while (true) {
        const _ = _tmp$39;
        if (_ < _bind$5) {
          const name = names[_];
          _L: {
            if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32declare__entry__matches__filters(self, name, nameref, readonly_mode, export_mode, indexed_array_mode, assoc_array_mode)) {
              break _L;
            }
            const _bind$6 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29format__declare__print__entry(self, name);
            if (_bind$6 === undefined) {
              if (filtered.length > 0 && self.call_depth <= 0) {
                _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: declare: ${name}: not found\n`);
                failed = true;
              }
            } else {
              const _Some = _bind$6;
              const _rendered = _Some;
              _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_rendered}\n`);
            }
            break _L;
          }
          _tmp$39 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
    }
    self.exit_code = failed ? 1 : 0;
    return undefined;
  }
  if (nameref) {
    const _bind$5 = filtered.length;
    let _tmp$39 = 0;
    while (true) {
      const _ = _tmp$39;
      if (_ < _bind$5) {
        const spec = filtered[_];
        const _bind$6 = _M0FP410Haoxincode8moonbash3lib11interpreter24parse__name__value__spec(spec);
        if (_bind$6 === undefined) {
        } else {
          const _Some = _bind$6;
          const _x = _Some;
          const _name = _x._0;
          const _x$2 = _x._1;
          if (_x$2 === undefined) {
            if (!global_mode) {
              _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext23capture__local__binding(self, _name);
            }
            if (!_M0MPB3Map8containsGssE(self.env, _name)) {
              _M0MPB3Map3setGssE(self.env, _name, "");
            }
          } else {
            const _Some$2 = _x$2;
            const _target = _Some$2;
            if (!global_mode) {
              _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext23capture__local__binding(self, _name);
            }
            _M0MPB3Map3setGssE(self.env, _name, _target);
            _M0MPB3Map3setGssE(self.env, `__MOON_BASH_NAMEREF__${_name}`, _target);
          }
        }
        _tmp$39 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    self.exit_code = 0;
    return undefined;
  }
  if (filtered.length === 0 && !(readonly_mode || (clear_readonly_mode || (integer_mode || (lowercase_mode || (uppercase_mode || (export_mode || (clear_export_mode || (global_mode || (indexed_array_mode || assoc_array_mode)))))))))) {
    const names = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext30collect__declare__print__names(self);
    const _bind$5 = names.length;
    let _tmp$39 = 0;
    while (true) {
      const _ = _tmp$39;
      if (_ < _bind$5) {
        const name = names[_];
        const _bind$6 = _M0MPB3Map3getGssE(self.env, name);
        if (_bind$6 === undefined) {
        } else {
          const _Some = _bind$6;
          const _value = _Some;
          _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name}=${_value}\n`);
        }
        _tmp$39 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    self.exit_code = 0;
    return undefined;
  }
  if (filtered.length === 0) {
    if (readonly_mode || (export_mode || nameref)) {
      const names = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext30collect__declare__print__names(self);
      const _bind$5 = names.length;
      let _tmp$39 = 0;
      while (true) {
        const _ = _tmp$39;
        if (_ < _bind$5) {
          const name = names[_];
          if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32declare__entry__matches__filters(self, name, nameref, readonly_mode, export_mode, indexed_array_mode, assoc_array_mode)) {
            const _bind$6 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29format__declare__print__entry(self, name);
            if (_bind$6 === undefined) {
            } else {
              const _Some = _bind$6;
              const _rendered = _Some;
              _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_rendered}\n`);
            }
          }
          _tmp$39 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      self.exit_code = 0;
      return undefined;
    }
    if (indexed_array_mode || assoc_array_mode) {
      const names = [];
      const _p$4 = "";
      const kind_prefix = `__MOON_BASH_ARRAY_KIND__${_p$4}`;
      const _it = _M0MPB3Map5iter2GssE(self.env);
      while (true) {
        const _bind$5 = _M0MPB5Iter24nextGssE(_it);
        if (_bind$5 === undefined) {
          break;
        } else {
          const _Some = _bind$5;
          const _x = _Some;
          const _key = _x._0;
          const _kind = _x._1;
          if (_M0FP410Haoxincode8moonbash3lib11interpreter19string__has__prefix(_key, kind_prefix)) {
            const name = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(_key, kind_prefix.length, undefined));
            if (indexed_array_mode && _kind === "indexed" || assoc_array_mode && _kind === "assoc") {
              _M0MPC15array5Array4pushGUssEE(names, name);
            }
          }
          continue;
        }
      }
      const _bind$5 = names.length;
      let _tmp$39 = 0;
      while (true) {
        const _ = _tmp$39;
        if (_ < _bind$5) {
          const name = names[_];
          const _bind$6 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29format__declare__print__entry(self, name);
          if (_bind$6 === undefined) {
          } else {
            const _Some = _bind$6;
            const _rendered = _Some;
            _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${_rendered}\n`);
          }
          _tmp$39 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
    }
    self.exit_code = 0;
    return undefined;
  }
  if ((indexed_array_mode || assoc_array_mode) && !(readonly_mode || (clear_readonly_mode || (integer_mode || (lowercase_mode || (uppercase_mode || (export_mode || (clear_export_mode || global_mode)))))))) {
    let failed = false;
    const _bind$5 = filtered.length;
    let _tmp$39 = 0;
    while (true) {
      const _ = _tmp$39;
      if (_ < _bind$5) {
        const spec = filtered[_];
        _L: {
          const _bind$6 = _M0FP410Haoxincode8moonbash3lib11interpreter24parse__name__value__spec(spec);
          if (_bind$6 === undefined) {
          } else {
            const _Some = _bind$6;
            const _x = _Some;
            const _name = _x._0;
            const _assigned_value = _x._1;
            const _append = _x._2;
            const target_kind = assoc_array_mode ? "assoc" : "indexed";
            const _p$4 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_ARRAY_KIND__${_name}`);
            const _p$5 = "";
            let existing_kind;
            if (_p$4 === undefined) {
              existing_kind = _p$5;
            } else {
              const _p$6 = _p$4;
              existing_kind = _p$6;
            }
            if (existing_kind.length > 0 && !(existing_kind === target_kind)) {
              failed = true;
              break _L;
            }
            if (!global_mode) {
              _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext23capture__local__binding(self, _name);
            }
            _M0MPB3Map3setGssE(self.env, `__MOON_BASH_ARRAY_KIND__${_name}`, target_kind);
            if (_assigned_value === undefined) {
              if (!_M0MPB3Map8containsGssE(self.env, `__MOON_BASH_ARRAY_COUNT__${_name}`)) {
                _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24store__array__assignment(self, _name, []);
              }
            } else {
              const _Some$2 = _assigned_value;
              const _raw_value = _Some$2;
              const word = _M0FP410Haoxincode8moonbash3lib6parser20parse__word__content(_raw_value);
              if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29try__store__array__assignment(self, _name, word, _append)) {
                if (self.should_exit) {
                  failed = true;
                  break;
                }
                break _L;
              }
              const value = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, word);
              if (self.should_exit) {
                failed = true;
                break;
              }
              let next_value;
              if (_append) {
                const _p$6 = _M0MPB3Map3getGssE(self.env, _name);
                const _p$7 = "";
                let _tmp$40;
                if (_p$6 === undefined) {
                  _tmp$40 = _p$7;
                } else {
                  const _p$8 = _p$6;
                  _tmp$40 = _p$8;
                }
                next_value = `${_tmp$40}${value}`;
              } else {
                next_value = value;
              }
              if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext40store__scalar__assignment__with__options(self, _name, next_value, false)) {
                failed = true;
                break;
              }
            }
          }
          break _L;
        }
        _tmp$39 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    self.exit_code = failed ? 1 : 0;
    return undefined;
  }
  if (!(readonly_mode || (clear_readonly_mode || (integer_mode || (lowercase_mode || (uppercase_mode || (export_mode || (clear_export_mode || global_mode)))))))) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__local(self, filtered);
    return undefined;
  }
  let failed = false;
  const _bind$5 = filtered.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$5) {
      const spec = filtered[_];
      _L: {
        const _bind$6 = _M0FP410Haoxincode8moonbash3lib11interpreter24parse__name__value__spec(spec);
        if (_bind$6 === undefined) {
        } else {
          const _Some = _bind$6;
          const _x = _Some;
          const _name = _x._0;
          const _assigned_value = _x._1;
          const _append = _x._2;
          if (!global_mode) {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext23capture__local__binding(self, _name);
          }
          if (readonly_mode) {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext23set__readonly__variable(self, _name, true);
          }
          if (clear_readonly_mode) {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext23set__readonly__variable(self, _name, false);
          }
          if (integer_mode) {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext23set__integer__attribute(self, _name, true);
          }
          if (lowercase_mode) {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21set__lower__attribute(self, _name, true);
          }
          if (uppercase_mode) {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21set__upper__attribute(self, _name, true);
          }
          if (lowercase_mode && uppercase_mode) {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21set__lower__attribute(self, _name, false);
          }
          if (export_mode) {
            _M0MPB3Map3setGsbE(self.exported, _name, true);
          }
          if (clear_export_mode) {
            _M0MPB3Map6removeGsbE(self.exported, _name);
          }
          if (_assigned_value === undefined) {
            if (!_M0MPB3Map8containsGssE(self.env, _name)) {
              if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext40store__scalar__assignment__with__options(self, _name, "", false)) {
                failed = true;
                break;
              }
            }
            if (clear_export_mode) {
              _M0MPB3Map6removeGsbE(self.exported, _name);
            }
          } else {
            const _Some$2 = _assigned_value;
            const _raw_value = _Some$2;
            const word = _M0FP410Haoxincode8moonbash3lib6parser20parse__word__content(_raw_value);
            if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29try__store__array__assignment(self, _name, word, _append)) {
              if (self.should_exit) {
                failed = true;
                break;
              }
              break _L;
            }
            const value = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, word);
            if (self.should_exit) {
              failed = true;
              break;
            }
            const _bind$7 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext34resolve__array__assignment__target(self, _name);
            if (_bind$7 === undefined) {
              let next_value;
              if (_append) {
                const _p$4 = _M0MPB3Map3getGssE(self.env, _name);
                const _p$5 = "";
                let _tmp$40;
                if (_p$4 === undefined) {
                  _tmp$40 = _p$5;
                } else {
                  const _p$6 = _p$4;
                  _tmp$40 = _p$6;
                }
                next_value = `${_tmp$40}${value}`;
              } else {
                next_value = value;
              }
              if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext40store__scalar__assignment__with__options(self, _name, next_value, false)) {
                failed = true;
                break;
              }
              if (clear_export_mode) {
                _M0MPB3Map6removeGsbE(self.exported, _name);
              }
            } else {
              const _Some$3 = _bind$7;
              const _x$2 = _Some$3;
              const _base = _x$2._0;
              const _index = _x$2._1;
              if (self.should_exit) {
                failed = true;
                break;
              }
              _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33store__array__element__assignment(self, _base, _index, value, _append);
            }
          }
        }
        break _L;
      }
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = failed ? 1 : 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__local(self, args) {
  let indexed_array_mode = false;
  let assoc_array_mode = false;
  let print_mode = false;
  let has_other_flags = false;
  const _bind$4 = args.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const arg = args[_];
      const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter29parse__declare__option__token(arg);
      if (_bind$5 === undefined) {
      } else {
        const _Some = _bind$5;
        const _x = _Some;
        const _flags = _x._1;
        const _bind$6 = _flags.length;
        let _tmp$39 = 0;
        while (true) {
          const _$2 = _tmp$39;
          if (_$2 < _bind$6) {
            const flag = _flags[_$2];
            switch (flag) {
              case 97: {
                indexed_array_mode = true;
                break;
              }
              case 65: {
                assoc_array_mode = true;
                break;
              }
              case 112: {
                print_mode = true;
                break;
              }
              default: {
                has_other_flags = true;
              }
            }
            _tmp$39 = _$2 + 1 | 0;
            continue;
          } else {
            break;
          }
        }
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (args.length === 0) {
    if (self.call_depth <= 0) {
      self.exit_code = 0;
      return undefined;
    }
    const _p$4 = _M0MPB3Map3getGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter24local__scope__names__key(self.call_depth));
    const _p$5 = "";
    let _tmp$39;
    if (_p$4 === undefined) {
      _tmp$39 = _p$5;
    } else {
      const _p$6 = _p$4;
      _tmp$39 = _p$6;
    }
    const locals = _M0FP410Haoxincode8moonbash3lib11interpreter26split__local__scope__names(_tmp$39);
    const _bind$5 = [];
    const seen = _M0MPB3Map3MapGsbE(new _M0TPB9ArrayViewGUsbEE(_bind$5, 0, 0), undefined);
    const names = [];
    const _bind$6 = locals.length;
    let _tmp$40 = 0;
    while (true) {
      const _ = _tmp$40;
      if (_ < _bind$6) {
        const name = locals[_];
        if (!_M0MPB3Map8containsGsbE(seen, name)) {
          _M0MPB3Map3setGsbE(seen, name, true);
          _M0MPC15array5Array4pushGUssEE(names, name);
        }
        _tmp$40 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    _M0MPC15array5Array8sort__byGUssEE(names, (a, b) => _M0FP410Haoxincode8moonbash3lib11interpreter13compare__text(a, b));
    const _bind$7 = names.length;
    let _tmp$41 = 0;
    while (true) {
      const _ = _tmp$41;
      if (_ < _bind$7) {
        const name = names[_];
        const _bind$8 = _M0MPB3Map3getGssE(self.env, name);
        if (_bind$8 === undefined) {
        } else {
          const _Some = _bind$8;
          const _value = _Some;
          _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name}=${_value}\n`);
        }
        _tmp$41 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    self.exit_code = 0;
    return undefined;
  }
  if (print_mode) {
    if (self.call_depth <= 0) {
      self.exit_code = 0;
      return undefined;
    }
    const _p$4 = _M0MPB3Map3getGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter24local__scope__names__key(self.call_depth));
    const _p$5 = "";
    let _tmp$39;
    if (_p$4 === undefined) {
      _tmp$39 = _p$5;
    } else {
      const _p$6 = _p$4;
      _tmp$39 = _p$6;
    }
    const local_names = _M0FP410Haoxincode8moonbash3lib11interpreter26split__local__scope__names(_tmp$39);
    const _bind$5 = [];
    const local_seen = _M0MPB3Map3MapGsbE(new _M0TPB9ArrayViewGUsbEE(_bind$5, 0, 0), undefined);
    const _bind$6 = local_names.length;
    let _tmp$40 = 0;
    while (true) {
      const _ = _tmp$40;
      if (_ < _bind$6) {
        const name = local_names[_];
        _M0MPB3Map3setGsbE(local_seen, name, true);
        _tmp$40 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    const requested = [];
    const _bind$7 = args.length;
    let _tmp$41 = 0;
    while (true) {
      const _ = _tmp$41;
      if (_ < _bind$7) {
        const arg = args[_];
        _L: {
          if (_M0FP410Haoxincode8moonbash3lib11interpreter26is__declare__option__token(arg)) {
            break _L;
          }
          _M0MPC15array5Array4pushGUssEE(requested, arg);
          break _L;
        }
        _tmp$41 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    const names = [];
    if (requested.length === 0) {
      const _it = _M0MPB3Map5iter2GsbE(local_seen);
      while (true) {
        const _bind$8 = _M0MPB5Iter24nextGsbE(_it);
        if (_bind$8 === undefined) {
          break;
        } else {
          const _Some = _bind$8;
          const _x = _Some;
          const _name = _x._0;
          _M0MPC15array5Array4pushGUssEE(names, _name);
          continue;
        }
      }
      _M0MPC15array5Array8sort__byGUssEE(names, (a, b) => _M0FP410Haoxincode8moonbash3lib11interpreter13compare__text(a, b));
    } else {
      self.exit_code = 0;
      return undefined;
    }
    const _bind$8 = names.length;
    let _tmp$42 = 0;
    while (true) {
      const _ = _tmp$42;
      if (_ < _bind$8) {
        const name = names[_];
        const _bind$9 = _M0MPB3Map3getGssE(self.env, name);
        if (_bind$9 === undefined) {
        } else {
          const _Some = _bind$9;
          const _value = _Some;
          _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, `${name}=${_value}\n`);
        }
        _tmp$42 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    self.exit_code = 0;
    return undefined;
  }
  if (indexed_array_mode || assoc_array_mode) {
    let failed = false;
    const _bind$5 = args.length;
    let _tmp$39 = 0;
    while (true) {
      const _ = _tmp$39;
      if (_ < _bind$5) {
        const arg = args[_];
        _L: {
          if (_M0FP410Haoxincode8moonbash3lib11interpreter26is__declare__option__token(arg)) {
            break _L;
          }
          const _bind$6 = _M0FP410Haoxincode8moonbash3lib11interpreter24parse__name__value__spec(arg);
          if (_bind$6 === undefined) {
            failed = true;
            break;
          } else {
            const _Some = _bind$6;
            const _x = _Some;
            const _name = _x._0;
            const _assigned_value = _x._1;
            const _append = _x._2;
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext23capture__local__binding(self, _name);
            _M0MPB3Map3setGssE(self.env, `__MOON_BASH_ARRAY_KIND__${_name}`, assoc_array_mode ? "assoc" : "indexed");
            if (_assigned_value === undefined) {
              _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24store__array__assignment(self, _name, []);
            } else {
              const _Some$2 = _assigned_value;
              const _raw_value = _Some$2;
              const word = _M0FP410Haoxincode8moonbash3lib6parser20parse__word__content(_raw_value);
              if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29try__store__array__assignment(self, _name, word, _append)) {
                if (self.should_exit) {
                  failed = true;
                  break;
                }
                break _L;
              }
              const value = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, word);
              if (self.should_exit) {
                failed = true;
                break;
              }
              let next_value;
              if (_append) {
                const _p$4 = _M0MPB3Map3getGssE(self.env, _name);
                const _p$5 = "";
                let _tmp$40;
                if (_p$4 === undefined) {
                  _tmp$40 = _p$5;
                } else {
                  const _p$6 = _p$4;
                  _tmp$40 = _p$6;
                }
                next_value = `${_tmp$40}${value}`;
              } else {
                next_value = value;
              }
              if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext40store__scalar__assignment__with__options(self, _name, next_value, false)) {
                failed = true;
                break;
              }
            }
          }
          break _L;
        }
        _tmp$39 = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    self.exit_code = failed ? 1 : 0;
    return undefined;
  }
  if (has_other_flags) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__declare(self, args);
    return undefined;
  }
  const _bind$5 = args.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$5) {
      const arg = args[_];
      if (_M0FP410Haoxincode8moonbash3lib11interpreter26is__declare__option__token(arg)) {
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__declare(self, args);
        return undefined;
      }
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let failed = false;
  const _bind$6 = args.length;
  let _tmp$40 = 0;
  while (true) {
    const _ = _tmp$40;
    if (_ < _bind$6) {
      const arg = args[_];
      _L: {
        const _bind$7 = _M0FP410Haoxincode8moonbash3lib11interpreter24parse__name__value__spec(arg);
        if (_bind$7 === undefined) {
          failed = true;
          break;
        } else {
          const _Some = _bind$7;
          const _x = _Some;
          const _name = _x._0;
          const _assigned_value = _x._1;
          const _append = _x._2;
          _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext23capture__local__binding(self, _name);
          if (_assigned_value === undefined) {
            if (_append && _M0MPB3Map8containsGssE(self.env, `__MOON_BASH_ARRAY_COUNT__${_name}`)) {
              self.should_exit = true;
              failed = true;
              break;
            }
            if (!_M0MPB3Map8containsGssE(self.env, _name)) {
              if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext40store__scalar__assignment__with__options(self, _name, "", false)) {
                failed = true;
                break;
              }
            }
          } else {
            const _Some$2 = _assigned_value;
            const _raw_value = _Some$2;
            const word = _M0FP410Haoxincode8moonbash3lib6parser20parse__word__content(_raw_value);
            if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29try__store__array__assignment(self, _name, word, _append)) {
              if (self.should_exit) {
                failed = true;
                break;
              }
              break _L;
            }
            const value = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, word);
            if (self.should_exit) {
              failed = true;
              break;
            }
            const _bind$8 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext34resolve__array__assignment__target(self, _name);
            if (_bind$8 === undefined) {
              const _p$4 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_NAMEREF__${_name}`);
              let target_name;
              if (_p$4 === undefined) {
                target_name = _name;
              } else {
                const _p$5 = _p$4;
                target_name = _p$5;
              }
              if (_append && _M0MPB3Map8containsGssE(self.env, `__MOON_BASH_ARRAY_COUNT__${target_name}`)) {
                self.should_exit = true;
                failed = true;
                break;
              }
              let next_value;
              if (_append) {
                const _p$5 = _M0MPB3Map3getGssE(self.env, target_name);
                const _p$6 = "";
                let _tmp$41;
                if (_p$5 === undefined) {
                  _tmp$41 = _p$6;
                } else {
                  const _p$7 = _p$5;
                  _tmp$41 = _p$7;
                }
                next_value = `${_tmp$41}${value}`;
              } else {
                next_value = value;
              }
              if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext40store__scalar__assignment__with__options(self, target_name, next_value, false)) {
                failed = true;
                break;
              }
            } else {
              const _Some$3 = _bind$8;
              const _x$2 = _Some$3;
              const _base = _x$2._0;
              const _index = _x$2._1;
              if (self.should_exit) {
                failed = true;
                break;
              }
              const _bind$9 = _M0FP410Haoxincode8moonbash3lib11interpreter31split__array__assignment__items(word.parts);
              if (_bind$9.$tag === 1) {
                self.should_exit = true;
                failed = true;
                break;
              }
              _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33store__array__element__assignment(self, _base, _index, value, _append);
            }
          }
        }
        break _L;
      }
      _tmp$40 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = failed ? 1 : 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext40store__scalar__assignment__with__options(self, name, value, enforce_readonly) {
  if (enforce_readonly && _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22is__readonly__variable(self, name)) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: ${name}: readonly variable\n`);
    self.exit_code = 1;
    return false;
  }
  const final_value = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27apply__variable__attributes(self, name, value);
  if (final_value.length > self.limits.max_string_length) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22fail__execution__limit(self, "string length limit exceeded");
    return false;
  }
  _M0MPB3Map3setGssE(self.env, name, final_value);
  return true;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27apply__variable__attributes(self, name, value) {
  let output = value;
  const _p$4 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_ATTR_INTEGER__${name}`);
  const _p$5 = "";
  let _tmp$38;
  if (_p$4 === undefined) {
    _tmp$38 = _p$5;
  } else {
    const _p$6 = _p$4;
    _tmp$38 = _p$6;
  }
  if (_tmp$38 === "1") {
    output = _M0MPC15int645Int6418to__string_2einner(_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16eval__arith__raw(self, value), 10);
  }
  const _p$6 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_ATTR_LOWER__${name}`);
  const _p$7 = "";
  let _tmp$39;
  if (_p$6 === undefined) {
    _tmp$39 = _p$7;
  } else {
    const _p$8 = _p$6;
    _tmp$39 = _p$8;
  }
  if (_tmp$39 === "1") {
    output = _M0FP410Haoxincode8moonbash3lib11interpreter9to__lower(output);
  }
  const _p$8 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_ATTR_UPPER__${name}`);
  const _p$9 = "";
  let _tmp$40;
  if (_p$8 === undefined) {
    _tmp$40 = _p$9;
  } else {
    const _p$10 = _p$8;
    _tmp$40 = _p$10;
  }
  if (_tmp$40 === "1") {
    output = _M0FP410Haoxincode8moonbash3lib11interpreter9to__upper(output);
  }
  return output;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24builtin__double__bracket(self, args) {
  let _tmp$38;
  if (args.length === 0) {
    _tmp$38 = true;
  } else {
    const _p$4 = _M0MPC15array5Array2atGUssEE(args, args.length - 1 | 0);
    const _p$5 = "]]";
    _tmp$38 = !(_p$4 === _p$5);
  }
  if (_tmp$38) {
    self.exit_code = 2;
    return undefined;
  }
  const test_args = [];
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < (args.length - 1 | 0)) {
      _M0MPC15array5Array4pushGUssEE(test_args, _M0MPC15array5Array2atGUssEE(args, i));
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const result = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext28evaluate__test__with__status(self, test_args, 2);
  if (result.status === 0) {
    self.exit_code = result.value ? 0 : 1;
    return;
  } else {
    self.exit_code = result.status;
    if (result.status === 2) {
      self.should_exit = true;
      return;
    } else {
      return;
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__eval(self, args) {
  let start = 0;
  if (args.length > 0 && _M0MPC15array5Array2atGUssEE(args, 0) === "--") {
    start = 1;
  }
  if (start >= args.length) {
    self.exit_code = 0;
    return undefined;
  }
  const eval_args = [];
  let _tmp$38 = start;
  while (true) {
    const i = _tmp$38;
    if (i < args.length) {
      _M0MPC15array5Array4pushGUssEE(eval_args, _M0MPC15array5Array2atGUssEE(args, i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _p$4 = _M0MPC15array5Array4iterGsE(eval_args);
  const _p$5 = "";
  let _p$6 = _p$5;
  while (true) {
    const _p$7 = _M0MPB4Iter4nextGUssEE(_p$4);
    if (_p$7 === undefined) {
      break;
    } else {
      const _p$8 = _p$7;
      const _p$9 = _p$8;
      const _p$10 = _p$6;
      _p$6 = _p$10.length === 0 ? _p$9 : `${_p$10} ${_p$9}`;
      continue;
    }
  }
  const script = _p$6;
  let parsed;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib6parser5parse(script);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        parsed = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    const _BashError = _try_err;
    const _msg = _BashError._0;
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: eval: ${_msg}\n`);
    self.exit_code = 2;
    return undefined;
  }
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, parsed);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__exec(self, args) {
  if (args.length === 0) {
    self.exit_code = 0;
    return undefined;
  }
  const command = _M0MPC15array5Array2atGUssEE(args, 0);
  const cmd_args = [];
  let _tmp$38 = 1;
  while (true) {
    const i = _tmp$38;
    if (i < args.length) {
      _M0MPC15array5Array4pushGUssEE(cmd_args, _M0MPC15array5Array2atGUssEE(args, i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12run__command(self, command, cmd_args);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__getopts(self, args) {
  if (args.length < 2) {
    self.exit_code = 1;
    return undefined;
  }
  const opt_spec = _M0MPC15array5Array2atGUssEE(args, 0);
  const target_name = _M0MPC15array5Array2atGUssEE(args, 1);
  const parse_args = [];
  if (args.length > 2) {
    let _tmp$38 = 2;
    while (true) {
      const i = _tmp$38;
      if (i < args.length) {
        _M0MPC15array5Array4pushGUssEE(parse_args, _M0MPC15array5Array2atGUssEE(args, i));
        _tmp$38 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  } else {
    const _p$4 = _M0MPB3Map3getGssE(self.env, "#");
    const _p$5 = "0";
    let _tmp$38;
    if (_p$4 === undefined) {
      _tmp$38 = _p$5;
    } else {
      const _p$6 = _p$4;
      _tmp$38 = _p$6;
    }
    const argc = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_tmp$38);
    let _tmp$39 = 1;
    while (true) {
      const i = _tmp$39;
      if (i <= argc) {
        const _p$6 = _M0MPB3Map3getGssE(self.env, _M0MPC13int3Int18to__string_2einner(i, 10));
        const _p$7 = "";
        let _tmp$40;
        if (_p$6 === undefined) {
          _tmp$40 = _p$7;
        } else {
          const _p$8 = _p$6;
          _tmp$40 = _p$8;
        }
        _M0MPC15array5Array4pushGUssEE(parse_args, _tmp$40);
        _tmp$39 = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
  }
  const _p$4 = _M0MPB3Map3getGssE(self.env, "OPTIND");
  const _p$5 = "1";
  let _tmp$38;
  if (_p$4 === undefined) {
    _tmp$38 = _p$5;
  } else {
    const _p$6 = _p$4;
    _tmp$38 = _p$6;
  }
  let optind = _M0FP410Haoxincode8moonbash3lib11interpreter17parse__int32__str(_tmp$38);
  if (optind < 1) {
    optind = 1;
  }
  if (optind > parse_args.length) {
    self.exit_code = 1;
    return undefined;
  }
  const current = _M0MPC15array5Array2atGUssEE(parse_args, optind - 1 | 0);
  if (current === "--") {
    _M0MPB3Map3setGssE(self.env, "OPTIND", _M0MPC13int3Int18to__string_2einner(optind + 1 | 0, 10));
    self.exit_code = 1;
    return undefined;
  }
  let _tmp$39;
  if (current.length < 2) {
    _tmp$39 = true;
  } else {
    $bound_check(current, 0);
    _tmp$39 = current.charCodeAt(0) !== 45;
  }
  if (_tmp$39) {
    self.exit_code = 1;
    return undefined;
  }
  $bound_check(current, 1);
  const option_char = current.charCodeAt(1);
  if (option_char === 45) {
    self.exit_code = 1;
    return undefined;
  }
  const option_name = _M0FP410Haoxincode8moonbash3lib11interpreter21getopts__char__string(option_char);
  const opt_idx = _M0FP410Haoxincode8moonbash3lib11interpreter21getopts__find__option(opt_spec, option_char);
  if (opt_idx < 0) {
    if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25store__scalar__assignment(self, target_name, "?")) {
      return undefined;
    }
    if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25store__scalar__assignment(self, "OPTARG", option_name)) {
      return undefined;
    }
    _M0MPB3Map3setGssE(self.env, "OPTIND", _M0MPC13int3Int18to__string_2einner(optind + 1 | 0, 10));
    self.exit_code = 0;
    return undefined;
  }
  const expects_arg = _M0FP410Haoxincode8moonbash3lib11interpreter32getopts__option__takes__argument(opt_spec, opt_idx);
  if (expects_arg) {
    const inline = current.length > 2 ? _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(current, 2, undefined)) : "";
    let optarg;
    if (inline.length > 0) {
      optarg = inline;
    } else {
      if (optind < parse_args.length) {
        optarg = _M0MPC15array5Array2atGUssEE(parse_args, optind);
      } else {
        if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25store__scalar__assignment(self, target_name, "?")) {
          return undefined;
        }
        _M0MPB3Map3setGssE(self.env, "OPTIND", _M0MPC13int3Int18to__string_2einner(optind + 1 | 0, 10));
        self.exit_code = 0;
        return undefined;
      }
    }
    if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25store__scalar__assignment(self, target_name, option_name)) {
      return undefined;
    }
    if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25store__scalar__assignment(self, "OPTARG", optarg)) {
      return undefined;
    }
    _M0MPB3Map3setGssE(self.env, "OPTIND", inline.length > 0 ? _M0MPC13int3Int18to__string_2einner(optind + 1 | 0, 10) : _M0MPC13int3Int18to__string_2einner(optind + 2 | 0, 10));
    self.exit_code = 0;
    return undefined;
  }
  if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25store__scalar__assignment(self, target_name, option_name)) {
    return undefined;
  }
  _M0MPB3Map6removeGssE(self.env, "OPTARG");
  _M0MPB3Map3setGssE(self.env, "OPTIND", _M0MPC13int3Int18to__string_2einner(optind + 1 | 0, 10));
  self.exit_code = 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25store__scalar__assignment(self, name, value) {
  return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext40store__scalar__assignment__with__options(self, name, value, true);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12builtin__let(self, args) {
  if (args.length === 0) {
    self.exit_code = 1;
    return undefined;
  }
  let last = 0n;
  const _bind$4 = args.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const expr_text = args[_];
      last = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(self, new _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Raw(expr_text));
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = BigInt.asUintN(64, last) !== BigInt.asUintN(64, 0n) ? 0 : 1;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15builtin__printf(self, args) {
  if (args.length === 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "printf: usage: printf format [arguments]\n");
    self.exit_code = 1;
    return undefined;
  }
  let value_target = undefined;
  let format_idx = 0;
  if (args.length >= 2 && _M0MPC15array5Array2atGUssEE(args, 0) === "-v") {
    value_target = _M0MPC15array5Array2atGUssEE(args, 1);
    format_idx = 2;
  }
  if (format_idx >= args.length) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "printf: usage: printf format [arguments]\n");
    self.exit_code = 1;
    return undefined;
  }
  const format = _M0MPC15array5Array2atGUssEE(args, format_idx);
  const fmt_args = [];
  let _tmp$38 = format_idx + 1 | 0;
  while (true) {
    const i = _tmp$38;
    if (i < args.length) {
      _M0MPC15array5Array4pushGUssEE(fmt_args, _M0MPC15array5Array2atGUssEE(args, i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const result = _M0FP410Haoxincode8moonbash3lib11interpreter14format__printf(format, fmt_args);
  const _bind$4 = value_target;
  if (_bind$4 === undefined) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stdout_buf, result);
  } else {
    const _Some = _bind$4;
    const _name = _Some;
    const _bind$5 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext34resolve__array__assignment__target(self, _name);
    if (_bind$5 === undefined) {
      if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25store__scalar__assignment(self, _name, result)) {
        return undefined;
      }
    } else {
      const _Some$2 = _bind$5;
      const _x = _Some$2;
      const _base = _x._0;
      const _index = _x._1;
      if (self.should_exit) {
        self.exit_code = 1;
        return undefined;
      }
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33store__array__element__assignment(self, _base, _index, result, false);
      if (self.should_exit) {
        self.exit_code = 1;
        return undefined;
      }
    }
  }
  self.exit_code = 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17builtin__readonly(self, args) {
  if (args.length > 1 && _M0MPC15array5Array2atGUssEE(args, 0) === "-p") {
    self.exit_code = 0;
    return undefined;
  }
  const declare_args = ["-r"];
  const _bind$4 = args.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const arg = args[_];
      _M0MPC15array5Array4pushGUssEE(declare_args, arg);
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__declare(self, declare_args);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11builtin__sh(self, args) {
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__bash(self, args);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15builtin__source(self, args) {
  if (args.length === 0) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "moon_bash: source: filename argument required\n");
    self.exit_code = 2;
    return undefined;
  }
  let path;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib2fs13resolve__path(self.cwd, _M0MPC15array5Array2atGUssEE(args, 0));
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        path = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    path = _M0MPC15array5Array2atGUssEE(args, 0);
  }
  let content;
  let _try_err$2;
  _L$2: {
    _L$3: {
      const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10read__file(self.fs, path);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        content = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err$2 = _err._0;
        break _L$3;
      }
      break _L$2;
    }
    const _FsError = _try_err$2;
    const _msg = _FsError._0;
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: source: ${_msg}\n`);
    self.exit_code = 1;
    return undefined;
  }
  let parsed;
  let _try_err$3;
  _L$3: {
    _L$4: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib6parser5parse(content);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        parsed = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err$3 = _err._0;
        break _L$4;
      }
      break _L$3;
    }
    const _BashError = _try_err$3;
    const _msg = _BashError._0;
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: source: ${_msg}\n`);
    self.exit_code = 2;
    return undefined;
  }
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, parsed);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__test(self, args) {
  const result = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext28evaluate__test__with__status(self, args, 0);
  if (result.status === 0) {
    self.exit_code = result.value ? 0 : 1;
    return;
  } else {
    self.exit_code = result.status;
    return;
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13builtin__time(self, args) {
  if (args.length === 0) {
    self.exit_code = 0;
    return undefined;
  }
  const start_ms = _M0FP410Haoxincode8moonbash3lib3ffi13now__ms__sync();
  const cmd_name = _M0MPC15array5Array2atGUssEE(args, 0);
  const cmd_args = [];
  let _tmp$38 = 1;
  while (true) {
    const i = _tmp$38;
    if (i < args.length) {
      _M0MPC15array5Array4pushGUssEE(cmd_args, _M0MPC15array5Array2atGUssEE(args, i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12run__command(self, cmd_name, cmd_args);
  const end_ms = _M0FP410Haoxincode8moonbash3lib3ffi13now__ms__sync();
  const elapsed_ms = end_ms >= start_ms ? end_ms - start_ms | 0 : 0;
  const minutes = elapsed_ms / 60000 | 0;
  const seconds = (elapsed_ms % 60000 | 0) / 1000 | 0;
  const millis = elapsed_ms % 1000 | 0;
  _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `\nreal\t${_M0IPC13int3IntPB4Show10to__string(minutes)}m${_M0IPC13int3IntPB4Show10to__string(seconds)}.${_M0FP410Haoxincode8moonbash3lib11interpreter11shell__pad3(millis)}s\n`);
  _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "user\t0m0.000s\nsys\t0m0.000s\n");
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16builtin__timeout(self, args) {
  if (args.length < 2) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, "moon_bash: timeout: missing operand\n");
    self.exit_code = 1;
    return undefined;
  }
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter26shell__parse__duration__ms(_M0MPC15array5Array2atGUssEE(args, 0));
  let duration_ms;
  if (_bind$4.$tag === 1) {
    const _Ok = _bind$4;
    duration_ms = _Ok._0;
  } else {
    const _Err = _bind$4;
    const _msg = _Err._0;
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: timeout: ${_msg}\n`);
    self.exit_code = 1;
    return undefined;
  }
  const cmd_name = _M0MPC15array5Array2atGUssEE(args, 1);
  const cmd_args = [];
  let _tmp$38 = 2;
  while (true) {
    const i = _tmp$38;
    if (i < args.length) {
      _M0MPC15array5Array4pushGUssEE(cmd_args, _M0MPC15array5Array2atGUssEE(args, i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const start_ms = _M0FP410Haoxincode8moonbash3lib3ffi13now__ms__sync();
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12run__command(self, cmd_name, cmd_args);
  const end_ms = _M0FP410Haoxincode8moonbash3lib3ffi13now__ms__sync();
  const elapsed_ms = end_ms >= start_ms ? end_ms - start_ms | 0 : 0;
  if (elapsed_ms > duration_ms) {
    _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: timeout: command timed out after ${_M0MPC15array5Array2atGUssEE(args, 0)}\n`);
    self.exit_code = 124;
    return;
  } else {
    return;
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__unset(self, args) {
  let unset_functions = false;
  let explicit_mode = false;
  let failed = false;
  const _bind$4 = args.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const arg = args[_];
      _L: {
        if (arg === "-f") {
          unset_functions = true;
          explicit_mode = true;
          break _L;
        }
        if (arg === "-v") {
          unset_functions = false;
          explicit_mode = true;
          break _L;
        }
        if (unset_functions) {
          _M0MPB3Map6removeGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self.functions, arg);
          break _L;
        }
        const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter39parse__array__element__assignment__name(arg);
        if (_bind$5 === undefined) {
        } else {
          const _Some = _bind$5;
          const _x = _Some;
          const _base = _x._0;
          const _index_expr = _x._1;
          const _p$4 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_ARRAY_KIND__${_base}`);
          const _p$5 = "";
          let _p$6;
          if (_p$4 === undefined) {
            _p$6 = _p$5;
          } else {
            const _p$7 = _p$4;
            _p$6 = _p$7;
          }
          const _p$7 = "assoc";
          if (!(_p$6 === _p$7)) {
            const expanded_index = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext26expand__array__index__expr(self, _index_expr);
            const raw_text = expanded_index.length > 0 ? expanded_index : _index_expr;
            const raw_index = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(self, new _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Raw(raw_text));
            const resolved_index = BigInt.asIntN(64, raw_index) < BigInt.asIntN(64, 0n) ? BigInt.asUintN(64, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22indexed__array__origin(self, _base) + raw_index) : raw_index;
            if (BigInt.asIntN(64, resolved_index) < BigInt.asIntN(64, 0n)) {
              const line = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27line__number__for__fragment(self, arg);
              _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `bash: line ${_M0MPC13int3Int18to__string_2einner(line, 10)}: unset: [${_M0MPC15int645Int6418to__string_2einner(raw_index, 10)}]: bad array subscript\n`);
              failed = true;
              break _L;
            }
          }
        }
        const _bind$6 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext34resolve__array__assignment__target(self, arg);
        if (_bind$6 === undefined) {
        } else {
          const _Some = _bind$6;
          const _x = _Some;
          const _base = _x._0;
          const _index = _x._1;
          if (self.should_exit) {
            self.exit_code = 1;
            return undefined;
          }
          _M0MPB3Map6removeGssE(self.env, `${_base}[${_index}]`);
          _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24refresh__array__metadata(self, _base);
          break _L;
        }
        _M0MPB3Map6removeGssE(self.env, arg);
        _M0MPB3Map6removeGssE(self.env, `__MOON_BASH_NAMEREF__${arg}`);
        _M0MPB3Map6removeGssE(self.env, `__MOON_BASH_READONLY__${arg}`);
        _M0MPB3Map6removeGssE(self.env, `__MOON_BASH_ATTR_INTEGER__${arg}`);
        _M0MPB3Map6removeGssE(self.env, `__MOON_BASH_ATTR_LOWER__${arg}`);
        _M0MPB3Map6removeGssE(self.env, `__MOON_BASH_ATTR_UPPER__${arg}`);
        _M0MPB3Map6removeGsbE(self.exported, arg);
        if (!explicit_mode) {
          _M0MPB3Map6removeGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(self.functions, arg);
        }
        break _L;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.exit_code = failed ? 1 : 0;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext14builtin__xargs(self, args) {
  const cmd_name = args.length > 0 ? _M0MPC15array5Array2atGUssEE(args, 0) : "echo";
  const cmd_args = [];
  let _tmp$38 = 1;
  while (true) {
    const i = _tmp$38;
    if (i < args.length) {
      _M0MPC15array5Array4pushGUssEE(cmd_args, _M0MPC15array5Array2atGUssEE(args, i));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const input_words = _M0FP410Haoxincode8moonbash3lib11interpreter21split__by__whitespace(self.stdin_buf);
  const _bind$4 = input_words.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$4) {
      const word = input_words[_];
      _M0MPC15array5Array4pushGUssEE(cmd_args, word);
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext12run__command(self, cmd_name, cmd_args);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext37try__execute__resolved__path__command(self, original_name, resolved_path, args) {
  if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext37try__dispatch__virtual__command__stub(self, resolved_path, args)) {
    return true;
  }
  const _bind$4 = _M0MPB3Map3getGsRP410Haoxincode8moonbash3lib2fs7FsEntryE(self.fs.entries, resolved_path);
  if (_bind$4 === undefined) {
    return false;
  } else {
    const _Some = _bind$4;
    const _entry = _Some;
    if (_entry.$tag === 1) {
      return false;
    } else {
      if (!_M0FP410Haoxincode8moonbash3lib11interpreter30command__is__executable__entry(_entry)) {
        return false;
      } else {
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext30execute__script__file__command(self, resolved_path, args, original_name);
        return true;
      }
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext28try__execute__alias__command(self, alias_candidate, args, has_multiline_literal_arg) {
  if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18shopt__is__enabled(self, "expand_aliases")) {
    return false;
  }
  const _p$4 = _M0MPB3Map3getGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter28alias__runtime__disable__key);
  const _p$5 = "";
  let _tmp$38;
  if (_p$4 === undefined) {
    _tmp$38 = _p$5;
  } else {
    const _p$6 = _p$4;
    _tmp$38 = _p$6;
  }
  if (_tmp$38 === "1") {
    return false;
  }
  let alias_name;
  if (alias_candidate === undefined) {
    return false;
  } else {
    const _Some = alias_candidate;
    alias_name = _Some;
  }
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31resolve__alias__command__source(self, alias_name, args);
  let source;
  if (_bind$4 === undefined) {
    return false;
  } else {
    const _Some = _bind$4;
    source = _Some;
  }
  if (has_multiline_literal_arg) {
    self.exit_code = 2;
    return true;
  }
  let parsed;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$5 = _M0FP410Haoxincode8moonbash3lib6parser5parse(source);
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        parsed = _ok._0;
      } else {
        const _err = _bind$5;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    self.exit_code = 2;
    return true;
  }
  const saved_disable = _M0MPB3Map3getGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter28alias__runtime__disable__key);
  _M0MPB3Map3setGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter28alias__runtime__disable__key, "1");
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, parsed);
  if (saved_disable === undefined) {
    _M0MPB3Map6removeGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter28alias__runtime__disable__key);
  } else {
    const _Some = saved_disable;
    const _value = _Some;
    _M0MPB3Map3setGssE(self.env, _M0FP410Haoxincode8moonbash3lib11interpreter28alias__runtime__disable__key, _value);
  }
  return true;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext13expand__param(self, pe) {
  switch (pe.$tag) {
    case 0: {
      const _Simple = pe;
      const _name = _Simple._0;
      return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25expand__simple__parameter(self, _name);
    }
    case 1: {
      const _Default = pe;
      const _name$2 = _Default._0;
      const _word = _Default._1;
      const _colon = _Default._2;
      const value = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16expand__variable(self, _name$2);
      const is_set = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18parameter__is__set(self, _name$2);
      const is_null = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19parameter__is__null(self, _name$2, value);
      return _colon ? (is_null ? _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext40expand__param__word__for__split__context(self, _word) : value) : !is_set ? _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext40expand__param__word__for__split__context(self, _word) : value;
    }
    case 2: {
      const _Assign = pe;
      const _name$3 = _Assign._0;
      const _word$2 = _Assign._1;
      const _colon$2 = _Assign._2;
      const value$2 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16expand__variable(self, _name$3);
      const is_set$2 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18parameter__is__set(self, _name$3);
      const is_null$2 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19parameter__is__null(self, _name$3, value$2);
      if (_colon$2) {
        if (is_null$2) {
          const expanded = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext40expand__param__word__for__split__context(self, _word$2);
          const _p$4 = _M0MPB3Map3getGssE(self.env, "IFS");
          const _p$5 = " \t\n";
          let _tmp$38;
          if (_p$4 === undefined) {
            _tmp$38 = _p$5;
          } else {
            const _p$6 = _p$4;
            _tmp$38 = _p$6;
          }
          const plain = _M0FP410Haoxincode8moonbash3lib11interpreter36decode__word__split__protected__text(expanded, _tmp$38);
          _M0MPB3Map3setGssE(self.env, _name$3, plain);
          return expanded;
        } else {
          return value$2;
        }
      } else {
        if (!is_set$2) {
          const expanded = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext40expand__param__word__for__split__context(self, _word$2);
          const _p$4 = _M0MPB3Map3getGssE(self.env, "IFS");
          const _p$5 = " \t\n";
          let _tmp$38;
          if (_p$4 === undefined) {
            _tmp$38 = _p$5;
          } else {
            const _p$6 = _p$4;
            _tmp$38 = _p$6;
          }
          const plain = _M0FP410Haoxincode8moonbash3lib11interpreter36decode__word__split__protected__text(expanded, _tmp$38);
          _M0MPB3Map3setGssE(self.env, _name$3, plain);
          return expanded;
        } else {
          return value$2;
        }
      }
    }
    case 3: {
      const _Error = pe;
      const _name$4 = _Error._0;
      const _msg_word = _Error._1;
      const _colon$3 = _Error._2;
      const value$3 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16expand__variable(self, _name$4);
      const is_set$3 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18parameter__is__set(self, _name$4);
      const is_null$3 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19parameter__is__null(self, _name$4, value$3);
      const is_error = _colon$3 ? is_null$3 : !is_set$3;
      if (is_error) {
        let msg;
        if (_msg_word === undefined) {
          msg = "parameter null or not set";
        } else {
          const _Some = _msg_word;
          const _w = _Some;
          msg = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, _w);
        }
        _M0IPB13StringBuilderPB6Logger13write__string(self.stderr_buf, `moon_bash: ${_name$4}: ${msg}\n`);
        self.exit_code = 1;
        return "";
      } else {
        return value$3;
      }
    }
    case 4: {
      const _Alternative = pe;
      const _name$5 = _Alternative._0;
      const _word$3 = _Alternative._1;
      const _colon$4 = _Alternative._2;
      const value$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16expand__variable(self, _name$5);
      const is_set$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18parameter__is__set(self, _name$5);
      const is_null$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19parameter__is__null(self, _name$5, value$4);
      return _colon$4 ? (!is_null$4 ? _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext40expand__param__word__for__split__context(self, _word$3) : "") : is_set$4 ? _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext40expand__param__word__for__split__context(self, _word$3) : "";
    }
    case 5: {
      const _Length = pe;
      const _name$6 = _Length._0;
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter23array__count__var__name(_name$6);
      if (_bind$4 === undefined) {
        const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter29parse__array__reference__name(_name$6);
        if (_bind$5 === undefined) {
        } else {
          const _Some = _bind$5;
          const _x = _Some;
          const _base = _x._0;
          const _index_expr = _x._1;
          let _tmp$38;
          const _p$4 = "@";
          if (!(_index_expr === _p$4)) {
            const _p$5 = "*";
            _tmp$38 = !(_index_expr === _p$5);
          } else {
            _tmp$38 = false;
          }
          if (_tmp$38) {
            const has_array_metadata = _M0MPB3Map8containsGssE(self.env, `__MOON_BASH_ARRAY_COUNT__${_base}`) || _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20collect__array__keys(self, _base).length > 0;
            if (!has_array_metadata) {
              const fragment = `${_base}[${_index_expr}]`;
              _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27emit__bad__array__subscript(self, _base, fragment);
              self.exit_code = 1;
              _M0MPB3Map3setGssE(self.env, "__MOON_BASH_ABORT_CURRENT_COMMAND__", "1");
              self.should_exit = true;
              return "";
            }
          }
        }
        const value$5 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16expand__variable(self, _name$6);
        return _M0MPC13int3Int18to__string_2einner(value$5.length, 10);
      } else {
        const _Some = _bind$4;
        const _count_key = _Some;
        const _p$4 = _M0MPB3Map3getGssE(self.env, _count_key);
        const _p$5 = "0";
        if (_p$4 === undefined) {
          return _p$5;
        } else {
          const _p$6 = _p$4;
          return _p$6;
        }
      }
    }
    case 7: {
      const _PrefixRemove = pe;
      const _name$7 = _PrefixRemove._0;
      const _pattern = _PrefixRemove._1;
      const _greedy = _PrefixRemove._2;
      const pat = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, _pattern);
      const _bind$5 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext35expand__array__parameter__transform(self, _name$7, (value$5) => _M0FP410Haoxincode8moonbash3lib11interpreter22strip__prefix__pattern(value$5, pat, _greedy));
      if (_bind$5.$tag === 1) {
        const _Some = _bind$5;
        const _values = _Some._0;
        return _M0FP410Haoxincode8moonbash3lib11interpreter25join__values__with__space(_values);
      } else {
        const value$5 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16expand__variable(self, _name$7);
        return _M0FP410Haoxincode8moonbash3lib11interpreter22strip__prefix__pattern(value$5, pat, _greedy);
      }
    }
    case 8: {
      const _SuffixRemove = pe;
      const _name$8 = _SuffixRemove._0;
      const _pattern$2 = _SuffixRemove._1;
      const _greedy$2 = _SuffixRemove._2;
      const pat$2 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, _pattern$2);
      const _bind$6 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext35expand__array__parameter__transform(self, _name$8, (value$5) => _M0FP410Haoxincode8moonbash3lib11interpreter22strip__suffix__pattern(value$5, pat$2, _greedy$2));
      if (_bind$6.$tag === 1) {
        const _Some = _bind$6;
        const _values = _Some._0;
        return _M0FP410Haoxincode8moonbash3lib11interpreter25join__values__with__space(_values);
      } else {
        const value$5 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16expand__variable(self, _name$8);
        return _M0FP410Haoxincode8moonbash3lib11interpreter22strip__suffix__pattern(value$5, pat$2, _greedy$2);
      }
    }
    case 9: {
      const _Replace = pe;
      const _name$9 = _Replace._0;
      const _pattern$3 = _Replace._1;
      const _replacement = _Replace._2;
      const _mode = _Replace._3;
      const pat$3 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, _pattern$3);
      let repl;
      if (_replacement === undefined) {
        repl = "";
      } else {
        const _Some = _replacement;
        const _w = _Some;
        repl = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, _w);
      }
      const _bind$7 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext35expand__array__parameter__transform(self, _name$9, (value$5) => _M0FP410Haoxincode8moonbash3lib11interpreter16replace__pattern(value$5, pat$3, repl, _mode));
      if (_bind$7.$tag === 1) {
        const _Some = _bind$7;
        const _values = _Some._0;
        return _M0FP410Haoxincode8moonbash3lib11interpreter25join__values__with__space(_values);
      } else {
        const value$5 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16expand__variable(self, _name$9);
        return _M0FP410Haoxincode8moonbash3lib11interpreter16replace__pattern(value$5, pat$3, repl, _mode);
      }
    }
    case 10: {
      const _Uppercase = pe;
      const _name$10 = _Uppercase._0;
      const _all = _Uppercase._2;
      const _bind$8 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext35expand__array__parameter__transform(self, _name$10, (value$5) => _all ? _M0FP410Haoxincode8moonbash3lib11interpreter9to__upper(value$5) : _M0FP410Haoxincode8moonbash3lib11interpreter12upper__first(value$5));
      if (_bind$8.$tag === 1) {
        const _Some = _bind$8;
        const _values = _Some._0;
        return _M0FP410Haoxincode8moonbash3lib11interpreter25join__values__with__space(_values);
      } else {
        const value$5 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16expand__variable(self, _name$10);
        return _all ? _M0FP410Haoxincode8moonbash3lib11interpreter9to__upper(value$5) : _M0FP410Haoxincode8moonbash3lib11interpreter12upper__first(value$5);
      }
    }
    case 11: {
      const _Lowercase = pe;
      const _name$11 = _Lowercase._0;
      const _all$2 = _Lowercase._2;
      const _bind$9 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext35expand__array__parameter__transform(self, _name$11, (value$5) => _all$2 ? _M0FP410Haoxincode8moonbash3lib11interpreter9to__lower(value$5) : _M0FP410Haoxincode8moonbash3lib11interpreter12lower__first(value$5));
      if (_bind$9.$tag === 1) {
        const _Some = _bind$9;
        const _values = _Some._0;
        return _M0FP410Haoxincode8moonbash3lib11interpreter25join__values__with__space(_values);
      } else {
        const value$5 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16expand__variable(self, _name$11);
        return _all$2 ? _M0FP410Haoxincode8moonbash3lib11interpreter9to__lower(value$5) : _M0FP410Haoxincode8moonbash3lib11interpreter12lower__first(value$5);
      }
    }
    case 6: {
      const _Substring = pe;
      const _name$12 = _Substring._0;
      const _offset_expr = _Substring._1;
      const _length_expr = _Substring._2;
      const offset = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(self, _offset_expr);
      let len;
      if (_length_expr === undefined) {
        len = undefined;
      } else {
        const _Some = _length_expr;
        const _le = _Some;
        len = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(self, _le);
      }
      if (_name$12 === "*" || _name$12 === "@") {
        const values = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext45slice__positional__parameters__for__substring(self, offset, len);
        return _M0FP410Haoxincode8moonbash3lib11interpreter25join__values__with__space(values);
      }
      _L: {
        const _bind$10 = _M0FP410Haoxincode8moonbash3lib11interpreter29parse__array__reference__name(_name$12);
        if (_bind$10 === undefined) {
          break _L;
        } else {
          const _Some = _bind$10;
          const _x = _Some;
          const _base = _x._0;
          const _index_expr = _x._1;
          if (_index_expr === "@" || _index_expr === "*") {
            if (len === undefined) {
            } else {
              const _Some$2 = len;
              const _length = _Some$2;
              if (BigInt.asIntN(64, _length) < BigInt.asIntN(64, 0n)) {
                self.exit_code = 1;
                _M0MPB3Map3setGssE(self.env, "__MOON_BASH_ABORT_CURRENT_COMMAND__", "1");
                return "";
              }
            }
            const _p$4 = _M0MPB3Map3getGssE(self.env, `__MOON_BASH_ARRAY_KIND__${_base}`);
            const _p$5 = "";
            let _tmp$38;
            if (_p$4 === undefined) {
              _tmp$38 = _p$5;
            } else {
              const _p$6 = _p$4;
              _tmp$38 = _p$6;
            }
            if (_tmp$38 === "assoc") {
              self.exit_code = 1;
              self.should_exit = true;
              return "";
            } else {
              const sliced = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext41expand__indexed__array__substring__values(self, _base, offset, len);
              if (_index_expr === "*") {
                const _p$6 = _M0MPB3Map3getGssE(self.env, "IFS");
                const _p$7 = " \t\n";
                let _tmp$39;
                if (_p$6 === undefined) {
                  _tmp$39 = _p$7;
                } else {
                  const _p$8 = _p$6;
                  _tmp$39 = _p$8;
                }
                return _M0FP410Haoxincode8moonbash3lib11interpreter23join__values__with__ifs(sliced, _tmp$39);
              } else {
                return _M0FP410Haoxincode8moonbash3lib11interpreter25join__values__with__space(sliced);
              }
            }
          } else {
            break _L;
          }
        }
      }
      const value$5 = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16expand__variable(self, _name$12);
      return _M0FP410Haoxincode8moonbash3lib11interpreter25expand__scalar__substring(value$5, offset, len);
    }
    default: {
      const _Indirection = pe;
      const _name$13 = _Indirection._0;
      const _bind$10 = _M0FP410Haoxincode8moonbash3lib11interpreter30indirection__array__keys__name(_name$13);
      if (_bind$10 === undefined) {
        const _bind$11 = _M0FP410Haoxincode8moonbash3lib11interpreter25indirection__prefix__name(_name$13);
        if (_bind$11 === undefined) {
          const indirect_name = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16expand__variable(self, _name$13);
          return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16expand__variable(self, indirect_name);
        } else {
          const _Some = _bind$11;
          const _prefix = _Some;
          return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31expand__variables__with__prefix(self, _prefix);
        }
      } else {
        const _Some = _bind$10;
        const _base = _Some;
        return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19expand__array__keys(self, _base);
      }
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext40expand__param__word__for__split__context(self, word) {
  if (_M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32inside__double__quote__expansion(self) || _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27split__protection__disabled(self)) {
    return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24expand__word__to__string(self, word);
  }
  return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext37expand__word__with__split__protection(self, word);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext37expand__word__with__split__protection(self, word) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _bind$4 = word.parts;
  const _bind$5 = _bind$4.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$5) {
      const part = _bind$4[_];
      _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext43expand__word__part__with__split__protection(self, part));
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext43expand__word__part__with__split__protection(self, part) {
  switch (part.$tag) {
    case 0: {
      const _Literal = part;
      const _s = _Literal._0;
      return _M0FP410Haoxincode8moonbash3lib11interpreter36escape__split__protect__marker__only(_s);
    }
    case 1: {
      const _SingleQuoted = part;
      const _s$2 = _SingleQuoted._0;
      return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext36encode__word__split__protected__text(self, _s$2);
    }
    case 2: {
      const _DoubleQuoted = part;
      const _inner_parts = _DoubleQuoted._0;
      return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext36encode__word__split__protected__text(self, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext29expand__double__quoted__parts(self, _inner_parts));
    }
    default: {
      return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18expand__word__part(self, part);
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext25expand__simple__parameter(self, name) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter33parse__parameter__transform__name(name);
  if (_bind$4 === undefined) {
    return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16expand__variable(self, name);
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _base_name = _x._0;
    const _transform = _x._1;
    return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext28expand__parameter__transform(self, _base_name, _transform);
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext28expand__parameter__transform(self, base_name, transform) {
  const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter29parse__array__reference__name(base_name);
  if (_bind$4 === undefined) {
    const value = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16expand__variable(self, base_name);
    switch (transform) {
      case 81: {
        return _M0FP410Haoxincode8moonbash3lib11interpreter31quote__value__for__q__transform(value);
      }
      case 97: {
        return _M0MPB3Map8containsGssE(self.env, `__MOON_BASH_ARRAY_COUNT__${base_name}`) ? _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22array__attribute__flag(self, base_name) : "";
      }
      default: {
        return value;
      }
    }
  } else {
    const _Some = _bind$4;
    const _x = _Some;
    const _base = _x._0;
    const _index = _x._1;
    if (_index === "@" || _index === "*") {
      const values = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext35expand__array__elements__for__words(self, _base);
      const transformed = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24transform__array__values(self, _base, values, transform);
      if (_index === "*") {
        const _p$4 = _M0MPB3Map3getGssE(self.env, "IFS");
        const _p$5 = " \t\n";
        let _tmp$38;
        if (_p$4 === undefined) {
          _tmp$38 = _p$5;
        } else {
          const _p$6 = _p$4;
          _tmp$38 = _p$6;
        }
        return _M0FP410Haoxincode8moonbash3lib11interpreter23join__values__with__ifs(transformed, _tmp$38);
      } else {
        return _M0FP410Haoxincode8moonbash3lib11interpreter25join__values__with__space(transformed);
      }
    } else {
      return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16expand__variable(self, base_name);
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19arith__parse__comma(self, p, execute) {
  let result = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24arith__parse__assignment(self, p, execute);
  while (true) {
    if (_M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser10match__tok(p, ",")) {
      result = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24arith__parse__assignment(self, p, execute);
      continue;
    } else {
      break;
    }
  }
  return result;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24arith__parse__assignment(self, p, execute) {
  const left = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21arith__parse__ternary(self, p, execute);
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser4peek(p);
  let op;
  if (_bind$4 === undefined) {
    return left;
  } else {
    const _Some = _bind$4;
    op = _Some;
  }
  if (!_M0FP410Haoxincode8moonbash3lib11interpreter25arith__is__assignment__op(op)) {
    return left;
  }
  _M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser7advance(p);
  const right = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24arith__parse__assignment(self, p, execute);
  let newv;
  switch (op) {
    case "=": {
      newv = right.value;
      break;
    }
    case "+=": {
      newv = BigInt.asUintN(64, left.value + right.value);
      break;
    }
    case "-=": {
      newv = BigInt.asUintN(64, left.value - right.value);
      break;
    }
    case "*=": {
      newv = BigInt.asUintN(64, left.value * right.value);
      break;
    }
    case "/=": {
      if (BigInt.asUintN(64, right.value) === BigInt.asUintN(64, 0n)) {
        newv = 0n;
      } else {
        const _tmp$38 = right.value;
        if (_tmp$38 === 0n) {
          $panic();
        }
        newv = BigInt.asUintN(64, BigInt.asIntN(64, left.value) / BigInt.asIntN(64, _tmp$38));
      }
      break;
    }
    case "%=": {
      if (BigInt.asUintN(64, right.value) === BigInt.asUintN(64, 0n)) {
        newv = 0n;
      } else {
        const _tmp$38 = right.value;
        if (_tmp$38 === 0n) {
          $panic();
        }
        newv = BigInt.asUintN(64, BigInt.asIntN(64, left.value) % BigInt.asIntN(64, _tmp$38));
      }
      break;
    }
    case "&=": {
      newv = BigInt.asUintN(64, left.value & right.value);
      break;
    }
    case "|=": {
      newv = BigInt.asUintN(64, left.value | right.value);
      break;
    }
    case "^=": {
      newv = BigInt.asUintN(64, left.value ^ right.value);
      break;
    }
    case "<<=": {
      newv = _M0FP410Haoxincode8moonbash3lib11interpreter18arith__shift__left(left.value, right.value);
      break;
    }
    case ">>=": {
      newv = _M0FP410Haoxincode8moonbash3lib11interpreter19arith__shift__right(left.value, right.value);
      break;
    }
    default: {
      newv = right.value;
    }
  }
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18arith__set__target(self, left.target, newv, execute);
  return _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(newv);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21arith__parse__ternary(self, p, execute) {
  const cond = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19arith__parse__logor(self, p, execute);
  if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser10match__tok(p, "?")) {
    return cond;
  }
  if (BigInt.asUintN(64, cond.value) !== BigInt.asUintN(64, 0n)) {
    const then_v = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19arith__parse__comma(self, p, execute);
    if (_M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser10match__tok(p, ":")) {
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21arith__parse__ternary(self, p, false);
    }
    return _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(then_v.value);
  } else {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19arith__parse__comma(self, p, false);
    if (_M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser10match__tok(p, ":")) {
      const else_v = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21arith__parse__ternary(self, p, execute);
      return _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(else_v.value);
    } else {
      return _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(0n);
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19arith__parse__logor(self, p, execute) {
  let left = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20arith__parse__logand(self, p, execute);
  while (true) {
    if (_M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser10match__tok(p, "||")) {
      if (BigInt.asUintN(64, left.value) !== BigInt.asUintN(64, 0n)) {
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20arith__parse__logand(self, p, false);
        left = _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(1n);
      } else {
        const right = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20arith__parse__logand(self, p, execute);
        left = _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(BigInt.asUintN(64, right.value) !== BigInt.asUintN(64, 0n) ? 1n : 0n);
      }
      continue;
    } else {
      break;
    }
  }
  return left;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20arith__parse__logand(self, p, execute) {
  let left = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19arith__parse__bitor(self, p, execute);
  while (true) {
    if (_M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser10match__tok(p, "&&")) {
      if (BigInt.asUintN(64, left.value) !== BigInt.asUintN(64, 0n)) {
        const right = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19arith__parse__bitor(self, p, execute);
        left = _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(BigInt.asUintN(64, right.value) !== BigInt.asUintN(64, 0n) ? 1n : 0n);
      } else {
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19arith__parse__bitor(self, p, false);
        left = _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(0n);
      }
      continue;
    } else {
      break;
    }
  }
  return left;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19arith__parse__bitor(self, p, execute) {
  let left = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20arith__parse__bitxor(self, p, execute);
  while (true) {
    if (_M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser10match__tok(p, "|")) {
      const right = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20arith__parse__bitxor(self, p, execute);
      left = _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(BigInt.asUintN(64, left.value | right.value));
      continue;
    } else {
      break;
    }
  }
  return left;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20arith__parse__bitxor(self, p, execute) {
  let left = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20arith__parse__bitand(self, p, execute);
  while (true) {
    if (_M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser10match__tok(p, "^")) {
      const right = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20arith__parse__bitand(self, p, execute);
      left = _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(BigInt.asUintN(64, left.value ^ right.value));
      continue;
    } else {
      break;
    }
  }
  return left;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext20arith__parse__bitand(self, p, execute) {
  let left = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16arith__parse__eq(self, p, execute);
  while (true) {
    if (_M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser10match__tok(p, "&")) {
      const right = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16arith__parse__eq(self, p, execute);
      left = _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(BigInt.asUintN(64, left.value & right.value));
      continue;
    } else {
      break;
    }
  }
  return left;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext16arith__parse__eq(self, p, execute) {
  let left = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17arith__parse__rel(self, p, execute);
  while (true) {
    const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser4peek(p);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _op = _Some;
      if (_op === "==" || _op === "!=") {
        _M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser7advance(p);
        const right = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17arith__parse__rel(self, p, execute);
        const contains_bare_array = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext30arith__target__is__bare__array(self, left.target) || _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext30arith__target__is__bare__array(self, right.target);
        const ok = contains_bare_array ? false : _op === "==" ? BigInt.asUintN(64, left.value) === BigInt.asUintN(64, right.value) : BigInt.asUintN(64, left.value) !== BigInt.asUintN(64, right.value);
        left = _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(ok ? 1n : 0n);
      } else {
        break;
      }
    }
    continue;
  }
  return left;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17arith__parse__rel(self, p, execute) {
  let left = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19arith__parse__shift(self, p, execute);
  while (true) {
    const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser4peek(p);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _op = _Some;
      if (_op === "<" || (_op === "<=" || (_op === ">" || _op === ">="))) {
        _M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser7advance(p);
        const right = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19arith__parse__shift(self, p, execute);
        const ok = _op === "<" ? BigInt.asIntN(64, left.value) < BigInt.asIntN(64, right.value) : _op === "<=" ? BigInt.asIntN(64, left.value) <= BigInt.asIntN(64, right.value) : _op === ">" ? BigInt.asIntN(64, left.value) > BigInt.asIntN(64, right.value) : BigInt.asIntN(64, left.value) >= BigInt.asIntN(64, right.value);
        left = _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(ok ? 1n : 0n);
      } else {
        break;
      }
    }
    continue;
  }
  return left;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19arith__parse__shift(self, p, execute) {
  let left = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17arith__parse__add(self, p, execute);
  while (true) {
    const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser4peek(p);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _op = _Some;
      if (_op === "<<" || _op === ">>") {
        _M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser7advance(p);
        const right = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17arith__parse__add(self, p, execute);
        const value = _op === "<<" ? _M0FP410Haoxincode8moonbash3lib11interpreter18arith__shift__left(left.value, right.value) : _M0FP410Haoxincode8moonbash3lib11interpreter19arith__shift__right(left.value, right.value);
        left = _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(value);
      } else {
        break;
      }
    }
    continue;
  }
  return left;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17arith__parse__add(self, p, execute) {
  let left = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17arith__parse__mul(self, p, execute);
  while (true) {
    const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser4peek(p);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _op = _Some;
      if (_op === "+" || _op === "-") {
        _M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser7advance(p);
        const right = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17arith__parse__mul(self, p, execute);
        const value = _op === "+" ? BigInt.asUintN(64, left.value + right.value) : BigInt.asUintN(64, left.value - right.value);
        left = _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(value);
      } else {
        break;
      }
    }
    continue;
  }
  return left;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17arith__parse__mul(self, p, execute) {
  let left = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17arith__parse__pow(self, p, execute);
  while (true) {
    const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser4peek(p);
    if (_bind$4 === undefined) {
      break;
    } else {
      const _Some = _bind$4;
      const _op = _Some;
      if (_op === "*" || (_op === "/" || _op === "%")) {
        _M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser7advance(p);
        const right = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17arith__parse__pow(self, p, execute);
        let value;
        switch (_op) {
          case "*": {
            value = BigInt.asUintN(64, left.value * right.value);
            break;
          }
          case "/": {
            if (BigInt.asUintN(64, right.value) === BigInt.asUintN(64, 0n)) {
              value = 0n;
            } else {
              const _tmp$38 = right.value;
              if (_tmp$38 === 0n) {
                $panic();
              }
              value = BigInt.asUintN(64, BigInt.asIntN(64, left.value) / BigInt.asIntN(64, _tmp$38));
            }
            break;
          }
          case "%": {
            if (BigInt.asUintN(64, right.value) === BigInt.asUintN(64, 0n)) {
              value = 0n;
            } else {
              const _tmp$38 = right.value;
              if (_tmp$38 === 0n) {
                $panic();
              }
              value = BigInt.asUintN(64, BigInt.asIntN(64, left.value) % BigInt.asIntN(64, _tmp$38));
            }
            break;
          }
          default: {
            value = left.value;
          }
        }
        left = _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(value);
      } else {
        break;
      }
    }
    continue;
  }
  return left;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext17arith__parse__pow(self, p, execute) {
  let left = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19arith__parse__unary(self, p, execute);
  while (true) {
    if (_M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser10match__tok(p, "**")) {
      const right = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19arith__parse__unary(self, p, execute);
      if (BigInt.asIntN(64, right.value) < BigInt.asIntN(64, 0n)) {
        self.exit_code = 1;
        _M0MPB3Map3setGssE(self.env, "__MOON_BASH_ABORT_CURRENT_COMMAND__", "1");
        return _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(0n);
      }
      left = _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(_M0FP410Haoxincode8moonbash3lib11interpreter8int__pow(left.value, right.value));
      continue;
    } else {
      break;
    }
  }
  return left;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19arith__parse__unary(self, p, execute) {
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser4peek(p);
  if (_bind$4 === undefined) {
    return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21arith__parse__postfix(self, p, execute);
  } else {
    const _Some = _bind$4;
    const _op = _Some;
    if (_op === "+" || (_op === "-" || (_op === "!" || (_op === "~" || (_op === "++" || _op === "--"))))) {
      _M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser7advance(p);
      const operand = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19arith__parse__unary(self, p, execute);
      switch (_op) {
        case "+": {
          return _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(operand.value);
        }
        case "-": {
          return _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(BigInt.asUintN(64, -operand.value));
        }
        case "!": {
          return _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(BigInt.asUintN(64, operand.value) === BigInt.asUintN(64, 0n) ? 1n : 0n);
        }
        case "~": {
          return _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(BigInt.asUintN(64, BigInt.asUintN(64, -operand.value) - 1n));
        }
        case "++": {
          const newv = BigInt.asUintN(64, operand.value + 1n);
          const _bind$5 = operand.target;
          if (_bind$5.$tag === 0) {
            return _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(operand.value);
          } else {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18arith__set__target(self, operand.target, newv, execute);
            return _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(newv);
          }
        }
        case "--": {
          const newv$2 = BigInt.asUintN(64, operand.value - 1n);
          const _bind$6 = operand.target;
          if (_bind$6.$tag === 0) {
            return _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(operand.value);
          } else {
            _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18arith__set__target(self, operand.target, newv$2, execute);
            return _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(newv$2);
          }
        }
        default: {
          return _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(operand.value);
        }
      }
    } else {
      return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21arith__parse__postfix(self, p, execute);
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21arith__parse__postfix(self, p, execute) {
  let value = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21arith__parse__primary(self, p, execute);
  while (true) {
    if (_M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser10match__tok(p, "++")) {
      const old = value.value;
      const newv = BigInt.asUintN(64, old + 1n);
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18arith__set__target(self, value.target, newv, execute);
      value = _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(old);
      continue;
    }
    if (_M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser10match__tok(p, "--")) {
      const old = value.value;
      const newv = BigInt.asUintN(64, old - 1n);
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18arith__set__target(self, value.target, newv, execute);
      value = _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(old);
      continue;
    }
    break;
  }
  return value;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext21arith__parse__primary(self, p, execute) {
  const _bind$4 = _M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser4peek(p);
  if (_bind$4 === undefined) {
    return _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(0n);
  } else {
    const _Some = _bind$4;
    const _tok = _Some;
    if (_tok === "(") {
      _M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser7advance(p);
      const result = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19arith__parse__comma(self, p, execute);
      _M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser10match__tok(p, ")");
      return _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(result.value);
    }
    _M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser7advance(p);
    if (_M0FP410Haoxincode8moonbash3lib11interpreter27arith__is__identifier__text(_tok)) {
      if (_M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser10match__tok(p, "[")) {
        const idx_expr = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext19arith__parse__comma(self, p, execute);
        if (!_M0MP410Haoxincode8moonbash3lib11interpreter11ArithParser10match__tok(p, "]")) {
          _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11arith__fail(self);
          return _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(0n);
        }
        const idx = idx_expr.value;
        const value = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext23arith__get__array__elem(self, _tok, idx);
        return _M0FP410Haoxincode8moonbash3lib11interpreter19arith__with__target(value, new _M0DTP410Haoxincode8moonbash3lib11interpreter11ArithTarget9ArrayElem(_tok, idx));
      }
      const value = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22arith__get__var__value(self, _tok);
      return _M0FP410Haoxincode8moonbash3lib11interpreter19arith__with__target(value, new _M0DTP410Haoxincode8moonbash3lib11interpreter11ArithTarget3Var(_tok));
    }
    const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter29arith__parse__number__literal(_tok);
    if (_bind$5 === undefined) {
      _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11arith__fail(self);
      return _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(0n);
    } else {
      const _Some$2 = _bind$5;
      const _v = _Some$2;
      return _M0FP410Haoxincode8moonbash3lib11interpreter12arith__plain(_v);
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext32expand__word__parts__with__brace(self, parts) {
  let has_quoted_part = false;
  const placeholders = [];
  const template = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _bind$4 = parts.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const part = parts[_];
      _L: {
        _L$2: {
          switch (part.$tag) {
            case 0: {
              const _Literal = part;
              const _text = _Literal._0;
              _M0IPB13StringBuilderPB6Logger13write__string(template, _text);
              break;
            }
            case 1: {
              break _L$2;
            }
            case 2: {
              break _L$2;
            }
            default: {
              const idx = placeholders.length;
              _M0MPC15array5Array4pushGUssEE(placeholders, part);
              _M0IPB13StringBuilderPB6Logger13write__string(template, _M0FP410Haoxincode8moonbash3lib11interpreter25brace__placeholder__token(idx));
            }
          }
          break _L;
        }
        has_quoted_part = true;
        const idx = placeholders.length;
        _M0MPC15array5Array4pushGUssEE(placeholders, part);
        _M0IPB13StringBuilderPB6Logger13write__string(template, _M0FP410Haoxincode8moonbash3lib11interpreter25brace__placeholder__token(idx));
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter22expand__brace__literal(template.val);
  const _brace_candidates = _bind$5._0;
  const _brace_syntax_error = _bind$5._1;
  if (_brace_syntax_error) {
    self.exit_code = 2;
    self.should_exit = true;
    return [""];
  }
  const _bind$6 = _M0FP410Haoxincode8moonbash3lib11interpreter36find__first__expandable__brace__pair(template.val);
  const had_expandable_brace = !(_bind$6 === undefined);
  const expanded_candidates = [];
  const _bind$7 = _brace_candidates.length;
  let _tmp$39 = 0;
  while (true) {
    const _ = _tmp$39;
    if (_ < _bind$7) {
      const candidate = _brace_candidates[_];
      const resolved = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext44expand__brace__candidate__with__placeholders(self, candidate, placeholders, had_expandable_brace);
      if (self.should_exit) {
        return [""];
      }
      const maybe_tilde = had_expandable_brace ? _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext27expand__tilde__after__brace(self, resolved) : resolved;
      if (maybe_tilde.length > self.limits.max_string_length) {
        _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext22fail__execution__limit(self, "string length limit exceeded");
        return [""];
      }
      _M0MPC15array5Array4pushGUssEE(expanded_candidates, maybe_tilde);
      _tmp$39 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (!had_expandable_brace) {
    return expanded_candidates;
  }
  const normalized_candidates = [];
  const _bind$8 = expanded_candidates.length;
  let _tmp$40 = 0;
  while (true) {
    const _ = _tmp$40;
    if (_ < _bind$8) {
      const candidate = expanded_candidates[_];
      _L: {
        if (candidate.length === 0 && !has_quoted_part) {
          break _L;
        }
        _M0MPC15array5Array4pushGUssEE(normalized_candidates, candidate);
        break _L;
      }
      _tmp$40 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (normalized_candidates.length === 0 && has_quoted_part) {
    return [""];
  }
  return expanded_candidates.length === 0 ? [""] : normalized_candidates;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext44expand__brace__candidate__with__placeholders(self, candidate, placeholders, defer_tilde_expansion) {
  const out = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let i = 0;
  while (true) {
    if (i < candidate.length) {
      const _tmp$38 = i;
      $bound_check(candidate, _tmp$38);
      if (candidate.charCodeAt(_tmp$38) === 29) {
        let j = i + 1 | 0;
        while (true) {
          let _tmp$39;
          if (j < candidate.length) {
            const _tmp$40 = j;
            $bound_check(candidate, _tmp$40);
            _tmp$39 = candidate.charCodeAt(_tmp$40) !== 30;
          } else {
            _tmp$39 = false;
          }
          if (_tmp$39) {
            j = j + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        if (j < candidate.length) {
          const token = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(candidate, i + 1 | 0, j));
          const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter32parse__brace__placeholder__index(token);
          if (_bind$4 === undefined) {
          } else {
            const _Some = _bind$4;
            const _idx = _Some;
            if (_idx >= 0 && _idx < placeholders.length) {
              const _bind$5 = _M0MPC15array5Array2atGUssEE(placeholders, _idx);
              if (_bind$5.$tag === 8) {
                const _TildePrefix = _bind$5;
                const _user = _TildePrefix._0;
                if (defer_tilde_expansion) {
                  _M0IPB13StringBuilderPB6Logger11write__char(out, 126);
                  _M0IPB13StringBuilderPB6Logger13write__string(out, _user);
                } else {
                  _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18expand__word__part(self, _M0MPC15array5Array2atGUssEE(placeholders, _idx)));
                }
              } else {
                _M0IPB13StringBuilderPB6Logger13write__string(out, _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext18expand__word__part(self, _M0MPC15array5Array2atGUssEE(placeholders, _idx)));
              }
              i = j + 1 | 0;
              continue;
            }
          }
        }
      }
      const _tmp$39 = i;
      $bound_check(candidate, _tmp$39);
      _M0IPB13StringBuilderPB6Logger11write__char(out, candidate.charCodeAt(_tmp$39));
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return out.val;
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext26store__indexed__assignment(self, name, values, append) {
  if (!append) {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24store__array__assignment(self, name, []);
  } else {
    _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext39seed__indexed__assignment__from__scalar(self, name);
  }
  let next_index = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext31next__indexed__assignment__seed(self, name, append);
  const _bind$4 = values.length;
  let _tmp$38 = 0;
  while (true) {
    const _ = _tmp$38;
    if (_ < _bind$4) {
      const token = values[_];
      const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter41parse__array__assignment__explicit__entry(token);
      if (_bind$5 === undefined) {
        const storage_key = `${name}[${_M0MPC13int3Int18to__string_2einner(next_index, 10)}]`;
        const normalized = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext38normalize__compound__assignment__value(self, token);
        _M0MPB3Map3setGssE(self.env, storage_key, normalized);
        next_index = next_index + 1 | 0;
      } else {
        const _Some = _bind$5;
        const _x = _Some;
        const _raw_index = _x._0;
        const _value = _x._1;
        const _append_mode = _x._2;
        const index = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33parse__indexed__assignment__index(self, _raw_index);
        const storage_key = `${name}[${_M0MPC13int3Int18to__string_2einner(index, 10)}]`;
        const normalized = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext38normalize__compound__assignment__value(self, _value);
        if (_append_mode) {
          const _tmp$39 = self.env;
          const _p$4 = _M0MPB3Map3getGssE(self.env, storage_key);
          const _p$5 = "";
          let _tmp$40;
          if (_p$4 === undefined) {
            _tmp$40 = _p$5;
          } else {
            const _p$6 = _p$4;
            _tmp$40 = _p$6;
          }
          _M0MPB3Map3setGssE(_tmp$39, storage_key, `${_tmp$40}${normalized}`);
        } else {
          _M0MPB3Map3setGssE(self.env, storage_key, normalized);
        }
        next_index = index + 1 | 0;
      }
      _tmp$38 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext24refresh__array__metadata(self, name);
  _M0MPB3Map3setGssE(self.env, `__MOON_BASH_ARRAY_KIND__${name}`, "indexed");
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33parse__indexed__assignment__index(self, raw_index) {
  let _tmp$38 = raw_index;
  while (true) {
    const raw_index$2 = _tmp$38;
    const _bind$4 = _M0FP410Haoxincode8moonbash3lib11interpreter29parse__array__reference__name(raw_index$2);
    if (_bind$4 === undefined) {
    } else {
      const _Some = _bind$4;
      const _x = _Some;
      const _base = _x._0;
      const _index_expr = _x._1;
      const resolved = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext33expand__array__element__reference(self, _base, _index_expr);
      if (self.should_exit) {
        return 0;
      }
      const next_raw = resolved.length > 0 ? resolved : "0";
      if (!(next_raw === raw_index$2)) {
        _tmp$38 = next_raw;
        continue;
      }
    }
    const _bind$5 = _M0FP410Haoxincode8moonbash3lib11interpreter36parse__non__negative__int__for__sort(raw_index$2);
    if (_bind$5 === undefined) {
      const evaluated = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11eval__arith(self, new _M0DTP410Haoxincode8moonbash3lib3ast9ArithExpr3Raw(raw_index$2));
      return BigInt.asIntN(64, evaluated) <= BigInt.asIntN(64, 0n) ? 0 : BigInt.asIntN(64, evaluated) > BigInt.asIntN(64, 2147483647n) ? 2147483647 : Number(BigInt.asIntN(32, evaluated)) | 0;
    } else {
      const _Some = _bind$5;
      return _Some;
    }
  }
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11new_2einner(fs, env, cwd, limits) {
  const _bind$4 = [];
  const default_env = _M0MPB3Map3MapGssE(new _M0TPB9ArrayViewGUssEE(_bind$4, 0, 0), undefined);
  const _bind$5 = [];
  const default_exported = _M0MPB3Map3MapGsbE(new _M0TPB9ArrayViewGUsbEE(_bind$5, 0, 0), undefined);
  _M0MPB3Map3setGssE(default_env, "HOME", "/home/user");
  _M0MPB3Map3setGssE(default_env, "PATH", "/usr/bin:/bin");
  _M0MPB3Map3setGssE(default_env, "USER", "user");
  _M0MPB3Map3setGssE(default_env, "PWD", cwd);
  _M0MPB3Map3setGssE(default_env, "IFS", " \t\n");
  _M0MPB3Map3setGssE(default_env, "SHELL", "/bin/bash");
  _M0MPB3Map3setGssE(default_env, "BASH_VERSION", "5.1.0(1)-release");
  const _it = _M0MPB3Map5iter2GssE(default_env);
  while (true) {
    const _bind$6 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$6 === undefined) {
      break;
    } else {
      const _Some = _bind$6;
      const _x = _Some;
      const _k = _x._0;
      _M0MPB3Map3setGsbE(default_exported, _k, true);
      continue;
    }
  }
  const _it$2 = _M0MPB3Map5iter2GssE(env);
  while (true) {
    const _bind$6 = _M0MPB5Iter24nextGssE(_it$2);
    if (_bind$6 === undefined) {
      break;
    } else {
      const _Some = _bind$6;
      const _x = _Some;
      const _k = _x._0;
      const _v = _x._1;
      _M0MPB3Map3setGssE(default_env, _k, _v);
      _M0MPB3Map3setGsbE(default_exported, _k, true);
      continue;
    }
  }
  const _p$4 = _M0MPB3Map3getGssE(default_env, "__MOON_BASH_STDIN");
  const _p$5 = "";
  let initial_stdin;
  if (_p$4 === undefined) {
    initial_stdin = _p$5;
  } else {
    const _p$6 = _p$4;
    initial_stdin = _p$6;
  }
  _M0MPB3Map6removeGssE(default_env, "__MOON_BASH_STDIN");
  const _bind$6 = [];
  return new _M0TP410Haoxincode8moonbash3lib11interpreter11ExecContext(default_env, default_exported, cwd, _M0MPB3Map3MapGsRP410Haoxincode8moonbash3lib3ast11FunctionDefE(new _M0TPB9ArrayViewGUsRP410Haoxincode8moonbash3lib3ast11FunctionDefEE(_bind$6, 0, 0), undefined), _M0MP410Haoxincode8moonbash3lib3ast12ShellOptions7default(), initial_stdin, _M0MPB13StringBuilder21StringBuilder_2einner(0), _M0MPB13StringBuilder21StringBuilder_2einner(0), 0, false, 0, 0, 0, false, limits, 0, 0, 0, 0, fs, "");
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext3new(fs, env$46$opt, cwd$46$opt, limits$46$opt) {
  let env;
  if (env$46$opt === undefined) {
    const _bind$4 = [];
    env = _M0MPB3Map3MapGssE(new _M0TPB9ArrayViewGUssEE(_bind$4, 0, 0), undefined);
  } else {
    const _Some = env$46$opt;
    env = _Some;
  }
  let cwd;
  if (cwd$46$opt === undefined) {
    cwd = "/home/user";
  } else {
    const _Some = cwd$46$opt;
    cwd = _Some;
  }
  let limits;
  if (limits$46$opt === undefined) {
    limits = _M0MP410Haoxincode8moonbash3lib3ast15ExecutionLimits7defaultN6recordS779;
  } else {
    const _Some = limits$46$opt;
    limits = _Some;
  }
  return _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11new_2einner(fs, env, cwd, limits);
}
function _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext7execute(self, script) {
  self.stdout_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  self.stderr_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  self.should_exit = false;
  self.return_requested = false;
  self.substitution_depth = 0;
  self.glob_operations = 0;
  self.current_script = script;
  let parsed;
  let _try_err;
  _L: {
    _L$2: {
      const _bind$4 = _M0FP410Haoxincode8moonbash3lib6parser5parse(script);
      if (_bind$4.$tag === 1) {
        const _ok = _bind$4;
        parsed = _ok._0;
      } else {
        const _err = _bind$4;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    const _BashError = _try_err;
    const _msg = _BashError._0;
    return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner("", `syntax error: ${_msg}\n`, 2);
  }
  _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext15execute__script(self, parsed);
  const _p$4 = self.stdout_buf;
  const _tmp$38 = _p$4.val;
  const _p$5 = self.stderr_buf;
  return _M0MP410Haoxincode8moonbash3lib3ast10ExecResult11new_2einner(_tmp$38, _p$5.val, self.exit_code);
}
function _M0FP410Haoxincode8moonbash3lib5entry10hex__digit(n) {
  return n < 10 ? n + 48 | 0 : (n - 10 | 0) + 97 | 0;
}
function _M0FP410Haoxincode8moonbash3lib5entry20json__escape__string(s) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger11write__char(buf, 34);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < s.length) {
      $bound_check(s, i);
      const ch = s.charCodeAt(i);
      switch (ch) {
        case 34: {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\\"");
          break;
        }
        case 92: {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\\\");
          break;
        }
        case 10: {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\n");
          break;
        }
        case 13: {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\r");
          break;
        }
        case 9: {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\t");
          break;
        }
        default: {
          const code = ch;
          if (code < 32) {
            _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\u00");
            const hi = code / 16 | 0;
            const lo = code % 16 | 0;
            _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0FP410Haoxincode8moonbash3lib5entry10hex__digit(hi));
            _M0IPB13StringBuilderPB6Logger11write__char(buf, _M0FP410Haoxincode8moonbash3lib5entry10hex__digit(lo));
          } else {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
          }
        }
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger11write__char(buf, 34);
  return buf.val;
}
function _M0FP410Haoxincode8moonbash3lib5entry16result__to__json(result) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger13write__string(buf, "{\"stdout\":");
  _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FP410Haoxincode8moonbash3lib5entry20json__escape__string(result.stdout));
  _M0IPB13StringBuilderPB6Logger13write__string(buf, ",\"stderr\":");
  _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FP410Haoxincode8moonbash3lib5entry20json__escape__string(result.stderr));
  _M0IPB13StringBuilderPB6Logger13write__string(buf, ",\"exitCode\":");
  _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0MPC13int3Int18to__string_2einner(result.exit_code, 10));
  _M0IPB13StringBuilderPB6Logger13write__string(buf, "}");
  return buf.val;
}
function _M0FP410Haoxincode8moonbash3lib5entry7execute(script) {
  const fs = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs3new();
  const ctx = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext3new(fs, undefined, undefined, undefined);
  const result = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext7execute(ctx, script);
  return _M0FP410Haoxincode8moonbash3lib5entry16result__to__json(result);
}
function _M0FP410Haoxincode8moonbash3lib5entry15ensure__parents(fs, path) {
  const parts = [];
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < path.length) {
      $bound_check(path, i);
      const ch = path.charCodeAt(i);
      if (ch === 47) {
        const s = buf.val;
        if (s.length > 0) {
          _M0MPC15array5Array4pushGUssEE(parts, s);
        }
        _M0MPB13StringBuilder5reset(buf);
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const dir_buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < parts.length) {
      _M0IPB13StringBuilderPB6Logger11write__char(dir_buf, 47);
      _M0IPB13StringBuilderPB6Logger13write__string(dir_buf, _M0MPC15array5Array2atGUssEE(parts, i));
      const dir_path = dir_buf.val;
      if (!_M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs6exists(fs, dir_path)) {
        let _try_err;
        _L: {
          _L$2: {
            const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs13mkdir_2einner(fs, dir_path, false);
            if (_bind$4.$tag === 1) {
              const _ok = _bind$4;
              _ok._0;
            } else {
              const _err = _bind$4;
              _try_err = _err._0;
              break _L$2;
            }
            break _L;
          }
        }
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0FP410Haoxincode8moonbash3lib5entry12starts__with(prefix_target, prefix) {
  if (prefix.length > prefix_target.length) {
    return false;
  }
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < prefix.length) {
      $bound_check(prefix_target, i);
      const _p$4 = prefix_target.charCodeAt(i);
      $bound_check(prefix, i);
      const _p$5 = prefix.charCodeAt(i);
      if (_p$4 !== _p$5) {
        return false;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return true;
}
function _M0FP410Haoxincode8moonbash3lib5entry25needs__home__user__layout(file_entries, dir_entries, link_entries, cwd) {
  if (_M0FP410Haoxincode8moonbash3lib5entry12starts__with(cwd, "/home/user")) {
    return true;
  }
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < file_entries.length) {
      const _bind$4 = _M0MPC15array5Array2atGUssEE(file_entries, i);
      const _path = _bind$4._0;
      if (_M0FP410Haoxincode8moonbash3lib5entry12starts__with(_path, "/home/user")) {
        return true;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < dir_entries.length) {
      const _bind$4 = _M0MPC15array5Array2atGUssEE(dir_entries, i);
      const _path = _bind$4._0;
      if (_M0FP410Haoxincode8moonbash3lib5entry12starts__with(_path, "/home/user")) {
        return true;
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let _tmp$40 = 0;
  while (true) {
    const i = _tmp$40;
    if (i < link_entries.length) {
      const _bind$4 = _M0MPC15array5Array2atGUssEE(link_entries, i);
      const _path = _bind$4._0;
      if (_M0FP410Haoxincode8moonbash3lib5entry12starts__with(_path, "/home/user")) {
        return true;
      }
      _tmp$40 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return false;
}
function _M0FP410Haoxincode8moonbash3lib5entry19parse__decimal__int(s) {
  let value = 0;
  let sign = 1;
  let i = 0;
  let _tmp$38;
  if (s.length > 0) {
    $bound_check(s, 0);
    _tmp$38 = s.charCodeAt(0) === 45;
  } else {
    _tmp$38 = false;
  }
  if (_tmp$38) {
    sign = -1;
    i = 1;
  }
  while (true) {
    if (i < s.length) {
      const _tmp$39 = i;
      $bound_check(s, _tmp$39);
      const ch = s.charCodeAt(_tmp$39);
      if (ch < 48 || ch > 57) {
        break;
      }
      value = (Math.imul(value, 10) | 0) + (ch - 48 | 0) | 0;
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return Math.imul(value, sign) | 0;
}
function _M0FP410Haoxincode8moonbash3lib5entry16json__hex__value(ch) {
  return ch >= 48 && ch <= 57 ? ch - 48 | 0 : ch >= 97 && ch <= 102 ? (ch - 97 | 0) + 10 | 0 : ch >= 65 && ch <= 70 ? (ch - 65 | 0) + 10 | 0 : -1;
}
function _M0FP410Haoxincode8moonbash3lib5entry19parse__json__string(json, start) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const len = json.length;
  let i = start + 1 | 0;
  while (true) {
    if (i < len) {
      const _tmp$38 = i;
      $bound_check(json, _tmp$38);
      const ch = json.charCodeAt(_tmp$38);
      if (ch === 34) {
        return { _0: buf.val, _1: i + 1 | 0 };
      }
      if (ch === 92 && (i + 1 | 0) < len) {
        i = i + 1 | 0;
        const _tmp$39 = i;
        $bound_check(json, _tmp$39);
        const esc = json.charCodeAt(_tmp$39);
        switch (esc) {
          case 110: {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 10);
            break;
          }
          case 114: {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 13);
            break;
          }
          case 116: {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 9);
            break;
          }
          case 34: {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 34);
            break;
          }
          case 92: {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
            break;
          }
          case 47: {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 47);
            break;
          }
          case 117: {
            if ((i + 4 | 0) < len) {
              const _tmp$40 = i + 1 | 0;
              $bound_check(json, _tmp$40);
              const d1 = _M0FP410Haoxincode8moonbash3lib5entry16json__hex__value(json.charCodeAt(_tmp$40));
              const _tmp$41 = i + 2 | 0;
              $bound_check(json, _tmp$41);
              const d2 = _M0FP410Haoxincode8moonbash3lib5entry16json__hex__value(json.charCodeAt(_tmp$41));
              const _tmp$42 = i + 3 | 0;
              $bound_check(json, _tmp$42);
              const d3 = _M0FP410Haoxincode8moonbash3lib5entry16json__hex__value(json.charCodeAt(_tmp$42));
              const _tmp$43 = i + 4 | 0;
              $bound_check(json, _tmp$43);
              const d4 = _M0FP410Haoxincode8moonbash3lib5entry16json__hex__value(json.charCodeAt(_tmp$43));
              if (d1 >= 0 && (d2 >= 0 && (d3 >= 0 && d4 >= 0))) {
                const code = (((Math.imul(d1, 4096) | 0) + (Math.imul(d2, 256) | 0) | 0) + (Math.imul(d3, 16) | 0) | 0) + d4 | 0;
                _M0IPB13StringBuilderPB6Logger11write__char(buf, code);
                i = i + 4 | 0;
              } else {
                _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
                _M0IPB13StringBuilderPB6Logger11write__char(buf, esc);
              }
            } else {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
              _M0IPB13StringBuilderPB6Logger11write__char(buf, esc);
            }
            break;
          }
          default: {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
            _M0IPB13StringBuilderPB6Logger11write__char(buf, esc);
          }
        }
      } else {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, ch);
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return { _0: buf.val, _1: i };
}
function _M0FP410Haoxincode8moonbash3lib5entry19parse__json__object(json) {
  const result = [];
  const len = json.length;
  if (len < 2) {
    return result;
  }
  let i = 0;
  while (true) {
    if (i < len) {
      const _tmp$38 = i;
      $bound_check(json, _tmp$38);
      const ch = json.charCodeAt(_tmp$38);
      if (ch === 123) {
        i = i + 1 | 0;
        break;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (i < len) {
      while (true) {
        if (i < len) {
          const _tmp$38 = i;
          $bound_check(json, _tmp$38);
          const ch = json.charCodeAt(_tmp$38);
          if (ch === 32 || (ch === 9 || (ch === 10 || ch === 13))) {
            i = i + 1 | 0;
          } else {
            break;
          }
          continue;
        } else {
          break;
        }
      }
      if (i >= len) {
        break;
      }
      const _tmp$38 = i;
      $bound_check(json, _tmp$38);
      const ch = json.charCodeAt(_tmp$38);
      if (ch === 125) {
        break;
      }
      if (ch === 44) {
        i = i + 1 | 0;
        continue;
      }
      if (ch === 34) {
        const _bind$4 = _M0FP410Haoxincode8moonbash3lib5entry19parse__json__string(json, i);
        const _key = _bind$4._0;
        const _next_i = _bind$4._1;
        i = _next_i;
        while (true) {
          if (i < len) {
            const _tmp$39 = i;
            $bound_check(json, _tmp$39);
            const c = json.charCodeAt(_tmp$39);
            if (c === 58) {
              i = i + 1 | 0;
              break;
            }
            i = i + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        while (true) {
          if (i < len) {
            const _tmp$39 = i;
            $bound_check(json, _tmp$39);
            const c = json.charCodeAt(_tmp$39);
            if (c === 32 || (c === 9 || (c === 10 || c === 13))) {
              i = i + 1 | 0;
            } else {
              break;
            }
            continue;
          } else {
            break;
          }
        }
        let _tmp$39;
        if (i < len) {
          const _tmp$40 = i;
          $bound_check(json, _tmp$40);
          _tmp$39 = json.charCodeAt(_tmp$40) === 34;
        } else {
          _tmp$39 = false;
        }
        if (_tmp$39) {
          const _bind$5 = _M0FP410Haoxincode8moonbash3lib5entry19parse__json__string(json, i);
          const _value = _bind$5._0;
          const _next_i2 = _bind$5._1;
          i = _next_i2;
          _M0MPC15array5Array4pushGUssEE(result, { _0: _key, _1: _value });
        } else {
          while (true) {
            if (i < len) {
              const _tmp$40 = i;
              $bound_check(json, _tmp$40);
              const c = json.charCodeAt(_tmp$40);
              if (c === 44 || c === 125) {
                break;
              }
              i = i + 1 | 0;
              continue;
            } else {
              break;
            }
          }
        }
      } else {
        i = i + 1 | 0;
      }
      continue;
    } else {
      break;
    }
  }
  return result;
}
function _M0FP410Haoxincode8moonbash3lib5entry13parse__limits(limits_json) {
  const defaults = _M0MP410Haoxincode8moonbash3lib3ast15ExecutionLimits7defaultN6recordS779;
  let max_call_depth = defaults.max_call_depth;
  let max_command_count = defaults.max_command_count;
  let max_loop_iterations = defaults.max_loop_iterations;
  let max_string_length = defaults.max_string_length;
  let max_array_elements = defaults.max_array_elements;
  let max_heredoc_size = defaults.max_heredoc_size;
  let max_substitution_depth = defaults.max_substitution_depth;
  let max_glob_operations = defaults.max_glob_operations;
  let max_awk_iterations = defaults.max_awk_iterations;
  let max_sed_iterations = defaults.max_sed_iterations;
  let max_jq_iterations = defaults.max_jq_iterations;
  const entries = _M0FP410Haoxincode8moonbash3lib5entry19parse__json__object(limits_json);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < entries.length) {
      _L: {
        const _bind$4 = _M0MPC15array5Array2atGUssEE(entries, i);
        const _key = _bind$4._0;
        const _value = _bind$4._1;
        const parsed = _M0FP410Haoxincode8moonbash3lib5entry19parse__decimal__int(_value);
        if (parsed <= 0) {
          break _L;
        }
        switch (_key) {
          case "max_call_depth": {
            max_call_depth = parsed;
            break;
          }
          case "max_command_count": {
            max_command_count = parsed;
            break;
          }
          case "max_loop_iterations": {
            max_loop_iterations = parsed;
            break;
          }
          case "max_string_length": {
            max_string_length = parsed;
            break;
          }
          case "max_array_elements": {
            max_array_elements = parsed;
            break;
          }
          case "max_heredoc_size": {
            max_heredoc_size = parsed;
            break;
          }
          case "max_substitution_depth": {
            max_substitution_depth = parsed;
            break;
          }
          case "max_glob_operations": {
            max_glob_operations = parsed;
            break;
          }
          case "max_awk_iterations": {
            max_awk_iterations = parsed;
            break;
          }
          case "max_sed_iterations": {
            max_sed_iterations = parsed;
            break;
          }
          case "max_jq_iterations": {
            max_jq_iterations = parsed;
            break;
          }
        }
        break _L;
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return new _M0TP410Haoxincode8moonbash3lib3ast15ExecutionLimits(max_call_depth, max_command_count, max_loop_iterations, max_string_length, max_array_elements, max_heredoc_size, max_substitution_depth, max_glob_operations, max_awk_iterations, max_sed_iterations, max_jq_iterations);
}
function _M0FP410Haoxincode8moonbash3lib5entry25json__object__from__pairs(pairs) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger11write__char(buf, 123);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < pairs.length) {
      if (i > 0) {
        _M0IPB13StringBuilderPB6Logger11write__char(buf, 44);
      }
      const _bind$4 = _M0MPC15array5Array2atGUssEE(pairs, i);
      const _k = _bind$4._0;
      const _v = _bind$4._1;
      _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FP410Haoxincode8moonbash3lib5entry20json__escape__string(_k));
      _M0IPB13StringBuilderPB6Logger11write__char(buf, 58);
      _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FP410Haoxincode8moonbash3lib5entry20json__escape__string(_v));
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0IPB13StringBuilderPB6Logger11write__char(buf, 125);
  return buf.val;
}
function _M0FP410Haoxincode8moonbash3lib5entry29result__with__state__to__json(result, files, dirs, links, modes, env) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB13StringBuilderPB6Logger13write__string(buf, "{\"stdout\":");
  _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FP410Haoxincode8moonbash3lib5entry20json__escape__string(result.stdout));
  _M0IPB13StringBuilderPB6Logger13write__string(buf, ",\"stderr\":");
  _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FP410Haoxincode8moonbash3lib5entry20json__escape__string(result.stderr));
  _M0IPB13StringBuilderPB6Logger13write__string(buf, ",\"exitCode\":");
  _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0MPC13int3Int18to__string_2einner(result.exit_code, 10));
  _M0IPB13StringBuilderPB6Logger13write__string(buf, ",\"files\":");
  _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FP410Haoxincode8moonbash3lib5entry25json__object__from__pairs(files));
  _M0IPB13StringBuilderPB6Logger13write__string(buf, ",\"dirs\":");
  _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FP410Haoxincode8moonbash3lib5entry25json__object__from__pairs(dirs));
  _M0IPB13StringBuilderPB6Logger13write__string(buf, ",\"links\":");
  _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FP410Haoxincode8moonbash3lib5entry25json__object__from__pairs(links));
  _M0IPB13StringBuilderPB6Logger13write__string(buf, ",\"modes\":");
  _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FP410Haoxincode8moonbash3lib5entry25json__object__from__pairs(modes));
  _M0IPB13StringBuilderPB6Logger13write__string(buf, ",\"env\":");
  _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FP410Haoxincode8moonbash3lib5entry25json__object__from__pairs(env));
  _M0IPB13StringBuilderPB6Logger13write__string(buf, "}");
  return buf.val;
}
function _M0FP410Haoxincode8moonbash3lib5entry20execute__with__state(script, env_json, files_json, dirs_json, links_json, modes_json, cwd, limits_json, layout_mode) {
  const fs = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs3new();
  const dir_entries = _M0FP410Haoxincode8moonbash3lib5entry19parse__json__object(dirs_json);
  let _tmp$38 = 0;
  while (true) {
    const i = _tmp$38;
    if (i < dir_entries.length) {
      const _bind$4 = _M0MPC15array5Array2atGUssEE(dir_entries, i);
      const _path = _bind$4._0;
      let _try_err;
      _L: {
        _L$2: {
          const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs13mkdir_2einner(fs, _path, true);
          if (_bind$5.$tag === 1) {
            const _ok = _bind$5;
            _ok._0;
          } else {
            const _err = _bind$5;
            _try_err = _err._0;
            break _L$2;
          }
          break _L;
        }
      }
      _tmp$38 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const file_entries = _M0FP410Haoxincode8moonbash3lib5entry19parse__json__object(files_json);
  let _tmp$39 = 0;
  while (true) {
    const i = _tmp$39;
    if (i < file_entries.length) {
      const _bind$4 = _M0MPC15array5Array2atGUssEE(file_entries, i);
      const _path = _bind$4._0;
      const _content = _bind$4._1;
      _M0FP410Haoxincode8moonbash3lib5entry15ensure__parents(fs, _path);
      let _try_err;
      _L: {
        _L$2: {
          const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs11write__file(fs, _path, _content);
          if (_bind$5.$tag === 1) {
            const _ok = _bind$5;
            _ok._0;
          } else {
            const _err = _bind$5;
            _try_err = _err._0;
            break _L$2;
          }
          break _L;
        }
      }
      _tmp$39 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const link_entries = _M0FP410Haoxincode8moonbash3lib5entry19parse__json__object(links_json);
  let _tmp$40 = 0;
  while (true) {
    const i = _tmp$40;
    if (i < link_entries.length) {
      const _bind$4 = _M0MPC15array5Array2atGUssEE(link_entries, i);
      const _path = _bind$4._0;
      const _target = _bind$4._1;
      let _try_err;
      _L: {
        _L$2: {
          const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs7symlink(fs, _target, _path);
          if (_bind$5.$tag === 1) {
            const _ok = _bind$5;
            _ok._0;
          } else {
            const _err = _bind$5;
            _try_err = _err._0;
            break _L$2;
          }
          break _L;
        }
      }
      _tmp$40 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const mode_entries = _M0FP410Haoxincode8moonbash3lib5entry19parse__json__object(modes_json);
  let _tmp$41 = 0;
  while (true) {
    const i = _tmp$41;
    if (i < mode_entries.length) {
      const _bind$4 = _M0MPC15array5Array2atGUssEE(mode_entries, i);
      const _path = _bind$4._0;
      const _mode_str = _bind$4._1;
      const mode = _M0FP410Haoxincode8moonbash3lib5entry19parse__decimal__int(_mode_str);
      let _try_err;
      _L: {
        _L$2: {
          const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs5chmod(fs, _path, mode);
          if (_bind$5.$tag === 1) {
            const _ok = _bind$5;
            _ok._0;
          } else {
            const _err = _bind$5;
            _try_err = _err._0;
            break _L$2;
          }
          break _L;
        }
      }
      _tmp$41 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const actual_cwd = cwd.length > 0 ? cwd : "/home/user";
  if (layout_mode === "minimal" && !_M0FP410Haoxincode8moonbash3lib5entry25needs__home__user__layout(file_entries, dir_entries, link_entries, actual_cwd)) {
    let _try_err;
    _L: {
      _L$2: {
        const _bind$4 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs10rm_2einner(fs, "/home/user", true, false);
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          _ok._0;
        } else {
          const _err = _bind$4;
          _try_err = _err._0;
          break _L$2;
        }
        break _L;
      }
    }
  }
  const _bind$4 = [];
  const env = _M0MPB3Map3MapGssE(new _M0TPB9ArrayViewGUssEE(_bind$4, 0, 0), undefined);
  const env_entries = _M0FP410Haoxincode8moonbash3lib5entry19parse__json__object(env_json);
  let _tmp$42 = 0;
  while (true) {
    const i = _tmp$42;
    if (i < env_entries.length) {
      const _bind$5 = _M0MPC15array5Array2atGUssEE(env_entries, i);
      const _key = _bind$5._0;
      const _value = _bind$5._1;
      _M0MPB3Map3setGssE(env, _key, _value);
      _tmp$42 = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const limits = _M0FP410Haoxincode8moonbash3lib5entry13parse__limits(limits_json);
  let _try_err;
  _L: {
    _L$2: {
      const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs13mkdir_2einner(fs, actual_cwd, true);
      if (_bind$5.$tag === 1) {
        const _ok = _bind$5;
        _ok._0;
      } else {
        const _err = _bind$5;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
  }
  const ctx = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext11new_2einner(fs, env, actual_cwd, limits);
  const result = _M0MP410Haoxincode8moonbash3lib11interpreter11ExecContext7execute(ctx, script);
  const files_out = [];
  const dirs_out = [];
  const links_out = [];
  const modes_out = [];
  const _bind$5 = _M0MP410Haoxincode8moonbash3lib2fs10InMemoryFs17snapshot__entries(fs);
  const _bind$6 = _bind$5.length;
  let _tmp$43 = 0;
  while (true) {
    const _ = _tmp$43;
    if (_ < _bind$6) {
      const entry = _bind$5[_];
      const _path = entry._0;
      const _kind = entry._1;
      const _data = entry._2;
      const _mode = entry._3;
      _M0MPC15array5Array4pushGUssEE(modes_out, { _0: _path, _1: _mode });
      if (_kind === "f") {
        _M0MPC15array5Array4pushGUssEE(files_out, { _0: _path, _1: _data });
      } else {
        if (_kind === "d") {
          _M0MPC15array5Array4pushGUssEE(dirs_out, { _0: _path, _1: "1" });
        } else {
          if (_kind === "l") {
            _M0MPC15array5Array4pushGUssEE(links_out, { _0: _path, _1: _data });
          }
        }
      }
      _tmp$43 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const env_out = [];
  const _it = _M0MPB3Map5iter2GssE(ctx.env);
  while (true) {
    const _bind$7 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$7 === undefined) {
      break;
    } else {
      const _Some = _bind$7;
      const _x = _Some;
      const _key = _x._0;
      const _value = _x._1;
      _M0MPC15array5Array4pushGUssEE(env_out, { _0: _key, _1: _value });
      continue;
    }
  }
  _M0MPC15array5Array8sort__byGUssEE(env_out, (a, b) => _M0IP016_24default__implPB7Compare6op__ltGsE(a._0, b._0) ? -1 : _M0IP016_24default__implPB7Compare6op__gtGsE(a._0, b._0) ? 1 : 0);
  return _M0FP410Haoxincode8moonbash3lib5entry29result__with__state__to__json(result, files_out, dirs_out, links_out, modes_out, env_out);
}
function _M0FP410Haoxincode8moonbash3lib5entry17execute__with__fs(script, env_json, files_json, cwd) {
  return _M0FP410Haoxincode8moonbash3lib5entry20execute__with__state(script, env_json, files_json, "{}", "{}", "{}", cwd, "{}", "default");
}
export { _M0FP410Haoxincode8moonbash3lib5entry7execute as execute, _M0FP410Haoxincode8moonbash3lib5entry20execute__with__state as execute_with_state, _M0FP410Haoxincode8moonbash3lib5entry17execute__with__fs as execute_with_fs }
